/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/talk-react-d3/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1289);
	module.exports = __webpack_require__(717);


/***/ },
/* 1 */
[1503, 115],
/* 2 */
[1483, 1204],
/* 3 */
[1486, 1190],
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(82),
	    isObject = __webpack_require__(44);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(621);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(364);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(90);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(91);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(36);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.LEGEND_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = undefined;
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isString2 = __webpack_require__(286);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isObject2 = __webpack_require__(44);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DataUtils = __webpack_require__(14);
	
	var _PureRender = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRESENTATION_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = {
	  alignmentBaseline: _propTypes2.default.string,
	  angle: _propTypes2.default.number,
	  baselineShift: _propTypes2.default.string,
	  clip: _propTypes2.default.string,
	  clipPath: _propTypes2.default.string,
	  clipRule: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  colorInterpolation: _propTypes2.default.string,
	  colorInterpolationFilters: _propTypes2.default.string,
	  colorProfile: _propTypes2.default.string,
	  colorRendering: _propTypes2.default.string,
	  cursor: _propTypes2.default.string,
	  direction: _propTypes2.default.oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes2.default.string,
	  dominantBaseline: _propTypes2.default.string,
	  enableBackground: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  fillOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  fillRule: _propTypes2.default.oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes2.default.string,
	  floodColor: _propTypes2.default.string,
	  floodOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  font: _propTypes2.default.string,
	  fontFamily: _propTypes2.default.string,
	  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontSizeAdjust: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontStretch: _propTypes2.default.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes2.default.oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes2.default.oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes2.default.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes2.default.string,
	  glyphOrientationVertical: _propTypes2.default.string,
	  imageRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  letterSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  lightingColor: _propTypes2.default.string,
	  markerEnd: _propTypes2.default.string,
	  markerMid: _propTypes2.default.string,
	  markerStart: _propTypes2.default.string,
	  mask: _propTypes2.default.string,
	  opacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  overflow: _propTypes2.default.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes2.default.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes2.default.string,
	  stopOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  stroke: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeDasharray: _propTypes2.default.string,
	  strokeDashoffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeLinecap: _propTypes2.default.oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes2.default.oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes2.default.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes2.default.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes2.default.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  writingMode: _propTypes2.default.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  dx: _propTypes2.default.number,
	  dy: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  r: _propTypes2.default.number
	};
	
	var EVENT_ATTRIBUTES = exports.EVENT_ATTRIBUTES = {
	  onClick: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  onMouseMove: _propTypes2.default.func,
	  onMouseOut: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func
	};
	
	var LEGEND_TYPES = exports.LEGEND_TYPES = ['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	var getDisplayName = exports.getDisplayName = function getDisplayName(Comp) {
	  if (!Comp) {
	    return '';
	  }
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	var findAllByType = exports.findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	var findChildByType = exports.findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	
	  return result && result[0];
	};
	
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	var withoutType = exports.withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types = void 0;
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	var getPresentationAttributes = exports.getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	  return out;
	};
	
	/**
	 * get all the event attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	var filterEventAttributes = exports.filterEventAttributes = function filterEventAttributes(el) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	  return out;
	};
	
	var getEventHandler = function getEventHandler(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	
	    return null;
	  };
	};
	
	var filterEventsOfChild = exports.filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction3.default)(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandler(props[i], data, index);
	    }
	  }
	  return out;
	};
	
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	var validateWidthHeight = exports.validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	var isSsr = exports.isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	var filterSvgElements = exports.filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react2.default.Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString3.default)(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	
	var isSingleChildEqual = exports.isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil3.default)(nextChild) && (0, _isNil3.default)(prevChild)) {
	    return true;
	  } else if (!(0, _isNil3.default)(nextChild) && !(0, _isNil3.default)(prevChild)) {
	    return (0, _PureRender.shallowEqual)(nextChild.props, prevChild.props);
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	var isChildrenEqual = exports.isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	  if (count === 1) {
	    return isSingleChildEqual(nextChildren, prevChildren);
	  }
	
	  for (var i = 0; i < count; i++) {
	    var nextChild = nextChildren[i];
	    var prevChild = prevChildren[i];
	
	    if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function shouldComponentUpdate(props, state) {
	  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
	}
	
	function pureRenderDecorator(component) {
	  // eslint-disable-next-line no-param-reassign
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}

/***/ },
/* 11 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _victoryAnimation=__webpack_require__(634);Object.defineProperty(exports,"VictoryAnimation",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryAnimation).default;}});var _victoryContainer=__webpack_require__(635);Object.defineProperty(exports,"VictoryContainer",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryContainer).
	default;}});var _victoryLabel=__webpack_require__(365);Object.defineProperty(exports,"VictoryLabel",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryLabel).
	default;}});var _victoryTransition=__webpack_require__(639);Object.defineProperty(exports,"VictoryTransition",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryTransition).
	default;}});var _victorySharedEvents=__webpack_require__(1462);Object.defineProperty(exports,"VictorySharedEvents",{enumerable:true,get:function get(){return _interopRequireDefault(_victorySharedEvents).
	default;}});var _victoryClipContainer=__webpack_require__(1449);Object.defineProperty(exports,"VictoryClipContainer",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryClipContainer).
	default;}});var _victoryTheme=__webpack_require__(367);Object.defineProperty(exports,"VictoryTheme",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryTheme).
	default;}});var _victoryLegend=__webpack_require__(1450);Object.defineProperty(exports,"VictoryLegend",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryLegend).
	default;}});var _victoryTooltip=__webpack_require__(1465);Object.defineProperty(exports,"VictoryTooltip",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryTooltip).
	default;}});var _victoryPortal=__webpack_require__(637);Object.defineProperty(exports,"VictoryPortal",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryPortal).
	default;}});var _portal=__webpack_require__(636);Object.defineProperty(exports,"Portal",{enumerable:true,get:function get(){return _interopRequireDefault(_portal).
	default;}});var _index=__webpack_require__(366);Object.defineProperty(exports,"Area",{enumerable:true,get:function get(){return _index.
	
	Area;}});Object.defineProperty(exports,"Bar",{enumerable:true,get:function get(){return _index.Bar;}});Object.defineProperty(exports,"Candle",{enumerable:true,get:function get(){return _index.Candle;}});Object.defineProperty(exports,"ClipPath",{enumerable:true,get:function get(){return _index.ClipPath;}});Object.defineProperty(exports,"Curve",{enumerable:true,get:function get(){return _index.Curve;}});Object.defineProperty(exports,"ErrorBar",{enumerable:true,get:function get(){return _index.ErrorBar;}});Object.defineProperty(exports,"Line",{enumerable:true,get:function get(){return _index.Line;}});Object.defineProperty(exports,"Point",{enumerable:true,get:function get(){return _index.Point;}});Object.defineProperty(exports,"Slice",{enumerable:true,get:function get(){return _index.Slice;}});Object.defineProperty(exports,"Voronoi",{enumerable:true,get:function get(){return _index.Voronoi;}});Object.defineProperty(exports,"Flyout",{enumerable:true,get:function get(){return _index.Flyout;}});var _index2=__webpack_require__(53);Object.defineProperty(exports,"addEvents",{enumerable:true,get:function get(){return _index2.
	
	
	addEvents;}});Object.defineProperty(exports,"Collection",{enumerable:true,get:function get(){return _index2.Collection;}});Object.defineProperty(exports,"Data",{enumerable:true,get:function get(){return _index2.Data;}});Object.defineProperty(exports,"DefaultTransitions",{enumerable:true,get:function get(){return _index2.DefaultTransitions;}});Object.defineProperty(exports,"Domain",{enumerable:true,get:function get(){return _index2.Domain;}});Object.defineProperty(exports,"Events",{enumerable:true,get:function get(){return _index2.Events;}});Object.defineProperty(exports,"Helpers",{enumerable:true,get:function get(){return _index2.Helpers;}});Object.defineProperty(exports,"Log",{enumerable:true,get:function get(){return _index2.Log;}});Object.defineProperty(exports,"PropTypes",{enumerable:true,get:function get(){return _index2.
	PropTypes;}});Object.defineProperty(exports,"Scale",{enumerable:true,get:function get(){return _index2.Scale;}});Object.defineProperty(exports,"Style",{enumerable:true,get:function get(){return _index2.Style;}});Object.defineProperty(exports,"TextSize",{enumerable:true,get:function get(){return _index2.TextSize;}});Object.defineProperty(exports,"Timer",{enumerable:true,get:function get(){return _index2.Timer;}});Object.defineProperty(exports,"Transitions",{enumerable:true,get:function get(){return _index2.Transitions;}});Object.defineProperty(exports,"Selection",{enumerable:true,get:function get(){return _index2.Selection;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(120)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var lineRadial$1 = function() {
	  return lineRadial(line().curve(curveRadialLinear));
	};
	
	var areaRadial = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var pointRadial = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = ((function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}))(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.truncateByDomain = exports.findPositionOfBar = exports.getValueByDataKey = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getBandSizeOfAxis = exports.validateCoordinateInRange = exports.parseSpecifiedDomain = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = undefined;
	
	var _get2 = __webpack_require__(126);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _sortBy2 = __webpack_require__(78);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNaN2 = __webpack_require__(1020);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isNumber2 = __webpack_require__(457);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _isString2 = __webpack_require__(286);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _d3Scale = __webpack_require__(101);
	
	var d3Scales = _interopRequireWildcard(_d3Scale);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mathSign = exports.mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	var isPercent = exports.isPercent = function isPercent(value) {
	  return (0, _isString3.default)(value) && value.indexOf('%') === value.length - 1;
	};
	
	var isNumber = exports.isNumber = function isNumber(value) {
	  return (0, _isNumber3.default)(value) && !(0, _isNaN3.default)(value);
	};
	
	var isNumOrStr = exports.isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString3.default)(value);
	};
	
	var idCounter = 0;
	var uniqueId = exports.uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	
	  return '' + (prefix || '') + id;
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	var getPercentValue = exports.getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString3.default)(percent)) {
	    return defaultValue;
	  }
	
	  var value = void 0;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if (isNaN(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([\d]+)$/;
	var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([\d]+)$/;
	
	var parseSpecifiedDomain = exports.parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray3.default)(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	
	  if (isNumber(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	
	    domain[0] = dataDomain[0] - value;
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if (isNumber(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else {
	    domain[1] = dataDomain[1];
	  }
	
	  return domain;
	};
	
	var validateCoordinateInRange = exports.validateCoordinateInRange = function validateCoordinateInRange(coordinate, scale) {
	  if (!scale) {
	    return false;
	  }
	
	  var range = scale.range();
	  var first = range[0];
	  var last = range[range.length - 1];
	  var isValidate = first <= last ? coordinate >= first && coordinate <= last : coordinate >= last && coordinate <= first;
	
	  return isValidate;
	};
	
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	var getBandSizeOfAxis = exports.getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy3.default)(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	
	var getAnyElementOfObject = exports.getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	var hasDuplicate = exports.hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray3.default)(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	var combineEventHandlers = exports.combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler = void 0;
	
	  if ((0, _isFunction3.default)(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction3.default)(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction3.default)(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction3.default)(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	
	      if ((0, _isFunction3.default)(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {String}   options.scale The specified scale type
	 * @param  {String}   options.type  The type of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	var parseScale = exports.parseScale = function parseScale(_ref, chartType) {
	  var scale = _ref.scale,
	      type = _ref.type;
	
	  if (scale === 'auto') {
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return d3Scales.scalePoint();
	    } else if (type === 'category') {
	      return d3Scales.scaleBand();
	    }
	
	    return d3Scales.scaleLinear();
	  } else if ((0, _isString3.default)(scale)) {
	    var name = 'scale' + scale.slice(0, 1).toUpperCase() + scale.slice(1);
	
	    return (d3Scales[name] || d3Scales.scalePoint)();
	  }
	
	  return (0, _isFunction3.default)(scale) ? scale : d3Scales.scalePoint();
	};
	var EPS = 1e-4;
	var checkDomainOfScale = exports.checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	var getValueByDataKey = exports.getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil3.default)(obj) || (0, _isNil3.default)(dataKey)) {
	    return defaultValue;
	  }
	
	  if (isNumOrStr(dataKey)) {
	    return (0, _get3.default)(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction3.default)(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	
	var findPositionOfBar = exports.findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	var truncateByDomain = exports.truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !isNumber(domain[0]) || !isNumber(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	
	  var result = [value[0], value[1]];
	  if (!isNumber(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!isNumber(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(1426);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 16 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(190),
	    copyObject = __webpack_require__(83),
	    createAssigner = __webpack_require__(152),
	    isArrayLike = __webpack_require__(75),
	    isPrototype = __webpack_require__(154),
	    keys = __webpack_require__(76);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.motionPropTypes = exports.marginPropType = exports.scalePropType = undefined;
	
	var _colors = __webpack_require__(1176);
	
	Object.keys(_colors).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _colors[key];
	        }
	    });
	});
	
	var _curve = __webpack_require__(1177);
	
	Object.keys(_curve).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _curve[key];
	        }
	    });
	});
	
	var _defs = __webpack_require__(1178);
	
	Object.keys(_defs).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _defs[key];
	        }
	    });
	});
	
	var _sankey = __webpack_require__(1179);
	
	Object.keys(_sankey).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _sankey[key];
	        }
	    });
	});
	
	var _stack = __webpack_require__(1180);
	
	Object.keys(_stack).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _stack[key];
	        }
	    });
	});
	
	var _treeMap = __webpack_require__(1181);
	
	Object.keys(_treeMap).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _treeMap[key];
	        }
	    });
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scalePropType = exports.scalePropType = _propTypes2.default.shape({
	    type: _propTypes2.default.string.isRequired,
	    domain: _propTypes2.default.array.isRequired,
	    range: _propTypes2.default.array.isRequired
	}); /*
	     * This file is part of the nivo project.
	     *
	     * Copyright 2016-present, Raphaël Benitte.
	     *
	     * For the full copyright and license information, please view the LICENSE
	     * file that was distributed with this source code.
	     */
	var marginPropType = exports.marginPropType = _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	}).isRequired;
	
	var motionPropTypes = exports.motionPropTypes = {
	    animate: _propTypes2.default.bool.isRequired,
	    motionStiffness: _propTypes2.default.number.isRequired,
	    motionDamping: _propTypes2.default.number.isRequired
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(148),
	    assignInWith = __webpack_require__(1007),
	    baseRest = __webpack_require__(93),
	    customDefaultsAssignIn = __webpack_require__(955);
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(args) {
	  args.push(undefined, customDefaultsAssignIn);
	  return apply(assignInWith, undefined, args);
	});
	
	module.exports = defaults;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _pick = __webpack_require__(1419);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _shallowEqual = __webpack_require__(364);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(90);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(91);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(119);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange = function (_Component) {
	      _inherits(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithPropsOnChange);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (shouldMap(this.props, nextProps)) {
	          this.computedProps = propsMapper(nextProps);
	        }
	      };
	
	      WithPropsOnChange.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	    return WithPropsOnChange;
	  };
	};
	
	exports.default = withPropsOnChange;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Voronoi = __webpack_require__(146);
	
	var _pureRenderComponent = __webpack_require__(114);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _animation = __webpack_require__(38);
	
	var _scalesUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = _extends({}, (0, _scalesUtils.getScalePropTypesByAttribute)('x'), (0, _scalesUtils.getScalePropTypesByAttribute)('y'), (0, _scalesUtils.getScalePropTypesByAttribute)('size'), (0, _scalesUtils.getScalePropTypesByAttribute)('opacity'), (0, _scalesUtils.getScalePropTypesByAttribute)('color'), {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  onValueMouseOver: _propTypes2.default.func,
	  onValueMouseOut: _propTypes2.default.func,
	  onValueClick: _propTypes2.default.func,
	  onSeriesMouseOver: _propTypes2.default.func,
	  onSeriesMouseOut: _propTypes2.default.func,
	  onSeriesClick: _propTypes2.default.func,
	  onNearestX: _propTypes2.default.func,
	  onNearestXY: _propTypes2.default.func,
	  animation: _animation.AnimationPropType
	});
	
	var defaultProps = {
	  className: ''
	};
	
	var AbstractSeries = function (_PureRenderComponent) {
	  _inherits(AbstractSeries, _PureRenderComponent);
	
	  function AbstractSeries(props) {
	    _classCallCheck(this, AbstractSeries);
	
	    var _this = _possibleConstructorReturn(this, (AbstractSeries.__proto__ || Object.getPrototypeOf(AbstractSeries)).call(this, props));
	
	    _this._seriesMouseOverHandler = _this._seriesMouseOverHandler.bind(_this);
	    _this._valueMouseOverHandler = _this._valueMouseOverHandler.bind(_this);
	    _this._seriesMouseOutHandler = _this._seriesMouseOutHandler.bind(_this);
	    _this._valueMouseOutHandler = _this._valueMouseOutHandler.bind(_this);
	    _this._seriesClickHandler = _this._seriesClickHandler.bind(_this);
	    _this._valueClickHandler = _this._valueClickHandler.bind(_this);
	    return _this;
	  }
	
	  /**
	   * Mouse over handler for the specific series' value.
	   * @param {Object} d Value object
	   * @param {Object} event Event.
	   * @protected
	   */
	
	
	  _createClass(AbstractSeries, [{
	    key: '_valueMouseOverHandler',
	    value: function _valueMouseOverHandler(d, event) {
	      var _props = this.props,
	          onValueMouseOver = _props.onValueMouseOver,
	          onSeriesMouseOver = _props.onSeriesMouseOver;
	
	      if (onValueMouseOver) {
	        onValueMouseOver(d, { event: event });
	      }
	      if (onSeriesMouseOver) {
	        onSeriesMouseOver({ event: event });
	      }
	    }
	
	    /**
	     * Mouse over handler for the entire series.
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_seriesMouseOverHandler',
	    value: function _seriesMouseOverHandler(event) {
	      var onSeriesMouseOver = this.props.onSeriesMouseOver;
	
	      if (onSeriesMouseOver) {
	        onSeriesMouseOver({ event: event });
	      }
	    }
	
	    /**
	     * Mouse out handler for the specific series' value.
	     * @param {Object} d Value object
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_valueMouseOutHandler',
	    value: function _valueMouseOutHandler(d, event) {
	      var _props2 = this.props,
	          onValueMouseOut = _props2.onValueMouseOut,
	          onSeriesMouseOut = _props2.onSeriesMouseOut;
	
	      if (onValueMouseOut) {
	        onValueMouseOut(d, { event: event });
	      }
	      if (onSeriesMouseOut) {
	        onSeriesMouseOut({ event: event });
	      }
	    }
	
	    /**
	     * Mouse out handler for the entire series.
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_seriesMouseOutHandler',
	    value: function _seriesMouseOutHandler(event) {
	      var onSeriesMouseOut = this.props.onSeriesMouseOut;
	
	      if (onSeriesMouseOut) {
	        onSeriesMouseOut({ event: event });
	      }
	    }
	
	    /**
	     * Click handler for the specific series' value.
	     * @param {Object} d Value object
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_valueClickHandler',
	    value: function _valueClickHandler(d, event) {
	      var _props3 = this.props,
	          onValueClick = _props3.onValueClick,
	          onSeriesClick = _props3.onSeriesClick;
	
	      if (onValueClick) {
	        onValueClick(d, { event: event });
	      }
	      if (onSeriesClick) {
	        onSeriesClick({ event: event });
	      }
	    }
	
	    /**
	     * Click handler for the entire series.
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_seriesClickHandler',
	    value: function _seriesClickHandler(event) {
	      var onSeriesClick = this.props.onSeriesClick;
	
	      if (onSeriesClick) {
	        onSeriesClick({ event: event });
	      }
	    }
	
	    /**
	     * Tells the rest of the world that it requires SVG to work.
	     * @returns {boolean} Result.
	     */
	
	  }, {
	    key: '_getAttributeFunctor',
	
	
	    /**
	     * Get attribute functor.
	     * @param {string} attr Attribute name
	     * @returns {*} Functor.
	     * @protected
	     */
	    value: function _getAttributeFunctor(attr) {
	      return (0, _scalesUtils.getAttributeFunctor)(this.props, attr);
	    }
	
	    /**
	     * Get the attr0 functor.
	     * @param {string} attr Attribute name.
	     * @returns {*} Functor.
	     * @private
	     */
	
	  }, {
	    key: '_getAttr0Functor',
	    value: function _getAttr0Functor(attr) {
	      return (0, _scalesUtils.getAttr0Functor)(this.props, attr);
	    }
	
	    /**
	     * Get the attribute value if it is available.
	     * @param {string} attr Attribute name.
	     * @returns {*} Attribute value if available, fallback value or undefined
	     * otherwise.
	     * @protected
	     */
	
	  }, {
	    key: '_getAttributeValue',
	    value: function _getAttributeValue(attr) {
	      return (0, _scalesUtils.getAttributeValue)(this.props, attr);
	    }
	
	    /**
	     * Get the scale object distance by the attribute from the list of properties.
	     * @param {string} attr Attribute name.
	     * @returns {number} Scale distance.
	     * @protected
	     */
	
	  }, {
	    key: '_getScaleDistance',
	    value: function _getScaleDistance(attr) {
	      var scaleObject = (0, _scalesUtils.getScaleObjectFromProps)(this.props, attr);
	      return scaleObject ? scaleObject.distance : 0;
	    }
	  }, {
	    key: '_getXYCoordinateInContainer',
	    value: function _getXYCoordinateInContainer(event) {
	      var _props4 = this.props,
	          _props4$marginTop = _props4.marginTop,
	          marginTop = _props4$marginTop === undefined ? 0 : _props4$marginTop,
	          _props4$marginLeft = _props4.marginLeft,
	          marginLeft = _props4$marginLeft === undefined ? 0 : _props4$marginLeft;
	      var _event$nativeEvent = event.nativeEvent,
	          clientX = _event$nativeEvent.clientX,
	          clientY = _event$nativeEvent.clientY,
	          currentTarget = event.currentTarget;
	
	      var rect = currentTarget.getBoundingClientRect();
	      return {
	        x: clientX - rect.left - currentTarget.clientLeft - marginLeft,
	        y: clientY - rect.top - currentTarget.clientTop - marginTop
	      };
	    }
	  }, {
	    key: '_handleNearestX',
	    value: function _handleNearestX(event) {
	      var _props5 = this.props,
	          onNearestX = _props5.onNearestX,
	          data = _props5.data;
	
	      var minDistance = Number.POSITIVE_INFINITY;
	      var value = null;
	      var valueIndex = null;
	
	      var coordinate = this._getXYCoordinateInContainer(event);
	      var xScaleFn = this._getAttributeFunctor('x');
	
	      data.forEach(function (item, i) {
	        var currentCoordinate = xScaleFn(item);
	        var newDistance = Math.abs(coordinate.x - currentCoordinate);
	        if (newDistance < minDistance) {
	          minDistance = newDistance;
	          value = item;
	          valueIndex = i;
	        }
	      });
	      if (!value) {
	        return;
	      }
	      onNearestX(value, {
	        innerX: xScaleFn(value),
	        index: valueIndex,
	        event: event.nativeEvent
	      });
	    }
	  }, {
	    key: '_handleNearestXY',
	    value: function _handleNearestXY(event) {
	      var _props6 = this.props,
	          onNearestXY = _props6.onNearestXY,
	          data = _props6.data;
	
	
	      var coordinate = this._getXYCoordinateInContainer(event);
	      var xScaleFn = this._getAttributeFunctor('x');
	      var yScaleFn = this._getAttributeFunctor('y');
	
	      // Create a voronoi with each node center points
	      var voronoiInstance = (0, _d3Voronoi.voronoi)().x(xScaleFn).y(yScaleFn);
	
	      var foundPoint = voronoiInstance(data).find(coordinate.x, coordinate.y);
	      var value = foundPoint.data;
	
	      if (!value) {
	        return;
	      }
	      onNearestXY(value, {
	        innerX: foundPoint.x,
	        innerY: foundPoint.y,
	        index: foundPoint.index,
	        event: event.nativeEvent
	      });
	    }
	  }, {
	    key: 'onParentMouseMove',
	    value: function onParentMouseMove(event) {
	      var _props7 = this.props,
	          onNearestX = _props7.onNearestX,
	          onNearestXY = _props7.onNearestXY,
	          data = _props7.data;
	
	      if (!onNearestX && !onNearestXY || !data) {
	        return;
	      }
	      if (onNearestXY) {
	        this._handleNearestXY(event);
	      } else {
	        this._handleNearestX(event);
	      }
	    }
	  }], [{
	    key: 'getParentConfig',
	
	
	    /**
	     * Get a default config for the parent.
	     * @returns {Object} Empty config.
	     */
	    value: function getParentConfig() {
	      return {};
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return AbstractSeries;
	}(_pureRenderComponent2.default);
	
	AbstractSeries.displayName = 'AbstractSeries';
	AbstractSeries.propTypes = propTypes;
	AbstractSeries.defaultProps = defaultProps;
	
	exports.default = AbstractSeries;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getColorsGenerator = exports.getColorRange = exports.nivoCategoricalColors = undefined;
	
	var _get2 = __webpack_require__(126);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _inherit = __webpack_require__(1171);
	
	Object.keys(_inherit).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _inherit[key];
	        }
	    });
	});
	
	var _motion = __webpack_require__(1172);
	
	Object.keys(_motion).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _motion[key];
	        }
	    });
	});
	
	var _quantize = __webpack_require__(1173);
	
	Object.keys(_quantize).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _quantize[key];
	        }
	    });
	});
	
	var _d3Scale = __webpack_require__(71);
	
	var _d3ScaleChromatic = __webpack_require__(253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var ordinalColorScales = {
	    d310: (0, _d3Scale.scaleOrdinal)(_d3Scale.schemeCategory10),
	    d320: (0, _d3Scale.scaleOrdinal)(_d3Scale.schemeCategory20),
	    d320b: (0, _d3Scale.scaleOrdinal)(_d3Scale.schemeCategory20b),
	    d320c: (0, _d3Scale.scaleOrdinal)(_d3Scale.schemeCategory20c),
	    accent: (0, _d3Scale.scaleOrdinal)(_d3ScaleChromatic.schemeAccent),
	    dark2: (0, _d3Scale.scaleOrdinal)(_d3ScaleChromatic.schemeDark2),
	    paired: (0, _d3Scale.scaleOrdinal)(_d3ScaleChromatic.schemePaired),
	    pastel1: (0, _d3Scale.scaleOrdinal)(_d3ScaleChromatic.schemePastel1),
	    pastel2: (0, _d3Scale.scaleOrdinal)(_d3ScaleChromatic.schemePastel2),
	    set1: (0, _d3Scale.scaleOrdinal)(_d3ScaleChromatic.schemeSet1),
	    set2: (0, _d3Scale.scaleOrdinal)(_d3ScaleChromatic.schemeSet2),
	    set3: (0, _d3Scale.scaleOrdinal)(_d3ScaleChromatic.schemeSet3)
	};
	
	var nivoCategoricalColors = exports.nivoCategoricalColors = function nivoCategoricalColors() {
	    return (0, _d3Scale.scaleOrdinal)(['#e8c1a0', '#f47560', '#f1e15b', '#e8a838', '#61cdbb', '#97e3d5']);
	};
	
	var dataColor = function dataColor(d) {
	    return d.color || d.data.color;
	};
	
	var getColorRange = exports.getColorRange = function getColorRange(instruction) {
	    if (instruction === 'data') return dataColor;
	
	    if (instruction === 'nivo') return nivoCategoricalColors();
	
	    if ((0, _isFunction3.default)(instruction)) return instruction;
	
	    if (ordinalColorScales[instruction]) return ordinalColorScales[instruction];
	
	    if ((0, _isArray3.default)(instruction)) return (0, _d3Scale.scaleOrdinal)(instruction);
	
	    return function () {
	        return instruction;
	    };
	};
	
	var getColorsGenerator = exports.getColorsGenerator = function getColorsGenerator(colors, colorBy) {
	    // skip range, color should be bound to data
	    if ((0, _isFunction3.default)(colorBy)) return colorBy;
	
	    var scale = void 0;
	    var getColorId = function getColorId(d) {
	        return (0, _get3.default)(d, colorBy);
	    };
	
	    if (colors === 'nivo') {
	        // use default nivo categorical colors
	        scale = nivoCategoricalColors();
	    } else if (ordinalColorScales[colors]) {
	        // use predefined d3 ordinal color scale
	        scale = ordinalColorScales[colors];
	    } else if ((0, _isArray3.default)(colors)) {
	        // user defined color range
	        scale = (0, _d3Scale.scaleOrdinal)(colors);
	    } else {
	        // just use provided value, all elements will have identical color
	        return function (d) {
	            return colors;
	        };
	    }
	
	    return function (d) {
	        return scale(getColorId(d));
	    };
	};

/***/ },
/* 25 */
[1488, 1192, 1193, 1194, 1197, 538, 225, 1196],
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Layer
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ['children', 'className']);
	
	  var layerClass = (0, _classnames2.default)('recharts-layer', className);
	
	  return _react2.default.createElement(
	    'g',
	    _extends({ className: layerClass }, others),
	    children
	  );
	}
	
	Layer.propTypes = propTypes;
	
	exports.default = Layer;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = additionalProps;
	
	var _callOrValue = __webpack_require__(376);
	
	var _callOrValue2 = _interopRequireDefault(_callOrValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function additionalProps(restProps, data) {
	  return Object.keys(restProps).reduce(function (ret, cur) {
	    ret[cur] = (0, _callOrValue2.default)(restProps[cur], data);
	    return ret;
	  }, {});
	}

/***/ },
/* 28 */
[1486, 711],
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Fx = exports.Shaders = exports.FramebufferObject = exports.pickModels = exports.Scene = exports.Group = exports.Object3D = exports.Mat4 = exports.Vec4 = exports.Vec3 = exports.experimental = exports.parseModel = exports.loadModel = exports.loadProgram = exports.loadTextures = exports.loadImages = exports.loadFiles = exports.loadImage = exports.loadFile = exports.Euler = exports.Quaternion = exports.Matrix4 = exports.Vector4 = exports.Vector3 = exports.Vector2 = exports.degrees = exports.radians = exports.ClipSpaceQuad = exports.TruncatedCone = exports.Sphere = exports.Plane = exports.IcoSphere = exports.Cylinder = exports.Cube = exports.Cone = exports.TruncatedConeGeometry = exports.SphereGeometry = exports.PlaneGeometry = exports.IcoSphereGeometry = exports.CylinderGeometry = exports.CubeGeometry = exports.ConeGeometry = exports.Geometry = exports.addEvents = exports.AnimationFrame = exports.Model = exports.VertexArrayObject = exports.TimerQuery = exports.isWebGL2Context = exports.isWebGLContext = exports.draw = exports.TextureCube = exports.Texture2D = exports.Renderbuffer = exports.Framebuffer = exports.Program = exports.FragmentShader = exports.VertexShader = exports.Shader = exports.Buffer = exports.glGetDebugInfo = exports.glContextWithState = exports.getGLExtension = exports.createGLContext = exports.GL = undefined;
	
	var _webglConstants = __webpack_require__(162);
	
	Object.defineProperty(exports, 'GL', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_webglConstants).default;
	  }
	});
	
	var _context = __webpack_require__(300);
	
	Object.defineProperty(exports, 'createGLContext', {
	  enumerable: true,
	  get: function get() {
	    return _context.createGLContext;
	  }
	});
	Object.defineProperty(exports, 'getGLExtension', {
	  enumerable: true,
	  get: function get() {
	    return _context.getGLExtension;
	  }
	});
	Object.defineProperty(exports, 'glContextWithState', {
	  enumerable: true,
	  get: function get() {
	    return _context.glContextWithState;
	  }
	});
	Object.defineProperty(exports, 'glGetDebugInfo', {
	  enumerable: true,
	  get: function get() {
	    return _context.glGetDebugInfo;
	  }
	});
	
	var _buffer = __webpack_require__(161);
	
	Object.defineProperty(exports, 'Buffer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buffer).default;
	  }
	});
	
	var _shader = __webpack_require__(302);
	
	Object.defineProperty(exports, 'Shader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shader).default;
	  }
	});
	Object.defineProperty(exports, 'VertexShader', {
	  enumerable: true,
	  get: function get() {
	    return _shader.VertexShader;
	  }
	});
	Object.defineProperty(exports, 'FragmentShader', {
	  enumerable: true,
	  get: function get() {
	    return _shader.FragmentShader;
	  }
	});
	
	var _program = __webpack_require__(483);
	
	Object.defineProperty(exports, 'Program', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_program).default;
	  }
	});
	
	var _framebuffer = __webpack_require__(301);
	
	Object.defineProperty(exports, 'Framebuffer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_framebuffer).default;
	  }
	});
	
	var _renderbuffer = __webpack_require__(215);
	
	Object.defineProperty(exports, 'Renderbuffer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_renderbuffer).default;
	  }
	});
	
	var _texture2d = __webpack_require__(216);
	
	Object.defineProperty(exports, 'Texture2D', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_texture2d).default;
	  }
	});
	
	var _textureCube = __webpack_require__(484);
	
	Object.defineProperty(exports, 'TextureCube', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_textureCube).default;
	  }
	});
	
	var _draw = __webpack_require__(481);
	
	Object.defineProperty(exports, 'draw', {
	  enumerable: true,
	  get: function get() {
	    return _draw.draw;
	  }
	});
	
	var _webglChecks = __webpack_require__(37);
	
	Object.defineProperty(exports, 'isWebGLContext', {
	  enumerable: true,
	  get: function get() {
	    return _webglChecks.isWebGLContext;
	  }
	});
	Object.defineProperty(exports, 'isWebGL2Context', {
	  enumerable: true,
	  get: function get() {
	    return _webglChecks.isWebGL2Context;
	  }
	});
	
	var _timerQuery = __webpack_require__(485);
	
	Object.defineProperty(exports, 'TimerQuery', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_timerQuery).default;
	  }
	});
	
	var _vertexArrayObject = __webpack_require__(487);
	
	Object.defineProperty(exports, 'VertexArrayObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vertexArrayObject).default;
	  }
	});
	
	var _model = __webpack_require__(212);
	
	Object.defineProperty(exports, 'Model', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_model).default;
	  }
	});
	
	var _animationFrame = __webpack_require__(463);
	
	Object.defineProperty(exports, 'AnimationFrame', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_animationFrame).default;
	  }
	});
	
	var _event = __webpack_require__(464);
	
	Object.defineProperty(exports, 'addEvents', {
	  enumerable: true,
	  get: function get() {
	    return _event.addEvents;
	  }
	});
	
	var _geometry = __webpack_require__(106);
	
	Object.defineProperty(exports, 'Geometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_geometry).default;
	  }
	});
	
	var _coneGeometry = __webpack_require__(469);
	
	Object.defineProperty(exports, 'ConeGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_coneGeometry).default;
	  }
	});
	
	var _cubeGeometry = __webpack_require__(470);
	
	Object.defineProperty(exports, 'CubeGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cubeGeometry).default;
	  }
	});
	
	var _cylinderGeometry = __webpack_require__(471);
	
	Object.defineProperty(exports, 'CylinderGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cylinderGeometry).default;
	  }
	});
	
	var _icoSphereGeometry = __webpack_require__(472);
	
	Object.defineProperty(exports, 'IcoSphereGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_icoSphereGeometry).default;
	  }
	});
	
	var _planeGeometry = __webpack_require__(473);
	
	Object.defineProperty(exports, 'PlaneGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_planeGeometry).default;
	  }
	});
	
	var _sphereGeometry = __webpack_require__(474);
	
	Object.defineProperty(exports, 'SphereGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sphereGeometry).default;
	  }
	});
	
	var _truncatedConeGeometry = __webpack_require__(213);
	
	Object.defineProperty(exports, 'TruncatedConeGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_truncatedConeGeometry).default;
	  }
	});
	
	var _cone = __webpack_require__(1055);
	
	Object.defineProperty(exports, 'Cone', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cone).default;
	  }
	});
	
	var _cube = __webpack_require__(1056);
	
	Object.defineProperty(exports, 'Cube', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cube).default;
	  }
	});
	
	var _cylinder = __webpack_require__(1057);
	
	Object.defineProperty(exports, 'Cylinder', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cylinder).default;
	  }
	});
	
	var _icoSphere = __webpack_require__(1058);
	
	Object.defineProperty(exports, 'IcoSphere', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_icoSphere).default;
	  }
	});
	
	var _plane = __webpack_require__(1059);
	
	Object.defineProperty(exports, 'Plane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_plane).default;
	  }
	});
	
	var _sphere = __webpack_require__(1060);
	
	Object.defineProperty(exports, 'Sphere', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sphere).default;
	  }
	});
	
	var _truncatedCone = __webpack_require__(1061);
	
	Object.defineProperty(exports, 'TruncatedCone', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_truncatedCone).default;
	  }
	});
	
	var _clipSpaceQuad = __webpack_require__(1054);
	
	Object.defineProperty(exports, 'ClipSpaceQuad', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_clipSpaceQuad).default;
	  }
	});
	
	var _common = __webpack_require__(85);
	
	Object.defineProperty(exports, 'radians', {
	  enumerable: true,
	  get: function get() {
	    return _common.radians;
	  }
	});
	Object.defineProperty(exports, 'degrees', {
	  enumerable: true,
	  get: function get() {
	    return _common.degrees;
	  }
	});
	
	var _vector = __webpack_require__(297);
	
	Object.defineProperty(exports, 'Vector2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vector).default;
	  }
	});
	
	var _vector2 = __webpack_require__(214);
	
	Object.defineProperty(exports, 'Vector3', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vector2).default;
	  }
	});
	
	var _vector3 = __webpack_require__(298);
	
	Object.defineProperty(exports, 'Vector4', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vector3).default;
	  }
	});
	
	var _matrix = __webpack_require__(295);
	
	Object.defineProperty(exports, 'Matrix4', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_matrix).default;
	  }
	});
	
	var _quaternion = __webpack_require__(296);
	
	Object.defineProperty(exports, 'Quaternion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quaternion).default;
	  }
	});
	
	var _euler = __webpack_require__(478);
	
	Object.defineProperty(exports, 'Euler', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_euler).default;
	  }
	});
	
	var _io = __webpack_require__(1052);
	
	Object.defineProperty(exports, 'loadFile', {
	  enumerable: true,
	  get: function get() {
	    return _io.loadFile;
	  }
	});
	Object.defineProperty(exports, 'loadImage', {
	  enumerable: true,
	  get: function get() {
	    return _io.loadImage;
	  }
	});
	Object.defineProperty(exports, 'loadFiles', {
	  enumerable: true,
	  get: function get() {
	    return _io.loadFiles;
	  }
	});
	Object.defineProperty(exports, 'loadImages', {
	  enumerable: true,
	  get: function get() {
	    return _io.loadImages;
	  }
	});
	Object.defineProperty(exports, 'loadTextures', {
	  enumerable: true,
	  get: function get() {
	    return _io.loadTextures;
	  }
	});
	Object.defineProperty(exports, 'loadProgram', {
	  enumerable: true,
	  get: function get() {
	    return _io.loadProgram;
	  }
	});
	Object.defineProperty(exports, 'loadModel', {
	  enumerable: true,
	  get: function get() {
	    return _io.loadModel;
	  }
	});
	Object.defineProperty(exports, 'parseModel', {
	  enumerable: true,
	  get: function get() {
	    return _io.parseModel;
	  }
	});
	
	var _math = __webpack_require__(292);
	
	Object.defineProperty(exports, 'Vec3', {
	  enumerable: true,
	  get: function get() {
	    return _math.Vec3;
	  }
	});
	Object.defineProperty(exports, 'Vec4', {
	  enumerable: true,
	  get: function get() {
	    return _math.Vec4;
	  }
	});
	Object.defineProperty(exports, 'Mat4', {
	  enumerable: true,
	  get: function get() {
	    return _math.Mat4;
	  }
	});
	
	var _scenegraph = __webpack_require__(1037);
	
	Object.defineProperty(exports, 'Object3D', {
	  enumerable: true,
	  get: function get() {
	    return _scenegraph.Object3D;
	  }
	});
	Object.defineProperty(exports, 'Group', {
	  enumerable: true,
	  get: function get() {
	    return _scenegraph.Group;
	  }
	});
	Object.defineProperty(exports, 'Scene', {
	  enumerable: true,
	  get: function get() {
	    return _scenegraph.Scene;
	  }
	});
	Object.defineProperty(exports, 'pickModels', {
	  enumerable: true,
	  get: function get() {
	    return _scenegraph.pickModels;
	  }
	});
	
	var _fbo = __webpack_require__(465);
	
	Object.defineProperty(exports, 'FramebufferObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fbo).default;
	  }
	});
	
	var _shaderlib = __webpack_require__(1040);
	
	Object.defineProperty(exports, 'Shaders', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shaderlib).default;
	  }
	});
	
	var _fx = __webpack_require__(1033);
	
	Object.defineProperty(exports, 'Fx', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fx).default;
	  }
	});
	
	__webpack_require__(475);
	
	var _shaderTools = __webpack_require__(467);
	
	__webpack_require__(1044);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// EXPERIMENTAL MODULES
	
	// Shader Tools
	
	// Register Shader Modules
	
	
	var experimental = exports.experimental = {
	  registerShaderModules: _shaderTools.registerShaderModules,
	  assembleShaders: _shaderTools.assembleShaders,
	  ShaderCache: _shaderTools.ShaderCache
	};
	
	// DEPRECATED IN V3.0
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isBrowser = __webpack_require__(299);
	
	Object.keys(_isBrowser).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _isBrowser[key];
	    }
	  });
	});
	
	var _browserUtils = __webpack_require__(1063);
	
	Object.keys(_browserUtils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _browserUtils[key];
	    }
	  });
	});
	
	var _promiseUtils = __webpack_require__(1064);
	
	Object.keys(_promiseUtils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _promiseUtils[key];
	    }
	  });
	});
	
	var _utils = __webpack_require__(1065);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});
	
	var _log = __webpack_require__(480);
	
	Object.keys(_log).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _log[key];
	    }
	  });
	});
	Object.defineProperty(exports, 'log', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_log).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7Ozt3Q0FDUUEsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vaXMtYnJvd3Nlcic7XG5leHBvcnQgKiBmcm9tICcuL2Jyb3dzZXItdXRpbHMnO1xuZXhwb3J0ICogZnJvbSAnLi9wcm9taXNlLXV0aWxzJztcbmV4cG9ydCAqIGZyb20gJy4vdXRpbHMnO1xuZXhwb3J0ICogZnJvbSAnLi9sb2cnO1xuZXhwb3J0IHtkZWZhdWx0IGFzIGxvZ30gZnJvbSAnLi9sb2cnO1xuIl19

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(272);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noop = __webpack_require__(107);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var containerStyle = {
	    position: 'relative'
	};
	
	var tooltipStyle = {
	    pointerEvents: 'none',
	    position: 'absolute',
	    zIndex: 10
	};
	
	var noopHandlers = {
	    showTooltip: _noop2.default,
	    hideTooltip: _noop2.default
	};
	
	var Container = function (_Component) {
	    _inherits(Container, _Component);
	
	    function Container() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Container);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            isTooltipVisible: false,
	            tooltipContent: null,
	            position: {}
	        }, _this.showTooltip = function (content, event) {
	            var clientX = event.clientX,
	                clientY = event.clientY;
	
	            var bounds = _this.container.getBoundingClientRect();
	
	            var x = clientX - bounds.left;
	            var y = clientY - bounds.top;
	
	            var position = {};
	
	            if (x < bounds.width / 2) position.left = x + 20;else position.right = bounds.width - x + 20;
	
	            if (y < bounds.height / 2) position.top = y - 12;else position.bottom = bounds.height - y - 12;
	
	            _this.setState({
	                isTooltipVisible: true,
	                tooltipContent: content,
	                position: position
	            });
	        }, _this.hideTooltip = function () {
	            _this.setState({ isTooltipVisible: false, tooltipContent: null });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Container.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            isInteractive = _props.isInteractive,
	            theme = _props.theme;
	        var _state = this.state,
	            isTooltipVisible = _state.isTooltipVisible,
	            tooltipContent = _state.tooltipContent,
	            position = _state.position;
	
	
	        if (!isInteractive) return children(noopHandlers);
	
	        return _react2.default.createElement(
	            'div',
	            {
	                style: containerStyle,
	                ref: function ref(container) {
	                    _this2.container = container;
	                }
	            },
	            children({
	                showTooltip: this.showTooltip,
	                hideTooltip: this.hideTooltip
	            }),
	            isTooltipVisible && _react2.default.createElement(
	                'div',
	                {
	                    style: _extends({}, tooltipStyle, position, theme.tooltip)
	                },
	                tooltipContent
	            )
	        );
	    };
	
	    return Container;
	}(_react.Component);
	
	Container.propTypes = {
	    children: _propTypes2.default.func.isRequired,
	    isInteractive: _propTypes2.default.bool.isRequired,
	    theme: _propTypes2.default.object.isRequired
	};
	Container.defaultProps = {
	    isInteractive: true
	};
	exports.default = Container;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMeasure = __webpack_require__(1273);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ResponsiveWrapper = function (_Component) {
	    _inherits(ResponsiveWrapper, _Component);
	
	    function ResponsiveWrapper() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ResponsiveWrapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            dimensions: {
	                width: -1,
	                height: -1
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    ResponsiveWrapper.prototype.render = function render() {
	        var _this2 = this;
	
	        var _state$dimensions = this.state.dimensions,
	            width = _state$dimensions.width,
	            height = _state$dimensions.height;
	
	
	        var shouldRender = width > 0 && height > 0;
	
	        return _react2.default.createElement(
	            _reactMeasure2.default,
	            {
	                bounds: true,
	                onResize: function onResize(contentRect) {
	                    _this2.setState({ dimensions: contentRect.bounds });
	                }
	            },
	            function (_ref) {
	                var measureRef = _ref.measureRef;
	                return _react2.default.createElement(
	                    'div',
	                    { ref: measureRef, style: { width: '100%', height: '100%' } },
	                    shouldRender && _this2.props.children({ width: width, height: height })
	                );
	            }
	        );
	    };
	
	    return ResponsiveWrapper;
	}(_react.Component);
	
	ResponsiveWrapper.propTypes = {
	    children: _propTypes2.default.func.isRequired
	};
	exports.default = ResponsiveWrapper;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var DOMProperty = __webpack_require__(135);
	var ReactDOMComponentFlags = __webpack_require__(545);
	
	var invariant = __webpack_require__(4);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = exports.LayerManager = exports.AttributeManager = exports.CompositeLayer = exports.Layer = exports.COORDINATE_SYSTEM = undefined;
	
	var _constants = __webpack_require__(183);
	
	Object.defineProperty(exports, 'COORDINATE_SYSTEM', {
	  enumerable: true,
	  get: function get() {
	    return _constants.COORDINATE_SYSTEM;
	  }
	});
	
	var _layer = __webpack_require__(259);
	
	Object.defineProperty(exports, 'Layer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_layer).default;
	  }
	});
	
	var _compositeLayer = __webpack_require__(825);
	
	Object.defineProperty(exports, 'CompositeLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_compositeLayer).default;
	  }
	});
	
	var _attributeManager = __webpack_require__(391);
	
	Object.defineProperty(exports, 'AttributeManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_attributeManager).default;
	  }
	});
	
	var _layerManager = __webpack_require__(828);
	
	Object.defineProperty(exports, 'LayerManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_layerManager).default;
	  }
	});
	
	var _get = __webpack_require__(260);
	
	Object.defineProperty(exports, 'get', {
	  enumerable: true,
	  get: function get() {
	    return _get.get;
	  }
	});
	
	__webpack_require__(827);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 36 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GL_BUFFER_USAGE = exports.GL_TARGETS = exports.GL_DRAW_MODES = exports.GL_INDEX_TYPES = undefined;
	exports.isWebGLContext = isWebGLContext;
	exports.isWebGL2Context = isWebGL2Context;
	exports.assertWebGLContext = assertWebGLContext;
	exports.assertWebGL2Context = assertWebGL2Context;
	exports.isIndexType = isIndexType;
	exports.assertIndexType = assertIndexType;
	exports.isDrawMode = isDrawMode;
	exports.assertDrawMode = assertDrawMode;
	exports.assertArrayTypeMatch = assertArrayTypeMatch;
	exports.glGetError = glGetError;
	exports.glCheckError = glCheckError;
	
	var _webglTypes = __webpack_require__(218);
	
	var _webglConstants = __webpack_require__(162);
	
	var _webglConstants2 = _interopRequireDefault(_webglConstants);
	
	var _webglArrays = __webpack_require__(489);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Helper definitions for validation of webgl parameters
	/* eslint-disable no-inline-comments, max-len */
	var ERR_CONTEXT = 'Invalid WebGLRenderingContext';
	var ERR_WEBGL2 = 'Requires WebGL2';
	
	function isWebGLContext(gl) {
	  return gl instanceof _webglTypes.WebGLRenderingContext || gl && gl.ARRAY_BUFFER === 0x8892;
	}
	
	function isWebGL2Context(gl) {
	  return gl instanceof _webglTypes.WebGL2RenderingContext || gl && gl.TEXTURE_BINDING_3D === 0x806A;
	}
	
	function assertWebGLContext(gl) {
	  // Need to handle debug context
	  (0, _assert2.default)(isWebGLContext(gl), ERR_CONTEXT);
	}
	
	function assertWebGL2Context(gl) {
	  // Need to handle debug context
	  (0, _assert2.default)(isWebGL2Context(gl), ERR_WEBGL2);
	}
	
	// INDEX TYPES
	
	// For drawElements, size of indices
	var GL_INDEX_TYPES = exports.GL_INDEX_TYPES = [_webglConstants2.default.UNSIGNED_BYTE, _webglConstants2.default.UNSIGNED_SHORT, _webglConstants2.default.UNSIGNED_INT];
	
	function isIndexType(type) {
	  return GL_INDEX_TYPES.indexOf(type) !== -1;
	}
	
	function assertIndexType(glType, source) {
	  (0, _assert2.default)(isIndexType(glType), 'Bad index type ' + (0, _webglConstants.glKey)(glType) + ' ' + source);
	}
	
	// DRAW MODES
	
	var GL_DRAW_MODES = exports.GL_DRAW_MODES = [_webglConstants2.default.POINTS, _webglConstants2.default.LINE_STRIP, _webglConstants2.default.LINE_LOOP, _webglConstants2.default.LINES, _webglConstants2.default.TRIANGLE_STRIP, _webglConstants2.default.TRIANGLE_FAN, _webglConstants2.default.TRIANGLES];
	
	function isDrawMode(glMode) {
	  return GL_DRAW_MODES.indexOf(glMode) !== -1;
	}
	
	function assertDrawMode(glType, source) {
	  (0, _assert2.default)(isDrawMode(glType), 'Bad draw mode ' + (0, _webglConstants.glKey)(glType) + ' ' + source);
	}
	
	// TARGET TYPES
	
	var GL_TARGETS = exports.GL_TARGETS = [_webglConstants2.default.ARRAY_BUFFER, // vertex attributes (e.g. vertex/texture coords or color)
	_webglConstants2.default.ELEMENT_ARRAY_BUFFER, // Buffer used for element indices.
	// For WebGL 2 contexts
	_webglConstants2.default.COPY_READ_BUFFER, // Buffer for copying from one buffer object to another
	_webglConstants2.default.COPY_WRITE_BUFFER, // Buffer for copying from one buffer object to another
	_webglConstants2.default.TRANSFORM_FEEDBACK_BUFFER, // Buffer for transform feedback operations
	_webglConstants2.default.UNIFORM_BUFFER, // Buffer used for storing uniform blocks
	_webglConstants2.default.PIXEL_PACK_BUFFER, // Buffer used for pixel transfer operations
	_webglConstants2.default.PIXEL_UNPACK_BUFFER // Buffer used for pixel transfer operations
	];
	
	// USAGE TYPES
	
	var GL_BUFFER_USAGE = exports.GL_BUFFER_USAGE = [_webglConstants2.default.STATIC_DRAW, // Buffer used often and not change often. Contents are written to the buffer, but not read.
	_webglConstants2.default.DYNAMIC_DRAW, // Buffer used often and change often. Contents are written to the buffer, but not read.
	_webglConstants2.default.STREAM_DRAW, // Buffer not used often. Contents are written to the buffer, but not read.
	// For WebGL 2 contexts
	_webglConstants2.default.STATIC_READ, // Buffer used often and not change often. Contents are read from the buffer, but not written.
	_webglConstants2.default.DYNAMIC_READ, // Buffer used often and change often. Contents are read from the buffer, but not written.
	_webglConstants2.default.STREAM_READ, // Contents of the buffer are likely to not be used often. Contents are read from the buffer, but not written.
	_webglConstants2.default.STATIC_COPY, // Buffer used often and not change often. Contents are neither written or read by the user.
	_webglConstants2.default.DYNAMIC_COPY, // Buffer used often and change often. Contents are neither written or read by the user.
	_webglConstants2.default.STREAM_COPY // Buffer used often and not change often. Contents are neither written or read by the user.
	];
	
	function assertArrayTypeMatch(array, type, source) {
	  (0, _assert2.default)(type === (0, _webglArrays.glTypeFromArray)(array), (array.constructor.name || 'Array') + ' ' + ('does not match element type ' + (0, _webglConstants.glKey)(type) + ' ' + source));
	}
	
	// GL errors
	
	// Returns an Error representing the Latest webGl error or null
	function glGetError(gl) {
	  // Loop to ensure all errors are cleared
	  var errorStack = [];
	  var glError = gl.getError();
	  while (glError !== gl.NO_ERROR) {
	    errorStack.push(glGetErrorMessage(gl, glError));
	    glError = gl.getError();
	  }
	  return errorStack.length ? new Error(errorStack.join('\n')) : null;
	}
	
	function glCheckError(gl) {
	  if (gl.debug) {
	    var error = glGetError(gl);
	    if (error) {
	      throw error;
	    }
	  }
	}
	
	function glGetErrorMessage(gl, glError) {
	  switch (glError) {
	    case _webglConstants2.default.CONTEXT_LOST_WEBGL:
	      //  If the WebGL context is lost, this error is returned on the
	      // first call to getError. Afterwards and until the context has been
	      // restored, it returns gl.NO_ERROR.
	      return 'WebGL context lost';
	    case _webglConstants2.default.INVALID_ENUM:
	      // An unacceptable value has been specified for an enumerated argument.
	      return 'WebGL invalid enumerated argument';
	    case _webglConstants2.default.INVALID_VALUE:
	      // A numeric argument is out of range.
	      return 'WebGL invalid value';
	    case _webglConstants2.default.INVALID_OPERATION:
	      // The specified command is not allowed for the current state.
	      return 'WebGL invalid operation';
	    case _webglConstants2.default.INVALID_FRAMEBUFFER_OPERATION:
	      // The currently bound framebuffer is not framebuffer complete
	      // when trying to render to or to read from it.
	      return 'WebGL invalid framebuffer operation';
	    case _webglConstants2.default.OUT_OF_MEMORY:
	      // Not enough memory is left to execute the command.
	      return 'WebGL out of memory';
	    default:
	      return 'WebGL unknown error ' + glError;
	  }
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnimationPropType = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Interpolate = __webpack_require__(145);
	
	var _reactMotion = __webpack_require__(1283);
	
	var _pureRenderComponent = __webpack_require__(114);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ANIMATION_PROPTYPES = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  stiffness: _propTypes2.default.number,
	  damping: _propTypes2.default.number
	}), _propTypes2.default.bool]);
	
	var propTypes = {
	  animatedProps: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	  animation: ANIMATION_PROPTYPES,
	  onStart: _propTypes2.default.func,
	  onEnd: _propTypes2.default.func
	};
	
	/**
	 * Format the animation style object
	 * @param {Object|String} animationStyle - The animation style property, either the name of a
	 * presets are one of noWobble, gentle, wobbly, stiff
	 */
	function getAnimationStyle() {
	  var animationStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _reactMotion.presets.noWobble;
	
	  if (typeof animationStyle === 'string') {
	    return _reactMotion.presets[animationStyle] || _reactMotion.presets.noWobble;
	  }
	  var damping = animationStyle.damping,
	      stiffness = animationStyle.stiffness;
	
	  return _extends({
	    damping: damping || _reactMotion.presets.noWobble.damping,
	    stiffness: stiffness || _reactMotion.presets.noWobble.stiffness
	  }, animationStyle);
	}
	
	var Animation = function (_PureRenderComponent) {
	  _inherits(Animation, _PureRenderComponent);
	
	  function Animation(props) {
	    _classCallCheck(this, Animation);
	
	    var _this = _possibleConstructorReturn(this, (Animation.__proto__ || Object.getPrototypeOf(Animation)).call(this, props));
	
	    _this._updateInterpolator(props);
	    _this._renderChildren = _this._renderChildren.bind(_this);
	    _this._motionEndHandler = _this._motionEndHandler.bind(_this);
	    return _this;
	  }
	
	  _createClass(Animation, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(props) {
	      this._updateInterpolator(this.props, props);
	      if (props.onStart) {
	        props.onStart();
	      }
	    }
	
	    /**
	     * Update the interpolator function and assign it to this._interpolator.
	     * @param {Object} oldProps Old props.
	     * @param {Object} newProps New props.
	     * @private
	     */
	
	  }, {
	    key: '_updateInterpolator',
	    value: function _updateInterpolator(oldProps, newProps) {
	      this._interpolator = (0, _d3Interpolate.interpolate)(this._extractAnimatedPropValues(oldProps), newProps ? this._extractAnimatedPropValues(newProps) : null);
	    }
	
	    /**
	     * Extract the animated props from the entire props object.
	     * @param {Object} props Props.
	     * @returns {Object} Object of animated props.
	     * @private
	     */
	
	  }, {
	    key: '_extractAnimatedPropValues',
	    value: function _extractAnimatedPropValues(props) {
	      var animatedProps = props.animatedProps,
	          otherProps = _objectWithoutProperties(props, ['animatedProps']);
	
	      return animatedProps.reduce(function (result, animatedPropName) {
	        if (otherProps.hasOwnProperty(animatedPropName)) {
	          result[animatedPropName] = otherProps[animatedPropName];
	        }
	        return result;
	      }, {});
	    }
	
	    /**
	     * Render the child into the parent.
	     * @param {Number} i Number generated by the spring.
	     * @returns {React.Component} Rendered react element.
	     * @private
	     */
	
	  }, {
	    key: '_renderChildren',
	    value: function _renderChildren(_ref) {
	      var i = _ref.i;
	      var children = this.props.children;
	
	      var interpolator = this._interpolator;
	      var child = _react2.default.Children.only(children);
	      var interpolatedProps = interpolator ? interpolator(i) : interpolator;
	
	      // interpolator doesnt play nice with deeply nested objected
	      // so we expose an additional prop for situations like these, soit _data,
	      // which stores the full tree and can be recombined with the sanitized version
	      // after interpolation
	      var data = interpolatedProps && interpolatedProps.data || null;
	      if (data && child.props._data) {
	        data = data.map(function (row, index) {
	          var correspondingCell = child.props._data[index];
	          return _extends({}, row, { parent: correspondingCell.parent, children: correspondingCell.children });
	        });
	      }
	
	      return _react2.default.cloneElement(child, _extends({}, child.props, interpolatedProps, {
	        data: data || child.props.data || null,
	        // enforce re-rendering
	        _animation: Math.random()
	      }));
	    }
	  }, {
	    key: '_motionEndHandler',
	    value: function _motionEndHandler() {
	      if (this.props.onEnd) {
	        this.props.onEnd();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animationStyle = getAnimationStyle(this.props.animation);
	      var defaultStyle = { i: 0 };
	      var style = { i: (0, _reactMotion.spring)(1, animationStyle) };
	      // In order to make Motion re-run animations each time, the random key is
	      // always passed.
	      // TODO: find a better solution for the spring.
	      var key = Math.random();
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        _extends({ defaultStyle: defaultStyle, style: style, key: key }, { onRest: this._motionEndHandler }),
	        this._renderChildren
	      );
	    }
	  }]);
	
	  return Animation;
	}(_pureRenderComponent2.default);
	
	Animation.propTypes = propTypes;
	Animation.displayName = 'Animation';
	
	exports.default = Animation;
	var AnimationPropType = exports.AnimationPropType = ANIMATION_PROPTYPES;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(246)
	  , core      = __webpack_require__(244)
	  , hide      = __webpack_require__(380)
	  , redefine  = __webpack_require__(735)
	  , ctx       = __webpack_require__(729)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _SCALE_FUNCTIONS;
	
	exports._getSmallestDistanceIndex = _getSmallestDistanceIndex;
	exports._getScaleFnFromScaleObject = _getScaleFnFromScaleObject;
	exports.getDomainByAttr = getDomainByAttr;
	exports._getScaleDistanceAndAdjustedDomain = _getScaleDistanceAndAdjustedDomain;
	exports._adjustCategoricalScale = _adjustCategoricalScale;
	exports.getScaleObjectFromProps = getScaleObjectFromProps;
	exports.getAttributeScale = getAttributeScale;
	exports.getAttributeFunctor = getAttributeFunctor;
	exports.getAttr0Functor = getAttr0Functor;
	exports.getAttributeValue = getAttributeValue;
	exports.getScalePropTypesByAttribute = getScalePropTypesByAttribute;
	exports.extractScalePropsFromProps = extractScalePropsFromProps;
	exports.getMissingScaleProps = getMissingScaleProps;
	exports.literalScale = literalScale;
	exports.getFontColorFromBackground = getFontColorFromBackground;
	
	var _d3Scale = __webpack_require__(101);
	
	var _d3Array = __webpack_require__(1384);
	
	var _d3Collection = __webpack_require__(143);
	
	var _d3Color = __webpack_require__(47);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactUtils = __webpack_require__(600);
	
	var _dataUtils = __webpack_require__(1383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Linear scale name.
	 * @type {string}
	 * @const
	 */
	var LINEAR_SCALE_TYPE = 'linear';
	
	/**
	 * Ordinal scale name.
	 * @type {string}
	 * @const
	 */
	var ORDINAL_SCALE_TYPE = 'ordinal';
	
	/**
	 * Category scale.
	 * @type {string}
	 * @const
	 */
	var CATEGORY_SCALE_TYPE = 'category';
	
	/**
	 * Literal scale.
	 * Differs slightly from d3's identity scale in that it does not coerce value
	 * into numbers, it simply returns exactly what you give it
	 * @type {string}
	 * @const
	 */
	var LITERAL_SCALE_TYPE = 'literal';
	
	/**
	 * Log scale name.
	 * @type {string}
	 * @const
	 */
	var LOG_SCALE_TYPE = 'log';
	
	/**
	 * Time scale name.
	 * @type {string}
	 * @const
	 */
	var TIME_SCALE_TYPE = 'time';
	
	/**
	 * Time UTC scale name.
	 * @type {string}
	 * @const
	 */
	var TIME_UTC_SCALE_TYPE = 'time-utc';
	
	/**
	 * Scale functions that are supported in the library.
	 * @type {Object}
	 * @const
	 */
	var SCALE_FUNCTIONS = (_SCALE_FUNCTIONS = {}, _defineProperty(_SCALE_FUNCTIONS, LINEAR_SCALE_TYPE, _d3Scale.scaleLinear), _defineProperty(_SCALE_FUNCTIONS, ORDINAL_SCALE_TYPE, _d3Scale.scalePoint), _defineProperty(_SCALE_FUNCTIONS, CATEGORY_SCALE_TYPE, _d3Scale.scaleOrdinal), _defineProperty(_SCALE_FUNCTIONS, LITERAL_SCALE_TYPE, literalScale), _defineProperty(_SCALE_FUNCTIONS, LOG_SCALE_TYPE, _d3Scale.scaleLog), _defineProperty(_SCALE_FUNCTIONS, TIME_SCALE_TYPE, _d3Scale.scaleTime), _defineProperty(_SCALE_FUNCTIONS, TIME_UTC_SCALE_TYPE, _d3Scale.scaleUtc), _SCALE_FUNCTIONS);
	/**
	 * Find the smallest distance between the values on a given scale and return
	 * the index of the element, where the smallest distance was found.
	 * It returns the first occurrence of i where
	 * `scale(value[i]) - scale(value[i - 1])` is minimal
	 * @param {Array} values Array of values.
	 * @param {Object} scaleObject Scale object.
	 * @returns {number} Index of an element where the smallest distance was found.
	 * @private
	 */
	function _getSmallestDistanceIndex(values, scaleObject) {
	  var scaleFn = _getScaleFnFromScaleObject(scaleObject);
	  var result = 0;
	  if (scaleFn) {
	    var nextValue = void 0;
	    var currentValue = scaleFn(values[0]);
	    var distance = Infinity;
	    var nextDistance = void 0;
	
	    for (var i = 1; i < values.length; i++) {
	      nextValue = scaleFn(values[i]);
	      nextDistance = Math.abs(nextValue - currentValue);
	      if (nextDistance < distance) {
	        distance = nextDistance;
	        result = i;
	      }
	      currentValue = nextValue;
	    }
	  }
	  return result;
	}
	
	/**
	 * Crate a scale function from the scale object.
	 * @param {Object} scaleObject Scale object.
	 - scaleObject.domain {Array}
	 - scaleObject.range {Array}
	 - scaleObject.type {string}
	 - scaleObject.attr {string}
	 * @returns {*} Scale function.
	 * @private
	 */
	function _getScaleFnFromScaleObject(scaleObject) {
	  if (!scaleObject) {
	    return null;
	  }
	  var type = scaleObject.type,
	      domain = scaleObject.domain,
	      range = scaleObject.range;
	
	  var modDomain = domain[0] === domain[1] ? domain[0] === 0 ? [-1, 0] : [-domain[0], domain[0]] : domain;
	  var scale = SCALE_FUNCTIONS[type]().domain(modDomain).range(range);
	  if (type === ORDINAL_SCALE_TYPE) {
	    scale.padding(0.5);
	  }
	  return scale;
	}
	
	/**
	 * Get the domain from the array of data.
	 * @param {Array} allData All data.
	 * @param {string} attr Property name.
	 * @param {string} type Scale type.
	 * @returns {Array} Domain.
	 * @private
	 */
	function getDomainByAttr(allData, attr, type) {
	  var domain = void 0;
	  var attr0 = attr + '0';
	
	  // Collect both attr and available attr0 values from the array of data.
	  var values = allData.reduce(function (data, d) {
	    var value = d[attr];
	    var value0 = d[attr0];
	    if (_isDefined(value)) {
	      data.push(value);
	    }
	    if (_isDefined(value0)) {
	      data.push(value0);
	    }
	    return data;
	  }, []);
	
	  if (!values.length) {
	    return [];
	  }
	
	  // Create proper domain depending on the type of the scale.
	  if (type !== ORDINAL_SCALE_TYPE && type !== CATEGORY_SCALE_TYPE) {
	    domain = (0, _d3Array.extent)(values);
	  } else {
	    domain = (0, _d3Collection.set)(values).values();
	  }
	  return domain;
	}
	
	/**
	 * Create custom scale object from the value. When the scale is created from
	 * this object, it should return the same value all time.
	 * @param {string} attr Attribute.
	 * @param {*} value Value.
	 * @param {string} type - the type of scale being used
	 * @returns {Object} Custom scale object.
	 * @private
	 */
	function _createScaleObjectForValue(attr, value, type) {
	  if (type === 'literal') {
	    return {
	      type: 'literal',
	      domain: [],
	      range: [value],
	      distance: 0,
	      attr: attr,
	      baseValue: undefined,
	      isValue: true
	    };
	  }
	  if (typeof value === 'undefined') {
	    return null;
	  }
	  return {
	    type: 'category',
	    range: [value],
	    domain: [],
	    distance: 0,
	    attr: attr,
	    baseValue: undefined,
	    isValue: true
	  };
	}
	
	/**
	 * Create a regular scale object for a further use from the existing parameters.
	 * @param {Array} domain Domain.
	 * @param {Array} range Range.
	 * @param {string} type Type.
	 * @param {number} distance Distance.
	 * @param {string} attr Attribute.
	 * @param {number} baseValue Base value.
	 * @returns {Object} Scale object.
	 * @private
	 */
	function _createScaleObjectForFunction(domain, range, type, distance, attr, baseValue) {
	  return {
	    domain: domain,
	    range: range,
	    type: type,
	    distance: distance,
	    attr: attr,
	    baseValue: baseValue,
	    isValue: false
	  };
	}
	
	/**
	 * Get scale object from props. E. g. object like {xRange, xDomain, xDistance,
	 * xType} is transformed into {range, domain, distance, type}.
	 * @param {Object} props Props.
	 * @param {string} attr Attribute.
	 * @returns {*} Null or an object with the scale.
	 * @private
	 */
	function _collectScaleObjectFromProps(props, attr) {
	  var value = props[attr],
	      fallbackValue = props['_' + attr + 'Value'],
	      range = props[attr + 'Range'],
	      _props$ = props[attr + 'Distance'],
	      distance = _props$ === undefined ? 0 : _props$,
	      baseValue = props[attr + 'BaseValue'],
	      _props$2 = props[attr + 'Type'],
	      type = _props$2 === undefined ? LINEAR_SCALE_TYPE : _props$2,
	      noFallBack = props[attr + 'NoFallBack'];
	  var domain = props[attr + 'Domain'];
	
	  // Return value-based scale if the value is assigned.
	
	  if (!noFallBack && typeof value !== 'undefined') {
	    return _createScaleObjectForValue(attr, value, props[attr + 'Type']);
	  }
	
	  // Pick up the domain from the properties and create a new one if it's not
	  // available.
	  if (typeof baseValue !== 'undefined') {
	    domain = (0, _dataUtils.addValueToArray)(domain, baseValue);
	  }
	
	  // Make sure that the minimum necessary properties exist.
	  if (!range || !domain || !domain.length) {
	    // Try to use the fallback value if it is available.
	    return _createScaleObjectForValue(attr, fallbackValue, props[attr + 'Type']);
	  }
	
	  return _createScaleObjectForFunction(domain, range, type, distance, attr, baseValue);
	}
	
	/**
	 * Compute left domain adjustment for the given values.
	 * @param {Array} values Array of values.
	 * @returns {number} Domain adjustment.
	 * @private
	 */
	function _computeLeftDomainAdjustment(values) {
	  if (values.length > 1) {
	    return (values[1] - values[0]) / 2;
	  }
	  if (values.length === 1) {
	    return values[0] - 0.5;
	  }
	  return 0;
	}
	
	/**
	 * Compute right domain adjustment for the given values.
	 * @param {Array} values Array of values.
	 * @returns {number} Domain adjustment.
	 * @private
	 */
	function _computeRightDomainAdjustment(values) {
	  if (values.length > 1) {
	    return (values[values.length - 1] - values[values.length - 2]) / 2;
	  }
	  if (values.length === 1) {
	    return values[0] - 0.5;
	  }
	  return 0;
	}
	
	/**
	 * Compute distance for the given values.
	 * @param {Array} values Array of values.
	 * @param {Array} domain Domain.
	 * @param {number} bestDistIndex Index of a best distance found.
	 * @param {function} scaleFn Scale function.
	 * @returns {number} Domain adjustment.
	 * @private
	 */
	function _computeScaleDistance(values, domain, bestDistIndex, scaleFn) {
	  if (values.length > 1) {
	    // Avoid zero indexes.
	    var i = Math.max(bestDistIndex, 1);
	    return Math.abs(scaleFn(values[i]) - scaleFn(values[i - 1]));
	  }
	  if (values.length === 1) {
	    return Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
	  }
	  return 0;
	}
	
	/**
	 * Get the distance, the smallest and the largest value of the domain.
	 * @param {Array} data Array of data for the single series.
	 * @param {Object} scaleObject Scale object.
	 * @returns {{domain0: number, domainN: number, distance: number}} Resuylt.
	 * @private
	 */
	function _getScaleDistanceAndAdjustedDomain(data, scaleObject) {
	  var attr = scaleObject.attr,
	      domain = scaleObject.domain;
	
	  var values = (0, _dataUtils.getUniquePropertyValues)(data, attr);
	  var index = _getSmallestDistanceIndex(values, scaleObject);
	
	  var adjustedDomain = [].concat(domain);
	
	  adjustedDomain[0] -= _computeLeftDomainAdjustment(values);
	  adjustedDomain[domain.length - 1] += _computeRightDomainAdjustment(values);
	  // Fix log scale if it's too small.
	  if (scaleObject.type === LOG_SCALE_TYPE && domain[0] <= 0) {
	    adjustedDomain[0] = Math.min(domain[1] / 10, 1);
	  }
	
	  var adjustedScaleFn = _getScaleFnFromScaleObject(_extends({}, scaleObject, {
	    domain: adjustedDomain
	  }));
	
	  var distance = _computeScaleDistance(values, adjustedDomain, index, adjustedScaleFn);
	
	  return {
	    domain0: adjustedDomain[0],
	    domainN: adjustedDomain[adjustedDomain.length - 1],
	    distance: distance
	  };
	}
	
	/**
	 * Returns true if scale adjustments are possible for a given scale.
	 * @param {Object} props Props.
	 * @param {Object} scaleObject Scale object.
	 * @returns {boolean} True if scale adjustments possible.
	 * @private
	 */
	function _isScaleAdjustmentPossible(props, scaleObject) {
	  var attr = scaleObject.attr;
	  var _props$_adjustBy = props._adjustBy,
	      adjustBy = _props$_adjustBy === undefined ? [] : _props$_adjustBy,
	      _props$_adjustWhat = props._adjustWhat,
	      adjustWhat = _props$_adjustWhat === undefined ? [] : _props$_adjustWhat;
	
	  // The scale cannot be adjusted if there's no attributes to adjust, no
	  // suitable values
	
	  return adjustWhat.length && adjustBy.length && adjustBy.indexOf(attr) !== -1;
	}
	
	/**
	 * Adjust continuous scales (e.g. 'linear', 'log' and 'time') by adding the
	 * space from the left and right of them and by computing the best distance.
	 * @param {Object} props Props.
	 * @param {Object} scaleObject Scale object.
	 * @returns {*} Scale object with adjustments.
	 * @private
	 */
	function _adjustContinuousScale(props, scaleObject) {
	  var allSeriesData = props._allData,
	      _props$_adjustWhat2 = props._adjustWhat,
	      adjustWhat = _props$_adjustWhat2 === undefined ? [] : _props$_adjustWhat2;
	
	  // Assign the initial values.
	
	  var domainLength = scaleObject.domain.length;
	  var domain = scaleObject.domain;
	
	  var scaleDomain0 = domain[0];
	  var scaleDomainN = domain[domainLength - 1];
	  var scaleDistance = scaleObject.distance;
	
	  // Find the smallest left position of the domain, the largest right position
	  // of the domain and the best distance for them.
	  allSeriesData.forEach(function (data, index) {
	    if (adjustWhat.indexOf(index) === -1) {
	      return;
	    }
	    if (data && data.length) {
	      var _getScaleDistanceAndA = _getScaleDistanceAndAdjustedDomain(data, scaleObject),
	          domain0 = _getScaleDistanceAndA.domain0,
	          domainN = _getScaleDistanceAndA.domainN,
	          distance = _getScaleDistanceAndA.distance;
	
	      scaleDomain0 = Math.min(scaleDomain0, domain0);
	      scaleDomainN = Math.max(scaleDomainN, domainN);
	      scaleDistance = Math.max(scaleDistance, distance);
	    }
	  });
	
	  scaleObject.domain = [scaleDomain0].concat(_toConsumableArray(domain.slice(1, -1)), [scaleDomainN]);
	
	  scaleObject.distance = scaleDistance;
	
	  return scaleObject;
	}
	
	/**
	 * Get an adjusted scale. Suitable for 'category' and 'ordinal' scales.
	 * @param {Object} scaleObject Scale object.
	 * @returns {*} Scale object with adjustments.
	 * @private
	 */
	function _adjustCategoricalScale(scaleObject) {
	  var scaleFn = _getScaleFnFromScaleObject(scaleObject);
	  var domain = scaleObject.domain,
	      range = scaleObject.range;
	
	  if (domain.length > 1) {
	    scaleObject.distance = Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
	  } else {
	    scaleObject.distance = Math.abs(range[1] - range[0]);
	  }
	
	  return scaleObject;
	}
	
	/**
	 * Retrieve a scale object or a value from the properties passed.
	 * @param {Object} props Object of props.
	 * @param {string} attr Attribute.
	 * @returns {*} Scale object, value or null.
	 */
	function getScaleObjectFromProps(props, attr) {
	  // Create the initial scale object.
	  var scaleObject = _collectScaleObjectFromProps(props, attr);
	
	  if (!scaleObject) {
	    return null;
	  }
	
	  // Make sure if it's possible to add space to the scale object. If not,
	  // return the object immediately.
	  if (!_isScaleAdjustmentPossible(props, scaleObject)) {
	    return scaleObject;
	  }
	
	  var type = scaleObject.type;
	  // Depending on what type the scale is, apply different adjustments. Distances
	  // for the ordinal and category scales are even, equal domains cannot be
	  // adjusted.
	
	  if (type === ORDINAL_SCALE_TYPE || type === CATEGORY_SCALE_TYPE) {
	    return _adjustCategoricalScale(scaleObject);
	  }
	  return _adjustContinuousScale(props, scaleObject);
	}
	
	/**
	 * Get d3 scale for a given prop.
	 * @param {Object} props Props.
	 * @param {string} attr Attribute.
	 * @returns {function} d3 scale function.
	 */
	function getAttributeScale(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  return _getScaleFnFromScaleObject(scaleObject);
	}
	
	/**
	 * Get the value of `attr` from the object.
	 * @param {Object} d Object.
	 * @param {string} attr Attribute.
	 * @returns {*} Value of the point.
	 * @private
	 */
	function _getAttrValue(d, attr) {
	  return d.data ? d.data[attr] : d[attr];
	}
	
	function _isDefined(value) {
	  return typeof value !== 'undefined';
	}
	
	/**
	 * Get prop functor (either a value or a function) for a given attribute.
	 * @param {Object} props Series props.
	 * @param {string} attr Property name.
	 * @returns {*} Function or value.
	 */
	function getAttributeFunctor(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  if (scaleObject) {
	    var scaleFn = _getScaleFnFromScaleObject(scaleObject);
	    return function (d) {
	      return scaleFn(_getAttrValue(d, attr));
	    };
	  }
	  return null;
	}
	
	/**
	 * Get the functor which extracts value form [attr]0 property. Use baseValue if
	 * no attr0 property for a given object is defined. Fall back to domain[0] if no
	 * base value is available.
	 * @param {Object} props Object of props.
	 * @param {string} attr Attribute name.
	 * @returns {*} Function which returns value or null if no values available.
	 */
	function getAttr0Functor(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  if (scaleObject) {
	    var attr0 = attr + '0';
	    var domain = scaleObject.domain;
	    var _scaleObject$baseValu = scaleObject.baseValue,
	        baseValue = _scaleObject$baseValu === undefined ? domain[0] : _scaleObject$baseValu;
	
	    var scaleFn = _getScaleFnFromScaleObject(scaleObject);
	    return function (d) {
	      var value = _getAttrValue(d, attr0);
	      return scaleFn(_isDefined(value) ? value : baseValue);
	    };
	  }
	  return null;
	}
	
	/**
	 * Tries to get the string|number value of the attr and falls back to
	 * a fallback property in case if the value is a scale.
	 * @param {Object} props Series props.
	 * @param {string} attr Property name.
	 * @returns {*} Function or value.
	 */
	function getAttributeValue(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  if (scaleObject) {
	    if (!scaleObject.isValue) {
	      (0, _reactUtils.warning)('[React-vis] Cannot use data defined ' + attr + ' for this ' + 'series type. Using fallback value instead.');
	    }
	    return scaleObject.range[0];
	  }
	  return null;
	}
	
	/**
	 * Get prop types by the attribute.
	 * @param {string} attr Attribute.
	 * @returns {Object} Object of xDomain, xRange, xType, xDistance and _xValue,
	 * where x is an attribute passed to the function.
	 */
	function getScalePropTypesByAttribute(attr) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, '_' + attr + 'Value', _propTypes2.default.any), _defineProperty(_ref, attr + 'Domain', _propTypes2.default.array), _defineProperty(_ref, attr + 'Range', _propTypes2.default.array), _defineProperty(_ref, attr + 'Type', _propTypes2.default.oneOf(Object.keys(SCALE_FUNCTIONS))), _defineProperty(_ref, attr + 'Distance', _propTypes2.default.number), _defineProperty(_ref, attr + 'BaseValue', _propTypes2.default.any), _ref;
	}
	
	/**
	 * Extract the list of scale properties from the entire props object.
	 * @param {Object} props Props.
	 * @param {Array<String>} attributes Array of attributes for the given
	 * components (for instance, `['x', 'y', 'color']`).
	 * @returns {Object} Collected props.
	 */
	function extractScalePropsFromProps(props, attributes) {
	  var result = {};
	  Object.keys(props).forEach(function (key) {
	    var attr = attributes.find(function (a) {
	      return key.indexOf(a) === 0 || key.indexOf('_' + a) === 0;
	    });
	    if (!attr) {
	      return;
	    }
	    result[key] = props[key];
	  });
	  return result;
	}
	
	/**
	 * Extract the missing scale props from the given data and return them as
	 * an object.
	 * @param {Object} props Props.
	 * @param {Array} data Array of all data.
	 * @param {Array<String>} attributes Array of attributes for the given
	 * components (for instance, `['x', 'y', 'color']`).
	 * @returns {Object} Collected props.
	 */
	function getMissingScaleProps(props, data, attributes) {
	  var result = {};
	  // Make sure that the domain is set and pass the domain as well.
	  attributes.forEach(function (attr) {
	    if (!props[attr + 'Domain']) {
	      result[attr + 'Domain'] = getDomainByAttr(data, attr, props[attr + 'Type']);
	    }
	  });
	  return result;
	}
	
	/**
	 * Return a d3 scale that returns the literal value that was given to it
	 * @returns {function} literal scale.
	 */
	function literalScale() {
	  function scale(d) {
	    return d;
	  }
	
	  function response() {
	    return scale;
	  }
	
	  scale.domain = response;
	  scale.range = response;
	  scale.unknown = response;
	  scale.copy = response;
	
	  return scale;
	}
	
	function getFontColorFromBackground(background) {
	  if (background) {
	    return (0, _d3Color.hsl)(background).l > 0.57 ? '#222' : '#fff';
	  }
	  return null;
	}
	
	exports.default = {
	  extractScalePropsFromProps: extractScalePropsFromProps,
	  getAttributeScale: getAttributeScale,
	  getAttributeFunctor: getAttributeFunctor,
	  getAttr0Functor: getAttr0Functor,
	  getAttributeValue: getAttributeValue,
	  getDomainByAttr: getDomainByAttr,
	  getFontColorFromBackground: getFontColorFromBackground,
	  getMissingScaleProps: getMissingScaleProps,
	  getScaleObjectFromProps: getScaleObjectFromProps,
	  getScalePropTypesByAttribute: getScalePropTypesByAttribute,
	  literalScale: literalScale
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setDisplayName = __webpack_require__(90);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(91);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(119);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	    DefaultProps.defaultProps = props;
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	    return DefaultProps;
	  };
	};
	
	exports.default = defaultProps;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _log = __webpack_require__(261);
	
	Object.defineProperty(exports, 'log', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_log).default;
	  }
	});
	
	var _flatten = __webpack_require__(833);
	
	Object.defineProperty(exports, 'flatten', {
	  enumerable: true,
	  get: function get() {
	    return _flatten.flatten;
	  }
	});
	Object.defineProperty(exports, 'flattenVertices', {
	  enumerable: true,
	  get: function get() {
	    return _flatten.flattenVertices;
	  }
	});
	Object.defineProperty(exports, 'fillArray', {
	  enumerable: true,
	  get: function get() {
	    return _flatten.fillArray;
	  }
	});
	
	var _compareObjects = __webpack_require__(832);
	
	Object.defineProperty(exports, 'compareProps', {
	  enumerable: true,
	  get: function get() {
	    return _compareObjects.compareProps;
	  }
	});
	Object.defineProperty(exports, 'areEqualShallow', {
	  enumerable: true,
	  get: function get() {
	    return _compareObjects.areEqualShallow;
	  }
	});
	
	var _compareArrays = __webpack_require__(831);
	
	Object.defineProperty(exports, 'compareArrays', {
	  enumerable: true,
	  get: function get() {
	    return _compareArrays.compareArrays;
	  }
	});
	Object.defineProperty(exports, 'checkArray', {
	  enumerable: true,
	  get: function get() {
	    return _compareArrays.checkArray;
	  }
	});
	
	var _fp = __webpack_require__(54);
	
	Object.defineProperty(exports, 'fp64ify', {
	  enumerable: true,
	  get: function get() {
	    return _fp.fp64ify;
	  }
	});
	
	var _color = __webpack_require__(830);
	
	Object.defineProperty(exports, 'parseColor', {
	  enumerable: true,
	  get: function get() {
	    return _color.parseColor;
	  }
	});
	
	var _blend = __webpack_require__(829);
	
	Object.defineProperty(exports, 'getBlendMode', {
	  enumerable: true,
	  get: function get() {
	    return _blend.getBlendMode;
	  }
	});
	Object.defineProperty(exports, 'setBlendMode', {
	  enumerable: true,
	  get: function get() {
	    return _blend.setBlendMode;
	  }
	});
	
	var _get = __webpack_require__(260);
	
	Object.defineProperty(exports, 'get', {
	  enumerable: true,
	  get: function get() {
	    return _get.get;
	  }
	});
	
	var _count = __webpack_require__(392);
	
	Object.defineProperty(exports, 'count', {
	  enumerable: true,
	  get: function get() {
	    return _count.count;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 44 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DISCRETE_COLOR_RANGE = exports.DISCRETE_COLOR_RANGE = ['#12939A', '#79C7E3', '#1A3177', '#FF9833', '#EF5D28'];
	
	var EXTENDED_DISCRETE_COLOR_RANGE = exports.EXTENDED_DISCRETE_COLOR_RANGE = ['#19CDD7', '#DDB27C', '#88572C', '#FF991F', '#F15C17', '#223F9A', '#DA70BF', '#125C77', '#4DC19C', '#776E57', '#12939A', '#17B8BE', '#F6D18A', '#B7885E', '#FFCB99', '#F89570', '#829AE3', '#E79FD5', '#1E96BE', '#89DAC1', '#B3AD9E'];
	
	var CONTINUOUS_COLOR_RANGE = exports.CONTINUOUS_COLOR_RANGE = ['#EF5D28', '#FF9833'];
	
	var SIZE_RANGE = exports.SIZE_RANGE = [1, 10];
	
	var OPACITY_RANGE = exports.OPACITY_RANGE = [0.1, 1];
	var OPACITY_TYPE = exports.OPACITY_TYPE = 'literal';
	var DEFAULT_OPACITY = exports.DEFAULT_OPACITY = 1;
	
	var DEFAULT_SIZE = exports.DEFAULT_SIZE = 5;
	
	var DEFAULT_COLOR = exports.DEFAULT_COLOR = DISCRETE_COLOR_RANGE[0];
	
	var DEFAULT_TICK_SIZE = exports.DEFAULT_TICK_SIZE = 7;

/***/ },
/* 46 */
[1484, 145, 382, 254, 384],
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(435);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assembleShaders = __webpack_require__(838);
	
	Object.keys(_assembleShaders).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _assembleShaders[key];
	    }
	  });
	});
	
	var _shaderChunks = __webpack_require__(397);
	
	Object.keys(_shaderChunks).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _shaderChunks[key];
	    }
	  });
	});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zaGFkZXItdXRpbHMvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFvQkE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOzs7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQ29weXJpZ2h0IChjKSAyMDE1IC0gMjAxNyBVYmVyIFRlY2hub2xvZ2llcywgSW5jLlxuLy9cbi8vIFBlcm1pc3Npb24gaXMgaGVyZWJ5IGdyYW50ZWQsIGZyZWUgb2YgY2hhcmdlLCB0byBhbnkgcGVyc29uIG9idGFpbmluZyBhIGNvcHlcbi8vIG9mIHRoaXMgc29mdHdhcmUgYW5kIGFzc29jaWF0ZWQgZG9jdW1lbnRhdGlvbiBmaWxlcyAodGhlIFwiU29mdHdhcmVcIiksIHRvIGRlYWxcbi8vIGluIHRoZSBTb2Z0d2FyZSB3aXRob3V0IHJlc3RyaWN0aW9uLCBpbmNsdWRpbmcgd2l0aG91dCBsaW1pdGF0aW9uIHRoZSByaWdodHNcbi8vIHRvIHVzZSwgY29weSwgbW9kaWZ5LCBtZXJnZSwgcHVibGlzaCwgZGlzdHJpYnV0ZSwgc3VibGljZW5zZSwgYW5kL29yIHNlbGxcbi8vIGNvcGllcyBvZiB0aGUgU29mdHdhcmUsIGFuZCB0byBwZXJtaXQgcGVyc29ucyB0byB3aG9tIHRoZSBTb2Z0d2FyZSBpc1xuLy8gZnVybmlzaGVkIHRvIGRvIHNvLCBzdWJqZWN0IHRvIHRoZSBmb2xsb3dpbmcgY29uZGl0aW9uczpcbi8vXG4vLyBUaGUgYWJvdmUgY29weXJpZ2h0IG5vdGljZSBhbmQgdGhpcyBwZXJtaXNzaW9uIG5vdGljZSBzaGFsbCBiZSBpbmNsdWRlZCBpblxuLy8gYWxsIGNvcGllcyBvciBzdWJzdGFudGlhbCBwb3J0aW9ucyBvZiB0aGUgU29mdHdhcmUuXG4vL1xuLy8gVEhFIFNPRlRXQVJFIElTIFBST1ZJREVEIFwiQVMgSVNcIiwgV0lUSE9VVCBXQVJSQU5UWSBPRiBBTlkgS0lORCwgRVhQUkVTUyBPUlxuLy8gSU1QTElFRCwgSU5DTFVESU5HIEJVVCBOT1QgTElNSVRFRCBUTyBUSEUgV0FSUkFOVElFUyBPRiBNRVJDSEFOVEFCSUxJVFksXG4vLyBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRSBBTkQgTk9OSU5GUklOR0VNRU5ULiBJTiBOTyBFVkVOVCBTSEFMTCBUSEVcbi8vIEFVVEhPUlMgT1IgQ09QWVJJR0hUIEhPTERFUlMgQkUgTElBQkxFIEZPUiBBTlkgQ0xBSU0sIERBTUFHRVMgT1IgT1RIRVJcbi8vIExJQUJJTElUWSwgV0hFVEhFUiBJTiBBTiBBQ1RJT04gT0YgQ09OVFJBQ1QsIFRPUlQgT1IgT1RIRVJXSVNFLCBBUklTSU5HIEZST00sXG4vLyBPVVQgT0YgT1IgSU4gQ09OTkVDVElPTiBXSVRIIFRIRSBTT0ZUV0FSRSBPUiBUSEUgVVNFIE9SIE9USEVSIERFQUxJTkdTIElOXG4vLyBUSEUgU09GVFdBUkUuXG5cbmV4cG9ydCAqIGZyb20gJy4vYXNzZW1ibGUtc2hhZGVycyc7XG5leHBvcnQgKiBmcm9tICcuL3NoYWRlci1jaHVua3MnO1xuIl19

/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(952);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withColors = __webpack_require__(1158);
	
	Object.defineProperty(exports, 'withColors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withColors).default;
	  }
	});
	
	var _withCurve = __webpack_require__(1159);
	
	Object.defineProperty(exports, 'withCurve', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withCurve).default;
	  }
	});
	
	var _withDimensions = __webpack_require__(1160);
	
	Object.defineProperty(exports, 'withDimensions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withDimensions).default;
	  }
	});
	
	var _withHierarchy = __webpack_require__(1161);
	
	Object.defineProperty(exports, 'withHierarchy', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withHierarchy).default;
	  }
	});
	
	var _withMotion = __webpack_require__(1162);
	
	Object.defineProperty(exports, 'withMotion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withMotion).default;
	  }
	});
	
	var _withTheme = __webpack_require__(1163);
	
	Object.defineProperty(exports, 'withTheme', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withTheme).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.Transitions=exports.Timer=exports.TextSize=exports.Style=exports.Selection=exports.Scale=exports.PropTypes=exports.Log=exports.Helpers=exports.Events=exports.Domain=exports.DefaultTransitions=exports.Data=exports.Collection=exports.addEvents=undefined;var _addEvents=__webpack_require__(1466);var _addEvents2=_interopRequireDefault(_addEvents);
	var _collection=__webpack_require__(139);var _collection2=_interopRequireDefault(_collection);
	var _data=__webpack_require__(368);var _data2=_interopRequireDefault(_data);
	var _defaultTransitions=__webpack_require__(1467);var DefaultTransitions=_interopRequireWildcard(_defaultTransitions);
	var _domain=__webpack_require__(1468);var _domain2=_interopRequireDefault(_domain);
	var _events=__webpack_require__(640);var _events2=_interopRequireDefault(_events);
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	var _log=__webpack_require__(369);var _log2=_interopRequireDefault(_log);
	var _propTypes=__webpack_require__(1469);var _propTypes2=_interopRequireDefault(_propTypes);
	var _scale=__webpack_require__(370);var _scale2=_interopRequireDefault(_scale);
	var _selection=__webpack_require__(1470);var _selection2=_interopRequireDefault(_selection);
	var _style=__webpack_require__(1471);var _style2=_interopRequireDefault(_style);
	var _textsize=__webpack_require__(1472);var _textsize2=_interopRequireDefault(_textsize);
	var _timer=__webpack_require__(641);var _timer2=_interopRequireDefault(_timer);
	var _transitions=__webpack_require__(1473);var Transitions=_interopRequireWildcard(_transitions);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.
	
	
	addEvents=_addEvents2.default;exports.
	Collection=_collection2.default;exports.
	Data=_data2.default;exports.
	DefaultTransitions=DefaultTransitions;exports.
	Domain=_domain2.default;exports.
	Events=_events2.default;exports.
	Helpers=_helpers2.default;exports.
	Log=_log2.default;exports.
	PropTypes=_propTypes2.default;exports.
	Scale=_scale2.default;exports.
	Selection=_selection2.default;exports.
	Style=_style2.default;exports.
	TextSize=_textsize2.default;exports.
	Timer=_timer2.default;exports.
	Transitions=Transitions;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fp64ify = fp64ify;
	exports.enable64bitSupport = enable64bitSupport;
	
	var _log = __webpack_require__(261);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _constants = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// TODO - move to shaderlib utilities
	function fp64ify(a) {
	  var hiPart = Math.fround(a);
	  var loPart = a - Math.fround(a);
	  return [hiPart, loPart];
	}
	
	function enable64bitSupport(props) {
	  if (props.fp64) {
	    if (props.projectionMode === _constants.COORDINATE_SYSTEM.LNGLAT) {
	      return true;
	    }
	    _log2.default.once(0, '64-bit mode only works with projectionMode set to\n      COORDINATE_SYSTEM.LNGLAT. Rendering in 32-bit mode instead');
	  }
	
	  return false;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @fileoverview gl-matrix - High performance matrix and vector operations
	 * @author Brandon Jones
	 * @author Colin MacKenzie IV
	 * @version 2.3.2
	 */
	
	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	// END HEADER
	
	exports.glMatrix = __webpack_require__(81);
	exports.mat2 = __webpack_require__(876);
	exports.mat2d = __webpack_require__(877);
	exports.mat3 = __webpack_require__(404);
	exports.mat4 = __webpack_require__(878);
	exports.quat = __webpack_require__(879);
	exports.vec2 = __webpack_require__(880);
	exports.vec3 = __webpack_require__(405);
	exports.vec4 = __webpack_require__(406);

/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(93),
	    createWrap = __webpack_require__(432),
	    getHolder = __webpack_require__(199),
	    replaceHolders = __webpack_require__(155);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to the arguments it receives.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partialRight));
	  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _webglTypes = __webpack_require__(218);
	
	Object.keys(_webglTypes).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _webglTypes[key];
	    }
	  });
	});
	
	var _webglArrays = __webpack_require__(489);
	
	Object.keys(_webglArrays).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _webglArrays[key];
	    }
	  });
	});
	
	var _webglConstants = __webpack_require__(162);
	
	Object.keys(_webglConstants).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _webglConstants[key];
	    }
	  });
	});
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_webglConstants).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy93ZWJnbC93ZWJnbC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OzttREFFUUEsTyIsImZpbGUiOiJ3ZWJnbC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvbnZlbmllbmNlXG5leHBvcnQgKiBmcm9tICcuL3dlYmdsLXR5cGVzJztcbmV4cG9ydCAqIGZyb20gJy4vd2ViZ2wtYXJyYXlzJztcbmV4cG9ydCAqIGZyb20gJy4vd2ViZ2wtY29uc3RhbnRzJztcblxuZXhwb3J0IHtkZWZhdWx0IGFzIGRlZmF1bHR9IGZyb20gJy4vd2ViZ2wtY29uc3RhbnRzJztcbiJdfQ==

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _defs = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgWrapper = function SvgWrapper(_ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        margin = _ref.margin,
	        defs = _ref.defs,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'svg',
	        { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
	        _react2.default.createElement(_defs.Defs, { defs: defs }),
	        _react2.default.createElement(
	            'g',
	            { transform: 'translate(' + margin.left + ',' + margin.top + ')' },
	            children
	        )
	    );
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	
	SvgWrapper.propTypes = {
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	    margin: _propTypes2.default.shape({
	        top: _propTypes2.default.number.isRequired,
	        left: _propTypes2.default.number.isRequired
	    }).isRequired,
	    defs: _propTypes2.default.array
	};
	
	exports.default = SvgWrapper;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(535);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});
	
	var _labels = __webpack_require__(1175);
	
	Object.keys(_labels).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _labels[key];
	    }
	  });
	});

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ANIMATED_SERIES_PROPS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.isSeriesChild = isSeriesChild;
	exports.getSeriesChildren = getSeriesChildren;
	exports.getStackedData = getStackedData;
	exports.getSeriesPropsFromChildren = getSeriesPropsFromChildren;
	exports.getRadialDomain = getRadialDomain;
	exports.getStackParams = getStackParams;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _theme = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Check if the component is series or not.
	 * @param {React.Component} child Component.
	 * @returns {boolean} True if the child is series, false otherwise.
	 */
	function isSeriesChild(child) {
	  var prototype = child.type.prototype;
	
	  return prototype instanceof _abstractSeries2.default;
	}
	
	/**
	 * Get all series from the 'children' object of the component.
	 * @param {Object} children Children.
	 * @returns {Array} Array of children.
	 */
	function getSeriesChildren(children) {
	  return _react2.default.Children.toArray(children).filter(function (child) {
	    return child && isSeriesChild(child);
	  });
	}
	
	/**
	 * Collect the map of repetitions of the series type for all children.
	 * @param {Array} children Array of children.
	 * @returns {{}} Map of repetitions where sameTypeTotal is the total amount and
	 * sameTypeIndex is always 0.
	 */
	function collectSeriesTypesInfo(children) {
	  var result = {};
	  children.filter(isSeriesChild).forEach(function (child) {
	    var displayName = child.type.displayName;
	    var cluster = child.props.cluster;
	
	    if (!result[displayName]) {
	      result[displayName] = {
	        sameTypeTotal: 0,
	        sameTypeIndex: 0,
	        clusters: new Set()
	      };
	    }
	    result[displayName].clusters.add(cluster);
	    result[displayName].sameTypeTotal++;
	  });
	  return result;
	}
	
	/**
	 * Check series to see if it has angular data that needs to be converted
	 * @param {Array} data - an array of objects to check
	 * @returns {Boolean} whether or not this series contains polar configuration
	 */
	function seriesHasAngleRadius() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (!data) {
	    return false;
	  }
	  return data.some(function (row) {
	    return row.radius && row.angle;
	  });
	}
	
	/**
	 * Possibly convert polar coordinates to x/y for computing domain
	 * @param {Array} data - an array of objects to check
	 * @param {String} attr - the property being checked
	 * @returns {Boolean} whether or not this series contains polar configuration
	 */
	function prepareData(data) {
	  if (!seriesHasAngleRadius(data)) {
	    return data;
	  }
	
	  return data.map(function (row) {
	    return _extends({}, row, {
	      x: row.radius * Math.cos(row.angle),
	      y: row.radius * Math.sin(row.angle)
	    });
	  });
	}
	
	/**
	 * Collect the stacked data for all children in use. If the children don't have
	 * the data (e.g. the child is invalid series or something else), then the child
	 * is skipped.
	 * Each next value of attr is equal to the previous value plus the difference
	 * between attr0 and attr.
	 * @param {Array} children Array of children.
	 * @param {string} attr Attribute to stack by.
	 * @returns {Array} New array of children for the series.
	 */
	function getStackedData(children, attr) {
	  return children.reduce(function (accumulator, series, seriesIndex) {
	    // Skip the children that are not series (e.g. don't have any data).
	    if (!series) {
	      accumulator.result.push(null);
	      return accumulator;
	    }
	
	    var _series$props = series.props,
	        data = _series$props.data,
	        _series$props$cluster = _series$props.cluster,
	        cluster = _series$props$cluster === undefined ? 'default' : _series$props$cluster;
	
	    var preppedData = prepareData(data, attr);
	
	    if (!attr || !preppedData || !preppedData.length) {
	      accumulator.result.push(preppedData);
	      return accumulator;
	    }
	
	    var attr0 = attr + '0';
	
	    accumulator.result.push(preppedData.map(function (d, dIndex) {
	      var _extends2;
	
	      // In case if it's the first series don't try to override any values.
	      if (!accumulator.seriesPointers[cluster]) {
	        return _extends({}, d);
	      }
	      // get the previous series in this cluster
	      var prevSeries = accumulator.seriesPointers[cluster].slice().pop();
	      // get the previous data point in that series
	      var prevD = accumulator.result[prevSeries][dIndex];
	      return _extends({}, d, (_extends2 = {}, _defineProperty(_extends2, attr0, prevD[attr]), _defineProperty(_extends2, attr, prevD[attr] + d[attr] - (d[attr0] || 0)), _extends2));
	    }));
	    accumulator.seriesPointers[cluster] = (accumulator.seriesPointers[cluster] || []).concat([seriesIndex]);
	    return accumulator;
	  }, {
	    result: [],
	    seriesPointers: {}
	  }).result;
	}
	
	/**
	 * Get the list of series props for a child.
	 * @param {Array} children Array of all children.
	 * @returns {Array} Array of series props for each child. If a child is not a
	 * series, than it's undefined.
	 */
	function getSeriesPropsFromChildren(children) {
	  var result = [];
	  var seriesTypesInfo = collectSeriesTypesInfo(children);
	  var seriesIndex = 0;
	  var _opacityValue = _theme.DEFAULT_OPACITY;
	  children.forEach(function (child) {
	    var props = void 0;
	    if (isSeriesChild(child)) {
	      var seriesTypeInfo = seriesTypesInfo[child.type.displayName];
	      var _colorValue = _theme.DISCRETE_COLOR_RANGE[seriesIndex % _theme.DISCRETE_COLOR_RANGE.length];
	      props = _extends({}, seriesTypeInfo, {
	        seriesIndex: seriesIndex,
	        ref: 'series' + seriesIndex,
	        _colorValue: _colorValue,
	        _opacityValue: _opacityValue
	      });
	      seriesTypeInfo.sameTypeIndex++;
	      seriesIndex++;
	      if (child.props.cluster) {
	        props.cluster = child.props.cluster;
	        // Using Array.from() so we can use .indexOf
	        props.clusters = Array.from(seriesTypeInfo.clusters);
	        props.sameTypeTotal = props.clusters.length;
	        props.sameTypeIndex = props.clusters.indexOf(child.props.cluster);
	      }
	    }
	    result.push(props);
	  });
	  return result;
	}
	
	/**
	 * Find the max radius value from the nodes to be rendered after they have been
	 * transformed into an array
	 * @param {Array} data - the tree data after it has been broken into a iterable
	 * it is an array of objects!
	 * @returns {number} the maximum value in coordinates for the radial variable
	 */
	function getRadialDomain(data) {
	  return data.reduce(function (res, row) {
	    return Math.max(row.radius, res);
	  }, 0);
	}
	
	var ANIMATED_SERIES_PROPS = exports.ANIMATED_SERIES_PROPS = ['xRange', 'xDomain', 'x', 'yRange', 'yDomain', 'y', 'colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'strokeRange', 'strokeDomain', 'stroke', 'fillRange', 'fillDomain', 'fill', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'data', 'angleDomain', 'angleRange', 'angle', 'radiusDomain', 'radiusRange', 'radius', 'innerRadiusDomain', 'innerRadiusRange', 'innerRadius'];
	
	function getStackParams(props) {
	  var _stackBy = props._stackBy,
	      valuePosAttr = props.valuePosAttr,
	      cluster = props.cluster;
	  var _props$sameTypeTotal = props.sameTypeTotal,
	      sameTypeTotal = _props$sameTypeTotal === undefined ? 1 : _props$sameTypeTotal,
	      _props$sameTypeIndex = props.sameTypeIndex,
	      sameTypeIndex = _props$sameTypeIndex === undefined ? 0 : _props$sameTypeIndex;
	
	  // If bars are stacked, but not clustering, override `sameTypeTotal` and
	  // `sameTypeIndex` such that bars are stacked and not staggered.
	
	  if (_stackBy === valuePosAttr && !cluster) {
	    sameTypeTotal = 1;
	    sameTypeIndex = 0;
	  }
	  return { sameTypeTotal: sameTypeTotal, sameTypeIndex: sameTypeIndex };
	}

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduceCssCalc = __webpack_require__(1421);
	
	var _reduceCssCalc2 = _interopRequireDefault(_reduceCssCalc);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DOMUtils = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(/\s+/) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return { word: word, width: (0, _DOMUtils.getStringSize)(word, props.style).width };
	    });
	
	    var spaceWidth = (0, _DOMUtils.getStringSize)('\xA0', props.style).width;
	
	    return { wordsWithComputedWidth: wordsWithComputedWidth, spaceWidth: spaceWidth };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text = (_temp2 = _class = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Text);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      wordsByLines: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Text, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
	      this.updateWordsByLines(nextProps, needCalculate);
	    }
	  }, {
	    key: 'updateWordsByLines',
	    value: function updateWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	
	
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            this.updateWordsWithoutCalculate(props);
	
	            return;
	          }
	        }
	
	        var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	        this.setState({ wordsByLines: wordsByLines });
	      } else {
	        this.updateWordsWithoutCalculate(props);
	      }
	    }
	  }, {
	    key: 'updateWordsWithoutCalculate',
	    value: function updateWordsWithoutCalculate(props) {
	      var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(/\s+/) : [];
	      this.setState({ wordsByLines: [{ words: words }] });
	    }
	  }, {
	    key: 'calculateWordsByLines',
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	
	      return wordsWithComputedWidth.reduce(function (result, _ref2) {
	        var word = _ref2.word,
	            width = _ref2.width;
	
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = { words: [word], width: width };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          dx = _props.dx,
	          dy = _props.dy,
	          textAnchor = _props.textAnchor,
	          verticalAnchor = _props.verticalAnchor,
	          scaleToFit = _props.scaleToFit,
	          angle = _props.angle,
	          lineHeight = _props.lineHeight,
	          capHeight = _props.capHeight,
	          className = _props.className,
	          textProps = _objectWithoutProperties(_props, ['dx', 'dy', 'textAnchor', 'verticalAnchor', 'scaleToFit', 'angle', 'lineHeight', 'capHeight', 'className']);
	
	      var wordsByLines = this.state.wordsByLines;
	
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	
	      var startDy = void 0;
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + capHeight + ')');
	          break;
	        case 'middle':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) / 2 + ' * -' + lineHeight + ' + (' + capHeight + ' / 2))');
	          break;
	        default:
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) + ' * -' + lineHeight + ')');
	          break;
	      }
	
	      var transforms = [];
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push('scale(' + this.props.width / lineWidth + ')');
	      }
	      if (angle) {
	        transforms.push('rotate(' + angle + ', ' + x + ', ' + y + ')');
	      }
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react2.default.createElement(
	        'text',
	        _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), {
	          x: x,
	          y: y,
	          className: (0, _classnames2.default)('recharts-text', className),
	          textAnchor: textAnchor
	        }),
	        wordsByLines.map(function (line, index) {
	          return _react2.default.createElement(
	            'tspan',
	            { x: x, dy: index === 0 ? startDy : lineHeight, key: index },
	            line.words.join(' ')
	          );
	        })
	      );
	    }
	  }]);
	
	  return Text;
	}(_react.Component), _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes2.default.bool,
	  angle: _propTypes2.default.number,
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end']),
	  style: _propTypes2.default.object
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em', // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' }, _temp2);
	exports.default = Text;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(108);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _Chip = __webpack_require__(166);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chipStyle = { marginRight: 7 }; /*
	                                     * This file is part of the nivo project.
	                                     *
	                                     * Copyright 2016-present, Raphaël Benitte.
	                                     *
	                                     * For the full copyright and license information, please view the LICENSE
	                                     * file that was distributed with this source code.
	                                     */
	
	
	var BasicTooltip = function BasicTooltip(props) {
	    var id = props.id,
	        _value = props.value,
	        format = props.format,
	        enableChip = props.enableChip,
	        color = props.color,
	        theme = props.theme;
	
	
	    var value = _value;
	    if (format !== undefined && value !== undefined) {
	        value = format(value);
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { style: theme.tooltip.container },
	        _react2.default.createElement(
	            'div',
	            { style: theme.tooltip.basic },
	            enableChip && _react2.default.createElement(_Chip2.default, { color: color, style: chipStyle }),
	            value !== undefined ? _react2.default.createElement(
	                'span',
	                null,
	                id,
	                ': ',
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    value
	                )
	            ) : id
	        )
	    );
	};
	
	BasicTooltip.propTypes = {
	    id: _propTypes2.default.node.isRequired,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    enableChip: _propTypes2.default.bool.isRequired,
	    color: _propTypes2.default.string,
	    format: _propTypes2.default.func,
	
	    theme: _propTypes2.default.shape({
	        tooltip: _propTypes2.default.shape({
	            container: _propTypes2.default.object.isRequired,
	            basic: _propTypes2.default.object.isRequired
	        }).isRequired
	    }).isRequired
	};
	
	BasicTooltip.defaultProps = {
	    enableChip: false
	};
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['format'], function (_ref) {
	    var format = _ref.format;
	
	    if (!format || (0, _isFunction3.default)(format)) return { format: format };
	    return { format: (0, _d3Format.format)(format) };
	}), _pure2.default);
	
	exports.default = enhance(BasicTooltip);

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getAccessorFor = exports.getLabelGenerator = undefined;
	
	var _get2 = __webpack_require__(126);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _d3Format = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLabelGenerator = exports.getLabelGenerator = function getLabelGenerator(_label, labelFormat) {
	    var getRawLabel = (0, _isFunction3.default)(_label) ? _label : function (d) {
	        return (0, _get3.default)(d, _label);
	    };
	    var formatter = void 0;
	    if (labelFormat) {
	        formatter = (0, _isFunction3.default)(labelFormat) ? labelFormat : (0, _d3Format.format)(labelFormat);
	    }
	
	    if (formatter) return function (d) {
	        return formatter(getRawLabel(d));
	    };
	    return getRawLabel;
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	var getAccessorFor = exports.getAccessorFor = function getAccessorFor(directive) {
	    return (0, _isFunction3.default)(directive) ? directive : function (d) {
	        return d[directive];
	    };
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.translateStyle = exports.AnimateGroup = exports.configBezier = exports.configSpring = undefined;
	
	var _Animate = __webpack_require__(569);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	var _easing = __webpack_require__(570);
	
	var _util = __webpack_require__(232);
	
	var _AnimateGroup = __webpack_require__(1290);
	
	var _AnimateGroup2 = _interopRequireDefault(_AnimateGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.configSpring = _easing.configSpring;
	exports.configBezier = _easing.configBezier;
	exports.AnimateGroup = _AnimateGroup2.default;
	exports.translateStyle = _util.translateStyle;
	exports.default = _Animate2.default;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Tooltip
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _DefaultTooltipContent = __webpack_require__(1408);
	
	var _DefaultTooltipContent2 = _interopRequireDefault(_DefaultTooltipContent);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DataUtils = __webpack_require__(14);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EPS = 1;
	
	var propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  active: _propTypes2.default.bool,
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  offset: _propTypes2.default.number,
	
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  wrapperStyle: _propTypes2.default.object,
	  cursor: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element, _propTypes2.default.object]),
	
	  coordinate: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  position: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes2.default.func
	};
	
	var defaultProps = {
	  active: false,
	  offset: 10,
	  viewBox: { x1: 0, x2: 0, y1: 0, y2: 0 },
	  coordinate: { x: 0, y: 0 },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  itemSorter: function itemSorter() {
	    return -1;
	  }
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultTooltipContent2.default, props);
	};
	
	var Tooltip = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          isAnimationActive = _props.isAnimationActive,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing;
	
	      var hasPayload = payload && payload.length && payload.filter(function (entry) {
	        return !(0, _isNil3.default)(entry.value);
	      }).length;
	      var _props2 = this.props,
	          content = _props2.content,
	          viewBox = _props2.viewBox,
	          coordinate = _props2.coordinate,
	          position = _props2.position,
	          active = _props2.active,
	          offset = _props2.offset,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	      var translateX = void 0,
	          translateY = void 0;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _state2 = this.state,
	            boxWidth = _state2.boxWidth,
	            boxHeight = _state2.boxHeight;
	
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = position && (0, _DataUtils.isNumber)(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);
	
	          translateY = position && (0, _DataUtils.isNumber)(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	        transform: 'translate(' + translateX + 'px, ' + translateY + 'px)'
	      }));
	
	      if (isAnimationActive && active) {
	        outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	          transition: 'transform ' + animationDuration + 'ms ' + animationEasing
	        }));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-tooltip-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component), _class2.displayName = 'Tooltip', _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _temp2)) || _class;
	
	exports.default = Tooltip;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(909),
	    baseMatchesProperty = __webpack_require__(910),
	    identity = __webpack_require__(69),
	    isArray = __webpack_require__(16),
	    property = __webpack_require__(289);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 70 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 71 */
[1484, 1184, 1183, 536, 1185],
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(11);
	
	var CallbackQueue = __webpack_require__(543);
	var PooledClass = __webpack_require__(109);
	var ReactFeatureFlags = __webpack_require__(551);
	var ReactReconciler = __webpack_require__(110);
	var Transaction = __webpack_require__(228);
	
	var invariant = __webpack_require__(4);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTicksTotalFromSize = getTicksTotalFromSize;
	exports.getTickValues = getTickValues;
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var ORIENTATION = exports.ORIENTATION = {
	  TOP: 'top',
	  LEFT: 'left',
	  RIGHT: 'right',
	  BOTTOM: 'bottom'
	};
	
	var DIRECTION = exports.DIRECTION = {
	  VERTICAL: 'vertical',
	  HORIZONTAL: 'horizontal'
	};
	
	/**
	 * Get total amount of ticks from a given size in pixels.
	 * @param {number} size Size of the axis in pixels.
	 * @returns {number} Total amount of ticks.
	 */
	function getTicksTotalFromSize(size) {
	  if (size < 700) {
	    if (size > 300) {
	      return 10;
	    }
	    return 5;
	  }
	  return 20;
	}
	
	/**
	 * Get the tick values from a given d3 scale.
	 * @param {d3.scale} scale Scale function.
	 * @param {number} tickTotal Total number of ticks
	 * @param {Array} tickValues Array of tick values if they exist.
	 * @returns {Array} Array of tick values.
	 */
	function getTickValues(scale, tickTotal, tickValues) {
	  return !tickValues ? scale.ticks ? scale.ticks(tickTotal) : scale.domain() : tickValues;
	}
	
	exports.default = {
	  DIRECTION: DIRECTION,
	  ORIENTATION: ORIENTATION,
	  getTicksTotalFromSize: getTicksTotalFromSize,
	  getTickValues: getTickValues
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=
	
	{
	DataProps:{
	categories:_propTypes2.default.oneOfType([
	_propTypes2.default.arrayOf(_propTypes2.default.string),
	_propTypes2.default.shape({
	x:_propTypes2.default.arrayOf(_propTypes2.default.string),y:_propTypes2.default.arrayOf(_propTypes2.default.string)})]),
	
	
	data:_propTypes2.default.array,
	dataComponent:_propTypes2.default.element,
	labelComponent:_propTypes2.default.element,
	labels:_propTypes2.default.oneOfType([_propTypes2.default.func,_propTypes2.default.array]),
	samples:_victoryCore.PropTypes.nonNegative,
	sortKey:_propTypes2.default.oneOfType([
	_propTypes2.default.func,
	_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),
	_propTypes2.default.string,
	_propTypes2.default.arrayOf(_propTypes2.default.string)]),
	
	style:_propTypes2.default.shape({
	parent:_propTypes2.default.object,data:_propTypes2.default.object,labels:_propTypes2.default.object}),
	
	x:_propTypes2.default.oneOfType([
	_propTypes2.default.func,
	_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),
	_propTypes2.default.string,
	_propTypes2.default.arrayOf(_propTypes2.default.string)]),
	
	y:_propTypes2.default.oneOfType([
	_propTypes2.default.func,
	_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),
	_propTypes2.default.string,
	_propTypes2.default.arrayOf(_propTypes2.default.string)])},
	
	BaseProps:{
	animate:_propTypes2.default.object,
	containerComponent:_propTypes2.default.element,
	domain:_propTypes2.default.oneOfType([
	_victoryCore.PropTypes.domain,
	_propTypes2.default.shape({x:_victoryCore.PropTypes.domain,y:_victoryCore.PropTypes.domain})]),
	
	domainPadding:_propTypes2.default.oneOfType([
	_propTypes2.default.shape({
	x:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.arrayOf(_propTypes2.default.number)]),
	y:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.arrayOf(_propTypes2.default.number)])}),
	
	_propTypes2.default.number,
	_propTypes2.default.arrayOf(_propTypes2.default.number)]),
	
	eventKey:_propTypes2.default.oneOfType([
	_propTypes2.default.func,
	_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),
	_propTypes2.default.string]),
	
	events:_propTypes2.default.arrayOf(_propTypes2.default.shape({
	target:_propTypes2.default.oneOf(["data","labels","parent"]),
	eventKey:_propTypes2.default.oneOfType([
	_propTypes2.default.array,
	_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),
	_propTypes2.default.string]),
	
	eventHandlers:_propTypes2.default.object})),
	
	groupComponent:_propTypes2.default.element,
	height:_victoryCore.PropTypes.nonNegative,
	name:_propTypes2.default.string,
	padding:_propTypes2.default.oneOfType([
	_propTypes2.default.number,
	_propTypes2.default.shape({
	top:_propTypes2.default.number,bottom:_propTypes2.default.number,
	left:_propTypes2.default.number,right:_propTypes2.default.number})]),
	
	
	scale:_propTypes2.default.oneOfType([
	_victoryCore.PropTypes.scale,
	_propTypes2.default.shape({x:_victoryCore.PropTypes.scale,y:_victoryCore.PropTypes.scale})]),
	
	sharedEvents:_propTypes2.default.shape({
	events:_propTypes2.default.array,
	getEventState:_propTypes2.default.func}),
	
	standalone:_propTypes2.default.bool,
	theme:_propTypes2.default.object,
	width:_victoryCore.PropTypes.nonNegative}};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(6),
	    isLength = __webpack_require__(285);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(413),
	    baseKeys = __webpack_require__(422),
	    isArrayLike = __webpack_require__(75);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(92),
	    baseClone = __webpack_require__(416),
	    baseUnset = __webpack_require__(928),
	    castPath = __webpack_require__(123),
	    copyObject = __webpack_require__(83),
	    customOmitClone = __webpack_require__(957),
	    flatRest = __webpack_require__(276),
	    getAllKeysIn = __webpack_require__(437);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(271),
	    baseOrderBy = __webpack_require__(912),
	    baseRest = __webpack_require__(93),
	    isIterateeCall = __webpack_require__(202);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _victoryUtil=__webpack_require__(53);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=
	
	{
	active:_propTypes2.default.bool,
	className:_propTypes2.default.string,
	data:_propTypes2.default.array,
	events:_propTypes2.default.object,
	index:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string]),
	role:_propTypes2.default.string,
	scale:_propTypes2.default.oneOfType([
	_victoryUtil.PropTypes.scale,
	_propTypes2.default.shape({x:_victoryUtil.PropTypes.scale,y:_victoryUtil.PropTypes.scale})]),
	
	shapeRendering:_propTypes2.default.string,
	style:_propTypes2.default.object};

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _reduce2=__webpack_require__(1025);var _reduce3=_interopRequireDefault(_reduce2);var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);var _property2=__webpack_require__(289);var _property3=_interopRequireDefault(_property2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);
	var _collection=__webpack_require__(139);var _collection2=_interopRequireDefault(_collection);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=
	
	{
	getPadding:function getPadding(props){
	var padding=typeof props.padding==="number"?props.padding:0;
	var paddingObj=typeof props.padding==="object"?props.padding:{};
	return{
	top:paddingObj.top||padding,
	bottom:paddingObj.bottom||padding,
	left:paddingObj.left||padding,
	right:paddingObj.right||padding};
	
	},
	
	getStyles:function getStyles(style,defaultStyles,height,width){
	if(!style){
	return(0,_defaults3.default)({parent:{height:height,width:width}},defaultStyles);
	}var
	
	data=style.data,labels=style.labels,parent=style.parent;
	var defaultParent=defaultStyles&&defaultStyles.parent||{};
	var defaultLabels=defaultStyles&&defaultStyles.labels||{};
	var defaultData=defaultStyles&&defaultStyles.data||{};
	return{
	parent:(0,_defaults3.default)({height:height,width:width},parent,defaultParent),
	labels:(0,_defaults3.default)({},labels,defaultLabels),
	data:(0,_defaults3.default)({},data,defaultData)};
	
	},
	
	evaluateProp:function evaluateProp(prop,data,active){
	return(0,_isFunction3.default)(prop)?prop(data,active):prop;
	},
	
	evaluateStyle:function evaluateStyle(style,data,active){var _this=this;
	if(!style||!Object.keys(style).some(function(value){return(0,_isFunction3.default)(style[value]);})){
	return style;
	}
	return Object.keys(style).reduce(function(prev,curr){
	prev[curr]=_this.evaluateProp(style[curr],data,active);
	return prev;
	},{});
	},
	
	getRange:function getRange(props,axis){
	
	var isVertical=axis!=="x";
	var padding=this.getPadding(props);
	if(isVertical){
	return[props.height-padding.bottom,padding.top];
	}
	return[padding.left,props.width-padding.right];
	},
	
	createAccessor:function createAccessor(key){
	
	
	if((0,_isFunction3.default)(key)){
	return key;
	}else if(key===null||typeof key==="undefined"){
	
	return function(x){return x;};
	}
	
	return(0,_property3.default)(key);
	},
	
	modifyProps:function modifyProps(props,fallbackProps,role){
	var theme=props.theme&&props.theme[role]?props.theme[role]:{};
	var themeProps=(0,_omit3.default)(theme,["style"]);
	return(0,_defaults3.default)({},props,themeProps,fallbackProps);
	},
	
	
	
	
	
	
	
	
	
	getCurrentAxis:function getCurrentAxis(axis,horizontal){
	var otherAxis=axis==="x"?"y":"x";
	return horizontal?otherAxis:axis;
	},
	
	
	
	
	
	isVertical:function isVertical(props){
	var orientation=props.orientation||(props.dependentAxis?"left":"bottom");
	var vertical={top:false,bottom:false,left:true,right:true};
	return vertical[orientation];
	},
	
	
	
	
	
	stringTicks:function stringTicks(props){
	return props.tickValues!==undefined&&_collection2.default.containsStrings(props.tickValues);
	},
	
	
	
	
	
	
	reduceChildren:function reduceChildren(children,iteratee){
	var childIndex=0;
	var traverseChildren=function traverseChildren(childArray,parent){
	return(0,_reduce3.default)(childArray,function(memo,child){
	var childName=child.props.name||childIndex;
	childIndex++;
	if(child.props&&child.props.children){
	var nestedChildren=_react2.default.Children.toArray(child.props.children);
	var nestedResults=traverseChildren(nestedChildren,child);
	memo=memo.concat(nestedResults);
	}else{
	var result=iteratee(child,childName,parent);
	memo=result?memo.concat(result):memo;
	}
	return memo;
	},[]);
	};
	return traverseChildren(children);
	}};

/***/ },
/* 81 */
/***/ function(module, exports) {

	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	/**
	 * @class Common utilities
	 * @name glMatrix
	 */
	var glMatrix = {};
	
	// Configuration Constants
	glMatrix.EPSILON = 0.000001;
	glMatrix.ARRAY_TYPE = (typeof Float32Array !== 'undefined') ? Float32Array : Array;
	glMatrix.RANDOM = Math.random;
	glMatrix.ENABLE_SIMD = false;
	
	// Capability detection
	glMatrix.SIMD_AVAILABLE = (glMatrix.ARRAY_TYPE === Float32Array) && ('SIMD' in this);
	glMatrix.USE_SIMD = glMatrix.ENABLE_SIMD && glMatrix.SIMD_AVAILABLE;
	
	/**
	 * Sets the type of array used when creating new vectors and matrices
	 *
	 * @param {Type} type Array type, such as Float32Array or Array
	 */
	glMatrix.setMatrixArrayType = function(type) {
	    glMatrix.ARRAY_TYPE = type;
	}
	
	var degree = Math.PI / 180;
	
	/**
	* Convert Degree To Radian
	*
	* @param {Number} Angle in Degrees
	*/
	glMatrix.toRadian = function(a){
	     return a * degree;
	}
	
	/**
	 * Tests whether or not the arguments have approximately the same value, within an absolute
	 * or relative tolerance of glMatrix.EPSILON (an absolute tolerance is used for values less 
	 * than or equal to 1.0, and a relative tolerance is used for larger values)
	 * 
	 * @param {Number} a The first number to test.
	 * @param {Number} b The second number to test.
	 * @returns {Boolean} True if the numbers are approximately equal, false otherwise.
	 */
	glMatrix.equals = function(a, b) {
		return Math.abs(a - b) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a), Math.abs(b));
	}
	
	module.exports = glMatrix;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(122),
	    getRawTag = __webpack_require__(961),
	    objectToString = __webpack_require__(990);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(190),
	    baseAssignValue = __webpack_require__(149);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _geometry = __webpack_require__(106);
	
	Object.defineProperty(exports, 'Geometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_geometry).default;
	  }
	});
	
	var _coneGeometry = __webpack_require__(469);
	
	Object.defineProperty(exports, 'ConeGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_coneGeometry).default;
	  }
	});
	
	var _cubeGeometry = __webpack_require__(470);
	
	Object.defineProperty(exports, 'CubeGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cubeGeometry).default;
	  }
	});
	
	var _cylinderGeometry = __webpack_require__(471);
	
	Object.defineProperty(exports, 'CylinderGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cylinderGeometry).default;
	  }
	});
	
	var _icoSphereGeometry = __webpack_require__(472);
	
	Object.defineProperty(exports, 'IcoSphereGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_icoSphereGeometry).default;
	  }
	});
	
	var _planeGeometry = __webpack_require__(473);
	
	Object.defineProperty(exports, 'PlaneGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_planeGeometry).default;
	  }
	});
	
	var _sphereGeometry = __webpack_require__(474);
	
	Object.defineProperty(exports, 'SphereGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sphereGeometry).default;
	  }
	});
	
	var _truncatedConeGeometry = __webpack_require__(213);
	
	Object.defineProperty(exports, 'TruncatedConeGeometry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_truncatedConeGeometry).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9nZW9tZXRyeS9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs2Q0FBUUEsTzs7Ozs7Ozs7O2lEQUVBQSxPOzs7Ozs7Ozs7aURBQ0FBLE87Ozs7Ozs7OztxREFDQUEsTzs7Ozs7Ozs7O3NEQUNBQSxPOzs7Ozs7Ozs7a0RBQ0FBLE87Ozs7Ozs7OzttREFDQUEsTzs7Ozs7Ozs7OzBEQUNBQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHtkZWZhdWx0IGFzIEdlb21ldHJ5fSBmcm9tICcuL2dlb21ldHJ5JztcblxuZXhwb3J0IHtkZWZhdWx0IGFzIENvbmVHZW9tZXRyeX0gZnJvbSAnLi9jb25lLWdlb21ldHJ5JztcbmV4cG9ydCB7ZGVmYXVsdCBhcyBDdWJlR2VvbWV0cnl9IGZyb20gJy4vY3ViZS1nZW9tZXRyeSc7XG5leHBvcnQge2RlZmF1bHQgYXMgQ3lsaW5kZXJHZW9tZXRyeX0gZnJvbSAnLi9jeWxpbmRlci1nZW9tZXRyeSc7XG5leHBvcnQge2RlZmF1bHQgYXMgSWNvU3BoZXJlR2VvbWV0cnl9IGZyb20gJy4vaWNvLXNwaGVyZS1nZW9tZXRyeSc7XG5leHBvcnQge2RlZmF1bHQgYXMgUGxhbmVHZW9tZXRyeX0gZnJvbSAnLi9wbGFuZS1nZW9tZXRyeSc7XG5leHBvcnQge2RlZmF1bHQgYXMgU3BoZXJlR2VvbWV0cnl9IGZyb20gJy4vc3BoZXJlLWdlb21ldHJ5JztcbmV4cG9ydCB7ZGVmYXVsdCBhcyBUcnVuY2F0ZWRDb25lR2VvbWV0cnl9IGZyb20gJy4vdHJ1bmNhdGVkLWNvbmUtZ2VvbWV0cnknO1xuIl19

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.glMatrix = undefined;
	exports.configure = configure;
	exports.formatValue = formatValue;
	exports.isArray = isArray;
	exports.clone = clone;
	exports.radians = radians;
	exports.degrees = degrees;
	exports.sin = sin;
	exports.cos = cos;
	exports.tan = tan;
	exports.asin = asin;
	exports.acos = acos;
	exports.atan = atan;
	exports.clamp = clamp;
	exports.equals = equals;
	
	var _glMatrix = __webpack_require__(55);
	
	// TODO - remove
	_glMatrix.glMatrix.debug = true; /* eslint-disable no-shadow */
	
	_glMatrix.glMatrix.printRowMajor = true;
	
	exports.glMatrix = _glMatrix.glMatrix;
	function configure(options) {
	  if ('epsilon' in options) {
	    _glMatrix.glMatrix.EPSILON = options.epsilon;
	  }
	
	  if ('debug' in options) {
	    _glMatrix.glMatrix.debug = options.debug;
	  }
	}
	
	function formatValue(value) {
	  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _glMatrix.glMatrix.precision || 4;
	
	  return parseFloat(value.toPrecision(precision));
	}
	
	// Returns true if value is either an array or a typed array
	// Note: does not return true for ArrayBuffers and DataViews
	function isArray(value) {
	  return Array.isArray(value) || ArrayBuffer.isView(value) && value.length !== undefined;
	}
	
	// If the array has a clone function, calls it, otherwise returns a copy
	function clone(array) {
	  return array.clone ? array.clone() : new Array(array);
	}
	
	// If the argument value is an array, applies the func element wise,
	// otherwise applies func to the argument value
	function map(value, func) {
	  if (isArray(value)) {
	    var result = clone(value);
	    for (var i = 0; i < result.length; ++i) {
	      result[i] = func(result[i], i, result);
	    }
	    return result;
	  }
	  return func(value);
	}
	
	//
	// GLSL math function equivalents
	// Works on both single values and vectors
	//
	
	function radians(degrees) {
	  return map(degrees, function (degrees) {
	    return degrees / 180 * Math.PI;
	  });
	}
	
	// GLSL equivalent: Works on single values and vectors
	function degrees(radians) {
	  return map(radians, function (radians) {
	    return radians * 180 / Math.PI;
	  });
	}
	
	// GLSL equivalent: Works on single values and vectors
	function sin(radians) {
	  return map(radians, function (angle) {
	    return Math.sin(angle);
	  });
	}
	
	// GLSL equivalent: Works on single values and vectors
	function cos(radians) {
	  return map(radians, function (angle) {
	    return Math.cos(angle);
	  });
	}
	
	// GLSL equivalent: Works on single values and vectors
	function tan(radians) {
	  return map(radians, function (angle) {
	    return Math.tan(angle);
	  });
	}
	
	// GLSL equivalent: Works on single values and vectors
	function asin(radians) {
	  return map(radians, function (angle) {
	    return Math.asin(angle);
	  });
	}
	
	// GLSL equivalent: Works on single values and vectors
	function acos(radians) {
	  return map(radians, function (angle) {
	    return Math.acos(angle);
	  });
	}
	
	// GLSL equivalent: Works on single values and vectors
	function atan(radians) {
	  return map(radians, function (angle) {
	    return Math.atan(angle);
	  });
	}
	
	// TODO - glsl equivalent
	function clamp(value, min, max) {
	  return Math.max(min, Math.min(max, value));
	}
	
	function equals(a, b) {
	  return Math.abs(a - b) <= _glMatrix.glMatrix.EPSILON * Math.max(1.0, Math.abs(a), Math.abs(b));
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var PooledClass = __webpack_require__(109);
	
	var emptyFunction = __webpack_require__(36);
	var warning = __webpack_require__(8);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 87 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Surface
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ['children', 'width', 'height', 'viewBox', 'className', 'style']);
	
	  var svgView = viewBox || { width: width, height: height, x: 0, y: 0 };
	  var layerClass = (0, _classnames2.default)('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({}, attrs, {
	      className: layerClass,
	      width: width,
	      height: height,
	      style: style,
	      viewBox: svgView.x + ' ' + svgView.y + ' ' + svgView.width + ' ' + svgView.height,
	      version: '1.1'
	    }),
	    children
	  );
	}
	
	Surface.propTypes = propTypes;
	
	exports.default = Surface;

/***/ },
/* 89 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RADIAN = exports.RADIAN = Math.PI / 180;
	
	var polarToCartesian = exports.polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	var getMaxRadius = exports.getMaxRadius = function getMaxRadius(width, height) {
	  var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0, right: 0, bottom: 0, left: 0
	  };
	  return Math.min(Math.abs(width - (margin.left || 0) - (margin.right || 0)), Math.abs(height - (margin.left || 0) - (margin.right || 0))) / 2;
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(620);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(1413);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ },
/* 92 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(69),
	    overRest = __webpack_require__(447),
	    setToString = __webpack_require__(282);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(913),
	    flatRest = __webpack_require__(276);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 95 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1207)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Dot
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Dot, _Component);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          r = _props.r,
	          className = _props.className;
	
	      var layerClass = (0, _classnames2.default)('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react2.default.createElement('circle', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.Component), _class2.displayName = 'Dot', _class2.propTypes = {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  r: _propTypes2.default.number
	}, _temp)) || _class;
	
	exports.default = Dot;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(90);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(91);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(119);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var WithState = function (_Component) {
	      _inherits(WithState, _Component);
	
	      function WithState() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithState);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithState.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return WithState;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withState'))(WithState);
	    }
	    return WithState;
	  };
	};
	
	exports.default = withState;

/***/ },
/* 99 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  top: 'top',
	  left: 'left',
	  right: 'right',
	  bottom: 'bottom'
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Group = __webpack_require__(653);
	
	Object.defineProperty(exports, 'Group', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Group).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(767), __webpack_require__(143), __webpack_require__(145), __webpack_require__(382), __webpack_require__(254), __webpack_require__(384), __webpack_require__(47)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    var d = domain(),
	        i = d.length - 1,
	        n = count == null ? 10 : count,
	        start = d[0],
	        stop = d[i],
	        step = d3Array.tickStep(start, stop, n);
	
	    if (step) {
	      step = d3Array.tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	      d[0] = Math.floor(start / step) * step;
	      d[i] = Math.ceil(stop / step) * step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(905),
	    getValue = __webpack_require__(962);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(82),
	    getPrototype = __webpack_require__(278),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(193),
	    baseGt = __webpack_require__(420),
	    identity = __webpack_require__(69);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _model = __webpack_require__(212);
	
	Object.defineProperty(exports, 'Model', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_model).default;
	  }
	});
	
	var _animationFrame = __webpack_require__(463);
	
	Object.defineProperty(exports, 'AnimationFrame', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_animationFrame).default;
	  }
	});
	Object.keys(_animationFrame).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _animationFrame[key];
	    }
	  });
	});
	
	var _camera = __webpack_require__(1034);
	
	Object.keys(_camera).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _camera[key];
	    }
	  });
	});
	
	var _event = __webpack_require__(464);
	
	Object.keys(_event).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _event[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb3JlL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OzBDQUFRQSxPOzs7Ozs7Ozs7bURBQ0FBLE87OztBQUNSO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7ZGVmYXVsdCBhcyBNb2RlbH0gZnJvbSAnLi9tb2RlbCc7XG5leHBvcnQge2RlZmF1bHQgYXMgQW5pbWF0aW9uRnJhbWV9IGZyb20gJy4vYW5pbWF0aW9uLWZyYW1lJztcbmV4cG9ydCAqIGZyb20gJy4vYW5pbWF0aW9uLWZyYW1lJztcbmV4cG9ydCAqIGZyb20gJy4vY2FtZXJhJztcbmV4cG9ydCAqIGZyb20gJy4vZXZlbnQnO1xuIl19

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(30);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ILLEGAL_ARG = 'Geometry: Illegal argument';
	
	var Geometry = function () {
	  function Geometry() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Geometry);
	
	    var id = opts.id,
	        _opts$drawMode = opts.drawMode,
	        drawMode = _opts$drawMode === undefined ? 'TRIANGLES' : _opts$drawMode,
	        _opts$vertexCount = opts.vertexCount,
	        vertexCount = _opts$vertexCount === undefined ? undefined : _opts$vertexCount,
	        attributes = opts.attributes;
	
	
	    (0, _assert2.default)(drawMode, ILLEGAL_ARG);
	
	    this.id = id || (0, _utils.uid)(this.constructor.name);
	    this.drawMode = drawMode;
	    this.vertexCount = vertexCount;
	    this.attributes = {};
	    this.needsRedraw = true;
	    this.userData = {};
	    Object.seal(this);
	
	    if (attributes) {
	      this.setAttributes(attributes);
	    } else {
	      _utils.log.once('Geometry: top-level attributes are deprecated, use "attributes" param');
	      // TODO this is deprecated
	      delete opts.id;
	      delete opts.drawMode;
	      delete opts.vertexCount;
	      delete opts.attributes;
	      this.setAttributes(opts);
	    }
	  }
	
	  _createClass(Geometry, [{
	    key: 'setNeedsRedraw',
	    value: function setNeedsRedraw() {
	      var redraw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.needsRedraw = redraw;
	      return this;
	    }
	  }, {
	    key: 'getNeedsRedraw',
	    value: function getNeedsRedraw() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$clearRedrawFlags = _ref.clearRedrawFlags,
	          clearRedrawFlags = _ref$clearRedrawFlags === undefined ? false : _ref$clearRedrawFlags;
	
	      var redraw = false;
	      redraw = redraw || this.needsRedraw;
	      this.needsRedraw = this.needsRedraw && !clearRedrawFlags;
	      return redraw;
	    }
	  }, {
	    key: 'setVertexCount',
	    value: function setVertexCount(vertexCount) {
	      this.vertexCount = vertexCount;
	    }
	  }, {
	    key: 'getVertexCount',
	    value: function getVertexCount() {
	      if (this.vertexCount !== undefined) {
	        return this.vertexCount;
	      } else if (this.attributes.indices) {
	        return this.attributes.indices.value.length;
	      } else if (this.attributes.vertices) {
	        return this.attributes.vertices.value.length / 3;
	      } else if (this.attributes.positions) {
	        return this.attributes.positions.value.length / 3;
	      }
	      return false;
	    }
	  }, {
	    key: 'hasAttribute',
	    value: function hasAttribute(attributeName) {
	      return Boolean(this.attributes[attributeName]);
	    }
	  }, {
	    key: 'getAttribute',
	    value: function getAttribute(attributeName) {
	      var attribute = this.attributes[attributeName];
	      (0, _assert2.default)(attribute);
	      return attribute.value;
	    }
	  }, {
	    key: 'getArray',
	    value: function getArray(attributeName) {
	      var attribute = this.attributes[attributeName];
	      (0, _assert2.default)(attribute);
	      return attribute.value;
	    }
	  }, {
	    key: 'getAttributes',
	    value: function getAttributes() {
	      return this.attributes;
	    }
	
	    // Attribute
	    // value: typed array
	    // type: indices, vertices, uvs
	    // size: elements per vertex
	    // target: WebGL buffer type (string or constant)
	
	  }, {
	    key: 'setAttributes',
	    value: function setAttributes(attributes) {
	      for (var attributeName in attributes) {
	        var attribute = attributes[attributeName];
	
	        // Wrap "unwrapped" arrays and try to autodetect their type
	        attribute = ArrayBuffer.isView(attribute) ? { value: attribute } : attribute;
	
	        (0, _assert2.default)(ArrayBuffer.isView(attribute.value), this._print(attributeName) + ': must be typed array or object with value as typed array');
	
	        this._autoDetectAttribute(attributeName, attribute);
	
	        this.attributes[attributeName] = Object.assign({}, attribute, {
	          instanced: attribute.instanced || 0
	        });
	      }
	      this.setNeedsRedraw();
	      return this;
	    }
	
	    // Check for well known attribute names
	    /* eslint-disable default-case, complexity */
	
	  }, {
	    key: '_autoDetectAttribute',
	    value: function _autoDetectAttribute(attributeName, attribute) {
	      var category = void 0;
	      switch (attributeName) {
	        case 'indices':
	          category = category || 'indices';
	          break;
	        case 'texCoords':
	        case 'texCoord1':
	        case 'texCoord2':
	        case 'texCoord3':
	          category = 'uvs';
	          break;
	        case 'vertices':
	        case 'positions':
	        case 'normals':
	        case 'pickingColors':
	          category = 'vectors';
	          break;
	      }
	
	      // Check for categorys
	      switch (category) {
	        case 'vectors':
	          attribute.size = attribute.size || 3;
	          break;
	        case 'uvs':
	          attribute.size = attribute.size || 2;
	          break;
	        case 'indices':
	          attribute.size = attribute.size || 1;
	          attribute.isIndexed = attribute.isIndexed || true;
	          (0, _assert2.default)(attribute.value instanceof Uint16Array || attribute.value instanceof Uint32Array, 'attribute array for "indices" must be of integer type');
	          break;
	      }
	
	      (0, _assert2.default)(attribute.size, 'attribute ' + attributeName + ' needs size');
	    }
	    /* eslint-enable default-case, complexity */
	
	  }, {
	    key: '_print',
	    value: function _print(attributeName) {
	      return 'Geometry ' + this.id + ' attribute ' + attributeName;
	    }
	  }]);
	
	  return Geometry;
	}();
	
	exports.default = Geometry;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	exports.default = function () {};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.2. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 109 */
[1491, 20],
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1242);
	var ReactInstrumentation = __webpack_require__(65);
	
	var warning = __webpack_require__(8);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 111 */
[1498, 573, 575],
/* 112 */
[1498, 579, 581],
/* 113 */
[1498, 584, 586],
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1208);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var PureRenderComponent = function (_React$Component) {
	  _inherits(PureRenderComponent, _React$Component);
	
	  function PureRenderComponent(props) {
	    _classCallCheck(this, PureRenderComponent);
	
	    return _possibleConstructorReturn(this, (PureRenderComponent.__proto__ || Object.getPrototypeOf(PureRenderComponent)).call(this, props));
	  }
	
	  _createClass(PureRenderComponent, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }]);
	
	  return PureRenderComponent;
	}(_react2.default.Component);
	
	exports.default = PureRenderComponent;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactChildren = __webpack_require__(1387);
	var ReactComponent = __webpack_require__(350);
	var ReactPureComponent = __webpack_require__(1392);
	var ReactClass = __webpack_require__(1388);
	var ReactDOMFactories = __webpack_require__(1389);
	var ReactElement = __webpack_require__(136);
	var ReactPropTypes = __webpack_require__(1391);
	var ReactVersion = __webpack_require__(1393);
	
	var onlyChild = __webpack_require__(1396);
	var warning = __webpack_require__(8);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Legend
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DefaultLegendContent = __webpack_require__(1407);
	
	var _DefaultLegendContent2 = _interopRequireDefault(_DefaultLegendContent);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultLegendContent2.default, props);
	};
	
	var EPS = 1;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Legend, _Component);
	
	  function Legend() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legend.__proto__ || Object.getPrototypeOf(Legend)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Legend, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'getBBox',
	    value: function getBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return { width: boxWidth, height: boxHeight };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getDefaultPosition',
	    value: function getDefaultPosition(style) {
	      var _props = this.props,
	          layout = _props.layout,
	          align = _props.align,
	          verticalAlign = _props.verticalAlign,
	          margin = _props.margin,
	          chartWidth = _props.chartWidth,
	          chartHeight = _props.chartHeight;
	
	      var hPos = void 0,
	          vPos = void 0;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || { width: 0 };
	          hPos = { left: ((chartWidth || 0) - box.width) / 2 };
	        } else {
	          hPos = align === 'right' ? { right: margin && margin.right || 0 } : { left: margin && margin.left || 0 };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || { height: 0 };
	          vPos = { top: ((chartHeight || 0) - _box.height) / 2 };
	        } else {
	          vPos = verticalAlign === 'bottom' ? { bottom: margin && margin.bottom || 0 } : { top: margin && margin.top || 0 };
	        }
	      }
	
	      return _extends({}, hPos, vPos);
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state2 = this.state,
	          boxWidth = _state2.boxWidth,
	          boxHeight = _state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          content = _props2.content,
	          width = _props2.width,
	          height = _props2.height,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), wrapperStyle);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-legend-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }], [{
	    key: 'getWithHeight',
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      } else if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  wrapperStyle: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    left: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onBBoxUpdate: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	}, _temp2)) || _class;
	
	exports.default = Legend;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(363);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed, curveBasisOpen: _d3Shape.curveBasisOpen, curveBasis: _d3Shape.curveBasis, curveLinearClosed: _d3Shape.curveLinearClosed, curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX, curveMonotoneY: _d3Shape.curveMonotoneY, curveNatural: _d3Shape.curveNatural, curveStep: _d3Shape.curveStep, curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	var getX = function getX(p) {
	  return p.x;
	};
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction3.default)(type)) {
	    return type;
	  }
	
	  var name = 'curve' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES['' + name + (layout === 'vertical' ? 'Y' : 'X')];
	  }
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Curve, _Component);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: 'getPath',
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          type = _props.type,
	          points = _props.points,
	          baseLine = _props.baseLine,
	          layout = _props.layout,
	          connectNulls = _props.connectNulls;
	
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction = void 0;
	
	      if ((0, _isArray3.default)(baseLine)) {
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _extends({}, entry, { base: baseLine[index] });
	        });
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	        lineFunction.defined(defined).curve(curveFactory);
	
	        return lineFunction(areaPoints);
	      } else if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          points = _props2.points,
	          pathRef = _props2.pathRef;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-curve', className),
	        d: this.getPath(),
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.Component), _class2.displayName = 'Curve', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  connectNulls: _propTypes2.default.bool,
	  pathRef: _propTypes2.default.func
	}), _class2.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	}, _temp)) || _class;
	
	exports.default = Curve;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Rectangle
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var sign = height >= 0 ? 1 : -1;
	  var clockWise = height >= 0 ? 1 : 0;
	  var path = void 0;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = 'M' + x + ',' + (y + sign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += 'A ' + newRadius[0] + ',' + newRadius[0] + ',0,0,' + clockWise + ',' + (x + newRadius[0]) + ',' + y;
	    }
	
	    path += 'L ' + (x + width - newRadius[1]) + ',' + y;
	
	    if (newRadius[1] > 0) {
	      path += 'A ' + newRadius[1] + ',' + newRadius[1] + ',0,0,' + clockWise + ',\n        ' + (x + width) + ',' + (y + sign * newRadius[1]);
	    }
	    path += 'L ' + (x + width) + ',' + (y + height - sign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += 'A ' + newRadius[2] + ',' + newRadius[2] + ',0,0,' + clockWise + ',\n        ' + (x + width - newRadius[2]) + ',' + (y + height);
	    }
	    path += 'L ' + (x + newRadius[3]) + ',' + (y + height);
	
	    if (newRadius[3] > 0) {
	      path += 'A ' + newRadius[3] + ',' + newRadius[3] + ',0,0,' + clockWise + ',\n        ' + x + ',' + (y + height - sign * newRadius[3]);
	    }
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = 'M ' + x + ',' + (y + sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + _newRadius) + ',' + y + '\n            L ' + (x + width - _newRadius) + ',' + y + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width) + ',' + (y + sign * _newRadius) + '\n            L ' + (x + width) + ',' + (y + height - sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width - _newRadius) + ',' + (y + height) + '\n            L ' + (x + _newRadius) + ',' + (y + height) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + x + ',' + (y + height - sign * _newRadius) + ' Z';
	  } else {
	    path = 'M ' + x + ',' + y + ' h ' + width + ' v ' + height + ' h ' + -width + ' Z';
	  }
	
	  return path;
	};
	
	var Rectangle = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Rectangle, _Component);
	
	  function Rectangle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      totalLength: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Rectangle, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        var totalLength = this.node.getTotalLength();
	
	        if (totalLength) {
	          this.setState({
	            totalLength: totalLength
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          radius = _props.radius,
	          className = _props.className;
	      var totalLength = this.state.totalLength;
	      var _props2 = this.props,
	          animationEasing = _props2.animationEasing,
	          animationDuration = _props2.animationDuration,
	          animationBegin = _props2.animationBegin,
	          isAnimationActive = _props2.isAnimationActive,
	          isUpdateAnimationActive = _props2.isUpdateAnimationActive;
	
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          canBegin: totalLength > 0,
	          from: { width: width, height: height, x: x, y: y },
	          to: { width: width, height: height, x: x, y: y },
	          duration: animationDuration,
	          animationEasing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref2) {
	          var currWidth = _ref2.width,
	              currHeight = _ref2.height,
	              currX = _ref2.x,
	              currY = _ref2.y;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              canBegin: totalLength > 0,
	              from: '0px ' + (totalLength === -1 ? 1 : totalLength) + 'px',
	              to: totalLength + 'px 0px',
	              attributeName: 'strokeDasharray',
	              begin: animationBegin,
	              duration: animationDuration,
	              isActive: isAnimationActive,
	              easing: animationEasing
	            },
	            _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	              className: layerClass,
	              d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	              ref: function ref(node) {
	                _this2.node = node;
	              }
	            }))
	          );
	        }
	      );
	    }
	  }]);
	
	  return Rectangle;
	}(_react.Component), _class2.displayName = 'Rectangle', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = Rectangle;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(1418);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(1415);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(48);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(16),
	    isKey = __webpack_require__(280),
	    stringToPath = __webpack_require__(1003),
	    toString = __webpack_require__(462);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(127);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 125 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(195);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(82),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(413),
	    baseKeysIn = __webpack_require__(907),
	    isArrayLike = __webpack_require__(75);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(193),
	    baseLt = __webpack_require__(423),
	    identity = __webpack_require__(69);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _common = __webpack_require__(85);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    var instance = Reflect.construct(cls, Array.from(arguments));
	    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
	    return instance;
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var MathArray = function (_extendableBuiltin2) {
	  _inherits(MathArray, _extendableBuiltin2);
	
	  function MathArray() {
	    _classCallCheck(this, MathArray);
	
	    return _possibleConstructorReturn(this, (MathArray.__proto__ || Object.getPrototypeOf(MathArray)).apply(this, arguments));
	  }
	
	  _createClass(MathArray, [{
	    key: 'clone',
	    value: function clone() {
	      var Subclass = this.constructor;
	      var clone = new Subclass().copy(this);
	      clone.check();
	      return clone;
	    }
	  }, {
	    key: 'copy',
	    value: function copy(array) {
	      for (var i = 0; i < this.ELEMENTS; ++i) {
	        this[i] = array[i];
	      }
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'set',
	    value: function set() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      for (var i = 0; i < this.ELEMENTS; ++i) {
	        this[i] = args[i] || 0;
	      }
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'fromArray',
	    value: function fromArray(array) {
	      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      for (var i = 0; i < this.ELEMENTS; ++i) {
	        this[i] = array[i + offset];
	      }
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var string = '';
	      for (var i = 0; i < this.ELEMENTS; ++i) {
	        string += (i > 0 ? ', ' : '') + (0, _common.formatValue)(this[i]);
	      }
	      return this.constructor.name + '(' + string + ')';
	    }
	  }, {
	    key: 'toArray',
	    value: function toArray() {
	      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      for (var i = 0; i < this.ELEMENTS; ++i) {
	        array[offset + i] = this[i];
	      }
	      return array;
	    }
	  }, {
	    key: 'toFloat32Array',
	    value: function toFloat32Array() {
	      return new Float32Array(this);
	    }
	  }, {
	    key: 'equals',
	    value: function equals(array) {
	      if (this.length !== array.length) {
	        return false;
	      }
	      for (var i = 0; i < this.ELEMENTS; ++i) {
	        if (!(0, _common.equals)(this[i], array[i])) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }, {
	    key: 'exactEquals',
	    value: function exactEquals(array) {
	      if (this.length !== array.length) {
	        return false;
	      }
	      for (var i = 0; i < this.ELEMENTS; ++i) {
	        if (this[i] !== array[i]) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }, {
	    key: 'validate',
	    value: function validate() {
	      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
	
	      var valid = array.length === this.ELEMENTS;
	      for (var i = 0; i < this.ELEMENTS; ++i) {
	        valid = valid && Number.isFinite(array[i]);
	      }
	      return valid;
	    }
	  }, {
	    key: 'check',
	    value: function check() {
	      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
	
	      if (_common.glMatrix.debug && !this.validate(array)) {
	        throw new Error('Invalid ' + this.constructor.name);
	      }
	    }
	  }]);
	
	  return MathArray;
	}(_extendableBuiltin(Array));
	
	exports.default = MathArray;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VertexArrayObject = exports.TimerQuery = exports.VertexAttributes = exports.TextureCube = exports.Texture2D = exports.Renderbuffer = exports.Framebuffer = exports.Program = exports.FragmentShader = exports.VertexShader = exports.Shader = exports.Buffer = exports.isWebGL2Context = exports.isWebGLContext = undefined;
	
	var _webgl = __webpack_require__(58);
	
	Object.keys(_webgl).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _webgl[key];
	    }
	  });
	});
	
	var _context = __webpack_require__(300);
	
	Object.keys(_context).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _context[key];
	    }
	  });
	});
	
	var _webglChecks = __webpack_require__(37);
	
	Object.defineProperty(exports, 'isWebGLContext', {
	  enumerable: true,
	  get: function get() {
	    return _webglChecks.isWebGLContext;
	  }
	});
	Object.defineProperty(exports, 'isWebGL2Context', {
	  enumerable: true,
	  get: function get() {
	    return _webglChecks.isWebGL2Context;
	  }
	});
	
	var _buffer = __webpack_require__(161);
	
	Object.defineProperty(exports, 'Buffer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buffer).default;
	  }
	});
	
	var _shader = __webpack_require__(302);
	
	Object.defineProperty(exports, 'Shader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shader).default;
	  }
	});
	Object.defineProperty(exports, 'VertexShader', {
	  enumerable: true,
	  get: function get() {
	    return _shader.VertexShader;
	  }
	});
	Object.defineProperty(exports, 'FragmentShader', {
	  enumerable: true,
	  get: function get() {
	    return _shader.FragmentShader;
	  }
	});
	
	var _program = __webpack_require__(483);
	
	Object.defineProperty(exports, 'Program', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_program).default;
	  }
	});
	
	var _framebuffer = __webpack_require__(301);
	
	Object.defineProperty(exports, 'Framebuffer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_framebuffer).default;
	  }
	});
	
	var _renderbuffer = __webpack_require__(215);
	
	Object.defineProperty(exports, 'Renderbuffer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_renderbuffer).default;
	  }
	});
	
	var _texture2d = __webpack_require__(216);
	
	Object.defineProperty(exports, 'Texture2D', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_texture2d).default;
	  }
	});
	
	var _textureCube = __webpack_require__(484);
	
	Object.defineProperty(exports, 'TextureCube', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_textureCube).default;
	  }
	});
	
	var _timerQuery = __webpack_require__(485);
	
	Object.defineProperty(exports, 'TimerQuery', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_timerQuery).default;
	  }
	});
	
	var _draw = __webpack_require__(481);
	
	Object.keys(_draw).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _draw[key];
	    }
	  });
	});
	
	var _uniforms = __webpack_require__(486);
	
	Object.keys(_uniforms).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _uniforms[key];
	    }
	  });
	});
	
	var _vertexArrayObject = __webpack_require__(487);
	
	Object.defineProperty(exports, 'VertexArrayObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vertexArrayObject).default;
	  }
	});
	
	var _vertexAttributes = __webpack_require__(488);
	
	var VertexAttributes = _interopRequireWildcard(_vertexAttributes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.VertexAttributes = VertexAttributes;
	
	// Extensions
	
	
	// Functions
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)))

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)))

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(317);
	var setInnerHTML = __webpack_require__(230);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(325);
	var setTextContent = __webpack_require__(565);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(4);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(87);
	
	var warning = __webpack_require__(8);
	var canDefineProperty = __webpack_require__(604);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(603);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 137 */
20,
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = function (WrappedComponent) {
	  var _class, _temp2;
	
	  var AnimationDecorator = (_temp2 = _class = function (_Component) {
	    _inherits(AnimationDecorator, _Component);
	
	    function AnimationDecorator() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, AnimationDecorator);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimationDecorator.__proto__ || Object.getPrototypeOf(AnimationDecorator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        animationId: 0
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AnimationDecorator, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var animationId = this.state.animationId;
	
	
	        if (this.props.data !== nextProps.data) {
	          this.setState({
	            animationId: animationId + 1
	          });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { animationId: this.state.animationId }));
	      }
	    }]);
	
	    return AnimationDecorator;
	  }(_react.Component), _class.displayName = 'AnimationDecorator(' + (0, _ReactUtils.getDisplayName)(WrappedComponent) + ')', _class.propTypes = _extends({}, WrappedComponent.propTypes, {
	    data: _propTypes2.default.array
	  }), _class.WrappedComponent = WrappedComponent, _class.defaultProps = WrappedComponent.defaultProps, _temp2);
	
	
	  return AnimationDecorator;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	isNonEmptyArray:function isNonEmptyArray(collection){
	return Array.isArray(collection)&&collection.length>0;
	},
	
	containsStrings:function containsStrings(collection){
	return Array.isArray(collection)&&collection.some(function(value){return typeof value==="string";});
	},
	
	containsDates:function containsDates(collection){
	return Array.isArray(collection)&&collection.some(function(value){return value instanceof Date;});
	},
	
	containsOnlyStrings:function containsOnlyStrings(collection){
	return this.isNonEmptyArray(collection)&&
	collection.every(function(value){return typeof value==="string";});
	},
	
	isArrayOfArrays:function isArrayOfArrays(collection){
	return this.isNonEmptyArray(collection)&&collection.every(Array.isArray);
	},
	
	removeUndefined:function removeUndefined(arr){
	return arr.filter(function(el){return el!==undefined;});
	},
	
	getMaxValue:function getMaxValue(arr){for(var _len=arguments.length,values=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){values[_key-1]=arguments[_key];}
	var array=arr.concat(values);
	return this.containsDates(array)?
	new Date(Math.max.apply(Math,_toConsumableArray(array))):
	Math.max.apply(Math,_toConsumableArray(array));
	},
	
	getMinValue:function getMinValue(arr){for(var _len2=arguments.length,values=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){values[_key2-1]=arguments[_key2];}
	var array=arr.concat(values);
	return this.containsDates(array)?
	new Date(Math.min.apply(Math,_toConsumableArray(array))):
	Math.min.apply(Math,_toConsumableArray(array));
	},
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	splitArray:function splitArray(array,delimiterFn){
	var segmentStartIndex=0;
	var segments=array.reduce(function(memo,item,index){
	if(delimiterFn(item)){
	memo=memo.concat([array.slice(segmentStartIndex,index)]);
	segmentStartIndex=index+1;
	}else if(index===array.length-1){
	memo=memo.concat([array.slice(segmentStartIndex,array.length)]);
	}
	return memo;
	},[]);
	
	return segments.filter(function(segment){
	return Array.isArray(segment)&&segment.length>0;
	});
	},
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	allSetsEqual:function allSetsEqual(itemSets){
	return itemSets.every(function(comparisonSet){
	return(0,_isEqual3.default)(comparisonSet[0],comparisonSet[1]);
	});
	}};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Axis;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(141);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shape = __webpack_require__(375);
	
	var _point = __webpack_require__(374);
	
	var _group = __webpack_require__(100);
	
	var _center = __webpack_require__(648);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _identity = __webpack_require__(649);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _labelTransform = __webpack_require__(650);
	
	var _labelTransform2 = _interopRequireDefault(_labelTransform);
	
	var _orientation = __webpack_require__(99);
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  axisClassName: _propTypes2.default.string,
	  axisLineClassName: _propTypes2.default.string,
	  hideAxisLine: _propTypes2.default.bool,
	  hideTicks: _propTypes2.default.bool,
	  hideZero: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  labelClassName: _propTypes2.default.string,
	  labelOffset: _propTypes2.default.number,
	  labelProps: _propTypes2.default.object,
	  left: _propTypes2.default.number,
	  numTicks: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf([_orientation2.default.top, _orientation2.default.right, _orientation2.default.bottom, _orientation2.default.left]),
	  rangePadding: _propTypes2.default.number,
	  scale: _propTypes2.default.func.isRequired,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  strokeDasharray: _propTypes2.default.string,
	  tickClassName: _propTypes2.default.string,
	  tickFormat: _propTypes2.default.func,
	  tickLabelProps: _propTypes2.default.func,
	  tickLength: _propTypes2.default.number,
	  tickStroke: _propTypes2.default.string,
	  tickTransform: _propTypes2.default.string,
	  tickValues: _propTypes2.default.array,
	  top: _propTypes2.default.number,
	  children: _propTypes2.default.func
	};
	
	function Axis(_ref) {
	  var children = _ref.children,
	      axisClassName = _ref.axisClassName,
	      axisLineClassName = _ref.axisLineClassName,
	      _ref$hideAxisLine = _ref.hideAxisLine,
	      hideAxisLine = _ref$hideAxisLine === undefined ? false : _ref$hideAxisLine,
	      _ref$hideTicks = _ref.hideTicks,
	      hideTicks = _ref$hideTicks === undefined ? false : _ref$hideTicks,
	      _ref$hideZero = _ref.hideZero,
	      hideZero = _ref$hideZero === undefined ? false : _ref$hideZero,
	      _ref$label = _ref.label,
	      label = _ref$label === undefined ? '' : _ref$label,
	      labelClassName = _ref.labelClassName,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 14 : _ref$labelOffset,
	      _ref$labelProps = _ref.labelProps,
	      labelProps = _ref$labelProps === undefined ? {
	    textAnchor: 'middle',
	    fontFamily: 'Arial',
	    fontSize: 10,
	    fill: 'black'
	  } : _ref$labelProps,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      _ref$numTicks = _ref.numTicks,
	      numTicks = _ref$numTicks === undefined ? 10 : _ref$numTicks,
	      _ref$orientation = _ref.orientation,
	      orientation = _ref$orientation === undefined ? _orientation2.default.bottom : _ref$orientation,
	      _ref$rangePadding = _ref.rangePadding,
	      rangePadding = _ref$rangePadding === undefined ? 0 : _ref$rangePadding,
	      scale = _ref.scale,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? 'black' : _ref$stroke,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 1 : _ref$strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      tickClassName = _ref.tickClassName,
	      tickFormat = _ref.tickFormat,
	      _ref$tickLabelProps = _ref.tickLabelProps,
	      tickLabelProps = _ref$tickLabelProps === undefined ? function (tickValue, index) {
	    return {
	      textAnchor: 'middle',
	      fontFamily: 'Arial',
	      fontSize: 10,
	      fill: 'black'
	    };
	  } : _ref$tickLabelProps,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      _ref$tickStroke = _ref.tickStroke,
	      tickStroke = _ref$tickStroke === undefined ? 'black' : _ref$tickStroke,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top;
	
	  var values = scale.ticks ? scale.ticks(numTicks) : scale.domain();
	  if (tickValues) values = tickValues;
	  var format = scale.tickFormat ? scale.tickFormat() : _identity2.default;
	  if (tickFormat) format = tickFormat;
	
	  var range = scale.range();
	  var range0 = range[0] + 0.5 - rangePadding;
	  var range1 = range[range.length - 1] + 0.5 + rangePadding;
	
	  var horizontal = orientation !== _orientation2.default.left && orientation !== _orientation2.default.right;
	  var isLeft = orientation === _orientation2.default.left;
	  var isTop = orientation === _orientation2.default.top;
	  var tickSign = isLeft || isTop ? -1 : 1;
	
	  var position = (scale.bandwidth ? _center2.default : _identity2.default)(scale.copy());
	
	  var axisFromPoint = new _point.Point({
	    x: horizontal ? range0 : 0,
	    y: horizontal ? 0 : range0
	  });
	  var axisToPoint = new _point.Point({
	    x: horizontal ? range1 : 0,
	    y: horizontal ? 0 : range1
	  });
	
	  var tickLabelFontSize = 10; // track the max tick label size to compute label offset
	
	  if (!!children) {
	    return _react2.default.createElement(
	      _group.Group,
	      {
	        className: (0, _classnames2.default)('vx-axis', axisClassName),
	        top: top,
	        left: left
	      },
	      children({
	        axisFromPoint: axisFromPoint,
	        axisToPoint: axisToPoint,
	        horizontal: horizontal,
	        tickSign: tickSign,
	        numTicks: numTicks,
	        label: label,
	        rangePadding: rangePadding,
	        tickLength: tickLength,
	        tickFormat: format,
	        tickPosition: position,
	        ticks: values.map(function (value, index) {
	          var from = new _point.Point({
	            x: horizontal ? position(value) : 0,
	            y: horizontal ? 0 : position(value)
	          });
	          var to = new _point.Point({
	            x: horizontal ? position(value) : tickSign * tickLength,
	            y: horizontal ? tickLength * tickSign : position(value)
	          });
	          return {
	            value: value,
	            index: index,
	            from: from,
	            to: to,
	            formattedValue: format(value, index)
	          };
	        })
	      })
	    );
	  }
	
	  return _react2.default.createElement(
	    _group.Group,
	    {
	      className: (0, _classnames2.default)('vx-axis', axisClassName),
	      top: top,
	      left: left
	    },
	    values.map(function (val, index) {
	      if (hideZero && val === 0) return null;
	
	      var tickFromPoint = new _point.Point({
	        x: horizontal ? position(val) : 0,
	        y: horizontal ? 0 : position(val)
	      });
	      var tickToPoint = new _point.Point({
	        x: horizontal ? position(val) : tickSign * tickLength,
	        y: horizontal ? tickLength * tickSign : position(val)
	      });
	
	      var tickLabelPropsObj = tickLabelProps(val, index);
	      tickLabelFontSize = Math.max(tickLabelFontSize, tickLabelPropsObj.fontSize || 0);
	
	      return _react2.default.createElement(
	        _group.Group,
	        {
	          key: 'vx-tick-' + val + '-' + index,
	          className: (0, _classnames2.default)('vx-axis-tick', tickClassName),
	          transform: tickTransform
	        },
	        !hideTicks && _react2.default.createElement(_shape.Line, {
	          from: tickFromPoint,
	          to: tickToPoint,
	          stroke: tickStroke
	        }),
	        _react2.default.createElement(
	          'text',
	          _extends({
	            x: tickToPoint.x,
	            y: tickToPoint.y + (horizontal && !isTop ? tickLabelFontSize : 0)
	          }, tickLabelPropsObj),
	          format(val, index)
	        )
	      );
	    }),
	    !hideAxisLine && _react2.default.createElement(_shape.Line, {
	      className: (0, _classnames2.default)('vx-axis-line', axisLineClassName),
	      from: axisFromPoint,
	      to: axisToPoint,
	      stroke: stroke,
	      strokeWidth: strokeWidth,
	      strokeDasharray: strokeDasharray
	    }),
	    label && _react2.default.createElement(
	      'text',
	      _extends({
	        className: (0, _classnames2.default)('vx-axis-label', labelClassName)
	      }, (0, _labelTransform2.default)({
	        labelOffset: labelOffset,
	        labelProps: labelProps,
	        orientation: orientation,
	        range: range,
	        tickLabelFontSize: tickLabelFontSize,
	        tickLength: tickLength
	      }), labelProps),
	      label
	    )
	  );
	}
	
	Axis.propTypes = propTypes;

/***/ },
/* 141 */
[1483, 651],
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      domain = _ref.domain,
	      unknown = _ref.unknown;
	
	  var scale = (0, _d3Scale.scaleOrdinal)();
	
	  if (range) scale.range(range);
	  if (domain) scale.domain(domain);
	  if (unknown) scale.unknown(unknown);
	
	  return scale;
	};

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) return rollup != null
	        ? rollup(array) : (sortValues != null
	        ? array.sort(sortValues)
	        : array);
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-hierarchy/ Version 1.1.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	var cluster = function() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	};
	
	function count(node) {
	  var sum = 0,
	      children = node.children,
	      i = children && children.length;
	  if (!i) sum = 1;
	  else while (--i >= 0) sum += children[i].value;
	  node.value = sum;
	}
	
	var node_count = function() {
	  return this.eachAfter(count);
	};
	
	var node_each = function(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	};
	
	var node_eachBefore = function(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	};
	
	var node_eachAfter = function(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	};
	
	var node_sum = function(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	};
	
	var node_sort = function(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	};
	
	var node_path = function(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	};
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	var node_ancestors = function() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	};
	
	var node_descendants = function() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	};
	
	var node_leaves = function() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	};
	
	var node_links = function() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	};
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  count: node_count,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	var slice = Array.prototype.slice;
	
	function shuffle(array) {
	  var m = array.length,
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m];
	    array[m] = array[i];
	    array[i] = t;
	  }
	
	  return array;
	}
	
	var enclose = function(circles) {
	  var i = 0, n = (circles = shuffle(slice.call(circles))).length, B = [], p, e;
	
	  while (i < n) {
	    p = circles[i];
	    if (e && enclosesWeak(e, p)) ++i;
	    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
	  }
	
	  return e;
	};
	
	function extendBasis(B, p) {
	  var i, j;
	
	  if (enclosesWeakAll(p, B)) return [p];
	
	  // If we get here then B must have at least one element.
	  for (i = 0; i < B.length; ++i) {
	    if (enclosesNot(p, B[i])
	        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
	      return [B[i], p];
	    }
	  }
	
	  // If we get here then B must have at least two elements.
	  for (i = 0; i < B.length - 1; ++i) {
	    for (j = i + 1; j < B.length; ++j) {
	      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
	          && enclosesNot(encloseBasis2(B[i], p), B[j])
	          && enclosesNot(encloseBasis2(B[j], p), B[i])
	          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
	        return [B[i], B[j], p];
	      }
	    }
	  }
	
	  // If we get here then something is very wrong.
	  throw new Error;
	}
	
	function enclosesNot(a, b) {
	  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
	  return dr < 0 || dr * dr < dx * dx + dy * dy;
	}
	
	function enclosesWeak(a, b) {
	  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function enclosesWeakAll(a, B) {
	  for (var i = 0; i < B.length; ++i) {
	    if (!enclosesWeak(a, B[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function encloseBasis(B) {
	  switch (B.length) {
	    case 1: return encloseBasis1(B[0]);
	    case 2: return encloseBasis2(B[0], B[1]);
	    case 3: return encloseBasis3(B[0], B[1], B[2]);
	  }
	}
	
	function encloseBasis1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function encloseBasis2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function encloseBasis3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = x1 - x2,
	      a3 = x1 - x3,
	      b2 = y1 - y2,
	      b3 = y1 - y3,
	      c2 = r2 - r1,
	      c3 = r3 - r1,
	      d1 = x1 * x1 + y1 * y1 - r1 * r1,
	      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
	      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (r1 + xa * xb + ya * yb),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
	  return {
	    x: x1 + xa + xb * r,
	    y: y1 + ya + yb * r,
	    r: r
	  };
	}
	
	function place(a, b, c) {
	  var ax = a.x,
	      ay = a.y,
	      da = b.r + c.r,
	      db = a.r + c.r,
	      dx = b.x - ax,
	      dy = b.y - ay,
	      dc = dx * dx + dy * dy;
	  if (dc) {
	    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
	        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	    c.x = ax + x * dx + y * dy;
	    c.y = ay + x * dy - y * dx;
	  } else {
	    c.x = ax + db;
	    c.y = ay;
	  }
	}
	
	function intersects(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r + b.r;
	  return dr * dr - 1e-6 > dx * dx + dy * dy;
	}
	
	function score(node) {
	  var a = node._,
	      b = node.next._,
	      ab = a.r + b.r,
	      dx = (a.x * b.r + b.x * a.r) / ab,
	      dy = (a.y * b.r + b.y * a.r) / ab;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n, aa, ca, i, j, k, sj, sk;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    // “Closeness” is determined by linear distance along the front-chain.
	    // “Ahead” or “behind” is likewise determined by linear distance.
	    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	    do {
	      if (sj <= sk) {
	        if (intersects(j._, c._)) {
	          b = j, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sj += j._.r, j = j.next;
	      } else {
	        if (intersects(k._, c._)) {
	          a = k, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sk += k._.r, k = k.previous;
	      }
	    } while (j !== k.next);
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Compute the new closest circle pair to the centroid.
	    aa = score(a);
	    while ((c = c.next) !== b) {
	      if ((ca = score(c)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	var siblings = function(circles) {
	  packEnclose(circles);
	  return circles;
	};
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	var index = function() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
	  };
	
	  return pack;
	};
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	var roundNode = function(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	};
	
	var treemapDice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	};
	
	var partition = function() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	};
	
	var keyPrefix = "$";
	var preroot = {depth: -1};
	var ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	var stratify = function() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	};
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	var tree = function() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	};
	
	var treemapSlice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	};
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = ((function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	}))(phi);
	
	var index$1 = function() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	};
	
	var binary = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((x1 - x0) > (y1 - y0)) {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    } else {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    }
	  }
	};
	
	var sliceDice = function(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	};
	
	var resquarify = ((function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	}))(phi);
	
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(47)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-voronoi/ Version 1.1.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function x(d) {
	  return d[0];
	}
	
	function y(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon || Math.abs(endY - startY) > epsilon) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon && y1 - endY > epsilon ? [x0, Math.abs(startX - x0) < epsilon ? startY : y1]
	              : Math.abs(endY - y1) < epsilon && x1 - endX > epsilon ? [Math.abs(startY - y1) < epsilon ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon && endY - y0 > epsilon ? [x1, Math.abs(startX - x1) < epsilon ? startY : y0]
	              : Math.abs(endY - y0) < epsilon && endX - x0 > epsilon ? [Math.abs(startY - y0) < epsilon ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon
	      && Math.abs(y - lArc.circle.cy) < epsilon) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon
	      && Math.abs(y - rArc.circle.cy) < epsilon) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      if (!(m = (halfedges = cell.halfedges).length)) return;
	      var site = cell.site,
	          halfedges,
	          j = -1,
	          m,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
	
	    // Use the previously-found cell, or start with an arbitrary one.
	    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
	    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
	
	    // Traverse the half-edges to find a closer cell, if any.
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	var voronoi = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon) * epsilon, Math.round(y$$1(d, i, data) / epsilon) * epsilon];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	exports.voronoi = voronoi;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// View and Projection Matrix management
	
	// However since it is used by mapbox etc, it should already be present
	// in most target application bundles.
	
	
	exports.createMat4 = createMat4;
	
	var _glMatrix = __webpack_require__(55);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IDENTITY = createMat4();
	
	var ERR_ARGUMENT = 'Illegal argument to Viewport';
	
	var Viewport = function () {
	  /**
	   * @classdesc
	   * Manages coordinate system transformations for deck.gl.
	   *
	   * Note: The Viewport is immutable in the sense that it only has accessors.
	   * A new viewport instance should be created if any parameters have changed.
	   *
	   * @class
	   * @param {Object} opt - options
	   * @param {Boolean} mercator=true - Whether to use mercator projection
	   *
	   * @param {Number} opt.width=1 - Width of "viewport" or window
	   * @param {Number} opt.height=1 - Height of "viewport" or window
	   * @param {Array} opt.center=[0, 0] - Center of viewport
	   *   [longitude, latitude] or [x, y]
	   * @param {Number} opt.scale=1 - Either use scale or zoom
	   * @param {Number} opt.pitch=0 - Camera angle in degrees (0 is straight down)
	   * @param {Number} opt.bearing=0 - Map rotation in degrees (0 means north is up)
	   * @param {Number} opt.altitude= - Altitude of camera in screen units
	   *
	   * Web mercator projection short-hand parameters
	   * @param {Number} opt.latitude - Center of viewport on map (alternative to opt.center)
	   * @param {Number} opt.longitude - Center of viewport on map (alternative to opt.center)
	   * @param {Number} opt.zoom - Scale = Math.pow(2,zoom) on map (alternative to opt.scale)
	   */
	  /* eslint-disable complexity */
	  function Viewport() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$width = _ref.width,
	        width = _ref$width === undefined ? 1 : _ref$width,
	        _ref$height = _ref.height,
	        height = _ref$height === undefined ? 1 : _ref$height,
	        _ref$viewMatrix = _ref.viewMatrix,
	        viewMatrix = _ref$viewMatrix === undefined ? IDENTITY : _ref$viewMatrix,
	        _ref$projectionMatrix = _ref.projectionMatrix,
	        projectionMatrix = _ref$projectionMatrix === undefined ? IDENTITY : _ref$projectionMatrix;
	
	    _classCallCheck(this, Viewport);
	
	    // Silently allow apps to send in 0,0
	    this.width = width || 1;
	    this.height = height || 1;
	    this.scale = 1;
	
	    this.viewMatrix = viewMatrix;
	    this.projectionMatrix = projectionMatrix;
	
	    // Note: As usual, matrix operations should be applied in "reverse" order
	    // since vectors will be multiplied in from the right during transformation
	    var vpm = createMat4();
	    _glMatrix.mat4.multiply(vpm, vpm, this.projectionMatrix);
	    _glMatrix.mat4.multiply(vpm, vpm, this.viewMatrix);
	    this.viewProjectionMatrix = vpm;
	
	    // Calculate matrices and scales needed for projection
	    /**
	     * Builds matrices that converts preprojected lngLats to screen pixels
	     * and vice versa.
	     * Note: Currently returns bottom-left coordinates!
	     * Note: Starts with the GL projection matrix and adds steps to the
	     *       scale and translate that matrix onto the window.
	     * Note: WebGL controls clip space to screen projection with gl.viewport
	     *       and does not need this step.
	     */
	    var m = createMat4();
	
	    // matrix for conversion from location to screen coordinates
	    _glMatrix.mat4.scale(m, m, [this.width / 2, -this.height / 2, 1]);
	    _glMatrix.mat4.translate(m, m, [1, -1, 0]);
	    _glMatrix.mat4.multiply(m, m, this.viewProjectionMatrix);
	
	    var mInverse = _glMatrix.mat4.invert(createMat4(), m);
	    if (!mInverse) {
	      throw new Error('Pixel project matrix not invertible');
	    }
	
	    this.pixelProjectionMatrix = m;
	    this.pixelUnprojectionMatrix = mInverse;
	
	    this.equals = this.equals.bind(this);
	    this.project = this.project.bind(this);
	    this.unproject = this.unproject.bind(this);
	    this.projectFlat = this.projectFlat.bind(this);
	    this.unprojectFlat = this.unprojectFlat.bind(this);
	    this.getMatrices = this.getMatrices.bind(this);
	  }
	  /* eslint-enable complexity */
	
	  // Two viewports are equal if width and height are identical, and if
	  // their view and projection matrices are (approximately) equal.
	
	
	  _createClass(Viewport, [{
	    key: 'equals',
	    value: function equals(viewport) {
	      if (!(viewport instanceof Viewport)) {
	        return false;
	      }
	
	      return viewport.width === this.width && viewport.height === this.height && _glMatrix.mat4.equals(viewport.projectionMatrix, this.projectionMatrix) && _glMatrix.mat4.equals(viewport.viewMatrix, this.viewMatrix);
	    }
	
	    /**
	     * Projects xyz (possibly latitude and longitude) to pixel coordinates in window
	     * using viewport projection parameters
	     * - [longitude, latitude] to [x, y]
	     * - [longitude, latitude, Z] => [x, y, z]
	     * Note: By default, returns top-left coordinates for canvas/SVG type render
	     *
	     * @param {Array} lngLatZ - [lng, lat] or [lng, lat, Z]
	     * @param {Object} opts - options
	     * @param {Object} opts.topLeft=true - Whether projected coords are top left
	     * @return {Array} - [x, y] or [x, y, z] in top left coords
	     */
	
	  }, {
	    key: 'project',
	    value: function project(xyz) {
	      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref2$topLeft = _ref2.topLeft,
	          topLeft = _ref2$topLeft === undefined ? false : _ref2$topLeft;
	
	      var _xyz = _slicedToArray(xyz, 3),
	          x0 = _xyz[0],
	          y0 = _xyz[1],
	          _xyz$ = _xyz[2],
	          z0 = _xyz$ === undefined ? 0 : _xyz$;
	
	      (0, _assert2.default)(Number.isFinite(x0) && Number.isFinite(y0) && Number.isFinite(z0), ERR_ARGUMENT);
	
	      var _projectFlat2 = this.projectFlat([x0, y0]),
	          _projectFlat3 = _slicedToArray(_projectFlat2, 2),
	          X = _projectFlat3[0],
	          Y = _projectFlat3[1];
	
	      var v = this.transformVector(this.pixelProjectionMatrix, [X, Y, z0, 1]);
	
	      var _v = _slicedToArray(v, 2),
	          x = _v[0],
	          y = _v[1];
	
	      var y2 = topLeft ? this.height - y : y;
	      return xyz.length === 2 ? [x, y2] : [x, y2, 0];
	    }
	
	    /**
	     * Unproject pixel coordinates on screen onto world coordinates,
	     * (possibly [lon, lat]) on map.
	     * - [x, y] => [lng, lat]
	     * - [x, y, z] => [lng, lat, Z]
	     * @param {Array} xyz -
	     * @return {Array} - [lng, lat, Z] or [X, Y, Z]
	     */
	
	  }, {
	    key: 'unproject',
	    value: function unproject(xyz) {
	      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref3$topLeft = _ref3.topLeft,
	          topLeft = _ref3$topLeft === undefined ? false : _ref3$topLeft;
	
	      var _xyz2 = _slicedToArray(xyz, 3),
	          x = _xyz2[0],
	          y = _xyz2[1],
	          _xyz2$ = _xyz2[2],
	          targetZ = _xyz2$ === undefined ? 0 : _xyz2$;
	
	      var y2 = topLeft ? this.height - y : y;
	
	      // since we don't know the correct projected z value for the point,
	      // unproject two points to get a line and then find the point on that line with z=0
	      var coord0 = this.transformVector(this.pixelUnprojectionMatrix, [x, y2, 0, 1]);
	      var coord1 = this.transformVector(this.pixelUnprojectionMatrix, [x, y2, 1, 1]);
	
	      var z0 = coord0[2];
	      var z1 = coord1[2];
	
	      var t = z0 === z1 ? 0 : (targetZ - z0) / (z1 - z0);
	      var v = _glMatrix.vec2.lerp([], coord0, coord1, t);
	
	      var vUnprojected = this.unprojectFlat(v);
	      return xyz.length === 2 ? vUnprojected : [vUnprojected[0], vUnprojected[1], 0];
	    }
	
	    // TODO - replace with math.gl
	
	  }, {
	    key: 'transformVector',
	    value: function transformVector(matrix, vector) {
	      var result = _glMatrix.vec4.transformMat4([0, 0, 0, 0], vector, matrix);
	      var scale = 1 / result[3];
	      _glMatrix.vec4.multiply(result, result, [scale, scale, scale, scale]);
	      return result;
	    }
	
	    // NON_LINEAR PROJECTION HOOKS
	    // Used for web meractor projection
	
	    /**
	     * Project [lng,lat] on sphere onto [x,y] on 512*512 Mercator Zoom 0 tile.
	     * Performs the nonlinear part of the web mercator projection.
	     * Remaining projection is done with 4x4 matrices which also handles
	     * perspective.
	     * @param {Array} lngLat - [lng, lat] coordinates
	     *   Specifies a point on the sphere to project onto the map.
	     * @return {Array} [x,y] coordinates.
	     */
	
	  }, {
	    key: 'projectFlat',
	    value: function projectFlat(_ref4) {
	      var _ref5 = _slicedToArray(_ref4, 2),
	          x = _ref5[0],
	          y = _ref5[1];
	
	      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scale;
	
	      return this._projectFlat.apply(this, arguments);
	    }
	
	    /**
	     * Unproject world point [x,y] on map onto {lat, lon} on sphere
	     * @param {object|Vector} xy - object with {x,y} members
	     *  representing point on projected map plane
	     * @return {GeoCoordinates} - object with {lat,lon} of point on sphere.
	     *   Has toArray method if you need a GeoJSON Array.
	     *   Per cartographic tradition, lat and lon are specified as degrees.
	     */
	
	  }, {
	    key: 'unprojectFlat',
	    value: function unprojectFlat(xyz) {
	      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scale;
	
	      return this._unprojectFlat.apply(this, arguments);
	    }
	  }, {
	    key: 'getMatrices',
	    value: function getMatrices() {
	      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref6$modelMatrix = _ref6.modelMatrix,
	          modelMatrix = _ref6$modelMatrix === undefined ? null : _ref6$modelMatrix;
	
	      var modelViewProjectionMatrix = this.viewProjectionMatrix;
	      var pixelProjectionMatrix = this.pixelProjectionMatrix;
	      var pixelUnprojectionMatrix = this.pixelUnprojectionMatrix;
	
	      if (modelMatrix) {
	        modelViewProjectionMatrix = _glMatrix.mat4.multiply([], this.viewProjectionMatrix, modelMatrix);
	        pixelProjectionMatrix = _glMatrix.mat4.multiply([], this.pixelProjectionMatrix, modelMatrix);
	        pixelUnprojectionMatrix = _glMatrix.mat4.invert([], pixelProjectionMatrix);
	      }
	
	      var matrices = Object.assign({
	        modelViewProjectionMatrix: modelViewProjectionMatrix,
	        viewProjectionMatrix: this.viewProjectionMatrix,
	        viewMatrix: this.viewMatrix,
	        projectionMatrix: this.projectionMatrix,
	
	        // project/unproject between pixels and world
	        pixelProjectionMatrix: pixelProjectionMatrix,
	        pixelUnprojectionMatrix: pixelUnprojectionMatrix,
	
	        width: this.width,
	        height: this.height,
	        scale: this.scale
	      },
	
	      // Subclass can add additional params
	      // TODO - Fragile: better to make base Viewport class aware of all params
	      this._getParams());
	
	      return matrices;
	    }
	  }, {
	    key: 'getDistanceScales',
	    value: function getDistanceScales() {
	      return {
	        pixelsPerMeter: [1, 1, 1],
	        metersPerPixel: [1, 1, 1],
	        pixelsPerDegree: [1, 1, 1],
	        degreesPerPixel: [1, 1, 1]
	      };
	    }
	
	    // INTERNAL METHODS
	
	    // Can be subclassed to add additional fields to `getMatrices`
	
	  }, {
	    key: '_getParams',
	    value: function _getParams() {
	      return {};
	    }
	  }, {
	    key: '_projectFlat',
	    value: function _projectFlat(xyz) {
	      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scale;
	
	      return xyz;
	    }
	  }, {
	    key: '_unprojectFlat',
	    value: function _unprojectFlat(xyz) {
	      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scale;
	
	      return xyz;
	    }
	  }]);
	
	  return Viewport;
	}();
	
	// Helper, avoids low-precision 32 bit matrices from gl-matrix mat4.create()
	
	
	exports.default = Viewport;
	function createMat4() {
	  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(433);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(194),
	    createBaseEach = __webpack_require__(944);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(93),
	    isIterateeCall = __webpack_require__(202);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 153 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 154 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 155 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(900),
	    isObjectLike = __webpack_require__(70);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(48),
	    stubFalse = __webpack_require__(1028);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(371)(module)))

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(274),
	    createAssigner = __webpack_require__(152);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(453),
	    isObject = __webpack_require__(44);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(895),
	    baseRest = __webpack_require__(93),
	    isArrayLikeObject = __webpack_require__(284);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BufferLayout = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BufferLayout =
	/**
	 * @classdesc
	 * Store characteristics of a data layout
	 * This data can be used when updating vertex attributes with
	 * the associated buffer, freeing the application from keeping
	 * track of this metadata.
	 *
	 * @class
	 * @param {GLuint} size - number of values per element (1-4)
	 * @param {GLuint} type - type of values (e.g. gl.FLOAT)
	 * @param {GLbool} normalized=false - normalize integers to [-1,1] or [0,1]
	 * @param {GLuint} integer=false - WebGL2 only, int-to-float conversion
	 * @param {GLuint} stride=0 - supports strided arrays
	 * @param {GLuint} offset=0 - supports strided arrays
	 */
	exports.BufferLayout = function BufferLayout() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      type = _ref.type,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 1 : _ref$size,
	      _ref$offset = _ref.offset,
	      offset = _ref$offset === undefined ? 0 : _ref$offset,
	      _ref$stride = _ref.stride,
	      stride = _ref$stride === undefined ? 0 : _ref$stride,
	      _ref$normalized = _ref.normalized,
	      normalized = _ref$normalized === undefined ? false : _ref$normalized,
	      _ref$integer = _ref.integer,
	      integer = _ref$integer === undefined ? false : _ref$integer,
	      _ref$instanced = _ref.instanced,
	      instanced = _ref$instanced === undefined ? 0 : _ref$instanced;
	
	  _classCallCheck(this, BufferLayout);
	
	  this.type = type;
	  this.size = size;
	  this.offset = offset;
	  this.stride = stride;
	  this.normalized = normalized;
	  this.integer = integer;
	  this.instanced = instanced;
	};
	
	// Encapsulates a WebGLBuffer object
	
	var Buffer = function () {
	  _createClass(Buffer, null, [{
	    key: 'makeFrom',
	
	
	    /**
	     * Returns a Buffer wrapped WebGLBuffer from a variety of inputs.
	     * Allows other functions to transparently accept raw WebGLBuffers etc
	     * and manipulate them using the methods in the `Buffer` class.
	     * Checks for ".handle" (allows use of stack.gl's gl-buffer)
	     *
	     * @param {WebGLRenderingContext} gl - if a new buffer needs to be initialized
	     * @param {*} object - candidate that will be coerced to a buffer
	     * @returns {Buffer} - Buffer object that wraps the buffer parameter
	     */
	    value: function makeFrom(gl) {
	      var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return object instanceof Buffer ? object :
	      // Use .handle (e.g from stack.gl's gl-buffer), else use buffer directly
	      new Buffer(gl).setData({ handle: object.handle || object });
	    }
	
	    /*
	     * @classdesc
	     * Can be used to store vertex data, pixel data retrieved from images
	     * or the framebuffer, and a variety of other things.
	     *
	     * Mainly used for uploading VertexAttributes to GPU
	     * Setting data on a buffers (arrays) uploads it to the GPU.
	     *
	     * Holds an attribute name as a convenience
	     * setData - Initializes size of buffer and sets
	     *
	     * @param {WebGLRenderingContext} gl - gl context
	     * @param {string} opt.id - id for debugging
	     */
	
	  }]);
	
	  function Buffer() {
	    var gl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        id = _ref2.id,
	        handle = _ref2.handle;
	
	    _classCallCheck(this, Buffer);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	
	    handle = handle || gl.createBuffer();
	    if (!(handle instanceof _webgl.WebGLBuffer)) {
	      throw new Error('Failed to create WebGLBuffer');
	    }
	
	    this.gl = gl;
	    this.handle = handle;
	    this.id = id;
	    this.bytes = undefined;
	    this.data = null;
	    this.target = _webgl.GL.ARRAY_BUFFER;
	    this.layout = null;
	
	    this.userData = {};
	    Object.seal(this);
	  }
	
	  _createClass(Buffer, [{
	    key: 'delete',
	    value: function _delete() {
	      var gl = this.gl;
	
	      if (this.handle) {
	        gl.deleteBuffer(this.handle);
	        this.handle = null;
	      }
	      return this;
	    }
	
	    /**
	     * Creates and initializes the buffer object's data store.
	     *
	     * @param {ArrayBufferView} opt.data - contents
	     * @param {GLsizeiptr} opt.bytes - the size of the buffer object's data store.
	     * @param {GLenum} opt.usage=gl.STATIC_DRAW - Allocation hint for GPU driver
	     *
	     * Characteristics of stored data, hints for vertex attribute
	     *
	     * @param {GLenum} opt.dataType=gl.FLOAT - type of data stored in buffer
	     * @param {GLuint} opt.size=1 - number of values per vertex
	     * @returns {Buffer} Returns itself for chaining.
	     */
	
	  }, {
	    key: 'setData',
	    value: function setData() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          data = _ref3.data,
	          bytes = _ref3.bytes,
	          _ref3$target = _ref3.target,
	          target = _ref3$target === undefined ? _webgl.GL.ARRAY_BUFFER : _ref3$target,
	          _ref3$usage = _ref3.usage,
	          usage = _ref3$usage === undefined ? _webgl.GL.STATIC_DRAW : _ref3$usage,
	          layout = _ref3.layout,
	          type = _ref3.type,
	          _ref3$size = _ref3.size,
	          size = _ref3$size === undefined ? 1 : _ref3$size,
	          _ref3$offset = _ref3.offset,
	          offset = _ref3$offset === undefined ? 0 : _ref3$offset,
	          _ref3$stride = _ref3.stride,
	          stride = _ref3$stride === undefined ? 0 : _ref3$stride,
	          _ref3$normalized = _ref3.normalized,
	          normalized = _ref3$normalized === undefined ? false : _ref3$normalized,
	          _ref3$integer = _ref3.integer,
	          integer = _ref3$integer === undefined ? false : _ref3$integer,
	          _ref3$instanced = _ref3.instanced,
	          instanced = _ref3$instanced === undefined ? 0 : _ref3$instanced;
	
	      var gl = this.gl;
	
	      (0, _assert2.default)(data || bytes >= 0, 'Buffer.setData needs data or bytes');
	      type = type || (0, _webgl.glTypeFromArray)(data);
	
	      if (data) {
	        (0, _webglChecks.assertArrayTypeMatch)(data, type, 'in Buffer.setData');
	      }
	
	      this.bytes = bytes;
	      this.data = data;
	      this.target = target;
	      this.layout = layout || new BufferLayout({
	        type: type,
	        size: size,
	        offset: offset,
	        stride: stride,
	        normalized: normalized,
	        integer: integer,
	        instanced: instanced
	      });
	
	      // Note: When we are just creating and/or filling the buffer with data,
	      // the target we use doesn't technically matter, so use ARRAY_BUFFER
	      // https://www.opengl.org/wiki/Buffer_Object
	      this.bind({ target: target });
	      gl.bufferData(target, data || bytes, usage);
	      this.unbind({ target: target });
	
	      return this;
	    }
	
	    /**
	     * Updates a subset of a buffer object's data store.
	     * @param {ArrayBufferView} opt.data - contents
	     * @returns {Buffer} Returns itself for chaining.
	     */
	
	  }, {
	    key: 'subData',
	    value: function subData() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          data = _ref4.data,
	          _ref4$offset = _ref4.offset,
	          offset = _ref4$offset === undefined ? 0 : _ref4$offset;
	
	      var gl = this.gl;
	
	      (0, _assert2.default)(data, 'Buffer.updateData needs data');
	
	      // Note: When we are just creating and/or filling the buffer with data,
	      // the target we use doesn't technically matter, so use ARRAY_BUFFER
	      // https://www.opengl.org/wiki/Buffer_Object
	      this.bind({ target: _webgl.GL.ARRAY_BUFFER });
	      gl.bufferSubData(_webgl.GL.ARRAY_BUFFER, offset, data);
	      this.unbind({ target: _webgl.GL.ARRAY_BUFFER });
	
	      return this;
	    }
	
	    /**
	     * Binds a buffer to a given binding point (target).
	     *
	     * @param {Glenum} target - target for the bind operation.
	     *  Possible values: gl.TRANSFORM_FEEDBACK_BUFFER and gl.UNIFORM_BUFFER
	     * @param {GLuint} index - the index of the target.
	     * @returns {Buffer} - Returns itself for chaining.
	     */
	
	  }, {
	    key: 'bind',
	    value: function bind() {
	      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref5$target = _ref5.target,
	          target = _ref5$target === undefined ? this.target : _ref5$target;
	
	      this.gl.bindBuffer(target, this.handle);
	      return this;
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind() {
	      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref6$target = _ref6.target,
	          target = _ref6$target === undefined ? this.target : _ref6$target;
	
	      // this.gl.bindBuffer(target, null);
	      return this;
	    }
	
	    /**
	     * Note: WEBGL2
	     * Binds a buffer to a given binding point (target) at a given index.
	     *
	     * @param {Glenum} target - target for the bind operation.
	     *  Possible values: gl.TRANSFORM_FEEDBACK_BUFFER and gl.UNIFORM_BUFFER
	     * @param {GLuint} index - the index of the target.
	     * @returns {Buffer} - Returns itself for chaining.
	     */
	
	  }, {
	    key: 'bindBase',
	    value: function bindBase() {
	      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref7$target = _ref7.target,
	          target = _ref7$target === undefined ? this.target : _ref7$target,
	          index = _ref7.index;
	
	      (0, _webglChecks.assertWebGL2Context)(this.gl);
	      this.gl.bindBufferBase(target, index, this.handle);
	      return this;
	    }
	  }, {
	    key: 'unbindBase',
	    value: function unbindBase() {
	      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref8$target = _ref8.target,
	          target = _ref8$target === undefined ? this.target : _ref8$target,
	          index = _ref8.index;
	
	      (0, _webglChecks.assertWebGL2Context)(this.gl);
	      this.gl.bindBufferBase(target, index, null);
	      return this;
	    }
	
	    /**
	     * Note: WEBGL2
	     * binds a range of a given WebGLBuffer to a given binding point (target)
	     * at a given index.
	     *
	     * @param {Glenum} target - target for the bind operation.
	     *  Possible values: gl.TRANSFORM_FEEDBACK_BUFFER and gl.UNIFORM_BUFFER
	     * @param {GLuint} index - the index of the target.
	     * @returns {Buffer} - Returns itself for chaining.
	     */
	
	  }, {
	    key: 'bindRange',
	    value: function bindRange() {
	      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref9$target = _ref9.target,
	          target = _ref9$target === undefined ? this.target : _ref9$target,
	          index = _ref9.index,
	          _ref9$offset = _ref9.offset,
	          offset = _ref9$offset === undefined ? 0 : _ref9$offset,
	          size = _ref9.size;
	
	      (0, _webglChecks.assertWebGL2Context)(this.gl);
	      this.gl.bindBufferRange(target, index, this.handle, offset, size);
	      return this;
	    }
	  }, {
	    key: 'unbindRange',
	    value: function unbindRange() {
	      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref10$target = _ref10.target,
	          target = _ref10$target === undefined ? this.target : _ref10$target,
	          index = _ref10.index;
	
	      (0, _webglChecks.assertWebGL2Context)(this.gl);
	      this.gl.bindBufferBase(target, index, null);
	      return this;
	    }
	  }]);
	
	  return Buffer;
	}();
	
	exports.default = Buffer;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GL = undefined;
	exports.glGet = glGet;
	exports.glKey = glKey;
	
	var _glConstants = __webpack_require__(875);
	
	var _glConstants2 = _interopRequireDefault(_glConstants);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// WEBGL BUILT-IN TYPES
	exports.GL = _glConstants2.default;
	exports.default = _glConstants2.default;
	
	// Resolve a WebGL enumeration name (returns itself if already a number)
	
	function glGet(name) {
	  // assertWebGLContext(gl);
	  var value = name;
	  if (typeof name === 'string') {
	    value = _glConstants2.default[name];
	    (0, _assert2.default)(value !== undefined, 'Accessing GL.' + name);
	  }
	  return value;
	}
	
	function glKey(value) {
	  for (var key in _glConstants2.default) {
	    if (_glConstants2.default[key] === value) {
	      return 'GL.' + key;
	    }
	  }
	  return String(value);
	}
	
	// Extract constants from WebGL prototype
	// function getWebGLConstants() {
	//   const constants = {};
	//   const WebGLContext =
	//     glob.WebGL2RenderingContext || WebGLRenderingContext;
	//   for (const key in WebGLContext.prototype) {
	//     if (typeof WebGLContext[key] !== 'function') {
	//       constants[key] = WebGLContext[key];
	//     }
	//   }
	//   Object.freeze(constants);
	//   return constants;
	// }
	
	// const GL = getWebGLConstants();
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy93ZWJnbC93ZWJnbC1jb25zdGFudHMuanMiXSwibmFtZXMiOlsiZ2xHZXQiLCJnbEtleSIsIkdMIiwibmFtZSIsInZhbHVlIiwidW5kZWZpbmVkIiwia2V5IiwiU3RyaW5nIl0sIm1hcHBpbmdzIjoiOzs7Ozs7UUFRZ0JBLEssR0FBQUEsSztRQVVBQyxLLEdBQUFBLEs7O0FBakJoQjs7OztBQUNBOzs7Ozs7QUFGQTtRQUlRQyxFOzs7QUFHUjs7QUFDTyxTQUFTRixLQUFULENBQWVHLElBQWYsRUFBcUI7QUFDMUI7QUFDQSxNQUFJQyxRQUFRRCxJQUFaO0FBQ0EsTUFBSSxPQUFPQSxJQUFQLEtBQWdCLFFBQXBCLEVBQThCO0FBQzVCQyxZQUFRLHNCQUFHRCxJQUFILENBQVI7QUFDQSwwQkFBT0MsVUFBVUMsU0FBakIsb0JBQTRDRixJQUE1QztBQUNEO0FBQ0QsU0FBT0MsS0FBUDtBQUNEOztBQUVNLFNBQVNILEtBQVQsQ0FBZUcsS0FBZixFQUFzQjtBQUMzQixPQUFLLElBQU1FLEdBQVgsMkJBQXNCO0FBQ3BCLFFBQUksc0JBQUdBLEdBQUgsTUFBWUYsS0FBaEIsRUFBdUI7QUFDckIscUJBQWFFLEdBQWI7QUFDRDtBQUNGO0FBQ0QsU0FBT0MsT0FBT0gsS0FBUCxDQUFQO0FBQ0Q7O0FBRUQ7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUEiLCJmaWxlIjoid2ViZ2wtY29uc3RhbnRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gV0VCR0wgQlVJTFQtSU4gVFlQRVNcbmltcG9ydCBHTCBmcm9tICdnbC1jb25zdGFudHMnO1xuaW1wb3J0IGFzc2VydCBmcm9tICdhc3NlcnQnO1xuXG5leHBvcnQge0dMfTtcbmV4cG9ydCBkZWZhdWx0IEdMO1xuXG4vLyBSZXNvbHZlIGEgV2ViR0wgZW51bWVyYXRpb24gbmFtZSAocmV0dXJucyBpdHNlbGYgaWYgYWxyZWFkeSBhIG51bWJlcilcbmV4cG9ydCBmdW5jdGlvbiBnbEdldChuYW1lKSB7XG4gIC8vIGFzc2VydFdlYkdMQ29udGV4dChnbCk7XG4gIGxldCB2YWx1ZSA9IG5hbWU7XG4gIGlmICh0eXBlb2YgbmFtZSA9PT0gJ3N0cmluZycpIHtcbiAgICB2YWx1ZSA9IEdMW25hbWVdO1xuICAgIGFzc2VydCh2YWx1ZSAhPT0gdW5kZWZpbmVkLCBgQWNjZXNzaW5nIEdMLiR7bmFtZX1gKTtcbiAgfVxuICByZXR1cm4gdmFsdWU7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBnbEtleSh2YWx1ZSkge1xuICBmb3IgKGNvbnN0IGtleSBpbiBHTCkge1xuICAgIGlmIChHTFtrZXldID09PSB2YWx1ZSkge1xuICAgICAgcmV0dXJuIGBHTC4ke2tleX1gO1xuICAgIH1cbiAgfVxuICByZXR1cm4gU3RyaW5nKHZhbHVlKTtcbn1cblxuLy8gRXh0cmFjdCBjb25zdGFudHMgZnJvbSBXZWJHTCBwcm90b3R5cGVcbi8vIGZ1bmN0aW9uIGdldFdlYkdMQ29uc3RhbnRzKCkge1xuLy8gICBjb25zdCBjb25zdGFudHMgPSB7fTtcbi8vICAgY29uc3QgV2ViR0xDb250ZXh0ID1cbi8vICAgICBnbG9iLldlYkdMMlJlbmRlcmluZ0NvbnRleHQgfHwgV2ViR0xSZW5kZXJpbmdDb250ZXh0O1xuLy8gICBmb3IgKGNvbnN0IGtleSBpbiBXZWJHTENvbnRleHQucHJvdG90eXBlKSB7XG4vLyAgICAgaWYgKHR5cGVvZiBXZWJHTENvbnRleHRba2V5XSAhPT0gJ2Z1bmN0aW9uJykge1xuLy8gICAgICAgY29uc3RhbnRzW2tleV0gPSBXZWJHTENvbnRleHRba2V5XTtcbi8vICAgICB9XG4vLyAgIH1cbi8vICAgT2JqZWN0LmZyZWV6ZShjb25zdGFudHMpO1xuLy8gICByZXR1cm4gY29uc3RhbnRzO1xuLy8gfVxuXG4vLyBjb25zdCBHTCA9IGdldFdlYkdMQ29uc3RhbnRzKCk7XG4iXX0=

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(25);
	
	var _d3Interpolate = __webpack_require__(1182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// credit to Tanner Linsey from this issue on react motion repository:
	// https://github.com/chenglou/react-motion/issues/153
	
	var enhancedSpring = function enhancedSpring(value, config) {
	    if (typeof value !== 'number') {
	        return {
	            value: value,
	            config: config,
	            interpolator: config && config.interpolator ? config.interpolator : _d3Interpolate.interpolate
	        };
	    }
	    return (0, _reactMotion.spring)(value, config);
	};
	
	var SmartMotion = function (_PureComponent) {
	    _inherits(SmartMotion, _PureComponent);
	
	    function SmartMotion() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SmartMotion);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.oldValues = {}, _this.newInters = {}, _this.currentStepValues = {}, _this.stepValues = {}, _this.stepInterpolators = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    SmartMotion.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            style = _props.style,
	            children = _props.children,
	            rest = _objectWithoutProperties(_props, ['style', 'children']);
	
	        var resolvedStyle = style(enhancedSpring);
	
	        for (var key in resolvedStyle) {
	            if (
	            // If key is a non-numeric interpolation
	            resolvedStyle[key] && resolvedStyle[key].interpolator) {
	                // Make sure the steps start at 0
	                this.currentStepValues[key] = this.currentStepValues[key] || 0;
	                if (
	                // And the value has changed
	                typeof this.newInters[key] === 'undefined' || resolvedStyle[key].value !== this.newInters[key].value) {
	                    // Save the new value
	                    this.newInters[key] = resolvedStyle[key];
	
	                    // Increment the stepInterValue for this key by 1
	                    this.stepValues[key] = this.currentStepValues[key] + 1;
	
	                    // Set up the new interpolator
	                    this.stepInterpolators[key] = this.newInters[key].interpolator(this.oldValues[key], this.newInters[key].value);
	                }
	                // Return the spring with the destination stepValue and spring config
	                resolvedStyle[key] = (0, _reactMotion.spring)(this.stepValues[key], this.newInters[key].config);
	                // console.log(resolvedStyle[key])
	            }
	        }
	
	        return _react2.default.createElement(
	            _reactMotion.Motion,
	            _extends({}, rest, { style: resolvedStyle }),
	            function (values) {
	                var newValues = {};
	                for (var _key2 in values) {
	                    if (_this2.stepValues[_key2]) {
	                        // Save the currentStepValue
	                        _this2.currentStepValues[_key2] = values[_key2];
	                        // Figure the percentage
	                        var percentage = _this2.currentStepValues[_key2] - _this2.stepValues[_key2] + 1;
	                        // Save the current value and replace the value in the interpolated object
	                        _this2.oldValues[_key2] = newValues[_key2] = _this2.stepInterpolators[_key2](percentage);
	                    }
	                }
	                return children(_extends({}, values, newValues));
	            }
	        );
	    };
	
	    return SmartMotion;
	}(_react.PureComponent);
	
	exports.default = SmartMotion;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEqual2 = __webpack_require__(31);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shouldUpdate = __webpack_require__(621);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _props = __webpack_require__(19);
	
	var _Axis = __webpack_require__(490);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var horizontalPositions = ['top', 'bottom'];
	var verticalPositions = ['left', 'right'];
	var positions = [].concat(horizontalPositions, verticalPositions);
	
	var Axes = function Axes(_ref) {
	    var xScale = _ref.xScale,
	        yScale = _ref.yScale,
	        width = _ref.width,
	        height = _ref.height,
	        top = _ref.top,
	        right = _ref.right,
	        bottom = _ref.bottom,
	        left = _ref.left,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    var axes = { top: top, right: right, bottom: bottom, left: left };
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        positions.map(function (position) {
	            var axis = axes[position];
	
	            if (!axis) return null;
	
	            var scale = horizontalPositions.includes(position) ? xScale : yScale;
	
	            return _react2.default.createElement(_Axis2.default, _extends({
	                theme: theme
	            }, axis, {
	                key: position,
	                width: width,
	                height: height,
	                position: position,
	                scale: scale,
	                animate: animate,
	                motionDamping: motionDamping,
	                motionStiffness: motionStiffness
	            }));
	        })
	    );
	};
	
	Axes.propTypes = _extends({
	    // generic
	    xScale: _propTypes2.default.func.isRequired,
	    yScale: _propTypes2.default.func.isRequired,
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	
	    // axes
	    top: _Axis.axisPropType,
	    right: _Axis.axisPropType,
	    bottom: _Axis.axisPropType,
	    left: _Axis.axisPropType,
	
	    // theming
	    theme: _propTypes2.default.object.isRequired
	
	}, _props.motionPropTypes);
	
	exports.default = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return props.xScale !== nextProps.xScale || props.yScale !== nextProps.yScale || props.width !== nextProps.width || props.height !== nextProps.height || props.theme !== nextProps.theme || props.animate !== nextProps.animate || props.motionDamping !== nextProps.motionDamping || props.motionStiffness !== nextProps.motionStiffness || !(0, _isEqual3.default)(props.top, nextProps.top) || !(0, _isEqual3.default)(props.right, nextProps.right) || !(0, _isEqual3.default)(props.bottom, nextProps.bottom) || !(0, _isEqual3.default)(props.left, nextProps.left);
	})(Axes);

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _defaults = __webpack_require__(167);
	
	var _GridLines = __webpack_require__(1074);
	
	var _GridLines2 = _interopRequireDefault(_GridLines);
	
	var _props = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var center = function center(scale) {
	    var offset = scale.bandwidth() / 2;
	    if (scale.round()) offset = Math.round(offset);
	
	    return function (d) {
	        return scale(d) + offset;
	    };
	};
	
	var Grid = function Grid(_ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        xScale = _ref.xScale,
	        yScale = _ref.yScale,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    var xLines = void 0;
	    if (xScale) {
	        var xValues = void 0;
	        if (xScale.ticks) {
	            xValues = xScale.ticks();
	        } else {
	            xValues = xScale.domain();
	        }
	
	        var xPosition = xScale.bandwidth ? center(xScale) : xScale;
	
	        xLines = xValues.map(function (v) {
	            return {
	                key: '' + v,
	                x1: xPosition(v),
	                x2: xPosition(v),
	                y2: height
	            };
	        });
	    }
	
	    var yLines = void 0;
	    if (yScale) {
	        var yValues = void 0;
	        if (yScale.ticks) {
	            yValues = yScale.ticks();
	        } else {
	            yValues = yScale.domain();
	        }
	
	        var yPosition = yScale.bandwidth ? center(yScale) : yScale;
	
	        yLines = yValues.map(function (v) {
	            return {
	                key: '' + v,
	                x2: width,
	                y1: yPosition(v),
	                y2: yPosition(v)
	            };
	        });
	    }
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        xLines && _react2.default.createElement(_GridLines2.default, {
	            type: 'x',
	            lines: xLines,
	            theme: theme,
	            animate: animate,
	            motionStiffness: motionStiffness,
	            motionDamping: motionDamping
	        }),
	        yLines && _react2.default.createElement(_GridLines2.default, {
	            type: 'y',
	            lines: yLines,
	            theme: theme,
	            animate: animate,
	            motionStiffness: motionStiffness,
	            motionDamping: motionDamping
	        })
	    );
	};
	
	Grid.propTypes = _extends({
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	
	    xScale: _propTypes2.default.func,
	    yScale: _propTypes2.default.func,
	
	    theme: _propTypes2.default.object.isRequired
	
	}, _props.motionPropTypes);
	
	Grid.defaultProps = {
	    // motion
	    animate: true,
	    motionStiffness: _defaults.defaultMotionStiffness,
	    motionDamping: _defaults.defaultMotionDamping
	};
	
	exports.default = (0, _pure2.default)(Grid);

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chip = function Chip(_ref) {
	    var size = _ref.size,
	        color = _ref.color,
	        style = _ref.style;
	    return _react2.default.createElement('span', { style: _extends({ display: 'block', width: size, height: size, background: color }, style) });
	};
	
	Chip.propTypes = {
	    size: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    style: _propTypes2.default.object.isRequired
	};
	
	Chip.defaultProps = {
	    size: 12,
	    style: {}
	};
	
	exports.default = (0, _pure2.default)(Chip);

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMargin = exports.defaultColorRange = exports.defaultCategoricalColors = exports.defaultMotionDamping = exports.defaultMotionStiffness = exports.defaultAnimate = undefined;
	
	var _theme = __webpack_require__(1157);
	
	Object.keys(_theme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _theme[key];
	    }
	  });
	});
	
	var _d3Scale = __webpack_require__(71);
	
	var _d3ScaleChromatic = __webpack_require__(253);
	
	var _colors = __webpack_require__(24);
	
	// motion
	var defaultAnimate = exports.defaultAnimate = true; /*
	                                                     * This file is part of the nivo project.
	                                                     *
	                                                     * Copyright 2016-present, Raphaël Benitte.
	                                                     *
	                                                     * For the full copyright and license information, please view the LICENSE
	                                                     * file that was distributed with this source code.
	                                                     */
	var defaultMotionStiffness = exports.defaultMotionStiffness = 90;
	var defaultMotionDamping = exports.defaultMotionDamping = 13;
	
	// colors
	var defaultCategoricalColors = exports.defaultCategoricalColors = _colors.nivoCategoricalColors;
	var defaultColorRange = exports.defaultColorRange = (0, _d3Scale.scaleOrdinal)(_d3ScaleChromatic.schemeSet3);
	
	// margin
	var defaultMargin = exports.defaultMargin = {
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	
	  // theming
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.bindDefs = exports.isMatchingDef = undefined;
	
	var _set2 = __webpack_require__(1026);
	
	var _set3 = _interopRequireDefault(_set2);
	
	var _get2 = __webpack_require__(126);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isEqual2 = __webpack_require__(31);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _pick2 = __webpack_require__(94);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _isPlainObject2 = __webpack_require__(103);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _defs = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var gradientKeys = Object.keys(_defs.gradientTypes);
	var patternKeys = Object.keys(_defs.patternTypes);
	
	/**
	 * Check a node matches given def predicate.
	 *
	 * @param {string|Function|Object} predicate
	 * @param {Object}                 node
	 * @param {string}                 [dataKey] - Optional path to access node data
	 * @returns {boolean}
	 */
	var isMatchingDef = exports.isMatchingDef = function isMatchingDef(predicate, node, dataKey) {
	    if (predicate === '*') {
	        return true;
	    } else if ((0, _isFunction3.default)(predicate)) {
	        return predicate(node);
	    } else if ((0, _isPlainObject3.default)(predicate)) {
	        var data = dataKey ? (0, _get3.default)(node, dataKey) : node;
	        return (0, _isEqual3.default)((0, _pick3.default)(data, Object.keys(predicate)), predicate);
	    }
	
	    return false;
	};
	
	/**
	 * Compute SVG defs.
	 *
	 * @param {Array.<Object>} defs               - Base SVG defs configs
	 * @param {Array.<Object>} nodes              - Data nodes to apply defs on
	 * @param {Array.<Object>} rules              - Rules used to conditionally apply defs on data nodes
	 * @param {string}         [dataKey]          - Path to node data, used for rule object query based predicate
	 * @param {string}         [colorKey='color'] - Node color path, required when inheritance is involved
	 * @param {string}         [targetKey='fill'] - Node target property to apply def ID on
	 * @returns {Array}
	 */
	var bindDefs = exports.bindDefs = function bindDefs(defs, nodes, rules) {
	    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        dataKey = _ref.dataKey,
	        _ref$colorKey = _ref.colorKey,
	        colorKey = _ref$colorKey === undefined ? 'color' : _ref$colorKey,
	        _ref$targetKey = _ref.targetKey,
	        targetKey = _ref$targetKey === undefined ? 'fill' : _ref$targetKey;
	
	    var boundDefs = [];
	
	    // will hold generated variation ids,
	    // to avoid generating multiple identical defs
	    var generatedIds = {};
	
	    if (defs.length && nodes.length) {
	        // first, add base defs
	        boundDefs = [].concat(defs);
	
	        nodes.forEach(function (node) {
	            var _loop = function _loop(i) {
	                var _rules$i = rules[i],
	                    id = _rules$i.id,
	                    match = _rules$i.match;
	
	                if (isMatchingDef(match, node, dataKey)) {
	                    var def = defs.find(function (_ref2) {
	                        var defId = _ref2.id;
	                        return defId === id;
	                    });
	                    if (def) {
	                        if (patternKeys.includes(def.type)) {
	                            if (def.background === 'inherit' || def.color === 'inherit') {
	                                var nodeColor = (0, _get3.default)(node, colorKey);
	                                var background = def.background;
	                                var color = def.color;
	
	                                var inheritedId = id;
	                                if (def.background === 'inherit') {
	                                    inheritedId = inheritedId + '.bg.' + nodeColor;
	                                    background = nodeColor;
	                                }
	                                if (def.color === 'inherit') {
	                                    inheritedId = inheritedId + '.fg.' + nodeColor;
	                                    color = nodeColor;
	                                }
	
	                                (0, _set3.default)(node, targetKey, 'url(#' + inheritedId + ')');
	                                if (!generatedIds[inheritedId]) {
	                                    boundDefs.push(_extends({}, def, {
	                                        id: inheritedId,
	                                        background: background,
	                                        color: color
	                                    }));
	                                    generatedIds[inheritedId] = 1;
	                                }
	                            } else {
	                                // do not generate new def as there's no inheritance involved
	                                (0, _set3.default)(node, targetKey, 'url(#' + id + ')');
	                            }
	                        } else if (gradientKeys.includes(def.type)) {
	                            var allColors = def.colors.map(function (_ref3) {
	                                var color = _ref3.color;
	                                return color;
	                            });
	
	                            if (allColors.includes('inherit')) {
	                                var _nodeColor = (0, _get3.default)(node, colorKey);
	
	                                var _inheritedId = id;
	                                var inheritedDef = _extends({}, def, {
	                                    colors: def.colors.map(function (colorStop, i) {
	                                        if (colorStop.color !== 'inherit') return colorStop;
	
	                                        _inheritedId = _inheritedId + '.' + i + '.' + _nodeColor;
	
	                                        return _extends({}, colorStop, {
	                                            color: colorStop.color === 'inherit' ? _nodeColor : colorStop.color
	                                        });
	                                    })
	                                });
	                                inheritedDef.id = _inheritedId;
	
	                                (0, _set3.default)(node, targetKey, 'url(#' + _inheritedId + ')');
	                                if (!generatedIds[_inheritedId]) {
	                                    boundDefs.push(inheritedDef);
	                                    generatedIds[_inheritedId] = 1;
	                                }
	                            } else {
	                                // do not generate new def as there's no inheritance involved
	                                (0, _set3.default)(node, targetKey, 'url(#' + id + ')');
	                            }
	                        }
	                    }
	
	                    // break loop on first match
	                    return 'break';
	                }
	            };
	
	            for (var i = 0; i < rules.length; i++) {
	                var _ret = _loop(i);
	
	                if (_ret === 'break') break;
	            }
	        });
	    }
	
	    return boundDefs;
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var EventPluginRegistry = __webpack_require__(318);
	var EventPluginUtils = __webpack_require__(319);
	var ReactErrorUtils = __webpack_require__(323);
	
	var accumulateInto = __webpack_require__(560);
	var forEachAccumulated = __webpack_require__(561);
	var invariant = __webpack_require__(4);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(169);
	var EventPluginUtils = __webpack_require__(319);
	
	var accumulateInto = __webpack_require__(560);
	var forEachAccumulated = __webpack_require__(561);
	var warning = __webpack_require__(8);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	var getEventTarget = __webpack_require__(328);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 174 */
173,
/* 175 */
173,
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cross
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cell = (_temp = _class = function (_Component) {
	  _inherits(Cell, _Component);
	
	  function Cell() {
	    _classCallCheck(this, Cell);
	
	    return _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).apply(this, arguments));
	  }
	
	  _createClass(Cell, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Cell;
	}(_react.Component), _class.displayName = 'Cell', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES), _temp);
	exports.default = Cell;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _CartesianUtils = __webpack_require__(239);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * ComposedDataDecorator is a wrapper component that calculates expensive,
	 * reusable data like ticks of an axis, stores it in state on this component,
	 * and passes it in as props to the wrapped component.
	 */
	exports.default = function (_ref) {
	  var getComposedData = _ref.getComposedData,
	      ChildComponent = _ref.ChildComponent;
	  return function (WrappedComponent) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_Component) {
	      _inherits(ComposedDataDecorator, _Component);
	
	      function ComposedDataDecorator() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ComposedDataDecorator);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ComposedDataDecorator.__proto__ || Object.getPrototypeOf(ComposedDataDecorator)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.calculateExpensiveState({ props: _this.props }), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      // static WrappedComponent = WrappedComponent;
	
	      _createClass(ComposedDataDecorator, [{
	        key: 'calculateExpensiveState',
	
	
	        /**
	         * @param {Object} props The props object to operate on
	         * @return {Object} returnObj
	         *  returnObj {Array} axisTicks Used by renderCursor and anything
	         *          else that needs the ticks of the axisTicks
	         *  returObj {Array} allComposedData An array or arrays.
	         *          Each top-level element is the composedData {points, baseLine, layout}
	         *          for a given child(graphcalItem) of the overall Chart
	         */
	        value: function calculateExpensiveState(_ref3) {
	          var props = _ref3.props;
	          var children = props.children,
	              graphicalItems = props.graphicalItems,
	              xAxisMap = props.xAxisMap,
	              yAxisMap = props.yAxisMap,
	              stackGroups = props.stackGroups,
	              layout = props.layout,
	              offset = props.offset,
	              barSize = props.barSize,
	              barGap = props.barGap,
	              barCategoryGap = props.barCategoryGap,
	              globalMaxBarSize = props.maxBarSize;
	
	          // Some charts pre-filter their items into the graphicalItems prop,
	          // others filter it in render of the children
	
	          var items = graphicalItems || (0, _ReactUtils.findAllByType)(children, ChildComponent);
	
	          var sizeList = (0, _CartesianUtils.getBarSizeList)({ barSize: barSize, stackGroups: stackGroups });
	
	          var axisTicks = void 0;
	          var allComposedData = [];
	          items.forEach(function (item) {
	            var _item$props = item.props,
	                xAxisId = _item$props.xAxisId,
	                yAxisId = _item$props.yAxisId,
	                dataKey = _item$props.dataKey,
	                childMaxBarSize = _item$props.maxBarSize;
	
	            var xAxis = void 0,
	                yAxis = void 0,
	                xTicks = void 0,
	                yTicks = void 0,
	                barPosition = void 0,
	                stackedData = void 0,
	                bandSize = void 0;
	
	            if (xAxisMap || yAxisMap) {
	
	              xAxis = xAxisMap[xAxisId];
	              yAxis = yAxisMap[yAxisId];
	
	              xTicks = (0, _CartesianUtils.getTicksOfAxis)(xAxis);
	              yTicks = (0, _CartesianUtils.getTicksOfAxis)(yAxis);
	
	              // axisTicks is more global - only need to set once
	              axisTicks = axisTicks || (layout === 'horizontal' ? xTicks : yTicks);
	
	              var numericAxisId = layout === 'horizontal' ? yAxisId : xAxisId;
	              var cateAxisId = layout === 'horizontal' ? xAxisId : yAxisId;
	              var cateAxis = layout === 'horizontal' ? xAxis : yAxis;
	              var cateTicks = layout === 'horizontal' ? xTicks : yTicks;
	
	              stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _CartesianUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	
	              bandSize = (0, _DataUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	              var maxBarSize = (0, _isNil3.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	              barPosition = (0, _CartesianUtils.getBarPosition)({
	                barGap: barGap, barCategoryGap: barCategoryGap, bandSize: bandSize, sizeList: sizeList[cateAxisId], maxBarSize: maxBarSize
	              });
	            }
	
	            var composedData = getComposedData && getComposedData({ props: props,
	              xAxis: xAxis, yAxis: yAxis, xTicks: xTicks, yTicks: yTicks, dataKey: dataKey, item: item, bandSize: bandSize, barPosition: barPosition, offset: offset, stackedData: stackedData
	            }) || {};
	            allComposedData.push(composedData);
	          });
	
	          return { axisTicks: axisTicks, allComposedData: allComposedData };
	        }
	        /*
	        * Update the state of the composedData if anything relevant changed
	        */
	        /* eslint-disable no-unused-vars */
	
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          var graphicalItems = nextProps.graphicalItems,
	              children = nextProps.children,
	              chartX = nextProps.chartX,
	              chartY = nextProps.chartY,
	              activeTooltipIndex = nextProps.activeTooltipIndex,
	              activeLabel = nextProps.activeLabel,
	              activeCoordinate = nextProps.activeCoordinate,
	              activePayload = nextProps.activePayload,
	              isTooltipActive = nextProps.isTooltipActive,
	              restNextProps = _objectWithoutProperties(nextProps, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);
	
	          var _props = this.props,
	              graphicalItemsOld = _props.graphicalItems,
	              childrenOld = _props.children,
	              chartXOld = _props.chartX,
	              chartYOld = _props.chartY,
	              aTIOld = _props.activeTooltipIndex,
	              aLOld = _props.activeLabel,
	              aCOld = _props.activeCoordinate,
	              aPOld = _props.activePayload,
	              iTAOld = _props.isTooltipActive,
	              restOldProps = _objectWithoutProperties(_props, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);
	
	          /* eslint-enable no-unused-vars */
	
	
	          if (!(0, _PureRender.shallowEqual)(graphicalItems, graphicalItemsOld) || !(0, _PureRender.shallowEqual)(children, childrenOld) || !(0, _PureRender.shallowEqual)(restNextProps, restOldProps)) {
	            this.setState(this.calculateExpensiveState({ props: nextProps }));
	          }
	        }
	        /*
	         * Ignore the state generated by calculateExpensiveState when determining
	         * whether to update
	         */
	
	      }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(_ref4, nextState) {
	          var graphicalItems = _ref4.graphicalItems,
	              restProps = _objectWithoutProperties(_ref4, ['graphicalItems']);
	
	          // props.graphicalItems is sometimes generated every time -
	          // check that specially as object equality is likely to fail
	          var _props2 = this.props,
	              graphicalItemsOld = _props2.graphicalItems,
	              restPropsOld = _objectWithoutProperties(_props2, ['graphicalItems']);
	
	          return !(0, _PureRender.shallowEqual)(graphicalItems, graphicalItemsOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(nextState, this.state);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state));
	        }
	      }]);
	
	      return ComposedDataDecorator;
	    }(_react.Component), _class.displayName = 'ComposedDataDecorator(' + (0, _ReactUtils.getDisplayName)(WrappedComponent) + ')', _class.propTypes = _extends({}, WrappedComponent.propTypes, {
	      chartX: _propTypes2.default.number,
	      chartY: _propTypes2.default.number,
	      data: _propTypes2.default.array
	    }), _class.defaultProps = WrappedComponent.defaultProps, _temp2;
	  };
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ReactUtils = __webpack_require__(9);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return value + 'px';
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	
	  return formatStrs.join('');
	}
	
	var getStyleString = exports.getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return '' + result + camelToMiddleLine(s) + ':' + autoCompleteStyle(s, style[s]) + ';';
	  }, '');
	};
	
	var getStringSize = exports.getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return { width: 0, height: 0 };
	  }
	
	  var str = '' + text;
	  var styleString = getStyleString(style);
	  var cacheKey = str + '-' + styleString;
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    }
	
	    measurementSpan.setAttribute('style', getStyleString(_extends({}, SPAN_STYLE, style)));
	    measurementSpan.textContent = str;
	
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = { width: rect.width, height: rect.height };
	
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return { width: 0, height: 0 };
	  }
	};
	
	var getOffset = exports.getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = { top: 0, left: 0 };
	
	  // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	var calculateChartCoordinate = exports.calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(620);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return (0, _setStatic2.default)('propTypes', propTypes);
	};
	
	exports.default = setPropTypes;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _createEagerFactory = __webpack_require__(119);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _setDisplayName = __webpack_require__(90);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(91);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _mapValues = __webpack_require__(622);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */
	
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var WithHandlers = function (_Component) {
	      _inherits(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	        this.cachedHandlers = {};
	      };
	
	      WithHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(_react.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.cachedHandlers = {};
	      this.handlers = (0, _mapValues2.default)(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
	        return function () {
	          var cachedHandler = _this2.cachedHandlers[handlerName];
	          if (cachedHandler) {
	            return cachedHandler.apply(undefined, arguments);
	          }
	
	          var handler = createHandler(_this2.props);
	          _this2.cachedHandlers[handlerName] = handler;
	
	          if (false) {
	            console.error(
	            // eslint-disable-line no-console
	            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	          }
	
	          return handler.apply(undefined, arguments);
	        };
	      });
	    };
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	    return WithHandlers;
	  };
	};
	
	exports.default = withHandlers;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Bar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	Bar.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function Bar(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? 0 : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? 0 : _ref$y,
	      width = _ref.width,
	      height = _ref.height,
	      rx = _ref.rx,
	      ry = _ref.ry,
	      _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'steelblue' : _ref$fill,
	      fillOpacity = _ref.fillOpacity,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      strokeLinecap = _ref.strokeLinecap,
	      strokeLinejoin = _ref.strokeLinejoin,
	      strokeMiterlimit = _ref.strokeMiterlimit,
	      strokeOpacity = _ref.strokeOpacity,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y', 'width', 'height', 'rx', 'ry', 'fill', 'fillOpacity', 'stroke', 'strokeWidth', 'strokeDasharray', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity']);
	
	  return _react2.default.createElement('rect', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-bar', className),
	    x: x,
	    y: y,
	    width: width,
	    height: height,
	    rx: rx,
	    ry: ry,
	    fill: fill,
	    fillOpacity: fillOpacity,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    strokeLinecap: strokeLinecap,
	    strokeLinejoin: strokeLinejoin,
	    strokeMiterlimit: strokeMiterlimit,
	    strokeOpacity: strokeOpacity
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ },
/* 182 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 183 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Note: The numeric values here are matched by shader code in the
	// "project" and "project64" shader modules. Both places need to be
	// updated.
	
	// TODO: Maybe "POSITIONS" would be a better name?
	var COORDINATE_SYSTEM = exports.COORDINATE_SYSTEM = {
	  // Positions are interpreted as [lng, lat, elevation]
	  // lng lat are degrees, elevation is meters. distances as meters.
	  LNGLAT: 1.0,
	
	  // Positions are interpreted as lng lat offsets: [deltaLng, deltaLat, elevation]
	  // deltaLng, deltaLat are delta degrees, elevation is meters.
	  // distances as meters.
	  LNGLAT_OFFSETS: 3.0,
	
	  // Positions are interpreted as meter offsets, distances as meters
	  METER_OFFSETS: 2.0,
	  METERS: 2.0,
	
	  // Positions and distances are not transformed: [x, y, z] in unit coordinates
	  IDENTITY: 0.0
	};
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 184 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = earcut;
	
	function earcut(data, holeIndices, dim) {
	
	    dim = dim || 2;
	
	    var hasHoles = holeIndices && holeIndices.length,
	        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
	        outerNode = linkedList(data, 0, outerLen, dim, true),
	        triangles = [];
	
	    if (!outerNode) return triangles;
	
	    var minX, minY, maxX, maxY, x, y, size;
	
	    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
	
	    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	    if (data.length > 80 * dim) {
	        minX = maxX = data[0];
	        minY = maxY = data[1];
	
	        for (var i = dim; i < outerLen; i += dim) {
	            x = data[i];
	            y = data[i + 1];
	            if (x < minX) minX = x;
	            if (y < minY) minY = y;
	            if (x > maxX) maxX = x;
	            if (y > maxY) maxY = y;
	        }
	
	        // minX, minY and size are later used to transform coords into integers for z-order calculation
	        size = Math.max(maxX - minX, maxY - minY);
	    }
	
	    earcutLinked(outerNode, triangles, dim, minX, minY, size);
	
	    return triangles;
	}
	
	// create a circular doubly linked list from polygon points in the specified winding order
	function linkedList(data, start, end, dim, clockwise) {
	    var i, last;
	
	    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
	        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
	    } else {
	        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
	    }
	
	    if (last && equals(last, last.next)) {
	        removeNode(last);
	        last = last.next;
	    }
	
	    return last;
	}
	
	// eliminate colinear or duplicate points
	function filterPoints(start, end) {
	    if (!start) return start;
	    if (!end) end = start;
	
	    var p = start,
	        again;
	    do {
	        again = false;
	
	        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	            removeNode(p);
	            p = end = p.prev;
	            if (p === p.next) return null;
	            again = true;
	
	        } else {
	            p = p.next;
	        }
	    } while (again || p !== end);
	
	    return end;
	}
	
	// main ear slicing loop which triangulates a polygon (given as a linked list)
	function earcutLinked(ear, triangles, dim, minX, minY, size, pass) {
	    if (!ear) return;
	
	    // interlink polygon nodes in z-order
	    if (!pass && size) indexCurve(ear, minX, minY, size);
	
	    var stop = ear,
	        prev, next;
	
	    // iterate through ears, slicing them one by one
	    while (ear.prev !== ear.next) {
	        prev = ear.prev;
	        next = ear.next;
	
	        if (size ? isEarHashed(ear, minX, minY, size) : isEar(ear)) {
	            // cut off the triangle
	            triangles.push(prev.i / dim);
	            triangles.push(ear.i / dim);
	            triangles.push(next.i / dim);
	
	            removeNode(ear);
	
	            // skipping the next vertice leads to less sliver triangles
	            ear = next.next;
	            stop = next.next;
	
	            continue;
	        }
	
	        ear = next;
	
	        // if we looped through the whole remaining polygon and can't find any more ears
	        if (ear === stop) {
	            // try filtering points and slicing again
	            if (!pass) {
	                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, size, 1);
	
	            // if this didn't work, try curing all small self-intersections locally
	            } else if (pass === 1) {
	                ear = cureLocalIntersections(ear, triangles, dim);
	                earcutLinked(ear, triangles, dim, minX, minY, size, 2);
	
	            // as a last resort, try splitting the remaining polygon into two
	            } else if (pass === 2) {
	                splitEarcut(ear, triangles, dim, minX, minY, size);
	            }
	
	            break;
	        }
	    }
	}
	
	// check whether a polygon node forms a valid ear with adjacent nodes
	function isEar(ear) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // now make sure we don't have other points inside the potential ear
	    var p = ear.next.next;
	
	    while (p !== ear.prev) {
	        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.next;
	    }
	
	    return true;
	}
	
	function isEarHashed(ear, minX, minY, size) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // triangle bbox; min & max are calculated like this for speed
	    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
	        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
	        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
	        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);
	
	    // z-order range for the current triangle bbox;
	    var minZ = zOrder(minTX, minTY, minX, minY, size),
	        maxZ = zOrder(maxTX, maxTY, minX, minY, size);
	
	    // first look for points inside the triangle in increasing z-order
	    var p = ear.nextZ;
	
	    while (p && p.z <= maxZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.nextZ;
	    }
	
	    // then look for points in decreasing z-order
	    p = ear.prevZ;
	
	    while (p && p.z >= minZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	    }
	
	    return true;
	}
	
	// go through all polygon nodes and cure small local self-intersections
	function cureLocalIntersections(start, triangles, dim) {
	    var p = start;
	    do {
	        var a = p.prev,
	            b = p.next.next;
	
	        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
	
	            triangles.push(a.i / dim);
	            triangles.push(p.i / dim);
	            triangles.push(b.i / dim);
	
	            // remove two nodes involved
	            removeNode(p);
	            removeNode(p.next);
	
	            p = start = b;
	        }
	        p = p.next;
	    } while (p !== start);
	
	    return p;
	}
	
	// try splitting polygon into two and triangulate them independently
	function splitEarcut(start, triangles, dim, minX, minY, size) {
	    // look for a valid diagonal that divides the polygon into two
	    var a = start;
	    do {
	        var b = a.next.next;
	        while (b !== a.prev) {
	            if (a.i !== b.i && isValidDiagonal(a, b)) {
	                // split the polygon in two by the diagonal
	                var c = splitPolygon(a, b);
	
	                // filter colinear points around the cuts
	                a = filterPoints(a, a.next);
	                c = filterPoints(c, c.next);
	
	                // run earcut on each half
	                earcutLinked(a, triangles, dim, minX, minY, size);
	                earcutLinked(c, triangles, dim, minX, minY, size);
	                return;
	            }
	            b = b.next;
	        }
	        a = a.next;
	    } while (a !== start);
	}
	
	// link every hole into the outer loop, producing a single-ring polygon without holes
	function eliminateHoles(data, holeIndices, outerNode, dim) {
	    var queue = [],
	        i, len, start, end, list;
	
	    for (i = 0, len = holeIndices.length; i < len; i++) {
	        start = holeIndices[i] * dim;
	        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	        list = linkedList(data, start, end, dim, false);
	        if (list === list.next) list.steiner = true;
	        queue.push(getLeftmost(list));
	    }
	
	    queue.sort(compareX);
	
	    // process holes from left to right
	    for (i = 0; i < queue.length; i++) {
	        eliminateHole(queue[i], outerNode);
	        outerNode = filterPoints(outerNode, outerNode.next);
	    }
	
	    return outerNode;
	}
	
	function compareX(a, b) {
	    return a.x - b.x;
	}
	
	// find a bridge between vertices that connects hole with an outer ring and and link it
	function eliminateHole(hole, outerNode) {
	    outerNode = findHoleBridge(hole, outerNode);
	    if (outerNode) {
	        var b = splitPolygon(outerNode, hole);
	        filterPoints(b, b.next);
	    }
	}
	
	// David Eberly's algorithm for finding a bridge between hole and outer polygon
	function findHoleBridge(hole, outerNode) {
	    var p = outerNode,
	        hx = hole.x,
	        hy = hole.y,
	        qx = -Infinity,
	        m;
	
	    // find a segment intersected by a ray from the hole's leftmost point to the left;
	    // segment's endpoint with lesser x will be potential connection point
	    do {
	        if (hy <= p.y && hy >= p.next.y) {
	            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	            if (x <= hx && x > qx) {
	                qx = x;
	                if (x === hx) {
	                    if (hy === p.y) return p;
	                    if (hy === p.next.y) return p.next;
	                }
	                m = p.x < p.next.x ? p : p.next;
	            }
	        }
	        p = p.next;
	    } while (p !== outerNode);
	
	    if (!m) return null;
	
	    if (hx === qx) return m.prev; // hole touches outer segment; pick lower endpoint
	
	    // look for points inside the triangle of hole point, segment intersection and endpoint;
	    // if there are no points found, we have a valid connection;
	    // otherwise choose the point of the minimum angle with the ray as connection point
	
	    var stop = m,
	        mx = m.x,
	        my = m.y,
	        tanMin = Infinity,
	        tan;
	
	    p = m.next;
	
	    while (p !== stop) {
	        if (hx >= p.x && p.x >= mx &&
	                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
	
	            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
	
	            if ((tan < tanMin || (tan === tanMin && p.x > m.x)) && locallyInside(p, hole)) {
	                m = p;
	                tanMin = tan;
	            }
	        }
	
	        p = p.next;
	    }
	
	    return m;
	}
	
	// interlink polygon nodes in z-order
	function indexCurve(start, minX, minY, size) {
	    var p = start;
	    do {
	        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, size);
	        p.prevZ = p.prev;
	        p.nextZ = p.next;
	        p = p.next;
	    } while (p !== start);
	
	    p.prevZ.nextZ = null;
	    p.prevZ = null;
	
	    sortLinked(p);
	}
	
	// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	function sortLinked(list) {
	    var i, p, q, e, tail, numMerges, pSize, qSize,
	        inSize = 1;
	
	    do {
	        p = list;
	        list = null;
	        tail = null;
	        numMerges = 0;
	
	        while (p) {
	            numMerges++;
	            q = p;
	            pSize = 0;
	            for (i = 0; i < inSize; i++) {
	                pSize++;
	                q = q.nextZ;
	                if (!q) break;
	            }
	
	            qSize = inSize;
	
	            while (pSize > 0 || (qSize > 0 && q)) {
	
	                if (pSize === 0) {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                } else if (qSize === 0 || !q) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else if (p.z <= q.z) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                }
	
	                if (tail) tail.nextZ = e;
	                else list = e;
	
	                e.prevZ = tail;
	                tail = e;
	            }
	
	            p = q;
	        }
	
	        tail.nextZ = null;
	        inSize *= 2;
	
	    } while (numMerges > 1);
	
	    return list;
	}
	
	// z-order of a point given coords and size of the data bounding box
	function zOrder(x, y, minX, minY, size) {
	    // coords are transformed into non-negative 15-bit integer range
	    x = 32767 * (x - minX) / size;
	    y = 32767 * (y - minY) / size;
	
	    x = (x | (x << 8)) & 0x00FF00FF;
	    x = (x | (x << 4)) & 0x0F0F0F0F;
	    x = (x | (x << 2)) & 0x33333333;
	    x = (x | (x << 1)) & 0x55555555;
	
	    y = (y | (y << 8)) & 0x00FF00FF;
	    y = (y | (y << 4)) & 0x0F0F0F0F;
	    y = (y | (y << 2)) & 0x33333333;
	    y = (y | (y << 1)) & 0x55555555;
	
	    return x | (y << 1);
	}
	
	// find the leftmost node of a polygon ring
	function getLeftmost(start) {
	    var p = start,
	        leftmost = start;
	    do {
	        if (p.x < leftmost.x) leftmost = p;
	        p = p.next;
	    } while (p !== start);
	
	    return leftmost;
	}
	
	// check if a point lies within a convex triangle
	function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
	           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
	           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	}
	
	// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	function isValidDiagonal(a, b) {
	    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) &&
	           locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b);
	}
	
	// signed area of a triangle
	function area(p, q, r) {
	    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	}
	
	// check if two points are equal
	function equals(p1, p2) {
	    return p1.x === p2.x && p1.y === p2.y;
	}
	
	// check if two segments intersect
	function intersects(p1, q1, p2, q2) {
	    if ((equals(p1, q1) && equals(p2, q2)) ||
	        (equals(p1, q2) && equals(p2, q1))) return true;
	    return area(p1, q1, p2) > 0 !== area(p1, q1, q2) > 0 &&
	           area(p2, q2, p1) > 0 !== area(p2, q2, q1) > 0;
	}
	
	// check if a polygon diagonal intersects any polygon segments
	function intersectsPolygon(a, b) {
	    var p = a;
	    do {
	        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
	                intersects(p, p.next, a, b)) return true;
	        p = p.next;
	    } while (p !== a);
	
	    return false;
	}
	
	// check if a polygon diagonal is locally inside the polygon
	function locallyInside(a, b) {
	    return area(a.prev, a, a.next) < 0 ?
	        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
	        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	}
	
	// check if the middle point of a polygon diagonal is inside the polygon
	function middleInside(a, b) {
	    var p = a,
	        inside = false,
	        px = (a.x + b.x) / 2,
	        py = (a.y + b.y) / 2;
	    do {
	        if (((p.y > py) !== (p.next.y > py)) && (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
	            inside = !inside;
	        p = p.next;
	    } while (p !== a);
	
	    return inside;
	}
	
	// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	function splitPolygon(a, b) {
	    var a2 = new Node(a.i, a.x, a.y),
	        b2 = new Node(b.i, b.x, b.y),
	        an = a.next,
	        bp = b.prev;
	
	    a.next = b;
	    b.prev = a;
	
	    a2.next = an;
	    an.prev = a2;
	
	    b2.next = a2;
	    a2.prev = b2;
	
	    bp.next = b2;
	    b2.prev = bp;
	
	    return b2;
	}
	
	// create a node and optionally link it with previous one (in a circular doubly linked list)
	function insertNode(i, x, y, last) {
	    var p = new Node(i, x, y);
	
	    if (!last) {
	        p.prev = p;
	        p.next = p;
	
	    } else {
	        p.next = last.next;
	        p.prev = last;
	        last.next.prev = p;
	        last.next = p;
	    }
	    return p;
	}
	
	function removeNode(p) {
	    p.next.prev = p.prev;
	    p.prev.next = p.next;
	
	    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
	}
	
	function Node(i, x, y) {
	    // vertice index in coordinates array
	    this.i = i;
	
	    // vertex coordinates
	    this.x = x;
	    this.y = y;
	
	    // previous and next vertice nodes in a polygon ring
	    this.prev = null;
	    this.next = null;
	
	    // z-order curve value
	    this.z = null;
	
	    // previous and next nodes in z-order
	    this.prevZ = null;
	    this.nextZ = null;
	
	    // indicates whether this is a steiner point
	    this.steiner = false;
	}
	
	// return a percentage difference between the polygon area and its triangulation area;
	// used to verify correctness of triangulation
	earcut.deviation = function (data, holeIndices, dim, triangles) {
	    var hasHoles = holeIndices && holeIndices.length;
	    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
	
	    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	    if (hasHoles) {
	        for (var i = 0, len = holeIndices.length; i < len; i++) {
	            var start = holeIndices[i] * dim;
	            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	            polygonArea -= Math.abs(signedArea(data, start, end, dim));
	        }
	    }
	
	    var trianglesArea = 0;
	    for (i = 0; i < triangles.length; i += 3) {
	        var a = triangles[i] * dim;
	        var b = triangles[i + 1] * dim;
	        var c = triangles[i + 2] * dim;
	        trianglesArea += Math.abs(
	            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
	            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	    }
	
	    return polygonArea === 0 && trianglesArea === 0 ? 0 :
	        Math.abs((trianglesArea - polygonArea) / polygonArea);
	};
	
	function signedArea(data, start, end, dim) {
	    var sum = 0;
	    for (var i = start, j = end - dim; i < end; i += dim) {
	        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	        j = i;
	    }
	    return sum;
	}
	
	// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
	earcut.flatten = function (data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;
	
	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	    return result;
	};


/***/ },
/* 185 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(976),
	    listCacheDelete = __webpack_require__(977),
	    listCacheGet = __webpack_require__(978),
	    listCacheHas = __webpack_require__(979),
	    listCacheSet = __webpack_require__(980);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(267),
	    setCacheAdd = __webpack_require__(994),
	    setCacheHas = __webpack_require__(995);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(186),
	    stackClear = __webpack_require__(997),
	    stackDelete = __webpack_require__(998),
	    stackGet = __webpack_require__(999),
	    stackHas = __webpack_require__(1000),
	    stackSet = __webpack_require__(1001);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(421);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(149),
	    eq = __webpack_require__(125);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(125);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(44);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(127);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(418),
	    keys = __webpack_require__(76);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(123),
	    toKey = __webpack_require__(124);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 196 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 197 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(192),
	    isObject = __webpack_require__(44);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(974);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(886),
	    Map = __webpack_require__(266),
	    Promise = __webpack_require__(888),
	    Set = __webpack_require__(408),
	    WeakMap = __webpack_require__(410),
	    baseGetTag = __webpack_require__(82),
	    toSource = __webpack_require__(451);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(125),
	    isArrayLike = __webpack_require__(75),
	    isIndex = __webpack_require__(153),
	    isObject = __webpack_require__(44);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(102);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 204 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(271);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(421),
	    isArrayLike = __webpack_require__(75),
	    isString = __webpack_require__(286),
	    toInteger = __webpack_require__(210),
	    values = __webpack_require__(291);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(906),
	    baseUnary = __webpack_require__(151),
	    nodeUtil = __webpack_require__(445);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(193),
	    baseGt = __webpack_require__(420),
	    baseIteratee = __webpack_require__(68);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(93),
	    createWrap = __webpack_require__(432),
	    getHolder = __webpack_require__(199),
	    replaceHolders = __webpack_require__(155);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with `partials` prepended to the
	 * arguments it receives. This method is like `_.bind` except it does **not**
	 * alter the `this` binding.
	 *
	 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.2.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var sayHelloTo = _.partial(greet, 'hello');
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 *
	 * // Partially applied with placeholders.
	 * var greetFred = _.partial(greet, _, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 */
	var partial = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partial));
	  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partial.placeholder = {};
	
	module.exports = partial;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(460);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(927);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Material = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(131);
	
	var _object3d = __webpack_require__(294);
	
	var _object3d2 = _interopRequireDefault(_object3d);
	
	var _utils = __webpack_require__(30);
	
	var _geometry = __webpack_require__(84);
	
	var _shaders = __webpack_require__(1050);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // A scenegraph object node
	/* eslint-disable guard-for-in */
	
	// Define some locals
	
	
	var MSG_INSTANCED_PARAM_DEPRECATED = 'Warning: Model constructor: parameter "instanced" renamed to "isInstanced".\nThis will become a hard error in a future version of luma.gl.';
	
	var MSG_TEXTURES_PARAM_REMOVED = 'Model: parameter "textures" removed. Use uniforms to set textures';
	
	// TODO - experimental, not yet used
	
	var Material = exports.Material = function Material() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$shininess = _ref.shininess,
	      shininess = _ref$shininess === undefined ? 0 : _ref$shininess,
	      _ref$reflection = _ref.reflection,
	      reflection = _ref$reflection === undefined ? 0 : _ref$reflection,
	      _ref$refraction = _ref.refraction,
	      refraction = _ref$refraction === undefined ? 0 : _ref$refraction;
	
	  _classCallCheck(this, Material);
	
	  this.shininess = shininess;
	  this.reflection = reflection;
	  this.refraction = refraction;
	};
	
	// Model abstract O3D Class
	
	
	var Model = function (_Object3D) {
	  _inherits(Model, _Object3D);
	
	  function Model(gl) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Model);
	
	    opts = (0, _webgl.isWebGLContext)(gl) ? Object.assign({}, opts, { gl: gl }) : gl;
	
	    var _this = _possibleConstructorReturn(this, (Model.__proto__ || Object.getPrototypeOf(Model)).call(this, opts));
	
	    _this.init(opts);
	    return _this;
	  }
	
	  /* eslint-disable max-statements  */
	  /* eslint-disable complexity  */
	
	
	  _createClass(Model, [{
	    key: 'init',
	    value: function init() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          program = _ref2.program,
	          _ref2$gl = _ref2.gl,
	          gl = _ref2$gl === undefined ? null : _ref2$gl,
	          _ref2$vs = _ref2.vs,
	          vs = _ref2$vs === undefined ? _shaders.SHADERS.vs : _ref2$vs,
	          _ref2$fs = _ref2.fs,
	          fs = _ref2$fs === undefined ? _shaders.SHADERS.fs : _ref2$fs,
	          defaultUniforms = _ref2.defaultUniforms,
	          geometry = _ref2.geometry,
	          _ref2$material = _ref2.material,
	          material = _ref2$material === undefined ? null : _ref2$material,
	          textures = _ref2.textures,
	          _ref2$isInstanced = _ref2.isInstanced,
	          isInstanced = _ref2$isInstanced === undefined ? false : _ref2$isInstanced,
	          instanced = _ref2.instanced,
	          _ref2$instanceCount = _ref2.instanceCount,
	          instanceCount = _ref2$instanceCount === undefined ? 0 : _ref2$instanceCount,
	          _ref2$vertexCount = _ref2.vertexCount,
	          vertexCount = _ref2$vertexCount === undefined ? undefined : _ref2$vertexCount,
	          _ref2$pickable = _ref2.pickable,
	          pickable = _ref2$pickable === undefined ? true : _ref2$pickable,
	          _ref2$pick = _ref2.pick,
	          pick = _ref2$pick === undefined ? null : _ref2$pick,
	          _ref2$uniforms = _ref2.uniforms,
	          uniforms = _ref2$uniforms === undefined ? {} : _ref2$uniforms,
	          _ref2$attributes = _ref2.attributes,
	          attributes = _ref2$attributes === undefined ? {} : _ref2$attributes,
	          _ref2$render = _ref2.render,
	          render = _ref2$render === undefined ? null : _ref2$render,
	          _ref2$onBeforeRender = _ref2.onBeforeRender,
	          onBeforeRender = _ref2$onBeforeRender === undefined ? function () {} : _ref2$onBeforeRender,
	          _ref2$onAfterRender = _ref2.onAfterRender,
	          onAfterRender = _ref2$onAfterRender === undefined ? function () {} : _ref2$onAfterRender,
	          _ref2$timerQueryEnabl = _ref2.timerQueryEnabled,
	          timerQueryEnabled = _ref2$timerQueryEnabl === undefined ? false : _ref2$timerQueryEnabl;
	
	      // assert(program || program instanceof Program);
	      (0, _assert2.default)(geometry instanceof _geometry.Geometry, 'Model needs a geometry');
	
	      // Assign default uniforms if any of the default shaders is being used
	      if (vs === _shaders.SHADERS.vs || fs === _shaders.SHADERS.fs && defaultUniforms === undefined) {
	        defaultUniforms = _shaders.SHADERS.defaultUniforms;
	      }
	
	      // set a custom program per o3d
	      this.program = program || new _webgl.Program(gl, { vs: vs, fs: fs });
	      (0, _assert2.default)(this.program instanceof _webgl.Program, 'Model needs a program');
	
	      if (instanced) {
	        /* global console */
	        /* eslint-disable no-console */
	        console.warn(MSG_INSTANCED_PARAM_DEPRECATED);
	        isInstanced = isInstanced || instanced;
	      }
	
	      if (textures) {
	        throw new Error(MSG_TEXTURES_PARAM_REMOVED);
	      }
	
	      // TODO - remove?
	      this.buffers = {};
	      this.userData = {};
	      this.drawParams = {};
	      this.dynamic = false;
	      this.needsRedraw = true;
	
	      this.material = material;
	
	      // Attributes and buffers
	      this.setGeometry(geometry);
	      this.attributes = {};
	      this.setAttributes(attributes);
	
	      uniforms = Object.assign({}, this.program.defaultUniforms, uniforms);
	      this.uniforms = {};
	      this.setUniforms(uniforms);
	
	      // instanced rendering
	      this.isInstanced = isInstanced;
	      this.instanceCount = instanceCount;
	      this.vertexCount = vertexCount;
	
	      // picking options
	      this.pickable = Boolean(pickable);
	      this.pick = pick || function () {
	        return false;
	      };
	
	      this.onBeforeRender = onBeforeRender;
	      this.onAfterRender = onAfterRender;
	
	      this.timeElapsedQuery = undefined;
	      this.ext = this.program.gl.getExtension('EXT_disjoint_timer_query');
	
	      this.lastQueryReturned = true;
	      this.accumulatedFrameTime = 0;
	      this.averageFrameTime = 0;
	      this.profileFrameCount = 0;
	
	      this.timerQueryEnabled = timerQueryEnabled && this.ext !== null;
	    }
	    /* eslint-enable max-statements */
	    /* eslint-enable complexity */
	
	  }, {
	    key: 'destroy',
	    value: function destroy() {}
	  }, {
	    key: 'setNeedsRedraw',
	    value: function setNeedsRedraw() {
	      var redraw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.needsRedraw = redraw;
	      return this;
	    }
	  }, {
	    key: 'getNeedsRedraw',
	    value: function getNeedsRedraw() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref3$clearRedrawFlag = _ref3.clearRedrawFlags,
	          clearRedrawFlags = _ref3$clearRedrawFlag === undefined ? false : _ref3$clearRedrawFlag;
	
	      var redraw = false;
	      redraw = redraw || this.needsRedraw;
	      this.needsRedraw = this.needsRedraw && !clearRedrawFlags;
	      redraw = redraw || this.geometry.getNeedsRedraw({ clearRedrawFlags: clearRedrawFlags });
	      return redraw;
	    }
	  }, {
	    key: 'setInstanceCount',
	    value: function setInstanceCount(instanceCount) {
	      (0, _assert2.default)(instanceCount !== undefined);
	      this.instanceCount = instanceCount;
	      return this;
	    }
	  }, {
	    key: 'getInstanceCount',
	    value: function getInstanceCount() {
	      return this.instanceCount;
	    }
	  }, {
	    key: 'setVertexCount',
	    value: function setVertexCount(vertexCount) {
	      this.vertexCount = vertexCount;
	      return this;
	    }
	  }, {
	    key: 'getVertexCount',
	    value: function getVertexCount() {
	      return this.vertexCount === undefined ? this.geometry.getVertexCount() : this.vertexCount;
	    }
	  }, {
	    key: 'isPickable',
	    value: function isPickable() {
	      return this.pickable;
	    }
	  }, {
	    key: 'setPickable',
	    value: function setPickable() {
	      var pickable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.pickable = Boolean(pickable);
	      return this;
	    }
	  }, {
	    key: 'getProgram',
	    value: function getProgram() {
	      return this.program;
	    }
	  }, {
	    key: 'getGeometry',
	    value: function getGeometry() {
	      return this.geometry;
	    }
	  }, {
	    key: 'setGeometry',
	    value: function setGeometry(geometry) {
	      this.geometry = geometry;
	      this._createBuffersFromAttributeDescriptors(this.geometry.getAttributes());
	      this.setNeedsRedraw();
	      return this;
	    }
	  }, {
	    key: 'getAttributes',
	    value: function getAttributes() {
	      return this.attributes;
	    }
	  }, {
	    key: 'setAttributes',
	    value: function setAttributes() {
	      var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      Object.assign(this.attributes, attributes);
	      this._createBuffersFromAttributeDescriptors(attributes);
	      this.setNeedsRedraw();
	      return this;
	    }
	  }, {
	    key: 'getUniforms',
	    value: function getUniforms() {
	      return this.uniforms;
	    }
	  }, {
	    key: 'setUniforms',
	    value: function setUniforms() {
	      var uniforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      (0, _webgl.checkUniformValues)(uniforms, this.id);
	      Object.assign(this.uniforms, uniforms);
	      this.setNeedsRedraw();
	      return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref4$uniforms = _ref4.uniforms,
	          uniforms = _ref4$uniforms === undefined ? {} : _ref4$uniforms,
	          _ref4$attributes = _ref4.attributes,
	          attributes = _ref4$attributes === undefined ? {} : _ref4$attributes,
	          _ref4$settings = _ref4.settings,
	          settings = _ref4$settings === undefined ? {} : _ref4$settings;
	
	      return this.render(uniforms);
	    }
	
	    // TODO - uniform names are too strongly linked camera <=> default shaders
	    // At least all special handling is collected here.
	
	  }, {
	    key: 'addViewUniforms',
	    value: function addViewUniforms(uniforms) {
	      // TODO - special treatment of these parameters should be removed
	      var camera = uniforms.camera,
	          viewMatrix = uniforms.viewMatrix,
	          modelMatrix = uniforms.modelMatrix;
	      // Camera exposes uniforms that can be used directly in shaders
	
	      var cameraUniforms = camera ? camera.getUniforms() : {};
	
	      var viewUniforms = viewMatrix ? this.getCoordinateUniforms(viewMatrix, modelMatrix) : {};
	
	      return Object.assign({}, uniforms, cameraUniforms, viewUniforms);
	    }
	
	    /*
	     * @param {Camera} opt.camera=
	     * @param {Camera} opt.viewMatrix=
	     */
	    /* eslint-disable max-statements */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var uniforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var resolvedUniforms = this.addViewUniforms(uniforms);
	
	      this.setUniforms(resolvedUniforms);
	
	      _utils.log.log(2, '>>> RENDERING MODEL ' + this.id, this);
	
	      this.setProgramState();
	
	      this._logAttributesAndUniforms(3, resolvedUniforms);
	
	      this.onBeforeRender();
	
	      var drawParams = this.drawParams;
	      if (drawParams.isInstanced && !this.isInstanced) {
	        _utils.log.warn(0, 'Found instanced attributes on non-instanced model');
	      }
	      var isIndexed = drawParams.isIndexed,
	          indexType = drawParams.indexType;
	      var geometry = this.geometry,
	          isInstanced = this.isInstanced,
	          instanceCount = this.instanceCount;
	
	
	      if (this.timerQueryEnabled === true && this.lastQueryReturned === true) {
	        this.program.gl.getParameter(this.ext.GPU_DISJOINT_EXT);
	        this.timeElapsedQuery = this.ext.createQueryEXT();
	        this.ext.beginQueryEXT(this.ext.TIME_ELAPSED_EXT, this.timeElapsedQuery);
	      }
	
	      (0, _webgl.draw)(this.program.gl, {
	        drawMode: geometry.drawMode,
	        vertexCount: this.getVertexCount(),
	        isIndexed: isIndexed,
	        indexType: indexType,
	        isInstanced: isInstanced,
	        instanceCount: instanceCount
	      });
	
	      if (this.timerQueryEnabled === true) {
	        if (this.lastQueryReturned === true) {
	          this.ext.endQueryEXT(this.ext.TIME_ELAPSED_EXT);
	          this.profileFrameCount++;
	          this.lastQueryReturned = false;
	        }
	        // ...at some point in the future, after returning control to the browser and being called again:
	        var disjoint = this.program.gl.getParameter(this.ext.GPU_DISJOINT_EXT);
	        if (disjoint) {
	          this.lastQueryReturned = true;
	          // Have to redo all of the measurements.
	        } else {
	          var available = this.ext.getQueryObjectEXT(this.timeElapsedQuery, this.ext.QUERY_RESULT_AVAILABLE_EXT);
	
	          if (available) {
	            var timeElapsed = this.ext.getQueryObjectEXT(this.timeElapsedQuery, this.ext.QUERY_RESULT_EXT) / 1e6;
	            this.accumulatedFrameTime += timeElapsed;
	            this.averageFrameTime = this.accumulatedFrameTime / this.profileFrameCount;
	            // Do something useful with the time.  Note that care should be
	            // taken to use all significant bits of the result, not just the
	            // least significant 32 bits.
	            _utils.log.log(2, 'program.id: ', this.program.id);
	            _utils.log.log(2, 'last frame time: ', timeElapsed, 'ms');
	            _utils.log.log(2, 'average frame time: ', this.averageFrameTime, 'ms');
	            _utils.log.log(2, 'accumulated frame time: ', this.accumulatedFrameTime, 'ms');
	            _utils.log.log(2, 'profile frame count: ', this.profileFrameCount);
	            this.lastQueryReturned = true;
	          }
	        }
	      }
	      this.onAfterRender();
	
	      this.unsetProgramState();
	
	      this.setNeedsRedraw(false);
	
	      _utils.log.log(2, '<<< RENDERING MODEL ' + this.id + ' - complete');
	
	      return this;
	    }
	  }, {
	    key: 'setProgramState',
	    value: function setProgramState() {
	      var program = this.program;
	
	      program.use();
	      this.drawParams = {};
	      program.setBuffers(this.buffers, { drawParams: this.drawParams });
	      program.setUniforms(this.uniforms);
	      return this;
	    }
	  }, {
	    key: 'unsetProgramState',
	    value: function unsetProgramState() {
	      // Ensures all vertex attributes are disabled and ELEMENT_ARRAY_BUFFER
	      // is unbound
	      this.program.unsetBuffers();
	      return this;
	    }
	
	    // Makes sure buffers are created for all attributes
	    // and that the program is updated with those buffers
	    // TODO - do we need the separation between "attributes" and "buffers"
	    // couldn't apps just create buffers directly?
	
	  }, {
	    key: '_createBuffersFromAttributeDescriptors',
	    value: function _createBuffersFromAttributeDescriptors(attributes) {
	      var gl = this.program.gl;
	
	
	      for (var attributeName in attributes) {
	        var attribute = attributes[attributeName];
	
	        if (attribute instanceof _webgl.Buffer) {
	          this.buffers[attributeName] = attribute;
	        } else {
	          // Autocreate a buffer
	          this.buffers[attributeName] = this.buffers[attributeName] || new _webgl.Buffer(gl);
	
	          var buffer = this.buffers[attributeName];
	          buffer.setData(Object.assign({}, attribute, {
	            data: attribute.value,
	            target: attribute.isIndexed ? _webgl.GL.ELEMENT_ARRAY_BUFFER : _webgl.GL.ARRAY_BUFFER
	          }));
	        }
	      }
	
	      return this;
	    }
	  }, {
	    key: '_logAttributesAndUniforms',
	    value: function _logAttributesAndUniforms() {
	      var priority = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
	      var uniforms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (_utils.log.priority >= priority) {
	        var attributeTable = this._getAttributesTable({
	          header: 'Attributes ' + this.id,
	          program: this.program,
	          attributes: Object.assign({}, this.geometry.attributes, this.attributes)
	        });
	        _utils.log.table(priority, attributeTable);
	
	        var _getUniformsTable = (0, _webgl.getUniformsTable)({
	          header: 'Uniforms ' + this.id,
	          program: this.program,
	          uniforms: Object.assign({}, this.uniforms, uniforms)
	        }),
	            table = _getUniformsTable.table,
	            unusedTable = _getUniformsTable.unusedTable,
	            unusedCount = _getUniformsTable.unusedCount;
	
	        _utils.log.table(priority, table);
	        _utils.log.log(priority, (unusedCount || 'No') + ' unused uniforms ', unusedTable);
	      }
	    }
	
	    // Todo move to attributes manager
	
	  }, {
	    key: '_getAttributesTable',
	    value: function _getAttributesTable() {
	      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          attributes = _ref5.attributes,
	          _ref5$header = _ref5.header,
	          header = _ref5$header === undefined ? 'Attributes' : _ref5$header,
	          instanced = _ref5.instanced,
	          program = _ref5.program;
	
	      (0, _assert2.default)(program);
	      var attributeLocations = program._attributeLocations;
	      var table = _defineProperty({}, header, {});
	
	      // Add used attributes
	      for (var attributeName in attributeLocations) {
	        var attribute = attributes[attributeName];
	        var location = attributeLocations[attributeName];
	        table[attributeName] = this._getAttributeEntry(attribute, location);
	      }
	
	      // Add any unused attributes
	      for (var _attributeName in attributes) {
	        var _attribute = attributes[_attributeName];
	        if (!table[_attributeName]) {
	          table[_attributeName] = this._getAttributeEntry(_attribute, null);
	        }
	      }
	
	      return table;
	    }
	  }, {
	    key: '_getAttributeEntry',
	    value: function _getAttributeEntry(attribute, location) {
	      var round = function round(num) {
	        return Math.round(num * 10) / 10;
	      };
	
	      var type = 'NOT PROVIDED';
	      var instanced = 0;
	      var size = 'N/A';
	      var verts = 'N/A';
	      var bytes = 'N/A';
	      var value = 'N/A';
	
	      if (attribute && location === null) {
	        location = attribute.isIndexed ? 'ELEMENT_ARRAY_BUFFER' : 'NOT USED';
	      }
	
	      if (attribute instanceof _webgl.Buffer) {
	        var buffer = attribute;
	        type = buffer.layout.type;
	        instanced = buffer.layout.instanced;
	        size = buffer.layout.size;
	        verts = round(buffer.data.length / buffer.layout.size);
	        bytes = buffer.data.length * buffer.data.BYTES_PER_ELEMENT;
	      } else if (attribute) {
	        type = attribute.value.constructor.name;
	        instanced = attribute.instanced;
	        size = attribute.size;
	        verts = round(attribute.value.length / attribute.size);
	        bytes = attribute.value.length * attribute.value.BYTES_PER_ELEMENT;
	        value = attribute.value;
	      }
	
	      // Generate a type name by dropping Array from Float32Array etc.
	      type = String(type).replace('Array', '');
	      // Look for 'nt' to detect integer types, e.g. Int32Array, Uint32Array
	      var isInteger = type.indexOf('nt') !== -1;
	
	      location = '' + location + (instanced ? ' [instanced]' : '');
	
	      return {
	        Location: location,
	        'Type Size x Verts = Bytes': type + ' ' + size + ' x ' + verts + ' = ' + bytes,
	        Value: (0, _utils.formatValue)(value, { size: size, isInteger: isInteger })
	      };
	    }
	
	    // DEPRECATED / REMOVED
	
	  }, {
	    key: 'setTextures',
	    value: function setTextures() {
	      var textures = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      throw new Error('model.setTextures replaced: setUniforms({sampler2D: new Texture2D})');
	    }
	  }, {
	    key: 'hash',
	    get: function get() {
	      return this.id + ' ' + this.$pickingIndex;
	    }
	  }]);
	
	  return Model;
	}(_object3d2.default);
	
	exports.default = Model;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(106);
	
	var _geometry2 = _interopRequireDefault(_geometry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TruncatedConeGeometry = function (_Geometry) {
	  _inherits(TruncatedConeGeometry, _Geometry);
	
	  // Primitives inspired by TDL http://code.google.com/p/webglsamples/,
	  // copyright 2011 Google Inc. new BSD License
	  // (http://www.opensource.org/licenses/bsd-license.php).
	  /* eslint-disable max-statements, complexity */
	  function TruncatedConeGeometry() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, TruncatedConeGeometry);
	
	    var _opts$bottomRadius = opts.bottomRadius,
	        bottomRadius = _opts$bottomRadius === undefined ? 0 : _opts$bottomRadius,
	        _opts$topRadius = opts.topRadius,
	        topRadius = _opts$topRadius === undefined ? 0 : _opts$topRadius,
	        _opts$height = opts.height,
	        height = _opts$height === undefined ? 1 : _opts$height,
	        _opts$nradial = opts.nradial,
	        nradial = _opts$nradial === undefined ? 10 : _opts$nradial,
	        _opts$nvertical = opts.nvertical,
	        nvertical = _opts$nvertical === undefined ? 10 : _opts$nvertical,
	        _opts$topCap = opts.topCap,
	        topCap = _opts$topCap === undefined ? false : _opts$topCap,
	        _opts$bottomCap = opts.bottomCap,
	        bottomCap = _opts$bottomCap === undefined ? false : _opts$bottomCap;
	
	
	    var extra = (topCap ? 2 : 0) + (bottomCap ? 2 : 0);
	    var numVertices = (nradial + 1) * (nvertical + 1 + extra);
	
	    var slant = Math.atan2(bottomRadius - topRadius, height);
	    var msin = Math.sin;
	    var mcos = Math.cos;
	    var mpi = Math.PI;
	    var cosSlant = mcos(slant);
	    var sinSlant = msin(slant);
	    var start = topCap ? -2 : 0;
	    var end = nvertical + (bottomCap ? 2 : 0);
	    var vertsAroundEdge = nradial + 1;
	
	    var positions = new Float32Array(numVertices * 3);
	    var normals = new Float32Array(numVertices * 3);
	    var texCoords = new Float32Array(numVertices * 2);
	    var indices = new Uint16Array(nradial * (nvertical + extra) * 6);
	
	    var i3 = 0;
	    var i2 = 0;
	    for (var i = start; i <= end; i++) {
	      var v = i / nvertical;
	      var y = height * v;
	      var ringRadius = void 0;
	
	      if (i < 0) {
	        y = 0;
	        v = 1;
	        ringRadius = bottomRadius;
	      } else if (i > nvertical) {
	        y = height;
	        v = 1;
	        ringRadius = topRadius;
	      } else {
	        ringRadius = bottomRadius + (topRadius - bottomRadius) * (i / nvertical);
	      }
	      if (i === -2 || i === nvertical + 2) {
	        ringRadius = 0;
	        v = 0;
	      }
	      y -= height / 2;
	      for (var j = 0; j < vertsAroundEdge; j++) {
	        var sin = msin(j * mpi * 2 / nradial);
	        var cos = mcos(j * mpi * 2 / nradial);
	
	        positions[i3 + 0] = sin * ringRadius;
	        positions[i3 + 1] = y;
	        positions[i3 + 2] = cos * ringRadius;
	
	        normals[i3 + 0] = i < 0 || i > nvertical ? 0 : sin * cosSlant;
	        normals[i3 + 1] = i < 0 ? -1 : i > nvertical ? 1 : sinSlant;
	        normals[i3 + 2] = i < 0 || i > nvertical ? 0 : cos * cosSlant;
	
	        texCoords[i2 + 0] = j / nradial;
	        texCoords[i2 + 1] = v;
	
	        i2 += 2;
	        i3 += 3;
	      }
	    }
	
	    for (var _i = 0; _i < nvertical + extra; _i++) {
	      for (var _j = 0; _j < nradial; _j++) {
	        var index = (_i * nradial + _j) * 6;
	        indices[index + 0] = vertsAroundEdge * (_i + 0) + 0 + _j;
	        indices[index + 1] = vertsAroundEdge * (_i + 0) + 1 + _j;
	        indices[index + 2] = vertsAroundEdge * (_i + 1) + 1 + _j;
	        indices[index + 3] = vertsAroundEdge * (_i + 0) + 0 + _j;
	        indices[index + 4] = vertsAroundEdge * (_i + 1) + 1 + _j;
	        indices[index + 5] = vertsAroundEdge * (_i + 1) + 0 + _j;
	      }
	    }
	
	    return _possibleConstructorReturn(this, (TruncatedConeGeometry.__proto__ || Object.getPrototypeOf(TruncatedConeGeometry)).call(this, Object.assign({}, opts, {
	      attributes: {
	        positions: positions,
	        normals: normals,
	        texCoords: texCoords,
	        indices: indices
	      }
	    })));
	  }
	
	  return TruncatedConeGeometry;
	}(_geometry2.default);
	
	exports.default = TruncatedConeGeometry;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mathArray = __webpack_require__(130);
	
	var _mathArray2 = _interopRequireDefault(_mathArray);
	
	var _common = __webpack_require__(85);
	
	var _glMatrix = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Vector3 = function (_MathArray) {
	  _inherits(Vector3, _MathArray);
	
	  // Creates a new vec3, either empty, or from an array or from values
	  function Vector3() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    _classCallCheck(this, Vector3);
	
	    var _this = _possibleConstructorReturn(this, (Vector3.__proto__ || Object.getPrototypeOf(Vector3)).call(this));
	
	    if (Array.isArray(x) && arguments.length === 1) {
	      _this.copy(x);
	    } else {
	      _this.set(x, y, z);
	    }
	    return _this;
	  }
	
	  _createClass(Vector3, [{
	    key: 'set',
	    value: function set(x, y, z) {
	      _glMatrix.vec3.set(this, x, y, z);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'equals',
	    value: function equals(vector) {
	      return _glMatrix.vec3.equals(this, vector);
	    }
	  }, {
	    key: 'exactEquals',
	    value: function exactEquals(vector) {
	      return _glMatrix.vec3.exactEquals(this, vector);
	    }
	
	    // Getters/setters
	    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
	
	  }, {
	    key: 'distance',
	
	    /* eslint-enable no-multi-spaces, brace-style, no-return-assign */
	
	    value: function distance(vector) {
	      return _glMatrix.vec3.distance(vector);
	    }
	  }, {
	    key: 'dist',
	    value: function dist(vector) {
	      return _glMatrix.vec3.dist(vector);
	    }
	  }, {
	    key: 'angle',
	    value: function angle(vector) {
	      return _glMatrix.vec3.angle(vector);
	    }
	
	    // MODIFIERS
	
	  }, {
	    key: 'add',
	    value: function add() {
	      for (var _len = arguments.length, vectors = Array(_len), _key = 0; _key < _len; _key++) {
	        vectors[_key] = arguments[_key];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = vectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var vector = _step.value;
	
	          _glMatrix.vec3.add(this, vector);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'subtract',
	    value: function subtract() {
	      for (var _len2 = arguments.length, vectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        vectors[_key2] = arguments[_key2];
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = vectors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var vector = _step2.value;
	
	          _glMatrix.vec3.subtract(this, vector);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'multiply',
	    value: function multiply() {
	      for (var _len3 = arguments.length, vectors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        vectors[_key3] = arguments[_key3];
	      }
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = vectors[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var vector = _step3.value;
	
	          _glMatrix.vec3.multiply(this, vector);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'divide',
	    value: function divide() {
	      for (var _len4 = arguments.length, vectors = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        vectors[_key4] = arguments[_key4];
	      }
	
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = vectors[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var vector = _step4.value;
	
	          _glMatrix.vec3.divide(this, vector);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'ceil',
	    value: function ceil() {
	      _glMatrix.vec3.ceil(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'floor',
	    value: function floor() {
	      _glMatrix.vec3.floor(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'min',
	    value: function min() {
	      _glMatrix.vec3.min(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'max',
	    value: function max() {
	      _glMatrix.vec3.max(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'scale',
	    value: function scale(_scale) {
	      _glMatrix.vec3.scale(this, this, _scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'scaleAndAdd',
	    value: function scaleAndAdd(vector, scale) {
	      _glMatrix.vec3.scaleAndAdd(this, this, vector, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'negate',
	    value: function negate() {
	      _glMatrix.vec3.negate(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'inverse',
	    value: function inverse() {
	      _glMatrix.vec3.inverse(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'normalize',
	    value: function normalize() {
	      _glMatrix.vec3.normalize(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'dot',
	    value: function dot(vector) {
	      _glMatrix.vec3.dot(this, this, vector);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'cross',
	    value: function cross(vector) {
	      _glMatrix.vec3.cross(this, this, vector);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'lerp',
	    value: function lerp(scale) {
	      _glMatrix.vec3.lerp(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'hermite',
	    value: function hermite(scale) {
	      _glMatrix.vec3.hermite(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'bezier',
	    value: function bezier(scale) {
	      _glMatrix.vec3.bezier(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'random',
	    value: function random(scale) {
	      _glMatrix.vec3.cross(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'rotateX',
	    value: function rotateX(origin, angle) {
	      _glMatrix.vec3.rotateX(this, this, origin, angle);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'rotateY',
	    value: function rotateY(origin, angle) {
	      _glMatrix.vec3.rotateY(this, this, origin, angle);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'rotateZ',
	    value: function rotateZ(origin, angle) {
	      _glMatrix.vec3.rotateZ(this, this, origin, angle);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'ELEMENTS',
	    get: function get() {
	      return 3;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(value) {
	      return this[0] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(value) {
	      return this[1] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'z',
	    get: function get() {
	      return this[2];
	    },
	    set: function set(value) {
	      return this[2] = (0, _common.checkNumber)(value);
	    }
	  }], [{
	    key: 'fromArray',
	    value: function fromArray(array) {
	      if (array instanceof Vector3) {
	        return array;
	      }
	      return new (Function.prototype.bind.apply(Vector3, [null].concat(_toConsumableArray(array))))();
	    }
	  }, {
	    key: 'dot',
	    value: function dot(a, b) {
	      return Vector3.fromArray(a).dot(b);
	    }
	  }, {
	    key: 'cross',
	    value: function cross(a, b) {
	      return Vector3.fromArray(a).cross(b);
	    }
	  }]);
	
	  return Vector3;
	}(_mathArray2.default);
	
	exports.default = Vector3;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wYWNrYWdlcy9tYXRoL3NyYy92ZWN0b3IzLmpzIl0sIm5hbWVzIjpbIlZlY3RvcjMiLCJ4IiwieSIsInoiLCJBcnJheSIsImlzQXJyYXkiLCJhcmd1bWVudHMiLCJsZW5ndGgiLCJjb3B5Iiwic2V0IiwiY2hlY2siLCJ2ZWN0b3IiLCJlcXVhbHMiLCJleGFjdEVxdWFscyIsImRpc3RhbmNlIiwiZGlzdCIsImFuZ2xlIiwidmVjdG9ycyIsImFkZCIsInN1YnRyYWN0IiwibXVsdGlwbHkiLCJkaXZpZGUiLCJjZWlsIiwiZmxvb3IiLCJtaW4iLCJtYXgiLCJzY2FsZSIsInNjYWxlQW5kQWRkIiwibmVnYXRlIiwiaW52ZXJzZSIsIm5vcm1hbGl6ZSIsImRvdCIsImNyb3NzIiwibGVycCIsImhlcm1pdGUiLCJiZXppZXIiLCJvcmlnaW4iLCJyb3RhdGVYIiwicm90YXRlWSIsInJvdGF0ZVoiLCJ2YWx1ZSIsImFycmF5IiwiYSIsImIiLCJmcm9tQXJyYXkiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7O0FBQ0E7Ozs7Ozs7Ozs7OztJQUVxQkEsTzs7O0FBQ25CO0FBQ0EscUJBQWlDO0FBQUEsUUFBckJDLENBQXFCLHVFQUFqQixDQUFpQjtBQUFBLFFBQWRDLENBQWMsdUVBQVYsQ0FBVTtBQUFBLFFBQVBDLENBQU8sdUVBQUgsQ0FBRzs7QUFBQTs7QUFBQTs7QUFFL0IsUUFBSUMsTUFBTUMsT0FBTixDQUFjSixDQUFkLEtBQW9CSyxVQUFVQyxNQUFWLEtBQXFCLENBQTdDLEVBQWdEO0FBQzlDLFlBQUtDLElBQUwsQ0FBVVAsQ0FBVjtBQUNELEtBRkQsTUFFTztBQUNMLFlBQUtRLEdBQUwsQ0FBU1IsQ0FBVCxFQUFZQyxDQUFaLEVBQWVDLENBQWY7QUFDRDtBQU44QjtBQU9oQzs7Ozt3QkFTR0YsQyxFQUFHQyxDLEVBQUdDLEMsRUFBRztBQUNYLHFCQUFLTSxHQUFMLENBQVMsSUFBVCxFQUFlUixDQUFmLEVBQWtCQyxDQUFsQixFQUFxQkMsQ0FBckI7QUFDQSxXQUFLTyxLQUFMO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7OzsyQkFFTUMsTSxFQUFRO0FBQ2IsYUFBTyxlQUFLQyxNQUFMLENBQVksSUFBWixFQUFrQkQsTUFBbEIsQ0FBUDtBQUNEOzs7Z0NBRVdBLE0sRUFBUTtBQUNsQixhQUFPLGVBQUtFLFdBQUwsQ0FBaUIsSUFBakIsRUFBdUJGLE1BQXZCLENBQVA7QUFDRDs7QUFFRDtBQUNBOzs7OztBQVFBOzs2QkFFU0EsTSxFQUFRO0FBQ2YsYUFBTyxlQUFLRyxRQUFMLENBQWNILE1BQWQsQ0FBUDtBQUNEOzs7eUJBRUlBLE0sRUFBUTtBQUNYLGFBQU8sZUFBS0ksSUFBTCxDQUFVSixNQUFWLENBQVA7QUFDRDs7OzBCQUVLQSxNLEVBQVE7QUFDWixhQUFPLGVBQUtLLEtBQUwsQ0FBV0wsTUFBWCxDQUFQO0FBQ0Q7O0FBRUQ7Ozs7MEJBRWdCO0FBQUEsd0NBQVRNLE9BQVM7QUFBVEEsZUFBUztBQUFBOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUNkLDZCQUFxQkEsT0FBckIsOEhBQThCO0FBQUEsY0FBbkJOLE1BQW1COztBQUM1Qix5QkFBS08sR0FBTCxDQUFTLElBQVQsRUFBZVAsTUFBZjtBQUNEO0FBSGE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFJZCxXQUFLRCxLQUFMO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7OzsrQkFFb0I7QUFBQSx5Q0FBVE8sT0FBUztBQUFUQSxlQUFTO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQ25CLDhCQUFxQkEsT0FBckIsbUlBQThCO0FBQUEsY0FBbkJOLE1BQW1COztBQUM1Qix5QkFBS1EsUUFBTCxDQUFjLElBQWQsRUFBb0JSLE1BQXBCO0FBQ0Q7QUFIa0I7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFJbkIsV0FBS0QsS0FBTDtBQUNBLGFBQU8sSUFBUDtBQUNEOzs7K0JBRW9CO0FBQUEseUNBQVRPLE9BQVM7QUFBVEEsZUFBUztBQUFBOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUNuQiw4QkFBcUJBLE9BQXJCLG1JQUE4QjtBQUFBLGNBQW5CTixNQUFtQjs7QUFDNUIseUJBQUtTLFFBQUwsQ0FBYyxJQUFkLEVBQW9CVCxNQUFwQjtBQUNEO0FBSGtCO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBSW5CLFdBQUtELEtBQUw7QUFDQSxhQUFPLElBQVA7QUFDRDs7OzZCQUVrQjtBQUFBLHlDQUFUTyxPQUFTO0FBQVRBLGVBQVM7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFDakIsOEJBQXFCQSxPQUFyQixtSUFBOEI7QUFBQSxjQUFuQk4sTUFBbUI7O0FBQzVCLHlCQUFLVSxNQUFMLENBQVksSUFBWixFQUFrQlYsTUFBbEI7QUFDRDtBQUhnQjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUlqQixXQUFLRCxLQUFMO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7OzsyQkFFTTtBQUNMLHFCQUFLWSxJQUFMLENBQVUsSUFBVixFQUFnQixJQUFoQjtBQUNBLFdBQUtaLEtBQUw7QUFDQSxhQUFPLElBQVA7QUFDRDs7OzRCQUVPO0FBQ04scUJBQUthLEtBQUwsQ0FBVyxJQUFYLEVBQWlCLElBQWpCO0FBQ0EsV0FBS2IsS0FBTDtBQUNBLGFBQU8sSUFBUDtBQUNEOzs7MEJBRUs7QUFDSixxQkFBS2MsR0FBTCxDQUFTLElBQVQsRUFBZSxJQUFmO0FBQ0EsV0FBS2QsS0FBTDtBQUNBLGFBQU8sSUFBUDtBQUNEOzs7MEJBRUs7QUFDSixxQkFBS2UsR0FBTCxDQUFTLElBQVQsRUFBZSxJQUFmO0FBQ0EsV0FBS2YsS0FBTDtBQUNBLGFBQU8sSUFBUDtBQUNEOzs7MEJBRUtnQixNLEVBQU87QUFDWCxxQkFBS0EsS0FBTCxDQUFXLElBQVgsRUFBaUIsSUFBakIsRUFBdUJBLE1BQXZCO0FBQ0EsV0FBS2hCLEtBQUw7QUFDQSxhQUFPLElBQVA7QUFDRDs7O2dDQUVXQyxNLEVBQVFlLEssRUFBTztBQUN6QixxQkFBS0MsV0FBTCxDQUFpQixJQUFqQixFQUF1QixJQUF2QixFQUE2QmhCLE1BQTdCLEVBQXFDZSxLQUFyQztBQUNBLFdBQUtoQixLQUFMO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7Ozs2QkFFUTtBQUNQLHFCQUFLa0IsTUFBTCxDQUFZLElBQVosRUFBa0IsSUFBbEI7QUFDQSxXQUFLbEIsS0FBTDtBQUNBLGFBQU8sSUFBUDtBQUNEOzs7OEJBRVM7QUFDUixxQkFBS21CLE9BQUwsQ0FBYSxJQUFiLEVBQW1CLElBQW5CO0FBQ0EsV0FBS25CLEtBQUw7QUFDQSxhQUFPLElBQVA7QUFDRDs7O2dDQUVXO0FBQ1YscUJBQUtvQixTQUFMLENBQWUsSUFBZixFQUFxQixJQUFyQjtBQUNBLFdBQUtwQixLQUFMO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7Ozt3QkFFR0MsTSxFQUFRO0FBQ1YscUJBQUtvQixHQUFMLENBQVMsSUFBVCxFQUFlLElBQWYsRUFBcUJwQixNQUFyQjtBQUNBLFdBQUtELEtBQUw7QUFDQSxhQUFPLElBQVA7QUFDRDs7OzBCQU1LQyxNLEVBQVE7QUFDWixxQkFBS3FCLEtBQUwsQ0FBVyxJQUFYLEVBQWlCLElBQWpCLEVBQXVCckIsTUFBdkI7QUFDQSxXQUFLRCxLQUFMO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7Ozt5QkFNSWdCLEssRUFBTztBQUNWLHFCQUFLTyxJQUFMLENBQVUsSUFBVixFQUFnQixJQUFoQixFQUFzQlAsS0FBdEI7QUFDQSxXQUFLaEIsS0FBTDtBQUNBLGFBQU8sSUFBUDtBQUNEOzs7NEJBRU9nQixLLEVBQU87QUFDYixxQkFBS1EsT0FBTCxDQUFhLElBQWIsRUFBbUIsSUFBbkIsRUFBeUJSLEtBQXpCO0FBQ0EsV0FBS2hCLEtBQUw7QUFDQSxhQUFPLElBQVA7QUFDRDs7OzJCQUVNZ0IsSyxFQUFPO0FBQ1oscUJBQUtTLE1BQUwsQ0FBWSxJQUFaLEVBQWtCLElBQWxCLEVBQXdCVCxLQUF4QjtBQUNBLFdBQUtoQixLQUFMO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7OzsyQkFFTWdCLEssRUFBTztBQUNaLHFCQUFLTSxLQUFMLENBQVcsSUFBWCxFQUFpQixJQUFqQixFQUF1Qk4sS0FBdkI7QUFDQSxXQUFLaEIsS0FBTDtBQUNBLGFBQU8sSUFBUDtBQUNEOzs7NEJBRU8wQixNLEVBQVFwQixLLEVBQU87QUFDckIscUJBQUtxQixPQUFMLENBQWEsSUFBYixFQUFtQixJQUFuQixFQUF5QkQsTUFBekIsRUFBaUNwQixLQUFqQztBQUNBLFdBQUtOLEtBQUw7QUFDQSxhQUFPLElBQVA7QUFDRDs7OzRCQUVPMEIsTSxFQUFRcEIsSyxFQUFPO0FBQ3JCLHFCQUFLc0IsT0FBTCxDQUFhLElBQWIsRUFBbUIsSUFBbkIsRUFBeUJGLE1BQXpCLEVBQWlDcEIsS0FBakM7QUFDQSxXQUFLTixLQUFMO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7Ozs0QkFFTzBCLE0sRUFBUXBCLEssRUFBTztBQUNyQixxQkFBS3VCLE9BQUwsQ0FBYSxJQUFiLEVBQW1CLElBQW5CLEVBQXlCSCxNQUF6QixFQUFpQ3BCLEtBQWpDO0FBQ0EsV0FBS04sS0FBTDtBQUNBLGFBQU8sSUFBUDtBQUNEOzs7d0JBektjO0FBQUUsYUFBTyxDQUFQO0FBQVc7Ozt3QkFDZjtBQUFFLGFBQU8sS0FBSyxDQUFMLENBQVA7QUFBaUIsSztzQkFDMUI4QixLLEVBQU87QUFBRSxhQUFPLEtBQUssQ0FBTCxJQUFVLHlCQUFZQSxLQUFaLENBQWpCO0FBQXNDOzs7d0JBQ3hDO0FBQUUsYUFBTyxLQUFLLENBQUwsQ0FBUDtBQUFpQixLO3NCQUMxQkEsSyxFQUFPO0FBQUUsYUFBTyxLQUFLLENBQUwsSUFBVSx5QkFBWUEsS0FBWixDQUFqQjtBQUFzQzs7O3dCQUN4QztBQUFFLGFBQU8sS0FBSyxDQUFMLENBQVA7QUFBaUIsSztzQkFDMUJBLEssRUFBTztBQUFFLGFBQU8sS0FBSyxDQUFMLElBQVUseUJBQVlBLEtBQVosQ0FBakI7QUFBc0M7Ozs4QkE3QnBDQyxLLEVBQU87QUFDdEIsVUFBSUEsaUJBQWlCekMsT0FBckIsRUFBOEI7QUFDNUIsZUFBT3lDLEtBQVA7QUFDRDtBQUNELGdEQUFXekMsT0FBWCxtQ0FBc0J5QyxLQUF0QjtBQUNEOzs7d0JBcUlVQyxDLEVBQUdDLEMsRUFBRztBQUNmLGFBQU8zQyxRQUFRNEMsU0FBUixDQUFrQkYsQ0FBbEIsRUFBcUJYLEdBQXJCLENBQXlCWSxDQUF6QixDQUFQO0FBQ0Q7OzswQkFRWUQsQyxFQUFHQyxDLEVBQUc7QUFDakIsYUFBTzNDLFFBQVE0QyxTQUFSLENBQWtCRixDQUFsQixFQUFxQlYsS0FBckIsQ0FBMkJXLENBQTNCLENBQVA7QUFDRDs7Ozs7O2tCQWpLa0IzQyxPIiwiZmlsZSI6InZlY3RvcjMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgTWF0aEFycmF5IGZyb20gJy4vbWF0aC1hcnJheSc7XG5pbXBvcnQge2NoZWNrTnVtYmVyfSBmcm9tICcuL2NvbW1vbic7XG5pbXBvcnQge3ZlYzN9IGZyb20gJ2dsLW1hdHJpeCc7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFZlY3RvcjMgZXh0ZW5kcyBNYXRoQXJyYXkge1xuICAvLyBDcmVhdGVzIGEgbmV3IHZlYzMsIGVpdGhlciBlbXB0eSwgb3IgZnJvbSBhbiBhcnJheSBvciBmcm9tIHZhbHVlc1xuICBjb25zdHJ1Y3Rvcih4ID0gMCwgeSA9IDAsIHogPSAwKSB7XG4gICAgc3VwZXIoKTtcbiAgICBpZiAoQXJyYXkuaXNBcnJheSh4KSAmJiBhcmd1bWVudHMubGVuZ3RoID09PSAxKSB7XG4gICAgICB0aGlzLmNvcHkoeCk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHRoaXMuc2V0KHgsIHksIHopO1xuICAgIH1cbiAgfVxuXG4gIHN0YXRpYyBmcm9tQXJyYXkoYXJyYXkpIHtcbiAgICBpZiAoYXJyYXkgaW5zdGFuY2VvZiBWZWN0b3IzKSB7XG4gICAgICByZXR1cm4gYXJyYXk7XG4gICAgfVxuICAgIHJldHVybiBuZXcgVmVjdG9yMyguLi5hcnJheSk7XG4gIH1cblxuICBzZXQoeCwgeSwgeikge1xuICAgIHZlYzMuc2V0KHRoaXMsIHgsIHksIHopO1xuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIGVxdWFscyh2ZWN0b3IpIHtcbiAgICByZXR1cm4gdmVjMy5lcXVhbHModGhpcywgdmVjdG9yKTtcbiAgfVxuXG4gIGV4YWN0RXF1YWxzKHZlY3Rvcikge1xuICAgIHJldHVybiB2ZWMzLmV4YWN0RXF1YWxzKHRoaXMsIHZlY3Rvcik7XG4gIH1cblxuICAvLyBHZXR0ZXJzL3NldHRlcnNcbiAgLyogZXNsaW50LWRpc2FibGUgbm8tbXVsdGktc3BhY2VzLCBicmFjZS1zdHlsZSwgbm8tcmV0dXJuLWFzc2lnbiAqL1xuICBnZXQgRUxFTUVOVFMoKSB7IHJldHVybiAzOyB9XG4gIGdldCB4KCkgICAgICB7IHJldHVybiB0aGlzWzBdOyB9XG4gIHNldCB4KHZhbHVlKSB7IHJldHVybiB0aGlzWzBdID0gY2hlY2tOdW1iZXIodmFsdWUpOyB9XG4gIGdldCB5KCkgICAgICB7IHJldHVybiB0aGlzWzFdOyB9XG4gIHNldCB5KHZhbHVlKSB7IHJldHVybiB0aGlzWzFdID0gY2hlY2tOdW1iZXIodmFsdWUpOyB9XG4gIGdldCB6KCkgICAgICB7IHJldHVybiB0aGlzWzJdOyB9XG4gIHNldCB6KHZhbHVlKSB7IHJldHVybiB0aGlzWzJdID0gY2hlY2tOdW1iZXIodmFsdWUpOyB9XG4gIC8qIGVzbGludC1lbmFibGUgbm8tbXVsdGktc3BhY2VzLCBicmFjZS1zdHlsZSwgbm8tcmV0dXJuLWFzc2lnbiAqL1xuXG4gIGRpc3RhbmNlKHZlY3Rvcikge1xuICAgIHJldHVybiB2ZWMzLmRpc3RhbmNlKHZlY3Rvcik7XG4gIH1cblxuICBkaXN0KHZlY3Rvcikge1xuICAgIHJldHVybiB2ZWMzLmRpc3QodmVjdG9yKTtcbiAgfVxuXG4gIGFuZ2xlKHZlY3Rvcikge1xuICAgIHJldHVybiB2ZWMzLmFuZ2xlKHZlY3Rvcik7XG4gIH1cblxuICAvLyBNT0RJRklFUlNcblxuICBhZGQoLi4udmVjdG9ycykge1xuICAgIGZvciAoY29uc3QgdmVjdG9yIG9mIHZlY3RvcnMpIHtcbiAgICAgIHZlYzMuYWRkKHRoaXMsIHZlY3Rvcik7XG4gICAgfVxuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIHN1YnRyYWN0KC4uLnZlY3RvcnMpIHtcbiAgICBmb3IgKGNvbnN0IHZlY3RvciBvZiB2ZWN0b3JzKSB7XG4gICAgICB2ZWMzLnN1YnRyYWN0KHRoaXMsIHZlY3Rvcik7XG4gICAgfVxuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIG11bHRpcGx5KC4uLnZlY3RvcnMpIHtcbiAgICBmb3IgKGNvbnN0IHZlY3RvciBvZiB2ZWN0b3JzKSB7XG4gICAgICB2ZWMzLm11bHRpcGx5KHRoaXMsIHZlY3Rvcik7XG4gICAgfVxuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIGRpdmlkZSguLi52ZWN0b3JzKSB7XG4gICAgZm9yIChjb25zdCB2ZWN0b3Igb2YgdmVjdG9ycykge1xuICAgICAgdmVjMy5kaXZpZGUodGhpcywgdmVjdG9yKTtcbiAgICB9XG4gICAgdGhpcy5jaGVjaygpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgY2VpbCgpIHtcbiAgICB2ZWMzLmNlaWwodGhpcywgdGhpcyk7XG4gICAgdGhpcy5jaGVjaygpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgZmxvb3IoKSB7XG4gICAgdmVjMy5mbG9vcih0aGlzLCB0aGlzKTtcbiAgICB0aGlzLmNoZWNrKCk7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICBtaW4oKSB7XG4gICAgdmVjMy5taW4odGhpcywgdGhpcyk7XG4gICAgdGhpcy5jaGVjaygpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgbWF4KCkge1xuICAgIHZlYzMubWF4KHRoaXMsIHRoaXMpO1xuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIHNjYWxlKHNjYWxlKSB7XG4gICAgdmVjMy5zY2FsZSh0aGlzLCB0aGlzLCBzY2FsZSk7XG4gICAgdGhpcy5jaGVjaygpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgc2NhbGVBbmRBZGQodmVjdG9yLCBzY2FsZSkge1xuICAgIHZlYzMuc2NhbGVBbmRBZGQodGhpcywgdGhpcywgdmVjdG9yLCBzY2FsZSk7XG4gICAgdGhpcy5jaGVjaygpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgbmVnYXRlKCkge1xuICAgIHZlYzMubmVnYXRlKHRoaXMsIHRoaXMpO1xuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIGludmVyc2UoKSB7XG4gICAgdmVjMy5pbnZlcnNlKHRoaXMsIHRoaXMpO1xuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIG5vcm1hbGl6ZSgpIHtcbiAgICB2ZWMzLm5vcm1hbGl6ZSh0aGlzLCB0aGlzKTtcbiAgICB0aGlzLmNoZWNrKCk7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICBkb3QodmVjdG9yKSB7XG4gICAgdmVjMy5kb3QodGhpcywgdGhpcywgdmVjdG9yKTtcbiAgICB0aGlzLmNoZWNrKCk7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICBzdGF0aWMgZG90KGEsIGIpIHtcbiAgICByZXR1cm4gVmVjdG9yMy5mcm9tQXJyYXkoYSkuZG90KGIpO1xuICB9XG5cbiAgY3Jvc3ModmVjdG9yKSB7XG4gICAgdmVjMy5jcm9zcyh0aGlzLCB0aGlzLCB2ZWN0b3IpO1xuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIHN0YXRpYyBjcm9zcyhhLCBiKSB7XG4gICAgcmV0dXJuIFZlY3RvcjMuZnJvbUFycmF5KGEpLmNyb3NzKGIpO1xuICB9XG5cbiAgbGVycChzY2FsZSkge1xuICAgIHZlYzMubGVycCh0aGlzLCB0aGlzLCBzY2FsZSk7XG4gICAgdGhpcy5jaGVjaygpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgaGVybWl0ZShzY2FsZSkge1xuICAgIHZlYzMuaGVybWl0ZSh0aGlzLCB0aGlzLCBzY2FsZSk7XG4gICAgdGhpcy5jaGVjaygpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgYmV6aWVyKHNjYWxlKSB7XG4gICAgdmVjMy5iZXppZXIodGhpcywgdGhpcywgc2NhbGUpO1xuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIHJhbmRvbShzY2FsZSkge1xuICAgIHZlYzMuY3Jvc3ModGhpcywgdGhpcywgc2NhbGUpO1xuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIHJvdGF0ZVgob3JpZ2luLCBhbmdsZSkge1xuICAgIHZlYzMucm90YXRlWCh0aGlzLCB0aGlzLCBvcmlnaW4sIGFuZ2xlKTtcbiAgICB0aGlzLmNoZWNrKCk7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICByb3RhdGVZKG9yaWdpbiwgYW5nbGUpIHtcbiAgICB2ZWMzLnJvdGF0ZVkodGhpcywgdGhpcywgb3JpZ2luLCBhbmdsZSk7XG4gICAgdGhpcy5jaGVjaygpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgcm90YXRlWihvcmlnaW4sIGFuZ2xlKSB7XG4gICAgdmVjMy5yb3RhdGVaKHRoaXMsIHRoaXMsIG9yaWdpbiwgYW5nbGUpO1xuICAgIHRoaXMuY2hlY2soKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxufVxuIl19

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(58);
	
	var _webgl2 = _interopRequireDefault(_webgl);
	
	var _webglChecks = __webpack_require__(37);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Renderbuffer = function () {
	  _createClass(Renderbuffer, null, [{
	    key: 'makeFrom',
	    value: function makeFrom(gl) {
	      var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return object instanceof Renderbuffer ? object :
	      // Use .handle (e.g from stack.gl's gl-buffer), else use buffer directly
	      new Renderbuffer(gl, { handle: object.handle || object });
	    }
	  }]);
	
	  function Renderbuffer(gl) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Renderbuffer);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	
	    this.gl = gl;
	    this.handle = gl.createRenderbuffer();
	    if (!this.handle) {
	      throw new Error('Failed to create WebGL Renderbuffer');
	    }
	  }
	
	  _createClass(Renderbuffer, [{
	    key: 'delete',
	    value: function _delete() {
	      this.gl.deleteRenderbuffer(this.handle);
	      return this;
	    }
	  }, {
	    key: 'bind',
	    value: function bind() {
	      this.gl.bindRenderbuffer(_webgl2.default.RENDERBUFFER, this.handle);
	      return this;
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind() {
	      this.gl.bindRenderbuffer(_webgl2.default.RENDERBUFFER, null);
	      return this;
	    }
	
	    /**
	     * Creates and initializes a renderbuffer object's data store
	     *
	     * @param {GLenum} opt.internalFormat -
	     * @param {GLint} opt.width -
	     * @param {GLint} opt.height
	     * @param {Boolean} opt.autobind=true - method call will bind/unbind object
	     * @returns {Renderbuffer} returns itself to enable chaining
	     */
	
	  }, {
	    key: 'storage',
	    value: function storage(_ref) {
	      var internalFormat = _ref.internalFormat,
	          width = _ref.width,
	          height = _ref.height;
	      var gl = this.gl;
	
	      (0, _assert2.default)(internalFormat, 'Needs internalFormat');
	      this.bind();
	      gl.renderbufferStorage(_webgl2.default.RENDERBUFFER, (0, _webgl.glGet)(internalFormat), width, height);
	      this.unbind();
	      return this;
	    }
	
	    // @param {Boolean} opt.autobind=true - method call will bind/unbind object
	    // @returns {GLenum|GLint} - depends on pname
	
	  }, {
	    key: 'getParameter',
	    value: function getParameter(pname) {
	      var gl = this.gl;
	
	      this.bind();
	      var value = gl.getRenderbufferParameter(_webgl2.default.RENDERBUFFER, (0, _webgl.glGet)(pname));
	      this.unbind();
	      return value;
	    }
	
	    // @returns {GLint} - width of the image of the currently bound renderbuffer.
	
	  }, {
	    key: 'storageMultisample',
	
	
	    // WEBGL2 METHODS
	
	    // (OpenGL ES 3.0.4 §4.4.2)
	    value: function storageMultisample() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          samples = _ref2.samples,
	          internalformat = _ref2.internalformat,
	          width = _ref2.width,
	          height = _ref2.height;
	
	      var gl = this.gl;
	
	      (0, _webglChecks.assertWebGL2Context)(gl);
	      gl.renderbufferStorageMultisample(_webgl2.default.RENDERBUFFER, samples, internalformat, width, height);
	      return this;
	    }
	
	    // (OpenGL ES 3.0.4 §6.1.15)
	
	  }, {
	    key: 'getInternalformatParameter',
	    value: function getInternalformatParameter(_ref3) {
	      var internalformat = _ref3.internalformat,
	          _ref3$pname = _ref3.pname,
	          pname = _ref3$pname === undefined ? 'SAMPLES' : _ref3$pname;
	      var gl = this.gl;
	
	      (0, _webglChecks.assertWebGL2Context)(gl);
	      return gl.getInternalformatParameter(_webgl2.default.RENDERBUFFER, internalformat, pname);
	    }
	  }, {
	    key: 'width',
	    get: function get() {
	      return this.getParameter(_webgl2.default.RENDERBUFFER_WIDTH);
	    }
	
	    // @returns {GLint} - height of the image of the currently bound renderbuffer.
	
	  }, {
	    key: 'height',
	    get: function get() {
	      return this.getParameter(_webgl2.default.RENDERBUFFER_HEIGHT);
	    }
	
	    // @returns {GLenum} internal format of the currently bound renderbuffer.
	    // The default is gl.RGBA4. Possible return values:
	    // gl.RGBA4: 4 red bits, 4 green bits, 4 blue bits 4 alpha bits.
	    // gl.RGB565: 5 red bits, 6 green bits, 5 blue bits.
	    // gl.RGB5_A1: 5 red bits, 5 green bits, 5 blue bits, 1 alpha bit.
	    // gl.DEPTH_COMPONENT16: 16 depth bits.
	    // gl.STENCIL_INDEX8: 8 stencil bits.
	
	  }, {
	    key: 'internalFormat',
	    get: function get() {
	      return this.getParameter(_webgl2.default.RENDERBUFFER_INTERNAL_FORMAT);
	    }
	
	    //  @returns {GLint} - resolution size (in bits) for the green color.
	
	  }, {
	    key: 'greenSize',
	    get: function get() {
	      return this.getParameter(_webgl2.default.RENDERBUFFER_GREEN_SIZE);
	    }
	
	    // @returns {GLint} - resolution size (in bits) for the blue color.
	
	  }, {
	    key: 'blueSize',
	    get: function get() {
	      return this.getParameter(_webgl2.default.RENDERBUFFER_BLUE_SIZE);
	    }
	
	    // @returns {GLint} - resolution size (in bits) for the red color.
	
	  }, {
	    key: 'redSize',
	    get: function get() {
	      return this.getParameter(_webgl2.default.RENDERBUFFER_RED_SIZE);
	    }
	
	    // @returns {GLint} - resolution size (in bits) for the alpha component.
	
	  }, {
	    key: 'alphaSize',
	    get: function get() {
	      return this.getParameter(_webgl2.default.RENDERBUFFER_ALPHA_SIZE);
	    }
	
	    // @returns {GLint} - resolution size (in bits) for the depth component.
	
	  }, {
	    key: 'depthSize',
	    get: function get() {
	      return this.getParameter(_webgl2.default.RENDERBUFFER_DEPTH_SIZE);
	    }
	
	    // @returns {GLint} - resolution size (in bits) for the stencil component.
	
	  }, {
	    key: 'stencilSize',
	    get: function get() {
	      return this.getParameter(_webgl2.default.RENDERBUFFER_STENCIL_SIZE);
	    }
	
	    // When using a WebGL 2 context, the following value is available
	
	  }, {
	    key: 'samples',
	    get: function get() {
	      return this.getParameter(this.gl.RENDERBUFFER_SAMPLES);
	    }
	  }]);
	
	  return Renderbuffer;
	}();
	
	exports.default = Renderbuffer;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy93ZWJnbC9yZW5kZXJidWZmZXIuanMiXSwibmFtZXMiOlsiUmVuZGVyYnVmZmVyIiwiZ2wiLCJvYmplY3QiLCJoYW5kbGUiLCJvcHRzIiwiY3JlYXRlUmVuZGVyYnVmZmVyIiwiRXJyb3IiLCJkZWxldGVSZW5kZXJidWZmZXIiLCJiaW5kUmVuZGVyYnVmZmVyIiwiUkVOREVSQlVGRkVSIiwiaW50ZXJuYWxGb3JtYXQiLCJ3aWR0aCIsImhlaWdodCIsImJpbmQiLCJyZW5kZXJidWZmZXJTdG9yYWdlIiwidW5iaW5kIiwicG5hbWUiLCJ2YWx1ZSIsImdldFJlbmRlcmJ1ZmZlclBhcmFtZXRlciIsInNhbXBsZXMiLCJpbnRlcm5hbGZvcm1hdCIsInJlbmRlcmJ1ZmZlclN0b3JhZ2VNdWx0aXNhbXBsZSIsImdldEludGVybmFsZm9ybWF0UGFyYW1ldGVyIiwiZ2V0UGFyYW1ldGVyIiwiUkVOREVSQlVGRkVSX1dJRFRIIiwiUkVOREVSQlVGRkVSX0hFSUdIVCIsIlJFTkRFUkJVRkZFUl9JTlRFUk5BTF9GT1JNQVQiLCJSRU5ERVJCVUZGRVJfR1JFRU5fU0laRSIsIlJFTkRFUkJVRkZFUl9CTFVFX1NJWkUiLCJSRU5ERVJCVUZGRVJfUkVEX1NJWkUiLCJSRU5ERVJCVUZGRVJfQUxQSEFfU0laRSIsIlJFTkRFUkJVRkZFUl9ERVBUSF9TSVpFIiwiUkVOREVSQlVGRkVSX1NURU5DSUxfU0laRSIsIlJFTkRFUkJVRkZFUl9TQU1QTEVTIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7OztBQUNBOztBQUVBOzs7Ozs7OztJQUVxQkEsWTs7OzZCQUVIQyxFLEVBQWlCO0FBQUEsVUFBYkMsTUFBYSx1RUFBSixFQUFJOztBQUMvQixhQUFPQSxrQkFBa0JGLFlBQWxCLEdBQWlDRSxNQUFqQztBQUNMO0FBQ0EsVUFBSUYsWUFBSixDQUFpQkMsRUFBakIsRUFBcUIsRUFBQ0UsUUFBUUQsT0FBT0MsTUFBUCxJQUFpQkQsTUFBMUIsRUFBckIsQ0FGRjtBQUdEOzs7QUFFRCx3QkFBWUQsRUFBWixFQUEyQjtBQUFBLFFBQVhHLElBQVcsdUVBQUosRUFBSTs7QUFBQTs7QUFDekIseUNBQW1CSCxFQUFuQjs7QUFFQSxTQUFLQSxFQUFMLEdBQVVBLEVBQVY7QUFDQSxTQUFLRSxNQUFMLEdBQWNGLEdBQUdJLGtCQUFILEVBQWQ7QUFDQSxRQUFJLENBQUMsS0FBS0YsTUFBVixFQUFrQjtBQUNoQixZQUFNLElBQUlHLEtBQUosQ0FBVSxxQ0FBVixDQUFOO0FBQ0Q7QUFDRjs7Ozs4QkFFUTtBQUNQLFdBQUtMLEVBQUwsQ0FBUU0sa0JBQVIsQ0FBMkIsS0FBS0osTUFBaEM7QUFDQSxhQUFPLElBQVA7QUFDRDs7OzJCQUVNO0FBQ0wsV0FBS0YsRUFBTCxDQUFRTyxnQkFBUixDQUF5QixnQkFBR0MsWUFBNUIsRUFBMEMsS0FBS04sTUFBL0M7QUFDQSxhQUFPLElBQVA7QUFDRDs7OzZCQUVRO0FBQ1AsV0FBS0YsRUFBTCxDQUFRTyxnQkFBUixDQUF5QixnQkFBR0MsWUFBNUIsRUFBMEMsSUFBMUM7QUFDQSxhQUFPLElBQVA7QUFDRDs7QUFFRDs7Ozs7Ozs7Ozs7O2tDQVN5QztBQUFBLFVBQWhDQyxjQUFnQyxRQUFoQ0EsY0FBZ0M7QUFBQSxVQUFoQkMsS0FBZ0IsUUFBaEJBLEtBQWdCO0FBQUEsVUFBVEMsTUFBUyxRQUFUQSxNQUFTO0FBQUEsVUFDaENYLEVBRGdDLEdBQzFCLElBRDBCLENBQ2hDQSxFQURnQzs7QUFFdkMsNEJBQU9TLGNBQVAsRUFBdUIsc0JBQXZCO0FBQ0EsV0FBS0csSUFBTDtBQUNBWixTQUFHYSxtQkFBSCxDQUNFLGdCQUFHTCxZQURMLEVBQ21CLGtCQUFNQyxjQUFOLENBRG5CLEVBQzBDQyxLQUQxQyxFQUNpREMsTUFEakQ7QUFHQSxXQUFLRyxNQUFMO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7O0FBRUQ7QUFDQTs7OztpQ0FDYUMsSyxFQUFPO0FBQUEsVUFDWGYsRUFEVyxHQUNMLElBREssQ0FDWEEsRUFEVzs7QUFFbEIsV0FBS1ksSUFBTDtBQUNBLFVBQU1JLFFBQ0poQixHQUFHaUIsd0JBQUgsQ0FBNEIsZ0JBQUdULFlBQS9CLEVBQTZDLGtCQUFNTyxLQUFOLENBQTdDLENBREY7QUFFQSxXQUFLRCxNQUFMO0FBQ0EsYUFBT0UsS0FBUDtBQUNEOztBQUVEOzs7Ozs7QUF3REE7O0FBRUE7eUNBTVE7QUFBQSxzRkFBSixFQUFJO0FBQUEsVUFKTkUsT0FJTSxTQUpOQSxPQUlNO0FBQUEsVUFITkMsY0FHTSxTQUhOQSxjQUdNO0FBQUEsVUFGTlQsS0FFTSxTQUZOQSxLQUVNO0FBQUEsVUFETkMsTUFDTSxTQUROQSxNQUNNOztBQUFBLFVBQ0NYLEVBREQsR0FDTyxJQURQLENBQ0NBLEVBREQ7O0FBRU4sNENBQW9CQSxFQUFwQjtBQUNBQSxTQUFHb0IsOEJBQUgsQ0FDRSxnQkFBR1osWUFETCxFQUNtQlUsT0FEbkIsRUFDNEJDLGNBRDVCLEVBQzRDVCxLQUQ1QyxFQUNtREMsTUFEbkQ7QUFHQSxhQUFPLElBQVA7QUFDRDs7QUFFRDs7OztzREFDZ0U7QUFBQSxVQUFwQ1EsY0FBb0MsU0FBcENBLGNBQW9DO0FBQUEsOEJBQXBCSixLQUFvQjtBQUFBLFVBQXBCQSxLQUFvQiwrQkFBWixTQUFZO0FBQUEsVUFDdkRmLEVBRHVELEdBQ2pELElBRGlELENBQ3ZEQSxFQUR1RDs7QUFFOUQsNENBQW9CQSxFQUFwQjtBQUNBLGFBQU9BLEdBQUdxQiwwQkFBSCxDQUNMLGdCQUFHYixZQURFLEVBQ1lXLGNBRFosRUFDNEJKLEtBRDVCLENBQVA7QUFHRDs7O3dCQS9FVztBQUNWLGFBQU8sS0FBS08sWUFBTCxDQUFrQixnQkFBR0Msa0JBQXJCLENBQVA7QUFDRDs7QUFFRDs7Ozt3QkFDYTtBQUNYLGFBQU8sS0FBS0QsWUFBTCxDQUFrQixnQkFBR0UsbUJBQXJCLENBQVA7QUFDRDs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozt3QkFDcUI7QUFDbkIsYUFBTyxLQUFLRixZQUFMLENBQWtCLGdCQUFHRyw0QkFBckIsQ0FBUDtBQUNEOztBQUVEOzs7O3dCQUNnQjtBQUNkLGFBQU8sS0FBS0gsWUFBTCxDQUFrQixnQkFBR0ksdUJBQXJCLENBQVA7QUFDRDs7QUFFRDs7Ozt3QkFDZTtBQUNiLGFBQU8sS0FBS0osWUFBTCxDQUFrQixnQkFBR0ssc0JBQXJCLENBQVA7QUFDRDs7QUFFRDs7Ozt3QkFDYztBQUNaLGFBQU8sS0FBS0wsWUFBTCxDQUFrQixnQkFBR00scUJBQXJCLENBQVA7QUFDRDs7QUFFRDs7Ozt3QkFDZ0I7QUFDZCxhQUFPLEtBQUtOLFlBQUwsQ0FBa0IsZ0JBQUdPLHVCQUFyQixDQUFQO0FBQ0Q7O0FBRUQ7Ozs7d0JBQ2dCO0FBQ2QsYUFBTyxLQUFLUCxZQUFMLENBQWtCLGdCQUFHUSx1QkFBckIsQ0FBUDtBQUNEOztBQUVEOzs7O3dCQUNrQjtBQUNoQixhQUFPLEtBQUtSLFlBQUwsQ0FBa0IsZ0JBQUdTLHlCQUFyQixDQUFQO0FBQ0Q7O0FBRUQ7Ozs7d0JBQ2M7QUFDWixhQUFPLEtBQUtULFlBQUwsQ0FBa0IsS0FBS3RCLEVBQUwsQ0FBUWdDLG9CQUExQixDQUFQO0FBQ0Q7Ozs7OztrQkF0SGtCakMsWSIsImZpbGUiOiJyZW5kZXJidWZmZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgR0wsIHtnbEdldH0gZnJvbSAnLi93ZWJnbCc7XG5pbXBvcnQge2Fzc2VydFdlYkdMQ29udGV4dCwgYXNzZXJ0V2ViR0wyQ29udGV4dH0gZnJvbSAnLi93ZWJnbC1jaGVja3MnO1xuXG5pbXBvcnQgYXNzZXJ0IGZyb20gJ2Fzc2VydCc7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFJlbmRlcmJ1ZmZlciB7XG5cbiAgc3RhdGljIG1ha2VGcm9tKGdsLCBvYmplY3QgPSB7fSkge1xuICAgIHJldHVybiBvYmplY3QgaW5zdGFuY2VvZiBSZW5kZXJidWZmZXIgPyBvYmplY3QgOlxuICAgICAgLy8gVXNlIC5oYW5kbGUgKGUuZyBmcm9tIHN0YWNrLmdsJ3MgZ2wtYnVmZmVyKSwgZWxzZSB1c2UgYnVmZmVyIGRpcmVjdGx5XG4gICAgICBuZXcgUmVuZGVyYnVmZmVyKGdsLCB7aGFuZGxlOiBvYmplY3QuaGFuZGxlIHx8IG9iamVjdH0pO1xuICB9XG5cbiAgY29uc3RydWN0b3IoZ2wsIG9wdHMgPSB7fSkge1xuICAgIGFzc2VydFdlYkdMQ29udGV4dChnbCk7XG5cbiAgICB0aGlzLmdsID0gZ2w7XG4gICAgdGhpcy5oYW5kbGUgPSBnbC5jcmVhdGVSZW5kZXJidWZmZXIoKTtcbiAgICBpZiAoIXRoaXMuaGFuZGxlKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoJ0ZhaWxlZCB0byBjcmVhdGUgV2ViR0wgUmVuZGVyYnVmZmVyJyk7XG4gICAgfVxuICB9XG5cbiAgZGVsZXRlKCkge1xuICAgIHRoaXMuZ2wuZGVsZXRlUmVuZGVyYnVmZmVyKHRoaXMuaGFuZGxlKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIGJpbmQoKSB7XG4gICAgdGhpcy5nbC5iaW5kUmVuZGVyYnVmZmVyKEdMLlJFTkRFUkJVRkZFUiwgdGhpcy5oYW5kbGUpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgdW5iaW5kKCkge1xuICAgIHRoaXMuZ2wuYmluZFJlbmRlcmJ1ZmZlcihHTC5SRU5ERVJCVUZGRVIsIG51bGwpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgLyoqXG4gICAqIENyZWF0ZXMgYW5kIGluaXRpYWxpemVzIGEgcmVuZGVyYnVmZmVyIG9iamVjdCdzIGRhdGEgc3RvcmVcbiAgICpcbiAgICogQHBhcmFtIHtHTGVudW19IG9wdC5pbnRlcm5hbEZvcm1hdCAtXG4gICAqIEBwYXJhbSB7R0xpbnR9IG9wdC53aWR0aCAtXG4gICAqIEBwYXJhbSB7R0xpbnR9IG9wdC5oZWlnaHRcbiAgICogQHBhcmFtIHtCb29sZWFufSBvcHQuYXV0b2JpbmQ9dHJ1ZSAtIG1ldGhvZCBjYWxsIHdpbGwgYmluZC91bmJpbmQgb2JqZWN0XG4gICAqIEByZXR1cm5zIHtSZW5kZXJidWZmZXJ9IHJldHVybnMgaXRzZWxmIHRvIGVuYWJsZSBjaGFpbmluZ1xuICAgKi9cbiAgc3RvcmFnZSh7aW50ZXJuYWxGb3JtYXQsIHdpZHRoLCBoZWlnaHR9KSB7XG4gICAgY29uc3Qge2dsfSA9IHRoaXM7XG4gICAgYXNzZXJ0KGludGVybmFsRm9ybWF0LCAnTmVlZHMgaW50ZXJuYWxGb3JtYXQnKTtcbiAgICB0aGlzLmJpbmQoKTtcbiAgICBnbC5yZW5kZXJidWZmZXJTdG9yYWdlKFxuICAgICAgR0wuUkVOREVSQlVGRkVSLCBnbEdldChpbnRlcm5hbEZvcm1hdCksIHdpZHRoLCBoZWlnaHRcbiAgICApO1xuICAgIHRoaXMudW5iaW5kKCk7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICAvLyBAcGFyYW0ge0Jvb2xlYW59IG9wdC5hdXRvYmluZD10cnVlIC0gbWV0aG9kIGNhbGwgd2lsbCBiaW5kL3VuYmluZCBvYmplY3RcbiAgLy8gQHJldHVybnMge0dMZW51bXxHTGludH0gLSBkZXBlbmRzIG9uIHBuYW1lXG4gIGdldFBhcmFtZXRlcihwbmFtZSkge1xuICAgIGNvbnN0IHtnbH0gPSB0aGlzO1xuICAgIHRoaXMuYmluZCgpO1xuICAgIGNvbnN0IHZhbHVlID1cbiAgICAgIGdsLmdldFJlbmRlcmJ1ZmZlclBhcmFtZXRlcihHTC5SRU5ERVJCVUZGRVIsIGdsR2V0KHBuYW1lKSk7XG4gICAgdGhpcy51bmJpbmQoKTtcbiAgICByZXR1cm4gdmFsdWU7XG4gIH1cblxuICAvLyBAcmV0dXJucyB7R0xpbnR9IC0gd2lkdGggb2YgdGhlIGltYWdlIG9mIHRoZSBjdXJyZW50bHkgYm91bmQgcmVuZGVyYnVmZmVyLlxuICBnZXQgd2lkdGgoKSB7XG4gICAgcmV0dXJuIHRoaXMuZ2V0UGFyYW1ldGVyKEdMLlJFTkRFUkJVRkZFUl9XSURUSCk7XG4gIH1cblxuICAvLyBAcmV0dXJucyB7R0xpbnR9IC0gaGVpZ2h0IG9mIHRoZSBpbWFnZSBvZiB0aGUgY3VycmVudGx5IGJvdW5kIHJlbmRlcmJ1ZmZlci5cbiAgZ2V0IGhlaWdodCgpIHtcbiAgICByZXR1cm4gdGhpcy5nZXRQYXJhbWV0ZXIoR0wuUkVOREVSQlVGRkVSX0hFSUdIVCk7XG4gIH1cblxuICAvLyBAcmV0dXJucyB7R0xlbnVtfSBpbnRlcm5hbCBmb3JtYXQgb2YgdGhlIGN1cnJlbnRseSBib3VuZCByZW5kZXJidWZmZXIuXG4gIC8vIFRoZSBkZWZhdWx0IGlzIGdsLlJHQkE0LiBQb3NzaWJsZSByZXR1cm4gdmFsdWVzOlxuICAvLyBnbC5SR0JBNDogNCByZWQgYml0cywgNCBncmVlbiBiaXRzLCA0IGJsdWUgYml0cyA0IGFscGhhIGJpdHMuXG4gIC8vIGdsLlJHQjU2NTogNSByZWQgYml0cywgNiBncmVlbiBiaXRzLCA1IGJsdWUgYml0cy5cbiAgLy8gZ2wuUkdCNV9BMTogNSByZWQgYml0cywgNSBncmVlbiBiaXRzLCA1IGJsdWUgYml0cywgMSBhbHBoYSBiaXQuXG4gIC8vIGdsLkRFUFRIX0NPTVBPTkVOVDE2OiAxNiBkZXB0aCBiaXRzLlxuICAvLyBnbC5TVEVOQ0lMX0lOREVYODogOCBzdGVuY2lsIGJpdHMuXG4gIGdldCBpbnRlcm5hbEZvcm1hdCgpIHtcbiAgICByZXR1cm4gdGhpcy5nZXRQYXJhbWV0ZXIoR0wuUkVOREVSQlVGRkVSX0lOVEVSTkFMX0ZPUk1BVCk7XG4gIH1cblxuICAvLyAgQHJldHVybnMge0dMaW50fSAtIHJlc29sdXRpb24gc2l6ZSAoaW4gYml0cykgZm9yIHRoZSBncmVlbiBjb2xvci5cbiAgZ2V0IGdyZWVuU2l6ZSgpIHtcbiAgICByZXR1cm4gdGhpcy5nZXRQYXJhbWV0ZXIoR0wuUkVOREVSQlVGRkVSX0dSRUVOX1NJWkUpO1xuICB9XG5cbiAgLy8gQHJldHVybnMge0dMaW50fSAtIHJlc29sdXRpb24gc2l6ZSAoaW4gYml0cykgZm9yIHRoZSBibHVlIGNvbG9yLlxuICBnZXQgYmx1ZVNpemUoKSB7XG4gICAgcmV0dXJuIHRoaXMuZ2V0UGFyYW1ldGVyKEdMLlJFTkRFUkJVRkZFUl9CTFVFX1NJWkUpO1xuICB9XG5cbiAgLy8gQHJldHVybnMge0dMaW50fSAtIHJlc29sdXRpb24gc2l6ZSAoaW4gYml0cykgZm9yIHRoZSByZWQgY29sb3IuXG4gIGdldCByZWRTaXplKCkge1xuICAgIHJldHVybiB0aGlzLmdldFBhcmFtZXRlcihHTC5SRU5ERVJCVUZGRVJfUkVEX1NJWkUpO1xuICB9XG5cbiAgLy8gQHJldHVybnMge0dMaW50fSAtIHJlc29sdXRpb24gc2l6ZSAoaW4gYml0cykgZm9yIHRoZSBhbHBoYSBjb21wb25lbnQuXG4gIGdldCBhbHBoYVNpemUoKSB7XG4gICAgcmV0dXJuIHRoaXMuZ2V0UGFyYW1ldGVyKEdMLlJFTkRFUkJVRkZFUl9BTFBIQV9TSVpFKTtcbiAgfVxuXG4gIC8vIEByZXR1cm5zIHtHTGludH0gLSByZXNvbHV0aW9uIHNpemUgKGluIGJpdHMpIGZvciB0aGUgZGVwdGggY29tcG9uZW50LlxuICBnZXQgZGVwdGhTaXplKCkge1xuICAgIHJldHVybiB0aGlzLmdldFBhcmFtZXRlcihHTC5SRU5ERVJCVUZGRVJfREVQVEhfU0laRSk7XG4gIH1cblxuICAvLyBAcmV0dXJucyB7R0xpbnR9IC0gcmVzb2x1dGlvbiBzaXplIChpbiBiaXRzKSBmb3IgdGhlIHN0ZW5jaWwgY29tcG9uZW50LlxuICBnZXQgc3RlbmNpbFNpemUoKSB7XG4gICAgcmV0dXJuIHRoaXMuZ2V0UGFyYW1ldGVyKEdMLlJFTkRFUkJVRkZFUl9TVEVOQ0lMX1NJWkUpO1xuICB9XG5cbiAgLy8gV2hlbiB1c2luZyBhIFdlYkdMIDIgY29udGV4dCwgdGhlIGZvbGxvd2luZyB2YWx1ZSBpcyBhdmFpbGFibGVcbiAgZ2V0IHNhbXBsZXMoKSB7XG4gICAgcmV0dXJuIHRoaXMuZ2V0UGFyYW1ldGVyKHRoaXMuZ2wuUkVOREVSQlVGRkVSX1NBTVBMRVMpO1xuICB9XG5cbiAgLy8gV0VCR0wyIE1FVEhPRFNcblxuICAvLyAoT3BlbkdMIEVTIDMuMC40IMKnNC40LjIpXG4gIHN0b3JhZ2VNdWx0aXNhbXBsZSh7XG4gICAgc2FtcGxlcyxcbiAgICBpbnRlcm5hbGZvcm1hdCxcbiAgICB3aWR0aCxcbiAgICBoZWlnaHRcbiAgfSA9IHt9KSB7XG4gICAgY29uc3Qge2dsfSA9IHRoaXM7XG4gICAgYXNzZXJ0V2ViR0wyQ29udGV4dChnbCk7XG4gICAgZ2wucmVuZGVyYnVmZmVyU3RvcmFnZU11bHRpc2FtcGxlKFxuICAgICAgR0wuUkVOREVSQlVGRkVSLCBzYW1wbGVzLCBpbnRlcm5hbGZvcm1hdCwgd2lkdGgsIGhlaWdodFxuICAgICk7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICAvLyAoT3BlbkdMIEVTIDMuMC40IMKnNi4xLjE1KVxuICBnZXRJbnRlcm5hbGZvcm1hdFBhcmFtZXRlcih7aW50ZXJuYWxmb3JtYXQsIHBuYW1lID0gJ1NBTVBMRVMnfSkge1xuICAgIGNvbnN0IHtnbH0gPSB0aGlzO1xuICAgIGFzc2VydFdlYkdMMkNvbnRleHQoZ2wpO1xuICAgIHJldHVybiBnbC5nZXRJbnRlcm5hbGZvcm1hdFBhcmFtZXRlcihcbiAgICAgIEdMLlJFTkRFUkJVRkZFUiwgaW50ZXJuYWxmb3JtYXQsIHBuYW1lXG4gICAgKTtcbiAgfVxufVxuIl19

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _texture = __webpack_require__(217);
	
	var _texture2 = _interopRequireDefault(_texture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Texture2D = function (_Texture) {
	  _inherits(Texture2D, _Texture);
	
	  _createClass(Texture2D, null, [{
	    key: 'makeFrom',
	    value: function makeFrom(gl) {
	      var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return object instanceof Texture2D ? object :
	      // Use .handle (e.g from stack.gl's gl-buffer), else use buffer directly
	      new Texture2D(gl, { handle: object.handle || object });
	    }
	  }, {
	    key: 'makeFromSolidColor',
	    value: function makeFromSolidColor(gl, _ref) {
	      var _ref2 = _slicedToArray(_ref, 4),
	          _ref2$ = _ref2[0],
	          r = _ref2$ === undefined ? 0 : _ref2$,
	          _ref2$2 = _ref2[1],
	          g = _ref2$2 === undefined ? 0 : _ref2$2,
	          _ref2$3 = _ref2[2],
	          b = _ref2$3 === undefined ? 0 : _ref2$3,
	          _ref2$4 = _ref2[3],
	          a = _ref2$4 === undefined ? 1 : _ref2$4;
	
	      return new Texture2D(gl, {
	        pixels: new Uint8Array([r, g, b, a]),
	        width: 1,
	        format: gl.RGBA,
	        magFilter: gl.NEAREST,
	        minFilter: gl.NEAREST
	      });
	    }
	  }, {
	    key: 'makeFromPixelArray',
	    value: function makeFromPixelArray(gl, opts) {
	      var dataArray = opts.dataArray,
	          _opts$format = opts.format,
	          format = _opts$format === undefined ? _webgl.GL.RGBA : _opts$format,
	          _opts$width = opts.width,
	          width = _opts$width === undefined ? 1 : _opts$width,
	          height = opts.height;
	      // Don't need to do this if the data is already in a typed array
	
	      var dataTypedArray = new Uint8Array(dataArray);
	      return new Texture2D(gl, Object.assign({
	        pixels: dataTypedArray,
	        width: width,
	        height: height,
	        format: format
	      }, opts));
	    }
	
	    /**
	     * @classdesc
	     * 2D WebGL Texture
	     * Note: Constructor will initialize your texture.
	     *
	     * @class
	     * @param {WebGLRenderingContext} gl - gl context
	     * @param {Image|ArrayBuffer|null} opts= - named options
	     * @param {Image|ArrayBuffer|null} opts.data= - buffer
	     * @param {GLint} width - width of texture
	     * @param {GLint} height - height of texture
	     */
	
	  }]);
	
	  function Texture2D(gl) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Texture2D);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	
	    var _this = _possibleConstructorReturn(this, (Texture2D.__proto__ || Object.getPrototypeOf(Texture2D)).call(this, gl, Object.assign({}, opts, { target: gl.TEXTURE_2D })));
	
	    _this.width = null;
	    _this.height = null;
	    Object.seal(_this);
	
	    _this.setImageData(opts);
	    if (opts.generateMipmap) {
	      _this.generateMipmap();
	    }
	    return _this;
	  }
	
	  // target cannot be modified by bind:
	  // textures are special because when you first bind them to a target,
	  // they get special information. When you first bind a texture as a
	  // GL_TEXTURE_2D, you are actually setting special state in the texture.
	  // You are saying that this texture is a 2D texture.
	  // And it will always be a 2D texture; this state cannot be changed ever.
	  // If you have a texture that was first bound as a GL_TEXTURE_2D,
	  // you must always bind it as a GL_TEXTURE_2D;
	  // attempting to bind it as GL_TEXTURE_1D will give rise to an error
	  // (while run-time).
	
	  _createClass(Texture2D, [{
	    key: 'bind',
	    value: function bind() {
	      var textureUnit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.textureUnit;
	      var gl = this.gl;
	
	      if (textureUnit === undefined) {
	        throw new Error('Texture.bind: must specify texture unit');
	      }
	      this.textureUnit = textureUnit;
	      gl.activeTexture(gl.TEXTURE0 + textureUnit);
	      gl.bindTexture(this.target, this.handle);
	      return textureUnit;
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind() {
	      var gl = this.gl;
	
	      if (this.textureUnit === undefined) {
	        throw new Error('Texture.unbind: texture unit not specified');
	      }
	      gl.activeTexture(gl.TEXTURE0 + this.textureUnit);
	      gl.bindTexture(this.target, null);
	      return this.textureUnit;
	    }
	  }, {
	    key: 'getActiveUnit',
	    value: function getActiveUnit() {
	      return this.gl.getParameter(_webgl.GL.ACTIVE_TEXTURE) - _webgl.GL.TEXTURE0;
	    }
	
	    // WebGL2
	
	  }, {
	    key: 'setPixels',
	    value: function setPixels() {
	      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var buffer = opts.buffer,
	          _opts$width2 = opts.width,
	          width = _opts$width2 === undefined ? null : _opts$width2,
	          _opts$height = opts.height,
	          height = _opts$height === undefined ? null : _opts$height,
	          _opts$mipmapLevel = opts.mipmapLevel,
	          mipmapLevel = _opts$mipmapLevel === undefined ? 0 : _opts$mipmapLevel,
	          _opts$format2 = opts.format,
	          format = _opts$format2 === undefined ? _webgl.GL.RGBA : _opts$format2,
	          _opts$type = opts.type,
	          type = _opts$type === undefined ? _webgl.GL.UNSIGNED_BYTE : _opts$type,
	          _opts$border = opts.border,
	          border = _opts$border === undefined ? 0 : _opts$border;
	      var gl = this.gl;
	
	      // This signature of texImage2D uses currently bound GL_PIXEL_UNPACK_BUFFER
	
	      gl.bindBuffer(_webgl.GL.PIXEL_UNPACK_BUFFER, buffer.target);
	      // And as always, we must also bind the texture itself
	      this.bind();
	
	      gl.texImage2D(gl.TEXTURE_2D, mipmapLevel, format, width, height, border, format, type, buffer.target);
	
	      this.unbind();
	      gl.bindBuffer(_webgl.GL.GL_PIXEL_UNPACK_BUFFER, null);
	      return this;
	    }
	  }, {
	    key: 'setImageDataFromCompressedBuffer',
	    value: function setImageDataFromCompressedBuffer(opts) {
	      var buffer = opts.buffer,
	          _opts$width3 = opts.width,
	          width = _opts$width3 === undefined ? null : _opts$width3,
	          _opts$height2 = opts.height,
	          height = _opts$height2 === undefined ? null : _opts$height2,
	          _opts$mipmapLevel2 = opts.mipmapLevel,
	          mipmapLevel = _opts$mipmapLevel2 === undefined ? 0 : _opts$mipmapLevel2,
	          _opts$internalFormat = opts.internalFormat,
	          internalFormat = _opts$internalFormat === undefined ? _webgl.GL.RGBA : _opts$internalFormat,
	          _opts$border2 = opts.border,
	          border = _opts$border2 === undefined ? 0 : _opts$border2;
	      var gl = this.gl;
	
	      gl.compressedTexImage2D(this.target, mipmapLevel, internalFormat, width, height, border, buffer);
	      // gl.compressedTexSubImage2D(target,
	      //   level, xoffset, yoffset, width, height, format, ArrayBufferView? pixels);
	      return this;
	    }
	
	    /**
	     * Defines a two-dimensional texture image or cube-map texture image with
	     * pixels from the current framebuffer (rather than from client memory).
	     * (gl.copyTexImage2D wrapper)
	     */
	
	  }, {
	    key: 'copyImageFromFramebuffer',
	    value: function copyImageFromFramebuffer(opts) {
	      var framebuffer = opts.framebuffer,
	          x = opts.x,
	          y = opts.y,
	          width = opts.width,
	          height = opts.height,
	          _opts$mipmapLevel3 = opts.mipmapLevel,
	          mipmapLevel = _opts$mipmapLevel3 === undefined ? 0 : _opts$mipmapLevel3,
	          _opts$internalFormat2 = opts.internalFormat,
	          internalFormat = _opts$internalFormat2 === undefined ? _webgl.GL.RGBA : _opts$internalFormat2,
	          _opts$border3 = opts.border,
	          border = _opts$border3 === undefined ? 0 : _opts$border3;
	      var gl = this.gl;
	
	      framebuffer.bind();
	
	      // target
	      this.bind();
	      gl.copyTexImage2D(this.target, mipmapLevel, internalFormat, x, y, width, height, border);
	      this.unbind();
	
	      framebuffer.unbind();
	    }
	  }, {
	    key: 'copySubImage',
	    value: function copySubImage(opts) {
	      _objectDestructuringEmpty(opts);
	
	      // if (pixels instanceof ArrayBufferView) {
	      //   gl.texSubImage2D(target, level, x, y, width, height, format, type, pixels);
	      // }
	      // gl.texSubImage2D(target, level, x, y, format, type, ? pixels);
	      // gl.texSubImage2D(target, level, x, y, format, type, HTMLImageElement pixels);
	      // gl.texSubImage2D(target, level, x, y, format, type, HTMLCanvasElement pixels);
	      // gl.texSubImage2D(target, level, x, y, format, type, HTMLVideoElement pixels);
	      // // Additional signature in a WebGL 2 context:
	      // gl.texSubImage2D(target, level, x, y, format, type, GLintptr offset);
	
	    }
	  }]);
	
	  return Texture2D;
	}(_texture2.default);
	
	exports.default = Texture2D;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _buffer = __webpack_require__(161);
	
	var _buffer2 = _interopRequireDefault(_buffer);
	
	var _utils = __webpack_require__(30);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Texture = function () {
	  function Texture(gl, opts) {
	    _classCallCheck(this, Texture);
	
	    var _opts$id = opts.id,
	        id = _opts$id === undefined ? (0, _utils.uid)('texture') : _opts$id,
	        _opts$unpackFlipY = opts.unpackFlipY,
	        unpackFlipY = _opts$unpackFlipY === undefined ? true : _opts$unpackFlipY,
	        _opts$magFilter = opts.magFilter,
	        magFilter = _opts$magFilter === undefined ? _webgl.GL.NEAREST : _opts$magFilter,
	        _opts$minFilter = opts.minFilter,
	        minFilter = _opts$minFilter === undefined ? _webgl.GL.NEAREST : _opts$minFilter,
	        _opts$wrapS = opts.wrapS,
	        wrapS = _opts$wrapS === undefined ? _webgl.GL.CLAMP_TO_EDGE : _opts$wrapS,
	        _opts$wrapT = opts.wrapT,
	        wrapT = _opts$wrapT === undefined ? _webgl.GL.CLAMP_TO_EDGE : _opts$wrapT,
	        _opts$target = opts.target,
	        target = _opts$target === undefined ? _webgl.GL.TEXTURE_2D : _opts$target,
	        handle = opts.handle;
	
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	
	    this.handle = handle || gl.createTexture();
	    this.id = id;
	    this.gl = gl;
	    this.target = target;
	    this.hasFloatTexture = gl.getExtension('OES_texture_float');
	    this.width = null;
	    this.height = null;
	    this.textureUnit = undefined;
	    this.userData = {};
	
	    this.setPixelStorageModes(Object.assign({}, opts, { unpackFlipY: unpackFlipY }));
	    this.setParameters(Object.assign({}, opts, { magFilter: magFilter, minFilter: minFilter, wrapS: wrapS, wrapT: wrapT }));
	  }
	
	  _createClass(Texture, [{
	    key: 'delete',
	    value: function _delete() {
	      if (this.handle) {
	        this.gl.deleteTexture(this.handle);
	        this.handle = null;
	      }
	      return this;
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return 'Texture(' + this.id + ',' + this.width + 'x' + this.height + ')';
	    }
	  }, {
	    key: 'generateMipmap',
	    value: function generateMipmap() {
	      this.gl.bindTexture(this.target, this.handle);
	      this.gl.generateMipmap(this.target);
	      this.gl.bindTexture(this.target, null);
	      return this;
	    }
	
	    /*
	     * @param {*} pixels -
	     *  null - create empty texture of specified format
	     *  Typed array - init from image data in typed array
	     *  Buffer|WebGLBuffer - (WEBGL2) init from image data in WebGLBuffer
	     *  HTMLImageElement|Image - Inits with content of image. Auto width/height
	     *  HTMLCanvasElement - Inits with contents of canvas. Auto width/height
	     *  HTMLVideoElement - Creates video texture. Auto width/height
	     *
	     * @param {GLint} width -
	     * @param {GLint} height -
	     * @param {GLint} mipMapLevel -
	     * @param {GLenum} format - format of image data.
	     * @param {GLenum} type
	     *  - format of array (autodetect from type) or
	     *  - (WEBGL2) format of buffer
	     * @param {Number} offset - (WEBGL2) offset from start of buffer
	     * @param {GLint} border - must be 0.
	     */
	    /* eslint-disable max-len, max-statements, complexity */
	
	  }, {
	    key: 'setImageData',
	    value: function setImageData(_ref) {
	      var _ref$target = _ref.target,
	          target = _ref$target === undefined ? this.target : _ref$target,
	          _ref$pixels = _ref.pixels,
	          pixels = _ref$pixels === undefined ? null : _ref$pixels,
	          _ref$data = _ref.data,
	          data = _ref$data === undefined ? null : _ref$data,
	          width = _ref.width,
	          height = _ref.height,
	          _ref$mipmapLevel = _ref.mipmapLevel,
	          mipmapLevel = _ref$mipmapLevel === undefined ? 0 : _ref$mipmapLevel,
	          _ref$format = _ref.format,
	          format = _ref$format === undefined ? _webgl.GL.RGBA : _ref$format,
	          type = _ref.type,
	          _ref$offset = _ref.offset,
	          offset = _ref$offset === undefined ? 0 : _ref$offset,
	          _ref$border = _ref.border,
	          border = _ref$border === undefined ? 0 : _ref$border;
	      var gl = this.gl;
	
	
	      pixels = pixels || data;
	
	      // Support ndarrays
	      if (pixels && pixels.data) {
	        var ndarray = pixels;
	        pixels = ndarray.data;
	        width = ndarray.shape[0];
	        height = ndarray.shape[1];
	      }
	
	      gl.bindTexture(this.target, this.handle);
	
	      if (pixels === null) {
	
	        // Create an minimal texture
	        width = width || 1;
	        height = height || 1;
	        type = type || _webgl.GL.UNSIGNED_BYTE;
	        // pixels = new Uint8Array([255, 0, 0, 1]);
	        gl.texImage2D(target, mipmapLevel, format, width, height, border, format, type, pixels);
	        this.width = width;
	        this.height = height;
	      } else if (ArrayBuffer.isView(pixels)) {
	
	        // Create from a typed array
	        (0, _assert2.default)(width > 0 && height > 0, 'Texture2D: Width and height required');
	        type = type || (0, _webgl.glTypeFromArray)(pixels);
	        // TODO - WebGL2 check?
	        if (type === gl.FLOAT && !this.hasFloatTexture) {
	          throw new Error('floating point textures are not supported.');
	        }
	        gl.texImage2D(target, mipmapLevel, format, width, height, border, format, type, pixels);
	        this.width = width;
	        this.height = height;
	      } else if (pixels instanceof _webgl.WebGLBuffer || pixels instanceof _buffer2.default) {
	
	        // WebGL2 allows us to create texture directly from a WebGL buffer
	        (0, _assert2.default)(gl instanceof _webgl.WebGL2RenderingContext, 'Requires WebGL2');
	        type = type || _webgl.GL.UNSIGNED_BYTE;
	        // This texImage2D signature uses currently bound GL_PIXEL_UNPACK_BUFFER
	        var buffer = _buffer2.default.makeFrom(pixels);
	        gl.bindBuffer(_webgl.GL.PIXEL_UNPACK_BUFFER, buffer.handle);
	        gl.texImage2D(target, mipmapLevel, format, width, height, border, format, type, offset);
	        gl.bindBuffer(_webgl.GL.GL_PIXEL_UNPACK_BUFFER, null);
	        this.width = width;
	        this.height = height;
	      } else {
	
	        var imageSize = this._deduceImageSize(pixels);
	        // Assume pixels is a browser supported object (ImageData, Canvas, ...)
	        (0, _assert2.default)(width === undefined && height === undefined, 'Texture2D.setImageData: Width and height must not be provided');
	        type = type || _webgl.GL.UNSIGNED_BYTE;
	        gl.texImage2D(target, mipmapLevel, format, format, type, pixels);
	        this.width = imageSize.width;
	        this.height = imageSize.height;
	      }
	
	      gl.bindTexture(this.target, null);
	
	      return this;
	    }
	    /* eslint-enable max-len, max-statements, complexity */
	
	    /* global ImageData, HTMLImageElement, HTMLCanvasElement, HTMLVideoElement */
	
	  }, {
	    key: '_deduceImageSize',
	    value: function _deduceImageSize(image) {
	      if (typeof ImageData !== 'undefined' && image instanceof ImageData) {
	        return { width: image.width, height: image.height };
	      } else if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
	        return { width: image.naturalWidth, height: image.naturalHeight };
	      } else if (typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement) {
	        return { width: image.width, height: image.height };
	      } else if (typeof HTMLVideoElement !== 'undefined' && image instanceof HTMLVideoElement) {
	        return { width: image.videoWidth, height: image.videoHeight };
	      }
	      throw new Error('Unknown image data format. Failed to deduce image size');
	    }
	
	    /**
	     * Batch update pixel storage modes
	     * @param {GLint} packAlignment - Packing of pixel data in memory (1,2,4,8)
	     * @param {GLint} unpackAlignment - Unpacking pixel data from memory(1,2,4,8)
	     * @param {GLboolean} unpackFlipY -  Flip source data along its vertical axis
	     * @param {GLboolean} unpackPremultiplyAlpha -
	     *   Multiplies the alpha channel into the other color channels
	     * @param {GLenum} unpackColorspaceConversion -
	     *   Default color space conversion or no color space conversion.
	     *
	     * @param {GLint} packRowLength -
	     *  Number of pixels in a row.
	     * @param {} packSkipPixels -
	     *   Number of pixels skipped before the first pixel is written into memory.
	     * @param {} packSkipRows -
	     *   Number of rows of pixels skipped before first pixel is written to memory.
	     * @param {} unpackRowLength -
	     *   Number of pixels in a row.
	     * @param {} unpackImageHeight -
	     *   Image height used for reading pixel data from memory
	     * @param {} unpackSkipPixels -
	     *   Number of pixel images skipped before first pixel is read from memory
	     * @param {} unpackSkipRows -
	     *   Number of rows of pixels skipped before first pixel is read from memory
	     * @param {} unpackSkipImages -
	     *   Number of pixel images skipped before first pixel is read from memory
	     */
	    /* eslint-disable complexity, max-statements */
	
	  }, {
	    key: 'setPixelStorageModes',
	    value: function setPixelStorageModes() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          packAlignment = _ref2.packAlignment,
	          unpackAlignment = _ref2.unpackAlignment,
	          unpackFlipY = _ref2.unpackFlipY,
	          unpackPremultiplyAlpha = _ref2.unpackPremultiplyAlpha,
	          unpackColorspaceConversion = _ref2.unpackColorspaceConversion,
	          packRowLength = _ref2.packRowLength,
	          packSkipPixels = _ref2.packSkipPixels,
	          packSkipRows = _ref2.packSkipRows,
	          unpackRowLength = _ref2.unpackRowLength,
	          unpackImageHeight = _ref2.unpackImageHeight,
	          unpackSkipPixels = _ref2.unpackSkipPixels,
	          unpackSkipRows = _ref2.unpackSkipRows,
	          unpackSkipImages = _ref2.unpackSkipImages;
	
	      var gl = this.gl;
	
	
	      gl.bindTexture(this.target, this.handle);
	
	      if (packAlignment) {
	        gl.pixelStorei(gl.PACK_ALIGNMENT, packAlignment);
	      }
	      if (unpackAlignment) {
	        gl.pixelStorei(gl.UNPACK_ALIGNMENT, unpackAlignment);
	      }
	      if (unpackFlipY) {
	        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, unpackFlipY);
	      }
	      if (unpackPremultiplyAlpha) {
	        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, unpackPremultiplyAlpha);
	      }
	      if (unpackColorspaceConversion) {
	        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackColorspaceConversion);
	      }
	
	      // WEBGL2
	      if (packRowLength) {
	        gl.pixelStorei(gl.PACK_ROW_LENGTH, packRowLength);
	      }
	      if (packSkipPixels) {
	        gl.pixelStorei(gl.PACK_SKIP_PIXELS, packSkipPixels);
	      }
	      if (packSkipRows) {
	        gl.pixelStorei(gl.PACK_SKIP_ROWS, packSkipRows);
	      }
	      if (unpackRowLength) {
	        gl.pixelStorei(gl.UNPACK_ROW_LENGTH, unpackRowLength);
	      }
	      if (unpackImageHeight) {
	        gl.pixelStorei(gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight);
	      }
	      if (unpackSkipPixels) {
	        gl.pixelStorei(gl.UNPACK_SKIP_PIXELS, unpackSkipPixels);
	      }
	      if (unpackSkipRows) {
	        gl.pixelStorei(gl.UNPACK_SKIP_ROWS, unpackSkipRows);
	      }
	      if (unpackSkipImages) {
	        gl.pixelStorei(gl.UNPACK_SKIP_IMAGES, unpackSkipImages);
	      }
	
	      gl.bindTexture(this.target, null);
	      return this;
	    }
	    /* eslint-enable complexity, max-statements */
	
	    /**
	     * Batch update sampler settings
	     *
	     * @param {GLenum} magFilter - texture magnification filter.
	     * @param {GLenum} minFilter - texture minification filter
	     * @param {GLenum} wrapS - texture wrapping function for texture coordinate s.
	     * @param {GLenum} wrapT - texture wrapping function for texture coordinate t.
	     * WEBGL2 only:
	     * @param {GLenum} wrapR - texture wrapping function for texture coordinate r.
	     * @param {GLenum} compareFunc - texture comparison function.
	     * @param {GLenum} compareMode - texture comparison mode.
	     * @param {GLfloat} minLOD - minimum level-of-detail value.
	     * @param {GLfloat} maxLOD - maximum level-of-detail value.
	     * @param {GLfloat} baseLevel - Texture mipmap level
	     * @param {GLfloat} maxLevel - Maximum texture mipmap array level
	     */
	    /* eslint-disable complexity, max-statements */
	
	  }, {
	    key: 'setParameters',
	    value: function setParameters(_ref3) {
	      var magFilter = _ref3.magFilter,
	          minFilter = _ref3.minFilter,
	          wrapS = _ref3.wrapS,
	          wrapT = _ref3.wrapT,
	          wrapR = _ref3.wrapR,
	          baseLevel = _ref3.baseLevel,
	          maxLevel = _ref3.maxLevel,
	          minLOD = _ref3.minLOD,
	          maxLOD = _ref3.maxLOD,
	          compareFunc = _ref3.compareFunc,
	          compareMode = _ref3.compareMode;
	      var gl = this.gl;
	
	      gl.bindTexture(this.target, this.handle);
	
	      if (magFilter) {
	        gl.texParameteri(this.target, gl.TEXTURE_MAG_FILTER, magFilter);
	      }
	      if (minFilter) {
	        gl.texParameteri(this.target, gl.TEXTURE_MIN_FILTER, minFilter);
	      }
	      if (wrapS) {
	        gl.texParameteri(this.target, gl.TEXTURE_WRAP_S, wrapS);
	      }
	      if (wrapT) {
	        gl.texParameteri(this.target, gl.TEXTURE_WRAP_T, wrapT);
	      }
	      // WEBGL2
	      if (wrapR) {
	        gl.texParameteri(this.target, gl.TEXTURE_WRAP_R, wrapR);
	      }
	      if (baseLevel) {
	        gl.texParameteri(this.target, gl.TEXTURE_BASE_LEVEL, baseLevel);
	      }
	      if (maxLevel) {
	        gl.texParameteri(this.target, gl.TEXTURE_MAX_LEVEL, maxLevel);
	      }
	      if (compareFunc) {
	        gl.texParameteri(this.target, gl.TEXTURE_COMPARE_FUNC, compareFunc);
	      }
	      if (compareMode) {
	        gl.texParameteri(this.target, gl.TEXTURE_COMPARE_MODE, compareMode);
	      }
	      if (minLOD) {
	        gl.texParameterf(this.target, gl.TEXTURE_MIN_LOD, minLOD);
	      }
	      if (maxLOD) {
	        gl.texParameterf(this.target, gl.TEXTURE_MAX_LOD, maxLOD);
	      }
	
	      gl.bindTexture(this.target, null);
	      return this;
	    }
	    /* eslint-enable complexity, max-statements */
	
	  }, {
	    key: 'getParameters',
	    value: function getParameters() {
	      var gl = this.gl;
	
	      gl.bindTexture(this.target, this.handle);
	      var webglParams = {
	        magFilter: gl.getTexParameter(this.target, gl.TEXTURE_MAG_FILTER),
	        minFilter: gl.getTexParameter(this.target, gl.TEXTURE_MIN_FILTER),
	        wrapS: gl.getTexParameter(this.target, gl.TEXTURE_WRAP_S),
	        wrapT: gl.getTexParameter(this.target, gl.TEXTURE_WRAP_T)
	      };
	      gl.bindTexture(this.target, null);
	      return webglParams;
	    }
	
	    // Deprecated methods
	
	  }, {
	    key: 'image2D',
	    value: function image2D(_ref4) {
	      var pixels = _ref4.pixels,
	          _ref4$format = _ref4.format,
	          format = _ref4$format === undefined ? _webgl.GL.RGBA : _ref4$format,
	          _ref4$type = _ref4.type,
	          type = _ref4$type === undefined ? _webgl.GL.UNSIGNED_BYTE : _ref4$type;
	
	      // TODO - WebGL2 check?
	      if (type === _webgl.GL.FLOAT && !this.hasFloatTexture) {
	        throw new Error('floating point textures are not supported.');
	      }
	
	      this.gl.bindTexture(this.target, this.handle);
	      this.gl.texImage2D(_webgl.GL.TEXTURE_2D, 0, format, format, type, pixels);
	      this.gl.bindTexture(this.target, null);
	      return this;
	    }
	  }, {
	    key: 'update',
	    value: function update(opts) {
	      throw new Error('Texture.update() is deprecated()');
	    }
	  }]);
	
	  return Texture;
	}();
	
	exports.default = Texture;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebGL2RenderingContext = exports.WebGLShaderPrecisionFormat = exports.WebGLActiveInfo = exports.WebGLUniformLocation = exports.WebGLTexture = exports.WebGLRenderbuffer = exports.WebGLFramebuffer = exports.WebGLBuffer = exports.WebGLShader = exports.WebGLProgram = exports.WebGLRenderingContext = exports.Image = exports.webGLTypesAvailable = undefined;
	
	var _init = __webpack_require__(475);
	
	var _init2 = _interopRequireDefault(_init);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // WEBGL BUILT-IN TYPES
	// 1) Exports all WebGL constants as {GL}
	// 2) Enables app to "import" WebGL types
	//    - Importing these types makes them known to eslint etc.
	//    - Provides dummy types for WebGL2 when not available to streamline
	//      library code.
	//    - Exports types from headless gl when running under Node.js
	
	var DummyType = function DummyType() {
	  _classCallCheck(this, DummyType);
	};
	
	var _ref = _init2.default.globals.headlessTypes || _init.global,
	    _ref$WebGLRenderingCo = _ref.WebGLRenderingContext,
	    WebGLRenderingContext = _ref$WebGLRenderingCo === undefined ? DummyType : _ref$WebGLRenderingCo,
	    _ref$WebGLProgram = _ref.WebGLProgram,
	    WebGLProgram = _ref$WebGLProgram === undefined ? DummyType : _ref$WebGLProgram,
	    _ref$WebGLShader = _ref.WebGLShader,
	    WebGLShader = _ref$WebGLShader === undefined ? DummyType : _ref$WebGLShader,
	    _ref$WebGLBuffer = _ref.WebGLBuffer,
	    WebGLBuffer = _ref$WebGLBuffer === undefined ? DummyType : _ref$WebGLBuffer,
	    _ref$WebGLFramebuffer = _ref.WebGLFramebuffer,
	    WebGLFramebuffer = _ref$WebGLFramebuffer === undefined ? DummyType : _ref$WebGLFramebuffer,
	    _ref$WebGLRenderbuffe = _ref.WebGLRenderbuffer,
	    WebGLRenderbuffer = _ref$WebGLRenderbuffe === undefined ? DummyType : _ref$WebGLRenderbuffe,
	    _ref$WebGLTexture = _ref.WebGLTexture,
	    WebGLTexture = _ref$WebGLTexture === undefined ? DummyType : _ref$WebGLTexture,
	    _ref$WebGLUniformLoca = _ref.WebGLUniformLocation,
	    WebGLUniformLocation = _ref$WebGLUniformLoca === undefined ? DummyType : _ref$WebGLUniformLoca,
	    _ref$WebGLActiveInfo = _ref.WebGLActiveInfo,
	    WebGLActiveInfo = _ref$WebGLActiveInfo === undefined ? DummyType : _ref$WebGLActiveInfo,
	    _ref$WebGLShaderPreci = _ref.WebGLShaderPrecisionFormat,
	    WebGLShaderPrecisionFormat = _ref$WebGLShaderPreci === undefined ? DummyType : _ref$WebGLShaderPreci;
	
	var webGLTypesAvailable = exports.webGLTypesAvailable = WebGLRenderingContext !== DummyType && WebGLProgram !== DummyType && WebGLShader !== DummyType && WebGLBuffer !== DummyType && WebGLFramebuffer !== DummyType && WebGLRenderbuffer !== DummyType && WebGLTexture !== DummyType && WebGLUniformLocation !== DummyType && WebGLActiveInfo !== DummyType && WebGLShaderPrecisionFormat !== DummyType;
	
	// Ensures that WebGL2RenderingContext is defined in non-WebGL2 environments
	// so that apps can test their gl contexts with instanceof
	// E.g. if (gl instanceof WebGL2RenderingContext) { }
	function getWebGL2RenderingContext() {
	  var WebGL2RenderingContextNotSupported = function WebGL2RenderingContextNotSupported() {
	    _classCallCheck(this, WebGL2RenderingContextNotSupported);
	  };
	
	  return _init.global.WebGL2RenderingContext || WebGL2RenderingContextNotSupported;
	}
	
	// Ensure that Image is defined under Node.js
	function getImage() {
	  var ImageNotSupported = function ImageNotSupported() {
	    _classCallCheck(this, ImageNotSupported);
	  };
	
	  return _init.global.Image || ImageNotSupported;
	}
	
	var WebGL2RenderingContext = getWebGL2RenderingContext();
	var Image = getImage();
	
	// Export the standard WebGL types
	exports.Image = Image;
	exports.WebGLRenderingContext = WebGLRenderingContext;
	exports.WebGLProgram = WebGLProgram;
	exports.WebGLShader = WebGLShader;
	exports.WebGLBuffer = WebGLBuffer;
	exports.WebGLFramebuffer = WebGLFramebuffer;
	exports.WebGLRenderbuffer = WebGLRenderbuffer;
	exports.WebGLTexture = WebGLTexture;
	exports.WebGLUniformLocation = WebGLUniformLocation;
	exports.WebGLActiveInfo = WebGLActiveInfo;
	exports.WebGLShaderPrecisionFormat = WebGLShaderPrecisionFormat;
	exports.WebGL2RenderingContext = WebGL2RenderingContext;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.BarDefaultProps = exports.BarPropTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noop = __webpack_require__(107);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _BarItem = __webpack_require__(1077);
	
	var _BarItem2 = _interopRequireDefault(_BarItem);
	
	var _props = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BarPropTypes = exports.BarPropTypes = _extends({
	    // data
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    indexBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getIndex: _propTypes2.default.func.isRequired, // computed
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	
	    groupMode: _propTypes2.default.oneOf(['stacked', 'grouped']).isRequired,
	    layout: _propTypes2.default.oneOf(['horizontal', 'vertical']).isRequired,
	    reverse: _propTypes2.default.bool.isRequired,
	
	    minValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]).isRequired,
	    maxValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]).isRequired,
	    padding: _propTypes2.default.number.isRequired,
	    innerPadding: _propTypes2.default.number.isRequired,
	
	    // axes & grid
	    axisTop: _propTypes2.default.object,
	    axisRight: _propTypes2.default.object,
	    axisBottom: _propTypes2.default.object,
	    axisLeft: _propTypes2.default.object,
	    enableGridX: _propTypes2.default.bool.isRequired,
	    enableGridY: _propTypes2.default.bool.isRequired,
	
	    // customization
	    barComponent: _propTypes2.default.func.isRequired,
	
	    // labels
	    enableLabel: _propTypes2.default.bool.isRequired,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    labelFormat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    getLabel: _propTypes2.default.func.isRequired, // computed
	    labelSkipWidth: _propTypes2.default.number.isRequired,
	    labelSkipHeight: _propTypes2.default.number.isRequired,
	    labelTextColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getLabelTextColor: _propTypes2.default.func.isRequired, // computed
	    labelLinkColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getLabelLinkColor: _propTypes2.default.func.isRequired, // computed
	
	    // styling
	    borderRadius: _propTypes2.default.number.isRequired,
	    getColor: _propTypes2.default.func.isRequired }, _props.defsPropTypes, {
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.any.isRequired,
	    getBorderColor: _propTypes2.default.func.isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	    // canvas specific
	    pixelRatio: _propTypes2.default.number.isRequired
	});
	
	var BarDefaultProps = exports.BarDefaultProps = {
	    indexBy: 'id',
	    keys: ['value'],
	
	    groupMode: 'stacked',
	    layout: 'vertical',
	    reverse: false,
	
	    minValue: 'auto',
	    maxValue: 'auto',
	    padding: 0.1,
	    innerPadding: 0,
	
	    // axes & grid
	    axisBottom: {},
	    axisLeft: {},
	    enableGridX: false,
	    enableGridY: true,
	
	    // customization
	    barComponent: _BarItem2.default,
	
	    // labels
	    enableLabel: true,
	    label: 'value',
	    labelSkipWidth: 0,
	    labelSkipHeight: 0,
	    labelLinkColor: 'theme',
	    labelTextColor: 'theme',
	
	    defs: [],
	    fill: [],
	    borderRadius: 0,
	    borderWidth: 0,
	    borderColor: 'inherit',
	
	    // interactivity
	    isInteractive: true,
	    onClick: _noop2.default,
	
	    // canvas specific
	    pixelRatio: global.window && global.window.devicePixelRatio ? global.window.devicePixelRatio : 1
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.ChordDefaultProps = exports.ChordPropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChordPropTypes = exports.ChordPropTypes = {
	    matrix: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.number)).isRequired,
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	
	    padAngle: _propTypes2.default.number.isRequired,
	    innerRadiusRatio: _propTypes2.default.number.isRequired,
	    innerRadiusOffset: _propTypes2.default.number.isRequired,
	
	    // arcs
	    arcOpacity: _propTypes2.default.number.isRequired,
	    arcBorderWidth: _propTypes2.default.number.isRequired,
	    arcBorderColor: _propTypes2.default.any.isRequired,
	    getArcBorderColor: _propTypes2.default.func.isRequired,
	
	    // ribbons
	    ribbonOpacity: _propTypes2.default.number.isRequired,
	    ribbonBorderWidth: _propTypes2.default.number.isRequired,
	    ribbonBorderColor: _propTypes2.default.any.isRequired,
	    getRibbonBorderColor: _propTypes2.default.func.isRequired,
	
	    // labels
	    enableLabel: _propTypes2.default.bool.isRequired,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getLabel: _propTypes2.default.func.isRequired, // computed
	    labelOffset: _propTypes2.default.number.isRequired,
	    labelRotation: _propTypes2.default.number.isRequired,
	    labelTextColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getLabelTextColor: _propTypes2.default.func.isRequired, // computed
	
	    // colors
	    colors: _propTypes2.default.any.isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool.isRequired,
	    arcHoverOpacity: _propTypes2.default.number.isRequired,
	    arcHoverOthersOpacity: _propTypes2.default.number.isRequired,
	    ribbonHoverOpacity: _propTypes2.default.number.isRequired,
	    ribbonHoverOthersOpacity: _propTypes2.default.number.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	    // canvas specific
	    pixelRatio: _propTypes2.default.number.isRequired
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	var ChordDefaultProps = exports.ChordDefaultProps = {
	    padAngle: 0,
	    innerRadiusRatio: 0.9,
	    innerRadiusOffset: 0,
	
	    // arcs
	    arcOpacity: 1,
	    arcBorderWidth: 1,
	    arcBorderColor: 'inherit:darker(0.4)',
	
	    // ribbons
	    ribbonOpacity: 0.5,
	    ribbonBorderWidth: 1,
	    ribbonBorderColor: 'inherit:darker(0.4)',
	
	    // labels
	    enableLabel: true,
	    label: 'id',
	    labelOffset: 12,
	    labelRotation: 0,
	    labelTextColor: 'inherit:darker(1)',
	
	    // colors
	    colors: 'nivo',
	
	    // interactivity
	    isInteractive: true,
	    arcHoverOpacity: 1,
	    arcHoverOthersOpacity: 0.15,
	    ribbonHoverOpacity: 0.85,
	    ribbonHoverOthersOpacity: 0.15,
	
	    // canvas specific
	    pixelRatio: global.window && global.window.devicePixelRatio ? global.window.devicePixelRatio : 1
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.HeatMapDefaultProps = exports.HeatMapPropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _props = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var HeatMapPropTypes = exports.HeatMapPropTypes = {
	    // data
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    indexBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getIndex: _propTypes2.default.func.isRequired, // computed
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	
	    minValue: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto']), _propTypes2.default.number]).isRequired,
	    maxValue: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto']), _propTypes2.default.number]).isRequired,
	
	    forceSquare: _propTypes2.default.bool.isRequired,
	    sizeVariation: _propTypes2.default.number.isRequired,
	    padding: _propTypes2.default.number.isRequired,
	
	    // cells
	    cellShape: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['rect', 'circle']), _propTypes2.default.func]).isRequired,
	    cellOpacity: _propTypes2.default.number.isRequired,
	    cellBorderWidth: _propTypes2.default.number.isRequired,
	    cellBorderColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getCellBorderColor: _propTypes2.default.func.isRequired, // computed
	
	    // axes & grid
	    axisTop: _propTypes2.default.object,
	    axisRight: _propTypes2.default.object,
	    axisBottom: _propTypes2.default.object,
	    axisLeft: _propTypes2.default.object,
	    enableGridX: _propTypes2.default.bool.isRequired,
	    enableGridY: _propTypes2.default.bool.isRequired,
	
	    // labels
	    enableLabels: _propTypes2.default.bool.isRequired,
	    labelTextColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getLabelTextColor: _propTypes2.default.func.isRequired, // computed
	
	    // theming
	    colors: _props.quantizeColorScalePropType.isRequired,
	    colorScale: _propTypes2.default.func.isRequired, // computed
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool,
	    hoverTarget: _propTypes2.default.oneOf(['cell', 'row', 'column', 'rowColumn']).isRequired,
	    cellHoverOpacity: _propTypes2.default.number.isRequired,
	    cellHoverOthersOpacity: _propTypes2.default.number.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	    // canvas specific
	    pixelRatio: _propTypes2.default.number.isRequired
	};
	
	var HeatMapDefaultProps = exports.HeatMapDefaultProps = {
	    indexBy: 'id',
	
	    minValue: 'auto',
	    maxValue: 'auto',
	
	    forceSquare: false,
	    sizeVariation: 0,
	    padding: 0,
	
	    // cells
	    cellShape: 'rect',
	    cellOpacity: 0.85,
	    cellBorderWidth: 0,
	    cellBorderColor: 'inherit',
	
	    // axes & grid
	    axisTop: {},
	    axisLeft: {},
	    enableGridX: false,
	    enableGridY: false,
	
	    // labels
	    enableLabels: true,
	    labelTextColor: 'inherit:darker(1.4)',
	
	    // theming
	    colors: 'nivo',
	
	    // interactivity
	    isInteractive: true,
	    hoverTarget: 'rowColumn',
	    cellHoverOpacity: 1,
	    cellHoverOthersOpacity: 0.35,
	
	    // canvas specific
	    pixelRatio: global.window && global.window.devicePixelRatio ? global.window.devicePixelRatio : 1
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tableStyle = {
	    width: '100%',
	    borderCollapse: 'collapse'
	};
	
	var TableTooltip = function TableTooltip(_ref) {
	    var title = _ref.title,
	        rows = _ref.rows,
	        theme = _ref.theme;
	
	    if (!rows.length) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { style: theme.tooltip.container },
	        title && title,
	        _react2.default.createElement(
	            'table',
	            { style: _extends({}, tableStyle, theme.tooltip.table) },
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rows.map(function (row, i) {
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        row.map(function (column, j) {
	                            return _react2.default.createElement(
	                                'td',
	                                { key: j, style: theme.tooltip.tableCell },
	                                column
	                            );
	                        })
	                    );
	                })
	            )
	        )
	    );
	};
	
	TableTooltip.propTypes = {
	    title: _propTypes2.default.node,
	    rows: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.node)).isRequired,
	    theme: _propTypes2.default.shape({
	        tooltip: _propTypes2.default.shape({
	            container: _propTypes2.default.object.isRequired,
	            table: _propTypes2.default.object.isRequired,
	            tableCell: _propTypes2.default.object.isRequired
	        }).isRequired
	    }).isRequired
	};
	
	TableTooltip.defaultProps = {};
	
	exports.default = (0, _pure2.default)(TableTooltip);

/***/ },
/* 223 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var DIRECTION_HORIZONTAL = exports.DIRECTION_HORIZONTAL = 'horizontal';
	var DIRECTION_VERTICAL = exports.DIRECTION_VERTICAL = 'vertical';

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _detect = __webpack_require__(1174);
	
	Object.keys(_detect).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _detect[key];
	    }
	  });
	});
	var getRelativeCursor = exports.getRelativeCursor = function getRelativeCursor(el, event) {
	  var pageX = event.pageX,
	      pageY = event.pageY;
	
	  var bounds = el.getBoundingClientRect();
	
	  return [pageX - bounds.left, pageY - bounds.top];
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 225 */
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var EventPluginRegistry = __webpack_require__(318);
	var ReactEventEmitterMixin = __webpack_require__(1235);
	var ViewportMetrics = __webpack_require__(559);
	
	var getVendorPrefixedEventName = __webpack_require__(1266);
	var isEventSupported = __webpack_require__(330);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(172);
	var ViewportMetrics = __webpack_require__(559);
	
	var getEventModifierState = __webpack_require__(327);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(4);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 229 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	var DOMNamespaces = __webpack_require__(317);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(325);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 231 */
225,
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = undefined;
	
	var _intersection2 = __webpack_require__(1017);
	
	var _intersection3 = _interopRequireDefault(_intersection2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = exports.getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection3.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	var identity = exports.identity = function identity(param) {
	  return param;
	};
	
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	var getDashCase = exports.getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return '-' + v.toLowerCase();
	  });
	};
	
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, IN_LINE_PREFIX_LIST[i] + '$1');
	    }
	
	    return _extends({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	var log = exports.log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	var debug = exports.debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	
	    return item;
	  };
	};
	
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	var debugf = exports.debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(undefined, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = '(' + args.map(JSON.stringify).join(', ') + ')';
	
	    log(name + ': ' + argNames + ' => ' + JSON.stringify(res));
	
	    return res;
	  };
	};
	
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	var mapObject = exports.mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	var translateStyle = exports.translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _extends({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	var compose = exports.compose = function compose() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var getTransitionVal = exports.getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return getDashCase(prop) + ' ' + duration + 'ms ' + easing;
	  }).join(',');
	};
	
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(120)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant$1 = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$1(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = Math.abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * Math.sin(ap)),
	            p1 = asin(rp / r1 * Math.sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * Math.cos(a01),
	          y01 = r1 * Math.sin(a01),
	          x10 = r0 * Math.cos(a10),
	          y10 = r0 * Math.sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * Math.cos(a11),
	            y11 = r1 * Math.sin(a11),
	            x00 = r0 * Math.cos(a00),
	            y00 = r0 * Math.sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [Math.cos(a) * r, Math.sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant$1(0),
	      y1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant$1(0),
	      endAngle = constant$1(tau),
	      padAngle = constant$1(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$1(circle),
	      size = constant$1(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var slice = Array.prototype.slice;
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (var j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$1([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Render a group of error bar
	                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorBar = (_temp = _class = function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, (ErrorBar.__proto__ || Object.getPrototypeOf(ErrorBar)).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: 'renderErrorBars',
	    value: function renderErrorBars() {
	      var _props = this.props,
	          offset = _props.offset,
	          layout = _props.layout,
	          width = _props.width,
	          dataKey = _props.dataKey,
	          data = _props.data,
	          dataPointFormatter = _props.dataPointFormatter,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          others = _objectWithoutProperties(_props, ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis']);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid = void 0,
	            yMid = void 0,
	            xMin = void 0,
	            yMin = void 0,
	            xMax = void 0,
	            yMax = void 0,
	            scale = void 0,
	            coordsTop = void 0,
	            coordsMid = void 0,
	            coordsBot = void 0,
	            lowBound = void 0,
	            highBound = void 0;
	
	        if (Array.isArray(errorVal)) {
	          lowBound = errorVal[0];
	          highBound = errorVal[1];
	        } else {
	          lowBound = errorVal;
	          highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = { x1: xMax, y1: yMin, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMin, y1: yMid, x2: xMax, y2: yMid };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMin, y2: yMax };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = { x1: xMin, y1: yMax, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMid, y1: yMin, x2: xMid, y2: yMax };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMax, y2: yMin };
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({ className: 'recharts-errorBar', key: i }, props),
	          _react2.default.createElement('line', coordsTop),
	          ';',
	          _react2.default.createElement('line', coordsMid),
	          ';',
	          _react2.default.createElement('line', coordsBot),
	          ';'
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-errorBars' },
	        this.renderErrorBars()
	      );
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component), _class.propTypes = {
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  data: _propTypes2.default.array,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  layout: _propTypes2.default.string,
	  dataPointFormatter: _propTypes2.default.func,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  offset: _propTypes2.default.number
	}, _class.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	}, _temp);
	exports.default = ErrorBar;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DataUtils = __webpack_require__(14);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceArea = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceArea, _Component);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, (ReferenceArea.__proto__ || Object.getPrototypeOf(ReferenceArea)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: 'getRect',
	    value: function getRect(hasX, hasY) {
	      var _props = this.props,
	          xValue1 = _props.x1,
	          xValue2 = _props.x2,
	          yValue1 = _props.y1,
	          yValue2 = _props.y2,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var xOffset = xScale.bandwidth ? xScale.bandwidth() / 2 : 0;
	      var yOffset = yScale.bandwidth ? yScale.bandwidth() / 2 : 0;
	      var xRange = xScale.range();
	      var yRange = yScale.range();
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0;
	
	      if (hasX && (0, _DataUtils.isNumOrStr)(xValue1)) {
	        x1 = xScale(xValue1) + xOffset;
	      } else if (hasY) {
	        x1 = xRange[0];
	      }
	      if (hasX && (0, _DataUtils.isNumOrStr)(xValue2)) {
	        x2 = xScale(xValue2) + xOffset;
	      } else if (hasY) {
	        x2 = xRange[1];
	      }
	      if (hasY && (0, _DataUtils.isNumOrStr)(yValue1)) {
	        y1 = yScale(yValue1) + yOffset;
	      } else if (hasX) {
	        y1 = yRange[0];
	      }
	      if (hasY && (0, _DataUtils.isNumOrStr)(yValue2)) {
	        y2 = yScale(yValue2) + yOffset;
	      } else if (hasX) {
	        y2 = yRange[1];
	      }
	
	      if ((0, _DataUtils.validateCoordinateInRange)(x1, xScale) && (0, _DataUtils.validateCoordinateInRange)(x2, xScale) && (0, _DataUtils.validateCoordinateInRange)(y1, yScale) && (0, _DataUtils.validateCoordinateInRange)(y2, yScale)) {
	        return {
	          x: Math.min(x1, x2),
	          y: Math.min(y1, y2),
	          width: Math.abs(x2 - x1),
	          height: Math.abs(y2 - y1)
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(_ref) {
	      var x = _ref.x,
	          y = _ref.y,
	          width = _ref.width,
	          height = _ref.height;
	      var _props2 = this.props,
	          label = _props2.label,
	          stroke = _props2.stroke;
	
	      var props = _extends({}, label, {
	        stroke: 'none',
	        fill: stroke,
	        x: x + width / 2,
	        y: y + height / 2,
	        textAnchor: 'middle'
	      });
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-reference-area-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderRect',
	    value: function renderRect(option, props) {
	      var rect = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rect = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rect = option(props);
	      } else {
	        rect = _react2.default.createElement(_Rectangle2.default, _extends({}, props, {
	          className: 'recharts-reference-area-rect'
	        }));
	      }
	
	      return rect;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          x1 = _props3.x1,
	          x2 = _props3.x2,
	          y1 = _props3.y1,
	          y2 = _props3.y2;
	
	      var hasX = (0, _DataUtils.isNumOrStr)(x1) && (0, _DataUtils.isNumOrStr)(x2);
	      var hasY = (0, _DataUtils.isNumOrStr)(y1) && (0, _DataUtils.isNumOrStr)(y2);
	
	      if (!hasX && !hasY) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX, hasY);
	
	      if (!rect) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-reference-area' },
	        this.renderRect(shape, _extends({}, this.props, rect)),
	        this.renderLabel(rect)
	      );
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.Component), _class2.displayName = 'ReferenceArea', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  x2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceArea;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Dot = __webpack_require__(97);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceDot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceDot, _Component);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, (ReferenceDot.__proto__ || Object.getPrototypeOf(ReferenceDot)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: 'getCoordinate',
	    value: function getCoordinate() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var result = {
	        cx: xScale(x) + (xScale.bandwidth ? xScale.bandwidth() / 2 : 0),
	        cy: yScale(y) + (yScale.bandwidth ? yScale.bandwidth() / 2 : 0)
	      };
	
	      if ((0, _DataUtils.validateCoordinateInRange)(result.cx, xScale) && (0, _DataUtils.validateCoordinateInRange)(result.cy, yScale)) {
	        return result;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(coordinate) {
	      var _props2 = this.props,
	          label = _props2.label,
	          stroke = _props2.stroke;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(label), {
	        stroke: 'none',
	        fill: stroke,
	        x: coordinate.cx,
	        y: coordinate.cy,
	        textAnchor: 'middle',
	        verticalAnchor: 'middle'
	      });
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-reference-dot-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderDot',
	    value: function renderDot(option, props) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: 'recharts-reference-dot-dot'
	        }));
	      }
	
	      return dot;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          x = _props3.x,
	          y = _props3.y;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	
	
	      var dotProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), coordinate);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-reference-dot' },
	        this.renderDot(shape, dotProps),
	        this.renderLabel(coordinate)
	      );
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.Component), _class2.displayName = 'ReferenceDot', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes2.default.number,
	
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	
	  xAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	  yAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceDot;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Reference Line
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderLine = function renderLine(option, props) {
	  var line = void 0;
	
	  if (_react2.default.isValidElement(option)) {
	    line = _react2.default.cloneElement(option, props);
	  } else if ((0, _isFunction3.default)(option)) {
	    line = option(props);
	  } else {
	    line = _react2.default.createElement('line', _extends({}, props, {
	      className: 'recharts-reference-line-line'
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceLine, _Component);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, (ReferenceLine.__proto__ || Object.getPrototypeOf(ReferenceLine)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: 'getEndPoints',
	    value: function getEndPoints(isX, isY) {
	      var _props = this.props,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          viewBox = _props.viewBox;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	
	      if (isY) {
	        var value = this.props.y;
	        var scale = yAxis.scale;
	
	        var offset = scale.bandwidth ? scale.bandwidth() / 2 : 0;
	        var coord = scale(value) + offset;
	
	        if ((0, _DataUtils.validateCoordinateInRange)(coord, scale)) {
	          return yAxis.orientation === 'left' ? [{ x: x, y: coord }, { x: x + width, y: coord }] : [{ x: x + width, y: coord }, { x: x, y: coord }];
	        }
	      } else if (isX) {
	        var _value = this.props.x;
	        var _scale = xAxis.scale;
	
	        var _offset = _scale.bandwidth ? _scale.bandwidth() / 2 : 0;
	        var _coord = _scale(_value) + _offset;
	
	        if ((0, _DataUtils.validateCoordinateInRange)(_coord, _scale)) {
	          return xAxis.orientation === 'top' ? [{ x: _coord, y: y }, { x: _coord, y: y + height }] : [{ x: _coord, y: y + height }, { x: _coord, y: y }];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getLabelProps',
	    value: function getLabelProps(isX, isY) {
	      var _props2 = this.props,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          labelPosition = _props2.labelPosition;
	
	
	      if (isY) {
	        var axis = yAxis;
	
	        if (axis.orientation === 'left' && labelPosition === 'end') {
	          return { dx: 6, dy: 6, textAnchor: 'start' };
	        }
	        if (axis.orientation === 'right' && labelPosition === 'start') {
	          return { dx: 6, dy: 6, textAnchor: 'start' };
	        }
	        return { dx: -6, dy: 6, textAnchor: 'end' };
	      } else if (isX) {
	        var _axis = xAxis;
	
	        if (_axis.orientation === 'top') {
	          return { dy: 6, textAnchor: 'middle' };
	        }
	        return { dy: -6, textAnchor: 'middle' };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(isX, isY, end) {
	      var _props3 = this.props,
	          label = _props3.label,
	          stroke = _props3.stroke;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(label), {
	        stroke: 'none',
	        fill: stroke
	      }, end, this.getLabelProps(isX, isY));
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-reference-line-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          x = _props4.x,
	          y = _props4.y,
	          labelPosition = _props4.labelPosition,
	          shape = _props4.shape;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX && !isY) {
	        return null;
	      }
	
	      var endPoints = this.getEndPoints(isX, isY);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          start = _endPoints[0],
	          end = _endPoints[1];
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: start.x,
	        y1: start.y,
	        x2: end.x,
	        y2: end.y
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-reference-line' },
	        renderLine(shape, props),
	        this.renderLabel(isX, isY, labelPosition === 'start' ? start : end)
	      );
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.Component), _class2.displayName = 'ReferenceLine', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  labelPosition: _propTypes2.default.oneOf(['start', 'end']),
	  shape: _propTypes2.default.func
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1,
	  labelPosition: 'end'
	}, _temp)) || _class;
	
	exports.default = ReferenceLine;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortBy2 = __webpack_require__(78);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _throttle2 = __webpack_require__(159);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(88);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Legend = __webpack_require__(116);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _LogUtils = __webpack_require__(362);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _CartesianAxis = __webpack_require__(354);
	
	var _CartesianAxis2 = _interopRequireDefault(_CartesianAxis);
	
	var _CartesianGrid = __webpack_require__(355);
	
	var _CartesianGrid2 = _interopRequireDefault(_CartesianGrid);
	
	var _ReferenceLine = __webpack_require__(237);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceDot = __webpack_require__(236);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceArea = __webpack_require__(235);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _XAxis = __webpack_require__(357);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(358);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _Brush = __webpack_require__(607);
	
	var _Brush2 = _interopRequireDefault(_Brush);
	
	var _DOMUtils = __webpack_require__(178);
	
	var _DataUtils = __webpack_require__(14);
	
	var _CartesianUtils = __webpack_require__(239);
	
	var _PureRender = __webpack_require__(10);
	
	var _Events = __webpack_require__(1412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	
	var originCoordinate = { x: 0, y: 0 };
	
	var generateCategoricalChart = function generateCategoricalChart(ChartComponent, GraphicalChild) {
	  var _class, _temp;
	
	  var CategoricalChartWrapper = (_temp = _class = function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    function CategoricalChartWrapper(props) {
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      var _this = _possibleConstructorReturn(this, (CategoricalChartWrapper.__proto__ || Object.getPrototypeOf(CategoricalChartWrapper)).call(this, props));
	
	      _this.handleLegendBBoxUpdate = function (box) {
	        if (box && _this.legendInstance) {
	          var _this$state = _this.state,
	              dataStartIndex = _this$state.dataStartIndex,
	              dataEndIndex = _this$state.dataEndIndex;
	
	
	          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
	            props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
	          }));
	        }
	      };
	
	      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
	        var _this$props = _this.props,
	            syncId = _this$props.syncId,
	            layout = _this$props.layout;
	
	
	        if (syncId === cId && chartId !== _this.uniqueChartId) {
	          var dataStartIndex = data.dataStartIndex,
	              dataEndIndex = data.dataEndIndex;
	
	
	          if (!(0, _isNil3.default)(data.dataStartIndex) || !(0, _isNil3.default)(data.dataEndIndex)) {
	            _this.setState(_extends({
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex })));
	          } else if (!(0, _isNil3.default)(data.activeTooltipIndex)) {
	            var chartX = data.chartX,
	                chartY = data.chartY,
	                activeTooltipIndex = data.activeTooltipIndex;
	            var _this$state2 = _this.state,
	                offset = _this$state2.offset,
	                tooltipTicks = _this$state2.tooltipTicks;
	
	            if (!offset) {
	              return;
	            }
	            var viewBox = _extends({}, offset, { x: offset.left, y: offset.top });
	            // When a categotical chart is combined with another chart, the value of chartX
	            // and chartY may beyond the boundaries.
	            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	            var activePayload = _this.getTooltipContent(activeTooltipIndex);
	            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	            } : originCoordinate;
	
	            _this.setState(_extends({}, data, { activeLabel: activeLabel, activeCoordinate: activeCoordinate, activePayload: activePayload }));
	          } else {
	            _this.setState(data);
	          }
	        }
	      };
	
	      _this.handleBrushChange = function (_ref) {
	        var startIndex = _ref.startIndex,
	            endIndex = _ref.endIndex;
	
	        // Only trigger changes if the extents of the brush have actually changed
	        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
	          _this.setState(_extends({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: startIndex, dataEndIndex: endIndex })));
	
	          _this.triggerSyncEvent({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          });
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        var mouse = _this.getMouseInfo(e);
	
	        if (mouse) {
	          var nextState = _extends({}, mouse, { isTooltipActive: true });
	          _this.setState(nextState);
	          _this.triggerSyncEvent(nextState);
	
	          if ((0, _isFunction3.default)(onMouseEnter)) {
	            onMouseEnter(nextState, e);
	          }
	        }
	      };
	
	      _this.triggeredAfterMouseMove = function (e) {
	        var onMouseMove = _this.props.onMouseMove;
	
	        var mouse = _this.getMouseInfo(e);
	        var nextState = mouse ? _extends({}, mouse, { isTooltipActive: true }) : { isTooltipActive: false };
	
	        _this.setState(nextState);
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction3.default)(onMouseMove)) {
	          onMouseMove(nextState, e);
	        }
	      };
	
	      _this.handleMouseMove = function (e) {
	        if (e && (0, _isFunction3.default)(e.persist)) {
	          e.persist();
	          _this.triggeredAfterMouseMove(e);
	        }
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	
	        var nextState = { isTooltipActive: false };
	
	        _this.setState(nextState);
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction3.default)(onMouseLeave)) {
	          onMouseLeave(nextState, e);
	        }
	      };
	
	      _this.handleClick = function (e) {
	        var onClick = _this.props.onClick;
	
	
	        if ((0, _isFunction3.default)(onClick)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onClick(mouse, e);
	        }
	      };
	
	      _this.handleMouseDown = function (e) {
	        var onMouseDown = _this.props.onMouseDown;
	
	
	        if ((0, _isFunction3.default)(onMouseDown)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseDown(mouse, e);
	        }
	      };
	
	      _this.handleMouseUp = function (e) {
	        var onMouseUp = _this.props.onMouseUp;
	
	
	        if ((0, _isFunction3.default)(onMouseUp)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseUp(mouse, e);
	        }
	      };
	
	      _this.handleTouchMove = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseMove(e.changedTouches[0]);
	        }
	      };
	
	      _this.verticalCoordinatesGenerator = function (_ref2) {
	        var xAxis = _ref2.xAxis,
	            width = _ref2.width,
	            height = _ref2.height,
	            offset = _ref2.offset;
	        return (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, xAxis, {
	          ticks: (0, _CartesianUtils.getTicksOfAxis)(xAxis, true),
	          viewBox: { x: 0, y: 0, width: width, height: height }
	        })), offset.left, offset.left + offset.width);
	      };
	
	      _this.horizontalCoordinatesGenerator = function (_ref3) {
	        var yAxis = _ref3.yAxis,
	            width = _ref3.width,
	            height = _ref3.height,
	            offset = _ref3.offset;
	        return (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, yAxis, {
	          ticks: (0, _CartesianUtils.getTicksOfAxis)(yAxis, true),
	          viewBox: { x: 0, y: 0, width: width, height: height }
	        })), offset.top, offset.top + offset.height);
	      };
	
	      _this.axesTicksGenerator = function (axis) {
	        return (0, _CartesianUtils.getTicksOfAxis)(axis, true);
	      };
	
	      _this.tooltipTicksGenerator = function (_ref4) {
	        var layout = _ref4.layout,
	            xAxisMap = _ref4.xAxisMap,
	            yAxisMap = _ref4.yAxisMap;
	
	        var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
	        var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	        var tooltipTicks = (0, _CartesianUtils.getTicksOfAxis)(axis, false, true);
	
	        return {
	          tooltipTicks: tooltipTicks,
	          orderedTooltipTicks: (0, _sortBy3.default)(tooltipTicks, function (o) {
	            return o.coordinate;
	          }),
	          tooltipAxis: axis
	        };
	      };
	
	      var defaultState = _this.createDefaultState(props);
	      _this.state = _extends({}, defaultState, { updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: props }, defaultState)));
	      _this.validateAxes();
	      _this.uniqueChartId = (0, _DataUtils.uniqueId)('recharts');
	
	      if (props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle3.default)(_this.triggeredAfterMouseMove, props.throttleDelay);
	      }
	      return _this;
	    }
	
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.addListener();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            data = _props.data,
	            children = _props.children,
	            width = _props.width,
	            height = _props.height,
	            layout = _props.layout,
	            stackOffset = _props.stackOffset,
	            margin = _props.margin;
	
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _PureRender.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.createDefaultState(nextProps);
	          this.setState(_extends({}, defaultState, { updateId: this.state.updateId + 1
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, defaultState))));
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          var _state = this.state,
	              dataStartIndex = _state.dataStartIndex,
	              dataEndIndex = _state.dataEndIndex;
	          // Don't update brush
	
	          var _defaultState = _extends({}, this.createDefaultState(nextProps), { dataEndIndex: dataEndIndex, dataStartIndex: dataStartIndex
	          });
	          this.setState(_extends({}, _defaultState, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, _defaultState))));
	        }
	        // add syncId
	        if ((0, _isNil3.default)(this.props.syncId) && !(0, _isNil3.default)(nextProps.syncId)) {
	          this.addListener();
	        }
	        // remove syncId
	        if (!(0, _isNil3.default)(this.props.syncId) && (0, _isNil3.default)(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.removeListener();
	        }
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: 'getAxisMap',
	      value: function getAxisMap(props, _ref5) {
	        var _ref5$axisType = _ref5.axisType,
	            axisType = _ref5$axisType === undefined ? 'xAxis' : _ref5$axisType,
	            graphicalItems = _ref5.graphicalItems,
	            stackGroups = _ref5.stackGroups,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex;
	        var children = props.children;
	
	        var Axis = axisType === 'xAxis' ? _XAxis2.default : _YAxis2.default;
	        var axisIdKey = axisType === 'xAxis' ? 'xAxisId' : 'yAxisId';
	        // Get all the instance of Axis
	        var axes = (0, _ReactUtils.findAllByType)(children, Axis);
	
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, { axes: axes, graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey,
	            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, { graphicalItems: graphicalItems, Axis: Axis, axisType: axisType, axisIdKey: axisIdKey,
	            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        }
	
	        return axisMap;
	      }
	
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByAxes',
	      value: function getAxisMapByAxes(props, _ref6) {
	        var axes = _ref6.axes,
	            graphicalItems = _ref6.graphicalItems,
	            axisType = _ref6.axisType,
	            axisIdKey = _ref6.axisIdKey,
	            stackGroups = _ref6.stackGroups,
	            dataStartIndex = _ref6.dataStartIndex,
	            dataEndIndex = _ref6.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            data = props.data,
	            stackOffset = props.stackOffset;
	
	        var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
	        var len = displayedData.length;
	        var isCategorial = (0, _CartesianUtils.isCategorialAxis)(layout, axisType);
	
	        // Eliminate duplicated axes
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              scale = _child$props.scale;
	
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            var domain = void 0,
	                duplicateDomain = void 0,
	                categoricalDomain = void 0;
	
	            if (dataKey) {
	              domain = (0, _CartesianUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	                duplicateDomain = duplicate ? domain : null;
	
	                // When category axis has duplicated text, serial numbers are used to generate scale
	                domain = duplicate ? (0, _range3.default)(0, len) : domain;
	              } else if (type === 'category') {
	                // eliminate undefined or null or empty string
	                domain = domain.filter(function (entry) {
	                  return entry !== '' && !(0, _isNil3.default)(entry);
	                });
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _CartesianUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _CartesianUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _CartesianUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (entry) {
	                return entry.props[axisIdKey] === axisId;
	              }), type, true);
	            }
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _CartesianUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	
	              if (child.props.domain) {
	                domain = (0, _DataUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByItems',
	      value: function getAxisMapByItems(props, _ref7) {
	        var graphicalItems = _ref7.graphicalItems,
	            Axis = _ref7.Axis,
	            axisType = _ref7.axisType,
	            axisIdKey = _ref7.axisIdKey,
	            stackGroups = _ref7.stackGroups,
	            dataStartIndex = _ref7.dataStartIndex,
	            dataEndIndex = _ref7.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            data = props.data;
	
	        var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
	        var len = displayedData.length;
	        var isCategorial = (0, _CartesianUtils.isCategorialAxis)(layout, axisType);
	        var index = -1;
	
	        // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain = void 0;
	
	            if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _CartesianUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _CartesianUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _DataUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _CartesianUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (entry) {
	                return entry.props[axisIdKey] === axisId;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _CartesianUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial
	            })));
	          }
	
	          return result;
	        }, {});
	
	        return axisMap;
	      }
	      /**
	       * Calculate the scale function, position, width, height of axes
	       * @param  {Object} props    Latest props
	       * @param  {Object} axisMap  The configuration of axes
	       * @param  {Object} offset   The offset of main part in the svg element
	       * @param  {Object} axisType The type of axes, x-axis or y-axis
	       * @return {Object} Configuration
	       */
	
	    }, {
	      key: 'getFormatAxisMap',
	      value: function getFormatAxisMap(props, axisMap, offset, axisType) {
	        var width = props.width,
	            height = props.height,
	            layout = props.layout;
	
	        var displayName = this.constructor.displayName;
	        var ids = Object.keys(axisMap);
	        var steps = {
	          left: offset.left,
	          leftMirror: offset.left,
	          right: width - offset.right,
	          rightMirror: width - offset.right,
	          top: offset.top,
	          topMirror: offset.top,
	          bottom: height - offset.bottom,
	          bottomMirror: height - offset.bottom
	        };
	
	        return ids.reduce(function (result, id) {
	          var axis = axisMap[id];
	          var orientation = axis.orientation,
	              domain = axis.domain,
	              _axis$padding = axis.padding,
	              padding = _axis$padding === undefined ? {} : _axis$padding,
	              mirror = axis.mirror,
	              reversed = axis.reversed;
	
	          var offsetKey = '' + orientation + (mirror ? 'Mirror' : '');
	
	          var range = void 0,
	              x = void 0,
	              y = void 0,
	              needSpace = void 0;
	
	          if (axisType === 'xAxis') {
	            range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	          } else {
	            range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	          }
	
	          if (reversed) {
	            range = [range[1], range[0]];
	          }
	
	          var scale = (0, _DataUtils.parseScale)(axis, displayName);
	          scale.domain(domain).range(range);
	          (0, _DataUtils.checkDomainOfScale)(scale);
	          var ticks = (0, _CartesianUtils.getTicksOfScale)(scale, axis);
	
	          if (axisType === 'xAxis') {
	            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	            x = offset.left;
	            y = steps[offsetKey] - needSpace * axis.height;
	          } else {
	            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	            x = steps[offsetKey] - needSpace * axis.width;
	            y = offset.top;
	          }
	
	          var finalAxis = _extends({}, axis, ticks, {
	            range: range, x: x, y: y, scale: scale,
	            width: axisType === 'xAxis' ? offset.width : axis.width,
	            height: axisType === 'yAxis' ? offset.height : axis.height
	          });
	          if (!axis.hide && axisType === 'xAxis') {
	            steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	          } else if (!axis.hide) {
	            steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	          }
	
	          return _extends({}, result, _defineProperty({}, id, finalAxis));
	        }, {});
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: 'getMouseInfo',
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var offset = this.state.offset;
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var isIn = e.chartX >= offset.left && e.chartX <= offset.left + offset.width && e.chartY >= offset.top && e.chartY <= offset.top + offset.height;
	
	        if (!isIn) {
	          return null;
	        }
	
	        var layout = this.props.layout;
	        var _state2 = this.state,
	            ticks = _state2.orderedTooltipTicks,
	            axis = _state2.tooltipAxis,
	            tooltipTicks = _state2.tooltipTicks;
	
	        var pos = layout === 'horizontal' ? e.chartX : e.chartY;
	        var activeIndex = (0, _CartesianUtils.calculateActiveTickIndex)(pos, ticks, axis);
	
	        if (activeIndex >= 0) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex);
	          var activeCoordinate = tooltipTicks[activeIndex] ? {
	            x: layout === 'horizontal' ? tooltipTicks[activeIndex].coordinate : e.chartX,
	            y: layout === 'horizontal' ? e.chartY : tooltipTicks[activeIndex].coordinate
	          } : originCoordinate;
	
	          return _extends({}, e, {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel,
	            activePayload: activePayload,
	            activeCoordinate: activeCoordinate
	          });
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: 'getTooltipContent',
	      value: function getTooltipContent(activeIndex) {
	        var _state3 = this.state,
	            dataStartIndex = _state3.dataStartIndex,
	            dataEndIndex = _state3.dataEndIndex,
	            graphicalItems = _state3.graphicalItems;
	
	        var data = this.props.data.slice(dataStartIndex, dataEndIndex + 1);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= data.length) {
	          return null;
	        }
	
	        return graphicalItems.map(function (child) {
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter;
	
	
	          return _extends({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey, unit: unit, formatter: formatter,
	            name: name || dataKey,
	            color: (0, _CartesianUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _DataUtils.getValueByDataKey)(data[activeIndex], dataKey),
	            payload: data[activeIndex]
	          });
	        });
	      }
	
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex The end index of the data series when a brush is applied
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: 'updateStateOfAxisMapsOffsetAndStackGroups',
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
	        var props = _ref8.props,
	            dataStartIndex = _ref8.dataStartIndex,
	            dataEndIndex = _ref8.dataEndIndex;
	        var data = props.data;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({ props: props }) || !data || !data.length) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset;
	
	        var numericIdName = layout === 'horizontal' ? 'yAxis' : 'xAxis';
	        var cateIdName = layout === 'horizontal' ? 'xAxis' : 'yAxis';
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _CartesianUtils.getStackGroupsByAxisId)(data, graphicalItems, numericIdName + 'Id', cateIdName + 'Id', stackOffset);
	
	        var xAxisMap = this.getAxisMap(props, {
	          axisType: 'xAxis',
	          graphicalItems: graphicalItems,
	          stackGroups: numericIdName === 'xAxis' && stackGroups,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	
	        var yAxisMap = this.getAxisMap(props, {
	          axisType: 'yAxis',
	          graphicalItems: graphicalItems,
	          stackGroups: numericIdName === 'yAxis' && stackGroups,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	
	        var offset = this.calculateOffset(props, graphicalItems, xAxisMap, yAxisMap);
	
	        xAxisMap = this.getFormatAxisMap(props, xAxisMap, offset, 'xAxis');
	        yAxisMap = this.getFormatAxisMap(props, yAxisMap, offset, 'yAxis');
	
	        var ticksObj = this.tooltipTicksGenerator({
	          layout: layout, xAxisMap: xAxisMap, yAxisMap: yAxisMap
	        });
	
	        return _extends({ graphicalItems: graphicalItems, xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset, stackGroups: stackGroups }, ticksObj);
	      }
	
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: 'addListener',
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: 'removeListener',
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Returns default, reset state for the categorical chart.
	       * @param {Object} props Props object to use when creating the default state
	       * @return {Object} Whole new state
	       */
	
	    }, {
	      key: 'createDefaultState',
	      value: function createDefaultState(props) {
	        var children = props.children;
	
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	        var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	        var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	        return {
	          chartX: 0,
	          chartY: 0,
	          dataStartIndex: startIndex,
	          dataEndIndex: endIndex,
	          activeTooltipIndex: -1,
	          isTooltipActive: false
	        };
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: 'calculateOffset',
	      value: function calculateOffset(props, graphicalItems, xAxisMap, yAxisMap) {
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, { left: margin.left || 0, right: margin.right || 0 });
	
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, { top: margin.top || 0, bottom: margin.bottom || 0 });
	
	        var offset = _extends({}, offsetV, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush2.default.defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	          offset = (0, _CartesianUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _extends({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	      /**
	       * The handler of mouse entering chart
	       * @param  {Object} e              Event object
	       * @return {Null}                  null
	       */
	
	
	      /**
	       * The handler of mouse moving in chart
	       * @param  {Object} e        Event object
	       * @return {Null} no return
	       */
	
	      /**
	       * The handler if mouse leaving chart
	       * @param {Object} e Event object
	       * @return {Null} no return
	       */
	
	    }, {
	      key: 'validateAxes',
	      value: function validateAxes() {
	        var _props2 = this.props,
	            layout = _props2.layout,
	            children = _props2.children;
	
	        var xAxes = (0, _ReactUtils.findAllByType)(children, _XAxis2.default);
	        var yAxes = (0, _ReactUtils.findAllByType)(children, _YAxis2.default);
	
	        if (layout === 'horizontal' && xAxes && xAxes.length) {
	          xAxes.forEach(function (axis) {
	            (0, _LogUtils.warn)(axis.props.type === 'category' || axis.props.type === 'number' && !(0, _isNil3.default)(axis.props.dataKey), 'x-axis should be a category axis or a number axis which has specifed dataKey\n             when the layout is horizontal');
	          });
	        } else if (layout === 'vertical') {
	          var displayName = this.constructor.displayName;
	
	          (0, _LogUtils.warn)(yAxes && yAxes.length, 'You should add <YAxis type="number" /> in ' + displayName + '.\n           The layout is vertical now, y-axis should be category axis,\n           but y-axis is number axis when no YAxis is added.');
	          (0, _LogUtils.warn)(xAxes && xAxes.length, 'You should add <XAxis /> in ' + displayName + '.\n          The layout is vertical now, x-axis is category when no XAxis is added.');
	
	          if (yAxes && yAxes.length) {
	            yAxes.forEach(function (axis) {
	              (0, _LogUtils.warn)(axis.props.type === 'category' || axis.props.type === 'number' && !(0, _isNil3.default)(axis.props.dataKey), 'y-axis should be a category axis or a number axis which has specifed dataKey\n               when the layout is vertical');
	            });
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: 'triggerSyncEvent',
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	
	        if (!(0, _isNil3.default)(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: 'renderAxes',
	
	
	      /**
	       * Draw axes
	       * @param {Object} axisMap The configuration of all x-axes or y-axes
	       * @param {String} name    The name of axes
	       * @return {ReactElement}  The instance of x-axes
	       */
	      value: function renderAxes(axisMap, name) {
	        var _props3 = this.props,
	            width = _props3.width,
	            height = _props3.height;
	
	        var ids = axisMap && Object.keys(axisMap);
	
	        if (ids && ids.length) {
	          var axes = [];
	
	          for (var i = 0, len = ids.length; i < len; i++) {
	            var axis = axisMap[ids[i]];
	
	            if (!axis.hide) {
	
	              axes.push(_react2.default.createElement(_CartesianAxis2.default, _extends({}, axis, {
	                key: name + '-' + ids[i],
	                viewBox: { x: 0, y: 0, width: width, height: height },
	                ticksGenerator: this.axesTicksGenerator
	              })));
	            }
	          }
	
	          return axes.length ? _react2.default.createElement(
	            _Layer2.default,
	            { key: name + '-layer', className: 'recharts-' + name },
	            axes
	          ) : null;
	        }
	
	        return null;
	      }
	
	      /**
	       * Draw grid
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: 'renderGrid',
	      value: function renderGrid() {
	        var _state4 = this.state,
	            xAxisMap = _state4.xAxisMap,
	            yAxisMap = _state4.yAxisMap,
	            offset = _state4.offset;
	        var _props4 = this.props,
	            children = _props4.children,
	            width = _props4.width,
	            height = _props4.height;
	
	        var gridItem = (0, _ReactUtils.findChildByType)(children, _CartesianGrid2.default);
	
	        if (!gridItem) {
	          return null;
	        }
	
	        var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	        var yAxis = (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	
	        return _react2.default.cloneElement(gridItem, {
	          key: 'grid',
	          x: offset.left,
	          y: offset.top,
	          width: offset.width,
	          height: offset.height,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          offset: offset,
	          chartWidth: width,
	          chartHeight: height,
	          verticalCoordinatesGenerator: this.verticalCoordinatesGenerator,
	          horizontalCoordinatesGenerator: this.horizontalCoordinatesGenerator
	        });
	      }
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	
	    }, {
	      key: 'renderLegend',
	      value: function renderLegend() {
	        var _this2 = this;
	
	        var graphicalItems = this.state.graphicalItems;
	        var _props5 = this.props,
	            children = _props5.children,
	            width = _props5.width,
	            height = _props5.height;
	
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _CartesianUtils.getLegendProps)(children, graphicalItems, legendWidth, legendHeight);
	
	        if (!props) {
	          return null;
	        }
	
	        return _react2.default.createElement(_Legend2.default, _extends({}, props, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this2.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: 'renderTooltip',
	      value: function renderTooltip() {
	        var children = this.props.children;
	
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _state5 = this.state,
	            isTooltipActive = _state5.isTooltipActive,
	            activeCoordinate = _state5.activeCoordinate,
	            activePayload = _state5.activePayload,
	            activeLabel = _state5.activeLabel,
	            offset = _state5.offset;
	
	
	        return _react2.default.cloneElement(tooltipItem, {
	          viewBox: _extends({}, offset, { x: offset.left, y: offset.top }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: 'renderBrush',
	      value: function renderBrush() {
	        var _props6 = this.props,
	            children = _props6.children,
	            margin = _props6.margin,
	            data = _props6.data;
	        var _state6 = this.state,
	            offset = _state6.offset,
	            dataStartIndex = _state6.dataStartIndex,
	            dataEndIndex = _state6.dataEndIndex,
	            updateId = _state6.updateId;
	
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	
	        if (!brushItem) {
	          return null;
	        }
	
	        // TODO: update brush when children update
	        return _react2.default.cloneElement(brushItem, {
	          onChange: (0, _DataUtils.combineEventHandlers)(this.handleBrushChange, null, brushItem.props.onChange),
	          data: data,
	          x: offset.left,
	          y: offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	          width: offset.width,
	          startIndex: dataStartIndex,
	          endIndex: dataEndIndex,
	          updateId: 'brush-' + updateId
	        });
	      }
	    }, {
	      key: 'renderReferenceElements',
	      value: function renderReferenceElements(isFront, Compt) {
	        var children = this.props.children;
	
	        var elements = (0, _ReactUtils.findAllByType)(children, Compt);
	
	        if (!elements || !elements.length) {
	          return null;
	        }
	
	        var _state7 = this.state,
	            xAxisMap = _state7.xAxisMap,
	            yAxisMap = _state7.yAxisMap,
	            offset = _state7.offset;
	
	        var keyPrefix = (0, _ReactUtils.getDisplayName)(Compt) + '-' + (isFront ? 'front' : 'back');
	
	        return elements.filter(function (entry) {
	          return isFront === entry.props.isFront;
	        }).map(function (entry, i) {
	          var _entry$props = entry.props,
	              xAxisId = _entry$props.xAxisId,
	              yAxisId = _entry$props.yAxisId;
	
	
	          return _react2.default.cloneElement(entry, {
	            key: keyPrefix + '-' + i,
	            xAxis: xAxisMap[xAxisId],
	            yAxis: yAxisMap[yAxisId],
	            viewBox: {
	              x: offset.left,
	              y: offset.top,
	              width: offset.width,
	              height: offset.height
	            }
	          });
	        });
	      }
	    }, {
	      key: 'renderChart',
	      value: function renderChart() {
	        var _props7 = this.props,
	            children = _props7.children,
	            width = _props7.width,
	            height = _props7.height,
	            others = _objectWithoutProperties(_props7, ['children', 'width', 'height']);
	
	        var _state8 = this.state,
	            xAxisMap = _state8.xAxisMap,
	            yAxisMap = _state8.yAxisMap;
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	        return _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderGrid(),
	          this.renderReferenceElements(false, _ReferenceArea2.default),
	          this.renderReferenceElements(false, _ReferenceLine2.default),
	          this.renderReferenceElements(false, _ReferenceDot2.default),
	          this.renderAxes(xAxisMap, 'x-axis'),
	          this.renderAxes(yAxisMap, 'y-axis'),
	          _react2.default.createElement(ChartComponent, _extends({}, this.props, this.state)),
	          this.renderReferenceElements(true, _ReferenceArea2.default),
	          this.renderReferenceElements(true, _ReferenceLine2.default),
	          this.renderReferenceElements(true, _ReferenceDot2.default),
	          this.renderBrush(),
	          (0, _ReactUtils.filterSvgElements)(children)
	        );
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var data = this.props.data;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this) || !data || !data.length) {
	          return null;
	        }
	
	        var _props8 = this.props,
	            className = _props8.className,
	            width = _props8.width,
	            height = _props8.height,
	            style = _props8.style,
	            compact = _props8.compact;
	
	
	        var events = {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onClick: this.handleClick,
	          onMouseDown: this.handleMouseDown,
	          onMouseUp: this.handleMouseUp,
	          onTouchMove: this.handleTouchMove
	        };
	
	        // The "compact" mode is mainly used as the panorama within Brush
	        if (compact) {
	          return this.renderChart();
	        }
	
	        return _react2.default.createElement(
	          'div',
	          _extends({
	            className: (0, _classnames2.default)('recharts-wrapper', className),
	            style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	          }, events, {
	            ref: function ref(node) {
	              _this3.container = node;
	            }
	          }),
	          this.renderChart(),
	          this.renderLegend(),
	          this.renderTooltip()
	        );
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component), _class.displayName = (0, _ReactUtils.getDisplayName)(ChartComponent), _class.propTypes = _extends({}, ChartComponent.propTypes, {
	    syncId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    compact: _propTypes2.default.bool,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes2.default.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes2.default.number,
	    margin: _propTypes2.default.shape({
	      top: _propTypes2.default.number,
	      right: _propTypes2.default.number,
	      bottom: _propTypes2.default.number,
	      left: _propTypes2.default.number
	    }),
	    style: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    onClick: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseMove: _propTypes2.default.func
	  }), _class.defaultProps = {
	    layout: 'horizontal',
	    stackOffset: 'none',
	    margin: { top: 5, right: 5, bottom: 5, left: 5 }
	  }, _temp);
	
	
	  return CategoricalChartWrapper;
	};
	
	exports.default = generateCategoricalChart;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getTicksOfScale = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.getDomainOfStackGroups = exports.getDomainOfDataByKey = exports.calculateDomainOfTicks = exports.getStackedDataOfItem = exports.getStackGroupsByAxisId = exports.getStackedData = exports.detectReferenceElementsDomain = exports.offsetSign = undefined;
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rechartsScale = __webpack_require__(605);
	
	var _d3Shape = __webpack_require__(363);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReferenceDot = __webpack_require__(236);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceLine = __webpack_require__(237);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceArea = __webpack_require__(235);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _Legend = __webpack_require__(116);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-param-reassign: 0 */
	var offsetSign = exports.offsetSign = function offsetSign(series) {
	  var n = series.length;
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = isNaN(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	    }
	  }
	};
	
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var detectReferenceElementsDomain = exports.detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine2.default);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot2.default);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea2.default);
	  var idKey = axisType + 'Id';
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = valueKey + '1';
	    var key2 = valueKey + '2';
	
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	var getStackedData = exports.getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +(0, _DataUtils.getValueByDataKey)(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	
	  return stack(data);
	};
	
	var getStackGroupsByAxisId = exports.getStackGroupsByAxisId = function getStackGroupsByAxisId(data, items, numericAxisId, cateAxisId, offsetType) {
	  var stackGroups = items.reduce(function (result, item) {
	    var stackId = item.props.stackId;
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || { hasStack: false, stackGroups: {} };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: []
	      };
	
	      childGroup.items = [item].concat(childGroup.items);
	
	      parentGroup.hasStack = true;
	
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: [item]
	      };
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	
	        return _extends({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	
	var getStackedDataOfItem = exports.getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	var calculateDomainOfTicks = exports.calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	  }
	
	  return ticks;
	};
	
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	var getDomainOfDataByKey = exports.getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = data.reduce(function (result, entry) {
	    var value = (0, _DataUtils.getValueByDataKey)(entry, key);
	
	    if ((0, _isArray3.default)(value)) {
	      return [].concat(_toConsumableArray(result), _toConsumableArray(value));
	    }
	
	    return [].concat(_toConsumableArray(result), [value]);
	  }, []);
	
	  if (type === 'number') {
	    var domain = flattenData.filter(_DataUtils.isNumber);
	
	    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil3.default)(entry);
	  }) : flattenData;
	
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [Math.min.apply(null, entry.concat([result[0]]).filter(_DataUtils.isNumber)), Math.max.apply(null, entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = exports.getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	var getDomainOfItemsWithSameAxis = exports.getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    return getDomainOfDataByKey(data, item.props.dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {};
	  // Get the union set of category axis
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	
	        result.push(entry[i]);
	      }
	    }
	    return result;
	  }, []);
	};
	
	var isCategorialAxis = exports.isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis';
	};
	/**
	* Calculate the Coordinates of grid
	* @param  {Array} ticks The ticks in axis
	* @param {Number} min   The minimun value of axis
	* @param {Number} max   The maximun value of axis
	* @return {Array}       Coordinates
	*/
	var getCoordinatesOfGrid = exports.getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin = void 0,
	      hasMax = void 0;
	
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	var getTicksOfAxis = exports.getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type;
	
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
	
	  // The ticks setted by user should only affect the ticks adjacent to axis line
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return { coordinate: scale(entry) + offset, value: entry };
	    });
	  }
	
	  // When axis has duplicated text, serial numbers are used to generate scale
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index
	    };
	  });
	};
	
	var calculateActiveTickIndex = exports.calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    for (var i = 0; i < len; i++) {
	      if (i === 0 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i > 0 && i < len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i === len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2) {
	        index = ticks[i].index;
	        break;
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	var getMainColorOfGraphicItem = exports.getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var result = void 0;
	
	  switch (displayName) {
	    case 'Line':
	    case 'Area':
	      result = item.props.stroke;
	      break;
	    default:
	      result = item.props.fill;
	      break;
	  }
	
	  return result;
	};
	
	var getLegendProps = exports.getLegendProps = function getLegendProps(children, graphicItems, width) {
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData = legendItem.props && legendItem.props.payload || graphicItems.map(function (child) {
	    var _child$props = child.props,
	        dataKey = _child$props.dataKey,
	        name = _child$props.name,
	        legendType = _child$props.legendType;
	
	
	    return {
	      dataKey: dataKey,
	      type: legendItem.props.iconType || legendType || 'square',
	      color: getMainColorOfGraphicItem(child),
	      value: name || dataKey,
	      payload: child.props
	    };
	  });
	
	  return _extends({}, legendItem.props, _Legend2.default.getWithHeight(legendItem, width), {
	    payload: legendData
	  });
	};
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	var getTicksOfScale = exports.getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	
	
	  if (opts.scale !== 'auto' && opts.scale !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	
	    return { niceTicks: tickValues };
	  } else if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return { niceTicks: _tickValues };
	  }
	
	  return null;
	};
	
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	var getBarSizeList = exports.getBarSizeList = function getBarSizeList(_ref) {
	  var globalSize = _ref.barSize,
	      _ref$stackGroups = _ref.stackGroups,
	      stackGroups = _ref$stackGroups === undefined ? {} : _ref$stackGroups;
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	
	
	      var barItems = items.filter(function (item) {
	        return item.type.displayName === 'Bar';
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil3.default)(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	var getBarPosition = exports.getBarPosition = function getBarPosition(_ref2) {
	  var barGap = _ref2.barGap,
	      barCategoryGap = _ref2.barCategoryGap,
	      bandSize = _ref2.bandSize,
	      _ref2$sizeList = _ref2.sizeList,
	      sizeList = _ref2$sizeList === undefined ? [] : _ref2$sizeList,
	      maxBarSize = _ref2.maxBarSize;
	
	  var len = sizeList.length;
	  if (len < 1) return null;
	
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result = void 0;
	
	  // whether or not is barSize setted by user
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	    if (sum >= bandSize && fullBarSize > 0) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = { offset: offset - realBarGap, size: 0 };
	
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: prev });
	        });
	      }
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: newRes[newRes.length - 1].position });
	        });
	      }
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	var appendOffsetOfLegend = exports.appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps(children, items, legendWidth, legendHeight);
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _extends({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _extends({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _identity2=__webpack_require__(69);var _identity3=_interopRequireDefault(_identity2);var _victoryCore=__webpack_require__(12);
	
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	
	
	
	
	
	getAxis:function getAxis(props){
	if(props.orientation){
	var vertical={top:"x",bottom:"x",left:"y",right:"y"};
	return vertical[props.orientation];
	}
	return props.dependentAxis?"y":"x";
	},
	
	
	
	
	
	
	
	getCurrentAxis:function getCurrentAxis(axis,horizontal){
	var otherAxis=axis==="x"?"y":"x";
	return horizontal?otherAxis:axis;
	},
	
	
	
	
	
	
	
	getAxisComponent:function getAxisComponent(childComponents,axis){
	var matchesAxis=function matchesAxis(component){
	var type=component.type.getAxis(component.props);
	return type===axis;
	};
	return this.findAxisComponents(childComponents,matchesAxis)[0];
	},
	
	
	
	
	
	
	
	findAxisComponents:function findAxisComponents(childComponents,predicate){
	predicate=predicate||_identity3.default;
	var findAxes=function findAxes(children){
	return children.reduce(function(memo,child){
	if(child.type&&child.type.role==="axis"&&predicate(child)){
	return memo.concat(child);
	}else if(child.props&&child.props.children){
	return memo.concat(findAxes(_react2.default.Children.toArray(child.props.children)));
	}
	return memo;
	},[]);
	};
	
	return findAxes(childComponents);
	},
	
	
	
	
	
	
	
	
	getAxisComponentsWithParent:function getAxisComponentsWithParent(childComponents,type){
	var matchesType=function matchesType(child){
	return type==="dependent"?child.props.dependentAxis:!child.props.dependentAxis;
	};
	
	var findAxisComponents=function findAxisComponents(children){
	return children.reduce(function(memo,child){
	if(child.type&&child.type.role==="axis"&&matchesType(child)){
	return memo.concat(child);
	}else if(child.props&&child.props.children){
	var childAxis=findAxisComponents(_react2.default.Children.toArray(child.props.children));
	return childAxis.length>0?memo.concat(child):memo;
	}
	return memo;
	},[]);
	};
	
	return findAxisComponents(childComponents);
	},
	
	getOrigin:function getOrigin(domain){
	var getSingleOrigin=function getSingleOrigin(){
	var domainMin=Math.min.apply(Math,_toConsumableArray(domain));
	var domainMax=Math.max.apply(Math,_toConsumableArray(domain));
	return domainMax<0?domainMax:Math.max(0,domainMin);
	};
	
	return _victoryCore.Collection.containsDates(domain)?
	new Date(Math.min.apply(Math,_toConsumableArray(domain))):getSingleOrigin();
	},
	
	getOriginSign:function getOriginSign(origin,domain){
	var getSign=function getSign(){
	return origin<=0&&Math.max.apply(Math,_toConsumableArray(domain))<=0?"negative":"positive";
	};
	return _victoryCore.Collection.containsDates(domain)?"positive":getSign();
	},
	
	
	
	
	
	
	
	getOrientation:function getOrientation(component,axis,originSign){
	if(component&&component.props&&component.props.orientation){
	return component.props.orientation;
	}
	var sign=originSign||"positive";
	var typicalOrientations={
	positive:{x:"bottom",y:"left"},
	negative:{x:"top",y:"right"}};
	
	var flippedOrientations={
	positive:{x:"left",y:"bottom"},
	negative:{x:"right",y:"top"}};
	
	if(!component){
	return typicalOrientations[sign][axis];
	}
	var dependent=component.props.dependentAxis;
	return!dependent&&axis==="y"||dependent&&axis==="x"?
	flippedOrientations[sign][axis]:typicalOrientations[sign][axis];
	},
	
	
	
	
	
	getAxisOrientations:function getAxisOrientations(childComponents){
	return{
	x:this.getOrientation(this.getAxisComponent(childComponents,"x"),"x"),
	y:this.getOrientation(this.getAxisComponent(childComponents,"y"),"y")};
	
	},
	
	
	
	
	
	isVertical:function isVertical(props){
	var orientation=props.orientation||(props.dependentAxis?"left":"bottom");
	var vertical={top:false,bottom:false,left:true,right:true};
	return vertical[orientation];
	},
	
	
	
	
	
	stringTicks:function stringTicks(props){
	return props.tickValues!==undefined&&_victoryCore.Collection.containsStrings(props.tickValues);
	}};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.attachId=undefined;var _uniqueId2=__webpack_require__(1031);var _uniqueId3=_interopRequireDefault(_uniqueId2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}
	
	var attachId=exports.attachId=function attachId(func){
	return function(){return{
	mutations:func.apply(undefined,arguments),
	id:(0,_uniqueId3.default)("throttledEvent")};};
	
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _some2=__webpack_require__(1027);var _some3=_interopRequireDefault(_some2);var _uniq2=__webpack_require__(211);var _uniq3=_interopRequireDefault(_uniq2);var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _flatten2=__webpack_require__(205);var _flatten3=_interopRequireDefault(_flatten2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);
	
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _axis=__webpack_require__(240);var _axis2=_interopRequireDefault(_axis);
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	
	{
	getData:function getData(props,childComponents){
	if(props.data){
	return _victoryCore.Data.getData(props);
	}
	childComponents=childComponents||_react2.default.Children.toArray(props.children);
	return this.getDataFromChildren(childComponents);
	},
	
	getDefaultDomainPadding:function getDefaultDomainPadding(props,axis,childComponents){
	var horizontalChildren=childComponents.some(function(component){
	return component.props&&component.props.horizontal;
	});
	var horizontal=props&&props.horizontal||horizontalChildren;
	var groupComponent=childComponents.filter(function(child){
	return child.type&&child.type.role&&child.type.role==="group";
	});
	
	if(groupComponent.length<1){
	return undefined;
	}var _groupComponent$0$pro=
	groupComponent[0].props,offset=_groupComponent$0$pro.offset,children=_groupComponent$0$pro.children;
	var defaultDomainPadding=horizontal?
	{y:offset*children.length/2}:
	{x:offset*children.length/2};
	return defaultDomainPadding[axis];
	},
	
	getDomain:function getDomain(props,axis,childComponents){
	childComponents=childComponents||_react2.default.Children.toArray(props.children);
	var propsDomain=_victoryCore.Domain.getDomainFromProps(props,axis);
	if(propsDomain){
	return propsDomain;
	}
	var dataset=(props.data||props.y)&&_victoryCore.Data.getData(props);
	var dataDomain=dataset?_victoryCore.Domain.getDomainFromData(props,axis,dataset):[];
	var childDomain=this.getDomainFromChildren(props,axis,childComponents);
	var min=_victoryCore.Collection.getMinValue([].concat(_toConsumableArray(dataDomain),_toConsumableArray(childDomain)));
	var max=_victoryCore.Collection.getMaxValue([].concat(_toConsumableArray(dataDomain),_toConsumableArray(childDomain)));
	var domainPadding=this.getDefaultDomainPadding(props,axis,childComponents);
	var paddedDomain=_victoryCore.Domain.padDomain([min,max],(0,_assign3.default)({domainPadding:domainPadding},props),axis);
	return _victoryCore.Domain.cleanDomain(paddedDomain,props,axis);
	
	},
	
	setAnimationState:function setAnimationState(props,nextProps){
	if(!props.animate){
	return;
	}
	if(props.animate.parentState){
	var nodesWillExit=props.animate.parentState.nodesWillExit;
	var oldProps=nodesWillExit?props:null;
	this.setState((0,_defaults3.default)({oldProps:oldProps,nextProps:nextProps},props.animate.parentState));
	}else{
	var oldChildren=_react2.default.Children.toArray(props.children);
	var nextChildren=_react2.default.Children.toArray(nextProps.children);
	var isContinuous=function isContinuous(child){
	var check=function check(c){return c.type&&c.type.continuous;};
	return Array.isArray(child)?(0,_some3.default)(child,check):check(child);
	};
	
	var continuous=(0,_some3.default)(oldChildren,function(child){
	return isContinuous(child)||child.props.children&&isContinuous(child.props.children);
	});var _Transitions$getIniti=
	
	
	
	
	
	_victoryCore.Transitions.getInitialTransitionState(oldChildren,nextChildren),_nodesWillExit=_Transitions$getIniti.nodesWillExit,nodesWillEnter=_Transitions$getIniti.nodesWillEnter,childrenTransitions=_Transitions$getIniti.childrenTransitions,nodesShouldEnter=_Transitions$getIniti.nodesShouldEnter;
	
	this.setState({
	nodesWillExit:_nodesWillExit,
	nodesWillEnter:nodesWillEnter,
	nodesShouldEnter:nodesShouldEnter,
	childrenTransitions:_victoryCore.Collection.isArrayOfArrays(childrenTransitions)?
	childrenTransitions[0]:childrenTransitions,
	oldProps:_nodesWillExit?props:null,
	nextProps:nextProps,
	continuous:continuous});
	
	}
	},
	
	getAllEvents:function getAllEvents(props){
	var components=["groupComponent","containerComponent"];
	this.componentEvents=_victoryCore.Events.getComponentEvents(props,components);
	if(Array.isArray(this.componentEvents)){var _componentEvents;
	return Array.isArray(props.events)?
	(_componentEvents=this.componentEvents).concat.apply(_componentEvents,_toConsumableArray(props.events)):this.componentEvents;
	}
	return props.events;
	},
	
	getAnimationProps:function getAnimationProps(props,child,index){var _this=this;
	if(!props.animate){
	return child.props.animate;
	}
	var getFilteredState=function getFilteredState(){
	var childrenTransitions=_this.state&&_this.state.childrenTransitions;
	childrenTransitions=_victoryCore.Collection.isArrayOfArrays(childrenTransitions)?
	childrenTransitions[index]:childrenTransitions;
	return(0,_defaults3.default)({childrenTransitions:childrenTransitions},_this.state);
	};
	
	var getTransitions=props.animate&&props.animate.getTransitions;
	var state=getFilteredState();
	var parentState=props.animate&&props.animate.parentState||state;
	if(!getTransitions){
	var getTransitionProps=_victoryCore.Transitions.getTransitionPropsFactory(
	props,
	state,
	function(newState){return _this.setState(newState);});
	
	getTransitions=(0,_partialRight3.default)(getTransitionProps,index);
	}
	return(0,_defaults3.default)({getTransitions:getTransitions,parentState:parentState},props.animate,child.props.animate);
	},
	
	getDomainFromChildren:function getDomainFromChildren(props,axis,childComponents){
	var childDomains=[];
	var childDomainsLength=0;
	
	var children=childComponents?
	childComponents.slice(0):
	_react2.default.Children.toArray(props.children);
	var childrenLength=children.length;
	
	var horizontalChildren=childComponents.some(function(component){
	return component.props&&component.props.horizontal;
	});
	var horizontal=props&&props.horizontal||horizontalChildren.length>0;
	var currentAxis=_axis2.default.getCurrentAxis(axis,horizontal);
	
	while(childrenLength>0){
	var child=children[--childrenLength];
	
	if(child.type&&(0,_isFunction3.default)(child.type.getDomain)){
	var parentData=props.data?_victoryCore.Data.getData(props,axis):undefined;
	var sharedProps=parentData?
	(0,_assign3.default)({},child.props,{data:parentData}):child.props;
	var childDomain=child.props&&child.type.getDomain(sharedProps,currentAxis);
	if(childDomain){
	var childDomainLength=childDomain.length;
	for(var index=0;index<childDomainLength;index++){
	childDomains[childDomainsLength++]=childDomain[index];
	}
	}
	}else if(child.props&&child.props.children){
	var newChildren=_react2.default.Children.toArray(child.props.children);
	var newChildrenLength=newChildren.length;
	for(var _index=0;_index<newChildrenLength;_index++){
	children[childrenLength++]=newChildren[_index];
	}
	}
	}
	
	var min=_victoryCore.Collection.getMinValue(childDomains);
	var max=_victoryCore.Collection.getMaxValue(childDomains);
	return childDomains.length===0?
	[0,1]:[min,max];
	},
	
	getDataFromChildren:function getDataFromChildren(props,childComponents){
	var getData=function getData(childProps){
	var data=_victoryCore.Data.getData(childProps);
	return Array.isArray(data)&&data.length>0?data:undefined;
	};
	
	
	
	var children=childComponents?
	childComponents.slice(0).reverse():
	_react2.default.Children.toArray(props.children).reverse();
	
	var childrenLength=children.length;
	
	var dataArr=[];
	var dataArrLength=0;
	while(childrenLength>0){
	var child=children[--childrenLength];
	if(child.type&&child.type.role==="axis"){
	dataArrLength=dataArrLength;
	}else if(child.type&&child.type.role!=="axis"&&(0,_isFunction3.default)(child.type.getData)){
	dataArr[dataArrLength++]=child.type.getData(child.props);
	}else if(child.props&&child.props.children){
	var newChildren=_react2.default.Children.toArray(child.props.children);
	var newChildrenLength=newChildren.length;
	for(var index=0;index<newChildrenLength;index++){
	children[childrenLength++]=newChildren[index];
	}
	}else{
	dataArr[dataArrLength++]=getData(child.props);
	}
	}
	
	return dataArr;
	},
	
	getStackedDomain:function getStackedDomain(props,axis){
	var propsDomain=_victoryCore.Domain.getDomainFromProps(props,axis);
	if(propsDomain){
	return propsDomain;
	}var
	horizontal=props.horizontal;
	var ensureZero=function ensureZero(domain){
	var isDependent=axis==="y"&&!horizontal||axis==="x"&&horizontal;
	return isDependent?
	[_victoryCore.Collection.getMinValue(domain,0),_victoryCore.Collection.getMaxValue(domain,0)]:domain;
	};
	var datasets=this.getDataFromChildren(props);
	return ensureZero(_victoryCore.Domain.getDomainFromGroupedData(props,axis,datasets));
	},
	
	getColor:function getColor(calculatedProps,child,index){var
	
	style=calculatedProps.style;var
	colorScale=calculatedProps.colorScale,color=calculatedProps.color;
	if(style&&style.data&&style.data.fill){
	return style.data.fill;
	}
	colorScale=child.props&&child.props.colorScale?child.props.colorScale:colorScale;
	color=child.props&&child.props.color?child.props.color:color;
	if(!colorScale&&!color){
	return undefined;
	}
	var colors=Array.isArray(colorScale)?
	colorScale:_victoryCore.Style.getColorScale(colorScale);
	return color||colors[index%colors.length];
	},
	
	getChildStyle:function getChildStyle(child,index,calculatedProps){var
	style=calculatedProps.style;
	var role=child.type&&child.type.role;
	var defaultFill=role==="stack"?
	undefined:this.getColor(calculatedProps,child,index);
	var defaultColor=role==="line"?
	{fill:"none",stroke:defaultFill}:{fill:defaultFill};
	var childStyle=child.props.style||{};
	var dataStyle=(0,_defaults3.default)({},childStyle.data,(0,_assign3.default)({},style.data,defaultColor));
	var labelsStyle=(0,_defaults3.default)({},childStyle.labels,style.labels);
	return{
	parent:style.parent,
	data:dataStyle,
	labels:labelsStyle};
	
	},
	
	getStringsFromCategories:function getStringsFromCategories(childComponents,axis){
	var strings=[];
	var stringsLength=0;
	
	var children=childComponents.slice(0).reverse();
	var childrenLength=children.length;
	
	while(childrenLength>0){
	var child=children[--childrenLength];
	
	if(child.props&&child.props.categories){
	var newStrings=_victoryCore.Data.getStringsFromCategories(child.props,axis);
	var newStringsLength=newStrings.length;
	for(var index=0;index<newStringsLength;index++){
	strings[stringsLength++]=newStrings[index];
	}
	}else if(child.props&&child.props.children){
	var newChildren=_react2.default.Children.toArray(child.props.children);
	var newChildrenLength=newChildren.length;
	for(var _index2=0;_index2<newChildrenLength;_index2++){
	children[childrenLength++]=newChildren[_index2];
	}
	}
	}
	
	return strings;
	},
	
	getStringsFromData:function getStringsFromData(childComponents,axis){
	var strings=[];
	var stringsLength=0;
	
	var children=childComponents.slice(0).reverse();
	var childrenLength=children.length;
	
	while(childrenLength>0){
	var child=children[--childrenLength];
	
	if(child.props&&child.props.data){
	var newStrings=_victoryCore.Data.getStringsFromData(child.props,axis);
	var newStringsLength=newStrings.length;
	for(var index=0;index<newStringsLength;index++){
	strings[stringsLength++]=newStrings[index];
	}
	}else if(child.type&&(0,_isFunction3.default)(child.type.getData)){
	var data=(0,_flatten3.default)(child.type.getData(child.props));
	var attr=axis==="x"?"xName":"yName";
	for(var _index3=0;_index3<data.length;_index3++){
	var datum=data[_index3];
	if(datum[attr]){
	strings[stringsLength++]=datum[attr];
	}
	}
	}else if(child.props&&child.props.children){
	var newChildren=_react2.default.Children.toArray(child.props.children);
	var newChildrenLength=newChildren.length;
	for(var _index4=0;_index4<newChildrenLength;_index4++){
	children[childrenLength++]=newChildren[_index4];
	}
	}
	}
	
	return strings;
	},
	
	getStringsFromChildren:function getStringsFromChildren(props,axis,childComponents){
	childComponents=childComponents||_react2.default.Children.toArray(props.children);
	var axisComponent=_axis2.default.getAxisComponent(childComponents,axis);
	var axisStrings=axisComponent?_victoryCore.Data.getStringsFromAxes(axisComponent.props,axis):[];
	var categoryStrings=this.getStringsFromCategories(childComponents,axis);
	var dataStrings=this.getStringsFromData(childComponents,axis);
	return(0,_uniq3.default)((0,_flatten3.default)([].concat(_toConsumableArray(categoryStrings),_toConsumableArray(dataStrings),_toConsumableArray(axisStrings))));
	},
	
	getCategories:function getCategories(props,axis){
	var categories=_victoryCore.Data.getCategories(props,axis)||
	this.getStringsFromChildren(props,axis);
	return categories.length>0?categories:undefined;
	},
	
	getY0:function getY0(datum,index,calculatedProps){
	if(datum.y0){
	return datum.y0;
	}var
	datasets=calculatedProps.datasets;
	var y=datum._y;
	var previousDataSets=datasets.slice(0,index);
	var previousPoints=previousDataSets.reduce(function(prev,dataset){
	return prev.concat(dataset.
	filter(function(previousDatum){return datum._x instanceof Date?
	previousDatum._x.getTime()===datum._x.getTime():
	previousDatum._x===datum._x;}).
	map(function(previousDatum){return previousDatum._y||0;}));
	
	},[]);
	var y0=previousPoints.length&&previousPoints.reduce(function(memo,value){
	var sameSign=y<0&&value<0||y>=0&&value>=0;
	return sameSign?+value+memo:memo;
	},0);
	return previousPoints.some(function(point){return point instanceof Date;})?new Date(y0):y0;
	}};

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(723)
	var ieee754 = __webpack_require__(882)
	var isArray = __webpack_require__(883)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 244 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(182)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 246 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 247 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 248 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 249 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(755);
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/d3/d3-sankey Version 0.7.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(766), __webpack_require__(143), __webpack_require__(13)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-shape'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Shape) { 'use strict';
	
	function targetDepth(d) {
	  return d.target.depth;
	}
	
	function left(node) {
	  return node.depth;
	}
	
	function right(node, n) {
	  return n - 1 - node.height;
	}
	
	function justify(node, n) {
	  return node.sourceLinks.length ? node.depth : n - 1;
	}
	
	function center(node) {
	  return node.targetLinks.length ? node.depth
	      : node.sourceLinks.length ? d3Array.min(node.sourceLinks, targetDepth) - 1
	      : 0;
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function ascendingSourceBreadth(a, b) {
	  return ascendingBreadth(a.source, b.source) || a.index - b.index;
	}
	
	function ascendingTargetBreadth(a, b) {
	  return ascendingBreadth(a.target, b.target) || a.index - b.index;
	}
	
	function ascendingBreadth(a, b) {
	  return a.y0 - b.y0;
	}
	
	function value(d) {
	  return d.value;
	}
	
	function nodeCenter(node) {
	  return (node.y0 + node.y1) / 2;
	}
	
	function weightedSource(link) {
	  return nodeCenter(link.source) * link.value;
	}
	
	function weightedTarget(link) {
	  return nodeCenter(link.target) * link.value;
	}
	
	function defaultId(d) {
	  return d.index;
	}
	
	function defaultNodes(graph) {
	  return graph.nodes;
	}
	
	function defaultLinks(graph) {
	  return graph.links;
	}
	
	function find(nodeById, id) {
	  var node = nodeById.get(id);
	  if (!node) throw new Error("missing: " + id);
	  return node;
	}
	
	var sankey = function() {
	  var x0 = 0, y0 = 0, x1 = 1, y1 = 1, // extent
	      dx = 24, // nodeWidth
	      py = 8, // nodePadding
	      id = defaultId,
	      align = justify,
	      nodes = defaultNodes,
	      links = defaultLinks,
	      iterations = 32;
	
	  function sankey() {
	    var graph = {nodes: nodes.apply(null, arguments), links: links.apply(null, arguments)};
	    computeNodeLinks(graph);
	    computeNodeValues(graph);
	    computeNodeDepths(graph);
	    computeNodeBreadths(graph, iterations);
	    computeLinkBreadths(graph);
	    return graph;
	  }
	
	  sankey.update = function(graph) {
	    computeLinkBreadths(graph);
	    return graph;
	  };
	
	  sankey.nodeId = function(_) {
	    return arguments.length ? (id = typeof _ === "function" ? _ : constant(_), sankey) : id;
	  };
	
	  sankey.nodeAlign = function(_) {
	    return arguments.length ? (align = typeof _ === "function" ? _ : constant(_), sankey) : align;
	  };
	
	  sankey.nodeWidth = function(_) {
	    return arguments.length ? (dx = +_, sankey) : dx;
	  };
	
	  sankey.nodePadding = function(_) {
	    return arguments.length ? (py = +_, sankey) : py;
	  };
	
	  sankey.nodes = function(_) {
	    return arguments.length ? (nodes = typeof _ === "function" ? _ : constant(_), sankey) : nodes;
	  };
	
	  sankey.links = function(_) {
	    return arguments.length ? (links = typeof _ === "function" ? _ : constant(_), sankey) : links;
	  };
	
	  sankey.size = function(_) {
	    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [x1 - x0, y1 - y0];
	  };
	
	  sankey.extent = function(_) {
	    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [[x0, y0], [x1, y1]];
	  };
	
	  sankey.iterations = function(_) {
	    return arguments.length ? (iterations = +_, sankey) : iterations;
	  };
	
	  // Populate the sourceLinks and targetLinks for each node.
	  // Also, if the source and target are not objects, assume they are indices.
	  function computeNodeLinks(graph) {
	    graph.nodes.forEach(function(node, i) {
	      node.index = i;
	      node.sourceLinks = [];
	      node.targetLinks = [];
	    });
	    var nodeById = d3Collection.map(graph.nodes, id);
	    graph.links.forEach(function(link, i) {
	      link.index = i;
	      var source = link.source, target = link.target;
	      if (typeof source !== "object") source = link.source = find(nodeById, source);
	      if (typeof target !== "object") target = link.target = find(nodeById, target);
	      source.sourceLinks.push(link);
	      target.targetLinks.push(link);
	    });
	  }
	
	  // Compute the value (size) of each node by summing the associated links.
	  function computeNodeValues(graph) {
	    graph.nodes.forEach(function(node) {
	      node.value = Math.max(
	        d3Array.sum(node.sourceLinks, value),
	        d3Array.sum(node.targetLinks, value)
	      );
	    });
	  }
	
	  // Iteratively assign the depth (x-position) for each node.
	  // Nodes are assigned the maximum depth of incoming neighbors plus one;
	  // nodes with no incoming links are assigned depth zero, while
	  // nodes with no outgoing links are assigned the maximum depth.
	  function computeNodeDepths(graph) {
	    var nodes, next, x;
	
	    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	      nodes.forEach(function(node) {
	        node.depth = x;
	        node.sourceLinks.forEach(function(link) {
	          if (next.indexOf(link.target) < 0) {
	            next.push(link.target);
	          }
	        });
	      });
	    }
	
	    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	      nodes.forEach(function(node) {
	        node.height = x;
	        node.targetLinks.forEach(function(link) {
	          if (next.indexOf(link.source) < 0) {
	            next.push(link.source);
	          }
	        });
	      });
	    }
	
	    var kx = (x1 - x0 - dx) / (x - 1);
	    graph.nodes.forEach(function(node) {
	      node.x1 = (node.x0 = x0 + Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x)))) * kx) + dx;
	    });
	  }
	
	  function computeNodeBreadths(graph) {
	    var columns = d3Collection.nest()
	        .key(function(d) { return d.x0; })
	        .sortKeys(d3Array.ascending)
	        .entries(graph.nodes)
	        .map(function(d) { return d.values; });
	
	    //
	    initializeNodeBreadth();
	    resolveCollisions();
	    for (var alpha = 1, n = iterations; n > 0; --n) {
	      relaxRightToLeft(alpha *= 0.99);
	      resolveCollisions();
	      relaxLeftToRight(alpha);
	      resolveCollisions();
	    }
	
	    function initializeNodeBreadth() {
	      var ky = d3Array.min(columns, function(nodes) {
	        return (y1 - y0 - (nodes.length - 1) * py) / d3Array.sum(nodes, value);
	      });
	
	      columns.forEach(function(nodes) {
	        nodes.forEach(function(node, i) {
	          node.y1 = (node.y0 = i) + node.value * ky;
	        });
	      });
	
	      graph.links.forEach(function(link) {
	        link.width = link.value * ky;
	      });
	    }
	
	    function relaxLeftToRight(alpha) {
	      columns.forEach(function(nodes) {
	        nodes.forEach(function(node) {
	          if (node.targetLinks.length) {
	            var dy = (d3Array.sum(node.targetLinks, weightedSource) / d3Array.sum(node.targetLinks, value) - nodeCenter(node)) * alpha;
	            node.y0 += dy, node.y1 += dy;
	          }
	        });
	      });
	    }
	
	    function relaxRightToLeft(alpha) {
	      columns.slice().reverse().forEach(function(nodes) {
	        nodes.forEach(function(node) {
	          if (node.sourceLinks.length) {
	            var dy = (d3Array.sum(node.sourceLinks, weightedTarget) / d3Array.sum(node.sourceLinks, value) - nodeCenter(node)) * alpha;
	            node.y0 += dy, node.y1 += dy;
	          }
	        });
	      });
	    }
	
	    function resolveCollisions() {
	      columns.forEach(function(nodes) {
	        var node,
	            dy,
	            y = y0,
	            n = nodes.length,
	            i;
	
	        // Push any overlapping nodes down.
	        nodes.sort(ascendingBreadth);
	        for (i = 0; i < n; ++i) {
	          node = nodes[i];
	          dy = y - node.y0;
	          if (dy > 0) node.y0 += dy, node.y1 += dy;
	          y = node.y1 + py;
	        }
	
	        // If the bottommost node goes outside the bounds, push it back up.
	        dy = y - py - y1;
	        if (dy > 0) {
	          y = (node.y0 -= dy), node.y1 -= dy;
	
	          // Push any overlapping nodes back up.
	          for (i = n - 2; i >= 0; --i) {
	            node = nodes[i];
	            dy = node.y1 + py - y;
	            if (dy > 0) node.y0 -= dy, node.y1 -= dy;
	            y = node.y0;
	          }
	        }
	      });
	    }
	  }
	
	  function computeLinkBreadths(graph) {
	    graph.nodes.forEach(function(node) {
	      node.sourceLinks.sort(ascendingTargetBreadth);
	      node.targetLinks.sort(ascendingSourceBreadth);
	    });
	    graph.nodes.forEach(function(node) {
	      var y0 = node.y0, y1 = y0;
	      node.sourceLinks.forEach(function(link) {
	        link.y0 = y0 + link.width / 2, y0 += link.width;
	      });
	      node.targetLinks.forEach(function(link) {
	        link.y1 = y1 + link.width / 2, y1 += link.width;
	      });
	    });
	  }
	
	  return sankey;
	};
	
	function horizontalSource(d) {
	  return [d.source.x1, d.y0];
	}
	
	function horizontalTarget(d) {
	  return [d.target.x0, d.y1];
	}
	
	var sankeyLinkHorizontal = function() {
	  return d3Shape.linkHorizontal()
	      .source(horizontalSource)
	      .target(horizontalTarget);
	};
	
	exports.sankey = sankey;
	exports.sankeyCenter = center;
	exports.sankeyLeft = left;
	exports.sankeyRight = right;
	exports.sankeyJustify = justify;
	exports.sankeyLinkHorizontal = sankeyLinkHorizontal;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale-chromatic/ Version 1.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(145)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-interpolate'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Interpolate) { 'use strict';
	
	var colors = function(specifier) {
	  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
	  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
	  return colors;
	};
	
	var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
	
	var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
	
	var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
	
	var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
	
	var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
	
	var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
	
	var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
	
	var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
	
	var ramp = function(scheme) {
	  return d3Interpolate.interpolateRgbBasis(scheme[scheme.length - 1]);
	};
	
	var scheme = new Array(3).concat(
	  "d8b365f5f5f55ab4ac",
	  "a6611adfc27d80cdc1018571",
	  "a6611adfc27df5f5f580cdc1018571",
	  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
	  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
	  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
	  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
	  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
	  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
	).map(colors);
	
	var BrBG = ramp(scheme);
	
	var scheme$1 = new Array(3).concat(
	  "af8dc3f7f7f77fbf7b",
	  "7b3294c2a5cfa6dba0008837",
	  "7b3294c2a5cff7f7f7a6dba0008837",
	  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
	  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
	  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
	  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
	  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
	  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
	).map(colors);
	
	var PRGn = ramp(scheme$1);
	
	var scheme$2 = new Array(3).concat(
	  "e9a3c9f7f7f7a1d76a",
	  "d01c8bf1b6dab8e1864dac26",
	  "d01c8bf1b6daf7f7f7b8e1864dac26",
	  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
	  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
	  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
	  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
	  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
	  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
	).map(colors);
	
	var PiYG = ramp(scheme$2);
	
	var scheme$3 = new Array(3).concat(
	  "998ec3f7f7f7f1a340",
	  "5e3c99b2abd2fdb863e66101",
	  "5e3c99b2abd2f7f7f7fdb863e66101",
	  "542788998ec3d8daebfee0b6f1a340b35806",
	  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
	  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
	  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
	  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
	  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
	).map(colors);
	
	var PuOr = ramp(scheme$3);
	
	var scheme$4 = new Array(3).concat(
	  "ef8a62f7f7f767a9cf",
	  "ca0020f4a58292c5de0571b0",
	  "ca0020f4a582f7f7f792c5de0571b0",
	  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
	  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
	  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
	  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
	  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
	  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
	).map(colors);
	
	var RdBu = ramp(scheme$4);
	
	var scheme$5 = new Array(3).concat(
	  "ef8a62ffffff999999",
	  "ca0020f4a582bababa404040",
	  "ca0020f4a582ffffffbababa404040",
	  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
	  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
	  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
	  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
	  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
	  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
	).map(colors);
	
	var RdGy = ramp(scheme$5);
	
	var scheme$6 = new Array(3).concat(
	  "fc8d59ffffbf91bfdb",
	  "d7191cfdae61abd9e92c7bb6",
	  "d7191cfdae61ffffbfabd9e92c7bb6",
	  "d73027fc8d59fee090e0f3f891bfdb4575b4",
	  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
	  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
	  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
	  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
	  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
	).map(colors);
	
	var RdYlBu = ramp(scheme$6);
	
	var scheme$7 = new Array(3).concat(
	  "fc8d59ffffbf91cf60",
	  "d7191cfdae61a6d96a1a9641",
	  "d7191cfdae61ffffbfa6d96a1a9641",
	  "d73027fc8d59fee08bd9ef8b91cf601a9850",
	  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
	  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
	  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
	  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
	  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
	).map(colors);
	
	var RdYlGn = ramp(scheme$7);
	
	var scheme$8 = new Array(3).concat(
	  "fc8d59ffffbf99d594",
	  "d7191cfdae61abdda42b83ba",
	  "d7191cfdae61ffffbfabdda42b83ba",
	  "d53e4ffc8d59fee08be6f59899d5943288bd",
	  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
	  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
	  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
	  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
	  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
	).map(colors);
	
	var Spectral = ramp(scheme$8);
	
	var scheme$9 = new Array(3).concat(
	  "e5f5f999d8c92ca25f",
	  "edf8fbb2e2e266c2a4238b45",
	  "edf8fbb2e2e266c2a42ca25f006d2c",
	  "edf8fbccece699d8c966c2a42ca25f006d2c",
	  "edf8fbccece699d8c966c2a441ae76238b45005824",
	  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
	  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
	).map(colors);
	
	var BuGn = ramp(scheme$9);
	
	var scheme$10 = new Array(3).concat(
	  "e0ecf49ebcda8856a7",
	  "edf8fbb3cde38c96c688419d",
	  "edf8fbb3cde38c96c68856a7810f7c",
	  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
	  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
	  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
	  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
	).map(colors);
	
	var BuPu = ramp(scheme$10);
	
	var scheme$11 = new Array(3).concat(
	  "e0f3dba8ddb543a2ca",
	  "f0f9e8bae4bc7bccc42b8cbe",
	  "f0f9e8bae4bc7bccc443a2ca0868ac",
	  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
	  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
	  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
	  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
	).map(colors);
	
	var GnBu = ramp(scheme$11);
	
	var scheme$12 = new Array(3).concat(
	  "fee8c8fdbb84e34a33",
	  "fef0d9fdcc8afc8d59d7301f",
	  "fef0d9fdcc8afc8d59e34a33b30000",
	  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
	  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
	  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
	  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
	).map(colors);
	
	var OrRd = ramp(scheme$12);
	
	var scheme$13 = new Array(3).concat(
	  "ece2f0a6bddb1c9099",
	  "f6eff7bdc9e167a9cf02818a",
	  "f6eff7bdc9e167a9cf1c9099016c59",
	  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
	  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
	  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
	  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
	).map(colors);
	
	var PuBuGn = ramp(scheme$13);
	
	var scheme$14 = new Array(3).concat(
	  "ece7f2a6bddb2b8cbe",
	  "f1eef6bdc9e174a9cf0570b0",
	  "f1eef6bdc9e174a9cf2b8cbe045a8d",
	  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
	  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
	  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
	  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
	).map(colors);
	
	var PuBu = ramp(scheme$14);
	
	var scheme$15 = new Array(3).concat(
	  "e7e1efc994c7dd1c77",
	  "f1eef6d7b5d8df65b0ce1256",
	  "f1eef6d7b5d8df65b0dd1c77980043",
	  "f1eef6d4b9dac994c7df65b0dd1c77980043",
	  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
	  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
	  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
	).map(colors);
	
	var PuRd = ramp(scheme$15);
	
	var scheme$16 = new Array(3).concat(
	  "fde0ddfa9fb5c51b8a",
	  "feebe2fbb4b9f768a1ae017e",
	  "feebe2fbb4b9f768a1c51b8a7a0177",
	  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
	  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
	  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
	  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
	).map(colors);
	
	var RdPu = ramp(scheme$16);
	
	var scheme$17 = new Array(3).concat(
	  "edf8b17fcdbb2c7fb8",
	  "ffffcca1dab441b6c4225ea8",
	  "ffffcca1dab441b6c42c7fb8253494",
	  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
	  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
	  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
	  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
	).map(colors);
	
	var YlGnBu = ramp(scheme$17);
	
	var scheme$18 = new Array(3).concat(
	  "f7fcb9addd8e31a354",
	  "ffffccc2e69978c679238443",
	  "ffffccc2e69978c67931a354006837",
	  "ffffccd9f0a3addd8e78c67931a354006837",
	  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
	  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
	  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
	).map(colors);
	
	var YlGn = ramp(scheme$18);
	
	var scheme$19 = new Array(3).concat(
	  "fff7bcfec44fd95f0e",
	  "ffffd4fed98efe9929cc4c02",
	  "ffffd4fed98efe9929d95f0e993404",
	  "ffffd4fee391fec44ffe9929d95f0e993404",
	  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
	  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
	  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
	).map(colors);
	
	var YlOrBr = ramp(scheme$19);
	
	var scheme$20 = new Array(3).concat(
	  "ffeda0feb24cf03b20",
	  "ffffb2fecc5cfd8d3ce31a1c",
	  "ffffb2fecc5cfd8d3cf03b20bd0026",
	  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
	  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
	  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
	  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
	).map(colors);
	
	var YlOrRd = ramp(scheme$20);
	
	var scheme$21 = new Array(3).concat(
	  "deebf79ecae13182bd",
	  "eff3ffbdd7e76baed62171b5",
	  "eff3ffbdd7e76baed63182bd08519c",
	  "eff3ffc6dbef9ecae16baed63182bd08519c",
	  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
	  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
	  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
	).map(colors);
	
	var Blues = ramp(scheme$21);
	
	var scheme$22 = new Array(3).concat(
	  "e5f5e0a1d99b31a354",
	  "edf8e9bae4b374c476238b45",
	  "edf8e9bae4b374c47631a354006d2c",
	  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
	  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
	  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
	  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
	).map(colors);
	
	var Greens = ramp(scheme$22);
	
	var scheme$23 = new Array(3).concat(
	  "f0f0f0bdbdbd636363",
	  "f7f7f7cccccc969696525252",
	  "f7f7f7cccccc969696636363252525",
	  "f7f7f7d9d9d9bdbdbd969696636363252525",
	  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
	  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
	  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
	).map(colors);
	
	var Greys = ramp(scheme$23);
	
	var scheme$24 = new Array(3).concat(
	  "efedf5bcbddc756bb1",
	  "f2f0f7cbc9e29e9ac86a51a3",
	  "f2f0f7cbc9e29e9ac8756bb154278f",
	  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
	  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
	  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
	  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
	).map(colors);
	
	var Purples = ramp(scheme$24);
	
	var scheme$25 = new Array(3).concat(
	  "fee0d2fc9272de2d26",
	  "fee5d9fcae91fb6a4acb181d",
	  "fee5d9fcae91fb6a4ade2d26a50f15",
	  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
	  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
	  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
	  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
	).map(colors);
	
	var Reds = ramp(scheme$25);
	
	var scheme$26 = new Array(3).concat(
	  "fee6cefdae6be6550d",
	  "feeddefdbe85fd8d3cd94701",
	  "feeddefdbe85fd8d3ce6550da63603",
	  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
	  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
	  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
	  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
	).map(colors);
	
	var Oranges = ramp(scheme$26);
	
	exports.schemeAccent = Accent;
	exports.schemeDark2 = Dark2;
	exports.schemePaired = Paired;
	exports.schemePastel1 = Pastel1;
	exports.schemePastel2 = Pastel2;
	exports.schemeSet1 = Set1;
	exports.schemeSet2 = Set2;
	exports.schemeSet3 = Set3;
	exports.interpolateBrBG = BrBG;
	exports.schemeBrBG = scheme;
	exports.interpolatePRGn = PRGn;
	exports.schemePRGn = scheme$1;
	exports.interpolatePiYG = PiYG;
	exports.schemePiYG = scheme$2;
	exports.interpolatePuOr = PuOr;
	exports.schemePuOr = scheme$3;
	exports.interpolateRdBu = RdBu;
	exports.schemeRdBu = scheme$4;
	exports.interpolateRdGy = RdGy;
	exports.schemeRdGy = scheme$5;
	exports.interpolateRdYlBu = RdYlBu;
	exports.schemeRdYlBu = scheme$6;
	exports.interpolateRdYlGn = RdYlGn;
	exports.schemeRdYlGn = scheme$7;
	exports.interpolateSpectral = Spectral;
	exports.schemeSpectral = scheme$8;
	exports.interpolateBuGn = BuGn;
	exports.schemeBuGn = scheme$9;
	exports.interpolateBuPu = BuPu;
	exports.schemeBuPu = scheme$10;
	exports.interpolateGnBu = GnBu;
	exports.schemeGnBu = scheme$11;
	exports.interpolateOrRd = OrRd;
	exports.schemeOrRd = scheme$12;
	exports.interpolatePuBuGn = PuBuGn;
	exports.schemePuBuGn = scheme$13;
	exports.interpolatePuBu = PuBu;
	exports.schemePuBu = scheme$14;
	exports.interpolatePuRd = PuRd;
	exports.schemePuRd = scheme$15;
	exports.interpolateRdPu = RdPu;
	exports.schemeRdPu = scheme$16;
	exports.interpolateYlGnBu = YlGnBu;
	exports.schemeYlGnBu = scheme$17;
	exports.interpolateYlGn = YlGn;
	exports.schemeYlGn = scheme$18;
	exports.interpolateYlOrBr = YlOrBr;
	exports.schemeYlOrBr = scheme$19;
	exports.interpolateYlOrRd = YlOrRd;
	exports.schemeYlOrRd = scheme$20;
	exports.interpolateBlues = Blues;
	exports.schemeBlues = scheme$21;
	exports.interpolateGreens = Greens;
	exports.schemeGreens = scheme$22;
	exports.interpolateGreys = Greys;
	exports.schemeGreys = scheme$23;
	exports.interpolatePurples = Purples;
	exports.schemePurples = scheme$24;
	exports.interpolateReds = Reds;
	exports.schemeReds = scheme$25;
	exports.interpolateOranges = Oranges;
	exports.schemeOranges = scheme$26;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _effect = __webpack_require__(773);
	
	Object.defineProperty(exports, 'Effect', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_effect).default;
	  }
	});
	
	var _effectManager = __webpack_require__(772);
	
	Object.defineProperty(exports, 'EffectManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_effectManager).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvbGliL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OzJDQW9CUUEsTzs7Ozs7Ozs7O2tEQUNBQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQ29weXJpZ2h0IChjKSAyMDE1IC0gMjAxNyBVYmVyIFRlY2hub2xvZ2llcywgSW5jLlxuLy9cbi8vIFBlcm1pc3Npb24gaXMgaGVyZWJ5IGdyYW50ZWQsIGZyZWUgb2YgY2hhcmdlLCB0byBhbnkgcGVyc29uIG9idGFpbmluZyBhIGNvcHlcbi8vIG9mIHRoaXMgc29mdHdhcmUgYW5kIGFzc29jaWF0ZWQgZG9jdW1lbnRhdGlvbiBmaWxlcyAodGhlIFwiU29mdHdhcmVcIiksIHRvIGRlYWxcbi8vIGluIHRoZSBTb2Z0d2FyZSB3aXRob3V0IHJlc3RyaWN0aW9uLCBpbmNsdWRpbmcgd2l0aG91dCBsaW1pdGF0aW9uIHRoZSByaWdodHNcbi8vIHRvIHVzZSwgY29weSwgbW9kaWZ5LCBtZXJnZSwgcHVibGlzaCwgZGlzdHJpYnV0ZSwgc3VibGljZW5zZSwgYW5kL29yIHNlbGxcbi8vIGNvcGllcyBvZiB0aGUgU29mdHdhcmUsIGFuZCB0byBwZXJtaXQgcGVyc29ucyB0byB3aG9tIHRoZSBTb2Z0d2FyZSBpc1xuLy8gZnVybmlzaGVkIHRvIGRvIHNvLCBzdWJqZWN0IHRvIHRoZSBmb2xsb3dpbmcgY29uZGl0aW9uczpcbi8vXG4vLyBUaGUgYWJvdmUgY29weXJpZ2h0IG5vdGljZSBhbmQgdGhpcyBwZXJtaXNzaW9uIG5vdGljZSBzaGFsbCBiZSBpbmNsdWRlZCBpblxuLy8gYWxsIGNvcGllcyBvciBzdWJzdGFudGlhbCBwb3J0aW9ucyBvZiB0aGUgU29mdHdhcmUuXG4vL1xuLy8gVEhFIFNPRlRXQVJFIElTIFBST1ZJREVEIFwiQVMgSVNcIiwgV0lUSE9VVCBXQVJSQU5UWSBPRiBBTlkgS0lORCwgRVhQUkVTUyBPUlxuLy8gSU1QTElFRCwgSU5DTFVESU5HIEJVVCBOT1QgTElNSVRFRCBUTyBUSEUgV0FSUkFOVElFUyBPRiBNRVJDSEFOVEFCSUxJVFksXG4vLyBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRSBBTkQgTk9OSU5GUklOR0VNRU5ULiBJTiBOTyBFVkVOVCBTSEFMTCBUSEVcbi8vIEFVVEhPUlMgT1IgQ09QWVJJR0hUIEhPTERFUlMgQkUgTElBQkxFIEZPUiBBTlkgQ0xBSU0sIERBTUFHRVMgT1IgT1RIRVJcbi8vIExJQUJJTElUWSwgV0hFVEhFUiBJTiBBTiBBQ1RJT04gT0YgQ09OVFJBQ1QsIFRPUlQgT1IgT1RIRVJXSVNFLCBBUklTSU5HIEZST00sXG4vLyBPVVQgT0YgT1IgSU4gQ09OTkVDVElPTiBXSVRIIFRIRSBTT0ZUV0FSRSBPUiBUSEUgVVNFIE9SIE9USEVSIERFQUxJTkdTIElOXG4vLyBUSEUgU09GVFdBUkUuXG5cbmV4cG9ydCB7ZGVmYXVsdCBhcyBFZmZlY3R9IGZyb20gJy4vZWZmZWN0JztcbmV4cG9ydCB7ZGVmYXVsdCBhcyBFZmZlY3RNYW5hZ2VyfSBmcm9tICcuL2VmZmVjdC1tYW5hZ2VyJztcbiJdfQ==

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.experimental = exports.default = exports.DeckGL = exports.ExtrudedChoroplethLayer64 = exports.ChoroplethLayer64 = exports.ChoroplethLayer = exports.GeoJsonLayer = exports.PolygonLayer = exports.PathLayer = exports.HexagonCellLayer = exports.HexagonLayer = exports.GridCellLayer = exports.GridLayer = exports.ScreenGridLayer = exports.ScatterplotLayer = exports.PointCloudLayer = exports.LineLayer = exports.IconLayer = exports.ArcLayer = exports.WebMercatorViewport = exports.OrthographicViewport = exports.PerspectiveViewport = exports.Viewport = exports.COORDINATE_SYSTEM = exports.AttributeManager = exports.LayerManager = exports.CompositeLayer = exports.Layer = exports.assembleShaders = undefined;
	
	var _shaderUtils = __webpack_require__(49);
	
	Object.defineProperty(exports, 'assembleShaders', {
	  enumerable: true,
	  get: function get() {
	    return _shaderUtils.assembleShaders;
	  }
	});
	
	var _lib = __webpack_require__(35);
	
	Object.defineProperty(exports, 'Layer', {
	  enumerable: true,
	  get: function get() {
	    return _lib.Layer;
	  }
	});
	Object.defineProperty(exports, 'CompositeLayer', {
	  enumerable: true,
	  get: function get() {
	    return _lib.CompositeLayer;
	  }
	});
	Object.defineProperty(exports, 'LayerManager', {
	  enumerable: true,
	  get: function get() {
	    return _lib.LayerManager;
	  }
	});
	Object.defineProperty(exports, 'AttributeManager', {
	  enumerable: true,
	  get: function get() {
	    return _lib.AttributeManager;
	  }
	});
	Object.defineProperty(exports, 'COORDINATE_SYSTEM', {
	  enumerable: true,
	  get: function get() {
	    return _lib.COORDINATE_SYSTEM;
	  }
	});
	
	var _viewport = __webpack_require__(147);
	
	Object.defineProperty(exports, 'Viewport', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_viewport).default;
	  }
	});
	
	var _perspectiveViewport = __webpack_require__(394);
	
	Object.defineProperty(exports, 'PerspectiveViewport', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_perspectiveViewport).default;
	  }
	});
	
	var _orthographicViewport = __webpack_require__(393);
	
	Object.defineProperty(exports, 'OrthographicViewport', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_orthographicViewport).default;
	  }
	});
	
	var _webMercatorViewport = __webpack_require__(395);
	
	Object.defineProperty(exports, 'WebMercatorViewport', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_webMercatorViewport).default;
	  }
	});
	
	var _arcLayer = __webpack_require__(777);
	
	Object.defineProperty(exports, 'ArcLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_arcLayer).default;
	  }
	});
	
	var _iconLayer = __webpack_require__(793);
	
	Object.defineProperty(exports, 'IconLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_iconLayer).default;
	  }
	});
	
	var _lineLayer = __webpack_require__(797);
	
	Object.defineProperty(exports, 'LineLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lineLayer).default;
	  }
	});
	
	var _pointCloudLayer = __webpack_require__(804);
	
	Object.defineProperty(exports, 'PointCloudLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pointCloudLayer).default;
	  }
	});
	
	var _scatterplotLayer = __webpack_require__(388);
	
	Object.defineProperty(exports, 'ScatterplotLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_scatterplotLayer).default;
	  }
	});
	
	var _screenGridLayer = __webpack_require__(811);
	
	Object.defineProperty(exports, 'ScreenGridLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_screenGridLayer).default;
	  }
	});
	
	var _gridLayer = __webpack_require__(784);
	
	Object.defineProperty(exports, 'GridLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_gridLayer).default;
	  }
	});
	
	var _gridCellLayer = __webpack_require__(386);
	
	Object.defineProperty(exports, 'GridCellLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_gridCellLayer).default;
	  }
	});
	
	var _hexagonLayer = __webpack_require__(789);
	
	Object.defineProperty(exports, 'HexagonLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hexagonLayer).default;
	  }
	});
	
	var _hexagonCellLayer = __webpack_require__(387);
	
	Object.defineProperty(exports, 'HexagonCellLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hexagonCellLayer).default;
	  }
	});
	
	var _pathLayer = __webpack_require__(257);
	
	Object.defineProperty(exports, 'PathLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pathLayer).default;
	  }
	});
	
	var _polygonLayer = __webpack_require__(805);
	
	Object.defineProperty(exports, 'PolygonLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_polygonLayer).default;
	  }
	});
	
	var _geojsonLayer = __webpack_require__(778);
	
	Object.defineProperty(exports, 'GeoJsonLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_geojsonLayer).default;
	  }
	});
	
	var _choroplethLayer = __webpack_require__(390);
	
	Object.defineProperty(exports, 'ChoroplethLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_choroplethLayer).default;
	  }
	});
	
	var _choroplethLayer2 = __webpack_require__(817);
	
	Object.defineProperty(exports, 'ChoroplethLayer64', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_choroplethLayer2).default;
	  }
	});
	
	var _extrudedChoroplethLayer = __webpack_require__(822);
	
	Object.defineProperty(exports, 'ExtrudedChoroplethLayer64', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_extrudedChoroplethLayer).default;
	  }
	});
	
	var _deckgl = __webpack_require__(836);
	
	Object.defineProperty(exports, 'DeckGL', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_deckgl).default;
	  }
	});
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_deckgl).default;
	  }
	});
	
	var _get = __webpack_require__(260);
	
	var _count = __webpack_require__(392);
	
	var _lib2 = __webpack_require__(255);
	
	var _reflectionEffect = __webpack_require__(385);
	
	var _reflectionEffect2 = _interopRequireDefault(_reflectionEffect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Experimental Features (May change in minor version bumps, use at your own risk)
	
	
	var experimental = exports.experimental = {
	  get: _get.get,
	  count: _count.count,
	  EffectManager: _lib2.EffectManager,
	  Effect: _lib2.Effect,
	  ReflectionEffect: _reflectionEffect2.default
	};
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _luma = __webpack_require__(29);
	
	var _fp = __webpack_require__(54);
	
	var _pathLayerVertex = __webpack_require__(800);
	
	var _pathLayerVertex2 = _interopRequireDefault(_pathLayerVertex);
	
	var _pathLayerVertex3 = __webpack_require__(799);
	
	var _pathLayerVertex4 = _interopRequireDefault(_pathLayerVertex3);
	
	var _pathLayerFragment = __webpack_require__(798);
	
	var _pathLayerFragment2 = _interopRequireDefault(_pathLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEFAULT_COLOR = [0, 0, 0, 255];
	
	var defaultProps = {
	  widthScale: 1, // stroke width in meters
	  widthMinPixels: 0, //  min stroke width in pixels
	  widthMaxPixels: Number.MAX_SAFE_INTEGER, // max stroke width in pixels
	  rounded: false,
	  miterLimit: 4,
	  fp64: false,
	
	  getPath: function getPath(object) {
	    return object.path;
	  },
	  getColor: function getColor(object) {
	    return object.color || DEFAULT_COLOR;
	  },
	  getWidth: function getWidth(object) {
	    return object.width || 1;
	  }
	};
	
	var isClosed = function isClosed(path) {
	  var firstPoint = path[0];
	  var lastPoint = path[path.length - 1];
	  return firstPoint[0] === lastPoint[0] && firstPoint[1] === lastPoint[1] && firstPoint[2] === lastPoint[2];
	};
	
	var PathLayer = function (_Layer) {
	  _inherits(PathLayer, _Layer);
	
	  function PathLayer() {
	    _classCallCheck(this, PathLayer);
	
	    return _possibleConstructorReturn(this, (PathLayer.__proto__ || Object.getPrototypeOf(PathLayer)).apply(this, arguments));
	  }
	
	  _createClass(PathLayer, [{
	    key: 'getShaders',
	    value: function getShaders() {
	      return (0, _fp.enable64bitSupport)(this.props) ? {
	        vs: _pathLayerVertex4.default, fs: _pathLayerFragment2.default, modules: ['fp64', 'project64']
	      } : {
	        vs: _pathLayerVertex2.default, fs: _pathLayerFragment2.default, modules: []
	      };
	    }
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      var gl = this.context.gl;
	
	      this.setState({ model: this._getModel(gl) });
	
	      var attributeManager = this.state.attributeManager;
	      /* eslint-disable max-len */
	
	      attributeManager.addInstanced({
	        instanceStartPositions: { size: 3, update: this.calculateStartPositions },
	        instanceEndPositions: { size: 3, update: this.calculateEndPositions },
	        instanceLeftDeltas: { size: 3, update: this.calculateLeftDeltas },
	        instanceRightDeltas: { size: 3, update: this.calculateRightDeltas },
	        instanceStrokeWidths: { size: 1, accessor: 'getWidth', update: this.calculateStrokeWidths },
	        instanceColors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getColor', update: this.calculateColors },
	        instancePickingColors: { size: 3, type: _luma.GL.UNSIGNED_BYTE, update: this.calculatePickingColors }
	      });
	      /* eslint-enable max-len */
	    }
	  }, {
	    key: 'updateAttribute',
	    value: function updateAttribute(_ref) {
	      var props = _ref.props,
	          oldProps = _ref.oldProps,
	          changeFlags = _ref.changeFlags;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidateAll();
	
	        if (props.fp64 && props.projectionMode === _lib.COORDINATE_SYSTEM.LNGLAT) {
	          attributeManager.addInstanced({
	            instanceStartEndPositions64xyLow: {
	              size: 4,
	              update: this.calculateInstanceStartEndPositions64xyLow
	            }
	          });
	        } else {
	          attributeManager.remove(['instanceStartEndPositions64xyLow']);
	        }
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref2) {
	      var oldProps = _ref2.oldProps,
	          props = _ref2.props,
	          changeFlags = _ref2.changeFlags;
	
	      _get(PathLayer.prototype.__proto__ || Object.getPrototypeOf(PathLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	
	      var getPath = this.props.getPath;
	      var attributeManager = this.state.attributeManager;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var gl = this.context.gl;
	
	        this.setState({ model: this._getModel(gl) });
	      }
	      this.updateAttribute({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	
	      if (changeFlags.dataChanged) {
	        // this.state.paths only stores point positions in each path
	        var paths = props.data.map(getPath);
	        var numInstances = paths.reduce(function (count, path) {
	          return count + path.length - 1;
	        }, 0);
	
	        this.setState({ paths: paths, numInstances: numInstances });
	        attributeManager.invalidateAll();
	      }
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref3) {
	      var uniforms = _ref3.uniforms;
	      var _props = this.props,
	          rounded = _props.rounded,
	          miterLimit = _props.miterLimit,
	          widthScale = _props.widthScale,
	          widthMinPixels = _props.widthMinPixels,
	          widthMaxPixels = _props.widthMaxPixels;
	
	
	      this.state.model.render(Object.assign({}, uniforms, {
	        jointType: Number(rounded),
	        widthScale: widthScale,
	        miterLimit: miterLimit,
	        widthMinPixels: widthMinPixels,
	        widthMaxPixels: widthMaxPixels
	      }));
	    }
	  }, {
	    key: '_getModel',
	    value: function _getModel(gl) {
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      /*
	       *       _
	       *        "-_ 1                   3                       5
	       *     _     "o---------------------o-------------------_-o
	       *       -   / ""--..__              '.             _.-' /
	       *   _     "@- - - - - ""--..__- - - - x - - - -_.@'    /
	       *    "-_  /                   ""--..__ '.  _,-` :     /
	       *       "o----------------------------""-o'    :     /
	       *      0,2                            4 / '.  :     /
	       *                                      /   '.:     /
	       *                                     /     :'.   /
	       *                                    /     :  ', /
	       *                                   /     :     o
	       */
	
	      var SEGMENT_INDICES = [
	      // start corner
	      0, 2, 1,
	      // body
	      1, 2, 4, 1, 4, 3,
	      // end corner
	      3, 4, 5];
	
	      // [0] position on segment - 0: start, 1: end
	      // [1] side of path - -1: left, 0: center, 1: right
	      // [2] role - 0: offset point 1: joint point
	      var SEGMENT_POSITIONS = [
	      // bevel start corner
	      0, 0, 1,
	      // start inner corner
	      0, -1, 0,
	      // start outer corner
	      0, 1, 0,
	      // end inner corner
	      1, -1, 0,
	      // end outer corner
	      1, 1, 0,
	      // bevel end corner
	      1, 0, 1];
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        fs: shaders.fs,
	        vs: shaders.vs,
	        geometry: new _luma.Geometry({
	          drawMode: _luma.GL.TRIANGLES,
	          attributes: {
	            indices: new Uint16Array(SEGMENT_INDICES),
	            positions: new Float32Array(SEGMENT_POSITIONS)
	          }
	        }),
	        isInstanced: true
	      });
	    }
	  }, {
	    key: 'calculateStartPositions',
	    value: function calculateStartPositions(attribute) {
	      var paths = this.state.paths;
	      var value = attribute.value;
	
	
	      var i = 0;
	      paths.forEach(function (path) {
	        var numSegments = path.length - 1;
	        for (var ptIndex = 0; ptIndex < numSegments; ptIndex++) {
	          var point = path[ptIndex];
	          value[i++] = point[0];
	          value[i++] = point[1];
	          value[i++] = point[2] || 0;
	        }
	      });
	    }
	  }, {
	    key: 'calculateEndPositions',
	    value: function calculateEndPositions(attribute) {
	      var paths = this.state.paths;
	      var value = attribute.value;
	
	
	      var i = 0;
	      paths.forEach(function (path) {
	        for (var ptIndex = 1; ptIndex < path.length; ptIndex++) {
	          var point = path[ptIndex];
	          value[i++] = point[0];
	          value[i++] = point[1];
	          value[i++] = point[2] || 0;
	        }
	      });
	    }
	  }, {
	    key: 'calculateInstanceStartEndPositions64xyLow',
	    value: function calculateInstanceStartEndPositions64xyLow(attribute) {
	      var paths = this.state.paths;
	      var value = attribute.value;
	
	
	      var i = 0;
	      paths.forEach(function (path) {
	        var numSegments = path.length - 1;
	        for (var ptIndex = 0; ptIndex < numSegments; ptIndex++) {
	          var startPoint = path[ptIndex];
	          var endPoint = path[ptIndex + 1];
	          value[i++] = (0, _fp.fp64ify)(startPoint[0])[1];
	          value[i++] = (0, _fp.fp64ify)(startPoint[1])[1];
	          value[i++] = (0, _fp.fp64ify)(endPoint[0])[1];
	          value[i++] = (0, _fp.fp64ify)(endPoint[1])[1];
	        }
	      });
	    }
	  }, {
	    key: 'calculateLeftDeltas',
	    value: function calculateLeftDeltas(attribute) {
	      var paths = this.state.paths;
	      var value = attribute.value;
	
	
	      var i = 0;
	      paths.forEach(function (path) {
	        var numSegments = path.length - 1;
	        var prevPoint = isClosed(path) ? path[path.length - 2] : path[0];
	
	        for (var ptIndex = 0; ptIndex < numSegments; ptIndex++) {
	          var point = path[ptIndex];
	          value[i++] = point[0] - prevPoint[0];
	          value[i++] = point[1] - prevPoint[1];
	          value[i++] = point[2] - prevPoint[2] || 0;
	          prevPoint = point;
	        }
	      });
	    }
	  }, {
	    key: 'calculateRightDeltas',
	    value: function calculateRightDeltas(attribute) {
	      var paths = this.state.paths;
	      var value = attribute.value;
	
	
	      var i = 0;
	      paths.forEach(function (path) {
	        for (var ptIndex = 1; ptIndex < path.length; ptIndex++) {
	          var point = path[ptIndex];
	          var nextPoint = path[ptIndex + 1];
	          if (!nextPoint) {
	            nextPoint = isClosed(path) ? path[1] : point;
	          }
	
	          value[i++] = nextPoint[0] - point[0];
	          value[i++] = nextPoint[1] - point[1];
	          value[i++] = nextPoint[2] - point[2] || 0;
	        }
	      });
	    }
	  }, {
	    key: 'calculateStrokeWidths',
	    value: function calculateStrokeWidths(attribute) {
	      var _props2 = this.props,
	          data = _props2.data,
	          getWidth = _props2.getWidth;
	      var paths = this.state.paths;
	      var value = attribute.value;
	
	
	      var i = 0;
	      paths.forEach(function (path, index) {
	        var width = getWidth(data[index], index);
	        for (var ptIndex = 1; ptIndex < path.length; ptIndex++) {
	          value[i++] = width;
	        }
	      });
	    }
	  }, {
	    key: 'calculateColors',
	    value: function calculateColors(attribute) {
	      var _props3 = this.props,
	          data = _props3.data,
	          getColor = _props3.getColor;
	      var paths = this.state.paths;
	      var value = attribute.value;
	
	
	      var i = 0;
	      paths.forEach(function (path, index) {
	        var pointColor = getColor(data[index], index);
	        if (isNaN(pointColor[3])) {
	          pointColor[3] = 255;
	        }
	        for (var ptIndex = 1; ptIndex < path.length; ptIndex++) {
	          value[i++] = pointColor[0];
	          value[i++] = pointColor[1];
	          value[i++] = pointColor[2];
	          value[i++] = pointColor[3];
	        }
	      });
	    }
	
	    // Override the default picking colors calculation
	
	  }, {
	    key: 'calculatePickingColors',
	    value: function calculatePickingColors(attribute) {
	      var _this2 = this;
	
	      var paths = this.state.paths;
	      var value = attribute.value;
	
	
	      var i = 0;
	      paths.forEach(function (path, index) {
	        var pickingColor = _this2.encodePickingColor(index);
	        for (var ptIndex = 1; ptIndex < path.length; ptIndex++) {
	          value[i++] = pickingColor[0];
	          value[i++] = pickingColor[1];
	          value[i++] = pickingColor[2];
	        }
	      });
	    }
	  }]);
	
	  return PathLayer;
	}(_lib.Layer);
	
	exports.default = PathLayer;
	
	
	PathLayer.layerName = 'PathLayer';
	PathLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSimple = isSimple;
	exports.normalize = normalize;
	exports.getVertexCount = getVertexCount;
	exports.getTriangleCount = getTriangleCount;
	exports.forEachVertex = forEachVertex;
	
	var _utils = __webpack_require__(42);
	
	// Basic polygon support
	//
	// Handles simple and complex polygons
	// Simple polygons are arrays of vertices, implicitly "closed"
	// Complex polygons are arrays of simple polygons, with the first polygon
	// representing the outer hull and other polygons representing holes
	
	/**
	 * Check if this is a non-nested polygon (i.e. the first element of the first element is a number)
	 * @param {Array} polygon - either a complex or simple polygon
	 * @return {Boolean} - true if the polygon is a simple polygon (i.e. not an array of polygons)
	 */
	function isSimple(polygon) {
	  return (0, _utils.count)(polygon) >= 1 && (0, _utils.count)((0, _utils.get)(polygon, 0)) >= 2 && Number.isFinite((0, _utils.get)((0, _utils.get)(polygon, 0), 0));
	}
	
	/**
	 * Normalize to ensure that all polygons in a list are complex - simplifies processing
	 * @param {Array} polygon - either a complex or a simple polygon
	 * @param {Object} opts
	 * @param {Object} opts.dimensions - if 3, the coords will be padded with 0's if needed
	 * @return {Array} - returns a complex polygons
	 */
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	function normalize(polygon) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$dimensions = _ref.dimensions,
	      dimensions = _ref$dimensions === undefined ? 3 : _ref$dimensions;
	
	  return isSimple(polygon) ? [polygon] : polygon;
	}
	
	/**
	 * Check if this is a non-nested polygon (i.e. the first element of the first element is a number)
	 * @param {Array} polygon - either a complex or simple polygon
	 * @return {Boolean} - true if the polygon is a simple polygon (i.e. not an array of polygons)
	 */
	function getVertexCount(polygon) {
	  return isSimple(polygon) ? (0, _utils.count)(polygon) : polygon.reduce(function (length, simplePolygon) {
	    return length + (0, _utils.count)(simplePolygon);
	  }, 0);
	}
	
	// Return number of triangles needed to tesselate the polygon
	function getTriangleCount(polygon) {
	  var triangleCount = 0;
	  var first = true;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = normalize(polygon)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var simplePolygon = _step.value;
	
	      var size = (0, _utils.count)(simplePolygon);
	      if (first) {
	        triangleCount += size >= 3 ? size - 2 : 0;
	      } else {
	        triangleCount += size + 1;
	      }
	      first = false;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return triangleCount;
	}
	
	function forEachVertex(polygon, visitor) {
	  if (isSimple(polygon)) {
	    polygon.forEach(visitor);
	    return;
	  }
	
	  var vertexIndex = 0;
	  polygon.forEach(function (simplePolygon) {
	    simplePolygon.forEach(function (v, i, p) {
	      return visitor(v, vertexIndex, polygon);
	    });
	    vertexIndex++;
	  });
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TEST_EXPORTS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* global window */
	
	
	var _constants = __webpack_require__(183);
	
	var _attributeManager = __webpack_require__(391);
	
	var _attributeManager2 = _interopRequireDefault(_attributeManager);
	
	var _utils = __webpack_require__(42);
	
	var _luma = __webpack_require__(29);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LOG_PRIORITY_UPDATE = 2;
	
	/*
	 * @param {string} props.id - layer name
	 * @param {array}  props.data - array of data instances
	 * @param {bool} props.opacity - opacity of the layer
	 */
	var defaultProps = {
	  dataComparator: null,
	  numInstances: undefined,
	  visible: true,
	  pickable: false,
	  opacity: 0.8,
	  onHover: function onHover() {},
	  onClick: function onClick() {},
	  // Update triggers: a key change detection mechanism in deck.gl
	  // See layer documentation
	  updateTriggers: {},
	  projectionMode: _constants.COORDINATE_SYSTEM.LNGLAT
	};
	
	var counter = 0;
	
	var Layer = function () {
	  /**
	   * @class
	   * @param {object} props - See docs and defaults above
	   */
	  function Layer(props) {
	    _classCallCheck(this, Layer);
	
	    // If sublayer has static defaultProps member, getDefaultProps will return it
	    var mergedDefaultProps = getDefaultProps(this);
	    // Merge supplied props with pre-merged default props
	    props = Object.assign({}, mergedDefaultProps, props);
	    // Accept null as data - otherwise apps and layers need to add ugly checks
	    props.data = props.data || [];
	    // Props are immutable
	    Object.freeze(props);
	
	    // Define all members and freeze layer
	    this.id = props.id;
	    this.props = props;
	    this.oldProps = null;
	    this.state = null;
	    this.context = null;
	    this.parentLayer = null;
	    this.count = counter++;
	    this.lifecycle = 'Awaiting state';
	    Object.seal(this);
	  }
	
	  _createClass(Layer, [{
	    key: 'toString',
	    value: function toString() {
	      var className = this.constructor.layerName || this.constructor.name;
	      return className !== this.props.id ? '<' + className + ':\'' + this.props.id + '\'>' : '<' + className + '>';
	    }
	
	    // //////////////////////////////////////////////////
	    // LIFECYCLE METHODS, overridden by the layer subclasses
	
	    // Called once to set up the initial state
	    // App can create WebGL resources
	
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      throw new Error('Layer ' + this + ' has not defined initializeState');
	    }
	
	    // Let's layer control if updateState should be called
	
	  }, {
	    key: 'shouldUpdateState',
	    value: function shouldUpdateState(_ref) {
	      var oldProps = _ref.oldProps,
	          props = _ref.props,
	          oldContext = _ref.oldContext,
	          context = _ref.context,
	          changeFlags = _ref.changeFlags;
	
	      return changeFlags.somethingChanged;
	    }
	
	    // Default implementation, all attributes will be invalidated and updated
	    // when data changes
	
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref2) {
	      var oldProps = _ref2.oldProps,
	          props = _ref2.props,
	          oldContext = _ref2.oldContext,
	          context = _ref2.context,
	          changeFlags = _ref2.changeFlags;
	
	      if (changeFlags.dataChanged) {
	        this.invalidateAttribute('all');
	      }
	    }
	
	    // Called once when layer is no longer matched and state will be discarded
	    // App can destroy WebGL resources here
	
	  }, {
	    key: 'finalizeState',
	    value: function finalizeState() {}
	
	    // Implement to generate sublayers
	
	  }, {
	    key: 'renderLayers',
	    value: function renderLayers() {
	      return null;
	    }
	
	    // If state has a model, draw it with supplied uniforms
	
	  }, {
	    key: 'draw',
	    value: function draw(_ref3) {
	      var _ref3$uniforms = _ref3.uniforms,
	          uniforms = _ref3$uniforms === undefined ? {} : _ref3$uniforms;
	
	      if (this.state.model) {
	        this.state.model.render(uniforms);
	      }
	    }
	
	    // called to populate the info object that is passed to the event handler
	    // @return null to cancel event
	
	  }, {
	    key: 'getPickingInfo',
	    value: function getPickingInfo(_ref4) {
	      var info = _ref4.info,
	          mode = _ref4.mode;
	      var color = info.color,
	          index = info.index;
	
	
	      if (index >= 0) {
	        // If props.data is an indexable array, get the object
	        if (Array.isArray(this.props.data)) {
	          info.object = this.props.data[index];
	        }
	      }
	
	      // TODO - move to the JS part of a shader picking shader package
	      if (mode === 'hover') {
	        var selectedPickingColor = new Float32Array(3);
	        selectedPickingColor[0] = color[0];
	        selectedPickingColor[1] = color[1];
	        selectedPickingColor[2] = color[2];
	        this.setUniforms({ selectedPickingColor: selectedPickingColor });
	      }
	
	      return info;
	    }
	
	    // END LIFECYCLE METHODS
	    // //////////////////////////////////////////////////
	
	    // Default implementation of attribute invalidation, can be redefine
	
	  }, {
	    key: 'invalidateAttribute',
	    value: function invalidateAttribute() {
	      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
	
	      if (name === 'all') {
	        this.state.attributeManager.invalidateAll();
	      } else {
	        this.state.attributeManager.invalidate(name);
	      }
	    }
	
	    // Calls attribute manager to update any WebGL attributes, can be redefined
	
	  }, {
	    key: 'updateAttributes',
	    value: function updateAttributes(props) {
	      var _state = this.state,
	          attributeManager = _state.attributeManager,
	          model = _state.model;
	
	      if (!attributeManager) {
	        return;
	      }
	
	      var numInstances = this.getNumInstances(props);
	      // Figure out data length
	      attributeManager.update({
	        data: props.data,
	        numInstances: numInstances,
	        props: props,
	        buffers: props,
	        context: this,
	        // Don't worry about non-attribute props
	        ignoreUnknownAttributes: true
	      });
	      if (model) {
	        var changedAttributes = attributeManager.getChangedAttributes({ clearChangedFlags: true });
	        model.setAttributes(changedAttributes);
	      }
	    }
	
	    // Public API
	
	    // Updates selected state members and marks the object for redraw
	
	  }, {
	    key: 'setState',
	    value: function setState(updateObject) {
	      Object.assign(this.state, updateObject);
	      this.state.needsRedraw = true;
	    }
	  }, {
	    key: 'setNeedsRedraw',
	    value: function setNeedsRedraw() {
	      var redraw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (this.state) {
	        this.state.needsRedraw = redraw;
	      }
	    }
	
	    // PROJECTION METHODS
	
	    /**
	     * Projects a point with current map state (lat, lon, zoom, pitch, bearing)
	     *
	     * Note: Position conversion is done in shader, so in many cases there is no need
	     * for this function
	     * @param {Array|TypedArray} lngLat - long and lat values
	     * @return {Array|TypedArray} - x, y coordinates
	     */
	
	  }, {
	    key: 'project',
	    value: function project(lngLat) {
	      var viewport = this.context.viewport;
	
	      (0, _assert2.default)(Array.isArray(lngLat), 'Layer.project needs [lng,lat]');
	      return viewport.project(lngLat);
	    }
	  }, {
	    key: 'unproject',
	    value: function unproject(xy) {
	      var viewport = this.context.viewport;
	
	      (0, _assert2.default)(Array.isArray(xy), 'Layer.unproject needs [x,y]');
	      return viewport.unproject(xy);
	    }
	  }, {
	    key: 'projectFlat',
	    value: function projectFlat(lngLat) {
	      var viewport = this.context.viewport;
	
	      (0, _assert2.default)(Array.isArray(lngLat), 'Layer.project needs [lng,lat]');
	      return viewport.projectFlat(lngLat);
	    }
	  }, {
	    key: 'unprojectFlat',
	    value: function unprojectFlat(xy) {
	      var viewport = this.context.viewport;
	
	      (0, _assert2.default)(Array.isArray(xy), 'Layer.unproject needs [x,y]');
	      return viewport.unprojectFlat(xy);
	    }
	  }, {
	    key: 'screenToDevicePixels',
	    value: function screenToDevicePixels(screenPixels) {
	      var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;
	      return screenPixels * devicePixelRatio;
	    }
	
	    /**
	     * Returns the picking color that doesn't match any subfeature
	     * Use if some graphics do not belong to any pickable subfeature
	     * @return {Array} - a black color
	     */
	
	  }, {
	    key: 'nullPickingColor',
	    value: function nullPickingColor() {
	      return [0, 0, 0];
	    }
	
	    /**
	     * Returns the picking color that doesn't match any subfeature
	     * Use if some graphics do not belong to any pickable subfeature
	     * @param {int} i - index to be decoded
	     * @return {Array} - the decoded color
	     */
	
	  }, {
	    key: 'encodePickingColor',
	    value: function encodePickingColor(i) {
	      return [(i + 1) % 256, Math.floor((i + 1) / 256) % 256, Math.floor((i + 1) / 256 / 256) % 256];
	    }
	
	    /**
	     * Returns the picking color that doesn't match any subfeature
	     * Use if some graphics do not belong to any pickable subfeature
	     * @param {Uint8Array} color - color array to be decoded
	     * @return {Array} - the decoded picking color
	     */
	
	  }, {
	    key: 'decodePickingColor',
	    value: function decodePickingColor(color) {
	      (0, _assert2.default)(color instanceof Uint8Array);
	
	      var _color = _slicedToArray(color, 3),
	          i1 = _color[0],
	          i2 = _color[1],
	          i3 = _color[2];
	      // 1 was added to seperate from no selection
	
	
	      var index = i1 + i2 * 256 + i3 * 65536 - 1;
	      return index;
	    }
	  }, {
	    key: 'calculateInstancePickingColors',
	    value: function calculateInstancePickingColors(attribute, _ref5) {
	      var numInstances = _ref5.numInstances;
	      var value = attribute.value,
	          size = attribute.size;
	      // add 1 to index to seperate from no selection
	
	      for (var i = 0; i < numInstances; i++) {
	        var pickingColor = this.encodePickingColor(i);
	        value[i * size + 0] = pickingColor[0];
	        value[i * size + 1] = pickingColor[1];
	        value[i * size + 2] = pickingColor[2];
	      }
	    }
	
	    // DATA ACCESS API
	    // Data can use iterators and may not be random access
	
	    // Use iteration (the only required capability on data) to get first element
	
	  }, {
	    key: 'getFirstObject',
	    value: function getFirstObject() {
	      var data = this.props.data;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var object = _step.value;
	
	          return object;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return null;
	    }
	
	    // INTERNAL METHODS
	
	    // Deduces numer of instances. Intention is to support:
	    // - Explicit setting of numInstances
	    // - Auto-deduction for ES6 containers that define a size member
	    // - Auto-deduction for Classic Arrays via the built-in length attribute
	    // - Auto-deduction via arrays
	
	  }, {
	    key: 'getNumInstances',
	    value: function getNumInstances(props) {
	      props = props || this.props;
	
	      // First check if the layer has set its own value
	      if (this.state && this.state.numInstances !== undefined) {
	        return this.state.numInstances;
	      }
	
	      // Check if app has provided an explicit value
	      if (props.numInstances !== undefined) {
	        return props.numInstances;
	      }
	
	      // Use container library to get a count for any ES6 container or object
	      var _props = props,
	          data = _props.data;
	
	      return (0, _utils.count)(data);
	    }
	
	    // LAYER MANAGER API
	    // Should only be called by the deck.gl LayerManager class
	
	    // Called by layer manager when a new layer is found
	    /* eslint-disable max-statements */
	
	  }, {
	    key: 'initializeLayer',
	    value: function initializeLayer(updateParams) {
	      (0, _assert2.default)(this.context.gl, 'Layer context missing gl');
	      (0, _assert2.default)(!this.state, 'Layer missing state');
	
	      this.state = {};
	
	      // Initialize state only once
	      this.setState({
	        attributeManager: new _attributeManager2.default({ id: this.props.id }),
	        model: null,
	        needsRedraw: true,
	        dataChanged: true
	      });
	
	      var attributeManager = this.state.attributeManager;
	      // All instanced layers get instancePickingColors attribute by default
	      // Their shaders can use it to render a picking scene
	      // TODO - this slows down non instanced layers
	
	      attributeManager.addInstanced({
	        instancePickingColors: {
	          type: _luma.GL.UNSIGNED_BYTE,
	          size: 3,
	          update: this.calculateInstancePickingColors
	        }
	      });
	
	      // Call subclass lifecycle methods
	      this.initializeState();
	      this.updateState(updateParams);
	      // End subclass lifecycle methods
	
	      // Add any subclass attributes
	      this.updateAttributes(this.props);
	      this._updateBaseUniforms();
	
	      var model = this.state.model;
	
	      if (model) {
	        model.setInstanceCount(this.getNumInstances());
	        model.id = this.props.id;
	        model.program.id = this.props.id + '-program';
	        model.geometry.id = this.props.id + '-geometry';
	        model.setAttributes(attributeManager.getAttributes());
	      }
	    }
	
	    // Called by layer manager when existing layer is getting new props
	
	  }, {
	    key: 'updateLayer',
	    value: function updateLayer(updateParams) {
	      // Check for deprecated method
	      if (this.shouldUpdate) {
	        _utils.log.once(0, 'deck.gl v3 ' + this + ': "shouldUpdate" deprecated, renamed to "shouldUpdateState"');
	      }
	
	      // Call subclass lifecycle method
	      var stateNeedsUpdate = this.shouldUpdateState(updateParams);
	      // End lifecycle method
	
	      if (stateNeedsUpdate) {
	        // Call subclass lifecycle method
	        this.updateState(updateParams);
	        // End lifecycle method
	
	        // Run the attribute updaters
	        this.updateAttributes(updateParams.props);
	        this._updateBaseUniforms();
	
	        if (this.state.model) {
	          this.state.model.setInstanceCount(this.getNumInstances());
	        }
	      }
	    }
	    /* eslint-enable max-statements */
	
	    // Called by manager when layer is about to be disposed
	    // Note: not guaranteed to be called on application shutdown
	
	  }, {
	    key: 'finalizeLayer',
	    value: function finalizeLayer() {
	      // Call subclass lifecycle method
	      this.finalizeState();
	      // End lifecycle method
	    }
	
	    // Calculates uniforms
	
	  }, {
	    key: 'drawLayer',
	    value: function drawLayer(_ref6) {
	      var _ref6$uniforms = _ref6.uniforms,
	          uniforms = _ref6$uniforms === undefined ? {} : _ref6$uniforms;
	
	      // Call subclass lifecycle method
	      this.draw({ uniforms: uniforms });
	      // End lifecycle method
	    }
	
	    // {uniforms = {}, ...opts}
	
	  }, {
	    key: 'pickLayer',
	    value: function pickLayer(opts) {
	      // Call subclass lifecycle method
	      return this.getPickingInfo(opts);
	      // End lifecycle method
	    }
	  }, {
	    key: 'diffProps',
	    value: function diffProps(oldProps, newProps, context) {
	      // First check if any props have changed (ignore props that will be examined separately)
	      var propsChangedReason = (0, _utils.compareProps)({
	        newProps: newProps,
	        oldProps: oldProps,
	        ignoreProps: { data: null, updateTriggers: null }
	      });
	
	      // Now check if any data related props have changed
	      var dataChangedReason = this._diffDataProps(oldProps, newProps);
	
	      var propsChanged = Boolean(propsChangedReason);
	      var dataChanged = Boolean(dataChangedReason);
	      var viewportChanged = context.viewportChanged;
	      var somethingChanged = propsChanged || dataChanged || viewportChanged;
	
	      // Check update triggers to determine if any attributes need regeneration
	      // Note - if data has changed, all attributes will need regeneration, so skip this step
	      if (!dataChanged) {
	        this._diffUpdateTriggers(oldProps, newProps);
	      } else {
	        _utils.log.log(2, 'dataChanged: ' + dataChanged);
	      }
	
	      return {
	        propsChanged: propsChanged,
	        dataChanged: dataChanged,
	        viewportChanged: viewportChanged,
	        somethingChanged: somethingChanged,
	        reason: dataChangedReason || propsChangedReason
	      };
	    }
	
	    // Checks state of attributes and model
	    // TODO - is attribute manager needed? - Model should be enough.
	
	  }, {
	    key: 'getNeedsRedraw',
	    value: function getNeedsRedraw() {
	      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref7$clearRedrawFlag = _ref7.clearRedrawFlags,
	          clearRedrawFlags = _ref7$clearRedrawFlag === undefined ? false : _ref7$clearRedrawFlag;
	
	      // this method may be called by the render loop as soon a the layer
	      // has been created, so guard against uninitialized state
	      if (!this.state) {
	        return false;
	      }
	
	      var redraw = false;
	      redraw = redraw || this.state.needsRedraw;
	      this.state.needsRedraw = this.state.needsRedraw && !clearRedrawFlags;
	
	      var _state2 = this.state,
	          attributeManager = _state2.attributeManager,
	          model = _state2.model;
	
	      redraw = redraw || attributeManager && attributeManager.getNeedsRedraw({ clearRedrawFlags: clearRedrawFlags });
	      redraw = redraw || model && model.getNeedsRedraw({ clearRedrawFlags: clearRedrawFlags });
	
	      return redraw;
	    }
	
	    // PRIVATE METHODS
	
	    // The comparison of the data prop requires special handling
	    // the dataComparator should be used if supplied
	
	  }, {
	    key: '_diffDataProps',
	    value: function _diffDataProps(oldProps, newProps) {
	      // Support optional app defined comparison of data
	      var dataComparator = newProps.dataComparator;
	
	      if (dataComparator) {
	        if (!dataComparator(newProps.data, oldProps.data)) {
	          return 'Data comparator detected a change';
	        }
	        // Otherwise, do a shallow equal on props
	      } else if (newProps.data !== oldProps.data) {
	        return 'A new data container was supplied';
	      }
	
	      return null;
	    }
	
	    // Checks if any update triggers have changed, and invalidate
	    // attributes accordingly.
	    /* eslint-disable max-statements */
	
	  }, {
	    key: '_diffUpdateTriggers',
	    value: function _diffUpdateTriggers(oldProps, newProps) {
	      // const {attributeManager} = this.state;
	      // const updateTriggerMap = attributeManager.getUpdateTriggerMap();
	
	      var change = false;
	
	      for (var propName in newProps.updateTriggers) {
	        var oldTriggers = oldProps.updateTriggers[propName] || {};
	        var newTriggers = newProps.updateTriggers[propName] || {};
	        var diffReason = (0, _utils.compareProps)({
	          oldProps: oldTriggers,
	          newProps: newTriggers
	        });
	        if (diffReason) {
	          if (propName === 'all') {
	            _utils.log.log(LOG_PRIORITY_UPDATE, 'updateTriggers invalidating all attributes: ' + diffReason);
	            this.invalidateAttribute('all');
	            change = true;
	          } else {
	            _utils.log.log(LOG_PRIORITY_UPDATE, 'updateTriggers invalidating attribute ' + propName + ': ' + diffReason);
	            this.invalidateAttribute(propName);
	            change = true;
	          }
	        }
	      }
	
	      return change;
	    }
	    /* eslint-enable max-statements */
	
	  }, {
	    key: '_checkRequiredProp',
	    value: function _checkRequiredProp(propertyName, condition) {
	      var value = this.props[propertyName];
	      if (value === undefined) {
	        throw new Error('Property ' + propertyName + ' undefined in layer ' + this);
	      }
	      if (condition && !condition(value)) {
	        throw new Error('Bad property ' + propertyName + ' in layer ' + this);
	      }
	    }
	
	    // Emits a warning if an old prop is used, optionally suggesting a replacement
	
	  }, {
	    key: '_checkRemovedProp',
	    value: function _checkRemovedProp(oldProp) {
	      var newProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (this.props[oldProp] !== undefined) {
	        var layerName = this.constructor;
	        var message = layerName + ' no longer accepts props.' + oldProp + ' in this version of deck.gl.';
	        if (newProp) {
	          message += '\nPlease use props.' + newProp + ' instead.';
	        }
	        _utils.log.once(0, message);
	      }
	    }
	  }, {
	    key: '_updateBaseUniforms',
	    value: function _updateBaseUniforms() {
	      this.setUniforms({
	        // apply gamma to opacity to make it visually "linear"
	        opacity: Math.pow(this.props.opacity, 1 / 2.2),
	        ONE: 1.0
	      });
	    }
	
	    // DEPRECATED METHODS
	
	    // Updates selected state members and marks the object for redraw
	
	  }, {
	    key: 'setUniforms',
	    value: function setUniforms(uniformMap) {
	      if (this.state.model) {
	        this.state.model.setUniforms(uniformMap);
	      }
	      // TODO - set needsRedraw on the model?
	      this.state.needsRedraw = true;
	      (0, _utils.log)(3, 'layer.setUniforms', uniformMap);
	    }
	  }]);
	
	  return Layer;
	}();
	
	exports.default = Layer;
	
	
	Layer.layerName = 'Layer';
	Layer.defaultProps = defaultProps;
	
	// HELPERS
	
	// Constructors have their super class constructors as prototypes
	function getOwnProperty(object, prop) {
	  return object.hasOwnProperty(prop) && object[prop];
	}
	/*
	 * Return merged default props stored on layers constructor, create them if needed
	 */
	function getDefaultProps(layer) {
	  var mergedDefaultProps = getOwnProperty(layer.constructor, 'mergedDefaultProps');
	  if (mergedDefaultProps) {
	    return mergedDefaultProps;
	  }
	  return mergeDefaultProps(layer);
	}
	
	/*
	 * Walk the prototype chain and merge all default props
	 */
	function mergeDefaultProps(layer) {
	  var subClassConstructor = layer.constructor;
	  var layerName = getOwnProperty(subClassConstructor, 'layerName');
	  if (!layerName) {
	    _utils.log.once(0, 'layer ' + layer.constructor.name + ' does not specify a "layerName"');
	  }
	  var mergedDefaultProps = {
	    id: layerName || layer.constructor.name
	  };
	
	  while (layer) {
	    var layerDefaultProps = getOwnProperty(layer.constructor, 'defaultProps');
	    Object.freeze(layerDefaultProps);
	    if (layerDefaultProps) {
	      mergedDefaultProps = Object.assign({}, layerDefaultProps, mergedDefaultProps);
	    }
	    layer = Object.getPrototypeOf(layer);
	  }
	  // Store for quick lookup
	  subClassConstructor.mergedDefaultProps = mergedDefaultProps;
	  return mergedDefaultProps;
	}
	
	var TEST_EXPORTS = exports.TEST_EXPORTS = {
	  mergeDefaultProps: mergeDefaultProps
	};
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.get = get;
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Access properties of nested containers using dot-path notation
	 * - Supports plain objects and arrays, as well as classes with `get` methods
	 *   such as ES6 Maps, Immutable.js objects etc
	 * - Returns undefined if any container is not valid, instead of throwing
	 *
	 * @param {Object} container - container that supports get
	 * @param {String|*} compositeKey - key to access, can be '.'-separated string
	 * @return {*} - value in the final key of the nested container
	 */
	function get(container, compositeKey) {
	  // Split the key into subkeys
	  var keyList = getKeys(compositeKey);
	  // Recursively get the value of each key;
	  var value = container;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = keyList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      // If any intermediate subfield is not a container, return undefined
	      if (!isObject(value)) {
	        return undefined;
	      }
	      // Get the `getter` for this container
	      var getter = getGetter(value);
	      // Use the getter to get the value for the key
	      value = getter(value, key);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return value;
	}
	
	/**
	 * Checks if argument is an indexable object (not a primitive value, nor null)
	 * @param {*} value - JavaScript value to be tested
	 * @return {Boolean} - true if argument is a JavaScript object
	 */
	function isObject(value) {
	  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	
	// Default getter is container indexing
	var squareBracketGetter = function squareBracketGetter(container, key) {
	  return container[key];
	};
	var getMethodGetter = function getMethodGetter(obj, key) {
	  return obj.get(key);
	};
	// Cache key to key arrays for speed
	var keyMap = {};
	
	// Looks for a `get` function on the prototype
	// TODO - follow prototype chain?
	// @private
	// @return {Function} - get function: (container, key) => value
	function getGetter(container) {
	  // Check if container has a special get method
	  var prototype = Object.getPrototypeOf(container);
	  return prototype.get ? getMethodGetter : squareBracketGetter;
	}
	
	// Takes a string of '.' separated keys and returns an array of keys
	// E.g. 'feature.geometry.type' => 'feature', 'geometry', 'type'
	// @private
	function getKeys(compositeKey) {
	  if (typeof compositeKey === 'string') {
	    // else assume string and split around dots
	    var keyList = keyMap[compositeKey];
	    if (!keyList) {
	      keyList = compositeKey.split('.');
	      keyMap[compositeKey] = keyList;
	    }
	    return keyList;
	  }
	  // Wrap in array if needed
	  return Array.isArray(compositeKey) ? compositeKey : [compositeKey];
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function log(priority) {
	  (0, _assert2.default)(Number.isFinite(priority), 'log priority must be a number');
	  if (priority <= log.priority) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    // Node doesn't have console.debug, but using it looks better in browser consoles
	    if (console.debug) {
	      var _console;
	
	      (_console = console).debug.apply(_console, args);
	    } else {
	      var _console2;
	
	      (_console2 = console).info.apply(_console2, args);
	    }
	  }
	} // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* eslint-disable no-console */
	/* global console */
	
	
	var cache = {};
	
	function once(priority, arg) {
	  if (!cache[arg] && priority <= log.priority) {
	    var _console3;
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    (_console3 = console).warn.apply(_console3, [arg].concat(args));
	    cache[arg] = true;
	  }
	}
	
	// Logs a message with a time
	function time(priority, label) {
	  (0, _assert2.default)(Number.isFinite(priority), 'log priority must be a number');
	  if (priority <= log.priority) {
	    // In case the platform doesn't have console.time
	    if (console.time) {
	      console.time(label);
	    } else {
	      console.info(label);
	    }
	  }
	}
	
	function timeEnd(priority, label) {
	  (0, _assert2.default)(Number.isFinite(priority), 'log priority must be a number');
	  if (priority <= log.priority) {
	    // In case the platform doesn't have console.timeEnd
	    if (console.timeEnd) {
	      console.timeEnd(label);
	    } else {
	      console.info(label);
	    }
	  }
	}
	
	log.priority = 0;
	log.log = log;
	log.once = once;
	log.time = time;
	log.timeEnd = timeEnd;
	
	exports.default = log;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _viewport = __webpack_require__(147);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_viewport).default;
	  }
	});
	Object.defineProperty(exports, 'Viewport', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_viewport).default;
	  }
	});
	
	var _perspectiveViewport = __webpack_require__(394);
	
	Object.defineProperty(exports, 'PerspectiveViewport', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_perspectiveViewport).default;
	  }
	});
	
	var _orthographicViewport = __webpack_require__(393);
	
	Object.defineProperty(exports, 'OrthographicViewport', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_orthographicViewport).default;
	  }
	});
	
	var _webMercatorViewport = __webpack_require__(395);
	
	Object.defineProperty(exports, 'WebMercatorViewport', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_webMercatorViewport).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 263 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(192),
	    baseLodash = __webpack_require__(273);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(192),
	    baseLodash = __webpack_require__(273);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(102),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(981),
	    mapCacheDelete = __webpack_require__(982),
	    mapCacheGet = __webpack_require__(983),
	    mapCacheHas = __webpack_require__(984),
	    mapCacheSet = __webpack_require__(985);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 268 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 269 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 270 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(269),
	    isFlattenable = __webpack_require__(973);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(902),
	    isObjectLike = __webpack_require__(70);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 273 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(188),
	    assignMergeValue = __webpack_require__(415),
	    baseFor = __webpack_require__(418),
	    baseMergeDeep = __webpack_require__(911),
	    isObject = __webpack_require__(44),
	    keysIn = __webpack_require__(128);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(409);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(205),
	    overRest = __webpack_require__(447),
	    setToString = __webpack_require__(282);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(444),
	    noop = __webpack_require__(458);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(446);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(412),
	    stubArray = __webpack_require__(459);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(16),
	    isSymbol = __webpack_require__(127);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 281 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(919),
	    shortOut = __webpack_require__(450);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(416);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(75),
	    isObjectLike = __webpack_require__(70);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 285 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(82),
	    isArray = __webpack_require__(16),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 287 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(267);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(915),
	    basePropertyDeep = __webpack_require__(916),
	    isKey = __webpack_require__(280),
	    toKey = __webpack_require__(124);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(68),
	    baseSum = __webpack_require__(923);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(929),
	    keys = __webpack_require__(76);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 292 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _extendableBuiltin5(cls) {
	  function ExtendableBuiltin() {
	    var instance = Reflect.construct(cls, Array.from(arguments));
	    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
	    return instance;
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	function _extendableBuiltin3(cls) {
	  function ExtendableBuiltin() {
	    var instance = Reflect.construct(cls, Array.from(arguments));
	    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
	    return instance;
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    var instance = Reflect.construct(cls, Array.from(arguments));
	    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
	    return instance;
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	// Vec3, Mat4 and Quat classes
	// TODO - clean up linting and remove some of these exceptions
	/* eslint-disable */
	/* eslint-disable computed-property-spacing, brace-style, max-params, one-var */
	/* eslint-disable indent, no-loop-func */
	
	var sqrt = Math.sqrt;
	var sin = Math.sin;
	var cos = Math.cos;
	var tan = Math.tan;
	var pi = Math.PI;
	var slice = Array.prototype.slice;
	
	// Vec3 Class
	
	var Vec3 = exports.Vec3 = function (_extendableBuiltin2) {
	  _inherits(Vec3, _extendableBuiltin2);
	
	  function Vec3() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    _classCallCheck(this, Vec3);
	
	    var _this = _possibleConstructorReturn(this, (Vec3.__proto__ || Object.getPrototypeOf(Vec3)).call(this, 3));
	
	    _this[0] = x;
	    _this[1] = y;
	    _this[2] = z;
	    return _this;
	  }
	
	  // fast Vec3 create.
	
	
	  _createClass(Vec3, [{
	    key: 'x',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(value) {
	      return this[0] = value;
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(value) {
	      return this[1] = value;
	    }
	  }, {
	    key: 'z',
	    get: function get() {
	      return this[2];
	    },
	    set: function set(value) {
	      return this[2] = value;
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      return new Vec3(3);
	    }
	  }]);
	
	  return Vec3;
	}(_extendableBuiltin(Array));
	
	var generics = {
	  setVec3: function setVec3(dest, vec) {
	    dest[0] = vec[0];
	    dest[1] = vec[1];
	    dest[2] = vec[2];
	    return dest;
	  },
	  set: function set(dest, x, y, z) {
	    dest[0] = x;
	    dest[1] = y;
	    dest[2] = z;
	    return dest;
	  },
	  add: function add(dest, vec) {
	    return new Vec3(dest[0] + vec[0], dest[1] + vec[1], dest[2] + vec[2]);
	  },
	  $add: function $add(dest, vec) {
	    dest[0] += vec[0];
	    dest[1] += vec[1];
	    dest[2] += vec[2];
	    return dest;
	  },
	  add2: function add2(dest, a, b) {
	    dest[0] = a[0] + b[0];
	    dest[1] = a[1] + b[1];
	    dest[2] = a[2] + b[2];
	    return dest;
	  },
	  sub: function sub(dest, vec) {
	    return new Vec3(dest[0] - vec[0], dest[1] - vec[1], dest[2] - vec[2]);
	  },
	  $sub: function $sub(dest, vec) {
	    dest[0] -= vec[0];
	    dest[1] -= vec[1];
	    dest[2] -= vec[2];
	    return dest;
	  },
	  sub2: function sub2(dest, a, b) {
	    dest[0] = a[0] - b[0];
	    dest[1] = a[1] - b[1];
	    dest[2] = a[2] - b[2];
	    return dest;
	  },
	  scale: function scale(dest, s) {
	    return new Vec3(dest[0] * s, dest[1] * s, dest[2] * s);
	  },
	  $scale: function $scale(dest, s) {
	    dest[0] *= s;
	    dest[1] *= s;
	    dest[2] *= s;
	    return dest;
	  },
	  neg: function neg(dest) {
	    return new Vec3(-dest[0], -dest[1], -dest[2]);
	  },
	  $neg: function $neg(dest) {
	    dest[0] = -dest[0];
	    dest[1] = -dest[1];
	    dest[2] = -dest[2];
	    return dest;
	  },
	  unit: function unit(dest) {
	    var len = Vec3.norm(dest);
	
	    if (len > 0) {
	      return Vec3.scale(dest, 1 / len);
	    }
	    return Vec3.clone(dest);
	  },
	  $unit: function $unit(dest) {
	    var len = Vec3.norm(dest);
	
	    if (len > 0) {
	      return Vec3.$scale(dest, 1 / len);
	    }
	    return dest;
	  },
	  cross: function cross(dest, vec) {
	    var dx = dest[0],
	        dy = dest[1],
	        dz = dest[2],
	        vx = vec[0],
	        vy = vec[1],
	        vz = vec[2];
	
	    return new Vec3(dy * vz - dz * vy, dz * vx - dx * vz, dx * vy - dy * vx);
	  },
	  $cross: function $cross(dest, vec) {
	    var dx = dest[0],
	        dy = dest[1],
	        dz = dest[2],
	        vx = vec[0],
	        vy = vec[1],
	        vz = vec[2];
	
	    dest[0] = dy * vz - dz * vy;
	    dest[1] = dz * vx - dx * vz;
	    dest[2] = dx * vy - dy * vx;
	    return dest;
	  },
	  distTo: function distTo(dest, vec) {
	    var dx = dest[0] - vec[0],
	        dy = dest[1] - vec[1],
	        dz = dest[2] - vec[2];
	
	    return sqrt(dx * dx + dy * dy + dz * dz);
	  },
	  distToSq: function distToSq(dest, vec) {
	    var dx = dest[0] - vec[0],
	        dy = dest[1] - vec[1],
	        dz = dest[2] - vec[2];
	
	    return dx * dx + dy * dy + dz * dz;
	  },
	  norm: function norm(dest) {
	    var dx = dest[0],
	        dy = dest[1],
	        dz = dest[2];
	
	    return sqrt(dx * dx + dy * dy + dz * dz);
	  },
	  normSq: function normSq(dest) {
	    var dx = dest[0],
	        dy = dest[1],
	        dz = dest[2];
	
	    return dx * dx + dy * dy + dz * dz;
	  },
	  dot: function dot(dest, vec) {
	    return dest[0] * vec[0] + dest[1] * vec[1] + dest[2] * vec[2];
	  },
	  clone: function clone(dest) {
	    if (dest instanceof Vec3) {
	      return new Vec3(dest[0], dest[1], dest[2]);
	    }
	    return Vec3.setVec3(new Float32Array(3), dest);
	  },
	  toFloat32Array: function toFloat32Array(dest) {
	    var ans = dest.typedContainer;
	
	    if (!ans) {
	      return dest;
	    }
	
	    ans[0] = dest[0];
	    ans[1] = dest[1];
	    ans[2] = dest[2];
	
	    return ans;
	  }
	};
	
	// add generics and instance methods
	var proto = Vec3.prototype;
	for (var method in generics) {
	  Vec3[method] = generics[method];
	  proto[method] = function _(m) {
	    return function () {
	      var args = slice.call(arguments);
	      args.unshift(this);
	      return Vec3[m].apply(Vec3, args);
	    };
	  }(method);
	}
	
	// Mat4 Class
	
	var Mat4 = exports.Mat4 = function (_extendableBuiltin4) {
	  _inherits(Mat4, _extendableBuiltin4);
	
	  function Mat4(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
	    _classCallCheck(this, Mat4);
	
	    var _this2 = _possibleConstructorReturn(this, (Mat4.__proto__ || Object.getPrototypeOf(Mat4)).call(this, 16));
	
	    _this2.length = 16;
	
	    if (typeof n11 === 'number') {
	
	      _this2.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
	    } else {
	      _this2.id();
	    }
	
	    _this2.typedContainer = new Float32Array(16);
	    return _this2;
	  }
	
	  _createClass(Mat4, [{
	    key: 'copy',
	    value: function copy(src) {
	      for (var i = 0; i < 16; ++i) {
	        this[i] = src[i];
	      }
	      return this;
	    }
	  }, {
	    key: 'n11',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(val) {
	      this[0] = val;
	    }
	  }, {
	    key: 'n12',
	    get: function get() {
	      return this[4];
	    },
	    set: function set(val) {
	      this[4] = val;
	    }
	  }, {
	    key: 'n13',
	    get: function get() {
	      return this[8];
	    },
	    set: function set(val) {
	      this[8] = val;
	    }
	  }, {
	    key: 'n14',
	    get: function get() {
	      return this[12];
	    },
	    set: function set(val) {
	      this[12] = val;
	    }
	  }, {
	    key: 'n21',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(val) {
	      this[1] = val;
	    }
	  }, {
	    key: 'n22',
	    get: function get() {
	      return this[5];
	    },
	    set: function set(val) {
	      this[5] = val;
	    }
	  }, {
	    key: 'n23',
	    get: function get() {
	      return this[9];
	    },
	    set: function set(val) {
	      this[9] = val;
	    }
	  }, {
	    key: 'n24',
	    get: function get() {
	      return this[13];
	    },
	    set: function set(val) {
	      this[13] = val;
	    }
	  }, {
	    key: 'n31',
	    get: function get() {
	      return this[2];
	    },
	    set: function set(val) {
	      this[2] = val;
	    }
	  }, {
	    key: 'n32',
	    get: function get() {
	      return this[6];
	    },
	    set: function set(val) {
	      this[6] = val;
	    }
	  }, {
	    key: 'n33',
	    get: function get() {
	      return this[10];
	    },
	    set: function set(val) {
	      this[10] = val;
	    }
	  }, {
	    key: 'n34',
	    get: function get() {
	      return this[14];
	    },
	    set: function set(val) {
	      this[14] = val;
	    }
	  }, {
	    key: 'n41',
	    get: function get() {
	      return this[3];
	    },
	    set: function set(val) {
	      this[3] = val;
	    }
	  }, {
	    key: 'n42',
	    get: function get() {
	      return this[7];
	    },
	    set: function set(val) {
	      this[7] = val;
	    }
	  }, {
	    key: 'n43',
	    get: function get() {
	      return this[11];
	    },
	    set: function set(val) {
	      this[11] = val;
	    }
	  }, {
	    key: 'n44',
	    get: function get() {
	      return this[15];
	    },
	    set: function set(val) {
	      this[15] = val;
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      return new Array(16);
	    }
	  }]);
	
	  return Mat4;
	}(_extendableBuiltin3(Array));
	
	generics = {
	  id: function id(dest) {
	
	    dest[0] = 1;
	    dest[1] = 0;
	    dest[2] = 0;
	    dest[3] = 0;
	    dest[4] = 0;
	    dest[5] = 1;
	    dest[6] = 0;
	    dest[7] = 0;
	    dest[8] = 0;
	    dest[9] = 0;
	    dest[10] = 1;
	    dest[11] = 0;
	    dest[12] = 0;
	    dest[13] = 0;
	    dest[14] = 0;
	    dest[15] = 1;
	
	    return dest;
	  },
	  clone: function clone(dest) {
	    if (dest instanceof Mat4) {
	      return new Mat4(dest[0], dest[4], dest[8], dest[12], dest[1], dest[5], dest[9], dest[13], dest[2], dest[6], dest[10], dest[14], dest[3], dest[7], dest[11], dest[15]);
	    }
	    return new typedArray(dest);
	  },
	  set: function set(dest, n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
	
	    dest[0] = n11;
	    dest[4] = n12;
	    dest[8] = n13;
	    dest[12] = n14;
	    dest[1] = n21;
	    dest[5] = n22;
	    dest[9] = n23;
	    dest[13] = n24;
	    dest[2] = n31;
	    dest[6] = n32;
	    dest[10] = n33;
	    dest[14] = n34;
	    dest[3] = n41;
	    dest[7] = n42;
	    dest[11] = n43;
	    dest[15] = n44;
	
	    return dest;
	  },
	  mulVec3: function mulVec3(dest, vec) {
	    var ans = Vec3.clone(vec);
	    return Mat4.$mulVec3(dest, ans);
	  },
	  $mulVec3: function $mulVec3(dest, vec) {
	    var vx = vec[0],
	        vy = vec[1],
	        vz = vec[2],
	        d = 1 / (dest[3] * vx + dest[7] * vy + dest[11] * vz + dest[15]);
	
	    vec[0] = (dest[0] * vx + dest[4] * vy + dest[8] * vz + dest[12]) * d;
	    vec[1] = (dest[1] * vx + dest[5] * vy + dest[9] * vz + dest[13]) * d;
	    vec[2] = (dest[2] * vx + dest[6] * vy + dest[10] * vz + dest[14]) * d;
	
	    return vec;
	  },
	  mulMat42: function mulMat42(dest, a, b) {
	    var a11 = a[0],
	        a12 = a[1],
	        a13 = a[2],
	        a14 = a[3],
	        a21 = a[4],
	        a22 = a[5],
	        a23 = a[6],
	        a24 = a[7],
	        a31 = a[8],
	        a32 = a[9],
	        a33 = a[10],
	        a34 = a[11],
	        a41 = a[12],
	        a42 = a[13],
	        a43 = a[14],
	        a44 = a[15],
	        b11 = b[0],
	        b12 = b[1],
	        b13 = b[2],
	        b14 = b[3],
	        b21 = b[4],
	        b22 = b[5],
	        b23 = b[6],
	        b24 = b[7],
	        b31 = b[8],
	        b32 = b[9],
	        b33 = b[10],
	        b34 = b[11],
	        b41 = b[12],
	        b42 = b[13],
	        b43 = b[14],
	        b44 = b[15];
	
	    dest[0] = b11 * a11 + b12 * a21 + b13 * a31 + b14 * a41;
	    dest[1] = b11 * a12 + b12 * a22 + b13 * a32 + b14 * a42;
	    dest[2] = b11 * a13 + b12 * a23 + b13 * a33 + b14 * a43;
	    dest[3] = b11 * a14 + b12 * a24 + b13 * a34 + b14 * a44;
	
	    dest[4] = b21 * a11 + b22 * a21 + b23 * a31 + b24 * a41;
	    dest[5] = b21 * a12 + b22 * a22 + b23 * a32 + b24 * a42;
	    dest[6] = b21 * a13 + b22 * a23 + b23 * a33 + b24 * a43;
	    dest[7] = b21 * a14 + b22 * a24 + b23 * a34 + b24 * a44;
	
	    dest[8] = b31 * a11 + b32 * a21 + b33 * a31 + b34 * a41;
	    dest[9] = b31 * a12 + b32 * a22 + b33 * a32 + b34 * a42;
	    dest[10] = b31 * a13 + b32 * a23 + b33 * a33 + b34 * a43;
	    dest[11] = b31 * a14 + b32 * a24 + b33 * a34 + b34 * a44;
	
	    dest[12] = b41 * a11 + b42 * a21 + b43 * a31 + b44 * a41;
	    dest[13] = b41 * a12 + b42 * a22 + b43 * a32 + b44 * a42;
	    dest[14] = b41 * a13 + b42 * a23 + b43 * a33 + b44 * a43;
	    dest[15] = b41 * a14 + b42 * a24 + b43 * a34 + b44 * a44;
	    return dest;
	  },
	  mulMat4: function mulMat4(a, b) {
	    var m = Mat4.clone(a);
	    return Mat4.mulMat42(m, a, b);
	  },
	  $mulMat4: function $mulMat4(a, b) {
	    return Mat4.mulMat42(a, a, b);
	  },
	  add: function add(dest, m) {
	    var copy = Mat4.clone(dest);
	    return Mat4.$add(copy, m);
	  },
	  $add: function $add(dest, m) {
	    dest[0] += m[0];
	    dest[1] += m[1];
	    dest[2] += m[2];
	    dest[3] += m[3];
	    dest[4] += m[4];
	    dest[5] += m[5];
	    dest[6] += m[6];
	    dest[7] += m[7];
	    dest[8] += m[8];
	    dest[9] += m[9];
	    dest[10] += m[10];
	    dest[11] += m[11];
	    dest[12] += m[12];
	    dest[13] += m[13];
	    dest[14] += m[14];
	    dest[15] += m[15];
	
	    return dest;
	  },
	  transpose: function transpose(dest) {
	    var m = Mat4.clone(dest);
	    return Mat4.$transpose(m);
	  },
	  $transpose: function $transpose(dest) {
	    var n4 = dest[4],
	        n8 = dest[8],
	        n12 = dest[12],
	        n1 = dest[1],
	        n9 = dest[9],
	        n13 = dest[13],
	        n2 = dest[2],
	        n6 = dest[6],
	        n14 = dest[14],
	        n3 = dest[3],
	        n7 = dest[7],
	        n11 = dest[11];
	
	    dest[1] = n4;
	    dest[2] = n8;
	    dest[3] = n12;
	    dest[4] = n1;
	    dest[6] = n9;
	    dest[7] = n13;
	    dest[8] = n2;
	    dest[9] = n6;
	    dest[11] = n14;
	    dest[12] = n3;
	    dest[13] = n7;
	    dest[14] = n11;
	
	    return dest;
	  },
	  rotateAxis: function rotateAxis(dest, theta, vec) {
	    var m = Mat4.clone(dest);
	    return Mat4.$rotateAxis(m, theta, vec);
	  },
	  $rotateAxis: function $rotateAxis(dest, theta, vec) {
	    var s = sin(theta),
	        c = cos(theta),
	        nc = 1 - c,
	        vx = vec[0],
	        vy = vec[1],
	        vz = vec[2],
	        m11 = vx * vx * nc + c,
	        m12 = vx * vy * nc + vz * s,
	        m13 = vx * vz * nc - vy * s,
	        m21 = vy * vx * nc - vz * s,
	        m22 = vy * vy * nc + c,
	        m23 = vy * vz * nc + vx * s,
	        m31 = vx * vz * nc + vy * s,
	        m32 = vy * vz * nc - vx * s,
	        m33 = vz * vz * nc + c,
	        d11 = dest[0],
	        d12 = dest[1],
	        d13 = dest[2],
	        d14 = dest[3],
	        d21 = dest[4],
	        d22 = dest[5],
	        d23 = dest[6],
	        d24 = dest[7],
	        d31 = dest[8],
	        d32 = dest[9],
	        d33 = dest[10],
	        d34 = dest[11],
	        d41 = dest[12],
	        d42 = dest[13],
	        d43 = dest[14],
	        d44 = dest[15];
	
	    dest[0] = d11 * m11 + d21 * m12 + d31 * m13;
	    dest[1] = d12 * m11 + d22 * m12 + d32 * m13;
	    dest[2] = d13 * m11 + d23 * m12 + d33 * m13;
	    dest[3] = d14 * m11 + d24 * m12 + d34 * m13;
	
	    dest[4] = d11 * m21 + d21 * m22 + d31 * m23;
	    dest[5] = d12 * m21 + d22 * m22 + d32 * m23;
	    dest[6] = d13 * m21 + d23 * m22 + d33 * m23;
	    dest[7] = d14 * m21 + d24 * m22 + d34 * m23;
	
	    dest[8] = d11 * m31 + d21 * m32 + d31 * m33;
	    dest[9] = d12 * m31 + d22 * m32 + d32 * m33;
	    dest[10] = d13 * m31 + d23 * m32 + d33 * m33;
	    dest[11] = d14 * m31 + d24 * m32 + d34 * m33;
	
	    return dest;
	  },
	  rotateXYZ: function rotateXYZ(dest, rx, ry, rz) {
	    var ans = Mat4.clone(dest);
	    return Mat4.$rotateXYZ(ans, rx, ry, rz);
	  },
	  $rotateXYZ: function $rotateXYZ(dest, rx, ry, rz) {
	    var d11 = dest[0],
	        d12 = dest[1],
	        d13 = dest[2],
	        d14 = dest[3],
	        d21 = dest[4],
	        d22 = dest[5],
	        d23 = dest[6],
	        d24 = dest[7],
	        d31 = dest[8],
	        d32 = dest[9],
	        d33 = dest[10],
	        d34 = dest[11],
	        crx = cos(rx),
	        cry = cos(ry),
	        crz = cos(rz),
	        srx = sin(rx),
	        sry = sin(ry),
	        srz = sin(rz),
	        m11 = cry * crz,
	        m21 = -crx * srz + srx * sry * crz,
	        m31 = srx * srz + crx * sry * crz,
	        m12 = cry * srz,
	        m22 = crx * crz + srx * sry * srz,
	        m32 = -srx * crz + crx * sry * srz,
	        m13 = -sry,
	        m23 = srx * cry,
	        m33 = crx * cry;
	
	    dest[0] = d11 * m11 + d21 * m12 + d31 * m13;
	    dest[1] = d12 * m11 + d22 * m12 + d32 * m13;
	    dest[2] = d13 * m11 + d23 * m12 + d33 * m13;
	    dest[3] = d14 * m11 + d24 * m12 + d34 * m13;
	
	    dest[4] = d11 * m21 + d21 * m22 + d31 * m23;
	    dest[5] = d12 * m21 + d22 * m22 + d32 * m23;
	    dest[6] = d13 * m21 + d23 * m22 + d33 * m23;
	    dest[7] = d14 * m21 + d24 * m22 + d34 * m23;
	
	    dest[8] = d11 * m31 + d21 * m32 + d31 * m33;
	    dest[9] = d12 * m31 + d22 * m32 + d32 * m33;
	    dest[10] = d13 * m31 + d23 * m32 + d33 * m33;
	    dest[11] = d14 * m31 + d24 * m32 + d34 * m33;
	
	    return dest;
	  },
	  translate: function translate(dest, x, y, z) {
	    var m = Mat4.clone(dest);
	    return Mat4.$translate(m, x, y, z);
	  },
	  $translate: function $translate(dest, x, y, z) {
	    dest[12] = dest[0] * x + dest[4] * y + dest[8] * z + dest[12];
	    dest[13] = dest[1] * x + dest[5] * y + dest[9] * z + dest[13];
	    dest[14] = dest[2] * x + dest[6] * y + dest[10] * z + dest[14];
	    dest[15] = dest[3] * x + dest[7] * y + dest[11] * z + dest[15];
	
	    return dest;
	  },
	  scale: function scale(dest, x, y, z) {
	    var m = Mat4.clone(dest);
	    return Mat4.$scale(m, x, y, z);
	  },
	  $scale: function $scale(dest, x, y, z) {
	    dest[0] *= x;
	    dest[1] *= x;
	    dest[2] *= x;
	    dest[3] *= x;
	    dest[4] *= y;
	    dest[5] *= y;
	    dest[6] *= y;
	    dest[7] *= y;
	    dest[8] *= z;
	    dest[9] *= z;
	    dest[10] *= z;
	    dest[11] *= z;
	
	    return dest;
	  },
	
	
	  // Method based on PreGL https:// github.com/deanm/pregl/ (c) Dean McNamee.
	  invert: function invert(dest) {
	    var m = Mat4.clone(dest);
	    return Mat4.$invert(m);
	  },
	  $invert: function $invert(dest) {
	    var x0 = dest[0],
	        x1 = dest[1],
	        x2 = dest[2],
	        x3 = dest[3],
	        x4 = dest[4],
	        x5 = dest[5],
	        x6 = dest[6],
	        x7 = dest[7],
	        x8 = dest[8],
	        x9 = dest[9],
	        x10 = dest[10],
	        x11 = dest[11],
	        x12 = dest[12],
	        x13 = dest[13],
	        x14 = dest[14],
	        x15 = dest[15];
	
	    var a0 = x0 * x5 - x1 * x4,
	        a1 = x0 * x6 - x2 * x4,
	        a2 = x0 * x7 - x3 * x4,
	        a3 = x1 * x6 - x2 * x5,
	        a4 = x1 * x7 - x3 * x5,
	        a5 = x2 * x7 - x3 * x6,
	        b0 = x8 * x13 - x9 * x12,
	        b1 = x8 * x14 - x10 * x12,
	        b2 = x8 * x15 - x11 * x12,
	        b3 = x9 * x14 - x10 * x13,
	        b4 = x9 * x15 - x11 * x13,
	        b5 = x10 * x15 - x11 * x14;
	
	    var invdet = 1 / (a0 * b5 - a1 * b4 + a2 * b3 + a3 * b2 - a4 * b1 + a5 * b0);
	
	    dest[0] = (+x5 * b5 - x6 * b4 + x7 * b3) * invdet;
	    dest[1] = (-x1 * b5 + x2 * b4 - x3 * b3) * invdet;
	    dest[2] = (+x13 * a5 - x14 * a4 + x15 * a3) * invdet;
	    dest[3] = (-x9 * a5 + x10 * a4 - x11 * a3) * invdet;
	    dest[4] = (-x4 * b5 + x6 * b2 - x7 * b1) * invdet;
	    dest[5] = (+x0 * b5 - x2 * b2 + x3 * b1) * invdet;
	    dest[6] = (-x12 * a5 + x14 * a2 - x15 * a1) * invdet;
	    dest[7] = (+x8 * a5 - x10 * a2 + x11 * a1) * invdet;
	    dest[8] = (+x4 * b4 - x5 * b2 + x7 * b0) * invdet;
	    dest[9] = (-x0 * b4 + x1 * b2 - x3 * b0) * invdet;
	    dest[10] = (+x12 * a4 - x13 * a2 + x15 * a0) * invdet;
	    dest[11] = (-x8 * a4 + x9 * a2 - x11 * a0) * invdet;
	    dest[12] = (-x4 * b3 + x5 * b1 - x6 * b0) * invdet;
	    dest[13] = (+x0 * b3 - x1 * b1 + x2 * b0) * invdet;
	    dest[14] = (-x12 * a3 + x13 * a1 - x14 * a0) * invdet;
	    dest[15] = (+x8 * a3 - x9 * a1 + x10 * a0) * invdet;
	
	    return dest;
	  },
	
	  // TODO(nico) breaking convention here...
	  // because I don't think it's useful to add
	  // two methods for each of these.
	  lookAt: function lookAt(dest, eye, center, up) {
	    var z = Vec3.sub(eye, center);
	    z.$unit();
	    var x = Vec3.cross(up, z);
	    x.$unit();
	    var y = Vec3.cross(z, x);
	    y.$unit();
	    return Mat4.set(dest, x[0], x[1], x[2], -x.dot(eye), y[0], y[1], y[2], -y.dot(eye), z[0], z[1], z[2], -z.dot(eye), 0, 0, 0, 1);
	  },
	  frustum: function frustum(dest, left, right, bottom, top, near, far) {
	    var rl = right - left,
	        tb = top - bottom,
	        fn = far - near;
	
	    dest[0] = near * 2 / rl;
	    dest[1] = 0;
	    dest[2] = 0;
	    dest[3] = 0;
	    dest[4] = 0;
	    dest[5] = near * 2 / tb;
	    dest[6] = 0;
	    dest[7] = 0;
	    dest[8] = (right + left) / rl;
	    dest[9] = (top + bottom) / tb;
	    dest[10] = -(far + near) / fn;
	    dest[11] = -1;
	    dest[12] = 0;
	    dest[13] = 0;
	    dest[14] = -(far * near * 2) / fn;
	    dest[15] = 0;
	
	    return dest;
	  },
	  perspective: function perspective(dest, fov, aspect, near, far) {
	    var ymax = near * tan(fov * pi / 360),
	        ymin = -ymax,
	        xmin = ymin * aspect,
	        xmax = ymax * aspect;
	
	    return Mat4.frustum(dest, xmin, xmax, ymin, ymax, near, far);
	  },
	  ortho: function ortho(dest, left, right, top, bottom, near, far) {
	    var te = this.elements,
	        w = right - left,
	        h = top - bottom,
	        p = far - near,
	        x = (right + left) / w,
	        y = (top + bottom) / h,
	        z = (far + near) / p;
	
	    dest[0] = 2 / w;dest[4] = 0;dest[8] = 0;dest[12] = -x;
	    dest[1] = 0;dest[5] = 2 / h;dest[9] = 0;dest[13] = -y;
	    dest[2] = 0;dest[6] = 0;dest[10] = -2 / p;dest[14] = -z;
	    dest[3] = 0;dest[7] = 0;dest[11] = 0;dest[15] = 1;
	
	    return dest;
	  },
	  toFloat32Array: function toFloat32Array(dest) {
	    var ans = dest.typedContainer;
	
	    if (!ans) {
	      return dest;
	    }
	
	    ans[0] = dest[0];
	    ans[1] = dest[1];
	    ans[2] = dest[2];
	    ans[3] = dest[3];
	    ans[4] = dest[4];
	    ans[5] = dest[5];
	    ans[6] = dest[6];
	    ans[7] = dest[7];
	    ans[8] = dest[8];
	    ans[9] = dest[9];
	    ans[10] = dest[10];
	    ans[11] = dest[11];
	    ans[12] = dest[12];
	    ans[13] = dest[13];
	    ans[14] = dest[14];
	    ans[15] = dest[15];
	
	    return ans;
	  }
	};
	
	// add generics and instance methods
	proto = Mat4.prototype;
	for (method in generics) {
	  Mat4[method] = generics[method];
	  proto[method] = function (m) {
	    return function () {
	      var args = slice.call(arguments);
	
	      args.unshift(this);
	      return Mat4[m].apply(Mat4, args);
	    };
	  }(method);
	}
	
	// Quaternion class
	
	var Quat = exports.Quat = function (_extendableBuiltin6) {
	  _inherits(Quat, _extendableBuiltin6);
	
	  function Quat(x, y, z, w) {
	    _classCallCheck(this, Quat);
	
	    var _this3 = _possibleConstructorReturn(this, (Quat.__proto__ || Object.getPrototypeOf(Quat)).call(this, 4));
	
	    _this3[0] = x || 0;
	    _this3[1] = y || 0;
	    _this3[2] = z || 0;
	    _this3[3] = w || 0;
	
	    _this3.typedContainer = new Float32Array(4);
	    return _this3;
	  }
	
	  _createClass(Quat, null, [{
	    key: 'create',
	    value: function create() {
	      return new Array(4);
	    }
	  }, {
	    key: 'fromVec3',
	    value: function fromVec3(v, r) {
	      return new Quat(v[0], v[1], v[2], r || 0);
	    }
	  }, {
	    key: 'fromMat4',
	    value: function fromMat4(m) {
	      var u;
	      var v;
	      var w;
	
	      // Choose u, v, and w such that u is the index of the biggest diagonal entry
	      // of m, and u v w is an even permutation of 0 1 and 2.
	      if (m[0] > m[5] && m[0] > m[10]) {
	        u = 0;
	        v = 1;
	        w = 2;
	      } else if (m[5] > m[0] && m[5] > m[10]) {
	        u = 1;
	        v = 2;
	        w = 0;
	      } else {
	        u = 2;
	        v = 0;
	        w = 1;
	      }
	
	      var r = sqrt(1 + m[u * 5] - m[v * 5] - m[w * 5]);
	      var q = new Quat();
	
	      q[u] = 0.5 * r;
	      q[v] = 0.5 * (m['n' + v + '' + u] + m['n' + u + '' + v]) / r;
	      q[w] = 0.5 * (m['n' + u + '' + w] + m['n' + w + '' + u]) / r;
	      q[3] = 0.5 * (m['n' + v + '' + w] - m['n' + w + '' + v]) / r;
	
	      return q;
	    }
	  }, {
	    key: 'fromXRotation',
	    value: function fromXRotation(angle) {
	      return new Quat(sin(angle / 2), 0, 0, cos(angle / 2));
	    }
	  }, {
	    key: 'fromYRotation',
	    value: function fromYRotation(angle) {
	      return new Quat(0, sin(angle / 2), 0, cos(angle / 2));
	    }
	  }, {
	    key: 'fromZRotation',
	    value: function fromZRotation(angle) {
	      return new Quat(0, 0, sin(angle / 2), cos(angle / 2));
	    }
	  }, {
	    key: 'fromAxisRotation',
	    value: function fromAxisRotation(vec, angle) {
	      var x = vec[0],
	          y = vec[1],
	          z = vec[2],
	          d = 1 / sqrt(x * x + y * y + z * z),
	          s = sin(angle / 2),
	          c = cos(angle / 2);
	
	      return new Quat(s * x * d, s * y * d, s * z * d, c);
	    }
	  }]);
	
	  return Quat;
	}(_extendableBuiltin5(Array));
	
	generics = {
	  setQuat: function setQuat(dest, q) {
	    dest[0] = q[0];
	    dest[1] = q[1];
	    dest[2] = q[2];
	    dest[3] = q[3];
	
	    return dest;
	  },
	  set: function set(dest, x, y, z, w) {
	    dest[0] = x || 0;
	    dest[1] = y || 0;
	    dest[2] = z || 0;
	    dest[3] = w || 0;
	
	    return dest;
	  },
	  clone: function clone(dest) {
	    if (dest instanceof Quat) {
	      return new Quat(dest[0], dest[1], dest[2], dest[3]);
	    }
	    return Quat.setQuat(new typedArray(4), dest);
	  },
	  neg: function neg(dest) {
	    return new Quat(-dest[0], -dest[1], -dest[2], -dest[3]);
	  },
	  $neg: function $neg(dest) {
	    dest[0] = -dest[0];
	    dest[1] = -dest[1];
	    dest[2] = -dest[2];
	    dest[3] = -dest[3];
	
	    return dest;
	  },
	  add: function add(dest, q) {
	    return new Quat(dest[0] + q[0], dest[1] + q[1], dest[2] + q[2], dest[3] + q[3]);
	  },
	  $add: function $add(dest, q) {
	    dest[0] += q[0];
	    dest[1] += q[1];
	    dest[2] += q[2];
	    dest[3] += q[3];
	
	    return dest;
	  },
	  sub: function sub(dest, q) {
	    return new Quat(dest[0] - q[0], dest[1] - q[1], dest[2] - q[2], dest[3] - q[3]);
	  },
	  $sub: function $sub(dest, q) {
	    dest[0] -= q[0];
	    dest[1] -= q[1];
	    dest[2] -= q[2];
	    dest[3] -= q[3];
	
	    return dest;
	  },
	  scale: function scale(dest, s) {
	    return new Quat(dest[0] * s, dest[1] * s, dest[2] * s, dest[3] * s);
	  },
	  $scale: function $scale(dest, s) {
	    dest[0] *= s;
	    dest[1] *= s;
	    dest[2] *= s;
	    dest[3] *= s;
	
	    return dest;
	  },
	  mulQuat: function mulQuat(dest, q) {
	    var aX = dest[0],
	        aY = dest[1],
	        aZ = dest[2],
	        aW = dest[3],
	        bX = q[0],
	        bY = q[1],
	        bZ = q[2],
	        bW = q[3];
	
	    return new Quat(aW * bX + aX * bW + aY * bZ - aZ * bY, aW * bY + aY * bW + aZ * bX - aX * bZ, aW * bZ + aZ * bW + aX * bY - aY * bX, aW * bW - aX * bX - aY * bY - aZ * bZ);
	  },
	  $mulQuat: function $mulQuat(dest, q) {
	    var aX = dest[0],
	        aY = dest[1],
	        aZ = dest[2],
	        aW = dest[3],
	        bX = q[0],
	        bY = q[1],
	        bZ = q[2],
	        bW = q[3];
	
	    dest[0] = aW * bX + aX * bW + aY * bZ - aZ * bY;
	    dest[1] = aW * bY + aY * bW + aZ * bX - aX * bZ;
	    dest[2] = aW * bZ + aZ * bW + aX * bY - aY * bX;
	    dest[3] = aW * bW - aX * bX - aY * bY - aZ * bZ;
	
	    return dest;
	  },
	  divQuat: function divQuat(dest, q) {
	    var aX = dest[0],
	        aY = dest[1],
	        aZ = dest[2],
	        aW = dest[3],
	        bX = q[0],
	        bY = q[1],
	        bZ = q[2],
	        bW = q[3];
	
	    var d = 1 / (bW * bW + bX * bX + bY * bY + bZ * bZ);
	
	    return new Quat((aX * bW - aW * bX - aY * bZ + aZ * bY) * d, (aX * bZ - aW * bY + aY * bW - aZ * bX) * d, (aY * bX + aZ * bW - aW * bZ - aX * bY) * d, (aW * bW + aX * bX + aY * bY + aZ * bZ) * d);
	  },
	  $divQuat: function $divQuat(dest, q) {
	    var aX = dest[0],
	        aY = dest[1],
	        aZ = dest[2],
	        aW = dest[3],
	        bX = q[0],
	        bY = q[1],
	        bZ = q[2],
	        bW = q[3];
	
	    var d = 1 / (bW * bW + bX * bX + bY * bY + bZ * bZ);
	
	    dest[0] = (aX * bW - aW * bX - aY * bZ + aZ * bY) * d;
	    dest[1] = (aX * bZ - aW * bY + aY * bW - aZ * bX) * d;
	    dest[2] = (aY * bX + aZ * bW - aW * bZ - aX * bY) * d;
	    dest[3] = (aW * bW + aX * bX + aY * bY + aZ * bZ) * d;
	
	    return dest;
	  },
	  invert: function invert(dest) {
	    var q0 = dest[0],
	        q1 = dest[1],
	        q2 = dest[2],
	        q3 = dest[3];
	
	    var d = 1 / (q0 * q0 + q1 * q1 + q2 * q2 + q3 * q3);
	
	    return new Quat(-q0 * d, -q1 * d, -q2 * d, q3 * d);
	  },
	  $invert: function $invert(dest) {
	    var q0 = dest[0],
	        q1 = dest[1],
	        q2 = dest[2],
	        q3 = dest[3];
	
	    var d = 1 / (q0 * q0 + q1 * q1 + q2 * q2 + q3 * q3);
	
	    dest[0] = -q0 * d;
	    dest[1] = -q1 * d;
	    dest[2] = -q2 * d;
	    dest[3] = q3 * d;
	
	    return dest;
	  },
	  norm: function norm(dest) {
	    var a = dest[0],
	        b = dest[1],
	        c = dest[2],
	        d = dest[3];
	
	    return sqrt(a * a + b * b + c * c + d * d);
	  },
	  normSq: function normSq(dest) {
	    var a = dest[0],
	        b = dest[1],
	        c = dest[2],
	        d = dest[3];
	
	    return a * a + b * b + c * c + d * d;
	  },
	  unit: function unit(dest) {
	    return Quat.scale(dest, 1 / Quat.norm(dest));
	  },
	  $unit: function $unit(dest) {
	    return Quat.$scale(dest, 1 / Quat.norm(dest));
	  },
	  conjugate: function conjugate(dest) {
	    return new Quat(-dest[0], -dest[1], -dest[2], dest[3]);
	  },
	  $conjugate: function $conjugate(dest) {
	    dest[0] = -dest[0];
	    dest[1] = -dest[1];
	    dest[2] = -dest[2];
	    return dest;
	  }
	};
	
	// add generics and instance methods
	
	proto = Quat.prototype = {};
	
	for (method in generics) {
	  Quat[method] = generics[method];
	  proto[method] = function (m) {
	    return function () {
	      var args = slice.call(arguments);
	
	      args.unshift(this);
	      return Quat[m].apply(Quat, args);
	    };
	  }(method);
	}
	
	// Add static methods
	Vec3.fromQuat = function (q) {
	  return new Vec3(q[0], q[1], q[2]);
	};
	
	Mat4.fromQuat = function (q) {
	  var a = q[3],
	      b = q[0],
	      c = q[1],
	      d = q[2];
	
	  return new Mat4(a * a + b * b - c * c - d * d, 2 * b * c - 2 * a * d, 2 * b * d + 2 * a * c, 0, 2 * b * c + 2 * a * d, a * a - b * b + c * c - d * d, 2 * c * d - 2 * a * b, 0, 2 * b * d - 2 * a * c, 2 * c * d + 2 * a * b, a * a - b * b - c * c + d * d, 0, 0, 0, 0, 1);
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object3d = __webpack_require__(294);
	
	var _object3d2 = _interopRequireDefault(_object3d);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Group = function (_Object3D) {
	  _inherits(Group, _Object3D);
	
	  function Group() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Group);
	
	    var _opts$children = opts.children,
	        children = _opts$children === undefined ? [] : _opts$children;
	
	    children.every(function (child) {
	      return (0, _assert2.default)(child instanceof _object3d2.default);
	    });
	
	    var _this = _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).call(this, opts));
	
	    _this.children = children;
	    return _this;
	  }
	
	  // Unpacks arrays and nested arrays of children
	
	
	  _createClass(Group, [{
	    key: 'add',
	    value: function add() {
	      for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
	        children[_key] = arguments[_key];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var child = _step.value;
	
	          if (Array.isArray(child)) {
	            this.add.apply(this, _toConsumableArray(child));
	          } else {
	            this.children.push(child);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return this;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(child) {
	      var children = this.children;
	      var indexOf = children.indexOf(child);
	      if (indexOf > -1) {
	        children.splice(indexOf, 1);
	      }
	      return this;
	    }
	  }, {
	    key: 'removeAll',
	    value: function removeAll() {
	      this.children = [];
	      return this;
	    }
	  }]);
	
	  return Group;
	}(_object3d2.default);
	
	exports.default = Group;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(30);
	
	var _math = __webpack_require__(292);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Object3D = function () {
	  function Object3D(_ref) {
	    var id = _ref.id,
	        _ref$display = _ref.display,
	        display = _ref$display === undefined ? true : _ref$display;
	
	    _classCallCheck(this, Object3D);
	
	    // model position, rotation, scale and all in all matrix
	    this.position = new _math.Vec3();
	    this.rotation = new _math.Vec3();
	    this.scale = new _math.Vec3(1, 1, 1);
	    this.matrix = new _math.Mat4();
	
	    // whether to display the object at all
	    this.id = id || (0, _utils.uid)(this.constructor.name);
	    this.display = true;
	    this.userData = {};
	  }
	
	  _createClass(Object3D, [{
	    key: 'setPosition',
	    value: function setPosition(position) {
	      (0, _assert2.default)(position.length === 3, 'setPosition requires vector argument');
	      this.position = position;
	      return this;
	    }
	  }, {
	    key: 'setRotation',
	    value: function setRotation(rotation) {
	      (0, _assert2.default)(rotation.length === 3, 'setRotation requires vector argument');
	      this.rotation = rotation;
	      return this;
	    }
	  }, {
	    key: 'setScale',
	    value: function setScale(scale) {
	      (0, _assert2.default)(scale.length === 3, 'setScale requires vector argument');
	      this.scale = scale;
	      return this;
	    }
	  }, {
	    key: 'setMatrixComponents',
	    value: function setMatrixComponents(_ref2) {
	      var position = _ref2.position,
	          rotation = _ref2.rotation,
	          scale = _ref2.scale,
	          _ref2$update = _ref2.update,
	          update = _ref2$update === undefined ? true : _ref2$update;
	
	      if (position) {
	        this.setPosition(position);
	      }
	      if (rotation) {
	        this.setRotation(rotation);
	      }
	      if (scale) {
	        this.setScale(scale);
	      }
	      if (update) {
	        this.updateMatrix();
	      }
	      return this;
	    }
	  }, {
	    key: 'updateMatrix',
	    value: function updateMatrix() {
	      var pos = this.position;
	      var rot = this.rotation;
	      var scale = this.scale;
	
	      this.matrix.id();
	      this.matrix.$translate(pos[0], pos[1], pos[2]);
	      this.matrix.$rotateXYZ(rot[0], rot[1], rot[2]);
	      this.matrix.$scale(scale[0], scale[1], scale[2]);
	      return this;
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          position = _ref3.position,
	          rotation = _ref3.rotation,
	          scale = _ref3.scale;
	
	      if (position) {
	        this.setPosition(position);
	      }
	      if (rotation) {
	        this.setRotation(rotation);
	      }
	      if (scale) {
	        this.setScale(scale);
	      }
	      this.updateMatrix();
	      return this;
	    }
	  }, {
	    key: 'getCoordinateUniforms',
	    value: function getCoordinateUniforms(viewMatrix, modelMatrix) {
	      // TODO - solve multiple class problem
	      // assert(viewMatrix instanceof Mat4);
	      (0, _assert2.default)(viewMatrix);
	      modelMatrix = modelMatrix || this.matrix;
	      var worldMatrix = new _math.Mat4().copy(viewMatrix).mulMat4(modelMatrix);
	      var worldInverse = worldMatrix.invert();
	      var worldInverseTranspose = worldInverse.transpose();
	
	      return {
	        viewMatrix: viewMatrix,
	        modelMatrix: modelMatrix,
	        objectMatrix: modelMatrix,
	        worldMatrix: worldMatrix,
	        worldInverseMatrix: worldInverse,
	        worldInverseTransposeMatrix: worldInverseTranspose
	      };
	    }
	
	    // TODO - copied code, not yet vetted
	
	  }, {
	    key: 'transform',
	    value: function transform() {
	
	      if (!this.parent) {
	        this.endPosition.setVec3(this.position);
	        this.endRotation.setVec3(this.rotation);
	        this.endScale.setVec3(this.scale);
	      } else {
	        var parent = this.parent;
	        this.endPosition.setVec3(this.position.add(parent.endPosition));
	        this.endRotation.setVec3(this.rotation.add(parent.endRotation));
	        this.endScale.setVec3(this.scale.add(parent.endScale));
	      }
	
	      var ch = this.children;
	      for (var i = 0; i < ch.length; ++i) {
	        ch[i].transform();
	      }
	
	      return this;
	    }
	  }]);
	
	  return Object3D;
	}();
	
	exports.default = Object3D;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mathArray = __webpack_require__(130);
	
	var _mathArray2 = _interopRequireDefault(_mathArray);
	
	var _common = __webpack_require__(85);
	
	var _vector = __webpack_require__(297);
	
	var _vector2 = _interopRequireDefault(_vector);
	
	var _vector3 = __webpack_require__(214);
	
	var _vector4 = _interopRequireDefault(_vector3);
	
	var _vector5 = __webpack_require__(298);
	
	var _vector6 = _interopRequireDefault(_vector5);
	
	var _glMatrix = __webpack_require__(55);
	
	var _validators = __webpack_require__(1062);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Matrix4 = function (_MathArray) {
	  _inherits(Matrix4, _MathArray);
	
	  function Matrix4() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Matrix4);
	
	    var _this = _possibleConstructorReturn(this, (Matrix4.__proto__ || Object.getPrototypeOf(Matrix4)).call(this));
	
	    if (Array.isArray(args[0]) && arguments.length === 1) {
	      _this.copy(args[0]);
	    } else {
	      _this.identity();
	    }
	    return _this;
	  }
	
	  _createClass(Matrix4, [{
	    key: 'setRowMajor',
	
	
	    /* eslint-disable max-params */
	    value: function setRowMajor() {
	      var m00 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var m10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var m20 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var m30 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var m01 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	      var m11 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
	      var m21 = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	      var m31 = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
	      var m02 = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
	      var m12 = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
	      var m22 = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 1;
	      var m32 = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 0;
	      var m03 = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : 0;
	      var m13 = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : 0;
	      var m23 = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : 0;
	      var m33 = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : 1;
	
	      _glMatrix.mat4.set(this, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'setColumnMajor',
	    value: function setColumnMajor() {
	      var m00 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var m01 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var m02 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var m03 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var m10 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	      var m11 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
	      var m12 = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	      var m13 = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
	      var m20 = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
	      var m21 = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
	      var m22 = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 1;
	      var m23 = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 0;
	      var m30 = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : 0;
	      var m31 = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : 0;
	      var m32 = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : 0;
	      var m33 = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : 1;
	
	      _glMatrix.mat4.set(this, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
	      this.check();
	      return this;
	    }
	    /* eslint-enable max-params */
	
	  }, {
	    key: 'equals',
	    value: function equals(a) {
	      return _glMatrix.mat4.equals(this, a);
	    }
	  }, {
	    key: 'exactEquals',
	    value: function exactEquals(a) {
	      return _glMatrix.mat4.exactEquals(this, a);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      if (_common.glMatrix.printRowMajor) {
	        _glMatrix.mat4.str(this);
	      } else {
	        _glMatrix.mat4.str(this);
	      }
	    }
	
	    // Row major setters and getters
	    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
	
	  }, {
	    key: 'determinant',
	
	    /* eslint-enable no-multi-spaces, brace-style, no-return-assign */
	
	    // Accessors
	
	    value: function determinant() {
	      return _glMatrix.mat4.determinant(this);
	    }
	  }, {
	    key: 'getRotation',
	    value: function getRotation() {
	      throw new Error('Not implemented');
	    }
	
	    // Constructors
	
	  }, {
	    key: 'identity',
	    value: function identity() {
	      _glMatrix.mat4.identity(this);
	      this.check();
	      return this;
	    }
	
	    // Generates a frustum matrix with the given bounds
	    // left  Number  Left bound of the frustum
	    // right Number  Right bound of the frustum
	    // bottom  Number  Bottom bound of the frustum
	    // top Number  Top bound of the frustum
	    // near  Number  Near bound of the frustum
	    // far Number  Far bound of the frustum
	
	  }, {
	    key: 'frustum',
	    value: function frustum(_ref) {
	      var left = _ref.left,
	          right = _ref.right,
	          bottom = _ref.bottom,
	          top = _ref.top,
	          near = _ref.near,
	          far = _ref.far;
	
	      _glMatrix.mat4.frustum(this, left, right, bottom, top, near, far);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'lookAt',
	
	
	    // Generates a look-at matrix with the given eye position, focal point,
	    // and up axis
	    // eye vec3  Position of the viewer
	    // center  vec3  Point the viewer is looking at
	    // up  vec3  vec3 pointing up
	    value: function lookAt() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          eye = _ref2.eye,
	          _ref2$center = _ref2.center,
	          center = _ref2$center === undefined ? [0, 0, 0] : _ref2$center,
	          _ref2$up = _ref2.up,
	          up = _ref2$up === undefined ? [0, 1, 0] : _ref2$up;
	
	      _glMatrix.mat4.lookAt(this, eye, center, up);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'ortho',
	
	
	    // Generates a orthogonal projection matrix with the given bounds
	    // left  number  Left bound of the frustum
	    // right number  Right bound of the frustum
	    // bottom  number  Bottom bound of the frustum
	    // top number  Top bound of the frustum
	    // near  number  Near bound of the frustum
	    // far number  Far bound of the frustum
	    value: function ortho(_ref3) {
	      var left = _ref3.left,
	          right = _ref3.right,
	          bottom = _ref3.bottom,
	          top = _ref3.top,
	          _ref3$near = _ref3.near,
	          near = _ref3$near === undefined ? 0.1 : _ref3$near,
	          _ref3$far = _ref3.far,
	          far = _ref3$far === undefined ? 500 : _ref3$far;
	
	      _glMatrix.mat4.ortho(this, left, right, bottom, top, near, far);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'perspective',
	
	
	    // Generates a perspective projection matrix with the given bounds
	    // fovy  number  Vertical field of view in radians
	    // aspect  number  Aspect ratio. typically viewport width/height
	    // near  number  Near bound of the frustum
	    // far number  Far bound of the frustum
	    value: function perspective() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref4$fov = _ref4.fov,
	          fov = _ref4$fov === undefined ? 45 * Math.PI / 180 : _ref4$fov,
	          _ref4$aspect = _ref4.aspect,
	          aspect = _ref4$aspect === undefined ? 1 : _ref4$aspect,
	          _ref4$near = _ref4.near,
	          near = _ref4$near === undefined ? 0.1 : _ref4$near,
	          _ref4$far = _ref4.far,
	          far = _ref4$far === undefined ? 500 : _ref4$far;
	
	      if (fov > Math.PI * 2) {
	        throw Error('radians');
	      }
	      _glMatrix.mat4.perspective(this, fov, aspect, near, far);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'perspectiveFromFieldOfView',
	
	
	    // Generates a perspective projection matrix with the given field of view.
	    // This is primarily useful for generating projection matrices to be used
	    // with the still experiemental WebVR API.
	    // fov Object  Object containing the following values:
	    //   upDegrees, downDegrees, leftDegrees, rightDegrees
	    // near  number  Near bound of the frustum
	    // far number  Far bound of the frustum
	    value: function perspectiveFromFieldOfView(out, fov, near, far) {
	      _glMatrix.mat4.perspectiveFromFieldOfView(out, fov, near, far);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'fromQuaternion',
	
	
	    // Calculates a 4x4 matrix from the given quaternion
	    // q quat  Quaternion to create matrix from
	    value: function fromQuaternion(q) {
	      _glMatrix.mat4.fromQuat(this, q);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'fromRotation',
	
	
	    // Creates a matrix from a given angle around a given axis
	    // his is equivalent to (but much faster than): mat4.identity(dest);
	    // mat4.rotate(dest, dest, rad, axis);
	    // rad Number  the angle to rotate the matrix by
	    // axis  vec3  the axis to rotate around
	    value: function fromRotation(rad, axis) {
	      _glMatrix.mat4.fromRotation(this, rad, axis);
	      this.check();
	      return this;
	    }
	
	    // Creates a matrix from a quaternion rotation and vector translation
	    // This is equivalent to (but much faster than): mat4.identity(dest);
	    // mat4.translate(dest, vec);
	    // var quatMat = mat4.create();
	    // quat4.toMat4(quat, quatMat);
	    // mat4.multiply(dest, quatMat);
	    // q quat4 Rotation quaternion
	    // v vec3  Translation vector
	
	  }, {
	    key: 'fromRotationTranslation',
	    value: function fromRotationTranslation(q, v) {
	      _glMatrix.mat4.fromRotationTranslation(this, q, v);
	      this.check();
	      return this;
	    }
	
	    // Creates a matrix from a quaternion rotation,
	    // vector translation and vector scale
	    // This is equivalent to (but much faster than):
	    // mat4.identity(dest);
	    // mat4.translate(dest, vec);
	    // var quatMat = mat4.create();
	    // quat4.toMat4(quat, quatMat);
	    // mat4.multiply(dest, quatMat);
	    // mat4.scale(dest, scale)
	    // q quat4 Rotation quaternion
	    // v vec3  Translation vector
	    // s vec3  Scaling vector
	
	  }, {
	    key: 'fromRotationTranslationScale',
	    value: function fromRotationTranslationScale(q, v, s) {
	      _glMatrix.mat4.fromRotationTranslationScale(this, q, v, s);
	      this.check();
	      return this;
	    }
	
	    // Creates a matrix from a quaternion rotation, vector translation and
	    // vector scale, rotating and scaling around the given origin
	    // This is equivalent to (but much faster than):
	    // mat4.identity(dest);
	    // mat4.translate(dest, vec);
	    // mat4.translate(dest, origin);
	    // var quatMat = mat4.create();
	    // quat4.toMat4(quat, quatMat);
	    // mat4.multiply(dest, quatMat);
	    // mat4.scale(dest, scale)
	    // mat4.translate(dest, negativeOrigin);
	    // q quat4 Rotation quaternion
	    // v vec3  Translation vector
	    // s vec3  Scaling vector
	    // o vec3  The origin vector around which to scale and rotate
	
	  }, {
	    key: 'fromRotationTranslationScaleOrigin',
	    value: function fromRotationTranslationScaleOrigin(q, v, s, o) {
	      _glMatrix.mat4.fromRotationTranslationScaleOrigin(this, q, v, s, o);
	      this.check();
	      return this;
	    }
	
	    // Creates a matrix from a vector scaling This is equivalent to
	    // (but much faster than):
	    // mat4.identity(dest); mat4.scale(dest, dest, vec);
	    // v vec3  Scaling vector
	
	  }, {
	    key: 'fromScaling',
	    value: function fromScaling(v) {
	      _glMatrix.mat4.fromScaling(this, v);
	      this.check();
	      return this;
	    }
	
	    // Creates a matrix from a vector translation
	    // This is equivalent to (but much faster than):
	    // mat4.identity(dest); mat4.translate(dest, dest, vec);
	    // v vec3  Translation vector
	
	  }, {
	    key: 'fromTranslation',
	    value: function fromTranslation(v) {
	      _glMatrix.mat4.fromTranslation(this, v);
	      this.check();
	      return this;
	    }
	
	    // Create a new mat4 with the given values
	    // m00 Number  Component in column 0, row 0 position (index 0)
	    // m01 Number  Component in column 0, row 1 position (index 1)
	    // m02 Number  Component in column 0, row 2 position (index 2)
	    // m03 Number  Component in column 0, row 3 position (index 3)
	    // m10 Number  Component in column 1, row 0 position (index 4)
	    // m11 Number  Component in column 1, row 1 position (index 5)
	    // m12 Number  Component in column 1, row 2 position (index 6)
	    // m13 Number  Component in column 1, row 3 position (index 7)
	    // m20 Number  Component in column 2, row 0 position (index 8)
	    // m21 Number  Component in column 2, row 1 position (index 9)
	    // m22 Number  Component in column 2, row 2 position (index 10)
	    // m23 Number  Component in column 2, row 3 position (index 11)
	    // m30 Number  Component in column 3, row 0 position (index 12)
	    // m31 Number  Component in column 3, row 1 position (index 13)
	    // m32 Number  Component in column 3, row 2 position (index 14)
	    // m33 Number  Component in column 3, row 3 position (index 15)
	    // fromValues(m00, m01, m02, m03, m10, m11, m12, m13,
	    //   m20, m21, m22, m23, m30, m31, m32, m33) {mat4}
	
	    // Creates a matrix from the given angle around the X axis
	    // This is equivalent to (but much faster than):
	    // mat4.identity(dest);
	    // mat4.rotateX(dest, dest, rad);
	    // rad Number  the angle to rotate the matrix by
	
	  }, {
	    key: 'fromXRotation',
	    value: function fromXRotation(rad) {
	      _glMatrix.mat4.fromXRotation(this, rad);
	      this.check();
	      return this;
	    }
	
	    // Creates a matrix from the given angle around the Y axis
	    // This is equivalent to (but much faster than):
	    // mat4.identity(dest);
	    // mat4.rotateY(dest, dest, rad);
	    // rad Number  the angle to rotate the matrix by
	
	  }, {
	    key: 'fromYRotation',
	    value: function fromYRotation(rad) {
	      _glMatrix.mat4.fromYRotation(this, rad);
	      this.check();
	      return this;
	    }
	
	    // Creates a matrix from the given angle around the Z axis
	    // This is equivalent to (but much faster than):
	    // mat4.identity(dest);
	    // mat4.rotateZ(dest, dest, rad);
	    // rad Number  the angle to rotate the matrix by
	
	  }, {
	    key: 'fromZRotation',
	    value: function fromZRotation(rad) {
	      _glMatrix.mat4.fromZRotation(this, rad);
	      this.check();
	      return this;
	    }
	
	    // Modifiers
	
	  }, {
	    key: 'transpose',
	    value: function transpose() {
	      _glMatrix.mat4.transpose(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'invert',
	    value: function invert() {
	      _glMatrix.mat4.invert(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'adjoint',
	    value: function adjoint() {
	      _glMatrix.mat4.adjoint(this, this);
	      this.check();
	      return this;
	    }
	
	    // Operations
	
	  }, {
	    key: 'add',
	    value: function add(a, b) {
	      _glMatrix.mat4.add(this, this, a);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'multiplyLeft',
	    value: function multiplyLeft(a) {
	      _glMatrix.mat4.multiply(this, a, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'multiplyRight',
	    value: function multiplyRight(a) {
	      _glMatrix.mat4.multiply(this, this, a);
	      this.check();
	      return this;
	    }
	
	    // Rotates a matrix by the given angle around the X axis
	    // uses SIMD if available and enabled
	
	  }, {
	    key: 'rotateX',
	    value: function rotateX(radians) {
	      _glMatrix.mat4.rotateX(this, this, radians);
	      this.check();
	      return this;
	    }
	
	    // Rotates a matrix by the given angle around the Y axis.
	    // Uses SIMD if available and enabled
	
	  }, {
	    key: 'rotateY',
	    value: function rotateY(radians) {
	      _glMatrix.mat4.rotateY(this, this, radians);
	      this.check();
	      return this;
	    }
	
	    // Rotates a matrix by the given angle around the Z axis.
	    // Uses SIMD if available and enabled
	
	  }, {
	    key: 'rotateZ',
	    value: function rotateZ(radians) {
	      _glMatrix.mat4.rotateZ(this, this, radians);
	      this.check();
	      return this;
	    }
	
	    // TODO - may not be needed
	    /* eslint-disable max-statements */
	
	  }, {
	    key: 'rotateXYZ',
	    value: function rotateXYZ(_ref5) {
	      var _ref6 = _slicedToArray(_ref5, 3),
	          rx = _ref6[0],
	          ry = _ref6[1],
	          rz = _ref6[2];
	
	      var d11 = this[0];
	      var d12 = this[1];
	      var d13 = this[2];
	      var d14 = this[3];
	      var d21 = this[4];
	      var d22 = this[5];
	      var d23 = this[6];
	      var d24 = this[7];
	      var d31 = this[8];
	      var d32 = this[9];
	      var d33 = this[10];
	      var d34 = this[11];
	      var crx = Math.cos(rx);
	      var cry = Math.cos(ry);
	      var crz = Math.cos(rz);
	      var srx = Math.sin(rx);
	      var sry = Math.sin(ry);
	      var srz = Math.sin(rz);
	      var m11 = cry * crz;
	      var m21 = -crx * srz + srx * sry * crz;
	      var m31 = srx * srz + crx * sry * crz;
	      var m12 = cry * srz;
	      var m22 = crx * crz + srx * sry * srz;
	      var m32 = -srx * crz + crx * sry * srz;
	      var m13 = -sry;
	      var m23 = srx * cry;
	      var m33 = crx * cry;
	
	      this[0] = d11 * m11 + d21 * m12 + d31 * m13;
	      this[1] = d12 * m11 + d22 * m12 + d32 * m13;
	      this[2] = d13 * m11 + d23 * m12 + d33 * m13;
	      this[3] = d14 * m11 + d24 * m12 + d34 * m13;
	
	      this[4] = d11 * m21 + d21 * m22 + d31 * m23;
	      this[5] = d12 * m21 + d22 * m22 + d32 * m23;
	      this[6] = d13 * m21 + d23 * m22 + d33 * m23;
	      this[7] = d14 * m21 + d24 * m22 + d34 * m23;
	
	      this[8] = d11 * m31 + d21 * m32 + d31 * m33;
	      this[9] = d12 * m31 + d22 * m32 + d32 * m33;
	      this[10] = d13 * m31 + d23 * m32 + d33 * m33;
	      this[11] = d14 * m31 + d24 * m32 + d34 * m33;
	
	      this.check();
	      return this;
	    }
	    /* eslint-enable max-statements */
	
	  }, {
	    key: 'scale',
	    value: function scale(vec) {
	      _glMatrix.mat4.scale(this, this, vec);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'translate',
	    value: function translate(vec) {
	      _glMatrix.mat4.translate(this, this, vec);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'transformVector2',
	    value: function transformVector2(vector) {
	      var out = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _vector2.default();
	
	      _glMatrix.vec2.transformMat4(out, vector, this);
	      (0, _validators.checkVector2)(out);
	      return out;
	    }
	  }, {
	    key: 'transformVector3',
	    value: function transformVector3(vector) {
	      var out = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _vector4.default();
	
	      _glMatrix.vec3.transformMat4(out, vector, this);
	      (0, _validators.checkVector3)(out);
	      return out;
	    }
	  }, {
	    key: 'transformVector4',
	    value: function transformVector4(vector) {
	      var out = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _vector6.default();
	
	      _glMatrix.vec4.transformMat4(out, vector, this);
	      (0, _validators.checkVector4)(out);
	      return out;
	    }
	
	    // Transforms any 2, 3 or 4 element vector
	    // returns a newly minted Vector2, Vector3 or Vector4
	
	  }, {
	    key: 'transformVector',
	    value: function transformVector(vector) {
	      switch (vector.length) {
	        case 2:
	          return this.transformVector2(vector);
	        case 3:
	          return this.transformVector3(vector);
	        case 4:
	          return this.transformVector4(vector);
	        default:
	          throw new Error('Illegal vector');
	      }
	    }
	  }, {
	    key: 'ELEMENTS',
	    get: function get() {
	      return 16;
	    }
	  }, {
	    key: 'm00',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(value) {
	      return this[0] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm01',
	    get: function get() {
	      return this[4];
	    },
	    set: function set(value) {
	      return this[4] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm02',
	    get: function get() {
	      return this[8];
	    },
	    set: function set(value) {
	      return this[8] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm03',
	    get: function get() {
	      return this[12];
	    },
	    set: function set(value) {
	      return this[12] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm10',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(value) {
	      return this[1] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm11',
	    get: function get() {
	      return this[5];
	    },
	    set: function set(value) {
	      return this[5] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm12',
	    get: function get() {
	      return this[9];
	    },
	    set: function set(value) {
	      return this[9] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm13',
	    get: function get() {
	      return this[13];
	    },
	    set: function set(value) {
	      return this[13] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm20',
	    get: function get() {
	      return this[2];
	    },
	    set: function set(value) {
	      return this[2] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm21',
	    get: function get() {
	      return this[6];
	    },
	    set: function set(value) {
	      return this[6] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm22',
	    get: function get() {
	      return this[10];
	    },
	    set: function set(value) {
	      return this[10] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm23',
	    get: function get() {
	      return this[14];
	    },
	    set: function set(value) {
	      return this[14] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm30',
	    get: function get() {
	      return this[3];
	    },
	    set: function set(value) {
	      return this[3] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm31',
	    get: function get() {
	      return this[7];
	    },
	    set: function set(value) {
	      return this[7] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm32',
	    get: function get() {
	      return this[11];
	    },
	    set: function set(value) {
	      return this[11] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'm33',
	    get: function get() {
	      return this[15];
	    },
	    set: function set(value) {
	      return this[15] = (0, _common.checkNumber)(value);
	    }
	  }], [{
	    key: 'equals',
	    value: function equals(a, b) {
	      return _glMatrix.mat4.equals(a, b);
	    }
	  }, {
	    key: 'exactEquals',
	    value: function exactEquals(a, b) {
	      return _glMatrix.mat4.exactEquals(a, b);
	    }
	  }, {
	    key: 'determinant',
	    value: function determinant(m) {
	      return _glMatrix.mat4.determinant(m);
	    }
	  }, {
	    key: 'frustum',
	    value: function frustum(opts) {
	      return new Matrix4().frustum(opts);
	    }
	  }, {
	    key: 'lookAt',
	    value: function lookAt(opts) {
	      return new Matrix4().lookAt(opts);
	    }
	  }, {
	    key: 'ortho',
	    value: function ortho(opts) {
	      return new Matrix4().ortho(opts);
	    }
	  }, {
	    key: 'perspective',
	    value: function perspective(opts) {
	      return new Matrix4().perspective(opts);
	    }
	  }, {
	    key: 'perspectiveFromFieldOfView',
	    value: function perspectiveFromFieldOfView(opts) {
	      return new Matrix4().perspectiveFromFieldOfView(opts);
	    }
	  }, {
	    key: 'fromQuaternion',
	    value: function fromQuaternion(q) {
	      return new Matrix4().fromQuaternion(q);
	    }
	  }]);
	
	  return Matrix4;
	}(_mathArray2.default);
	
	exports.default = Matrix4;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mathArray = __webpack_require__(130);
	
	var _mathArray2 = _interopRequireDefault(_mathArray);
	
	var _common = __webpack_require__(85);
	
	var _glMatrix = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Quaternion = function (_MathArray) {
	  _inherits(Quaternion, _MathArray);
	
	  // Creates a new identity quat
	  function Quaternion() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	    _classCallCheck(this, Quaternion);
	
	    var _this = _possibleConstructorReturn(this, (Quaternion.__proto__ || Object.getPrototypeOf(Quaternion)).call(this));
	
	    if (Array.isArray(x) && arguments.length === 1) {
	      _this.copy(x);
	    } else {
	      _this.set(x, y, z, w);
	    }
	    return _this;
	  }
	
	  // Creates a quaternion from the given 3x3 rotation matrix.
	  // NOTE: The resultant quaternion is not normalized, so you should
	  // be sure to renormalize the quaternion yourself where necessary.
	
	
	  _createClass(Quaternion, [{
	    key: 'fromMatrix3',
	    value: function fromMatrix3(m) {
	      _glMatrix.quat.fromMat3(this, m);
	      this.check();
	      return this;
	    }
	
	    // Creates a new quat initialized with the given values
	
	  }, {
	    key: 'fromValues',
	    value: function fromValues(x, y, z, w) {
	      return this.set(x, y, z, w);
	    }
	
	    // Set a quat to the identity quaternion
	
	  }, {
	    key: 'identity',
	    value: function identity() {
	      _glMatrix.quat.identity(this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'equals',
	    value: function equals(quaternion) {
	      return _glMatrix.quat.equals(this, quaternion);
	    }
	
	    // Returns whether or not the quaternions have exactly the same elements
	    // in the same position (when compared with ===)
	
	  }, {
	    key: 'exactEquals',
	    value: function exactEquals(quaternion) {
	      return _glMatrix.quat.exactEquals(this, quaternion);
	    }
	
	    // Getters/setters
	    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
	
	  }, {
	    key: 'length',
	
	    /* eslint-enable no-multi-spaces, brace-style, no-return-assign */
	
	    // Calculates the length of a quat
	    value: function length() {
	      return _glMatrix.quat.length(this);
	    }
	
	    // Calculates the squared length of a quat
	
	  }, {
	    key: 'squaredLength',
	    value: function squaredLength(a) {
	      return _glMatrix.quat.squaredLength(this);
	    }
	
	    // Calculates the dot product of two quat's
	    // @return {Number}
	
	  }, {
	    key: 'dot',
	    value: function dot(a, b) {
	      if (b !== undefined) {
	        throw new Error('Quaternion.dot only takes one argument');
	      }
	      return _glMatrix.quat.dot(this, a);
	    }
	
	    // Gets the rotation axis and angle for a given quaternion.
	    // If a quaternion is created with setAxisAngle, this method will
	    // return the same values as providied in the original parameter
	    // list OR functionally equivalent values.
	    // Example: The quaternion formed by axis [0, 0, 1] and angle -90
	    // is the same as the quaternion formed by [0, 0, 1] and 270.
	    // This method favors the latter.
	    // @return {{[x,y,z], Number}}
	
	  }, {
	    key: 'getAxisAngle',
	    value: function getAxisAngle() {
	      var axis = [];
	      var angle = _glMatrix.quat.getAxisAngle(axis, this);
	      return { axis: axis, angle: angle };
	    }
	
	    // MODIFIERS
	
	    // Sets a quaternion to represent the shortest rotation from one vector
	    // to another. Both vectors are assumed to be unit length.
	
	  }, {
	    key: 'rotationTo',
	    value: function rotationTo(vectorA, vectorB) {
	      _glMatrix.quat.rotationTo(this, vectorA, vectorB);
	      this.check();
	      return this;
	    }
	
	    // Sets the specified quaternion with values corresponding to the given axes.
	    // Each axis is a vec3 and is expected to be unit length and perpendicular
	    // to all other specified axes.
	    // setAxes() {
	    //   Number
	    // }
	
	    // Performs a spherical linear interpolation with two control points
	    // sqlerp() {
	    //   Number;
	    // }
	
	    // Adds two quat's
	
	  }, {
	    key: 'add',
	    value: function add(a, b) {
	      if (b !== undefined) {
	        throw new Error('Quaternion.add only takes one argument');
	      }
	      _glMatrix.quat.add(this, a);
	      this.check();
	      return this;
	    }
	
	    // Calculates the W component of a quat from the X, Y, and Z components.
	    // Any existing W component will be ignored.
	
	  }, {
	    key: 'calculateW',
	    value: function calculateW() {
	      _glMatrix.quat.calculateW(this, this);
	      this.check();
	      return this;
	    }
	
	    // Calculates the conjugate of a quat If the quaternion is normalized,
	    // this function is faster than quat.inverse and produces the same result.
	
	  }, {
	    key: 'conjugate',
	    value: function conjugate() {
	      _glMatrix.quat.conjugate(this, this);
	      this.check();
	      return this;
	    }
	
	    // Calculates the inverse of a quat
	
	  }, {
	    key: 'invert',
	    value: function invert() {
	      _glMatrix.quat.invert(this, this);
	      this.check();
	      return this;
	    }
	
	    // Performs a linear interpolation between two quat's
	
	  }, {
	    key: 'lerp',
	    value: function lerp(a, b, t) {
	      _glMatrix.quat.lerp(this, a, b, t);
	      this.check();
	      return this;
	    }
	
	    // Multiplies two quat's
	
	  }, {
	    key: 'multiply',
	    value: function multiply(a, b) {
	      if (b !== undefined) {
	        throw new Error('Quaternion.multiply only takes one argument');
	      }
	      _glMatrix.quat.multiply(this, this, b);
	      this.check();
	      return this;
	    }
	
	    // Normalize a quat
	
	  }, {
	    key: 'normalize',
	    value: function normalize() {
	      _glMatrix.quat.normalize(this, this);
	      this.check();
	      return this;
	    }
	
	    // Rotates a quaternion by the given angle about the X axis
	
	  }, {
	    key: 'rotateX',
	    value: function rotateX(rad) {
	      _glMatrix.quat.rotateX(this, this, rad);
	      this.check();
	      return this;
	    }
	
	    // Rotates a quaternion by the given angle about the Y axis
	
	  }, {
	    key: 'rotateY',
	    value: function rotateY(rad) {
	      _glMatrix.quat.rotateY(this, this, rad);
	      this.check();
	      return this;
	    }
	
	    // Rotates a quaternion by the given angle about the Z axis
	
	  }, {
	    key: 'rotateZ',
	    value: function rotateZ(rad) {
	      _glMatrix.quat.rotateZ(this, this, rad);
	      this.check();
	      return this;
	    }
	
	    // Scales a quat by a scalar number
	
	  }, {
	    key: 'scale',
	    value: function scale(b) {
	      _glMatrix.quat.scale(this, this, b);
	      this.check();
	      return this;
	    }
	
	    // Set the components of a quat to the given values
	
	  }, {
	    key: 'set',
	    value: function set(i, j, k, l) {
	      _glMatrix.quat.set(this, i, j, k, l);
	      this.check();
	      return this;
	    }
	
	    // Sets a quat from the given angle and rotation axis, then returns it.
	
	  }, {
	    key: 'setAxisAngle',
	    value: function setAxisAngle(axis, rad) {
	      _glMatrix.quat.setAxisAngle(this, axis, rad);
	      this.check();
	      return this;
	    }
	
	    // Performs a spherical linear interpolation between two quat
	
	  }, {
	    key: 'slerp',
	    value: function slerp(a, b, t) {
	      _glMatrix.quat.slerp(this, a, b, t);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'ELEMENTS',
	    get: function get() {
	      return 4;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(value) {
	      return this[0] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(value) {
	      return this[1] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'z',
	    get: function get() {
	      return this[2];
	    },
	    set: function set(value) {
	      return this[2] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'w',
	    get: function get() {
	      return this[3];
	    },
	    set: function set(value) {
	      return this[3] = (0, _common.checkNumber)(value);
	    }
	  }]);
	
	  return Quaternion;
	}(_mathArray2.default);
	
	exports.default = Quaternion;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mathArray = __webpack_require__(130);
	
	var _mathArray2 = _interopRequireDefault(_mathArray);
	
	var _common = __webpack_require__(85);
	
	var _glMatrix = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Vector2 = function (_MathArray) {
	  _inherits(Vector2, _MathArray);
	
	  // Creates a new, empty vec2
	  function Vector2() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    _classCallCheck(this, Vector2);
	
	    var _this = _possibleConstructorReturn(this, (Vector2.__proto__ || Object.getPrototypeOf(Vector2)).call(this));
	
	    if (Array.isArray(x) && arguments.length === 1) {
	      _this.copy(x);
	    } else {
	      _this.set(x, y);
	    }
	    return _this;
	  }
	
	  _createClass(Vector2, [{
	    key: 'set',
	    value: function set(x, y) {
	      _glMatrix.vec2.set(this, x, y);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'equals',
	    value: function equals(vector) {
	      return _glMatrix.vec2.equals(this, vector);
	    }
	  }, {
	    key: 'exactEquals',
	    value: function exactEquals(vector) {
	      return _glMatrix.vec2.exactEquals(this, vector);
	    }
	
	    // Getters/setters
	    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
	
	  }, {
	    key: 'add',
	
	    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
	
	    value: function add() {
	      for (var _len = arguments.length, vectors = Array(_len), _key = 0; _key < _len; _key++) {
	        vectors[_key] = arguments[_key];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = vectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var vector = _step.value;
	
	          _glMatrix.vec2.add(this, vector);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return this;
	    }
	  }, {
	    key: 'ELEMENTS',
	    get: function get() {
	      return 2;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(value) {
	      return this[0] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(value) {
	      return this[1] = (0, _common.checkNumber)(value);
	    }
	  }]);
	
	  return Vector2;
	}(_mathArray2.default);
	
	exports.default = Vector2;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mathArray = __webpack_require__(130);
	
	var _mathArray2 = _interopRequireDefault(_mathArray);
	
	var _common = __webpack_require__(85);
	
	var _glMatrix = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Vector4 = function (_MathArray) {
	  _inherits(Vector4, _MathArray);
	
	  // Creates a new, empty vec4
	  function Vector4() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    _classCallCheck(this, Vector4);
	
	    var _this = _possibleConstructorReturn(this, (Vector4.__proto__ || Object.getPrototypeOf(Vector4)).call(this));
	
	    if (Array.isArray(x) && arguments.length === 1) {
	      _this.copy(x);
	    } else {
	      _this.set(x, y, z, w);
	    }
	    return _this;
	  }
	
	  _createClass(Vector4, [{
	    key: 'set',
	    value: function set(x, y, z, w) {
	      _glMatrix.vec4.set(this, x, y, z, w);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'equals',
	    value: function equals(vector) {
	      return _glMatrix.vec4.equals(this, vector);
	    }
	  }, {
	    key: 'exactEquals',
	    value: function exactEquals(vector) {
	      return _glMatrix.vec4.exactEquals(this, vector);
	    }
	
	    // Getters/setters
	    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
	
	  }, {
	    key: 'distance',
	
	    /* eslint-enable no-multi-spaces, brace-style, no-return-assign */
	
	    value: function distance(vector) {
	      return _glMatrix.vec4.distance(vector);
	    }
	  }, {
	    key: 'dist',
	    value: function dist(vector) {
	      return _glMatrix.vec4.dist(vector);
	    }
	  }, {
	    key: 'angle',
	    value: function angle(vector) {
	      return _glMatrix.vec4.angle(vector);
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      for (var _len = arguments.length, vectors = Array(_len), _key = 0; _key < _len; _key++) {
	        vectors[_key] = arguments[_key];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = vectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var vector = _step.value;
	
	          _glMatrix.vec4.add(this, vector);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'subtract',
	    value: function subtract() {
	      for (var _len2 = arguments.length, vectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        vectors[_key2] = arguments[_key2];
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = vectors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var vector = _step2.value;
	
	          _glMatrix.vec4.subtract(this, vector);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'multiply',
	    value: function multiply() {
	      for (var _len3 = arguments.length, vectors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        vectors[_key3] = arguments[_key3];
	      }
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = vectors[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var vector = _step3.value;
	
	          _glMatrix.vec4.multiply(this, vector);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'divide',
	    value: function divide() {
	      for (var _len4 = arguments.length, vectors = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        vectors[_key4] = arguments[_key4];
	      }
	
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = vectors[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var vector = _step4.value;
	
	          _glMatrix.vec4.divide(this, vector);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'ceil',
	    value: function ceil() {
	      _glMatrix.vec4.ceil(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'floor',
	    value: function floor() {
	      _glMatrix.vec4.floor(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'min',
	    value: function min() {
	      _glMatrix.vec4.min(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'max',
	    value: function max() {
	      _glMatrix.vec4.max(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'scale',
	    value: function scale(_scale) {
	      _glMatrix.vec4.scale(this, this, _scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'scaleAndAdd',
	    value: function scaleAndAdd(vector, scale) {
	      _glMatrix.vec4.scaleAndAdd(this, this, vector, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'negate',
	    value: function negate() {
	      _glMatrix.vec4.negate(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'inverse',
	    value: function inverse() {
	      _glMatrix.vec4.inverse(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'normalize',
	    value: function normalize() {
	      _glMatrix.vec4.normalize(this, this);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'dot',
	    value: function dot(scale) {
	      _glMatrix.vec4.dot(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'cross',
	    value: function cross(scale) {
	      _glMatrix.vec4.cross(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'lerp',
	    value: function lerp(scale) {
	      _glMatrix.vec4.lerp(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'hermite',
	    value: function hermite(scale) {
	      _glMatrix.vec4.hermite(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'bezier',
	    value: function bezier(scale) {
	      _glMatrix.vec4.bezier(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'random',
	    value: function random(scale) {
	      _glMatrix.vec4.random(this, this, scale);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'rotateX',
	    value: function rotateX(origin, angle) {
	      _glMatrix.vec4.rotateX(this, this, origin, angle);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'rotateY',
	    value: function rotateY(origin, angle) {
	      _glMatrix.vec4.rotateY(this, this, origin, angle);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'rotateZ',
	    value: function rotateZ(origin, angle) {
	      _glMatrix.vec4.rotateZ(this, this, origin, angle);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'ELEMENTS',
	    get: function get() {
	      return 4;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(value) {
	      return this[0] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(value) {
	      return this[1] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'z',
	    get: function get() {
	      return this[2];
	    },
	    set: function set(value) {
	      return this[2] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'w',
	    get: function get() {
	      return this[3];
	    },
	    set: function set(value) {
	      return this[3] = (0, _common.checkNumber)(value);
	    }
	  }]);
	
	  return Vector4;
	}(_mathArray2.default);
	
	exports.default = Vector4;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// This function is needed in initialization stages,
	// make sure it can be imported in isolation
	/* global process */
	
	var isNode = exports.isNode = (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && String(process) === '[object process]' && !process.browser;
	
	var isBrowser = exports.isBrowser = !isNode;
	
	exports.default = isBrowser;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9pcy1icm93c2VyLmpzIl0sIm5hbWVzIjpbImlzTm9kZSIsInByb2Nlc3MiLCJTdHJpbmciLCJicm93c2VyIiwiaXNCcm93c2VyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBO0FBQ0E7QUFDQTs7QUFFTyxJQUFNQSwwQkFDWCxRQUFPQyxPQUFQLHlDQUFPQSxPQUFQLE9BQW1CLFFBQW5CLElBQ0FDLE9BQU9ELE9BQVAsTUFBb0Isa0JBRHBCLElBRUEsQ0FBQ0EsUUFBUUUsT0FISjs7QUFLQSxJQUFNQyxnQ0FBWSxDQUFDSixNQUFuQjs7a0JBRVFJLFMiLCJmaWxlIjoiaXMtYnJvd3Nlci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIFRoaXMgZnVuY3Rpb24gaXMgbmVlZGVkIGluIGluaXRpYWxpemF0aW9uIHN0YWdlcyxcbi8vIG1ha2Ugc3VyZSBpdCBjYW4gYmUgaW1wb3J0ZWQgaW4gaXNvbGF0aW9uXG4vKiBnbG9iYWwgcHJvY2VzcyAqL1xuXG5leHBvcnQgY29uc3QgaXNOb2RlID1cbiAgdHlwZW9mIHByb2Nlc3MgPT09ICdvYmplY3QnICYmXG4gIFN0cmluZyhwcm9jZXNzKSA9PT0gJ1tvYmplY3QgcHJvY2Vzc10nICYmXG4gICFwcm9jZXNzLmJyb3dzZXI7XG5cbmV4cG9ydCBjb25zdCBpc0Jyb3dzZXIgPSAhaXNOb2RlO1xuXG5leHBvcnQgZGVmYXVsdCBpc0Jyb3dzZXI7XG4iXX0=
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)))

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createGLContext = createGLContext;
	exports.getGLExtension = getGLExtension;
	exports.poll = poll;
	exports.glContextWithState = glContextWithState;
	exports.glGetDebugInfo = glGetDebugInfo;
	
	var _webglDebug = __webpack_require__(1481);
	
	var _webglDebug2 = _interopRequireDefault(_webglDebug);
	
	var _webglTypes = __webpack_require__(218);
	
	var _webglChecks = __webpack_require__(37);
	
	var _queryManager = __webpack_require__(482);
	
	var _queryManager2 = _interopRequireDefault(_queryManager);
	
	var _utils = __webpack_require__(30);
	
	var _globals = __webpack_require__(479);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // WebGLRenderingContext related methods
	/* eslint-disable no-try-catch, no-loop-func */
	
	
	/* global document */
	
	var luma = _globals.global.luma;
	
	
	var ERR_WEBGL_MISSING_BROWSER = 'WebGL API is missing. Check your if your browser supports WebGL or\ninstall a recent version of a major browser.';
	
	var ERR_WEBGL_MISSING_NODE = 'WebGL API is missing. To run luma.gl under Node.js, please "npm install gl"\nand import \'luma.gl/headless\' before importing \'luma.gl\'.';
	
	var ERR_HEADLESSGL_NOT_AVAILABLE = 'Cannot create headless WebGL context, headlessGL not available';
	
	var ERR_HEADLESSGL_FAILED = 'headlessGL failed to create headless WebGL context';
	
	// Checks if WebGL is enabled and creates a context for using WebGL.
	/* eslint-disable complexity, max-statements */
	function createGLContext() {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var canvas = opts.canvas;
	  var _opts$width = opts.width,
	      width = _opts$width === undefined ? 800 : _opts$width,
	      _opts$height = opts.height,
	      height = _opts$height === undefined ? 600 : _opts$height,
	      _opts$webgl = opts.webgl2,
	      webgl2 = _opts$webgl === undefined ? false : _opts$webgl,
	      _opts$debug = opts.debug,
	      debug = _opts$debug === undefined ? true : _opts$debug;
	
	
	  var gl = void 0;
	
	  if (!_utils.isBrowser) {
	    gl = _createHeadlessContext(width, height, opts);
	  } else {
	    // Create browser gl context
	    if (!_webglTypes.webGLTypesAvailable) {
	      throw new Error(ERR_WEBGL_MISSING_BROWSER);
	    }
	    // Make sure we have a canvas
	    canvas = canvas;
	    if (typeof canvas === 'string') {
	      if (!_utils.isPageLoaded) {
	        throw new Error('createGLContext called on canvas \'' + canvas + '\' before page was loaded');
	      }
	      canvas = document.getElementById(canvas);
	    }
	    if (!canvas) {
	      canvas = _createCanvas();
	    }
	
	    canvas.addEventListener('webglcontextcreationerror', function (e) {
	      _utils.log.log(0, e.statusMessage || 'Unknown error');
	    }, false);
	
	    // Prefer webgl2 over webgl1, prefer conformant over experimental
	    if (webgl2) {
	      gl = gl || canvas.getContext('webgl2', opts);
	      gl = gl || canvas.getContext('experimental-webgl2', opts);
	    } else {
	      gl = gl || canvas.getContext('webgl', opts);
	      gl = gl || canvas.getContext('experimental-webgl', opts);
	    }
	
	    (0, _assert2.default)(gl, 'Failed to create WebGLRenderingContext');
	  }
	
	  if (_utils.isBrowser && debug) {
	    var debugGL = _webglDebug2.default.makeDebugContext(gl, throwOnError, validateArgsAndLog);
	
	    var WebGLDebugContext = function WebGLDebugContext() {
	      _classCallCheck(this, WebGLDebugContext);
	    };
	
	    Object.assign(WebGLDebugContext.prototype, debugGL);
	    gl = debugGL;
	    gl.debug = true;
	    _utils.log.priority = _utils.log.priority < 1 ? 1 : _utils.log.priority;
	
	    logInfo(gl);
	  }
	
	  return gl;
	}
	
	// Create a canvas set to 100%
	// TODO - remove
	function _createCanvas() {
	  var canvas = document.createElement('canvas');
	  canvas.id = 'lumagl-canvas';
	  canvas.style.width = '100%';
	  canvas.style.height = '100%';
	  // adds the canvas to the body element
	  _utils.pageLoadPromise.then(function (document) {
	    var body = document.body;
	    body.insertBefore(canvas, body.firstChild);
	  });
	  return canvas;
	}
	
	function _createHeadlessContext(width, height, opts) {
	  // Create headless gl context
	  if (!_webglTypes.webGLTypesAvailable) {
	    throw new Error(ERR_WEBGL_MISSING_NODE);
	  }
	  if (!luma.globals.headlessGL) {
	    throw new Error(ERR_HEADLESSGL_NOT_AVAILABLE);
	  }
	  var gl = luma.globals.headlessGL(width, height, opts);
	  if (!gl) {
	    throw new Error(ERR_HEADLESSGL_FAILED);
	  }
	  return gl;
	}
	
	// Returns the extension or throws an error
	function getGLExtension(gl, extensionName) {
	  // assertWebGLContext(gl);
	  var ERROR = 'Illegal arg to getExtension';
	  (0, _assert2.default)(gl instanceof _webglTypes.WebGLRenderingContext, ERROR);
	  (0, _assert2.default)(typeof extensionName === 'string', ERROR);
	  var extension = gl.getExtension(extensionName);
	  (0, _assert2.default)(extension, extensionName + ' not supported!');
	  return extension;
	}
	
	// POLLING FOR PENDING QUERIES
	
	// Calling this function checks all pending queries for completion
	function poll(gl) {
	  (0, _webglChecks.assertWebGLContext)(gl);
	  _queryManager2.default.poll(gl);
	}
	
	// VERY LIMITED / BASIC GL STATE MANAGEMENT
	
	// Executes a function with gl states temporarily set, exception safe
	// Currently support scissor test and framebuffer binding
	function glContextWithState(gl, _ref, func) {
	  var scissorTest = _ref.scissorTest,
	      framebuffer = _ref.framebuffer;
	
	  // assertWebGLContext(gl);
	
	  var scissorTestWasEnabled = void 0;
	  if (scissorTest) {
	    scissorTestWasEnabled = gl.isEnabled(gl.SCISSOR_TEST);
	    var x = scissorTest.x,
	        y = scissorTest.y,
	        w = scissorTest.w,
	        h = scissorTest.h;
	
	    gl.enable(gl.SCISSOR_TEST);
	    gl.scissor(x, y, w, h);
	  }
	
	  if (framebuffer) {
	    // TODO - was there any previously set frame buffer we need to remember?
	    framebuffer.bind();
	  }
	
	  var value = void 0;
	  try {
	    value = func(gl);
	  } finally {
	    if (!scissorTestWasEnabled) {
	      gl.disable(gl.SCISSOR_TEST);
	    }
	    if (framebuffer) {
	      // TODO - was there any previously set frame buffer?
	      // TODO - delegate "unbind" to Framebuffer object?
	      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	    }
	  }
	
	  return value;
	}
	
	// DEBUG INFO
	
	/**
	 * Provides strings identifying the GPU vendor and driver.
	 * https://www.khronos.org/registry/webgl/extensions/WEBGL_debug_renderer_info/
	 * @param {WebGLRenderingContext} gl - context
	 * @return {Object} - 'vendor' and 'renderer' string fields.
	 */
	function glGetDebugInfo(gl) {
	  var info = gl.getExtension('WEBGL_debug_renderer_info');
	  // We can't determine if 'WEBGL_debug_renderer_info' is supported by
	  // checking whether info is null here. Firefox doesn't follow the
	  // specs by returning null for unsupported extension. Instead,
	  // it returns an object without GL_UNMASKED_VENDOR_WEBGL and GL_UNMASKED_RENDERER_WEBGL.
	  return {
	    vendor: info && info.UNMASKED_VENDOR_WEBGL ? gl.getParameter(info.UNMASKED_VENDOR_WEBGL) : 'unknown',
	    renderer: info && info.UNMASKED_RENDERER_WEBGL ? gl.getParameter(info.UNMASKED_RENDERER_WEBGL) : 'unknown'
	  };
	}
	
	function logInfo(gl) {
	  var webGL = (0, _webglChecks.isWebGL2Context)(gl) ? 'WebGL2' : 'WebGL1';
	  var info = glGetDebugInfo(gl);
	  var driver = info ? '(' + info.vendor + ' ' + info.renderer + ')' : '';
	  var debug = gl.debug ? 'debug' : '';
	  _utils.log.log(0, 'luma.gl: Created ' + webGL + ' ' + debug + ' context ' + driver, gl);
	
	  // const extensions = gl.getSupportedExtensions();
	  // log.log(0, `Supported extensions: [${extensions.join(', ')}]`);
	}
	
	// DEBUG TRACING
	
	function getFunctionString(functionName, functionArgs) {
	  var args = _webglDebug2.default.glFunctionArgsToString(functionName, functionArgs);
	  args = '' + args.slice(0, 100) + (args.length > 100 ? '...' : '');
	  return 'gl.' + functionName + '(' + args + ')';
	}
	
	function throwOnError(err, functionName, args) {
	  var errorMessage = _webglDebug2.default.glEnumToString(err);
	  var functionArgs = _webglDebug2.default.glFunctionArgsToString(functionName, args);
	  throw new Error(errorMessage + ' was caused by call to: ' + ('gl.' + functionName + '(' + functionArgs + ')'));
	}
	
	// Don't generate function string until it is needed
	function validateArgsAndLog(functionName, functionArgs) {
	  var functionString = void 0;
	  if (_utils.log.priority >= 4) {
	    functionString = getFunctionString(functionName, functionArgs);
	    _utils.log.info(4, '' + functionString);
	  }
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = functionArgs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var arg = _step.value;
	
	      if (arg === undefined) {
	        functionString = functionString || getFunctionString(functionName, functionArgs);
	        throw new Error('Undefined argument: ' + functionString);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  if (_utils.log.break) {
	    functionString = functionString || getFunctionString(functionName, functionArgs);
	    var isBreakpoint = _utils.log.break && _utils.log.break.every(function (breakString) {
	      return functionString.indexOf(breakString) !== -1;
	    });
	
	    /* eslint-disable no-debugger */
	    if (isBreakpoint) {
	      debugger;
	    }
	    /* eslint-enable no-debugger */
	  }
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _texture2d = __webpack_require__(216);
	
	var _texture2d2 = _interopRequireDefault(_texture2d);
	
	var _renderbuffer = __webpack_require__(215);
	
	var _renderbuffer2 = _interopRequireDefault(_renderbuffer);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _utils = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Returns number of components in a specific WebGL format
	function glFormatToComponents(format) {
	  switch (format) {
	    case _webgl.GL.ALPHA:
	      return 1;
	    case _webgl.GL.RGB:
	      return 3;
	    case _webgl.GL.RGBA:
	      return 4;
	    default:
	      throw new Error('Unknown format');
	  }
	}
	
	var Framebuffer = function () {
	  _createClass(Framebuffer, null, [{
	    key: 'makeFrom',
	    value: function makeFrom(gl) {
	      var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return object instanceof Framebuffer ? object :
	      // Use .handle (e.g from stack.gl's gl-buffer), else use buffer directly
	      new Framebuffer(gl, { handle: object.handle || object });
	    }
	
	    /* eslint-disable max-statements */
	
	  }]);
	
	  function Framebuffer(gl) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Framebuffer);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	
	    var id = opts.id;
	
	
	    var handle = gl.createFramebuffer();
	    if (!handle) {
	      throw new Error('Failed to create WebGL Framebuffer');
	    }
	
	    this.gl = gl;
	    this.id = (0, _utils.uid)(id);
	    this.handle = handle;
	    this.colorBuffer = null;
	    this.depthBuffer = null;
	    this.stencilBuffer = null;
	    this.texture = null;
	    this.userData = {};
	    this.width = 0;
	    this.height = 0;
	    Object.seal(this);
	
	    this.resize(opts);
	  }
	  /* eslint-enable max-statements */
	
	  _createClass(Framebuffer, [{
	    key: 'delete',
	    value: function _delete() {
	      var gl = this.gl;
	
	      gl.deleteFramebuffer(this.handle);
	    }
	
	    // SIMPLIFIED INTERFACE
	
	  }, {
	    key: 'resize',
	    value: function resize(_ref) {
	      var width = _ref.width,
	          height = _ref.height;
	
	      this.update({ width: width, height: height });
	    }
	
	    /* eslint-disable max-statements */
	
	  }, {
	    key: 'update',
	    value: function update(_ref2) {
	      var _ref2$width = _ref2.width,
	          width = _ref2$width === undefined ? 1 : _ref2$width,
	          _ref2$height = _ref2.height,
	          height = _ref2$height === undefined ? 1 : _ref2$height,
	          _ref2$depth = _ref2.depth,
	          depth = _ref2$depth === undefined ? true : _ref2$depth,
	          _ref2$minFilter = _ref2.minFilter,
	          minFilter = _ref2$minFilter === undefined ? _webgl.GL.NEAREST : _ref2$minFilter,
	          _ref2$magFilter = _ref2.magFilter,
	          magFilter = _ref2$magFilter === undefined ? _webgl.GL.NEAREST : _ref2$magFilter,
	          _ref2$format = _ref2.format,
	          format = _ref2$format === undefined ? _webgl.GL.RGBA : _ref2$format,
	          _ref2$type = _ref2.type,
	          type = _ref2$type === undefined ? _webgl.GL.UNSIGNED_BYTE : _ref2$type;
	
	      (0, _assert2.default)(width >= 0 && height >= 0, 'Width and height need to be integers');
	      if (width === this.width && height === this.height) {
	        return;
	      }
	
	      _utils.log.log(2, 'Resizing framebuffer ' + this.id + ' to ' + width + 'x' + height);
	
	      var gl = this.gl;
	
	      // TODO - do we need to reallocate the framebuffer?
	
	      var colorBuffer = new _texture2d2.default(gl, {
	        minFilter: this.minFilter,
	        magFilter: this.magFilter
	      })
	      // TODO - should be handled by Texture2D constructor?
	      .setImageData({
	        data: null,
	        width: width,
	        height: height,
	        type: type,
	        format: format
	      });
	
	      this.attachTexture({
	        attachment: _webgl.GL.COLOR_ATTACHMENT0,
	        texture: colorBuffer
	      });
	
	      if (this.colorBuffer) {
	        this.colorBuffer.delete();
	      }
	      this.colorBuffer = colorBuffer;
	      this.texture = colorBuffer;
	
	      // Add a depth buffer if requested
	      if (depth) {
	        var depthBuffer = new _renderbuffer2.default(gl).storage({
	          internalFormat: _webgl.GL.DEPTH_COMPONENT16,
	          width: width,
	          height: height
	        });
	        this.attachRenderbuffer({
	          attachment: _webgl.GL.DEPTH_ATTACHMENT,
	          renderbuffer: depthBuffer
	        });
	
	        if (this.depthBuffer) {
	          this.depthBuffer.delete();
	        }
	        this.depthBuffer = depthBuffer;
	      }
	
	      // Checks that framebuffer was properly set up,
	      // if not, throws an explanatory error
	      this.checkStatus();
	
	      this.width = width;
	      this.height = height;
	    }
	
	    // WEBGL INTERFACE
	
	  }, {
	    key: 'bind',
	    value: function bind() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref3$target = _ref3.target,
	          target = _ref3$target === undefined ? _webgl.GL.FRAMEBUFFER : _ref3$target;
	
	      var gl = this.gl;
	
	      gl.bindFramebuffer(target, this.handle);
	      return this;
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref4$target = _ref4.target,
	          target = _ref4$target === undefined ? _webgl.GL.FRAMEBUFFER : _ref4$target;
	
	      var gl = this.gl;
	
	      gl.bindFramebuffer(target, null);
	      return this;
	    }
	
	    //
	    // NOTE: Slow requires roundtrip to GPU
	    // App can provide pixelArray or have it auto allocated by this method
	    // @returns {Uint8Array|Uint16Array|FloatArray} - pixel array,
	    //  newly allocated by this method unless provided by app.
	
	  }, {
	    key: 'readPixels',
	    value: function readPixels(_ref5) {
	      var _ref5$x = _ref5.x,
	          x = _ref5$x === undefined ? 0 : _ref5$x,
	          _ref5$y = _ref5.y,
	          y = _ref5$y === undefined ? 0 : _ref5$y,
	          width = _ref5.width,
	          height = _ref5.height,
	          _ref5$format = _ref5.format,
	          format = _ref5$format === undefined ? _webgl.GL.RGBA : _ref5$format,
	          type = _ref5.type,
	          _ref5$pixelArray = _ref5.pixelArray,
	          pixelArray = _ref5$pixelArray === undefined ? null : _ref5$pixelArray;
	      var gl = this.gl;
	
	      // Deduce type and allocated pixelArray if needed
	
	      if (!pixelArray) {
	        // Allocate pixel array if not already available, using supplied type
	        type = type || _webgl.GL.UNSIGNED_BYTE;
	        var ArrayType = (0, _webgl.glTypeToArray)(type);
	        var components = glFormatToComponents(format);
	        // TODO - check for composite type (components = 1).
	        pixelArray = pixelArray || new ArrayType(width * height * components);
	      }
	
	      // Pixel array available, if necessary, deduce type from it.
	      type = type || (0, _webgl.glTypeFromArray)(pixelArray);
	
	      this.bind();
	      gl.readPixels(x, y, width, height, format, type, pixelArray);
	      this.unbind();
	
	      return pixelArray;
	    }
	
	    /**
	     * Used to attach textures to a framebuffer, the textures will store
	     * the various buffers.
	     *
	     *  The set of available attachments is larger in WebGL2, and also the
	     *  extensions WEBGL_draw_buffers and WEBGL_depth_texture provide additional
	     *  attachments that match or exceed the WebGL2 set.
	     *
	     * @param {Texture2D|TextureCube|WebGLTexture|null} opt.texture=null -
	     *    default is null which unbinds the texture for the attachment
	     * @param {String|Number} opt.attachment= - which attachment to bind
	     *    defaults to gl.COLOR_ATTACHMENT0.
	     * @param {String|Number} opt.target= - bind point, normally gl.FRAMEBUFFER
	     *    (WebGL2 support separating bet)
	     * @param {String|Number} opt.textureTarget= - can be used to specify
	     *    faces of a cube map.
	     * @returns {FrameBuffer} returns itself to enable chaining
	     */
	
	  }, {
	    key: 'attachTexture',
	    value: function attachTexture() {
	      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref6$texture = _ref6.texture,
	          texture = _ref6$texture === undefined ? null : _ref6$texture,
	          _ref6$target = _ref6.target,
	          target = _ref6$target === undefined ? _webgl.GL.FRAMEBUFFER : _ref6$target,
	          _ref6$attachment = _ref6.attachment,
	          attachment = _ref6$attachment === undefined ? _webgl.GL.COLOR_ATTACHMENT0 : _ref6$attachment,
	          _ref6$textureTarget = _ref6.textureTarget,
	          textureTarget = _ref6$textureTarget === undefined ? _webgl.GL.TEXTURE_2D : _ref6$textureTarget,
	          _ref6$mipmapLevel = _ref6.mipmapLevel,
	          mipmapLevel = _ref6$mipmapLevel === undefined ? 0 : _ref6$mipmapLevel;
	
	      var gl = this.gl;
	
	
	      texture = texture && _texture2d2.default.makeFrom(gl, texture);
	
	      this.bind({ target: target });
	
	      gl.framebufferTexture2D(target, (0, _webgl.glGet)(attachment), (0, _webgl.glGet)(textureTarget), texture.handle, mipmapLevel);
	
	      this.unbind();
	      return this;
	    }
	
	    /**
	     * Used to attach a framebuffer to a framebuffer, the textures will store
	     * the various buffers.
	     * @param {Object} opts= - named parameters
	     * @param {RenderBuffer|WebGLRenderBuffer|null} opts.renderbuffer=null -
	     *    renderbuffer to bind
	     *    default is null which unbinds the renderbuffer for the attachment
	     * @param {String|Number} opts.attachment= - which buffer to bind
	     * @returns {FrameBuffer} returns itself to enable chaining
	     */
	
	  }, {
	    key: 'attachRenderbuffer',
	    value: function attachRenderbuffer() {
	      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref7$renderbuffer = _ref7.renderbuffer,
	          renderbuffer = _ref7$renderbuffer === undefined ? null : _ref7$renderbuffer,
	          _ref7$attachment = _ref7.attachment,
	          attachment = _ref7$attachment === undefined ? _webgl.GL.COLOR_ATTACHMENT0 : _ref7$attachment,
	          _ref7$target = _ref7.target,
	          target = _ref7$target === undefined ? _webgl.GL.FRAMEBUFFER : _ref7$target,
	          _ref7$renderbufferTar = _ref7.renderbufferTarget,
	          renderbufferTarget = _ref7$renderbufferTar === undefined ? _webgl.GL.RENDERBUFFER : _ref7$renderbufferTar;
	
	      var gl = this.gl;
	
	      renderbuffer = renderbuffer && _renderbuffer2.default.makeFrom(gl, renderbuffer);
	
	      this.bind({ target: target });
	
	      gl.framebufferRenderbuffer(target, (0, _webgl.glGet)(attachment), (0, _webgl.glGet)(renderbufferTarget), renderbuffer.handle);
	
	      this.unbind({ target: target });
	
	      return this;
	    }
	  }, {
	    key: 'checkStatus',
	    value: function checkStatus() {
	      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref8$target = _ref8.target,
	          target = _ref8$target === undefined ? _webgl.GL.FRAMEBUFFER : _ref8$target;
	
	      var gl = this.gl;
	
	
	      this.bind({ target: target });
	
	      var status = gl.checkFramebufferStatus(target);
	
	      this.unbind({ target: target });
	
	      if (status !== gl.FRAMEBUFFER_COMPLETE) {
	        throw new Error(this._getFrameBufferStatus(status));
	      }
	
	      return this;
	    }
	
	    // WEBGL2 INTERFACE
	
	  }, {
	    key: 'blit',
	    value: function blit(_ref9) {
	      var srcX0 = _ref9.srcX0,
	          srcY0 = _ref9.srcY0,
	          srcX1 = _ref9.srcX1,
	          srcY1 = _ref9.srcY1,
	          dstX0 = _ref9.dstX0,
	          dstY0 = _ref9.dstY0,
	          dstX1 = _ref9.dstX1,
	          dstY1 = _ref9.dstY1,
	          mask = _ref9.mask,
	          _ref9$filter = _ref9.filter,
	          filter = _ref9$filter === undefined ? _webgl.GL.NEAREST : _ref9$filter;
	      var gl = this.gl;
	
	      (0, _webglChecks.assertWebGL2Context)(gl);
	      gl.blitFramebuffer(srcX0, srcY0, srcX1, srcY1, dstX0, dstY0, dstX1, dstY1, mask, filter);
	      return this;
	    }
	  }, {
	    key: 'textureLayer',
	    value: function textureLayer() {
	      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref10$target = _ref10.target,
	          target = _ref10$target === undefined ? _webgl.GL.FRAMEBUFFER : _ref10$target,
	          attachment = _ref10.attachment,
	          texture = _ref10.texture,
	          level = _ref10.level,
	          layer = _ref10.layer;
	
	      var gl = this.gl;
	
	      (0, _webglChecks.assertWebGL2Context)(gl);
	      gl.framebufferTextureLayer(target, attachment, texture, level, layer);
	      return this;
	    }
	  }, {
	    key: 'invalidate',
	    value: function invalidate(_ref11) {
	      var _ref11$target = _ref11.target,
	          target = _ref11$target === undefined ? _webgl.GL.FRAMEBUFFER : _ref11$target,
	          _ref11$attachments = _ref11.attachments,
	          attachments = _ref11$attachments === undefined ? [] : _ref11$attachments;
	      var gl = this.gl;
	
	      (0, _webglChecks.assertWebGL2Context)(gl);
	      gl.invalidateFramebuffer(target, attachments);
	      return this;
	    }
	  }, {
	    key: 'invalidateSub',
	    value: function invalidateSub(_ref12) {
	      var _ref12$target = _ref12.target,
	          target = _ref12$target === undefined ? _webgl.GL.FRAMEBUFFER : _ref12$target,
	          _ref12$attachments = _ref12.attachments,
	          attachments = _ref12$attachments === undefined ? [] : _ref12$attachments,
	          _ref12$x = _ref12.x,
	          x = _ref12$x === undefined ? 0 : _ref12$x,
	          _ref12$y = _ref12.y,
	          y = _ref12$y === undefined ? 0 : _ref12$y,
	          width = _ref12.width,
	          height = _ref12.height;
	      var gl = this.gl;
	
	      (0, _webglChecks.assertWebGL2Context)(gl);
	      gl.invalidateFramebuffer(target, attachments, x, y, width, height);
	      return this;
	    }
	
	    // Selects a color buffer as the source for pixels for subsequent calls to
	    // copyTexImage2D, copyTexSubImage2D, copyTexSubImage3D or readPixels.
	    // src
	    //  gl.BACK: Reads from the back color buffer.
	    //  gl.NONE: Reads from no color buffer.
	    //  gl.COLOR_ATTACHMENT{0-15}: Reads from one of 16 color attachment buffers.
	
	  }, {
	    key: 'readBuffer',
	    value: function readBuffer(_ref13) {
	      var src = _ref13.src;
	      var gl = this.gl;
	
	      (0, _webglChecks.assertWebGL2Context)(gl);
	      gl.readBuffer(src);
	      return this;
	    }
	
	    // @returns {GLint}
	
	  }, {
	    key: 'alphaSize',
	    value: function alphaSize() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE);
	    }
	
	    // @returns {GLint}
	
	  }, {
	    key: 'blueSize',
	    value: function blueSize() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_BLUE_SIZE);
	    }
	
	    // @returns {GLenum}
	
	  }, {
	    key: 'colorEncoding',
	    value: function colorEncoding() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING);
	    }
	
	    // @returns {GLenum}
	
	  }, {
	    key: 'componentType',
	    value: function componentType() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE);
	    }
	
	    // @returns {GLint}
	
	  }, {
	    key: 'depthSize',
	    value: function depthSize() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE);
	    }
	
	    // @returns {GLint}
	
	  }, {
	    key: 'greenSize',
	    value: function greenSize() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_GREEN_SIZE);
	    }
	
	    // @returns {WebGLRenderbuffer|WebGLTexture}
	
	  }, {
	    key: 'objectName',
	    value: function objectName() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_OBJECT_NAME);
	    }
	
	    // @returns {GLenum}
	
	  }, {
	    key: 'objectType',
	    value: function objectType() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE);
	    }
	
	    // @returns {GLint}
	
	  }, {
	    key: 'redSize',
	    value: function redSize() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_RED_SIZE);
	    }
	
	    // @returns {GLint}
	
	  }, {
	    key: 'stencilSize',
	    value: function stencilSize() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE);
	    }
	
	    // @returns {GLint}
	
	  }, {
	    key: 'cubeMapFace',
	    value: function cubeMapFace() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE);
	    }
	
	    // @returns {GLint}
	
	  }, {
	    key: 'layer',
	    value: function layer() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER);
	    }
	
	    // @returns {GLint}
	
	  }, {
	    key: 'level',
	    value: function level() {
	      return this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL);
	    }
	  }, {
	    key: 'getParameters',
	    value: function getParameters() {
	      return {
	        redSize: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_RED_SIZE),
	        greenSize: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_GREEN_SIZE),
	        blueSize: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_BLUE_SIZE),
	        alphaSize: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE),
	
	        depthSize: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE),
	        stencilSize: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE),
	
	        colorEncoding: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING),
	        componentType: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE),
	        objectName: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_OBJECT_NAME),
	        objectType: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE),
	        cubeMapFace: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE),
	        layer: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER),
	        level: this.getAttachmentParameter(_webgl.GL.FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL)
	      };
	    }
	
	    // (OpenGL ES 3.0.4 §6.1.13, similar to glGetFramebufferAttachmentParameteriv)
	    // Return the value for the passed pname given the target and attachment.
	    // The type returned is the natural type for the requested pname:
	    // pname returned type
	    // FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE GLint
	    // FRAMEBUFFER_ATTACHMENT_BLUE_SIZE  GLint
	    // FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING GLenum
	    // FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE GLenum
	    // FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE GLint
	    // FRAMEBUFFER_ATTACHMENT_GREEN_SIZE GLint
	    // FRAMEBUFFER_ATTACHMENT_OBJECT_NAME  WebGLRenderbuffer or WebGLTexture
	    // FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE  GLenum
	    // FRAMEBUFFER_ATTACHMENT_RED_SIZE GLint
	    // FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE GLint
	    // FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE  GLint
	    // FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER  GLint
	    // FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL  GLint
	    // If pname is not in the table above, generates an INVALID_ENUM error.
	    // If an OpenGL error is generated, returns null.
	
	  }, {
	    key: 'getAttachmentParameter',
	    value: function getAttachmentParameter() {
	      var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          pname = _ref14.pname,
	          target = _ref14.target,
	          attachment = _ref14.attachment;
	
	      var gl = this.gl;
	
	      (0, _webglChecks.assertWebGL2Context)(gl);
	      var value = gl.getFramebufferAttachmentParameter(target, attachment, pname);
	      return value;
	    }
	
	    /* eslint-disable max-len */
	
	  }, {
	    key: '_getFrameBufferStatus',
	    value: function _getFrameBufferStatus(status) {
	      var error = void 0;
	      switch (status) {
	        case _webgl.GL.FRAMEBUFFER_COMPLETE:
	          error = 'Success. Framebuffer is correctly set up';
	          break;
	        case _webgl.GL.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
	          error = 'The attachment types are mismatched or not all framebuffer attachment points are framebuffer attachment complete.';
	          break;
	        case _webgl.GL.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
	          error = 'There is no attachment.';
	          break;
	        case _webgl.GL.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
	          error = 'Height and width of the attachment are not the same.';
	          break;
	        case _webgl.GL.FRAMEBUFFER_UNSUPPORTED:
	          error = 'The format of the attachment is not supported or if depth and stencil attachments are not the same renderbuffer.';
	          break;
	        // When using a WebGL 2 context, the following values can be returned
	        case _webgl.GL.FRAMEBUFFER_INCOMPLETE_MULTISAMPLE:
	          error = 'The values of GL.RENDERBUFFER_SAMPLES are different among attached renderbuffers, or are non-zero if the attached images are a mix of renderbuffers and textures.';
	          break;
	        default:
	          error = 'Framebuffer error ' + status;
	          break;
	      }
	      return error;
	    }
	    /* eslint-enable max-len */
	
	  }]);
	
	  return Framebuffer;
	}();
	
	exports.default = Framebuffer;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FragmentShader = exports.VertexShader = exports.Shader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _webglFormatGlslError = __webpack_require__(1066);
	
	var _utils = __webpack_require__(30);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ERR_SOURCE = 'Shader: GLSL source code must be a JavaScript string';
	
	// For now this is an internal class
	
	var Shader = exports.Shader = function () {
	
	  /* eslint-disable max-statements */
	  function Shader(gl, source, shaderType) {
	    _classCallCheck(this, Shader);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	    (0, _assert2.default)(typeof source === 'string', ERR_SOURCE);
	
	    this.id = (0, _webglFormatGlslError.getShaderName)(source) || (0, _utils.uid)(this.getTypeName(shaderType));
	    this.gl = gl;
	    this.shaderType = shaderType;
	    this.source = source;
	    this.handle = gl.createShader(shaderType);
	    if (this.handle === null) {
	      throw new Error('Error creating shader with type ' + shaderType);
	    }
	    this.compile();
	  }
	
	  _createClass(Shader, [{
	    key: 'delete',
	    value: function _delete() {
	      var gl = this.gl;
	
	      if (this.handle) {
	        gl.deleteShader(this.handle);
	        this.handle = null;
	      }
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.getTypeName(this.shaderType) + ':' + this.id;
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return (0, _webglFormatGlslError.getShaderName)(this.source);
	    }
	  }, {
	    key: 'getTypeName',
	    value: function getTypeName(shaderType) {
	      switch (shaderType) {
	        case _webgl.GL.VERTEX_SHADER:
	          return 'vertex-shader';
	        case _webgl.GL.FRAGMENT_SHADER:
	          return 'fragment-shader';
	        default:
	          return 'shader';
	      }
	    }
	  }, {
	    key: 'compile',
	    value: function compile() {
	      var gl = this.gl;
	
	      gl.shaderSource(this.handle, this.source);
	      gl.compileShader(this.handle);
	
	      // Shader compilation error is checked only when debug context is used
	      if (gl.debug) {
	        var compiled = gl.getShaderParameter(this.handle, _webgl.GL.COMPILE_STATUS);
	        if (!compiled) {
	          var infoLog = gl.getShaderInfoLog(this.handle);
	          var error = (0, _webglFormatGlslError.formatGLSLCompilerError)(infoLog, this.source, this.shaderType);
	          this.delete();
	          throw new Error('Error while compiling the shader ' + error);
	        }
	      }
	    }
	    /* eslint-enable max-statements */
	
	    // TODO - move to debug utils?
	
	  }, {
	    key: 'copyToClipboard',
	    value: function copyToClipboard(text) {
	      if (_utils.isBrowser) {
	        /* global document */
	        var input = document.createElement('textarea');
	        document.body.appendChild(input);
	        input.value = text;
	        input.focus();
	        input.select();
	        if (!document.execCommand('copy')) {
	          /* eslint-disable no-console */
	          /* global console */
	          console.log('Failed to copy to clipboard');
	        }
	        input.remove();
	      }
	    }
	  }]);
	
	  return Shader;
	}();
	
	var VertexShader = exports.VertexShader = function (_Shader) {
	  _inherits(VertexShader, _Shader);
	
	  function VertexShader(gl, source) {
	    _classCallCheck(this, VertexShader);
	
	    return _possibleConstructorReturn(this, (VertexShader.__proto__ || Object.getPrototypeOf(VertexShader)).call(this, gl, source, _webgl.GL.VERTEX_SHADER));
	  }
	
	  return VertexShader;
	}(Shader);
	
	var FragmentShader = exports.FragmentShader = function (_Shader2) {
	  _inherits(FragmentShader, _Shader2);
	
	  function FragmentShader(gl, source) {
	    _classCallCheck(this, FragmentShader);
	
	    return _possibleConstructorReturn(this, (FragmentShader.__proto__ || Object.getPrototypeOf(FragmentShader)).call(this, gl, source, _webgl.GL.FRAGMENT_SHADER));
	  }
	
	  return FragmentShader;
	}(Shader);
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _d3Hierarchy = __webpack_require__(144);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _withStateHandlers = __webpack_require__(1420);
	
	var _withStateHandlers2 = _interopRequireDefault(_withStateHandlers);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _hocs = __webpack_require__(52);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _colors = __webpack_require__(24);
	
	var _defs = __webpack_require__(168);
	
	var _bubble = __webpack_require__(1168);
	
	var _props = __webpack_require__(500);
	
	var props = _interopRequireWildcard(_props);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonEnhancers = [(0, _hocs.withHierarchy)(), (0, _hocs.withDimensions)(), (0, _hocs.withTheme)(), (0, _hocs.withColors)({ defaultColorBy: 'depth' }), (0, _withPropsOnChange2.default)(['width', 'height', 'padding'], function (_ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        padding = _ref.padding;
	    return {
	        pack: (0, _d3Hierarchy.pack)().size([width, height]).padding(padding)
	    };
	}), (0, _withPropsOnChange2.default)(['identity'], function (_ref2) {
	    var identity = _ref2.identity;
	    return {
	        getIdentity: (0, _propertiesConverters.getAccessorFor)(identity)
	    };
	}),
	
	// border
	(0, _withPropsOnChange2.default)(['borderColor'], function (_ref3) {
	    var borderColor = _ref3.borderColor;
	    return {
	        getBorderColor: (0, _colors.getInheritedColorGenerator)(borderColor)
	    };
	}),
	
	// labels
	(0, _withPropsOnChange2.default)(['label', 'labelFormat'], function (_ref4) {
	    var label = _ref4.label,
	        labelFormat = _ref4.labelFormat;
	    return {
	        getLabel: (0, _propertiesConverters.getLabelGenerator)(label, labelFormat)
	    };
	}), (0, _withPropsOnChange2.default)(['labelTextColor'], function (_ref5) {
	    var labelTextColor = _ref5.labelTextColor;
	    return {
	        getLabelTextColor: (0, _colors.getInheritedColorGenerator)(labelTextColor)
	    };
	}),
	
	// zoom
	(0, _withStateHandlers2.default)(function (_ref6) {
	    var _ref6$currentNodePath = _ref6.currentNodePath,
	        currentNodePath = _ref6$currentNodePath === undefined ? null : _ref6$currentNodePath;
	    return {
	        currentNodePath: currentNodePath
	    };
	}, {
	    zoomToNode: function zoomToNode(_ref7) {
	        var currentNodePath = _ref7.currentNodePath;
	        return function (path) {
	            if (path === currentNodePath) return { currentNodePath: null };
	            return { currentNodePath: path };
	        };
	    }
	}), (0, _withPropsOnChange2.default)(['root', 'pack', 'leavesOnly', 'getIdentity', 'getColor'], function (_ref8) {
	    var root = _ref8.root,
	        pack = _ref8.pack,
	        leavesOnly = _ref8.leavesOnly,
	        getIdentity = _ref8.getIdentity,
	        getColor = _ref8.getColor;
	
	    var nodes = (0, _bubble.computeNodes)({ root: root, pack: pack, leavesOnly: leavesOnly, getIdentity: getIdentity, getColor: getColor });
	
	    return { nodes: nodes };
	}), (0, _withPropsOnChange2.default)(['enableLabel', 'nodes', 'getLabel', 'labelSkipRadius'], function (_ref9) {
	    var enableLabel = _ref9.enableLabel,
	        nodes = _ref9.nodes,
	        getLabel = _ref9.getLabel,
	        labelSkipRadius = _ref9.labelSkipRadius;
	
	    if (!enableLabel) return;
	    var nodesWithLabel = nodes.map(function (node) {
	        if (node.height !== 0 || labelSkipRadius > 0 && node.r < labelSkipRadius) return node;
	        return _extends({}, node, { label: getLabel(node) });
	    });
	
	    return { nodes: nodesWithLabel };
	}), (0, _withPropsOnChange2.default)(['nodes', 'isZoomable', 'currentNodePath'], function (_ref10) {
	    var nodes = _ref10.nodes,
	        isZoomable = _ref10.isZoomable,
	        currentNodePath = _ref10.currentNodePath,
	        width = _ref10.width,
	        height = _ref10.height;
	
	    if (currentNodePath && isZoomable) {
	        return {
	            nodes: (0, _bubble.computeZoom)(nodes, currentNodePath, width, height)
	        };
	    }
	})];
	
	var svgEnhancers = [(0, _withPropsOnChange2.default)(['nodes', 'defs', 'fill'], function (_ref11) {
	    var nodes = _ref11.nodes,
	        defs = _ref11.defs,
	        fill = _ref11.fill;
	
	    return {
	        defs: (0, _defs.bindDefs)(defs, nodes, fill, { targetKey: 'fill' })
	    };
	})];
	
	exports.default = function (Component) {
	    var implPropTypes = props[Component.displayName + 'PropTypes'];
	    var implDefaultProps = props[Component.displayName + 'DefaultProps'];
	
	    Component.propTypes = implPropTypes;
	
	    switch (Component.displayName) {
	        case 'Bubble':
	            return _compose2.default.apply(undefined, [(0, _defaultProps2.default)(implDefaultProps)].concat(commonEnhancers, svgEnhancers, [(0, _hocs.withMotion)(), _pure2.default]))(Component);
	
	        case 'BubbleHtml':
	            return _compose2.default.apply(undefined, [(0, _defaultProps2.default)(implDefaultProps)].concat(commonEnhancers, [(0, _hocs.withMotion)(), _pure2.default]))(Component);
	
	        case 'BubbleCanvas':
	            return _compose2.default.apply(undefined, [(0, _defaultProps2.default)(implDefaultProps)].concat(commonEnhancers, [_pure2.default]))(Component);
	    }
	
	    return Component;
	};

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CalendarDefaultProps = exports.CalendarPropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noop = __webpack_require__(107);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _directions = __webpack_require__(223);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Calendar components propTypes.
	 *
	 * @type {object}
	 */
	var CalendarPropTypes = exports.CalendarPropTypes = {
	    from: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
	    to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        day: _propTypes2.default.string.isRequired,
	        value: _propTypes2.default.number.isRequired
	    })).isRequired,
	
	    domain: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto']), _propTypes2.default.arrayOf(_propTypes2.default.number)]).isRequired,
	    colors: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	    colorScale: _propTypes2.default.func.isRequired,
	
	    onDayClick: _propTypes2.default.func.isRequired,
	    direction: _propTypes2.default.oneOf([_directions.DIRECTION_HORIZONTAL, _directions.DIRECTION_VERTICAL]),
	    emptyColor: _propTypes2.default.string.isRequired,
	
	    // years
	    yearSpacing: _propTypes2.default.number.isRequired,
	    yearLegendOffset: _propTypes2.default.number.isRequired,
	
	    // months
	    monthBorderWidth: _propTypes2.default.number.isRequired,
	    monthBorderColor: _propTypes2.default.string.isRequired,
	    monthLegendOffset: _propTypes2.default.number.isRequired,
	
	    // days
	    daySpacing: _propTypes2.default.number.isRequired,
	    dayBorderWidth: _propTypes2.default.number.isRequired,
	    dayBorderColor: _propTypes2.default.string.isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	
	    /**
	     * Calendar components defaultProps.
	     *
	     * @type {object}
	     */
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	var CalendarDefaultProps = exports.CalendarDefaultProps = {
	    domain: 'auto',
	    colors: ['#61cdbb', '#97e3d5', '#e8c1a0', '#f47560'],
	
	    direction: _directions.DIRECTION_HORIZONTAL,
	    onDayClick: function onDayClick() {},
	    emptyColor: '#fff',
	
	    // years
	    yearSpacing: 30,
	    yearLegendOffset: 10,
	
	    // months
	    monthBorderWidth: 2,
	    monthBorderColor: '#000',
	    monthLegendOffset: 6,
	
	    // days
	    daySpacing: 0,
	    dayBorderWidth: 1,
	    dayBorderColor: '#000',
	
	    // interactivity
	    isInteractive: true,
	    onClick: _noop2.default
	};

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PieDefaultProps = exports.PiePropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PiePropTypes = exports.PiePropTypes = {
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired,
	        value: _propTypes2.default.number.isRequired
	    })).isRequired,
	
	    sortByValue: _propTypes2.default.bool.isRequired,
	    innerRadius: _propTypes2.default.number.isRequired,
	    padAngle: _propTypes2.default.number.isRequired,
	    cornerRadius: _propTypes2.default.number.isRequired,
	
	    // border
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	    // radial labels
	    enableRadialLabels: _propTypes2.default.bool.isRequired,
	    radialLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    radialLabelsSkipAngle: _propTypes2.default.number,
	    radialLabelsTextXOffset: _propTypes2.default.number,
	    radialLabelsTextColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    radialLabelsLinkOffset: _propTypes2.default.number,
	    radialLabelsLinkDiagonalLength: _propTypes2.default.number,
	    radialLabelsLinkHorizontalLength: _propTypes2.default.number,
	    radialLabelsLinkStrokeWidth: _propTypes2.default.number,
	    radialLabelsLinkColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	    // slices labels
	    enableSlicesLabels: _propTypes2.default.bool.isRequired,
	    sliceLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    slicesLabelsSkipAngle: _propTypes2.default.number,
	    slicesLabelsTextColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	    // styling
	    defs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired
	    })).isRequired,
	    fill: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string,
	        match: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['*']), _propTypes2.default.object, _propTypes2.default.func]).isRequired
	    })).isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	var PieDefaultProps = exports.PieDefaultProps = {
	    sortByValue: false,
	    innerRadius: 0,
	    padAngle: 0,
	    cornerRadius: 0,
	
	    // border
	    borderWidth: 0,
	    borderColor: 'inherit:darker(1)',
	
	    // radial labels
	    enableRadialLabels: true,
	    radialLabel: 'id',
	    radialLabelsTextColor: 'theme',
	    radialLabelsLinkColor: 'theme',
	
	    // slices labels
	    enableSlicesLabels: true,
	    sliceLabel: 'value',
	    slicesLabelsTextColor: 'theme',
	
	    // styling
	    defs: [],
	    fill: [],
	
	    // interactivity
	    isInteractive: true
	};

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SankeyDefaultProps = exports.SankeyPropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _props = __webpack_require__(19);
	
	var _noop = __webpack_require__(107);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SankeyPropTypes = exports.SankeyPropTypes = {
	    data: _propTypes2.default.shape({
	        nodes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	            id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	        })).isRequired,
	        links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	            source: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	            target: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	        })).isRequired
	    }).isRequired,
	
	    align: _props.sankeyAlignmentPropType.isRequired,
	
	    // nodes
	    nodeOpacity: _propTypes2.default.number.isRequired,
	    nodeHoverOpacity: _propTypes2.default.number.isRequired,
	    nodeHoverOthersOpacity: _propTypes2.default.number.isRequired,
	    nodeWidth: _propTypes2.default.number.isRequired,
	    nodePaddingX: _propTypes2.default.number.isRequired,
	    nodePaddingY: _propTypes2.default.number.isRequired,
	    nodeBorderWidth: _propTypes2.default.number.isRequired,
	    nodeBorderColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	    // links
	    linkOpacity: _propTypes2.default.number.isRequired,
	    linkHoverOpacity: _propTypes2.default.number.isRequired,
	    linkHoverOthersOpacity: _propTypes2.default.number.isRequired,
	    linkContract: _propTypes2.default.number.isRequired,
	
	    // labels
	    enableLabels: _propTypes2.default.bool.isRequired,
	    labelPosition: _propTypes2.default.oneOf(['inside', 'outside']).isRequired,
	    labelPadding: _propTypes2.default.number.isRequired,
	    labelOrientation: _propTypes2.default.oneOf(['horizontal', 'vertical']).isRequired,
	    labelTextColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    getLabelTextColor: _propTypes2.default.func.isRequired, // computed
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    labelFormat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    getLabel: _propTypes2.default.func.isRequired, // computed
	
	    // tooltip
	    nodeTooltip: _propTypes2.default.func,
	    linkTooltip: _propTypes2.default.func,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	var SankeyDefaultProps = exports.SankeyDefaultProps = {
	    align: 'center',
	
	    // nodes
	    nodeOpacity: 0.75,
	    nodeHoverOpacity: 1,
	    nodeHoverOthersOpacity: 0.15,
	    nodeWidth: 12,
	    nodePaddingX: 0,
	    nodePaddingY: 12,
	    nodeBorderWidth: 1,
	    nodeBorderColor: 'inherit:darker(0.5)',
	
	    // links
	    linkOpacity: 0.25,
	    linkHoverOpacity: 0.6,
	    linkHoverOthersOpacity: 0.15,
	    linkContract: 0,
	
	    // labels
	    enableLabels: true,
	    label: 'id',
	    labelPosition: 'inside',
	    labelPadding: 9,
	    labelOrientation: 'horizontal',
	    labelTextColor: 'inherit:darker(0.8)',
	
	    // interactivity
	    isInteractive: true,
	    onClick: _noop2.default
	};

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StreamDefaultProps = exports.StreamPropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _props = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var StreamPropTypes = exports.StreamPropTypes = {
	    // data
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    keys: _propTypes2.default.array.isRequired,
	
	    stack: _propTypes2.default.func.isRequired,
	    xScale: _propTypes2.default.func.isRequired,
	    yScale: _propTypes2.default.func.isRequired,
	
	    order: _props.stackOrderPropType.isRequired,
	    offsetType: _props.stackOffsetPropType.isRequired,
	    curve: _props.areaCurvePropType.isRequired,
	    areaGenerator: _propTypes2.default.func.isRequired,
	
	    // axes & grid
	    axisTop: _propTypes2.default.object,
	    axisRight: _propTypes2.default.object,
	    axisBottom: _propTypes2.default.object,
	    axisLeft: _propTypes2.default.object,
	    enableGridX: _propTypes2.default.bool.isRequired,
	    enableGridY: _propTypes2.default.bool.isRequired,
	
	    // styling
	    colors: _propTypes2.default.any.isRequired,
	    fillOpacity: _propTypes2.default.number.isRequired,
	    getColor: _propTypes2.default.func.isRequired, // computed
	    defs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired
	    })).isRequired,
	    fill: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string,
	        match: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['*']), _propTypes2.default.object, _propTypes2.default.func]).isRequired
	    })).isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.any.isRequired,
	    getBorderColor: _propTypes2.default.func.isRequired, // computed
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool,
	    enableStackTooltip: _propTypes2.default.bool.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	};
	
	var StreamDefaultProps = exports.StreamDefaultProps = {
	    order: 'none',
	    offsetType: 'wiggle',
	    curve: 'catmullRom',
	
	    // axes & grid
	    axisBottom: {},
	    enableGridX: true,
	    enableGridY: false,
	
	    borderWidth: 0,
	    borderColor: 'inherit:darker(1)',
	
	    // styling
	    colors: 'nivo',
	    fillOpacity: 1,
	    defs: [],
	    fill: [],
	
	    // interactivity
	    isInteractive: true,
	
	    // stack tooltip
	    enableStackTooltip: true
	};

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _d3Hierarchy = __webpack_require__(144);
	
	var _cloneDeep = __webpack_require__(283);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _hocs = __webpack_require__(52);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _props = __webpack_require__(19);
	
	var _colors = __webpack_require__(24);
	
	var _hierarchy = __webpack_require__(534);
	
	var _defs = __webpack_require__(168);
	
	var _props2 = __webpack_require__(524);
	
	var props = _interopRequireWildcard(_props2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonEnhancers = [(0, _hocs.withHierarchy)(), (0, _hocs.withDimensions)(), (0, _hocs.withColors)({ defaultColorBy: 'depth' }), (0, _hocs.withTheme)(), (0, _hocs.withMotion)(), (0, _withPropsOnChange2.default)(['identity'], function (_ref) {
	    var identity = _ref.identity;
	    return {
	        getIdentity: (0, _propertiesConverters.getAccessorFor)(identity)
	    };
	}), (0, _withPropsOnChange2.default)(['borderColor'], function (_ref2) {
	    var borderColor = _ref2.borderColor;
	    return {
	        getBorderColor: (0, _colors.getInheritedColorGenerator)(borderColor)
	    };
	}), (0, _withPropsOnChange2.default)(['label', 'labelFormat'], function (_ref3) {
	    var label = _ref3.label,
	        labelFormat = _ref3.labelFormat;
	    return {
	        getLabel: (0, _propertiesConverters.getLabelGenerator)(label, labelFormat)
	    };
	}), (0, _withPropsOnChange2.default)(['labelTextColor'], function (_ref4) {
	    var labelTextColor = _ref4.labelTextColor;
	    return {
	        getLabelTextColor: (0, _colors.getInheritedColorGenerator)(labelTextColor)
	    };
	}), (0, _withPropsOnChange2.default)(['width', 'height', 'tile', 'innerPadding', 'outerPadding'], function (_ref5) {
	    var width = _ref5.width,
	        height = _ref5.height,
	        tile = _ref5.tile,
	        innerPadding = _ref5.innerPadding,
	        outerPadding = _ref5.outerPadding;
	    return {
	        treemap: (0, _d3Hierarchy.treemap)().size([width, height]).tile((0, _props.treeMapTileFromProp)(tile)).round(true).paddingInner(innerPadding).paddingOuter(outerPadding)
	    };
	}), (0, _withPropsOnChange2.default)(['root', 'treemap', 'leavesOnly', 'getIdentity', 'getColor'], function (_ref6) {
	    var _root = _ref6.root,
	        treemap = _ref6.treemap,
	        leavesOnly = _ref6.leavesOnly,
	        getIdentity = _ref6.getIdentity,
	        getColor = _ref6.getColor;
	
	    var root = (0, _cloneDeep2.default)(_root);
	
	    treemap(root);
	
	    var nodes = leavesOnly ? root.leaves() : root.descendants();
	    nodes = nodes.map(function (d) {
	        d.path = (0, _hierarchy.computeNodePath)(d, getIdentity);
	
	        d.nodeHeight = d.height;
	
	        d.x = d.x0;
	        d.y = d.y0;
	        d.width = d.x1 - d.x0;
	        d.height = d.y1 - d.y0;
	        d.data.color = d.color = getColor(_extends({}, d.data, { depth: d.depth }));
	
	        d.data.id = d.id = getIdentity(d.data);
	        d.data.value = d.value;
	
	        return d;
	    });
	
	    return { nodes: nodes };
	}), (0, _withPropsOnChange2.default)(['enableLabel', 'nodes', 'getLabel', 'labelSkipSize'], function (_ref7) {
	    var enableLabel = _ref7.enableLabel,
	        nodes = _ref7.nodes,
	        getLabel = _ref7.getLabel,
	        labelSkipSize = _ref7.labelSkipSize;
	
	    if (!enableLabel) return;
	
	    var nodesWithLabel = nodes.map(function (node) {
	        if (node.nodeHeight > 0 || labelSkipSize !== 0 && Math.min(node.width, node.height) <= labelSkipSize) return node;
	        return _extends({}, node, { label: getLabel(node.data) });
	    });
	
	    return { nodes: nodesWithLabel };
	})];
	
	var svgEnhancers = [(0, _withPropsOnChange2.default)(['nodes', 'defs', 'fill'], function (_ref8) {
	    var nodes = _ref8.nodes,
	        defs = _ref8.defs,
	        fill = _ref8.fill;
	
	    return {
	        defs: (0, _defs.bindDefs)(defs, nodes, fill, { targetKey: 'fill' })
	    };
	})];
	
	exports.default = function (Component) {
	    var implPropTypes = props[Component.displayName + 'PropTypes'];
	    var implDefaultProps = props[Component.displayName + 'DefaultProps'];
	
	    Component.propTypes = implPropTypes;
	
	    switch (Component.displayName) {
	        case 'TreeMap':
	        case 'TreeMapPlaceholders':
	            return _compose2.default.apply(undefined, [(0, _defaultProps2.default)(implDefaultProps)].concat(commonEnhancers, svgEnhancers, [(0, _hocs.withMotion)(), _pure2.default]))(Component);
	
	        case 'TreeMapHtml':
	            return _compose2.default.apply(undefined, [(0, _defaultProps2.default)(implDefaultProps)].concat(commonEnhancers, [(0, _hocs.withMotion)(), _pure2.default]))(Component);
	
	        case 'TreeMapCanvas':
	            return _compose2.default.apply(undefined, [(0, _defaultProps2.default)(implDefaultProps)].concat(commonEnhancers, [_pure2.default]))(Component);
	    }
	
	    return Component;
	};

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.VoronoiDefaultProps = exports.VoronoiPropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VoronoiPropTypes = exports.VoronoiPropTypes = {
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	        x: _propTypes2.default.number.isRequired,
	        y: _propTypes2.default.number.isRequired
	    })).isRequired,
	    enablePolygons: _propTypes2.default.bool.isRequired,
	    enableSites: _propTypes2.default.bool.isRequired,
	    enableLinks: _propTypes2.default.bool.isRequired,
	    x: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    y: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired,
	    linkWidth: _propTypes2.default.number.isRequired,
	    linkColor: _propTypes2.default.string.isRequired,
	    siteSize: _propTypes2.default.number.isRequired,
	    siteColor: _propTypes2.default.string.isRequired
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	var VoronoiDefaultProps = exports.VoronoiDefaultProps = {
	    enablePolygons: true,
	    enableSites: false,
	    enableLinks: false,
	    x: 0,
	    y: 1,
	    borderWidth: 2,
	    borderColor: '#000',
	    linkWidth: 1,
	    linkColor: '#bbb',
	    siteSize: 4,
	    siteColor: '#666'
	};

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gradients = __webpack_require__(526);
	
	Object.keys(_gradients).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _gradients[key];
	    }
	  });
	});
	
	var _patterns = __webpack_require__(527);
	
	Object.keys(_patterns).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _patterns[key];
	    }
	  });
	});
	
	var _Defs = __webpack_require__(1149);
	
	Object.keys(_Defs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Defs[key];
	    }
	  });
	});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DotsItemDefaultProps = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _DotsItemSymbol = __webpack_require__(1154);
	
	var _DotsItemSymbol2 = _interopRequireDefault(_DotsItemSymbol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var DotsItem = function DotsItem(_ref) {
	    var x = _ref.x,
	        y = _ref.y,
	        symbol = _ref.symbol,
	        size = _ref.size,
	        color = _ref.color,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        label = _ref.label,
	        labelTextAnchor = _ref.labelTextAnchor,
	        labelYOffset = _ref.labelYOffset,
	        theme = _ref.theme;
	    return _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + x + ', ' + y + ')', style: { pointerEvents: 'none' } },
	        _react2.default.createElement(symbol, {
	            size: size,
	            color: color,
	            borderWidth: borderWidth,
	            borderColor: borderColor
	        }),
	        label && _react2.default.createElement(
	            'text',
	            {
	                textAnchor: labelTextAnchor,
	                y: labelYOffset,
	                style: {
	                    fontSize: theme.dots.fontSize,
	                    fill: theme.dots.textColor
	                }
	            },
	            label
	        )
	    );
	};
	
	DotsItem.propTypes = {
	    // position
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired,
	
	    // style
	    size: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired,
	
	    symbol: _propTypes2.default.func.isRequired,
	
	    // label
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    labelTextAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end']),
	    labelYOffset: _propTypes2.default.number.isRequired,
	
	    // theming
	    theme: _propTypes2.default.shape({
	        dots: _propTypes2.default.shape({
	            textColor: _propTypes2.default.string.isRequired,
	            fontSize: _propTypes2.default.string.isRequired
	        }).isRequired
	    }).isRequired
	};
	
	var DotsItemDefaultProps = exports.DotsItemDefaultProps = {
	    symbol: _DotsItemSymbol2.default,
	
	    // label
	    labelTextAnchor: 'middle',
	    labelYOffset: -12
	};
	
	DotsItem.defaultProps = DotsItemDefaultProps;
	
	exports.default = (0, _pure2.default)(DotsItem);

/***/ },
/* 312 */
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 313 */
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 314 */
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },
/* 315 */
[1483, 1200],
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(134);
	var Danger = __webpack_require__(1214);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(65);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(325);
	var setInnerHTML = __webpack_require__(230);
	var setTextContent = __webpack_require__(565);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 317 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactErrorUtils = __webpack_require__(323);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 320 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactPropTypesSecret = __webpack_require__(1240);
	var propTypesFactory = __webpack_require__(540);
	
	var React = __webpack_require__(115);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(4);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactInstanceMap = __webpack_require__(171);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactUpdates = __webpack_require__(72);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 325 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 326 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 327 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 328 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(11);
	
	var ReactCompositeComponent = __webpack_require__(1221);
	var ReactEmptyComponent = __webpack_require__(550);
	var ReactHostComponent = __webpack_require__(552);
	
	var getNextDebugID = __webpack_require__(1395);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 331 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var emptyFunction = __webpack_require__(36);
	var warning = __webpack_require__(8);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 333 */
312,
/* 334 */
313,
/* 335 */
314,
/* 336 */
[1496, 173, 337, 575],
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utility = exports.events = exports.base = exports.element = exports.helpers = undefined;
	
	var _helpers = __webpack_require__(578);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _element = __webpack_require__(1316);
	
	var _element2 = _interopRequireDefault(_element);
	
	var _base = __webpack_require__(577);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _events = __webpack_require__(1317);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _utility = __webpack_require__(339);
	
	var _utility2 = _interopRequireDefault(_utility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = exports.helpers = _helpers2.default;
	var element = exports.element = _element2.default;
	var base = exports.base = _base2.default;
	var events = exports.events = _events2.default;
	var utility = exports.utility = _utility2.default;
	
	exports.default = {
	  helpers: _helpers2.default,
	  element: _element2.default,
	  base: _base2.default,
	  events: _events2.default,
	  utility: _utility2.default
	};

/***/ },
/* 339 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var utilityKeys = exports.utilityKeys = function utilityKeys(attr) {
	  var obj = utilityCss[attr];
	
	  return Object.keys(obj).map(function (key) {
	    return key;
	  });
	};
	
	var utilityCss = exports.utilityCss = {
	  align: {
	    left: 'uk-align-left',
	    right: 'uk-align-right',
	    middleLeft: 'uk-align-medium-left',
	    middleRight: 'uk-align-medium-right',
	    center: 'uk-align-center'
	  },
	
	  borderRadius: {
	    rounded: 'uk-border-rounded',
	    circle: 'uk-border-circle'
	  },
	
	  center: 'uk-container-center',
	
	  clear: {
	    fix: 'uk-clearfix',
	    nbfc: 'uk-nbfc',
	    alt: 'uk-nbfc-alt'
	  },
	
	  display: {
	    block: 'uk-display-block',
	    inline: 'uk-display-inline',
	    inlineBlock: 'uk-display-inline-block'
	  },
	
	  'float': {
	    left: 'uk-float-left',
	    right: 'uk-float-right',
	    clear: 'uk-clearfix'
	  },
	
	  hidden: {
	    all: 'uk-hidden',
	    invisible: 'uk-invisible',
	    large: 'uk-hidden-large',
	    small: 'uk-hidden-small',
	    medium: 'uk-hidden-medium',
	    touch: 'uk-hidden-touch',
	    notouch: 'uk-hidden-notouch'
	  },
	
	  margin: {
	    top: 'uk-margin-top',
	    left: 'uk-margin-left',
	    bottom: 'uk-margin-bottom',
	    right: 'uk-margin-right',
	    smallTop: 'uk-margin-small-top',
	    smallLeft: 'uk-margin-small-left',
	    smallBottom: 'uk-margin-small-bottom',
	    smallRight: 'uk-margin-small-right',
	    largeTop: 'uk-margin-large-top',
	    largeLeft: 'uk-margin-large-left',
	    largeBottom: 'uk-margin-large-bottom',
	    largeRight: 'uk-margin-large-right',
	    remove: 'uk-margin-remove',
	    removeTop: 'uk-margin-top-remove',
	    removeBottom: 'uk-margin-bottom-remove'
	  },
	
	  order: {
	    first: 'uk-flex-order-first',
	    firstSmall: 'uk-flex-order-first-small',
	    firstMedium: 'uk-flex-order-first-medium',
	    firstLarge: 'uk-flex-order-first-large',
	    firstXlarge: 'uk-flex-order-first-xlarge',
	    last: 'uk-flex-order-last',
	    lastSmall: 'uk-flex-order-last-small',
	    lastMedium: 'uk-flex-order-last-medium',
	    lastLarge: 'uk-flex-order-last-large',
	    lastXlarge: 'uk-flex-order-last-xlarge'
	  },
	
	  padding: {
	    top: 'uk-padding-top',
	    left: 'uk-padding-left',
	    bottom: 'uk-padding-bottom',
	    right: 'uk-padding-right',
	    smallTop: 'uk-padding-small-top',
	    smallLeft: 'uk-padding-small-left',
	    smallBottom: 'uk-padding-small-bottom',
	    smallRight: 'uk-padding-small-right',
	    largeTop: 'uk-padding-large-top',
	    largeLeft: 'uk-padding-large-left',
	    largeBottom: 'uk-padding-large-bottom',
	    largeRight: 'uk-padding-large-right',
	    remove: 'uk-padding-remove',
	    removeTop: 'uk-padding-top-remove',
	    removeBottom: 'uk-padding-bottom-remove',
	    removeVertical: 'uk-padding-vertical-remove'
	  },
	
	  position: {
	    top: 'uk-position-top',
	    topLeft: 'uk-position-top-left',
	    topRight: 'uk-position-top-right',
	    bottom: 'uk-position-bottom',
	    bottomLeft: 'uk-position-bottom-left',
	    bottomRight: 'uk-position-bottom-right',
	    cover: 'uk-position-cover',
	    relative: 'uk-position-relative',
	    zIndex: 'uk-position-z-index'
	  },
	
	  responsive: {
	    width: 'uk-responsive-width',
	    height: 'uk-responsive-height'
	  },
	
	  scroll: {
	    auto: 'uk-overflow-container',
	    box: 'uk-scrollable-box',
	    hidden: 'uk-nbfc',
	    text: 'uk-scrollable-text'
	  },
	
	  tall: 'uk-height-1-1',
	
	  textAlign: {
	    center: 'uk-text-center',
	    centerSmall: 'uk-text-center-small',
	    centerMedium: 'uk-text-center-medium',
	    left: 'uk-text-left',
	    leftSmall: 'uk-text-left-small',
	    leftMedium: 'uk-text-left-medium',
	    justify: 'uk-text-justify',
	    right: 'uk-text-right'
	  },
	
	  textVertical: {
	    top: 'uk-text-top',
	    middle: 'uk-text-middle',
	    bottom: 'uk-text-bottom'
	  },
	
	  textWrap: {
	    truncate: 'uk-text-truncate',
	    'break': 'uk-text-break',
	    nowrap: 'uk-text-nowrap'
	  },
	
	  vertical: {
	    parent: 'uk-vertical-align',
	    middle: 'uk-vertical-align-middle',
	    bottom: 'uk-vertical-align-bottom'
	  },
	
	  visible: {
	    hover: 'uk-visible-hover',
	    hoverInline: 'uk-visible-hover-inline',
	    large: 'uk-visible-large',
	    medium: 'uk-visible-medium',
	    small: 'uk-visible-small',
	    touch: 'uk-visible-touch'
	  },
	
	  wide: 'uk-width-1-1'
	};
	
	exports.default = {
	  utilityKeys: utilityKeys,
	  utilityCss: utilityCss
	};

/***/ },
/* 340 */
[1496, 174, 341, 581],
/* 341 */
337,
/* 342 */
[1496, 175, 343, 586],
/* 343 */
337,
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pureRenderComponent = __webpack_require__(114);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _axisUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var VERTICAL = _axisUtils.DIRECTION.VERTICAL,
	    HORIZONTAL = _axisUtils.DIRECTION.HORIZONTAL;
	
	
	var propTypes = {
	  direction: _propTypes2.default.oneOf([VERTICAL, HORIZONTAL]),
	  attr: _propTypes2.default.string.isRequired,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	
	  tickValues: _propTypes2.default.array,
	  tickTotal: _propTypes2.default.number,
	
	  animation: _animation.AnimationPropType,
	
	  // generally supplied by xyplot
	  marginTop: _propTypes2.default.number,
	  marginBottom: _propTypes2.default.number,
	  marginLeft: _propTypes2.default.number,
	  marginRight: _propTypes2.default.number,
	  innerWidth: _propTypes2.default.number,
	  innerHeight: _propTypes2.default.number
	};
	
	var defaultProps = {
	  direction: VERTICAL
	};
	
	var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];
	
	var GridLines = function (_PureRenderComponent) {
	  _inherits(GridLines, _PureRenderComponent);
	
	  function GridLines() {
	    _classCallCheck(this, GridLines);
	
	    return _possibleConstructorReturn(this, (GridLines.__proto__ || Object.getPrototypeOf(GridLines)).apply(this, arguments));
	  }
	
	  _createClass(GridLines, [{
	    key: '_getDefaultProps',
	    value: function _getDefaultProps() {
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          marginTop = _props.marginTop,
	          marginLeft = _props.marginLeft,
	          direction = _props.direction;
	
	      return {
	        left: marginLeft,
	        top: marginTop,
	        width: innerWidth,
	        height: innerHeight,
	        tickTotal: (0, _axisUtils.getTicksTotalFromSize)(direction === VERTICAL ? innerWidth : innerHeight)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animation = this.props.animation;
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(GridLines, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var props = _extends({}, this._getDefaultProps(), this.props);
	
	      var attr = props.attr,
	          direction = props.direction,
	          width = props.width,
	          height = props.height,
	          tickTotal = props.tickTotal,
	          tickValues = props.tickValues,
	          top = props.top,
	          left = props.left;
	
	      var isVertical = direction === VERTICAL;
	      var tickXAttr = isVertical ? 'y' : 'x';
	      var tickYAttr = isVertical ? 'x' : 'y';
	      var length = isVertical ? height : width;
	
	      var scale = (0, _scalesUtils.getAttributeScale)(props, attr);
	      var values = (0, _axisUtils.getTickValues)(scale, tickTotal, tickValues);
	
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + left + ',' + top + ')',
	          className: 'rv-xy-plot__grid-lines' },
	        values.map(function (v, i) {
	          var _pathProps;
	
	          var pos = scale(v);
	          var pathProps = (_pathProps = {}, _defineProperty(_pathProps, tickYAttr + '1', pos), _defineProperty(_pathProps, tickYAttr + '2', pos), _defineProperty(_pathProps, tickXAttr + '1', 0), _defineProperty(_pathProps, tickXAttr + '2', length), _pathProps);
	          return _react2.default.createElement('line', _extends({}, pathProps, {
	            key: i,
	            className: 'rv-xy-plot__grid-lines__line' }));
	        })
	      );
	    }
	  }]);
	
	  return GridLines;
	}(_pureRenderComponent2.default);
	
	GridLines.displayName = 'GridLines';
	GridLines.defaultProps = defaultProps;
	GridLines.propTypes = propTypes;
	GridLines.requiresSVG = true;
	
	exports.default = GridLines;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _d3Shape = __webpack_require__(233);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _scalesUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--arc';
	var ATTRIBUTES = ['radius', 'angle'];
	
	var ArcSeries = function (_AbstractSeries) {
	  _inherits(ArcSeries, _AbstractSeries);
	
	  function ArcSeries(props) {
	    _classCallCheck(this, ArcSeries);
	
	    var _this = _possibleConstructorReturn(this, (ArcSeries.__proto__ || Object.getPrototypeOf(ArcSeries)).call(this, props));
	
	    var scaleProps = _this._getAllScaleProps(props);
	    _this.state = { scaleProps: scaleProps };
	    return _this;
	  }
	
	  _createClass(ArcSeries, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ scaleProps: this._getAllScaleProps(nextProps) });
	    }
	
	    /**
	     * Get the map of scales from the props.
	     * @param {Object} props Props.
	     * @param {Array} data Array of all data.
	     * @returns {Object} Map of scales.
	     * @private
	     */
	
	  }, {
	    key: '_getAllScaleProps',
	    value: function _getAllScaleProps(props) {
	      var defaultScaleProps = this._getDefaultScaleProps(props);
	      var userScaleProps = (0, _scalesUtils.extractScalePropsFromProps)(props, ATTRIBUTES);
	      var missingScaleProps = (0, _scalesUtils.getMissingScaleProps)(_extends({}, defaultScaleProps, userScaleProps), props.data, ATTRIBUTES);
	
	      return _extends({}, defaultScaleProps, userScaleProps, missingScaleProps);
	    }
	
	    /**
	     * Get the list of scale-related settings that should be applied by default.
	     * @param {Object} props Object of props.
	     * @returns {Object} Defaults.
	     * @private
	     */
	
	  }, {
	    key: '_getDefaultScaleProps',
	    value: function _getDefaultScaleProps(props) {
	      var innerWidth = props.innerWidth,
	          innerHeight = props.innerHeight;
	
	      var radius = Math.min(innerWidth / 2, innerHeight / 2);
	      return {
	        radiusRange: [0, radius],
	        _radiusValue: radius,
	        angleType: 'literal'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          arcClassName = _props.arcClassName,
	          animation = _props.animation,
	          className = _props.className,
	          center = _props.center,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          _props$style = _props.style,
	          style = _props$style === undefined ? {} : _props$style;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(ArcSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var scaleProps = this.state.scaleProps;
	      var radiusDomain = scaleProps.radiusDomain;
	      // need to generate our own functors as abstract series doesnt have anythign for us
	
	      var radius = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'radius');
	      var radius0 = (0, _scalesUtils.getAttr0Functor)(scaleProps, 'radius');
	      var angle = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'angle');
	      var angle0 = (0, _scalesUtils.getAttr0Functor)(scaleProps, 'angle');
	      // but it does have good color support!
	      var fill = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var stroke = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var opacity = this._getAttributeFunctor('opacity');
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          onMouseOver: this._seriesMouseOverHandler,
	          onMouseOut: this._seriesMouseOutHandler,
	          onClick: this._seriesClickHandler,
	          ref: 'container',
	          transform: 'translate(' + (marginLeft + x(center)) + ',' + (marginTop + y(center)) + ')' },
	        data.map(function (row, i) {
	          var noRadius = radiusDomain[1] === radiusDomain[0];
	          var arcArg = {
	            innerRadius: noRadius ? 0 : radius0(row),
	            outerRadius: radius(row),
	            startAngle: angle0(row) || 0,
	            endAngle: angle(row)
	          };
	          var arcedData = (0, _d3Shape.arc)();
	          var rowStyle = row.style || {};
	          return _react2.default.createElement('path', {
	            style: _extends({
	              opacity: opacity && opacity(row),
	              stroke: stroke && stroke(row),
	              fill: fill && fill(row)
	            }, style, rowStyle),
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(row, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(row, e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(row, e);
	            },
	            key: i,
	            className: arcClassName,
	            d: arcedData(arcArg)
	          });
	        })
	      );
	    }
	  }]);
	
	  return ArcSeries;
	}(_abstractSeries2.default);
	
	ArcSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes, (0, _scalesUtils.getScalePropTypesByAttribute)('radius'), (0, _scalesUtils.getScalePropTypesByAttribute)('angle'), {
	  center: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  arcClassName: _propTypes2.default.string
	});
	ArcSeries.defaultProps = {
	  arcClassName: '',
	  center: { x: 0, y: 0 },
	  className: ''
	};
	ArcSeries.displayName = 'ArcSeries';
	
	exports.default = ArcSeries;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Color = __webpack_require__(47);
	
	var _theme = __webpack_require__(45);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	var RectSeriesCanvas = function (_AbstractSeries) {
	  _inherits(RectSeriesCanvas, _AbstractSeries);
	
	  function RectSeriesCanvas() {
	    _classCallCheck(this, RectSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (RectSeriesCanvas.__proto__ || Object.getPrototypeOf(RectSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(RectSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      var data = props.data,
	          linePosAttr = props.linePosAttr,
	          lineSizeAttr = props.lineSizeAttr,
	          valuePosAttr = props.valuePosAttr;
	
	      if (!data || data.length === 0) {
	        return;
	      }
	
	      var line = (0, _scalesUtils.getAttributeFunctor)(props, linePosAttr);
	      var line0 = (0, _scalesUtils.getAttr0Functor)(props, linePosAttr);
	      var value = (0, _scalesUtils.getAttributeFunctor)(props, valuePosAttr);
	      var value0 = (0, _scalesUtils.getAttr0Functor)(props, valuePosAttr);
	      var fill = (0, _scalesUtils.getAttributeFunctor)(props, 'fill') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var stroke = (0, _scalesUtils.getAttributeFunctor)(props, 'stroke') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var opacity = (0, _scalesUtils.getAttributeFunctor)(props, 'opacity');
	
	      data.forEach(function (row) {
	        var fillColor = (0, _d3Color.rgb)(fill(row));
	        var strokeColor = (0, _d3Color.rgb)(stroke(row));
	        var rowOpacity = opacity(row) || _theme.DEFAULT_OPACITY;
	
	        var linePos = line0(row);
	        var valuePos = Math.min(value0(row), value(row));
	        var x = valuePosAttr === 'x' ? valuePos : linePos;
	        var y = valuePosAttr === 'y' ? valuePos : linePos;
	
	        var lineSize = Math.abs(line(row) - line0(row));
	        var valueSize = Math.abs(-value0(row) + value(row));
	        var height = lineSizeAttr === 'height' ? lineSize : valueSize;
	        var width = lineSizeAttr === 'width' ? lineSize : valueSize;
	
	        ctx.beginPath();
	        ctx.rect(x, y, width, height);
	        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
	        ctx.fill();
	        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
	        ctx.stroke();
	      });
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return RectSeriesCanvas;
	}(_abstractSeries2.default);
	
	RectSeriesCanvas.displayName = 'RectSeriesCanvas';
	RectSeriesCanvas.defaultProps = {
	  linePosAttr: _propTypes2.default.string.isRequired,
	  valuePosAttr: _propTypes2.default.string.isRequired,
	  lineSizeAttr: _propTypes2.default.string.isRequired,
	  valueSizeAttr: _propTypes2.default.string.isRequired
	};
	
	RectSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = RectSeriesCanvas;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--rect';
	
	var RectSeries = function (_AbstractSeries) {
	  _inherits(RectSeries, _AbstractSeries);
	
	  function RectSeries() {
	    _classCallCheck(this, RectSeries);
	
	    return _possibleConstructorReturn(this, (RectSeries.__proto__ || Object.getPrototypeOf(RectSeries)).apply(this, arguments));
	  }
	
	  _createClass(RectSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          linePosAttr = _props.linePosAttr,
	          lineSizeAttr = _props.lineSizeAttr,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          valuePosAttr = _props.valuePosAttr,
	          valueSizeAttr = _props.valueSizeAttr;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(RectSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var lineFunctor = this._getAttributeFunctor(linePosAttr);
	      var line0Functor = this._getAttr0Functor(linePosAttr);
	      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
	      var value0Functor = this._getAttr0Functor(valuePosAttr);
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var _attrs;
	
	          var attrs = (_attrs = {
	            style: {
	              opacity: opacityFunctor && opacityFunctor(d),
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d)
	            }
	          }, _defineProperty(_attrs, linePosAttr, line0Functor(d)), _defineProperty(_attrs, lineSizeAttr, Math.abs(lineFunctor(d) - line0Functor(d))), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
	            return _this2._valueClickHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
	            return _this2._valueMouseOverHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
	            return _this2._valueMouseOutHandler(d, e);
	          }), _defineProperty(_attrs, 'key', i), _attrs);
	          return _react2.default.createElement('rect', attrs);
	        })
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return _extends({}, _abstractSeries2.default.propTypes, {
	        linePosAttr: _propTypes2.default.string,
	        valuePosAttr: _propTypes2.default.string,
	        lineSizeAttr: _propTypes2.default.string,
	        valueSizeAttr: _propTypes2.default.string
	      });
	    }
	  }]);
	
	  return RectSeries;
	}(_abstractSeries2.default);
	
	RectSeries.displayName = 'RectSeries';
	
	exports.default = RectSeries;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deepEqual = __webpack_require__(848);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _chartUtils = __webpack_require__(349);
	
	var _animation = __webpack_require__(38);
	
	var _theme = __webpack_require__(45);
	
	var _deckGlWrapper = __webpack_require__(1363);
	
	var _deckGlWrapper2 = _interopRequireDefault(_deckGlWrapper);
	
	var _canvasWrapper = __webpack_require__(1362);
	
	var _canvasWrapper2 = _interopRequireDefault(_canvasWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['x', 'y', 'radius', 'angle', 'color', 'fill', 'stroke', 'opacity', 'size'];
	
	var DEFAULT_MARGINS = {
	  left: 40,
	  right: 10,
	  top: 10,
	  bottom: 40
	};
	
	/**
	 * Remove parents from tree formatted data. deep-equal doesnt play nice with data
	 * that has circular structures, so we make every node single directional by pruning the parents.
	 * @param {Array} data - the data object to have circular deps resolved in
	 * @returns {Array} the sanitized data
	 */
	function cleanseData(data) {
	  return data.map(function (series) {
	    if (!Array.isArray(series)) {
	      return series;
	    }
	    return series.map(function (row) {
	      return _extends({}, row, { parent: null });
	    });
	  });
	}
	
	/**
	 * Wrapper on the deep-equal method for checking equality of next props vs current props
	 * @param {Object} scaleMixins - Scale object.
	 * @param {Object} nextScaleMixins - Scale object.
	 * @returns {Boolean} whether or not the two mixins objects are equal
	 */
	function checkIfMixinsAreEqual(nextScaleMixins, scaleMixins) {
	  var newMixins = _extends({}, nextScaleMixins, {
	    _allData: cleanseData(nextScaleMixins._allData)
	  });
	  var oldMixins = _extends({}, scaleMixins, {
	    _allData: cleanseData(scaleMixins._allData)
	  });
	  // it's hard to say if this function is reasonable?
	  return (0, _deepEqual2.default)(newMixins, oldMixins);
	}
	
	var XYPlot = function (_React$Component) {
	  _inherits(XYPlot, _React$Component);
	
	  _createClass(XYPlot, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        animation: _animation.AnimationPropType,
	        className: _propTypes2.default.string,
	        height: _propTypes2.default.number.isRequired,
	        margin: _chartUtils.MarginPropType,
	        onMouseDown: _propTypes2.default.func,
	        onMouseEnter: _propTypes2.default.func,
	        onMouseLeave: _propTypes2.default.func,
	        onMouseMove: _propTypes2.default.func,
	        stackBy: _propTypes2.default.oneOf(ATTRIBUTES),
	        width: _propTypes2.default.number.isRequired
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        className: ''
	      };
	    }
	  }]);
	
	  function XYPlot(props) {
	    _classCallCheck(this, XYPlot);
	
	    var _this = _possibleConstructorReturn(this, (XYPlot.__proto__ || Object.getPrototypeOf(XYPlot)).call(this, props));
	
	    _this._mouseDownHandler = _this._mouseDownHandler.bind(_this);
	    _this._mouseLeaveHandler = _this._mouseLeaveHandler.bind(_this);
	    _this._mouseEnterHandler = _this._mouseEnterHandler.bind(_this);
	    _this._mouseMoveHandler = _this._mouseMoveHandler.bind(_this);
	    var stackBy = props.stackBy;
	
	    var children = (0, _seriesUtils.getSeriesChildren)(props.children);
	    var data = (0, _seriesUtils.getStackedData)(children, stackBy);
	    _this.state = {
	      scaleMixins: _this._getScaleMixins(data, props),
	      data: data
	    };
	    return _this;
	  }
	
	  _createClass(XYPlot, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var children = (0, _seriesUtils.getSeriesChildren)(nextProps.children);
	      var nextData = (0, _seriesUtils.getStackedData)(children, nextProps.stackBy);
	      var scaleMixins = this.state.scaleMixins;
	
	      var nextScaleMixins = this._getScaleMixins(nextData, nextProps);
	      if (!checkIfMixinsAreEqual(nextScaleMixins, scaleMixins)) {
	        this.setState({
	          scaleMixins: nextScaleMixins,
	          data: nextData
	        });
	      }
	    }
	
	    /**
	     * Trigger mouse-down related callbacks if they are available.
	     * @param {React.SyntheticEvent} event Mouse down event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseDownHandler',
	    value: function _mouseDownHandler(event) {
	      var _this2 = this;
	
	      var _props = this.props,
	          onMouseDown = _props.onMouseDown,
	          children = _props.children;
	
	      if (onMouseDown) {
	        onMouseDown(event);
	      }
	      var seriesChildren = (0, _seriesUtils.getSeriesChildren)(children);
	      seriesChildren.forEach(function (child, index) {
	        var component = _this2.refs['series' + index];
	        if (component && component.onParentMouseDown) {
	          component.onParentMouseDown(event);
	        }
	      });
	    }
	
	    /**
	     * Trigger movement-related callbacks if they are available.
	     * @param {React.SyntheticEvent} event Mouse move event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseMoveHandler',
	    value: function _mouseMoveHandler(event) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          onMouseMove = _props2.onMouseMove,
	          children = _props2.children;
	
	      if (onMouseMove) {
	        onMouseMove(event);
	      }
	      var seriesChildren = (0, _seriesUtils.getSeriesChildren)(children);
	      seriesChildren.forEach(function (child, index) {
	        var component = _this3.refs['series' + index];
	        if (component && component.onParentMouseMove) {
	          component.onParentMouseMove(event);
	        }
	      });
	    }
	
	    /**
	     * Trigger onMouseLeave handler if it was passed in props.
	     * @param {Event} event Native event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseLeaveHandler',
	    value: function _mouseLeaveHandler(event) {
	      var onMouseLeave = this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave({ event: event });
	      }
	    }
	
	    /**
	     * Trigger onMouseEnter handler if it was passed in props.
	     * @param {Event} event Native event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseEnterHandler',
	    value: function _mouseEnterHandler(event) {
	      var onMouseEnter = this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter({ event: event });
	      }
	    }
	
	    /**
	     * Get the list of scale-related settings that should be applied by default.
	     * @param {Object} props Object of props.
	     * @returns {Object} Defaults.
	     * @private
	     */
	
	  }, {
	    key: '_getDefaultScaleProps',
	    value: function _getDefaultScaleProps(props) {
	      var _getInnerDimensions = (0, _chartUtils.getInnerDimensions)(props, DEFAULT_MARGINS),
	          innerWidth = _getInnerDimensions.innerWidth,
	          innerHeight = _getInnerDimensions.innerHeight;
	
	      return {
	        xRange: [0, innerWidth],
	        yRange: [innerHeight, 0],
	        colorRange: _theme.CONTINUOUS_COLOR_RANGE,
	        opacityType: _theme.OPACITY_TYPE,
	        sizeRange: _theme.SIZE_RANGE
	      };
	    }
	
	    /**
	     * Get the map of scales from the props, apply defaults to them and then pass
	     * them further.
	     * @param {Object} data Array of all data.
	     * @param {Object} props Props of the component.
	     * @returns {Object} Map of scale-related props.
	     * @private
	     */
	
	  }, {
	    key: '_getScaleMixins',
	    value: function _getScaleMixins(data, props) {
	      var _ref;
	
	      var filteredData = data.filter(function (d) {
	        return d;
	      });
	      var allData = (_ref = []).concat.apply(_ref, _toConsumableArray(filteredData));
	
	      var defaultScaleProps = this._getDefaultScaleProps(props);
	      var userScaleProps = (0, _scalesUtils.extractScalePropsFromProps)(props, ATTRIBUTES);
	      var missingScaleProps = (0, _scalesUtils.getMissingScaleProps)(_extends({}, defaultScaleProps, userScaleProps), allData, ATTRIBUTES);
	      var children = (0, _seriesUtils.getSeriesChildren)(props.children);
	      var zeroBaseProps = {};
	      var adjustBy = new Set();
	      var adjustWhat = new Set();
	      children.forEach(function (child, index) {
	        if (!child || !data[index]) {
	          return;
	        }
	        ATTRIBUTES.forEach(function (attr) {
	          var _child$type$getParent = child.type.getParentConfig(attr, child.props),
	              isDomainAdjustmentNeeded = _child$type$getParent.isDomainAdjustmentNeeded,
	              zeroBaseValue = _child$type$getParent.zeroBaseValue;
	
	          if (isDomainAdjustmentNeeded) {
	            adjustBy.add(attr);
	            adjustWhat.add(index);
	          }
	          if (zeroBaseValue) {
	            zeroBaseProps[attr + 'BaseValue'] = 0;
	          }
	        });
	      });
	      return _extends({}, defaultScaleProps, zeroBaseProps, userScaleProps, missingScaleProps, {
	        _allData: data,
	        _adjustBy: Array.from(adjustBy),
	        _adjustWhat: Array.from(adjustWhat),
	        _stackBy: props.stackBy
	      });
	    }
	
	    /**
	     * Checks if the plot is empty or not.
	     * Currently checks the data only.
	     * @returns {boolean} True for empty.
	     * @private
	     */
	
	  }, {
	    key: '_isPlotEmpty',
	    value: function _isPlotEmpty() {
	      var data = this.state.data;
	
	      return !data || !data.length || !data.some(function (series) {
	        return series && series.some(function (d) {
	          return d;
	        });
	      });
	    }
	
	    /**
	     * Prepare the child components (including series) for rendering.
	     * @returns {Array} Array of child components.
	     * @private
	     */
	
	  }, {
	    key: '_getClonedChildComponents',
	    value: function _getClonedChildComponents() {
	      var animation = this.props.animation;
	      var _state = this.state,
	          scaleMixins = _state.scaleMixins,
	          data = _state.data;
	
	      var dimensions = (0, _chartUtils.getInnerDimensions)(this.props, DEFAULT_MARGINS);
	      var children = _react2.default.Children.toArray(this.props.children);
	      var seriesProps = (0, _seriesUtils.getSeriesPropsFromChildren)(children);
	      return children.map(function (child, index) {
	        var dataProps = null;
	        if (seriesProps[index]) {
	          // Get the index of the series in the list of props and retrieve
	          // the data property from it.
	          var seriesIndex = seriesProps[index].seriesIndex;
	
	          dataProps = { data: data[seriesIndex] };
	        }
	        return _react2.default.cloneElement(child, _extends({}, dimensions, {
	          animation: animation
	        }, seriesProps[index], scaleMixins, child.props, dataProps));
	      });
	    }
	  }, {
	    key: 'renderDeckGlComponents',
	    value: function renderDeckGlComponents(components, props) {
	      var componentsToRender = components.filter(function (c) {
	        return c && !c.type.requiresSVG && c.type.isDeckGL;
	      });
	      if (componentsToRender.length === 0) {
	        return null;
	      }
	      var animation = componentsToRender.some(function (layer) {
	        return layer.props.animation;
	      });
	      var _componentsToRender$ = componentsToRender[0].props,
	          marginLeft = _componentsToRender$.marginLeft,
	          marginTop = _componentsToRender$.marginTop,
	          marginBottom = _componentsToRender$.marginBottom,
	          marginRight = _componentsToRender$.marginRight,
	          innerHeight = _componentsToRender$.innerHeight,
	          innerWidth = _componentsToRender$.innerWidth;
	
	      return _react2.default.createElement(
	        _deckGlWrapper2.default,
	        {
	          animation: animation,
	          marginLeft: marginLeft,
	          marginTop: marginTop,
	          marginBottom: marginBottom,
	          marginRight: marginRight,
	          innerHeight: innerHeight,
	          innerWidth: innerWidth
	        },
	        componentsToRender
	      );
	    }
	  }, {
	    key: 'renderCanvasComponents',
	    value: function renderCanvasComponents(components, props) {
	      var componentsToRender = components.filter(function (c) {
	        return c && !c.type.requiresSVG && c.type.isCanvas;
	      });
	
	      if (componentsToRender.length === 0) {
	        return null;
	      }
	      var _componentsToRender$2 = componentsToRender[0].props,
	          marginLeft = _componentsToRender$2.marginLeft,
	          marginTop = _componentsToRender$2.marginTop,
	          marginBottom = _componentsToRender$2.marginBottom,
	          marginRight = _componentsToRender$2.marginRight,
	          innerHeight = _componentsToRender$2.innerHeight,
	          innerWidth = _componentsToRender$2.innerWidth;
	
	      return _react2.default.createElement(
	        _canvasWrapper2.default,
	        {
	          marginLeft: marginLeft,
	          marginTop: marginTop,
	          marginBottom: marginBottom,
	          marginRight: marginRight,
	          innerHeight: innerHeight,
	          innerWidth: innerWidth
	        },
	        componentsToRender
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          width = _props3.width,
	          height = _props3.height;
	
	
	      if (this._isPlotEmpty()) {
	        return _react2.default.createElement('div', {
	          className: 'rv-xy-plot ' + className,
	          style: {
	            width: width + 'px',
	            height: height + 'px'
	          } });
	      }
	      var components = this._getClonedChildComponents();
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            width: width + 'px',
	            height: height + 'px'
	          },
	          className: 'rv-xy-plot ' + className },
	        _react2.default.createElement(
	          'svg',
	          {
	            className: 'rv-xy-plot__inner',
	            width: width,
	            height: height,
	            onMouseDown: this._mouseDownHandler,
	            onMouseMove: this._mouseMoveHandler,
	            onMouseLeave: this._mouseLeaveHandler,
	            onMouseEnter: this._mouseEnterHandler },
	          components.filter(function (c) {
	            return c && c.type.requiresSVG && !c.type.isDeckGL;
	          })
	        ),
	        this.renderCanvasComponents(components, this.props),
	        this.renderDeckGlComponents(components, this.props),
	        components.filter(function (c) {
	          return c && !c.type.requiresSVG;
	        })
	      );
	    }
	  }]);
	
	  return XYPlot;
	}(_react2.default.Component);
	
	XYPlot.displayName = 'XYPlot';
	
	exports.default = XYPlot;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MarginPropType = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.getInnerDimensions = getInnerDimensions;
	exports.getRadialLayoutMargin = getRadialLayoutMargin;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the dimensions of the component for the future use.
	 * @param {Object} props Props.
	 * @param {Object} defaultMargins Object with default margins.
	 * @returns {Object} Dimensions of the component.
	 */
	function getInnerDimensions(props, defaultMargins) {
	  var margin = props.margin,
	      width = props.width,
	      height = props.height;
	
	  var marginProps = _extends({}, defaultMargins, typeof margin === 'number' ? {
	    left: margin,
	    right: margin,
	    top: margin,
	    bottom: margin
	  } : margin);
	  var _marginProps$left = marginProps.left,
	      marginLeft = _marginProps$left === undefined ? 0 : _marginProps$left,
	      _marginProps$top = marginProps.top,
	      marginTop = _marginProps$top === undefined ? 0 : _marginProps$top,
	      _marginProps$right = marginProps.right,
	      marginRight = _marginProps$right === undefined ? 0 : _marginProps$right,
	      _marginProps$bottom = marginProps.bottom,
	      marginBottom = _marginProps$bottom === undefined ? 0 : _marginProps$bottom;
	
	  return {
	    marginLeft: marginLeft,
	    marginTop: marginTop,
	    marginRight: marginRight,
	    marginBottom: marginBottom,
	    innerHeight: height - marginBottom - marginTop,
	    innerWidth: width - marginLeft - marginRight
	  };
	}
	
	/**
	 * Calculate the margin of the sunburst,
	 * so it can be at the center of the container
	 * @param  {Number} width - the width of the container
	 * @param  {Number} height - the height of the container
	 * @param  {Number} radius - the max radius of the sunburst
	 * @return {Object} an object includes {bottom, left, right, top}
	 */
	function getRadialLayoutMargin(width, height, radius) {
	  var marginX = width / 2 - radius;
	  var marginY = height / 2 - radius;
	  return {
	    bottom: marginY,
	    left: marginX,
	    right: marginX,
	    top: marginY
	  };
	}
	
	var MarginPropType = exports.MarginPropType = _propTypes2.default.oneOfType([_propTypes2.default.shape({
	  left: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  right: _propTypes2.default.number,
	  bottom: _propTypes2.default.number
	}), _propTypes2.default.number]);

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(137);
	
	var ReactNoopUpdateQueue = __webpack_require__(351);
	
	var canDefineProperty = __webpack_require__(604);
	var emptyObject = __webpack_require__(43);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Area
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(97);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Area = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Area, _Component);
	
	  function Area() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Area.__proto__ || Object.getPrototypeOf(Area)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: true }, _this.id = (0, _DataUtils.uniqueId)('recharts-area-'), _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Area, [{
	    key: 'renderCurve',
	    value: function renderCurve() {
	      var _props = this.props,
	          layout = _props.layout,
	          type = _props.type,
	          stroke = _props.stroke,
	          points = _props.points,
	          baseLine = _props.baseLine,
	          connectNulls = _props.connectNulls,
	          isRange = _props.isRange;
	
	
	      return _react2.default.createElement(
	        'g',
	        null,
	        stroke !== 'none' && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: points
	        })),
	        stroke !== 'none' && isRange && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: baseLine
	        })),
	        _react2.default.createElement(_Curve2.default, _extends({}, this.props, {
	          stroke: 'none',
	          className: 'recharts-area-area'
	        }))
	      );
	    }
	  }, {
	    key: 'renderHorizontalRect',
	    value: function renderHorizontalRect(alpha) {
	      var _props2 = this.props,
	          baseLine = _props2.baseLine,
	          points = _props2.points,
	          strokeWidth = _props2.strokeWidth;
	
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = Math.max.apply(null, points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else {
	        maxY = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      return _react2.default.createElement('rect', {
	        x: startX < endX ? startX : startX - width,
	        y: 0,
	        width: width,
	        height: maxY + (strokeWidth || 1)
	      });
	    }
	  }, {
	    key: 'renderVerticalRect',
	    value: function renderVerticalRect(alpha) {
	      var _props3 = this.props,
	          baseLine = _props3.baseLine,
	          points = _props3.points,
	          strokeWidth = _props3.strokeWidth;
	
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = Math.max.apply(null, points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else {
	        maxX = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      return _react2.default.createElement('rect', {
	        x: 0,
	        y: startY < endY ? startY : startY - height,
	        width: maxX + (strokeWidth || 1),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderClipRect',
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: 'renderClipPath',
	    value: function renderClipPath() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          isAnimationActive = _props4.isAnimationActive,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          animationBegin = _props4.animationBegin,
	          animationId = _props4.animationId;
	
	
	      return _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'animationClipPath-' + this.id },
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration,
	              key: animationId,
	              animationBegin: animationBegin,
	              onAnimationStart: this.handleAnimationStart,
	              onAnimationEnd: this.handleAnimationEnd,
	              from: { alpha: 0 },
	              to: { alpha: 1 }
	            },
	            function (_ref2) {
	              var alpha = _ref2.alpha;
	              return _this2.renderClipRect(alpha);
	            }
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-area-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this3 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          dot = _props5.dot,
	          points = _props5.points;
	
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, areaProps, customDotProps, {
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this3.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            key: props.key
	          }, props, {
	            className: 'recharts-area-label'
	          }),
	          (0, _isArray3.default)(value) ? value[1] : value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this4 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          points = _props6.points,
	          label = _props6.label;
	
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = points.map(function (entry, i) {
	        var labelProps = _extends({
	          textAnchor: 'middle'
	        }, entry, areaProps, customLabelProps, {
	          index: i,
	          key: 'label-' + i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this4.renderLabelItem(label, labelProps, entry.value);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          dot = _props7.dot,
	          label = _props7.label,
	          points = _props7.points,
	          className = _props7.className,
	          top = _props7.top,
	          left = _props7.left,
	          xAxis = _props7.xAxis,
	          yAxis = _props7.yAxis,
	          width = _props7.width,
	          height = _props7.height;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint ? this.renderClipPath() : null,
	        !hasSinglePoint ? _react2.default.createElement(
	          _Layer2.default,
	          { clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null },
	          _react2.default.createElement(
	            _Layer2.default,
	            { clipPath: 'url(#animationClipPath-' + this.id + ')' },
	            this.renderCurve()
	          )
	        ) : null,
	        (dot || hasSinglePoint) && this.renderDots(),
	        label && this.renderLabels()
	      );
	    }
	  }]);
	
	  return Area;
	}(_react.Component), _class2.displayName = 'Area', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  connectNulls: _propTypes2.default.bool,
	
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  // dot configuration
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	
	  // have curve configuration
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isRange: _propTypes2.default.bool,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array])
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  label: false,
	  activeDot: true,
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _temp2)) || _class;
	
	exports.default = Area;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ErrorBar = __webpack_require__(234);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Bar, _Component);
	
	  function Bar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bar.__proto__ || Object.getPrototypeOf(Bar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-bar-'), _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Bar, [{
	    key: 'renderRectangle',
	    value: function renderRectangle(option, props) {
	      var rectangle = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rectangle = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react2.default.createElement(_Rectangle2.default, props);
	      }
	
	      return rectangle;
	    }
	  }, {
	    key: 'renderRectangles',
	    value: function renderRectangles() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          shape = _props.shape,
	          layout = _props.layout,
	          isAnimationActive = _props.isAnimationActive,
	          animationBegin = _props.animationBegin,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing,
	          animationId = _props.animationId;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var getStyle = function getStyle(isBegin) {
	        return {
	          transform: 'scale' + (layout === 'vertical' ? 'X' : 'Y') + '(' + (isBegin ? 0 : 1) + ')'
	        };
	      };
	
	      return data.map(function (entry, index) {
	        var x = entry.x,
	            y = entry.y,
	            width = entry.width,
	            height = entry.height;
	
	        var props = _extends({}, baseProps, entry, { index: index });
	
	        if ((0, _isNil3.default)(entry.value) || !isAnimationActive) {
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({
	              className: 'recharts-bar-rectangle'
	            }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, index), {
	              key: 'rectangle-' + index
	            }),
	            _this2.renderRectangle(shape, props)
	          );
	        }
	
	        var transformOrigin = '';
	
	        if (layout === 'vertical') {
	          transformOrigin = x + 'px ' + (y + height / 2) + 'px';
	        } else {
	          transformOrigin = x + width / 2 + 'px ' + (y + height) + 'px';
	        }
	
	        return _react2.default.createElement(
	          _reactSmooth2.default,
	          {
	            begin: animationBegin,
	            duration: animationDuration,
	            isActive: isAnimationActive,
	            easing: animationEasing,
	            from: getStyle(true),
	            to: getStyle(false),
	            key: 'rectangle-' + index + '-' + animationId,
	            onAnimationEnd: _this2.handleAnimationEnd,
	            onAnimationStart: _this2.handleAnimationStart
	          },
	          _react2.default.createElement(
	            _Layer2.default,
	            _extends({
	              className: 'recharts-bar-rectangle',
	              style: (0, _reactSmooth.translateStyle)({ transformOrigin: transformOrigin })
	            }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, index), {
	              key: 'rectangle-' + index
	            }),
	            _this2.renderRectangle(shape, props)
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = null;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            key: props.key,
	            className: 'recharts-bar-label'
	          }),
	          (0, _isArray3.default)(value) ? value[1] : value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this3 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          data = _props2.data,
	          label = _props2.label,
	          layout = _props2.layout;
	
	      var barProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = data.map(function (entry, i) {
	        var textAnchor = 'middle';
	        var dominantBaseline = 'central';
	        var x = 0;
	        var y = 0;
	
	        if (layout === 'vertical') {
	          textAnchor = entry.width < 0 ? 'end' : 'start';
	          x = entry.x + entry.width + (entry.width < 0 ? -1 : 1) * 5;
	          y = entry.y + entry.height / 2;
	        } else {
	          dominantBaseline = entry.height < 0 ? 'hanging' : 'inherit';
	          x = entry.x + entry.width / 2;
	          y = entry.y - (entry.height < 0 ? -1 : 1) * 5;
	        }
	
	        var labelProps = _extends({
	          dominantBaseline: dominantBaseline,
	          textAnchor: textAnchor
	        }, barProps, entry, customLabelProps, {
	          x: x,
	          y: y,
	          index: i,
	          key: 'label-' + i,
	          payload: entry.payload
	        });
	
	        var labelValue = entry.value;
	        if (label === true && entry.value && labelProps.label) {
	          labelValue = labelProps.label;
	        }
	        return _this3.renderLabelItem(label, labelProps, labelValue);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-bar-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          data = _props3.data,
	          xAxis = _props3.xAxis,
	          yAxis = _props3.yAxis,
	          layout = _props3.layout,
	          children = _props3.children;
	
	      var errorBarItem = (0, _ReactUtils.findChildByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItem) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return _react2.default.cloneElement(errorBarItem, {
	        data: data,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        layout: layout,
	        offset: offset,
	        dataPointFormatter: dataPointFormatter
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          data = _props4.data,
	          className = _props4.className,
	          label = _props4.label,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          left = _props4.left,
	          top = _props4.top,
	          width = _props4.width,
	          height = _props4.height;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        _react2.default.createElement(
	          _Layer2.default,
	          {
	            className: 'recharts-bar-rectangles',
	            clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
	          },
	          this.renderRectangles()
	        ),
	        label && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-bar-rectangle-labels' },
	          this.renderLabels()
	        ),
	        this.renderErrorBar()
	      );
	    }
	  }]);
	
	  return Bar;
	}(_react.Component), _class2.displayName = 'Bar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  layout: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  barSize: _propTypes2.default.number,
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  minPointSize: _propTypes2.default.number,
	  maxBarSize: _propTypes2.default.number,
	
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array])
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _temp2)) || _class;
	
	exports.default = Bar;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cartesian Axis
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _DOMUtils = __webpack_require__(178);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianAxis = (_temp = _class = function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, (CartesianAxis.__proto__ || Object.getPrototypeOf(CartesianAxis)).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ['viewBox']);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _props = this.props,
	          viewBoxOld = _props.viewBox,
	          restPropsOld = _objectWithoutProperties(_props, ['viewBox']);
	
	      return !(0, _PureRender.shallowEqual)(viewBox, viewBoxOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(state, this.state);
	    }
	
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: 'getTickLineCoord',
	    value: function getTickLineCoord(data) {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          width = _props2.width,
	          height = _props2.height,
	          orientation = _props2.orientation,
	          tickSize = _props2.tickSize,
	          mirror = _props2.mirror;
	
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0,
	          tx = void 0,
	          ty = void 0;
	
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = ty = y2 - sign * finalTickSize;
	          tx = tickCoord;
	          break;
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = tx = x2 - sign * finalTickSize;
	          ty = tickCoord;
	          break;
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = tx = x2 + sign * finalTickSize;
	          ty = tickCoord;
	          break;
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = ty = y2 + sign * finalTickSize;
	          tx = tickCoord;
	          break;
	      }
	
	      return { line: { x1: x1, y1: y1, x2: x2, y2: y2 }, tick: { x: tx, y: ty } };
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var _props3 = this.props,
	          orientation = _props3.orientation,
	          mirror = _props3.mirror;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'getTickVerticalAnchor',
	    value: function getTickVerticalAnchor() {
	      var _props4 = this.props,
	          orientation = _props4.orientation,
	          mirror = _props4.mirror;
	
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: 'getLabelProps',
	    value: function getLabelProps() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          orientation = _props5.orientation;
	
	
	      switch (orientation) {
	        case 'left':
	          return { x: x + width, y: y - 6, textAnchor: 'middle' };
	        case 'right':
	          return { x: x, y: y - 6, textAnchor: 'middle' };
	        case 'top':
	          return { x: x + width + 6, y: y + height + 6, textAnchor: 'start' };
	        default:
	          return { x: x + width + 6, y: y + 6, textAnchor: 'start' };
	      }
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          orientation = _props6.orientation,
	          axisLine = _props6.axisLine,
	          mirror = _props6.mirror;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _extends({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _extends({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-cartesian-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-cartesian-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks(ticks) {
	      var _this2 = this;
	
	      var _props7 = this.props,
	          tickLine = _props7.tickLine,
	          stroke = _props7.stroke,
	          tick = _props7.tick,
	          tickFormatter = _props7.tickFormatter;
	
	      var finalTicks = CartesianAxis.getTicks(_extends({}, this.props, { ticks: ticks }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	      var items = finalTicks.map(function (entry, i) {
	        var _getTickLineCoord = _this2.getTickLineCoord(entry),
	            lineCoord = _getTickLineCoord.line,
	            tickCoord = _getTickLineCoord.tick;
	
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, tickCoord, {
	          index: i, payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-cartesian-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-cartesian-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var _props8 = this.props,
	          label = _props8.label,
	          stroke = _props8.stroke,
	          orientation = _props8.orientation,
	          viewBox = _props8.viewBox;
	
	      var presentation = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, _extends({}, presentation, { orientation: orientation, viewBox: viewBox }));
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(this.props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        var props = _extends({}, presentation, {
	          stroke: 'none',
	          fill: stroke
	        }, this.getLabelProps());
	
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-cartesian-axis-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props9 = this.props,
	          axisLine = _props9.axisLine,
	          width = _props9.width,
	          height = _props9.height,
	          ticksGenerator = _props9.ticksGenerator;
	
	      var _props10 = this.props,
	          ticks = _props10.ticks,
	          noTicksProps = _objectWithoutProperties(_props10, ['ticks']);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction3.default)(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-cartesian-axis' },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks(finalTicks),
	        this.renderLabel()
	      );
	    }
	  }], [{
	    key: 'getTicks',
	    value: function getTicks(props) {
	      var ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter;
	
	
	      if (!ticks || !ticks.length) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
	        }, true);
	      } else if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({ ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap });
	    }
	  }, {
	    key: 'getNumberIntervalTicks',
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: 'getTicksStart',
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey];
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _extends({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _extends({}, tail, { isShow: true });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	      for (var i = 0; i < count; i++) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey];
	
	        if (i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: 'getTicksEnd',
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var i = len - 1; i >= 0; i--) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey];
	
	        if (i === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component), _class.displayName = 'CartesianAxis', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  mirror: _propTypes2.default.bool,
	
	  minTickGap: _propTypes2.default.number,
	  ticks: _propTypes2.default.array,
	  tickSize: _propTypes2.default.number,
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  ticksGenerator: _propTypes2.default.func,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: { x: 0, y: 0, width: 0, height: 0 },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  interval: 'preserveEnd'
	}, _temp);
	exports.default = CartesianAxis;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cartesian Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CartesianGrid, _Component);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, (CartesianGrid.__proto__ || Object.getPrototypeOf(CartesianGrid)).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: 'renderLineItem',
	    value: function renderLineItem(option, props) {
	      var lineItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        lineItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ['x1', 'y1', 'x2', 'y2', 'key']);
	
	        lineItem = _react2.default.createElement('line', _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: 'none',
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	
	  }, {
	    key: 'renderHorizontal',
	    value: function renderHorizontal(horizontalPoints) {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          width = _props.width,
	          horizontal = _props.horizontal;
	
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _extends({}, _this2.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this2.renderLineItem(horizontal, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-horizontal' },
	        items
	      );
	    }
	
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: 'renderVertical',
	    value: function renderVertical(verticalPoints) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          y = _props2.y,
	          height = _props2.height,
	          vertical = _props2.vertical;
	
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _extends({}, _this3.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this3.renderLineItem(vertical, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-vertical' },
	        items
	      );
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _props3 = this.props,
	          fillOpacity = _props3.fillOpacity,
	          x = _props3.x,
	          y = _props3.y,
	          width = _props3.width,
	          height = _props3.height;
	
	
	      return _react2.default.createElement('rect', {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: 'none',
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: 'recharts-cartesian-grid-bg'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          x = _props4.x,
	          y = _props4.y,
	          width = _props4.width,
	          height = _props4.height,
	          horizontal = _props4.horizontal,
	          vertical = _props4.vertical,
	          horizontalCoordinatesGenerator = _props4.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _props4.verticalCoordinatesGenerator,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          offset = _props4.offset,
	          chartWidth = _props4.chartWidth,
	          chartHeight = _props4.chartHeight;
	
	
	      if (width <= 0 || height <= 0 || x !== +x || y !== +y) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          horizontalPoints = _props5.horizontalPoints,
	          verticalPoints = _props5.verticalPoints;
	
	
	      if ((0, _isFunction3.default)(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({ yAxis: yAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      if ((0, _isFunction3.default)(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({ xAxis: xAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid' },
	        this.renderBackground(),
	        horizontal && this.renderHorizontal(horizontalPoints),
	        vertical && this.renderVertical(verticalPoints)
	      );
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.Component), _class2.displayName = 'CartesianGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  horizontal: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  vertical: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  horizontalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  verticalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  horizontalCoordinatesGenerator: _propTypes2.default.func,
	  verticalCoordinatesGenerator: _propTypes2.default.func,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	
	  stroke: '#ccc',
	  fill: 'none'
	}, _temp)) || _class;
	
	exports.default = CartesianGrid;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Line
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(97);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ErrorBar = __webpack_require__(234);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FACTOR = 1.0000001;
	
	var Line = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-line-'), _this.pathRef = function (node) {
	      _this.animate = node;
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Line, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (!isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	
	      this.setState({ totalLength: totalLength });
	    }
	
	    /* eslint-disable  react/no-did-update-set-state */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var animationId = this.props.animationId;
	
	
	      if (animationId !== prevProps.animationId) {
	        var cur = this.getTotalLength();
	        var totalLength = prevState.totalLength;
	        // A hack method to trigger animation
	
	        this.setState({
	          totalLength: cur === totalLength ? cur * FACTOR : cur
	        });
	      }
	    }
	  }, {
	    key: 'getTotalLength',
	    value: function getTotalLength() {
	      var curveDom = this.animate;
	      var totalLength = curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	
	      return totalLength;
	    }
	  }, {
	    key: 'getStrokeDasharray',
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	
	      var remainLines = [];
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	
	      return [].concat(_toConsumableArray(this.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return line + 'px';
	      }).join(', ');
	    }
	  }, {
	    key: 'repeat',
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            key: props.key
	          }, props, {
	            className: 'recharts-line-label'
	          }),
	          value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props = this.props,
	          points = _props.points,
	          label = _props.label;
	
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = points.map(function (entry, i) {
	        var labelProps = _extends({
	          textAnchor: 'middle'
	        }, entry, lineProps, customLabelProps, {
	          index: i,
	          key: 'label-' + i
	        });
	
	        return _this2.renderLabelItem(label, labelProps, entry.value);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          points = _props2.points,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          layout = _props2.layout,
	          children = _props2.children;
	
	      var errorBarItem = (0, _ReactUtils.findChildByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItem) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return _react2.default.cloneElement(errorBarItem, {
	        data: points,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        layout: layout,
	        dataPointFormatter: dataPointFormatter
	      });
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames2.default)('recharts-line-dot', option.className);
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: className }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this3 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props3 = this.props,
	          dot = _props3.dot,
	          points = _props3.points;
	
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, lineProps, customDotProps, {
	          value: entry.value,
	          cx: entry.x, cy: entry.y, index: i, payload: entry.payload
	        });
	
	        return _this3.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-dots', key: 'dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderCurve',
	    value: function renderCurve(needClip) {
	      var _this4 = this;
	
	      var _props4 = this.props,
	          points = _props4.points,
	          strokeDasharray = _props4.strokeDasharray,
	          isAnimationActive = _props4.isAnimationActive,
	          animationBegin = _props4.animationBegin,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          onClick = _props4.onClick,
	          onMouseEnter = _props4.onMouseEnter,
	          onMouseLeave = _props4.onMouseLeave,
	          other = _objectWithoutProperties(_props4, ['points', 'strokeDasharray', 'isAnimationActive', 'animationBegin', 'animationDuration', 'animationEasing', 'onClick', 'onMouseEnter', 'onMouseLeave']);
	
	      var totalLength = this.state.totalLength;
	
	      var animationProps = {
	        isActive: isAnimationActive,
	        begin: animationBegin,
	        canBegin: totalLength > 0,
	        easing: animationEasing,
	        duration: animationDuration,
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart,
	        shouldReAnimate: true,
	        pathRef: this.pathRef
	      };
	      var curveProps = _extends({}, other, {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null,
	        onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, points: points
	      });
	
	      if (!isAnimationActive) {
	        return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, { strokeDasharray: strokeDasharray }));
	      }
	
	      if (strokeDasharray && totalLength) {
	        var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	          return parseFloat(num);
	        });
	
	        return _react2.default.createElement(
	          _reactSmooth2.default,
	          _extends({}, animationProps, {
	            from: { curveLen: 0 },
	            to: { curveLen: totalLength }
	          }),
	          function (_ref2) {
	            var curveLen = _ref2.curveLen;
	            return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, {
	              strokeDasharray: _this4.getStrokeDasharray(curveLen, totalLength, lines)
	            }));
	          }
	        );
	      } else if (strokeDasharray) {
	        return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, {
	          pathRef: this.pathRef,
	          strokeDasharray: strokeDasharray
	        }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        _extends({}, animationProps, {
	          from: '0px ' + (totalLength === 0 ? 1 : totalLength) + 'px',
	          to: totalLength + 'px 0px',
	          attributeName: 'strokeDasharray'
	        }),
	        _react2.default.createElement(_Curve2.default, curveProps)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          dot = _props5.dot,
	          points = _props5.points,
	          label = _props5.label,
	          className = _props5.className,
	          xAxis = _props5.xAxis,
	          yAxis = _props5.yAxis,
	          top = _props5.top,
	          left = _props5.left,
	          width = _props5.width,
	          height = _props5.height;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint && this.renderCurve(needClip),
	        this.renderErrorBar(),
	        (hasSinglePoint || dot) && this.renderDots(),
	        label && this.renderLabels()
	      );
	    }
	  }]);
	
	  return Line;
	}(_react.Component), _class2.displayName = 'Line', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes2.default.bool,
	
	  // whether have dot in line
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes2.default.number
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _temp2)) || _class;
	
	exports.default = Line;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview X Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var XAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(XAxis, _Component);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, (XAxis.__proto__ || Object.getPrototypeOf(XAxis)).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.Component), _class2.displayName = 'XAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes2.default.number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['top', 'bottom']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  padding: _propTypes2.default.shape({
	    left: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: { left: 0, right: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	}, _temp)) || _class;
	
	exports.default = XAxis;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Y Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(YAxis, _Component);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, (YAxis.__proto__ || Object.getPrototypeOf(YAxis)).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.Component), _class2.displayName = 'YAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes2.default.number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['left', 'right']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    bottom: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: { top: 0, bottom: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	}, _temp)) || _class;
	
	exports.default = YAxis;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polygon
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Polygon, _Component);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          points = _props.points,
	          className = _props.className;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-polygon', className);
	
	      return _react2.default.createElement('polygon', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.Component), _class2.displayName = 'Polygon', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }))
	}), _temp)) || _class;
	
	exports.default = Polygon;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Sector
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _PolarUtils = __webpack_require__(89);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius;
	
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	  var centerAngle = angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
	  // The coordinate of point which is tangent to the circle
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
	  // The coordinate of point which is tangent to the radius line
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), angle);
	
	  return { center: center, circleTangency: circleTangency, lineTangency: lineTangency, theta: theta };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	
	  var angle = getDeltaAngle(startAngle, endAngle);
	
	  // When the angle of sector equals to 360, star point and end point coincide
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	
	  var path = 'M ' + outerStartPoint.x + ',' + outerStartPoint.y + '\n    A ' + outerRadius + ',' + outerRadius + ',0,\n    ' + +(Math.abs(angle) > 180) + ',' + +(startAngle > tempEndAngle) + ',\n    ' + outerEndPoint.x + ',' + outerEndPoint.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += 'L ' + innerEndPoint.x + ',' + innerEndPoint.y + '\n            A ' + innerRadius + ',' + innerRadius + ',0,\n            ' + +(Math.abs(angle) > 180) + ',' + +(startAngle <= tempEndAngle) + ',\n            ' + innerStartPoint.x + ',' + innerStartPoint.y + ' Z';
	  } else {
	    path += 'L ' + cx + ',' + cy + ' Z';
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: startAngle, sign: sign, cornerRadius: cornerRadius
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: endAngle, sign: -sign, cornerRadius: cornerRadius
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    return getSectorPath({
	      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    });
	  }
	
	  var path = 'M ' + solt.x + ',' + solt.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + soct.x + ',' + soct.y + '\n    A' + outerRadius + ',' + outerRadius + ',0,' + +(outerArcAngle > 180) + ',' + +(sign < 0) + ',' + eoct.x + ',' + eoct.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eolt.x + ',' + eolt.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: startAngle, sign: sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: endAngle, sign: -sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return path + 'L' + cx + ',' + cy + 'Z';
	    }
	
	    path += 'L' + eilt.x + ',' + eilt.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eict.x + ',' + eict.y + '\n      A' + innerRadius + ',' + innerRadius + ',0,' + +(innerArcAngle > 180) + ',' + +(sign > 0) + ',' + sict.x + ',' + sict.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + silt.x + ',' + silt.y + 'Z';
	  } else {
	    path += 'L' + cx + ',' + cy + 'Z';
	  }
	
	  return path;
	};
	
	var Sector = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sector, _Component);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, (Sector.__proto__ || Object.getPrototypeOf(Sector)).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          innerRadius = _props.innerRadius,
	          outerRadius = _props.outerRadius,
	          cornerRadius = _props.cornerRadius,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle,
	          className = _props.className;
	
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path = void 0;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          startAngle: startAngle, endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({ cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle });
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.Component), _class2.displayName = 'Sector', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0
	}, _temp)) || _class;
	
	exports.default = Sector;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(363);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle, symbolCross: _d3Shape.symbolCross, symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare, symbolStar: _d3Shape.symbolStar, symbolTriangle: _d3Shape.symbolTriangle, symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = 'symbol' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	    case 'square':
	      return size * size;
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Symbols, _Component);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, (Symbols.__proto__ || Object.getPrototypeOf(Symbols)).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: 'getPath',
	
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          size = _props.size,
	          sizeType = _props.sizeType,
	          type = _props.type;
	
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	
	      return symbol();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          size = _props2.size;
	
	
	      if (cx === +cx && cy === +cy && size === +size) {
	
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames2.default)('recharts-symbols', className),
	          transform: 'translate(' + cx + ', ' + cy + ')',
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.Component), _class2.displayName = 'Symbols', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  size: _propTypes2.default.number,
	  sizeType: _propTypes2.default.oneOf(['area', 'diameter'])
	}), _class2.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	}, _temp)) || _class;
	
	exports.default = Symbols;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ },
/* 363 */
233,
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(1417);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _merge2=__webpack_require__(158);var _merge3=_interopRequireDefault(_merge2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _index=__webpack_require__(53);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	
	var defaultStyles={
	fill:"#252525",
	fontSize:14,
	fontFamily:"'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
	stroke:"transparent"};var
	
	
	VictoryLabel=function(_React$Component){_inherits(VictoryLabel,_React$Component);function VictoryLabel(){_classCallCheck(this,VictoryLabel);return _possibleConstructorReturn(this,(VictoryLabel.__proto__||Object.getPrototypeOf(VictoryLabel)).apply(this,arguments));}_createClass(VictoryLabel,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{
	this.cacheAttributes(this.calculateAttributes(this.props));
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){
	var attrs=this.calculateAttributes(nextProps);var
	style=attrs.style,dx=attrs.dx,dy=attrs.dy,content=attrs.content,lineHeight=attrs.lineHeight,textAnchor=attrs.textAnchor,transform=attrs.transform;var _props=
	this.props,x=_props.x,y=_props.y;
	if(
	x!==nextProps.x||
	y!==nextProps.y||
	dx!==this.dx||
	dy!==this.dy||
	lineHeight!==this.lineHeight||
	transform!==this.transform||
	textAnchor!==this.textAnchor||
	!(0,_isEqual3.default)(content,this.content)||
	!(0,_isEqual3.default)(style,this.style))
	{
	this.cacheAttributes(attrs);
	return true;
	}
	return false;
	}},{key:"cacheAttributes",value:function cacheAttributes(
	
	attrs){var
	style=attrs.style,dx=attrs.dx,dy=attrs.dy,content=attrs.content,textAnchor=attrs.textAnchor,transform=attrs.transform,lineHeight=attrs.lineHeight;
	this.style=style;
	this.dx=dx;
	this.dy=dy;
	this.content=content;
	this.textAnchor=textAnchor;
	this.lineHeight=lineHeight;
	this.transform=transform;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){
	var style=this.getStyles(props);
	var fontSize=style[0].fontSize;
	var lineHeight=this.getHeight(props,"lineHeight");
	var textAnchor=props.textAnchor?
	_index.Helpers.evaluateProp(props.textAnchor,props.datum):"start";
	var content=this.getContent(props);
	var dx=props.dx?_index.Helpers.evaluateProp(this.props.dx,props.datum):0;
	var dy=this.getDy(props,style,content,lineHeight)*fontSize;
	var transform=this.getTransform(props,style);
	return{
	style:style,dx:dx,dy:dy,content:content,lineHeight:lineHeight,textAnchor:textAnchor,transform:transform};
	
	}},{key:"getStyle",value:function getStyle(
	
	props,style){
	style=style?(0,_merge3.default)({},defaultStyles,style):defaultStyles;
	var datum=props.datum||props.data;
	var baseStyles=_index.Helpers.evaluateStyle(style,datum,props.active);
	return(0,_assign3.default)({},baseStyles,{fontSize:this.getFontSize(baseStyles)});
	}},{key:"getStyles",value:function getStyles(
	
	props){var _this2=this;
	return Array.isArray(props.style)?
	props.style.map(function(style){return _this2.getStyle(props,style);}):[this.getStyle(props,props.style)];
	}},{key:"getHeight",value:function getHeight(
	
	props,type){
	var datum=props.datum||props.data;
	return _index.Helpers.evaluateProp(props[type],datum,props.active);
	}},{key:"getContent",value:function getContent(
	
	props){
	if(props.text===undefined||props.text===null){
	return[" "];
	}
	var datum=props.datum||props.data;
	if(Array.isArray(props.text)){
	return props.text.map(function(line){return _index.Helpers.evaluateProp(line,datum,props.active);});
	}
	var child=_index.Helpers.evaluateProp(props.text,datum,props.active);
	return(""+child).split("\n");
	}},{key:"getDy",value:function getDy(
	
	props,style,content,lineHeight){
	var datum=props.datum||props.data;
	var dy=props.dy?_index.Helpers.evaluateProp(props.dy,datum):0;
	var length=content.length;
	var capHeight=this.getHeight(props,"capHeight");
	var verticalAnchor=style.verticalAnchor||props.verticalAnchor;
	var anchor=verticalAnchor?
	_index.Helpers.evaluateProp(verticalAnchor,datum):"middle";
	switch(anchor){
	case"end":
	return dy+capHeight/2+(0.5-length)*lineHeight;
	case"middle":
	return dy+capHeight/2+(0.5-length/2)*lineHeight;
	default:
	return dy+capHeight/2+lineHeight/2;}
	
	}},{key:"getTransform",value:function getTransform(
	
	props,style){var
	datum=props.datum,x=props.x,y=props.y;
	var angle=style.angle||props.angle;
	var transform=props.transform||style.transform;
	var transformPart=transform&&_index.Helpers.evaluateProp(transform,datum);
	var rotatePart=angle&&{rotate:[angle,x,y]};
	return transformPart||angle?
	_index.Style.toTransformString(transformPart,rotatePart):undefined;
	}},{key:"getFontSize",value:function getFontSize(
	
	style){
	var baseSize=style&&style.fontSize;
	if(typeof baseSize==="number"){
	return baseSize;
	}else if(baseSize===undefined||baseSize===null){
	return defaultStyles.fontSize;
	}else if(typeof baseSize==="string"){
	var fontSize=+baseSize.replace("px","");
	if(!isNaN(fontSize)){
	return fontSize;
	}else{
	_index.Log.warn("fontSize should be expressed as a number of pixels");
	return defaultStyles.fontSize;
	}
	}
	return defaultStyles.fontSize;
	}},{key:"renderElements",value:function renderElements(
	
	
	props){var _this3=this;
	var textProps={
	dx:this.dx,dy:this.dy,x:props.x,y:props.y,
	transform:this.transform,className:props.className};
	
	return(
	_react2.default.createElement("text",_extends({},textProps,
	props.events),
	
	this.content.map(function(line,i){
	var style=_this3.style[i]||_this3.style[0];
	var lastStyle=_this3.style[i-1]||_this3.style[0];
	var fontSize=(style.fontSize+lastStyle.fontSize)/2;
	var textAnchor=style.textAnchor||_this3.textAnchor;
	var dy=i?_this3.lineHeight*fontSize:undefined;
	return(
	_react2.default.createElement("tspan",{key:i,x:props.x,dy:dy,dx:_this3.dx,style:style,textAnchor:textAnchor},
	line));
	
	
	})));
	
	
	}},{key:"render",value:function render()
	
	{
	return this.renderElements(this.props);
	}}]);return VictoryLabel;}(_react2.default.Component);VictoryLabel.displayName="VictoryLabel";VictoryLabel.role="label";VictoryLabel.propTypes={active:_propTypes2.default.bool,angle:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number]),capHeight:_propTypes2.default.oneOfType([_propTypes2.default.string,_index.PropTypes.nonNegative,_propTypes2.default.func]),className:_propTypes2.default.string,data:_propTypes2.default.array,datum:_propTypes2.default.any,dx:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string,_propTypes2.default.func]),dy:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string,_propTypes2.default.func]),events:_propTypes2.default.object,index:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string]),lineHeight:_propTypes2.default.oneOfType([_propTypes2.default.string,_index.PropTypes.nonNegative,_propTypes2.default.func]),style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.array]),text:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number,_propTypes2.default.func,_propTypes2.default.array]),textAnchor:_propTypes2.default.oneOfType([_propTypes2.default.oneOf(["start","middle","end","inherit"]),_propTypes2.default.func]),transform:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.object,_propTypes2.default.func]),verticalAnchor:_propTypes2.default.oneOfType([_propTypes2.default.oneOf(["start","middle","end"]),_propTypes2.default.func]),x:_propTypes2.default.number,y:_propTypes2.default.number};VictoryLabel.defaultProps={capHeight:0.71,lineHeight:1};exports.default=VictoryLabel;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.Flyout=exports.Voronoi=exports.Slice=exports.Point=exports.Line=exports.ErrorBar=exports.Curve=exports.ClipPath=exports.Candle=exports.Bar=exports.Area=undefined;var _area=__webpack_require__(1451);var _area2=_interopRequireDefault(_area);
	var _bar=__webpack_require__(1452);var _bar2=_interopRequireDefault(_bar);
	var _candle=__webpack_require__(1453);var _candle2=_interopRequireDefault(_candle);
	var _clipPath=__webpack_require__(1454);var _clipPath2=_interopRequireDefault(_clipPath);
	var _curve=__webpack_require__(1455);var _curve2=_interopRequireDefault(_curve);
	var _errorBar=__webpack_require__(1456);var _errorBar2=_interopRequireDefault(_errorBar);
	var _line=__webpack_require__(1458);var _line2=_interopRequireDefault(_line);
	var _point=__webpack_require__(638);var _point2=_interopRequireDefault(_point);
	var _slice=__webpack_require__(1460);var _slice2=_interopRequireDefault(_slice);
	var _voronoi=__webpack_require__(1461);var _voronoi2=_interopRequireDefault(_voronoi);
	var _flyout=__webpack_require__(1457);var _flyout2=_interopRequireDefault(_flyout);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.
	
	
	
	Area=_area2.default;exports.Bar=_bar2.default;exports.Candle=_candle2.default;exports.ClipPath=_clipPath2.default;exports.Curve=_curve2.default;exports.ErrorBar=_errorBar2.default;exports.Line=_line2.default;exports.Point=_point2.default;exports.Slice=_slice2.default;exports.Voronoi=_voronoi2.default;exports.Flyout=_flyout2.default;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _material=__webpack_require__(1464);var _material2=_interopRequireDefault(_material);
	var _grayscale=__webpack_require__(1463);var _grayscale2=_interopRequireDefault(_grayscale);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=
	
	{
	material:_material2.default,
	grayscale:_grayscale2.default};

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _sortBy2=__webpack_require__(78);var _sortBy3=_interopRequireDefault(_sortBy2);var _property2=__webpack_require__(289);var _property3=_interopRequireDefault(_property2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _last2=__webpack_require__(287);var _last3=_interopRequireDefault(_last2);var _range2=__webpack_require__(51);var _range3=_interopRequireDefault(_range2);var _uniq2=__webpack_require__(211);var _uniq3=_interopRequireDefault(_uniq2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	var _collection=__webpack_require__(139);var _collection2=_interopRequireDefault(_collection);
	var _log=__webpack_require__(369);var _log2=_interopRequireDefault(_log);
	var _scale=__webpack_require__(370);var _scale2=_interopRequireDefault(_scale);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	
	
	
	
	
	getData:function getData(props){
	var data=void 0;
	if(props.data){
	if(props.data.length<1){
	_log2.default.warn("This is an empty dataset.");
	return[];
	}else{
	data=this.formatData(props.data,props);
	}
	}else{
	data=this.formatData(this.generateData(props),props);
	}
	return this.addEventKeys(props,data);
	},
	
	
	
	
	
	
	
	generateDataArray:function generateDataArray(props,axis){
	var propsDomain=props.domain&&Array.isArray(props.domain)?
	props.domain:props.domain&&props.domain[axis];
	var domain=propsDomain||_scale2.default.getBaseScale(props,axis).domain();
	var samples=props.samples||1;
	var domainMax=Math.max.apply(Math,_toConsumableArray(domain));
	var domainMin=Math.min.apply(Math,_toConsumableArray(domain));
	var step=(domainMax-domainMin)/samples;
	var values=(0,_range3.default)(domainMin,domainMax,step);
	return(0,_last3.default)(values)===domainMax?values:values.concat(domainMax);
	},
	
	
	
	
	
	
	generateData:function generateData(props){
	var xValues=this.generateDataArray(props,"x");
	var yValues=this.generateDataArray(props,"y");
	var values=xValues.map(function(x,i){
	return{x:x,y:yValues[i]};
	});
	return values;
	},
	
	
	
	
	
	
	
	
	formatData:function formatData(dataset,props,stringMap){
	if(!Array.isArray(dataset)){
	return[];
	}
	stringMap=stringMap||{
	x:this.createStringMap(props,"x"),
	y:this.createStringMap(props,"y")};
	
	var accessor={
	x:_helpers2.default.createAccessor(props.x!==undefined?props.x:"x"),
	y:_helpers2.default.createAccessor(props.y!==undefined?props.y:"y")};
	
	var data=dataset.map(function(datum,index){
	var evaluatedX=datum._x!==undefined?datum._x:accessor.x(datum);
	var evaluatedY=datum._y!==undefined?datum._y:accessor.y(datum);
	var x=evaluatedX!==undefined?evaluatedX:index;
	var y=evaluatedY!==undefined?evaluatedY:datum;
	return(0,_assign3.default)(
	{x:x,y:y},
	datum,
	{_x:x,_y:y},
	
	typeof x==="string"?{_x:stringMap.x[x],xName:x}:{},
	typeof y==="string"?{_y:stringMap.y[y],yName:y}:{});
	
	});
	
	var sortedData=this.sortData(data,props.sortKey);
	
	return this.cleanData(sortedData,props);
	},
	
	
	
	
	
	
	
	
	sortData:function sortData(dataset,sortKey){
	if(!sortKey){
	return dataset;
	}
	
	
	if(sortKey==="x"||sortKey==="y"){
	sortKey="_"+sortKey;
	}
	
	return(0,_sortBy3.default)(dataset,sortKey);
	},
	
	
	
	
	
	
	
	
	
	cleanData:function cleanData(dataset,props){
	var scaleType={
	x:_scale2.default.getScaleType(props,"x"),
	y:_scale2.default.getScaleType(props,"y")};
	
	if(scaleType.x!=="log"&&scaleType.y!=="log"){
	return dataset;
	}
	var rules=function rules(datum,axis){
	return scaleType[axis]==="log"?datum["_"+axis]!==0:true;
	};
	return dataset.filter(function(datum){
	return rules(datum,"x")&&rules(datum,"y");
	});
	},
	
	
	getEventKey:function getEventKey(key){
	
	
	if((0,_isFunction3.default)(key)){
	return key;
	}else if(key===null||typeof key==="undefined"){
	return function(){return undefined;};
	}
	
	return(0,_property3.default)(key);
	},
	
	
	addEventKeys:function addEventKeys(props,data){
	var eventKeyAccessor=this.getEventKey(props.eventKey);
	return data.map(function(datum,index){
	var eventKey=datum.eventKey||eventKeyAccessor(datum)||index;
	return(0,_assign3.default)({eventKey:eventKey},datum);
	});
	},
	
	
	
	
	
	
	
	createStringMap:function createStringMap(props,axis){
	var stringsFromAxes=this.getStringsFromAxes(props,axis);
	var stringsFromCategories=this.getStringsFromCategories(props,axis);
	var stringsFromData=this.getStringsFromData(props,axis);
	
	var allStrings=(0,_uniq3.default)([].concat(_toConsumableArray(stringsFromAxes),_toConsumableArray(stringsFromCategories),_toConsumableArray(stringsFromData)));
	return allStrings.length===0?null:
	allStrings.reduce(function(memo,string,index){
	memo[string]=index+1;
	return memo;
	},{});
	},
	
	
	
	
	
	
	
	getStringsFromData:function getStringsFromData(props,axis){
	if(!Array.isArray(props.data)){
	return[];
	}
	var key=typeof props[axis]==="undefined"?axis:props[axis];
	var accessor=_helpers2.default.createAccessor(key);
	var dataStrings=props.data.
	map(function(datum){return accessor(datum);}).
	filter(function(datum){return typeof datum==="string";});
	
	return dataStrings.reduce(function(prev,curr){
	if(typeof curr!=="undefined"&&curr!==null&&prev.indexOf(curr)===-1){
	prev.push(curr);
	}
	return prev;
	},[]);
	},
	
	
	
	
	
	
	
	getStringsFromAxes:function getStringsFromAxes(props,axis){
	if(!props.tickValues||!Array.isArray(props.tickValues)&&!props.tickValues[axis]){
	return[];
	}
	var tickValueArray=props.tickValues[axis]||props.tickValues;
	return tickValueArray.filter(function(val){return typeof val==="string";});
	},
	
	
	
	
	
	
	
	getStringsFromCategories:function getStringsFromCategories(props,axis){
	if(!props.categories){
	return[];
	}
	var categories=this.getCategories(props,axis);
	var categoryStrings=categories&&categories.filter(function(val){return typeof val==="string";});
	return categoryStrings?_collection2.default.removeUndefined(categoryStrings):[];
	},
	
	
	
	
	
	
	
	getCategories:function getCategories(props,axis){
	return props.categories&&!Array.isArray(props.categories)?
	props.categories[axis]:props.categories;
	}};

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.default=
	
	
	
	{
	warn:function warn(message){
	if(false){
	if(console&&console.warn){
	console.warn(message);
	}
	}
	}};

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _includes2=__webpack_require__(206);var _includes3=_interopRequireDefault(_includes2);
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	var _collection=__webpack_require__(139);var _collection2=_interopRequireDefault(_collection);
	var _d3Scale=__webpack_require__(101);var d3Scale=_interopRequireWildcard(_d3Scale);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}
	
	var supportedScaleStrings=["linear","time","log","sqrt"];exports.default=
	
	{
	
	getDefaultScale:function getDefaultScale(){
	return d3Scale.scaleLinear();
	},
	
	toNewName:function toNewName(scale){
	
	var capitalize=function capitalize(s){return s&&s[0].toUpperCase()+s.slice(1);};
	return"scale"+capitalize(scale);
	},
	
	validScale:function validScale(scale){
	if(typeof scale==="function"){
	return(0,_isFunction3.default)(scale.copy)&&(0,_isFunction3.default)(scale.domain)&&(0,_isFunction3.default)(scale.range);
	}else if(typeof scale==="string"){
	return(0,_includes3.default)(supportedScaleStrings,scale);
	}
	return false;
	},
	
	isScaleDefined:function isScaleDefined(props,axis){
	if(!props.scale){
	return false;
	}else if(props.scale.x||props.scale.y){
	return props.scale[axis]?true:false;
	}
	return true;
	},
	
	getScaleTypeFromProps:function getScaleTypeFromProps(props,axis){
	if(!this.isScaleDefined(props,axis)){
	return undefined;
	}
	var scale=props.scale[axis]||props.scale;
	return typeof scale==="string"?scale:this.getType(scale);
	},
	
	getScaleFromProps:function getScaleFromProps(props,axis){
	if(!this.isScaleDefined(props,axis)){
	return undefined;
	}
	var scale=props.scale[axis]||props.scale;
	
	if(this.validScale(scale)){
	return(0,_isFunction3.default)(scale)?scale:d3Scale[this.toNewName(scale)]();
	}
	return undefined;
	},
	
	getScaleTypeFromData:function getScaleTypeFromData(props,axis){
	if(!props.data){
	return"linear";
	}
	var accessor=_helpers2.default.createAccessor(props[axis]);
	var axisData=props.data.map(accessor);
	return _collection2.default.containsDates(axisData)?"time":"linear";
	},
	
	getBaseScale:function getBaseScale(props,axis){
	var scale=this.getScaleFromProps(props,axis);
	if(scale){
	return scale;
	}
	var dataScale=this.getScaleTypeFromData(props,axis);
	return d3Scale[this.toNewName(dataScale)]();
	},
	
	getType:function getType(scale){
	var duckTypes=[
	{name:"log",method:"base"},
	{name:"ordinal",method:"unknown"},
	{name:"pow-sqrt",method:"exponent"},
	{name:"quantile",method:"quantiles"},
	{name:"quantize-threshold",method:"invertExtent"}];
	
	var scaleType=duckTypes.filter(function(type){
	return scale[type.method]!==undefined;
	})[0];
	return scaleType?scaleType.name:undefined;
	},
	
	getScaleType:function getScaleType(props,axis){
	
	return this.getScaleTypeFromProps(props,axis)||this.getScaleTypeFromData(props,axis);
	}};

/***/ },
/* 371 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Shape = __webpack_require__(13);
	
	Object.defineProperty(exports, 'curveBasis', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveBasis;
	  }
	});
	Object.defineProperty(exports, 'curveBasisClosed', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveBasisClosed;
	  }
	});
	Object.defineProperty(exports, 'curveBasisOpen', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveBasisOpen;
	  }
	});
	Object.defineProperty(exports, 'curveStep', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveStep;
	  }
	});
	Object.defineProperty(exports, 'curveStepAfter', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveStepAfter;
	  }
	});
	Object.defineProperty(exports, 'curveStepBefore', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveStepBefore;
	  }
	});
	Object.defineProperty(exports, 'curveBundle', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveBundle;
	  }
	});
	Object.defineProperty(exports, 'curveLinear', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveLinear;
	  }
	});
	Object.defineProperty(exports, 'curveLinearClosed', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveLinearClosed;
	  }
	});
	Object.defineProperty(exports, 'curveCardinal', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCardinal;
	  }
	});
	Object.defineProperty(exports, 'curveCardinalClosed', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCardinalClosed;
	  }
	});
	Object.defineProperty(exports, 'curveCardinalOpen', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCardinalOpen;
	  }
	});
	Object.defineProperty(exports, 'curveCatmullRom', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCatmullRom;
	  }
	});
	Object.defineProperty(exports, 'curveCatmullRomClosed', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCatmullRomClosed;
	  }
	});
	Object.defineProperty(exports, 'curveCatmullRomOpen', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCatmullRomOpen;
	  }
	});
	Object.defineProperty(exports, 'curveMonotoneX', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveMonotoneX;
	  }
	});
	Object.defineProperty(exports, 'curveMonotoneY', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveMonotoneY;
	  }
	});
	Object.defineProperty(exports, 'curveNatural', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveNatural;
	  }
	});

/***/ },
/* 373 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = genBin;
	var defaultCount = function defaultCount(i, n) {
	  return Math.random() * (25 * (n - i));
	};
	
	var defaultBin = function defaultBin(i, n) {
	  return i * 150;
	};
	
	function genBin(n) {
	  var bin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultBin;
	  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultCount;
	
	  return Array(n).fill(1).reduce(function (data, d, i) {
	    return data.concat([{
	      bin: bin(i, n),
	      count: count(i, n)
	    }]);
	  }, []);
	}

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Point = __webpack_require__(668);
	
	Object.defineProperty(exports, 'Point', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Point).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Arc = __webpack_require__(685);
	
	Object.defineProperty(exports, 'Arc', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Arc).default;
	  }
	});
	
	var _Pie = __webpack_require__(695);
	
	Object.defineProperty(exports, 'Pie', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pie).default;
	  }
	});
	
	var _Line = __webpack_require__(692);
	
	Object.defineProperty(exports, 'Line', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Line).default;
	  }
	});
	
	var _LinePath = __webpack_require__(693);
	
	Object.defineProperty(exports, 'LinePath', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinePath).default;
	  }
	});
	
	var _LineRadial = __webpack_require__(694);
	
	Object.defineProperty(exports, 'LineRadial', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LineRadial).default;
	  }
	});
	
	var _LinkHorizontal = __webpack_require__(700);
	
	Object.defineProperty(exports, 'LinkHorizontal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkHorizontal).default;
	  }
	});
	
	var _LinkVertical = __webpack_require__(702);
	
	Object.defineProperty(exports, 'LinkVertical', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkVertical).default;
	  }
	});
	
	var _LinkRadial = __webpack_require__(701);
	
	Object.defineProperty(exports, 'LinkRadial', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkRadial).default;
	  }
	});
	
	var _LinkHorizontalCurve = __webpack_require__(697);
	
	Object.defineProperty(exports, 'LinkHorizontalCurve', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkHorizontalCurve).default;
	  }
	});
	
	var _LinkVerticalCurve = __webpack_require__(699);
	
	Object.defineProperty(exports, 'LinkVerticalCurve', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkVerticalCurve).default;
	  }
	});
	
	var _LinkRadialCurve = __webpack_require__(698);
	
	Object.defineProperty(exports, 'LinkRadialCurve', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkRadialCurve).default;
	  }
	});
	
	var _LinkHorizontalLine = __webpack_require__(703);
	
	Object.defineProperty(exports, 'LinkHorizontalLine', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkHorizontalLine).default;
	  }
	});
	
	var _LinkVerticalLine = __webpack_require__(705);
	
	Object.defineProperty(exports, 'LinkVerticalLine', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkVerticalLine).default;
	  }
	});
	
	var _LinkRadialLine = __webpack_require__(704);
	
	Object.defineProperty(exports, 'LinkRadialLine', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkRadialLine).default;
	  }
	});
	
	var _LinkHorizontalStep = __webpack_require__(706);
	
	Object.defineProperty(exports, 'LinkHorizontalStep', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkHorizontalStep).default;
	  }
	});
	
	var _LinkVerticalStep = __webpack_require__(708);
	
	Object.defineProperty(exports, 'LinkVerticalStep', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkVerticalStep).default;
	  }
	});
	
	var _LinkRadialStep = __webpack_require__(707);
	
	Object.defineProperty(exports, 'LinkRadialStep', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkRadialStep).default;
	  }
	});
	
	var _Area = __webpack_require__(686);
	
	Object.defineProperty(exports, 'Area', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Area).default;
	  }
	});
	
	var _AreaClosed = __webpack_require__(687);
	
	Object.defineProperty(exports, 'AreaClosed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AreaClosed).default;
	  }
	});
	
	var _AreaStack = __webpack_require__(688);
	
	Object.defineProperty(exports, 'AreaStack', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AreaStack).default;
	  }
	});
	
	var _Bar = __webpack_require__(181);
	
	Object.defineProperty(exports, 'Bar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bar).default;
	  }
	});
	
	var _BarGroup = __webpack_require__(689);
	
	Object.defineProperty(exports, 'BarGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BarGroup).default;
	  }
	});
	
	var _BarStack = __webpack_require__(690);
	
	Object.defineProperty(exports, 'BarStack', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BarStack).default;
	  }
	});
	
	var _BarStackHorizontal = __webpack_require__(691);
	
	Object.defineProperty(exports, 'BarStackHorizontal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BarStackHorizontal).default;
	  }
	});
	
	var _Stack = __webpack_require__(696);
	
	Object.defineProperty(exports, 'Stack', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Stack).default;
	  }
	});
	
	var _callOrValue = __webpack_require__(376);
	
	Object.defineProperty(exports, 'callOrValue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_callOrValue).default;
	  }
	});
	
	var _stackOffset = __webpack_require__(377);
	
	Object.defineProperty(exports, 'stackOffset', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stackOffset).default;
	  }
	});
	Object.defineProperty(exports, 'STACK_OFFSETS', {
	  enumerable: true,
	  get: function get() {
	    return _stackOffset.STACK_OFFSETS;
	  }
	});
	Object.defineProperty(exports, 'STACK_OFFSET_NAMES', {
	  enumerable: true,
	  get: function get() {
	    return _stackOffset.STACK_OFFSET_NAMES;
	  }
	});
	
	var _stackOrder = __webpack_require__(378);
	
	Object.defineProperty(exports, 'stackOrder', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stackOrder).default;
	  }
	});
	Object.defineProperty(exports, 'STACK_ORDERS', {
	  enumerable: true,
	  get: function get() {
	    return _stackOrder.STACK_ORDERS;
	  }
	});
	Object.defineProperty(exports, 'STACK_ORDER_NAMES', {
	  enumerable: true,
	  get: function get() {
	    return _stackOrder.STACK_ORDER_NAMES;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 376 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOrValue;
	function callOrValue(maybeFn, data) {
	  if (typeof maybeFn === 'function') {
	    return maybeFn(data);
	  }
	  return maybeFn;
	}

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STACK_OFFSET_NAMES = exports.STACK_OFFSETS = undefined;
	exports.default = stackOffset;
	
	var _d3Shape = __webpack_require__(13);
	
	var STACK_OFFSETS = exports.STACK_OFFSETS = {
	  expand: _d3Shape.stackOffsetExpand,
	  diverging: _d3Shape.stackOffsetDiverging,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var STACK_OFFSET_NAMES = exports.STACK_OFFSET_NAMES = Object.keys(STACK_OFFSETS);
	
	function stackOffset(offset) {
	  return STACK_OFFSETS[offset] || STACK_OFFSETS.none;
	}

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STACK_ORDER_NAMES = exports.STACK_ORDERS = undefined;
	exports.default = stackOrder;
	
	var _d3Shape = __webpack_require__(13);
	
	var STACK_ORDERS = exports.STACK_ORDERS = {
	  ascending: _d3Shape.stackOrderAscending,
	  descending: _d3Shape.stackOrderDescending,
	  insideout: _d3Shape.stackOrderInsideOut,
	  none: _d3Shape.stackOrderNone,
	  reverse: _d3Shape.stackOrderReverse
	};
	
	var STACK_ORDER_NAMES = exports.STACK_ORDER_NAMES = Object.keys(STACK_ORDERS);
	
	function stackOrder(order) {
	  return STACK_ORDERS[order] || STACK_ORDERS.none;
	}

/***/ },
/* 379 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(733)
	  , createDesc = __webpack_require__(734);
	module.exports = __webpack_require__(245) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 381 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-random/ Version 1.1.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var defaultSource = function() {
	  return Math.random();
	};
	
	var uniform = ((function sourceRandomUniform(source) {
	  function randomUniform(min, max) {
	    min = min == null ? 0 : +min;
	    max = max == null ? 1 : +max;
	    if (arguments.length === 1) max = min, min = 0;
	    else max -= min;
	    return function() {
	      return source() * max + min;
	    };
	  }
	
	  randomUniform.source = sourceRandomUniform;
	
	  return randomUniform;
	}))(defaultSource);
	
	var normal = ((function sourceRandomNormal(source) {
	  function randomNormal(mu, sigma) {
	    var x, r;
	    mu = mu == null ? 0 : +mu;
	    sigma = sigma == null ? 1 : +sigma;
	    return function() {
	      var y;
	
	      // If available, use the second previously-generated uniform random.
	      if (x != null) y = x, x = null;
	
	      // Otherwise, generate a new x and y.
	      else do {
	        x = source() * 2 - 1;
	        y = source() * 2 - 1;
	        r = x * x + y * y;
	      } while (!r || r > 1);
	
	      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
	    };
	  }
	
	  randomNormal.source = sourceRandomNormal;
	
	  return randomNormal;
	}))(defaultSource);
	
	var logNormal = ((function sourceRandomLogNormal(source) {
	  function randomLogNormal() {
	    var randomNormal = normal.source(source).apply(this, arguments);
	    return function() {
	      return Math.exp(randomNormal());
	    };
	  }
	
	  randomLogNormal.source = sourceRandomLogNormal;
	
	  return randomLogNormal;
	}))(defaultSource);
	
	var irwinHall = ((function sourceRandomIrwinHall(source) {
	  function randomIrwinHall(n) {
	    return function() {
	      for (var sum = 0, i = 0; i < n; ++i) sum += source();
	      return sum;
	    };
	  }
	
	  randomIrwinHall.source = sourceRandomIrwinHall;
	
	  return randomIrwinHall;
	}))(defaultSource);
	
	var bates = ((function sourceRandomBates(source) {
	  function randomBates(n) {
	    var randomIrwinHall = irwinHall.source(source)(n);
	    return function() {
	      return randomIrwinHall() / n;
	    };
	  }
	
	  randomBates.source = sourceRandomBates;
	
	  return randomBates;
	}))(defaultSource);
	
	var exponential = ((function sourceRandomExponential(source) {
	  function randomExponential(lambda) {
	    return function() {
	      return -Math.log(1 - source()) / lambda;
	    };
	  }
	
	  randomExponential.source = sourceRandomExponential;
	
	  return randomExponential;
	}))(defaultSource);
	
	exports.randomUniform = uniform;
	exports.randomNormal = normal;
	exports.randomLogNormal = logNormal;
	exports.randomBates = bates;
	exports.randomIrwinHall = irwinHall;
	exports.randomExponential = exponential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 384 */
[1487, 254],
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflectionEffect = __webpack_require__(770);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reflectionEffect).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvZWZmZWN0cy9yZWZsZWN0aW9uLWVmZmVjdC9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztxREFvQlFBLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDb3B5cmlnaHQgKGMpIDIwMTUgLSAyMDE3IFViZXIgVGVjaG5vbG9naWVzLCBJbmMuXG4vL1xuLy8gUGVybWlzc2lvbiBpcyBoZXJlYnkgZ3JhbnRlZCwgZnJlZSBvZiBjaGFyZ2UsIHRvIGFueSBwZXJzb24gb2J0YWluaW5nIGEgY29weVxuLy8gb2YgdGhpcyBzb2Z0d2FyZSBhbmQgYXNzb2NpYXRlZCBkb2N1bWVudGF0aW9uIGZpbGVzICh0aGUgXCJTb2Z0d2FyZVwiKSwgdG8gZGVhbFxuLy8gaW4gdGhlIFNvZnR3YXJlIHdpdGhvdXQgcmVzdHJpY3Rpb24sIGluY2x1ZGluZyB3aXRob3V0IGxpbWl0YXRpb24gdGhlIHJpZ2h0c1xuLy8gdG8gdXNlLCBjb3B5LCBtb2RpZnksIG1lcmdlLCBwdWJsaXNoLCBkaXN0cmlidXRlLCBzdWJsaWNlbnNlLCBhbmQvb3Igc2VsbFxuLy8gY29waWVzIG9mIHRoZSBTb2Z0d2FyZSwgYW5kIHRvIHBlcm1pdCBwZXJzb25zIHRvIHdob20gdGhlIFNvZnR3YXJlIGlzXG4vLyBmdXJuaXNoZWQgdG8gZG8gc28sIHN1YmplY3QgdG8gdGhlIGZvbGxvd2luZyBjb25kaXRpb25zOlxuLy9cbi8vIFRoZSBhYm92ZSBjb3B5cmlnaHQgbm90aWNlIGFuZCB0aGlzIHBlcm1pc3Npb24gbm90aWNlIHNoYWxsIGJlIGluY2x1ZGVkIGluXG4vLyBhbGwgY29waWVzIG9yIHN1YnN0YW50aWFsIHBvcnRpb25zIG9mIHRoZSBTb2Z0d2FyZS5cbi8vXG4vLyBUSEUgU09GVFdBUkUgSVMgUFJPVklERUQgXCJBUyBJU1wiLCBXSVRIT1VUIFdBUlJBTlRZIE9GIEFOWSBLSU5ELCBFWFBSRVNTIE9SXG4vLyBJTVBMSUVELCBJTkNMVURJTkcgQlVUIE5PVCBMSU1JVEVEIFRPIFRIRSBXQVJSQU5USUVTIE9GIE1FUkNIQU5UQUJJTElUWSxcbi8vIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFIEFORCBOT05JTkZSSU5HRU1FTlQuIElOIE5PIEVWRU5UIFNIQUxMIFRIRVxuLy8gQVVUSE9SUyBPUiBDT1BZUklHSFQgSE9MREVSUyBCRSBMSUFCTEUgRk9SIEFOWSBDTEFJTSwgREFNQUdFUyBPUiBPVEhFUlxuLy8gTElBQklMSVRZLCBXSEVUSEVSIElOIEFOIEFDVElPTiBPRiBDT05UUkFDVCwgVE9SVCBPUiBPVEhFUldJU0UsIEFSSVNJTkcgRlJPTSxcbi8vIE9VVCBPRiBPUiBJTiBDT05ORUNUSU9OIFdJVEggVEhFIFNPRlRXQVJFIE9SIFRIRSBVU0UgT1IgT1RIRVIgREVBTElOR1MgSU5cbi8vIFRIRSBTT0ZUV0FSRS5cblxuZXhwb3J0IHtkZWZhdWx0IGFzIGRlZmF1bHR9IGZyb20gJy4vcmVmbGVjdGlvbi1lZmZlY3QnO1xuIl19

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _luma = __webpack_require__(29);
	
	var _fp = __webpack_require__(54);
	
	var _gridCellLayerVertex = __webpack_require__(782);
	
	var _gridCellLayerVertex2 = _interopRequireDefault(_gridCellLayerVertex);
	
	var _gridCellLayerVertex3 = __webpack_require__(781);
	
	var _gridCellLayerVertex4 = _interopRequireDefault(_gridCellLayerVertex3);
	
	var _gridCellLayerFragment = __webpack_require__(780);
	
	var _gridCellLayerFragment2 = _interopRequireDefault(_gridCellLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEFAULT_COLOR = [255, 0, 255, 255];
	
	var defaultProps = {
	  cellSize: 1000,
	  elevationScale: 1,
	  extruded: true,
	  fp64: false,
	
	  getPosition: function getPosition(x) {
	    return x.position;
	  },
	  getElevation: function getElevation(x) {
	    return x.elevation;
	  },
	  getColor: function getColor(x) {
	    return x.color;
	  },
	
	  lightSettings: {
	    lightsPosition: [-122.45, 37.65, 8000, -122.45, 37.20, 1000],
	    ambientRatio: 0.4,
	    diffuseRatio: 0.6,
	    specularRatio: 0.8,
	    lightsStrength: [1.0, 0.0, 0.8, 0.0],
	    numberOfLights: 2
	  }
	};
	
	var GridCellLayer = function (_Layer) {
	  _inherits(GridCellLayer, _Layer);
	
	  function GridCellLayer() {
	    _classCallCheck(this, GridCellLayer);
	
	    return _possibleConstructorReturn(this, (GridCellLayer.__proto__ || Object.getPrototypeOf(GridCellLayer)).apply(this, arguments));
	  }
	
	  _createClass(GridCellLayer, [{
	    key: 'getShaders',
	
	    /**
	     * A generic GridLayer that takes latitude longitude delta of cells as a uniform
	     * and the min lat lng of cells. grid can be 3d when pass in a height
	     * and set enable3d to true
	     *
	     * @param {array} props.data -
	     * @param {boolean} props.extruded - enable grid elevation
	     * @param {number} props.cellSize - grid cell size in meters
	     * @param {function} props.getPosition - position accessor, returned as [minLng, minLat]
	     * @param {function} props.getElevation - elevation accessor
	     * @param {function} props.getColor - color accessor, returned as [r, g, b, a]
	     */
	
	    value: function getShaders() {
	      return (0, _fp.enable64bitSupport)(this.props) ? {
	        vs: _gridCellLayerVertex4.default, fs: _gridCellLayerFragment2.default, modules: ['fp64', 'project64', 'lighting']
	      } : {
	        vs: _gridCellLayerVertex2.default, fs: _gridCellLayerFragment2.default, modules: ['lighting']
	      };
	    }
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      var gl = this.context.gl;
	
	      this.setState({ model: this._getModel(gl) });
	
	      var attributeManager = this.state.attributeManager;
	      /* eslint-disable max-len */
	
	      attributeManager.addInstanced({
	        instancePositions: { size: 4, accessor: ['getPosition', 'getElevation'], update: this.calculateInstancePositions },
	        instanceColors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getColor', update: this.calculateInstanceColors }
	      });
	      /* eslint-enable max-len */
	    }
	  }, {
	    key: 'updateAttribute',
	    value: function updateAttribute(_ref) {
	      var props = _ref.props,
	          oldProps = _ref.oldProps,
	          changeFlags = _ref.changeFlags;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidateAll();
	
	        if (props.fp64 && props.projectionMode === _lib.COORDINATE_SYSTEM.LNGLAT) {
	          attributeManager.addInstanced({
	            instancePositions64xyLow: {
	              size: 2,
	              accessor: 'getPosition',
	              update: this.calculateInstancePositions64xyLow
	            }
	          });
	        } else {
	          attributeManager.remove(['instancePositions64xyLow']);
	        }
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref2) {
	      var props = _ref2.props,
	          oldProps = _ref2.oldProps,
	          changeFlags = _ref2.changeFlags;
	
	      _get(GridCellLayer.prototype.__proto__ || Object.getPrototypeOf(GridCellLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	      // Re-generate model if geometry changed
	      if (props.fp64 !== oldProps.fp64) {
	        var gl = this.context.gl;
	
	        this.setState({ model: this._getModel(gl) });
	      }
	      this.updateAttribute({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	      this.updateUniforms();
	    }
	  }, {
	    key: '_getModel',
	    value: function _getModel(gl) {
	      var geometry = new _luma.CubeGeometry({});
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: geometry,
	        isInstanced: true
	      });
	    }
	  }, {
	    key: 'updateUniforms',
	    value: function updateUniforms() {
	      var _props = this.props,
	          opacity = _props.opacity,
	          extruded = _props.extruded,
	          elevationScale = _props.elevationScale,
	          cellSize = _props.cellSize,
	          lightSettings = _props.lightSettings;
	      var viewport = this.context.viewport;
	
	      var _viewport$getDistance = viewport.getDistanceScales(),
	          pixelsPerMeter = _viewport$getDistance.pixelsPerMeter;
	
	      this.setUniforms(Object.assign({}, {
	        extruded: extruded,
	        elevationScale: elevationScale,
	        opacity: opacity,
	        cellSize: cellSize * pixelsPerMeter[0]
	      }, lightSettings));
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref3) {
	      var uniforms = _ref3.uniforms;
	
	      _get(GridCellLayer.prototype.__proto__ || Object.getPrototypeOf(GridCellLayer.prototype), 'draw', this).call(this, { uniforms: Object.assign({}, uniforms) });
	    }
	  }, {
	    key: 'calculateInstancePositions',
	    value: function calculateInstancePositions(attribute) {
	      var _props2 = this.props,
	          data = _props2.data,
	          getPosition = _props2.getPosition,
	          getElevation = _props2.getElevation;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var object = _step.value;
	
	          var position = getPosition(object);
	          var elevation = getElevation(object) || 0;
	          value[i + 0] = position[0];
	          value[i + 1] = position[1];
	          value[i + 2] = 0;
	          value[i + 3] = elevation;
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstancePositions64xyLow',
	    value: function calculateInstancePositions64xyLow(attribute) {
	      var _props3 = this.props,
	          data = _props3.data,
	          getPosition = _props3.getPosition;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var point = _step2.value;
	
	          var position = getPosition(point);
	          value[i++] = (0, _fp.fp64ify)(position[0])[1];
	          value[i++] = (0, _fp.fp64ify)(position[1])[1];
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceColors',
	    value: function calculateInstanceColors(attribute) {
	      var _props4 = this.props,
	          data = _props4.data,
	          getColor = _props4.getColor;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var object = _step3.value;
	
	          var color = getColor(object) || DEFAULT_COLOR;
	          value[i + 0] = color[0];
	          value[i + 1] = color[1];
	          value[i + 2] = color[2];
	          value[i + 3] = Number.isFinite(color[3]) ? color[3] : DEFAULT_COLOR[3];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }]);
	
	  return GridCellLayer;
	}(_lib.Layer);
	
	exports.default = GridCellLayer;
	
	
	GridCellLayer.layerName = 'GridCellLayer';
	GridCellLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _luma = __webpack_require__(29);
	
	var _utils = __webpack_require__(42);
	
	var _fp = __webpack_require__(54);
	
	var _hexagonCellLayerVertex = __webpack_require__(787);
	
	var _hexagonCellLayerVertex2 = _interopRequireDefault(_hexagonCellLayerVertex);
	
	var _hexagonCellLayerVertex3 = __webpack_require__(786);
	
	var _hexagonCellLayerVertex4 = _interopRequireDefault(_hexagonCellLayerVertex3);
	
	var _hexagonCellLayerFragment = __webpack_require__(785);
	
	var _hexagonCellLayerFragment2 = _interopRequireDefault(_hexagonCellLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	function positionsAreEqual(v1, v2) {
	  // Hex positions are expected to change entirely, not to maintain some
	  // positions and change others. Right now we only check a single vertex,
	  // because H3 guarantees order, but even if that wasn't true, this would only
	  // return a false positive for adjacent hexagons, which is close enough for
	  // our purposes.
	  return v1 === v2 || v1 && v2 && v1[0][0] === v2[0][0] && v1[0][1] === v2[0][1];
	}
	
	var DEFAULT_COLOR = [255, 0, 255, 255];
	
	var defaultProps = {
	  hexagonVertices: null,
	  radius: null,
	  angle: null,
	  coverage: 1,
	  elevationScale: 1,
	  extruded: true,
	  fp64: false,
	
	  getCentroid: function getCentroid(x) {
	    return x.centroid;
	  },
	  getColor: function getColor(x) {
	    return x.color;
	  },
	  getElevation: function getElevation(x) {
	    return x.elevation;
	  },
	
	  lightSettings: {
	    lightsPosition: [-122.45, 37.75, 8000, -122.0, 38.00, 5000],
	    ambientRatio: 0.4,
	    diffuseRatio: 0.6,
	    specularRatio: 0.8,
	    lightsStrength: [1.2, 0.0, 0.8, 0.0],
	    numberOfLights: 2
	  }
	};
	
	var HexagonCellLayer = function (_Layer) {
	  _inherits(HexagonCellLayer, _Layer);
	
	  function HexagonCellLayer(props) {
	    _classCallCheck(this, HexagonCellLayer);
	
	    var missingProps = false;
	    if (!props.hexagonVertices && (!props.radius || !Number.isFinite(props.angle))) {
	      _utils.log.once(0, 'HexagonCellLayer: Either hexagonVertices or radius and angle are ' + 'needed to calculate primitive hexagon.');
	      missingProps = true;
	    } else if (props.hexagonVertices && (!Array.isArray(props.hexagonVertices) || props.hexagonVertices.length < 6)) {
	      _utils.log.once(0, 'HexagonCellLayer: hexagonVertices needs to be an array of 6 points');
	
	      missingProps = true;
	    }
	
	    if (missingProps) {
	      _utils.log.once(0, 'Now using 1000 meter as default radius, 0 as default angle');
	      props.radius = 1000;
	      props.angle = 0;
	    }
	
	    return _possibleConstructorReturn(this, (HexagonCellLayer.__proto__ || Object.getPrototypeOf(HexagonCellLayer)).call(this, props));
	  }
	
	  _createClass(HexagonCellLayer, [{
	    key: 'getShaders',
	    value: function getShaders() {
	      return (0, _fp.enable64bitSupport)(this.props) ? {
	        vs: _hexagonCellLayerVertex4.default, fs: _hexagonCellLayerFragment2.default, modules: ['fp64', 'project64', 'lighting']
	      } : {
	        vs: _hexagonCellLayerVertex2.default, fs: _hexagonCellLayerFragment2.default, modules: ['lighting']
	      };
	    }
	
	    /**
	     * DeckGL calls initializeState when GL context is available
	     * Essentially a deferred constructor
	     */
	
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      var gl = this.context.gl;
	
	      this.setState({ model: this._getModel(gl) });
	
	      var attributeManager = this.state.attributeManager;
	      /* eslint-disable max-len */
	
	      attributeManager.addInstanced({
	        instancePositions: { size: 3, accessor: ['getCentroid', 'getElevation'],
	          update: this.calculateInstancePositions },
	        instanceColors: { size: 4, type: gl.UNSIGNED_BYTE, accessor: 'getColor',
	          update: this.calculateInstanceColors }
	      });
	      /* eslint-enable max-len */
	
	      this.updateRadiusAngle();
	    }
	  }, {
	    key: 'updateAttribute',
	    value: function updateAttribute(_ref) {
	      var props = _ref.props,
	          oldProps = _ref.oldProps,
	          changeFlags = _ref.changeFlags;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidateAll();
	
	        if (props.fp64 && props.projectionMode === _lib.COORDINATE_SYSTEM.LNGLAT) {
	          attributeManager.addInstanced({
	            instancePositions64xyLow: {
	              size: 2,
	              accessor: 'getCentroid',
	              update: this.calculateInstancePositions64xyLow
	            }
	          });
	        } else {
	          attributeManager.remove(['instancePositions64xyLow']);
	        }
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref2) {
	      var props = _ref2.props,
	          oldProps = _ref2.oldProps,
	          changeFlags = _ref2.changeFlags;
	
	      _get(HexagonCellLayer.prototype.__proto__ || Object.getPrototypeOf(HexagonCellLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	      if (props.fp64 !== oldProps.fp64) {
	        var gl = this.context.gl;
	
	        this.setState({ model: this._getModel(gl) });
	      }
	      this.updateAttribute({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	
	      var viewportChanged = changeFlags.viewportChanged;
	      var model = this.state.model;
	
	      // Update the positions in the model if they've changes
	
	      var verticesChanged = !positionsAreEqual(oldProps.hexagonVertices, props.hexagonVertices);
	
	      if (model && (verticesChanged || viewportChanged)) {
	        this.updateRadiusAngle();
	      }
	      this.updateUniforms();
	    }
	  }, {
	    key: 'updateRadiusAngle',
	    value: function updateRadiusAngle() {
	      var angle = void 0;
	      var radius = void 0;
	      var hexagonVertices = this.props.hexagonVertices;
	
	
	      if (Array.isArray(hexagonVertices) && hexagonVertices.length >= 6) {
	
	        // calculate angle and vertices from hexagonVertices if provided
	        var vertices = this.props.hexagonVertices;
	
	        var vertex0 = vertices[0];
	        var vertex3 = vertices[3];
	
	        // transform to space coordinates
	        var spaceCoord0 = this.projectFlat(vertex0);
	        var spaceCoord3 = this.projectFlat(vertex3);
	
	        // distance between two close centroids
	        var dx = spaceCoord0[0] - spaceCoord3[0];
	        var dy = spaceCoord0[1] - spaceCoord3[1];
	        var dxy = Math.sqrt(dx * dx + dy * dy);
	
	        // Calculate angle that the perpendicular hexagon vertex axis is tilted
	        angle = Math.acos(dx / dxy) * -Math.sign(dy) + Math.PI / 2;
	        radius = dxy / 2;
	      } else if (this.props.radius && Number.isFinite(this.props.angle)) {
	
	        // if no hexagonVertices provided, try use radius & angle
	        var viewport = this.context.viewport;
	
	        var _viewport$getDistance = viewport.getDistanceScales(),
	            pixelsPerMeter = _viewport$getDistance.pixelsPerMeter;
	
	        angle = this.props.angle;
	        radius = this.props.radius * pixelsPerMeter[0];
	      }
	
	      this.setUniforms({
	        angle: angle,
	        radius: radius
	      });
	    }
	  }, {
	    key: 'getCylinderGeometry',
	    value: function getCylinderGeometry(radius) {
	      return new _luma.CylinderGeometry({
	        radius: radius,
	        topRadius: radius,
	        bottomRadius: radius,
	        topCap: true,
	        bottomCap: true,
	        height: 1,
	        nradial: 6,
	        nvertical: 1
	      });
	    }
	  }, {
	    key: 'updateUniforms',
	    value: function updateUniforms() {
	      var _props = this.props,
	          opacity = _props.opacity,
	          elevationScale = _props.elevationScale,
	          extruded = _props.extruded,
	          coverage = _props.coverage,
	          lightSettings = _props.lightSettings;
	
	
	      this.setUniforms(Object.assign({}, {
	        extruded: extruded,
	        opacity: opacity,
	        coverage: coverage,
	        elevationScale: elevationScale
	      }, lightSettings));
	    }
	  }, {
	    key: '_getModel',
	    value: function _getModel(gl) {
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: this.getCylinderGeometry(1),
	        isInstanced: true
	      });
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref3) {
	      var uniforms = _ref3.uniforms;
	
	      _get(HexagonCellLayer.prototype.__proto__ || Object.getPrototypeOf(HexagonCellLayer.prototype), 'draw', this).call(this, { uniforms: Object.assign({}, uniforms) });
	    }
	  }, {
	    key: 'calculateInstancePositions',
	    value: function calculateInstancePositions(attribute) {
	      var _props2 = this.props,
	          data = _props2.data,
	          getCentroid = _props2.getCentroid,
	          getElevation = _props2.getElevation;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var object = _step.value;
	
	          var _getCentroid = getCentroid(object),
	              _getCentroid2 = _slicedToArray(_getCentroid, 2),
	              lon = _getCentroid2[0],
	              lat = _getCentroid2[1];
	
	          var elevation = getElevation(object);
	          value[i + 0] = lon;
	          value[i + 1] = lat;
	          value[i + 2] = elevation || this.props.elevation;
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstancePositions64xyLow',
	    value: function calculateInstancePositions64xyLow(attribute) {
	      var _props3 = this.props,
	          data = _props3.data,
	          getCentroid = _props3.getCentroid;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var object = _step2.value;
	
	          var position = getCentroid(object);
	          value[i++] = (0, _fp.fp64ify)(position[0])[1];
	          value[i++] = (0, _fp.fp64ify)(position[1])[1];
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceColors',
	    value: function calculateInstanceColors(attribute) {
	      var _props4 = this.props,
	          data = _props4.data,
	          getColor = _props4.getColor;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var object = _step3.value;
	
	          var color = getColor(object) || DEFAULT_COLOR;
	
	          value[i + 0] = color[0];
	          value[i + 1] = color[1];
	          value[i + 2] = color[2];
	          value[i + 3] = Number.isFinite(color[3]) ? color[3] : DEFAULT_COLOR[3];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }]);
	
	  return HexagonCellLayer;
	}(_lib.Layer);
	
	exports.default = HexagonCellLayer;
	
	
	HexagonCellLayer.layerName = 'HexagonCellLayer';
	HexagonCellLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _utils = __webpack_require__(42);
	
	var _fp = __webpack_require__(54);
	
	var _luma = __webpack_require__(29);
	
	var _scatterplotLayerVertex = __webpack_require__(808);
	
	var _scatterplotLayerVertex2 = _interopRequireDefault(_scatterplotLayerVertex);
	
	var _scatterplotLayerVertex3 = __webpack_require__(807);
	
	var _scatterplotLayerVertex4 = _interopRequireDefault(_scatterplotLayerVertex3);
	
	var _scatterplotLayerFragment = __webpack_require__(806);
	
	var _scatterplotLayerFragment2 = _interopRequireDefault(_scatterplotLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEFAULT_COLOR = [0, 0, 0, 255];
	
	var defaultProps = {
	  radiusScale: 1, //  point radius in meters
	  radiusMinPixels: 0, //  min point radius in pixels
	  radiusMaxPixels: Number.MAX_SAFE_INTEGER, // max point radius in pixels
	  strokeWidth: 1,
	  outline: false,
	  fp64: false,
	
	  getPosition: function getPosition(x) {
	    return x.position;
	  },
	  getRadius: function getRadius(x) {
	    return x.radius || 1;
	  },
	  getColor: function getColor(x) {
	    return x.color || DEFAULT_COLOR;
	  }
	};
	
	var ScatterplotLayer = function (_Layer) {
	  _inherits(ScatterplotLayer, _Layer);
	
	  function ScatterplotLayer() {
	    _classCallCheck(this, ScatterplotLayer);
	
	    return _possibleConstructorReturn(this, (ScatterplotLayer.__proto__ || Object.getPrototypeOf(ScatterplotLayer)).apply(this, arguments));
	  }
	
	  _createClass(ScatterplotLayer, [{
	    key: 'getShaders',
	    value: function getShaders(id) {
	      return (0, _fp.enable64bitSupport)(this.props) ? {
	        vs: _scatterplotLayerVertex4.default, fs: _scatterplotLayerFragment2.default, modules: ['fp64', 'project64']
	      } : {
	        vs: _scatterplotLayerVertex2.default, fs: _scatterplotLayerFragment2.default, modules: []
	      };
	    }
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      var gl = this.context.gl;
	
	      this.setState({ model: this._getModel(gl) });
	
	      /* eslint-disable max-len */
	      /* deprecated props check */
	      this._checkRemovedProp('radius', 'radiusScale');
	      this._checkRemovedProp('drawOutline', 'outline');
	
	      this.state.attributeManager.addInstanced({
	        instancePositions: { size: 3, accessor: 'getPosition', update: this.calculateInstancePositions },
	        instanceRadius: { size: 1, accessor: 'getRadius', defaultValue: 1, update: this.calculateInstanceRadius },
	        instanceColors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getColor', update: this.calculateInstanceColors }
	      });
	      /* eslint-enable max-len */
	    }
	  }, {
	    key: 'updateAttribute',
	    value: function updateAttribute(_ref) {
	      var props = _ref.props,
	          oldProps = _ref.oldProps,
	          changeFlags = _ref.changeFlags;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidateAll();
	
	        if (props.fp64 && props.projectionMode === _lib.COORDINATE_SYSTEM.LNGLAT) {
	          attributeManager.addInstanced({
	            instancePositions64xyLow: {
	              size: 2,
	              accessor: 'getPosition',
	              update: this.calculateInstancePositions64xyLow
	            }
	          });
	        } else {
	          attributeManager.remove(['instancePositions64xyLow']);
	        }
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref2) {
	      var props = _ref2.props,
	          oldProps = _ref2.oldProps,
	          changeFlags = _ref2.changeFlags;
	
	      _get(ScatterplotLayer.prototype.__proto__ || Object.getPrototypeOf(ScatterplotLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	      if (props.fp64 !== oldProps.fp64) {
	        var gl = this.context.gl;
	
	        this.setState({ model: this._getModel(gl) });
	      }
	      this.updateAttribute({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref3) {
	      var uniforms = _ref3.uniforms;
	      var _props = this.props,
	          radiusScale = _props.radiusScale,
	          radiusMinPixels = _props.radiusMinPixels,
	          radiusMaxPixels = _props.radiusMaxPixels,
	          outline = _props.outline,
	          strokeWidth = _props.strokeWidth;
	
	      this.state.model.render(Object.assign({}, uniforms, {
	        outline: outline ? 1 : 0,
	        strokeWidth: strokeWidth,
	        radiusScale: radiusScale,
	        radiusMinPixels: radiusMinPixels,
	        radiusMaxPixels: radiusMaxPixels
	      }));
	    }
	  }, {
	    key: '_getModel',
	    value: function _getModel(gl) {
	      // a square that minimally cover the unit circle
	      var positions = [-1, -1, 0, -1, 1, 0, 1, 1, 0, 1, -1, 0];
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: _luma.GL.TRIANGLE_FAN,
	          positions: new Float32Array(positions)
	        }),
	        isInstanced: true
	      });
	    }
	  }, {
	    key: 'calculateInstancePositions',
	    value: function calculateInstancePositions(attribute) {
	      var _props2 = this.props,
	          data = _props2.data,
	          getPosition = _props2.getPosition;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var point = _step.value;
	
	          var position = getPosition(point);
	          value[i++] = (0, _utils.get)(position, 0);
	          value[i++] = (0, _utils.get)(position, 1);
	          value[i++] = (0, _utils.get)(position, 2) || 0;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstancePositions64xyLow',
	    value: function calculateInstancePositions64xyLow(attribute) {
	      var _props3 = this.props,
	          data = _props3.data,
	          getPosition = _props3.getPosition;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var point = _step2.value;
	
	          var position = getPosition(point);
	          value[i++] = (0, _fp.fp64ify)((0, _utils.get)(position, 0))[1];
	          value[i++] = (0, _fp.fp64ify)((0, _utils.get)(position, 1))[1];
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceRadius',
	    value: function calculateInstanceRadius(attribute) {
	      var _props4 = this.props,
	          data = _props4.data,
	          getRadius = _props4.getRadius;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var point = _step3.value;
	
	          var radius = getRadius(point);
	          value[i++] = isNaN(radius) ? 1 : radius;
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceColors',
	    value: function calculateInstanceColors(attribute) {
	      var _props5 = this.props,
	          data = _props5.data,
	          getColor = _props5.getColor;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var point = _step4.value;
	
	          var color = getColor(point) || DEFAULT_COLOR;
	          value[i++] = (0, _utils.get)(color, 0);
	          value[i++] = (0, _utils.get)(color, 1);
	          value[i++] = (0, _utils.get)(color, 2);
	          value[i++] = isNaN((0, _utils.get)(color, 3)) ? 255 : (0, _utils.get)(color, 3);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	  }]);
	
	  return ScatterplotLayer;
	}(_lib.Layer);
	
	exports.default = ScatterplotLayer;
	
	
	ScatterplotLayer.layerName = 'ScatterplotLayer';
	ScatterplotLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _utils = __webpack_require__(42);
	
	var _luma = __webpack_require__(29);
	
	var _fp = __webpack_require__(54);
	
	var _polygonTesselator = __webpack_require__(813);
	
	var _polygonTesselatorExtruded = __webpack_require__(812);
	
	var _solidPolygonLayerVertex = __webpack_require__(816);
	
	var _solidPolygonLayerVertex2 = _interopRequireDefault(_solidPolygonLayerVertex);
	
	var _solidPolygonLayerVertex3 = __webpack_require__(815);
	
	var _solidPolygonLayerVertex4 = _interopRequireDefault(_solidPolygonLayerVertex3);
	
	var _solidPolygonLayerFragment = __webpack_require__(814);
	
	var _solidPolygonLayerFragment2 = _interopRequireDefault(_solidPolygonLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Polygon geometry generation is managed by the polygon tesselator
	
	
	var defaultProps = {
	  // Whether to extrude
	  extruded: false,
	  // Whether to draw a GL.LINES wireframe of the polygon
	  wireframe: false,
	  fp64: false,
	
	  // Accessor for polygon geometry
	  getPolygon: function getPolygon(f) {
	    return (0, _utils.get)(f, 'polygon') || (0, _utils.get)(f, 'geometry.coordinates');
	  },
	  // Accessor for extrusion height
	  getElevation: function getElevation(f) {
	    return (0, _utils.get)(f, 'elevation') || (0, _utils.get)(f, 'properties.height') || 0;
	  },
	  // Accessor for color
	  getColor: function getColor(f) {
	    return (0, _utils.get)(f, 'color') || (0, _utils.get)(f, 'properties.color');
	  },
	
	  // Optional settings for 'lighting' shader module
	  lightSettings: {
	    lightsPosition: [-122.45, 37.75, 8000, -122.0, 38.00, 5000],
	    ambientRatio: 0.05,
	    diffuseRatio: 0.6,
	    specularRatio: 0.8,
	    lightsStrength: [2.0, 0.0, 0.0, 0.0],
	    numberOfLights: 2
	  }
	};
	
	var SolidPolygonLayer = function (_Layer) {
	  _inherits(SolidPolygonLayer, _Layer);
	
	  function SolidPolygonLayer() {
	    _classCallCheck(this, SolidPolygonLayer);
	
	    return _possibleConstructorReturn(this, (SolidPolygonLayer.__proto__ || Object.getPrototypeOf(SolidPolygonLayer)).apply(this, arguments));
	  }
	
	  _createClass(SolidPolygonLayer, [{
	    key: 'getShaders',
	    value: function getShaders() {
	      return (0, _fp.enable64bitSupport)(this.props) ? {
	        vs: _solidPolygonLayerVertex4.default, fs: _solidPolygonLayerFragment2.default, modules: ['fp64', 'project64', 'lighting']
	      } : {
	        vs: _solidPolygonLayerVertex2.default, fs: _solidPolygonLayerFragment2.default, modules: ['lighting']
	      };
	    }
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      var gl = this.context.gl;
	
	      this.setState({
	        model: this._getModel(gl),
	        numInstances: 0,
	        IndexType: gl.getExtension('OES_element_index_uint') ? Uint32Array : Uint16Array
	      });
	
	      var attributeManager = this.state.attributeManager;
	
	      var noAlloc = true;
	      /* eslint-disable max-len */
	      attributeManager.add({
	        indices: { size: 1, isIndexed: true, update: this.calculateIndices, noAlloc: noAlloc },
	        positions: { size: 3, accessor: 'getElevation', update: this.calculatePositions, noAlloc: noAlloc },
	        normals: { size: 3, update: this.calculateNormals, noAlloc: noAlloc },
	        colors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getColor', update: this.calculateColors, noAlloc: noAlloc },
	        pickingColors: { size: 3, type: _luma.GL.UNSIGNED_BYTE, update: this.calculatePickingColors, noAlloc: noAlloc }
	      });
	      /* eslint-enable max-len */
	    }
	  }, {
	    key: 'updateAttribute',
	    value: function updateAttribute(_ref) {
	      var props = _ref.props,
	          oldProps = _ref.oldProps,
	          changeFlags = _ref.changeFlags;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidateAll();
	
	        if (props.fp64 && props.projectionMode === _lib.COORDINATE_SYSTEM.LNGLAT) {
	          attributeManager.add({
	            positions64xyLow: { size: 2, update: this.calculatePositionsLow }
	          });
	        } else {
	          attributeManager.remove(['positions64xyLow']);
	        }
	      }
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref2) {
	      var uniforms = _ref2.uniforms;
	      var _props = this.props,
	          extruded = _props.extruded,
	          lightSettings = _props.lightSettings;
	
	
	      this.state.model.render(Object.assign({}, uniforms, {
	        extruded: extruded ? 1.0 : 0.0
	      }, lightSettings));
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref3) {
	      var props = _ref3.props,
	          oldProps = _ref3.oldProps,
	          changeFlags = _ref3.changeFlags;
	
	      _get(SolidPolygonLayer.prototype.__proto__ || Object.getPrototypeOf(SolidPolygonLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	
	      var geometryChanged = this.updateGeometry({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	
	      // Re-generate model if geometry changed
	      if (geometryChanged) {
	        var gl = this.context.gl;
	
	        this.setState({ model: this._getModel(gl) });
	      }
	      this.updateAttribute({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	    }
	  }, {
	    key: 'updateGeometry',
	    value: function updateGeometry(_ref4) {
	      var _this2 = this;
	
	      var props = _ref4.props,
	          oldProps = _ref4.oldProps,
	          changeFlags = _ref4.changeFlags;
	
	      var regenerateModel = changeFlags.dataChanged || props.extruded !== oldProps.extruded || props.wireframe !== oldProps.wireframe || props.fp64 !== oldProps.fp64;
	
	      if (regenerateModel) {
	        var getPolygon = props.getPolygon,
	            extruded = props.extruded,
	            wireframe = props.wireframe,
	            getElevation = props.getElevation;
	
	        // TODO - avoid creating a temporary array here: let the tesselator iterate
	
	        var polygons = props.data.map(getPolygon);
	
	        this.setState({
	          polygonTesselator: !extruded ? new _polygonTesselator.PolygonTesselator({ polygons: polygons, fp64: this.props.fp64 }) : new _polygonTesselatorExtruded.PolygonTesselatorExtruded({ polygons: polygons, wireframe: wireframe,
	            getHeight: function getHeight(polygonIndex) {
	              return getElevation(_this2.props.data[polygonIndex]);
	            },
	            fp64: this.props.fp64
	          })
	        });
	
	        this.state.attributeManager.invalidateAll();
	      }
	
	      return regenerateModel;
	    }
	  }, {
	    key: '_getModel',
	    value: function _getModel(gl) {
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: this.props.wireframe ? _luma.GL.LINES : _luma.GL.TRIANGLES
	        }),
	        vertexCount: 0,
	        isIndexed: true
	      });
	    }
	  }, {
	    key: 'calculateIndices',
	    value: function calculateIndices(attribute) {
	      attribute.value = this.state.polygonTesselator.indices();
	      attribute.target = _luma.GL.ELEMENT_ARRAY_BUFFER;
	      this.state.model.setVertexCount(attribute.value.length / attribute.size);
	    }
	  }, {
	    key: 'calculatePositions',
	    value: function calculatePositions(attribute) {
	      attribute.value = this.state.polygonTesselator.positions().positions;
	    }
	  }, {
	    key: 'calculatePositionsLow',
	    value: function calculatePositionsLow(attribute) {
	      attribute.value = this.state.polygonTesselator.positions().positions64xyLow;
	    }
	  }, {
	    key: 'calculateNormals',
	    value: function calculateNormals(attribute) {
	      attribute.value = this.state.polygonTesselator.normals();
	    }
	  }, {
	    key: 'calculateColors',
	    value: function calculateColors(attribute) {
	      var _this3 = this;
	
	      attribute.value = this.state.polygonTesselator.colors({
	        getColor: function getColor(polygonIndex) {
	          return _this3.props.getColor(_this3.props.data[polygonIndex]);
	        }
	      });
	    }
	
	    // Override the default picking colors calculation
	
	  }, {
	    key: 'calculatePickingColors',
	    value: function calculatePickingColors(attribute) {
	      attribute.value = this.state.polygonTesselator.pickingColors();
	    }
	  }]);
	
	  return SolidPolygonLayer;
	}(_lib.Layer);
	
	exports.default = SolidPolygonLayer;
	
	
	SolidPolygonLayer.layerName = 'SolidPolygonLayer';
	SolidPolygonLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _utils = __webpack_require__(42);
	
	var _geojson = __webpack_require__(821);
	
	var _luma = __webpack_require__(29);
	
	var _earcut = __webpack_require__(184);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	var _choroplethLayerVertex = __webpack_require__(820);
	
	var _choroplethLayerVertex2 = _interopRequireDefault(_choroplethLayerVertex);
	
	var _choroplethLayerFragment = __webpack_require__(819);
	
	var _choroplethLayerFragment2 = _interopRequireDefault(_choroplethLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEFAULT_COLOR = [0, 0, 255, 255];
	
	var defaultProps = {
	  getColor: function getColor(feature) {
	    return (0, _utils.get)(feature, 'properties.color');
	  },
	  drawContour: false,
	  strokeWidth: 1
	};
	
	var ChoroplethLayer = function (_Layer) {
	  _inherits(ChoroplethLayer, _Layer);
	
	  function ChoroplethLayer(props) {
	    _classCallCheck(this, ChoroplethLayer);
	
	    var _this = _possibleConstructorReturn(this, (ChoroplethLayer.__proto__ || Object.getPrototypeOf(ChoroplethLayer)).call(this, props));
	
	    _utils.log.once('ChoroplethLayer is deprecated. Consider using GeoJsonLayer instead');
	    return _this;
	  }
	
	  _createClass(ChoroplethLayer, [{
	    key: 'getShaders',
	    value: function getShaders() {
	      return {
	        vs: _choroplethLayerVertex2.default,
	        fs: _choroplethLayerFragment2.default
	      };
	    }
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      var gl = this.context.gl;
	      var attributeManager = this.state.attributeManager;
	
	      attributeManager.add({
	        // Primtive attributes
	        indices: { size: 1, update: this.calculateIndices, isIndexed: true },
	        positions: { size: 3, update: this.calculatePositions },
	        colors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, update: this.calculateColors },
	        // Instanced attributes
	        pickingColors: {
	          size: 3,
	          type: _luma.GL.UNSIGNED_BYTE,
	          update: this.calculatePickingColors,
	          noAlloc: true
	        }
	      });
	
	      var IndexType = gl.getExtension('OES_element_index_uint') ? Uint32Array : Uint16Array;
	
	      this.setState({
	        model: this.getModel(gl),
	        numInstances: 0,
	        IndexType: IndexType
	      });
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref) {
	      var oldProps = _ref.oldProps,
	          props = _ref.props,
	          changeFlags = _ref.changeFlags;
	      var attributeManager = this.state.attributeManager;
	
	      if (changeFlags.dataChanged) {
	        this.state.choropleths = (0, _geojson.extractPolygons)(props.data);
	        attributeManager.invalidateAll();
	      }
	
	      if (props.drawContour !== oldProps.drawContour) {
	        this.state.model.geometry.drawMode = props.drawContour ? _luma.GL.LINES : _luma.GL.TRIANGLES;
	        attributeManager.invalidateAll();
	      }
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref2) {
	      var uniforms = _ref2.uniforms;
	      var gl = this.context.gl;
	
	      var lineWidth = this.screenToDevicePixels(this.props.strokeWidth);
	      gl.lineWidth(lineWidth);
	      this.state.model.render(uniforms);
	      // Setting line width back to 1 is here to workaround a Google Chrome bug
	      // gl.clear() and gl.isEnabled() will return GL_INVALID_VALUE even with
	      // correct parameter
	      // This is not happening on Safari and Firefox
	      gl.lineWidth(1.0);
	    }
	  }, {
	    key: 'getPickingInfo',
	    value: function getPickingInfo(opts) {
	      var info = _get(ChoroplethLayer.prototype.__proto__ || Object.getPrototypeOf(ChoroplethLayer.prototype), 'getPickingInfo', this).call(this, opts);
	      var index = this.decodePickingColor(info.color);
	      var feature = index >= 0 ? (0, _utils.get)(this.props.data, ['features', index]) : null;
	      info.feature = feature;
	      info.object = feature;
	      return info;
	    }
	  }, {
	    key: 'getModel',
	    value: function getModel(gl) {
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: this.props.drawContour ? _luma.GL.LINES : _luma.GL.TRIANGLES
	        }),
	        vertexCount: 0,
	        isIndexed: true
	      });
	    }
	  }, {
	    key: 'calculateIndices',
	    value: function calculateIndices(attribute) {
	      var _this2 = this;
	
	      // adjust index offset for multiple choropleths
	      var offsets = this.state.choropleths.reduce(function (acc, choropleth) {
	        return [].concat(_toConsumableArray(acc), [acc[acc.length - 1] + choropleth.reduce(function (count, polygon) {
	          return count + polygon.length;
	        }, 0)]);
	      }, [0]);
	      var IndexType = this.state.IndexType;
	
	      if (IndexType === Uint16Array && offsets[offsets.length - 1] > 65535) {
	        throw new Error('Vertex count exceeds browser\'s limit');
	      }
	
	      var indices = this.state.choropleths.map(function (choropleth, choroplethIndex) {
	        return _this2.props.drawContour ?
	        // 1. get sequentially ordered indices of each choropleth contour
	        // 2. offset them by the number of indices in previous choropleths
	        calculateContourIndices(choropleth).map(function (index) {
	          return index + offsets[choroplethIndex];
	        }) :
	        // 1. get triangulated indices for the internal areas
	        // 2. offset them by the number of indices in previous choropleths
	        calculateSurfaceIndices(choropleth).map(function (index) {
	          return index + offsets[choroplethIndex];
	        });
	      });
	
	      attribute.value = new IndexType((0, _utils.flatten)(indices));
	      attribute.target = _luma.GL.ELEMENT_ARRAY_BUFFER;
	      this.state.model.setVertexCount(attribute.value.length / attribute.size);
	    }
	  }, {
	    key: 'calculatePositions',
	    value: function calculatePositions(attribute) {
	      var vertices = (0, _utils.flatten)(this.state.choropleths);
	      attribute.value = new Float32Array(vertices);
	    }
	  }, {
	    key: 'calculateColors',
	    value: function calculateColors(attribute) {
	      var _props = this.props,
	          data = _props.data,
	          getColor = _props.getColor;
	
	      var features = (0, _utils.get)(data, 'features');
	      var colors = this.state.choropleths.map(function (choropleth, choroplethIndex) {
	        var feature = (0, _utils.get)(features, choropleth.featureIndex);
	        var color = getColor(feature) || DEFAULT_COLOR;
	        // Ensure alpha is set
	        if (isNaN(color[3])) {
	          color[3] = DEFAULT_COLOR[3];
	        }
	        return choropleth.map(function (polygon) {
	          return polygon.map(function (vertex) {
	            return color;
	          });
	        });
	      });
	
	      attribute.value = new Uint8Array((0, _utils.flatten)(colors));
	    }
	
	    // Override the default picking colors calculation
	
	  }, {
	    key: 'calculatePickingColors',
	    value: function calculatePickingColors(attribute) {
	      var _this3 = this;
	
	      var colors = this.state.choropleths.map(function (choropleth, choroplethIndex) {
	        var featureIndex = choropleth.featureIndex;
	
	        var color = _this3.props.drawContour ? [0, 0, 0] : [(featureIndex + 1) % 256, Math.floor((featureIndex + 1) / 256) % 256, Math.floor((featureIndex + 1) / 256 / 256) % 256];
	        return choropleth.map(function (polygon) {
	          return polygon.map(function (vertex) {
	            return color;
	          });
	        });
	      });
	
	      attribute.value = new Uint8Array((0, _utils.flatten)(colors));
	    }
	  }]);
	
	  return ChoroplethLayer;
	}(_lib.Layer);
	
	exports.default = ChoroplethLayer;
	
	
	ChoroplethLayer.layerName = 'ChoroplethLayer';
	ChoroplethLayer.defaultProps = defaultProps;
	
	/*
	 * get vertex indices for drawing choropleth contour
	 * @param {[Number,Number,Number][][]} choropleth
	 * @returns {[Number]} indices
	 */
	function calculateContourIndices(choropleth) {
	  var offset = 0;
	
	  return choropleth.reduce(function (acc, polygon) {
	    var numVertices = polygon.length;
	
	    // use vertex pairs for gl.LINES => [0, 1, 1, 2, 2, ..., n-2, n-2, n-1]
	    var indices = [].concat(_toConsumableArray(acc), [offset]);
	    for (var i = 1; i < numVertices - 1; i++) {
	      indices.push(i + offset, i + offset);
	    }
	    indices.push(offset + numVertices - 1);
	
	    offset += numVertices;
	    return indices;
	  }, []);
	}
	
	/*
	 * get vertex indices for drawing choropleth mesh
	 * @param {[Number,Number,Number][][]} choropleth
	 * @returns {[Number]} indices
	 */
	function calculateSurfaceIndices(choropleth) {
	  var holes = null;
	
	  if (choropleth.length > 1) {
	    holes = choropleth.reduce(function (acc, polygon) {
	      return [].concat(_toConsumableArray(acc), [acc[acc.length - 1] + polygon.length]);
	    }, [0]).slice(1, choropleth.length);
	  }
	
	  return (0, _earcut2.default)((0, _utils.flatten)(choropleth), holes, 3);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* eslint-disable guard-for-in */
	
	
	exports.glArrayFromType = glArrayFromType;
	
	var _luma = __webpack_require__(29);
	
	var _utils = __webpack_require__(42);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LOG_START_END_PRIORITY = 1;
	var LOG_DETAIL_PRIORITY = 2;
	
	function noop() {}
	
	/* eslint-disable complexity */
	function glArrayFromType(glType) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$clamped = _ref.clamped,
	      clamped = _ref$clamped === undefined ? true : _ref$clamped;
	
	  // Sorted in some order of likelihood to reduce amount of comparisons
	  switch (glType) {
	    case _luma.GL.FLOAT:
	      return Float32Array;
	    case _luma.GL.UNSIGNED_SHORT:
	    case _luma.GL.UNSIGNED_SHORT_5_6_5:
	    case _luma.GL.UNSIGNED_SHORT_4_4_4_4:
	    case _luma.GL.UNSIGNED_SHORT_5_5_5_1:
	      return Uint16Array;
	    case _luma.GL.UNSIGNED_INT:
	      return Uint32Array;
	    case _luma.GL.UNSIGNED_BYTE:
	      return clamped ? Uint8ClampedArray : Uint8Array;
	    case _luma.GL.BYTE:
	      return Int8Array;
	    case _luma.GL.SHORT:
	      return Int16Array;
	    case _luma.GL.INT:
	      return Int32Array;
	    default:
	      throw new Error('Failed to deduce type from array');
	  }
	}
	/* eslint-enable complexity */
	
	// Default loggers
	var logFunctions = {
	  onUpdateStart: function onUpdateStart(_ref2) {
	    var level = _ref2.level,
	        id = _ref2.id;
	
	    _utils.log.time(level, 'Updated attributes for ' + id);
	  },
	  onLog: function onLog(_ref3) {
	    var level = _ref3.level,
	        message = _ref3.message;
	
	    _utils.log.log(level, message);
	  },
	  onUpdateEnd: function onUpdateEnd(_ref4) {
	    var level = _ref4.level,
	        id = _ref4.id;
	
	    _utils.log.timeEnd(level, 'Updated attributes for ' + id);
	  }
	};
	
	var AttributeManager = function () {
	  _createClass(AttributeManager, null, [{
	    key: 'setDefaultLogFunctions',
	
	    /**
	     * Sets log functions to help trace or time attribute updates.
	     * Default logging uses deck logger.
	     *
	     * `onLog` is called for each attribute.
	     *
	     * To enable detailed control of timming and e.g. hierarchical logging,
	     * hooks are also provided for update start and end.
	     *
	     * @param {Object} [opts]
	     * @param {String} [opts.onLog=] - called to print
	     * @param {String} [opts.onUpdateStart=] - called before update() starts
	     * @param {String} [opts.onUpdateEnd=] - called after update() ends
	     */
	    value: function setDefaultLogFunctions() {
	      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          onLog = _ref5.onLog,
	          onUpdateStart = _ref5.onUpdateStart,
	          onUpdateEnd = _ref5.onUpdateEnd;
	
	      if (onLog !== undefined) {
	        logFunctions.onLog = onLog || noop;
	      }
	      if (onUpdateStart !== undefined) {
	        logFunctions.onUpdateStart = onUpdateStart || noop;
	      }
	      if (onUpdateEnd !== undefined) {
	        logFunctions.onUpdateEnd = onUpdateEnd || noop;
	      }
	    }
	
	    /**
	     * @classdesc
	     * Automated attribute generation and management. Suitable when a set of
	     * vertex shader attributes are generated by iteration over a data array,
	     * and updates to these attributes are needed either when the data itself
	     * changes, or when other data relevant to the calculations change.
	     *
	     * - First the application registers descriptions of its dynamic vertex
	     *   attributes using AttributeManager.add().
	     * - Then, when any change that affects attributes is detected by the
	     *   application, the app will call AttributeManager.invalidate().
	     * - Finally before it renders, it calls AttributeManager.update() to
	     *   ensure that attributes are automatically rebuilt if anything has been
	     *   invalidated.
	     *
	     * The application provided update functions describe how attributes
	     * should be updated from a data array and are expected to traverse
	     * that data array (or iterable) and fill in the attribute's typed array.
	     *
	     * Note that the attribute manager intentionally does not do advanced
	     * change detection, but instead makes it easy to build such detection
	     * by offering the ability to "invalidate" each attribute separately.
	     *
	     * Summary:
	     * - keeps track of valid state for each attribute
	     * - auto reallocates attributes when needed
	     * - auto updates attributes with registered updater functions
	     * - allows overriding with application supplied buffers
	     *
	     * Limitations:
	     * - There are currently no provisions for only invalidating a range of
	     *   indices in an attribute.
	     *
	     * @class
	     * @param {Object} [props]
	     * @param {String} [props.id] - identifier (for debugging)
	     */
	
	  }]);
	
	  function AttributeManager() {
	    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref6$id = _ref6.id,
	        id = _ref6$id === undefined ? 'attribute-manager' : _ref6$id;
	
	    _classCallCheck(this, AttributeManager);
	
	    this.id = id;
	    this.attributes = {};
	    this.updateTriggers = {};
	    this.allocedInstances = -1;
	    this.needsRedraw = true;
	    this.userData = {};
	
	    // For debugging sanity, prevent uninitialized members
	    Object.seal(this);
	  }
	
	  /**
	   * Adds attributes
	   * Takes a map of attribute descriptor objects
	   * - keys are attribute names
	   * - values are objects with attribute fields
	   *
	   * attribute.size - number of elements per object
	   * attribute.updater - number of elements
	   * attribute.instanced=0 - is this is an instanced attribute (a.k.a. divisor)
	   * attribute.noAlloc=false - if this attribute should not be allocated
	   *
	   * @example
	   * attributeManager.add({
	   *   positions: {size: 2, update: calculatePositions}
	   *   colors: {size: 3, update: calculateColors}
	   * });
	   *
	   * @param {Object} attributes - attribute map (see above)
	   * @param {Object} updaters - separate map of update functions (deprecated)
	   */
	
	
	  _createClass(AttributeManager, [{
	    key: 'add',
	    value: function add(attributes) {
	      var updaters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._add(attributes, updaters);
	    }
	
	    /**
	      * Removes attributes
	      * Takes an array of attribute names and delete them from
	      * the attribute map if they exists
	      *
	      * @example
	      * attributeManager.remove(['position']);
	      *
	      * @param {Object} attributeNameArray - attribute name array (see above)
	      */
	
	  }, {
	    key: 'remove',
	    value: function remove(attributeNameArray) {
	      for (var i = 0; i < attributeNameArray.length; i++) {
	        var name = attributeNameArray[i];
	        if (this.attributes[name] !== undefined) {
	          delete this.attributes[name];
	        }
	      }
	    }
	
	    /* Marks an attribute for update
	     * @param {string} triggerName: attribute or accessor name
	     */
	
	  }, {
	    key: 'invalidate',
	    value: function invalidate(triggerName) {
	      var attributes = this.attributes,
	          updateTriggers = this.updateTriggers;
	
	      var attributesToUpdate = updateTriggers[triggerName];
	
	      if (!attributesToUpdate) {
	        var message = 'invalidating non-existent attribute ' + triggerName + ' for ' + this.id + '\n';
	        message += 'Valid attributes: ' + Object.keys(attributes).join(', ');
	        (0, _assert2.default)(attributesToUpdate, message);
	      }
	      attributesToUpdate.forEach(function (name) {
	        var attribute = attributes[name];
	        if (attribute) {
	          attribute.needsUpdate = true;
	        }
	      });
	      // For performance tuning
	      logFunctions.onLog({
	        level: LOG_DETAIL_PRIORITY,
	        message: 'invalidated attribute ' + attributesToUpdate + ' for ' + this.id,
	        id: this.identifier
	      });
	    }
	  }, {
	    key: 'invalidateAll',
	    value: function invalidateAll() {
	      var attributes = this.attributes;
	
	      for (var attributeName in attributes) {
	        this.invalidate(attributeName);
	      }
	    }
	
	    /**
	     * Ensure all attribute buffers are updated from props or data.
	     *
	     * Note: Any preallocated buffers in "buffers" matching registered attribute
	     * names will be used. No update will happen in this case.
	     * Note: Calls onUpdateStart and onUpdateEnd log callbacks before and after.
	     *
	     * @param {Object} opts - options
	     * @param {Object} opts.data - data (iterable object)
	     * @param {Object} opts.numInstances - count of data
	     * @param {Object} opts.buffers = {} - pre-allocated buffers
	     * @param {Object} opts.props - passed to updaters
	     * @param {Object} opts.context - Used as "this" context for updaters
	     */
	
	  }, {
	    key: 'update',
	    value: function update() {
	      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          data = _ref7.data,
	          numInstances = _ref7.numInstances,
	          _ref7$props = _ref7.props,
	          props = _ref7$props === undefined ? {} : _ref7$props,
	          _ref7$buffers = _ref7.buffers,
	          buffers = _ref7$buffers === undefined ? {} : _ref7$buffers,
	          _ref7$context = _ref7.context,
	          context = _ref7$context === undefined ? {} : _ref7$context,
	          _ref7$ignoreUnknownAt = _ref7.ignoreUnknownAttributes,
	          ignoreUnknownAttributes = _ref7$ignoreUnknownAt === undefined ? false : _ref7$ignoreUnknownAt;
	
	      // First apply any application provided buffers
	      this._checkExternalBuffers({ buffers: buffers, ignoreUnknownAttributes: ignoreUnknownAttributes });
	      this._setExternalBuffers(buffers);
	
	      // Only initiate alloc/update (and logging) if actually needed
	      if (this._analyzeBuffers({ numInstances: numInstances })) {
	        logFunctions.onUpdateStart({ level: LOG_START_END_PRIORITY, id: this.id });
	        this._updateBuffers({ numInstances: numInstances, data: data, props: props, context: context });
	        logFunctions.onUpdateEnd({ level: LOG_START_END_PRIORITY, id: this.id });
	      }
	    }
	
	    /**
	     * Returns all attribute descriptors
	     * Note: Format matches luma.gl Model/Program.setAttributes()
	     * @return {Object} attributes - descriptors
	     */
	
	  }, {
	    key: 'getAttributes',
	    value: function getAttributes() {
	      return this.attributes;
	    }
	
	    /**
	     * Returns changed attribute descriptors
	     * This indicates which WebGLBuggers need to be updated
	     * @return {Object} attributes - descriptors
	     */
	
	  }, {
	    key: 'getChangedAttributes',
	    value: function getChangedAttributes(_ref8) {
	      var _ref8$clearChangedFla = _ref8.clearChangedFlags,
	          clearChangedFlags = _ref8$clearChangedFla === undefined ? false : _ref8$clearChangedFla;
	      var attributes = this.attributes;
	
	      var changedAttributes = {};
	      for (var attributeName in attributes) {
	        var attribute = attributes[attributeName];
	        if (attribute.changed) {
	          attribute.changed = attribute.changed && !clearChangedFlags;
	          changedAttributes[attributeName] = attribute;
	        }
	      }
	      return changedAttributes;
	    }
	
	    /**
	     * Returns the redraw flag, optionally clearing it.
	     * Redraw flag will be set if any attributes attributes changed since
	     * flag was last cleared.
	     *
	     * @param {Object} [opts]
	     * @param {String} [opts.clearRedrawFlags=false] - whether to clear the flag
	     * @return {Boolean} - whether a redraw is needed.
	     */
	
	  }, {
	    key: 'getNeedsRedraw',
	    value: function getNeedsRedraw() {
	      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref9$clearRedrawFlag = _ref9.clearRedrawFlags,
	          clearRedrawFlags = _ref9$clearRedrawFlag === undefined ? false : _ref9$clearRedrawFlag;
	
	      var redraw = this.needsRedraw;
	      redraw = redraw || this.needsRedraw;
	      this.needsRedraw = this.needsRedraw && !clearRedrawFlags;
	      return redraw;
	    }
	
	    /**
	     * Sets the redraw flag.
	     * @param {Boolean} redraw=true
	     * @return {AttributeManager} - for chaining
	     */
	
	  }, {
	    key: 'setNeedsRedraw',
	    value: function setNeedsRedraw() {
	      var redraw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.needsRedraw = true;
	      return this;
	    }
	
	    // DEPRECATED METHODS
	
	    /**
	     * @deprecated since version 2.5, use add() instead
	     * Adds attributes
	     * @param {Object} attributes - attribute map (see above)
	     * @param {Object} updaters - separate map of update functions (deprecated)
	     */
	
	  }, {
	    key: 'addInstanced',
	    value: function addInstanced(attributes) {
	      var updaters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._add(attributes, updaters, { instanced: 1 });
	    }
	
	    // PRIVATE METHODS
	
	    // Used to register an attribute
	
	  }, {
	    key: '_add',
	    value: function _add(attributes) {
	      var updaters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var _extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var newAttributes = {};
	
	      for (var attributeName in attributes) {
	        // support for separate update function map
	        // For now, just copy any attributes from that map into the main map
	        // TODO - Attribute maps are a deprecated feature, remove
	        if (attributeName in updaters) {
	          attributes[attributeName] = Object.assign({}, attributes[attributeName], updaters[attributeName]);
	        }
	
	        var attribute = attributes[attributeName];
	
	        var isIndexed = attribute.isIndexed || attribute.elements;
	        var size = attribute.elements && 1 || attribute.size;
	        var value = attribute.value || null;
	
	        // Initialize the attribute descriptor, with WebGL and metadata fields
	        var attributeData = Object.assign({
	          // Ensure that fields are present before Object.seal()
	          target: undefined,
	          userData: {} // Reserved for application
	        },
	        // Metadata
	        attribute, {
	          // State
	          isExternalBuffer: false,
	          needsAlloc: false,
	          needsUpdate: false,
	          changed: false,
	
	          // Luma fields
	          isIndexed: isIndexed,
	          size: size,
	          value: value
	        }, _extraProps);
	        // Sanity - no app fields on our attributes. Use userData instead.
	        Object.seal(attributeData);
	
	        // Check all fields and generate helpful error messages
	        this._validateAttributeDefinition(attributeName, attributeData);
	
	        // Add to both attributes list (for registration with model)
	        newAttributes[attributeName] = attributeData;
	      }
	
	      Object.assign(this.attributes, newAttributes);
	
	      this._mapUpdateTriggersToAttributes();
	    }
	
	    // build updateTrigger name to attribute name mapping
	
	  }, {
	    key: '_mapUpdateTriggersToAttributes',
	    value: function _mapUpdateTriggersToAttributes() {
	      var _this = this;
	
	      var triggers = {};
	
	      var _loop = function _loop(attributeName) {
	        var attribute = _this.attributes[attributeName];
	        var accessor = attribute.accessor;
	
	        // use attribute name as update trigger key
	
	        triggers[attributeName] = [attributeName];
	
	        // use accessor name as update trigger key
	        if (typeof accessor === 'string') {
	          accessor = [accessor];
	        }
	        if (Array.isArray(accessor)) {
	          accessor.forEach(function (accessorName) {
	            if (!triggers[accessorName]) {
	              triggers[accessorName] = [];
	            }
	            triggers[accessorName].push(attributeName);
	          });
	        }
	      };
	
	      for (var attributeName in this.attributes) {
	        _loop(attributeName);
	      }
	
	      this.updateTriggers = triggers;
	    }
	  }, {
	    key: '_validateAttributeDefinition',
	    value: function _validateAttributeDefinition(attributeName, attribute) {
	      (0, _assert2.default)(attribute.size >= 1 && attribute.size <= 4, 'Attribute definition for ' + attributeName + ' invalid size');
	
	      // Check that either 'accessor' or 'update' is a valid function
	      var hasUpdater = attribute.noAlloc || typeof attribute.update === 'function' || typeof attribute.accessor === 'string';
	      if (!hasUpdater) {
	        throw new Error('Attribute ' + attributeName + ' missing update or accessor');
	      }
	    }
	
	    // Checks that any attribute buffers in props are valid
	    // Note: This is just to help app catch mistakes
	
	  }, {
	    key: '_checkExternalBuffers',
	    value: function _checkExternalBuffers() {
	      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref10$buffers = _ref10.buffers,
	          buffers = _ref10$buffers === undefined ? {} : _ref10$buffers,
	          _ref10$ignoreUnknownA = _ref10.ignoreUnknownAttributes,
	          ignoreUnknownAttributes = _ref10$ignoreUnknownA === undefined ? false : _ref10$ignoreUnknownA;
	
	      var attributes = this.attributes;
	
	      for (var attributeName in buffers) {
	        var attribute = attributes[attributeName];
	        if (!attribute && !ignoreUnknownAttributes) {
	          throw new Error('Unknown attribute prop ' + attributeName);
	        }
	        // const buffer = buffers[attributeName];
	        // TODO - check buffer type
	      }
	    }
	
	    // Set the buffers for the supplied attributes
	    // Update attribute buffers from any attributes in props
	    // Detach any previously set buffers, marking all
	    // Attributes for auto allocation
	    /* eslint-disable max-statements */
	
	  }, {
	    key: '_setExternalBuffers',
	    value: function _setExternalBuffers(bufferMap) {
	      var attributes = this.attributes,
	          numInstances = this.numInstances;
	
	      // Copy the refs of any supplied buffers in the props
	
	      for (var attributeName in attributes) {
	        var attribute = attributes[attributeName];
	        var buffer = bufferMap[attributeName];
	        attribute.isExternalBuffer = false;
	        if (buffer) {
	          if (!(buffer instanceof Float32Array)) {
	            throw new Error('Attribute properties must be of type Float32Array');
	          }
	          if (attribute.auto && buffer.length <= numInstances * attribute.size) {
	            throw new Error('Attribute prop array must match length and size');
	          }
	
	          attribute.isExternalBuffer = true;
	          attribute.needsUpdate = false;
	          if (attribute.value !== buffer) {
	            attribute.value = buffer;
	            attribute.changed = true;
	            this.needsRedraw = true;
	          }
	        }
	      }
	    }
	    /* eslint-enable max-statements */
	
	    /* Checks that typed arrays for attributes are big enough
	     * sets alloc flag if not
	     * @return {Boolean} whether any updates are needed
	     */
	
	  }, {
	    key: '_analyzeBuffers',
	    value: function _analyzeBuffers(_ref11) {
	      var numInstances = _ref11.numInstances;
	      var attributes = this.attributes;
	
	      (0, _assert2.default)(numInstances !== undefined, 'numInstances not defined');
	
	      // Track whether any allocations or updates are needed
	      var needsUpdate = false;
	
	      for (var attributeName in attributes) {
	        var attribute = attributes[attributeName];
	        if (!attribute.isExternalBuffer) {
	          // Do we need to reallocate the attribute's typed array?
	          var needsAlloc = attribute.value === null || attribute.value.length / attribute.size < numInstances;
	          if (needsAlloc && (attribute.update || attribute.accessor)) {
	            attribute.needsAlloc = true;
	            needsUpdate = true;
	          }
	          if (attribute.needsUpdate) {
	            needsUpdate = true;
	          }
	        }
	      }
	
	      return needsUpdate;
	    }
	
	    /**
	     * @private
	     * Calls update on any buffers that need update
	     * TODO? - If app supplied all attributes, no need to iterate over data
	     *
	     * @param {Object} opts - options
	     * @param {Object} opts.data - data (iterable object)
	     * @param {Object} opts.numInstances - count of data
	     * @param {Object} opts.buffers = {} - pre-allocated buffers
	     * @param {Object} opts.props - passed to updaters
	     * @param {Object} opts.context - Used as "this" context for updaters
	     */
	    /* eslint-disable max-statements, complexity */
	
	  }, {
	    key: '_updateBuffers',
	    value: function _updateBuffers(_ref12) {
	      var numInstances = _ref12.numInstances,
	          data = _ref12.data,
	          props = _ref12.props,
	          context = _ref12.context;
	      var attributes = this.attributes;
	
	      // Allocate at least one element to ensure a valid buffer
	
	      var allocCount = Math.max(numInstances, 1);
	
	      for (var attributeName in attributes) {
	        var attribute = attributes[attributeName];
	
	        // Allocate a new typed array if needed
	        if (attribute.needsAlloc) {
	          var ArrayType = glArrayFromType(attribute.type || _luma.GL.FLOAT);
	          attribute.value = new ArrayType(attribute.size * allocCount);
	          logFunctions.onLog({
	            level: LOG_DETAIL_PRIORITY,
	            message: this.id + ':' + attributeName + ' allocated ' + allocCount,
	            id: this.id
	          });
	          attribute.needsAlloc = false;
	          attribute.needsUpdate = true;
	        }
	
	        // Call updater function if needed
	        if (attribute.needsUpdate) {
	          this._updateBuffer({ attribute: attribute, attributeName: attributeName, numInstances: numInstances, data: data, props: props, context: context });
	        }
	      }
	
	      this.allocedInstances = allocCount;
	    }
	  }, {
	    key: '_updateBuffer',
	    value: function _updateBuffer(_ref13) {
	      var attribute = _ref13.attribute,
	          attributeName = _ref13.attributeName,
	          numInstances = _ref13.numInstances,
	          data = _ref13.data,
	          props = _ref13.props,
	          context = _ref13.context;
	      var update = attribute.update,
	          accessor = attribute.accessor;
	
	      if (update) {
	        // Custom updater - typically for non-instanced layers
	        logFunctions.onLog({
	          level: LOG_DETAIL_PRIORITY,
	          message: this.id + ':' + attributeName + ' updating ' + numInstances,
	          id: this.id
	        });
	        update.call(context, attribute, { data: data, props: props, numInstances: numInstances });
	        this._checkAttributeArray(attribute, attributeName);
	      } else if (accessor) {
	        // Standard updater
	        this._updateBufferViaStandardAccessor({ attribute: attribute, data: data, props: props });
	        this._checkAttributeArray(attribute, attributeName);
	      } else {
	        logFunctions.onLog({
	          level: LOG_DETAIL_PRIORITY,
	          message: this.id + ':' + attributeName + ' missing update function',
	          id: this.id
	        });
	      }
	
	      attribute.needsUpdate = false;
	      attribute.changed = true;
	      this.needsRedraw = true;
	    }
	    /* eslint-enable max-statements */
	
	  }, {
	    key: '_updateBufferViaStandardAccessor',
	    value: function _updateBufferViaStandardAccessor(_ref14) {
	      var attribute = _ref14.attribute,
	          data = _ref14.data,
	          props = _ref14.props;
	      var accessor = attribute.accessor,
	          value = attribute.value,
	          size = attribute.size;
	
	      var accessorFunc = props[accessor];
	
	      (0, _assert2.default)(typeof accessorFunc === 'function', 'accessor "' + accessor + '" is not a function');
	
	      var _attribute$defaultVal = attribute.defaultValue,
	          defaultValue = _attribute$defaultVal === undefined ? [0, 0, 0, 0] : _attribute$defaultVal;
	
	      defaultValue = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
	      var i = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var object = _step.value;
	
	          var objectValue = accessorFunc(object);
	          objectValue = Array.isArray(objectValue) ? objectValue : [objectValue];
	          /* eslint-disable no-fallthrough, default-case */
	          switch (size) {
	            case 4:
	              value[i + 3] = Number.isFinite(objectValue[3]) ? objectValue[3] : defaultValue[3];
	            case 3:
	              value[i + 2] = Number.isFinite(objectValue[2]) ? objectValue[2] : defaultValue[2];
	            case 2:
	              value[i + 1] = Number.isFinite(objectValue[1]) ? objectValue[1] : defaultValue[1];
	            case 1:
	              value[i + 0] = Number.isFinite(objectValue[0]) ? objectValue[0] : defaultValue[0];
	          }
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: '_checkAttributeArray',
	    value: function _checkAttributeArray(attribute, attributeName) {
	      var value = attribute.value;
	
	      if (value && value.length >= 4) {
	        var valid = Number.isFinite(value[0]) && Number.isFinite(value[1]) && Number.isFinite(value[2]) && Number.isFinite(value[3]);
	        if (!valid) {
	          throw new Error('Illegal attribute generated for ' + attributeName);
	        }
	      }
	    }
	  }]);
	
	  return AttributeManager;
	}();
	
	exports.default = AttributeManager;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 392 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.count = count;
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var ERR_NOT_OBJECT = 'count(): argument not an object';
	var ERR_NOT_CONTAINER = 'count(): argument not a container';
	
	/**
	 * Deduces numer of elements in a JavaScript container.
	 * - Auto-deduction for ES6 containers that define a count() method
	 * - Auto-deduction for ES6 containers that define a size member
	 * - Auto-deduction for Classic Arrays via the built-in length attribute
	 * - Also handles objects, although note that this an O(N) operation
	 */
	function count(container) {
	  if (!isObject(container)) {
	    throw new Error(ERR_NOT_OBJECT);
	  }
	
	  // Check if ES6 collection "count" function is available
	  if (typeof container.count === 'function') {
	    return container.count();
	  }
	
	  // Check if ES6 collection "size" attribute is set
	  if (Number.isFinite(container.size)) {
	    return container.size;
	  }
	
	  // Check if array length attribute is set
	  // Note: checking this last since some ES6 collections (Immutable.js)
	  // emit profuse warnings when trying to access `length` attribute
	  if (Number.isFinite(container.length)) {
	    return container.length;
	  }
	
	  // Note that getting the count of an object is O(N)
	  if (isPlainObject(container)) {
	    var counter = 0;
	    for (var key in container) {
	      // eslint-disable-line
	      counter++;
	    }
	    return counter;
	  }
	
	  throw new Error(ERR_NOT_CONTAINER);
	}
	
	/**
	 * Checks if argument is a plain object (not a class or array etc)
	 * @param {*} value - JavaScript value to be tested
	 * @return {Boolean} - true if argument is a plain JavaScript object
	 */
	function isPlainObject(value) {
	  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Object;
	}
	
	/**
	 * Checks if argument is an indexable object (not a primitive value, nor null)
	 * @param {*} value - JavaScript value to be tested
	 * @return {Boolean} - true if argument is a JavaScript object
	 */
	function isObject(value) {
	  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _viewport = __webpack_require__(147);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _glMatrix = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var OrthographicViewport = function (_Viewport) {
	  _inherits(OrthographicViewport, _Viewport);
	
	  function OrthographicViewport(_ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        _ref$eye = _ref.eye,
	        eye = _ref$eye === undefined ? [0, 0, 1] : _ref$eye,
	        _ref$lookAt = _ref.lookAt,
	        lookAt = _ref$lookAt === undefined ? [0, 0, 0] : _ref$lookAt,
	        _ref$up = _ref.up,
	        up = _ref$up === undefined ? [0, 1, 0] : _ref$up,
	        _ref$near = _ref.near,
	        near = _ref$near === undefined ? 1 : _ref$near,
	        _ref$far = _ref.far,
	        far = _ref$far === undefined ? 100 : _ref$far,
	        left = _ref.left,
	        top = _ref.top,
	        _ref$right = _ref.right,
	        right = _ref$right === undefined ? null : _ref$right,
	        _ref$bottom = _ref.bottom,
	        bottom = _ref$bottom === undefined ? null : _ref$bottom;
	
	    _classCallCheck(this, OrthographicViewport);
	
	    right = Number.isFinite(right) ? right : left + width;
	    bottom = Number.isFinite(bottom) ? bottom : top + height;
	    return _possibleConstructorReturn(this, (OrthographicViewport.__proto__ || Object.getPrototypeOf(OrthographicViewport)).call(this, {
	      viewMatrix: _glMatrix.mat4.lookAt([], eye, lookAt, up),
	      projectionMatrix: _glMatrix.mat4.ortho([], left, right, bottom, top, near, far),
	      width: width,
	      height: height
	    }));
	  }
	
	  return OrthographicViewport;
	}(_viewport2.default);
	
	exports.default = OrthographicViewport;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _viewport = __webpack_require__(147);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _glMatrix = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEGREES_TO_RADIANS = Math.PI / 180;
	
	var PerspectiveViewport = function (_Viewport) {
	  _inherits(PerspectiveViewport, _Viewport);
	
	  function PerspectiveViewport(_ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        eye = _ref.eye,
	        _ref$lookAt = _ref.lookAt,
	        lookAt = _ref$lookAt === undefined ? [0, 0, 0] : _ref$lookAt,
	        _ref$up = _ref.up,
	        up = _ref$up === undefined ? [0, 1, 0] : _ref$up,
	        _ref$fovy = _ref.fovy,
	        fovy = _ref$fovy === undefined ? 75 : _ref$fovy,
	        _ref$near = _ref.near,
	        near = _ref$near === undefined ? 1 : _ref$near,
	        _ref$far = _ref.far,
	        far = _ref$far === undefined ? 100 : _ref$far,
	        _ref$aspect = _ref.aspect,
	        aspect = _ref$aspect === undefined ? null : _ref$aspect;
	
	    _classCallCheck(this, PerspectiveViewport);
	
	    var fovyRadians = fovy * DEGREES_TO_RADIANS;
	    aspect = Number.isFinite(aspect) ? aspect : width / height;
	    return _possibleConstructorReturn(this, (PerspectiveViewport.__proto__ || Object.getPrototypeOf(PerspectiveViewport)).call(this, {
	      viewMatrix: _glMatrix.mat4.lookAt([], eye, lookAt, up),
	      projectionMatrix: _glMatrix.mat4.perspective([], fovyRadians, aspect, near, far),
	      width: width,
	      height: height
	    }));
	  }
	
	  return PerspectiveViewport;
	}(_viewport2.default);
	
	exports.default = PerspectiveViewport;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvdmlld3BvcnRzL3BlcnNwZWN0aXZlLXZpZXdwb3J0LmpzIl0sIm5hbWVzIjpbIkRFR1JFRVNfVE9fUkFESUFOUyIsIk1hdGgiLCJQSSIsIlBlcnNwZWN0aXZlVmlld3BvcnQiLCJ3aWR0aCIsImhlaWdodCIsImV5ZSIsImxvb2tBdCIsInVwIiwiZm92eSIsIm5lYXIiLCJmYXIiLCJhc3BlY3QiLCJmb3Z5UmFkaWFucyIsIk51bWJlciIsImlzRmluaXRlIiwidmlld01hdHJpeCIsInByb2plY3Rpb25NYXRyaXgiLCJwZXJzcGVjdGl2ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBb0JBOzs7O0FBQ0E7Ozs7Ozs7OytlQXJCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUFLQSxJQUFNQSxxQkFBcUJDLEtBQUtDLEVBQUwsR0FBVSxHQUFyQzs7SUFFcUJDLG1COzs7QUFDbkIscUNBY0c7QUFBQSxRQVpEQyxLQVlDLFFBWkRBLEtBWUM7QUFBQSxRQVhEQyxNQVdDLFFBWERBLE1BV0M7QUFBQSxRQVREQyxHQVNDLFFBVERBLEdBU0M7QUFBQSwyQkFSREMsTUFRQztBQUFBLFFBUkRBLE1BUUMsK0JBUlEsQ0FBQyxDQUFELEVBQUksQ0FBSixFQUFPLENBQVAsQ0FRUjtBQUFBLHVCQVBEQyxFQU9DO0FBQUEsUUFQREEsRUFPQywyQkFQSSxDQUFDLENBQUQsRUFBSSxDQUFKLEVBQU8sQ0FBUCxDQU9KO0FBQUEseUJBTERDLElBS0M7QUFBQSxRQUxEQSxJQUtDLDZCQUxNLEVBS047QUFBQSx5QkFKREMsSUFJQztBQUFBLFFBSkRBLElBSUMsNkJBSk0sQ0FJTjtBQUFBLHdCQUhEQyxHQUdDO0FBQUEsUUFIREEsR0FHQyw0QkFISyxHQUdMO0FBQUEsMkJBRERDLE1BQ0M7QUFBQSxRQUREQSxNQUNDLCtCQURRLElBQ1I7O0FBQUE7O0FBQ0QsUUFBTUMsY0FBY0osT0FBT1Qsa0JBQTNCO0FBQ0FZLGFBQVNFLE9BQU9DLFFBQVAsQ0FBZ0JILE1BQWhCLElBQTBCQSxNQUExQixHQUFtQ1IsUUFBUUMsTUFBcEQ7QUFGQyxxSUFHSztBQUNKVyxrQkFBWSxlQUFLVCxNQUFMLENBQVksRUFBWixFQUFnQkQsR0FBaEIsRUFBcUJDLE1BQXJCLEVBQTZCQyxFQUE3QixDQURSO0FBRUpTLHdCQUFrQixlQUFLQyxXQUFMLENBQWlCLEVBQWpCLEVBQXFCTCxXQUFyQixFQUFrQ0QsTUFBbEMsRUFBMENGLElBQTFDLEVBQWdEQyxHQUFoRCxDQUZkO0FBR0pQLGtCQUhJO0FBSUpDO0FBSkksS0FITDtBQVNGOzs7OztrQkF4QmtCRixtQiIsImZpbGUiOiJwZXJzcGVjdGl2ZS12aWV3cG9ydC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvcHlyaWdodCAoYykgMjAxNSAtIDIwMTcgVWJlciBUZWNobm9sb2dpZXMsIEluYy5cbi8vXG4vLyBQZXJtaXNzaW9uIGlzIGhlcmVieSBncmFudGVkLCBmcmVlIG9mIGNoYXJnZSwgdG8gYW55IHBlcnNvbiBvYnRhaW5pbmcgYSBjb3B5XG4vLyBvZiB0aGlzIHNvZnR3YXJlIGFuZCBhc3NvY2lhdGVkIGRvY3VtZW50YXRpb24gZmlsZXMgKHRoZSBcIlNvZnR3YXJlXCIpLCB0byBkZWFsXG4vLyBpbiB0aGUgU29mdHdhcmUgd2l0aG91dCByZXN0cmljdGlvbiwgaW5jbHVkaW5nIHdpdGhvdXQgbGltaXRhdGlvbiB0aGUgcmlnaHRzXG4vLyB0byB1c2UsIGNvcHksIG1vZGlmeSwgbWVyZ2UsIHB1Ymxpc2gsIGRpc3RyaWJ1dGUsIHN1YmxpY2Vuc2UsIGFuZC9vciBzZWxsXG4vLyBjb3BpZXMgb2YgdGhlIFNvZnR3YXJlLCBhbmQgdG8gcGVybWl0IHBlcnNvbnMgdG8gd2hvbSB0aGUgU29mdHdhcmUgaXNcbi8vIGZ1cm5pc2hlZCB0byBkbyBzbywgc3ViamVjdCB0byB0aGUgZm9sbG93aW5nIGNvbmRpdGlvbnM6XG4vL1xuLy8gVGhlIGFib3ZlIGNvcHlyaWdodCBub3RpY2UgYW5kIHRoaXMgcGVybWlzc2lvbiBub3RpY2Ugc2hhbGwgYmUgaW5jbHVkZWQgaW5cbi8vIGFsbCBjb3BpZXMgb3Igc3Vic3RhbnRpYWwgcG9ydGlvbnMgb2YgdGhlIFNvZnR3YXJlLlxuLy9cbi8vIFRIRSBTT0ZUV0FSRSBJUyBQUk9WSURFRCBcIkFTIElTXCIsIFdJVEhPVVQgV0FSUkFOVFkgT0YgQU5ZIEtJTkQsIEVYUFJFU1MgT1Jcbi8vIElNUExJRUQsIElOQ0xVRElORyBCVVQgTk9UIExJTUlURUQgVE8gVEhFIFdBUlJBTlRJRVMgT0YgTUVSQ0hBTlRBQklMSVRZLFxuLy8gRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UgQU5EIE5PTklORlJJTkdFTUVOVC4gSU4gTk8gRVZFTlQgU0hBTEwgVEhFXG4vLyBBVVRIT1JTIE9SIENPUFlSSUdIVCBIT0xERVJTIEJFIExJQUJMRSBGT1IgQU5ZIENMQUlNLCBEQU1BR0VTIE9SIE9USEVSXG4vLyBMSUFCSUxJVFksIFdIRVRIRVIgSU4gQU4gQUNUSU9OIE9GIENPTlRSQUNULCBUT1JUIE9SIE9USEVSV0lTRSwgQVJJU0lORyBGUk9NLFxuLy8gT1VUIE9GIE9SIElOIENPTk5FQ1RJT04gV0lUSCBUSEUgU09GVFdBUkUgT1IgVEhFIFVTRSBPUiBPVEhFUiBERUFMSU5HUyBJTlxuLy8gVEhFIFNPRlRXQVJFLlxuXG5pbXBvcnQgVmlld3BvcnQgZnJvbSAnLi92aWV3cG9ydCc7XG5pbXBvcnQge21hdDR9IGZyb20gJ2dsLW1hdHJpeCc7XG5cbmNvbnN0IERFR1JFRVNfVE9fUkFESUFOUyA9IE1hdGguUEkgLyAxODA7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFBlcnNwZWN0aXZlVmlld3BvcnQgZXh0ZW5kcyBWaWV3cG9ydCB7XG4gIGNvbnN0cnVjdG9yKHtcbiAgICAvLyB2aWV3cG9ydCBhcmd1bWVudHNcbiAgICB3aWR0aCwgLy8gV2lkdGggb2Ygdmlld3BvcnRcbiAgICBoZWlnaHQsIC8vIEhlaWdodCBvZiB2aWV3cG9ydFxuICAgIC8vIHZpZXcgbWF0cml4IGFyZ3VtZW50c1xuICAgIGV5ZSwgLy8gRGVmaW5lcyBleWUgcG9zaXRpb25cbiAgICBsb29rQXQgPSBbMCwgMCwgMF0sIC8vIFdoaWNoIHBvaW50IGlzIGNhbWVyYSBsb29raW5nIGF0LCBkZWZhdWx0IG9yaWdpblxuICAgIHVwID0gWzAsIDEsIDBdLCAvLyBEZWZpbmVzIHVwIGRpcmVjdGlvbiwgZGVmYXVsdCBwb3NpdGl2ZSB5IGF4aXNcbiAgICAvLyBwcm9qZWN0aW9uIG1hdHJpeCBhcmd1bWVudHNcbiAgICBmb3Z5ID0gNzUsIC8vIEZpZWxkIG9mIHZpZXcgY292ZXJlZCBieSBjYW1lcmFcbiAgICBuZWFyID0gMSwgLy8gRGlzdGFuY2Ugb2YgbmVhciBjbGlwcGluZyBwbGFuZVxuICAgIGZhciA9IDEwMCwgLy8gRGlzdGFuY2Ugb2YgZmFyIGNsaXBwaW5nIHBsYW5lXG4gICAgLy8gYXV0b21hdGljYWxseSBjYWxjdWxhdGVkXG4gICAgYXNwZWN0ID0gbnVsbCAvLyBBc3BlY3QgcmF0aW8gKHNldCB0byB2aWV3cG9ydCB3aWRodC9oZWlnaHQpXG4gIH0pIHtcbiAgICBjb25zdCBmb3Z5UmFkaWFucyA9IGZvdnkgKiBERUdSRUVTX1RPX1JBRElBTlM7XG4gICAgYXNwZWN0ID0gTnVtYmVyLmlzRmluaXRlKGFzcGVjdCkgPyBhc3BlY3QgOiB3aWR0aCAvIGhlaWdodDtcbiAgICBzdXBlcih7XG4gICAgICB2aWV3TWF0cml4OiBtYXQ0Lmxvb2tBdChbXSwgZXllLCBsb29rQXQsIHVwKSxcbiAgICAgIHByb2plY3Rpb25NYXRyaXg6IG1hdDQucGVyc3BlY3RpdmUoW10sIGZvdnlSYWRpYW5zLCBhc3BlY3QsIG5lYXIsIGZhciksXG4gICAgICB3aWR0aCxcbiAgICAgIGhlaWdodFxuICAgIH0pO1xuICB9XG59XG4iXX0=

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getFov = getFov;
	exports.getClippingPlanes = getClippingPlanes;
	exports.makeProjectionMatrixFromMercatorParams = makeProjectionMatrixFromMercatorParams;
	
	var _viewport = __webpack_require__(147);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _glMatrix = __webpack_require__(55);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// View and Projection Matrix calculations for mapbox-js style
	// map view properties
	
	
	// CONSTANTS
	var PI = Math.PI;
	var PI_4 = PI / 4;
	var DEGREES_TO_RADIANS = PI / 180;
	var RADIANS_TO_DEGREES = 180 / PI;
	var TILE_SIZE = 512;
	var WORLD_SCALE = TILE_SIZE;
	
	var DEFAULT_MAP_STATE = {
	  latitude: 37,
	  longitude: -122,
	  zoom: 11,
	  pitch: 0,
	  bearing: 0,
	  altitude: 1.5
	};
	
	var ERR_ARGUMENT = 'Illegal argument to WebMercatorViewport';
	
	var WebMercatorViewport = function (_Viewport) {
	  _inherits(WebMercatorViewport, _Viewport);
	
	  /**
	   * @classdesc
	   * Creates view/projection matrices from mercator params
	   * Note: The Viewport is immutable in the sense that it only has accessors.
	   * A new viewport instance should be created if any parameters have changed.
	   *
	   * @class
	   * @param {Object} opt - options
	   * @param {Boolean} mercator=true - Whether to use mercator projection
	   *
	   * @param {Number} opt.width=1 - Width of "viewport" or window
	   * @param {Number} opt.height=1 - Height of "viewport" or window
	   * @param {Array} opt.center=[0, 0] - Center of viewport
	   *   [longitude, latitude] or [x, y]
	   * @param {Number} opt.scale=1 - Either use scale or zoom
	   * @param {Number} opt.pitch=0 - Camera angle in degrees (0 is straight down)
	   * @param {Number} opt.bearing=0 - Map rotation in degrees (0 means north is up)
	   * @param {Number} opt.altitude= - Altitude of camera in screen units
	   *
	   * Web mercator projection short-hand parameters
	   * @param {Number} opt.latitude - Center of viewport on map (alternative to opt.center)
	   * @param {Number} opt.longitude - Center of viewport on map (alternative to opt.center)
	   * @param {Number} opt.zoom - Scale = Math.pow(2,zoom) on map (alternative to opt.scale)
	    * Notes:
	   *  - Only one of center or [latitude, longitude] can be specified
	   *  - [latitude, longitude] can only be specified when "mercator" is true
	   *  - Altitude has a default value that matches assumptions in mapbox-gl
	   *  - width and height are forced to 1 if supplied as 0, to avoid
	   *    division by zero. This is intended to reduce the burden of apps to
	   *    to check values before instantiating a Viewport.
	   */
	  /* eslint-disable complexity, max-statements */
	  function WebMercatorViewport() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        width = _ref.width,
	        height = _ref.height,
	        latitude = _ref.latitude,
	        longitude = _ref.longitude,
	        zoom = _ref.zoom,
	        pitch = _ref.pitch,
	        bearing = _ref.bearing,
	        altitude = _ref.altitude,
	        _ref$farZMultiplier = _ref.farZMultiplier,
	        farZMultiplier = _ref$farZMultiplier === undefined ? 10 : _ref$farZMultiplier;
	
	    _classCallCheck(this, WebMercatorViewport);
	
	    // Viewport - support undefined arguments
	    width = width !== undefined ? width : DEFAULT_MAP_STATE.width;
	    height = height !== undefined ? height : DEFAULT_MAP_STATE.height;
	    zoom = zoom !== undefined ? zoom : DEFAULT_MAP_STATE.zoom;
	    latitude = latitude !== undefined ? latitude : DEFAULT_MAP_STATE.latitude;
	    longitude = longitude !== undefined ? longitude : DEFAULT_MAP_STATE.longitude;
	    bearing = bearing !== undefined ? bearing : DEFAULT_MAP_STATE.bearing;
	    pitch = pitch !== undefined ? pitch : DEFAULT_MAP_STATE.pitch;
	    altitude = altitude !== undefined ? altitude : DEFAULT_MAP_STATE.altitude;
	
	    // Silently allow apps to send in 0,0 to facilitate isomorphic render etc
	    width = width || 1;
	    height = height || 1;
	
	    var scale = Math.pow(2, zoom);
	    // Altitude - prevent division by 0
	    // TODO - just throw an Error instead?
	    altitude = Math.max(0.75, altitude);
	
	    var distanceScales = calculateDistanceScales({ latitude: latitude, longitude: longitude, scale: scale });
	
	    var projectionMatrix = makeProjectionMatrixFromMercatorParams({
	      width: width,
	      height: height,
	      pitch: pitch,
	      bearing: bearing,
	      altitude: altitude,
	      farZMultiplier: farZMultiplier
	    });
	
	    // The uncentered matrix allows us two move the center addition to the
	    // shader (cheap) which gives a coordinate system that has its center in
	    // the layer's center position. This makes rotations and other modelMatrx
	    // transforms much more useful.
	    var viewMatrixUncentered = makeUncenteredViewMatrixFromMercatorParams({
	      width: width,
	      height: height,
	      longitude: longitude,
	      latitude: latitude,
	      zoom: zoom,
	      pitch: pitch,
	      bearing: bearing,
	      altitude: altitude,
	      distanceScales: distanceScales
	    });
	
	    // Make a centered version of the matrix for projection modes without an offset
	    var center = projectFlat([longitude, latitude], scale);
	
	    var viewMatrix = _glMatrix.mat4.translate((0, _viewport.createMat4)(), viewMatrixUncentered, [-center[0], -center[1], 0]);
	
	    // Save parameters
	    var _this = _possibleConstructorReturn(this, (WebMercatorViewport.__proto__ || Object.getPrototypeOf(WebMercatorViewport)).call(this, { width: width, height: height, viewMatrix: viewMatrix, projectionMatrix: projectionMatrix }));
	
	    _this.latitude = latitude;
	    _this.longitude = longitude;
	    _this.zoom = zoom;
	    _this.pitch = pitch;
	    _this.bearing = bearing;
	    _this.altitude = altitude;
	
	    // Save calculated values
	    _this.scale = scale;
	    _this.center = center;
	    _this.viewMatrixUncentered = viewMatrixUncentered;
	    _this._distanceScales = distanceScales;
	
	    // Bind methods
	    _this.getDistanceScales = _this.getDistanceScales.bind(_this);
	    _this.metersToLngLatDelta = _this.metersToLngLatDelta.bind(_this);
	    _this.lngLatDeltaToMeters = _this.lngLatDeltaToMeters.bind(_this);
	    _this.addMetersToLngLat = _this.addMetersToLngLat.bind(_this);
	
	    Object.freeze(_this);
	    return _this;
	  }
	  /* eslint-enable complexity, max-statements */
	
	  /**
	   * Project [lng,lat] on sphere onto [x,y] on 512*512 Mercator Zoom 0 tile.
	   * Performs the nonlinear part of the web mercator projection.
	   * Remaining projection is done with 4x4 matrices which also handles
	   * perspective.
	   *
	   * @param {Array} lngLat - [lng, lat] coordinates
	   *   Specifies a point on the sphere to project onto the map.
	   * @return {Array} [x,y] coordinates.
	   */
	
	
	  _createClass(WebMercatorViewport, [{
	    key: '_projectFlat',
	    value: function _projectFlat(lngLat) {
	      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scale;
	
	      return projectFlat(lngLat, scale);
	    }
	
	    /**
	     * Unproject world point [x,y] on map onto {lat, lon} on sphere
	     *
	     * @param {object|Vector} xy - object with {x,y} members
	     *  representing point on projected map plane
	     * @return {GeoCoordinates} - object with {lat,lon} of point on sphere.
	     *   Has toArray method if you need a GeoJSON Array.
	     *   Per cartographic tradition, lat and lon are specified as degrees.
	     */
	
	  }, {
	    key: '_unprojectFlat',
	    value: function _unprojectFlat(xy) {
	      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scale;
	
	      return unprojectFlat(xy, scale);
	    }
	  }, {
	    key: 'getLocationAtPoint',
	    value: function getLocationAtPoint(_ref2) {
	      var lngLat = _ref2.lngLat,
	          pos = _ref2.pos;
	
	      var c = this.project(lngLat, { topLeft: false });
	      var coordCenter = this.project([this.longitude, this.latitude], { topLeft: false });
	      var coordAtPoint = pos;
	      var translate = _glMatrix.vec2.sub([], coordAtPoint, c);
	      var newPos = _glMatrix.vec2.sub([], coordCenter, translate);
	      var newLngLat = this.unproject(newPos, { topLeft: false });
	
	      return newLngLat;
	    }
	
	    /*
	    getLngLatAtViewportPosition(lnglat, xy) {
	      const c = this.locationCoordinate(lnglat);
	      const coordAtPoint = this.pointCoordinate(xy);
	      const coordCenter = this.pointCoordinate(this.centerPoint);
	      const translate = coordAtPoint._sub(c);
	      this.center = this.coordinateLocation(coordCenter._sub(translate));
	    }
	    */
	
	  }, {
	    key: 'getDistanceScales',
	    value: function getDistanceScales() {
	      return this._distanceScales;
	    }
	
	    /**
	     * Converts a meter offset to a lnglat offset
	     *
	     * Note: Uses simple linear approximation around the viewport center
	     * Error increases with size of offset (roughly 1% per 100km)
	     *
	     * @param {[Number,Number]|[Number,Number,Number]) xyz - array of meter deltas
	     * @return {[Number,Number]|[Number,Number,Number]) - array of [lng,lat,z] deltas
	     */
	
	  }, {
	    key: 'metersToLngLatDelta',
	    value: function metersToLngLatDelta(xyz) {
	      var _xyz = _slicedToArray(xyz, 3),
	          x = _xyz[0],
	          y = _xyz[1],
	          _xyz$ = _xyz[2],
	          z = _xyz$ === undefined ? 0 : _xyz$;
	
	      (0, _assert2.default)(Number.isFinite(x) && Number.isFinite(y) && Number.isFinite(z), ERR_ARGUMENT);
	      var _distanceScales = this._distanceScales,
	          pixelsPerMeter = _distanceScales.pixelsPerMeter,
	          degreesPerPixel = _distanceScales.degreesPerPixel;
	
	      var deltaLng = x * pixelsPerMeter[0] * degreesPerPixel[0];
	      var deltaLat = y * pixelsPerMeter[1] * degreesPerPixel[1];
	      return xyz.length === 2 ? [deltaLng, deltaLat] : [deltaLng, deltaLat, z];
	    }
	
	    /**
	     * Converts a lnglat offset to a meter offset
	     *
	     * Note: Uses simple linear approximation around the viewport center
	     * Error increases with size of offset (roughly 1% per 100km)
	     *
	     * @param {[Number,Number]|[Number,Number,Number]) deltaLngLatZ - array of [lng,lat,z] deltas
	     * @return {[Number,Number]|[Number,Number,Number]) - array of meter deltas
	     */
	
	  }, {
	    key: 'lngLatDeltaToMeters',
	    value: function lngLatDeltaToMeters(deltaLngLatZ) {
	      var _deltaLngLatZ = _slicedToArray(deltaLngLatZ, 3),
	          deltaLng = _deltaLngLatZ[0],
	          deltaLat = _deltaLngLatZ[1],
	          _deltaLngLatZ$ = _deltaLngLatZ[2],
	          deltaZ = _deltaLngLatZ$ === undefined ? 0 : _deltaLngLatZ$;
	
	      (0, _assert2.default)(Number.isFinite(deltaLng) && Number.isFinite(deltaLat) && Number.isFinite(deltaZ), ERR_ARGUMENT);
	      var _distanceScales2 = this._distanceScales,
	          pixelsPerDegree = _distanceScales2.pixelsPerDegree,
	          metersPerPixel = _distanceScales2.metersPerPixel;
	
	      var deltaX = deltaLng * pixelsPerDegree[0] * metersPerPixel[0];
	      var deltaY = deltaLat * pixelsPerDegree[1] * metersPerPixel[1];
	      return deltaLngLatZ.length === 2 ? [deltaX, deltaY] : [deltaX, deltaY, deltaZ];
	    }
	
	    /**
	     * Add a meter delta to a base lnglat coordinate, returning a new lnglat array
	     *
	     * Note: Uses simple linear approximation around the viewport center
	     * Error increases with size of offset (roughly 1% per 100km)
	     *
	     * @param {[Number,Number]|[Number,Number,Number]) lngLatZ - base coordinate
	     * @param {[Number,Number]|[Number,Number,Number]) xyz - array of meter deltas
	     * @return {[Number,Number]|[Number,Number,Number]) array of [lng,lat,z] deltas
	     */
	
	  }, {
	    key: 'addMetersToLngLat',
	    value: function addMetersToLngLat(lngLatZ, xyz) {
	      var _lngLatZ = _slicedToArray(lngLatZ, 3),
	          lng = _lngLatZ[0],
	          lat = _lngLatZ[1],
	          _lngLatZ$ = _lngLatZ[2],
	          Z = _lngLatZ$ === undefined ? 0 : _lngLatZ$;
	
	      var _metersToLngLatDelta = this.metersToLngLatDelta(xyz),
	          _metersToLngLatDelta2 = _slicedToArray(_metersToLngLatDelta, 3),
	          deltaLng = _metersToLngLatDelta2[0],
	          deltaLat = _metersToLngLatDelta2[1],
	          _metersToLngLatDelta3 = _metersToLngLatDelta2[2],
	          deltaZ = _metersToLngLatDelta3 === undefined ? 0 : _metersToLngLatDelta3;
	
	      return lngLatZ.length === 2 ? [lng + deltaLng, lat + deltaLat] : [lng + deltaLng, lat + deltaLat, Z + deltaZ];
	    }
	
	    // INTERNAL METHODS
	
	  }, {
	    key: '_getParams',
	    value: function _getParams() {
	      return this._distanceScales;
	    }
	  }]);
	
	  return WebMercatorViewport;
	}(_viewport2.default);
	
	/**
	 * Project [lng,lat] on sphere onto [x,y] on 512*512 Mercator Zoom 0 tile.
	 * Performs the nonlinear part of the web mercator projection.
	 * Remaining projection is done with 4x4 matrices which also handles
	 * perspective.
	 *
	 * @param {Array} lngLat - [lng, lat] coordinates
	 *   Specifies a point on the sphere to project onto the map.
	 * @return {Array} [x,y] coordinates.
	 */
	
	
	exports.default = WebMercatorViewport;
	function projectFlat(_ref3, scale) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      lng = _ref4[0],
	      lat = _ref4[1];
	
	  scale = scale * WORLD_SCALE;
	  var lambda2 = lng * DEGREES_TO_RADIANS;
	  var phi2 = lat * DEGREES_TO_RADIANS;
	  var x = scale * (lambda2 + PI) / (2 * PI);
	  var y = scale * (PI - Math.log(Math.tan(PI_4 + phi2 * 0.5))) / (2 * PI);
	  return [x, y];
	}
	
	/**
	 * Unproject world point [x,y] on map onto {lat, lon} on sphere
	 *
	 * @param {object|Vector} xy - object with {x,y} members
	 *  representing point on projected map plane
	 * @return {GeoCoordinates} - object with {lat,lon} of point on sphere.
	 *   Has toArray method if you need a GeoJSON Array.
	 *   Per cartographic tradition, lat and lon are specified as degrees.
	 */
	function unprojectFlat(_ref5, scale) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      x = _ref6[0],
	      y = _ref6[1];
	
	  scale = scale * WORLD_SCALE;
	  var lambda2 = x / scale * (2 * PI) - PI;
	  var phi2 = 2 * (Math.atan(Math.exp(PI - y / scale * (2 * PI))) - PI_4);
	  return [lambda2 * RADIANS_TO_DEGREES, phi2 * RADIANS_TO_DEGREES];
	}
	
	/**
	 * Calculate distance scales in meters around current lat/lon, both for
	 * degrees and pixels.
	 * In mercator projection mode, the distance scales vary significantly
	 * with latitude.
	 */
	function calculateDistanceScales(_ref7) {
	  var latitude = _ref7.latitude,
	      longitude = _ref7.longitude,
	      scale = _ref7.scale;
	
	  (0, _assert2.default)(!isNaN(latitude) && !isNaN(longitude) && !isNaN(scale), ERR_ARGUMENT);
	  // Approximately 111km per degree at equator
	  var METERS_PER_DEGREE = 111000;
	
	  var latCosine = Math.cos(latitude * Math.PI / 180);
	
	  var metersPerDegree = METERS_PER_DEGREE * latCosine;
	
	  // Calculate number of pixels occupied by one degree longitude
	  // around current lat/lon
	  var pixelsPerDegreeX = _glMatrix.vec2.distance(projectFlat([longitude + 0.5, latitude], scale), projectFlat([longitude - 0.5, latitude], scale));
	  // Calculate number of pixels occupied by one degree latitude
	  // around current lat/lon
	  var pixelsPerDegreeY = _glMatrix.vec2.distance(projectFlat([longitude, latitude + 0.5], scale), projectFlat([longitude, latitude - 0.5], scale));
	
	  var pixelsPerMeterX = pixelsPerDegreeX / metersPerDegree;
	  var pixelsPerMeterY = pixelsPerDegreeY / metersPerDegree;
	  var pixelsPerMeterZ = (pixelsPerMeterX + pixelsPerMeterY) / 2;
	  // const pixelsPerMeter = [pixelsPerMeterX, pixelsPerMeterY, pixelsPerMeterZ];
	
	  var worldSize = TILE_SIZE * scale;
	  var altPixelsPerMeter = worldSize / (4e7 * latCosine);
	  var pixelsPerMeter = [altPixelsPerMeter, altPixelsPerMeter, altPixelsPerMeter];
	  var metersPerPixel = [1 / altPixelsPerMeter, 1 / altPixelsPerMeter, 1 / pixelsPerMeterZ];
	
	  var pixelsPerDegree = [pixelsPerDegreeX, pixelsPerDegreeY, pixelsPerMeterZ];
	  var degreesPerPixel = [1 / pixelsPerDegreeX, 1 / pixelsPerDegreeY, 1 / pixelsPerMeterZ];
	
	  // Main results, used for converting meters to latlng deltas and scaling offsets
	  return {
	    pixelsPerMeter: pixelsPerMeter,
	    metersPerPixel: metersPerPixel,
	    pixelsPerDegree: pixelsPerDegree,
	    degreesPerPixel: degreesPerPixel
	  };
	}
	
	// ATTRIBUTION:
	// view and projection matrix creation is intentionally kept compatible with
	// mapbox-gl's implementation to ensure that seamless interoperation
	// with mapbox and react-map-gl. See: https://github.com/mapbox/mapbox-gl-js
	
	// Variable fov (in radians)
	function getFov(_ref8) {
	  var height = _ref8.height,
	      altitude = _ref8.altitude;
	
	  return 2 * Math.atan(height / 2 / altitude);
	}
	
	function getClippingPlanes(_ref9) {
	  var altitude = _ref9.altitude,
	      pitch = _ref9.pitch;
	
	  // Find the distance from the center point to the center top
	  // in altitude units using law of sines.
	  var pitchRadians = pitch * DEGREES_TO_RADIANS;
	  var halfFov = Math.atan(0.5 / altitude);
	  var topHalfSurfaceDistance = Math.sin(halfFov) * altitude / Math.sin(Math.PI / 2 - pitchRadians - halfFov);
	
	  // Calculate z value of the farthest fragment that should be rendered.
	  var farZ = Math.cos(Math.PI / 2 - pitchRadians) * topHalfSurfaceDistance + altitude;
	
	  return { farZ: farZ, nearZ: 0.1 };
	}
	
	// PROJECTION MATRIX: PROJECTS FROM CAMERA (VIEW) SPACE TO CLIPSPACE
	function makeProjectionMatrixFromMercatorParams(_ref10) {
	  var width = _ref10.width,
	      height = _ref10.height,
	      pitch = _ref10.pitch,
	      altitude = _ref10.altitude,
	      _ref10$farZMultiplier = _ref10.farZMultiplier,
	      farZMultiplier = _ref10$farZMultiplier === undefined ? 10 : _ref10$farZMultiplier;
	
	  var _getClippingPlanes = getClippingPlanes({ altitude: altitude, pitch: pitch }),
	      nearZ = _getClippingPlanes.nearZ,
	      farZ = _getClippingPlanes.farZ;
	
	  var fov = getFov({ height: height, altitude: altitude });
	
	  var projectionMatrix = _glMatrix.mat4.perspective((0, _viewport.createMat4)(), fov, // fov in radians
	  width / height, // aspect ratio
	  nearZ, // near plane
	  farZ * farZMultiplier // far plane
	  );
	
	  return projectionMatrix;
	}
	
	function makeUncenteredViewMatrixFromMercatorParams(_ref11) {
	  var width = _ref11.width,
	      height = _ref11.height,
	      longitude = _ref11.longitude,
	      latitude = _ref11.latitude,
	      zoom = _ref11.zoom,
	      pitch = _ref11.pitch,
	      bearing = _ref11.bearing,
	      altitude = _ref11.altitude,
	      center = _ref11.center;
	
	  // VIEW MATRIX: PROJECTS FROM VIRTUAL PIXELS TO CAMERA SPACE
	  // Note: As usual, matrix operation orders should be read in reverse
	  // since vectors will be multiplied from the right during transformation
	  var vm = (0, _viewport.createMat4)();
	
	  // Move camera to altitude
	  _glMatrix.mat4.translate(vm, vm, [0, 0, -altitude]);
	
	  // After the rotateX, z values are in pixel units. Convert them to
	  // altitude units. 1 altitude unit = the screen height.
	  _glMatrix.mat4.scale(vm, vm, [1, -1, 1 / height]);
	
	  // Rotate by bearing, and then by pitch (which tilts the view)
	  _glMatrix.mat4.rotateX(vm, vm, pitch * DEGREES_TO_RADIANS);
	  _glMatrix.mat4.rotateZ(vm, vm, -bearing * DEGREES_TO_RADIANS);
	
	  return vm;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvdmlld3BvcnRzL3dlYi1tZXJjYXRvci12aWV3cG9ydC5qcyJdLCJuYW1lcyI6WyJnZXRGb3YiLCJnZXRDbGlwcGluZ1BsYW5lcyIsIm1ha2VQcm9qZWN0aW9uTWF0cml4RnJvbU1lcmNhdG9yUGFyYW1zIiwiUEkiLCJNYXRoIiwiUElfNCIsIkRFR1JFRVNfVE9fUkFESUFOUyIsIlJBRElBTlNfVE9fREVHUkVFUyIsIlRJTEVfU0laRSIsIldPUkxEX1NDQUxFIiwiREVGQVVMVF9NQVBfU1RBVEUiLCJsYXRpdHVkZSIsImxvbmdpdHVkZSIsInpvb20iLCJwaXRjaCIsImJlYXJpbmciLCJhbHRpdHVkZSIsIkVSUl9BUkdVTUVOVCIsIldlYk1lcmNhdG9yVmlld3BvcnQiLCJ3aWR0aCIsImhlaWdodCIsImZhclpNdWx0aXBsaWVyIiwidW5kZWZpbmVkIiwic2NhbGUiLCJwb3ciLCJtYXgiLCJkaXN0YW5jZVNjYWxlcyIsImNhbGN1bGF0ZURpc3RhbmNlU2NhbGVzIiwicHJvamVjdGlvbk1hdHJpeCIsInZpZXdNYXRyaXhVbmNlbnRlcmVkIiwibWFrZVVuY2VudGVyZWRWaWV3TWF0cml4RnJvbU1lcmNhdG9yUGFyYW1zIiwiY2VudGVyIiwicHJvamVjdEZsYXQiLCJ2aWV3TWF0cml4IiwidHJhbnNsYXRlIiwiX2Rpc3RhbmNlU2NhbGVzIiwiZ2V0RGlzdGFuY2VTY2FsZXMiLCJiaW5kIiwibWV0ZXJzVG9MbmdMYXREZWx0YSIsImxuZ0xhdERlbHRhVG9NZXRlcnMiLCJhZGRNZXRlcnNUb0xuZ0xhdCIsIk9iamVjdCIsImZyZWV6ZSIsImxuZ0xhdCIsInh5IiwidW5wcm9qZWN0RmxhdCIsInBvcyIsImMiLCJwcm9qZWN0IiwidG9wTGVmdCIsImNvb3JkQ2VudGVyIiwiY29vcmRBdFBvaW50Iiwic3ViIiwibmV3UG9zIiwibmV3TG5nTGF0IiwidW5wcm9qZWN0IiwieHl6IiwieCIsInkiLCJ6IiwiTnVtYmVyIiwiaXNGaW5pdGUiLCJwaXhlbHNQZXJNZXRlciIsImRlZ3JlZXNQZXJQaXhlbCIsImRlbHRhTG5nIiwiZGVsdGFMYXQiLCJsZW5ndGgiLCJkZWx0YUxuZ0xhdFoiLCJkZWx0YVoiLCJwaXhlbHNQZXJEZWdyZWUiLCJtZXRlcnNQZXJQaXhlbCIsImRlbHRhWCIsImRlbHRhWSIsImxuZ0xhdFoiLCJsbmciLCJsYXQiLCJaIiwibGFtYmRhMiIsInBoaTIiLCJsb2ciLCJ0YW4iLCJhdGFuIiwiZXhwIiwiaXNOYU4iLCJNRVRFUlNfUEVSX0RFR1JFRSIsImxhdENvc2luZSIsImNvcyIsIm1ldGVyc1BlckRlZ3JlZSIsInBpeGVsc1BlckRlZ3JlZVgiLCJkaXN0YW5jZSIsInBpeGVsc1BlckRlZ3JlZVkiLCJwaXhlbHNQZXJNZXRlclgiLCJwaXhlbHNQZXJNZXRlclkiLCJwaXhlbHNQZXJNZXRlcloiLCJ3b3JsZFNpemUiLCJhbHRQaXhlbHNQZXJNZXRlciIsInBpdGNoUmFkaWFucyIsImhhbGZGb3YiLCJ0b3BIYWxmU3VyZmFjZURpc3RhbmNlIiwic2luIiwiZmFyWiIsIm5lYXJaIiwiZm92IiwicGVyc3BlY3RpdmUiLCJ2bSIsInJvdGF0ZVgiLCJyb3RhdGVaIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O1FBc1hnQkEsTSxHQUFBQSxNO1FBSUFDLGlCLEdBQUFBLGlCO1FBZUFDLHNDLEdBQUFBLHNDOztBQW5YaEI7Ozs7QUFDQTs7QUFDQTs7Ozs7Ozs7OzsrZUF4QkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUE7QUFDQTs7O0FBS0E7QUFDQSxJQUFNQyxLQUFLQyxLQUFLRCxFQUFoQjtBQUNBLElBQU1FLE9BQU9GLEtBQUssQ0FBbEI7QUFDQSxJQUFNRyxxQkFBcUJILEtBQUssR0FBaEM7QUFDQSxJQUFNSSxxQkFBcUIsTUFBTUosRUFBakM7QUFDQSxJQUFNSyxZQUFZLEdBQWxCO0FBQ0EsSUFBTUMsY0FBY0QsU0FBcEI7O0FBRUEsSUFBTUUsb0JBQW9CO0FBQ3hCQyxZQUFVLEVBRGM7QUFFeEJDLGFBQVcsQ0FBQyxHQUZZO0FBR3hCQyxRQUFNLEVBSGtCO0FBSXhCQyxTQUFPLENBSmlCO0FBS3hCQyxXQUFTLENBTGU7QUFNeEJDLFlBQVU7QUFOYyxDQUExQjs7QUFTQSxJQUFNQyxlQUFlLHlDQUFyQjs7SUFFcUJDLG1COzs7QUFDbkI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFnQ0E7QUFDQSxpQ0FXUTtBQUFBLG1GQUFKLEVBQUk7QUFBQSxRQVROQyxLQVNNLFFBVE5BLEtBU007QUFBQSxRQVJOQyxNQVFNLFFBUk5BLE1BUU07QUFBQSxRQVBOVCxRQU9NLFFBUE5BLFFBT007QUFBQSxRQU5OQyxTQU1NLFFBTk5BLFNBTU07QUFBQSxRQUxOQyxJQUtNLFFBTE5BLElBS007QUFBQSxRQUpOQyxLQUlNLFFBSk5BLEtBSU07QUFBQSxRQUhOQyxPQUdNLFFBSE5BLE9BR007QUFBQSxRQUZOQyxRQUVNLFFBRk5BLFFBRU07QUFBQSxtQ0FETkssY0FDTTtBQUFBLFFBRE5BLGNBQ00sdUNBRFcsRUFDWDs7QUFBQTs7QUFDTjtBQUNBRixZQUFRQSxVQUFVRyxTQUFWLEdBQXNCSCxLQUF0QixHQUE4QlQsa0JBQWtCUyxLQUF4RDtBQUNBQyxhQUFTQSxXQUFXRSxTQUFYLEdBQXVCRixNQUF2QixHQUFnQ1Ysa0JBQWtCVSxNQUEzRDtBQUNBUCxXQUFPQSxTQUFTUyxTQUFULEdBQXFCVCxJQUFyQixHQUE0Qkgsa0JBQWtCRyxJQUFyRDtBQUNBRixlQUFXQSxhQUFhVyxTQUFiLEdBQXlCWCxRQUF6QixHQUFvQ0Qsa0JBQWtCQyxRQUFqRTtBQUNBQyxnQkFBWUEsY0FBY1UsU0FBZCxHQUEwQlYsU0FBMUIsR0FBc0NGLGtCQUFrQkUsU0FBcEU7QUFDQUcsY0FBVUEsWUFBWU8sU0FBWixHQUF3QlAsT0FBeEIsR0FBa0NMLGtCQUFrQkssT0FBOUQ7QUFDQUQsWUFBUUEsVUFBVVEsU0FBVixHQUFzQlIsS0FBdEIsR0FBOEJKLGtCQUFrQkksS0FBeEQ7QUFDQUUsZUFBV0EsYUFBYU0sU0FBYixHQUF5Qk4sUUFBekIsR0FBb0NOLGtCQUFrQk0sUUFBakU7O0FBRUE7QUFDQUcsWUFBUUEsU0FBUyxDQUFqQjtBQUNBQyxhQUFTQSxVQUFVLENBQW5COztBQUVBLFFBQU1HLFFBQVFuQixLQUFLb0IsR0FBTCxDQUFTLENBQVQsRUFBWVgsSUFBWixDQUFkO0FBQ0E7QUFDQTtBQUNBRyxlQUFXWixLQUFLcUIsR0FBTCxDQUFTLElBQVQsRUFBZVQsUUFBZixDQUFYOztBQUVBLFFBQU1VLGlCQUFpQkMsd0JBQXdCLEVBQUNoQixrQkFBRCxFQUFXQyxvQkFBWCxFQUFzQlcsWUFBdEIsRUFBeEIsQ0FBdkI7O0FBRUEsUUFBTUssbUJBQW1CMUIsdUNBQXVDO0FBQzlEaUIsa0JBRDhEO0FBRTlEQyxvQkFGOEQ7QUFHOUROLGtCQUg4RDtBQUk5REMsc0JBSjhEO0FBSzlEQyx3QkFMOEQ7QUFNOURLO0FBTjhELEtBQXZDLENBQXpCOztBQVNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EsUUFBTVEsdUJBQXVCQywyQ0FBMkM7QUFDdEVYLGtCQURzRTtBQUV0RUMsb0JBRnNFO0FBR3RFUiwwQkFIc0U7QUFJdEVELHdCQUpzRTtBQUt0RUUsZ0JBTHNFO0FBTXRFQyxrQkFOc0U7QUFPdEVDLHNCQVBzRTtBQVF0RUMsd0JBUnNFO0FBU3RFVTtBQVRzRSxLQUEzQyxDQUE3Qjs7QUFZQTtBQUNBLFFBQU1LLFNBQVNDLFlBQVksQ0FBQ3BCLFNBQUQsRUFBWUQsUUFBWixDQUFaLEVBQW1DWSxLQUFuQyxDQUFmOztBQUVBLFFBQU1VLGFBQWEsZUFBS0MsU0FBTCxDQUNqQiwyQkFEaUIsRUFDSEwsb0JBREcsRUFDbUIsQ0FBQyxDQUFDRSxPQUFPLENBQVAsQ0FBRixFQUFhLENBQUNBLE9BQU8sQ0FBUCxDQUFkLEVBQXlCLENBQXpCLENBRG5CLENBQW5COztBQUtBO0FBdkRNLDBJQXFEQSxFQUFDWixZQUFELEVBQVFDLGNBQVIsRUFBZ0JhLHNCQUFoQixFQUE0Qkwsa0NBQTVCLEVBckRBOztBQXdETixVQUFLakIsUUFBTCxHQUFnQkEsUUFBaEI7QUFDQSxVQUFLQyxTQUFMLEdBQWlCQSxTQUFqQjtBQUNBLFVBQUtDLElBQUwsR0FBWUEsSUFBWjtBQUNBLFVBQUtDLEtBQUwsR0FBYUEsS0FBYjtBQUNBLFVBQUtDLE9BQUwsR0FBZUEsT0FBZjtBQUNBLFVBQUtDLFFBQUwsR0FBZ0JBLFFBQWhCOztBQUVBO0FBQ0EsVUFBS08sS0FBTCxHQUFhQSxLQUFiO0FBQ0EsVUFBS1EsTUFBTCxHQUFjQSxNQUFkO0FBQ0EsVUFBS0Ysb0JBQUwsR0FBNEJBLG9CQUE1QjtBQUNBLFVBQUtNLGVBQUwsR0FBdUJULGNBQXZCOztBQUVBO0FBQ0EsVUFBS1UsaUJBQUwsR0FBeUIsTUFBS0EsaUJBQUwsQ0FBdUJDLElBQXZCLE9BQXpCO0FBQ0EsVUFBS0MsbUJBQUwsR0FBMkIsTUFBS0EsbUJBQUwsQ0FBeUJELElBQXpCLE9BQTNCO0FBQ0EsVUFBS0UsbUJBQUwsR0FBMkIsTUFBS0EsbUJBQUwsQ0FBeUJGLElBQXpCLE9BQTNCO0FBQ0EsVUFBS0csaUJBQUwsR0FBeUIsTUFBS0EsaUJBQUwsQ0FBdUJILElBQXZCLE9BQXpCOztBQUVBSSxXQUFPQyxNQUFQO0FBM0VNO0FBNEVQO0FBQ0Q7O0FBRUE7Ozs7Ozs7Ozs7Ozs7O2lDQVVhQyxNLEVBQTRCO0FBQUEsVUFBcEJwQixLQUFvQix1RUFBWixLQUFLQSxLQUFPOztBQUN2QyxhQUFPUyxZQUFZVyxNQUFaLEVBQW9CcEIsS0FBcEIsQ0FBUDtBQUNEOztBQUVEOzs7Ozs7Ozs7Ozs7bUNBU2VxQixFLEVBQXdCO0FBQUEsVUFBcEJyQixLQUFvQix1RUFBWixLQUFLQSxLQUFPOztBQUNyQyxhQUFPc0IsY0FBY0QsRUFBZCxFQUFrQnJCLEtBQWxCLENBQVA7QUFDRDs7OzhDQUVpQztBQUFBLFVBQWRvQixNQUFjLFNBQWRBLE1BQWM7QUFBQSxVQUFORyxHQUFNLFNBQU5BLEdBQU07O0FBQ2hDLFVBQU1DLElBQUksS0FBS0MsT0FBTCxDQUFhTCxNQUFiLEVBQXFCLEVBQUNNLFNBQVMsS0FBVixFQUFyQixDQUFWO0FBQ0EsVUFBTUMsY0FBYyxLQUFLRixPQUFMLENBQWEsQ0FBQyxLQUFLcEMsU0FBTixFQUFpQixLQUFLRCxRQUF0QixDQUFiLEVBQThDLEVBQUNzQyxTQUFTLEtBQVYsRUFBOUMsQ0FBcEI7QUFDQSxVQUFNRSxlQUFlTCxHQUFyQjtBQUNBLFVBQU1aLFlBQVksZUFBS2tCLEdBQUwsQ0FBUyxFQUFULEVBQWFELFlBQWIsRUFBMkJKLENBQTNCLENBQWxCO0FBQ0EsVUFBTU0sU0FBUyxlQUFLRCxHQUFMLENBQVMsRUFBVCxFQUFhRixXQUFiLEVBQTBCaEIsU0FBMUIsQ0FBZjtBQUNBLFVBQU1vQixZQUFZLEtBQUtDLFNBQUwsQ0FBZUYsTUFBZixFQUF1QixFQUFDSixTQUFTLEtBQVYsRUFBdkIsQ0FBbEI7O0FBRUEsYUFBT0ssU0FBUDtBQUNEOztBQUVEOzs7Ozs7Ozs7Ozs7d0NBVW9CO0FBQ2xCLGFBQU8sS0FBS25CLGVBQVo7QUFDRDs7QUFFRDs7Ozs7Ozs7Ozs7O3dDQVNvQnFCLEcsRUFBSztBQUFBLGdDQUNEQSxHQURDO0FBQUEsVUFDaEJDLENBRGdCO0FBQUEsVUFDYkMsQ0FEYTtBQUFBO0FBQUEsVUFDVkMsQ0FEVSx5QkFDTixDQURNOztBQUV2Qiw0QkFBT0MsT0FBT0MsUUFBUCxDQUFnQkosQ0FBaEIsS0FBc0JHLE9BQU9DLFFBQVAsQ0FBZ0JILENBQWhCLENBQXRCLElBQTRDRSxPQUFPQyxRQUFQLENBQWdCRixDQUFoQixDQUFuRCxFQUF1RTFDLFlBQXZFO0FBRnVCLDRCQUdtQixLQUFLa0IsZUFIeEI7QUFBQSxVQUdoQjJCLGNBSGdCLG1CQUdoQkEsY0FIZ0I7QUFBQSxVQUdBQyxlQUhBLG1CQUdBQSxlQUhBOztBQUl2QixVQUFNQyxXQUFXUCxJQUFJSyxlQUFlLENBQWYsQ0FBSixHQUF3QkMsZ0JBQWdCLENBQWhCLENBQXpDO0FBQ0EsVUFBTUUsV0FBV1AsSUFBSUksZUFBZSxDQUFmLENBQUosR0FBd0JDLGdCQUFnQixDQUFoQixDQUF6QztBQUNBLGFBQU9QLElBQUlVLE1BQUosS0FBZSxDQUFmLEdBQW1CLENBQUNGLFFBQUQsRUFBV0MsUUFBWCxDQUFuQixHQUEwQyxDQUFDRCxRQUFELEVBQVdDLFFBQVgsRUFBcUJOLENBQXJCLENBQWpEO0FBQ0Q7O0FBRUQ7Ozs7Ozs7Ozs7Ozt3Q0FTb0JRLFksRUFBYztBQUFBLHlDQUNTQSxZQURUO0FBQUEsVUFDekJILFFBRHlCO0FBQUEsVUFDZkMsUUFEZTtBQUFBO0FBQUEsVUFDTEcsTUFESyxrQ0FDSSxDQURKOztBQUVoQyw0QkFBT1IsT0FBT0MsUUFBUCxDQUFnQkcsUUFBaEIsS0FBNkJKLE9BQU9DLFFBQVAsQ0FBZ0JJLFFBQWhCLENBQTdCLElBQTBETCxPQUFPQyxRQUFQLENBQWdCTyxNQUFoQixDQUFqRSxFQUNFbkQsWUFERjtBQUZnQyw2QkFJVSxLQUFLa0IsZUFKZjtBQUFBLFVBSXpCa0MsZUFKeUIsb0JBSXpCQSxlQUp5QjtBQUFBLFVBSVJDLGNBSlEsb0JBSVJBLGNBSlE7O0FBS2hDLFVBQU1DLFNBQVNQLFdBQVdLLGdCQUFnQixDQUFoQixDQUFYLEdBQWdDQyxlQUFlLENBQWYsQ0FBL0M7QUFDQSxVQUFNRSxTQUFTUCxXQUFXSSxnQkFBZ0IsQ0FBaEIsQ0FBWCxHQUFnQ0MsZUFBZSxDQUFmLENBQS9DO0FBQ0EsYUFBT0gsYUFBYUQsTUFBYixLQUF3QixDQUF4QixHQUE0QixDQUFDSyxNQUFELEVBQVNDLE1BQVQsQ0FBNUIsR0FBK0MsQ0FBQ0QsTUFBRCxFQUFTQyxNQUFULEVBQWlCSixNQUFqQixDQUF0RDtBQUNEOztBQUVEOzs7Ozs7Ozs7Ozs7O3NDQVVrQkssTyxFQUFTakIsRyxFQUFLO0FBQUEsb0NBQ0ppQixPQURJO0FBQUEsVUFDdkJDLEdBRHVCO0FBQUEsVUFDbEJDLEdBRGtCO0FBQUE7QUFBQSxVQUNiQyxDQURhLDZCQUNULENBRFM7O0FBQUEsaUNBRVcsS0FBS3RDLG1CQUFMLENBQXlCa0IsR0FBekIsQ0FGWDtBQUFBO0FBQUEsVUFFdkJRLFFBRnVCO0FBQUEsVUFFYkMsUUFGYTtBQUFBO0FBQUEsVUFFSEcsTUFGRyx5Q0FFTSxDQUZOOztBQUc5QixhQUFPSyxRQUFRUCxNQUFSLEtBQW1CLENBQW5CLEdBQ0wsQ0FBQ1EsTUFBTVYsUUFBUCxFQUFpQlcsTUFBTVYsUUFBdkIsQ0FESyxHQUVMLENBQUNTLE1BQU1WLFFBQVAsRUFBaUJXLE1BQU1WLFFBQXZCLEVBQWlDVyxJQUFJUixNQUFyQyxDQUZGO0FBR0Q7O0FBRUQ7Ozs7aUNBRWE7QUFDWCxhQUFPLEtBQUtqQyxlQUFaO0FBQ0Q7Ozs7OztBQUdIOzs7Ozs7Ozs7Ozs7a0JBOU9xQmpCLG1CO0FBd1ByQixTQUFTYyxXQUFULFFBQWlDVCxLQUFqQyxFQUF3QztBQUFBO0FBQUEsTUFBbEJtRCxHQUFrQjtBQUFBLE1BQWJDLEdBQWE7O0FBQ3RDcEQsVUFBUUEsUUFBUWQsV0FBaEI7QUFDQSxNQUFNb0UsVUFBVUgsTUFBTXBFLGtCQUF0QjtBQUNBLE1BQU13RSxPQUFPSCxNQUFNckUsa0JBQW5CO0FBQ0EsTUFBTW1ELElBQUlsQyxTQUFTc0QsVUFBVTFFLEVBQW5CLEtBQTBCLElBQUlBLEVBQTlCLENBQVY7QUFDQSxNQUFNdUQsSUFBSW5DLFNBQVNwQixLQUFLQyxLQUFLMkUsR0FBTCxDQUFTM0UsS0FBSzRFLEdBQUwsQ0FBUzNFLE9BQU95RSxPQUFPLEdBQXZCLENBQVQsQ0FBZCxLQUF3RCxJQUFJM0UsRUFBNUQsQ0FBVjtBQUNBLFNBQU8sQ0FBQ3NELENBQUQsRUFBSUMsQ0FBSixDQUFQO0FBQ0Q7O0FBRUQ7Ozs7Ozs7OztBQVNBLFNBQVNiLGFBQVQsUUFBK0J0QixLQUEvQixFQUFzQztBQUFBO0FBQUEsTUFBZGtDLENBQWM7QUFBQSxNQUFYQyxDQUFXOztBQUNwQ25DLFVBQVFBLFFBQVFkLFdBQWhCO0FBQ0EsTUFBTW9FLFVBQVdwQixJQUFJbEMsS0FBTCxJQUFlLElBQUlwQixFQUFuQixJQUF5QkEsRUFBekM7QUFDQSxNQUFNMkUsT0FBTyxLQUFLMUUsS0FBSzZFLElBQUwsQ0FBVTdFLEtBQUs4RSxHQUFMLENBQVMvRSxLQUFNdUQsSUFBSW5DLEtBQUwsSUFBZSxJQUFJcEIsRUFBbkIsQ0FBZCxDQUFWLElBQW1ERSxJQUF4RCxDQUFiO0FBQ0EsU0FBTyxDQUFDd0UsVUFBVXRFLGtCQUFYLEVBQStCdUUsT0FBT3ZFLGtCQUF0QyxDQUFQO0FBQ0Q7O0FBRUQ7Ozs7OztBQU1BLFNBQVNvQix1QkFBVCxRQUErRDtBQUFBLE1BQTdCaEIsUUFBNkIsU0FBN0JBLFFBQTZCO0FBQUEsTUFBbkJDLFNBQW1CLFNBQW5CQSxTQUFtQjtBQUFBLE1BQVJXLEtBQVEsU0FBUkEsS0FBUTs7QUFDN0Qsd0JBQU8sQ0FBQzRELE1BQU14RSxRQUFOLENBQUQsSUFBb0IsQ0FBQ3dFLE1BQU12RSxTQUFOLENBQXJCLElBQXlDLENBQUN1RSxNQUFNNUQsS0FBTixDQUFqRCxFQUErRE4sWUFBL0Q7QUFDQTtBQUNBLE1BQU1tRSxvQkFBb0IsTUFBMUI7O0FBRUEsTUFBTUMsWUFBWWpGLEtBQUtrRixHQUFMLENBQVMzRSxXQUFXUCxLQUFLRCxFQUFoQixHQUFxQixHQUE5QixDQUFsQjs7QUFFQSxNQUFNb0Ysa0JBQWtCSCxvQkFBb0JDLFNBQTVDOztBQUVBO0FBQ0E7QUFDQSxNQUFNRyxtQkFBbUIsZUFBS0MsUUFBTCxDQUN2QnpELFlBQVksQ0FBQ3BCLFlBQVksR0FBYixFQUFrQkQsUUFBbEIsQ0FBWixFQUF5Q1ksS0FBekMsQ0FEdUIsRUFFdkJTLFlBQVksQ0FBQ3BCLFlBQVksR0FBYixFQUFrQkQsUUFBbEIsQ0FBWixFQUF5Q1ksS0FBekMsQ0FGdUIsQ0FBekI7QUFJQTtBQUNBO0FBQ0EsTUFBTW1FLG1CQUFtQixlQUFLRCxRQUFMLENBQ3ZCekQsWUFBWSxDQUFDcEIsU0FBRCxFQUFZRCxXQUFXLEdBQXZCLENBQVosRUFBeUNZLEtBQXpDLENBRHVCLEVBRXZCUyxZQUFZLENBQUNwQixTQUFELEVBQVlELFdBQVcsR0FBdkIsQ0FBWixFQUF5Q1ksS0FBekMsQ0FGdUIsQ0FBekI7O0FBS0EsTUFBTW9FLGtCQUFrQkgsbUJBQW1CRCxlQUEzQztBQUNBLE1BQU1LLGtCQUFrQkYsbUJBQW1CSCxlQUEzQztBQUNBLE1BQU1NLGtCQUFrQixDQUFDRixrQkFBa0JDLGVBQW5CLElBQXNDLENBQTlEO0FBQ0E7O0FBRUEsTUFBTUUsWUFBWXRGLFlBQVllLEtBQTlCO0FBQ0EsTUFBTXdFLG9CQUFvQkQsYUFBYSxNQUFNVCxTQUFuQixDQUExQjtBQUNBLE1BQU12QixpQkFBaUIsQ0FBQ2lDLGlCQUFELEVBQW9CQSxpQkFBcEIsRUFBdUNBLGlCQUF2QyxDQUF2QjtBQUNBLE1BQU16QixpQkFBaUIsQ0FBQyxJQUFJeUIsaUJBQUwsRUFBd0IsSUFBSUEsaUJBQTVCLEVBQStDLElBQUlGLGVBQW5ELENBQXZCOztBQUVBLE1BQU14QixrQkFBa0IsQ0FBQ21CLGdCQUFELEVBQW1CRSxnQkFBbkIsRUFBcUNHLGVBQXJDLENBQXhCO0FBQ0EsTUFBTTlCLGtCQUFrQixDQUFDLElBQUl5QixnQkFBTCxFQUF1QixJQUFJRSxnQkFBM0IsRUFBNkMsSUFBSUcsZUFBakQsQ0FBeEI7O0FBRUE7QUFDQSxTQUFPO0FBQ0wvQixrQ0FESztBQUVMUSxrQ0FGSztBQUdMRCxvQ0FISztBQUlMTjtBQUpLLEdBQVA7QUFNRDs7QUFFRDtBQUNBO0FBQ0E7QUFDQTs7QUFFQTtBQUNPLFNBQVMvRCxNQUFULFFBQW9DO0FBQUEsTUFBbkJvQixNQUFtQixTQUFuQkEsTUFBbUI7QUFBQSxNQUFYSixRQUFXLFNBQVhBLFFBQVc7O0FBQ3pDLFNBQU8sSUFBSVosS0FBSzZFLElBQUwsQ0FBVzdELFNBQVMsQ0FBVixHQUFlSixRQUF6QixDQUFYO0FBQ0Q7O0FBRU0sU0FBU2YsaUJBQVQsUUFBOEM7QUFBQSxNQUFsQmUsUUFBa0IsU0FBbEJBLFFBQWtCO0FBQUEsTUFBUkYsS0FBUSxTQUFSQSxLQUFROztBQUNuRDtBQUNBO0FBQ0EsTUFBTWtGLGVBQWVsRixRQUFRUixrQkFBN0I7QUFDQSxNQUFNMkYsVUFBVTdGLEtBQUs2RSxJQUFMLENBQVUsTUFBTWpFLFFBQWhCLENBQWhCO0FBQ0EsTUFBTWtGLHlCQUNKOUYsS0FBSytGLEdBQUwsQ0FBU0YsT0FBVCxJQUFvQmpGLFFBQXBCLEdBQStCWixLQUFLK0YsR0FBTCxDQUFTL0YsS0FBS0QsRUFBTCxHQUFVLENBQVYsR0FBYzZGLFlBQWQsR0FBNkJDLE9BQXRDLENBRGpDOztBQUdBO0FBQ0EsTUFBTUcsT0FBT2hHLEtBQUtrRixHQUFMLENBQVNsRixLQUFLRCxFQUFMLEdBQVUsQ0FBVixHQUFjNkYsWUFBdkIsSUFBdUNFLHNCQUF2QyxHQUFnRWxGLFFBQTdFOztBQUVBLFNBQU8sRUFBQ29GLFVBQUQsRUFBT0MsT0FBTyxHQUFkLEVBQVA7QUFDRDs7QUFFRDtBQUNPLFNBQVNuRyxzQ0FBVCxTQU1KO0FBQUEsTUFMRGlCLEtBS0MsVUFMREEsS0FLQztBQUFBLE1BSkRDLE1BSUMsVUFKREEsTUFJQztBQUFBLE1BSEROLEtBR0MsVUFIREEsS0FHQztBQUFBLE1BRkRFLFFBRUMsVUFGREEsUUFFQztBQUFBLHFDQURESyxjQUNDO0FBQUEsTUFEREEsY0FDQyx5Q0FEZ0IsRUFDaEI7O0FBQUEsMkJBQ3FCcEIsa0JBQWtCLEVBQUNlLGtCQUFELEVBQVdGLFlBQVgsRUFBbEIsQ0FEckI7QUFBQSxNQUNNdUYsS0FETixzQkFDTUEsS0FETjtBQUFBLE1BQ2FELElBRGIsc0JBQ2FBLElBRGI7O0FBRUQsTUFBTUUsTUFBTXRHLE9BQU8sRUFBQ29CLGNBQUQsRUFBU0osa0JBQVQsRUFBUCxDQUFaOztBQUVBLE1BQU1ZLG1CQUFtQixlQUFLMkUsV0FBTCxDQUN2QiwyQkFEdUIsRUFFdkJELEdBRnVCLEVBRUw7QUFDbEJuRixVQUFRQyxNQUhlLEVBR0w7QUFDbEJpRixPQUp1QixFQUlMO0FBQ2xCRCxTQUFPL0UsY0FMZ0IsQ0FLRDtBQUxDLEdBQXpCOztBQVFBLFNBQU9PLGdCQUFQO0FBQ0Q7O0FBRUQsU0FBU0UsMENBQVQsU0FVRztBQUFBLE1BVERYLEtBU0MsVUFUREEsS0FTQztBQUFBLE1BUkRDLE1BUUMsVUFSREEsTUFRQztBQUFBLE1BUERSLFNBT0MsVUFQREEsU0FPQztBQUFBLE1BTkRELFFBTUMsVUFOREEsUUFNQztBQUFBLE1BTERFLElBS0MsVUFMREEsSUFLQztBQUFBLE1BSkRDLEtBSUMsVUFKREEsS0FJQztBQUFBLE1BSERDLE9BR0MsVUFIREEsT0FHQztBQUFBLE1BRkRDLFFBRUMsVUFGREEsUUFFQztBQUFBLE1BRERlLE1BQ0MsVUFEREEsTUFDQzs7QUFDRDtBQUNBO0FBQ0E7QUFDQSxNQUFNeUUsS0FBSywyQkFBWDs7QUFFQTtBQUNBLGlCQUFLdEUsU0FBTCxDQUFlc0UsRUFBZixFQUFtQkEsRUFBbkIsRUFBdUIsQ0FBQyxDQUFELEVBQUksQ0FBSixFQUFPLENBQUN4RixRQUFSLENBQXZCOztBQUVBO0FBQ0E7QUFDQSxpQkFBS08sS0FBTCxDQUFXaUYsRUFBWCxFQUFlQSxFQUFmLEVBQW1CLENBQUMsQ0FBRCxFQUFJLENBQUMsQ0FBTCxFQUFRLElBQUlwRixNQUFaLENBQW5COztBQUVBO0FBQ0EsaUJBQUtxRixPQUFMLENBQWFELEVBQWIsRUFBaUJBLEVBQWpCLEVBQXFCMUYsUUFBUVIsa0JBQTdCO0FBQ0EsaUJBQUtvRyxPQUFMLENBQWFGLEVBQWIsRUFBaUJBLEVBQWpCLEVBQXFCLENBQUN6RixPQUFELEdBQVdULGtCQUFoQzs7QUFFQSxTQUFPa0csRUFBUDtBQUNEIiwiZmlsZSI6IndlYi1tZXJjYXRvci12aWV3cG9ydC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvcHlyaWdodCAoYykgMjAxNSAtIDIwMTcgVWJlciBUZWNobm9sb2dpZXMsIEluYy5cbi8vXG4vLyBQZXJtaXNzaW9uIGlzIGhlcmVieSBncmFudGVkLCBmcmVlIG9mIGNoYXJnZSwgdG8gYW55IHBlcnNvbiBvYnRhaW5pbmcgYSBjb3B5XG4vLyBvZiB0aGlzIHNvZnR3YXJlIGFuZCBhc3NvY2lhdGVkIGRvY3VtZW50YXRpb24gZmlsZXMgKHRoZSBcIlNvZnR3YXJlXCIpLCB0byBkZWFsXG4vLyBpbiB0aGUgU29mdHdhcmUgd2l0aG91dCByZXN0cmljdGlvbiwgaW5jbHVkaW5nIHdpdGhvdXQgbGltaXRhdGlvbiB0aGUgcmlnaHRzXG4vLyB0byB1c2UsIGNvcHksIG1vZGlmeSwgbWVyZ2UsIHB1Ymxpc2gsIGRpc3RyaWJ1dGUsIHN1YmxpY2Vuc2UsIGFuZC9vciBzZWxsXG4vLyBjb3BpZXMgb2YgdGhlIFNvZnR3YXJlLCBhbmQgdG8gcGVybWl0IHBlcnNvbnMgdG8gd2hvbSB0aGUgU29mdHdhcmUgaXNcbi8vIGZ1cm5pc2hlZCB0byBkbyBzbywgc3ViamVjdCB0byB0aGUgZm9sbG93aW5nIGNvbmRpdGlvbnM6XG4vL1xuLy8gVGhlIGFib3ZlIGNvcHlyaWdodCBub3RpY2UgYW5kIHRoaXMgcGVybWlzc2lvbiBub3RpY2Ugc2hhbGwgYmUgaW5jbHVkZWQgaW5cbi8vIGFsbCBjb3BpZXMgb3Igc3Vic3RhbnRpYWwgcG9ydGlvbnMgb2YgdGhlIFNvZnR3YXJlLlxuLy9cbi8vIFRIRSBTT0ZUV0FSRSBJUyBQUk9WSURFRCBcIkFTIElTXCIsIFdJVEhPVVQgV0FSUkFOVFkgT0YgQU5ZIEtJTkQsIEVYUFJFU1MgT1Jcbi8vIElNUExJRUQsIElOQ0xVRElORyBCVVQgTk9UIExJTUlURUQgVE8gVEhFIFdBUlJBTlRJRVMgT0YgTUVSQ0hBTlRBQklMSVRZLFxuLy8gRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UgQU5EIE5PTklORlJJTkdFTUVOVC4gSU4gTk8gRVZFTlQgU0hBTEwgVEhFXG4vLyBBVVRIT1JTIE9SIENPUFlSSUdIVCBIT0xERVJTIEJFIExJQUJMRSBGT1IgQU5ZIENMQUlNLCBEQU1BR0VTIE9SIE9USEVSXG4vLyBMSUFCSUxJVFksIFdIRVRIRVIgSU4gQU4gQUNUSU9OIE9GIENPTlRSQUNULCBUT1JUIE9SIE9USEVSV0lTRSwgQVJJU0lORyBGUk9NLFxuLy8gT1VUIE9GIE9SIElOIENPTk5FQ1RJT04gV0lUSCBUSEUgU09GVFdBUkUgT1IgVEhFIFVTRSBPUiBPVEhFUiBERUFMSU5HUyBJTlxuLy8gVEhFIFNPRlRXQVJFLlxuXG4vLyBWaWV3IGFuZCBQcm9qZWN0aW9uIE1hdHJpeCBjYWxjdWxhdGlvbnMgZm9yIG1hcGJveC1qcyBzdHlsZVxuLy8gbWFwIHZpZXcgcHJvcGVydGllc1xuaW1wb3J0IFZpZXdwb3J0LCB7Y3JlYXRlTWF0NH0gZnJvbSAnLi92aWV3cG9ydCc7XG5pbXBvcnQge21hdDQsIHZlYzJ9IGZyb20gJ2dsLW1hdHJpeCc7XG5pbXBvcnQgYXNzZXJ0IGZyb20gJ2Fzc2VydCc7XG5cbi8vIENPTlNUQU5UU1xuY29uc3QgUEkgPSBNYXRoLlBJO1xuY29uc3QgUElfNCA9IFBJIC8gNDtcbmNvbnN0IERFR1JFRVNfVE9fUkFESUFOUyA9IFBJIC8gMTgwO1xuY29uc3QgUkFESUFOU19UT19ERUdSRUVTID0gMTgwIC8gUEk7XG5jb25zdCBUSUxFX1NJWkUgPSA1MTI7XG5jb25zdCBXT1JMRF9TQ0FMRSA9IFRJTEVfU0laRTtcblxuY29uc3QgREVGQVVMVF9NQVBfU1RBVEUgPSB7XG4gIGxhdGl0dWRlOiAzNyxcbiAgbG9uZ2l0dWRlOiAtMTIyLFxuICB6b29tOiAxMSxcbiAgcGl0Y2g6IDAsXG4gIGJlYXJpbmc6IDAsXG4gIGFsdGl0dWRlOiAxLjVcbn07XG5cbmNvbnN0IEVSUl9BUkdVTUVOVCA9ICdJbGxlZ2FsIGFyZ3VtZW50IHRvIFdlYk1lcmNhdG9yVmlld3BvcnQnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBXZWJNZXJjYXRvclZpZXdwb3J0IGV4dGVuZHMgVmlld3BvcnQge1xuICAvKipcbiAgICogQGNsYXNzZGVzY1xuICAgKiBDcmVhdGVzIHZpZXcvcHJvamVjdGlvbiBtYXRyaWNlcyBmcm9tIG1lcmNhdG9yIHBhcmFtc1xuICAgKiBOb3RlOiBUaGUgVmlld3BvcnQgaXMgaW1tdXRhYmxlIGluIHRoZSBzZW5zZSB0aGF0IGl0IG9ubHkgaGFzIGFjY2Vzc29ycy5cbiAgICogQSBuZXcgdmlld3BvcnQgaW5zdGFuY2Ugc2hvdWxkIGJlIGNyZWF0ZWQgaWYgYW55IHBhcmFtZXRlcnMgaGF2ZSBjaGFuZ2VkLlxuICAgKlxuICAgKiBAY2xhc3NcbiAgICogQHBhcmFtIHtPYmplY3R9IG9wdCAtIG9wdGlvbnNcbiAgICogQHBhcmFtIHtCb29sZWFufSBtZXJjYXRvcj10cnVlIC0gV2hldGhlciB0byB1c2UgbWVyY2F0b3IgcHJvamVjdGlvblxuICAgKlxuICAgKiBAcGFyYW0ge051bWJlcn0gb3B0LndpZHRoPTEgLSBXaWR0aCBvZiBcInZpZXdwb3J0XCIgb3Igd2luZG93XG4gICAqIEBwYXJhbSB7TnVtYmVyfSBvcHQuaGVpZ2h0PTEgLSBIZWlnaHQgb2YgXCJ2aWV3cG9ydFwiIG9yIHdpbmRvd1xuICAgKiBAcGFyYW0ge0FycmF5fSBvcHQuY2VudGVyPVswLCAwXSAtIENlbnRlciBvZiB2aWV3cG9ydFxuICAgKiAgIFtsb25naXR1ZGUsIGxhdGl0dWRlXSBvciBbeCwgeV1cbiAgICogQHBhcmFtIHtOdW1iZXJ9IG9wdC5zY2FsZT0xIC0gRWl0aGVyIHVzZSBzY2FsZSBvciB6b29tXG4gICAqIEBwYXJhbSB7TnVtYmVyfSBvcHQucGl0Y2g9MCAtIENhbWVyYSBhbmdsZSBpbiBkZWdyZWVzICgwIGlzIHN0cmFpZ2h0IGRvd24pXG4gICAqIEBwYXJhbSB7TnVtYmVyfSBvcHQuYmVhcmluZz0wIC0gTWFwIHJvdGF0aW9uIGluIGRlZ3JlZXMgKDAgbWVhbnMgbm9ydGggaXMgdXApXG4gICAqIEBwYXJhbSB7TnVtYmVyfSBvcHQuYWx0aXR1ZGU9IC0gQWx0aXR1ZGUgb2YgY2FtZXJhIGluIHNjcmVlbiB1bml0c1xuICAgKlxuICAgKiBXZWIgbWVyY2F0b3IgcHJvamVjdGlvbiBzaG9ydC1oYW5kIHBhcmFtZXRlcnNcbiAgICogQHBhcmFtIHtOdW1iZXJ9IG9wdC5sYXRpdHVkZSAtIENlbnRlciBvZiB2aWV3cG9ydCBvbiBtYXAgKGFsdGVybmF0aXZlIHRvIG9wdC5jZW50ZXIpXG4gICAqIEBwYXJhbSB7TnVtYmVyfSBvcHQubG9uZ2l0dWRlIC0gQ2VudGVyIG9mIHZpZXdwb3J0IG9uIG1hcCAoYWx0ZXJuYXRpdmUgdG8gb3B0LmNlbnRlcilcbiAgICogQHBhcmFtIHtOdW1iZXJ9IG9wdC56b29tIC0gU2NhbGUgPSBNYXRoLnBvdygyLHpvb20pIG9uIG1hcCAoYWx0ZXJuYXRpdmUgdG8gb3B0LnNjYWxlKVxuXG4gICAqIE5vdGVzOlxuICAgKiAgLSBPbmx5IG9uZSBvZiBjZW50ZXIgb3IgW2xhdGl0dWRlLCBsb25naXR1ZGVdIGNhbiBiZSBzcGVjaWZpZWRcbiAgICogIC0gW2xhdGl0dWRlLCBsb25naXR1ZGVdIGNhbiBvbmx5IGJlIHNwZWNpZmllZCB3aGVuIFwibWVyY2F0b3JcIiBpcyB0cnVlXG4gICAqICAtIEFsdGl0dWRlIGhhcyBhIGRlZmF1bHQgdmFsdWUgdGhhdCBtYXRjaGVzIGFzc3VtcHRpb25zIGluIG1hcGJveC1nbFxuICAgKiAgLSB3aWR0aCBhbmQgaGVpZ2h0IGFyZSBmb3JjZWQgdG8gMSBpZiBzdXBwbGllZCBhcyAwLCB0byBhdm9pZFxuICAgKiAgICBkaXZpc2lvbiBieSB6ZXJvLiBUaGlzIGlzIGludGVuZGVkIHRvIHJlZHVjZSB0aGUgYnVyZGVuIG9mIGFwcHMgdG9cbiAgICogICAgdG8gY2hlY2sgdmFsdWVzIGJlZm9yZSBpbnN0YW50aWF0aW5nIGEgVmlld3BvcnQuXG4gICAqL1xuICAvKiBlc2xpbnQtZGlzYWJsZSBjb21wbGV4aXR5LCBtYXgtc3RhdGVtZW50cyAqL1xuICBjb25zdHJ1Y3Rvcih7XG4gICAgLy8gTWFwIHN0YXRlXG4gICAgd2lkdGgsXG4gICAgaGVpZ2h0LFxuICAgIGxhdGl0dWRlLFxuICAgIGxvbmdpdHVkZSxcbiAgICB6b29tLFxuICAgIHBpdGNoLFxuICAgIGJlYXJpbmcsXG4gICAgYWx0aXR1ZGUsXG4gICAgZmFyWk11bHRpcGxpZXIgPSAxMFxuICB9ID0ge30pIHtcbiAgICAvLyBWaWV3cG9ydCAtIHN1cHBvcnQgdW5kZWZpbmVkIGFyZ3VtZW50c1xuICAgIHdpZHRoID0gd2lkdGggIT09IHVuZGVmaW5lZCA/IHdpZHRoIDogREVGQVVMVF9NQVBfU1RBVEUud2lkdGg7XG4gICAgaGVpZ2h0ID0gaGVpZ2h0ICE9PSB1bmRlZmluZWQgPyBoZWlnaHQgOiBERUZBVUxUX01BUF9TVEFURS5oZWlnaHQ7XG4gICAgem9vbSA9IHpvb20gIT09IHVuZGVmaW5lZCA/IHpvb20gOiBERUZBVUxUX01BUF9TVEFURS56b29tO1xuICAgIGxhdGl0dWRlID0gbGF0aXR1ZGUgIT09IHVuZGVmaW5lZCA/IGxhdGl0dWRlIDogREVGQVVMVF9NQVBfU1RBVEUubGF0aXR1ZGU7XG4gICAgbG9uZ2l0dWRlID0gbG9uZ2l0dWRlICE9PSB1bmRlZmluZWQgPyBsb25naXR1ZGUgOiBERUZBVUxUX01BUF9TVEFURS5sb25naXR1ZGU7XG4gICAgYmVhcmluZyA9IGJlYXJpbmcgIT09IHVuZGVmaW5lZCA/IGJlYXJpbmcgOiBERUZBVUxUX01BUF9TVEFURS5iZWFyaW5nO1xuICAgIHBpdGNoID0gcGl0Y2ggIT09IHVuZGVmaW5lZCA/IHBpdGNoIDogREVGQVVMVF9NQVBfU1RBVEUucGl0Y2g7XG4gICAgYWx0aXR1ZGUgPSBhbHRpdHVkZSAhPT0gdW5kZWZpbmVkID8gYWx0aXR1ZGUgOiBERUZBVUxUX01BUF9TVEFURS5hbHRpdHVkZTtcblxuICAgIC8vIFNpbGVudGx5IGFsbG93IGFwcHMgdG8gc2VuZCBpbiAwLDAgdG8gZmFjaWxpdGF0ZSBpc29tb3JwaGljIHJlbmRlciBldGNcbiAgICB3aWR0aCA9IHdpZHRoIHx8IDE7XG4gICAgaGVpZ2h0ID0gaGVpZ2h0IHx8IDE7XG5cbiAgICBjb25zdCBzY2FsZSA9IE1hdGgucG93KDIsIHpvb20pO1xuICAgIC8vIEFsdGl0dWRlIC0gcHJldmVudCBkaXZpc2lvbiBieSAwXG4gICAgLy8gVE9ETyAtIGp1c3QgdGhyb3cgYW4gRXJyb3IgaW5zdGVhZD9cbiAgICBhbHRpdHVkZSA9IE1hdGgubWF4KDAuNzUsIGFsdGl0dWRlKTtcblxuICAgIGNvbnN0IGRpc3RhbmNlU2NhbGVzID0gY2FsY3VsYXRlRGlzdGFuY2VTY2FsZXMoe2xhdGl0dWRlLCBsb25naXR1ZGUsIHNjYWxlfSk7XG5cbiAgICBjb25zdCBwcm9qZWN0aW9uTWF0cml4ID0gbWFrZVByb2plY3Rpb25NYXRyaXhGcm9tTWVyY2F0b3JQYXJhbXMoe1xuICAgICAgd2lkdGgsXG4gICAgICBoZWlnaHQsXG4gICAgICBwaXRjaCxcbiAgICAgIGJlYXJpbmcsXG4gICAgICBhbHRpdHVkZSxcbiAgICAgIGZhclpNdWx0aXBsaWVyXG4gICAgfSk7XG5cbiAgICAvLyBUaGUgdW5jZW50ZXJlZCBtYXRyaXggYWxsb3dzIHVzIHR3byBtb3ZlIHRoZSBjZW50ZXIgYWRkaXRpb24gdG8gdGhlXG4gICAgLy8gc2hhZGVyIChjaGVhcCkgd2hpY2ggZ2l2ZXMgYSBjb29yZGluYXRlIHN5c3RlbSB0aGF0IGhhcyBpdHMgY2VudGVyIGluXG4gICAgLy8gdGhlIGxheWVyJ3MgY2VudGVyIHBvc2l0aW9uLiBUaGlzIG1ha2VzIHJvdGF0aW9ucyBhbmQgb3RoZXIgbW9kZWxNYXRyeFxuICAgIC8vIHRyYW5zZm9ybXMgbXVjaCBtb3JlIHVzZWZ1bC5cbiAgICBjb25zdCB2aWV3TWF0cml4VW5jZW50ZXJlZCA9IG1ha2VVbmNlbnRlcmVkVmlld01hdHJpeEZyb21NZXJjYXRvclBhcmFtcyh7XG4gICAgICB3aWR0aCxcbiAgICAgIGhlaWdodCxcbiAgICAgIGxvbmdpdHVkZSxcbiAgICAgIGxhdGl0dWRlLFxuICAgICAgem9vbSxcbiAgICAgIHBpdGNoLFxuICAgICAgYmVhcmluZyxcbiAgICAgIGFsdGl0dWRlLFxuICAgICAgZGlzdGFuY2VTY2FsZXNcbiAgICB9KTtcblxuICAgIC8vIE1ha2UgYSBjZW50ZXJlZCB2ZXJzaW9uIG9mIHRoZSBtYXRyaXggZm9yIHByb2plY3Rpb24gbW9kZXMgd2l0aG91dCBhbiBvZmZzZXRcbiAgICBjb25zdCBjZW50ZXIgPSBwcm9qZWN0RmxhdChbbG9uZ2l0dWRlLCBsYXRpdHVkZV0sIHNjYWxlKTtcblxuICAgIGNvbnN0IHZpZXdNYXRyaXggPSBtYXQ0LnRyYW5zbGF0ZShcbiAgICAgIGNyZWF0ZU1hdDQoKSwgdmlld01hdHJpeFVuY2VudGVyZWQsIFstY2VudGVyWzBdLCAtY2VudGVyWzFdLCAwXSk7XG5cbiAgICBzdXBlcih7d2lkdGgsIGhlaWdodCwgdmlld01hdHJpeCwgcHJvamVjdGlvbk1hdHJpeH0pO1xuXG4gICAgLy8gU2F2ZSBwYXJhbWV0ZXJzXG4gICAgdGhpcy5sYXRpdHVkZSA9IGxhdGl0dWRlO1xuICAgIHRoaXMubG9uZ2l0dWRlID0gbG9uZ2l0dWRlO1xuICAgIHRoaXMuem9vbSA9IHpvb207XG4gICAgdGhpcy5waXRjaCA9IHBpdGNoO1xuICAgIHRoaXMuYmVhcmluZyA9IGJlYXJpbmc7XG4gICAgdGhpcy5hbHRpdHVkZSA9IGFsdGl0dWRlO1xuXG4gICAgLy8gU2F2ZSBjYWxjdWxhdGVkIHZhbHVlc1xuICAgIHRoaXMuc2NhbGUgPSBzY2FsZTtcbiAgICB0aGlzLmNlbnRlciA9IGNlbnRlcjtcbiAgICB0aGlzLnZpZXdNYXRyaXhVbmNlbnRlcmVkID0gdmlld01hdHJpeFVuY2VudGVyZWQ7XG4gICAgdGhpcy5fZGlzdGFuY2VTY2FsZXMgPSBkaXN0YW5jZVNjYWxlcztcblxuICAgIC8vIEJpbmQgbWV0aG9kc1xuICAgIHRoaXMuZ2V0RGlzdGFuY2VTY2FsZXMgPSB0aGlzLmdldERpc3RhbmNlU2NhbGVzLmJpbmQodGhpcyk7XG4gICAgdGhpcy5tZXRlcnNUb0xuZ0xhdERlbHRhID0gdGhpcy5tZXRlcnNUb0xuZ0xhdERlbHRhLmJpbmQodGhpcyk7XG4gICAgdGhpcy5sbmdMYXREZWx0YVRvTWV0ZXJzID0gdGhpcy5sbmdMYXREZWx0YVRvTWV0ZXJzLmJpbmQodGhpcyk7XG4gICAgdGhpcy5hZGRNZXRlcnNUb0xuZ0xhdCA9IHRoaXMuYWRkTWV0ZXJzVG9MbmdMYXQuYmluZCh0aGlzKTtcblxuICAgIE9iamVjdC5mcmVlemUodGhpcyk7XG4gIH1cbiAgLyogZXNsaW50LWVuYWJsZSBjb21wbGV4aXR5LCBtYXgtc3RhdGVtZW50cyAqL1xuXG4gIC8qKlxuICAgKiBQcm9qZWN0IFtsbmcsbGF0XSBvbiBzcGhlcmUgb250byBbeCx5XSBvbiA1MTIqNTEyIE1lcmNhdG9yIFpvb20gMCB0aWxlLlxuICAgKiBQZXJmb3JtcyB0aGUgbm9ubGluZWFyIHBhcnQgb2YgdGhlIHdlYiBtZXJjYXRvciBwcm9qZWN0aW9uLlxuICAgKiBSZW1haW5pbmcgcHJvamVjdGlvbiBpcyBkb25lIHdpdGggNHg0IG1hdHJpY2VzIHdoaWNoIGFsc28gaGFuZGxlc1xuICAgKiBwZXJzcGVjdGl2ZS5cbiAgICpcbiAgICogQHBhcmFtIHtBcnJheX0gbG5nTGF0IC0gW2xuZywgbGF0XSBjb29yZGluYXRlc1xuICAgKiAgIFNwZWNpZmllcyBhIHBvaW50IG9uIHRoZSBzcGhlcmUgdG8gcHJvamVjdCBvbnRvIHRoZSBtYXAuXG4gICAqIEByZXR1cm4ge0FycmF5fSBbeCx5XSBjb29yZGluYXRlcy5cbiAgICovXG4gIF9wcm9qZWN0RmxhdChsbmdMYXQsIHNjYWxlID0gdGhpcy5zY2FsZSkge1xuICAgIHJldHVybiBwcm9qZWN0RmxhdChsbmdMYXQsIHNjYWxlKTtcbiAgfVxuXG4gIC8qKlxuICAgKiBVbnByb2plY3Qgd29ybGQgcG9pbnQgW3gseV0gb24gbWFwIG9udG8ge2xhdCwgbG9ufSBvbiBzcGhlcmVcbiAgICpcbiAgICogQHBhcmFtIHtvYmplY3R8VmVjdG9yfSB4eSAtIG9iamVjdCB3aXRoIHt4LHl9IG1lbWJlcnNcbiAgICogIHJlcHJlc2VudGluZyBwb2ludCBvbiBwcm9qZWN0ZWQgbWFwIHBsYW5lXG4gICAqIEByZXR1cm4ge0dlb0Nvb3JkaW5hdGVzfSAtIG9iamVjdCB3aXRoIHtsYXQsbG9ufSBvZiBwb2ludCBvbiBzcGhlcmUuXG4gICAqICAgSGFzIHRvQXJyYXkgbWV0aG9kIGlmIHlvdSBuZWVkIGEgR2VvSlNPTiBBcnJheS5cbiAgICogICBQZXIgY2FydG9ncmFwaGljIHRyYWRpdGlvbiwgbGF0IGFuZCBsb24gYXJlIHNwZWNpZmllZCBhcyBkZWdyZWVzLlxuICAgKi9cbiAgX3VucHJvamVjdEZsYXQoeHksIHNjYWxlID0gdGhpcy5zY2FsZSkge1xuICAgIHJldHVybiB1bnByb2plY3RGbGF0KHh5LCBzY2FsZSk7XG4gIH1cblxuICBnZXRMb2NhdGlvbkF0UG9pbnQoe2xuZ0xhdCwgcG9zfSkge1xuICAgIGNvbnN0IGMgPSB0aGlzLnByb2plY3QobG5nTGF0LCB7dG9wTGVmdDogZmFsc2V9KTtcbiAgICBjb25zdCBjb29yZENlbnRlciA9IHRoaXMucHJvamVjdChbdGhpcy5sb25naXR1ZGUsIHRoaXMubGF0aXR1ZGVdLCB7dG9wTGVmdDogZmFsc2V9KTtcbiAgICBjb25zdCBjb29yZEF0UG9pbnQgPSBwb3M7XG4gICAgY29uc3QgdHJhbnNsYXRlID0gdmVjMi5zdWIoW10sIGNvb3JkQXRQb2ludCwgYyk7XG4gICAgY29uc3QgbmV3UG9zID0gdmVjMi5zdWIoW10sIGNvb3JkQ2VudGVyLCB0cmFuc2xhdGUpO1xuICAgIGNvbnN0IG5ld0xuZ0xhdCA9IHRoaXMudW5wcm9qZWN0KG5ld1Bvcywge3RvcExlZnQ6IGZhbHNlfSk7XG5cbiAgICByZXR1cm4gbmV3TG5nTGF0O1xuICB9XG5cbiAgLypcbiAgZ2V0TG5nTGF0QXRWaWV3cG9ydFBvc2l0aW9uKGxuZ2xhdCwgeHkpIHtcbiAgICBjb25zdCBjID0gdGhpcy5sb2NhdGlvbkNvb3JkaW5hdGUobG5nbGF0KTtcbiAgICBjb25zdCBjb29yZEF0UG9pbnQgPSB0aGlzLnBvaW50Q29vcmRpbmF0ZSh4eSk7XG4gICAgY29uc3QgY29vcmRDZW50ZXIgPSB0aGlzLnBvaW50Q29vcmRpbmF0ZSh0aGlzLmNlbnRlclBvaW50KTtcbiAgICBjb25zdCB0cmFuc2xhdGUgPSBjb29yZEF0UG9pbnQuX3N1YihjKTtcbiAgICB0aGlzLmNlbnRlciA9IHRoaXMuY29vcmRpbmF0ZUxvY2F0aW9uKGNvb3JkQ2VudGVyLl9zdWIodHJhbnNsYXRlKSk7XG4gIH1cbiAgKi9cblxuICBnZXREaXN0YW5jZVNjYWxlcygpIHtcbiAgICByZXR1cm4gdGhpcy5fZGlzdGFuY2VTY2FsZXM7XG4gIH1cblxuICAvKipcbiAgICogQ29udmVydHMgYSBtZXRlciBvZmZzZXQgdG8gYSBsbmdsYXQgb2Zmc2V0XG4gICAqXG4gICAqIE5vdGU6IFVzZXMgc2ltcGxlIGxpbmVhciBhcHByb3hpbWF0aW9uIGFyb3VuZCB0aGUgdmlld3BvcnQgY2VudGVyXG4gICAqIEVycm9yIGluY3JlYXNlcyB3aXRoIHNpemUgb2Ygb2Zmc2V0IChyb3VnaGx5IDElIHBlciAxMDBrbSlcbiAgICpcbiAgICogQHBhcmFtIHtbTnVtYmVyLE51bWJlcl18W051bWJlcixOdW1iZXIsTnVtYmVyXSkgeHl6IC0gYXJyYXkgb2YgbWV0ZXIgZGVsdGFzXG4gICAqIEByZXR1cm4ge1tOdW1iZXIsTnVtYmVyXXxbTnVtYmVyLE51bWJlcixOdW1iZXJdKSAtIGFycmF5IG9mIFtsbmcsbGF0LHpdIGRlbHRhc1xuICAgKi9cbiAgbWV0ZXJzVG9MbmdMYXREZWx0YSh4eXopIHtcbiAgICBjb25zdCBbeCwgeSwgeiA9IDBdID0geHl6O1xuICAgIGFzc2VydChOdW1iZXIuaXNGaW5pdGUoeCkgJiYgTnVtYmVyLmlzRmluaXRlKHkpICYmIE51bWJlci5pc0Zpbml0ZSh6KSwgRVJSX0FSR1VNRU5UKTtcbiAgICBjb25zdCB7cGl4ZWxzUGVyTWV0ZXIsIGRlZ3JlZXNQZXJQaXhlbH0gPSB0aGlzLl9kaXN0YW5jZVNjYWxlcztcbiAgICBjb25zdCBkZWx0YUxuZyA9IHggKiBwaXhlbHNQZXJNZXRlclswXSAqIGRlZ3JlZXNQZXJQaXhlbFswXTtcbiAgICBjb25zdCBkZWx0YUxhdCA9IHkgKiBwaXhlbHNQZXJNZXRlclsxXSAqIGRlZ3JlZXNQZXJQaXhlbFsxXTtcbiAgICByZXR1cm4geHl6Lmxlbmd0aCA9PT0gMiA/IFtkZWx0YUxuZywgZGVsdGFMYXRdIDogW2RlbHRhTG5nLCBkZWx0YUxhdCwgel07XG4gIH1cblxuICAvKipcbiAgICogQ29udmVydHMgYSBsbmdsYXQgb2Zmc2V0IHRvIGEgbWV0ZXIgb2Zmc2V0XG4gICAqXG4gICAqIE5vdGU6IFVzZXMgc2ltcGxlIGxpbmVhciBhcHByb3hpbWF0aW9uIGFyb3VuZCB0aGUgdmlld3BvcnQgY2VudGVyXG4gICAqIEVycm9yIGluY3JlYXNlcyB3aXRoIHNpemUgb2Ygb2Zmc2V0IChyb3VnaGx5IDElIHBlciAxMDBrbSlcbiAgICpcbiAgICogQHBhcmFtIHtbTnVtYmVyLE51bWJlcl18W051bWJlcixOdW1iZXIsTnVtYmVyXSkgZGVsdGFMbmdMYXRaIC0gYXJyYXkgb2YgW2xuZyxsYXQsel0gZGVsdGFzXG4gICAqIEByZXR1cm4ge1tOdW1iZXIsTnVtYmVyXXxbTnVtYmVyLE51bWJlcixOdW1iZXJdKSAtIGFycmF5IG9mIG1ldGVyIGRlbHRhc1xuICAgKi9cbiAgbG5nTGF0RGVsdGFUb01ldGVycyhkZWx0YUxuZ0xhdFopIHtcbiAgICBjb25zdCBbZGVsdGFMbmcsIGRlbHRhTGF0LCBkZWx0YVogPSAwXSA9IGRlbHRhTG5nTGF0WjtcbiAgICBhc3NlcnQoTnVtYmVyLmlzRmluaXRlKGRlbHRhTG5nKSAmJiBOdW1iZXIuaXNGaW5pdGUoZGVsdGFMYXQpICYmIE51bWJlci5pc0Zpbml0ZShkZWx0YVopLFxuICAgICAgRVJSX0FSR1VNRU5UKTtcbiAgICBjb25zdCB7cGl4ZWxzUGVyRGVncmVlLCBtZXRlcnNQZXJQaXhlbH0gPSB0aGlzLl9kaXN0YW5jZVNjYWxlcztcbiAgICBjb25zdCBkZWx0YVggPSBkZWx0YUxuZyAqIHBpeGVsc1BlckRlZ3JlZVswXSAqIG1ldGVyc1BlclBpeGVsWzBdO1xuICAgIGNvbnN0IGRlbHRhWSA9IGRlbHRhTGF0ICogcGl4ZWxzUGVyRGVncmVlWzFdICogbWV0ZXJzUGVyUGl4ZWxbMV07XG4gICAgcmV0dXJuIGRlbHRhTG5nTGF0Wi5sZW5ndGggPT09IDIgPyBbZGVsdGFYLCBkZWx0YVldIDogW2RlbHRhWCwgZGVsdGFZLCBkZWx0YVpdO1xuICB9XG5cbiAgLyoqXG4gICAqIEFkZCBhIG1ldGVyIGRlbHRhIHRvIGEgYmFzZSBsbmdsYXQgY29vcmRpbmF0ZSwgcmV0dXJuaW5nIGEgbmV3IGxuZ2xhdCBhcnJheVxuICAgKlxuICAgKiBOb3RlOiBVc2VzIHNpbXBsZSBsaW5lYXIgYXBwcm94aW1hdGlvbiBhcm91bmQgdGhlIHZpZXdwb3J0IGNlbnRlclxuICAgKiBFcnJvciBpbmNyZWFzZXMgd2l0aCBzaXplIG9mIG9mZnNldCAocm91Z2hseSAxJSBwZXIgMTAwa20pXG4gICAqXG4gICAqIEBwYXJhbSB7W051bWJlcixOdW1iZXJdfFtOdW1iZXIsTnVtYmVyLE51bWJlcl0pIGxuZ0xhdFogLSBiYXNlIGNvb3JkaW5hdGVcbiAgICogQHBhcmFtIHtbTnVtYmVyLE51bWJlcl18W051bWJlcixOdW1iZXIsTnVtYmVyXSkgeHl6IC0gYXJyYXkgb2YgbWV0ZXIgZGVsdGFzXG4gICAqIEByZXR1cm4ge1tOdW1iZXIsTnVtYmVyXXxbTnVtYmVyLE51bWJlcixOdW1iZXJdKSBhcnJheSBvZiBbbG5nLGxhdCx6XSBkZWx0YXNcbiAgICovXG4gIGFkZE1ldGVyc1RvTG5nTGF0KGxuZ0xhdFosIHh5eikge1xuICAgIGNvbnN0IFtsbmcsIGxhdCwgWiA9IDBdID0gbG5nTGF0WjtcbiAgICBjb25zdCBbZGVsdGFMbmcsIGRlbHRhTGF0LCBkZWx0YVogPSAwXSA9IHRoaXMubWV0ZXJzVG9MbmdMYXREZWx0YSh4eXopO1xuICAgIHJldHVybiBsbmdMYXRaLmxlbmd0aCA9PT0gMiA/XG4gICAgICBbbG5nICsgZGVsdGFMbmcsIGxhdCArIGRlbHRhTGF0XSA6XG4gICAgICBbbG5nICsgZGVsdGFMbmcsIGxhdCArIGRlbHRhTGF0LCBaICsgZGVsdGFaXTtcbiAgfVxuXG4gIC8vIElOVEVSTkFMIE1FVEhPRFNcblxuICBfZ2V0UGFyYW1zKCkge1xuICAgIHJldHVybiB0aGlzLl9kaXN0YW5jZVNjYWxlcztcbiAgfVxufVxuXG4vKipcbiAqIFByb2plY3QgW2xuZyxsYXRdIG9uIHNwaGVyZSBvbnRvIFt4LHldIG9uIDUxMio1MTIgTWVyY2F0b3IgWm9vbSAwIHRpbGUuXG4gKiBQZXJmb3JtcyB0aGUgbm9ubGluZWFyIHBhcnQgb2YgdGhlIHdlYiBtZXJjYXRvciBwcm9qZWN0aW9uLlxuICogUmVtYWluaW5nIHByb2plY3Rpb24gaXMgZG9uZSB3aXRoIDR4NCBtYXRyaWNlcyB3aGljaCBhbHNvIGhhbmRsZXNcbiAqIHBlcnNwZWN0aXZlLlxuICpcbiAqIEBwYXJhbSB7QXJyYXl9IGxuZ0xhdCAtIFtsbmcsIGxhdF0gY29vcmRpbmF0ZXNcbiAqICAgU3BlY2lmaWVzIGEgcG9pbnQgb24gdGhlIHNwaGVyZSB0byBwcm9qZWN0IG9udG8gdGhlIG1hcC5cbiAqIEByZXR1cm4ge0FycmF5fSBbeCx5XSBjb29yZGluYXRlcy5cbiAqL1xuZnVuY3Rpb24gcHJvamVjdEZsYXQoW2xuZywgbGF0XSwgc2NhbGUpIHtcbiAgc2NhbGUgPSBzY2FsZSAqIFdPUkxEX1NDQUxFO1xuICBjb25zdCBsYW1iZGEyID0gbG5nICogREVHUkVFU19UT19SQURJQU5TO1xuICBjb25zdCBwaGkyID0gbGF0ICogREVHUkVFU19UT19SQURJQU5TO1xuICBjb25zdCB4ID0gc2NhbGUgKiAobGFtYmRhMiArIFBJKSAvICgyICogUEkpO1xuICBjb25zdCB5ID0gc2NhbGUgKiAoUEkgLSBNYXRoLmxvZyhNYXRoLnRhbihQSV80ICsgcGhpMiAqIDAuNSkpKSAvICgyICogUEkpO1xuICByZXR1cm4gW3gsIHldO1xufVxuXG4vKipcbiAqIFVucHJvamVjdCB3b3JsZCBwb2ludCBbeCx5XSBvbiBtYXAgb250byB7bGF0LCBsb259IG9uIHNwaGVyZVxuICpcbiAqIEBwYXJhbSB7b2JqZWN0fFZlY3Rvcn0geHkgLSBvYmplY3Qgd2l0aCB7eCx5fSBtZW1iZXJzXG4gKiAgcmVwcmVzZW50aW5nIHBvaW50IG9uIHByb2plY3RlZCBtYXAgcGxhbmVcbiAqIEByZXR1cm4ge0dlb0Nvb3JkaW5hdGVzfSAtIG9iamVjdCB3aXRoIHtsYXQsbG9ufSBvZiBwb2ludCBvbiBzcGhlcmUuXG4gKiAgIEhhcyB0b0FycmF5IG1ldGhvZCBpZiB5b3UgbmVlZCBhIEdlb0pTT04gQXJyYXkuXG4gKiAgIFBlciBjYXJ0b2dyYXBoaWMgdHJhZGl0aW9uLCBsYXQgYW5kIGxvbiBhcmUgc3BlY2lmaWVkIGFzIGRlZ3JlZXMuXG4gKi9cbmZ1bmN0aW9uIHVucHJvamVjdEZsYXQoW3gsIHldLCBzY2FsZSkge1xuICBzY2FsZSA9IHNjYWxlICogV09STERfU0NBTEU7XG4gIGNvbnN0IGxhbWJkYTIgPSAoeCAvIHNjYWxlKSAqICgyICogUEkpIC0gUEk7XG4gIGNvbnN0IHBoaTIgPSAyICogKE1hdGguYXRhbihNYXRoLmV4cChQSSAtICh5IC8gc2NhbGUpICogKDIgKiBQSSkpKSAtIFBJXzQpO1xuICByZXR1cm4gW2xhbWJkYTIgKiBSQURJQU5TX1RPX0RFR1JFRVMsIHBoaTIgKiBSQURJQU5TX1RPX0RFR1JFRVNdO1xufVxuXG4vKipcbiAqIENhbGN1bGF0ZSBkaXN0YW5jZSBzY2FsZXMgaW4gbWV0ZXJzIGFyb3VuZCBjdXJyZW50IGxhdC9sb24sIGJvdGggZm9yXG4gKiBkZWdyZWVzIGFuZCBwaXhlbHMuXG4gKiBJbiBtZXJjYXRvciBwcm9qZWN0aW9uIG1vZGUsIHRoZSBkaXN0YW5jZSBzY2FsZXMgdmFyeSBzaWduaWZpY2FudGx5XG4gKiB3aXRoIGxhdGl0dWRlLlxuICovXG5mdW5jdGlvbiBjYWxjdWxhdGVEaXN0YW5jZVNjYWxlcyh7bGF0aXR1ZGUsIGxvbmdpdHVkZSwgc2NhbGV9KSB7XG4gIGFzc2VydCghaXNOYU4obGF0aXR1ZGUpICYmICFpc05hTihsb25naXR1ZGUpICYmICFpc05hTihzY2FsZSksIEVSUl9BUkdVTUVOVCk7XG4gIC8vIEFwcHJveGltYXRlbHkgMTExa20gcGVyIGRlZ3JlZSBhdCBlcXVhdG9yXG4gIGNvbnN0IE1FVEVSU19QRVJfREVHUkVFID0gMTExMDAwO1xuXG4gIGNvbnN0IGxhdENvc2luZSA9IE1hdGguY29zKGxhdGl0dWRlICogTWF0aC5QSSAvIDE4MCk7XG5cbiAgY29uc3QgbWV0ZXJzUGVyRGVncmVlID0gTUVURVJTX1BFUl9ERUdSRUUgKiBsYXRDb3NpbmU7XG5cbiAgLy8gQ2FsY3VsYXRlIG51bWJlciBvZiBwaXhlbHMgb2NjdXBpZWQgYnkgb25lIGRlZ3JlZSBsb25naXR1ZGVcbiAgLy8gYXJvdW5kIGN1cnJlbnQgbGF0L2xvblxuICBjb25zdCBwaXhlbHNQZXJEZWdyZWVYID0gdmVjMi5kaXN0YW5jZShcbiAgICBwcm9qZWN0RmxhdChbbG9uZ2l0dWRlICsgMC41LCBsYXRpdHVkZV0sIHNjYWxlKSxcbiAgICBwcm9qZWN0RmxhdChbbG9uZ2l0dWRlIC0gMC41LCBsYXRpdHVkZV0sIHNjYWxlKVxuICApO1xuICAvLyBDYWxjdWxhdGUgbnVtYmVyIG9mIHBpeGVscyBvY2N1cGllZCBieSBvbmUgZGVncmVlIGxhdGl0dWRlXG4gIC8vIGFyb3VuZCBjdXJyZW50IGxhdC9sb25cbiAgY29uc3QgcGl4ZWxzUGVyRGVncmVlWSA9IHZlYzIuZGlzdGFuY2UoXG4gICAgcHJvamVjdEZsYXQoW2xvbmdpdHVkZSwgbGF0aXR1ZGUgKyAwLjVdLCBzY2FsZSksXG4gICAgcHJvamVjdEZsYXQoW2xvbmdpdHVkZSwgbGF0aXR1ZGUgLSAwLjVdLCBzY2FsZSlcbiAgKTtcblxuICBjb25zdCBwaXhlbHNQZXJNZXRlclggPSBwaXhlbHNQZXJEZWdyZWVYIC8gbWV0ZXJzUGVyRGVncmVlO1xuICBjb25zdCBwaXhlbHNQZXJNZXRlclkgPSBwaXhlbHNQZXJEZWdyZWVZIC8gbWV0ZXJzUGVyRGVncmVlO1xuICBjb25zdCBwaXhlbHNQZXJNZXRlclogPSAocGl4ZWxzUGVyTWV0ZXJYICsgcGl4ZWxzUGVyTWV0ZXJZKSAvIDI7XG4gIC8vIGNvbnN0IHBpeGVsc1Blck1ldGVyID0gW3BpeGVsc1Blck1ldGVyWCwgcGl4ZWxzUGVyTWV0ZXJZLCBwaXhlbHNQZXJNZXRlclpdO1xuXG4gIGNvbnN0IHdvcmxkU2l6ZSA9IFRJTEVfU0laRSAqIHNjYWxlO1xuICBjb25zdCBhbHRQaXhlbHNQZXJNZXRlciA9IHdvcmxkU2l6ZSAvICg0ZTcgKiBsYXRDb3NpbmUpO1xuICBjb25zdCBwaXhlbHNQZXJNZXRlciA9IFthbHRQaXhlbHNQZXJNZXRlciwgYWx0UGl4ZWxzUGVyTWV0ZXIsIGFsdFBpeGVsc1Blck1ldGVyXTtcbiAgY29uc3QgbWV0ZXJzUGVyUGl4ZWwgPSBbMSAvIGFsdFBpeGVsc1Blck1ldGVyLCAxIC8gYWx0UGl4ZWxzUGVyTWV0ZXIsIDEgLyBwaXhlbHNQZXJNZXRlclpdO1xuXG4gIGNvbnN0IHBpeGVsc1BlckRlZ3JlZSA9IFtwaXhlbHNQZXJEZWdyZWVYLCBwaXhlbHNQZXJEZWdyZWVZLCBwaXhlbHNQZXJNZXRlclpdO1xuICBjb25zdCBkZWdyZWVzUGVyUGl4ZWwgPSBbMSAvIHBpeGVsc1BlckRlZ3JlZVgsIDEgLyBwaXhlbHNQZXJEZWdyZWVZLCAxIC8gcGl4ZWxzUGVyTWV0ZXJaXTtcblxuICAvLyBNYWluIHJlc3VsdHMsIHVzZWQgZm9yIGNvbnZlcnRpbmcgbWV0ZXJzIHRvIGxhdGxuZyBkZWx0YXMgYW5kIHNjYWxpbmcgb2Zmc2V0c1xuICByZXR1cm4ge1xuICAgIHBpeGVsc1Blck1ldGVyLFxuICAgIG1ldGVyc1BlclBpeGVsLFxuICAgIHBpeGVsc1BlckRlZ3JlZSxcbiAgICBkZWdyZWVzUGVyUGl4ZWxcbiAgfTtcbn1cblxuLy8gQVRUUklCVVRJT046XG4vLyB2aWV3IGFuZCBwcm9qZWN0aW9uIG1hdHJpeCBjcmVhdGlvbiBpcyBpbnRlbnRpb25hbGx5IGtlcHQgY29tcGF0aWJsZSB3aXRoXG4vLyBtYXBib3gtZ2wncyBpbXBsZW1lbnRhdGlvbiB0byBlbnN1cmUgdGhhdCBzZWFtbGVzcyBpbnRlcm9wZXJhdGlvblxuLy8gd2l0aCBtYXBib3ggYW5kIHJlYWN0LW1hcC1nbC4gU2VlOiBodHRwczovL2dpdGh1Yi5jb20vbWFwYm94L21hcGJveC1nbC1qc1xuXG4vLyBWYXJpYWJsZSBmb3YgKGluIHJhZGlhbnMpXG5leHBvcnQgZnVuY3Rpb24gZ2V0Rm92KHtoZWlnaHQsIGFsdGl0dWRlfSkge1xuICByZXR1cm4gMiAqIE1hdGguYXRhbigoaGVpZ2h0IC8gMikgLyBhbHRpdHVkZSk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBnZXRDbGlwcGluZ1BsYW5lcyh7YWx0aXR1ZGUsIHBpdGNofSkge1xuICAvLyBGaW5kIHRoZSBkaXN0YW5jZSBmcm9tIHRoZSBjZW50ZXIgcG9pbnQgdG8gdGhlIGNlbnRlciB0b3BcbiAgLy8gaW4gYWx0aXR1ZGUgdW5pdHMgdXNpbmcgbGF3IG9mIHNpbmVzLlxuICBjb25zdCBwaXRjaFJhZGlhbnMgPSBwaXRjaCAqIERFR1JFRVNfVE9fUkFESUFOUztcbiAgY29uc3QgaGFsZkZvdiA9IE1hdGguYXRhbigwLjUgLyBhbHRpdHVkZSk7XG4gIGNvbnN0IHRvcEhhbGZTdXJmYWNlRGlzdGFuY2UgPVxuICAgIE1hdGguc2luKGhhbGZGb3YpICogYWx0aXR1ZGUgLyBNYXRoLnNpbihNYXRoLlBJIC8gMiAtIHBpdGNoUmFkaWFucyAtIGhhbGZGb3YpO1xuXG4gIC8vIENhbGN1bGF0ZSB6IHZhbHVlIG9mIHRoZSBmYXJ0aGVzdCBmcmFnbWVudCB0aGF0IHNob3VsZCBiZSByZW5kZXJlZC5cbiAgY29uc3QgZmFyWiA9IE1hdGguY29zKE1hdGguUEkgLyAyIC0gcGl0Y2hSYWRpYW5zKSAqIHRvcEhhbGZTdXJmYWNlRGlzdGFuY2UgKyBhbHRpdHVkZTtcblxuICByZXR1cm4ge2ZhclosIG5lYXJaOiAwLjF9O1xufVxuXG4vLyBQUk9KRUNUSU9OIE1BVFJJWDogUFJPSkVDVFMgRlJPTSBDQU1FUkEgKFZJRVcpIFNQQUNFIFRPIENMSVBTUEFDRVxuZXhwb3J0IGZ1bmN0aW9uIG1ha2VQcm9qZWN0aW9uTWF0cml4RnJvbU1lcmNhdG9yUGFyYW1zKHtcbiAgd2lkdGgsXG4gIGhlaWdodCxcbiAgcGl0Y2gsXG4gIGFsdGl0dWRlLFxuICBmYXJaTXVsdGlwbGllciA9IDEwXG59KSB7XG4gIGNvbnN0IHtuZWFyWiwgZmFyWn0gPSBnZXRDbGlwcGluZ1BsYW5lcyh7YWx0aXR1ZGUsIHBpdGNofSk7XG4gIGNvbnN0IGZvdiA9IGdldEZvdih7aGVpZ2h0LCBhbHRpdHVkZX0pO1xuXG4gIGNvbnN0IHByb2plY3Rpb25NYXRyaXggPSBtYXQ0LnBlcnNwZWN0aXZlKFxuICAgIGNyZWF0ZU1hdDQoKSxcbiAgICBmb3YsICAgICAgICAgICAgICAvLyBmb3YgaW4gcmFkaWFuc1xuICAgIHdpZHRoIC8gaGVpZ2h0LCAgIC8vIGFzcGVjdCByYXRpb1xuICAgIG5lYXJaLCAgICAgICAgICAgIC8vIG5lYXIgcGxhbmVcbiAgICBmYXJaICogZmFyWk11bHRpcGxpZXIgLy8gZmFyIHBsYW5lXG4gICk7XG5cbiAgcmV0dXJuIHByb2plY3Rpb25NYXRyaXg7XG59XG5cbmZ1bmN0aW9uIG1ha2VVbmNlbnRlcmVkVmlld01hdHJpeEZyb21NZXJjYXRvclBhcmFtcyh7XG4gIHdpZHRoLFxuICBoZWlnaHQsXG4gIGxvbmdpdHVkZSxcbiAgbGF0aXR1ZGUsXG4gIHpvb20sXG4gIHBpdGNoLFxuICBiZWFyaW5nLFxuICBhbHRpdHVkZSxcbiAgY2VudGVyXG59KSB7XG4gIC8vIFZJRVcgTUFUUklYOiBQUk9KRUNUUyBGUk9NIFZJUlRVQUwgUElYRUxTIFRPIENBTUVSQSBTUEFDRVxuICAvLyBOb3RlOiBBcyB1c3VhbCwgbWF0cml4IG9wZXJhdGlvbiBvcmRlcnMgc2hvdWxkIGJlIHJlYWQgaW4gcmV2ZXJzZVxuICAvLyBzaW5jZSB2ZWN0b3JzIHdpbGwgYmUgbXVsdGlwbGllZCBmcm9tIHRoZSByaWdodCBkdXJpbmcgdHJhbnNmb3JtYXRpb25cbiAgY29uc3Qgdm0gPSBjcmVhdGVNYXQ0KCk7XG5cbiAgLy8gTW92ZSBjYW1lcmEgdG8gYWx0aXR1ZGVcbiAgbWF0NC50cmFuc2xhdGUodm0sIHZtLCBbMCwgMCwgLWFsdGl0dWRlXSk7XG5cbiAgLy8gQWZ0ZXIgdGhlIHJvdGF0ZVgsIHogdmFsdWVzIGFyZSBpbiBwaXhlbCB1bml0cy4gQ29udmVydCB0aGVtIHRvXG4gIC8vIGFsdGl0dWRlIHVuaXRzLiAxIGFsdGl0dWRlIHVuaXQgPSB0aGUgc2NyZWVuIGhlaWdodC5cbiAgbWF0NC5zY2FsZSh2bSwgdm0sIFsxLCAtMSwgMSAvIGhlaWdodF0pO1xuXG4gIC8vIFJvdGF0ZSBieSBiZWFyaW5nLCBhbmQgdGhlbiBieSBwaXRjaCAod2hpY2ggdGlsdHMgdGhlIHZpZXcpXG4gIG1hdDQucm90YXRlWCh2bSwgdm0sIHBpdGNoICogREVHUkVFU19UT19SQURJQU5TKTtcbiAgbWF0NC5yb3RhdGVaKHZtLCB2bSwgLWJlYXJpbmcgKiBERUdSRUVTX1RPX1JBRElBTlMpO1xuXG4gIHJldHVybiB2bTtcbn1cbiJdfQ==

/***/ },
/* 396 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = autobind;
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var PREDEFINED = ['constructor', 'render', 'componentWillMount', 'componentDidMount', 'componentWillReceiveProps', 'shouldComponentUpdate', 'componentWillUpdate', 'componentDidUpdate', 'componentWillUnmount'];
	
	/**
	 * Binds the "this" argument of all functions on a class instance to the instance
	 * @param {Object} obj - class instance (typically a react component)
	 */
	function autobind(obj) {
	  var proto = Object.getPrototypeOf(obj);
	  var propNames = Object.getOwnPropertyNames(proto);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    var _loop = function _loop() {
	      var key = _step.value;
	
	      if (typeof obj[key] === 'function') {
	        if (!PREDEFINED.find(function (name) {
	          return key === name;
	        })) {
	          obj[key] = obj[key].bind(obj);
	        }
	      }
	    };
	
	    for (var _iterator = propNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      _loop();
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fp = __webpack_require__(839);
	
	Object.keys(_fp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _fp[key];
	    }
	  });
	});
	
	var _project = __webpack_require__(843);
	
	Object.keys(_project).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _project[key];
	    }
	  });
	});
	
	var _project2 = __webpack_require__(845);
	
	Object.keys(_project2).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _project2[key];
	    }
	  });
	});
	
	var _lighting = __webpack_require__(841);
	
	Object.keys(_lighting).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _lighting[key];
	    }
	  });
	});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 398 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultColorRange = exports.defaultColorRange = [[255, 255, 178], [254, 217, 118], [254, 178, 76], [253, 141, 60], [240, 59, 32], [189, 0, 38]];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 399 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.linearScale = linearScale;
	exports.quantizeScale = quantizeScale;
	exports.clamp = clamp;
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Linear scale maps continuous domain to continuous range
	function linearScale(domain, range, value) {
	
	  return (value - domain[0]) / (domain[1] - domain[0]) * (range[1] - range[0]) + range[0];
	}
	
	// Quantize scale is similar to linear scales,
	// except it uses a discrete rather than continuous range
	function quantizeScale(domain, range, value) {
	  var step = (domain[1] - domain[0]) / range.length;
	  var idx = Math.floor((value - domain[0]) / step);
	  var clampIdx = Math.max(Math.min(idx, range.length - 1), 0);
	
	  return range[clampIdx];
	}
	
	function clamp(_ref, value) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  return Math.min(max, Math.max(min, value));
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 400 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(36);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 402 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 403 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var glMatrix = __webpack_require__(81);
	
	/**
	 * @class 3x3 Matrix
	 * @name mat3
	 */
	var mat3 = {};
	
	/**
	 * Creates a new identity mat3
	 *
	 * @returns {mat3} a new 3x3 matrix
	 */
	mat3.create = function() {
	    var out = new glMatrix.ARRAY_TYPE(9);
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 1;
	    out[5] = 0;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 1;
	    return out;
	};
	
	/**
	 * Copies the upper-left 3x3 values into the given mat3.
	 *
	 * @param {mat3} out the receiving 3x3 matrix
	 * @param {mat4} a   the source 4x4 matrix
	 * @returns {mat3} out
	 */
	mat3.fromMat4 = function(out, a) {
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[4];
	    out[4] = a[5];
	    out[5] = a[6];
	    out[6] = a[8];
	    out[7] = a[9];
	    out[8] = a[10];
	    return out;
	};
	
	/**
	 * Creates a new mat3 initialized with values from an existing matrix
	 *
	 * @param {mat3} a matrix to clone
	 * @returns {mat3} a new 3x3 matrix
	 */
	mat3.clone = function(a) {
	    var out = new glMatrix.ARRAY_TYPE(9);
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    out[4] = a[4];
	    out[5] = a[5];
	    out[6] = a[6];
	    out[7] = a[7];
	    out[8] = a[8];
	    return out;
	};
	
	/**
	 * Copy the values from one mat3 to another
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the source matrix
	 * @returns {mat3} out
	 */
	mat3.copy = function(out, a) {
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    out[4] = a[4];
	    out[5] = a[5];
	    out[6] = a[6];
	    out[7] = a[7];
	    out[8] = a[8];
	    return out;
	};
	
	/**
	 * Create a new mat3 with the given values
	 *
	 * @param {Number} m00 Component in column 0, row 0 position (index 0)
	 * @param {Number} m01 Component in column 0, row 1 position (index 1)
	 * @param {Number} m02 Component in column 0, row 2 position (index 2)
	 * @param {Number} m10 Component in column 1, row 0 position (index 3)
	 * @param {Number} m11 Component in column 1, row 1 position (index 4)
	 * @param {Number} m12 Component in column 1, row 2 position (index 5)
	 * @param {Number} m20 Component in column 2, row 0 position (index 6)
	 * @param {Number} m21 Component in column 2, row 1 position (index 7)
	 * @param {Number} m22 Component in column 2, row 2 position (index 8)
	 * @returns {mat3} A new mat3
	 */
	mat3.fromValues = function(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
	    var out = new glMatrix.ARRAY_TYPE(9);
	    out[0] = m00;
	    out[1] = m01;
	    out[2] = m02;
	    out[3] = m10;
	    out[4] = m11;
	    out[5] = m12;
	    out[6] = m20;
	    out[7] = m21;
	    out[8] = m22;
	    return out;
	};
	
	/**
	 * Set the components of a mat3 to the given values
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {Number} m00 Component in column 0, row 0 position (index 0)
	 * @param {Number} m01 Component in column 0, row 1 position (index 1)
	 * @param {Number} m02 Component in column 0, row 2 position (index 2)
	 * @param {Number} m10 Component in column 1, row 0 position (index 3)
	 * @param {Number} m11 Component in column 1, row 1 position (index 4)
	 * @param {Number} m12 Component in column 1, row 2 position (index 5)
	 * @param {Number} m20 Component in column 2, row 0 position (index 6)
	 * @param {Number} m21 Component in column 2, row 1 position (index 7)
	 * @param {Number} m22 Component in column 2, row 2 position (index 8)
	 * @returns {mat3} out
	 */
	mat3.set = function(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
	    out[0] = m00;
	    out[1] = m01;
	    out[2] = m02;
	    out[3] = m10;
	    out[4] = m11;
	    out[5] = m12;
	    out[6] = m20;
	    out[7] = m21;
	    out[8] = m22;
	    return out;
	};
	
	/**
	 * Set a mat3 to the identity matrix
	 *
	 * @param {mat3} out the receiving matrix
	 * @returns {mat3} out
	 */
	mat3.identity = function(out) {
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 1;
	    out[5] = 0;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 1;
	    return out;
	};
	
	/**
	 * Transpose the values of a mat3
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the source matrix
	 * @returns {mat3} out
	 */
	mat3.transpose = function(out, a) {
	    // If we are transposing ourselves we can skip a few steps but have to cache some values
	    if (out === a) {
	        var a01 = a[1], a02 = a[2], a12 = a[5];
	        out[1] = a[3];
	        out[2] = a[6];
	        out[3] = a01;
	        out[5] = a[7];
	        out[6] = a02;
	        out[7] = a12;
	    } else {
	        out[0] = a[0];
	        out[1] = a[3];
	        out[2] = a[6];
	        out[3] = a[1];
	        out[4] = a[4];
	        out[5] = a[7];
	        out[6] = a[2];
	        out[7] = a[5];
	        out[8] = a[8];
	    }
	    
	    return out;
	};
	
	/**
	 * Inverts a mat3
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the source matrix
	 * @returns {mat3} out
	 */
	mat3.invert = function(out, a) {
	    var a00 = a[0], a01 = a[1], a02 = a[2],
	        a10 = a[3], a11 = a[4], a12 = a[5],
	        a20 = a[6], a21 = a[7], a22 = a[8],
	
	        b01 = a22 * a11 - a12 * a21,
	        b11 = -a22 * a10 + a12 * a20,
	        b21 = a21 * a10 - a11 * a20,
	
	        // Calculate the determinant
	        det = a00 * b01 + a01 * b11 + a02 * b21;
	
	    if (!det) { 
	        return null; 
	    }
	    det = 1.0 / det;
	
	    out[0] = b01 * det;
	    out[1] = (-a22 * a01 + a02 * a21) * det;
	    out[2] = (a12 * a01 - a02 * a11) * det;
	    out[3] = b11 * det;
	    out[4] = (a22 * a00 - a02 * a20) * det;
	    out[5] = (-a12 * a00 + a02 * a10) * det;
	    out[6] = b21 * det;
	    out[7] = (-a21 * a00 + a01 * a20) * det;
	    out[8] = (a11 * a00 - a01 * a10) * det;
	    return out;
	};
	
	/**
	 * Calculates the adjugate of a mat3
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the source matrix
	 * @returns {mat3} out
	 */
	mat3.adjoint = function(out, a) {
	    var a00 = a[0], a01 = a[1], a02 = a[2],
	        a10 = a[3], a11 = a[4], a12 = a[5],
	        a20 = a[6], a21 = a[7], a22 = a[8];
	
	    out[0] = (a11 * a22 - a12 * a21);
	    out[1] = (a02 * a21 - a01 * a22);
	    out[2] = (a01 * a12 - a02 * a11);
	    out[3] = (a12 * a20 - a10 * a22);
	    out[4] = (a00 * a22 - a02 * a20);
	    out[5] = (a02 * a10 - a00 * a12);
	    out[6] = (a10 * a21 - a11 * a20);
	    out[7] = (a01 * a20 - a00 * a21);
	    out[8] = (a00 * a11 - a01 * a10);
	    return out;
	};
	
	/**
	 * Calculates the determinant of a mat3
	 *
	 * @param {mat3} a the source matrix
	 * @returns {Number} determinant of a
	 */
	mat3.determinant = function (a) {
	    var a00 = a[0], a01 = a[1], a02 = a[2],
	        a10 = a[3], a11 = a[4], a12 = a[5],
	        a20 = a[6], a21 = a[7], a22 = a[8];
	
	    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
	};
	
	/**
	 * Multiplies two mat3's
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the first operand
	 * @param {mat3} b the second operand
	 * @returns {mat3} out
	 */
	mat3.multiply = function (out, a, b) {
	    var a00 = a[0], a01 = a[1], a02 = a[2],
	        a10 = a[3], a11 = a[4], a12 = a[5],
	        a20 = a[6], a21 = a[7], a22 = a[8],
	
	        b00 = b[0], b01 = b[1], b02 = b[2],
	        b10 = b[3], b11 = b[4], b12 = b[5],
	        b20 = b[6], b21 = b[7], b22 = b[8];
	
	    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
	    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
	    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
	
	    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
	    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
	    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
	
	    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
	    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
	    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
	    return out;
	};
	
	/**
	 * Alias for {@link mat3.multiply}
	 * @function
	 */
	mat3.mul = mat3.multiply;
	
	/**
	 * Translate a mat3 by the given vector
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the matrix to translate
	 * @param {vec2} v vector to translate by
	 * @returns {mat3} out
	 */
	mat3.translate = function(out, a, v) {
	    var a00 = a[0], a01 = a[1], a02 = a[2],
	        a10 = a[3], a11 = a[4], a12 = a[5],
	        a20 = a[6], a21 = a[7], a22 = a[8],
	        x = v[0], y = v[1];
	
	    out[0] = a00;
	    out[1] = a01;
	    out[2] = a02;
	
	    out[3] = a10;
	    out[4] = a11;
	    out[5] = a12;
	
	    out[6] = x * a00 + y * a10 + a20;
	    out[7] = x * a01 + y * a11 + a21;
	    out[8] = x * a02 + y * a12 + a22;
	    return out;
	};
	
	/**
	 * Rotates a mat3 by the given angle
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat3} out
	 */
	mat3.rotate = function (out, a, rad) {
	    var a00 = a[0], a01 = a[1], a02 = a[2],
	        a10 = a[3], a11 = a[4], a12 = a[5],
	        a20 = a[6], a21 = a[7], a22 = a[8],
	
	        s = Math.sin(rad),
	        c = Math.cos(rad);
	
	    out[0] = c * a00 + s * a10;
	    out[1] = c * a01 + s * a11;
	    out[2] = c * a02 + s * a12;
	
	    out[3] = c * a10 - s * a00;
	    out[4] = c * a11 - s * a01;
	    out[5] = c * a12 - s * a02;
	
	    out[6] = a20;
	    out[7] = a21;
	    out[8] = a22;
	    return out;
	};
	
	/**
	 * Scales the mat3 by the dimensions in the given vec2
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the matrix to rotate
	 * @param {vec2} v the vec2 to scale the matrix by
	 * @returns {mat3} out
	 **/
	mat3.scale = function(out, a, v) {
	    var x = v[0], y = v[1];
	
	    out[0] = x * a[0];
	    out[1] = x * a[1];
	    out[2] = x * a[2];
	
	    out[3] = y * a[3];
	    out[4] = y * a[4];
	    out[5] = y * a[5];
	
	    out[6] = a[6];
	    out[7] = a[7];
	    out[8] = a[8];
	    return out;
	};
	
	/**
	 * Creates a matrix from a vector translation
	 * This is equivalent to (but much faster than):
	 *
	 *     mat3.identity(dest);
	 *     mat3.translate(dest, dest, vec);
	 *
	 * @param {mat3} out mat3 receiving operation result
	 * @param {vec2} v Translation vector
	 * @returns {mat3} out
	 */
	mat3.fromTranslation = function(out, v) {
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 1;
	    out[5] = 0;
	    out[6] = v[0];
	    out[7] = v[1];
	    out[8] = 1;
	    return out;
	}
	
	/**
	 * Creates a matrix from a given angle
	 * This is equivalent to (but much faster than):
	 *
	 *     mat3.identity(dest);
	 *     mat3.rotate(dest, dest, rad);
	 *
	 * @param {mat3} out mat3 receiving operation result
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat3} out
	 */
	mat3.fromRotation = function(out, rad) {
	    var s = Math.sin(rad), c = Math.cos(rad);
	
	    out[0] = c;
	    out[1] = s;
	    out[2] = 0;
	
	    out[3] = -s;
	    out[4] = c;
	    out[5] = 0;
	
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 1;
	    return out;
	}
	
	/**
	 * Creates a matrix from a vector scaling
	 * This is equivalent to (but much faster than):
	 *
	 *     mat3.identity(dest);
	 *     mat3.scale(dest, dest, vec);
	 *
	 * @param {mat3} out mat3 receiving operation result
	 * @param {vec2} v Scaling vector
	 * @returns {mat3} out
	 */
	mat3.fromScaling = function(out, v) {
	    out[0] = v[0];
	    out[1] = 0;
	    out[2] = 0;
	
	    out[3] = 0;
	    out[4] = v[1];
	    out[5] = 0;
	
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 1;
	    return out;
	}
	
	/**
	 * Copies the values from a mat2d into a mat3
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat2d} a the matrix to copy
	 * @returns {mat3} out
	 **/
	mat3.fromMat2d = function(out, a) {
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = 0;
	
	    out[3] = a[2];
	    out[4] = a[3];
	    out[5] = 0;
	
	    out[6] = a[4];
	    out[7] = a[5];
	    out[8] = 1;
	    return out;
	};
	
	/**
	* Calculates a 3x3 matrix from the given quaternion
	*
	* @param {mat3} out mat3 receiving operation result
	* @param {quat} q Quaternion to create matrix from
	*
	* @returns {mat3} out
	*/
	mat3.fromQuat = function (out, q) {
	    var x = q[0], y = q[1], z = q[2], w = q[3],
	        x2 = x + x,
	        y2 = y + y,
	        z2 = z + z,
	
	        xx = x * x2,
	        yx = y * x2,
	        yy = y * y2,
	        zx = z * x2,
	        zy = z * y2,
	        zz = z * z2,
	        wx = w * x2,
	        wy = w * y2,
	        wz = w * z2;
	
	    out[0] = 1 - yy - zz;
	    out[3] = yx - wz;
	    out[6] = zx + wy;
	
	    out[1] = yx + wz;
	    out[4] = 1 - xx - zz;
	    out[7] = zy - wx;
	
	    out[2] = zx - wy;
	    out[5] = zy + wx;
	    out[8] = 1 - xx - yy;
	
	    return out;
	};
	
	/**
	* Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
	*
	* @param {mat3} out mat3 receiving operation result
	* @param {mat4} a Mat4 to derive the normal matrix from
	*
	* @returns {mat3} out
	*/
	mat3.normalFromMat4 = function (out, a) {
	    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
	        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
	        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
	        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],
	
	        b00 = a00 * a11 - a01 * a10,
	        b01 = a00 * a12 - a02 * a10,
	        b02 = a00 * a13 - a03 * a10,
	        b03 = a01 * a12 - a02 * a11,
	        b04 = a01 * a13 - a03 * a11,
	        b05 = a02 * a13 - a03 * a12,
	        b06 = a20 * a31 - a21 * a30,
	        b07 = a20 * a32 - a22 * a30,
	        b08 = a20 * a33 - a23 * a30,
	        b09 = a21 * a32 - a22 * a31,
	        b10 = a21 * a33 - a23 * a31,
	        b11 = a22 * a33 - a23 * a32,
	
	        // Calculate the determinant
	        det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	
	    if (!det) { 
	        return null; 
	    }
	    det = 1.0 / det;
	
	    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	
	    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	
	    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	
	    return out;
	};
	
	/**
	 * Returns a string representation of a mat3
	 *
	 * @param {mat3} mat matrix to represent as a string
	 * @returns {String} string representation of the matrix
	 */
	mat3.str = function (a) {
	    return 'mat3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + 
	                    a[3] + ', ' + a[4] + ', ' + a[5] + ', ' + 
	                    a[6] + ', ' + a[7] + ', ' + a[8] + ')';
	};
	
	/**
	 * Returns Frobenius norm of a mat3
	 *
	 * @param {mat3} a the matrix to calculate Frobenius norm of
	 * @returns {Number} Frobenius norm
	 */
	mat3.frob = function (a) {
	    return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2)))
	};
	
	/**
	 * Adds two mat3's
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the first operand
	 * @param {mat3} b the second operand
	 * @returns {mat3} out
	 */
	mat3.add = function(out, a, b) {
	    out[0] = a[0] + b[0];
	    out[1] = a[1] + b[1];
	    out[2] = a[2] + b[2];
	    out[3] = a[3] + b[3];
	    out[4] = a[4] + b[4];
	    out[5] = a[5] + b[5];
	    out[6] = a[6] + b[6];
	    out[7] = a[7] + b[7];
	    out[8] = a[8] + b[8];
	    return out;
	};
	
	/**
	 * Subtracts matrix b from matrix a
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the first operand
	 * @param {mat3} b the second operand
	 * @returns {mat3} out
	 */
	mat3.subtract = function(out, a, b) {
	    out[0] = a[0] - b[0];
	    out[1] = a[1] - b[1];
	    out[2] = a[2] - b[2];
	    out[3] = a[3] - b[3];
	    out[4] = a[4] - b[4];
	    out[5] = a[5] - b[5];
	    out[6] = a[6] - b[6];
	    out[7] = a[7] - b[7];
	    out[8] = a[8] - b[8];
	    return out;
	};
	
	/**
	 * Alias for {@link mat3.subtract}
	 * @function
	 */
	mat3.sub = mat3.subtract;
	
	/**
	 * Multiply each element of the matrix by a scalar.
	 *
	 * @param {mat3} out the receiving matrix
	 * @param {mat3} a the matrix to scale
	 * @param {Number} b amount to scale the matrix's elements by
	 * @returns {mat3} out
	 */
	mat3.multiplyScalar = function(out, a, b) {
	    out[0] = a[0] * b;
	    out[1] = a[1] * b;
	    out[2] = a[2] * b;
	    out[3] = a[3] * b;
	    out[4] = a[4] * b;
	    out[5] = a[5] * b;
	    out[6] = a[6] * b;
	    out[7] = a[7] * b;
	    out[8] = a[8] * b;
	    return out;
	};
	
	/**
	 * Adds two mat3's after multiplying each element of the second operand by a scalar value.
	 *
	 * @param {mat3} out the receiving vector
	 * @param {mat3} a the first operand
	 * @param {mat3} b the second operand
	 * @param {Number} scale the amount to scale b's elements by before adding
	 * @returns {mat3} out
	 */
	mat3.multiplyScalarAndAdd = function(out, a, b, scale) {
	    out[0] = a[0] + (b[0] * scale);
	    out[1] = a[1] + (b[1] * scale);
	    out[2] = a[2] + (b[2] * scale);
	    out[3] = a[3] + (b[3] * scale);
	    out[4] = a[4] + (b[4] * scale);
	    out[5] = a[5] + (b[5] * scale);
	    out[6] = a[6] + (b[6] * scale);
	    out[7] = a[7] + (b[7] * scale);
	    out[8] = a[8] + (b[8] * scale);
	    return out;
	};
	
	/*
	 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
	 *
	 * @param {mat3} a The first matrix.
	 * @param {mat3} b The second matrix.
	 * @returns {Boolean} True if the matrices are equal, false otherwise.
	 */
	mat3.exactEquals = function (a, b) {
	    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && 
	           a[3] === b[3] && a[4] === b[4] && a[5] === b[5] &&
	           a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
	};
	
	/**
	 * Returns whether or not the matrices have approximately the same elements in the same position.
	 *
	 * @param {mat3} a The first matrix.
	 * @param {mat3} b The second matrix.
	 * @returns {Boolean} True if the matrices are equal, false otherwise.
	 */
	mat3.equals = function (a, b) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
	    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = a[6], b7 = b[7], b8 = b[8];
	    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
	            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
	            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
	            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
	            Math.abs(a4 - b4) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
	            Math.abs(a5 - b5) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a5), Math.abs(b5)) &&
	            Math.abs(a6 - b6) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a6), Math.abs(b6)) &&
	            Math.abs(a7 - b7) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a7), Math.abs(b7)) &&
	            Math.abs(a8 - b8) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a8), Math.abs(b8)));
	};
	
	
	module.exports = mat3;


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var glMatrix = __webpack_require__(81);
	
	/**
	 * @class 3 Dimensional Vector
	 * @name vec3
	 */
	var vec3 = {};
	
	/**
	 * Creates a new, empty vec3
	 *
	 * @returns {vec3} a new 3D vector
	 */
	vec3.create = function() {
	    var out = new glMatrix.ARRAY_TYPE(3);
	    out[0] = 0;
	    out[1] = 0;
	    out[2] = 0;
	    return out;
	};
	
	/**
	 * Creates a new vec3 initialized with values from an existing vector
	 *
	 * @param {vec3} a vector to clone
	 * @returns {vec3} a new 3D vector
	 */
	vec3.clone = function(a) {
	    var out = new glMatrix.ARRAY_TYPE(3);
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    return out;
	};
	
	/**
	 * Creates a new vec3 initialized with the given values
	 *
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @returns {vec3} a new 3D vector
	 */
	vec3.fromValues = function(x, y, z) {
	    var out = new glMatrix.ARRAY_TYPE(3);
	    out[0] = x;
	    out[1] = y;
	    out[2] = z;
	    return out;
	};
	
	/**
	 * Copy the values from one vec3 to another
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the source vector
	 * @returns {vec3} out
	 */
	vec3.copy = function(out, a) {
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    return out;
	};
	
	/**
	 * Set the components of a vec3 to the given values
	 *
	 * @param {vec3} out the receiving vector
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @returns {vec3} out
	 */
	vec3.set = function(out, x, y, z) {
	    out[0] = x;
	    out[1] = y;
	    out[2] = z;
	    return out;
	};
	
	/**
	 * Adds two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	vec3.add = function(out, a, b) {
	    out[0] = a[0] + b[0];
	    out[1] = a[1] + b[1];
	    out[2] = a[2] + b[2];
	    return out;
	};
	
	/**
	 * Subtracts vector b from vector a
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	vec3.subtract = function(out, a, b) {
	    out[0] = a[0] - b[0];
	    out[1] = a[1] - b[1];
	    out[2] = a[2] - b[2];
	    return out;
	};
	
	/**
	 * Alias for {@link vec3.subtract}
	 * @function
	 */
	vec3.sub = vec3.subtract;
	
	/**
	 * Multiplies two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	vec3.multiply = function(out, a, b) {
	    out[0] = a[0] * b[0];
	    out[1] = a[1] * b[1];
	    out[2] = a[2] * b[2];
	    return out;
	};
	
	/**
	 * Alias for {@link vec3.multiply}
	 * @function
	 */
	vec3.mul = vec3.multiply;
	
	/**
	 * Divides two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	vec3.divide = function(out, a, b) {
	    out[0] = a[0] / b[0];
	    out[1] = a[1] / b[1];
	    out[2] = a[2] / b[2];
	    return out;
	};
	
	/**
	 * Alias for {@link vec3.divide}
	 * @function
	 */
	vec3.div = vec3.divide;
	
	/**
	 * Math.ceil the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to ceil
	 * @returns {vec3} out
	 */
	vec3.ceil = function (out, a) {
	    out[0] = Math.ceil(a[0]);
	    out[1] = Math.ceil(a[1]);
	    out[2] = Math.ceil(a[2]);
	    return out;
	};
	
	/**
	 * Math.floor the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to floor
	 * @returns {vec3} out
	 */
	vec3.floor = function (out, a) {
	    out[0] = Math.floor(a[0]);
	    out[1] = Math.floor(a[1]);
	    out[2] = Math.floor(a[2]);
	    return out;
	};
	
	/**
	 * Returns the minimum of two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	vec3.min = function(out, a, b) {
	    out[0] = Math.min(a[0], b[0]);
	    out[1] = Math.min(a[1], b[1]);
	    out[2] = Math.min(a[2], b[2]);
	    return out;
	};
	
	/**
	 * Returns the maximum of two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	vec3.max = function(out, a, b) {
	    out[0] = Math.max(a[0], b[0]);
	    out[1] = Math.max(a[1], b[1]);
	    out[2] = Math.max(a[2], b[2]);
	    return out;
	};
	
	/**
	 * Math.round the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to round
	 * @returns {vec3} out
	 */
	vec3.round = function (out, a) {
	    out[0] = Math.round(a[0]);
	    out[1] = Math.round(a[1]);
	    out[2] = Math.round(a[2]);
	    return out;
	};
	
	/**
	 * Scales a vec3 by a scalar number
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the vector to scale
	 * @param {Number} b amount to scale the vector by
	 * @returns {vec3} out
	 */
	vec3.scale = function(out, a, b) {
	    out[0] = a[0] * b;
	    out[1] = a[1] * b;
	    out[2] = a[2] * b;
	    return out;
	};
	
	/**
	 * Adds two vec3's after scaling the second operand by a scalar value
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @param {Number} scale the amount to scale b by before adding
	 * @returns {vec3} out
	 */
	vec3.scaleAndAdd = function(out, a, b, scale) {
	    out[0] = a[0] + (b[0] * scale);
	    out[1] = a[1] + (b[1] * scale);
	    out[2] = a[2] + (b[2] * scale);
	    return out;
	};
	
	/**
	 * Calculates the euclidian distance between two vec3's
	 *
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {Number} distance between a and b
	 */
	vec3.distance = function(a, b) {
	    var x = b[0] - a[0],
	        y = b[1] - a[1],
	        z = b[2] - a[2];
	    return Math.sqrt(x*x + y*y + z*z);
	};
	
	/**
	 * Alias for {@link vec3.distance}
	 * @function
	 */
	vec3.dist = vec3.distance;
	
	/**
	 * Calculates the squared euclidian distance between two vec3's
	 *
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {Number} squared distance between a and b
	 */
	vec3.squaredDistance = function(a, b) {
	    var x = b[0] - a[0],
	        y = b[1] - a[1],
	        z = b[2] - a[2];
	    return x*x + y*y + z*z;
	};
	
	/**
	 * Alias for {@link vec3.squaredDistance}
	 * @function
	 */
	vec3.sqrDist = vec3.squaredDistance;
	
	/**
	 * Calculates the length of a vec3
	 *
	 * @param {vec3} a vector to calculate length of
	 * @returns {Number} length of a
	 */
	vec3.length = function (a) {
	    var x = a[0],
	        y = a[1],
	        z = a[2];
	    return Math.sqrt(x*x + y*y + z*z);
	};
	
	/**
	 * Alias for {@link vec3.length}
	 * @function
	 */
	vec3.len = vec3.length;
	
	/**
	 * Calculates the squared length of a vec3
	 *
	 * @param {vec3} a vector to calculate squared length of
	 * @returns {Number} squared length of a
	 */
	vec3.squaredLength = function (a) {
	    var x = a[0],
	        y = a[1],
	        z = a[2];
	    return x*x + y*y + z*z;
	};
	
	/**
	 * Alias for {@link vec3.squaredLength}
	 * @function
	 */
	vec3.sqrLen = vec3.squaredLength;
	
	/**
	 * Negates the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to negate
	 * @returns {vec3} out
	 */
	vec3.negate = function(out, a) {
	    out[0] = -a[0];
	    out[1] = -a[1];
	    out[2] = -a[2];
	    return out;
	};
	
	/**
	 * Returns the inverse of the components of a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to invert
	 * @returns {vec3} out
	 */
	vec3.inverse = function(out, a) {
	  out[0] = 1.0 / a[0];
	  out[1] = 1.0 / a[1];
	  out[2] = 1.0 / a[2];
	  return out;
	};
	
	/**
	 * Normalize a vec3
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a vector to normalize
	 * @returns {vec3} out
	 */
	vec3.normalize = function(out, a) {
	    var x = a[0],
	        y = a[1],
	        z = a[2];
	    var len = x*x + y*y + z*z;
	    if (len > 0) {
	        //TODO: evaluate use of glm_invsqrt here?
	        len = 1 / Math.sqrt(len);
	        out[0] = a[0] * len;
	        out[1] = a[1] * len;
	        out[2] = a[2] * len;
	    }
	    return out;
	};
	
	/**
	 * Calculates the dot product of two vec3's
	 *
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {Number} dot product of a and b
	 */
	vec3.dot = function (a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	};
	
	/**
	 * Computes the cross product of two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @returns {vec3} out
	 */
	vec3.cross = function(out, a, b) {
	    var ax = a[0], ay = a[1], az = a[2],
	        bx = b[0], by = b[1], bz = b[2];
	
	    out[0] = ay * bz - az * by;
	    out[1] = az * bx - ax * bz;
	    out[2] = ax * by - ay * bx;
	    return out;
	};
	
	/**
	 * Performs a linear interpolation between two vec3's
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {vec3} out
	 */
	vec3.lerp = function (out, a, b, t) {
	    var ax = a[0],
	        ay = a[1],
	        az = a[2];
	    out[0] = ax + t * (b[0] - ax);
	    out[1] = ay + t * (b[1] - ay);
	    out[2] = az + t * (b[2] - az);
	    return out;
	};
	
	/**
	 * Performs a hermite interpolation with two control points
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @param {vec3} c the third operand
	 * @param {vec3} d the fourth operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {vec3} out
	 */
	vec3.hermite = function (out, a, b, c, d, t) {
	  var factorTimes2 = t * t,
	      factor1 = factorTimes2 * (2 * t - 3) + 1,
	      factor2 = factorTimes2 * (t - 2) + t,
	      factor3 = factorTimes2 * (t - 1),
	      factor4 = factorTimes2 * (3 - 2 * t);
	  
	  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
	  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
	  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
	  
	  return out;
	};
	
	/**
	 * Performs a bezier interpolation with two control points
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the first operand
	 * @param {vec3} b the second operand
	 * @param {vec3} c the third operand
	 * @param {vec3} d the fourth operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {vec3} out
	 */
	vec3.bezier = function (out, a, b, c, d, t) {
	  var inverseFactor = 1 - t,
	      inverseFactorTimesTwo = inverseFactor * inverseFactor,
	      factorTimes2 = t * t,
	      factor1 = inverseFactorTimesTwo * inverseFactor,
	      factor2 = 3 * t * inverseFactorTimesTwo,
	      factor3 = 3 * factorTimes2 * inverseFactor,
	      factor4 = factorTimes2 * t;
	  
	  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
	  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
	  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
	  
	  return out;
	};
	
	/**
	 * Generates a random vector with the given scale
	 *
	 * @param {vec3} out the receiving vector
	 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
	 * @returns {vec3} out
	 */
	vec3.random = function (out, scale) {
	    scale = scale || 1.0;
	
	    var r = glMatrix.RANDOM() * 2.0 * Math.PI;
	    var z = (glMatrix.RANDOM() * 2.0) - 1.0;
	    var zScale = Math.sqrt(1.0-z*z) * scale;
	
	    out[0] = Math.cos(r) * zScale;
	    out[1] = Math.sin(r) * zScale;
	    out[2] = z * scale;
	    return out;
	};
	
	/**
	 * Transforms the vec3 with a mat4.
	 * 4th vector component is implicitly '1'
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the vector to transform
	 * @param {mat4} m matrix to transform with
	 * @returns {vec3} out
	 */
	vec3.transformMat4 = function(out, a, m) {
	    var x = a[0], y = a[1], z = a[2],
	        w = m[3] * x + m[7] * y + m[11] * z + m[15];
	    w = w || 1.0;
	    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
	    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
	    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
	    return out;
	};
	
	/**
	 * Transforms the vec3 with a mat3.
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the vector to transform
	 * @param {mat4} m the 3x3 matrix to transform with
	 * @returns {vec3} out
	 */
	vec3.transformMat3 = function(out, a, m) {
	    var x = a[0], y = a[1], z = a[2];
	    out[0] = x * m[0] + y * m[3] + z * m[6];
	    out[1] = x * m[1] + y * m[4] + z * m[7];
	    out[2] = x * m[2] + y * m[5] + z * m[8];
	    return out;
	};
	
	/**
	 * Transforms the vec3 with a quat
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec3} a the vector to transform
	 * @param {quat} q quaternion to transform with
	 * @returns {vec3} out
	 */
	vec3.transformQuat = function(out, a, q) {
	    // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
	
	    var x = a[0], y = a[1], z = a[2],
	        qx = q[0], qy = q[1], qz = q[2], qw = q[3],
	
	        // calculate quat * vec
	        ix = qw * x + qy * z - qz * y,
	        iy = qw * y + qz * x - qx * z,
	        iz = qw * z + qx * y - qy * x,
	        iw = -qx * x - qy * y - qz * z;
	
	    // calculate result * inverse quat
	    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
	    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
	    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
	    return out;
	};
	
	/**
	 * Rotate a 3D vector around the x-axis
	 * @param {vec3} out The receiving vec3
	 * @param {vec3} a The vec3 point to rotate
	 * @param {vec3} b The origin of the rotation
	 * @param {Number} c The angle of rotation
	 * @returns {vec3} out
	 */
	vec3.rotateX = function(out, a, b, c){
	   var p = [], r=[];
		  //Translate point to the origin
		  p[0] = a[0] - b[0];
		  p[1] = a[1] - b[1];
	  	p[2] = a[2] - b[2];
	
		  //perform rotation
		  r[0] = p[0];
		  r[1] = p[1]*Math.cos(c) - p[2]*Math.sin(c);
		  r[2] = p[1]*Math.sin(c) + p[2]*Math.cos(c);
	
		  //translate to correct position
		  out[0] = r[0] + b[0];
		  out[1] = r[1] + b[1];
		  out[2] = r[2] + b[2];
	
	  	return out;
	};
	
	/**
	 * Rotate a 3D vector around the y-axis
	 * @param {vec3} out The receiving vec3
	 * @param {vec3} a The vec3 point to rotate
	 * @param {vec3} b The origin of the rotation
	 * @param {Number} c The angle of rotation
	 * @returns {vec3} out
	 */
	vec3.rotateY = function(out, a, b, c){
	  	var p = [], r=[];
	  	//Translate point to the origin
	  	p[0] = a[0] - b[0];
	  	p[1] = a[1] - b[1];
	  	p[2] = a[2] - b[2];
	  
	  	//perform rotation
	  	r[0] = p[2]*Math.sin(c) + p[0]*Math.cos(c);
	  	r[1] = p[1];
	  	r[2] = p[2]*Math.cos(c) - p[0]*Math.sin(c);
	  
	  	//translate to correct position
	  	out[0] = r[0] + b[0];
	  	out[1] = r[1] + b[1];
	  	out[2] = r[2] + b[2];
	  
	  	return out;
	};
	
	/**
	 * Rotate a 3D vector around the z-axis
	 * @param {vec3} out The receiving vec3
	 * @param {vec3} a The vec3 point to rotate
	 * @param {vec3} b The origin of the rotation
	 * @param {Number} c The angle of rotation
	 * @returns {vec3} out
	 */
	vec3.rotateZ = function(out, a, b, c){
	  	var p = [], r=[];
	  	//Translate point to the origin
	  	p[0] = a[0] - b[0];
	  	p[1] = a[1] - b[1];
	  	p[2] = a[2] - b[2];
	  
	  	//perform rotation
	  	r[0] = p[0]*Math.cos(c) - p[1]*Math.sin(c);
	  	r[1] = p[0]*Math.sin(c) + p[1]*Math.cos(c);
	  	r[2] = p[2];
	  
	  	//translate to correct position
	  	out[0] = r[0] + b[0];
	  	out[1] = r[1] + b[1];
	  	out[2] = r[2] + b[2];
	  
	  	return out;
	};
	
	/**
	 * Perform some operation over an array of vec3s.
	 *
	 * @param {Array} a the array of vectors to iterate over
	 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
	 * @param {Number} offset Number of elements to skip at the beginning of the array
	 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
	 * @param {Function} fn Function to call for each vector in the array
	 * @param {Object} [arg] additional argument to pass to fn
	 * @returns {Array} a
	 * @function
	 */
	vec3.forEach = (function() {
	    var vec = vec3.create();
	
	    return function(a, stride, offset, count, fn, arg) {
	        var i, l;
	        if(!stride) {
	            stride = 3;
	        }
	
	        if(!offset) {
	            offset = 0;
	        }
	        
	        if(count) {
	            l = Math.min((count * stride) + offset, a.length);
	        } else {
	            l = a.length;
	        }
	
	        for(i = offset; i < l; i += stride) {
	            vec[0] = a[i]; vec[1] = a[i+1]; vec[2] = a[i+2];
	            fn(vec, vec, arg);
	            a[i] = vec[0]; a[i+1] = vec[1]; a[i+2] = vec[2];
	        }
	        
	        return a;
	    };
	})();
	
	/**
	 * Get the angle between two 3D vectors
	 * @param {vec3} a The first operand
	 * @param {vec3} b The second operand
	 * @returns {Number} The angle in radians
	 */
	vec3.angle = function(a, b) {
	   
	    var tempA = vec3.fromValues(a[0], a[1], a[2]);
	    var tempB = vec3.fromValues(b[0], b[1], b[2]);
	 
	    vec3.normalize(tempA, tempA);
	    vec3.normalize(tempB, tempB);
	 
	    var cosine = vec3.dot(tempA, tempB);
	
	    if(cosine > 1.0){
	        return 0;
	    } else {
	        return Math.acos(cosine);
	    }     
	};
	
	/**
	 * Returns a string representation of a vector
	 *
	 * @param {vec3} vec vector to represent as a string
	 * @returns {String} string representation of the vector
	 */
	vec3.str = function (a) {
	    return 'vec3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ')';
	};
	
	/**
	 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
	 *
	 * @param {vec3} a The first vector.
	 * @param {vec3} b The second vector.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	vec3.exactEquals = function (a, b) {
	    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
	};
	
	/**
	 * Returns whether or not the vectors have approximately the same elements in the same position.
	 *
	 * @param {vec3} a The first vector.
	 * @param {vec3} b The second vector.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	vec3.equals = function (a, b) {
	    var a0 = a[0], a1 = a[1], a2 = a[2];
	    var b0 = b[0], b1 = b[1], b2 = b[2];
	    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
	            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
	            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)));
	};
	
	module.exports = vec3;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var glMatrix = __webpack_require__(81);
	
	/**
	 * @class 4 Dimensional Vector
	 * @name vec4
	 */
	var vec4 = {};
	
	/**
	 * Creates a new, empty vec4
	 *
	 * @returns {vec4} a new 4D vector
	 */
	vec4.create = function() {
	    var out = new glMatrix.ARRAY_TYPE(4);
	    out[0] = 0;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    return out;
	};
	
	/**
	 * Creates a new vec4 initialized with values from an existing vector
	 *
	 * @param {vec4} a vector to clone
	 * @returns {vec4} a new 4D vector
	 */
	vec4.clone = function(a) {
	    var out = new glMatrix.ARRAY_TYPE(4);
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    return out;
	};
	
	/**
	 * Creates a new vec4 initialized with the given values
	 *
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @param {Number} w W component
	 * @returns {vec4} a new 4D vector
	 */
	vec4.fromValues = function(x, y, z, w) {
	    var out = new glMatrix.ARRAY_TYPE(4);
	    out[0] = x;
	    out[1] = y;
	    out[2] = z;
	    out[3] = w;
	    return out;
	};
	
	/**
	 * Copy the values from one vec4 to another
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the source vector
	 * @returns {vec4} out
	 */
	vec4.copy = function(out, a) {
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    return out;
	};
	
	/**
	 * Set the components of a vec4 to the given values
	 *
	 * @param {vec4} out the receiving vector
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @param {Number} w W component
	 * @returns {vec4} out
	 */
	vec4.set = function(out, x, y, z, w) {
	    out[0] = x;
	    out[1] = y;
	    out[2] = z;
	    out[3] = w;
	    return out;
	};
	
	/**
	 * Adds two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	vec4.add = function(out, a, b) {
	    out[0] = a[0] + b[0];
	    out[1] = a[1] + b[1];
	    out[2] = a[2] + b[2];
	    out[3] = a[3] + b[3];
	    return out;
	};
	
	/**
	 * Subtracts vector b from vector a
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	vec4.subtract = function(out, a, b) {
	    out[0] = a[0] - b[0];
	    out[1] = a[1] - b[1];
	    out[2] = a[2] - b[2];
	    out[3] = a[3] - b[3];
	    return out;
	};
	
	/**
	 * Alias for {@link vec4.subtract}
	 * @function
	 */
	vec4.sub = vec4.subtract;
	
	/**
	 * Multiplies two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	vec4.multiply = function(out, a, b) {
	    out[0] = a[0] * b[0];
	    out[1] = a[1] * b[1];
	    out[2] = a[2] * b[2];
	    out[3] = a[3] * b[3];
	    return out;
	};
	
	/**
	 * Alias for {@link vec4.multiply}
	 * @function
	 */
	vec4.mul = vec4.multiply;
	
	/**
	 * Divides two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	vec4.divide = function(out, a, b) {
	    out[0] = a[0] / b[0];
	    out[1] = a[1] / b[1];
	    out[2] = a[2] / b[2];
	    out[3] = a[3] / b[3];
	    return out;
	};
	
	/**
	 * Alias for {@link vec4.divide}
	 * @function
	 */
	vec4.div = vec4.divide;
	
	/**
	 * Math.ceil the components of a vec4
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a vector to ceil
	 * @returns {vec4} out
	 */
	vec4.ceil = function (out, a) {
	    out[0] = Math.ceil(a[0]);
	    out[1] = Math.ceil(a[1]);
	    out[2] = Math.ceil(a[2]);
	    out[3] = Math.ceil(a[3]);
	    return out;
	};
	
	/**
	 * Math.floor the components of a vec4
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a vector to floor
	 * @returns {vec4} out
	 */
	vec4.floor = function (out, a) {
	    out[0] = Math.floor(a[0]);
	    out[1] = Math.floor(a[1]);
	    out[2] = Math.floor(a[2]);
	    out[3] = Math.floor(a[3]);
	    return out;
	};
	
	/**
	 * Returns the minimum of two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	vec4.min = function(out, a, b) {
	    out[0] = Math.min(a[0], b[0]);
	    out[1] = Math.min(a[1], b[1]);
	    out[2] = Math.min(a[2], b[2]);
	    out[3] = Math.min(a[3], b[3]);
	    return out;
	};
	
	/**
	 * Returns the maximum of two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {vec4} out
	 */
	vec4.max = function(out, a, b) {
	    out[0] = Math.max(a[0], b[0]);
	    out[1] = Math.max(a[1], b[1]);
	    out[2] = Math.max(a[2], b[2]);
	    out[3] = Math.max(a[3], b[3]);
	    return out;
	};
	
	/**
	 * Math.round the components of a vec4
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a vector to round
	 * @returns {vec4} out
	 */
	vec4.round = function (out, a) {
	    out[0] = Math.round(a[0]);
	    out[1] = Math.round(a[1]);
	    out[2] = Math.round(a[2]);
	    out[3] = Math.round(a[3]);
	    return out;
	};
	
	/**
	 * Scales a vec4 by a scalar number
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the vector to scale
	 * @param {Number} b amount to scale the vector by
	 * @returns {vec4} out
	 */
	vec4.scale = function(out, a, b) {
	    out[0] = a[0] * b;
	    out[1] = a[1] * b;
	    out[2] = a[2] * b;
	    out[3] = a[3] * b;
	    return out;
	};
	
	/**
	 * Adds two vec4's after scaling the second operand by a scalar value
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @param {Number} scale the amount to scale b by before adding
	 * @returns {vec4} out
	 */
	vec4.scaleAndAdd = function(out, a, b, scale) {
	    out[0] = a[0] + (b[0] * scale);
	    out[1] = a[1] + (b[1] * scale);
	    out[2] = a[2] + (b[2] * scale);
	    out[3] = a[3] + (b[3] * scale);
	    return out;
	};
	
	/**
	 * Calculates the euclidian distance between two vec4's
	 *
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {Number} distance between a and b
	 */
	vec4.distance = function(a, b) {
	    var x = b[0] - a[0],
	        y = b[1] - a[1],
	        z = b[2] - a[2],
	        w = b[3] - a[3];
	    return Math.sqrt(x*x + y*y + z*z + w*w);
	};
	
	/**
	 * Alias for {@link vec4.distance}
	 * @function
	 */
	vec4.dist = vec4.distance;
	
	/**
	 * Calculates the squared euclidian distance between two vec4's
	 *
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {Number} squared distance between a and b
	 */
	vec4.squaredDistance = function(a, b) {
	    var x = b[0] - a[0],
	        y = b[1] - a[1],
	        z = b[2] - a[2],
	        w = b[3] - a[3];
	    return x*x + y*y + z*z + w*w;
	};
	
	/**
	 * Alias for {@link vec4.squaredDistance}
	 * @function
	 */
	vec4.sqrDist = vec4.squaredDistance;
	
	/**
	 * Calculates the length of a vec4
	 *
	 * @param {vec4} a vector to calculate length of
	 * @returns {Number} length of a
	 */
	vec4.length = function (a) {
	    var x = a[0],
	        y = a[1],
	        z = a[2],
	        w = a[3];
	    return Math.sqrt(x*x + y*y + z*z + w*w);
	};
	
	/**
	 * Alias for {@link vec4.length}
	 * @function
	 */
	vec4.len = vec4.length;
	
	/**
	 * Calculates the squared length of a vec4
	 *
	 * @param {vec4} a vector to calculate squared length of
	 * @returns {Number} squared length of a
	 */
	vec4.squaredLength = function (a) {
	    var x = a[0],
	        y = a[1],
	        z = a[2],
	        w = a[3];
	    return x*x + y*y + z*z + w*w;
	};
	
	/**
	 * Alias for {@link vec4.squaredLength}
	 * @function
	 */
	vec4.sqrLen = vec4.squaredLength;
	
	/**
	 * Negates the components of a vec4
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a vector to negate
	 * @returns {vec4} out
	 */
	vec4.negate = function(out, a) {
	    out[0] = -a[0];
	    out[1] = -a[1];
	    out[2] = -a[2];
	    out[3] = -a[3];
	    return out;
	};
	
	/**
	 * Returns the inverse of the components of a vec4
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a vector to invert
	 * @returns {vec4} out
	 */
	vec4.inverse = function(out, a) {
	  out[0] = 1.0 / a[0];
	  out[1] = 1.0 / a[1];
	  out[2] = 1.0 / a[2];
	  out[3] = 1.0 / a[3];
	  return out;
	};
	
	/**
	 * Normalize a vec4
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a vector to normalize
	 * @returns {vec4} out
	 */
	vec4.normalize = function(out, a) {
	    var x = a[0],
	        y = a[1],
	        z = a[2],
	        w = a[3];
	    var len = x*x + y*y + z*z + w*w;
	    if (len > 0) {
	        len = 1 / Math.sqrt(len);
	        out[0] = x * len;
	        out[1] = y * len;
	        out[2] = z * len;
	        out[3] = w * len;
	    }
	    return out;
	};
	
	/**
	 * Calculates the dot product of two vec4's
	 *
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @returns {Number} dot product of a and b
	 */
	vec4.dot = function (a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	};
	
	/**
	 * Performs a linear interpolation between two vec4's
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the first operand
	 * @param {vec4} b the second operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {vec4} out
	 */
	vec4.lerp = function (out, a, b, t) {
	    var ax = a[0],
	        ay = a[1],
	        az = a[2],
	        aw = a[3];
	    out[0] = ax + t * (b[0] - ax);
	    out[1] = ay + t * (b[1] - ay);
	    out[2] = az + t * (b[2] - az);
	    out[3] = aw + t * (b[3] - aw);
	    return out;
	};
	
	/**
	 * Generates a random vector with the given scale
	 *
	 * @param {vec4} out the receiving vector
	 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
	 * @returns {vec4} out
	 */
	vec4.random = function (out, scale) {
	    scale = scale || 1.0;
	
	    //TODO: This is a pretty awful way of doing this. Find something better.
	    out[0] = glMatrix.RANDOM();
	    out[1] = glMatrix.RANDOM();
	    out[2] = glMatrix.RANDOM();
	    out[3] = glMatrix.RANDOM();
	    vec4.normalize(out, out);
	    vec4.scale(out, out, scale);
	    return out;
	};
	
	/**
	 * Transforms the vec4 with a mat4.
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the vector to transform
	 * @param {mat4} m matrix to transform with
	 * @returns {vec4} out
	 */
	vec4.transformMat4 = function(out, a, m) {
	    var x = a[0], y = a[1], z = a[2], w = a[3];
	    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
	    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
	    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
	    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
	    return out;
	};
	
	/**
	 * Transforms the vec4 with a quat
	 *
	 * @param {vec4} out the receiving vector
	 * @param {vec4} a the vector to transform
	 * @param {quat} q quaternion to transform with
	 * @returns {vec4} out
	 */
	vec4.transformQuat = function(out, a, q) {
	    var x = a[0], y = a[1], z = a[2],
	        qx = q[0], qy = q[1], qz = q[2], qw = q[3],
	
	        // calculate quat * vec
	        ix = qw * x + qy * z - qz * y,
	        iy = qw * y + qz * x - qx * z,
	        iz = qw * z + qx * y - qy * x,
	        iw = -qx * x - qy * y - qz * z;
	
	    // calculate result * inverse quat
	    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
	    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
	    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
	    out[3] = a[3];
	    return out;
	};
	
	/**
	 * Perform some operation over an array of vec4s.
	 *
	 * @param {Array} a the array of vectors to iterate over
	 * @param {Number} stride Number of elements between the start of each vec4. If 0 assumes tightly packed
	 * @param {Number} offset Number of elements to skip at the beginning of the array
	 * @param {Number} count Number of vec4s to iterate over. If 0 iterates over entire array
	 * @param {Function} fn Function to call for each vector in the array
	 * @param {Object} [arg] additional argument to pass to fn
	 * @returns {Array} a
	 * @function
	 */
	vec4.forEach = (function() {
	    var vec = vec4.create();
	
	    return function(a, stride, offset, count, fn, arg) {
	        var i, l;
	        if(!stride) {
	            stride = 4;
	        }
	
	        if(!offset) {
	            offset = 0;
	        }
	        
	        if(count) {
	            l = Math.min((count * stride) + offset, a.length);
	        } else {
	            l = a.length;
	        }
	
	        for(i = offset; i < l; i += stride) {
	            vec[0] = a[i]; vec[1] = a[i+1]; vec[2] = a[i+2]; vec[3] = a[i+3];
	            fn(vec, vec, arg);
	            a[i] = vec[0]; a[i+1] = vec[1]; a[i+2] = vec[2]; a[i+3] = vec[3];
	        }
	        
	        return a;
	    };
	})();
	
	/**
	 * Returns a string representation of a vector
	 *
	 * @param {vec4} vec vector to represent as a string
	 * @returns {String} string representation of the vector
	 */
	vec4.str = function (a) {
	    return 'vec4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
	};
	
	/**
	 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
	 *
	 * @param {vec4} a The first vector.
	 * @param {vec4} b The second vector.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	vec4.exactEquals = function (a, b) {
	    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
	};
	
	/**
	 * Returns whether or not the vectors have approximately the same elements in the same position.
	 *
	 * @param {vec4} a The first vector.
	 * @param {vec4} b The second vector.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	vec4.equals = function (a, b) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
	    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
	    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
	            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
	            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
	            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)));
	};
	
	module.exports = vec4;


/***/ },
/* 407 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Recursively flattens `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flattenDeep([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, 3, 4, 5]
	 */
	function flattenDeep(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, INFINITY) : [];
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = flattenDeep;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(102),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(48);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(102),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 411 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 412 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(924),
	    isArguments = __webpack_require__(156),
	    isArray = __webpack_require__(16),
	    isBuffer = __webpack_require__(157),
	    isIndex = __webpack_require__(153),
	    isTypedArray = __webpack_require__(207);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 414 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(149),
	    eq = __webpack_require__(125);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(188),
	    arrayEach = __webpack_require__(411),
	    assignValue = __webpack_require__(190),
	    baseAssign = __webpack_require__(893),
	    baseAssignIn = __webpack_require__(894),
	    cloneBuffer = __webpack_require__(426),
	    copyArray = __webpack_require__(197),
	    copySymbols = __webpack_require__(939),
	    copySymbolsIn = __webpack_require__(940),
	    getAllKeys = __webpack_require__(436),
	    getAllKeysIn = __webpack_require__(437),
	    getTag = __webpack_require__(201),
	    initCloneArray = __webpack_require__(970),
	    initCloneByTag = __webpack_require__(971),
	    initCloneObject = __webpack_require__(440),
	    isArray = __webpack_require__(16),
	    isBuffer = __webpack_require__(157),
	    isObject = __webpack_require__(44),
	    keys = __webpack_require__(76);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 417 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(945);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(269),
	    isArray = __webpack_require__(16);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 420 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(417),
	    baseIsNaN = __webpack_require__(904),
	    strictIndexOf = __webpack_require__(1002);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(154),
	    nativeKeys = __webpack_require__(988);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 423 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(190),
	    castPath = __webpack_require__(123),
	    isIndex = __webpack_require__(153),
	    isObject = __webpack_require__(44),
	    toKey = __webpack_require__(124);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(69),
	    metaMap = __webpack_require__(444);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(48);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(371)(module)))

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(275);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 428 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 429 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(428),
	    composeArgsRight = __webpack_require__(429),
	    countHolders = __webpack_require__(942),
	    createCtor = __webpack_require__(198),
	    createRecurry = __webpack_require__(431),
	    getHolder = __webpack_require__(199),
	    reorder = __webpack_require__(993),
	    replaceHolders = __webpack_require__(155),
	    root = __webpack_require__(48);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(441),
	    setData = __webpack_require__(448),
	    setWrapToString = __webpack_require__(449);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(425),
	    createBind = __webpack_require__(946),
	    createCurry = __webpack_require__(947),
	    createHybrid = __webpack_require__(430),
	    createPartial = __webpack_require__(951),
	    getData = __webpack_require__(277),
	    mergeData = __webpack_require__(987),
	    setData = __webpack_require__(448),
	    setWrapToString = __webpack_require__(449),
	    toInteger = __webpack_require__(210);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(102);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(187),
	    arraySome = __webpack_require__(414),
	    cacheHas = __webpack_require__(196);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 435 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(419),
	    getSymbols = __webpack_require__(279),
	    keys = __webpack_require__(76);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(419),
	    getSymbolsIn = __webpack_require__(439),
	    keysIn = __webpack_require__(128);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(992);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(269),
	    getPrototype = __webpack_require__(278),
	    getSymbols = __webpack_require__(279),
	    stubArray = __webpack_require__(459);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(192),
	    getPrototype = __webpack_require__(278),
	    isPrototype = __webpack_require__(154);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(264),
	    getData = __webpack_require__(277),
	    getFuncName = __webpack_require__(438),
	    lodash = __webpack_require__(1032);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(44);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 443 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(410);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(435);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(371)(module)))

/***/ },
/* 446 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(148);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(425),
	    shortOut = __webpack_require__(450);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(963),
	    insertWrapDetails = __webpack_require__(972),
	    setToString = __webpack_require__(282),
	    updateWrapDetails = __webpack_require__(1004);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ },
/* 450 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 451 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 452 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(44),
	    now = __webpack_require__(1024),
	    toNumber = __webpack_require__(461);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(149),
	    createAggregator = __webpack_require__(943);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(897),
	    hasPath = __webpack_require__(964);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(422),
	    getTag = __webpack_require__(201),
	    isArguments = __webpack_require__(156),
	    isArray = __webpack_require__(16),
	    isArrayLike = __webpack_require__(75),
	    isBuffer = __webpack_require__(157),
	    isPrototype = __webpack_require__(154),
	    isTypedArray = __webpack_require__(207);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(82),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 458 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 459 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(461);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(44),
	    isSymbol = __webpack_require__(127);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(926);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.cancelAnimationFrame = exports.requestAnimationFrame = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window, setTimeout, clearTimeout */
	
	
	var _utils = __webpack_require__(30);
	
	var _webglChecks = __webpack_require__(37);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Node.js polyfills for requestAnimationFrame and cancelAnimationFrame
	var requestAnimationFrame = exports.requestAnimationFrame = function requestAnimationFrame(callback) {
	  return _utils.isBrowser ? window.requestAnimationFrame(callback) : setTimeout(callback, 1000 / 60);
	};
	
	var cancelAnimationFrame = exports.cancelAnimationFrame = function cancelAnimationFrame(timerId) {
	  return _utils.isBrowser ? window.cancelAnimationFrame(timerId) : clearTimeout(timerId);
	};
	
	var AnimationFrame = function () {
	  /*
	   * @param {HTMLCanvasElement} canvas - if provided, with and height will be
	   *   passed to context
	   */
	  function AnimationFrame() {
	    var _this = this;
	
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, AnimationFrame);
	
	    var _opts$gl = opts.gl,
	        gl = _opts$gl === undefined ? null : _opts$gl,
	        _opts$width = opts.width,
	        width = _opts$width === undefined ? null : _opts$width,
	        _opts$height = opts.height,
	        height = _opts$height === undefined ? null : _opts$height,
	        _opts$autoResizeViewp = opts.autoResizeViewport,
	        autoResizeViewport = _opts$autoResizeViewp === undefined ? true : _opts$autoResizeViewp,
	        _opts$autoResizeCanva = opts.autoResizeCanvas,
	        autoResizeCanvas = _opts$autoResizeCanva === undefined ? true : _opts$autoResizeCanva,
	        _opts$autoResizeDrawi = opts.autoResizeDrawingBuffer,
	        autoResizeDrawingBuffer = _opts$autoResizeDrawi === undefined ? true : _opts$autoResizeDrawi,
	        _opts$useDevicePixelR = opts.useDevicePixelRatio,
	        useDevicePixelRatio = _opts$useDevicePixelR === undefined ? true : _opts$useDevicePixelR;
	
	
	    this.start = this.start.bind(this);
	    this.stop = this.stop.bind(this);
	    this._frame = this._frame.bind(this);
	
	    this.update({
	      autoResizeViewport: autoResizeViewport,
	      autoResizeCanvas: autoResizeCanvas,
	      autoResizeDrawingBuffer: autoResizeDrawingBuffer,
	      useDevicePixelRatio: useDevicePixelRatio
	    });
	
	    this.width = width;
	    this.height = height;
	
	    // Don't do a
	    this._startPromise = _utils.pageLoadPromise.then(function (page) {
	      _this.gl = gl;
	      return page;
	    });
	  }
	
	  _createClass(AnimationFrame, [{
	    key: 'update',
	    value: function update(_ref) {
	      var _ref$autoResizeDrawin = _ref.autoResizeDrawingBuffer,
	          autoResizeDrawingBuffer = _ref$autoResizeDrawin === undefined ? true : _ref$autoResizeDrawin,
	          _ref$autoResizeCanvas = _ref.autoResizeCanvas,
	          autoResizeCanvas = _ref$autoResizeCanvas === undefined ? true : _ref$autoResizeCanvas,
	          _ref$autoResizeViewpo = _ref.autoResizeViewport,
	          autoResizeViewport = _ref$autoResizeViewpo === undefined ? true : _ref$autoResizeViewpo,
	          _ref$useDevicePixelRa = _ref.useDevicePixelRatio,
	          useDevicePixelRatio = _ref$useDevicePixelRa === undefined ? true : _ref$useDevicePixelRa;
	
	      this.autoResizeViewport = autoResizeViewport;
	      this.autoResizeCanvas = autoResizeCanvas;
	      this.autoResizeDrawingBuffer = autoResizeDrawingBuffer;
	      this.useDevicePixelRatio = useDevicePixelRatio;
	      return this;
	    }
	  }, {
	    key: 'context',
	    value: function context(onCreateContext) {
	      var _this2 = this;
	
	      if (this.gl) {
	        throw new Error('AnimationFrame.context - context already provided');
	      }
	      this._startPromise = this._startPromise.then(function () {
	        _this2.gl = onCreateContext();
	        if (!(0, _webglChecks.isWebGLContext)(_this2.gl)) {
	          throw new Error('AnimationFrame.context - illegal context returned');
	        }
	      });
	      return this;
	    }
	  }, {
	    key: 'init',
	    value: function init(onInit) {
	      var _this3 = this;
	
	      this._startPromise = this._startPromise.then(function () {
	        if (!_this3.gl) {
	          throw new Error('AnimationFrame.context - no context provided');
	        }
	        _this3._initializeContext();
	        return onInit(_this3._context) || {};
	      });
	
	      return this;
	    }
	  }, {
	    key: 'setupFrame',
	    value: function setupFrame(onSetupFrame) {
	      this._onSetupFrame = onSetupFrame;
	      return this;
	    }
	
	    /**
	     * Starts a global render loop with the given frame function
	     * @param {Function} onRenderFrame - application frame renderer function
	     *  expected to take a context parameter
	     * @param {Object} context - contains frame specific info
	     *  (E.g. tick, width, height, etc)
	     * @return {Renderer} - returns self for chaining
	     */
	
	  }, {
	    key: 'frame',
	    value: function frame(onRenderFrame) {
	      this._onRenderFrame = onRenderFrame;
	      return this;
	    }
	
	    /**
	     * Starts a render loop if not already running
	     */
	
	  }, {
	    key: 'start',
	    value: function start() {
	      var _this4 = this;
	
	      // Wait for start promise before rendering frame
	      this._startPromise.then(function () {
	        var appContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _this4._initializeContext(appContext);
	        if (!_this4._animationFrameId) {
	          _this4._animationFrameId = requestAnimationFrame(_this4._frame);
	        }
	      });
	      return this;
	    }
	
	    /**
	     * Stops a render loop if already running
	     */
	
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (this._animationFrameId) {
	        cancelAnimationFrame(this._animationFrameId);
	        this._animationFrameId = null;
	      }
	      return this;
	    }
	
	    /**
	     * Resize canvas in "CSS coordinates" (may be different from device coords)
	     * NOTE: No effect on headless contexts
	     * @param {Number} width - new width of canvas in CSS coordinates
	     * @param {Number} height - new height of canvas in CSS coordinates
	     * @return {Renderer} - returns self for chaining
	     */
	
	  }, {
	    key: 'resizeCanvas',
	    value: function resizeCanvas(width, height) {
	      this._resizeCanvas(width, height);
	      return this;
	    }
	
	    // PRIVATE METHODS
	
	  }, {
	    key: '_initializeContext',
	    value: function _initializeContext(appContext) {
	      if (!this._context) {
	        this._context = {
	          gl: this.gl,
	          canvas: this.gl.canvas,
	          stop: this.stop,
	          tick: 0,
	          tock: 0
	        };
	      }
	      this._updateContext();
	      if ((typeof appContext === 'undefined' ? 'undefined' : _typeof(appContext)) === 'object' && appContext !== null) {
	        this._context = Object.assign({}, appContext, this._context);
	      }
	    }
	  }, {
	    key: '_updateContext',
	    value: function _updateContext() {
	      // Context width and height represent drawing buffer width and height
	      var canvas = this._context.canvas;
	
	      this._context.width = canvas.width;
	      this._context.height = canvas.height;
	      this._context.aspect = canvas.width / canvas.height;
	    }
	
	    /**
	     * @private
	     * Handles a render loop frame- updates context and calls the application
	     * callback
	     */
	
	  }, {
	    key: '_frame',
	    value: function _frame() {
	      var canvas = this._context.canvas;
	
	
	      if (this._onSetupFrame) {
	        this._onSetupFrame(this._context);
	      } else {
	        this._resizeCanvasDrawingBuffer(canvas);
	        // Default viewport setup
	        if (this.autoResizeViewport) {
	          this.gl.viewport(0, 0, canvas.width, canvas.height);
	        }
	      }
	
	      this._updateContext();
	      this._onRenderFrame(this._context);
	
	      // Increment tick
	      this._context.tick++;
	
	      // Request another render frame (now )
	      this._animationFrameId = requestAnimationFrame(this._frame);
	    }
	
	    /**
	     * Resize canvas in "CSS coordinates" (may be different from device coords)
	     * NOTE: No effect on headless contexts
	     * @param {Number} width - new width of canvas in CSS coordinates
	     * @param {Number} height - new height of canvas in CSS coordinates
	     * @return {Renderer} - returns self for chaining
	     */
	
	  }, {
	    key: '_resizeCanvas',
	    value: function _resizeCanvas(width, height) {
	      var canvas = this._context.canvas;
	
	      if (canvas) {
	        if (this.autoResizeDrawingBuffer) {
	          var cssToDevicePixels = this.useDevicePixelRatio ? window.devicePixelRatio || 1 : 1;
	
	          // Lookup the size the browser is displaying the canvas in CSS pixels
	          // and compute a size needed to make our drawingbuffer match it in
	          // device pixels.
	          var displayWidth = Math.floor(width * cssToDevicePixels);
	          var displayHeight = Math.floor(height * cssToDevicePixels);
	
	          // Check if the canvas is not the same size.
	          if (canvas.width !== displayWidth || canvas.height !== displayHeight) {
	            // Make the canvas the same size
	            canvas.width = displayWidth;
	            canvas.height = displayHeight;
	          }
	        }
	
	        canvas.style.width = width + 'px';
	        canvas.style.height = height + 'px';
	      }
	      return this;
	    }
	
	    // Resize the render buffer of the canvas to match canvas client size
	    // multiplying with dpr (Optionally can be turned off)
	    // http://webgl2fundamentals.org/webgl/lessons/webgl-resizing-the-canvas.html
	
	  }, {
	    key: '_resizeCanvasDrawingBuffer',
	    value: function _resizeCanvasDrawingBuffer() {
	      if (this.autoResizeDrawingBuffer) {
	        var canvas = this._context.canvas;
	
	        var cssToDevicePixels = this.useDevicePixelRatio ? window.devicePixelRatio || 1 : 1;
	
	        // Lookup the size the browser is displaying the canvas in CSS pixels
	        // and compute a size needed to make our drawingbuffer match it in
	        // device pixels.
	        var oldWidth = window.innerWidth;
	        var oldHeight = window.innerHeight;
	        var displayWidth = Math.floor(oldWidth * cssToDevicePixels);
	        var displayHeight = Math.floor(oldHeight * cssToDevicePixels);
	
	        // Check if the canvas is not the same size.
	        if (oldWidth !== displayWidth || oldHeight !== displayHeight) {
	          // Make the canvas the same size
	          canvas.width = displayWidth;
	          canvas.height = displayHeight;
	          canvas.style.width = oldWidth;
	          canvas.style.height = oldHeight;
	        }
	      }
	    }
	
	    /**
	     * Resize canvas drawing buffer
	     * NOTE: The drawing buffer will be scaled to the viewport
	     * for best visual results, usually set to either:
	     *  canvas CSS width x CSS height
	     *  canvas CSS width * devicePixelRatio x CSS height * devicePixelRatio
	     * TODO - add separate call for headless contexts
	     * @param {Number} width - new width of canvas in CSS coordinates
	     * @param {Number} height - new height of canvas in CSS coordinates
	     * @return {Renderer} - returns self for chaining
	     */
	
	  }, {
	    key: '_resizeDrawingBuffer',
	    value: function _resizeDrawingBuffer(width, height) {
	      var canvas = this._context.canvas;
	
	      if (canvas) {
	        canvas.width = width;
	        canvas.height = height;
	        this.autoResizeDrawingBuffer = false;
	      }
	      return this;
	    }
	  }]);
	
	  return AnimationFrame;
	}();
	
	exports.default = AnimationFrame;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Keys = exports.EventsProxy = exports.stop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // event.js
	// Handle keyboard/mouse/touch events in the Canvas
	// TODO - this will not work under node
	
	/* eslint-disable dot-notation, max-statements, no-loop-func */
	/* global window, document */
	
	
	exports.get = get;
	exports.getWheel = getWheel;
	exports.getKey = getKey;
	exports.isRightClick = isRightClick;
	exports.getPos = getPos;
	exports.addEvents = addEvents;
	
	var _utils = __webpack_require__(30);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KEYS = {
	  enter: 13,
	  up: 38,
	  down: 40,
	  left: 37,
	  right: 39,
	  esc: 27,
	  space: 32,
	  backspace: 8,
	  tab: 9,
	  delete: 46
	};
	
	// returns an O3D object or false otherwise.
	function toO3D(n) {
	  return n !== true ? n : false;
	}
	
	// Returns an element position
	function _getPos(elem) {
	  var bbox = elem.getBoundingClientRect();
	  return {
	    x: bbox.left,
	    y: bbox.top,
	    bbox: bbox
	  };
	}
	
	// event object wrapper
	function get(e, win) {
	  win = win || window;
	  return e || win.event;
	}
	
	function getWheel(e) {
	  return e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
	}
	
	function getKey(e) {
	  var code = e.which || e.keyCode;
	  var key = keyOf(code);
	  // onkeydown
	  var fKey = code - 111;
	  if (fKey > 0 && fKey < 13) {
	    key = 'f' + fKey;
	  }
	  key = key || String.fromCharCode(code).toLowerCase();
	
	  return {
	    code: code,
	    key: key,
	    shift: e.shiftKey,
	    control: e.ctrlKey,
	    alt: e.altKey,
	    meta: e.metaKey
	  };
	}
	
	function isRightClick(e) {
	  return e.which === 3 || e.button === 2;
	}
	
	function getPos(e, win) {
	  // get mouse position
	  win = win || window;
	  e = e || win.event;
	  var doc = win.document;
	  doc = doc.documentElement || doc.body;
	  // TODO(nico): make touch event handling better
	  if (e.touches && e.touches.length) {
	    var touchesPos = [];
	    var l = e.touches.length;
	    var evt = void 0;
	    for (var i = 0; i < l; ++i) {
	      evt = e.touches[i];
	      touchesPos.push({
	        x: evt.pageX || evt.clientX + doc.scrollLeft,
	        y: evt.pageY || evt.clientY + doc.scrollTop
	      });
	    }
	    return touchesPos;
	  }
	  var page = {
	    x: e.pageX || e.clientX + doc.scrollLeft,
	    y: e.pageY || e.clientY + doc.scrollTop
	  };
	  return [page];
	}
	
	function _stop(e) {
	  if (e.stopPropagation) {
	    e.stopPropagation();
	  }
	  e.cancelBubble = true;
	  if (e.preventDefault) {
	    e.preventDefault();
	  } else {
	    e.returnValue = false;
	  }
	}
	
	exports.stop = _stop;
	
	var EventsProxy = exports.EventsProxy = function () {
	  function EventsProxy(domElem, opt) {
	    _classCallCheck(this, EventsProxy);
	
	    this.scene = opt.scene;
	    this.domElem = domElem;
	    this.pos = _getPos(domElem);
	    this.opt = this.callbacks = opt;
	
	    this.size = {
	      width: domElem.width || domElem.offsetWidth,
	      height: domElem.height || domElem.offsetHeight
	    };
	
	    this.attachEvents();
	  }
	
	  _createClass(EventsProxy, [{
	    key: 'attachEvents',
	    value: function attachEvents() {
	      var _this = this;
	
	      var domElem = this.domElem;
	      var opt = this.opt;
	
	      if (opt.disableContextMenu) {
	        domElem.oncontextmenu = function () {
	          return false;
	        };
	      }
	
	      if (opt.enableMouse) {
	        ['mouseup', 'mousedown', 'mousemove', 'mouseover', 'mouseout'].forEach(function (action) {
	          domElem.addEventListener(action, function (e, win) {
	            _this[action](_this.eventInfo(action, e, win));
	          }, false);
	        });
	
	        // "well, this is embarrassing..."
	        var type = '';
	        if (!document.getBoxObjectFor && window.mozInnerScreenX === null) {
	          type = 'mousewheel';
	        } else {
	          type = 'DOMMouseScroll';
	        }
	        domElem.addEventListener(type, function (e, win) {
	          _this['mousewheel'](_this.eventInfo('mousewheel', e, win));
	        }, false);
	      }
	
	      if (opt.enableTouch) {
	        ['touchstart', 'touchmove', 'touchend'].forEach(function (action) {
	          domElem.addEventListener(action, function (e, win) {
	            _this[action](_this.eventInfo(action, e, win));
	          }, false);
	        });
	      }
	
	      if (opt.enableKeyboard) {
	        ['keydown', 'keyup'].forEach(function (action) {
	          document.addEventListener(action, function (e, win) {
	            _this[action](_this.eventInfo(action, e, win));
	          }, false);
	        });
	      }
	    }
	  }, {
	    key: 'eventInfo',
	    value: function eventInfo(type, e, win) {
	      var domElem = this.domElem;
	      var scene = this.scene;
	      var opt = this.opt;
	      var size = this.getSize();
	      var relative = opt.relative;
	      var centerOrigin = opt.centerOrigin;
	      var pos = opt.cachePosition && this.pos || _getPos(domElem);
	      var ge = get(e, win);
	      var epos = getPos(e, win);
	      var origPos = { x: epos[0].x, y: epos[0].y };
	      var evt = {};
	      var x = void 0;
	      var y = void 0;
	
	      // get Position
	      for (var i = 0, l = epos.length; i < l; ++i) {
	        x = epos[i].x;
	        y = epos[i].y;
	        if (relative) {
	          x -= pos.x;y -= pos.y;
	          if (centerOrigin) {
	            x -= size.width / 2;
	            y -= size.height / 2;
	            // y axis now points to the top of the screen
	            y *= -1;
	          }
	        }
	        epos[i].x = x;
	        epos[i].y = y;
	      }
	
	      switch (type) {
	        case 'mousewheel':
	          evt.wheel = getWheel(ge);
	          break;
	        case 'keydown':
	        case 'keyup':
	          Object.assign(evt, getKey(ge));
	          break;
	        case 'mouseup':
	          evt.isRightClick = isRightClick(ge);
	          break;
	        default:
	          break;
	      }
	
	      var cacheTarget = void 0;
	
	      Object.assign(evt, {
	        x: epos[0].x,
	        y: epos[0].y,
	        posArray: epos,
	
	        cache: false,
	        // stop event propagation
	        stop: function stop() {
	          _stop(ge);
	        },
	
	        // get the target element of the event
	        getTarget: function getTarget() {
	          if (cacheTarget) {
	            return cacheTarget;
	          }
	          return cacheTarget = opt.picking && scene.pick(origPos.x - pos.x, origPos.y - pos.y) || true;
	        }
	      });
	      // wrap native event
	      evt.event = ge;
	
	      return evt;
	    }
	  }, {
	    key: 'getSize',
	    value: function getSize() {
	      if (this.cacheSize) {
	        return this.size;
	      }
	      var domElem = this.domElem;
	      return {
	        width: domElem.width || domElem.offsetWidth,
	        height: domElem.height || domElem.offsetHeight
	      };
	    }
	  }, {
	    key: 'mouseup',
	    value: function mouseup(e) {
	      if (!this.moved) {
	        if (e.isRightClick) {
	          this.callbacks.onRightClick(e, this.hovered);
	        } else {
	          this.callbacks.onClick(e, toO3D(this.pressed));
	        }
	      }
	      if (this.pressed) {
	        if (this.moved) {
	          this.callbacks.onDragEnd(e, toO3D(this.pressed));
	        } else {
	          this.callbacks.onDragCancel(e, toO3D(this.pressed));
	        }
	        this.pressed = this.moved = false;
	      }
	    }
	  }, {
	    key: 'mouseout',
	    value: function mouseout(e) {
	      // mouseout canvas
	      var rt = e.relatedTarget;
	      var domElem = this.domElem;
	      while (rt && rt.parentNode) {
	        if (domElem === rt.parentNode) {
	          return;
	        }
	        rt = rt.parentNode;
	      }
	      if (this.hovered) {
	        this.callbacks.onMouseLeave(e, this.hovered);
	        this.hovered = false;
	      }
	      if (this.pressed && this.moved) {
	        this.callbacks.onDragEnd(e);
	        this.pressed = this.moved = false;
	      }
	    }
	  }, {
	    key: 'mouseover',
	    value: function mouseover(e) {}
	  }, {
	    key: 'mousemove',
	    value: function mousemove(e) {
	      if (this.pressed) {
	        this.moved = true;
	        this.callbacks.onDragMove(e, toO3D(this.pressed));
	        return;
	      }
	      if (this.hovered) {
	        var target = toO3D(e.getTarget());
	        if (!target || target.hash !== this.hash) {
	          this.callbacks.onMouseLeave(e, this.hovered);
	          this.hovered = target;
	          this.hash = target;
	          if (target) {
	            this.hash = target.hash;
	            this.callbacks.onMouseEnter(e, this.hovered);
	          }
	        } else {
	          this.callbacks.onMouseMove(e, this.hovered);
	        }
	      } else {
	        this.hovered = toO3D(e.getTarget());
	        this.hash = this.hovered;
	        if (this.hovered) {
	          this.hash = this.hovered.hash;
	          this.callbacks.onMouseEnter(e, this.hovered);
	        }
	      }
	      if (!this.opt.picking) {
	        this.callbacks.onMouseMove(e);
	      }
	    }
	  }, {
	    key: 'mousewheel',
	    value: function mousewheel(e) {
	      this.callbacks.onMouseWheel(e);
	    }
	  }, {
	    key: 'mousedown',
	    value: function mousedown(e) {
	      this.pressed = e.getTarget();
	      this.callbacks.onDragStart(e, toO3D(this.pressed));
	    }
	  }, {
	    key: 'touchstart',
	    value: function touchstart(e) {
	      this.touched = e.getTarget();
	      this.touchedLastPosition = { x: e.x, y: e.y };
	      this.callbacks.onTouchStart(e, toO3D(this.touched));
	    }
	  }, {
	    key: 'touchmove',
	    value: function touchmove(e) {
	      if (this.touched) {
	        this.touchMoved = true;
	        this.callbacks.onTouchMove(e, toO3D(this.touched));
	      }
	    }
	  }, {
	    key: 'touchend',
	    value: function touchend(e) {
	      if (this.touched) {
	        if (this.touchMoved) {
	          this.callbacks.onTouchEnd(e, toO3D(this.touched));
	        } else {
	          e.x = isNaN(e.x) ? this.touchedLastPosition.x : e.x;
	          e.y = isNaN(e.y) ? this.touchedLastPosition.y : e.y;
	          this.callbacks.onTap(e, toO3D(this.touched));
	          this.callbacks.onTouchCancel(e, toO3D(this.touched));
	        }
	        this.touched = this.touchMoved = false;
	      }
	    }
	  }, {
	    key: 'keydown',
	    value: function keydown(e) {
	      this.callbacks.onKeyDown(e);
	    }
	  }, {
	    key: 'keyup',
	    value: function keyup(e) {
	      this.callbacks.onKeyUp(e);
	    }
	  }]);
	
	  return EventsProxy;
	}();
	
	Object.assign(EventsProxy.prototype, {
	  hovered: false,
	  pressed: false,
	  touched: false,
	  touchedLastPosition: { x: 0, y: 0 },
	  touchMoved: false,
	  moved: false
	});
	
	var DEFAULT_OPTS = {
	  cachePosition: true,
	  cacheSize: true,
	  relative: true,
	  centerOrigin: true,
	  disableContextMenu: true,
	  bind: false,
	  picking: false,
	
	  enableTouch: true,
	  enableMouse: true,
	  enableKeyboard: true,
	
	  onClick: _utils.noop,
	  onRightClick: _utils.noop,
	  onDragStart: _utils.noop,
	  onDragMove: _utils.noop,
	  onDragEnd: _utils.noop,
	  onDragCancel: _utils.noop,
	  onTouchStart: _utils.noop,
	  onTouchMove: _utils.noop,
	  onTouchEnd: _utils.noop,
	  onTouchCancel: _utils.noop,
	  onTap: _utils.noop,
	  onMouseMove: _utils.noop,
	  onMouseEnter: _utils.noop,
	  onMouseLeave: _utils.noop,
	  onMouseWheel: _utils.noop,
	  onKeyDown: _utils.noop,
	  onKeyUp: _utils.noop
	};
	
	var Keys = exports.Keys = KEYS;
	
	function keyOf(code) {
	  var keyMap = Keys;
	  for (var name in keyMap) {
	    if (keyMap[name] === code) {
	      return name;
	    }
	  }
	  return null;
	}
	
	function addEvents(domElement) {
	  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  opt = Object.assign({}, DEFAULT_OPTS, opt);
	
	  var bind = opt.bind;
	  if (bind) {
	    for (var name in opt) {
	      if (name.match(/^on[a-zA-Z0-9]+$/)) {
	        (function (fname, fn) {
	          opt[fname] = function f() {
	            fn.apply(bind, Array.prototype.slice.call(arguments));
	          };
	        })(name, opt[name]);
	      }
	    }
	  }
	
	  return new EventsProxy(domElement, opt);
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _framebuffer = __webpack_require__(301);
	
	var _framebuffer2 = _interopRequireDefault(_framebuffer);
	
	var _renderbuffer = __webpack_require__(215);
	
	var _renderbuffer2 = _interopRequireDefault(_renderbuffer);
	
	var _texture2d = __webpack_require__(216);
	
	var _texture2d2 = _interopRequireDefault(_texture2d);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FramebufferObject = function () {
	
	  /* eslint-disable max-statements */
	  function FramebufferObject(gl) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$width = _ref.width,
	        width = _ref$width === undefined ? 1 : _ref$width,
	        _ref$height = _ref.height,
	        height = _ref$height === undefined ? 1 : _ref$height,
	        _ref$depth = _ref.depth,
	        depth = _ref$depth === undefined ? true : _ref$depth,
	        _ref$minFilter = _ref.minFilter,
	        minFilter = _ref$minFilter === undefined ? _webgl.GL.NEAREST : _ref$minFilter,
	        _ref$magFilter = _ref.magFilter,
	        magFilter = _ref$magFilter === undefined ? _webgl.GL.NEAREST : _ref$magFilter,
	        _ref$format = _ref.format,
	        format = _ref$format === undefined ? _webgl.GL.RGBA : _ref$format,
	        _ref$type = _ref.type,
	        type = _ref$type === undefined ? _webgl.GL.UNSIGNED_BYTE : _ref$type;
	
	    _classCallCheck(this, FramebufferObject);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	
	    this.gl = gl;
	    this.depth = depth;
	    this.minFilter = minFilter;
	    this.magFilter = magFilter;
	    this.format = format;
	    this.type = type;
	
	    this.resize(width, height);
	  }
	
	  _createClass(FramebufferObject, [{
	    key: 'delete',
	    value: function _delete() {}
	  }, {
	    key: 'resize',
	    value: function resize(width, height) {
	      (0, _assert2.default)(width >= 0 && height >= 0, 'Width and height need to be integers');
	      if (width === this.width && height === this.height) {
	        return;
	      }
	
	      var gl = this.gl;
	
	      // TODO - do we need to reallocate the framebuffer?
	
	      var fb = new _framebuffer2.default(gl);
	
	      var colorBuffer = new _texture2d2.default(gl, {
	        minFilter: this.minFilter,
	        magFilter: this.magFilter
	      })
	      // TODO - should be handled by Texture2D constructor?
	      .setImageData({
	        data: null,
	        width: width,
	        height: height,
	        type: this.type,
	        format: this.format
	      });
	
	      fb.attachTexture({
	        attachment: _webgl.GL.COLOR_ATTACHMENT0,
	        texture: colorBuffer
	      });
	
	      if (this.colorBuffer) {
	        this.colorBuffer.delete();
	      }
	      this.colorBuffer = colorBuffer;
	
	      // Add a depth buffer if requested
	      if (this.depth) {
	        var depthBuffer = new _renderbuffer2.default(gl).storage({
	          internalFormat: _webgl.GL.DEPTH_COMPONENT16,
	          width: width,
	          height: height
	        });
	        fb.attachRenderbuffer({
	          attachment: _webgl.GL.DEPTH_ATTACHMENT,
	          renderbuffer: depthBuffer
	        });
	
	        if (this.depthBuffer) {
	          this.depthBuffer.delete();
	        }
	        this.depthBuffer = depthBuffer;
	      }
	
	      // Checks that framebuffer was properly set up,
	      // if not, throws an explanatory error
	      fb.checkStatus();
	
	      this.width = width;
	      this.height = height;
	
	      // Immediately dispose of old buffer
	      if (this.fb) {
	        this.fb.delete();
	      }
	      this.fb = fb;
	    }
	    /* eslint-enable max-statements */
	
	  }, {
	    key: 'bind',
	    value: function bind() {
	      this.fb.bind();
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind() {
	      this.fb.unbind();
	    }
	  }]);
	
	  return FramebufferObject;
	}();
	
	exports.default = FramebufferObject;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pickModels = pickModels;
	
	var _webgl = __webpack_require__(131);
	
	var _webglChecks = __webpack_require__(37);
	
	var _group = __webpack_require__(293);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO - this is the new picking for deck.gl
	/* eslint-disable max-statements, no-try-catch */
	/* global window */
	var ILLEGAL_ARG = 'Illegal argument to pick';
	
	function pickModels(gl, _ref) {
	  var group = _ref.group,
	      uniforms = _ref.uniforms,
	      x = _ref.x,
	      y = _ref.y,
	      _ref$framebuffer = _ref.framebuffer,
	      framebuffer = _ref$framebuffer === undefined ? null : _ref$framebuffer,
	      _ref$pickingFBO = _ref.pickingFBO,
	      pickingFBO = _ref$pickingFBO === undefined ? null : _ref$pickingFBO,
	      _ref$pickingProgram = _ref.pickingProgram,
	      pickingProgram = _ref$pickingProgram === undefined ? null : _ref$pickingProgram,
	      _ref$pickingColors = _ref.pickingColors,
	      pickingColors = _ref$pickingColors === undefined ? null : _ref$pickingColors;
	
	  (0, _webglChecks.assertWebGLContext)(gl);
	  (0, _assert2.default)(group instanceof _group2.default, ILLEGAL_ARG);
	
	  var dpr = typeof window !== 'undefined' ? window.devicePixelRatio : 1;
	  var deviceX = x * dpr;
	  var deviceY = gl.canvas.height - y * dpr;
	
	  // Set up a frame buffer if needed
	  // TODO - cache picking fbo (needs to be resized)?
	  framebuffer = framebuffer || pickingFBO || new _webgl.Framebuffer(gl, {
	    width: gl.canvas.width,
	    height: gl.canvas.height
	  });
	
	  framebuffer.resize({ width: gl.canvas.width, height: gl.canvas.height });
	
	  // Make sure we clear scissor test and fbo bindings in case of exceptions
	  return (0, _webgl.glContextWithState)(gl, {
	    framebuffer: framebuffer,
	    // We are only interested in one pixel, no need to render anything else
	    scissorTest: { x: deviceX, y: deviceY, w: 1, h: 1 }
	  }, function () {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = group.traverseReverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var model = _step.value;
	
	        if (model.isPickable()) {
	
	          // Clear the frame buffer, render and sample
	          gl.clear(_webgl.GL.COLOR_BUFFER_BIT | _webgl.GL.DEPTH_BUFFER_BIT);
	
	          model.setUniforms({
	            renderPickingBuffer: 1,
	            enablePicking: true
	          });
	
	          model.render(uniforms);
	
	          model.setUniforms({
	            renderPickingBuffer: false,
	            enablePicking: false
	          });
	
	          // Read color in the central pixel, to be mapped with picking colors
	          var color = new Uint8Array(4);
	          gl.readPixels(deviceX, deviceY, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, color);
	
	          var isPicked = color[0] !== 0 || color[1] !== 0 || color[2] !== 0 || color[3] !== 0;
	
	          // Add the information to the stack
	          if (isPicked) {
	            return {
	              model: model,
	              color: color,
	              x: x,
	              y: y,
	              deviceX: deviceX,
	              deviceY: deviceY
	            };
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return null;
	  });
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registerShaders = __webpack_require__(468);
	
	Object.defineProperty(exports, 'registerShaderModules', {
	  enumerable: true,
	  get: function get() {
	    return _registerShaders.registerShaderModules;
	  }
	});
	
	var _assembleShaders = __webpack_require__(1047);
	
	Object.defineProperty(exports, 'assembleShaders', {
	  enumerable: true,
	  get: function get() {
	    return _assembleShaders.assembleShaders;
	  }
	});
	
	var _shaderCache = __webpack_require__(1048);
	
	Object.defineProperty(exports, 'ShaderCache', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shaderCache).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVyLXRvb2xzL2luZGV4LmpzIl0sIm5hbWVzIjpbInJlZ2lzdGVyU2hhZGVyTW9kdWxlcyIsImFzc2VtYmxlU2hhZGVycyIsImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OzRCQUFRQSxxQjs7Ozs7Ozs7OzRCQUNBQyxlOzs7Ozs7Ozs7Z0RBQ0FDLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQge3JlZ2lzdGVyU2hhZGVyTW9kdWxlc30gZnJvbSAnLi9yZWdpc3Rlci1zaGFkZXJzJztcbmV4cG9ydCB7YXNzZW1ibGVTaGFkZXJzfSBmcm9tICcuL2Fzc2VtYmxlLXNoYWRlcnMnO1xuZXhwb3J0IHtkZWZhdWx0IGFzIFNoYWRlckNhY2hlfSBmcm9tICcuL3NoYWRlci1jYWNoZSc7XG4iXX0=

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerShaderModules = registerShaderModules;
	exports.getShaderModule = getShaderModule;
	exports.getShaderDependencies = getShaderDependencies;
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shaderModules = {};
	
	/**
	 * Registers an array of shader modules
	 * @param {Object[]} shaderModuleList - Array of shader modules
	 */
	function registerShaderModules(shaderModuleList) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = shaderModuleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var shaderModule = _step.value;
	
	      (0, _assert2.default)(shaderModule.name, 'shader module has no name');
	      if (shaderModules[shaderModule.name]) {
	        throw new Error('shader module ' + shaderModule.name + ' already registered');
	      }
	      shaderModules[shaderModule.name] = shaderModule;
	      shaderModule.dependencies = shaderModule.dependencies || [];
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function getShaderModule(moduleName) {
	  var shaderModule = shaderModules[moduleName];
	  if (!shaderModule) {
	    // console.log(`${moduleName} not in registered modules:`, shaderModules);
	    (0, _assert2.default)(false, 'Unknown shader module ' + moduleName);
	  }
	  return shaderModule;
	}
	
	/**
	 * Takes a list of shader module names and returns a new list of
	 * shader module names that includes all dependencies, sorted so
	 * that modules that are dependencies of other modules come first.
	 *
	 * If the shader glsl code from the returned modules is concatenated
	 * in the reverse order, it is guaranteed that all functions be resolved and
	 * that all function and variable definitions come before use.
	 *
	 * @param {String[]} moduleNames - Array of module names
	 * @return {String[]} - Array of modules
	 */
	function getShaderDependencies(moduleNames) {
	  var result = {};
	  getDependencyGraph({
	    moduleNames: moduleNames,
	    level: 0,
	    result: result
	  });
	  return Object.keys(result).sort(function (a, b) {
	    return result[a] - result[b];
	  });
	}
	
	// Adds another level of dependencies to the result map
	function getDependencyGraph(_ref) {
	  var moduleNames = _ref.moduleNames,
	      level = _ref.level,
	      result = _ref.result;
	
	  if (level >= 5) {
	    throw new Error('Possible loop in shader dependency graph');
	  }
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = moduleNames[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var moduleName = _step2.value;
	
	      result[moduleName] = level;
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  var _iteratorNormalCompletion3 = true;
	  var _didIteratorError3 = false;
	  var _iteratorError3 = undefined;
	
	  try {
	    for (var _iterator3 = moduleNames[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	      var _moduleName = _step3.value;
	
	      var shaderModule = getShaderModule(_moduleName);
	
	      getDependencyGraph({
	        moduleNames: shaderModule.dependencies,
	        level: level,
	        result: result
	      });
	    }
	  } catch (err) {
	    _didIteratorError3 = true;
	    _iteratorError3 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion3 && _iterator3.return) {
	        _iterator3.return();
	      }
	    } finally {
	      if (_didIteratorError3) {
	        throw _iteratorError3;
	      }
	    }
	  }
	
	  return result;
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _truncatedConeGeometry = __webpack_require__(213);
	
	var _truncatedConeGeometry2 = _interopRequireDefault(_truncatedConeGeometry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConeGeometry = function (_TruncatedConeGeometr) {
	  _inherits(ConeGeometry, _TruncatedConeGeometr);
	
	  function ConeGeometry() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, ConeGeometry);
	
	    var _opts$radius = opts.radius,
	        radius = _opts$radius === undefined ? 1 : _opts$radius,
	        _opts$cap = opts.cap,
	        cap = _opts$cap === undefined ? true : _opts$cap;
	    return _possibleConstructorReturn(this, (ConeGeometry.__proto__ || Object.getPrototypeOf(ConeGeometry)).call(this, Object.assign({}, opts, {
	      topRadius: 0,
	      topCap: Boolean(cap),
	      bottomCap: Boolean(cap),
	      bottomRadius: radius
	    })));
	  }
	
	  return ConeGeometry;
	}(_truncatedConeGeometry2.default);
	
	exports.default = ConeGeometry;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9nZW9tZXRyeS9jb25lLWdlb21ldHJ5LmpzIl0sIm5hbWVzIjpbIkNvbmVHZW9tZXRyeSIsIm9wdHMiLCJyYWRpdXMiLCJjYXAiLCJPYmplY3QiLCJhc3NpZ24iLCJ0b3BSYWRpdXMiLCJ0b3BDYXAiLCJCb29sZWFuIiwiYm90dG9tQ2FwIiwiYm90dG9tUmFkaXVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7OztJQUVxQkEsWTs7O0FBQ25CLDBCQUF1QjtBQUFBLFFBQVhDLElBQVcsdUVBQUosRUFBSTs7QUFBQTs7QUFBQSx1QkFDWUEsSUFEWixDQUNkQyxNQURjO0FBQUEsUUFDZEEsTUFEYyxnQ0FDTCxDQURLO0FBQUEsb0JBQ1lELElBRFosQ0FDRkUsR0FERTtBQUFBLFFBQ0ZBLEdBREUsNkJBQ0ksSUFESjtBQUFBLHVIQUVmQyxPQUFPQyxNQUFQLENBQWMsRUFBZCxFQUFrQkosSUFBbEIsRUFBd0I7QUFDNUJLLGlCQUFXLENBRGlCO0FBRTVCQyxjQUFRQyxRQUFRTCxHQUFSLENBRm9CO0FBRzVCTSxpQkFBV0QsUUFBUUwsR0FBUixDQUhpQjtBQUk1Qk8sb0JBQWNSO0FBSmMsS0FBeEIsQ0FGZTtBQVF0Qjs7Ozs7a0JBVGtCRixZIiwiZmlsZSI6ImNvbmUtZ2VvbWV0cnkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVHJ1bmNhdGVkQ29uZUdlb21ldHJ5IGZyb20gJy4vdHJ1bmNhdGVkLWNvbmUtZ2VvbWV0cnknO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBDb25lR2VvbWV0cnkgZXh0ZW5kcyBUcnVuY2F0ZWRDb25lR2VvbWV0cnkge1xuICBjb25zdHJ1Y3RvcihvcHRzID0ge30pIHtcbiAgICBjb25zdCB7cmFkaXVzID0gMSwgY2FwID0gdHJ1ZX0gPSBvcHRzO1xuICAgIHN1cGVyKE9iamVjdC5hc3NpZ24oe30sIG9wdHMsIHtcbiAgICAgIHRvcFJhZGl1czogMCxcbiAgICAgIHRvcENhcDogQm9vbGVhbihjYXApLFxuICAgICAgYm90dG9tQ2FwOiBCb29sZWFuKGNhcCksXG4gICAgICBib3R0b21SYWRpdXM6IHJhZGl1c1xuICAgIH0pKTtcbiAgfVxufVxuIl19

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(106);
	
	var _geometry2 = _interopRequireDefault(_geometry);
	
	var _utils = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CubeGeometry = function (_Geometry) {
	  _inherits(CubeGeometry, _Geometry);
	
	  function CubeGeometry() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, CubeGeometry);
	
	    var _opts$id = opts.id,
	        id = _opts$id === undefined ? (0, _utils.uid)('cube-geometry') : _opts$id;
	    return _possibleConstructorReturn(this, (CubeGeometry.__proto__ || Object.getPrototypeOf(CubeGeometry)).call(this, Object.assign({}, opts, { id: id, attributes: getCubeAttributes() })));
	  }
	
	  return CubeGeometry;
	}(_geometry2.default);
	
	/* eslint-disable no-multi-spaces, indent */
	
	
	exports.default = CubeGeometry;
	var CUBE_INDICES = new Uint16Array([0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23]);
	
	var CUBE_POSITIONS = new Float32Array([-1, -1, 1, 1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1, -1, -1, 1, -1, 1, 1, -1, 1, -1, -1, -1, 1, -1, -1, 1, 1, 1, 1, 1, 1, 1, -1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, -1, 1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1, 1, -1]);
	
	var CUBE_NORMALS = new Float32Array([
	// Front face
	0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0,
	
	// Back face
	0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0,
	
	// Top face
	0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0,
	
	// Bottom face
	0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0,
	
	// Right face
	1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0,
	
	// Left face
	-1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0]);
	
	var CUBE_TEX_COORDS = new Float32Array([
	// Front face
	0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0,
	
	// Back face
	1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 0.0, 0.0,
	
	// Top face
	0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0,
	
	// Bottom face
	1.0, 1.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0,
	
	// Right face
	1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 0.0, 0.0,
	
	// Left face
	0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0]);
	/* eslint-enable no-multi-spaces, indent */
	
	function getCubeAttributes() {
	  return {
	    indices: new Uint16Array(CUBE_INDICES),
	    positions: new Float32Array(CUBE_POSITIONS),
	    normals: new Float32Array(CUBE_NORMALS),
	    texCoords: new Float32Array(CUBE_TEX_COORDS)
	  };
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _truncatedConeGeometry = __webpack_require__(213);
	
	var _truncatedConeGeometry2 = _interopRequireDefault(_truncatedConeGeometry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CylinderGeometry = function (_TruncatedConeGeometr) {
	  _inherits(CylinderGeometry, _TruncatedConeGeometr);
	
	  function CylinderGeometry() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, CylinderGeometry);
	
	    var _opts$radius = opts.radius,
	        radius = _opts$radius === undefined ? 1 : _opts$radius;
	    return _possibleConstructorReturn(this, (CylinderGeometry.__proto__ || Object.getPrototypeOf(CylinderGeometry)).call(this, Object.assign({}, opts, {
	      bottomRadius: radius,
	      topRadius: radius
	    })));
	  }
	
	  return CylinderGeometry;
	}(_truncatedConeGeometry2.default);
	
	exports.default = CylinderGeometry;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9nZW9tZXRyeS9jeWxpbmRlci1nZW9tZXRyeS5qcyJdLCJuYW1lcyI6WyJDeWxpbmRlckdlb21ldHJ5Iiwib3B0cyIsInJhZGl1cyIsIk9iamVjdCIsImFzc2lnbiIsImJvdHRvbVJhZGl1cyIsInRvcFJhZGl1cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7SUFFcUJBLGdCOzs7QUFDbkIsOEJBQXVCO0FBQUEsUUFBWEMsSUFBVyx1RUFBSixFQUFJOztBQUFBOztBQUFBLHVCQUNBQSxJQURBLENBQ2RDLE1BRGM7QUFBQSxRQUNkQSxNQURjLGdDQUNMLENBREs7QUFBQSwrSEFFZkMsT0FBT0MsTUFBUCxDQUFjLEVBQWQsRUFBa0JILElBQWxCLEVBQXdCO0FBQzVCSSxvQkFBY0gsTUFEYztBQUU1QkksaUJBQVdKO0FBRmlCLEtBQXhCLENBRmU7QUFNdEI7Ozs7O2tCQVBrQkYsZ0IiLCJmaWxlIjoiY3lsaW5kZXItZ2VvbWV0cnkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVHJ1bmNhdGVkQ29uZUdlb21ldHJ5IGZyb20gJy4vdHJ1bmNhdGVkLWNvbmUtZ2VvbWV0cnknO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBDeWxpbmRlckdlb21ldHJ5IGV4dGVuZHMgVHJ1bmNhdGVkQ29uZUdlb21ldHJ5IHtcbiAgY29uc3RydWN0b3Iob3B0cyA9IHt9KSB7XG4gICAgY29uc3Qge3JhZGl1cyA9IDF9ID0gb3B0cztcbiAgICBzdXBlcihPYmplY3QuYXNzaWduKHt9LCBvcHRzLCB7XG4gICAgICBib3R0b21SYWRpdXM6IHJhZGl1cyxcbiAgICAgIHRvcFJhZGl1czogcmFkaXVzXG4gICAgfSkpO1xuICB9XG59XG4iXX0=

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(106);
	
	var _geometry2 = _interopRequireDefault(_geometry);
	
	var _math = __webpack_require__(477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable comma-spacing, max-statements, complexity */
	
	var ICO_POSITIONS = [-1, 0, 0, 0, 1, 0, 0, 0, -1, 0, 0, 1, 0, -1, 0, 1, 0, 0];
	var ICO_INDICES = [3, 4, 5, 3, 5, 1, 3, 1, 0, 3, 0, 4, 4, 0, 2, 4, 2, 5, 2, 0, 1, 5, 2, 1];
	
	var IcoSphereGeometry = function (_Geometry) {
	  _inherits(IcoSphereGeometry, _Geometry);
	
	  function IcoSphereGeometry() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, IcoSphereGeometry);
	
	    var _ref = {},
	        _ref$iterations = _ref.iterations,
	        iterations = _ref$iterations === undefined ? 0 : _ref$iterations;
	
	
	    var PI = Math.PI;
	    var PI2 = PI * 2;
	
	    var positions = [].concat(ICO_POSITIONS);
	    var indices = [].concat(ICO_INDICES);
	
	    positions.push();
	    indices.push();
	
	    var getMiddlePoint = function () {
	      var pointMemo = {};
	
	      return function (i1, i2) {
	        i1 *= 3;
	        i2 *= 3;
	        var mini = i1 < i2 ? i1 : i2;
	        var maxi = i1 > i2 ? i1 : i2;
	        var key = mini + '|' + maxi;
	
	        if (key in pointMemo) {
	          return pointMemo[key];
	        }
	
	        var x1 = positions[i1];
	        var y1 = positions[i1 + 1];
	        var z1 = positions[i1 + 2];
	        var x2 = positions[i2];
	        var y2 = positions[i2 + 1];
	        var z2 = positions[i2 + 2];
	        var xm = (x1 + x2) / 2;
	        var ym = (y1 + y2) / 2;
	        var zm = (z1 + z2) / 2;
	        var len = Math.sqrt(xm * xm + ym * ym + zm * zm);
	
	        xm /= len;
	        ym /= len;
	        zm /= len;
	
	        positions.push(xm, ym, zm);
	
	        return pointMemo[key] = positions.length / 3 - 1;
	      };
	    }();
	
	    for (var i = 0; i < iterations; i++) {
	      var indices2 = [];
	      for (var j = 0; j < indices.length; j += 3) {
	        var a = getMiddlePoint(indices[j + 0], indices[j + 1]);
	        var b = getMiddlePoint(indices[j + 1], indices[j + 2]);
	        var c = getMiddlePoint(indices[j + 2], indices[j + 0]);
	
	        indices2.push(c, indices[j + 0], a, a, indices[j + 1], b, b, indices[j + 2], c, a, b, c);
	      }
	      indices = indices2;
	    }
	
	    // Calculate texCoords and normals
	    var normals = new Array(indices.length * 3);
	    var texCoords = new Array(indices.length * 2);
	
	    var l = indices.length;
	    for (var _i = l - 3; _i >= 0; _i -= 3) {
	      var i1 = indices[_i + 0];
	      var i2 = indices[_i + 1];
	      var i3 = indices[_i + 2];
	      var in1 = i1 * 3;
	      var in2 = i2 * 3;
	      var in3 = i3 * 3;
	      var iu1 = i1 * 2;
	      var iu2 = i2 * 2;
	      var iu3 = i3 * 2;
	      var x1 = positions[in1 + 0];
	      var y1 = positions[in1 + 1];
	      var z1 = positions[in1 + 2];
	      var theta1 = Math.acos(z1 / Math.sqrt(x1 * x1 + y1 * y1 + z1 * z1));
	      var phi1 = Math.atan2(y1, x1) + PI;
	      var v1 = theta1 / PI;
	      var u1 = 1 - phi1 / PI2;
	      var x2 = positions[in2 + 0];
	      var y2 = positions[in2 + 1];
	      var z2 = positions[in2 + 2];
	      var theta2 = Math.acos(z2 / Math.sqrt(x2 * x2 + y2 * y2 + z2 * z2));
	      var phi2 = Math.atan2(y2, x2) + PI;
	      var v2 = theta2 / PI;
	      var u2 = 1 - phi2 / PI2;
	      var x3 = positions[in3 + 0];
	      var y3 = positions[in3 + 1];
	      var z3 = positions[in3 + 2];
	      var theta3 = Math.acos(z3 / Math.sqrt(x3 * x3 + y3 * y3 + z3 * z3));
	      var phi3 = Math.atan2(y3, x3) + PI;
	      var v3 = theta3 / PI;
	      var u3 = 1 - phi3 / PI2;
	      var vec1 = [x3 - x2, y3 - y2, z3 - z2];
	      var vec2 = [x1 - x2, y1 - y2, z1 - z2];
	      var normal = _math.Vector3.cross(vec1, vec2).normalize();
	      var newIndex = void 0;
	
	      if ((u1 === 0 || u2 === 0 || u3 === 0) && (u1 === 0 || u1 > 0.5) && (u2 === 0 || u2 > 0.5) && (u3 === 0 || u3 > 0.5)) {
	
	        positions.push(positions[in1 + 0], positions[in1 + 1], positions[in1 + 2]);
	        newIndex = positions.length / 3 - 1;
	        indices.push(newIndex);
	        texCoords[newIndex * 2 + 0] = 1;
	        texCoords[newIndex * 2 + 1] = v1;
	        normals[newIndex * 3 + 0] = normal.x;
	        normals[newIndex * 3 + 1] = normal.y;
	        normals[newIndex * 3 + 2] = normal.z;
	
	        positions.push(positions[in2 + 0], positions[in2 + 1], positions[in2 + 2]);
	        newIndex = positions.length / 3 - 1;
	        indices.push(newIndex);
	        texCoords[newIndex * 2 + 0] = 1;
	        texCoords[newIndex * 2 + 1] = v2;
	        normals[newIndex * 3 + 0] = normal.x;
	        normals[newIndex * 3 + 1] = normal.y;
	        normals[newIndex * 3 + 2] = normal.z;
	
	        positions.push(positions[in3 + 0], positions[in3 + 1], positions[in3 + 2]);
	        newIndex = positions.length / 3 - 1;
	        indices.push(newIndex);
	        texCoords[newIndex * 2 + 0] = 1;
	        texCoords[newIndex * 2 + 1] = v3;
	        normals[newIndex * 3 + 0] = normal.x;
	        normals[newIndex * 3 + 1] = normal.y;
	        normals[newIndex * 3 + 2] = normal.z;
	      }
	
	      normals[in1 + 0] = normals[in2 + 0] = normals[in3 + 0] = normal.x;
	      normals[in1 + 1] = normals[in2 + 1] = normals[in3 + 1] = normal.y;
	      normals[in1 + 2] = normals[in2 + 2] = normals[in3 + 2] = normal.z;
	
	      texCoords[iu1 + 0] = u1;
	      texCoords[iu1 + 1] = v1;
	
	      texCoords[iu2 + 0] = u2;
	      texCoords[iu2 + 1] = v2;
	
	      texCoords[iu3 + 0] = u3;
	      texCoords[iu3 + 1] = v3;
	    }
	
	    return _possibleConstructorReturn(this, (IcoSphereGeometry.__proto__ || Object.getPrototypeOf(IcoSphereGeometry)).call(this, Object.assign({}, opts, {
	      attributes: {
	        positions: new Float32Array(positions),
	        normals: new Float32Array(normals),
	        texCoords: new Float32Array(texCoords),
	        indices: new Uint16Array(indices)
	      }
	    })));
	  }
	
	  return IcoSphereGeometry;
	}(_geometry2.default);
	
	exports.default = IcoSphereGeometry;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(106);
	
	var _geometry2 = _interopRequireDefault(_geometry);
	
	var _utils = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlaneGeometry = function (_Geometry) {
	  _inherits(PlaneGeometry, _Geometry);
	
	  // Primitives inspired by TDL http://code.google.com/p/webglsamples/,
	  // copyright 2011 Google Inc. new BSD License
	  // (http://www.opensource.org/licenses/bsd-license.php).
	  /* eslint-disable max-statements, complexity */
	  /* eslint-disable complexity, max-statements */
	  function PlaneGeometry() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, PlaneGeometry);
	
	    var _opts$type = opts.type,
	        type = _opts$type === undefined ? 'x,y' : _opts$type,
	        _opts$offset = opts.offset,
	        offset = _opts$offset === undefined ? 0 : _opts$offset,
	        _opts$flipCull = opts.flipCull,
	        flipCull = _opts$flipCull === undefined ? false : _opts$flipCull,
	        _opts$unpack = opts.unpack,
	        unpack = _opts$unpack === undefined ? false : _opts$unpack,
	        _opts$id = opts.id,
	        id = _opts$id === undefined ? (0, _utils.uid)('plane-geometry') : _opts$id;
	
	
	    var coords = type.split(',');
	    // width, height
	    var c1len = opts[coords[0] + 'len'];
	    var c2len = opts[coords[1] + 'len'];
	    // subdivisionsWidth, subdivisionsDepth
	    var subdivisions1 = opts['n' + coords[0]] || 1;
	    var subdivisions2 = opts['n' + coords[1]] || 1;
	    var numVertices = (subdivisions1 + 1) * (subdivisions2 + 1);
	
	    var positions = new Float32Array(numVertices * 3);
	    var normals = new Float32Array(numVertices * 3);
	    var texCoords = new Float32Array(numVertices * 2);
	
	    if (flipCull) {
	      c1len = -c1len;
	    }
	
	    var i2 = 0;
	    var i3 = 0;
	    for (var z = 0; z <= subdivisions2; z++) {
	      for (var x = 0; x <= subdivisions1; x++) {
	        var u = x / subdivisions1;
	        var v = z / subdivisions2;
	        texCoords[i2 + 0] = flipCull ? 1 - u : u;
	        texCoords[i2 + 1] = v;
	
	        switch (type) {
	          case 'x,y':
	            positions[i3 + 0] = c1len * u - c1len * 0.5;
	            positions[i3 + 1] = c2len * v - c2len * 0.5;
	            positions[i3 + 2] = offset;
	
	            normals[i3 + 0] = 0;
	            normals[i3 + 1] = 0;
	            normals[i3 + 2] = flipCull ? 1 : -1;
	            break;
	
	          case 'x,z':
	            positions[i3 + 0] = c1len * u - c1len * 0.5;
	            positions[i3 + 1] = offset;
	            positions[i3 + 2] = c2len * v - c2len * 0.5;
	
	            normals[i3 + 0] = 0;
	            normals[i3 + 1] = flipCull ? 1 : -1;
	            normals[i3 + 2] = 0;
	            break;
	
	          case 'y,z':
	            positions[i3 + 0] = offset;
	            positions[i3 + 1] = c1len * u - c1len * 0.5;
	            positions[i3 + 2] = c2len * v - c2len * 0.5;
	
	            normals[i3 + 0] = flipCull ? 1 : -1;
	            normals[i3 + 1] = 0;
	            normals[i3 + 2] = 0;
	            break;
	
	          default:
	            break;
	        }
	
	        i2 += 2;
	        i3 += 3;
	      }
	    }
	
	    var numVertsAcross = subdivisions1 + 1;
	    var indices = new Uint16Array(subdivisions1 * subdivisions2 * 6);
	
	    for (var _z = 0; _z < subdivisions2; _z++) {
	      for (var _x2 = 0; _x2 < subdivisions1; _x2++) {
	        var index = (_z * subdivisions1 + _x2) * 6;
	        // Make triangle 1 of quad.
	        indices[index + 0] = (_z + 0) * numVertsAcross + _x2;
	        indices[index + 1] = (_z + 1) * numVertsAcross + _x2;
	        indices[index + 2] = (_z + 0) * numVertsAcross + _x2 + 1;
	
	        // Make triangle 2 of quad.
	        indices[index + 3] = (_z + 1) * numVertsAcross + _x2;
	        indices[index + 4] = (_z + 1) * numVertsAcross + _x2 + 1;
	        indices[index + 5] = (_z + 0) * numVertsAcross + _x2 + 1;
	      }
	    }
	
	    // Optionally, unpack indexed geometry
	    if (unpack) {
	      var positions2 = new Float32Array(indices.length * 3);
	      var normals2 = new Float32Array(indices.length * 3);
	      var texCoords2 = new Float32Array(indices.length * 2);
	
	      for (var _x3 = 0; _x3 < indices.length; ++_x3) {
	        var _index = indices[_x3];
	        positions2[_x3 * 3 + 0] = positions[_index * 3 + 0];
	        positions2[_x3 * 3 + 1] = positions[_index * 3 + 1];
	        positions2[_x3 * 3 + 2] = positions[_index * 3 + 2];
	        normals2[_x3 * 3 + 0] = normals[_index * 3 + 0];
	        normals2[_x3 * 3 + 1] = normals[_index * 3 + 1];
	        normals2[_x3 * 3 + 2] = normals[_index * 3 + 2];
	        texCoords2[_x3 * 2 + 0] = texCoords[_index * 2 + 0];
	        texCoords2[_x3 * 2 + 1] = texCoords[_index * 2 + 1];
	      }
	
	      positions = positions2;
	      normals = normals2;
	      texCoords = texCoords2;
	      indices = undefined;
	    }
	
	    var attributes = {
	      positions: positions,
	      normals: normals,
	      texCoords: texCoords
	    };
	
	    if (indices) {
	      attributes.indices = indices;
	    }
	
	    return _possibleConstructorReturn(this, (PlaneGeometry.__proto__ || Object.getPrototypeOf(PlaneGeometry)).call(this, Object.assign({}, opts, { attributes: attributes, id: id })));
	  }
	
	  return PlaneGeometry;
	}(_geometry2.default);
	
	exports.default = PlaneGeometry;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(106);
	
	var _geometry2 = _interopRequireDefault(_geometry);
	
	var _utils = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SphereGeometry = function (_Geometry) {
	  _inherits(SphereGeometry, _Geometry);
	
	  function SphereGeometry() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, SphereGeometry);
	
	    var _opts$nlat = opts.nlat,
	        nlat = _opts$nlat === undefined ? 10 : _opts$nlat,
	        _opts$nlong = opts.nlong,
	        nlong = _opts$nlong === undefined ? 10 : _opts$nlong,
	        _opts$radius = opts.radius,
	        radius = _opts$radius === undefined ? 1 : _opts$radius,
	        _opts$id = opts.id,
	        id = _opts$id === undefined ? (0, _utils.uid)('sphere-geometry') : _opts$id;
	    return _possibleConstructorReturn(this, (SphereGeometry.__proto__ || Object.getPrototypeOf(SphereGeometry)).call(this, Object.assign({}, opts, { id: id, attributes: getSphereAttributes(nlat, nlong, radius) })));
	  }
	
	  return SphereGeometry;
	}(_geometry2.default);
	
	// Primitives inspired by TDL http://code.google.com/p/webglsamples/,
	// copyright 2011 Google Inc. new BSD License
	// (http://www.opensource.org/licenses/bsd-license.php).
	/* eslint-disable max-statements, complexity */
	
	
	exports.default = SphereGeometry;
	function getSphereAttributes(nlat, nlong, radius) {
	  var startLat = 0;
	  var endLat = Math.PI;
	  var latRange = endLat - startLat;
	  var startLong = 0;
	  var endLong = 2 * Math.PI;
	  var longRange = endLong - startLong;
	  var numVertices = (nlat + 1) * (nlong + 1);
	
	  if (typeof radius === 'number') {
	    (function () {
	      var value = radius;
	      radius = function radius(n1, n2, n3, u, v) {
	        return value;
	      };
	    })();
	  }
	
	  var positions = new Float32Array(numVertices * 3);
	  var normals = new Float32Array(numVertices * 3);
	  var texCoords = new Float32Array(numVertices * 2);
	  var indices = new Uint16Array(nlat * nlong * 6);
	
	  // Create positions, normals and texCoords
	  for (var y = 0; y <= nlat; y++) {
	    for (var x = 0; x <= nlong; x++) {
	
	      var u = x / nlong;
	      var v = y / nlat;
	
	      var index = x + y * (nlong + 1);
	      var i2 = index * 2;
	      var i3 = index * 3;
	
	      var theta = longRange * u;
	      var phi = latRange * v;
	      var sinTheta = Math.sin(theta);
	      var cosTheta = Math.cos(theta);
	      var sinPhi = Math.sin(phi);
	      var cosPhi = Math.cos(phi);
	      var ux = cosTheta * sinPhi;
	      var uy = cosPhi;
	      var uz = sinTheta * sinPhi;
	
	      var r = radius(ux, uy, uz, u, v);
	
	      positions[i3 + 0] = r * ux;
	      positions[i3 + 1] = r * uy;
	      positions[i3 + 2] = r * uz;
	
	      normals[i3 + 0] = ux;
	      normals[i3 + 1] = uy;
	      normals[i3 + 2] = uz;
	
	      texCoords[i2 + 0] = u;
	      texCoords[i2 + 1] = v;
	    }
	  }
	
	  // Create indices
	  var numVertsAround = nlat + 1;
	  for (var _x2 = 0; _x2 < nlat; _x2++) {
	    for (var _y = 0; _y < nlong; _y++) {
	      var _index = (_x2 * nlong + _y) * 6;
	
	      indices[_index + 0] = _y * numVertsAround + _x2;
	      indices[_index + 1] = _y * numVertsAround + _x2 + 1;
	      indices[_index + 2] = (_y + 1) * numVertsAround + _x2;
	
	      indices[_index + 3] = (_y + 1) * numVertsAround + _x2;
	      indices[_index + 4] = _y * numVertsAround + _x2 + 1;
	      indices[_index + 5] = (_y + 1) * numVertsAround + _x2 + 1;
	    }
	  }
	
	  return {
	    positions: positions,
	    indices: indices,
	    normals: normals,
	    texCoords: texCoords
	  };
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9nZW9tZXRyeS9zcGhlcmUtZ2VvbWV0cnkuanMiXSwibmFtZXMiOlsiU3BoZXJlR2VvbWV0cnkiLCJvcHRzIiwibmxhdCIsIm5sb25nIiwicmFkaXVzIiwiaWQiLCJPYmplY3QiLCJhc3NpZ24iLCJhdHRyaWJ1dGVzIiwiZ2V0U3BoZXJlQXR0cmlidXRlcyIsInN0YXJ0TGF0IiwiZW5kTGF0IiwiTWF0aCIsIlBJIiwibGF0UmFuZ2UiLCJzdGFydExvbmciLCJlbmRMb25nIiwibG9uZ1JhbmdlIiwibnVtVmVydGljZXMiLCJ2YWx1ZSIsIm4xIiwibjIiLCJuMyIsInUiLCJ2IiwicG9zaXRpb25zIiwiRmxvYXQzMkFycmF5Iiwibm9ybWFscyIsInRleENvb3JkcyIsImluZGljZXMiLCJVaW50MTZBcnJheSIsInkiLCJ4IiwiaW5kZXgiLCJpMiIsImkzIiwidGhldGEiLCJwaGkiLCJzaW5UaGV0YSIsInNpbiIsImNvc1RoZXRhIiwiY29zIiwic2luUGhpIiwiY29zUGhpIiwidXgiLCJ1eSIsInV6IiwiciIsIm51bVZlcnRzQXJvdW5kIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFDQTs7Ozs7Ozs7OztJQUVxQkEsYzs7O0FBQ25CLDRCQUF1QjtBQUFBLFFBQVhDLElBQVcsdUVBQUosRUFBSTs7QUFBQTs7QUFBQSxxQkFNakJBLElBTmlCLENBRW5CQyxJQUZtQjtBQUFBLFFBRW5CQSxJQUZtQiw4QkFFWixFQUZZO0FBQUEsc0JBTWpCRCxJQU5pQixDQUduQkUsS0FIbUI7QUFBQSxRQUduQkEsS0FIbUIsK0JBR1gsRUFIVztBQUFBLHVCQU1qQkYsSUFOaUIsQ0FJbkJHLE1BSm1CO0FBQUEsUUFJbkJBLE1BSm1CLGdDQUlWLENBSlU7QUFBQSxtQkFNakJILElBTmlCLENBS25CSSxFQUxtQjtBQUFBLFFBS25CQSxFQUxtQiw0QkFLZCxnQkFBSSxpQkFBSixDQUxjO0FBQUEsMkhBUWZDLE9BQU9DLE1BQVAsQ0FBYyxFQUFkLEVBQWtCTixJQUFsQixFQUF3QixFQUFDSSxNQUFELEVBQUtHLFlBQVlDLG9CQUFvQlAsSUFBcEIsRUFBMEJDLEtBQTFCLEVBQWlDQyxNQUFqQyxDQUFqQixFQUF4QixDQVJlO0FBU3RCOzs7OztBQUdIO0FBQ0E7QUFDQTtBQUNBOzs7a0JBaEJxQkosYztBQWlCckIsU0FBU1MsbUJBQVQsQ0FBNkJQLElBQTdCLEVBQW1DQyxLQUFuQyxFQUEwQ0MsTUFBMUMsRUFBa0Q7QUFDaEQsTUFBTU0sV0FBVyxDQUFqQjtBQUNBLE1BQU1DLFNBQVNDLEtBQUtDLEVBQXBCO0FBQ0EsTUFBTUMsV0FBV0gsU0FBU0QsUUFBMUI7QUFDQSxNQUFNSyxZQUFZLENBQWxCO0FBQ0EsTUFBTUMsVUFBVSxJQUFJSixLQUFLQyxFQUF6QjtBQUNBLE1BQU1JLFlBQVlELFVBQVVELFNBQTVCO0FBQ0EsTUFBTUcsY0FBYyxDQUFDaEIsT0FBTyxDQUFSLEtBQWNDLFFBQVEsQ0FBdEIsQ0FBcEI7O0FBRUEsTUFBSSxPQUFPQyxNQUFQLEtBQWtCLFFBQXRCLEVBQWdDO0FBQUE7QUFDOUIsVUFBTWUsUUFBUWYsTUFBZDtBQUNBQSxlQUFTLGdCQUFDZ0IsRUFBRCxFQUFLQyxFQUFMLEVBQVNDLEVBQVQsRUFBYUMsQ0FBYixFQUFnQkMsQ0FBaEI7QUFBQSxlQUFzQkwsS0FBdEI7QUFBQSxPQUFUO0FBRjhCO0FBRy9COztBQUVELE1BQU1NLFlBQVksSUFBSUMsWUFBSixDQUFpQlIsY0FBYyxDQUEvQixDQUFsQjtBQUNBLE1BQU1TLFVBQVUsSUFBSUQsWUFBSixDQUFpQlIsY0FBYyxDQUEvQixDQUFoQjtBQUNBLE1BQU1VLFlBQVksSUFBSUYsWUFBSixDQUFpQlIsY0FBYyxDQUEvQixDQUFsQjtBQUNBLE1BQU1XLFVBQVUsSUFBSUMsV0FBSixDQUFnQjVCLE9BQU9DLEtBQVAsR0FBZSxDQUEvQixDQUFoQjs7QUFFQTtBQUNBLE9BQUssSUFBSTRCLElBQUksQ0FBYixFQUFnQkEsS0FBSzdCLElBQXJCLEVBQTJCNkIsR0FBM0IsRUFBZ0M7QUFDOUIsU0FBSyxJQUFJQyxJQUFJLENBQWIsRUFBZ0JBLEtBQUs3QixLQUFyQixFQUE0QjZCLEdBQTVCLEVBQWlDOztBQUUvQixVQUFNVCxJQUFJUyxJQUFJN0IsS0FBZDtBQUNBLFVBQU1xQixJQUFJTyxJQUFJN0IsSUFBZDs7QUFFQSxVQUFNK0IsUUFBUUQsSUFBSUQsS0FBSzVCLFFBQVEsQ0FBYixDQUFsQjtBQUNBLFVBQU0rQixLQUFLRCxRQUFRLENBQW5CO0FBQ0EsVUFBTUUsS0FBS0YsUUFBUSxDQUFuQjs7QUFFQSxVQUFNRyxRQUFRbkIsWUFBWU0sQ0FBMUI7QUFDQSxVQUFNYyxNQUFNdkIsV0FBV1UsQ0FBdkI7QUFDQSxVQUFNYyxXQUFXMUIsS0FBSzJCLEdBQUwsQ0FBU0gsS0FBVCxDQUFqQjtBQUNBLFVBQU1JLFdBQVc1QixLQUFLNkIsR0FBTCxDQUFTTCxLQUFULENBQWpCO0FBQ0EsVUFBTU0sU0FBUzlCLEtBQUsyQixHQUFMLENBQVNGLEdBQVQsQ0FBZjtBQUNBLFVBQU1NLFNBQVMvQixLQUFLNkIsR0FBTCxDQUFTSixHQUFULENBQWY7QUFDQSxVQUFNTyxLQUFLSixXQUFXRSxNQUF0QjtBQUNBLFVBQU1HLEtBQUtGLE1BQVg7QUFDQSxVQUFNRyxLQUFLUixXQUFXSSxNQUF0Qjs7QUFFQSxVQUFNSyxJQUFJM0MsT0FBT3dDLEVBQVAsRUFBV0MsRUFBWCxFQUFlQyxFQUFmLEVBQW1CdkIsQ0FBbkIsRUFBc0JDLENBQXRCLENBQVY7O0FBRUFDLGdCQUFVVSxLQUFLLENBQWYsSUFBb0JZLElBQUlILEVBQXhCO0FBQ0FuQixnQkFBVVUsS0FBSyxDQUFmLElBQW9CWSxJQUFJRixFQUF4QjtBQUNBcEIsZ0JBQVVVLEtBQUssQ0FBZixJQUFvQlksSUFBSUQsRUFBeEI7O0FBRUFuQixjQUFRUSxLQUFLLENBQWIsSUFBa0JTLEVBQWxCO0FBQ0FqQixjQUFRUSxLQUFLLENBQWIsSUFBa0JVLEVBQWxCO0FBQ0FsQixjQUFRUSxLQUFLLENBQWIsSUFBa0JXLEVBQWxCOztBQUVBbEIsZ0JBQVVNLEtBQUssQ0FBZixJQUFvQlgsQ0FBcEI7QUFDQUssZ0JBQVVNLEtBQUssQ0FBZixJQUFvQlYsQ0FBcEI7QUFDRDtBQUNGOztBQUVEO0FBQ0EsTUFBTXdCLGlCQUFpQjlDLE9BQU8sQ0FBOUI7QUFDQSxPQUFLLElBQUk4QixNQUFJLENBQWIsRUFBZ0JBLE1BQUk5QixJQUFwQixFQUEwQjhCLEtBQTFCLEVBQStCO0FBQzdCLFNBQUssSUFBSUQsS0FBSSxDQUFiLEVBQWdCQSxLQUFJNUIsS0FBcEIsRUFBMkI0QixJQUEzQixFQUFnQztBQUM5QixVQUFNRSxTQUFRLENBQUNELE1BQUk3QixLQUFKLEdBQVk0QixFQUFiLElBQWtCLENBQWhDOztBQUVBRixjQUFRSSxTQUFRLENBQWhCLElBQXFCRixLQUFJaUIsY0FBSixHQUFxQmhCLEdBQTFDO0FBQ0FILGNBQVFJLFNBQVEsQ0FBaEIsSUFBcUJGLEtBQUlpQixjQUFKLEdBQXFCaEIsR0FBckIsR0FBeUIsQ0FBOUM7QUFDQUgsY0FBUUksU0FBUSxDQUFoQixJQUFxQixDQUFDRixLQUFJLENBQUwsSUFBVWlCLGNBQVYsR0FBMkJoQixHQUFoRDs7QUFFQUgsY0FBUUksU0FBUSxDQUFoQixJQUFxQixDQUFDRixLQUFJLENBQUwsSUFBVWlCLGNBQVYsR0FBMkJoQixHQUFoRDtBQUNBSCxjQUFRSSxTQUFRLENBQWhCLElBQXFCRixLQUFJaUIsY0FBSixHQUFxQmhCLEdBQXJCLEdBQXlCLENBQTlDO0FBQ0FILGNBQVFJLFNBQVEsQ0FBaEIsSUFBcUIsQ0FBQ0YsS0FBSSxDQUFMLElBQVVpQixjQUFWLEdBQTJCaEIsR0FBM0IsR0FBK0IsQ0FBcEQ7QUFDRDtBQUNGOztBQUVELFNBQU87QUFDTFAsd0JBREs7QUFFTEksb0JBRks7QUFHTEYsb0JBSEs7QUFJTEM7QUFKSyxHQUFQO0FBTUQiLCJmaWxlIjoic3BoZXJlLWdlb21ldHJ5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IEdlb21ldHJ5IGZyb20gJy4vZ2VvbWV0cnknO1xuaW1wb3J0IHt1aWR9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgU3BoZXJlR2VvbWV0cnkgZXh0ZW5kcyBHZW9tZXRyeSB7XG4gIGNvbnN0cnVjdG9yKG9wdHMgPSB7fSkge1xuICAgIGNvbnN0IHtcbiAgICAgIG5sYXQgPSAxMCxcbiAgICAgIG5sb25nID0gMTAsXG4gICAgICByYWRpdXMgPSAxLFxuICAgICAgaWQgPSB1aWQoJ3NwaGVyZS1nZW9tZXRyeScpXG4gICAgfSA9IG9wdHM7XG5cbiAgICBzdXBlcihPYmplY3QuYXNzaWduKHt9LCBvcHRzLCB7aWQsIGF0dHJpYnV0ZXM6IGdldFNwaGVyZUF0dHJpYnV0ZXMobmxhdCwgbmxvbmcsIHJhZGl1cyl9KSk7XG4gIH1cbn1cblxuLy8gUHJpbWl0aXZlcyBpbnNwaXJlZCBieSBUREwgaHR0cDovL2NvZGUuZ29vZ2xlLmNvbS9wL3dlYmdsc2FtcGxlcy8sXG4vLyBjb3B5cmlnaHQgMjAxMSBHb29nbGUgSW5jLiBuZXcgQlNEIExpY2Vuc2Vcbi8vIChodHRwOi8vd3d3Lm9wZW5zb3VyY2Uub3JnL2xpY2Vuc2VzL2JzZC1saWNlbnNlLnBocCkuXG4vKiBlc2xpbnQtZGlzYWJsZSBtYXgtc3RhdGVtZW50cywgY29tcGxleGl0eSAqL1xuZnVuY3Rpb24gZ2V0U3BoZXJlQXR0cmlidXRlcyhubGF0LCBubG9uZywgcmFkaXVzKSB7XG4gIGNvbnN0IHN0YXJ0TGF0ID0gMDtcbiAgY29uc3QgZW5kTGF0ID0gTWF0aC5QSTtcbiAgY29uc3QgbGF0UmFuZ2UgPSBlbmRMYXQgLSBzdGFydExhdDtcbiAgY29uc3Qgc3RhcnRMb25nID0gMDtcbiAgY29uc3QgZW5kTG9uZyA9IDIgKiBNYXRoLlBJO1xuICBjb25zdCBsb25nUmFuZ2UgPSBlbmRMb25nIC0gc3RhcnRMb25nO1xuICBjb25zdCBudW1WZXJ0aWNlcyA9IChubGF0ICsgMSkgKiAobmxvbmcgKyAxKTtcblxuICBpZiAodHlwZW9mIHJhZGl1cyA9PT0gJ251bWJlcicpIHtcbiAgICBjb25zdCB2YWx1ZSA9IHJhZGl1cztcbiAgICByYWRpdXMgPSAobjEsIG4yLCBuMywgdSwgdikgPT4gdmFsdWU7XG4gIH1cblxuICBjb25zdCBwb3NpdGlvbnMgPSBuZXcgRmxvYXQzMkFycmF5KG51bVZlcnRpY2VzICogMyk7XG4gIGNvbnN0IG5vcm1hbHMgPSBuZXcgRmxvYXQzMkFycmF5KG51bVZlcnRpY2VzICogMyk7XG4gIGNvbnN0IHRleENvb3JkcyA9IG5ldyBGbG9hdDMyQXJyYXkobnVtVmVydGljZXMgKiAyKTtcbiAgY29uc3QgaW5kaWNlcyA9IG5ldyBVaW50MTZBcnJheShubGF0ICogbmxvbmcgKiA2KTtcblxuICAvLyBDcmVhdGUgcG9zaXRpb25zLCBub3JtYWxzIGFuZCB0ZXhDb29yZHNcbiAgZm9yIChsZXQgeSA9IDA7IHkgPD0gbmxhdDsgeSsrKSB7XG4gICAgZm9yIChsZXQgeCA9IDA7IHggPD0gbmxvbmc7IHgrKykge1xuXG4gICAgICBjb25zdCB1ID0geCAvIG5sb25nO1xuICAgICAgY29uc3QgdiA9IHkgLyBubGF0O1xuXG4gICAgICBjb25zdCBpbmRleCA9IHggKyB5ICogKG5sb25nICsgMSk7XG4gICAgICBjb25zdCBpMiA9IGluZGV4ICogMjtcbiAgICAgIGNvbnN0IGkzID0gaW5kZXggKiAzO1xuXG4gICAgICBjb25zdCB0aGV0YSA9IGxvbmdSYW5nZSAqIHU7XG4gICAgICBjb25zdCBwaGkgPSBsYXRSYW5nZSAqIHY7XG4gICAgICBjb25zdCBzaW5UaGV0YSA9IE1hdGguc2luKHRoZXRhKTtcbiAgICAgIGNvbnN0IGNvc1RoZXRhID0gTWF0aC5jb3ModGhldGEpO1xuICAgICAgY29uc3Qgc2luUGhpID0gTWF0aC5zaW4ocGhpKTtcbiAgICAgIGNvbnN0IGNvc1BoaSA9IE1hdGguY29zKHBoaSk7XG4gICAgICBjb25zdCB1eCA9IGNvc1RoZXRhICogc2luUGhpO1xuICAgICAgY29uc3QgdXkgPSBjb3NQaGk7XG4gICAgICBjb25zdCB1eiA9IHNpblRoZXRhICogc2luUGhpO1xuXG4gICAgICBjb25zdCByID0gcmFkaXVzKHV4LCB1eSwgdXosIHUsIHYpO1xuXG4gICAgICBwb3NpdGlvbnNbaTMgKyAwXSA9IHIgKiB1eDtcbiAgICAgIHBvc2l0aW9uc1tpMyArIDFdID0gciAqIHV5O1xuICAgICAgcG9zaXRpb25zW2kzICsgMl0gPSByICogdXo7XG5cbiAgICAgIG5vcm1hbHNbaTMgKyAwXSA9IHV4O1xuICAgICAgbm9ybWFsc1tpMyArIDFdID0gdXk7XG4gICAgICBub3JtYWxzW2kzICsgMl0gPSB1ejtcblxuICAgICAgdGV4Q29vcmRzW2kyICsgMF0gPSB1O1xuICAgICAgdGV4Q29vcmRzW2kyICsgMV0gPSB2O1xuICAgIH1cbiAgfVxuXG4gIC8vIENyZWF0ZSBpbmRpY2VzXG4gIGNvbnN0IG51bVZlcnRzQXJvdW5kID0gbmxhdCArIDE7XG4gIGZvciAobGV0IHggPSAwOyB4IDwgbmxhdDsgeCsrKSB7XG4gICAgZm9yIChsZXQgeSA9IDA7IHkgPCBubG9uZzsgeSsrKSB7XG4gICAgICBjb25zdCBpbmRleCA9ICh4ICogbmxvbmcgKyB5KSAqIDY7XG5cbiAgICAgIGluZGljZXNbaW5kZXggKyAwXSA9IHkgKiBudW1WZXJ0c0Fyb3VuZCArIHg7XG4gICAgICBpbmRpY2VzW2luZGV4ICsgMV0gPSB5ICogbnVtVmVydHNBcm91bmQgKyB4ICsgMTtcbiAgICAgIGluZGljZXNbaW5kZXggKyAyXSA9ICh5ICsgMSkgKiBudW1WZXJ0c0Fyb3VuZCArIHg7XG5cbiAgICAgIGluZGljZXNbaW5kZXggKyAzXSA9ICh5ICsgMSkgKiBudW1WZXJ0c0Fyb3VuZCArIHg7XG4gICAgICBpbmRpY2VzW2luZGV4ICsgNF0gPSB5ICogbnVtVmVydHNBcm91bmQgKyB4ICsgMTtcbiAgICAgIGluZGljZXNbaW5kZXggKyA1XSA9ICh5ICsgMSkgKiBudW1WZXJ0c0Fyb3VuZCArIHggKyAxO1xuICAgIH1cbiAgfVxuXG4gIHJldHVybiB7XG4gICAgcG9zaXRpb25zLFxuICAgIGluZGljZXMsXG4gICAgbm9ybWFscyxcbiAgICB0ZXhDb29yZHNcbiAgfTtcbn1cbiJdfQ==

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.global = undefined;
	
	var _isBrowser = __webpack_require__(299);
	
	var _globals = __webpack_require__(479);
	
	var _log = __webpack_require__(480);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _package = __webpack_require__(885);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STARTUP_MESSAGE = 'Assign luma.log.priority in console to control logging: 0: none, 1: minimal, 2: verbose, 3: attribute/uniforms, 4: gl logs\nluma.log.break[], set to gl funcs, luma.log.profile[] set to model names';
	// Version detection
	// TODO - this imports a rather large JSON file, we only need one field
	
	
	if (_globals.global.luma && _globals.global.luma.VERSION !== _package.version) {
	  throw new Error('luma.gl - multiple versions detected: ' + _globals.global.luma.VERSION + ' vs ' + _package.version);
	}
	
	if (!_globals.global.luma) {
	  /* global console */
	  /* eslint-disable no-console */
	  if (_isBrowser.isBrowser) {
	    console.log('luma.gl ' + _package.version + ' - ' + STARTUP_MESSAGE);
	  }
	
	  _globals.global.luma = _globals.global.luma || {
	    VERSION: _package.version,
	    version: _package.version,
	    log: _log2.default,
	
	    // Keep some luma globals in a sub-object
	    // This allows us to dynamically detect if certain modules have been
	    // included (such as IO and headless) and enable related functionality,
	    // without unconditionally requiring and thus bundling big dependencies
	    // into the app.
	    globals: {
	      headlessGL: null,
	      headlessTypes: null,
	      modules: {},
	      nodeIO: {}
	    }
	  };
	}
	
	exports.global = _globals.global;
	exports.default = _globals.global.luma;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadFile = loadFile;
	exports.loadImage = loadImage;
	
	var _browserRequestFile = __webpack_require__(1051);
	
	function loadFile(opts) {
	  return (0, _browserRequestFile.requestFile)(opts);
	}
	
	/* global Image */
	
	/*
	 * Loads images asynchronously
	 * image.crossOrigin can be set via opts.crossOrigin, default to 'anonymous'
	 * returns a promise tracking the load
	 */
	function loadImage(url) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    crossOrigin: 'anonymous'
	  };
	
	  return new Promise(function (resolve, reject) {
	    try {
	      (function () {
	        var image = new Image();
	        image.onload = function () {
	          return resolve(image);
	        };
	        image.onerror = function () {
	          return reject(new Error('Could not load image ' + url + '.'));
	        };
	        image.crossOrigin = opts.crossOrigin;
	        image.src = url;
	      })();
	    } catch (error) {
	      reject(error);
	    }
	  });
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(85);
	
	Object.keys(_common).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _common[key];
	    }
	  });
	});
	
	var _vector = __webpack_require__(297);
	
	Object.defineProperty(exports, 'Vector2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vector).default;
	  }
	});
	
	var _vector2 = __webpack_require__(214);
	
	Object.defineProperty(exports, 'Vector3', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vector2).default;
	  }
	});
	
	var _vector3 = __webpack_require__(298);
	
	Object.defineProperty(exports, 'Vector4', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vector3).default;
	  }
	});
	
	var _matrix = __webpack_require__(295);
	
	Object.defineProperty(exports, 'Matrix4', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_matrix).default;
	  }
	});
	
	var _quaternion = __webpack_require__(296);
	
	Object.defineProperty(exports, 'Quaternion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quaternion).default;
	  }
	});
	
	var _euler = __webpack_require__(478);
	
	Object.defineProperty(exports, 'Euler', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_euler).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wYWNrYWdlcy9tYXRoL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOzs7Ozs7OzJDQUNRQSxPOzs7Ozs7Ozs7NENBQ0FBLE87Ozs7Ozs7Ozs0Q0FDQUEsTzs7Ozs7Ozs7OzJDQUNBQSxPOzs7Ozs7Ozs7K0NBQ0FBLE87Ozs7Ozs7OzswQ0FDQUEsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vc3JjL2NvbW1vbic7XG5leHBvcnQge2RlZmF1bHQgYXMgVmVjdG9yMn0gZnJvbSAnLi9zcmMvdmVjdG9yMic7XG5leHBvcnQge2RlZmF1bHQgYXMgVmVjdG9yM30gZnJvbSAnLi9zcmMvdmVjdG9yMyc7XG5leHBvcnQge2RlZmF1bHQgYXMgVmVjdG9yNH0gZnJvbSAnLi9zcmMvdmVjdG9yNCc7XG5leHBvcnQge2RlZmF1bHQgYXMgTWF0cml4NH0gZnJvbSAnLi9zcmMvbWF0cml4NCc7XG5leHBvcnQge2RlZmF1bHQgYXMgUXVhdGVybmlvbn0gZnJvbSAnLi9zcmMvcXVhdGVybmlvbic7XG5leHBvcnQge2RlZmF1bHQgYXMgRXVsZXJ9IGZyb20gJy4vc3JjL2V1bGVyJztcbiJdfQ==

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mathArray = __webpack_require__(130);
	
	var _mathArray2 = _interopRequireDefault(_mathArray);
	
	var _common = __webpack_require__(85);
	
	var _matrix = __webpack_require__(295);
	
	var _quaternion = __webpack_require__(296);
	
	var _vector = __webpack_require__(214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Internal constants
	var ERR_UNKNOWN_ORDER = 'Unknown Euler angle order';
	var ALMOST_ONE = 0.99999;
	
	function validateOrder(value) {
	  return value >= 0 && value < 6;
	}
	
	function checkOrder(value) {
	  if (value < 0 && value >= 6) {
	    throw new Error(ERR_UNKNOWN_ORDER);
	  }
	  return value;
	}
	
	var Euler = function (_MathArray) {
	  _inherits(Euler, _MathArray);
	
	  _createClass(Euler, [{
	    key: 'ELEMENTS',
	    get: function get() {
	      return 4;
	    }
	    /* eslint-enable no-multi-spaces, brace-style, no-return-assign */
	
	    /*
	     * Number|Number[], Number, Number, Number
	     */
	
	  }], [{
	    key: 'rotationOrder',
	    value: function rotationOrder(order) {
	      return Euler.RotationOrders[order];
	    }
	  }, {
	    key: 'ZYX',
	
	
	    // Constants
	    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
	    get: function get() {
	      return 0;
	    }
	  }, {
	    key: 'YXZ',
	    get: function get() {
	      return 1;
	    }
	  }, {
	    key: 'XZY',
	    get: function get() {
	      return 2;
	    }
	  }, {
	    key: 'ZXY',
	    get: function get() {
	      return 3;
	    }
	  }, {
	    key: 'YZX',
	    get: function get() {
	      return 4;
	    }
	  }, {
	    key: 'XYZ',
	    get: function get() {
	      return 5;
	    }
	  }, {
	    key: 'RollPitchYaw',
	    get: function get() {
	      return 0;
	    }
	  }, {
	    key: 'DefaultOrder',
	    get: function get() {
	      return Euler.ZYX;
	    }
	  }, {
	    key: 'RotationOrders',
	    get: function get() {
	      return ['ZYX', 'YXZ', 'XZY', 'ZXY', 'YZX', 'XYZ'];
	    }
	  }]);
	
	  function Euler() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Euler.DefaultOrder;
	
	    _classCallCheck(this, Euler);
	
	    var _this = _possibleConstructorReturn(this, (Euler.__proto__ || Object.getPrototypeOf(Euler)).call(this));
	
	    if (arguments.length > 0 && Array.isArray(arguments[0])) {
	      _this.fromVector3.apply(_this, arguments);
	    } else {
	      _this.set(x, y, z, order);
	    }
	    return _this;
	  }
	
	  // If copied array does contain fourth element, preserves currently set order
	
	
	  _createClass(Euler, [{
	    key: 'copy',
	    value: function copy(array) {
	      for (var i = 0; i < 3; ++i) {
	        this[i] = array[i];
	      }
	      this[3] = Number.isFinite(array[3]) || this.order;
	      this.check();
	      return this;
	    }
	
	    // Sets the three angles, and optionally sets the rotation order
	    // If order is not specified, preserves currently set order
	
	  }, {
	    key: 'set',
	    value: function set() {
	      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var order = arguments[3];
	
	      this[0] = x;
	      this[1] = y;
	      this[2] = z;
	      this[3] = Number.isFinite(order) ? order : this[3];
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'validate',
	    value: function validate() {
	      return validateOrder(this[3]) && Number.isFinite(this[0]) && Number.isFinite(this[1]) && Number.isFinite(this[2]);
	    }
	
	    // Does not copy the orientation element
	
	  }, {
	    key: 'toArray',
	    value: function toArray() {
	      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      array[offset] = this[0];
	      array[offset + 1] = this[1];
	      array[offset + 2] = this[2];
	      return array;
	    }
	
	    // Copies the orientation element
	
	  }, {
	    key: 'toArray4',
	    value: function toArray4() {
	      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      array[offset] = this[0];
	      array[offset + 1] = this[1];
	      array[offset + 2] = this[2];
	      array[offset + 3] = this[3];
	      return array;
	    }
	  }, {
	    key: 'toVector3',
	    value: function toVector3(optionalResult) {
	      if (optionalResult) {
	        return optionalResult.set(this[0], this[1], this[2]);
	      }
	      return new _vector.Vector3(this[0], this[1], this[2]);
	    }
	
	    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
	    // x, y, z angle notation (note: only corresponds to axis in XYZ orientation)
	
	  }, {
	    key: 'fromVector3',
	
	    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
	
	    // Constructors
	    value: function fromVector3(v, order) {
	      return this.set(v[0], v[1], v[2], Number.isFinite(order) ? order : this[3]);
	    }
	
	    // TODO - with and without 4th element
	
	  }, {
	    key: 'fromArray',
	    value: function fromArray(array) {
	      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      this[0] = array[0 + offset];
	      this[1] = array[1 + offset];
	      this[2] = array[2 + offset];
	      if (array[3] !== undefined) {
	        this[3] = array[3];
	      }
	      this.check();
	      return this;
	    }
	
	    // Common ZYX rotation order
	
	  }, {
	    key: 'fromRollPitchYaw',
	    value: function fromRollPitchYaw(roll, pitch, yaw) {
	      return this.set(roll, pitch, yaw, Euler.ZYX);
	    }
	  }, {
	    key: 'fromQuaternion',
	    value: function fromQuaternion(q, order) {
	      this._fromRotationMatrix(_matrix.Matrix4.fromQuaternion(q), order);
	      this.check();
	      return this;
	    }
	  }, {
	    key: 'fromRotationMatrix',
	    value: function fromRotationMatrix(m) {
	      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Euler.DefaultOrder;
	
	      this._fromRotationMatrix(m, order);
	      this.check();
	      return this;
	    }
	
	    // ACCESSORS
	
	    // @return {Matrix4} a rotation matrix corresponding to rotations
	    //   per the specified euler angles
	
	  }, {
	    key: 'getRotationMatrix',
	    value: function getRotationMatrix() {
	      var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _matrix.Matrix4();
	
	      this._getRotationMatrix(m);
	      return m;
	    }
	  }, {
	    key: 'getQuaternion',
	    value: function getQuaternion() {
	      var q = new _quaternion.Quaternion();
	      switch (this[4]) {
	        case Euler.XYZ:
	          return q.rotateX(this[0]).rotateY(this[1]).rotateZ(this[2]);
	        case Euler.YXZ:
	          return q.rotateY(this[0]).rotateX(this[1]).rotateZ(this[2]);
	        case Euler.ZXY:
	          return q.rotateZ(this[0]).rotateX(this[1]).rotateY(this[2]);
	        case Euler.ZYX:
	          return q.rotateZ(this[0]).rotateY(this[1]).rotateX(this[2]);
	        case Euler.YZX:
	          return q.rotateY(this[0]).rotateZ(this[1]).rotateX(this[2]);
	        case Euler.XZY:
	          return q.rotateX(this[0]).rotateZ(this[1]).rotateY(this[2]);
	        default:
	          throw new Error(ERR_UNKNOWN_ORDER);
	      }
	    }
	
	    // INTERNAL METHODS
	
	    // Concersion from Euler to rotation matrix and from matrix to Euler
	    // Adapted from three.js under MIT license
	
	    // // WARNING: this discards revolution information -bhouston
	    // reorder(newOrder) {
	    //   const q = new Quaternion().setFromEuler(this);
	    //   return this.setFromQuaternion(q, newOrder);
	
	    /* eslint-disable complexity, max-statements, one-var */
	
	  }, {
	    key: '_fromRotationMatrix',
	    value: function _fromRotationMatrix(m) {
	      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Euler.DefaultOrder;
	
	      // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
	      var te = m.elements;
	      var m11 = te[0],
	          m12 = te[4],
	          m13 = te[8];
	      var m21 = te[1],
	          m22 = te[5],
	          m23 = te[9];
	      var m31 = te[2],
	          m32 = te[6],
	          m33 = te[10];
	
	      order = order || this[3];
	
	      switch (order) {
	        case Euler.XYZ:
	          this[1] = Math.asin((0, _common.clamp)(m13, -1, 1));
	
	          if (Math.abs(m13) < ALMOST_ONE) {
	            this[0] = Math.atan2(-m23, m33);
	            this[2] = Math.atan2(-m12, m11);
	          } else {
	            this[0] = Math.atan2(m32, m22);
	            this[2] = 0;
	          }
	          break;
	
	        case Euler.YXZ:
	          this[0] = Math.asin(-(0, _common.clamp)(m23, -1, 1));
	
	          if (Math.abs(m23) < ALMOST_ONE) {
	            this[1] = Math.atan2(m13, m33);
	            this[2] = Math.atan2(m21, m22);
	          } else {
	            this[1] = Math.atan2(-m31, m11);
	            this[2] = 0;
	          }
	          break;
	
	        case Euler.ZXY:
	          this[0] = Math.asin((0, _common.clamp)(m32, -1, 1));
	
	          if (Math.abs(m32) < ALMOST_ONE) {
	            this[1] = Math.atan2(-m31, m33);
	            this[2] = Math.atan2(-m12, m22);
	          } else {
	            this[1] = 0;
	            this[2] = Math.atan2(m21, m11);
	          }
	          break;
	
	        case Euler.ZYX:
	          this[1] = Math.asin(-(0, _common.clamp)(m31, -1, 1));
	
	          if (Math.abs(m31) < ALMOST_ONE) {
	            this[0] = Math.atan2(m32, m33);
	            this[2] = Math.atan2(m21, m11);
	          } else {
	            this[0] = 0;
	            this[2] = Math.atan2(-m12, m22);
	          }
	          break;
	
	        case Euler.YZX:
	          this[2] = Math.asin((0, _common.clamp)(m21, -1, 1));
	
	          if (Math.abs(m21) < ALMOST_ONE) {
	            this[0] = Math.atan2(-m23, m22);
	            this[1] = Math.atan2(-m31, m11);
	          } else {
	            this[0] = 0;
	            this[1] = Math.atan2(m13, m33);
	          }
	          break;
	
	        case Euler.XZY:
	          this[2] = Math.asin(-(0, _common.clamp)(m12, -1, 1));
	
	          if (Math.abs(m12) < ALMOST_ONE) {
	            this[0] = Math.atan2(m32, m22);
	            this[1] = Math.atan2(m13, m11);
	          } else {
	            this[0] = Math.atan2(-m23, m33);
	            this[1] = 0;
	          }
	          break;
	
	        default:
	          throw new Error(ERR_UNKNOWN_ORDER);
	      }
	
	      this[3] = order;
	
	      return this;
	    }
	  }, {
	    key: '_getRotationMatrix',
	    value: function _getRotationMatrix() {
	      var te = new _matrix.Matrix4();
	
	      var x = this.x,
	          y = this.y,
	          z = this.z;
	      var a = Math.cos(x);
	      var c = Math.cos(y);
	      var e = Math.cos(z);
	      var b = Math.sin(x);
	      var d = Math.sin(y);
	      var f = Math.sin(z);
	
	      switch (this[3]) {
	        case Euler.XYZ:
	          {
	            var ae = a * e,
	                af = a * f,
	                be = b * e,
	                bf = b * f;
	
	            te[0] = c * e;
	            te[4] = -c * f;
	            te[8] = d;
	
	            te[1] = af + be * d;
	            te[5] = ae - bf * d;
	            te[9] = -b * c;
	
	            te[2] = bf - ae * d;
	            te[6] = be + af * d;
	            te[10] = a * c;
	            break;
	          }
	
	        case Euler.YXZ:
	          {
	            var ce = c * e,
	                cf = c * f,
	                de = d * e,
	                df = d * f;
	
	            te[0] = ce + df * b;
	            te[4] = de * b - cf;
	            te[8] = a * d;
	
	            te[1] = a * f;
	            te[5] = a * e;
	            te[9] = -b;
	
	            te[2] = cf * b - de;
	            te[6] = df + ce * b;
	            te[10] = a * c;
	            break;
	          }
	
	        case Euler.ZXY:
	          {
	            var _ce = c * e,
	                _cf = c * f,
	                _de = d * e,
	                _df = d * f;
	
	            te[0] = _ce - _df * b;
	            te[4] = -a * f;
	            te[8] = _de + _cf * b;
	
	            te[1] = _cf + _de * b;
	            te[5] = a * e;
	            te[9] = _df - _ce * b;
	
	            te[2] = -a * d;
	            te[6] = b;
	            te[10] = a * c;
	            break;
	          }
	
	        case Euler.ZYX:
	          {
	            var _ae = a * e,
	                _af = a * f,
	                _be = b * e,
	                _bf = b * f;
	
	            te[0] = c * e;
	            te[4] = _be * d - _af;
	            te[8] = _ae * d + _bf;
	
	            te[1] = c * f;
	            te[5] = _bf * d + _ae;
	            te[9] = _af * d - _be;
	
	            te[2] = -d;
	            te[6] = b * c;
	            te[10] = a * c;
	            break;
	          }
	
	        case Euler.YZX:
	          {
	            var ac = a * c,
	                ad = a * d,
	                bc = b * c,
	                bd = b * d;
	
	            te[0] = c * e;
	            te[4] = bd - ac * f;
	            te[8] = bc * f + ad;
	
	            te[1] = f;
	            te[5] = a * e;
	            te[9] = -b * e;
	
	            te[2] = -d * e;
	            te[6] = ad * f + bc;
	            te[10] = ac - bd * f;
	            break;
	          }
	
	        case Euler.XZY:
	          {
	            var _ac = a * c,
	                _ad = a * d,
	                _bc = b * c,
	                _bd = b * d;
	
	            te[0] = c * e;
	            te[4] = -f;
	            te[8] = d * e;
	
	            te[1] = _ac * f + _bd;
	            te[5] = a * e;
	            te[9] = _ad * f - _bc;
	
	            te[2] = _bc * f - _ad;
	            te[6] = b * e;
	            te[10] = _bd * f + _ac;
	            break;
	          }
	
	        default:
	          throw new Error(ERR_UNKNOWN_ORDER);
	      }
	
	      // last column
	      te[3] = 0;
	      te[7] = 0;
	      te[11] = 0;
	
	      // bottom row
	      te[12] = 0;
	      te[13] = 0;
	      te[14] = 0;
	      te[15] = 1;
	
	      return this;
	    }
	    /* eslint-enable complexity, max-statements, one-var */
	
	  }, {
	    key: 'x',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(value) {
	      return this[0] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(value) {
	      return this[1] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'z',
	    get: function get() {
	      return this[2];
	    },
	    set: function set(value) {
	      return this[2] = (0, _common.checkNumber)(value);
	    }
	
	    // alpha, beta, gamma angle notation
	
	  }, {
	    key: 'alpha',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(value) {
	      return this[0] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'beta',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(value) {
	      return this[1] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'gamma',
	    get: function get() {
	      return this[2];
	    },
	    set: function set(value) {
	      return this[2] = (0, _common.checkNumber)(value);
	    }
	
	    // phi, theta, psi angle notation
	
	  }, {
	    key: 'phi',
	    get: function get() {
	      return this[0];
	    },
	    set: function set(value) {
	      return this[0] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'theta',
	    get: function get() {
	      return this[1];
	    },
	    set: function set(value) {
	      return this[1] = (0, _common.checkNumber)(value);
	    }
	  }, {
	    key: 'psi',
	    get: function get() {
	      return this[2];
	    },
	    set: function set(value) {
	      return this[2] = (0, _common.checkNumber)(value);
	    }
	
	    // rotation order, in all three angle notations
	
	  }, {
	    key: 'order',
	    get: function get() {
	      return this[3];
	    },
	    set: function set(value) {
	      return this[3] = checkOrder(value);
	    }
	  }]);
	
	  return Euler;
	}(_mathArray2.default);
	
	exports.default = Euler;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 479 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	/* global window, global, document */
	module.exports = {
	  window: typeof window !== 'undefined' ? window : global,
	  global: typeof global !== 'undefined' ? global : window,
	  document: typeof document !== 'undefined' ? document : {}
	};
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9nbG9iYWxzLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJ3aW5kb3ciLCJnbG9iYWwiLCJkb2N1bWVudCJdLCJtYXBwaW5ncyI6Ijs7QUFBQTtBQUNBQSxPQUFPQyxPQUFQLEdBQWlCO0FBQ2ZDLFVBQVEsT0FBT0EsTUFBUCxLQUFrQixXQUFsQixHQUFnQ0EsTUFBaEMsR0FBeUNDLE1BRGxDO0FBRWZBLFVBQVEsT0FBT0EsTUFBUCxLQUFrQixXQUFsQixHQUFnQ0EsTUFBaEMsR0FBeUNELE1BRmxDO0FBR2ZFLFlBQVUsT0FBT0EsUUFBUCxLQUFvQixXQUFwQixHQUFrQ0EsUUFBbEMsR0FBNkM7QUFIeEMsQ0FBakIiLCJmaWxlIjoiZ2xvYmFscy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGdsb2JhbCB3aW5kb3csIGdsb2JhbCwgZG9jdW1lbnQgKi9cbm1vZHVsZS5leHBvcnRzID0ge1xuICB3aW5kb3c6IHR5cGVvZiB3aW5kb3cgIT09ICd1bmRlZmluZWQnID8gd2luZG93IDogZ2xvYmFsLFxuICBnbG9iYWw6IHR5cGVvZiBnbG9iYWwgIT09ICd1bmRlZmluZWQnID8gZ2xvYmFsIDogd2luZG93LFxuICBkb2N1bWVudDogdHlwZW9mIGRvY3VtZW50ICE9PSAndW5kZWZpbmVkJyA/IGRvY3VtZW50IDoge31cbn07XG4iXX0=
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 480 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatValue = formatValue;
	/* eslint-disable no-console */
	/* global console */
	var cache = {};
	
	var _log = {
	  priority: 0,
	  table: function table(priority, _table) {
	    if (priority <= _log.priority && _table) {
	      console.table(_table);
	    }
	  },
	  log: function log(priority) {
	    if (priority <= _log.priority) {
	      var _console;
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      (_console = console).debug.apply(_console, args);
	    }
	  },
	  info: function info(priority) {
	    if (priority <= _log.priority) {
	      var _console2;
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      (_console2 = console).log.apply(_console2, args);
	    }
	  },
	  warn: function warn(priority) {
	    if (priority <= _log.priority) {
	      var _console3;
	
	      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        args[_key3 - 1] = arguments[_key3];
	      }
	
	      (_console3 = console).warn.apply(_console3, args);
	    }
	  },
	  once: function once(priority, arg) {
	    if (!cache[arg]) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	        args[_key4 - 2] = arguments[_key4];
	      }
	
	      _log.log.apply(_log, [priority, arg].concat(args));
	    }
	    cache[arg] = true;
	  }
	};
	
	function formatArrayValue(v, opts) {
	  var _opts$maxElts = opts.maxElts,
	      maxElts = _opts$maxElts === undefined ? 16 : _opts$maxElts,
	      _opts$size = opts.size,
	      size = _opts$size === undefined ? 1 : _opts$size;
	
	  var string = '[';
	  for (var i = 0; i < v.length && i < maxElts; ++i) {
	    if (i > 0) {
	      string += ',' + (i % size === 0 ? ' ' : '');
	    }
	    string += formatValue(v[i], opts);
	  }
	  var terminator = v.length > maxElts ? '...' : ']';
	  return '' + string + terminator;
	}
	
	function formatValue(v) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _opts$isInteger = opts.isInteger,
	      isInteger = _opts$isInteger === undefined ? false : _opts$isInteger;
	
	  if (Array.isArray(v) || ArrayBuffer.isView(v)) {
	    return formatArrayValue(v, opts);
	  }
	  if (!Number.isFinite(v)) {
	    return String(v);
	  }
	  if (isInteger) {
	    return v.toFixed(0);
	  }
	  if (Math.abs(v) > 100 && Math.abs(v) < 10000) {
	    return v.toFixed(0);
	  }
	  var string = v.toPrecision(2);
	  var decimal = string.indexOf('.0');
	  return decimal === string.length - 2 ? string.slice(0, -1) : string;
	}
	
	exports.default = _log;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9sb2cuanMiXSwibmFtZXMiOlsiZm9ybWF0VmFsdWUiLCJjYWNoZSIsImxvZyIsInByaW9yaXR5IiwidGFibGUiLCJjb25zb2xlIiwiYXJncyIsImRlYnVnIiwiaW5mbyIsIndhcm4iLCJvbmNlIiwiYXJnIiwiZm9ybWF0QXJyYXlWYWx1ZSIsInYiLCJvcHRzIiwibWF4RWx0cyIsInNpemUiLCJzdHJpbmciLCJpIiwibGVuZ3RoIiwidGVybWluYXRvciIsImlzSW50ZWdlciIsIkFycmF5IiwiaXNBcnJheSIsIkFycmF5QnVmZmVyIiwiaXNWaWV3IiwiTnVtYmVyIiwiaXNGaW5pdGUiLCJTdHJpbmciLCJ0b0ZpeGVkIiwiTWF0aCIsImFicyIsInRvUHJlY2lzaW9uIiwiZGVjaW1hbCIsImluZGV4T2YiLCJzbGljZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7UUErQ2dCQSxXLEdBQUFBLFc7QUEvQ2hCO0FBQ0E7QUFDQSxJQUFNQyxRQUFRLEVBQWQ7O0FBRUEsSUFBTUMsT0FBTTtBQUNWQyxZQUFVLENBREE7QUFFVkMsT0FGVSxpQkFFSkQsUUFGSSxFQUVNQyxNQUZOLEVBRWE7QUFDckIsUUFBSUQsWUFBWUQsS0FBSUMsUUFBaEIsSUFBNEJDLE1BQWhDLEVBQXVDO0FBQ3JDQyxjQUFRRCxLQUFSLENBQWNBLE1BQWQ7QUFDRDtBQUNGLEdBTlM7QUFPVkYsS0FQVSxlQU9OQyxRQVBNLEVBT2E7QUFDckIsUUFBSUEsWUFBWUQsS0FBSUMsUUFBcEIsRUFBOEI7QUFBQTs7QUFBQSx3Q0FEZkcsSUFDZTtBQURmQSxZQUNlO0FBQUE7O0FBQzVCLDJCQUFRQyxLQUFSLGlCQUFpQkQsSUFBakI7QUFDRDtBQUNGLEdBWFM7QUFZVkUsTUFaVSxnQkFZTEwsUUFaSyxFQVljO0FBQ3RCLFFBQUlBLFlBQVlELEtBQUlDLFFBQXBCLEVBQThCO0FBQUE7O0FBQUEseUNBRGRHLElBQ2M7QUFEZEEsWUFDYztBQUFBOztBQUM1Qiw0QkFBUUosR0FBUixrQkFBZUksSUFBZjtBQUNEO0FBQ0YsR0FoQlM7QUFpQlZHLE1BakJVLGdCQWlCTE4sUUFqQkssRUFpQmM7QUFDdEIsUUFBSUEsWUFBWUQsS0FBSUMsUUFBcEIsRUFBOEI7QUFBQTs7QUFBQSx5Q0FEZEcsSUFDYztBQURkQSxZQUNjO0FBQUE7O0FBQzVCLDRCQUFRRyxJQUFSLGtCQUFnQkgsSUFBaEI7QUFDRDtBQUNGLEdBckJTO0FBc0JWSSxNQXRCVSxnQkFzQkxQLFFBdEJLLEVBc0JLUSxHQXRCTCxFQXNCbUI7QUFDM0IsUUFBSSxDQUFDVixNQUFNVSxHQUFOLENBQUwsRUFBaUI7QUFBQSx5Q0FESUwsSUFDSjtBQURJQSxZQUNKO0FBQUE7O0FBQ2ZKLFdBQUlBLEdBQUosY0FBUUMsUUFBUixFQUFrQlEsR0FBbEIsU0FBMEJMLElBQTFCO0FBQ0Q7QUFDREwsVUFBTVUsR0FBTixJQUFhLElBQWI7QUFDRDtBQTNCUyxDQUFaOztBQThCQSxTQUFTQyxnQkFBVCxDQUEwQkMsQ0FBMUIsRUFBNkJDLElBQTdCLEVBQW1DO0FBQUEsc0JBQ0FBLElBREEsQ0FDMUJDLE9BRDBCO0FBQUEsTUFDMUJBLE9BRDBCLGlDQUNoQixFQURnQjtBQUFBLG1CQUNBRCxJQURBLENBQ1pFLElBRFk7QUFBQSxNQUNaQSxJQURZLDhCQUNMLENBREs7O0FBRWpDLE1BQUlDLFNBQVMsR0FBYjtBQUNBLE9BQUssSUFBSUMsSUFBSSxDQUFiLEVBQWdCQSxJQUFJTCxFQUFFTSxNQUFOLElBQWdCRCxJQUFJSCxPQUFwQyxFQUE2QyxFQUFFRyxDQUEvQyxFQUFrRDtBQUNoRCxRQUFJQSxJQUFJLENBQVIsRUFBVztBQUNURCx1QkFBZUMsSUFBSUYsSUFBSixLQUFhLENBQWQsR0FBbUIsR0FBbkIsR0FBeUIsRUFBdkM7QUFDRDtBQUNEQyxjQUFVakIsWUFBWWEsRUFBRUssQ0FBRixDQUFaLEVBQWtCSixJQUFsQixDQUFWO0FBQ0Q7QUFDRCxNQUFNTSxhQUFhUCxFQUFFTSxNQUFGLEdBQVdKLE9BQVgsR0FBcUIsS0FBckIsR0FBNkIsR0FBaEQ7QUFDQSxjQUFVRSxNQUFWLEdBQW1CRyxVQUFuQjtBQUNEOztBQUVNLFNBQVNwQixXQUFULENBQXFCYSxDQUFyQixFQUFtQztBQUFBLE1BQVhDLElBQVcsdUVBQUosRUFBSTtBQUFBLHdCQUNaQSxJQURZLENBQ2pDTyxTQURpQztBQUFBLE1BQ2pDQSxTQURpQyxtQ0FDckIsS0FEcUI7O0FBRXhDLE1BQUlDLE1BQU1DLE9BQU4sQ0FBY1YsQ0FBZCxLQUFvQlcsWUFBWUMsTUFBWixDQUFtQlosQ0FBbkIsQ0FBeEIsRUFBK0M7QUFDN0MsV0FBT0QsaUJBQWlCQyxDQUFqQixFQUFvQkMsSUFBcEIsQ0FBUDtBQUNEO0FBQ0QsTUFBSSxDQUFDWSxPQUFPQyxRQUFQLENBQWdCZCxDQUFoQixDQUFMLEVBQXlCO0FBQ3ZCLFdBQU9lLE9BQU9mLENBQVAsQ0FBUDtBQUNEO0FBQ0QsTUFBSVEsU0FBSixFQUFlO0FBQ2IsV0FBT1IsRUFBRWdCLE9BQUYsQ0FBVSxDQUFWLENBQVA7QUFDRDtBQUNELE1BQUlDLEtBQUtDLEdBQUwsQ0FBU2xCLENBQVQsSUFBYyxHQUFkLElBQXFCaUIsS0FBS0MsR0FBTCxDQUFTbEIsQ0FBVCxJQUFjLEtBQXZDLEVBQThDO0FBQzVDLFdBQU9BLEVBQUVnQixPQUFGLENBQVUsQ0FBVixDQUFQO0FBQ0Q7QUFDRCxNQUFNWixTQUFTSixFQUFFbUIsV0FBRixDQUFjLENBQWQsQ0FBZjtBQUNBLE1BQU1DLFVBQVVoQixPQUFPaUIsT0FBUCxDQUFlLElBQWYsQ0FBaEI7QUFDQSxTQUFPRCxZQUFZaEIsT0FBT0UsTUFBUCxHQUFnQixDQUE1QixHQUFnQ0YsT0FBT2tCLEtBQVAsQ0FBYSxDQUFiLEVBQWdCLENBQUMsQ0FBakIsQ0FBaEMsR0FBc0RsQixNQUE3RDtBQUNEOztrQkFFY2YsSSIsImZpbGUiOiJsb2cuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQtZGlzYWJsZSBuby1jb25zb2xlICovXG4vKiBnbG9iYWwgY29uc29sZSAqL1xuY29uc3QgY2FjaGUgPSB7fTtcblxuY29uc3QgbG9nID0ge1xuICBwcmlvcml0eTogMCxcbiAgdGFibGUocHJpb3JpdHksIHRhYmxlKSB7XG4gICAgaWYgKHByaW9yaXR5IDw9IGxvZy5wcmlvcml0eSAmJiB0YWJsZSkge1xuICAgICAgY29uc29sZS50YWJsZSh0YWJsZSk7XG4gICAgfVxuICB9LFxuICBsb2cocHJpb3JpdHksIC4uLmFyZ3MpIHtcbiAgICBpZiAocHJpb3JpdHkgPD0gbG9nLnByaW9yaXR5KSB7XG4gICAgICBjb25zb2xlLmRlYnVnKC4uLmFyZ3MpO1xuICAgIH1cbiAgfSxcbiAgaW5mbyhwcmlvcml0eSwgLi4uYXJncykge1xuICAgIGlmIChwcmlvcml0eSA8PSBsb2cucHJpb3JpdHkpIHtcbiAgICAgIGNvbnNvbGUubG9nKC4uLmFyZ3MpO1xuICAgIH1cbiAgfSxcbiAgd2Fybihwcmlvcml0eSwgLi4uYXJncykge1xuICAgIGlmIChwcmlvcml0eSA8PSBsb2cucHJpb3JpdHkpIHtcbiAgICAgIGNvbnNvbGUud2FybiguLi5hcmdzKTtcbiAgICB9XG4gIH0sXG4gIG9uY2UocHJpb3JpdHksIGFyZywgLi4uYXJncykge1xuICAgIGlmICghY2FjaGVbYXJnXSkge1xuICAgICAgbG9nLmxvZyhwcmlvcml0eSwgYXJnLCAuLi5hcmdzKTtcbiAgICB9XG4gICAgY2FjaGVbYXJnXSA9IHRydWU7XG4gIH1cbn07XG5cbmZ1bmN0aW9uIGZvcm1hdEFycmF5VmFsdWUodiwgb3B0cykge1xuICBjb25zdCB7bWF4RWx0cyA9IDE2LCBzaXplID0gMX0gPSBvcHRzO1xuICBsZXQgc3RyaW5nID0gJ1snO1xuICBmb3IgKGxldCBpID0gMDsgaSA8IHYubGVuZ3RoICYmIGkgPCBtYXhFbHRzOyArK2kpIHtcbiAgICBpZiAoaSA+IDApIHtcbiAgICAgIHN0cmluZyArPSBgLCR7KGkgJSBzaXplID09PSAwKSA/ICcgJyA6ICcnfWA7XG4gICAgfVxuICAgIHN0cmluZyArPSBmb3JtYXRWYWx1ZSh2W2ldLCBvcHRzKTtcbiAgfVxuICBjb25zdCB0ZXJtaW5hdG9yID0gdi5sZW5ndGggPiBtYXhFbHRzID8gJy4uLicgOiAnXSc7XG4gIHJldHVybiBgJHtzdHJpbmd9JHt0ZXJtaW5hdG9yfWA7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBmb3JtYXRWYWx1ZSh2LCBvcHRzID0ge30pIHtcbiAgY29uc3Qge2lzSW50ZWdlciA9IGZhbHNlfSA9IG9wdHM7XG4gIGlmIChBcnJheS5pc0FycmF5KHYpIHx8IEFycmF5QnVmZmVyLmlzVmlldyh2KSkge1xuICAgIHJldHVybiBmb3JtYXRBcnJheVZhbHVlKHYsIG9wdHMpO1xuICB9XG4gIGlmICghTnVtYmVyLmlzRmluaXRlKHYpKSB7XG4gICAgcmV0dXJuIFN0cmluZyh2KTtcbiAgfVxuICBpZiAoaXNJbnRlZ2VyKSB7XG4gICAgcmV0dXJuIHYudG9GaXhlZCgwKTtcbiAgfVxuICBpZiAoTWF0aC5hYnModikgPiAxMDAgJiYgTWF0aC5hYnModikgPCAxMDAwMCkge1xuICAgIHJldHVybiB2LnRvRml4ZWQoMCk7XG4gIH1cbiAgY29uc3Qgc3RyaW5nID0gdi50b1ByZWNpc2lvbigyKTtcbiAgY29uc3QgZGVjaW1hbCA9IHN0cmluZy5pbmRleE9mKCcuMCcpO1xuICByZXR1cm4gZGVjaW1hbCA9PT0gc3RyaW5nLmxlbmd0aCAtIDIgPyBzdHJpbmcuc2xpY2UoMCwgLTEpIDogc3RyaW5nO1xufVxuXG5leHBvcnQgZGVmYXVsdCBsb2c7XG4iXX0=

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.draw = draw;
	
	var _context = __webpack_require__(300);
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// A good thing about webGL is that there are so many ways to draw things,
	// e.g. depending on whether data is indexed and/or isInstanced.
	// This function unifies those into a single call with simple parameters
	// that have sane defaults.
	/* eslint-disable */
	// TODO - generic draw call
	// One of the good things about GL is that there are so many ways to draw things
	function draw(gl, _ref) {
	  var _ref$drawMode = _ref.drawMode,
	      drawMode = _ref$drawMode === undefined ? _webgl.GL.TRIANGLES : _ref$drawMode,
	      vertexCount = _ref.vertexCount,
	      _ref$offset = _ref.offset,
	      offset = _ref$offset === undefined ? 0 : _ref$offset,
	      _ref$isIndexed = _ref.isIndexed,
	      isIndexed = _ref$isIndexed === undefined ? false : _ref$isIndexed,
	      _ref$indexType = _ref.indexType,
	      indexType = _ref$indexType === undefined ? _webgl.GL.UNSIGNED_SHORT : _ref$indexType,
	      _ref$isInstanced = _ref.isInstanced,
	      isInstanced = _ref$isInstanced === undefined ? false : _ref$isInstanced,
	      _ref$instanceCount = _ref.instanceCount,
	      instanceCount = _ref$instanceCount === undefined ? 0 : _ref$instanceCount;
	
	  (0, _webglChecks.assertWebGLContext)(gl);
	
	  drawMode = (0, _webgl.glGet)(drawMode);
	  indexType = (0, _webgl.glGet)(indexType);
	
	  (0, _webglChecks.assertDrawMode)(drawMode, 'in draw');
	  if (isIndexed) {
	    (0, _webglChecks.assertIndexType)(indexType, 'in draw');
	  }
	
	  // TODO - Use polyfilled WebGL2RenderingContext instead of ANGLE extension
	  if (isInstanced) {
	    var webgl2 = (0, _webglChecks.isWebGL2Context)(gl);
	    var extension = gl.getExtension('ANGLE_instanced_arrays');
	    var context = webgl2 ? gl : extension;
	    var suffix = webgl2 ? '' : 'ANGLE';
	    var drawElements = 'drawElementsInstanced' + suffix;
	    var drawArrays = 'drawArraysInstanced' + suffix;
	
	    if (isIndexed) {
	      context[drawElements](drawMode, vertexCount, indexType, offset, instanceCount);
	    } else {
	      context[drawArrays](drawMode, offset, vertexCount, instanceCount);
	    }
	  } else if (isIndexed) {
	    gl.drawElements(drawMode, vertexCount, indexType, offset);
	  } else {
	    gl.drawArrays(drawMode, offset, vertexCount);
	  }
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 482 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ERR_DELETED = 'Query was deleted before result was available';
	var ERR_CANCEL = 'Query was canceled before result was available';
	
	var noop = function noop(x) {
	  return x;
	};
	
	var QueryManager = function () {
	
	  /**
	   * Internal class that helps "asynchronous WebGL query objects" manage
	   * pending requests (e.g. for EXT_disjoint_timer_query and WebGL2 queries)
	   *
	   * Creates and manages promises for the queries.
	   * Tracks pending queries enabling polling.
	   * Tracks pending queries enabling invalidation.
	   * Encapsulates some standard error messages.
	   *
	   * Remarks:
	   * - Maintains a minimal list of pending queries only to minimize GC impact
	   * - Exported as a singleton class instance.
	   */
	  function QueryManager() {
	    _classCallCheck(this, QueryManager);
	
	    this.pendingQueries = new Set();
	    this.invalidQueryType = null;
	    this.invalidErrorMessage = '';
	    this.checkInvalid = function () {
	      return false;
	    };
	  }
	
	  // API THAT SHOULD BE EXPOSED TO APPLICATION
	
	  // Checks invalidation callback and then all pending queries for completion
	  // Should only be called once per tick
	
	
	  _createClass(QueryManager, [{
	    key: 'poll',
	    value: function poll(gl) {
	      this.cancelInvalidQueries(gl);
	
	      // Now check availability of results and resolve promises as appropriate
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.pendingQueries.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var query = _step.value;
	
	          var resultAvailable = query.isResultAvailable();
	          if (resultAvailable) {
	            var result = query.getResult();
	            this.resolveQuery(query, result);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	
	    // API FOR MANAGED QUERY CLASSES
	
	    // Registers query invalidation method - used to detect disjoint timer queries
	
	  }, {
	    key: 'setInvalidator',
	    value: function setInvalidator(_ref) {
	      var queryType = _ref.queryType,
	          errorMessage = _ref.errorMessage,
	          checkInvalid = _ref.checkInvalid;
	
	      this.invalidQueryType = queryType;
	      this.invalidErrorMessage = errorMessage;
	      this.checkInvalid = checkInvalid;
	    }
	
	    // Starts a query, sets up a new promise
	
	  }, {
	    key: 'beginQuery',
	    value: function beginQuery(query) {
	      var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	      var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
	
	      // Make sure disjoint state is cleared, so that this query starts fresh
	      // Cancel other queries if needed
	      this.cancelInvalidQueries(query.gl);
	
	      // Cancel current promise - noop if already resolved or rejected
	      this.cancelQuery(query);
	
	      // Create a new promise with attached resolve and reject methods
	      var resolvers = {};
	      query.promise = new Promise(function (resolve, reject) {
	        resolvers.resolve = resolve;
	        resolvers.reject = reject;
	      });
	      Object.assign(query.promise, resolvers);
	
	      // Add this query to the pending queries
	      this.pendingQueries.add(query);
	      // Register the callbacks
	      return query.promise.then(onComplete).catch(onError);
	    }
	
	    // Resolves a query with a result
	
	  }, {
	    key: 'resolveQuery',
	    value: function resolveQuery(query, result) {
	      this.pendingQueries.delete(query);
	      query.promise.resolve(result);
	    }
	
	    // Rejects the promise
	
	  }, {
	    key: 'rejectQuery',
	    value: function rejectQuery(query, errorMessage) {
	      this.pendingQueries.delete(query);
	      if (query.promise) {
	        query.promise.reject(new Error(errorMessage));
	      }
	    }
	
	    // Rejects promise with standard message for Query.delete()
	
	  }, {
	    key: 'deleteQuery',
	    value: function deleteQuery(query) {
	      return this.rejectQuery(query, ERR_DELETED);
	    }
	
	    // Rejects promise with standard message for Query.cancel()
	
	  }, {
	    key: 'cancelQuery',
	    value: function cancelQuery(query) {
	      return this.rejectQuery(query, ERR_CANCEL);
	    }
	
	    // Rejects promise with registered message for invalidation
	
	  }, {
	    key: 'invalidateQuery',
	    value: function invalidateQuery(query) {
	      if (query instanceof this.invalidQueryType) {
	        this.rejectQuery(query, this.invalidErrorMessage);
	      }
	    }
	
	    // Checks all queries to see if need to be invalidated
	
	  }, {
	    key: 'cancelInvalidQueries',
	    value: function cancelInvalidQueries(gl) {
	      // We assume that we can cancel queries for all context.
	      // Should be OK since this is used to check for "disjoint" GPU state
	      if (this.checkInvalid(gl)) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = this.pendingQueries.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var query = _step2.value;
	
	            this.invalidateQuery(query);
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    }
	  }]);
	
	  return QueryManager;
	}();
	
	exports.default = new QueryManager();
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getUniformDescriptors = getUniformDescriptors;
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _vertexAttributes = __webpack_require__(488);
	
	var VertexAttributes = _interopRequireWildcard(_vertexAttributes);
	
	var _buffer2 = __webpack_require__(161);
	
	var _buffer3 = _interopRequireDefault(_buffer2);
	
	var _texture = __webpack_require__(217);
	
	var _texture2 = _interopRequireDefault(_texture);
	
	var _uniforms = __webpack_require__(486);
	
	var _shader = __webpack_require__(302);
	
	var _utils = __webpack_require__(30);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Program = function () {
	  _createClass(Program, null, [{
	    key: 'makeFrom',
	
	
	    /**
	     * Returns a Program wrapped WebGLProgram from a variety of inputs.
	     * Allows other functions to transparently accept raw WebGLPrograms etc
	     * and manipulate them using the methods in the `Program` class.
	     * Checks for ".handle"
	     *
	     * @param {WebGLRenderingContext} gl - if a new buffer needs to be initialized
	     * @param {*} object - candidate that will be coerced to a buffer
	     * @returns {Program} - Program object that wraps the buffer parameter
	     */
	    value: function makeFrom(gl) {
	      var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return object instanceof Program ? object :
	      // Use .handle if available, else use 'program' directly
	      new Program(gl).setData({ handle: object.handle || object });
	    }
	
	    /*
	     * @classdesc
	     * Handles creation of programs, mapping of attributes and uniforms
	     *
	     * @class
	     * @param {WebGLRenderingContext} gl - gl context
	     * @param {Object} opts - options
	     * @param {String} opts.vs - Vertex shader source
	     * @param {String} opts.fs - Fragment shader source
	     * @param {String} opts.id= - Id
	     */
	    /* eslint-disable max-statements */
	
	  }]);
	
	  function Program(gl) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        id = _ref.id,
	        vs = _ref.vs,
	        fs = _ref.fs,
	        defaultUniforms = _ref.defaultUniforms,
	        handle = _ref.handle;
	
	    _classCallCheck(this, Program);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	
	    // Create shaders if needed
	    this.vs = typeof vs === 'string' ? new _shader.VertexShader(gl, vs) : vs;
	    this.fs = typeof vs === 'string' ? new _shader.FragmentShader(gl, fs) : fs;
	
	    (0, _assert2.default)(this.vs instanceof _shader.VertexShader, 'Program: bad vertex shader');
	    (0, _assert2.default)(this.fs instanceof _shader.FragmentShader, 'Program: bad fragment shader');
	
	    // If program is not named, name it after shader names
	    var programName = this.vs.getName() || this.fs.getName();
	    programName = programName ? programName + '-program' : 'program';
	    this.id = id || (0, _utils.uid)(programName);
	
	    this.gl = gl;
	    this.defaultUniforms = defaultUniforms;
	    this.handle = handle;
	    if (!this.handle) {
	      this.handle = gl.createProgram();
	      this._compileAndLink();
	    }
	    if (!this.handle) {
	      throw new Error('Failed to create program');
	    }
	
	    // determine attribute locations (i.e. indices)
	    this._attributeLocations = this._getAttributeLocations();
	    this._attributeCount = this.getAttributeCount();
	    this._warn = [];
	    this._filledLocations = {};
	
	    // prepare uniform setters
	    this._uniformSetters = this._getUniformSetters();
	    this._uniformCount = this.getUniformCount();
	    this._textureIndexCounter = 0;
	
	    this.userData = {};
	    Object.seal(this);
	  }
	  /* eslint-enable max-statements */
	
	  _createClass(Program, [{
	    key: 'delete',
	    value: function _delete() {
	      var gl = this.gl;
	
	      if (this.handle) {
	        gl.deleteProgram(this.handle);
	      }
	      this.handle = null;
	      return this;
	    }
	  }, {
	    key: 'use',
	    value: function use() {
	      var gl = this.gl;
	
	      gl.useProgram(this.handle);
	      return this;
	    }
	
	    // DEPRECATED METHODS
	
	  }, {
	    key: 'clearBuffers',
	    value: function clearBuffers() {
	      this._filledLocations = {};
	      return this;
	    }
	  }, {
	    key: '_print',
	    value: function _print(bufferName) {
	      return 'Program ' + this.id + ': Attribute ' + bufferName;
	    }
	
	    /**
	     * Attach a map of Buffers values to a program
	     * Only attributes with names actually present in the linked program
	     * will be updated. Other supplied buffers will be ignored.
	     *
	     * @param {Object} buffers - An object map with attribute names being keys
	     *  and values are expected to be instances of Buffer.
	     * @returns {Program} Returns itself for chaining.
	     */
	    /* eslint-disable max-statements */
	
	  }, {
	    key: 'setBuffers',
	    value: function setBuffers(buffers) {
	      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref2$clear = _ref2.clear,
	          clear = _ref2$clear === undefined ? true : _ref2$clear,
	          _ref2$check = _ref2.check,
	          check = _ref2$check === undefined ? true : _ref2$check,
	          _ref2$drawParams = _ref2.drawParams,
	          drawParams = _ref2$drawParams === undefined ? {} : _ref2$drawParams;
	
	      var gl = this.gl;
	
	      if (Array.isArray(buffers)) {
	        throw new Error('Program.setBuffers expects map of buffers');
	      }
	
	      if (clear) {
	        this.clearBuffers();
	      }
	
	      // indexing is autodetected - buffer with target gl.ELEMENT_ARRAY_BUFFER
	      // index type is saved for drawElement calls
	      drawParams.isInstanced = false;
	      drawParams.isIndexed = false;
	      drawParams.indexType = null;
	
	      var _sortBuffersByLocatio = this._sortBuffersByLocation(buffers),
	          locations = _sortBuffersByLocatio.locations,
	          elements = _sortBuffersByLocatio.elements;
	
	      // Process locations in order
	
	
	      for (var location = 0; location < locations.length; ++location) {
	        var bufferName = locations[location];
	        var buffer = buffers[bufferName];
	        // DISABLE MISSING ATTRIBUTE
	        if (!buffer) {
	          VertexAttributes.disable(gl, location);
	        } else {
	          var divisor = buffer.layout.instanced ? 1 : 0;
	          VertexAttributes.enable(gl, location);
	          VertexAttributes.setBuffer({ gl: gl, location: location, buffer: buffer });
	          VertexAttributes.setDivisor(gl, location, divisor);
	          drawParams.isInstanced = buffer.layout.instanced > 0;
	          this._filledLocations[bufferName] = true;
	        }
	      }
	
	      // SET ELEMENTS ARRAY BUFFER
	      if (elements) {
	        var _buffer = buffers[elements];
	        _buffer.bind();
	        drawParams.isIndexed = true;
	        drawParams.indexType = _buffer.layout.type;
	      }
	
	      if (check) {
	        this.checkBuffers();
	      }
	
	      return this;
	    }
	    /* eslint-enable max-statements */
	
	  }, {
	    key: 'checkBuffers',
	    value: function checkBuffers() {
	      for (var attributeName in this._attributeLocations) {
	        if (!this._filledLocations[attributeName] && !this._warn[attributeName]) {
	          var location = this._attributeLocations[attributeName];
	          // throw new Error(`Program ${this.id}: ` +
	          //   `Attribute ${location}:${attributeName} not supplied`);
	          _utils.log.warn(0, 'Program ' + this.id + ': ' + ('Attribute ' + location + ':' + attributeName + ' not supplied'));
	          this._warn[attributeName] = true;
	        }
	      }
	      return this;
	    }
	
	    /*
	     * @returns {Program} Returns itself for chaining.
	     */
	
	  }, {
	    key: 'unsetBuffers',
	    value: function unsetBuffers() {
	      var gl = this.gl;
	
	      var length = this._attributeCount;
	      for (var i = 1; i < length; ++i) {
	        // VertexAttributes.setDivisor(gl, i, 0);
	        VertexAttributes.disable(gl, i);
	      }
	      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
	      return this;
	    }
	
	    /**
	     * Apply a set of uniform values to a program
	     * Only uniforms with names actually present in the linked program
	     * will be updated.
	     * other uniforms will be ignored
	     *
	     * @param {Object} uniformMap - An object with names being keys
	     * @returns {Program} - returns itself for chaining.
	     */
	    /* eslint-disable max-depth */
	
	  }, {
	    key: 'setUniforms',
	    value: function setUniforms(uniforms) {
	      for (var uniformName in uniforms) {
	        var uniform = uniforms[uniformName];
	        var uniformSetter = this._uniformSetters[uniformName];
	        if (uniformSetter) {
	          if (uniform instanceof _texture2.default) {
	            if (uniformSetter.textureIndex === undefined) {
	              uniformSetter.textureIndex = this._textureIndexCounter++;
	            }
	            // Bind texture to index, and set the uniform sampler to the index
	            var texture = uniform;
	            var textureIndex = uniformSetter.textureIndex;
	            // console.debug('setting texture', textureIndex, texture);
	
	            texture.bind(textureIndex);
	            uniformSetter(textureIndex);
	          } else {
	            // Just set the value
	            uniformSetter(uniform);
	          }
	        }
	      }
	      return this;
	    }
	    /* eslint-enable max-depth */
	
	    // RAW WEBGL METHODS
	
	  }, {
	    key: 'getAttachedShadersCount',
	    value: function getAttachedShadersCount() {
	      return this.getProgramParameter(_webgl.GL.ATTACHED_SHADERS);
	    }
	
	    // ATTRIBUTES API
	    // Note: Locations are numeric indices
	
	  }, {
	    key: 'getAttributeCount',
	    value: function getAttributeCount() {
	      return this.getProgramParameter(_webgl.GL.ACTIVE_ATTRIBUTES);
	    }
	
	    /**
	     * Returns an object with info about attribute at index "location"/
	     * @param {int} location - index of an attribute
	     * @returns {WebGLActiveInfo} - info about an active attribute
	     *   fields: {name, size, type}
	     */
	
	  }, {
	    key: 'getAttributeInfo',
	    value: function getAttributeInfo(location) {
	      return this.gl.getActiveAttrib(this.handle, location);
	    }
	  }, {
	    key: 'getAttributeName',
	    value: function getAttributeName(location) {
	      return this.getAttributeInfo(location).name;
	    }
	
	    /**
	     * Returns location (index) of a name
	     * @param {String} attributeName - name of an attribute
	     *   (matches name in a linked shader)
	     * @returns {String[]} - array of actual attribute names from shader linking
	     */
	
	  }, {
	    key: 'getAttributeLocation',
	    value: function getAttributeLocation(attributeName) {
	      return this.gl.getAttribLocation(this.handle, attributeName);
	    }
	
	    // UNIFORMS API
	    // Note: locations are opaque structures
	
	  }, {
	    key: 'getUniformCount',
	    value: function getUniformCount() {
	      return this.getProgramParameter(_webgl.GL.ACTIVE_UNIFORMS);
	    }
	
	    /*
	     * @returns {WebGLActiveInfo} - object with {name, size, type}
	     */
	
	  }, {
	    key: 'getUniformInfo',
	    value: function getUniformInfo(index) {
	      return this.gl.getActiveUniform(this.handle, index);
	    }
	
	    /*
	     * @returns {WebGLUniformLocation} - opaque object representing location
	     * of uniform, used by setter methods
	     */
	
	  }, {
	    key: 'getUniformLocation',
	    value: function getUniformLocation(name) {
	      return this.gl.getUniformLocation(this.handle, name);
	    }
	  }, {
	    key: 'getUniformValue',
	    value: function getUniformValue(location) {
	      return this.gl.getUniform(this.handle, location);
	    }
	
	    // PROGRAM API
	
	  }, {
	    key: 'isFlaggedForDeletion',
	    value: function isFlaggedForDeletion() {
	      return this.getProgramParameter(_webgl.GL.DELETE_STATUS);
	    }
	  }, {
	    key: 'getLastLinkStatus',
	    value: function getLastLinkStatus() {
	      return this.getProgramParameter(_webgl.GL.LINK_STATUS);
	    }
	  }, {
	    key: 'getLastValidationStatus',
	    value: function getLastValidationStatus() {
	      return this.getProgramParameter(_webgl.GL.VALIDATE_STATUS);
	    }
	
	    // WEBGL2 INTERFACE
	
	    // This may be gl.SEPARATE_ATTRIBS or gl.INTERLEAVED_ATTRIBS.
	
	  }, {
	    key: 'getTransformFeedbackBufferMode',
	    value: function getTransformFeedbackBufferMode() {
	      (0, _webglChecks.assertWebGL2Context)(this.gl);
	      return this.getProgramParameter(this.gl.TRANSFORM_FEEDBACK_BUFFER_MODE);
	    }
	  }, {
	    key: 'getTransformFeedbackVaryingsCount',
	    value: function getTransformFeedbackVaryingsCount() {
	      (0, _webglChecks.assertWebGL2Context)(this.gl);
	      return this.getProgramParameter(this.gl.TRANSFORM_FEEDBACK_VARYINGS);
	    }
	  }, {
	    key: 'getActiveUniformBlocksCount',
	    value: function getActiveUniformBlocksCount() {
	      (0, _webglChecks.assertWebGL2Context)(this.gl);
	      return this.getProgramParameter(this.gl.ACTIVE_UNIFORM_BLOCKS);
	    }
	
	    // Retrieves the assigned color number binding for the user-defined varying
	    // out variable name for program. program must have previously been linked.
	    // [WebGLHandlesContextLoss]
	
	  }, {
	    key: 'getFragDataLocation',
	    value: function getFragDataLocation(varyingName) {
	      (0, _webglChecks.assertWebGL2Context)(this.gl);
	      return this.gl.getFragDataLocation(this.handle, varyingName);
	    }
	
	    // Return the value for the passed pname given the passed program.
	    // The type returned is the natural type for the requested pname,
	    // as given in the following table:
	    // pname returned type
	    // DELETE_STATUS GLboolean
	    // LINK_STATUS GLboolean
	    // VALIDATE_STATUS GLboolean
	    // ATTACHED_SHADERS  GLint
	    // ACTIVE_ATTRIBUTES GLint
	    // ACTIVE_UNIFORMS GLint
	    // TRANSFORM_FEEDBACK_BUFFER_MODE  GLenum
	    // TRANSFORM_FEEDBACK_VARYINGS GLint
	    // ACTIVE_UNIFORM_BLOCKS GLint
	
	  }, {
	    key: 'getProgramParameter',
	    value: function getProgramParameter(pname) {
	      return this.gl.getProgramParameter(this.handle, pname);
	    }
	
	    // PRIVATE METHODS
	
	  }, {
	    key: '_compileAndLink',
	    value: function _compileAndLink() {
	      var gl = this.gl;
	
	      gl.attachShader(this.handle, this.vs.handle);
	      gl.attachShader(this.handle, this.fs.handle);
	      gl.linkProgram(this.handle);
	      // Program linking error is checked only when debug context is used
	      if (gl.debug) {
	        gl.validateProgram(this.handle);
	        var linked = gl.getProgramParameter(this.handle, gl.LINK_STATUS);
	        if (!linked) {
	          throw new Error('Error linking ' + gl.getProgramInfoLog(this.handle));
	        }
	      }
	    }
	  }, {
	    key: '_sortBuffersByLocation',
	    value: function _sortBuffersByLocation(buffers) {
	      var elements = null;
	      var locations = new Array(this._attributeCount);
	
	      for (var bufferName in buffers) {
	        var buffer = _buffer3.default.makeFrom(this.gl, buffers[bufferName]);
	        var location = this._attributeLocations[bufferName];
	        if (location === undefined) {
	          if (buffer.target === _webgl.GL.ELEMENT_ARRAY_BUFFER && elements) {
	            throw new Error(this._print(bufferName) + ' duplicate gl.ELEMENT_ARRAY_BUFFER');
	          } else if (buffer.target === _webgl.GL.ELEMENT_ARRAY_BUFFER) {
	            elements = bufferName;
	          } else if (!this._warn[bufferName]) {
	            _utils.log.warn(2, this._print(bufferName) + ' not used');
	            this._warn[bufferName] = true;
	          }
	        } else {
	          if (buffer.target === _webgl.GL.ELEMENT_ARRAY_BUFFER) {
	            throw new Error(this._print(bufferName) + ':' + location + ' ' + 'has both location and type gl.ELEMENT_ARRAY_BUFFER');
	          }
	          locations[location] = bufferName;
	        }
	      }
	
	      return { locations: locations, elements: elements };
	    }
	
	    // Check that all active attributes are enabled
	
	  }, {
	    key: '_areAllAttributesEnabled',
	    value: function _areAllAttributesEnabled() {
	      var gl = this.gl;
	
	      var length = this._attributeCount;
	      for (var i = 0; i < length; ++i) {
	        if (!VertexAttributes.isEnabled(gl, i)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    // determine attribute locations (maps attribute name to index)
	
	  }, {
	    key: '_getAttributeLocations',
	    value: function _getAttributeLocations() {
	      var attributeLocations = {};
	      var length = this.getAttributeCount();
	      for (var location = 0; location < length; location++) {
	        var name = this.getAttributeName(location);
	        attributeLocations[name] = this.getAttributeLocation(name);
	      }
	      return attributeLocations;
	    }
	
	    // create uniform setters
	    // Map of uniform names to setter functions
	
	  }, {
	    key: '_getUniformSetters',
	    value: function _getUniformSetters() {
	      var gl = this.gl;
	
	      var uniformSetters = {};
	      var length = this.getUniformCount();
	      for (var i = 0; i < length; i++) {
	        var info = this.getUniformInfo(i);
	        var parsedName = (0, _uniforms.parseUniformName)(info.name);
	        var location = this.getUniformLocation(parsedName.name);
	        uniformSetters[parsedName.name] = (0, _uniforms.getUniformSetter)(gl, location, info, parsedName.isArray);
	      }
	      return uniformSetters;
	    }
	  }]);
	
	  return Program;
	}();
	
	// create uniform setters
	// Map of uniform names to setter functions
	
	
	exports.default = Program;
	function getUniformDescriptors(gl, program) {
	  var uniformDescriptors = {};
	  var length = program.getUniformCount();
	  for (var i = 0; i < length; i++) {
	    var info = program.getUniformInfo(i);
	    var location = program.getUniformLocation(info.name);
	    var descriptor = (0, _uniforms.getUniformSetter)(gl, location, info);
	    uniformDescriptors[descriptor.name] = descriptor;
	  }
	  return uniformDescriptors;
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _texture = __webpack_require__(217);
	
	var _texture2 = _interopRequireDefault(_texture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextureCube = function (_Texture) {
	  _inherits(TextureCube, _Texture);
	
	  _createClass(TextureCube, null, [{
	    key: 'makeFrom',
	    value: function makeFrom(gl) {
	      var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return object instanceof TextureCube ? object :
	      // Use .handle (e.g from stack.gl's gl-buffer), else use buffer directly
	      new TextureCube(gl, { handle: object.handle || object });
	    }
	  }]);
	
	  function TextureCube(gl) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, TextureCube);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	
	    var _this = _possibleConstructorReturn(this, (TextureCube.__proto__ || Object.getPrototypeOf(TextureCube)).call(this, gl, Object.assign({}, opts, { target: _webgl.GL.TEXTURE_CUBE_MAP })));
	
	    _this.setCubeMapImageData(opts);
	    return _this;
	  }
	
	  _createClass(TextureCube, [{
	    key: 'bind',
	    value: function bind() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          index = _ref.index;
	
	      var gl = this.gl;
	
	      if (index !== undefined) {
	        gl.activeTexture(_webgl.GL.TEXTURE0 + index);
	      }
	      gl.bindTexture(_webgl.GL.TEXTURE_CUBE_MAP, this.handle);
	      if (index === undefined) {
	        var result = gl.getParameter(gl.ACTIVE_TEXTURE) - _webgl.GL.TEXTURE0;
	        return result;
	      }
	      return index;
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind() {
	      var gl = this.gl;
	
	      gl.bindTexture(_webgl.GL.TEXTURE_CUBE_MAP, null);
	    }
	
	    /* eslint-disable max-statements, max-len */
	
	  }, {
	    key: 'setCubeMapImageData',
	    value: function setCubeMapImageData(_ref2) {
	      var width = _ref2.width,
	          height = _ref2.height,
	          pixels = _ref2.pixels,
	          data = _ref2.data,
	          _ref2$border = _ref2.border,
	          border = _ref2$border === undefined ? 0 : _ref2$border,
	          _ref2$format = _ref2.format,
	          format = _ref2$format === undefined ? _webgl.GL.RGBA : _ref2$format,
	          _ref2$type = _ref2.type,
	          type = _ref2$type === undefined ? _webgl.GL.UNSIGNED_BYTE : _ref2$type,
	          _ref2$generateMipmap = _ref2.generateMipmap,
	          generateMipmap = _ref2$generateMipmap === undefined ? false : _ref2$generateMipmap;
	      var gl = this.gl;
	
	      pixels = pixels || data;
	      this.bind();
	      if (this.width || this.height) {
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_POSITIVE_X, 0, format, width, height, border, format, type, pixels.pos.x);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_POSITIVE_Y, 0, format, width, height, border, format, type, pixels.pos.y);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_POSITIVE_Z, 0, format, width, height, border, format, type, pixels.pos.z);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_NEGATIVE_X, 0, format, width, height, border, format, type, pixels.neg.x);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_NEGATIVE_Y, 0, format, width, height, border, format, type, pixels.neg.y);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_NEGATIVE_Z, 0, format, width, height, border, format, type, pixels.neg.z);
	      } else {
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_POSITIVE_X, 0, format, format, type, pixels.pos.x);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_POSITIVE_Y, 0, format, format, type, pixels.pos.y);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_POSITIVE_Z, 0, format, format, type, pixels.pos.z);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_NEGATIVE_X, 0, format, format, type, pixels.neg.x);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_NEGATIVE_Y, 0, format, format, type, pixels.neg.y);
	        gl.texImage2D(_webgl.GL.TEXTURE_CUBE_MAP_NEGATIVE_Z, 0, format, format, type, pixels.neg.z);
	      }
	
	      this.unbind();
	
	      if (generateMipmap) {
	        this.generateMipmap();
	      }
	      return this;
	    }
	  }]);
	
	  return TextureCube;
	}(_texture2.default);
	
	exports.default = TextureCube;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy93ZWJnbC90ZXh0dXJlLWN1YmUuanMiXSwibmFtZXMiOlsiVGV4dHVyZUN1YmUiLCJnbCIsIm9iamVjdCIsImhhbmRsZSIsIm9wdHMiLCJPYmplY3QiLCJhc3NpZ24iLCJ0YXJnZXQiLCJURVhUVVJFX0NVQkVfTUFQIiwic2V0Q3ViZU1hcEltYWdlRGF0YSIsImluZGV4IiwidW5kZWZpbmVkIiwiYWN0aXZlVGV4dHVyZSIsIlRFWFRVUkUwIiwiYmluZFRleHR1cmUiLCJyZXN1bHQiLCJnZXRQYXJhbWV0ZXIiLCJBQ1RJVkVfVEVYVFVSRSIsIndpZHRoIiwiaGVpZ2h0IiwicGl4ZWxzIiwiZGF0YSIsImJvcmRlciIsImZvcm1hdCIsIlJHQkEiLCJ0eXBlIiwiVU5TSUdORURfQllURSIsImdlbmVyYXRlTWlwbWFwIiwiYmluZCIsInRleEltYWdlMkQiLCJURVhUVVJFX0NVQkVfTUFQX1BPU0lUSVZFX1giLCJwb3MiLCJ4IiwiVEVYVFVSRV9DVUJFX01BUF9QT1NJVElWRV9ZIiwieSIsIlRFWFRVUkVfQ1VCRV9NQVBfUE9TSVRJVkVfWiIsInoiLCJURVhUVVJFX0NVQkVfTUFQX05FR0FUSVZFX1giLCJuZWciLCJURVhUVVJFX0NVQkVfTUFQX05FR0FUSVZFX1kiLCJURVhUVVJFX0NVQkVfTUFQX05FR0FUSVZFX1oiLCJ1bmJpbmQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7SUFFcUJBLFc7Ozs7OzZCQUVIQyxFLEVBQWlCO0FBQUEsVUFBYkMsTUFBYSx1RUFBSixFQUFJOztBQUMvQixhQUFPQSxrQkFBa0JGLFdBQWxCLEdBQWdDRSxNQUFoQztBQUNMO0FBQ0EsVUFBSUYsV0FBSixDQUFnQkMsRUFBaEIsRUFBb0IsRUFBQ0UsUUFBUUQsT0FBT0MsTUFBUCxJQUFpQkQsTUFBMUIsRUFBcEIsQ0FGRjtBQUdEOzs7QUFFRCx1QkFBWUQsRUFBWixFQUEyQjtBQUFBLFFBQVhHLElBQVcsdUVBQUosRUFBSTs7QUFBQTs7QUFDekIseUNBQW1CSCxFQUFuQjs7QUFEeUIsMEhBRW5CQSxFQUZtQixFQUVmSSxPQUFPQyxNQUFQLENBQWMsRUFBZCxFQUFrQkYsSUFBbEIsRUFBd0IsRUFBQ0csUUFBUSxVQUFHQyxnQkFBWixFQUF4QixDQUZlOztBQUd6QixVQUFLQyxtQkFBTCxDQUF5QkwsSUFBekI7QUFIeUI7QUFJMUI7Ozs7MkJBRWtCO0FBQUEscUZBQUosRUFBSTtBQUFBLFVBQWJNLEtBQWEsUUFBYkEsS0FBYTs7QUFBQSxVQUNWVCxFQURVLEdBQ0osSUFESSxDQUNWQSxFQURVOztBQUVqQixVQUFJUyxVQUFVQyxTQUFkLEVBQXlCO0FBQ3ZCVixXQUFHVyxhQUFILENBQWlCLFVBQUdDLFFBQUgsR0FBY0gsS0FBL0I7QUFDRDtBQUNEVCxTQUFHYSxXQUFILENBQWUsVUFBR04sZ0JBQWxCLEVBQW9DLEtBQUtMLE1BQXpDO0FBQ0EsVUFBSU8sVUFBVUMsU0FBZCxFQUF5QjtBQUN2QixZQUFNSSxTQUFTZCxHQUFHZSxZQUFILENBQWdCZixHQUFHZ0IsY0FBbkIsSUFBcUMsVUFBR0osUUFBdkQ7QUFDQSxlQUFPRSxNQUFQO0FBQ0Q7QUFDRCxhQUFPTCxLQUFQO0FBQ0Q7Ozs2QkFFUTtBQUFBLFVBQ0FULEVBREEsR0FDTSxJQUROLENBQ0FBLEVBREE7O0FBRVBBLFNBQUdhLFdBQUgsQ0FBZSxVQUFHTixnQkFBbEIsRUFBb0MsSUFBcEM7QUFDRDs7QUFFRDs7OzsrQ0FVRztBQUFBLFVBUkRVLEtBUUMsU0FSREEsS0FRQztBQUFBLFVBUERDLE1BT0MsU0FQREEsTUFPQztBQUFBLFVBTkRDLE1BTUMsU0FOREEsTUFNQztBQUFBLFVBTERDLElBS0MsU0FMREEsSUFLQztBQUFBLCtCQUpEQyxNQUlDO0FBQUEsVUFKREEsTUFJQyxnQ0FKUSxDQUlSO0FBQUEsK0JBSERDLE1BR0M7QUFBQSxVQUhEQSxNQUdDLGdDQUhRLFVBQUdDLElBR1g7QUFBQSw2QkFGREMsSUFFQztBQUFBLFVBRkRBLElBRUMsOEJBRk0sVUFBR0MsYUFFVDtBQUFBLHVDQUREQyxjQUNDO0FBQUEsVUFEREEsY0FDQyx3Q0FEZ0IsS0FDaEI7QUFBQSxVQUNNMUIsRUFETixHQUNZLElBRFosQ0FDTUEsRUFETjs7QUFFRG1CLGVBQVNBLFVBQVVDLElBQW5CO0FBQ0EsV0FBS08sSUFBTDtBQUNBLFVBQUksS0FBS1YsS0FBTCxJQUFjLEtBQUtDLE1BQXZCLEVBQStCO0FBQzdCbEIsV0FBRzRCLFVBQUgsQ0FBYyxVQUFHQywyQkFBakIsRUFDRSxDQURGLEVBQ0tQLE1BREwsRUFDYUwsS0FEYixFQUNvQkMsTUFEcEIsRUFDNEJHLE1BRDVCLEVBQ29DQyxNQURwQyxFQUM0Q0UsSUFENUMsRUFDa0RMLE9BQU9XLEdBQVAsQ0FBV0MsQ0FEN0Q7QUFFQS9CLFdBQUc0QixVQUFILENBQWMsVUFBR0ksMkJBQWpCLEVBQ0UsQ0FERixFQUNLVixNQURMLEVBQ2FMLEtBRGIsRUFDb0JDLE1BRHBCLEVBQzRCRyxNQUQ1QixFQUNvQ0MsTUFEcEMsRUFDNENFLElBRDVDLEVBQ2tETCxPQUFPVyxHQUFQLENBQVdHLENBRDdEO0FBRUFqQyxXQUFHNEIsVUFBSCxDQUFjLFVBQUdNLDJCQUFqQixFQUNFLENBREYsRUFDS1osTUFETCxFQUNhTCxLQURiLEVBQ29CQyxNQURwQixFQUM0QkcsTUFENUIsRUFDb0NDLE1BRHBDLEVBQzRDRSxJQUQ1QyxFQUNrREwsT0FBT1csR0FBUCxDQUFXSyxDQUQ3RDtBQUVBbkMsV0FBRzRCLFVBQUgsQ0FBYyxVQUFHUSwyQkFBakIsRUFDRSxDQURGLEVBQ0tkLE1BREwsRUFDYUwsS0FEYixFQUNvQkMsTUFEcEIsRUFDNEJHLE1BRDVCLEVBQ29DQyxNQURwQyxFQUM0Q0UsSUFENUMsRUFDa0RMLE9BQU9rQixHQUFQLENBQVdOLENBRDdEO0FBRUEvQixXQUFHNEIsVUFBSCxDQUFjLFVBQUdVLDJCQUFqQixFQUNFLENBREYsRUFDS2hCLE1BREwsRUFDYUwsS0FEYixFQUNvQkMsTUFEcEIsRUFDNEJHLE1BRDVCLEVBQ29DQyxNQURwQyxFQUM0Q0UsSUFENUMsRUFDa0RMLE9BQU9rQixHQUFQLENBQVdKLENBRDdEO0FBRUFqQyxXQUFHNEIsVUFBSCxDQUFjLFVBQUdXLDJCQUFqQixFQUNFLENBREYsRUFDS2pCLE1BREwsRUFDYUwsS0FEYixFQUNvQkMsTUFEcEIsRUFDNEJHLE1BRDVCLEVBQ29DQyxNQURwQyxFQUM0Q0UsSUFENUMsRUFDa0RMLE9BQU9rQixHQUFQLENBQVdGLENBRDdEO0FBRUQsT0FiRCxNQWFPO0FBQ0xuQyxXQUFHNEIsVUFBSCxDQUFjLFVBQUdDLDJCQUFqQixFQUNFLENBREYsRUFDS1AsTUFETCxFQUNhQSxNQURiLEVBQ3FCRSxJQURyQixFQUMyQkwsT0FBT1csR0FBUCxDQUFXQyxDQUR0QztBQUVBL0IsV0FBRzRCLFVBQUgsQ0FBYyxVQUFHSSwyQkFBakIsRUFDRSxDQURGLEVBQ0tWLE1BREwsRUFDYUEsTUFEYixFQUNxQkUsSUFEckIsRUFDMkJMLE9BQU9XLEdBQVAsQ0FBV0csQ0FEdEM7QUFFQWpDLFdBQUc0QixVQUFILENBQWMsVUFBR00sMkJBQWpCLEVBQ0UsQ0FERixFQUNLWixNQURMLEVBQ2FBLE1BRGIsRUFDcUJFLElBRHJCLEVBQzJCTCxPQUFPVyxHQUFQLENBQVdLLENBRHRDO0FBRUFuQyxXQUFHNEIsVUFBSCxDQUFjLFVBQUdRLDJCQUFqQixFQUNFLENBREYsRUFDS2QsTUFETCxFQUNhQSxNQURiLEVBQ3FCRSxJQURyQixFQUMyQkwsT0FBT2tCLEdBQVAsQ0FBV04sQ0FEdEM7QUFFQS9CLFdBQUc0QixVQUFILENBQWMsVUFBR1UsMkJBQWpCLEVBQ0UsQ0FERixFQUNLaEIsTUFETCxFQUNhQSxNQURiLEVBQ3FCRSxJQURyQixFQUMyQkwsT0FBT2tCLEdBQVAsQ0FBV0osQ0FEdEM7QUFFQWpDLFdBQUc0QixVQUFILENBQWMsVUFBR1csMkJBQWpCLEVBQ0UsQ0FERixFQUNLakIsTUFETCxFQUNhQSxNQURiLEVBQ3FCRSxJQURyQixFQUMyQkwsT0FBT2tCLEdBQVAsQ0FBV0YsQ0FEdEM7QUFFRDs7QUFFRCxXQUFLSyxNQUFMOztBQUVBLFVBQUlkLGNBQUosRUFBb0I7QUFDbEIsYUFBS0EsY0FBTDtBQUNEO0FBQ0QsYUFBTyxJQUFQO0FBQ0Q7Ozs7OztrQkFoRmtCM0IsVyIsImZpbGUiOiJ0ZXh0dXJlLWN1YmUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge0dMfSBmcm9tICcuL3dlYmdsJztcbmltcG9ydCB7YXNzZXJ0V2ViR0xDb250ZXh0fSBmcm9tICcuL3dlYmdsLWNoZWNrcyc7XG5pbXBvcnQgVGV4dHVyZSBmcm9tICcuL3RleHR1cmUnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBUZXh0dXJlQ3ViZSBleHRlbmRzIFRleHR1cmUge1xuXG4gIHN0YXRpYyBtYWtlRnJvbShnbCwgb2JqZWN0ID0ge30pIHtcbiAgICByZXR1cm4gb2JqZWN0IGluc3RhbmNlb2YgVGV4dHVyZUN1YmUgPyBvYmplY3QgOlxuICAgICAgLy8gVXNlIC5oYW5kbGUgKGUuZyBmcm9tIHN0YWNrLmdsJ3MgZ2wtYnVmZmVyKSwgZWxzZSB1c2UgYnVmZmVyIGRpcmVjdGx5XG4gICAgICBuZXcgVGV4dHVyZUN1YmUoZ2wsIHtoYW5kbGU6IG9iamVjdC5oYW5kbGUgfHwgb2JqZWN0fSk7XG4gIH1cblxuICBjb25zdHJ1Y3RvcihnbCwgb3B0cyA9IHt9KSB7XG4gICAgYXNzZXJ0V2ViR0xDb250ZXh0KGdsKTtcbiAgICBzdXBlcihnbCwgT2JqZWN0LmFzc2lnbih7fSwgb3B0cywge3RhcmdldDogR0wuVEVYVFVSRV9DVUJFX01BUH0pKTtcbiAgICB0aGlzLnNldEN1YmVNYXBJbWFnZURhdGEob3B0cyk7XG4gIH1cblxuICBiaW5kKHtpbmRleH0gPSB7fSkge1xuICAgIGNvbnN0IHtnbH0gPSB0aGlzO1xuICAgIGlmIChpbmRleCAhPT0gdW5kZWZpbmVkKSB7XG4gICAgICBnbC5hY3RpdmVUZXh0dXJlKEdMLlRFWFRVUkUwICsgaW5kZXgpO1xuICAgIH1cbiAgICBnbC5iaW5kVGV4dHVyZShHTC5URVhUVVJFX0NVQkVfTUFQLCB0aGlzLmhhbmRsZSk7XG4gICAgaWYgKGluZGV4ID09PSB1bmRlZmluZWQpIHtcbiAgICAgIGNvbnN0IHJlc3VsdCA9IGdsLmdldFBhcmFtZXRlcihnbC5BQ1RJVkVfVEVYVFVSRSkgLSBHTC5URVhUVVJFMDtcbiAgICAgIHJldHVybiByZXN1bHQ7XG4gICAgfVxuICAgIHJldHVybiBpbmRleDtcbiAgfVxuXG4gIHVuYmluZCgpIHtcbiAgICBjb25zdCB7Z2x9ID0gdGhpcztcbiAgICBnbC5iaW5kVGV4dHVyZShHTC5URVhUVVJFX0NVQkVfTUFQLCBudWxsKTtcbiAgfVxuXG4gIC8qIGVzbGludC1kaXNhYmxlIG1heC1zdGF0ZW1lbnRzLCBtYXgtbGVuICovXG4gIHNldEN1YmVNYXBJbWFnZURhdGEoe1xuICAgIHdpZHRoLFxuICAgIGhlaWdodCxcbiAgICBwaXhlbHMsXG4gICAgZGF0YSxcbiAgICBib3JkZXIgPSAwLFxuICAgIGZvcm1hdCA9IEdMLlJHQkEsXG4gICAgdHlwZSA9IEdMLlVOU0lHTkVEX0JZVEUsXG4gICAgZ2VuZXJhdGVNaXBtYXAgPSBmYWxzZVxuICB9KSB7XG4gICAgY29uc3Qge2dsfSA9IHRoaXM7XG4gICAgcGl4ZWxzID0gcGl4ZWxzIHx8IGRhdGE7XG4gICAgdGhpcy5iaW5kKCk7XG4gICAgaWYgKHRoaXMud2lkdGggfHwgdGhpcy5oZWlnaHQpIHtcbiAgICAgIGdsLnRleEltYWdlMkQoR0wuVEVYVFVSRV9DVUJFX01BUF9QT1NJVElWRV9YLFxuICAgICAgICAwLCBmb3JtYXQsIHdpZHRoLCBoZWlnaHQsIGJvcmRlciwgZm9ybWF0LCB0eXBlLCBwaXhlbHMucG9zLngpO1xuICAgICAgZ2wudGV4SW1hZ2UyRChHTC5URVhUVVJFX0NVQkVfTUFQX1BPU0lUSVZFX1ksXG4gICAgICAgIDAsIGZvcm1hdCwgd2lkdGgsIGhlaWdodCwgYm9yZGVyLCBmb3JtYXQsIHR5cGUsIHBpeGVscy5wb3MueSk7XG4gICAgICBnbC50ZXhJbWFnZTJEKEdMLlRFWFRVUkVfQ1VCRV9NQVBfUE9TSVRJVkVfWixcbiAgICAgICAgMCwgZm9ybWF0LCB3aWR0aCwgaGVpZ2h0LCBib3JkZXIsIGZvcm1hdCwgdHlwZSwgcGl4ZWxzLnBvcy56KTtcbiAgICAgIGdsLnRleEltYWdlMkQoR0wuVEVYVFVSRV9DVUJFX01BUF9ORUdBVElWRV9YLFxuICAgICAgICAwLCBmb3JtYXQsIHdpZHRoLCBoZWlnaHQsIGJvcmRlciwgZm9ybWF0LCB0eXBlLCBwaXhlbHMubmVnLngpO1xuICAgICAgZ2wudGV4SW1hZ2UyRChHTC5URVhUVVJFX0NVQkVfTUFQX05FR0FUSVZFX1ksXG4gICAgICAgIDAsIGZvcm1hdCwgd2lkdGgsIGhlaWdodCwgYm9yZGVyLCBmb3JtYXQsIHR5cGUsIHBpeGVscy5uZWcueSk7XG4gICAgICBnbC50ZXhJbWFnZTJEKEdMLlRFWFRVUkVfQ1VCRV9NQVBfTkVHQVRJVkVfWixcbiAgICAgICAgMCwgZm9ybWF0LCB3aWR0aCwgaGVpZ2h0LCBib3JkZXIsIGZvcm1hdCwgdHlwZSwgcGl4ZWxzLm5lZy56KTtcbiAgICB9IGVsc2Uge1xuICAgICAgZ2wudGV4SW1hZ2UyRChHTC5URVhUVVJFX0NVQkVfTUFQX1BPU0lUSVZFX1gsXG4gICAgICAgIDAsIGZvcm1hdCwgZm9ybWF0LCB0eXBlLCBwaXhlbHMucG9zLngpO1xuICAgICAgZ2wudGV4SW1hZ2UyRChHTC5URVhUVVJFX0NVQkVfTUFQX1BPU0lUSVZFX1ksXG4gICAgICAgIDAsIGZvcm1hdCwgZm9ybWF0LCB0eXBlLCBwaXhlbHMucG9zLnkpO1xuICAgICAgZ2wudGV4SW1hZ2UyRChHTC5URVhUVVJFX0NVQkVfTUFQX1BPU0lUSVZFX1osXG4gICAgICAgIDAsIGZvcm1hdCwgZm9ybWF0LCB0eXBlLCBwaXhlbHMucG9zLnopO1xuICAgICAgZ2wudGV4SW1hZ2UyRChHTC5URVhUVVJFX0NVQkVfTUFQX05FR0FUSVZFX1gsXG4gICAgICAgIDAsIGZvcm1hdCwgZm9ybWF0LCB0eXBlLCBwaXhlbHMubmVnLngpO1xuICAgICAgZ2wudGV4SW1hZ2UyRChHTC5URVhUVVJFX0NVQkVfTUFQX05FR0FUSVZFX1ksXG4gICAgICAgIDAsIGZvcm1hdCwgZm9ybWF0LCB0eXBlLCBwaXhlbHMubmVnLnkpO1xuICAgICAgZ2wudGV4SW1hZ2UyRChHTC5URVhUVVJFX0NVQkVfTUFQX05FR0FUSVZFX1osXG4gICAgICAgIDAsIGZvcm1hdCwgZm9ybWF0LCB0eXBlLCBwaXhlbHMubmVnLnopO1xuICAgIH1cblxuICAgIHRoaXMudW5iaW5kKCk7XG5cbiAgICBpZiAoZ2VuZXJhdGVNaXBtYXApIHtcbiAgICAgIHRoaXMuZ2VuZXJhdGVNaXBtYXAoKTtcbiAgICB9XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cbn1cbiJdfQ==

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // WebGL2 VertexArray Objects Helper
	
	
	var _webglChecks = __webpack_require__(37);
	
	var _queryManager = __webpack_require__(482);
	
	var _queryManager2 = _interopRequireDefault(_queryManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable no-multi-spaces */
	var GL_QUERY_COUNTER_BITS_EXT = 0x8864;
	var GL_QUERY_RESULT_EXT = 0x8866;
	var GL_QUERY_RESULT_AVAILABLE_EXT = 0x8867;
	var GL_TIME_ELAPSED_EXT = 0x88BF;
	var GL_TIMESTAMP_EXT = 0x8E28;
	var GL_GPU_DISJOINT_EXT = 0x8FBB;
	/* eslint-enable no-multi-spaces */
	
	var noop = function noop(x) {
	  return x;
	};
	
	var ERR_GPU_DISJOINT = 'Disjoint GPU operation invalidated timer queries';
	var ERR_TIMER_QUERY_NOT_SUPPORTED = 'Timer queries require "EXT_disjoint_timer_query" extension';
	
	var TimerQuery = function () {
	  _createClass(TimerQuery, null, [{
	    key: 'isSupported',
	
	    /**
	     * Returns true if TimerQuery is supported by the WebGL implementation
	     * (depends on the EXT_disjoint_timer_query extension)/
	     * Can also check whether timestamp queries are available.
	     *
	     * @param {WebGLRenderingContext} gl - gl context
	     * @param {Object} opts= - options
	     * @param {Object} opts.requireTimestamps=false -
	     *   If true, checks if timestamps are supported
	     * @return {Boolean} - TimerQueries are supported with specified configuration
	     */
	    value: function isSupported(gl) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref$requireTimestamp = _ref.requireTimestamps,
	          requireTimestamps = _ref$requireTimestamp === undefined ? false : _ref$requireTimestamp;
	
	      (0, _webglChecks.assertWebGLContext)(gl);
	      var ext = gl.getExtension('EXT_disjoint_timer_query');
	      var queryCounterBits = ext ? ext.getQueryEXT(GL_TIMESTAMP_EXT, GL_QUERY_COUNTER_BITS_EXT) : 0;
	      var timestampsSupported = queryCounterBits > 0;
	      return Boolean(ext) && (!requireTimestamps || timestampsSupported);
	    }
	
	    /**
	     * @classdesc
	     * Provides a way to measure the duration of a set of GL commands,
	     * without stalling the rendering pipeline.
	     *
	     * Exposes a `promise` member that tracks the state of the query
	     * when `poll` is used to update queries.
	     *
	     * @example
	        const timerQuery = new TimerQuery({
	          onComplete: timestamp => console.log(timestamp)
	          onError: error => console.warn(error)
	        });
	         timerQuery.begin();
	         // Issue GPU calls
	         timerQuery.end();
	         // Poll for resolved queries
	        requestAnimationFrame(() => TimerQuery.poll(gl))
	     *
	     * Remarks:
	     * - On Chrome, go to chrome:flags and enable "WebGL Draft Extensions"
	     *
	     * - For full functionality, TimerQuery depends on a `poll` function being
	     *   called regularly. When this is done, completed queries will be
	     *   automatically detected and any callbacks called.
	     *
	     * - TimerQuery instance creation will always succeed, even when the required
	     *   extension is not supported. Instead any issued queries will fail
	     *   immediately. This allows applications to unconditionally use TimerQueries
	     *   without adding logic to check whether they are supported; the
	     *   difference being that the `onComplete` callback never gets called,
	     *   (the `onError` callback, if supplied, will be called instead).
	     *
	     * - Even when supported, timer queries can fail whenever a change in the
	     *   GPU occurs that will make the values returned by this extension unusable
	     *   for performance metrics. Power conservation might cause the GPU to go to
	     *   sleep at the lower levers. TimerQuery will detect this condition and
	     *   fail any outstanding queries (which calls the `onError` function,
	     *   if supplied).
	     *
	     * @class
	     * @param {WebGLRenderingContext} gl - gl context
	     * @param {Object} opts - options
	     * @param {Function} opts.onComplete - called with a timestamp.
	     *   Specifying this parameter causes a timestamp query to be initiated
	     * @param {Function} opts.onComplete - called with a timestamp.
	     *   Specifying this parameter causes a timestamp query to be initiated
	     */
	
	  }]);
	
	  function TimerQuery(gl) {
	    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref2$onComplete = _ref2.onComplete,
	        onComplete = _ref2$onComplete === undefined ? noop : _ref2$onComplete,
	        _ref2$onError = _ref2.onError,
	        onError = _ref2$onError === undefined ? noop : _ref2$onError;
	
	    _classCallCheck(this, TimerQuery);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	
	    this.gl = gl;
	    this.ext = this.gl.getExtension('EXT_disjoint_timer_query');
	    this.handle = this.ext ? this.ext.createQueryEXT() : null;
	    this.target = null;
	    this.userData = {};
	
	    this.onComplete = onComplete;
	    this.onError = onError;
	
	    // query manager needs a promise field
	    this.promise = null;
	
	    Object.seal(this);
	  }
	
	  /**
	   * Destroys the WebGL object
	   * Rejects any pending query
	   *
	   * @return {TimerQuery} - returns itself, to enable chaining of calls.
	   */
	
	
	  _createClass(TimerQuery, [{
	    key: 'delete',
	    value: function _delete() {
	      if (this.handle) {
	        _queryManager2.default.deleteQuery(this);
	        this.ext.deleteQueryEXT(this.handle);
	        (0, _webglChecks.glCheckError)(this.gl);
	        this.handle = null;
	      }
	      return this;
	    }
	
	    /**
	     * Measures GPU time delta between this call and a matching `end` call in the
	     * GPU instruction stream.
	     *
	     * Remarks:
	     * - Due to OpenGL API limitations, after calling `begin()` on one TimerQuery
	     *   instance, `end()` must be called on that same instance before
	     *   calling `begin()` on another query. While there can be multiple
	     *   outstanding queries representing disjoint `begin()`/`end()` intervals.
	     *   It is not possible to interleave or overlap `begin` and `end` calls.
	     *
	     * - Triggering a new query when a TimerQuery is already tracking an
	     *   unresolved query causes that query to be cancelled.
	     *
	     * @return {TimerQuery} - returns itself, to enable chaining of calls.
	     */
	
	  }, {
	    key: 'begin',
	    value: function begin() {
	      _queryManager2.default.beginQuery(this, this.onComplete, this.onError);
	      if (this.ext) {
	        this.target = GL_TIME_ELAPSED_EXT;
	        this.ext.beginQueryEXT(this.target, this.handle);
	      } else {
	        _queryManager2.default.rejectQuery(this, ERR_TIMER_QUERY_NOT_SUPPORTED);
	      }
	      return this;
	    }
	
	    /**
	     * Inserts a query end marker into the GPU instruction stream.
	     * Can be called multiple times.
	     *
	     * @return {TimerQuery} - returns itself, to enable chaining of calls.
	     */
	
	  }, {
	    key: 'end',
	    value: function end() {
	      // Note: calling end does not affect the pending promise
	      if (this.target) {
	        this.ext.endQueryEXT(this.target);
	        this.target = null;
	      }
	      return this;
	    }
	
	    /**
	     * Generates a GPU time stamp when the GPU instruction stream reaches
	     * this instruction.
	     * To measure time deltas, two queries are needed.
	     *
	     * Remarks:
	     * - timestamp() queries may not be available even when the timer query
	     *   extension is. See TimeQuery.isSupported() flags.
	     *
	     * - Triggering a new query when a TimerQuery is already tracking an
	     *   unresolved query causes that query to be cancelled.
	     *
	     * @return {TimerQuery} - returns itself, to enable chaining of calls.
	     */
	
	  }, {
	    key: 'timestamp',
	    value: function timestamp() {
	      _queryManager2.default.beginQuery(this, this.onComplete, this.onError);
	      if (this.ext) {
	        this.ext.queryCounterEXT(this.handle, GL_TIMESTAMP_EXT);
	      } else {
	        _queryManager2.default.rejectQuery(this, ERR_TIMER_QUERY_NOT_SUPPORTED);
	      }
	      return this;
	    }
	
	    /**
	     * Cancels a pending query
	     * Note - Cancel's the promise and calls end on the current query if needed.
	     *
	     * @return {TimerQuery} - returns itself, to enable chaining of calls.
	     */
	
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.end();
	      _queryManager2.default.cancelQuery(this);
	      return this;
	    }
	
	    /**
	     * @return {Boolean} - true if query result is available
	     */
	
	  }, {
	    key: 'isResultAvailable',
	    value: function isResultAvailable() {
	      return this.ext && this.ext.getQueryObjectEXT(this.handle, GL_QUERY_RESULT_AVAILABLE_EXT);
	    }
	
	    /**
	     * Returns the query result, converted to milliseconds to match
	     * JavaScript conventions.
	     *
	     * @return {Number} - measured time or timestamp, in milliseconds
	     */
	
	  }, {
	    key: 'getResult',
	    value: function getResult() {
	      return this.ext ? this.ext.getQueryObjectEXT(this.handle, GL_QUERY_RESULT_EXT) / 1e6 : 0;
	    }
	  }]);
	
	  return TimerQuery;
	}();
	
	// NOTE: This call lets the queryManager know how to detect disjoint GPU state
	// It will check dsjoint state on polls and before adding a new query
	// and reject any outstanding TimerQueries with our supplied error message.
	
	
	exports.default = TimerQuery;
	_queryManager2.default.setInvalidator({
	  queryType: TimerQuery,
	  errorMessage: ERR_GPU_DISJOINT,
	  // Note: Querying the disjoint state resets it
	  checkInvalid: function checkInvalid(gl) {
	    return gl.getParameter(GL_GPU_DISJOINT_EXT);
	  }
	});
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UNIFORM_BASE_DESCRIP;
	
	exports.parseUniformName = parseUniformName;
	exports.getUniformSetter = getUniformSetter;
	exports.checkUniformValues = checkUniformValues;
	exports.getUniformsTable = getUniformsTable;
	
	var _webgl = __webpack_require__(58);
	
	var _texture = __webpack_require__(217);
	
	var _texture2 = _interopRequireDefault(_texture);
	
	var _utils = __webpack_require__(30);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// TODO - use tables to reduce complexity of method below
	/* eslint-disable max-len */
	var UNIFORM_BASE_DESCRIPTORS = (_UNIFORM_BASE_DESCRIP = {}, _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.FLOAT, { function: 'uniform1f', type: Float32Array }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.INT, { function: 'uniform1i', type: Uint16Array }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.BOOL, { function: 'uniform1i', type: Uint16Array }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.FLOAT_VEC2, { function: 'uniform2fv', type: Float32Array, elements: 2 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.FLOAT_VEC3, { function: 'uniform3fv', type: Float32Array, elements: 3 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.FLOAT_VEC4, { function: 'uniform4fv', type: Float32Array, elements: 4 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.INT_VEC2, { function: 'uniform2iv', type: Uint16Array, elements: 2 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.INT_VEC3, { function: 'uniform3iv', type: Uint16Array, elements: 3 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.INT_VEC4, { function: 'uniform4iv', type: Uint16Array, elements: 4 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.BOOL_VEC2, { function: 'uniform2iv', type: Uint16Array, elements: 2 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.BOOL_VEC3, { function: 'uniform3fv', type: Uint16Array, elements: 3 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.BOOL_VEC4, { function: 'uniform4iv', type: Uint16Array, elements: 4 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.FLOAT_MAT2, { function: 'uniformMatrix2fv', type: Float32Array, matrix: true, elements: 4 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.FLOAT_MAT3, { mfunction: 'uniformMatrix3fv', type: Float32Array, matrix: true, elements: 9 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.FLOAT_MAT4, { function: 'uniformMatrix4fv', type: Float32Array, matrix: true, elements: 16 }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.SAMPLER_2D, { function: 'uniform1i', type: Uint16Array, texture: true }), _defineProperty(_UNIFORM_BASE_DESCRIP, _webgl.GL.SAMPLER_CUBE, { function: 'uniform1i', type: Uint16Array, texture: true }), _UNIFORM_BASE_DESCRIP);
	/* eslint-enable max-len */
	
	function parseUniformName(name) {
	  // name = name[name.length - 1] === ']' ?
	  // name.substr(0, name.length - 3) : name;
	
	  // if array name then clean the array brackets
	  var UNIFORM_NAME_REGEXP = /([^\[]*)(\[[0-9]+\])?/;
	  var matches = name.match(UNIFORM_NAME_REGEXP);
	  if (!matches || matches.length < 2) {
	    throw new Error('Failed to parse GLSL uniform name ' + name);
	  }
	
	  return {
	    name: matches[1],
	    length: matches[2] || 1,
	    isArray: Boolean(matches[2])
	  };
	}
	
	// Returns a Magic Uniform Setter
	/* eslint-disable complexity */
	function getUniformSetter(gl, location, info) {
	  var descriptor = UNIFORM_BASE_DESCRIPTORS[info.type];
	  if (!descriptor) {
	    throw new Error('Unknown GLSL uniform type ' + info.type);
	  }
	
	  var glFunction = gl[descriptor.function].bind(gl);
	  var TypedArray = descriptor.type;
	
	  // How many data elements does app need to provide
	  var flatArrayLength = info.size * (descriptor.elements || 1);
	
	  // console.log('getSetter', location, info, flatArrayLength);
	
	  // Set a uniform array
	  var setter = void 0;
	  if (flatArrayLength > 1) {
	    setter = function setter(val) {
	      if (!(val instanceof TypedArray)) {
	        var typedArray = new TypedArray(flatArrayLength);
	        typedArray.set(val);
	        val = typedArray;
	      }
	      (0, _assert2.default)(val.length === flatArrayLength);
	      if (descriptor.matrix) {
	        // Second param: whether to transpose the matrix. Must be false.
	        glFunction(location, false, val);
	      } else {
	        glFunction(location, val);
	      }
	    };
	  } else {
	    setter = function setter(val) {
	      return glFunction(location, val);
	    };
	  }
	
	  // Set a primitive-valued uniform
	  return setter;
	}
	
	// Basic checks of uniform values without knowledge of program
	// To facilitate early detection of e.g. undefined values in JavaScript
	function checkUniformValues(uniforms, source) {
	  for (var uniformName in uniforms) {
	    var value = uniforms[uniformName];
	    if (!checkUniformValue(value)) {
	      // Add space to source
	      source = source ? source + ' ' : '';
	      /* eslint-disable no-console */
	      /* global console */
	      // Value could be unprintable so write the object on console
	      console.error(source + ' Bad uniform ' + uniformName, value);
	      /* eslint-enable no-console */
	      throw new Error(source + ' Bad uniform ' + uniformName);
	    }
	  }
	  return true;
	}
	
	function checkUniformValue(value) {
	  var ok = true;
	
	  // Test for texture (for sampler uniforms)
	  // WebGL2: if (value instanceof Texture || value instanceof Sampler) {
	  if (value instanceof _texture2.default) {
	    ok = true;
	    // Check that every element in array is a number, and at least 1 element
	  } else if (Array.isArray(value)) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var element = _step.value;
	
	        if (!isFinite(element)) {
	          ok = false;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    ok = ok && value.length > 0;
	    // Typed arrays can only contain numbers, but check length
	  } else if (ArrayBuffer.isView(value)) {
	    ok = value.length > 0;
	    // Check that single value is a number
	  } else if (!isFinite(value)) {
	    ok = false;
	  }
	
	  return ok;
	}
	
	// Prepares a table suitable for console.table
	/* eslint-disable max-statements */
	function getUniformsTable() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$header = _ref.header,
	      header = _ref$header === undefined ? 'Uniforms' : _ref$header,
	      program = _ref.program,
	      uniforms = _ref.uniforms;
	
	  (0, _assert2.default)(program);
	
	  var uniformLocations = program._uniformSetters;
	  var table = _defineProperty({}, header, {});
	
	  // Add program's provided uniforms
	  for (var uniformName in uniformLocations) {
	    var uniform = uniforms[uniformName];
	    if (uniform !== undefined) {
	      table[uniformName] = {
	        Type: uniform,
	        Value: (0, _utils.formatValue)(uniform)
	      };
	    }
	  }
	
	  // Add program's unprovided uniforms
	  for (var _uniformName in uniformLocations) {
	    var _uniform = uniforms[_uniformName];
	    if (_uniform === undefined) {
	      table[_uniformName] = {
	        Type: 'NOT PROVIDED',
	        Value: 'N/A'
	      };
	    }
	  }
	
	  var unusedTable = {};
	  var unusedCount = 0;
	
	  // List any unused uniforms
	  for (var _uniformName2 in uniforms) {
	    var _uniform2 = uniforms[_uniformName2];
	    if (!table[_uniformName2]) {
	      unusedCount++;
	      unusedTable[_uniformName2] = {
	        Type: 'NOT USED: ' + _uniform2,
	        Value: (0, _utils.formatValue)(_uniform2)
	      };
	    }
	  }
	
	  return { table: table, unusedTable: unusedTable, unusedCount: unusedCount };
	}
	
	/*
	  if (vector) {
	    switch (type) {
	    case GL.FLOAT:
	      glFunction = gl.uniform1f;
	      break;
	    case GL.FLOAT_VEC2:
	      glFunction = gl.uniform2fv;
	      TypedArray = isArray ? Float32Array : new Float32Array(2);
	      break;
	    case GL.FLOAT_VEC3:
	      glFunction = gl.uniform3fv;
	      TypedArray = isArray ? Float32Array : new Float32Array(3);
	      break;
	    case GL.FLOAT_VEC4:
	      glFunction = gl.uniform4fv;
	      TypedArray = isArray ? Float32Array : new Float32Array(4);
	      break;
	    case GL.INT:
	    case GL.BOOL:
	    case GL.SAMPLER_2D:
	    case GL.SAMPLER_CUBE:
	      glFunction = gl.uniform1i;
	      break;
	    case GL.INT_VEC2:
	    case GL.BOOL_VEC2:
	      glFunction = gl.uniform2iv;
	      TypedArray = isArray ? Uint16Array : new Uint16Array(2);
	      break;
	    case GL.INT_VEC3:
	    case GL.BOOL_VEC3:
	      glFunction = gl.uniform3iv;
	      TypedArray = isArray ? Uint16Array : new Uint16Array(3);
	      break;
	    case GL.INT_VEC4:
	    case GL.BOOL_VEC4:
	      glFunction = gl.uniform4iv;
	      TypedArray = isArray ? Uint16Array : new Uint16Array(4);
	      break;
	    case GL.FLOAT_MAT2:
	      matrix = true;
	      glFunction = gl.uniformMatrix2fv;
	      break;
	    case GL.FLOAT_MAT3:
	      matrix = true;
	      glFunction = gl.uniformMatrix3fv;
	      break;
	    case GL.FLOAT_MAT4:
	      matrix = true;
	      glFunction = gl.uniformMatrix4fv;
	      break;
	    default:
	      break;
	    }
	  }
	*/
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // WebGL2 VertexArray Objects Helper
	
	
	exports.isVertexArray = isVertexArray;
	
	var _webglTypes = __webpack_require__(218);
	
	var _webglChecks = __webpack_require__(37);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable camelcase */
	var OES_vertex_array_object = 'OES_vertex_array_object';
	
	var VertexArrayObject = function () {
	  _createClass(VertexArrayObject, null, [{
	    key: 'isSupported',
	
	
	    // Returns true if VertexArrayObject is supported by implementation
	    value: function isSupported(gl) {
	      (0, _webglChecks.assertWebGLContext)(gl);
	      return gl instanceof _webglTypes.WebGL2RenderingContext || gl.getExtension('OES_vertex_array_object');
	    }
	
	    // Wraps a WebGLVertexArrayObject in a VertexArrayObject
	
	  }, {
	    key: 'wrap',
	    value: function wrap(gl, object) {
	      return object instanceof VertexArrayObject ? object : new VertexArrayObject(gl, { handle: object.handle || object });
	    }
	
	    // Create a VertexArrayObject
	
	  }]);
	
	  function VertexArrayObject(gl) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        handle = _ref.handle;
	
	    _classCallCheck(this, VertexArrayObject);
	
	    (0, _webglChecks.assertWebGLContext)(gl);
	    (0, _assert2.default)(VertexArrayObject.isSupported(gl), 'VertexArrayObject: WebGL2 or OES_vertex_array_object required');
	
	    handle = handle || createVertexArray(gl);
	    // TODO isVertexArray fails when using extension for some reason
	    // if (!isVertexArray(gl, handle)) {
	    if (!handle) {
	      throw new Error('Could not create VertexArrayObject');
	    }
	
	    this.gl = gl;
	    this.handle = handle;
	    this.userData = {};
	    Object.seal(this);
	  }
	
	  _createClass(VertexArrayObject, [{
	    key: 'delete',
	    value: function _delete() {
	      deleteVertexArray(this.gl, this.handle);
	      return this;
	    }
	  }, {
	    key: 'bind',
	    value: function bind() {
	      bindVertexArray(this.gl, this.handle);
	      return this;
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind() {
	      bindVertexArray(this.gl, null);
	      return this;
	    }
	  }]);
	
	  return VertexArrayObject;
	}();
	
	exports.default = VertexArrayObject;
	
	
	function createVertexArray(gl) {
	  if (gl instanceof _webglTypes.WebGL2RenderingContext) {
	    return gl.createVertexArray();
	  }
	  var ext = gl.getExtension(OES_vertex_array_object);
	  if (ext) {
	    return ext.createVertexArrayOES();
	  }
	  return null;
	}
	
	function deleteVertexArray(gl, vertexArray) {
	  if (gl instanceof _webglTypes.WebGL2RenderingContext) {
	    gl.deleteVertexArray(vertexArray);
	  }
	  var ext = gl.getExtension(OES_vertex_array_object);
	  if (ext) {
	    ext.deleteVertexArrayOES(vertexArray);
	  }
	}
	
	function isVertexArray(gl, vertexArray) {
	  if (gl instanceof _webglTypes.WebGL2RenderingContext) {
	    return gl.isVertexArray(vertexArray);
	  }
	  var ext = gl.getExtension(OES_vertex_array_object);
	  if (ext) {
	    return ext.isVertexArrayOES(vertexArray);
	  }
	  return false;
	}
	
	function bindVertexArray(gl, vertexArray) {
	  if (gl instanceof _webglTypes.WebGL2RenderingContext) {
	    gl.bindVertexArray(vertexArray);
	  }
	  var ext = gl.getExtension(OES_vertex_array_object);
	  if (ext) {
	    ext.bindVertexArrayOES(vertexArray);
	  }
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMaxAttributes = getMaxAttributes;
	exports.hasDivisor = hasDivisor;
	exports.isEnabled = isEnabled;
	exports.getBuffer = getBuffer;
	exports.getGeneric = getGeneric;
	exports.getSize = getSize;
	exports.getType = getType;
	exports.isNormalized = isNormalized;
	exports.isInteger = isInteger;
	exports.getStride = getStride;
	exports.getOffset = getOffset;
	exports.enable = enable;
	exports.disable = disable;
	exports.setDivisor = setDivisor;
	exports.getDivisor = getDivisor;
	exports.setBuffer = setBuffer;
	exports.setGeneric = setGeneric;
	exports.setGenericValues = setGenericValues;
	
	var _webgl = __webpack_require__(58);
	
	var _webglChecks = __webpack_require__(37);
	
	var _buffer = __webpack_require__(161);
	
	var _buffer2 = _interopRequireDefault(_buffer);
	
	var _utils = __webpack_require__(30);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Methods for manipulating the vertex attributes array, which is where
	 * vertex data is staged for shader execution.
	 *
	 * Vertex attributes are stored in "arrays" with indices from 0 and up.
	 * During shader execution, these indices (or 'locations') are matched to
	 * the indices assigned to shader attributes during WebGLProgram linking.
	 *
	 * Note: The global state contains an implicit vertex attribute array which
	 * the methods in this class manipulate by default. It is also possible to
	 * create and bind a VertexArrayObject to manage multiple arrays.
	 *
	 * Each vertex attribute has these properties:
	 * - Can be enabled or disabled (Only enable attrs actually used by a program)
	 * - Has an instance `divisor` (usually 1 or 0 to enable/disable instancing)
	 * - Have a size (1-4 values per vertex)
	 * - Has a value or values that is accessible in shaders
	 *
	 * Attribute values are either
	 * - Generic: a constant value for all vertices/instances, or
	 * - Bound to a WebGLBuffer with unique values for each vertex/instance
	 *
	 * When binding to a WebGLBuffer it is necessary to specify the layout of
	 * data in the buffer:
	 * - size (1-4 values per vertex)
	 * - data type (e.g. gl.FLOAT)
	 * - stride, offset, and integer normalization policy can also be specified
	 *
	 * Note: All methods in this class take a `location` index to specify which
	 * vertex attribute in the array they are operating on.
	 *
	 * Note: Attribute 0 can sometimes be treated specially by the driver,
	 * to be safe we avoid disabling it.
	 *
	 * Note: WebGL2
	 * - Improves support for integer attributes, both generic and buffered.
	 * - Setting instance "divisors" no longer require using a WebGL extension.
	 *
	 */
	
	function glGetLumaInfo(gl) {
	  if (!gl.luma) {
	    gl.luma = { extensions: {} };
	  }
	  if (gl.luma.extensions['ANGLE_instanced_arrays'] === undefined) {
	    gl.luma.extensions['ANGLE_instanced_arrays'] = gl.getExtension('ANGLE_instanced_arrays');
	  }
	  return gl.luma;
	}
	
	// ACCESSORS
	
	/**
	 * The max number of attributes in the vertex attribute array is an
	 * implementation defined limit, but never smaller than 8
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @returns {GLuint} - (max) number of attributes in the vertex attribute array
	 */
	/* eslint-disable dot-notation*/
	function getMaxAttributes(gl) {
	  (0, _webglChecks.assertWebGLContext)(gl);
	  return gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
	}
	
	/**
	 * Is instance divisor availble (checks for WebGL2 or ANGLE extension)
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @returns {Boolean} - is divisor available?
	 */
	function hasDivisor(gl) {
	  (0, _webglChecks.assertWebGLContext)(gl);
	  return Boolean((0, _webglChecks.isWebGL2Context)(gl) || gl.getExtension(gl, 'ANGLE_instanced_arrays'));
	}
	
	/**
	 * Returns true if the vertex attribute is enabled at this index.
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 * @returns {Boolean} - enabled status
	 */
	function isEnabled(gl, location) {
	  return Boolean(get(gl, location, gl.VERTEX_ATTRIB_ARRAY_ENABLED));
	}
	
	/**
	 * Returns the currently bound buffer
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 * @returns {WebGLBuffer} Returns the currently bound buffer
	 */
	function getBuffer(gl, location) {
	  return get(gl, location, gl.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING);
	}
	
	/**
	 * Get values for generic vertex attributes
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 * @returns {Float32Array} (with 4 elements) representing the current value
	 * of the vertex attribute at the given index.
	 */
	function getGeneric(gl, location) {
	  return get(gl, gl.CURRENT_VERTEX_ATTRIB);
	}
	
	/**
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 */
	// @returns {GLint} the size of an element of the vertex array.
	function getSize(gl, location) {
	  return get(location, gl.VERTEX_ATTRIB_ARRAY_SIZE);
	}
	
	/**
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 */
	// @returns {GLenum} representing the array type.
	function getType(gl, location) {
	  return get(location, gl.VERTEX_ATTRIB_ARRAY_TYPE);
	}
	
	/**
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 */
	// @returns {GLboolean} true if fixed-point data types are normalized
	// for the vertex attribute array at the given index.
	function isNormalized(gl, location) {
	  return get(location, gl.VERTEX_ATTRIB_ARRAY_NORMALIZED);
	}
	
	/**
	 * check if an integer data type in the vertex attribute at index
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - index of the vertex attribute.
	 * @returns {GLboolean} - true if an integer data type is in the
	 * vertex attribute array at the given index.
	 */
	function isInteger(gl, location) {
	  (0, _webglChecks.assertWebGL2Context)(gl);
	  return get(location, gl.VERTEX_ATTRIB_ARRAY_INTEGER);
	}
	
	/**
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 * @returns {GLint} number of bytes between successive elements in the array.
	 * 0 means that the elements are sequential.
	 */
	function getStride(gl, location) {
	  return get(location, gl.VERTEX_ATTRIB_ARRAY_STRIDE);
	}
	
	/**
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 * @param {GLuint} pname - enum specifying which offset to return
	 * @returns {GLuint} the address of a specified vertex attribute.
	 */
	function getOffset(gl, location) {
	  var pname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : gl.VERTEX_ATTRIB_ARRAY_POINTER;
	
	  return gl.getVertexAttribOffset(location, pname);
	}
	
	/**
	 * @private
	 * Generic getter for information about a vertex attribute at a given position
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - index of the vertex attribute.
	 * @param {GLenum} pname - specifies the information to query.
	 * @returns {*} - requested vertex attribute information (specified by pname)
	 */
	function get(gl, location, pname) {
	  (0, _webglChecks.assertWebGLContext)(gl);
	  return gl.getVertexAttrib(location, pname);
	}
	
	// MODIFIERS
	
	/**
	 * Enable the attribute
	 * Note: By default all attributes are disabled. Only attributes
	 * used by a program's shaders should be enabled.
	 *
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 */
	function enable(gl, location) {
	  gl.enableVertexAttribArray(location);
	}
	
	/**
	 * Disable the attribute
	 * Note: Only attributes used by a program's shaders should be enabled.
	 *
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 */
	function disable(gl, location) {
	  // Don't disable location 0
	  if (location > 0) {
	    gl.disableVertexAttribArray(location);
	  }
	}
	
	/**
	 * Set the frequency divisor used for instanced rendering.
	 * Note: Usually simply set to 1 or 0 to enable/disable instanced rendering
	 * for a specific attribute.
	 *
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 * @param {GLuint} divisor - instances that pass between updates of attribute
	 */
	function setDivisor(gl, location, divisor) {
	  if ((0, _webglChecks.isWebGL2Context)(gl)) {
	    gl.vertexAttribDivisor(location, divisor);
	    return;
	  }
	  var ext = glGetLumaInfo(gl).extensions['ANGLE_instanced_arrays'];
	  if (ext) {
	    ext.vertexAttribDivisorANGLE(location, divisor);
	    return;
	  }
	  // Accept divisor 0 even if instancing is not supported (0 = no instancing)
	  if (divisor !== 0) {
	    throw new Error('WebGL instanced rendering not supported');
	  }
	}
	
	/**
	 * Returns the frequency divisor used for instanced rendering.
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 * @returns {GLuint} divisor
	 */
	function getDivisor(gl, location) {
	  (0, _assert2.default)(location > 0);
	  if ((0, _webglChecks.isWebGL2Context)(gl)) {
	    var divisor = get(location, gl.VERTEX_ATTRIB_ARRAY_DIVISOR);
	    return divisor;
	  }
	  var ext = glGetLumaInfo(gl).extensions['ANGLE_instanced_arrays'];
	  if (ext) {
	    var _divisor = get(location, ext.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE);
	    return _divisor;
	  }
	  // if instancing is not available, return 0 meaning divisor has not been set
	  return 0;
	}
	
	/**
	 * Set a location in vertex attributes array to a buffer, specifying
	 * its data layout and integer to float conversion and normalization flags
	 *
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 * @param {WebGLBuffer|Buffer} buffer - WebGL buffer to set as value
	 * @param {GLuint} target=gl.ARRAY_BUFFER - which target to bind to
	 * @param {Object} layout= Optional data layout, defaults to buffer's layout
	 * @param {GLuint} layout.size - number of values per element (1-4)
	 * @param {GLuint} layout.type - type of values (e.g. gl.FLOAT)
	 * @param {GLbool} layout.normalized=false - normalize integers to [-1,1], [0,1]
	 * @param {GLuint} layout.integer=false - WebGL2 only, disable int-to-float conv
	 * @param {GLuint} layout.stride=0 - supports strided arrays
	 * @param {GLuint} layout.offset=0 - supports strided arrays
	 */
	function setBuffer() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      gl = _ref.gl,
	      location = _ref.location,
	      buffer = _ref.buffer,
	      target = _ref.target,
	      layout = _ref.layout;
	
	  (0, _webglChecks.assertWebGLContext)(gl);
	  buffer = _buffer2.default.makeFrom(gl, buffer);
	
	  // Copy main data characteristics from buffer
	  target = (0, _webgl.glGet)(target !== undefined ? target : buffer.target);
	  layout = layout !== undefined ? layout : buffer.layout;
	  (0, _assert2.default)(target, 'setBuffer needs target');
	  (0, _assert2.default)(layout, 'setBuffer called on uninitialized buffer');
	
	  // a non-zero named buffer object must be bound to the GL_ARRAY_BUFFER target
	  buffer.bind({ target: gl.ARRAY_BUFFER });
	
	  // Attach bound ARRAY_BUFFER with specified buffer format to location
	  if (!layout.integer) {
	    gl.vertexAttribPointer(location, layout.size, (0, _webgl.glGet)(layout.type), layout.normalized, layout.stride, layout.offset);
	  } else {
	    // specifies *integer* data formats and locations of vertex attributes
	    // For glVertexAttribIPointer, Values are always left as integer values.
	    // Only accepts the integer types gl.BYTE, gl.UNSIGNED_BYTE,
	    // gl.SHORT, gl.UNSIGNED_SHORT, gl.INT, gl.UNSIGNED_INT
	    (0, _webglChecks.assertWebGL2Context)(gl);
	    gl.vertexAttribIPointer(location, layout.size, (0, _webgl.glGet)(layout.type), layout.stride, layout.offset);
	  }
	
	  buffer.unbind({ target: gl.ARRAY_BUFFER });
	}
	
	/*
	 * Specify values for generic vertex attributes
	 * Generic vertex attributes are constant for all vertices
	 * Up to 4 values depending on attribute size
	 *
	 * @param {WebGLRenderingContext} gl - webgl context
	 * @param {GLuint} location - ordinal number of the attribute
	 * @param {GLuint} divisor - instances that pass between updates of attribute
	 */
	function setGeneric(_ref2) {
	  var gl = _ref2.gl,
	      location = _ref2.location,
	      array = _ref2.array;
	
	  _utils.log.warn(0, 'VertexAttributes.setGeneric is not well tested');
	  // throw new Error('vertex attribute size must be between 1 and 4');
	
	  if (array instanceof Float32Array) {
	    gl.vertexAttrib4fv(location, array);
	  } else if (array instanceof Int32Array) {
	    (0, _webglChecks.assertWebGL2Context)(gl);
	    gl.vertexAttribI4iv(location, array);
	  } else if (array instanceof Uint32Array) {
	    (0, _webglChecks.assertWebGL2Context)(gl);
	    gl.vertexAttribI4uiv(location, array);
	  }
	}
	
	/*
	 * Specify values for generic vertex attributes
	 * Generic vertex attributes are constant for all vertices
	 * Up to 4 values depending on attribute size
	 *
	 * @param {GLuint} location - ordinal number of the attribute
	 * @param {GLuint} divisor - instances that pass between updates of attribute
	 */
	/* eslint-disable max-params */
	function setGenericValues(gl, location, v0, v1, v2, v3) {
	  _utils.log.warn(0, 'VertexAttributes.setGenericValues is not well tested');
	  switch (arguments.length - 1) {
	    case 1:
	      gl.vertexAttrib1f(location, v0);break;
	    case 2:
	      gl.vertexAttrib2f(location, v0, v1);break;
	    case 3:
	      gl.vertexAttrib3f(location, v0, v1, v2);break;
	    case 4:
	      gl.vertexAttrib4f(location, v0, v1, v2, v3);break;
	    default:
	      throw new Error('vertex attribute size must be between 1 and 4');
	  }
	
	  // assert(gl instanceof WebGL2RenderingContext, 'WebGL2 required');
	  // Looks like these will check how many arguments were supplied?
	  // gl.vertexAttribI4i(location, v0, v1, v2, v3);
	  // gl.vertexAttribI4ui(location, v0, v1, v2, v3);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy93ZWJnbC92ZXJ0ZXgtYXR0cmlidXRlcy5qcyJdLCJuYW1lcyI6WyJnZXRNYXhBdHRyaWJ1dGVzIiwiaGFzRGl2aXNvciIsImlzRW5hYmxlZCIsImdldEJ1ZmZlciIsImdldEdlbmVyaWMiLCJnZXRTaXplIiwiZ2V0VHlwZSIsImlzTm9ybWFsaXplZCIsImlzSW50ZWdlciIsImdldFN0cmlkZSIsImdldE9mZnNldCIsImVuYWJsZSIsImRpc2FibGUiLCJzZXREaXZpc29yIiwiZ2V0RGl2aXNvciIsInNldEJ1ZmZlciIsInNldEdlbmVyaWMiLCJzZXRHZW5lcmljVmFsdWVzIiwiZ2xHZXRMdW1hSW5mbyIsImdsIiwibHVtYSIsImV4dGVuc2lvbnMiLCJ1bmRlZmluZWQiLCJnZXRFeHRlbnNpb24iLCJnZXRQYXJhbWV0ZXIiLCJNQVhfVkVSVEVYX0FUVFJJQlMiLCJCb29sZWFuIiwibG9jYXRpb24iLCJnZXQiLCJWRVJURVhfQVRUUklCX0FSUkFZX0VOQUJMRUQiLCJWRVJURVhfQVRUUklCX0FSUkFZX0JVRkZFUl9CSU5ESU5HIiwiQ1VSUkVOVF9WRVJURVhfQVRUUklCIiwiVkVSVEVYX0FUVFJJQl9BUlJBWV9TSVpFIiwiVkVSVEVYX0FUVFJJQl9BUlJBWV9UWVBFIiwiVkVSVEVYX0FUVFJJQl9BUlJBWV9OT1JNQUxJWkVEIiwiVkVSVEVYX0FUVFJJQl9BUlJBWV9JTlRFR0VSIiwiVkVSVEVYX0FUVFJJQl9BUlJBWV9TVFJJREUiLCJwbmFtZSIsIlZFUlRFWF9BVFRSSUJfQVJSQVlfUE9JTlRFUiIsImdldFZlcnRleEF0dHJpYk9mZnNldCIsImdldFZlcnRleEF0dHJpYiIsImVuYWJsZVZlcnRleEF0dHJpYkFycmF5IiwiZGlzYWJsZVZlcnRleEF0dHJpYkFycmF5IiwiZGl2aXNvciIsInZlcnRleEF0dHJpYkRpdmlzb3IiLCJleHQiLCJ2ZXJ0ZXhBdHRyaWJEaXZpc29yQU5HTEUiLCJFcnJvciIsIlZFUlRFWF9BVFRSSUJfQVJSQVlfRElWSVNPUiIsIlZFUlRFWF9BVFRSSUJfQVJSQVlfRElWSVNPUl9BTkdMRSIsImJ1ZmZlciIsInRhcmdldCIsImxheW91dCIsIm1ha2VGcm9tIiwiYmluZCIsIkFSUkFZX0JVRkZFUiIsImludGVnZXIiLCJ2ZXJ0ZXhBdHRyaWJQb2ludGVyIiwic2l6ZSIsInR5cGUiLCJub3JtYWxpemVkIiwic3RyaWRlIiwib2Zmc2V0IiwidmVydGV4QXR0cmliSVBvaW50ZXIiLCJ1bmJpbmQiLCJhcnJheSIsIndhcm4iLCJGbG9hdDMyQXJyYXkiLCJ2ZXJ0ZXhBdHRyaWI0ZnYiLCJJbnQzMkFycmF5IiwidmVydGV4QXR0cmliSTRpdiIsIlVpbnQzMkFycmF5IiwidmVydGV4QXR0cmliSTR1aXYiLCJ2MCIsInYxIiwidjIiLCJ2MyIsImFyZ3VtZW50cyIsImxlbmd0aCIsInZlcnRleEF0dHJpYjFmIiwidmVydGV4QXR0cmliMmYiLCJ2ZXJ0ZXhBdHRyaWIzZiIsInZlcnRleEF0dHJpYjRmIl0sIm1hcHBpbmdzIjoiOzs7OztRQXFFZ0JBLGdCLEdBQUFBLGdCO1FBVUFDLFUsR0FBQUEsVTtRQWNBQyxTLEdBQUFBLFM7UUFVQUMsUyxHQUFBQSxTO1FBV0FDLFUsR0FBQUEsVTtRQVNBQyxPLEdBQUFBLE87UUFTQUMsTyxHQUFBQSxPO1FBVUFDLFksR0FBQUEsWTtRQVdBQyxTLEdBQUFBLFM7UUFXQUMsUyxHQUFBQSxTO1FBVUFDLFMsR0FBQUEsUztRQTZCQUMsTSxHQUFBQSxNO1FBV0FDLE8sR0FBQUEsTztRQWdCQUMsVSxHQUFBQSxVO1FBc0JBQyxVLEdBQUFBLFU7UUErQkFDLFMsR0FBQUEsUztRQXdEQUMsVSxHQUFBQSxVO1FBd0JBQyxnQixHQUFBQSxnQjs7QUExV2hCOztBQUNBOztBQUlBOzs7O0FBQ0E7O0FBQ0E7Ozs7OztBQUVBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBd0NBLFNBQVNDLGFBQVQsQ0FBdUJDLEVBQXZCLEVBQTJCO0FBQ3pCLE1BQUksQ0FBQ0EsR0FBR0MsSUFBUixFQUFjO0FBQ1pELE9BQUdDLElBQUgsR0FBVSxFQUFDQyxZQUFZLEVBQWIsRUFBVjtBQUNEO0FBQ0QsTUFBSUYsR0FBR0MsSUFBSCxDQUFRQyxVQUFSLENBQW1CLHdCQUFuQixNQUFpREMsU0FBckQsRUFBZ0U7QUFDOURILE9BQUdDLElBQUgsQ0FBUUMsVUFBUixDQUFtQix3QkFBbkIsSUFDRUYsR0FBR0ksWUFBSCxDQUFnQix3QkFBaEIsQ0FERjtBQUVEO0FBQ0QsU0FBT0osR0FBR0MsSUFBVjtBQUNEOztBQUVEOztBQUVBOzs7Ozs7QUEvREE7QUFxRU8sU0FBU3BCLGdCQUFULENBQTBCbUIsRUFBMUIsRUFBOEI7QUFDbkMsdUNBQW1CQSxFQUFuQjtBQUNBLFNBQU9BLEdBQUdLLFlBQUgsQ0FBZ0JMLEdBQUdNLGtCQUFuQixDQUFQO0FBQ0Q7O0FBRUQ7Ozs7O0FBS08sU0FBU3hCLFVBQVQsQ0FBb0JrQixFQUFwQixFQUF3QjtBQUM3Qix1Q0FBbUJBLEVBQW5CO0FBQ0EsU0FBT08sUUFDTCxrQ0FBZ0JQLEVBQWhCLEtBQ0FBLEdBQUdJLFlBQUgsQ0FBZ0JKLEVBQWhCLEVBQW9CLHdCQUFwQixDQUZLLENBQVA7QUFJRDs7QUFFRDs7Ozs7O0FBTU8sU0FBU2pCLFNBQVQsQ0FBbUJpQixFQUFuQixFQUF1QlEsUUFBdkIsRUFBaUM7QUFDdEMsU0FBT0QsUUFBUUUsSUFBSVQsRUFBSixFQUFRUSxRQUFSLEVBQWtCUixHQUFHVSwyQkFBckIsQ0FBUixDQUFQO0FBQ0Q7O0FBRUQ7Ozs7OztBQU1PLFNBQVMxQixTQUFULENBQW1CZ0IsRUFBbkIsRUFBdUJRLFFBQXZCLEVBQWlDO0FBQ3RDLFNBQU9DLElBQUlULEVBQUosRUFBUVEsUUFBUixFQUFrQlIsR0FBR1csa0NBQXJCLENBQVA7QUFDRDs7QUFFRDs7Ozs7OztBQU9PLFNBQVMxQixVQUFULENBQW9CZSxFQUFwQixFQUF3QlEsUUFBeEIsRUFBa0M7QUFDdkMsU0FBT0MsSUFBSVQsRUFBSixFQUFRQSxHQUFHWSxxQkFBWCxDQUFQO0FBQ0Q7O0FBRUQ7Ozs7QUFJQTtBQUNPLFNBQVMxQixPQUFULENBQWlCYyxFQUFqQixFQUFxQlEsUUFBckIsRUFBK0I7QUFDcEMsU0FBT0MsSUFBSUQsUUFBSixFQUFjUixHQUFHYSx3QkFBakIsQ0FBUDtBQUNEOztBQUVEOzs7O0FBSUE7QUFDTyxTQUFTMUIsT0FBVCxDQUFpQmEsRUFBakIsRUFBcUJRLFFBQXJCLEVBQStCO0FBQ3BDLFNBQU9DLElBQUlELFFBQUosRUFBY1IsR0FBR2Msd0JBQWpCLENBQVA7QUFDRDs7QUFFRDs7OztBQUlBO0FBQ0E7QUFDTyxTQUFTMUIsWUFBVCxDQUFzQlksRUFBdEIsRUFBMEJRLFFBQTFCLEVBQW9DO0FBQ3pDLFNBQU9DLElBQUlELFFBQUosRUFBY1IsR0FBR2UsOEJBQWpCLENBQVA7QUFDRDs7QUFFRDs7Ozs7OztBQU9PLFNBQVMxQixTQUFULENBQW1CVyxFQUFuQixFQUF1QlEsUUFBdkIsRUFBaUM7QUFDdEMsd0NBQW9CUixFQUFwQjtBQUNBLFNBQU9TLElBQUlELFFBQUosRUFBY1IsR0FBR2dCLDJCQUFqQixDQUFQO0FBQ0Q7O0FBRUQ7Ozs7OztBQU1PLFNBQVMxQixTQUFULENBQW1CVSxFQUFuQixFQUF1QlEsUUFBdkIsRUFBaUM7QUFDdEMsU0FBT0MsSUFBSUQsUUFBSixFQUFjUixHQUFHaUIsMEJBQWpCLENBQVA7QUFDRDs7QUFFRDs7Ozs7O0FBTU8sU0FBUzFCLFNBQVQsQ0FDTFMsRUFESyxFQUNEUSxRQURDLEVBRUw7QUFBQSxNQURjVSxLQUNkLHVFQURzQmxCLEdBQUdtQiwyQkFDekI7O0FBQ0EsU0FBT25CLEdBQUdvQixxQkFBSCxDQUF5QlosUUFBekIsRUFBbUNVLEtBQW5DLENBQVA7QUFDRDs7QUFFRDs7Ozs7Ozs7QUFRQSxTQUFTVCxHQUFULENBQWFULEVBQWIsRUFBaUJRLFFBQWpCLEVBQTJCVSxLQUEzQixFQUFrQztBQUNoQyx1Q0FBbUJsQixFQUFuQjtBQUNBLFNBQU9BLEdBQUdxQixlQUFILENBQW1CYixRQUFuQixFQUE2QlUsS0FBN0IsQ0FBUDtBQUNEOztBQUVEOztBQUVBOzs7Ozs7OztBQVFPLFNBQVMxQixNQUFULENBQWdCUSxFQUFoQixFQUFvQlEsUUFBcEIsRUFBOEI7QUFDbkNSLEtBQUdzQix1QkFBSCxDQUEyQmQsUUFBM0I7QUFDRDs7QUFFRDs7Ozs7OztBQU9PLFNBQVNmLE9BQVQsQ0FBaUJPLEVBQWpCLEVBQXFCUSxRQUFyQixFQUErQjtBQUNwQztBQUNBLE1BQUlBLFdBQVcsQ0FBZixFQUFrQjtBQUNoQlIsT0FBR3VCLHdCQUFILENBQTRCZixRQUE1QjtBQUNEO0FBQ0Y7O0FBRUQ7Ozs7Ozs7OztBQVNPLFNBQVNkLFVBQVQsQ0FBb0JNLEVBQXBCLEVBQXdCUSxRQUF4QixFQUFrQ2dCLE9BQWxDLEVBQTJDO0FBQ2hELE1BQUksa0NBQWdCeEIsRUFBaEIsQ0FBSixFQUF5QjtBQUN2QkEsT0FBR3lCLG1CQUFILENBQXVCakIsUUFBdkIsRUFBaUNnQixPQUFqQztBQUNBO0FBQ0Q7QUFDRCxNQUFNRSxNQUFNM0IsY0FBY0MsRUFBZCxFQUFrQkUsVUFBbEIsQ0FBNkIsd0JBQTdCLENBQVo7QUFDQSxNQUFJd0IsR0FBSixFQUFTO0FBQ1BBLFFBQUlDLHdCQUFKLENBQTZCbkIsUUFBN0IsRUFBdUNnQixPQUF2QztBQUNBO0FBQ0Q7QUFDRDtBQUNBLE1BQUlBLFlBQVksQ0FBaEIsRUFBbUI7QUFDakIsVUFBTSxJQUFJSSxLQUFKLENBQVUseUNBQVYsQ0FBTjtBQUNEO0FBQ0Y7O0FBRUQ7Ozs7OztBQU1PLFNBQVNqQyxVQUFULENBQW9CSyxFQUFwQixFQUF3QlEsUUFBeEIsRUFBa0M7QUFDdkMsd0JBQU9BLFdBQVcsQ0FBbEI7QUFDQSxNQUFJLGtDQUFnQlIsRUFBaEIsQ0FBSixFQUF5QjtBQUN2QixRQUFNd0IsVUFBVWYsSUFBSUQsUUFBSixFQUFjUixHQUFHNkIsMkJBQWpCLENBQWhCO0FBQ0EsV0FBT0wsT0FBUDtBQUNEO0FBQ0QsTUFBTUUsTUFBTTNCLGNBQWNDLEVBQWQsRUFBa0JFLFVBQWxCLENBQTZCLHdCQUE3QixDQUFaO0FBQ0EsTUFBSXdCLEdBQUosRUFBUztBQUNQLFFBQU1GLFdBQVVmLElBQUlELFFBQUosRUFBY2tCLElBQUlJLGlDQUFsQixDQUFoQjtBQUNBLFdBQU9OLFFBQVA7QUFDRDtBQUNEO0FBQ0EsU0FBTyxDQUFQO0FBQ0Q7O0FBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7QUFnQk8sU0FBUzVCLFNBQVQsR0FNQztBQUFBLGlGQUFKLEVBQUk7QUFBQSxNQUxOSSxFQUtNLFFBTE5BLEVBS007QUFBQSxNQUpOUSxRQUlNLFFBSk5BLFFBSU07QUFBQSxNQUhOdUIsTUFHTSxRQUhOQSxNQUdNO0FBQUEsTUFGTkMsTUFFTSxRQUZOQSxNQUVNO0FBQUEsTUFETkMsTUFDTSxRQUROQSxNQUNNOztBQUNOLHVDQUFtQmpDLEVBQW5CO0FBQ0ErQixXQUFTLGlCQUFPRyxRQUFQLENBQWdCbEMsRUFBaEIsRUFBb0IrQixNQUFwQixDQUFUOztBQUVBO0FBQ0FDLFdBQVMsa0JBQU1BLFdBQVc3QixTQUFYLEdBQXVCNkIsTUFBdkIsR0FBZ0NELE9BQU9DLE1BQTdDLENBQVQ7QUFDQUMsV0FBU0EsV0FBVzlCLFNBQVgsR0FBdUI4QixNQUF2QixHQUFnQ0YsT0FBT0UsTUFBaEQ7QUFDQSx3QkFBT0QsTUFBUCxFQUFlLHdCQUFmO0FBQ0Esd0JBQU9DLE1BQVAsRUFBZSwwQ0FBZjs7QUFFQTtBQUNBRixTQUFPSSxJQUFQLENBQVksRUFBQ0gsUUFBUWhDLEdBQUdvQyxZQUFaLEVBQVo7O0FBRUE7QUFDQSxNQUFJLENBQUNILE9BQU9JLE9BQVosRUFBcUI7QUFDbkJyQyxPQUFHc0MsbUJBQUgsQ0FDRTlCLFFBREYsRUFFRXlCLE9BQU9NLElBRlQsRUFHRSxrQkFBTU4sT0FBT08sSUFBYixDQUhGLEVBSUVQLE9BQU9RLFVBSlQsRUFLRVIsT0FBT1MsTUFMVCxFQU1FVCxPQUFPVSxNQU5UO0FBUUQsR0FURCxNQVNPO0FBQ0w7QUFDQTtBQUNBO0FBQ0E7QUFDQSwwQ0FBb0IzQyxFQUFwQjtBQUNBQSxPQUFHNEMsb0JBQUgsQ0FDRXBDLFFBREYsRUFFRXlCLE9BQU9NLElBRlQsRUFHRSxrQkFBTU4sT0FBT08sSUFBYixDQUhGLEVBSUVQLE9BQU9TLE1BSlQsRUFLRVQsT0FBT1UsTUFMVDtBQU9EOztBQUVEWixTQUFPYyxNQUFQLENBQWMsRUFBQ2IsUUFBUWhDLEdBQUdvQyxZQUFaLEVBQWQ7QUFDRDs7QUFFRDs7Ozs7Ozs7O0FBU08sU0FBU3ZDLFVBQVQsUUFBMkM7QUFBQSxNQUF0QkcsRUFBc0IsU0FBdEJBLEVBQXNCO0FBQUEsTUFBbEJRLFFBQWtCLFNBQWxCQSxRQUFrQjtBQUFBLE1BQVJzQyxLQUFRLFNBQVJBLEtBQVE7O0FBQ2hELGFBQUlDLElBQUosQ0FBUyxDQUFULEVBQVksZ0RBQVo7QUFDQTs7QUFFQSxNQUFJRCxpQkFBaUJFLFlBQXJCLEVBQW1DO0FBQ2pDaEQsT0FBR2lELGVBQUgsQ0FBbUJ6QyxRQUFuQixFQUE2QnNDLEtBQTdCO0FBQ0QsR0FGRCxNQUVPLElBQUlBLGlCQUFpQkksVUFBckIsRUFBaUM7QUFDdEMsMENBQW9CbEQsRUFBcEI7QUFDQUEsT0FBR21ELGdCQUFILENBQW9CM0MsUUFBcEIsRUFBOEJzQyxLQUE5QjtBQUNELEdBSE0sTUFHQSxJQUFJQSxpQkFBaUJNLFdBQXJCLEVBQWtDO0FBQ3ZDLDBDQUFvQnBELEVBQXBCO0FBQ0FBLE9BQUdxRCxpQkFBSCxDQUFxQjdDLFFBQXJCLEVBQStCc0MsS0FBL0I7QUFDRDtBQUNGOztBQUVEOzs7Ozs7OztBQVFBO0FBQ08sU0FBU2hELGdCQUFULENBQTBCRSxFQUExQixFQUE4QlEsUUFBOUIsRUFBd0M4QyxFQUF4QyxFQUE0Q0MsRUFBNUMsRUFBZ0RDLEVBQWhELEVBQW9EQyxFQUFwRCxFQUF3RDtBQUM3RCxhQUFJVixJQUFKLENBQVMsQ0FBVCxFQUFZLHNEQUFaO0FBQ0EsVUFBUVcsVUFBVUMsTUFBVixHQUFtQixDQUEzQjtBQUNBLFNBQUssQ0FBTDtBQUFRM0QsU0FBRzRELGNBQUgsQ0FBa0JwRCxRQUFsQixFQUE0QjhDLEVBQTVCLEVBQWlDO0FBQ3pDLFNBQUssQ0FBTDtBQUFRdEQsU0FBRzZELGNBQUgsQ0FBa0JyRCxRQUFsQixFQUE0QjhDLEVBQTVCLEVBQWdDQyxFQUFoQyxFQUFxQztBQUM3QyxTQUFLLENBQUw7QUFBUXZELFNBQUc4RCxjQUFILENBQWtCdEQsUUFBbEIsRUFBNEI4QyxFQUE1QixFQUFnQ0MsRUFBaEMsRUFBb0NDLEVBQXBDLEVBQXlDO0FBQ2pELFNBQUssQ0FBTDtBQUFReEQsU0FBRytELGNBQUgsQ0FBa0J2RCxRQUFsQixFQUE0QjhDLEVBQTVCLEVBQWdDQyxFQUFoQyxFQUFvQ0MsRUFBcEMsRUFBd0NDLEVBQXhDLEVBQTZDO0FBQ3JEO0FBQ0UsWUFBTSxJQUFJN0IsS0FBSixDQUFVLCtDQUFWLENBQU47QUFORjs7QUFTQTtBQUNBO0FBQ0E7QUFDQTtBQUNEIiwiZmlsZSI6InZlcnRleC1hdHRyaWJ1dGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUgZG90LW5vdGF0aW9uKi9cbmltcG9ydCB7Z2xHZXR9IGZyb20gJy4vd2ViZ2wnO1xuaW1wb3J0IHtcbiAgYXNzZXJ0V2ViR0xDb250ZXh0LFxuICBhc3NlcnRXZWJHTDJDb250ZXh0LCBpc1dlYkdMMkNvbnRleHRcbn0gZnJvbSAnLi93ZWJnbC1jaGVja3MnO1xuaW1wb3J0IEJ1ZmZlciBmcm9tICcuL2J1ZmZlcic7XG5pbXBvcnQge2xvZ30gZnJvbSAnLi4vdXRpbHMnO1xuaW1wb3J0IGFzc2VydCBmcm9tICdhc3NlcnQnO1xuXG4vKipcbiAqIE1ldGhvZHMgZm9yIG1hbmlwdWxhdGluZyB0aGUgdmVydGV4IGF0dHJpYnV0ZXMgYXJyYXksIHdoaWNoIGlzIHdoZXJlXG4gKiB2ZXJ0ZXggZGF0YSBpcyBzdGFnZWQgZm9yIHNoYWRlciBleGVjdXRpb24uXG4gKlxuICogVmVydGV4IGF0dHJpYnV0ZXMgYXJlIHN0b3JlZCBpbiBcImFycmF5c1wiIHdpdGggaW5kaWNlcyBmcm9tIDAgYW5kIHVwLlxuICogRHVyaW5nIHNoYWRlciBleGVjdXRpb24sIHRoZXNlIGluZGljZXMgKG9yICdsb2NhdGlvbnMnKSBhcmUgbWF0Y2hlZCB0b1xuICogdGhlIGluZGljZXMgYXNzaWduZWQgdG8gc2hhZGVyIGF0dHJpYnV0ZXMgZHVyaW5nIFdlYkdMUHJvZ3JhbSBsaW5raW5nLlxuICpcbiAqIE5vdGU6IFRoZSBnbG9iYWwgc3RhdGUgY29udGFpbnMgYW4gaW1wbGljaXQgdmVydGV4IGF0dHJpYnV0ZSBhcnJheSB3aGljaFxuICogdGhlIG1ldGhvZHMgaW4gdGhpcyBjbGFzcyBtYW5pcHVsYXRlIGJ5IGRlZmF1bHQuIEl0IGlzIGFsc28gcG9zc2libGUgdG9cbiAqIGNyZWF0ZSBhbmQgYmluZCBhIFZlcnRleEFycmF5T2JqZWN0IHRvIG1hbmFnZSBtdWx0aXBsZSBhcnJheXMuXG4gKlxuICogRWFjaCB2ZXJ0ZXggYXR0cmlidXRlIGhhcyB0aGVzZSBwcm9wZXJ0aWVzOlxuICogLSBDYW4gYmUgZW5hYmxlZCBvciBkaXNhYmxlZCAoT25seSBlbmFibGUgYXR0cnMgYWN0dWFsbHkgdXNlZCBieSBhIHByb2dyYW0pXG4gKiAtIEhhcyBhbiBpbnN0YW5jZSBgZGl2aXNvcmAgKHVzdWFsbHkgMSBvciAwIHRvIGVuYWJsZS9kaXNhYmxlIGluc3RhbmNpbmcpXG4gKiAtIEhhdmUgYSBzaXplICgxLTQgdmFsdWVzIHBlciB2ZXJ0ZXgpXG4gKiAtIEhhcyBhIHZhbHVlIG9yIHZhbHVlcyB0aGF0IGlzIGFjY2Vzc2libGUgaW4gc2hhZGVyc1xuICpcbiAqIEF0dHJpYnV0ZSB2YWx1ZXMgYXJlIGVpdGhlclxuICogLSBHZW5lcmljOiBhIGNvbnN0YW50IHZhbHVlIGZvciBhbGwgdmVydGljZXMvaW5zdGFuY2VzLCBvclxuICogLSBCb3VuZCB0byBhIFdlYkdMQnVmZmVyIHdpdGggdW5pcXVlIHZhbHVlcyBmb3IgZWFjaCB2ZXJ0ZXgvaW5zdGFuY2VcbiAqXG4gKiBXaGVuIGJpbmRpbmcgdG8gYSBXZWJHTEJ1ZmZlciBpdCBpcyBuZWNlc3NhcnkgdG8gc3BlY2lmeSB0aGUgbGF5b3V0IG9mXG4gKiBkYXRhIGluIHRoZSBidWZmZXI6XG4gKiAtIHNpemUgKDEtNCB2YWx1ZXMgcGVyIHZlcnRleClcbiAqIC0gZGF0YSB0eXBlIChlLmcuIGdsLkZMT0FUKVxuICogLSBzdHJpZGUsIG9mZnNldCwgYW5kIGludGVnZXIgbm9ybWFsaXphdGlvbiBwb2xpY3kgY2FuIGFsc28gYmUgc3BlY2lmaWVkXG4gKlxuICogTm90ZTogQWxsIG1ldGhvZHMgaW4gdGhpcyBjbGFzcyB0YWtlIGEgYGxvY2F0aW9uYCBpbmRleCB0byBzcGVjaWZ5IHdoaWNoXG4gKiB2ZXJ0ZXggYXR0cmlidXRlIGluIHRoZSBhcnJheSB0aGV5IGFyZSBvcGVyYXRpbmcgb24uXG4gKlxuICogTm90ZTogQXR0cmlidXRlIDAgY2FuIHNvbWV0aW1lcyBiZSB0cmVhdGVkIHNwZWNpYWxseSBieSB0aGUgZHJpdmVyLFxuICogdG8gYmUgc2FmZSB3ZSBhdm9pZCBkaXNhYmxpbmcgaXQuXG4gKlxuICogTm90ZTogV2ViR0wyXG4gKiAtIEltcHJvdmVzIHN1cHBvcnQgZm9yIGludGVnZXIgYXR0cmlidXRlcywgYm90aCBnZW5lcmljIGFuZCBidWZmZXJlZC5cbiAqIC0gU2V0dGluZyBpbnN0YW5jZSBcImRpdmlzb3JzXCIgbm8gbG9uZ2VyIHJlcXVpcmUgdXNpbmcgYSBXZWJHTCBleHRlbnNpb24uXG4gKlxuICovXG5cbmZ1bmN0aW9uIGdsR2V0THVtYUluZm8oZ2wpIHtcbiAgaWYgKCFnbC5sdW1hKSB7XG4gICAgZ2wubHVtYSA9IHtleHRlbnNpb25zOiB7fX07XG4gIH1cbiAgaWYgKGdsLmx1bWEuZXh0ZW5zaW9uc1snQU5HTEVfaW5zdGFuY2VkX2FycmF5cyddID09PSB1bmRlZmluZWQpIHtcbiAgICBnbC5sdW1hLmV4dGVuc2lvbnNbJ0FOR0xFX2luc3RhbmNlZF9hcnJheXMnXSA9XG4gICAgICBnbC5nZXRFeHRlbnNpb24oJ0FOR0xFX2luc3RhbmNlZF9hcnJheXMnKTtcbiAgfVxuICByZXR1cm4gZ2wubHVtYTtcbn1cblxuLy8gQUNDRVNTT1JTXG5cbi8qKlxuICogVGhlIG1heCBudW1iZXIgb2YgYXR0cmlidXRlcyBpbiB0aGUgdmVydGV4IGF0dHJpYnV0ZSBhcnJheSBpcyBhblxuICogaW1wbGVtZW50YXRpb24gZGVmaW5lZCBsaW1pdCwgYnV0IG5ldmVyIHNtYWxsZXIgdGhhbiA4XG4gKiBAcGFyYW0ge1dlYkdMUmVuZGVyaW5nQ29udGV4dH0gZ2wgLSB3ZWJnbCBjb250ZXh0XG4gKiBAcmV0dXJucyB7R0x1aW50fSAtIChtYXgpIG51bWJlciBvZiBhdHRyaWJ1dGVzIGluIHRoZSB2ZXJ0ZXggYXR0cmlidXRlIGFycmF5XG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBnZXRNYXhBdHRyaWJ1dGVzKGdsKSB7XG4gIGFzc2VydFdlYkdMQ29udGV4dChnbCk7XG4gIHJldHVybiBnbC5nZXRQYXJhbWV0ZXIoZ2wuTUFYX1ZFUlRFWF9BVFRSSUJTKTtcbn1cblxuLyoqXG4gKiBJcyBpbnN0YW5jZSBkaXZpc29yIGF2YWlsYmxlIChjaGVja3MgZm9yIFdlYkdMMiBvciBBTkdMRSBleHRlbnNpb24pXG4gKiBAcGFyYW0ge1dlYkdMUmVuZGVyaW5nQ29udGV4dH0gZ2wgLSB3ZWJnbCBjb250ZXh0XG4gKiBAcmV0dXJucyB7Qm9vbGVhbn0gLSBpcyBkaXZpc29yIGF2YWlsYWJsZT9cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGhhc0Rpdmlzb3IoZ2wpIHtcbiAgYXNzZXJ0V2ViR0xDb250ZXh0KGdsKTtcbiAgcmV0dXJuIEJvb2xlYW4oXG4gICAgaXNXZWJHTDJDb250ZXh0KGdsKSB8fFxuICAgIGdsLmdldEV4dGVuc2lvbihnbCwgJ0FOR0xFX2luc3RhbmNlZF9hcnJheXMnKVxuICApO1xufVxuXG4vKipcbiAqIFJldHVybnMgdHJ1ZSBpZiB0aGUgdmVydGV4IGF0dHJpYnV0ZSBpcyBlbmFibGVkIGF0IHRoaXMgaW5kZXguXG4gKiBAcGFyYW0ge1dlYkdMUmVuZGVyaW5nQ29udGV4dH0gZ2wgLSB3ZWJnbCBjb250ZXh0XG4gKiBAcGFyYW0ge0dMdWludH0gbG9jYXRpb24gLSBvcmRpbmFsIG51bWJlciBvZiB0aGUgYXR0cmlidXRlXG4gKiBAcmV0dXJucyB7Qm9vbGVhbn0gLSBlbmFibGVkIHN0YXR1c1xuICovXG5leHBvcnQgZnVuY3Rpb24gaXNFbmFibGVkKGdsLCBsb2NhdGlvbikge1xuICByZXR1cm4gQm9vbGVhbihnZXQoZ2wsIGxvY2F0aW9uLCBnbC5WRVJURVhfQVRUUklCX0FSUkFZX0VOQUJMRUQpKTtcbn1cblxuLyoqXG4gKiBSZXR1cm5zIHRoZSBjdXJyZW50bHkgYm91bmQgYnVmZmVyXG4gKiBAcGFyYW0ge1dlYkdMUmVuZGVyaW5nQ29udGV4dH0gZ2wgLSB3ZWJnbCBjb250ZXh0XG4gKiBAcGFyYW0ge0dMdWludH0gbG9jYXRpb24gLSBvcmRpbmFsIG51bWJlciBvZiB0aGUgYXR0cmlidXRlXG4gKiBAcmV0dXJucyB7V2ViR0xCdWZmZXJ9IFJldHVybnMgdGhlIGN1cnJlbnRseSBib3VuZCBidWZmZXJcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGdldEJ1ZmZlcihnbCwgbG9jYXRpb24pIHtcbiAgcmV0dXJuIGdldChnbCwgbG9jYXRpb24sIGdsLlZFUlRFWF9BVFRSSUJfQVJSQVlfQlVGRkVSX0JJTkRJTkcpO1xufVxuXG4vKipcbiAqIEdldCB2YWx1ZXMgZm9yIGdlbmVyaWMgdmVydGV4IGF0dHJpYnV0ZXNcbiAqIEBwYXJhbSB7V2ViR0xSZW5kZXJpbmdDb250ZXh0fSBnbCAtIHdlYmdsIGNvbnRleHRcbiAqIEBwYXJhbSB7R0x1aW50fSBsb2NhdGlvbiAtIG9yZGluYWwgbnVtYmVyIG9mIHRoZSBhdHRyaWJ1dGVcbiAqIEByZXR1cm5zIHtGbG9hdDMyQXJyYXl9ICh3aXRoIDQgZWxlbWVudHMpIHJlcHJlc2VudGluZyB0aGUgY3VycmVudCB2YWx1ZVxuICogb2YgdGhlIHZlcnRleCBhdHRyaWJ1dGUgYXQgdGhlIGdpdmVuIGluZGV4LlxuICovXG5leHBvcnQgZnVuY3Rpb24gZ2V0R2VuZXJpYyhnbCwgbG9jYXRpb24pIHtcbiAgcmV0dXJuIGdldChnbCwgZ2wuQ1VSUkVOVF9WRVJURVhfQVRUUklCKTtcbn1cblxuLyoqXG4gKiBAcGFyYW0ge1dlYkdMUmVuZGVyaW5nQ29udGV4dH0gZ2wgLSB3ZWJnbCBjb250ZXh0XG4gKiBAcGFyYW0ge0dMdWludH0gbG9jYXRpb24gLSBvcmRpbmFsIG51bWJlciBvZiB0aGUgYXR0cmlidXRlXG4gKi9cbi8vIEByZXR1cm5zIHtHTGludH0gdGhlIHNpemUgb2YgYW4gZWxlbWVudCBvZiB0aGUgdmVydGV4IGFycmF5LlxuZXhwb3J0IGZ1bmN0aW9uIGdldFNpemUoZ2wsIGxvY2F0aW9uKSB7XG4gIHJldHVybiBnZXQobG9jYXRpb24sIGdsLlZFUlRFWF9BVFRSSUJfQVJSQVlfU0laRSk7XG59XG5cbi8qKlxuICogQHBhcmFtIHtXZWJHTFJlbmRlcmluZ0NvbnRleHR9IGdsIC0gd2ViZ2wgY29udGV4dFxuICogQHBhcmFtIHtHTHVpbnR9IGxvY2F0aW9uIC0gb3JkaW5hbCBudW1iZXIgb2YgdGhlIGF0dHJpYnV0ZVxuICovXG4vLyBAcmV0dXJucyB7R0xlbnVtfSByZXByZXNlbnRpbmcgdGhlIGFycmF5IHR5cGUuXG5leHBvcnQgZnVuY3Rpb24gZ2V0VHlwZShnbCwgbG9jYXRpb24pIHtcbiAgcmV0dXJuIGdldChsb2NhdGlvbiwgZ2wuVkVSVEVYX0FUVFJJQl9BUlJBWV9UWVBFKTtcbn1cblxuLyoqXG4gKiBAcGFyYW0ge1dlYkdMUmVuZGVyaW5nQ29udGV4dH0gZ2wgLSB3ZWJnbCBjb250ZXh0XG4gKiBAcGFyYW0ge0dMdWludH0gbG9jYXRpb24gLSBvcmRpbmFsIG51bWJlciBvZiB0aGUgYXR0cmlidXRlXG4gKi9cbi8vIEByZXR1cm5zIHtHTGJvb2xlYW59IHRydWUgaWYgZml4ZWQtcG9pbnQgZGF0YSB0eXBlcyBhcmUgbm9ybWFsaXplZFxuLy8gZm9yIHRoZSB2ZXJ0ZXggYXR0cmlidXRlIGFycmF5IGF0IHRoZSBnaXZlbiBpbmRleC5cbmV4cG9ydCBmdW5jdGlvbiBpc05vcm1hbGl6ZWQoZ2wsIGxvY2F0aW9uKSB7XG4gIHJldHVybiBnZXQobG9jYXRpb24sIGdsLlZFUlRFWF9BVFRSSUJfQVJSQVlfTk9STUFMSVpFRCk7XG59XG5cbi8qKlxuICogY2hlY2sgaWYgYW4gaW50ZWdlciBkYXRhIHR5cGUgaW4gdGhlIHZlcnRleCBhdHRyaWJ1dGUgYXQgaW5kZXhcbiAqIEBwYXJhbSB7V2ViR0xSZW5kZXJpbmdDb250ZXh0fSBnbCAtIHdlYmdsIGNvbnRleHRcbiAqIEBwYXJhbSB7R0x1aW50fSBsb2NhdGlvbiAtIGluZGV4IG9mIHRoZSB2ZXJ0ZXggYXR0cmlidXRlLlxuICogQHJldHVybnMge0dMYm9vbGVhbn0gLSB0cnVlIGlmIGFuIGludGVnZXIgZGF0YSB0eXBlIGlzIGluIHRoZVxuICogdmVydGV4IGF0dHJpYnV0ZSBhcnJheSBhdCB0aGUgZ2l2ZW4gaW5kZXguXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBpc0ludGVnZXIoZ2wsIGxvY2F0aW9uKSB7XG4gIGFzc2VydFdlYkdMMkNvbnRleHQoZ2wpO1xuICByZXR1cm4gZ2V0KGxvY2F0aW9uLCBnbC5WRVJURVhfQVRUUklCX0FSUkFZX0lOVEVHRVIpO1xufVxuXG4vKipcbiAqIEBwYXJhbSB7V2ViR0xSZW5kZXJpbmdDb250ZXh0fSBnbCAtIHdlYmdsIGNvbnRleHRcbiAqIEBwYXJhbSB7R0x1aW50fSBsb2NhdGlvbiAtIG9yZGluYWwgbnVtYmVyIG9mIHRoZSBhdHRyaWJ1dGVcbiAqIEByZXR1cm5zIHtHTGludH0gbnVtYmVyIG9mIGJ5dGVzIGJldHdlZW4gc3VjY2Vzc2l2ZSBlbGVtZW50cyBpbiB0aGUgYXJyYXkuXG4gKiAwIG1lYW5zIHRoYXQgdGhlIGVsZW1lbnRzIGFyZSBzZXF1ZW50aWFsLlxuICovXG5leHBvcnQgZnVuY3Rpb24gZ2V0U3RyaWRlKGdsLCBsb2NhdGlvbikge1xuICByZXR1cm4gZ2V0KGxvY2F0aW9uLCBnbC5WRVJURVhfQVRUUklCX0FSUkFZX1NUUklERSk7XG59XG5cbi8qKlxuICogQHBhcmFtIHtXZWJHTFJlbmRlcmluZ0NvbnRleHR9IGdsIC0gd2ViZ2wgY29udGV4dFxuICogQHBhcmFtIHtHTHVpbnR9IGxvY2F0aW9uIC0gb3JkaW5hbCBudW1iZXIgb2YgdGhlIGF0dHJpYnV0ZVxuICogQHBhcmFtIHtHTHVpbnR9IHBuYW1lIC0gZW51bSBzcGVjaWZ5aW5nIHdoaWNoIG9mZnNldCB0byByZXR1cm5cbiAqIEByZXR1cm5zIHtHTHVpbnR9IHRoZSBhZGRyZXNzIG9mIGEgc3BlY2lmaWVkIHZlcnRleCBhdHRyaWJ1dGUuXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBnZXRPZmZzZXQoXG4gIGdsLCBsb2NhdGlvbiwgcG5hbWUgPSBnbC5WRVJURVhfQVRUUklCX0FSUkFZX1BPSU5URVJcbikge1xuICByZXR1cm4gZ2wuZ2V0VmVydGV4QXR0cmliT2Zmc2V0KGxvY2F0aW9uLCBwbmFtZSk7XG59XG5cbi8qKlxuICogQHByaXZhdGVcbiAqIEdlbmVyaWMgZ2V0dGVyIGZvciBpbmZvcm1hdGlvbiBhYm91dCBhIHZlcnRleCBhdHRyaWJ1dGUgYXQgYSBnaXZlbiBwb3NpdGlvblxuICogQHBhcmFtIHtXZWJHTFJlbmRlcmluZ0NvbnRleHR9IGdsIC0gd2ViZ2wgY29udGV4dFxuICogQHBhcmFtIHtHTHVpbnR9IGxvY2F0aW9uIC0gaW5kZXggb2YgdGhlIHZlcnRleCBhdHRyaWJ1dGUuXG4gKiBAcGFyYW0ge0dMZW51bX0gcG5hbWUgLSBzcGVjaWZpZXMgdGhlIGluZm9ybWF0aW9uIHRvIHF1ZXJ5LlxuICogQHJldHVybnMgeyp9IC0gcmVxdWVzdGVkIHZlcnRleCBhdHRyaWJ1dGUgaW5mb3JtYXRpb24gKHNwZWNpZmllZCBieSBwbmFtZSlcbiAqL1xuZnVuY3Rpb24gZ2V0KGdsLCBsb2NhdGlvbiwgcG5hbWUpIHtcbiAgYXNzZXJ0V2ViR0xDb250ZXh0KGdsKTtcbiAgcmV0dXJuIGdsLmdldFZlcnRleEF0dHJpYihsb2NhdGlvbiwgcG5hbWUpO1xufVxuXG4vLyBNT0RJRklFUlNcblxuLyoqXG4gKiBFbmFibGUgdGhlIGF0dHJpYnV0ZVxuICogTm90ZTogQnkgZGVmYXVsdCBhbGwgYXR0cmlidXRlcyBhcmUgZGlzYWJsZWQuIE9ubHkgYXR0cmlidXRlc1xuICogdXNlZCBieSBhIHByb2dyYW0ncyBzaGFkZXJzIHNob3VsZCBiZSBlbmFibGVkLlxuICpcbiAqIEBwYXJhbSB7V2ViR0xSZW5kZXJpbmdDb250ZXh0fSBnbCAtIHdlYmdsIGNvbnRleHRcbiAqIEBwYXJhbSB7R0x1aW50fSBsb2NhdGlvbiAtIG9yZGluYWwgbnVtYmVyIG9mIHRoZSBhdHRyaWJ1dGVcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGVuYWJsZShnbCwgbG9jYXRpb24pIHtcbiAgZ2wuZW5hYmxlVmVydGV4QXR0cmliQXJyYXkobG9jYXRpb24pO1xufVxuXG4vKipcbiAqIERpc2FibGUgdGhlIGF0dHJpYnV0ZVxuICogTm90ZTogT25seSBhdHRyaWJ1dGVzIHVzZWQgYnkgYSBwcm9ncmFtJ3Mgc2hhZGVycyBzaG91bGQgYmUgZW5hYmxlZC5cbiAqXG4gKiBAcGFyYW0ge1dlYkdMUmVuZGVyaW5nQ29udGV4dH0gZ2wgLSB3ZWJnbCBjb250ZXh0XG4gKiBAcGFyYW0ge0dMdWludH0gbG9jYXRpb24gLSBvcmRpbmFsIG51bWJlciBvZiB0aGUgYXR0cmlidXRlXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBkaXNhYmxlKGdsLCBsb2NhdGlvbikge1xuICAvLyBEb24ndCBkaXNhYmxlIGxvY2F0aW9uIDBcbiAgaWYgKGxvY2F0aW9uID4gMCkge1xuICAgIGdsLmRpc2FibGVWZXJ0ZXhBdHRyaWJBcnJheShsb2NhdGlvbik7XG4gIH1cbn1cblxuLyoqXG4gKiBTZXQgdGhlIGZyZXF1ZW5jeSBkaXZpc29yIHVzZWQgZm9yIGluc3RhbmNlZCByZW5kZXJpbmcuXG4gKiBOb3RlOiBVc3VhbGx5IHNpbXBseSBzZXQgdG8gMSBvciAwIHRvIGVuYWJsZS9kaXNhYmxlIGluc3RhbmNlZCByZW5kZXJpbmdcbiAqIGZvciBhIHNwZWNpZmljIGF0dHJpYnV0ZS5cbiAqXG4gKiBAcGFyYW0ge1dlYkdMUmVuZGVyaW5nQ29udGV4dH0gZ2wgLSB3ZWJnbCBjb250ZXh0XG4gKiBAcGFyYW0ge0dMdWludH0gbG9jYXRpb24gLSBvcmRpbmFsIG51bWJlciBvZiB0aGUgYXR0cmlidXRlXG4gKiBAcGFyYW0ge0dMdWludH0gZGl2aXNvciAtIGluc3RhbmNlcyB0aGF0IHBhc3MgYmV0d2VlbiB1cGRhdGVzIG9mIGF0dHJpYnV0ZVxuICovXG5leHBvcnQgZnVuY3Rpb24gc2V0RGl2aXNvcihnbCwgbG9jYXRpb24sIGRpdmlzb3IpIHtcbiAgaWYgKGlzV2ViR0wyQ29udGV4dChnbCkpIHtcbiAgICBnbC52ZXJ0ZXhBdHRyaWJEaXZpc29yKGxvY2F0aW9uLCBkaXZpc29yKTtcbiAgICByZXR1cm47XG4gIH1cbiAgY29uc3QgZXh0ID0gZ2xHZXRMdW1hSW5mbyhnbCkuZXh0ZW5zaW9uc1snQU5HTEVfaW5zdGFuY2VkX2FycmF5cyddO1xuICBpZiAoZXh0KSB7XG4gICAgZXh0LnZlcnRleEF0dHJpYkRpdmlzb3JBTkdMRShsb2NhdGlvbiwgZGl2aXNvcik7XG4gICAgcmV0dXJuO1xuICB9XG4gIC8vIEFjY2VwdCBkaXZpc29yIDAgZXZlbiBpZiBpbnN0YW5jaW5nIGlzIG5vdCBzdXBwb3J0ZWQgKDAgPSBubyBpbnN0YW5jaW5nKVxuICBpZiAoZGl2aXNvciAhPT0gMCkge1xuICAgIHRocm93IG5ldyBFcnJvcignV2ViR0wgaW5zdGFuY2VkIHJlbmRlcmluZyBub3Qgc3VwcG9ydGVkJyk7XG4gIH1cbn1cblxuLyoqXG4gKiBSZXR1cm5zIHRoZSBmcmVxdWVuY3kgZGl2aXNvciB1c2VkIGZvciBpbnN0YW5jZWQgcmVuZGVyaW5nLlxuICogQHBhcmFtIHtXZWJHTFJlbmRlcmluZ0NvbnRleHR9IGdsIC0gd2ViZ2wgY29udGV4dFxuICogQHBhcmFtIHtHTHVpbnR9IGxvY2F0aW9uIC0gb3JkaW5hbCBudW1iZXIgb2YgdGhlIGF0dHJpYnV0ZVxuICogQHJldHVybnMge0dMdWludH0gZGl2aXNvclxuICovXG5leHBvcnQgZnVuY3Rpb24gZ2V0RGl2aXNvcihnbCwgbG9jYXRpb24pIHtcbiAgYXNzZXJ0KGxvY2F0aW9uID4gMCk7XG4gIGlmIChpc1dlYkdMMkNvbnRleHQoZ2wpKSB7XG4gICAgY29uc3QgZGl2aXNvciA9IGdldChsb2NhdGlvbiwgZ2wuVkVSVEVYX0FUVFJJQl9BUlJBWV9ESVZJU09SKTtcbiAgICByZXR1cm4gZGl2aXNvcjtcbiAgfVxuICBjb25zdCBleHQgPSBnbEdldEx1bWFJbmZvKGdsKS5leHRlbnNpb25zWydBTkdMRV9pbnN0YW5jZWRfYXJyYXlzJ107XG4gIGlmIChleHQpIHtcbiAgICBjb25zdCBkaXZpc29yID0gZ2V0KGxvY2F0aW9uLCBleHQuVkVSVEVYX0FUVFJJQl9BUlJBWV9ESVZJU09SX0FOR0xFKTtcbiAgICByZXR1cm4gZGl2aXNvcjtcbiAgfVxuICAvLyBpZiBpbnN0YW5jaW5nIGlzIG5vdCBhdmFpbGFibGUsIHJldHVybiAwIG1lYW5pbmcgZGl2aXNvciBoYXMgbm90IGJlZW4gc2V0XG4gIHJldHVybiAwO1xufVxuXG4vKipcbiAqIFNldCBhIGxvY2F0aW9uIGluIHZlcnRleCBhdHRyaWJ1dGVzIGFycmF5IHRvIGEgYnVmZmVyLCBzcGVjaWZ5aW5nXG4gKiBpdHMgZGF0YSBsYXlvdXQgYW5kIGludGVnZXIgdG8gZmxvYXQgY29udmVyc2lvbiBhbmQgbm9ybWFsaXphdGlvbiBmbGFnc1xuICpcbiAqIEBwYXJhbSB7V2ViR0xSZW5kZXJpbmdDb250ZXh0fSBnbCAtIHdlYmdsIGNvbnRleHRcbiAqIEBwYXJhbSB7R0x1aW50fSBsb2NhdGlvbiAtIG9yZGluYWwgbnVtYmVyIG9mIHRoZSBhdHRyaWJ1dGVcbiAqIEBwYXJhbSB7V2ViR0xCdWZmZXJ8QnVmZmVyfSBidWZmZXIgLSBXZWJHTCBidWZmZXIgdG8gc2V0IGFzIHZhbHVlXG4gKiBAcGFyYW0ge0dMdWludH0gdGFyZ2V0PWdsLkFSUkFZX0JVRkZFUiAtIHdoaWNoIHRhcmdldCB0byBiaW5kIHRvXG4gKiBAcGFyYW0ge09iamVjdH0gbGF5b3V0PSBPcHRpb25hbCBkYXRhIGxheW91dCwgZGVmYXVsdHMgdG8gYnVmZmVyJ3MgbGF5b3V0XG4gKiBAcGFyYW0ge0dMdWludH0gbGF5b3V0LnNpemUgLSBudW1iZXIgb2YgdmFsdWVzIHBlciBlbGVtZW50ICgxLTQpXG4gKiBAcGFyYW0ge0dMdWludH0gbGF5b3V0LnR5cGUgLSB0eXBlIG9mIHZhbHVlcyAoZS5nLiBnbC5GTE9BVClcbiAqIEBwYXJhbSB7R0xib29sfSBsYXlvdXQubm9ybWFsaXplZD1mYWxzZSAtIG5vcm1hbGl6ZSBpbnRlZ2VycyB0byBbLTEsMV0sIFswLDFdXG4gKiBAcGFyYW0ge0dMdWludH0gbGF5b3V0LmludGVnZXI9ZmFsc2UgLSBXZWJHTDIgb25seSwgZGlzYWJsZSBpbnQtdG8tZmxvYXQgY29udlxuICogQHBhcmFtIHtHTHVpbnR9IGxheW91dC5zdHJpZGU9MCAtIHN1cHBvcnRzIHN0cmlkZWQgYXJyYXlzXG4gKiBAcGFyYW0ge0dMdWludH0gbGF5b3V0Lm9mZnNldD0wIC0gc3VwcG9ydHMgc3RyaWRlZCBhcnJheXNcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIHNldEJ1ZmZlcih7XG4gIGdsLFxuICBsb2NhdGlvbixcbiAgYnVmZmVyLFxuICB0YXJnZXQsXG4gIGxheW91dFxufSA9IHt9KSB7XG4gIGFzc2VydFdlYkdMQ29udGV4dChnbCk7XG4gIGJ1ZmZlciA9IEJ1ZmZlci5tYWtlRnJvbShnbCwgYnVmZmVyKTtcblxuICAvLyBDb3B5IG1haW4gZGF0YSBjaGFyYWN0ZXJpc3RpY3MgZnJvbSBidWZmZXJcbiAgdGFyZ2V0ID0gZ2xHZXQodGFyZ2V0ICE9PSB1bmRlZmluZWQgPyB0YXJnZXQgOiBidWZmZXIudGFyZ2V0KTtcbiAgbGF5b3V0ID0gbGF5b3V0ICE9PSB1bmRlZmluZWQgPyBsYXlvdXQgOiBidWZmZXIubGF5b3V0O1xuICBhc3NlcnQodGFyZ2V0LCAnc2V0QnVmZmVyIG5lZWRzIHRhcmdldCcpO1xuICBhc3NlcnQobGF5b3V0LCAnc2V0QnVmZmVyIGNhbGxlZCBvbiB1bmluaXRpYWxpemVkIGJ1ZmZlcicpO1xuXG4gIC8vIGEgbm9uLXplcm8gbmFtZWQgYnVmZmVyIG9iamVjdCBtdXN0IGJlIGJvdW5kIHRvIHRoZSBHTF9BUlJBWV9CVUZGRVIgdGFyZ2V0XG4gIGJ1ZmZlci5iaW5kKHt0YXJnZXQ6IGdsLkFSUkFZX0JVRkZFUn0pO1xuXG4gIC8vIEF0dGFjaCBib3VuZCBBUlJBWV9CVUZGRVIgd2l0aCBzcGVjaWZpZWQgYnVmZmVyIGZvcm1hdCB0byBsb2NhdGlvblxuICBpZiAoIWxheW91dC5pbnRlZ2VyKSB7XG4gICAgZ2wudmVydGV4QXR0cmliUG9pbnRlcihcbiAgICAgIGxvY2F0aW9uLFxuICAgICAgbGF5b3V0LnNpemUsXG4gICAgICBnbEdldChsYXlvdXQudHlwZSksXG4gICAgICBsYXlvdXQubm9ybWFsaXplZCxcbiAgICAgIGxheW91dC5zdHJpZGUsXG4gICAgICBsYXlvdXQub2Zmc2V0XG4gICAgKTtcbiAgfSBlbHNlIHtcbiAgICAvLyBzcGVjaWZpZXMgKmludGVnZXIqIGRhdGEgZm9ybWF0cyBhbmQgbG9jYXRpb25zIG9mIHZlcnRleCBhdHRyaWJ1dGVzXG4gICAgLy8gRm9yIGdsVmVydGV4QXR0cmliSVBvaW50ZXIsIFZhbHVlcyBhcmUgYWx3YXlzIGxlZnQgYXMgaW50ZWdlciB2YWx1ZXMuXG4gICAgLy8gT25seSBhY2NlcHRzIHRoZSBpbnRlZ2VyIHR5cGVzIGdsLkJZVEUsIGdsLlVOU0lHTkVEX0JZVEUsXG4gICAgLy8gZ2wuU0hPUlQsIGdsLlVOU0lHTkVEX1NIT1JULCBnbC5JTlQsIGdsLlVOU0lHTkVEX0lOVFxuICAgIGFzc2VydFdlYkdMMkNvbnRleHQoZ2wpO1xuICAgIGdsLnZlcnRleEF0dHJpYklQb2ludGVyKFxuICAgICAgbG9jYXRpb24sXG4gICAgICBsYXlvdXQuc2l6ZSxcbiAgICAgIGdsR2V0KGxheW91dC50eXBlKSxcbiAgICAgIGxheW91dC5zdHJpZGUsXG4gICAgICBsYXlvdXQub2Zmc2V0XG4gICAgKTtcbiAgfVxuXG4gIGJ1ZmZlci51bmJpbmQoe3RhcmdldDogZ2wuQVJSQVlfQlVGRkVSfSk7XG59XG5cbi8qXG4gKiBTcGVjaWZ5IHZhbHVlcyBmb3IgZ2VuZXJpYyB2ZXJ0ZXggYXR0cmlidXRlc1xuICogR2VuZXJpYyB2ZXJ0ZXggYXR0cmlidXRlcyBhcmUgY29uc3RhbnQgZm9yIGFsbCB2ZXJ0aWNlc1xuICogVXAgdG8gNCB2YWx1ZXMgZGVwZW5kaW5nIG9uIGF0dHJpYnV0ZSBzaXplXG4gKlxuICogQHBhcmFtIHtXZWJHTFJlbmRlcmluZ0NvbnRleHR9IGdsIC0gd2ViZ2wgY29udGV4dFxuICogQHBhcmFtIHtHTHVpbnR9IGxvY2F0aW9uIC0gb3JkaW5hbCBudW1iZXIgb2YgdGhlIGF0dHJpYnV0ZVxuICogQHBhcmFtIHtHTHVpbnR9IGRpdmlzb3IgLSBpbnN0YW5jZXMgdGhhdCBwYXNzIGJldHdlZW4gdXBkYXRlcyBvZiBhdHRyaWJ1dGVcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIHNldEdlbmVyaWMoe2dsLCBsb2NhdGlvbiwgYXJyYXl9KSB7XG4gIGxvZy53YXJuKDAsICdWZXJ0ZXhBdHRyaWJ1dGVzLnNldEdlbmVyaWMgaXMgbm90IHdlbGwgdGVzdGVkJyk7XG4gIC8vIHRocm93IG5ldyBFcnJvcigndmVydGV4IGF0dHJpYnV0ZSBzaXplIG11c3QgYmUgYmV0d2VlbiAxIGFuZCA0Jyk7XG5cbiAgaWYgKGFycmF5IGluc3RhbmNlb2YgRmxvYXQzMkFycmF5KSB7XG4gICAgZ2wudmVydGV4QXR0cmliNGZ2KGxvY2F0aW9uLCBhcnJheSk7XG4gIH0gZWxzZSBpZiAoYXJyYXkgaW5zdGFuY2VvZiBJbnQzMkFycmF5KSB7XG4gICAgYXNzZXJ0V2ViR0wyQ29udGV4dChnbCk7XG4gICAgZ2wudmVydGV4QXR0cmliSTRpdihsb2NhdGlvbiwgYXJyYXkpO1xuICB9IGVsc2UgaWYgKGFycmF5IGluc3RhbmNlb2YgVWludDMyQXJyYXkpIHtcbiAgICBhc3NlcnRXZWJHTDJDb250ZXh0KGdsKTtcbiAgICBnbC52ZXJ0ZXhBdHRyaWJJNHVpdihsb2NhdGlvbiwgYXJyYXkpO1xuICB9XG59XG5cbi8qXG4gKiBTcGVjaWZ5IHZhbHVlcyBmb3IgZ2VuZXJpYyB2ZXJ0ZXggYXR0cmlidXRlc1xuICogR2VuZXJpYyB2ZXJ0ZXggYXR0cmlidXRlcyBhcmUgY29uc3RhbnQgZm9yIGFsbCB2ZXJ0aWNlc1xuICogVXAgdG8gNCB2YWx1ZXMgZGVwZW5kaW5nIG9uIGF0dHJpYnV0ZSBzaXplXG4gKlxuICogQHBhcmFtIHtHTHVpbnR9IGxvY2F0aW9uIC0gb3JkaW5hbCBudW1iZXIgb2YgdGhlIGF0dHJpYnV0ZVxuICogQHBhcmFtIHtHTHVpbnR9IGRpdmlzb3IgLSBpbnN0YW5jZXMgdGhhdCBwYXNzIGJldHdlZW4gdXBkYXRlcyBvZiBhdHRyaWJ1dGVcbiAqL1xuLyogZXNsaW50LWRpc2FibGUgbWF4LXBhcmFtcyAqL1xuZXhwb3J0IGZ1bmN0aW9uIHNldEdlbmVyaWNWYWx1ZXMoZ2wsIGxvY2F0aW9uLCB2MCwgdjEsIHYyLCB2Mykge1xuICBsb2cud2FybigwLCAnVmVydGV4QXR0cmlidXRlcy5zZXRHZW5lcmljVmFsdWVzIGlzIG5vdCB3ZWxsIHRlc3RlZCcpO1xuICBzd2l0Y2ggKGFyZ3VtZW50cy5sZW5ndGggLSAxKSB7XG4gIGNhc2UgMTogZ2wudmVydGV4QXR0cmliMWYobG9jYXRpb24sIHYwKTsgYnJlYWs7XG4gIGNhc2UgMjogZ2wudmVydGV4QXR0cmliMmYobG9jYXRpb24sIHYwLCB2MSk7IGJyZWFrO1xuICBjYXNlIDM6IGdsLnZlcnRleEF0dHJpYjNmKGxvY2F0aW9uLCB2MCwgdjEsIHYyKTsgYnJlYWs7XG4gIGNhc2UgNDogZ2wudmVydGV4QXR0cmliNGYobG9jYXRpb24sIHYwLCB2MSwgdjIsIHYzKTsgYnJlYWs7XG4gIGRlZmF1bHQ6XG4gICAgdGhyb3cgbmV3IEVycm9yKCd2ZXJ0ZXggYXR0cmlidXRlIHNpemUgbXVzdCBiZSBiZXR3ZWVuIDEgYW5kIDQnKTtcbiAgfVxuXG4gIC8vIGFzc2VydChnbCBpbnN0YW5jZW9mIFdlYkdMMlJlbmRlcmluZ0NvbnRleHQsICdXZWJHTDIgcmVxdWlyZWQnKTtcbiAgLy8gTG9va3MgbGlrZSB0aGVzZSB3aWxsIGNoZWNrIGhvdyBtYW55IGFyZ3VtZW50cyB3ZXJlIHN1cHBsaWVkP1xuICAvLyBnbC52ZXJ0ZXhBdHRyaWJJNGkobG9jYXRpb24sIHYwLCB2MSwgdjIsIHYzKTtcbiAgLy8gZ2wudmVydGV4QXR0cmliSTR1aShsb2NhdGlvbiwgdjAsIHYxLCB2MiwgdjMpO1xufVxuIl19

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.glArrayFromType = undefined;
	exports.glTypeFromArray = glTypeFromArray;
	exports.glTypeToArray = glTypeToArray;
	
	var _webglConstants = __webpack_require__(162);
	
	var _webglConstants2 = _interopRequireDefault(_webglConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TYPED ARRAYS
	
	function glTypeFromArray(arrayOrType) {
	  // If typed array, look up type name
	  var type = ArrayBuffer.isView(arrayOrType) ? arrayOrType.constructor : arrayOrType;
	
	  switch (type) {
	    case Float32Array:
	      return _webglConstants2.default.FLOAT;
	    case Uint16Array:
	      return _webglConstants2.default.UNSIGNED_SHORT;
	    case Uint32Array:
	      return _webglConstants2.default.UNSIGNED_INT;
	    case Uint8Array:
	      return _webglConstants2.default.UNSIGNED_BYTE;
	    case Uint8ClampedArray:
	      return _webglConstants2.default.UNSIGNED_BYTE;
	    case Int8Array:
	      return _webglConstants2.default.BYTE;
	    case Int16Array:
	      return _webglConstants2.default.SHORT;
	    case Int32Array:
	      return _webglConstants2.default.INT;
	    default:
	      throw new Error('Failed to deduce type from array/array type');
	  }
	}
	
	/* eslint-disable complexity */
	function glTypeToArray(glType) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$clamped = _ref.clamped,
	      clamped = _ref$clamped === undefined ? true : _ref$clamped;
	
	  // Sorted in some order of likelihood to reduce amount of comparisons
	  switch (glType) {
	    case _webglConstants2.default.FLOAT:
	      return Float32Array;
	    case _webglConstants2.default.UNSIGNED_SHORT:
	    case _webglConstants2.default.UNSIGNED_SHORT_5_6_5:
	    case _webglConstants2.default.UNSIGNED_SHORT_4_4_4_4:
	    case _webglConstants2.default.UNSIGNED_SHORT_5_5_5_1:
	      return Uint16Array;
	    case _webglConstants2.default.UNSIGNED_INT:
	      return Uint32Array;
	    case _webglConstants2.default.UNSIGNED_BYTE:
	      return clamped ? Uint8ClampedArray : Uint8Array;
	    case _webglConstants2.default.BYTE:
	      return Int8Array;
	    case _webglConstants2.default.SHORT:
	      return Int16Array;
	    case _webglConstants2.default.INT:
	      return Int32Array;
	    default:
	      throw new Error('Failed to deduce type from array');
	  }
	}
	/* eslint-enable complexity */
	
	// Deprecated
	exports.glArrayFromType = glTypeToArray;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.axisPropType = undefined;
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(108);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _reactMotion = __webpack_require__(25);
	
	var _hocs = __webpack_require__(52);
	
	var _axes = __webpack_require__(528);
	
	var _AxisTick = __webpack_require__(1072);
	
	var _AxisTick2 = _interopRequireDefault(_AxisTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axisPositions = ['top', 'right', 'bottom', 'left'];
	var legendPositions = ['start', 'center', 'end'];
	
	var axisPropType = exports.axisPropType = _propTypes2.default.shape({
	    orient: _propTypes2.default.oneOf(axisPositions),
	
	    // ticks
	    tickValues: _propTypes2.default.array,
	    tickSize: _propTypes2.default.number,
	    tickPadding: _propTypes2.default.number,
	    tickRotation: _propTypes2.default.number,
	    format: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	    // legend
	    legend: _propTypes2.default.string,
	    legendPosition: _propTypes2.default.oneOf(legendPositions),
	    legendOffset: _propTypes2.default.number
	});
	
	var willEnter = function willEnter() {
	    return {
	        opacity: 0,
	        x: 0,
	        y: 0
	    };
	};
	
	var willLeave = function willLeave(springConfig) {
	    return function (_ref) {
	        var _ref$style = _ref.style,
	            x = _ref$style.x,
	            y = _ref$style.y;
	        return {
	            opacity: (0, _reactMotion.spring)(0, springConfig),
	            x: (0, _reactMotion.spring)(x.val, springConfig),
	            y: (0, _reactMotion.spring)(y.val, springConfig)
	        };
	    };
	};
	
	var Axis = function Axis(_ref2) {
	    var scale = _ref2.scale,
	        width = _ref2.width,
	        height = _ref2.height,
	        _position = _ref2.position,
	        tickValues = _ref2.tickValues,
	        tickCount = _ref2.tickCount,
	        tickSize = _ref2.tickSize,
	        tickPadding = _ref2.tickPadding,
	        tickRotation = _ref2.tickRotation,
	        format = _ref2.format,
	        _legend = _ref2.legend,
	        legendPosition = _ref2.legendPosition,
	        legendOffset = _ref2.legendOffset,
	        theme = _ref2.theme,
	        animate = _ref2.animate,
	        motionStiffness = _ref2.motionStiffness,
	        motionDamping = _ref2.motionDamping,
	        onClick = _ref2.onClick;
	
	    var _computeAxisTicks = (0, _axes.computeAxisTicks)({
	        width: width,
	        height: height,
	        scale: scale,
	        position: _position,
	        tickValues: tickValues,
	        tickCount: tickCount,
	        tickSize: tickSize,
	        tickPadding: tickPadding,
	        tickRotation: tickRotation
	    }),
	        x = _computeAxisTicks.x,
	        y = _computeAxisTicks.y,
	        ticks = _computeAxisTicks.ticks,
	        textAlign = _computeAxisTicks.textAlign,
	        textBaseline = _computeAxisTicks.textBaseline;
	
	    var legend = null;
	    if (_legend !== undefined) {
	        var legendX = 0;
	        var legendY = 0;
	        var legendRotation = 0;
	        var textAnchor = void 0;
	
	        if (['left', 'right'].includes(_position)) {
	            legendRotation = -90;
	            legendX = legendOffset;
	            if (legendPosition === 'start') {
	                textAnchor = 'start';
	                legendY = height;
	            } else if (legendPosition === 'center') {
	                textAnchor = 'middle';
	                legendY = height / 2;
	            } else if (legendPosition === 'end') {
	                textAnchor = 'end';
	            }
	        } else {
	            legendY = legendOffset;
	            if (legendPosition === 'start') {
	                textAnchor = 'start';
	            } else if (legendPosition === 'center') {
	                textAnchor = 'middle';
	                legendX = width / 2;
	            } else if (legendPosition === 'end') {
	                textAnchor = 'end';
	                legendX = width;
	            }
	        }
	
	        legend = _react2.default.createElement(
	            'text',
	            {
	                fill: theme.axis.legendColor,
	                transform: 'translate(' + legendX + ', ' + legendY + ') rotate(' + legendRotation + ')',
	                textAnchor: textAnchor,
	                style: { fontSize: theme.axis.legendFontSize }
	            },
	            _legend
	        );
	    }
	
	    var tickElements = void 0;
	    if (!animate) {
	        tickElements = _react2.default.createElement(
	            'g',
	            null,
	            ticks.map(function (tick) {
	                return _react2.default.createElement(_AxisTick2.default, _extends({
	                    key: tick.key,
	                    value: tick.key,
	                    format: format,
	                    lineX: tick.lineX,
	                    lineY: tick.lineY,
	                    rotate: tickRotation,
	                    textX: tick.textX,
	                    textY: tick.textY,
	                    textBaseline: textBaseline,
	                    textAnchor: textAlign,
	                    theme: theme,
	                    x: tick.x,
	                    y: tick.y
	                }, onClick ? { onClick: onClick } : {}));
	            })
	        );
	    } else {
	        var springConfig = {
	            stiffness: motionStiffness,
	            damping: motionDamping
	        };
	
	        tickElements = _react2.default.createElement(
	            _reactMotion.TransitionMotion,
	            {
	                willEnter: willEnter,
	                willLeave: willLeave(springConfig),
	                styles: ticks.map(function (tick) {
	                    return {
	                        key: '' + tick.key,
	                        data: tick,
	                        style: {
	                            opacity: (0, _reactMotion.spring)(1, springConfig),
	                            x: (0, _reactMotion.spring)(tick.x, springConfig),
	                            y: (0, _reactMotion.spring)(tick.y, springConfig)
	                        }
	                    };
	                })
	            },
	            function (interpolatedStyles) {
	                return _react2.default.createElement(
	                    'g',
	                    null,
	                    interpolatedStyles.map(function (_ref3) {
	                        var key = _ref3.key,
	                            style = _ref3.style,
	                            tick = _ref3.data;
	                        return _react2.default.createElement(_AxisTick2.default, _extends({
	                            key: key,
	                            value: key,
	                            format: format,
	                            lineX: tick.lineX,
	                            lineY: tick.lineY,
	                            rotate: tickRotation,
	                            textX: tick.textX,
	                            textY: tick.textY,
	                            textBaseline: textBaseline,
	                            textAnchor: textAlign,
	                            theme: theme
	                        }, onClick ? { onClick: onClick } : {}, style));
	                    })
	                );
	            }
	        );
	    }
	
	    return _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + x + ',' + y + ')' },
	        legend,
	        tickElements
	    );
	};
	
	Axis.propTypes = {
	    // generic
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	    position: _propTypes2.default.oneOf(axisPositions).isRequired,
	    scale: _propTypes2.default.func.isRequired,
	
	    // ticks
	    tickValues: _propTypes2.default.array,
	    tickCount: _propTypes2.default.number,
	    tickSize: _propTypes2.default.number.isRequired,
	    tickPadding: _propTypes2.default.number.isRequired,
	    tickRotation: _propTypes2.default.number.isRequired,
	    format: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	    // legend
	    legend: _propTypes2.default.string,
	    legendPosition: _propTypes2.default.oneOf(legendPositions).isRequired,
	    legendOffset: _propTypes2.default.number.isRequired,
	
	    // theming
	    theme: _propTypes2.default.object.isRequired,
	
	    // interactivity
	    onClick: _propTypes2.default.func
	};
	
	Axis.defaultProps = {
	    // ticks
	    tickSize: 5,
	    tickPadding: 5,
	    tickRotation: 0,
	
	    // legend
	    legendPosition: 'end',
	    legendOffset: 0
	};
	
	var enhance = (0, _compose2.default)((0, _hocs.withMotion)(), (0, _withPropsOnChange2.default)(['format'], function (_ref4) {
	    var format = _ref4.format;
	
	    if (!format || (0, _isFunction3.default)(format)) return { format: format };
	    return { format: (0, _d3Format.format)(format) };
	}), _pure2.default);
	
	exports.default = enhance(Axis);

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _CartesianMarkersItem = __webpack_require__(1076);
	
	var _CartesianMarkersItem2 = _interopRequireDefault(_CartesianMarkersItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CartesianMarkers = function CartesianMarkers(_ref) {
	    var markers = _ref.markers,
	        width = _ref.width,
	        height = _ref.height,
	        xScale = _ref.xScale,
	        yScale = _ref.yScale,
	        theme = _ref.theme;
	
	    if (!markers || markers.length === 0) return null;
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        markers.map(function (marker, i) {
	            return _react2.default.createElement(_CartesianMarkersItem2.default, _extends({
	                key: i
	            }, marker, {
	                width: width,
	                height: height,
	                scale: marker.axis === 'y' ? yScale : xScale,
	                theme: theme
	            }));
	        })
	    );
	};
	
	CartesianMarkers.propTypes = {
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	
	    xScale: _propTypes2.default.func.isRequired,
	    yScale: _propTypes2.default.func.isRequired,
	
	    theme: _propTypes2.default.shape({
	        markers: _propTypes2.default.shape({
	            lineColor: _propTypes2.default.string.isRequired,
	            lineStrokeWidth: _propTypes2.default.number.isRequired,
	            textColor: _propTypes2.default.string.isRequired,
	            fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired
	        }).isRequired
	    }).isRequired,
	
	    markers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        axis: _propTypes2.default.oneOf(['x', 'y']).isRequired,
	        value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	        style: _propTypes2.default.object
	    }))
	};
	
	exports.default = (0, _pure2.default)(CartesianMarkers);

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(25);
	
	var _defs = __webpack_require__(168);
	
	var _bar = __webpack_require__(532);
	
	var _enhance = __webpack_require__(494);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _props = __webpack_require__(219);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _Grid = __webpack_require__(165);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _CartesianMarkers = __webpack_require__(491);
	
	var _CartesianMarkers2 = _interopRequireDefault(_CartesianMarkers);
	
	var _Axes = __webpack_require__(164);
	
	var _Axes2 = _interopRequireDefault(_Axes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var barWillEnterHorizontal = function barWillEnterHorizontal(_ref) {
	    var style = _ref.style;
	    return {
	        x: style.x.val,
	        y: style.y.val,
	        width: 0,
	        height: style.height.val
	    };
	};
	
	var barWillEnterVertical = function barWillEnterVertical(_ref2) {
	    var style = _ref2.style;
	    return {
	        x: style.x.val,
	        y: style.y.val + style.height.val,
	        width: style.width.val,
	        height: 0
	    };
	};
	
	var barWillLeaveHorizontal = function barWillLeaveHorizontal(springConfig) {
	    return function (_ref3) {
	        var style = _ref3.style;
	        return {
	            x: style.x,
	            y: style.y,
	            width: (0, _reactMotion.spring)(0, springConfig),
	            height: style.height
	        };
	    };
	};
	
	var barWillLeaveVertical = function barWillLeaveVertical(springConfig) {
	    return function (_ref4) {
	        var style = _ref4.style;
	        return {
	            x: style.x,
	            y: (0, _reactMotion.spring)(style.y.val + style.height.val, springConfig),
	            width: style.width,
	            height: (0, _reactMotion.spring)(0, springConfig)
	        };
	    };
	};
	
	var Bar = function Bar(_ref5) {
	    var data = _ref5.data,
	        getIndex = _ref5.getIndex,
	        keys = _ref5.keys,
	        groupMode = _ref5.groupMode,
	        layout = _ref5.layout,
	        reverse = _ref5.reverse,
	        minValue = _ref5.minValue,
	        maxValue = _ref5.maxValue,
	        margin = _ref5.margin,
	        width = _ref5.width,
	        height = _ref5.height,
	        outerWidth = _ref5.outerWidth,
	        outerHeight = _ref5.outerHeight,
	        padding = _ref5.padding,
	        innerPadding = _ref5.innerPadding,
	        axisTop = _ref5.axisTop,
	        axisRight = _ref5.axisRight,
	        axisBottom = _ref5.axisBottom,
	        axisLeft = _ref5.axisLeft,
	        enableGridX = _ref5.enableGridX,
	        enableGridY = _ref5.enableGridY,
	        barComponent = _ref5.barComponent,
	        enableLabel = _ref5.enableLabel,
	        getLabel = _ref5.getLabel,
	        labelSkipWidth = _ref5.labelSkipWidth,
	        labelSkipHeight = _ref5.labelSkipHeight,
	        getLabelTextColor = _ref5.getLabelTextColor,
	        markers = _ref5.markers,
	        theme = _ref5.theme,
	        getColor = _ref5.getColor,
	        defs = _ref5.defs,
	        fill = _ref5.fill,
	        borderRadius = _ref5.borderRadius,
	        borderWidth = _ref5.borderWidth,
	        getBorderColor = _ref5.getBorderColor,
	        animate = _ref5.animate,
	        motionStiffness = _ref5.motionStiffness,
	        motionDamping = _ref5.motionDamping,
	        isInteractive = _ref5.isInteractive,
	        tooltipFormat = _ref5.tooltipFormat,
	        onClick = _ref5.onClick;
	
	    var options = {
	        layout: layout,
	        reverse: reverse,
	        data: data,
	        getIndex: getIndex,
	        keys: keys,
	        minValue: minValue,
	        maxValue: maxValue,
	        width: width,
	        height: height,
	        getColor: getColor,
	        padding: padding,
	        innerPadding: innerPadding
	    };
	    var result = groupMode === 'grouped' ? (0, _bar.generateGroupedBars)(options) : (0, _bar.generateStackedBars)(options);
	
	    var motionProps = {
	        animate: animate,
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    var springConfig = {
	        damping: motionDamping,
	        stiffness: motionStiffness
	    };
	
	    var willEnter = layout === 'vertical' ? barWillEnterVertical : barWillEnterHorizontal;
	    var willLeave = layout === 'vertical' ? barWillLeaveVertical(springConfig) : barWillLeaveHorizontal(springConfig);
	
	    var shouldRenderLabel = function shouldRenderLabel(_ref6) {
	        var width = _ref6.width,
	            height = _ref6.height;
	
	        if (!enableLabel) return false;
	        if (labelSkipWidth > 0 && width < labelSkipWidth) return false;
	        if (labelSkipHeight > 0 && height < labelSkipHeight) return false;
	        return true;
	    };
	
	    var boundDefs = (0, _defs.bindDefs)(defs, result.bars, fill, {
	        dataKey: 'data',
	        targetKey: 'data.fill'
	    });
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref7) {
	            var showTooltip = _ref7.showTooltip,
	                hideTooltip = _ref7.hideTooltip;
	
	            var commonProps = {
	                borderRadius: borderRadius,
	                borderWidth: borderWidth,
	                enableLabel: enableLabel,
	                labelSkipWidth: labelSkipWidth,
	                labelSkipHeight: labelSkipHeight,
	                showTooltip: showTooltip,
	                hideTooltip: hideTooltip,
	                onClick: onClick,
	                theme: theme,
	                tooltipFormat: tooltipFormat
	            };
	
	            var bars = void 0;
	            if (animate === true) {
	                bars = _react2.default.createElement(
	                    _reactMotion.TransitionMotion,
	                    {
	                        willEnter: willEnter,
	                        willLeave: willLeave,
	                        styles: result.bars.map(function (bar) {
	                            return {
	                                key: bar.key,
	                                data: bar,
	                                style: {
	                                    x: (0, _reactMotion.spring)(bar.x, springConfig),
	                                    y: (0, _reactMotion.spring)(bar.y, springConfig),
	                                    width: (0, _reactMotion.spring)(bar.width, springConfig),
	                                    height: (0, _reactMotion.spring)(bar.height, springConfig)
	                                }
	                            };
	                        })
	                    },
	                    function (interpolatedStyles) {
	                        return _react2.default.createElement(
	                            'g',
	                            null,
	                            interpolatedStyles.map(function (_ref8) {
	                                var key = _ref8.key,
	                                    style = _ref8.style,
	                                    bar = _ref8.data;
	
	                                var baseProps = _extends({}, bar, style);
	
	                                return _react2.default.createElement(barComponent, _extends({
	                                    key: key
	                                }, baseProps, commonProps, {
	                                    shouldRenderLabel: shouldRenderLabel(baseProps),
	                                    width: Math.max(style.width, 0),
	                                    height: Math.max(style.height, 0),
	                                    label: getLabel(bar.data),
	                                    labelColor: getLabelTextColor(baseProps, theme),
	                                    borderColor: getBorderColor(baseProps)
	                                }));
	                            })
	                        );
	                    }
	                );
	            } else {
	                bars = result.bars.map(function (d) {
	                    return _react2.default.createElement(barComponent, _extends({
	                        key: d.key
	                    }, d, commonProps, {
	                        label: getLabel(d.data),
	                        shouldRenderLabel: shouldRenderLabel(d),
	                        labelColor: getLabelTextColor(d, theme),
	                        borderColor: getBorderColor(d)
	                    }));
	                });
	            }
	
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                {
	                    width: outerWidth,
	                    height: outerHeight,
	                    margin: margin,
	                    defs: boundDefs
	                },
	                _react2.default.createElement(_Grid2.default, _extends({
	                    theme: theme,
	                    width: width,
	                    height: height,
	                    xScale: enableGridX ? result.xScale : null,
	                    yScale: enableGridY ? result.yScale : null
	                }, motionProps)),
	                _react2.default.createElement(_Axes2.default, _extends({
	                    xScale: result.xScale,
	                    yScale: result.yScale,
	                    width: width,
	                    height: height,
	                    theme: theme,
	                    top: axisTop,
	                    right: axisRight,
	                    bottom: axisBottom,
	                    left: axisLeft
	                }, motionProps)),
	                bars,
	                _react2.default.createElement(_CartesianMarkers2.default, {
	                    markers: markers,
	                    width: width,
	                    height: height,
	                    xScale: result.xScale,
	                    yScale: result.yScale,
	                    theme: theme
	                })
	            );
	        }
	    );
	};
	
	Bar.propTypes = _props.BarPropTypes;
	
	exports.default = (0, _enhance2.default)(Bar);

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bar = __webpack_require__(532);
	
	var _axes = __webpack_require__(530);
	
	var _interactivity = __webpack_require__(224);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	var _props2 = __webpack_require__(219);
	
	var _enhance = __webpack_require__(494);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var findNodeUnderCursor = function findNodeUnderCursor(nodes, margin, x, y) {
	    return nodes.find(function (node) {
	        return (0, _interactivity.isCursorInRect)(node.x + margin.left, node.y + margin.top, node.width, node.height, x, y);
	    });
	};
	
	var BarCanvas = function (_Component) {
	    _inherits(BarCanvas, _Component);
	
	    function BarCanvas() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, BarCanvas);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleMouseHover = function (showTooltip, hideTooltip) {
	            return function (event) {
	                if (!_this.bars) return;
	
	                var _this$props = _this.props,
	                    margin = _this$props.margin,
	                    theme = _this$props.theme;
	
	                var _getRelativeCursor = (0, _interactivity.getRelativeCursor)(_this.surface, event),
	                    x = _getRelativeCursor[0],
	                    y = _getRelativeCursor[1];
	
	                var bar = findNodeUnderCursor(_this.bars, margin, x, y);
	
	                if (bar !== undefined) {
	                    showTooltip(_react2.default.createElement(_BasicTooltip2.default, {
	                        id: bar.data.id + ' - ' + bar.data.indexValue,
	                        value: bar.data.value,
	                        enableChip: true,
	                        color: bar.color,
	                        theme: theme
	                    }), event);
	                } else {
	                    hideTooltip();
	                }
	            };
	        }, _this.handleMouseLeave = function (hideTooltip) {
	            return function () {
	                hideTooltip();
	            };
	        }, _this.handleClick = function (event) {
	            if (!_this.bars) return;
	
	            var _this$props2 = _this.props,
	                margin = _this$props2.margin,
	                onClick = _this$props2.onClick;
	
	            var _getRelativeCursor2 = (0, _interactivity.getRelativeCursor)(_this.surface, event),
	                x = _getRelativeCursor2[0],
	                y = _getRelativeCursor2[1];
	
	            var node = findNodeUnderCursor(_this.bars, margin, x, y);
	            if (node !== undefined) onClick(node.data, event);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    BarCanvas.prototype.componentDidMount = function componentDidMount() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    BarCanvas.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
	        if (this.props.outerWidth !== props.outerWidth || this.props.outerHeight !== props.outerHeight || this.props.isInteractive !== props.isInteractive || this.props.theme !== props.theme) {
	            return true;
	        } else {
	            this.draw(props);
	            return false;
	        }
	    };
	
	    BarCanvas.prototype.componentDidUpdate = function componentDidUpdate() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    BarCanvas.prototype.draw = function draw(props) {
	        var _this2 = this;
	
	        var data = props.data,
	            keys = props.keys,
	            getIndex = props.getIndex,
	            minValue = props.minValue,
	            maxValue = props.maxValue,
	            width = props.width,
	            height = props.height,
	            outerWidth = props.outerWidth,
	            outerHeight = props.outerHeight,
	            pixelRatio = props.pixelRatio,
	            margin = props.margin,
	            layout = props.layout,
	            reverse = props.reverse,
	            groupMode = props.groupMode,
	            padding = props.padding,
	            innerPadding = props.innerPadding,
	            axisTop = props.axisTop,
	            axisRight = props.axisRight,
	            axisBottom = props.axisBottom,
	            axisLeft = props.axisLeft,
	            getColor = props.getColor;
	
	
	        this.surface.width = outerWidth * pixelRatio;
	        this.surface.height = outerHeight * pixelRatio;
	
	        this.ctx.scale(pixelRatio, pixelRatio);
	
	        var options = {
	            layout: layout,
	            reverse: reverse,
	            data: data,
	            getIndex: getIndex,
	            keys: keys,
	            minValue: minValue,
	            maxValue: maxValue,
	            width: width,
	            height: height,
	            getColor: getColor,
	            padding: padding,
	            innerPadding: innerPadding
	        };
	
	        var result = groupMode === 'grouped' ? (0, _bar.generateGroupedBars)(options) : (0, _bar.generateStackedBars)(options);
	
	        this.bars = result.bars;
	
	        this.ctx.clearRect(0, 0, outerWidth, outerHeight);
	        this.ctx.translate(margin.left, margin.top);
	
	        (0, _axes.renderAxes)(this.ctx, {
	            xScale: result.xScale,
	            yScale: result.yScale,
	            width: width,
	            height: height,
	            top: axisTop,
	            right: axisRight,
	            bottom: axisBottom,
	            left: axisLeft
	        });
	
	        result.bars.forEach(function (_ref) {
	            var x = _ref.x,
	                y = _ref.y,
	                color = _ref.color,
	                width = _ref.width,
	                height = _ref.height;
	
	            _this2.ctx.fillStyle = color;
	            _this2.ctx.fillRect(x, y, width, height);
	        });
	    };
	
	    BarCanvas.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            outerWidth = _props.outerWidth,
	            outerHeight = _props.outerHeight,
	            pixelRatio = _props.pixelRatio,
	            isInteractive = _props.isInteractive,
	            theme = _props.theme;
	
	
	        return _react2.default.createElement(
	            _Container2.default,
	            { isInteractive: isInteractive, theme: theme },
	            function (_ref2) {
	                var showTooltip = _ref2.showTooltip,
	                    hideTooltip = _ref2.hideTooltip;
	                return _react2.default.createElement('canvas', {
	                    ref: function ref(surface) {
	                        _this3.surface = surface;
	                    },
	                    width: outerWidth * pixelRatio,
	                    height: outerHeight * pixelRatio,
	                    style: {
	                        width: outerWidth,
	                        height: outerHeight
	                    },
	                    onMouseEnter: _this3.handleMouseHover(showTooltip, hideTooltip),
	                    onMouseMove: _this3.handleMouseHover(showTooltip, hideTooltip),
	                    onMouseLeave: _this3.handleMouseLeave(hideTooltip),
	                    onClick: _this3.handleClick
	                });
	            }
	        );
	    };
	
	    return BarCanvas;
	}(_react.Component);
	
	BarCanvas.propTypes = _props2.BarPropTypes;
	
	exports.default = (0, _enhance2.default)(BarCanvas);

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _hocs = __webpack_require__(52);
	
	var _colors = __webpack_require__(24);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _props = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *d
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	exports.default = function (Component) {
	    return (0, _compose2.default)((0, _defaultProps2.default)(_props.BarDefaultProps), (0, _hocs.withTheme)(), (0, _hocs.withColors)(), (0, _hocs.withDimensions)(), (0, _hocs.withMotion)(), (0, _withPropsOnChange2.default)(['indexBy'], function (_ref) {
	        var indexBy = _ref.indexBy;
	        return {
	            getIndex: (0, _propertiesConverters.getAccessorFor)(indexBy)
	        };
	    }), (0, _withPropsOnChange2.default)(['labelTextColor'], function (_ref2) {
	        var labelTextColor = _ref2.labelTextColor;
	        return {
	            getLabelTextColor: (0, _colors.getInheritedColorGenerator)(labelTextColor, 'axis.textColor')
	        };
	    }), (0, _withPropsOnChange2.default)(['labelLinkColor'], function (_ref3) {
	        var labelLinkColor = _ref3.labelLinkColor;
	        return {
	            getLabelLinkColor: (0, _colors.getInheritedColorGenerator)(labelLinkColor, 'axis.tickColor')
	        };
	    }), (0, _withPropsOnChange2.default)(['label', 'labelFormat'], function (_ref4) {
	        var label = _ref4.label,
	            labelFormat = _ref4.labelFormat;
	        return {
	            getLabel: (0, _propertiesConverters.getLabelGenerator)(label, labelFormat)
	        };
	    }), (0, _withPropsOnChange2.default)(['borderColor'], function (_ref5) {
	        var borderColor = _ref5.borderColor;
	        return {
	            getBorderColor: (0, _colors.getInheritedColorGenerator)(borderColor)
	        };
	    }), _pure2.default)(Component);
	};

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(25);
	
	var _pick = __webpack_require__(94);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _colors = __webpack_require__(24);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _enhance = __webpack_require__(303);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _motion = __webpack_require__(499);
	
	var _interactivity = __webpack_require__(498);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bubble = function Bubble(_ref) {
	    var nodes = _ref.nodes,
	        nodeComponent = _ref.nodeComponent,
	        margin = _ref.margin,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        theme = _ref.theme,
	        borderWidth = _ref.borderWidth,
	        getBorderColor = _ref.getBorderColor,
	        defs = _ref.defs,
	        getLabelTextColor = _ref.getLabelTextColor,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping,
	        isInteractive = _ref.isInteractive,
	        onClick = _ref.onClick,
	        tooltipFormat = _ref.tooltipFormat,
	        isZoomable = _ref.isZoomable,
	        zoomToNode = _ref.zoomToNode;
	
	    var springConfig = {
	        stiffness: motionStiffness,
	        damping: motionDamping
	    };
	
	    var getHandlers = function getHandlers(node, showTooltip, hideTooltip) {
	        return (0, _interactivity.getNodeHandlers)(node, {
	            isInteractive: isInteractive,
	            onClick: onClick,
	            showTooltip: showTooltip,
	            hideTooltip: hideTooltip,
	            isZoomable: isZoomable,
	            zoomToNode: zoomToNode,
	            theme: theme,
	            tooltipFormat: tooltipFormat
	        });
	    };
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                { width: outerWidth, height: outerHeight, margin: margin, defs: defs },
	                !animate && _react2.default.createElement(
	                    'g',
	                    null,
	                    nodes.map(function (node) {
	                        return _react2.default.createElement(nodeComponent, {
	                            key: node.path,
	                            node: node,
	                            style: _extends({}, (0, _pick2.default)(node, ['scale', 'r', 'x', 'y', 'color']), {
	                                fill: node.fill,
	                                borderWidth: borderWidth,
	                                borderColor: getBorderColor(node),
	                                labelTextColor: getLabelTextColor(node)
	                            }),
	                            handlers: getHandlers(node, showTooltip, hideTooltip)
	                        });
	                    })
	                ),
	                animate && _react2.default.createElement(
	                    _reactMotion.TransitionMotion,
	                    {
	                        willEnter: _motion.nodeWillEnter,
	                        willLeave: (0, _motion.nodeWillLeave)(springConfig),
	                        styles: nodes.map(function (node) {
	                            return {
	                                key: node.path,
	                                data: node,
	                                style: _extends({
	                                    scale: (0, _reactMotion.spring)(1, springConfig),
	                                    r: (0, _reactMotion.spring)(node.r, springConfig),
	                                    x: (0, _reactMotion.spring)(node.x, springConfig),
	                                    y: (0, _reactMotion.spring)(node.y, springConfig),
	                                    opacity: (0, _reactMotion.spring)(1, springConfig)
	                                }, (0, _colors.colorMotionSpring)(node.color, springConfig))
	                            };
	                        })
	                    },
	                    function (interpolatedStyles) {
	                        return _react2.default.createElement(
	                            'g',
	                            null,
	                            interpolatedStyles.map(function (_ref3) {
	                                var style = _ref3.style,
	                                    node = _ref3.data;
	
	                                style.color = (0, _colors.getInterpolatedColor)(style);
	
	                                return _react2.default.createElement(nodeComponent, {
	                                    key: node.path,
	                                    node: node,
	                                    style: _extends({}, style, {
	                                        fill: node.fill,
	                                        borderWidth: borderWidth,
	                                        borderColor: getBorderColor(style),
	                                        labelTextColor: getLabelTextColor(style)
	                                    }),
	                                    handlers: getHandlers(node, showTooltip, hideTooltip)
	                                });
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    );
	};
	
	Bubble.displayName = 'Bubble';
	
	exports.default = (0, _enhance2.default)(Bubble);

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _enhance = __webpack_require__(303);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var BubbleCanvas = function (_Component) {
	    _inherits(BubbleCanvas, _Component);
	
	    function BubbleCanvas() {
	        _classCallCheck(this, BubbleCanvas);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    BubbleCanvas.prototype.componentDidMount = function componentDidMount() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    BubbleCanvas.prototype.componentDidUpdate = function componentDidUpdate() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    BubbleCanvas.prototype.draw = function draw(props) {
	        var _this2 = this;
	
	        var nodes = props.nodes,
	            pixelRatio = props.pixelRatio,
	            margin = props.margin,
	            outerWidth = props.outerWidth,
	            outerHeight = props.outerHeight,
	            borderWidth = props.borderWidth,
	            getBorderColor = props.getBorderColor,
	            enableLabel = props.enableLabel,
	            getLabel = props.getLabel,
	            labelSkipRadius = props.labelSkipRadius,
	            getLabelTextColor = props.getLabelTextColor;
	
	
	        this.surface.width = outerWidth * pixelRatio;
	        this.surface.height = outerHeight * pixelRatio;
	
	        this.ctx.scale(pixelRatio, pixelRatio);
	        this.ctx.clearRect(0, 0, outerWidth, outerHeight);
	        this.ctx.translate(margin.left, margin.top);
	
	        /*
	        Could be used to compute metaballs,
	        grouping nodes by depth + common parent
	        using marching squares, but it really is a bonus feature…
	         const maxDepth = _.maxBy(nodes, 'depth').depth
	        const nodesByDepth = _.range(maxDepth + 1).map(depth =>
	            _.values(
	                _.groupBy(nodes.filter(({ depth: nodeDepth }) => nodeDepth === depth), 'parent.id')
	            )
	        )
	        nodesByDepth.forEach(layer => {
	            layer.forEach(node => {
	                console.log(node)
	            })
	        })
	        */
	
	        nodes.forEach(function (node) {
	            _this2.ctx.save();
	
	            if (borderWidth > 0) {
	                _this2.ctx.strokeStyle = getBorderColor(node);
	                _this2.ctx.lineWidth = borderWidth;
	            }
	
	            _this2.ctx.beginPath();
	            _this2.ctx.arc(node.x, node.y, node.r, 0, 2 * Math.PI);
	            _this2.ctx.fillStyle = node.color;
	            _this2.ctx.fill();
	
	            if (borderWidth > 0) {
	                _this2.ctx.stroke();
	            }
	        });
	
	        if (enableLabel) {
	            this.ctx.textAlign = 'center';
	            this.ctx.textBaseline = 'middle';
	
	            // draw labels on top
	            nodes.filter(function (_ref) {
	                var r = _ref.r;
	                return r > labelSkipRadius;
	            }).forEach(function (node) {
	                var label = getLabel(node);
	                var labelTextColor = getLabelTextColor(node);
	
	                _this2.ctx.fillStyle = labelTextColor;
	                _this2.ctx.fillText(label, node.x, node.y);
	            });
	        }
	    };
	
	    BubbleCanvas.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            outerWidth = _props.outerWidth,
	            outerHeight = _props.outerHeight,
	            pixelRatio = _props.pixelRatio,
	            isInteractive = _props.isInteractive,
	            theme = _props.theme;
	
	
	        return _react2.default.createElement(
	            _Container2.default,
	            { isInteractive: isInteractive, theme: theme },
	            function (_ref2) {
	                var showTooltip = _ref2.showTooltip,
	                    hideTooltip = _ref2.hideTooltip;
	                return _react2.default.createElement('canvas', {
	                    ref: function ref(surface) {
	                        _this3.surface = surface;
	                    },
	                    width: outerWidth * pixelRatio,
	                    height: outerHeight * pixelRatio,
	                    style: {
	                        width: outerWidth,
	                        height: outerHeight
	                    }
	                });
	            }
	        );
	    };
	
	    return BubbleCanvas;
	}(_react.Component);
	
	BubbleCanvas.displayName = 'BubbleCanvas';
	
	exports.default = (0, _enhance2.default)(BubbleCanvas);

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(25);
	
	var _pick = __webpack_require__(94);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _colors = __webpack_require__(24);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _enhance = __webpack_require__(303);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _motion = __webpack_require__(499);
	
	var _interactivity = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BubbleHtml = function BubbleHtml(_ref) {
	    var nodes = _ref.nodes,
	        nodeComponent = _ref.nodeComponent,
	        margin = _ref.margin,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        theme = _ref.theme,
	        borderWidth = _ref.borderWidth,
	        getBorderColor = _ref.getBorderColor,
	        getLabelTextColor = _ref.getLabelTextColor,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping,
	        isInteractive = _ref.isInteractive,
	        onClick = _ref.onClick,
	        isZoomable = _ref.isZoomable,
	        zoomToNode = _ref.zoomToNode;
	
	    var springConfig = {
	        stiffness: motionStiffness,
	        damping: motionDamping
	    };
	
	    var getHandlers = function getHandlers(node, showTooltip, hideTooltip) {
	        return (0, _interactivity.getNodeHandlers)(node, {
	            isInteractive: isInteractive,
	            onClick: onClick,
	            showTooltip: showTooltip,
	            hideTooltip: hideTooltip,
	            isZoomable: isZoomable,
	            zoomToNode: zoomToNode,
	            theme: theme
	        });
	    };
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        position: 'relative',
	                        width: outerWidth,
	                        height: outerHeight
	                    }
	                },
	                !animate && _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: margin.top, left: margin.left } },
	                    nodes.map(function (node) {
	                        return _react2.default.createElement(nodeComponent, {
	                            key: node.path,
	                            node: node,
	                            style: _extends({}, (0, _pick2.default)(node, ['scale', 'r', 'x', 'y', 'color']), {
	                                borderWidth: borderWidth,
	                                borderColor: getBorderColor(node),
	                                labelTextColor: getLabelTextColor(node)
	                            }),
	                            handlers: getHandlers(node, showTooltip, hideTooltip)
	                        });
	                    })
	                ),
	                animate && _react2.default.createElement(
	                    _reactMotion.TransitionMotion,
	                    {
	                        willEnter: _motion.nodeWillEnter,
	                        willLeave: (0, _motion.nodeWillLeave)(springConfig),
	                        styles: nodes.map(function (node) {
	                            return {
	                                key: node.path,
	                                data: node,
	                                style: _extends({
	                                    scale: (0, _reactMotion.spring)(1, springConfig),
	                                    r: (0, _reactMotion.spring)(node.r, springConfig),
	                                    x: (0, _reactMotion.spring)(node.x, springConfig),
	                                    y: (0, _reactMotion.spring)(node.y, springConfig),
	                                    opacity: (0, _reactMotion.spring)(1, springConfig)
	                                }, (0, _colors.colorMotionSpring)(node.color, springConfig))
	                            };
	                        })
	                    },
	                    function (interpolatedStyles) {
	                        return _react2.default.createElement(
	                            'div',
	                            {
	                                style: {
	                                    position: 'absolute',
	                                    top: margin.top,
	                                    left: margin.left
	                                }
	                            },
	                            interpolatedStyles.map(function (_ref3) {
	                                var style = _ref3.style,
	                                    node = _ref3.data;
	
	                                style.color = (0, _colors.getInterpolatedColor)(style);
	
	                                return _react2.default.createElement(nodeComponent, {
	                                    key: node.path,
	                                    node: node,
	                                    style: _extends({}, style, {
	                                        borderWidth: borderWidth,
	                                        borderColor: getBorderColor(style),
	                                        labelTextColor: getLabelTextColor(style)
	                                    }),
	                                    handlers: getHandlers(node, showTooltip, hideTooltip)
	                                });
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    );
	};
	
	BubbleHtml.displayName = 'BubbleHtml';
	
	exports.default = (0, _enhance2.default)(BubbleHtml);

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getNodeHandlers = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var getNodeHandlers = exports.getNodeHandlers = function getNodeHandlers(node, _ref) {
	    var isInteractive = _ref.isInteractive,
	        onClick = _ref.onClick,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        isZoomable = _ref.isZoomable,
	        zoomToNode = _ref.zoomToNode,
	        theme = _ref.theme,
	        tooltipFormat = _ref.tooltipFormat;
	
	    if (!isInteractive) return {};
	
	    var handleTooltip = function handleTooltip(e) {
	        showTooltip(_react2.default.createElement(_BasicTooltip2.default, {
	            id: node.id,
	            value: node.value,
	            enableChip: true,
	            color: node.color,
	            theme: theme,
	            format: tooltipFormat
	        }), e);
	    };
	
	    var clickHandler = onClick;
	    if (isZoomable) {
	        clickHandler = function clickHandler(event) {
	            onClick(node, event);
	            zoomToNode(node.path);
	        };
	    }
	
	    return {
	        onMouseEnter: handleTooltip,
	        onMouseMove: handleTooltip,
	        onMouseLeave: hideTooltip,
	        onClick: clickHandler
	    };
	};

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nodeWillLeave = exports.nodeWillEnter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _reactMotion = __webpack_require__(25);
	
	var _colors = __webpack_require__(24);
	
	var nodeWillEnter = exports.nodeWillEnter = function nodeWillEnter(_ref) {
	    var data = _ref.data;
	    return _extends({
	        scale: 0,
	        r: 0,
	        x: data.x,
	        y: data.y
	    }, (0, _colors.colorMotionSpring)(data.color));
	};
	
	var nodeWillLeave = exports.nodeWillLeave = function nodeWillLeave(springConfig) {
	    return function (_ref2) {
	        var data = _ref2.data;
	        return _extends({
	            scale: (0, _reactMotion.spring)(0, springConfig),
	            r: (0, _reactMotion.spring)(0, springConfig),
	            x: (0, _reactMotion.spring)(data.x, springConfig),
	            y: (0, _reactMotion.spring)(data.y, springConfig)
	        }, (0, _colors.colorMotionSpring)(data.color, springConfig));
	    };
	};

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.BubbleCanvasDefaultProps = exports.BubbleHtmlDefaultProps = exports.BubbleDefaultProps = exports.BubbleCanvasPropTypes = exports.BubbleHtmlPropTypes = exports.BubblePropTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noop = __webpack_require__(107);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _props = __webpack_require__(19);
	
	var _BubbleNode = __webpack_require__(1082);
	
	var _BubbleNode2 = _interopRequireDefault(_BubbleNode);
	
	var _BubbleHtmlNode = __webpack_require__(1081);
	
	var _BubbleHtmlNode2 = _interopRequireDefault(_BubbleHtmlNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*—————————————————————————————————————————————————————————————————————————————
	
	  Prop types
	
	—————————————————————————————————————————————————————————————————————————————*/
	
	var commonPropTypes = {
	    // data
	    // `root` managed by `withHierarchy()` HOC
	    identity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	    // dimensions managed by `withDimensions()` HOC
	
	    // styling
	    // theme managed by `withTheme()` HOC
	    // colors managed by `withColors()` HOC
	
	    leavesOnly: _propTypes2.default.bool.isRequired,
	    padding: _propTypes2.default.number.isRequired,
	
	    // border
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.any.isRequired,
	
	    // labels
	    enableLabel: _propTypes2.default.bool.isRequired,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    labelFormat: _propTypes2.default.string,
	    labelTextColor: _propTypes2.default.any.isRequired,
	    labelSkipRadius: _propTypes2.default.number.isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    isZoomable: _propTypes2.default.bool.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	};
	
	var BubblePropTypes = exports.BubblePropTypes = _extends({}, commonPropTypes, {
	    nodeComponent: _propTypes2.default.func.isRequired
	}, _props.defsPropTypes);
	
	var BubbleHtmlPropTypes = exports.BubbleHtmlPropTypes = _extends({}, commonPropTypes, {
	    nodeComponent: _propTypes2.default.func.isRequired
	});
	
	var BubbleCanvasPropTypes = exports.BubbleCanvasPropTypes = _extends({}, commonPropTypes, {
	    pixelRatio: _propTypes2.default.number.isRequired
	
	    /*—————————————————————————————————————————————————————————————————————————————
	    
	      Default props
	    
	    —————————————————————————————————————————————————————————————————————————————*/
	
	});var commonDefaultProps = {
	    identity: 'id',
	
	    leavesOnly: false,
	    padding: 1,
	
	    // border
	    borderWidth: 0,
	    borderColor: 'inherit',
	
	    // labels
	    enableLabel: true,
	    label: 'id',
	    labelTextColor: 'inherit:darker(1)',
	    labelSkipRadius: 8,
	
	    // interactivity
	    isInteractive: true,
	    onClick: _noop2.default,
	    isZoomable: true
	};
	
	var BubbleDefaultProps = exports.BubbleDefaultProps = _extends({}, commonDefaultProps, {
	    nodeComponent: _BubbleNode2.default,
	    defs: [],
	    fill: []
	});
	
	var BubbleHtmlDefaultProps = exports.BubbleHtmlDefaultProps = _extends({}, commonDefaultProps, {
	    nodeComponent: _BubbleHtmlNode2.default
	});
	
	var BubbleCanvasDefaultProps = exports.BubbleCanvasDefaultProps = _extends({}, commonDefaultProps, {
	    pixelRatio: global.window && global.window.devicePixelRatio ? global.window.devicePixelRatio : 1
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CalendarLayout = __webpack_require__(1169);
	
	var _CalendarLayout2 = _interopRequireDefault(_CalendarLayout);
	
	var _props = __webpack_require__(304);
	
	var _d3TimeFormat = __webpack_require__(537);
	
	var _directions = __webpack_require__(223);
	
	var _CalendarDay = __webpack_require__(1087);
	
	var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
	var _CalendarMonthPath = __webpack_require__(1088);
	
	var _CalendarMonthPath2 = _interopRequireDefault(_CalendarMonthPath);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _enhance = __webpack_require__(1090);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var monthLegendFormat = (0, _d3TimeFormat.timeFormat)('%b');
	
	var Calendar = function Calendar(_ref) {
	    var data = _ref.data,
	        from = _ref.from,
	        to = _ref.to,
	        colorScale = _ref.colorScale,
	        margin = _ref.margin,
	        width = _ref.width,
	        height = _ref.height,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        direction = _ref.direction,
	        emptyColor = _ref.emptyColor,
	        yearSpacing = _ref.yearSpacing,
	        yearLegendOffset = _ref.yearLegendOffset,
	        daySpacing = _ref.daySpacing,
	        dayBorderWidth = _ref.dayBorderWidth,
	        dayBorderColor = _ref.dayBorderColor,
	        monthBorderWidth = _ref.monthBorderWidth,
	        monthBorderColor = _ref.monthBorderColor,
	        monthLegendOffset = _ref.monthLegendOffset,
	        theme = _ref.theme,
	        isInteractive = _ref.isInteractive,
	        tooltipFormat = _ref.tooltipFormat,
	        onClick = _ref.onClick;
	
	    var _computeCalendar = (0, _CalendarLayout2.default)({
	        width: width,
	        height: height,
	        from: from,
	        to: to,
	        data: data,
	        direction: direction,
	        colorScale: colorScale,
	        emptyColor: emptyColor,
	        yearSpacing: yearSpacing,
	        daySpacing: daySpacing
	    }),
	        years = _computeCalendar.years,
	        months = _computeCalendar.months,
	        days = _computeCalendar.days;
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                { width: outerWidth, height: outerHeight, margin: margin },
	                days.map(function (d) {
	                    return _react2.default.createElement(_CalendarDay2.default, {
	                        key: d.date.toString(),
	                        data: d,
	                        x: d.x,
	                        y: d.y,
	                        size: d.size,
	                        color: d.color,
	                        borderWidth: dayBorderWidth,
	                        borderColor: dayBorderColor,
	                        showTooltip: showTooltip,
	                        hideTooltip: hideTooltip,
	                        tooltipFormat: tooltipFormat,
	                        theme: theme,
	                        onClick: onClick
	                    });
	                }),
	                months.map(function (m) {
	                    return _react2.default.createElement(_CalendarMonthPath2.default, {
	                        key: m.date.toString(),
	                        path: m.path,
	                        borderWidth: monthBorderWidth,
	                        borderColor: monthBorderColor
	                    });
	                }),
	                months.map(function (month) {
	                    var transform = void 0;
	                    if (direction === _directions.DIRECTION_HORIZONTAL) {
	                        transform = 'translate(' + (month.bbox.x + month.bbox.width / 2) + ',' + (month.bbox.y - monthLegendOffset) + ')';
	                    } else {
	                        transform = 'translate(' + (month.bbox.x - monthLegendOffset) + ',' + (month.bbox.y + month.bbox.height / 2) + ') rotate(-90)';
	                    }
	
	                    return _react2.default.createElement(
	                        'text',
	                        {
	                            key: month.date.toString() + '.legend',
	                            className: 'nivo_calendar_month_legend',
	                            transform: transform,
	                            textAnchor: 'middle'
	                        },
	                        monthLegendFormat(month.date)
	                    );
	                }),
	                years.map(function (year) {
	                    var transform = void 0;
	                    if (direction === _directions.DIRECTION_HORIZONTAL) {
	                        transform = 'translate(' + (year.bbox.x - yearLegendOffset) + ',' + (year.bbox.y + year.bbox.height / 2) + ') rotate(-90)';
	                    } else {
	                        transform = 'translate(' + (year.bbox.x + year.bbox.width / 2) + ',' + (year.bbox.y - yearLegendOffset) + ')';
	                    }
	
	                    return _react2.default.createElement(
	                        'text',
	                        {
	                            key: year.year,
	                            className: 'nivo_calendar_year_legend',
	                            transform: transform,
	                            textAnchor: 'middle'
	                        },
	                        year.year
	                    );
	                })
	            );
	        }
	    );
	};
	
	Calendar.propTypes = _props.CalendarPropTypes;
	
	exports.default = (0, _enhance2.default)(Calendar);

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _enhance = __webpack_require__(505);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _props = __webpack_require__(220);
	
	var _ChordRibbons = __webpack_require__(1094);
	
	var _ChordRibbons2 = _interopRequireDefault(_ChordRibbons);
	
	var _ChordArcs = __webpack_require__(1092);
	
	var _ChordArcs2 = _interopRequireDefault(_ChordArcs);
	
	var _ChordLabels = __webpack_require__(1093);
	
	var _ChordLabels2 = _interopRequireDefault(_ChordLabels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chord = function Chord(_ref) {
	    var margin = _ref.margin,
	        width = _ref.width,
	        height = _ref.height,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        arcBorderWidth = _ref.arcBorderWidth,
	        getArcBorderColor = _ref.getArcBorderColor,
	        ribbonBorderWidth = _ref.ribbonBorderWidth,
	        getRibbonBorderColor = _ref.getRibbonBorderColor,
	        enableLabel = _ref.enableLabel,
	        getLabel = _ref.getLabel,
	        labelOffset = _ref.labelOffset,
	        labelRotation = _ref.labelRotation,
	        getLabelTextColor = _ref.getLabelTextColor,
	        arcGenerator = _ref.arcGenerator,
	        ribbonGenerator = _ref.ribbonGenerator,
	        theme = _ref.theme,
	        isInteractive = _ref.isInteractive,
	        tooltipFormat = _ref.tooltipFormat,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness,
	        ribbons = _ref.ribbons,
	        arcs = _ref.arcs,
	        radius = _ref.radius,
	        setCurrentArc = _ref.setCurrentArc,
	        setCurrentRibbon = _ref.setCurrentRibbon,
	        getArcOpacity = _ref.getArcOpacity,
	        getRibbonOpacity = _ref.getRibbonOpacity;
	
	    var centerX = width / 2;
	    var centerY = height / 2;
	
	    var motionProps = {
	        animate: animate,
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                { width: outerWidth, height: outerHeight, margin: margin },
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(' + centerX + ', ' + centerY + ')' },
	                    _react2.default.createElement(_ChordRibbons2.default, _extends({
	                        ribbons: ribbons,
	                        shapeGenerator: ribbonGenerator,
	                        borderWidth: ribbonBorderWidth,
	                        getBorderColor: getRibbonBorderColor,
	                        getOpacity: getRibbonOpacity,
	                        setCurrent: setCurrentRibbon,
	                        theme: theme,
	                        tooltipFormat: tooltipFormat,
	                        showTooltip: showTooltip,
	                        hideTooltip: hideTooltip
	                    }, motionProps)),
	                    _react2.default.createElement(_ChordArcs2.default, _extends({
	                        arcs: arcs,
	                        shapeGenerator: arcGenerator,
	                        borderWidth: arcBorderWidth,
	                        getBorderColor: getArcBorderColor,
	                        getOpacity: getArcOpacity,
	                        setCurrent: setCurrentArc,
	                        theme: theme,
	                        tooltipFormat: tooltipFormat,
	                        showTooltip: showTooltip,
	                        hideTooltip: hideTooltip
	                    }, motionProps)),
	                    enableLabel && _react2.default.createElement(_ChordLabels2.default, _extends({
	                        arcs: arcs,
	                        radius: radius + labelOffset,
	                        rotation: labelRotation,
	                        getLabel: getLabel,
	                        getColor: getLabelTextColor,
	                        theme: theme
	                    }, motionProps))
	                )
	            );
	        }
	    );
	};
	
	Chord.propTypes = _props.ChordPropTypes;
	
	exports.default = (0, _enhance2.default)(Chord);

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var ChordArcTooltip = function ChordArcTooltip(_ref) {
	    var arc = _ref.arc,
	        theme = _ref.theme,
	        format = _ref.format;
	    return _react2.default.createElement(_BasicTooltip2.default, {
	        id: arc.id,
	        value: arc.value,
	        color: arc.color,
	        enableChip: true,
	        theme: theme,
	        format: format
	    });
	};
	
	ChordArcTooltip.propTypes = {
	    arc: _propTypes2.default.object.isRequired,
	    theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _pure2.default)(ChordArcTooltip);

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _partial2 = __webpack_require__(209);
	
	var _partial3 = _interopRequireDefault(_partial2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polar = __webpack_require__(60);
	
	var _interactivity = __webpack_require__(224);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _props3 = __webpack_require__(220);
	
	var _enhance = __webpack_require__(505);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _ChordArcTooltip = __webpack_require__(503);
	
	var _ChordArcTooltip2 = _interopRequireDefault(_ChordArcTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ChordCanvas = function (_Component) {
	    _inherits(ChordCanvas, _Component);
	
	    function ChordCanvas() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ChordCanvas);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleMouseHover = function (showTooltip, hideTooltip, event) {
	            if (_this.props.isInteractive !== true) return;
	
	            var _getRelativeCursor = (0, _interactivity.getRelativeCursor)(_this.surface, event),
	                x = _getRelativeCursor[0],
	                y = _getRelativeCursor[1];
	
	            var _this$props = _this.props,
	                width = _this$props.width,
	                height = _this$props.height,
	                margin = _this$props.margin,
	                radius = _this$props.radius,
	                innerRadius = _this$props.innerRadius,
	                arcs = _this$props.arcs,
	                setCurrentArc = _this$props.setCurrentArc,
	                theme = _this$props.theme;
	
	
	            var centerX = width / 2 + margin.left;
	            var centerY = height / 2 + margin.top;
	
	            var arc = (0, _interactivity.getHoveredArc)(centerX, centerY, radius, innerRadius, arcs, x, y);
	            if (arc) {
	                setCurrentArc(arc);
	                showTooltip(_react2.default.createElement(_ChordArcTooltip2.default, { arc: arc, theme: theme }), event);
	            } else {
	                setCurrentArc(null);
	                hideTooltip();
	            }
	        }, _this.handleMouseLeave = function (hideTooltip) {
	            if (_this.props.isInteractive !== true) return;
	
	            _this.props.setCurrentArc(null);
	            hideTooltip();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    ChordCanvas.prototype.componentDidMount = function componentDidMount() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    ChordCanvas.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
	        if (this.props.outerWidth !== props.outerWidth || this.props.outerHeight !== props.outerHeight || this.props.isInteractive !== props.isInteractive || this.props.theme !== props.theme) {
	            return true;
	        } else {
	            this.draw(props);
	            return false;
	        }
	    };
	
	    ChordCanvas.prototype.componentDidUpdate = function componentDidUpdate() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    ChordCanvas.prototype.draw = function draw(props) {
	        var _this2 = this;
	
	        var pixelRatio = props.pixelRatio,
	            width = props.width,
	            height = props.height,
	            margin = props.margin,
	            outerWidth = props.outerWidth,
	            outerHeight = props.outerHeight,
	            enableLabel = props.enableLabel,
	            getLabel = props.getLabel,
	            labelOffset = props.labelOffset,
	            labelRotation = props.labelRotation,
	            getLabelTextColor = props.getLabelTextColor,
	            arcGenerator = props.arcGenerator,
	            ribbonGenerator = props.ribbonGenerator,
	            theme = props.theme,
	            ribbons = props.ribbons,
	            arcs = props.arcs,
	            radius = props.radius,
	            getArcOpacity = props.getArcOpacity,
	            getRibbonOpacity = props.getRibbonOpacity;
	
	
	        this.surface.width = outerWidth * pixelRatio;
	        this.surface.height = outerHeight * pixelRatio;
	
	        this.ctx.scale(pixelRatio, pixelRatio);
	
	        var centerX = width / 2 + margin.left;
	        var centerY = height / 2 + margin.top;
	
	        this.ctx.clearRect(0, 0, outerWidth, outerHeight);
	        this.ctx.translate(centerX, centerY);
	
	        ribbonGenerator.context(this.ctx);
	        ribbons.forEach(function (ribbon) {
	            _this2.ctx.save();
	            _this2.ctx.globalAlpha = getRibbonOpacity(ribbon);
	
	            _this2.ctx.beginPath();
	            ribbonGenerator(ribbon);
	            _this2.ctx.fillStyle = ribbon.source.color;
	            _this2.ctx.fill();
	
	            _this2.ctx.restore();
	        });
	
	        arcGenerator.context(this.ctx);
	        arcs.forEach(function (arc) {
	            _this2.ctx.save();
	            _this2.ctx.globalAlpha = getArcOpacity(arc);
	
	            _this2.ctx.beginPath();
	            arcGenerator(arc);
	            _this2.ctx.fillStyle = arc.color;
	            _this2.ctx.fill();
	
	            _this2.ctx.restore();
	
	            if (enableLabel) {
	                var labelTextColor = getLabelTextColor(arc, theme);
	                var angle = (0, _polar.midAngle)(arc);
	                var _props = (0, _polar.getPolarLabelProps)(radius + labelOffset, angle, labelRotation);
	
	                _this2.ctx.save();
	                _this2.ctx.translate(_props.x, _props.y);
	                _this2.ctx.rotate((0, _polar.degreesToRadians)(_props.rotate));
	
	                _this2.ctx.textAlign = _props.align;
	                _this2.ctx.textBaseline = _props.baseline;
	                _this2.ctx.fillStyle = labelTextColor;
	                _this2.ctx.fillText(getLabel(arc), 0, 0);
	
	                _this2.ctx.restore();
	            }
	        });
	    };
	
	    ChordCanvas.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props2 = this.props,
	            outerWidth = _props2.outerWidth,
	            outerHeight = _props2.outerHeight,
	            pixelRatio = _props2.pixelRatio,
	            isInteractive = _props2.isInteractive,
	            theme = _props2.theme;
	
	
	        return _react2.default.createElement(
	            _Container2.default,
	            { isInteractive: isInteractive, theme: theme },
	            function (_ref) {
	                var showTooltip = _ref.showTooltip,
	                    hideTooltip = _ref.hideTooltip;
	                return _react2.default.createElement('canvas', {
	                    ref: function ref(surface) {
	                        _this3.surface = surface;
	                    },
	                    width: outerWidth * pixelRatio,
	                    height: outerHeight * pixelRatio,
	                    style: {
	                        width: outerWidth,
	                        height: outerHeight
	                    },
	                    onMouseEnter: (0, _partial3.default)(_this3.handleMouseHover, showTooltip, hideTooltip),
	                    onMouseMove: (0, _partial3.default)(_this3.handleMouseHover, showTooltip, hideTooltip),
	                    onMouseLeave: (0, _partial3.default)(_this3.handleMouseLeave, hideTooltip)
	                });
	            }
	        );
	    };
	
	    return ChordCanvas;
	}(_react.Component);
	
	ChordCanvas.propTypes = _props3.ChordPropTypes;
	
	exports.default = (0, _enhance2.default)(ChordCanvas);

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withState = __webpack_require__(98);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _d3Shape = __webpack_require__(13);
	
	var _d3Chord = __webpack_require__(757);
	
	var _colors = __webpack_require__(24);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _hocs = __webpack_require__(52);
	
	var _props = __webpack_require__(220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (Component) {
	    return (0, _compose2.default)((0, _defaultProps2.default)(_props.ChordDefaultProps), (0, _withState2.default)('currentArc', 'setCurrentArc', null), (0, _withState2.default)('currentRibbon', 'setCurrentRibbon', null), (0, _hocs.withMotion)(), (0, _hocs.withTheme)(), (0, _hocs.withDimensions)(), (0, _withPropsOnChange2.default)(['label'], function (_ref) {
	        var label = _ref.label;
	        return {
	            getLabel: (0, _propertiesConverters.getLabelGenerator)(label)
	        };
	    }), (0, _withPropsOnChange2.default)(['padAngle'], function (_ref2) {
	        var padAngle = _ref2.padAngle;
	        return {
	            chord: (0, _d3Chord.chord)().padAngle(padAngle)
	        };
	    }), (0, _withPropsOnChange2.default)(['labelTextColor'], function (_ref3) {
	        var labelTextColor = _ref3.labelTextColor;
	        return {
	            getLabelTextColor: (0, _colors.getInheritedColorGenerator)(labelTextColor, 'labels.textColor')
	        };
	    }), (0, _withPropsOnChange2.default)(['colors', 'keys'], function (_ref4) {
	        var colors = _ref4.colors,
	            keys = _ref4.keys;
	
	        var color = (0, _colors.getColorRange)(colors);
	
	        return {
	            colorById: keys.reduce(function (acc, key) {
	                acc[key] = color(key);
	                return acc;
	            }, {})
	        };
	    }), (0, _withPropsOnChange2.default)(['width', 'height', 'innerRadiusRatio', 'innerRadiusOffset'], function (_ref5) {
	        var width = _ref5.width,
	            height = _ref5.height,
	            innerRadiusRatio = _ref5.innerRadiusRatio,
	            innerRadiusOffset = _ref5.innerRadiusOffset;
	
	        var radius = Math.min(width, height) / 2;
	        var innerRadius = radius * innerRadiusRatio;
	        var ribbonRadius = radius * (innerRadiusRatio - innerRadiusOffset);
	
	        var arcGenerator = (0, _d3Shape.arc)().outerRadius(radius).innerRadius(innerRadius);
	        var ribbonGenerator = (0, _d3Chord.ribbon)().radius(ribbonRadius);
	
	        return { radius: radius, innerRadius: innerRadius, arcGenerator: arcGenerator, ribbonGenerator: ribbonGenerator };
	    }), (0, _withPropsOnChange2.default)(['arcOpacity', 'ribbonOpacity'], function (_ref6) {
	        var arcOpacity = _ref6.arcOpacity,
	            ribbonOpacity = _ref6.ribbonOpacity;
	        return {
	            getArcOpacity: function getArcOpacity() {
	                return arcOpacity;
	            },
	            getRibbonOpacity: function getRibbonOpacity() {
	                return ribbonOpacity;
	            }
	        };
	    }), (0, _withPropsOnChange2.default)(['isInteractive', 'currentArc', 'arcHoverOpacity', 'arcHoverOthersOpacity', 'currentRibbon', 'ribbonHoverOpacity', 'ribbonHoverOthersOpacity'], function (_ref7) {
	        var isInteractive = _ref7.isInteractive,
	            currentArc = _ref7.currentArc,
	            arcHoverOpacity = _ref7.arcHoverOpacity,
	            arcHoverOthersOpacity = _ref7.arcHoverOthersOpacity,
	            currentRibbon = _ref7.currentRibbon,
	            ribbonHoverOpacity = _ref7.ribbonHoverOpacity,
	            ribbonHoverOthersOpacity = _ref7.ribbonHoverOthersOpacity;
	
	        if (!isInteractive || !currentArc && !currentRibbon) return null;
	
	        var getArcOpacity = void 0;
	        var getRibbonOpacity = void 0;
	        if (isInteractive) {
	            if (currentArc) {
	                getArcOpacity = function getArcOpacity(arc) {
	                    if (arc.id === currentArc.id) return arcHoverOpacity;
	                    return arcHoverOthersOpacity;
	                };
	                getRibbonOpacity = function getRibbonOpacity(ribbon) {
	                    if (ribbon.source.id === currentArc.id || ribbon.target.id === currentArc.id) return ribbonHoverOpacity;
	                    return ribbonHoverOthersOpacity;
	                };
	            } else if (currentRibbon) {
	                getArcOpacity = function getArcOpacity(arc) {
	                    if (arc.id === currentRibbon.source.id || arc.id === currentRibbon.target.id) return arcHoverOpacity;
	                    return arcHoverOthersOpacity;
	                };
	                getRibbonOpacity = function getRibbonOpacity(ribbon) {
	                    if (ribbon.source.id === currentRibbon.source.id && ribbon.target.id === currentRibbon.target.id) return ribbonHoverOpacity;
	                    return ribbonHoverOthersOpacity;
	                };
	            }
	        }
	
	        return { getArcOpacity: getArcOpacity, getRibbonOpacity: getRibbonOpacity };
	    }), (0, _withPropsOnChange2.default)(['chord', 'colorById', 'matrix', 'keys'], function (_ref8) {
	        var chord = _ref8.chord,
	            colorById = _ref8.colorById,
	            matrix = _ref8.matrix,
	            keys = _ref8.keys;
	
	        var ribbons = chord(matrix);
	        ribbons.forEach(function (ribbon) {
	            ribbon.source.id = keys[ribbon.source.index];
	            ribbon.source.color = colorById[ribbon.source.id];
	            ribbon.target.id = keys[ribbon.target.index];
	            ribbon.target.color = colorById[ribbon.target.id];
	            var ribbonKeys = [ribbon.source.id, ribbon.target.id];
	            ribbonKeys.sort();
	            ribbon.key = ribbonKeys.sort().join('.');
	        });
	
	        var arcs = ribbons.groups.map(function (arc) {
	            arc.key = arc.id = keys[arc.index];
	            arc.color = colorById[arc.id];
	            return arc;
	        });
	
	        return { ribbons: ribbons, arcs: arcs };
	    }), (0, _withPropsOnChange2.default)(['arcBorderColor'], function (_ref9) {
	        var arcBorderColor = _ref9.arcBorderColor;
	        return {
	            getArcBorderColor: (0, _colors.getInheritedColorGenerator)(arcBorderColor)
	        };
	    }), (0, _withPropsOnChange2.default)(['ribbonBorderColor'], function (_ref10) {
	        var ribbonBorderColor = _ref10.ribbonBorderColor;
	        return {
	            getRibbonBorderColor: (0, _colors.getInheritedColorGenerator)(ribbonBorderColor)
	        };
	    }), _pure2.default)(Component);
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _partial2 = __webpack_require__(209);
	
	var _partial3 = _interopRequireDefault(_partial2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(25);
	
	var _colors = __webpack_require__(24);
	
	var _props2 = __webpack_require__(221);
	
	var _heatmap = __webpack_require__(533);
	
	var _enhance = __webpack_require__(509);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _Grid = __webpack_require__(165);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Axes = __webpack_require__(164);
	
	var _Axes2 = _interopRequireDefault(_Axes);
	
	var _HeatMapCellRect = __webpack_require__(1099);
	
	var _HeatMapCellRect2 = _interopRequireDefault(_HeatMapCellRect);
	
	var _HeatMapCellCircle = __webpack_require__(1098);
	
	var _HeatMapCellCircle2 = _interopRequireDefault(_HeatMapCellCircle);
	
	var _HeatMapCellTooltip = __webpack_require__(508);
	
	var _HeatMapCellTooltip2 = _interopRequireDefault(_HeatMapCellTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var HeatMap = function (_Component) {
	    _inherits(HeatMap, _Component);
	
	    function HeatMap() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, HeatMap);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleNodeHover = function (showTooltip, node, event) {
	            var _this$props = _this.props,
	                setCurrentNode = _this$props.setCurrentNode,
	                theme = _this$props.theme,
	                tooltipFormat = _this$props.tooltipFormat;
	
	            setCurrentNode(node);
	            showTooltip(_react2.default.createElement(_HeatMapCellTooltip2.default, { node: node, theme: theme, format: tooltipFormat }), event);
	        }, _this.handleNodeLeave = function (hideTooltip) {
	            _this.props.setCurrentNode(null);
	            hideTooltip();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    HeatMap.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            xScale = _props.xScale,
	            yScale = _props.yScale,
	            offsetX = _props.offsetX,
	            offsetY = _props.offsetY,
	            margin = _props.margin,
	            width = _props.width,
	            height = _props.height,
	            outerWidth = _props.outerWidth,
	            outerHeight = _props.outerHeight,
	            cellShape = _props.cellShape,
	            cellBorderWidth = _props.cellBorderWidth,
	            getCellBorderColor = _props.getCellBorderColor,
	            axisTop = _props.axisTop,
	            axisRight = _props.axisRight,
	            axisBottom = _props.axisBottom,
	            axisLeft = _props.axisLeft,
	            enableGridX = _props.enableGridX,
	            enableGridY = _props.enableGridY,
	            enableLabels = _props.enableLabels,
	            getLabelTextColor = _props.getLabelTextColor,
	            theme = _props.theme,
	            animate = _props.animate,
	            motionStiffness = _props.motionStiffness,
	            motionDamping = _props.motionDamping,
	            boundSpring = _props.boundSpring,
	            isInteractive = _props.isInteractive;
	
	
	        var Cell = void 0;
	        if (cellShape === 'rect') {
	            Cell = _HeatMapCellRect2.default;
	        } else if (cellShape === 'circle') {
	            Cell = _HeatMapCellCircle2.default;
	        } else {
	            Cell = cellShape;
	        }
	
	        var nodes = (0, _heatmap.computeNodes)(this.props);
	
	        var motionProps = {
	            animate: animate,
	            motionDamping: motionDamping,
	            motionStiffness: motionStiffness
	        };
	
	        return _react2.default.createElement(
	            _Container2.default,
	            { isInteractive: isInteractive, theme: theme },
	            function (_ref) {
	                var showTooltip = _ref.showTooltip,
	                    hideTooltip = _ref.hideTooltip;
	
	                var onHover = (0, _partial3.default)(_this2.handleNodeHover, showTooltip);
	                var onLeave = (0, _partial3.default)(_this2.handleNodeLeave, hideTooltip);
	
	                return _react2.default.createElement(
	                    _SvgWrapper2.default,
	                    {
	                        width: outerWidth,
	                        height: outerHeight,
	                        margin: Object.assign({}, margin, {
	                            top: margin.top + offsetY,
	                            left: margin.left + offsetX
	                        })
	                    },
	                    _react2.default.createElement(_Grid2.default, _extends({
	                        theme: theme,
	                        width: width - offsetX * 2,
	                        height: height - offsetY * 2,
	                        xScale: enableGridX ? xScale : null,
	                        yScale: enableGridY ? yScale : null
	                    }, motionProps)),
	                    _react2.default.createElement(_Axes2.default, _extends({
	                        xScale: xScale,
	                        yScale: yScale,
	                        width: width,
	                        height: height,
	                        theme: theme,
	                        top: axisTop,
	                        right: axisRight,
	                        bottom: axisBottom,
	                        left: axisLeft
	                    }, motionProps)),
	                    !animate && nodes.map(function (node) {
	                        return _react2.default.createElement(Cell, {
	                            key: node.key,
	                            value: node.value,
	                            x: node.x,
	                            y: node.y,
	                            width: node.width,
	                            height: node.height,
	                            color: node.color,
	                            opacity: node.opacity,
	                            borderWidth: cellBorderWidth,
	                            borderColor: getCellBorderColor(node),
	                            textColor: getLabelTextColor(node),
	                            onHover: (0, _partial3.default)(onHover, node),
	                            onLeave: onLeave
	                        });
	                    }),
	                    animate === true && _react2.default.createElement(
	                        _reactMotion.TransitionMotion,
	                        {
	                            styles: nodes.map(function (node) {
	                                return {
	                                    key: node.key,
	                                    data: node,
	                                    style: _extends({
	                                        x: boundSpring(node.x),
	                                        y: boundSpring(node.y),
	                                        width: boundSpring(node.width),
	                                        height: boundSpring(node.height),
	                                        opacity: boundSpring(node.opacity)
	                                    }, (0, _colors.colorMotionSpring)(node.color, {
	                                        damping: motionDamping,
	                                        stiffness: motionStiffness
	                                    }))
	                                };
	                            })
	                        },
	                        function (interpolatedStyles) {
	                            return _react2.default.createElement(
	                                'g',
	                                null,
	                                interpolatedStyles.map(function (_ref2) {
	                                    var key = _ref2.key,
	                                        style = _ref2.style,
	                                        node = _ref2.data;
	
	                                    var color = (0, _colors.getInterpolatedColor)(style);
	
	                                    return _react2.default.createElement(Cell, {
	                                        key: key,
	                                        value: node.value,
	                                        x: style.x,
	                                        y: style.y,
	                                        width: Math.max(style.width, 0),
	                                        height: Math.max(style.height, 0),
	                                        color: color,
	                                        opacity: style.opacity,
	                                        borderWidth: cellBorderWidth,
	                                        borderColor: getCellBorderColor(_extends({}, node, {
	                                            color: color
	                                        })),
	                                        textColor: getLabelTextColor(_extends({}, node, {
	                                            color: color
	                                        })),
	                                        onHover: (0, _partial3.default)(onHover, node),
	                                        onLeave: onLeave
	                                    });
	                                })
	                            );
	                        }
	                    )
	                );
	            }
	        );
	    };
	
	    return HeatMap;
	}(_react.Component);
	
	HeatMap.propTypes = _props2.HeatMapPropTypes;
	exports.default = (0, _enhance2.default)(HeatMap);

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _partial2 = __webpack_require__(209);
	
	var _partial3 = _interopRequireDefault(_partial2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axes = __webpack_require__(530);
	
	var _interactivity = __webpack_require__(224);
	
	var _heatmap = __webpack_require__(1165);
	
	var _heatmap2 = __webpack_require__(533);
	
	var _HeatMapCellTooltip = __webpack_require__(508);
	
	var _HeatMapCellTooltip2 = _interopRequireDefault(_HeatMapCellTooltip);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _props2 = __webpack_require__(221);
	
	var _enhance = __webpack_require__(509);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var HeatMapCanvas = function (_Component) {
	    _inherits(HeatMapCanvas, _Component);
	
	    function HeatMapCanvas() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, HeatMapCanvas);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleMouseHover = function (showTooltip, hideTooltip, event) {
	            if (!_this.nodes) return;
	
	            var _getRelativeCursor = (0, _interactivity.getRelativeCursor)(_this.surface, event),
	                x = _getRelativeCursor[0],
	                y = _getRelativeCursor[1];
	
	            var _this$props = _this.props,
	                margin = _this$props.margin,
	                offsetX = _this$props.offsetX,
	                offsetY = _this$props.offsetY,
	                theme = _this$props.theme,
	                setCurrentNode = _this$props.setCurrentNode;
	
	            var node = _this.nodes.find(function (node) {
	                return (0, _interactivity.isCursorInRect)(node.x + margin.left + offsetX - node.width / 2, node.y + margin.top + offsetY - node.height / 2, node.width, node.height, x, y);
	            });
	
	            if (node !== undefined) {
	                setCurrentNode(node);
	                showTooltip(_react2.default.createElement(_HeatMapCellTooltip2.default, { node: node, theme: theme }), event);
	            } else {
	                setCurrentNode(null);
	                hideTooltip();
	            }
	        }, _this.handleMouseLeave = function (hideTooltip) {
	            _this.props.setCurrentNode(null);
	            hideTooltip();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    HeatMapCanvas.prototype.componentDidMount = function componentDidMount() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    HeatMapCanvas.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
	        if (this.props.outerWidth !== props.outerWidth || this.props.outerHeight !== props.outerHeight || this.props.isInteractive !== props.isInteractive || this.props.theme !== props.theme) {
	            return true;
	        } else {
	            this.draw(props);
	            return false;
	        }
	    };
	
	    HeatMapCanvas.prototype.componentDidUpdate = function componentDidUpdate() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    HeatMapCanvas.prototype.draw = function draw(props) {
	        var width = props.width,
	            height = props.height,
	            outerWidth = props.outerWidth,
	            outerHeight = props.outerHeight,
	            pixelRatio = props.pixelRatio,
	            margin = props.margin,
	            offsetX = props.offsetX,
	            offsetY = props.offsetY,
	            xScale = props.xScale,
	            yScale = props.yScale,
	            cellShape = props.cellShape;
	
	
	        this.surface.width = outerWidth * pixelRatio;
	        this.surface.height = outerHeight * pixelRatio;
	
	        this.ctx.scale(pixelRatio, pixelRatio);
	
	        var renderNode = void 0;
	        if (cellShape === 'rect') {
	            renderNode = (0, _partial3.default)(_heatmap.renderRect, this.ctx);
	        } else {
	            renderNode = (0, _partial3.default)(_heatmap.renderCircle, this.ctx);
	        }
	
	        var nodes = (0, _heatmap2.computeNodes)(props);
	
	        this.ctx.clearRect(0, 0, outerWidth, outerHeight);
	        this.ctx.translate(margin.left + offsetX, margin.top + offsetY);
	
	        (0, _axes.renderAxes)(this.ctx, {
	            xScale: xScale,
	            yScale: yScale,
	            width: width - offsetX * 2,
	            height: height - offsetY * 2,
	            top: props.axisTop,
	            right: props.axisRight,
	            bottom: props.axisBottom,
	            left: props.axisLeft
	        });
	
	        this.ctx.textAlign = 'center';
	        this.ctx.textBaseline = 'middle';
	
	        nodes.forEach(renderNode);
	
	        this.nodes = nodes;
	    };
	
	    HeatMapCanvas.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            outerWidth = _props.outerWidth,
	            outerHeight = _props.outerHeight,
	            pixelRatio = _props.pixelRatio,
	            isInteractive = _props.isInteractive,
	            theme = _props.theme;
	
	
	        return _react2.default.createElement(
	            _Container2.default,
	            { isInteractive: isInteractive, theme: theme },
	            function (_ref) {
	                var showTooltip = _ref.showTooltip,
	                    hideTooltip = _ref.hideTooltip;
	                return _react2.default.createElement('canvas', {
	                    ref: function ref(surface) {
	                        _this2.surface = surface;
	                    },
	                    width: outerWidth * pixelRatio,
	                    height: outerHeight * pixelRatio,
	                    style: {
	                        width: outerWidth,
	                        height: outerHeight
	                    },
	                    onMouseEnter: (0, _partial3.default)(_this2.handleMouseHover, showTooltip, hideTooltip),
	                    onMouseMove: (0, _partial3.default)(_this2.handleMouseHover, showTooltip, hideTooltip),
	                    onMouseLeave: (0, _partial3.default)(_this2.handleMouseLeave, hideTooltip)
	                });
	            }
	        );
	    };
	
	    return HeatMapCanvas;
	}(_react.Component);
	
	HeatMapCanvas.propTypes = _props2.HeatMapPropTypes;
	
	exports.default = (0, _enhance2.default)(HeatMapCanvas);

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeatMapCellTooltip = function HeatMapCellTooltip(_ref) {
	    var node = _ref.node,
	        theme = _ref.theme,
	        format = _ref.format;
	    return _react2.default.createElement(_BasicTooltip2.default, {
	        id: node.yKey + ' - ' + node.xKey,
	        value: node.value,
	        enableChip: true,
	        color: node.color,
	        theme: theme,
	        format: format
	    });
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	exports.default = (0, _pure2.default)(HeatMapCellTooltip);

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEqual2 = __webpack_require__(31);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _max2 = __webpack_require__(104);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _min2 = __webpack_require__(129);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _withState = __webpack_require__(98);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _d3Scale = __webpack_require__(71);
	
	var _hocs = __webpack_require__(52);
	
	var _colors = __webpack_require__(24);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _props = __webpack_require__(221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var computeX = function computeX(column, cellWidth, padding) {
	    return column * cellWidth + cellWidth * 0.5 + padding * column + padding;
	};
	var computeY = function computeY(row, cellHeight, padding) {
	    return row * cellHeight + cellHeight * 0.5 + padding * row + padding;
	};
	
	exports.default = function (Component) {
	    return (0, _compose2.default)((0, _defaultProps2.default)(_props.HeatMapDefaultProps), (0, _withState2.default)('currentNode', 'setCurrentNode', null), (0, _hocs.withTheme)(), (0, _hocs.withDimensions)(), (0, _hocs.withMotion)(), (0, _withPropsOnChange2.default)(['colors'], function (_ref) {
	        var colors = _ref.colors;
	        return {
	            colorScale: (0, _colors.guessQuantizeColorScale)(colors)
	        };
	    }), (0, _withPropsOnChange2.default)(['indexBy'], function (_ref2) {
	        var indexBy = _ref2.indexBy;
	        return {
	            getIndex: (0, _propertiesConverters.getAccessorFor)(indexBy)
	        };
	    }), (0, _withPropsOnChange2.default)(['data', 'keys', 'width', 'height', 'padding', 'forceSquare'], function (_ref3) {
	        var data = _ref3.data,
	            keys = _ref3.keys,
	            width = _ref3.width,
	            height = _ref3.height,
	            padding = _ref3.padding,
	            forceSquare = _ref3.forceSquare;
	
	        var columns = keys.length;
	        var rows = data.length;
	
	        var cellWidth = Math.max((width - padding * (columns + 1)) / columns, 0);
	        var cellHeight = Math.max((height - padding * (rows + 1)) / rows, 0);
	
	        var offsetX = 0;
	        var offsetY = 0;
	        if (forceSquare === true) {
	            var cellSize = Math.min(cellWidth, cellHeight);
	            cellWidth = cellSize;
	            cellHeight = cellSize;
	
	            offsetX = (width - ((cellWidth + padding) * columns + padding)) / 2;
	            offsetY = (height - ((cellHeight + padding) * rows + padding)) / 2;
	        }
	
	        return {
	            cellWidth: cellWidth,
	            cellHeight: cellHeight,
	            offsetX: offsetX,
	            offsetY: offsetY
	        };
	    }), (0, _withPropsOnChange2.default)(['data', 'getIndex'], function (_ref4) {
	        var data = _ref4.data,
	            getIndex = _ref4.getIndex;
	        return {
	            indices: data.map(getIndex)
	        };
	    }), (0, _withPropsOnChange2.default)(function (prev, next) {
	        return prev.keys !== next.keys || prev.cellWidth !== next.cellWidth || prev.cellHeight !== next.cellHeight || prev.padding !== next.padding || !(0, _isEqual3.default)(prev.indices, next.indices);
	    }, function (_ref5) {
	        var indices = _ref5.indices,
	            keys = _ref5.keys,
	            cellWidth = _ref5.cellWidth,
	            cellHeight = _ref5.cellHeight,
	            padding = _ref5.padding;
	        return {
	            xScale: (0, _d3Scale.scaleOrdinal)(keys.map(function (key, i) {
	                return computeX(i, cellWidth, padding);
	            })).domain(keys),
	            yScale: (0, _d3Scale.scaleOrdinal)(indices.map(function (d, i) {
	                return computeY(i, cellHeight, padding);
	            })).domain(indices)
	        };
	    }), (0, _withPropsOnChange2.default)(['data', 'keys', 'minValue', 'maxValue'], function (_ref6) {
	        var data = _ref6.data,
	            keys = _ref6.keys,
	            _minValue = _ref6.minValue,
	            _maxValue = _ref6.maxValue;
	
	        var minValue = _minValue;
	        var maxValue = _maxValue;
	        if (minValue === 'auto' || maxValue === 'auto') {
	            var allValues = data.reduce(function (acc, row) {
	                return acc.concat(keys.map(function (key) {
	                    return row[key];
	                }));
	            }, []);
	
	            if (minValue === 'auto') minValue = (0, _min3.default)(allValues);
	            if (maxValue === 'auto') maxValue = (0, _max3.default)(allValues);
	        }
	
	        return {
	            minValue: Math.min(minValue, maxValue),
	            maxValue: Math.max(maxValue, minValue)
	        };
	    }), (0, _withPropsOnChange2.default)(['colorScale', 'minValue', 'maxValue'], function (_ref7) {
	        var colorScale = _ref7.colorScale,
	            minValue = _ref7.minValue,
	            maxValue = _ref7.maxValue;
	        return {
	            colorScale: colorScale.domain([minValue, maxValue])
	        };
	    }), (0, _withPropsOnChange2.default)(['sizeVariation', 'minValue', 'maxValue'], function (_ref8) {
	        var sizeVariation = _ref8.sizeVariation,
	            minValue = _ref8.minValue,
	            maxValue = _ref8.maxValue;
	
	        var sizeScale = void 0;
	        if (sizeVariation > 0) {
	            sizeScale = (0, _d3Scale.scaleLinear)().range([1 - sizeVariation, 1]).domain([minValue, maxValue]);
	        }
	
	        return { sizeScale: sizeScale };
	    }), (0, _withPropsOnChange2.default)(['cellBorderColor'], function (_ref9) {
	        var cellBorderColor = _ref9.cellBorderColor;
	        return {
	            getCellBorderColor: (0, _colors.getInheritedColorGenerator)(cellBorderColor)
	        };
	    }), (0, _withPropsOnChange2.default)(['labelTextColor'], function (_ref10) {
	        var labelTextColor = _ref10.labelTextColor;
	        return {
	            getLabelTextColor: (0, _colors.getInheritedColorGenerator)(labelTextColor)
	        };
	    }), _pure2.default)(Component);
	};

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sortBy2 = __webpack_require__(78);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Shape = __webpack_require__(13);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _props = __webpack_require__(19);
	
	var _colors = __webpack_require__(24);
	
	var _hocs = __webpack_require__(52);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _line = __webpack_require__(1170);
	
	var _CartesianMarkers = __webpack_require__(491);
	
	var _CartesianMarkers2 = _interopRequireDefault(_CartesianMarkers);
	
	var _Axes = __webpack_require__(164);
	
	var _Axes2 = _interopRequireDefault(_Axes);
	
	var _Grid = __webpack_require__(165);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _LineAreas = __webpack_require__(1103);
	
	var _LineAreas2 = _interopRequireDefault(_LineAreas);
	
	var _LineLines = __webpack_require__(1105);
	
	var _LineLines2 = _interopRequireDefault(_LineLines);
	
	var _LineSlices = __webpack_require__(1106);
	
	var _LineSlices2 = _interopRequireDefault(_LineSlices);
	
	var _LineDots = __webpack_require__(1104);
	
	var _LineDots2 = _interopRequireDefault(_LineDots);
	
	var _props2 = __webpack_require__(511);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Line = function Line(_ref) {
	    var lines = _ref.lines,
	        lineGenerator = _ref.lineGenerator,
	        areaGenerator = _ref.areaGenerator,
	        xScale = _ref.xScale,
	        yScale = _ref.yScale,
	        slices = _ref.slices,
	        margin = _ref.margin,
	        width = _ref.width,
	        height = _ref.height,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        axisTop = _ref.axisTop,
	        axisRight = _ref.axisRight,
	        axisBottom = _ref.axisBottom,
	        axisLeft = _ref.axisLeft,
	        enableGridX = _ref.enableGridX,
	        enableGridY = _ref.enableGridY,
	        lineWidth = _ref.lineWidth,
	        enableArea = _ref.enableArea,
	        areaOpacity = _ref.areaOpacity,
	        enableDots = _ref.enableDots,
	        dotSymbol = _ref.dotSymbol,
	        dotSize = _ref.dotSize,
	        dotColor = _ref.dotColor,
	        dotBorderWidth = _ref.dotBorderWidth,
	        dotBorderColor = _ref.dotBorderColor,
	        enableDotLabel = _ref.enableDotLabel,
	        dotLabel = _ref.dotLabel,
	        dotLabelFormat = _ref.dotLabelFormat,
	        dotLabelYOffset = _ref.dotLabelYOffset,
	        markers = _ref.markers,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping,
	        isInteractive = _ref.isInteractive,
	        tooltipFormat = _ref.tooltipFormat,
	        enableStackTooltip = _ref.enableStackTooltip;
	
	    var motionProps = {
	        animate: animate,
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                { width: outerWidth, height: outerHeight, margin: margin },
	                _react2.default.createElement(_Grid2.default, _extends({
	                    theme: theme,
	                    width: width,
	                    height: height,
	                    xScale: enableGridX ? xScale : null,
	                    yScale: enableGridY ? yScale : null
	                }, motionProps)),
	                _react2.default.createElement(_CartesianMarkers2.default, {
	                    markers: markers,
	                    width: width,
	                    height: height,
	                    xScale: xScale,
	                    yScale: yScale,
	                    theme: theme
	                }),
	                _react2.default.createElement(_Axes2.default, _extends({
	                    xScale: xScale,
	                    yScale: yScale,
	                    width: width,
	                    height: height,
	                    theme: theme,
	                    top: axisTop,
	                    right: axisRight,
	                    bottom: axisBottom,
	                    left: axisLeft
	                }, motionProps)),
	                enableArea && _react2.default.createElement(_LineAreas2.default, _extends({
	                    areaGenerator: areaGenerator,
	                    areaOpacity: areaOpacity,
	                    lines: lines
	                }, motionProps)),
	                _react2.default.createElement(_LineLines2.default, _extends({
	                    lines: lines,
	                    lineGenerator: lineGenerator,
	                    lineWidth: lineWidth
	                }, motionProps)),
	                isInteractive && enableStackTooltip && _react2.default.createElement(_LineSlices2.default, {
	                    slices: slices,
	                    height: height,
	                    showTooltip: showTooltip,
	                    hideTooltip: hideTooltip,
	                    theme: theme,
	                    tooltipFormat: tooltipFormat
	                }),
	                enableDots && _react2.default.createElement(_LineDots2.default, _extends({
	                    lines: lines,
	                    symbol: dotSymbol,
	                    size: dotSize,
	                    color: (0, _colors.getInheritedColorGenerator)(dotColor),
	                    borderWidth: dotBorderWidth,
	                    borderColor: (0, _colors.getInheritedColorGenerator)(dotBorderColor),
	                    enableLabel: enableDotLabel,
	                    label: dotLabel,
	                    labelFormat: dotLabelFormat,
	                    labelYOffset: dotLabelYOffset,
	                    theme: theme
	                }, motionProps))
	            );
	        }
	    );
	};
	
	Line.propTypes = _props2.LinePropTypes;
	
	var enhance = (0, _compose2.default)((0, _defaultProps2.default)(_props2.LineDefaultProps), (0, _hocs.withTheme)(), (0, _hocs.withColors)(), (0, _hocs.withDimensions)(), (0, _hocs.withMotion)(), (0, _withPropsOnChange2.default)(['curve', 'height'], function (_ref3) {
	    var curve = _ref3.curve,
	        height = _ref3.height;
	    return {
	        areaGenerator: (0, _d3Shape.area)().x(function (d) {
	            return d.x;
	        }).y0(height).y1(function (d) {
	            return d.y;
	        }).curve((0, _props.curveFromProp)(curve)),
	        lineGenerator: (0, _d3Shape.line)().defined(function (d) {
	            return d.value !== null;
	        }).x(function (d) {
	            return d.x;
	        }).y(function (d) {
	            return d.y;
	        }).curve((0, _props.curveFromProp)(curve))
	    };
	}), (0, _withPropsOnChange2.default)(['data', 'stacked', 'width', 'height', 'minY', 'maxY'], function (_ref4) {
	    var data = _ref4.data,
	        stacked = _ref4.stacked,
	        width = _ref4.width,
	        height = _ref4.height,
	        margin = _ref4.margin,
	        minY = _ref4.minY,
	        maxY = _ref4.maxY;
	
	    var scales = void 0;
	    var args = { data: data, width: width, height: height, minY: minY, maxY: maxY };
	    if (stacked === true) {
	        scales = (0, _line.getStackedScales)(args);
	    } else {
	        scales = (0, _line.getScales)(args);
	    }
	
	    return _extends({
	        margin: margin,
	        width: width,
	        height: height
	    }, scales);
	}), (0, _withPropsOnChange2.default)(['getColor', 'xScale', 'yScale'], function (_ref5) {
	    var data = _ref5.data,
	        stacked = _ref5.stacked,
	        xScale = _ref5.xScale,
	        yScale = _ref5.yScale,
	        getColor = _ref5.getColor;
	
	    var lines = void 0;
	    if (stacked === true) {
	        lines = (0, _line.generateStackedLines)(data, xScale, yScale, getColor);
	    } else {
	        lines = (0, _line.generateLines)(data, xScale, yScale, getColor);
	    }
	
	    var slices = xScale.domain().map(function (id, i) {
	        var points = (0, _sortBy3.default)(lines.map(function (line) {
	            return {
	                id: line.id,
	                value: line.points[i].value,
	                y: line.points[i].y,
	                color: line.color
	            };
	        }), 'y');
	
	        return {
	            id: id,
	            x: xScale(id),
	            points: points
	        };
	    });
	
	    return { lines: lines, slices: slices };
	}), _pure2.default);
	
	var enhancedLine = enhance(Line);
	enhancedLine.displayName = 'enhance(Line)';
	
	exports.default = enhancedLine;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LineDefaultProps = exports.LinePropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _props = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var LinePropTypes = exports.LinePropTypes = {
	    // data
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired,
	        data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	            x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	            y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	        })).isRequired
	    })).isRequired,
	
	    stacked: _propTypes2.default.bool.isRequired,
	    curve: _props.lineCurvePropType.isRequired,
	    areaGenerator: _propTypes2.default.func.isRequired,
	    lineGenerator: _propTypes2.default.func.isRequired,
	
	    lines: _propTypes2.default.array.isRequired,
	    slices: _propTypes2.default.array.isRequired,
	
	    minY: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.oneOf(['auto'])]).isRequired,
	    maxY: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.oneOf(['auto'])]).isRequired,
	    xScale: _propTypes2.default.func.isRequired, // computed
	    yScale: _propTypes2.default.func.isRequired, // computed
	
	    // axes & grid
	    axisTop: _propTypes2.default.object,
	    axisRight: _propTypes2.default.object,
	    axisBottom: _propTypes2.default.object,
	    axisLeft: _propTypes2.default.object,
	    enableGridX: _propTypes2.default.bool.isRequired,
	    enableGridY: _propTypes2.default.bool.isRequired,
	
	    // dots
	    enableDots: _propTypes2.default.bool.isRequired,
	    dotSymbol: _propTypes2.default.func,
	    dotSize: _propTypes2.default.number.isRequired,
	    dotColor: _propTypes2.default.any.isRequired,
	    dotBorderWidth: _propTypes2.default.number.isRequired,
	    dotBorderColor: _propTypes2.default.any.isRequired,
	    enableDotLabel: _propTypes2.default.bool.isRequired,
	
	    // markers
	    markers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        axis: _propTypes2.default.oneOf(['x', 'y']).isRequired,
	        value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	        style: _propTypes2.default.object
	    })),
	
	    // styling
	    getColor: _propTypes2.default.func.isRequired,
	    enableArea: _propTypes2.default.bool.isRequired,
	    areaOpacity: _propTypes2.default.number.isRequired,
	    lineWidth: _propTypes2.default.number.isRequired,
	    defs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired
	    })).isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool.isRequired,
	    enableStackTooltip: _propTypes2.default.bool.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	};
	
	var LineDefaultProps = exports.LineDefaultProps = {
	    indexBy: 'id',
	    keys: ['value'],
	
	    stacked: false,
	    curve: 'linear',
	
	    // scales
	    minY: 0,
	    maxY: 'auto',
	
	    // axes & grid
	    axisBottom: {},
	    axisLeft: {},
	    enableGridX: true,
	    enableGridY: true,
	
	    // dots
	    enableDots: true,
	    dotSize: 6,
	    dotColor: 'inherit',
	    dotBorderWidth: 0,
	    dotBorderColor: 'inherit',
	    enableDotLabel: false,
	
	    // styling
	    colors: 'nivo',
	    colorBy: 'id',
	    enableArea: false,
	    areaOpacity: 0.2,
	    lineWidth: 2,
	    defs: [],
	
	    // interactivity
	    isInteractive: true,
	    enableStackTooltip: true
	};

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(25);
	
	var _colors = __webpack_require__(24);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _polar = __webpack_require__(60);
	
	var _defs = __webpack_require__(168);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _d3Shape = __webpack_require__(13);
	
	var _PieRadialLabels = __webpack_require__(1110);
	
	var _PieRadialLabels2 = _interopRequireDefault(_PieRadialLabels);
	
	var _PieSlicesLabels = __webpack_require__(1111);
	
	var _PieSlicesLabels2 = _interopRequireDefault(_PieSlicesLabels);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	var _props = __webpack_require__(305);
	
	var _enhance = __webpack_require__(1113);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pie = function Pie(_ref) {
	    var data = _ref.data,
	        margin = _ref.margin,
	        width = _ref.width,
	        height = _ref.height,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        sortByValue = _ref.sortByValue,
	        _innerRadius = _ref.innerRadius,
	        _padAngle = _ref.padAngle,
	        cornerRadius = _ref.cornerRadius,
	        borderWidth = _ref.borderWidth,
	        _borderColor = _ref.borderColor,
	        enableRadialLabels = _ref.enableRadialLabels,
	        radialLabel = _ref.radialLabel,
	        radialLabelsSkipAngle = _ref.radialLabelsSkipAngle,
	        radialLabelsLinkOffset = _ref.radialLabelsLinkOffset,
	        radialLabelsLinkDiagonalLength = _ref.radialLabelsLinkDiagonalLength,
	        radialLabelsLinkHorizontalLength = _ref.radialLabelsLinkHorizontalLength,
	        radialLabelsLinkStrokeWidth = _ref.radialLabelsLinkStrokeWidth,
	        radialLabelsTextXOffset = _ref.radialLabelsTextXOffset,
	        radialLabelsTextColor = _ref.radialLabelsTextColor,
	        radialLabelsLinkColor = _ref.radialLabelsLinkColor,
	        enableSlicesLabels = _ref.enableSlicesLabels,
	        sliceLabel = _ref.sliceLabel,
	        slicesLabelsSkipAngle = _ref.slicesLabelsSkipAngle,
	        slicesLabelsTextColor = _ref.slicesLabelsTextColor,
	        theme = _ref.theme,
	        getColor = _ref.getColor,
	        defs = _ref.defs,
	        fill = _ref.fill,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping,
	        isInteractive = _ref.isInteractive,
	        tooltipFormat = _ref.tooltipFormat;
	
	    var centerX = width / 2;
	    var centerY = height / 2;
	
	    var padAngle = (0, _polar.degreesToRadians)(_padAngle);
	
	    var borderColor = (0, _colors.getInheritedColorGenerator)(_borderColor);
	
	    var motionProps = {
	        animate: animate,
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    var radialLabelsProps = {
	        label: (0, _propertiesConverters.getLabelGenerator)(radialLabel),
	        skipAngle: radialLabelsSkipAngle,
	        linkOffset: radialLabelsLinkOffset,
	        linkDiagonalLength: radialLabelsLinkDiagonalLength,
	        linkHorizontalLength: radialLabelsLinkHorizontalLength,
	        linkStrokeWidth: radialLabelsLinkStrokeWidth,
	        textXOffset: radialLabelsTextXOffset,
	        textColor: (0, _colors.getInheritedColorGenerator)(radialLabelsTextColor, 'labels.textColor'),
	        linkColor: (0, _colors.getInheritedColorGenerator)(radialLabelsLinkColor, 'axis.tickColor')
	    };
	
	    var slicesLabelsProps = {
	        label: (0, _propertiesConverters.getLabelGenerator)(sliceLabel),
	        skipAngle: slicesLabelsSkipAngle,
	        textColor: (0, _colors.getInheritedColorGenerator)(slicesLabelsTextColor, 'labels.textColor')
	    };
	
	    var radius = Math.min(width, height) / 2;
	    var innerRadius = radius * Math.min(_innerRadius, 1);
	
	    var pie = (0, _d3Shape.pie)();
	    pie.value(function (d) {
	        return d.value;
	    });
	    if (sortByValue !== true) pie.sortValues(null);
	
	    var arc = (0, _d3Shape.arc)();
	    arc.outerRadius(radius);
	
	    var enhancedData = data.map(function (d) {
	        var color = getColor(d);
	        return _extends({}, d, { color: color });
	    });
	
	    var boundDefs = (0, _defs.bindDefs)(defs, enhancedData, fill);
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                {
	                    width: outerWidth,
	                    height: outerHeight,
	                    margin: margin,
	                    defs: boundDefs
	                },
	                _react2.default.createElement(
	                    _reactMotion.Motion,
	                    {
	                        style: {
	                            centerX: (0, _reactMotion.spring)(centerX, motionProps),
	                            centerY: (0, _reactMotion.spring)(centerY, motionProps),
	                            innerRadius: (0, _reactMotion.spring)(innerRadius),
	                            padAngle: (0, _reactMotion.spring)(padAngle, motionProps),
	                            cornerRadius: (0, _reactMotion.spring)(cornerRadius, motionProps)
	                        }
	                    },
	                    function (interpolatingStyle) {
	                        var interpolatedPie = pie.padAngle(interpolatingStyle.padAngle);
	                        var interpolatedArc = arc.cornerRadius(interpolatingStyle.cornerRadius).innerRadius(interpolatingStyle.innerRadius);
	
	                        var arcsData = interpolatedPie(enhancedData).map(function (d) {
	                            var angle = d.endAngle - d.startAngle;
	
	                            return _extends({}, d, {
	                                angle: angle,
	                                angleDegrees: (0, _polar.radiansToDegrees)(angle),
	                                data: d.data
	                            });
	                        });
	
	                        return _react2.default.createElement(
	                            'g',
	                            {
	                                transform: 'translate(' + interpolatingStyle.centerX + ', ' + interpolatingStyle.centerY + ')'
	                            },
	                            arcsData.map(function (d) {
	                                var handleTooltip = function handleTooltip(e) {
	                                    return showTooltip(_react2.default.createElement(_BasicTooltip2.default, {
	                                        id: d.data.label,
	                                        value: d.data.value,
	                                        enableChip: true,
	                                        color: d.data.color,
	                                        theme: theme,
	                                        format: tooltipFormat
	                                    }), e);
	                                };
	
	                                return _react2.default.createElement('path', {
	                                    key: d.data.id,
	                                    d: interpolatedArc(d),
	                                    fill: d.data.fill ? d.data.fill : d.data.color,
	                                    strokeWidth: borderWidth,
	                                    stroke: borderColor(d.data),
	                                    onMouseEnter: handleTooltip,
	                                    onMouseMove: handleTooltip,
	                                    onMouseLeave: hideTooltip
	                                });
	                            }),
	                            enableSlicesLabels && _react2.default.createElement(_PieSlicesLabels2.default, _extends({
	                                data: arcsData,
	                                radius: radius,
	                                innerRadius: interpolatingStyle.innerRadius,
	                                theme: theme
	                            }, slicesLabelsProps)),
	                            enableRadialLabels && _react2.default.createElement(_PieRadialLabels2.default, _extends({
	                                data: arcsData,
	                                radius: radius,
	                                theme: theme
	                            }, radialLabelsProps))
	                        );
	                    }
	                )
	            );
	        }
	    );
	};
	
	Pie.propTypes = _props.PiePropTypes;
	
	var enhancedPie = (0, _enhance2.default)(Pie);
	enhancedPie.displayName = 'enhance(Pie)';
	
	exports.default = enhancedPie;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RadarDefaultProps = undefined;
	
	var _max2 = __webpack_require__(104);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _props = __webpack_require__(19);
	
	var _hocs = __webpack_require__(52);
	
	var _d3Scale = __webpack_require__(71);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _RadarShapes = __webpack_require__(1118);
	
	var _RadarShapes2 = _interopRequireDefault(_RadarShapes);
	
	var _RadarGrid = __webpack_require__(1115);
	
	var _RadarGrid2 = _interopRequireDefault(_RadarGrid);
	
	var _RadarTooltip = __webpack_require__(1119);
	
	var _RadarTooltip2 = _interopRequireDefault(_RadarTooltip);
	
	var _RadarDots = __webpack_require__(514);
	
	var _RadarDots2 = _interopRequireDefault(_RadarDots);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Radar = function Radar(_ref) {
	    var data = _ref.data,
	        keys = _ref.keys,
	        getIndex = _ref.getIndex,
	        indices = _ref.indices,
	        curveInterpolator = _ref.curveInterpolator,
	        radius = _ref.radius,
	        radiusScale = _ref.radiusScale,
	        angleStep = _ref.angleStep,
	        centerX = _ref.centerX,
	        centerY = _ref.centerY,
	        margin = _ref.margin,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        gridLevels = _ref.gridLevels,
	        gridShape = _ref.gridShape,
	        gridLabelOffset = _ref.gridLabelOffset,
	        enableDots = _ref.enableDots,
	        dotSymbol = _ref.dotSymbol,
	        dotSize = _ref.dotSize,
	        dotColor = _ref.dotColor,
	        dotBorderWidth = _ref.dotBorderWidth,
	        dotBorderColor = _ref.dotBorderColor,
	        enableDotLabel = _ref.enableDotLabel,
	        dotLabel = _ref.dotLabel,
	        dotLabelFormat = _ref.dotLabelFormat,
	        dotLabelYOffset = _ref.dotLabelYOffset,
	        theme = _ref.theme,
	        fillOpacity = _ref.fillOpacity,
	        colorByKey = _ref.colorByKey,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping,
	        isInteractive = _ref.isInteractive,
	        tooltipFormat = _ref.tooltipFormat;
	
	    var motionProps = {
	        animate: animate,
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                { width: outerWidth, height: outerHeight, margin: margin },
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(' + centerX + ', ' + centerY + ')' },
	                    _react2.default.createElement(_RadarGrid2.default, _extends({
	                        levels: gridLevels,
	                        shape: gridShape,
	                        radius: radius,
	                        angleStep: angleStep,
	                        theme: theme,
	                        indices: indices,
	                        labelOffset: gridLabelOffset
	                    }, motionProps)),
	                    _react2.default.createElement(_RadarShapes2.default, _extends({
	                        data: data,
	                        keys: keys,
	                        colorByKey: colorByKey,
	                        radiusScale: radiusScale,
	                        angleStep: angleStep,
	                        curveInterpolator: curveInterpolator,
	                        borderWidth: borderWidth,
	                        borderColor: borderColor,
	                        fillOpacity: fillOpacity
	                    }, motionProps)),
	                    isInteractive && _react2.default.createElement(_RadarTooltip2.default, {
	                        data: data,
	                        keys: keys,
	                        getIndex: getIndex,
	                        colorByKey: colorByKey,
	                        radius: radius,
	                        angleStep: angleStep,
	                        theme: theme,
	                        tooltipFormat: tooltipFormat,
	                        showTooltip: showTooltip,
	                        hideTooltip: hideTooltip
	                    }),
	                    enableDots && _react2.default.createElement(_RadarDots2.default, _extends({
	                        data: data,
	                        keys: keys,
	                        getIndex: getIndex,
	                        radiusScale: radiusScale,
	                        angleStep: angleStep,
	                        symbol: dotSymbol,
	                        size: dotSize,
	                        colorByKey: colorByKey,
	                        color: dotColor,
	                        borderWidth: dotBorderWidth,
	                        borderColor: dotBorderColor,
	                        enableLabel: enableDotLabel,
	                        label: dotLabel,
	                        labelFormat: dotLabelFormat,
	                        labelYOffset: dotLabelYOffset,
	                        theme: theme
	                    }, motionProps))
	                )
	            );
	        }
	    );
	};
	
	Radar.propTypes = {
	    // data
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])).isRequired,
	    indexBy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getIndex: _propTypes2.default.func.isRequired, // computed
	    indices: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])).isRequired, // computed
	
	    curve: _props.closedCurvePropType.isRequired,
	    curveInterpolator: _propTypes2.default.func.isRequired, // computed
	
	    // border
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	    // grid
	    gridLevels: _propTypes2.default.number,
	    gridShape: _propTypes2.default.oneOf(['circular', 'linear']),
	    gridLabelOffset: _propTypes2.default.number,
	
	    // dots
	    enableDots: _propTypes2.default.bool.isRequired,
	    dotSymbol: _propTypes2.default.func,
	    dotSize: _propTypes2.default.number,
	    dotColor: _propTypes2.default.any,
	    dotBorderWidth: _propTypes2.default.number,
	    dotBorderColor: _propTypes2.default.any,
	    enableDotLabel: _propTypes2.default.bool,
	    dotLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    dotLabelFormat: _propTypes2.default.string,
	    dotLabelYOffset: _propTypes2.default.number,
	
	    // theming
	    getColor: _propTypes2.default.func.isRequired, // computed
	    colorByKey: _propTypes2.default.object.isRequired, // computed
	    fillOpacity: _propTypes2.default.number.isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	};
	
	var RadarDefaultProps = exports.RadarDefaultProps = {
	    curve: 'linearClosed',
	
	    // border
	    borderWidth: 2,
	    borderColor: 'inherit',
	
	    // grid
	    gridLevels: 5,
	    gridShape: 'circular',
	    gridLabelOffset: 16,
	
	    // dots
	    enableDots: true,
	
	    // theming
	    fillOpacity: 0.15,
	
	    // interactivity
	    isInteractive: true
	};
	
	var enhance = (0, _compose2.default)((0, _defaultProps2.default)(RadarDefaultProps), (0, _hocs.withTheme)(), (0, _hocs.withColors)({
	    defaultColorBy: 'key'
	}), (0, _hocs.withCurve)(), (0, _hocs.withDimensions)(), (0, _hocs.withMotion)(), (0, _withPropsOnChange2.default)(['indexBy'], function (_ref3) {
	    var indexBy = _ref3.indexBy;
	    return {
	        getIndex: (0, _propertiesConverters.getAccessorFor)(indexBy)
	    };
	}), (0, _withPropsOnChange2.default)(['data', 'getIndex'], function (_ref4) {
	    var data = _ref4.data,
	        getIndex = _ref4.getIndex;
	    return {
	        indices: data.map(getIndex)
	    };
	}), (0, _withPropsOnChange2.default)(['keys', 'getColor'], function (_ref5) {
	    var keys = _ref5.keys,
	        getColor = _ref5.getColor;
	    return {
	        colorByKey: keys.reduce(function (mapping, key, index) {
	            mapping[key] = getColor({ key: key, index: index });
	            return mapping;
	        }, {})
	    };
	}), (0, _withPropsOnChange2.default)(['keys', 'indexBy', 'data', 'width', 'height'], function (_ref6) {
	    var data = _ref6.data,
	        keys = _ref6.keys,
	        width = _ref6.width,
	        height = _ref6.height;
	
	    var maxValue = (0, _max3.default)(data.reduce(function (acc, d) {
	        return [].concat(acc, keys.map(function (key) {
	            return d[key];
	        }));
	    }, []));
	
	    var radius = Math.min(width, height) / 2;
	    var radiusScale = (0, _d3Scale.scaleLinear)().range([0, radius]).domain([0, maxValue]);
	
	    return {
	        data: data,
	        radius: radius,
	        radiusScale: radiusScale,
	        centerX: width / 2,
	        centerY: height / 2,
	        angleStep: Math.PI * 2 / data.length
	    };
	}), _pure2.default);
	
	var enhancedRadar = enhance(Radar);
	enhancedRadar.displayName = 'enhance(Radar)';
	
	exports.default = enhancedRadar;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _props2 = __webpack_require__(19);
	
	var _colors = __webpack_require__(24);
	
	var _polar = __webpack_require__(60);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _DotsItem = __webpack_require__(311);
	
	var _DotsItem2 = _interopRequireDefault(_DotsItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var RadarDots = function (_Component) {
	    _inherits(RadarDots, _Component);
	
	    function RadarDots() {
	        _classCallCheck(this, RadarDots);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    RadarDots.prototype.render = function render() {
	        var _props = this.props,
	            data = _props.data,
	            keys = _props.keys,
	            getIndex = _props.getIndex,
	            colorByKey = _props.colorByKey,
	            radiusScale = _props.radiusScale,
	            angleStep = _props.angleStep,
	            symbol = _props.symbol,
	            size = _props.size,
	            color = _props.color,
	            borderWidth = _props.borderWidth,
	            borderColor = _props.borderColor,
	            enableLabel = _props.enableLabel,
	            label = _props.label,
	            labelFormat = _props.labelFormat,
	            labelYOffset = _props.labelYOffset,
	            theme = _props.theme,
	            animate = _props.animate,
	            motionStiffness = _props.motionStiffness,
	            motionDamping = _props.motionDamping;
	
	
	        var fillColor = (0, _colors.getInheritedColorGenerator)(color);
	        var strokeColor = (0, _colors.getInheritedColorGenerator)(borderColor);
	        var getLabel = (0, _propertiesConverters.getLabelGenerator)(label, labelFormat);
	
	        var points = data.reduce(function (acc, datum, i) {
	            var index = getIndex(datum);
	            keys.forEach(function (key) {
	                var pointData = {
	                    index: index,
	                    key: key,
	                    value: datum[key],
	                    color: colorByKey[key]
	                };
	                acc.push({
	                    key: key + '.' + index,
	                    label: enableLabel ? getLabel(pointData) : null,
	                    style: _extends({
	                        fill: fillColor(pointData),
	                        stroke: strokeColor(pointData)
	                    }, (0, _polar.positionFromAngle)(angleStep * i - Math.PI / 2, radiusScale(datum[key]))),
	                    data: pointData
	                });
	            });
	
	            return acc;
	        }, []);
	
	        if (animate !== true) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                points.map(function (point) {
	                    return _react2.default.createElement(_DotsItem2.default, {
	                        key: point.key,
	                        x: point.style.x,
	                        y: point.style.y,
	                        symbol: symbol,
	                        size: size,
	                        color: point.style.fill,
	                        borderWidth: borderWidth,
	                        borderColor: point.style.stroke,
	                        label: point.label,
	                        labelYOffset: labelYOffset,
	                        theme: theme
	                    });
	                })
	            );
	        }
	
	        var springConfig = {
	            motionDamping: motionDamping,
	            motionStiffness: motionStiffness
	        };
	
	        return _react2.default.createElement(
	            _reactMotion.TransitionMotion,
	            {
	                styles: points.map(function (point) {
	                    return {
	                        key: point.key,
	                        data: point,
	                        style: {
	                            x: (0, _reactMotion.spring)(point.style.x, springConfig),
	                            y: (0, _reactMotion.spring)(point.style.y, springConfig),
	                            size: (0, _reactMotion.spring)(size, springConfig)
	                        }
	                    };
	                })
	            },
	            function (interpolatedStyles) {
	                return _react2.default.createElement(
	                    'g',
	                    null,
	                    interpolatedStyles.map(function (_ref) {
	                        var key = _ref.key,
	                            style = _ref.style,
	                            point = _ref.data;
	                        return _react2.default.createElement(_DotsItem2.default, _extends({
	                            key: key
	                        }, style, {
	                            symbol: symbol,
	                            color: point.style.fill,
	                            borderWidth: borderWidth,
	                            borderColor: point.style.stroke,
	                            label: point.label,
	                            labelYOffset: labelYOffset,
	                            theme: theme
	                        }));
	                    })
	                );
	            }
	        );
	    };
	
	    return RadarDots;
	}(_react.Component);
	
	RadarDots.propTypes = _extends({
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])).isRequired,
	    getIndex: _propTypes2.default.func.isRequired,
	
	    colorByKey: _propTypes2.default.object.isRequired,
	
	    radiusScale: _propTypes2.default.func.isRequired,
	    angleStep: _propTypes2.default.number.isRequired,
	
	    symbol: _propTypes2.default.func,
	    size: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	    // labels
	    enableLabel: _propTypes2.default.bool.isRequired,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    labelFormat: _propTypes2.default.string,
	    labelYOffset: _propTypes2.default.number,
	
	    // theming
	    theme: _propTypes2.default.shape({
	        dots: _propTypes2.default.shape({
	            textColor: _propTypes2.default.string.isRequired,
	            fontSize: _propTypes2.default.string.isRequired
	        }).isRequired
	    }).isRequired
	
	}, _props2.motionPropTypes);
	RadarDots.defaultProps = {
	    size: 6,
	    color: 'inherit',
	    borderWidth: 0,
	    borderColor: 'inherit',
	
	    // labels
	    enableLabel: false,
	    label: 'value'
	};
	exports.default = RadarDots;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _uniq2 = __webpack_require__(211);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _cloneDeep2 = __webpack_require__(283);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Sankey = __webpack_require__(252);
	
	var _props = __webpack_require__(19);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _SankeyNodes = __webpack_require__(1127);
	
	var _SankeyNodes2 = _interopRequireDefault(_SankeyNodes);
	
	var _SankeyLinks = __webpack_require__(1125);
	
	var _SankeyLinks2 = _interopRequireDefault(_SankeyLinks);
	
	var _SankeyLabels = __webpack_require__(1124);
	
	var _SankeyLabels2 = _interopRequireDefault(_SankeyLabels);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _props2 = __webpack_require__(306);
	
	var _enhance = __webpack_require__(1129);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getId = function getId(d) {
	    return d.id;
	};
	
	var Sankey = function Sankey(_ref) {
	    var _data = _ref.data,
	        align = _ref.align,
	        margin = _ref.margin,
	        width = _ref.width,
	        height = _ref.height,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        nodeOpacity = _ref.nodeOpacity,
	        nodeHoverOpacity = _ref.nodeHoverOpacity,
	        nodeHoverOthersOpacity = _ref.nodeHoverOthersOpacity,
	        nodeWidth = _ref.nodeWidth,
	        nodePaddingX = _ref.nodePaddingX,
	        nodePaddingY = _ref.nodePaddingY,
	        nodeBorderWidth = _ref.nodeBorderWidth,
	        getNodeBorderColor = _ref.getNodeBorderColor,
	        setCurrentNode = _ref.setCurrentNode,
	        currentNode = _ref.currentNode,
	        linkOpacity = _ref.linkOpacity,
	        linkHoverOpacity = _ref.linkHoverOpacity,
	        linkHoverOthersOpacity = _ref.linkHoverOthersOpacity,
	        linkContract = _ref.linkContract,
	        getLinkColor = _ref.getLinkColor,
	        setCurrentLink = _ref.setCurrentLink,
	        currentLink = _ref.currentLink,
	        enableLabels = _ref.enableLabels,
	        getLabel = _ref.getLabel,
	        labelPosition = _ref.labelPosition,
	        labelPadding = _ref.labelPadding,
	        labelOrientation = _ref.labelOrientation,
	        getLabelTextColor = _ref.getLabelTextColor,
	        theme = _ref.theme,
	        getColor = _ref.getColor,
	        nodeTooltip = _ref.nodeTooltip,
	        linkTooltip = _ref.linkTooltip,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness,
	        isInteractive = _ref.isInteractive,
	        onClick = _ref.onClick,
	        tooltipFormat = _ref.tooltipFormat;
	
	    var sankey = (0, _d3Sankey.sankey)().nodeAlign((0, _props.sankeyAlignmentFromProp)(align)).nodeWidth(nodeWidth).nodePadding(nodePaddingY).size([width, height]).nodeId(getId);
	
	    // deep clone is required as the sankey diagram mutates data
	    var data = (0, _cloneDeep3.default)(_data);
	    sankey(data);
	
	    data.nodes.forEach(function (node) {
	        node.color = getColor(node);
	        node.label = getLabel(node);
	        node.x = node.x0 + nodePaddingX;
	        node.y = node.y0;
	        node.width = Math.max(node.x1 - node.x0 - nodePaddingX * 2, 0);
	        node.height = Math.max(node.y1 - node.y0, 0);
	    });
	
	    data.links.forEach(function (link) {
	        link.color = getLinkColor(link);
	    });
	
	    var motionProps = {
	        animate: animate,
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    var isCurrentNode = function isCurrentNode() {
	        return false;
	    };
	    var isCurrentLink = function isCurrentLink() {
	        return false;
	    };
	
	    if (currentLink) {
	        isCurrentNode = function isCurrentNode(_ref2) {
	            var id = _ref2.id;
	            return id === currentLink.source.id || id === currentLink.target.id;
	        };
	        isCurrentLink = function isCurrentLink(_ref3) {
	            var source = _ref3.source,
	                target = _ref3.target;
	            return source.id === currentLink.source.id && target.id === currentLink.target.id;
	        };
	    }
	
	    if (currentNode) {
	        var currentNodeIds = [currentNode.id];
	        data.links.filter(function (_ref4) {
	            var source = _ref4.source,
	                target = _ref4.target;
	            return source.id === currentNode.id || target.id === currentNode.id;
	        }).forEach(function (_ref5) {
	            var source = _ref5.source,
	                target = _ref5.target;
	
	            currentNodeIds.push(source.id);
	            currentNodeIds.push(target.id);
	        });
	
	        currentNodeIds = (0, _uniq3.default)(currentNodeIds);
	        isCurrentNode = function isCurrentNode(_ref6) {
	            var id = _ref6.id;
	            return currentNodeIds.includes(id);
	        };
	        isCurrentLink = function isCurrentLink(_ref7) {
	            var source = _ref7.source,
	                target = _ref7.target;
	            return source.id === currentNode.id || target.id === currentNode.id;
	        };
	    }
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref8) {
	            var showTooltip = _ref8.showTooltip,
	                hideTooltip = _ref8.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                { width: outerWidth, height: outerHeight, margin: margin },
	                _react2.default.createElement(_SankeyLinks2.default, _extends({
	                    links: data.links,
	                    linkContract: linkContract,
	                    linkOpacity: linkOpacity,
	                    linkHoverOpacity: linkHoverOpacity,
	                    linkHoverOthersOpacity: linkHoverOthersOpacity,
	                    showTooltip: showTooltip,
	                    hideTooltip: hideTooltip,
	                    setCurrentLink: setCurrentLink,
	                    currentNode: currentNode,
	                    currentLink: currentLink,
	                    isCurrentLink: isCurrentLink,
	                    onClick: onClick,
	                    tooltip: linkTooltip,
	                    theme: theme,
	                    tooltipFormat: tooltipFormat
	                }, motionProps)),
	                _react2.default.createElement(_SankeyNodes2.default, _extends({
	                    nodes: data.nodes,
	                    nodePaddingX: nodePaddingX,
	                    nodeOpacity: nodeOpacity,
	                    nodeHoverOpacity: nodeHoverOpacity,
	                    nodeHoverOthersOpacity: nodeHoverOthersOpacity,
	                    nodeBorderWidth: nodeBorderWidth,
	                    getNodeBorderColor: getNodeBorderColor,
	                    showTooltip: showTooltip,
	                    hideTooltip: hideTooltip,
	                    setCurrentNode: setCurrentNode,
	                    currentNode: currentNode,
	                    currentLink: currentLink,
	                    isCurrentNode: isCurrentNode,
	                    onClick: onClick,
	                    tooltip: nodeTooltip,
	                    theme: theme,
	                    tooltipFormat: tooltipFormat
	                }, motionProps)),
	                enableLabels && _react2.default.createElement(_SankeyLabels2.default, _extends({
	                    nodes: data.nodes,
	                    width: width,
	                    labelPosition: labelPosition,
	                    labelPadding: labelPadding,
	                    labelOrientation: labelOrientation,
	                    getLabelTextColor: getLabelTextColor,
	                    theme: theme
	                }, motionProps))
	            );
	        }
	    );
	};
	
	Sankey.propTypes = _props2.SankeyPropTypes;
	
	exports.default = (0, _enhance2.default)(Sankey);

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sortBy2 = __webpack_require__(78);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defs = __webpack_require__(168);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Axes = __webpack_require__(164);
	
	var _Axes2 = _interopRequireDefault(_Axes);
	
	var _Grid = __webpack_require__(165);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _StreamLayers = __webpack_require__(1132);
	
	var _StreamLayers2 = _interopRequireDefault(_StreamLayers);
	
	var _StreamSlices = __webpack_require__(1133);
	
	var _StreamSlices2 = _interopRequireDefault(_StreamSlices);
	
	var _props = __webpack_require__(307);
	
	var _enhance = __webpack_require__(1135);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Stream = function Stream(_ref) {
	    var data = _ref.data,
	        keys = _ref.keys,
	        xScale = _ref.xScale,
	        yScale = _ref.yScale,
	        layers = _ref.layers,
	        areaGenerator = _ref.areaGenerator,
	        margin = _ref.margin,
	        width = _ref.width,
	        height = _ref.height,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        axisTop = _ref.axisTop,
	        axisRight = _ref.axisRight,
	        axisBottom = _ref.axisBottom,
	        axisLeft = _ref.axisLeft,
	        enableGridX = _ref.enableGridX,
	        enableGridY = _ref.enableGridY,
	        theme = _ref.theme,
	        getColor = _ref.getColor,
	        fillOpacity = _ref.fillOpacity,
	        borderWidth = _ref.borderWidth,
	        getBorderColor = _ref.getBorderColor,
	        defs = _ref.defs,
	        fill = _ref.fill,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping,
	        isInteractive = _ref.isInteractive,
	        tooltipFormat = _ref.tooltipFormat,
	        enableStackTooltip = _ref.enableStackTooltip;
	
	    var enhancedLayers = layers.map(function (points, i) {
	        var layer = points.map(function (point, i) {
	            return {
	                index: i,
	                x: xScale(i),
	                value: point.value,
	                y1: yScale(point[0]),
	                y2: yScale(point[1])
	            };
	        });
	
	        return {
	            id: keys[i],
	            layer: layer,
	            path: areaGenerator(layer),
	            color: getColor(i)
	        };
	    });
	
	    var slices = (0, _range3.default)(data.length).map(function (i) {
	        return {
	            index: i,
	            x: enhancedLayers[0].layer[i].x,
	            stack: (0, _sortBy3.default)(enhancedLayers.map(function (layer) {
	                return _extends({
	                    id: layer.id,
	                    color: layer.color
	                }, layer.layer[i]);
	            }), 'y2')
	        };
	    });
	
	    var motionProps = {
	        animate: animate,
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    var boundDefs = (0, _defs.bindDefs)(defs, enhancedLayers, fill);
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                {
	                    width: outerWidth,
	                    height: outerHeight,
	                    margin: margin,
	                    defs: boundDefs
	                },
	                _react2.default.createElement(_Grid2.default, _extends({
	                    theme: theme,
	                    width: width,
	                    height: height,
	                    xScale: enableGridX ? xScale : null,
	                    yScale: enableGridY ? yScale : null
	                }, motionProps)),
	                _react2.default.createElement(_StreamLayers2.default, _extends({
	                    layers: enhancedLayers,
	                    fillOpacity: fillOpacity,
	                    borderWidth: borderWidth,
	                    getBorderColor: getBorderColor,
	                    showTooltip: showTooltip,
	                    hideTooltip: hideTooltip,
	                    theme: theme
	                }, motionProps)),
	                _react2.default.createElement(_Axes2.default, _extends({
	                    xScale: xScale,
	                    yScale: yScale,
	                    width: width,
	                    height: height,
	                    theme: theme,
	                    top: axisTop,
	                    right: axisRight,
	                    bottom: axisBottom,
	                    left: axisLeft
	                }, motionProps)),
	                isInteractive && enableStackTooltip && _react2.default.createElement(_StreamSlices2.default, {
	                    slices: slices,
	                    height: height,
	                    showTooltip: showTooltip,
	                    hideTooltip: hideTooltip,
	                    theme: theme,
	                    tooltipFormat: tooltipFormat
	                })
	            );
	        }
	    );
	};
	
	Stream.propTypes = _props.StreamPropTypes;
	
	var enhancedStream = (0, _enhance2.default)(Stream);
	enhancedStream.displayName = 'enhance(Stream)';
	
	exports.default = enhancedStream;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SunburstDefaultProps = undefined;
	
	var _cloneDeep2 = __webpack_require__(283);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _sortBy2 = __webpack_require__(78);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _withProps = __webpack_require__(623);
	
	var _withProps2 = _interopRequireDefault(_withProps);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _d3Hierarchy = __webpack_require__(144);
	
	var _d3Shape = __webpack_require__(13);
	
	var _colors = __webpack_require__(24);
	
	var _hocs = __webpack_require__(52);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _SunburstArc = __webpack_require__(1138);
	
	var _SunburstArc2 = _interopRequireDefault(_SunburstArc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var getAncestor = function getAncestor(node) {
	    if (node.depth === 1) return node;
	    if (node.parent) return getAncestor(node.parent);
	    return node;
	};
	
	var Sunburst = function Sunburst(_ref) {
	    var nodes = _ref.nodes,
	        margin = _ref.margin,
	        centerX = _ref.centerX,
	        centerY = _ref.centerY,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        arcGenerator = _ref.arcGenerator,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        theme = _ref.theme,
	        isInteractive = _ref.isInteractive;
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                { width: outerWidth, height: outerHeight, margin: margin },
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(' + centerX + ', ' + centerY + ')' },
	                    nodes.filter(function (node) {
	                        return node.depth > 0;
	                    }).map(function (node, i) {
	                        return _react2.default.createElement(_SunburstArc2.default, {
	                            key: i,
	                            node: node,
	                            arcGenerator: arcGenerator,
	                            borderWidth: borderWidth,
	                            borderColor: borderColor,
	                            showTooltip: showTooltip,
	                            hideTooltip: hideTooltip,
	                            theme: theme
	                        });
	                    })
	                )
	            );
	        }
	    );
	};
	
	Sunburst.propTypes = {
	    data: _propTypes2.default.object.isRequired,
	    identity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getIdentity: _propTypes2.default.func.isRequired, // computed
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getValue: _propTypes2.default.func.isRequired, // computed
	    nodes: _propTypes2.default.array.isRequired, // computed
	
	    partition: _propTypes2.default.func.isRequired, // computed
	
	    cornerRadius: _propTypes2.default.number.isRequired,
	    arcGenerator: _propTypes2.default.func.isRequired, // computed
	
	    radius: _propTypes2.default.number.isRequired, // computed
	    centerX: _propTypes2.default.number.isRequired, // computed
	    centerY: _propTypes2.default.number.isRequired, // computed
	
	    // border
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired,
	
	    childColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool
	};
	
	var SunburstDefaultProps = exports.SunburstDefaultProps = {
	    identity: 'id',
	    value: 'value',
	
	    cornerRadius: 0,
	
	    // border
	    borderWidth: 1,
	    borderColor: 'white',
	
	    childColor: 'inherit',
	
	    // interactivity
	    isInteractive: true
	};
	
	var enhance = (0, _compose2.default)((0, _defaultProps2.default)(SunburstDefaultProps), (0, _hocs.withTheme)(), (0, _hocs.withDimensions)(), (0, _hocs.withColors)(), (0, _withProps2.default)(function (_ref3) {
	    var width = _ref3.width,
	        height = _ref3.height;
	
	    var radius = Math.min(width, height) / 2;
	
	    var partition = (0, _d3Hierarchy.partition)().size([2 * Math.PI, radius * radius]);
	
	    return { radius: radius, partition: partition, centerX: width / 2, centerY: height / 2 };
	}), (0, _withPropsOnChange2.default)(['cornerRadius'], function (_ref4) {
	    var cornerRadius = _ref4.cornerRadius;
	    return {
	        arcGenerator: (0, _d3Shape.arc)().startAngle(function (d) {
	            return d.x0;
	        }).endAngle(function (d) {
	            return d.x1;
	        }).innerRadius(function (d) {
	            return Math.sqrt(d.y0);
	        }).outerRadius(function (d) {
	            return Math.sqrt(d.y1);
	        }).cornerRadius(cornerRadius)
	    };
	}), (0, _withPropsOnChange2.default)(['identity'], function (_ref5) {
	    var identity = _ref5.identity;
	    return {
	        getIdentity: (0, _propertiesConverters.getAccessorFor)(identity)
	    };
	}), (0, _withPropsOnChange2.default)(['value'], function (_ref6) {
	    var value = _ref6.value;
	    return {
	        getValue: (0, _propertiesConverters.getAccessorFor)(value)
	    };
	}), (0, _withPropsOnChange2.default)(['data', 'getValue'], function (_ref7) {
	    var data = _ref7.data,
	        getValue = _ref7.getValue;
	    return {
	        data: (0, _d3Hierarchy.hierarchy)(data).sum(getValue)
	    };
	}), (0, _withPropsOnChange2.default)(['childColor'], function (_ref8) {
	    var childColor = _ref8.childColor;
	    return {
	        getChildColor: (0, _colors.getInheritedColorGenerator)(childColor)
	    };
	}), (0, _withPropsOnChange2.default)(['data', 'partition', 'getIdentity', 'getChildColor'], function (_ref9) {
	    var data = _ref9.data,
	        partition = _ref9.partition,
	        getIdentity = _ref9.getIdentity,
	        getColor = _ref9.getColor,
	        getChildColor = _ref9.getChildColor;
	
	    var total = data.value;
	
	    var nodes = (0, _sortBy3.default)(partition((0, _cloneDeep3.default)(data)).descendants(), 'depth');
	    nodes.forEach(function (node) {
	        var ancestor = getAncestor(node).data;
	
	        delete node.children;
	        delete node.data.children;
	
	        Object.assign(node.data, {
	            id: getIdentity(node.data),
	            value: node.value,
	            percentage: 100 * node.value / total,
	            depth: node.depth,
	            ancestor: ancestor
	        });
	
	        if (node.depth === 1) {
	            node.data.color = getColor(node.data);
	        } else if (node.depth > 1) {
	            node.data.color = getChildColor(node.parent.data);
	        }
	    });
	
	    return { nodes: nodes };
	}), _pure2.default);
	
	var enhancedSunburst = enhance(Sunburst);
	enhancedSunburst.displayName = 'enhance(Sunburst)';
	
	exports.default = enhancedSunburst;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(25);
	
	var _colors = __webpack_require__(24);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _enhance = __webpack_require__(308);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _motion = __webpack_require__(523);
	
	var _interactivity = __webpack_require__(522);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreeMap = function TreeMap(_ref) {
	    var nodes = _ref.nodes,
	        nodeComponent = _ref.nodeComponent,
	        margin = _ref.margin,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        theme = _ref.theme,
	        borderWidth = _ref.borderWidth,
	        getBorderColor = _ref.getBorderColor,
	        defs = _ref.defs,
	        getLabelTextColor = _ref.getLabelTextColor,
	        orientLabel = _ref.orientLabel,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping,
	        isInteractive = _ref.isInteractive,
	        onClick = _ref.onClick;
	
	    var springConfig = {
	        stiffness: motionStiffness,
	        damping: motionDamping
	    };
	
	    var getHandlers = function getHandlers(node, showTooltip, hideTooltip) {
	        return (0, _interactivity.getNodeHandlers)(node, {
	            isInteractive: isInteractive,
	            onClick: onClick,
	            showTooltip: showTooltip,
	            hideTooltip: hideTooltip,
	            theme: theme
	        });
	    };
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                { width: outerWidth, height: outerHeight, margin: margin, defs: defs },
	                !animate && _react2.default.createElement(
	                    'g',
	                    null,
	                    nodes.map(function (node) {
	                        return _react2.default.createElement(nodeComponent, {
	                            key: node.path,
	                            node: node,
	                            style: {
	                                fill: node.fill,
	                                x: node.x0,
	                                y: node.y0,
	                                width: node.width,
	                                height: node.height,
	                                color: node.color,
	                                borderWidth: borderWidth,
	                                borderColor: getBorderColor(node),
	                                labelTextColor: getLabelTextColor(node),
	                                orientLabel: orientLabel
	                            },
	                            handlers: getHandlers(node, showTooltip, hideTooltip)
	                        });
	                    })
	                ),
	                animate && _react2.default.createElement(
	                    _reactMotion.TransitionMotion,
	                    {
	                        willEnter: _motion.nodeWillEnter,
	                        willLeave: (0, _motion.nodeWillLeave)(springConfig),
	                        styles: nodes.map(function (node) {
	                            return {
	                                key: node.path,
	                                data: node,
	                                style: _extends({
	                                    x: (0, _reactMotion.spring)(node.x, springConfig),
	                                    y: (0, _reactMotion.spring)(node.y, springConfig),
	                                    width: (0, _reactMotion.spring)(node.width, springConfig),
	                                    height: (0, _reactMotion.spring)(node.height, springConfig)
	                                }, (0, _colors.colorMotionSpring)(node.color, springConfig))
	                            };
	                        })
	                    },
	                    function (interpolatedStyles) {
	                        return _react2.default.createElement(
	                            'g',
	                            null,
	                            interpolatedStyles.map(function (_ref3) {
	                                var style = _ref3.style,
	                                    node = _ref3.data;
	
	                                style.color = (0, _colors.getInterpolatedColor)(style);
	
	                                return _react2.default.createElement(nodeComponent, {
	                                    key: node.path,
	                                    node: node,
	                                    style: _extends({}, style, {
	                                        fill: node.fill,
	                                        borderWidth: borderWidth,
	                                        borderColor: getBorderColor(style),
	                                        labelTextColor: getLabelTextColor(style),
	                                        orientLabel: orientLabel
	                                    }),
	                                    handlers: getHandlers(node, showTooltip, hideTooltip)
	                                });
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    );
	};
	
	TreeMap.displayName = 'TreeMap';
	
	exports.default = (0, _enhance2.default)(TreeMap);

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polar = __webpack_require__(60);
	
	var _interactivity = __webpack_require__(224);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _enhance = __webpack_require__(308);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _TreeMapNodeTooltip = __webpack_require__(521);
	
	var _TreeMapNodeTooltip2 = _interopRequireDefault(_TreeMapNodeTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var findNodeUnderCursor = function findNodeUnderCursor(nodes, margin, x, y) {
	    return nodes.find(function (node) {
	        return (0, _interactivity.isCursorInRect)(node.x + margin.left, node.y + margin.top, node.width, node.height, x, y);
	    });
	};
	
	var TreeMapCanvas = function (_Component) {
	    _inherits(TreeMapCanvas, _Component);
	
	    function TreeMapCanvas() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TreeMapCanvas);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleMouseHover = function (showTooltip, hideTooltip) {
	            return function (event) {
	                var _this$props = _this.props,
	                    isInteractive = _this$props.isInteractive,
	                    nodes = _this$props.nodes,
	                    margin = _this$props.margin,
	                    theme = _this$props.theme;
	
	
	                if (!isInteractive) return;
	
	                var _getRelativeCursor = (0, _interactivity.getRelativeCursor)(_this.surface, event),
	                    x = _getRelativeCursor[0],
	                    y = _getRelativeCursor[1];
	
	                var node = findNodeUnderCursor(nodes, margin, x, y);
	
	                if (node !== undefined) {
	                    showTooltip(_react2.default.createElement(_TreeMapNodeTooltip2.default, { node: node, theme: theme }), event);
	                } else {
	                    hideTooltip();
	                }
	            };
	        }, _this.handleMouseLeave = function (hideTooltip) {
	            return function () {
	                hideTooltip();
	            };
	        }, _this.handleClick = function (event) {
	            var _this$props2 = _this.props,
	                isInteractive = _this$props2.isInteractive,
	                nodes = _this$props2.nodes,
	                margin = _this$props2.margin,
	                onClick = _this$props2.onClick;
	
	
	            if (!isInteractive) return;
	
	            var _getRelativeCursor2 = (0, _interactivity.getRelativeCursor)(_this.surface, event),
	                x = _getRelativeCursor2[0],
	                y = _getRelativeCursor2[1];
	
	            var node = findNodeUnderCursor(nodes, margin, x, y);
	            if (node !== undefined) onClick(node, event);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    TreeMapCanvas.prototype.componentDidMount = function componentDidMount() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    TreeMapCanvas.prototype.componentDidUpdate = function componentDidUpdate() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    TreeMapCanvas.prototype.draw = function draw(props) {
	        var _this2 = this;
	
	        var nodes = props.nodes,
	            pixelRatio = props.pixelRatio,
	            margin = props.margin,
	            outerWidth = props.outerWidth,
	            outerHeight = props.outerHeight,
	            borderWidth = props.borderWidth,
	            getBorderColor = props.getBorderColor,
	            enableLabel = props.enableLabel,
	            getLabelTextColor = props.getLabelTextColor,
	            orientLabel = props.orientLabel;
	
	
	        this.surface.width = outerWidth * pixelRatio;
	        this.surface.height = outerHeight * pixelRatio;
	
	        this.ctx.scale(pixelRatio, pixelRatio);
	        this.ctx.clearRect(0, 0, outerWidth, outerHeight);
	        this.ctx.translate(margin.left, margin.top);
	
	        nodes.forEach(function (node) {
	            _this2.ctx.fillStyle = node.color;
	            _this2.ctx.fillRect(node.x, node.y, node.width, node.height);
	
	            if (borderWidth > 0) {
	                _this2.ctx.strokeStyle = getBorderColor(node);
	                _this2.ctx.lineWidth = borderWidth;
	                _this2.ctx.strokeRect(node.x, node.y, node.width, node.height);
	            }
	        });
	
	        if (enableLabel) {
	            this.ctx.textAlign = 'center';
	            this.ctx.textBaseline = 'middle';
	
	            // draw labels on top
	            nodes.filter(function (_ref) {
	                var label = _ref.label;
	                return label !== undefined;
	            }).forEach(function (node) {
	                var labelTextColor = getLabelTextColor(node);
	
	                var rotate = orientLabel && node.height > node.width;
	
	                _this2.ctx.save();
	                _this2.ctx.translate(node.x + node.width / 2, node.y + node.height / 2);
	                _this2.ctx.rotate((0, _polar.degreesToRadians)(rotate ? -90 : 0));
	
	                _this2.ctx.fillStyle = labelTextColor;
	                _this2.ctx.fillText(node.label, 0, 0);
	
	                _this2.ctx.restore();
	            });
	        }
	    };
	
	    TreeMapCanvas.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            outerWidth = _props.outerWidth,
	            outerHeight = _props.outerHeight,
	            pixelRatio = _props.pixelRatio,
	            isInteractive = _props.isInteractive,
	            theme = _props.theme;
	
	
	        return _react2.default.createElement(
	            _Container2.default,
	            { isInteractive: isInteractive, theme: theme },
	            function (_ref2) {
	                var showTooltip = _ref2.showTooltip,
	                    hideTooltip = _ref2.hideTooltip;
	                return _react2.default.createElement('canvas', {
	                    ref: function ref(surface) {
	                        _this3.surface = surface;
	                    },
	                    width: outerWidth * pixelRatio,
	                    height: outerHeight * pixelRatio,
	                    style: {
	                        width: outerWidth,
	                        height: outerHeight
	                    },
	                    onMouseEnter: _this3.handleMouseHover(showTooltip, hideTooltip),
	                    onMouseMove: _this3.handleMouseHover(showTooltip, hideTooltip),
	                    onMouseLeave: _this3.handleMouseLeave(hideTooltip),
	                    onClick: _this3.handleClick
	                });
	            }
	        );
	    };
	
	    return TreeMapCanvas;
	}(_react.Component);
	
	TreeMapCanvas.displayName = 'TreeMapCanvas';
	
	exports.default = (0, _enhance2.default)(TreeMapCanvas);

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(25);
	
	var _colors = __webpack_require__(24);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _enhance = __webpack_require__(308);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _interactivity = __webpack_require__(522);
	
	var _motion = __webpack_require__(523);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreeMapHtml = function TreeMapHtml(_ref) {
	    var nodes = _ref.nodes,
	        nodeComponent = _ref.nodeComponent,
	        margin = _ref.margin,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        theme = _ref.theme,
	        borderWidth = _ref.borderWidth,
	        getBorderColor = _ref.getBorderColor,
	        getLabelTextColor = _ref.getLabelTextColor,
	        orientLabel = _ref.orientLabel,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping,
	        isInteractive = _ref.isInteractive,
	        onClick = _ref.onClick;
	
	    var springConfig = {
	        stiffness: motionStiffness,
	        damping: motionDamping
	    };
	
	    var getHandlers = function getHandlers(node, showTooltip, hideTooltip) {
	        return (0, _interactivity.getNodeHandlers)(node, {
	            isInteractive: isInteractive,
	            onClick: onClick,
	            showTooltip: showTooltip,
	            hideTooltip: hideTooltip,
	            theme: theme
	        });
	    };
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        position: 'relative',
	                        width: outerWidth,
	                        height: outerHeight
	                    }
	                },
	                !animate && _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: margin.top, left: margin.left } },
	                    nodes.map(function (node) {
	                        return _react2.default.createElement(nodeComponent, {
	                            key: node.path,
	                            node: node,
	                            style: {
	                                x: node.x,
	                                y: node.y,
	                                width: node.width,
	                                height: node.height,
	                                color: node.color,
	                                borderWidth: borderWidth,
	                                borderColor: getBorderColor(node),
	                                labelTextColor: getLabelTextColor(node),
	                                orientLabel: orientLabel
	                            },
	                            handlers: getHandlers(node, showTooltip, hideTooltip)
	                        });
	                    })
	                ),
	                animate && _react2.default.createElement(
	                    _reactMotion.TransitionMotion,
	                    {
	                        willEnter: _motion.nodeWillEnter,
	                        willLeave: (0, _motion.nodeWillLeave)(springConfig),
	                        styles: nodes.map(function (node) {
	                            return {
	                                key: node.path,
	                                data: node,
	                                style: _extends({
	                                    x: (0, _reactMotion.spring)(node.x, springConfig),
	                                    y: (0, _reactMotion.spring)(node.y, springConfig),
	                                    width: (0, _reactMotion.spring)(node.width, springConfig),
	                                    height: (0, _reactMotion.spring)(node.height, springConfig)
	                                }, (0, _colors.colorMotionSpring)(node.color, springConfig))
	                            };
	                        })
	                    },
	                    function (interpolatedStyles) {
	                        return _react2.default.createElement(
	                            'div',
	                            {
	                                style: {
	                                    position: 'absolute',
	                                    top: margin.top,
	                                    left: margin.left
	                                }
	                            },
	                            interpolatedStyles.map(function (_ref3) {
	                                var style = _ref3.style,
	                                    node = _ref3.data;
	
	                                style.color = (0, _colors.getInterpolatedColor)(style);
	
	                                return _react2.default.createElement(nodeComponent, {
	                                    key: node.path,
	                                    node: node,
	                                    style: _extends({}, style, {
	                                        fill: node.fill,
	                                        borderWidth: borderWidth,
	                                        borderColor: getBorderColor(style),
	                                        labelTextColor: getLabelTextColor(style),
	                                        orientLabel: orientLabel
	                                    }),
	                                    handlers: getHandlers(node, showTooltip, hideTooltip)
	                                });
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    );
	};
	
	TreeMapHtml.displayName = 'TreeMapHtml';
	
	exports.default = (0, _enhance2.default)(TreeMapHtml);

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreeMapNodeTooltip = function TreeMapNodeTooltip(_ref) {
	    var node = _ref.node,
	        theme = _ref.theme;
	    return _react2.default.createElement(_BasicTooltip2.default, {
	        id: node.id,
	        value: node.value,
	        enableChip: true,
	        color: node.color,
	        theme: theme
	    });
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	exports.default = (0, _pure2.default)(TreeMapNodeTooltip);

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getNodeHandlers = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TreeMapNodeTooltip = __webpack_require__(521);
	
	var _TreeMapNodeTooltip2 = _interopRequireDefault(_TreeMapNodeTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var getNodeHandlers = exports.getNodeHandlers = function getNodeHandlers(node, _ref) {
	    var isInteractive = _ref.isInteractive,
	        _onClick = _ref.onClick,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        theme = _ref.theme;
	
	    if (!isInteractive) return {};
	
	    var handleTooltip = function handleTooltip(e) {
	        showTooltip(_react2.default.createElement(_TreeMapNodeTooltip2.default, { node: node, theme: theme }), e);
	    };
	
	    return {
	        onMouseEnter: handleTooltip,
	        onMouseMove: handleTooltip,
	        onMouseLeave: hideTooltip,
	        onClick: function onClick(event) {
	            return _onClick(node, event);
	        }
	    };
	};

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nodeWillLeave = exports.nodeWillEnter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _reactMotion = __webpack_require__(25);
	
	var _colors = __webpack_require__(24);
	
	var nodeWillEnter = exports.nodeWillEnter = function nodeWillEnter(_ref) {
	    var node = _ref.data;
	    return _extends({
	        x: node.x,
	        y: node.y,
	        width: node.width,
	        height: node.height
	    }, (0, _colors.colorMotionSpring)(node.color));
	};
	
	var nodeWillLeave = exports.nodeWillLeave = function nodeWillLeave(springConfig) {
	    return function (_ref2) {
	        var node = _ref2.data;
	        return _extends({
	            x: (0, _reactMotion.spring)(node.x + node.width / 2, springConfig),
	            y: (0, _reactMotion.spring)(node.y + node.height / 2, springConfig),
	            width: (0, _reactMotion.spring)(0, springConfig),
	            height: (0, _reactMotion.spring)(0, springConfig)
	        }, (0, _colors.colorMotionSpring)(node.color, springConfig));
	    };
	};

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.TreeMapCanvasDefaultProps = exports.TreeMapHtmlDefaultProps = exports.TreeMapPlaceholdersDefaultProps = exports.TreeMapDefaultProps = exports.TreeMapHtmlCanvasPropTypes = exports.TreeMapHtmlPropTypes = exports.TreeMapPlaceholdersPropTypes = exports.TreeMapPropTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noop = __webpack_require__(107);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _props = __webpack_require__(19);
	
	var _TreeMapNode = __webpack_require__(1144);
	
	var _TreeMapNode2 = _interopRequireDefault(_TreeMapNode);
	
	var _TreeMapHtmlNode = __webpack_require__(1143);
	
	var _TreeMapHtmlNode2 = _interopRequireDefault(_TreeMapHtmlNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*—————————————————————————————————————————————————————————————————————————————
	
	  Prop types
	
	—————————————————————————————————————————————————————————————————————————————*/
	
	var commonPropTypes = {
	    // data
	    // `root` managed by `withHierarchy()` HOC
	    identity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	    // dimensions managed by `withDimensions()` HOC
	
	    // styling
	    // theme managed by `withTheme()` HOC
	    // colors managed by `withColors()` HOC
	
	    leavesOnly: _propTypes2.default.bool.isRequired,
	    tile: _props.treeMapTilePropType.isRequired,
	    innerPadding: _propTypes2.default.number.isRequired,
	    outerPadding: _propTypes2.default.number.isRequired,
	
	    // labels
	    enableLabel: _propTypes2.default.bool.isRequired,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    labelFormat: _propTypes2.default.string,
	    labelSkipSize: _propTypes2.default.number.isRequired,
	    orientLabel: _propTypes2.default.bool.isRequired,
	
	    // border
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.any.isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool.isRequired,
	    onClick: _propTypes2.default.func.isRequired
	};
	
	var TreeMapPropTypes = exports.TreeMapPropTypes = _extends({}, commonPropTypes, {
	    nodeComponent: _propTypes2.default.func.isRequired
	}, _props.defsPropTypes);
	
	var TreeMapPlaceholdersPropTypes = exports.TreeMapPlaceholdersPropTypes = TreeMapPropTypes;
	
	var TreeMapHtmlPropTypes = exports.TreeMapHtmlPropTypes = _extends({}, commonPropTypes, {
	    nodeComponent: _propTypes2.default.func.isRequired
	});
	
	var TreeMapHtmlCanvasPropTypes = exports.TreeMapHtmlCanvasPropTypes = _extends({}, commonPropTypes, {
	    pixelRatio: _propTypes2.default.number.isRequired
	
	    /*—————————————————————————————————————————————————————————————————————————————
	    
	      Default props
	    
	    —————————————————————————————————————————————————————————————————————————————*/
	
	});var commonDefaultProps = {
	    // data
	    identity: 'id',
	
	    tile: 'squarify',
	    leavesOnly: false,
	
	    // labels
	    enableLabel: true,
	    label: 'id',
	    labelSkipSize: 0,
	    labelTextColor: 'inherit:darker(1)',
	    orientLabel: true,
	
	    innerPadding: 0,
	    outerPadding: 0,
	
	    borderWidth: 0,
	    borderColor: 'inherit',
	
	    // interactivity
	    isInteractive: true,
	    onClick: _noop2.default
	};
	
	var TreeMapDefaultProps = exports.TreeMapDefaultProps = _extends({}, commonDefaultProps, {
	    nodeComponent: _TreeMapNode2.default,
	    defs: [],
	    fill: []
	});
	
	var TreeMapPlaceholdersDefaultProps = exports.TreeMapPlaceholdersDefaultProps = TreeMapDefaultProps;
	
	var TreeMapHtmlDefaultProps = exports.TreeMapHtmlDefaultProps = _extends({}, commonDefaultProps, {
	    nodeComponent: _TreeMapHtmlNode2.default
	});
	
	var TreeMapCanvasDefaultProps = exports.TreeMapCanvasDefaultProps = _extends({}, commonDefaultProps, {
	    pixelRatio: global.window && global.window.devicePixelRatio ? global.window.devicePixelRatio : 1
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Voronoi = __webpack_require__(146);
	
	var _Container = __webpack_require__(32);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SvgWrapper = __webpack_require__(59);
	
	var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);
	
	var _enhance = __webpack_require__(1147);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _props = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var Voronoi = function Voronoi(_ref) {
	    var data = _ref.data,
	        margin = _ref.margin,
	        width = _ref.width,
	        height = _ref.height,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        enableSites = _ref.enableSites,
	        enableLinks = _ref.enableLinks,
	        enablePolygons = _ref.enablePolygons,
	        theme = _ref.theme,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        linkWidth = _ref.linkWidth,
	        linkColor = _ref.linkColor,
	        siteSize = _ref.siteSize,
	        siteColor = _ref.siteColor;
	
	    var voronoi = (0, _d3Voronoi.voronoi)().x(function (d) {
	        return d.x;
	    }).y(function (d) {
	        return d.y;
	    }).extent([[0, 0], [width, height]]);
	
	    var polygons = voronoi.polygons(data);
	    var links = voronoi.links(data);
	
	    return _react2.default.createElement(
	        _Container2.default,
	        { isInteractive: false, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	            return _react2.default.createElement(
	                _SvgWrapper2.default,
	                { width: outerWidth, height: outerHeight, margin: margin },
	                enableLinks && links.map(function (l) {
	                    return _react2.default.createElement('line', {
	                        key: l.source.id + '.' + l.target.id,
	                        fill: 'none',
	                        stroke: linkColor,
	                        strokeWidth: linkWidth,
	                        x1: l.source.x,
	                        y1: l.source.y,
	                        x2: l.target.x,
	                        y2: l.target.y
	                    });
	                }),
	                enablePolygons && polygons.map(function (p) {
	                    return _react2.default.createElement('path', {
	                        key: p.data.id,
	                        fill: 'none',
	                        stroke: borderColor,
	                        strokeWidth: borderWidth,
	                        d: 'M' + p.join('L') + 'Z',
	                        onClick: function onClick() {
	                            console.log(p.data);
	                        }
	                    });
	                }),
	                enableSites && data.map(function (d) {
	                    return _react2.default.createElement('circle', {
	                        key: d.id,
	                        r: siteSize / 2,
	                        cx: d.x,
	                        cy: d.y,
	                        fill: siteColor,
	                        stroke: 'none'
	                    });
	                })
	            );
	        }
	    );
	};
	
	Voronoi.propTypes = _props.VoronoiPropTypes;
	
	exports.default = (0, _enhance2.default)(Voronoi);

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.gradientTypes = undefined;
	
	var _LinearGradient = __webpack_require__(1150);
	
	Object.keys(_LinearGradient).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _LinearGradient[key];
	    }
	  });
	});
	var gradientTypes = exports.gradientTypes = {
	  linearGradient: _LinearGradient.LinearGradient
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.patternTypes = undefined;
	
	var _PatternDots = __webpack_require__(1151);
	
	Object.keys(_PatternDots).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _PatternDots[key];
	    }
	  });
	});
	
	var _PatternLines = __webpack_require__(1152);
	
	Object.keys(_PatternLines).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _PatternLines[key];
	    }
	  });
	});
	
	var _PatternSquares = __webpack_require__(1153);
	
	Object.keys(_PatternSquares).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _PatternSquares[key];
	    }
	  });
	});
	var patternTypes = exports.patternTypes = {
	  patternDots: _PatternDots.PatternDots,
	  patternLines: _PatternLines.PatternLines,
	  patternSquares: _PatternSquares.PatternSquares
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.computeAxisTicks = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _bridge = __webpack_require__(529);
	
	var horizontalPositions = ['top', 'bottom'];
	var verticalPositions = ['left', 'right'];
	
	var centerScale = function centerScale(scale) {
	    var bandwidth = scale.bandwidth();
	
	    if (bandwidth === 0) return scale;
	
	    var offset = bandwidth / 2;
	    if (scale.round()) {
	        offset = Math.round(offset);
	    }
	
	    return function (d) {
	        return scale(d) + offset;
	    };
	};
	
	/**
	 * @typedef {Object} AxisTick
	 * @param {number} x
	 * @param {number} y
	 * @param {number} lineX
	 * @param {number} lineY
	 * @param {number} textX
	 * @param {number} textY
	 */
	
	/**
	 * @param {number}                width
	 * @param {number}                height
	 * @param {string}                _position
	 * @param {Function}              scale
	 * @param {Array.<string|number>} [tickValues]
	 * @param {number}                [tickCount]
	 * @param {number}                [tickSize=5]
	 * @param {number}                [tickPadding=5]
	 * @param {number}                [tickRotation=0]
	 * @parem {string}                [engine='svg']
	 * @return {{ x: number, y: number, ticks: Array.<AxisTick>, textAlign: string, textBaseline: string }}
	 */
	var computeAxisTicks = exports.computeAxisTicks = function computeAxisTicks(_ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        _position = _ref.position,
	        scale = _ref.scale,
	        tickValues = _ref.tickValues,
	        tickCount = _ref.tickCount,
	        _ref$tickSize = _ref.tickSize,
	        tickSize = _ref$tickSize === undefined ? 5 : _ref$tickSize,
	        _ref$tickPadding = _ref.tickPadding,
	        tickPadding = _ref$tickPadding === undefined ? 5 : _ref$tickPadding,
	        _ref$tickRotation = _ref.tickRotation,
	        tickRotation = _ref$tickRotation === undefined ? 0 : _ref$tickRotation,
	        _ref$engine = _ref.engine,
	        engine = _ref$engine === undefined ? 'svg' : _ref$engine;
	
	    var values = void 0;
	    if (tickValues) values = tickValues;else if (scale.ticks) values = scale.ticks(tickCount);else values = scale.domain();
	
	    var textProps = _bridge.textPropsByEngine[engine];
	
	    var orient = _position;
	    var position = scale.bandwidth ? centerScale(scale) : scale;
	    var line = { lineX: 0, lineY: 0 };
	    var text = { textX: 0, textY: 0 };
	
	    var x = 0;
	    var y = 0;
	    var translate = void 0;
	    var textAlign = textProps.align.center;
	    var textBaseline = textProps.baseline.center;
	
	    if (horizontalPositions.includes(orient)) {
	        translate = function translate(d) {
	            return { x: position(d), y: 0 };
	        };
	
	        line.lineY = tickSize * (orient === 'bottom' ? 1 : -1);
	        text.textY = (tickSize + tickPadding) * (orient === 'bottom' ? 1 : -1);
	
	        if (orient === 'bottom') {
	            y = height;
	            textBaseline = textProps.baseline.top;
	        } else {
	            textBaseline = textProps.baseline.bottom;
	        }
	
	        if (tickRotation === 0) {
	            textAlign = textProps.align.center;
	        } else if (orient === 'bottom' && tickRotation < 0 || orient === 'top' && tickRotation > 0) {
	            textAlign = textProps.align.right;
	            textBaseline = textProps.baseline.center;
	        } else if (orient === 'bottom' && tickRotation > 0 || orient === 'top' && tickRotation < 0) {
	            textAlign = textProps.align.left;
	            textBaseline = textProps.baseline.center;
	        }
	    } else if (verticalPositions.includes(orient)) {
	        translate = function translate(d) {
	            return { x: 0, y: position(d) };
	        };
	
	        line.lineX = tickSize * (orient === 'right' ? 1 : -1);
	        text.textX = (tickSize + tickPadding) * (orient === 'right' ? 1 : -1);
	
	        if (orient === 'right') {
	            x = width;
	            textAlign = textProps.align.left;
	        } else {
	            textAlign = textProps.align.right;
	        }
	    }
	
	    var ticks = values.map(function (value) {
	        return _extends({
	            key: value,
	            value: value
	        }, translate(value), line, text);
	    });
	
	    return {
	        x: x,
	        y: y,
	        ticks: ticks,
	        textAlign: textAlign,
	        textBaseline: textBaseline
	    };
	};

/***/ },
/* 529 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	
	var textPropsByEngine = exports.textPropsByEngine = {
	    svg: {
	        align: {
	            left: 'start',
	            center: 'middle',
	            right: 'end'
	        },
	        baseline: {
	            top: 'before-edge',
	            center: 'central',
	            bottom: 'after-edge'
	        }
	    },
	    canvas: {
	        align: {
	            left: 'left',
	            center: 'center',
	            right: 'right'
	        },
	        baseline: {
	            top: 'top',
	            center: 'middle',
	            bottom: 'bottom'
	        }
	    }
	};

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.renderAxes = exports.renderAxis = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _axes = __webpack_require__(528);
	
	var _polar = __webpack_require__(60);
	
	var horizontalPositions = ['top', 'bottom'];
	var positions = ['top', 'right', 'bottom', 'left'];
	
	var renderAxis = exports.renderAxis = function renderAxis(ctx, _ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        position = _ref.position,
	        scale = _ref.scale,
	        _ref$tickSize = _ref.tickSize,
	        tickSize = _ref$tickSize === undefined ? 5 : _ref$tickSize,
	        _ref$tickPadding = _ref.tickPadding,
	        tickPadding = _ref$tickPadding === undefined ? 5 : _ref$tickPadding,
	        _ref$tickRotation = _ref.tickRotation,
	        tickRotation = _ref$tickRotation === undefined ? 0 : _ref$tickRotation;
	
	    var _computeAxisTicks = (0, _axes.computeAxisTicks)({
	        width: width,
	        height: height,
	        position: position,
	        scale: scale,
	        tickSize: tickSize,
	        tickPadding: tickPadding,
	        tickRotation: tickRotation,
	        engine: 'canvas'
	    }),
	        x = _computeAxisTicks.x,
	        y = _computeAxisTicks.y,
	        ticks = _computeAxisTicks.ticks,
	        textAlign = _computeAxisTicks.textAlign,
	        textBaseline = _computeAxisTicks.textBaseline;
	
	    ctx.save();
	    ctx.translate(x, y);
	    ctx.textAlign = textAlign;
	    ctx.textBaseline = textBaseline;
	
	    ticks.forEach(function (tick) {
	        ctx.beginPath();
	        ctx.moveTo(tick.x, tick.y);
	        ctx.lineTo(tick.x + tick.lineX, tick.y + tick.lineY);
	        ctx.stroke();
	
	        ctx.save();
	        ctx.translate(tick.x + tick.textX, tick.y + tick.textY);
	        ctx.rotate((0, _polar.degreesToRadians)(tickRotation));
	        ctx.fillText(tick.value, 0, 0);
	        ctx.restore();
	    });
	
	    ctx.restore();
	};
	
	var renderAxes = exports.renderAxes = function renderAxes(ctx, _ref2) {
	    var xScale = _ref2.xScale,
	        yScale = _ref2.yScale,
	        width = _ref2.width,
	        height = _ref2.height,
	        top = _ref2.top,
	        right = _ref2.right,
	        bottom = _ref2.bottom,
	        left = _ref2.left;
	
	    var axes = { top: top, right: right, bottom: bottom, left: left };
	
	    positions.map(function (position) {
	        if (!axes[position]) return null;
	
	        var axis = axes[position];
	        var scale = horizontalPositions.includes(position) ? xScale : yScale;
	
	        renderAxis(ctx, _extends({}, axis, {
	            width: width,
	            height: height,
	            position: position,
	            scale: scale
	        }));
	    });
	};

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getIndexedScale = undefined;
	
	var _d3Scale = __webpack_require__(71);
	
	/**
	 * Generates indexed scale.
	 *
	 * @param {Array.<Object>} data
	 * @param {Function}       getIndex
	 * @param {Array.<number>} range
	 * @param {number}         padding
	 * @returns {Function}
	 */
	var getIndexedScale = exports.getIndexedScale = function getIndexedScale(data, getIndex, range, padding) {
	  return (0, _d3Scale.scaleBand)().rangeRound(range).domain(data.map(getIndex)).padding(padding);
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _grouped = __webpack_require__(1166);
	
	Object.keys(_grouped).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _grouped[key];
	    }
	  });
	});
	
	var _stacked = __webpack_require__(1167);
	
	Object.keys(_stacked).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _stacked[key];
	    }
	  });
	});

/***/ },
/* 533 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	
	var isHoverTargetByType = {
	    cell: function cell(node, current) {
	        return node.xKey === current.xKey && node.yKey === current.yKey;
	    },
	    row: function row(node, current) {
	        return node.yKey === current.yKey;
	    },
	    column: function column(node, current) {
	        return node.xKey === current.xKey;
	    },
	    rowColumn: function rowColumn(node, current) {
	        return node.xKey === current.xKey || node.yKey === current.yKey;
	    }
	};
	
	var computeNodes = exports.computeNodes = function computeNodes(_ref) {
	    var data = _ref.data,
	        keys = _ref.keys,
	        getIndex = _ref.getIndex,
	        xScale = _ref.xScale,
	        yScale = _ref.yScale,
	        sizeScale = _ref.sizeScale,
	        cellOpacity = _ref.cellOpacity,
	        cellWidth = _ref.cellWidth,
	        cellHeight = _ref.cellHeight,
	        colorScale = _ref.colorScale,
	        getLabelTextColor = _ref.getLabelTextColor,
	        currentNode = _ref.currentNode,
	        hoverTarget = _ref.hoverTarget,
	        cellHoverOpacity = _ref.cellHoverOpacity,
	        cellHoverOthersOpacity = _ref.cellHoverOthersOpacity;
	
	    var isHoverTarget = isHoverTargetByType[hoverTarget];
	
	    return data.reduce(function (acc, d) {
	        keys.forEach(function (key) {
	            var width = sizeScale ? Math.min(sizeScale(d[key]) * cellWidth, cellWidth) : cellWidth;
	            var height = sizeScale ? Math.min(sizeScale(d[key]) * cellHeight, cellHeight) : cellHeight;
	
	            var node = {
	                key: key + "." + getIndex(d),
	                xKey: key,
	                yKey: getIndex(d),
	                x: xScale(key),
	                y: yScale(getIndex(d)),
	                width: width,
	                height: height,
	                value: d[key],
	                color: colorScale(d[key])
	            };
	
	            var opacity = cellOpacity;
	            if (currentNode) {
	                opacity = isHoverTarget(node, currentNode) ? cellHoverOpacity : cellHoverOthersOpacity;
	            }
	
	            acc.push(Object.assign(node, {
	                labelTextColor: getLabelTextColor(node),
	                opacity: opacity
	            }));
	        });
	
	        return acc;
	    }, []);
	};

/***/ },
/* 534 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var computeNodePath = exports.computeNodePath = function computeNodePath(node, getIdentity) {
	  return node.ancestors().map(function (ancestor) {
	    return getIdentity(ancestor.data);
	  }).join('.');
	};

/***/ },
/* 535 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var degreesToRadians = exports.degreesToRadians = function degreesToRadians(degrees) {
	  return degrees * Math.PI / 180;
	};
	
	var radiansToDegrees = exports.radiansToDegrees = function radiansToDegrees(radians) {
	  return 180 * radians / Math.PI;
	};
	
	var midAngle = exports.midAngle = function midAngle(arc) {
	  return arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
	};
	
	var positionFromAngle = exports.positionFromAngle = function positionFromAngle(angle, distance) {
	  return {
	    x: Math.cos(angle) * distance,
	    y: Math.sin(angle) * distance
	  };
	};

/***/ },
/* 536 */
254,
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1186)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 538 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(713);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1205);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1222);


/***/ },
/* 542 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(109);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(135);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(65);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1267);
	var warning = __webpack_require__(8);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 545 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(332);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var LinkedValueUtils = __webpack_require__(321);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(72);
	
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactUpdates = __webpack_require__(72);
	var Transaction = __webpack_require__(228);
	
	var emptyFunction = __webpack_require__(36);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1209);
	var BeforeInputEventPlugin = __webpack_require__(1211);
	var ChangeEventPlugin = __webpack_require__(1213);
	var DefaultEventPluginOrder = __webpack_require__(1215);
	var EnterLeaveEventPlugin = __webpack_require__(1216);
	var HTMLDOMPropertyConfig = __webpack_require__(1218);
	var ReactComponentBrowserEnvironment = __webpack_require__(1220);
	var ReactDOMComponent = __webpack_require__(1223);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMEmptyComponent = __webpack_require__(1224);
	var ReactDOMTreeTraversal = __webpack_require__(1233);
	var ReactDOMTextComponent = __webpack_require__(1231);
	var ReactDefaultBatchingStrategy = __webpack_require__(548);
	var ReactEventListener = __webpack_require__(1236);
	var ReactInjection = __webpack_require__(1237);
	var ReactReconcileTransaction = __webpack_require__(1241);
	var SVGDOMPropertyConfig = __webpack_require__(1246);
	var SelectEventPlugin = __webpack_require__(1247);
	var SimpleEventPlugin = __webpack_require__(1248);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 550 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 551 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(4);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1229);
	
	var containsNode = __webpack_require__(864);
	var focusNode = __webpack_require__(402);
	var getActiveElement = __webpack_require__(403);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1259);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var DOMLazyTree = __webpack_require__(134);
	var DOMProperty = __webpack_require__(135);
	var React = __webpack_require__(115);
	var ReactBrowserEventEmitter = __webpack_require__(226);
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMContainerInfo = __webpack_require__(546);
	var ReactDOMFeatureFlags = __webpack_require__(1225);
	var ReactFeatureFlags = __webpack_require__(551);
	var ReactInstanceMap = __webpack_require__(171);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactMarkupChecksum = __webpack_require__(554);
	var ReactReconciler = __webpack_require__(110);
	var ReactUpdateQueue = __webpack_require__(324);
	var ReactUpdates = __webpack_require__(72);
	
	var emptyObject = __webpack_require__(43);
	var instantiateReactComponent = __webpack_require__(329);
	var invariant = __webpack_require__(4);
	var setInnerHTML = __webpack_require__(230);
	var shouldUpdateReactComponent = __webpack_require__(331);
	var warning = __webpack_require__(8);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var React = __webpack_require__(115);
	
	var invariant = __webpack_require__(4);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var PooledClass = __webpack_require__(109);
	var Transaction = __webpack_require__(228);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactServerUpdateQueue = __webpack_require__(1245);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 558 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ },
/* 559 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 561 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(556);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 564 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	var escapeTextContentForBrowser = __webpack_require__(229);
	var setInnerHTML = __webpack_require__(230);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var REACT_ELEMENT_TYPE = __webpack_require__(1234);
	
	var getIteratorFn = __webpack_require__(1264);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(320);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1277);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(1423);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _getTypes = __webpack_require__(1272);
	
	var _getTypes2 = _interopRequireDefault(_getTypes);
	
	var _getContentRect = __webpack_require__(1271);
	
	var _getContentRect2 = _interopRequireDefault(_getContentRect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withContentRect(types) {
	  return function (WrappedComponent) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          contentRect: {
	            entry: {},
	            client: {},
	            offset: {},
	            scroll: {},
	            bounds: {},
	            margin: {}
	          }
	        }, _this.measure = function (entries) {
	          var contentRect = (0, _getContentRect2.default)(_this._node, types || (0, _getTypes2.default)(_this.props));
	
	          if (entries) {
	            contentRect.entry = entries[0].contentRect;
	          }
	
	          _this.setState({ contentRect: contentRect });
	
	          if (typeof _this.props.onResize === 'function') {
	            _this.props.onResize(contentRect);
	          }
	        }, _this._handleRef = function (node) {
	          if (_this._resizeObserver) {
	            if (node) {
	              _this._resizeObserver.observe(node);
	            } else {
	              _this._resizeObserver.disconnect(_this._node);
	            }
	          }
	          _this._node = node;
	
	          if (typeof _this.props.innerRef === 'function') {
	            _this.props.innerRef(node);
	          }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(_class, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          this._resizeObserver = new _resizeObserverPolyfill2.default(this.measure);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              innerRef = _props.innerRef,
	              onResize = _props.onResize,
	              props = _objectWithoutProperties(_props, ['innerRef', 'onResize']);
	
	          return (0, _react.createElement)(WrappedComponent, _extends({}, props, {
	            measureRef: this._handleRef,
	            measure: this.measure,
	            contentRect: this.state.contentRect
	          }));
	        }
	      }]);
	
	      return _class;
	    }(_react.Component), _class.propTypes = {
	      client: _propTypes2.default.bool,
	      offset: _propTypes2.default.bool,
	      scroll: _propTypes2.default.bool,
	      bounds: _propTypes2.default.bool,
	      margin: _propTypes2.default.bool,
	      innerRef: _propTypes2.default.func,
	      onResize: _propTypes2.default.func,
	      children: _propTypes2.default.func
	    }, _temp2;
	  };
	}
	
	exports.default = withContentRect;
	module.exports = exports['default'];

/***/ },
/* 568 */
538,
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(31);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateManager = __webpack_require__(1292);
	
	var _AnimateManager2 = _interopRequireDefault(_AnimateManager);
	
	var _PureRender = __webpack_require__(1293);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _easing = __webpack_require__(570);
	
	var _configUpdate = __webpack_require__(1294);
	
	var _configUpdate2 = _interopRequireDefault(_configUpdate);
	
	var _util = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Animate = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate(props, context) {
	    _classCallCheck(this, Animate);
	
	    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));
	
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	
	
	    _this.handleStyleChange = _this.handleStyleChange.bind(_this);
	    _this.changeStyle = _this.changeStyle.bind(_this);
	
	    if (!isActive) {
	      _this.state = { style: {} };
	
	      // if children is a function and animation is not active, set style to 'to'
	      if (typeof children === 'function') {
	        _this.state = { style: to };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = { style: steps[0].style };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	
	        return _possibleConstructorReturn(_this);
	      }
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = { style: {} };
	    }
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isActive = _props.isActive,
	          canBegin = _props.canBegin;
	
	
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isActive = nextProps.isActive,
	          canBegin = nextProps.canBegin,
	          attributeName = nextProps.attributeName,
	          shouldReAnimate = nextProps.shouldReAnimate;
	
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        this.setState({
	          style: attributeName ? _defineProperty({}, attributeName, nextProps.to) : nextProps.to
	        });
	
	        return;
	      }
	
	      var animateProps = ['to', 'canBegin', 'isActive'];
	
	      if ((0, _isEqual3.default)(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
	        return;
	      }
	
	      var isTriggered = !this.props.canBegin || !this.props.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;
	
	      this.setState({
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      });
	
	      this.runAnimation(_extends({}, nextProps, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: 'runJSAnimation',
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	
	      var startAnimation = (0, _configUpdate2.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'runStepAnimation',
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === undefined ? 0 : _steps$$duration;
	
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === undefined ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	
	
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return [].concat(_toConsumableArray(sequence), [_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	        var newStyle = _extends({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return [].concat(_toConsumableArray(sequence), [newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: 'runAnimation',
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager2.default)();
	      }
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsFrom = props.from,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	
	
	      var manager = this.manager;
	
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	
	      manager.start([onAnimationStart, begin, _extends({}, to, { transition: transition }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'handleStyleChange',
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: 'changeStyle',
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          begin = _props2.begin,
	          duration = _props2.duration,
	          attributeName = _props2.attributeName,
	          easing = _props2.easing,
	          isActive = _props2.isActive,
	          steps = _props2.steps,
	          from = _props2.from,
	          to = _props2.to,
	          canBegin = _props2.canBegin,
	          onAnimationEnd = _props2.onAnimationEnd,
	          shouldReAnimate = _props2.shouldReAnimate,
	          onAnimationReStart = _props2.onAnimationReStart,
	          others = _objectWithoutProperties(_props2, ['children', 'begin', 'duration', 'attributeName', 'easing', 'isActive', 'steps', 'from', 'to', 'canBegin', 'onAnimationEnd', 'shouldReAnimate', 'onAnimationReStart']);
	
	      var count = _react.Children.count(children);
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === undefined ? {} : _container$props$styl,
	            className = _container$props.className;
	
	
	        var res = (0, _react.cloneElement)(container, _extends({}, others, {
	          style: _extends({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        var onlyChild = _react.Children.only(children);
	
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react.Children.map(children, function (child) {
	          return cloneContainer(child);
	        })
	      );
	    }
	  }]);
	
	  return Animate;
	}(_react.Component), _class2.displayName = 'Animate', _class2.propTypes = {
	  from: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  to: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  attributeName: _propTypes2.default.string,
	  // animation duration
	  duration: _propTypes2.default.number,
	  begin: _propTypes2.default.number,
	  easing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    duration: _propTypes2.default.number.isRequired,
	    style: _propTypes2.default.object.isRequired,
	    easing: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes2.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes2.default.arrayOf('string'),
	    onAnimationEnd: _propTypes2.default.func
	  })),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  isActive: _propTypes2.default.bool,
	  canBegin: _propTypes2.default.bool,
	  onAnimationEnd: _propTypes2.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes2.default.bool,
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationReStart: _propTypes2.default.func
	}, _class2.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	}, _temp)) || _class;
	
	exports.default = Animate;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = undefined;
	
	var _util = __webpack_require__(232);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    var newParams = [].concat(_toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)), [0]);
	
	    return multyTime(newParams, t);
	  };
	};
	
	// calculate cubic-bezier using Newton's method
	var configBezier = exports.configBezier = function configBezier() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      default:
	        (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	
	  return bezier;
	};
	
	var configSpring = exports.configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === undefined ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === undefined ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === undefined ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	
	  return stepper;
	};
	
	var configEasing = exports.configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	      case 'spring':
	        return configSpring();
	      default:
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	
	  return null;
	};

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(725);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(1480);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.childRefs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key) {
	      var component = _this.childRefs[key];
	      if (component && component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    };
	
	    _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.childRefs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    };
	
	    _this._handleDoneEntering = function (key) {
	      var component = _this.childRefs[key];
	      if (component && component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    };
	
	    _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.childRefs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key) {
	      var component = _this.childRefs[key];
	
	      if (component && component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this2.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this2.props.childFactory(child);
	        var ref = function ref(r) {
	          _this2.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes = propTypes;
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ },
/* 573 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 576 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(583);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ufunc = __webpack_require__(624);
	
	var _helpers = __webpack_require__(578);
	
	var _utility = __webpack_require__(339);
	
	var _cuid = __webpack_require__(756);
	
	var _cuid2 = _interopRequireDefault(_cuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var base = function base(Cmpt) {
	  var UIKitBase = function (_React$Component) {
	    _inherits(UIKitBase, _React$Component);
	
	    function UIKitBase() {
	      _classCallCheck(this, UIKitBase);
	
	      return _possibleConstructorReturn(this, (UIKitBase.__proto__ || Object.getPrototypeOf(UIKitBase)).apply(this, arguments));
	    }
	
	    _createClass(UIKitBase, [{
	      key: 'render',
	      value: function render() {
	        var props = this.props;
	        var classes = [props.align ? (0, _helpers.getClass)(props.align, _utility.utilityCss.align) : null, props.borderRadius ? (0, _helpers.getClass)(props.borderRadius, _utility.utilityCss.borderRadius) : null, props.clear ? (0, _helpers.getClass)(props.clear, _utility.utilityCss.clear) : null, props.contrast ? 'uk-contrast' : null, props.col ? 'uk-width-1-1' : null, props.colSmall ? 'uk-width-1-1' : null, props.colMedium ? 'uk-width-1-1' : null, props.colLarge ? 'uk-width-1-1' : null, props.display ? (0, _helpers.getClass)(props.display, _utility.utilityCss.display) : null, props.float ? (0, _helpers.getClass)(props.float, _utility.utilityCss.float) : null, props.hidden ? (0, _helpers.getClasses)(props.hidden, _utility.utilityCss.hidden) : null, props.margin ? (0, _helpers.getClasses)(props.margin, _utility.utilityCss.margin) : null, props.order ? (0, _helpers.getClass)(props.order, _utility.utilityCss.order) : null, props.padding ? (0, _helpers.getClasses)(props.padding, _utility.utilityCss.padding) : null, props.position ? (0, _helpers.getClasses)(props.position, _utility.utilityCss.position) : null, props.responsive ? (0, _helpers.getClasses)(props.responsive, _utility.utilityCss.responsive) : null, props.scroll ? (0, _helpers.getClass)(props.scroll, _utility.utilityCss.scroll) : null, props.tall ? props.tall !== 'parent' ? _utility.utilityCss.tall : null : null, props.textAlign ? (0, _helpers.getClasses)(props.textAlign, _utility.utilityCss.textAlign) : null, props.textVertical ? (0, _helpers.getClasses)(props.textVertical, _utility.utilityCss.textVertical) : null, props.textWrap ? (0, _helpers.getClasses)(props.textWrap, _utility.utilityCss.textWrap) : null, props.vertical ? (0, _helpers.getClass)(props.vertical, _utility.utilityCss.vertical) : null, props.viewport ? 'uk-height-viewport' : null, props.visible ? (0, _helpers.getClasses)(props.visible, _utility.utilityCss.visible) : null, props.wide ? props.wide !== 'parent' ? _utility.utilityCss.tall : null : null];
	
	        var containerClasses = (0, _helpers.cleanClasses)([props.center ? _utility.utilityCss.center : null, props.col ? 'uk-width-' + props.col : null, props.colSmall ? 'uk-width-small-' + props.colSmall : null, props.colMedium ? 'uk-width-medium-' + props.colMedium : null, props.colLarge ? 'uk-width-large-' + props.colLarge : null, props.vertical ? 'uk-vertical-align' : null, props.tall ? props.tall === 'parent' ? _utility.utilityCss.tall : null : null, props.wide ? props.wide === 'parent' ? _utility.utilityCss.tall : null : null]);
	
	        var kitid = props.kitid || (0, _cuid2.default)();
	
	        // Elementd
	        var component = _react2.default.createElement(Cmpt, _extends({}, this.props, { kitid: kitid, classes: (0, _ufunc.cleanAll)(classes) }));
	
	        var list = (0, _ufunc.maybeIf)(_react2.default.createElement(
	          'li',
	          { className: containerClasses },
	          component
	        ))(props.list);
	
	        var container = (0, _ufunc.maybeIf)(_react2.default.createElement(
	          'div',
	          { className: containerClasses },
	          component
	        ))((0, _ufunc.someTrue)(props.center, props.col, props.colSmall, props.colMedium, props.colLarge, props.vertical));
	
	        // return component
	        return list || container || component;
	      }
	    }]);
	
	    return UIKitBase;
	  }(_react2.default.Component);
	
	  UIKitBase.propTypes = {
	    align: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('align')),
	    children: _react2.default.PropTypes.any,
	    className: _react2.default.PropTypes.string,
	    borderRadius: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('borderRadius')),
	    clear: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('clear')),
	    center: _react2.default.PropTypes.bool,
	    col: _react2.default.PropTypes.oneOf(_helpers.colSpan),
	    colSmall: _react2.default.PropTypes.oneOf(_helpers.colSpan),
	    colMedium: _react2.default.PropTypes.oneOf(_helpers.colSpan),
	    colLarge: _react2.default.PropTypes.oneOf(_helpers.colSpan),
	    contrast: _react2.default.PropTypes.bool,
	    display: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('display')),
	    float: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('float')),
	    hidden: _react2.default.PropTypes.string,
	    kitid: _react2.default.PropTypes.string,
	    margin: _react2.default.PropTypes.string,
	    order: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('order')),
	    padding: _react2.default.PropTypes.string,
	    position: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('position')),
	    responsive: _react2.default.PropTypes.string,
	    scroll: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('scroll')),
	    tall: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.string]),
	    textAlign: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('textAlign')),
	    textVertical: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('textVertical')),
	    textWrap: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('textWrap')),
	    vertical: _react2.default.PropTypes.oneOf((0, _utility.utilityKeys)('vertical')),
	    viewport: _react2.default.PropTypes.bool,
	    visible: _react2.default.PropTypes.string,
	    wide: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.string])
	  };
	
	  return UIKitBase;
	};
	
	exports.default = base;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getElement = exports.queryDataAll = exports.queryData = exports.getClass = exports.getClasses = exports.stringToClasses = exports.colSpan = exports.closeClass = exports.cleanProps = exports.cleanClasses = exports.breakpoints = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ufunc = __webpack_require__(624);
	
	var _utility = __webpack_require__(339);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var breakpoints = exports.breakpoints = function breakpoints() {
	  var media = {
	    small: 767,
	    medium: 768,
	    large: 960,
	    xlarge: 1200
	  };
	
	  var screen = {
	    small: window.innerWidth <= media.small,
	    medium: window.innerWidth >= media.medium && window.innerWidth < media.large,
	    large: window.innerWidth >= media.large && window.innerWidth < media.xlarge,
	    xlarge: window.innerWidth >= media.xlarge
	  };
	
	  return {
	    media: media,
	    screen: screen
	  };
	};
	
	var cleanClasses = exports.cleanClasses = function cleanClasses(c) {
	  var str = (0, _ufunc.cleanAll)(c).join(' ').trim().replace(/,/gi, ' ');
	  return (0, _ufunc.maybeIf)(str)(str !== '');
	};
	
	var cleanProps = exports.cleanProps = function cleanProps(ignoreKeys) {
	  var ignore = [].concat(_toConsumableArray(ignoreKeys), _toConsumableArray(Object.keys(_utility.utilityCss)), ['animate', 'center', 'children', 'classes', 'contrast', 'col', 'colLarge', 'colMedium', 'colSmall', 'kitid', 'list']);
	
	  return function (obj) {
	    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || Array.isArray(obj)) return null;
	
	    var newObj = _extends({}, obj);
	
	    for (var i = 0; i < ignore.length; i++) {
	      if (obj[ignore[i]]) {
	        newObj[ignore[i]] = null;
	      }
	    }
	
	    return (0, _ufunc.cleanObj)(newObj);
	  };
	};
	
	var closeClass = exports.closeClass = function closeClass(alt) {
	  return alt ? 'uk-close-alt' : ' uk-close';
	};
	
	var colSpan = exports.colSpan = ['1-1', '1-2', '1-3', '2-3', '1-4', '2-4', '3-4', '1-5', '2-5', '3-5', '4-5', '1-6', '2-6', '3-6', '4-6', '5-6', '1-10', '2-10', '3-10', '4-10', '5-10', '6-10', '7-10', '8-10', '9-10'];
	
	var stringToClasses = exports.stringToClasses = function stringToClasses(str, cssClasses) {
	  var classes = str.split(' ').map(function (item) {
	    return cssClasses[item];
	  });
	
	  return classes.join(' ');
	};
	
	var getClasses = exports.getClasses = function getClasses(str, cssClasses) {
	  return typeof str === 'string' ? stringToClasses(str, cssClasses) : '';
	};
	
	var getClass = exports.getClass = function getClass(str, cssClasses) {
	  return cssClasses[str] ? cssClasses[str] : '';
	};
	
	var queryData = exports.queryData = function queryData(value) {
	  return document.querySelector('[data-' + value + ']');
	};
	
	var queryDataAll = exports.queryDataAll = function queryDataAll(value) {
	  return document.querySelectorAll('[data-' + value + ']');
	};
	
	var getElement = exports.getElement = function getElement(dataId) {
	  return queryData('kitid="' + dataId + '"');
	};
	
	exports.default = {
	  breakpoints: breakpoints,
	  closeClass: closeClass,
	  colSpan: colSpan,
	  cleanClasses: cleanClasses,
	  cleanProps: cleanProps,
	  getClasses: getClasses,
	  getClass: getClass,
	  getElement: getElement,
	  stringToClasses: stringToClasses,
	  queryData: queryData,
	  queryDataAll: queryDataAll
	};

/***/ },
/* 579 */
573,
/* 580 */
574,
/* 581 */
575,
/* 582 */
576,
/* 583 */
[1503, 1320],
/* 584 */
573,
/* 585 */
574,
/* 586 */
575,
/* 587 */
576,
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _discreteColorLegendItem = __webpack_require__(1349);
	
	var _discreteColorLegendItem2 = _interopRequireDefault(_discreteColorLegendItem);
	
	var _theme = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape({
	    title: _propTypes2.default.string.isRequired,
	    color: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool
	  }), _propTypes2.default.string.isRequired])).isRequired,
	  onItemClick: _propTypes2.default.func,
	  height: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf(['vertical', 'horizontal'])
	};
	
	var defaultProps = {
	  className: '',
	  colors: _theme.DISCRETE_COLOR_RANGE,
	  orientation: 'vertical'
	};
	
	function fillItemsWithDefaults(items) {
	  return items.map(function (item, i) {
	    return {
	      title: item.title ? item.title : item,
	      color: item.color ? item.color : _theme.DISCRETE_COLOR_RANGE[i % _theme.DISCRETE_COLOR_RANGE.length],
	      disabled: Boolean(item.disabled)
	    };
	  });
	}
	
	function DiscreteColorLegend(_ref) {
	  var initialItems = _ref.items,
	      width = _ref.width,
	      height = _ref.height,
	      onItemClick = _ref.onItemClick,
	      orientation = _ref.orientation,
	      className = _ref.className;
	
	  var updatedItems = fillItemsWithDefaults(initialItems);
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'rv-discrete-color-legend ' + orientation + ' ' + className,
	      style: { width: width, height: height } },
	    updatedItems.map(function (item, i) {
	      return _react2.default.createElement(_discreteColorLegendItem2.default, _extends({}, item, {
	        orientation: orientation,
	        key: i,
	        onClick: onItemClick ? function () {
	          return onItemClick(initialItems[i], i);
	        } : null }));
	    })
	  );
	}
	
	DiscreteColorLegend.displayName = 'DiscreteColorLegendItem';
	DiscreteColorLegend.propTypes = propTypes;
	DiscreteColorLegend.defaultProps = defaultProps;
	
	exports.default = DiscreteColorLegend;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _pureRenderComponent = __webpack_require__(114);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _axisUtils = __webpack_require__(73);
	
	var _axisLine = __webpack_require__(1352);
	
	var _axisLine2 = _interopRequireDefault(_axisLine);
	
	var _axisTicks = __webpack_require__(1353);
	
	var _axisTicks2 = _interopRequireDefault(_axisTicks);
	
	var _axisTitle = __webpack_require__(1354);
	
	var _axisTitle2 = _interopRequireDefault(_axisTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickSize', 'tickTotal', 'tickSizeInner', 'tickSizeOuter'];
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = {
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT, TOP, BOTTOM]),
	  attr: _propTypes2.default.string.isRequired,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	
	  className: _propTypes2.default.string,
	  hideTicks: _propTypes2.default.bool,
	  hideLine: _propTypes2.default.bool,
	  tickLabelAngle: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  tickSizeInner: _propTypes2.default.number,
	  tickSizeOuter: _propTypes2.default.number,
	  tickPadding: _propTypes2.default.number,
	  tickValues: _propTypes2.default.array,
	  tickFormat: _propTypes2.default.func,
	  tickTotal: _propTypes2.default.number,
	
	  // Not expected to be used by the users.
	  // TODO: Add underscore to these properties later.
	  marginTop: _propTypes2.default.number,
	  marginBottom: _propTypes2.default.number,
	  marginLeft: _propTypes2.default.number,
	  marginRight: _propTypes2.default.number,
	  innerWidth: _propTypes2.default.number,
	  innerHeight: _propTypes2.default.number
	};
	
	var defaultProps = {
	  className: '',
	  tickSize: 6,
	  tickPadding: 8,
	  orientation: BOTTOM
	};
	
	var predefinedClassName = 'rv-xy-plot__axis';
	var VERTICAL_CLASS_NAME = 'rv-xy-plot__axis--vertical';
	var HORIZONTAL_CLASS_NAME = 'rv-xy-plot__axis--horizontal';
	
	var Axis = function (_PureRenderComponent) {
	  _inherits(Axis, _PureRenderComponent);
	
	  function Axis() {
	    _classCallCheck(this, Axis);
	
	    return _possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).apply(this, arguments));
	  }
	
	  _createClass(Axis, [{
	    key: '_getDefaultAxisProps',
	
	
	    /**
	     * Define the default values depending on the data passed from the outside.
	     * @returns {*} Object of default properties.
	     * @private
	     */
	    value: function _getDefaultAxisProps() {
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          marginTop = _props.marginTop,
	          marginBottom = _props.marginBottom,
	          marginLeft = _props.marginLeft,
	          marginRight = _props.marginRight,
	          orientation = _props.orientation;
	
	      if (orientation === BOTTOM) {
	        return {
	          tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerWidth),
	          top: innerHeight + marginTop,
	          left: marginLeft,
	          width: innerWidth,
	          height: marginBottom
	        };
	      } else if (orientation === TOP) {
	        return {
	          tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerWidth),
	          top: 0,
	          left: marginLeft,
	          width: innerWidth,
	          height: marginTop
	        };
	      } else if (orientation === LEFT) {
	        return {
	          tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerHeight),
	          top: marginTop,
	          left: 0,
	          width: marginLeft,
	          height: innerHeight
	        };
	      }
	      return {
	        tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerHeight),
	        top: marginTop,
	        left: marginLeft + innerWidth,
	        width: marginRight,
	        height: innerHeight
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animation = this.props.animation;
	
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(Axis, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var props = _extends({}, this._getDefaultAxisProps(), this.props);
	
	      var className = props.className,
	          height = props.height,
	          hideLine = props.hideLine,
	          hideTicks = props.hideTicks,
	          left = props.left,
	          orientation = props.orientation,
	          title = props.title,
	          top = props.top,
	          width = props.width;
	
	      var isVertical = [LEFT, RIGHT].indexOf(orientation) > -1;
	      var axisClassName = isVertical ? VERTICAL_CLASS_NAME : HORIZONTAL_CLASS_NAME;
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + left + ',' + top + ')',
	          className: predefinedClassName + ' ' + axisClassName + ' ' + className },
	        !hideLine && _react2.default.createElement(_axisLine2.default, {
	          height: height,
	          width: width,
	          orientation: orientation }),
	        !hideTicks && _react2.default.createElement(_axisTicks2.default, props),
	        title ? _react2.default.createElement(_axisTitle2.default, {
	          title: title,
	          height: height,
	          width: width,
	          orientation: orientation }) : null
	      );
	    }
	  }]);
	
	  return Axis;
	}(_pureRenderComponent2.default);
	
	Axis.displayName = 'Axis';
	Axis.propTypes = propTypes;
	Axis.defaultProps = defaultProps;
	Axis.requiresSVG = true;
	
	exports.default = Axis;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Color = __webpack_require__(47);
	
	var _theme = __webpack_require__(45);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	function getScaleDistance(props, attr) {
	  var scaleObject = (0, _scalesUtils.getScaleObjectFromProps)(props, attr);
	  return scaleObject ? scaleObject.distance : 0;
	}
	
	var BarSeriesCanvas = function (_AbstractSeries) {
	  _inherits(BarSeriesCanvas, _AbstractSeries);
	
	  function BarSeriesCanvas() {
	    _classCallCheck(this, BarSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (BarSeriesCanvas.__proto__ || Object.getPrototypeOf(BarSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(BarSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      var data = props.data,
	          linePosAttr = props.linePosAttr,
	          lineSizeAttr = props.lineSizeAttr,
	          valuePosAttr = props.valuePosAttr;
	
	      if (!data || data.length === 0) {
	        return;
	      }
	
	      var distance = getScaleDistance(props, linePosAttr);
	      var line = (0, _scalesUtils.getAttributeFunctor)(props, linePosAttr);
	      var value = (0, _scalesUtils.getAttributeFunctor)(props, valuePosAttr);
	      var value0 = (0, _scalesUtils.getAttr0Functor)(props, valuePosAttr);
	      var fill = (0, _scalesUtils.getAttributeFunctor)(props, 'fill') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var stroke = (0, _scalesUtils.getAttributeFunctor)(props, 'stroke') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var opacity = (0, _scalesUtils.getAttributeFunctor)(props, 'opacity');
	
	      var itemSize = distance / 2 * 0.85;
	
	      var _getStackParams = (0, _seriesUtils.getStackParams)(props),
	          sameTypeTotal = _getStackParams.sameTypeTotal,
	          sameTypeIndex = _getStackParams.sameTypeIndex;
	
	      data.forEach(function (row) {
	        var fillColor = (0, _d3Color.rgb)(fill(row));
	        var strokeColor = (0, _d3Color.rgb)(stroke(row));
	        var rowOpacity = opacity(row) || _theme.DEFAULT_OPACITY;
	
	        var linePos = line(row) - itemSize + itemSize * 2 / sameTypeTotal * sameTypeIndex;
	        var valuePos = Math.min(value0(row), value(row));
	        var x = valuePosAttr === 'x' ? valuePos : linePos;
	        var y = valuePosAttr === 'y' ? valuePos : linePos;
	
	        var lineSize = itemSize * 2 / sameTypeTotal;
	        var valueSize = Math.abs(-value0(row) + value(row));
	        var height = lineSizeAttr === 'height' ? lineSize : valueSize;
	        var width = lineSizeAttr === 'width' ? lineSize : valueSize;
	
	        ctx.beginPath();
	        ctx.rect(x, y, width, height);
	        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
	        ctx.fill();
	        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
	        ctx.stroke();
	      });
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return BarSeriesCanvas;
	}(_abstractSeries2.default);
	
	BarSeriesCanvas.displayName = 'BarSeriesCanvas';
	BarSeriesCanvas.defaultProps = {
	  linePosAttr: _propTypes2.default.string.isRequired,
	  valuePosAttr: _propTypes2.default.string.isRequired,
	  lineSizeAttr: _propTypes2.default.string.isRequired,
	  valueSizeAttr: _propTypes2.default.string.isRequired
	};
	
	BarSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = BarSeriesCanvas;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--bar';
	
	var BarSeries = function (_AbstractSeries) {
	  _inherits(BarSeries, _AbstractSeries);
	
	  function BarSeries() {
	    _classCallCheck(this, BarSeries);
	
	    return _possibleConstructorReturn(this, (BarSeries.__proto__ || Object.getPrototypeOf(BarSeries)).apply(this, arguments));
	  }
	
	  _createClass(BarSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          linePosAttr = _props.linePosAttr,
	          lineSizeAttr = _props.lineSizeAttr,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          valuePosAttr = _props.valuePosAttr,
	          valueSizeAttr = _props.valueSizeAttr;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(BarSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var _getStackParams = (0, _seriesUtils.getStackParams)(this.props),
	          sameTypeTotal = _getStackParams.sameTypeTotal,
	          sameTypeIndex = _getStackParams.sameTypeIndex;
	
	      var distance = this._getScaleDistance(linePosAttr);
	      var lineFunctor = this._getAttributeFunctor(linePosAttr);
	      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
	      var value0Functor = this._getAttr0Functor(valuePosAttr);
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	
	      var itemSize = distance / 2 * 0.85;
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var _attrs;
	
	          var attrs = (_attrs = {
	            style: {
	              opacity: opacityFunctor && opacityFunctor(d),
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d)
	            }
	          }, _defineProperty(_attrs, linePosAttr, lineFunctor(d) - itemSize + itemSize * 2 / sameTypeTotal * sameTypeIndex), _defineProperty(_attrs, lineSizeAttr, itemSize * 2 / sameTypeTotal), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
	            return _this2._valueClickHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
	            return _this2._valueMouseOverHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
	            return _this2._valueMouseOutHandler(d, e);
	          }), _defineProperty(_attrs, 'key', i), _attrs);
	          return _react2.default.createElement('rect', attrs);
	        })
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return _extends({}, _abstractSeries2.default.propTypes, {
	        linePosAttr: _propTypes2.default.string,
	        valuePosAttr: _propTypes2.default.string,
	        lineSizeAttr: _propTypes2.default.string,
	        valueSizeAttr: _propTypes2.default.string,
	        cluster: _propTypes2.default.string
	      });
	    }
	  }]);
	
	  return BarSeries;
	}(_abstractSeries2.default);
	
	BarSeries.displayName = 'BarSeries';
	
	exports.default = BarSeries;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--label';
	
	var LabelSeries = function (_AbstractSeries) {
	  _inherits(LabelSeries, _AbstractSeries);
	
	  function LabelSeries() {
	    _classCallCheck(this, LabelSeries);
	
	    return _possibleConstructorReturn(this, (LabelSeries.__proto__ || Object.getPrototypeOf(LabelSeries)).apply(this, arguments));
	  }
	
	  _createClass(LabelSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          allowOffsetToBeReversed = _props.allowOffsetToBeReversed,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          xRange = _props.xRange,
	          yRange = _props.yRange;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(LabelSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.reduce(function (res, d, i) {
	          var label = d.label,
	              style = d.style,
	              xOffset = d.xOffset,
	              yOffset = d.yOffset;
	
	          if (!label) {
	            return res;
	          }
	          var xVal = xFunctor(d);
	          var yVal = yFunctor(d);
	          var leftOfMiddle = xVal < (xRange[1] - xRange[0]) / 2;
	          var aboveMiddle = yVal < Math.abs(yRange[1] - yRange[0]) / 2;
	          var attrs = _extends({
	            alignmentBaseline: aboveMiddle ? 'text-before-edge' : 'text-after-edge',
	            className: 'rv-xy-plot__series--label-text',
	            key: i,
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(d, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(d, e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(d, e);
	            },
	            textAnchor: leftOfMiddle ? 'start' : 'end',
	            x: xVal + (allowOffsetToBeReversed && leftOfMiddle ? -1 : 1) * (xOffset || 0),
	            y: yVal + (allowOffsetToBeReversed && aboveMiddle ? -1 : 1) * (yOffset || 0)
	          }, style);
	
	          return res.concat([_react2.default.createElement(
	            'text',
	            attrs,
	            label
	          )]);
	        }, [])
	      );
	    }
	  }]);
	
	  return LabelSeries;
	}(_abstractSeries2.default);
	
	LabelSeries.PropTypes = {
	  animation: _propTypes2.default.bool,
	  allowOffsetToBeReversed: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired,
	    label: _propTypes2.default.string.isRequired,
	    xOffset: _propTypes2.default.number,
	    yOffset: _propTypes2.default.number,
	    style: _propTypes2.default.object
	  })).isRequired,
	  marginLeft: _propTypes2.default.number,
	  marginTop: _propTypes2.default.number,
	  xRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  yRange: _propTypes2.default.arrayOf(_propTypes2.default.number)
	};
	
	exports.default = LabelSeries;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Color = __webpack_require__(47);
	
	var _theme = __webpack_require__(45);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	var LineSeriesCanvas = function (_AbstractSeries) {
	  _inherits(LineSeriesCanvas, _AbstractSeries);
	
	  function LineSeriesCanvas() {
	    _classCallCheck(this, LineSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (LineSeriesCanvas.__proto__ || Object.getPrototypeOf(LineSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(LineSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      var data = props.data,
	          strokeWidth = props.strokeWidth,
	          strokeDasharray = props.strokeDasharray;
	
	      if (!data || data.length === 0) {
	        return;
	      }
	
	      var x = (0, _scalesUtils.getAttributeFunctor)(props, 'x');
	      var y = (0, _scalesUtils.getAttributeFunctor)(props, 'y');
	      var stroke = (0, _scalesUtils.getAttributeValue)(props, 'stroke') || (0, _scalesUtils.getAttributeValue)(props, 'color');
	      var strokeColor = (0, _d3Color.rgb)(stroke);
	      var newOpacity = (0, _scalesUtils.getAttributeValue)(props, 'opacity');
	      var opacity = Number.isFinite(newOpacity) ? newOpacity : _theme.DEFAULT_OPACITY;
	
	      ctx.beginPath();
	      ctx.moveTo(x(data[0]), y(data[0]));
	      data.forEach(function (row) {
	        return ctx.lineTo(x(row), y(row));
	      });
	
	      ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + opacity + ')';
	      ctx.lineWidth = strokeWidth;
	      if (strokeDasharray) {
	        ctx.setLineDash(strokeDasharray);
	      }
	      ctx.stroke();
	      // set back to default
	      ctx.lineWidth = 1;
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return LineSeriesCanvas;
	}(_abstractSeries2.default);
	
	LineSeriesCanvas.displayName = 'LineSeriesCanvas';
	LineSeriesCanvas.defaultProps = {
	  strokeWidth: _propTypes2.default.number,
	  strokeDasharray: _propTypes2.default.string
	};
	
	LineSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  strokeWidth: 1
	});
	
	exports.default = LineSeriesCanvas;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deck = __webpack_require__(256);
	
	var _d3Color = __webpack_require__(47);
	
	var _theme = __webpack_require__(45);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _scalesUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var LineSeriesGL = function (_AbstractSeries) {
	  _inherits(LineSeriesGL, _AbstractSeries);
	
	  function LineSeriesGL() {
	    _classCallCheck(this, LineSeriesGL);
	
	    return _possibleConstructorReturn(this, (LineSeriesGL.__proto__ || Object.getPrototypeOf(LineSeriesGL)).apply(this, arguments));
	  }
	
	  _createClass(LineSeriesGL, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props) {
	      var data = props.data,
	          opacity = props.opacity,
	          seriesId = props.seriesId,
	          strokeWidth = props.strokeWidth,
	          onValueMouseOver = props.onValueMouseOver,
	          onValueClick = props.onValueClick,
	          fp64 = props.fp64;
	
	
	      var x = (0, _scalesUtils.getAttributeFunctor)(props, 'x');
	      var y = (0, _scalesUtils.getAttributeFunctor)(props, 'y');
	      var fill = (0, _scalesUtils.getAttributeFunctor)(props, 'fill') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var opacityScale = (0, _scalesUtils.getAttributeFunctor)(props, 'opacity');
	
	      return new _deck.PathLayer({
	        id: seriesId,
	        data: [data],
	        getPath: function getPath(p) {
	          return p.map(function (row) {
	            return [x(row), y(row)];
	          });
	        },
	        getColor: function getColor(p) {
	          var color = (0, _d3Color.rgb)(fill(p));
	          return [color.r, color.g, color.b, (opacityScale(p) || _theme.DEFAULT_OPACITY) * 255];
	        },
	        getWidth: function getWidth(p) {
	          return Number(strokeWidth) || 1;
	        },
	        opacity: opacity || _theme.DEFAULT_OPACITY,
	        projectionMode: _deck.COORDINATE_SYSTEM.IDENTITY,
	        pickable: true,
	        onHover: function onHover(row) {
	          return onValueMouseOver(row.object);
	        },
	        onClick: function onClick(row) {
	          return onValueClick(row.object);
	        },
	        fp64: fp64
	      });
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isDeckGL',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return LineSeriesGL;
	}(_abstractSeries2.default);
	
	LineSeriesGL.displayName = 'LineSeriesGL';
	LineSeriesGL.defaultProps = {
	  onValueMouseOver: function onValueMouseOver() {},
	  onValueClick: function onValueClick() {},
	  fp64: false
	};
	LineSeriesGL.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  seriesId: _propTypes2.default.string.isRequired
	});
	
	exports.default = LineSeriesGL;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(233);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _theme = __webpack_require__(45);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';
	
	var STROKE_STYLES = {
	  dashed: '6, 2',
	  solid: null
	};
	
	var defaultProps = {
	  strokeStyle: 'solid',
	  opacity: 1,
	  curve: null
	};
	
	var propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  strokeStyle: _propTypes2.default.oneOf(Object.keys(STROKE_STYLES)),
	  curve: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	});
	
	var LineSeries = function (_AbstractSeries) {
	  _inherits(LineSeries, _AbstractSeries);
	
	  function LineSeries() {
	    _classCallCheck(this, LineSeries);
	
	    return _possibleConstructorReturn(this, (LineSeries.__proto__ || Object.getPrototypeOf(LineSeries)).apply(this, arguments));
	  }
	
	  _createClass(LineSeries, [{
	    key: '_renderLine',
	    value: function _renderLine(data, x, y, curve) {
	      var line = d3Shape.line();
	      if (curve !== null) {
	        if (typeof curve === 'string' && d3Shape[curve]) {
	          line = line.curve(d3Shape[curve]);
	        } else if (typeof curve === 'function') {
	          line = line.curve(curve);
	        }
	      }
	      line = line.x(x).y(y);
	      return line(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(LineSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var _props2 = this.props,
	          strokeDasharray = _props2.strokeDasharray,
	          strokeStyle = _props2.strokeStyle,
	          strokeWidth = _props2.strokeWidth,
	          marginLeft = _props2.marginLeft,
	          marginTop = _props2.marginTop,
	          curve = _props2.curve;
	
	
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
	      var newOpacity = this._getAttributeValue('opacity');
	      var opacity = Number.isFinite(newOpacity) ? newOpacity : _theme.DEFAULT_OPACITY;
	      var d = this._renderLine(data, x, y, curve);
	
	      return _react2.default.createElement('path', {
	        d: d,
	        className: predefinedClassName + ' ' + className,
	        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
	        onMouseOver: this._seriesMouseOverHandler,
	        onMouseOut: this._seriesMouseOutHandler,
	        onClick: this._seriesClickHandler,
	        style: {
	          opacity: opacity,
	          strokeDasharray: STROKE_STYLES[strokeStyle] || strokeDasharray,
	          strokeWidth: strokeWidth,
	          stroke: stroke
	        } });
	    }
	  }]);
	
	  return LineSeries;
	}(_abstractSeries2.default);
	
	LineSeries.displayName = 'LineSeries';
	LineSeries.defaultProps = defaultProps;
	LineSeries.propTypes = propTypes;
	
	exports.default = LineSeries;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _d3Color = __webpack_require__(47);
	
	var _theme = __webpack_require__(45);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var MarkSeriesCanvas = function (_AbstractSeries) {
	  _inherits(MarkSeriesCanvas, _AbstractSeries);
	
	  function MarkSeriesCanvas() {
	    _classCallCheck(this, MarkSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (MarkSeriesCanvas.__proto__ || Object.getPrototypeOf(MarkSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(MarkSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      var data = props.data;
	
	
	      var x = (0, _scalesUtils.getAttributeFunctor)(props, 'x');
	      var y = (0, _scalesUtils.getAttributeFunctor)(props, 'y');
	      var size = (0, _scalesUtils.getAttributeFunctor)(props, 'size') || function (p) {
	        return _theme.DEFAULT_SIZE;
	      };
	      var fill = (0, _scalesUtils.getAttributeFunctor)(props, 'fill') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var stroke = (0, _scalesUtils.getAttributeFunctor)(props, 'stroke') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var opacity = (0, _scalesUtils.getAttributeFunctor)(props, 'opacity');
	
	      data.forEach(function (row) {
	        var fillColor = (0, _d3Color.rgb)(fill(row));
	        var strokeColor = (0, _d3Color.rgb)(stroke(row));
	        var rowOpacity = opacity(row) || _theme.DEFAULT_OPACITY;
	        ctx.beginPath();
	        ctx.arc(x(row), y(row), size(row), 0, 2 * Math.PI);
	        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
	        ctx.fill();
	        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
	        ctx.stroke();
	      });
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return MarkSeriesCanvas;
	}(_abstractSeries2.default);
	
	MarkSeriesCanvas.displayName = 'MarkSeriesCanvas';
	MarkSeriesCanvas.defaultProps = {};
	
	MarkSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = MarkSeriesCanvas;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _deck = __webpack_require__(256);
	
	var _d3Color = __webpack_require__(47);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _theme = __webpack_require__(45);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var MarkSeriesGL = function (_AbstractSeries) {
	  _inherits(MarkSeriesGL, _AbstractSeries);
	
	  function MarkSeriesGL() {
	    _classCallCheck(this, MarkSeriesGL);
	
	    return _possibleConstructorReturn(this, (MarkSeriesGL.__proto__ || Object.getPrototypeOf(MarkSeriesGL)).apply(this, arguments));
	  }
	
	  _createClass(MarkSeriesGL, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props) {
	      var data = props.data,
	          _renderKey = props._renderKey,
	          seriesId = props.seriesId,
	          colorDomain = props.colorDomain,
	          colorRange = props.colorRange,
	          sizeDomain = props.sizeDomain,
	          sizeRange = props.sizeRange,
	          outline = props.outline;
	
	
	      var xFunctor = (0, _scalesUtils.getAttributeFunctor)(props, 'x');
	      var yFunctor = (0, _scalesUtils.getAttributeFunctor)(props, 'y');
	      var sizeFunctor = (0, _scalesUtils.getAttributeFunctor)(props, 'size') || function (p) {
	        return _theme.DEFAULT_SIZE;
	      };
	      var fillFunctor = (0, _scalesUtils.getAttributeFunctor)(props, 'fill') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var opacityFunctor = (0, _scalesUtils.getAttributeFunctor)(props, 'opacity');
	
	      return new _deck.ScatterplotLayer({
	        id: seriesId,
	        data: data,
	        getPosition: function getPosition(p) {
	          return [xFunctor(p), yFunctor(p)];
	        },
	        getRadius: function getRadius(p) {
	          return sizeFunctor(p);
	        },
	        getColor: function getColor(p) {
	          var color = (0, _d3Color.rgb)(fillFunctor(p));
	          return [color.r, color.g, color.b, (opacityFunctor(p) || _theme.DEFAULT_OPACITY) * 255];
	        },
	        opacity: 1,
	        outline: outline,
	        projectionMode: _deck.COORDINATE_SYSTEM.IDENTITY,
	        updateTriggers: {
	          getPosition: _renderKey,
	          getColor: colorDomain.concat(colorRange).concat([_renderKey]).join(''),
	          getRadius: sizeDomain.concat(sizeRange).concat([_renderKey]).join('')
	        },
	        // there's a bug that the radius calculated with project_scale
	        radiusMinPixels: 2,
	        pickable: true,
	        onHover: function onHover(row) {
	          return props.onValueMouseOver(row.object);
	        },
	        onClick: function onClick(row) {
	          return props.onValueClick(row.object);
	        }
	      });
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isDeckGL',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return MarkSeriesGL;
	}(_abstractSeries2.default);
	
	MarkSeriesGL.displayName = 'MarkSeriesGL';
	MarkSeriesGL.defaultProps = {
	  onValueMouseOver: function onValueMouseOver() {},
	  onValueClick: function onValueClick() {},
	  outline: false
	};
	
	MarkSeriesGL.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  seriesId: _propTypes2.default.string.isRequired,
	  outline: _propTypes2.default.bool
	});
	
	exports.default = MarkSeriesGL;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _theme = __webpack_require__(45);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--mark';
	var DEFAULT_STROKE_WIDTH = 1;
	
	var MarkSeries = function (_AbstractSeries) {
	  _inherits(MarkSeries, _AbstractSeries);
	
	  function MarkSeries() {
	    _classCallCheck(this, MarkSeries);
	
	    return _possibleConstructorReturn(this, (MarkSeries.__proto__ || Object.getPrototypeOf(MarkSeries)).apply(this, arguments));
	  }
	
	  _createClass(MarkSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          strokeWidth = _props.strokeWidth;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(MarkSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var sizeFunctor = this._getAttributeFunctor('size');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var attrs = {
	            r: sizeFunctor ? sizeFunctor(d) : _theme.DEFAULT_SIZE,
	            cx: xFunctor(d),
	            cy: yFunctor(d),
	            style: {
	              opacity: opacityFunctor ? opacityFunctor(d) : _theme.DEFAULT_OPACITY,
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d),
	              strokeWidth: strokeWidth || DEFAULT_STROKE_WIDTH
	            },
	            key: i,
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(d, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(d, e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(d, e);
	            }
	          };
	          return _react2.default.createElement('circle', attrs);
	        })
	      );
	    }
	  }]);
	
	  return MarkSeries;
	}(_abstractSeries2.default);
	
	MarkSeries.displayName = 'MarkSeries';
	MarkSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  strokeWidth: _propTypes2.default.number
	});
	exports.default = MarkSeries;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Voronoi = __webpack_require__(146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOOP = function NOOP(f) {
	  return f;
	};
	
	function Voronoi(_ref) {
	  var className = _ref.className,
	      extent = _ref.extent,
	      nodes = _ref.nodes,
	      onBlur = _ref.onBlur,
	      _onClick = _ref.onClick,
	      onHover = _ref.onHover,
	      polygonStyle = _ref.polygonStyle,
	      style = _ref.style,
	      x = _ref.x,
	      y = _ref.y;
	
	  // Create a voronoi with each node center points
	  var voronoiInstance = (0, _d3Voronoi.voronoi)().x(x).y(y).extent(extent);
	
	  return _react2.default.createElement(
	    'g',
	    { className: className + ' rv-voronoi', style: style },
	    voronoiInstance.polygons(nodes).map(function (d, i) {
	      return _react2.default.createElement('path', {
	        className: 'rv-voronoi__cell',
	        d: 'M' + d.join('L') + 'Z',
	        onClick: function onClick() {
	          return _onClick(d.data);
	        },
	        onMouseOver: function onMouseOver() {
	          return onHover(d.data);
	        },
	        onMouseOut: function onMouseOut() {
	          return onBlur(d.data);
	        },
	        fill: 'none',
	        style: _extends({
	          pointerEvents: 'all'
	        }, polygonStyle),
	        key: i });
	    })
	  );
	}
	
	Voronoi.requiresSVG = true;
	
	Voronoi.defaultProps = {
	  className: '',
	  onBlur: NOOP,
	  onClick: NOOP,
	  onHover: NOOP,
	  x: function x(d) {
	    return d.x;
	  },
	  y: function y(d) {
	    return d.y;
	  }
	};
	
	Voronoi.propTypes = {
	  className: _propTypes2.default.string,
	  extent: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.number)).isRequired,
	  nodes: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onHover: _propTypes2.default.func,
	  x: _propTypes2.default.func,
	  y: _propTypes2.default.func
	};
	
	exports.default = Voronoi;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDOMNode = exports.isReactDOMSupported = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.warning = warning;
	exports.warnOnce = warnOnce;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$version$split = _react2.default.version.split('.'),
	    _React$version$split2 = _slicedToArray(_React$version$split, 2),
	    major = _React$version$split2[0],
	    minor = _React$version$split2[1];
	
	var versionHigherThanThirteen = Number(minor) > 13 || Number(major) > 13;
	
	var isReactDOMSupported = exports.isReactDOMSupported = function isReactDOMSupported() {
	  return versionHigherThanThirteen;
	};
	
	/**
	 * Support React 0.13 and greater where refs are React components, not DOM
	 * nodes.
	 * @param {*} ref React's ref.
	 * @returns {Element} DOM element.
	 */
	var getDOMNode = exports.getDOMNode = function getDOMNode(ref) {
	  if (!isReactDOMSupported()) {
	    return ref && ref.getDOMNode();
	  }
	  return ref;
	};
	
	var USED_MESSAGES = {};
	var HIDDEN_PROCESSES = {
	  test: true,
	  production: true
	};
	
	/**
	 * Warn the user about something
	 * @param {String} message - the message to be shown
	 * @param {Boolean} onlyShowMessageOnce - whether or not we allow the
	 - message to be show multiple times
	 */
	function warning(message) {
	  var onlyShowMessageOnce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  /* eslint-disable no-undef, no-process-env */
	  if (process && HIDDEN_PROCESSES[("production")]) {
	    return;
	  }
	  /* eslint-enable no-undef, no-process-env */
	  if (!onlyShowMessageOnce || !USED_MESSAGES[message]) {
	    /* eslint-disable no-console */
	    console.warn(message);
	    /* eslint-enable no-console */
	    USED_MESSAGES[message] = true;
	  }
	}
	
	/**
	 * Convience wrapper for warning
	 * @param {String} message - the message to be shown
	 */
	function warnOnce(message) {
	  warning(message, true);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)))

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-hierarchy/ Version 1.1.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	var cluster = function() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	};
	
	function count(node) {
	  var sum = 0,
	      children = node.children,
	      i = children && children.length;
	  if (!i) sum = 1;
	  else while (--i >= 0) sum += children[i].value;
	  node.value = sum;
	}
	
	var node_count = function() {
	  return this.eachAfter(count);
	};
	
	var node_each = function(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	};
	
	var node_eachBefore = function(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	};
	
	var node_eachAfter = function(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	};
	
	var node_sum = function(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	};
	
	var node_sort = function(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	};
	
	var node_path = function(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	};
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	var node_ancestors = function() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	};
	
	var node_descendants = function() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	};
	
	var node_leaves = function() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	};
	
	var node_links = function() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	};
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  count: node_count,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	function Node$2(value) {
	  this._ = value;
	  this.next = null;
	}
	
	var shuffle = function(array) {
	  var i,
	      n = (array = array.slice()).length,
	      head = null,
	      node = head;
	
	  while (n) {
	    var next = new Node$2(array[n - 1]);
	    if (node) node = node.next = next;
	    else node = head = next;
	    array[i] = array[--n];
	  }
	
	  return {
	    head: head,
	    tail: node
	  };
	};
	
	var enclose = function(circles) {
	  return encloseN(shuffle(circles), []);
	};
	
	function encloses(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r - b.r;
	  return dr * dr + 1e-6 > dx * dx + dy * dy;
	}
	
	// Returns the smallest circle that contains circles L and intersects circles B.
	function encloseN(L, B) {
	  var circle,
	      l0 = null,
	      l1 = L.head,
	      l2,
	      p1;
	
	  switch (B.length) {
	    case 1: circle = enclose1(B[0]); break;
	    case 2: circle = enclose2(B[0], B[1]); break;
	    case 3: circle = enclose3(B[0], B[1], B[2]); break;
	  }
	
	  while (l1) {
	    p1 = l1._, l2 = l1.next;
	    if (!circle || !encloses(circle, p1)) {
	
	      // Temporarily truncate L before l1.
	      if (l0) L.tail = l0, l0.next = null;
	      else L.head = L.tail = null;
	
	      B.push(p1);
	      circle = encloseN(L, B); // Note: reorders L!
	      B.pop();
	
	      // Move l1 to the front of L and reconnect the truncated list L.
	      if (L.head) l1.next = L.head, L.head = l1;
	      else l1.next = null, L.head = L.tail = l1;
	      l0 = L.tail, l0.next = l2;
	
	    } else {
	      l0 = l1;
	    }
	    l1 = l2;
	  }
	
	  L.tail = l0;
	  return circle;
	}
	
	function enclose1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function enclose2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function enclose3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = 2 * (x1 - x2),
	      b2 = 2 * (y1 - y2),
	      c2 = 2 * (r2 - r1),
	      d2 = x1 * x1 + y1 * y1 - r1 * r1 - x2 * x2 - y2 * y2 + r2 * r2,
	      a3 = 2 * (x1 - x3),
	      b3 = 2 * (y1 - y3),
	      c3 = 2 * (r3 - r1),
	      d3 = x1 * x1 + y1 * y1 - r1 * r1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / ab - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / ab - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (xa * xb + ya * yb + r1),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
	  return {
	    x: xa + xb * r + x1,
	    y: ya + yb * r + y1,
	    r: r
	  };
	}
	
	function place(a, b, c) {
	  var ax = a.x,
	      ay = a.y,
	      da = b.r + c.r,
	      db = a.r + c.r,
	      dx = b.x - ax,
	      dy = b.y - ay,
	      dc = dx * dx + dy * dy;
	  if (dc) {
	    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
	        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	    c.x = ax + x * dx + y * dy;
	    c.y = ay + x * dy - y * dx;
	  } else {
	    c.x = ax + db;
	    c.y = ay;
	  }
	}
	
	function intersects(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r + b.r;
	  return dr * dr - 1e-6 > dx * dx + dy * dy;
	}
	
	function distance2(node, x, y) {
	  var a = node._,
	      b = node.next._,
	      ab = a.r + b.r,
	      dx = (a.x * b.r + b.x * a.r) / ab - x,
	      dy = (a.y * b.r + b.y * a.r) / ab - y;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the weighted centroid.
	  var aa = a.r * a.r,
	      ba = b.r * b.r,
	      ca = c.r * c.r,
	      oa = aa + ba + ca,
	      ox = aa * a.x + ba * b.x + ca * c.x,
	      oy = aa * a.y + ba * b.y + ca * c.y,
	      cx, cy, i, j, k, sj, sk;
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    // “Closeness” is determined by linear distance along the front-chain.
	    // “Ahead” or “behind” is likewise determined by linear distance.
	    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	    do {
	      if (sj <= sk) {
	        if (intersects(j._, c._)) {
	          b = j, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sj += j._.r, j = j.next;
	      } else {
	        if (intersects(k._, c._)) {
	          a = k, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sk += k._.r, k = k.previous;
	      }
	    } while (j !== k.next);
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Update the weighted centroid.
	    oa += ca = c._.r * c._.r;
	    ox += ca * c._.x;
	    oy += ca * c._.y;
	
	    // Compute the new closest circle pair to the centroid.
	    aa = distance2(a, cx = ox / oa, cy = oy / oa);
	    while ((c = c.next) !== b) {
	      if ((ca = distance2(c, cx, cy)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	var siblings = function(circles) {
	  packEnclose(circles);
	  return circles;
	};
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	var index = function() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
	  };
	
	  return pack;
	};
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	var roundNode = function(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	};
	
	var treemapDice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	};
	
	var partition = function() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	};
	
	var keyPrefix = "$";
	var preroot = {depth: -1};
	var ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	var stratify = function() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	};
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	var tree = function() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	};
	
	var treemapSlice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	};
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = ((function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	}))(phi);
	
	var index$1 = function() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	};
	
	var binary = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((x1 - x0) > (y1 - y0)) {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    } else {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    }
	  }
	};
	
	var sliceDice = function(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	};
	
	var resquarify = ((function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	}))(phi);
	
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(137);
	
	var ReactCurrentOwner = __webpack_require__(87);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 603 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getNiceTickValues = __webpack_require__(1398);
	
	Object.defineProperty(exports, 'getTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, 'getNiceTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, 'getTickValuesFixedDomain', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});

/***/ },
/* 606 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = exports.PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(undefined, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(undefined, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	
	      return fn.apply(undefined, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = exports.curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	var range = exports.range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	var map = exports.map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	
	var compose = exports.compose = function compose() {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var reverse = exports.reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  }
	
	  // can be string
	  return arr.split('').reverse.join('');
	};
	
	var memoize = exports.memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	
	  return function () {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(undefined, args);
	
	    return lastResult;
	  };
	};

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Brush
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(101);
	
	var _DataUtils = __webpack_require__(14);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brush = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Brush, _Component);
	
	  function Brush(props) {
	    _classCallCheck(this, Brush);
	
	    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, 1000);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
	    };
	
	    if (props.data && props.data.length) {
	      _this.updateScale(props);
	    } else {
	      _this.state = {};
	    }
	    return _this;
	  }
	
	  _createClass(Brush, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          x = _props.x,
	          travellerWidth = _props.travellerWidth,
	          updateId = _props.updateId;
	
	
	      if (nextProps.data !== data || nextProps.updateId !== updateId) {
	        this.updateScale(nextProps);
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: 'getIndexInRange',
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.getIndexInRange(this.scaleValues, max);
	
	      return {
	        startIndex: minIndex,
	        endIndex: maxIndex
	      };
	    }
	  }, {
	    key: 'getTextOfTick',
	    value: function getTextOfTick(index) {
	      var _props2 = this.props,
	          data = _props2.data,
	          tickFormatter = _props2.tickFormatter,
	          dataKey = _props2.dataKey;
	
	      var text = (0, _DataUtils.getValueByDataKey)(data[index], dataKey, index);
	
	      return (0, _isFunction3.default)(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: 'handleSlideDrag',
	    value: function handleSlideDrag(e) {
	      var _state = this.state,
	          slideMoveStartX = _state.slideMoveStartX,
	          startX = _state.startX,
	          endX = _state.endX;
	      var _props3 = this.props,
	          x = _props3.x,
	          width = _props3.width,
	          travellerWidth = _props3.travellerWidth,
	          startIndex = _props3.startIndex,
	          endIndex = _props3.endIndex,
	          onChange = _props3.onChange;
	
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerDragStart',
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerMove',
	    value: function handleTravellerMove(e) {
	      var _setState;
	
	      var _state2 = this.state,
	          brushMoveStartX = _state2.brushMoveStartX,
	          movingTravellerId = _state2.movingTravellerId;
	
	      var prevValue = this.state[movingTravellerId];
	      var _props4 = this.props,
	          x = _props4.x,
	          width = _props4.width,
	          travellerWidth = _props4.travellerWidth,
	          onChange = _props4.onChange;
	
	
	      var params = { startX: this.state.startX, endX: this.state.endX };
	      var delta = e.pageX - brushMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	      var newIndex = this.getIndex(params);
	
	      this.setState((_setState = {}, _defineProperty(_setState, movingTravellerId, prevValue + delta), _defineProperty(_setState, 'brushMoveStartX', e.pageX), _setState), function () {
	        if (onChange) {
	          onChange(newIndex);
	        }
	      });
	    }
	  }, {
	    key: 'updateScale',
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	
	
	      if (data && data.length) {
	        var len = data.length;
	        this.scale = (0, _d3Scale.scalePoint)().domain((0, _range3.default)(0, len)).range([x, x + width - travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this3.scale(entry);
	        });
	        this.state = {
	          isTextActive: false,
	          isSlideMoving: false,
	          isTravellerMoving: false,
	          startX: this.scale(startIndex),
	          endX: this.scale(endIndex)
	        };
	      }
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          fill = _props5.fill,
	          stroke = _props5.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: 'renderPanorama',
	    value: function renderPanorama() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          data = _props6.data,
	          children = _props6.children,
	          padding = _props6.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react2.default.cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: 'renderTraveller',
	    value: function renderTraveller(startX, id) {
	      var _props7 = this.props,
	          y = _props7.y,
	          travellerWidth = _props7.travellerWidth,
	          height = _props7.height,
	          stroke = _props7.stroke;
	
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(startX, this.props.x);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: 'recharts-brush-traveller',
	          onMouseEnter: this.handleEnterSlideOrTraveller,
	          onMouseLeave: this.handleLeaveSlideOrTraveller,
	          onMouseDown: this.travellerDragStartHandlers[id],
	          onTouchStart: this.travellerDragStartHandlers[id],
	          style: { cursor: 'col-resize' }
	        },
	        _react2.default.createElement('rect', {
	          x: x,
	          y: y,
	          width: travellerWidth,
	          height: height,
	          fill: stroke,
	          stroke: 'none'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY,
	          x2: x + travellerWidth - 1,
	          y2: lineY,
	          fill: 'none',
	          stroke: '#fff'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY + 2,
	          x2: x + travellerWidth - 1,
	          y2: lineY + 2,
	          fill: 'none',
	          stroke: '#fff'
	        })
	      );
	    }
	  }, {
	    key: 'renderSlide',
	    value: function renderSlide(startX, endX) {
	      var _props8 = this.props,
	          y = _props8.y,
	          height = _props8.height,
	          stroke = _props8.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        className: 'recharts-brush-slide',
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: { cursor: 'move' },
	        stroke: 'none',
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderText',
	    value: function renderText() {
	      var _props9 = this.props,
	          startIndex = _props9.startIndex,
	          endIndex = _props9.endIndex,
	          y = _props9.y,
	          height = _props9.height,
	          travellerWidth = _props9.travellerWidth,
	          stroke = _props9.stroke;
	      var _state3 = this.state,
	          startX = _state3.startX,
	          endX = _state3.endX;
	
	      var offset = 5;
	      var style = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-brush-texts' },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            textAnchor: 'end',
	            verticalAnchor: 'middle',
	            style: style,
	            x: Math.min(startX, endX) - offset,
	            y: y + height / 2
	          },
	          this.getTextOfTick(startIndex)
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            textAnchor: 'start',
	            verticalAnchor: 'middle',
	            style: style,
	            x: Math.max(startX, endX) + travellerWidth + offset,
	            y: y + height / 2
	          },
	          this.getTextOfTick(endIndex)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props10 = this.props,
	          data = _props10.data,
	          className = _props10.className,
	          children = _props10.children;
	      var _state4 = this.state,
	          startX = _state4.startX,
	          endX = _state4.endX,
	          isTextActive = _state4.isTextActive,
	          isSlideMoving = _state4.isSlideMoving,
	          isTravellerMoving = _state4.isTravellerMoving;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-brush', className);
	      var isPanoramic = _react2.default.Children.count(children) === 1;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          onMouseMove: this.handleDrag,
	          onMouseLeave: this.handleLeaveWrapper,
	          onMouseUp: this.handleDragEnd,
	          onTouchEnd: this.handleDragEnd,
	          onTouchMove: this.handleTouchMove
	        },
	        this.renderBackground(),
	        isPanoramic && this.renderPanorama(),
	        this.renderSlide(startX, endX),
	        this.renderTraveller(startX, 'startX'),
	        this.renderTraveller(endX, 'endX'),
	        (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText()
	      );
	    }
	  }]);
	
	  return Brush;
	}(_react.Component), _class2.displayName = 'Brush', _class2.propTypes = {
	  className: _propTypes2.default.string,
	
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  x: _propTypes2.default.number.isRequired,
	  y: _propTypes2.default.number.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  travellerWidth: _propTypes2.default.number,
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  data: _propTypes2.default.array,
	  startIndex: _propTypes2.default.number,
	  endIndex: _propTypes2.default.number,
	  tickFormatter: _propTypes2.default.func,
	
	  children: _propTypes2.default.node,
	
	  onChange: _propTypes2.default.func,
	  updateId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 40,
	  travellerWidth: 5,
	  fill: '#fff',
	  stroke: '#666',
	  padding: { top: 1, right: 1, bottom: 1, left: 1 }
	}, _temp)) || _class;
	
	exports.default = Brush;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of scatters
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Symbols = __webpack_require__(361);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ErrorBar = __webpack_require__(234);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _DataUtils = __webpack_require__(14);
	
	var _AnimationDecorator = __webpack_require__(138);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scatter = (0, _AnimationDecorator2.default)(_class = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Scatter, _Component);
	
	  function Scatter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scatter.__proto__ || Object.getPrototypeOf(Scatter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { activeIndex: -1, isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-'), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Scatter, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var animationDuration = this.props.animationDuration;
	
	      window.setTimeout(function () {
	        return _this2.setState({ isAnimationFinished: true });
	      }, animationDuration);
	    }
	  }, {
	    key: 'renderSymbolItem',
	    value: function renderSymbolItem(option, props) {
	      var symbol = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        symbol = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react2.default.createElement(_Symbols2.default, _extends({}, props, { type: option }));
	      }
	
	      return symbol;
	    }
	  }, {
	    key: 'renderSymbols',
	    value: function renderSymbols() {
	      var _this3 = this;
	
	      var _props = this.props,
	          points = _props.points,
	          shape = _props.shape,
	          activeShape = _props.activeShape,
	          activeIndex = _props.activeIndex,
	          animationBegin = _props.animationBegin,
	          animationDuration = _props.animationDuration,
	          isAnimationActive = _props.isAnimationActive,
	          animationEasing = _props.animationEasing,
	          animationId = _props.animationId;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return points.map(function (entry, i) {
	        var props = _extends({
	          key: 'symbol-' + i
	        }, baseProps, entry);
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-scatter-symbol'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	            key: 'symbol-' + i
	          }),
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              from: { size: 0 },
	              to: { size: props.size },
	              duration: animationDuration,
	              begin: animationBegin,
	              isActive: isAnimationActive,
	              key: animationId,
	              easing: animationEasing
	            },
	            function (_ref2) {
	              var size = _ref2.size;
	
	              var finalProps = _extends({}, props, { size: size });
	
	              return _this3.renderSymbolItem(activeIndex === i ? activeShape : shape, finalProps);
	            }
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (!this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          points = _props2.points,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          children = _props2.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.y,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.x,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	
	
	        return _react2.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: 'renderLine',
	    value: function renderLine() {
	      var _props3 = this.props,
	          points = _props3.points,
	          line = _props3.line,
	          lineType = _props3.lineType,
	          lineJointType = _props3.lineJointType;
	
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints = void 0,
	          lineItem = void 0;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return { x: entry.cx, y: entry.cy };
	        });
	      }
	      var lineProps = _extends({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react2.default.isValidElement(line)) {
	        lineItem = _react2.default.cloneElement(line, lineProps);
	      } else if ((0, _isFunction3.default)(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react2.default.createElement(_Curve2.default, _extends({}, lineProps, { type: lineJointType }));
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-scatter-line', key: 'recharts-scatter-line' },
	        lineItem
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          points = _props4.points,
	          line = _props4.line,
	          className = _props4.className,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          left = _props4.left,
	          top = _props4.top,
	          width = _props4.width,
	          height = _props4.height;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
	        },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        line && this.renderLine(),
	        this.renderErrorBar(),
	        _react2.default.createElement(
	          _Layer2.default,
	          { key: 'recharts-scatter-symbols' },
	          this.renderSymbols()
	        )
	      );
	    }
	  }]);
	
	  return Scatter;
	}(_react.Component), _class2.displayName = 'Scatter', _class2.propTypes = _extends({}, _ReactUtils.EVENT_ATTRIBUTES, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  line: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  lineType: _propTypes2.default.oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  className: _propTypes2.default.string,
	
	  activeIndex: _propTypes2.default.number,
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes2.default.element, _propTypes2.default.func]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    size: _propTypes2.default.number,
	    node: _propTypes2.default.shape({
	      x: _propTypes2.default.number,
	      y: _propTypes2.default.number,
	      z: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	    }),
	    payload: _propTypes2.default.any
	  })),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	}, _temp2)) || _class) || _class;
	
	exports.default = Scatter;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Z Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ZAxis, _Component);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, (ZAxis.__proto__ || Object.getPrototypeOf(ZAxis)).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.Component), _class2.displayName = 'ZAxis', _class2.propTypes = {
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The range of axis
	  range: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func])
	}, _class2.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto'
	}, _temp)) || _class;
	
	exports.default = ZAxis;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AreaChart = undefined;
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /**
	                                   * @fileOverview Area Chart
	                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Dot = __webpack_require__(97);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _CartesianUtils = __webpack_require__(239);
	
	var _DataUtils = __webpack_require__(14);
	
	var _generateCategoricalChart = __webpack_require__(238);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Area = __webpack_require__(352);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _AnimationDecorator = __webpack_require__(138);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _ComposedDataDecorator = __webpack_require__(177);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
	  var axis = _ref.axis,
	      ticks = _ref.ticks,
	      bandSize = _ref.bandSize,
	      entry = _ref.entry,
	      index = _ref.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = (0, _DataUtils.getValueByDataKey)(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) : null;
	};
	
	var getBaseValue = function getBaseValue(props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numberAxis.scale.domain();
	
	  if (numberAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	};
	
	/**
	 * Compose the data of each area
	 * @param {Object} props The props that are passed to the component
	 * @param {Object} xAxis       The configuration of x-axis
	 * @param {Object} yAxis       The configuration of y-axis
	 * @param {String} dataKey     The unique key of a group
	 * @param {Array} stackedData If the area is stacked,
	 * the stackedData is an array of min value and max value
	 * @return {Array} Composed data
	 */
	var getComposedData = function getComposedData(_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xTicks = _ref2.xTicks,
	      yTicks = _ref2.yTicks,
	      bandSize = _ref2.bandSize,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData;
	  var layout = props.layout,
	      dataStartIndex = props.dataStartIndex,
	      dataEndIndex = props.dataEndIndex;
	
	  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	
	  var points = data.map(function (entry, index) {
	    var value = void 0;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: getCategoryAxisCoordinate({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value[1]) ? null : xAxis.scale(value[1]),
	      y: getCategoryAxisCoordinate({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	
	  var baseLine = void 0;
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      return {
	        x: layout === 'horizontal' ? entry.x : xAxis.scale(entry && entry.value[0]),
	        y: layout === 'horizontal' ? yAxis.scale(entry && entry.value[0]) : entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return { points: points, baseLine: baseLine, layout: layout, isRange: isRange };
	};
	
	var AreaChart = exports.AreaChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData }), (0, _AnimationDecorator2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AreaChart, _Component);
	
	  function AreaChart() {
	    _classCallCheck(this, AreaChart);
	
	    return _possibleConstructorReturn(this, (AreaChart.__proto__ || Object.getPrototypeOf(AreaChart)).apply(this, arguments));
	  }
	
	  _createClass(AreaChart, [{
	    key: 'renderCursor',
	    value: function renderCursor(_ref3) {
	      var offset = _ref3.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var start = ticks[activeTooltipIndex].coordinate;
	      var x1 = layout === 'horizontal' ? start : offset.left;
	      var y1 = layout === 'horizontal' ? offset.top : start;
	      var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
	      var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
	      var cursorProps = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Curve2.default, _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
	    }
	  }, {
	    key: 'renderActiveDot',
	    value: function renderActiveDot(option, props, childIndex) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, props);
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: 'scale(0)',
	          to: 'scale(1)',
	          duration: 400,
	          key: 'dot-' + childIndex + '-' + props.pointType,
	          attributeName: 'transform'
	        },
	        _react2.default.createElement(
	          _Layer2.default,
	          { style: { transformOrigin: 'center center' } },
	          dot
	        )
	      );
	    }
	
	    /**
	     * Draw the main part of area chart
	     * @param  {Array} items     React elements of Area
	     * @param  {Object} xAxisMap The configuration of all x-axis
	     * @param  {Object} yAxisMap The configuration of all y-axis
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @param  {Array} allComposedData The array of pre-created composedData
	     *                                 {points, basedLine, layout} for each item
	     * @return {ReactComponent} The instances of Area
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, xAxisMap, yAxisMap, offset, allComposedData) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          layout = _props2.layout,
	          isTooltipActive = _props2.isTooltipActive,
	          activeTooltipIndex = _props2.activeTooltipIndex;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      var hasDot = tooltipItem && isTooltipActive;
	      var dotItems = [];
	      var animationId = this.props.animationId;
	
	
	      var areaItems = items.reduce(function (result, child, i) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            activeDot = _child$props.activeDot;
	
	        var currentComposedData = allComposedData[i];
	        var isRange = currentComposedData.isRange;
	
	        var activePoint = currentComposedData.points && currentComposedData.points[activeTooltipIndex];
	        var basePoint = isRange && currentComposedData.baseLine && currentComposedData.baseLine[activeTooltipIndex];
	
	        if (hasDot && activeDot && activePoint) {
	          var dotProps = _extends({
	            index: activeTooltipIndex,
	            dataKey: dataKey,
	            animationId: animationId,
	            cx: activePoint.x, cy: activePoint.y, r: 4,
	            fill: (0, _CartesianUtils.getMainColorOfGraphicItem)(child),
	            strokeWidth: 2, stroke: '#fff',
	            payload: activePoint.payload,
	            value: activePoint.value,
	            pointType: 'activePoint'
	          }, (0, _ReactUtils.getPresentationAttributes)(activeDot));
	
	          dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));
	
	          if (basePoint) {
	            dotItems.push(_this2.renderActiveDot(activeDot, _extends({}, dotProps, {
	              cx: basePoint.x,
	              cy: basePoint.y,
	              pointType: 'basePoint'
	            }), i));
	          }
	        }
	
	        var area = _react2.default.cloneElement(child, _extends({
	          key: child.key || 'area-' + i
	        }, currentComposedData, offset, {
	          animationId: animationId,
	          layout: layout,
	          xAxis: xAxisMap[child.props.xAxisId],
	          yAxis: yAxisMap[child.props.yAxisId]
	        }));
	
	        return [].concat(_toConsumableArray(result), [area]);
	      }, []);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-chart-group' },
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-area-chart-shapes' },
	          areaItems
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-area-chart-dots' },
	          dotItems
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          isComposed = _props3.isComposed,
	          graphicalItems = _props3.graphicalItems,
	          xAxisMap = _props3.xAxisMap,
	          yAxisMap = _props3.yAxisMap,
	          offset = _props3.offset,
	          allComposedData = _props3.allComposedData;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-graphical' },
	        !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
	        this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset, allComposedData)
	      );
	    }
	  }]);
	
	  return AreaChart;
	}(_react.Component), _class2.displayName = 'AreaChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  axisTicks: _propTypes2.default.array,
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _propTypes2.default.number,
	  dataEndIndex: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  isTooltipActive: _propTypes2.default.bool,
	  activeTooltipIndex: _propTypes2.default.number,
	  xAxisMap: _propTypes2.default.object,
	  yAxisMap: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  graphicalItems: _propTypes2.default.array,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  stackGroups: _propTypes2.default.object,
	  baseValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['dataMin', 'dataMax', 'auto'])]),
	  // used internally
	  isComposed: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number
	}, _class2.defaultProps = {
	  baseValue: 'auto'
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(AreaChart, _Area2.default);

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BarChart = undefined;
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Bar Chart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _generateCategoricalChart = __webpack_require__(238);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Cell = __webpack_require__(176);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _Bar = __webpack_require__(353);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _AnimationDecorator = __webpack_require__(138);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _ComposedDataDecorator = __webpack_require__(177);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
	  var axis = _ref.axis,
	      ticks = _ref.ticks,
	      offset = _ref.offset,
	      bandSize = _ref.bandSize,
	      entry = _ref.entry,
	      index = _ref.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	
	  var value = (0, _DataUtils.getValueByDataKey)(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	var getBaseValue = function getBaseValue(_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis;
	  var layout = props.layout;
	
	  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numberAxis.scale.domain();
	
	  if (numberAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	/**
	 * Compose the data of each group
	 * @param {Object} props Props for the component
	 * @param {Object} item        An instance of Bar
	 * @param {Array} barPosition The offset and size of each bar
	 * @param {Object} xAxis       The configuration of x-axis
	 * @param {Object} yAxis       The configuration of y-axis
	 * @param {Array} stackedData  The stacked data of a bar item
	 * @return{Array} Composed data
	 */
	var getComposedData = function getComposedData(_ref3) {
	  var props = _ref3.props,
	      item = _ref3.item,
	      barPosition = _ref3.barPosition,
	      bandSize = _ref3.bandSize,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xTicks = _ref3.xTicks,
	      yTicks = _ref3.yTicks,
	      stackedData = _ref3.stackedData;
	  var layout = props.layout,
	      dataStartIndex = props.dataStartIndex,
	      dataEndIndex = props.dataEndIndex;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	
	  var pos = (0, _DataUtils.findPositionOfBar)(barPosition, item);
	  var stackedDomain = stackedData && layout === 'horizontal' ? yAxis.scale.domain() : xAxis.scale.domain();
	
	  if (!pos) {
	    return [];
	  }
	
	  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
	  var baseValue = getBaseValue({ props: props, xAxis: xAxis, yAxis: yAxis });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  return data.map(function (entry, index) {
	    var value = void 0,
	        x = void 0,
	        y = void 0,
	        width = void 0,
	        height = void 0;
	
	    if (stackedData) {
	      value = (0, _DataUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = getCategoryAxisCoordinate({
	        axis: xAxis,
	        ticks: xTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = getCategoryAxisCoordinate({
	        axis: yAxis,
	        ticks: yTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	        width += _delta;
	      }
	    }
	
	    return _extends({}, entry, {
	      x: x, y: y, width: width, height: height, value: stackedData ? value : value[1],
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	};
	
	var BarChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData }), (0, _AnimationDecorator2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(BarChart, _Component);
	
	  function BarChart() {
	    _classCallCheck(this, BarChart);
	
	    return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).apply(this, arguments));
	  }
	
	  _createClass(BarChart, [{
	    key: 'renderCursor',
	    value: function renderCursor(_ref4) {
	      var xAxisMap = _ref4.xAxisMap,
	          yAxisMap = _ref4.yAxisMap,
	          offset = _ref4.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
	      var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var bandSize = (0, _DataUtils.getBandSizeOfAxis)(axis);
	      var start = ticks[activeTooltipIndex].coordinate;
	      var cursorProps = _extends({
	        fill: '#f1f1f1'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        x: layout === 'horizontal' ? start : offset.left + 0.5,
	        y: layout === 'horizontal' ? offset.top + 0.5 : start,
	        width: layout === 'horizontal' ? bandSize : offset.width - 1,
	        height: layout === 'horizontal' ? offset.height - 1 : bandSize
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Rectangle2.default, _extends({}, cursorProps, { className: 'recharts-bar-cursor' }));
	    }
	
	    /**
	     * Draw the main part of bar chart
	     * @param  {Array} items     All the instance of Bar
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @return {ReactComponent}  All the instances of Bar
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, offset) {
	      if (!items || !items.length) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          layout = _props2.layout,
	          xAxisMap = _props2.xAxisMap,
	          yAxisMap = _props2.yAxisMap;
	      var _props3 = this.props,
	          animationId = _props3.animationId,
	          allComposedData = _props3.allComposedData;
	
	
	      return items.map(function (child, i) {
	        return _react2.default.cloneElement(child, _extends({
	          key: child.key || 'bar-' + i,
	          layout: layout,
	          animationId: animationId
	        }, offset, {
	          data: allComposedData[i],
	          xAxis: xAxisMap[child.props.xAxisId],
	          yAxis: yAxisMap[child.props.yAxisId]
	        }));
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          isComposed = _props4.isComposed,
	          graphicalItems = _props4.graphicalItems,
	          xAxisMap = _props4.xAxisMap,
	          yAxisMap = _props4.yAxisMap,
	          offset = _props4.offset;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-bar-graphical' },
	        !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
	        this.renderItems(graphicalItems, offset)
	      );
	    }
	  }]);
	
	  return BarChart;
	}(_react.Component), _class2.displayName = 'BarChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  axisTicks: _propTypes2.default.array,
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _propTypes2.default.number,
	  dataEndIndex: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  isTooltipActive: _propTypes2.default.bool,
	  activeTooltipIndex: _propTypes2.default.number,
	  xAxisMap: _propTypes2.default.object,
	  yAxisMap: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  graphicalItems: _propTypes2.default.array,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  stackGroups: _propTypes2.default.object,
	  barCategoryGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  barGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  barSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  maxBarSize: _propTypes2.default.number,
	  // used internally
	  isComposed: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number
	}, _class2.defaultProps = {
	  barCategoryGap: '10%',
	  barGap: 4
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(BarChart, _Bar2.default);
	exports.BarChart = BarChart;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LineChart = undefined;
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /**
	                                   * @fileOverview Line Chart
	                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(97);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _generateCategoricalChart = __webpack_require__(238);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Line = __webpack_require__(356);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _AnimationDecorator = __webpack_require__(138);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _ComposedDataDecorator = __webpack_require__(177);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
	  var axis = _ref.axis,
	      ticks = _ref.ticks,
	      bandSize = _ref.bandSize,
	      entry = _ref.entry,
	      index = _ref.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = (0, _DataUtils.getValueByDataKey)(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) : null;
	};
	/**
	 * Compose the data of each group
	 * @param {Object} props The props from the component
	 * @param  {Object} xAxis   The configuration of x-axis
	 * @param  {Object} yAxis   The configuration of y-axis
	 * @param  {String} dataKey The unique key of a group
	 * @return {Array}  Composed data
	 */
	var getComposedData = function getComposedData(_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xTicks = _ref2.xTicks,
	      yTicks = _ref2.yTicks,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize;
	  var layout = props.layout,
	      dataStartIndex = props.dataStartIndex,
	      dataEndIndex = props.dataEndIndex;
	
	  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
	
	  return data.map(function (entry, index) {
	    var value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: getCategoryAxisCoordinate({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value) ? null : xAxis.scale(value),
	      y: getCategoryAxisCoordinate({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	};
	
	var LineChart = exports.LineChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData }), (0, _AnimationDecorator2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(LineChart, _Component);
	
	  function LineChart() {
	    _classCallCheck(this, LineChart);
	
	    return _possibleConstructorReturn(this, (LineChart.__proto__ || Object.getPrototypeOf(LineChart)).apply(this, arguments));
	  }
	
	  _createClass(LineChart, [{
	    key: 'renderCursor',
	    value: function renderCursor(_ref3) {
	      var offset = _ref3.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var start = ticks[activeTooltipIndex].coordinate;
	      var x1 = layout === 'horizontal' ? start : offset.left;
	      var y1 = layout === 'horizontal' ? offset.top : start;
	      var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
	      var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
	      var cursorProps = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Curve2.default, _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
	    }
	  }, {
	    key: 'renderActiveDot',
	    value: function renderActiveDot(option, props, childIndex) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        var className = (0, _classnames2.default)('recharts-line-active-dot', option.className);
	        dot = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: className }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: 'scale(0)',
	          to: 'scale(1)',
	          duration: 400,
	          key: 'dot-' + childIndex,
	          attributeName: 'transform'
	        },
	        _react2.default.createElement(
	          _Layer2.default,
	          { style: { transformOrigin: 'center center' } },
	          dot
	        )
	      );
	    }
	    /**
	     * Draw the main part of line chart
	     * @param  {Array} items     All the instance of Line
	     * @param  {Object} xAxisMap The configuration of all x-axes
	     * @param  {Object} yAxisMap The configuration of all y-axes
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @return {ReactComponent}  All the instances of Line
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, xAxisMap, yAxisMap, offset) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          layout = _props2.layout,
	          isTooltipActive = _props2.isTooltipActive,
	          activeTooltipIndex = _props2.activeTooltipIndex,
	          animationId = _props2.animationId,
	          allComposedData = _props2.allComposedData;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      var hasDot = tooltipItem && isTooltipActive;
	      var dotItems = [];
	
	      var lineItems = items.map(function (child, i) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            stroke = _child$props.stroke,
	            activeDot = _child$props.activeDot;
	
	        var points = allComposedData[i];
	        var activePoint = points[activeTooltipIndex];
	
	        if (hasDot && activeDot && activePoint) {
	          var dotProps = _extends({
	            index: activeTooltipIndex,
	            dataKey: dataKey,
	            cx: activePoint.x, cy: activePoint.y, r: 4,
	            fill: stroke, strokeWidth: 2, stroke: '#fff',
	            payload: activePoint.payload,
	            value: activePoint.value
	          }, (0, _ReactUtils.getPresentationAttributes)(activeDot));
	          dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));
	        }
	
	        return _react2.default.cloneElement(child, _extends({
	          key: child.key || 'line-' + i
	        }, offset, {
	          layout: layout,
	          points: points,
	          animationId: animationId,
	          xAxis: xAxisMap[child.props.xAxisId],
	          yAxis: yAxisMap[child.props.yAxisId]
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-chart-wrapper' },
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-line-chart' },
	          lineItems
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-line-chart-dot' },
	          dotItems
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          isComposed = _props3.isComposed,
	          xAxisMap = _props3.xAxisMap,
	          yAxisMap = _props3.yAxisMap,
	          offset = _props3.offset,
	          graphicalItems = _props3.graphicalItems;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-graphical' },
	        !isComposed && this.renderCursor({ offset: offset }),
	        this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset)
	      );
	    }
	  }]);
	
	  return LineChart;
	}(_react.Component), _class2.displayName = 'LineChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  axisTicks: _propTypes2.default.array,
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _propTypes2.default.number,
	  dataEndIndex: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  isTooltipActive: _propTypes2.default.bool,
	  activeTooltipIndex: _propTypes2.default.number,
	  xAxisMap: _propTypes2.default.object,
	  yAxisMap: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  graphicalItems: _propTypes2.default.array,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  // used internally
	  isComposed: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(LineChart, _Line2.default);

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPlainObject2 = __webpack_require__(103);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render sectors of a pie
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Sector = __webpack_require__(360);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _PolarUtils = __webpack_require__(89);
	
	var _AnimationDecorator = __webpack_require__(138);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pie = (0, _AnimationDecorator2.default)(_class = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Pie, _Component);
	
	  function Pie() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pie.__proto__ || Object.getPrototypeOf(Pie)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-pie-'), _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Pie, [{
	    key: 'getDeltaAngle',
	    value: function getDeltaAngle() {
	      var _props = this.props,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle;
	
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	      return sign * deltaAngle;
	    }
	  }, {
	    key: 'getSectors',
	    value: function getSectors(data) {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          innerRadius = _props2.innerRadius,
	          outerRadius = _props2.outerRadius,
	          cornerRadius = _props2.cornerRadius,
	          startAngle = _props2.startAngle,
	          paddingAngle = _props2.paddingAngle,
	          minAngle = _props2.minAngle,
	          nameKey = _props2.nameKey,
	          valueKey = _props2.valueKey;
	
	      var len = data.length;
	      var deltaAngle = this.getDeltaAngle();
	      var absDeltaAngle = Math.abs(deltaAngle);
	      var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	      var sum = data.reduce(function (result, entry) {
	        return result + (0, _DataUtils.getValueByDataKey)(entry, valueKey, 0);
	      }, 0);
	
	      var sectors = [];
	      var prev = void 0;
	
	      if (sum > 0) {
	        sectors = data.map(function (entry, i) {
	          var percent = (0, _DataUtils.getValueByDataKey)(entry, valueKey, 0) / sum;
	
	          var tempStartAngle = void 0;
	
	          if (i) {
	            tempStartAngle = (deltaAngle < 0 ? prev.endAngle : prev.startAngle) + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	          } else {
	            tempStartAngle = startAngle;
	          }
	
	          var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * (absDeltaAngle - len * minAngle - totalPadingAngle));
	
	          prev = _extends({
	            percent: percent,
	            cornerRadius: cornerRadius
	          }, entry, {
	            cx: cx,
	            cy: cy,
	            innerRadius: innerRadius,
	            outerRadius: outerRadius,
	            name: (0, _DataUtils.getValueByDataKey)(entry, nameKey),
	            value: (0, _DataUtils.getValueByDataKey)(entry, valueKey),
	            startAngle: deltaAngle < 0 ? tempStartAngle : tempEndAngle,
	            endAngle: deltaAngle < 0 ? tempEndAngle : tempStartAngle,
	            midAngle: (tempStartAngle + tempEndAngle) / 2
	          });
	
	          return prev;
	        });
	      }
	
	      return sectors;
	    }
	  }, {
	    key: 'getTextAnchor',
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      } else if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: 'isActiveIndex',
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: 'renderClipPath',
	    value: function renderClipPath() {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy,
	          maxRadius = _props3.maxRadius,
	          startAngle = _props3.startAngle,
	          isAnimationActive = _props3.isAnimationActive,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          animationBegin = _props3.animationBegin,
	          animationId = _props3.animationId;
	
	
	      return _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'clipPath',
	          { id: this.id },
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration,
	              key: animationId,
	              animationBegin: animationBegin,
	              onAnimationEnd: this.handleAnimationEnd,
	              from: {
	                endAngle: startAngle
	              },
	              to: {
	                outerRadius: Math.max(this.props.outerRadius, maxRadius || 0),
	                innerRadius: 0,
	                endAngle: this.props.endAngle
	              }
	            },
	            function (_ref2) {
	              var outerRadius = _ref2.outerRadius,
	                  innerRadius = _ref2.innerRadius,
	                  endAngle = _ref2.endAngle;
	              return _react2.default.createElement(_Sector2.default, {
	                cx: cx,
	                cy: cy,
	                outerRadius: outerRadius,
	                innerRadius: innerRadius,
	                startAngle: startAngle,
	                endAngle: endAngle
	              });
	            }
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderLabelLineItem',
	    value: function renderLabelLineItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Curve2.default, _extends({}, props, { type: 'linear', className: 'recharts-pie-label-line' }));
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      }
	      var label = value;
	      if ((0, _isFunction3.default)(option)) {
	        label = option(props);
	        if (_react2.default.isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react2.default.createElement(
	        _Text2.default,
	        _extends({}, props, {
	          alignmentBaseline: 'middle',
	          className: 'recharts-pie-label-text'
	        }),
	        label
	      );
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props4 = this.props,
	          label = _props4.label,
	          labelLine = _props4.labelLine,
	          valueKey = _props4.valueKey;
	
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	        var labelProps = _extends({}, pieProps, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	        var lineProps = _extends({}, pieProps, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          { key: 'label-' + i },
	          labelLine && _this2.renderLabelLineItem(labelLine, lineProps),
	          _this2.renderLabelItem(label, labelProps, (0, _DataUtils.getValueByDataKey)(entry, valueKey))
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-pie-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderSectorItem',
	    value: function renderSectorItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      } else if ((0, _isPlainObject3.default)(option)) {
	        return _react2.default.createElement(_Sector2.default, _extends({}, props, option));
	      }
	
	      return _react2.default.createElement(_Sector2.default, props);
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors(sectors) {
	      var _this3 = this;
	
	      var activeShape = this.props.activeShape;
	
	
	      return sectors.map(function (entry, i) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-pie-sector'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	            key: 'sector-' + i
	          }),
	          _this3.renderSectorItem(_this3.isActiveIndex(i) ? activeShape : null, entry)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          data = _props5.data,
	          composedData = _props5.composedData,
	          className = _props5.className,
	          label = _props5.label,
	          cx = _props5.cx,
	          cy = _props5.cy,
	          innerRadius = _props5.innerRadius,
	          outerRadius = _props5.outerRadius;
	
	      var pieData = composedData || data;
	
	      if (!pieData || !pieData.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var sectors = this.getSectors(pieData);
	      var layerClass = (0, _classnames2.default)('recharts-pie', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        this.renderClipPath(),
	        _react2.default.createElement(
	          'g',
	          { clipPath: 'url(#' + this.id + ')' },
	          this.renderSectors(sectors)
	        ),
	        label && this.renderLabels(sectors)
	      );
	    }
	  }]);
	
	  return Pie;
	}(_react.Component), _class2.displayName = 'Pie', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  animationId: _propTypes2.default.number,
	  cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  paddingAngle: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  valueKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  composedData: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  minAngle: _propTypes2.default.number,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  maxRadius: _propTypes2.default.number,
	
	  labelLine: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.shape({
	    offsetRadius: _propTypes2.default.number
	  }), _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
	}), _class2.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  nameKey: 'name',
	  valueKey: 'value',
	  labelLine: true,
	  data: [],
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class) || _class;
	
	exports.default = Pie;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Axis of radial direction
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _Dot = __webpack_require__(97);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Polygon = __webpack_require__(359);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PolarUtils = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarAngleAxis, _Component);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, (PolarAngleAxis.__proto__ || Object.getPrototypeOf(PolarAngleAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: 'getTickLineCoord',
	
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          radius = _props.radius,
	          orientation = _props.orientation,
	          tickLine = _props.tickLine;
	
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.angle);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.angle);
	
	      return { x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	
	      var cos = Math.cos(-data.angle * RADIAN);
	      var textAnchor = void 0;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          radius = _props2.radius,
	          axisLine = _props2.axisLine,
	          axisLineType = _props2.axisLineType;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react2.default.createElement(_Dot2.default, _extends({
	          className: 'recharts-polar-angle-axis-line'
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	      var ticks = this.props.ticks;
	
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.angle);
	      });
	
	      return _react2.default.createElement(_Polygon2.default, _extends({ className: 'recharts-polar-angle-axis-line' }, props, { points: points }));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-angle-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          ticks = _props3.ticks,
	          tick = _props3.tick,
	          tickLine = _props3.tickLine,
	          tickFormatter = _props3.tickFormatter,
	          stroke = _props3.stroke;
	
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this2.getTickLineCoord(entry);
	        var textAnchor = _this2.getTickTextAnchor(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i, payload: entry,
	          x: lineCoord.x2, y: lineCoord.y2
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-angle-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-polar-angle-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          radius = _props4.radius,
	          axisLine = _props4.axisLine;
	
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis' },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks()
	      );
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.Component), _class2.displayName = 'PolarAngleAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  hide: _propTypes2.default.bool,
	
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  axisLineType: _propTypes2.default.oneOf(['polygon', 'circle']),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    angle: _propTypes2.default.number
	  })),
	  stroke: _propTypes2.default.string,
	  orientation: _propTypes2.default.oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes2.default.func
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false
	}, _temp)) || _class;
	
	exports.default = PolarAngleAxis;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polar Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _PolarUtils = __webpack_require__(89);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarGrid, _Component);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, (PolarGrid.__proto__ || Object.getPrototypeOf(PolarGrid)).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: 'getPolygonPath',
	    value: function getPolygonPath(radius) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          polarAngles = _props.polarAngles;
	
	
	      var path = '';
	
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += 'L ' + point.x + ',' + point.y;
	        } else {
	          path += 'M ' + point.x + ',' + point.y;
	        }
	      });
	      path += 'Z';
	
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: 'renderPolarAngles',
	    value: function renderPolarAngles() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          innerRadius = _props2.innerRadius,
	          outerRadius = _props2.outerRadius,
	          polarAngles = _props2.polarAngles;
	
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-angle' },
	        polarAngles.map(function (entry, i) {
	          var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	          var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	
	          return _react2.default.createElement('line', _extends({}, props, {
	            key: 'line-' + i,
	            x1: start.x,
	            y1: start.y,
	            x2: end.x,
	            y2: end.y
	          }));
	        })
	      );
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: 'renderConcentricCircle',
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy;
	
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('circle', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-circle',
	        key: 'circle-' + index,
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: 'renderConcentricPolygon',
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('path', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-polygon',
	        key: 'path-' + index,
	        d: this.getPolygonPath(radius)
	      }));
	    }
	
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: 'renderConcentricPath',
	    value: function renderConcentricPath() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          polarRadius = _props4.polarRadius,
	          gridType = _props4.gridType;
	
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-concentric' },
	        polarRadius.map(function (entry, i) {
	          return gridType === 'circle' ? _this2.renderConcentricCircle(entry, i) : _this2.renderConcentricPolygon(entry, i);
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid' },
	        this.renderPolarAngles(),
	        this.renderConcentricPath()
	      );
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.Component), _class2.displayName = 'PolarGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	
	  polarAngles: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  polarRadius: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  gridType: _propTypes2.default.oneOf(['polygon', 'circle'])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	}, _temp)) || _class;
	
	exports.default = PolarGrid;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maxBy2 = __webpack_require__(208);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview The axis of polar coordinate system
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _PolarUtils = __webpack_require__(89);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarRadiusAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarRadiusAxis, _Component);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, (PolarRadiusAxis.__proto__ || Object.getPrototypeOf(PolarRadiusAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: 'getTickValueCoord',
	
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Object} radius The data of a simple tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var radius = _ref.radius;
	      var _props = this.props,
	          angle = _props.angle,
	          cx = _props.cx,
	          cy = _props.cy;
	
	
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	        case 'right':
	          textAnchor = 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          angle = _props2.angle,
	          ticks = _props2.ticks,
	          axisLine = _props2.axisLine,
	          others = _objectWithoutProperties(_props2, ['cx', 'cy', 'angle', 'ticks', 'axisLine']);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.radius), Math.max(result[1], entry.radius)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-polar-radius-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-radius-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          ticks = _props3.ticks,
	          tick = _props3.tick,
	          angle = _props3.angle,
	          tickFormatter = _props3.tickFormatter,
	          stroke = _props3.stroke,
	          others = _objectWithoutProperties(_props3, ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke']);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var items = ticks.map(function (entry, i) {
	        var coord = _this2.getTickValueCoord(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-radius-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var label = this.props.label;
	
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          angle = _props4.angle,
	          stroke = _props4.stroke,
	          others = _objectWithoutProperties(_props4, ['ticks', 'angle', 'stroke']);
	
	      var maxRadiusTick = (0, _maxBy3.default)(ticks, function (entry) {
	        return entry.radius || 0;
	      });
	      var radius = maxRadiusTick.radius || 0;
	      var coord = this.getTickValueCoord({ radius: radius + 10 });
	      var props = _extends({}, others, {
	        stroke: 'none',
	        fill: stroke
	      }, coord, {
	        textAnchor: 'middle',
	        transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
	      });
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-polar-radius-axis-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          ticks = _props5.ticks,
	          axisLine = _props5.axisLine,
	          tick = _props5.tick;
	
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis' },
	        axisLine && this.renderAxisLine(),
	        tick && this.renderTicks(),
	        this.renderLabel()
	      );
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.Component), _class2.displayName = 'PolarRadiusAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  hide: _propTypes2.default.bool,
	
	  angle: _propTypes2.default.number,
	  tickCount: _propTypes2.default.number,
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    radius: _propTypes2.default.value
	  })),
	  orientation: _propTypes2.default.oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  allowDataOverflow: _propTypes2.default.bool
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto'
	}, _temp)) || _class;
	
	exports.default = PolarRadiusAxis;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _Polygon = __webpack_require__(359);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Dot = __webpack_require__(97);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(62);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Radar, _Component);
	
	  function Radar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radar.__proto__ || Object.getPrototypeOf(Radar)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    }, _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Radar, [{
	    key: 'renderPolygon',
	    value: function renderPolygon() {
	      /* eslint-disable no-unused-vars */
	      var _props = this.props,
	          shape = _props.shape,
	          points = _props.points,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing,
	          animationBegin = _props.animationBegin,
	          isAnimationActive = _props.isAnimationActive,
	          animationId = _props.animationId,
	          dataKey = _props.dataKey,
	          className = _props.className,
	          others = _objectWithoutProperties(_props, ['shape', 'points', 'animationDuration', 'animationEasing', 'animationBegin', 'isAnimationActive', 'animationId', 'dataKey', 'className']);
	      /* eslint-enable no-unused-vars */
	
	      if (_react2.default.isValidElement(shape)) {
	        return _react2.default.cloneElement(shape, _extends({}, others, { points: points }));
	      } else if ((0, _isFunction3.default)(shape)) {
	        return shape(this.props);
	      }
	
	      var point = points[0];
	      var transformPoints = points.map(function (p) {
	        return { x: p.x - point.cx, y: p.y - point.cy };
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-polygon', transform: 'translate(' + point.cx + ', ' + point.cy + ')' },
	        _react2.default.createElement(
	          _reactSmooth2.default,
	          {
	            from: 'scale(0)',
	            to: 'scale(1)',
	            attributeName: 'transform',
	            isActive: isAnimationActive,
	            begin: animationBegin,
	            easing: animationEasing,
	            duration: animationDuration,
	            key: animationId
	          },
	          _react2.default.createElement(_Polygon2.default, _extends({
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave
	          }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	            points: transformPoints
	          }))
	        )
	      );
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            key: props.key
	          }, props, {
	            className: 'recharts-radar-label'
	          }),
	          value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          points = _props2.points,
	          label = _props2.label;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = points.map(function (entry, i) {
	        var labelProps = _extends({
	          textAnchor: 'middle'
	        }, baseProps, {
	          stroke: 'none',
	          fill: baseProps && baseProps.stroke || '#666'
	        }, customLabelProps, entry, {
	          index: i,
	          key: 'label-' + i,
	          payload: entry
	        });
	
	        return _this2.renderLabelItem(label, labelProps, entry.value);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-radar-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          dot = _props3.dot,
	          points = _props3.points;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, baseProps, customDotProps, {
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          playload: entry
	        });
	
	        return _this3.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          points = _props4.points,
	          label = _props4.label,
	          dot = _props4.dot;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-radar', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        this.renderPolygon(),
	        label && this.renderLabels(),
	        dot && this.renderDots()
	      );
	    }
	  }]);
	
	  return Radar;
	}(_react.Component), _class2.displayName = 'Radar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    angle: _propTypes2.default.number,
	    radius: _propTypes2.default.number,
	    value: _propTypes2.default.number,
	    payload: _propTypes2.default.object
	  })),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.bool]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  dot: false,
	  label: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = Radar;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of radial bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Sector = __webpack_require__(360);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _DOMUtils = __webpack_require__(178);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _PolarUtils = __webpack_require__(89);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIAN = Math.PI / 180;
	
	var RadialBar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadialBar, _Component);
	
	  function RadialBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBar.__proto__ || Object.getPrototypeOf(RadialBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: false
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadialBar, [{
	    key: 'getDeltaAngle',
	    value: function getDeltaAngle() {
	      var _props = this.props,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle;
	
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	      return sign * deltaAngle;
	    }
	  }, {
	    key: 'getSectors',
	    value: function getSectors() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          startAngle = _props2.startAngle,
	          data = _props2.data,
	          minAngle = _props2.minAngle,
	          maxAngle = _props2.maxAngle;
	
	      var maxValue = Math.max.apply(null, data.map(function (entry) {
	        return Math.abs(entry.value);
	      }));
	      var absMinAngle = Math.abs(minAngle);
	      var absMaxAngle = Math.abs(maxAngle);
	      var deltaAngle = this.getDeltaAngle();
	      var gapAngle = Math.min(Math.abs(absMaxAngle - absMinAngle), 360);
	
	      var sectors = data.map(function (entry) {
	        var value = entry.value;
	        var tempEndAngle = maxValue === 0 ? startAngle : startAngle + (0, _DataUtils.mathSign)(value * deltaAngle) * (absMinAngle + gapAngle * Math.abs(entry.value) / maxValue);
	
	        return _extends({}, entry, {
	          cx: cx, cy: cy,
	          startAngle: startAngle,
	          endAngle: tempEndAngle,
	          payload: entry
	        });
	      });
	
	      return sectors;
	    }
	  }, {
	    key: 'getLabelPathArc',
	    value: function getLabelPathArc(data, labelContent, style) {
	      var label = this.props.label;
	
	      var labelProps = _react2.default.isValidElement(label) ? label.props : label;
	      var offsetRadius = labelProps.offsetRadius || 2;
	      var orientation = labelProps.orientation || 'inner';
	      var cx = data.cx,
	          cy = data.cy,
	          innerRadius = data.innerRadius,
	          outerRadius = data.outerRadius,
	          startAngle = data.startAngle,
	          endAngle = data.endAngle;
	
	      var clockWise = this.getDeltaAngle() < 0 && data.value > 0;
	      var radius = clockWise ? innerRadius + offsetRadius : Math.max(outerRadius - offsetRadius, 0);
	
	      if (radius <= 0) {
	        return '';
	      }
	
	      var labelSize = (0, _DOMUtils.getStringSize)(labelContent, style);
	      var deltaAngle = labelSize.width / (radius * RADIAN);
	      var tempStartAngle = void 0,
	          tempEndAngle = void 0;
	
	      if (clockWise) {
	        tempStartAngle = orientation === 'inner' ? Math.min(endAngle + deltaAngle, startAngle) : endAngle;
	        tempEndAngle = tempStartAngle - deltaAngle;
	      } else {
	        tempStartAngle = orientation === 'inner' ? Math.max(endAngle - deltaAngle, startAngle) : endAngle;
	        tempEndAngle = tempStartAngle + deltaAngle;
	      }
	
	      var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, tempStartAngle);
	      var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, tempEndAngle);
	
	      return 'M' + startPoint.x + ',' + startPoint.y + '\n            A' + radius + ',' + radius + ',0,\n            ' + (deltaAngle >= 180 ? 1 : 0) + ',\n            ' + (clockWise ? 1 : 0) + ',\n            ' + endPoint.x + ',' + endPoint.y;
	    }
	  }, {
	    key: 'renderSectorShape',
	    value: function renderSectorShape(shape, props) {
	      var sectorShape = void 0;
	
	      if (_react2.default.isValidElement(shape)) {
	        sectorShape = _react2.default.cloneElement(shape, props);
	      } else if ((0, _isFunction3.default)(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react2.default.createElement(_Sector2.default, props);
	      }
	
	      return sectorShape;
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors(sectors) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          shape = _props3.shape,
	          activeShape = _props3.activeShape,
	          activeIndex = _props3.activeIndex,
	          cornerRadius = _props3.cornerRadius;
	      var _props4 = this.props,
	          animationEasing = _props4.animationEasing,
	          animationDuration = _props4.animationDuration,
	          animationBegin = _props4.animationBegin,
	          isAnimationActive = _props4.isAnimationActive;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return sectors.map(function (entry, i) {
	        var startAngle = entry.startAngle,
	            endAngle = entry.endAngle;
	
	
	        return _react2.default.createElement(
	          _reactSmooth2.default,
	          {
	            from: { angle: startAngle },
	            to: { angle: endAngle },
	            begin: animationBegin,
	            isActive: isAnimationActive,
	            duration: animationDuration,
	            easing: animationEasing,
	            shouldReAnimate: true,
	            key: 'aniamte-' + i,
	            onAnimationStart: _this2.handleAnimationStart,
	            onAnimationEnd: _this2.handleAnimationEnd
	          },
	          function (_ref2) {
	            var angle = _ref2.angle;
	
	            var props = _extends({}, baseProps, {
	              cornerRadius: cornerRadius
	            }, entry, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	              endAngle: angle,
	              key: 'sector-' + i,
	              className: 'recharts-radial-bar-sector'
	            });
	
	            return _this2.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	          }
	        );
	      });
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground(sectors) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          startAngle = _props5.startAngle,
	          endAngle = _props5.endAngle,
	          background = _props5.background,
	          cornerRadius = _props5.cornerRadius;
	
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(background);
	
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            rest = _objectWithoutProperties(entry, ['value']);
	
	        var props = _extends({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	          startAngle: startAngle,
	          endAngle: endAngle,
	          index: i,
	          key: 'sector-' + i,
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this3.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        var id = (0, _DataUtils.uniqueId)('recharts-defs-');
	        var filteredProps = (0, _ReactUtils.getPresentationAttributes)(props);
	        var path = this.getLabelPathArc(props, value, filteredProps);
	
	        labelItem = _react2.default.createElement(
	          'text',
	          _extends({}, filteredProps, { key: props.key, className: 'recharts-radial-bar-label' }),
	          _react2.default.createElement(
	            'defs',
	            null,
	            _react2.default.createElement('path', { id: id, d: path })
	          ),
	          _react2.default.createElement(
	            'textPath',
	            { xlinkHref: '#' + id },
	            value
	          )
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(sectors) {
	      var _this4 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var label = this.props.label;
	
	
	      return sectors.map(function (entry, i) {
	        var props = _extends({
	          fontSize: 10
	        }, entry, (0, _ReactUtils.getPresentationAttributes)(label), {
	          index: i,
	          key: 'label-' + i
	        });
	
	        return _this4.renderLabelItem(label, props, entry.value);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          data = _props6.data,
	          className = _props6.className,
	          background = _props6.background,
	          label = _props6.label;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var sectors = this.getSectors();
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        background && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-background' },
	          this.renderBackground(sectors)
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-sectors' },
	          this.renderSectors(sectors)
	        ),
	        label && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-labels' },
	          this.renderLabels(sectors)
	        )
	      );
	    }
	  }]);
	
	  return RadialBar;
	}(_react.Component), _class2.displayName = 'RadialBar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.number,
	
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  maxAngle: _propTypes2.default.number,
	  minAngle: _propTypes2.default.number,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    innerRadius: _propTypes2.default.number,
	    outerRadius: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object]),
	  background: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	}), _class2.defaultProps = {
	  startAngle: 180,
	  endAngle: 0,
	  maxAngle: 135,
	  minAngle: 0,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = RadialBar;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cross
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cross = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Cross, _Component);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, (Cross.__proto__ || Object.getPrototypeOf(Cross)).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: 'getPath',
	    value: function getPath(x, y, width, height, top, left) {
	      return 'M' + x + ',' + top + 'v' + height + 'M' + left + ',' + y + 'h' + width;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          top = _props.top,
	          left = _props.left,
	          className = _props.className;
	
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-cross', className),
	        d: this.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }]);
	
	  return Cross;
	}(_react.Component), _class2.displayName = 'Cross', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  className: _propTypes2.default.string
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	}, _temp)) || _class;
	
	exports.default = Cross;

/***/ },
/* 620 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(90);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(91);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(119);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ },
/* 622 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	  return result;
	};
	
	exports.default = mapValues;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _wrapDisplayName = __webpack_require__(91);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _setDisplayName = __webpack_require__(90);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _mapProps = __webpack_require__(1416);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withProps = function withProps(input) {
	  var hoc = (0, _mapProps2.default)(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	exports.default = withProps;

/***/ },
/* 624 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Remove false values from a list, expect 0's
	 * @param  {array} list - List of items to be filtered
	 * @return {array}      - New lsit with false items removed
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.clean = clean;
	exports.cleanAll = cleanAll;
	exports.cleanObj = cleanObj;
	exports.cleanObjAll = cleanObjAll;
	exports.curry = curry;
	exports.filterObjetsInList = filterObjetsInList;
	exports.fmap = fmap;
	exports.either = either;
	exports.maybe = maybe;
	exports.maybeIf = maybeIf;
	exports.pickKeyValuesFromList = pickKeyValuesFromList;
	exports.pipe = pipe;
	exports.everyTrue = everyTrue;
	exports.someTrue = someTrue;
	exports.unique = unique;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function clean(list) {
	  return list.filter(function (e) {
	    return e === 0 ? '0' : e;
	  });
	}
	
	/**
	 * Removes all false values from a list
	 * @param  {array} list - List of items to be filtered
	 * @return {array}      - New list with false items removed
	 */
	function cleanAll(list) {
	  return list.filter(function (e) {
	    return e;
	  });
	}
	
	/**
	 * Removes all false key/values pairs from a list, expect 0's
	 * @param  {object} list - List of items to be filtered
	 * @return {object}      - New list with false items removed
	 */
	function cleanObj(obj) {
	  Object.keys(obj).forEach(function (key) {
	    return obj[key] && _typeof(obj[key]) === 'object' && cleanObj(obj[key]) || (obj[key] === undefined || obj[key] === null) && delete obj[key];
	  });
	  return obj;
	}
	
	/**
	 * Removes all key/values pairs values from a list
	 * @param  {object} list - List of items to be filtered
	 * @return {object}      - New list with false items removed
	 */
	function cleanObjAll(obj) {
	  Object.keys(obj).forEach(function (key) {
	    return obj[key] && _typeof(obj[key]) === 'object' && cleanObj(obj[key]) || (obj[key] === null || obj[key] === undefined || obj[key] === 0) && delete obj[key];
	  });
	  return obj;
	}
	
	function curry(fn) {
	  return function curried() {
	    return fn.apply(this, arguments);
	  };
	}
	
	/**
	*  Filters a list of objects by using another list of objects as the criteria
	*  @param  {function}  fn(criteria, search)  Function to filter criteria from searh
	*  @param  {array}     criteria              List of objects to us as the criteria
	*  @param  {array}     search                List of objects to be searhed
	*  @return {array}                           New list of objects with only filterd properties
	*/
	function filterObjetsInList(fn, criteria, search) {
	  return curry(function () {
	    return clean(criteria.map(function (c) {
	      return search.map(function (s) {
	        return fn(c, s);
	      });
	    })[0]);
	  });
	}
	
	/**
	* Maps a function over a container and returns a new container
	* @param  {function} function to be applied to value
	* @param  {[object]}
	* @param  {[type]}
	* @return {[type]}     value to be mapped
	*/
	function fmap(f, container, val) {
	  if (val == null) {
	    return curry(function () {
	      return container(null);
	    });
	  };
	
	  return curry(function () {
	    return container(f(val));
	  });
	}
	
	/**
	 * Executes left if any of the condition are true, else right if false.
	 * @param  {any}   left        If true.
	 * @param  {any}   right       If fasle.
	 * @param  {array} conditions  Array of conditions to be evaluated.
	 * @return {any}               Execute left if true else right if false.
	 */
	function either(left, right) {
	  return curry(function (conditions) {
	    var conditionsBool = Array.isArray(conditions) ? conditions.map(function (c) {
	      return Boolean(c);
	    }).some(function (b) {
	      return b === true;
	    }) : Boolean(conditions);
	
	    if (conditionsBool) return typeof left === 'function' ? left() : left;
	
	    return typeof right === 'function' ? right() : right;
	  });
	}
	
	/**
	* Create a container with an immutabe value or returns null if no value passed.
	* @param  {any}  value      Value to be returned if true.
	* @param  {any}  emptyType  Value to be returned if false value param is null/undefined. Default is null.
	* @return {any}             Returns value or emptyType.
	*/
	function maybe() {
	  var emptyType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	  return curry(function (value) {
	    return value == null ? emptyType : value;
	  });
	}
	
	/**
	* Create a container with an immutabe value or returns null if no value passed.
	* @param  {any}    value      Value to be returned if true
	* @param  {bool}   condition  Condition to be evaluated. Default is false.
	* @param  {any}    emptyType  Value to be returned if false value param is null/undefined. Default is null
	* @return {any}               Returns value or emptyType based on condition.
	*/
	function maybeIf(value) {
	  return curry(function () {
	    var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var emptyType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    return !condition ? emptyType : value;
	  });
	}
	
	/**
	* @param  {array} propsList    List of key name to be picked.
	* @param  {array} objectsList  List of objects.
	* @return {array}              New array of objects only containing the picked items.
	*/
	function pickKeyValuesFromList(propsList, objectsList) {
	  return objectsList.map(function (obj) {
	    function pickAll(propsList, obj) {
	      var result = {};
	
	      for (var idx = 0; idx < propsList.length; idx++) {
	        var propItem = propsList[idx];
	        result[propItem] = obj[propItem];
	      }
	
	      return result;
	    };
	
	    return pickAll(propsList, obj);
	  });
	}
	
	function pipe() {
	  var fns = [].slice.call(arguments);
	
	  return curry(function (initalValue) {
	    function reducer(prev, curr) {
	      return curr(prev);
	    }
	
	    return fns.reduce(reducer, initalValue);
	  });
	}
	
	function everyTrue() {
	  return [].concat(Array.prototype.slice.call(arguments)).every(function (e) {
	    return Boolean(e);
	  });
	}
	
	function someTrue() {
	  return [].concat(Array.prototype.slice.call(arguments)).some(function (e) {
	    return Boolean(e);
	  });
	}
	
	function unique(array) {
	  return [].concat(_toConsumableArray(new Set(array)));
	}
	
	var utils = {
	  clean: clean,
	  cleanAll: cleanAll,
	  cleanObj: cleanObj,
	  cleanObjAll: cleanObjAll,
	  curry: curry,
	  filterObjetsInList: filterObjetsInList,
	  fmap: fmap,
	  either: either,
	  everyTrue: everyTrue,
	  maybe: maybe,
	  maybeIf: maybeIf,
	  pickKeyValuesFromList: pickKeyValuesFromList,
	  pipe: pipe,
	  someTrue: someTrue
	};
	
	exports.default = utils;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _throttle2=__webpack_require__(159);var _throttle3=_interopRequireDefault(_throttle2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};
	var _victoryCore=__webpack_require__(12);
	
	var _eventHandlers=__webpack_require__(241);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}
	
	var Helpers={
	withinBounds:function withinBounds(point,bounds,padding){var
	x1=bounds.x1,x2=bounds.x2,y1=bounds.y1,y2=bounds.y2;var
	x=point.x,y=point.y;
	padding=padding?padding/2:0;
	return x+padding>=Math.min(x1,x2)&&
	x-padding<=Math.max(x1,x2)&&
	y+padding>=Math.min(y1,y2)&&
	y-padding<=Math.max(y1,y2);
	},
	
	getDomainBox:function getDomainBox(props,fullDomain,selectedDomain){var
	dimension=props.dimension,scale=props.scale;
	fullDomain=(0,_defaults3.default)({},fullDomain,props.domain);
	selectedDomain=(0,_defaults3.default)({},selectedDomain,fullDomain);
	var fullCoordinates=_victoryCore.Selection.getDomainCoordinates(scale,fullDomain);
	var selectedCoordinates=_victoryCore.Selection.getDomainCoordinates(scale,selectedDomain);
	
	return{
	x1:dimension!=="y"?Math.min.apply(Math,_toConsumableArray(selectedCoordinates.x)):Math.min.apply(Math,_toConsumableArray(fullCoordinates.x)),
	x2:dimension!=="y"?Math.max.apply(Math,_toConsumableArray(selectedCoordinates.x)):Math.max.apply(Math,_toConsumableArray(fullCoordinates.x)),
	y1:dimension!=="x"?Math.min.apply(Math,_toConsumableArray(selectedCoordinates.y)):Math.min.apply(Math,_toConsumableArray(fullCoordinates.y)),
	y2:dimension!=="x"?Math.max.apply(Math,_toConsumableArray(selectedCoordinates.y)):Math.max.apply(Math,_toConsumableArray(fullCoordinates.y))};
	
	},
	
	getHandles:function getHandles(props,domainBox){var
	x1=domainBox.x1,x2=domainBox.x2,y1=domainBox.y1,y2=domainBox.y2;
	var minX=Math.min(x1,x2);
	var maxX=Math.max(x1,x2);
	var minY=Math.min(y1,y2);
	var maxY=Math.max(y1,y2);
	var handleWidth=props.handleWidth/2;
	return{
	left:{x1:minX-handleWidth,x2:minX+handleWidth,y1:y1,y2:y2},
	right:{x1:maxX-handleWidth,x2:maxX+handleWidth,y1:y1,y2:y2},
	top:{x1:x1,x2:x2,y1:minY+handleWidth,y2:minY-handleWidth},
	bottom:{x1:x1,x2:x2,y1:maxY+handleWidth,y2:maxY-handleWidth}};
	
	},
	
	getActiveHandles:function getActiveHandles(point,props,domainBox){var _this=this;
	var handles=this.getHandles(props,domainBox);
	var activeHandles=["top","bottom","left","right"].reduce(function(memo,opt){
	memo=_this.withinBounds(point,handles[opt])?memo.concat(opt):memo;
	return memo;
	},[]);
	return activeHandles.length&&activeHandles;
	},
	
	getResizeMutation:function getResizeMutation(box,handles){var
	x1=box.x1,y1=box.y1,x2=box.x2,y2=box.y2;
	var mutations={
	left:{x1:Math.max(x1,x2),x2:Math.min(x1,x2),y1:y1,y2:y2},
	right:{x1:Math.min(x1,x2),x2:Math.max(x1,x2),y1:y1,y2:y2},
	top:{y1:Math.max(y1,y2),y2:Math.min(y1,y2),x1:x1,x2:x2},
	bottom:{y1:Math.min(y1,y2),y2:Math.max(y1,y2),x1:x1,x2:x2}};
	
	return handles.reduce(function(memo,current){
	return(0,_assign3.default)(memo,mutations[current]);
	},{});
	},
	
	getMinimumDomain:function getMinimumDomain(){
	return{x:[0,1/Number.MAX_SAFE_INTEGER],y:[0,1/Number.MAX_SAFE_INTEGER]};
	},
	
	getSelectionMutation:function getSelectionMutation(point,box,dimension){var
	x=point.x,y=point.y;var
	x1=box.x1,x2=box.x2,y1=box.y1,y2=box.y2;
	return{
	x1:dimension!=="y"?x:x1,
	y1:dimension!=="x"?y:y1,
	x2:dimension!=="y"?x:x2,
	y2:dimension!=="x"?y:y2};
	
	},
	
	panBox:function panBox(props,point){var
	dimension=props.dimension,domain=props.domain,startX=props.startX,startY=props.startY;
	var selectedDomain=(0,_defaults3.default)({},props.selectedDomain,domain);
	var fullDomain=(0,_defaults3.default)({},props.fullDomain,domain);var _ref=
	props.x1?
	props:this.getDomainBox(props,fullDomain,selectedDomain),x1=_ref.x1,x2=_ref.x2,y1=_ref.y1,y2=_ref.y2;var
	
	x=point.x,y=point.y;
	var delta={
	x:startX?startX-x:0,
	y:startY?startY-y:0};
	
	return{
	x1:dimension!=="y"?Math.min(x1,x2)-delta.x:Math.min(x1,x2),
	x2:dimension!=="y"?Math.max(x1,x2)-delta.x:Math.max(x1,x2),
	y1:dimension!=="x"?Math.min(y1,y2)-delta.y:Math.min(y1,y2),
	y2:dimension!=="x"?Math.max(y1,y2)-delta.y:Math.max(y1,y2)};
	
	},
	
	constrainBox:function constrainBox(box,fullDomainBox){var
	x1=fullDomainBox.x1,y1=fullDomainBox.y1,x2=fullDomainBox.x2,y2=fullDomainBox.y2;
	return{
	x1:box.x2>x2?x2-Math.abs(box.x2-box.x1):Math.max(box.x1,x1),
	y1:box.y2>y2?y2-Math.abs(box.y2-box.y1):Math.max(box.y1,y1),
	x2:box.x1<x1?x1+Math.abs(box.x2-box.x1):Math.min(box.x2,x2),
	y2:box.y1<y1?y1+Math.abs(box.y2-box.y1):Math.min(box.y2,y2)};
	
	},
	
	onMouseDown:function onMouseDown(evt,targetProps){var _this2=this;
	evt.preventDefault();var
	
	dimension=
	targetProps.dimension,handleWidth=targetProps.handleWidth,onDomainChange=targetProps.onDomainChange,cachedSelectedDomain=targetProps.cachedSelectedDomain,domain=targetProps.domain;
	var selectedDomain=(0,_defaults3.default)({},targetProps.selectedDomain,domain);
	var fullDomainBox=targetProps.fullDomainBox||
	this.getDomainBox(targetProps,domain);
	var currentDomain=(0,_isEqual3.default)(selectedDomain,cachedSelectedDomain)?
	targetProps.currentDomain||selectedDomain||domain:selectedDomain||domain;var _Selection$getSVGEven=
	_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven.x,y=_Selection$getSVGEven.y;
	
	if(!this.withinBounds({x:x,y:y},fullDomainBox,handleWidth)){
	return{};
	}
	var domainBox=this.getDomainBox(targetProps,domain,currentDomain);
	var activeHandles=this.getActiveHandles({x:x,y:y},targetProps,domainBox);
	
	if(activeHandles){
	return[{
	target:"parent",
	mutation:function mutation(){
	return _extends({
	isSelecting:true,domainBox:domainBox,fullDomainBox:fullDomainBox,
	cachedSelectedDomain:selectedDomain,currentDomain:currentDomain},
	_this2.getResizeMutation(domainBox,activeHandles));
	
	}}];
	
	}else if(
	this.withinBounds({x:x,y:y},domainBox)&&
	!(0,_isEqual3.default)(domain,currentDomain))
	{
	
	
	return[{
	target:"parent",
	mutation:function mutation(){return{
	isPanning:true,startX:x,startY:y,domainBox:domainBox,fullDomainBox:fullDomainBox,currentDomain:currentDomain,
	cachedSelectedDomain:selectedDomain};}}];
	
	
	}else{
	
	
	var minimumDomain=this.getMinimumDomain();
	if((0,_isFunction3.default)(onDomainChange)){
	onDomainChange(minimumDomain);
	}
	return[{
	target:"parent",
	mutation:function mutation(){
	return _extends({
	isSelecting:true,domainBox:domainBox,fullDomainBox:fullDomainBox,
	cachedSelectedDomain:selectedDomain,
	currentDomain:_this2.getMinimumDomain()},
	_this2.getSelectionMutation({x:x,y:y},domainBox,dimension));
	
	}}];
	
	}
	},
	
	onMouseMove:function onMouseMove(evt,targetProps){
	
	if(!targetProps.isPanning&&!targetProps.isSelecting){
	return{};
	}var
	
	dimension=
	targetProps.dimension,scale=targetProps.scale,isPanning=targetProps.isPanning,isSelecting=targetProps.isSelecting,fullDomainBox=targetProps.fullDomainBox,onDomainChange=targetProps.onDomainChange;var _Selection$getSVGEven2=
	_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven2.x,y=_Selection$getSVGEven2.y;
	
	if(!this.withinBounds({x:x,y:y},fullDomainBox)){
	return{};
	}
	if(isPanning){var
	startX=targetProps.startX,startY=targetProps.startY;
	var pannedBox=this.panBox(targetProps,{x:x,y:y});
	var constrainedBox=this.constrainBox(pannedBox,fullDomainBox);
	var currentDomain=_victoryCore.Selection.getBounds(_extends({},constrainedBox,{scale:scale}));
	if((0,_isFunction3.default)(onDomainChange)){
	onDomainChange(currentDomain);
	}
	return[{
	target:"parent",
	mutation:function mutation(){
	return _extends({
	currentDomain:currentDomain,
	startX:pannedBox.x2>=fullDomainBox.x2||pannedBox.x1<=fullDomainBox.x1?
	startX:x,
	startY:pannedBox.y2>=fullDomainBox.y2||pannedBox.y1<=fullDomainBox.y1?
	startY:y},
	constrainedBox);
	
	}}];
	
	}else if(isSelecting){
	var x2=dimension!=="y"?x:targetProps.x2;
	var y2=dimension!=="x"?y:targetProps.y2;
	var _currentDomain=
	_victoryCore.Selection.getBounds({x2:x2,y2:y2,x1:targetProps.x1,y1:targetProps.y1,scale:scale});
	if((0,_isFunction3.default)(onDomainChange)){
	onDomainChange(_currentDomain);
	}
	return[{
	target:"parent",
	mutation:function mutation(){
	return{
	x2:x2,y2:y2,currentDomain:_currentDomain};
	
	}}];
	
	}
	return{};
	},
	
	onMouseUp:function onMouseUp(evt,targetProps){var
	x1=targetProps.x1,y1=targetProps.y1,x2=targetProps.x2,y2=targetProps.y2,onDomainChange=targetProps.onDomainChange,domain=targetProps.domain;
	
	if(x1===x2||y1===y2){
	if((0,_isFunction3.default)(onDomainChange)){
	onDomainChange(domain);
	}
	return[{
	target:"parent",
	mutation:function mutation(){
	return{
	isPanning:false,isSelecting:false,currentDomain:domain};
	
	}}];
	
	}
	return[{
	target:"parent",
	mutation:function mutation(){return{isPanning:false,isSelecting:false};}}];
	
	},
	
	onMouseLeave:function onMouseLeave(){
	return[{
	target:"parent",
	mutation:function mutation(){return{isPanning:false,isSelecting:false};}}];
	
	}};exports.default=
	
	
	{
	onMouseDown:Helpers.onMouseDown.bind(Helpers),
	onMouseUp:Helpers.onMouseUp.bind(Helpers),
	onMouseLeave:Helpers.onMouseLeave.bind(Helpers),
	onMouseMove:(0,_throttle3.default)(
	(0,_eventHandlers.attachId)(Helpers.onMouseMove.bind(Helpers)),
	16,
	{leading:true,trailing:false})};

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _throttle2=__webpack_require__(159);var _throttle3=_interopRequireDefault(_throttle2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _victoryCore=__webpack_require__(12);
	
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _eventHandlers=__webpack_require__(241);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}
	
	var SelectionHelpers={
	getDatasets:function getDatasets(props){
	if(props.data){
	return[{data:props.data}];
	}
	
	var getData=function getData(childProps){
	var data=_victoryCore.Data.getData(childProps);
	return Array.isArray(data)&&data.length>0?data:undefined;
	};
	
	var iteratee=function iteratee(child,childName,parent){
	if(child.type&&child.type.role==="axis"){
	return null;
	}else if(child.type&&(0,_isFunction3.default)(child.type.getData)){
	child=parent?_react2.default.cloneElement(child,parent.props):child;
	var childData=child.props&&child.type.getData(child.props);
	return childData?{childName:childName,data:childData}:null;
	}else{
	var _childData=getData(child.props);
	return _childData?{childName:childName,data:_childData}:null;
	}
	};
	return _victoryCore.Helpers.reduceChildren(_react2.default.Children.toArray(props.children),iteratee);
	},
	
	filterDatasets:function filterDatasets(datasets,bounds){var _this=this;
	var filtered=datasets.reduce(function(memo,dataset){
	var selectedData=_this.getSelectedData(dataset.data,bounds);
	memo=selectedData?
	memo.concat({
	childName:dataset.childName,eventKey:selectedData.eventKey,data:selectedData.data}):
	
	memo;
	return memo;
	},[]);
	return filtered.length?filtered:null;
	},
	
	getSelectedData:function getSelectedData(dataset,bounds){var
	x=bounds.x,y=bounds.y;
	var withinBounds=function withinBounds(d){
	return d._x>=x[0]&&d._x<=x[1]&&d._y>=y[0]&&d._y<=y[1];
	};
	var eventKey=[];
	var data=[];
	var count=0;
	for(var index=0,len=dataset.length;index<len;index++){
	var datum=dataset[index];
	if(withinBounds(datum)){
	data[count]=datum;
	eventKey[count]=datum.eventKey===undefined?index:datum.eventKey;
	count++;
	}
	}
	return count>0?{eventKey:eventKey,data:data}:null;
	},
	
	onMouseDown:function onMouseDown(evt,targetProps){
	evt.preventDefault();var
	dimension=targetProps.dimension,scale=targetProps.scale;
	var datasets=targetProps.datasets||[];var _Selection$getSVGEven=
	_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven.x,y=_Selection$getSVGEven.y;
	var x1=dimension!=="y"?x:_victoryCore.Selection.getDomainCoordinates(scale).x[0];
	var y1=dimension!=="x"?y:_victoryCore.Selection.getDomainCoordinates(scale).y[0];
	var x2=dimension!=="y"?x:_victoryCore.Selection.getDomainCoordinates(scale).x[1];
	var y2=dimension!=="x"?y:_victoryCore.Selection.getDomainCoordinates(scale).y[1];
	if((0,_isFunction3.default)(targetProps.onSelectionCleared)){
	targetProps.onSelectionCleared();
	}
	return[
	{
	target:"parent",
	mutation:function mutation(){
	return{x1:x1,y1:y1,select:true,x2:x2,y2:y2};
	}},
	{
	target:"data",
	childName:targetProps.children||datasets.length?"all":undefined,
	eventKey:"all",
	mutation:function mutation(){return null;}}];
	
	
	},
	
	onMouseMove:function onMouseMove(evt,targetProps){var
	dimension=targetProps.dimension,scale=targetProps.scale,select=targetProps.select;
	if(!select){
	return{};
	}else{var _Selection$getSVGEven2=
	_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven2.x,y=_Selection$getSVGEven2.y;
	var x2=dimension!=="y"?x:_victoryCore.Selection.getDomainCoordinates(scale).x[1];
	var y2=dimension!=="x"?y:_victoryCore.Selection.getDomainCoordinates(scale).y[1];
	return{
	target:"parent",
	mutation:function mutation(){
	return{x2:x2,y2:y2};
	}};
	
	}
	},
	
	onMouseUp:function onMouseUp(evt,targetProps){var
	x2=targetProps.x2,y2=targetProps.y2;
	if(!x2||!y2){
	return[{
	target:"parent",
	mutation:function mutation(){
	return{select:false,x1:null,x2:null,y1:null,y2:null};
	}}];
	
	}
	var datasets=this.getDatasets(targetProps);
	var bounds=_victoryCore.Selection.getBounds(targetProps);
	var selectedData=this.filterDatasets(datasets,bounds);
	var callbackMutation=selectedData&&(0,_isFunction3.default)(targetProps.onSelection)?
	targetProps.onSelection(selectedData,bounds):{};
	
	var parentMutation=[{
	target:"parent",
	mutation:function mutation(){
	return{datasets:datasets,select:false,x1:null,x2:null,y1:null,y2:null};
	}}];
	
	
	var dataMutation=selectedData?
	selectedData.map(function(d){
	return{
	childName:d.childName,eventKey:d.eventKey,target:"data",
	mutation:function mutation(){
	return(0,_assign3.default)({active:true},callbackMutation);
	}};
	
	}):[];
	
	return parentMutation.concat(dataMutation);
	}};exports.default=
	
	
	{
	onMouseDown:SelectionHelpers.onMouseDown.bind(SelectionHelpers),
	onMouseUp:SelectionHelpers.onMouseUp.bind(SelectionHelpers),
	onMouseMove:(0,_throttle3.default)(
	(0,_eventHandlers.attachId)(SelectionHelpers.onMouseMove.bind(SelectionHelpers)),
	16,
	{leading:true,trailing:false})};

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.brushContainerMixin=undefined;var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _this2=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _victoryCore=__webpack_require__(12);
	var _brushHelpers=__webpack_require__(625);var _brushHelpers2=_interopRequireDefault(_brushHelpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	
	var brushContainerMixin=exports.brushContainerMixin=function brushContainerMixin(base){var _class,_temp;return _temp=_class=function(_base){_inherits(VictoryBrushContainer,_base);function VictoryBrushContainer(){_classCallCheck(this,VictoryBrushContainer);return _possibleConstructorReturn(this,(VictoryBrushContainer.__proto__||Object.getPrototypeOf(VictoryBrushContainer)).apply(this,arguments));}_createClass(VictoryBrushContainer,[{key:"getSelectBox",value:function getSelectBox(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	props,coordinates){var
	x=coordinates.x,y=coordinates.y;var
	selectionStyle=props.selectionStyle,selectionComponent=props.selectionComponent;
	var selectionComponentStyle=selectionComponent.props&&selectionComponent.props.style;
	return x[0]!==x[1]&&y[0]!==y[1]?
	_react2.default.cloneElement(selectionComponent,{
	width:Math.abs(x[1]-x[0])||1,
	height:Math.abs(y[1]-y[0])||1,
	x:Math.min(x[0],x[1]),
	y:Math.min(y[0],y[1]),
	cursor:"move",
	style:(0,_defaults3.default)({},selectionComponentStyle,selectionStyle)}):
	null;
	}},{key:"getHandles",value:function getHandles(
	
	props,coordinates){var
	dimension=props.dimension,handleWidth=props.handleWidth,handleStyle=props.handleStyle,handleComponent=props.handleComponent;var
	x=coordinates.x,y=coordinates.y;
	var width=Math.abs(x[1]-x[0])||1;
	var height=Math.abs(y[1]-y[0])||1;
	var handleComponentStyle=handleComponent.props&&handleComponent.props.style||{};
	var style=(0,_defaults3.default)({},handleComponentStyle,handleStyle);
	var yProps={style:style,width:width,height:handleWidth,cursor:"ns-resize"};
	var xProps={style:style,width:handleWidth,height:height,cursor:"ew-resize"};
	var handleProps={
	top:dimension!=="x"&&(0,_assign3.default)({x:x[0],y:y[1]-handleWidth/2},yProps),
	bottom:dimension!=="x"&&(0,_assign3.default)({x:x[0],y:y[0]-handleWidth/2},yProps),
	left:dimension!=="y"&&(0,_assign3.default)({y:y[1],x:x[0]-handleWidth/2},xProps),
	right:dimension!=="y"&&(0,_assign3.default)({y:y[1],x:x[1]-handleWidth/2},xProps)};
	
	var handles=["top","bottom","left","right"].reduce(function(memo,curr){
	memo=handleProps[curr]?
	memo.concat(_react2.default.cloneElement(
	handleComponent,
	(0,_assign3.default)({key:"handle-"+curr},handleProps[curr]))):
	memo;
	return memo;
	},[]);
	return handles.length?handles:null;
	}},{key:"getRect",value:function getRect(
	
	props){var
	currentDomain=props.currentDomain,cachedSelectedDomain=props.cachedSelectedDomain,scale=props.scale;
	var selectedDomain=(0,_defaults3.default)({},props.selectedDomain,props.domain);
	var domain=(0,_isEqual3.default)(selectedDomain,cachedSelectedDomain)?
	(0,_defaults3.default)({},currentDomain,selectedDomain):selectedDomain;
	var coordinates=_victoryCore.Selection.getDomainCoordinates(scale,domain);
	var selectBox=this.getSelectBox(props,coordinates);
	return selectBox?
	
	_react2.default.createElement("g",null,
	selectBox,
	this.getHandles(props,coordinates)):
	
	null;
	}},{key:"getChildren",value:function getChildren(
	
	
	props){
	var children=_react2.default.Children.toArray(props.children);
	return[].concat(_toConsumableArray(children),[this.getRect(props)]).map(function(component,i){
	return component?_react2.default.cloneElement(component,{key:i}):null;
	});
	}}]);return VictoryBrushContainer;}(base),_class.displayName="VictoryBrushContainer",_class.propTypes=_extends({},_victoryCore.VictoryContainer.propTypes,{dimension:_propTypes2.default.oneOf(["x","y"]),handleComponent:_propTypes2.default.element,handleStyle:_propTypes2.default.object,handleWidth:_propTypes2.default.number,onDomainChange:_propTypes2.default.func,selectedDomain:_propTypes2.default.shape({x:_propTypes2.default.array,y:_propTypes2.default.array}),selectionComponent:_propTypes2.default.element,selectionStyle:_propTypes2.default.object}),_class.defaultProps=_extends({},_victoryCore.VictoryContainer.defaultProps,{handleComponent:_react2.default.createElement("rect",null),handleStyle:{stroke:"transparent",fill:"transparent"},handleWidth:8,selectionComponent:_react2.default.createElement("rect",null),selectionStyle:{stroke:"transparent",fill:"black",fillOpacity:0.1}}),_class.defaultEvents=[{target:"parent",eventHandlers:{onMouseDown:function onMouseDown(evt,targetProps){return _brushHelpers2.default.onMouseDown(evt,targetProps);},onMouseMove:function onMouseMove(evt,targetProps){var mutations=_brushHelpers2.default.onMouseMove(evt,targetProps);if(mutations.id!==_this2.mouseMoveMutationId){_this2.mouseMoveMutationId=mutations.id;return mutations.mutations;}return undefined;},onMouseUp:function onMouseUp(evt,targetProps){return _brushHelpers2.default.onMouseUp(evt,targetProps);},onMouseLeave:function onMouseLeave(evt,targetProps){return _brushHelpers2.default.onMouseLeave(evt,targetProps);}}}],_temp;};exports.default=
	
	
	brushContainerMixin(_victoryCore.VictoryContainer);

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.selectionContainerMixin=undefined;var _this2=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _victoryCore=__webpack_require__(12);
	var _selectionHelpers=__webpack_require__(626);var _selectionHelpers2=_interopRequireDefault(_selectionHelpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var selectionContainerMixin=exports.selectionContainerMixin=function selectionContainerMixin(base){var _class,_temp;return _temp=_class=function(_base){_inherits(VictorySelectionContainer,_base);function VictorySelectionContainer(){_classCallCheck(this,VictorySelectionContainer);return _possibleConstructorReturn(this,(VictorySelectionContainer.__proto__||Object.getPrototypeOf(VictorySelectionContainer)).apply(this,arguments));}_createClass(VictorySelectionContainer,[{key:"getRect",value:function getRect(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	props){var
	x1=props.x1,x2=props.x2,y1=props.y1,y2=props.y2,selectionStyle=props.selectionStyle,selectionComponent=props.selectionComponent;
	var width=Math.abs(x2-x1)||1;
	var height=Math.abs(y2-y1)||1;
	var x=Math.min(x1,x2);
	var y=Math.min(y1,y2);
	return y2&&x2&&x1&&y1?
	_react2.default.cloneElement(selectionComponent,{x:x,y:y,width:width,height:height,style:selectionStyle}):null;
	}},{key:"getChildren",value:function getChildren(
	
	
	props){
	var children=_react2.default.Children.toArray(props.children);
	return[].concat(_toConsumableArray(children),[this.getRect(props)]).map(function(component,i){
	return component?_react2.default.cloneElement(component,{key:i}):null;
	});
	}}]);return VictorySelectionContainer;}(base),_class.displayName="VictorySelectionContainer",_class.propTypes=_extends({},_victoryCore.VictoryContainer.propTypes,{dimension:_propTypes2.default.oneOf(["x","y"]),onSelection:_propTypes2.default.func,onSelectionCleared:_propTypes2.default.func,selectionComponent:_propTypes2.default.element,selectionStyle:_propTypes2.default.object,standalone:_propTypes2.default.bool}),_class.defaultProps=_extends({},_victoryCore.VictoryContainer.defaultProps,{selectionComponent:_react2.default.createElement("rect",null),selectionStyle:{stroke:"transparent",fill:"black",fillOpacity:0.1}}),_class.defaultEvents=[{target:"parent",eventHandlers:{onMouseDown:function onMouseDown(evt,targetProps){return _selectionHelpers2.default.onMouseDown(evt,targetProps);},onMouseMove:function onMouseMove(evt,targetProps){var mutations=_selectionHelpers2.default.onMouseMove(evt,targetProps);if(mutations.id!==_this2.mouseMoveMutationId){_this2.mouseMoveMutationId=mutations.id;return mutations.mutations;}return undefined;},onMouseUp:function onMouseUp(evt,targetProps){return _selectionHelpers2.default.onMouseUp(evt,targetProps);}}}],_temp;};exports.default=
	
	
	selectionContainerMixin(_victoryCore.VictoryContainer);

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.voronoiContainerMixin=undefined;var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);var _this2=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _victoryCore=__webpack_require__(12);
	var _voronoiHelpers=__webpack_require__(631);var _voronoiHelpers2=_interopRequireDefault(_voronoiHelpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	
	var voronoiContainerMixin=exports.voronoiContainerMixin=function voronoiContainerMixin(base){var _class,_temp;return _temp=_class=function(_base){_inherits(VictoryVoronoiContainer,_base);function VictoryVoronoiContainer(){_classCallCheck(this,VictoryVoronoiContainer);return _possibleConstructorReturn(this,(VictoryVoronoiContainer.__proto__||Object.getPrototypeOf(VictoryVoronoiContainer)).apply(this,arguments));}_createClass(VictoryVoronoiContainer,[{key:"getLabelPadding",value:function getLabelPadding(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	style){
	if(!style){
	return 0;
	}
	var paddings=Array.isArray(style)?style.map(function(s){return s.padding;}):[style.padding];
	return Math.max.apply(Math,_toConsumableArray(paddings).concat([0]));
	}},{key:"getFlyoutSize",value:function getFlyoutSize(
	
	labelComponent,text,style){
	var padding=this.getLabelPadding(style);
	var textSize=_victoryCore.TextSize.approximateTextSize(text,style);
	return{
	x:labelComponent.width||textSize.width+padding,
	y:labelComponent.height||textSize.height+padding};
	
	}},{key:"getLabelCornerRadius",value:function getLabelCornerRadius(
	
	props,labelProps){
	if(typeof labelProps.cornerRadius!=="undefined"){
	return labelProps.cornerRadius;
	}
	var theme=props.theme||labelProps.theme;
	return theme.tooltip&&theme.tooltip.cornerRadius||0;
	}},{key:"getFlyoutExtent",value:function getFlyoutExtent(
	
	position,props,labelProps){var
	text=labelProps.text,style=labelProps.style;var
	orientation=labelProps.orientation,_labelProps$dx=labelProps.dx,dx=_labelProps$dx===undefined?0:_labelProps$dx,_labelProps$dy=labelProps.dy,dy=_labelProps$dy===undefined?0:_labelProps$dy;
	var flyoutSize=this.getFlyoutSize(props.labelComponent,text,style);
	var cornerRadius=this.getLabelCornerRadius(props,labelProps);
	var x=position.x+dx+2*cornerRadius;
	var y=position.y+dy+2*cornerRadius;
	var width=orientation==="top"||orientation==="bottom"?
	flyoutSize.x/2:
	flyoutSize.x;
	var horizontalSign=orientation==="left"?-1:1;
	var verticalSign=orientation==="bottom"?1:-1;
	var extent={};
	if(orientation==="top"||orientation==="bottom"){
	extent.x=[x-width,x+width];
	}else{
	extent.x=[x,x+horizontalSign*width];
	}
	extent.y=[y,y+verticalSign*flyoutSize.y];
	return{
	x:[Math.min.apply(Math,_toConsumableArray(extent.x)),Math.max.apply(Math,_toConsumableArray(extent.x))],
	y:[Math.min.apply(Math,_toConsumableArray(extent.y)),Math.max.apply(Math,_toConsumableArray(extent.y))]};
	
	}},{key:"getLabelPosition",value:function getLabelPosition(
	
	props,points,labelProps){var
	mousePosition=props.mousePosition,dimension=props.dimension,scale=props.scale,voronoiPadding=props.voronoiPadding;
	var dataX=points[0]._x1!==undefined?points[0]._x1:points[0]._x;
	var dataY=points[0]._y1!==undefined?points[0]._y1:points[0]._y;
	var basePosition={
	x:scale.x(dataX),
	y:scale.y(dataY)};
	
	if(!dimension||points.length<2){
	return basePosition;
	}
	
	var x=dimension==="y"?mousePosition.x:basePosition.x;
	var y=dimension==="x"?mousePosition.y:basePosition.y;
	var range={x:scale.x.range(),y:scale.y.range()};
	var extent={
	x:[Math.min.apply(Math,_toConsumableArray(range.x))+voronoiPadding,Math.max.apply(Math,_toConsumableArray(range.x))-voronoiPadding],
	y:[Math.min.apply(Math,_toConsumableArray(range.y))+voronoiPadding,Math.max.apply(Math,_toConsumableArray(range.y))-voronoiPadding]};
	
	var flyoutExtent=this.getFlyoutExtent({x:x,y:y},props,labelProps);
	var adjustments={
	x:[
	flyoutExtent.x[0]<extent.x[0]?extent.x[0]-flyoutExtent.x[0]:0,
	flyoutExtent.x[1]>extent.x[1]?flyoutExtent.x[1]-extent.x[1]:0],
	
	y:[
	flyoutExtent.y[0]<extent.y[0]?extent.y[0]-flyoutExtent.y[0]:0,
	flyoutExtent.y[1]>extent.y[1]?flyoutExtent.y[1]-extent.y[1]:0]};
	
	
	return{
	x:Math.round(x+adjustments.x[0]-adjustments.x[1]),
	y:Math.round(y+adjustments.y[0]-adjustments.y[1])};
	
	}},{key:"getStyle",value:function getStyle(
	
	props,points,type){var
	labels=props.labels,labelComponent=props.labelComponent,theme=props.theme;
	var componentProps=labelComponent.props||{};
	var themeStyles=theme&&theme.voronoi&&theme.voronoi.style?theme.voronoi.style:{};
	var componentStyle=type==="flyout"?componentProps.flyoutStyle:componentProps.style;
	var defaultStyles=(0,_defaults3.default)({},componentStyle,themeStyles[type]);
	return points.reduce(function(memo,point){
	var text=_victoryCore.Helpers.evaluateProp(labels,point,true);
	var textArray=text?(""+text).split("\n"):[];
	var baseStyle=point.style&&point.style[type]||{};
	var style=_victoryCore.Helpers.evaluateStyle((0,_defaults3.default)({},baseStyle,defaultStyles),point,true);
	var styleArray=textArray.length?textArray.map(function(){return style;}):[style];
	memo=memo.concat(styleArray);
	return memo;
	},[]);
	}},{key:"getDefaultLabelProps",value:function getDefaultLabelProps(
	
	props,points){var
	dimension=props.dimension;
	var multiPoint=dimension&&points.length>1;
	return{
	orientation:multiPoint?"top":undefined,
	pointerLength:multiPoint?0:undefined};
	
	}},{key:"getLabelProps",value:function getLabelProps(
	
	props,points){var
	labels=props.labels,scale=props.scale,labelComponent=props.labelComponent,theme=props.theme;
	var text=points.reduce(function(memo,point){
	var t=_victoryCore.Helpers.evaluateProp(labels,point,true);
	if(t===null||t===undefined){
	return memo;
	}
	memo=memo.concat((""+t).split("\n"));
	return memo;
	},[]);
	var style=this.getStyle(props,points,"labels");
	var labelProps=(0,_defaults3.default)(
	{
	theme:theme,style:style,text:text,scale:scale,
	active:true,
	renderInPortal:false,
	flyoutStyle:this.getStyle(props,points,"flyout")[0],
	datum:(0,_omit3.default)(points[0],["childName","style","continuous"])},
	
	labelComponent.props,
	this.getDefaultLabelProps(props,points));
	
	var labelPosition=this.getLabelPosition(props,points,labelProps);
	return _extends({},labelProps,labelPosition);
	}},{key:"getTooltip",value:function getTooltip(
	
	props){var
	labels=props.labels,activePoints=props.activePoints,labelComponent=props.labelComponent;
	if(!labels){
	return null;
	}
	if(Array.isArray(activePoints)&&activePoints.length){
	return _react2.default.cloneElement(labelComponent,this.getLabelProps(props,activePoints));
	}else{
	return null;
	}
	}},{key:"getChildren",value:function getChildren(
	
	
	props){
	var children=_react2.default.Children.toArray(props.children);
	return[].concat(_toConsumableArray(children),[this.getTooltip(props)]).map(function(component,i){
	return component?_react2.default.cloneElement(component,{key:i}):null;
	});
	}}]);return VictoryVoronoiContainer;}(base),_class.displayName="VictoryVoronoiContainer",_class.propTypes=_extends({},_victoryCore.VictoryContainer.propTypes,{dimension:_propTypes2.default.oneOf(["x","y"]),labelComponent:_propTypes2.default.element,labels:_propTypes2.default.func,onActivated:_propTypes2.default.func,onDeactivated:_propTypes2.default.func,radius:_propTypes2.default.number,standalone:_propTypes2.default.bool,voronoiPadding:_propTypes2.default.number}),_class.defaultProps=_extends({},_victoryCore.VictoryContainer.defaultProps,{labelComponent:_react2.default.createElement(_victoryCore.VictoryTooltip,null),voronoiPadding:5}),_class.defaultEvents=[{target:"parent",eventHandlers:{onMouseLeave:function onMouseLeave(evt,targetProps){return _voronoiHelpers2.default.onMouseLeave(evt,targetProps);},onMouseMove:function onMouseMove(evt,targetProps){var mutations=_voronoiHelpers2.default.onMouseMove(evt,targetProps);if(mutations.id!==_this2.mouseMoveMutationId){_this2.mouseMoveMutationId=mutations.id;return mutations.mutations;}return undefined;}}},{target:"data",eventHandlers:{onMouseOver:function onMouseOver(){return null;},onMouseOut:function onMouseOut(){return null;},onMouseMove:function onMouseMove(){return null;}}}],_temp;};exports.default=
	
	
	voronoiContainerMixin(_victoryCore.VictoryContainer);

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.zoomContainerMixin=undefined;var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _this2=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	
	var _zoomHelpers=__webpack_require__(632);var _zoomHelpers2=_interopRequireDefault(_zoomHelpers);
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var zoomContainerMixin=exports.zoomContainerMixin=function zoomContainerMixin(base){var _class,_temp;return _temp=_class=function(_base){_inherits(VictoryZoomContainer,_base);function VictoryZoomContainer(){_classCallCheck(this,VictoryZoomContainer);return _possibleConstructorReturn(this,(VictoryZoomContainer.__proto__||Object.getPrototypeOf(VictoryZoomContainer)).apply(this,arguments));}_createClass(VictoryZoomContainer,[{key:"clipDataComponents",value:function clipDataComponents(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	children,props){var
	scale=props.scale,clipContainerComponent=props.clipContainerComponent;
	var rangeX=scale.x.range();
	var rangeY=scale.y.range();
	var plottableWidth=Math.abs(rangeX[0]-rangeX[1]);
	var plottableHeight=Math.abs(rangeY[0]-rangeY[1]);
	var childComponents=[];
	var group=[];
	var groupNumber=0;
	
	var makeGroup=function makeGroup(arr,index){
	return Array.isArray(arr)&&arr.length?
	_react2.default.cloneElement(clipContainerComponent,{
	key:"ZoomClipContainer-"+index,
	clipWidth:plottableWidth,
	clipHeight:plottableHeight,
	translateX:Math.min.apply(Math,_toConsumableArray(rangeX)),
	translateY:Math.min.apply(Math,_toConsumableArray(rangeY)),
	children:arr}):
	
	null;
	};
	
	var findNextAxis=function findNextAxis(start){
	var subset=children.slice(start);
	return subset.findIndex(function(child){return child.type.displayName==="VictoryAxis";})+start;
	};
	
	var axisIndex=findNextAxis(0);
	
	if(axisIndex===-1){
	return makeGroup(children,groupNumber);
	}
	for(var i=0,len=children.length;i<len;i++){
	if(i===axisIndex){
	childComponents.push(makeGroup(group,groupNumber),children[i]);
	axisIndex=findNextAxis(i+1);
	group=[];
	groupNumber++;
	}else{
	group.push(children[i]);
	}
	}
	childComponents.push(makeGroup(group,groupNumber));
	return childComponents.filter(Boolean);
	}},{key:"modifyChildren",value:function modifyChildren(
	
	props){
	var childComponents=_react2.default.Children.toArray(props.children);
	
	return childComponents.map(function(child){var
	currentDomain=props.currentDomain;
	var originalDomain=(0,_defaults3.default)({},props.original,props.domain);
	var zoomDomain=(0,_defaults3.default)({},props.zoomDomain,props.domain);
	var cachedZoomDomain=(0,_defaults3.default)({},props.cachedZoomDomain,props.domain);
	var domain=(0,_isEqual3.default)(zoomDomain,cachedZoomDomain)?
	(0,_defaults3.default)({},currentDomain,originalDomain):zoomDomain;
	return _react2.default.cloneElement(
	child,(0,_defaults3.default)({domain:domain},child.props));
	
	});
	}},{key:"getChildren",value:function getChildren(
	
	
	props){
	var children=this.modifyChildren(props);
	return this.clipDataComponents(children,props);
	}}]);return VictoryZoomContainer;}(base),_class.displayName="VictoryZoomContainer",_class.propTypes=_extends({},_victoryCore.VictoryContainer.propTypes,{allowZoom:_propTypes2.default.bool,clipContainerComponent:_propTypes2.default.element.isRequired,dimension:_propTypes2.default.oneOf(["x","y"]),minimumZoom:_propTypes2.default.shape({x:_propTypes2.default.number,y:_propTypes2.default.number}),onDomainChange:_propTypes2.default.func,zoomDomain:_propTypes2.default.shape({x:_victoryCore.PropTypes.domain,y:_victoryCore.PropTypes.domain})}),_class.defaultProps=_extends({},_victoryCore.VictoryContainer.defaultProps,{clipContainerComponent:_react2.default.createElement(_victoryCore.VictoryClipContainer,null),allowZoom:true}),_class.defaultEvents=[{target:"parent",eventHandlers:{onMouseDown:function onMouseDown(evt,targetProps){return _zoomHelpers2.default.onMouseDown(evt,targetProps);},onMouseUp:function onMouseUp(evt,targetProps){return _zoomHelpers2.default.onMouseUp(evt,targetProps);},onMouseLeave:function onMouseLeave(evt,targetProps){return _zoomHelpers2.default.onMouseLeave(evt,targetProps);},onMouseMove:function onMouseMove(evt,targetProps,eventKey,ctx){evt.preventDefault();var mutations=_zoomHelpers2.default.onMouseMove(evt,targetProps,eventKey,ctx);if(mutations.id!==_this2.mouseMoveMutationId){_this2.mouseMoveMutationId=mutations.id;return mutations.mutations;}return undefined;},onWheel:function onWheel(evt,targetProps,eventKey,ctx){evt.preventDefault();var mutations=_zoomHelpers2.default.onWheel(evt,targetProps,eventKey,ctx);if(mutations.id!==_this2.wheelMutationId){_this2.wheelMutationId=mutations.id;return mutations.mutations;}return undefined;}}}],_temp;};exports.default=
	
	
	zoomContainerMixin(_victoryCore.VictoryContainer);

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _keys2=__webpack_require__(76);var _keys3=_interopRequireDefault(_keys2);var _groupBy2=__webpack_require__(454);var _groupBy3=_interopRequireDefault(_groupBy2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _throttle2=__webpack_require__(159);var _throttle3=_interopRequireDefault(_throttle2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _victoryCore=__webpack_require__(12);
	
	var _d3Voronoi=__webpack_require__(146);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _eventHandlers=__webpack_require__(241);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}
	
	var VoronoiHelpers={
	withinBounds:function withinBounds(props,point){var
	width=props.width,height=props.height,voronoiPadding=props.voronoiPadding;
	var padding=voronoiPadding||0;var
	x=point.x,y=point.y;
	return x>=padding&&x<=width-padding&&y>=padding&&y<=height-padding;
	},
	
	getDatasets:function getDatasets(props){
	var addMeta=function addMeta(data,name,child){
	var continuous=child&&child.type&&child.type.continuous;
	var style=child?child.props&&child.props.style:props.style;
	return data.map(function(datum,index){
	var x=datum._x1!==undefined?datum._x1:datum._x;
	var y=datum._y1!==undefined?datum._y1:datum._y;
	return(0,_assign3.default)({
	_voronoiX:props.dimension==="y"?0:x,
	_voronoiY:props.dimension==="x"?0:y,
	childName:name,eventKey:index,continuous:continuous,style:style},
	datum);
	});
	};
	
	if(props.data){
	return addMeta(props.data);
	}
	
	var getData=function getData(childProps){
	var data=_victoryCore.Data.getData(childProps);
	return Array.isArray(data)&&data.length>0?data:undefined;
	};
	
	var iteratee=function iteratee(child,childName,parent){
	if(child.type&&child.type.role==="axis"){
	return null;
	}else if(child.type&&(0,_isFunction3.default)(child.type.getData)){
	child=parent?_react2.default.cloneElement(child,parent.props):child;
	var childData=child.props&&child.type.getData(child.props);
	return childData?addMeta(childData,childName,child):null;
	}else{
	var _childData=getData(child.props);
	return _childData?addMeta(_childData,childName,child):null;
	}
	};
	return _victoryCore.Helpers.reduceChildren(_react2.default.Children.toArray(props.children),iteratee);
	},
	
	
	
	mergeDatasets:function mergeDatasets(props,datasets){var
	scale=props.scale;
	var points=(0,_groupBy3.default)(datasets,function(datum){
	var x=scale.x(datum._voronoiX);
	var y=scale.y(datum._voronoiY);
	return x+","+y;
	});
	return(0,_keys3.default)(points).map(function(key){
	var point=key.split(",");
	return{
	x:+point[0],
	y:+point[1],
	points:points[key]};
	
	});
	},
	
	getVoronoi:function getVoronoi(props,mousePosition){var
	width=props.width,height=props.height,voronoiPadding=props.voronoiPadding;
	var padding=voronoiPadding||0;
	var voronoiFunction=(0,_d3Voronoi.voronoi)().
	x(function(d){return d.x;}).
	y(function(d){return d.y;}).
	extent([[padding,padding],[width-padding,height-padding]]);
	var datasets=this.getDatasets(props);
	var voronoi=voronoiFunction(this.mergeDatasets(props,datasets));
	var size=props.dimension?undefined:props.radius;
	return voronoi.find(mousePosition.x,mousePosition.y,size);
	},
	
	getActiveMutations:function getActiveMutations(props,point){var
	childName=point.childName,continuous=point.continuous;
	var targets=props.labels?["data"]:["data","labels"];
	return targets.map(function(target){
	var eventKey=continuous===true&&target==="data"?"all":point.eventKey;
	return{
	childName:childName,eventKey:eventKey,target:target,mutation:function mutation(){return{active:true};}};
	
	});
	},
	
	getInactiveMutations:function getInactiveMutations(props,point){var
	childName=point.childName,continuous=point.continuous;
	var targets=props.labels?["data"]:["data","labels"];
	return targets.map(function(target){
	var eventKey=continuous&&target==="data"?"all":point.eventKey;
	return{
	childName:childName,eventKey:eventKey,target:target,mutation:function mutation(){return null;}};
	
	});
	},
	
	getParentMutation:function getParentMutation(activePoints,mousePosition){
	return[{
	target:"parent",
	eventKey:"parent",
	mutation:function mutation(){return{activePoints:activePoints,mousePosition:mousePosition};}}];
	
	},
	
	onActivated:function onActivated(props,points){
	if((0,_isFunction3.default)(props.onActivated)){
	props.onActivated(points);
	}
	},
	
	onDeactivated:function onDeactivated(props,points){
	if((0,_isFunction3.default)(props.onDeactivated)){
	props.onDeactivated(points);
	}
	},
	
	onMouseLeave:function onMouseLeave(evt,targetProps){var _this=this,_getParentMutation;
	var activePoints=targetProps.activePoints||[];
	this.onDeactivated(targetProps,activePoints);
	var inactiveMutations=activePoints.length?
	activePoints.map(function(point){return _this.getInactiveMutations(targetProps,point);}):[];
	return(_getParentMutation=this.getParentMutation([])).concat.apply(_getParentMutation,_toConsumableArray(inactiveMutations));
	},
	
	onMouseMove:function onMouseMove(evt,targetProps){var _this2=this;
	var activePoints=targetProps.activePoints||[];
	var mousePosition=_victoryCore.Selection.getSVGEventCoordinates(evt);
	if(!this.withinBounds(targetProps,mousePosition)){var _getParentMutation2;
	this.onDeactivated(targetProps,activePoints);
	var inactiveMutations=activePoints.length?
	activePoints.map(function(point){return _this2.getInactiveMutations(targetProps,point);}):[];
	return(_getParentMutation2=this.getParentMutation([],mousePosition)).concat.apply(_getParentMutation2,_toConsumableArray(inactiveMutations));
	}
	var nearestVoronoi=this.getVoronoi(targetProps,mousePosition);
	var points=nearestVoronoi?nearestVoronoi.data.points:[];
	var parentMutations=this.getParentMutation(points,mousePosition);
	if(activePoints.length&&(0,_isEqual3.default)(points,activePoints)){
	return parentMutations;
	}else{
	this.onActivated(targetProps,points);
	this.onDeactivated(targetProps,activePoints);
	var activeMutations=points.length?
	points.map(function(point){return _this2.getActiveMutations(targetProps,point);}):[];
	var _inactiveMutations=activePoints.length?
	activePoints.map(function(point){return _this2.getInactiveMutations(targetProps,point);}):[];
	return parentMutations.concat.apply(parentMutations,_toConsumableArray(_inactiveMutations).concat(_toConsumableArray(activeMutations)));
	}
	}};exports.default=
	
	
	{
	onMouseLeave:VoronoiHelpers.onMouseLeave.bind(VoronoiHelpers),
	onMouseMove:(0,_throttle3.default)(
	(0,_eventHandlers.attachId)(VoronoiHelpers.onMouseMove.bind(VoronoiHelpers)),
	32,
	{leading:true,trailing:false})};

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.RawZoomHelpers=undefined;var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _throttle2=__webpack_require__(159);var _throttle3=_interopRequireDefault(_throttle2);var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==="function"?Symbol.iterator:"@@iterator"](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==="function"?Symbol.iterator:"@@iterator")in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();
	var _victoryCore=__webpack_require__(12);
	
	var _eventHandlers=__webpack_require__(241);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}
	
	var Helpers={
	
	
	
	
	
	
	
	
	
	scale:function scale(currentDomain,evt,props,axis){var _currentDomain=_slicedToArray(
	currentDomain,2),from=_currentDomain[0],to=_currentDomain[1];
	var range=Math.abs(to-from);
	var minimumZoom=props.minimumZoom&&props.minimumZoom[axis];
	var factor=this.getScaleFactor(evt);
	if(minimumZoom&&range<=minimumZoom&&factor<1){
	return currentDomain;
	}var _getDomain$axis=_slicedToArray(
	this.getDomain(props)[axis],2),fromBound=_getDomain$axis[0],toBound=_getDomain$axis[1];
	var percent=this.getScalePercent(evt,props,axis);
	var point=factor*from+percent*(factor*range);
	var minDomain=this.getMinimumDomain(point,props,axis);var _getScaledDomain=
	this.getScaledDomain(currentDomain,factor,percent),_getScaledDomain2=_slicedToArray(_getScaledDomain,2),newMin=_getScaledDomain2[0],newMax=_getScaledDomain2[1];
	var newDomain=[
	newMin>fromBound&&newMin<toBound?newMin:fromBound,
	newMax<toBound&&newMax>fromBound?newMax:toBound];
	
	var domain=Math.abs(minDomain[1]-minDomain[0])>Math.abs(newDomain[1]-newDomain[0])?
	minDomain:newDomain;
	return _victoryCore.Collection.containsDates([fromBound,toBound])?
	[new Date(domain[0]),new Date(domain[1])]:domain;
	},
	
	getScaledDomain:function getScaledDomain(currentDomain,factor,percent){var _currentDomain2=_slicedToArray(
	currentDomain,2),from=_currentDomain2[0],to=_currentDomain2[1];
	var range=Math.abs(to-from);
	var diff=range-range*factor;
	var newMin=+from+diff*percent;
	var newMax=+to-diff*(1-percent);
	return[Math.min(newMin,newMax),Math.max(newMin,newMax)];
	},
	
	getMinimumDomain:function getMinimumDomain(point,props,axis){var
	minimumZoom=props.minimumZoom;
	var originalDomain=this.getDomain(props)[axis];var _originalDomain=_slicedToArray(
	originalDomain,2),from=_originalDomain[0],to=_originalDomain[1];
	var defaultMin=Math.abs(from-to)/1000;
	var extent=minimumZoom?minimumZoom[axis]||defaultMin:defaultMin;
	var minExtent=point-extent/2;
	var maxExtent=point+extent/2;
	return[
	minExtent>from&&minExtent<to?minExtent:from,
	maxExtent<to&&maxExtent>from?maxExtent:+from+extent/2];
	
	},
	
	getScaleFactor:function getScaleFactor(evt){
	var sign=evt.deltaY>0?1:-1;
	
	var delta=Math.min(Math.abs(evt.deltaY/300),0.5);
	return Math.abs(1+sign*delta);
	},
	
	getScalePercent:function getScalePercent(evt,props,axis){
	var originalDomain=this.getDomain(props);var _originalDomain$axis=_slicedToArray(
	originalDomain[axis],2),from=_originalDomain$axis[0],to=_originalDomain$axis[1];
	var position=this.getPosition(evt,props,originalDomain);
	return(position[axis]-from)/Math.abs(to-from);
	},
	
	getPosition:function getPosition(evt,props,originalDomain){var _Selection$getSVGEven=
	_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven.x,y=_Selection$getSVGEven.y;
	var originalScale={
	x:props.scale.x.domain(originalDomain.x),
	y:props.scale.y.domain(originalDomain.y)};
	
	return _victoryCore.Selection.getDataCoordinates(originalScale,x,y);
	},
	
	
	
	
	
	
	
	
	pan:function pan(currentDomain,originalDomain,delta){var _currentDomain$map=
	currentDomain.map(function(val){return+val;}),_currentDomain$map2=_slicedToArray(_currentDomain$map,2),fromCurrent=_currentDomain$map2[0],toCurrent=_currentDomain$map2[1];var _originalDomain$map=
	originalDomain.map(function(val){return+val;}),_originalDomain$map2=_slicedToArray(_originalDomain$map,2),fromOriginal=_originalDomain$map2[0],toOriginal=_originalDomain$map2[1];
	var lowerBound=fromCurrent+delta;
	var upperBound=toCurrent+delta;
	var newDomain=void 0;
	if(lowerBound>fromOriginal&&upperBound<toOriginal){
	newDomain=[lowerBound,upperBound];
	}else if(lowerBound<fromOriginal){
	var dx=toCurrent-fromCurrent;
	newDomain=[fromOriginal,fromOriginal+dx];
	}else if(upperBound>toOriginal){
	var _dx=toCurrent-fromCurrent;
	newDomain=[toOriginal-_dx,toOriginal];
	}else{
	newDomain=currentDomain;
	}
	return _victoryCore.Collection.containsDates(currentDomain)||_victoryCore.Collection.containsDates(originalDomain)?
	newDomain.map(function(val){return new Date(val);}):newDomain;
	},
	
	getDomainScale:function getDomainScale(domain,scale,axis){
	var axisDomain=Array.isArray(domain)?domain:domain[axis];var _axisDomain=_slicedToArray(
	axisDomain,2),from=_axisDomain[0],to=_axisDomain[1];
	var range=scale[axis].range();
	var plottableWidth=Math.abs(range[0]-range[1]);
	return plottableWidth/(to-from);
	},
	
	handleAnimation:function handleAnimation(ctx){
	var getTimer=(0,_isFunction3.default)(ctx.getTimer)&&ctx.getTimer.bind(ctx);
	if(getTimer&&(0,_isFunction3.default)(getTimer().bypassAnimation)){
	getTimer().bypassAnimation();
	return(0,_isFunction3.default)(getTimer().resumeAnimation)?
	function(){return getTimer().resumeAnimation();}:undefined;
	}
	return undefined;
	},
	
	getDomain:function getDomain(props){var
	originalDomain=props.originalDomain,domain=props.domain,scale=props.scale;
	var scaleDomain={x:scale.x.domain(),y:scale.y.domain()};
	return(0,_defaults3.default)({},originalDomain,domain,scaleDomain);
	},
	
	onMouseDown:function onMouseDown(evt,targetProps){
	evt.preventDefault();var
	domain=targetProps.domain,zoomDomain=targetProps.zoomDomain;
	var originalDomain=this.getDomain(targetProps);
	var currentDomain=(0,_defaults3.default)(
	{},targetProps.currentDomain||zoomDomain||originalDomain,domain);var _Selection$getSVGEven2=
	
	_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven2.x,y=_Selection$getSVGEven2.y;
	return[{
	target:"parent",
	mutation:function mutation(){
	return{
	startX:x,startY:y,domain:currentDomain,cachedZoomDomain:zoomDomain,
	originalDomain:originalDomain,currentDomain:currentDomain,panning:true,
	parentControlledProps:["domain"]};
	
	}}];
	
	},
	
	onMouseUp:function onMouseUp(){
	return[{
	target:"parent",
	mutation:function mutation(){
	return{panning:false};
	}}];
	
	},
	
	onMouseLeave:function onMouseLeave(){
	return[{
	target:"parent",
	mutation:function mutation(){
	return{panning:false};
	}}];
	
	},
	
	onMouseMove:function onMouseMove(evt,targetProps,eventKey,ctx){
	if(targetProps.panning){var
	scale=targetProps.scale,startX=targetProps.startX,startY=targetProps.startY,onDomainChange=targetProps.onDomainChange,dimension=targetProps.dimension,domain=targetProps.domain,zoomDomain=targetProps.zoomDomain;var _Selection$getSVGEven3=
	_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven3.x,y=_Selection$getSVGEven3.y;
	var originalDomain=this.getDomain(targetProps);
	var lastDomain=(0,_defaults3.default)(
	{},targetProps.currentDomain||zoomDomain||originalDomain,domain);
	
	var dx=(startX-x)/this.getDomainScale(lastDomain,scale,"x");
	var dy=(y-startY)/this.getDomainScale(lastDomain,scale,"y");
	var currentDomain={
	x:dimension==="y"?originalDomain.x:this.pan(lastDomain.x,originalDomain.x,dx),
	y:dimension==="x"?originalDomain.y:this.pan(lastDomain.y,originalDomain.y,dy)};
	
	var resumeAnimation=this.handleAnimation(ctx);
	if((0,_isFunction3.default)(onDomainChange)){
	onDomainChange(currentDomain);
	}
	return[{
	target:"parent",
	callback:resumeAnimation,
	mutation:function mutation(){
	return{
	parentControlledProps:["domain"],startX:x,startY:y,
	domain:currentDomain,currentDomain:currentDomain,originalDomain:originalDomain,cachedZoomDomain:zoomDomain};
	
	}}];
	
	}
	return undefined;
	},
	
	onWheel:function onWheel(evt,targetProps,eventKey,ctx){
	if(!targetProps.allowZoom){
	return{};
	}var
	onDomainChange=targetProps.onDomainChange,dimension=targetProps.dimension,domain=targetProps.domain,zoomDomain=targetProps.zoomDomain;
	var originalDomain=this.getDomain(targetProps);
	var lastDomain=(0,_defaults3.default)(
	{},targetProps.currentDomain||zoomDomain||originalDomain,domain);var
	
	x=lastDomain.x,y=lastDomain.y;
	var currentDomain={
	x:dimension==="y"?lastDomain.x:this.scale(x,evt,targetProps,"x"),
	y:dimension==="x"?lastDomain.y:this.scale(y,evt,targetProps,"y")};
	
	var resumeAnimation=this.handleAnimation(ctx);
	if((0,_isFunction3.default)(onDomainChange)){
	onDomainChange(currentDomain);
	}
	return[{
	target:"parent",
	callback:resumeAnimation,
	mutation:function mutation(){
	return{
	domain:currentDomain,currentDomain:currentDomain,originalDomain:originalDomain,cachedZoomDomain:zoomDomain,
	parentControlledProps:["domain"],panning:false};
	
	}}];
	
	}};exports.
	
	
	RawZoomHelpers=Helpers;exports.default=
	
	{
	onMouseDown:Helpers.onMouseDown.bind(Helpers),
	onMouseUp:Helpers.onMouseUp.bind(Helpers),
	onMouseLeave:Helpers.onMouseLeave.bind(Helpers),
	onMouseMove:(0,_throttle3.default)(
	(0,_eventHandlers.attachId)(Helpers.onMouseMove.bind(Helpers)),
	16,
	{leading:true,trailing:false}),
	
	onWheel:(0,_throttle3.default)(
	(0,_eventHandlers.attachId)(Helpers.onWheel.bind(Helpers)),
	16,
	{leading:true,trailing:false})};

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	
	var _victoryCore=__webpack_require__(12);
	
	
	
	var _helperMethods=__webpack_require__(1430);var _helperMethods2=_interopRequireDefault(_helperMethods);
	var _axis=__webpack_require__(240);var _axis2=_interopRequireDefault(_axis);
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50};
	
	
	var animationWhitelist=[
	"style","domain","range","tickCount","tickValues",
	"offsetX","offsetY","padding","width","height"];var
	
	
	VictoryAxis=function(_React$Component){_inherits(VictoryAxis,_React$Component);function VictoryAxis(){_classCallCheck(this,VictoryAxis);return _possibleConstructorReturn(this,(VictoryAxis.__proto__||Object.getPrototypeOf(VictoryAxis)).apply(this,arguments));}_createClass(VictoryAxis,[{key:"renderLine",value:function renderLine(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	props){var
	axisComponent=props.axisComponent;
	var axisProps=this.getComponentProps(axisComponent,"axis",0);
	return _react2.default.cloneElement(axisComponent,axisProps);
	}},{key:"renderLabel",value:function renderLabel(
	
	props){var
	axisLabelComponent=props.axisLabelComponent;
	var axisLabelProps=this.getComponentProps(axisLabelComponent,"axisLabel",0);
	return _react2.default.cloneElement(axisLabelComponent,axisLabelProps);
	}},{key:"renderGridAndTicks",value:function renderGridAndTicks(
	
	props){var _this2=this;var
	tickComponent=props.tickComponent,tickLabelComponent=props.tickLabelComponent,gridComponent=props.gridComponent;
	
	return this.dataKeys.map(function(key,index){
	var tickProps=_this2.getComponentProps(tickComponent,"ticks",index);
	var TickComponent=_react2.default.cloneElement(tickComponent,tickProps);
	var gridProps=_this2.getComponentProps(gridComponent,"grid",index);
	var GridComponent=_react2.default.cloneElement(gridComponent,gridProps);
	var tickLabelProps=_this2.getComponentProps(tickLabelComponent,"tickLabels",index);
	var TickLabel=_react2.default.cloneElement(tickLabelComponent,tickLabelProps);
	
	return _react2.default.cloneElement(
	props.groupComponent,{key:"tick-group-"+key},GridComponent,TickComponent,TickLabel);
	
	});
	}},{key:"fixLabelOverlap",value:function fixLabelOverlap(
	
	gridAndTicks,props){
	var isVertical=_victoryCore.Helpers.isVertical(props);
	var size=isVertical?props.height:props.width;
	var isVictoryLabel=function isVictoryLabel(child){return child.type&&child.type.role==="label";};
	var labels=gridAndTicks.map(function(gridAndTick){return gridAndTick.props.children;}).
	reduce(function(accumulator,childArr){return accumulator.concat(childArr);}).
	filter(isVictoryLabel).
	map(function(child){return child.props;});
	var paddingToObject=function paddingToObject(padding){return(
	typeof padding==="object"?
	(0,_assign3.default)({},{top:0,right:0,bottom:0,left:0},padding):
	{top:padding,right:padding,bottom:padding,left:padding});};
	var labelsSumSize=labels.reduce(function(sum,label){
	var padding=paddingToObject(label.style.padding);
	var labelSize=_victoryCore.TextSize.approximateTextSize(label.text,{
	angle:label.angle,
	fontSize:label.style.fontSize,
	letterSpacing:label.style.letterSpacing,
	fontFamily:label.style.fontFamily});
	
	return sum+(isVertical?
	labelSize.height+padding.top+padding.bottom:
	labelSize.width+padding.right+padding.left);
	},0);
	var availiableLabelCount=Math.floor(size*gridAndTicks.length/labelsSumSize);
	var divider=Math.ceil(gridAndTicks.length/availiableLabelCount)||1;
	var getLabelCoord=function getLabelCoord(gridAndTick){return gridAndTick.props.children.
	filter(isVictoryLabel).
	reduce(function(prev,child){return(isVertical?child.props.y:child.props.x)||0;},0);};
	var sorted=gridAndTicks.sort(function(a,b){return isVertical?
	getLabelCoord(b)-getLabelCoord(a):
	getLabelCoord(a)-getLabelCoord(b);});
	
	return sorted.filter(function(gridAndTick,index){return index%divider===0;});
	}},{key:"shouldAnimate",value:function shouldAnimate()
	
	
	{
	return!!this.props.animate;
	}},{key:"render",value:function render()
	
	{
	var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,"axis");
	if(this.shouldAnimate()){
	return this.animateComponent(props,animationWhitelist);
	}
	
	var gridAndTicks=this.renderGridAndTicks(props);
	var modifiedGridAndTicks=props.fixLabelOverlap?
	this.fixLabelOverlap(gridAndTicks,props):
	gridAndTicks;
	var children=[].concat(_toConsumableArray(
	modifiedGridAndTicks),[
	this.renderLine(props),
	this.renderLabel(props)]);
	
	return this.renderContainer(props.containerComponent,children);
	}}]);return VictoryAxis;}(_react2.default.Component);VictoryAxis.displayName="VictoryAxis";VictoryAxis.role="axis";VictoryAxis.defaultTransitions={onExit:{duration:500},onEnter:{duration:500}};VictoryAxis.propTypes=_extends({},_commonProps.BaseProps,{axisComponent:_propTypes2.default.element,axisLabelComponent:_propTypes2.default.element,crossAxis:_propTypes2.default.bool,dependentAxis:_propTypes2.default.bool,fixLabelOverlap:_propTypes2.default.bool,gridComponent:_propTypes2.default.element,groupComponent:_propTypes2.default.element,label:_propTypes2.default.any,offsetX:_propTypes2.default.number,offsetY:_propTypes2.default.number,orientation:_propTypes2.default.oneOf(["top","bottom","left","right"]),style:_propTypes2.default.shape({parent:_propTypes2.default.object,axis:_propTypes2.default.object,axisLabel:_propTypes2.default.object,grid:_propTypes2.default.object,ticks:_propTypes2.default.object,tickLabels:_propTypes2.default.object}),tickComponent:_propTypes2.default.element,tickCount:_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.greaterThanZero]),tickFormat:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.homogeneousArray]),tickLabelComponent:_propTypes2.default.element,tickValues:_victoryCore.PropTypes.homogeneousArray});VictoryAxis.defaultProps={axisComponent:_react2.default.createElement(_victoryCore.Line,{type:"axis"}),axisLabelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),tickLabelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),tickComponent:_react2.default.createElement(_victoryCore.Line,{type:"tick"}),gridComponent:_react2.default.createElement(_victoryCore.Line,{type:"grid"}),scale:"linear",standalone:true,theme:_victoryCore.VictoryTheme.grayscale,tickCount:5,containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",{role:"presentation"}),fixLabelOverlap:false};VictoryAxis.getDomain=_helperMethods2.default.getDomain.bind(_helperMethods2.default);VictoryAxis.getAxis=_axis2.default.getAxis.bind(_axis2.default);VictoryAxis.getScale=_helperMethods2.default.getScale.bind(_helperMethods2.default);VictoryAxis.getStyles=(0,_partialRight3.default)(_helperMethods2.default.getStyles.bind(_helperMethods2.default),fallbackProps.style);VictoryAxis.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryAxis.expectedComponents=["axisComponent","axisLabelComponent","groupComponent","containerComponent","tickComponent","tickLabelComponent","gridComponent"];exports.default=
	
	
	(0,_victoryCore.addEvents)(VictoryAxis);

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _d3Ease=__webpack_require__(759);var d3Ease=_interopRequireWildcard(_d3Ease);
	var _util=__webpack_require__(1448);
	var _timer=__webpack_require__(641);var _timer2=_interopRequireDefault(_timer);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	VictoryAnimation=function(_React$Component){_inherits(VictoryAnimation,_React$Component);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function VictoryAnimation(props){_classCallCheck(this,VictoryAnimation);var _this=_possibleConstructorReturn(this,(VictoryAnimation.__proto__||Object.getPrototypeOf(VictoryAnimation)).call(this,
	props));
	
	_this.state={
	data:Array.isArray(_this.props.data)?
	_this.props.data[0]:_this.props.data,
	animationInfo:{
	progress:0,
	animating:false}};
	
	
	_this.interpolator=null;
	_this.queue=Array.isArray(_this.props.data)?
	_this.props.data.slice(1):[];
	
	_this.ease=d3Ease[_this.toNewName(_this.props.easing)];
	
	
	
	
	_this.functionToBeRunEachFrame=_this.functionToBeRunEachFrame.bind(_this);
	_this.getTimer=_this.getTimer.bind(_this);return _this;
	}_createClass(VictoryAnimation,[{key:"componentDidMount",value:function componentDidMount()
	
	{
	
	if(this.queue.length){
	this.traverseQueue();
	}
	}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(
	
	
	nextProps){
	
	this.getTimer().unsubscribe(this.loopID);
	
	
	if(!Array.isArray(nextProps.data)){
	
	
	this.queue.length=0;
	this.queue.push(nextProps.data);
	
	}else{var _queue;
	
	(_queue=this.queue).push.apply(_queue,_toConsumableArray(nextProps.data));
	}
	
	this.traverseQueue();
	}},{key:"componentWillUnmount",value:function componentWillUnmount()
	
	{
	if(this.loopID){
	this.getTimer().unsubscribe(this.loopID);
	}else{
	this.getTimer().stop();
	}
	}},{key:"getTimer",value:function getTimer()
	
	{
	if(this.context.getTimer){
	return this.context.getTimer();
	}
	if(!this.timer){
	this.timer=new _timer2.default();
	}
	return this.timer;
	}},{key:"toNewName",value:function toNewName(
	
	ease){
	
	var capitalize=function capitalize(s){return s&&s[0].toUpperCase()+s.slice(1);};
	return"ease"+capitalize(ease);
	}},{key:"traverseQueue",value:function traverseQueue()
	
	
	{var _this2=this;
	if(this.queue.length){
	
	var data=this.queue[0];
	
	this.interpolator=(0,_util.victoryInterpolator)(this.state.data,data);
	
	if(this.props.delay){
	setTimeout(function(){
	_this2.loopID=_this2.getTimer().subscribe(
	_this2.functionToBeRunEachFrame,_this2.props.duration);
	
	},this.props.delay);
	}else{
	this.loopID=this.getTimer().subscribe(
	this.functionToBeRunEachFrame,this.props.duration);
	
	}
	}else if(this.props.onEnd){
	this.props.onEnd();
	}
	}},{key:"functionToBeRunEachFrame",value:function functionToBeRunEachFrame(
	
	elapsed,duration){
	
	
	
	
	duration=duration!==undefined?duration:this.props.duration;
	var step=duration?elapsed/duration:1;
	if(step>=1){
	this.setState({
	data:this.interpolator(1),
	animationInfo:{
	progress:1,
	animating:false}});
	
	
	if(this.loopID){
	this.getTimer().unsubscribe(this.loopID);
	}
	this.queue.shift();
	this.traverseQueue();
	return;
	}
	
	
	
	
	
	this.setState({
	data:this.interpolator(this.ease(step)),
	animationInfo:{
	progress:step,
	animating:step<1}});
	
	
	}},{key:"render",value:function render()
	
	{
	return this.props.children(this.state.data,this.state.animationInfo);
	}}]);return VictoryAnimation;}(_react2.default.Component);VictoryAnimation.displayName="VictoryAnimation";VictoryAnimation.propTypes={children:_propTypes2.default.func,data:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.array]),delay:_propTypes2.default.number,duration:_propTypes2.default.number,easing:_propTypes2.default.oneOf(["back","backIn","backOut","backInOut","bounce","bounceIn","bounceOut","bounceInOut","circle","circleIn","circleOut","circleInOut","linear","linearIn","linearOut","linearInOut","cubic","cubicIn","cubicOut","cubicInOut","elastic","elasticIn","elasticOut","elasticInOut","exp","expIn","expOut","expInOut","poly","polyIn","polyOut","polyInOut","quad","quadIn","quadOut","quadInOut","sin","sinIn","sinOut","sinInOut"]),onEnd:_propTypes2.default.func};VictoryAnimation.defaultProps={data:{},delay:0,duration:1000,easing:"quadInOut"};VictoryAnimation.contextTypes={getTimer:_propTypes2.default.func};exports.default=VictoryAnimation;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	
	var _portal=__webpack_require__(636);var _portal2=_interopRequireDefault(_portal);
	var _index=__webpack_require__(53);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	VictoryContainer=function(_React$Component){_inherits(VictoryContainer,_React$Component);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function VictoryContainer(props){_classCallCheck(this,VictoryContainer);var _this=_possibleConstructorReturn(this,(VictoryContainer.__proto__||Object.getPrototypeOf(VictoryContainer)).call(this,
	props));
	_this.getTimer=_this.getTimer.bind(_this);return _this;
	}_createClass(VictoryContainer,[{key:"getChildContext",value:function getChildContext()
	
	{
	return this.props.standalone!==false?
	{
	portalUpdate:this.portalUpdate,
	portalRegister:this.portalRegister,
	portalDeregister:this.portalDeregister,
	getTimer:this.getTimer}:
	{};
	}},{key:"componentWillMount",value:function componentWillMount()
	
	{var _this2=this;
	this.savePortalRef=function(portal){
	_this2.portalRef=portal;
	return portal;
	};
	this.portalUpdate=function(key,el){return _this2.portalRef.portalUpdate(key,el);};
	this.portalRegister=function(){return _this2.portalRef.portalRegister();};
	this.portalDeregister=function(key){return _this2.portalRef.portalDeregister(key);};
	}},{key:"componentWillUnmount",value:function componentWillUnmount()
	
	{
	if(!this.context.getTimer){
	this.getTimer().stop();
	}
	}},{key:"getTimer",value:function getTimer()
	
	{
	if(this.context.getTimer){
	return this.context.getTimer();
	}
	if(!this.timer){
	this.timer=new _index.Timer();
	}
	return this.timer;
	}},{key:"getChildren",value:function getChildren(
	
	
	props){
	return props.children;
	}},{key:"renderContainer",value:function renderContainer(
	
	
	props,svgProps,style){var
	title=props.title,desc=props.desc,portalComponent=props.portalComponent,className=props.className,standalone=props.standalone;
	var children=this.getChildren(props);
	var parentProps=(0,_defaults3.default)({style:style,className:className},svgProps);
	var groupComponent=props.groupComponent||_react2.default.createElement("g",null);
	return standalone!==false?
	
	_react2.default.createElement("svg",parentProps,
	title?_react2.default.createElement("title",{id:"title"},title):null,
	desc?_react2.default.createElement("desc",{id:"desc"},desc):null,
	children,
	_react2.default.cloneElement(portalComponent,{ref:this.savePortalRef})):
	
	
	_react2.default.cloneElement(groupComponent,parentProps,children);
	}},{key:"render",value:function render()
	
	{var _props=
	this.props,width=_props.width,height=_props.height,responsive=_props.responsive,events=_props.events,standalone=_props.standalone;
	var style=responsive?this.props.style:(0,_omit3.default)(this.props.style,["height","width"]);
	var svgProps=(0,_assign3.default)(
	{
	width:width,height:height,
	"aria-labelledby":standalone!==false?"title desc":undefined,
	role:standalone!==false?"img":"presentation",
	viewBox:responsive&&standalone!==false?"0 0 "+width+" "+height:undefined},
	
	events);
	
	return this.renderContainer(this.props,svgProps,style);
	}}]);return VictoryContainer;}(_react2.default.Component);VictoryContainer.displayName="VictoryContainer";VictoryContainer.role="container";VictoryContainer.propTypes={children:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node),_propTypes2.default.node]),className:_propTypes2.default.string,desc:_propTypes2.default.string,events:_propTypes2.default.object,height:_propTypes2.default.number,portalComponent:_propTypes2.default.element,responsive:_propTypes2.default.bool,standalone:_propTypes2.default.bool,style:_propTypes2.default.object,theme:_propTypes2.default.object,title:_propTypes2.default.string,width:_propTypes2.default.number};VictoryContainer.defaultProps={portalComponent:_react2.default.createElement(_portal2.default,null),responsive:true};VictoryContainer.contextTypes={getTimer:_propTypes2.default.func};VictoryContainer.childContextTypes={portalUpdate:_propTypes2.default.func,portalRegister:_propTypes2.default.func,portalDeregister:_propTypes2.default.func,getTimer:_propTypes2.default.func};exports.default=VictoryContainer;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Portal=function(_React$Component){_inherits(Portal,_React$Component);
	
	
	
	
	
	
	
	
	
	
	function Portal(props){_classCallCheck(this,Portal);var _this=_possibleConstructorReturn(this,(Portal.__proto__||Object.getPrototypeOf(Portal)).call(this,
	props));
	_this.map={};
	_this.index=1;
	_this.portalUpdate=_this.portalUpdate.bind(_this);
	_this.portalRegister=_this.portalRegister.bind(_this);
	_this.portalDeregister=_this.portalDeregister.bind(_this);return _this;
	}_createClass(Portal,[{key:"portalRegister",value:function portalRegister()
	
	{
	return++this.index;
	}},{key:"portalUpdate",value:function portalUpdate(
	
	key,element){
	this.map[key]=element;
	this.forceUpdate();
	}},{key:"portalDeregister",value:function portalDeregister(
	
	key){
	delete this.map[key];
	}},{key:"render",value:function render()
	
	
	{var _this2=this;
	return _react2.default.cloneElement(
	this.props.groupComponent,
	{},
	Object.keys(this.map).map(function(key){
	var el=_this2.map[key];
	return el?_react2.default.cloneElement(el,{key:key}):el;
	}));
	
	}}]);return Portal;}(_react2.default.Component);Portal.displayName="Portal";Portal.propTypes={groupComponent:_propTypes2.default.element};Portal.defaultProps={groupComponent:_react2.default.createElement("g",null)};exports.default=Portal;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _index=__webpack_require__(53);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	
	VictoryPortal=function(_React$Component){_inherits(VictoryPortal,_React$Component);function VictoryPortal(){_classCallCheck(this,VictoryPortal);return _possibleConstructorReturn(this,(VictoryPortal.__proto__||Object.getPrototypeOf(VictoryPortal)).apply(this,arguments));}_createClass(VictoryPortal,[{key:"componentDidMount",value:function componentDidMount()
	
	
	
	
	
	
	
	
	
	
	{
	if(!this.checkedContext){
	if(typeof this.context.portalUpdate!=="function"){
	var msg="`renderInPortal` is not supported outside of `VictoryContainer`. "+
	"Component will be rendered in place";
	_index.Log.warn(msg);
	this.renderInPlace=true;
	}
	this.checkedContext=true;
	}
	this.forceUpdate();
	}},{key:"componentDidUpdate",value:function componentDidUpdate()
	
	{
	if(!this.renderInPlace){
	this.portalKey=this.portalKey||this.context.portalRegister();
	this.context.portalUpdate(this.portalKey,this.element);
	}
	}},{key:"componentWillUnmount",value:function componentWillUnmount()
	
	{
	if(this.context&&this.context.portalDeregister){
	this.context.portalDeregister(this.portalKey);
	}
	}},{key:"renderPortal",value:function renderPortal(
	
	
	child){
	if(this.renderInPlace){
	return child;
	}
	this.element=child;
	return null;
	}},{key:"render",value:function render()
	
	{var
	children=this.props.children;
	var childProps=children&&children.props||{};
	var child=children&&_react2.default.cloneElement(
	children,(0,_defaults3.default)({},childProps,(0,_omit3.default)(this.props,"children")));
	
	return this.renderPortal(child);
	}}]);return VictoryPortal;}(_react2.default.Component);VictoryPortal.propTypes={children:_propTypes2.default.node};VictoryPortal.contextTypes={portalDeregister:_propTypes2.default.func,portalRegister:_propTypes2.default.func,portalUpdate:_propTypes2.default.func};exports.default=VictoryPortal;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	var _pathHelpers=__webpack_require__(1459);var _pathHelpers2=_interopRequireDefault(_pathHelpers);
	
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Point=function(_React$Component){_inherits(Point,_React$Component);function Point(){_classCallCheck(this,Point);return _possibleConstructorReturn(this,(Point.__proto__||Object.getPrototypeOf(Point)).apply(this,arguments));}_createClass(Point,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{var _calculateAttributes=
	this.calculateAttributes(this.props),style=_calculateAttributes.style,path=_calculateAttributes.path;
	this.style=style;
	this.path=path;
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _calculateAttributes2=
	this.calculateAttributes(nextProps),style=_calculateAttributes2.style,path=_calculateAttributes2.path;
	if(path!==this.path||!(0,_isEqual3.default)(style,this.style)){
	this.style=style;
	this.path=path;
	return true;
	}
	return false;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){var
	style=props.style,datum=props.datum,active=props.active;
	return{
	style:_helpers2.default.evaluateStyle(style,datum,active),
	path:this.getPath(props)};
	
	}},{key:"getPath",value:function getPath(
	
	props){var
	datum=props.datum,active=props.active,x=props.x,y=props.y;
	var pathFunctions={
	circle:_pathHelpers2.default.circle,
	square:_pathHelpers2.default.square,
	diamond:_pathHelpers2.default.diamond,
	triangleDown:_pathHelpers2.default.triangleDown,
	triangleUp:_pathHelpers2.default.triangleUp,
	plus:_pathHelpers2.default.plus,
	star:_pathHelpers2.default.star};
	
	var symbol=_helpers2.default.evaluateProp(props.symbol,datum,active);
	var size=_helpers2.default.evaluateProp(props.size,datum,active);
	return pathFunctions[symbol].call(null,x,y,size);
	}},{key:"renderPoint",value:function renderPoint(
	
	
	path,style,events){var _props=
	this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
	return(
	_react2.default.createElement("path",_extends({},
	events,{
	d:path,
	className:className,
	role:role||"presentation",
	shapeRendering:shapeRendering||"auto",
	style:style})));
	
	
	}},{key:"render",value:function render()
	
	{
	return this.renderPoint(this.path,this.style,this.props.events);
	}}]);return Point;}(_react2.default.Component);Point.propTypes=_extends({},_commonProps2.default,{datum:_propTypes2.default.object,size:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.func]),symbol:_propTypes2.default.oneOfType([_propTypes2.default.oneOf(["circle","diamond","plus","square","star","triangleDown","triangleUp"]),_propTypes2.default.func]),x:_propTypes2.default.number,y:_propTypes2.default.number});exports.default=Point;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _pick2=__webpack_require__(94);var _pick3=_interopRequireDefault(_pick2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _victoryAnimation=__webpack_require__(634);var _victoryAnimation2=_interopRequireDefault(_victoryAnimation);
	var _index=__webpack_require__(53);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	
	VictoryTransition=function(_React$Component){_inherits(VictoryTransition,_React$Component);
	
	
	
	
	
	
	
	
	function VictoryTransition(props){_classCallCheck(this,VictoryTransition);var _this=_possibleConstructorReturn(this,(VictoryTransition.__proto__||Object.getPrototypeOf(VictoryTransition)).call(this,
	props));
	_this.state={
	nodesShouldLoad:false,
	nodesDoneLoad:false};
	
	var child=_this.props.children;
	_this.continuous=child.type&&child.type.continuous===true;
	_this.getTransitionState=_this.getTransitionState.bind(_this);
	_this.getTimer=_this.getTimer.bind(_this);return _this;
	}_createClass(VictoryTransition,[{key:"componentDidMount",value:function componentDidMount()
	
	{
	this.setState({nodesShouldLoad:true});
	}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(
	
	nextProps){var _this2=this;
	this.getTimer().bypassAnimation();
	this.setState(
	this.getTransitionState(this.props,nextProps),function(){return _this2.getTimer().resumeAnimation();});
	
	}},{key:"componentWillUnmount",value:function componentWillUnmount()
	
	{
	this.getTimer().stop();
	}},{key:"getTimer",value:function getTimer()
	
	{
	if(this.context.getTimer){
	return this.context.getTimer();
	}
	if(!this.timer){
	this.timer=new _index.Timer();
	}
	return this.timer;
	}},{key:"getTransitionState",value:function getTransitionState(
	
	props,nextProps){var
	animate=props.animate;
	if(!animate){
	return{};
	}else if(animate.parentState){
	var state=animate.parentState;
	var oldProps=state.nodesWillExit?props:null;
	return{oldProps:oldProps,nextProps:nextProps};
	}else{
	var oldChildren=_react2.default.Children.toArray(props.children);
	var nextChildren=_react2.default.Children.toArray(nextProps.children);var _Transitions$getIniti=
	
	
	
	
	
	_index.Transitions.getInitialTransitionState(oldChildren,nextChildren),nodesWillExit=_Transitions$getIniti.nodesWillExit,nodesWillEnter=_Transitions$getIniti.nodesWillEnter,childrenTransitions=_Transitions$getIniti.childrenTransitions,nodesShouldEnter=_Transitions$getIniti.nodesShouldEnter;
	return{
	nodesWillExit:nodesWillExit,
	nodesWillEnter:nodesWillEnter,
	childrenTransitions:childrenTransitions,
	nodesShouldEnter:nodesShouldEnter,
	oldProps:nodesWillExit?props:null,
	nextProps:nextProps};
	
	}
	}},{key:"getDomainFromChildren",value:function getDomainFromChildren(
	
	props,axis){
	var getChildDomains=function getChildDomains(children){
	return children.reduce(function(memo,child){
	if(child.type&&(0,_isFunction3.default)(child.type.getDomain)){
	var childDomain=child.props&&child.type.getDomain(child.props,axis);
	return childDomain?memo.concat(childDomain):memo;
	}else if(child.props&&child.props.children){
	return memo.concat(getChildDomains(_react2.default.Children.toArray(child.props.children)));
	}
	return memo;
	},[]);
	};
	
	var child=_react2.default.Children.toArray(props.children)[0];
	var childProps=child.props||{};
	var domain=Array.isArray(childProps.domain)?
	childProps.domain:childProps.domain&&childProps.domain[axis];
	if(!childProps.children&&domain){
	return domain;
	}else{
	var childDomains=getChildDomains([child]);
	return childDomains.length===0?
	[0,1]:[_index.Collection.getMinValue(childDomains),_index.Collection.getMaxValue(childDomains)];
	}
	}},{key:"pickProps",value:function pickProps()
	
	{
	if(!this.state){
	return this.props;
	}
	return this.state.nodesWillExit?this.state.oldProps||this.props:this.props;
	}},{key:"pickDomainProps",value:function pickDomainProps(
	
	props){
	var parentState=props.animate&&props.animate.parentState;
	if(parentState&&parentState.nodesWillExit){
	return this.continous||parentState.continuous?
	parentState.nextProps||this.state.nextProps||props:props;
	}
	return this.continuous&&this.state.nodesWillExit?this.state.nextProps||props:props;
	}},{key:"getClipWidth",value:function getClipWidth(
	
	props,child){
	var getDefaultClipWidth=function getDefaultClipWidth(){
	var range=_index.Helpers.getRange(child.props,"x");
	return range?Math.abs(range[1]-range[0]):props.width;
	};
	var clipWidth=this.transitionProps?this.transitionProps.clipWidth:undefined;
	return clipWidth!==undefined?clipWidth:getDefaultClipWidth();
	}},{key:"render",value:function render()
	
	{var _this3=this;
	var props=this.pickProps();
	var getTransitionProps=this.props.animate&&this.props.animate.getTransitions?
	this.props.animate.getTransitions:
	_index.Transitions.getTransitionPropsFactory(
	props,
	this.state,
	function(newState){return _this3.setState(newState);});
	
	var child=_react2.default.Children.toArray(props.children)[0];
	var transitionProps=getTransitionProps(child);
	this.transitionProps=transitionProps;
	var domain={
	x:this.getDomainFromChildren(this.pickDomainProps(props),"x"),
	y:this.getDomainFromChildren(props,"y")};
	
	var clipWidth=this.getClipWidth(props,child);
	var combinedProps=(0,_defaults3.default)({domain:domain,clipWidth:clipWidth},transitionProps,child.props);
	var animationWhitelist=props.animationWhitelist||[];
	var whitelist=animationWhitelist.concat(["clipWidth"]);
	var propsToAnimate=whitelist.length?(0,_pick3.default)(combinedProps,whitelist):combinedProps;
	return(
	_react2.default.createElement(_victoryAnimation2.default,_extends({},combinedProps.animate,{data:propsToAnimate}),
	function(newProps){
	if(child.props.groupComponent){
	var groupComponent=_this3.continuous?
	_react2.default.cloneElement(
	child.props.groupComponent,
	{clipWidth:newProps.clipWidth||0}):
	
	child.props.groupComponent;
	return _react2.default.cloneElement(
	child,(0,_defaults3.default)({animate:null,groupComponent:groupComponent},newProps,combinedProps));
	
	}
	return _react2.default.cloneElement(
	child,(0,_defaults3.default)({animate:null},newProps,combinedProps));
	
	}));
	
	
	}}]);return VictoryTransition;}(_react2.default.Component);VictoryTransition.displayName="VictoryTransition";VictoryTransition.propTypes={animate:_propTypes2.default.object,animationWhitelist:_propTypes2.default.array,children:_propTypes2.default.node};exports.default=VictoryTransition;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _without2=__webpack_require__(160);var _without3=_interopRequireDefault(_without2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _isEmpty2=__webpack_require__(456);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _partial2=__webpack_require__(209);var _partial3=_interopRequireDefault(_partial2);var _merge2=__webpack_require__(158);var _merge3=_interopRequireDefault(_merge2);var _extend6=__webpack_require__(1009);var _extend7=_interopRequireDefault(_extend6);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	
	
	
	
	
	
	getEvents:function getEvents(props,target,eventKey,getScopedEvents){var _this=this;
	
	var getEventsByTarget=function getEventsByTarget(events){
	var getSelectedEvents=function getSelectedEvents(){
	var targetEvents=events.reduce(function(memo,event){
	if(event.target!==undefined){
	return""+event.target===""+target?memo.concat(event):memo;
	}
	return memo.concat(event);
	},[]);
	
	if(eventKey!==undefined&&target!=="parent"){
	return targetEvents.filter(function(obj){
	var targetKeys=obj.eventKey;
	var useKey=function useKey(key){return key?""+key===""+eventKey:true;};
	return Array.isArray(targetKeys)?
	targetKeys.some(function(k){return useKey(k);}):useKey(targetKeys);
	});
	}
	return targetEvents;
	};
	
	var selectedEvents=getSelectedEvents();
	return Array.isArray(selectedEvents)&&selectedEvents.reduce(function(memo,event){
	return event?(0,_assign3.default)(memo,event.eventHandlers):memo;
	},{});
	};
	
	
	
	
	
	var getAllEvents=function getAllEvents(){
	if(Array.isArray(_this.componentEvents)){var _componentEvents;
	return Array.isArray(props.events)?
	(_componentEvents=_this.componentEvents).concat.apply(_componentEvents,_toConsumableArray(props.events)):_this.componentEvents;
	}
	return props.events;
	};
	
	var allEvents=getAllEvents();
	var ownEvents=allEvents&&(0,_isFunction3.default)(getScopedEvents)?
	getScopedEvents(getEventsByTarget(allEvents),target):undefined;
	if(!props.sharedEvents){
	return ownEvents;
	}
	var getSharedEvents=props.sharedEvents.getEvents;
	var sharedEvents=props.sharedEvents.events&&
	getSharedEvents(getEventsByTarget(props.sharedEvents.events),target);
	return(0,_assign3.default)({},sharedEvents,ownEvents);
	},
	
	
	
	
	
	
	getScopedEvents:function getScopedEvents(events,namespace,childType,baseProps){var _this2=this;
	if((0,_isEmpty3.default)(events)){
	return{};
	}
	
	baseProps=baseProps||this.baseProps;
	
	var getTargetProps=function getTargetProps(identifier,type){var
	childName=identifier.childName,target=identifier.target,key=identifier.key;
	var baseType=type==="props"?baseProps:_this2.state;
	var base=childName===undefined||childName===null||!baseType[childName]?
	baseType:baseType[childName];
	return key==="parent"?base.parent:base[key]&&base[key][target];
	};
	
	
	
	var parseEvent=function parseEvent(eventReturn,eventKey){
	var childNames=namespace==="parent"?
	eventReturn.childName:eventReturn.childName||childType;
	var target=eventReturn.target||namespace;
	
	
	var getKeys=function getKeys(childName){
	if(eventReturn.eventKey==="all"){
	return baseProps[childName]?
	(0,_without3.default)(Object.keys(baseProps[childName]),"parent"):
	(0,_without3.default)(Object.keys(baseProps),"parent");
	}else if(eventReturn.eventKey===undefined&&eventKey==="parent"){
	return baseProps[childName]?
	Object.keys(baseProps[childName]):Object.keys(baseProps);
	}
	return eventReturn.eventKey!==undefined?eventReturn.eventKey:eventKey;
	};
	
	
	var getMutationObject=function getMutationObject(key,childName){
	var nullFunction=function nullFunction(){return null;};
	var mutationTargetProps=getTargetProps({childName:childName,key:key,target:target},"props");
	var mutationTargetState=getTargetProps({childName:childName,key:key,target:target},"state");
	var mutation=eventReturn.mutation||nullFunction;
	var mutatedProps=mutation(
	(0,_assign3.default)({},mutationTargetProps,mutationTargetState),baseProps);
	
	var childState=_this2.state[childName]||{};
	var extendState=function extendState(state){
	return target==="parent"?
	(0,_extend7.default)(state[key],mutatedProps):(0,_extend7.default)(state[key],_defineProperty({},target,mutatedProps));
	};
	return childName!==undefined&&childName!==null?
	(0,_extend7.default)(_this2.state,_defineProperty({},
	childName,(0,_extend7.default)(childState,_defineProperty({},key,extendState(childState))))):
	
	(0,_extend7.default)(_this2.state,_defineProperty({},key,extendState(_this2.state)));
	};
	
	
	var getReturnByChild=function getReturnByChild(childName){
	var mutationKeys=getKeys(childName);
	return Array.isArray(mutationKeys)?
	mutationKeys.reduce(function(memo,key){
	return(0,_assign3.default)(memo,getMutationObject(key,childName));
	},{}):
	getMutationObject(mutationKeys,childName);
	};
	
	
	var allChildNames=childNames==="all"?
	(0,_without3.default)(Object.keys(baseProps),"parent"):childNames;
	return Array.isArray(allChildNames)?allChildNames.reduce(function(memo,childName){
	return(0,_assign3.default)(memo,getReturnByChild(childName));
	},{}):getReturnByChild(allChildNames);
	};
	
	
	var parseEventReturn=function parseEventReturn(eventReturn,eventKey){
	return Array.isArray(eventReturn)?
	eventReturn.reduce(function(memo,props){
	memo=(0,_merge3.default)({},memo,parseEvent(props,eventKey));
	return memo;
	},{}):
	parseEvent(eventReturn,eventKey);
	};
	
	var compileCallbacks=function compileCallbacks(eventReturn){
	var getCallback=function getCallback(obj){return(0,_isFunction3.default)(obj.callback)&&obj.callback;};
	var callbacks=Array.isArray(eventReturn)?
	eventReturn.map(function(evtObj){return getCallback(evtObj);}):[getCallback(eventReturn)];
	var callbackArray=callbacks.filter(function(callback){return callback!==false;});
	return callbackArray.length?
	function(){return callbackArray.forEach(function(callback){return callback();});}:undefined;
	};
	
	
	
	var onEvent=function onEvent(evt,childProps,eventKey,eventName){
	var eventReturn=events[eventName](evt,childProps,eventKey,_this2);
	if(eventReturn){
	var callbacks=compileCallbacks(eventReturn);
	_this2.setState(parseEventReturn(eventReturn,eventKey),callbacks);
	}
	};
	
	
	return Object.keys(events).reduce(function(memo,event){
	memo[event]=onEvent;
	return memo;
	},{});
	},
	
	
	
	
	getPartialEvents:function getPartialEvents(events,eventKey,childProps){
	return events?
	Object.keys(events).reduce(function(memo,eventName){
	
	memo[eventName]=(0,_partial3.default)(
	events[eventName],
	_partial3.default.placeholder,
	childProps,
	eventKey,
	eventName);
	
	return memo;
	},{}):
	{};
	},
	
	
	
	
	getEventState:function getEventState(eventKey,namespace,childType){
	if(!childType){
	return eventKey==="parent"?
	this.state[eventKey]&&this.state[eventKey][namespace]||this.state[eventKey]:
	this.state[eventKey]&&this.state[eventKey][namespace];
	}
	return this.state[childType]&&
	this.state[childType][eventKey]&&
	this.state[childType][eventKey][namespace];
	
	},
	
	
	
	
	getComponentEvents:function getComponentEvents(props,components){
	var events=Array.isArray(components)&&components.reduce(function(memo,componentName){var _memo;
	var component=props[componentName];
	var componentEvents=component&&component.type&&component.type.defaultEvents;
	memo=Array.isArray(componentEvents)?(_memo=memo).concat.apply(_memo,_toConsumableArray(componentEvents)):memo;
	return memo;
	},[]);
	return events&&events.length?events:undefined;
	}};

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _d3Timer=__webpack_require__(1474);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var
	
	Timer=function(){
	function Timer(){_classCallCheck(this,Timer);
	this.shouldAnimate=true;
	this.subscribers=[];
	this.loop=this.loop.bind(this);
	this.timer=(0,_d3Timer.timer)(this.loop);
	}_createClass(Timer,[{key:"bypassAnimation",value:function bypassAnimation()
	
	{
	this.shouldAnimate=false;
	}},{key:"resumeAnimation",value:function resumeAnimation()
	
	{
	this.shouldAnimate=true;
	}},{key:"loop",value:function loop()
	
	{
	this.subscribers.forEach(function(s){
	s.callback((0,_d3Timer.now)()-s.startTime,s.duration);
	});
	}},{key:"start",value:function start()
	
	{
	this.timer.start();
	}},{key:"stop",value:function stop()
	
	{
	this.timer.stop();
	}},{key:"subscribe",value:function subscribe(
	
	callback,duration){
	duration=this.shouldAnimate?duration:0;
	return this.subscribers.push({
	startTime:(0,_d3Timer.now)(),
	callback:callback,
	duration:duration});
	
	}},{key:"unsubscribe",value:function unsubscribe(
	
	id){
	if(id!==null){
	delete this.subscribers[id-1];
	}
	}}]);return Timer;}();exports.default=Timer;

/***/ },
/* 642 */
233,
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AxisBottom;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(141);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Axis = __webpack_require__(140);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _orientation = __webpack_require__(99);
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  axisClassName: _propTypes2.default.string,
	  axisLineClassName: _propTypes2.default.string,
	  hideAxisLine: _propTypes2.default.bool,
	  hideTicks: _propTypes2.default.bool,
	  hideZero: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  labelClassName: _propTypes2.default.string,
	  labelOffset: _propTypes2.default.number,
	  labelProps: _propTypes2.default.object,
	  left: _propTypes2.default.number,
	  numTicks: _propTypes2.default.number,
	  rangePadding: _propTypes2.default.number,
	  scale: _propTypes2.default.func.isRequired,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  strokeDasharray: _propTypes2.default.string,
	  tickClassName: _propTypes2.default.string,
	  tickFormat: _propTypes2.default.func,
	  tickLabelProps: _propTypes2.default.func,
	  tickLength: _propTypes2.default.number,
	  tickStroke: _propTypes2.default.string,
	  tickTransform: _propTypes2.default.string,
	  tickValues: _propTypes2.default.array,
	  top: _propTypes2.default.number,
	  children: _propTypes2.default.func
	};
	
	function AxisBottom(_ref) {
	  var children = _ref.children,
	      axisClassName = _ref.axisClassName,
	      axisLineClassName = _ref.axisLineClassName,
	      hideAxisLine = _ref.hideAxisLine,
	      hideTicks = _ref.hideTicks,
	      hideZero = _ref.hideZero,
	      label = _ref.label,
	      labelClassName = _ref.labelClassName,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 8 : _ref$labelOffset,
	      labelProps = _ref.labelProps,
	      left = _ref.left,
	      numTicks = _ref.numTicks,
	      rangePadding = _ref.rangePadding,
	      scale = _ref.scale,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      tickClassName = _ref.tickClassName,
	      tickFormat = _ref.tickFormat,
	      _ref$tickLabelProps = _ref.tickLabelProps,
	      tickLabelProps = _ref$tickLabelProps === undefined ? function (_ref2) {
	    var tick = _ref2.tick,
	        index = _ref2.index;
	    return {
	      dy: '0.25em',
	      fill: 'black',
	      fontFamily: 'Arial',
	      fontSize: 10,
	      textAnchor: 'middle'
	    };
	  } : _ref$tickLabelProps,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      tickStroke = _ref.tickStroke,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      top = _ref.top;
	
	  return _react2.default.createElement(_Axis2.default, {
	    axisClassName: (0, _classnames2.default)('vx-axis-bottom', axisClassName),
	    axisLineClassName: axisLineClassName,
	    hideAxisLine: hideAxisLine,
	    hideTicks: hideTicks,
	    hideZero: hideZero,
	    label: label,
	    labelClassName: labelClassName,
	    labelOffset: labelOffset,
	    labelProps: labelProps,
	    left: left,
	    numTicks: numTicks,
	    orientation: _orientation2.default.bottom,
	    rangePadding: rangePadding,
	    scale: scale,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    tickClassName: tickClassName,
	    tickFormat: tickFormat,
	    tickLabelProps: tickLabelProps,
	    tickLength: tickLength,
	    tickStroke: tickStroke,
	    tickTransform: tickTransform,
	    tickValues: tickValues,
	    top: top,
	    children: children
	  });
	}
	
	AxisBottom.propTypes = propTypes;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AxisLeft;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(141);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Axis = __webpack_require__(140);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _orientation = __webpack_require__(99);
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  axisClassName: _propTypes2.default.string,
	  axisLineClassName: _propTypes2.default.string,
	  hideAxisLine: _propTypes2.default.bool,
	  hideTicks: _propTypes2.default.bool,
	  hideZero: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  labelClassName: _propTypes2.default.string,
	  labelOffset: _propTypes2.default.number,
	  labelProps: _propTypes2.default.object,
	  left: _propTypes2.default.number,
	  numTicks: _propTypes2.default.number,
	  rangePadding: _propTypes2.default.number,
	  scale: _propTypes2.default.func.isRequired,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  strokeDasharray: _propTypes2.default.string,
	  tickClassName: _propTypes2.default.string,
	  tickFormat: _propTypes2.default.func,
	  tickLabelProps: _propTypes2.default.func,
	  tickLength: _propTypes2.default.number,
	  tickStroke: _propTypes2.default.string,
	  tickTransform: _propTypes2.default.string,
	  tickValues: _propTypes2.default.array,
	  top: _propTypes2.default.number,
	  children: _propTypes2.default.func
	};
	
	function AxisLeft(_ref) {
	  var children = _ref.children,
	      axisClassName = _ref.axisClassName,
	      axisLineClassName = _ref.axisLineClassName,
	      hideAxisLine = _ref.hideAxisLine,
	      hideTicks = _ref.hideTicks,
	      hideZero = _ref.hideZero,
	      label = _ref.label,
	      labelClassName = _ref.labelClassName,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 36 : _ref$labelOffset,
	      labelProps = _ref.labelProps,
	      left = _ref.left,
	      numTicks = _ref.numTicks,
	      rangePadding = _ref.rangePadding,
	      scale = _ref.scale,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      tickClassName = _ref.tickClassName,
	      tickFormat = _ref.tickFormat,
	      _ref$tickLabelProps = _ref.tickLabelProps,
	      tickLabelProps = _ref$tickLabelProps === undefined ? function (_ref2) {
	    var tick = _ref2.tick,
	        index = _ref2.index;
	    return {
	      dx: '-0.25em',
	      dy: '0.25em',
	      fill: 'black',
	      fontFamily: 'Arial',
	      fontSize: 10,
	      textAnchor: 'end'
	    };
	  } : _ref$tickLabelProps,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      tickStroke = _ref.tickStroke,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      top = _ref.top;
	
	  return _react2.default.createElement(_Axis2.default, {
	    axisClassName: (0, _classnames2.default)('vx-axis-left', axisClassName),
	    axisLineClassName: axisLineClassName,
	    hideAxisLine: hideAxisLine,
	    hideTicks: hideTicks,
	    hideZero: hideZero,
	    label: label,
	    labelClassName: labelClassName,
	    labelOffset: labelOffset,
	    labelProps: labelProps,
	    left: left,
	    numTicks: numTicks,
	    orientation: _orientation2.default.left,
	    rangePadding: rangePadding,
	    scale: scale,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    tickClassName: tickClassName,
	    tickFormat: tickFormat,
	    tickLabelProps: tickLabelProps,
	    tickLength: tickLength,
	    tickStroke: tickStroke,
	    tickTransform: tickTransform,
	    tickValues: tickValues,
	    top: top,
	    children: children
	  });
	}
	
	AxisLeft.propTypes = propTypes;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AxisRight;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(141);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Axis = __webpack_require__(140);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _orientation = __webpack_require__(99);
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  axisClassName: _propTypes2.default.string,
	  axisLineClassName: _propTypes2.default.string,
	  hideAxisLine: _propTypes2.default.bool,
	  hideTicks: _propTypes2.default.bool,
	  hideZero: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  labelClassName: _propTypes2.default.string,
	  labelOffset: _propTypes2.default.number,
	  labelProps: _propTypes2.default.object,
	  left: _propTypes2.default.number,
	  numTicks: _propTypes2.default.number,
	  rangePadding: _propTypes2.default.number,
	  scale: _propTypes2.default.func.isRequired,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  strokeDasharray: _propTypes2.default.string,
	  tickClassName: _propTypes2.default.string,
	  tickFormat: _propTypes2.default.func,
	  tickLabelProps: _propTypes2.default.func,
	  tickLength: _propTypes2.default.number,
	  tickStroke: _propTypes2.default.string,
	  tickTransform: _propTypes2.default.string,
	  tickValues: _propTypes2.default.array,
	  top: _propTypes2.default.number,
	  children: _propTypes2.default.func
	};
	
	function AxisRight(_ref) {
	  var children = _ref.children,
	      axisClassName = _ref.axisClassName,
	      axisLineClassName = _ref.axisLineClassName,
	      hideAxisLine = _ref.hideAxisLine,
	      hideTicks = _ref.hideTicks,
	      hideZero = _ref.hideZero,
	      label = _ref.label,
	      labelClassName = _ref.labelClassName,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 36 : _ref$labelOffset,
	      labelProps = _ref.labelProps,
	      left = _ref.left,
	      numTicks = _ref.numTicks,
	      rangePadding = _ref.rangePadding,
	      scale = _ref.scale,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      tickClassName = _ref.tickClassName,
	      tickFormat = _ref.tickFormat,
	      _ref$tickLabelProps = _ref.tickLabelProps,
	      tickLabelProps = _ref$tickLabelProps === undefined ? function (_ref2) {
	    var tick = _ref2.tick,
	        index = _ref2.index;
	    return {
	      dx: '0.25em',
	      dy: '0.25em',
	      fill: 'black',
	      fontFamily: 'Arial',
	      fontSize: 10,
	      textAnchor: 'start'
	    };
	  } : _ref$tickLabelProps,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      tickStroke = _ref.tickStroke,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      top = _ref.top;
	
	  return _react2.default.createElement(_Axis2.default, {
	    axisClassName: (0, _classnames2.default)('vx-axis-right', axisClassName),
	    axisLineClassName: axisLineClassName,
	    hideAxisLine: hideAxisLine,
	    hideTicks: hideTicks,
	    hideZero: hideZero,
	    label: label,
	    labelClassName: labelClassName,
	    labelOffset: labelOffset,
	    labelProps: labelProps,
	    left: left,
	    numTicks: numTicks,
	    orientation: _orientation2.default.right,
	    rangePadding: rangePadding,
	    scale: scale,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    tickClassName: tickClassName,
	    tickFormat: tickFormat,
	    tickLabelProps: tickLabelProps,
	    tickLength: tickLength,
	    tickStroke: tickStroke,
	    tickTransform: tickTransform,
	    tickValues: tickValues,
	    top: top,
	    children: children
	  });
	}
	
	AxisRight.propTypes = propTypes;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AxisTop;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(141);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Axis = __webpack_require__(140);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _orientation = __webpack_require__(99);
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  axisClassName: _propTypes2.default.string,
	  axisLineClassName: _propTypes2.default.string,
	  hideAxisLine: _propTypes2.default.bool,
	  hideTicks: _propTypes2.default.bool,
	  hideZero: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  labelClassName: _propTypes2.default.string,
	  labelOffset: _propTypes2.default.number,
	  labelProps: _propTypes2.default.object,
	  left: _propTypes2.default.number,
	  numTicks: _propTypes2.default.number,
	  rangePadding: _propTypes2.default.number,
	  scale: _propTypes2.default.func.isRequired,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  strokeDasharray: _propTypes2.default.string,
	  tickClassName: _propTypes2.default.string,
	  tickFormat: _propTypes2.default.func,
	  tickLabelProps: _propTypes2.default.func,
	  tickLength: _propTypes2.default.number,
	  tickStroke: _propTypes2.default.string,
	  tickTransform: _propTypes2.default.string,
	  tickValues: _propTypes2.default.array,
	  top: _propTypes2.default.number,
	  children: _propTypes2.default.func
	};
	
	function AxisTop(_ref) {
	  var children = _ref.children,
	      axisClassName = _ref.axisClassName,
	      axisLineClassName = _ref.axisLineClassName,
	      hideAxisLine = _ref.hideAxisLine,
	      hideTicks = _ref.hideTicks,
	      hideZero = _ref.hideZero,
	      label = _ref.label,
	      labelClassName = _ref.labelClassName,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 8 : _ref$labelOffset,
	      labelProps = _ref.labelProps,
	      left = _ref.left,
	      numTicks = _ref.numTicks,
	      rangePadding = _ref.rangePadding,
	      scale = _ref.scale,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      tickClassName = _ref.tickClassName,
	      tickFormat = _ref.tickFormat,
	      _ref$tickLabelProps = _ref.tickLabelProps,
	      tickLabelProps = _ref$tickLabelProps === undefined ? function (_ref2) {
	    var tick = _ref2.tick,
	        index = _ref2.index;
	    return {
	      dy: '-0.25em',
	      fill: 'black',
	      fontFamily: 'Arial',
	      fontSize: 10,
	      textAnchor: 'middle'
	    };
	  } : _ref$tickLabelProps,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      tickStroke = _ref.tickStroke,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      top = _ref.top;
	
	  return _react2.default.createElement(_Axis2.default, {
	    axisClassName: (0, _classnames2.default)('vx-axis-top', axisClassName),
	    axisLineClassName: axisLineClassName,
	    hideAxisLine: hideAxisLine,
	    hideTicks: hideTicks,
	    hideZero: hideZero,
	    label: label,
	    labelClassName: labelClassName,
	    labelOffset: labelOffset,
	    labelProps: labelProps,
	    left: left,
	    numTicks: numTicks,
	    orientation: _orientation2.default.top,
	    rangePadding: rangePadding,
	    scale: scale,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    tickClassName: tickClassName,
	    tickFormat: tickFormat,
	    tickLabelProps: tickLabelProps,
	    tickLength: tickLength,
	    tickStroke: tickStroke,
	    tickTransform: tickTransform,
	    tickValues: tickValues,
	    top: top,
	    children: children
	  });
	}
	
	AxisTop.propTypes = propTypes;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Axis = __webpack_require__(140);
	
	Object.defineProperty(exports, 'Axis', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Axis).default;
	  }
	});
	
	var _AxisLeft = __webpack_require__(644);
	
	Object.defineProperty(exports, 'AxisLeft', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AxisLeft).default;
	  }
	});
	
	var _AxisRight = __webpack_require__(645);
	
	Object.defineProperty(exports, 'AxisRight', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AxisRight).default;
	  }
	});
	
	var _AxisTop = __webpack_require__(646);
	
	Object.defineProperty(exports, 'AxisTop', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AxisTop).default;
	  }
	});
	
	var _AxisBottom = __webpack_require__(643);
	
	Object.defineProperty(exports, 'AxisBottom', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AxisBottom).default;
	  }
	});
	
	var _orientation = __webpack_require__(99);
	
	Object.defineProperty(exports, 'Orientation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_orientation).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 648 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = center;
	function center(scale) {
	  var offset = scale.bandwidth() / 2;
	  if (scale.round()) offset = Math.round(offset);
	  return function (d) {
	    return scale(d) + offset;
	  };
	}

/***/ },
/* 649 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = identity;
	function identity(x) {
	  return x;
	}

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = labelTransform;
	
	var _orientation = __webpack_require__(99);
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function labelTransform(_ref) {
	  var labelOffset = _ref.labelOffset,
	      labelProps = _ref.labelProps,
	      orientation = _ref.orientation,
	      range = _ref.range,
	      tickLabelFontSize = _ref.tickLabelFontSize,
	      tickLength = _ref.tickLength;
	
	  var sign = orientation === _orientation2.default.left || orientation === _orientation2.default.top ? -1 : 1;
	
	  var x = void 0,
	      y = void 0,
	      transform = null;
	  if (orientation === _orientation2.default.top || orientation === _orientation2.default.bottom) {
	    x = Math.max.apply(Math, _toConsumableArray(range)) / 2;
	    y = sign * (tickLength + labelOffset + tickLabelFontSize + (orientation === _orientation2.default.bottom ? labelProps.fontSize : 0));
	  } else {
	    x = sign * (Math.max.apply(Math, _toConsumableArray(range)) / 2);
	    y = -(tickLength + labelOffset);
	    transform = 'rotate(' + sign * 90 + ')';
	  }
	
	  return { x: x, y: y, transform: transform };
	}

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(36);
	var invariant = __webpack_require__(4);
	var ReactPropTypesSecret = __webpack_require__(652);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 652 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Group;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Group(_ref) {
	  var _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      transform = _ref.transform,
	      className = _ref.className,
	      children = _ref.children,
	      restProps = _objectWithoutProperties(_ref, ['top', 'left', 'transform', 'className', 'children']);
	
	  return _react2.default.createElement(
	    'g',
	    _extends({
	      className: (0, _classnames2.default)('cx-group', className),
	      transform: transform || 'translate(' + left + ', ' + top + ')'
	    }, restProps),
	    children
	  );
	}

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = genBins;
	
	var _genBin = __webpack_require__(373);
	
	var _genBin2 = _interopRequireDefault(_genBin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function genBins(x, y, bin, count) {
	  return Array(x).fill(1).reduce(function (data, d, i) {
	    return data.concat([{
	      bin: i,
	      bins: (0, _genBin2.default)(y, bin, count)
	    }]);
	  }, []);
	}

/***/ },
/* 655 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = genDateValue;
	function genDateValue(n) {
	  return Array(n).fill(1).map(function (d, i) {
	    return {
	      date: new Date(Date.now() - i * 3600000),
	      value: Math.max(250, Math.random() * 3000 | 0)
	    };
	  });
	}

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.genPointsRange = genPointsRange;
	exports.default = genPoints;
	
	var _d3Random = __webpack_require__(383);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var random = (0, _d3Random.randomNormal)(0, 0.2);
	var sqrt3 = Math.sqrt(3);
	
	function range(n) {
	  return Array(n).fill(1);
	}
	
	function genPointsRange(n, _ref) {
	  var _ref2 = _slicedToArray(_ref, 3),
	      offsetX = _ref2[0],
	      offsetY = _ref2[1],
	      index = _ref2[2];
	
	  return range(n).map(function () {
	    return [random() + offsetX, random() + offsetY, index];
	  });
	}
	
	function genPoints() {
	  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
	
	  return [].concat(_toConsumableArray(genPointsRange(count, [sqrt3, 1, 0])), _toConsumableArray(genPointsRange(count, [-sqrt3, 1, 1])), _toConsumableArray(genPointsRange(count, [0, -1, 2])));
	}

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = genStats;
	
	var _d3Random = __webpack_require__(383);
	
	var random = (0, _d3Random.randomNormal)(4, 3);
	var randomOffset = function randomOffset() {
	  return Math.random() * 10;
	};
	var sampleSize = 1000;
	
	function genStats(number) {
	  var data = [];
	  var i = void 0;
	
	  var _loop = function _loop() {
	    var points = [];
	    var j = void 0;
	    var offset = randomOffset();
	    for (j = 0; j < sampleSize; j += 1) {
	      points.push(offset + random());
	    }
	
	    points.sort(function (a, b) {
	      return a - b;
	    });
	
	    var firstQuartile = points[Math.round(sampleSize / 4)];
	    var thirdQuartile = points[Math.round(3 * sampleSize / 4)];
	    var IQR = thirdQuartile - firstQuartile;
	
	    var min = firstQuartile - 1.5 * IQR;
	    var max = thirdQuartile + 1.5 * IQR;
	
	    var outliers = points.filter(function (p) {
	      return p < min || p > max;
	    });
	    var binWidth = 2 * IQR * Math.pow(sampleSize - outliers.length, -1 / 3);
	    var binNum = Math.round((max - min) / binWidth);
	    var actualBinWidth = (max - min) / binNum;
	
	    var bins = Array(binNum + 2).fill(0);
	    var values = Array(binNum + 2).fill(min);
	
	    for (var _i = 1; _i <= binNum; _i += 1) {
	      values[_i] += actualBinWidth * (_i - 0.5);
	    }
	
	    values[values.length - 1] = max;
	
	    points.filter(function (p) {
	      return p >= min && p <= max;
	    }).forEach(function (p) {
	      bins[Math.floor((p - min) / actualBinWidth) + 1] += 1;
	    });
	
	    var binData = values.map(function (v, i) {
	      return {
	        value: v,
	        count: bins[i]
	      };
	    });
	
	    var boxPlot = {
	      x: 'Statistics ' + i,
	      min: min,
	      firstQuartile: firstQuartile,
	      median: points[Math.round(sampleSize / 2)],
	      thirdQuartile: thirdQuartile,
	      max: max,
	      outliers: outliers
	    };
	
	    data.push({
	      boxPlot: boxPlot,
	      binData: binData
	    });
	  };
	
	  for (i = 0; i < number; i += 1) {
	    _loop();
	  }
	  return data;
	}

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _genDateValue = __webpack_require__(655);
	
	Object.defineProperty(exports, 'genDateValue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_genDateValue).default;
	  }
	});
	
	var _genRandomNormalPoints = __webpack_require__(656);
	
	Object.defineProperty(exports, 'genRandomNormalPoints', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_genRandomNormalPoints).default;
	  }
	});
	
	var _genBin = __webpack_require__(373);
	
	Object.defineProperty(exports, 'genBin', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_genBin).default;
	  }
	});
	
	var _genBins = __webpack_require__(654);
	
	Object.defineProperty(exports, 'genBins', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_genBins).default;
	  }
	});
	
	var _genStats = __webpack_require__(657);
	
	Object.defineProperty(exports, 'genStats', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_genStats).default;
	  }
	});
	
	var _appleStock = __webpack_require__(659);
	
	Object.defineProperty(exports, 'appleStock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_appleStock).default;
	  }
	});
	
	var _letterFrequency = __webpack_require__(665);
	
	Object.defineProperty(exports, 'letterFrequency', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_letterFrequency).default;
	  }
	});
	
	var _browserUsage = __webpack_require__(660);
	
	Object.defineProperty(exports, 'browserUsage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_browserUsage).default;
	  }
	});
	
	var _groupDateValue = __webpack_require__(663);
	
	Object.defineProperty(exports, 'groupDateValue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_groupDateValue).default;
	  }
	});
	
	var _cityTemperature = __webpack_require__(661);
	
	Object.defineProperty(exports, 'cityTemperature', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cityTemperature).default;
	  }
	});
	
	var _lesMiserables = __webpack_require__(664);
	
	Object.defineProperty(exports, 'lesMiserables', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lesMiserables).default;
	  }
	});
	
	var _exoplanets = __webpack_require__(662);
	
	Object.defineProperty(exports, 'exoplanets', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_exoplanets).default;
	  }
	});
	
	var _planets = __webpack_require__(666);
	
	Object.defineProperty(exports, 'planets', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_planets).default;
	  }
	});
	
	var _shakespeare = __webpack_require__(667);
	
	Object.defineProperty(exports, 'shakespeare', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shakespeare).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 659 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{ date: '2007-04-24T07:00:00.000Z', close: 93.24 }, { date: '2007-04-25T07:00:00.000Z', close: 95.35 }, { date: '2007-04-26T07:00:00.000Z', close: 98.84 }, { date: '2007-04-27T07:00:00.000Z', close: 99.92 }, { date: '2007-04-30T07:00:00.000Z', close: 99.8 }, { date: '2007-05-01T07:00:00.000Z', close: 99.47 }, { date: '2007-05-02T07:00:00.000Z', close: 100.39 }, { date: '2007-05-03T07:00:00.000Z', close: 100.4 }, { date: '2007-05-04T07:00:00.000Z', close: 100.81 }, { date: '2007-05-07T07:00:00.000Z', close: 103.92 }, { date: '2007-05-08T07:00:00.000Z', close: 105.06 }, { date: '2007-05-09T07:00:00.000Z', close: 106.88 }, { date: '2007-05-10T07:00:00.000Z', close: 107.34 }, { date: '2007-05-11T07:00:00.000Z', close: 108.74 }, { date: '2007-05-14T07:00:00.000Z', close: 109.36 }, { date: '2007-05-15T07:00:00.000Z', close: 107.52 }, { date: '2007-05-16T07:00:00.000Z', close: 107.34 }, { date: '2007-05-17T07:00:00.000Z', close: 109.44 }, { date: '2007-05-18T07:00:00.000Z', close: 110.02 }, { date: '2007-05-21T07:00:00.000Z', close: 111.98 }, { date: '2007-05-22T07:00:00.000Z', close: 113.54 }, { date: '2007-05-23T07:00:00.000Z', close: 112.89 }, { date: '2007-05-24T07:00:00.000Z', close: 110.69 }, { date: '2007-05-25T07:00:00.000Z', close: 113.62 }, { date: '2007-05-29T07:00:00.000Z', close: 114.35 }, { date: '2007-05-30T07:00:00.000Z', close: 118.77 }, { date: '2007-05-31T07:00:00.000Z', close: 121.19 }, { date: '2007-06-01T07:00:00.000Z', close: 118.4 }, { date: '2007-06-04T07:00:00.000Z', close: 121.33 }, { date: '2007-06-05T07:00:00.000Z', close: 122.67 }, { date: '2007-06-06T07:00:00.000Z', close: 123.64 }, { date: '2007-06-07T07:00:00.000Z', close: 124.07 }, { date: '2007-06-08T07:00:00.000Z', close: 124.49 }, { date: '2007-06-11T07:00:00.000Z', close: 120.19 }, { date: '2007-06-12T07:00:00.000Z', close: 120.38 }, { date: '2007-06-13T07:00:00.000Z', close: 117.5 }, { date: '2007-06-14T07:00:00.000Z', close: 118.75 }, { date: '2007-06-15T07:00:00.000Z', close: 120.5 }, { date: '2007-06-18T07:00:00.000Z', close: 125.09 }, { date: '2007-06-19T07:00:00.000Z', close: 123.66 }, { date: '2007-06-20T07:00:00.000Z', close: 121.55 }, { date: '2007-06-21T07:00:00.000Z', close: 123.9 }, { date: '2007-06-22T07:00:00.000Z', close: 123 }, { date: '2007-06-25T07:00:00.000Z', close: 122.34 }, { date: '2007-06-26T07:00:00.000Z', close: 119.65 }, { date: '2007-06-27T07:00:00.000Z', close: 121.89 }, { date: '2007-06-28T07:00:00.000Z', close: 120.56 }, { date: '2007-06-29T07:00:00.000Z', close: 122.04 }, { date: '2007-07-02T07:00:00.000Z', close: 121.26 }, { date: '2007-07-03T07:00:00.000Z', close: 127.17 }, { date: '2007-07-05T07:00:00.000Z', close: 132.75 }, { date: '2007-07-06T07:00:00.000Z', close: 132.3 }, { date: '2007-07-09T07:00:00.000Z', close: 130.33 }, { date: '2007-07-10T07:00:00.000Z', close: 132.35 }, { date: '2007-07-11T07:00:00.000Z', close: 132.39 }, { date: '2007-07-12T07:00:00.000Z', close: 134.07 }, { date: '2007-07-13T07:00:00.000Z', close: 137.73 }, { date: '2007-07-16T07:00:00.000Z', close: 138.1 }, { date: '2007-07-17T07:00:00.000Z', close: 138.91 }, { date: '2007-07-18T07:00:00.000Z', close: 138.12 }, { date: '2007-07-19T07:00:00.000Z', close: 140 }, { date: '2007-07-20T07:00:00.000Z', close: 143.75 }, { date: '2007-07-23T07:00:00.000Z', close: 143.7 }, { date: '2007-07-24T07:00:00.000Z', close: 134.89 }, { date: '2007-07-25T07:00:00.000Z', close: 137.26 }, { date: '2007-07-26T07:00:00.000Z', close: 146 }, { date: '2007-07-27T07:00:00.000Z', close: 143.85 }, { date: '2007-07-30T07:00:00.000Z', close: 141.43 }, { date: '2007-07-31T07:00:00.000Z', close: 131.76 }, { date: '2007-08-01T07:00:00.000Z', close: 135 }, { date: '2007-08-02T07:00:00.000Z', close: 136.49 }, { date: '2007-08-03T07:00:00.000Z', close: 131.85 }, { date: '2007-08-06T07:00:00.000Z', close: 135.25 }, { date: '2007-08-07T07:00:00.000Z', close: 135.03 }, { date: '2007-08-08T07:00:00.000Z', close: 134.01 }, { date: '2007-08-09T07:00:00.000Z', close: 126.39 }, { date: '2007-08-10T07:00:00.000Z', close: 125 }, { date: '2007-08-13T07:00:00.000Z', close: 127.79 }, { date: '2007-08-14T07:00:00.000Z', close: 124.03 }, { date: '2007-08-15T07:00:00.000Z', close: 119.9 }, { date: '2007-08-16T07:00:00.000Z', close: 117.05 }, { date: '2007-08-17T07:00:00.000Z', close: 122.06 }, { date: '2007-08-20T07:00:00.000Z', close: 122.22 }, { date: '2007-08-21T07:00:00.000Z', close: 127.57 }, { date: '2007-08-22T07:00:00.000Z', close: 132.51 }, { date: '2007-08-23T07:00:00.000Z', close: 131.07 }, { date: '2007-08-24T07:00:00.000Z', close: 135.3 }, { date: '2007-08-27T07:00:00.000Z', close: 132.25 }, { date: '2007-08-28T07:00:00.000Z', close: 126.82 }, { date: '2007-08-29T07:00:00.000Z', close: 134.08 }, { date: '2007-08-30T07:00:00.000Z', close: 136.25 }, { date: '2007-08-31T07:00:00.000Z', close: 138.48 }, { date: '2007-09-04T07:00:00.000Z', close: 144.16 }, { date: '2007-09-05T07:00:00.000Z', close: 136.76 }, { date: '2007-09-06T07:00:00.000Z', close: 135.01 }, { date: '2007-09-07T07:00:00.000Z', close: 131.77 }, { date: '2007-09-10T07:00:00.000Z', close: 136.71 }, { date: '2007-09-11T07:00:00.000Z', close: 135.49 }, { date: '2007-09-12T07:00:00.000Z', close: 136.85 }, { date: '2007-09-13T07:00:00.000Z', close: 137.2 }, { date: '2007-09-14T07:00:00.000Z', close: 138.81 }, { date: '2007-09-17T07:00:00.000Z', close: 138.41 }, { date: '2007-09-18T07:00:00.000Z', close: 140.92 }, { date: '2007-09-19T07:00:00.000Z', close: 140.77 }, { date: '2007-09-20T07:00:00.000Z', close: 140.31 }, { date: '2007-09-21T07:00:00.000Z', close: 144.15 }, { date: '2007-09-24T07:00:00.000Z', close: 148.28 }, { date: '2007-09-25T07:00:00.000Z', close: 153.18 }, { date: '2007-09-26T07:00:00.000Z', close: 152.77 }, { date: '2007-09-27T07:00:00.000Z', close: 154.5 }, { date: '2007-09-28T07:00:00.000Z', close: 153.47 }, { date: '2007-10-01T07:00:00.000Z', close: 156.34 }, { date: '2007-10-02T07:00:00.000Z', close: 158.45 }, { date: '2007-10-03T07:00:00.000Z', close: 157.92 }, { date: '2007-10-04T07:00:00.000Z', close: 156.24 }, { date: '2007-10-05T07:00:00.000Z', close: 161.45 }, { date: '2007-10-08T07:00:00.000Z', close: 167.91 }, { date: '2007-10-09T07:00:00.000Z', close: 167.86 }, { date: '2007-10-10T07:00:00.000Z', close: 166.79 }, { date: '2007-10-11T07:00:00.000Z', close: 162.23 }, { date: '2007-10-12T07:00:00.000Z', close: 167.25 }, { date: '2007-10-15T07:00:00.000Z', close: 166.98 }, { date: '2007-10-16T07:00:00.000Z', close: 169.58 }, { date: '2007-10-17T07:00:00.000Z', close: 172.75 }, { date: '2007-10-18T07:00:00.000Z', close: 173.5 }, { date: '2007-10-19T07:00:00.000Z', close: 170.42 }, { date: '2007-10-22T07:00:00.000Z', close: 174.36 }, { date: '2007-10-23T07:00:00.000Z', close: 186.16 }, { date: '2007-10-24T07:00:00.000Z', close: 185.93 }, { date: '2007-10-25T07:00:00.000Z', close: 182.78 }, { date: '2007-10-26T07:00:00.000Z', close: 184.7 }, { date: '2007-10-29T07:00:00.000Z', close: 185.09 }, { date: '2007-10-30T07:00:00.000Z', close: 187 }, { date: '2007-10-31T07:00:00.000Z', close: 189.95 }, { date: '2007-11-01T07:00:00.000Z', close: 187.44 }, { date: '2007-11-02T07:00:00.000Z', close: 187.87 }, { date: '2007-11-05T08:00:00.000Z', close: 186.18 }, { date: '2007-11-06T08:00:00.000Z', close: 191.79 }, { date: '2007-11-07T08:00:00.000Z', close: 186.3 }, { date: '2007-11-08T08:00:00.000Z', close: 175.47 }, { date: '2007-11-09T08:00:00.000Z', close: 165.37 }, { date: '2007-11-12T08:00:00.000Z', close: 153.76 }, { date: '2007-11-13T08:00:00.000Z', close: 169.96 }, { date: '2007-11-14T08:00:00.000Z', close: 166.11 }, { date: '2007-11-15T08:00:00.000Z', close: 164.3 }, { date: '2007-11-16T08:00:00.000Z', close: 166.39 }, { date: '2007-11-19T08:00:00.000Z', close: 163.95 }, { date: '2007-11-20T08:00:00.000Z', close: 168.85 }, { date: '2007-11-21T08:00:00.000Z', close: 168.46 }, { date: '2007-11-23T08:00:00.000Z', close: 171.54 }, { date: '2007-11-26T08:00:00.000Z', close: 172.54 }, { date: '2007-11-27T08:00:00.000Z', close: 174.81 }, { date: '2007-11-28T08:00:00.000Z', close: 180.22 }, { date: '2007-11-29T08:00:00.000Z', close: 184.29 }, { date: '2007-11-30T08:00:00.000Z', close: 182.22 }, { date: '2007-12-03T08:00:00.000Z', close: 178.86 }, { date: '2007-12-04T08:00:00.000Z', close: 179.81 }, { date: '2007-12-05T08:00:00.000Z', close: 185.5 }, { date: '2007-12-06T08:00:00.000Z', close: 189.95 }, { date: '2007-12-07T08:00:00.000Z', close: 194.3 }, { date: '2007-12-10T08:00:00.000Z', close: 194.21 }, { date: '2007-12-11T08:00:00.000Z', close: 188.54 }, { date: '2007-12-12T08:00:00.000Z', close: 190.86 }, { date: '2007-12-13T08:00:00.000Z', close: 191.83 }, { date: '2007-12-14T08:00:00.000Z', close: 190.39 }, { date: '2007-12-17T08:00:00.000Z', close: 184.4 }, { date: '2007-12-18T08:00:00.000Z', close: 182.98 }, { date: '2007-12-19T08:00:00.000Z', close: 183.12 }, { date: '2007-12-20T08:00:00.000Z', close: 187.21 }, { date: '2007-12-21T08:00:00.000Z', close: 193.91 }, { date: '2007-12-24T08:00:00.000Z', close: 198.8 }, { date: '2007-12-26T08:00:00.000Z', close: 198.95 }, { date: '2007-12-27T08:00:00.000Z', close: 198.57 }, { date: '2007-12-28T08:00:00.000Z', close: 199.83 }, { date: '2007-12-31T08:00:00.000Z', close: 198.08 }, { date: '2008-01-02T08:00:00.000Z', close: 194.84 }, { date: '2008-01-03T08:00:00.000Z', close: 194.93 }, { date: '2008-01-04T08:00:00.000Z', close: 180.05 }, { date: '2008-01-07T08:00:00.000Z', close: 177.64 }, { date: '2008-01-08T08:00:00.000Z', close: 171.25 }, { date: '2008-01-09T08:00:00.000Z', close: 179.4 }, { date: '2008-01-10T08:00:00.000Z', close: 178.02 }, { date: '2008-01-11T08:00:00.000Z', close: 172.69 }, { date: '2008-01-14T08:00:00.000Z', close: 178.78 }, { date: '2008-01-15T08:00:00.000Z', close: 169.04 }, { date: '2008-01-16T08:00:00.000Z', close: 159.64 }, { date: '2008-01-17T08:00:00.000Z', close: 160.89 }, { date: '2008-01-18T08:00:00.000Z', close: 161.36 }, { date: '2008-01-22T08:00:00.000Z', close: 155.64 }, { date: '2008-01-23T08:00:00.000Z', close: 139.07 }, { date: '2008-01-24T08:00:00.000Z', close: 135.6 }, { date: '2008-01-25T08:00:00.000Z', close: 130.01 }, { date: '2008-01-28T08:00:00.000Z', close: 130.01 }, { date: '2008-01-29T08:00:00.000Z', close: 131.54 }, { date: '2008-01-30T08:00:00.000Z', close: 132.18 }, { date: '2008-01-31T08:00:00.000Z', close: 135.36 }, { date: '2008-02-01T08:00:00.000Z', close: 133.75 }, { date: '2008-02-04T08:00:00.000Z', close: 131.65 }, { date: '2008-02-05T08:00:00.000Z', close: 129.36 }, { date: '2008-02-06T08:00:00.000Z', close: 122 }, { date: '2008-02-07T08:00:00.000Z', close: 121.24 }, { date: '2008-02-08T08:00:00.000Z', close: 125.48 }, { date: '2008-02-11T08:00:00.000Z', close: 129.45 }, { date: '2008-02-12T08:00:00.000Z', close: 124.86 }, { date: '2008-02-13T08:00:00.000Z', close: 129.4 }, { date: '2008-02-14T08:00:00.000Z', close: 127.46 }, { date: '2008-02-15T08:00:00.000Z', close: 124.63 }, { date: '2008-02-19T08:00:00.000Z', close: 122.18 }, { date: '2008-02-20T08:00:00.000Z', close: 123.82 }, { date: '2008-02-21T08:00:00.000Z', close: 121.54 }, { date: '2008-02-22T08:00:00.000Z', close: 119.46 }, { date: '2008-02-25T08:00:00.000Z', close: 119.74 }, { date: '2008-02-26T08:00:00.000Z', close: 119.15 }, { date: '2008-02-27T08:00:00.000Z', close: 122.96 }, { date: '2008-02-28T08:00:00.000Z', close: 129.91 }, { date: '2008-02-29T08:00:00.000Z', close: 125.02 }, { date: '2008-03-03T08:00:00.000Z', close: 121.73 }, { date: '2008-03-04T08:00:00.000Z', close: 124.62 }, { date: '2008-03-05T08:00:00.000Z', close: 124.49 }, { date: '2008-03-06T08:00:00.000Z', close: 120.93 }, { date: '2008-03-07T08:00:00.000Z', close: 122.25 }, { date: '2008-03-10T07:00:00.000Z', close: 119.69 }, { date: '2008-03-11T07:00:00.000Z', close: 127.35 }, { date: '2008-03-12T07:00:00.000Z', close: 126.03 }, { date: '2008-03-13T07:00:00.000Z', close: 127.94 }, { date: '2008-03-14T07:00:00.000Z', close: 126.61 }, { date: '2008-03-17T07:00:00.000Z', close: 126.73 }, { date: '2008-03-18T07:00:00.000Z', close: 132.82 }, { date: '2008-03-19T07:00:00.000Z', close: 129.67 }, { date: '2008-03-20T07:00:00.000Z', close: 133.27 }, { date: '2008-03-24T07:00:00.000Z', close: 139.53 }, { date: '2008-03-25T07:00:00.000Z', close: 140.98 }, { date: '2008-03-26T07:00:00.000Z', close: 145.06 }, { date: '2008-03-27T07:00:00.000Z', close: 140.25 }, { date: '2008-03-28T07:00:00.000Z', close: 143.01 }, { date: '2008-03-31T07:00:00.000Z', close: 143.5 }, { date: '2008-04-01T07:00:00.000Z', close: 149.53 }, { date: '2008-04-02T07:00:00.000Z', close: 147.49 }, { date: '2008-04-03T07:00:00.000Z', close: 151.61 }, { date: '2008-04-04T07:00:00.000Z', close: 153.08 }, { date: '2008-04-07T07:00:00.000Z', close: 155.89 }, { date: '2008-04-08T07:00:00.000Z', close: 152.84 }, { date: '2008-04-09T07:00:00.000Z', close: 151.44 }, { date: '2008-04-10T07:00:00.000Z', close: 154.55 }, { date: '2008-04-11T07:00:00.000Z', close: 147.14 }, { date: '2008-04-14T07:00:00.000Z', close: 147.78 }, { date: '2008-04-15T07:00:00.000Z', close: 148.38 }, { date: '2008-04-16T07:00:00.000Z', close: 153.7 }, { date: '2008-04-17T07:00:00.000Z', close: 154.49 }, { date: '2008-04-18T07:00:00.000Z', close: 161.04 }, { date: '2008-04-21T07:00:00.000Z', close: 168.16 }, { date: '2008-04-22T07:00:00.000Z', close: 160.2 }, { date: '2008-04-23T07:00:00.000Z', close: 162.89 }, { date: '2008-04-24T07:00:00.000Z', close: 168.94 }, { date: '2008-04-25T07:00:00.000Z', close: 169.73 }, { date: '2008-04-28T07:00:00.000Z', close: 172.24 }, { date: '2008-04-29T07:00:00.000Z', close: 175.05 }, { date: '2008-04-30T07:00:00.000Z', close: 173.95 }, { date: '2008-05-01T07:00:00.000Z', close: 180 }, { date: '2008-05-02T07:00:00.000Z', close: 180.94 }, { date: '2008-05-05T07:00:00.000Z', close: 184.73 }, { date: '2008-05-06T07:00:00.000Z', close: 186.66 }, { date: '2008-05-07T07:00:00.000Z', close: 182.59 }, { date: '2008-05-08T07:00:00.000Z', close: 185.06 }, { date: '2008-05-09T07:00:00.000Z', close: 183.45 }, { date: '2008-05-12T07:00:00.000Z', close: 188.16 }, { date: '2008-05-13T07:00:00.000Z', close: 189.96 }, { date: '2008-05-14T07:00:00.000Z', close: 186.26 }, { date: '2008-05-15T07:00:00.000Z', close: 189.73 }, { date: '2008-05-16T07:00:00.000Z', close: 187.62 }, { date: '2008-05-19T07:00:00.000Z', close: 183.6 }, { date: '2008-05-20T07:00:00.000Z', close: 185.9 }, { date: '2008-05-21T07:00:00.000Z', close: 178.19 }, { date: '2008-05-22T07:00:00.000Z', close: 177.05 }, { date: '2008-05-23T07:00:00.000Z', close: 181.17 }, { date: '2008-05-27T07:00:00.000Z', close: 186.43 }, { date: '2008-05-28T07:00:00.000Z', close: 187.01 }, { date: '2008-05-29T07:00:00.000Z', close: 186.69 }, { date: '2008-05-30T07:00:00.000Z', close: 188.75 }, { date: '2008-06-02T07:00:00.000Z', close: 186.1 }, { date: '2008-06-03T07:00:00.000Z', close: 185.37 }, { date: '2008-06-04T07:00:00.000Z', close: 185.19 }, { date: '2008-06-05T07:00:00.000Z', close: 189.43 }, { date: '2008-06-06T07:00:00.000Z', close: 185.64 }, { date: '2008-06-09T07:00:00.000Z', close: 181.61 }, { date: '2008-06-10T07:00:00.000Z', close: 185.64 }, { date: '2008-06-11T07:00:00.000Z', close: 180.81 }, { date: '2008-06-12T07:00:00.000Z', close: 173.26 }, { date: '2008-06-13T07:00:00.000Z', close: 172.37 }, { date: '2008-06-16T07:00:00.000Z', close: 176.84 }, { date: '2008-06-17T07:00:00.000Z', close: 181.43 }, { date: '2008-06-18T07:00:00.000Z', close: 178.75 }, { date: '2008-06-19T07:00:00.000Z', close: 180.9 }, { date: '2008-06-20T07:00:00.000Z', close: 175.27 }, { date: '2008-06-23T07:00:00.000Z', close: 173.16 }, { date: '2008-06-24T07:00:00.000Z', close: 173.25 }, { date: '2008-06-25T07:00:00.000Z', close: 177.39 }, { date: '2008-06-26T07:00:00.000Z', close: 168.26 }, { date: '2008-06-27T07:00:00.000Z', close: 170.09 }, { date: '2008-06-30T07:00:00.000Z', close: 167.44 }, { date: '2008-07-01T07:00:00.000Z', close: 174.68 }, { date: '2008-07-02T07:00:00.000Z', close: 168.18 }, { date: '2008-07-03T07:00:00.000Z', close: 170.12 }, { date: '2008-07-07T07:00:00.000Z', close: 175.16 }, { date: '2008-07-08T07:00:00.000Z', close: 179.55 }, { date: '2008-07-09T07:00:00.000Z', close: 174.25 }, { date: '2008-07-10T07:00:00.000Z', close: 176.63 }, { date: '2008-07-11T07:00:00.000Z', close: 172.58 }, { date: '2008-07-14T07:00:00.000Z', close: 173.88 }, { date: '2008-07-15T07:00:00.000Z', close: 169.64 }, { date: '2008-07-16T07:00:00.000Z', close: 172.81 }, { date: '2008-07-17T07:00:00.000Z', close: 171.81 }, { date: '2008-07-18T07:00:00.000Z', close: 165.15 }, { date: '2008-07-21T07:00:00.000Z', close: 166.29 }, { date: '2008-07-22T07:00:00.000Z', close: 162.02 }, { date: '2008-07-23T07:00:00.000Z', close: 166.26 }, { date: '2008-07-24T07:00:00.000Z', close: 159.03 }, { date: '2008-07-25T07:00:00.000Z', close: 162.12 }, { date: '2008-07-28T07:00:00.000Z', close: 154.4 }, { date: '2008-07-29T07:00:00.000Z', close: 157.08 }, { date: '2008-07-30T07:00:00.000Z', close: 159.88 }, { date: '2008-07-31T07:00:00.000Z', close: 158.95 }, { date: '2008-08-01T07:00:00.000Z', close: 156.66 }, { date: '2008-08-04T07:00:00.000Z', close: 153.23 }, { date: '2008-08-05T07:00:00.000Z', close: 160.64 }, { date: '2008-08-06T07:00:00.000Z', close: 164.19 }, { date: '2008-08-07T07:00:00.000Z', close: 163.57 }, { date: '2008-08-08T07:00:00.000Z', close: 169.55 }, { date: '2008-08-11T07:00:00.000Z', close: 173.56 }, { date: '2008-08-12T07:00:00.000Z', close: 176.73 }, { date: '2008-08-13T07:00:00.000Z', close: 179.3 }, { date: '2008-08-14T07:00:00.000Z', close: 179.32 }, { date: '2008-08-15T07:00:00.000Z', close: 175.74 }, { date: '2008-08-18T07:00:00.000Z', close: 175.39 }, { date: '2008-08-19T07:00:00.000Z', close: 173.53 }, { date: '2008-08-20T07:00:00.000Z', close: 175.84 }, { date: '2008-08-21T07:00:00.000Z', close: 174.29 }, { date: '2008-08-22T07:00:00.000Z', close: 176.79 }, { date: '2008-08-25T07:00:00.000Z', close: 172.55 }, { date: '2008-08-26T07:00:00.000Z', close: 173.64 }, { date: '2008-08-27T07:00:00.000Z', close: 174.67 }, { date: '2008-08-28T07:00:00.000Z', close: 173.74 }, { date: '2008-08-29T07:00:00.000Z', close: 169.53 }, { date: '2008-09-02T07:00:00.000Z', close: 166.19 }, { date: '2008-09-03T07:00:00.000Z', close: 166.96 }, { date: '2008-09-04T07:00:00.000Z', close: 161.22 }, { date: '2008-09-05T07:00:00.000Z', close: 160.18 }, { date: '2008-09-08T07:00:00.000Z', close: 157.92 }, { date: '2008-09-09T07:00:00.000Z', close: 151.68 }, { date: '2008-09-10T07:00:00.000Z', close: 151.61 }, { date: '2008-09-11T07:00:00.000Z', close: 152.65 }, { date: '2008-09-12T07:00:00.000Z', close: 148.94 }, { date: '2008-09-15T07:00:00.000Z', close: 140.36 }, { date: '2008-09-16T07:00:00.000Z', close: 139.88 }, { date: '2008-09-17T07:00:00.000Z', close: 127.83 }, { date: '2008-09-18T07:00:00.000Z', close: 134.09 }, { date: '2008-09-19T07:00:00.000Z', close: 140.91 }, { date: '2008-09-22T07:00:00.000Z', close: 131.05 }, { date: '2008-09-23T07:00:00.000Z', close: 126.84 }, { date: '2008-09-24T07:00:00.000Z', close: 128.71 }, { date: '2008-09-25T07:00:00.000Z', close: 131.93 }, { date: '2008-09-26T07:00:00.000Z', close: 128.24 }, { date: '2008-09-29T07:00:00.000Z', close: 105.26 }, { date: '2008-09-30T07:00:00.000Z', close: 113.66 }, { date: '2008-10-01T07:00:00.000Z', close: 109.12 }, { date: '2008-10-02T07:00:00.000Z', close: 100.1 }, { date: '2008-10-03T07:00:00.000Z', close: 97.07 }, { date: '2008-10-06T07:00:00.000Z', close: 98.14 }, { date: '2008-10-07T07:00:00.000Z', close: 89.16 }, { date: '2008-10-08T07:00:00.000Z', close: 89.79 }, { date: '2008-10-09T07:00:00.000Z', close: 88.74 }, { date: '2008-10-10T07:00:00.000Z', close: 96.8 }, { date: '2008-10-13T07:00:00.000Z', close: 110.26 }, { date: '2008-10-14T07:00:00.000Z', close: 104.08 }, { date: '2008-10-15T07:00:00.000Z', close: 97.95 }, { date: '2008-10-16T07:00:00.000Z', close: 101.89 }, { date: '2008-10-17T07:00:00.000Z', close: 97.4 }, { date: '2008-10-20T07:00:00.000Z', close: 98.44 }, { date: '2008-10-21T07:00:00.000Z', close: 91.49 }, { date: '2008-10-22T07:00:00.000Z', close: 96.87 }, { date: '2008-10-23T07:00:00.000Z', close: 98.23 }, { date: '2008-10-24T07:00:00.000Z', close: 96.38 }, { date: '2008-10-27T07:00:00.000Z', close: 92.09 }, { date: '2008-10-28T07:00:00.000Z', close: 99.91 }, { date: '2008-10-29T07:00:00.000Z', close: 104.55 }, { date: '2008-10-30T07:00:00.000Z', close: 111.04 }, { date: '2008-10-31T07:00:00.000Z', close: 107.59 }, { date: '2008-11-03T08:00:00.000Z', close: 106.96 }, { date: '2008-11-04T08:00:00.000Z', close: 110.99 }, { date: '2008-11-05T08:00:00.000Z', close: 103.3 }, { date: '2008-11-06T08:00:00.000Z', close: 99.1 }, { date: '2008-11-07T08:00:00.000Z', close: 98.24 }, { date: '2008-11-10T08:00:00.000Z', close: 95.88 }, { date: '2008-11-11T08:00:00.000Z', close: 94.77 }, { date: '2008-11-12T08:00:00.000Z', close: 90.12 }, { date: '2008-11-13T08:00:00.000Z', close: 96.44 }, { date: '2008-11-14T08:00:00.000Z', close: 90.24 }, { date: '2008-11-17T08:00:00.000Z', close: 88.14 }, { date: '2008-11-18T08:00:00.000Z', close: 89.91 }, { date: '2008-11-19T08:00:00.000Z', close: 86.29 }, { date: '2008-11-20T08:00:00.000Z', close: 80.49 }, { date: '2008-11-21T08:00:00.000Z', close: 82.58 }, { date: '2008-11-24T08:00:00.000Z', close: 92.95 }, { date: '2008-11-25T08:00:00.000Z', close: 90.8 }, { date: '2008-11-26T08:00:00.000Z', close: 95 }, { date: '2008-11-27T08:00:00.000Z', close: 95 }, { date: '2008-11-28T08:00:00.000Z', close: 92.67 }, { date: '2008-12-01T08:00:00.000Z', close: 88.93 }, { date: '2008-12-02T08:00:00.000Z', close: 92.47 }, { date: '2008-12-03T08:00:00.000Z', close: 95.9 }, { date: '2008-12-04T08:00:00.000Z', close: 91.41 }, { date: '2008-12-05T08:00:00.000Z', close: 94 }, { date: '2008-12-08T08:00:00.000Z', close: 99.72 }, { date: '2008-12-09T08:00:00.000Z', close: 100.06 }, { date: '2008-12-10T08:00:00.000Z', close: 98.21 }, { date: '2008-12-11T08:00:00.000Z', close: 95 }, { date: '2008-12-12T08:00:00.000Z', close: 98.27 }, { date: '2008-12-15T08:00:00.000Z', close: 94.75 }, { date: '2008-12-16T08:00:00.000Z', close: 95.43 }, { date: '2008-12-17T08:00:00.000Z', close: 89.16 }, { date: '2008-12-18T08:00:00.000Z', close: 89.43 }, { date: '2008-12-19T08:00:00.000Z', close: 90 }, { date: '2008-12-22T08:00:00.000Z', close: 85.74 }, { date: '2008-12-23T08:00:00.000Z', close: 86.38 }, { date: '2008-12-24T08:00:00.000Z', close: 85.04 }, { date: '2008-12-25T08:00:00.000Z', close: 85.04 }, { date: '2008-12-26T08:00:00.000Z', close: 85.81 }, { date: '2008-12-29T08:00:00.000Z', close: 86.61 }, { date: '2008-12-30T08:00:00.000Z', close: 86.29 }, { date: '2008-12-31T08:00:00.000Z', close: 85.35 }, { date: '2009-01-01T08:00:00.000Z', close: 85.35 }, { date: '2009-01-02T08:00:00.000Z', close: 90.75 }, { date: '2009-01-05T08:00:00.000Z', close: 94.58 }, { date: '2009-01-06T08:00:00.000Z', close: 93.02 }, { date: '2009-01-07T08:00:00.000Z', close: 91.01 }, { date: '2009-01-08T08:00:00.000Z', close: 92.7 }, { date: '2009-01-09T08:00:00.000Z', close: 90.58 }, { date: '2009-01-12T08:00:00.000Z', close: 88.66 }, { date: '2009-01-13T08:00:00.000Z', close: 87.71 }, { date: '2009-01-14T08:00:00.000Z', close: 85.33 }, { date: '2009-01-15T08:00:00.000Z', close: 83.38 }, { date: '2009-01-16T08:00:00.000Z', close: 82.33 }, { date: '2009-01-20T08:00:00.000Z', close: 78.2 }, { date: '2009-01-21T08:00:00.000Z', close: 82.83 }, { date: '2009-01-22T08:00:00.000Z', close: 88.36 }, { date: '2009-01-23T08:00:00.000Z', close: 88.36 }, { date: '2009-01-26T08:00:00.000Z', close: 89.64 }, { date: '2009-01-27T08:00:00.000Z', close: 90.73 }, { date: '2009-01-28T08:00:00.000Z', close: 94.2 }, { date: '2009-01-29T08:00:00.000Z', close: 93 }, { date: '2009-01-30T08:00:00.000Z', close: 90.13 }, { date: '2009-02-02T08:00:00.000Z', close: 91.51 }, { date: '2009-02-03T08:00:00.000Z', close: 92.98 }, { date: '2009-02-04T08:00:00.000Z', close: 93.55 }, { date: '2009-02-05T08:00:00.000Z', close: 96.46 }, { date: '2009-02-06T08:00:00.000Z', close: 99.72 }, { date: '2009-02-09T08:00:00.000Z', close: 102.51 }, { date: '2009-02-10T08:00:00.000Z', close: 97.83 }, { date: '2009-02-11T08:00:00.000Z', close: 96.82 }, { date: '2009-02-12T08:00:00.000Z', close: 99.27 }, { date: '2009-02-13T08:00:00.000Z', close: 99.16 }, { date: '2009-02-17T08:00:00.000Z', close: 94.53 }, { date: '2009-02-18T08:00:00.000Z', close: 94.37 }, { date: '2009-02-19T08:00:00.000Z', close: 90.64 }, { date: '2009-02-20T08:00:00.000Z', close: 91.2 }, { date: '2009-02-23T08:00:00.000Z', close: 86.95 }, { date: '2009-02-24T08:00:00.000Z', close: 90.25 }, { date: '2009-02-25T08:00:00.000Z', close: 91.16 }, { date: '2009-02-26T08:00:00.000Z', close: 89.19 }, { date: '2009-02-27T08:00:00.000Z', close: 89.31 }, { date: '2009-03-02T08:00:00.000Z', close: 87.94 }, { date: '2009-03-03T08:00:00.000Z', close: 88.37 }, { date: '2009-03-04T08:00:00.000Z', close: 91.17 }, { date: '2009-03-05T08:00:00.000Z', close: 88.84 }, { date: '2009-03-06T08:00:00.000Z', close: 85.3 }, { date: '2009-03-09T07:00:00.000Z', close: 83.11 }, { date: '2009-03-10T07:00:00.000Z', close: 88.63 }, { date: '2009-03-11T07:00:00.000Z', close: 92.68 }, { date: '2009-03-12T07:00:00.000Z', close: 96.35 }, { date: '2009-03-13T07:00:00.000Z', close: 95.93 }, { date: '2009-03-16T07:00:00.000Z', close: 95.42 }, { date: '2009-03-17T07:00:00.000Z', close: 99.66 }, { date: '2009-03-18T07:00:00.000Z', close: 101.52 }, { date: '2009-03-19T07:00:00.000Z', close: 101.62 }, { date: '2009-03-20T07:00:00.000Z', close: 101.59 }, { date: '2009-03-23T07:00:00.000Z', close: 107.66 }, { date: '2009-03-24T07:00:00.000Z', close: 106.5 }, { date: '2009-03-25T07:00:00.000Z', close: 106.49 }, { date: '2009-03-26T07:00:00.000Z', close: 109.87 }, { date: '2009-03-27T07:00:00.000Z', close: 106.85 }, { date: '2009-03-30T07:00:00.000Z', close: 104.49 }, { date: '2009-03-31T07:00:00.000Z', close: 105.12 }, { date: '2009-04-01T07:00:00.000Z', close: 108.69 }, { date: '2009-04-02T07:00:00.000Z', close: 112.71 }, { date: '2009-04-03T07:00:00.000Z', close: 115.99 }, { date: '2009-04-06T07:00:00.000Z', close: 118.45 }, { date: '2009-04-07T07:00:00.000Z', close: 115 }, { date: '2009-04-08T07:00:00.000Z', close: 116.32 }, { date: '2009-04-09T07:00:00.000Z', close: 119.57 }, { date: '2009-04-10T07:00:00.000Z', close: 119.57 }, { date: '2009-04-13T07:00:00.000Z', close: 120.22 }, { date: '2009-04-14T07:00:00.000Z', close: 118.31 }, { date: '2009-04-15T07:00:00.000Z', close: 117.64 }, { date: '2009-04-16T07:00:00.000Z', close: 121.45 }, { date: '2009-04-17T07:00:00.000Z', close: 123.42 }, { date: '2009-04-20T07:00:00.000Z', close: 120.5 }, { date: '2009-04-21T07:00:00.000Z', close: 121.76 }, { date: '2009-04-22T07:00:00.000Z', close: 121.51 }, { date: '2009-04-23T07:00:00.000Z', close: 125.4 }, { date: '2009-04-24T07:00:00.000Z', close: 123.9 }, { date: '2009-04-27T07:00:00.000Z', close: 124.73 }, { date: '2009-04-28T07:00:00.000Z', close: 123.9 }, { date: '2009-04-29T07:00:00.000Z', close: 125.14 }, { date: '2009-04-30T07:00:00.000Z', close: 125.83 }, { date: '2009-05-01T07:00:00.000Z', close: 127.24 }, { date: '2009-05-04T07:00:00.000Z', close: 132.07 }, { date: '2009-05-05T07:00:00.000Z', close: 132.71 }, { date: '2009-05-06T07:00:00.000Z', close: 132.5 }, { date: '2009-05-07T07:00:00.000Z', close: 129.06 }, { date: '2009-05-08T07:00:00.000Z', close: 129.19 }, { date: '2009-05-11T07:00:00.000Z', close: 129.57 }, { date: '2009-05-12T07:00:00.000Z', close: 124.42 }, { date: '2009-05-13T07:00:00.000Z', close: 119.49 }, { date: '2009-05-14T07:00:00.000Z', close: 122.95 }, { date: '2009-05-15T07:00:00.000Z', close: 122.42 }, { date: '2009-05-18T07:00:00.000Z', close: 126.65 }, { date: '2009-05-19T07:00:00.000Z', close: 127.45 }, { date: '2009-05-20T07:00:00.000Z', close: 125.87 }, { date: '2009-05-21T07:00:00.000Z', close: 124.18 }, { date: '2009-05-22T07:00:00.000Z', close: 122.5 }, { date: '2009-05-26T07:00:00.000Z', close: 130.78 }, { date: '2009-05-27T07:00:00.000Z', close: 133.05 }, { date: '2009-05-28T07:00:00.000Z', close: 135.07 }, { date: '2009-05-29T07:00:00.000Z', close: 135.81 }, { date: '2009-06-01T07:00:00.000Z', close: 139.35 }, { date: '2009-06-02T07:00:00.000Z', close: 139.49 }, { date: '2009-06-03T07:00:00.000Z', close: 140.95 }, { date: '2009-06-04T07:00:00.000Z', close: 143.74 }, { date: '2009-06-05T07:00:00.000Z', close: 144.67 }, { date: '2009-06-08T07:00:00.000Z', close: 143.85 }, { date: '2009-06-09T07:00:00.000Z', close: 142.72 }, { date: '2009-06-10T07:00:00.000Z', close: 140.25 }, { date: '2009-06-11T07:00:00.000Z', close: 139.95 }, { date: '2009-06-12T07:00:00.000Z', close: 136.97 }, { date: '2009-06-15T07:00:00.000Z', close: 136.09 }, { date: '2009-06-16T07:00:00.000Z', close: 136.35 }, { date: '2009-06-17T07:00:00.000Z', close: 135.58 }, { date: '2009-06-18T07:00:00.000Z', close: 135.88 }, { date: '2009-06-19T07:00:00.000Z', close: 139.48 }, { date: '2009-06-22T07:00:00.000Z', close: 137.37 }, { date: '2009-06-23T07:00:00.000Z', close: 134.01 }, { date: '2009-06-24T07:00:00.000Z', close: 136.22 }, { date: '2009-06-25T07:00:00.000Z', close: 139.86 }, { date: '2009-06-26T07:00:00.000Z', close: 142.44 }, { date: '2009-06-29T07:00:00.000Z', close: 141.97 }, { date: '2009-06-30T07:00:00.000Z', close: 142.43 }, { date: '2009-07-01T07:00:00.000Z', close: 142.83 }, { date: '2009-07-02T07:00:00.000Z', close: 140.02 }, { date: '2009-07-03T07:00:00.000Z', close: 140.02 }, { date: '2009-07-06T07:00:00.000Z', close: 138.61 }, { date: '2009-07-07T07:00:00.000Z', close: 135.4 }, { date: '2009-07-08T07:00:00.000Z', close: 137.22 }, { date: '2009-07-09T07:00:00.000Z', close: 136.36 }, { date: '2009-07-10T07:00:00.000Z', close: 138.52 }, { date: '2009-07-13T07:00:00.000Z', close: 142.34 }, { date: '2009-07-14T07:00:00.000Z', close: 142.27 }, { date: '2009-07-15T07:00:00.000Z', close: 146.88 }, { date: '2009-07-16T07:00:00.000Z', close: 147.52 }, { date: '2009-07-17T07:00:00.000Z', close: 151.75 }, { date: '2009-07-20T07:00:00.000Z', close: 152.91 }, { date: '2009-07-21T07:00:00.000Z', close: 151.51 }, { date: '2009-07-22T07:00:00.000Z', close: 156.74 }, { date: '2009-07-23T07:00:00.000Z', close: 157.82 }, { date: '2009-07-24T07:00:00.000Z', close: 159.99 }, { date: '2009-07-27T07:00:00.000Z', close: 160.1 }, { date: '2009-07-28T07:00:00.000Z', close: 160 }, { date: '2009-07-29T07:00:00.000Z', close: 160.03 }, { date: '2009-07-30T07:00:00.000Z', close: 162.79 }, { date: '2009-07-31T07:00:00.000Z', close: 163.39 }, { date: '2009-08-03T07:00:00.000Z', close: 166.43 }, { date: '2009-08-04T07:00:00.000Z', close: 165.55 }, { date: '2009-08-05T07:00:00.000Z', close: 165.11 }, { date: '2009-08-06T07:00:00.000Z', close: 163.91 }, { date: '2009-08-07T07:00:00.000Z', close: 165.51 }, { date: '2009-08-10T07:00:00.000Z', close: 164.72 }, { date: '2009-08-12T07:00:00.000Z', close: 165.31 }, { date: '2009-08-13T07:00:00.000Z', close: 168.42 }, { date: '2009-08-14T07:00:00.000Z', close: 166.78 }, { date: '2009-08-17T07:00:00.000Z', close: 159.59 }, { date: '2009-08-18T07:00:00.000Z', close: 164 }, { date: '2009-08-19T07:00:00.000Z', close: 164.6 }, { date: '2009-08-20T07:00:00.000Z', close: 166.33 }, { date: '2009-08-21T07:00:00.000Z', close: 169.22 }, { date: '2009-08-24T07:00:00.000Z', close: 169.06 }, { date: '2009-08-25T07:00:00.000Z', close: 169.4 }, { date: '2009-08-26T07:00:00.000Z', close: 167.41 }, { date: '2009-08-27T07:00:00.000Z', close: 169.45 }, { date: '2009-08-28T07:00:00.000Z', close: 170.05 }, { date: '2009-08-31T07:00:00.000Z', close: 168.21 }, { date: '2009-09-01T07:00:00.000Z', close: 165.3 }, { date: '2009-09-02T07:00:00.000Z', close: 165.18 }, { date: '2009-09-03T07:00:00.000Z', close: 166.55 }, { date: '2009-09-04T07:00:00.000Z', close: 170.31 }, { date: '2009-09-08T07:00:00.000Z', close: 172.93 }, { date: '2009-09-09T07:00:00.000Z', close: 171.14 }, { date: '2009-09-10T07:00:00.000Z', close: 172.56 }, { date: '2009-09-11T07:00:00.000Z', close: 172.16 }, { date: '2009-09-14T07:00:00.000Z', close: 173.72 }, { date: '2009-09-15T07:00:00.000Z', close: 175.16 }, { date: '2009-09-16T07:00:00.000Z', close: 181.87 }, { date: '2009-09-17T07:00:00.000Z', close: 184.55 }, { date: '2009-09-18T07:00:00.000Z', close: 185.02 }, { date: '2009-09-21T07:00:00.000Z', close: 184.02 }, { date: '2009-09-22T07:00:00.000Z', close: 184.48 }, { date: '2009-09-23T07:00:00.000Z', close: 185.5 }, { date: '2009-09-24T07:00:00.000Z', close: 183.82 }, { date: '2009-09-25T07:00:00.000Z', close: 182.37 }, { date: '2009-09-28T07:00:00.000Z', close: 186.15 }, { date: '2009-09-29T07:00:00.000Z', close: 185.38 }, { date: '2009-09-30T07:00:00.000Z', close: 185.35 }, { date: '2009-10-01T07:00:00.000Z', close: 180.86 }, { date: '2009-10-02T07:00:00.000Z', close: 184.9 }, { date: '2009-10-05T07:00:00.000Z', close: 186.02 }, { date: '2009-10-06T07:00:00.000Z', close: 190.01 }, { date: '2009-10-07T07:00:00.000Z', close: 190.25 }, { date: '2009-10-08T07:00:00.000Z', close: 189.27 }, { date: '2009-10-09T07:00:00.000Z', close: 190.47 }, { date: '2009-10-12T07:00:00.000Z', close: 190.81 }, { date: '2009-10-13T07:00:00.000Z', close: 190.02 }, { date: '2009-10-14T07:00:00.000Z', close: 191.29 }, { date: '2009-10-15T07:00:00.000Z', close: 190.56 }, { date: '2009-10-16T07:00:00.000Z', close: 188.05 }, { date: '2009-10-19T07:00:00.000Z', close: 189.86 }, { date: '2009-10-20T07:00:00.000Z', close: 198.76 }, { date: '2009-10-21T07:00:00.000Z', close: 204.92 }, { date: '2009-10-22T07:00:00.000Z', close: 205.2 }, { date: '2009-10-23T07:00:00.000Z', close: 203.94 }, { date: '2009-10-26T07:00:00.000Z', close: 202.48 }, { date: '2009-10-27T07:00:00.000Z', close: 197.37 }, { date: '2009-10-28T07:00:00.000Z', close: 192.4 }, { date: '2009-10-29T07:00:00.000Z', close: 196.35 }, { date: '2009-10-30T07:00:00.000Z', close: 188.5 }, { date: '2009-11-02T08:00:00.000Z', close: 189.31 }, { date: '2009-11-03T08:00:00.000Z', close: 188.75 }, { date: '2009-11-04T08:00:00.000Z', close: 190.81 }, { date: '2009-11-05T08:00:00.000Z', close: 194.03 }, { date: '2009-11-06T08:00:00.000Z', close: 194.34 }, { date: '2009-11-09T08:00:00.000Z', close: 201.46 }, { date: '2009-11-10T08:00:00.000Z', close: 202.98 }, { date: '2009-11-11T08:00:00.000Z', close: 203.25 }, { date: '2009-11-12T08:00:00.000Z', close: 201.99 }, { date: '2009-11-13T08:00:00.000Z', close: 204.45 }, { date: '2009-11-16T08:00:00.000Z', close: 206.63 }, { date: '2009-11-17T08:00:00.000Z', close: 207 }, { date: '2009-11-18T08:00:00.000Z', close: 205.96 }, { date: '2009-11-19T08:00:00.000Z', close: 200.51 }, { date: '2009-11-20T08:00:00.000Z', close: 199.92 }, { date: '2009-11-23T08:00:00.000Z', close: 205.88 }, { date: '2009-11-24T08:00:00.000Z', close: 204.44 }, { date: '2009-11-25T08:00:00.000Z', close: 204.19 }, { date: '2009-11-26T08:00:00.000Z', close: 204.19 }, { date: '2009-11-27T08:00:00.000Z', close: 200.59 }, { date: '2009-11-30T08:00:00.000Z', close: 199.91 }, { date: '2009-12-01T08:00:00.000Z', close: 196.97 }, { date: '2009-12-02T08:00:00.000Z', close: 196.23 }, { date: '2009-12-03T08:00:00.000Z', close: 196.48 }, { date: '2009-12-04T08:00:00.000Z', close: 193.32 }, { date: '2009-12-07T08:00:00.000Z', close: 188.95 }, { date: '2009-12-08T08:00:00.000Z', close: 189.87 }, { date: '2009-12-09T08:00:00.000Z', close: 197.8 }, { date: '2009-12-10T08:00:00.000Z', close: 196.43 }, { date: '2009-12-11T08:00:00.000Z', close: 194.67 }, { date: '2009-12-14T08:00:00.000Z', close: 196.98 }, { date: '2009-12-15T08:00:00.000Z', close: 194.17 }, { date: '2009-12-16T08:00:00.000Z', close: 195.03 }, { date: '2009-12-17T08:00:00.000Z', close: 191.86 }, { date: '2009-12-18T08:00:00.000Z', close: 195.43 }, { date: '2009-12-21T08:00:00.000Z', close: 198.23 }, { date: '2009-12-22T08:00:00.000Z', close: 200.36 }, { date: '2009-12-23T08:00:00.000Z', close: 202.1 }, { date: '2009-12-24T08:00:00.000Z', close: 209.04 }, { date: '2009-12-25T08:00:00.000Z', close: 209.04 }, { date: '2009-12-28T08:00:00.000Z', close: 211.61 }, { date: '2009-12-29T08:00:00.000Z', close: 209.1 }, { date: '2009-12-30T08:00:00.000Z', close: 211.64 }, { date: '2009-12-31T08:00:00.000Z', close: 210.73 }, { date: '2010-01-01T08:00:00.000Z', close: 210.73 }, { date: '2010-01-04T08:00:00.000Z', close: 214.01 }, { date: '2010-01-05T08:00:00.000Z', close: 214.38 }, { date: '2010-01-06T08:00:00.000Z', close: 210.97 }, { date: '2010-01-07T08:00:00.000Z', close: 210.58 }, { date: '2010-01-08T08:00:00.000Z', close: 211.98 }, { date: '2010-01-11T08:00:00.000Z', close: 210.11 }, { date: '2010-01-12T08:00:00.000Z', close: 207.72 }, { date: '2010-01-13T08:00:00.000Z', close: 210.65 }, { date: '2010-01-14T08:00:00.000Z', close: 209.43 }, { date: '2010-01-15T08:00:00.000Z', close: 205.93 }, { date: '2010-01-18T08:00:00.000Z', close: 205.93 }, { date: '2010-01-19T08:00:00.000Z', close: 215.04 }, { date: '2010-01-20T08:00:00.000Z', close: 211.72 }, { date: '2010-01-21T08:00:00.000Z', close: 208.07 }, { date: '2010-01-22T08:00:00.000Z', close: 197.75 }, { date: '2010-01-25T08:00:00.000Z', close: 203.08 }, { date: '2010-01-26T08:00:00.000Z', close: 205.94 }, { date: '2010-01-27T08:00:00.000Z', close: 207.88 }, { date: '2010-01-28T08:00:00.000Z', close: 199.29 }, { date: '2010-01-29T08:00:00.000Z', close: 192.06 }, { date: '2010-02-01T08:00:00.000Z', close: 194.73 }, { date: '2010-02-02T08:00:00.000Z', close: 195.86 }, { date: '2010-02-03T08:00:00.000Z', close: 199.23 }, { date: '2010-02-04T08:00:00.000Z', close: 192.05 }, { date: '2010-02-05T08:00:00.000Z', close: 195.46 }, { date: '2010-02-08T08:00:00.000Z', close: 194.12 }, { date: '2010-02-09T08:00:00.000Z', close: 196.19 }, { date: '2010-02-10T08:00:00.000Z', close: 195.12 }, { date: '2010-02-11T08:00:00.000Z', close: 198.67 }, { date: '2010-02-12T08:00:00.000Z', close: 200.38 }, { date: '2010-02-15T08:00:00.000Z', close: 200.38 }, { date: '2010-02-16T08:00:00.000Z', close: 203.4 }, { date: '2010-02-17T08:00:00.000Z', close: 202.55 }, { date: '2010-02-18T08:00:00.000Z', close: 202.93 }, { date: '2010-02-19T08:00:00.000Z', close: 201.67 }, { date: '2010-02-22T08:00:00.000Z', close: 200.42 }, { date: '2010-02-23T08:00:00.000Z', close: 197.06 }, { date: '2010-02-24T08:00:00.000Z', close: 200.66 }, { date: '2010-02-25T08:00:00.000Z', close: 202 }, { date: '2010-02-26T08:00:00.000Z', close: 204.62 }, { date: '2010-03-01T08:00:00.000Z', close: 208.99 }, { date: '2010-03-02T08:00:00.000Z', close: 208.85 }, { date: '2010-03-03T08:00:00.000Z', close: 209.33 }, { date: '2010-03-04T08:00:00.000Z', close: 210.71 }, { date: '2010-03-05T08:00:00.000Z', close: 218.95 }, { date: '2010-03-08T08:00:00.000Z', close: 219.08 }, { date: '2010-03-09T08:00:00.000Z', close: 223.02 }, { date: '2010-03-10T08:00:00.000Z', close: 224.84 }, { date: '2010-03-11T08:00:00.000Z', close: 225.5 }, { date: '2010-03-12T08:00:00.000Z', close: 226.6 }, { date: '2010-03-15T07:00:00.000Z', close: 223.84 }, { date: '2010-03-16T07:00:00.000Z', close: 224.45 }, { date: '2010-03-17T07:00:00.000Z', close: 224.12 }, { date: '2010-03-18T07:00:00.000Z', close: 224.65 }, { date: '2010-03-19T07:00:00.000Z', close: 222.25 }, { date: '2010-03-22T07:00:00.000Z', close: 224.75 }, { date: '2010-03-23T07:00:00.000Z', close: 228.36 }, { date: '2010-03-24T07:00:00.000Z', close: 229.37 }, { date: '2010-03-25T07:00:00.000Z', close: 226.65 }, { date: '2010-03-26T07:00:00.000Z', close: 230.9 }, { date: '2010-03-29T07:00:00.000Z', close: 232.39 }, { date: '2010-03-30T07:00:00.000Z', close: 235.84 }, { date: '2010-03-31T07:00:00.000Z', close: 235 }, { date: '2010-04-01T07:00:00.000Z', close: 235.97 }, { date: '2010-04-02T07:00:00.000Z', close: 235.97 }, { date: '2010-04-05T07:00:00.000Z', close: 238.49 }, { date: '2010-04-06T07:00:00.000Z', close: 239.54 }, { date: '2010-04-07T07:00:00.000Z', close: 240.6 }, { date: '2010-04-08T07:00:00.000Z', close: 239.95 }, { date: '2010-04-09T07:00:00.000Z', close: 241.79 }, { date: '2010-04-12T07:00:00.000Z', close: 242.29 }, { date: '2010-04-13T07:00:00.000Z', close: 242.43 }, { date: '2010-04-14T07:00:00.000Z', close: 245.69 }, { date: '2010-04-15T07:00:00.000Z', close: 248.92 }, { date: '2010-04-16T07:00:00.000Z', close: 247.4 }, { date: '2010-04-19T07:00:00.000Z', close: 247.07 }, { date: '2010-04-20T07:00:00.000Z', close: 244.59 }, { date: '2010-04-21T07:00:00.000Z', close: 259.22 }, { date: '2010-04-22T07:00:00.000Z', close: 266.47 }, { date: '2010-04-23T07:00:00.000Z', close: 270.83 }, { date: '2010-04-26T07:00:00.000Z', close: 269.5 }, { date: '2010-04-27T07:00:00.000Z', close: 262.04 }, { date: '2010-04-28T07:00:00.000Z', close: 261.6 }, { date: '2010-04-29T07:00:00.000Z', close: 268.64 }, { date: '2010-04-30T07:00:00.000Z', close: 261.09 }, { date: '2010-05-03T07:00:00.000Z', close: 266.35 }, { date: '2010-05-04T07:00:00.000Z', close: 258.68 }, { date: '2010-05-05T07:00:00.000Z', close: 255.98 }, { date: '2010-05-06T07:00:00.000Z', close: 246.25 }, { date: '2010-05-07T07:00:00.000Z', close: 235.86 }, { date: '2010-05-10T07:00:00.000Z', close: 253.99 }, { date: '2010-05-11T07:00:00.000Z', close: 256.52 }, { date: '2010-05-12T07:00:00.000Z', close: 262.09 }, { date: '2010-05-13T07:00:00.000Z', close: 258.36 }, { date: '2010-05-14T07:00:00.000Z', close: 253.82 }, { date: '2010-05-17T07:00:00.000Z', close: 254.22 }, { date: '2010-05-18T07:00:00.000Z', close: 252.36 }, { date: '2010-05-19T07:00:00.000Z', close: 248.34 }, { date: '2010-05-20T07:00:00.000Z', close: 237.76 }, { date: '2010-05-21T07:00:00.000Z', close: 242.32 }, { date: '2010-05-24T07:00:00.000Z', close: 246.76 }, { date: '2010-05-25T07:00:00.000Z', close: 245.22 }, { date: '2010-05-26T07:00:00.000Z', close: 244.11 }, { date: '2010-05-27T07:00:00.000Z', close: 253.35 }, { date: '2010-05-28T07:00:00.000Z', close: 256.88 }, { date: '2010-05-31T07:00:00.000Z', close: 256.88 }, { date: '2010-06-01T07:00:00.000Z', close: 260.83 }, { date: '2010-06-02T07:00:00.000Z', close: 263.95 }, { date: '2010-06-03T07:00:00.000Z', close: 263.12 }, { date: '2010-06-04T07:00:00.000Z', close: 255.96 }, { date: '2010-06-07T07:00:00.000Z', close: 250.94 }, { date: '2010-06-08T07:00:00.000Z', close: 249.33 }, { date: '2010-06-09T07:00:00.000Z', close: 243.2 }, { date: '2010-06-10T07:00:00.000Z', close: 250.51 }, { date: '2010-06-11T07:00:00.000Z', close: 253.51 }, { date: '2010-06-14T07:00:00.000Z', close: 254.28 }, { date: '2010-06-15T07:00:00.000Z', close: 259.69 }, { date: '2010-06-16T07:00:00.000Z', close: 267.25 }, { date: '2010-06-17T07:00:00.000Z', close: 271.87 }, { date: '2010-06-18T07:00:00.000Z', close: 274.07 }, { date: '2010-06-21T07:00:00.000Z', close: 270.17 }, { date: '2010-06-22T07:00:00.000Z', close: 273.85 }, { date: '2010-06-23T07:00:00.000Z', close: 270.97 }, { date: '2010-06-24T07:00:00.000Z', close: 269 }, { date: '2010-06-25T07:00:00.000Z', close: 266.7 }, { date: '2010-06-28T07:00:00.000Z', close: 268.3 }, { date: '2010-06-29T07:00:00.000Z', close: 256.17 }, { date: '2010-06-30T07:00:00.000Z', close: 251.53 }, { date: '2010-07-01T07:00:00.000Z', close: 248.48 }, { date: '2010-07-02T07:00:00.000Z', close: 246.94 }, { date: '2010-07-05T07:00:00.000Z', close: 246.94 }, { date: '2010-07-06T07:00:00.000Z', close: 248.63 }, { date: '2010-07-07T07:00:00.000Z', close: 258.66 }, { date: '2010-07-08T07:00:00.000Z', close: 258.09 }, { date: '2010-07-09T07:00:00.000Z', close: 259.62 }, { date: '2010-07-12T07:00:00.000Z', close: 257.28 }, { date: '2010-07-13T07:00:00.000Z', close: 251.8 }, { date: '2010-07-14T07:00:00.000Z', close: 252.73 }, { date: '2010-07-15T07:00:00.000Z', close: 251.45 }, { date: '2010-07-16T07:00:00.000Z', close: 249.9 }, { date: '2010-07-19T07:00:00.000Z', close: 245.58 }, { date: '2010-07-20T07:00:00.000Z', close: 251.89 }, { date: '2010-07-21T07:00:00.000Z', close: 254.24 }, { date: '2010-07-22T07:00:00.000Z', close: 259.02 }, { date: '2010-07-23T07:00:00.000Z', close: 259.94 }, { date: '2010-07-26T07:00:00.000Z', close: 259.28 }, { date: '2010-07-27T07:00:00.000Z', close: 264.08 }, { date: '2010-07-28T07:00:00.000Z', close: 260.96 }, { date: '2010-07-29T07:00:00.000Z', close: 258.11 }, { date: '2010-07-30T07:00:00.000Z', close: 257.25 }, { date: '2010-08-02T07:00:00.000Z', close: 261.85 }, { date: '2010-08-03T07:00:00.000Z', close: 261.93 }, { date: '2010-08-04T07:00:00.000Z', close: 262.98 }, { date: '2010-08-05T07:00:00.000Z', close: 261.7 }, { date: '2010-08-06T07:00:00.000Z', close: 260.09 }, { date: '2010-08-09T07:00:00.000Z', close: 261.75 }, { date: '2010-08-10T07:00:00.000Z', close: 259.41 }, { date: '2010-08-11T07:00:00.000Z', close: 250.19 }, { date: '2010-08-12T07:00:00.000Z', close: 251.79 }, { date: '2010-08-13T07:00:00.000Z', close: 249.1 }, { date: '2010-08-16T07:00:00.000Z', close: 247.64 }, { date: '2010-08-17T07:00:00.000Z', close: 251.97 }, { date: '2010-08-18T07:00:00.000Z', close: 253.07 }, { date: '2010-08-19T07:00:00.000Z', close: 249.88 }, { date: '2010-08-20T07:00:00.000Z', close: 249.64 }, { date: '2010-08-23T07:00:00.000Z', close: 245.8 }, { date: '2010-08-24T07:00:00.000Z', close: 239.93 }, { date: '2010-08-25T07:00:00.000Z', close: 242.89 }, { date: '2010-08-26T07:00:00.000Z', close: 240.28 }, { date: '2010-08-27T07:00:00.000Z', close: 241.62 }, { date: '2010-08-30T07:00:00.000Z', close: 242.5 }, { date: '2010-08-31T07:00:00.000Z', close: 243.1 }, { date: '2010-09-01T07:00:00.000Z', close: 250.33 }, { date: '2010-09-02T07:00:00.000Z', close: 252.17 }, { date: '2010-09-03T07:00:00.000Z', close: 258.77 }, { date: '2010-09-06T07:00:00.000Z', close: 258.77 }, { date: '2010-09-07T07:00:00.000Z', close: 257.81 }, { date: '2010-09-08T07:00:00.000Z', close: 262.92 }, { date: '2010-09-09T07:00:00.000Z', close: 263.07 }, { date: '2010-09-10T07:00:00.000Z', close: 263.41 }, { date: '2010-09-13T07:00:00.000Z', close: 267.04 }, { date: '2010-09-14T07:00:00.000Z', close: 268.06 }, { date: '2010-09-15T07:00:00.000Z', close: 270.22 }, { date: '2010-09-16T07:00:00.000Z', close: 276.57 }, { date: '2010-09-17T07:00:00.000Z', close: 275.37 }, { date: '2010-09-20T07:00:00.000Z', close: 283.23 }, { date: '2010-09-21T07:00:00.000Z', close: 283.77 }, { date: '2010-09-22T07:00:00.000Z', close: 287.75 }, { date: '2010-09-23T07:00:00.000Z', close: 288.92 }, { date: '2010-09-24T07:00:00.000Z', close: 292.32 }, { date: '2010-09-27T07:00:00.000Z', close: 291.16 }, { date: '2010-09-28T07:00:00.000Z', close: 286.86 }, { date: '2010-09-29T07:00:00.000Z', close: 287.37 }, { date: '2010-09-30T07:00:00.000Z', close: 283.75 }, { date: '2010-10-01T07:00:00.000Z', close: 282.52 }, { date: '2010-10-04T07:00:00.000Z', close: 278.64 }, { date: '2010-10-05T07:00:00.000Z', close: 288.94 }, { date: '2010-10-06T07:00:00.000Z', close: 289.19 }, { date: '2010-10-07T07:00:00.000Z', close: 289.22 }, { date: '2010-10-08T07:00:00.000Z', close: 294.07 }, { date: '2010-10-11T07:00:00.000Z', close: 295.36 }, { date: '2010-10-12T07:00:00.000Z', close: 298.54 }, { date: '2010-10-13T07:00:00.000Z', close: 300.14 }, { date: '2010-10-14T07:00:00.000Z', close: 302.31 }, { date: '2010-10-15T07:00:00.000Z', close: 314.74 }, { date: '2010-10-18T07:00:00.000Z', close: 318 }, { date: '2010-10-19T07:00:00.000Z', close: 309.49 }, { date: '2010-10-20T07:00:00.000Z', close: 310.53 }, { date: '2010-10-21T07:00:00.000Z', close: 309.52 }, { date: '2010-10-22T07:00:00.000Z', close: 307.47 }, { date: '2010-10-25T07:00:00.000Z', close: 308.84 }, { date: '2010-10-26T07:00:00.000Z', close: 308.05 }, { date: '2010-10-27T07:00:00.000Z', close: 307.83 }, { date: '2010-10-28T07:00:00.000Z', close: 305.24 }, { date: '2010-10-29T07:00:00.000Z', close: 300.98 }, { date: '2010-11-01T07:00:00.000Z', close: 304.18 }, { date: '2010-11-02T07:00:00.000Z', close: 309.36 }, { date: '2010-11-03T07:00:00.000Z', close: 312.8 }, { date: '2010-11-04T07:00:00.000Z', close: 318.27 }, { date: '2010-11-05T07:00:00.000Z', close: 317.13 }, { date: '2010-11-08T08:00:00.000Z', close: 318.62 }, { date: '2010-11-09T08:00:00.000Z', close: 316.08 }, { date: '2010-11-10T08:00:00.000Z', close: 318.03 }, { date: '2010-11-11T08:00:00.000Z', close: 316.66 }, { date: '2010-11-12T08:00:00.000Z', close: 308.03 }, { date: '2010-11-15T08:00:00.000Z', close: 307.04 }, { date: '2010-11-16T08:00:00.000Z', close: 301.59 }, { date: '2010-11-17T08:00:00.000Z', close: 300.5 }, { date: '2010-11-18T08:00:00.000Z', close: 308.43 }, { date: '2010-11-19T08:00:00.000Z', close: 306.73 }, { date: '2010-11-22T08:00:00.000Z', close: 313.36 }, { date: '2010-11-23T08:00:00.000Z', close: 308.73 }, { date: '2010-11-24T08:00:00.000Z', close: 314.8 }, { date: '2010-11-26T08:00:00.000Z', close: 315 }, { date: '2010-11-29T08:00:00.000Z', close: 316.87 }, { date: '2010-11-30T08:00:00.000Z', close: 311.15 }, { date: '2010-12-01T08:00:00.000Z', close: 316.4 }, { date: '2010-12-02T08:00:00.000Z', close: 318.15 }, { date: '2010-12-03T08:00:00.000Z', close: 317.44 }, { date: '2010-12-06T08:00:00.000Z', close: 320.15 }, { date: '2010-12-07T08:00:00.000Z', close: 318.21 }, { date: '2010-12-08T08:00:00.000Z', close: 321.01 }, { date: '2010-12-09T08:00:00.000Z', close: 319.76 }, { date: '2010-12-10T08:00:00.000Z', close: 320.56 }, { date: '2010-12-13T08:00:00.000Z', close: 321.67 }, { date: '2010-12-14T08:00:00.000Z', close: 320.29 }, { date: '2010-12-15T08:00:00.000Z', close: 320.36 }, { date: '2010-12-16T08:00:00.000Z', close: 321.25 }, { date: '2010-12-17T08:00:00.000Z', close: 320.61 }, { date: '2010-12-20T08:00:00.000Z', close: 322.21 }, { date: '2010-12-21T08:00:00.000Z', close: 324.2 }, { date: '2010-12-22T08:00:00.000Z', close: 325.16 }, { date: '2010-12-23T08:00:00.000Z', close: 323.6 }, { date: '2010-12-27T08:00:00.000Z', close: 324.68 }, { date: '2010-12-28T08:00:00.000Z', close: 325.47 }, { date: '2010-12-29T08:00:00.000Z', close: 325.29 }, { date: '2010-12-30T08:00:00.000Z', close: 323.66 }, { date: '2010-12-31T08:00:00.000Z', close: 322.56 }, { date: '2011-01-03T08:00:00.000Z', close: 329.57 }, { date: '2011-01-04T08:00:00.000Z', close: 331.29 }, { date: '2011-01-05T08:00:00.000Z', close: 334 }, { date: '2011-01-06T08:00:00.000Z', close: 333.73 }, { date: '2011-01-07T08:00:00.000Z', close: 336.12 }, { date: '2011-01-10T08:00:00.000Z', close: 342.46 }, { date: '2011-01-11T08:00:00.000Z', close: 341.64 }, { date: '2011-01-12T08:00:00.000Z', close: 344.42 }, { date: '2011-01-13T08:00:00.000Z', close: 345.68 }, { date: '2011-01-14T08:00:00.000Z', close: 348.48 }, { date: '2011-01-18T08:00:00.000Z', close: 340.65 }, { date: '2011-01-19T08:00:00.000Z', close: 338.84 }, { date: '2011-01-20T08:00:00.000Z', close: 332.68 }, { date: '2011-01-21T08:00:00.000Z', close: 326.72 }, { date: '2011-01-24T08:00:00.000Z', close: 337.45 }, { date: '2011-01-25T08:00:00.000Z', close: 341.4 }, { date: '2011-01-26T08:00:00.000Z', close: 343.85 }, { date: '2011-01-27T08:00:00.000Z', close: 343.21 }, { date: '2011-01-28T08:00:00.000Z', close: 336.1 }, { date: '2011-01-31T08:00:00.000Z', close: 339.32 }, { date: '2011-02-01T08:00:00.000Z', close: 345.03 }, { date: '2011-02-02T08:00:00.000Z', close: 344.32 }, { date: '2011-02-03T08:00:00.000Z', close: 343.44 }, { date: '2011-02-04T08:00:00.000Z', close: 346.5 }, { date: '2011-02-07T08:00:00.000Z', close: 351.88 }, { date: '2011-02-08T08:00:00.000Z', close: 355.2 }, { date: '2011-02-09T08:00:00.000Z', close: 358.16 }, { date: '2011-02-10T08:00:00.000Z', close: 354.54 }, { date: '2011-02-11T08:00:00.000Z', close: 356.85 }, { date: '2011-02-14T08:00:00.000Z', close: 359.18 }, { date: '2011-02-15T08:00:00.000Z', close: 359.9 }, { date: '2011-02-16T08:00:00.000Z', close: 363.13 }, { date: '2011-02-17T08:00:00.000Z', close: 358.3 }, { date: '2011-02-18T08:00:00.000Z', close: 350.56 }, { date: '2011-02-22T08:00:00.000Z', close: 338.61 }, { date: '2011-02-23T08:00:00.000Z', close: 342.62 }, { date: '2011-02-24T08:00:00.000Z', close: 342.88 }, { date: '2011-02-25T08:00:00.000Z', close: 348.16 }, { date: '2011-02-28T08:00:00.000Z', close: 353.21 }, { date: '2011-03-01T08:00:00.000Z', close: 349.31 }, { date: '2011-03-02T08:00:00.000Z', close: 352.12 }, { date: '2011-03-03T08:00:00.000Z', close: 359.56 }, { date: '2011-03-04T08:00:00.000Z', close: 360 }, { date: '2011-03-07T08:00:00.000Z', close: 355.36 }, { date: '2011-03-08T08:00:00.000Z', close: 355.76 }, { date: '2011-03-09T08:00:00.000Z', close: 352.47 }, { date: '2011-03-10T08:00:00.000Z', close: 346.67 }, { date: '2011-03-11T08:00:00.000Z', close: 351.99 }, { date: '2011-03-14T07:00:00.000Z', close: 353.56 }, { date: '2011-03-15T07:00:00.000Z', close: 345.43 }, { date: '2011-03-16T07:00:00.000Z', close: 330.01 }, { date: '2011-03-17T07:00:00.000Z', close: 334.64 }, { date: '2011-03-18T07:00:00.000Z', close: 330.67 }, { date: '2011-03-21T07:00:00.000Z', close: 339.3 }, { date: '2011-03-22T07:00:00.000Z', close: 341.2 }, { date: '2011-03-23T07:00:00.000Z', close: 339.19 }, { date: '2011-03-24T07:00:00.000Z', close: 344.97 }, { date: '2011-03-25T07:00:00.000Z', close: 351.54 }, { date: '2011-03-28T07:00:00.000Z', close: 350.44 }, { date: '2011-03-29T07:00:00.000Z', close: 350.96 }, { date: '2011-03-30T07:00:00.000Z', close: 348.63 }, { date: '2011-03-31T07:00:00.000Z', close: 348.51 }, { date: '2011-04-01T07:00:00.000Z', close: 344.56 }, { date: '2011-04-04T07:00:00.000Z', close: 341.19 }, { date: '2011-04-05T07:00:00.000Z', close: 338.89 }, { date: '2011-04-06T07:00:00.000Z', close: 338.04 }, { date: '2011-04-07T07:00:00.000Z', close: 338.08 }, { date: '2011-04-08T07:00:00.000Z', close: 335.06 }, { date: '2011-04-11T07:00:00.000Z', close: 330.8 }, { date: '2011-04-12T07:00:00.000Z', close: 332.4 }, { date: '2011-04-13T07:00:00.000Z', close: 336.13 }, { date: '2011-04-14T07:00:00.000Z', close: 332.42 }, { date: '2011-04-15T07:00:00.000Z', close: 327.46 }, { date: '2011-04-18T07:00:00.000Z', close: 331.85 }, { date: '2011-04-19T07:00:00.000Z', close: 337.86 }, { date: '2011-04-20T07:00:00.000Z', close: 342.41 }, { date: '2011-04-21T07:00:00.000Z', close: 350.7 }, { date: '2011-04-25T07:00:00.000Z', close: 353.01 }, { date: '2011-04-26T07:00:00.000Z', close: 350.42 }, { date: '2011-04-27T07:00:00.000Z', close: 350.15 }, { date: '2011-04-28T07:00:00.000Z', close: 346.75 }, { date: '2011-04-29T07:00:00.000Z', close: 350.13 }, { date: '2011-05-02T07:00:00.000Z', close: 346.28 }, { date: '2011-05-03T07:00:00.000Z', close: 348.2 }, { date: '2011-05-04T07:00:00.000Z', close: 349.57 }, { date: '2011-05-05T07:00:00.000Z', close: 346.75 }, { date: '2011-05-06T07:00:00.000Z', close: 346.66 }, { date: '2011-05-09T07:00:00.000Z', close: 347.6 }, { date: '2011-05-10T07:00:00.000Z', close: 349.45 }, { date: '2011-05-11T07:00:00.000Z', close: 347.23 }, { date: '2011-05-12T07:00:00.000Z', close: 346.57 }, { date: '2011-05-13T07:00:00.000Z', close: 340.5 }, { date: '2011-05-16T07:00:00.000Z', close: 333.3 }, { date: '2011-05-17T07:00:00.000Z', close: 336.14 }, { date: '2011-05-18T07:00:00.000Z', close: 339.87 }, { date: '2011-05-19T07:00:00.000Z', close: 340.53 }, { date: '2011-05-20T07:00:00.000Z', close: 335.22 }, { date: '2011-05-23T07:00:00.000Z', close: 334.4 }, { date: '2011-05-24T07:00:00.000Z', close: 332.19 }, { date: '2011-05-25T07:00:00.000Z', close: 336.78 }, { date: '2011-05-26T07:00:00.000Z', close: 335 }, { date: '2011-05-27T07:00:00.000Z', close: 337.41 }, { date: '2011-05-31T07:00:00.000Z', close: 347.83 }, { date: '2011-06-01T07:00:00.000Z', close: 345.51 }, { date: '2011-06-02T07:00:00.000Z', close: 346.1 }, { date: '2011-06-03T07:00:00.000Z', close: 343.44 }, { date: '2011-06-06T07:00:00.000Z', close: 338.04 }, { date: '2011-06-07T07:00:00.000Z', close: 332.04 }, { date: '2011-06-08T07:00:00.000Z', close: 332.24 }, { date: '2011-06-09T07:00:00.000Z', close: 331.49 }, { date: '2011-06-10T07:00:00.000Z', close: 325.9 }, { date: '2011-06-13T07:00:00.000Z', close: 326.6 }, { date: '2011-06-14T07:00:00.000Z', close: 332.44 }, { date: '2011-06-15T07:00:00.000Z', close: 326.75 }, { date: '2011-06-16T07:00:00.000Z', close: 325.16 }, { date: '2011-06-17T07:00:00.000Z', close: 320.26 }, { date: '2011-06-20T07:00:00.000Z', close: 315.32 }, { date: '2011-06-21T07:00:00.000Z', close: 325.3 }, { date: '2011-06-22T07:00:00.000Z', close: 322.61 }, { date: '2011-06-23T07:00:00.000Z', close: 331.23 }, { date: '2011-06-24T07:00:00.000Z', close: 326.35 }, { date: '2011-06-27T07:00:00.000Z', close: 332.04 }, { date: '2011-06-28T07:00:00.000Z', close: 335.26 }, { date: '2011-06-29T07:00:00.000Z', close: 334.04 }, { date: '2011-06-30T07:00:00.000Z', close: 335.67 }, { date: '2011-07-01T07:00:00.000Z', close: 343.26 }, { date: '2011-07-05T07:00:00.000Z', close: 349.43 }, { date: '2011-07-06T07:00:00.000Z', close: 351.76 }, { date: '2011-07-07T07:00:00.000Z', close: 357.2 }, { date: '2011-07-08T07:00:00.000Z', close: 359.71 }, { date: '2011-07-11T07:00:00.000Z', close: 354 }, { date: '2011-07-12T07:00:00.000Z', close: 353.75 }, { date: '2011-07-13T07:00:00.000Z', close: 358.02 }, { date: '2011-07-14T07:00:00.000Z', close: 357.77 }, { date: '2011-07-15T07:00:00.000Z', close: 364.92 }, { date: '2011-07-18T07:00:00.000Z', close: 373.8 }, { date: '2011-07-19T07:00:00.000Z', close: 376.85 }, { date: '2011-07-20T07:00:00.000Z', close: 386.9 }, { date: '2011-07-21T07:00:00.000Z', close: 387.29 }, { date: '2011-07-22T07:00:00.000Z', close: 393.3 }, { date: '2011-07-25T07:00:00.000Z', close: 398.5 }, { date: '2011-07-26T07:00:00.000Z', close: 403.41 }, { date: '2011-07-27T07:00:00.000Z', close: 392.59 }, { date: '2011-07-28T07:00:00.000Z', close: 391.82 }, { date: '2011-07-29T07:00:00.000Z', close: 390.48 }, { date: '2011-08-01T07:00:00.000Z', close: 396.75 }, { date: '2011-08-02T07:00:00.000Z', close: 388.91 }, { date: '2011-08-03T07:00:00.000Z', close: 392.57 }, { date: '2011-08-04T07:00:00.000Z', close: 377.37 }, { date: '2011-08-05T07:00:00.000Z', close: 373.62 }, { date: '2011-08-08T07:00:00.000Z', close: 353.21 }, { date: '2011-08-09T07:00:00.000Z', close: 374.01 }, { date: '2011-08-10T07:00:00.000Z', close: 363.69 }, { date: '2011-08-11T07:00:00.000Z', close: 373.7 }, { date: '2011-08-12T07:00:00.000Z', close: 376.99 }, { date: '2011-08-15T07:00:00.000Z', close: 383.41 }, { date: '2011-08-16T07:00:00.000Z', close: 380.48 }, { date: '2011-08-17T07:00:00.000Z', close: 380.44 }, { date: '2011-08-18T07:00:00.000Z', close: 366.05 }, { date: '2011-08-19T07:00:00.000Z', close: 356.03 }, { date: '2011-08-22T07:00:00.000Z', close: 356.44 }, { date: '2011-08-23T07:00:00.000Z', close: 373.6 }, { date: '2011-08-24T07:00:00.000Z', close: 376.18 }, { date: '2011-08-25T07:00:00.000Z', close: 373.72 }, { date: '2011-08-26T07:00:00.000Z', close: 383.58 }, { date: '2011-08-29T07:00:00.000Z', close: 389.97 }, { date: '2011-08-30T07:00:00.000Z', close: 389.99 }, { date: '2011-08-31T07:00:00.000Z', close: 384.83 }, { date: '2011-09-01T07:00:00.000Z', close: 381.03 }, { date: '2011-09-02T07:00:00.000Z', close: 374.05 }, { date: '2011-09-06T07:00:00.000Z', close: 379.74 }, { date: '2011-09-07T07:00:00.000Z', close: 383.93 }, { date: '2011-09-08T07:00:00.000Z', close: 384.14 }, { date: '2011-09-09T07:00:00.000Z', close: 377.48 }, { date: '2011-09-12T07:00:00.000Z', close: 379.94 }, { date: '2011-09-13T07:00:00.000Z', close: 384.62 }, { date: '2011-09-14T07:00:00.000Z', close: 389.3 }, { date: '2011-09-15T07:00:00.000Z', close: 392.96 }, { date: '2011-09-16T07:00:00.000Z', close: 400.5 }, { date: '2011-09-19T07:00:00.000Z', close: 411.63 }, { date: '2011-09-20T07:00:00.000Z', close: 413.45 }, { date: '2011-09-21T07:00:00.000Z', close: 412.14 }, { date: '2011-09-22T07:00:00.000Z', close: 401.82 }, { date: '2011-09-23T07:00:00.000Z', close: 404.3 }, { date: '2011-09-26T07:00:00.000Z', close: 403.17 }, { date: '2011-09-27T07:00:00.000Z', close: 399.26 }, { date: '2011-09-28T07:00:00.000Z', close: 397.01 }, { date: '2011-09-29T07:00:00.000Z', close: 390.57 }, { date: '2011-09-30T07:00:00.000Z', close: 381.32 }, { date: '2011-10-03T07:00:00.000Z', close: 374.6 }, { date: '2011-10-04T07:00:00.000Z', close: 372.5 }, { date: '2011-10-05T07:00:00.000Z', close: 378.25 }, { date: '2011-10-06T07:00:00.000Z', close: 377.37 }, { date: '2011-10-07T07:00:00.000Z', close: 369.8 }, { date: '2011-10-10T07:00:00.000Z', close: 388.81 }, { date: '2011-10-11T07:00:00.000Z', close: 400.29 }, { date: '2011-10-12T07:00:00.000Z', close: 402.19 }, { date: '2011-10-13T07:00:00.000Z', close: 408.43 }, { date: '2011-10-14T07:00:00.000Z', close: 422 }, { date: '2011-10-17T07:00:00.000Z', close: 419.99 }, { date: '2011-10-18T07:00:00.000Z', close: 422.24 }, { date: '2011-10-19T07:00:00.000Z', close: 398.62 }, { date: '2011-10-20T07:00:00.000Z', close: 395.31 }, { date: '2011-10-21T07:00:00.000Z', close: 392.87 }, { date: '2011-10-24T07:00:00.000Z', close: 405.77 }, { date: '2011-10-25T07:00:00.000Z', close: 397.77 }, { date: '2011-10-26T07:00:00.000Z', close: 400.6 }, { date: '2011-10-27T07:00:00.000Z', close: 404.69 }, { date: '2011-10-28T07:00:00.000Z', close: 404.95 }, { date: '2011-10-31T07:00:00.000Z', close: 404.78 }, { date: '2011-11-01T07:00:00.000Z', close: 396.51 }, { date: '2011-11-02T07:00:00.000Z', close: 397.41 }, { date: '2011-11-03T07:00:00.000Z', close: 403.07 }, { date: '2011-11-04T07:00:00.000Z', close: 400.24 }, { date: '2011-11-07T08:00:00.000Z', close: 399.73 }, { date: '2011-11-08T08:00:00.000Z', close: 406.23 }, { date: '2011-11-09T08:00:00.000Z', close: 395.28 }, { date: '2011-11-10T08:00:00.000Z', close: 385.22 }, { date: '2011-11-11T08:00:00.000Z', close: 384.62 }, { date: '2011-11-14T08:00:00.000Z', close: 379.26 }, { date: '2011-11-15T08:00:00.000Z', close: 388.83 }, { date: '2011-11-16T08:00:00.000Z', close: 384.77 }, { date: '2011-11-17T08:00:00.000Z', close: 377.41 }, { date: '2011-11-18T08:00:00.000Z', close: 374.94 }, { date: '2011-11-21T08:00:00.000Z', close: 369.01 }, { date: '2011-11-22T08:00:00.000Z', close: 376.51 }, { date: '2011-11-23T08:00:00.000Z', close: 366.99 }, { date: '2011-11-25T08:00:00.000Z', close: 363.57 }, { date: '2011-11-28T08:00:00.000Z', close: 376.12 }, { date: '2011-11-29T08:00:00.000Z', close: 373.2 }, { date: '2011-11-30T08:00:00.000Z', close: 382.2 }, { date: '2011-12-01T08:00:00.000Z', close: 387.93 }, { date: '2011-12-02T08:00:00.000Z', close: 389.7 }, { date: '2011-12-05T08:00:00.000Z', close: 393.01 }, { date: '2011-12-06T08:00:00.000Z', close: 390.95 }, { date: '2011-12-07T08:00:00.000Z', close: 389.09 }, { date: '2011-12-08T08:00:00.000Z', close: 390.66 }, { date: '2011-12-09T08:00:00.000Z', close: 393.62 }, { date: '2011-12-12T08:00:00.000Z', close: 391.84 }, { date: '2011-12-13T08:00:00.000Z', close: 388.81 }, { date: '2011-12-14T08:00:00.000Z', close: 380.19 }, { date: '2011-12-15T08:00:00.000Z', close: 378.94 }, { date: '2011-12-16T08:00:00.000Z', close: 381.02 }, { date: '2011-12-19T08:00:00.000Z', close: 382.21 }, { date: '2011-12-20T08:00:00.000Z', close: 395.95 }, { date: '2011-12-21T08:00:00.000Z', close: 396.44 }, { date: '2011-12-22T08:00:00.000Z', close: 398.55 }, { date: '2011-12-23T08:00:00.000Z', close: 403.43 }, { date: '2011-12-27T08:00:00.000Z', close: 406.53 }, { date: '2011-12-28T08:00:00.000Z', close: 402.64 }, { date: '2011-12-29T08:00:00.000Z', close: 405.12 }, { date: '2011-12-30T08:00:00.000Z', close: 405 }, { date: '2012-01-03T08:00:00.000Z', close: 411.23 }, { date: '2012-01-04T08:00:00.000Z', close: 413.44 }, { date: '2012-01-05T08:00:00.000Z', close: 418.03 }, { date: '2012-01-06T08:00:00.000Z', close: 422.4 }, { date: '2012-01-09T08:00:00.000Z', close: 421.73 }, { date: '2012-01-10T08:00:00.000Z', close: 423.24 }, { date: '2012-01-11T08:00:00.000Z', close: 422.55 }, { date: '2012-01-12T08:00:00.000Z', close: 421.39 }, { date: '2012-01-13T08:00:00.000Z', close: 419.81 }, { date: '2012-01-17T08:00:00.000Z', close: 424.7 }, { date: '2012-01-18T08:00:00.000Z', close: 429.11 }, { date: '2012-01-19T08:00:00.000Z', close: 427.75 }, { date: '2012-01-20T08:00:00.000Z', close: 420.3 }, { date: '2012-01-23T08:00:00.000Z', close: 427.41 }, { date: '2012-01-24T08:00:00.000Z', close: 420.41 }, { date: '2012-01-25T08:00:00.000Z', close: 446.66 }, { date: '2012-01-26T08:00:00.000Z', close: 444.63 }, { date: '2012-01-27T08:00:00.000Z', close: 447.28 }, { date: '2012-01-30T08:00:00.000Z', close: 453.01 }, { date: '2012-01-31T08:00:00.000Z', close: 456.48 }, { date: '2012-02-01T08:00:00.000Z', close: 456.19 }, { date: '2012-02-02T08:00:00.000Z', close: 455.12 }, { date: '2012-02-03T08:00:00.000Z', close: 459.68 }, { date: '2012-02-06T08:00:00.000Z', close: 463.97 }, { date: '2012-02-07T08:00:00.000Z', close: 468.83 }, { date: '2012-02-08T08:00:00.000Z', close: 476.68 }, { date: '2012-02-09T08:00:00.000Z', close: 493.17 }, { date: '2012-02-10T08:00:00.000Z', close: 493.42 }, { date: '2012-02-13T08:00:00.000Z', close: 502.6 }, { date: '2012-02-14T08:00:00.000Z', close: 509.46 }, { date: '2012-02-15T08:00:00.000Z', close: 497.67 }, { date: '2012-02-16T08:00:00.000Z', close: 502.21 }, { date: '2012-02-17T08:00:00.000Z', close: 502.12 }, { date: '2012-02-21T08:00:00.000Z', close: 514.85 }, { date: '2012-02-22T08:00:00.000Z', close: 513.04 }, { date: '2012-02-23T08:00:00.000Z', close: 516.39 }, { date: '2012-02-24T08:00:00.000Z', close: 522.41 }, { date: '2012-02-27T08:00:00.000Z', close: 525.76 }, { date: '2012-02-28T08:00:00.000Z', close: 535.41 }, { date: '2012-02-29T08:00:00.000Z', close: 542.44 }, { date: '2012-03-01T08:00:00.000Z', close: 544.47 }, { date: '2012-03-02T08:00:00.000Z', close: 545.18 }, { date: '2012-03-05T08:00:00.000Z', close: 533.16 }, { date: '2012-03-06T08:00:00.000Z', close: 530.26 }, { date: '2012-03-07T08:00:00.000Z', close: 530.69 }, { date: '2012-03-08T08:00:00.000Z', close: 541.99 }, { date: '2012-03-09T08:00:00.000Z', close: 545.17 }, { date: '2012-03-12T07:00:00.000Z', close: 552 }, { date: '2012-03-13T07:00:00.000Z', close: 568.1 }, { date: '2012-03-14T07:00:00.000Z', close: 589.58 }, { date: '2012-03-15T07:00:00.000Z', close: 585.56 }, { date: '2012-03-16T07:00:00.000Z', close: 585.57 }, { date: '2012-03-19T07:00:00.000Z', close: 601.1 }, { date: '2012-03-20T07:00:00.000Z', close: 605.96 }, { date: '2012-03-21T07:00:00.000Z', close: 602.5 }, { date: '2012-03-22T07:00:00.000Z', close: 599.34 }, { date: '2012-03-23T07:00:00.000Z', close: 596.05 }, { date: '2012-03-26T07:00:00.000Z', close: 606.98 }, { date: '2012-03-27T07:00:00.000Z', close: 614.48 }, { date: '2012-03-28T07:00:00.000Z', close: 617.62 }, { date: '2012-03-29T07:00:00.000Z', close: 609.86 }, { date: '2012-03-30T07:00:00.000Z', close: 599.55 }, { date: '2012-04-02T07:00:00.000Z', close: 618.63 }, { date: '2012-04-03T07:00:00.000Z', close: 629.32 }, { date: '2012-04-04T07:00:00.000Z', close: 624.31 }, { date: '2012-04-05T07:00:00.000Z', close: 633.68 }, { date: '2012-04-09T07:00:00.000Z', close: 636.23 }, { date: '2012-04-10T07:00:00.000Z', close: 628.44 }, { date: '2012-04-11T07:00:00.000Z', close: 626.2 }, { date: '2012-04-12T07:00:00.000Z', close: 622.77 }, { date: '2012-04-13T07:00:00.000Z', close: 605.23 }, { date: '2012-04-16T07:00:00.000Z', close: 580.13 }, { date: '2012-04-17T07:00:00.000Z', close: 609.7 }, { date: '2012-04-18T07:00:00.000Z', close: 608.34 }, { date: '2012-04-19T07:00:00.000Z', close: 587.44 }, { date: '2012-04-20T07:00:00.000Z', close: 572.98 }, { date: '2012-04-23T07:00:00.000Z', close: 571.7 }, { date: '2012-04-24T07:00:00.000Z', close: 560.28 }, { date: '2012-04-25T07:00:00.000Z', close: 610 }, { date: '2012-04-26T07:00:00.000Z', close: 607.7 }, { date: '2012-04-27T07:00:00.000Z', close: 603 }, { date: '2012-04-30T07:00:00.000Z', close: 583.98 }, { date: '2012-05-01T07:00:00.000Z', close: 582.13 }];

/***/ },
/* 660 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  date: '2015 Jun 15',
	  'Google Chrome': '48.09',
	  'Internet Explorer': '24.14',
	  Firefox: '18.82',
	  Safari: '7.46',
	  'Microsoft Edge': '0.03',
	  Opera: '1.32',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 16',
	  'Google Chrome': '48',
	  'Internet Explorer': '24.19',
	  Firefox: '18.96',
	  Safari: '7.36',
	  'Microsoft Edge': '0.03',
	  Opera: '1.32',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 17',
	  'Google Chrome': '47.87',
	  'Internet Explorer': '24.44',
	  Firefox: '18.91',
	  Safari: '7.27',
	  'Microsoft Edge': '0.03',
	  Opera: '1.36',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 18',
	  'Google Chrome': '48.22',
	  'Internet Explorer': '23.83',
	  Firefox: '19.16',
	  Safari: '7.24',
	  'Microsoft Edge': '0.04',
	  Opera: '1.39',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 19',
	  'Google Chrome': '47.91',
	  'Internet Explorer': '23.86',
	  Firefox: '19.35',
	  Safari: '7.31',
	  'Microsoft Edge': '0.04',
	  Opera: '1.41',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 20',
	  'Google Chrome': '48.78',
	  'Internet Explorer': '21.14',
	  Firefox: '19.66',
	  Safari: '8.42',
	  'Microsoft Edge': '0.05',
	  Opera: '1.83',
	  Mozilla: '0.1',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 21',
	  'Google Chrome': '49.43',
	  'Internet Explorer': '20.55',
	  Firefox: '19.42',
	  Safari: '8.66',
	  'Microsoft Edge': '0.05',
	  Opera: '1.75',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 22',
	  'Google Chrome': '48.98',
	  'Internet Explorer': '23.47',
	  Firefox: '18.84',
	  Safari: '7.25',
	  'Microsoft Edge': '0.04',
	  Opera: '1.28',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 23',
	  'Google Chrome': '48.69',
	  'Internet Explorer': '23.76',
	  Firefox: '18.89',
	  Safari: '7.22',
	  'Microsoft Edge': '0.04',
	  Opera: '1.27',
	  Mozilla: '0.11',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 24',
	  'Google Chrome': '49.17',
	  'Internet Explorer': '23.35',
	  Firefox: '18.91',
	  Safari: '7.09',
	  'Microsoft Edge': '0.04',
	  Opera: '1.32',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 25',
	  'Google Chrome': '49.32',
	  'Internet Explorer': '23.39',
	  Firefox: '18.76',
	  Safari: '7.03',
	  'Microsoft Edge': '0.04',
	  Opera: '1.34',
	  Mozilla: '0.11',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Jun 26',
	  'Google Chrome': '49.39',
	  'Internet Explorer': '23.11',
	  Firefox: '18.84',
	  Safari: '7.14',
	  'Microsoft Edge': '0.04',
	  Opera: '1.37',
	  Mozilla: '0.1',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Jun 27',
	  'Google Chrome': '49.77',
	  'Internet Explorer': '20.68',
	  Firefox: '19.23',
	  Safari: '8.46',
	  'Microsoft Edge': '0.05',
	  Opera: '1.71',
	  Mozilla: '0.09',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 28',
	  'Google Chrome': '50.07',
	  'Internet Explorer': '20.41',
	  Firefox: '18.91',
	  Safari: '8.77',
	  'Microsoft Edge': '0.05',
	  Opera: '1.69',
	  Mozilla: '0.1',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 29',
	  'Google Chrome': '49.32',
	  'Internet Explorer': '23.3',
	  Firefox: '18.54',
	  Safari: '7.4',
	  'Microsoft Edge': '0.04',
	  Opera: '1.27',
	  Mozilla: '0.11',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jun 30',
	  'Google Chrome': '49.99',
	  'Internet Explorer': '22.94',
	  Firefox: '18.45',
	  Safari: '7.07',
	  'Microsoft Edge': '0.07',
	  Opera: '1.32',
	  Mozilla: '0.13',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Jul 1',
	  'Google Chrome': '50.22',
	  'Internet Explorer': '22.79',
	  Firefox: '18.46',
	  Safari: '6.95',
	  'Microsoft Edge': '0.07',
	  Opera: '1.37',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Jul 2',
	  'Google Chrome': '50.33',
	  'Internet Explorer': '22.59',
	  Firefox: '18.74',
	  Safari: '6.69',
	  'Microsoft Edge': '0.07',
	  Opera: '1.45',
	  Mozilla: '0.12',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Jul 3',
	  'Google Chrome': '50.4',
	  'Internet Explorer': '21.29',
	  Firefox: '19.28',
	  Safari: '7.28',
	  'Microsoft Edge': '0.08',
	  Opera: '1.54',
	  Mozilla: '0.11',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Jul 4',
	  'Google Chrome': '50.83',
	  'Internet Explorer': '20.02',
	  Firefox: '19.12',
	  Safari: '7.99',
	  'Microsoft Edge': '0.08',
	  Opera: '1.82',
	  Mozilla: '0.11',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Jul 5',
	  'Google Chrome': '51.6',
	  'Internet Explorer': '19.6',
	  Firefox: '18.43',
	  Safari: '8.58',
	  'Microsoft Edge': '0.07',
	  Opera: '1.62',
	  Mozilla: '0.1',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 6',
	  'Google Chrome': '50.53',
	  'Internet Explorer': '22.64',
	  Firefox: '18.04',
	  Safari: '7.33',
	  'Microsoft Edge': '0.07',
	  Opera: '1.27',
	  Mozilla: '0.11',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 7',
	  'Google Chrome': '50.01',
	  'Internet Explorer': '23.02',
	  Firefox: '18.32',
	  Safari: '7.25',
	  'Microsoft Edge': '0.07',
	  Opera: '1.25',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 8',
	  'Google Chrome': '49.52',
	  'Internet Explorer': '23.17',
	  Firefox: '18.55',
	  Safari: '7.31',
	  'Microsoft Edge': '0.07',
	  Opera: '1.32',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 9',
	  'Google Chrome': '49.31',
	  'Internet Explorer': '23.24',
	  Firefox: '18.7',
	  Safari: '7.22',
	  'Microsoft Edge': '0.08',
	  Opera: '1.39',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 10',
	  'Google Chrome': '48.4',
	  'Internet Explorer': '23.68',
	  Firefox: '18.97',
	  Safari: '7.37',
	  'Microsoft Edge': '0.09',
	  Opera: '1.43',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 11',
	  'Google Chrome': '48.87',
	  'Internet Explorer': '21.22',
	  Firefox: '19.33',
	  Safari: '8.65',
	  'Microsoft Edge': '0.1',
	  Opera: '1.76',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 12',
	  'Google Chrome': '49.4',
	  'Internet Explorer': '20.87',
	  Firefox: '18.84',
	  Safari: '8.99',
	  'Microsoft Edge': '0.09',
	  Opera: '1.73',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 13',
	  'Google Chrome': '49.12',
	  'Internet Explorer': '23.35',
	  Firefox: '18.49',
	  Safari: '7.51',
	  'Microsoft Edge': '0.07',
	  Opera: '1.39',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 14',
	  'Google Chrome': '49.36',
	  'Internet Explorer': '23.2',
	  Firefox: '18.48',
	  Safari: '7.48',
	  'Microsoft Edge': '0.08',
	  Opera: '1.35',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 15',
	  'Google Chrome': '48.88',
	  'Internet Explorer': '23.73',
	  Firefox: '18.46',
	  Safari: '7.44',
	  'Microsoft Edge': '0.09',
	  Opera: '1.34',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 16',
	  'Google Chrome': '48.76',
	  'Internet Explorer': '23.77',
	  Firefox: '18.5',
	  Safari: '7.43',
	  'Microsoft Edge': '0.09',
	  Opera: '1.4',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 17',
	  'Google Chrome': '47.58',
	  'Internet Explorer': '24.54',
	  Firefox: '18.76',
	  Safari: '7.53',
	  'Microsoft Edge': '0.09',
	  Opera: '1.43',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 18',
	  'Google Chrome': '48.06',
	  'Internet Explorer': '21.89',
	  Firefox: '19.14',
	  Safari: '8.99',
	  'Microsoft Edge': '0.11',
	  Opera: '1.74',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 19',
	  'Google Chrome': '48.39',
	  'Internet Explorer': '21.5',
	  Firefox: '19',
	  Safari: '9.23',
	  'Microsoft Edge': '0.11',
	  Opera: '1.7',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 20',
	  'Google Chrome': '48.32',
	  'Internet Explorer': '23.91',
	  Firefox: '18.62',
	  Safari: '7.68',
	  'Microsoft Edge': '0.09',
	  Opera: '1.32',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 21',
	  'Google Chrome': '47.81',
	  'Internet Explorer': '24.98',
	  Firefox: '18.34',
	  Safari: '7.52',
	  'Microsoft Edge': '0.08',
	  Opera: '1.2',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 22',
	  'Google Chrome': '48.28',
	  'Internet Explorer': '24.4',
	  Firefox: '18.45',
	  Safari: '7.44',
	  'Microsoft Edge': '0.08',
	  Opera: '1.29',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 23',
	  'Google Chrome': '48.41',
	  'Internet Explorer': '24.2',
	  Firefox: '18.57',
	  Safari: '7.35',
	  'Microsoft Edge': '0.08',
	  Opera: '1.31',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 24',
	  'Google Chrome': '48.22',
	  'Internet Explorer': '23.96',
	  Firefox: '18.67',
	  Safari: '7.55',
	  'Microsoft Edge': '0.1',
	  Opera: '1.42',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 25',
	  'Google Chrome': '48.11',
	  'Internet Explorer': '21.86',
	  Firefox: '19.28',
	  Safari: '8.88',
	  'Microsoft Edge': '0.1',
	  Opera: '1.65',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Jul 26',
	  'Google Chrome': '48.27',
	  'Internet Explorer': '21.57',
	  Firefox: '19',
	  Safari: '9.38',
	  'Microsoft Edge': '0.11',
	  Opera: '1.59',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 27',
	  'Google Chrome': '48.5',
	  'Internet Explorer': '23.72',
	  Firefox: '18.59',
	  Safari: '7.76',
	  'Microsoft Edge': '0.1',
	  Opera: '1.27',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Jul 28',
	  'Google Chrome': '48.48',
	  'Internet Explorer': '23.95',
	  Firefox: '18.46',
	  Safari: '7.61',
	  'Microsoft Edge': '0.12',
	  Opera: '1.31',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Jul 29',
	  'Google Chrome': '48.33',
	  'Internet Explorer': '23.77',
	  Firefox: '18.56',
	  Safari: '7.51',
	  'Microsoft Edge': '0.42',
	  Opera: '1.33',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Jul 30',
	  'Google Chrome': '47.8',
	  'Internet Explorer': '24.06',
	  Firefox: '18.6',
	  Safari: '7.46',
	  'Microsoft Edge': '0.7',
	  Opera: '1.3',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Jul 31',
	  'Google Chrome': '48.41',
	  'Internet Explorer': '22.9',
	  Firefox: '18.88',
	  Safari: '7.48',
	  'Microsoft Edge': '0.84',
	  Opera: '1.41',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 1',
	  'Google Chrome': '48.8',
	  'Internet Explorer': '20.29',
	  Firefox: '19.16',
	  Safari: '8.75',
	  'Microsoft Edge': '1.16',
	  Opera: '1.75',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 2',
	  'Google Chrome': '48.95',
	  'Internet Explorer': '20.27',
	  Firefox: '18.81',
	  Safari: '9',
	  'Microsoft Edge': '1.23',
	  Opera: '1.65',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 3',
	  'Google Chrome': '49.07',
	  'Internet Explorer': '22.67',
	  Firefox: '18.35',
	  Safari: '7.59',
	  'Microsoft Edge': '0.93',
	  Opera: '1.31',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 4',
	  'Google Chrome': '49.18',
	  'Internet Explorer': '22.72',
	  Firefox: '18.31',
	  Safari: '7.44',
	  'Microsoft Edge': '0.95',
	  Opera: '1.32',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 5',
	  'Google Chrome': '49.56',
	  'Internet Explorer': '22.37',
	  Firefox: '18.28',
	  Safari: '7.38',
	  'Microsoft Edge': '0.99',
	  Opera: '1.34',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 6',
	  'Google Chrome': '49.77',
	  'Internet Explorer': '21.81',
	  Firefox: '18.28',
	  Safari: '7.67',
	  'Microsoft Edge': '1.12',
	  Opera: '1.28',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 7',
	  'Google Chrome': '48.73',
	  'Internet Explorer': '22.63',
	  Firefox: '18.42',
	  Safari: '7.5',
	  'Microsoft Edge': '1.26',
	  Opera: '1.39',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 8',
	  'Google Chrome': '49.6',
	  'Internet Explorer': '18.97',
	  Firefox: '19.11',
	  Safari: '8.79',
	  'Microsoft Edge': '1.69',
	  Opera: '1.74',
	  Mozilla: '0.09',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 9',
	  'Google Chrome': '49.68',
	  'Internet Explorer': '18.85',
	  Firefox: '18.71',
	  Safari: '9.23',
	  'Microsoft Edge': '1.72',
	  Opera: '1.72',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 10',
	  'Google Chrome': '49.11',
	  'Internet Explorer': '22.54',
	  Firefox: '17.97',
	  Safari: '7.64',
	  'Microsoft Edge': '1.28',
	  Opera: '1.39',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 11',
	  'Google Chrome': '49.21',
	  'Internet Explorer': '22.59',
	  Firefox: '17.96',
	  Safari: '7.56',
	  'Microsoft Edge': '1.27',
	  Opera: '1.35',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 12',
	  'Google Chrome': '48.95',
	  'Internet Explorer': '22.68',
	  Firefox: '18.21',
	  Safari: '7.44',
	  'Microsoft Edge': '1.3',
	  Opera: '1.35',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 13',
	  'Google Chrome': '49.31',
	  'Internet Explorer': '22.28',
	  Firefox: '18.19',
	  Safari: '7.32',
	  'Microsoft Edge': '1.31',
	  Opera: '1.51',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 14',
	  'Google Chrome': '49.08',
	  'Internet Explorer': '21.98',
	  Firefox: '18.38',
	  Safari: '7.47',
	  'Microsoft Edge': '1.43',
	  Opera: '1.56',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 15',
	  'Google Chrome': '49.1',
	  'Internet Explorer': '19.47',
	  Firefox: '18.77',
	  Safari: '8.85',
	  'Microsoft Edge': '1.87',
	  Opera: '1.86',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 16',
	  'Google Chrome': '49.5',
	  'Internet Explorer': '19.33',
	  Firefox: '18.42',
	  Safari: '9.12',
	  'Microsoft Edge': '1.83',
	  Opera: '1.72',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 17',
	  'Google Chrome': '49.42',
	  'Internet Explorer': '22.12',
	  Firefox: '18.06',
	  Safari: '7.5',
	  'Microsoft Edge': '1.36',
	  Opera: '1.44',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 18',
	  'Google Chrome': '49.46',
	  'Internet Explorer': '22.16',
	  Firefox: '18.05',
	  Safari: '7.43',
	  'Microsoft Edge': '1.41',
	  Opera: '1.41',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 19',
	  'Google Chrome': '49.51',
	  'Internet Explorer': '22.21',
	  Firefox: '17.93',
	  Safari: '7.46',
	  'Microsoft Edge': '1.39',
	  Opera: '1.42',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 20',
	  'Google Chrome': '49.43',
	  'Internet Explorer': '22.38',
	  Firefox: '17.91',
	  Safari: '7.31',
	  'Microsoft Edge': '1.42',
	  Opera: '1.47',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 21',
	  'Google Chrome': '49.44',
	  'Internet Explorer': '21.79',
	  Firefox: '18.3',
	  Safari: '7.39',
	  'Microsoft Edge': '1.51',
	  Opera: '1.47',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 22',
	  'Google Chrome': '49.79',
	  'Internet Explorer': '19.29',
	  Firefox: '18.51',
	  Safari: '8.67',
	  'Microsoft Edge': '1.91',
	  Opera: '1.74',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 23',
	  'Google Chrome': '50.12',
	  'Internet Explorer': '18.91',
	  Firefox: '18.1',
	  Safari: '9.11',
	  'Microsoft Edge': '1.89',
	  Opera: '1.8',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 24',
	  'Google Chrome': '49.34',
	  'Internet Explorer': '22.2',
	  Firefox: '18.01',
	  Safari: '7.62',
	  'Microsoft Edge': '1.48',
	  Opera: '1.29',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Aug 25',
	  'Google Chrome': '49.21',
	  'Internet Explorer': '22.51',
	  Firefox: '17.91',
	  Safari: '7.47',
	  'Microsoft Edge': '1.47',
	  Opera: '1.38',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 26',
	  'Google Chrome': '49.06',
	  'Internet Explorer': '22.58',
	  Firefox: '17.92',
	  Safari: '7.52',
	  'Microsoft Edge': '1.47',
	  Opera: '1.39',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 27',
	  'Google Chrome': '48.89',
	  'Internet Explorer': '22.63',
	  Firefox: '17.98',
	  Safari: '7.57',
	  'Microsoft Edge': '1.51',
	  Opera: '1.35',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Aug 28',
	  'Google Chrome': '48.69',
	  'Internet Explorer': '22.44',
	  Firefox: '18.2',
	  Safari: '7.56',
	  'Microsoft Edge': '1.61',
	  Opera: '1.43',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 29',
	  'Google Chrome': '48.64',
	  'Internet Explorer': '19.87',
	  Firefox: '18.43',
	  Safari: '9.16',
	  'Microsoft Edge': '2.07',
	  Opera: '1.74',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 30',
	  'Google Chrome': '49.72',
	  'Internet Explorer': '18.84',
	  Firefox: '17.88',
	  Safari: '9.76',
	  'Microsoft Edge': '2.03',
	  Opera: '1.69',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Aug 31',
	  'Google Chrome': '49.43',
	  'Internet Explorer': '21.94',
	  Firefox: '17.82',
	  Safari: '7.87',
	  'Microsoft Edge': '1.57',
	  Opera: '1.31',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 1',
	  'Google Chrome': '49.65',
	  'Internet Explorer': '21.91',
	  Firefox: '17.95',
	  Safari: '7.52',
	  'Microsoft Edge': '1.52',
	  Opera: '1.39',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 2',
	  'Google Chrome': '49.73',
	  'Internet Explorer': '21.85',
	  Firefox: '18.02',
	  Safari: '7.49',
	  'Microsoft Edge': '1.53',
	  Opera: '1.3',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 3',
	  'Google Chrome': '49.59',
	  'Internet Explorer': '21.97',
	  Firefox: '17.88',
	  Safari: '7.6',
	  'Microsoft Edge': '1.58',
	  Opera: '1.31',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 4',
	  'Google Chrome': '49.52',
	  'Internet Explorer': '21.64',
	  Firefox: '18.06',
	  Safari: '7.62',
	  'Microsoft Edge': '1.67',
	  Opera: '1.41',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 5',
	  'Google Chrome': '50.28',
	  'Internet Explorer': '18.93',
	  Firefox: '18.19',
	  Safari: '8.71',
	  'Microsoft Edge': '2.13',
	  Opera: '1.69',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 6',
	  'Google Chrome': '50.25',
	  'Internet Explorer': '18.67',
	  Firefox: '18.2',
	  Safari: '9.04',
	  'Microsoft Edge': '2.09',
	  Opera: '1.67',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 7',
	  'Google Chrome': '49.83',
	  'Internet Explorer': '19.8',
	  Firefox: '18.39',
	  Safari: '8.63',
	  'Microsoft Edge': '1.86',
	  Opera: '1.43',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 8',
	  'Google Chrome': '50',
	  'Internet Explorer': '21.8',
	  Firefox: '17.62',
	  Safari: '7.66',
	  'Microsoft Edge': '1.55',
	  Opera: '1.31',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 9',
	  'Google Chrome': '49.81',
	  'Internet Explorer': '21.89',
	  Firefox: '17.58',
	  Safari: '7.83',
	  'Microsoft Edge': '1.59',
	  Opera: '1.25',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 10',
	  'Google Chrome': '49.65',
	  'Internet Explorer': '21.93',
	  Firefox: '17.74',
	  Safari: '7.82',
	  'Microsoft Edge': '1.6',
	  Opera: '1.19',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 11',
	  'Google Chrome': '49.75',
	  'Internet Explorer': '21.71',
	  Firefox: '17.88',
	  Safari: '7.64',
	  'Microsoft Edge': '1.67',
	  Opera: '1.29',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 12',
	  'Google Chrome': '49.86',
	  'Internet Explorer': '19.04',
	  Firefox: '17.96',
	  Safari: '9.3',
	  'Microsoft Edge': '2.21',
	  Opera: '1.56',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 13',
	  'Google Chrome': '50.1',
	  'Internet Explorer': '18.71',
	  Firefox: '17.76',
	  Safari: '9.69',
	  'Microsoft Edge': '2.19',
	  Opera: '1.49',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 14',
	  'Google Chrome': '49.91',
	  'Internet Explorer': '21.55',
	  Firefox: '17.87',
	  Safari: '7.74',
	  'Microsoft Edge': '1.66',
	  Opera: '1.21',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 15',
	  'Google Chrome': '50.1',
	  'Internet Explorer': '21.34',
	  Firefox: '17.96',
	  Safari: '7.63',
	  'Microsoft Edge': '1.66',
	  Opera: '1.25',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 16',
	  'Google Chrome': '50.6',
	  'Internet Explorer': '21.53',
	  Firefox: '17.44',
	  Safari: '7.56',
	  'Microsoft Edge': '1.59',
	  Opera: '1.23',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 17',
	  'Google Chrome': '50.59',
	  'Internet Explorer': '21.59',
	  Firefox: '17.55',
	  Safari: '7.37',
	  'Microsoft Edge': '1.6',
	  Opera: '1.24',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 18',
	  'Google Chrome': '50.57',
	  'Internet Explorer': '21.75',
	  Firefox: '17.43',
	  Safari: '7.17',
	  'Microsoft Edge': '1.7',
	  Opera: '1.32',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Sep 19',
	  'Google Chrome': '51.33',
	  'Internet Explorer': '18.77',
	  Firefox: '17.63',
	  Safari: '8.37',
	  'Microsoft Edge': '2.17',
	  Opera: '1.66',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 20',
	  'Google Chrome': '51.41',
	  'Internet Explorer': '18.15',
	  Firefox: '17.55',
	  Safari: '9.09',
	  'Microsoft Edge': '2.17',
	  Opera: '1.58',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 21',
	  'Google Chrome': '50.76',
	  'Internet Explorer': '21.38',
	  Firefox: '17.41',
	  Safari: '7.52',
	  'Microsoft Edge': '1.67',
	  Opera: '1.22',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 22',
	  'Google Chrome': '50.6',
	  'Internet Explorer': '21.48',
	  Firefox: '17.55',
	  Safari: '7.41',
	  'Microsoft Edge': '1.7',
	  Opera: '1.22',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Sep 23',
	  'Google Chrome': '50.56',
	  'Internet Explorer': '21.5',
	  Firefox: '17.52',
	  Safari: '7.42',
	  'Microsoft Edge': '1.71',
	  Opera: '1.25',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Sep 24',
	  'Google Chrome': '50.66',
	  'Internet Explorer': '21.34',
	  Firefox: '17.52',
	  Safari: '7.45',
	  'Microsoft Edge': '1.7',
	  Opera: '1.29',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Sep 25',
	  'Google Chrome': '50.87',
	  'Internet Explorer': '20.84',
	  Firefox: '17.84',
	  Safari: '7.24',
	  'Microsoft Edge': '1.78',
	  Opera: '1.39',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 26',
	  'Google Chrome': '51.66',
	  'Internet Explorer': '17.77',
	  Firefox: '18.01',
	  Safari: '8.52',
	  'Microsoft Edge': '2.28',
	  Opera: '1.71',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 27',
	  'Google Chrome': '51.99',
	  'Internet Explorer': '17.24',
	  Firefox: '17.71',
	  Safari: '9.17',
	  'Microsoft Edge': '2.25',
	  Opera: '1.6',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Sep 28',
	  'Google Chrome': '50.77',
	  'Internet Explorer': '21.23',
	  Firefox: '17.52',
	  Safari: '7.49',
	  'Microsoft Edge': '1.73',
	  Opera: '1.22',
	  Mozilla: '0.03',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 29',
	  'Google Chrome': '50.75',
	  'Internet Explorer': '21.39',
	  Firefox: '17.47',
	  Safari: '7.38',
	  'Microsoft Edge': '1.74',
	  Opera: '1.22',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Sep 30',
	  'Google Chrome': '50.8',
	  'Internet Explorer': '21.34',
	  Firefox: '17.4',
	  Safari: '7.46',
	  'Microsoft Edge': '1.74',
	  Opera: '1.23',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 1',
	  'Google Chrome': '50.82',
	  'Internet Explorer': '21.39',
	  Firefox: '17.19',
	  Safari: '7.55',
	  'Microsoft Edge': '1.78',
	  Opera: '1.24',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 2',
	  'Google Chrome': '50.93',
	  'Internet Explorer': '21.17',
	  Firefox: '17.32',
	  Safari: '7.38',
	  'Microsoft Edge': '1.86',
	  Opera: '1.32',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 3',
	  'Google Chrome': '51.69',
	  'Internet Explorer': '18.12',
	  Firefox: '17.51',
	  Safari: '8.61',
	  'Microsoft Edge': '2.34',
	  Opera: '1.68',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 4',
	  'Google Chrome': '52.06',
	  'Internet Explorer': '17.59',
	  Firefox: '17.18',
	  Safari: '9.25',
	  'Microsoft Edge': '2.32',
	  Opera: '1.58',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 5',
	  'Google Chrome': '51.4',
	  'Internet Explorer': '20.73',
	  Firefox: '17.24',
	  Safari: '7.56',
	  'Microsoft Edge': '1.81',
	  Opera: '1.22',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 6',
	  'Google Chrome': '51.81',
	  'Internet Explorer': '20.35',
	  Firefox: '17.31',
	  Safari: '7.46',
	  'Microsoft Edge': '1.79',
	  Opera: '1.25',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 7',
	  'Google Chrome': '51.98',
	  'Internet Explorer': '20.18',
	  Firefox: '17.29',
	  Safari: '7.49',
	  'Microsoft Edge': '1.76',
	  Opera: '1.27',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 8',
	  'Google Chrome': '50.97',
	  'Internet Explorer': '20.56',
	  Firefox: '17.72',
	  Safari: '7.63',
	  'Microsoft Edge': '1.79',
	  Opera: '1.3',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 9',
	  'Google Chrome': '50.94',
	  'Internet Explorer': '20.42',
	  Firefox: '17.8',
	  Safari: '7.52',
	  'Microsoft Edge': '1.88',
	  Opera: '1.4',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 10',
	  'Google Chrome': '51.02',
	  'Internet Explorer': '17.74',
	  Firefox: '18.26',
	  Safari: '8.79',
	  'Microsoft Edge': '2.38',
	  Opera: '1.75',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 11',
	  'Google Chrome': '52.07',
	  'Internet Explorer': '16.83',
	  Firefox: '17.77',
	  Safari: '9.23',
	  'Microsoft Edge': '2.32',
	  Opera: '1.72',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Oct 12',
	  'Google Chrome': '50.9',
	  'Internet Explorer': '19.94',
	  Firefox: '17.55',
	  Safari: '8.27',
	  'Microsoft Edge': '1.94',
	  Opera: '1.35',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Oct 13',
	  'Google Chrome': '51.52',
	  'Internet Explorer': '19.66',
	  Firefox: '17.71',
	  Safari: '7.76',
	  'Microsoft Edge': '1.78',
	  Opera: '1.51',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Oct 14',
	  'Google Chrome': '51.75',
	  'Internet Explorer': '19.37',
	  Firefox: '17.85',
	  Safari: '7.72',
	  'Microsoft Edge': '1.82',
	  Opera: '1.44',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 15',
	  'Google Chrome': '51.37',
	  'Internet Explorer': '19.66',
	  Firefox: '17.92',
	  Safari: '7.68',
	  'Microsoft Edge': '1.87',
	  Opera: '1.46',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 16',
	  'Google Chrome': '51.29',
	  'Internet Explorer': '19.56',
	  Firefox: '18.06',
	  Safari: '7.62',
	  'Microsoft Edge': '1.91',
	  Opera: '1.52',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 17',
	  'Google Chrome': '52.47',
	  'Internet Explorer': '15.8',
	  Firefox: '18.39',
	  Safari: '8.96',
	  'Microsoft Edge': '2.46',
	  Opera: '1.88',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 18',
	  'Google Chrome': '51.88',
	  'Internet Explorer': '16.03',
	  Firefox: '18.07',
	  Safari: '9.75',
	  'Microsoft Edge': '2.42',
	  Opera: '1.79',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 19',
	  'Google Chrome': '51.48',
	  'Internet Explorer': '19.69',
	  Firefox: '17.68',
	  Safari: '7.87',
	  'Microsoft Edge': '1.83',
	  Opera: '1.41',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 20',
	  'Google Chrome': '51.58',
	  'Internet Explorer': '19.73',
	  Firefox: '17.63',
	  Safari: '7.85',
	  'Microsoft Edge': '1.8',
	  Opera: '1.38',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 21',
	  'Google Chrome': '52.04',
	  'Internet Explorer': '20.14',
	  Firefox: '16.99',
	  Safari: '7.63',
	  'Microsoft Edge': '1.81',
	  Opera: '1.34',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 22',
	  'Google Chrome': '51.62',
	  'Internet Explorer': '20.1',
	  Firefox: '17.28',
	  Safari: '7.75',
	  'Microsoft Edge': '1.86',
	  Opera: '1.35',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 23',
	  'Google Chrome': '51.87',
	  'Internet Explorer': '19.88',
	  Firefox: '17.17',
	  Safari: '7.64',
	  'Microsoft Edge': '1.94',
	  Opera: '1.45',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Oct 24',
	  'Google Chrome': '52.62',
	  'Internet Explorer': '16.25',
	  Firefox: '17.52',
	  Safari: '9.28',
	  'Microsoft Edge': '2.5',
	  Opera: '1.78',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 25',
	  'Google Chrome': '52.64',
	  'Internet Explorer': '16.1',
	  Firefox: '17.4',
	  Safari: '9.69',
	  'Microsoft Edge': '2.46',
	  Opera: '1.67',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Oct 26',
	  'Google Chrome': '52.29',
	  'Internet Explorer': '19.72',
	  Firefox: '17',
	  Safari: '7.81',
	  'Microsoft Edge': '1.88',
	  Opera: '1.26',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 27',
	  'Google Chrome': '51.88',
	  'Internet Explorer': '20.08',
	  Firefox: '17.1',
	  Safari: '7.73',
	  'Microsoft Edge': '1.87',
	  Opera: '1.3',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 28',
	  'Google Chrome': '51.92',
	  'Internet Explorer': '19.48',
	  Firefox: '17.49',
	  Safari: '7.86',
	  'Microsoft Edge': '1.93',
	  Opera: '1.28',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 29',
	  'Google Chrome': '51.56',
	  'Internet Explorer': '19.74',
	  Firefox: '17.83',
	  Safari: '7.64',
	  'Microsoft Edge': '1.9',
	  Opera: '1.31',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 30',
	  'Google Chrome': '51.8',
	  'Internet Explorer': '19.42',
	  Firefox: '17.86',
	  Safari: '7.5',
	  'Microsoft Edge': '1.99',
	  Opera: '1.38',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Oct 31',
	  'Google Chrome': '52.67',
	  'Internet Explorer': '16.22',
	  Firefox: '18.22',
	  Safari: '8.62',
	  'Microsoft Edge': '2.46',
	  Opera: '1.76',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 1',
	  'Google Chrome': '52.4',
	  'Internet Explorer': '15.92',
	  Firefox: '17.77',
	  Safari: '9.7',
	  'Microsoft Edge': '2.48',
	  Opera: '1.62',
	  Mozilla: '0.1',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 2',
	  'Google Chrome': '51.9',
	  'Internet Explorer': '19.56',
	  Firefox: '17.26',
	  Safari: '7.93',
	  'Microsoft Edge': '1.96',
	  Opera: '1.32',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 3',
	  'Google Chrome': '51.95',
	  'Internet Explorer': '19.83',
	  Firefox: '17.41',
	  Safari: '7.53',
	  'Microsoft Edge': '1.89',
	  Opera: '1.33',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 4',
	  'Google Chrome': '52.25',
	  'Internet Explorer': '19.61',
	  Firefox: '17.24',
	  Safari: '7.57',
	  'Microsoft Edge': '1.83',
	  Opera: '1.44',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 5',
	  'Google Chrome': '51.98',
	  'Internet Explorer': '19.9',
	  Firefox: '17.2',
	  Safari: '7.63',
	  'Microsoft Edge': '1.87',
	  Opera: '1.35',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 6',
	  'Google Chrome': '51.38',
	  'Internet Explorer': '20.09',
	  Firefox: '17.39',
	  Safari: '7.74',
	  'Microsoft Edge': '1.97',
	  Opera: '1.36',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 7',
	  'Google Chrome': '52.45',
	  'Internet Explorer': '16.46',
	  Firefox: '17.38',
	  Safari: '9.32',
	  'Microsoft Edge': '2.6',
	  Opera: '1.7',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Nov 8',
	  'Google Chrome': '52.61',
	  'Internet Explorer': '16.12',
	  Firefox: '16.97',
	  Safari: '9.97',
	  'Microsoft Edge': '2.55',
	  Opera: '1.69',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Nov 9',
	  'Google Chrome': '51.65',
	  'Internet Explorer': '20.18',
	  Firefox: '16.67',
	  Safari: '8.21',
	  'Microsoft Edge': '1.96',
	  Opera: '1.28',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 10',
	  'Google Chrome': '51.95',
	  'Internet Explorer': '19.99',
	  Firefox: '16.46',
	  Safari: '8.29',
	  'Microsoft Edge': '1.95',
	  Opera: '1.29',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Nov 11',
	  'Google Chrome': '52.74',
	  'Internet Explorer': '18.91',
	  Firefox: '16.38',
	  Safari: '8.49',
	  'Microsoft Edge': '2.04',
	  Opera: '1.37',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Nov 12',
	  'Google Chrome': '52.16',
	  'Internet Explorer': '19.88',
	  Firefox: '16.54',
	  Safari: '8.03',
	  'Microsoft Edge': '1.99',
	  Opera: '1.35',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 13',
	  'Google Chrome': '52.17',
	  'Internet Explorer': '19.7',
	  Firefox: '16.65',
	  Safari: '7.98',
	  'Microsoft Edge': '2.09',
	  Opera: '1.35',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 14',
	  'Google Chrome': '52.81',
	  'Internet Explorer': '16.25',
	  Firefox: '17.02',
	  Safari: '9.53',
	  'Microsoft Edge': '2.71',
	  Opera: '1.62',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 15',
	  'Google Chrome': '52.89',
	  'Internet Explorer': '15.65',
	  Firefox: '16.97',
	  Safari: '10.25',
	  'Microsoft Edge': '2.62',
	  Opera: '1.56',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 16',
	  'Google Chrome': '52.68',
	  'Internet Explorer': '19.59',
	  Firefox: '16.23',
	  Safari: '8.22',
	  'Microsoft Edge': '2',
	  Opera: '1.24',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 17',
	  'Google Chrome': '52.6',
	  'Internet Explorer': '19.62',
	  Firefox: '16.38',
	  Safari: '8.12',
	  'Microsoft Edge': '1.96',
	  Opera: '1.28',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 18',
	  'Google Chrome': '52.35',
	  'Internet Explorer': '19.79',
	  Firefox: '16.39',
	  Safari: '8.12',
	  'Microsoft Edge': '1.99',
	  Opera: '1.33',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 19',
	  'Google Chrome': '52.37',
	  'Internet Explorer': '19.81',
	  Firefox: '16.46',
	  Safari: '8',
	  'Microsoft Edge': '2',
	  Opera: '1.31',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 20',
	  'Google Chrome': '52.2',
	  'Internet Explorer': '19.55',
	  Firefox: '16.74',
	  Safari: '7.96',
	  'Microsoft Edge': '2.11',
	  Opera: '1.39',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 21',
	  'Google Chrome': '52.7',
	  'Internet Explorer': '16.03',
	  Firefox: '17.04',
	  Safari: '9.83',
	  'Microsoft Edge': '2.72',
	  Opera: '1.62',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 22',
	  'Google Chrome': '52.72',
	  'Internet Explorer': '15.75',
	  Firefox: '16.9',
	  Safari: '10.36',
	  'Microsoft Edge': '2.68',
	  Opera: '1.54',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 23',
	  'Google Chrome': '52.35',
	  'Internet Explorer': '19.53',
	  Firefox: '16.53',
	  Safari: '8.21',
	  'Microsoft Edge': '2.04',
	  Opera: '1.28',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 24',
	  'Google Chrome': '52.33',
	  'Internet Explorer': '19.53',
	  Firefox: '16.75',
	  Safari: '7.96',
	  'Microsoft Edge': '2.03',
	  Opera: '1.34',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 25',
	  'Google Chrome': '52.34',
	  'Internet Explorer': '19.04',
	  Firefox: '17.02',
	  Safari: '7.82',
	  'Microsoft Edge': '2.07',
	  Opera: '1.64',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 26',
	  'Google Chrome': '53.29',
	  'Internet Explorer': '17.12',
	  Firefox: '17.42',
	  Safari: '8.12',
	  'Microsoft Edge': '2.27',
	  Opera: '1.7',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 27',
	  'Google Chrome': '52.46',
	  'Internet Explorer': '17.83',
	  Firefox: '17.12',
	  Safari: '8.58',
	  'Microsoft Edge': '2.49',
	  Opera: '1.46',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 28',
	  'Google Chrome': '52.84',
	  'Internet Explorer': '15.74',
	  Firefox: '17.03',
	  Safari: '9.7',
	  'Microsoft Edge': '2.97',
	  Opera: '1.67',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 29',
	  'Google Chrome': '52.8',
	  'Internet Explorer': '15.57',
	  Firefox: '16.72',
	  Safari: '10.32',
	  'Microsoft Edge': '2.91',
	  Opera: '1.63',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Nov 30',
	  'Google Chrome': '52.71',
	  'Internet Explorer': '19.08',
	  Firefox: '16.21',
	  Safari: '8.49',
	  'Microsoft Edge': '2.22',
	  Opera: '1.24',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 1',
	  'Google Chrome': '52.41',
	  'Internet Explorer': '19.62',
	  Firefox: '16.28',
	  Safari: '8.11',
	  'Microsoft Edge': '2.25',
	  Opera: '1.29',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 2',
	  'Google Chrome': '52.64',
	  'Internet Explorer': '19.41',
	  Firefox: '16.18',
	  Safari: '8.1',
	  'Microsoft Edge': '2.31',
	  Opera: '1.31',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 3',
	  'Google Chrome': '52.37',
	  'Internet Explorer': '19.3',
	  Firefox: '16.4',
	  Safari: '8.23',
	  'Microsoft Edge': '2.31',
	  Opera: '1.35',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 4',
	  'Google Chrome': '52.15',
	  'Internet Explorer': '19.2',
	  Firefox: '16.72',
	  Safari: '7.98',
	  'Microsoft Edge': '2.46',
	  Opera: '1.44',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 5',
	  'Google Chrome': '52.15',
	  'Internet Explorer': '15.77',
	  Firefox: '17.33',
	  Safari: '9.82',
	  'Microsoft Edge': '3.18',
	  Opera: '1.68',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 6',
	  'Google Chrome': '52.92',
	  'Internet Explorer': '15.33',
	  Firefox: '16.65',
	  Safari: '10.31',
	  'Microsoft Edge': '3.06',
	  Opera: '1.67',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 7',
	  'Google Chrome': '52.59',
	  'Internet Explorer': '19.15',
	  Firefox: '16.25',
	  Safari: '8.36',
	  'Microsoft Edge': '2.34',
	  Opera: '1.26',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 8',
	  'Google Chrome': '52.57',
	  'Internet Explorer': '19.12',
	  Firefox: '16.38',
	  Safari: '8.21',
	  'Microsoft Edge': '2.38',
	  Opera: '1.28',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 9',
	  'Google Chrome': '52.47',
	  'Internet Explorer': '19.47',
	  Firefox: '16.41',
	  Safari: '7.98',
	  'Microsoft Edge': '2.31',
	  Opera: '1.3',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 10',
	  'Google Chrome': '52.22',
	  'Internet Explorer': '20',
	  Firefox: '16.4',
	  Safari: '7.73',
	  'Microsoft Edge': '2.35',
	  Opera: '1.25',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 11',
	  'Google Chrome': '51.97',
	  'Internet Explorer': '19.54',
	  Firefox: '16.69',
	  Safari: '7.91',
	  'Microsoft Edge': '2.49',
	  Opera: '1.34',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 12',
	  'Google Chrome': '52.03',
	  'Internet Explorer': '16.49',
	  Firefox: '16.84',
	  Safari: '9.67',
	  'Microsoft Edge': '3.18',
	  Opera: '1.68',
	  Mozilla: '0.1',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 13',
	  'Google Chrome': '52.17',
	  'Internet Explorer': '16.22',
	  Firefox: '16.61',
	  Safari: '10.18',
	  'Microsoft Edge': '3.16',
	  Opera: '1.57',
	  Mozilla: '0.08',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 14',
	  'Google Chrome': '51.48',
	  'Internet Explorer': '20.71',
	  Firefox: '16.04',
	  Safari: '8.12',
	  'Microsoft Edge': '2.39',
	  Opera: '1.21',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 15',
	  'Google Chrome': '51.64',
	  'Internet Explorer': '20.54',
	  Firefox: '16.11',
	  Safari: '8.05',
	  'Microsoft Edge': '2.37',
	  Opera: '1.23',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 16',
	  'Google Chrome': '51.32',
	  'Internet Explorer': '21.04',
	  Firefox: '16.04',
	  Safari: '7.9',
	  'Microsoft Edge': '2.45',
	  Opera: '1.2',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 17',
	  'Google Chrome': '51.03',
	  'Internet Explorer': '21.29',
	  Firefox: '16.13',
	  Safari: '7.77',
	  'Microsoft Edge': '2.46',
	  Opera: '1.25',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 18',
	  'Google Chrome': '50.9',
	  'Internet Explorer': '20.71',
	  Firefox: '16.59',
	  Safari: '7.73',
	  'Microsoft Edge': '2.6',
	  Opera: '1.38',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 19',
	  'Google Chrome': '51.36',
	  'Internet Explorer': '17.02',
	  Firefox: '17.13',
	  Safari: '9.36',
	  'Microsoft Edge': '3.29',
	  Opera: '1.75',
	  Mozilla: '0.09',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 20',
	  'Google Chrome': '52.24',
	  'Internet Explorer': '16.39',
	  Firefox: '17.18',
	  Safari: '9.39',
	  'Microsoft Edge': '3.13',
	  Opera: '1.58',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 21',
	  'Google Chrome': '51.44',
	  'Internet Explorer': '20.62',
	  Firefox: '16.64',
	  Safari: '7.45',
	  'Microsoft Edge': '2.51',
	  Opera: '1.28',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 22',
	  'Google Chrome': '51.44',
	  'Internet Explorer': '20.64',
	  Firefox: '16.72',
	  Safari: '7.23',
	  'Microsoft Edge': '2.58',
	  Opera: '1.33',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 23',
	  'Google Chrome': '50.69',
	  'Internet Explorer': '21.15',
	  Firefox: '16.69',
	  Safari: '7.24',
	  'Microsoft Edge': '2.7',
	  Opera: '1.46',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 24',
	  'Google Chrome': '50.13',
	  'Internet Explorer': '20.14',
	  Firefox: '16.68',
	  Safari: '8',
	  'Microsoft Edge': '3.1',
	  Opera: '1.85',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.02'
	}, {
	  date: '2015 Dec 25',
	  'Google Chrome': '50.55',
	  'Internet Explorer': '17.4',
	  Firefox: '16.92',
	  Safari: '9.19',
	  'Microsoft Edge': '3.73',
	  Opera: '2.1',
	  Mozilla: '0.09',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 26',
	  'Google Chrome': '50.12',
	  'Internet Explorer': '17.8',
	  Firefox: '16.92',
	  Safari: '9.44',
	  'Microsoft Edge': '3.72',
	  Opera: '1.9',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 27',
	  'Google Chrome': '50.68',
	  'Internet Explorer': '17.25',
	  Firefox: '16.89',
	  Safari: '9.55',
	  'Microsoft Edge': '3.73',
	  Opera: '1.81',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2015 Dec 28',
	  'Google Chrome': '49.89',
	  'Internet Explorer': '21.09',
	  Firefox: '16.22',
	  Safari: '8.13',
	  'Microsoft Edge': '3.21',
	  Opera: '1.39',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 29',
	  'Google Chrome': '50.27',
	  'Internet Explorer': '20.86',
	  Firefox: '16.25',
	  Safari: '7.95',
	  'Microsoft Edge': '3.22',
	  Opera: '1.37',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 30',
	  'Google Chrome': '49.85',
	  'Internet Explorer': '21.28',
	  Firefox: '16.26',
	  Safari: '7.87',
	  'Microsoft Edge': '3.29',
	  Opera: '1.37',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2015 Dec 31',
	  'Google Chrome': '49.4',
	  'Internet Explorer': '20.41',
	  Firefox: '16.43',
	  Safari: '8.52',
	  'Microsoft Edge': '3.57',
	  Opera: '1.59',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jan 1',
	  'Google Chrome': '50.07',
	  'Internet Explorer': '16.61',
	  Firefox: '17.36',
	  Safari: '10.09',
	  'Microsoft Edge': '4.01',
	  Opera: '1.76',
	  Mozilla: '0.09',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jan 2',
	  'Google Chrome': '50.72',
	  'Internet Explorer': '16.66',
	  Firefox: '17.22',
	  Safari: '9.67',
	  'Microsoft Edge': '3.91',
	  Opera: '1.74',
	  Mozilla: '0.08',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 3',
	  'Google Chrome': '51.23',
	  'Internet Explorer': '16.46',
	  Firefox: '16.95',
	  Safari: '9.87',
	  'Microsoft Edge': '3.75',
	  Opera: '1.67',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 4',
	  'Google Chrome': '51.26',
	  'Internet Explorer': '20.36',
	  Firefox: '16.35',
	  Safari: '7.84',
	  'Microsoft Edge': '2.85',
	  Opera: '1.29',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 5',
	  'Google Chrome': '51.32',
	  'Internet Explorer': '20.21',
	  Firefox: '16.35',
	  Safari: '7.89',
	  'Microsoft Edge': '2.79',
	  Opera: '1.36',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 6',
	  'Google Chrome': '51.81',
	  'Internet Explorer': '19.86',
	  Firefox: '16.2',
	  Safari: '7.93',
	  'Microsoft Edge': '2.76',
	  Opera: '1.38',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 7',
	  'Google Chrome': '51.85',
	  'Internet Explorer': '19.82',
	  Firefox: '16.31',
	  Safari: '7.81',
	  'Microsoft Edge': '2.76',
	  Opera: '1.4',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 8',
	  'Google Chrome': '50.99',
	  'Internet Explorer': '20.36',
	  Firefox: '16.55',
	  Safari: '7.64',
	  'Microsoft Edge': '2.9',
	  Opera: '1.49',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jan 9',
	  'Google Chrome': '51.5',
	  'Internet Explorer': '16.58',
	  Firefox: '17.03',
	  Safari: '9.38',
	  'Microsoft Edge': '3.57',
	  Opera: '1.86',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jan 10',
	  'Google Chrome': '51.88',
	  'Internet Explorer': '15.91',
	  Firefox: '17',
	  Safari: '9.79',
	  'Microsoft Edge': '3.52',
	  Opera: '1.81',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jan 11',
	  'Google Chrome': '51.91',
	  'Internet Explorer': '19.73',
	  Firefox: '16.3',
	  Safari: '7.93',
	  'Microsoft Edge': '2.72',
	  Opera: '1.37',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 12',
	  'Google Chrome': '51.99',
	  'Internet Explorer': '19.63',
	  Firefox: '16.35',
	  Safari: '7.84',
	  'Microsoft Edge': '2.74',
	  Opera: '1.39',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jan 13',
	  'Google Chrome': '52.31',
	  'Internet Explorer': '19.26',
	  Firefox: '16.25',
	  Safari: '7.95',
	  'Microsoft Edge': '2.85',
	  Opera: '1.33',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 14',
	  'Google Chrome': '52.07',
	  'Internet Explorer': '19.64',
	  Firefox: '16.1',
	  Safari: '7.95',
	  'Microsoft Edge': '2.87',
	  Opera: '1.32',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 15',
	  'Google Chrome': '52.21',
	  'Internet Explorer': '18.83',
	  Firefox: '16.42',
	  Safari: '7.98',
	  'Microsoft Edge': '3.04',
	  Opera: '1.46',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jan 16',
	  'Google Chrome': '52.65',
	  'Internet Explorer': '15.51',
	  Firefox: '16.86',
	  Safari: '9.5',
	  'Microsoft Edge': '3.66',
	  Opera: '1.75',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 17',
	  'Google Chrome': '52.48',
	  'Internet Explorer': '15.69',
	  Firefox: '16.61',
	  Safari: '9.84',
	  'Microsoft Edge': '3.66',
	  Opera: '1.66',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 18',
	  'Google Chrome': '52.07',
	  'Internet Explorer': '18.91',
	  Firefox: '16.31',
	  Safari: '8.36',
	  'Microsoft Edge': '3',
	  Opera: '1.3',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 19',
	  'Google Chrome': '52.51',
	  'Internet Explorer': '19.48',
	  Firefox: '16.08',
	  Safari: '7.91',
	  'Microsoft Edge': '2.72',
	  Opera: '1.25',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 20',
	  'Google Chrome': '52.82',
	  'Internet Explorer': '19.01',
	  Firefox: '16.14',
	  Safari: '7.97',
	  'Microsoft Edge': '2.76',
	  Opera: '1.25',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jan 21',
	  'Google Chrome': '52.76',
	  'Internet Explorer': '19.26',
	  Firefox: '16.12',
	  Safari: '7.79',
	  'Microsoft Edge': '2.74',
	  Opera: '1.3',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 22',
	  'Google Chrome': '52.56',
	  'Internet Explorer': '18.8',
	  Firefox: '16.33',
	  Safari: '7.9',
	  'Microsoft Edge': '2.95',
	  Opera: '1.4',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 23',
	  'Google Chrome': '52.38',
	  'Internet Explorer': '15.76',
	  Firefox: '16.79',
	  Safari: '9.5',
	  'Microsoft Edge': '3.78',
	  Opera: '1.72',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 24',
	  'Google Chrome': '53.12',
	  'Internet Explorer': '15.22',
	  Firefox: '16.55',
	  Safari: '9.83',
	  'Microsoft Edge': '3.57',
	  Opera: '1.65',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 25',
	  'Google Chrome': '52.55',
	  'Internet Explorer': '19.12',
	  Firefox: '16.15',
	  Safari: '7.94',
	  'Microsoft Edge': '2.89',
	  Opera: '1.32',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 26',
	  'Google Chrome': '52.45',
	  'Internet Explorer': '19.49',
	  Firefox: '16.03',
	  Safari: '7.83',
	  'Microsoft Edge': '2.87',
	  Opera: '1.28',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 27',
	  'Google Chrome': '52.64',
	  'Internet Explorer': '19.42',
	  Firefox: '16.06',
	  Safari: '7.7',
	  'Microsoft Edge': '2.84',
	  Opera: '1.29',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 28',
	  'Google Chrome': '51.95',
	  'Internet Explorer': '19.87',
	  Firefox: '16.15',
	  Safari: '7.77',
	  'Microsoft Edge': '2.92',
	  Opera: '1.32',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 29',
	  'Google Chrome': '51.03',
	  'Internet Explorer': '20',
	  Firefox: '16.6',
	  Safari: '7.85',
	  'Microsoft Edge': '3.07',
	  Opera: '1.4',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jan 30',
	  'Google Chrome': '50.97',
	  'Internet Explorer': '16.86',
	  Firefox: '17.28',
	  Safari: '9.36',
	  'Microsoft Edge': '3.71',
	  Opera: '1.76',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jan 31',
	  'Google Chrome': '52.36',
	  'Internet Explorer': '15.75',
	  Firefox: '16.71',
	  Safari: '9.85',
	  'Microsoft Edge': '3.63',
	  Opera: '1.63',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 1',
	  'Google Chrome': '52.62',
	  'Internet Explorer': '19.09',
	  Firefox: '16.1',
	  Safari: '7.98',
	  'Microsoft Edge': '2.88',
	  Opera: '1.28',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 2',
	  'Google Chrome': '52.48',
	  'Internet Explorer': '19.25',
	  Firefox: '16.25',
	  Safari: '7.83',
	  'Microsoft Edge': '2.85',
	  Opera: '1.29',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 3',
	  'Google Chrome': '52.47',
	  'Internet Explorer': '19.16',
	  Firefox: '16.16',
	  Safari: '7.94',
	  'Microsoft Edge': '2.91',
	  Opera: '1.31',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 4',
	  'Google Chrome': '51.91',
	  'Internet Explorer': '19.77',
	  Firefox: '16.12',
	  Safari: '7.83',
	  'Microsoft Edge': '3',
	  Opera: '1.31',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 5',
	  'Google Chrome': '51.76',
	  'Internet Explorer': '19.36',
	  Firefox: '16.44',
	  Safari: '7.78',
	  'Microsoft Edge': '3.15',
	  Opera: '1.44',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 6',
	  'Google Chrome': '52.11',
	  'Internet Explorer': '15.66',
	  Firefox: '16.99',
	  Safari: '9.43',
	  'Microsoft Edge': '3.96',
	  Opera: '1.78',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 7',
	  'Google Chrome': '52.41',
	  'Internet Explorer': '15.14',
	  Firefox: '17.12',
	  Safari: '9.69',
	  'Microsoft Edge': '3.81',
	  Opera: '1.77',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 8',
	  'Google Chrome': '51.83',
	  'Internet Explorer': '19.4',
	  Firefox: '15.93',
	  Safari: '8.38',
	  'Microsoft Edge': '3.13',
	  Opera: '1.27',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 9',
	  'Google Chrome': '52.01',
	  'Internet Explorer': '19.2',
	  Firefox: '16.01',
	  Safari: '8.25',
	  'Microsoft Edge': '3.09',
	  Opera: '1.37',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 10',
	  'Google Chrome': '52.92',
	  'Internet Explorer': '18.52',
	  Firefox: '15.94',
	  Safari: '8.23',
	  'Microsoft Edge': '2.93',
	  Opera: '1.41',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 11',
	  'Google Chrome': '52.71',
	  'Internet Explorer': '18.9',
	  Firefox: '16.17',
	  Safari: '7.94',
	  'Microsoft Edge': '2.88',
	  Opera: '1.35',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 12',
	  'Google Chrome': '52.37',
	  'Internet Explorer': '18.63',
	  Firefox: '16.65',
	  Safari: '7.84',
	  'Microsoft Edge': '3.01',
	  Opera: '1.45',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 13',
	  'Google Chrome': '52.73',
	  'Internet Explorer': '14.69',
	  Firefox: '17.33',
	  Safari: '9.38',
	  'Microsoft Edge': '3.92',
	  Opera: '1.87',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 14',
	  'Google Chrome': '52.73',
	  'Internet Explorer': '14.91',
	  Firefox: '17.06',
	  Safari: '9.67',
	  'Microsoft Edge': '3.85',
	  Opera: '1.71',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 15',
	  'Google Chrome': '52.68',
	  'Internet Explorer': '17.65',
	  Firefox: '16.58',
	  Safari: '8.54',
	  'Microsoft Edge': '3.2',
	  Opera: '1.31',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 16',
	  'Google Chrome': '53.18',
	  'Internet Explorer': '18.24',
	  Firefox: '16.32',
	  Safari: '7.98',
	  'Microsoft Edge': '2.93',
	  Opera: '1.3',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 17',
	  'Google Chrome': '52.8',
	  'Internet Explorer': '18.68',
	  Firefox: '16.37',
	  Safari: '7.83',
	  'Microsoft Edge': '2.97',
	  Opera: '1.3',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 18',
	  'Google Chrome': '52.85',
	  'Internet Explorer': '18.74',
	  Firefox: '16.32',
	  Safari: '7.74',
	  'Microsoft Edge': '2.93',
	  Opera: '1.37',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 19',
	  'Google Chrome': '52.5',
	  'Internet Explorer': '18.49',
	  Firefox: '16.7',
	  Safari: '7.75',
	  'Microsoft Edge': '3.08',
	  Opera: '1.43',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 20',
	  'Google Chrome': '52.15',
	  'Internet Explorer': '15.14',
	  Firefox: '17.4',
	  Safari: '9.45',
	  'Microsoft Edge': '3.89',
	  Opera: '1.9',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 21',
	  'Google Chrome': '52.1',
	  'Internet Explorer': '14.95',
	  Firefox: '17.14',
	  Safari: '10.17',
	  'Microsoft Edge': '3.9',
	  Opera: '1.66',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 22',
	  'Google Chrome': '52.35',
	  'Internet Explorer': '18.91',
	  Firefox: '16.41',
	  Safari: '8.05',
	  'Microsoft Edge': '2.97',
	  Opera: '1.25',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 23',
	  'Google Chrome': '52',
	  'Internet Explorer': '19.19',
	  Firefox: '16.48',
	  Safari: '8.07',
	  'Microsoft Edge': '2.97',
	  Opera: '1.25',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 24',
	  'Google Chrome': '52.27',
	  'Internet Explorer': '18.8',
	  Firefox: '16.71',
	  Safari: '7.93',
	  'Microsoft Edge': '2.96',
	  Opera: '1.28',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 25',
	  'Google Chrome': '52.2',
	  'Internet Explorer': '18.84',
	  Firefox: '16.71',
	  Safari: '7.91',
	  'Microsoft Edge': '2.98',
	  Opera: '1.31',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 26',
	  'Google Chrome': '52.28',
	  'Internet Explorer': '18.37',
	  Firefox: '16.95',
	  Safari: '7.86',
	  'Microsoft Edge': '3.09',
	  Opera: '1.39',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 27',
	  'Google Chrome': '52.63',
	  'Internet Explorer': '14.89',
	  Firefox: '17.29',
	  Safari: '9.44',
	  'Microsoft Edge': '3.9',
	  Opera: '1.77',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Feb 28',
	  'Google Chrome': '52.74',
	  'Internet Explorer': '14.98',
	  Firefox: '16.83',
	  Safari: '9.89',
	  'Microsoft Edge': '3.85',
	  Opera: '1.64',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Feb 29',
	  'Google Chrome': '53.2',
	  'Internet Explorer': '18.53',
	  Firefox: '16.18',
	  Safari: '7.88',
	  'Microsoft Edge': '3',
	  Opera: '1.17',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 1',
	  'Google Chrome': '53.27',
	  'Internet Explorer': '18.36',
	  Firefox: '16.23',
	  Safari: '7.99',
	  'Microsoft Edge': '2.92',
	  Opera: '1.18',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 2',
	  'Google Chrome': '53.37',
	  'Internet Explorer': '18.14',
	  Firefox: '16.21',
	  Safari: '8.14',
	  'Microsoft Edge': '2.89',
	  Opera: '1.19',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 3',
	  'Google Chrome': '53.03',
	  'Internet Explorer': '18.51',
	  Firefox: '16.26',
	  Safari: '7.98',
	  'Microsoft Edge': '2.97',
	  Opera: '1.22',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 4',
	  'Google Chrome': '52.47',
	  'Internet Explorer': '18.63',
	  Firefox: '16.48',
	  Safari: '7.92',
	  'Microsoft Edge': '3.13',
	  Opera: '1.32',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 5',
	  'Google Chrome': '52.43',
	  'Internet Explorer': '14.9',
	  Firefox: '17.03',
	  Safari: '9.82',
	  'Microsoft Edge': '4.04',
	  Opera: '1.72',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Mar 6',
	  'Google Chrome': '52.86',
	  'Internet Explorer': '14.56',
	  Firefox: '16.85',
	  Safari: '10.1',
	  'Microsoft Edge': '3.95',
	  Opera: '1.63',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 7',
	  'Google Chrome': '52.59',
	  'Internet Explorer': '18.9',
	  Firefox: '16.25',
	  Safari: '7.99',
	  'Microsoft Edge': '3.01',
	  Opera: '1.22',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 8',
	  'Google Chrome': '52.75',
	  'Internet Explorer': '18.59',
	  Firefox: '16.36',
	  Safari: '7.99',
	  'Microsoft Edge': '3.01',
	  Opera: '1.24',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 9',
	  'Google Chrome': '53.16',
	  'Internet Explorer': '18.21',
	  Firefox: '16.39',
	  Safari: '7.89',
	  'Microsoft Edge': '3.05',
	  Opera: '1.26',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 10',
	  'Google Chrome': '52.99',
	  'Internet Explorer': '18.49',
	  Firefox: '16.45',
	  Safari: '7.7',
	  'Microsoft Edge': '3.04',
	  Opera: '1.28',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 11',
	  'Google Chrome': '52.42',
	  'Internet Explorer': '18.46',
	  Firefox: '16.68',
	  Safari: '7.81',
	  'Microsoft Edge': '3.22',
	  Opera: '1.36',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 12',
	  'Google Chrome': '51.86',
	  'Internet Explorer': '15.55',
	  Firefox: '17.13',
	  Safari: '9.46',
	  'Microsoft Edge': '4.16',
	  Opera: '1.78',
	  Mozilla: '0.06',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Mar 13',
	  'Google Chrome': '51.95',
	  'Internet Explorer': '15.09',
	  Firefox: '17.03',
	  Safari: '10.04',
	  'Microsoft Edge': '4.17',
	  Opera: '1.66',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 14',
	  'Google Chrome': '51.94',
	  'Internet Explorer': '19.4',
	  Firefox: '16.23',
	  Safari: '8.01',
	  'Microsoft Edge': '3.16',
	  Opera: '1.21',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 15',
	  'Google Chrome': '52.49',
	  'Internet Explorer': '18.73',
	  Firefox: '16.42',
	  Safari: '7.96',
	  'Microsoft Edge': '3.11',
	  Opera: '1.23',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Mar 16',
	  'Google Chrome': '52.41',
	  'Internet Explorer': '18.66',
	  Firefox: '16.61',
	  Safari: '7.85',
	  'Microsoft Edge': '3.17',
	  Opera: '1.26',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 17',
	  'Google Chrome': '52.26',
	  'Internet Explorer': '19.15',
	  Firefox: '16.53',
	  Safari: '7.58',
	  'Microsoft Edge': '3.15',
	  Opera: '1.29',
	  Mozilla: '0.04',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Mar 18',
	  'Google Chrome': '51.98',
	  'Internet Explorer': '18.86',
	  Firefox: '16.76',
	  Safari: '7.69',
	  'Microsoft Edge': '3.3',
	  Opera: '1.37',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 19',
	  'Google Chrome': '51.89',
	  'Internet Explorer': '15.61',
	  Firefox: '17',
	  Safari: '9.39',
	  'Microsoft Edge': '4.21',
	  Opera: '1.79',
	  Mozilla: '0.11',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Mar 20',
	  'Google Chrome': '51.86',
	  'Internet Explorer': '15.29',
	  Firefox: '16.87',
	  Safari: '9.91',
	  'Microsoft Edge': '4.27',
	  Opera: '1.71',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Mar 21',
	  'Google Chrome': '52.74',
	  'Internet Explorer': '18.37',
	  Firefox: '16.28',
	  Safari: '7.99',
	  'Microsoft Edge': '3.22',
	  Opera: '1.35',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 22',
	  'Google Chrome': '52.93',
	  'Internet Explorer': '18.46',
	  Firefox: '16.22',
	  Safari: '7.76',
	  'Microsoft Edge': '3.12',
	  Opera: '1.45',
	  Mozilla: '0.05',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Mar 23',
	  'Google Chrome': '52.65',
	  'Internet Explorer': '18.47',
	  Firefox: '16.28',
	  Safari: '7.76',
	  'Microsoft Edge': '3.22',
	  Opera: '1.58',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 24',
	  'Google Chrome': '52.53',
	  'Internet Explorer': '18.25',
	  Firefox: '16.21',
	  Safari: '8.03',
	  'Microsoft Edge': '3.36',
	  Opera: '1.58',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 25',
	  'Google Chrome': '52.15',
	  'Internet Explorer': '16.95',
	  Firefox: '16.75',
	  Safari: '8.7',
	  'Microsoft Edge': '3.76',
	  Opera: '1.64',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 26',
	  'Google Chrome': '52.24',
	  'Internet Explorer': '15.04',
	  Firefox: '17.07',
	  Safari: '9.52',
	  'Microsoft Edge': '4.23',
	  Opera: '1.85',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 27',
	  'Google Chrome': '52.56',
	  'Internet Explorer': '14.27',
	  Firefox: '16.98',
	  Safari: '10.11',
	  'Microsoft Edge': '4.26',
	  Opera: '1.78',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 28',
	  'Google Chrome': '53.31',
	  'Internet Explorer': '17.05',
	  Firefox: '16.2',
	  Safari: '8.49',
	  'Microsoft Edge': '3.48',
	  Opera: '1.43',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 29',
	  'Google Chrome': '52.98',
	  'Internet Explorer': '17.82',
	  Firefox: '16.37',
	  Safari: '8.09',
	  'Microsoft Edge': '3.23',
	  Opera: '1.48',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 30',
	  'Google Chrome': '53.07',
	  'Internet Explorer': '17.84',
	  Firefox: '16.37',
	  Safari: '7.96',
	  'Microsoft Edge': '3.27',
	  Opera: '1.45',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Mar 31',
	  'Google Chrome': '53.4',
	  'Internet Explorer': '17.73',
	  Firefox: '16.24',
	  Safari: '7.84',
	  'Microsoft Edge': '3.3',
	  Opera: '1.43',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 1',
	  'Google Chrome': '52.72',
	  'Internet Explorer': '18.26',
	  Firefox: '16.4',
	  Safari: '7.72',
	  'Microsoft Edge': '3.4',
	  Opera: '1.47',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 2',
	  'Google Chrome': '52.99',
	  'Internet Explorer': '14.44',
	  Firefox: '16.96',
	  Safari: '9.33',
	  'Microsoft Edge': '4.35',
	  Opera: '1.87',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 3',
	  'Google Chrome': '53.29',
	  'Internet Explorer': '14.13',
	  Firefox: '16.7',
	  Safari: '9.8',
	  'Microsoft Edge': '4.2',
	  Opera: '1.82',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 4',
	  'Google Chrome': '53.65',
	  'Internet Explorer': '17.74',
	  Firefox: '16.06',
	  Safari: '7.79',
	  'Microsoft Edge': '3.22',
	  Opera: '1.5',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 5',
	  'Google Chrome': '53.21',
	  'Internet Explorer': '18.25',
	  Firefox: '16.05',
	  Safari: '7.71',
	  'Microsoft Edge': '3.21',
	  Opera: '1.54',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 6',
	  'Google Chrome': '53.29',
	  'Internet Explorer': '18.24',
	  Firefox: '16.02',
	  Safari: '7.52',
	  'Microsoft Edge': '3.28',
	  Opera: '1.6',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 7',
	  'Google Chrome': '52.77',
	  'Internet Explorer': '18.33',
	  Firefox: '16.26',
	  Safari: '7.56',
	  'Microsoft Edge': '3.35',
	  Opera: '1.69',
	  Mozilla: '0.03',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 8',
	  'Google Chrome': '52.41',
	  'Internet Explorer': '18.15',
	  Firefox: '16.82',
	  Safari: '7.65',
	  'Microsoft Edge': '3.5',
	  Opera: '1.42',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 9',
	  'Google Chrome': '52.03',
	  'Internet Explorer': '15.11',
	  Firefox: '17.19',
	  Safari: '9.37',
	  'Microsoft Edge': '4.48',
	  Opera: '1.77',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 10',
	  'Google Chrome': '52.62',
	  'Internet Explorer': '14.85',
	  Firefox: '16.78',
	  Safari: '9.63',
	  'Microsoft Edge': '4.42',
	  Opera: '1.66',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 11',
	  'Google Chrome': '52.54',
	  'Internet Explorer': '18.79',
	  Firefox: '16.17',
	  Safari: '7.73',
	  'Microsoft Edge': '3.37',
	  Opera: '1.34',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 12',
	  'Google Chrome': '53.2',
	  'Internet Explorer': '18.04',
	  Firefox: '16.1',
	  Safari: '7.61',
	  'Microsoft Edge': '3.34',
	  Opera: '1.65',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 13',
	  'Google Chrome': '53.01',
	  'Internet Explorer': '17.89',
	  Firefox: '16.22',
	  Safari: '7.67',
	  'Microsoft Edge': '3.39',
	  Opera: '1.72',
	  Mozilla: '0.1',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 14',
	  'Google Chrome': '53.2',
	  'Internet Explorer': '18.06',
	  Firefox: '16.08',
	  Safari: '7.53',
	  'Microsoft Edge': '3.3',
	  Opera: '1.68',
	  Mozilla: '0.15',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 15',
	  'Google Chrome': '52.96',
	  'Internet Explorer': '17.82',
	  Firefox: '16.32',
	  Safari: '7.52',
	  'Microsoft Edge': '3.46',
	  Opera: '1.81',
	  Mozilla: '0.12',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 16',
	  'Google Chrome': '52.52',
	  'Internet Explorer': '14.52',
	  Firefox: '17.23',
	  Safari: '9.32',
	  'Microsoft Edge': '4.47',
	  Opera: '1.81',
	  Mozilla: '0.13',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 17',
	  'Google Chrome': '52.71',
	  'Internet Explorer': '14.25',
	  Firefox: '16.94',
	  Safari: '9.9',
	  'Microsoft Edge': '4.4',
	  Opera: '1.7',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 18',
	  'Google Chrome': '53.22',
	  'Internet Explorer': '17.85',
	  Firefox: '16.08',
	  Safari: '7.79',
	  'Microsoft Edge': '3.33',
	  Opera: '1.66',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 19',
	  'Google Chrome': '53.51',
	  'Internet Explorer': '17.76',
	  Firefox: '16.19',
	  Safari: '7.77',
	  'Microsoft Edge': '3.27',
	  Opera: '1.43',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 20',
	  'Google Chrome': '53.62',
	  'Internet Explorer': '17.44',
	  Firefox: '16.12',
	  Safari: '7.81',
	  'Microsoft Edge': '3.36',
	  Opera: '1.57',
	  Mozilla: '0.08',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 21',
	  'Google Chrome': '53.4',
	  'Internet Explorer': '17.94',
	  Firefox: '15.94',
	  Safari: '7.59',
	  'Microsoft Edge': '3.47',
	  Opera: '1.6',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 22',
	  'Google Chrome': '52.62',
	  'Internet Explorer': '18.57',
	  Firefox: '16.13',
	  Safari: '7.55',
	  'Microsoft Edge': '3.61',
	  Opera: '1.46',
	  Mozilla: '0.08',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 23',
	  'Google Chrome': '52.42',
	  'Internet Explorer': '14.46',
	  Firefox: '17.12',
	  Safari: '9.44',
	  'Microsoft Edge': '4.72',
	  Opera: '1.75',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 24',
	  'Google Chrome': '53.43',
	  'Internet Explorer': '13.62',
	  Firefox: '16.79',
	  Safari: '9.84',
	  'Microsoft Edge': '4.59',
	  Opera: '1.66',
	  Mozilla: '0.07',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Apr 25',
	  'Google Chrome': '53.48',
	  'Internet Explorer': '17.72',
	  Firefox: '15.98',
	  Safari: '7.79',
	  'Microsoft Edge': '3.46',
	  Opera: '1.5',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 26',
	  'Google Chrome': '53.5',
	  'Internet Explorer': '17.81',
	  Firefox: '16.13',
	  Safari: '7.73',
	  'Microsoft Edge': '3.4',
	  Opera: '1.36',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 27',
	  'Google Chrome': '53.68',
	  'Internet Explorer': '17.4',
	  Firefox: '16.39',
	  Safari: '7.76',
	  'Microsoft Edge': '3.45',
	  Opera: '1.24',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 28',
	  'Google Chrome': '53.08',
	  'Internet Explorer': '18.16',
	  Firefox: '16.31',
	  Safari: '7.68',
	  'Microsoft Edge': '3.49',
	  Opera: '1.21',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Apr 29',
	  'Google Chrome': '53.09',
	  'Internet Explorer': '17.74',
	  Firefox: '16.65',
	  Safari: '7.59',
	  'Microsoft Edge': '3.56',
	  Opera: '1.28',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Apr 30',
	  'Google Chrome': '53.1',
	  'Internet Explorer': '14.09',
	  Firefox: '16.82',
	  Safari: '9.4',
	  'Microsoft Edge': '4.86',
	  Opera: '1.65',
	  Mozilla: '0.1',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 1',
	  'Google Chrome': '52.76',
	  'Internet Explorer': '13.89',
	  Firefox: '16.72',
	  Safari: '10.07',
	  'Microsoft Edge': '4.88',
	  Opera: '1.58',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 May 2',
	  'Google Chrome': '53.44',
	  'Internet Explorer': '17.2',
	  Firefox: '16.17',
	  Safari: '8.2',
	  'Microsoft Edge': '3.67',
	  Opera: '1.21',
	  Mozilla: '0.1',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 3',
	  'Google Chrome': '52.97',
	  'Internet Explorer': '17.96',
	  Firefox: '16.21',
	  Safari: '7.85',
	  'Microsoft Edge': '3.52',
	  Opera: '1.41',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 4',
	  'Google Chrome': '53.55',
	  'Internet Explorer': '17.62',
	  Firefox: '16.01',
	  Safari: '7.62',
	  'Microsoft Edge': '3.57',
	  Opera: '1.54',
	  Mozilla: '0.08',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 5',
	  'Google Chrome': '53.76',
	  'Internet Explorer': '17.45',
	  Firefox: '15.92',
	  Safari: '7.6',
	  'Microsoft Edge': '3.63',
	  Opera: '1.57',
	  Mozilla: '0.08',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 6',
	  'Google Chrome': '52.97',
	  'Internet Explorer': '17.61',
	  Firefox: '16.28',
	  Safari: '7.72',
	  'Microsoft Edge': '3.78',
	  Opera: '1.55',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 7',
	  'Google Chrome': '51.82',
	  'Internet Explorer': '14.56',
	  Firefox: '17.28',
	  Safari: '9.66',
	  'Microsoft Edge': '4.86',
	  Opera: '1.72',
	  Mozilla: '0.1',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 8',
	  'Google Chrome': '52.46',
	  'Internet Explorer': '14.09',
	  Firefox: '17.17',
	  Safari: '9.79',
	  'Microsoft Edge': '4.69',
	  Opera: '1.71',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 9',
	  'Google Chrome': '53.05',
	  'Internet Explorer': '18.2',
	  Firefox: '16.1',
	  Safari: '7.92',
	  'Microsoft Edge': '3.58',
	  Opera: '1.08',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 10',
	  'Google Chrome': '52.83',
	  'Internet Explorer': '18.34',
	  Firefox: '16.14',
	  Safari: '7.77',
	  'Microsoft Edge': '3.62',
	  Opera: '1.24',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 11',
	  'Google Chrome': '53.18',
	  'Internet Explorer': '17.93',
	  Firefox: '16.28',
	  Safari: '7.67',
	  'Microsoft Edge': '3.6',
	  Opera: '1.26',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 12',
	  'Google Chrome': '52.5',
	  'Internet Explorer': '18.46',
	  Firefox: '16.41',
	  Safari: '7.53',
	  'Microsoft Edge': '3.63',
	  Opera: '1.4',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 13',
	  'Google Chrome': '51.81',
	  'Internet Explorer': '18.58',
	  Firefox: '16.66',
	  Safari: '7.6',
	  'Microsoft Edge': '3.77',
	  Opera: '1.48',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 14',
	  'Google Chrome': '50.29',
	  'Internet Explorer': '15.33',
	  Firefox: '17.99',
	  Safari: '9.42',
	  'Microsoft Edge': '4.96',
	  Opera: '1.91',
	  Mozilla: '0.1',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 15',
	  'Google Chrome': '51.36',
	  'Internet Explorer': '14.55',
	  Firefox: '17.56',
	  Safari: '9.66',
	  'Microsoft Edge': '4.91',
	  Opera: '1.87',
	  Mozilla: '0.08',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 16',
	  'Google Chrome': '52.3',
	  'Internet Explorer': '18.24',
	  Firefox: '16.41',
	  Safari: '7.76',
	  'Microsoft Edge': '3.73',
	  Opera: '1.49',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 17',
	  'Google Chrome': '52.05',
	  'Internet Explorer': '18.88',
	  Firefox: '16.42',
	  Safari: '7.64',
	  'Microsoft Edge': '3.57',
	  Opera: '1.37',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 18',
	  'Google Chrome': '51.99',
	  'Internet Explorer': '18.87',
	  Firefox: '16.43',
	  Safari: '7.76',
	  'Microsoft Edge': '3.64',
	  Opera: '1.24',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 19',
	  'Google Chrome': '51.67',
	  'Internet Explorer': '19.25',
	  Firefox: '16.18',
	  Safari: '7.96',
	  'Microsoft Edge': '3.77',
	  Opera: '1.1',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 20',
	  'Google Chrome': '51.75',
	  'Internet Explorer': '18.51',
	  Firefox: '16.52',
	  Safari: '7.88',
	  'Microsoft Edge': '4.09',
	  Opera: '1.19',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 21',
	  'Google Chrome': '51.83',
	  'Internet Explorer': '14.13',
	  Firefox: '17.6',
	  Safari: '9.54',
	  'Microsoft Edge': '5.19',
	  Opera: '1.62',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 22',
	  'Google Chrome': '52.46',
	  'Internet Explorer': '13.53',
	  Firefox: '17.44',
	  Safari: '9.82',
	  'Microsoft Edge': '5.07',
	  Opera: '1.61',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 23',
	  'Google Chrome': '52.6',
	  'Internet Explorer': '18.04',
	  Firefox: '16.37',
	  Safari: '7.69',
	  'Microsoft Edge': '3.95',
	  Opera: '1.3',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 24',
	  'Google Chrome': '52.83',
	  'Internet Explorer': '17.85',
	  Firefox: '16.46',
	  Safari: '7.58',
	  'Microsoft Edge': '3.91',
	  Opera: '1.32',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 25',
	  'Google Chrome': '53.16',
	  'Internet Explorer': '17.45',
	  Firefox: '16.35',
	  Safari: '7.6',
	  'Microsoft Edge': '3.99',
	  Opera: '1.39',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 26',
	  'Google Chrome': '52.81',
	  'Internet Explorer': '17.8',
	  Firefox: '16.38',
	  Safari: '7.67',
	  'Microsoft Edge': '3.95',
	  Opera: '1.33',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 27',
	  'Google Chrome': '52.54',
	  'Internet Explorer': '17.27',
	  Firefox: '16.86',
	  Safari: '7.73',
	  'Microsoft Edge': '4.17',
	  Opera: '1.35',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 28',
	  'Google Chrome': '52.58',
	  'Internet Explorer': '13.24',
	  Firefox: '17.76',
	  Safari: '9.27',
	  'Microsoft Edge': '5.33',
	  Opera: '1.74',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 29',
	  'Google Chrome': '52.85',
	  'Internet Explorer': '12.95',
	  Firefox: '17.78',
	  Safari: '9.34',
	  'Microsoft Edge': '5.29',
	  Opera: '1.72',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 30',
	  'Google Chrome': '52.89',
	  'Internet Explorer': '14.39',
	  Firefox: '17.67',
	  Safari: '8.53',
	  'Microsoft Edge': '4.86',
	  Opera: '1.59',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 May 31',
	  'Google Chrome': '53.61',
	  'Internet Explorer': '17.15',
	  Firefox: '16.08',
	  Safari: '7.6',
	  'Microsoft Edge': '4.13',
	  Opera: '1.37',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 1',
	  'Google Chrome': '53.58',
	  'Internet Explorer': '16.65',
	  Firefox: '16.01',
	  Safari: '7.99',
	  'Microsoft Edge': '4.29',
	  Opera: '1.42',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 2',
	  'Google Chrome': '52.76',
	  'Internet Explorer': '17.4',
	  Firefox: '16.35',
	  Safari: '7.81',
	  'Microsoft Edge': '4.29',
	  Opera: '1.33',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 3',
	  'Google Chrome': '52.44',
	  'Internet Explorer': '16.96',
	  Firefox: '16.52',
	  Safari: '7.71',
	  'Microsoft Edge': '4.6',
	  Opera: '1.69',
	  Mozilla: '0.08',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 4',
	  'Google Chrome': '52.33',
	  'Internet Explorer': '12.93',
	  Firefox: '17.3',
	  Safari: '9.52',
	  'Microsoft Edge': '5.88',
	  Opera: '1.96',
	  Mozilla: '0.08',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 5',
	  'Google Chrome': '52.38',
	  'Internet Explorer': '12.56',
	  Firefox: '17.42',
	  Safari: '9.66',
	  'Microsoft Edge': '5.76',
	  Opera: '2.14',
	  Mozilla: '0.08',
	  'Other/Unknown': '0.01'
	}, {
	  date: '2016 Jun 6',
	  'Google Chrome': '52.69',
	  'Internet Explorer': '17.32',
	  Firefox: '16.31',
	  Safari: '7.43',
	  'Microsoft Edge': '4.18',
	  Opera: '2.01',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 7',
	  'Google Chrome': '52.95',
	  'Internet Explorer': '17.47',
	  Firefox: '16.28',
	  Safari: '7.65',
	  'Microsoft Edge': '4.05',
	  Opera: '1.55',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 8',
	  'Google Chrome': '52.68',
	  'Internet Explorer': '17.66',
	  Firefox: '16.3',
	  Safari: '7.6',
	  'Microsoft Edge': '4.14',
	  Opera: '1.56',
	  Mozilla: '0.06',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 9',
	  'Google Chrome': '52.3',
	  'Internet Explorer': '18.02',
	  Firefox: '16.25',
	  Safari: '7.85',
	  'Microsoft Edge': '4.14',
	  Opera: '1.38',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 10',
	  'Google Chrome': '52.22',
	  'Internet Explorer': '17.36',
	  Firefox: '16.46',
	  Safari: '7.96',
	  'Microsoft Edge': '4.44',
	  Opera: '1.49',
	  Mozilla: '0.07',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 11',
	  'Google Chrome': '52.06',
	  'Internet Explorer': '13.19',
	  Firefox: '17.21',
	  Safari: '9.98',
	  'Microsoft Edge': '5.78',
	  Opera: '1.69',
	  Mozilla: '0.09',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 12',
	  'Google Chrome': '52.09',
	  'Internet Explorer': '12.75',
	  Firefox: '16.89',
	  Safari: '10.65',
	  'Microsoft Edge': '5.96',
	  Opera: '1.6',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 13',
	  'Google Chrome': '53.18',
	  'Internet Explorer': '16.87',
	  Firefox: '16.21',
	  Safari: '8.15',
	  'Microsoft Edge': '4.39',
	  Opera: '1.15',
	  Mozilla: '0.05',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 14',
	  'Google Chrome': '53.45',
	  'Internet Explorer': '17.03',
	  Firefox: '16.15',
	  Safari: '7.8',
	  'Microsoft Edge': '4.31',
	  Opera: '1.21',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}, {
	  date: '2016 Jun 15',
	  'Google Chrome': '53.4',
	  'Internet Explorer': '18.12',
	  Firefox: '16.51',
	  Safari: '6.69',
	  'Microsoft Edge': '3.84',
	  Opera: '1.4',
	  Mozilla: '0.04',
	  'Other/Unknown': '0'
	}];

/***/ },
/* 661 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  date: '20111001',
	  'New York': '63.4',
	  'San Francisco': '62.7',
	  Austin: '72.2'
	}, {
	  date: '20111002',
	  'New York': '58.0',
	  'San Francisco': '59.9',
	  Austin: '67.7'
	}, {
	  date: '20111003',
	  'New York': '53.3',
	  'San Francisco': '59.1',
	  Austin: '69.4'
	}, {
	  date: '20111004',
	  'New York': '55.7',
	  'San Francisco': '58.8',
	  Austin: '68.0'
	}, {
	  date: '20111005',
	  'New York': '64.2',
	  'San Francisco': '58.7',
	  Austin: '72.4'
	}, {
	  date: '20111006',
	  'New York': '58.8',
	  'San Francisco': '57.0',
	  Austin: '77.0'
	}, {
	  date: '20111007',
	  'New York': '57.9',
	  'San Francisco': '56.7',
	  Austin: '82.3'
	}, {
	  date: '20111008',
	  'New York': '61.8',
	  'San Francisco': '56.8',
	  Austin: '78.9'
	}, {
	  date: '20111009',
	  'New York': '69.3',
	  'San Francisco': '56.7',
	  Austin: '68.8'
	}, {
	  date: '20111010',
	  'New York': '71.2',
	  'San Francisco': '60.1',
	  Austin: '68.7'
	}, {
	  date: '20111011',
	  'New York': '68.7',
	  'San Francisco': '61.1',
	  Austin: '70.3'
	}, {
	  date: '20111012',
	  'New York': '61.8',
	  'San Francisco': '61.5',
	  Austin: '75.3'
	}, {
	  date: '20111013',
	  'New York': '63.0',
	  'San Francisco': '64.3',
	  Austin: '76.6'
	}, {
	  date: '20111014',
	  'New York': '66.9',
	  'San Francisco': '67.1',
	  Austin: '66.6'
	}, {
	  date: '20111015',
	  'New York': '61.7',
	  'San Francisco': '64.6',
	  Austin: '68.0'
	}, {
	  date: '20111016',
	  'New York': '61.8',
	  'San Francisco': '61.6',
	  Austin: '70.6'
	}, {
	  date: '20111017',
	  'New York': '62.8',
	  'San Francisco': '61.1',
	  Austin: '71.1'
	}, {
	  date: '20111018',
	  'New York': '60.8',
	  'San Francisco': '59.2',
	  Austin: '70.0'
	}, {
	  date: '20111019',
	  'New York': '62.1',
	  'San Francisco': '58.9',
	  Austin: '61.6'
	}, {
	  date: '20111020',
	  'New York': '65.1',
	  'San Francisco': '57.2',
	  Austin: '57.4'
	}, {
	  date: '20111021',
	  'New York': '55.6',
	  'San Francisco': '56.4',
	  Austin: '64.3'
	}, {
	  date: '20111022',
	  'New York': '54.4',
	  'San Francisco': '60.7',
	  Austin: '72.4'
	}, {
	  date: '20111023',
	  'New York': '54.4',
	  'San Francisco': '65.1',
	  Austin: '72.4'
	}, {
	  date: '20111024',
	  'New York': '54.8',
	  'San Francisco': '60.9',
	  Austin: '72.5'
	}, {
	  date: '20111025',
	  'New York': '57.9',
	  'San Francisco': '56.1',
	  Austin: '72.7'
	}, {
	  date: '20111026',
	  'New York': '54.6',
	  'San Francisco': '54.6',
	  Austin: '73.4'
	}, {
	  date: '20111027',
	  'New York': '54.4',
	  'San Francisco': '56.1',
	  Austin: '70.7'
	}, {
	  date: '20111028',
	  'New York': '42.5',
	  'San Francisco': '58.1',
	  Austin: '56.8'
	}, {
	  date: '20111029',
	  'New York': '40.9',
	  'San Francisco': '57.5',
	  Austin: '51.0'
	}, {
	  date: '20111030',
	  'New York': '38.6',
	  'San Francisco': '57.7',
	  Austin: '54.9'
	}, {
	  date: '20111031',
	  'New York': '44.2',
	  'San Francisco': '55.1',
	  Austin: '58.8'
	}, {
	  date: '20111101',
	  'New York': '49.6',
	  'San Francisco': '57.9',
	  Austin: '62.6'
	}, {
	  date: '20111102',
	  'New York': '47.2',
	  'San Francisco': '64.6',
	  Austin: '71.0'
	}, {
	  date: '20111103',
	  'New York': '50.1',
	  'San Francisco': '56.2',
	  Austin: '58.4'
	}, {
	  date: '20111104',
	  'New York': '50.1',
	  'San Francisco': '50.5',
	  Austin: '45.1'
	}, {
	  date: '20111105',
	  'New York': '43.5',
	  'San Francisco': '51.3',
	  Austin: '52.2'
	}, {
	  date: '20111106',
	  'New York': '43.8',
	  'San Francisco': '52.6',
	  Austin: '73.0'
	}, {
	  date: '20111107',
	  'New York': '48.9',
	  'San Francisco': '51.4',
	  Austin: '75.4'
	}, {
	  date: '20111108',
	  'New York': '55.5',
	  'San Francisco': '50.6',
	  Austin: '72.1'
	}, {
	  date: '20111109',
	  'New York': '53.7',
	  'San Francisco': '54.6',
	  Austin: '56.6'
	}, {
	  date: '20111110',
	  'New York': '57.7',
	  'San Francisco': '55.6',
	  Austin: '55.4'
	}, {
	  date: '20111111',
	  'New York': '48.5',
	  'San Francisco': '53.9',
	  Austin: '46.7'
	}, {
	  date: '20111112',
	  'New York': '46.8',
	  'San Francisco': '54.0',
	  Austin: '62.0'
	}, {
	  date: '20111113',
	  'New York': '51.1',
	  'San Francisco': '53.8',
	  Austin: '71.6'
	}, {
	  date: '20111114',
	  'New York': '56.8',
	  'San Francisco': '53.5',
	  Austin: '75.5'
	}, {
	  date: '20111115',
	  'New York': '59.7',
	  'San Francisco': '53.4',
	  Austin: '72.1'
	}, {
	  date: '20111116',
	  'New York': '56.5',
	  'San Francisco': '52.2',
	  Austin: '65.7'
	}, {
	  date: '20111117',
	  'New York': '49.6',
	  'San Francisco': '52.7',
	  Austin: '56.8'
	}, {
	  date: '20111118',
	  'New York': '41.5',
	  'San Francisco': '53.1',
	  Austin: '49.9'
	}, {
	  date: '20111119',
	  'New York': '44.3',
	  'San Francisco': '49.0',
	  Austin: '71.7'
	}, {
	  date: '20111120',
	  'New York': '54.0',
	  'San Francisco': '50.4',
	  Austin: '77.7'
	}, {
	  date: '20111121',
	  'New York': '54.1',
	  'San Francisco': '51.1',
	  Austin: '76.4'
	}, {
	  date: '20111122',
	  'New York': '49.4',
	  'San Francisco': '52.3',
	  Austin: '68.8'
	}, {
	  date: '20111123',
	  'New York': '50.0',
	  'San Francisco': '54.6',
	  Austin: '57.0'
	}, {
	  date: '20111124',
	  'New York': '44.0',
	  'San Francisco': '55.1',
	  Austin: '55.5'
	}, {
	  date: '20111125',
	  'New York': '50.3',
	  'San Francisco': '51.5',
	  Austin: '61.6'
	}, {
	  date: '20111126',
	  'New York': '52.1',
	  'San Francisco': '53.6',
	  Austin: '64.1'
	}, {
	  date: '20111127',
	  'New York': '49.6',
	  'San Francisco': '52.3',
	  Austin: '51.1'
	}, {
	  date: '20111128',
	  'New York': '57.2',
	  'San Francisco': '51.0',
	  Austin: '43.0'
	}, {
	  date: '20111129',
	  'New York': '59.1',
	  'San Francisco': '49.5',
	  Austin: '46.4'
	}, {
	  date: '20111130',
	  'New York': '50.6',
	  'San Francisco': '49.8',
	  Austin: '48.0'
	}, {
	  date: '20111201',
	  'New York': '44.3',
	  'San Francisco': '60.4',
	  Austin: '48.1'
	}, {
	  date: '20111202',
	  'New York': '43.9',
	  'San Francisco': '62.2',
	  Austin: '60.6'
	}, {
	  date: '20111203',
	  'New York': '42.1',
	  'San Francisco': '58.3',
	  Austin: '62.6'
	}, {
	  date: '20111204',
	  'New York': '43.9',
	  'San Francisco': '52.7',
	  Austin: '57.1'
	}, {
	  date: '20111205',
	  'New York': '50.2',
	  'San Francisco': '51.5',
	  Austin: '44.2'
	}, {
	  date: '20111206',
	  'New York': '54.2',
	  'San Francisco': '49.9',
	  Austin: '37.4'
	}, {
	  date: '20111207',
	  'New York': '54.6',
	  'San Francisco': '48.6',
	  Austin: '35.0'
	}, {
	  date: '20111208',
	  'New York': '43.4',
	  'San Francisco': '46.4',
	  Austin: '37.0'
	}, {
	  date: '20111209',
	  'New York': '42.2',
	  'San Francisco': '49.8',
	  Austin: '45.4'
	}, {
	  date: '20111210',
	  'New York': '45.0',
	  'San Francisco': '52.1',
	  Austin: '50.7'
	}, {
	  date: '20111211',
	  'New York': '33.8',
	  'San Francisco': '48.8',
	  Austin: '48.6'
	}, {
	  date: '20111212',
	  'New York': '36.8',
	  'San Francisco': '47.4',
	  Austin: '52.2'
	}, {
	  date: '20111213',
	  'New York': '38.6',
	  'San Francisco': '47.2',
	  Austin: '60.8'
	}, {
	  date: '20111214',
	  'New York': '41.9',
	  'San Francisco': '46.1',
	  Austin: '70.0'
	}, {
	  date: '20111215',
	  'New York': '49.6',
	  'San Francisco': '48.8',
	  Austin: '64.2'
	}, {
	  date: '20111216',
	  'New York': '50.2',
	  'San Francisco': '47.9',
	  Austin: '50.9'
	}, {
	  date: '20111217',
	  'New York': '40.6',
	  'San Francisco': '49.8',
	  Austin: '51.6'
	}, {
	  date: '20111218',
	  'New York': '29.1',
	  'San Francisco': '49.1',
	  Austin: '55.2'
	}, {
	  date: '20111219',
	  'New York': '33.7',
	  'San Francisco': '48.3',
	  Austin: '62.1'
	}, {
	  date: '20111220',
	  'New York': '45.8',
	  'San Francisco': '49.3',
	  Austin: '56.3'
	}, {
	  date: '20111221',
	  'New York': '47.4',
	  'San Francisco': '48.4',
	  Austin: '47.2'
	}, {
	  date: '20111222',
	  'New York': '54.4',
	  'San Francisco': '53.3',
	  Austin: '52.3'
	}, {
	  date: '20111223',
	  'New York': '47.8',
	  'San Francisco': '47.5',
	  Austin: '45.2'
	}, {
	  date: '20111224',
	  'New York': '34.9',
	  'San Francisco': '47.9',
	  Austin: '43.6'
	}, {
	  date: '20111225',
	  'New York': '35.9',
	  'San Francisco': '48.9',
	  Austin: '42.9'
	}, {
	  date: '20111226',
	  'New York': '43.6',
	  'San Francisco': '45.9',
	  Austin: '48.2'
	}, {
	  date: '20111227',
	  'New York': '42.9',
	  'San Francisco': '47.2',
	  Austin: '45.4'
	}, {
	  date: '20111228',
	  'New York': '46.2',
	  'San Francisco': '48.9',
	  Austin: '44.2'
	}, {
	  date: '20111229',
	  'New York': '30.8',
	  'San Francisco': '50.9',
	  Austin: '50.4'
	}, {
	  date: '20111230',
	  'New York': '40.8',
	  'San Francisco': '52.9',
	  Austin: '52.4'
	}, {
	  date: '20111231',
	  'New York': '49.8',
	  'San Francisco': '50.1',
	  Austin: '53.5'
	}, {
	  date: '20120101',
	  'New York': '46.3',
	  'San Francisco': '53.9',
	  Austin: '55.9'
	}, {
	  date: '20120102',
	  'New York': '43.2',
	  'San Francisco': '53.1',
	  Austin: '48.2'
	}, {
	  date: '20120103',
	  'New York': '30.3',
	  'San Francisco': '49.7',
	  Austin: '41.0'
	}, {
	  date: '20120104',
	  'New York': '19.2',
	  'San Francisco': '52.7',
	  Austin: '48.9'
	}, {
	  date: '20120105',
	  'New York': '32.1',
	  'San Francisco': '52.6',
	  Austin: '54.8'
	}, {
	  date: '20120106',
	  'New York': '41.2',
	  'San Francisco': '49.0',
	  Austin: '61.2'
	}, {
	  date: '20120107',
	  'New York': '47.0',
	  'San Francisco': '51.0',
	  Austin: '59.7'
	}, {
	  date: '20120108',
	  'New York': '46.0',
	  'San Francisco': '56.8',
	  Austin: '52.5'
	}, {
	  date: '20120109',
	  'New York': '34.7',
	  'San Francisco': '52.3',
	  Austin: '54.0'
	}, {
	  date: '20120110',
	  'New York': '39.4',
	  'San Francisco': '51.6',
	  Austin: '47.7'
	}, {
	  date: '20120111',
	  'New York': '40.4',
	  'San Francisco': '49.8',
	  Austin: '49.2'
	}, {
	  date: '20120112',
	  'New York': '45.4',
	  'San Francisco': '51.9',
	  Austin: '48.4'
	}, {
	  date: '20120113',
	  'New York': '40.7',
	  'San Francisco': '53.7',
	  Austin: '40.2'
	}, {
	  date: '20120114',
	  'New York': '30.4',
	  'San Francisco': '52.9',
	  Austin: '43.9'
	}, {
	  date: '20120115',
	  'New York': '23.9',
	  'San Francisco': '49.7',
	  Austin: '45.2'
	}, {
	  date: '20120116',
	  'New York': '22.6',
	  'San Francisco': '45.3',
	  Austin: '65.0'
	}, {
	  date: '20120117',
	  'New York': '39.8',
	  'San Francisco': '43.6',
	  Austin: '68.2'
	}, {
	  date: '20120118',
	  'New York': '43.2',
	  'San Francisco': '45.0',
	  Austin: '47.5'
	}, {
	  date: '20120119',
	  'New York': '26.3',
	  'San Francisco': '47.3',
	  Austin: '57.1'
	}, {
	  date: '20120120',
	  'New York': '32.8',
	  'San Francisco': '51.4',
	  Austin: '61.9'
	}, {
	  date: '20120121',
	  'New York': '27.4',
	  'San Francisco': '53.7',
	  Austin: '54.6'
	}, {
	  date: '20120122',
	  'New York': '25.0',
	  'San Francisco': '48.3',
	  Austin: '56.7'
	}, {
	  date: '20120123',
	  'New York': '39.4',
	  'San Francisco': '52.9',
	  Austin: '54.4'
	}, {
	  date: '20120124',
	  'New York': '48.7',
	  'San Francisco': '49.1',
	  Austin: '52.7'
	}, {
	  date: '20120125',
	  'New York': '43.0',
	  'San Francisco': '52.1',
	  Austin: '61.8'
	}, {
	  date: '20120126',
	  'New York': '37.1',
	  'San Francisco': '53.6',
	  Austin: '55.0'
	}, {
	  date: '20120127',
	  'New York': '48.2',
	  'San Francisco': '50.4',
	  Austin: '50.7'
	}, {
	  date: '20120128',
	  'New York': '43.7',
	  'San Francisco': '50.3',
	  Austin: '52.9'
	}, {
	  date: '20120129',
	  'New York': '40.1',
	  'San Francisco': '53.8',
	  Austin: '44.4'
	}, {
	  date: '20120130',
	  'New York': '38.0',
	  'San Francisco': '51.9',
	  Austin: '49.1'
	}, {
	  date: '20120131',
	  'New York': '43.5',
	  'San Francisco': '50.0',
	  Austin: '62.8'
	}, {
	  date: '20120201',
	  'New York': '50.4',
	  'San Francisco': '50.0',
	  Austin: '64.6'
	}, {
	  date: '20120202',
	  'New York': '45.8',
	  'San Francisco': '51.3',
	  Austin: '61.1'
	}, {
	  date: '20120203',
	  'New York': '37.5',
	  'San Francisco': '51.5',
	  Austin: '70.0'
	}, {
	  date: '20120204',
	  'New York': '40.8',
	  'San Francisco': '52.0',
	  Austin: '61.3'
	}, {
	  date: '20120205',
	  'New York': '36.5',
	  'San Francisco': '53.8',
	  Austin: '48.2'
	}, {
	  date: '20120206',
	  'New York': '39.1',
	  'San Francisco': '54.6',
	  Austin: '44.2'
	}, {
	  date: '20120207',
	  'New York': '43.2',
	  'San Francisco': '54.3',
	  Austin: '51.3'
	}, {
	  date: '20120208',
	  'New York': '36.5',
	  'San Francisco': '51.9',
	  Austin: '49.2'
	}, {
	  date: '20120209',
	  'New York': '36.5',
	  'San Francisco': '53.8',
	  Austin: '45.7'
	}, {
	  date: '20120210',
	  'New York': '38.3',
	  'San Francisco': '53.9',
	  Austin: '54.1'
	}, {
	  date: '20120211',
	  'New York': '36.9',
	  'San Francisco': '52.3',
	  Austin: '44.9'
	}, {
	  date: '20120212',
	  'New York': '29.7',
	  'San Francisco': '50.1',
	  Austin: '36.5'
	}, {
	  date: '20120213',
	  'New York': '33.1',
	  'San Francisco': '49.5',
	  Austin: '44.8'
	}, {
	  date: '20120214',
	  'New York': '39.6',
	  'San Francisco': '48.6',
	  Austin: '52.3'
	}, {
	  date: '20120215',
	  'New York': '42.3',
	  'San Francisco': '49.9',
	  Austin: '68.0'
	}, {
	  date: '20120216',
	  'New York': '39.7',
	  'San Francisco': '52.4',
	  Austin: '54.6'
	}, {
	  date: '20120217',
	  'New York': '46.0',
	  'San Francisco': '49.9',
	  Austin: '53.8'
	}, {
	  date: '20120218',
	  'New York': '41.2',
	  'San Francisco': '51.6',
	  Austin: '56.2'
	}, {
	  date: '20120219',
	  'New York': '39.8',
	  'San Francisco': '47.8',
	  Austin: '50.8'
	}, {
	  date: '20120220',
	  'New York': '38.1',
	  'San Francisco': '48.7',
	  Austin: '53.0'
	}, {
	  date: '20120221',
	  'New York': '37.1',
	  'San Francisco': '49.7',
	  Austin: '61.0'
	}, {
	  date: '20120222',
	  'New York': '45.5',
	  'San Francisco': '53.4',
	  Austin: '68.8'
	}, {
	  date: '20120223',
	  'New York': '50.6',
	  'San Francisco': '54.1',
	  Austin: '69.4'
	}, {
	  date: '20120224',
	  'New York': '42.7',
	  'San Francisco': '55.9',
	  Austin: '59.3'
	}, {
	  date: '20120225',
	  'New York': '42.6',
	  'San Francisco': '51.7',
	  Austin: '47.2'
	}, {
	  date: '20120226',
	  'New York': '36.9',
	  'San Francisco': '47.7',
	  Austin: '47.7'
	}, {
	  date: '20120227',
	  'New York': '40.9',
	  'San Francisco': '45.4',
	  Austin: '61.9'
	}, {
	  date: '20120228',
	  'New York': '45.9',
	  'San Francisco': '47.0',
	  Austin: '67.2'
	}, {
	  date: '20120229',
	  'New York': '40.7',
	  'San Francisco': '49.8',
	  Austin: '70.1'
	}, {
	  date: '20120301',
	  'New York': '41.3',
	  'San Francisco': '48.9',
	  Austin: '62.1'
	}, {
	  date: '20120302',
	  'New York': '36.8',
	  'San Francisco': '48.1',
	  Austin: '72.7'
	}, {
	  date: '20120303',
	  'New York': '47.6',
	  'San Francisco': '50.7',
	  Austin: '59.0'
	}, {
	  date: '20120304',
	  'New York': '44.2',
	  'San Francisco': '55.0',
	  Austin: '51.8'
	}, {
	  date: '20120305',
	  'New York': '38.5',
	  'San Francisco': '48.8',
	  Austin: '55.0'
	}, {
	  date: '20120306',
	  'New York': '32.9',
	  'San Francisco': '48.4',
	  Austin: '61.8'
	}, {
	  date: '20120307',
	  'New York': '43.3',
	  'San Francisco': '49.9',
	  Austin: '67.1'
	}, {
	  date: '20120308',
	  'New York': '51.2',
	  'San Francisco': '49.2',
	  Austin: '72.0'
	}, {
	  date: '20120309',
	  'New York': '47.8',
	  'San Francisco': '51.7',
	  Austin: '46.4'
	}, {
	  date: '20120310',
	  'New York': '37.2',
	  'San Francisco': '49.3',
	  Austin: '46.7'
	}, {
	  date: '20120311',
	  'New York': '42.9',
	  'San Francisco': '50.0',
	  Austin: '56.9'
	}, {
	  date: '20120312',
	  'New York': '48.8',
	  'San Francisco': '48.6',
	  Austin: '61.9'
	}, {
	  date: '20120313',
	  'New York': '52.6',
	  'San Francisco': '53.9',
	  Austin: '68.8'
	}, {
	  date: '20120314',
	  'New York': '60.5',
	  'San Francisco': '55.2',
	  Austin: '71.9'
	}, {
	  date: '20120315',
	  'New York': '47.2',
	  'San Francisco': '55.9',
	  Austin: '72.0'
	}, {
	  date: '20120316',
	  'New York': '44.7',
	  'San Francisco': '54.6',
	  Austin: '72.5'
	}, {
	  date: '20120317',
	  'New York': '48.2',
	  'San Francisco': '48.2',
	  Austin: '71.7'
	}, {
	  date: '20120318',
	  'New York': '48.2',
	  'San Francisco': '47.1',
	  Austin: '71.1'
	}, {
	  date: '20120319',
	  'New York': '53.1',
	  'San Francisco': '45.8',
	  Austin: '73.0'
	}, {
	  date: '20120320',
	  'New York': '57.8',
	  'San Francisco': '49.7',
	  Austin: '63.8'
	}, {
	  date: '20120321',
	  'New York': '57.5',
	  'San Francisco': '51.4',
	  Austin: '60.0'
	}, {
	  date: '20120322',
	  'New York': '57.3',
	  'San Francisco': '51.4',
	  Austin: '62.3'
	}, {
	  date: '20120323',
	  'New York': '61.7',
	  'San Francisco': '48.4',
	  Austin: '61.1'
	}, {
	  date: '20120324',
	  'New York': '55.8',
	  'San Francisco': '49.0',
	  Austin: '62.0'
	}, {
	  date: '20120325',
	  'New York': '48.4',
	  'San Francisco': '46.4',
	  Austin: '64.6'
	}, {
	  date: '20120326',
	  'New York': '49.8',
	  'San Francisco': '49.7',
	  Austin: '66.0'
	}, {
	  date: '20120327',
	  'New York': '39.6',
	  'San Francisco': '54.1',
	  Austin: '65.8'
	}, {
	  date: '20120328',
	  'New York': '49.7',
	  'San Francisco': '54.6',
	  Austin: '69.2'
	}, {
	  date: '20120329',
	  'New York': '56.8',
	  'San Francisco': '52.3',
	  Austin: '69.5'
	}, {
	  date: '20120330',
	  'New York': '46.5',
	  'San Francisco': '54.5',
	  Austin: '73.5'
	}, {
	  date: '20120331',
	  'New York': '42.2',
	  'San Francisco': '56.2',
	  Austin: '73.9'
	}, {
	  date: '20120401',
	  'New York': '45.3',
	  'San Francisco': '51.1',
	  Austin: '75.3'
	}, {
	  date: '20120402',
	  'New York': '48.1',
	  'San Francisco': '50.5',
	  Austin: '75.4'
	}, {
	  date: '20120403',
	  'New York': '51.2',
	  'San Francisco': '52.2',
	  Austin: '77.3'
	}, {
	  date: '20120404',
	  'New York': '61.0',
	  'San Francisco': '50.6',
	  Austin: '67.0'
	}, {
	  date: '20120405',
	  'New York': '50.7',
	  'San Francisco': '47.9',
	  Austin: '71.1'
	}, {
	  date: '20120406',
	  'New York': '48.0',
	  'San Francisco': '47.4',
	  Austin: '70.4'
	}, {
	  date: '20120407',
	  'New York': '51.1',
	  'San Francisco': '49.4',
	  Austin: '73.6'
	}, {
	  date: '20120408',
	  'New York': '55.7',
	  'San Francisco': '50.0',
	  Austin: '71.1'
	}, {
	  date: '20120409',
	  'New York': '58.3',
	  'San Francisco': '51.3',
	  Austin: '70.0'
	}, {
	  date: '20120410',
	  'New York': '55.0',
	  'San Francisco': '53.8',
	  Austin: '69.0'
	}, {
	  date: '20120411',
	  'New York': '49.0',
	  'San Francisco': '52.9',
	  Austin: '69.2'
	}, {
	  date: '20120412',
	  'New York': '51.7',
	  'San Francisco': '53.9',
	  Austin: '74.5'
	}, {
	  date: '20120413',
	  'New York': '53.1',
	  'San Francisco': '50.2',
	  Austin: '73.4'
	}, {
	  date: '20120414',
	  'New York': '55.2',
	  'San Francisco': '50.9',
	  Austin: '76.0'
	}, {
	  date: '20120415',
	  'New York': '62.3',
	  'San Francisco': '51.5',
	  Austin: '74.5'
	}, {
	  date: '20120416',
	  'New York': '62.9',
	  'San Francisco': '51.9',
	  Austin: '63.6'
	}, {
	  date: '20120417',
	  'New York': '69.3',
	  'San Francisco': '53.2',
	  Austin: '67.3'
	}, {
	  date: '20120418',
	  'New York': '59.0',
	  'San Francisco': '53.0',
	  Austin: '65.1'
	}, {
	  date: '20120419',
	  'New York': '54.1',
	  'San Francisco': '55.1',
	  Austin: '67.9'
	}, {
	  date: '20120420',
	  'New York': '56.5',
	  'San Francisco': '55.8',
	  Austin: '68.9'
	}, {
	  date: '20120421',
	  'New York': '58.2',
	  'San Francisco': '58.0',
	  Austin: '65.1'
	}, {
	  date: '20120422',
	  'New York': '52.4',
	  'San Francisco': '52.8',
	  Austin: '65.4'
	}, {
	  date: '20120423',
	  'New York': '51.6',
	  'San Francisco': '55.1',
	  Austin: '70.1'
	}, {
	  date: '20120424',
	  'New York': '49.3',
	  'San Francisco': '57.9',
	  Austin: '67.0'
	}, {
	  date: '20120425',
	  'New York': '52.5',
	  'San Francisco': '57.5',
	  Austin: '75.4'
	}, {
	  date: '20120426',
	  'New York': '50.5',
	  'San Francisco': '55.3',
	  Austin: '77.5'
	}, {
	  date: '20120427',
	  'New York': '51.9',
	  'San Francisco': '53.5',
	  Austin: '77.0'
	}, {
	  date: '20120428',
	  'New York': '47.4',
	  'San Francisco': '54.7',
	  Austin: '77.7'
	}, {
	  date: '20120429',
	  'New York': '54.1',
	  'San Francisco': '54.0',
	  Austin: '77.7'
	}, {
	  date: '20120430',
	  'New York': '51.9',
	  'San Francisco': '53.4',
	  Austin: '77.7'
	}, {
	  date: '20120501',
	  'New York': '57.4',
	  'San Francisco': '52.7',
	  Austin: '77.0'
	}, {
	  date: '20120502',
	  'New York': '53.7',
	  'San Francisco': '50.7',
	  Austin: '77.9'
	}, {
	  date: '20120503',
	  'New York': '53.1',
	  'San Francisco': '52.6',
	  Austin: '79.1'
	}, {
	  date: '20120504',
	  'New York': '57.2',
	  'San Francisco': '53.4',
	  Austin: '80.1'
	}, {
	  date: '20120505',
	  'New York': '57.0',
	  'San Francisco': '53.1',
	  Austin: '82.1'
	}, {
	  date: '20120506',
	  'New York': '56.6',
	  'San Francisco': '56.5',
	  Austin: '79.0'
	}, {
	  date: '20120507',
	  'New York': '54.6',
	  'San Francisco': '55.3',
	  Austin: '79.8'
	}, {
	  date: '20120508',
	  'New York': '57.9',
	  'San Francisco': '52.0',
	  Austin: '70.0'
	}, {
	  date: '20120509',
	  'New York': '59.2',
	  'San Francisco': '52.4',
	  Austin: '69.8'
	}, {
	  date: '20120510',
	  'New York': '61.1',
	  'San Francisco': '53.4',
	  Austin: '71.3'
	}, {
	  date: '20120511',
	  'New York': '59.7',
	  'San Francisco': '53.1',
	  Austin: '69.4'
	}, {
	  date: '20120512',
	  'New York': '64.1',
	  'San Francisco': '49.9',
	  Austin: '72.0'
	}, {
	  date: '20120513',
	  'New York': '65.3',
	  'San Francisco': '52.0',
	  Austin: '72.4'
	}, {
	  date: '20120514',
	  'New York': '64.2',
	  'San Francisco': '56.0',
	  Austin: '72.5'
	}, {
	  date: '20120515',
	  'New York': '62.0',
	  'San Francisco': '53.0',
	  Austin: '67.6'
	}, {
	  date: '20120516',
	  'New York': '63.8',
	  'San Francisco': '51.0',
	  Austin: '69.0'
	}, {
	  date: '20120517',
	  'New York': '64.5',
	  'San Francisco': '51.4',
	  Austin: '72.7'
	}, {
	  date: '20120518',
	  'New York': '61.0',
	  'San Francisco': '52.2',
	  Austin: '73.7'
	}, {
	  date: '20120519',
	  'New York': '62.6',
	  'San Francisco': '52.4',
	  Austin: '77.5'
	}, {
	  date: '20120520',
	  'New York': '66.2',
	  'San Francisco': '54.5',
	  Austin: '75.8'
	}, {
	  date: '20120521',
	  'New York': '62.7',
	  'San Francisco': '52.8',
	  Austin: '76.9'
	}, {
	  date: '20120522',
	  'New York': '63.7',
	  'San Francisco': '53.9',
	  Austin: '78.8'
	}, {
	  date: '20120523',
	  'New York': '66.4',
	  'San Francisco': '56.5',
	  Austin: '77.7'
	}, {
	  date: '20120524',
	  'New York': '64.5',
	  'San Francisco': '54.7',
	  Austin: '80.6'
	}, {
	  date: '20120525',
	  'New York': '65.4',
	  'San Francisco': '52.5',
	  Austin: '81.4'
	}, {
	  date: '20120526',
	  'New York': '69.4',
	  'San Francisco': '52.1',
	  Austin: '82.3'
	}, {
	  date: '20120527',
	  'New York': '71.9',
	  'San Francisco': '52.2',
	  Austin: '80.3'
	}, {
	  date: '20120528',
	  'New York': '74.4',
	  'San Francisco': '52.9',
	  Austin: '80.3'
	}, {
	  date: '20120529',
	  'New York': '75.9',
	  'San Francisco': '52.1',
	  Austin: '82.2'
	}, {
	  date: '20120530',
	  'New York': '72.9',
	  'San Francisco': '52.1',
	  Austin: '81.9'
	}, {
	  date: '20120531',
	  'New York': '72.5',
	  'San Francisco': '53.3',
	  Austin: '82.4'
	}, {
	  date: '20120601',
	  'New York': '67.2',
	  'San Francisco': '54.8',
	  Austin: '77.9'
	}, {
	  date: '20120602',
	  'New York': '68.3',
	  'San Francisco': '54.0',
	  Austin: '81.1'
	}, {
	  date: '20120603',
	  'New York': '67.7',
	  'San Francisco': '52.3',
	  Austin: '82.2'
	}, {
	  date: '20120604',
	  'New York': '61.9',
	  'San Francisco': '55.3',
	  Austin: '81.2'
	}, {
	  date: '20120605',
	  'New York': '58.3',
	  'San Francisco': '53.5',
	  Austin: '83.0'
	}, {
	  date: '20120606',
	  'New York': '61.7',
	  'San Francisco': '54.1',
	  Austin: '83.2'
	}, {
	  date: '20120607',
	  'New York': '66.7',
	  'San Francisco': '53.9',
	  Austin: '82.1'
	}, {
	  date: '20120608',
	  'New York': '68.7',
	  'San Francisco': '54.4',
	  Austin: '77.5'
	}, {
	  date: '20120609',
	  'New York': '72.2',
	  'San Francisco': '55.0',
	  Austin: '77.9'
	}, {
	  date: '20120610',
	  'New York': '72.6',
	  'San Francisco': '60.0',
	  Austin: '82.9'
	}, {
	  date: '20120611',
	  'New York': '69.2',
	  'San Francisco': '57.2',
	  Austin: '86.8'
	}, {
	  date: '20120612',
	  'New York': '66.9',
	  'San Francisco': '55.1',
	  Austin: '85.3'
	}, {
	  date: '20120613',
	  'New York': '66.7',
	  'San Francisco': '53.3',
	  Austin: '76.9'
	}, {
	  date: '20120614',
	  'New York': '67.7',
	  'San Francisco': '53.4',
	  Austin: '84.5'
	}, {
	  date: '20120615',
	  'New York': '68.5',
	  'San Francisco': '54.6',
	  Austin: '84.4'
	}, {
	  date: '20120616',
	  'New York': '67.5',
	  'San Francisco': '57.0',
	  Austin: '83.8'
	}, {
	  date: '20120617',
	  'New York': '64.2',
	  'San Francisco': '55.6',
	  Austin: '82.5'
	}, {
	  date: '20120618',
	  'New York': '61.7',
	  'San Francisco': '52.5',
	  Austin: '82.9'
	}, {
	  date: '20120619',
	  'New York': '66.4',
	  'San Francisco': '53.9',
	  Austin: '82.5'
	}, {
	  date: '20120620',
	  'New York': '77.9',
	  'San Francisco': '55.3',
	  Austin: '81.3'
	}, {
	  date: '20120621',
	  'New York': '88.3',
	  'San Francisco': '53.3',
	  Austin: '80.8'
	}, {
	  date: '20120622',
	  'New York': '82.2',
	  'San Francisco': '54.1',
	  Austin: '81.7'
	}, {
	  date: '20120623',
	  'New York': '77.0',
	  'San Francisco': '55.2',
	  Austin: '83.9'
	}, {
	  date: '20120624',
	  'New York': '75.4',
	  'San Francisco': '55.8',
	  Austin: '85.5'
	}, {
	  date: '20120625',
	  'New York': '70.9',
	  'San Francisco': '56.8',
	  Austin: '87.2'
	}, {
	  date: '20120626',
	  'New York': '65.9',
	  'San Francisco': '57.5',
	  Austin: '88.0'
	}, {
	  date: '20120627',
	  'New York': '73.5',
	  'San Francisco': '57.7',
	  Austin: '89.6'
	}, {
	  date: '20120628',
	  'New York': '77.4',
	  'San Francisco': '56.6',
	  Austin: '86.7'
	}, {
	  date: '20120629',
	  'New York': '79.6',
	  'San Francisco': '56.4',
	  Austin: '85.3'
	}, {
	  date: '20120630',
	  'New York': '84.2',
	  'San Francisco': '58.4',
	  Austin: '81.7'
	}, {
	  date: '20120701',
	  'New York': '81.8',
	  'San Francisco': '58.8',
	  Austin: '78.5'
	}, {
	  date: '20120702',
	  'New York': '82.5',
	  'San Francisco': '56.4',
	  Austin: '83.1'
	}, {
	  date: '20120703',
	  'New York': '80.2',
	  'San Francisco': '56.5',
	  Austin: '83.1'
	}, {
	  date: '20120704',
	  'New York': '77.8',
	  'San Francisco': '55.8',
	  Austin: '84.5'
	}, {
	  date: '20120705',
	  'New York': '86.1',
	  'San Francisco': '54.8',
	  Austin: '84.6'
	}, {
	  date: '20120706',
	  'New York': '79.9',
	  'San Francisco': '54.9',
	  Austin: '84.2'
	}, {
	  date: '20120707',
	  'New York': '83.5',
	  'San Francisco': '54.7',
	  Austin: '86.7'
	}, {
	  date: '20120708',
	  'New York': '81.5',
	  'San Francisco': '52.8',
	  Austin: '84.3'
	}, {
	  date: '20120709',
	  'New York': '77.8',
	  'San Francisco': '53.7',
	  Austin: '83.7'
	}, {
	  date: '20120710',
	  'New York': '76.1',
	  'San Francisco': '53.1',
	  Austin: '77.1'
	}, {
	  date: '20120711',
	  'New York': '76.3',
	  'San Francisco': '52.7',
	  Austin: '77.4'
	}, {
	  date: '20120712',
	  'New York': '75.8',
	  'San Francisco': '52.0',
	  Austin: '80.6'
	}, {
	  date: '20120713',
	  'New York': '77.2',
	  'San Francisco': '53.4',
	  Austin: '81.4'
	}, {
	  date: '20120714',
	  'New York': '79.3',
	  'San Francisco': '54.0',
	  Austin: '80.2'
	}, {
	  date: '20120715',
	  'New York': '78.9',
	  'San Francisco': '54.0',
	  Austin: '81.8'
	}, {
	  date: '20120716',
	  'New York': '79.6',
	  'San Francisco': '54.5',
	  Austin: '77.3'
	}, {
	  date: '20120717',
	  'New York': '83.3',
	  'San Francisco': '56.7',
	  Austin: '80.8'
	}, {
	  date: '20120718',
	  'New York': '84.3',
	  'San Francisco': '57.5',
	  Austin: '81.6'
	}, {
	  date: '20120719',
	  'New York': '75.1',
	  'San Francisco': '57.1',
	  Austin: '80.9'
	}, {
	  date: '20120720',
	  'New York': '68.4',
	  'San Francisco': '58.1',
	  Austin: '83.9'
	}, {
	  date: '20120721',
	  'New York': '68.4',
	  'San Francisco': '57.6',
	  Austin: '85.6'
	}, {
	  date: '20120722',
	  'New York': '72.2',
	  'San Francisco': '56.0',
	  Austin: '83.6'
	}, {
	  date: '20120723',
	  'New York': '75.6',
	  'San Francisco': '56.6',
	  Austin: '84.0'
	}, {
	  date: '20120724',
	  'New York': '82.6',
	  'San Francisco': '57.8',
	  Austin: '83.0'
	}, {
	  date: '20120725',
	  'New York': '78.4',
	  'San Francisco': '57.5',
	  Austin: '84.8'
	}, {
	  date: '20120726',
	  'New York': '77.0',
	  'San Francisco': '56.4',
	  Austin: '84.4'
	}, {
	  date: '20120727',
	  'New York': '79.4',
	  'San Francisco': '55.3',
	  Austin: '84.3'
	}, {
	  date: '20120728',
	  'New York': '77.4',
	  'San Francisco': '55.0',
	  Austin: '83.9'
	}, {
	  date: '20120729',
	  'New York': '72.5',
	  'San Francisco': '55.6',
	  Austin: '85.0'
	}, {
	  date: '20120730',
	  'New York': '72.9',
	  'San Francisco': '55.6',
	  Austin: '84.9'
	}, {
	  date: '20120731',
	  'New York': '73.6',
	  'San Francisco': '55.9',
	  Austin: '86.3'
	}, {
	  date: '20120801',
	  'New York': '75.0',
	  'San Francisco': '55.4',
	  Austin: '86.5'
	}, {
	  date: '20120802',
	  'New York': '77.7',
	  'San Francisco': '54.4',
	  Austin: '85.8'
	}, {
	  date: '20120803',
	  'New York': '79.7',
	  'San Francisco': '53.7',
	  Austin: '85.3'
	}, {
	  date: '20120804',
	  'New York': '79.6',
	  'San Francisco': '54.1',
	  Austin: '86.0'
	}, {
	  date: '20120805',
	  'New York': '81.5',
	  'San Francisco': '57.8',
	  Austin: '84.2'
	}, {
	  date: '20120806',
	  'New York': '80.0',
	  'San Francisco': '58.2',
	  Austin: '81.9'
	}, {
	  date: '20120807',
	  'New York': '75.7',
	  'San Francisco': '58.0',
	  Austin: '86.5'
	}, {
	  date: '20120808',
	  'New York': '77.8',
	  'San Francisco': '57.0',
	  Austin: '86.1'
	}, {
	  date: '20120809',
	  'New York': '78.6',
	  'San Francisco': '55.0',
	  Austin: '86.8'
	}, {
	  date: '20120810',
	  'New York': '77.8',
	  'San Francisco': '54.8',
	  Austin: '88.0'
	}, {
	  date: '20120811',
	  'New York': '78.5',
	  'San Francisco': '53.0',
	  Austin: '85.1'
	}, {
	  date: '20120812',
	  'New York': '78.8',
	  'San Francisco': '52.5',
	  Austin: '87.4'
	}, {
	  date: '20120813',
	  'New York': '78.6',
	  'San Francisco': '53.3',
	  Austin: '88.0'
	}, {
	  date: '20120814',
	  'New York': '76.8',
	  'San Francisco': '53.9',
	  Austin: '88.0'
	}, {
	  date: '20120815',
	  'New York': '76.7',
	  'San Francisco': '56.2',
	  Austin: '87.2'
	}, {
	  date: '20120816',
	  'New York': '75.9',
	  'San Francisco': '57.1',
	  Austin: '86.1'
	}, {
	  date: '20120817',
	  'New York': '77.6',
	  'San Francisco': '55.3',
	  Austin: '86.8'
	}, {
	  date: '20120818',
	  'New York': '72.6',
	  'San Francisco': '56.2',
	  Austin: '84.9'
	}, {
	  date: '20120819',
	  'New York': '70.4',
	  'San Francisco': '54.3',
	  Austin: '76.8'
	}, {
	  date: '20120820',
	  'New York': '71.8',
	  'San Francisco': '53.1',
	  Austin: '80.6'
	}, {
	  date: '20120821',
	  'New York': '73.6',
	  'San Francisco': '53.4',
	  Austin: '80.0'
	}, {
	  date: '20120822',
	  'New York': '74.7',
	  'San Francisco': '54.5',
	  Austin: '78.2'
	}, {
	  date: '20120823',
	  'New York': '74.6',
	  'San Francisco': '55.7',
	  Austin: '79.1'
	}, {
	  date: '20120824',
	  'New York': '76.0',
	  'San Francisco': '54.8',
	  Austin: '81.9'
	}, {
	  date: '20120825',
	  'New York': '76.2',
	  'San Francisco': '53.8',
	  Austin: '84.7'
	}, {
	  date: '20120826',
	  'New York': '73.4',
	  'San Francisco': '56.5',
	  Austin: '83.5'
	}, {
	  date: '20120827',
	  'New York': '74.6',
	  'San Francisco': '58.3',
	  Austin: '82.1'
	}, {
	  date: '20120828',
	  'New York': '79.4',
	  'San Francisco': '58.7',
	  Austin: '84.0'
	}, {
	  date: '20120829',
	  'New York': '74.7',
	  'San Francisco': '57.5',
	  Austin: '85.7'
	}, {
	  date: '20120830',
	  'New York': '73.5',
	  'San Francisco': '55.9',
	  Austin: '87.2'
	}, {
	  date: '20120831',
	  'New York': '77.9',
	  'San Francisco': '55.4',
	  Austin: '82.9'
	}, {
	  date: '20120901',
	  'New York': '80.7',
	  'San Francisco': '55.7',
	  Austin: '84.8'
	}, {
	  date: '20120902',
	  'New York': '75.1',
	  'San Francisco': '53.1',
	  Austin: '83.9'
	}, {
	  date: '20120903',
	  'New York': '73.5',
	  'San Francisco': '53.5',
	  Austin: '85.5'
	}, {
	  date: '20120904',
	  'New York': '73.5',
	  'San Francisco': '52.5',
	  Austin: '86.4'
	}, {
	  date: '20120905',
	  'New York': '77.7',
	  'San Francisco': '54.5',
	  Austin: '85.8'
	}, {
	  date: '20120906',
	  'New York': '74.2',
	  'San Francisco': '56.3',
	  Austin: '85.4'
	}, {
	  date: '20120907',
	  'New York': '76.0',
	  'San Francisco': '56.4',
	  Austin: '85.3'
	}, {
	  date: '20120908',
	  'New York': '77.1',
	  'San Francisco': '56.5',
	  Austin: '81.9'
	}, {
	  date: '20120909',
	  'New York': '69.7',
	  'San Francisco': '56.4',
	  Austin: '74.8'
	}, {
	  date: '20120910',
	  'New York': '67.8',
	  'San Francisco': '55.4',
	  Austin: '71.6'
	}, {
	  date: '20120911',
	  'New York': '64.0',
	  'San Francisco': '56.2',
	  Austin: '75.9'
	}, {
	  date: '20120912',
	  'New York': '68.1',
	  'San Francisco': '55.7',
	  Austin: '82.1'
	}, {
	  date: '20120913',
	  'New York': '69.3',
	  'San Francisco': '54.3',
	  Austin: '80.5'
	}, {
	  date: '20120914',
	  'New York': '70.0',
	  'San Francisco': '55.2',
	  Austin: '70.0'
	}, {
	  date: '20120915',
	  'New York': '69.3',
	  'San Francisco': '54.3',
	  Austin: '71.2'
	}, {
	  date: '20120916',
	  'New York': '66.3',
	  'San Francisco': '52.9',
	  Austin: '70.3'
	}, {
	  date: '20120917',
	  'New York': '67.0',
	  'San Francisco': '54.8',
	  Austin: '72.1'
	}, {
	  date: '20120918',
	  'New York': '72.8',
	  'San Francisco': '54.8',
	  Austin: '73.7'
	}, {
	  date: '20120919',
	  'New York': '67.2',
	  'San Francisco': '56.8',
	  Austin: '72.7'
	}, {
	  date: '20120920',
	  'New York': '62.1',
	  'San Francisco': '55.4',
	  Austin: '71.7'
	}, {
	  date: '20120921',
	  'New York': '64.0',
	  'San Francisco': '55.8',
	  Austin: '72.9'
	}, {
	  date: '20120922',
	  'New York': '65.5',
	  'San Francisco': '55.9',
	  Austin: '73.1'
	}, {
	  date: '20120923',
	  'New York': '65.7',
	  'San Francisco': '52.8',
	  Austin: '75.6'
	}, {
	  date: '20120924',
	  'New York': '60.4',
	  'San Francisco': '54.5',
	  Austin: '78.3'
	}, {
	  date: '20120925',
	  'New York': '63.2',
	  'San Francisco': '53.3',
	  Austin: '78.3'
	}, {
	  date: '20120926',
	  'New York': '68.5',
	  'San Francisco': '53.6',
	  Austin: '79.6'
	}, {
	  date: '20120927',
	  'New York': '69.2',
	  'San Francisco': '52.1',
	  Austin: '76.4'
	}, {
	  date: '20120928',
	  'New York': '68.7',
	  'San Francisco': '52.6',
	  Austin: '77.2'
	}, {
	  date: '20120929',
	  'New York': '62.5',
	  'San Francisco': '53.9',
	  Austin: '75.2'
	}, {
	  date: '20120930',
	  'New York': '62.3',
	  'San Francisco': '55.1',
	  Austin: '71.9'
	}];

/***/ },
/* 662 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  name: 'Jupiter',
	  radius: '10.97',
	  distance: '0'
	}, {
	  name: 'Saturn',
	  radius: '9.14',
	  distance: '0'
	}, {
	  name: 'Uranus',
	  radius: '3.98',
	  distance: '0'
	}, {
	  name: 'Neptune',
	  radius: '3.86',
	  distance: '0'
	}, {
	  name: 'Earth',
	  radius: '1',
	  distance: '0'
	}, {
	  name: 'Venus',
	  radius: '0.950',
	  distance: '0'
	}, {
	  name: 'Mars',
	  radius: '0.532',
	  distance: '0'
	}, {
	  name: 'Mercury',
	  radius: '0.383',
	  distance: '0'
	}, {
	  name: 'Pluto',
	  radius: '0.181',
	  distance: '0'
	}, {
	  name: '11 Com b',
	  radius: '12.64',
	  distance: '110.60'
	}, {
	  name: '11 UMi b',
	  radius: '12.89',
	  distance: '119.50'
	}, {
	  name: '14 And b',
	  radius: '13.18',
	  distance: '76.40'
	}, {
	  name: '14 Her b',
	  radius: '13.24',
	  distance: '18.10'
	}, {
	  name: '16 Cyg B b',
	  radius: '13.69',
	  distance: '21.41'
	}, {
	  name: '18 Del b',
	  radius: '12.90',
	  distance: '73.10'
	}, {
	  name: '1RXS1609 b',
	  radius: '19.04',
	  distance: '145.00'
	}, {
	  name: '24 Sex b',
	  radius: '13.62',
	  distance: '74.80'
	}, {
	  name: '24 Sex c',
	  radius: '13.99',
	  distance: '74.80'
	}, {
	  name: '2M 0103(AB) b',
	  radius: '12.74',
	  distance: '47.20'
	}, {
	  name: '2M 0122-2439 b',
	  radius: '12.74',
	  distance: '36.00'
	}, {
	  name: '2M 044144 b',
	  radius: '13.04',
	  distance: '140.00'
	}, {
	  name: '2M 0746+20 b',
	  radius: '10.86',
	  distance: '12.21'
	}, {
	  name: '2M 2140+16 b',
	  radius: '10.30',
	  distance: '25.00'
	}, {
	  name: '2M 2206-20 b',
	  radius: '14.56',
	  distance: '26.67'
	}, {
	  name: '2M1207 b',
	  radius: '13.31',
	  distance: '52.40'
	}, {
	  name: '30 Ari B b',
	  radius: '12.92',
	  distance: '39.40'
	}, {
	  name: '4 Uma b',
	  radius: '13.06',
	  distance: '78.50'
	}, {
	  name: '42 Dra b',
	  radius: '13.32',
	  distance: '97.30'
	}, {
	  name: '47 Uma b',
	  radius: '13.51',
	  distance: '13.97'
	}, {
	  name: '47 Uma c',
	  radius: '14.21',
	  distance: '13.97'
	}, {
	  name: '47 Uma d',
	  radius: '13.70',
	  distance: '13.97'
	}, {
	  name: '51 Peg b',
	  radius: '14.28',
	  distance: '14.70'
	}, {
	  name: '55 Cnc b',
	  radius: '14.03',
	  distance: '12.34'
	}, {
	  name: '55 Cnc c',
	  radius: '8.48',
	  distance: '12.34'
	}, {
	  name: '55 Cnc d',
	  radius: '13.33',
	  distance: '12.34'
	}, {
	  name: '55 Cnc e',
	  radius: '1.99',
	  distance: '12.34'
	}, {
	  name: '55 Cnc f',
	  radius: '7.75',
	  distance: '12.34'
	}, {
	  name: '6 Lyn b',
	  radius: '13.53',
	  distance: '56.90'
	}, {
	  name: '61 Vir b',
	  radius: '1.89',
	  distance: '8.52'
	}, {
	  name: '61 Vir c',
	  radius: '4.63',
	  distance: '8.52'
	}, {
	  name: '61 Vir d',
	  radius: '5.26',
	  distance: '8.52'
	}, {
	  name: '7 CMa b',
	  radius: '13.50',
	  distance: '19.75'
	}, {
	  name: '70 Vir b',
	  radius: '13.09',
	  distance: '22.00'
	}, {
	  name: '75 Cet b',
	  radius: '13.37',
	  distance: '81.50'
	}, {
	  name: '81 Cet b',
	  radius: '13.19',
	  distance: '97.20'
	}, {
	  name: '91 Aqr b',
	  radius: '13.41',
	  distance: '45.90'
	}, {
	  name: 'AB Pic b',
	  radius: '12.79',
	  distance: '47.30'
	}, {
	  name: 'alf Ari b',
	  radius: '13.66',
	  distance: '20.20'
	}, {
	  name: 'alf Cen B b',
	  radius: '1.10',
	  distance: '1.30'
	}, {
	  name: 'BD +48 738 b',
	  radius: '13.90',
	  distance: ''
	}, {
	  name: 'BD+15 2940 b',
	  radius: '13.81',
	  distance: '585.00'
	}, {
	  name: 'BD+20 274 c',
	  radius: '13.22',
	  distance: ''
	}, {
	  name: 'BD-061339 b',
	  radius: '3.29',
	  distance: '20.00'
	}, {
	  name: 'BD-061339 c',
	  radius: '9.22',
	  distance: '20.00'
	}, {
	  name: 'BD-082823 b',
	  radius: '4.04',
	  distance: '42.20'
	}, {
	  name: 'BD-082823 c',
	  radius: '14.44',
	  distance: '42.20'
	}, {
	  name: 'BD-10 3166 b',
	  radius: '14.26',
	  distance: '66.00'
	}, {
	  name: 'BD-17 63 b',
	  radius: '13.20',
	  distance: '34.60'
	}, {
	  name: 'BD14 4559 b',
	  radius: '13.75',
	  distance: '50.00'
	}, {
	  name: 'BD20 2457 b',
	  radius: '12.60',
	  distance: '200.00'
	}, {
	  name: 'BD20 2457 c',
	  radius: '12.82',
	  distance: '200.00'
	}, {
	  name: 'beta Pic b',
	  radius: '13.07',
	  distance: '19.30'
	}, {
	  name: 'CD-35 2722 b',
	  radius: '12.44',
	  distance: '21.30'
	}, {
	  name: 'CFBDS 1458 b',
	  radius: '13.10',
	  distance: '23.10'
	}, {
	  name: 'CHXR 73 b',
	  radius: '12.78',
	  distance: ''
	}, {
	  name: 'CoRoT-1 b',
	  radius: '16.69',
	  distance: '460.00'
	}, {
	  name: 'CoRoT-10 b',
	  radius: '10.86',
	  distance: '345.00'
	}, {
	  name: 'CoRoT-11 b',
	  radius: '16.02',
	  distance: '560.00'
	}, {
	  name: 'CoRoT-12 b',
	  radius: '16.13',
	  distance: '1150.00'
	}, {
	  name: 'CoRoT-13 b',
	  radius: '9.91',
	  distance: '1310.00'
	}, {
	  name: 'CoRoT-14 b',
	  radius: '12.21',
	  distance: '1340.00'
	}, {
	  name: 'CoRoT-16 b',
	  radius: '13.10',
	  distance: '840.00'
	}, {
	  name: 'CoRoT-17 b',
	  radius: '11.42',
	  distance: '920.00'
	}, {
	  name: 'CoRoT-18 b',
	  radius: '14.67',
	  distance: '870.00'
	}, {
	  name: 'CoRoT-19 b',
	  radius: '14.45',
	  distance: '800.00'
	}, {
	  name: 'CoRoT-2 b',
	  radius: '16.41',
	  distance: '300.00'
	}, {
	  name: 'CoRoT-20 b',
	  radius: '9.41',
	  distance: '1230.00'
	}, {
	  name: 'CoRoT-21 b',
	  radius: '14.56',
	  distance: ''
	}, {
	  name: 'CoRoT-23 b',
	  radius: '12.10',
	  distance: '600.00'
	}, {
	  name: 'CoRoT-25 b',
	  radius: '12.10',
	  distance: '1000.00'
	}, {
	  name: 'CoRoT-26 b',
	  radius: '14.11',
	  distance: '1670.00'
	}, {
	  name: 'CoRoT-3 b',
	  radius: '11.31',
	  distance: '680.00'
	}, {
	  name: 'CoRoT-4 b',
	  radius: '13.33',
	  distance: ''
	}, {
	  name: 'CoRoT-5 b',
	  radius: '14.90',
	  distance: '400.00'
	}, {
	  name: 'CoRoT-6 b',
	  radius: '13.06',
	  distance: ''
	}, {
	  name: 'CoRoT-7 b',
	  radius: '1.67',
	  distance: '150.00'
	}, {
	  name: 'CoRoT-7 c',
	  radius: '2.43',
	  distance: '150.00'
	}, {
	  name: 'CoRoT-8 b',
	  radius: '6.37',
	  distance: '380.00'
	}, {
	  name: 'CoRoT-9 b',
	  radius: '10.53',
	  distance: '460.00'
	}, {
	  name: 'CT Cha b',
	  radius: '24.64',
	  distance: '165.00'
	}, {
	  name: 'DH Tau b',
	  radius: '12.81',
	  distance: ''
	}, {
	  name: 'DP Leo b',
	  radius: '13.07',
	  distance: ''
	}, {
	  name: 'eps CrB b',
	  radius: '13.02',
	  distance: '67.90'
	}, {
	  name: 'eps Eridani b',
	  radius: '13.73',
	  distance: '3.20'
	}, {
	  name: 'eps Tau b',
	  radius: '13.03',
	  distance: '45.00'
	}, {
	  name: 'Fomalhaut b',
	  radius: '13.61',
	  distance: '7.70'
	}, {
	  name: 'FU Tau b',
	  radius: '12.74',
	  distance: '140.00'
	}, {
	  name: 'gamma 1 Leo b',
	  radius: '12.97',
	  distance: '38.50'
	}, {
	  name: 'gamma Cephei b',
	  radius: '13.65',
	  distance: '13.79'
	}, {
	  name: 'GJ 1214 b',
	  radius: '2.67',
	  distance: '13.00'
	}, {
	  name: 'GJ 163 b',
	  radius: '3.71',
	  distance: '15.00'
	}, {
	  name: 'GJ 163 c',
	  radius: '2.43',
	  distance: '15.00'
	}, {
	  name: 'Gj 163 d',
	  radius: '5.58',
	  distance: '15.00'
	}, {
	  name: 'GJ 176 b',
	  radius: '2.43',
	  distance: '9.42'
	}, {
	  name: 'GJ 3021 b',
	  radius: '13.38',
	  distance: '17.62'
	}, {
	  name: 'GJ 317 b',
	  radius: '13.66',
	  distance: '15.10'
	}, {
	  name: 'GJ 317 c',
	  radius: '13.61',
	  distance: '15.10'
	}, {
	  name: 'GJ 328 b',
	  radius: '13.49',
	  distance: '19.80'
	}, {
	  name: 'GJ 3470 b',
	  radius: '4.19',
	  distance: '30.70'
	}, {
	  name: 'GJ 3634 b',
	  radius: '2.20',
	  distance: '19.80'
	}, {
	  name: 'GJ 433 b',
	  radius: '2.01',
	  distance: '9.04'
	}, {
	  name: 'GJ 433 c',
	  radius: '7.63',
	  distance: '9.04'
	}, {
	  name: 'GJ 436 b',
	  radius: '4.09',
	  distance: '10.20'
	}, {
	  name: 'GJ 504 b',
	  radius: '13.24',
	  distance: '17.56'
	}, {
	  name: 'GJ 667C b',
	  radius: '1.95',
	  distance: '7.23'
	}, {
	  name: 'GJ 667C c',
	  radius: '1.74',
	  distance: '7.23'
	}, {
	  name: 'GJ 667C d',
	  radius: '2.19',
	  distance: '7.23'
	}, {
	  name: 'GJ 667C e',
	  radius: '1.52',
	  distance: '7.23'
	}, {
	  name: 'GJ 667C f',
	  radius: '1.52',
	  distance: '7.23'
	}, {
	  name: 'GJ 667C g',
	  radius: '1.93',
	  distance: '7.23'
	}, {
	  name: 'GJ 674 b',
	  radius: '3.62',
	  distance: '4.54'
	}, {
	  name: 'GJ 676A b',
	  radius: '13.21',
	  distance: '16.45'
	}, {
	  name: 'GJ 676A c',
	  radius: '13.37',
	  distance: '16.45'
	}, {
	  name: 'GJ 676A d',
	  radius: '1.90',
	  distance: '16.45'
	}, {
	  name: 'GJ 676A e',
	  radius: '3.87',
	  distance: '16.45'
	}, {
	  name: 'GJ 832 b',
	  radius: '14.13',
	  distance: '4.94'
	}, {
	  name: 'GJ 849 b',
	  radius: '13.97',
	  distance: '9.10'
	}, {
	  name: 'GJ 849 c',
	  radius: '13.98',
	  distance: '9.10'
	}, {
	  name: 'Gl 179 b',
	  radius: '14.02',
	  distance: '12.30'
	}, {
	  name: 'Gl 581 b',
	  radius: '4.29',
	  distance: '6.21'
	}, {
	  name: 'Gl 581 c',
	  radius: '1.94',
	  distance: '6.21'
	}, {
	  name: 'Gl 581 d',
	  radius: '2.05',
	  distance: '6.21'
	}, {
	  name: 'Gl 581 e',
	  radius: '1.27',
	  distance: '6.21'
	}, {
	  name: 'Gl 649 b',
	  radius: '14.44',
	  distance: '10.34'
	}, {
	  name: 'Gl 649 c',
	  radius: '3.49',
	  distance: '10.34'
	}, {
	  name: 'Gl 86 b',
	  radius: '13.31',
	  distance: '10.90'
	}, {
	  name: 'Gliese 876 b',
	  radius: '13.56',
	  distance: '4.70'
	}, {
	  name: 'Gliese 876 c',
	  radius: '14.08',
	  distance: '4.70'
	}, {
	  name: 'Gliese 876 d',
	  radius: '2.15',
	  distance: '4.70'
	}, {
	  name: 'Gliese 876 e',
	  radius: '4.09',
	  distance: '4.70'
	}, {
	  name: 'GQ Lup b',
	  radius: '20.16',
	  distance: '140.00'
	}, {
	  name: 'GSC 06214-00210 b',
	  radius: '12.69',
	  distance: '145.00'
	}, {
	  name: 'HAT-P-1 b',
	  radius: '14.77',
	  distance: '139.00'
	}, {
	  name: 'HAT-P-11 b',
	  radius: '4.73',
	  distance: '38.00'
	}, {
	  name: 'HAT-P-12 b',
	  radius: '10.69',
	  distance: '142.50'
	}, {
	  name: 'HAT-P-13 b',
	  radius: '14.34',
	  distance: '214.00'
	}, {
	  name: 'HAT-P-13 c',
	  radius: '12.76',
	  distance: '214.00'
	}, {
	  name: 'HAT-P-14 b',
	  radius: '13.44',
	  distance: '205.00'
	}, {
	  name: 'HAT-P-15 b',
	  radius: '12.01',
	  distance: '190.00'
	}, {
	  name: 'HAT-P-16 b',
	  radius: '14.44',
	  distance: '235.00'
	}, {
	  name: 'HAT-P-17 b',
	  radius: '11.31',
	  distance: '90.00'
	}, {
	  name: 'HAT-P-17 c',
	  radius: '13.77',
	  distance: '90.00'
	}, {
	  name: 'HAT-P-18 b',
	  radius: '11.09',
	  distance: '166.00'
	}, {
	  name: 'HAT-P-19 b',
	  radius: '12.68',
	  distance: '215.00'
	}, {
	  name: 'HAT-P-2 b',
	  radius: '10.65',
	  distance: '118.00'
	}, {
	  name: 'HAT-P-20 b',
	  radius: '9.71',
	  distance: '70.00'
	}, {
	  name: 'HAT-P-21 b',
	  radius: '11.47',
	  distance: '254.00'
	}, {
	  name: 'HAT-P-22 b',
	  radius: '12.10',
	  distance: '82.00'
	}, {
	  name: 'HAT-P-23 b',
	  radius: '15.32',
	  distance: '393.00'
	}, {
	  name: 'HAT-P-24 b',
	  radius: '13.91',
	  distance: '306.00'
	}, {
	  name: 'HAT-P-25 b',
	  radius: '13.33',
	  distance: '297.00'
	}, {
	  name: 'HAT-P-26 b',
	  radius: '6.32',
	  distance: '134.00'
	}, {
	  name: 'HAT-P-27-WASP-40 b',
	  radius: '11.82',
	  distance: '204.00'
	}, {
	  name: 'HAT-P-28 b',
	  radius: '13.57',
	  distance: '395.00'
	}, {
	  name: 'HAT-P-29 b',
	  radius: '12.40',
	  distance: '322.00'
	}, {
	  name: 'HAT-P-3 b',
	  radius: '9.26',
	  distance: '130.00'
	}, {
	  name: 'HAT-P-30-WASP-51 b',
	  radius: '15.01',
	  distance: '193.00'
	}, {
	  name: 'HAT-P-31 b',
	  radius: '11.98',
	  distance: '354.00'
	}, {
	  name: 'HAT-P-32 b',
	  radius: '22.81',
	  distance: '320.00'
	}, {
	  name: 'HAT-P-33 b',
	  radius: '20.46',
	  distance: '419.00'
	}, {
	  name: 'HAT-P-34 b',
	  radius: '12.40',
	  distance: '257.00'
	}, {
	  name: 'HAT-P-35 b',
	  radius: '14.92',
	  distance: '535.00'
	}, {
	  name: 'HAT-P-36 b',
	  radius: '14.16',
	  distance: '317.00'
	}, {
	  name: 'HAT-P-37 b',
	  radius: '13.19',
	  distance: '411.00'
	}, {
	  name: 'HAT-P-38 b',
	  radius: '9.24',
	  distance: '249.00'
	}, {
	  name: 'HAT-P-39 b',
	  radius: '17.60',
	  distance: '642.00'
	}, {
	  name: 'HAT-P-4 b',
	  radius: '14.22',
	  distance: '310.00'
	}, {
	  name: 'HAT-P-40 b',
	  radius: '19.38',
	  distance: '501.00'
	}, {
	  name: 'HAT-P-41 b',
	  radius: '17.12',
	  distance: '311.00'
	}, {
	  name: 'HAT-P-42 b',
	  radius: '14.30',
	  distance: '447.00'
	}, {
	  name: 'HAT-P-43 b',
	  radius: '14.37',
	  distance: '543.00'
	}, {
	  name: 'HAT-P-44 b',
	  radius: '14.34',
	  distance: '374.00'
	}, {
	  name: 'HAT-P-44 c',
	  radius: '13.65',
	  distance: '374.00'
	}, {
	  name: 'HAT-P-45 b',
	  radius: '15.97',
	  distance: '305.00'
	}, {
	  name: 'HAT-P-46 b',
	  radius: '14.38',
	  distance: '296.00'
	}, {
	  name: 'HAT-P-46 c',
	  radius: '13.55',
	  distance: '296.00'
	}, {
	  name: 'HAT-P-5 b',
	  radius: '14.02',
	  distance: '340.00'
	}, {
	  name: 'HAT-P-6 b',
	  radius: '14.90',
	  distance: '200.00'
	}, {
	  name: 'HAT-P-7 b',
	  radius: '15.92',
	  distance: '320.00'
	}, {
	  name: 'HAT-P-8 b',
	  radius: '16.80',
	  distance: '230.00'
	}, {
	  name: 'HAT-P-9 b',
	  radius: '15.68',
	  distance: '480.00'
	}, {
	  name: 'HATS-1 b',
	  radius: '14.58',
	  distance: '303.00'
	}, {
	  name: 'HATS-2 b',
	  radius: '13.08',
	  distance: '360.00'
	}, {
	  name: 'HATS-3 b',
	  radius: '15.47',
	  distance: '453.00'
	}, {
	  name: 'HD 100655 b',
	  radius: '13.69',
	  distance: '122.00'
	}, {
	  name: 'HD 100777 b',
	  radius: '13.86',
	  distance: '52.80'
	}, {
	  name: 'HD 10180 c',
	  radius: '3.85',
	  distance: '39.40'
	}, {
	  name: 'HD 10180 d',
	  radius: '3.62',
	  distance: '39.40'
	}, {
	  name: 'HD 10180 e',
	  radius: '5.54',
	  distance: '39.40'
	}, {
	  name: 'HD 10180 f',
	  radius: '5.39',
	  distance: '39.40'
	}, {
	  name: 'HD 10180 g',
	  radius: '5.06',
	  distance: '39.40'
	}, {
	  name: 'HD 10180 h',
	  radius: '9.38',
	  distance: '39.40'
	}, {
	  name: 'HD 101930 b',
	  radius: '11.69',
	  distance: '30.49'
	}, {
	  name: 'HD 102117 b',
	  radius: '8.56',
	  distance: '42.00'
	}, {
	  name: 'HD 102195 b',
	  radius: '14.30',
	  distance: '28.98'
	}, {
	  name: 'HD 102272 b',
	  radius: '13.14',
	  distance: '360.00'
	}, {
	  name: 'HD 102272 c',
	  radius: '13.50',
	  distance: '360.00'
	}, {
	  name: 'HD 102329 b',
	  radius: '13.14',
	  distance: '158.00'
	}, {
	  name: 'HD 102365 b',
	  radius: '4.29',
	  distance: '9.24'
	}, {
	  name: 'HD 102956 b',
	  radius: '13.94',
	  distance: '126.00'
	}, {
	  name: 'HD 103197 b',
	  radius: '6.25',
	  distance: '49.30'
	}, {
	  name: 'HD 103774 b',
	  radius: '14.32',
	  distance: '55.00'
	}, {
	  name: 'HD 104067 b',
	  radius: '8.95',
	  distance: '20.80'
	}, {
	  name: 'HD 104985 b',
	  radius: '13.11',
	  distance: '102.00'
	}, {
	  name: 'HD 106252 b',
	  radius: '13.03',
	  distance: '37.44'
	}, {
	  name: 'HD 106270 b',
	  radius: '12.87',
	  distance: '84.90'
	}, {
	  name: 'HD 10647 b',
	  radius: '13.96',
	  distance: '17.30'
	}, {
	  name: 'HD 106515A b',
	  radius: '12.87',
	  distance: '35.20'
	}, {
	  name: 'HD 10697 b',
	  radius: '13.11',
	  distance: '32.56'
	}, {
	  name: 'HD 107148 b',
	  radius: '9.57',
	  distance: '51.30'
	}, {
	  name: 'HD 108147 b',
	  radius: '10.81',
	  distance: '38.57'
	}, {
	  name: 'HD 108863 b',
	  radius: '13.50',
	  distance: '139.00'
	}, {
	  name: 'HD 108874 b',
	  radius: '13.79',
	  distance: '68.50'
	}, {
	  name: 'HD 108874 c',
	  radius: '13.92',
	  distance: '68.50'
	}, {
	  name: 'HD 109246 b',
	  radius: '14.05',
	  distance: '65.60'
	}, {
	  name: 'HD 109271 b',
	  radius: '4.85',
	  distance: '62.00'
	}, {
	  name: 'HD 109271 c',
	  radius: '5.87',
	  distance: '62.00'
	}, {
	  name: 'HD 109749 b',
	  radius: '11.25',
	  distance: '59.00'
	}, {
	  name: 'HD 110014 b',
	  radius: '12.87',
	  distance: '90.00'
	}, {
	  name: 'HD 111232 b',
	  radius: '13.08',
	  distance: '29.00'
	}, {
	  name: 'HD 113337 b',
	  radius: '13.40',
	  distance: '36.90'
	}, {
	  name: 'HD 113538 b',
	  radius: '11.02',
	  distance: '15.80'
	}, {
	  name: 'HD 113538 c',
	  radius: '14.08',
	  distance: '15.80'
	}, {
	  name: 'HD 114386 b',
	  radius: '13.83',
	  distance: '28.00'
	}, {
	  name: 'HD 114386 c',
	  radius: '13.78',
	  distance: '28.00'
	}, {
	  name: 'HD 114729 b',
	  radius: '14.01',
	  distance: '35.00'
	}, {
	  name: 'HD 114762 b',
	  radius: '12.87',
	  distance: '39.46'
	}, {
	  name: 'HD 114783 b',
	  radius: '13.93',
	  distance: '20.40'
	}, {
	  name: 'HD 11506 b',
	  radius: '13.37',
	  distance: '53.82'
	}, {
	  name: 'HD 11506 c',
	  radius: '14.02',
	  distance: '53.82'
	}, {
	  name: 'HD 116029 b',
	  radius: '13.59',
	  distance: '123.20'
	}, {
	  name: 'HD 117207 b',
	  radius: '13.60',
	  distance: '33.00'
	}, {
	  name: 'HD 117618 b',
	  radius: '8.73',
	  distance: '38.00'
	}, {
	  name: 'HD 117618 c',
	  radius: '10.10',
	  distance: '38.00'
	}, {
	  name: 'HD 118203 b',
	  radius: '13.59',
	  distance: '88.60'
	}, {
	  name: 'HD 11964 b',
	  radius: '14.14',
	  distance: '33.98'
	}, {
	  name: 'HD 11964 c',
	  radius: '5.54',
	  distance: '33.98'
	}, {
	  name: 'HD 11977 b',
	  radius: '13.09',
	  distance: '66.50'
	}, {
	  name: 'HD 120084 b',
	  radius: '13.19',
	  distance: '97.70'
	}, {
	  name: 'HD 121504 b',
	  radius: '13.84',
	  distance: '44.37'
	}, {
	  name: 'HD 122430 b',
	  radius: '13.34',
	  distance: '135.00'
	}, {
	  name: 'HD 125595 b',
	  radius: '3.89',
	  distance: '27.40'
	}, {
	  name: 'HD 125612 b',
	  radius: '13.43',
	  distance: '52.82'
	}, {
	  name: 'HD 125612 c',
	  radius: '4.66',
	  distance: '52.82'
	}, {
	  name: 'HD 125612 d',
	  radius: '13.05',
	  distance: '52.82'
	}, {
	  name: 'HD 126525 b',
	  radius: '9.93',
	  distance: '38.10'
	}, {
	  name: 'HD 12661 b',
	  radius: '13.55',
	  distance: '37.16'
	}, {
	  name: 'HD 12661 c',
	  radius: '13.72',
	  distance: '37.16'
	}, {
	  name: 'HD 126614 b',
	  radius: '14.37',
	  distance: '72.40'
	}, {
	  name: 'HD 128311 b',
	  radius: '13.57',
	  distance: '16.60'
	}, {
	  name: 'HD 128311 c',
	  radius: '13.40',
	  distance: '16.60'
	}, {
	  name: 'HD 129445 b',
	  radius: '13.71',
	  distance: '67.61'
	}, {
	  name: 'HD 130322 b',
	  radius: '13.92',
	  distance: '30.00'
	}, {
	  name: 'HD 131496 b',
	  radius: '13.57',
	  distance: '110.00'
	}, {
	  name: 'HD 13189 b',
	  radius: '12.77',
	  distance: '185.00'
	}, {
	  name: 'HD 132406 b',
	  radius: '13.16',
	  distance: '71.00'
	}, {
	  name: 'HD 132563B b',
	  radius: '13.75',
	  distance: '96.00'
	}, {
	  name: 'HD 134060 b',
	  radius: '3.52',
	  distance: '24.20'
	}, {
	  name: 'HD 134060 c',
	  radius: '7.95',
	  distance: '24.20'
	}, {
	  name: 'HD 134606 b',
	  radius: '2.57',
	  distance: '26.50'
	}, {
	  name: 'HD 134606 c',
	  radius: '3.69',
	  distance: '26.50'
	}, {
	  name: 'HD 134606 d',
	  radius: '7.03',
	  distance: '26.50'
	}, {
	  name: 'HD 134987 b',
	  radius: '13.72',
	  distance: '22.20'
	}, {
	  name: 'HD 134987 c',
	  radius: '14.02',
	  distance: '22.20'
	}, {
	  name: 'HD 136352 b',
	  radius: '1.92',
	  distance: '14.80'
	}, {
	  name: 'HD 136352 c',
	  radius: '3.56',
	  distance: '14.80'
	}, {
	  name: 'HD 136352 d',
	  radius: '3.22',
	  distance: '14.80'
	}, {
	  name: 'HD 136418 b',
	  radius: '13.61',
	  distance: '98.20'
	}, {
	  name: 'HD 137388 b',
	  radius: '9.90',
	  distance: '38.00'
	}, {
	  name: 'HD 13808 b',
	  radius: '3.37',
	  distance: '28.60'
	}, {
	  name: 'HD 13808 c',
	  radius: '3.57',
	  distance: '28.60'
	}, {
	  name: 'HD 13908 b',
	  radius: '13.93',
	  distance: '71.20'
	}, {
	  name: 'HD 13908 c',
	  radius: '13.14',
	  distance: '71.20'
	}, {
	  name: 'HD 13931 b',
	  radius: '13.64',
	  distance: '44.20'
	}, {
	  name: 'HD 139357 b',
	  radius: '12.92',
	  distance: '121.40'
	}, {
	  name: 'HD 141937 b',
	  radius: '12.93',
	  distance: '33.46'
	}, {
	  name: 'HD 142 b',
	  radius: '13.82',
	  distance: '20.60'
	}, {
	  name: 'HD 142 c',
	  radius: '13.19',
	  distance: '20.60'
	}, {
	  name: 'HD 142022 A b',
	  radius: '13.20',
	  distance: '35.87'
	}, {
	  name: 'HD 142245 b',
	  radius: '13.64',
	  distance: '109.50'
	}, {
	  name: 'HD 142415 b',
	  radius: '13.71',
	  distance: '34.20'
	}, {
	  name: 'HD 143361 b',
	  radius: '13.42',
	  distance: '59.35'
	}, {
	  name: 'HD 145377 b',
	  radius: '13.15',
	  distance: '57.70'
	}, {
	  name: 'HD 145457 b',
	  radius: '13.45',
	  distance: '126.00'
	}, {
	  name: 'HD 1461 b',
	  radius: '2.30',
	  distance: '23.40'
	}, {
	  name: 'HD 1461 c',
	  radius: '2.03',
	  distance: '23.40'
	}, {
	  name: 'HD 147018 b',
	  radius: '13.59',
	  distance: '42.96'
	}, {
	  name: 'HD 147018 c',
	  radius: '13.09',
	  distance: '42.96'
	}, {
	  name: 'HD 147513 b',
	  radius: '13.84',
	  distance: '12.90'
	}, {
	  name: 'HD 148156 b',
	  radius: '14.00',
	  distance: '53.05'
	}, {
	  name: 'HD 148427 b',
	  radius: '13.94',
	  distance: '59.30'
	}, {
	  name: 'HD 149026 b',
	  radius: '8.04',
	  distance: '78.90'
	}, {
	  name: 'HD 149143 b',
	  radius: '13.79',
	  distance: '63.00'
	}, {
	  name: 'HD 1502 b',
	  radius: '13.42',
	  distance: '159.00'
	}, {
	  name: 'HD 150433 b',
	  radius: '8.45',
	  distance: '29.60'
	}, {
	  name: 'HD 150706 b',
	  radius: '13.48',
	  distance: '27.20'
	}, {
	  name: 'HD 152079 b',
	  radius: '13.43',
	  distance: '85.17'
	}, {
	  name: 'HD 152581 b',
	  radius: '13.74',
	  distance: '186.00'
	}, {
	  name: 'HD 153950 b',
	  radius: '13.48',
	  distance: '49.60'
	}, {
	  name: 'HD 154088 b',
	  radius: '2.06',
	  distance: '17.80'
	}, {
	  name: 'HD 154345 b',
	  radius: '13.93',
	  distance: '18.06'
	}, {
	  name: 'HD 154672 b',
	  radius: '13.21',
	  distance: '65.80'
	}, {
	  name: 'HD 154857 b',
	  radius: '13.66',
	  distance: '68.50'
	}, {
	  name: 'HD 155358 b',
	  radius: '14.00',
	  distance: '43.00'
	}, {
	  name: 'HD 155358 c',
	  radius: '14.02',
	  distance: '43.00'
	}, {
	  name: 'HD 156279 b',
	  radius: '12.93',
	  distance: '36.60'
	}, {
	  name: 'HD 156411 b',
	  radius: '14.06',
	  distance: '55.10'
	}, {
	  name: 'HD 156668 b',
	  radius: '1.72',
	  distance: '24.50'
	}, {
	  name: 'HD 157172 b',
	  radius: '7.00',
	  distance: '31.90'
	}, {
	  name: 'HD 158038 b',
	  radius: '13.66',
	  distance: '103.60'
	}, {
	  name: 'HD 159243 b',
	  radius: '13.81',
	  distance: '69.20'
	}, {
	  name: 'HD 159243 c',
	  radius: '13.57',
	  distance: '69.20'
	}, {
	  name: 'HD 159868 b',
	  radius: '13.59',
	  distance: '52.70'
	}, {
	  name: 'HD 159868 c',
	  radius: '14.07',
	  distance: '52.70'
	}, {
	  name: 'HD 16141 b',
	  radius: '9.70',
	  distance: '35.90'
	}, {
	  name: 'HD 16175 b',
	  radius: '13.27',
	  distance: '59.80'
	}, {
	  name: 'HD 162020 b',
	  radius: '12.76',
	  distance: '31.26'
	}, {
	  name: 'HD 163607 b',
	  radius: '14.05',
	  distance: '69.00'
	}, {
	  name: 'HD 163607 c',
	  radius: '13.55',
	  distance: '69.00'
	}, {
	  name: 'HD 16417 b',
	  radius: '5.13',
	  distance: '25.50'
	}, {
	  name: 'HD 164509 b',
	  radius: '14.26',
	  distance: '52.00'
	}, {
	  name: 'HD 164604 b',
	  radius: '13.48',
	  distance: '38.00'
	}, {
	  name: 'HD 164922 b',
	  radius: '14.40',
	  distance: '21.93'
	}, {
	  name: 'HD 166724 b',
	  radius: '13.30',
	  distance: '42.30'
	}, {
	  name: 'HD 167042 b',
	  radius: '13.71',
	  distance: '50.00'
	}, {
	  name: 'HD 168443 b',
	  radius: '13.03',
	  distance: '37.38'
	}, {
	  name: 'HD 168443 c',
	  radius: '12.69',
	  distance: '37.38'
	}, {
	  name: 'HD 168746 b',
	  radius: '10.07',
	  distance: '43.12'
	}, {
	  name: 'HD 1690 b',
	  radius: '13.12',
	  distance: '319.00'
	}, {
	  name: 'HD 169830 b',
	  radius: '13.45',
	  distance: '36.32'
	}, {
	  name: 'HD 169830 c',
	  radius: '13.30',
	  distance: '36.32'
	}, {
	  name: 'HD 170469 b',
	  radius: '14.11',
	  distance: '64.97'
	}, {
	  name: 'HD 17092 b',
	  radius: '13.25',
	  distance: '109.00'
	}, {
	  name: 'HD 171028 b',
	  radius: '13.62',
	  distance: '90.00'
	}, {
	  name: 'HD 171238 b',
	  radius: '13.50',
	  distance: '50.28'
	}, {
	  name: 'HD 17156 b',
	  radius: '12.26',
	  distance: '78.24'
	}, {
	  name: 'HD 173416 b',
	  radius: '13.48',
	  distance: '135.00'
	}, {
	  name: 'HD 175167 b',
	  radius: '13.02',
	  distance: '67.02'
	}, {
	  name: 'HD 175541 b',
	  radius: '14.15',
	  distance: '128.00'
	}, {
	  name: 'HD 176051 b',
	  radius: '13.74',
	  distance: '14.99'
	}, {
	  name: 'HD 177830 b',
	  radius: '13.75',
	  distance: '59.00'
	}, {
	  name: 'HD 177830 c',
	  radius: '7.93',
	  distance: '59.00'
	}, {
	  name: 'HD 178911 B b',
	  radius: '13.11',
	  distance: '46.73'
	}, {
	  name: 'HD 179079 b',
	  radius: '5.58',
	  distance: '63.69'
	}, {
	  name: 'HD 179949 b',
	  radius: '13.95',
	  distance: '27.00'
	}, {
	  name: 'HD 180314 b',
	  radius: '12.58',
	  distance: '132.00'
	}, {
	  name: 'HD 180902 b',
	  radius: '13.71',
	  distance: '110.00'
	}, {
	  name: 'HD 181342 b',
	  radius: '13.39',
	  distance: '110.60'
	}, {
	  name: 'HD 181433 b',
	  radius: '2.30',
	  distance: '26.15'
	}, {
	  name: 'HD 181433 c',
	  radius: '14.13',
	  distance: '26.15'
	}, {
	  name: 'HD 181433 d',
	  radius: '14.21',
	  distance: '26.15'
	}, {
	  name: 'HD 181720 b',
	  radius: '14.39',
	  distance: '56.00'
	}, {
	  name: 'HD 183263 b',
	  radius: '13.35',
	  distance: '53.00'
	}, {
	  name: 'HD 183263 c',
	  radius: '13.33',
	  distance: '53.00'
	}, {
	  name: 'HD 185269 b',
	  radius: '13.95',
	  distance: '47.00'
	}, {
	  name: 'HD 187085 b',
	  radius: '14.06',
	  distance: '44.98'
	}, {
	  name: 'HD 187123 b',
	  radius: '14.23',
	  distance: '50.00'
	}, {
	  name: 'HD 187123 c',
	  radius: '13.62',
	  distance: '50.00'
	}, {
	  name: 'HD 18742 b',
	  radius: '13.48',
	  distance: '135.00'
	}, {
	  name: 'HD 188015 b',
	  radius: '13.82',
	  distance: '52.60'
	}, {
	  name: 'HD 189567 b',
	  radius: '3.32',
	  distance: '17.70'
	}, {
	  name: 'HD 189733 b',
	  radius: '12.75',
	  distance: '19.30'
	}, {
	  name: 'HD 190360 b',
	  radius: '13.74',
	  distance: '15.89'
	}, {
	  name: 'HD 190360 c',
	  radius: '4.61',
	  distance: '15.89'
	}, {
	  name: 'HD 190647 b',
	  radius: '13.64',
	  distance: '54.20'
	}, {
	  name: 'HD 190984 b',
	  radius: '13.42',
	  distance: '103.00'
	}, {
	  name: 'HD 192263 b',
	  radius: '14.07',
	  distance: '19.90'
	}, {
	  name: 'HD 192310 b',
	  radius: '4.43',
	  distance: '8.82'
	}, {
	  name: 'HD 192310 c',
	  radius: '5.38',
	  distance: '8.82'
	}, {
	  name: 'HD 192699 b',
	  radius: '13.51',
	  distance: '67.00'
	}, {
	  name: 'HD 195019 b',
	  radius: '13.34',
	  distance: '37.36'
	}, {
	  name: 'HD 196050 b',
	  radius: '13.46',
	  distance: '46.90'
	}, {
	  name: 'HD 196067 b',
	  radius: '13.01',
	  distance: '44.30'
	}, {
	  name: 'HD 196885 A b',
	  radius: '13.44',
	  distance: '33.00'
	}, {
	  name: 'HD 197037 b',
	  radius: '14.03',
	  distance: '33.00'
	}, {
	  name: 'HD 19994 b',
	  radius: '13.69',
	  distance: '22.38'
	}, {
	  name: 'HD 20003 b',
	  radius: '3.67',
	  distance: '43.80'
	}, {
	  name: 'HD 20003 c',
	  radius: '3.90',
	  distance: '43.80'
	}, {
	  name: 'HD 200964 b',
	  radius: '13.65',
	  distance: '68.40'
	}, {
	  name: 'HD 200964 c',
	  radius: '13.97',
	  distance: '68.40'
	}, {
	  name: 'HD 202206 b',
	  radius: '12.68',
	  distance: '46.34'
	}, {
	  name: 'HD 202206 c',
	  radius: '13.52',
	  distance: '46.34'
	}, {
	  name: 'HD 20367 b',
	  radius: '13.90',
	  distance: '27.00'
	}, {
	  name: 'HD 2039 b',
	  radius: '13.22',
	  distance: '89.80'
	}, {
	  name: 'HD 204313 b',
	  radius: '13.36',
	  distance: '47.37'
	}, {
	  name: 'HD 204313 c',
	  radius: '4.48',
	  distance: '47.37'
	}, {
	  name: 'HD 204313 d',
	  radius: '13.69',
	  distance: '47.37'
	}, {
	  name: 'HD 204941 b',
	  radius: '10.93',
	  distance: '27.00'
	}, {
	  name: 'HD 205739 b',
	  radius: '13.78',
	  distance: '90.30'
	}, {
	  name: 'HD 206610 b',
	  radius: '13.57',
	  distance: '194.00'
	}, {
	  name: 'HD 20781 b',
	  radius: '3.67',
	  distance: '35.40'
	}, {
	  name: 'HD 20781 c',
	  radius: '4.27',
	  distance: '35.40'
	}, {
	  name: 'HD 20782 b',
	  radius: '13.64',
	  distance: '36.02'
	}, {
	  name: 'HD 207832 b',
	  radius: '14.13',
	  distance: '54.40'
	}, {
	  name: 'HD 207832 c',
	  radius: '14.00',
	  distance: '54.40'
	}, {
	  name: 'HD 20794 b',
	  radius: '1.44',
	  distance: '6.06'
	}, {
	  name: 'HD 20794 c',
	  radius: '1.38',
	  distance: '6.06'
	}, {
	  name: 'HD 20794 d',
	  radius: '1.83',
	  distance: '6.06'
	}, {
	  name: 'HD 208487 b',
	  radius: '14.34',
	  distance: '45.00'
	}, {
	  name: 'HD 208527 b',
	  radius: '12.86',
	  distance: '320.20'
	}, {
	  name: 'HD 20868 b',
	  radius: '13.62',
	  distance: '48.90'
	}, {
	  name: 'HD 209458 b',
	  radius: '15.46',
	  distance: '47.00'
	}, {
	  name: 'HD 210277 b',
	  radius: '13.83',
	  distance: '21.29'
	}, {
	  name: 'HD 210702 b',
	  radius: '13.64',
	  distance: '56.00'
	}, {
	  name: 'HD 212301 b',
	  radius: '14.30',
	  distance: '52.70'
	}, {
	  name: 'HD 212771 b',
	  radius: '13.55',
	  distance: '131.00'
	}, {
	  name: 'HD 213240 b',
	  radius: '13.26',
	  distance: '40.75'
	}, {
	  name: 'HD 215152 b',
	  radius: '1.45',
	  distance: '21.50'
	}, {
	  name: 'HD 215152 c',
	  radius: '1.52',
	  distance: '21.50'
	}, {
	  name: 'HD 215456 b',
	  radius: '6.35',
	  distance: '38.00'
	}, {
	  name: 'HD 215456 c',
	  radius: '10.46',
	  distance: '38.00'
	}, {
	  name: 'HD 215497 b',
	  radius: '2.10',
	  distance: '44.00'
	}, {
	  name: 'HD 215497 c',
	  radius: '14.44',
	  distance: '44.00'
	}, {
	  name: 'HD 216435 b',
	  radius: '13.82',
	  distance: '33.30'
	}, {
	  name: 'HD 216437 b',
	  radius: '13.66',
	  distance: '26.50'
	}, {
	  name: 'HD 216770 b',
	  radius: '14.12',
	  distance: '38.00'
	}, {
	  name: 'HD 21693 b',
	  radius: '3.35',
	  distance: '32.40'
	}, {
	  name: 'HD 21693 c',
	  radius: '4.95',
	  distance: '32.40'
	}, {
	  name: 'HD 217107 b',
	  radius: '13.80',
	  distance: '19.72'
	}, {
	  name: 'HD 217107 c',
	  radius: '13.52',
	  distance: '19.72'
	}, {
	  name: 'HD 217786 b',
	  radius: '12.80',
	  distance: '54.80'
	}, {
	  name: 'HD 218566 b',
	  radius: '9.57',
	  distance: '29.94'
	}, {
	  name: 'HD 219077 b',
	  radius: '12.84',
	  distance: '29.35'
	}, {
	  name: 'HD 219415 b',
	  radius: '13.86',
	  distance: ''
	}, {
	  name: 'HD 219828 b',
	  radius: '5.01',
	  distance: '81.10'
	}, {
	  name: 'HD 220074 b',
	  radius: '12.81',
	  distance: '290.20'
	}, {
	  name: 'HD 220689 b',
	  radius: '13.83',
	  distance: '44.60'
	}, {
	  name: 'HD 220773 b',
	  radius: '13.76',
	  distance: '49.00'
	}, {
	  name: 'HD 221287 b',
	  radius: '13.42',
	  distance: '52.90'
	}, {
	  name: 'HD 222155 b',
	  radius: '13.64',
	  distance: '49.10'
	}, {
	  name: 'HD 222582 b',
	  radius: '13.02',
	  distance: '42.00'
	}, {
	  name: 'HD 224693 b',
	  radius: '14.08',
	  distance: '94.00'
	}, {
	  name: 'HD 22781 b',
	  radius: '12.78',
	  distance: '31.79'
	}, {
	  name: 'HD 23079 b',
	  radius: '13.51',
	  distance: '34.80'
	}, {
	  name: 'HD 23127 b',
	  radius: '13.74',
	  distance: '89.10'
	}, {
	  name: 'HD 231701 b',
	  radius: '13.89',
	  distance: '108.40'
	}, {
	  name: 'HD 233604 b',
	  radius: '13.03',
	  distance: ''
	}, {
	  name: 'HD 23596 b',
	  radius: '13.00',
	  distance: '52.00'
	}, {
	  name: 'HD 240210 b',
	  radius: '13.07',
	  distance: '143.00'
	}, {
	  name: 'HD 240237 b',
	  radius: '13.19',
	  distance: '1500.00'
	}, {
	  name: 'HD 24040 b',
	  radius: '13.31',
	  distance: '46.51'
	}, {
	  name: 'HD 25171 b',
	  radius: '13.95',
	  distance: '55.00'
	}, {
	  name: 'HD 2638 b',
	  radius: '14.26',
	  distance: '53.71'
	}, {
	  name: 'HD 27442 b',
	  radius: '13.79',
	  distance: '18.10'
	}, {
	  name: 'HD 27631 b',
	  radius: '13.69',
	  distance: '45.50'
	}, {
	  name: 'HD 27894 b',
	  radius: '14.15',
	  distance: '42.37'
	}, {
	  name: 'HD 28185 b',
	  radius: '13.15',
	  distance: '39.40'
	}, {
	  name: 'HD 28254 b',
	  radius: '13.86',
	  distance: '56.20'
	}, {
	  name: 'HD 285507 b',
	  radius: '13.90',
	  distance: '41.30'
	}, {
	  name: 'HD 28678 b',
	  radius: '13.69',
	  distance: '227.00'
	}, {
	  name: 'HD 290327 b',
	  radius: '13.51',
	  distance: '54.90'
	}, {
	  name: 'HD 2952 b',
	  radius: '13.65',
	  distance: '115.20'
	}, {
	  name: 'HD 30177 b',
	  radius: '13.02',
	  distance: '55.00'
	}, {
	  name: 'HD 30562 b',
	  radius: '13.81',
	  distance: '26.50'
	}, {
	  name: 'HD 30856 b',
	  radius: '13.66',
	  distance: '118.10'
	}, {
	  name: 'HD 31253 b',
	  radius: '14.25',
	  distance: '53.82'
	}, {
	  name: 'HD 31527 b',
	  radius: '3.58',
	  distance: '38.60'
	}, {
	  name: 'HD 31527 c',
	  radius: '4.28',
	  distance: '38.60'
	}, {
	  name: 'HD 31527 d',
	  radius: '4.38',
	  distance: '38.60'
	}, {
	  name: 'HD 32518 b',
	  radius: '13.43',
	  distance: '117.40'
	}, {
	  name: 'HD 330075 b',
	  radius: '14.15',
	  distance: '50.20'
	}, {
	  name: 'HD 33142 b',
	  radius: '13.81',
	  distance: '126.00'
	}, {
	  name: 'HD 33283 b',
	  radius: '14.44',
	  distance: '86.00'
	}, {
	  name: 'HD 33564 b',
	  radius: '12.95',
	  distance: '20.98'
	}, {
	  name: 'HD 34445 b',
	  radius: '14.03',
	  distance: '46.50'
	}, {
	  name: 'HD 3651 b',
	  radius: '9.32',
	  distance: '11.00'
	}, {
	  name: 'HD 3651 c',
	  radius: '6.46',
	  distance: '11.00'
	}, {
	  name: 'HD 37124 b',
	  radius: '14.11',
	  distance: '33.00'
	}, {
	  name: 'HD 37124 c',
	  radius: '14.12',
	  distance: '33.00'
	}, {
	  name: 'HD 37124 d',
	  radius: '14.09',
	  distance: '33.00'
	}, {
	  name: 'HD 37605 b',
	  radius: '13.46',
	  distance: '44.00'
	}, {
	  name: 'HD 37605 c',
	  radius: '13.32',
	  distance: '44.00'
	}, {
	  name: 'HD 38283 b',
	  radius: '14.43',
	  distance: '37.70'
	}, {
	  name: 'HD 38529 b',
	  radius: '14.04',
	  distance: '39.28'
	}, {
	  name: 'HD 38529 c',
	  radius: '12.67',
	  distance: '39.28'
	}, {
	  name: 'HD 38801 b',
	  radius: '12.89',
	  distance: '99.40'
	}, {
	  name: 'HD 38858 b',
	  radius: '6.18',
	  distance: '15.20'
	}, {
	  name: 'HD 39091 b',
	  radius: '12.90',
	  distance: '18.32'
	}, {
	  name: 'HD 39194 b',
	  radius: '1.64',
	  distance: '25.90'
	}, {
	  name: 'HD 39194 c',
	  radius: '2.03',
	  distance: '25.90'
	}, {
	  name: 'HD 39194 d',
	  radius: '1.90',
	  distance: '25.90'
	}, {
	  name: 'HD 40307 b',
	  radius: '1.69',
	  distance: '12.80'
	}, {
	  name: 'HD 40307 c',
	  radius: '2.14',
	  distance: '12.80'
	}, {
	  name: 'HD 40307 d',
	  radius: '3.21',
	  distance: '12.80'
	}, {
	  name: 'HD 40307 e',
	  radius: '1.70',
	  distance: '12.80'
	}, {
	  name: 'HD 40307 f',
	  radius: '2.04',
	  distance: '12.80'
	}, {
	  name: 'HD 40307 g',
	  radius: '2.39',
	  distance: '12.80'
	}, {
	  name: 'HD 40979 b',
	  radius: '13.39',
	  distance: '33.30'
	}, {
	  name: 'HD 41004 A b',
	  radius: '13.51',
	  distance: '42.50'
	}, {
	  name: 'HD 41004 B b',
	  radius: '12.66',
	  distance: '43.03'
	}, {
	  name: 'HD 4113 b',
	  radius: '13.72',
	  distance: '44.00'
	}, {
	  name: 'HD 41248 b',
	  radius: '4.03',
	  distance: '52.38'
	}, {
	  name: 'HD 41248 c',
	  radius: '3.30',
	  distance: '52.38'
	}, {
	  name: 'HD 4203 b',
	  radius: '13.60',
	  distance: '77.50'
	}, {
	  name: 'HD 4208 b',
	  radius: '14.03',
	  distance: '33.90'
	}, {
	  name: 'HD 4308 b',
	  radius: '3.81',
	  distance: '21.90'
	}, {
	  name: 'HD 4313 b',
	  radius: '13.55',
	  distance: '137.00'
	}, {
	  name: 'HD 43197 b',
	  radius: '14.16',
	  distance: '54.90'
	}, {
	  name: 'HD 43691 b',
	  radius: '13.52',
	  distance: '93.20'
	}, {
	  name: 'HD 44219 b',
	  radius: '14.18',
	  distance: '50.43'
	}, {
	  name: 'HD 45184 b',
	  radius: '3.78',
	  distance: '21.90'
	}, {
	  name: 'HD 45350 b',
	  radius: '13.66',
	  distance: '49.00'
	}, {
	  name: 'HD 45364 b',
	  radius: '8.98',
	  distance: '32.60'
	}, {
	  name: 'HD 45364 c',
	  radius: '14.12',
	  distance: '32.60'
	}, {
	  name: 'HD 45652 b',
	  radius: '14.27',
	  distance: '36.00'
	}, {
	  name: 'HD 46375 b',
	  radius: '10.53',
	  distance: '33.40'
	}, {
	  name: 'HD 47186 b',
	  radius: '5.24',
	  distance: '37.84'
	}, {
	  name: 'HD 47186 c',
	  radius: '14.41',
	  distance: '37.84'
	}, {
	  name: 'HD 47536 b',
	  radius: '13.21',
	  distance: '121.36'
	}, {
	  name: 'HD 47536 c',
	  radius: '13.00',
	  distance: '121.36'
	}, {
	  name: 'HD 48265 b',
	  radius: '13.86',
	  distance: '87.40'
	}, {
	  name: 'HD 49674 b',
	  radius: '6.83',
	  distance: '40.70'
	}, {
	  name: 'HD 50499 b',
	  radius: '13.68',
	  distance: '47.26'
	}, {
	  name: 'HD 50554 b',
	  radius: '13.20',
	  distance: '31.03'
	}, {
	  name: 'HD 51608 b',
	  radius: '3.85',
	  distance: '34.80'
	}, {
	  name: 'HD 51608 c',
	  radius: '4.59',
	  distance: '34.80'
	}, {
	  name: 'HD 52265 b',
	  radius: '13.90',
	  distance: '28.00'
	}, {
	  name: 'HD 52265 c',
	  radius: '14.35',
	  distance: '28.00'
	}, {
	  name: 'HD 5319 b',
	  radius: '13.63',
	  distance: '100.00'
	}, {
	  name: 'HD 5608 b',
	  radius: '13.71',
	  distance: '58.20'
	}, {
	  name: 'HD 5891 b',
	  radius: '13.03',
	  distance: '251.00'
	}, {
	  name: 'HD 59686 b',
	  radius: '13.19',
	  distance: '92.00'
	}, {
	  name: 'HD 60532 b',
	  radius: '13.41',
	  distance: '25.70'
	}, {
	  name: 'HD 60532 c',
	  radius: '13.04',
	  distance: '25.70'
	}, {
	  name: 'HD 62509 b',
	  radius: '13.45',
	  distance: '10.34'
	}, {
	  name: 'HD 63454 b',
	  radius: '14.37',
	  distance: '35.80'
	}, {
	  name: 'HD 63765 b',
	  radius: '14.13',
	  distance: '32.60'
	}, {
	  name: 'HD 6434 b',
	  radius: '14.36',
	  distance: '40.32'
	}, {
	  name: 'HD 65216 b',
	  radius: '13.84',
	  distance: '34.30'
	}, {
	  name: 'HD 65216 c',
	  radius: '9.22',
	  distance: '34.30'
	}, {
	  name: 'HD 66141 b',
	  radius: '13.07',
	  distance: '80.90'
	}, {
	  name: 'HD 66428 b',
	  radius: '13.46',
	  distance: '55.00'
	}, {
	  name: 'HD 6718 b',
	  radius: '13.72',
	  distance: '55.90'
	}, {
	  name: 'HD 68988 b',
	  radius: '13.64',
	  distance: '58.00'
	}, {
	  name: 'HD 69830 b',
	  radius: '3.40',
	  distance: '12.60'
	}, {
	  name: 'HD 69830 c',
	  radius: '3.68',
	  distance: '12.60'
	}, {
	  name: 'HD 69830 d',
	  radius: '4.66',
	  distance: '12.60'
	}, {
	  name: 'HD 70573 b',
	  radius: '13.12',
	  distance: '45.70'
	}, {
	  name: 'HD 70642 b',
	  radius: '13.61',
	  distance: '28.80'
	}, {
	  name: 'HD 7199 b',
	  radius: '11.47',
	  distance: '36.00'
	}, {
	  name: 'HD 72659 b',
	  radius: '13.41',
	  distance: '49.80'
	}, {
	  name: 'HD 73256 b',
	  radius: '13.64',
	  distance: '36.50'
	}, {
	  name: 'HD 73267 b',
	  radius: '13.42',
	  distance: '54.91'
	}, {
	  name: 'HD 73526 b',
	  radius: '13.45',
	  distance: '99.00'
	}, {
	  name: 'HD 73526 c',
	  radius: '13.51',
	  distance: '99.00'
	}, {
	  name: 'HD 73534 b',
	  radius: '13.86',
	  distance: '96.99'
	}, {
	  name: 'HD 74156 b',
	  radius: '13.64',
	  distance: '64.56'
	}, {
	  name: 'HD 74156 c',
	  radius: '13.01',
	  distance: '64.56'
	}, {
	  name: 'HD 7449 b',
	  radius: '13.88',
	  distance: '39.00'
	}, {
	  name: 'HD 7449 c',
	  radius: '13.61',
	  distance: '39.00'
	}, {
	  name: 'HD 75289 b',
	  radius: '14.33',
	  distance: '28.94'
	}, {
	  name: 'HD 75898 b',
	  radius: '13.51',
	  distance: '80.58'
	}, {
	  name: 'HD 76700 b',
	  radius: '9.24',
	  distance: '59.70'
	}, {
	  name: 'HD 77338 b',
	  radius: '14.18',
	  distance: '40.75'
	}, {
	  name: 'HD 7924 b',
	  radius: '2.56',
	  distance: '16.80'
	}, {
	  name: 'HD 79498 b',
	  radius: '13.79',
	  distance: '49.00'
	}, {
	  name: 'HD 80606 b',
	  radius: '10.32',
	  distance: '58.40'
	}, {
	  name: 'HD 81040 b',
	  radius: '13.07',
	  distance: '32.56'
	}, {
	  name: 'HD 81688 b',
	  radius: '13.48',
	  distance: '88.26'
	}, {
	  name: 'HD 82886 b',
	  radius: '13.81',
	  distance: '125.00'
	}, {
	  name: 'HD 82943 b',
	  radius: '13.23',
	  distance: '27.46'
	}, {
	  name: 'HD 82943 c',
	  radius: '13.23',
	  distance: '27.46'
	}, {
	  name: 'HD 82943 d',
	  radius: '14.43',
	  distance: '27.46'
	}, {
	  name: 'HD 83443 b',
	  radius: '14.35',
	  distance: '43.54'
	}, {
	  name: 'HD 8535 b',
	  radius: '14.10',
	  distance: '52.50'
	}, {
	  name: 'HD 85390 b',
	  radius: '7.38',
	  distance: '33.96'
	}, {
	  name: 'HD 85390 c',
	  radius: '10.10',
	  distance: '33.96'
	}, {
	  name: 'HD 85512 b',
	  radius: '1.60',
	  distance: '11.15'
	}, {
	  name: 'HD 8574 b',
	  radius: '13.59',
	  distance: '44.20'
	}, {
	  name: 'HD 86081 b',
	  radius: '13.74',
	  distance: '91.00'
	}, {
	  name: 'HD 86226 b',
	  radius: '13.74',
	  distance: '42.48'
	}, {
	  name: 'HD 86264 b',
	  radius: '13.07',
	  distance: '72.60'
	}, {
	  name: 'HD 8673 b',
	  radius: '12.77',
	  distance: '38.25'
	}, {
	  name: 'HD 87883 b',
	  radius: '12.83',
	  distance: '18.10'
	}, {
	  name: 'HD 88133 b',
	  radius: '9.83',
	  distance: '74.50'
	}, {
	  name: 'HD 89307 b',
	  radius: '13.61',
	  distance: '30.90'
	}, {
	  name: 'HD 89744 b',
	  radius: '13.05',
	  distance: '40.00'
	}, {
	  name: 'HD 89744 c',
	  radius: '13.34',
	  distance: '40.00'
	}, {
	  name: 'HD 90156 b',
	  radius: '4.61',
	  distance: '39.60'
	}, {
	  name: 'HD 92788 b',
	  radius: '13.32',
	  distance: '32.82'
	}, {
	  name: 'HD 92788 c',
	  radius: '13.91',
	  distance: '32.82'
	}, {
	  name: 'HD 93083 b',
	  radius: '14.39',
	  distance: '28.90'
	}, {
	  name: 'HD 93385 b',
	  radius: '2.42',
	  distance: '42.20'
	}, {
	  name: 'HD 93385 c',
	  radius: '3.33',
	  distance: '42.20'
	}, {
	  name: 'HD 9446 b',
	  radius: '14.09',
	  distance: '53.00'
	}, {
	  name: 'HD 9446 c',
	  radius: '13.66',
	  distance: '53.00'
	}, {
	  name: 'HD 95086 b',
	  radius: '13.19',
	  distance: '90.40'
	}, {
	  name: 'HD 95089 b',
	  radius: '13.84',
	  distance: '139.00'
	}, {
	  name: 'HD 9578 b',
	  radius: '14.08',
	  distance: '57.24'
	}, {
	  name: 'HD 96063 b',
	  radius: '13.97',
	  distance: '158.00'
	}, {
	  name: 'HD 96127 b',
	  radius: '13.31',
	  distance: '540.00'
	}, {
	  name: 'HD 96167 b',
	  radius: '14.10',
	  distance: '84.00'
	}, {
	  name: 'HD 96700 b',
	  radius: '2.53',
	  distance: '25.60'
	}, {
	  name: 'HD 96700 c',
	  radius: '3.78',
	  distance: '25.60'
	}, {
	  name: 'HD 97658 b',
	  radius: '2.34',
	  distance: '21.10'
	}, {
	  name: 'HD 98219 b',
	  radius: '13.66',
	  distance: '134.00'
	}, {
	  name: 'HD 98649 b',
	  radius: '13.02',
	  distance: '40.30'
	}, {
	  name: 'HD 99109 b',
	  radius: '14.24',
	  distance: '60.50'
	}, {
	  name: 'HD 99492 b',
	  radius: '6.63',
	  distance: '18.00'
	}, {
	  name: 'HD 99492 c',
	  radius: '14.40',
	  distance: '18.00'
	}, {
	  name: 'HD 99706 b',
	  radius: '13.77',
	  distance: '129.00'
	}, {
	  name: 'HIP 12961 b',
	  radius: '14.41',
	  distance: '23.00'
	}, {
	  name: 'HIP 13044 b',
	  radius: '13.82',
	  distance: '701.00'
	}, {
	  name: 'HIP 14810 b',
	  radius: '13.32',
	  distance: '52.90'
	}, {
	  name: 'HIP 14810 c',
	  radius: '13.81',
	  distance: '52.90'
	}, {
	  name: 'HIP 14810 d',
	  radius: '14.18',
	  distance: '52.90'
	}, {
	  name: 'HIP 5158 b',
	  radius: '13.76',
	  distance: '45.00'
	}, {
	  name: 'HIP 5158 c',
	  radius: '12.74',
	  distance: '45.00'
	}, {
	  name: 'HIP 57050 b',
	  radius: '11.65',
	  distance: '11.00'
	}, {
	  name: 'HIP 57274 b',
	  radius: '3.57',
	  distance: '25.92'
	}, {
	  name: 'HIP 57274 c',
	  radius: '14.34',
	  distance: '25.92'
	}, {
	  name: 'HIP 57274 d',
	  radius: '14.22',
	  distance: '25.92'
	}, {
	  name: 'HIP 63242 b',
	  radius: '12.89',
	  distance: '135.00'
	}, {
	  name: 'HIP 70849 b',
	  radius: '12.96',
	  distance: '24.00'
	}, {
	  name: 'HIP 75458 b',
	  radius: '12.97',
	  distance: '31.50'
	}, {
	  name: 'HIP 77900 b',
	  radius: '12.56',
	  distance: ''
	}, {
	  name: 'HIP 78530 b',
	  radius: '12.57',
	  distance: '156.70'
	}, {
	  name: 'HIP 79431 b',
	  radius: '13.59',
	  distance: '14.40'
	}, {
	  name: 'HIP 91258 b',
	  radius: '13.83',
	  distance: '44.90'
	}, {
	  name: 'HN Peg b',
	  radius: '12.32',
	  distance: '18.40'
	}, {
	  name: 'HR 228 b',
	  radius: '13.47',
	  distance: ''
	}, {
	  name: 'HR 228 c',
	  radius: '13.47',
	  distance: ''
	}, {
	  name: 'HR 810 b',
	  radius: '13.56',
	  distance: '17.17'
	}, {
	  name: 'HR 8799 b',
	  radius: '12.32',
	  distance: '39.40'
	}, {
	  name: 'HR 8799 c',
	  radius: '14.56',
	  distance: '39.40'
	}, {
	  name: 'HR 8799 d',
	  radius: '13.44',
	  distance: '39.40'
	}, {
	  name: 'HR 8799 e',
	  radius: '12.96',
	  distance: '39.40'
	}, {
	  name: 'HU Aqr(AB) c',
	  radius: '13.08',
	  distance: ''
	}, {
	  name: 'HW Vir(AB) b',
	  radius: '12.76',
	  distance: '181.00'
	}, {
	  name: 'kappa And b',
	  radius: '12.74',
	  distance: '51.60'
	}, {
	  name: 'kappa CrB b',
	  radius: '13.71',
	  distance: '31.10'
	}, {
	  name: 'KELT-1 b',
	  radius: '12.50',
	  distance: '263.00'
	}, {
	  name: 'KELT-2A b',
	  radius: '14.63',
	  distance: '128.90'
	}, {
	  name: 'KELT-3 b',
	  radius: '14.93',
	  distance: '178.00'
	}, {
	  name: 'KELT-6 b',
	  radius: '13.33',
	  distance: ''
	}, {
	  name: 'Kepler-10 b',
	  radius: '1.41',
	  distance: '173.00'
	}, {
	  name: 'Kepler-10 c',
	  radius: '2.23',
	  distance: '173.00'
	}, {
	  name: 'Kepler-11 b',
	  radius: '1.80',
	  distance: ''
	}, {
	  name: 'Kepler-11 c',
	  radius: '2.87',
	  distance: ''
	}, {
	  name: 'Kepler-11 d',
	  radius: '3.12',
	  distance: ''
	}, {
	  name: 'Kepler-11 e',
	  radius: '4.53',
	  distance: ''
	}, {
	  name: 'Kepler-11 f',
	  radius: '2.49',
	  distance: ''
	}, {
	  name: 'Kepler-11 g',
	  radius: '3.67',
	  distance: ''
	}, {
	  name: 'Kepler-12 b',
	  radius: '18.98',
	  distance: ''
	}, {
	  name: 'Kepler-13 b',
	  radius: '20.50',
	  distance: ''
	}, {
	  name: 'Kepler-14 b',
	  radius: '12.72',
	  distance: '980.00'
	}, {
	  name: 'Kepler-15 b',
	  radius: '10.75',
	  distance: ''
	}, {
	  name: 'Kepler-16(AB) b',
	  radius: '8.44',
	  distance: ''
	}, {
	  name: 'Kepler-17 b',
	  radius: '14.69',
	  distance: '800.00'
	}, {
	  name: 'Kepler-18 b',
	  radius: '2.00',
	  distance: ''
	}, {
	  name: 'Kepler-18 c',
	  radius: '5.48',
	  distance: ''
	}, {
	  name: 'Kepler-18 d',
	  radius: '6.96',
	  distance: ''
	}, {
	  name: 'Kepler-19 b',
	  radius: '2.22',
	  distance: ''
	}, {
	  name: 'Kepler-20 b',
	  radius: '1.90',
	  distance: '290.00'
	}, {
	  name: 'Kepler-20 c',
	  radius: '3.06',
	  distance: '290.00'
	}, {
	  name: 'Kepler-20 d',
	  radius: '2.80',
	  distance: '290.00'
	}, {
	  name: 'Kepler-20 e',
	  radius: '0.87',
	  distance: '290.00'
	}, {
	  name: 'Kepler-20 f',
	  radius: '1.01',
	  distance: '290.00'
	}, {
	  name: 'Kepler-21 b',
	  radius: '1.63',
	  distance: '108.00'
	}, {
	  name: 'Kepler-22 b',
	  radius: '2.35',
	  distance: '190.00'
	}, {
	  name: 'Kepler-23 b',
	  radius: '1.90',
	  distance: ''
	}, {
	  name: 'Kepler-23 c',
	  radius: '3.25',
	  distance: ''
	}, {
	  name: 'Kepler-24 b',
	  radius: '2.35',
	  distance: ''
	}, {
	  name: 'Kepler-24 c',
	  radius: '2.80',
	  distance: ''
	}, {
	  name: 'Kepler-25 b',
	  radius: '2.58',
	  distance: ''
	}, {
	  name: 'Kepler-25 c',
	  radius: '4.48',
	  distance: ''
	}, {
	  name: 'Kepler-26 b',
	  radius: '3.58',
	  distance: ''
	}, {
	  name: 'Kepler-26 c',
	  radius: '3.58',
	  distance: ''
	}, {
	  name: 'Kepler-27 b',
	  radius: '4.03',
	  distance: ''
	}, {
	  name: 'Kepler-27 c',
	  radius: '4.93',
	  distance: ''
	}, {
	  name: 'Kepler-28 b',
	  radius: '3.58',
	  distance: ''
	}, {
	  name: 'Kepler-28 c',
	  radius: '3.36',
	  distance: ''
	}, {
	  name: 'Kepler-29 b',
	  radius: '3.58',
	  distance: ''
	}, {
	  name: 'Kepler-29 c',
	  radius: '2.91',
	  distance: ''
	}, {
	  name: 'Kepler-30 b',
	  radius: '3.92',
	  distance: ''
	}, {
	  name: 'Kepler-30 c',
	  radius: '12.32',
	  distance: ''
	}, {
	  name: 'Kepler-30 d',
	  radius: '8.85',
	  distance: ''
	}, {
	  name: 'Kepler-31 b',
	  radius: '4.26',
	  distance: ''
	}, {
	  name: 'Kepler-31 c',
	  radius: '4.26',
	  distance: ''
	}, {
	  name: 'Kepler-32 b',
	  radius: '4.14',
	  distance: ''
	}, {
	  name: 'Kepler-32 c',
	  radius: '3.70',
	  distance: ''
	}, {
	  name: 'Kepler-33 b',
	  radius: '1.79',
	  distance: ''
	}, {
	  name: 'Kepler-33 c',
	  radius: '3.25',
	  distance: ''
	}, {
	  name: 'Kepler-33 d',
	  radius: '5.38',
	  distance: ''
	}, {
	  name: 'Kepler-33 e',
	  radius: '4.03',
	  distance: ''
	}, {
	  name: 'Kepler-33 f',
	  radius: '4.48',
	  distance: ''
	}, {
	  name: 'Kepler-34(AB)  b',
	  radius: '8.55',
	  distance: '1499.00'
	}, {
	  name: 'Kepler-35(AB) b',
	  radius: '8.15',
	  distance: '1645.00'
	}, {
	  name: 'Kepler-36 b',
	  radius: '1.48',
	  distance: ''
	}, {
	  name: 'Kepler-36 c',
	  radius: '3.68',
	  distance: ''
	}, {
	  name: 'Kepler-37 b',
	  radius: '0.30',
	  distance: '66.00'
	}, {
	  name: 'Kepler-37 c',
	  radius: '0.74',
	  distance: '66.00'
	}, {
	  name: 'Kepler-37 d',
	  radius: '1.98',
	  distance: '66.00'
	}, {
	  name: 'Kepler-38(AB) b',
	  radius: '4.37',
	  distance: ''
	}, {
	  name: 'Kepler-39 b',
	  radius: '13.66',
	  distance: '1200.00'
	}, {
	  name: 'Kepler-4 b',
	  radius: '4.00',
	  distance: '550.00'
	}, {
	  name: 'Kepler-40 b',
	  radius: '13.10',
	  distance: '2700.00'
	}, {
	  name: 'Kepler-41  b',
	  radius: '9.42',
	  distance: '730.00'
	}, {
	  name: 'Kepler-42 b',
	  radius: '0.78',
	  distance: '38.70'
	}, {
	  name: 'Kepler-42 c',
	  radius: '0.73',
	  distance: '38.70'
	}, {
	  name: 'Kepler-42 d',
	  radius: '0.57',
	  distance: '38.70'
	}, {
	  name: 'Kepler-43 b',
	  radius: '13.44',
	  distance: '1950.00'
	}, {
	  name: 'Kepler-44 b',
	  radius: '13.89',
	  distance: '2250.00'
	}, {
	  name: 'Kepler-45 b',
	  radius: '10.75',
	  distance: '333.00'
	}, {
	  name: 'Kepler-46 b',
	  radius: '9.09',
	  distance: '857.00'
	}, {
	  name: 'Kepler-46 c',
	  radius: '14.38',
	  distance: '857.00'
	}, {
	  name: 'Kepler-47(AB) b',
	  radius: '3.02',
	  distance: ''
	}, {
	  name: 'Kepler-47(AB) c',
	  radius: '4.59',
	  distance: ''
	}, {
	  name: 'Kepler-48 b',
	  radius: '2.02',
	  distance: ''
	}, {
	  name: 'Kepler-48 c',
	  radius: '3.36',
	  distance: ''
	}, {
	  name: 'Kepler-49 b',
	  radius: '2.69',
	  distance: ''
	}, {
	  name: 'Kepler-49 c',
	  radius: '2.58',
	  distance: ''
	}, {
	  name: 'Kepler-5 b',
	  radius: '16.03',
	  distance: ''
	}, {
	  name: 'Kepler-50 b',
	  radius: '2.24',
	  distance: ''
	}, {
	  name: 'Kepler-50 c',
	  radius: '2.80',
	  distance: ''
	}, {
	  name: 'Kepler-51 b',
	  radius: '7.06',
	  distance: ''
	}, {
	  name: 'Kepler-51 c',
	  radius: '5.71',
	  distance: ''
	}, {
	  name: 'Kepler-52 b',
	  radius: '2.13',
	  distance: ''
	}, {
	  name: 'Kepler-52 c',
	  radius: '1.79',
	  distance: ''
	}, {
	  name: 'Kepler-53 b',
	  radius: '2.91',
	  distance: ''
	}, {
	  name: 'Kepler-53 c',
	  radius: '3.14',
	  distance: ''
	}, {
	  name: 'Kepler-54 b',
	  radius: '2.13',
	  distance: ''
	}, {
	  name: 'Kepler-54 c',
	  radius: '1.23',
	  distance: ''
	}, {
	  name: 'Kepler-55 b',
	  radius: '2.46',
	  distance: ''
	}, {
	  name: 'Kepler-55 c',
	  radius: '2.24',
	  distance: ''
	}, {
	  name: 'Kepler-56 b',
	  radius: '6.50',
	  distance: ''
	}, {
	  name: 'Kepler-56 c',
	  radius: '9.86',
	  distance: ''
	}, {
	  name: 'Kepler-56 d',
	  radius: '13.33',
	  distance: ''
	}, {
	  name: 'Kepler-57 b',
	  radius: '2.24',
	  distance: ''
	}, {
	  name: 'Kepler-57 c',
	  radius: '1.57',
	  distance: ''
	}, {
	  name: 'Kepler-58 b',
	  radius: '2.80',
	  distance: ''
	}, {
	  name: 'Kepler-58 c',
	  radius: '2.91',
	  distance: ''
	}, {
	  name: 'Kepler-59 b',
	  radius: '1.10',
	  distance: ''
	}, {
	  name: 'Kepler-59 c',
	  radius: '2.02',
	  distance: ''
	}, {
	  name: 'Kepler-6 b',
	  radius: '14.82',
	  distance: ''
	}, {
	  name: 'Kepler-60 b',
	  radius: '2.24',
	  distance: ''
	}, {
	  name: 'Kepler-60 c',
	  radius: '2.46',
	  distance: ''
	}, {
	  name: 'Kepler-60 d',
	  radius: '2.58',
	  distance: ''
	}, {
	  name: 'Kepler-61 b',
	  radius: '2.15',
	  distance: '326.00'
	}, {
	  name: 'Kepler-62 b',
	  radius: '1.31',
	  distance: '368.00'
	}, {
	  name: 'Kepler-62 c',
	  radius: '0.54',
	  distance: '368.00'
	}, {
	  name: 'Kepler-62 d',
	  radius: '1.95',
	  distance: '368.00'
	}, {
	  name: 'Kepler-62 e',
	  radius: '1.61',
	  distance: '368.00'
	}, {
	  name: 'Kepler-62 f',
	  radius: '1.41',
	  distance: '368.00'
	}, {
	  name: 'Kepler-63 b',
	  radius: '6.10',
	  distance: '200.00'
	}, {
	  name: 'Kepler-65 b',
	  radius: '1.42',
	  distance: ''
	}, {
	  name: 'Kepler-65 c',
	  radius: '2.58',
	  distance: ''
	}, {
	  name: 'Kepler-65 d',
	  radius: '1.51',
	  distance: ''
	}, {
	  name: 'Kepler-66 b',
	  radius: '2.80',
	  distance: '1107.00'
	}, {
	  name: 'Kepler-67 b',
	  radius: '2.91',
	  distance: '1107.00'
	}, {
	  name: 'Kepler-68 b',
	  radius: '2.30',
	  distance: '135.00'
	}, {
	  name: 'Kepler-68 c',
	  radius: '0.91',
	  distance: '135.00'
	}, {
	  name: 'Kepler-68 d',
	  radius: '13.89',
	  distance: '135.00'
	}, {
	  name: 'Kepler-69 b',
	  radius: '2.24',
	  distance: ''
	}, {
	  name: 'Kepler-69 c',
	  radius: '1.71',
	  distance: ''
	}, {
	  name: 'Kepler-7 b',
	  radius: '18.08',
	  distance: ''
	}, {
	  name: 'Kepler-70  b',
	  radius: '0.76',
	  distance: '1180.00'
	}, {
	  name: 'Kepler-70 c',
	  radius: '0.87',
	  distance: '1180.00'
	}, {
	  name: 'Kepler-71 b',
	  radius: '11.71',
	  distance: ''
	}, {
	  name: 'Kepler-74 b',
	  radius: '14.78',
	  distance: '1330.00'
	}, {
	  name: 'Kepler-75 b',
	  radius: '11.54',
	  distance: '1140.00'
	}, {
	  name: 'Kepler-76 b',
	  radius: '14.00',
	  distance: ''
	}, {
	  name: 'Kepler-77 b',
	  radius: '10.75',
	  distance: '570.00'
	}, {
	  name: 'Kepler-78 b',
	  radius: '1.20',
	  distance: ''
	}, {
	  name: 'Kepler-79 b',
	  radius: '3.30',
	  distance: ''
	}, {
	  name: 'Kepler-79 c',
	  radius: '3.73',
	  distance: ''
	}, {
	  name: 'Kepler-79 d',
	  radius: '7.17',
	  distance: ''
	}, {
	  name: 'Kepler-79 e',
	  radius: '3.49',
	  distance: ''
	}, {
	  name: 'Kepler-8 b',
	  radius: '15.89',
	  distance: '1330.00'
	}, {
	  name: 'Kepler-80 b',
	  radius: '2.35',
	  distance: ''
	}, {
	  name: 'Kepler-80 c',
	  radius: '2.58',
	  distance: ''
	}, {
	  name: 'Kepler-80 d',
	  radius: '1.40',
	  distance: ''
	}, {
	  name: 'Kepler-80 e',
	  radius: '1.50',
	  distance: ''
	}, {
	  name: 'Kepler-80 f',
	  radius: '1.30',
	  distance: ''
	}, {
	  name: 'Kepler-81 b',
	  radius: '2.54',
	  distance: ''
	}, {
	  name: 'Kepler-81 c',
	  radius: '2.45',
	  distance: ''
	}, {
	  name: 'Kepler-82 b',
	  radius: '4.00',
	  distance: ''
	}, {
	  name: 'Kepler-82 c',
	  radius: '5.30',
	  distance: ''
	}, {
	  name: 'Kepler-83 b',
	  radius: '2.34',
	  distance: ''
	}, {
	  name: 'Kepler-83 c',
	  radius: '1.94',
	  distance: ''
	}, {
	  name: 'Kepler-84 b',
	  radius: '2.20',
	  distance: ''
	}, {
	  name: 'Kepler-84 c',
	  radius: '2.40',
	  distance: ''
	}, {
	  name: 'Kepler-85 b',
	  radius: '1.99',
	  distance: ''
	}, {
	  name: 'Kepler-85 c',
	  radius: '2.21',
	  distance: ''
	}, {
	  name: 'Kepler-86 b',
	  radius: '10.14',
	  distance: ''
	}, {
	  name: 'Kepler-87 b',
	  radius: '13.55',
	  distance: ''
	}, {
	  name: 'Kepler-87 c',
	  radius: '6.15',
	  distance: ''
	}, {
	  name: 'Kepler-88 b',
	  radius: '4.22',
	  distance: '385.00'
	}, {
	  name: 'Kepler-88 c',
	  radius: '14.04',
	  distance: '385.00'
	}, {
	  name: 'Kepler-89 b',
	  radius: '1.71',
	  distance: ''
	}, {
	  name: 'Kepler-89 c',
	  radius: '4.32',
	  distance: ''
	}, {
	  name: 'Kepler-89 d',
	  radius: '11.20',
	  distance: ''
	}, {
	  name: 'Kepler-89 e',
	  radius: '6.16',
	  distance: ''
	}, {
	  name: 'Kepler-9 b',
	  radius: '9.42',
	  distance: ''
	}, {
	  name: 'Kepler-9 c',
	  radius: '9.21',
	  distance: ''
	}, {
	  name: 'Kepler-9 d',
	  radius: '1.65',
	  distance: ''
	}, {
	  name: 'Kepler-90 b',
	  radius: '1.31',
	  distance: ''
	}, {
	  name: 'Kepler-90 c',
	  radius: '1.19',
	  distance: ''
	}, {
	  name: 'Kepler-90 d',
	  radius: '2.88',
	  distance: ''
	}, {
	  name: 'Kepler-90 e',
	  radius: '2.67',
	  distance: ''
	}, {
	  name: 'Kepler-90 f',
	  radius: '2.89',
	  distance: ''
	}, {
	  name: 'Kepler-90 g',
	  radius: '8.12',
	  distance: ''
	}, {
	  name: 'Kepler-90 h',
	  radius: '11.31',
	  distance: ''
	}, {
	  name: 'KIC-10255705 b',
	  radius: '7.28',
	  distance: ''
	}, {
	  name: 'KIC-10905746 b',
	  radius: '2.65',
	  distance: ''
	}, {
	  name: 'KIC-11152511 b',
	  radius: '4.03',
	  distance: ''
	}, {
	  name: 'KIC-12351927(AB) b',
	  radius: '4.37',
	  distance: ''
	}, {
	  name: 'KIC-12454613 b',
	  radius: '2.69',
	  distance: ''
	}, {
	  name: 'KIC-12557548 b',
	  radius: '0.85',
	  distance: '470.00'
	}, {
	  name: 'KIC-5010054 b',
	  radius: '6.94',
	  distance: ''
	}, {
	  name: 'KIC-5094412 b',
	  radius: '5.71',
	  distance: ''
	}, {
	  name: 'KIC-5522786 b',
	  radius: '1.23',
	  distance: ''
	}, {
	  name: 'KIC-5732155 b',
	  radius: '12.77',
	  distance: ''
	}, {
	  name: 'KIC-6185331 b',
	  radius: '8.06',
	  distance: ''
	}, {
	  name: 'KIC-6372194 b',
	  radius: '8.29',
	  distance: ''
	}, {
	  name: 'KIC-6436029 c',
	  radius: '3.07',
	  distance: ''
	}, {
	  name: 'KIC-8852719 b',
	  radius: '3.53',
	  distance: ''
	}, {
	  name: 'KIC-9662267 b',
	  radius: '3.81',
	  distance: ''
	}, {
	  name: 'KIC-9704149 b',
	  radius: '4.48',
	  distance: ''
	}, {
	  name: 'KOI-111 b',
	  radius: '2.14',
	  distance: ''
	}, {
	  name: 'KOI-111 c',
	  radius: '2.05',
	  distance: ''
	}, {
	  name: 'KOI-115 b',
	  radius: '4.82',
	  distance: ''
	}, {
	  name: 'KOI-115 c',
	  radius: '1.91',
	  distance: ''
	}, {
	  name: 'KOI-117 b',
	  radius: '1.58',
	  distance: ''
	}, {
	  name: 'KOI-117 c',
	  radius: '1.71',
	  distance: ''
	}, {
	  name: 'KOI-1203 b',
	  radius: '2.90',
	  distance: ''
	}, {
	  name: 'KOI-1203 c',
	  radius: '2.80',
	  distance: ''
	}, {
	  name: 'KOI-1215 b',
	  radius: '2.92',
	  distance: ''
	}, {
	  name: 'KOI-1215 c',
	  radius: '3.36',
	  distance: ''
	}, {
	  name: 'KOI-1236 b',
	  radius: '4.31',
	  distance: ''
	}, {
	  name: 'KOI-1236 c',
	  radius: '3.10',
	  distance: ''
	}, {
	  name: 'KOI-1278 b',
	  radius: '2.46',
	  distance: ''
	}, {
	  name: 'KOI-1278 c',
	  radius: '3.10',
	  distance: ''
	}, {
	  name: 'KOI-156 b',
	  radius: '1.18',
	  distance: ''
	}, {
	  name: 'KOI-156 c',
	  radius: '1.60',
	  distance: ''
	}, {
	  name: 'KOI-156 d',
	  radius: '2.53',
	  distance: ''
	}, {
	  name: 'KOI-1563 b',
	  radius: '3.61',
	  distance: ''
	}, {
	  name: 'KOI-1563 c',
	  radius: '3.30',
	  distance: ''
	}, {
	  name: 'KOI-1576 c',
	  radius: '2.80',
	  distance: ''
	}, {
	  name: 'KOI-1676 b',
	  radius: '3.20',
	  distance: ''
	}, {
	  name: 'KOI-1781 b',
	  radius: '1.88',
	  distance: ''
	}, {
	  name: 'KOI-1843 b',
	  radius: '0.58',
	  distance: ''
	}, {
	  name: 'KOI-1873 b',
	  radius: '2.31',
	  distance: ''
	}, {
	  name: 'KOI-1873 c',
	  radius: '5.41',
	  distance: ''
	}, {
	  name: 'KOI-202 b',
	  radius: '11.42',
	  distance: ''
	}, {
	  name: 'KOI-2025 b',
	  radius: '3.10',
	  distance: ''
	}, {
	  name: 'KOI-2025 c',
	  radius: '2.80',
	  distance: ''
	}, {
	  name: 'KOI-206 b',
	  radius: '7.84',
	  distance: ''
	}, {
	  name: 'KOI-2672 b',
	  radius: '3.47',
	  distance: ''
	}, {
	  name: 'KOI-2672 c',
	  radius: '5.26',
	  distance: ''
	}, {
	  name: 'KOI-274 b',
	  radius: '1.13',
	  distance: ''
	}, {
	  name: 'KOI-274 c',
	  radius: '1.13',
	  distance: ''
	}, {
	  name: 'KOI-282 b',
	  radius: '2.90',
	  distance: ''
	}, {
	  name: 'KOI-285 b',
	  radius: '3.52',
	  distance: ''
	}, {
	  name: 'KOI-285 c',
	  radius: '2.61',
	  distance: ''
	}, {
	  name: 'KOI-370 b',
	  radius: '2.65',
	  distance: ''
	}, {
	  name: 'KOI-370 c',
	  radius: '4.42',
	  distance: ''
	}, {
	  name: 'KOI-523 b',
	  radius: '2.90',
	  distance: ''
	}, {
	  name: 'KOI-523 c',
	  radius: '7.11',
	  distance: ''
	}, {
	  name: 'KOI-680 b',
	  radius: '7.28',
	  distance: ''
	}, {
	  name: 'KOI-730 b',
	  radius: '3.47',
	  distance: ''
	}, {
	  name: 'KOI-730 c',
	  radius: '2.58',
	  distance: ''
	}, {
	  name: 'KOI-730 d',
	  radius: '2.80',
	  distance: ''
	}, {
	  name: 'KOI-730 e',
	  radius: '2.02',
	  distance: ''
	}, {
	  name: 'KOI-82 b',
	  radius: '2.20',
	  distance: ''
	}, {
	  name: 'KOI-82 c',
	  radius: '1.34',
	  distance: ''
	}, {
	  name: 'KOI-82 d',
	  radius: '0.69',
	  distance: ''
	}, {
	  name: 'KOI-834 b',
	  radius: '5.61',
	  distance: ''
	}, {
	  name: 'KOI-834 c',
	  radius: '2.00',
	  distance: ''
	}, {
	  name: 'ksi Aql b',
	  radius: '13.46',
	  distance: '62.70'
	}, {
	  name: 'LKCA 15 b',
	  radius: '13.13',
	  distance: '145.00'
	}, {
	  name: 'MOA-2007-BLG-192-L b',
	  radius: '1.54',
	  distance: '700.00'
	}, {
	  name: 'MOA-2007-BLG-400-L b',
	  radius: '13.97',
	  distance: '6000.00'
	}, {
	  name: 'MOA-2008-BLG-310-L b',
	  radius: '10.07',
	  distance: '6000.00'
	}, {
	  name: 'MOA-2008-BLG-379L b',
	  radius: '13.17',
	  distance: '3600.00'
	}, {
	  name: 'MOA-2009-BLG-266L b',
	  radius: '3.38',
	  distance: '3040.00'
	}, {
	  name: 'MOA-2009-BLG-319 b',
	  radius: '8.14',
	  distance: '6100.00'
	}, {
	  name: 'MOA-2009-BLG-387L b',
	  radius: '13.50',
	  distance: '5700.00'
	}, {
	  name: 'MOA-2010-BLG-328L b',
	  radius: '3.42',
	  distance: '810.00'
	}, {
	  name: 'MOA-2010-BLG-477L b',
	  radius: '13.74',
	  distance: '2300.00'
	}, {
	  name: 'MOA-2011-BLG-293L b',
	  radius: '13.23',
	  distance: '7700.00'
	}, {
	  name: 'MOA-2011-BLG-322 b',
	  radius: '12.96',
	  distance: '7740.00'
	}, {
	  name: 'MOA-bin-1 b',
	  radius: '13.34',
	  distance: '5100.00'
	}, {
	  name: 'mu Ara b',
	  radius: '13.69',
	  distance: '15.30'
	}, {
	  name: 'mu Ara c',
	  radius: '3.41',
	  distance: '15.30'
	}, {
	  name: 'mu Ara d',
	  radius: '14.23',
	  distance: '15.30'
	}, {
	  name: 'mu Ara e',
	  radius: '13.66',
	  distance: '15.30'
	}, {
	  name: 'NGC 2423 3 b',
	  radius: '12.89',
	  distance: '766.00'
	}, {
	  name: 'NGC 4349 No 127 b',
	  radius: '12.63',
	  distance: '2176.00'
	}, {
	  name: 'NN Ser(AB) c',
	  radius: '13.07',
	  distance: '500.00'
	}, {
	  name: 'NN Ser(AB) d',
	  radius: '13.55',
	  distance: '500.00'
	}, {
	  name: 'nu Oph b',
	  radius: '12.55',
	  distance: '46.80'
	}, {
	  name: 'nu Oph c',
	  radius: '12.50',
	  distance: '46.80'
	}, {
	  name: 'NY Vir b',
	  radius: '13.49',
	  distance: ''
	}, {
	  name: 'OGLE-05-071L b',
	  radius: '13.37',
	  distance: '3300.00'
	}, {
	  name: 'OGLE-05-169L b',
	  radius: '3.78',
	  distance: '2700.00'
	}, {
	  name: 'OGLE-05-390L b',
	  radius: '1.94',
	  distance: '6500.00'
	}, {
	  name: 'OGLE-06-109L b',
	  radius: '14.07',
	  distance: '1510.00'
	}, {
	  name: 'OGLE-06-109L c',
	  radius: '11.04',
	  distance: '1510.00'
	}, {
	  name: 'OGLE-2007-BLG-368L b',
	  radius: '5.15',
	  distance: '5900.00'
	}, {
	  name: 'OGLE-2009-BLG-151_MOA-2009-232 b',
	  radius: '12.97',
	  distance: '390.00'
	}, {
	  name: 'OGLE-2011-BLG-0251 b',
	  radius: '13.88',
	  distance: '4090.00'
	}, {
	  name: 'OGLE-2011-BLG-0420 b',
	  radius: '12.88',
	  distance: '1990.00'
	}, {
	  name: 'OGLE-2012-BLG-0026L b',
	  radius: '7.22',
	  distance: '4080.00'
	}, {
	  name: 'OGLE-2012-BLG-0026L c',
	  radius: '14.04',
	  distance: '4080.00'
	}, {
	  name: 'OGLE-2012-BLG-0358L b',
	  radius: '13.58',
	  distance: '1760.00'
	}, {
	  name: 'OGLE-2012-BLG-0406L b',
	  radius: '13.41',
	  distance: '4970.00'
	}, {
	  name: 'OGLE-TR-10 b',
	  radius: '19.26',
	  distance: '1500.00'
	}, {
	  name: 'OGLE-TR-111 b',
	  radius: '12.06',
	  distance: '1500.00'
	}, {
	  name: 'OGLE-TR-113 b',
	  radius: '12.43',
	  distance: '1500.00'
	}, {
	  name: 'OGLE-TR-132 b',
	  radius: '13.78',
	  distance: '1500.00'
	}, {
	  name: 'OGLE-TR-182 b',
	  radius: '16.46',
	  distance: ''
	}, {
	  name: 'OGLE-TR-211 b',
	  radius: '14.11',
	  distance: ''
	}, {
	  name: 'OGLE-TR-56 b',
	  radius: '13.44',
	  distance: '1500.00'
	}, {
	  name: 'OGLE2-TR-L9 b',
	  radius: '18.08',
	  distance: '900.00'
	}, {
	  name: 'OGLE235-MOA53 b',
	  radius: '13.50',
	  distance: '5200.00'
	}, {
	  name: 'ome Ser b',
	  radius: '13.62',
	  distance: '80.60'
	}, {
	  name: 'omi CrB b',
	  radius: '13.68',
	  distance: '84.00'
	}, {
	  name: 'omi UMa b',
	  radius: '13.23',
	  distance: '56.30'
	}, {
	  name: 'Oph 11 b',
	  radius: '12.60',
	  distance: '145.00'
	}, {
	  name: 'PH1-Kepler-64 b',
	  radius: '6.19',
	  distance: ''
	}, {
	  name: 'POTS-1 b',
	  radius: '10.54',
	  distance: ''
	}, {
	  name: 'Pr0201 c',
	  radius: '14.14',
	  distance: ''
	}, {
	  name: 'Pr0211 b',
	  radius: '13.59',
	  distance: ''
	}, {
	  name: 'PSR 1257 12 b',
	  radius: '0.30',
	  distance: '710.00'
	}, {
	  name: 'PSR 1257 12 c',
	  radius: '1.72',
	  distance: '710.00'
	}, {
	  name: 'PSR 1257 12 d',
	  radius: '1.66',
	  distance: '710.00'
	}, {
	  name: 'PSR 1719-14 b',
	  radius: '4.48',
	  distance: '1200.00'
	}, {
	  name: 'PSR B1620-26 b',
	  radius: '13.51',
	  distance: '3800.00'
	}, {
	  name: 'Qatar-1 b',
	  radius: '13.04',
	  distance: ''
	}, {
	  name: 'Qatar-2 b',
	  radius: '12.81',
	  distance: ''
	}, {
	  name: 'Ross 458(AB) c',
	  radius: '12.98',
	  distance: '114.00'
	}, {
	  name: 'ROXs 42B b',
	  radius: '12.83',
	  distance: '135.00'
	}, {
	  name: 'RR Cae b',
	  radius: '13.22',
	  distance: ''
	}, {
	  name: 'SR 12 AB c',
	  radius: '12.80',
	  distance: '125.00'
	}, {
	  name: 'SWEEPS-04b',
	  radius: '9.07',
	  distance: '8500.00'
	}, {
	  name: 'SWEEPS-11b',
	  radius: '12.66',
	  distance: '8500.00'
	}, {
	  name: 'tau Boo b',
	  radius: '13.14',
	  distance: '15.60'
	}, {
	  name: 'tau Gem b',
	  radius: '12.55',
	  distance: '98.40'
	}, {
	  name: 'TrES-1b',
	  radius: '12.31',
	  distance: '157.00'
	}, {
	  name: 'TrES-2b',
	  radius: '13.09',
	  distance: '220.00'
	}, {
	  name: 'TrES-3b',
	  radius: '14.62',
	  distance: ''
	}, {
	  name: 'TrES-4b',
	  radius: '19.11',
	  distance: '479.00'
	}, {
	  name: 'TrES-5b',
	  radius: '13.54',
	  distance: '360.00'
	}, {
	  name: 'ups And b',
	  radius: '14.15',
	  distance: '13.47'
	}, {
	  name: 'ups And c',
	  radius: '13.66',
	  distance: '13.47'
	}, {
	  name: 'ups And d',
	  radius: '12.91',
	  distance: '13.47'
	}, {
	  name: 'ups And e',
	  radius: '13.90',
	  distance: '13.47'
	}, {
	  name: 'USco1602-2401 b',
	  radius: '12.22',
	  distance: ''
	}, {
	  name: 'USco1610-1913 b',
	  radius: '12.56',
	  distance: ''
	}, {
	  name: 'USco1612-1800 b',
	  radius: '12.46',
	  distance: ''
	}, {
	  name: 'UScoCTIO 108 b',
	  radius: '12.72',
	  distance: '145.00'
	}, {
	  name: 'UZ For(ab) d',
	  radius: '12.96',
	  distance: ''
	}, {
	  name: 'V391 Peg b',
	  radius: '13.41',
	  distance: '1400.00'
	}, {
	  name: 'WASP-1 b',
	  radius: '16.62',
	  distance: ''
	}, {
	  name: 'WASP-10 b',
	  radius: '12.10',
	  distance: '90.00'
	}, {
	  name: 'WASP-100 b',
	  radius: '18.93',
	  distance: ''
	}, {
	  name: 'WASP-101 b',
	  radius: '15.79',
	  distance: ''
	}, {
	  name: 'WASP-11-HAT-P-10 b',
	  radius: '11.70',
	  distance: '125.00'
	}, {
	  name: 'WASP-12 b',
	  radius: '19.44',
	  distance: '427.00'
	}, {
	  name: 'WASP-13 b',
	  radius: '15.29',
	  distance: '156.00'
	}, {
	  name: 'WASP-14 b',
	  radius: '14.35',
	  distance: '160.00'
	}, {
	  name: 'WASP-15 b',
	  radius: '15.99',
	  distance: '308.00'
	}, {
	  name: 'WASP-16 b',
	  radius: '11.29',
	  distance: ''
	}, {
	  name: 'WASP-17 b',
	  radius: '22.30',
	  distance: ''
	}, {
	  name: 'WASP-18 b',
	  radius: '13.05',
	  distance: '100.00'
	}, {
	  name: 'WASP-19 b',
	  radius: '15.62',
	  distance: ''
	}, {
	  name: 'WASP-2 b',
	  radius: '12.08',
	  distance: '144.00'
	}, {
	  name: 'WASP-20 b',
	  radius: '10.08',
	  distance: ''
	}, {
	  name: 'WASP-21 b',
	  radius: '13.55',
	  distance: '230.00'
	}, {
	  name: 'WASP-22 b',
	  radius: '12.97',
	  distance: '300.00'
	}, {
	  name: 'WASP-23 b',
	  radius: '10.77',
	  distance: ''
	}, {
	  name: 'WASP-24 b',
	  radius: '12.36',
	  distance: '330.00'
	}, {
	  name: 'WASP-25 b',
	  radius: '14.11',
	  distance: '169.00'
	}, {
	  name: 'WASP-26 b',
	  radius: '14.35',
	  distance: '250.00'
	}, {
	  name: 'WASP-28 b',
	  radius: '12.54',
	  distance: '334.00'
	}, {
	  name: 'WASP-29 b',
	  radius: '9.42',
	  distance: '80.00'
	}, {
	  name: 'WASP-3 b',
	  radius: '16.28',
	  distance: '223.00'
	}, {
	  name: 'WASP-31 b',
	  radius: '17.21',
	  distance: '400.00'
	}, {
	  name: 'WASP-32 b',
	  radius: '13.22',
	  distance: ''
	}, {
	  name: 'WASP-33 b',
	  radius: '16.11',
	  distance: '116.00'
	}, {
	  name: 'WASP-34 b',
	  radius: '13.66',
	  distance: '120.00'
	}, {
	  name: 'WASP-35 b',
	  radius: '14.78',
	  distance: ''
	}, {
	  name: 'WASP-36 b',
	  radius: '14.21',
	  distance: '450.00'
	}, {
	  name: 'WASP-37 b',
	  radius: '12.72',
	  distance: '338.00'
	}, {
	  name: 'WASP-38 b',
	  radius: '12.08',
	  distance: '110.00'
	}, {
	  name: 'WASP-39 b',
	  radius: '14.22',
	  distance: '230.00'
	}, {
	  name: 'WASP-4 b',
	  radius: '15.62',
	  distance: '300.00'
	}, {
	  name: 'WASP-41 b',
	  radius: '13.55',
	  distance: '180.00'
	}, {
	  name: 'WASP-42 b',
	  radius: '12.10',
	  distance: ''
	}, {
	  name: 'WASP-43 b',
	  radius: '11.60',
	  distance: ''
	}, {
	  name: 'WASP-44 b',
	  radius: '12.77',
	  distance: ''
	}, {
	  name: 'WASP-45 b',
	  radius: '12.99',
	  distance: ''
	}, {
	  name: 'WASP-46 b',
	  radius: '14.67',
	  distance: ''
	}, {
	  name: 'WASP-47 b',
	  radius: '12.88',
	  distance: '200.00'
	}, {
	  name: 'WASP-48 b',
	  radius: '18.70',
	  distance: ''
	}, {
	  name: 'WASP-49 b',
	  radius: '12.49',
	  distance: ''
	}, {
	  name: 'WASP-5 b',
	  radius: '13.12',
	  distance: '297.00'
	}, {
	  name: 'WASP-50 b',
	  radius: '12.75',
	  distance: '230.00'
	}, {
	  name: 'WASP-52 b',
	  radius: '14.22',
	  distance: '140.00'
	}, {
	  name: 'WASP-53 b',
	  radius: '13.44',
	  distance: ''
	}, {
	  name: 'WASP-54 b',
	  radius: '15.68',
	  distance: ''
	}, {
	  name: 'WASP-55 b',
	  radius: '14.56',
	  distance: '330.00'
	}, {
	  name: 'WASP-56 b',
	  radius: '13.44',
	  distance: ''
	}, {
	  name: 'WASP-57 b',
	  radius: '12.32',
	  distance: ''
	}, {
	  name: 'WASP-58 b',
	  radius: '15.34',
	  distance: '300.00'
	}, {
	  name: 'WASP-59 b',
	  radius: '10.08',
	  distance: '125.00'
	}, {
	  name: 'WASP-6 b',
	  radius: '13.71',
	  distance: '307.00'
	}, {
	  name: 'WASP-60 b',
	  radius: '10.08',
	  distance: '400.00'
	}, {
	  name: 'WASP-61 b',
	  radius: '13.89',
	  distance: '480.00'
	}, {
	  name: 'WASP-62 b',
	  radius: '15.57',
	  distance: '160.00'
	}, {
	  name: 'WASP-63 b',
	  radius: '16.02',
	  distance: '330.00'
	}, {
	  name: 'WASP-64 b',
	  radius: '7.84',
	  distance: ''
	}, {
	  name: 'WASP-65 b',
	  radius: '12.45',
	  distance: '310.00'
	}, {
	  name: 'WASP-66 b',
	  radius: '15.57',
	  distance: '380.00'
	}, {
	  name: 'WASP-67 b',
	  radius: '15.68',
	  distance: '225.00'
	}, {
	  name: 'WASP-68 b',
	  radius: '10.08',
	  distance: ''
	}, {
	  name: 'WASP-69 b',
	  radius: '11.20',
	  distance: ''
	}, {
	  name: 'WASP-7 b',
	  radius: '14.90',
	  distance: '140.00'
	}, {
	  name: 'WASP-70 b',
	  radius: '8.96',
	  distance: ''
	}, {
	  name: 'WASP-71 b',
	  radius: '16.80',
	  distance: '200.00'
	}, {
	  name: 'WASP-72 b',
	  radius: '14.22',
	  distance: ''
	}, {
	  name: 'WASP-75 b',
	  radius: '14.22',
	  distance: '260.00'
	}, {
	  name: 'WASP-76 b',
	  radius: '20.50',
	  distance: '120.00'
	}, {
	  name: 'WASP-77A b',
	  radius: '13.55',
	  distance: ''
	}, {
	  name: 'WASP-78 b',
	  radius: '19.60',
	  distance: '550.00'
	}, {
	  name: 'WASP-79 b',
	  radius: '19.04',
	  distance: '240.00'
	}, {
	  name: 'WASP-8 b',
	  radius: '11.63',
	  distance: '87.00'
	}, {
	  name: 'WASP-80 b',
	  radius: '10.66',
	  distance: '60.00'
	}, {
	  name: 'WASP-82 b',
	  radius: '18.70',
	  distance: '200.00'
	}, {
	  name: 'WASP-84 b',
	  radius: '10.55',
	  distance: '120.00'
	}, {
	  name: 'WASP-90 b',
	  radius: '18.26',
	  distance: '340.00'
	}, {
	  name: 'WASP-95 b',
	  radius: '13.55',
	  distance: ''
	}, {
	  name: 'WASP-96 b',
	  radius: '13.44',
	  distance: ''
	}, {
	  name: 'WASP-97 b',
	  radius: '12.66',
	  distance: ''
	}, {
	  name: 'WASP-98 b',
	  radius: '12.32',
	  distance: ''
	}, {
	  name: 'WASP-99 b',
	  radius: '12.32',
	  distance: ''
	}, {
	  name: 'WD 0806-661B b',
	  radius: '13.01',
	  distance: '19.20'
	}, {
	  name: 'WISE 1217+16A b',
	  radius: '11.20',
	  distance: '10.00'
	}, {
	  name: 'WISE 1711+3500 b',
	  radius: '12.74',
	  distance: '19.00'
	}, {
	  name: 'WTS-1 b',
	  radius: '16.69',
	  distance: '3200.00'
	}, {
	  name: 'WTS-2 b',
	  radius: '14.56',
	  distance: '1000.00'
	}, {
	  name: 'XO-1 b',
	  radius: '13.26',
	  distance: '200.00'
	}, {
	  name: 'XO-2 b',
	  radius: '10.90',
	  distance: '149.00'
	}, {
	  name: 'XO-3 b',
	  radius: '13.63',
	  distance: '260.00'
	}, {
	  name: 'XO-4 b',
	  radius: '15.01',
	  distance: '293.00'
	}, {
	  name: 'XO-5 b',
	  radius: '11.54',
	  distance: '255.00'
	}];

/***/ },
/* 663 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{ key: 'Group1', value: '37', date: '04/23/12' }, { key: 'Group2', value: '12', date: '04/23/12' }, { key: 'Group3', value: '46', date: '04/23/12' }, { key: 'Group1', value: '32', date: '04/24/12' }, { key: 'Group2', value: '19', date: '04/24/12' }, { key: 'Group3', value: '42', date: '04/24/12' }, { key: 'Group1', value: '45', date: '04/25/12' }, { key: 'Group2', value: '16', date: '04/25/12' }, { key: 'Group3', value: '44', date: '04/25/12' }, { key: 'Group1', value: '24', date: '04/26/12' }, { key: 'Group2', value: '52', date: '04/26/12' }, { key: 'Group3', value: '64', date: '04/26/12' }];

/***/ },
/* 664 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "nodes": [{ "id": "Myriel", "group": 1 }, { "id": "Napoleon", "group": 1 }, { "id": "Mlle.Baptistine", "group": 1 }, { "id": "Mme.Magloire", "group": 1 }, { "id": "CountessdeLo", "group": 1 }, { "id": "Geborand", "group": 1 }, { "id": "Champtercier", "group": 1 }, { "id": "Cravatte", "group": 1 }, { "id": "Count", "group": 1 }, { "id": "OldMan", "group": 1 }, { "id": "Labarre", "group": 2 }, { "id": "Valjean", "group": 2 }, { "id": "Marguerite", "group": 3 }, { "id": "Mme.deR", "group": 2 }, { "id": "Isabeau", "group": 2 }, { "id": "Gervais", "group": 2 }, { "id": "Tholomyes", "group": 3 }, { "id": "Listolier", "group": 3 }, { "id": "Fameuil", "group": 3 }, { "id": "Blacheville", "group": 3 }, { "id": "Favourite", "group": 3 }, { "id": "Dahlia", "group": 3 }, { "id": "Zephine", "group": 3 }, { "id": "Fantine", "group": 3 }, { "id": "Mme.Thenardier", "group": 4 }, { "id": "Thenardier", "group": 4 }, { "id": "Cosette", "group": 5 }, { "id": "Javert", "group": 4 }, { "id": "Fauchelevent", "group": 0 }, { "id": "Bamatabois", "group": 2 }, { "id": "Perpetue", "group": 3 }, { "id": "Simplice", "group": 2 }, { "id": "Scaufflaire", "group": 2 }, { "id": "Woman1", "group": 2 }, { "id": "Judge", "group": 2 }, { "id": "Champmathieu", "group": 2 }, { "id": "Brevet", "group": 2 }, { "id": "Chenildieu", "group": 2 }, { "id": "Cochepaille", "group": 2 }, { "id": "Pontmercy", "group": 4 }, { "id": "Boulatruelle", "group": 6 }, { "id": "Eponine", "group": 4 }, { "id": "Anzelma", "group": 4 }, { "id": "Woman2", "group": 5 }, { "id": "MotherInnocent", "group": 0 }, { "id": "Gribier", "group": 0 }, { "id": "Jondrette", "group": 7 }, { "id": "Mme.Burgon", "group": 7 }, { "id": "Gavroche", "group": 8 }, { "id": "Gillenormand", "group": 5 }, { "id": "Magnon", "group": 5 }, { "id": "Mlle.Gillenormand", "group": 5 }, { "id": "Mme.Pontmercy", "group": 5 }, { "id": "Mlle.Vaubois", "group": 5 }, { "id": "Lt.Gillenormand", "group": 5 }, { "id": "Marius", "group": 8 }, { "id": "BaronessT", "group": 5 }, { "id": "Mabeuf", "group": 8 }, { "id": "Enjolras", "group": 8 }, { "id": "Combeferre", "group": 8 }, { "id": "Prouvaire", "group": 8 }, { "id": "Feuilly", "group": 8 }, { "id": "Courfeyrac", "group": 8 }, { "id": "Bahorel", "group": 8 }, { "id": "Bossuet", "group": 8 }, { "id": "Joly", "group": 8 }, { "id": "Grantaire", "group": 8 }, { "id": "MotherPlutarch", "group": 9 }, { "id": "Gueulemer", "group": 4 }, { "id": "Babet", "group": 4 }, { "id": "Claquesous", "group": 4 }, { "id": "Montparnasse", "group": 4 }, { "id": "Toussaint", "group": 5 }, { "id": "Child1", "group": 10 }, { "id": "Child2", "group": 10 }, { "id": "Brujon", "group": 4 }, { "id": "Mme.Hucheloup", "group": 8 }],
	  "links": [{ "source": "Napoleon", "target": "Myriel", "value": 1 }, { "source": "Mlle.Baptistine", "target": "Myriel", "value": 8 }, { "source": "Mme.Magloire", "target": "Myriel", "value": 10 }, { "source": "Mme.Magloire", "target": "Mlle.Baptistine", "value": 6 }, { "source": "CountessdeLo", "target": "Myriel", "value": 1 }, { "source": "Geborand", "target": "Myriel", "value": 1 }, { "source": "Champtercier", "target": "Myriel", "value": 1 }, { "source": "Cravatte", "target": "Myriel", "value": 1 }, { "source": "Count", "target": "Myriel", "value": 2 }, { "source": "OldMan", "target": "Myriel", "value": 1 }, { "source": "Valjean", "target": "Labarre", "value": 1 }, { "source": "Valjean", "target": "Mme.Magloire", "value": 3 }, { "source": "Valjean", "target": "Mlle.Baptistine", "value": 3 }, { "source": "Valjean", "target": "Myriel", "value": 5 }, { "source": "Marguerite", "target": "Valjean", "value": 1 }, { "source": "Mme.deR", "target": "Valjean", "value": 1 }, { "source": "Isabeau", "target": "Valjean", "value": 1 }, { "source": "Gervais", "target": "Valjean", "value": 1 }, { "source": "Listolier", "target": "Tholomyes", "value": 4 }, { "source": "Fameuil", "target": "Tholomyes", "value": 4 }, { "source": "Fameuil", "target": "Listolier", "value": 4 }, { "source": "Blacheville", "target": "Tholomyes", "value": 4 }, { "source": "Blacheville", "target": "Listolier", "value": 4 }, { "source": "Blacheville", "target": "Fameuil", "value": 4 }, { "source": "Favourite", "target": "Tholomyes", "value": 3 }, { "source": "Favourite", "target": "Listolier", "value": 3 }, { "source": "Favourite", "target": "Fameuil", "value": 3 }, { "source": "Favourite", "target": "Blacheville", "value": 4 }, { "source": "Dahlia", "target": "Tholomyes", "value": 3 }, { "source": "Dahlia", "target": "Listolier", "value": 3 }, { "source": "Dahlia", "target": "Fameuil", "value": 3 }, { "source": "Dahlia", "target": "Blacheville", "value": 3 }, { "source": "Dahlia", "target": "Favourite", "value": 5 }, { "source": "Zephine", "target": "Tholomyes", "value": 3 }, { "source": "Zephine", "target": "Listolier", "value": 3 }, { "source": "Zephine", "target": "Fameuil", "value": 3 }, { "source": "Zephine", "target": "Blacheville", "value": 3 }, { "source": "Zephine", "target": "Favourite", "value": 4 }, { "source": "Zephine", "target": "Dahlia", "value": 4 }, { "source": "Fantine", "target": "Tholomyes", "value": 3 }, { "source": "Fantine", "target": "Listolier", "value": 3 }, { "source": "Fantine", "target": "Fameuil", "value": 3 }, { "source": "Fantine", "target": "Blacheville", "value": 3 }, { "source": "Fantine", "target": "Favourite", "value": 4 }, { "source": "Fantine", "target": "Dahlia", "value": 4 }, { "source": "Fantine", "target": "Zephine", "value": 4 }, { "source": "Fantine", "target": "Marguerite", "value": 2 }, { "source": "Fantine", "target": "Valjean", "value": 9 }, { "source": "Mme.Thenardier", "target": "Fantine", "value": 2 }, { "source": "Mme.Thenardier", "target": "Valjean", "value": 7 }, { "source": "Thenardier", "target": "Mme.Thenardier", "value": 13 }, { "source": "Thenardier", "target": "Fantine", "value": 1 }, { "source": "Thenardier", "target": "Valjean", "value": 12 }, { "source": "Cosette", "target": "Mme.Thenardier", "value": 4 }, { "source": "Cosette", "target": "Valjean", "value": 31 }, { "source": "Cosette", "target": "Tholomyes", "value": 1 }, { "source": "Cosette", "target": "Thenardier", "value": 1 }, { "source": "Javert", "target": "Valjean", "value": 17 }, { "source": "Javert", "target": "Fantine", "value": 5 }, { "source": "Javert", "target": "Thenardier", "value": 5 }, { "source": "Javert", "target": "Mme.Thenardier", "value": 1 }, { "source": "Javert", "target": "Cosette", "value": 1 }, { "source": "Fauchelevent", "target": "Valjean", "value": 8 }, { "source": "Fauchelevent", "target": "Javert", "value": 1 }, { "source": "Bamatabois", "target": "Fantine", "value": 1 }, { "source": "Bamatabois", "target": "Javert", "value": 1 }, { "source": "Bamatabois", "target": "Valjean", "value": 2 }, { "source": "Perpetue", "target": "Fantine", "value": 1 }, { "source": "Simplice", "target": "Perpetue", "value": 2 }, { "source": "Simplice", "target": "Valjean", "value": 3 }, { "source": "Simplice", "target": "Fantine", "value": 2 }, { "source": "Simplice", "target": "Javert", "value": 1 }, { "source": "Scaufflaire", "target": "Valjean", "value": 1 }, { "source": "Woman1", "target": "Valjean", "value": 2 }, { "source": "Woman1", "target": "Javert", "value": 1 }, { "source": "Judge", "target": "Valjean", "value": 3 }, { "source": "Judge", "target": "Bamatabois", "value": 2 }, { "source": "Champmathieu", "target": "Valjean", "value": 3 }, { "source": "Champmathieu", "target": "Judge", "value": 3 }, { "source": "Champmathieu", "target": "Bamatabois", "value": 2 }, { "source": "Brevet", "target": "Judge", "value": 2 }, { "source": "Brevet", "target": "Champmathieu", "value": 2 }, { "source": "Brevet", "target": "Valjean", "value": 2 }, { "source": "Brevet", "target": "Bamatabois", "value": 1 }, { "source": "Chenildieu", "target": "Judge", "value": 2 }, { "source": "Chenildieu", "target": "Champmathieu", "value": 2 }, { "source": "Chenildieu", "target": "Brevet", "value": 2 }, { "source": "Chenildieu", "target": "Valjean", "value": 2 }, { "source": "Chenildieu", "target": "Bamatabois", "value": 1 }, { "source": "Cochepaille", "target": "Judge", "value": 2 }, { "source": "Cochepaille", "target": "Champmathieu", "value": 2 }, { "source": "Cochepaille", "target": "Brevet", "value": 2 }, { "source": "Cochepaille", "target": "Chenildieu", "value": 2 }, { "source": "Cochepaille", "target": "Valjean", "value": 2 }, { "source": "Cochepaille", "target": "Bamatabois", "value": 1 }, { "source": "Pontmercy", "target": "Thenardier", "value": 1 }, { "source": "Boulatruelle", "target": "Thenardier", "value": 1 }, { "source": "Eponine", "target": "Mme.Thenardier", "value": 2 }, { "source": "Eponine", "target": "Thenardier", "value": 3 }, { "source": "Anzelma", "target": "Eponine", "value": 2 }, { "source": "Anzelma", "target": "Thenardier", "value": 2 }, { "source": "Anzelma", "target": "Mme.Thenardier", "value": 1 }, { "source": "Woman2", "target": "Valjean", "value": 3 }, { "source": "Woman2", "target": "Cosette", "value": 1 }, { "source": "Woman2", "target": "Javert", "value": 1 }, { "source": "MotherInnocent", "target": "Fauchelevent", "value": 3 }, { "source": "MotherInnocent", "target": "Valjean", "value": 1 }, { "source": "Gribier", "target": "Fauchelevent", "value": 2 }, { "source": "Mme.Burgon", "target": "Jondrette", "value": 1 }, { "source": "Gavroche", "target": "Mme.Burgon", "value": 2 }, { "source": "Gavroche", "target": "Thenardier", "value": 1 }, { "source": "Gavroche", "target": "Javert", "value": 1 }, { "source": "Gavroche", "target": "Valjean", "value": 1 }, { "source": "Gillenormand", "target": "Cosette", "value": 3 }, { "source": "Gillenormand", "target": "Valjean", "value": 2 }, { "source": "Magnon", "target": "Gillenormand", "value": 1 }, { "source": "Magnon", "target": "Mme.Thenardier", "value": 1 }, { "source": "Mlle.Gillenormand", "target": "Gillenormand", "value": 9 }, { "source": "Mlle.Gillenormand", "target": "Cosette", "value": 2 }, { "source": "Mlle.Gillenormand", "target": "Valjean", "value": 2 }, { "source": "Mme.Pontmercy", "target": "Mlle.Gillenormand", "value": 1 }, { "source": "Mme.Pontmercy", "target": "Pontmercy", "value": 1 }, { "source": "Mlle.Vaubois", "target": "Mlle.Gillenormand", "value": 1 }, { "source": "Lt.Gillenormand", "target": "Mlle.Gillenormand", "value": 2 }, { "source": "Lt.Gillenormand", "target": "Gillenormand", "value": 1 }, { "source": "Lt.Gillenormand", "target": "Cosette", "value": 1 }, { "source": "Marius", "target": "Mlle.Gillenormand", "value": 6 }, { "source": "Marius", "target": "Gillenormand", "value": 12 }, { "source": "Marius", "target": "Pontmercy", "value": 1 }, { "source": "Marius", "target": "Lt.Gillenormand", "value": 1 }, { "source": "Marius", "target": "Cosette", "value": 21 }, { "source": "Marius", "target": "Valjean", "value": 19 }, { "source": "Marius", "target": "Tholomyes", "value": 1 }, { "source": "Marius", "target": "Thenardier", "value": 2 }, { "source": "Marius", "target": "Eponine", "value": 5 }, { "source": "Marius", "target": "Gavroche", "value": 4 }, { "source": "BaronessT", "target": "Gillenormand", "value": 1 }, { "source": "BaronessT", "target": "Marius", "value": 1 }, { "source": "Mabeuf", "target": "Marius", "value": 1 }, { "source": "Mabeuf", "target": "Eponine", "value": 1 }, { "source": "Mabeuf", "target": "Gavroche", "value": 1 }, { "source": "Enjolras", "target": "Marius", "value": 7 }, { "source": "Enjolras", "target": "Gavroche", "value": 7 }, { "source": "Enjolras", "target": "Javert", "value": 6 }, { "source": "Enjolras", "target": "Mabeuf", "value": 1 }, { "source": "Enjolras", "target": "Valjean", "value": 4 }, { "source": "Combeferre", "target": "Enjolras", "value": 15 }, { "source": "Combeferre", "target": "Marius", "value": 5 }, { "source": "Combeferre", "target": "Gavroche", "value": 6 }, { "source": "Combeferre", "target": "Mabeuf", "value": 2 }, { "source": "Prouvaire", "target": "Gavroche", "value": 1 }, { "source": "Prouvaire", "target": "Enjolras", "value": 4 }, { "source": "Prouvaire", "target": "Combeferre", "value": 2 }, { "source": "Feuilly", "target": "Gavroche", "value": 2 }, { "source": "Feuilly", "target": "Enjolras", "value": 6 }, { "source": "Feuilly", "target": "Prouvaire", "value": 2 }, { "source": "Feuilly", "target": "Combeferre", "value": 5 }, { "source": "Feuilly", "target": "Mabeuf", "value": 1 }, { "source": "Feuilly", "target": "Marius", "value": 1 }, { "source": "Courfeyrac", "target": "Marius", "value": 9 }, { "source": "Courfeyrac", "target": "Enjolras", "value": 17 }, { "source": "Courfeyrac", "target": "Combeferre", "value": 13 }, { "source": "Courfeyrac", "target": "Gavroche", "value": 7 }, { "source": "Courfeyrac", "target": "Mabeuf", "value": 2 }, { "source": "Courfeyrac", "target": "Eponine", "value": 1 }, { "source": "Courfeyrac", "target": "Feuilly", "value": 6 }, { "source": "Courfeyrac", "target": "Prouvaire", "value": 3 }, { "source": "Bahorel", "target": "Combeferre", "value": 5 }, { "source": "Bahorel", "target": "Gavroche", "value": 5 }, { "source": "Bahorel", "target": "Courfeyrac", "value": 6 }, { "source": "Bahorel", "target": "Mabeuf", "value": 2 }, { "source": "Bahorel", "target": "Enjolras", "value": 4 }, { "source": "Bahorel", "target": "Feuilly", "value": 3 }, { "source": "Bahorel", "target": "Prouvaire", "value": 2 }, { "source": "Bahorel", "target": "Marius", "value": 1 }, { "source": "Bossuet", "target": "Marius", "value": 5 }, { "source": "Bossuet", "target": "Courfeyrac", "value": 12 }, { "source": "Bossuet", "target": "Gavroche", "value": 5 }, { "source": "Bossuet", "target": "Bahorel", "value": 4 }, { "source": "Bossuet", "target": "Enjolras", "value": 10 }, { "source": "Bossuet", "target": "Feuilly", "value": 6 }, { "source": "Bossuet", "target": "Prouvaire", "value": 2 }, { "source": "Bossuet", "target": "Combeferre", "value": 9 }, { "source": "Bossuet", "target": "Mabeuf", "value": 1 }, { "source": "Bossuet", "target": "Valjean", "value": 1 }, { "source": "Joly", "target": "Bahorel", "value": 5 }, { "source": "Joly", "target": "Bossuet", "value": 7 }, { "source": "Joly", "target": "Gavroche", "value": 3 }, { "source": "Joly", "target": "Courfeyrac", "value": 5 }, { "source": "Joly", "target": "Enjolras", "value": 5 }, { "source": "Joly", "target": "Feuilly", "value": 5 }, { "source": "Joly", "target": "Prouvaire", "value": 2 }, { "source": "Joly", "target": "Combeferre", "value": 5 }, { "source": "Joly", "target": "Mabeuf", "value": 1 }, { "source": "Joly", "target": "Marius", "value": 2 }, { "source": "Grantaire", "target": "Bossuet", "value": 3 }, { "source": "Grantaire", "target": "Enjolras", "value": 3 }, { "source": "Grantaire", "target": "Combeferre", "value": 1 }, { "source": "Grantaire", "target": "Courfeyrac", "value": 2 }, { "source": "Grantaire", "target": "Joly", "value": 2 }, { "source": "Grantaire", "target": "Gavroche", "value": 1 }, { "source": "Grantaire", "target": "Bahorel", "value": 1 }, { "source": "Grantaire", "target": "Feuilly", "value": 1 }, { "source": "Grantaire", "target": "Prouvaire", "value": 1 }, { "source": "MotherPlutarch", "target": "Mabeuf", "value": 3 }, { "source": "Gueulemer", "target": "Thenardier", "value": 5 }, { "source": "Gueulemer", "target": "Valjean", "value": 1 }, { "source": "Gueulemer", "target": "Mme.Thenardier", "value": 1 }, { "source": "Gueulemer", "target": "Javert", "value": 1 }, { "source": "Gueulemer", "target": "Gavroche", "value": 1 }, { "source": "Gueulemer", "target": "Eponine", "value": 1 }, { "source": "Babet", "target": "Thenardier", "value": 6 }, { "source": "Babet", "target": "Gueulemer", "value": 6 }, { "source": "Babet", "target": "Valjean", "value": 1 }, { "source": "Babet", "target": "Mme.Thenardier", "value": 1 }, { "source": "Babet", "target": "Javert", "value": 2 }, { "source": "Babet", "target": "Gavroche", "value": 1 }, { "source": "Babet", "target": "Eponine", "value": 1 }, { "source": "Claquesous", "target": "Thenardier", "value": 4 }, { "source": "Claquesous", "target": "Babet", "value": 4 }, { "source": "Claquesous", "target": "Gueulemer", "value": 4 }, { "source": "Claquesous", "target": "Valjean", "value": 1 }, { "source": "Claquesous", "target": "Mme.Thenardier", "value": 1 }, { "source": "Claquesous", "target": "Javert", "value": 1 }, { "source": "Claquesous", "target": "Eponine", "value": 1 }, { "source": "Claquesous", "target": "Enjolras", "value": 1 }, { "source": "Montparnasse", "target": "Javert", "value": 1 }, { "source": "Montparnasse", "target": "Babet", "value": 2 }, { "source": "Montparnasse", "target": "Gueulemer", "value": 2 }, { "source": "Montparnasse", "target": "Claquesous", "value": 2 }, { "source": "Montparnasse", "target": "Valjean", "value": 1 }, { "source": "Montparnasse", "target": "Gavroche", "value": 1 }, { "source": "Montparnasse", "target": "Eponine", "value": 1 }, { "source": "Montparnasse", "target": "Thenardier", "value": 1 }, { "source": "Toussaint", "target": "Cosette", "value": 2 }, { "source": "Toussaint", "target": "Javert", "value": 1 }, { "source": "Toussaint", "target": "Valjean", "value": 1 }, { "source": "Child1", "target": "Gavroche", "value": 2 }, { "source": "Child2", "target": "Gavroche", "value": 2 }, { "source": "Child2", "target": "Child1", "value": 3 }, { "source": "Brujon", "target": "Babet", "value": 3 }, { "source": "Brujon", "target": "Gueulemer", "value": 3 }, { "source": "Brujon", "target": "Thenardier", "value": 3 }, { "source": "Brujon", "target": "Gavroche", "value": 1 }, { "source": "Brujon", "target": "Eponine", "value": 1 }, { "source": "Brujon", "target": "Claquesous", "value": 1 }, { "source": "Brujon", "target": "Montparnasse", "value": 1 }, { "source": "Mme.Hucheloup", "target": "Bossuet", "value": 1 }, { "source": "Mme.Hucheloup", "target": "Joly", "value": 1 }, { "source": "Mme.Hucheloup", "target": "Grantaire", "value": 1 }, { "source": "Mme.Hucheloup", "target": "Bahorel", "value": 1 }, { "source": "Mme.Hucheloup", "target": "Courfeyrac", "value": 1 }, { "source": "Mme.Hucheloup", "target": "Gavroche", "value": 1 }, { "source": "Mme.Hucheloup", "target": "Enjolras", "value": 1 }]
	};

/***/ },
/* 665 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{ letter: 'A', frequency: 0.08167 }, { letter: 'B', frequency: 0.01492 }, { letter: 'C', frequency: 0.02782 }, { letter: 'D', frequency: 0.04253 }, { letter: 'E', frequency: 0.12702 }, { letter: 'F', frequency: 0.02288 }, { letter: 'G', frequency: 0.02015 }, { letter: 'H', frequency: 0.06094 }, { letter: 'I', frequency: 0.06966 }, { letter: 'J', frequency: 0.00153 }, { letter: 'K', frequency: 0.00772 }, { letter: 'L', frequency: 0.04025 }, { letter: 'M', frequency: 0.02406 }, { letter: 'N', frequency: 0.06749 }, { letter: 'O', frequency: 0.07507 }, { letter: 'P', frequency: 0.01929 }, { letter: 'Q', frequency: 0.00095 }, { letter: 'R', frequency: 0.05987 }, { letter: 'S', frequency: 0.06327 }, { letter: 'T', frequency: 0.09056 }, { letter: 'U', frequency: 0.02758 }, { letter: 'V', frequency: 0.00978 }, { letter: 'W', frequency: 0.0236 }, { letter: 'X', frequency: 0.0015 }, { letter: 'Y', frequency: 0.01974 }, { letter: 'Z', frequency: 0.00074 }];

/***/ },
/* 666 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  name: 'Jupiter',
	  radius: '10.97',
	  distance: '0'
	}, {
	  name: 'Saturn',
	  radius: '9.14',
	  distance: '0'
	}, {
	  name: 'Uranus',
	  radius: '3.98',
	  distance: '0'
	}, {
	  name: 'Neptune',
	  radius: '3.86',
	  distance: '0'
	}, {
	  name: 'Earth',
	  radius: '1',
	  distance: '0'
	}, {
	  name: 'Venus',
	  radius: '0.950',
	  distance: '0'
	}, {
	  name: 'Mars',
	  radius: '0.532',
	  distance: '0'
	}, {
	  name: 'Mercury',
	  radius: '0.383',
	  distance: '0'
	}, {
	  name: 'Pluto',
	  radius: '0.181',
	  distance: '0'
	}];

/***/ },
/* 667 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  id: 'Shakespeare',
	  parent: null,
	  size: 0
	}, {
	  id: 'Comedies',
	  parent: 'Shakespeare',
	  size: null
	}, {
	  id: 'Tragedies',
	  parent: 'Shakespeare',
	  size: null
	}, {
	  id: 'Histories',
	  parent: 'Shakespeare',
	  size: null
	}, {
	  id: 'As You Like It',
	  parent: 'Comedies',
	  size: null
	}, {
	  id: 'Adam',
	  parent: 'As You Like It',
	  size: 10
	}, {
	  id: 'Amiens',
	  parent: 'As You Like It',
	  size: 10
	}, {
	  id: 'Audrey',
	  parent: 'As You Like It',
	  size: 12
	}, {
	  id: 'Celia',
	  parent: 'As You Like It',
	  size: 108
	}, {
	  id: 'Charles',
	  parent: 'As You Like It',
	  size: 8
	}, {
	  id: 'Corin',
	  parent: 'As You Like It',
	  size: 24
	}, {
	  id: 'Dennis',
	  parent: 'As You Like It',
	  size: 2
	}, {
	  id: 'Duke',
	  parent: 'As You Like It',
	  size: 32
	}, {
	  id: 'Frederick',
	  parent: 'As You Like It',
	  size: 20
	}, {
	  id: 'Hymen',
	  parent: 'As You Like It',
	  size: 1
	}, {
	  id: 'Jaques (lord)',
	  parent: 'As You Like It',
	  size: 57
	}, {
	  id: 'Jaques (son)',
	  parent: 'As You Like It',
	  size: 2
	}, {
	  id: 'Le Beau',
	  parent: 'As You Like It',
	  size: 14
	}, {
	  id: 'Oliver',
	  parent: 'As You Like It',
	  size: 37
	}, {
	  id: 'Orlando',
	  parent: 'As You Like It',
	  size: 120
	}, {
	  id: 'Phebe',
	  parent: 'As You Like It',
	  size: 23
	}, {
	  id: 'Rosalind',
	  parent: 'As You Like It',
	  size: 201
	}, {
	  id: 'Silvius',
	  parent: 'As You Like It',
	  size: 24
	}, {
	  id: 'Sir Oliver Martext',
	  parent: 'As You Like It',
	  size: 3
	}, {
	  id: 'Touchstone',
	  parent: 'As You Like It',
	  size: 74
	}, {
	  id: 'William',
	  parent: 'As You Like It',
	  size: 11
	}, {
	  id: 'Comedy Of Errors',
	  parent: 'Comedies',
	  size: null
	}, {
	  id: 'Adriana',
	  parent: 'Comedy Of Errors',
	  size: 79
	}, {
	  id: 'Aegeon',
	  parent: 'Comedy Of Errors',
	  size: 17
	}, {
	  id: 'Aemilia',
	  parent: 'Comedy Of Errors',
	  size: 16
	}, {
	  id: 'Angelo',
	  parent: 'Comedy Of Errors',
	  size: 31
	}, {
	  id: 'Antipholus of Ephesus',
	  parent: 'Comedy Of Errors',
	  size: 76
	}, {
	  id: 'Antipholus of Syracuse',
	  parent: 'Comedy Of Errors',
	  size: 103
	}, {
	  id: 'Balthazar',
	  parent: 'Comedy Of Errors',
	  size: 5
	}, {
	  id: 'Courtezan',
	  parent: 'Comedy Of Errors',
	  size: 11
	}, {
	  id: 'Dromio of Ephesus',
	  parent: 'Comedy Of Errors',
	  size: 63
	}, {
	  id: 'Dromio of Syracuse',
	  parent: 'Comedy Of Errors',
	  size: 99
	}, {
	  id: 'Luce',
	  parent: 'Comedy Of Errors',
	  size: 7
	}, {
	  id: 'Luciana',
	  parent: 'Comedy Of Errors',
	  size: 43
	}, {
	  id: 'Pinch',
	  parent: 'Comedy Of Errors',
	  size: 6
	}, {
	  id: 'Solinus',
	  parent: 'Comedy Of Errors',
	  size: 22
	}, {
	  id: 'Merchant Of Venice',
	  parent: 'Comedies',
	  size: null
	}, {
	  id: 'Antonio',
	  parent: 'Merchant Of Venice',
	  size: 47
	}, {
	  id: 'Balthasar',
	  parent: 'Merchant Of Venice',
	  size: 1
	}, {
	  id: 'Bassanio',
	  parent: 'Merchant Of Venice',
	  size: 73
	}, {
	  id: 'Duke (of Venice)',
	  parent: 'Merchant Of Venice',
	  size: 18
	}, {
	  id: 'Gratiano',
	  parent: 'Merchant Of Venice',
	  size: 48
	}, {
	  id: 'Jessica',
	  parent: 'Merchant Of Venice',
	  size: 26
	}, {
	  id: 'Launcelot Gobbo',
	  parent: 'Merchant Of Venice',
	  size: 44
	}, {
	  id: 'Leonardo',
	  parent: 'Merchant Of Venice',
	  size: 2
	}, {
	  id: 'Lorenzo',
	  parent: 'Merchant Of Venice',
	  size: 47
	}, {
	  id: 'Nerissa',
	  parent: 'Merchant Of Venice',
	  size: 36
	}, {
	  id: 'Old Gobbo',
	  parent: 'Merchant Of Venice',
	  size: 19
	}, {
	  id: 'Portia',
	  parent: 'Merchant Of Venice',
	  size: 117
	}, {
	  id: 'Prince of Arragon',
	  parent: 'Merchant Of Venice',
	  size: 4
	}, {
	  id: 'Prince of Morocco',
	  parent: 'Merchant Of Venice',
	  size: 7
	}, {
	  id: 'Salanio',
	  parent: 'Merchant Of Venice',
	  size: 18
	}, {
	  id: 'Salarino',
	  parent: 'Merchant Of Venice',
	  size: 27
	}, {
	  id: 'Salerio',
	  parent: 'Merchant Of Venice',
	  size: 6
	}, {
	  id: 'Shylock',
	  parent: 'Merchant Of Venice',
	  size: 79
	}, {
	  id: 'Stephano',
	  parent: 'Merchant Of Venice',
	  size: 3
	}, {
	  id: 'Tubal',
	  parent: 'Merchant Of Venice',
	  size: 8
	}, {
	  id: "Midsummer Night's Dream",
	  parent: 'Comedies',
	  size: null
	}, {
	  id: 'Bottom',
	  parent: "Midsummer Night's Dream",
	  size: 59
	}, {
	  id: 'Cobweb',
	  parent: "Midsummer Night's Dream",
	  size: 4
	}, {
	  id: 'Demetrius',
	  parent: "Midsummer Night's Dream",
	  size: 48
	}, {
	  id: 'Egeus',
	  parent: "Midsummer Night's Dream",
	  size: 7
	}, {
	  id: 'Fairy',
	  parent: "Midsummer Night's Dream",
	  size: 4
	}, {
	  id: 'Flute',
	  parent: "Midsummer Night's Dream",
	  size: 18
	}, {
	  id: 'Helena',
	  parent: "Midsummer Night's Dream",
	  size: 36
	}, {
	  id: 'Hermia',
	  parent: "Midsummer Night's Dream",
	  size: 48
	}, {
	  id: 'Hippolyta',
	  parent: "Midsummer Night's Dream",
	  size: 14
	}, {
	  id: 'Lysander',
	  parent: "Midsummer Night's Dream",
	  size: 50
	}, {
	  id: 'Moth',
	  parent: "Midsummer Night's Dream",
	  size: 2
	}, {
	  id: 'Mustardseed',
	  parent: "Midsummer Night's Dream",
	  size: 5
	}, {
	  id: 'Oberon',
	  parent: "Midsummer Night's Dream",
	  size: 29
	}, {
	  id: 'Peaseblossom',
	  parent: "Midsummer Night's Dream",
	  size: 4
	}, {
	  id: 'Philostrate',
	  parent: "Midsummer Night's Dream",
	  size: 6
	}, {
	  id: 'Puck',
	  parent: "Midsummer Night's Dream",
	  size: 33
	}, {
	  id: 'Quince',
	  parent: "Midsummer Night's Dream",
	  size: 40
	}, {
	  id: 'Snout',
	  parent: "Midsummer Night's Dream",
	  size: 9
	}, {
	  id: 'Snug',
	  parent: "Midsummer Night's Dream",
	  size: 4
	}, {
	  id: 'Starveling',
	  parent: "Midsummer Night's Dream",
	  size: 7
	}, {
	  id: 'Theseus',
	  parent: "Midsummer Night's Dream",
	  size: 48
	}, {
	  id: 'Titania',
	  parent: "Midsummer Night's Dream",
	  size: 23
	}, {
	  id: 'Taming Of The Shrew',
	  parent: 'Comedies',
	  size: null
	}, {
	  id: 'Baptista Minola',
	  parent: 'Taming Of The Shrew',
	  size: 68
	}, {
	  id: 'Bianca',
	  parent: 'Taming Of The Shrew',
	  size: 29
	}, {
	  id: 'Biondello',
	  parent: 'Taming Of The Shrew',
	  size: 39
	}, {
	  id: 'Christopher Sly',
	  parent: 'Taming Of The Shrew',
	  size: 24
	}, {
	  id: 'Curtis',
	  parent: 'Taming Of The Shrew',
	  size: 20
	}, {
	  id: 'Gremio',
	  parent: 'Taming Of The Shrew',
	  size: 58
	}, {
	  id: 'Grumio',
	  parent: 'Taming Of The Shrew',
	  size: 63
	}, {
	  id: 'Haberdasher',
	  parent: 'Taming Of The Shrew',
	  size: 1
	}, {
	  id: 'Hortensio',
	  parent: 'Taming Of The Shrew',
	  size: 70
	}, {
	  id: 'Joseph',
	  parent: 'Taming Of The Shrew',
	  size: 1
	}, {
	  id: 'Katherina',
	  parent: 'Taming Of The Shrew',
	  size: 82
	}, {
	  id: 'Lucentio',
	  parent: 'Taming Of The Shrew',
	  size: 61
	}, {
	  id: 'Nathaniel',
	  parent: 'Taming Of The Shrew',
	  size: 4
	}, {
	  id: 'Nicholas',
	  parent: 'Taming Of The Shrew',
	  size: 1
	}, {
	  id: 'Peter',
	  parent: 'Taming Of The Shrew',
	  size: 2
	}, {
	  id: 'Petruchio',
	  parent: 'Taming Of The Shrew',
	  size: 158
	}, {
	  id: 'Philip',
	  parent: 'Taming Of The Shrew',
	  size: 1
	}, {
	  id: 'Tranio',
	  parent: 'Taming Of The Shrew',
	  size: 90
	}, {
	  id: 'Vincentio',
	  parent: 'Taming Of The Shrew',
	  size: 23
	}, {
	  id: 'The Tempest',
	  parent: 'Comedies',
	  size: null
	}, {
	  id: 'Adrian',
	  parent: 'The Tempest',
	  size: 9
	}, {
	  id: 'Alonso',
	  parent: 'The Tempest',
	  size: 40
	}, {
	  id: 'Antonio, duke of Milan',
	  parent: 'The Tempest',
	  size: 57
	}, {
	  id: 'Ariel',
	  parent: 'The Tempest',
	  size: 45
	}, {
	  id: 'Caliban',
	  parent: 'The Tempest',
	  size: 50
	}, {
	  id: 'Ceres',
	  parent: 'The Tempest',
	  size: 4
	}, {
	  id: 'Ferdinand',
	  parent: 'The Tempest',
	  size: 31
	}, {
	  id: 'Francisco',
	  parent: 'The Tempest',
	  size: 2
	}, {
	  id: 'Gonzalo',
	  parent: 'The Tempest',
	  size: 52
	}, {
	  id: 'Iris',
	  parent: 'The Tempest',
	  size: 4
	}, {
	  id: 'Juno',
	  parent: 'The Tempest',
	  size: 2
	}, {
	  id: 'Master',
	  parent: 'The Tempest',
	  size: 2
	}, {
	  id: 'Miranda',
	  parent: 'The Tempest',
	  size: 50
	}, {
	  id: 'Nymphs',
	  parent: 'The Tempest',
	  size: 0
	}, {
	  id: 'Prospero',
	  parent: 'The Tempest',
	  size: 114
	}, {
	  id: 'Reapers',
	  parent: 'The Tempest',
	  size: 0
	}, {
	  id: 'Sebastian',
	  parent: 'The Tempest',
	  size: 67
	}, {
	  id: 'Stephano (Servant to Portia)',
	  parent: 'The Tempest',
	  size: 60
	}, {
	  id: 'Trinculo',
	  parent: 'The Tempest',
	  size: 39
	}, {
	  id: 'Henry VIII',
	  parent: 'Histories',
	  size: null
	}, {
	  id: 'Anne Bullen',
	  parent: 'Henry VIII',
	  size: 18
	}, {
	  id: 'Archbishop Cranmer',
	  parent: 'Henry VIII',
	  size: 21
	}, {
	  id: 'Bishop Lincoln',
	  parent: 'Henry VIII',
	  size: 2
	}, {
	  id: 'Brandon',
	  parent: 'Henry VIII',
	  size: 6
	}, {
	  id: 'Capucius',
	  parent: 'Henry VIII',
	  size: 5
	}, {
	  id: 'Cardinal Campeius',
	  parent: 'Henry VIII',
	  size: 14
	}, {
	  id: 'Cardinal Wolsey',
	  parent: 'Henry VIII',
	  size: 79
	}, {
	  id: 'Cromwell',
	  parent: 'Henry VIII',
	  size: 21
	}, {
	  id: 'Doctor Butts',
	  parent: 'Henry VIII',
	  size: 4
	}, {
	  id: 'Duke of Buckingham',
	  parent: 'Henry VIII',
	  size: 26
	}, {
	  id: 'Duke of Norfolk',
	  parent: 'Henry VIII',
	  size: 48
	}, {
	  id: 'Duke of Suffolk',
	  parent: 'Henry VIII',
	  size: 30
	}, {
	  id: 'Earl of Surrey',
	  parent: 'Henry VIII',
	  size: 24
	}, {
	  id: 'First Secretary to Wolsey',
	  parent: 'Henry VIII',
	  size: 2
	}, {
	  id: 'Gardiner',
	  parent: 'Henry VIII',
	  size: 22
	}, {
	  id: 'Garter',
	  parent: 'Henry VIII',
	  size: 1
	}, {
	  id: 'Griffith',
	  parent: 'Henry VIII',
	  size: 13
	}, {
	  id: 'King Henry VIII',
	  parent: 'Henry VIII',
	  size: 81
	}, {
	  id: 'Lord Abergavenny',
	  parent: 'Henry VIII',
	  size: 5
	}, {
	  id: 'Lord Chamberlain',
	  parent: 'Henry VIII',
	  size: 38
	}, {
	  id: 'Lord Chancellor',
	  parent: 'Henry VIII',
	  size: 7
	}, {
	  id: 'Lord Sands',
	  parent: 'Henry VIII',
	  size: 17
	}, {
	  id: 'Old Lady',
	  parent: 'Henry VIII',
	  size: 14
	}, {
	  id: 'Patience',
	  parent: 'Henry VIII',
	  size: 3
	}, {
	  id: 'Porter (door-keeper of the Council-chamber)',
	  parent: 'Henry VIII',
	  size: 10
	}, {
	  id: 'Queen Katharine',
	  parent: 'Henry VIII',
	  size: 50
	}, {
	  id: 'Sir Anthony Denny',
	  parent: 'Henry VIII',
	  size: 3
	}, {
	  id: 'Sir Henry Guildford',
	  parent: 'Henry VIII',
	  size: 1
	}, {
	  id: 'Sir Nicholas Vaux',
	  parent: 'Henry VIII',
	  size: 1
	}, {
	  id: 'Sir Thomas Lovell',
	  parent: 'Henry VIII',
	  size: 21
	}, {
	  id: 'Surveyor to the Duke of Buckingham',
	  parent: 'Henry VIII',
	  size: 9
	}, {
	  id: 'History Of King John',
	  parent: 'Histories',
	  size: null
	}, {
	  id: 'Arthur Duke of Bretagne',
	  parent: 'History Of King John',
	  size: 23
	}, {
	  id: 'Blanch',
	  parent: 'History Of King John',
	  size: 9
	}, {
	  id: 'Cardinal Pandulph',
	  parent: 'History Of King John',
	  size: 23
	}, {
	  id: 'Chatillon',
	  parent: 'History Of King John',
	  size: 5
	}, {
	  id: 'Constance',
	  parent: 'History Of King John',
	  size: 36
	}, {
	  id: 'Essex',
	  parent: 'History Of King John',
	  size: 1
	}, {
	  id: 'Faulconbridge',
	  parent: 'History Of King John',
	  size: 4
	}, {
	  id: 'Hubert de Burgh',
	  parent: 'History Of King John',
	  size: 52
	}, {
	  id: 'James Gurney',
	  parent: 'History Of King John',
	  size: 1
	}, {
	  id: 'King John',
	  parent: 'History Of King John',
	  size: 95
	}, {
	  id: 'King Phillip',
	  parent: 'History Of King John',
	  size: 43
	}, {
	  id: 'Lady Faulconbridge',
	  parent: 'History Of King John',
	  size: 5
	}, {
	  id: 'Lewis the Dauphin',
	  parent: 'History Of King John',
	  size: 29
	}, {
	  id: 'Lord Bigot',
	  parent: 'History Of King John',
	  size: 6
	}, {
	  id: 'Lymoges duke of Austria',
	  parent: 'History Of King John',
	  size: 16
	}, {
	  id: 'Melun',
	  parent: 'History Of King John',
	  size: 3
	}, {
	  id: 'Pembroke earl of Pembroke',
	  parent: 'History Of King John',
	  size: 20
	}, {
	  id: 'Peter of Pomfret',
	  parent: 'History Of King John',
	  size: 1
	}, {
	  id: 'Philip the Bastard',
	  parent: 'History Of King John',
	  size: 89
	}, {
	  id: 'Prince Henry',
	  parent: 'History Of King John',
	  size: 8
	}, {
	  id: 'Queen Elinor',
	  parent: 'History Of King John',
	  size: 22
	}, {
	  id: 'Salisbury earl of Salisbury',
	  parent: 'History Of King John',
	  size: 36
	}, {
	  id: 'Antony And Cleopatra',
	  parent: 'Tragedies',
	  size: null
	}, {
	  id: 'Agrippa',
	  parent: 'Antony And Cleopatra',
	  size: 28
	}, {
	  id: 'Alexas',
	  parent: 'Antony And Cleopatra',
	  size: 15
	}, {
	  id: 'Antony',
	  parent: 'Antony And Cleopatra',
	  size: 202
	}, {
	  id: 'Canidius',
	  parent: 'Antony And Cleopatra',
	  size: 10
	}, {
	  id: 'Captain',
	  parent: 'Antony And Cleopatra',
	  size: 1
	}, {
	  id: 'Charmian',
	  parent: 'Antony And Cleopatra',
	  size: 63
	}, {
	  id: 'Cleopatra',
	  parent: 'Antony And Cleopatra',
	  size: 204
	}, {
	  id: 'Demetrius (Friend to Antony)',
	  parent: 'Antony And Cleopatra',
	  size: 2
	}, {
	  id: 'Dercetas',
	  parent: 'Antony And Cleopatra',
	  size: 5
	}, {
	  id: 'Diomedes',
	  parent: 'Antony And Cleopatra',
	  size: 7
	}, {
	  id: 'Dolabella',
	  parent: 'Antony And Cleopatra',
	  size: 23
	}, {
	  id: 'Domitius Enobarus',
	  parent: 'Antony And Cleopatra',
	  size: 113
	}, {
	  id: 'Egyptian',
	  parent: 'Antony And Cleopatra',
	  size: 2
	}, {
	  id: 'Eros',
	  parent: 'Antony And Cleopatra',
	  size: 27
	}, {
	  id: 'Euphronius',
	  parent: 'Antony And Cleopatra',
	  size: 5
	}, {
	  id: 'Gallus',
	  parent: 'Antony And Cleopatra',
	  size: 1
	}, {
	  id: 'Iras',
	  parent: 'Antony And Cleopatra',
	  size: 18
	}, {
	  id: 'Lepidus',
	  parent: 'Antony And Cleopatra',
	  size: 30
	}, {
	  id: 'Mardian',
	  parent: 'Antony And Cleopatra',
	  size: 7
	}, {
	  id: 'Mecaenas',
	  parent: 'Antony And Cleopatra',
	  size: 16
	}, {
	  id: 'Menas',
	  parent: 'Antony And Cleopatra',
	  size: 35
	}, {
	  id: 'Menecrates',
	  parent: 'Antony And Cleopatra',
	  size: 2
	}, {
	  id: 'Octavia',
	  parent: 'Antony And Cleopatra',
	  size: 13
	}, {
	  id: 'Octavius',
	  parent: 'Antony And Cleopatra',
	  size: 98
	}, {
	  id: 'Philo',
	  parent: 'Antony And Cleopatra',
	  size: 2
	}, {
	  id: 'Pompey',
	  parent: 'Antony And Cleopatra',
	  size: 41
	}, {
	  id: 'Proculeius',
	  parent: 'Antony And Cleopatra',
	  size: 10
	}, {
	  id: 'Scarus',
	  parent: 'Antony And Cleopatra',
	  size: 12
	}, {
	  id: 'Seleucus',
	  parent: 'Antony And Cleopatra',
	  size: 3
	}, {
	  id: 'Silius',
	  parent: 'Antony And Cleopatra',
	  size: 3
	}, {
	  id: 'Taurus',
	  parent: 'Antony And Cleopatra',
	  size: 1
	}, {
	  id: 'Thyreus',
	  parent: 'Antony And Cleopatra',
	  size: 12
	}, {
	  id: 'Varrius',
	  parent: 'Antony And Cleopatra',
	  size: 1
	}, {
	  id: 'Ventidius',
	  parent: 'Antony And Cleopatra',
	  size: 4
	}, {
	  id: 'Coriolanus',
	  parent: 'Tragedies',
	  size: null
	}, {
	  id: 'Aedile',
	  parent: 'Coriolanus',
	  size: 10
	}, {
	  id: 'Cominius',
	  parent: 'Coriolanus',
	  size: 67
	}, {
	  id: 'Coriolanus (Caius Marcius Coriolanus)',
	  parent: 'Coriolanus',
	  size: 189
	}, {
	  id: 'Junius Brutus',
	  parent: 'Coriolanus',
	  size: 91
	}, {
	  id: 'Lieutenant',
	  parent: 'Coriolanus',
	  size: 4
	}, {
	  id: 'Menenius Agrippa',
	  parent: 'Coriolanus',
	  size: 162
	}, {
	  id: 'Patrician',
	  parent: 'Coriolanus',
	  size: 3
	}, {
	  id: 'Roman',
	  parent: 'Coriolanus',
	  size: 10
	}, {
	  id: 'Sicinius Velutus',
	  parent: 'Coriolanus',
	  size: 117
	}, {
	  id: 'Titus Lartius',
	  parent: 'Coriolanus',
	  size: 23
	}, {
	  id: 'Tullus Aufidius',
	  parent: 'Coriolanus',
	  size: 45
	}, {
	  id: 'Valeria',
	  parent: 'Coriolanus',
	  size: 14
	}, {
	  id: 'Virgilia',
	  parent: 'Coriolanus',
	  size: 26
	}, {
	  id: 'Volsce',
	  parent: 'Coriolanus',
	  size: 9
	}, {
	  id: 'Volumnia',
	  parent: 'Coriolanus',
	  size: 57
	}, {
	  id: 'Young Coriolanus',
	  parent: 'Coriolanus',
	  size: 1
	}, {
	  id: 'Cymbeline',
	  parent: 'Tragedies',
	  size: null
	}, {
	  id: 'Arviragus',
	  parent: 'Cymbeline',
	  size: 46
	}, {
	  id: 'Belarius',
	  parent: 'Cymbeline',
	  size: 58
	}, {
	  id: 'Caius Lucius',
	  parent: 'Cymbeline',
	  size: 25
	}, {
	  id: 'Cloten',
	  parent: 'Cymbeline',
	  size: 77
	}, {
	  id: 'Cornelius (physician)',
	  parent: 'Cymbeline',
	  size: 13
	}, {
	  id: 'Cymbeline, King of Britain',
	  parent: 'Cymbeline',
	  size: 81
	}, {
	  id: 'Guiderius',
	  parent: 'Cymbeline',
	  size: 62
	}, {
	  id: 'Helen',
	  parent: 'Cymbeline',
	  size: 0
	}, {
	  id: 'Iachimo',
	  parent: 'Cymbeline',
	  size: 77
	}, {
	  id: 'Imogen',
	  parent: 'Cymbeline',
	  size: 118
	}, {
	  id: 'Jupiter',
	  parent: 'Cymbeline',
	  size: 1
	}, {
	  id: 'Philario',
	  parent: 'Cymbeline',
	  size: 14
	}, {
	  id: 'Pisanio',
	  parent: 'Cymbeline',
	  size: 58
	}, {
	  id: 'Posthumus Leonatus',
	  parent: 'Cymbeline',
	  size: 77
	}, {
	  id: 'Queen',
	  parent: 'Cymbeline',
	  size: 27
	}, {
	  id: 'Roman Captain',
	  parent: 'Cymbeline',
	  size: 4
	}, {
	  id: 'Sicilius Leonatus',
	  parent: 'Cymbeline',
	  size: 7
	}, {
	  id: 'The Tragedy of Hamlet, Prince of Denmark',
	  parent: 'Tragedies',
	  size: null
	}, {
	  id: 'Bernardo',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 19
	}, {
	  id: 'Claudius, King of Denmark',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 102
	}, {
	  id: 'Cornelius',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 1
	}, {
	  id: "Father's Ghost",
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 15
	}, {
	  id: 'Fortinbras',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 6
	}, {
	  id: 'Francisco ',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 8
	}, {
	  id: 'Gertrude',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 69
	}, {
	  id: 'Guildenstern',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 29
	}, {
	  id: 'Hamlet',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 358
	}, {
	  id: 'Horatio',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 109
	}, {
	  id: 'Laertes',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 62
	}, {
	  id: 'Lucianus',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 0
	}, {
	  id: 'Marcellus',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 37
	}, {
	  id: 'Ophelia',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 58
	}, {
	  id: 'Osric',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 25
	}, {
	  id: 'Polonius',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 86
	}, {
	  id: 'Reynaldo',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 13
	}, {
	  id: 'Rosencrantz',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 48
	}, {
	  id: 'Voltemand',
	  parent: 'The Tragedy of Hamlet, Prince of Denmark',
	  size: 1
	}, {
	  id: 'Julius Caesar',
	  parent: 'Tragedies',
	  size: null
	}, {
	  id: 'Antony (Marcus Antonius)',
	  parent: 'Julius Caesar',
	  size: 51
	}, {
	  id: 'Artemidorus of Cnidos',
	  parent: 'Julius Caesar',
	  size: 4
	}, {
	  id: 'Brutus (Marcus Brutus)',
	  parent: 'Julius Caesar',
	  size: 194
	}, {
	  id: 'Caesar (Julius Caesar)',
	  parent: 'Julius Caesar',
	  size: 42
	}, {
	  id: 'Calpurnia',
	  parent: 'Julius Caesar',
	  size: 6
	}, {
	  id: 'Casca',
	  parent: 'Julius Caesar',
	  size: 39
	}, {
	  id: 'Cassius',
	  parent: 'Julius Caesar',
	  size: 140
	}, {
	  id: 'Cicero',
	  parent: 'Julius Caesar',
	  size: 4
	}, {
	  id: 'Cinna',
	  parent: 'Julius Caesar',
	  size: 11
	}, {
	  id: 'Cinna the Poet',
	  parent: 'Julius Caesar',
	  size: 8
	}, {
	  id: 'Claudius',
	  parent: 'Julius Caesar',
	  size: 2
	}, {
	  id: 'Clitus',
	  parent: 'Julius Caesar',
	  size: 8
	}, {
	  id: 'Dardanius',
	  parent: 'Julius Caesar',
	  size: 3
	}, {
	  id: 'Decius Brutus',
	  parent: 'Julius Caesar',
	  size: 12
	}, {
	  id: 'Flavius',
	  parent: 'Julius Caesar',
	  size: 5
	}, {
	  id: 'Lepidus (Marcus Antonius Lepidus)',
	  parent: 'Julius Caesar',
	  size: 3
	}, {
	  id: 'Ligarius',
	  parent: 'Julius Caesar',
	  size: 5
	}, {
	  id: 'Lucilius',
	  parent: 'Julius Caesar',
	  size: 10
	}, {
	  id: 'Lucius',
	  parent: 'Julius Caesar',
	  size: 24
	}, {
	  id: 'Marullus',
	  parent: 'Julius Caesar',
	  size: 6
	}, {
	  id: 'Messala',
	  parent: 'Julius Caesar',
	  size: 20
	}, {
	  id: 'Metellus Cimber',
	  parent: 'Julius Caesar',
	  size: 5
	}, {
	  id: 'Octavius (Octavius Caesar)',
	  parent: 'Julius Caesar',
	  size: 19
	}, {
	  id: 'Pindarus',
	  parent: 'Julius Caesar',
	  size: 5
	}, {
	  id: 'Popilius (Popilius Lena)',
	  parent: 'Julius Caesar',
	  size: 2
	}, {
	  id: 'Portia (wife of Brutus)',
	  parent: 'Julius Caesar',
	  size: 16
	}, {
	  id: 'Publius',
	  parent: 'Julius Caesar',
	  size: 2
	}, {
	  id: 'Strato',
	  parent: 'Julius Caesar',
	  size: 4
	}, {
	  id: 'Tintinius',
	  parent: 'Julius Caesar',
	  size: 10
	}, {
	  id: 'Trebonius',
	  parent: 'Julius Caesar',
	  size: 4
	}, {
	  id: 'Varro',
	  parent: 'Julius Caesar',
	  size: 6
	}, {
	  id: 'Volumnius',
	  parent: 'Julius Caesar',
	  size: 3
	}, {
	  id: 'Young Cato',
	  parent: 'Julius Caesar',
	  size: 3
	}, {
	  id: 'King Lear',
	  parent: 'Tragedies',
	  size: null
	}, {
	  id: 'Cordelia',
	  parent: 'King Lear',
	  size: 31
	}, {
	  id: 'Curan',
	  parent: 'King Lear',
	  size: 4
	}, {
	  id: 'Duke of Albany',
	  parent: 'King Lear',
	  size: 58
	}, {
	  id: 'Duke of Burgundy',
	  parent: 'King Lear',
	  size: 5
	}, {
	  id: 'Duke of Cornwall',
	  parent: 'King Lear',
	  size: 53
	}, {
	  id: 'Earl of Gloucester',
	  parent: 'King Lear',
	  size: 118
	}, {
	  id: 'Earl of Kent',
	  parent: 'King Lear',
	  size: 127
	}, {
	  id: 'Edgar',
	  parent: 'King Lear',
	  size: 98
	}, {
	  id: 'Edmund',
	  parent: 'King Lear',
	  size: 79
	}, {
	  id: 'Goneril',
	  parent: 'King Lear',
	  size: 53
	}, {
	  id: 'King of France',
	  parent: 'King Lear',
	  size: 5
	}, {
	  id: 'Lear',
	  parent: 'King Lear',
	  size: 188
	}, {
	  id: 'Oswald',
	  parent: 'King Lear',
	  size: 38
	}, {
	  id: 'Regan',
	  parent: 'King Lear',
	  size: 73
	}, {
	  id: 'The Tragedy Of Macbeth',
	  parent: 'Tragedies',
	  size: null
	}, {
	  id: 'Angus',
	  parent: 'The Tragedy Of Macbeth',
	  size: 4
	}, {
	  id: 'Banquo',
	  parent: 'The Tragedy Of Macbeth',
	  size: 33
	}, {
	  id: 'Caithness',
	  parent: 'The Tragedy Of Macbeth',
	  size: 3
	}, {
	  id: 'Donalbain',
	  parent: 'The Tragedy Of Macbeth',
	  size: 3
	}, {
	  id: 'Duncan',
	  parent: 'The Tragedy Of Macbeth',
	  size: 18
	}, {
	  id: 'Fleance',
	  parent: 'The Tragedy Of Macbeth',
	  size: 2
	}, {
	  id: 'Hecate',
	  parent: 'The Tragedy Of Macbeth',
	  size: 2
	}, {
	  id: 'Lady Macbeth',
	  parent: 'The Tragedy Of Macbeth',
	  size: 59
	}, {
	  id: 'Lady Macduff',
	  parent: 'The Tragedy Of Macbeth',
	  size: 19
	}, {
	  id: 'Lennox',
	  parent: 'The Tragedy Of Macbeth',
	  size: 21
	}, {
	  id: 'Macbeth',
	  parent: 'The Tragedy Of Macbeth',
	  size: 146
	}, {
	  id: 'Macduff',
	  parent: 'The Tragedy Of Macbeth',
	  size: 59
	}, {
	  id: 'Malcolm',
	  parent: 'The Tragedy Of Macbeth',
	  size: 40
	}, {
	  id: 'Menteith',
	  parent: 'The Tragedy Of Macbeth',
	  size: 5
	}, {
	  id: 'Porter',
	  parent: 'The Tragedy Of Macbeth',
	  size: 4
	}, {
	  id: 'Ross',
	  parent: 'The Tragedy Of Macbeth',
	  size: 39
	}, {
	  id: 'Seyton',
	  parent: 'The Tragedy Of Macbeth',
	  size: 5
	}, {
	  id: 'Siward',
	  parent: 'The Tragedy Of Macbeth',
	  size: 11
	}, {
	  id: "Son (Macduff's son)",
	  parent: 'The Tragedy Of Macbeth',
	  size: 14
	}, {
	  id: 'Young Siward',
	  parent: 'The Tragedy Of Macbeth',
	  size: 4
	}, {
	  id: 'The Tragedy Of Othello',
	  parent: 'Tragedies',
	  size: null
	}, {
	  id: 'Bianca (Mistress to Cassio)',
	  parent: 'The Tragedy Of Othello',
	  size: 15
	}, {
	  id: 'Brabantio',
	  parent: 'The Tragedy Of Othello',
	  size: 30
	}, {
	  id: 'Cassio',
	  parent: 'The Tragedy Of Othello',
	  size: 110
	}, {
	  id: 'Desdemona',
	  parent: 'The Tragedy Of Othello',
	  size: 165
	}, {
	  id: 'Duke of Venice',
	  parent: 'The Tragedy Of Othello',
	  size: 25
	}, {
	  id: 'Emilia',
	  parent: 'The Tragedy Of Othello',
	  size: 103
	}, {
	  id: 'Gratiano (Brother to Brabantio)',
	  parent: 'The Tragedy Of Othello',
	  size: 20
	}, {
	  id: 'Iago',
	  parent: 'The Tragedy Of Othello',
	  size: 272
	}, {
	  id: 'Lodovico',
	  parent: 'The Tragedy Of Othello',
	  size: 33
	}, {
	  id: 'Montano',
	  parent: 'The Tragedy Of Othello',
	  size: 24
	}, {
	  id: 'Othello',
	  parent: 'The Tragedy Of Othello',
	  size: 274
	}, {
	  id: 'Roderigo',
	  parent: 'The Tragedy Of Othello',
	  size: 59
	}, {
	  id: 'Romeo And Juliet',
	  parent: 'Tragedies',
	  size: null
	}, {
	  id: 'Abraham',
	  parent: 'Romeo And Juliet',
	  size: 5
	}, {
	  id: 'Balthasar (Servant to Romeo)',
	  parent: 'Romeo And Juliet',
	  size: 12
	}, {
	  id: 'Benvolio',
	  parent: 'Romeo And Juliet',
	  size: 64
	}, {
	  id: 'Capulet',
	  parent: 'Romeo And Juliet',
	  size: 51
	}, {
	  id: 'Friar John',
	  parent: 'Romeo And Juliet',
	  size: 4
	}, {
	  id: 'Friar Laurence',
	  parent: 'Romeo And Juliet',
	  size: 55
	}, {
	  id: 'Gregory',
	  parent: 'Romeo And Juliet',
	  size: 15
	}, {
	  id: 'Juliet',
	  parent: 'Romeo And Juliet',
	  size: 118
	}, {
	  id: 'Lady Capulet',
	  parent: 'Romeo And Juliet',
	  size: 45
	}, {
	  id: 'Lady Montague',
	  parent: 'Romeo And Juliet',
	  size: 2
	}, {
	  id: 'Mercutio',
	  parent: 'Romeo And Juliet',
	  size: 62
	}, {
	  id: 'Montague',
	  parent: 'Romeo And Juliet',
	  size: 10
	}, {
	  id: 'Paris',
	  parent: 'Romeo And Juliet',
	  size: 23
	}, {
	  id: "Peter (Servant to Juliet's Nurse)",
	  parent: 'Romeo And Juliet',
	  size: 13
	}, {
	  id: 'Prince Escalus',
	  parent: 'Romeo And Juliet',
	  size: 16
	}, {
	  id: 'Romeo',
	  parent: 'Romeo And Juliet',
	  size: 163
	}, {
	  id: 'Sampson',
	  parent: 'Romeo And Juliet',
	  size: 20
	}, {
	  id: 'Tybalt',
	  parent: 'Romeo And Juliet',
	  size: 17
	}];

/***/ },
/* 668 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Point = function () {
	  function Point(_ref) {
	    var _ref$x = _ref.x,
	        x = _ref$x === undefined ? 0 : _ref$x,
	        _ref$y = _ref.y,
	        y = _ref$y === undefined ? 0 : _ref$y;
	
	    _classCallCheck(this, Point);
	
	    this.x = x;
	    this.y = y;
	  }
	
	  _createClass(Point, [{
	    key: "value",
	    value: function value() {
	      return {
	        x: this.x,
	        y: this.y
	      };
	    }
	  }, {
	    key: "toArray",
	    value: function toArray() {
	      return [this.x, this.y];
	    }
	  }]);
	
	  return Point;
	}();
	
	exports.default = Point;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _band = __webpack_require__(670);
	
	Object.defineProperty(exports, 'scaleBand', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_band).default;
	  }
	});
	
	var _point = __webpack_require__(677);
	
	Object.defineProperty(exports, 'scalePoint', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_point).default;
	  }
	});
	
	var _linear = __webpack_require__(675);
	
	Object.defineProperty(exports, 'scaleLinear', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_linear).default;
	  }
	});
	
	var _time = __webpack_require__(682);
	
	Object.defineProperty(exports, 'scaleTime', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_time).default;
	  }
	});
	
	var _utc = __webpack_require__(683);
	
	Object.defineProperty(exports, 'scaleUtc', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_utc).default;
	  }
	});
	
	var _log = __webpack_require__(676);
	
	Object.defineProperty(exports, 'scaleLog', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_log).default;
	  }
	});
	
	var _power = __webpack_require__(678);
	
	Object.defineProperty(exports, 'scalePower', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_power).default;
	  }
	});
	
	var _ordinal = __webpack_require__(142);
	
	Object.defineProperty(exports, 'scaleOrdinal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ordinal).default;
	  }
	});
	
	var _quantize = __webpack_require__(680);
	
	Object.defineProperty(exports, 'scaleQuantize', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quantize).default;
	  }
	});
	
	var _quantile = __webpack_require__(679);
	
	Object.defineProperty(exports, 'scaleQuantile', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quantile).default;
	  }
	});
	
	var _threshold = __webpack_require__(681);
	
	Object.defineProperty(exports, 'scaleThreshold', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_threshold).default;
	  }
	});
	
	var _schemeCategory = __webpack_require__(671);
	
	Object.defineProperty(exports, 'schemeCategory10', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_schemeCategory).default;
	  }
	});
	
	var _schemeCategory2 = __webpack_require__(672);
	
	Object.defineProperty(exports, 'schemeCategory20', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_schemeCategory2).default;
	  }
	});
	
	var _schemeCategory20b = __webpack_require__(673);
	
	Object.defineProperty(exports, 'schemeCategory20b', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_schemeCategory20b).default;
	  }
	});
	
	var _schemeCategory20c = __webpack_require__(674);
	
	Object.defineProperty(exports, 'schemeCategory20c', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_schemeCategory20c).default;
	  }
	});
	
	var _updateScale = __webpack_require__(684);
	
	Object.defineProperty(exports, 'updateScale', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_updateScale).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      padding = _ref.padding,
	      paddingInner = _ref.paddingInner,
	      paddingOuter = _ref.paddingOuter,
	      align = _ref.align,
	      tickFormat = _ref.tickFormat;
	
	  var scale = (0, _d3Scale.scaleBand)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (padding) scale.padding(padding);
	  if (paddingInner) scale.paddingInner(paddingInner);
	  if (paddingOuter) scale.paddingOuter(paddingOuter);
	  if (align) scale.align(align);
	  if (tickFormat) scale.tickFormat = tickFormat;
	
	  return scale;
	};

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordinal = __webpack_require__(142);
	
	var _ordinal2 = _interopRequireDefault(_ordinal);
	
	var _d3Scale = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _ordinal2.default)(_d3Scale.schemeCategory10);

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordinal = __webpack_require__(142);
	
	var _ordinal2 = _interopRequireDefault(_ordinal);
	
	var _d3Scale = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _ordinal2.default)(_d3Scale.schemeCategory20);

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordinal = __webpack_require__(142);
	
	var _ordinal2 = _interopRequireDefault(_ordinal);
	
	var _d3Scale = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _ordinal2.default)(_d3Scale.schemeCategory20b);

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordinal = __webpack_require__(142);
	
	var _ordinal2 = _interopRequireDefault(_ordinal);
	
	var _d3Scale = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _ordinal2.default)(_d3Scale.schemeCategory20c);

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scaleLinear)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	
	  return scale;
	};

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      base = _ref.base,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scaleLog)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	  if (base) scale.base(base);
	
	  return scale;
	};

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      padding = _ref.padding,
	      align = _ref.align,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice;
	
	  var scale = (0, _d3Scale.scalePoint)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (padding) scale.padding(padding);
	  if (align) scale.align(align);
	
	  return scale;
	};

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      base = _ref.base,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scalePow)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	  if (base) scale.base(base);
	
	  return scale;
	};

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      domain = _ref.domain;
	
	  var scale = (0, _d3Scale.scaleQuantile)();
	
	  if (range) scale.range(range);
	  if (domain) scale.domain(domain);
	
	  return scale;
	};

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      domain = _ref.domain,
	      ticks = _ref.ticks,
	      tickFormat = _ref.tickFormat,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice;
	
	  var scale = (0, _d3Scale.scaleQuantize)();
	
	  if (range) scale.range(range);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (ticks) scale.ticks(ticks);
	  if (tickFormat) scale.tickFormat(tickFormat);
	
	  return scale;
	};

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      domain = _ref.domain;
	
	  var scale = (0, _d3Scale.scaleThreshold)();
	
	  if (range) scale.range(range);
	  if (domain) scale.domain(domain);
	
	  return scale;
	};

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scaleTime)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	
	  return scale;
	};

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(46);
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scaleUtc)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	
	  return scale;
	};

/***/ },
/* 684 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateScale;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function updateScale(scale, _ref) {
	  var args = _objectWithoutProperties(_ref, []);
	
	  var nextScale = scale.copy();
	  Object.keys(args).forEach(function (key) {
	    if (nextScale.hasOwnProperty(key)) nextScale[key](args[key]);
	  });
	  return nextScale;
	}

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Arc;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Arc(_ref) {
	  var className = _ref.className,
	      data = _ref.data,
	      centroid = _ref.centroid,
	      innerRadius = _ref.innerRadius,
	      outerRadius = _ref.outerRadius,
	      cornerRadius = _ref.cornerRadius,
	      startAngle = _ref.startAngle,
	      endAngle = _ref.endAngle,
	      padAngle = _ref.padAngle,
	      padRadius = _ref.padRadius,
	      restProps = _objectWithoutProperties(_ref, ['className', 'data', 'centroid', 'innerRadius', 'outerRadius', 'cornerRadius', 'startAngle', 'endAngle', 'padAngle', 'padRadius']);
	
	  var arc = (0, _d3Shape.arc)();
	  if (centroid) arc.centroid(centroid);
	  if (innerRadius) arc.innerRadius(innerRadius);
	  if (outerRadius) arc.outerRadius(outerRadius);
	  if (cornerRadius) arc.cornerRadius(cornerRadius);
	  if (startAngle) arc.startAngle(startAngle);
	  if (endAngle) arc.endAngle(endAngle);
	  if (padAngle) arc.padAngle(padAngle);
	  if (padRadius) arc.padRadius(padRadius);
	  return _react2.default.createElement('path', _extends({
	    className: (0, _classnames2.default)('vx-arc', className),
	    d: arc(data)
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Area;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	Area.propTypes = {
	  x: _propTypes2.default.func,
	  x0: _propTypes2.default.func,
	  x1: _propTypes2.default.func,
	  y: _propTypes2.default.func,
	  y0: _propTypes2.default.func,
	  y1: _propTypes2.default.func,
	  xScale: _propTypes2.default.func,
	  yScale: _propTypes2.default.func,
	  data: _propTypes2.default.array,
	  defined: _propTypes2.default.func,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.array]),
	  innerRef: _propTypes2.default.func,
	  strokeDasharray: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  stroke: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  curve: _propTypes2.default.func
	};
	
	function Area(_ref) {
	  var x = _ref.x,
	      x0 = _ref.x0,
	      x1 = _ref.x1,
	      y = _ref.y,
	      y0 = _ref.y0,
	      y1 = _ref.y1,
	      xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? [] : _ref$data,
	      _ref$defined = _ref.defined,
	      defined = _ref$defined === undefined ? function () {
	    return true;
	  } : _ref$defined,
	      className = _ref.className,
	      strokeDasharray = _ref.strokeDasharray,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 2 : _ref$strokeWidth,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? 'black' : _ref$stroke,
	      _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'rgba(0,0,0,0.3)' : _ref$fill,
	      curve = _ref.curve,
	      innerRef = _ref.innerRef,
	      restProps = _objectWithoutProperties(_ref, ['x', 'x0', 'x1', 'y', 'y0', 'y1', 'xScale', 'yScale', 'data', 'defined', 'className', 'strokeDasharray', 'strokeWidth', 'stroke', 'fill', 'curve', 'innerRef']);
	
	  var path = (0, _d3Shape.area)();
	  if (x) path.x(function (d) {
	    return xScale(x(d));
	  });
	  if (x0) path.x0(function (d) {
	    return xScale(x0(d));
	  });
	  if (x1) path.x1(function (d) {
	    return xScale(x1(d));
	  });
	  if (y) path.y(function (d) {
	    return yScale(y(d));
	  });
	  if (y0) path.y0(function (d) {
	    return yScale(y0(d));
	  });
	  if (y1) path.y1(function (d) {
	    return yScale(y1(d));
	  });
	  if (defined) path.defined(defined);
	  if (curve) path.curve(curve);
	  return _react2.default.createElement(
	    'g',
	    null,
	    _react2.default.createElement('path', _extends({
	      ref: innerRef,
	      className: (0, _classnames2.default)('vx-area', className),
	      d: path(data),
	      stroke: stroke,
	      strokeWidth: strokeWidth,
	      strokeDasharray: strokeDasharray,
	      fill: fill
	    }, (0, _additionalProps2.default)(restProps, data)))
	  );
	}

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = AreaClosed;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	AreaClosed.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function AreaClosed(_ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      data = _ref.data,
	      _ref$defined = _ref.defined,
	      defined = _ref$defined === undefined ? function () {
	    return true;
	  } : _ref$defined,
	      className = _ref.className,
	      strokeDasharray = _ref.strokeDasharray,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 2 : _ref$strokeWidth,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? 'black' : _ref$stroke,
	      _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'rgba(0,0,0,0.3)' : _ref$fill,
	      curve = _ref.curve,
	      innerRef = _ref.innerRef,
	      restProps = _objectWithoutProperties(_ref, ['x', 'y', 'xScale', 'yScale', 'data', 'defined', 'className', 'strokeDasharray', 'strokeWidth', 'stroke', 'fill', 'curve', 'innerRef']);
	
	  var path = (0, _d3Shape.area)().x(function (d) {
	    return xScale(x(d));
	  }).y0(yScale.range()[0]).y1(function (d) {
	    return yScale(y(d));
	  }).defined(defined);
	  if (curve) path.curve(curve);
	  return _react2.default.createElement(
	    'g',
	    null,
	    _react2.default.createElement('path', _extends({
	      ref: innerRef,
	      className: (0, _classnames2.default)('vx-area-closed', className),
	      d: path(data),
	      stroke: stroke,
	      strokeWidth: strokeWidth,
	      strokeDasharray: strokeDasharray,
	      fill: fill
	    }, (0, _additionalProps2.default)(restProps, data)))
	  );
	}

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = AreaStack;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	var _d3Shape = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function AreaStack(_ref) {
	  var className = _ref.className,
	      _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      keys = _ref.keys,
	      data = _ref.data,
	      curve = _ref.curve,
	      defined = _ref.defined,
	      x = _ref.x,
	      x0 = _ref.x0,
	      x1 = _ref.x1,
	      y0 = _ref.y0,
	      y1 = _ref.y1,
	      glyph = _ref.glyph,
	      _ref$reverse = _ref.reverse,
	      reverse = _ref$reverse === undefined ? false : _ref$reverse,
	      restProps = _objectWithoutProperties(_ref, ['className', 'top', 'left', 'keys', 'data', 'curve', 'defined', 'x', 'x0', 'x1', 'y0', 'y1', 'glyph', 'reverse']);
	
	  var stack = (0, _d3Shape.stack)();
	  if (keys) stack.keys(keys);
	
	  var path = (0, _d3Shape.area)();
	  if (x) path.x(x);
	  if (x0) path.x0(x0);
	  if (x1) path.x1(x1);
	  if (y0) path.y0(y0);
	  if (y1) path.y1(y1);
	  if (curve) path.curve(curve);
	  if (defined) path.defined(defined);
	
	  var seriesData = stack(data);
	  if (reverse) seriesData.reverse();
	
	  return _react2.default.createElement(
	    'g',
	    null,
	    seriesData.map(function (series, i) {
	      return _react2.default.createElement('path', _extends({
	        className: (0, _classnames2.default)('vx-area-stack', className),
	        key: 'area-stack-' + i + '-' + (series.key || ''),
	        d: path(series)
	      }, (0, _additionalProps2.default)(restProps, {
	        datum: series[i],
	        index: i,
	        series: series
	      })));
	    }),
	    !!glyph && _react2.default.createElement(
	      'g',
	      { className: 'vx-area-stack-glyphs' },
	      data.map(glyph)
	    )
	  );
	}

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = BarGroup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _group = __webpack_require__(100);
	
	var _Bar = __webpack_require__(181);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BarGroup(_ref) {
	  var data = _ref.data,
	      className = _ref.className,
	      top = _ref.top,
	      left = _ref.left,
	      x0 = _ref.x0,
	      x0Scale = _ref.x0Scale,
	      x1Scale = _ref.x1Scale,
	      yScale = _ref.yScale,
	      zScale = _ref.zScale,
	      keys = _ref.keys,
	      height = _ref.height,
	      restProps = _objectWithoutProperties(_ref, ['data', 'className', 'top', 'left', 'x0', 'x0Scale', 'x1Scale', 'yScale', 'zScale', 'keys', 'height']);
	
	  var format = x0Scale.tickFormat ? x0Scale.tickFormat() : function (d) {
	    return d;
	  };
	  return _react2.default.createElement(
	    _group.Group,
	    {
	      className: (0, _classnames2.default)('vx-bar-group', className),
	      top: top,
	      left: left
	    },
	    data && data.map(function (d, i) {
	      return _react2.default.createElement(
	        _group.Group,
	        {
	          key: 'bar-group-' + i + '-' + x0(d),
	          left: x0Scale(x0(d))
	        },
	        keys && keys.map(function (key, i) {
	          var value = d[key];
	          return _react2.default.createElement(_Bar2.default, _extends({
	            key: 'bar-group-bar-' + i + '-' + value + '-' + key,
	            x: x1Scale(key),
	            y: yScale(value),
	            width: x1Scale.bandwidth(),
	            height: height - yScale(value),
	            fill: zScale(key),
	            data: {
	              key: key,
	              value: value,
	              x: format(x0(d)),
	              data: d
	            }
	          }, restProps));
	        })
	      );
	    })
	  );
	}
	
	BarGroup.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  x0: _propTypes2.default.func.isRequired,
	  x0Scale: _propTypes2.default.func.isRequired,
	  x1Scale: _propTypes2.default.func.isRequired,
	  yScale: _propTypes2.default.func.isRequired,
	  zScale: _propTypes2.default.func.isRequired,
	  keys: _propTypes2.default.array.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  className: _propTypes2.default.string,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number
	};

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = BarStack;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _group = __webpack_require__(100);
	
	var _Bar = __webpack_require__(181);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _d3Shape = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BarStack(_ref) {
	  var data = _ref.data,
	      className = _ref.className,
	      top = _ref.top,
	      left = _ref.left,
	      x = _ref.x,
	      xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      zScale = _ref.zScale,
	      keys = _ref.keys,
	      height = _ref.height,
	      restProps = _objectWithoutProperties(_ref, ['data', 'className', 'top', 'left', 'x', 'xScale', 'yScale', 'zScale', 'keys', 'height']);
	
	  var series = (0, _d3Shape.stack)().keys(keys)(data);
	  var format = xScale.tickFormat ? xScale.tickFormat() : function (d) {
	    return d;
	  };
	  var bandwidth = xScale.bandwidth();
	  var step = xScale.step();
	  var paddingInner = xScale.paddingInner();
	  var paddingOuter = xScale.paddingOuter();
	  return _react2.default.createElement(
	    _group.Group,
	    { className: (0, _classnames2.default)('vx-bar-stack', className), top: top, left: left },
	    series && series.map(function (s, i) {
	      return _react2.default.createElement(
	        _group.Group,
	        { key: 'vx-bar-stack-' + i },
	        s.map(function (d, ii) {
	          var barHeight = yScale(d[0]) - yScale(d[1]);
	          return _react2.default.createElement(_Bar2.default, _extends({
	            key: 'bar-group-bar-' + i + '-' + ii + '-' + s.key,
	            x: xScale(x(d.data)),
	            y: yScale(d[1]),
	            width: bandwidth,
	            height: barHeight,
	            fill: zScale(s.key),
	            data: {
	              bandwidth: bandwidth,
	              paddingInner: paddingInner,
	              paddingOuter: paddingOuter,
	              step: step,
	              key: s.key,
	              value: d[1],
	              height: barHeight,
	              width: bandwidth,
	              x: x(d.data),
	              xFormatted: format(x(d.data)),
	              data: d.data
	            }
	          }, restProps));
	        })
	      );
	    })
	  );
	}
	
	BarStack.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  x: _propTypes2.default.func.isRequired,
	  xScale: _propTypes2.default.func.isRequired,
	  yScale: _propTypes2.default.func.isRequired,
	  zScale: _propTypes2.default.func.isRequired,
	  keys: _propTypes2.default.array.isRequired,
	  className: _propTypes2.default.string,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number
	};

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = BarStackHorizontal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _group = __webpack_require__(100);
	
	var _Bar = __webpack_require__(181);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _d3Shape = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BarStackHorizontal(_ref) {
	  var data = _ref.data,
	      className = _ref.className,
	      top = _ref.top,
	      left = _ref.left,
	      y = _ref.y,
	      xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      zScale = _ref.zScale,
	      keys = _ref.keys,
	      height = _ref.height,
	      restProps = _objectWithoutProperties(_ref, ['data', 'className', 'top', 'left', 'y', 'xScale', 'yScale', 'zScale', 'keys', 'height']);
	
	  var series = (0, _d3Shape.stack)().keys(keys)(data);
	  var format = yScale.tickFormat ? yScale.tickFormat() : function (d) {
	    return d;
	  };
	  var bandwidth = yScale.bandwidth();
	  var step = yScale.step();
	  var paddingInner = yScale.paddingInner();
	  var paddingOuter = yScale.paddingOuter();
	  return _react2.default.createElement(
	    _group.Group,
	    { className: (0, _classnames2.default)('vx-bar-stack-horizontal', className), top: top, left: left },
	    series && series.map(function (s, i) {
	      return _react2.default.createElement(
	        _group.Group,
	        { key: 'vx-bar-stack-horizontal-' + i },
	        s.map(function (d, ii) {
	          var barWidth = xScale(d[1]) - xScale(d[0]);
	          return _react2.default.createElement(_Bar2.default, _extends({
	            key: 'bar-group-bar-' + i + '-' + ii + '-' + s.key,
	            x: xScale(d[0]),
	            y: yScale(y(d.data)),
	            width: barWidth,
	            height: bandwidth,
	            fill: zScale(s.key),
	            data: {
	              bandwidth: bandwidth,
	              paddingInner: paddingInner,
	              paddingOuter: paddingOuter,
	              step: step,
	              key: s.key,
	              value: d[0],
	              height: bandwidth,
	              width: barWidth,
	              y: y(d.data),
	              yFormatted: format(y(d.data)),
	              data: d.data
	            }
	          }, restProps));
	        })
	      );
	    })
	  );
	}
	
	BarStackHorizontal.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  y: _propTypes2.default.func.isRequired,
	  xScale: _propTypes2.default.func.isRequired,
	  yScale: _propTypes2.default.func.isRequired,
	  zScale: _propTypes2.default.func.isRequired,
	  keys: _propTypes2.default.array.isRequired,
	  className: _propTypes2.default.string,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number
	};

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Line;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _point = __webpack_require__(374);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	Line.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function Line(_ref) {
	  var _ref$from = _ref.from,
	      from = _ref$from === undefined ? new _point.Point({ x: 0, y: 0 }) : _ref$from,
	      _ref$to = _ref.to,
	      to = _ref$to === undefined ? new _point.Point({ x: 1, y: 1 }) : _ref$to,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? 'black' : _ref$stroke,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 1 : _ref$strokeWidth,
	      _ref$strokeDasharray = _ref.strokeDasharray,
	      strokeDasharray = _ref$strokeDasharray === undefined ? '' : _ref$strokeDasharray,
	      _ref$transform = _ref.transform,
	      transform = _ref$transform === undefined ? '' : _ref$transform,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      data = _ref.data,
	      innerRef = _ref.innerRef,
	      restProps = _objectWithoutProperties(_ref, ['from', 'to', 'stroke', 'strokeWidth', 'strokeDasharray', 'transform', 'className', 'data', 'innerRef']);
	
	  return _react2.default.createElement('line', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-line', className),
	    x1: from.x,
	    y1: from.y,
	    x2: to.x,
	    y2: to.y,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    transform: transform
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinePath;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _curve = __webpack_require__(372);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinePath.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinePath(_ref) {
	  var data = _ref.data,
	      xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      x = _ref.x,
	      y = _ref.y,
	      _ref$defined = _ref.defined,
	      defined = _ref$defined === undefined ? function () {
	    return true;
	  } : _ref$defined,
	      className = _ref.className,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? 'steelblue' : _ref$stroke,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 2 : _ref$strokeWidth,
	      _ref$strokeDasharray = _ref.strokeDasharray,
	      strokeDasharray = _ref$strokeDasharray === undefined ? '' : _ref$strokeDasharray,
	      _ref$strokeDashoffset = _ref.strokeDashoffset,
	      strokeDashoffset = _ref$strokeDashoffset === undefined ? 0 : _ref$strokeDashoffset,
	      _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'none' : _ref$fill,
	      _ref$curve = _ref.curve,
	      curve = _ref$curve === undefined ? _curve.curveLinear : _ref$curve,
	      glyph = _ref.glyph,
	      innerRef = _ref.innerRef,
	      restProps = _objectWithoutProperties(_ref, ['data', 'xScale', 'yScale', 'x', 'y', 'defined', 'className', 'stroke', 'strokeWidth', 'strokeDasharray', 'strokeDashoffset', 'fill', 'curve', 'glyph', 'innerRef']);
	
	  var path = (0, _d3Shape.line)().x(function (d) {
	    return xScale(x(d));
	  }).y(function (d) {
	    return yScale(y(d));
	  }).defined(defined).curve(curve);
	  return _react2.default.createElement(
	    'g',
	    null,
	    _react2.default.createElement('path', _extends({
	      ref: innerRef,
	      className: (0, _classnames2.default)('vx-linepath', className),
	      d: path(data),
	      stroke: stroke,
	      strokeWidth: strokeWidth,
	      strokeDasharray: strokeDasharray,
	      strokeDashoffset: strokeDashoffset,
	      fill: fill
	    }, (0, _additionalProps2.default)(restProps, data))),
	    glyph && _react2.default.createElement(
	      'g',
	      { className: 'vx-linepath-glyphs' },
	      data.map(glyph)
	    )
	  );
	}

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LineRadial;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LineRadial.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LineRadial(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      angle = _ref.angle,
	      radius = _ref.radius,
	      defined = _ref.defined,
	      curve = _ref.curve,
	      data = _ref.data,
	      innerRef = _ref.innerRef,
	      restProps = _objectWithoutProperties(_ref, ['className', 'angle', 'radius', 'defined', 'curve', 'data', 'innerRef']);
	
	  var path = (0, _d3Shape.radialLine)();
	  if (angle) path.angle(angle);
	  if (radius) path.radius(radius);
	  if (defined) path.defined(defined);
	  if (curve) path.curve(curve);
	  return _react2.default.createElement(
	    'g',
	    null,
	    _react2.default.createElement('path', _extends({
	      ref: innerRef,
	      className: (0, _classnames2.default)('vx-line-radial', className),
	      d: path(data)
	    }, (0, _additionalProps2.default)(restProps, data)))
	  );
	}

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Pie;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _group = __webpack_require__(100);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Pie(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      data = _ref.data,
	      centroid = _ref.centroid,
	      _ref$innerRadius = _ref.innerRadius,
	      innerRadius = _ref$innerRadius === undefined ? 0 : _ref$innerRadius,
	      outerRadius = _ref.outerRadius,
	      cornerRadius = _ref.cornerRadius,
	      _ref$startAngle = _ref.startAngle,
	      startAngle = _ref$startAngle === undefined ? 0 : _ref$startAngle,
	      endAngle = _ref.endAngle,
	      padAngle = _ref.padAngle,
	      padRadius = _ref.padRadius,
	      pieSort = _ref.pieSort,
	      pieValue = _ref.pieValue,
	      restProps = _objectWithoutProperties(_ref, ['className', 'top', 'left', 'data', 'centroid', 'innerRadius', 'outerRadius', 'cornerRadius', 'startAngle', 'endAngle', 'padAngle', 'padRadius', 'pieSort', 'pieValue']);
	
	  var path = (0, _d3Shape.arc)();
	  path.innerRadius(innerRadius);
	  if (outerRadius) path.outerRadius(outerRadius);
	  if (cornerRadius) path.cornerRadius(cornerRadius);
	  if (padRadius) path.padRadius(padRadius);
	  var pie = (0, _d3Shape.pie)();
	  if (pieSort) pie.sort(pieSort);
	  if (pieValue) pie.value(pieValue);
	  if (padAngle) pie.padAngle(padAngle);
	  var arcs = pie(data);
	  return _react2.default.createElement(
	    _group.Group,
	    { className: 'vx-pie-arcs-group', top: top, left: left },
	    arcs.map(function (arc, i) {
	      var c = void 0;
	      if (centroid) c = path.centroid(arc);
	      return _react2.default.createElement(
	        'g',
	        { key: 'pie-arc-' + i },
	        _react2.default.createElement('path', _extends({
	          className: (0, _classnames2.default)('vx-pie-arc', className),
	          d: path(arc)
	        }, (0, _additionalProps2.default)(restProps, _extends({}, arc, {
	          index: i,
	          centroid: c
	        })))),
	        centroid && centroid(c, arc)
	      );
	    })
	  );
	}

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Stack;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _group = __webpack_require__(100);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	var _stackOrder = __webpack_require__(378);
	
	var _stackOrder2 = _interopRequireDefault(_stackOrder);
	
	var _stackOffset = __webpack_require__(377);
	
	var _stackOffset2 = _interopRequireDefault(_stackOffset);
	
	var _d3Shape = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Stack(_ref) {
	  var className = _ref.className,
	      _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      keys = _ref.keys,
	      data = _ref.data,
	      curve = _ref.curve,
	      defined = _ref.defined,
	      x = _ref.x,
	      x0 = _ref.x0,
	      x1 = _ref.x1,
	      y0 = _ref.y0,
	      y1 = _ref.y1,
	      value = _ref.value,
	      order = _ref.order,
	      offset = _ref.offset,
	      render = _ref.render,
	      _ref$reverse = _ref.reverse,
	      reverse = _ref$reverse === undefined ? false : _ref$reverse,
	      restProps = _objectWithoutProperties(_ref, ['className', 'top', 'left', 'keys', 'data', 'curve', 'defined', 'x', 'x0', 'x1', 'y0', 'y1', 'value', 'order', 'offset', 'render', 'reverse']);
	
	  var stack = (0, _d3Shape.stack)();
	  if (keys) stack.keys(keys);
	  if (value) stack.value(value);
	  if (order) stack.order((0, _stackOrder2.default)(order));
	  if (offset) stack.offset((0, _stackOffset2.default)(offset));
	
	  var path = (0, _d3Shape.area)();
	  if (x) path.x(x);
	  if (x0) path.x0(x0);
	  if (x1) path.x1(x1);
	  if (y0) path.y0(y0);
	  if (y1) path.y1(y1);
	  if (curve) path.curve(curve);
	  if (defined) path.defined(defined);
	
	  var seriesData = stack(data);
	  if (reverse) seriesData.reverse();
	
	  if (render) return _react2.default.createElement(
	    _group.Group,
	    { top: top, left: left },
	    render({ seriesData: seriesData, path: path })
	  );
	
	  return _react2.default.createElement(
	    _group.Group,
	    { top: top, left: left },
	    seriesData.map(function (series, i) {
	      return _react2.default.createElement('path', _extends({
	        className: (0, _classnames2.default)('vx-stack', className),
	        key: 'stack-' + i + '-' + (series.key || ''),
	        d: path(series)
	      }, (0, _additionalProps2.default)(restProps, {
	        datum: series[i],
	        index: i,
	        series: series
	      })));
	    })
	  );
	}

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkHorizontalCurve;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkHorizontalCurve.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkHorizontalCurve(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.y;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.x;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y']);
	
	  var curve = function curve(source, target) {
	    var sx = x(source);
	    var sy = y(source);
	    var tx = x(target);
	    var ty = y(target);
	
	    var dx = tx - sx;
	    var dy = ty - sy;
	    var ix = 0.2 * (dx + dy);
	    var iy = 0.2 * (dy - dx);
	
	    return 'M' + sx + ',' + sy + '\n      C' + (sx + ix) + ',' + (sy + iy) + '\n      ' + (tx + iy) + ',' + (ty - ix) + '\n      ' + tx + ',' + ty + '\n    ';
	  };
	
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link', className),
	    d: curve(data.source, data.target)
	  }, restProps));
	}

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkRadialCurve;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkRadialCurve.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkRadialCurve(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.x;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.y;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y']);
	
	  var curve = function curve(source, target) {
	    var sa = x(source) - Math.PI / 2;
	    var sr = y(source);
	    var ta = x(target) - Math.PI / 2;
	    var tr = y(target);
	
	    var sc = Math.cos(sa);
	    var ss = Math.sin(sa);
	    var tc = Math.cos(ta);
	    var ts = Math.sin(ta);
	
	    var sx = sr * sc;
	    var sy = sr * ss;
	    var tx = tr * tc;
	    var ty = tr * ts;
	
	    var dx = tx - sx;
	    var dy = ty - sy;
	    var ix = 0.2 * (dx + dy);
	    var iy = 0.2 * (dy - dx);
	
	    return 'M' + sx + ',' + sy + '\n      C' + (sx + ix) + ',' + (sy + iy) + '\n      ' + (tx + iy) + ',' + (ty - ix) + '\n      ' + tx + ',' + ty + '\n    ';
	  };
	
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link', className),
	    d: curve(data.source, data.target)
	  }, restProps));
	}

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkVerticalCurve;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkVerticalCurve.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkVerticalCurve(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.x;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.y;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y']);
	
	  var curve = function curve(source, target) {
	    var sx = x(source);
	    var sy = y(source);
	    var tx = x(target);
	    var ty = y(target);
	
	    var dx = tx - sx;
	    var dy = ty - sy;
	    var ix = 0.2 * (dx + dy);
	    var iy = 0.2 * (dy - dx);
	
	    return 'M' + sx + ',' + sy + '\n      C' + (sx + ix) + ',' + (sy + iy) + '\n      ' + (tx + iy) + ',' + (ty - ix) + '\n      ' + tx + ',' + ty + '\n    ';
	  };
	
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link', className),
	    d: curve(data.source, data.target)
	  }, restProps));
	}

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkHorizontal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkHorizontal.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkHorizontal(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.y;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.x;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y']);
	
	  var link = (0, _d3Shape.linkHorizontal)();
	  link.x(x);
	  link.y(y);
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link-horizontal', className),
	    d: link(data)
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkRadial;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkRadial.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkRadial(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$angle = _ref.angle,
	      angle = _ref$angle === undefined ? function (d) {
	    return d.x;
	  } : _ref$angle,
	      _ref$radius = _ref.radius,
	      radius = _ref$radius === undefined ? function (d) {
	    return d.y;
	  } : _ref$radius,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'angle', 'radius']);
	
	  var link = (0, _d3Shape.linkRadial)();
	  link.angle(angle);
	  link.radius(radius);
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link-radius', className),
	    d: link(data)
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkVertical;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkVertical.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkVertical(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.x;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.y;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y']);
	
	  var link = (0, _d3Shape.linkVertical)();
	  link.x(x);
	  link.y(y);
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link-vertical', className),
	    d: link(data)
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkHorizontalLine;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkHorizontalLine.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkHorizontalLine(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.y;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.x;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y']);
	
	  var line = function line(source, target) {
	    return '\n    M' + x(source) + ',' + y(source) + '\n    L' + x(target) + ',' + y(target) + '\n  ';
	  };
	
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link', className),
	    d: line(data.source, data.target)
	  }, restProps));
	}

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkRadialStep;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkRadialStep.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkRadialStep(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.x;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.y;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y']);
	
	  var line = function line(source, target) {
	    var sa = x(source) - Math.PI / 2;
	    var sr = y(source);
	    var ta = x(target) - Math.PI / 2;
	    var tr = y(target);
	
	    var sc = Math.cos(sa);
	    var ss = Math.sin(sa);
	    var tc = Math.cos(ta);
	    var ts = Math.sin(ta);
	
	    return '\n      M' + sr * sc + ',' + sr * ss + '\n      L' + tr * tc + ',' + tr * ts + '\n    ';
	  };
	
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link', className),
	    d: line(data.source, data.target)
	  }, restProps));
	}

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkVerticalLine;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkVerticalLine.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkVerticalLine(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.x;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.y;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y']);
	
	  var line = function line(source, target) {
	    return '\n    M' + x(source) + ',' + y(source) + '\n    L' + x(target) + ',' + y(target) + '\n  ';
	  };
	
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link', className),
	    d: line(data.source, data.target)
	  }, restProps));
	}

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkHorizontalStep;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkHorizontalStep.propTypes = {
	  innerRef: _propTypes2.default.func,
	  percent: _propTypes2.default.number
	};
	
	function LinkHorizontalStep(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$percent = _ref.percent,
	      percent = _ref$percent === undefined ? 0.5 : _ref$percent,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.y;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.x;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'percent', 'x', 'y']);
	
	  var line = function line(source, target) {
	    return '\n    M' + x(source) + ',' + y(source) + '\n    H' + (x(source) + (x(target) - x(source)) * percent) + '\n    V' + y(target) + '\n    H' + x(target) + '\n  ';
	  };
	
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link', className),
	    d: line(data.source, data.target)
	  }, restProps));
	}

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkRadialStep;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkRadialStep.propTypes = {
	  innerRef: _propTypes2.default.func
	};
	
	function LinkRadialStep(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.x;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.y;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'x', 'y']);
	
	  var step = function step(source, target) {
	    var sa = x(source) - Math.PI / 2;
	    var sr = y(source);
	    var ta = x(target) - Math.PI / 2;
	    var tr = y(target);
	
	    var sc = Math.cos(sa);
	    var ss = Math.sin(sa);
	    var tc = Math.cos(ta);
	    var ts = Math.sin(ta);
	    var sf = Math.abs(ta - sa) > Math.PI ? ta <= sa : ta > sa;
	
	    return '\n      M' + sr * sc + ',' + sr * ss + '\n      A' + sr + ',' + sr + ' 0 0,' + (sf ? 1 : 0) + '\n      ' + sr * tc + ',' + sr * ts + '\n      L' + tr * tc + ',' + tr * ts + '\n    ';
	  };
	
	  var line = step;
	
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link', className),
	    d: line(data.source, data.target)
	  }, restProps));
	}

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkVerticalStep;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _additionalProps = __webpack_require__(27);
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	LinkVerticalStep.propTypes = {
	  innerRef: _propTypes2.default.func,
	  percent: _propTypes2.default.number
	};
	
	function LinkVerticalStep(_ref) {
	  var className = _ref.className,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      _ref$percent = _ref.percent,
	      percent = _ref$percent === undefined ? 0.5 : _ref$percent,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.x;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.y;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'innerRef', 'data', 'percent', 'x', 'y']);
	
	  var line = function line(source, target) {
	    return '\n    M' + x(source) + ',' + y(source) + '\n    V' + (y(source) + (y(target) - y(source)) * percent) + '\n    H' + x(target) + '\n    V' + y(target) + '\n  ';
	  };
	
	  return _react2.default.createElement('path', _extends({
	    ref: innerRef,
	    className: (0, _classnames2.default)('vx-link', className),
	    d: line(data.source, data.target)
	  }, restProps));
	}

/***/ },
/* 709 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 711 */
[1485, 709, 710, 712],
/* 712 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 713 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _line = __webpack_require__(721);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _line3 = __webpack_require__(720);
	
	var _line4 = _interopRequireDefault(_line3);
	
	var _line5 = __webpack_require__(719);
	
	var _line6 = _interopRequireDefault(_line5);
	
	var _line7 = __webpack_require__(722);
	
	var _line8 = _interopRequireDefault(_line7);
	
	var _line9 = __webpack_require__(715);
	
	var _line10 = _interopRequireDefault(_line9);
	
	var _line11 = __webpack_require__(718);
	
	var _line12 = _interopRequireDefault(_line11);
	
	var _d3Logo = __webpack_require__(716);
	
	var _d3Logo2 = _interopRequireDefault(_d3Logo);
	
	var _reactUikitGrid = __webpack_require__(1331);
	
	var _reactUikitGrid2 = _interopRequireDefault(_reactUikitGrid);
	
	var _reactUikitArticle = __webpack_require__(1301);
	
	var _reactUikitArticle2 = _interopRequireDefault(_reactUikitArticle);
	
	var _logo = __webpack_require__(874);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__(859);
	
	__webpack_require__(858);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(
	          'div',
	          { className: 'App-header' },
	          _react2.default.createElement('img', { src: _logo2.default, className: 'App-logo', alt: 'logo' }),
	          _react2.default.createElement(_d3Logo2.default, null)
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'React-D3 Libraries Showcase'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'App-intro' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Line chart demos with different React D3 libraries: Victory.js, Recharts, Nivo, VX, Britecharts-react and react-vis.'
	          ),
	          _react2.default.createElement(
	            'small',
	            null,
	            'Check the code in ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/Golodhros/talk-react-d3' },
	              'https://github.com/Golodhros/talk-react-d3'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactUikitGrid2.default,
	          null,
	          _react2.default.createElement(
	            _reactUikitArticle2.default,
	            { col: '1-1',
	              className: 'uk-margin-bottom',
	              title: 'Victory.js',
	              lead: 'Low level charting library by Formidable Labs'
	            },
	            _react2.default.createElement(
	              'section',
	              { className: 'demo demo-victory uk-margin-bottom' },
	              _react2.default.createElement(_line2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _reactUikitArticle2.default,
	            { col: '1-1',
	              className: 'uk-margin-bottom',
	              title: 'Recharts',
	              lead: 'A composable charting library built on React components'
	            },
	            _react2.default.createElement(
	              'section',
	              { className: 'demo demo-recharts uk-margin-bottom' },
	              _react2.default.createElement(_line4.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _reactUikitArticle2.default,
	            { col: '1-1',
	              className: 'uk-margin-bottom',
	              title: 'Nivo',
	              lead: 'Nivo provides a rich set of dataviz components, built on top of the awesome d3 and Reactjs libraries.'
	            },
	            _react2.default.createElement(
	              'section',
	              { className: 'demo demo-nivo uk-margin-bottom' },
	              _react2.default.createElement(_line12.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _reactUikitArticle2.default,
	            { col: '1-1',
	              className: 'uk-margin-bottom',
	              title: 'VX',
	              lead: 'Low-level visualization components for creating visualizations'
	            },
	            _react2.default.createElement(
	              'section',
	              { className: 'demo demo-vx uk-margin-bottom' },
	              _react2.default.createElement(_line8.default, {
	                width: 400,
	                height: 200,
	                margin: {
	                  top: 10,
	                  left: 10,
	                  right: 10,
	                  bottom: 10
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactUikitArticle2.default,
	            { col: '1-1',
	              className: 'uk-margin-bottom',
	              title: 'Britecharts-React',
	              lead: 'React wrapper for Britecharts'
	            },
	            _react2.default.createElement(
	              'section',
	              { className: 'demo demo-bcr uk-margin-bottom' },
	              _react2.default.createElement(_line10.default, {
	                width: 400,
	                height: 200
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactUikitArticle2.default,
	            { col: '1-1',
	              className: 'uk-margin-bottom',
	              title: 'react-vis',
	              lead: 'Uber\'s visualization library'
	            },
	            _react2.default.createElement(
	              'section',
	              { className: 'demo demo-react-vis uk-margin-bottom' },
	              _react2.default.createElement(_line6.default, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _britechartsReact = __webpack_require__(724);
	
	__webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var oneSet = function oneSet() {
	    return {
	        dataByTopic: [{
	            topic: -1,
	            topicName: 'Vivid',
	            dates: [{
	                date: '31-Jul-16',
	                value: 0,
	                fullDate: '2016-07-31T00:00:00-07:00'
	            }, {
	                date: '1-Aug-16',
	                value: 0,
	                fullDate: '2016-08-01T00:00:00-07:00'
	            }, {
	                date: '2-Aug-16',
	                value: 3,
	                fullDate: '2016-08-02T00:00:00-07:00'
	            }, {
	                date: '3-Aug-16',
	                value: 1,
	                fullDate: '2016-08-03T00:00:00-07:00'
	            }, {
	                date: '4-Aug-16',
	                value: 3,
	                fullDate: '2016-08-04T00:00:00-07:00'
	            }, {
	                date: '5-Aug-16',
	                value: 3,
	                fullDate: '2016-08-05T00:00:00-07:00'
	            }, {
	                date: '6-Aug-16',
	                value: 0,
	                fullDate: '2016-08-06T00:00:00-07:00'
	            }, {
	                date: '7-Aug-16',
	                value: 1,
	                fullDate: '2016-08-07T00:00:00-07:00'
	            }, {
	                date: '8-Aug-16',
	                value: 1,
	                fullDate: '2016-08-08T00:00:00-07:00'
	            }, {
	                date: '9-Aug-16',
	                value: 0,
	                fullDate: '2016-08-09T00:00:00-07:00'
	            }, {
	                date: '10-Aug-16',
	                value: 3,
	                fullDate: '2016-08-10T00:00:00-07:00'
	            }, {
	                date: '11-Aug-16',
	                value: 4,
	                fullDate: '2016-08-11T00:00:00-07:00'
	            }, {
	                date: '12-Aug-16',
	                value: 4,
	                fullDate: '2016-08-12T00:00:00-07:00'
	            }, {
	                date: '13-Aug-16',
	                value: 2,
	                fullDate: '2016-08-13T00:00:00-07:00'
	            }, {
	                date: '14-Aug-16',
	                value: 3,
	                fullDate: '2016-08-14T00:00:00-07:00'
	            }, {
	                date: '15-Aug-16',
	                value: 0,
	                fullDate: '2016-08-15T00:00:00-07:00'
	            }, {
	                date: '16-Aug-16',
	                value: 1,
	                fullDate: '2016-08-16T00:00:00-07:00'
	            }, {
	                date: '17-Aug-16',
	                value: 0,
	                fullDate: '2016-08-17T00:00:00-07:00'
	            }, {
	                date: '18-Aug-16',
	                value: 2,
	                fullDate: '2016-08-18T00:00:00-07:00'
	            }, {
	                date: '19-Aug-16',
	                value: 5,
	                fullDate: '2016-08-19T00:00:00-07:00'
	            }, {
	                date: '20-Aug-16',
	                value: 1,
	                fullDate: '2016-08-20T00:00:00-07:00'
	            }, {
	                date: '21-Aug-16',
	                value: 2,
	                fullDate: '2016-08-21T00:00:00-07:00'
	            }, {
	                date: '22-Aug-16',
	                value: 9,
	                fullDate: '2016-08-22T00:00:00-07:00'
	            }, {
	                date: '23-Aug-16',
	                value: 4,
	                fullDate: '2016-08-23T00:00:00-07:00'
	            }, {
	                date: '24-Aug-16',
	                value: 3,
	                fullDate: '2016-08-24T00:00:00-07:00'
	            }, {
	                date: '25-Aug-16',
	                value: 2,
	                fullDate: '2016-08-25T00:00:00-07:00'
	            }, {
	                date: '26-Aug-16',
	                value: 5,
	                fullDate: '2016-08-26T00:00:00-07:00'
	            }]
	        }]
	    };
	};
	
	var LineChartBritechartsReact = function (_Component) {
	    _inherits(LineChartBritechartsReact, _Component);
	
	    function LineChartBritechartsReact() {
	        _classCallCheck(this, LineChartBritechartsReact);
	
	        return _possibleConstructorReturn(this, (LineChartBritechartsReact.__proto__ || Object.getPrototypeOf(LineChartBritechartsReact)).apply(this, arguments));
	    }
	
	    _createClass(LineChartBritechartsReact, [{
	        key: 'render',
	        value: function render() {
	            var margin = {
	                top: 60,
	                right: 50,
	                bottom: 60,
	                left: 70
	            };
	
	            return _react2.default.createElement(_britechartsReact.Tooltip, {
	                data: oneSet(),
	                topicLabel: 'topics',
	                title: 'Tooltip Title',
	                render: function render(props) {
	                    return _react2.default.createElement(_britechartsReact.Line, Object.assign({
	                        width: 600,
	                        height: 300,
	                        isAnimated: true,
	                        margin: margin,
	                        lineCurve: 'basis'
	                    }, props));
	                }
	            });
	        }
	    }]);
	
	    return LineChartBritechartsReact;
	}(_react.Component);
	
	exports.default = LineChartBritechartsReact;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var D3Logo = function (_Component) {
	    _inherits(D3Logo, _Component);
	
	    function D3Logo() {
	        _classCallCheck(this, D3Logo);
	
	        return _possibleConstructorReturn(this, (D3Logo.__proto__ || Object.getPrototypeOf(D3Logo)).apply(this, arguments));
	    }
	
	    _createClass(D3Logo, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "svg",
	                { version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "90", height: "90", viewBox: "-10 -10 116 111" },
	                _react2.default.createElement(
	                    "defs",
	                    null,
	                    _react2.default.createElement("path", { id: "deethree", d: "M0,0h7.75a45.5,45.5 0 1 1 0,91h-7.75v-20h7.75a25.5,25.5 0 1 0 0,-51h-7.75zm36.2510,0h32a27.75,27.75 0 0 1 21.331,45.5a27.75,27.75 0 0 1 -21.331,45.5h-32a53.6895,53.6895 0 0 0 18.7464,-20h13.2526a7.75,7.75 0 1 0 0,-15.5h-7.75a53.6895,53.6895 0 0 0 0,-20h7.75a7.75,7.75 0 1 0 0,-15.5h-13.2526a53.6895,53.6895 0 0 0 -18.7464,-20z" })
	                ),
	                _react2.default.createElement("use", { stroke: "black", strokeWidth: "20", fill: "none", xlinkHref: "#deethree" }),
	                _react2.default.createElement("use", { fill: "white", xlinkHref: "#deethree" })
	            );
	        }
	    }]);
	
	    return D3Logo;
	}(_react.Component);
	
	exports.default = D3Logo;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSnapshot = __webpack_require__(1296);
	
	var _App = __webpack_require__(714);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(860);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactSnapshot.render)(_react2.default.createElement(_App2.default, null), document.getElementById('root'));
	// import ReactDOM from 'react-dom';

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nivo = __webpack_require__(1164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './styles.css';
	
	var data = [{
	  "id": "whisky",
	  "color": "hsl(177, 70%, 50%)",
	  "data": [{
	    "color": "hsl(173, 70%, 50%)",
	    "x": "KP",
	    "y": 33
	  }, {
	    "color": "hsl(190, 70%, 50%)",
	    "x": "SH",
	    "y": 32
	  }, {
	    "color": "hsl(188, 70%, 50%)",
	    "x": "MG",
	    "y": 25
	  }, {
	    "color": "hsl(164, 70%, 50%)",
	    "x": "AR",
	    "y": 7
	  }, {
	    "color": "hsl(171, 70%, 50%)",
	    "x": "HT",
	    "y": 53
	  }, {
	    "color": "hsl(89, 70%, 50%)",
	    "x": "ET",
	    "y": 8
	  }, {
	    "color": "hsl(216, 70%, 50%)",
	    "x": "ID",
	    "y": 54
	  }, {
	    "color": "hsl(6, 70%, 50%)",
	    "x": "FJ",
	    "y": 56
	  }, {
	    "color": "hsl(304, 70%, 50%)",
	    "x": "AU",
	    "y": 14
	  }]
	}, {
	  "id": "rhum",
	  "color": "hsl(224, 70%, 50%)",
	  "data": [{
	    "color": "hsl(8, 70%, 50%)",
	    "x": "KP",
	    "y": 60
	  }, {
	    "color": "hsl(95, 70%, 50%)",
	    "x": "SH",
	    "y": 36
	  }, {
	    "color": "hsl(87, 70%, 50%)",
	    "x": "MG",
	    "y": 17
	  }, {
	    "color": "hsl(200, 70%, 50%)",
	    "x": "AR",
	    "y": 4
	  }, {
	    "color": "hsl(331, 70%, 50%)",
	    "x": "HT",
	    "y": 5
	  }, {
	    "color": "hsl(313, 70%, 50%)",
	    "x": "ET",
	    "y": 17
	  }, {
	    "color": "hsl(209, 70%, 50%)",
	    "x": "ID",
	    "y": 46
	  }, {
	    "color": "hsl(18, 70%, 50%)",
	    "x": "FJ",
	    "y": 1
	  }, {
	    "color": "hsl(225, 70%, 50%)",
	    "x": "AU",
	    "y": 56
	  }]
	}, {
	  "id": "gin",
	  "color": "hsl(60, 70%, 50%)",
	  "data": [{
	    "color": "hsl(17, 70%, 50%)",
	    "x": "KP",
	    "y": 18
	  }, {
	    "color": "hsl(202, 70%, 50%)",
	    "x": "SH",
	    "y": 40
	  }, {
	    "color": "hsl(202, 70%, 50%)",
	    "x": "MG",
	    "y": 60
	  }, {
	    "color": "hsl(117, 70%, 50%)",
	    "x": "AR",
	    "y": 47
	  }, {
	    "color": "hsl(14, 70%, 50%)",
	    "x": "HT",
	    "y": 36
	  }, {
	    "color": "hsl(356, 70%, 50%)",
	    "x": "ET",
	    "y": 14
	  }, {
	    "color": "hsl(38, 70%, 50%)",
	    "x": "ID",
	    "y": 21
	  }, {
	    "color": "hsl(224, 70%, 50%)",
	    "x": "FJ",
	    "y": 47
	  }, {
	    "color": "hsl(210, 70%, 50%)",
	    "x": "AU",
	    "y": 53
	  }]
	}, {
	  "id": "vodka",
	  "color": "hsl(20, 70%, 50%)",
	  "data": [{
	    "color": "hsl(196, 70%, 50%)",
	    "x": "KP",
	    "y": 38
	  }, {
	    "color": "hsl(72, 70%, 50%)",
	    "x": "SH",
	    "y": 9
	  }, {
	    "color": "hsl(246, 70%, 50%)",
	    "x": "MG",
	    "y": 6
	  }, {
	    "color": "hsl(288, 70%, 50%)",
	    "x": "AR",
	    "y": 58
	  }, {
	    "color": "hsl(349, 70%, 50%)",
	    "x": "HT",
	    "y": 3
	  }, {
	    "color": "hsl(338, 70%, 50%)",
	    "x": "ET",
	    "y": 22
	  }, {
	    "color": "hsl(250, 70%, 50%)",
	    "x": "ID",
	    "y": 30
	  }, {
	    "color": "hsl(260, 70%, 50%)",
	    "x": "FJ",
	    "y": 0
	  }, {
	    "color": "hsl(60, 70%, 50%)",
	    "x": "AU",
	    "y": 28
	  }]
	}, {
	  "id": "cognac",
	  "color": "hsl(78, 70%, 50%)",
	  "data": [{
	    "color": "hsl(357, 70%, 50%)",
	    "x": "KP",
	    "y": 59
	  }, {
	    "color": "hsl(275, 70%, 50%)",
	    "x": "SH",
	    "y": 14
	  }, {
	    "color": "hsl(359, 70%, 50%)",
	    "x": "MG",
	    "y": 26
	  }, {
	    "color": "hsl(292, 70%, 50%)",
	    "x": "AR",
	    "y": 39
	  }, {
	    "color": "hsl(94, 70%, 50%)",
	    "x": "HT",
	    "y": 57
	  }, {
	    "color": "hsl(31, 70%, 50%)",
	    "x": "ET",
	    "y": 54
	  }, {
	    "color": "hsl(79, 70%, 50%)",
	    "x": "ID",
	    "y": 54
	  }, {
	    "color": "hsl(70, 70%, 50%)",
	    "x": "FJ",
	    "y": 3
	  }, {
	    "color": "hsl(147, 70%, 50%)",
	    "x": "AU",
	    "y": 0
	  }]
	}];
	
	var LineChartNivo = function (_Component) {
	  _inherits(LineChartNivo, _Component);
	
	  function LineChartNivo() {
	    _classCallCheck(this, LineChartNivo);
	
	    return _possibleConstructorReturn(this, (LineChartNivo.__proto__ || Object.getPrototypeOf(LineChartNivo)).apply(this, arguments));
	  }
	
	  _createClass(LineChartNivo, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_nivo.Line, {
	        data: [{
	          id: 'fake corp. A',
	          color: '#547687',
	          data: [0.4, 0.5, 0.7, 0.1, 0.2, 0.5, 0.6, 0.5].map(function (y, i) {
	            return { x: '#' + i, y: y };
	          })
	        }, {
	          id: 'fake corp. B',
	          color: '#7f98a5',
	          data: [0.5, 0.6, 0.8, 0.7, 0.8, 0.5, 0.2, 0.3].map(function (y, i) {
	            return { x: '#' + i, y: y };
	          })
	        }, {
	          id: 'fake corp. C',
	          color: '#a7bac3',
	          data: [0.9, 0.5, 0.6, 0.5, 0.4, 0.3, 0.1, 0.1].map(function (y, i) {
	            return { x: '#' + i, y: y };
	          })
	        }],
	        width: 600,
	        height: 300,
	        margin: {
	          "top": 50,
	          "right": 110,
	          "bottom": 50,
	          "left": 60
	        },
	        minY: 'auto',
	        stacked: true,
	        axisBottom: {
	          "orient": "bottom",
	          "tickSize": 5,
	          "tickPadding": 5,
	          "tickRotation": 0,
	          "legend": "country code",
	          "legendOffset": 36,
	          "legendPosition": "center"
	        },
	        axisLeft: {
	          "orient": "left",
	          "tickSize": 5,
	          "tickPadding": 5,
	          "tickRotation": 0,
	          "legend": "count",
	          "legendOffset": -40,
	          "legendPosition": "center"
	        },
	        dotSize: 10,
	        dotColor: 'inherit:darker(0.3)',
	        dotBorderWidth: 2,
	        dotBorderColor: '#ffffff',
	        enableDotLabel: true,
	        dotLabel: 'y',
	        dotLabelYOffset: -12,
	        animate: true,
	        motionStiffness: 90,
	        motionDamping: 15,
	        legends: [{
	          "anchor": "bottom-right",
	          "direction": "column",
	          "translateX": 100,
	          "itemWidth": 80,
	          "itemHeight": 20,
	          "symbolSize": 12,
	          "symbolShape": "circle"
	        }]
	      });
	    }
	  }]);
	
	  return LineChartNivo;
	}(_react.Component);
	
	exports.default = LineChartNivo;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVis = __webpack_require__(1346);
	
	__webpack_require__(861);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var data1 = [{ x: 0, y: 4000, pv: 2400, amt: 2400 }, { x: 1, y: 3000, pv: 1398, amt: 2210 }, { x: 2, y: 2000, pv: 9800, amt: 2290 }, { x: 3, y: 2780, pv: 3908, amt: 2000 }, { x: 4, y: 1890, pv: 4800, amt: 2181 }, { x: 5, y: 2390, pv: 3800, amt: 2500 }, { x: 6, y: 3490, pv: 4300, amt: 2100 }];
	var data2 = [{ x: 0, pu: 4000, y: 2400, amt: 2400 }, { x: 1, pu: 3000, y: 1398, amt: 2210 }, { x: 2, pu: 2000, y: 9800, amt: 2290 }, { x: 3, pu: 2780, y: 3908, amt: 2000 }, { x: 4, pu: 1890, y: 4800, amt: 2181 }, { x: 5, pu: 2390, y: 3800, amt: 2500 }, { x: 6, pu: 3490, y: 4300, amt: 2100 }];
	
	var LineChartRVis = function (_Component) {
	    _inherits(LineChartRVis, _Component);
	
	    function LineChartRVis() {
	        _classCallCheck(this, LineChartRVis);
	
	        return _possibleConstructorReturn(this, (LineChartRVis.__proto__ || Object.getPrototypeOf(LineChartRVis)).apply(this, arguments));
	    }
	
	    _createClass(LineChartRVis, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactVis.XYPlot,
	                {
	                    width: 600,
	                    height: 300
	                },
	                _react2.default.createElement(_reactVis.HorizontalGridLines, null),
	                _react2.default.createElement(_reactVis.LineSeries, {
	                    data: data1
	                }),
	                _react2.default.createElement(_reactVis.LineSeries, {
	                    data: data2
	                }),
	                _react2.default.createElement(_reactVis.XAxis, null),
	                _react2.default.createElement(_reactVis.YAxis, null)
	            );
	        }
	    }]);
	
	    return LineChartRVis;
	}(_react.Component);
	
	exports.default = LineChartRVis;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(1410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var data = [{ name: 'Page A', uv: 4000, pv: 2400, amt: 2400 }, { name: 'Page B', uv: 3000, pv: 1398, amt: 2210 }, { name: 'Page C', uv: 2000, pv: 9800, amt: 2290 }, { name: 'Page D', uv: 2780, pv: 3908, amt: 2000 }, { name: 'Page E', uv: 1890, pv: 4800, amt: 2181 }, { name: 'Page F', uv: 2390, pv: 3800, amt: 2500 }, { name: 'Page G', uv: 3490, pv: 4300, amt: 2100 }];
	
	var SimpleLineChart = function (_Component) {
	    _inherits(SimpleLineChart, _Component);
	
	    function SimpleLineChart() {
	        _classCallCheck(this, SimpleLineChart);
	
	        return _possibleConstructorReturn(this, (SimpleLineChart.__proto__ || Object.getPrototypeOf(SimpleLineChart)).apply(this, arguments));
	    }
	
	    _createClass(SimpleLineChart, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _recharts.LineChart,
	                {
	                    width: 600,
	                    height: 300,
	                    data: data,
	                    margin: { top: 5, right: 30, left: 20, bottom: 5 }
	                },
	                _react2.default.createElement(_recharts.XAxis, { dataKey: 'name' }),
	                _react2.default.createElement(_recharts.YAxis, null),
	                _react2.default.createElement(_recharts.CartesianGrid, { strokeDasharray: '3 3' }),
	                _react2.default.createElement(_recharts.Tooltip, null),
	                _react2.default.createElement(_recharts.Legend, null),
	                _react2.default.createElement(_recharts.Line, {
	                    type: 'monotone',
	                    dataKey: 'pv',
	                    stroke: '#8884d8',
	                    activeDot: { r: 8 }
	                }),
	                _react2.default.createElement(_recharts.Line, {
	                    type: 'monotone',
	                    dataKey: 'uv',
	                    stroke: '#82ca9d'
	                })
	            );
	        }
	    }]);
	
	    return SimpleLineChart;
	}(_react.Component);
	
	exports.default = SimpleLineChart;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victory = __webpack_require__(1479);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var data = [{ name: 'Page A', uv: 4000, pv: 2400, amt: 2400 }, { name: 'Page B', uv: 3000, pv: 1398, amt: 2210 }, { name: 'Page C', uv: 2000, pv: 9800, amt: 2290 }, { name: 'Page D', uv: 2780, pv: 3908, amt: 2000 }, { name: 'Page E', uv: 1890, pv: 4800, amt: 2181 }, { name: 'Page F', uv: 2390, pv: 3800, amt: 2500 }, { name: 'Page G', uv: 3490, pv: 4300, amt: 2100 }];
	
	var LineChartVictory = function (_Component) {
	    _inherits(LineChartVictory, _Component);
	
	    function LineChartVictory() {
	        _classCallCheck(this, LineChartVictory);
	
	        return _possibleConstructorReturn(this, (LineChartVictory.__proto__ || Object.getPrototypeOf(LineChartVictory)).apply(this, arguments));
	    }
	
	    _createClass(LineChartVictory, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _victory.VictoryChart,
	                {
	                    width: 600,
	                    height: 300,
	                    containerComponent: _react2.default.createElement(_victory.VictoryVoronoiContainer, { dimension: 'x',
	                        labels: function labels(d) {
	                            return 'uv: ' + d.uv;
	                        },
	                        labelComponent: _react2.default.createElement(_victory.VictoryTooltip, { cornerRadius: 0, flyoutStyle: { fill: 'white' } })
	                    }),
	                    theme: _victory.VictoryTheme.material
	                },
	                _react2.default.createElement(_victory.VictoryLine, {
	                    labelComponent: _react2.default.createElement(_victory.VictoryTooltip, null),
	                    data: data,
	                    x: 'name',
	                    y: 'uv',
	                    theme: _victory.VictoryTheme.grayscale
	                }),
	                _react2.default.createElement(_victory.VictoryLine, {
	                    labelComponent: _react2.default.createElement(_victory.VictoryTooltip, null),
	                    data: data,
	                    x: 'name',
	                    y: 'pv',
	                    theme: _victory.VictoryTheme.grayscale
	                }),
	                _react2.default.createElement(_victory.VictoryAxis, {
	                    dependentAxis: true
	                }),
	                _react2.default.createElement(_victory.VictoryAxis, {
	                    scale: 'time',
	                    standalone: false
	                })
	            );
	        }
	    }]);
	
	    return LineChartVictory;
	}(_react.Component);
	
	exports.default = LineChartVictory;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _group = __webpack_require__(100);
	
	var _shape = __webpack_require__(375);
	
	var _curve = __webpack_require__(372);
	
	var _mockData = __webpack_require__(658);
	
	var _scale = __webpack_require__(669);
	
	var _axis = __webpack_require__(647);
	
	var _d3Array = __webpack_require__(251);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function genLines(num) {
	    return new Array(num).fill(1).map(function () {
	        return (0, _mockData.genDateValue)(25);
	    });
	}
	
	var series = genLines(1);
	var data = series.reduce(function (rec, d) {
	    return rec.concat(d);
	}, []);
	
	// accessors
	var x = function x(d) {
	    return d.date;
	};
	var y = function y(d) {
	    return d.value;
	};
	
	// responsive utils for axis ticks
	function numTicksForHeight(height) {
	    if (height <= 300) return 3;
	    if (300 < height && height <= 600) return 5;
	    return 10;
	}
	
	var LineChartVX = function (_React$Component) {
	    _inherits(LineChartVX, _React$Component);
	
	    function LineChartVX() {
	        _classCallCheck(this, LineChartVX);
	
	        return _possibleConstructorReturn(this, (LineChartVX.__proto__ || Object.getPrototypeOf(LineChartVX)).apply(this, arguments));
	    }
	
	    _createClass(LineChartVX, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                width = _props.width,
	                height = _props.height,
	                margin = _props.margin;
	
	            // bounds
	
	            var xMax = width - margin.left - margin.right;
	            var yMax = height - margin.top - margin.bottom;
	
	            // scales
	            var xScale = (0, _scale.scaleTime)({
	                range: [0, xMax],
	                domain: (0, _d3Array.extent)(data, x)
	            });
	            var yScale = (0, _scale.scaleLinear)({
	                range: [yMax, 0],
	                domain: [0, (0, _d3Array.max)(data, y)],
	                nice: true
	            });
	
	            return _react2.default.createElement(
	                'svg',
	                {
	                    width: width,
	                    height: height
	                },
	                _react2.default.createElement('rect', {
	                    x: 0,
	                    y: 0,
	                    width: width,
	                    height: height,
	                    fill: 'white',
	                    rx: 14
	                }),
	                _react2.default.createElement(
	                    _group.Group,
	                    { top: margin.top },
	                    _react2.default.createElement(_shape.LinePath, {
	                        data: data,
	                        xScale: xScale,
	                        yScale: yScale,
	                        x: x,
	                        y: y,
	                        stroke: '#32deaa',
	                        strokeWidth: 2
	                    })
	                )
	            );
	        }
	    }]);
	
	    return LineChartVX;
	}(_react2.default.Component);
	
	exports.default = LineChartVX;
	;

/***/ },
/* 723 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 724 */
/***/ function(module, exports) {

	module.exports=function(t){function __webpack_require__(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,__webpack_require__),r.l=!0,r.exports}var e={};return __webpack_require__.m=t,__webpack_require__.c=e,__webpack_require__.d=function(t,e,n){__webpack_require__.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},__webpack_require__.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return __webpack_require__.d(e,"a",e),e},__webpack_require__.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=41)}([function(t,e){function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}function runTimeout(t){if(n===setTimeout)return setTimeout(t,0);if((n===defaultSetTimout||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}function runClearTimeout(t){if(r===clearTimeout)return clearTimeout(t);if((r===defaultClearTimeout||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{return r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}function cleanUpNextTick(){u&&i&&(u=!1,i.length?o=i.concat(o):c=-1,o.length&&drainQueue())}function drainQueue(){if(!u){var t=runTimeout(cleanUpNextTick);u=!0;for(var e=o.length;e;){for(i=o,o=[];++c<e;)i&&i[c].run();c=-1,e=o.length}i=null,u=!1,runClearTimeout(t)}}function Item(t,e){this.fun=t,this.array=e}function noop(){}var n,r,a=t.exports={};!function(){try{n="function"==typeof setTimeout?setTimeout:defaultSetTimout}catch(t){n=defaultSetTimout}try{r="function"==typeof clearTimeout?clearTimeout:defaultClearTimeout}catch(t){r=defaultClearTimeout}}();var i,o=[],u=!1,c=-1;a.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];o.push(new Item(t,e)),1!==o.length||u||runTimeout(drainQueue)},Item.prototype.run=function(){this.fun.apply(null,this.array)},a.title="browser",a.browser=!0,a.env={},a.argv=[],a.version="",a.versions={},a.on=noop,a.addListener=noop,a.once=noop,a.off=noop,a.removeListener=noop,a.removeAllListeners=noop,a.emit=noop,a.prependListener=noop,a.prependOnceListener=noop,a.listeners=function(t){return[]},a.binding=function(t){throw new Error("process.binding is not supported")},a.cwd=function(){return"/"},a.chdir=function(t){throw new Error("process.chdir is not supported")},a.umask=function(){return 0}},function(t,e,n){"use strict";function Selection(t,e){this._groups=t,this._parents=e}function selection(){return new Selection([[document.documentElement]],E)}n.d(e,"c",function(){return E}),e.a=Selection;var r=n(65),a=n(66),i=n(67),o=n(68),u=n(37),c=n(70),s=n(71),f=n(72),l=n(73),h=n(74),d=n(75),p=n(76),b=n(77),v=n(78),m=n(79),y=n(80),g=n(39),_=n(81),x=n(82),w=n(83),O=n(84),M=n(85),C=n(86),j=n(87),T=n(88),k=n(89),S=n(90),N=n(25),A=n(91),E=[null];Selection.prototype=selection.prototype={constructor:Selection,select:r.a,selectAll:a.a,filter:i.a,data:o.a,enter:u.b,exit:c.a,merge:s.a,order:f.a,sort:l.a,call:h.a,nodes:d.a,node:p.a,size:b.a,empty:v.a,each:m.a,attr:y.a,style:g.a,property:_.a,classed:x.a,text:w.a,html:O.a,raise:M.a,lower:C.a,append:j.a,insert:T.a,remove:k.a,datum:S.a,on:N.b,dispatch:A.a},e.b=selection},function(t,e,n){"use strict";(function(e){function invariant(t,e,r,a,i,o,u,c){if(n(e),!t){var s;if(void 0===e)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,a,i,o,u,c],l=0;s=new Error(e.replace(/%s/g,function(){return f[l++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}}var n=function(t){};"production"!==e.env.NODE_ENV&&(n=function(t){if(void 0===t)throw new Error("invariant requires an error message argument")}),t.exports=invariant}).call(e,n(0))},function(t,e,n){"use strict";(function(e){var r=n(12),a=r;if("production"!==e.env.NODE_ENV){var i=function(t){for(var e=arguments.length,n=Array(e>1?e-1:0),r=1;r<e;r++)n[r-1]=arguments[r];var a=0,i="Warning: "+t.replace(/%s/g,function(){return n[a++]});try{throw new Error(i)}catch(t){}};a=function(t,e){if(void 0===e)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(0!==e.indexOf("Failed Composite propType: ")&&!t){for(var n=arguments.length,r=Array(n>2?n-2:0),a=2;a<n;a++)r[a-2]=arguments[a];i.apply(void 0,[e].concat(r))}}}t.exports=a}).call(e,n(0))},function(t,e,n){"use strict";t.exports=n(43)},function(t,e,n){"use strict";(function(e){function hasValidRef(t){if("production"!==e.env.NODE_ENV&&s.call(t,"ref")){var n=Object.getOwnPropertyDescriptor(t,"ref").get;if(n&&n.isReactWarning)return!1}return void 0!==t.ref}function hasValidKey(t){if("production"!==e.env.NODE_ENV&&s.call(t,"key")){var n=Object.getOwnPropertyDescriptor(t,"key").get;if(n&&n.isReactWarning)return!1}return void 0!==t.key}function defineKeyPropWarningGetter(t,n){var a=function(){r||(r=!0,"production"!==e.env.NODE_ENV&&u(!1,"%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)",n))};a.isReactWarning=!0,Object.defineProperty(t,"key",{get:a,configurable:!0})}function defineRefPropWarningGetter(t,n){var r=function(){a||(a=!0,"production"!==e.env.NODE_ENV&&u(!1,"%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)",n))};r.isReactWarning=!0,Object.defineProperty(t,"ref",{get:r,configurable:!0})}var r,a,i=n(11),o=n(14),u=n(3),c=n(13),s=Object.prototype.hasOwnProperty,f=n(31),l={key:!0,ref:!0,__self:!0,__source:!0},h=function(t,n,r,a,i,o,u){var s={$$typeof:f,type:t,key:n,ref:r,props:u,_owner:o};return"production"!==e.env.NODE_ENV&&(s._store={},c?(Object.defineProperty(s._store,"validated",{configurable:!1,enumerable:!1,writable:!0,value:!1}),Object.defineProperty(s,"_self",{configurable:!1,enumerable:!1,writable:!1,value:a}),Object.defineProperty(s,"_source",{configurable:!1,enumerable:!1,writable:!1,value:i})):(s._store.validated=!1,s._self=a,s._source=i),Object.freeze&&(Object.freeze(s.props),Object.freeze(s))),s};h.createElement=function(t,n,r){var a,i={},u=null,c=null,d=null,p=null;if(null!=n){hasValidRef(n)&&(c=n.ref),hasValidKey(n)&&(u=""+n.key),d=void 0===n.__self?null:n.__self,p=void 0===n.__source?null:n.__source;for(a in n)s.call(n,a)&&!l.hasOwnProperty(a)&&(i[a]=n[a])}var b=arguments.length-2;if(1===b)i.children=r;else if(b>1){for(var v=Array(b),m=0;m<b;m++)v[m]=arguments[m+2];"production"!==e.env.NODE_ENV&&Object.freeze&&Object.freeze(v),i.children=v}if(t&&t.defaultProps){var y=t.defaultProps;for(a in y)void 0===i[a]&&(i[a]=y[a])}if("production"!==e.env.NODE_ENV&&(u||c)&&(void 0===i.$$typeof||i.$$typeof!==f)){var g="function"==typeof t?t.displayName||t.name||"Unknown":t;u&&defineKeyPropWarningGetter(i,g),c&&defineRefPropWarningGetter(i,g)}return h(t,u,c,d,p,o.current,i)},h.createFactory=function(t){var e=h.createElement.bind(null,t);return e.type=t,e},h.cloneAndReplaceKey=function(t,e){return h(t.type,e,t.ref,t._self,t._source,t._owner,t.props)},h.cloneElement=function(t,e,n){var r,a=i({},t.props),u=t.key,c=t.ref,f=t._self,d=t._source,p=t._owner;if(null!=e){hasValidRef(e)&&(c=e.ref,p=o.current),hasValidKey(e)&&(u=""+e.key);var b;t.type&&t.type.defaultProps&&(b=t.type.defaultProps);for(r in e)s.call(e,r)&&!l.hasOwnProperty(r)&&(void 0===e[r]&&void 0!==b?a[r]=b[r]:a[r]=e[r])}var v=arguments.length-2;if(1===v)a.children=n;else if(v>1){for(var m=Array(v),y=0;y<v;y++)m[y]=arguments[y+2];a.children=m}return h(t.type,u,c,f,d,p,a)},h.isValidElement=function(t){return"object"==typeof t&&null!==t&&t.$$typeof===f},t.exports=h}).call(e,n(0))},function(t,e,n){(function(e){if("production"!==e.env.NODE_ENV){var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,a=function(t){return"object"==typeof t&&null!==t&&t.$$typeof===r};t.exports=n(34)(a,!0)}else t.exports=n(59)()}).call(e,n(0))},function(t,e,n){"use strict";function reactProdInvariant(t){for(var e=arguments.length-1,n="Minified React error #"+t+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+t,r=0;r<e;r++)n+="&args[]="+encodeURIComponent(arguments[r+1]);n+=" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";var a=new Error(n);throw a.name="Invariant Violation",a.framesToPop=1,a}t.exports=reactProdInvariant},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(21);n.d(e,"creator",function(){return r.a});var a=n(62);n.d(e,"local",function(){return a.a});var i=n(35);n.d(e,"matcher",function(){return i.a});var o=n(63);n.d(e,"mouse",function(){return o.a});var u=n(22);n.d(e,"namespace",function(){return u.a});var c=n(23);n.d(e,"namespaces",function(){return c.a});var s=n(15);n.d(e,"clientPoint",function(){return s.a});var f=n(64);n.d(e,"select",function(){return f.a});var l=n(92);n.d(e,"selectAll",function(){return l.a});var h=n(1);n.d(e,"selection",function(){return h.b});var d=n(26);n.d(e,"selector",function(){return d.a});var p=n(36);n.d(e,"selectorAll",function(){return p.a});var b=n(39);n.d(e,"style",function(){return b.b});var v=n(93);n.d(e,"touch",function(){return v.a});var m=n(94);n.d(e,"touches",function(){return m.a});var y=n(27);n.d(e,"window",function(){return y.a});var g=n(25);n.d(e,"event",function(){return g.c}),n.d(e,"customEvent",function(){return g.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.validateData=e.validateContainer=e.validateConfiguration=void 0;var r=n(40),a=function(t){return-1===r.britechartsCustomEvents.indexOf(t)};e.validateConfiguration=function(t,e){var n=Object.keys(e),r=n.filter(a),i=Object.keys(t.prototype.constructor),o=r.filter(function(t){return!i.includes(t)});if(o.length)throw new Error("Method not supported by Britechart: "+o.join(" "))},e.validateContainer=function(t){if(t.empty())throw Error("A root container is required")},e.validateData=function(t){}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.applyConfiguration=void 0;var r=n(40),a=function(t){return-1!==r.britechartsCustomEvents.indexOf(t)},i=function(t){return!a(t)},o=function(t,e,n){e[n]&&t[n](e[n])},u=function(t,e,n){e[n]&&t.on(n,e[n])};e.applyConfiguration=function(t,e){var n=Object.keys(e);return n.filter(i).forEach(o.bind(null,t,e)),n.filter(a).forEach(u.bind(null,t,e)),t}},function(t,e,n){"use strict";function toObject(t){if(null===t||void 0===t)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(t)}var r=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable;t.exports=function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},n=0;n<10;n++)e["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(e).map(function(t){return e[t]}).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach(function(t){r[t]=t}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(t){return!1}}()?Object.assign:function(t,e){for(var n,o,u=toObject(t),c=1;c<arguments.length;c++){n=Object(arguments[c]);for(var s in n)a.call(n,s)&&(u[s]=n[s]);if(r){o=r(n);for(var f=0;f<o.length;f++)i.call(n,o[f])&&(u[o[f]]=n[o[f]])}}return u}},function(t,e,n){"use strict";function makeEmptyFunction(t){return function(){return t}}var r=function(){};r.thatReturns=makeEmptyFunction,r.thatReturnsFalse=makeEmptyFunction(!1),r.thatReturnsTrue=makeEmptyFunction(!0),r.thatReturnsNull=makeEmptyFunction(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(t){return t},t.exports=r},function(t,e,n){"use strict";(function(e){var n=!1;if("production"!==e.env.NODE_ENV)try{Object.defineProperty({},"x",{get:function(){}}),n=!0}catch(t){}t.exports=n}).call(e,n(0))},function(t,e,n){"use strict";var r={current:null};t.exports=r},function(t,e,n){"use strict";e.a=function(t,e){var n=t.ownerSVGElement||t;if(n.createSVGPoint){var r=n.createSVGPoint();return r.x=e.clientX,r.y=e.clientY,r=r.matrixTransform(t.getScreenCTM().inverse()),[r.x,r.y]}var a=t.getBoundingClientRect();return[e.clientX-a.left-t.clientLeft,e.clientY-a.top-t.clientTop]}},function(t,e,n){!function(e,n){t.exports=n()}(0,function(){return function(t){function __webpack_require__(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,__webpack_require__),r.l=!0,r.exports}var e={};return __webpack_require__.m=t,__webpack_require__.c=e,__webpack_require__.d=function(t,e,n){__webpack_require__.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},__webpack_require__.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return __webpack_require__.d(e,"a",e),e},__webpack_require__.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=317)}({238:function(t,e,n){"use strict";var r;void 0!==(r=function(){return{bar:'\n            <svg class="load-state bar-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 325">\n              \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(0 29)">\n                        <g stroke="#EFF2F5" stroke-dasharray="4 4">\n                            <path d="M.400592911 200.302477L710.674315 200.302477M.400592884 131.172748L710.674315 131.172748M.324410282 64.2071321L710.621499 64.2071321M.291004517.563888874L709.82431.563888889"/>\n                        </g>\n                        <g fill="#D2D6DF" transform="translate(63.08 11)">\n                            <polygon points="-.08 176 23.92 176 23.92 255 -.08 255"/>\n                            <polygon points="50.829 147 74.829 147 74.829 255 50.829 255"/>\n                            <polygon points="254.465 0 278.465 0 278.465 255 254.465 255"/>\n                            <polygon points="458.102 169 482.102 169 482.102 255 458.102 255"/>\n                            <polygon points="152.647 82 176.647 82 176.647 255 152.647 255"/>\n                            <polygon points="356.283 66 380.283 66 380.283 255 356.283 255"/>\n                            <polygon points="559.92 229 583.92 229 583.92 255 559.92 255"/>\n                            <polygon points="101.738 115 125.738 115 125.738 255 101.738 255"/>\n                            <polygon points="305.374 42 329.374 42 329.374 255 305.374 255"/>\n                            <polygon points="509.011 201 533.011 201 533.011 255 509.011 255"/>\n                            <polygon points="203.556 19 227.556 19 227.556 255 203.556 255"/>\n                            <polygon points="407.192 115 431.192 115 431.192 255 407.192 255"/>\n                        </g>\n                    </g>\n                    <polygon fill="#D2D6DF" fill-rule="nonzero" points="0 295 711 295 711 294 0 294"/>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',donut:'\n            <svg class="load-state donut-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 376 331">\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(116 107)">\n                        <circle cx="72" cy="72" r="72" stroke="#EFF2F5" stroke-linecap="round" stroke-width="9.6"/>\n                        <path stroke="#D2D6DF" stroke-width="19.2" d="M126.153559,119.524055 C137.264629,106.845712 144,90.2321371 144,72.0444604 C144,32.2554036 111.764502,0 72,0"/>\n                        <circle cx="72" cy="72" r="67.2" fill="#FFF"/>\n                    </g>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',line:'\n            <svg \n                class="load-state line-load-state" \n                xmlns="http://www.w3.org/2000/svg" \n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path \n                    id="chart-bg" \n                    class="chart-bg" \n                    style="stroke:#C3C6CF;" \n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n               <polyline \n                    id="chart-line" \n                    class="chart-line" \n                    style="stroke:#C3C6CF;stroke-width:4;fill:none;" \n                    points="8.8,175.8 62.4,237.7 116.1,184.7 169.7,175.8 223.3,57 277,176.8 330.6,176.8 384.3,122.5 437.9,176.8 491.6,176.8 545.2,218.4 598.8,122.5 652.5,184.7 706.1,135.1 "\n                />\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        '}}.call(e,n,e,t))&&(t.exports=r)},317:function(t,e,n){t.exports=n(238)}})})},function(t,e,n){"use strict";function _interopRequireDefault(t){return t&&t.__esModule?t:{default:t}}function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.loadingContainerWrapper=void 0;var r=function(){function defineProperties(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(t,e,n){return e&&defineProperties(t.prototype,e),n&&defineProperties(t,n),t}}(),a=n(4),i=_interopRequireDefault(a),o=n(6),u=_interopRequireDefault(o),c=(e.loadingContainerWrapper=function(t,e,n){var r=t.data,a=t.height,o=t.shouldShowLoadingState,u=t.width;return o&&(n=i.default.createElement(c,{data:r,height:a,loadingState:e,shouldShowLoadingState:o,width:u},n)),n},function(t){function LoadingContainer(){return _classCallCheck(this,LoadingContainer),_possibleConstructorReturn(this,(LoadingContainer.__proto__||Object.getPrototypeOf(LoadingContainer)).apply(this,arguments))}return _inherits(LoadingContainer,t),r(LoadingContainer,[{key:"render",value:function(){var t=this.props,e=t.children,n=t.height,r=t.loadingState,a=t.shouldShowLoadingState,o=t.width,u={};a&&(u.display="none");var c=i.default.createElement("div",{className:"loading-container__svg-container",dangerouslySetInnerHTML:{__html:r},style:{width:o||"100%",height:n||"100%"}});return i.default.createElement("div",null,a&&c,i.default.createElement("div",{className:"loading-container__children",style:u},e))}}]),LoadingContainer}(a.PureComponent));c.propTypes={children:u.default.element,data:u.default.oneOfType([u.default.object,u.default.array]),loadingState:u.default.string},e.default=c},function(t,e,n){"use strict";(function(e){var n=function(){};if("production"!==e.env.NODE_ENV){var r=function(t){for(var e=arguments.length,n=Array(e>1?e-1:0),r=1;r<e;r++)n[r-1]=arguments[r];var a=0,i="Warning: "+t.replace(/%s/g,function(){return n[a++]});try{throw new Error(i)}catch(t){}};n=function(t,e){if(void 0===e)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(!t){for(var n=arguments.length,a=Array(n>2?n-2:0),i=2;i<n;i++)a[i-2]=arguments[i];r.apply(void 0,[e].concat(a))}}}t.exports=n}).call(e,n(0))},function(t,e,n){"use strict";(function(e){function isNative(t){var e=Function.prototype.toString,n=Object.prototype.hasOwnProperty,r=RegExp("^"+e.call(n).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");try{var a=e.call(t);return r.test(a)}catch(t){return!1}}function purgeDeep(t){var e=a(t);if(e){var n=e.childIDs;i(t),n.forEach(purgeDeep)}}function describeComponentFrame(t,e,n){return"\n    in "+(t||"Unknown")+(e?" (at "+e.fileName.replace(/^.*[\\\/]/,"")+":"+e.lineNumber+")":n?" (created by "+n+")":"")}function getDisplayName(t){return null==t?"#empty":"string"==typeof t||"number"==typeof t?"#text":"string"==typeof t.type?t.type:t.type.displayName||t.type.name||"Unknown"}function describeID(t){var n,r=w.getDisplayName(t),a=w.getElement(t),i=w.getOwnerID(t);return i&&(n=w.getDisplayName(i)),"production"!==e.env.NODE_ENV&&d(a,"ReactComponentTreeHook: Missing React element for debugID %s when building stack",t),describeComponentFrame(r,a&&a._source,n)}var r,a,i,o,u,c,s,f=n(7),l=n(14),h=n(2),d=n(3),p="function"==typeof Array.from&&"function"==typeof Map&&isNative(Map)&&null!=Map.prototype&&"function"==typeof Map.prototype.keys&&isNative(Map.prototype.keys)&&"function"==typeof Set&&isNative(Set)&&null!=Set.prototype&&"function"==typeof Set.prototype.keys&&isNative(Set.prototype.keys);if(p){var b=new Map,v=new Set;r=function(t,e){b.set(t,e)},a=function(t){return b.get(t)},i=function(t){b.delete(t)},o=function(){return Array.from(b.keys())},u=function(t){v.add(t)},c=function(t){v.delete(t)},s=function(){return Array.from(v.keys())}}else{var m={},y={},g=function(t){return"."+t},_=function(t){return parseInt(t.substr(1),10)};r=function(t,e){var n=g(t);m[n]=e},a=function(t){var e=g(t);return m[e]},i=function(t){var e=g(t);delete m[e]},o=function(){return Object.keys(m).map(_)},u=function(t){var e=g(t);y[e]=!0},c=function(t){var e=g(t);delete y[e]},s=function(){return Object.keys(y).map(_)}}var x=[],w={onSetChildren:function(t,n){var r=a(t);r||("production"!==e.env.NODE_ENV?h(!1,"Item must have been set"):f("144")),r.childIDs=n;for(var i=0;i<n.length;i++){var o=n[i],u=a(o);u||("production"!==e.env.NODE_ENV?h(!1,"Expected hook events to fire for the child before its parent includes it in onSetChildren()."):f("140")),null==u.childIDs&&"object"==typeof u.element&&null!=u.element&&("production"!==e.env.NODE_ENV?h(!1,"Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren()."):f("141")),u.isMounted||("production"!==e.env.NODE_ENV?h(!1,"Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren()."):f("71")),null==u.parentID&&(u.parentID=t),u.parentID!==t&&("production"!==e.env.NODE_ENV?h(!1,"Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).",o,u.parentID,t):f("142",o,u.parentID,t))}},onBeforeMountComponent:function(t,e,n){r(t,{element:e,parentID:n,text:null,childIDs:[],isMounted:!1,updateCount:0})},onBeforeUpdateComponent:function(t,e){var n=a(t);n&&n.isMounted&&(n.element=e)},onMountComponent:function(t){var n=a(t);n||("production"!==e.env.NODE_ENV?h(!1,"Item must have been set"):f("144")),n.isMounted=!0,0===n.parentID&&u(t)},onUpdateComponent:function(t){var e=a(t);e&&e.isMounted&&e.updateCount++},onUnmountComponent:function(t){var e=a(t);if(e){e.isMounted=!1;0===e.parentID&&c(t)}x.push(t)},purgeUnmountedComponents:function(){if(!w._preventPurging){for(var t=0;t<x.length;t++){purgeDeep(x[t])}x.length=0}},isMounted:function(t){var e=a(t);return!!e&&e.isMounted},getCurrentStackAddendum:function(t){var e="";if(t){var n=getDisplayName(t),r=t._owner;e+=describeComponentFrame(n,t._source,r&&r.getName())}var a=l.current,i=a&&a._debugID;return e+=w.getStackAddendumByID(i)},getStackAddendumByID:function(t){for(var e="";t;)e+=describeID(t),t=w.getParentID(t);return e},getChildIDs:function(t){var e=a(t);return e?e.childIDs:[]},getDisplayName:function(t){var e=w.getElement(t);return e?getDisplayName(e):null},getElement:function(t){var e=a(t);return e?e.element:null},getOwnerID:function(t){var e=w.getElement(t);return e&&e._owner?e._owner._debugID:null},getParentID:function(t){var e=a(t);return e?e.parentID:null},getSource:function(t){var e=a(t),n=e?e.element:null;return null!=n?n._source:null},getText:function(t){var e=w.getElement(t);return"string"==typeof e?e:"number"==typeof e?""+e:null},getUpdateCount:function(t){var e=a(t);return e?e.updateCount:0},getRootIDs:s,getRegisteredIDs:o,pushNonStandardWarningStack:function(t,e){if("function"==typeof console.reactStack){var n=[],r=l.current,a=r&&r._debugID;try{for(t&&n.push({name:a?w.getDisplayName(a):null,fileName:e?e.fileName:null,lineNumber:e?e.lineNumber:null});a;){var i=w.getElement(a),o=w.getParentID(a),u=w.getOwnerID(a),c=u?w.getDisplayName(u):null,s=i&&i._source;n.push({name:c,fileName:s?s.fileName:null,lineNumber:s?s.lineNumber:null}),a=o}}catch(t){}}},popNonStandardWarningStack:function(){console.reactStackEnd}};t.exports=w}).call(e,n(0))},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){"use strict";function creatorInherit(t){return function(){var e=this.ownerDocument,n=this.namespaceURI;return n===a.b&&e.documentElement.namespaceURI===a.b?e.createElement(t):e.createElementNS(n,t)}}function creatorFixed(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}var r=n(22),a=n(23);e.a=function(t){var e=Object(r.a)(t);return(e.local?creatorFixed:creatorInherit)(e)}},function(t,e,n){"use strict";var r=n(23);e.a=function(t){var e=t+="",n=e.indexOf(":");return n>=0&&"xmlns"!==(e=t.slice(0,n))&&(t=t.slice(n+1)),r.a.hasOwnProperty(e)?{space:r.a[e],local:t}:t}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r="http://www.w3.org/1999/xhtml";e.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,e,n){"use strict";var r=n(25);e.a=function(){for(var t,e=r.c;t=e.sourceEvent;)e=t;return e}},function(t,e,n){"use strict";function filterContextListener(t,e,n){return t=contextListener(t,e,n),function(e){var n=e.relatedTarget;n&&(n===this||8&n.compareDocumentPosition(this))||t.call(this,e)}}function contextListener(t,e,n){return function(r){var i=a;a=r;try{t.call(this,this.__data__,e,n)}finally{a=i}}}function parseTypenames(t){return t.trim().split(/^|\s+/).map(function(t){var e="",n=t.indexOf(".");return n>=0&&(e=t.slice(n+1),t=t.slice(0,n)),{type:t,name:e}})}function onRemove(t){return function(){var e=this.__on;if(e){for(var n,r=0,a=-1,i=e.length;r<i;++r)n=e[r],t.type&&n.type!==t.type||n.name!==t.name?e[++a]=n:this.removeEventListener(n.type,n.listener,n.capture);++a?e.length=a:delete this.__on}}}function onAdd(t,e,n){var a=r.hasOwnProperty(t.type)?filterContextListener:contextListener;return function(r,i,o){var u,c=this.__on,s=a(e,i,o);if(c)for(var f=0,l=c.length;f<l;++f)if((u=c[f]).type===t.type&&u.name===t.name)return this.removeEventListener(u.type,u.listener,u.capture),this.addEventListener(u.type,u.listener=s,u.capture=n),void(u.value=e);this.addEventListener(t.type,s,n),u={type:t.type,name:t.name,value:e,listener:s,capture:n},c?c.push(u):this.__on=[u]}}function customEvent(t,e,n,r){var i=a;t.sourceEvent=a,a=t;try{return e.apply(n,r)}finally{a=i}}n.d(e,"c",function(){return a}),e.a=customEvent;var r={},a=null;if("undefined"!=typeof document){"onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"})}e.b=function(t,e,n){var r,a,i=parseTypenames(t+""),o=i.length;{if(!(arguments.length<2)){for(u=e?onAdd:onRemove,null==n&&(n=!1),r=0;r<o;++r)this.each(u(i[r],e,n));return this}var u=this.node().__on;if(u)for(var c,s=0,f=u.length;s<f;++s)for(r=0,c=u[s];r<o;++r)if((a=i[r]).type===c.type&&a.name===c.name)return c.value}}},function(t,e,n){"use strict";function none(){}e.a=function(t){return null==t?none:function(){return this.querySelector(t)}}},function(t,e,n){"use strict";e.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,e,n){"use strict";(function(e){function ReactComponent(t,e,n){this.props=t,this.context=e,this.refs=u,this.updater=n||i}function ReactPureComponent(t,e,n){this.props=t,this.context=e,this.refs=u,this.updater=n||i}function ComponentDummy(){}var r=n(7),a=n(11),i=n(29),o=n(13),u=n(30),c=n(2),s=n(18);if(ReactComponent.prototype.isReactComponent={},ReactComponent.prototype.setState=function(t,n){"object"!=typeof t&&"function"!=typeof t&&null!=t&&("production"!==e.env.NODE_ENV?c(!1,"setState(...): takes an object of state variables to update or a function which returns an object of state variables."):r("85")),this.updater.enqueueSetState(this,t),n&&this.updater.enqueueCallback(this,n,"setState")},ReactComponent.prototype.forceUpdate=function(t){this.updater.enqueueForceUpdate(this),t&&this.updater.enqueueCallback(this,t,"forceUpdate")},"production"!==e.env.NODE_ENV){var f={isMounted:["isMounted","Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],replaceState:["replaceState","Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]};for(var l in f)f.hasOwnProperty(l)&&function(t,e){o&&Object.defineProperty(ReactComponent.prototype,t,{get:function(){s(!1,"%s(...) is deprecated in plain JavaScript React classes. %s",e[0],e[1])}})}(l,f[l])}ComponentDummy.prototype=ReactComponent.prototype,ReactPureComponent.prototype=new ComponentDummy,ReactPureComponent.prototype.constructor=ReactPureComponent,a(ReactPureComponent.prototype,ReactComponent.prototype),ReactPureComponent.prototype.isPureReactComponent=!0,t.exports={Component:ReactComponent,PureComponent:ReactPureComponent}}).call(e,n(0))},function(t,e,n){"use strict";(function(e){function warnNoop(t,n){if("production"!==e.env.NODE_ENV){var a=t.constructor;"production"!==e.env.NODE_ENV&&r(!1,"%s(...): Can only update a mounted or mounting component. This usually means you called %s() on an unmounted component. This is a no-op. Please check the code for the %s component.",n,n,a&&(a.displayName||a.name)||"ReactClass")}}var r=n(3),a={isMounted:function(t){return!1},enqueueCallback:function(t,e){},enqueueForceUpdate:function(t){warnNoop(t,"forceUpdate")},enqueueReplaceState:function(t,e){warnNoop(t,"replaceState")},enqueueSetState:function(t,e){warnNoop(t,"setState")}};t.exports=a}).call(e,n(0))},function(t,e,n){"use strict";(function(e){var n={};"production"!==e.env.NODE_ENV&&Object.freeze(n),t.exports=n}).call(e,n(0))},function(t,e,n){"use strict";var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;t.exports=r},function(t,e,n){"use strict";function getIteratorFn(t){var e=t&&(r&&t[r]||t[a]);if("function"==typeof e)return e}var r="function"==typeof Symbol&&Symbol.iterator,a="@@iterator";t.exports=getIteratorFn},function(t,e,n){"use strict";(function(e){function getDeclarationErrorAddendum(){if(r.current){var t=r.current.getName();if(t)return" Check the render method of `"+t+"`."}return""}function getSourceInfoErrorAddendum(t){if(null!==t&&void 0!==t&&void 0!==t.__source){var e=t.__source;return" Check your code at "+e.fileName.replace(/^.*[\\\/]/,"")+":"+e.lineNumber+"."}return""}function getCurrentComponentErrorInfo(t){var e=getDeclarationErrorAddendum();if(!e){var n="string"==typeof t?t:t.displayName||t.name;n&&(e=" Check the top-level render call using <"+n+">.")}return e}function validateExplicitKey(t,n){if(t._store&&!t._store.validated&&null==t.key){t._store.validated=!0;var i=l.uniqueKey||(l.uniqueKey={}),o=getCurrentComponentErrorInfo(n);if(!i[o]){i[o]=!0;var u="";t&&t._owner&&t._owner!==r.current&&(u=" It was passed a child from "+t._owner.getName()+"."),"production"!==e.env.NODE_ENV&&s(!1,'Each child in an array or iterator should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.%s',o,u,a.getCurrentStackAddendum(t))}}}function validateChildKeys(t,e){if("object"==typeof t)if(Array.isArray(t))for(var n=0;n<t.length;n++){var r=t[n];i.isValidElement(r)&&validateExplicitKey(r,e)}else if(i.isValidElement(t))t._store&&(t._store.validated=!0);else if(t){var a=c(t);if(a&&a!==t.entries)for(var o,u=a.call(t);!(o=u.next()).done;)i.isValidElement(o.value)&&validateExplicitKey(o.value,e)}}function validatePropTypes(t){var n=t.type;if("function"==typeof n){var r=n.displayName||n.name;n.propTypes&&o(n.propTypes,t.props,"prop",r,t,null),"function"==typeof n.getDefaultProps&&"production"!==e.env.NODE_ENV&&s(n.getDefaultProps.isReactClassApproved,"getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.")}}var r=n(14),a=n(19),i=n(5),o=n(49),u=n(13),c=n(32),s=n(3),f=n(18),l={},h={createElement:function(t,n,r){var o="string"==typeof t||"function"==typeof t;if(!o&&"function"!=typeof t&&"string"!=typeof t){var u="";(void 0===t||"object"==typeof t&&null!==t&&0===Object.keys(t).length)&&(u+=" You likely forgot to export your component from the file it's defined in.");var c=getSourceInfoErrorAddendum(n);u+=c||getDeclarationErrorAddendum(),u+=a.getCurrentStackAddendum();var f=null!==n&&void 0!==n&&void 0!==n.__source?n.__source:null;a.pushNonStandardWarningStack(!0,f),"production"!==e.env.NODE_ENV&&s(!1,"React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",null==t?t:typeof t,u),a.popNonStandardWarningStack()}var l=i.createElement.apply(this,arguments);if(null==l)return l;if(o)for(var h=2;h<arguments.length;h++)validateChildKeys(arguments[h],t);return validatePropTypes(l),l},createFactory:function(t){var n=h.createElement.bind(null,t);return n.type=t,"production"!==e.env.NODE_ENV&&u&&Object.defineProperty(n,"type",{enumerable:!1,get:function(){return f(!1,"Factory.type is deprecated. Access the class directly before passing it to createFactory."),Object.defineProperty(this,"type",{value:t}),t}}),n},cloneElement:function(t,e,n){for(var r=i.cloneElement.apply(this,arguments),a=2;a<arguments.length;a++)validateChildKeys(arguments[a],r.type);return validatePropTypes(r),r}};t.exports=h}).call(e,n(0))},function(t,e,n){"use strict";(function(e){var r=n(12),a=n(2),i=n(3),o=n(11),u=n(20),c=n(54);t.exports=function(t,n){function getIteratorFn(t){var e=t&&(s&&t[s]||t[f]);if("function"==typeof e)return e}function is(t,e){return t===e?0!==t||1/t==1/e:t!==t&&e!==e}function PropTypeError(t){this.message=t,this.stack=""}function createChainableTypeChecker(t){function checkType(c,s,f,h,d,p,b){if(h=h||l,p=p||f,b!==u)if(n)a(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if("production"!==e.env.NODE_ENV&&"undefined"!=typeof console){var v=h+":"+f;!r[v]&&o<3&&(i(!1,"You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",p,h),r[v]=!0,o++)}return null==s[f]?c?new PropTypeError(null===s[f]?"The "+d+" `"+p+"` is marked as required in `"+h+"`, but its value is `null`.":"The "+d+" `"+p+"` is marked as required in `"+h+"`, but its value is `undefined`."):null:t(s,f,h,d,p)}if("production"!==e.env.NODE_ENV)var r={},o=0;var c=checkType.bind(null,!1);return c.isRequired=checkType.bind(null,!0),c}function createPrimitiveTypeChecker(t){function validate(e,n,r,a,i,o){var u=e[n];if(getPropType(u)!==t)return new PropTypeError("Invalid "+a+" `"+i+"` of type `"+getPreciseType(u)+"` supplied to `"+r+"`, expected `"+t+"`.");return null}return createChainableTypeChecker(validate)}function createArrayOfTypeChecker(t){function validate(e,n,r,a,i){if("function"!=typeof t)return new PropTypeError("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var o=e[n];if(!Array.isArray(o)){return new PropTypeError("Invalid "+a+" `"+i+"` of type `"+getPropType(o)+"` supplied to `"+r+"`, expected an array.")}for(var c=0;c<o.length;c++){var s=t(o,c,r,a,i+"["+c+"]",u);if(s instanceof Error)return s}return null}return createChainableTypeChecker(validate)}function createInstanceTypeChecker(t){function validate(e,n,r,a,i){if(!(e[n]instanceof t)){var o=t.name||l;return new PropTypeError("Invalid "+a+" `"+i+"` of type `"+getClassName(e[n])+"` supplied to `"+r+"`, expected instance of `"+o+"`.")}return null}return createChainableTypeChecker(validate)}function createEnumTypeChecker(t){function validate(e,n,r,a,i){for(var o=e[n],u=0;u<t.length;u++)if(is(o,t[u]))return null;return new PropTypeError("Invalid "+a+" `"+i+"` of value `"+o+"` supplied to `"+r+"`, expected one of "+JSON.stringify(t)+".")}return Array.isArray(t)?createChainableTypeChecker(validate):("production"!==e.env.NODE_ENV&&i(!1,"Invalid argument supplied to oneOf, expected an instance of array."),r.thatReturnsNull)}function createObjectOfTypeChecker(t){function validate(e,n,r,a,i){if("function"!=typeof t)return new PropTypeError("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var o=e[n],c=getPropType(o);if("object"!==c)return new PropTypeError("Invalid "+a+" `"+i+"` of type `"+c+"` supplied to `"+r+"`, expected an object.");for(var s in o)if(o.hasOwnProperty(s)){var f=t(o,s,r,a,i+"."+s,u);if(f instanceof Error)return f}return null}return createChainableTypeChecker(validate)}function createUnionTypeChecker(t){function validate(e,n,r,a,i){for(var o=0;o<t.length;o++){if(null==(0,t[o])(e,n,r,a,i,u))return null}return new PropTypeError("Invalid "+a+" `"+i+"` supplied to `"+r+"`.")}if(!Array.isArray(t))return"production"!==e.env.NODE_ENV&&i(!1,"Invalid argument supplied to oneOfType, expected an instance of array."),r.thatReturnsNull;for(var n=0;n<t.length;n++){var a=t[n];if("function"!=typeof a)return i(!1,"Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",getPostfixForTypeWarning(a),n),r.thatReturnsNull}return createChainableTypeChecker(validate)}function createShapeTypeChecker(t){function validate(e,n,r,a,i){var o=e[n],c=getPropType(o);if("object"!==c)return new PropTypeError("Invalid "+a+" `"+i+"` of type `"+c+"` supplied to `"+r+"`, expected `object`.");for(var s in t){var f=t[s];if(f){var l=f(o,s,r,a,i+"."+s,u);if(l)return l}}return null}return createChainableTypeChecker(validate)}function createStrictShapeTypeChecker(t){function validate(e,n,r,a,i){var c=e[n],s=getPropType(c);if("object"!==s)return new PropTypeError("Invalid "+a+" `"+i+"` of type `"+s+"` supplied to `"+r+"`, expected `object`.");var f=o({},e[n],t);for(var l in f){var h=t[l];if(!h)return new PropTypeError("Invalid "+a+" `"+i+"` key `"+l+"` supplied to `"+r+"`.\nBad object: "+JSON.stringify(e[n],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(t),null,"  "));var d=h(c,l,r,a,i+"."+l,u);if(d)return d}return null}return createChainableTypeChecker(validate)}function isNode(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(isNode);if(null===e||t(e))return!0;var n=getIteratorFn(e);if(!n)return!1;var r,a=n.call(e);if(n!==e.entries){for(;!(r=a.next()).done;)if(!isNode(r.value))return!1}else for(;!(r=a.next()).done;){var i=r.value;if(i&&!isNode(i[1]))return!1}return!0;default:return!1}}function isSymbol(t,e){return"symbol"===t||("Symbol"===e["@@toStringTag"]||"function"==typeof Symbol&&e instanceof Symbol)}function getPropType(t){var e=typeof t;return Array.isArray(t)?"array":t instanceof RegExp?"object":isSymbol(e,t)?"symbol":e}function getPreciseType(t){if(void 0===t||null===t)return""+t;var e=getPropType(t);if("object"===e){if(t instanceof Date)return"date";if(t instanceof RegExp)return"regexp"}return e}function getPostfixForTypeWarning(t){var e=getPreciseType(t);switch(e){case"array":case"object":return"an "+e;case"boolean":case"date":case"regexp":return"a "+e;default:return e}}function getClassName(t){return t.constructor&&t.constructor.name?t.constructor.name:l}var s="function"==typeof Symbol&&Symbol.iterator,f="@@iterator",l="<<anonymous>>",h={array:createPrimitiveTypeChecker("array"),bool:createPrimitiveTypeChecker("boolean"),func:createPrimitiveTypeChecker("function"),number:createPrimitiveTypeChecker("number"),object:createPrimitiveTypeChecker("object"),string:createPrimitiveTypeChecker("string"),symbol:createPrimitiveTypeChecker("symbol"),any:function(){return createChainableTypeChecker(r.thatReturnsNull)}(),arrayOf:createArrayOfTypeChecker,element:function(){function validate(e,n,r,a,i){var o=e[n];if(!t(o)){return new PropTypeError("Invalid "+a+" `"+i+"` of type `"+getPropType(o)+"` supplied to `"+r+"`, expected a single ReactElement.")}return null}return createChainableTypeChecker(validate)}(),instanceOf:createInstanceTypeChecker,node:function(){function validate(t,e,n,r,a){return isNode(t[e])?null:new PropTypeError("Invalid "+r+" `"+a+"` supplied to `"+n+"`, expected a ReactNode.")}return createChainableTypeChecker(validate)}(),objectOf:createObjectOfTypeChecker,oneOf:createEnumTypeChecker,oneOfType:createUnionTypeChecker,shape:createShapeTypeChecker,exact:createStrictShapeTypeChecker};return PropTypeError.prototype=Error.prototype,h.checkPropTypes=c,h.PropTypes=h,h}}).call(e,n(0))},function(t,e,n){"use strict";var r=function(t){return function(){return this.matches(t)}};if("undefined"!=typeof document){var a=document.documentElement;if(!a.matches){var i=a.webkitMatchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector;r=function(t){return function(){return i.call(this,t)}}}}e.a=r},function(t,e,n){"use strict";function empty(){return[]}e.a=function(t){return null==t?empty:function(){return this.querySelectorAll(t)}}},function(t,e,n){"use strict";function EnterNode(t,e){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=e}e.a=EnterNode;var r=n(38),a=n(1);e.b=function(){return new a.a(this._enter||this._groups.map(r.a),this._parents)},EnterNode.prototype={constructor:EnterNode,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,e){return this._parent.insertBefore(t,e)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}}},function(t,e,n){"use strict";e.a=function(t){return new Array(t.length)}},function(t,e,n){"use strict";function styleRemove(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){return function(){this.style.setProperty(t,e,n)}}function styleFunction(t,e,n){return function(){var r=e.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,n)}}function styleValue(t,e){return t.style.getPropertyValue(e)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(e)}e.b=styleValue;var r=n(27);e.a=function(t,e,n){return arguments.length>1?this.each((null==e?styleRemove:"function"==typeof e?styleFunction:styleConstant)(t,e,null==n?"":n)):styleValue(this.node(),t)}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.britechartsCustomEvents=["customMouseOver","customMouseMove","customMouseOut"]},function(t,e,n){"use strict";function _interopRequireDefault(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var r=n(42);Object.defineProperty(e,"Bar",{enumerable:!0,get:function(){return _interopRequireDefault(r).default}});var a=n(95);Object.defineProperty(e,"Donut",{enumerable:!0,get:function(){return _interopRequireDefault(a).default}});var i=n(98);Object.defineProperty(e,"Legend",{enumerable:!0,get:function(){return _interopRequireDefault(i).default}});var o=n(101);Object.defineProperty(e,"Line",{enumerable:!0,get:function(){return _interopRequireDefault(o).default}});var u=n(104);Object.defineProperty(e,"StackedArea",{enumerable:!0,get:function(){return _interopRequireDefault(u).default}});var c=n(107);Object.defineProperty(e,"Tooltip",{enumerable:!0,get:function(){return _interopRequireDefault(c).default}})},function(t,e,n){"use strict";function _interopRequireDefault(t){return t&&t.__esModule?t:{default:t}}function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},a=function(){function defineProperties(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(t,e,n){return e&&defineProperties(t.prototype,e),n&&defineProperties(t,n),t}}(),i=n(4),o=_interopRequireDefault(i),u=n(6),c=_interopRequireDefault(u),s=n(60),f=_interopRequireDefault(s),l=n(17),h=function(t){function Bar(){return _classCallCheck(this,Bar),_possibleConstructorReturn(this,(Bar.__proto__||Object.getPrototypeOf(Bar)).apply(this,arguments))}return _inherits(Bar,t),a(Bar,[{key:"componentDidMount",value:function(){this.props.shouldShowLoadingState||this._createChart()}},{key:"componentDidUpdate",value:function(){this.props.shouldShowLoadingState||(this._chart?(this._updateChart(),this.props.createTooltip()):this._createChart())}},{key:"componentWillUnmount",value:function(){this.props.chart.destroy(this._rootNode)}},{key:"_createChart",value:function(){this._chart=this.props.chart.create(this._rootNode,this.props.data,this._getChartConfiguration())}},{key:"_updateChart",value:function(){this.props.chart.update(this._rootNode,this.props.data,this._getChartConfiguration(),this._chart)}},{key:"_getChartConfiguration",value:function(){var t=r({},this.props);return delete t.data,delete t.chart,delete t.createTooltip,delete t.shouldShowLoadingState,t}},{key:"_setRef",value:function(t){this._rootNode=t}},{key:"render",value:function(){return(0,l.loadingContainerWrapper)(this.props,this.props.loadingState||this.props.chart.loading(),o.default.createElement("div",{className:"bar-container",ref:this._setRef.bind(this)}))}}]),Bar}(i.Component);h.propTypes={data:c.default.arrayOf(c.default.any),betweenBarsPadding:c.default.number,colorSchema:c.default.arrayOf(c.default.string),enablePercentageLabels:c.default.bool,hasPercentage:c.default.bool,height:c.default.number,isAnimated:c.default.bool,isHorizontal:c.default.bool,locale:c.default.string,margin:c.default.shape({top:c.default.number,bottom:c.default.number,left:c.default.number,right:c.default.number}),nameLabel:c.default.number,numberFormat:c.default.string,orderingFunction:c.default.func,percentageAxisToMaxRatio:c.default.number,percentageLabelMargin:c.default.number,shouldReverseColorList:c.default.bool,shouldShowLoadingState:c.default.bool,tooltipThreshold:c.default.number,usePercentage:c.default.bool,valueLabel:c.default.number,width:c.default.number,yAxisPaddingBetweenChart:c.default.number,xTicks:c.default.number,yTicks:c.default.number,customMouseOver:c.default.func,customMouseMove:c.default.func,customMouseOut:c.default.func,chart:c.default.object},h.defaultProps={chart:f.default,createTooltip:function(){return null},shouldShowLoadingState:!1},e.default=h},function(t,e,n){"use strict";(function(e){var r=n(11),a=n(28),i=n(44),o=n(48),u=n(5),c=n(52),s=n(55),f=n(56),l=n(58),h=u.createElement,d=u.createFactory,p=u.cloneElement;if("production"!==e.env.NODE_ENV){var b=n(18),v=n(13),m=n(33),y=!1;h=m.createElement,d=m.createFactory,p=m.cloneElement}var g=r,_=function(t){return t};if("production"!==e.env.NODE_ENV){var x=!1,w=!1;g=function(){return b(x,"React.__spread is deprecated and should not be used. Use Object.assign directly or another helper function with similar semantics. You may be seeing this warning due to your compiler. See https://fb.me/react-spread-deprecation for more details."),x=!0,r.apply(null,arguments)},_=function(t){return b(w,"React.createMixin is deprecated and should not be used. In React v16.0, it will be removed. You can use this mixin directly instead. See https://fb.me/createmixin-was-never-implemented for more info."),w=!0,t}}var O={Children:{map:i.map,forEach:i.forEach,count:i.count,toArray:i.toArray,only:l},Component:a.Component,PureComponent:a.PureComponent,createElement:h,cloneElement:p,isValidElement:u.isValidElement,PropTypes:c,createClass:f,createFactory:d,createMixin:_,DOM:o,version:s,__spread:g};if("production"!==e.env.NODE_ENV){var M=!1;v&&(Object.defineProperty(O,"PropTypes",{get:function(){return b(y,"Accessing PropTypes via the main React package is deprecated, and will be removed in  React v16.0. Use the latest available v15.* prop-types package from npm instead. For info on usage, compatibility, migration and more, see https://fb.me/prop-types-docs"),y=!0,c}}),Object.defineProperty(O,"createClass",{get:function(){return b(M,"Accessing createClass via the main React package is deprecated, and will be removed in React v16.0. Use a plain JavaScript class instead. If you're not yet ready to migrate, create-react-class v15.* is available on npm as a temporary, drop-in replacement. For more info see https://fb.me/react-create-class"),M=!0,f}})),O.DOM={};var C=!1;Object.keys(o).forEach(function(t){O.DOM[t]=function(){return C||(b(!1,"Accessing factories like React.DOM.%s has been deprecated and will be removed in v16.0+. Use the react-dom-factories package instead.  Version 1.0 provides a drop-in replacement. For more info, see https://fb.me/react-dom-factories",t),C=!0),o[t].apply(o,arguments)}})}t.exports=O}).call(e,n(0))},function(t,e,n){"use strict";function escapeUserProvidedKey(t){return(""+t).replace(s,"$&/")}function ForEachBookKeeping(t,e){this.func=t,this.context=e,this.count=0}function forEachSingleChild(t,e,n){var r=t.func,a=t.context;r.call(a,e,t.count++)}function forEachChildren(t,e,n){if(null==t)return t;var r=ForEachBookKeeping.getPooled(e,n);o(t,forEachSingleChild,r),ForEachBookKeeping.release(r)}function MapBookKeeping(t,e,n,r){this.result=t,this.keyPrefix=e,this.func=n,this.context=r,this.count=0}function mapSingleChildIntoContext(t,e,n){var r=t.result,o=t.keyPrefix,u=t.func,c=t.context,s=u.call(c,e,t.count++);Array.isArray(s)?mapIntoWithKeyPrefixInternal(s,r,n,i.thatReturnsArgument):null!=s&&(a.isValidElement(s)&&(s=a.cloneAndReplaceKey(s,o+(!s.key||e&&e.key===s.key?"":escapeUserProvidedKey(s.key)+"/")+n)),r.push(s))}function mapIntoWithKeyPrefixInternal(t,e,n,r,a){var i="";null!=n&&(i=escapeUserProvidedKey(n)+"/");var u=MapBookKeeping.getPooled(e,i,r,a);o(t,mapSingleChildIntoContext,u),MapBookKeeping.release(u)}function mapChildren(t,e,n){if(null==t)return t;var r=[];return mapIntoWithKeyPrefixInternal(t,r,null,e,n),r}function forEachSingleChildDummy(t,e,n){return null}function countChildren(t,e){return o(t,forEachSingleChildDummy,null)}function toArray(t){var e=[];return mapIntoWithKeyPrefixInternal(t,e,null,i.thatReturnsArgument),e}var r=n(45),a=n(5),i=n(12),o=n(46),u=r.twoArgumentPooler,c=r.fourArgumentPooler,s=/\/+/g;ForEachBookKeeping.prototype.destructor=function(){this.func=null,this.context=null,this.count=0},r.addPoolingTo(ForEachBookKeeping,u),MapBookKeeping.prototype.destructor=function(){this.result=null,this.keyPrefix=null,this.func=null,this.context=null,this.count=0},r.addPoolingTo(MapBookKeeping,c);var f={forEach:forEachChildren,map:mapChildren,mapIntoWithKeyPrefixInternal:mapIntoWithKeyPrefixInternal,count:countChildren,toArray:toArray};t.exports=f},function(t,e,n){"use strict";(function(e){var r=n(7),a=n(2),i=function(t){var e=this;if(e.instancePool.length){var n=e.instancePool.pop();return e.call(n,t),n}return new e(t)},o=function(t,e){var n=this;if(n.instancePool.length){var r=n.instancePool.pop();return n.call(r,t,e),r}return new n(t,e)},u=function(t,e,n){var r=this;if(r.instancePool.length){var a=r.instancePool.pop();return r.call(a,t,e,n),a}return new r(t,e,n)},c=function(t,e,n,r){var a=this;if(a.instancePool.length){var i=a.instancePool.pop();return a.call(i,t,e,n,r),i}return new a(t,e,n,r)},s=function(t){var n=this;t instanceof n||("production"!==e.env.NODE_ENV?a(!1,"Trying to release an instance into a pool of a different type."):r("25")),t.destructor(),n.instancePool.length<n.poolSize&&n.instancePool.push(t)},f=i,l=function(t,e){var n=t;return n.instancePool=[],n.getPooled=e||f,n.poolSize||(n.poolSize=10),n.release=s,n},h={addPoolingTo:l,oneArgumentPooler:i,twoArgumentPooler:o,threeArgumentPooler:u,fourArgumentPooler:c};t.exports=h}).call(e,n(0))},function(t,e,n){"use strict";(function(e){function getComponentKey(t,e){return t&&"object"==typeof t&&null!=t.key?c.escape(t.key):e.toString(36)}function traverseAllChildrenImpl(t,n,d,p){var b=typeof t;if("undefined"!==b&&"boolean"!==b||(t=null),null===t||"string"===b||"number"===b||"object"===b&&t.$$typeof===i)return d(p,t,""===n?f+getComponentKey(t,0):n),1;var v,m,y=0,g=""===n?f:n+l;if(Array.isArray(t))for(var _=0;_<t.length;_++)v=t[_],m=g+getComponentKey(v,_),y+=traverseAllChildrenImpl(v,m,d,p);else{var x=o(t);if(x){var w,O=x.call(t);if(x!==t.entries)for(var M=0;!(w=O.next()).done;)v=w.value,m=g+getComponentKey(v,M++),y+=traverseAllChildrenImpl(v,m,d,p);else{if("production"!==e.env.NODE_ENV){var C="";if(a.current){var j=a.current.getName();j&&(C=" Check the render method of `"+j+"`.")}"production"!==e.env.NODE_ENV&&s(h,"Using Maps as children is not yet fully supported. It is an experimental feature that might be removed. Convert it to a sequence / iterable of keyed ReactElements instead.%s",C),h=!0}for(;!(w=O.next()).done;){var T=w.value;T&&(v=T[1],m=g+c.escape(T[0])+l+getComponentKey(v,0),y+=traverseAllChildrenImpl(v,m,d,p))}}}else if("object"===b){var k="";if("production"!==e.env.NODE_ENV&&(k=" If you meant to render a collection of children, use an array instead or wrap the object using createFragment(object) from the React add-ons.",t._isReactElement&&(k=" It looks like you're using an element created by a different version of React. Make sure to use only one copy of React."),a.current)){var S=a.current.getName();S&&(k+=" Check the render method of `"+S+"`.")}var N=String(t);"production"!==e.env.NODE_ENV?u(!1,"Objects are not valid as a React child (found: %s).%s","[object Object]"===N?"object with keys {"+Object.keys(t).join(", ")+"}":N,k):r("31","[object Object]"===N?"object with keys {"+Object.keys(t).join(", ")+"}":N,k)}}return y}function traverseAllChildren(t,e,n){return null==t?0:traverseAllChildrenImpl(t,"",e,n)}var r=n(7),a=n(14),i=n(31),o=n(32),u=n(2),c=n(47),s=n(3),f=".",l=":",h=!1;t.exports=traverseAllChildren}).call(e,n(0))},function(t,e,n){"use strict";function escape(t){var e={"=":"=0",":":"=2"};return"$"+(""+t).replace(/[=:]/g,function(t){return e[t]})}function unescape(t){var e=/(=0|=2)/g,n={"=0":"=","=2":":"};return(""+("."===t[0]&&"$"===t[1]?t.substring(2):t.substring(1))).replace(e,function(t){return n[t]})}var r={escape:escape,unescape:unescape};t.exports=r},function(t,e,n){"use strict";(function(e){var r=n(5),a=r.createFactory;if("production"!==e.env.NODE_ENV){a=n(33).createFactory}var i={a:a("a"),abbr:a("abbr"),address:a("address"),area:a("area"),article:a("article"),aside:a("aside"),audio:a("audio"),b:a("b"),base:a("base"),bdi:a("bdi"),bdo:a("bdo"),big:a("big"),blockquote:a("blockquote"),body:a("body"),br:a("br"),button:a("button"),canvas:a("canvas"),caption:a("caption"),cite:a("cite"),code:a("code"),col:a("col"),colgroup:a("colgroup"),data:a("data"),datalist:a("datalist"),dd:a("dd"),del:a("del"),details:a("details"),dfn:a("dfn"),dialog:a("dialog"),div:a("div"),dl:a("dl"),dt:a("dt"),em:a("em"),embed:a("embed"),fieldset:a("fieldset"),figcaption:a("figcaption"),figure:a("figure"),footer:a("footer"),form:a("form"),h1:a("h1"),h2:a("h2"),h3:a("h3"),h4:a("h4"),h5:a("h5"),h6:a("h6"),head:a("head"),header:a("header"),hgroup:a("hgroup"),hr:a("hr"),html:a("html"),i:a("i"),iframe:a("iframe"),img:a("img"),input:a("input"),ins:a("ins"),kbd:a("kbd"),keygen:a("keygen"),label:a("label"),legend:a("legend"),li:a("li"),link:a("link"),main:a("main"),map:a("map"),mark:a("mark"),menu:a("menu"),menuitem:a("menuitem"),meta:a("meta"),meter:a("meter"),nav:a("nav"),noscript:a("noscript"),object:a("object"),ol:a("ol"),optgroup:a("optgroup"),option:a("option"),output:a("output"),p:a("p"),param:a("param"),picture:a("picture"),pre:a("pre"),progress:a("progress"),q:a("q"),rp:a("rp"),rt:a("rt"),ruby:a("ruby"),s:a("s"),samp:a("samp"),script:a("script"),section:a("section"),select:a("select"),small:a("small"),source:a("source"),span:a("span"),strong:a("strong"),style:a("style"),sub:a("sub"),summary:a("summary"),sup:a("sup"),table:a("table"),tbody:a("tbody"),td:a("td"),textarea:a("textarea"),tfoot:a("tfoot"),th:a("th"),thead:a("thead"),time:a("time"),title:a("title"),tr:a("tr"),track:a("track"),u:a("u"),ul:a("ul"),var:a("var"),video:a("video"),wbr:a("wbr"),circle:a("circle"),clipPath:a("clipPath"),defs:a("defs"),ellipse:a("ellipse"),g:a("g"),image:a("image"),line:a("line"),linearGradient:a("linearGradient"),mask:a("mask"),path:a("path"),pattern:a("pattern"),polygon:a("polygon"),polyline:a("polyline"),radialGradient:a("radialGradient"),rect:a("rect"),stop:a("stop"),svg:a("svg"),text:a("text"),tspan:a("tspan")};t.exports=i}).call(e,n(0))},function(t,e,n){"use strict";(function(e){function checkReactTypeSpec(t,f,l,h,d,p){for(var b in t)if(t.hasOwnProperty(b)){var v;try{"function"!=typeof t[b]&&("production"!==e.env.NODE_ENV?u(!1,"%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.",h||"React class",i[l],b):a("84",h||"React class",i[l],b)),v=t[b](f,b,h,l,null,o)}catch(t){v=t}if("production"!==e.env.NODE_ENV&&c(!v||v instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",h||"React class",i[l],b,typeof v),v instanceof Error&&!(v.message in s)){s[v.message]=!0;var m="";"production"!==e.env.NODE_ENV&&(r||(r=n(19)),null!==p?m=r.getStackAddendumByID(p):null!==d&&(m=r.getCurrentStackAddendum(d))),"production"!==e.env.NODE_ENV&&c(!1,"Failed %s type: %s%s",l,v.message,m)}}}var r,a=n(7),i=n(50),o=n(51),u=n(2),c=n(3);void 0!==e&&e.env&&"test"===e.env.NODE_ENV&&(r=n(19));var s={};t.exports=checkReactTypeSpec}).call(e,n(0))},function(t,e,n){"use strict";(function(e){var n={};"production"!==e.env.NODE_ENV&&(n={prop:"prop",context:"context",childContext:"child context"}),t.exports=n}).call(e,n(0))},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){"use strict";var r=n(5),a=r.isValidElement,i=n(53);t.exports=i(a)},function(t,e,n){"use strict";var r=n(34);t.exports=function(t){return r(t,!1)}},function(t,e,n){"use strict";(function(e){function checkPropTypes(t,n,u,c,s){if("production"!==e.env.NODE_ENV)for(var f in t)if(t.hasOwnProperty(f)){var l;try{r("function"==typeof t[f],"%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.",c||"React class",u,f,typeof t[f]),l=t[f](n,f,c,u,null,i)}catch(t){l=t}if(a(!l||l instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",c||"React class",u,f,typeof l),l instanceof Error&&!(l.message in o)){o[l.message]=!0;var h=s?s():"";a(!1,"Failed %s type: %s%s",u,l.message,null!=h?h:"")}}}if("production"!==e.env.NODE_ENV)var r=n(2),a=n(3),i=n(20),o={};t.exports=checkPropTypes}).call(e,n(0))},function(t,e,n){"use strict";t.exports="15.6.2"},function(t,e,n){"use strict";var r=n(28),a=r.Component,i=n(5),o=i.isValidElement,u=n(29),c=n(57);t.exports=c(a,o,u)},function(t,e,n){"use strict";(function(e){function identity(t){return t}function factory(t,n,s){function validateTypeDef(t,n,r){for(var a in n)n.hasOwnProperty(a)&&"production"!==e.env.NODE_ENV&&o("function"==typeof n[a],"%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.",t.displayName||"ReactClass",u[r],a)}function validateMethodOverride(t,e){var n=l.hasOwnProperty(e)?l[e]:null;b.hasOwnProperty(e)&&i("OVERRIDE_BASE"===n,"ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",e),t&&i("DEFINE_MANY"===n||"DEFINE_MANY_MERGED"===n,"ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",e)}function mixSpecIntoComponent(t,r){if(r){i("function"!=typeof r,"ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."),i(!n(r),"ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");var a=t.prototype,u=a.__reactAutoBindPairs;r.hasOwnProperty(c)&&h.mixins(t,r.mixins);for(var s in r)if(r.hasOwnProperty(s)&&s!==c){var f=r[s],d=a.hasOwnProperty(s);if(validateMethodOverride(d,s),h.hasOwnProperty(s))h[s](t,f);else{var p=l.hasOwnProperty(s),b="function"==typeof f,v=b&&!p&&!d&&!1!==r.autobind;if(v)u.push(s,f),a[s]=f;else if(d){var m=l[s];i(p&&("DEFINE_MANY_MERGED"===m||"DEFINE_MANY"===m),"ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",m,s),"DEFINE_MANY_MERGED"===m?a[s]=createMergedResultFunction(a[s],f):"DEFINE_MANY"===m&&(a[s]=createChainedFunction(a[s],f))}else a[s]=f,"production"!==e.env.NODE_ENV&&"function"==typeof f&&r.displayName&&(a[s].displayName=r.displayName+"_"+s)}}}else if("production"!==e.env.NODE_ENV){var y=typeof r,g="object"===y&&null!==r;"production"!==e.env.NODE_ENV&&o(g,"%s: You're attempting to include a mixin that is either null or not an object. Check the mixins included by the component, as well as any mixins they include themselves. Expected object but got %s.",t.displayName||"ReactClass",null===r?null:y)}}function mixStaticSpecIntoComponent(t,e){if(e)for(var n in e){var r=e[n];if(e.hasOwnProperty(n)){var a=n in h;i(!a,'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',n);var o=n in t;i(!o,"ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",n),t[n]=r}}}function mergeIntoWithNoDuplicateKeys(t,e){i(t&&e&&"object"==typeof t&&"object"==typeof e,"mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.");for(var n in e)e.hasOwnProperty(n)&&(i(void 0===t[n],"mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",n),t[n]=e[n]);return t}function createMergedResultFunction(t,e){return function(){var n=t.apply(this,arguments),r=e.apply(this,arguments);if(null==n)return r;if(null==r)return n;var a={};return mergeIntoWithNoDuplicateKeys(a,n),mergeIntoWithNoDuplicateKeys(a,r),a}}function createChainedFunction(t,e){return function(){t.apply(this,arguments),e.apply(this,arguments)}}function bindAutoBindMethod(t,n){var r=n.bind(t);if("production"!==e.env.NODE_ENV){r.__reactBoundContext=t,r.__reactBoundMethod=n,r.__reactBoundArguments=null;var a=t.constructor.displayName,i=r.bind;r.bind=function(u){for(var c=arguments.length,s=Array(c>1?c-1:0),f=1;f<c;f++)s[f-1]=arguments[f];if(u!==t&&null!==u)"production"!==e.env.NODE_ENV&&o(!1,"bind(): React component methods may only be bound to the component instance. See %s",a);else if(!s.length)return"production"!==e.env.NODE_ENV&&o(!1,"bind(): You are binding a component method to the component. React does this for you automatically in a high-performance way, so you can safely remove this call. See %s",a),r;var l=i.apply(r,arguments);return l.__reactBoundContext=t,l.__reactBoundMethod=n,l.__reactBoundArguments=s,l}}return r}function bindAutoBindMethods(t){for(var e=t.__reactAutoBindPairs,n=0;n<e.length;n+=2){var r=e[n],a=e[n+1];t[r]=bindAutoBindMethod(t,a)}}function createClass(t){var n=identity(function(t,r,u){"production"!==e.env.NODE_ENV&&o(this instanceof n,"Something is calling a React component directly. Use a factory or JSX instead. See: https://fb.me/react-legacyfactory"),this.__reactAutoBindPairs.length&&bindAutoBindMethods(this),this.props=t,this.context=r,this.refs=a,this.updater=u||s,this.state=null;var c=this.getInitialState?this.getInitialState():null;"production"!==e.env.NODE_ENV&&void 0===c&&this.getInitialState._isMockFunction&&(c=null),i("object"==typeof c&&!Array.isArray(c),"%s.getInitialState(): must return an object or null",n.displayName||"ReactCompositeComponent"),this.state=c});n.prototype=new v,n.prototype.constructor=n,n.prototype.__reactAutoBindPairs=[],f.forEach(mixSpecIntoComponent.bind(null,n)),mixSpecIntoComponent(n,d),mixSpecIntoComponent(n,t),mixSpecIntoComponent(n,p),n.getDefaultProps&&(n.defaultProps=n.getDefaultProps()),"production"!==e.env.NODE_ENV&&(n.getDefaultProps&&(n.getDefaultProps.isReactClassApproved={}),n.prototype.getInitialState&&(n.prototype.getInitialState.isReactClassApproved={})),i(n.prototype.render,"createClass(...): Class specification must implement a `render` method."),"production"!==e.env.NODE_ENV&&(o(!n.prototype.componentShouldUpdate,"%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",t.displayName||"A component"),o(!n.prototype.componentWillRecieveProps,"%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",t.displayName||"A component"));for(var r in l)n.prototype[r]||(n.prototype[r]=null);return n}var f=[],l={mixins:"DEFINE_MANY",statics:"DEFINE_MANY",propTypes:"DEFINE_MANY",contextTypes:"DEFINE_MANY",childContextTypes:"DEFINE_MANY",getDefaultProps:"DEFINE_MANY_MERGED",getInitialState:"DEFINE_MANY_MERGED",getChildContext:"DEFINE_MANY_MERGED",render:"DEFINE_ONCE",componentWillMount:"DEFINE_MANY",componentDidMount:"DEFINE_MANY",componentWillReceiveProps:"DEFINE_MANY",shouldComponentUpdate:"DEFINE_ONCE",componentWillUpdate:"DEFINE_MANY",componentDidUpdate:"DEFINE_MANY",componentWillUnmount:"DEFINE_MANY",updateComponent:"OVERRIDE_BASE"},h={displayName:function(t,e){t.displayName=e},mixins:function(t,e){if(e)for(var n=0;n<e.length;n++)mixSpecIntoComponent(t,e[n])},childContextTypes:function(t,n){"production"!==e.env.NODE_ENV&&validateTypeDef(t,n,"childContext"),t.childContextTypes=r({},t.childContextTypes,n)},contextTypes:function(t,n){"production"!==e.env.NODE_ENV&&validateTypeDef(t,n,"context"),t.contextTypes=r({},t.contextTypes,n)},getDefaultProps:function(t,e){t.getDefaultProps?t.getDefaultProps=createMergedResultFunction(t.getDefaultProps,e):t.getDefaultProps=e},propTypes:function(t,n){"production"!==e.env.NODE_ENV&&validateTypeDef(t,n,"prop"),t.propTypes=r({},t.propTypes,n)},statics:function(t,e){mixStaticSpecIntoComponent(t,e)},autobind:function(){}},d={componentDidMount:function(){this.__isMounted=!0}},p={componentWillUnmount:function(){this.__isMounted=!1}},b={replaceState:function(t,e){this.updater.enqueueReplaceState(this,t,e)},isMounted:function(){return"production"!==e.env.NODE_ENV&&(o(this.__didWarnIsMounted,"%s: isMounted is deprecated. Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks.",this.constructor&&this.constructor.displayName||this.name||"Component"),this.__didWarnIsMounted=!0),!!this.__isMounted}},v=function(){};return r(v.prototype,t.prototype,b),createClass}var r=n(11),a=n(30),i=n(2);if("production"!==e.env.NODE_ENV)var o=n(3);var u,c="mixins";u="production"!==e.env.NODE_ENV?{prop:"prop",context:"context",childContext:"child context"}:{},t.exports=factory}).call(e,n(0))},function(t,e,n){"use strict";(function(e){function onlyChild(t){return a.isValidElement(t)||("production"!==e.env.NODE_ENV?i(!1,"React.Children.only expected to receive a single React element child."):r("143")),t}var r=n(7),a=n(5),i=n(2);t.exports=onlyChild}).call(e,n(0))},function(t,e,n){"use strict";var r=n(12),a=n(2),i=n(20);t.exports=function(){function shim(t,e,n,r,o,u){u!==i&&a(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function getShim(){return shim}shim.isRequired=shim;var t={array:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim};return t.checkPropTypes=r,t.PropTypes=t,t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(61),a=function(t){return t&&t.__esModule?t:{default:t}}(r),i=n(8),o=n(9),u=n(10),c=n(16),s={};s.create=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=(0,i.select)(t),c=(0,a.default)();return(0,o.validateData)(e),(0,o.validateContainer)(r),(0,o.validateConfiguration)(c,n),r.datum(e).call((0,u.applyConfiguration)(c,n)),c},s.update=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=arguments[3],a=(0,i.select)(t);return(0,o.validateContainer)(a),(0,o.validateConfiguration)(r,n),(0,u.applyConfiguration)(r,n),e?a.datum(e).call(r):a.call(r),r},s.destroy=function(){},s.loading=function(){return c.bar},e.default=s},function(t,e,n){!function(e,n){t.exports=n()}(0,function(){return function(t){function __webpack_require__(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,__webpack_require__),r.l=!0,r.exports}var e={};return __webpack_require__.m=t,__webpack_require__.c=e,__webpack_require__.d=function(t,e,n){__webpack_require__.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},__webpack_require__.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return __webpack_require__.d(e,"a",e),e},__webpack_require__.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=296)}([function(t,e,n){"use strict";function newInterval(t,e,n,i){function interval(e){return t(e=new Date(+e)),e}return interval.floor=interval,interval.ceil=function(n){return t(n=new Date(n-1)),e(n,1),t(n),n},interval.round=function(t){var e=interval(t),n=interval.ceil(t);return t-e<n-t?e:n},interval.offset=function(t,n){return e(t=new Date(+t),null==n?1:Math.floor(n)),t},interval.range=function(n,r,a){var i=[];if(n=interval.ceil(n),a=null==a?1:Math.floor(a),!(n<r&&a>0))return i;do{i.push(new Date(+n))}while(e(n,a),t(n),n<r);return i},interval.filter=function(n){return newInterval(function(e){if(e>=e)for(;t(e),!n(e);)e.setTime(e-1)},function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;e(t,-1),!n(t););else for(;--r>=0;)for(;e(t,1),!n(t););})},n&&(interval.count=function(e,i){return r.setTime(+e),a.setTime(+i),t(r),t(a),Math.floor(n(r,a))},interval.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?interval.filter(i?function(e){return i(e)%t==0}:function(e){return interval.count(0,e)%t==0}):interval:null}),interval}e.a=newInterval;var r=new Date,a=new Date},function(t,e,n){"use strict";function Selection(t,e){this._groups=t,this._parents=e}function selection(){return new Selection([[document.documentElement]],E)}n.d(e,"c",function(){return E}),e.a=Selection;var r=n(128),a=n(129),i=n(130),o=n(131),u=n(55),c=n(133),s=n(134),f=n(135),l=n(136),h=n(137),d=n(138),p=n(139),b=n(140),v=n(141),m=n(142),y=n(143),g=n(57),_=n(144),x=n(145),w=n(146),O=n(147),M=n(148),C=n(149),j=n(150),T=n(151),k=n(152),S=n(153),N=n(29),A=n(154),E=[null];Selection.prototype=selection.prototype={constructor:Selection,select:r.a,selectAll:a.a,filter:i.a,data:o.a,enter:u.b,exit:c.a,merge:s.a,order:f.a,sort:l.a,call:h.a,nodes:d.a,node:p.a,size:b.a,empty:v.a,each:m.a,attr:y.a,style:g.a,property:_.a,classed:x.a,text:w.a,html:O.a,raise:M.a,lower:C.a,append:j.a,insert:T.a,remove:k.a,datum:S.a,on:N.b,dispatch:A.a},e.b=selection},function(t,e,n){"use strict";function init(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>u)throw new Error("too late");return n}function set(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>s)throw new Error("too late");return n}function get(t,e){var n=t.__transition;if(!n||!(n=n[e]))throw new Error("too late");return n}function create(t,e,n){function schedule(t){n.state=c,n.timer.restart(start,n.delay,n.time),n.delay<=t&&start(t-n.delay)}function start(o){var u,h,p,b;if(n.state!==c)return stop();for(u in i)if(b=i[u],b.name===n.name){if(b.state===f)return Object(a.b)(start);b.state===l?(b.state=d,b.timer.stop(),b.on.call("interrupt",t,t.__data__,b.index,b.group),delete i[u]):+u<e&&(b.state=d,b.timer.stop(),delete i[u])}if(Object(a.b)(function(){n.state===f&&(n.state=l,n.timer.restart(tick,n.delay,n.time),tick(o))}),n.state=s,n.on.call("start",t,t.__data__,n.index,n.group),n.state===s){for(n.state=f,r=new Array(p=n.tween.length),u=0,h=-1;u<p;++u)(b=n.tween[u].value.call(t,t.__data__,n.index,n.group))&&(r[++h]=b);r.length=h+1}}function tick(e){for(var a=e<n.duration?n.ease.call(null,e/n.duration):(n.timer.restart(stop),n.state=h,1),i=-1,o=r.length;++i<o;)r[i].call(null,a);n.state===h&&(n.on.call("end",t,t.__data__,n.index,n.group),stop())}function stop(){n.state=d,n.timer.stop(),delete i[e];for(var r in i)return;delete t.__transition}var r,i=t.__transition;i[e]=n,n.timer=Object(a.c)(schedule,0,n.time)}n.d(e,"c",function(){return c}),n.d(e,"d",function(){return s}),n.d(e,"b",function(){return h}),n.d(e,"a",function(){return d}),e.g=init,e.h=set,e.f=get;var r=n(66),a=n(59),i=Object(r.dispatch)("start","end","interrupt"),o=[],u=0,c=1,s=2,f=3,l=4,h=5,d=6;e.e=function(t,e,n,r,a,c){var s=t.__transition;if(s){if(n in s)return}else t.__transition={};create(t,n,{name:e,index:r,group:a,on:i,tween:o,time:c.time,delay:c.delay,duration:c.duration,ease:c.ease,timer:null,state:u})}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(25);n.d(e,"creator",function(){return r.a});var a=n(125);n.d(e,"local",function(){return a.a});var i=n(53);n.d(e,"matcher",function(){return i.a});var o=n(126);n.d(e,"mouse",function(){return o.a});var u=n(26);n.d(e,"namespace",function(){return u.a});var c=n(27);n.d(e,"namespaces",function(){return c.a});var s=n(127);n.d(e,"select",function(){return s.a});var f=n(155);n.d(e,"selectAll",function(){return f.a});var l=n(1);n.d(e,"selection",function(){return l.b});var h=n(31);n.d(e,"selector",function(){return h.a});var d=n(54);n.d(e,"selectorAll",function(){return d.a});var p=n(57);n.d(e,"style",function(){return p.b});var b=n(156);n.d(e,"touch",function(){return b.a});var v=n(157);n.d(e,"touches",function(){return v.a});var m=n(32);n.d(e,"window",function(){return m.a});var y=n(29);n.d(e,"event",function(){return y.c}),n.d(e,"customEvent",function(){return y.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(19);n.d(e,"color",function(){return r.e}),n.d(e,"rgb",function(){return r.g}),n.d(e,"hsl",function(){return r.f});var a=n(102);n.d(e,"lab",function(){return a.a}),n.d(e,"hcl",function(){return a.b});var i=n(103);n.d(e,"cubehelix",function(){return i.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(67);n.d(e,"bisect",function(){return r.c}),n.d(e,"bisectRight",function(){return r.b}),n.d(e,"bisectLeft",function(){return r.a});var a=n(10);n.d(e,"ascending",function(){return a.a});var i=n(68);n.d(e,"bisector",function(){return i.a});var o=n(184);n.d(e,"cross",function(){return o.a});var u=n(185);n.d(e,"descending",function(){return u.a});var c=n(70);n.d(e,"deviation",function(){return c.a});var s=n(72);n.d(e,"extent",function(){return s.a});var f=n(186);n.d(e,"histogram",function(){return f.a});var l=n(189);n.d(e,"thresholdFreedmanDiaconis",function(){return l.a});var h=n(190);n.d(e,"thresholdScott",function(){return h.a});var d=n(76);n.d(e,"thresholdSturges",function(){return d.a});var p=n(191);n.d(e,"max",function(){return p.a});var b=n(192);n.d(e,"mean",function(){return b.a});var v=n(193);n.d(e,"median",function(){return v.a});var m=n(194);n.d(e,"merge",function(){return m.a});var y=n(77);n.d(e,"min",function(){return y.a});var g=n(69);n.d(e,"pairs",function(){return g.a});var _=n(195);n.d(e,"permute",function(){return _.a});var x=n(36);n.d(e,"quantile",function(){return x.a});var w=n(74);n.d(e,"range",function(){return w.a});var O=n(196);n.d(e,"scan",function(){return O.a});var M=n(197);n.d(e,"shuffle",function(){return M.a});var C=n(198);n.d(e,"sum",function(){return C.a});var j=n(75);n.d(e,"ticks",function(){return j.a}),n.d(e,"tickIncrement",function(){return j.b}),n.d(e,"tickStep",function(){return j.c});var T=n(78);n.d(e,"transpose",function(){return T.a});var k=n(71);n.d(e,"variance",function(){return k.a});var S=n(199);n.d(e,"zip",function(){return S.a})},function(t,e,n){"use strict";n.d(e,"d",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"a",function(){return o}),n.d(e,"e",function(){return u});var r=1e3,a=6e4,i=36e5,o=864e5,u=6048e5},function(t,e,n){"use strict";function Transition(t,e,n,r){this._groups=t,this._parents=e,this._name=n,this._id=r}function transition(t){return Object(r.selection)().transition(t)}function newId(){return++x}e.a=Transition,e.b=transition,e.c=newId;var r=n(3),a=n(163),i=n(164),o=n(165),u=n(166),c=n(167),s=n(168),f=n(169),l=n(170),h=n(171),d=n(172),p=n(173),b=n(174),v=n(175),m=n(176),y=n(177),g=n(178),_=n(17),x=0,w=r.selection.prototype;Transition.prototype=transition.prototype={constructor:Transition,select:d.a,selectAll:p.a,filter:s.a,merge:f.a,selection:b.a,transition:g.a,call:w.call,nodes:w.nodes,node:w.node,size:w.size,empty:w.empty,each:w.each,on:l.a,attr:a.a,attrTween:i.a,style:v.a,styleTween:m.a,text:y.a,remove:h.a,tween:_.a,delay:o.a,duration:u.a,ease:c.a}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(23);n.d(e,"interpolate",function(){return r.a});var a=n(49);n.d(e,"interpolateArray",function(){return a.a});var i=n(24);n.d(e,"interpolateBasis",function(){return i.b});var o=n(47);n.d(e,"interpolateBasisClosed",function(){return o.a});var u=n(50);n.d(e,"interpolateDate",function(){return u.a});var c=n(15);n.d(e,"interpolateNumber",function(){return c.a});var s=n(51);n.d(e,"interpolateObject",function(){return s.a});var f=n(115);n.d(e,"interpolateRound",function(){return f.a});var l=n(52);n.d(e,"interpolateString",function(){return l.a});var h=n(116);n.d(e,"interpolateTransformCss",function(){return h.a}),n.d(e,"interpolateTransformSvg",function(){return h.b});var d=n(119);n.d(e,"interpolateZoom",function(){return d.a});var p=n(46);n.d(e,"interpolateRgb",function(){return p.a}),n.d(e,"interpolateRgbBasis",function(){return p.b}),n.d(e,"interpolateRgbBasisClosed",function(){return p.c});var b=n(120);n.d(e,"interpolateHsl",function(){return b.a}),n.d(e,"interpolateHslLong",function(){return b.b});var v=n(121);n.d(e,"interpolateLab",function(){return v.a});var m=n(122);n.d(e,"interpolateHcl",function(){return m.a}),n.d(e,"interpolateHclLong",function(){return m.b});var y=n(123);n.d(e,"interpolateCubehelix",function(){return y.b}),n.d(e,"interpolateCubehelixLong",function(){return y.a});var g=n(124);n.d(e,"quantize",function(){return g.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"b",function(){return i});var r=Array.prototype,a=r.map,i=r.slice},function(t,e,n){"use strict";e.a=function(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}},function(t,e,n){"use strict";function linear(t,e){return function(n){return t+n*e}}function exponential(t,e,n){return t=Math.pow(t,n),e=Math.pow(e,n)-t,n=1/n,function(r){return Math.pow(t+r*e,n)}}function hue(t,e){var n=e-t;return n?linear(t,n>180||n<-180?n-360*Math.round(n/360):n):Object(r.a)(isNaN(t)?e:t)}function gamma(t){return 1==(t=+t)?nogamma:function(e,n){return n-e?exponential(e,n,t):Object(r.a)(isNaN(e)?n:e)}}function nogamma(t,e){var n=e-t;return n?linear(t,n):Object(r.a)(isNaN(t)?e:t)}e.c=hue,e.b=gamma,e.a=nogamma;var r=n(48)},function(t,e,n){"use strict";e.a=function(t){return null===t?NaN:+t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t){return t=Object(r.a)(Math.abs(t)),t?t[1]:NaN}},function(t,e,n){"use strict";function linearish(t){var e=t.domain;return t.ticks=function(t){var n=e();return Object(r.ticks)(n[0],n[n.length-1],null==t?10:t)},t.tickFormat=function(t,n){return Object(o.a)(e(),t,n)},t.nice=function(n){null==n&&(n=10);var a,i=e(),o=0,u=i.length-1,c=i[o],s=i[u];return s<c&&(a=c,c=s,s=a,a=o,o=u,u=a),a=Object(r.tickIncrement)(c,s,n),a>0?(c=Math.floor(c/a)*a,s=Math.ceil(s/a)*a,a=Object(r.tickIncrement)(c,s,n)):a<0&&(c=Math.ceil(c*a)/a,s=Math.floor(s*a)/a,a=Object(r.tickIncrement)(c,s,n)),a>0?(i[o]=Math.floor(c/a)*a,i[u]=Math.ceil(s/a)*a,e(i)):a<0&&(i[o]=Math.ceil(c*a)/a,i[u]=Math.floor(s*a)/a,e(i)),t},t}function linear(){var t=Object(i.b)(i.c,a.interpolateNumber);return t.copy=function(){return Object(i.a)(t,linear())},linearish(t)}e.b=linearish,e.a=linear;var r=n(5),a=n(8),i=n(18),o=n(223)},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return t+e*n}}},function(t,e,n){"use strict";e.a=function(t){return t.match(/.{6}/g).map(function(t){return"#"+t})}},function(t,e,n){"use strict";function tweenRemove(t,e){var n,a;return function(){var i=Object(r.h)(this,t),o=i.tween;if(o!==n){a=n=o;for(var u=0,c=a.length;u<c;++u)if(a[u].name===e){a=a.slice(),a.splice(u,1);break}}i.tween=a}}function tweenFunction(t,e,n){var a,i;if("function"!=typeof n)throw new Error;return function(){var o=Object(r.h)(this,t),u=o.tween;if(u!==a){i=(a=u).slice();for(var c={name:e,value:n},s=0,f=i.length;s<f;++s)if(i[s].name===e){i[s]=c;break}s===f&&i.push(c)}o.tween=i}}function tweenValue(t,e,n){var a=t._id;return t.each(function(){var t=Object(r.h)(this,a);(t.value||(t.value={}))[e]=n.apply(this,arguments)}),function(t){return Object(r.f)(t,a).value[e]}}e.b=tweenValue;var r=n(2);e.a=function(t,e){var n=this._id;if(t+="",arguments.length<2){for(var a,i=Object(r.f)(this.node(),n).tween,o=0,u=i.length;o<u;++o)if((a=i[o]).name===t)return a.value;return null}return this.each((null==e?tweenRemove:tweenFunction)(n,t,e))}},function(t,e,n){"use strict";function deinterpolateLinear(t,e){return(e-=t=+t)?function(n){return(n-t)/e}:Object(o.a)(e)}function deinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=e?0:t>=n?1:r(t)}}}function reinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=0?e:t>=1?n:r(t)}}}function bimap(t,e,n,r){var a=t[0],i=t[1],o=e[0],u=e[1];return i<a?(a=n(i,a),o=r(u,o)):(a=n(a,i),o=r(o,u)),function(t){return o(a(t))}}function polymap(t,e,n,a){var i=Math.min(t.length,e.length)-1,o=new Array(i),u=new Array(i),c=-1;for(t[i]<t[0]&&(t=t.slice().reverse(),e=e.slice().reverse());++c<i;)o[c]=n(t[c],t[c+1]),u[c]=a(e[c],e[c+1]);return function(e){var n=Object(r.bisect)(t,e,1,i)-1;return u[n](o[n](e))}}function copy(t,e){return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp())}function continuous(t,e){function rescale(){return n=Math.min(s.length,f.length)>2?polymap:bimap,r=o=null,scale}function scale(e){return(r||(r=n(s,f,h?deinterpolateClamp(t):t,l)))(+e)}var n,r,o,s=c,f=c,l=a.interpolate,h=!1;return scale.invert=function(t){return(o||(o=n(f,s,deinterpolateLinear,h?reinterpolateClamp(e):e)))(+t)},scale.domain=function(t){return arguments.length?(s=i.a.call(t,u.a),rescale()):s.slice()},scale.range=function(t){return arguments.length?(f=i.b.call(t),rescale()):f.slice()},scale.rangeRound=function(t){return f=i.b.call(t),l=a.interpolateRound,rescale()},scale.clamp=function(t){return arguments.length?(h=!!t,rescale()):h},scale.interpolate=function(t){return arguments.length?(l=t,rescale()):l},rescale()}e.c=deinterpolateLinear,e.a=copy,e.b=continuous;var r=n(5),a=n(8),i=n(9),o=n(39),u=n(82),c=[0,1]},function(t,e,n){"use strict";function Color(){}function color(t){var e;return t=(t+"").trim().toLowerCase(),(e=s.exec(t))?(e=parseInt(e[1],16),new Rgb(e>>8&15|e>>4&240,e>>4&15|240&e,(15&e)<<4|15&e,1)):(e=f.exec(t))?rgbn(parseInt(e[1],16)):(e=l.exec(t))?new Rgb(e[1],e[2],e[3],1):(e=h.exec(t))?new Rgb(255*e[1]/100,255*e[2]/100,255*e[3]/100,1):(e=d.exec(t))?rgba(e[1],e[2],e[3],e[4]):(e=p.exec(t))?rgba(255*e[1]/100,255*e[2]/100,255*e[3]/100,e[4]):(e=b.exec(t))?hsla(e[1],e[2]/100,e[3]/100,1):(e=v.exec(t))?hsla(e[1],e[2]/100,e[3]/100,e[4]):m.hasOwnProperty(t)?rgbn(m[t]):"transparent"===t?new Rgb(NaN,NaN,NaN,0):null}function rgbn(t){return new Rgb(t>>16&255,t>>8&255,255&t,1)}function rgba(t,e,n,r){return r<=0&&(t=e=n=NaN),new Rgb(t,e,n,r)}function rgbConvert(t){return t instanceof Color||(t=color(t)),t?(t=t.rgb(),new Rgb(t.r,t.g,t.b,t.opacity)):new Rgb}function rgb(t,e,n,r){return 1===arguments.length?rgbConvert(t):new Rgb(t,e,n,null==r?1:r)}function Rgb(t,e,n,r){this.r=+t,this.g=+e,this.b=+n,this.opacity=+r}function hsla(t,e,n,r){return r<=0?t=e=n=NaN:n<=0||n>=1?t=e=NaN:e<=0&&(t=NaN),new Hsl(t,e,n,r)}function hslConvert(t){if(t instanceof Hsl)return new Hsl(t.h,t.s,t.l,t.opacity);if(t instanceof Color||(t=color(t)),!t)return new Hsl;if(t instanceof Hsl)return t;t=t.rgb();var e=t.r/255,n=t.g/255,r=t.b/255,a=Math.min(e,n,r),i=Math.max(e,n,r),o=NaN,u=i-a,c=(i+a)/2;return u?(o=e===i?(n-r)/u+6*(n<r):n===i?(r-e)/u+2:(e-n)/u+4,u/=c<.5?i+a:2-i-a,o*=60):u=c>0&&c<1?0:o,new Hsl(o,u,c,t.opacity)}function hsl(t,e,n,r){return 1===arguments.length?hslConvert(t):new Hsl(t,e,n,null==r?1:r)}function Hsl(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}function hsl2rgb(t,e,n){return 255*(t<60?e+(n-e)*t/60:t<180?n:t<240?e+(n-e)*(240-t)/60:e)}e.a=Color,n.d(e,"d",function(){return a}),n.d(e,"c",function(){return i}),e.e=color,e.h=rgbConvert,e.g=rgb,e.b=Rgb,e.f=hsl;var r=n(20),a=.7,i=1/a,o="\\s*([+-]?\\d+)\\s*",u="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",s=/^#([0-9a-f]{3})$/,f=/^#([0-9a-f]{6})$/,l=new RegExp("^rgb\\("+[o,o,o]+"\\)$"),h=new RegExp("^rgb\\("+[c,c,c]+"\\)$"),d=new RegExp("^rgba\\("+[o,o,o,u]+"\\)$"),p=new RegExp("^rgba\\("+[c,c,c,u]+"\\)$"),b=new RegExp("^hsl\\("+[u,c,c]+"\\)$"),v=new RegExp("^hsla\\("+[u,c,c,u]+"\\)$"),m={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};Object(r.a)(Color,color,{displayable:function(){return this.rgb().displayable()},toString:function(){return this.rgb()+""}}),Object(r.a)(Rgb,rgb,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return 0<=this.r&&this.r<=255&&0<=this.g&&this.g<=255&&0<=this.b&&this.b<=255&&0<=this.opacity&&this.opacity<=1},toString:function(){var t=this.opacity;return t=isNaN(t)?1:Math.max(0,Math.min(1,t)),(1===t?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}})),Object(r.a)(Hsl,hsl,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),e=isNaN(t)||isNaN(this.s)?0:this.s,n=this.l,r=n+(n<.5?n:1-n)*e,a=2*n-r;return new Rgb(hsl2rgb(t>=240?t-240:t+120,a,r),hsl2rgb(t,a,r),hsl2rgb(t<120?t+240:t-120,a,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1}}))},function(t,e,n){"use strict";function extend(t,e){var n=Object.create(t.prototype);for(var r in e)n[r]=e[r];return n}e.b=extend,e.a=function(t,e,n){t.prototype=e.prototype=n,n.constructor=t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(105);n.d(e,"formatDefaultLocale",function(){return r.a}),n.d(e,"format",function(){return r.b}),n.d(e,"formatPrefix",function(){return r.c});var a=n(42);n.d(e,"formatLocale",function(){return a.a});var i=n(43);n.d(e,"formatSpecifier",function(){return i.a});var o=n(111);n.d(e,"precisionFixed",function(){return o.a});var u=n(112);n.d(e,"precisionPrefix",function(){return u.a});var c=n(113);n.d(e,"precisionRound",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){if((n=(t=e?t.toExponential(e-1):t.toExponential()).indexOf("e"))<0)return null;var n,r=t.slice(0,n);return[r.length>1?r[0]+r.slice(2):r,+t.slice(n+1)]}},function(t,e,n){"use strict";var r=n(4),a=n(46),i=n(49),o=n(50),u=n(15),c=n(51),s=n(52),f=n(48);e.a=function(t,e){var n,l=typeof e;return null==e||"boolean"===l?Object(f.a)(e):("number"===l?u.a:"string"===l?(n=Object(r.color)(e))?(e=n,a.a):s.a:e instanceof r.color?a.a:e instanceof Date?o.a:Array.isArray(e)?i.a:"function"!=typeof e.valueOf&&"function"!=typeof e.toString||isNaN(e)?c.a:u.a)(t,e)}},function(t,e,n){"use strict";function basis(t,e,n,r,a){var i=t*t,o=i*t;return((1-3*t+3*i-o)*e+(4-6*i+3*o)*n+(1+3*t+3*i-3*o)*r+o*a)/6}e.a=basis,e.b=function(t){var e=t.length-1;return function(n){var r=n<=0?n=0:n>=1?(n=1,e-1):Math.floor(n*e),a=t[r],i=t[r+1],o=r>0?t[r-1]:2*a-i,u=r<e-1?t[r+2]:2*i-a;return basis((n-r/e)*e,o,a,i,u)}}},function(t,e,n){"use strict";function creatorInherit(t){return function(){var e=this.ownerDocument,n=this.namespaceURI;return n===a.b&&e.documentElement.namespaceURI===a.b?e.createElement(t):e.createElementNS(n,t)}}function creatorFixed(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}var r=n(26),a=n(27);e.a=function(t){var e=Object(r.a)(t);return(e.local?creatorFixed:creatorInherit)(e)}},function(t,e,n){"use strict";var r=n(27);e.a=function(t){var e=t+="",n=e.indexOf(":");return n>=0&&"xmlns"!==(e=t.slice(0,n))&&(t=t.slice(n+1)),r.a.hasOwnProperty(e)?{space:r.a[e],local:t}:t}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r="http://www.w3.org/1999/xhtml";e.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,e,n){"use strict";var r=n(29);e.a=function(){for(var t,e=r.c;t=e.sourceEvent;)e=t;return e}},function(t,e,n){"use strict";function filterContextListener(t,e,n){return t=contextListener(t,e,n),function(e){var n=e.relatedTarget;n&&(n===this||8&n.compareDocumentPosition(this))||t.call(this,e)}}function contextListener(t,e,n){return function(r){var i=a;a=r;try{t.call(this,this.__data__,e,n)}finally{a=i}}}function parseTypenames(t){return t.trim().split(/^|\s+/).map(function(t){var e="",n=t.indexOf(".");return n>=0&&(e=t.slice(n+1),t=t.slice(0,n)),{type:t,name:e}})}function onRemove(t){return function(){var e=this.__on;if(e){for(var n,r=0,a=-1,i=e.length;r<i;++r)n=e[r],t.type&&n.type!==t.type||n.name!==t.name?e[++a]=n:this.removeEventListener(n.type,n.listener,n.capture);++a?e.length=a:delete this.__on}}}function onAdd(t,e,n){var a=r.hasOwnProperty(t.type)?filterContextListener:contextListener;return function(r,i,o){var u,c=this.__on,s=a(e,i,o);if(c)for(var f=0,l=c.length;f<l;++f)if((u=c[f]).type===t.type&&u.name===t.name)return this.removeEventListener(u.type,u.listener,u.capture),this.addEventListener(u.type,u.listener=s,u.capture=n),void(u.value=e);this.addEventListener(t.type,s,n),u={type:t.type,name:t.name,value:e,listener:s,capture:n},c?c.push(u):this.__on=[u]}}function customEvent(t,e,n,r){var i=a;t.sourceEvent=a,a=t;try{return e.apply(n,r)}finally{a=i}}n.d(e,"c",function(){return a}),e.a=customEvent;var r={},a=null;if("undefined"!=typeof document){"onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"})}e.b=function(t,e,n){var r,a,i=parseTypenames(t+""),o=i.length;{if(!(arguments.length<2)){for(u=e?onAdd:onRemove,null==n&&(n=!1),r=0;r<o;++r)this.each(u(i[r],e,n));return this}var u=this.node().__on;if(u)for(var c,s=0,f=u.length;s<f;++s)for(r=0,c=u[s];r<o;++r)if((a=i[r]).type===c.type&&a.name===c.name)return c.value}}},function(t,e,n){"use strict";e.a=function(t,e){var n=t.ownerSVGElement||t;if(n.createSVGPoint){var r=n.createSVGPoint();return r.x=e.clientX,r.y=e.clientY,r=r.matrixTransform(t.getScreenCTM().inverse()),[r.x,r.y]}var a=t.getBoundingClientRect();return[e.clientX-a.left-t.clientLeft,e.clientY-a.top-t.clientTop]}},function(t,e,n){"use strict";function none(){}e.a=function(t){return null==t?none:function(){return this.querySelector(t)}}},function(t,e,n){"use strict";e.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,e,n){"use strict";function now(){return f||(d(clearNow),f=h.now()+l)}function clearNow(){f=0}function Timer(){this._call=this._time=this._next=null}function timer(t,e,n){var r=new Timer;return r.restart(t,e,n),r}function timerFlush(){now(),++i;for(var t,e=r;e;)(t=f-e._time)>=0&&e._call.call(null,t),e=e._next;--i}function wake(){f=(s=h.now())+l,i=o=0;try{timerFlush()}finally{i=0,nap(),f=0}}function poke(){var t=h.now(),e=t-s;e>c&&(l-=e,s=t)}function nap(){for(var t,e,n=r,i=1/0;n;)n._call?(i>n._time&&(i=n._time),t=n,n=n._next):(e=n._next,n._next=null,n=t?t._next=e:r=e);a=t,sleep(i)}function sleep(t){if(!i){o&&(o=clearTimeout(o));var e=t-f;e>24?(t<1/0&&(o=setTimeout(wake,e)),u&&(u=clearInterval(u))):(u||(s=f,u=setInterval(poke,c)),i=1,d(wake))}}e.b=now,e.a=Timer,e.c=timer;var r,a,i=0,o=0,u=0,c=1e3,s=0,f=0,l=0,h="object"==typeof performance&&performance.now?performance:Date,d="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};Timer.prototype=timer.prototype={constructor:Timer,restart:function(t,e,n){if("function"!=typeof t)throw new TypeError("callback is not a function");n=(null==n?now():+n)+(null==e?0:+e),this._next||a===this||(a?a._next=this:r=this,a=this),this._call=t,this._time=n,sleep()},stop:function(){this._call&&(this._call=null,this._time=1/0,sleep())}}},,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(0);n.d(e,"timeInterval",function(){return r.a});var a=n(200);n.d(e,"timeMillisecond",function(){return a.a}),n.d(e,"timeMilliseconds",function(){return a.b}),n.d(e,"utcMillisecond",function(){return a.a}),n.d(e,"utcMilliseconds",function(){return a.b});var i=n(201);n.d(e,"timeSecond",function(){return i.a}),n.d(e,"timeSeconds",function(){return i.b}),n.d(e,"utcSecond",function(){return i.a}),n.d(e,"utcSeconds",function(){return i.b});var o=n(202);n.d(e,"timeMinute",function(){return o.a}),n.d(e,"timeMinutes",function(){return o.b});var u=n(203);n.d(e,"timeHour",function(){return u.a}),n.d(e,"timeHours",function(){return u.b});var c=n(204);n.d(e,"timeDay",function(){return c.b}),n.d(e,"timeDays",function(){return c.a});var s=n(205);n.d(e,"timeWeek",function(){return s.g}),n.d(e,"timeWeeks",function(){return s.h}),n.d(e,"timeSunday",function(){return s.g}),n.d(e,"timeSundays",function(){return s.h}),n.d(e,"timeMonday",function(){return s.c}),n.d(e,"timeMondays",function(){return s.d}),n.d(e,"timeTuesday",function(){return s.k}),n.d(e,"timeTuesdays",function(){return s.l}),n.d(e,"timeWednesday",function(){return s.m}),n.d(e,"timeWednesdays",function(){return s.n}),n.d(e,"timeThursday",function(){return s.i}),n.d(e,"timeThursdays",function(){return s.j}),n.d(e,"timeFriday",function(){return s.a}),n.d(e,"timeFridays",function(){return s.b}),n.d(e,"timeSaturday",function(){return s.e}),n.d(e,"timeSaturdays",function(){return s.f});var f=n(206);n.d(e,"timeMonth",function(){return f.a}),n.d(e,"timeMonths",function(){return f.b});var l=n(207);n.d(e,"timeYear",function(){return l.a}),n.d(e,"timeYears",function(){return l.b});var h=n(208);n.d(e,"utcMinute",function(){return h.a}),n.d(e,"utcMinutes",function(){return h.b});var d=n(209);n.d(e,"utcHour",function(){return d.a}),n.d(e,"utcHours",function(){return d.b});var p=n(210);n.d(e,"utcDay",function(){return p.a}),n.d(e,"utcDays",function(){return p.b});var b=n(211);n.d(e,"utcWeek",function(){return b.g}),n.d(e,"utcWeeks",function(){return b.h}),n.d(e,"utcSunday",function(){return b.g}),n.d(e,"utcSundays",function(){return b.h}),n.d(e,"utcMonday",function(){return b.c}),n.d(e,"utcMondays",function(){return b.d}),n.d(e,"utcTuesday",function(){return b.k}),n.d(e,"utcTuesdays",function(){return b.l}),n.d(e,"utcWednesday",function(){return b.m}),n.d(e,"utcWednesdays",function(){return b.n}),n.d(e,"utcThursday",function(){return b.i}),n.d(e,"utcThursdays",function(){return b.j}),n.d(e,"utcFriday",function(){return b.a}),n.d(e,"utcFridays",function(){return b.b}),n.d(e,"utcSaturday",function(){return b.e}),n.d(e,"utcSaturdays",function(){return b.f});var v=n(212);n.d(e,"utcMonth",function(){return v.a}),n.d(e,"utcMonths",function(){return v.b});var m=n(213);n.d(e,"utcYear",function(){return m.a}),n.d(e,"utcYears",function(){return m.b})},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e,n){if(null==n&&(n=r.a),a=t.length){if((e=+e)<=0||a<2)return+n(t[0],0,t);if(e>=1)return+n(t[a-1],a-1,t);var a,i=(a-1)*e,o=Math.floor(i),u=+n(t[o],o,t);return u+(+n(t[o+1],o+1,t)-u)*(i-o)}}},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(c.a)(t),a=r.format,i=r.parse,o=r.utcFormat,u=r.utcParse,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"d",function(){return o}),n.d(e,"e",function(){return u}),e.a=defaultLocale;var r,a,i,o,u,c=n(79);defaultLocale({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,e,n){"use strict";function Map(){}function map(t,e){var n=new Map;if(t instanceof Map)t.each(function(t,e){n.set(e,t)});else if(Array.isArray(t)){var r,a=-1,i=t.length;if(null==e)for(;++a<i;)n.set(a,t[a]);else for(;++a<i;)n.set(e(r=t[a],a,t),r)}else if(t)for(var o in t)n.set(o,t[o]);return n}n.d(e,"b",function(){return r});var r="$";Map.prototype=map.prototype={constructor:Map,has:function(t){return r+t in this},get:function(t){return this[r+t]},set:function(t,e){return this[r+t]=e,this},remove:function(t){var e=r+t;return e in this&&delete this[e]},clear:function(){for(var t in this)t[0]===r&&delete this[t]},keys:function(){var t=[];for(var e in this)e[0]===r&&t.push(e.slice(1));return t},values:function(){var t=[];for(var e in this)e[0]===r&&t.push(this[e]);return t},entries:function(){var t=[];for(var e in this)e[0]===r&&t.push({key:e.slice(1),value:this[e]});return t},size:function(){var t=0;for(var e in this)e[0]===r&&++t;return t},empty:function(){for(var t in this)if(t[0]===r)return!1;return!0},each:function(t){for(var e in this)e[0]===r&&t(this[e],e.slice(1),this)}},e.a=map},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(37);n.d(e,"timeFormatDefaultLocale",function(){return r.a}),n.d(e,"timeFormat",function(){return r.b}),n.d(e,"timeParse",function(){return r.c}),n.d(e,"utcFormat",function(){return r.d}),n.d(e,"utcParse",function(){return r.e});var a=n(79);n.d(e,"timeFormatLocale",function(){return a.a});var i=n(80);n.d(e,"isoFormat",function(){return i.a});var o=n(214);n.d(e,"isoParse",function(){return o.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"b",function(){return a});var r=Math.PI/180,a=180/Math.PI},function(t,e,n){"use strict";var r=n(13),a=n(106),i=n(107),o=n(43),u=n(44),c=n(45),s=n(110),f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];e.a=function(t){function newFormat(t){function format(t){var n,o,u,s=g,d=_;if("c"===y)d=x(t)+d,t="";else{t=+t;var O=t<0;if(t=x(Math.abs(t),m),O&&0==+t&&(O=!1),s=(O?"("===i?i:"-":"-"===i||"("===i?"":i)+s,d=d+("s"===y?f[8+c.b/3]:"")+(O&&"("===i?")":""),w)for(n=-1,o=t.length;++n<o;)if(48>(u=t.charCodeAt(n))||u>57){d=(46===u?l+t.slice(n+1):t.slice(n))+d,t=t.slice(0,n);break}}v&&!p&&(t=e(t,1/0));var M=s.length+t.length+d.length,C=M<b?new Array(b-M+1).join(r):"";switch(v&&p&&(t=e(C+t,C.length?b-d.length:1/0),C=""),a){case"<":t=s+t+d+C;break;case"=":t=s+C+t+d;break;case"^":t=C.slice(0,M=C.length>>1)+s+t+d+C.slice(M);break;default:t=C+s+t+d}return h(t)}t=Object(o.a)(t);var r=t.fill,a=t.align,i=t.sign,s=t.symbol,p=t.zero,b=t.width,v=t.comma,m=t.precision,y=t.type,g="$"===s?n[0]:"#"===s&&/[boxX]/.test(y)?"0"+y.toLowerCase():"",_="$"===s?n[1]:/[%p]/.test(y)?d:"",x=u.a[y],w=!y||/[defgprs%]/.test(y);return m=null==m?y?6:12:/[gprs]/.test(y)?Math.max(1,Math.min(21,m)):Math.max(0,Math.min(20,m)),format.toString=function(){return t+""},format}function formatPrefix(t,e){var n=newFormat((t=Object(o.a)(t),t.type="f",t)),a=3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3))),i=Math.pow(10,-a),u=f[8+a/3];return function(t){return n(i*t)+u}}var e=t.grouping&&t.thousands?Object(a.a)(t.grouping,t.thousands):s.a,n=t.currency,l=t.decimal,h=t.numerals?Object(i.a)(t.numerals):s.a,d=t.percent||"%";return{format:newFormat,formatPrefix:formatPrefix}}},function(t,e,n){"use strict";function formatSpecifier(t){return new FormatSpecifier(t)}function FormatSpecifier(t){if(!(e=a.exec(t)))throw new Error("invalid format: "+t);var e,n=e[1]||" ",i=e[2]||">",o=e[3]||"-",u=e[4]||"",c=!!e[5],s=e[6]&&+e[6],f=!!e[7],l=e[8]&&+e[8].slice(1),h=e[9]||"";"n"===h?(f=!0,h="g"):r.a[h]||(h=""),(c||"0"===n&&"="===i)&&(c=!0,n="0",i="="),this.fill=n,this.align=i,this.sign=o,this.symbol=u,this.zero=c,this.width=s,this.comma=f,this.precision=l,this.type=h}e.a=formatSpecifier;var r=n(44),a=/^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;formatSpecifier.prototype=FormatSpecifier.prototype,FormatSpecifier.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(null==this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(null==this.precision?"":"."+Math.max(0,0|this.precision))+this.type}},function(t,e,n){"use strict";var r=n(108),a=n(45),i=n(109);e.a={"":r.a,"%":function(t,e){return(100*t).toFixed(e)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,e){return t.toExponential(e)},f:function(t,e){return t.toFixed(e)},g:function(t,e){return t.toPrecision(e)},o:function(t){return Math.round(t).toString(8)},p:function(t,e){return Object(i.a)(100*t,e)},r:i.a,s:a.a,X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r,a=n(22);e.a=function(t,e){var n=Object(a.a)(t,e);if(!n)return t+"";var i=n[0],o=n[1],u=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return u===c?i:u>c?i+new Array(u-c+1).join("0"):u>0?i.slice(0,u)+"."+i.slice(u):"0."+new Array(1-u).join("0")+Object(a.a)(t,Math.max(0,e+u-1))[0]}},function(t,e,n){"use strict";function rgbSpline(t){return function(e){var n,a,i=e.length,o=new Array(i),u=new Array(i),c=new Array(i);for(n=0;n<i;++n)a=Object(r.rgb)(e[n]),o[n]=a.r||0,u[n]=a.g||0,c[n]=a.b||0;return o=t(o),u=t(u),c=t(c),a.opacity=1,function(t){return a.r=o(t),a.g=u(t),a.b=c(t),a+""}}}n.d(e,"b",function(){return u}),n.d(e,"c",function(){return c});var r=n(4),a=n(24),i=n(47),o=n(11);e.a=function rgbGamma(t){function rgb(t,n){var a=e((t=Object(r.rgb)(t)).r,(n=Object(r.rgb)(n)).r),i=e(t.g,n.g),u=e(t.b,n.b),c=Object(o.a)(t.opacity,n.opacity);return function(e){return t.r=a(e),t.g=i(e),t.b=u(e),t.opacity=c(e),t+""}}var e=Object(o.b)(t);return rgb.gamma=rgbGamma,rgb}(1);var u=rgbSpline(a.b),c=rgbSpline(i.a)},function(t,e,n){"use strict";var r=n(24);e.a=function(t){var e=t.length;return function(n){var a=Math.floor(((n%=1)<0?++n:n)*e),i=t[(a+e-1)%e],o=t[a%e],u=t[(a+1)%e],c=t[(a+2)%e];return Object(r.a)((n-a/e)*e,i,o,u,c)}}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a=e?e.length:0,i=t?Math.min(a,t.length):0,o=new Array(a),u=new Array(a);for(n=0;n<i;++n)o[n]=Object(r.a)(t[n],e[n]);for(;n<a;++n)u[n]=e[n];return function(t){for(n=0;n<i;++n)u[n]=o[n](t);return u}}},function(t,e,n){"use strict";e.a=function(t,e){var n=new Date;return t=+t,e-=t,function(r){return n.setTime(t+e*r),n}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a={},i={};null!==t&&"object"==typeof t||(t={}),null!==e&&"object"==typeof e||(e={});for(n in e)n in t?a[n]=Object(r.a)(t[n],e[n]):i[n]=e[n];return function(t){for(n in a)i[n]=a[n](t);return i}}},function(t,e,n){"use strict";function zero(t){return function(){return t}}function one(t){return function(e){return t(e)+""}}var r=n(15),a=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,i=new RegExp(a.source,"g");e.a=function(t,e){var n,o,u,c=a.lastIndex=i.lastIndex=0,s=-1,f=[],l=[];for(t+="",e+="";(n=a.exec(t))&&(o=i.exec(e));)(u=o.index)>c&&(u=e.slice(c,u),f[s]?f[s]+=u:f[++s]=u),(n=n[0])===(o=o[0])?f[s]?f[s]+=o:f[++s]=o:(f[++s]=null,l.push({i:s,x:Object(r.a)(n,o)})),c=i.lastIndex;return c<e.length&&(u=e.slice(c),f[s]?f[s]+=u:f[++s]=u),f.length<2?l[0]?one(l[0].x):zero(e):(e=l.length,function(t){for(var n,r=0;r<e;++r)f[(n=l[r]).i]=n.x(t);return f.join("")})}},function(t,e,n){"use strict";var r=function(t){return function(){return this.matches(t)}};if("undefined"!=typeof document){var a=document.documentElement;if(!a.matches){var i=a.webkitMatchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector;r=function(t){return function(){return i.call(this,t)}}}}e.a=r},function(t,e,n){"use strict";function empty(){return[]}e.a=function(t){return null==t?empty:function(){return this.querySelectorAll(t)}}},function(t,e,n){"use strict";function EnterNode(t,e){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=e}e.a=EnterNode;var r=n(56),a=n(1);e.b=function(){return new a.a(this._enter||this._groups.map(r.a),this._parents)},EnterNode.prototype={constructor:EnterNode,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,e){return this._parent.insertBefore(t,e)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}}},function(t,e,n){"use strict";e.a=function(t){return new Array(t.length)}},function(t,e,n){"use strict";function styleRemove(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){return function(){this.style.setProperty(t,e,n)}}function styleFunction(t,e,n){return function(){var r=e.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,n)}}function styleValue(t,e){return t.style.getPropertyValue(e)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(e)}e.b=styleValue;var r=n(32);e.a=function(t,e,n){return arguments.length>1?this.each((null==e?styleRemove:"function"==typeof e?styleFunction:styleConstant)(t,e,null==n?"":n)):styleValue(this.node(),t)}},function(t,e,n){"use strict";var r=n(2);e.a=function(t,e){var n,a,i,o=t.__transition,u=!0;if(o){e=null==e?null:e+"";for(i in o)(n=o[i]).name===e?(a=n.state>r.d&&n.state<r.b,n.state=r.a,n.timer.stop(),a&&n.on.call("interrupt",t,t.__data__,n.index,n.group),delete o[i]):u=!1;u&&delete t.__transition}}},function(t,e,n){"use strict";var r=n(33);n.d(e,"a",function(){return r.b}),n.d(e,"c",function(){return r.c});var a=n(160);n.d(e,"b",function(){return a.a});n(161)},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=function(t,e){var n;return("number"==typeof e?a.interpolateNumber:e instanceof r.color?a.interpolateRgb:(n=Object(r.color)(e))?(e=n,a.interpolateRgb):a.interpolateString)(t,e)}},,,,,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(92);n.d(e,"easeLinear",function(){return r.a});var a=n(93);n.d(e,"easeQuad",function(){return a.b}),n.d(e,"easeQuadIn",function(){return a.a}),n.d(e,"easeQuadOut",function(){return a.c}),n.d(e,"easeQuadInOut",function(){return a.b});var i=n(94);n.d(e,"easeCubic",function(){return i.b}),n.d(e,"easeCubicIn",function(){return i.a}),n.d(e,"easeCubicOut",function(){return i.c}),n.d(e,"easeCubicInOut",function(){return i.b});var o=n(95);n.d(e,"easePoly",function(){return o.b}),n.d(e,"easePolyIn",function(){return o.a}),n.d(e,"easePolyOut",function(){return o.c}),n.d(e,"easePolyInOut",function(){return o.b});var u=n(96);n.d(e,"easeSin",function(){return u.b}),n.d(e,"easeSinIn",function(){return u.a}),n.d(e,"easeSinOut",function(){return u.c}),n.d(e,"easeSinInOut",function(){return u.b});var c=n(97);n.d(e,"easeExp",function(){return c.b}),n.d(e,"easeExpIn",function(){return c.a}),n.d(e,"easeExpOut",function(){return c.c}),n.d(e,"easeExpInOut",function(){return c.b});var s=n(98);n.d(e,"easeCircle",function(){return s.b}),n.d(e,"easeCircleIn",function(){return s.a}),n.d(e,"easeCircleOut",function(){return s.c}),n.d(e,"easeCircleInOut",function(){return s.b});var f=n(99);n.d(e,"easeBounce",function(){return f.c}),n.d(e,"easeBounceIn",function(){return f.a}),n.d(e,"easeBounceOut",function(){return f.c}),n.d(e,"easeBounceInOut",function(){return f.b});var l=n(100);n.d(e,"easeBack",function(){return l.b}),n.d(e,"easeBackIn",function(){return l.a}),n.d(e,"easeBackOut",function(){return l.c}),n.d(e,"easeBackInOut",function(){return l.b});var h=n(101);n.d(e,"easeElastic",function(){return h.c}),n.d(e,"easeElasticIn",function(){return h.a}),n.d(e,"easeElasticOut",function(){return h.c}),n.d(e,"easeElasticInOut",function(){return h.b})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(104);n.d(e,"dispatch",function(){return r.a})},function(t,e,n){"use strict";n.d(e,"b",function(){return o}),n.d(e,"a",function(){return u});var r=n(10),a=n(68),i=Object(a.a)(r.a),o=i.right,u=i.left;e.c=o},function(t,e,n){"use strict";function ascendingComparator(t){return function(e,n){return Object(r.a)(t(e),n)}}var r=n(10);e.a=function(t){return 1===t.length&&(t=ascendingComparator(t)),{left:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)<0?r=i+1:a=i}return r},right:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)>0?a=i:r=i+1}return r}}}},function(t,e,n){"use strict";function pair(t,e){return[t,e]}e.b=pair,e.a=function(t,e){null==e&&(e=pair);for(var n=0,r=t.length-1,a=t[0],i=new Array(r<0?0:r);n<r;)i[n]=e(a,a=t[++n]);return i}},function(t,e,n){"use strict";var r=n(71);e.a=function(t,e){var n=Object(r.a)(t,e);return n?Math.sqrt(n):n}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a,i=t.length,o=0,u=-1,c=0,s=0;if(null==e)for(;++u<i;)isNaN(n=Object(r.a)(t[u]))||(a=n-c,c+=a/++o,s+=a*(n-c));else for(;++u<i;)isNaN(n=Object(r.a)(e(t[u],u,t)))||(a=n-c,c+=a/++o,s+=a*(n-c));if(o>1)return s/(o-1)}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a,i=t.length,o=-1;if(null==e){for(;++o<i;)if(null!=(n=t[o])&&n>=n)for(r=a=n;++o<i;)null!=(n=t[o])&&(r>n&&(r=n),a<n&&(a=n))}else for(;++o<i;)if(null!=(n=e(t[o],o,t))&&n>=n)for(r=a=n;++o<i;)null!=(n=e(t[o],o,t))&&(r>n&&(r=n),a<n&&(a=n));return[r,a]}},function(t,e,n){"use strict";n.d(e,"b",function(){return a}),n.d(e,"a",function(){return i});var r=Array.prototype,a=r.slice,i=r.map},function(t,e,n){"use strict";e.a=function(t,e,n){t=+t,e=+e,n=(a=arguments.length)<2?(e=t,t=0,1):a<3?1:+n;for(var r=-1,a=0|Math.max(0,Math.ceil((e-t)/n)),i=new Array(a);++r<a;)i[r]=t+r*n;return i}},function(t,e,n){"use strict";function tickIncrement(t,e,n){var o=(e-t)/Math.max(0,n),u=Math.floor(Math.log(o)/Math.LN10),c=o/Math.pow(10,u);return u>=0?(c>=r?10:c>=a?5:c>=i?2:1)*Math.pow(10,u):-Math.pow(10,-u)/(c>=r?10:c>=a?5:c>=i?2:1)}function tickStep(t,e,n){var o=Math.abs(e-t)/Math.max(0,n),u=Math.pow(10,Math.floor(Math.log(o)/Math.LN10)),c=o/u;return c>=r?u*=10:c>=a?u*=5:c>=i&&(u*=2),e<t?-u:u}e.b=tickIncrement,e.c=tickStep;var r=Math.sqrt(50),a=Math.sqrt(10),i=Math.sqrt(2);e.a=function(t,e,n){var r,a,i,o=e<t,u=-1;if(o&&(r=t,t=e,e=r),0===(i=tickIncrement(t,e,n))||!isFinite(i))return[];if(i>0)for(t=Math.ceil(t/i),e=Math.floor(e/i),a=new Array(r=Math.ceil(e-t+1));++u<r;)a[u]=(t+u)*i;else for(t=Math.floor(t*i),e=Math.ceil(e*i),a=new Array(r=Math.ceil(t-e+1));++u<r;)a[u]=(t-u)/i;return o&&a.reverse(),a}},function(t,e,n){"use strict";e.a=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&r>n&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&r>n&&(r=n);return r}},function(t,e,n){"use strict";function length(t){return t.length}var r=n(77);e.a=function(t){if(!(i=t.length))return[];for(var e=-1,n=Object(r.a)(t,length),a=new Array(n);++e<n;)for(var i,o=-1,u=a[e]=new Array(i);++o<i;)u[o]=t[o][e];return a}},function(t,e,n){"use strict";function localDate(t){if(0<=t.y&&t.y<100){var e=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return e.setFullYear(t.y),e}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function utcDate(t){if(0<=t.y&&t.y<100){var e=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return e.setUTCFullYear(t.y),e}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function newYear(t){return{y:t,m:0,d:1,H:0,M:0,S:0,L:0}}function formatLocale(t){function newFormat(t,e){return function(n){var r,i,o,u=[],c=-1,s=0,f=t.length;for(n instanceof Date||(n=new Date(+n));++c<f;)37===t.charCodeAt(c)&&(u.push(t.slice(s,c)),null!=(i=a[r=t.charAt(++c)])?r=t.charAt(++c):i="e"===r?" ":"0",(o=e[r])&&(r=o(n,i)),u.push(r),s=c+1);return u.push(t.slice(s,c)),u.join("")}}function newParse(t,e){return function(n){var r=newYear(1900);if(parseSpecifier(r,t,n+="",0)!=n.length)return null;if("p"in r&&(r.H=r.H%12+12*r.p),"W"in r||"U"in r){"w"in r||(r.w="W"in r?1:0);var a="Z"in r?utcDate(newYear(r.y)).getUTCDay():e(newYear(r.y)).getDay();r.m=0,r.d="W"in r?(r.w+6)%7+7*r.W-(a+5)%7:r.w+7*r.U-(a+6)%7}return"Z"in r?(r.H+=r.Z/100|0,r.M+=r.Z%100,utcDate(r)):e(r)}}function parseSpecifier(t,e,n,r){for(var i,o,u=0,c=e.length,s=n.length;u<c;){if(r>=s)return-1;if(37===(i=e.charCodeAt(u++))){if(i=e.charAt(u++),!(o=w[i in a?e.charAt(u++):i])||(r=o(t,n,r))<0)return-1}else if(i!=n.charCodeAt(r++))return-1}return r}function parsePeriod(t,e,n){var r=f.exec(e.slice(n));return r?(t.p=l[r[0].toLowerCase()],n+r[0].length):-1}function parseShortWeekday(t,e,n){var r=p.exec(e.slice(n));return r?(t.w=b[r[0].toLowerCase()],n+r[0].length):-1}function parseWeekday(t,e,n){var r=h.exec(e.slice(n));return r?(t.w=d[r[0].toLowerCase()],n+r[0].length):-1}function parseShortMonth(t,e,n){var r=y.exec(e.slice(n));return r?(t.m=g[r[0].toLowerCase()],n+r[0].length):-1}function parseMonth(t,e,n){var r=v.exec(e.slice(n));return r?(t.m=m[r[0].toLowerCase()],n+r[0].length):-1}function parseLocaleDateTime(t,n,r){return parseSpecifier(t,e,n,r)}function parseLocaleDate(t,e,r){return parseSpecifier(t,n,e,r)}function parseLocaleTime(t,e,n){return parseSpecifier(t,r,e,n)}function formatShortWeekday(t){return u[t.getDay()]}function formatWeekday(t){return o[t.getDay()]}function formatShortMonth(t){return s[t.getMonth()]}function formatMonth(t){return c[t.getMonth()]}function formatPeriod(t){return i[+(t.getHours()>=12)]}function formatUTCShortWeekday(t){return u[t.getUTCDay()]}function formatUTCWeekday(t){return o[t.getUTCDay()]}function formatUTCShortMonth(t){return s[t.getUTCMonth()]}function formatUTCMonth(t){return c[t.getUTCMonth()]}function formatUTCPeriod(t){return i[+(t.getUTCHours()>=12)]}var e=t.dateTime,n=t.date,r=t.time,i=t.periods,o=t.days,u=t.shortDays,c=t.months,s=t.shortMonths,f=formatRe(i),l=formatLookup(i),h=formatRe(o),d=formatLookup(o),p=formatRe(u),b=formatLookup(u),v=formatRe(c),m=formatLookup(c),y=formatRe(s),g=formatLookup(s),_={a:formatShortWeekday,A:formatWeekday,b:formatShortMonth,B:formatMonth,c:null,d:formatDayOfMonth,e:formatDayOfMonth,H:formatHour24,I:formatHour12,j:formatDayOfYear,L:formatMilliseconds,m:formatMonthNumber,M:formatMinutes,p:formatPeriod,S:formatSeconds,U:formatWeekNumberSunday,w:formatWeekdayNumber,W:formatWeekNumberMonday,x:null,X:null,y:formatYear,Y:formatFullYear,Z:formatZone,"%":formatLiteralPercent},x={a:formatUTCShortWeekday,A:formatUTCWeekday,b:formatUTCShortMonth,B:formatUTCMonth,c:null,d:formatUTCDayOfMonth,e:formatUTCDayOfMonth,H:formatUTCHour24,I:formatUTCHour12,j:formatUTCDayOfYear,L:formatUTCMilliseconds,m:formatUTCMonthNumber,M:formatUTCMinutes,p:formatUTCPeriod,S:formatUTCSeconds,U:formatUTCWeekNumberSunday,w:formatUTCWeekdayNumber,W:formatUTCWeekNumberMonday,x:null,X:null,y:formatUTCYear,Y:formatUTCFullYear,Z:formatUTCZone,"%":formatLiteralPercent},w={a:parseShortWeekday,A:parseWeekday,b:parseShortMonth,B:parseMonth,c:parseLocaleDateTime,d:parseDayOfMonth,e:parseDayOfMonth,H:parseHour24,I:parseHour24,j:parseDayOfYear,L:parseMilliseconds,m:parseMonthNumber,M:parseMinutes,p:parsePeriod,S:parseSeconds,U:parseWeekNumberSunday,w:parseWeekdayNumber,W:parseWeekNumberMonday,x:parseLocaleDate,X:parseLocaleTime,y:parseYear,Y:parseFullYear,Z:parseZone,"%":parseLiteralPercent};return _.x=newFormat(n,_),_.X=newFormat(r,_),_.c=newFormat(e,_),x.x=newFormat(n,x),x.X=newFormat(r,x),x.c=newFormat(e,x),{format:function(t){var e=newFormat(t+="",_);return e.toString=function(){return t},e},parse:function(t){var e=newParse(t+="",localDate);return e.toString=function(){return t},e},utcFormat:function(t){var e=newFormat(t+="",x);return e.toString=function(){return t},e},utcParse:function(t){var e=newParse(t,utcDate);return e.toString=function(){return t},e}}}function pad(t,e,n){var r=t<0?"-":"",a=(r?-t:t)+"",i=a.length;return r+(i<n?new Array(n-i+1).join(e)+a:a)}function requote(t){return t.replace(u,"\\$&")}function formatRe(t){return new RegExp("^(?:"+t.map(requote).join("|")+")","i")}function formatLookup(t){for(var e={},n=-1,r=t.length;++n<r;)e[t[n].toLowerCase()]=n;return e}function parseWeekdayNumber(t,e,n){var r=i.exec(e.slice(n,n+1));return r?(t.w=+r[0],n+r[0].length):-1}function parseWeekNumberSunday(t,e,n){var r=i.exec(e.slice(n));return r?(t.U=+r[0],n+r[0].length):-1}function parseWeekNumberMonday(t,e,n){var r=i.exec(e.slice(n));return r?(t.W=+r[0],n+r[0].length):-1}function parseFullYear(t,e,n){var r=i.exec(e.slice(n,n+4));return r?(t.y=+r[0],n+r[0].length):-1}function parseYear(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),n+r[0].length):-1}function parseZone(t,e,n){var r=/^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(e.slice(n,n+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),n+r[0].length):-1}function parseMonthNumber(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.m=r[0]-1,n+r[0].length):-1}function parseDayOfMonth(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.d=+r[0],n+r[0].length):-1}function parseDayOfYear(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.m=0,t.d=+r[0],n+r[0].length):-1}function parseHour24(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.H=+r[0],n+r[0].length):-1}function parseMinutes(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.M=+r[0],n+r[0].length):-1}function parseSeconds(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.S=+r[0],n+r[0].length):-1}function parseMilliseconds(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.L=+r[0],n+r[0].length):-1}function parseLiteralPercent(t,e,n){var r=o.exec(e.slice(n,n+1));return r?n+r[0].length:-1}function formatDayOfMonth(t,e){return pad(t.getDate(),e,2)}function formatHour24(t,e){return pad(t.getHours(),e,2)}function formatHour12(t,e){return pad(t.getHours()%12||12,e,2)}function formatDayOfYear(t,e){return pad(1+r.timeDay.count(Object(r.timeYear)(t),t),e,3)}function formatMilliseconds(t,e){return pad(t.getMilliseconds(),e,3)}function formatMonthNumber(t,e){return pad(t.getMonth()+1,e,2)}function formatMinutes(t,e){return pad(t.getMinutes(),e,2)}function formatSeconds(t,e){return pad(t.getSeconds(),e,2)}function formatWeekNumberSunday(t,e){return pad(r.timeSunday.count(Object(r.timeYear)(t),t),e,2)}function formatWeekdayNumber(t){return t.getDay()}function formatWeekNumberMonday(t,e){return pad(r.timeMonday.count(Object(r.timeYear)(t),t),e,2)}function formatYear(t,e){return pad(t.getFullYear()%100,e,2)}function formatFullYear(t,e){return pad(t.getFullYear()%1e4,e,4)}function formatZone(t){var e=t.getTimezoneOffset();return(e>0?"-":(e*=-1,"+"))+pad(e/60|0,"0",2)+pad(e%60,"0",2)}function formatUTCDayOfMonth(t,e){return pad(t.getUTCDate(),e,2)}function formatUTCHour24(t,e){return pad(t.getUTCHours(),e,2)}function formatUTCHour12(t,e){return pad(t.getUTCHours()%12||12,e,2)}function formatUTCDayOfYear(t,e){return pad(1+r.utcDay.count(Object(r.utcYear)(t),t),e,3)}function formatUTCMilliseconds(t,e){return pad(t.getUTCMilliseconds(),e,3)}function formatUTCMonthNumber(t,e){return pad(t.getUTCMonth()+1,e,2)}function formatUTCMinutes(t,e){return pad(t.getUTCMinutes(),e,2)}function formatUTCSeconds(t,e){return pad(t.getUTCSeconds(),e,2)}function formatUTCWeekNumberSunday(t,e){return pad(r.utcSunday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCWeekdayNumber(t){return t.getUTCDay()}function formatUTCWeekNumberMonday(t,e){return pad(r.utcMonday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCYear(t,e){return pad(t.getUTCFullYear()%100,e,2)}function formatUTCFullYear(t,e){return pad(t.getUTCFullYear()%1e4,e,4)}function formatUTCZone(){return"+0000"}function formatLiteralPercent(){return"%"}e.a=formatLocale;var r=n(35),a={"-":"",_:" ",0:"0"},i=/^\s*\d+/,o=/^%/,u=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g},function(t,e,n){"use strict";function formatIsoNative(t){return t.toISOString()}n.d(e,"b",function(){return a});var r=n(37),a="%Y-%m-%dT%H:%M:%S.%LZ",i=Date.prototype.toISOString?formatIsoNative:Object(r.d)(a);e.a=i},function(t,e,n){"use strict";function ordinal(t){function scale(r){var a=r+"",u=e.get(a);if(!u){if(o!==i)return o;e.set(a,u=n.push(r))}return t[(u-1)%t.length]}var e=Object(r.map)(),n=[],o=i;return t=null==t?[]:a.b.call(t),scale.domain=function(t){if(!arguments.length)return n.slice();n=[],e=Object(r.map)();for(var a,i,o=-1,u=t.length;++o<u;)e.has(i=(a=t[o])+"")||e.set(i,n.push(a));return scale},scale.range=function(e){return arguments.length?(t=a.b.call(e),scale):t.slice()},scale.unknown=function(t){return arguments.length?(o=t,scale):o},scale.copy=function(){return ordinal().domain(n).range(t).unknown(o)},scale}n.d(e,"b",function(){return i}),e.a=ordinal;var r=n(114),a=n(9),i={name:"implicit"}},function(t,e,n){"use strict";e.a=function(t){return+t}},function(t,e,n){"use strict";e.a=function(t,e){t=t.slice();var n,r=0,a=t.length-1,i=t[r],o=t[a];return o<i&&(n=r,r=a,a=n,n=i,i=o,o=n),t[r]=e.floor(i),t[a]=e.ceil(o),t}},function(t,e,n){"use strict";function date(t){return new Date(t)}function number(t){return t instanceof Date?+t:+new Date(+t)}function calendar(t,e,n,i,o,m,y,g,_){function tickFormat(r){return(y(r)<r?M:m(r)<r?C:o(r)<r?j:i(r)<r?T:e(r)<r?n(r)<r?k:S:t(r)<r?N:A)(r)}function tickInterval(e,n,a,i){if(null==e&&(e=10),"number"==typeof e){var o=Math.abs(a-n)/e,u=Object(r.bisector)(function(t){return t[2]}).right(E,o);u===E.length?(i=Object(r.tickStep)(n/v,a/v,e),e=t):u?(u=E[o/E[u-1][2]<E[u][2]/o?u-1:u],i=u[1],e=u[0]):(i=Object(r.tickStep)(n,a,e),e=g)}return null==i?e:e.every(i)}var x=Object(c.b)(c.c,a.interpolateNumber),w=x.invert,O=x.domain,M=_(".%L"),C=_(":%S"),j=_("%I:%M"),T=_("%I %p"),k=_("%a %d"),S=_("%b %d"),N=_("%B"),A=_("%Y"),E=[[y,1,f],[y,5,5*f],[y,15,15*f],[y,30,30*f],[m,1,l],[m,5,5*l],[m,15,15*l],[m,30,30*l],[o,1,h],[o,3,3*h],[o,6,6*h],[o,12,12*h],[i,1,d],[i,2,2*d],[n,1,p],[e,1,b],[e,3,3*b],[t,1,v]];return x.invert=function(t){return new Date(w(t))},x.domain=function(t){return arguments.length?O(u.a.call(t,number)):O().map(date)},x.ticks=function(t,e){var n,r=O(),a=r[0],i=r[r.length-1],o=i<a;return o&&(n=a,a=i,i=n),n=tickInterval(t,a,i,e),n=n?n.range(a,i+1):[],o?n.reverse():n},x.tickFormat=function(t,e){return null==e?tickFormat:_(e)},x.nice=function(t,e){var n=O();return(t=tickInterval(t,n[0],n[n.length-1],e))?O(Object(s.a)(n,t)):x},x.copy=function(){return Object(c.a)(x,calendar(t,e,n,i,o,m,y,g,_))},x}e.a=calendar;var r=n(5),a=n(8),i=n(35),o=n(40),u=n(9),c=n(18),s=n(83),f=1e3,l=60*f,h=60*l,d=24*h,p=7*d,b=30*d,v=365*d;e.b=function(){return calendar(i.timeYear,i.timeMonth,i.timeWeek,i.timeDay,i.timeHour,i.timeMinute,i.timeSecond,i.timeMillisecond,o.timeFormat).domain([new Date(2e3,0,1),new Date(2e3,0,2)])}},,,,,function(t,e,n){"use strict";var r;void 0!==(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},singleColors:{aloeGreen:["#7bdcc0"]},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green To Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"}}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},emptyDonutData:[{quantity:1,percentage:100}],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId"}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=(n(158),n(7));n.d(e,"transition",function(){return r.b});var a=n(179);n.d(e,"active",function(){return a.a});var i=n(58);n.d(e,"interrupt",function(){return i.a})},function(t,e,n){"use strict";function linear(t){return+t}e.a=linear},function(t,e,n){"use strict";function quadIn(t){return t*t}function quadOut(t){return t*(2-t)}function quadInOut(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.a=quadIn,e.c=quadOut,e.b=quadInOut},function(t,e,n){"use strict";function cubicIn(t){return t*t*t}function cubicOut(t){return--t*t*t+1}function cubicInOut(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.a=cubicIn,e.c=cubicOut,e.b=cubicInOut},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function polyIn(e){return Math.pow(e,t)}return t=+t,polyIn.exponent=custom,polyIn}(3),a=function custom(t){function polyOut(e){return 1-Math.pow(1-e,t)}return t=+t,polyOut.exponent=custom,polyOut}(3),i=function custom(t){function polyInOut(e){return((e*=2)<=1?Math.pow(e,t):2-Math.pow(2-e,t))/2}return t=+t,polyInOut.exponent=custom,polyInOut}(3)},function(t,e,n){"use strict";function sinIn(t){return 1-Math.cos(t*a)}function sinOut(t){return Math.sin(t*a)}function sinInOut(t){return(1-Math.cos(r*t))/2}e.a=sinIn,e.c=sinOut,e.b=sinInOut;var r=Math.PI,a=r/2},function(t,e,n){"use strict";function expIn(t){return Math.pow(2,10*t-10)}function expOut(t){return 1-Math.pow(2,-10*t)}function expInOut(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}e.a=expIn,e.c=expOut,e.b=expInOut},function(t,e,n){"use strict";function circleIn(t){return 1-Math.sqrt(1-t*t)}function circleOut(t){return Math.sqrt(1- --t*t)}function circleInOut(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}e.a=circleIn,e.c=circleOut,e.b=circleInOut},function(t,e,n){"use strict";function bounceIn(t){return 1-bounceOut(1-t)}function bounceOut(t){return(t=+t)<r?h*t*t:t<i?h*(t-=a)*t+o:t<c?h*(t-=u)*t+s:h*(t-=f)*t+l}function bounceInOut(t){return((t*=2)<=1?1-bounceOut(1-t):bounceOut(t-1)+1)/2}e.a=bounceIn,e.c=bounceOut,e.b=bounceInOut;var r=4/11,a=6/11,i=8/11,o=.75,u=9/11,c=10/11,s=.9375,f=21/22,l=63/64,h=1/r/r},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function backIn(e){return e*e*((t+1)*e-t)}return t=+t,backIn.overshoot=custom,backIn}(1.70158),a=function custom(t){function backOut(e){return--e*e*((t+1)*e+t)+1}return t=+t,backOut.overshoot=custom,backOut}(1.70158),i=function custom(t){function backInOut(e){return((e*=2)<1?e*e*((t+1)*e-t):(e-=2)*e*((t+1)*e+t)+2)/2}return t=+t,backInOut.overshoot=custom,backInOut}(1.70158)},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"b",function(){return o});var r=2*Math.PI,a=function custom(t,e){function elasticIn(r){return t*Math.pow(2,10*--r)*Math.sin((n-r)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticIn.amplitude=function(t){return custom(t,e*r)},elasticIn.period=function(e){return custom(t,e)},elasticIn}(1,.3),i=function custom(t,e){function elasticOut(r){return 1-t*Math.pow(2,-10*(r=+r))*Math.sin((r+n)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticOut.amplitude=function(t){return custom(t,e*r)},elasticOut.period=function(e){return custom(t,e)},elasticOut}(1,.3),o=function custom(t,e){function elasticInOut(r){return((r=2*r-1)<0?t*Math.pow(2,10*r)*Math.sin((n-r)/e):2-t*Math.pow(2,-10*r)*Math.sin((n+r)/e))/2}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticInOut.amplitude=function(t){return custom(t,e*r)},elasticInOut.period=function(e){return custom(t,e)},elasticInOut}(1,.3)},function(t,e,n){"use strict";function labConvert(t){if(t instanceof Lab)return new Lab(t.l,t.a,t.b,t.opacity);if(t instanceof Hcl){var e=t.h*i.a;return new Lab(t.l,Math.cos(e)*t.c,Math.sin(e)*t.c,t.opacity)}t instanceof a.b||(t=Object(a.h)(t));var n=rgb2xyz(t.r),r=rgb2xyz(t.g),s=rgb2xyz(t.b),f=xyz2lab((.4124564*n+.3575761*r+.1804375*s)/o),l=xyz2lab((.2126729*n+.7151522*r+.072175*s)/u);return new Lab(116*l-16,500*(f-l),200*(l-xyz2lab((.0193339*n+.119192*r+.9503041*s)/c)),t.opacity)}function lab(t,e,n,r){return 1===arguments.length?labConvert(t):new Lab(t,e,n,null==r?1:r)}function Lab(t,e,n,r){this.l=+t,this.a=+e,this.b=+n,this.opacity=+r}function xyz2lab(t){return t>h?Math.pow(t,1/3):t/l+s}function lab2xyz(t){return t>f?t*t*t:l*(t-s)}function xyz2rgb(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function rgb2xyz(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function hclConvert(t){if(t instanceof Hcl)return new Hcl(t.h,t.c,t.l,t.opacity);t instanceof Lab||(t=labConvert(t));var e=Math.atan2(t.b,t.a)*i.b;return new Hcl(e<0?e+360:e,Math.sqrt(t.a*t.a+t.b*t.b),t.l,t.opacity)}function hcl(t,e,n,r){return 1===arguments.length?hclConvert(t):new Hcl(t,e,n,null==r?1:r)}function Hcl(t,e,n,r){this.h=+t,this.c=+e,this.l=+n,this.opacity=+r}e.a=lab,e.b=hcl;var r=n(20),a=n(19),i=n(41),o=.95047,u=1,c=1.08883,s=4/29,f=6/29,l=3*f*f,h=f*f*f;Object(r.a)(Lab,lab,Object(r.b)(a.a,{brighter:function(t){return new Lab(this.l+18*(null==t?1:t),this.a,this.b,this.opacity)},darker:function(t){return new Lab(this.l-18*(null==t?1:t),this.a,this.b,this.opacity)},rgb:function(){var t=(this.l+16)/116,e=isNaN(this.a)?t:t+this.a/500,n=isNaN(this.b)?t:t-this.b/200;return t=u*lab2xyz(t),e=o*lab2xyz(e),n=c*lab2xyz(n),new a.b(xyz2rgb(3.2404542*e-1.5371385*t-.4985314*n),xyz2rgb(-.969266*e+1.8760108*t+.041556*n),xyz2rgb(.0556434*e-.2040259*t+1.0572252*n),this.opacity)}})),Object(r.a)(Hcl,hcl,Object(r.b)(a.a,{brighter:function(t){return new Hcl(this.h,this.c,this.l+18*(null==t?1:t),this.opacity)},darker:function(t){return new Hcl(this.h,this.c,this.l-18*(null==t?1:t),this.opacity)},rgb:function(){return labConvert(this).rgb()}}))},function(t,e,n){"use strict";function cubehelixConvert(t){if(t instanceof Cubehelix)return new Cubehelix(t.h,t.s,t.l,t.opacity);t instanceof a.b||(t=Object(a.h)(t));var e=t.r/255,n=t.g/255,r=t.b/255,o=(d*r+l*e-h*n)/(d+l-h),u=r-o,p=(f*(n-o)-c*u)/s,b=Math.sqrt(p*p+u*u)/(f*o*(1-o)),v=b?Math.atan2(p,u)*i.b-120:NaN;return new Cubehelix(v<0?v+360:v,b,o,t.opacity)}function cubehelix(t,e,n,r){return 1===arguments.length?cubehelixConvert(t):new Cubehelix(t,e,n,null==r?1:r)}function Cubehelix(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}e.a=cubehelix;var r=n(20),a=n(19),i=n(41),o=-.14861,u=1.78277,c=-.29227,s=-.90649,f=1.97294,l=f*s,h=f*u,d=u*c-s*o;Object(r.a)(Cubehelix,cubehelix,Object(r.b)(a.a,{brighter:function(t){return t=null==t?a.c:Math.pow(a.c,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a.d:Math.pow(a.d,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=isNaN(this.h)?0:(this.h+120)*i.a,e=+this.l,n=isNaN(this.s)?0:this.s*e*(1-e),r=Math.cos(t),l=Math.sin(t);return new a.b(255*(e+n*(o*r+u*l)),255*(e+n*(c*r+s*l)),255*(e+n*(f*r)),this.opacity)}}))},function(t,e,n){"use strict";function dispatch(){for(var t,e=0,n=arguments.length,r={};e<n;++e){if(!(t=arguments[e]+"")||t in r)throw new Error("illegal type: "+t);r[t]=[]}return new Dispatch(r)}function Dispatch(t){this._=t}function parseTypenames(t,e){return t.trim().split(/^|\s+/).map(function(t){var n="",r=t.indexOf(".");if(r>=0&&(n=t.slice(r+1),t=t.slice(0,r)),t&&!e.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:n}})}function get(t,e){for(var n,r=0,a=t.length;r<a;++r)if((n=t[r]).name===e)return n.value}function set(t,e,n){for(var a=0,i=t.length;a<i;++a)if(t[a].name===e){t[a]=r,t=t.slice(0,a).concat(t.slice(a+1));break}return null!=n&&t.push({name:e,value:n}),t}var r={value:function(){}};Dispatch.prototype=dispatch.prototype={constructor:Dispatch,on:function(t,e){var n,r=this._,a=parseTypenames(t+"",r),i=-1,o=a.length;{if(!(arguments.length<2)){if(null!=e&&"function"!=typeof e)throw new Error("invalid callback: "+e);for(;++i<o;)if(n=(t=a[i]).type)r[n]=set(r[n],t.name,e);else if(null==e)for(n in r)r[n]=set(r[n],t.name,null);return this}for(;++i<o;)if((n=(t=a[i]).type)&&(n=get(r[n],t.name)))return n}},copy:function(){var t={},e=this._;for(var n in e)t[n]=e[n].slice();return new Dispatch(t)},call:function(t,e){if((n=arguments.length-2)>0)for(var n,r,a=new Array(n),i=0;i<n;++i)a[i]=arguments[i+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(r=this._[t],i=0,n=r.length;i<n;++i)r[i].value.apply(e,a)},apply:function(t,e,n){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],a=0,i=r.length;a<i;++a)r[a].value.apply(e,n)}},e.a=dispatch},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(o.a)(t),a=r.format,i=r.formatPrefix,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),e.a=defaultLocale;var r,a,i,o=n(42);defaultLocale({decimal:".",thousands:",",grouping:[3],currency:["$",""]})},function(t,e,n){"use strict";e.a=function(t,e){return function(n,r){for(var a=n.length,i=[],o=0,u=t[0],c=0;a>0&&u>0&&(c+u+1>r&&(u=Math.max(1,r-c)),i.push(n.substring(a-=u,a+u)),!((c+=u+1)>r));)u=t[o=(o+1)%t.length];return i.reverse().join(e)}}},function(t,e,n){"use strict";e.a=function(t){return function(e){return e.replace(/[0-9]/g,function(e){return t[+e]})}}},function(t,e,n){"use strict";e.a=function(t,e){t=t.toPrecision(e);t:for(var n,r=t.length,a=1,i=-1;a<r;++a)switch(t[a]){case".":i=n=a;break;case"0":0===i&&(i=a),n=a;break;case"e":break t;default:i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t,e){var n=Object(r.a)(t,e);if(!n)return t+"";var a=n[0],i=n[1];return i<0?"0."+new Array(-i).join("0")+a:a.length>i+1?a.slice(0,i+1)+"."+a.slice(i+1):a+new Array(i-a.length+2).join("0")}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(13);e.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3)))-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return t=Math.abs(t),e=Math.abs(e)-t,Math.max(0,Object(r.a)(e)-Object(r.a)(t))+1}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(217);n.d(e,"nest",function(){return r.a});var a=n(218);n.d(e,"set",function(){return a.a});var i=n(38);n.d(e,"map",function(){return i.a});var o=n(219);n.d(e,"keys",function(){return o.a});var u=n(220);n.d(e,"values",function(){return u.a});var c=n(221);n.d(e,"entries",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return Math.round(t+e*n)}}},function(t,e,n){"use strict";function interpolateTransform(t,e,n,a){function pop(t){return t.length?t.pop()+" ":""}function translate(t,a,i,o,u,c){if(t!==i||a!==o){var s=u.push("translate(",null,e,null,n);c.push({i:s-4,x:Object(r.a)(t,i)},{i:s-2,x:Object(r.a)(a,o)})}else(i||o)&&u.push("translate("+i+e+o+n)}function rotate(t,e,n,i){t!==e?(t-e>180?e+=360:e-t>180&&(t+=360),i.push({i:n.push(pop(n)+"rotate(",null,a)-2,x:Object(r.a)(t,e)})):e&&n.push(pop(n)+"rotate("+e+a)}function skewX(t,e,n,i){t!==e?i.push({i:n.push(pop(n)+"skewX(",null,a)-2,x:Object(r.a)(t,e)}):e&&n.push(pop(n)+"skewX("+e+a)}function scale(t,e,n,a,i,o){if(t!==n||e!==a){var u=i.push(pop(i)+"scale(",null,",",null,")");o.push({i:u-4,x:Object(r.a)(t,n)},{i:u-2,x:Object(r.a)(e,a)})}else 1===n&&1===a||i.push(pop(i)+"scale("+n+","+a+")")}return function(e,n){var r=[],a=[];return e=t(e),n=t(n),translate(e.translateX,e.translateY,n.translateX,n.translateY,r,a),rotate(e.rotate,n.rotate,r,a),skewX(e.skewX,n.skewX,r,a),scale(e.scaleX,e.scaleY,n.scaleX,n.scaleY,r,a),e=n=null,function(t){for(var e,n=-1,i=a.length;++n<i;)r[(e=a[n]).i]=e.x(t);return r.join("")}}}n.d(e,"a",function(){return i}),n.d(e,"b",function(){return o});var r=n(15),a=n(117),i=interpolateTransform(a.a,"px, ","px)","deg)"),o=interpolateTransform(a.b,", ",")",")")},function(t,e,n){"use strict";function parseCss(t){return"none"===t?u.b:(r||(r=document.createElement("DIV"),a=document.documentElement,i=document.defaultView),r.style.transform=t,t=i.getComputedStyle(a.appendChild(r),null).getPropertyValue("transform"),a.removeChild(r),t=t.slice(7,-1).split(","),Object(u.a)(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}function parseSvg(t){return null==t?u.b:(o||(o=document.createElementNS("http://www.w3.org/2000/svg","g")),o.setAttribute("transform",t),(t=o.transform.baseVal.consolidate())?(t=t.matrix,Object(u.a)(t.a,t.b,t.c,t.d,t.e,t.f)):u.b)}e.a=parseCss,e.b=parseSvg;var r,a,i,o,u=n(118)},function(t,e,n){"use strict";n.d(e,"b",function(){return a});var r=180/Math.PI,a={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};e.a=function(t,e,n,a,i,o){var u,c,s;return(u=Math.sqrt(t*t+e*e))&&(t/=u,e/=u),(s=t*n+e*a)&&(n-=t*s,a-=e*s),(c=Math.sqrt(n*n+a*a))&&(n/=c,a/=c,s/=c),t*a<e*n&&(t=-t,e=-e,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(e,t)*r,skewX:Math.atan(s)*r,scaleX:u,scaleY:c}}},function(t,e,n){"use strict";function cosh(t){return((t=Math.exp(t))+1/t)/2}function sinh(t){return((t=Math.exp(t))-1/t)/2}function tanh(t){return((t=Math.exp(2*t))-1)/(t+1)}var r=Math.SQRT2;e.a=function(t,e){var n,a,i=t[0],o=t[1],u=t[2],c=e[0],s=e[1],f=e[2],l=c-i,h=s-o,d=l*l+h*h;if(d<1e-12)a=Math.log(f/u)/r,n=function(t){return[i+t*l,o+t*h,u*Math.exp(r*t*a)]};else{var p=Math.sqrt(d),b=(f*f-u*u+4*d)/(2*u*2*p),v=(f*f-u*u-4*d)/(2*f*2*p),m=Math.log(Math.sqrt(b*b+1)-b),y=Math.log(Math.sqrt(v*v+1)-v);a=(y-m)/r,n=function(t){var e=t*a,n=cosh(m),c=u/(2*p)*(n*tanh(r*e+m)-sinh(m));return[i+c*l,o+c*h,u*n/cosh(r*e+m)]}}return n.duration=1e3*a,n}},function(t,e,n){"use strict";function hsl(t){return function(e,n){var i=t((e=Object(r.hsl)(e)).h,(n=Object(r.hsl)(n)).h),o=Object(a.a)(e.s,n.s),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.s=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hsl(a.c);var i=hsl(a.a)},function(t,e,n){"use strict";function lab(t,e){var n=Object(a.a)((t=Object(r.lab)(t)).l,(e=Object(r.lab)(e)).l),i=Object(a.a)(t.a,e.a),o=Object(a.a)(t.b,e.b),u=Object(a.a)(t.opacity,e.opacity);return function(e){return t.l=n(e),t.a=i(e),t.b=o(e),t.opacity=u(e),t+""}}e.a=lab;var r=n(4),a=n(11)},function(t,e,n){"use strict";function hcl(t){return function(e,n){var i=t((e=Object(r.hcl)(e)).h,(n=Object(r.hcl)(n)).h),o=Object(a.a)(e.c,n.c),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.c=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hcl(a.c);var i=hcl(a.a)},function(t,e,n){"use strict";function cubehelix(t){return function cubehelixGamma(e){function cubehelix(n,i){var o=t((n=Object(r.cubehelix)(n)).h,(i=Object(r.cubehelix)(i)).h),u=Object(a.a)(n.s,i.s),c=Object(a.a)(n.l,i.l),s=Object(a.a)(n.opacity,i.opacity);return function(t){return n.h=o(t),n.s=u(t),n.l=c(Math.pow(t,e)),n.opacity=s(t),n+""}}return e=+e,cubehelix.gamma=cubehelixGamma,cubehelix}(1)}n.d(e,"a",function(){return i});var r=n(4),a=n(11);e.b=cubehelix(a.c);var i=cubehelix(a.a)},function(t,e,n){"use strict";e.a=function(t,e){for(var n=new Array(e),r=0;r<e;++r)n[r]=t(r/(e-1));return n}},function(t,e,n){"use strict";function local(){return new Local}function Local(){this._="@"+(++r).toString(36)}e.a=local;var r=0;Local.prototype=local.prototype={constructor:Local,get:function(t){for(var e=this._;!(e in t);)if(!(t=t.parentNode))return;return t[e]},set:function(t,e){return t[this._]=e},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t){var e=Object(r.a)();return e.changedTouches&&(e=e.changedTouches[0]),Object(a.a)(t,e)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,e,n){"use strict";var r=n(1),a=n(31);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c,s=e[o],f=s.length,l=i[o]=new Array(f),h=0;h<f;++h)(u=s[h])&&(c=t.call(u,u.__data__,h,s))&&("__data__"in u&&(c.__data__=u.__data__),l[h]=c);return new r.a(i,this._parents)}},function(t,e,n){"use strict";var r=n(1),a=n(54);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=[],o=[],u=0;u<n;++u)for(var c,s=e[u],f=s.length,l=0;l<f;++l)(c=s[l])&&(i.push(t.call(c,c.__data__,l,s)),o.push(c));return new r.a(i,o)}},function(t,e,n){"use strict";var r=n(1),a=n(53);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new r.a(i,this._parents)}},function(t,e,n){"use strict";function bindIndex(t,e,n,r,i,o){for(var u,c=0,s=e.length,f=o.length;c<f;++c)(u=e[c])?(u.__data__=o[c],r[c]=u):n[c]=new a.a(t,o[c]);for(;c<s;++c)(u=e[c])&&(i[c]=u)}function bindKey(t,e,n,r,i,u,c){var s,f,l,h={},d=e.length,p=u.length,b=new Array(d);for(s=0;s<d;++s)(f=e[s])&&(b[s]=l=o+c.call(f,f.__data__,s,e),l in h?i[s]=f:h[l]=f);for(s=0;s<p;++s)l=o+c.call(t,u[s],s,u),(f=h[l])?(r[s]=f,f.__data__=u[s],h[l]=null):n[s]=new a.a(t,u[s]);for(s=0;s<d;++s)(f=e[s])&&h[b[s]]===f&&(i[s]=f)}var r=n(1),a=n(55),i=n(132),o="$";e.a=function(t,e){if(!t)return b=new Array(this.size()),l=-1,this.each(function(t){b[++l]=t}),b;var n=e?bindKey:bindIndex,a=this._parents,o=this._groups;"function"!=typeof t&&(t=Object(i.a)(t));for(var u=o.length,c=new Array(u),s=new Array(u),f=new Array(u),l=0;l<u;++l){var h=a[l],d=o[l],p=d.length,b=t.call(h,h&&h.__data__,l,a),v=b.length,m=s[l]=new Array(v),y=c[l]=new Array(v);n(h,d,m,y,f[l]=new Array(p),b,e);for(var g,_,x=0,w=0;x<v;++x)if(g=m[x]){for(x>=w&&(w=x+1);!(_=y[w])&&++w<v;);g._next=_||null}}return c=new r.a(c,a),c._enter=s,c._exit=f,c}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(56),a=n(1);e.a=function(){return new a.a(this._exit||this._groups.map(r.a),this._parents)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents)}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=-1,n=t.length;++e<n;)for(var r,a=t[e],i=a.length-1,o=a[i];--i>=0;)(r=a[i])&&(o&&o!==r.nextSibling&&o.parentNode.insertBefore(r,o),o=r);return this}},function(t,e,n){"use strict";function ascending(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}var r=n(1);e.a=function(t){function compareNode(e,n){return e&&n?t(e.__data__,n.__data__):!e-!n}t||(t=ascending);for(var e=this._groups,n=e.length,a=new Array(n),i=0;i<n;++i){for(var o,u=e[i],c=u.length,s=a[i]=new Array(c),f=0;f<c;++f)(o=u[f])&&(s[f]=o);s.sort(compareNode)}return new r.a(a,this._parents).order()}},function(t,e,n){"use strict";e.a=function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}},function(t,e,n){"use strict";e.a=function(){var t=new Array(this.size()),e=-1;return this.each(function(){t[++e]=this}),t}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=0,n=t.length;e<n;++e)for(var r=t[e],a=0,i=r.length;a<i;++a){var o=r[a];if(o)return o}return null}},function(t,e,n){"use strict";e.a=function(){var t=0;return this.each(function(){++t}),t}},function(t,e,n){"use strict";e.a=function(){return!this.node()}},function(t,e,n){"use strict";e.a=function(t){for(var e=this._groups,n=0,r=e.length;n<r;++n)for(var a,i=e[n],o=0,u=i.length;o<u;++o)(a=i[o])&&t.call(a,a.__data__,o,i);return this}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e){return function(){this.setAttribute(t,e)}}function attrConstantNS(t,e){return function(){this.setAttributeNS(t.space,t.local,e)}}function attrFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttribute(t):this.setAttribute(t,n)}}function attrFunctionNS(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,n)}}var r=n(26);e.a=function(t,e){var n=Object(r.a)(t);if(arguments.length<2){var a=this.node();return n.local?a.getAttributeNS(n.space,n.local):a.getAttribute(n)}return this.each((null==e?n.local?attrRemoveNS:attrRemove:"function"==typeof e?n.local?attrFunctionNS:attrFunction:n.local?attrConstantNS:attrConstant)(n,e))}},function(t,e,n){"use strict";function propertyRemove(t){return function(){delete this[t]}}function propertyConstant(t,e){return function(){this[t]=e}}function propertyFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?delete this[t]:this[t]=n}}e.a=function(t,e){return arguments.length>1?this.each((null==e?propertyRemove:"function"==typeof e?propertyFunction:propertyConstant)(t,e)):this.node()[t]}},function(t,e,n){"use strict";function classArray(t){return t.trim().split(/^|\s+/)}function classList(t){return t.classList||new ClassList(t)}function ClassList(t){this._node=t,this._names=classArray(t.getAttribute("class")||"")}function classedAdd(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.add(e[r])}function classedRemove(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.remove(e[r])}function classedTrue(t){return function(){classedAdd(this,t)}}function classedFalse(t){return function(){classedRemove(this,t)}}function classedFunction(t,e){return function(){(e.apply(this,arguments)?classedAdd:classedRemove)(this,t)}}ClassList.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var e=this._names.indexOf(t);e>=0&&(this._names.splice(e,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}},e.a=function(t,e){var n=classArray(t+"");if(arguments.length<2){for(var r=classList(this.node()),a=-1,i=n.length;++a<i;)if(!r.contains(n[a]))return!1;return!0}return this.each(("function"==typeof e?classedFunction:e?classedTrue:classedFalse)(n,e))}},function(t,e,n){"use strict";function textRemove(){this.textContent=""}function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t.apply(this,arguments);this.textContent=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?textRemove:("function"==typeof t?textFunction:textConstant)(t)):this.node().textContent}},function(t,e,n){"use strict";function htmlRemove(){this.innerHTML=""}function htmlConstant(t){return function(){this.innerHTML=t}}function htmlFunction(t){return function(){var e=t.apply(this,arguments);this.innerHTML=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?htmlRemove:("function"==typeof t?htmlFunction:htmlConstant)(t)):this.node().innerHTML}},function(t,e,n){"use strict";function raise(){this.nextSibling&&this.parentNode.appendChild(this)}e.a=function(){return this.each(raise)}},function(t,e,n){"use strict";function lower(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}e.a=function(){return this.each(lower)}},function(t,e,n){"use strict";var r=n(25);e.a=function(t){var e="function"==typeof t?t:Object(r.a)(t);return this.select(function(){return this.appendChild(e.apply(this,arguments))})}},function(t,e,n){"use strict";function constantNull(){return null}var r=n(25),a=n(31);e.a=function(t,e){var n="function"==typeof t?t:Object(r.a)(t),i=null==e?constantNull:"function"==typeof e?e:Object(a.a)(e);return this.select(function(){return this.insertBefore(n.apply(this,arguments),i.apply(this,arguments)||null)})}},function(t,e,n){"use strict";function remove(){var t=this.parentNode;t&&t.removeChild(this)}e.a=function(){return this.each(remove)}},function(t,e,n){"use strict";e.a=function(t){return arguments.length?this.property("__data__",t):this.node().__data__}},function(t,e,n){"use strict";function dispatchEvent(t,e,n){var a=Object(r.a)(t),i=a.CustomEvent;"function"==typeof i?i=new i(e,n):(i=a.document.createEvent("Event"),n?(i.initEvent(e,n.bubbles,n.cancelable),i.detail=n.detail):i.initEvent(e,!1,!1)),t.dispatchEvent(i)}function dispatchConstant(t,e){return function(){return dispatchEvent(this,t,e)}}function dispatchFunction(t,e){return function(){return dispatchEvent(this,t,e.apply(this,arguments))}}var r=n(32);e.a=function(t,e){return this.each(("function"==typeof e?dispatchFunction:dispatchConstant)(t,e))}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([document.querySelectorAll(t)],[document.documentElement]):new r.a([null==t?[]:t],r.c)}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e,n){arguments.length<3&&(n=e,e=Object(r.a)().changedTouches);for(var i,o=0,u=e?e.length:0;o<u;++o)if((i=e[o]).identifier===n)return Object(a.a)(t,i);return null}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e){null==e&&(e=Object(r.a)().touches);for(var n=0,i=e?e.length:0,o=new Array(i);n<i;++n)o[n]=Object(a.a)(t,e[n]);return o}},function(t,e,n){"use strict";var r=n(3),a=n(159),i=n(162);r.selection.prototype.interrupt=a.a,r.selection.prototype.transition=i.a},function(t,e,n){"use strict";var r=n(58);e.a=function(t){return this.each(function(){Object(r.a)(this,t)})}},function(t,e,n){"use strict";var r=n(33);e.a=function(t,e,n){var a=new r.a;return e=null==e?0:+e,a.restart(function(n){a.stop(),t(n+e)},e,n),a}},function(t,e,n){"use strict";n(33)},function(t,e,n){"use strict";function inherit(t,e){for(var n;!(n=t.__transition)||!(n=n[e]);)if(!(t=t.parentNode))return u.time=Object(o.a)(),u;return n}var r=n(7),a=n(2),i=n(65),o=n(59),u={time:null,delay:0,duration:250,ease:i.easeCubicInOut};e.a=function(t){var e,n;t instanceof r.a?(e=t._id,t=t._name):(e=Object(r.c)(),(n=u).time=Object(o.a)(),t=null==t?null:t+"");for(var i=this._groups,c=i.length,s=0;s<c;++s)for(var f,l=i[s],h=l.length,d=0;d<h;++d)(f=l[d])&&Object(a.e)(f,t,e,d,l,n||inherit(f,e));return new r.a(i,this._parents,t,e)}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e,n){var r,a;return function(){var i=this.getAttribute(t);return i===n?null:i===r?a:a=e(r=i,n)}}function attrConstantNS(t,e,n){var r,a;return function(){var i=this.getAttributeNS(t.space,t.local);return i===n?null:i===r?a:a=e(r=i,n)}}function attrFunction(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttribute(t):(o=this.getAttribute(t),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}function attrFunctionNS(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttributeNS(t.space,t.local):(o=this.getAttributeNS(t.space,t.local),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e){var n=Object(a.namespace)(t),u="transform"===n?r.interpolateTransformSvg:o.a;return this.attrTween(t,"function"==typeof e?(n.local?attrFunctionNS:attrFunction)(n,u,Object(i.b)(this,"attr."+t,e)):null==e?(n.local?attrRemoveNS:attrRemove)(n):(n.local?attrConstantNS:attrConstant)(n,u,e+""))}},function(t,e,n){"use strict";function attrTweenNS(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttributeNS(t.space,t.local,r(e))}}return tween._value=e,tween}function attrTween(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttribute(t,r(e))}}return tween._value=e,tween}var r=n(3);e.a=function(t,e){var n="attr."+t;if(arguments.length<2)return(n=this.tween(n))&&n._value;if(null==e)return this.tween(n,null);if("function"!=typeof e)throw new Error;var a=Object(r.namespace)(t);return this.tween(n,(a.local?attrTweenNS:attrTween)(a,e))}},function(t,e,n){"use strict";function delayFunction(t,e){return function(){Object(r.g)(this,t).delay=+e.apply(this,arguments)}}function delayConstant(t,e){return e=+e,function(){Object(r.g)(this,t).delay=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?delayFunction:delayConstant)(e,t)):Object(r.f)(this.node(),e).delay}},function(t,e,n){"use strict";function durationFunction(t,e){return function(){Object(r.h)(this,t).duration=+e.apply(this,arguments)}}function durationConstant(t,e){return e=+e,function(){Object(r.h)(this,t).duration=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?durationFunction:durationConstant)(e,t)):Object(r.f)(this.node(),e).duration}},function(t,e,n){"use strict";function easeConstant(t,e){if("function"!=typeof e)throw new Error;return function(){Object(r.h)(this,t).ease=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(easeConstant(e,t)):Object(r.f)(this.node(),e).ease}},function(t,e,n){"use strict";var r=n(3),a=n(7);e.a=function(t){"function"!=typeof t&&(t=Object(r.matcher)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new a.a(i,this._parents,this._name,this._id)}},function(t,e,n){"use strict";var r=n(7);e.a=function(t){if(t._id!==this._id)throw new Error;for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents,this._name,this._id)}},function(t,e,n){"use strict";function start(t){return(t+"").trim().split(/^|\s+/).every(function(t){var e=t.indexOf(".");return e>=0&&(t=t.slice(0,e)),!t||"start"===t})}function onFunction(t,e,n){var a,i,o=start(e)?r.g:r.h;return function(){var r=o(this,t),u=r.on;u!==a&&(i=(a=u).copy()).on(e,n),r.on=i}}var r=n(2);e.a=function(t,e){var n=this._id;return arguments.length<2?Object(r.f)(this.node(),n).on.on(t):this.each(onFunction(n,t,e))}},function(t,e,n){"use strict";function removeFunction(t){return function(){var e=this.parentNode;for(var n in this.__transition)if(+n!==t)return;e&&e.removeChild(this)}}e.a=function(){return this.on("end.remove",removeFunction(this._id))}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selector)(t));for(var o=this._groups,u=o.length,c=new Array(u),s=0;s<u;++s)for(var f,l,h=o[s],d=h.length,p=c[s]=new Array(d),b=0;b<d;++b)(f=h[b])&&(l=t.call(f,f.__data__,b,h))&&("__data__"in f&&(l.__data__=f.__data__),p[b]=l,Object(i.e)(p[b],e,n,b,p,Object(i.f)(f,n)));return new a.a(c,this._parents,e,n)}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selectorAll)(t));for(var o=this._groups,u=o.length,c=[],s=[],f=0;f<u;++f)for(var l,h=o[f],d=h.length,p=0;p<d;++p)if(l=h[p]){for(var b,v=t.call(l,l.__data__,p,h),m=Object(i.f)(l,n),y=0,g=v.length;y<g;++y)(b=v[y])&&Object(i.e)(b,e,n,y,v,m);c.push(v),s.push(l)}return new a.a(c,s,e,n)}},function(t,e,n){"use strict";var r=n(3),a=r.selection.prototype.constructor;e.a=function(){return new a(this._groups,this._parents)}},function(t,e,n){"use strict";function styleRemove(t,e){var n,r,i;return function(){var o=Object(a.style)(this,t),u=(this.style.removeProperty(t),Object(a.style)(this,t));return o===u?null:o===n&&u===r?i:i=e(n=o,r=u)}}function styleRemoveEnd(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){var r,i;return function(){var o=Object(a.style)(this,t);return o===n?null:o===r?i:i=e(r=o,n)}}function styleFunction(t,e,n){var r,i,o;return function(){var u=Object(a.style)(this,t),c=n(this);return null==c&&(this.style.removeProperty(t),c=Object(a.style)(this,t)),u===c?null:u===r&&c===i?o:o=e(r=u,i=c)}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e,n){var a="transform"==(t+="")?r.interpolateTransformCss:o.a;return null==e?this.styleTween(t,styleRemove(t,a)).on("end.style."+t,styleRemoveEnd(t)):this.styleTween(t,"function"==typeof e?styleFunction(t,a,Object(i.b)(this,"style."+t,e)):styleConstant(t,a,e+""),n)}},function(t,e,n){"use strict";function styleTween(t,e,n){function tween(){var r=this,a=e.apply(r,arguments);return a&&function(e){r.style.setProperty(t,a(e),n)}}return tween._value=e,tween}e.a=function(t,e,n){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==e)return this.tween(r,null);if("function"!=typeof e)throw new Error;return this.tween(r,styleTween(t,e,null==n?"":n))}},function(t,e,n){"use strict";function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t(this);this.textContent=null==e?"":e}}var r=n(17);e.a=function(t){return this.tween("text","function"==typeof t?textFunction(Object(r.b)(this,"text",t)):textConstant(null==t?"":t+""))}},function(t,e,n){"use strict";var r=n(7),a=n(2);e.a=function(){for(var t=this._name,e=this._id,n=Object(r.c)(),i=this._groups,o=i.length,u=0;u<o;++u)for(var c,s=i[u],f=s.length,l=0;l<f;++l)if(c=s[l]){var h=Object(a.f)(c,e);Object(a.e)(c,t,n,l,s,{time:h.time+h.delay+h.duration,delay:0,duration:h.duration,ease:h.ease})}return new r.a(i,this._parents,t,n)}},function(t,e,n){"use strict";var r=n(7),a=n(2),i=[null];e.a=function(t,e){var n,o,u=t.__transition;if(u){e=null==e?null:e+"";for(o in u)if((n=u[o]).state>a.c&&n.name===e)return new r.a([[t]],i,e,+o)}return null}},,,,,function(t,e,n){"use strict";var r=n(69);e.a=function(t,e,n){var a,i,o,u,c=t.length,s=e.length,f=new Array(c*s);for(null==n&&(n=r.b),a=o=0;a<c;++a)for(u=t[a],i=0;i<s;++i,++o)f[o]=n(u,e[i]);return f}},function(t,e,n){"use strict";e.a=function(t,e){return e<t?-1:e>t?1:e>=t?0:NaN}},function(t,e,n){"use strict";var r=n(73),a=n(67),i=n(187),o=n(72),u=n(188),c=n(74),s=n(75),f=n(76);e.a=function(){function histogram(r){var i,o,u=r.length,f=new Array(u);for(i=0;i<u;++i)f[i]=t(r[i],i,r);var l=e(f),h=l[0],d=l[1],p=n(f,h,d);Array.isArray(p)||(p=Object(s.c)(h,d,p),p=Object(c.a)(Math.ceil(h/p)*p,Math.floor(d/p)*p,p));for(var b=p.length;p[0]<=h;)p.shift(),--b;for(;p[b-1]>d;)p.pop(),--b;var v,m=new Array(b+1);for(i=0;i<=b;++i)v=m[i]=[],v.x0=i>0?p[i-1]:h,v.x1=i<b?p[i]:d;for(i=0;i<u;++i)o=f[i],h<=o&&o<=d&&m[Object(a.c)(p,o,0,b)].push(r[i]);return m}var t=u.a,e=o.a,n=f.a;return histogram.value=function(e){return arguments.length?(t="function"==typeof e?e:Object(i.a)(e),histogram):t},histogram.domain=function(t){return arguments.length?(e="function"==typeof t?t:Object(i.a)([t[0],t[1]]),histogram):e},histogram.thresholds=function(t){return arguments.length?(n="function"==typeof t?t:Array.isArray(t)?Object(i.a)(r.b.call(t)):Object(i.a)(t),histogram):n},histogram}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(73),a=n(10),i=n(12),o=n(36);e.a=function(t,e,n){return t=r.a.call(t,i.a).sort(a.a),Math.ceil((n-e)/(2*(Object(o.a)(t,.75)-Object(o.a)(t,.25))*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";var r=n(70);e.a=function(t,e,n){return Math.ceil((n-e)/(3.5*Object(r.a)(t)*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&n>r&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&n>r&&(r=n);return r}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a=t.length,i=a,o=-1,u=0;if(null==e)for(;++o<a;)isNaN(n=Object(r.a)(t[o]))?--i:u+=n;else for(;++o<a;)isNaN(n=Object(r.a)(e(t[o],o,t)))?--i:u+=n;if(i)return u/i}},function(t,e,n){"use strict";var r=n(10),a=n(12),i=n(36);e.a=function(t,e){var n,o=t.length,u=-1,c=[];if(null==e)for(;++u<o;)isNaN(n=Object(a.a)(t[u]))||c.push(n);else for(;++u<o;)isNaN(n=Object(a.a)(e(t[u],u,t)))||c.push(n);return Object(i.a)(c.sort(r.a),.5)}},function(t,e,n){"use strict";e.a=function(t){for(var e,n,r,a=t.length,i=-1,o=0;++i<a;)o+=t[i].length;for(n=new Array(o);--a>=0;)for(r=t[a],e=r.length;--e>=0;)n[--o]=r[e];return n}},function(t,e,n){"use strict";e.a=function(t,e){for(var n=e.length,r=new Array(n);n--;)r[n]=t[e[n]];return r}},function(t,e,n){"use strict";var r=n(10);e.a=function(t,e){if(n=t.length){var n,a,i=0,o=0,u=t[o];for(null==e&&(e=r.a);++i<n;)(e(a=t[i],u)<0||0!==e(u,u))&&(u=a,o=i);return 0===e(u,u)?o:void 0}}},function(t,e,n){"use strict";e.a=function(t,e,n){for(var r,a,i=(null==n?t.length:n)-(e=null==e?0:+e);i;)a=Math.random()*i--|0,r=t[i+e],t[i+e]=t[a+e],t[a+e]=r;return t}},function(t,e,n){"use strict";e.a=function(t,e){var n,r=t.length,a=-1,i=0;if(null==e)for(;++a<r;)(n=+t[a])&&(i+=n);else for(;++a<r;)(n=+e(t[a],a,t))&&(i+=n);return i}},function(t,e,n){"use strict";var r=n(78);e.a=function(){return Object(r.a)(arguments)}},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(){},function(t,e){t.setTime(+t+e)},function(t,e){return e-t});a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)(function(e){e.setTime(Math.floor(e/t)*t)},function(e,n){e.setTime(+e+n*t)},function(e,n){return(n-e)/t}):a:null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.d)*a.d)},function(t,e){t.setTime(+t+e*a.d)},function(t,e){return(e-t)/a.d},function(t){return t.getUTCSeconds()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.c)*a.c)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){var e=t.getTimezoneOffset()*a.c%a.b;e<0&&(e+=a.b),t.setTime(Math.floor((+t-e)/a.b)*a.b+e)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"a",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.a},function(t){return t.getDate()-1});e.b=i;var o=i.range},function(t,e,n){"use strict";function weekday(t){return Object(r.a)(function(e){e.setDate(e.getDate()-(e.getDay()+7-t)%7),e.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+7*e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=weekday(0),o=weekday(1),u=weekday(2),c=weekday(3),s=weekday(4),f=weekday(5),l=weekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setDate(1),t.setHours(0,0,0,0)},function(t,e){t.setMonth(t.getMonth()+e)},function(t,e){return e.getMonth()-t.getMonth()+12*(e.getFullYear()-t.getFullYear())},function(t){return t.getMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setMonth(0,1),t.setHours(0,0,0,0)},function(t,e){t.setFullYear(t.getFullYear()+e)},function(t,e){return e.getFullYear()-t.getFullYear()},function(t){return t.getFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setFullYear(Math.floor(e.getFullYear()/t)*t),e.setMonth(0,1),e.setHours(0,0,0,0)},function(e,n){e.setFullYear(e.getFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCSeconds(0,0)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getUTCMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCMinutes(0,0,0)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getUTCHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+e)},function(t,e){return(e-t)/a.a},function(t){return t.getUTCDate()-1});e.a=i;var o=i.range},function(t,e,n){"use strict";function utcWeekday(t){return Object(r.a)(function(e){e.setUTCDate(e.getUTCDate()-(e.getUTCDay()+7-t)%7),e.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+7*e)},function(t,e){return(e-t)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=utcWeekday(0),o=utcWeekday(1),u=utcWeekday(2),c=utcWeekday(3),s=utcWeekday(4),f=utcWeekday(5),l=utcWeekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCMonth(t.getUTCMonth()+e)},function(t,e){return e.getUTCMonth()-t.getUTCMonth()+12*(e.getUTCFullYear()-t.getUTCFullYear())},function(t){return t.getUTCMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCFullYear(t.getUTCFullYear()+e)},function(t,e){return e.getUTCFullYear()-t.getUTCFullYear()},function(t){return t.getUTCFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setUTCFullYear(Math.floor(e.getUTCFullYear()/t)*t),e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0)},function(e,n){e.setUTCFullYear(e.getUTCFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";function parseIsoNative(t){var e=new Date(t);return isNaN(e)?null:e}var r=n(80),a=n(37),i=+new Date("2000-01-01T00:00:00.000Z")?parseIsoNative:Object(a.e)(r.b);e.a=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(216);n.d(e,"scaleBand",function(){return r.a}),n.d(e,"scalePoint",function(){return r.b});var a=n(222);n.d(e,"scaleIdentity",function(){return a.a});var i=n(14);n.d(e,"scaleLinear",function(){return i.a});var o=n(224);n.d(e,"scaleLog",function(){return o.a});var u=n(81);n.d(e,"scaleOrdinal",function(){return u.a}),n.d(e,"scaleImplicit",function(){return u.b});var c=n(225);n.d(e,"scalePow",function(){return c.a}),n.d(e,"scaleSqrt",function(){return c.b});var s=n(226);n.d(e,"scaleQuantile",function(){return s.a});var f=n(227);n.d(e,"scaleQuantize",function(){return f.a});var l=n(228);n.d(e,"scaleThreshold",function(){return l.a});var h=n(84);n.d(e,"scaleTime",function(){return h.b});var d=n(229);n.d(e,"scaleUtc",function(){return d.a});var p=n(230);n.d(e,"schemeCategory10",function(){return p.a});var b=n(231);n.d(e,"schemeCategory20b",function(){return b.a});var v=n(232);n.d(e,"schemeCategory20c",function(){return v.a});var m=n(233);n.d(e,"schemeCategory20",function(){return m.a});var y=n(234);n.d(e,"interpolateCubehelixDefault",function(){return y.a});var g=n(235);n.d(e,"interpolateRainbow",function(){return g.b}),n.d(e,"interpolateWarm",function(){return g.c}),n.d(e,"interpolateCool",function(){return g.a});var _=n(236);n.d(e,"interpolateViridis",function(){return _.a}),n.d(e,"interpolateMagma",function(){return _.c}),n.d(e,"interpolateInferno",function(){return _.b}),n.d(e,"interpolatePlasma",function(){return _.d});var x=n(237);n.d(e,"scaleSequential",function(){return x.a})},function(t,e,n){"use strict";function band(){function rescale(){var n=i().length,a=u[1]<u[0],h=u[a-0],d=u[1-a];t=(d-h)/Math.max(1,n-s+2*f),c&&(t=Math.floor(t)),h+=(d-h-t*(n-s))*l,e=t*(1-s),c&&(h=Math.round(h),e=Math.round(e));var p=Object(r.range)(n).map(function(e){return h+t*e});return o(a?p.reverse():p)}var t,e,n=Object(a.a)().unknown(void 0),i=n.domain,o=n.range,u=[0,1],c=!1,s=0,f=0,l=.5;return delete n.unknown,n.domain=function(t){return arguments.length?(i(t),rescale()):i()},n.range=function(t){return arguments.length?(u=[+t[0],+t[1]],rescale()):u.slice()},n.rangeRound=function(t){return u=[+t[0],+t[1]],c=!0,rescale()},n.bandwidth=function(){return e},n.step=function(){return t},n.round=function(t){return arguments.length?(c=!!t,rescale()):c},n.padding=function(t){return arguments.length?(s=f=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingInner=function(t){return arguments.length?(s=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingOuter=function(t){return arguments.length?(f=Math.max(0,Math.min(1,t)),rescale()):f},n.align=function(t){return arguments.length?(l=Math.max(0,Math.min(1,t)),rescale()):l},n.copy=function(){return band().domain(i()).range(u).round(c).paddingInner(s).paddingOuter(f).align(l)},rescale()}function pointish(t){var e=t.copy;return t.padding=t.paddingOuter,delete t.paddingInner,delete t.paddingOuter,t.copy=function(){return pointish(e())},t}function point(){return pointish(band().paddingInner(1))}e.a=band,e.b=point;var r=n(5),a=n(81)},function(t,e,n){"use strict";function createObject(){return{}}function setObject(t,e,n){t[e]=n}function createMap(){return Object(r.a)()}function setMap(t,e,n){t.set(e,n)}var r=n(38);e.a=function(){function apply(n,i,o,u){if(i>=a.length)return null!=t&&n.sort(t),null!=e?e(n):n;for(var c,s,f,l=-1,h=n.length,d=a[i++],p=Object(r.a)(),b=o();++l<h;)(f=p.get(c=d(s=n[l])+""))?f.push(s):p.set(c,[s]);return p.each(function(t,e){u(b,e,apply(t,i,o,u))}),b}function entries(t,n){if(++n>a.length)return t;var r,o=i[n-1];return null!=e&&n>=a.length?r=t.entries():(r=[],t.each(function(t,e){r.push({key:e,values:entries(t,n)})})),null!=o?r.sort(function(t,e){return o(t.key,e.key)}):r}var t,e,n,a=[],i=[];return n={object:function(t){return apply(t,0,createObject,setObject)},map:function(t){return apply(t,0,createMap,setMap)},entries:function(t){return entries(apply(t,0,createMap,setMap),0)},key:function(t){return a.push(t),n},sortKeys:function(t){return i[a.length-1]=t,n},sortValues:function(e){return t=e,n},rollup:function(t){return e=t,n}}}},function(t,e,n){"use strict";function Set(){}function set(t,e){var n=new Set;if(t instanceof Set)t.each(function(t){n.add(t)});else if(t){var r=-1,a=t.length;if(null==e)for(;++r<a;)n.add(t[r]);else for(;++r<a;)n.add(e(t[r],r,t))}return n}var r=n(38),a=r.a.prototype;Set.prototype=set.prototype={constructor:Set,has:a.has,add:function(t){return t+="",this[r.b+t]=t,this},remove:a.remove,clear:a.clear,values:a.keys,size:a.size,empty:a.empty,each:a.each},e.a=set},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(n);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(t[n]);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push({key:n,value:t[n]});return e}},function(t,e,n){"use strict";function identity(){function scale(t){return+t}var t=[0,1];return scale.invert=scale,scale.domain=scale.range=function(e){return arguments.length?(t=r.a.call(e,i.a),scale):t.slice()},scale.copy=function(){return identity().domain(t)},Object(a.b)(scale)}e.a=identity;var r=n(9),a=n(14),i=n(82)},function(t,e,n){"use strict";var r=n(5),a=n(21);e.a=function(t,e,n){var i,o=t[0],u=t[t.length-1],c=Object(r.tickStep)(o,u,null==e?10:e);switch(n=Object(a.formatSpecifier)(null==n?",f":n),n.type){case"s":var s=Math.max(Math.abs(o),Math.abs(u));return null!=n.precision||isNaN(i=Object(a.precisionPrefix)(c,s))||(n.precision=i),Object(a.formatPrefix)(n,s);case"":case"e":case"g":case"p":case"r":null!=n.precision||isNaN(i=Object(a.precisionRound)(c,Math.max(Math.abs(o),Math.abs(u))))||(n.precision=i-("e"===n.type));break;case"f":case"%":null!=n.precision||isNaN(i=Object(a.precisionFixed)(c))||(n.precision=i-2*("%"===n.type))}return Object(a.format)(n)}},function(t,e,n){"use strict";function deinterpolate(t,e){return(e=Math.log(e/t))?function(n){return Math.log(n/t)/e}:Object(i.a)(e)}function reinterpolate(t,e){return t<0?function(n){return-Math.pow(-e,n)*Math.pow(-t,1-n)}:function(n){return Math.pow(e,n)*Math.pow(t,1-n)}}function pow10(t){return isFinite(t)?+("1e"+t):t<0?0:t}function powp(t){return 10===t?pow10:t===Math.E?Math.exp:function(e){return Math.pow(t,e)}}function logp(t){return t===Math.E?Math.log:10===t&&Math.log10||2===t&&Math.log2||(t=Math.log(t),function(e){return Math.log(e)/t})}function reflect(t){return function(e){return-t(-e)}}function log(){function rescale(){return i=logp(n),c=powp(n),e()[0]<0&&(i=reflect(i),c=reflect(c)),t}var t=Object(u.b)(deinterpolate,reinterpolate).domain([1,10]),e=t.domain,n=10,i=logp(10),c=powp(10);return t.base=function(t){return arguments.length?(n=+t,rescale()):n},t.domain=function(t){return arguments.length?(e(t),rescale()):e()},t.ticks=function(t){var a,o=e(),u=o[0],s=o[o.length-1];(a=s<u)&&(d=u,u=s,s=d);var f,l,h,d=i(u),p=i(s),b=null==t?10:+t,v=[];if(!(n%1)&&p-d<b){if(d=Math.round(d)-1,p=Math.round(p)+1,u>0){for(;d<p;++d)for(l=1,f=c(d);l<n;++l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else for(;d<p;++d)for(l=n-1,f=c(d);l>=1;--l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else v=Object(r.ticks)(d,p,Math.min(p-d,b)).map(c);return a?v.reverse():v},t.tickFormat=function(e,r){if(null==r&&(r=10===n?".0e":","),"function"!=typeof r&&(r=Object(a.format)(r)),e===1/0)return r;null==e&&(e=10);var o=Math.max(1,n*e/t.ticks().length);return function(t){var e=t/c(Math.round(i(t)));return e*n<n-.5&&(e*=n),e<=o?r(t):""}},t.nice=function(){return e(Object(o.a)(e(),{floor:function(t){return c(Math.floor(i(t)))},ceil:function(t){return c(Math.ceil(i(t)))}}))},t.copy=function(){return Object(u.a)(t,log().base(n))},t}e.a=log;var r=n(5),a=n(21),i=n(39),o=n(83),u=n(18)},function(t,e,n){"use strict";function raise(t,e){return t<0?-Math.pow(-t,e):Math.pow(t,e)}function pow(){function deinterpolate(e,n){return(n=raise(n,t)-(e=raise(e,t)))?function(r){return(raise(r,t)-e)/n}:Object(r.a)(n)}function reinterpolate(e,n){return n=raise(n,t)-(e=raise(e,t)),function(r){return raise(e+n*r,1/t)}}var t=1,e=Object(i.b)(deinterpolate,reinterpolate),n=e.domain;return e.exponent=function(e){return arguments.length?(t=+e,n(n())):t},e.copy=function(){return Object(i.a)(e,pow().exponent(t))},Object(a.b)(e)}function sqrt(){return pow().exponent(.5)}e.a=pow,e.b=sqrt;var r=n(39),a=n(14),i=n(18)},function(t,e,n){"use strict";function quantile(){function rescale(){var a=0,i=Math.max(1,e.length);for(n=new Array(i-1);++a<i;)n[a-1]=Object(r.quantile)(t,a/i);return scale}function scale(t){if(!isNaN(t=+t))return e[Object(r.bisect)(n,t)]}var t=[],e=[],n=[];return scale.invertExtent=function(r){var a=e.indexOf(r);return a<0?[NaN,NaN]:[a>0?n[a-1]:t[0],a<n.length?n[a]:t[t.length-1]]},scale.domain=function(e){if(!arguments.length)return t.slice();t=[];for(var n,a=0,i=e.length;a<i;++a)null==(n=e[a])||isNaN(n=+n)||t.push(n);return t.sort(r.ascending),rescale()},scale.range=function(t){return arguments.length?(e=a.b.call(t),rescale()):e.slice()},scale.quantiles=function(){return n.slice()},scale.copy=function(){return quantile().domain(t).range(e)},scale}e.a=quantile;var r=n(5),a=n(9)},function(t,e,n){"use strict";function quantize(){function scale(t){if(t<=t)return u[Object(r.bisect)(o,t,0,n)]}function rescale(){var r=-1;for(o=new Array(n);++r<n;)o[r]=((r+1)*e-(r-n)*t)/(n+1);return scale}var t=0,e=1,n=1,o=[.5],u=[0,1];return scale.domain=function(n){return arguments.length?(t=+n[0],e=+n[1],rescale()):[t,e]},scale.range=function(t){return arguments.length?(n=(u=a.b.call(t)).length-1,rescale()):u.slice()},scale.invertExtent=function(r){var a=u.indexOf(r);return a<0?[NaN,NaN]:a<1?[t,o[0]]:a>=n?[o[n-1],e]:[o[a-1],o[a]]},scale.copy=function(){return quantize().domain([t,e]).range(u)},Object(i.b)(scale)}e.a=quantize;var r=n(5),a=n(9),i=n(14)},function(t,e,n){"use strict";function threshold(){function scale(a){if(a<=a)return e[Object(r.bisect)(t,a,0,n)]}var t=[.5],e=[0,1],n=1;return scale.domain=function(r){return arguments.length?(t=a.b.call(r),n=Math.min(t.length,e.length-1),scale):t.slice()},scale.range=function(r){return arguments.length?(e=a.b.call(r),n=Math.min(t.length,e.length-1),scale):e.slice()},scale.invertExtent=function(n){var r=e.indexOf(n);return[t[r-1],t[r]]},scale.copy=function(){return threshold().domain(t).range(e)},scale}e.a=threshold;var r=n(5),a=n(9)},function(t,e,n){"use strict";var r=n(84),a=n(40),i=n(35);e.a=function(){return Object(r.a)(i.utcYear,i.utcMonth,i.utcWeek,i.utcDay,i.utcHour,i.utcMinute,i.utcSecond,i.utcMillisecond,a.utcFormat).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)])}},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5")},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(300,.5,0),Object(r.cubehelix)(-240,.5,1))},function(t,e,n){"use strict";n.d(e,"c",function(){return i}),n.d(e,"a",function(){return o});var r=n(4),a=n(8),i=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(-100,.75,.35),Object(r.cubehelix)(80,1.5,.8)),o=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(260,.75,.35),Object(r.cubehelix)(80,1.5,.8)),u=Object(r.cubehelix)();e.b=function(t){(t<0||t>1)&&(t-=Math.floor(t));var e=Math.abs(t-.5);return u.h=360*t-100,u.s=1.5-1.5*e,u.l=.8-.9*e,u+""}},function(t,e,n){"use strict";function ramp(t){var e=t.length;return function(n){return t[Math.max(0,Math.min(e-1,Math.floor(n*e)))]}}n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"d",function(){return o});var r=n(16);e.a=ramp(Object(r.a)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));var a=ramp(Object(r.a)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),i=ramp(Object(r.a)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),o=ramp(Object(r.a)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"))},function(t,e,n){"use strict";function sequential(t){function scale(r){var i=(r-e)/(n-e);return t(a?Math.max(0,Math.min(1,i)):i)}var e=0,n=1,a=!1;return scale.domain=function(t){return arguments.length?(e=+t[0],n=+t[1],scale):[e,n]},scale.clamp=function(t){return arguments.length?(a=!!t,scale):a},scale.interpolator=function(e){return arguments.length?(t=e,scale):t},scale.copy=function(){return sequential(t).domain([e,n]).clamp(a)},Object(r.b)(scale)}e.a=sequential;var r=n(14)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{bar:'\n            <svg class="load-state bar-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 325">\n              \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(0 29)">\n                        <g stroke="#EFF2F5" stroke-dasharray="4 4">\n                            <path d="M.400592911 200.302477L710.674315 200.302477M.400592884 131.172748L710.674315 131.172748M.324410282 64.2071321L710.621499 64.2071321M.291004517.563888874L709.82431.563888889"/>\n                        </g>\n                        <g fill="#D2D6DF" transform="translate(63.08 11)">\n                            <polygon points="-.08 176 23.92 176 23.92 255 -.08 255"/>\n                            <polygon points="50.829 147 74.829 147 74.829 255 50.829 255"/>\n                            <polygon points="254.465 0 278.465 0 278.465 255 254.465 255"/>\n                            <polygon points="458.102 169 482.102 169 482.102 255 458.102 255"/>\n                            <polygon points="152.647 82 176.647 82 176.647 255 152.647 255"/>\n                            <polygon points="356.283 66 380.283 66 380.283 255 356.283 255"/>\n                            <polygon points="559.92 229 583.92 229 583.92 255 559.92 255"/>\n                            <polygon points="101.738 115 125.738 115 125.738 255 101.738 255"/>\n                            <polygon points="305.374 42 329.374 42 329.374 255 305.374 255"/>\n                            <polygon points="509.011 201 533.011 201 533.011 255 509.011 255"/>\n                            <polygon points="203.556 19 227.556 19 227.556 255 203.556 255"/>\n                            <polygon points="407.192 115 431.192 115 431.192 255 407.192 255"/>\n                        </g>\n                    </g>\n                    <polygon fill="#D2D6DF" fill-rule="nonzero" points="0 295 711 295 711 294 0 294"/>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',donut:'\n            <svg class="load-state donut-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 376 331">\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(116 107)">\n                        <circle cx="72" cy="72" r="72" stroke="#EFF2F5" stroke-linecap="round" stroke-width="9.6"/>\n                        <path stroke="#D2D6DF" stroke-width="19.2" d="M126.153559,119.524055 C137.264629,106.845712 144,90.2321371 144,72.0444604 C144,32.2554036 111.764502,0 72,0"/>\n                        <circle cx="72" cy="72" r="67.2" fill="#FFF"/>\n                    </g>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',line:'\n            <svg \n                class="load-state line-load-state" \n                xmlns="http://www.w3.org/2000/svg" \n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path \n                    id="chart-bg" \n                    class="chart-bg" \n                    style="stroke:#C3C6CF;" \n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n               <polyline \n                    id="chart-line" \n                    class="chart-line" \n                    style="stroke:#C3C6CF;stroke-width:4;fill:none;" \n                    points="8.8,175.8 62.4,237.7 116.1,184.7 169.7,175.8 223.3,57 277,176.8 330.6,176.8 384.3,122.5 437.9,176.8 491.6,176.8 545.2,218.4 598.8,122.5 652.5,184.7 706.1,135.1 "\n                />\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        '}}.call(e,n,e,t))&&(t.exports=r)},,,,,,,,,,,,,,,function(t,e,n){"use strict";var r;void 0!==(r=function(t){function exportChart(t,e,n){var r=createImage(convertSvgToHtml.call(this,t,n));r.onload=handleImageLoad.bind(r,createCanvas(this.width(),this.height()),e)}function addBackground(t){return t.replace(">",">"+c.styleBackgroundString)}function convertSvgToHtml(t,e){if(t){t.attr("version",1.1).attr("xmlns","http://www.w3.org/2000/svg");var n=a.initializeSerializer(),r=n(t.node());return r=formatHtmlByBrowser(r),r=prependTitle.call(this,r,e,parseInt(t.attr("width"),10)),r=addBackground(r)}}function createCanvas(t,e){var n=document.createElement("canvas");return n.height=e,n.width=t,n}function createImage(t){var e=new Image;return e.src=""+c.imageSourceBase+u(t),e}function drawImageOnCanvas(t,e){return e.getContext("2d").drawImage(t,0,0),e}function downloadCanvas(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:c.defaultFilename,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"image/png",r=t.toDataURL(n),a=document.createElement("a");a.href=r,a.download=e,document.body.appendChild(a),a.click(),document.body.removeChild(a)}function formatHtmlByBrowser(t){return navigator.userAgent.search("FireFox")>-1?t.replace(/url.*&quot;\)/,'url(&quot;linearGradient[id*="-gradient-"]&quot;);'):t}function handleImageLoad(t,e,n){n.preventDefault(),downloadCanvas(drawImageOnCanvas(this,t),e)}function prependTitle(t,e,n){if(!e||!n)return t;var a=r.grey;return t=t.replace(/<g/,'<text x="'+this.margin().left+'" y="'+c.titleTopOffset+'" font-family="'+c.titleFontFamily+'" font-size="'+c.titleFontSize+'" fill="'+a[6]+'"> '+e+" </text><g ")}var e=n(89),r=e.colorSchemas,a=(n(90),n(254)),i="undefined"!=typeof window,o=i&&window.btoa;o||(o=n(255).encode);var u=function(t){return o(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g,function(t,e){return String.fromCharCode("0x"+e)}))},c={styleClass:"britechartStyle",defaultFilename:"britechart.png",chartBackground:"white",imageSourceBase:"data:image/svg+xml;base64,",titleFontSize:"15px",titleFontFamily:"'Benton Sans', sans-serif",titleTopOffset:30,get styleBackgroundString(){return"<style>svg{background:"+this.chartBackground+";}</style>"}};return{exportChart:exportChart,convertSvgToHtml:convertSvgToHtml,createImage:createImage,drawImageOnCanvas:drawImageOnCanvas}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";t.exports=function(){return{initializeSerializer:function(){function computeDefaultStyleByTagName(t){var e={},n=document.body.appendChild(document.createElement(t)),r=window.getComputedStyle(n);return[].forEach.call(r,function(t){e[t]=r[t]}),document.body.removeChild(n),e}function getDefaultStyleByTagName(e){return e=e.toUpperCase(),t[e]||(t[e]=computeDefaultStyleByTagName(e)),t[e]}function serializeWithStyles(t){var n=[],r=void 0,a=void 0,i=void 0,o=void 0;if(t&&t.nodeType===Node.ELEMENT_NODE)return n=[],r=t.querySelectorAll("*"),[].forEach.call(r,function(t,r){e[t.tagName]||(a=window.getComputedStyle(t),i=getDefaultStyleByTagName(t.tagName),n[r]=t.style.cssText,[].forEach.call(a,function(e){a[e]!==i[e]&&(t.style[e]=a[e])}))}),o=t.outerHTML,r=[].map.call(r,function(t,e){return t.style.cssText=n[e],t}),o}var t={},e={BASE:!0,HEAD:!0,HTML:!0,META:!0,NOFRAME:!0,NOSCRIPT:!0,PARAM:!0,SCRIPT:!0,STYLE:!0,TITLE:!0},n=["A","ABBR","ADDRESS","AREA","ARTICLE","ASIDE","AUDIO","B","BASE","BDI","BDO","BLOCKQUOTE","BODY","BR","BUTTON","CANVAS","CAPTION","CENTER","CITE","CODE","COL","COLGROUP","COMMAND","DATALIST","DD","DEL","DETAILS","DFN","DIV","DL","DT","EM","EMBED","FIELDSET","FIGCAPTION","FIGURE","FONT","FOOTER","FORM","H1","H2","H3","H4","H5","H6","HEAD","HEADER","HGROUP","HR","HTML","I","IFRAME","IMG","INPUT","INS","KBD","LABEL","LEGEND","LI","LINK","MAP","MARK","MATH","MENU","META","METER","NAV","NOBR","NOSCRIPT","OBJECT","OL","OPTION","OPTGROUP","OUTPUT","P","PARAM","PRE","PROGRESS","Q","RP","RT","RUBY","S","SAMP","SCRIPT","SECTION","SELECT","SMALL","SOURCE","SPAN","STRONG","STYLE","SUB","SUMMARY","SUP","SVG","TABLE","TBODY","TD","TEXTAREA","TFOOT","TH","THEAD","TIME","TITLE","TR","TRACK","U","UL","VAR","VIDEO","WBR"];return[].forEach.call(n,function(n){e[n]||(t[n]=computeDefaultStyleByTagName(n))}),serializeWithStyles}}}()},function(t,e,n){(function(t,r){var a;!function(i){var o="object"==typeof e&&e,u=("object"==typeof t&&t&&t.exports,"object"==typeof r&&r);var c=function(t){this.message=t};c.prototype=new Error,c.prototype.name="InvalidCharacterError";var s=function(t){throw new c(t)},f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=/[\t\n\f\r ]/g,h=function(t){t=String(t).replace(l,"");var e=t.length;e%4==0&&(t=t.replace(/==?$/,""),e=t.length),(e%4==1||/[^+a-zA-Z0-9\/]/.test(t))&&s("Invalid character: the string to be decoded is not correctly encoded.");for(var n,r,a=0,i="",o=-1;++o<e;)r=f.indexOf(t.charAt(o)),n=a%4?64*n+r:r,a++%4&&(i+=String.fromCharCode(255&n>>(-2*a&6)));return i},d=function(t){t=String(t),/[^\0-\xFF]/.test(t)&&s("The string to be encoded contains characters outside of the Latin1 range.");for(var e,n,r,a,i=t.length%3,o="",u=-1,c=t.length-i;++u<c;)e=t.charCodeAt(u)<<16,n=t.charCodeAt(++u)<<8,r=t.charCodeAt(++u),a=e+n+r,o+=f.charAt(a>>18&63)+f.charAt(a>>12&63)+f.charAt(a>>6&63)+f.charAt(63&a);return 2==i?(e=t.charCodeAt(u)<<8,n=t.charCodeAt(++u),a=e+n,o+=f.charAt(a>>10)+f.charAt(a>>4&63)+f.charAt(a<<2&63)+"="):1==i&&(a=t.charCodeAt(u),o+=f.charAt(a>>2)+f.charAt(a<<4&63)+"=="),o},p={encode:d,decode:h,version:"0.1.0"};void 0!==(a=function(){return p}.call(e,n,e,t))&&(t.exports=a)}()}).call(e,n(256)(t),n(257))},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(259);n.d(e,"axisTop",function(){return r.d}),n.d(e,"axisRight",function(){return r.c}),n.d(e,"axisBottom",function(){return r.a}),n.d(e,"axisLeft",function(){return r.b})},function(t,e,n){"use strict";function translateX(t){return"translate("+(t+.5)+",0)"}function translateY(t){return"translate(0,"+(t+.5)+")"}function number(t){return function(e){return+t(e)}}function center(t){var e=Math.max(0,t.bandwidth()-1)/2;return t.round()&&(e=Math.round(e)),function(n){return+t(n)+e}}function entering(){return!this.__axis}function axis(t,e){function axis(r){var y=null==f?e.ticks?e.ticks.apply(e,n):e.domain():f,g=null==l?e.tickFormat?e.tickFormat.apply(e,n):a.a:l,_=Math.max(h,0)+p,x=e.range(),w=+x[0]+.5,O=+x[x.length-1]+.5,M=(e.bandwidth?center:number)(e.copy()),C=r.selection?r.selection():r,j=C.selectAll(".domain").data([null]),T=C.selectAll(".tick").data(y,e).order(),k=T.exit(),S=T.enter().append("g").attr("class","tick"),N=T.select("line"),A=T.select("text");j=j.merge(j.enter().insert("path",".tick").attr("class","domain").attr("stroke","#000")),T=T.merge(S),N=N.merge(S.append("line").attr("stroke","#000").attr(v+"2",b*h)),A=A.merge(S.append("text").attr("fill","#000").attr(v,b*_).attr("dy",t===i?"0em":t===u?"0.71em":"0.32em")),r!==C&&(j=j.transition(r),T=T.transition(r),N=N.transition(r),A=A.transition(r),k=k.transition(r).attr("opacity",s).attr("transform",function(t){return isFinite(t=M(t))?m(t):this.getAttribute("transform")}),S.attr("opacity",s).attr("transform",function(t){var e=this.parentNode.__axis;return m(e&&isFinite(e=e(t))?e:M(t))})),k.remove(),j.attr("d",t===c||t==o?"M"+b*d+","+w+"H0.5V"+O+"H"+b*d:"M"+w+","+b*d+"V0.5H"+O+"V"+b*d),T.attr("opacity",1).attr("transform",function(t){return m(M(t))}),N.attr(v+"2",b*h),A.attr(v,b*_).text(g),C.filter(entering).attr("fill","none").attr("font-size",10).attr("font-family","sans-serif").attr("text-anchor",t===o?"start":t===c?"end":"middle"),C.each(function(){this.__axis=M})}var n=[],f=null,l=null,h=6,d=6,p=3,b=t===i||t===c?-1:1,v=t===c||t===o?"x":"y",m=t===i||t===u?translateX:translateY;return axis.scale=function(t){return arguments.length?(e=t,axis):e},axis.ticks=function(){return n=r.a.call(arguments),axis},axis.tickArguments=function(t){return arguments.length?(n=null==t?[]:r.a.call(t),axis):n.slice()},axis.tickValues=function(t){return arguments.length?(f=null==t?null:r.a.call(t),axis):f&&f.slice()},axis.tickFormat=function(t){return arguments.length?(l=t,axis):l},axis.tickSize=function(t){return arguments.length?(h=d=+t,axis):h},axis.tickSizeInner=function(t){return arguments.length?(h=+t,axis):h},axis.tickSizeOuter=function(t){return arguments.length?(d=+t,axis):d},axis.tickPadding=function(t){return arguments.length?(p=+t,axis):p},axis}function axisTop(t){return axis(i,t)}function axisRight(t){return axis(o,t)}function axisBottom(t){return axis(u,t)}function axisLeft(t){return axis(c,t)}e.d=axisTop,e.c=axisRight,e.a=axisBottom,e.b=axisLeft;var r=n(260),a=n(261),i=1,o=2,u=3,c=4,s=1e-6},function(t,e,n){"use strict";n.d(e,"a",function(){return r});var r=Array.prototype.slice},function(t,e,n){"use strict";e.a=function(t){return t}},,,,,,,,,,,,,,,,,,,,,,,,,,,,function(t,e,n){"use strict";var r;void 0!==(r=function(t){var e=n(3),r={lineHeight:1.2,smallTextOffset:10,smallTextLineHeightRatio:.9,smallTextRatio:.6,valueClassName:"value",labelClassName:"label"},a=function(t,n,a,i){var o=e.select(i),u=o.text().split(/\s+/).reverse(),c=void 0,s=[],f=0,l=r.lineHeight*r.smallTextLineHeightRatio,h=o.attr("y"),d=parseFloat(o.attr("dy")),p=n*r.smallTextRatio,b=o.text(null).append("tspan").attr("x",t).attr("y",h-5).attr("dy",d+"em").classed(r.valueClassName,!0).style("font-size",n+"px");for(b.text(u.pop()),b=o.append("tspan").classed(r.labelClassName,!0).attr("x",t).attr("y",h+r.smallTextOffset).attr("dy",++f*l+d+"em").style("font-size",p+"px");c=u.pop();)s.push(c),b.text(s.join(" ")),b.node()&&b.node().getComputedTextLength()>a-50&&(s.pop(),b.text(s.join(" ")),s=[c],b=o.append("tspan").classed(r.labelClassName,!0).attr("x",t).attr("y",h+r.smallTextOffset).attr("dy",++f*l+d+"em").text(c).style("font-size",p+"px"))},i=function(t,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2;t.each(function(){var i,o,u,c,s,f,l,h;for(t=e.select(this),i=t.text().split(/\s+/).reverse(),u=[],c=0,s=1.2,f=t.attr("y"),l=parseFloat(t.attr("dy")),h=t.text(null).append("tspan").attr("x",r).attr("y",f).attr("dy",l+"em");o=i.pop();)if(u.push(o),h.text(u.join(" ")),h.node()&&h.node().getComputedTextLength()>n){if(u.pop(),h.text(u.join(" ")),!(c<a-1)){u.push("..."),h.text(u.join(" "));break}u=[o],h=t.append("tspan").attr("x",r).attr("y",f).attr("dy",++c*s+l+"em").text(o),t.classed("adjust-upwards",!0)}})};return{getTextWidth:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:12,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"Arial",r=document.createElement("canvas"),a=r.getContext("2d");return a.font=e+"px "+n,a.measureText(t).width},wrapText:a,wrapTextWithEllipses:i}}.call(e,n,e,t))&&(t.exports=r)},,,,,,,function(t,e,n){"use strict";function _toConsumableArray(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}var r;void 0!==(r=function(t){var e=n(5),r=n(65),a=n(258),i=n(4),o=n(66),u=n(21),c=n(215),s=n(3),f=(n(91),n(289)),l=n(253),h=l.exportChart,d=n(89),p=n(238),b=p.bar;return function(){function exports(e){e.each(function(e){y=n-t.left-t.right-1.2*P,g=l-t.top-t.bottom;var r=sortData(cleanData(e));v=r.data,m=r.dataZeroed,buildScales(),buildAxis(),buildSVG(this),drawGridLines(),drawBars(),drawAxis(),k&&drawPercentageLabels()})}function buildAxis(){L?(D=a.axisBottom(_).ticks(j,E).tickSizeInner([-g]),F=a.axisLeft(x)):(D=a.axisBottom(_),F=a.axisLeft(x).ticks(C,E))}function buildContainerGroups(){var e=U.append("g").classed("container-group",!0).attr("transform","translate("+(t.left+P)+", "+t.top+")");e.append("g").classed("grid-lines-group",!0),e.append("g").classed("chart-group",!0),e.append("g").classed("x-axis-group axis",!0),e.append("g").attr("transform","translate("+-1*P+", 0)").classed("y-axis-group axis",!0),e.append("g").classed("metadata-group",!0)}function buildScales(){var t=Math.min(T*e.max(v,Q));L?(_=c.scaleLinear().domain([0,t]).rangeRound([0,y]),x=c.scaleBand().domain(v.map(K)).rangeRound([g,0]).padding(S)):(_=c.scaleBand().domain(v.map(K)).rangeRound([0,y]).padding(S),x=c.scaleLinear().domain([0,t]).rangeRound([g,0])),O=Z?v.map(function(t){return t}).reverse().map(function(t,e){return{name:t.name,color:w[e%w.length]}}):v.map(function(t){return t}).map(function(t,e){return{name:t.name,color:w[e%w.length]}}),M=function(t){return O.filter(function(e){return e.name===t})[0].color}}function buildSVG(t){U||(U=s.select(t).append("svg").classed("britechart bar-chart",!0),buildContainerGroups()),U.attr("width",n).attr("height",l)}function cleanData(t){var e=t.reduce(function(t,e){return e.value=+e[W],e.name=String(e[V]),[].concat(_toConsumableArray(t),[e])},[]);return{data:e,dataZeroed:e.map(function(t){return{value:0,name:String(t[V])}})}}function sortData(t){var e=t.data,n=t.dataZeroed;return z&&(e.sort(z),n.sort(z)),{data:e,dataZeroed:n}}function wrapText(t,e){f.wrapTextWithEllipses(t,e,0,R)}function drawAxis(){U.select(".x-axis-group.axis").attr("transform","translate(0, "+g+")").call(D),U.select(".y-axis-group.axis").call(F),U.selectAll(".y-axis-group .tick text").call(wrapText,t.left-P)}function drawHorizontalBars(t){t.enter().append("rect").classed("bar",!0).attr("y",g).attr("x",0).attr("height",x.bandwidth()).attr("width",function(t){var e=t.value;return _(e)}).on("mouseover",function(t){handleMouseOver(this,t,y,g)}).on("mousemove",function(t){handleMouseMove(this,t,y,g)}).on("mouseout",function(t){handleMouseOut(this,t,y,g)}).on("click",function(t){handleClick(this,t,y,g)}).merge(t).attr("x",0).attr("y",function(t){var e=t.name;return x(e)}).attr("height",x.bandwidth()).attr("width",function(t){var e=t.value;return _(e)}).attr("fill",function(t){var e=t.name;return M(e)})}function drawAnimatedHorizontalBars(t){t.enter().append("rect").classed("bar",!0).attr("x",0).attr("y",g).attr("height",x.bandwidth()).attr("width",function(t){var e=t.value;return _(e)}).on("mouseover",function(t){handleMouseOver(this,t,y,g)}).on("mousemove",function(t){handleMouseMove(this,t,y,g)}).on("mouseout",function(t){handleMouseOut(this,t,y,g)}).on("click",function(t){handleClick(this,t,y,g)}),t.attr("x",0).attr("y",function(t){var e=t.name;return x(e)}).attr("height",x.bandwidth()).attr("fill",function(t){var e=t.name;return M(e)}).transition().duration(q).delay(B).ease(Y).attr("width",function(t){var e=t.value;return _(e)})}function drawAnimatedVerticalBars(t){t.enter().append("rect").classed("bar",!0).attr("x",y).attr("y",function(t){var e=t.value;return x(e)}).attr("width",_.bandwidth()).attr("height",function(t){var e=t.value;return g-x(e)}).on("mouseover",function(t){handleMouseOver(this,t,y,g)}).on("mousemove",function(t){handleMouseMove(this,t,y,g)}).on("mouseout",function(t){handleMouseOut(this,t,y,g)}).on("click",function(t){handleClick(this,t,y,g)}).merge(t).attr("x",function(t){var e=t.name;return _(e)}).attr("width",_.bandwidth()).attr("fill",function(t){var e=t.name;return M(e)}).transition().duration(q).delay(B).ease(Y).attr("y",function(t){var e=t.value;return x(e)}).attr("height",function(t){var e=t.value;return g-x(e)})}function drawVerticalBars(t){t.enter().append("rect").classed("bar",!0).attr("x",y).attr("y",function(t){var e=t.value;return x(e)}).attr("width",_.bandwidth()).attr("height",function(t){var e=t.value;return g-x(e)}).on("mouseover",function(t){handleMouseOver(this,t,y,g)}).on("mousemove",function(t){handleMouseMove(this,t,y,g)}).on("mouseout",function(t){handleMouseOut(this,t,y,g)}).on("click",function(t){handleClick(this,t,y,g)}).merge(t).attr("x",function(t){var e=t.name;return _(e)}).attr("y",function(t){var e=t.value;return x(e)}).attr("width",_.bandwidth()).attr("height",function(t){var e=t.value;return g-x(e)}).attr("fill",function(t){var e=t.name;return M(e)})}function drawPercentageLabels(){var t=L?J:et,e=L?tt:nt,n=L?rt:at;U.select(".metadata-group").append("g").classed("percentage-label-group",!0).selectAll("text").data(v.reverse()).enter().append("text").classed("percentage-label",!0).attr("x",t).attr("y",e).text(n).attr("font-size",A+"px")}function drawBars(){var t=void 0;H?(t=U.select(".chart-group").selectAll(".bar").data(m),L?drawHorizontalBars(t):drawVerticalBars(t),t=U.select(".chart-group").selectAll(".bar").data(v),L?drawAnimatedHorizontalBars(t):drawAnimatedVerticalBars(t)):(t=U.select(".chart-group").selectAll(".bar").data(v),L?drawHorizontalBars(t):drawVerticalBars(t)),t.exit().transition().style("opacity",0).remove()}function drawGridLines(){L?drawHorizontalGridLines():drawVerticalGridLines()}function drawHorizontalGridLines(){X=U.select(".grid-lines-group").selectAll("line.vertical-grid-line").data(_.ticks(4)).enter().append("line").attr("class","vertical-grid-line").attr("y1",I.left).attr("y2",g).attr("x1",function(t){return _(t)}).attr("x2",function(t){return _(t)}),drawVerticalExtendedLine()}function drawVerticalExtendedLine(){G=U.select(".grid-lines-group").selectAll("line.extended-y-line").data([0]).enter().append("line").attr("class","extended-y-line").attr("y1",I.bottom).attr("y2",g).attr("x1",0).attr("x2",0)}function drawVerticalGridLines(){X=U.select(".grid-lines-group").selectAll("line.horizontal-grid-line").data(x.ticks(4)).enter().append("line").attr("class","horizontal-grid-line").attr("x1",I.left).attr("x2",y).attr("y1",function(t){return x(t)}).attr("y2",function(t){return x(t)}),drawHorizontalExtendedLine()}function drawHorizontalExtendedLine(){G=U.select(".grid-lines-group").selectAll("line.extended-x-line").data([0]).enter().append("line").attr("class","extended-x-line").attr("x1",I.left).attr("x2",y).attr("y1",g).attr("y2",g)}function handleMouseOver(t,e,n,r){$.call("customMouseOver",t,e,s.mouse(t),[n,r]),s.select(t).attr("fill",function(t){var e=t.name;return i.color(M(e)).darker()})}function handleMouseMove(t,e,n,r){$.call("customMouseMove",t,e,s.mouse(t),[n,r])}function handleMouseOut(t,e,n,r){$.call("customMouseOut",t,e,s.mouse(t),[n,r]),s.select(t).attr("fill",function(t){var e=t.name;return M(e)})}function handleClick(t,e,n,r){$.call("customClick",t,e,s.mouse(t),[n,r])}var t={top:20,right:20,bottom:30,left:40},n=960,l=500,p=b,v=void 0,m=void 0,y=void 0,g=void 0,_=void 0,x=void 0,w=d.singleColors.aloeGreen,O=void 0,M=void 0,C=5,j=5,T=1,k=!1,S=.1,N=7,A=12,E=",f",D=void 0,F=void 0,I={top:0,left:0,bottom:0,right:0},P=10,R=1,L=!1,U=void 0,H=!1,Y=r.easeQuadInOut,q=800,B=function(t,e){return 70*e},z=void 0,W="value",V="name",G=void 0,X=void 0,Z=!0,$=o.dispatch("customMouseOver","customMouseOut","customMouseMove","customClick"),K=function(t){return t.name},Q=function(t){return t.value},J=function(t){var e=t.value;return _(e)+N},tt=function(t){var e=t.name;return x(e)+x.bandwidth()/2+A*(3/8)},et=function(t){var e=t.name;return _(e)},nt=function(t){var e=t.value;return x(e)-N},rt=function(t){var e=t.value;return u.format(".0%")(e)},at=function(t){var e=t.value;return u.format(".0f")(100*parseFloat(e))};return exports.betweenBarsPadding=function(t){return arguments.length?(S=t,this):S},exports.colorSchema=function(t){return arguments.length?(w=t,this):w},exports.enablePercentageLabels=function(t){return arguments.length?(k=t,this):k},exports.exportChart=function(t,e){h.call(exports,U,t,e)},exports.height=function(t){return arguments.length?(l=t,this):l},exports.isAnimated=function(t){return arguments.length?(H=t,this):H},exports.isHorizontal=function(t){return arguments.length?(L=t,this):L},exports.loadingState=function(t){return arguments.length?(p=t,this):p},exports.margin=function(e){return arguments.length?(t=e,this):t},exports.nameLabel=function(t){return arguments.length?(V=t,this):V},exports.numberFormat=function(t){return arguments.length?(E=t,this):E},exports.on=function(){var t=$.on.apply($,arguments);return t===$?exports:t},exports.percentageAxisToMaxRatio=function(t){return arguments.length?(T=t,this):T},exports.percentageLabelMargin=function(t){return arguments.length?(N=t,this):N},exports.shouldReverseColorList=function(t){return arguments.length?(Z=t,this):Z},exports.orderingFunction=function(t){return arguments.length?(z=t,this):z},exports.hasPercentage=function(t){return arguments.length?(E=t?"%":",f",this):"%"===E},exports.usePercentage=function(t){return arguments.length?(E=t?"%":",f",this):"%"===E},exports.valueLabel=function(t){return arguments.length?(W=t,this):W},exports.width=function(t){return arguments.length?(n=t,this):n},exports.xTicks=function(t){return arguments.length?(j=t,this):j},exports.yAxisPaddingBetweenChart=function(t){return arguments.length?(P=t,this):P},exports.yTicks=function(t){return arguments.length?(C=t,this):C},exports}}.call(e,n,e,t))&&(t.exports=r)}])})},function(t,e,n){"use strict";function local(){return new Local}function Local(){this._="@"+(++r).toString(36)}e.a=local;var r=0;Local.prototype=local.prototype={constructor:Local,get:function(t){for(var e=this._;!(e in t);)if(!(t=t.parentNode))return;return t[e]},set:function(t,e){return t[this._]=e},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}}},function(t,e,n){"use strict";var r=n(24),a=n(15);e.a=function(t){var e=Object(r.a)();return e.changedTouches&&(e=e.changedTouches[0]),Object(a.a)(t,e)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,e,n){"use strict";var r=n(1),a=n(26);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c,s=e[o],f=s.length,l=i[o]=new Array(f),h=0;h<f;++h)(u=s[h])&&(c=t.call(u,u.__data__,h,s))&&("__data__"in u&&(c.__data__=u.__data__),l[h]=c);return new r.a(i,this._parents)}},function(t,e,n){"use strict";var r=n(1),a=n(36);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=[],o=[],u=0;u<n;++u)for(var c,s=e[u],f=s.length,l=0;l<f;++l)(c=s[l])&&(i.push(t.call(c,c.__data__,l,s)),o.push(c));return new r.a(i,o)}},function(t,e,n){"use strict";var r=n(1),a=n(35);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new r.a(i,this._parents)}},function(t,e,n){"use strict";function bindIndex(t,e,n,r,i,o){for(var u,c=0,s=e.length,f=o.length;c<f;++c)(u=e[c])?(u.__data__=o[c],r[c]=u):n[c]=new a.a(t,o[c]);for(;c<s;++c)(u=e[c])&&(i[c]=u)}function bindKey(t,e,n,r,i,u,c){var s,f,l,h={},d=e.length,p=u.length,b=new Array(d);for(s=0;s<d;++s)(f=e[s])&&(b[s]=l=o+c.call(f,f.__data__,s,e),l in h?i[s]=f:h[l]=f);for(s=0;s<p;++s)l=o+c.call(t,u[s],s,u),(f=h[l])?(r[s]=f,f.__data__=u[s],h[l]=null):n[s]=new a.a(t,u[s]);for(s=0;s<d;++s)(f=e[s])&&h[b[s]]===f&&(i[s]=f)}var r=n(1),a=n(37),i=n(69),o="$";e.a=function(t,e){if(!t)return b=new Array(this.size()),l=-1,this.each(function(t){b[++l]=t}),b;var n=e?bindKey:bindIndex,a=this._parents,o=this._groups;"function"!=typeof t&&(t=Object(i.a)(t));for(var u=o.length,c=new Array(u),s=new Array(u),f=new Array(u),l=0;l<u;++l){var h=a[l],d=o[l],p=d.length,b=t.call(h,h&&h.__data__,l,a),v=b.length,m=s[l]=new Array(v),y=c[l]=new Array(v);n(h,d,m,y,f[l]=new Array(p),b,e);for(var g,_,x=0,w=0;x<v;++x)if(g=m[x]){for(x>=w&&(w=x+1);!(_=y[w])&&++w<v;);g._next=_||null}}return c=new r.a(c,a),c._enter=s,c._exit=f,c}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(38),a=n(1);e.a=function(){return new a.a(this._exit||this._groups.map(r.a),this._parents)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents)}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=-1,n=t.length;++e<n;)for(var r,a=t[e],i=a.length-1,o=a[i];--i>=0;)(r=a[i])&&(o&&o!==r.nextSibling&&o.parentNode.insertBefore(r,o),o=r);return this}},function(t,e,n){"use strict";function ascending(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}var r=n(1);e.a=function(t){function compareNode(e,n){return e&&n?t(e.__data__,n.__data__):!e-!n}t||(t=ascending);for(var e=this._groups,n=e.length,a=new Array(n),i=0;i<n;++i){for(var o,u=e[i],c=u.length,s=a[i]=new Array(c),f=0;f<c;++f)(o=u[f])&&(s[f]=o);s.sort(compareNode)}return new r.a(a,this._parents).order()}},function(t,e,n){"use strict";e.a=function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}},function(t,e,n){"use strict";e.a=function(){var t=new Array(this.size()),e=-1;return this.each(function(){t[++e]=this}),t}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=0,n=t.length;e<n;++e)for(var r=t[e],a=0,i=r.length;a<i;++a){var o=r[a];if(o)return o}return null}},function(t,e,n){"use strict";e.a=function(){var t=0;return this.each(function(){++t}),t}},function(t,e,n){"use strict";e.a=function(){return!this.node()}},function(t,e,n){"use strict";e.a=function(t){for(var e=this._groups,n=0,r=e.length;n<r;++n)for(var a,i=e[n],o=0,u=i.length;o<u;++o)(a=i[o])&&t.call(a,a.__data__,o,i);return this}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e){return function(){this.setAttribute(t,e)}}function attrConstantNS(t,e){return function(){this.setAttributeNS(t.space,t.local,e)}}function attrFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttribute(t):this.setAttribute(t,n)}}function attrFunctionNS(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,n)}}var r=n(22);e.a=function(t,e){var n=Object(r.a)(t);if(arguments.length<2){var a=this.node();return n.local?a.getAttributeNS(n.space,n.local):a.getAttribute(n)}return this.each((null==e?n.local?attrRemoveNS:attrRemove:"function"==typeof e?n.local?attrFunctionNS:attrFunction:n.local?attrConstantNS:attrConstant)(n,e))}},function(t,e,n){"use strict";function propertyRemove(t){return function(){delete this[t]}}function propertyConstant(t,e){return function(){this[t]=e}}function propertyFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?delete this[t]:this[t]=n}}e.a=function(t,e){return arguments.length>1?this.each((null==e?propertyRemove:"function"==typeof e?propertyFunction:propertyConstant)(t,e)):this.node()[t]}},function(t,e,n){"use strict";function classArray(t){return t.trim().split(/^|\s+/)}function classList(t){return t.classList||new ClassList(t)}function ClassList(t){this._node=t,this._names=classArray(t.getAttribute("class")||"")}function classedAdd(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.add(e[r])}function classedRemove(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.remove(e[r])}function classedTrue(t){return function(){classedAdd(this,t)}}function classedFalse(t){return function(){classedRemove(this,t)}}function classedFunction(t,e){return function(){(e.apply(this,arguments)?classedAdd:classedRemove)(this,t)}}ClassList.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var e=this._names.indexOf(t);e>=0&&(this._names.splice(e,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}},e.a=function(t,e){var n=classArray(t+"");if(arguments.length<2){for(var r=classList(this.node()),a=-1,i=n.length;++a<i;)if(!r.contains(n[a]))return!1;return!0}return this.each(("function"==typeof e?classedFunction:e?classedTrue:classedFalse)(n,e))}},function(t,e,n){"use strict";function textRemove(){this.textContent=""}function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t.apply(this,arguments);this.textContent=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?textRemove:("function"==typeof t?textFunction:textConstant)(t)):this.node().textContent}},function(t,e,n){"use strict";function htmlRemove(){this.innerHTML=""}function htmlConstant(t){return function(){this.innerHTML=t}}function htmlFunction(t){return function(){var e=t.apply(this,arguments);this.innerHTML=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?htmlRemove:("function"==typeof t?htmlFunction:htmlConstant)(t)):this.node().innerHTML}},function(t,e,n){"use strict";function raise(){this.nextSibling&&this.parentNode.appendChild(this)}e.a=function(){return this.each(raise)}},function(t,e,n){"use strict";function lower(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}e.a=function(){return this.each(lower)}},function(t,e,n){"use strict";var r=n(21);e.a=function(t){var e="function"==typeof t?t:Object(r.a)(t);return this.select(function(){return this.appendChild(e.apply(this,arguments))})}},function(t,e,n){"use strict";function constantNull(){return null}var r=n(21),a=n(26);e.a=function(t,e){var n="function"==typeof t?t:Object(r.a)(t),i=null==e?constantNull:"function"==typeof e?e:Object(a.a)(e);return this.select(function(){return this.insertBefore(n.apply(this,arguments),i.apply(this,arguments)||null)})}},function(t,e,n){"use strict";function remove(){var t=this.parentNode;t&&t.removeChild(this)}e.a=function(){return this.each(remove)}},function(t,e,n){"use strict";e.a=function(t){return arguments.length?this.property("__data__",t):this.node().__data__}},function(t,e,n){"use strict";function dispatchEvent(t,e,n){var a=Object(r.a)(t),i=a.CustomEvent;"function"==typeof i?i=new i(e,n):(i=a.document.createEvent("Event"),n?(i.initEvent(e,n.bubbles,n.cancelable),i.detail=n.detail):i.initEvent(e,!1,!1)),t.dispatchEvent(i)}function dispatchConstant(t,e){return function(){return dispatchEvent(this,t,e)}}function dispatchFunction(t,e){return function(){return dispatchEvent(this,t,e.apply(this,arguments))}}var r=n(27);e.a=function(t,e){return this.each(("function"==typeof e?dispatchFunction:dispatchConstant)(t,e))}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([document.querySelectorAll(t)],[document.documentElement]):new r.a([null==t?[]:t],r.c)}},function(t,e,n){"use strict";var r=n(24),a=n(15);e.a=function(t,e,n){arguments.length<3&&(n=e,e=Object(r.a)().changedTouches);for(var i,o=0,u=e?e.length:0;o<u;++o)if((i=e[o]).identifier===n)return Object(a.a)(t,i);return null}},function(t,e,n){"use strict";var r=n(24),a=n(15);e.a=function(t,e){null==e&&(e=Object(r.a)().touches);for(var n=0,i=e?e.length:0,o=new Array(i);n<i;++n)o[n]=Object(a.a)(t,e[n]);return o}},function(t,e,n){"use strict";function _interopRequireDefault(t){return t&&t.__esModule?t:{default:t}}function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},a=function(){function defineProperties(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(t,e,n){return e&&defineProperties(t.prototype,e),n&&defineProperties(t,n),t}}(),i=n(4),o=_interopRequireDefault(i),u=n(6),c=_interopRequireDefault(u),s=n(96),f=_interopRequireDefault(s),l=n(17),h=function(t){function Donut(){return _classCallCheck(this,Donut),_possibleConstructorReturn(this,(Donut.__proto__||Object.getPrototypeOf(Donut)).apply(this,arguments))}return _inherits(Donut,t),a(Donut,[{key:"componentDidMount",value:function(){this.props.shouldShowLoadingState||this._createChart()}},{key:"componentDidUpdate",value:function(){this.props.shouldShowLoadingState||(this._chart?this._updateChart():this._createChart())}},{key:"componentWillUnmount",value:function(){this.props.chart.destroy(this._rootNode)}},{key:"_createChart",value:function(){this._chart=this.props.chart.create(this._rootNode,this.props.data,this._getChartConfiguration())}},{key:"_updateChart",value:function(){this.props.chart.update(this._rootNode,this.props.data,this._getChartConfiguration(),this._chart)}},{key:"_getChartConfiguration",value:function(){var t=r({},this.props);return delete t.data,delete t.chart,delete t.shouldShowLoadingState,t}},{key:"_setRef",value:function(t){this._rootNode=t}},{key:"render",value:function(){return(0,l.loadingContainerWrapper)(this.props,this.props.loadingState||this.props.chart.loading(),o.default.createElement("div",{className:"donut-container",ref:this._setRef.bind(this)}))}}]),Donut}(i.Component);h.PropTypes={data:c.default.array,colorSchema:c.default.arrayOf(c.default.string),externalRadius:c.default.number,hasFixedHighlightedSlice:c.default.boolean,height:c.default.number,highlightSliceById:c.default.number,internalRadius:c.default.number,isAnimated:c.default.boolean,margin:c.default.shape({top:c.default.number,bottom:c.default.number,left:c.default.number,right:c.default.number}),orderingFunction:c.default.func,shouldShowLoadingState:c.default.bool,width:c.default.number,customMouseOver:c.default.func,customMouseOut:c.default.func,chart:c.default.object},h.defaultProps={chart:f.default,isAnimated:!0,shouldShowLoadingState:!1},e.default=h},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(97),a=function(t){return t&&t.__esModule?t:{default:t}}(r),i=n(8),o=n(9),u=n(10),c=n(16),s={};s.create=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=(0,i.select)(t),c=(0,a.default)();return(0,o.validateData)(e),(0,o.validateContainer)(r),(0,o.validateConfiguration)(c,n),r.datum(e).call((0,u.applyConfiguration)(c,n)),c},s.update=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=arguments[3],a=(0,i.select)(t);return(0,o.validateContainer)(a),(0,o.validateConfiguration)(r,n),(0,u.applyConfiguration)(r,n),e?a.datum(e).call(r):a.call(r),r},s.destroy=function(){},s.loading=function(){return c.donut},e.default=s},function(t,e,n){!function(e,n){t.exports=n()}(0,function(){return function(t){function __webpack_require__(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,__webpack_require__),r.l=!0,r.exports}var e={};return __webpack_require__.m=t,__webpack_require__.c=e,__webpack_require__.d=function(t,e,n){__webpack_require__.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},__webpack_require__.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return __webpack_require__.d(e,"a",e),e},__webpack_require__.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=297)}([function(t,e,n){"use strict";function newInterval(t,e,n,i){function interval(e){return t(e=new Date(+e)),e}return interval.floor=interval,interval.ceil=function(n){return t(n=new Date(n-1)),e(n,1),t(n),n},interval.round=function(t){var e=interval(t),n=interval.ceil(t);return t-e<n-t?e:n},interval.offset=function(t,n){return e(t=new Date(+t),null==n?1:Math.floor(n)),t},interval.range=function(n,r,a){var i=[];if(n=interval.ceil(n),a=null==a?1:Math.floor(a),!(n<r&&a>0))return i;do{i.push(new Date(+n))}while(e(n,a),t(n),n<r);return i},interval.filter=function(n){return newInterval(function(e){if(e>=e)for(;t(e),!n(e);)e.setTime(e-1)},function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;e(t,-1),!n(t););else for(;--r>=0;)for(;e(t,1),!n(t););})},n&&(interval.count=function(e,i){return r.setTime(+e),a.setTime(+i),t(r),t(a),Math.floor(n(r,a))},interval.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?interval.filter(i?function(e){return i(e)%t==0}:function(e){return interval.count(0,e)%t==0}):interval:null}),interval}e.a=newInterval;var r=new Date,a=new Date},function(t,e,n){"use strict";function Selection(t,e){this._groups=t,this._parents=e}function selection(){return new Selection([[document.documentElement]],E)}n.d(e,"c",function(){return E}),e.a=Selection;var r=n(128),a=n(129),i=n(130),o=n(131),u=n(55),c=n(133),s=n(134),f=n(135),l=n(136),h=n(137),d=n(138),p=n(139),b=n(140),v=n(141),m=n(142),y=n(143),g=n(57),_=n(144),x=n(145),w=n(146),O=n(147),M=n(148),C=n(149),j=n(150),T=n(151),k=n(152),S=n(153),N=n(29),A=n(154),E=[null];Selection.prototype=selection.prototype={constructor:Selection,select:r.a,selectAll:a.a,filter:i.a,data:o.a,enter:u.b,exit:c.a,merge:s.a,order:f.a,sort:l.a,call:h.a,nodes:d.a,node:p.a,size:b.a,empty:v.a,each:m.a,attr:y.a,style:g.a,property:_.a,classed:x.a,text:w.a,html:O.a,raise:M.a,lower:C.a,append:j.a,insert:T.a,remove:k.a,datum:S.a,on:N.b,dispatch:A.a},e.b=selection},function(t,e,n){"use strict";function init(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>u)throw new Error("too late");return n}function set(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>s)throw new Error("too late");return n}function get(t,e){var n=t.__transition;if(!n||!(n=n[e]))throw new Error("too late");return n}function create(t,e,n){function schedule(t){n.state=c,n.timer.restart(start,n.delay,n.time),n.delay<=t&&start(t-n.delay)}function start(o){var u,h,p,b;if(n.state!==c)return stop();for(u in i)if(b=i[u],b.name===n.name){if(b.state===f)return Object(a.b)(start);b.state===l?(b.state=d,b.timer.stop(),b.on.call("interrupt",t,t.__data__,b.index,b.group),delete i[u]):+u<e&&(b.state=d,b.timer.stop(),delete i[u])}if(Object(a.b)(function(){n.state===f&&(n.state=l,n.timer.restart(tick,n.delay,n.time),tick(o))}),n.state=s,n.on.call("start",t,t.__data__,n.index,n.group),n.state===s){for(n.state=f,r=new Array(p=n.tween.length),u=0,h=-1;u<p;++u)(b=n.tween[u].value.call(t,t.__data__,n.index,n.group))&&(r[++h]=b);r.length=h+1}}function tick(e){for(var a=e<n.duration?n.ease.call(null,e/n.duration):(n.timer.restart(stop),n.state=h,1),i=-1,o=r.length;++i<o;)r[i].call(null,a);n.state===h&&(n.on.call("end",t,t.__data__,n.index,n.group),stop())}function stop(){n.state=d,n.timer.stop(),delete i[e];for(var r in i)return;delete t.__transition}var r,i=t.__transition;i[e]=n,n.timer=Object(a.c)(schedule,0,n.time)}n.d(e,"c",function(){return c}),n.d(e,"d",function(){return s}),n.d(e,"b",function(){return h}),n.d(e,"a",function(){return d}),e.g=init,e.h=set,e.f=get;var r=n(66),a=n(59),i=Object(r.dispatch)("start","end","interrupt"),o=[],u=0,c=1,s=2,f=3,l=4,h=5,d=6;e.e=function(t,e,n,r,a,c){var s=t.__transition;if(s){if(n in s)return}else t.__transition={};create(t,n,{name:e,index:r,group:a,on:i,tween:o,time:c.time,delay:c.delay,duration:c.duration,ease:c.ease,timer:null,state:u})}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(25);n.d(e,"creator",function(){return r.a});var a=n(125);n.d(e,"local",function(){return a.a});var i=n(53);n.d(e,"matcher",function(){return i.a});var o=n(126);n.d(e,"mouse",function(){return o.a});var u=n(26);n.d(e,"namespace",function(){return u.a});var c=n(27);n.d(e,"namespaces",function(){return c.a});var s=n(127);n.d(e,"select",function(){return s.a});var f=n(155);n.d(e,"selectAll",function(){return f.a});var l=n(1);n.d(e,"selection",function(){return l.b});var h=n(31);n.d(e,"selector",function(){return h.a});var d=n(54);n.d(e,"selectorAll",function(){return d.a});var p=n(57);n.d(e,"style",function(){return p.b});var b=n(156);n.d(e,"touch",function(){return b.a});var v=n(157);n.d(e,"touches",function(){return v.a});var m=n(32);n.d(e,"window",function(){return m.a});var y=n(29);n.d(e,"event",function(){return y.c}),n.d(e,"customEvent",function(){return y.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(19);n.d(e,"color",function(){return r.e}),n.d(e,"rgb",function(){return r.g}),n.d(e,"hsl",function(){return r.f});var a=n(102);n.d(e,"lab",function(){return a.a}),n.d(e,"hcl",function(){return a.b});var i=n(103);n.d(e,"cubehelix",function(){return i.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(67);n.d(e,"bisect",function(){return r.c}),n.d(e,"bisectRight",function(){return r.b}),n.d(e,"bisectLeft",function(){return r.a});var a=n(10);n.d(e,"ascending",function(){return a.a});var i=n(68);n.d(e,"bisector",function(){return i.a});var o=n(184);n.d(e,"cross",function(){return o.a});var u=n(185);n.d(e,"descending",function(){return u.a});var c=n(70);n.d(e,"deviation",function(){return c.a});var s=n(72);n.d(e,"extent",function(){return s.a});var f=n(186);n.d(e,"histogram",function(){return f.a});var l=n(189);n.d(e,"thresholdFreedmanDiaconis",function(){return l.a});var h=n(190);n.d(e,"thresholdScott",function(){return h.a});var d=n(76);n.d(e,"thresholdSturges",function(){return d.a});var p=n(191);n.d(e,"max",function(){return p.a});var b=n(192);n.d(e,"mean",function(){return b.a});var v=n(193);n.d(e,"median",function(){return v.a});var m=n(194);n.d(e,"merge",function(){return m.a});var y=n(77);n.d(e,"min",function(){return y.a});var g=n(69);n.d(e,"pairs",function(){return g.a});var _=n(195);n.d(e,"permute",function(){return _.a});var x=n(36);n.d(e,"quantile",function(){return x.a});var w=n(74);n.d(e,"range",function(){return w.a});var O=n(196);n.d(e,"scan",function(){return O.a});var M=n(197);n.d(e,"shuffle",function(){return M.a});var C=n(198);n.d(e,"sum",function(){return C.a});var j=n(75);n.d(e,"ticks",function(){return j.a}),n.d(e,"tickIncrement",function(){return j.b}),n.d(e,"tickStep",function(){return j.c});var T=n(78);n.d(e,"transpose",function(){return T.a});var k=n(71);n.d(e,"variance",function(){return k.a});var S=n(199);n.d(e,"zip",function(){return S.a})},function(t,e,n){"use strict";n.d(e,"d",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"a",function(){return o}),n.d(e,"e",function(){return u});var r=1e3,a=6e4,i=36e5,o=864e5,u=6048e5},function(t,e,n){"use strict";function Transition(t,e,n,r){this._groups=t,this._parents=e,this._name=n,this._id=r}function transition(t){return Object(r.selection)().transition(t)}function newId(){return++x}e.a=Transition,e.b=transition,e.c=newId;var r=n(3),a=n(163),i=n(164),o=n(165),u=n(166),c=n(167),s=n(168),f=n(169),l=n(170),h=n(171),d=n(172),p=n(173),b=n(174),v=n(175),m=n(176),y=n(177),g=n(178),_=n(17),x=0,w=r.selection.prototype;Transition.prototype=transition.prototype={constructor:Transition,select:d.a,selectAll:p.a,filter:s.a,merge:f.a,selection:b.a,transition:g.a,call:w.call,nodes:w.nodes,node:w.node,size:w.size,empty:w.empty,each:w.each,on:l.a,attr:a.a,attrTween:i.a,style:v.a,styleTween:m.a,text:y.a,remove:h.a,tween:_.a,delay:o.a,duration:u.a,ease:c.a}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(23);n.d(e,"interpolate",function(){return r.a});var a=n(49);n.d(e,"interpolateArray",function(){return a.a});var i=n(24);n.d(e,"interpolateBasis",function(){return i.b});var o=n(47);n.d(e,"interpolateBasisClosed",function(){return o.a});var u=n(50);n.d(e,"interpolateDate",function(){return u.a});var c=n(15);n.d(e,"interpolateNumber",function(){return c.a});var s=n(51);n.d(e,"interpolateObject",function(){return s.a});var f=n(115);n.d(e,"interpolateRound",function(){return f.a});var l=n(52);n.d(e,"interpolateString",function(){return l.a});var h=n(116);n.d(e,"interpolateTransformCss",function(){return h.a}),n.d(e,"interpolateTransformSvg",function(){return h.b});var d=n(119);n.d(e,"interpolateZoom",function(){return d.a});var p=n(46);n.d(e,"interpolateRgb",function(){return p.a}),n.d(e,"interpolateRgbBasis",function(){return p.b}),n.d(e,"interpolateRgbBasisClosed",function(){return p.c});var b=n(120);n.d(e,"interpolateHsl",function(){return b.a}),n.d(e,"interpolateHslLong",function(){return b.b});var v=n(121);n.d(e,"interpolateLab",function(){return v.a});var m=n(122);n.d(e,"interpolateHcl",function(){return m.a}),n.d(e,"interpolateHclLong",function(){return m.b});var y=n(123);n.d(e,"interpolateCubehelix",function(){return y.b}),n.d(e,"interpolateCubehelixLong",function(){return y.a});var g=n(124);n.d(e,"quantize",function(){return g.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"b",function(){return i});var r=Array.prototype,a=r.map,i=r.slice},function(t,e,n){"use strict";e.a=function(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}},function(t,e,n){"use strict";function linear(t,e){return function(n){return t+n*e}}function exponential(t,e,n){return t=Math.pow(t,n),e=Math.pow(e,n)-t,n=1/n,function(r){return Math.pow(t+r*e,n)}}function hue(t,e){var n=e-t;return n?linear(t,n>180||n<-180?n-360*Math.round(n/360):n):Object(r.a)(isNaN(t)?e:t)}function gamma(t){return 1==(t=+t)?nogamma:function(e,n){return n-e?exponential(e,n,t):Object(r.a)(isNaN(e)?n:e)}}function nogamma(t,e){var n=e-t;return n?linear(t,n):Object(r.a)(isNaN(t)?e:t)}e.c=hue,e.b=gamma,e.a=nogamma;var r=n(48)},function(t,e,n){"use strict";e.a=function(t){return null===t?NaN:+t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t){return t=Object(r.a)(Math.abs(t)),t?t[1]:NaN}},function(t,e,n){"use strict";function linearish(t){var e=t.domain;return t.ticks=function(t){var n=e();return Object(r.ticks)(n[0],n[n.length-1],null==t?10:t)},t.tickFormat=function(t,n){return Object(o.a)(e(),t,n)},t.nice=function(n){null==n&&(n=10);var a,i=e(),o=0,u=i.length-1,c=i[o],s=i[u];return s<c&&(a=c,c=s,s=a,a=o,o=u,u=a),a=Object(r.tickIncrement)(c,s,n),a>0?(c=Math.floor(c/a)*a,s=Math.ceil(s/a)*a,a=Object(r.tickIncrement)(c,s,n)):a<0&&(c=Math.ceil(c*a)/a,s=Math.floor(s*a)/a,a=Object(r.tickIncrement)(c,s,n)),a>0?(i[o]=Math.floor(c/a)*a,i[u]=Math.ceil(s/a)*a,e(i)):a<0&&(i[o]=Math.ceil(c*a)/a,i[u]=Math.floor(s*a)/a,e(i)),t},t}function linear(){var t=Object(i.b)(i.c,a.interpolateNumber);return t.copy=function(){return Object(i.a)(t,linear())},linearish(t)}e.b=linearish,e.a=linear;var r=n(5),a=n(8),i=n(18),o=n(223)},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return t+e*n}}},function(t,e,n){"use strict";e.a=function(t){return t.match(/.{6}/g).map(function(t){return"#"+t})}},function(t,e,n){"use strict";function tweenRemove(t,e){var n,a;return function(){var i=Object(r.h)(this,t),o=i.tween;if(o!==n){a=n=o;for(var u=0,c=a.length;u<c;++u)if(a[u].name===e){a=a.slice(),a.splice(u,1);break}}i.tween=a}}function tweenFunction(t,e,n){var a,i;if("function"!=typeof n)throw new Error;return function(){var o=Object(r.h)(this,t),u=o.tween;if(u!==a){i=(a=u).slice();for(var c={name:e,value:n},s=0,f=i.length;s<f;++s)if(i[s].name===e){i[s]=c;break}s===f&&i.push(c)}o.tween=i}}function tweenValue(t,e,n){var a=t._id;return t.each(function(){var t=Object(r.h)(this,a);(t.value||(t.value={}))[e]=n.apply(this,arguments)}),function(t){return Object(r.f)(t,a).value[e]}}e.b=tweenValue;var r=n(2);e.a=function(t,e){var n=this._id;if(t+="",arguments.length<2){for(var a,i=Object(r.f)(this.node(),n).tween,o=0,u=i.length;o<u;++o)if((a=i[o]).name===t)return a.value;return null}return this.each((null==e?tweenRemove:tweenFunction)(n,t,e))}},function(t,e,n){"use strict";function deinterpolateLinear(t,e){return(e-=t=+t)?function(n){return(n-t)/e}:Object(o.a)(e)}function deinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=e?0:t>=n?1:r(t)}}}function reinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=0?e:t>=1?n:r(t)}}}function bimap(t,e,n,r){var a=t[0],i=t[1],o=e[0],u=e[1];return i<a?(a=n(i,a),o=r(u,o)):(a=n(a,i),o=r(o,u)),function(t){return o(a(t))}}function polymap(t,e,n,a){var i=Math.min(t.length,e.length)-1,o=new Array(i),u=new Array(i),c=-1;for(t[i]<t[0]&&(t=t.slice().reverse(),e=e.slice().reverse());++c<i;)o[c]=n(t[c],t[c+1]),u[c]=a(e[c],e[c+1]);return function(e){var n=Object(r.bisect)(t,e,1,i)-1;return u[n](o[n](e))}}function copy(t,e){return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp())}function continuous(t,e){function rescale(){return n=Math.min(s.length,f.length)>2?polymap:bimap,r=o=null,scale}function scale(e){return(r||(r=n(s,f,h?deinterpolateClamp(t):t,l)))(+e)}var n,r,o,s=c,f=c,l=a.interpolate,h=!1;return scale.invert=function(t){return(o||(o=n(f,s,deinterpolateLinear,h?reinterpolateClamp(e):e)))(+t)},scale.domain=function(t){return arguments.length?(s=i.a.call(t,u.a),rescale()):s.slice()},scale.range=function(t){return arguments.length?(f=i.b.call(t),rescale()):f.slice()},scale.rangeRound=function(t){return f=i.b.call(t),l=a.interpolateRound,rescale()},scale.clamp=function(t){return arguments.length?(h=!!t,rescale()):h},scale.interpolate=function(t){return arguments.length?(l=t,rescale()):l},rescale()}e.c=deinterpolateLinear,e.a=copy,e.b=continuous;var r=n(5),a=n(8),i=n(9),o=n(39),u=n(82),c=[0,1]},function(t,e,n){"use strict";function Color(){}function color(t){var e;return t=(t+"").trim().toLowerCase(),(e=s.exec(t))?(e=parseInt(e[1],16),new Rgb(e>>8&15|e>>4&240,e>>4&15|240&e,(15&e)<<4|15&e,1)):(e=f.exec(t))?rgbn(parseInt(e[1],16)):(e=l.exec(t))?new Rgb(e[1],e[2],e[3],1):(e=h.exec(t))?new Rgb(255*e[1]/100,255*e[2]/100,255*e[3]/100,1):(e=d.exec(t))?rgba(e[1],e[2],e[3],e[4]):(e=p.exec(t))?rgba(255*e[1]/100,255*e[2]/100,255*e[3]/100,e[4]):(e=b.exec(t))?hsla(e[1],e[2]/100,e[3]/100,1):(e=v.exec(t))?hsla(e[1],e[2]/100,e[3]/100,e[4]):m.hasOwnProperty(t)?rgbn(m[t]):"transparent"===t?new Rgb(NaN,NaN,NaN,0):null}function rgbn(t){return new Rgb(t>>16&255,t>>8&255,255&t,1)}function rgba(t,e,n,r){return r<=0&&(t=e=n=NaN),new Rgb(t,e,n,r)}function rgbConvert(t){return t instanceof Color||(t=color(t)),t?(t=t.rgb(),new Rgb(t.r,t.g,t.b,t.opacity)):new Rgb}function rgb(t,e,n,r){return 1===arguments.length?rgbConvert(t):new Rgb(t,e,n,null==r?1:r)}function Rgb(t,e,n,r){this.r=+t,this.g=+e,this.b=+n,this.opacity=+r}function hsla(t,e,n,r){return r<=0?t=e=n=NaN:n<=0||n>=1?t=e=NaN:e<=0&&(t=NaN),new Hsl(t,e,n,r)}function hslConvert(t){if(t instanceof Hsl)return new Hsl(t.h,t.s,t.l,t.opacity);if(t instanceof Color||(t=color(t)),!t)return new Hsl;if(t instanceof Hsl)return t;t=t.rgb();var e=t.r/255,n=t.g/255,r=t.b/255,a=Math.min(e,n,r),i=Math.max(e,n,r),o=NaN,u=i-a,c=(i+a)/2;return u?(o=e===i?(n-r)/u+6*(n<r):n===i?(r-e)/u+2:(e-n)/u+4,u/=c<.5?i+a:2-i-a,o*=60):u=c>0&&c<1?0:o,new Hsl(o,u,c,t.opacity)}function hsl(t,e,n,r){return 1===arguments.length?hslConvert(t):new Hsl(t,e,n,null==r?1:r)}function Hsl(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}function hsl2rgb(t,e,n){return 255*(t<60?e+(n-e)*t/60:t<180?n:t<240?e+(n-e)*(240-t)/60:e)}e.a=Color,n.d(e,"d",function(){return a}),n.d(e,"c",function(){return i}),e.e=color,e.h=rgbConvert,e.g=rgb,e.b=Rgb,e.f=hsl;var r=n(20),a=.7,i=1/a,o="\\s*([+-]?\\d+)\\s*",u="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",s=/^#([0-9a-f]{3})$/,f=/^#([0-9a-f]{6})$/,l=new RegExp("^rgb\\("+[o,o,o]+"\\)$"),h=new RegExp("^rgb\\("+[c,c,c]+"\\)$"),d=new RegExp("^rgba\\("+[o,o,o,u]+"\\)$"),p=new RegExp("^rgba\\("+[c,c,c,u]+"\\)$"),b=new RegExp("^hsl\\("+[u,c,c]+"\\)$"),v=new RegExp("^hsla\\("+[u,c,c,u]+"\\)$"),m={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};Object(r.a)(Color,color,{displayable:function(){return this.rgb().displayable()},toString:function(){return this.rgb()+""}}),Object(r.a)(Rgb,rgb,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return 0<=this.r&&this.r<=255&&0<=this.g&&this.g<=255&&0<=this.b&&this.b<=255&&0<=this.opacity&&this.opacity<=1},toString:function(){var t=this.opacity;return t=isNaN(t)?1:Math.max(0,Math.min(1,t)),(1===t?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}})),Object(r.a)(Hsl,hsl,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),e=isNaN(t)||isNaN(this.s)?0:this.s,n=this.l,r=n+(n<.5?n:1-n)*e,a=2*n-r;return new Rgb(hsl2rgb(t>=240?t-240:t+120,a,r),hsl2rgb(t,a,r),hsl2rgb(t<120?t+240:t-120,a,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1}}))},function(t,e,n){"use strict";function extend(t,e){var n=Object.create(t.prototype);for(var r in e)n[r]=e[r];return n}e.b=extend,e.a=function(t,e,n){t.prototype=e.prototype=n,n.constructor=t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(105);n.d(e,"formatDefaultLocale",function(){return r.a}),n.d(e,"format",function(){return r.b}),n.d(e,"formatPrefix",function(){return r.c});var a=n(42);n.d(e,"formatLocale",function(){return a.a});var i=n(43);n.d(e,"formatSpecifier",function(){return i.a});var o=n(111);n.d(e,"precisionFixed",function(){return o.a});var u=n(112);n.d(e,"precisionPrefix",function(){return u.a});var c=n(113);n.d(e,"precisionRound",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){if((n=(t=e?t.toExponential(e-1):t.toExponential()).indexOf("e"))<0)return null;var n,r=t.slice(0,n);return[r.length>1?r[0]+r.slice(2):r,+t.slice(n+1)]}},function(t,e,n){"use strict";var r=n(4),a=n(46),i=n(49),o=n(50),u=n(15),c=n(51),s=n(52),f=n(48);e.a=function(t,e){var n,l=typeof e;return null==e||"boolean"===l?Object(f.a)(e):("number"===l?u.a:"string"===l?(n=Object(r.color)(e))?(e=n,a.a):s.a:e instanceof r.color?a.a:e instanceof Date?o.a:Array.isArray(e)?i.a:"function"!=typeof e.valueOf&&"function"!=typeof e.toString||isNaN(e)?c.a:u.a)(t,e)}},function(t,e,n){"use strict";function basis(t,e,n,r,a){var i=t*t,o=i*t;return((1-3*t+3*i-o)*e+(4-6*i+3*o)*n+(1+3*t+3*i-3*o)*r+o*a)/6}e.a=basis,e.b=function(t){var e=t.length-1;return function(n){var r=n<=0?n=0:n>=1?(n=1,e-1):Math.floor(n*e),a=t[r],i=t[r+1],o=r>0?t[r-1]:2*a-i,u=r<e-1?t[r+2]:2*i-a;return basis((n-r/e)*e,o,a,i,u)}}},function(t,e,n){"use strict";function creatorInherit(t){return function(){var e=this.ownerDocument,n=this.namespaceURI;return n===a.b&&e.documentElement.namespaceURI===a.b?e.createElement(t):e.createElementNS(n,t)}}function creatorFixed(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}var r=n(26),a=n(27);e.a=function(t){var e=Object(r.a)(t);return(e.local?creatorFixed:creatorInherit)(e)}},function(t,e,n){"use strict";var r=n(27);e.a=function(t){var e=t+="",n=e.indexOf(":");return n>=0&&"xmlns"!==(e=t.slice(0,n))&&(t=t.slice(n+1)),r.a.hasOwnProperty(e)?{space:r.a[e],local:t}:t}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r="http://www.w3.org/1999/xhtml";e.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,e,n){"use strict";var r=n(29);e.a=function(){for(var t,e=r.c;t=e.sourceEvent;)e=t;return e}},function(t,e,n){"use strict";function filterContextListener(t,e,n){return t=contextListener(t,e,n),function(e){var n=e.relatedTarget;n&&(n===this||8&n.compareDocumentPosition(this))||t.call(this,e)}}function contextListener(t,e,n){return function(r){var i=a;a=r;try{t.call(this,this.__data__,e,n)}finally{a=i}}}function parseTypenames(t){return t.trim().split(/^|\s+/).map(function(t){var e="",n=t.indexOf(".");return n>=0&&(e=t.slice(n+1),t=t.slice(0,n)),{type:t,name:e}})}function onRemove(t){return function(){var e=this.__on;if(e){for(var n,r=0,a=-1,i=e.length;r<i;++r)n=e[r],t.type&&n.type!==t.type||n.name!==t.name?e[++a]=n:this.removeEventListener(n.type,n.listener,n.capture);++a?e.length=a:delete this.__on}}}function onAdd(t,e,n){var a=r.hasOwnProperty(t.type)?filterContextListener:contextListener;return function(r,i,o){var u,c=this.__on,s=a(e,i,o);if(c)for(var f=0,l=c.length;f<l;++f)if((u=c[f]).type===t.type&&u.name===t.name)return this.removeEventListener(u.type,u.listener,u.capture),this.addEventListener(u.type,u.listener=s,u.capture=n),void(u.value=e);this.addEventListener(t.type,s,n),u={type:t.type,name:t.name,value:e,listener:s,capture:n},c?c.push(u):this.__on=[u]}}function customEvent(t,e,n,r){var i=a;t.sourceEvent=a,a=t;try{return e.apply(n,r)}finally{a=i}}n.d(e,"c",function(){return a}),e.a=customEvent;var r={},a=null;if("undefined"!=typeof document){"onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"})}e.b=function(t,e,n){var r,a,i=parseTypenames(t+""),o=i.length;{if(!(arguments.length<2)){for(u=e?onAdd:onRemove,null==n&&(n=!1),r=0;r<o;++r)this.each(u(i[r],e,n));return this}var u=this.node().__on;if(u)for(var c,s=0,f=u.length;s<f;++s)for(r=0,c=u[s];r<o;++r)if((a=i[r]).type===c.type&&a.name===c.name)return c.value}}},function(t,e,n){"use strict";e.a=function(t,e){var n=t.ownerSVGElement||t;if(n.createSVGPoint){var r=n.createSVGPoint();return r.x=e.clientX,r.y=e.clientY,r=r.matrixTransform(t.getScreenCTM().inverse()),[r.x,r.y]}var a=t.getBoundingClientRect();return[e.clientX-a.left-t.clientLeft,e.clientY-a.top-t.clientTop]}},function(t,e,n){"use strict";function none(){}e.a=function(t){return null==t?none:function(){return this.querySelector(t)}}},function(t,e,n){"use strict";e.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,e,n){"use strict";function now(){return f||(d(clearNow),f=h.now()+l)}function clearNow(){f=0}function Timer(){this._call=this._time=this._next=null}function timer(t,e,n){var r=new Timer;return r.restart(t,e,n),r}function timerFlush(){now(),++i;for(var t,e=r;e;)(t=f-e._time)>=0&&e._call.call(null,t),e=e._next;--i}function wake(){f=(s=h.now())+l,i=o=0;try{timerFlush()}finally{i=0,nap(),f=0}}function poke(){var t=h.now(),e=t-s;e>c&&(l-=e,s=t)}function nap(){for(var t,e,n=r,i=1/0;n;)n._call?(i>n._time&&(i=n._time),t=n,n=n._next):(e=n._next,n._next=null,n=t?t._next=e:r=e);a=t,sleep(i)}function sleep(t){if(!i){o&&(o=clearTimeout(o));var e=t-f;e>24?(t<1/0&&(o=setTimeout(wake,e)),u&&(u=clearInterval(u))):(u||(s=f,u=setInterval(poke,c)),i=1,d(wake))}}e.b=now,e.a=Timer,e.c=timer;var r,a,i=0,o=0,u=0,c=1e3,s=0,f=0,l=0,h="object"==typeof performance&&performance.now?performance:Date,d="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};Timer.prototype=timer.prototype={constructor:Timer,restart:function(t,e,n){if("function"!=typeof t)throw new TypeError("callback is not a function");n=(null==n?now():+n)+(null==e?0:+e),this._next||a===this||(a?a._next=this:r=this,a=this),this._call=t,this._time=n,sleep()},stop:function(){this._call&&(this._call=null,this._time=1/0,sleep())}}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(0);n.d(e,"timeInterval",function(){return r.a});var a=n(200);n.d(e,"timeMillisecond",function(){return a.a}),n.d(e,"timeMilliseconds",function(){return a.b}),n.d(e,"utcMillisecond",function(){return a.a}),n.d(e,"utcMilliseconds",function(){return a.b});var i=n(201);n.d(e,"timeSecond",function(){return i.a}),n.d(e,"timeSeconds",function(){return i.b}),n.d(e,"utcSecond",function(){return i.a}),n.d(e,"utcSeconds",function(){return i.b});var o=n(202);n.d(e,"timeMinute",function(){return o.a}),n.d(e,"timeMinutes",function(){return o.b});var u=n(203);n.d(e,"timeHour",function(){return u.a}),n.d(e,"timeHours",function(){return u.b});var c=n(204);n.d(e,"timeDay",function(){return c.b}),n.d(e,"timeDays",function(){return c.a});var s=n(205);n.d(e,"timeWeek",function(){return s.g}),n.d(e,"timeWeeks",function(){return s.h}),n.d(e,"timeSunday",function(){return s.g}),n.d(e,"timeSundays",function(){return s.h}),n.d(e,"timeMonday",function(){return s.c}),n.d(e,"timeMondays",function(){return s.d}),n.d(e,"timeTuesday",function(){return s.k}),n.d(e,"timeTuesdays",function(){return s.l}),n.d(e,"timeWednesday",function(){return s.m}),n.d(e,"timeWednesdays",function(){return s.n}),n.d(e,"timeThursday",function(){return s.i}),n.d(e,"timeThursdays",function(){return s.j}),n.d(e,"timeFriday",function(){return s.a}),n.d(e,"timeFridays",function(){return s.b}),n.d(e,"timeSaturday",function(){return s.e}),n.d(e,"timeSaturdays",function(){return s.f});var f=n(206);n.d(e,"timeMonth",function(){return f.a}),n.d(e,"timeMonths",function(){return f.b});var l=n(207);n.d(e,"timeYear",function(){return l.a}),n.d(e,"timeYears",function(){return l.b});var h=n(208);n.d(e,"utcMinute",function(){return h.a}),n.d(e,"utcMinutes",function(){return h.b});var d=n(209);n.d(e,"utcHour",function(){return d.a}),n.d(e,"utcHours",function(){return d.b});var p=n(210);n.d(e,"utcDay",function(){return p.a}),n.d(e,"utcDays",function(){return p.b});var b=n(211);n.d(e,"utcWeek",function(){return b.g}),n.d(e,"utcWeeks",function(){return b.h}),n.d(e,"utcSunday",function(){return b.g}),n.d(e,"utcSundays",function(){return b.h}),n.d(e,"utcMonday",function(){return b.c}),n.d(e,"utcMondays",function(){return b.d}),n.d(e,"utcTuesday",function(){return b.k}),n.d(e,"utcTuesdays",function(){return b.l}),n.d(e,"utcWednesday",function(){return b.m}),n.d(e,"utcWednesdays",function(){return b.n}),n.d(e,"utcThursday",function(){return b.i}),n.d(e,"utcThursdays",function(){return b.j}),n.d(e,"utcFriday",function(){return b.a}),n.d(e,"utcFridays",function(){return b.b}),n.d(e,"utcSaturday",function(){return b.e}),n.d(e,"utcSaturdays",function(){return b.f});var v=n(212);n.d(e,"utcMonth",function(){return v.a}),n.d(e,"utcMonths",function(){return v.b});var m=n(213);n.d(e,"utcYear",function(){return m.a}),n.d(e,"utcYears",function(){return m.b})},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e,n){if(null==n&&(n=r.a),a=t.length){if((e=+e)<=0||a<2)return+n(t[0],0,t);if(e>=1)return+n(t[a-1],a-1,t);var a,i=(a-1)*e,o=Math.floor(i),u=+n(t[o],o,t);return u+(+n(t[o+1],o+1,t)-u)*(i-o)}}},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(c.a)(t),a=r.format,i=r.parse,o=r.utcFormat,u=r.utcParse,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"d",function(){return o}),n.d(e,"e",function(){return u}),e.a=defaultLocale;var r,a,i,o,u,c=n(79);defaultLocale({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,e,n){"use strict";function Map(){}function map(t,e){var n=new Map;if(t instanceof Map)t.each(function(t,e){n.set(e,t)});else if(Array.isArray(t)){var r,a=-1,i=t.length;if(null==e)for(;++a<i;)n.set(a,t[a]);else for(;++a<i;)n.set(e(r=t[a],a,t),r)}else if(t)for(var o in t)n.set(o,t[o]);return n}n.d(e,"b",function(){return r});var r="$";Map.prototype=map.prototype={constructor:Map,has:function(t){return r+t in this},get:function(t){return this[r+t]},set:function(t,e){return this[r+t]=e,this},remove:function(t){var e=r+t;return e in this&&delete this[e]},clear:function(){for(var t in this)t[0]===r&&delete this[t]},keys:function(){var t=[];for(var e in this)e[0]===r&&t.push(e.slice(1));return t},values:function(){var t=[];for(var e in this)e[0]===r&&t.push(this[e]);return t},entries:function(){var t=[];for(var e in this)e[0]===r&&t.push({key:e.slice(1),value:this[e]});return t},size:function(){var t=0;for(var e in this)e[0]===r&&++t;return t},empty:function(){for(var t in this)if(t[0]===r)return!1;return!0},each:function(t){for(var e in this)e[0]===r&&t(this[e],e.slice(1),this)}},e.a=map},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(37);n.d(e,"timeFormatDefaultLocale",function(){return r.a}),n.d(e,"timeFormat",function(){return r.b}),n.d(e,"timeParse",function(){return r.c}),n.d(e,"utcFormat",function(){return r.d}),n.d(e,"utcParse",function(){return r.e});var a=n(79);n.d(e,"timeFormatLocale",function(){return a.a});var i=n(80);n.d(e,"isoFormat",function(){return i.a});var o=n(214);n.d(e,"isoParse",function(){return o.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"b",function(){return a});var r=Math.PI/180,a=180/Math.PI},function(t,e,n){"use strict";var r=n(13),a=n(106),i=n(107),o=n(43),u=n(44),c=n(45),s=n(110),f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];e.a=function(t){function newFormat(t){function format(t){var n,o,u,s=g,d=_;if("c"===y)d=x(t)+d,t="";else{t=+t;var O=t<0;if(t=x(Math.abs(t),m),O&&0==+t&&(O=!1),s=(O?"("===i?i:"-":"-"===i||"("===i?"":i)+s,d=d+("s"===y?f[8+c.b/3]:"")+(O&&"("===i?")":""),w)for(n=-1,o=t.length;++n<o;)if(48>(u=t.charCodeAt(n))||u>57){d=(46===u?l+t.slice(n+1):t.slice(n))+d,t=t.slice(0,n);break}}v&&!p&&(t=e(t,1/0));var M=s.length+t.length+d.length,C=M<b?new Array(b-M+1).join(r):"";switch(v&&p&&(t=e(C+t,C.length?b-d.length:1/0),C=""),a){case"<":t=s+t+d+C;break;case"=":t=s+C+t+d;break;case"^":t=C.slice(0,M=C.length>>1)+s+t+d+C.slice(M);break;default:t=C+s+t+d}return h(t)}t=Object(o.a)(t);var r=t.fill,a=t.align,i=t.sign,s=t.symbol,p=t.zero,b=t.width,v=t.comma,m=t.precision,y=t.type,g="$"===s?n[0]:"#"===s&&/[boxX]/.test(y)?"0"+y.toLowerCase():"",_="$"===s?n[1]:/[%p]/.test(y)?d:"",x=u.a[y],w=!y||/[defgprs%]/.test(y);return m=null==m?y?6:12:/[gprs]/.test(y)?Math.max(1,Math.min(21,m)):Math.max(0,Math.min(20,m)),format.toString=function(){return t+""},format}function formatPrefix(t,e){var n=newFormat((t=Object(o.a)(t),t.type="f",t)),a=3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3))),i=Math.pow(10,-a),u=f[8+a/3];return function(t){return n(i*t)+u}}var e=t.grouping&&t.thousands?Object(a.a)(t.grouping,t.thousands):s.a,n=t.currency,l=t.decimal,h=t.numerals?Object(i.a)(t.numerals):s.a,d=t.percent||"%";return{format:newFormat,formatPrefix:formatPrefix}}},function(t,e,n){"use strict";function formatSpecifier(t){return new FormatSpecifier(t)}function FormatSpecifier(t){if(!(e=a.exec(t)))throw new Error("invalid format: "+t);var e,n=e[1]||" ",i=e[2]||">",o=e[3]||"-",u=e[4]||"",c=!!e[5],s=e[6]&&+e[6],f=!!e[7],l=e[8]&&+e[8].slice(1),h=e[9]||"";"n"===h?(f=!0,h="g"):r.a[h]||(h=""),(c||"0"===n&&"="===i)&&(c=!0,n="0",i="="),this.fill=n,this.align=i,this.sign=o,this.symbol=u,this.zero=c,this.width=s,this.comma=f,this.precision=l,this.type=h}e.a=formatSpecifier;var r=n(44),a=/^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;formatSpecifier.prototype=FormatSpecifier.prototype,FormatSpecifier.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(null==this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(null==this.precision?"":"."+Math.max(0,0|this.precision))+this.type}},function(t,e,n){"use strict";var r=n(108),a=n(45),i=n(109);e.a={"":r.a,"%":function(t,e){return(100*t).toFixed(e)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,e){return t.toExponential(e)},f:function(t,e){return t.toFixed(e)},g:function(t,e){return t.toPrecision(e)},o:function(t){return Math.round(t).toString(8)},p:function(t,e){return Object(i.a)(100*t,e)},r:i.a,s:a.a,X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r,a=n(22);e.a=function(t,e){var n=Object(a.a)(t,e);if(!n)return t+"";var i=n[0],o=n[1],u=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return u===c?i:u>c?i+new Array(u-c+1).join("0"):u>0?i.slice(0,u)+"."+i.slice(u):"0."+new Array(1-u).join("0")+Object(a.a)(t,Math.max(0,e+u-1))[0]}},function(t,e,n){"use strict";function rgbSpline(t){return function(e){var n,a,i=e.length,o=new Array(i),u=new Array(i),c=new Array(i);for(n=0;n<i;++n)a=Object(r.rgb)(e[n]),o[n]=a.r||0,u[n]=a.g||0,c[n]=a.b||0;return o=t(o),u=t(u),c=t(c),a.opacity=1,function(t){return a.r=o(t),a.g=u(t),a.b=c(t),a+""}}}n.d(e,"b",function(){return u}),n.d(e,"c",function(){return c});var r=n(4),a=n(24),i=n(47),o=n(11);e.a=function rgbGamma(t){function rgb(t,n){var a=e((t=Object(r.rgb)(t)).r,(n=Object(r.rgb)(n)).r),i=e(t.g,n.g),u=e(t.b,n.b),c=Object(o.a)(t.opacity,n.opacity);return function(e){return t.r=a(e),t.g=i(e),t.b=u(e),t.opacity=c(e),t+""}}var e=Object(o.b)(t);return rgb.gamma=rgbGamma,rgb}(1);var u=rgbSpline(a.b),c=rgbSpline(i.a)},function(t,e,n){"use strict";var r=n(24);e.a=function(t){var e=t.length;return function(n){var a=Math.floor(((n%=1)<0?++n:n)*e),i=t[(a+e-1)%e],o=t[a%e],u=t[(a+1)%e],c=t[(a+2)%e];return Object(r.a)((n-a/e)*e,i,o,u,c)}}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a=e?e.length:0,i=t?Math.min(a,t.length):0,o=new Array(a),u=new Array(a);for(n=0;n<i;++n)o[n]=Object(r.a)(t[n],e[n]);for(;n<a;++n)u[n]=e[n];return function(t){for(n=0;n<i;++n)u[n]=o[n](t);return u}}},function(t,e,n){"use strict";e.a=function(t,e){var n=new Date;return t=+t,e-=t,function(r){return n.setTime(t+e*r),n}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a={},i={};null!==t&&"object"==typeof t||(t={}),null!==e&&"object"==typeof e||(e={});for(n in e)n in t?a[n]=Object(r.a)(t[n],e[n]):i[n]=e[n];return function(t){for(n in a)i[n]=a[n](t);return i}}},function(t,e,n){"use strict";function zero(t){return function(){return t}}function one(t){return function(e){return t(e)+""}}var r=n(15),a=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,i=new RegExp(a.source,"g");e.a=function(t,e){var n,o,u,c=a.lastIndex=i.lastIndex=0,s=-1,f=[],l=[];for(t+="",e+="";(n=a.exec(t))&&(o=i.exec(e));)(u=o.index)>c&&(u=e.slice(c,u),f[s]?f[s]+=u:f[++s]=u),(n=n[0])===(o=o[0])?f[s]?f[s]+=o:f[++s]=o:(f[++s]=null,l.push({i:s,x:Object(r.a)(n,o)})),c=i.lastIndex;return c<e.length&&(u=e.slice(c),f[s]?f[s]+=u:f[++s]=u),f.length<2?l[0]?one(l[0].x):zero(e):(e=l.length,function(t){for(var n,r=0;r<e;++r)f[(n=l[r]).i]=n.x(t);return f.join("")})}},function(t,e,n){"use strict";var r=function(t){return function(){return this.matches(t)}};if("undefined"!=typeof document){var a=document.documentElement;if(!a.matches){var i=a.webkitMatchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector;r=function(t){return function(){return i.call(this,t)}}}}e.a=r},function(t,e,n){"use strict";function empty(){return[]}e.a=function(t){return null==t?empty:function(){return this.querySelectorAll(t)}}},function(t,e,n){"use strict";function EnterNode(t,e){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=e}e.a=EnterNode;var r=n(56),a=n(1);e.b=function(){return new a.a(this._enter||this._groups.map(r.a),this._parents)},EnterNode.prototype={constructor:EnterNode,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,e){return this._parent.insertBefore(t,e)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}}},function(t,e,n){"use strict";e.a=function(t){return new Array(t.length)}},function(t,e,n){"use strict";function styleRemove(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){return function(){this.style.setProperty(t,e,n)}}function styleFunction(t,e,n){return function(){var r=e.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,n)}}function styleValue(t,e){return t.style.getPropertyValue(e)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(e)}e.b=styleValue;var r=n(32);e.a=function(t,e,n){return arguments.length>1?this.each((null==e?styleRemove:"function"==typeof e?styleFunction:styleConstant)(t,e,null==n?"":n)):styleValue(this.node(),t)}},function(t,e,n){"use strict";var r=n(2);e.a=function(t,e){var n,a,i,o=t.__transition,u=!0;if(o){e=null==e?null:e+"";for(i in o)(n=o[i]).name===e?(a=n.state>r.d&&n.state<r.b,n.state=r.a,n.timer.stop(),a&&n.on.call("interrupt",t,t.__data__,n.index,n.group),delete o[i]):u=!1;u&&delete t.__transition}}},function(t,e,n){"use strict";var r=n(33);n.d(e,"a",function(){return r.b}),n.d(e,"c",function(){return r.c});var a=n(160);n.d(e,"b",function(){return a.a});n(161)},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=function(t,e){var n;return("number"==typeof e?a.interpolateNumber:e instanceof r.color?a.interpolateRgb:(n=Object(r.color)(e))?(e=n,a.interpolateRgb):a.interpolateString)(t,e)}},function(t,e,n){"use strict";var r=n(264);n.d(e,"a",function(){return r.a})},function(t,e,n){"use strict";function acos(t){return t>1?0:t<-1?l:Math.acos(t)}function asin(t){return t>=1?h:t<=-1?-h:Math.asin(t)}n.d(e,"a",function(){return r}),n.d(e,"d",function(){return a}),n.d(e,"e",function(){return i}),n.d(e,"h",function(){return o}),n.d(e,"i",function(){return u}),n.d(e,"k",function(){return c}),n.d(e,"l",function(){return s}),n.d(e,"f",function(){return f}),n.d(e,"j",function(){return l}),n.d(e,"g",function(){return h}),n.d(e,"m",function(){return d}),e.b=acos,e.c=asin;var r=Math.abs,a=Math.atan2,i=Math.cos,o=Math.max,u=Math.min,c=Math.sin,s=Math.sqrt,f=1e-12,l=Math.PI,h=l/2,d=2*l},function(t,e,n){"use strict";e.a=function(t,e){if((a=t.length)>1)for(var n,r,a,i=1,o=t[e[0]],u=o.length;i<a;++i)for(r=o,o=t[e[i]],n=0;n<u;++n)o[n][1]+=o[n][0]=isNaN(r[n][1])?r[n][0]:r[n][1]}},function(t,e,n){"use strict";e.a=function(t){for(var e=t.length,n=new Array(e);--e>=0;)n[e]=e;return n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(92);n.d(e,"easeLinear",function(){return r.a});var a=n(93);n.d(e,"easeQuad",function(){return a.b}),n.d(e,"easeQuadIn",function(){return a.a}),n.d(e,"easeQuadOut",function(){return a.c}),n.d(e,"easeQuadInOut",function(){return a.b});var i=n(94);n.d(e,"easeCubic",function(){return i.b}),n.d(e,"easeCubicIn",function(){return i.a}),n.d(e,"easeCubicOut",function(){return i.c}),n.d(e,"easeCubicInOut",function(){return i.b});var o=n(95);n.d(e,"easePoly",function(){return o.b}),n.d(e,"easePolyIn",function(){return o.a}),n.d(e,"easePolyOut",function(){return o.c}),n.d(e,"easePolyInOut",function(){return o.b});var u=n(96);n.d(e,"easeSin",function(){return u.b}),n.d(e,"easeSinIn",function(){return u.a}),n.d(e,"easeSinOut",function(){return u.c}),n.d(e,"easeSinInOut",function(){return u.b});var c=n(97);n.d(e,"easeExp",function(){return c.b}),n.d(e,"easeExpIn",function(){return c.a}),n.d(e,"easeExpOut",function(){return c.c}),n.d(e,"easeExpInOut",function(){return c.b});var s=n(98);n.d(e,"easeCircle",function(){return s.b}),n.d(e,"easeCircleIn",function(){return s.a}),n.d(e,"easeCircleOut",function(){return s.c}),n.d(e,"easeCircleInOut",function(){return s.b});var f=n(99);n.d(e,"easeBounce",function(){return f.c}),n.d(e,"easeBounceIn",function(){return f.a}),n.d(e,"easeBounceOut",function(){return f.c}),n.d(e,"easeBounceInOut",function(){return f.b});var l=n(100);n.d(e,"easeBack",function(){return l.b}),n.d(e,"easeBackIn",function(){return l.a}),n.d(e,"easeBackOut",function(){return l.c}),n.d(e,"easeBackInOut",function(){return l.b});var h=n(101);n.d(e,"easeElastic",function(){return h.c}),n.d(e,"easeElasticIn",function(){return h.a}),n.d(e,"easeElasticOut",function(){return h.c}),n.d(e,"easeElasticInOut",function(){return h.b})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(104);n.d(e,"dispatch",function(){return r.a})},function(t,e,n){"use strict";n.d(e,"b",function(){return o}),n.d(e,"a",function(){return u});var r=n(10),a=n(68),i=Object(a.a)(r.a),o=i.right,u=i.left;e.c=o},function(t,e,n){"use strict";function ascendingComparator(t){return function(e,n){return Object(r.a)(t(e),n)}}var r=n(10);e.a=function(t){return 1===t.length&&(t=ascendingComparator(t)),{left:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)<0?r=i+1:a=i}return r},right:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)>0?a=i:r=i+1}return r}}}},function(t,e,n){"use strict";function pair(t,e){return[t,e]}e.b=pair,e.a=function(t,e){null==e&&(e=pair);for(var n=0,r=t.length-1,a=t[0],i=new Array(r<0?0:r);n<r;)i[n]=e(a,a=t[++n]);return i}},function(t,e,n){"use strict";var r=n(71);e.a=function(t,e){var n=Object(r.a)(t,e);return n?Math.sqrt(n):n}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a,i=t.length,o=0,u=-1,c=0,s=0;if(null==e)for(;++u<i;)isNaN(n=Object(r.a)(t[u]))||(a=n-c,c+=a/++o,s+=a*(n-c));else for(;++u<i;)isNaN(n=Object(r.a)(e(t[u],u,t)))||(a=n-c,c+=a/++o,s+=a*(n-c));if(o>1)return s/(o-1)}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a,i=t.length,o=-1;if(null==e){for(;++o<i;)if(null!=(n=t[o])&&n>=n)for(r=a=n;++o<i;)null!=(n=t[o])&&(r>n&&(r=n),a<n&&(a=n))}else for(;++o<i;)if(null!=(n=e(t[o],o,t))&&n>=n)for(r=a=n;++o<i;)null!=(n=e(t[o],o,t))&&(r>n&&(r=n),a<n&&(a=n));return[r,a]}},function(t,e,n){"use strict";n.d(e,"b",function(){return a}),n.d(e,"a",function(){return i});var r=Array.prototype,a=r.slice,i=r.map},function(t,e,n){"use strict";e.a=function(t,e,n){t=+t,e=+e,n=(a=arguments.length)<2?(e=t,t=0,1):a<3?1:+n;for(var r=-1,a=0|Math.max(0,Math.ceil((e-t)/n)),i=new Array(a);++r<a;)i[r]=t+r*n;return i}},function(t,e,n){"use strict";function tickIncrement(t,e,n){var o=(e-t)/Math.max(0,n),u=Math.floor(Math.log(o)/Math.LN10),c=o/Math.pow(10,u);return u>=0?(c>=r?10:c>=a?5:c>=i?2:1)*Math.pow(10,u):-Math.pow(10,-u)/(c>=r?10:c>=a?5:c>=i?2:1)}function tickStep(t,e,n){var o=Math.abs(e-t)/Math.max(0,n),u=Math.pow(10,Math.floor(Math.log(o)/Math.LN10)),c=o/u;return c>=r?u*=10:c>=a?u*=5:c>=i&&(u*=2),e<t?-u:u}e.b=tickIncrement,e.c=tickStep;var r=Math.sqrt(50),a=Math.sqrt(10),i=Math.sqrt(2);e.a=function(t,e,n){var r,a,i,o=e<t,u=-1;if(o&&(r=t,t=e,e=r),0===(i=tickIncrement(t,e,n))||!isFinite(i))return[];if(i>0)for(t=Math.ceil(t/i),e=Math.floor(e/i),a=new Array(r=Math.ceil(e-t+1));++u<r;)a[u]=(t+u)*i;else for(t=Math.floor(t*i),e=Math.ceil(e*i),a=new Array(r=Math.ceil(t-e+1));++u<r;)a[u]=(t-u)/i;return o&&a.reverse(),a}},function(t,e,n){"use strict";e.a=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&r>n&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&r>n&&(r=n);return r}},function(t,e,n){"use strict";function length(t){return t.length}var r=n(77);e.a=function(t){if(!(i=t.length))return[];for(var e=-1,n=Object(r.a)(t,length),a=new Array(n);++e<n;)for(var i,o=-1,u=a[e]=new Array(i);++o<i;)u[o]=t[o][e];return a}},function(t,e,n){"use strict";function localDate(t){if(0<=t.y&&t.y<100){var e=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return e.setFullYear(t.y),e}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function utcDate(t){if(0<=t.y&&t.y<100){var e=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return e.setUTCFullYear(t.y),e}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function newYear(t){return{y:t,m:0,d:1,H:0,M:0,S:0,L:0}}function formatLocale(t){function newFormat(t,e){return function(n){var r,i,o,u=[],c=-1,s=0,f=t.length;for(n instanceof Date||(n=new Date(+n));++c<f;)37===t.charCodeAt(c)&&(u.push(t.slice(s,c)),null!=(i=a[r=t.charAt(++c)])?r=t.charAt(++c):i="e"===r?" ":"0",(o=e[r])&&(r=o(n,i)),u.push(r),s=c+1);return u.push(t.slice(s,c)),u.join("")}}function newParse(t,e){return function(n){var r=newYear(1900);if(parseSpecifier(r,t,n+="",0)!=n.length)return null;if("p"in r&&(r.H=r.H%12+12*r.p),"W"in r||"U"in r){"w"in r||(r.w="W"in r?1:0);var a="Z"in r?utcDate(newYear(r.y)).getUTCDay():e(newYear(r.y)).getDay();r.m=0,r.d="W"in r?(r.w+6)%7+7*r.W-(a+5)%7:r.w+7*r.U-(a+6)%7}return"Z"in r?(r.H+=r.Z/100|0,r.M+=r.Z%100,utcDate(r)):e(r)}}function parseSpecifier(t,e,n,r){for(var i,o,u=0,c=e.length,s=n.length;u<c;){if(r>=s)return-1;if(37===(i=e.charCodeAt(u++))){if(i=e.charAt(u++),!(o=w[i in a?e.charAt(u++):i])||(r=o(t,n,r))<0)return-1}else if(i!=n.charCodeAt(r++))return-1}return r}function parsePeriod(t,e,n){var r=f.exec(e.slice(n));return r?(t.p=l[r[0].toLowerCase()],n+r[0].length):-1}function parseShortWeekday(t,e,n){var r=p.exec(e.slice(n));return r?(t.w=b[r[0].toLowerCase()],n+r[0].length):-1}function parseWeekday(t,e,n){var r=h.exec(e.slice(n));return r?(t.w=d[r[0].toLowerCase()],n+r[0].length):-1}function parseShortMonth(t,e,n){var r=y.exec(e.slice(n));return r?(t.m=g[r[0].toLowerCase()],n+r[0].length):-1}function parseMonth(t,e,n){var r=v.exec(e.slice(n));return r?(t.m=m[r[0].toLowerCase()],n+r[0].length):-1}function parseLocaleDateTime(t,n,r){return parseSpecifier(t,e,n,r)}function parseLocaleDate(t,e,r){return parseSpecifier(t,n,e,r)}function parseLocaleTime(t,e,n){return parseSpecifier(t,r,e,n)}function formatShortWeekday(t){return u[t.getDay()]}function formatWeekday(t){return o[t.getDay()]}function formatShortMonth(t){return s[t.getMonth()]}function formatMonth(t){return c[t.getMonth()]}function formatPeriod(t){return i[+(t.getHours()>=12)]}function formatUTCShortWeekday(t){return u[t.getUTCDay()]}function formatUTCWeekday(t){return o[t.getUTCDay()]}function formatUTCShortMonth(t){return s[t.getUTCMonth()]}function formatUTCMonth(t){return c[t.getUTCMonth()]}function formatUTCPeriod(t){return i[+(t.getUTCHours()>=12)]}var e=t.dateTime,n=t.date,r=t.time,i=t.periods,o=t.days,u=t.shortDays,c=t.months,s=t.shortMonths,f=formatRe(i),l=formatLookup(i),h=formatRe(o),d=formatLookup(o),p=formatRe(u),b=formatLookup(u),v=formatRe(c),m=formatLookup(c),y=formatRe(s),g=formatLookup(s),_={a:formatShortWeekday,A:formatWeekday,b:formatShortMonth,B:formatMonth,c:null,d:formatDayOfMonth,e:formatDayOfMonth,H:formatHour24,I:formatHour12,j:formatDayOfYear,L:formatMilliseconds,m:formatMonthNumber,M:formatMinutes,p:formatPeriod,S:formatSeconds,U:formatWeekNumberSunday,w:formatWeekdayNumber,W:formatWeekNumberMonday,x:null,X:null,y:formatYear,Y:formatFullYear,Z:formatZone,"%":formatLiteralPercent},x={a:formatUTCShortWeekday,A:formatUTCWeekday,b:formatUTCShortMonth,B:formatUTCMonth,c:null,d:formatUTCDayOfMonth,e:formatUTCDayOfMonth,H:formatUTCHour24,I:formatUTCHour12,j:formatUTCDayOfYear,L:formatUTCMilliseconds,m:formatUTCMonthNumber,M:formatUTCMinutes,p:formatUTCPeriod,S:formatUTCSeconds,U:formatUTCWeekNumberSunday,w:formatUTCWeekdayNumber,W:formatUTCWeekNumberMonday,x:null,X:null,y:formatUTCYear,Y:formatUTCFullYear,Z:formatUTCZone,"%":formatLiteralPercent},w={a:parseShortWeekday,A:parseWeekday,b:parseShortMonth,B:parseMonth,c:parseLocaleDateTime,d:parseDayOfMonth,e:parseDayOfMonth,H:parseHour24,I:parseHour24,j:parseDayOfYear,L:parseMilliseconds,m:parseMonthNumber,M:parseMinutes,p:parsePeriod,S:parseSeconds,U:parseWeekNumberSunday,w:parseWeekdayNumber,W:parseWeekNumberMonday,x:parseLocaleDate,X:parseLocaleTime,y:parseYear,Y:parseFullYear,Z:parseZone,"%":parseLiteralPercent};return _.x=newFormat(n,_),_.X=newFormat(r,_),_.c=newFormat(e,_),x.x=newFormat(n,x),x.X=newFormat(r,x),x.c=newFormat(e,x),{format:function(t){var e=newFormat(t+="",_);return e.toString=function(){return t},e},parse:function(t){var e=newParse(t+="",localDate);return e.toString=function(){return t},e},utcFormat:function(t){var e=newFormat(t+="",x);return e.toString=function(){return t},e},utcParse:function(t){var e=newParse(t,utcDate);return e.toString=function(){return t},e}}}function pad(t,e,n){var r=t<0?"-":"",a=(r?-t:t)+"",i=a.length;return r+(i<n?new Array(n-i+1).join(e)+a:a)}function requote(t){return t.replace(u,"\\$&")}function formatRe(t){return new RegExp("^(?:"+t.map(requote).join("|")+")","i")}function formatLookup(t){for(var e={},n=-1,r=t.length;++n<r;)e[t[n].toLowerCase()]=n;return e}function parseWeekdayNumber(t,e,n){var r=i.exec(e.slice(n,n+1));return r?(t.w=+r[0],n+r[0].length):-1}function parseWeekNumberSunday(t,e,n){var r=i.exec(e.slice(n));return r?(t.U=+r[0],n+r[0].length):-1}function parseWeekNumberMonday(t,e,n){var r=i.exec(e.slice(n));return r?(t.W=+r[0],n+r[0].length):-1}function parseFullYear(t,e,n){var r=i.exec(e.slice(n,n+4));return r?(t.y=+r[0],n+r[0].length):-1}function parseYear(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),n+r[0].length):-1}function parseZone(t,e,n){var r=/^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(e.slice(n,n+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),n+r[0].length):-1}function parseMonthNumber(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.m=r[0]-1,n+r[0].length):-1}function parseDayOfMonth(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.d=+r[0],n+r[0].length):-1}function parseDayOfYear(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.m=0,t.d=+r[0],n+r[0].length):-1}function parseHour24(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.H=+r[0],n+r[0].length):-1}function parseMinutes(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.M=+r[0],n+r[0].length):-1}function parseSeconds(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.S=+r[0],n+r[0].length):-1}function parseMilliseconds(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.L=+r[0],n+r[0].length):-1}function parseLiteralPercent(t,e,n){var r=o.exec(e.slice(n,n+1));return r?n+r[0].length:-1}function formatDayOfMonth(t,e){return pad(t.getDate(),e,2)}function formatHour24(t,e){return pad(t.getHours(),e,2)}function formatHour12(t,e){return pad(t.getHours()%12||12,e,2)}function formatDayOfYear(t,e){return pad(1+r.timeDay.count(Object(r.timeYear)(t),t),e,3)}function formatMilliseconds(t,e){return pad(t.getMilliseconds(),e,3)}function formatMonthNumber(t,e){return pad(t.getMonth()+1,e,2)}function formatMinutes(t,e){return pad(t.getMinutes(),e,2)}function formatSeconds(t,e){return pad(t.getSeconds(),e,2)}function formatWeekNumberSunday(t,e){return pad(r.timeSunday.count(Object(r.timeYear)(t),t),e,2)}function formatWeekdayNumber(t){return t.getDay()}function formatWeekNumberMonday(t,e){return pad(r.timeMonday.count(Object(r.timeYear)(t),t),e,2)}function formatYear(t,e){return pad(t.getFullYear()%100,e,2)}function formatFullYear(t,e){return pad(t.getFullYear()%1e4,e,4)}function formatZone(t){var e=t.getTimezoneOffset();return(e>0?"-":(e*=-1,"+"))+pad(e/60|0,"0",2)+pad(e%60,"0",2)}function formatUTCDayOfMonth(t,e){return pad(t.getUTCDate(),e,2)}function formatUTCHour24(t,e){return pad(t.getUTCHours(),e,2)}function formatUTCHour12(t,e){return pad(t.getUTCHours()%12||12,e,2)}function formatUTCDayOfYear(t,e){return pad(1+r.utcDay.count(Object(r.utcYear)(t),t),e,3)}function formatUTCMilliseconds(t,e){return pad(t.getUTCMilliseconds(),e,3)}function formatUTCMonthNumber(t,e){return pad(t.getUTCMonth()+1,e,2)}function formatUTCMinutes(t,e){return pad(t.getUTCMinutes(),e,2)}function formatUTCSeconds(t,e){return pad(t.getUTCSeconds(),e,2)}function formatUTCWeekNumberSunday(t,e){return pad(r.utcSunday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCWeekdayNumber(t){return t.getUTCDay()}function formatUTCWeekNumberMonday(t,e){return pad(r.utcMonday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCYear(t,e){return pad(t.getUTCFullYear()%100,e,2)}function formatUTCFullYear(t,e){return pad(t.getUTCFullYear()%1e4,e,4)}function formatUTCZone(){return"+0000"}function formatLiteralPercent(){return"%"}e.a=formatLocale;var r=n(35),a={"-":"",_:" ",0:"0"},i=/^\s*\d+/,o=/^%/,u=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g},function(t,e,n){"use strict";function formatIsoNative(t){return t.toISOString()}n.d(e,"b",function(){return a});var r=n(37),a="%Y-%m-%dT%H:%M:%S.%LZ",i=Date.prototype.toISOString?formatIsoNative:Object(r.d)(a);e.a=i},function(t,e,n){"use strict";function ordinal(t){function scale(r){var a=r+"",u=e.get(a);if(!u){if(o!==i)return o;e.set(a,u=n.push(r))}return t[(u-1)%t.length]}var e=Object(r.map)(),n=[],o=i;return t=null==t?[]:a.b.call(t),scale.domain=function(t){if(!arguments.length)return n.slice();n=[],e=Object(r.map)();for(var a,i,o=-1,u=t.length;++o<u;)e.has(i=(a=t[o])+"")||e.set(i,n.push(a));return scale},scale.range=function(e){return arguments.length?(t=a.b.call(e),scale):t.slice()},scale.unknown=function(t){return arguments.length?(o=t,scale):o},scale.copy=function(){return ordinal().domain(n).range(t).unknown(o)},scale}n.d(e,"b",function(){return i}),e.a=ordinal;var r=n(114),a=n(9),i={name:"implicit"}},function(t,e,n){"use strict";e.a=function(t){return+t}},function(t,e,n){"use strict";e.a=function(t,e){t=t.slice();var n,r=0,a=t.length-1,i=t[r],o=t[a];return o<i&&(n=r,r=a,a=n,n=i,i=o,o=n),t[r]=e.floor(i),t[a]=e.ceil(o),t}},function(t,e,n){"use strict";function date(t){return new Date(t)}function number(t){return t instanceof Date?+t:+new Date(+t)}function calendar(t,e,n,i,o,m,y,g,_){function tickFormat(r){return(y(r)<r?M:m(r)<r?C:o(r)<r?j:i(r)<r?T:e(r)<r?n(r)<r?k:S:t(r)<r?N:A)(r)}function tickInterval(e,n,a,i){if(null==e&&(e=10),"number"==typeof e){var o=Math.abs(a-n)/e,u=Object(r.bisector)(function(t){return t[2]}).right(E,o);u===E.length?(i=Object(r.tickStep)(n/v,a/v,e),e=t):u?(u=E[o/E[u-1][2]<E[u][2]/o?u-1:u],i=u[1],e=u[0]):(i=Object(r.tickStep)(n,a,e),e=g)}return null==i?e:e.every(i)}var x=Object(c.b)(c.c,a.interpolateNumber),w=x.invert,O=x.domain,M=_(".%L"),C=_(":%S"),j=_("%I:%M"),T=_("%I %p"),k=_("%a %d"),S=_("%b %d"),N=_("%B"),A=_("%Y"),E=[[y,1,f],[y,5,5*f],[y,15,15*f],[y,30,30*f],[m,1,l],[m,5,5*l],[m,15,15*l],[m,30,30*l],[o,1,h],[o,3,3*h],[o,6,6*h],[o,12,12*h],[i,1,d],[i,2,2*d],[n,1,p],[e,1,b],[e,3,3*b],[t,1,v]];return x.invert=function(t){return new Date(w(t))},x.domain=function(t){return arguments.length?O(u.a.call(t,number)):O().map(date)},x.ticks=function(t,e){var n,r=O(),a=r[0],i=r[r.length-1],o=i<a;return o&&(n=a,a=i,i=n),n=tickInterval(t,a,i,e),n=n?n.range(a,i+1):[],o?n.reverse():n},x.tickFormat=function(t,e){return null==e?tickFormat:_(e)},x.nice=function(t,e){var n=O();return(t=tickInterval(t,n[0],n[n.length-1],e))?O(Object(s.a)(n,t)):x},x.copy=function(){return Object(c.a)(x,calendar(t,e,n,i,o,m,y,g,_))},x}e.a=calendar;var r=n(5),a=n(8),i=n(35),o=n(40),u=n(9),c=n(18),s=n(83),f=1e3,l=60*f,h=60*l,d=24*h,p=7*d,b=30*d,v=365*d;e.b=function(){return calendar(i.timeYear,i.timeMonth,i.timeWeek,i.timeDay,i.timeHour,i.timeMinute,i.timeSecond,i.timeMillisecond,o.timeFormat).domain([new Date(2e3,0,1),new Date(2e3,0,2)])}},function(t,e,n){"use strict";function Linear(t){this._context=t}Linear.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._point=0},lineEnd:function(){(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;default:this._context.lineTo(t,e)}}},e.a=function(t){return new Linear(t)}},function(t,e,n){"use strict";e.a=function(){}},function(t,e,n){"use strict";function point(t,e,n){t._context.bezierCurveTo((2*t._x0+t._x1)/3,(2*t._y0+t._y1)/3,(t._x0+2*t._x1)/3,(t._y0+2*t._y1)/3,(t._x0+4*t._x1+e)/6,(t._y0+4*t._y1+n)/6)}function Basis(t){this._context=t}e.c=point,e.a=Basis,Basis.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){switch(this._point){case 3:point(this,this._x1,this._y1);case 2:this._context.lineTo(this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;break;case 2:this._point=3,this._context.lineTo((5*this._x0+this._x1)/6,(5*this._y0+this._y1)/6);default:point(this,t,e)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e}},e.b=function(t){return new Basis(t)}},function(t,e,n){"use strict";function point(t,e,n){t._context.bezierCurveTo(t._x1+t._k*(t._x2-t._x0),t._y1+t._k*(t._y2-t._y0),t._x2+t._k*(t._x1-e),t._y2+t._k*(t._y1-n),t._x2,t._y2)}function Cardinal(t,e){this._context=t,this._k=(1-e)/6}e.c=point,e.a=Cardinal,Cardinal.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:point(this,this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2,this._x1=t,this._y1=e;break;case 2:this._point=3;default:point(this,t,e)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.b=function custom(t){function cardinal(e){return new Cardinal(e,t)}return cardinal.tension=function(t){return custom(+t)},cardinal}(0)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},singleColors:{aloeGreen:["#7bdcc0"]},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green To Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"}}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},emptyDonutData:[{quantity:1,percentage:100}],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId"}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=(n(158),n(7));n.d(e,"transition",function(){return r.b});var a=n(179);n.d(e,"active",function(){return a.a});var i=n(58);n.d(e,"interrupt",function(){return i.a})},function(t,e,n){"use strict";function linear(t){return+t}e.a=linear},function(t,e,n){"use strict";function quadIn(t){return t*t}function quadOut(t){return t*(2-t)}function quadInOut(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.a=quadIn,e.c=quadOut,e.b=quadInOut},function(t,e,n){"use strict";function cubicIn(t){return t*t*t}function cubicOut(t){return--t*t*t+1}function cubicInOut(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.a=cubicIn,e.c=cubicOut,e.b=cubicInOut},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function polyIn(e){return Math.pow(e,t)}return t=+t,polyIn.exponent=custom,polyIn}(3),a=function custom(t){function polyOut(e){return 1-Math.pow(1-e,t)}return t=+t,polyOut.exponent=custom,polyOut}(3),i=function custom(t){function polyInOut(e){return((e*=2)<=1?Math.pow(e,t):2-Math.pow(2-e,t))/2}return t=+t,polyInOut.exponent=custom,polyInOut}(3)},function(t,e,n){"use strict";function sinIn(t){return 1-Math.cos(t*a)}function sinOut(t){return Math.sin(t*a)}function sinInOut(t){return(1-Math.cos(r*t))/2}e.a=sinIn,e.c=sinOut,e.b=sinInOut;var r=Math.PI,a=r/2},function(t,e,n){"use strict";function expIn(t){return Math.pow(2,10*t-10)}function expOut(t){return 1-Math.pow(2,-10*t)}function expInOut(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}e.a=expIn,e.c=expOut,e.b=expInOut},function(t,e,n){"use strict";function circleIn(t){return 1-Math.sqrt(1-t*t)}function circleOut(t){return Math.sqrt(1- --t*t)}function circleInOut(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}e.a=circleIn,e.c=circleOut,e.b=circleInOut},function(t,e,n){"use strict";function bounceIn(t){return 1-bounceOut(1-t)}function bounceOut(t){return(t=+t)<r?h*t*t:t<i?h*(t-=a)*t+o:t<c?h*(t-=u)*t+s:h*(t-=f)*t+l}function bounceInOut(t){return((t*=2)<=1?1-bounceOut(1-t):bounceOut(t-1)+1)/2}e.a=bounceIn,e.c=bounceOut,e.b=bounceInOut;var r=4/11,a=6/11,i=8/11,o=.75,u=9/11,c=10/11,s=.9375,f=21/22,l=63/64,h=1/r/r},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function backIn(e){return e*e*((t+1)*e-t)}return t=+t,backIn.overshoot=custom,backIn}(1.70158),a=function custom(t){function backOut(e){return--e*e*((t+1)*e+t)+1}return t=+t,backOut.overshoot=custom,backOut}(1.70158),i=function custom(t){function backInOut(e){return((e*=2)<1?e*e*((t+1)*e-t):(e-=2)*e*((t+1)*e+t)+2)/2}return t=+t,backInOut.overshoot=custom,backInOut}(1.70158)},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"b",function(){return o});var r=2*Math.PI,a=function custom(t,e){function elasticIn(r){return t*Math.pow(2,10*--r)*Math.sin((n-r)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticIn.amplitude=function(t){return custom(t,e*r)},elasticIn.period=function(e){return custom(t,e)},elasticIn}(1,.3),i=function custom(t,e){function elasticOut(r){return 1-t*Math.pow(2,-10*(r=+r))*Math.sin((r+n)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticOut.amplitude=function(t){return custom(t,e*r)},elasticOut.period=function(e){return custom(t,e)},elasticOut}(1,.3),o=function custom(t,e){function elasticInOut(r){return((r=2*r-1)<0?t*Math.pow(2,10*r)*Math.sin((n-r)/e):2-t*Math.pow(2,-10*r)*Math.sin((n+r)/e))/2}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticInOut.amplitude=function(t){return custom(t,e*r)},elasticInOut.period=function(e){return custom(t,e)},elasticInOut}(1,.3)},function(t,e,n){"use strict";function labConvert(t){if(t instanceof Lab)return new Lab(t.l,t.a,t.b,t.opacity);if(t instanceof Hcl){var e=t.h*i.a;return new Lab(t.l,Math.cos(e)*t.c,Math.sin(e)*t.c,t.opacity)}t instanceof a.b||(t=Object(a.h)(t));var n=rgb2xyz(t.r),r=rgb2xyz(t.g),s=rgb2xyz(t.b),f=xyz2lab((.4124564*n+.3575761*r+.1804375*s)/o),l=xyz2lab((.2126729*n+.7151522*r+.072175*s)/u);return new Lab(116*l-16,500*(f-l),200*(l-xyz2lab((.0193339*n+.119192*r+.9503041*s)/c)),t.opacity)}function lab(t,e,n,r){return 1===arguments.length?labConvert(t):new Lab(t,e,n,null==r?1:r)}function Lab(t,e,n,r){this.l=+t,this.a=+e,this.b=+n,this.opacity=+r}function xyz2lab(t){return t>h?Math.pow(t,1/3):t/l+s}function lab2xyz(t){return t>f?t*t*t:l*(t-s)}function xyz2rgb(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function rgb2xyz(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function hclConvert(t){if(t instanceof Hcl)return new Hcl(t.h,t.c,t.l,t.opacity);t instanceof Lab||(t=labConvert(t));var e=Math.atan2(t.b,t.a)*i.b;return new Hcl(e<0?e+360:e,Math.sqrt(t.a*t.a+t.b*t.b),t.l,t.opacity)}function hcl(t,e,n,r){return 1===arguments.length?hclConvert(t):new Hcl(t,e,n,null==r?1:r)}function Hcl(t,e,n,r){this.h=+t,this.c=+e,this.l=+n,this.opacity=+r}e.a=lab,e.b=hcl;var r=n(20),a=n(19),i=n(41),o=.95047,u=1,c=1.08883,s=4/29,f=6/29,l=3*f*f,h=f*f*f;Object(r.a)(Lab,lab,Object(r.b)(a.a,{brighter:function(t){return new Lab(this.l+18*(null==t?1:t),this.a,this.b,this.opacity)},darker:function(t){return new Lab(this.l-18*(null==t?1:t),this.a,this.b,this.opacity)},rgb:function(){var t=(this.l+16)/116,e=isNaN(this.a)?t:t+this.a/500,n=isNaN(this.b)?t:t-this.b/200;return t=u*lab2xyz(t),e=o*lab2xyz(e),n=c*lab2xyz(n),new a.b(xyz2rgb(3.2404542*e-1.5371385*t-.4985314*n),xyz2rgb(-.969266*e+1.8760108*t+.041556*n),xyz2rgb(.0556434*e-.2040259*t+1.0572252*n),this.opacity)}})),Object(r.a)(Hcl,hcl,Object(r.b)(a.a,{brighter:function(t){return new Hcl(this.h,this.c,this.l+18*(null==t?1:t),this.opacity)},darker:function(t){return new Hcl(this.h,this.c,this.l-18*(null==t?1:t),this.opacity)},rgb:function(){return labConvert(this).rgb()}}))},function(t,e,n){"use strict";function cubehelixConvert(t){if(t instanceof Cubehelix)return new Cubehelix(t.h,t.s,t.l,t.opacity);t instanceof a.b||(t=Object(a.h)(t));var e=t.r/255,n=t.g/255,r=t.b/255,o=(d*r+l*e-h*n)/(d+l-h),u=r-o,p=(f*(n-o)-c*u)/s,b=Math.sqrt(p*p+u*u)/(f*o*(1-o)),v=b?Math.atan2(p,u)*i.b-120:NaN;return new Cubehelix(v<0?v+360:v,b,o,t.opacity)}function cubehelix(t,e,n,r){return 1===arguments.length?cubehelixConvert(t):new Cubehelix(t,e,n,null==r?1:r)}function Cubehelix(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}e.a=cubehelix;var r=n(20),a=n(19),i=n(41),o=-.14861,u=1.78277,c=-.29227,s=-.90649,f=1.97294,l=f*s,h=f*u,d=u*c-s*o;Object(r.a)(Cubehelix,cubehelix,Object(r.b)(a.a,{brighter:function(t){return t=null==t?a.c:Math.pow(a.c,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a.d:Math.pow(a.d,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=isNaN(this.h)?0:(this.h+120)*i.a,e=+this.l,n=isNaN(this.s)?0:this.s*e*(1-e),r=Math.cos(t),l=Math.sin(t);return new a.b(255*(e+n*(o*r+u*l)),255*(e+n*(c*r+s*l)),255*(e+n*(f*r)),this.opacity)}}))},function(t,e,n){"use strict";function dispatch(){for(var t,e=0,n=arguments.length,r={};e<n;++e){if(!(t=arguments[e]+"")||t in r)throw new Error("illegal type: "+t);r[t]=[]}return new Dispatch(r)}function Dispatch(t){this._=t}function parseTypenames(t,e){return t.trim().split(/^|\s+/).map(function(t){var n="",r=t.indexOf(".");if(r>=0&&(n=t.slice(r+1),t=t.slice(0,r)),t&&!e.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:n}})}function get(t,e){for(var n,r=0,a=t.length;r<a;++r)if((n=t[r]).name===e)return n.value}function set(t,e,n){for(var a=0,i=t.length;a<i;++a)if(t[a].name===e){t[a]=r,t=t.slice(0,a).concat(t.slice(a+1));break}return null!=n&&t.push({name:e,value:n}),t}var r={value:function(){}};Dispatch.prototype=dispatch.prototype={constructor:Dispatch,on:function(t,e){var n,r=this._,a=parseTypenames(t+"",r),i=-1,o=a.length;{if(!(arguments.length<2)){if(null!=e&&"function"!=typeof e)throw new Error("invalid callback: "+e);for(;++i<o;)if(n=(t=a[i]).type)r[n]=set(r[n],t.name,e);else if(null==e)for(n in r)r[n]=set(r[n],t.name,null);return this}for(;++i<o;)if((n=(t=a[i]).type)&&(n=get(r[n],t.name)))return n}},copy:function(){var t={},e=this._;for(var n in e)t[n]=e[n].slice();return new Dispatch(t)},call:function(t,e){if((n=arguments.length-2)>0)for(var n,r,a=new Array(n),i=0;i<n;++i)a[i]=arguments[i+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(r=this._[t],i=0,n=r.length;i<n;++i)r[i].value.apply(e,a)},apply:function(t,e,n){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],a=0,i=r.length;a<i;++a)r[a].value.apply(e,n)}},e.a=dispatch},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(o.a)(t),a=r.format,i=r.formatPrefix,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),e.a=defaultLocale;var r,a,i,o=n(42);defaultLocale({decimal:".",thousands:",",grouping:[3],currency:["$",""]})},function(t,e,n){"use strict";e.a=function(t,e){return function(n,r){for(var a=n.length,i=[],o=0,u=t[0],c=0;a>0&&u>0&&(c+u+1>r&&(u=Math.max(1,r-c)),i.push(n.substring(a-=u,a+u)),!((c+=u+1)>r));)u=t[o=(o+1)%t.length];return i.reverse().join(e)}}},function(t,e,n){"use strict";e.a=function(t){return function(e){return e.replace(/[0-9]/g,function(e){return t[+e]})}}},function(t,e,n){"use strict";e.a=function(t,e){t=t.toPrecision(e);t:for(var n,r=t.length,a=1,i=-1;a<r;++a)switch(t[a]){case".":i=n=a;break;case"0":0===i&&(i=a),n=a;break;case"e":break t;default:i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t,e){var n=Object(r.a)(t,e);if(!n)return t+"";var a=n[0],i=n[1];return i<0?"0."+new Array(-i).join("0")+a:a.length>i+1?a.slice(0,i+1)+"."+a.slice(i+1):a+new Array(i-a.length+2).join("0")}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(13);e.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3)))-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return t=Math.abs(t),e=Math.abs(e)-t,Math.max(0,Object(r.a)(e)-Object(r.a)(t))+1}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(217);n.d(e,"nest",function(){return r.a});var a=n(218);n.d(e,"set",function(){return a.a});var i=n(38);n.d(e,"map",function(){return i.a});var o=n(219);n.d(e,"keys",function(){return o.a});var u=n(220);n.d(e,"values",function(){return u.a});var c=n(221);n.d(e,"entries",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return Math.round(t+e*n)}}},function(t,e,n){"use strict";function interpolateTransform(t,e,n,a){function pop(t){return t.length?t.pop()+" ":""}function translate(t,a,i,o,u,c){if(t!==i||a!==o){var s=u.push("translate(",null,e,null,n);c.push({i:s-4,x:Object(r.a)(t,i)},{i:s-2,x:Object(r.a)(a,o)})}else(i||o)&&u.push("translate("+i+e+o+n)}function rotate(t,e,n,i){t!==e?(t-e>180?e+=360:e-t>180&&(t+=360),i.push({i:n.push(pop(n)+"rotate(",null,a)-2,x:Object(r.a)(t,e)})):e&&n.push(pop(n)+"rotate("+e+a)}function skewX(t,e,n,i){t!==e?i.push({i:n.push(pop(n)+"skewX(",null,a)-2,x:Object(r.a)(t,e)}):e&&n.push(pop(n)+"skewX("+e+a)}function scale(t,e,n,a,i,o){if(t!==n||e!==a){var u=i.push(pop(i)+"scale(",null,",",null,")");o.push({i:u-4,x:Object(r.a)(t,n)},{i:u-2,x:Object(r.a)(e,a)})}else 1===n&&1===a||i.push(pop(i)+"scale("+n+","+a+")")}return function(e,n){var r=[],a=[];return e=t(e),n=t(n),translate(e.translateX,e.translateY,n.translateX,n.translateY,r,a),rotate(e.rotate,n.rotate,r,a),skewX(e.skewX,n.skewX,r,a),scale(e.scaleX,e.scaleY,n.scaleX,n.scaleY,r,a),e=n=null,function(t){for(var e,n=-1,i=a.length;++n<i;)r[(e=a[n]).i]=e.x(t);return r.join("")}}}n.d(e,"a",function(){return i}),n.d(e,"b",function(){return o});var r=n(15),a=n(117),i=interpolateTransform(a.a,"px, ","px)","deg)"),o=interpolateTransform(a.b,", ",")",")")},function(t,e,n){"use strict";function parseCss(t){return"none"===t?u.b:(r||(r=document.createElement("DIV"),a=document.documentElement,i=document.defaultView),r.style.transform=t,t=i.getComputedStyle(a.appendChild(r),null).getPropertyValue("transform"),a.removeChild(r),t=t.slice(7,-1).split(","),Object(u.a)(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}function parseSvg(t){return null==t?u.b:(o||(o=document.createElementNS("http://www.w3.org/2000/svg","g")),o.setAttribute("transform",t),(t=o.transform.baseVal.consolidate())?(t=t.matrix,Object(u.a)(t.a,t.b,t.c,t.d,t.e,t.f)):u.b)}e.a=parseCss,e.b=parseSvg;var r,a,i,o,u=n(118)},function(t,e,n){"use strict";n.d(e,"b",function(){return a});var r=180/Math.PI,a={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};e.a=function(t,e,n,a,i,o){var u,c,s;return(u=Math.sqrt(t*t+e*e))&&(t/=u,e/=u),(s=t*n+e*a)&&(n-=t*s,a-=e*s),(c=Math.sqrt(n*n+a*a))&&(n/=c,a/=c,s/=c),t*a<e*n&&(t=-t,e=-e,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(e,t)*r,skewX:Math.atan(s)*r,scaleX:u,scaleY:c}}},function(t,e,n){"use strict";function cosh(t){return((t=Math.exp(t))+1/t)/2}function sinh(t){return((t=Math.exp(t))-1/t)/2}function tanh(t){return((t=Math.exp(2*t))-1)/(t+1)}var r=Math.SQRT2;e.a=function(t,e){var n,a,i=t[0],o=t[1],u=t[2],c=e[0],s=e[1],f=e[2],l=c-i,h=s-o,d=l*l+h*h;if(d<1e-12)a=Math.log(f/u)/r,n=function(t){return[i+t*l,o+t*h,u*Math.exp(r*t*a)]};else{var p=Math.sqrt(d),b=(f*f-u*u+4*d)/(2*u*2*p),v=(f*f-u*u-4*d)/(2*f*2*p),m=Math.log(Math.sqrt(b*b+1)-b),y=Math.log(Math.sqrt(v*v+1)-v);a=(y-m)/r,n=function(t){var e=t*a,n=cosh(m),c=u/(2*p)*(n*tanh(r*e+m)-sinh(m));return[i+c*l,o+c*h,u*n/cosh(r*e+m)]}}return n.duration=1e3*a,n}},function(t,e,n){"use strict";function hsl(t){return function(e,n){var i=t((e=Object(r.hsl)(e)).h,(n=Object(r.hsl)(n)).h),o=Object(a.a)(e.s,n.s),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.s=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hsl(a.c);var i=hsl(a.a)},function(t,e,n){"use strict";function lab(t,e){var n=Object(a.a)((t=Object(r.lab)(t)).l,(e=Object(r.lab)(e)).l),i=Object(a.a)(t.a,e.a),o=Object(a.a)(t.b,e.b),u=Object(a.a)(t.opacity,e.opacity);return function(e){return t.l=n(e),t.a=i(e),t.b=o(e),t.opacity=u(e),t+""}}e.a=lab;var r=n(4),a=n(11)},function(t,e,n){"use strict";function hcl(t){return function(e,n){var i=t((e=Object(r.hcl)(e)).h,(n=Object(r.hcl)(n)).h),o=Object(a.a)(e.c,n.c),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.c=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hcl(a.c);var i=hcl(a.a)},function(t,e,n){"use strict";function cubehelix(t){return function cubehelixGamma(e){function cubehelix(n,i){var o=t((n=Object(r.cubehelix)(n)).h,(i=Object(r.cubehelix)(i)).h),u=Object(a.a)(n.s,i.s),c=Object(a.a)(n.l,i.l),s=Object(a.a)(n.opacity,i.opacity);return function(t){return n.h=o(t),n.s=u(t),n.l=c(Math.pow(t,e)),n.opacity=s(t),n+""}}return e=+e,cubehelix.gamma=cubehelixGamma,cubehelix}(1)}n.d(e,"a",function(){return i});var r=n(4),a=n(11);e.b=cubehelix(a.c);var i=cubehelix(a.a)},function(t,e,n){"use strict";e.a=function(t,e){for(var n=new Array(e),r=0;r<e;++r)n[r]=t(r/(e-1));return n}},function(t,e,n){"use strict";function local(){return new Local}function Local(){this._="@"+(++r).toString(36)}e.a=local;var r=0;Local.prototype=local.prototype={constructor:Local,get:function(t){for(var e=this._;!(e in t);)if(!(t=t.parentNode))return;return t[e]},set:function(t,e){return t[this._]=e},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t){var e=Object(r.a)();return e.changedTouches&&(e=e.changedTouches[0]),Object(a.a)(t,e)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,e,n){"use strict";var r=n(1),a=n(31);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c,s=e[o],f=s.length,l=i[o]=new Array(f),h=0;h<f;++h)(u=s[h])&&(c=t.call(u,u.__data__,h,s))&&("__data__"in u&&(c.__data__=u.__data__),l[h]=c);return new r.a(i,this._parents)}},function(t,e,n){"use strict";var r=n(1),a=n(54);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=[],o=[],u=0;u<n;++u)for(var c,s=e[u],f=s.length,l=0;l<f;++l)(c=s[l])&&(i.push(t.call(c,c.__data__,l,s)),o.push(c));return new r.a(i,o)}},function(t,e,n){"use strict";var r=n(1),a=n(53);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new r.a(i,this._parents)}},function(t,e,n){"use strict";function bindIndex(t,e,n,r,i,o){for(var u,c=0,s=e.length,f=o.length;c<f;++c)(u=e[c])?(u.__data__=o[c],r[c]=u):n[c]=new a.a(t,o[c]);for(;c<s;++c)(u=e[c])&&(i[c]=u)}function bindKey(t,e,n,r,i,u,c){var s,f,l,h={},d=e.length,p=u.length,b=new Array(d);for(s=0;s<d;++s)(f=e[s])&&(b[s]=l=o+c.call(f,f.__data__,s,e),l in h?i[s]=f:h[l]=f);for(s=0;s<p;++s)l=o+c.call(t,u[s],s,u),(f=h[l])?(r[s]=f,f.__data__=u[s],h[l]=null):n[s]=new a.a(t,u[s]);for(s=0;s<d;++s)(f=e[s])&&h[b[s]]===f&&(i[s]=f)}var r=n(1),a=n(55),i=n(132),o="$";e.a=function(t,e){if(!t)return b=new Array(this.size()),l=-1,this.each(function(t){b[++l]=t}),b;var n=e?bindKey:bindIndex,a=this._parents,o=this._groups;"function"!=typeof t&&(t=Object(i.a)(t));for(var u=o.length,c=new Array(u),s=new Array(u),f=new Array(u),l=0;l<u;++l){var h=a[l],d=o[l],p=d.length,b=t.call(h,h&&h.__data__,l,a),v=b.length,m=s[l]=new Array(v),y=c[l]=new Array(v);n(h,d,m,y,f[l]=new Array(p),b,e);for(var g,_,x=0,w=0;x<v;++x)if(g=m[x]){for(x>=w&&(w=x+1);!(_=y[w])&&++w<v;);g._next=_||null}}return c=new r.a(c,a),c._enter=s,c._exit=f,c}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(56),a=n(1);e.a=function(){return new a.a(this._exit||this._groups.map(r.a),this._parents)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents)}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=-1,n=t.length;++e<n;)for(var r,a=t[e],i=a.length-1,o=a[i];--i>=0;)(r=a[i])&&(o&&o!==r.nextSibling&&o.parentNode.insertBefore(r,o),o=r);return this}},function(t,e,n){"use strict";function ascending(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}var r=n(1);e.a=function(t){function compareNode(e,n){return e&&n?t(e.__data__,n.__data__):!e-!n}t||(t=ascending);for(var e=this._groups,n=e.length,a=new Array(n),i=0;i<n;++i){for(var o,u=e[i],c=u.length,s=a[i]=new Array(c),f=0;f<c;++f)(o=u[f])&&(s[f]=o);s.sort(compareNode)}return new r.a(a,this._parents).order()}},function(t,e,n){"use strict";e.a=function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}},function(t,e,n){"use strict";e.a=function(){var t=new Array(this.size()),e=-1;return this.each(function(){t[++e]=this}),t}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=0,n=t.length;e<n;++e)for(var r=t[e],a=0,i=r.length;a<i;++a){var o=r[a];if(o)return o}return null}},function(t,e,n){"use strict";e.a=function(){var t=0;return this.each(function(){++t}),t}},function(t,e,n){"use strict";e.a=function(){return!this.node()}},function(t,e,n){"use strict";e.a=function(t){for(var e=this._groups,n=0,r=e.length;n<r;++n)for(var a,i=e[n],o=0,u=i.length;o<u;++o)(a=i[o])&&t.call(a,a.__data__,o,i);return this}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e){return function(){this.setAttribute(t,e)}}function attrConstantNS(t,e){return function(){this.setAttributeNS(t.space,t.local,e)}}function attrFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttribute(t):this.setAttribute(t,n)}}function attrFunctionNS(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,n)}}var r=n(26);e.a=function(t,e){var n=Object(r.a)(t);if(arguments.length<2){var a=this.node();return n.local?a.getAttributeNS(n.space,n.local):a.getAttribute(n)}return this.each((null==e?n.local?attrRemoveNS:attrRemove:"function"==typeof e?n.local?attrFunctionNS:attrFunction:n.local?attrConstantNS:attrConstant)(n,e))}},function(t,e,n){"use strict";function propertyRemove(t){return function(){delete this[t]}}function propertyConstant(t,e){return function(){this[t]=e}}function propertyFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?delete this[t]:this[t]=n}}e.a=function(t,e){return arguments.length>1?this.each((null==e?propertyRemove:"function"==typeof e?propertyFunction:propertyConstant)(t,e)):this.node()[t]}},function(t,e,n){"use strict";function classArray(t){return t.trim().split(/^|\s+/)}function classList(t){return t.classList||new ClassList(t)}function ClassList(t){this._node=t,this._names=classArray(t.getAttribute("class")||"")}function classedAdd(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.add(e[r])}function classedRemove(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.remove(e[r])}function classedTrue(t){return function(){classedAdd(this,t)}}function classedFalse(t){return function(){classedRemove(this,t)}}function classedFunction(t,e){return function(){(e.apply(this,arguments)?classedAdd:classedRemove)(this,t)}}ClassList.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var e=this._names.indexOf(t);e>=0&&(this._names.splice(e,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}},e.a=function(t,e){var n=classArray(t+"");if(arguments.length<2){for(var r=classList(this.node()),a=-1,i=n.length;++a<i;)if(!r.contains(n[a]))return!1;return!0}return this.each(("function"==typeof e?classedFunction:e?classedTrue:classedFalse)(n,e))}},function(t,e,n){"use strict";function textRemove(){this.textContent=""}function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t.apply(this,arguments);this.textContent=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?textRemove:("function"==typeof t?textFunction:textConstant)(t)):this.node().textContent}},function(t,e,n){"use strict";function htmlRemove(){this.innerHTML=""}function htmlConstant(t){return function(){this.innerHTML=t}}function htmlFunction(t){return function(){var e=t.apply(this,arguments);this.innerHTML=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?htmlRemove:("function"==typeof t?htmlFunction:htmlConstant)(t)):this.node().innerHTML}},function(t,e,n){"use strict";function raise(){this.nextSibling&&this.parentNode.appendChild(this)}e.a=function(){return this.each(raise)}},function(t,e,n){"use strict";function lower(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}e.a=function(){return this.each(lower)}},function(t,e,n){"use strict";var r=n(25);e.a=function(t){var e="function"==typeof t?t:Object(r.a)(t);return this.select(function(){return this.appendChild(e.apply(this,arguments))})}},function(t,e,n){"use strict";function constantNull(){return null}var r=n(25),a=n(31);e.a=function(t,e){var n="function"==typeof t?t:Object(r.a)(t),i=null==e?constantNull:"function"==typeof e?e:Object(a.a)(e);return this.select(function(){return this.insertBefore(n.apply(this,arguments),i.apply(this,arguments)||null)})}},function(t,e,n){"use strict";function remove(){var t=this.parentNode;t&&t.removeChild(this)}e.a=function(){return this.each(remove)}},function(t,e,n){"use strict";e.a=function(t){return arguments.length?this.property("__data__",t):this.node().__data__}},function(t,e,n){"use strict";function dispatchEvent(t,e,n){var a=Object(r.a)(t),i=a.CustomEvent;"function"==typeof i?i=new i(e,n):(i=a.document.createEvent("Event"),n?(i.initEvent(e,n.bubbles,n.cancelable),i.detail=n.detail):i.initEvent(e,!1,!1)),t.dispatchEvent(i)}function dispatchConstant(t,e){return function(){return dispatchEvent(this,t,e)}}function dispatchFunction(t,e){return function(){return dispatchEvent(this,t,e.apply(this,arguments))}}var r=n(32);e.a=function(t,e){return this.each(("function"==typeof e?dispatchFunction:dispatchConstant)(t,e))}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([document.querySelectorAll(t)],[document.documentElement]):new r.a([null==t?[]:t],r.c)}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e,n){arguments.length<3&&(n=e,e=Object(r.a)().changedTouches);for(var i,o=0,u=e?e.length:0;o<u;++o)if((i=e[o]).identifier===n)return Object(a.a)(t,i);return null}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e){null==e&&(e=Object(r.a)().touches);for(var n=0,i=e?e.length:0,o=new Array(i);n<i;++n)o[n]=Object(a.a)(t,e[n]);return o}},function(t,e,n){"use strict";var r=n(3),a=n(159),i=n(162);r.selection.prototype.interrupt=a.a,r.selection.prototype.transition=i.a},function(t,e,n){"use strict";var r=n(58);e.a=function(t){return this.each(function(){Object(r.a)(this,t)})}},function(t,e,n){"use strict";var r=n(33);e.a=function(t,e,n){var a=new r.a;return e=null==e?0:+e,a.restart(function(n){a.stop(),t(n+e)},e,n),a}},function(t,e,n){"use strict";n(33)},function(t,e,n){"use strict";function inherit(t,e){for(var n;!(n=t.__transition)||!(n=n[e]);)if(!(t=t.parentNode))return u.time=Object(o.a)(),u;return n}var r=n(7),a=n(2),i=n(65),o=n(59),u={time:null,delay:0,duration:250,ease:i.easeCubicInOut};e.a=function(t){var e,n;t instanceof r.a?(e=t._id,t=t._name):(e=Object(r.c)(),(n=u).time=Object(o.a)(),t=null==t?null:t+"");for(var i=this._groups,c=i.length,s=0;s<c;++s)for(var f,l=i[s],h=l.length,d=0;d<h;++d)(f=l[d])&&Object(a.e)(f,t,e,d,l,n||inherit(f,e));return new r.a(i,this._parents,t,e)}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e,n){var r,a;return function(){var i=this.getAttribute(t);return i===n?null:i===r?a:a=e(r=i,n)}}function attrConstantNS(t,e,n){var r,a;return function(){var i=this.getAttributeNS(t.space,t.local);return i===n?null:i===r?a:a=e(r=i,n)}}function attrFunction(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttribute(t):(o=this.getAttribute(t),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}function attrFunctionNS(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttributeNS(t.space,t.local):(o=this.getAttributeNS(t.space,t.local),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e){var n=Object(a.namespace)(t),u="transform"===n?r.interpolateTransformSvg:o.a;return this.attrTween(t,"function"==typeof e?(n.local?attrFunctionNS:attrFunction)(n,u,Object(i.b)(this,"attr."+t,e)):null==e?(n.local?attrRemoveNS:attrRemove)(n):(n.local?attrConstantNS:attrConstant)(n,u,e+""))}},function(t,e,n){"use strict";function attrTweenNS(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttributeNS(t.space,t.local,r(e))}}return tween._value=e,tween}function attrTween(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttribute(t,r(e))}}return tween._value=e,tween}var r=n(3);e.a=function(t,e){var n="attr."+t;if(arguments.length<2)return(n=this.tween(n))&&n._value;if(null==e)return this.tween(n,null);if("function"!=typeof e)throw new Error;var a=Object(r.namespace)(t);return this.tween(n,(a.local?attrTweenNS:attrTween)(a,e))}},function(t,e,n){"use strict";function delayFunction(t,e){return function(){Object(r.g)(this,t).delay=+e.apply(this,arguments)}}function delayConstant(t,e){return e=+e,function(){Object(r.g)(this,t).delay=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?delayFunction:delayConstant)(e,t)):Object(r.f)(this.node(),e).delay}},function(t,e,n){"use strict";function durationFunction(t,e){return function(){Object(r.h)(this,t).duration=+e.apply(this,arguments)}}function durationConstant(t,e){return e=+e,function(){Object(r.h)(this,t).duration=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?durationFunction:durationConstant)(e,t)):Object(r.f)(this.node(),e).duration}},function(t,e,n){"use strict";function easeConstant(t,e){if("function"!=typeof e)throw new Error;return function(){Object(r.h)(this,t).ease=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(easeConstant(e,t)):Object(r.f)(this.node(),e).ease}},function(t,e,n){"use strict";var r=n(3),a=n(7);e.a=function(t){"function"!=typeof t&&(t=Object(r.matcher)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new a.a(i,this._parents,this._name,this._id)}},function(t,e,n){"use strict";var r=n(7);e.a=function(t){if(t._id!==this._id)throw new Error;for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents,this._name,this._id)}},function(t,e,n){"use strict";function start(t){return(t+"").trim().split(/^|\s+/).every(function(t){var e=t.indexOf(".");return e>=0&&(t=t.slice(0,e)),!t||"start"===t})}function onFunction(t,e,n){var a,i,o=start(e)?r.g:r.h;return function(){var r=o(this,t),u=r.on;u!==a&&(i=(a=u).copy()).on(e,n),r.on=i}}var r=n(2);e.a=function(t,e){var n=this._id;return arguments.length<2?Object(r.f)(this.node(),n).on.on(t):this.each(onFunction(n,t,e))}},function(t,e,n){"use strict";function removeFunction(t){return function(){var e=this.parentNode;for(var n in this.__transition)if(+n!==t)return;e&&e.removeChild(this)}}e.a=function(){return this.on("end.remove",removeFunction(this._id))}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selector)(t));for(var o=this._groups,u=o.length,c=new Array(u),s=0;s<u;++s)for(var f,l,h=o[s],d=h.length,p=c[s]=new Array(d),b=0;b<d;++b)(f=h[b])&&(l=t.call(f,f.__data__,b,h))&&("__data__"in f&&(l.__data__=f.__data__),p[b]=l,Object(i.e)(p[b],e,n,b,p,Object(i.f)(f,n)));return new a.a(c,this._parents,e,n)}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selectorAll)(t));for(var o=this._groups,u=o.length,c=[],s=[],f=0;f<u;++f)for(var l,h=o[f],d=h.length,p=0;p<d;++p)if(l=h[p]){for(var b,v=t.call(l,l.__data__,p,h),m=Object(i.f)(l,n),y=0,g=v.length;y<g;++y)(b=v[y])&&Object(i.e)(b,e,n,y,v,m);c.push(v),s.push(l)}return new a.a(c,s,e,n)}},function(t,e,n){"use strict";var r=n(3),a=r.selection.prototype.constructor;e.a=function(){return new a(this._groups,this._parents)}},function(t,e,n){"use strict";function styleRemove(t,e){var n,r,i;return function(){var o=Object(a.style)(this,t),u=(this.style.removeProperty(t),Object(a.style)(this,t));return o===u?null:o===n&&u===r?i:i=e(n=o,r=u)}}function styleRemoveEnd(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){var r,i;return function(){var o=Object(a.style)(this,t);return o===n?null:o===r?i:i=e(r=o,n)}}function styleFunction(t,e,n){var r,i,o;return function(){var u=Object(a.style)(this,t),c=n(this);return null==c&&(this.style.removeProperty(t),c=Object(a.style)(this,t)),u===c?null:u===r&&c===i?o:o=e(r=u,i=c)}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e,n){var a="transform"==(t+="")?r.interpolateTransformCss:o.a;return null==e?this.styleTween(t,styleRemove(t,a)).on("end.style."+t,styleRemoveEnd(t)):this.styleTween(t,"function"==typeof e?styleFunction(t,a,Object(i.b)(this,"style."+t,e)):styleConstant(t,a,e+""),n)}},function(t,e,n){"use strict";function styleTween(t,e,n){function tween(){var r=this,a=e.apply(r,arguments);return a&&function(e){r.style.setProperty(t,a(e),n)}}return tween._value=e,tween}e.a=function(t,e,n){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==e)return this.tween(r,null);if("function"!=typeof e)throw new Error;return this.tween(r,styleTween(t,e,null==n?"":n))}},function(t,e,n){"use strict";function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t(this);this.textContent=null==e?"":e}}var r=n(17);e.a=function(t){return this.tween("text","function"==typeof t?textFunction(Object(r.b)(this,"text",t)):textConstant(null==t?"":t+""))}},function(t,e,n){"use strict";var r=n(7),a=n(2);e.a=function(){for(var t=this._name,e=this._id,n=Object(r.c)(),i=this._groups,o=i.length,u=0;u<o;++u)for(var c,s=i[u],f=s.length,l=0;l<f;++l)if(c=s[l]){var h=Object(a.f)(c,e);Object(a.e)(c,t,n,l,s,{time:h.time+h.delay+h.duration,delay:0,duration:h.duration,ease:h.ease})}return new r.a(i,this._parents,t,n)}},function(t,e,n){"use strict";var r=n(7),a=n(2),i=[null];e.a=function(t,e){var n,o,u=t.__transition;if(u){e=null==e?null:e+"";for(o in u)if((n=u[o]).state>a.c&&n.name===e)return new r.a([[t]],i,e,+o)}return null}},function(t,e,n){"use strict";var r=n(61),a=n(34),i=n(85),o=n(181);e.a=function(){function line(a){var i,o,f,l=a.length,h=!1;for(null==u&&(s=c(f=Object(r.a)())),i=0;i<=l;++i)!(i<l&&n(o=a[i],i,a))===h&&((h=!h)?s.lineStart():s.lineEnd()),h&&s.point(+t(o,i,a),+e(o,i,a));if(f)return s=null,f+""||null}var t=o.a,e=o.b,n=Object(a.a)(!0),u=null,c=i.a,s=null;return line.x=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(+e),line):t},line.y=function(t){return arguments.length?(e="function"==typeof t?t:Object(a.a)(+t),line):e},line.defined=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(!!t),line):n},line.curve=function(t){return arguments.length?(c=t,null!=u&&(s=c(u)),line):c},line.context=function(t){return arguments.length?(null==t?u=s=null:s=c(u=t),line):u},line}},function(t,e,n){"use strict";function x(t){return t[0]}function y(t){return t[1]}e.a=x,e.b=y},function(t,e,n){"use strict";function point(t,e,n){var a=t._x1,i=t._y1,o=t._x2,u=t._y2;if(t._l01_a>r.f){var c=2*t._l01_2a+3*t._l01_a*t._l12_a+t._l12_2a,s=3*t._l01_a*(t._l01_a+t._l12_a);a=(a*c-t._x0*t._l12_2a+t._x2*t._l01_2a)/s,i=(i*c-t._y0*t._l12_2a+t._y2*t._l01_2a)/s}if(t._l23_a>r.f){var f=2*t._l23_2a+3*t._l23_a*t._l12_a+t._l12_2a,l=3*t._l23_a*(t._l23_a+t._l12_a);o=(o*f+t._x1*t._l23_2a-e*t._l12_2a)/l,u=(u*f+t._y1*t._l23_2a-n*t._l12_2a)/l}t._context.bezierCurveTo(a,i,o,u,t._x2,t._y2)}function CatmullRom(t,e){this._context=t,this._alpha=e}e.b=point;var r=n(62),a=n(88);CatmullRom.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:this.point(this._x2,this._y2)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){if(t=+t,e=+e,this._point){var n=this._x2-t,r=this._y2-e;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(n*n+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;break;case 2:this._point=3;default:point(this,t,e)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.a=function custom(t){function catmullRom(e){return t?new CatmullRom(e,t):new a.a(e,0)}return catmullRom.alpha=function(t){return custom(+t)},catmullRom}(.5)},function(t,e,n){"use strict";function sum(t){for(var e,n=0,r=-1,a=t.length;++r<a;)(e=+t[r][1])&&(n+=e);return n}e.b=sum;var r=n(64);e.a=function(t){var e=t.map(sum);return Object(r.a)(t).sort(function(t,n){return e[t]-e[n]})}},function(t,e,n){"use strict";var r=n(69);e.a=function(t,e,n){var a,i,o,u,c=t.length,s=e.length,f=new Array(c*s);for(null==n&&(n=r.b),a=o=0;a<c;++a)for(u=t[a],i=0;i<s;++i,++o)f[o]=n(u,e[i]);return f}},function(t,e,n){"use strict";e.a=function(t,e){return e<t?-1:e>t?1:e>=t?0:NaN}},function(t,e,n){"use strict";var r=n(73),a=n(67),i=n(187),o=n(72),u=n(188),c=n(74),s=n(75),f=n(76);e.a=function(){function histogram(r){var i,o,u=r.length,f=new Array(u);for(i=0;i<u;++i)f[i]=t(r[i],i,r);var l=e(f),h=l[0],d=l[1],p=n(f,h,d);Array.isArray(p)||(p=Object(s.c)(h,d,p),p=Object(c.a)(Math.ceil(h/p)*p,Math.floor(d/p)*p,p));for(var b=p.length;p[0]<=h;)p.shift(),--b;for(;p[b-1]>d;)p.pop(),--b;var v,m=new Array(b+1);for(i=0;i<=b;++i)v=m[i]=[],v.x0=i>0?p[i-1]:h,v.x1=i<b?p[i]:d;for(i=0;i<u;++i)o=f[i],h<=o&&o<=d&&m[Object(a.c)(p,o,0,b)].push(r[i]);return m}var t=u.a,e=o.a,n=f.a;return histogram.value=function(e){return arguments.length?(t="function"==typeof e?e:Object(i.a)(e),histogram):t},histogram.domain=function(t){return arguments.length?(e="function"==typeof t?t:Object(i.a)([t[0],t[1]]),histogram):e},histogram.thresholds=function(t){return arguments.length?(n="function"==typeof t?t:Array.isArray(t)?Object(i.a)(r.b.call(t)):Object(i.a)(t),histogram):n},histogram}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(73),a=n(10),i=n(12),o=n(36);e.a=function(t,e,n){return t=r.a.call(t,i.a).sort(a.a),Math.ceil((n-e)/(2*(Object(o.a)(t,.75)-Object(o.a)(t,.25))*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";var r=n(70);e.a=function(t,e,n){return Math.ceil((n-e)/(3.5*Object(r.a)(t)*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&n>r&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&n>r&&(r=n);return r}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a=t.length,i=a,o=-1,u=0;if(null==e)for(;++o<a;)isNaN(n=Object(r.a)(t[o]))?--i:u+=n;else for(;++o<a;)isNaN(n=Object(r.a)(e(t[o],o,t)))?--i:u+=n;if(i)return u/i}},function(t,e,n){"use strict";var r=n(10),a=n(12),i=n(36);e.a=function(t,e){var n,o=t.length,u=-1,c=[];if(null==e)for(;++u<o;)isNaN(n=Object(a.a)(t[u]))||c.push(n);else for(;++u<o;)isNaN(n=Object(a.a)(e(t[u],u,t)))||c.push(n);return Object(i.a)(c.sort(r.a),.5)}},function(t,e,n){"use strict";e.a=function(t){for(var e,n,r,a=t.length,i=-1,o=0;++i<a;)o+=t[i].length;for(n=new Array(o);--a>=0;)for(r=t[a],e=r.length;--e>=0;)n[--o]=r[e];return n}},function(t,e,n){"use strict";e.a=function(t,e){for(var n=e.length,r=new Array(n);n--;)r[n]=t[e[n]];return r}},function(t,e,n){"use strict";var r=n(10);e.a=function(t,e){if(n=t.length){var n,a,i=0,o=0,u=t[o];for(null==e&&(e=r.a);++i<n;)(e(a=t[i],u)<0||0!==e(u,u))&&(u=a,o=i);return 0===e(u,u)?o:void 0}}},function(t,e,n){"use strict";e.a=function(t,e,n){for(var r,a,i=(null==n?t.length:n)-(e=null==e?0:+e);i;)a=Math.random()*i--|0,r=t[i+e],t[i+e]=t[a+e],t[a+e]=r;return t}},function(t,e,n){"use strict";e.a=function(t,e){var n,r=t.length,a=-1,i=0;if(null==e)for(;++a<r;)(n=+t[a])&&(i+=n);else for(;++a<r;)(n=+e(t[a],a,t))&&(i+=n);return i}},function(t,e,n){"use strict";var r=n(78);e.a=function(){return Object(r.a)(arguments)}},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(){},function(t,e){t.setTime(+t+e)},function(t,e){return e-t});a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)(function(e){e.setTime(Math.floor(e/t)*t)},function(e,n){e.setTime(+e+n*t)},function(e,n){return(n-e)/t}):a:null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.d)*a.d)},function(t,e){t.setTime(+t+e*a.d)},function(t,e){return(e-t)/a.d},function(t){return t.getUTCSeconds()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.c)*a.c)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){var e=t.getTimezoneOffset()*a.c%a.b;e<0&&(e+=a.b),t.setTime(Math.floor((+t-e)/a.b)*a.b+e)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"a",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.a},function(t){return t.getDate()-1});e.b=i;var o=i.range},function(t,e,n){"use strict";function weekday(t){return Object(r.a)(function(e){e.setDate(e.getDate()-(e.getDay()+7-t)%7),e.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+7*e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=weekday(0),o=weekday(1),u=weekday(2),c=weekday(3),s=weekday(4),f=weekday(5),l=weekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setDate(1),t.setHours(0,0,0,0)},function(t,e){t.setMonth(t.getMonth()+e)},function(t,e){return e.getMonth()-t.getMonth()+12*(e.getFullYear()-t.getFullYear())},function(t){return t.getMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setMonth(0,1),t.setHours(0,0,0,0)},function(t,e){t.setFullYear(t.getFullYear()+e)},function(t,e){return e.getFullYear()-t.getFullYear()},function(t){return t.getFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setFullYear(Math.floor(e.getFullYear()/t)*t),e.setMonth(0,1),e.setHours(0,0,0,0)},function(e,n){e.setFullYear(e.getFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCSeconds(0,0)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getUTCMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCMinutes(0,0,0)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getUTCHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+e)},function(t,e){return(e-t)/a.a},function(t){return t.getUTCDate()-1});e.a=i;var o=i.range},function(t,e,n){"use strict";function utcWeekday(t){return Object(r.a)(function(e){e.setUTCDate(e.getUTCDate()-(e.getUTCDay()+7-t)%7),e.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+7*e)},function(t,e){return(e-t)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=utcWeekday(0),o=utcWeekday(1),u=utcWeekday(2),c=utcWeekday(3),s=utcWeekday(4),f=utcWeekday(5),l=utcWeekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCMonth(t.getUTCMonth()+e)},function(t,e){return e.getUTCMonth()-t.getUTCMonth()+12*(e.getUTCFullYear()-t.getUTCFullYear())},function(t){return t.getUTCMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCFullYear(t.getUTCFullYear()+e)},function(t,e){return e.getUTCFullYear()-t.getUTCFullYear()},function(t){return t.getUTCFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setUTCFullYear(Math.floor(e.getUTCFullYear()/t)*t),e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0)},function(e,n){e.setUTCFullYear(e.getUTCFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";function parseIsoNative(t){var e=new Date(t);return isNaN(e)?null:e}var r=n(80),a=n(37),i=+new Date("2000-01-01T00:00:00.000Z")?parseIsoNative:Object(a.e)(r.b);e.a=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(216);n.d(e,"scaleBand",function(){return r.a}),n.d(e,"scalePoint",function(){return r.b});var a=n(222);n.d(e,"scaleIdentity",function(){return a.a});var i=n(14);n.d(e,"scaleLinear",function(){return i.a});var o=n(224);n.d(e,"scaleLog",function(){return o.a});var u=n(81);n.d(e,"scaleOrdinal",function(){return u.a}),n.d(e,"scaleImplicit",function(){return u.b});var c=n(225);n.d(e,"scalePow",function(){return c.a}),n.d(e,"scaleSqrt",function(){return c.b});var s=n(226);n.d(e,"scaleQuantile",function(){return s.a});var f=n(227);n.d(e,"scaleQuantize",function(){return f.a});var l=n(228);n.d(e,"scaleThreshold",function(){return l.a});var h=n(84);n.d(e,"scaleTime",function(){return h.b});var d=n(229);n.d(e,"scaleUtc",function(){return d.a});var p=n(230);n.d(e,"schemeCategory10",function(){return p.a});var b=n(231);n.d(e,"schemeCategory20b",function(){return b.a});var v=n(232);n.d(e,"schemeCategory20c",function(){return v.a});var m=n(233);n.d(e,"schemeCategory20",function(){return m.a});var y=n(234);n.d(e,"interpolateCubehelixDefault",function(){return y.a});var g=n(235);n.d(e,"interpolateRainbow",function(){return g.b}),n.d(e,"interpolateWarm",function(){return g.c}),n.d(e,"interpolateCool",function(){return g.a});var _=n(236);n.d(e,"interpolateViridis",function(){return _.a}),n.d(e,"interpolateMagma",function(){return _.c}),n.d(e,"interpolateInferno",function(){return _.b}),n.d(e,"interpolatePlasma",function(){return _.d});var x=n(237);n.d(e,"scaleSequential",function(){return x.a})},function(t,e,n){"use strict";function band(){function rescale(){var n=i().length,a=u[1]<u[0],h=u[a-0],d=u[1-a];t=(d-h)/Math.max(1,n-s+2*f),c&&(t=Math.floor(t)),h+=(d-h-t*(n-s))*l,e=t*(1-s),c&&(h=Math.round(h),e=Math.round(e));var p=Object(r.range)(n).map(function(e){return h+t*e});return o(a?p.reverse():p)}var t,e,n=Object(a.a)().unknown(void 0),i=n.domain,o=n.range,u=[0,1],c=!1,s=0,f=0,l=.5;return delete n.unknown,n.domain=function(t){return arguments.length?(i(t),rescale()):i()},n.range=function(t){return arguments.length?(u=[+t[0],+t[1]],rescale()):u.slice()},n.rangeRound=function(t){return u=[+t[0],+t[1]],c=!0,rescale()},n.bandwidth=function(){return e},n.step=function(){return t},n.round=function(t){return arguments.length?(c=!!t,rescale()):c},n.padding=function(t){return arguments.length?(s=f=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingInner=function(t){return arguments.length?(s=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingOuter=function(t){return arguments.length?(f=Math.max(0,Math.min(1,t)),rescale()):f},n.align=function(t){return arguments.length?(l=Math.max(0,Math.min(1,t)),rescale()):l},n.copy=function(){return band().domain(i()).range(u).round(c).paddingInner(s).paddingOuter(f).align(l)},rescale()}function pointish(t){var e=t.copy;return t.padding=t.paddingOuter,delete t.paddingInner,delete t.paddingOuter,t.copy=function(){return pointish(e())},t}function point(){return pointish(band().paddingInner(1))}e.a=band,e.b=point;var r=n(5),a=n(81)},function(t,e,n){"use strict";function createObject(){return{}}function setObject(t,e,n){t[e]=n}function createMap(){return Object(r.a)()}function setMap(t,e,n){t.set(e,n)}var r=n(38);e.a=function(){function apply(n,i,o,u){if(i>=a.length)return null!=t&&n.sort(t),null!=e?e(n):n;for(var c,s,f,l=-1,h=n.length,d=a[i++],p=Object(r.a)(),b=o();++l<h;)(f=p.get(c=d(s=n[l])+""))?f.push(s):p.set(c,[s]);return p.each(function(t,e){u(b,e,apply(t,i,o,u))}),b}function entries(t,n){if(++n>a.length)return t;var r,o=i[n-1];return null!=e&&n>=a.length?r=t.entries():(r=[],t.each(function(t,e){r.push({key:e,values:entries(t,n)})})),null!=o?r.sort(function(t,e){return o(t.key,e.key)}):r}var t,e,n,a=[],i=[];return n={object:function(t){return apply(t,0,createObject,setObject)},map:function(t){return apply(t,0,createMap,setMap)},entries:function(t){return entries(apply(t,0,createMap,setMap),0)},key:function(t){return a.push(t),n},sortKeys:function(t){return i[a.length-1]=t,n},sortValues:function(e){return t=e,n},rollup:function(t){return e=t,n}}}},function(t,e,n){"use strict";function Set(){}function set(t,e){var n=new Set;if(t instanceof Set)t.each(function(t){n.add(t)});else if(t){var r=-1,a=t.length;if(null==e)for(;++r<a;)n.add(t[r]);else for(;++r<a;)n.add(e(t[r],r,t))}return n}var r=n(38),a=r.a.prototype;Set.prototype=set.prototype={constructor:Set,has:a.has,add:function(t){return t+="",this[r.b+t]=t,this},remove:a.remove,clear:a.clear,values:a.keys,size:a.size,empty:a.empty,each:a.each},e.a=set},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(n);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(t[n]);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push({key:n,value:t[n]});return e}},function(t,e,n){"use strict";function identity(){function scale(t){return+t}var t=[0,1];return scale.invert=scale,scale.domain=scale.range=function(e){return arguments.length?(t=r.a.call(e,i.a),scale):t.slice()},scale.copy=function(){return identity().domain(t)},Object(a.b)(scale)}e.a=identity;var r=n(9),a=n(14),i=n(82)},function(t,e,n){"use strict";var r=n(5),a=n(21);e.a=function(t,e,n){var i,o=t[0],u=t[t.length-1],c=Object(r.tickStep)(o,u,null==e?10:e);switch(n=Object(a.formatSpecifier)(null==n?",f":n),n.type){case"s":var s=Math.max(Math.abs(o),Math.abs(u));return null!=n.precision||isNaN(i=Object(a.precisionPrefix)(c,s))||(n.precision=i),Object(a.formatPrefix)(n,s);case"":case"e":case"g":case"p":case"r":null!=n.precision||isNaN(i=Object(a.precisionRound)(c,Math.max(Math.abs(o),Math.abs(u))))||(n.precision=i-("e"===n.type));break;case"f":case"%":null!=n.precision||isNaN(i=Object(a.precisionFixed)(c))||(n.precision=i-2*("%"===n.type))}return Object(a.format)(n)}},function(t,e,n){"use strict";function deinterpolate(t,e){return(e=Math.log(e/t))?function(n){return Math.log(n/t)/e}:Object(i.a)(e)}function reinterpolate(t,e){return t<0?function(n){return-Math.pow(-e,n)*Math.pow(-t,1-n)}:function(n){return Math.pow(e,n)*Math.pow(t,1-n)}}function pow10(t){return isFinite(t)?+("1e"+t):t<0?0:t}function powp(t){return 10===t?pow10:t===Math.E?Math.exp:function(e){return Math.pow(t,e)}}function logp(t){return t===Math.E?Math.log:10===t&&Math.log10||2===t&&Math.log2||(t=Math.log(t),function(e){return Math.log(e)/t})}function reflect(t){return function(e){return-t(-e)}}function log(){function rescale(){return i=logp(n),c=powp(n),e()[0]<0&&(i=reflect(i),c=reflect(c)),t}var t=Object(u.b)(deinterpolate,reinterpolate).domain([1,10]),e=t.domain,n=10,i=logp(10),c=powp(10);return t.base=function(t){return arguments.length?(n=+t,rescale()):n},t.domain=function(t){return arguments.length?(e(t),rescale()):e()},t.ticks=function(t){var a,o=e(),u=o[0],s=o[o.length-1];(a=s<u)&&(d=u,u=s,s=d);var f,l,h,d=i(u),p=i(s),b=null==t?10:+t,v=[];if(!(n%1)&&p-d<b){if(d=Math.round(d)-1,p=Math.round(p)+1,u>0){for(;d<p;++d)for(l=1,f=c(d);l<n;++l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else for(;d<p;++d)for(l=n-1,f=c(d);l>=1;--l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else v=Object(r.ticks)(d,p,Math.min(p-d,b)).map(c);return a?v.reverse():v},t.tickFormat=function(e,r){if(null==r&&(r=10===n?".0e":","),"function"!=typeof r&&(r=Object(a.format)(r)),e===1/0)return r;null==e&&(e=10);var o=Math.max(1,n*e/t.ticks().length);return function(t){var e=t/c(Math.round(i(t)));return e*n<n-.5&&(e*=n),e<=o?r(t):""}},t.nice=function(){return e(Object(o.a)(e(),{floor:function(t){return c(Math.floor(i(t)))},ceil:function(t){return c(Math.ceil(i(t)))}}))},t.copy=function(){return Object(u.a)(t,log().base(n))},t}e.a=log;var r=n(5),a=n(21),i=n(39),o=n(83),u=n(18)},function(t,e,n){"use strict";function raise(t,e){return t<0?-Math.pow(-t,e):Math.pow(t,e)}function pow(){function deinterpolate(e,n){return(n=raise(n,t)-(e=raise(e,t)))?function(r){return(raise(r,t)-e)/n}:Object(r.a)(n)}function reinterpolate(e,n){return n=raise(n,t)-(e=raise(e,t)),function(r){return raise(e+n*r,1/t)}}var t=1,e=Object(i.b)(deinterpolate,reinterpolate),n=e.domain;return e.exponent=function(e){return arguments.length?(t=+e,n(n())):t},e.copy=function(){return Object(i.a)(e,pow().exponent(t))},Object(a.b)(e)}function sqrt(){return pow().exponent(.5)}e.a=pow,e.b=sqrt;var r=n(39),a=n(14),i=n(18)},function(t,e,n){"use strict";function quantile(){function rescale(){var a=0,i=Math.max(1,e.length);for(n=new Array(i-1);++a<i;)n[a-1]=Object(r.quantile)(t,a/i);return scale}function scale(t){if(!isNaN(t=+t))return e[Object(r.bisect)(n,t)]}var t=[],e=[],n=[];return scale.invertExtent=function(r){var a=e.indexOf(r);return a<0?[NaN,NaN]:[a>0?n[a-1]:t[0],a<n.length?n[a]:t[t.length-1]]},scale.domain=function(e){if(!arguments.length)return t.slice();t=[];for(var n,a=0,i=e.length;a<i;++a)null==(n=e[a])||isNaN(n=+n)||t.push(n);return t.sort(r.ascending),rescale()},scale.range=function(t){return arguments.length?(e=a.b.call(t),rescale()):e.slice()},scale.quantiles=function(){return n.slice()},scale.copy=function(){return quantile().domain(t).range(e)},scale}e.a=quantile;var r=n(5),a=n(9)},function(t,e,n){"use strict";function quantize(){function scale(t){if(t<=t)return u[Object(r.bisect)(o,t,0,n)]}function rescale(){var r=-1;for(o=new Array(n);++r<n;)o[r]=((r+1)*e-(r-n)*t)/(n+1);return scale}var t=0,e=1,n=1,o=[.5],u=[0,1];return scale.domain=function(n){return arguments.length?(t=+n[0],e=+n[1],rescale()):[t,e]},scale.range=function(t){return arguments.length?(n=(u=a.b.call(t)).length-1,rescale()):u.slice()},scale.invertExtent=function(r){var a=u.indexOf(r);return a<0?[NaN,NaN]:a<1?[t,o[0]]:a>=n?[o[n-1],e]:[o[a-1],o[a]]},scale.copy=function(){return quantize().domain([t,e]).range(u)},Object(i.b)(scale)}e.a=quantize;var r=n(5),a=n(9),i=n(14)},function(t,e,n){"use strict";function threshold(){function scale(a){if(a<=a)return e[Object(r.bisect)(t,a,0,n)]}var t=[.5],e=[0,1],n=1;return scale.domain=function(r){return arguments.length?(t=a.b.call(r),n=Math.min(t.length,e.length-1),scale):t.slice()},scale.range=function(r){return arguments.length?(e=a.b.call(r),n=Math.min(t.length,e.length-1),scale):e.slice()},scale.invertExtent=function(n){var r=e.indexOf(n);return[t[r-1],t[r]]},scale.copy=function(){return threshold().domain(t).range(e)},scale}e.a=threshold;var r=n(5),a=n(9)},function(t,e,n){"use strict";var r=n(84),a=n(40),i=n(35);e.a=function(){return Object(r.a)(i.utcYear,i.utcMonth,i.utcWeek,i.utcDay,i.utcHour,i.utcMinute,i.utcSecond,i.utcMillisecond,a.utcFormat).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)])}},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5")},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(300,.5,0),Object(r.cubehelix)(-240,.5,1))},function(t,e,n){"use strict";n.d(e,"c",function(){return i}),n.d(e,"a",function(){return o});var r=n(4),a=n(8),i=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(-100,.75,.35),Object(r.cubehelix)(80,1.5,.8)),o=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(260,.75,.35),Object(r.cubehelix)(80,1.5,.8)),u=Object(r.cubehelix)();e.b=function(t){(t<0||t>1)&&(t-=Math.floor(t));var e=Math.abs(t-.5);return u.h=360*t-100,u.s=1.5-1.5*e,u.l=.8-.9*e,u+""}},function(t,e,n){"use strict";function ramp(t){var e=t.length;return function(n){return t[Math.max(0,Math.min(e-1,Math.floor(n*e)))]}}n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"d",function(){return o});var r=n(16);e.a=ramp(Object(r.a)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));var a=ramp(Object(r.a)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),i=ramp(Object(r.a)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),o=ramp(Object(r.a)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"))},function(t,e,n){"use strict";function sequential(t){function scale(r){var i=(r-e)/(n-e);return t(a?Math.max(0,Math.min(1,i)):i)}var e=0,n=1,a=!1;return scale.domain=function(t){return arguments.length?(e=+t[0],n=+t[1],scale):[e,n]},scale.clamp=function(t){return arguments.length?(a=!!t,scale):a},scale.interpolator=function(e){return arguments.length?(t=e,scale):t},scale.copy=function(){return sequential(t).domain([e,n]).clamp(a)},Object(r.b)(scale)}e.a=sequential;var r=n(14)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{bar:'\n            <svg class="load-state bar-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 325">\n              \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(0 29)">\n                        <g stroke="#EFF2F5" stroke-dasharray="4 4">\n                            <path d="M.400592911 200.302477L710.674315 200.302477M.400592884 131.172748L710.674315 131.172748M.324410282 64.2071321L710.621499 64.2071321M.291004517.563888874L709.82431.563888889"/>\n                        </g>\n                        <g fill="#D2D6DF" transform="translate(63.08 11)">\n                            <polygon points="-.08 176 23.92 176 23.92 255 -.08 255"/>\n                            <polygon points="50.829 147 74.829 147 74.829 255 50.829 255"/>\n                            <polygon points="254.465 0 278.465 0 278.465 255 254.465 255"/>\n                            <polygon points="458.102 169 482.102 169 482.102 255 458.102 255"/>\n                            <polygon points="152.647 82 176.647 82 176.647 255 152.647 255"/>\n                            <polygon points="356.283 66 380.283 66 380.283 255 356.283 255"/>\n                            <polygon points="559.92 229 583.92 229 583.92 255 559.92 255"/>\n                            <polygon points="101.738 115 125.738 115 125.738 255 101.738 255"/>\n                            <polygon points="305.374 42 329.374 42 329.374 255 305.374 255"/>\n                            <polygon points="509.011 201 533.011 201 533.011 255 509.011 255"/>\n                            <polygon points="203.556 19 227.556 19 227.556 255 203.556 255"/>\n                            <polygon points="407.192 115 431.192 115 431.192 255 407.192 255"/>\n                        </g>\n                    </g>\n                    <polygon fill="#D2D6DF" fill-rule="nonzero" points="0 295 711 295 711 294 0 294"/>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',donut:'\n            <svg class="load-state donut-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 376 331">\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(116 107)">\n                        <circle cx="72" cy="72" r="72" stroke="#EFF2F5" stroke-linecap="round" stroke-width="9.6"/>\n                        <path stroke="#D2D6DF" stroke-width="19.2" d="M126.153559,119.524055 C137.264629,106.845712 144,90.2321371 144,72.0444604 C144,32.2554036 111.764502,0 72,0"/>\n                        <circle cx="72" cy="72" r="67.2" fill="#FFF"/>\n                    </g>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',line:'\n            <svg \n                class="load-state line-load-state" \n                xmlns="http://www.w3.org/2000/svg" \n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path \n                    id="chart-bg" \n                    class="chart-bg" \n                    style="stroke:#C3C6CF;" \n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n               <polyline \n                    id="chart-line" \n                    class="chart-line" \n                    style="stroke:#C3C6CF;stroke-width:4;fill:none;" \n                    points="8.8,175.8 62.4,237.7 116.1,184.7 169.7,175.8 223.3,57 277,176.8 330.6,176.8 384.3,122.5 437.9,176.8 491.6,176.8 545.2,218.4 598.8,122.5 652.5,184.7 706.1,135.1 "\n                />\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        '}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r=n(61),a=n(34),i=n(85),o=n(180),u=n(181);e.a=function(){function area(a){var i,o,u,d,p,b=a.length,v=!1,m=new Array(b),y=new Array(b);for(null==f&&(h=l(p=Object(r.a)())),i=0;i<=b;++i){if(!(i<b&&s(d=a[i],i,a))===v)if(v=!v)o=i,h.areaStart(),h.lineStart();else{for(h.lineEnd(),h.lineStart(),u=i-1;u>=o;--u)h.point(m[u],y[u]);h.lineEnd(),h.areaEnd()}v&&(m[i]=+t(d,i,a),y[i]=+n(d,i,a),h.point(e?+e(d,i,a):m[i],c?+c(d,i,a):y[i]))}if(p)return h=null,p+""||null}function arealine(){return Object(o.a)().defined(s).curve(l).context(f)}var t=u.a,e=null,n=Object(a.a)(0),c=u.b,s=Object(a.a)(!0),f=null,l=i.a,h=null;return area.x=function(n){return arguments.length?(t="function"==typeof n?n:Object(a.a)(+n),e=null,area):t},area.x0=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(+e),area):t},area.x1=function(t){return arguments.length?(e=null==t?null:"function"==typeof t?t:Object(a.a)(+t),area):e},area.y=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(+t),c=null,area):n},area.y0=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(+t),area):n},area.y1=function(t){return arguments.length?(c=null==t?null:"function"==typeof t?t:Object(a.a)(+t),area):c},area.lineX0=area.lineY0=function(){return arealine().x(t).y(n)},area.lineY1=function(){return arealine().x(t).y(c)},area.lineX1=function(){return arealine().x(e).y(n)},area.defined=function(t){return arguments.length?(s="function"==typeof t?t:Object(a.a)(!!t),area):s},area.curve=function(t){return arguments.length?(l=t,null!=f&&(h=l(f)),area):l},area.context=function(t){return arguments.length?(null==t?f=h=null:h=l(f=t),area):f},area}},function(t,e,n){"use strict";function Radial(t){this._curve=t}function curveRadial(t){function radial(e){return new Radial(t(e))}return radial._curve=t,radial}n.d(e,"a",function(){return a}),e.b=curveRadial;var r=n(85),a=curveRadial(r.a);Radial.prototype={areaStart:function(){this._curve.areaStart()},areaEnd:function(){this._curve.areaEnd()},lineStart:function(){this._curve.lineStart()},lineEnd:function(){this._curve.lineEnd()},point:function(t,e){this._curve.point(e*Math.sin(t),e*-Math.cos(t))}}},function(t,e,n){"use strict";function lineRadial(t){var e=t.curve;return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t.curve=function(t){return arguments.length?e(Object(r.b)(t)):e()._curve},t}e.b=lineRadial;var r=n(240),a=n(180);e.a=function(){return lineRadial(Object(a.a)().curve(r.a))}},function(t,e,n){"use strict";e.a=function(t,e){return[(e=+e)*Math.cos(t-=Math.PI/2),e*Math.sin(t)]}},function(t,e,n){"use strict";n.d(e,"a",function(){return r});var r=Array.prototype.slice},function(t,e,n){"use strict";var r=n(62);e.a={draw:function(t,e){var n=Math.sqrt(e/r.j);t.moveTo(n,0),t.arc(0,0,n,0,r.m)}}},function(t,e,n){"use strict";e.a={draw:function(t,e){var n=Math.sqrt(e/5)/2;t.moveTo(-3*n,-n),t.lineTo(-n,-n),t.lineTo(-n,-3*n),t.lineTo(n,-3*n),t.lineTo(n,-n),t.lineTo(3*n,-n),t.lineTo(3*n,n),t.lineTo(n,n),t.lineTo(n,3*n),t.lineTo(-n,3*n),t.lineTo(-n,n),t.lineTo(-3*n,n),t.closePath()}}},function(t,e,n){"use strict";var r=Math.sqrt(1/3),a=2*r;e.a={draw:function(t,e){var n=Math.sqrt(e/a),i=n*r;t.moveTo(0,-n),t.lineTo(i,0),t.lineTo(0,n),t.lineTo(-i,0),t.closePath()}}},function(t,e,n){"use strict";var r=n(62),a=Math.sin(r.j/10)/Math.sin(7*r.j/10),i=Math.sin(r.m/10)*a,o=-Math.cos(r.m/10)*a;e.a={draw:function(t,e){var n=Math.sqrt(.8908130915292852*e),a=i*n,u=o*n;t.moveTo(0,-n),t.lineTo(a,u);for(var c=1;c<5;++c){var s=r.m*c/5,f=Math.cos(s),l=Math.sin(s);t.lineTo(l*n,-f*n),t.lineTo(f*a-l*u,l*a+f*u)}t.closePath()}}},function(t,e,n){"use strict";e.a={draw:function(t,e){var n=Math.sqrt(e),r=-n/2;t.rect(r,r,n,n)}}},function(t,e,n){"use strict";var r=Math.sqrt(3);e.a={draw:function(t,e){var n=-Math.sqrt(e/(3*r));t.moveTo(0,2*n),t.lineTo(-r*n,-n),t.lineTo(r*n,-n),t.closePath()}}},function(t,e,n){"use strict";var r=-.5,a=Math.sqrt(3)/2,i=1/Math.sqrt(12),o=3*(i/2+1);e.a={draw:function(t,e){var n=Math.sqrt(e/o),u=n/2,c=n*i,s=u,f=n*i+n,l=-s,h=f;t.moveTo(u,c),t.lineTo(s,f),t.lineTo(l,h),t.lineTo(r*u-a*c,a*u+r*c),t.lineTo(r*s-a*f,a*s+r*f),t.lineTo(r*l-a*h,a*l+r*h),t.lineTo(r*u+a*c,r*c-a*u),t.lineTo(r*s+a*f,r*f-a*s),t.lineTo(r*l+a*h,r*h-a*l),t.closePath()}}},function(t,e,n){"use strict";function CardinalClosed(t,e){this._context=t,this._k=(1-e)/6}e.a=CardinalClosed;var r=n(86),a=n(88);CardinalClosed.prototype={areaStart:r.a,areaEnd:r.a,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._x3=t,this._y3=e;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=e);break;case 2:this._point=3,this._x5=t,this._y5=e;break;default:Object(a.c)(this,t,e)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.b=function custom(t){function cardinal(e){return new CardinalClosed(e,t)}return cardinal.tension=function(t){return custom(+t)},cardinal}(0)},function(t,e,n){"use strict";function CardinalOpen(t,e){this._context=t,this._k=(1-e)/6}e.a=CardinalOpen;var r=n(88);CardinalOpen.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Object(r.c)(this,t,e)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.b=function custom(t){function cardinal(e){return new CardinalOpen(e,t)}return cardinal.tension=function(t){return custom(+t)},cardinal}(0)},function(t,e,n){"use strict";var r;void 0!==(r=function(t){function exportChart(t,e,n){var r=createImage(convertSvgToHtml.call(this,t,n));r.onload=handleImageLoad.bind(r,createCanvas(this.width(),this.height()),e)}function addBackground(t){return t.replace(">",">"+c.styleBackgroundString)}function convertSvgToHtml(t,e){if(t){t.attr("version",1.1).attr("xmlns","http://www.w3.org/2000/svg");var n=a.initializeSerializer(),r=n(t.node());return r=formatHtmlByBrowser(r),r=prependTitle.call(this,r,e,parseInt(t.attr("width"),10)),r=addBackground(r)}}function createCanvas(t,e){var n=document.createElement("canvas");return n.height=e,n.width=t,n}function createImage(t){var e=new Image;return e.src=""+c.imageSourceBase+u(t),e}function drawImageOnCanvas(t,e){return e.getContext("2d").drawImage(t,0,0),e}function downloadCanvas(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:c.defaultFilename,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"image/png",r=t.toDataURL(n),a=document.createElement("a");a.href=r,a.download=e,document.body.appendChild(a),a.click(),document.body.removeChild(a)}function formatHtmlByBrowser(t){return navigator.userAgent.search("FireFox")>-1?t.replace(/url.*&quot;\)/,'url(&quot;linearGradient[id*="-gradient-"]&quot;);'):t}function handleImageLoad(t,e,n){n.preventDefault(),downloadCanvas(drawImageOnCanvas(this,t),e)}function prependTitle(t,e,n){if(!e||!n)return t;var a=r.grey;return t=t.replace(/<g/,'<text x="'+this.margin().left+'" y="'+c.titleTopOffset+'" font-family="'+c.titleFontFamily+'" font-size="'+c.titleFontSize+'" fill="'+a[6]+'"> '+e+" </text><g ")}var e=n(89),r=e.colorSchemas,a=(n(90),n(254)),i="undefined"!=typeof window,o=i&&window.btoa;o||(o=n(255).encode);var u=function(t){return o(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g,function(t,e){return String.fromCharCode("0x"+e)}))},c={styleClass:"britechartStyle",defaultFilename:"britechart.png",chartBackground:"white",imageSourceBase:"data:image/svg+xml;base64,",titleFontSize:"15px",titleFontFamily:"'Benton Sans', sans-serif",titleTopOffset:30,get styleBackgroundString(){return"<style>svg{background:"+this.chartBackground+";}</style>"}};return{exportChart:exportChart,convertSvgToHtml:convertSvgToHtml,createImage:createImage,drawImageOnCanvas:drawImageOnCanvas}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";t.exports=function(){return{initializeSerializer:function(){function computeDefaultStyleByTagName(t){var e={},n=document.body.appendChild(document.createElement(t)),r=window.getComputedStyle(n);return[].forEach.call(r,function(t){e[t]=r[t]}),document.body.removeChild(n),e}function getDefaultStyleByTagName(e){return e=e.toUpperCase(),t[e]||(t[e]=computeDefaultStyleByTagName(e)),t[e]}function serializeWithStyles(t){var n=[],r=void 0,a=void 0,i=void 0,o=void 0;if(t&&t.nodeType===Node.ELEMENT_NODE)return n=[],r=t.querySelectorAll("*"),[].forEach.call(r,function(t,r){e[t.tagName]||(a=window.getComputedStyle(t),i=getDefaultStyleByTagName(t.tagName),n[r]=t.style.cssText,[].forEach.call(a,function(e){a[e]!==i[e]&&(t.style[e]=a[e])}))}),o=t.outerHTML,r=[].map.call(r,function(t,e){return t.style.cssText=n[e],t}),o}var t={},e={BASE:!0,HEAD:!0,HTML:!0,META:!0,NOFRAME:!0,NOSCRIPT:!0,PARAM:!0,SCRIPT:!0,STYLE:!0,TITLE:!0},n=["A","ABBR","ADDRESS","AREA","ARTICLE","ASIDE","AUDIO","B","BASE","BDI","BDO","BLOCKQUOTE","BODY","BR","BUTTON","CANVAS","CAPTION","CENTER","CITE","CODE","COL","COLGROUP","COMMAND","DATALIST","DD","DEL","DETAILS","DFN","DIV","DL","DT","EM","EMBED","FIELDSET","FIGCAPTION","FIGURE","FONT","FOOTER","FORM","H1","H2","H3","H4","H5","H6","HEAD","HEADER","HGROUP","HR","HTML","I","IFRAME","IMG","INPUT","INS","KBD","LABEL","LEGEND","LI","LINK","MAP","MARK","MATH","MENU","META","METER","NAV","NOBR","NOSCRIPT","OBJECT","OL","OPTION","OPTGROUP","OUTPUT","P","PARAM","PRE","PROGRESS","Q","RP","RT","RUBY","S","SAMP","SCRIPT","SECTION","SELECT","SMALL","SOURCE","SPAN","STRONG","STYLE","SUB","SUMMARY","SUP","SVG","TABLE","TBODY","TD","TEXTAREA","TFOOT","TH","THEAD","TIME","TITLE","TR","TRACK","U","UL","VAR","VIDEO","WBR"];return[].forEach.call(n,function(n){e[n]||(t[n]=computeDefaultStyleByTagName(n))}),serializeWithStyles}}}()},function(t,e,n){(function(t,r){var a;!function(i){var o="object"==typeof e&&e,u=("object"==typeof t&&t&&t.exports,"object"==typeof r&&r);var c=function(t){this.message=t};c.prototype=new Error,c.prototype.name="InvalidCharacterError";var s=function(t){throw new c(t)},f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=/[\t\n\f\r ]/g,h=function(t){t=String(t).replace(l,"");var e=t.length;e%4==0&&(t=t.replace(/==?$/,""),e=t.length),(e%4==1||/[^+a-zA-Z0-9\/]/.test(t))&&s("Invalid character: the string to be decoded is not correctly encoded.");for(var n,r,a=0,i="",o=-1;++o<e;)r=f.indexOf(t.charAt(o)),n=a%4?64*n+r:r,a++%4&&(i+=String.fromCharCode(255&n>>(-2*a&6)));return i},d=function(t){t=String(t),/[^\0-\xFF]/.test(t)&&s("The string to be encoded contains characters outside of the Latin1 range.");for(var e,n,r,a,i=t.length%3,o="",u=-1,c=t.length-i;++u<c;)e=t.charCodeAt(u)<<16,n=t.charCodeAt(++u)<<8,r=t.charCodeAt(++u),a=e+n+r,o+=f.charAt(a>>18&63)+f.charAt(a>>12&63)+f.charAt(a>>6&63)+f.charAt(63&a);return 2==i?(e=t.charCodeAt(u)<<8,n=t.charCodeAt(++u),a=e+n,o+=f.charAt(a>>10)+f.charAt(a>>4&63)+f.charAt(a<<2&63)+"="):1==i&&(a=t.charCodeAt(u),o+=f.charAt(a>>2)+f.charAt(a<<4&63)+"=="),o},p={encode:d,decode:h,version:"0.1.0"};void 0!==(a=function(){return p}.call(e,n,e,t))&&(t.exports=a)}()}).call(e,n(256)(t),n(257))},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},,,,,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(263);n.d(e,"arc",function(){return r.a});var a=n(239);n.d(e,"area",function(){return a.a});var i=n(180);n.d(e,"line",function(){return i.a});var o=n(265);n.d(e,"pie",function(){return o.a});var u=n(268);n.d(e,"areaRadial",function(){return u.a}),n.d(e,"radialArea",function(){return u.a});var c=n(241);n.d(e,"lineRadial",function(){return c.a}),n.d(e,"radialLine",function(){return c.a});var s=n(242);n.d(e,"pointRadial",function(){return s.a});var f=n(269);n.d(e,"linkHorizontal",function(){return f.a}),n.d(e,"linkVertical",function(){return f.c}),n.d(e,"linkRadial",function(){return f.b});var l=n(270);n.d(e,"symbol",function(){return l.a}),n.d(e,"symbols",function(){return l.b});var h=n(244);n.d(e,"symbolCircle",function(){return h.a});var d=n(245);n.d(e,"symbolCross",function(){return d.a});var p=n(246);n.d(e,"symbolDiamond",function(){return p.a});var b=n(248);n.d(e,"symbolSquare",function(){return b.a});var v=n(247);n.d(e,"symbolStar",function(){return v.a});var m=n(249);n.d(e,"symbolTriangle",function(){return m.a});var y=n(250);n.d(e,"symbolWye",function(){return y.a});var g=n(271);n.d(e,"curveBasisClosed",function(){return g.a});var _=n(272);n.d(e,"curveBasisOpen",function(){return _.a});var x=n(87);n.d(e,"curveBasis",function(){return x.b});var w=n(273);n.d(e,"curveBundle",function(){return w.a});var O=n(251);n.d(e,"curveCardinalClosed",function(){return O.b});var M=n(252);n.d(e,"curveCardinalOpen",function(){return M.b});var C=n(88);n.d(e,"curveCardinal",function(){return C.b});var j=n(274);n.d(e,"curveCatmullRomClosed",function(){return j.a});var T=n(275);n.d(e,"curveCatmullRomOpen",function(){return T.a});var k=n(182);n.d(e,"curveCatmullRom",function(){return k.a});var S=n(276);n.d(e,"curveLinearClosed",function(){return S.a});var N=n(85);n.d(e,"curveLinear",function(){return N.a});var A=n(277);n.d(e,"curveMonotoneX",function(){return A.a}),n.d(e,"curveMonotoneY",function(){return A.b});var E=n(278);n.d(e,"curveNatural",function(){return E.a});var D=n(279);n.d(e,"curveStep",function(){return D.a}),n.d(e,"curveStepAfter",function(){return D.b}),n.d(e,"curveStepBefore",function(){return D.c});var F=n(280);n.d(e,"stack",function(){return F.a});var I=n(281);n.d(e,"stackOffsetExpand",function(){return I.a});var P=n(282);n.d(e,"stackOffsetDiverging",function(){return P.a});var R=n(63);n.d(e,"stackOffsetNone",function(){return R.a});var L=n(283);n.d(e,"stackOffsetSilhouette",function(){return L.a});var U=n(284);n.d(e,"stackOffsetWiggle",function(){return U.a});var H=n(183);n.d(e,"stackOrderAscending",function(){return H.a});var Y=n(285);n.d(e,"stackOrderDescending",function(){return Y.a});var q=n(286);n.d(e,"stackOrderInsideOut",function(){return q.a});var B=n(64);n.d(e,"stackOrderNone",function(){return B.a});var z=n(287);n.d(e,"stackOrderReverse",function(){return z.a})},function(t,e,n){"use strict";function arcInnerRadius(t){return t.innerRadius}function arcOuterRadius(t){return t.outerRadius}function arcStartAngle(t){return t.startAngle}function arcEndAngle(t){return t.endAngle}function arcPadAngle(t){return t&&t.padAngle}function intersect(t,e,n,r,a,i,o,u){var c=n-t,s=r-e,f=o-a,l=u-i,h=(f*(e-i)-l*(t-a))/(l*c-f*s);return[t+h*c,e+h*s]}function cornerTangents(t,e,n,r,a,o,u){var c=t-n,s=e-r,f=(u?o:-o)/Object(i.l)(c*c+s*s),l=f*s,h=-f*c,d=t+l,p=e+h,b=n+l,v=r+h,m=(d+b)/2,y=(p+v)/2,g=b-d,_=v-p,x=g*g+_*_,w=a-o,O=d*v-b*p,M=(_<0?-1:1)*Object(i.l)(Object(i.h)(0,w*w*x-O*O)),C=(O*_-g*M)/x,j=(-O*g-_*M)/x,T=(O*_+g*M)/x,k=(-O*g+_*M)/x,S=C-m,N=j-y,A=T-m,E=k-y;return S*S+N*N>A*A+E*E&&(C=T,j=k),{cx:C,cy:j,x01:-l,y01:-h,x11:C*(a/w-1),y11:j*(a/w-1)}}var r=n(61),a=n(34),i=n(62);e.a=function(){function arc(){var a,l,h=+t.apply(this,arguments),d=+e.apply(this,arguments),p=u.apply(this,arguments)-i.g,b=c.apply(this,arguments)-i.g,v=Object(i.a)(b-p),m=b>p;if(f||(f=a=Object(r.a)()),d<h&&(l=d,d=h,h=l),d>i.f)if(v>i.m-i.f)f.moveTo(d*Object(i.e)(p),d*Object(i.k)(p)),f.arc(0,0,d,p,b,!m),h>i.f&&(f.moveTo(h*Object(i.e)(b),h*Object(i.k)(b)),f.arc(0,0,h,b,p,m));else{var y,g,_=p,x=b,w=p,O=b,M=v,C=v,j=s.apply(this,arguments)/2,T=j>i.f&&(o?+o.apply(this,arguments):Object(i.l)(h*h+d*d)),k=Object(i.i)(Object(i.a)(d-h)/2,+n.apply(this,arguments)),S=k,N=k;if(T>i.f){var A=Object(i.c)(T/h*Object(i.k)(j)),E=Object(i.c)(T/d*Object(i.k)(j));(M-=2*A)>i.f?(A*=m?1:-1,w+=A,O-=A):(M=0,w=O=(p+b)/2),(C-=2*E)>i.f?(E*=m?1:-1,_+=E,x-=E):(C=0,_=x=(p+b)/2)}var D=d*Object(i.e)(_),F=d*Object(i.k)(_),I=h*Object(i.e)(O),P=h*Object(i.k)(O);if(k>i.f){var R=d*Object(i.e)(x),L=d*Object(i.k)(x),U=h*Object(i.e)(w),H=h*Object(i.k)(w);if(v<i.j){var Y=M>i.f?intersect(D,F,U,H,R,L,I,P):[I,P],q=D-Y[0],B=F-Y[1],z=R-Y[0],W=L-Y[1],V=1/Object(i.k)(Object(i.b)((q*z+B*W)/(Object(i.l)(q*q+B*B)*Object(i.l)(z*z+W*W)))/2),G=Object(i.l)(Y[0]*Y[0]+Y[1]*Y[1]);S=Object(i.i)(k,(h-G)/(V-1)),N=Object(i.i)(k,(d-G)/(V+1))}}C>i.f?N>i.f?(y=cornerTangents(U,H,D,F,d,N,m),g=cornerTangents(R,L,I,P,d,N,m),f.moveTo(y.cx+y.x01,y.cy+y.y01),N<k?f.arc(y.cx,y.cy,N,Object(i.d)(y.y01,y.x01),Object(i.d)(g.y01,g.x01),!m):(f.arc(y.cx,y.cy,N,Object(i.d)(y.y01,y.x01),Object(i.d)(y.y11,y.x11),!m),f.arc(0,0,d,Object(i.d)(y.cy+y.y11,y.cx+y.x11),Object(i.d)(g.cy+g.y11,g.cx+g.x11),!m),f.arc(g.cx,g.cy,N,Object(i.d)(g.y11,g.x11),Object(i.d)(g.y01,g.x01),!m))):(f.moveTo(D,F),f.arc(0,0,d,_,x,!m)):f.moveTo(D,F),h>i.f&&M>i.f?S>i.f?(y=cornerTangents(I,P,R,L,h,-S,m),g=cornerTangents(D,F,U,H,h,-S,m),f.lineTo(y.cx+y.x01,y.cy+y.y01),S<k?f.arc(y.cx,y.cy,S,Object(i.d)(y.y01,y.x01),Object(i.d)(g.y01,g.x01),!m):(f.arc(y.cx,y.cy,S,Object(i.d)(y.y01,y.x01),Object(i.d)(y.y11,y.x11),!m),f.arc(0,0,h,Object(i.d)(y.cy+y.y11,y.cx+y.x11),Object(i.d)(g.cy+g.y11,g.cx+g.x11),m),f.arc(g.cx,g.cy,S,Object(i.d)(g.y11,g.x11),Object(i.d)(g.y01,g.x01),!m))):f.arc(0,0,h,O,w,m):f.lineTo(I,P)}else f.moveTo(0,0);if(f.closePath(),a)return f=null,a+""||null}var t=arcInnerRadius,e=arcOuterRadius,n=Object(a.a)(0),o=null,u=arcStartAngle,c=arcEndAngle,s=arcPadAngle,f=null;return arc.centroid=function(){var n=(+t.apply(this,arguments)+ +e.apply(this,arguments))/2,r=(+u.apply(this,arguments)+ +c.apply(this,arguments))/2-i.j/2;return[Object(i.e)(r)*n,Object(i.k)(r)*n]},arc.innerRadius=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(+e),arc):t},arc.outerRadius=function(t){return arguments.length?(e="function"==typeof t?t:Object(a.a)(+t),arc):e},arc.cornerRadius=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(+t),arc):n},arc.padRadius=function(t){return arguments.length?(o=null==t?null:"function"==typeof t?t:Object(a.a)(+t),arc):o},arc.startAngle=function(t){return arguments.length?(u="function"==typeof t?t:Object(a.a)(+t),arc):u},arc.endAngle=function(t){return arguments.length?(c="function"==typeof t?t:Object(a.a)(+t),arc):c},arc.padAngle=function(t){return arguments.length?(s="function"==typeof t?t:Object(a.a)(+t),arc):s},arc.context=function(t){return arguments.length?(f=null==t?null:t,arc):f},arc}},function(t,e,n){"use strict";function Path(){this._x0=this._y0=this._x1=this._y1=null,this._=""}function path(){return new Path}var r=Math.PI,a=2*r,i=a-1e-6;Path.prototype=path.prototype={constructor:Path,moveTo:function(t,e){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+e)},closePath:function(){null!==this._x1&&(this._x1=this._x0,this._y1=this._y0,this._+="Z")},lineTo:function(t,e){this._+="L"+(this._x1=+t)+","+(this._y1=+e)},quadraticCurveTo:function(t,e,n,r){this._+="Q"+ +t+","+ +e+","+(this._x1=+n)+","+(this._y1=+r)},bezierCurveTo:function(t,e,n,r,a,i){this._+="C"+ +t+","+ +e+","+ +n+","+ +r+","+(this._x1=+a)+","+(this._y1=+i)},arcTo:function(t,e,n,a,i){t=+t,e=+e,n=+n,a=+a,i=+i;var o=this._x1,u=this._y1,c=n-t,s=a-e,f=o-t,l=u-e,h=f*f+l*l;if(i<0)throw new Error("negative radius: "+i);if(null===this._x1)this._+="M"+(this._x1=t)+","+(this._y1=e);else if(h>1e-6)if(Math.abs(l*c-s*f)>1e-6&&i){var d=n-o,p=a-u,b=c*c+s*s,v=d*d+p*p,m=Math.sqrt(b),y=Math.sqrt(h),g=i*Math.tan((r-Math.acos((b+h-v)/(2*m*y)))/2),_=g/y,x=g/m;Math.abs(_-1)>1e-6&&(this._+="L"+(t+_*f)+","+(e+_*l)),this._+="A"+i+","+i+",0,0,"+ +(l*d>f*p)+","+(this._x1=t+x*c)+","+(this._y1=e+x*s)}else this._+="L"+(this._x1=t)+","+(this._y1=e);else;},arc:function(t,e,n,o,u,c){t=+t,e=+e,n=+n;var s=n*Math.cos(o),f=n*Math.sin(o),l=t+s,h=e+f,d=1^c,p=c?o-u:u-o;if(n<0)throw new Error("negative radius: "+n);null===this._x1?this._+="M"+l+","+h:(Math.abs(this._x1-l)>1e-6||Math.abs(this._y1-h)>1e-6)&&(this._+="L"+l+","+h),n&&(p<0&&(p=p%a+a),p>i?this._+="A"+n+","+n+",0,1,"+d+","+(t-s)+","+(e-f)+"A"+n+","+n+",0,1,"+d+","+(this._x1=l)+","+(this._y1=h):p>1e-6&&(this._+="A"+n+","+n+",0,"+ +(p>=r)+","+d+","+(this._x1=t+n*Math.cos(u))+","+(this._y1=e+n*Math.sin(u))))},rect:function(t,e,n,r){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+e)+"h"+ +n+"v"+ +r+"h"+-n+"Z"},toString:function(){return this._}},e.a=path},function(t,e,n){"use strict";var r=n(34),a=n(266),i=n(267),o=n(62);e.a=function(){function pie(r){var a,i,f,l,h,d=r.length,p=0,b=new Array(d),v=new Array(d),m=+u.apply(this,arguments),y=Math.min(o.m,Math.max(-o.m,c.apply(this,arguments)-m)),g=Math.min(Math.abs(y)/d,s.apply(this,arguments)),_=g*(y<0?-1:1);for(a=0;a<d;++a)(h=v[b[a]=a]=+t(r[a],a,r))>0&&(p+=h);for(null!=e?b.sort(function(t,n){return e(v[t],v[n])}):null!=n&&b.sort(function(t,e){return n(r[t],r[e])}),a=0,f=p?(y-d*_)/p:0;a<d;++a,m=l)i=b[a],h=v[i],l=m+(h>0?h*f:0)+_,v[i]={data:r[i],index:a,value:h,startAngle:m,endAngle:l,padAngle:g};return v}var t=i.a,e=a.a,n=null,u=Object(r.a)(0),c=Object(r.a)(o.m),s=Object(r.a)(0);return pie.value=function(e){return arguments.length?(t="function"==typeof e?e:Object(r.a)(+e),pie):t},pie.sortValues=function(t){return arguments.length?(e=t,n=null,pie):e},pie.sort=function(t){return arguments.length?(n=t,e=null,pie):n},pie.startAngle=function(t){return arguments.length?(u="function"==typeof t?t:Object(r.a)(+t),pie):u},pie.endAngle=function(t){return arguments.length?(c="function"==typeof t?t:Object(r.a)(+t),pie):c},pie.padAngle=function(t){return arguments.length?(s="function"==typeof t?t:Object(r.a)(+t),pie):s},pie}},function(t,e,n){"use strict";e.a=function(t,e){return e<t?-1:e>t?1:e>=t?0:NaN}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(240),a=n(239),i=n(241);e.a=function(){var t=Object(a.a)().curve(r.a),e=t.curve,n=t.lineX0,o=t.lineX1,u=t.lineY0,c=t.lineY1;return t.angle=t.x,delete t.x,t.startAngle=t.x0,delete t.x0,t.endAngle=t.x1,delete t.x1,t.radius=t.y,delete t.y,t.innerRadius=t.y0,delete t.y0,t.outerRadius=t.y1,delete t.y1,t.lineStartAngle=function(){return Object(i.b)(n())},delete t.lineX0,t.lineEndAngle=function(){return Object(i.b)(o())},delete t.lineX1,t.lineInnerRadius=function(){return Object(i.b)(u())},delete t.lineY0,t.lineOuterRadius=function(){return Object(i.b)(c())},delete t.lineY1,t.curve=function(t){return arguments.length?e(Object(r.b)(t)):e()._curve},t}},function(t,e,n){"use strict";function linkSource(t){return t.source}function linkTarget(t){return t.target}function link(t){function link(){var i,o=a.a.call(arguments),f=e.apply(this,o),l=n.apply(this,o);if(s||(s=i=Object(r.a)()),t(s,+u.apply(this,(o[0]=f,o)),+c.apply(this,o),+u.apply(this,(o[0]=l,o)),+c.apply(this,o)),i)return s=null,i+""||null}var e=linkSource,n=linkTarget,u=o.a,c=o.b,s=null;return link.source=function(t){return arguments.length?(e=t,link):e},link.target=function(t){return arguments.length?(n=t,link):n},link.x=function(t){return arguments.length?(u="function"==typeof t?t:Object(i.a)(+t),link):u},link.y=function(t){return arguments.length?(c="function"==typeof t?t:Object(i.a)(+t),link):c},link.context=function(t){return arguments.length?(s=null==t?null:t,link):s},link}function curveHorizontal(t,e,n,r,a){t.moveTo(e,n),t.bezierCurveTo(e=(e+r)/2,n,e,a,r,a)}function curveVertical(t,e,n,r,a){t.moveTo(e,n),t.bezierCurveTo(e,n=(n+a)/2,r,n,r,a)}function curveRadial(t,e,n,r,a){var i=Object(u.a)(e,n),o=Object(u.a)(e,n=(n+a)/2),c=Object(u.a)(r,n),s=Object(u.a)(r,a);t.moveTo(i[0],i[1]),t.bezierCurveTo(o[0],o[1],c[0],c[1],s[0],s[1])}function linkHorizontal(){return link(curveHorizontal)}function linkVertical(){return link(curveVertical)}function linkRadial(){var t=link(curveRadial);return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t}e.a=linkHorizontal,e.c=linkVertical,e.b=linkRadial;var r=n(61),a=n(243),i=n(34),o=n(181),u=n(242)},function(t,e,n){"use strict";n.d(e,"b",function(){return h});var r=n(61),a=n(244),i=n(245),o=n(246),u=n(247),c=n(248),s=n(249),f=n(250),l=n(34),h=[a.a,i.a,o.a,c.a,u.a,s.a,f.a];e.a=function(){function symbol(){var a;if(n||(n=a=Object(r.a)()),t.apply(this,arguments).draw(n,+e.apply(this,arguments)),a)return n=null,a+""||null}var t=Object(l.a)(a.a),e=Object(l.a)(64),n=null;return symbol.type=function(e){return arguments.length?(t="function"==typeof e?e:Object(l.a)(e),symbol):t},symbol.size=function(t){return arguments.length?(e="function"==typeof t?t:Object(l.a)(+t),symbol):e},symbol.context=function(t){return arguments.length?(n=null==t?null:t,symbol):n},symbol}},function(t,e,n){"use strict";function BasisClosed(t){this._context=t}var r=n(86),a=n(87);BasisClosed.prototype={areaStart:r.a,areaEnd:r.a,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._y0=this._y1=this._y2=this._y3=this._y4=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x2,this._y2),this._context.closePath();break;case 2:this._context.moveTo((this._x2+2*this._x3)/3,(this._y2+2*this._y3)/3),this._context.lineTo((this._x3+2*this._x2)/3,(this._y3+2*this._y2)/3),this._context.closePath();break;case 3:this.point(this._x2,this._y2),this.point(this._x3,this._y3),this.point(this._x4,this._y4)}},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._x2=t,this._y2=e;break;case 1:this._point=2,this._x3=t,this._y3=e;break;case 2:this._point=3,this._x4=t,this._y4=e,this._context.moveTo((this._x0+4*this._x1+t)/6,(this._y0+4*this._y1+e)/6);break;default:Object(a.c)(this,t,e)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e}},e.a=function(t){return new BasisClosed(t)}},function(t,e,n){"use strict";function BasisOpen(t){this._context=t}var r=n(87);BasisOpen.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3;var n=(this._x0+4*this._x1+t)/6,a=(this._y0+4*this._y1+e)/6;this._line?this._context.lineTo(n,a):this._context.moveTo(n,a);break;case 3:this._point=4;default:Object(r.c)(this,t,e)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e}},e.a=function(t){return new BasisOpen(t)}},function(t,e,n){"use strict";function Bundle(t,e){this._basis=new r.a(t),this._beta=e}var r=n(87);Bundle.prototype={lineStart:function(){this._x=[],this._y=[],this._basis.lineStart()},lineEnd:function(){var t=this._x,e=this._y,n=t.length-1;if(n>0)for(var r,a=t[0],i=e[0],o=t[n]-a,u=e[n]-i,c=-1;++c<=n;)r=c/n,this._basis.point(this._beta*t[c]+(1-this._beta)*(a+r*o),this._beta*e[c]+(1-this._beta)*(i+r*u));this._x=this._y=null,this._basis.lineEnd()},point:function(t,e){this._x.push(+t),this._y.push(+e)}},e.a=function custom(t){function bundle(e){return 1===t?new r.a(e):new Bundle(e,t)}return bundle.beta=function(t){return custom(+t)},bundle}(.85)},function(t,e,n){"use strict";function CatmullRomClosed(t,e){this._context=t,this._alpha=e}var r=n(251),a=n(86),i=n(182);CatmullRomClosed.prototype={areaStart:a.a,areaEnd:a.a,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,e){if(t=+t,e=+e,this._point){var n=this._x2-t,r=this._y2-e;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(n*n+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._x3=t,this._y3=e;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=e);break;case 2:this._point=3,this._x5=t,this._y5=e;break;default:Object(i.b)(this,t,e)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.a=function custom(t){function catmullRom(e){return t?new CatmullRomClosed(e,t):new r.a(e,0)}return catmullRom.alpha=function(t){return custom(+t)},catmullRom}(.5)},function(t,e,n){"use strict";function CatmullRomOpen(t,e){this._context=t,this._alpha=e}var r=n(252),a=n(182);CatmullRomOpen.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){if(t=+t,e=+e,this._point){var n=this._x2-t,r=this._y2-e;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(n*n+r*r,this._alpha))}switch(this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Object(a.b)(this,t,e)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.a=function custom(t){function catmullRom(e){return t?new CatmullRomOpen(e,t):new r.a(e,0)}return catmullRom.alpha=function(t){return custom(+t)},catmullRom}(.5)},function(t,e,n){"use strict";function LinearClosed(t){this._context=t}var r=n(86);LinearClosed.prototype={areaStart:r.a,areaEnd:r.a,lineStart:function(){this._point=0},lineEnd:function(){this._point&&this._context.closePath()},point:function(t,e){t=+t,e=+e,this._point?this._context.lineTo(t,e):(this._point=1,this._context.moveTo(t,e))}},e.a=function(t){return new LinearClosed(t)}},function(t,e,n){"use strict";function sign(t){return t<0?-1:1}function slope3(t,e,n){var r=t._x1-t._x0,a=e-t._x1,i=(t._y1-t._y0)/(r||a<0&&-0),o=(n-t._y1)/(a||r<0&&-0),u=(i*a+o*r)/(r+a);return(sign(i)+sign(o))*Math.min(Math.abs(i),Math.abs(o),.5*Math.abs(u))||0}function slope2(t,e){var n=t._x1-t._x0;return n?(3*(t._y1-t._y0)/n-e)/2:e}function point(t,e,n){var r=t._x0,a=t._y0,i=t._x1,o=t._y1,u=(i-r)/3;t._context.bezierCurveTo(r+u,a+u*e,i-u,o-u*n,i,o)}function MonotoneX(t){this._context=t}function MonotoneY(t){this._context=new ReflectContext(t)}function ReflectContext(t){this._context=t}function monotoneX(t){return new MonotoneX(t)}function monotoneY(t){return new MonotoneY(t)}e.a=monotoneX,e.b=monotoneY,MonotoneX.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=this._t0=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x1,this._y1);break;case 3:point(this,this._t0,slope2(this,this._t0))}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){var n=NaN;if(t=+t,e=+e,t!==this._x1||e!==this._y1){switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;break;case 2:this._point=3,point(this,slope2(this,n=slope3(this,t,e)),n);break;default:point(this,this._t0,n=slope3(this,t,e))}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e,this._t0=n}}},(MonotoneY.prototype=Object.create(MonotoneX.prototype)).point=function(t,e){MonotoneX.prototype.point.call(this,e,t)},ReflectContext.prototype={moveTo:function(t,e){this._context.moveTo(e,t)},closePath:function(){this._context.closePath()},lineTo:function(t,e){this._context.lineTo(e,t)},bezierCurveTo:function(t,e,n,r,a,i){this._context.bezierCurveTo(e,t,r,n,i,a)}}},function(t,e,n){"use strict";function Natural(t){this._context=t}function controlPoints(t){var e,n,r=t.length-1,a=new Array(r),i=new Array(r),o=new Array(r);for(a[0]=0,i[0]=2,o[0]=t[0]+2*t[1],e=1;e<r-1;++e)a[e]=1,i[e]=4,o[e]=4*t[e]+2*t[e+1];for(a[r-1]=2,i[r-1]=7,o[r-1]=8*t[r-1]+t[r],e=1;e<r;++e)n=a[e]/i[e-1],i[e]-=n,o[e]-=n*o[e-1];for(a[r-1]=o[r-1]/i[r-1],e=r-2;e>=0;--e)a[e]=(o[e]-a[e+1])/i[e];for(i[r-1]=(t[r]+a[r-1])/2,e=0;e<r-1;++e)i[e]=2*t[e+1]-a[e+1];return[a,i]}Natural.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=[],this._y=[]},lineEnd:function(){var t=this._x,e=this._y,n=t.length;if(n)if(this._line?this._context.lineTo(t[0],e[0]):this._context.moveTo(t[0],e[0]),2===n)this._context.lineTo(t[1],e[1]);else for(var r=controlPoints(t),a=controlPoints(e),i=0,o=1;o<n;++i,++o)this._context.bezierCurveTo(r[0][i],a[0][i],r[1][i],a[1][i],t[o],e[o]);(this._line||0!==this._line&&1===n)&&this._context.closePath(),this._line=1-this._line,this._x=this._y=null},point:function(t,e){this._x.push(+t),this._y.push(+e)}},e.a=function(t){return new Natural(t)}},function(t,e,n){"use strict";function Step(t,e){this._context=t,this._t=e}function stepBefore(t){return new Step(t,0)}function stepAfter(t){return new Step(t,1)}e.c=stepBefore,e.b=stepAfter,Step.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=this._y=NaN,this._point=0},lineEnd:function(){0<this._t&&this._t<1&&2===this._point&&this._context.lineTo(this._x,this._y),(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line>=0&&(this._t=1-this._t,this._line=1-this._line)},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;default:if(this._t<=0)this._context.lineTo(this._x,e),this._context.lineTo(t,e);else{var n=this._x*(1-this._t)+t*this._t;this._context.lineTo(n,this._y),this._context.lineTo(n,e)}}this._x=t,this._y=e}},e.a=function(t){return new Step(t,.5)}},function(t,e,n){"use strict";function stackValue(t,e){return t[e]}var r=n(243),a=n(34),i=n(63),o=n(64);e.a=function(){function stack(r){var a,i,o=t.apply(this,arguments),c=r.length,s=o.length,f=new Array(s);for(a=0;a<s;++a){for(var l,h=o[a],d=f[a]=new Array(c),p=0;p<c;++p)d[p]=l=[0,+u(r[p],h,p,r)],l.data=r[p];d.key=h}for(a=0,i=e(f);a<s;++a)f[i[a]].index=a;return n(f,i),f}var t=Object(a.a)([]),e=o.a,n=i.a,u=stackValue;return stack.keys=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(r.a.call(e)),stack):t},stack.value=function(t){return arguments.length?(u="function"==typeof t?t:Object(a.a)(+t),stack):u},stack.order=function(t){return arguments.length?(e=null==t?o.a:"function"==typeof t?t:Object(a.a)(r.a.call(t)),stack):e},stack.offset=function(t){return arguments.length?(n=null==t?i.a:t,stack):n},stack}},function(t,e,n){"use strict";var r=n(63);e.a=function(t,e){if((a=t.length)>0){for(var n,a,i,o=0,u=t[0].length;o<u;++o){for(i=n=0;n<a;++n)i+=t[n][o][1]||0;if(i)for(n=0;n<a;++n)t[n][o][1]/=i}Object(r.a)(t,e)}}},function(t,e,n){"use strict";e.a=function(t,e){if((u=t.length)>1)for(var n,r,a,i,o,u,c=0,s=t[e[0]].length;c<s;++c)for(i=o=0,n=0;n<u;++n)(a=(r=t[e[n]][c])[1]-r[0])>=0?(r[0]=i,r[1]=i+=a):a<0?(r[1]=o,r[0]=o+=a):r[0]=i}},function(t,e,n){"use strict";var r=n(63);e.a=function(t,e){if((n=t.length)>0){for(var n,a=0,i=t[e[0]],o=i.length;a<o;++a){for(var u=0,c=0;u<n;++u)c+=t[u][a][1]||0;i[a][1]+=i[a][0]=-c/2}Object(r.a)(t,e)}}},function(t,e,n){"use strict";var r=n(63);e.a=function(t,e){if((i=t.length)>0&&(a=(n=t[e[0]]).length)>0){for(var n,a,i,o=0,u=1;u<a;++u){for(var c=0,s=0,f=0;c<i;++c){for(var l=t[e[c]],h=l[u][1]||0,d=l[u-1][1]||0,p=(h-d)/2,b=0;b<c;++b){var v=t[e[b]];p+=(v[u][1]||0)-(v[u-1][1]||0)}s+=h,f+=p*h}n[u-1][1]+=n[u-1][0]=o,s&&(o-=f/s)}n[u-1][1]+=n[u-1][0]=o,Object(r.a)(t,e)}}},function(t,e,n){"use strict";var r=n(183);e.a=function(t){return Object(r.a)(t).reverse()}},function(t,e,n){"use strict";var r=n(64),a=n(183);e.a=function(t){var e,n,i=t.length,o=t.map(a.b),u=Object(r.a)(t).sort(function(t,e){return o[e]-o[t]}),c=0,s=0,f=[],l=[];for(e=0;e<i;++e)n=u[e],c<s?(c+=o[n],f.push(n)):(s+=o[n],l.push(n));return l.reverse().concat(f)}},function(t,e,n){"use strict";var r=n(64);e.a=function(t){return Object(r.a)(t).reverse()}},function(t,e,n){"use strict";var r;void 0!==(r=function(t){function addDays(t,e){var n=new Date(t);return n.setDate(n.getDate()+e),String(n)}function calculatePercent(t,n,r){var a=n?t/n*100:0;return e.format(r)(a)}function diffDays(t,e){return Math.ceil(Math.abs((new Date(t).getTime()-new Date(e).getTime())/864e5))}function isInteger(t){return t%1==0}function uniqueId(t){var e=++r;return t.toString()+"-"+e}var e=n(21),r=0;return{addDays:addDays,calculatePercent:calculatePercent,diffDays:diffDays,isInteger:isInteger,uniqueId:uniqueId}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r;void 0!==(r=function(t){var e=n(3),r={lineHeight:1.2,smallTextOffset:10,smallTextLineHeightRatio:.9,smallTextRatio:.6,valueClassName:"value",labelClassName:"label"},a=function(t,n,a,i){var o=e.select(i),u=o.text().split(/\s+/).reverse(),c=void 0,s=[],f=0,l=r.lineHeight*r.smallTextLineHeightRatio,h=o.attr("y"),d=parseFloat(o.attr("dy")),p=n*r.smallTextRatio,b=o.text(null).append("tspan").attr("x",t).attr("y",h-5).attr("dy",d+"em").classed(r.valueClassName,!0).style("font-size",n+"px");for(b.text(u.pop()),b=o.append("tspan").classed(r.labelClassName,!0).attr("x",t).attr("y",h+r.smallTextOffset).attr("dy",++f*l+d+"em").style("font-size",p+"px");c=u.pop();)s.push(c),b.text(s.join(" ")),b.node()&&b.node().getComputedTextLength()>a-50&&(s.pop(),b.text(s.join(" ")),s=[c],b=o.append("tspan").classed(r.labelClassName,!0).attr("x",t).attr("y",h+r.smallTextOffset).attr("dy",++f*l+d+"em").text(c).style("font-size",p+"px"))},i=function(t,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2;t.each(function(){var i,o,u,c,s,f,l,h;for(t=e.select(this),i=t.text().split(/\s+/).reverse(),u=[],c=0,s=1.2,f=t.attr("y"),l=parseFloat(t.attr("dy")),h=t.text(null).append("tspan").attr("x",r).attr("y",f).attr("dy",l+"em");o=i.pop();)if(u.push(o),h.text(u.join(" ")),h.node()&&h.node().getComputedTextLength()>n){if(u.pop(),h.text(u.join(" ")),!(c<a-1)){u.push("..."),h.text(u.join(" "));break}u=[o],h=t.append("tspan").attr("x",r).attr("y",f).attr("dy",++c*s+l+"em").text(o),t.classed("adjust-upwards",!0)}})};return{getTextWidth:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:12,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"Arial",r=document.createElement("canvas"),a=r.getContext("2d");return a.font=e+"px "+n,a.measureText(t).width},wrapText:a,wrapTextWithEllipses:i}}.call(e,n,e,t))&&(t.exports=r)},,,,,,,,function(t,e,n){"use strict";function _toConsumableArray(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}var r;void 0!==(r=function(t){var e=n(66),r=n(65),a=(n(21),n(8)),i=n(215),o=n(262),u=n(3),c=(n(91),n(253)),s=c.exportChart,f=n(289),l=n(89),h=n(288),d=h.calculatePercent,p=n(90),b=p.emptyDonutData,v=n(238),m=v.donut;return function(){function exports(e){e.each(function(e){w=n-t.left-t.right,O=c-t.top-t.bottom,x=cleanData(e),buildLayout(),buildColorScale(),buildShape(),buildSVG(this),drawSlices(),initTooltip(),D&&initHighlightSlice(),E&&P.showEmptySlice&&drawEmptySlice()})}function buildColorScale(){B&&(q=i.scaleOrdinal().range(B))}function buildContainerGroups(){var t=N.append("g").classed("container-group",!0);t.append("g").classed("chart-group",!0),t.append("g").classed("legend-group",!0)}function buildLayout(){T=o.pie().padAngle(_).value(X).sort(V)}function buildShape(){k=o.arc().innerRadius(C).padRadius(M)}function buildSVG(t){N||(N=u.select(t).append("svg").classed("britechart donut-chart",!0),buildContainerGroups()),N.select(".container-group").attr("transform","translate("+n/2+", "+c/2+")"),N.attr("width",n).attr("height",c)}function cleanData(t){var e=t.reduce(function(t,e){return void 0===e[R]||null===e[R]?t:(e.quantity=+e[R],e.name=String(e[L]),e.percentage=e[U]||null,[].concat(_toConsumableArray(t),[e]))},[]),n=G(e);return 0===n&&P.showEmptySlice&&(E=!0),e.map(function(t){return t.percentage=String(t.percentage||d(t[R],n,H)),t})}function cleanLegend(){N.select(".donut-text").text("")}function drawEmptySlice(){S&&N.selectAll("g.arc").remove(),S=N.select(".chart-group").selectAll("g.arc").data(T(b)),S.enter().append("g").each(z).each(W).classed("arc",!0).append("path").merge(S).attr("fill",P.emptySliceColor).attr("d",k).transition().ease(p).duration(v).attrTween("d",tweenLoading),S.exit().remove()}function drawLegend(t){t.data&&(N.select(".donut-text").text(function(){return t.data.percentage+"% "+t.data.name}).attr("dy",".2em").attr("text-anchor","middle"),N.select(".donut-text").call(wrapText,j))}function drawSlices(){S&&N.selectAll("g.arc").remove(),S=N.select(".chart-group").selectAll("g.arc").data(T(x));var t=S.enter().append("g").each(z).each(W).classed("arc",!0).append("path");A?t.merge(S).attr("fill",Z).on("mouseover",function(t){handleMouseOver(this,t,w,O)}).on("mousemove",function(t){handleMouseMove(this,t,w,O)}).on("mouseout",function(t){handleMouseOut(this,t,w,O)}).on("click",function(t){handleClick(this,t,w,O)}).transition().ease(p).duration(v).attrTween("d",tweenLoading):t.merge(S).attr("fill",Z).attr("d",k).on("mouseover",function(t){handleMouseOver(this,t,w,O)}).on("mousemove",function(t){handleMouseMove(this,t,w,O)}).on("mouseout",function(t){handleMouseOut(this,t,w,O)}).on("click",function(t){handleClick(this,t,w,O)}),S.exit().remove()}function filterHighlightedSlice(t){if(t.data.id===D)return this}function handleMouseOver(t,e,n,r){drawLegend(e),$.call("customMouseOver",t,e,u.mouse(t),[n,r]),F&&t!==F&&tweenGrowth(F,M-g),tweenGrowth(t,M)}function handleMouseMove(t,e,n,r){$.call("customMouseMove",t,e,u.mouse(t),[n,r])}function handleMouseOut(t,e,n,r){cleanLegend(),F&&I&&(drawLegend(F.__data__),tweenGrowth(F,M)),(t!==F||!I&&t===F)&&tweenGrowth(t,M-g,y),$.call("customMouseOut",t,e,u.mouse(t),[n,r])}function handleClick(t,e,n,r){$.call("customClick",t,e,u.mouse(t),[n,r])}function initHighlightSlice(){(F=N.selectAll(".chart-group .arc path").select(filterHighlightedSlice).node())&&(drawLegend(F.__data__),tweenGrowth(F,M,v))}function initTooltip(){N.select(".legend-group").append("text").attr("class","donut-text")}function tweenGrowth(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;u.select(t).transition().delay(n).attrTween("d",function(t){var n=a.interpolate(t.outerRadius,e);return function(e){return t.outerRadius=n(e),k(t)}})}function tweenLoading(t){var e=void 0;return t.innerRadius=0,e=a.interpolate({startAngle:0,endAngle:0},t),function(t){return k(e(t))}}function wrapText(t,e){var n=M/5;f.wrapText.call(null,0,n,e,t.node())}var t={top:0,right:0,bottom:0,left:0},n=300,c=300,h=m,p=r.easeCubicInOut,v=1200,y=150,g=12,_=0,x=void 0,w=void 0,O=void 0,M=140,C=45.5,j=M+C,T=void 0,k=void 0,S=void 0,N=void 0,A=!1,E=!1,D=void 0,F=void 0,I=!1,P={emptySliceColor:"#EFF2F5",showEmptySlice:!1},R="quantity",L="name",U="percentage",H=".1f",Y=void 0,q=void 0,B=l.colorSchemas.britecharts,z=function(t){this._current=t},W=function(t){t.outerRadius=M-g},V=function(t,e){return e.quantity-t.quantity},G=function(t){return t.reduce(function(t,e){return e.quantity+t},0)},X=function(t){return t.quantity},Z=function(t){var e=t.data;return q(e.name)},$=e.dispatch("customMouseOver","customMouseOut","customMouseMove","customClick");return exports.colorSchema=function(t){return arguments.length?(B=t,this):B},exports.emptyDataConfig=function(t){return arguments.length?(P=t,this):P},exports.exportChart=function(t,e){s.call(exports,N,t,e)},exports.externalRadius=function(t){return arguments.length?(M=t,this):M},exports.hasFixedHighlightedSlice=function(t){return arguments.length?(I=t,this):I},exports.height=function(t){return arguments.length?(c=t,this):c},exports.highlightSliceById=function(t){return arguments.length?(D=t,this):D},exports.internalRadius=function(t){return arguments.length?(C=t,this):C},exports.isAnimated=function(t){return arguments.length?(A=t,this):A},exports.loadingState=function(t){return arguments.length?(h=t,this):h},exports.margin=function(e){return arguments.length?(t=e,this):t},exports.numberFormat=function(t){return arguments.length?(Y=t,this):Y},exports.on=function(){var t=$.on.apply($,arguments);return t===$?exports:t},exports.orderingFunction=function(t){return arguments.length?(V=t,this):V},exports.percentageFormat=function(t){return arguments.length?(H=t,this):H},exports.radiusHoverOffset=function(t){return arguments.length?(g=t,this):g},exports.width=function(t){return arguments.length?(n=t,this):n},exports}}.call(e,n,e,t))&&(t.exports=r)}])})},function(t,e,n){"use strict";function _interopRequireDefault(t){return t&&t.__esModule?t:{default:t}}function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},a=function(){function defineProperties(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(t,e,n){return e&&defineProperties(t.prototype,e),n&&defineProperties(t,n),t}}(),i=n(4),o=_interopRequireDefault(i),u=n(6),c=_interopRequireDefault(u),s=n(99),f=_interopRequireDefault(s),l=function(t){function Legend(){return _classCallCheck(this,Legend),_possibleConstructorReturn(this,(Legend.__proto__||Object.getPrototypeOf(Legend)).apply(this,arguments))}return _inherits(Legend,t),a(Legend,[{key:"componentDidMount",value:function(){this._chart=this.props.chart.create(this._rootNode,this.props.data,this._getChartConfiguration())}},{key:"componentDidUpdate",value:function(){this.props.chart.update(this._rootNode,this.props.data,this._getChartConfiguration(),this._chart)}},{key:"componentWillUnmount",value:function(){this.props.chart.destroy(this._rootNode)}},{key:"_getChartConfiguration",value:function(){var t=r({},this.props);return delete t.data,delete t.chart,t}},{key:"_setRef",value:function(t){this._rootNode=t}},{key:"render",value:function(){return o.default.createElement("div",{className:"legend-container",ref:this._setRef.bind(this)})}}]),Legend}(o.default.Component);l.defaultProps={chart:f.default},l.propTypes={colorSchema:c.default.arrayOf(c.default.string),height:c.default.number,highlight:c.default.number,isHorizontal:c.default.bool,margin:c.default.shape({top:c.default.number,bottom:c.default.number,left:c.default.number,right:c.default.number}),marginRatio:c.default.number,markerSize:c.default.number,numberFormat:c.default.string,width:c.default.number,data:c.default.arrayOf(c.default.any).isRequired,chart:c.default.object},e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(100),a=function(t){return t&&t.__esModule?t:{default:t}}(r),i=n(8),o=n(9),u=n(10),c={};c.create=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=(0,i.select)(t),c=(0,a.default)();return(0,o.validateContainer)(r),(0,o.validateData)(e),(0,o.validateConfiguration)(c,n),r.datum(e).call((0,u.applyConfiguration)(c,n)),c},c.update=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=arguments[3],a=(0,i.select)(t);return(0,o.validateContainer)(a),(0,o.validateConfiguration)(r,n),(0,u.applyConfiguration)(r,n),e&&e.length?a.datum(e).call(r):a.call(r),r},c.destroy=function(){},e.default=c},function(t,e,n){!function(e,n){t.exports=n()}(0,function(){return function(t){function __webpack_require__(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,__webpack_require__),r.l=!0,r.exports}var e={};return __webpack_require__.m=t,__webpack_require__.c=e,__webpack_require__.d=function(t,e,n){__webpack_require__.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},__webpack_require__.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return __webpack_require__.d(e,"a",e),e},__webpack_require__.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=298)}([function(t,e,n){"use strict";function newInterval(t,e,n,i){function interval(e){return t(e=new Date(+e)),e}return interval.floor=interval,interval.ceil=function(n){return t(n=new Date(n-1)),e(n,1),t(n),n},interval.round=function(t){var e=interval(t),n=interval.ceil(t);return t-e<n-t?e:n},interval.offset=function(t,n){return e(t=new Date(+t),null==n?1:Math.floor(n)),t},interval.range=function(n,r,a){var i=[];if(n=interval.ceil(n),a=null==a?1:Math.floor(a),!(n<r&&a>0))return i;do{i.push(new Date(+n))}while(e(n,a),t(n),n<r);return i},interval.filter=function(n){return newInterval(function(e){if(e>=e)for(;t(e),!n(e);)e.setTime(e-1)},function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;e(t,-1),!n(t););else for(;--r>=0;)for(;e(t,1),!n(t););})},n&&(interval.count=function(e,i){return r.setTime(+e),a.setTime(+i),t(r),t(a),Math.floor(n(r,a))},interval.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?interval.filter(i?function(e){return i(e)%t==0}:function(e){return interval.count(0,e)%t==0}):interval:null}),interval}e.a=newInterval;var r=new Date,a=new Date},function(t,e,n){"use strict";function Selection(t,e){this._groups=t,this._parents=e}function selection(){return new Selection([[document.documentElement]],E)}n.d(e,"c",function(){return E}),e.a=Selection;var r=n(128),a=n(129),i=n(130),o=n(131),u=n(55),c=n(133),s=n(134),f=n(135),l=n(136),h=n(137),d=n(138),p=n(139),b=n(140),v=n(141),m=n(142),y=n(143),g=n(57),_=n(144),x=n(145),w=n(146),O=n(147),M=n(148),C=n(149),j=n(150),T=n(151),k=n(152),S=n(153),N=n(29),A=n(154),E=[null];Selection.prototype=selection.prototype={constructor:Selection,select:r.a,selectAll:a.a,filter:i.a,data:o.a,enter:u.b,exit:c.a,merge:s.a,order:f.a,sort:l.a,call:h.a,nodes:d.a,node:p.a,size:b.a,empty:v.a,each:m.a,attr:y.a,style:g.a,property:_.a,classed:x.a,text:w.a,html:O.a,raise:M.a,lower:C.a,append:j.a,insert:T.a,remove:k.a,datum:S.a,on:N.b,dispatch:A.a},e.b=selection},function(t,e,n){"use strict";function init(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>u)throw new Error("too late");return n}function set(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>s)throw new Error("too late");return n}function get(t,e){var n=t.__transition;if(!n||!(n=n[e]))throw new Error("too late");return n}function create(t,e,n){function schedule(t){n.state=c,n.timer.restart(start,n.delay,n.time),n.delay<=t&&start(t-n.delay)}function start(o){var u,h,p,b;if(n.state!==c)return stop();for(u in i)if(b=i[u],b.name===n.name){if(b.state===f)return Object(a.b)(start);b.state===l?(b.state=d,b.timer.stop(),b.on.call("interrupt",t,t.__data__,b.index,b.group),delete i[u]):+u<e&&(b.state=d,b.timer.stop(),delete i[u])}if(Object(a.b)(function(){n.state===f&&(n.state=l,n.timer.restart(tick,n.delay,n.time),tick(o))}),n.state=s,n.on.call("start",t,t.__data__,n.index,n.group),n.state===s){for(n.state=f,r=new Array(p=n.tween.length),u=0,h=-1;u<p;++u)(b=n.tween[u].value.call(t,t.__data__,n.index,n.group))&&(r[++h]=b);r.length=h+1}}function tick(e){for(var a=e<n.duration?n.ease.call(null,e/n.duration):(n.timer.restart(stop),n.state=h,1),i=-1,o=r.length;++i<o;)r[i].call(null,a);n.state===h&&(n.on.call("end",t,t.__data__,n.index,n.group),stop())}function stop(){n.state=d,n.timer.stop(),delete i[e];for(var r in i)return;delete t.__transition}var r,i=t.__transition;i[e]=n,n.timer=Object(a.c)(schedule,0,n.time)}n.d(e,"c",function(){return c}),n.d(e,"d",function(){return s}),n.d(e,"b",function(){return h}),n.d(e,"a",function(){return d}),e.g=init,e.h=set,e.f=get;var r=n(66),a=n(59),i=Object(r.dispatch)("start","end","interrupt"),o=[],u=0,c=1,s=2,f=3,l=4,h=5,d=6;e.e=function(t,e,n,r,a,c){var s=t.__transition;if(s){if(n in s)return}else t.__transition={};create(t,n,{name:e,index:r,group:a,on:i,tween:o,time:c.time,delay:c.delay,duration:c.duration,ease:c.ease,timer:null,state:u})}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(25);n.d(e,"creator",function(){return r.a});var a=n(125);n.d(e,"local",function(){return a.a});var i=n(53);n.d(e,"matcher",function(){return i.a});var o=n(126);n.d(e,"mouse",function(){return o.a});var u=n(26);n.d(e,"namespace",function(){return u.a});var c=n(27);n.d(e,"namespaces",function(){return c.a});var s=n(127);n.d(e,"select",function(){return s.a});var f=n(155);n.d(e,"selectAll",function(){return f.a});var l=n(1);n.d(e,"selection",function(){return l.b});var h=n(31);n.d(e,"selector",function(){return h.a});var d=n(54);n.d(e,"selectorAll",function(){return d.a});var p=n(57);n.d(e,"style",function(){return p.b});var b=n(156);n.d(e,"touch",function(){return b.a});var v=n(157);n.d(e,"touches",function(){return v.a});var m=n(32);n.d(e,"window",function(){return m.a});var y=n(29);n.d(e,"event",function(){return y.c}),n.d(e,"customEvent",function(){return y.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(19);n.d(e,"color",function(){return r.e}),n.d(e,"rgb",function(){return r.g}),n.d(e,"hsl",function(){return r.f});var a=n(102);n.d(e,"lab",function(){return a.a}),n.d(e,"hcl",function(){return a.b});var i=n(103);n.d(e,"cubehelix",function(){return i.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(67);n.d(e,"bisect",function(){return r.c}),n.d(e,"bisectRight",function(){return r.b}),n.d(e,"bisectLeft",function(){return r.a});var a=n(10);n.d(e,"ascending",function(){return a.a});var i=n(68);n.d(e,"bisector",function(){return i.a});var o=n(184);n.d(e,"cross",function(){return o.a});var u=n(185);n.d(e,"descending",function(){return u.a});var c=n(70);n.d(e,"deviation",function(){return c.a});var s=n(72);n.d(e,"extent",function(){return s.a});var f=n(186);n.d(e,"histogram",function(){return f.a});var l=n(189);n.d(e,"thresholdFreedmanDiaconis",function(){return l.a});var h=n(190);n.d(e,"thresholdScott",function(){return h.a});var d=n(76);n.d(e,"thresholdSturges",function(){return d.a});var p=n(191);n.d(e,"max",function(){return p.a});var b=n(192);n.d(e,"mean",function(){return b.a});var v=n(193);n.d(e,"median",function(){return v.a});var m=n(194);n.d(e,"merge",function(){return m.a});var y=n(77);n.d(e,"min",function(){return y.a});var g=n(69);n.d(e,"pairs",function(){return g.a});var _=n(195);n.d(e,"permute",function(){return _.a});var x=n(36);n.d(e,"quantile",function(){return x.a});var w=n(74);n.d(e,"range",function(){return w.a});var O=n(196);n.d(e,"scan",function(){return O.a});var M=n(197);n.d(e,"shuffle",function(){return M.a});var C=n(198);n.d(e,"sum",function(){return C.a});var j=n(75);n.d(e,"ticks",function(){return j.a}),n.d(e,"tickIncrement",function(){return j.b}),n.d(e,"tickStep",function(){return j.c});var T=n(78);n.d(e,"transpose",function(){return T.a});var k=n(71);n.d(e,"variance",function(){return k.a});var S=n(199);n.d(e,"zip",function(){return S.a})},function(t,e,n){"use strict";n.d(e,"d",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"a",function(){return o}),n.d(e,"e",function(){return u});var r=1e3,a=6e4,i=36e5,o=864e5,u=6048e5},function(t,e,n){"use strict";function Transition(t,e,n,r){this._groups=t,this._parents=e,this._name=n,this._id=r}function transition(t){return Object(r.selection)().transition(t)}function newId(){return++x}e.a=Transition,e.b=transition,e.c=newId;var r=n(3),a=n(163),i=n(164),o=n(165),u=n(166),c=n(167),s=n(168),f=n(169),l=n(170),h=n(171),d=n(172),p=n(173),b=n(174),v=n(175),m=n(176),y=n(177),g=n(178),_=n(17),x=0,w=r.selection.prototype;Transition.prototype=transition.prototype={constructor:Transition,select:d.a,selectAll:p.a,filter:s.a,merge:f.a,selection:b.a,transition:g.a,call:w.call,nodes:w.nodes,node:w.node,size:w.size,empty:w.empty,each:w.each,on:l.a,attr:a.a,attrTween:i.a,style:v.a,styleTween:m.a,text:y.a,remove:h.a,tween:_.a,delay:o.a,duration:u.a,ease:c.a}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(23);n.d(e,"interpolate",function(){return r.a});var a=n(49);n.d(e,"interpolateArray",function(){return a.a});var i=n(24);n.d(e,"interpolateBasis",function(){return i.b});var o=n(47);n.d(e,"interpolateBasisClosed",function(){return o.a});var u=n(50);n.d(e,"interpolateDate",function(){return u.a});var c=n(15);n.d(e,"interpolateNumber",function(){return c.a});var s=n(51);n.d(e,"interpolateObject",function(){return s.a});var f=n(115);n.d(e,"interpolateRound",function(){return f.a});var l=n(52);n.d(e,"interpolateString",function(){return l.a});var h=n(116);n.d(e,"interpolateTransformCss",function(){return h.a}),n.d(e,"interpolateTransformSvg",function(){return h.b});var d=n(119);n.d(e,"interpolateZoom",function(){return d.a});var p=n(46);n.d(e,"interpolateRgb",function(){return p.a}),n.d(e,"interpolateRgbBasis",function(){return p.b}),n.d(e,"interpolateRgbBasisClosed",function(){return p.c});var b=n(120);n.d(e,"interpolateHsl",function(){return b.a}),n.d(e,"interpolateHslLong",function(){return b.b});var v=n(121);n.d(e,"interpolateLab",function(){return v.a});var m=n(122);n.d(e,"interpolateHcl",function(){return m.a}),n.d(e,"interpolateHclLong",function(){return m.b});var y=n(123);n.d(e,"interpolateCubehelix",function(){return y.b}),n.d(e,"interpolateCubehelixLong",function(){return y.a});var g=n(124);n.d(e,"quantize",function(){return g.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"b",function(){return i});var r=Array.prototype,a=r.map,i=r.slice},function(t,e,n){"use strict";e.a=function(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}},function(t,e,n){"use strict";function linear(t,e){return function(n){return t+n*e}}function exponential(t,e,n){return t=Math.pow(t,n),e=Math.pow(e,n)-t,n=1/n,function(r){return Math.pow(t+r*e,n)}}function hue(t,e){var n=e-t;return n?linear(t,n>180||n<-180?n-360*Math.round(n/360):n):Object(r.a)(isNaN(t)?e:t)}function gamma(t){return 1==(t=+t)?nogamma:function(e,n){return n-e?exponential(e,n,t):Object(r.a)(isNaN(e)?n:e)}}function nogamma(t,e){var n=e-t;return n?linear(t,n):Object(r.a)(isNaN(t)?e:t)}e.c=hue,e.b=gamma,e.a=nogamma;var r=n(48)},function(t,e,n){"use strict";e.a=function(t){return null===t?NaN:+t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t){return t=Object(r.a)(Math.abs(t)),t?t[1]:NaN}},function(t,e,n){"use strict";function linearish(t){var e=t.domain;return t.ticks=function(t){var n=e();return Object(r.ticks)(n[0],n[n.length-1],null==t?10:t)},t.tickFormat=function(t,n){return Object(o.a)(e(),t,n)},t.nice=function(n){null==n&&(n=10);var a,i=e(),o=0,u=i.length-1,c=i[o],s=i[u];return s<c&&(a=c,c=s,s=a,a=o,o=u,u=a),a=Object(r.tickIncrement)(c,s,n),a>0?(c=Math.floor(c/a)*a,s=Math.ceil(s/a)*a,a=Object(r.tickIncrement)(c,s,n)):a<0&&(c=Math.ceil(c*a)/a,s=Math.floor(s*a)/a,a=Object(r.tickIncrement)(c,s,n)),a>0?(i[o]=Math.floor(c/a)*a,i[u]=Math.ceil(s/a)*a,e(i)):a<0&&(i[o]=Math.ceil(c*a)/a,i[u]=Math.floor(s*a)/a,e(i)),t},t}function linear(){var t=Object(i.b)(i.c,a.interpolateNumber);return t.copy=function(){return Object(i.a)(t,linear())},linearish(t)}e.b=linearish,e.a=linear;var r=n(5),a=n(8),i=n(18),o=n(223)},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return t+e*n}}},function(t,e,n){"use strict";e.a=function(t){return t.match(/.{6}/g).map(function(t){return"#"+t})}},function(t,e,n){"use strict";function tweenRemove(t,e){var n,a;return function(){var i=Object(r.h)(this,t),o=i.tween;if(o!==n){a=n=o;for(var u=0,c=a.length;u<c;++u)if(a[u].name===e){a=a.slice(),a.splice(u,1);break}}i.tween=a}}function tweenFunction(t,e,n){var a,i;if("function"!=typeof n)throw new Error;return function(){var o=Object(r.h)(this,t),u=o.tween;if(u!==a){i=(a=u).slice();for(var c={name:e,value:n},s=0,f=i.length;s<f;++s)if(i[s].name===e){i[s]=c;break}s===f&&i.push(c)}o.tween=i}}function tweenValue(t,e,n){var a=t._id;return t.each(function(){var t=Object(r.h)(this,a);(t.value||(t.value={}))[e]=n.apply(this,arguments)}),function(t){return Object(r.f)(t,a).value[e]}}e.b=tweenValue;var r=n(2);e.a=function(t,e){var n=this._id;if(t+="",arguments.length<2){for(var a,i=Object(r.f)(this.node(),n).tween,o=0,u=i.length;o<u;++o)if((a=i[o]).name===t)return a.value;return null}return this.each((null==e?tweenRemove:tweenFunction)(n,t,e))}},function(t,e,n){"use strict";function deinterpolateLinear(t,e){return(e-=t=+t)?function(n){return(n-t)/e}:Object(o.a)(e)}function deinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=e?0:t>=n?1:r(t)}}}function reinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=0?e:t>=1?n:r(t)}}}function bimap(t,e,n,r){var a=t[0],i=t[1],o=e[0],u=e[1];return i<a?(a=n(i,a),o=r(u,o)):(a=n(a,i),o=r(o,u)),function(t){return o(a(t))}}function polymap(t,e,n,a){var i=Math.min(t.length,e.length)-1,o=new Array(i),u=new Array(i),c=-1;for(t[i]<t[0]&&(t=t.slice().reverse(),e=e.slice().reverse());++c<i;)o[c]=n(t[c],t[c+1]),u[c]=a(e[c],e[c+1]);return function(e){var n=Object(r.bisect)(t,e,1,i)-1;return u[n](o[n](e))}}function copy(t,e){return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp())}function continuous(t,e){function rescale(){return n=Math.min(s.length,f.length)>2?polymap:bimap,r=o=null,scale}function scale(e){return(r||(r=n(s,f,h?deinterpolateClamp(t):t,l)))(+e)}var n,r,o,s=c,f=c,l=a.interpolate,h=!1;return scale.invert=function(t){return(o||(o=n(f,s,deinterpolateLinear,h?reinterpolateClamp(e):e)))(+t)},scale.domain=function(t){return arguments.length?(s=i.a.call(t,u.a),rescale()):s.slice()},scale.range=function(t){return arguments.length?(f=i.b.call(t),rescale()):f.slice()},scale.rangeRound=function(t){return f=i.b.call(t),l=a.interpolateRound,rescale()},scale.clamp=function(t){return arguments.length?(h=!!t,rescale()):h},scale.interpolate=function(t){return arguments.length?(l=t,rescale()):l},rescale()}e.c=deinterpolateLinear,e.a=copy,e.b=continuous;var r=n(5),a=n(8),i=n(9),o=n(39),u=n(82),c=[0,1]},function(t,e,n){"use strict";function Color(){}function color(t){var e;return t=(t+"").trim().toLowerCase(),(e=s.exec(t))?(e=parseInt(e[1],16),new Rgb(e>>8&15|e>>4&240,e>>4&15|240&e,(15&e)<<4|15&e,1)):(e=f.exec(t))?rgbn(parseInt(e[1],16)):(e=l.exec(t))?new Rgb(e[1],e[2],e[3],1):(e=h.exec(t))?new Rgb(255*e[1]/100,255*e[2]/100,255*e[3]/100,1):(e=d.exec(t))?rgba(e[1],e[2],e[3],e[4]):(e=p.exec(t))?rgba(255*e[1]/100,255*e[2]/100,255*e[3]/100,e[4]):(e=b.exec(t))?hsla(e[1],e[2]/100,e[3]/100,1):(e=v.exec(t))?hsla(e[1],e[2]/100,e[3]/100,e[4]):m.hasOwnProperty(t)?rgbn(m[t]):"transparent"===t?new Rgb(NaN,NaN,NaN,0):null}function rgbn(t){return new Rgb(t>>16&255,t>>8&255,255&t,1)}function rgba(t,e,n,r){return r<=0&&(t=e=n=NaN),new Rgb(t,e,n,r)}function rgbConvert(t){return t instanceof Color||(t=color(t)),t?(t=t.rgb(),new Rgb(t.r,t.g,t.b,t.opacity)):new Rgb}function rgb(t,e,n,r){return 1===arguments.length?rgbConvert(t):new Rgb(t,e,n,null==r?1:r)}function Rgb(t,e,n,r){this.r=+t,this.g=+e,this.b=+n,this.opacity=+r}function hsla(t,e,n,r){return r<=0?t=e=n=NaN:n<=0||n>=1?t=e=NaN:e<=0&&(t=NaN),new Hsl(t,e,n,r)}function hslConvert(t){if(t instanceof Hsl)return new Hsl(t.h,t.s,t.l,t.opacity);if(t instanceof Color||(t=color(t)),!t)return new Hsl;if(t instanceof Hsl)return t;t=t.rgb();var e=t.r/255,n=t.g/255,r=t.b/255,a=Math.min(e,n,r),i=Math.max(e,n,r),o=NaN,u=i-a,c=(i+a)/2;return u?(o=e===i?(n-r)/u+6*(n<r):n===i?(r-e)/u+2:(e-n)/u+4,u/=c<.5?i+a:2-i-a,o*=60):u=c>0&&c<1?0:o,new Hsl(o,u,c,t.opacity)}function hsl(t,e,n,r){return 1===arguments.length?hslConvert(t):new Hsl(t,e,n,null==r?1:r)}function Hsl(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}function hsl2rgb(t,e,n){return 255*(t<60?e+(n-e)*t/60:t<180?n:t<240?e+(n-e)*(240-t)/60:e)}e.a=Color,n.d(e,"d",function(){return a}),n.d(e,"c",function(){return i}),e.e=color,e.h=rgbConvert,e.g=rgb,e.b=Rgb,e.f=hsl;var r=n(20),a=.7,i=1/a,o="\\s*([+-]?\\d+)\\s*",u="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",s=/^#([0-9a-f]{3})$/,f=/^#([0-9a-f]{6})$/,l=new RegExp("^rgb\\("+[o,o,o]+"\\)$"),h=new RegExp("^rgb\\("+[c,c,c]+"\\)$"),d=new RegExp("^rgba\\("+[o,o,o,u]+"\\)$"),p=new RegExp("^rgba\\("+[c,c,c,u]+"\\)$"),b=new RegExp("^hsl\\("+[u,c,c]+"\\)$"),v=new RegExp("^hsla\\("+[u,c,c,u]+"\\)$"),m={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};Object(r.a)(Color,color,{displayable:function(){return this.rgb().displayable()},toString:function(){return this.rgb()+""}}),Object(r.a)(Rgb,rgb,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return 0<=this.r&&this.r<=255&&0<=this.g&&this.g<=255&&0<=this.b&&this.b<=255&&0<=this.opacity&&this.opacity<=1},toString:function(){var t=this.opacity;return t=isNaN(t)?1:Math.max(0,Math.min(1,t)),(1===t?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}})),Object(r.a)(Hsl,hsl,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),e=isNaN(t)||isNaN(this.s)?0:this.s,n=this.l,r=n+(n<.5?n:1-n)*e,a=2*n-r;return new Rgb(hsl2rgb(t>=240?t-240:t+120,a,r),hsl2rgb(t,a,r),hsl2rgb(t<120?t+240:t-120,a,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1}}))},function(t,e,n){"use strict";function extend(t,e){var n=Object.create(t.prototype);for(var r in e)n[r]=e[r];return n}e.b=extend,e.a=function(t,e,n){t.prototype=e.prototype=n,n.constructor=t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(105);n.d(e,"formatDefaultLocale",function(){return r.a}),n.d(e,"format",function(){return r.b}),n.d(e,"formatPrefix",function(){return r.c});var a=n(42);n.d(e,"formatLocale",function(){return a.a});var i=n(43);n.d(e,"formatSpecifier",function(){return i.a});var o=n(111);n.d(e,"precisionFixed",function(){return o.a});var u=n(112);n.d(e,"precisionPrefix",function(){return u.a});var c=n(113);n.d(e,"precisionRound",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){if((n=(t=e?t.toExponential(e-1):t.toExponential()).indexOf("e"))<0)return null;var n,r=t.slice(0,n);return[r.length>1?r[0]+r.slice(2):r,+t.slice(n+1)]}},function(t,e,n){"use strict";var r=n(4),a=n(46),i=n(49),o=n(50),u=n(15),c=n(51),s=n(52),f=n(48);e.a=function(t,e){var n,l=typeof e;return null==e||"boolean"===l?Object(f.a)(e):("number"===l?u.a:"string"===l?(n=Object(r.color)(e))?(e=n,a.a):s.a:e instanceof r.color?a.a:e instanceof Date?o.a:Array.isArray(e)?i.a:"function"!=typeof e.valueOf&&"function"!=typeof e.toString||isNaN(e)?c.a:u.a)(t,e)}},function(t,e,n){"use strict";function basis(t,e,n,r,a){var i=t*t,o=i*t;return((1-3*t+3*i-o)*e+(4-6*i+3*o)*n+(1+3*t+3*i-3*o)*r+o*a)/6}e.a=basis,e.b=function(t){var e=t.length-1;return function(n){var r=n<=0?n=0:n>=1?(n=1,e-1):Math.floor(n*e),a=t[r],i=t[r+1],o=r>0?t[r-1]:2*a-i,u=r<e-1?t[r+2]:2*i-a;return basis((n-r/e)*e,o,a,i,u)}}},function(t,e,n){"use strict";function creatorInherit(t){return function(){var e=this.ownerDocument,n=this.namespaceURI;return n===a.b&&e.documentElement.namespaceURI===a.b?e.createElement(t):e.createElementNS(n,t)}}function creatorFixed(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}var r=n(26),a=n(27);e.a=function(t){var e=Object(r.a)(t);return(e.local?creatorFixed:creatorInherit)(e)}},function(t,e,n){"use strict";var r=n(27);e.a=function(t){var e=t+="",n=e.indexOf(":");return n>=0&&"xmlns"!==(e=t.slice(0,n))&&(t=t.slice(n+1)),r.a.hasOwnProperty(e)?{space:r.a[e],local:t}:t}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r="http://www.w3.org/1999/xhtml";e.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,e,n){"use strict";var r=n(29);e.a=function(){for(var t,e=r.c;t=e.sourceEvent;)e=t;return e}},function(t,e,n){"use strict";function filterContextListener(t,e,n){return t=contextListener(t,e,n),function(e){var n=e.relatedTarget;n&&(n===this||8&n.compareDocumentPosition(this))||t.call(this,e)}}function contextListener(t,e,n){return function(r){var i=a;a=r;try{t.call(this,this.__data__,e,n)}finally{a=i}}}function parseTypenames(t){return t.trim().split(/^|\s+/).map(function(t){var e="",n=t.indexOf(".");return n>=0&&(e=t.slice(n+1),t=t.slice(0,n)),{type:t,name:e}})}function onRemove(t){return function(){var e=this.__on;if(e){for(var n,r=0,a=-1,i=e.length;r<i;++r)n=e[r],t.type&&n.type!==t.type||n.name!==t.name?e[++a]=n:this.removeEventListener(n.type,n.listener,n.capture);++a?e.length=a:delete this.__on}}}function onAdd(t,e,n){var a=r.hasOwnProperty(t.type)?filterContextListener:contextListener;return function(r,i,o){var u,c=this.__on,s=a(e,i,o);if(c)for(var f=0,l=c.length;f<l;++f)if((u=c[f]).type===t.type&&u.name===t.name)return this.removeEventListener(u.type,u.listener,u.capture),this.addEventListener(u.type,u.listener=s,u.capture=n),void(u.value=e);this.addEventListener(t.type,s,n),u={type:t.type,name:t.name,value:e,listener:s,capture:n},c?c.push(u):this.__on=[u]}}function customEvent(t,e,n,r){var i=a;t.sourceEvent=a,a=t;try{return e.apply(n,r)}finally{a=i}}n.d(e,"c",function(){return a}),e.a=customEvent;var r={},a=null;if("undefined"!=typeof document){"onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"})}e.b=function(t,e,n){var r,a,i=parseTypenames(t+""),o=i.length;{if(!(arguments.length<2)){for(u=e?onAdd:onRemove,null==n&&(n=!1),r=0;r<o;++r)this.each(u(i[r],e,n));return this}var u=this.node().__on;if(u)for(var c,s=0,f=u.length;s<f;++s)for(r=0,c=u[s];r<o;++r)if((a=i[r]).type===c.type&&a.name===c.name)return c.value}}},function(t,e,n){"use strict";e.a=function(t,e){var n=t.ownerSVGElement||t;if(n.createSVGPoint){var r=n.createSVGPoint();return r.x=e.clientX,r.y=e.clientY,r=r.matrixTransform(t.getScreenCTM().inverse()),[r.x,r.y]}var a=t.getBoundingClientRect();return[e.clientX-a.left-t.clientLeft,e.clientY-a.top-t.clientTop]}},function(t,e,n){"use strict";function none(){}e.a=function(t){return null==t?none:function(){return this.querySelector(t)}}},function(t,e,n){"use strict";e.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,e,n){"use strict";function now(){return f||(d(clearNow),f=h.now()+l)}function clearNow(){f=0}function Timer(){this._call=this._time=this._next=null}function timer(t,e,n){var r=new Timer;return r.restart(t,e,n),r}function timerFlush(){now(),++i;for(var t,e=r;e;)(t=f-e._time)>=0&&e._call.call(null,t),e=e._next;--i}function wake(){f=(s=h.now())+l,i=o=0;try{timerFlush()}finally{i=0,nap(),f=0}}function poke(){var t=h.now(),e=t-s;e>c&&(l-=e,s=t)}function nap(){for(var t,e,n=r,i=1/0;n;)n._call?(i>n._time&&(i=n._time),t=n,n=n._next):(e=n._next,n._next=null,n=t?t._next=e:r=e);a=t,sleep(i)}function sleep(t){if(!i){o&&(o=clearTimeout(o));var e=t-f;e>24?(t<1/0&&(o=setTimeout(wake,e)),u&&(u=clearInterval(u))):(u||(s=f,u=setInterval(poke,c)),i=1,d(wake))}}e.b=now,e.a=Timer,e.c=timer;var r,a,i=0,o=0,u=0,c=1e3,s=0,f=0,l=0,h="object"==typeof performance&&performance.now?performance:Date,d="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};Timer.prototype=timer.prototype={constructor:Timer,restart:function(t,e,n){if("function"!=typeof t)throw new TypeError("callback is not a function");n=(null==n?now():+n)+(null==e?0:+e),this._next||a===this||(a?a._next=this:r=this,a=this),this._call=t,this._time=n,sleep()},stop:function(){this._call&&(this._call=null,this._time=1/0,sleep())}}},,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(0);n.d(e,"timeInterval",function(){return r.a});var a=n(200);n.d(e,"timeMillisecond",function(){return a.a}),n.d(e,"timeMilliseconds",function(){return a.b}),n.d(e,"utcMillisecond",function(){return a.a}),n.d(e,"utcMilliseconds",function(){return a.b});var i=n(201);n.d(e,"timeSecond",function(){return i.a}),n.d(e,"timeSeconds",function(){return i.b}),n.d(e,"utcSecond",function(){return i.a}),n.d(e,"utcSeconds",function(){return i.b});var o=n(202);n.d(e,"timeMinute",function(){return o.a}),n.d(e,"timeMinutes",function(){return o.b});var u=n(203);n.d(e,"timeHour",function(){return u.a}),n.d(e,"timeHours",function(){return u.b});var c=n(204);n.d(e,"timeDay",function(){return c.b}),n.d(e,"timeDays",function(){return c.a});var s=n(205);n.d(e,"timeWeek",function(){return s.g}),n.d(e,"timeWeeks",function(){return s.h}),n.d(e,"timeSunday",function(){return s.g}),n.d(e,"timeSundays",function(){return s.h}),n.d(e,"timeMonday",function(){return s.c}),n.d(e,"timeMondays",function(){return s.d}),n.d(e,"timeTuesday",function(){return s.k}),n.d(e,"timeTuesdays",function(){return s.l}),n.d(e,"timeWednesday",function(){return s.m}),n.d(e,"timeWednesdays",function(){return s.n}),n.d(e,"timeThursday",function(){return s.i}),n.d(e,"timeThursdays",function(){return s.j}),n.d(e,"timeFriday",function(){return s.a}),n.d(e,"timeFridays",function(){return s.b}),n.d(e,"timeSaturday",function(){return s.e}),n.d(e,"timeSaturdays",function(){return s.f});var f=n(206);n.d(e,"timeMonth",function(){return f.a}),n.d(e,"timeMonths",function(){return f.b});var l=n(207);n.d(e,"timeYear",function(){return l.a}),n.d(e,"timeYears",function(){return l.b});var h=n(208);n.d(e,"utcMinute",function(){return h.a}),n.d(e,"utcMinutes",function(){return h.b});var d=n(209);n.d(e,"utcHour",function(){return d.a}),n.d(e,"utcHours",function(){return d.b});var p=n(210);n.d(e,"utcDay",function(){return p.a}),n.d(e,"utcDays",function(){return p.b});var b=n(211);n.d(e,"utcWeek",function(){return b.g}),n.d(e,"utcWeeks",function(){return b.h}),n.d(e,"utcSunday",function(){return b.g}),n.d(e,"utcSundays",function(){return b.h}),n.d(e,"utcMonday",function(){return b.c}),n.d(e,"utcMondays",function(){return b.d}),n.d(e,"utcTuesday",function(){return b.k}),n.d(e,"utcTuesdays",function(){return b.l}),n.d(e,"utcWednesday",function(){return b.m}),n.d(e,"utcWednesdays",function(){return b.n}),n.d(e,"utcThursday",function(){return b.i}),n.d(e,"utcThursdays",function(){return b.j}),n.d(e,"utcFriday",function(){return b.a}),n.d(e,"utcFridays",function(){return b.b}),n.d(e,"utcSaturday",function(){return b.e}),n.d(e,"utcSaturdays",function(){return b.f});var v=n(212);n.d(e,"utcMonth",function(){return v.a}),n.d(e,"utcMonths",function(){return v.b});var m=n(213);n.d(e,"utcYear",function(){return m.a}),n.d(e,"utcYears",function(){return m.b})},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e,n){if(null==n&&(n=r.a),a=t.length){if((e=+e)<=0||a<2)return+n(t[0],0,t);if(e>=1)return+n(t[a-1],a-1,t);var a,i=(a-1)*e,o=Math.floor(i),u=+n(t[o],o,t);return u+(+n(t[o+1],o+1,t)-u)*(i-o)}}},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(c.a)(t),a=r.format,i=r.parse,o=r.utcFormat,u=r.utcParse,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"d",function(){return o}),n.d(e,"e",function(){return u}),e.a=defaultLocale;var r,a,i,o,u,c=n(79);defaultLocale({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,e,n){"use strict";function Map(){}function map(t,e){var n=new Map;if(t instanceof Map)t.each(function(t,e){n.set(e,t)});else if(Array.isArray(t)){var r,a=-1,i=t.length;if(null==e)for(;++a<i;)n.set(a,t[a]);else for(;++a<i;)n.set(e(r=t[a],a,t),r)}else if(t)for(var o in t)n.set(o,t[o]);return n}n.d(e,"b",function(){return r});var r="$";Map.prototype=map.prototype={constructor:Map,has:function(t){return r+t in this},get:function(t){return this[r+t]},set:function(t,e){return this[r+t]=e,this},remove:function(t){var e=r+t;return e in this&&delete this[e]},clear:function(){for(var t in this)t[0]===r&&delete this[t]},keys:function(){var t=[];for(var e in this)e[0]===r&&t.push(e.slice(1));return t},values:function(){var t=[];for(var e in this)e[0]===r&&t.push(this[e]);return t},entries:function(){var t=[];for(var e in this)e[0]===r&&t.push({key:e.slice(1),value:this[e]});return t},size:function(){var t=0;for(var e in this)e[0]===r&&++t;return t},empty:function(){for(var t in this)if(t[0]===r)return!1;return!0},each:function(t){for(var e in this)e[0]===r&&t(this[e],e.slice(1),this)}},e.a=map},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(37);n.d(e,"timeFormatDefaultLocale",function(){return r.a}),n.d(e,"timeFormat",function(){return r.b}),n.d(e,"timeParse",function(){return r.c}),n.d(e,"utcFormat",function(){return r.d}),n.d(e,"utcParse",function(){return r.e});var a=n(79);n.d(e,"timeFormatLocale",function(){return a.a});var i=n(80);n.d(e,"isoFormat",function(){return i.a});var o=n(214);n.d(e,"isoParse",function(){return o.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"b",function(){return a});var r=Math.PI/180,a=180/Math.PI},function(t,e,n){"use strict";var r=n(13),a=n(106),i=n(107),o=n(43),u=n(44),c=n(45),s=n(110),f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];e.a=function(t){function newFormat(t){function format(t){var n,o,u,s=g,d=_;if("c"===y)d=x(t)+d,t="";else{t=+t;var O=t<0;if(t=x(Math.abs(t),m),O&&0==+t&&(O=!1),s=(O?"("===i?i:"-":"-"===i||"("===i?"":i)+s,d=d+("s"===y?f[8+c.b/3]:"")+(O&&"("===i?")":""),w)for(n=-1,o=t.length;++n<o;)if(48>(u=t.charCodeAt(n))||u>57){d=(46===u?l+t.slice(n+1):t.slice(n))+d,t=t.slice(0,n);break}}v&&!p&&(t=e(t,1/0));var M=s.length+t.length+d.length,C=M<b?new Array(b-M+1).join(r):"";switch(v&&p&&(t=e(C+t,C.length?b-d.length:1/0),C=""),a){case"<":t=s+t+d+C;break;case"=":t=s+C+t+d;break;case"^":t=C.slice(0,M=C.length>>1)+s+t+d+C.slice(M);break;default:t=C+s+t+d}return h(t)}t=Object(o.a)(t);var r=t.fill,a=t.align,i=t.sign,s=t.symbol,p=t.zero,b=t.width,v=t.comma,m=t.precision,y=t.type,g="$"===s?n[0]:"#"===s&&/[boxX]/.test(y)?"0"+y.toLowerCase():"",_="$"===s?n[1]:/[%p]/.test(y)?d:"",x=u.a[y],w=!y||/[defgprs%]/.test(y);return m=null==m?y?6:12:/[gprs]/.test(y)?Math.max(1,Math.min(21,m)):Math.max(0,Math.min(20,m)),format.toString=function(){return t+""},format}function formatPrefix(t,e){var n=newFormat((t=Object(o.a)(t),t.type="f",t)),a=3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3))),i=Math.pow(10,-a),u=f[8+a/3];return function(t){return n(i*t)+u}}var e=t.grouping&&t.thousands?Object(a.a)(t.grouping,t.thousands):s.a,n=t.currency,l=t.decimal,h=t.numerals?Object(i.a)(t.numerals):s.a,d=t.percent||"%";return{format:newFormat,formatPrefix:formatPrefix}}},function(t,e,n){"use strict";function formatSpecifier(t){return new FormatSpecifier(t)}function FormatSpecifier(t){if(!(e=a.exec(t)))throw new Error("invalid format: "+t);var e,n=e[1]||" ",i=e[2]||">",o=e[3]||"-",u=e[4]||"",c=!!e[5],s=e[6]&&+e[6],f=!!e[7],l=e[8]&&+e[8].slice(1),h=e[9]||"";"n"===h?(f=!0,h="g"):r.a[h]||(h=""),(c||"0"===n&&"="===i)&&(c=!0,n="0",i="="),this.fill=n,this.align=i,this.sign=o,this.symbol=u,this.zero=c,this.width=s,this.comma=f,this.precision=l,this.type=h}e.a=formatSpecifier;var r=n(44),a=/^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;formatSpecifier.prototype=FormatSpecifier.prototype,FormatSpecifier.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(null==this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(null==this.precision?"":"."+Math.max(0,0|this.precision))+this.type}},function(t,e,n){"use strict";var r=n(108),a=n(45),i=n(109);e.a={"":r.a,"%":function(t,e){return(100*t).toFixed(e)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,e){return t.toExponential(e)},f:function(t,e){return t.toFixed(e)},g:function(t,e){return t.toPrecision(e)},o:function(t){return Math.round(t).toString(8)},p:function(t,e){return Object(i.a)(100*t,e)},r:i.a,s:a.a,X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r,a=n(22);e.a=function(t,e){var n=Object(a.a)(t,e);if(!n)return t+"";var i=n[0],o=n[1],u=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return u===c?i:u>c?i+new Array(u-c+1).join("0"):u>0?i.slice(0,u)+"."+i.slice(u):"0."+new Array(1-u).join("0")+Object(a.a)(t,Math.max(0,e+u-1))[0]}},function(t,e,n){"use strict";function rgbSpline(t){return function(e){var n,a,i=e.length,o=new Array(i),u=new Array(i),c=new Array(i);for(n=0;n<i;++n)a=Object(r.rgb)(e[n]),o[n]=a.r||0,u[n]=a.g||0,c[n]=a.b||0;return o=t(o),u=t(u),c=t(c),a.opacity=1,function(t){return a.r=o(t),a.g=u(t),a.b=c(t),a+""}}}n.d(e,"b",function(){return u}),n.d(e,"c",function(){return c});var r=n(4),a=n(24),i=n(47),o=n(11);e.a=function rgbGamma(t){function rgb(t,n){var a=e((t=Object(r.rgb)(t)).r,(n=Object(r.rgb)(n)).r),i=e(t.g,n.g),u=e(t.b,n.b),c=Object(o.a)(t.opacity,n.opacity);return function(e){return t.r=a(e),t.g=i(e),t.b=u(e),t.opacity=c(e),t+""}}var e=Object(o.b)(t);return rgb.gamma=rgbGamma,rgb}(1);var u=rgbSpline(a.b),c=rgbSpline(i.a)},function(t,e,n){"use strict";var r=n(24);e.a=function(t){var e=t.length;return function(n){var a=Math.floor(((n%=1)<0?++n:n)*e),i=t[(a+e-1)%e],o=t[a%e],u=t[(a+1)%e],c=t[(a+2)%e];return Object(r.a)((n-a/e)*e,i,o,u,c)}}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a=e?e.length:0,i=t?Math.min(a,t.length):0,o=new Array(a),u=new Array(a);for(n=0;n<i;++n)o[n]=Object(r.a)(t[n],e[n]);for(;n<a;++n)u[n]=e[n];return function(t){for(n=0;n<i;++n)u[n]=o[n](t);return u}}},function(t,e,n){"use strict";e.a=function(t,e){var n=new Date;return t=+t,e-=t,function(r){return n.setTime(t+e*r),n}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a={},i={};null!==t&&"object"==typeof t||(t={}),null!==e&&"object"==typeof e||(e={});for(n in e)n in t?a[n]=Object(r.a)(t[n],e[n]):i[n]=e[n];return function(t){for(n in a)i[n]=a[n](t);return i}}},function(t,e,n){"use strict";function zero(t){return function(){return t}}function one(t){return function(e){return t(e)+""}}var r=n(15),a=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,i=new RegExp(a.source,"g");e.a=function(t,e){var n,o,u,c=a.lastIndex=i.lastIndex=0,s=-1,f=[],l=[];for(t+="",e+="";(n=a.exec(t))&&(o=i.exec(e));)(u=o.index)>c&&(u=e.slice(c,u),f[s]?f[s]+=u:f[++s]=u),(n=n[0])===(o=o[0])?f[s]?f[s]+=o:f[++s]=o:(f[++s]=null,l.push({i:s,x:Object(r.a)(n,o)})),c=i.lastIndex;return c<e.length&&(u=e.slice(c),f[s]?f[s]+=u:f[++s]=u),f.length<2?l[0]?one(l[0].x):zero(e):(e=l.length,function(t){for(var n,r=0;r<e;++r)f[(n=l[r]).i]=n.x(t);return f.join("")})}},function(t,e,n){"use strict";var r=function(t){return function(){return this.matches(t)}};if("undefined"!=typeof document){var a=document.documentElement;if(!a.matches){var i=a.webkitMatchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector;r=function(t){return function(){return i.call(this,t)}}}}e.a=r},function(t,e,n){"use strict";function empty(){return[]}e.a=function(t){return null==t?empty:function(){return this.querySelectorAll(t)}}},function(t,e,n){"use strict";function EnterNode(t,e){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=e}e.a=EnterNode;var r=n(56),a=n(1);e.b=function(){return new a.a(this._enter||this._groups.map(r.a),this._parents)},EnterNode.prototype={constructor:EnterNode,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,e){return this._parent.insertBefore(t,e)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}}},function(t,e,n){"use strict";e.a=function(t){return new Array(t.length)}},function(t,e,n){"use strict";function styleRemove(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){return function(){this.style.setProperty(t,e,n)}}function styleFunction(t,e,n){return function(){var r=e.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,n)}}function styleValue(t,e){return t.style.getPropertyValue(e)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(e)}e.b=styleValue;var r=n(32);e.a=function(t,e,n){return arguments.length>1?this.each((null==e?styleRemove:"function"==typeof e?styleFunction:styleConstant)(t,e,null==n?"":n)):styleValue(this.node(),t)}},function(t,e,n){"use strict";var r=n(2);e.a=function(t,e){var n,a,i,o=t.__transition,u=!0;if(o){e=null==e?null:e+"";for(i in o)(n=o[i]).name===e?(a=n.state>r.d&&n.state<r.b,n.state=r.a,n.timer.stop(),a&&n.on.call("interrupt",t,t.__data__,n.index,n.group),delete o[i]):u=!1;u&&delete t.__transition}}},function(t,e,n){"use strict";var r=n(33);n.d(e,"a",function(){return r.b}),n.d(e,"c",function(){return r.c});var a=n(160);n.d(e,"b",function(){return a.a});n(161)},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=function(t,e){var n;return("number"==typeof e?a.interpolateNumber:e instanceof r.color?a.interpolateRgb:(n=Object(r.color)(e))?(e=n,a.interpolateRgb):a.interpolateString)(t,e)}},,,,,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(92);n.d(e,"easeLinear",function(){return r.a});var a=n(93);n.d(e,"easeQuad",function(){return a.b}),n.d(e,"easeQuadIn",function(){return a.a}),n.d(e,"easeQuadOut",function(){return a.c}),n.d(e,"easeQuadInOut",function(){return a.b});var i=n(94);n.d(e,"easeCubic",function(){return i.b}),n.d(e,"easeCubicIn",function(){return i.a}),n.d(e,"easeCubicOut",function(){return i.c}),n.d(e,"easeCubicInOut",function(){return i.b});var o=n(95);n.d(e,"easePoly",function(){return o.b}),n.d(e,"easePolyIn",function(){return o.a}),n.d(e,"easePolyOut",function(){return o.c}),n.d(e,"easePolyInOut",function(){return o.b});var u=n(96);n.d(e,"easeSin",function(){return u.b}),n.d(e,"easeSinIn",function(){return u.a}),n.d(e,"easeSinOut",function(){return u.c}),n.d(e,"easeSinInOut",function(){return u.b});var c=n(97);n.d(e,"easeExp",function(){return c.b}),n.d(e,"easeExpIn",function(){return c.a}),n.d(e,"easeExpOut",function(){return c.c}),n.d(e,"easeExpInOut",function(){return c.b});var s=n(98);n.d(e,"easeCircle",function(){return s.b}),n.d(e,"easeCircleIn",function(){return s.a}),n.d(e,"easeCircleOut",function(){return s.c}),n.d(e,"easeCircleInOut",function(){return s.b});var f=n(99);n.d(e,"easeBounce",function(){return f.c}),n.d(e,"easeBounceIn",function(){return f.a}),n.d(e,"easeBounceOut",function(){return f.c}),n.d(e,"easeBounceInOut",function(){return f.b});var l=n(100);n.d(e,"easeBack",function(){return l.b}),n.d(e,"easeBackIn",function(){return l.a}),n.d(e,"easeBackOut",function(){return l.c}),n.d(e,"easeBackInOut",function(){return l.b});var h=n(101);n.d(e,"easeElastic",function(){return h.c}),n.d(e,"easeElasticIn",function(){return h.a}),n.d(e,"easeElasticOut",function(){return h.c}),n.d(e,"easeElasticInOut",function(){return h.b})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(104);n.d(e,"dispatch",function(){return r.a})},function(t,e,n){"use strict";n.d(e,"b",function(){return o}),n.d(e,"a",function(){return u});var r=n(10),a=n(68),i=Object(a.a)(r.a),o=i.right,u=i.left;e.c=o},function(t,e,n){"use strict";function ascendingComparator(t){return function(e,n){return Object(r.a)(t(e),n)}}var r=n(10);e.a=function(t){return 1===t.length&&(t=ascendingComparator(t)),{left:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)<0?r=i+1:a=i}return r},right:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)>0?a=i:r=i+1}return r}}}},function(t,e,n){"use strict";function pair(t,e){return[t,e]}e.b=pair,e.a=function(t,e){null==e&&(e=pair);for(var n=0,r=t.length-1,a=t[0],i=new Array(r<0?0:r);n<r;)i[n]=e(a,a=t[++n]);return i}},function(t,e,n){"use strict";var r=n(71);e.a=function(t,e){var n=Object(r.a)(t,e);return n?Math.sqrt(n):n}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a,i=t.length,o=0,u=-1,c=0,s=0;if(null==e)for(;++u<i;)isNaN(n=Object(r.a)(t[u]))||(a=n-c,c+=a/++o,s+=a*(n-c));else for(;++u<i;)isNaN(n=Object(r.a)(e(t[u],u,t)))||(a=n-c,c+=a/++o,s+=a*(n-c));if(o>1)return s/(o-1)}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a,i=t.length,o=-1;if(null==e){for(;++o<i;)if(null!=(n=t[o])&&n>=n)for(r=a=n;++o<i;)null!=(n=t[o])&&(r>n&&(r=n),a<n&&(a=n))}else for(;++o<i;)if(null!=(n=e(t[o],o,t))&&n>=n)for(r=a=n;++o<i;)null!=(n=e(t[o],o,t))&&(r>n&&(r=n),a<n&&(a=n));return[r,a]}},function(t,e,n){"use strict";n.d(e,"b",function(){return a}),n.d(e,"a",function(){return i});var r=Array.prototype,a=r.slice,i=r.map},function(t,e,n){"use strict";e.a=function(t,e,n){t=+t,e=+e,n=(a=arguments.length)<2?(e=t,t=0,1):a<3?1:+n;for(var r=-1,a=0|Math.max(0,Math.ceil((e-t)/n)),i=new Array(a);++r<a;)i[r]=t+r*n;return i}},function(t,e,n){"use strict";function tickIncrement(t,e,n){var o=(e-t)/Math.max(0,n),u=Math.floor(Math.log(o)/Math.LN10),c=o/Math.pow(10,u);return u>=0?(c>=r?10:c>=a?5:c>=i?2:1)*Math.pow(10,u):-Math.pow(10,-u)/(c>=r?10:c>=a?5:c>=i?2:1)}function tickStep(t,e,n){var o=Math.abs(e-t)/Math.max(0,n),u=Math.pow(10,Math.floor(Math.log(o)/Math.LN10)),c=o/u;return c>=r?u*=10:c>=a?u*=5:c>=i&&(u*=2),e<t?-u:u}e.b=tickIncrement,e.c=tickStep;var r=Math.sqrt(50),a=Math.sqrt(10),i=Math.sqrt(2);e.a=function(t,e,n){var r,a,i,o=e<t,u=-1;if(o&&(r=t,t=e,e=r),0===(i=tickIncrement(t,e,n))||!isFinite(i))return[];if(i>0)for(t=Math.ceil(t/i),e=Math.floor(e/i),a=new Array(r=Math.ceil(e-t+1));++u<r;)a[u]=(t+u)*i;else for(t=Math.floor(t*i),e=Math.ceil(e*i),a=new Array(r=Math.ceil(t-e+1));++u<r;)a[u]=(t-u)/i;return o&&a.reverse(),a}},function(t,e,n){"use strict";e.a=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&r>n&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&r>n&&(r=n);return r}},function(t,e,n){"use strict";function length(t){return t.length}var r=n(77);e.a=function(t){if(!(i=t.length))return[];for(var e=-1,n=Object(r.a)(t,length),a=new Array(n);++e<n;)for(var i,o=-1,u=a[e]=new Array(i);++o<i;)u[o]=t[o][e];return a}},function(t,e,n){"use strict";function localDate(t){if(0<=t.y&&t.y<100){var e=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return e.setFullYear(t.y),e}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function utcDate(t){if(0<=t.y&&t.y<100){var e=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return e.setUTCFullYear(t.y),e}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function newYear(t){return{y:t,m:0,d:1,H:0,M:0,S:0,L:0}}function formatLocale(t){function newFormat(t,e){return function(n){var r,i,o,u=[],c=-1,s=0,f=t.length;for(n instanceof Date||(n=new Date(+n));++c<f;)37===t.charCodeAt(c)&&(u.push(t.slice(s,c)),null!=(i=a[r=t.charAt(++c)])?r=t.charAt(++c):i="e"===r?" ":"0",(o=e[r])&&(r=o(n,i)),u.push(r),s=c+1);return u.push(t.slice(s,c)),u.join("")}}function newParse(t,e){return function(n){var r=newYear(1900);if(parseSpecifier(r,t,n+="",0)!=n.length)return null;if("p"in r&&(r.H=r.H%12+12*r.p),"W"in r||"U"in r){"w"in r||(r.w="W"in r?1:0);var a="Z"in r?utcDate(newYear(r.y)).getUTCDay():e(newYear(r.y)).getDay();r.m=0,r.d="W"in r?(r.w+6)%7+7*r.W-(a+5)%7:r.w+7*r.U-(a+6)%7}return"Z"in r?(r.H+=r.Z/100|0,r.M+=r.Z%100,utcDate(r)):e(r)}}function parseSpecifier(t,e,n,r){for(var i,o,u=0,c=e.length,s=n.length;u<c;){if(r>=s)return-1;if(37===(i=e.charCodeAt(u++))){if(i=e.charAt(u++),!(o=w[i in a?e.charAt(u++):i])||(r=o(t,n,r))<0)return-1}else if(i!=n.charCodeAt(r++))return-1}return r}function parsePeriod(t,e,n){var r=f.exec(e.slice(n));return r?(t.p=l[r[0].toLowerCase()],n+r[0].length):-1}function parseShortWeekday(t,e,n){var r=p.exec(e.slice(n));return r?(t.w=b[r[0].toLowerCase()],n+r[0].length):-1}function parseWeekday(t,e,n){var r=h.exec(e.slice(n));return r?(t.w=d[r[0].toLowerCase()],n+r[0].length):-1}function parseShortMonth(t,e,n){var r=y.exec(e.slice(n));return r?(t.m=g[r[0].toLowerCase()],n+r[0].length):-1}function parseMonth(t,e,n){var r=v.exec(e.slice(n));return r?(t.m=m[r[0].toLowerCase()],n+r[0].length):-1}function parseLocaleDateTime(t,n,r){return parseSpecifier(t,e,n,r)}function parseLocaleDate(t,e,r){return parseSpecifier(t,n,e,r)}function parseLocaleTime(t,e,n){return parseSpecifier(t,r,e,n)}function formatShortWeekday(t){return u[t.getDay()]}function formatWeekday(t){return o[t.getDay()]}function formatShortMonth(t){return s[t.getMonth()]}function formatMonth(t){return c[t.getMonth()]}function formatPeriod(t){return i[+(t.getHours()>=12)]}function formatUTCShortWeekday(t){return u[t.getUTCDay()]}function formatUTCWeekday(t){return o[t.getUTCDay()]}function formatUTCShortMonth(t){return s[t.getUTCMonth()]}function formatUTCMonth(t){return c[t.getUTCMonth()]}function formatUTCPeriod(t){return i[+(t.getUTCHours()>=12)]}var e=t.dateTime,n=t.date,r=t.time,i=t.periods,o=t.days,u=t.shortDays,c=t.months,s=t.shortMonths,f=formatRe(i),l=formatLookup(i),h=formatRe(o),d=formatLookup(o),p=formatRe(u),b=formatLookup(u),v=formatRe(c),m=formatLookup(c),y=formatRe(s),g=formatLookup(s),_={a:formatShortWeekday,A:formatWeekday,b:formatShortMonth,B:formatMonth,c:null,d:formatDayOfMonth,e:formatDayOfMonth,H:formatHour24,I:formatHour12,j:formatDayOfYear,L:formatMilliseconds,m:formatMonthNumber,M:formatMinutes,p:formatPeriod,S:formatSeconds,U:formatWeekNumberSunday,w:formatWeekdayNumber,W:formatWeekNumberMonday,x:null,X:null,y:formatYear,Y:formatFullYear,Z:formatZone,"%":formatLiteralPercent},x={a:formatUTCShortWeekday,A:formatUTCWeekday,b:formatUTCShortMonth,B:formatUTCMonth,c:null,d:formatUTCDayOfMonth,e:formatUTCDayOfMonth,H:formatUTCHour24,I:formatUTCHour12,j:formatUTCDayOfYear,L:formatUTCMilliseconds,m:formatUTCMonthNumber,M:formatUTCMinutes,p:formatUTCPeriod,S:formatUTCSeconds,U:formatUTCWeekNumberSunday,w:formatUTCWeekdayNumber,W:formatUTCWeekNumberMonday,x:null,X:null,y:formatUTCYear,Y:formatUTCFullYear,Z:formatUTCZone,"%":formatLiteralPercent},w={a:parseShortWeekday,A:parseWeekday,b:parseShortMonth,B:parseMonth,c:parseLocaleDateTime,d:parseDayOfMonth,e:parseDayOfMonth,H:parseHour24,I:parseHour24,j:parseDayOfYear,L:parseMilliseconds,m:parseMonthNumber,M:parseMinutes,p:parsePeriod,S:parseSeconds,U:parseWeekNumberSunday,w:parseWeekdayNumber,W:parseWeekNumberMonday,x:parseLocaleDate,X:parseLocaleTime,y:parseYear,Y:parseFullYear,Z:parseZone,"%":parseLiteralPercent};return _.x=newFormat(n,_),_.X=newFormat(r,_),_.c=newFormat(e,_),x.x=newFormat(n,x),x.X=newFormat(r,x),x.c=newFormat(e,x),{format:function(t){var e=newFormat(t+="",_);return e.toString=function(){return t},e},parse:function(t){var e=newParse(t+="",localDate);return e.toString=function(){return t},e},utcFormat:function(t){var e=newFormat(t+="",x);return e.toString=function(){return t},e},utcParse:function(t){var e=newParse(t,utcDate);return e.toString=function(){return t},e}}}function pad(t,e,n){var r=t<0?"-":"",a=(r?-t:t)+"",i=a.length;return r+(i<n?new Array(n-i+1).join(e)+a:a)}function requote(t){return t.replace(u,"\\$&")}function formatRe(t){return new RegExp("^(?:"+t.map(requote).join("|")+")","i")}function formatLookup(t){for(var e={},n=-1,r=t.length;++n<r;)e[t[n].toLowerCase()]=n;return e}function parseWeekdayNumber(t,e,n){var r=i.exec(e.slice(n,n+1));return r?(t.w=+r[0],n+r[0].length):-1}function parseWeekNumberSunday(t,e,n){var r=i.exec(e.slice(n));return r?(t.U=+r[0],n+r[0].length):-1}function parseWeekNumberMonday(t,e,n){var r=i.exec(e.slice(n));return r?(t.W=+r[0],n+r[0].length):-1}function parseFullYear(t,e,n){var r=i.exec(e.slice(n,n+4));return r?(t.y=+r[0],n+r[0].length):-1}function parseYear(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),n+r[0].length):-1}function parseZone(t,e,n){var r=/^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(e.slice(n,n+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),n+r[0].length):-1}function parseMonthNumber(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.m=r[0]-1,n+r[0].length):-1}function parseDayOfMonth(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.d=+r[0],n+r[0].length):-1}function parseDayOfYear(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.m=0,t.d=+r[0],n+r[0].length):-1}function parseHour24(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.H=+r[0],n+r[0].length):-1}function parseMinutes(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.M=+r[0],n+r[0].length):-1}function parseSeconds(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.S=+r[0],n+r[0].length):-1}function parseMilliseconds(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.L=+r[0],n+r[0].length):-1}function parseLiteralPercent(t,e,n){var r=o.exec(e.slice(n,n+1));return r?n+r[0].length:-1}function formatDayOfMonth(t,e){return pad(t.getDate(),e,2)}function formatHour24(t,e){return pad(t.getHours(),e,2)}function formatHour12(t,e){return pad(t.getHours()%12||12,e,2)}function formatDayOfYear(t,e){return pad(1+r.timeDay.count(Object(r.timeYear)(t),t),e,3)}function formatMilliseconds(t,e){return pad(t.getMilliseconds(),e,3)}function formatMonthNumber(t,e){return pad(t.getMonth()+1,e,2)}function formatMinutes(t,e){return pad(t.getMinutes(),e,2)}function formatSeconds(t,e){return pad(t.getSeconds(),e,2)}function formatWeekNumberSunday(t,e){return pad(r.timeSunday.count(Object(r.timeYear)(t),t),e,2)}function formatWeekdayNumber(t){return t.getDay()}function formatWeekNumberMonday(t,e){return pad(r.timeMonday.count(Object(r.timeYear)(t),t),e,2)}function formatYear(t,e){return pad(t.getFullYear()%100,e,2)}function formatFullYear(t,e){return pad(t.getFullYear()%1e4,e,4)}function formatZone(t){var e=t.getTimezoneOffset();return(e>0?"-":(e*=-1,"+"))+pad(e/60|0,"0",2)+pad(e%60,"0",2)}function formatUTCDayOfMonth(t,e){return pad(t.getUTCDate(),e,2)}function formatUTCHour24(t,e){return pad(t.getUTCHours(),e,2)}function formatUTCHour12(t,e){return pad(t.getUTCHours()%12||12,e,2)}function formatUTCDayOfYear(t,e){return pad(1+r.utcDay.count(Object(r.utcYear)(t),t),e,3)}function formatUTCMilliseconds(t,e){return pad(t.getUTCMilliseconds(),e,3)}function formatUTCMonthNumber(t,e){return pad(t.getUTCMonth()+1,e,2)}function formatUTCMinutes(t,e){return pad(t.getUTCMinutes(),e,2)}function formatUTCSeconds(t,e){return pad(t.getUTCSeconds(),e,2)}function formatUTCWeekNumberSunday(t,e){return pad(r.utcSunday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCWeekdayNumber(t){return t.getUTCDay()}function formatUTCWeekNumberMonday(t,e){return pad(r.utcMonday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCYear(t,e){return pad(t.getUTCFullYear()%100,e,2)}function formatUTCFullYear(t,e){return pad(t.getUTCFullYear()%1e4,e,4)}function formatUTCZone(){return"+0000"}function formatLiteralPercent(){return"%"}e.a=formatLocale;var r=n(35),a={"-":"",_:" ",0:"0"},i=/^\s*\d+/,o=/^%/,u=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g},function(t,e,n){"use strict";function formatIsoNative(t){return t.toISOString()}n.d(e,"b",function(){return a});var r=n(37),a="%Y-%m-%dT%H:%M:%S.%LZ",i=Date.prototype.toISOString?formatIsoNative:Object(r.d)(a);e.a=i},function(t,e,n){"use strict";function ordinal(t){function scale(r){var a=r+"",u=e.get(a);if(!u){if(o!==i)return o;e.set(a,u=n.push(r))}return t[(u-1)%t.length]}var e=Object(r.map)(),n=[],o=i;return t=null==t?[]:a.b.call(t),scale.domain=function(t){if(!arguments.length)return n.slice();n=[],e=Object(r.map)();for(var a,i,o=-1,u=t.length;++o<u;)e.has(i=(a=t[o])+"")||e.set(i,n.push(a));return scale},scale.range=function(e){return arguments.length?(t=a.b.call(e),scale):t.slice()},scale.unknown=function(t){return arguments.length?(o=t,scale):o},scale.copy=function(){return ordinal().domain(n).range(t).unknown(o)},scale}n.d(e,"b",function(){return i}),e.a=ordinal;var r=n(114),a=n(9),i={name:"implicit"}},function(t,e,n){"use strict";e.a=function(t){return+t}},function(t,e,n){"use strict";e.a=function(t,e){t=t.slice();var n,r=0,a=t.length-1,i=t[r],o=t[a];return o<i&&(n=r,r=a,a=n,n=i,i=o,o=n),t[r]=e.floor(i),t[a]=e.ceil(o),t}},function(t,e,n){"use strict";function date(t){return new Date(t)}function number(t){return t instanceof Date?+t:+new Date(+t)}function calendar(t,e,n,i,o,m,y,g,_){function tickFormat(r){return(y(r)<r?M:m(r)<r?C:o(r)<r?j:i(r)<r?T:e(r)<r?n(r)<r?k:S:t(r)<r?N:A)(r)}function tickInterval(e,n,a,i){if(null==e&&(e=10),"number"==typeof e){var o=Math.abs(a-n)/e,u=Object(r.bisector)(function(t){return t[2]}).right(E,o);u===E.length?(i=Object(r.tickStep)(n/v,a/v,e),e=t):u?(u=E[o/E[u-1][2]<E[u][2]/o?u-1:u],i=u[1],e=u[0]):(i=Object(r.tickStep)(n,a,e),e=g)}return null==i?e:e.every(i)}var x=Object(c.b)(c.c,a.interpolateNumber),w=x.invert,O=x.domain,M=_(".%L"),C=_(":%S"),j=_("%I:%M"),T=_("%I %p"),k=_("%a %d"),S=_("%b %d"),N=_("%B"),A=_("%Y"),E=[[y,1,f],[y,5,5*f],[y,15,15*f],[y,30,30*f],[m,1,l],[m,5,5*l],[m,15,15*l],[m,30,30*l],[o,1,h],[o,3,3*h],[o,6,6*h],[o,12,12*h],[i,1,d],[i,2,2*d],[n,1,p],[e,1,b],[e,3,3*b],[t,1,v]];return x.invert=function(t){return new Date(w(t))},x.domain=function(t){return arguments.length?O(u.a.call(t,number)):O().map(date)},x.ticks=function(t,e){var n,r=O(),a=r[0],i=r[r.length-1],o=i<a;return o&&(n=a,a=i,i=n),n=tickInterval(t,a,i,e),n=n?n.range(a,i+1):[],o?n.reverse():n},x.tickFormat=function(t,e){return null==e?tickFormat:_(e)},x.nice=function(t,e){var n=O();return(t=tickInterval(t,n[0],n[n.length-1],e))?O(Object(s.a)(n,t)):x},x.copy=function(){return Object(c.a)(x,calendar(t,e,n,i,o,m,y,g,_))},x}e.a=calendar;var r=n(5),a=n(8),i=n(35),o=n(40),u=n(9),c=n(18),s=n(83),f=1e3,l=60*f,h=60*l,d=24*h,p=7*d,b=30*d,v=365*d;e.b=function(){return calendar(i.timeYear,i.timeMonth,i.timeWeek,i.timeDay,i.timeHour,i.timeMinute,i.timeSecond,i.timeMillisecond,o.timeFormat).domain([new Date(2e3,0,1),new Date(2e3,0,2)])}},,,,,function(t,e,n){"use strict";var r;void 0!==(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},singleColors:{aloeGreen:["#7bdcc0"]},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green To Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"}}}.call(e,n,e,t))&&(t.exports=r)},,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=(n(158),n(7));n.d(e,"transition",function(){return r.b});var a=n(179);n.d(e,"active",function(){return a.a});var i=n(58);n.d(e,"interrupt",function(){return i.a})},function(t,e,n){"use strict";function linear(t){return+t}e.a=linear},function(t,e,n){"use strict";function quadIn(t){return t*t}function quadOut(t){return t*(2-t)}function quadInOut(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.a=quadIn,e.c=quadOut,e.b=quadInOut},function(t,e,n){"use strict";function cubicIn(t){return t*t*t}function cubicOut(t){return--t*t*t+1}function cubicInOut(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.a=cubicIn,e.c=cubicOut,e.b=cubicInOut},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function polyIn(e){return Math.pow(e,t)}return t=+t,polyIn.exponent=custom,polyIn}(3),a=function custom(t){function polyOut(e){return 1-Math.pow(1-e,t)}return t=+t,polyOut.exponent=custom,polyOut}(3),i=function custom(t){function polyInOut(e){return((e*=2)<=1?Math.pow(e,t):2-Math.pow(2-e,t))/2}return t=+t,polyInOut.exponent=custom,polyInOut}(3)},function(t,e,n){"use strict";function sinIn(t){return 1-Math.cos(t*a)}function sinOut(t){return Math.sin(t*a)}function sinInOut(t){return(1-Math.cos(r*t))/2}e.a=sinIn,e.c=sinOut,e.b=sinInOut;var r=Math.PI,a=r/2},function(t,e,n){"use strict";function expIn(t){return Math.pow(2,10*t-10)}function expOut(t){return 1-Math.pow(2,-10*t)}function expInOut(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}e.a=expIn,e.c=expOut,e.b=expInOut},function(t,e,n){"use strict";function circleIn(t){return 1-Math.sqrt(1-t*t)}function circleOut(t){return Math.sqrt(1- --t*t)}function circleInOut(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}e.a=circleIn,e.c=circleOut,e.b=circleInOut},function(t,e,n){"use strict";function bounceIn(t){return 1-bounceOut(1-t)}function bounceOut(t){return(t=+t)<r?h*t*t:t<i?h*(t-=a)*t+o:t<c?h*(t-=u)*t+s:h*(t-=f)*t+l}function bounceInOut(t){return((t*=2)<=1?1-bounceOut(1-t):bounceOut(t-1)+1)/2}e.a=bounceIn,e.c=bounceOut,e.b=bounceInOut;var r=4/11,a=6/11,i=8/11,o=.75,u=9/11,c=10/11,s=.9375,f=21/22,l=63/64,h=1/r/r},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function backIn(e){return e*e*((t+1)*e-t)}return t=+t,backIn.overshoot=custom,backIn}(1.70158),a=function custom(t){function backOut(e){return--e*e*((t+1)*e+t)+1}return t=+t,backOut.overshoot=custom,backOut}(1.70158),i=function custom(t){function backInOut(e){return((e*=2)<1?e*e*((t+1)*e-t):(e-=2)*e*((t+1)*e+t)+2)/2}return t=+t,backInOut.overshoot=custom,backInOut}(1.70158)},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"b",function(){return o});var r=2*Math.PI,a=function custom(t,e){function elasticIn(r){return t*Math.pow(2,10*--r)*Math.sin((n-r)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticIn.amplitude=function(t){return custom(t,e*r)},elasticIn.period=function(e){return custom(t,e)},elasticIn}(1,.3),i=function custom(t,e){function elasticOut(r){return 1-t*Math.pow(2,-10*(r=+r))*Math.sin((r+n)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticOut.amplitude=function(t){return custom(t,e*r)},elasticOut.period=function(e){return custom(t,e)},elasticOut}(1,.3),o=function custom(t,e){function elasticInOut(r){return((r=2*r-1)<0?t*Math.pow(2,10*r)*Math.sin((n-r)/e):2-t*Math.pow(2,-10*r)*Math.sin((n+r)/e))/2}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticInOut.amplitude=function(t){return custom(t,e*r)},elasticInOut.period=function(e){return custom(t,e)},elasticInOut}(1,.3)},function(t,e,n){"use strict";function labConvert(t){if(t instanceof Lab)return new Lab(t.l,t.a,t.b,t.opacity);if(t instanceof Hcl){var e=t.h*i.a;return new Lab(t.l,Math.cos(e)*t.c,Math.sin(e)*t.c,t.opacity)}t instanceof a.b||(t=Object(a.h)(t));var n=rgb2xyz(t.r),r=rgb2xyz(t.g),s=rgb2xyz(t.b),f=xyz2lab((.4124564*n+.3575761*r+.1804375*s)/o),l=xyz2lab((.2126729*n+.7151522*r+.072175*s)/u);return new Lab(116*l-16,500*(f-l),200*(l-xyz2lab((.0193339*n+.119192*r+.9503041*s)/c)),t.opacity)}function lab(t,e,n,r){return 1===arguments.length?labConvert(t):new Lab(t,e,n,null==r?1:r)}function Lab(t,e,n,r){this.l=+t,this.a=+e,this.b=+n,this.opacity=+r}function xyz2lab(t){return t>h?Math.pow(t,1/3):t/l+s}function lab2xyz(t){return t>f?t*t*t:l*(t-s)}function xyz2rgb(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function rgb2xyz(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function hclConvert(t){if(t instanceof Hcl)return new Hcl(t.h,t.c,t.l,t.opacity);t instanceof Lab||(t=labConvert(t));var e=Math.atan2(t.b,t.a)*i.b;return new Hcl(e<0?e+360:e,Math.sqrt(t.a*t.a+t.b*t.b),t.l,t.opacity)}function hcl(t,e,n,r){return 1===arguments.length?hclConvert(t):new Hcl(t,e,n,null==r?1:r)}function Hcl(t,e,n,r){this.h=+t,this.c=+e,this.l=+n,this.opacity=+r}e.a=lab,e.b=hcl;var r=n(20),a=n(19),i=n(41),o=.95047,u=1,c=1.08883,s=4/29,f=6/29,l=3*f*f,h=f*f*f;Object(r.a)(Lab,lab,Object(r.b)(a.a,{brighter:function(t){return new Lab(this.l+18*(null==t?1:t),this.a,this.b,this.opacity)},darker:function(t){return new Lab(this.l-18*(null==t?1:t),this.a,this.b,this.opacity)},rgb:function(){var t=(this.l+16)/116,e=isNaN(this.a)?t:t+this.a/500,n=isNaN(this.b)?t:t-this.b/200;return t=u*lab2xyz(t),e=o*lab2xyz(e),n=c*lab2xyz(n),new a.b(xyz2rgb(3.2404542*e-1.5371385*t-.4985314*n),xyz2rgb(-.969266*e+1.8760108*t+.041556*n),xyz2rgb(.0556434*e-.2040259*t+1.0572252*n),this.opacity)}})),Object(r.a)(Hcl,hcl,Object(r.b)(a.a,{brighter:function(t){return new Hcl(this.h,this.c,this.l+18*(null==t?1:t),this.opacity)},darker:function(t){return new Hcl(this.h,this.c,this.l-18*(null==t?1:t),this.opacity)},rgb:function(){return labConvert(this).rgb()}}))},function(t,e,n){"use strict";function cubehelixConvert(t){if(t instanceof Cubehelix)return new Cubehelix(t.h,t.s,t.l,t.opacity);t instanceof a.b||(t=Object(a.h)(t));var e=t.r/255,n=t.g/255,r=t.b/255,o=(d*r+l*e-h*n)/(d+l-h),u=r-o,p=(f*(n-o)-c*u)/s,b=Math.sqrt(p*p+u*u)/(f*o*(1-o)),v=b?Math.atan2(p,u)*i.b-120:NaN;return new Cubehelix(v<0?v+360:v,b,o,t.opacity)}function cubehelix(t,e,n,r){return 1===arguments.length?cubehelixConvert(t):new Cubehelix(t,e,n,null==r?1:r)}function Cubehelix(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}e.a=cubehelix;var r=n(20),a=n(19),i=n(41),o=-.14861,u=1.78277,c=-.29227,s=-.90649,f=1.97294,l=f*s,h=f*u,d=u*c-s*o;Object(r.a)(Cubehelix,cubehelix,Object(r.b)(a.a,{brighter:function(t){return t=null==t?a.c:Math.pow(a.c,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a.d:Math.pow(a.d,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=isNaN(this.h)?0:(this.h+120)*i.a,e=+this.l,n=isNaN(this.s)?0:this.s*e*(1-e),r=Math.cos(t),l=Math.sin(t);return new a.b(255*(e+n*(o*r+u*l)),255*(e+n*(c*r+s*l)),255*(e+n*(f*r)),this.opacity)}}))},function(t,e,n){"use strict";function dispatch(){for(var t,e=0,n=arguments.length,r={};e<n;++e){if(!(t=arguments[e]+"")||t in r)throw new Error("illegal type: "+t);r[t]=[]}return new Dispatch(r)}function Dispatch(t){this._=t}function parseTypenames(t,e){return t.trim().split(/^|\s+/).map(function(t){var n="",r=t.indexOf(".");if(r>=0&&(n=t.slice(r+1),t=t.slice(0,r)),t&&!e.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:n}})}function get(t,e){for(var n,r=0,a=t.length;r<a;++r)if((n=t[r]).name===e)return n.value}function set(t,e,n){for(var a=0,i=t.length;a<i;++a)if(t[a].name===e){t[a]=r,t=t.slice(0,a).concat(t.slice(a+1));break}return null!=n&&t.push({name:e,value:n}),t}var r={value:function(){}};Dispatch.prototype=dispatch.prototype={constructor:Dispatch,on:function(t,e){var n,r=this._,a=parseTypenames(t+"",r),i=-1,o=a.length;{if(!(arguments.length<2)){if(null!=e&&"function"!=typeof e)throw new Error("invalid callback: "+e);for(;++i<o;)if(n=(t=a[i]).type)r[n]=set(r[n],t.name,e);else if(null==e)for(n in r)r[n]=set(r[n],t.name,null);return this}for(;++i<o;)if((n=(t=a[i]).type)&&(n=get(r[n],t.name)))return n}},copy:function(){var t={},e=this._;for(var n in e)t[n]=e[n].slice();return new Dispatch(t)},call:function(t,e){if((n=arguments.length-2)>0)for(var n,r,a=new Array(n),i=0;i<n;++i)a[i]=arguments[i+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(r=this._[t],i=0,n=r.length;i<n;++i)r[i].value.apply(e,a)},apply:function(t,e,n){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],a=0,i=r.length;a<i;++a)r[a].value.apply(e,n)}},e.a=dispatch},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(o.a)(t),a=r.format,i=r.formatPrefix,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),e.a=defaultLocale;var r,a,i,o=n(42);defaultLocale({decimal:".",thousands:",",grouping:[3],currency:["$",""]})},function(t,e,n){"use strict";e.a=function(t,e){return function(n,r){for(var a=n.length,i=[],o=0,u=t[0],c=0;a>0&&u>0&&(c+u+1>r&&(u=Math.max(1,r-c)),i.push(n.substring(a-=u,a+u)),!((c+=u+1)>r));)u=t[o=(o+1)%t.length];return i.reverse().join(e)}}},function(t,e,n){"use strict";e.a=function(t){return function(e){return e.replace(/[0-9]/g,function(e){return t[+e]})}}},function(t,e,n){"use strict";e.a=function(t,e){t=t.toPrecision(e);t:for(var n,r=t.length,a=1,i=-1;a<r;++a)switch(t[a]){case".":i=n=a;break;case"0":0===i&&(i=a),n=a;break;case"e":break t;default:i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t,e){var n=Object(r.a)(t,e);if(!n)return t+"";var a=n[0],i=n[1];return i<0?"0."+new Array(-i).join("0")+a:a.length>i+1?a.slice(0,i+1)+"."+a.slice(i+1):a+new Array(i-a.length+2).join("0")}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(13);e.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3)))-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return t=Math.abs(t),e=Math.abs(e)-t,Math.max(0,Object(r.a)(e)-Object(r.a)(t))+1}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(217);n.d(e,"nest",function(){return r.a});var a=n(218);n.d(e,"set",function(){return a.a});var i=n(38);n.d(e,"map",function(){return i.a});var o=n(219);n.d(e,"keys",function(){return o.a});var u=n(220);n.d(e,"values",function(){return u.a});var c=n(221);n.d(e,"entries",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return Math.round(t+e*n)}}},function(t,e,n){"use strict";function interpolateTransform(t,e,n,a){function pop(t){return t.length?t.pop()+" ":""}function translate(t,a,i,o,u,c){if(t!==i||a!==o){var s=u.push("translate(",null,e,null,n);c.push({i:s-4,x:Object(r.a)(t,i)},{i:s-2,x:Object(r.a)(a,o)})}else(i||o)&&u.push("translate("+i+e+o+n)}function rotate(t,e,n,i){t!==e?(t-e>180?e+=360:e-t>180&&(t+=360),i.push({i:n.push(pop(n)+"rotate(",null,a)-2,x:Object(r.a)(t,e)})):e&&n.push(pop(n)+"rotate("+e+a)}function skewX(t,e,n,i){t!==e?i.push({i:n.push(pop(n)+"skewX(",null,a)-2,x:Object(r.a)(t,e)}):e&&n.push(pop(n)+"skewX("+e+a)}function scale(t,e,n,a,i,o){if(t!==n||e!==a){var u=i.push(pop(i)+"scale(",null,",",null,")");o.push({i:u-4,x:Object(r.a)(t,n)},{i:u-2,x:Object(r.a)(e,a)})}else 1===n&&1===a||i.push(pop(i)+"scale("+n+","+a+")")}return function(e,n){var r=[],a=[];return e=t(e),n=t(n),translate(e.translateX,e.translateY,n.translateX,n.translateY,r,a),rotate(e.rotate,n.rotate,r,a),skewX(e.skewX,n.skewX,r,a),scale(e.scaleX,e.scaleY,n.scaleX,n.scaleY,r,a),e=n=null,function(t){for(var e,n=-1,i=a.length;++n<i;)r[(e=a[n]).i]=e.x(t);return r.join("")}}}n.d(e,"a",function(){return i}),n.d(e,"b",function(){return o});var r=n(15),a=n(117),i=interpolateTransform(a.a,"px, ","px)","deg)"),o=interpolateTransform(a.b,", ",")",")")},function(t,e,n){"use strict";function parseCss(t){return"none"===t?u.b:(r||(r=document.createElement("DIV"),a=document.documentElement,i=document.defaultView),r.style.transform=t,t=i.getComputedStyle(a.appendChild(r),null).getPropertyValue("transform"),a.removeChild(r),t=t.slice(7,-1).split(","),Object(u.a)(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}function parseSvg(t){return null==t?u.b:(o||(o=document.createElementNS("http://www.w3.org/2000/svg","g")),o.setAttribute("transform",t),(t=o.transform.baseVal.consolidate())?(t=t.matrix,Object(u.a)(t.a,t.b,t.c,t.d,t.e,t.f)):u.b)}e.a=parseCss,e.b=parseSvg;var r,a,i,o,u=n(118)},function(t,e,n){"use strict";n.d(e,"b",function(){return a});var r=180/Math.PI,a={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};e.a=function(t,e,n,a,i,o){var u,c,s;return(u=Math.sqrt(t*t+e*e))&&(t/=u,e/=u),(s=t*n+e*a)&&(n-=t*s,a-=e*s),(c=Math.sqrt(n*n+a*a))&&(n/=c,a/=c,s/=c),t*a<e*n&&(t=-t,e=-e,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(e,t)*r,skewX:Math.atan(s)*r,scaleX:u,scaleY:c}}},function(t,e,n){"use strict";function cosh(t){return((t=Math.exp(t))+1/t)/2}function sinh(t){return((t=Math.exp(t))-1/t)/2}function tanh(t){return((t=Math.exp(2*t))-1)/(t+1)}var r=Math.SQRT2;e.a=function(t,e){var n,a,i=t[0],o=t[1],u=t[2],c=e[0],s=e[1],f=e[2],l=c-i,h=s-o,d=l*l+h*h;if(d<1e-12)a=Math.log(f/u)/r,n=function(t){return[i+t*l,o+t*h,u*Math.exp(r*t*a)]};else{var p=Math.sqrt(d),b=(f*f-u*u+4*d)/(2*u*2*p),v=(f*f-u*u-4*d)/(2*f*2*p),m=Math.log(Math.sqrt(b*b+1)-b),y=Math.log(Math.sqrt(v*v+1)-v);a=(y-m)/r,n=function(t){var e=t*a,n=cosh(m),c=u/(2*p)*(n*tanh(r*e+m)-sinh(m));return[i+c*l,o+c*h,u*n/cosh(r*e+m)]}}return n.duration=1e3*a,n}},function(t,e,n){"use strict";function hsl(t){return function(e,n){var i=t((e=Object(r.hsl)(e)).h,(n=Object(r.hsl)(n)).h),o=Object(a.a)(e.s,n.s),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.s=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hsl(a.c);var i=hsl(a.a)},function(t,e,n){"use strict";function lab(t,e){var n=Object(a.a)((t=Object(r.lab)(t)).l,(e=Object(r.lab)(e)).l),i=Object(a.a)(t.a,e.a),o=Object(a.a)(t.b,e.b),u=Object(a.a)(t.opacity,e.opacity);return function(e){return t.l=n(e),t.a=i(e),t.b=o(e),t.opacity=u(e),t+""}}e.a=lab;var r=n(4),a=n(11)},function(t,e,n){"use strict";function hcl(t){return function(e,n){var i=t((e=Object(r.hcl)(e)).h,(n=Object(r.hcl)(n)).h),o=Object(a.a)(e.c,n.c),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.c=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hcl(a.c);var i=hcl(a.a)},function(t,e,n){"use strict";function cubehelix(t){return function cubehelixGamma(e){function cubehelix(n,i){var o=t((n=Object(r.cubehelix)(n)).h,(i=Object(r.cubehelix)(i)).h),u=Object(a.a)(n.s,i.s),c=Object(a.a)(n.l,i.l),s=Object(a.a)(n.opacity,i.opacity);return function(t){return n.h=o(t),n.s=u(t),n.l=c(Math.pow(t,e)),n.opacity=s(t),n+""}}return e=+e,cubehelix.gamma=cubehelixGamma,cubehelix}(1)}n.d(e,"a",function(){return i});var r=n(4),a=n(11);e.b=cubehelix(a.c);var i=cubehelix(a.a)},function(t,e,n){"use strict";e.a=function(t,e){for(var n=new Array(e),r=0;r<e;++r)n[r]=t(r/(e-1));return n}},function(t,e,n){"use strict";function local(){return new Local}function Local(){this._="@"+(++r).toString(36)}e.a=local;var r=0;Local.prototype=local.prototype={constructor:Local,get:function(t){for(var e=this._;!(e in t);)if(!(t=t.parentNode))return;return t[e]},set:function(t,e){return t[this._]=e},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t){var e=Object(r.a)();return e.changedTouches&&(e=e.changedTouches[0]),Object(a.a)(t,e)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,e,n){"use strict";var r=n(1),a=n(31);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c,s=e[o],f=s.length,l=i[o]=new Array(f),h=0;h<f;++h)(u=s[h])&&(c=t.call(u,u.__data__,h,s))&&("__data__"in u&&(c.__data__=u.__data__),l[h]=c);return new r.a(i,this._parents)}},function(t,e,n){"use strict";var r=n(1),a=n(54);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=[],o=[],u=0;u<n;++u)for(var c,s=e[u],f=s.length,l=0;l<f;++l)(c=s[l])&&(i.push(t.call(c,c.__data__,l,s)),o.push(c));return new r.a(i,o)}},function(t,e,n){"use strict";var r=n(1),a=n(53);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new r.a(i,this._parents)}},function(t,e,n){"use strict";function bindIndex(t,e,n,r,i,o){for(var u,c=0,s=e.length,f=o.length;c<f;++c)(u=e[c])?(u.__data__=o[c],r[c]=u):n[c]=new a.a(t,o[c]);for(;c<s;++c)(u=e[c])&&(i[c]=u)}function bindKey(t,e,n,r,i,u,c){var s,f,l,h={},d=e.length,p=u.length,b=new Array(d);for(s=0;s<d;++s)(f=e[s])&&(b[s]=l=o+c.call(f,f.__data__,s,e),l in h?i[s]=f:h[l]=f);for(s=0;s<p;++s)l=o+c.call(t,u[s],s,u),(f=h[l])?(r[s]=f,f.__data__=u[s],h[l]=null):n[s]=new a.a(t,u[s]);for(s=0;s<d;++s)(f=e[s])&&h[b[s]]===f&&(i[s]=f)}var r=n(1),a=n(55),i=n(132),o="$";e.a=function(t,e){if(!t)return b=new Array(this.size()),l=-1,this.each(function(t){b[++l]=t}),b;var n=e?bindKey:bindIndex,a=this._parents,o=this._groups;"function"!=typeof t&&(t=Object(i.a)(t));for(var u=o.length,c=new Array(u),s=new Array(u),f=new Array(u),l=0;l<u;++l){var h=a[l],d=o[l],p=d.length,b=t.call(h,h&&h.__data__,l,a),v=b.length,m=s[l]=new Array(v),y=c[l]=new Array(v);n(h,d,m,y,f[l]=new Array(p),b,e);for(var g,_,x=0,w=0;x<v;++x)if(g=m[x]){for(x>=w&&(w=x+1);!(_=y[w])&&++w<v;);g._next=_||null}}return c=new r.a(c,a),c._enter=s,c._exit=f,c}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(56),a=n(1);e.a=function(){return new a.a(this._exit||this._groups.map(r.a),this._parents)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents)}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=-1,n=t.length;++e<n;)for(var r,a=t[e],i=a.length-1,o=a[i];--i>=0;)(r=a[i])&&(o&&o!==r.nextSibling&&o.parentNode.insertBefore(r,o),o=r);return this}},function(t,e,n){"use strict";function ascending(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}var r=n(1);e.a=function(t){function compareNode(e,n){return e&&n?t(e.__data__,n.__data__):!e-!n}t||(t=ascending);for(var e=this._groups,n=e.length,a=new Array(n),i=0;i<n;++i){for(var o,u=e[i],c=u.length,s=a[i]=new Array(c),f=0;f<c;++f)(o=u[f])&&(s[f]=o);s.sort(compareNode)}return new r.a(a,this._parents).order()}},function(t,e,n){"use strict";e.a=function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}},function(t,e,n){"use strict";e.a=function(){var t=new Array(this.size()),e=-1;return this.each(function(){t[++e]=this}),t}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=0,n=t.length;e<n;++e)for(var r=t[e],a=0,i=r.length;a<i;++a){var o=r[a];if(o)return o}return null}},function(t,e,n){"use strict";e.a=function(){var t=0;return this.each(function(){++t}),t}},function(t,e,n){"use strict";e.a=function(){return!this.node()}},function(t,e,n){"use strict";e.a=function(t){for(var e=this._groups,n=0,r=e.length;n<r;++n)for(var a,i=e[n],o=0,u=i.length;o<u;++o)(a=i[o])&&t.call(a,a.__data__,o,i);return this}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e){return function(){this.setAttribute(t,e)}}function attrConstantNS(t,e){return function(){this.setAttributeNS(t.space,t.local,e)}}function attrFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttribute(t):this.setAttribute(t,n)}}function attrFunctionNS(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,n)}}var r=n(26);e.a=function(t,e){var n=Object(r.a)(t);if(arguments.length<2){var a=this.node();return n.local?a.getAttributeNS(n.space,n.local):a.getAttribute(n)}return this.each((null==e?n.local?attrRemoveNS:attrRemove:"function"==typeof e?n.local?attrFunctionNS:attrFunction:n.local?attrConstantNS:attrConstant)(n,e))}},function(t,e,n){"use strict";function propertyRemove(t){return function(){delete this[t]}}function propertyConstant(t,e){return function(){this[t]=e}}function propertyFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?delete this[t]:this[t]=n}}e.a=function(t,e){return arguments.length>1?this.each((null==e?propertyRemove:"function"==typeof e?propertyFunction:propertyConstant)(t,e)):this.node()[t]}},function(t,e,n){"use strict";function classArray(t){return t.trim().split(/^|\s+/)}function classList(t){return t.classList||new ClassList(t)}function ClassList(t){this._node=t,this._names=classArray(t.getAttribute("class")||"")}function classedAdd(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.add(e[r])}function classedRemove(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.remove(e[r])}function classedTrue(t){return function(){classedAdd(this,t)}}function classedFalse(t){return function(){classedRemove(this,t)}}function classedFunction(t,e){return function(){(e.apply(this,arguments)?classedAdd:classedRemove)(this,t)}}ClassList.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var e=this._names.indexOf(t);e>=0&&(this._names.splice(e,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}},e.a=function(t,e){var n=classArray(t+"");if(arguments.length<2){for(var r=classList(this.node()),a=-1,i=n.length;++a<i;)if(!r.contains(n[a]))return!1;return!0}return this.each(("function"==typeof e?classedFunction:e?classedTrue:classedFalse)(n,e))}},function(t,e,n){"use strict";function textRemove(){this.textContent=""}function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t.apply(this,arguments);this.textContent=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?textRemove:("function"==typeof t?textFunction:textConstant)(t)):this.node().textContent}},function(t,e,n){"use strict";function htmlRemove(){this.innerHTML=""}function htmlConstant(t){return function(){this.innerHTML=t}}function htmlFunction(t){return function(){var e=t.apply(this,arguments);this.innerHTML=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?htmlRemove:("function"==typeof t?htmlFunction:htmlConstant)(t)):this.node().innerHTML}},function(t,e,n){"use strict";function raise(){this.nextSibling&&this.parentNode.appendChild(this)}e.a=function(){return this.each(raise)}},function(t,e,n){"use strict";function lower(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}e.a=function(){return this.each(lower)}},function(t,e,n){"use strict";var r=n(25);e.a=function(t){var e="function"==typeof t?t:Object(r.a)(t);return this.select(function(){return this.appendChild(e.apply(this,arguments))})}},function(t,e,n){"use strict";function constantNull(){return null}var r=n(25),a=n(31);e.a=function(t,e){var n="function"==typeof t?t:Object(r.a)(t),i=null==e?constantNull:"function"==typeof e?e:Object(a.a)(e);return this.select(function(){return this.insertBefore(n.apply(this,arguments),i.apply(this,arguments)||null)})}},function(t,e,n){"use strict";function remove(){var t=this.parentNode;t&&t.removeChild(this)}e.a=function(){return this.each(remove)}},function(t,e,n){"use strict";e.a=function(t){return arguments.length?this.property("__data__",t):this.node().__data__}},function(t,e,n){"use strict";function dispatchEvent(t,e,n){var a=Object(r.a)(t),i=a.CustomEvent;"function"==typeof i?i=new i(e,n):(i=a.document.createEvent("Event"),n?(i.initEvent(e,n.bubbles,n.cancelable),i.detail=n.detail):i.initEvent(e,!1,!1)),t.dispatchEvent(i)}function dispatchConstant(t,e){return function(){return dispatchEvent(this,t,e)}}function dispatchFunction(t,e){return function(){return dispatchEvent(this,t,e.apply(this,arguments))}}var r=n(32);e.a=function(t,e){return this.each(("function"==typeof e?dispatchFunction:dispatchConstant)(t,e))}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([document.querySelectorAll(t)],[document.documentElement]):new r.a([null==t?[]:t],r.c)}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e,n){arguments.length<3&&(n=e,e=Object(r.a)().changedTouches);for(var i,o=0,u=e?e.length:0;o<u;++o)if((i=e[o]).identifier===n)return Object(a.a)(t,i);return null}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e){null==e&&(e=Object(r.a)().touches);for(var n=0,i=e?e.length:0,o=new Array(i);n<i;++n)o[n]=Object(a.a)(t,e[n]);return o}},function(t,e,n){"use strict";var r=n(3),a=n(159),i=n(162);r.selection.prototype.interrupt=a.a,r.selection.prototype.transition=i.a},function(t,e,n){"use strict";var r=n(58);e.a=function(t){return this.each(function(){Object(r.a)(this,t)})}},function(t,e,n){"use strict";var r=n(33);e.a=function(t,e,n){var a=new r.a;return e=null==e?0:+e,a.restart(function(n){a.stop(),t(n+e)},e,n),a}},function(t,e,n){"use strict";n(33)},function(t,e,n){"use strict";function inherit(t,e){for(var n;!(n=t.__transition)||!(n=n[e]);)if(!(t=t.parentNode))return u.time=Object(o.a)(),u;return n}var r=n(7),a=n(2),i=n(65),o=n(59),u={time:null,delay:0,duration:250,ease:i.easeCubicInOut};e.a=function(t){var e,n;t instanceof r.a?(e=t._id,t=t._name):(e=Object(r.c)(),(n=u).time=Object(o.a)(),t=null==t?null:t+"");for(var i=this._groups,c=i.length,s=0;s<c;++s)for(var f,l=i[s],h=l.length,d=0;d<h;++d)(f=l[d])&&Object(a.e)(f,t,e,d,l,n||inherit(f,e));return new r.a(i,this._parents,t,e)}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e,n){var r,a;return function(){var i=this.getAttribute(t);return i===n?null:i===r?a:a=e(r=i,n)}}function attrConstantNS(t,e,n){var r,a;return function(){var i=this.getAttributeNS(t.space,t.local);return i===n?null:i===r?a:a=e(r=i,n)}}function attrFunction(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttribute(t):(o=this.getAttribute(t),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}function attrFunctionNS(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttributeNS(t.space,t.local):(o=this.getAttributeNS(t.space,t.local),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e){var n=Object(a.namespace)(t),u="transform"===n?r.interpolateTransformSvg:o.a;return this.attrTween(t,"function"==typeof e?(n.local?attrFunctionNS:attrFunction)(n,u,Object(i.b)(this,"attr."+t,e)):null==e?(n.local?attrRemoveNS:attrRemove)(n):(n.local?attrConstantNS:attrConstant)(n,u,e+""))}},function(t,e,n){"use strict";function attrTweenNS(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttributeNS(t.space,t.local,r(e))}}return tween._value=e,tween}function attrTween(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttribute(t,r(e))}}return tween._value=e,tween}var r=n(3);e.a=function(t,e){var n="attr."+t;if(arguments.length<2)return(n=this.tween(n))&&n._value;if(null==e)return this.tween(n,null);if("function"!=typeof e)throw new Error;var a=Object(r.namespace)(t);return this.tween(n,(a.local?attrTweenNS:attrTween)(a,e))}},function(t,e,n){"use strict";function delayFunction(t,e){return function(){Object(r.g)(this,t).delay=+e.apply(this,arguments)}}function delayConstant(t,e){return e=+e,function(){Object(r.g)(this,t).delay=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?delayFunction:delayConstant)(e,t)):Object(r.f)(this.node(),e).delay}},function(t,e,n){"use strict";function durationFunction(t,e){return function(){Object(r.h)(this,t).duration=+e.apply(this,arguments)}}function durationConstant(t,e){return e=+e,function(){Object(r.h)(this,t).duration=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?durationFunction:durationConstant)(e,t)):Object(r.f)(this.node(),e).duration}},function(t,e,n){"use strict";function easeConstant(t,e){if("function"!=typeof e)throw new Error;return function(){Object(r.h)(this,t).ease=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(easeConstant(e,t)):Object(r.f)(this.node(),e).ease}},function(t,e,n){"use strict";var r=n(3),a=n(7);e.a=function(t){"function"!=typeof t&&(t=Object(r.matcher)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new a.a(i,this._parents,this._name,this._id)}},function(t,e,n){"use strict";var r=n(7);e.a=function(t){if(t._id!==this._id)throw new Error;for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents,this._name,this._id)}},function(t,e,n){"use strict";function start(t){return(t+"").trim().split(/^|\s+/).every(function(t){var e=t.indexOf(".");return e>=0&&(t=t.slice(0,e)),!t||"start"===t})}function onFunction(t,e,n){var a,i,o=start(e)?r.g:r.h;return function(){var r=o(this,t),u=r.on;u!==a&&(i=(a=u).copy()).on(e,n),r.on=i}}var r=n(2);e.a=function(t,e){var n=this._id;return arguments.length<2?Object(r.f)(this.node(),n).on.on(t):this.each(onFunction(n,t,e))}},function(t,e,n){"use strict";function removeFunction(t){return function(){var e=this.parentNode;for(var n in this.__transition)if(+n!==t)return;e&&e.removeChild(this)}}e.a=function(){return this.on("end.remove",removeFunction(this._id))}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selector)(t));for(var o=this._groups,u=o.length,c=new Array(u),s=0;s<u;++s)for(var f,l,h=o[s],d=h.length,p=c[s]=new Array(d),b=0;b<d;++b)(f=h[b])&&(l=t.call(f,f.__data__,b,h))&&("__data__"in f&&(l.__data__=f.__data__),p[b]=l,Object(i.e)(p[b],e,n,b,p,Object(i.f)(f,n)));return new a.a(c,this._parents,e,n)}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selectorAll)(t));for(var o=this._groups,u=o.length,c=[],s=[],f=0;f<u;++f)for(var l,h=o[f],d=h.length,p=0;p<d;++p)if(l=h[p]){for(var b,v=t.call(l,l.__data__,p,h),m=Object(i.f)(l,n),y=0,g=v.length;y<g;++y)(b=v[y])&&Object(i.e)(b,e,n,y,v,m);c.push(v),s.push(l)}return new a.a(c,s,e,n)}},function(t,e,n){"use strict";var r=n(3),a=r.selection.prototype.constructor;e.a=function(){return new a(this._groups,this._parents)}},function(t,e,n){"use strict";function styleRemove(t,e){var n,r,i;return function(){var o=Object(a.style)(this,t),u=(this.style.removeProperty(t),Object(a.style)(this,t));return o===u?null:o===n&&u===r?i:i=e(n=o,r=u)}}function styleRemoveEnd(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){var r,i;return function(){var o=Object(a.style)(this,t);return o===n?null:o===r?i:i=e(r=o,n)}}function styleFunction(t,e,n){var r,i,o;return function(){var u=Object(a.style)(this,t),c=n(this);return null==c&&(this.style.removeProperty(t),c=Object(a.style)(this,t)),u===c?null:u===r&&c===i?o:o=e(r=u,i=c)}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e,n){var a="transform"==(t+="")?r.interpolateTransformCss:o.a;return null==e?this.styleTween(t,styleRemove(t,a)).on("end.style."+t,styleRemoveEnd(t)):this.styleTween(t,"function"==typeof e?styleFunction(t,a,Object(i.b)(this,"style."+t,e)):styleConstant(t,a,e+""),n)}},function(t,e,n){"use strict";function styleTween(t,e,n){function tween(){var r=this,a=e.apply(r,arguments);return a&&function(e){r.style.setProperty(t,a(e),n)}}return tween._value=e,tween}e.a=function(t,e,n){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==e)return this.tween(r,null);if("function"!=typeof e)throw new Error;return this.tween(r,styleTween(t,e,null==n?"":n))}},function(t,e,n){"use strict";function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t(this);this.textContent=null==e?"":e}}var r=n(17);e.a=function(t){return this.tween("text","function"==typeof t?textFunction(Object(r.b)(this,"text",t)):textConstant(null==t?"":t+""))}},function(t,e,n){"use strict";var r=n(7),a=n(2);e.a=function(){for(var t=this._name,e=this._id,n=Object(r.c)(),i=this._groups,o=i.length,u=0;u<o;++u)for(var c,s=i[u],f=s.length,l=0;l<f;++l)if(c=s[l]){var h=Object(a.f)(c,e);Object(a.e)(c,t,n,l,s,{time:h.time+h.delay+h.duration,delay:0,duration:h.duration,ease:h.ease})}return new r.a(i,this._parents,t,n)}},function(t,e,n){"use strict";var r=n(7),a=n(2),i=[null];e.a=function(t,e){var n,o,u=t.__transition;if(u){e=null==e?null:e+"";for(o in u)if((n=u[o]).state>a.c&&n.name===e)return new r.a([[t]],i,e,+o)}return null}},,,,,function(t,e,n){"use strict";var r=n(69);e.a=function(t,e,n){var a,i,o,u,c=t.length,s=e.length,f=new Array(c*s);for(null==n&&(n=r.b),a=o=0;a<c;++a)for(u=t[a],i=0;i<s;++i,++o)f[o]=n(u,e[i]);return f}},function(t,e,n){"use strict";e.a=function(t,e){return e<t?-1:e>t?1:e>=t?0:NaN}},function(t,e,n){"use strict";var r=n(73),a=n(67),i=n(187),o=n(72),u=n(188),c=n(74),s=n(75),f=n(76);e.a=function(){function histogram(r){var i,o,u=r.length,f=new Array(u);for(i=0;i<u;++i)f[i]=t(r[i],i,r);var l=e(f),h=l[0],d=l[1],p=n(f,h,d);Array.isArray(p)||(p=Object(s.c)(h,d,p),p=Object(c.a)(Math.ceil(h/p)*p,Math.floor(d/p)*p,p));for(var b=p.length;p[0]<=h;)p.shift(),--b;for(;p[b-1]>d;)p.pop(),--b;var v,m=new Array(b+1);for(i=0;i<=b;++i)v=m[i]=[],v.x0=i>0?p[i-1]:h,v.x1=i<b?p[i]:d;for(i=0;i<u;++i)o=f[i],h<=o&&o<=d&&m[Object(a.c)(p,o,0,b)].push(r[i]);return m}var t=u.a,e=o.a,n=f.a;return histogram.value=function(e){return arguments.length?(t="function"==typeof e?e:Object(i.a)(e),histogram):t},histogram.domain=function(t){return arguments.length?(e="function"==typeof t?t:Object(i.a)([t[0],t[1]]),histogram):e},histogram.thresholds=function(t){return arguments.length?(n="function"==typeof t?t:Array.isArray(t)?Object(i.a)(r.b.call(t)):Object(i.a)(t),histogram):n},histogram}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(73),a=n(10),i=n(12),o=n(36);e.a=function(t,e,n){return t=r.a.call(t,i.a).sort(a.a),Math.ceil((n-e)/(2*(Object(o.a)(t,.75)-Object(o.a)(t,.25))*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";var r=n(70);e.a=function(t,e,n){return Math.ceil((n-e)/(3.5*Object(r.a)(t)*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&n>r&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&n>r&&(r=n);return r}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a=t.length,i=a,o=-1,u=0;if(null==e)for(;++o<a;)isNaN(n=Object(r.a)(t[o]))?--i:u+=n;else for(;++o<a;)isNaN(n=Object(r.a)(e(t[o],o,t)))?--i:u+=n;if(i)return u/i}},function(t,e,n){"use strict";var r=n(10),a=n(12),i=n(36);e.a=function(t,e){var n,o=t.length,u=-1,c=[];if(null==e)for(;++u<o;)isNaN(n=Object(a.a)(t[u]))||c.push(n);else for(;++u<o;)isNaN(n=Object(a.a)(e(t[u],u,t)))||c.push(n);return Object(i.a)(c.sort(r.a),.5)}},function(t,e,n){"use strict";e.a=function(t){for(var e,n,r,a=t.length,i=-1,o=0;++i<a;)o+=t[i].length;for(n=new Array(o);--a>=0;)for(r=t[a],e=r.length;--e>=0;)n[--o]=r[e];return n}},function(t,e,n){"use strict";e.a=function(t,e){for(var n=e.length,r=new Array(n);n--;)r[n]=t[e[n]];return r}},function(t,e,n){"use strict";var r=n(10);e.a=function(t,e){if(n=t.length){var n,a,i=0,o=0,u=t[o];for(null==e&&(e=r.a);++i<n;)(e(a=t[i],u)<0||0!==e(u,u))&&(u=a,o=i);return 0===e(u,u)?o:void 0}}},function(t,e,n){"use strict";e.a=function(t,e,n){for(var r,a,i=(null==n?t.length:n)-(e=null==e?0:+e);i;)a=Math.random()*i--|0,r=t[i+e],t[i+e]=t[a+e],t[a+e]=r;return t}},function(t,e,n){"use strict";e.a=function(t,e){var n,r=t.length,a=-1,i=0;if(null==e)for(;++a<r;)(n=+t[a])&&(i+=n);else for(;++a<r;)(n=+e(t[a],a,t))&&(i+=n);return i}},function(t,e,n){"use strict";var r=n(78);e.a=function(){return Object(r.a)(arguments)}},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(){},function(t,e){t.setTime(+t+e)},function(t,e){return e-t});a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)(function(e){e.setTime(Math.floor(e/t)*t)},function(e,n){e.setTime(+e+n*t)},function(e,n){return(n-e)/t}):a:null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.d)*a.d)},function(t,e){t.setTime(+t+e*a.d)},function(t,e){return(e-t)/a.d},function(t){return t.getUTCSeconds()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.c)*a.c)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){var e=t.getTimezoneOffset()*a.c%a.b;e<0&&(e+=a.b),t.setTime(Math.floor((+t-e)/a.b)*a.b+e)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"a",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.a},function(t){return t.getDate()-1});e.b=i;var o=i.range},function(t,e,n){"use strict";function weekday(t){return Object(r.a)(function(e){e.setDate(e.getDate()-(e.getDay()+7-t)%7),e.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+7*e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=weekday(0),o=weekday(1),u=weekday(2),c=weekday(3),s=weekday(4),f=weekday(5),l=weekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setDate(1),t.setHours(0,0,0,0)},function(t,e){t.setMonth(t.getMonth()+e)},function(t,e){return e.getMonth()-t.getMonth()+12*(e.getFullYear()-t.getFullYear())},function(t){return t.getMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setMonth(0,1),t.setHours(0,0,0,0)},function(t,e){t.setFullYear(t.getFullYear()+e)},function(t,e){return e.getFullYear()-t.getFullYear()},function(t){return t.getFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setFullYear(Math.floor(e.getFullYear()/t)*t),e.setMonth(0,1),e.setHours(0,0,0,0)},function(e,n){e.setFullYear(e.getFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCSeconds(0,0)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getUTCMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCMinutes(0,0,0)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getUTCHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+e)},function(t,e){return(e-t)/a.a},function(t){return t.getUTCDate()-1});e.a=i;var o=i.range},function(t,e,n){"use strict";function utcWeekday(t){return Object(r.a)(function(e){e.setUTCDate(e.getUTCDate()-(e.getUTCDay()+7-t)%7),e.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+7*e)},function(t,e){return(e-t)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=utcWeekday(0),o=utcWeekday(1),u=utcWeekday(2),c=utcWeekday(3),s=utcWeekday(4),f=utcWeekday(5),l=utcWeekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCMonth(t.getUTCMonth()+e)},function(t,e){return e.getUTCMonth()-t.getUTCMonth()+12*(e.getUTCFullYear()-t.getUTCFullYear())},function(t){return t.getUTCMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCFullYear(t.getUTCFullYear()+e)},function(t,e){return e.getUTCFullYear()-t.getUTCFullYear()},function(t){return t.getUTCFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setUTCFullYear(Math.floor(e.getUTCFullYear()/t)*t),e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0)},function(e,n){e.setUTCFullYear(e.getUTCFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";function parseIsoNative(t){var e=new Date(t);return isNaN(e)?null:e}var r=n(80),a=n(37),i=+new Date("2000-01-01T00:00:00.000Z")?parseIsoNative:Object(a.e)(r.b);e.a=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(216);n.d(e,"scaleBand",function(){return r.a}),n.d(e,"scalePoint",function(){return r.b});var a=n(222);n.d(e,"scaleIdentity",function(){return a.a});var i=n(14);n.d(e,"scaleLinear",function(){return i.a});var o=n(224);n.d(e,"scaleLog",function(){return o.a});var u=n(81);n.d(e,"scaleOrdinal",function(){return u.a}),n.d(e,"scaleImplicit",function(){return u.b});var c=n(225);n.d(e,"scalePow",function(){return c.a}),n.d(e,"scaleSqrt",function(){return c.b});var s=n(226);n.d(e,"scaleQuantile",function(){return s.a});var f=n(227);n.d(e,"scaleQuantize",function(){return f.a});var l=n(228);n.d(e,"scaleThreshold",function(){return l.a});var h=n(84);n.d(e,"scaleTime",function(){return h.b});var d=n(229);n.d(e,"scaleUtc",function(){return d.a});var p=n(230);n.d(e,"schemeCategory10",function(){return p.a});var b=n(231);n.d(e,"schemeCategory20b",function(){return b.a});var v=n(232);n.d(e,"schemeCategory20c",function(){return v.a});var m=n(233);n.d(e,"schemeCategory20",function(){return m.a});var y=n(234);n.d(e,"interpolateCubehelixDefault",function(){return y.a});var g=n(235);n.d(e,"interpolateRainbow",function(){return g.b}),n.d(e,"interpolateWarm",function(){return g.c}),n.d(e,"interpolateCool",function(){return g.a});var _=n(236);n.d(e,"interpolateViridis",function(){return _.a}),n.d(e,"interpolateMagma",function(){return _.c}),n.d(e,"interpolateInferno",function(){return _.b}),n.d(e,"interpolatePlasma",function(){return _.d});var x=n(237);n.d(e,"scaleSequential",function(){return x.a})},function(t,e,n){"use strict";function band(){function rescale(){var n=i().length,a=u[1]<u[0],h=u[a-0],d=u[1-a];t=(d-h)/Math.max(1,n-s+2*f),c&&(t=Math.floor(t)),h+=(d-h-t*(n-s))*l,e=t*(1-s),c&&(h=Math.round(h),e=Math.round(e));var p=Object(r.range)(n).map(function(e){return h+t*e});return o(a?p.reverse():p)}var t,e,n=Object(a.a)().unknown(void 0),i=n.domain,o=n.range,u=[0,1],c=!1,s=0,f=0,l=.5;return delete n.unknown,n.domain=function(t){return arguments.length?(i(t),rescale()):i()},n.range=function(t){return arguments.length?(u=[+t[0],+t[1]],rescale()):u.slice()},n.rangeRound=function(t){return u=[+t[0],+t[1]],c=!0,rescale()},n.bandwidth=function(){return e},n.step=function(){return t},n.round=function(t){return arguments.length?(c=!!t,rescale()):c},n.padding=function(t){return arguments.length?(s=f=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingInner=function(t){return arguments.length?(s=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingOuter=function(t){return arguments.length?(f=Math.max(0,Math.min(1,t)),rescale()):f},n.align=function(t){return arguments.length?(l=Math.max(0,Math.min(1,t)),rescale()):l},n.copy=function(){return band().domain(i()).range(u).round(c).paddingInner(s).paddingOuter(f).align(l)},rescale()}function pointish(t){var e=t.copy;return t.padding=t.paddingOuter,delete t.paddingInner,delete t.paddingOuter,t.copy=function(){return pointish(e())},t}function point(){return pointish(band().paddingInner(1))}e.a=band,e.b=point;var r=n(5),a=n(81)},function(t,e,n){"use strict";function createObject(){return{}}function setObject(t,e,n){t[e]=n}function createMap(){return Object(r.a)()}function setMap(t,e,n){t.set(e,n)}var r=n(38);e.a=function(){function apply(n,i,o,u){if(i>=a.length)return null!=t&&n.sort(t),null!=e?e(n):n;for(var c,s,f,l=-1,h=n.length,d=a[i++],p=Object(r.a)(),b=o();++l<h;)(f=p.get(c=d(s=n[l])+""))?f.push(s):p.set(c,[s]);return p.each(function(t,e){u(b,e,apply(t,i,o,u))}),b}function entries(t,n){if(++n>a.length)return t;var r,o=i[n-1];return null!=e&&n>=a.length?r=t.entries():(r=[],t.each(function(t,e){r.push({key:e,values:entries(t,n)})})),null!=o?r.sort(function(t,e){return o(t.key,e.key)}):r}var t,e,n,a=[],i=[];return n={object:function(t){return apply(t,0,createObject,setObject)},map:function(t){return apply(t,0,createMap,setMap)},entries:function(t){return entries(apply(t,0,createMap,setMap),0)},key:function(t){return a.push(t),n},sortKeys:function(t){return i[a.length-1]=t,n},sortValues:function(e){return t=e,n},rollup:function(t){return e=t,n}}}},function(t,e,n){"use strict";function Set(){}function set(t,e){var n=new Set;if(t instanceof Set)t.each(function(t){n.add(t)});else if(t){var r=-1,a=t.length;if(null==e)for(;++r<a;)n.add(t[r]);else for(;++r<a;)n.add(e(t[r],r,t))}return n}var r=n(38),a=r.a.prototype;Set.prototype=set.prototype={constructor:Set,has:a.has,add:function(t){return t+="",this[r.b+t]=t,this},remove:a.remove,clear:a.clear,values:a.keys,size:a.size,empty:a.empty,each:a.each},e.a=set},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(n);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(t[n]);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push({key:n,value:t[n]});return e}},function(t,e,n){"use strict";function identity(){function scale(t){return+t}var t=[0,1];return scale.invert=scale,scale.domain=scale.range=function(e){return arguments.length?(t=r.a.call(e,i.a),scale):t.slice()},scale.copy=function(){return identity().domain(t)},Object(a.b)(scale)}e.a=identity;var r=n(9),a=n(14),i=n(82)},function(t,e,n){"use strict";var r=n(5),a=n(21);e.a=function(t,e,n){var i,o=t[0],u=t[t.length-1],c=Object(r.tickStep)(o,u,null==e?10:e);switch(n=Object(a.formatSpecifier)(null==n?",f":n),n.type){case"s":var s=Math.max(Math.abs(o),Math.abs(u));return null!=n.precision||isNaN(i=Object(a.precisionPrefix)(c,s))||(n.precision=i),Object(a.formatPrefix)(n,s);case"":case"e":case"g":case"p":case"r":null!=n.precision||isNaN(i=Object(a.precisionRound)(c,Math.max(Math.abs(o),Math.abs(u))))||(n.precision=i-("e"===n.type));break;case"f":case"%":null!=n.precision||isNaN(i=Object(a.precisionFixed)(c))||(n.precision=i-2*("%"===n.type))}return Object(a.format)(n)}},function(t,e,n){"use strict";function deinterpolate(t,e){return(e=Math.log(e/t))?function(n){return Math.log(n/t)/e}:Object(i.a)(e)}function reinterpolate(t,e){return t<0?function(n){return-Math.pow(-e,n)*Math.pow(-t,1-n)}:function(n){return Math.pow(e,n)*Math.pow(t,1-n)}}function pow10(t){return isFinite(t)?+("1e"+t):t<0?0:t}function powp(t){return 10===t?pow10:t===Math.E?Math.exp:function(e){return Math.pow(t,e)}}function logp(t){return t===Math.E?Math.log:10===t&&Math.log10||2===t&&Math.log2||(t=Math.log(t),function(e){return Math.log(e)/t})}function reflect(t){return function(e){return-t(-e)}}function log(){function rescale(){return i=logp(n),c=powp(n),e()[0]<0&&(i=reflect(i),c=reflect(c)),t}var t=Object(u.b)(deinterpolate,reinterpolate).domain([1,10]),e=t.domain,n=10,i=logp(10),c=powp(10);return t.base=function(t){return arguments.length?(n=+t,rescale()):n},t.domain=function(t){return arguments.length?(e(t),rescale()):e()},t.ticks=function(t){var a,o=e(),u=o[0],s=o[o.length-1];(a=s<u)&&(d=u,u=s,s=d);var f,l,h,d=i(u),p=i(s),b=null==t?10:+t,v=[];if(!(n%1)&&p-d<b){if(d=Math.round(d)-1,p=Math.round(p)+1,u>0){for(;d<p;++d)for(l=1,f=c(d);l<n;++l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else for(;d<p;++d)for(l=n-1,f=c(d);l>=1;--l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else v=Object(r.ticks)(d,p,Math.min(p-d,b)).map(c);return a?v.reverse():v},t.tickFormat=function(e,r){if(null==r&&(r=10===n?".0e":","),"function"!=typeof r&&(r=Object(a.format)(r)),e===1/0)return r;null==e&&(e=10);var o=Math.max(1,n*e/t.ticks().length);return function(t){var e=t/c(Math.round(i(t)));return e*n<n-.5&&(e*=n),e<=o?r(t):""}},t.nice=function(){return e(Object(o.a)(e(),{floor:function(t){return c(Math.floor(i(t)))},ceil:function(t){return c(Math.ceil(i(t)))}}))},t.copy=function(){return Object(u.a)(t,log().base(n))},t}e.a=log;var r=n(5),a=n(21),i=n(39),o=n(83),u=n(18)},function(t,e,n){"use strict";function raise(t,e){return t<0?-Math.pow(-t,e):Math.pow(t,e)}function pow(){function deinterpolate(e,n){return(n=raise(n,t)-(e=raise(e,t)))?function(r){return(raise(r,t)-e)/n}:Object(r.a)(n)}function reinterpolate(e,n){return n=raise(n,t)-(e=raise(e,t)),function(r){return raise(e+n*r,1/t)}}var t=1,e=Object(i.b)(deinterpolate,reinterpolate),n=e.domain;return e.exponent=function(e){return arguments.length?(t=+e,n(n())):t},e.copy=function(){return Object(i.a)(e,pow().exponent(t))},Object(a.b)(e)}function sqrt(){return pow().exponent(.5)}e.a=pow,e.b=sqrt;var r=n(39),a=n(14),i=n(18)},function(t,e,n){"use strict";function quantile(){function rescale(){var a=0,i=Math.max(1,e.length);for(n=new Array(i-1);++a<i;)n[a-1]=Object(r.quantile)(t,a/i);return scale}function scale(t){if(!isNaN(t=+t))return e[Object(r.bisect)(n,t)]}var t=[],e=[],n=[];return scale.invertExtent=function(r){var a=e.indexOf(r);return a<0?[NaN,NaN]:[a>0?n[a-1]:t[0],a<n.length?n[a]:t[t.length-1]]},scale.domain=function(e){if(!arguments.length)return t.slice();t=[];for(var n,a=0,i=e.length;a<i;++a)null==(n=e[a])||isNaN(n=+n)||t.push(n);return t.sort(r.ascending),rescale()},scale.range=function(t){return arguments.length?(e=a.b.call(t),rescale()):e.slice()},scale.quantiles=function(){return n.slice()},scale.copy=function(){return quantile().domain(t).range(e)},scale}e.a=quantile;var r=n(5),a=n(9)},function(t,e,n){"use strict";function quantize(){function scale(t){if(t<=t)return u[Object(r.bisect)(o,t,0,n)]}function rescale(){var r=-1;for(o=new Array(n);++r<n;)o[r]=((r+1)*e-(r-n)*t)/(n+1);return scale}var t=0,e=1,n=1,o=[.5],u=[0,1];return scale.domain=function(n){return arguments.length?(t=+n[0],e=+n[1],rescale()):[t,e]},scale.range=function(t){return arguments.length?(n=(u=a.b.call(t)).length-1,rescale()):u.slice()},scale.invertExtent=function(r){var a=u.indexOf(r);return a<0?[NaN,NaN]:a<1?[t,o[0]]:a>=n?[o[n-1],e]:[o[a-1],o[a]]},scale.copy=function(){return quantize().domain([t,e]).range(u)},Object(i.b)(scale)}e.a=quantize;var r=n(5),a=n(9),i=n(14)},function(t,e,n){"use strict";function threshold(){function scale(a){if(a<=a)return e[Object(r.bisect)(t,a,0,n)]}var t=[.5],e=[0,1],n=1;return scale.domain=function(r){return arguments.length?(t=a.b.call(r),n=Math.min(t.length,e.length-1),scale):t.slice()},scale.range=function(r){return arguments.length?(e=a.b.call(r),n=Math.min(t.length,e.length-1),scale):e.slice()},scale.invertExtent=function(n){var r=e.indexOf(n);return[t[r-1],t[r]]},scale.copy=function(){return threshold().domain(t).range(e)},scale}e.a=threshold;var r=n(5),a=n(9)},function(t,e,n){"use strict";var r=n(84),a=n(40),i=n(35);e.a=function(){return Object(r.a)(i.utcYear,i.utcMonth,i.utcWeek,i.utcDay,i.utcHour,i.utcMinute,i.utcSecond,i.utcMillisecond,a.utcFormat).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)])}},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5")},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(300,.5,0),Object(r.cubehelix)(-240,.5,1))},function(t,e,n){"use strict";n.d(e,"c",function(){return i}),n.d(e,"a",function(){return o});var r=n(4),a=n(8),i=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(-100,.75,.35),Object(r.cubehelix)(80,1.5,.8)),o=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(260,.75,.35),Object(r.cubehelix)(80,1.5,.8)),u=Object(r.cubehelix)();e.b=function(t){(t<0||t>1)&&(t-=Math.floor(t));var e=Math.abs(t-.5);return u.h=360*t-100,u.s=1.5-1.5*e,u.l=.8-.9*e,u+""}},function(t,e,n){"use strict";function ramp(t){var e=t.length;return function(n){return t[Math.max(0,Math.min(e-1,Math.floor(n*e)))]}}n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"d",function(){return o});var r=n(16);e.a=ramp(Object(r.a)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));var a=ramp(Object(r.a)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),i=ramp(Object(r.a)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),o=ramp(Object(r.a)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"))},function(t,e,n){"use strict";function sequential(t){function scale(r){var i=(r-e)/(n-e);return t(a?Math.max(0,Math.min(1,i)):i)}var e=0,n=1,a=!1;return scale.domain=function(t){return arguments.length?(e=+t[0],n=+t[1],scale):[e,n]},scale.clamp=function(t){return arguments.length?(a=!!t,scale):a},scale.interpolator=function(e){return arguments.length?(t=e,scale):t},scale.copy=function(){return sequential(t).domain([e,n]).clamp(a)},Object(r.b)(scale)}e.a=sequential;var r=n(14)},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,function(t,e,n){"use strict";var r;void 0!==(r=function(t){var e=n(3),r={lineHeight:1.2,smallTextOffset:10,smallTextLineHeightRatio:.9,smallTextRatio:.6,valueClassName:"value",labelClassName:"label"},a=function(t,n,a,i){var o=e.select(i),u=o.text().split(/\s+/).reverse(),c=void 0,s=[],f=0,l=r.lineHeight*r.smallTextLineHeightRatio,h=o.attr("y"),d=parseFloat(o.attr("dy")),p=n*r.smallTextRatio,b=o.text(null).append("tspan").attr("x",t).attr("y",h-5).attr("dy",d+"em").classed(r.valueClassName,!0).style("font-size",n+"px");for(b.text(u.pop()),b=o.append("tspan").classed(r.labelClassName,!0).attr("x",t).attr("y",h+r.smallTextOffset).attr("dy",++f*l+d+"em").style("font-size",p+"px");c=u.pop();)s.push(c),b.text(s.join(" ")),b.node()&&b.node().getComputedTextLength()>a-50&&(s.pop(),b.text(s.join(" ")),s=[c],b=o.append("tspan").classed(r.labelClassName,!0).attr("x",t).attr("y",h+r.smallTextOffset).attr("dy",++f*l+d+"em").text(c).style("font-size",p+"px"))},i=function(t,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2;t.each(function(){var i,o,u,c,s,f,l,h;for(t=e.select(this),i=t.text().split(/\s+/).reverse(),u=[],c=0,s=1.2,f=t.attr("y"),l=parseFloat(t.attr("dy")),h=t.text(null).append("tspan").attr("x",r).attr("y",f).attr("dy",l+"em");o=i.pop();)if(u.push(o),h.text(u.join(" ")),h.node()&&h.node().getComputedTextLength()>n){if(u.pop(),h.text(u.join(" ")),!(c<a-1)){u.push("..."),h.text(u.join(" "));break}u=[o],h=t.append("tspan").attr("x",r).attr("y",f).attr("dy",++c*s+l+"em").text(o),t.classed("adjust-upwards",!0)}})};return{getTextWidth:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:12,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"Arial",r=document.createElement("canvas"),a=r.getContext("2d");return a.font=e+"px "+n,a.measureText(t).width},wrapText:a,wrapTextWithEllipses:i}}.call(e,n,e,t))&&(t.exports=r)},,,,,,,,,function(t,e,n){"use strict";var r;void 0!==(r=function(t){var e=n(21),r=n(215),a=n(3),i=(n(91),n(289)),o=n(89);return function(){function exports(e){e.each(function(e){C=n-t.left-t.right,j=u-t.top-t.bottom,T=e,buildColorScale(),buildSVG(this),m?drawHorizontalLegend():drawVerticalLegend()})}function adjustLines(){var t=k.select(".legend-line").node().getBoundingClientRect().width+f;C-t<=0&&splitInLines(),centerLegendOnSVG()}function buildContainerGroups(){k.append("g").classed("legend-container-group",!0).append("g").classed("legend-group",!0)}function buildColorScale(){g&&(y=r.scaleOrdinal().range(g))}function buildSVG(e){k||(k=a.select(e).append("svg").classed("britechart britechart-legend",!0),buildContainerGroups()),k.select("g.legend-container-group").attr("transform","translate("+t.left+","+t.top+")"),k.attr("width",n).attr("height",u)}function centerLegendOnSVG(){var t=k.select("g.legend-container-group").node().getBoundingClientRect().width+getLineElementMargin(),e=n-t;e>0&&k.select("g.legend-container-group").attr("transform","translate("+e/2+",0)")}function cleanFadedLines(){k.select(".legend-group").selectAll("g.legend-entry").classed(v,!1)}function drawHorizontalLegend(){var t=f;k.select(".legend-group").selectAll("g").remove(),k.select(".legend-group").append("g").classed("legend-line",!0),M=k.select(".legend-line").selectAll("g.legend-entry").data(T),M.enter().append("g").classed("legend-entry",!0).attr("data-item",_).attr("transform",function(e){var n=e.name,r=t,a=j/2,o=a,u=i.getTextWidth(n,c);return t+=f+2*getLineElementMargin()+u,"translate("+r+","+o+")"}).merge(M).append("circle").classed("legend-circle",!0).attr("cx",f/2).attr("cy",l).attr("r",f/2).style("fill",O).style("stroke-width",1),k.select(".legend-group").selectAll("g.legend-entry").append("text").classed("legend-entry-name",!0).text(x).attr("x",getLineElementMargin()).style("font-size",c+"px").style("letter-spacing",s+"px"),k.select(".legend-group").selectAll("g.legend-entry").exit().transition().style("opacity",0).remove(),adjustLines()}function drawVerticalLegend(){M=k.select(".legend-group").selectAll("g.legend-line").data(T),M.enter().append("g").classed("legend-line",!0).append("g").classed("legend-entry",!0).attr("data-item",_).attr("transform",function(t,e){return"translate("+(f+getLineElementMargin())+","+(e+1)*(j/(T.length+1))+")"}).merge(M).append("circle").classed("legend-circle",!0).attr("cx",f/2).attr("cy",l).attr("r",f/2).style("fill",O).style("stroke-width",1),k.select(".legend-group").selectAll("g.legend-line").selectAll("g.legend-entry").append("text").classed("legend-entry-name",!0).text(x).attr("x",getLineElementMargin()).style("font-size",c+"px").style("letter-spacing",s+"px"),k.select(".legend-group").selectAll("g.legend-line").selectAll("g.legend-entry").append("text").classed("legend-entry-value",!0).text(w).attr("x",C-d).style("font-size",c+"px").style("letter-spacing",p+"px").style("text-anchor","end").style("startOffset","100%"),k.select(".legend-group").selectAll("g.legend-line").exit().transition().style("opacity",0).remove()}function fadeLinesBut(t){k.select(".legend-group").selectAll("g.legend-entry").classed(v,!0),k.select('[data-item="'+t+'"]').classed(v,!1)}function getLineElementMargin(){return h*f}function splitInLines(){var t=k.selectAll(".legend-entry"),e=t.size(),n=j/2*1.7,r=k.select(".legend-group").append("g").classed("legend-line",!0).attr("transform","translate(0, "+n+")"),a=t.filter(":nth-child("+e+")");a.attr("transform","translate("+f+",0)"),r.append(function(){return a.node()})}var t={top:5,right:5,bottom:5,left:5},n=320,u=180,c=12,s=.5,f=16,l=-(c-2)/2,h=1.5,d=40,p=.8,b="s",v="is-faded",m=!1,y=void 0,g=o.colorSchemas.britecharts,_=function(t){return t.id},x=function(t){return t.name},w=function(t){var n=t.quantity;return e.format(b)(n)},O=function(t){var e=t.name;return y(e)},M=void 0,C=void 0,j=void 0,T=void 0,k=void 0;return exports.clearHighlight=function(){cleanFadedLines()},exports.colorSchema=function(t){return arguments.length?(g=t,this):g},exports.height=function(t){return arguments.length?(u=t,this):u},exports.highlight=function(t){cleanFadedLines(),fadeLinesBut(t)},exports.isHorizontal=function(t){return arguments.length?(m=t,this):m},exports.margin=function(e){return arguments.length?(t=e,this):t},exports.marginRatio=function(t){return arguments.length?(h=t,this):h},exports.markerSize=function(t){return arguments.length?(f=t,this):f},exports.numberFormat=function(t){return arguments.length?(b=t,this):b},exports.width=function(t){return arguments.length?(n=t,this):n},exports}}.call(e,n,e,t))&&(t.exports=r)}])})},function(t,e,n){"use strict";function _interopRequireDefault(t){return t&&t.__esModule?t:{default:t}}function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},a=function(){function defineProperties(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(t,e,n){return e&&defineProperties(t.prototype,e),n&&defineProperties(t,n),t}}(),i=n(4),o=_interopRequireDefault(i),u=n(6),c=_interopRequireDefault(u),s=n(102),f=_interopRequireDefault(s),l=n(17),h=function(t){function Line(){return _classCallCheck(this,Line),_possibleConstructorReturn(this,(Line.__proto__||Object.getPrototypeOf(Line)).apply(this,arguments))}return _inherits(Line,t),a(Line,[{key:"componentDidMount",value:function(){this.props.shouldShowLoadingState||this._createChart()}},{key:"componentDidUpdate",value:function(){this.props.shouldShowLoadingState||(this._chart?(this._updateChart(),this.props.createTooltip()):this._createChart())}},{key:"componentWillUnmount",value:function(){this.props.chart.destroy(this._rootNode)}},{key:"_createChart",value:function(){this._chart=this.props.chart.create(this._rootNode,this.props.data,this._getChartConfiguration())}},{key:"_updateChart",value:function(){this.props.chart.update(this._rootNode,this.props.data,this._getChartConfiguration(),this._chart)}},{key:"_getChartConfiguration",value:function(){var t=r({},this.props);return delete t.data,delete t.chart,delete t.createTooltip,delete t.shouldShowLoadingState,t}},{key:"_setRef",value:function(t){this._rootNode=t}},{key:"render",value:function(){return(0,l.loadingContainerWrapper)(this.props,this.props.loadingState||this.props.chart.loading(),o.default.createElement("div",{className:"line-container",ref:this._setRef.bind(this)}))}}]),Line}(o.default.Component);h.propTypes={data:c.default.object,axisTimeCombinations:c.default.number,aspectRatio:c.default.number,colorSchema:c.default.arrayOf(c.default.string),dateLabel:c.default.string,grid:c.default.string,height:c.default.number,isAnimated:c.default.bool,lineCurve:c.default.string,lineGradient:c.default.arrayOf(c.default.string),locale:c.default.string,margin:c.default.shape({top:c.default.number,bottom:c.default.number,left:c.default.number,right:c.default.number}),numberFormat:c.default.string,shouldShowLoadingState:c.default.bool,tooltipThreshold:c.default.number,topicLabel:c.default.number,valueLabel:c.default.number,width:c.default.number,xAxisCustomFormat:c.default.string,xAxisFormat:c.default.string,xAxisLabel:c.default.string,xTicks:c.default.number,yAxisLabel:c.default.string,yTicks:c.default.number,customMouseOver:c.default.func,customMouseMove:c.default.func,customMouseOut:c.default.func,chart:c.default.object},h.defaultProps={chart:f.default,createTooltip:function(){return null},shouldShowLoadingState:!1},e.default=h},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(103),a=function(t){return t&&t.__esModule?t:{default:t}}(r),i=n(8),o=n(9),u=n(10),c=n(16),s={};s.create=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=(0,i.select)(t),c=(0,a.default)();return(0,o.validateData)(e),(0,o.validateContainer)(r),(0,o.validateConfiguration)(c,n),r.datum(e).call((0,u.applyConfiguration)(c,n)),c},s.update=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=arguments[3],a=(0,i.select)(t);return(0,o.validateContainer)(a),(0,o.validateConfiguration)(r,n),(0,u.applyConfiguration)(r,n),e&&e.length?((0,o.validateData)(e),a.datum(e).call(r)):a.call(r),r},s.destroy=function(){},s.loading=function(){return c.line},e.default=s},function(t,e,n){!function(e,n){t.exports=n()}(0,function(){return function(t){function __webpack_require__(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,__webpack_require__),r.l=!0,r.exports}var e={};return __webpack_require__.m=t,__webpack_require__.c=e,__webpack_require__.d=function(t,e,n){__webpack_require__.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},__webpack_require__.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return __webpack_require__.d(e,"a",e),e},__webpack_require__.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=299)}([function(t,e,n){"use strict";function newInterval(t,e,n,i){function interval(e){return t(e=new Date(+e)),e}return interval.floor=interval,interval.ceil=function(n){return t(n=new Date(n-1)),e(n,1),t(n),n},interval.round=function(t){var e=interval(t),n=interval.ceil(t);return t-e<n-t?e:n},interval.offset=function(t,n){return e(t=new Date(+t),null==n?1:Math.floor(n)),t},interval.range=function(n,r,a){var i=[];if(n=interval.ceil(n),a=null==a?1:Math.floor(a),!(n<r&&a>0))return i;do{i.push(new Date(+n))}while(e(n,a),t(n),n<r);return i},interval.filter=function(n){return newInterval(function(e){if(e>=e)for(;t(e),!n(e);)e.setTime(e-1)},function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;e(t,-1),!n(t););else for(;--r>=0;)for(;e(t,1),!n(t););})},n&&(interval.count=function(e,i){return r.setTime(+e),a.setTime(+i),t(r),t(a),Math.floor(n(r,a))},interval.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?interval.filter(i?function(e){return i(e)%t==0}:function(e){return interval.count(0,e)%t==0}):interval:null}),interval}e.a=newInterval;var r=new Date,a=new Date},function(t,e,n){"use strict";function Selection(t,e){this._groups=t,this._parents=e}function selection(){return new Selection([[document.documentElement]],E)}n.d(e,"c",function(){return E}),e.a=Selection;var r=n(128),a=n(129),i=n(130),o=n(131),u=n(55),c=n(133),s=n(134),f=n(135),l=n(136),h=n(137),d=n(138),p=n(139),b=n(140),v=n(141),m=n(142),y=n(143),g=n(57),_=n(144),x=n(145),w=n(146),O=n(147),M=n(148),C=n(149),j=n(150),T=n(151),k=n(152),S=n(153),N=n(29),A=n(154),E=[null];Selection.prototype=selection.prototype={constructor:Selection,select:r.a,selectAll:a.a,filter:i.a,data:o.a,enter:u.b,exit:c.a,merge:s.a,order:f.a,sort:l.a,call:h.a,nodes:d.a,node:p.a,size:b.a,empty:v.a,each:m.a,attr:y.a,style:g.a,property:_.a,classed:x.a,text:w.a,html:O.a,raise:M.a,lower:C.a,append:j.a,insert:T.a,remove:k.a,datum:S.a,on:N.b,dispatch:A.a},e.b=selection},function(t,e,n){"use strict";function init(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>u)throw new Error("too late");return n}function set(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>s)throw new Error("too late");return n}function get(t,e){var n=t.__transition;if(!n||!(n=n[e]))throw new Error("too late");return n}function create(t,e,n){function schedule(t){n.state=c,n.timer.restart(start,n.delay,n.time),n.delay<=t&&start(t-n.delay)}function start(o){var u,h,p,b;if(n.state!==c)return stop();for(u in i)if(b=i[u],b.name===n.name){if(b.state===f)return Object(a.b)(start);b.state===l?(b.state=d,b.timer.stop(),b.on.call("interrupt",t,t.__data__,b.index,b.group),delete i[u]):+u<e&&(b.state=d,b.timer.stop(),delete i[u])}if(Object(a.b)(function(){n.state===f&&(n.state=l,n.timer.restart(tick,n.delay,n.time),tick(o))}),n.state=s,n.on.call("start",t,t.__data__,n.index,n.group),n.state===s){for(n.state=f,r=new Array(p=n.tween.length),u=0,h=-1;u<p;++u)(b=n.tween[u].value.call(t,t.__data__,n.index,n.group))&&(r[++h]=b);r.length=h+1}}function tick(e){for(var a=e<n.duration?n.ease.call(null,e/n.duration):(n.timer.restart(stop),n.state=h,1),i=-1,o=r.length;++i<o;)r[i].call(null,a);n.state===h&&(n.on.call("end",t,t.__data__,n.index,n.group),stop())}function stop(){n.state=d,n.timer.stop(),delete i[e];for(var r in i)return;delete t.__transition}var r,i=t.__transition;i[e]=n,n.timer=Object(a.c)(schedule,0,n.time)}n.d(e,"c",function(){return c}),n.d(e,"d",function(){return s}),n.d(e,"b",function(){return h}),n.d(e,"a",function(){return d}),e.g=init,e.h=set,e.f=get;var r=n(66),a=n(59),i=Object(r.dispatch)("start","end","interrupt"),o=[],u=0,c=1,s=2,f=3,l=4,h=5,d=6;e.e=function(t,e,n,r,a,c){var s=t.__transition;if(s){if(n in s)return}else t.__transition={};create(t,n,{name:e,index:r,group:a,on:i,tween:o,time:c.time,delay:c.delay,duration:c.duration,ease:c.ease,timer:null,state:u})}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(25);n.d(e,"creator",function(){return r.a});var a=n(125);n.d(e,"local",function(){return a.a});var i=n(53);n.d(e,"matcher",function(){return i.a});var o=n(126);n.d(e,"mouse",function(){return o.a});var u=n(26);n.d(e,"namespace",function(){return u.a});var c=n(27);n.d(e,"namespaces",function(){return c.a});var s=n(127);n.d(e,"select",function(){return s.a});var f=n(155);n.d(e,"selectAll",function(){return f.a});var l=n(1);n.d(e,"selection",function(){return l.b});var h=n(31);n.d(e,"selector",function(){return h.a});var d=n(54);n.d(e,"selectorAll",function(){return d.a});var p=n(57);n.d(e,"style",function(){return p.b});var b=n(156);n.d(e,"touch",function(){return b.a});var v=n(157);n.d(e,"touches",function(){return v.a});var m=n(32);n.d(e,"window",function(){return m.a});var y=n(29);n.d(e,"event",function(){return y.c}),n.d(e,"customEvent",function(){return y.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(19);n.d(e,"color",function(){return r.e}),n.d(e,"rgb",function(){return r.g}),n.d(e,"hsl",function(){return r.f});var a=n(102);n.d(e,"lab",function(){return a.a}),n.d(e,"hcl",function(){return a.b});var i=n(103);n.d(e,"cubehelix",function(){return i.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(67);n.d(e,"bisect",function(){return r.c}),n.d(e,"bisectRight",function(){return r.b}),n.d(e,"bisectLeft",function(){return r.a});var a=n(10);n.d(e,"ascending",function(){return a.a});var i=n(68);n.d(e,"bisector",function(){return i.a});var o=n(184);n.d(e,"cross",function(){return o.a});var u=n(185);n.d(e,"descending",function(){return u.a});var c=n(70);n.d(e,"deviation",function(){return c.a});var s=n(72);n.d(e,"extent",function(){return s.a});var f=n(186);n.d(e,"histogram",function(){return f.a});var l=n(189);n.d(e,"thresholdFreedmanDiaconis",function(){return l.a});var h=n(190);n.d(e,"thresholdScott",function(){return h.a});var d=n(76);n.d(e,"thresholdSturges",function(){return d.a});var p=n(191);n.d(e,"max",function(){return p.a});var b=n(192);n.d(e,"mean",function(){return b.a});var v=n(193);n.d(e,"median",function(){return v.a});var m=n(194);n.d(e,"merge",function(){return m.a});var y=n(77);n.d(e,"min",function(){return y.a});var g=n(69);n.d(e,"pairs",function(){return g.a});var _=n(195);n.d(e,"permute",function(){return _.a});var x=n(36);n.d(e,"quantile",function(){return x.a});var w=n(74);n.d(e,"range",function(){return w.a});var O=n(196);n.d(e,"scan",function(){return O.a});var M=n(197);n.d(e,"shuffle",function(){return M.a});var C=n(198);n.d(e,"sum",function(){return C.a});var j=n(75);n.d(e,"ticks",function(){return j.a}),n.d(e,"tickIncrement",function(){return j.b}),n.d(e,"tickStep",function(){return j.c});var T=n(78);n.d(e,"transpose",function(){return T.a});var k=n(71);n.d(e,"variance",function(){return k.a});var S=n(199);n.d(e,"zip",function(){return S.a})},function(t,e,n){"use strict";n.d(e,"d",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"a",function(){return o}),n.d(e,"e",function(){return u});var r=1e3,a=6e4,i=36e5,o=864e5,u=6048e5},function(t,e,n){"use strict";function Transition(t,e,n,r){this._groups=t,this._parents=e,this._name=n,this._id=r}function transition(t){return Object(r.selection)().transition(t)}function newId(){return++x}e.a=Transition,e.b=transition,e.c=newId;var r=n(3),a=n(163),i=n(164),o=n(165),u=n(166),c=n(167),s=n(168),f=n(169),l=n(170),h=n(171),d=n(172),p=n(173),b=n(174),v=n(175),m=n(176),y=n(177),g=n(178),_=n(17),x=0,w=r.selection.prototype;Transition.prototype=transition.prototype={constructor:Transition,select:d.a,selectAll:p.a,filter:s.a,merge:f.a,selection:b.a,transition:g.a,call:w.call,nodes:w.nodes,node:w.node,size:w.size,empty:w.empty,each:w.each,on:l.a,attr:a.a,attrTween:i.a,style:v.a,styleTween:m.a,text:y.a,remove:h.a,tween:_.a,delay:o.a,duration:u.a,ease:c.a}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(23);n.d(e,"interpolate",function(){return r.a});var a=n(49);n.d(e,"interpolateArray",function(){return a.a});var i=n(24);n.d(e,"interpolateBasis",function(){return i.b});var o=n(47);n.d(e,"interpolateBasisClosed",function(){return o.a});var u=n(50);n.d(e,"interpolateDate",function(){return u.a});var c=n(15);n.d(e,"interpolateNumber",function(){return c.a});var s=n(51);n.d(e,"interpolateObject",function(){return s.a});var f=n(115);n.d(e,"interpolateRound",function(){return f.a});var l=n(52);n.d(e,"interpolateString",function(){return l.a});var h=n(116);n.d(e,"interpolateTransformCss",function(){return h.a}),n.d(e,"interpolateTransformSvg",function(){return h.b});var d=n(119);n.d(e,"interpolateZoom",function(){return d.a});var p=n(46);n.d(e,"interpolateRgb",function(){return p.a}),n.d(e,"interpolateRgbBasis",function(){return p.b}),n.d(e,"interpolateRgbBasisClosed",function(){return p.c});var b=n(120);n.d(e,"interpolateHsl",function(){return b.a}),n.d(e,"interpolateHslLong",function(){return b.b});var v=n(121);n.d(e,"interpolateLab",function(){return v.a});var m=n(122);n.d(e,"interpolateHcl",function(){return m.a}),n.d(e,"interpolateHclLong",function(){return m.b});var y=n(123);n.d(e,"interpolateCubehelix",function(){return y.b}),n.d(e,"interpolateCubehelixLong",function(){return y.a});var g=n(124);n.d(e,"quantize",function(){return g.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"b",function(){return i});var r=Array.prototype,a=r.map,i=r.slice},function(t,e,n){"use strict";e.a=function(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}},function(t,e,n){"use strict";function linear(t,e){return function(n){return t+n*e}}function exponential(t,e,n){return t=Math.pow(t,n),e=Math.pow(e,n)-t,n=1/n,function(r){return Math.pow(t+r*e,n)}}function hue(t,e){var n=e-t;return n?linear(t,n>180||n<-180?n-360*Math.round(n/360):n):Object(r.a)(isNaN(t)?e:t)}function gamma(t){return 1==(t=+t)?nogamma:function(e,n){return n-e?exponential(e,n,t):Object(r.a)(isNaN(e)?n:e)}}function nogamma(t,e){var n=e-t;return n?linear(t,n):Object(r.a)(isNaN(t)?e:t)}e.c=hue,e.b=gamma,e.a=nogamma;var r=n(48)},function(t,e,n){"use strict";e.a=function(t){return null===t?NaN:+t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t){return t=Object(r.a)(Math.abs(t)),t?t[1]:NaN}},function(t,e,n){"use strict";function linearish(t){var e=t.domain;return t.ticks=function(t){var n=e();return Object(r.ticks)(n[0],n[n.length-1],null==t?10:t)},t.tickFormat=function(t,n){return Object(o.a)(e(),t,n)},t.nice=function(n){null==n&&(n=10);var a,i=e(),o=0,u=i.length-1,c=i[o],s=i[u];return s<c&&(a=c,c=s,s=a,a=o,o=u,u=a),a=Object(r.tickIncrement)(c,s,n),a>0?(c=Math.floor(c/a)*a,s=Math.ceil(s/a)*a,a=Object(r.tickIncrement)(c,s,n)):a<0&&(c=Math.ceil(c*a)/a,s=Math.floor(s*a)/a,a=Object(r.tickIncrement)(c,s,n)),a>0?(i[o]=Math.floor(c/a)*a,i[u]=Math.ceil(s/a)*a,e(i)):a<0&&(i[o]=Math.ceil(c*a)/a,i[u]=Math.floor(s*a)/a,e(i)),t},t}function linear(){var t=Object(i.b)(i.c,a.interpolateNumber);return t.copy=function(){return Object(i.a)(t,linear())},linearish(t)}e.b=linearish,e.a=linear;var r=n(5),a=n(8),i=n(18),o=n(223)},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return t+e*n}}},function(t,e,n){"use strict";e.a=function(t){return t.match(/.{6}/g).map(function(t){return"#"+t})}},function(t,e,n){"use strict";function tweenRemove(t,e){var n,a;return function(){var i=Object(r.h)(this,t),o=i.tween;if(o!==n){a=n=o;for(var u=0,c=a.length;u<c;++u)if(a[u].name===e){a=a.slice(),a.splice(u,1);break}}i.tween=a}}function tweenFunction(t,e,n){var a,i;if("function"!=typeof n)throw new Error;return function(){var o=Object(r.h)(this,t),u=o.tween;if(u!==a){i=(a=u).slice();for(var c={name:e,value:n},s=0,f=i.length;s<f;++s)if(i[s].name===e){i[s]=c;break}s===f&&i.push(c)}o.tween=i}}function tweenValue(t,e,n){var a=t._id;return t.each(function(){var t=Object(r.h)(this,a);(t.value||(t.value={}))[e]=n.apply(this,arguments)}),function(t){return Object(r.f)(t,a).value[e]}}e.b=tweenValue;var r=n(2);e.a=function(t,e){var n=this._id;if(t+="",arguments.length<2){for(var a,i=Object(r.f)(this.node(),n).tween,o=0,u=i.length;o<u;++o)if((a=i[o]).name===t)return a.value;return null}return this.each((null==e?tweenRemove:tweenFunction)(n,t,e))}},function(t,e,n){"use strict";function deinterpolateLinear(t,e){return(e-=t=+t)?function(n){return(n-t)/e}:Object(o.a)(e)}function deinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=e?0:t>=n?1:r(t)}}}function reinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=0?e:t>=1?n:r(t)}}}function bimap(t,e,n,r){var a=t[0],i=t[1],o=e[0],u=e[1];return i<a?(a=n(i,a),o=r(u,o)):(a=n(a,i),o=r(o,u)),function(t){return o(a(t))}}function polymap(t,e,n,a){var i=Math.min(t.length,e.length)-1,o=new Array(i),u=new Array(i),c=-1;for(t[i]<t[0]&&(t=t.slice().reverse(),e=e.slice().reverse());++c<i;)o[c]=n(t[c],t[c+1]),u[c]=a(e[c],e[c+1]);return function(e){var n=Object(r.bisect)(t,e,1,i)-1;return u[n](o[n](e))}}function copy(t,e){return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp())}function continuous(t,e){function rescale(){return n=Math.min(s.length,f.length)>2?polymap:bimap,r=o=null,scale}function scale(e){return(r||(r=n(s,f,h?deinterpolateClamp(t):t,l)))(+e)}var n,r,o,s=c,f=c,l=a.interpolate,h=!1;return scale.invert=function(t){return(o||(o=n(f,s,deinterpolateLinear,h?reinterpolateClamp(e):e)))(+t)},scale.domain=function(t){return arguments.length?(s=i.a.call(t,u.a),rescale()):s.slice()},scale.range=function(t){return arguments.length?(f=i.b.call(t),rescale()):f.slice()},scale.rangeRound=function(t){return f=i.b.call(t),l=a.interpolateRound,rescale()},scale.clamp=function(t){return arguments.length?(h=!!t,rescale()):h},scale.interpolate=function(t){return arguments.length?(l=t,rescale()):l},rescale()}e.c=deinterpolateLinear,e.a=copy,e.b=continuous;var r=n(5),a=n(8),i=n(9),o=n(39),u=n(82),c=[0,1]},function(t,e,n){"use strict";function Color(){}function color(t){var e;return t=(t+"").trim().toLowerCase(),(e=s.exec(t))?(e=parseInt(e[1],16),new Rgb(e>>8&15|e>>4&240,e>>4&15|240&e,(15&e)<<4|15&e,1)):(e=f.exec(t))?rgbn(parseInt(e[1],16)):(e=l.exec(t))?new Rgb(e[1],e[2],e[3],1):(e=h.exec(t))?new Rgb(255*e[1]/100,255*e[2]/100,255*e[3]/100,1):(e=d.exec(t))?rgba(e[1],e[2],e[3],e[4]):(e=p.exec(t))?rgba(255*e[1]/100,255*e[2]/100,255*e[3]/100,e[4]):(e=b.exec(t))?hsla(e[1],e[2]/100,e[3]/100,1):(e=v.exec(t))?hsla(e[1],e[2]/100,e[3]/100,e[4]):m.hasOwnProperty(t)?rgbn(m[t]):"transparent"===t?new Rgb(NaN,NaN,NaN,0):null}function rgbn(t){return new Rgb(t>>16&255,t>>8&255,255&t,1)}function rgba(t,e,n,r){return r<=0&&(t=e=n=NaN),new Rgb(t,e,n,r)}function rgbConvert(t){return t instanceof Color||(t=color(t)),t?(t=t.rgb(),new Rgb(t.r,t.g,t.b,t.opacity)):new Rgb}function rgb(t,e,n,r){return 1===arguments.length?rgbConvert(t):new Rgb(t,e,n,null==r?1:r)}function Rgb(t,e,n,r){this.r=+t,this.g=+e,this.b=+n,this.opacity=+r}function hsla(t,e,n,r){return r<=0?t=e=n=NaN:n<=0||n>=1?t=e=NaN:e<=0&&(t=NaN),new Hsl(t,e,n,r)}function hslConvert(t){if(t instanceof Hsl)return new Hsl(t.h,t.s,t.l,t.opacity);if(t instanceof Color||(t=color(t)),!t)return new Hsl;if(t instanceof Hsl)return t;t=t.rgb();var e=t.r/255,n=t.g/255,r=t.b/255,a=Math.min(e,n,r),i=Math.max(e,n,r),o=NaN,u=i-a,c=(i+a)/2;return u?(o=e===i?(n-r)/u+6*(n<r):n===i?(r-e)/u+2:(e-n)/u+4,u/=c<.5?i+a:2-i-a,o*=60):u=c>0&&c<1?0:o,new Hsl(o,u,c,t.opacity)}function hsl(t,e,n,r){return 1===arguments.length?hslConvert(t):new Hsl(t,e,n,null==r?1:r)}function Hsl(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}function hsl2rgb(t,e,n){return 255*(t<60?e+(n-e)*t/60:t<180?n:t<240?e+(n-e)*(240-t)/60:e)}e.a=Color,n.d(e,"d",function(){return a}),n.d(e,"c",function(){return i}),e.e=color,e.h=rgbConvert,e.g=rgb,e.b=Rgb,e.f=hsl;var r=n(20),a=.7,i=1/a,o="\\s*([+-]?\\d+)\\s*",u="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",s=/^#([0-9a-f]{3})$/,f=/^#([0-9a-f]{6})$/,l=new RegExp("^rgb\\("+[o,o,o]+"\\)$"),h=new RegExp("^rgb\\("+[c,c,c]+"\\)$"),d=new RegExp("^rgba\\("+[o,o,o,u]+"\\)$"),p=new RegExp("^rgba\\("+[c,c,c,u]+"\\)$"),b=new RegExp("^hsl\\("+[u,c,c]+"\\)$"),v=new RegExp("^hsla\\("+[u,c,c,u]+"\\)$"),m={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};Object(r.a)(Color,color,{displayable:function(){return this.rgb().displayable()},toString:function(){return this.rgb()+""}}),Object(r.a)(Rgb,rgb,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return 0<=this.r&&this.r<=255&&0<=this.g&&this.g<=255&&0<=this.b&&this.b<=255&&0<=this.opacity&&this.opacity<=1},toString:function(){var t=this.opacity;return t=isNaN(t)?1:Math.max(0,Math.min(1,t)),(1===t?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}})),Object(r.a)(Hsl,hsl,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),e=isNaN(t)||isNaN(this.s)?0:this.s,n=this.l,r=n+(n<.5?n:1-n)*e,a=2*n-r;return new Rgb(hsl2rgb(t>=240?t-240:t+120,a,r),hsl2rgb(t,a,r),hsl2rgb(t<120?t+240:t-120,a,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1}}))},function(t,e,n){"use strict";function extend(t,e){var n=Object.create(t.prototype);for(var r in e)n[r]=e[r];return n}e.b=extend,e.a=function(t,e,n){t.prototype=e.prototype=n,n.constructor=t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(105);n.d(e,"formatDefaultLocale",function(){return r.a}),n.d(e,"format",function(){return r.b}),n.d(e,"formatPrefix",function(){return r.c});var a=n(42);n.d(e,"formatLocale",function(){return a.a});var i=n(43);n.d(e,"formatSpecifier",function(){return i.a});var o=n(111);n.d(e,"precisionFixed",function(){return o.a});var u=n(112);n.d(e,"precisionPrefix",function(){return u.a});var c=n(113);n.d(e,"precisionRound",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){if((n=(t=e?t.toExponential(e-1):t.toExponential()).indexOf("e"))<0)return null;var n,r=t.slice(0,n);return[r.length>1?r[0]+r.slice(2):r,+t.slice(n+1)]}},function(t,e,n){"use strict";var r=n(4),a=n(46),i=n(49),o=n(50),u=n(15),c=n(51),s=n(52),f=n(48);e.a=function(t,e){var n,l=typeof e;return null==e||"boolean"===l?Object(f.a)(e):("number"===l?u.a:"string"===l?(n=Object(r.color)(e))?(e=n,a.a):s.a:e instanceof r.color?a.a:e instanceof Date?o.a:Array.isArray(e)?i.a:"function"!=typeof e.valueOf&&"function"!=typeof e.toString||isNaN(e)?c.a:u.a)(t,e)}},function(t,e,n){"use strict";function basis(t,e,n,r,a){var i=t*t,o=i*t;return((1-3*t+3*i-o)*e+(4-6*i+3*o)*n+(1+3*t+3*i-3*o)*r+o*a)/6}e.a=basis,e.b=function(t){var e=t.length-1;return function(n){var r=n<=0?n=0:n>=1?(n=1,e-1):Math.floor(n*e),a=t[r],i=t[r+1],o=r>0?t[r-1]:2*a-i,u=r<e-1?t[r+2]:2*i-a;return basis((n-r/e)*e,o,a,i,u)}}},function(t,e,n){"use strict";function creatorInherit(t){return function(){var e=this.ownerDocument,n=this.namespaceURI;return n===a.b&&e.documentElement.namespaceURI===a.b?e.createElement(t):e.createElementNS(n,t)}}function creatorFixed(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}var r=n(26),a=n(27);e.a=function(t){var e=Object(r.a)(t);return(e.local?creatorFixed:creatorInherit)(e)}},function(t,e,n){"use strict";var r=n(27);e.a=function(t){var e=t+="",n=e.indexOf(":");return n>=0&&"xmlns"!==(e=t.slice(0,n))&&(t=t.slice(n+1)),r.a.hasOwnProperty(e)?{space:r.a[e],local:t}:t}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r="http://www.w3.org/1999/xhtml";e.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,e,n){"use strict";var r=n(29);e.a=function(){for(var t,e=r.c;t=e.sourceEvent;)e=t;return e}},function(t,e,n){"use strict";function filterContextListener(t,e,n){return t=contextListener(t,e,n),function(e){var n=e.relatedTarget;n&&(n===this||8&n.compareDocumentPosition(this))||t.call(this,e)}}function contextListener(t,e,n){return function(r){var i=a;a=r;try{t.call(this,this.__data__,e,n)}finally{a=i}}}function parseTypenames(t){return t.trim().split(/^|\s+/).map(function(t){var e="",n=t.indexOf(".");return n>=0&&(e=t.slice(n+1),t=t.slice(0,n)),{type:t,name:e}})}function onRemove(t){return function(){var e=this.__on;if(e){for(var n,r=0,a=-1,i=e.length;r<i;++r)n=e[r],t.type&&n.type!==t.type||n.name!==t.name?e[++a]=n:this.removeEventListener(n.type,n.listener,n.capture);++a?e.length=a:delete this.__on}}}function onAdd(t,e,n){var a=r.hasOwnProperty(t.type)?filterContextListener:contextListener;return function(r,i,o){var u,c=this.__on,s=a(e,i,o);if(c)for(var f=0,l=c.length;f<l;++f)if((u=c[f]).type===t.type&&u.name===t.name)return this.removeEventListener(u.type,u.listener,u.capture),this.addEventListener(u.type,u.listener=s,u.capture=n),void(u.value=e);this.addEventListener(t.type,s,n),u={type:t.type,name:t.name,value:e,listener:s,capture:n},c?c.push(u):this.__on=[u]}}function customEvent(t,e,n,r){var i=a;t.sourceEvent=a,a=t;try{return e.apply(n,r)}finally{a=i}}n.d(e,"c",function(){return a}),e.a=customEvent;var r={},a=null;if("undefined"!=typeof document){"onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"})}e.b=function(t,e,n){var r,a,i=parseTypenames(t+""),o=i.length;{if(!(arguments.length<2)){for(u=e?onAdd:onRemove,null==n&&(n=!1),r=0;r<o;++r)this.each(u(i[r],e,n));return this}var u=this.node().__on;if(u)for(var c,s=0,f=u.length;s<f;++s)for(r=0,c=u[s];r<o;++r)if((a=i[r]).type===c.type&&a.name===c.name)return c.value}}},function(t,e,n){"use strict";e.a=function(t,e){var n=t.ownerSVGElement||t;if(n.createSVGPoint){var r=n.createSVGPoint();return r.x=e.clientX,r.y=e.clientY,r=r.matrixTransform(t.getScreenCTM().inverse()),[r.x,r.y]}var a=t.getBoundingClientRect();return[e.clientX-a.left-t.clientLeft,e.clientY-a.top-t.clientTop]}},function(t,e,n){"use strict";function none(){}e.a=function(t){return null==t?none:function(){return this.querySelector(t)}}},function(t,e,n){"use strict";e.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,e,n){"use strict";function now(){return f||(d(clearNow),f=h.now()+l)}function clearNow(){f=0}function Timer(){this._call=this._time=this._next=null}function timer(t,e,n){var r=new Timer;return r.restart(t,e,n),r}function timerFlush(){now(),++i;for(var t,e=r;e;)(t=f-e._time)>=0&&e._call.call(null,t),e=e._next;--i}function wake(){f=(s=h.now())+l,i=o=0;try{timerFlush()}finally{i=0,nap(),f=0}}function poke(){var t=h.now(),e=t-s;e>c&&(l-=e,s=t)}function nap(){for(var t,e,n=r,i=1/0;n;)n._call?(i>n._time&&(i=n._time),t=n,n=n._next):(e=n._next,n._next=null,n=t?t._next=e:r=e);a=t,sleep(i)}function sleep(t){if(!i){o&&(o=clearTimeout(o));var e=t-f;e>24?(t<1/0&&(o=setTimeout(wake,e)),u&&(u=clearInterval(u))):(u||(s=f,u=setInterval(poke,c)),i=1,d(wake))}}e.b=now,e.a=Timer,e.c=timer;var r,a,i=0,o=0,u=0,c=1e3,s=0,f=0,l=0,h="object"==typeof performance&&performance.now?performance:Date,d="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};Timer.prototype=timer.prototype={constructor:Timer,restart:function(t,e,n){if("function"!=typeof t)throw new TypeError("callback is not a function");n=(null==n?now():+n)+(null==e?0:+e),this._next||a===this||(a?a._next=this:r=this,a=this),this._call=t,this._time=n,sleep()},stop:function(){this._call&&(this._call=null,this._time=1/0,sleep())}}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(0);n.d(e,"timeInterval",function(){return r.a});var a=n(200);n.d(e,"timeMillisecond",function(){return a.a}),n.d(e,"timeMilliseconds",function(){return a.b}),n.d(e,"utcMillisecond",function(){return a.a}),n.d(e,"utcMilliseconds",function(){return a.b});var i=n(201);n.d(e,"timeSecond",function(){return i.a}),n.d(e,"timeSeconds",function(){return i.b}),n.d(e,"utcSecond",function(){return i.a}),n.d(e,"utcSeconds",function(){return i.b});var o=n(202);n.d(e,"timeMinute",function(){return o.a}),n.d(e,"timeMinutes",function(){return o.b});var u=n(203);n.d(e,"timeHour",function(){return u.a}),n.d(e,"timeHours",function(){return u.b});var c=n(204);n.d(e,"timeDay",function(){return c.b}),n.d(e,"timeDays",function(){return c.a});var s=n(205);n.d(e,"timeWeek",function(){return s.g}),n.d(e,"timeWeeks",function(){return s.h}),n.d(e,"timeSunday",function(){return s.g}),n.d(e,"timeSundays",function(){return s.h}),n.d(e,"timeMonday",function(){return s.c}),n.d(e,"timeMondays",function(){return s.d}),n.d(e,"timeTuesday",function(){return s.k}),n.d(e,"timeTuesdays",function(){return s.l}),n.d(e,"timeWednesday",function(){return s.m}),n.d(e,"timeWednesdays",function(){return s.n}),n.d(e,"timeThursday",function(){return s.i}),n.d(e,"timeThursdays",function(){return s.j}),n.d(e,"timeFriday",function(){return s.a}),n.d(e,"timeFridays",function(){return s.b}),n.d(e,"timeSaturday",function(){return s.e}),n.d(e,"timeSaturdays",function(){return s.f});var f=n(206);n.d(e,"timeMonth",function(){return f.a}),n.d(e,"timeMonths",function(){return f.b});var l=n(207);n.d(e,"timeYear",function(){return l.a}),n.d(e,"timeYears",function(){return l.b});var h=n(208);n.d(e,"utcMinute",function(){return h.a}),n.d(e,"utcMinutes",function(){return h.b});var d=n(209);n.d(e,"utcHour",function(){return d.a}),n.d(e,"utcHours",function(){return d.b});var p=n(210);n.d(e,"utcDay",function(){return p.a}),n.d(e,"utcDays",function(){return p.b});var b=n(211);n.d(e,"utcWeek",function(){return b.g}),n.d(e,"utcWeeks",function(){return b.h}),n.d(e,"utcSunday",function(){return b.g}),n.d(e,"utcSundays",function(){return b.h}),n.d(e,"utcMonday",function(){return b.c}),n.d(e,"utcMondays",function(){return b.d}),n.d(e,"utcTuesday",function(){return b.k}),n.d(e,"utcTuesdays",function(){return b.l}),n.d(e,"utcWednesday",function(){return b.m}),n.d(e,"utcWednesdays",function(){return b.n}),n.d(e,"utcThursday",function(){return b.i}),n.d(e,"utcThursdays",function(){return b.j}),n.d(e,"utcFriday",function(){return b.a}),n.d(e,"utcFridays",function(){return b.b}),n.d(e,"utcSaturday",function(){return b.e}),n.d(e,"utcSaturdays",function(){return b.f});var v=n(212);n.d(e,"utcMonth",function(){return v.a}),n.d(e,"utcMonths",function(){return v.b});var m=n(213);n.d(e,"utcYear",function(){return m.a}),n.d(e,"utcYears",function(){return m.b})},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e,n){if(null==n&&(n=r.a),a=t.length){if((e=+e)<=0||a<2)return+n(t[0],0,t);if(e>=1)return+n(t[a-1],a-1,t);var a,i=(a-1)*e,o=Math.floor(i),u=+n(t[o],o,t);return u+(+n(t[o+1],o+1,t)-u)*(i-o)}}},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(c.a)(t),a=r.format,i=r.parse,o=r.utcFormat,u=r.utcParse,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"d",function(){return o}),n.d(e,"e",function(){return u}),e.a=defaultLocale;var r,a,i,o,u,c=n(79);defaultLocale({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,e,n){"use strict";function Map(){}function map(t,e){var n=new Map;if(t instanceof Map)t.each(function(t,e){n.set(e,t)});else if(Array.isArray(t)){var r,a=-1,i=t.length;if(null==e)for(;++a<i;)n.set(a,t[a]);else for(;++a<i;)n.set(e(r=t[a],a,t),r)}else if(t)for(var o in t)n.set(o,t[o]);return n}n.d(e,"b",function(){return r});var r="$";Map.prototype=map.prototype={constructor:Map,has:function(t){return r+t in this},get:function(t){return this[r+t]},set:function(t,e){return this[r+t]=e,this},remove:function(t){var e=r+t;return e in this&&delete this[e]},clear:function(){for(var t in this)t[0]===r&&delete this[t]},keys:function(){var t=[];for(var e in this)e[0]===r&&t.push(e.slice(1));return t},values:function(){var t=[];for(var e in this)e[0]===r&&t.push(this[e]);return t},entries:function(){var t=[];for(var e in this)e[0]===r&&t.push({key:e.slice(1),value:this[e]});return t},size:function(){var t=0;for(var e in this)e[0]===r&&++t;return t},empty:function(){for(var t in this)if(t[0]===r)return!1;return!0},each:function(t){for(var e in this)e[0]===r&&t(this[e],e.slice(1),this)}},e.a=map},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(37);n.d(e,"timeFormatDefaultLocale",function(){return r.a}),n.d(e,"timeFormat",function(){return r.b}),n.d(e,"timeParse",function(){return r.c}),n.d(e,"utcFormat",function(){return r.d}),n.d(e,"utcParse",function(){return r.e});var a=n(79);n.d(e,"timeFormatLocale",function(){return a.a});var i=n(80);n.d(e,"isoFormat",function(){return i.a});var o=n(214);n.d(e,"isoParse",function(){return o.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"b",function(){return a});var r=Math.PI/180,a=180/Math.PI},function(t,e,n){"use strict";var r=n(13),a=n(106),i=n(107),o=n(43),u=n(44),c=n(45),s=n(110),f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];e.a=function(t){function newFormat(t){function format(t){var n,o,u,s=g,d=_;if("c"===y)d=x(t)+d,t="";else{t=+t;var O=t<0;if(t=x(Math.abs(t),m),O&&0==+t&&(O=!1),s=(O?"("===i?i:"-":"-"===i||"("===i?"":i)+s,d=d+("s"===y?f[8+c.b/3]:"")+(O&&"("===i?")":""),w)for(n=-1,o=t.length;++n<o;)if(48>(u=t.charCodeAt(n))||u>57){d=(46===u?l+t.slice(n+1):t.slice(n))+d,t=t.slice(0,n);break}}v&&!p&&(t=e(t,1/0));var M=s.length+t.length+d.length,C=M<b?new Array(b-M+1).join(r):"";switch(v&&p&&(t=e(C+t,C.length?b-d.length:1/0),C=""),a){case"<":t=s+t+d+C;break;case"=":t=s+C+t+d;break;case"^":t=C.slice(0,M=C.length>>1)+s+t+d+C.slice(M);break;default:t=C+s+t+d}return h(t)}t=Object(o.a)(t);var r=t.fill,a=t.align,i=t.sign,s=t.symbol,p=t.zero,b=t.width,v=t.comma,m=t.precision,y=t.type,g="$"===s?n[0]:"#"===s&&/[boxX]/.test(y)?"0"+y.toLowerCase():"",_="$"===s?n[1]:/[%p]/.test(y)?d:"",x=u.a[y],w=!y||/[defgprs%]/.test(y);return m=null==m?y?6:12:/[gprs]/.test(y)?Math.max(1,Math.min(21,m)):Math.max(0,Math.min(20,m)),format.toString=function(){return t+""},format}function formatPrefix(t,e){var n=newFormat((t=Object(o.a)(t),t.type="f",t)),a=3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3))),i=Math.pow(10,-a),u=f[8+a/3];return function(t){return n(i*t)+u}}var e=t.grouping&&t.thousands?Object(a.a)(t.grouping,t.thousands):s.a,n=t.currency,l=t.decimal,h=t.numerals?Object(i.a)(t.numerals):s.a,d=t.percent||"%";return{format:newFormat,formatPrefix:formatPrefix}}},function(t,e,n){"use strict";function formatSpecifier(t){return new FormatSpecifier(t)}function FormatSpecifier(t){if(!(e=a.exec(t)))throw new Error("invalid format: "+t);var e,n=e[1]||" ",i=e[2]||">",o=e[3]||"-",u=e[4]||"",c=!!e[5],s=e[6]&&+e[6],f=!!e[7],l=e[8]&&+e[8].slice(1),h=e[9]||"";"n"===h?(f=!0,h="g"):r.a[h]||(h=""),(c||"0"===n&&"="===i)&&(c=!0,n="0",i="="),this.fill=n,this.align=i,this.sign=o,this.symbol=u,this.zero=c,this.width=s,this.comma=f,this.precision=l,this.type=h}e.a=formatSpecifier;var r=n(44),a=/^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;formatSpecifier.prototype=FormatSpecifier.prototype,FormatSpecifier.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(null==this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(null==this.precision?"":"."+Math.max(0,0|this.precision))+this.type}},function(t,e,n){"use strict";var r=n(108),a=n(45),i=n(109);e.a={"":r.a,"%":function(t,e){return(100*t).toFixed(e)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,e){return t.toExponential(e)},f:function(t,e){return t.toFixed(e)},g:function(t,e){return t.toPrecision(e)},o:function(t){return Math.round(t).toString(8)},p:function(t,e){return Object(i.a)(100*t,e)},r:i.a,s:a.a,X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r,a=n(22);e.a=function(t,e){var n=Object(a.a)(t,e);if(!n)return t+"";var i=n[0],o=n[1],u=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return u===c?i:u>c?i+new Array(u-c+1).join("0"):u>0?i.slice(0,u)+"."+i.slice(u):"0."+new Array(1-u).join("0")+Object(a.a)(t,Math.max(0,e+u-1))[0]}},function(t,e,n){"use strict";function rgbSpline(t){return function(e){var n,a,i=e.length,o=new Array(i),u=new Array(i),c=new Array(i);for(n=0;n<i;++n)a=Object(r.rgb)(e[n]),o[n]=a.r||0,u[n]=a.g||0,c[n]=a.b||0;return o=t(o),u=t(u),c=t(c),a.opacity=1,function(t){return a.r=o(t),a.g=u(t),a.b=c(t),a+""}}}n.d(e,"b",function(){return u}),n.d(e,"c",function(){return c});var r=n(4),a=n(24),i=n(47),o=n(11);e.a=function rgbGamma(t){function rgb(t,n){var a=e((t=Object(r.rgb)(t)).r,(n=Object(r.rgb)(n)).r),i=e(t.g,n.g),u=e(t.b,n.b),c=Object(o.a)(t.opacity,n.opacity);return function(e){return t.r=a(e),t.g=i(e),t.b=u(e),t.opacity=c(e),t+""}}var e=Object(o.b)(t);return rgb.gamma=rgbGamma,rgb}(1);var u=rgbSpline(a.b),c=rgbSpline(i.a)},function(t,e,n){"use strict";var r=n(24);e.a=function(t){var e=t.length;return function(n){var a=Math.floor(((n%=1)<0?++n:n)*e),i=t[(a+e-1)%e],o=t[a%e],u=t[(a+1)%e],c=t[(a+2)%e];return Object(r.a)((n-a/e)*e,i,o,u,c)}}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a=e?e.length:0,i=t?Math.min(a,t.length):0,o=new Array(a),u=new Array(a);for(n=0;n<i;++n)o[n]=Object(r.a)(t[n],e[n]);for(;n<a;++n)u[n]=e[n];return function(t){for(n=0;n<i;++n)u[n]=o[n](t);return u}}},function(t,e,n){"use strict";e.a=function(t,e){var n=new Date;return t=+t,e-=t,function(r){return n.setTime(t+e*r),n}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a={},i={};null!==t&&"object"==typeof t||(t={}),null!==e&&"object"==typeof e||(e={});for(n in e)n in t?a[n]=Object(r.a)(t[n],e[n]):i[n]=e[n];return function(t){for(n in a)i[n]=a[n](t);return i}}},function(t,e,n){"use strict";function zero(t){return function(){return t}}function one(t){return function(e){return t(e)+""}}var r=n(15),a=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,i=new RegExp(a.source,"g");e.a=function(t,e){var n,o,u,c=a.lastIndex=i.lastIndex=0,s=-1,f=[],l=[];for(t+="",e+="";(n=a.exec(t))&&(o=i.exec(e));)(u=o.index)>c&&(u=e.slice(c,u),f[s]?f[s]+=u:f[++s]=u),(n=n[0])===(o=o[0])?f[s]?f[s]+=o:f[++s]=o:(f[++s]=null,l.push({i:s,x:Object(r.a)(n,o)})),c=i.lastIndex;return c<e.length&&(u=e.slice(c),f[s]?f[s]+=u:f[++s]=u),f.length<2?l[0]?one(l[0].x):zero(e):(e=l.length,function(t){for(var n,r=0;r<e;++r)f[(n=l[r]).i]=n.x(t);return f.join("")})}},function(t,e,n){"use strict";var r=function(t){return function(){return this.matches(t)}};if("undefined"!=typeof document){var a=document.documentElement;if(!a.matches){var i=a.webkitMatchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector;r=function(t){return function(){return i.call(this,t)}}}}e.a=r},function(t,e,n){"use strict";function empty(){return[]}e.a=function(t){return null==t?empty:function(){return this.querySelectorAll(t)}}},function(t,e,n){"use strict";function EnterNode(t,e){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=e}e.a=EnterNode;var r=n(56),a=n(1);e.b=function(){return new a.a(this._enter||this._groups.map(r.a),this._parents)},EnterNode.prototype={constructor:EnterNode,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,e){return this._parent.insertBefore(t,e)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}}},function(t,e,n){"use strict";e.a=function(t){return new Array(t.length)}},function(t,e,n){"use strict";function styleRemove(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){return function(){this.style.setProperty(t,e,n)}}function styleFunction(t,e,n){return function(){var r=e.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,n)}}function styleValue(t,e){return t.style.getPropertyValue(e)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(e)}e.b=styleValue;var r=n(32);e.a=function(t,e,n){return arguments.length>1?this.each((null==e?styleRemove:"function"==typeof e?styleFunction:styleConstant)(t,e,null==n?"":n)):styleValue(this.node(),t)}},function(t,e,n){"use strict";var r=n(2);e.a=function(t,e){var n,a,i,o=t.__transition,u=!0;if(o){e=null==e?null:e+"";for(i in o)(n=o[i]).name===e?(a=n.state>r.d&&n.state<r.b,n.state=r.a,n.timer.stop(),a&&n.on.call("interrupt",t,t.__data__,n.index,n.group),delete o[i]):u=!1;u&&delete t.__transition}}},function(t,e,n){"use strict";var r=n(33);n.d(e,"a",function(){return r.b}),n.d(e,"c",function(){return r.c});var a=n(160);n.d(e,"b",function(){return a.a});n(161)},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=function(t,e){var n;return("number"==typeof e?a.interpolateNumber:e instanceof r.color?a.interpolateRgb:(n=Object(r.color)(e))?(e=n,a.interpolateRgb):a.interpolateString)(t,e)}},function(t,e,n){"use strict";var r=n(264);n.d(e,"a",function(){return r.a})},function(t,e,n){"use strict";function acos(t){return t>1?0:t<-1?l:Math.acos(t)}function asin(t){return t>=1?h:t<=-1?-h:Math.asin(t)}n.d(e,"a",function(){return r}),n.d(e,"d",function(){return a}),n.d(e,"e",function(){return i}),n.d(e,"h",function(){return o}),n.d(e,"i",function(){return u}),n.d(e,"k",function(){return c}),n.d(e,"l",function(){return s}),n.d(e,"f",function(){return f}),n.d(e,"j",function(){return l}),n.d(e,"g",function(){return h}),n.d(e,"m",function(){return d}),e.b=acos,e.c=asin;var r=Math.abs,a=Math.atan2,i=Math.cos,o=Math.max,u=Math.min,c=Math.sin,s=Math.sqrt,f=1e-12,l=Math.PI,h=l/2,d=2*l},function(t,e,n){"use strict";e.a=function(t,e){if((a=t.length)>1)for(var n,r,a,i=1,o=t[e[0]],u=o.length;i<a;++i)for(r=o,o=t[e[i]],n=0;n<u;++n)o[n][1]+=o[n][0]=isNaN(r[n][1])?r[n][0]:r[n][1]}},function(t,e,n){"use strict";e.a=function(t){for(var e=t.length,n=new Array(e);--e>=0;)n[e]=e;return n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(92);n.d(e,"easeLinear",function(){return r.a});var a=n(93);n.d(e,"easeQuad",function(){return a.b}),n.d(e,"easeQuadIn",function(){return a.a}),n.d(e,"easeQuadOut",function(){return a.c}),n.d(e,"easeQuadInOut",function(){return a.b});var i=n(94);n.d(e,"easeCubic",function(){return i.b}),n.d(e,"easeCubicIn",function(){return i.a}),n.d(e,"easeCubicOut",function(){return i.c}),n.d(e,"easeCubicInOut",function(){return i.b});var o=n(95);n.d(e,"easePoly",function(){return o.b}),n.d(e,"easePolyIn",function(){return o.a}),n.d(e,"easePolyOut",function(){return o.c}),n.d(e,"easePolyInOut",function(){return o.b});var u=n(96);n.d(e,"easeSin",function(){return u.b}),n.d(e,"easeSinIn",function(){return u.a}),n.d(e,"easeSinOut",function(){return u.c}),n.d(e,"easeSinInOut",function(){return u.b});var c=n(97);n.d(e,"easeExp",function(){return c.b}),n.d(e,"easeExpIn",function(){return c.a}),n.d(e,"easeExpOut",function(){return c.c}),n.d(e,"easeExpInOut",function(){return c.b});var s=n(98);n.d(e,"easeCircle",function(){return s.b}),n.d(e,"easeCircleIn",function(){return s.a}),n.d(e,"easeCircleOut",function(){return s.c}),n.d(e,"easeCircleInOut",function(){return s.b});var f=n(99);n.d(e,"easeBounce",function(){return f.c}),n.d(e,"easeBounceIn",function(){return f.a}),n.d(e,"easeBounceOut",function(){return f.c}),n.d(e,"easeBounceInOut",function(){return f.b});var l=n(100);n.d(e,"easeBack",function(){return l.b}),n.d(e,"easeBackIn",function(){return l.a}),n.d(e,"easeBackOut",function(){return l.c}),n.d(e,"easeBackInOut",function(){return l.b});var h=n(101);n.d(e,"easeElastic",function(){return h.c}),n.d(e,"easeElasticIn",function(){return h.a}),n.d(e,"easeElasticOut",function(){return h.c}),n.d(e,"easeElasticInOut",function(){return h.b})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(104);n.d(e,"dispatch",function(){return r.a})},function(t,e,n){"use strict";n.d(e,"b",function(){return o}),n.d(e,"a",function(){return u});var r=n(10),a=n(68),i=Object(a.a)(r.a),o=i.right,u=i.left;e.c=o},function(t,e,n){"use strict";function ascendingComparator(t){return function(e,n){return Object(r.a)(t(e),n)}}var r=n(10);e.a=function(t){return 1===t.length&&(t=ascendingComparator(t)),{left:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)<0?r=i+1:a=i}return r},right:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)>0?a=i:r=i+1}return r}}}},function(t,e,n){"use strict";function pair(t,e){return[t,e]}e.b=pair,e.a=function(t,e){null==e&&(e=pair);for(var n=0,r=t.length-1,a=t[0],i=new Array(r<0?0:r);n<r;)i[n]=e(a,a=t[++n]);return i}},function(t,e,n){"use strict";var r=n(71);e.a=function(t,e){var n=Object(r.a)(t,e);return n?Math.sqrt(n):n}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a,i=t.length,o=0,u=-1,c=0,s=0;if(null==e)for(;++u<i;)isNaN(n=Object(r.a)(t[u]))||(a=n-c,c+=a/++o,s+=a*(n-c));else for(;++u<i;)isNaN(n=Object(r.a)(e(t[u],u,t)))||(a=n-c,c+=a/++o,s+=a*(n-c));if(o>1)return s/(o-1)}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a,i=t.length,o=-1;if(null==e){for(;++o<i;)if(null!=(n=t[o])&&n>=n)for(r=a=n;++o<i;)null!=(n=t[o])&&(r>n&&(r=n),a<n&&(a=n))}else for(;++o<i;)if(null!=(n=e(t[o],o,t))&&n>=n)for(r=a=n;++o<i;)null!=(n=e(t[o],o,t))&&(r>n&&(r=n),a<n&&(a=n));return[r,a]}},function(t,e,n){"use strict";n.d(e,"b",function(){return a}),n.d(e,"a",function(){return i});var r=Array.prototype,a=r.slice,i=r.map},function(t,e,n){"use strict";e.a=function(t,e,n){t=+t,e=+e,n=(a=arguments.length)<2?(e=t,t=0,1):a<3?1:+n;for(var r=-1,a=0|Math.max(0,Math.ceil((e-t)/n)),i=new Array(a);++r<a;)i[r]=t+r*n;return i}},function(t,e,n){"use strict";function tickIncrement(t,e,n){var o=(e-t)/Math.max(0,n),u=Math.floor(Math.log(o)/Math.LN10),c=o/Math.pow(10,u);return u>=0?(c>=r?10:c>=a?5:c>=i?2:1)*Math.pow(10,u):-Math.pow(10,-u)/(c>=r?10:c>=a?5:c>=i?2:1)}function tickStep(t,e,n){var o=Math.abs(e-t)/Math.max(0,n),u=Math.pow(10,Math.floor(Math.log(o)/Math.LN10)),c=o/u;return c>=r?u*=10:c>=a?u*=5:c>=i&&(u*=2),e<t?-u:u}e.b=tickIncrement,e.c=tickStep;var r=Math.sqrt(50),a=Math.sqrt(10),i=Math.sqrt(2);e.a=function(t,e,n){var r,a,i,o=e<t,u=-1;if(o&&(r=t,t=e,e=r),0===(i=tickIncrement(t,e,n))||!isFinite(i))return[];if(i>0)for(t=Math.ceil(t/i),e=Math.floor(e/i),a=new Array(r=Math.ceil(e-t+1));++u<r;)a[u]=(t+u)*i;else for(t=Math.floor(t*i),e=Math.ceil(e*i),a=new Array(r=Math.ceil(t-e+1));++u<r;)a[u]=(t-u)/i;return o&&a.reverse(),a}},function(t,e,n){"use strict";e.a=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&r>n&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&r>n&&(r=n);return r}},function(t,e,n){"use strict";function length(t){return t.length}var r=n(77);e.a=function(t){if(!(i=t.length))return[];for(var e=-1,n=Object(r.a)(t,length),a=new Array(n);++e<n;)for(var i,o=-1,u=a[e]=new Array(i);++o<i;)u[o]=t[o][e];return a}},function(t,e,n){"use strict";function localDate(t){if(0<=t.y&&t.y<100){var e=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return e.setFullYear(t.y),e}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function utcDate(t){if(0<=t.y&&t.y<100){var e=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return e.setUTCFullYear(t.y),e}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function newYear(t){return{y:t,m:0,d:1,H:0,M:0,S:0,L:0}}function formatLocale(t){function newFormat(t,e){return function(n){var r,i,o,u=[],c=-1,s=0,f=t.length;for(n instanceof Date||(n=new Date(+n));++c<f;)37===t.charCodeAt(c)&&(u.push(t.slice(s,c)),null!=(i=a[r=t.charAt(++c)])?r=t.charAt(++c):i="e"===r?" ":"0",(o=e[r])&&(r=o(n,i)),u.push(r),s=c+1);return u.push(t.slice(s,c)),u.join("")}}function newParse(t,e){return function(n){var r=newYear(1900);if(parseSpecifier(r,t,n+="",0)!=n.length)return null;if("p"in r&&(r.H=r.H%12+12*r.p),"W"in r||"U"in r){"w"in r||(r.w="W"in r?1:0);var a="Z"in r?utcDate(newYear(r.y)).getUTCDay():e(newYear(r.y)).getDay();r.m=0,r.d="W"in r?(r.w+6)%7+7*r.W-(a+5)%7:r.w+7*r.U-(a+6)%7}return"Z"in r?(r.H+=r.Z/100|0,r.M+=r.Z%100,utcDate(r)):e(r)}}function parseSpecifier(t,e,n,r){for(var i,o,u=0,c=e.length,s=n.length;u<c;){if(r>=s)return-1;if(37===(i=e.charCodeAt(u++))){if(i=e.charAt(u++),!(o=w[i in a?e.charAt(u++):i])||(r=o(t,n,r))<0)return-1}else if(i!=n.charCodeAt(r++))return-1}return r}function parsePeriod(t,e,n){var r=f.exec(e.slice(n));return r?(t.p=l[r[0].toLowerCase()],n+r[0].length):-1}function parseShortWeekday(t,e,n){var r=p.exec(e.slice(n));return r?(t.w=b[r[0].toLowerCase()],n+r[0].length):-1}function parseWeekday(t,e,n){var r=h.exec(e.slice(n));return r?(t.w=d[r[0].toLowerCase()],n+r[0].length):-1}function parseShortMonth(t,e,n){var r=y.exec(e.slice(n));return r?(t.m=g[r[0].toLowerCase()],n+r[0].length):-1}function parseMonth(t,e,n){var r=v.exec(e.slice(n));return r?(t.m=m[r[0].toLowerCase()],n+r[0].length):-1}function parseLocaleDateTime(t,n,r){return parseSpecifier(t,e,n,r)}function parseLocaleDate(t,e,r){return parseSpecifier(t,n,e,r)}function parseLocaleTime(t,e,n){return parseSpecifier(t,r,e,n)}function formatShortWeekday(t){return u[t.getDay()]}function formatWeekday(t){return o[t.getDay()]}function formatShortMonth(t){return s[t.getMonth()]}function formatMonth(t){return c[t.getMonth()]}function formatPeriod(t){return i[+(t.getHours()>=12)]}function formatUTCShortWeekday(t){return u[t.getUTCDay()]}function formatUTCWeekday(t){return o[t.getUTCDay()]}function formatUTCShortMonth(t){return s[t.getUTCMonth()]}function formatUTCMonth(t){return c[t.getUTCMonth()]}function formatUTCPeriod(t){return i[+(t.getUTCHours()>=12)]}var e=t.dateTime,n=t.date,r=t.time,i=t.periods,o=t.days,u=t.shortDays,c=t.months,s=t.shortMonths,f=formatRe(i),l=formatLookup(i),h=formatRe(o),d=formatLookup(o),p=formatRe(u),b=formatLookup(u),v=formatRe(c),m=formatLookup(c),y=formatRe(s),g=formatLookup(s),_={a:formatShortWeekday,A:formatWeekday,b:formatShortMonth,B:formatMonth,c:null,d:formatDayOfMonth,e:formatDayOfMonth,H:formatHour24,I:formatHour12,j:formatDayOfYear,L:formatMilliseconds,m:formatMonthNumber,M:formatMinutes,p:formatPeriod,S:formatSeconds,U:formatWeekNumberSunday,w:formatWeekdayNumber,W:formatWeekNumberMonday,x:null,X:null,y:formatYear,Y:formatFullYear,Z:formatZone,"%":formatLiteralPercent},x={a:formatUTCShortWeekday,A:formatUTCWeekday,b:formatUTCShortMonth,B:formatUTCMonth,c:null,d:formatUTCDayOfMonth,e:formatUTCDayOfMonth,H:formatUTCHour24,I:formatUTCHour12,j:formatUTCDayOfYear,L:formatUTCMilliseconds,m:formatUTCMonthNumber,M:formatUTCMinutes,p:formatUTCPeriod,S:formatUTCSeconds,U:formatUTCWeekNumberSunday,w:formatUTCWeekdayNumber,W:formatUTCWeekNumberMonday,x:null,X:null,y:formatUTCYear,Y:formatUTCFullYear,Z:formatUTCZone,"%":formatLiteralPercent},w={a:parseShortWeekday,A:parseWeekday,b:parseShortMonth,B:parseMonth,c:parseLocaleDateTime,d:parseDayOfMonth,e:parseDayOfMonth,H:parseHour24,I:parseHour24,j:parseDayOfYear,L:parseMilliseconds,m:parseMonthNumber,M:parseMinutes,p:parsePeriod,S:parseSeconds,U:parseWeekNumberSunday,w:parseWeekdayNumber,W:parseWeekNumberMonday,x:parseLocaleDate,X:parseLocaleTime,y:parseYear,Y:parseFullYear,Z:parseZone,"%":parseLiteralPercent};return _.x=newFormat(n,_),_.X=newFormat(r,_),_.c=newFormat(e,_),x.x=newFormat(n,x),x.X=newFormat(r,x),x.c=newFormat(e,x),{format:function(t){var e=newFormat(t+="",_);return e.toString=function(){return t},e},parse:function(t){var e=newParse(t+="",localDate);return e.toString=function(){return t},e},utcFormat:function(t){var e=newFormat(t+="",x);return e.toString=function(){return t},e},utcParse:function(t){var e=newParse(t,utcDate);return e.toString=function(){return t},e}}}function pad(t,e,n){var r=t<0?"-":"",a=(r?-t:t)+"",i=a.length;return r+(i<n?new Array(n-i+1).join(e)+a:a)}function requote(t){return t.replace(u,"\\$&")}function formatRe(t){return new RegExp("^(?:"+t.map(requote).join("|")+")","i")}function formatLookup(t){for(var e={},n=-1,r=t.length;++n<r;)e[t[n].toLowerCase()]=n;return e}function parseWeekdayNumber(t,e,n){var r=i.exec(e.slice(n,n+1));return r?(t.w=+r[0],n+r[0].length):-1}function parseWeekNumberSunday(t,e,n){var r=i.exec(e.slice(n));return r?(t.U=+r[0],n+r[0].length):-1}function parseWeekNumberMonday(t,e,n){var r=i.exec(e.slice(n));return r?(t.W=+r[0],n+r[0].length):-1}function parseFullYear(t,e,n){var r=i.exec(e.slice(n,n+4));return r?(t.y=+r[0],n+r[0].length):-1}function parseYear(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),n+r[0].length):-1}function parseZone(t,e,n){var r=/^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(e.slice(n,n+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),n+r[0].length):-1}function parseMonthNumber(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.m=r[0]-1,n+r[0].length):-1}function parseDayOfMonth(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.d=+r[0],n+r[0].length):-1}function parseDayOfYear(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.m=0,t.d=+r[0],n+r[0].length):-1}function parseHour24(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.H=+r[0],n+r[0].length):-1}function parseMinutes(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.M=+r[0],n+r[0].length):-1}function parseSeconds(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.S=+r[0],n+r[0].length):-1}function parseMilliseconds(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.L=+r[0],n+r[0].length):-1}function parseLiteralPercent(t,e,n){var r=o.exec(e.slice(n,n+1));return r?n+r[0].length:-1}function formatDayOfMonth(t,e){return pad(t.getDate(),e,2)}function formatHour24(t,e){return pad(t.getHours(),e,2)}function formatHour12(t,e){return pad(t.getHours()%12||12,e,2)}function formatDayOfYear(t,e){return pad(1+r.timeDay.count(Object(r.timeYear)(t),t),e,3)}function formatMilliseconds(t,e){return pad(t.getMilliseconds(),e,3)}function formatMonthNumber(t,e){return pad(t.getMonth()+1,e,2)}function formatMinutes(t,e){return pad(t.getMinutes(),e,2)}function formatSeconds(t,e){return pad(t.getSeconds(),e,2)}function formatWeekNumberSunday(t,e){return pad(r.timeSunday.count(Object(r.timeYear)(t),t),e,2)}function formatWeekdayNumber(t){return t.getDay()}function formatWeekNumberMonday(t,e){return pad(r.timeMonday.count(Object(r.timeYear)(t),t),e,2)}function formatYear(t,e){return pad(t.getFullYear()%100,e,2)}function formatFullYear(t,e){return pad(t.getFullYear()%1e4,e,4)}function formatZone(t){var e=t.getTimezoneOffset();return(e>0?"-":(e*=-1,"+"))+pad(e/60|0,"0",2)+pad(e%60,"0",2)}function formatUTCDayOfMonth(t,e){return pad(t.getUTCDate(),e,2)}function formatUTCHour24(t,e){return pad(t.getUTCHours(),e,2)}function formatUTCHour12(t,e){return pad(t.getUTCHours()%12||12,e,2)}function formatUTCDayOfYear(t,e){return pad(1+r.utcDay.count(Object(r.utcYear)(t),t),e,3)}function formatUTCMilliseconds(t,e){return pad(t.getUTCMilliseconds(),e,3)}function formatUTCMonthNumber(t,e){return pad(t.getUTCMonth()+1,e,2)}function formatUTCMinutes(t,e){return pad(t.getUTCMinutes(),e,2)}function formatUTCSeconds(t,e){return pad(t.getUTCSeconds(),e,2)}function formatUTCWeekNumberSunday(t,e){return pad(r.utcSunday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCWeekdayNumber(t){return t.getUTCDay()}function formatUTCWeekNumberMonday(t,e){return pad(r.utcMonday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCYear(t,e){return pad(t.getUTCFullYear()%100,e,2)}function formatUTCFullYear(t,e){return pad(t.getUTCFullYear()%1e4,e,4)}function formatUTCZone(){return"+0000"}function formatLiteralPercent(){return"%"}e.a=formatLocale;var r=n(35),a={"-":"",_:" ",0:"0"},i=/^\s*\d+/,o=/^%/,u=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g},function(t,e,n){"use strict";function formatIsoNative(t){return t.toISOString()}n.d(e,"b",function(){return a});var r=n(37),a="%Y-%m-%dT%H:%M:%S.%LZ",i=Date.prototype.toISOString?formatIsoNative:Object(r.d)(a);e.a=i},function(t,e,n){"use strict";function ordinal(t){function scale(r){var a=r+"",u=e.get(a);if(!u){if(o!==i)return o;e.set(a,u=n.push(r))}return t[(u-1)%t.length]}var e=Object(r.map)(),n=[],o=i;return t=null==t?[]:a.b.call(t),scale.domain=function(t){if(!arguments.length)return n.slice();n=[],e=Object(r.map)();for(var a,i,o=-1,u=t.length;++o<u;)e.has(i=(a=t[o])+"")||e.set(i,n.push(a));return scale},scale.range=function(e){return arguments.length?(t=a.b.call(e),scale):t.slice()},scale.unknown=function(t){return arguments.length?(o=t,scale):o},scale.copy=function(){return ordinal().domain(n).range(t).unknown(o)},scale}n.d(e,"b",function(){return i}),e.a=ordinal;var r=n(114),a=n(9),i={name:"implicit"}},function(t,e,n){"use strict";e.a=function(t){return+t}},function(t,e,n){"use strict";e.a=function(t,e){t=t.slice();var n,r=0,a=t.length-1,i=t[r],o=t[a];return o<i&&(n=r,r=a,a=n,n=i,i=o,o=n),t[r]=e.floor(i),t[a]=e.ceil(o),t}},function(t,e,n){"use strict";function date(t){return new Date(t)}function number(t){return t instanceof Date?+t:+new Date(+t)}function calendar(t,e,n,i,o,m,y,g,_){function tickFormat(r){return(y(r)<r?M:m(r)<r?C:o(r)<r?j:i(r)<r?T:e(r)<r?n(r)<r?k:S:t(r)<r?N:A)(r)}function tickInterval(e,n,a,i){if(null==e&&(e=10),"number"==typeof e){var o=Math.abs(a-n)/e,u=Object(r.bisector)(function(t){return t[2]}).right(E,o);u===E.length?(i=Object(r.tickStep)(n/v,a/v,e),e=t):u?(u=E[o/E[u-1][2]<E[u][2]/o?u-1:u],i=u[1],e=u[0]):(i=Object(r.tickStep)(n,a,e),e=g)}return null==i?e:e.every(i)}var x=Object(c.b)(c.c,a.interpolateNumber),w=x.invert,O=x.domain,M=_(".%L"),C=_(":%S"),j=_("%I:%M"),T=_("%I %p"),k=_("%a %d"),S=_("%b %d"),N=_("%B"),A=_("%Y"),E=[[y,1,f],[y,5,5*f],[y,15,15*f],[y,30,30*f],[m,1,l],[m,5,5*l],[m,15,15*l],[m,30,30*l],[o,1,h],[o,3,3*h],[o,6,6*h],[o,12,12*h],[i,1,d],[i,2,2*d],[n,1,p],[e,1,b],[e,3,3*b],[t,1,v]];return x.invert=function(t){return new Date(w(t))},x.domain=function(t){return arguments.length?O(u.a.call(t,number)):O().map(date)},x.ticks=function(t,e){var n,r=O(),a=r[0],i=r[r.length-1],o=i<a;return o&&(n=a,a=i,i=n),n=tickInterval(t,a,i,e),n=n?n.range(a,i+1):[],o?n.reverse():n},x.tickFormat=function(t,e){return null==e?tickFormat:_(e)},x.nice=function(t,e){var n=O();return(t=tickInterval(t,n[0],n[n.length-1],e))?O(Object(s.a)(n,t)):x},x.copy=function(){return Object(c.a)(x,calendar(t,e,n,i,o,m,y,g,_))},x}e.a=calendar;var r=n(5),a=n(8),i=n(35),o=n(40),u=n(9),c=n(18),s=n(83),f=1e3,l=60*f,h=60*l,d=24*h,p=7*d,b=30*d,v=365*d;e.b=function(){return calendar(i.timeYear,i.timeMonth,i.timeWeek,i.timeDay,i.timeHour,i.timeMinute,i.timeSecond,i.timeMillisecond,o.timeFormat).domain([new Date(2e3,0,1),new Date(2e3,0,2)])}},function(t,e,n){"use strict";function Linear(t){this._context=t}Linear.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._point=0},lineEnd:function(){(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;default:this._context.lineTo(t,e)}}},e.a=function(t){return new Linear(t)}},function(t,e,n){"use strict";e.a=function(){}},function(t,e,n){"use strict";function point(t,e,n){t._context.bezierCurveTo((2*t._x0+t._x1)/3,(2*t._y0+t._y1)/3,(t._x0+2*t._x1)/3,(t._y0+2*t._y1)/3,(t._x0+4*t._x1+e)/6,(t._y0+4*t._y1+n)/6)}function Basis(t){this._context=t}e.c=point,e.a=Basis,Basis.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){switch(this._point){case 3:point(this,this._x1,this._y1);case 2:this._context.lineTo(this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;break;case 2:this._point=3,this._context.lineTo((5*this._x0+this._x1)/6,(5*this._y0+this._y1)/6);default:point(this,t,e)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e}},e.b=function(t){return new Basis(t)}},function(t,e,n){"use strict";function point(t,e,n){t._context.bezierCurveTo(t._x1+t._k*(t._x2-t._x0),t._y1+t._k*(t._y2-t._y0),t._x2+t._k*(t._x1-e),t._y2+t._k*(t._y1-n),t._x2,t._y2)}function Cardinal(t,e){this._context=t,this._k=(1-e)/6}e.c=point,e.a=Cardinal,Cardinal.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:point(this,this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2,this._x1=t,this._y1=e;break;case 2:this._point=3;default:point(this,t,e)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.b=function custom(t){function cardinal(e){return new Cardinal(e,t)}return cardinal.tension=function(t){return custom(+t)},cardinal}(0)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},singleColors:{aloeGreen:["#7bdcc0"]},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green To Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"}}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},emptyDonutData:[{quantity:1,percentage:100}],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId"}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=(n(158),n(7));n.d(e,"transition",function(){return r.b});var a=n(179);n.d(e,"active",function(){return a.a});var i=n(58);n.d(e,"interrupt",function(){return i.a})},function(t,e,n){"use strict";function linear(t){return+t}e.a=linear},function(t,e,n){"use strict";function quadIn(t){return t*t}function quadOut(t){return t*(2-t)}function quadInOut(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.a=quadIn,e.c=quadOut,e.b=quadInOut},function(t,e,n){"use strict";function cubicIn(t){return t*t*t}function cubicOut(t){return--t*t*t+1}function cubicInOut(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.a=cubicIn,e.c=cubicOut,e.b=cubicInOut},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function polyIn(e){return Math.pow(e,t)}return t=+t,polyIn.exponent=custom,polyIn}(3),a=function custom(t){function polyOut(e){return 1-Math.pow(1-e,t)}return t=+t,polyOut.exponent=custom,polyOut}(3),i=function custom(t){function polyInOut(e){return((e*=2)<=1?Math.pow(e,t):2-Math.pow(2-e,t))/2}return t=+t,polyInOut.exponent=custom,polyInOut}(3)},function(t,e,n){"use strict";function sinIn(t){return 1-Math.cos(t*a)}function sinOut(t){return Math.sin(t*a)}function sinInOut(t){return(1-Math.cos(r*t))/2}e.a=sinIn,e.c=sinOut,e.b=sinInOut;var r=Math.PI,a=r/2},function(t,e,n){"use strict";function expIn(t){return Math.pow(2,10*t-10)}function expOut(t){return 1-Math.pow(2,-10*t)}function expInOut(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}e.a=expIn,e.c=expOut,e.b=expInOut},function(t,e,n){"use strict";function circleIn(t){return 1-Math.sqrt(1-t*t)}function circleOut(t){return Math.sqrt(1- --t*t)}function circleInOut(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}e.a=circleIn,e.c=circleOut,e.b=circleInOut},function(t,e,n){"use strict";function bounceIn(t){return 1-bounceOut(1-t)}function bounceOut(t){return(t=+t)<r?h*t*t:t<i?h*(t-=a)*t+o:t<c?h*(t-=u)*t+s:h*(t-=f)*t+l}function bounceInOut(t){return((t*=2)<=1?1-bounceOut(1-t):bounceOut(t-1)+1)/2}e.a=bounceIn,e.c=bounceOut,e.b=bounceInOut;var r=4/11,a=6/11,i=8/11,o=.75,u=9/11,c=10/11,s=.9375,f=21/22,l=63/64,h=1/r/r},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function backIn(e){return e*e*((t+1)*e-t)}return t=+t,backIn.overshoot=custom,backIn}(1.70158),a=function custom(t){function backOut(e){return--e*e*((t+1)*e+t)+1}return t=+t,backOut.overshoot=custom,backOut}(1.70158),i=function custom(t){function backInOut(e){return((e*=2)<1?e*e*((t+1)*e-t):(e-=2)*e*((t+1)*e+t)+2)/2}return t=+t,backInOut.overshoot=custom,backInOut}(1.70158)},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"b",function(){return o});var r=2*Math.PI,a=function custom(t,e){function elasticIn(r){return t*Math.pow(2,10*--r)*Math.sin((n-r)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticIn.amplitude=function(t){return custom(t,e*r)},elasticIn.period=function(e){return custom(t,e)},elasticIn}(1,.3),i=function custom(t,e){function elasticOut(r){return 1-t*Math.pow(2,-10*(r=+r))*Math.sin((r+n)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticOut.amplitude=function(t){return custom(t,e*r)},elasticOut.period=function(e){return custom(t,e)},elasticOut}(1,.3),o=function custom(t,e){function elasticInOut(r){return((r=2*r-1)<0?t*Math.pow(2,10*r)*Math.sin((n-r)/e):2-t*Math.pow(2,-10*r)*Math.sin((n+r)/e))/2}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticInOut.amplitude=function(t){return custom(t,e*r)},elasticInOut.period=function(e){return custom(t,e)},elasticInOut}(1,.3)},function(t,e,n){"use strict";function labConvert(t){if(t instanceof Lab)return new Lab(t.l,t.a,t.b,t.opacity);if(t instanceof Hcl){var e=t.h*i.a;return new Lab(t.l,Math.cos(e)*t.c,Math.sin(e)*t.c,t.opacity)}t instanceof a.b||(t=Object(a.h)(t));var n=rgb2xyz(t.r),r=rgb2xyz(t.g),s=rgb2xyz(t.b),f=xyz2lab((.4124564*n+.3575761*r+.1804375*s)/o),l=xyz2lab((.2126729*n+.7151522*r+.072175*s)/u);return new Lab(116*l-16,500*(f-l),200*(l-xyz2lab((.0193339*n+.119192*r+.9503041*s)/c)),t.opacity)}function lab(t,e,n,r){return 1===arguments.length?labConvert(t):new Lab(t,e,n,null==r?1:r)}function Lab(t,e,n,r){this.l=+t,this.a=+e,this.b=+n,this.opacity=+r}function xyz2lab(t){return t>h?Math.pow(t,1/3):t/l+s}function lab2xyz(t){return t>f?t*t*t:l*(t-s)}function xyz2rgb(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function rgb2xyz(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function hclConvert(t){if(t instanceof Hcl)return new Hcl(t.h,t.c,t.l,t.opacity);t instanceof Lab||(t=labConvert(t));var e=Math.atan2(t.b,t.a)*i.b;return new Hcl(e<0?e+360:e,Math.sqrt(t.a*t.a+t.b*t.b),t.l,t.opacity)}function hcl(t,e,n,r){return 1===arguments.length?hclConvert(t):new Hcl(t,e,n,null==r?1:r)}function Hcl(t,e,n,r){this.h=+t,this.c=+e,this.l=+n,this.opacity=+r}e.a=lab,e.b=hcl;var r=n(20),a=n(19),i=n(41),o=.95047,u=1,c=1.08883,s=4/29,f=6/29,l=3*f*f,h=f*f*f;Object(r.a)(Lab,lab,Object(r.b)(a.a,{brighter:function(t){return new Lab(this.l+18*(null==t?1:t),this.a,this.b,this.opacity)},darker:function(t){return new Lab(this.l-18*(null==t?1:t),this.a,this.b,this.opacity)},rgb:function(){var t=(this.l+16)/116,e=isNaN(this.a)?t:t+this.a/500,n=isNaN(this.b)?t:t-this.b/200;return t=u*lab2xyz(t),e=o*lab2xyz(e),n=c*lab2xyz(n),new a.b(xyz2rgb(3.2404542*e-1.5371385*t-.4985314*n),xyz2rgb(-.969266*e+1.8760108*t+.041556*n),xyz2rgb(.0556434*e-.2040259*t+1.0572252*n),this.opacity)}})),Object(r.a)(Hcl,hcl,Object(r.b)(a.a,{brighter:function(t){return new Hcl(this.h,this.c,this.l+18*(null==t?1:t),this.opacity)},darker:function(t){return new Hcl(this.h,this.c,this.l-18*(null==t?1:t),this.opacity)},rgb:function(){return labConvert(this).rgb()}}))},function(t,e,n){"use strict";function cubehelixConvert(t){if(t instanceof Cubehelix)return new Cubehelix(t.h,t.s,t.l,t.opacity);t instanceof a.b||(t=Object(a.h)(t));var e=t.r/255,n=t.g/255,r=t.b/255,o=(d*r+l*e-h*n)/(d+l-h),u=r-o,p=(f*(n-o)-c*u)/s,b=Math.sqrt(p*p+u*u)/(f*o*(1-o)),v=b?Math.atan2(p,u)*i.b-120:NaN;return new Cubehelix(v<0?v+360:v,b,o,t.opacity)}function cubehelix(t,e,n,r){return 1===arguments.length?cubehelixConvert(t):new Cubehelix(t,e,n,null==r?1:r)}function Cubehelix(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}e.a=cubehelix;var r=n(20),a=n(19),i=n(41),o=-.14861,u=1.78277,c=-.29227,s=-.90649,f=1.97294,l=f*s,h=f*u,d=u*c-s*o;Object(r.a)(Cubehelix,cubehelix,Object(r.b)(a.a,{brighter:function(t){return t=null==t?a.c:Math.pow(a.c,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a.d:Math.pow(a.d,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=isNaN(this.h)?0:(this.h+120)*i.a,e=+this.l,n=isNaN(this.s)?0:this.s*e*(1-e),r=Math.cos(t),l=Math.sin(t);return new a.b(255*(e+n*(o*r+u*l)),255*(e+n*(c*r+s*l)),255*(e+n*(f*r)),this.opacity)}}))},function(t,e,n){"use strict";function dispatch(){for(var t,e=0,n=arguments.length,r={};e<n;++e){if(!(t=arguments[e]+"")||t in r)throw new Error("illegal type: "+t);r[t]=[]}return new Dispatch(r)}function Dispatch(t){this._=t}function parseTypenames(t,e){return t.trim().split(/^|\s+/).map(function(t){var n="",r=t.indexOf(".");if(r>=0&&(n=t.slice(r+1),t=t.slice(0,r)),t&&!e.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:n}})}function get(t,e){for(var n,r=0,a=t.length;r<a;++r)if((n=t[r]).name===e)return n.value}function set(t,e,n){for(var a=0,i=t.length;a<i;++a)if(t[a].name===e){t[a]=r,t=t.slice(0,a).concat(t.slice(a+1));break}return null!=n&&t.push({name:e,value:n}),t}var r={value:function(){}};Dispatch.prototype=dispatch.prototype={constructor:Dispatch,on:function(t,e){var n,r=this._,a=parseTypenames(t+"",r),i=-1,o=a.length;{if(!(arguments.length<2)){if(null!=e&&"function"!=typeof e)throw new Error("invalid callback: "+e);for(;++i<o;)if(n=(t=a[i]).type)r[n]=set(r[n],t.name,e);else if(null==e)for(n in r)r[n]=set(r[n],t.name,null);return this}for(;++i<o;)if((n=(t=a[i]).type)&&(n=get(r[n],t.name)))return n}},copy:function(){var t={},e=this._;for(var n in e)t[n]=e[n].slice();return new Dispatch(t)},call:function(t,e){if((n=arguments.length-2)>0)for(var n,r,a=new Array(n),i=0;i<n;++i)a[i]=arguments[i+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(r=this._[t],i=0,n=r.length;i<n;++i)r[i].value.apply(e,a)},apply:function(t,e,n){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],a=0,i=r.length;a<i;++a)r[a].value.apply(e,n)}},e.a=dispatch},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(o.a)(t),a=r.format,i=r.formatPrefix,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),e.a=defaultLocale;var r,a,i,o=n(42);defaultLocale({decimal:".",thousands:",",grouping:[3],currency:["$",""]})},function(t,e,n){"use strict";e.a=function(t,e){return function(n,r){for(var a=n.length,i=[],o=0,u=t[0],c=0;a>0&&u>0&&(c+u+1>r&&(u=Math.max(1,r-c)),i.push(n.substring(a-=u,a+u)),!((c+=u+1)>r));)u=t[o=(o+1)%t.length];return i.reverse().join(e)}}},function(t,e,n){"use strict";e.a=function(t){return function(e){return e.replace(/[0-9]/g,function(e){return t[+e]})}}},function(t,e,n){"use strict";e.a=function(t,e){t=t.toPrecision(e);t:for(var n,r=t.length,a=1,i=-1;a<r;++a)switch(t[a]){case".":i=n=a;break;case"0":0===i&&(i=a),n=a;break;case"e":break t;default:i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t,e){var n=Object(r.a)(t,e);if(!n)return t+"";var a=n[0],i=n[1];return i<0?"0."+new Array(-i).join("0")+a:a.length>i+1?a.slice(0,i+1)+"."+a.slice(i+1):a+new Array(i-a.length+2).join("0")}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(13);e.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3)))-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return t=Math.abs(t),e=Math.abs(e)-t,Math.max(0,Object(r.a)(e)-Object(r.a)(t))+1}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(217);n.d(e,"nest",function(){return r.a});var a=n(218);n.d(e,"set",function(){return a.a});var i=n(38);n.d(e,"map",function(){return i.a});var o=n(219);n.d(e,"keys",function(){return o.a});var u=n(220);n.d(e,"values",function(){return u.a});var c=n(221);n.d(e,"entries",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return Math.round(t+e*n)}}},function(t,e,n){"use strict";function interpolateTransform(t,e,n,a){function pop(t){return t.length?t.pop()+" ":""}function translate(t,a,i,o,u,c){if(t!==i||a!==o){var s=u.push("translate(",null,e,null,n);c.push({i:s-4,x:Object(r.a)(t,i)},{i:s-2,x:Object(r.a)(a,o)})}else(i||o)&&u.push("translate("+i+e+o+n)}function rotate(t,e,n,i){t!==e?(t-e>180?e+=360:e-t>180&&(t+=360),i.push({i:n.push(pop(n)+"rotate(",null,a)-2,x:Object(r.a)(t,e)})):e&&n.push(pop(n)+"rotate("+e+a)}function skewX(t,e,n,i){t!==e?i.push({i:n.push(pop(n)+"skewX(",null,a)-2,x:Object(r.a)(t,e)}):e&&n.push(pop(n)+"skewX("+e+a)}function scale(t,e,n,a,i,o){if(t!==n||e!==a){var u=i.push(pop(i)+"scale(",null,",",null,")");o.push({i:u-4,x:Object(r.a)(t,n)},{i:u-2,x:Object(r.a)(e,a)})}else 1===n&&1===a||i.push(pop(i)+"scale("+n+","+a+")")}return function(e,n){var r=[],a=[];return e=t(e),n=t(n),translate(e.translateX,e.translateY,n.translateX,n.translateY,r,a),rotate(e.rotate,n.rotate,r,a),skewX(e.skewX,n.skewX,r,a),scale(e.scaleX,e.scaleY,n.scaleX,n.scaleY,r,a),e=n=null,function(t){for(var e,n=-1,i=a.length;++n<i;)r[(e=a[n]).i]=e.x(t);return r.join("")}}}n.d(e,"a",function(){return i}),n.d(e,"b",function(){return o});var r=n(15),a=n(117),i=interpolateTransform(a.a,"px, ","px)","deg)"),o=interpolateTransform(a.b,", ",")",")")},function(t,e,n){"use strict";function parseCss(t){return"none"===t?u.b:(r||(r=document.createElement("DIV"),a=document.documentElement,i=document.defaultView),r.style.transform=t,t=i.getComputedStyle(a.appendChild(r),null).getPropertyValue("transform"),a.removeChild(r),t=t.slice(7,-1).split(","),Object(u.a)(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}function parseSvg(t){return null==t?u.b:(o||(o=document.createElementNS("http://www.w3.org/2000/svg","g")),o.setAttribute("transform",t),(t=o.transform.baseVal.consolidate())?(t=t.matrix,Object(u.a)(t.a,t.b,t.c,t.d,t.e,t.f)):u.b)}e.a=parseCss,e.b=parseSvg;var r,a,i,o,u=n(118)},function(t,e,n){"use strict";n.d(e,"b",function(){return a});var r=180/Math.PI,a={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};e.a=function(t,e,n,a,i,o){var u,c,s;return(u=Math.sqrt(t*t+e*e))&&(t/=u,e/=u),(s=t*n+e*a)&&(n-=t*s,a-=e*s),(c=Math.sqrt(n*n+a*a))&&(n/=c,a/=c,s/=c),t*a<e*n&&(t=-t,e=-e,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(e,t)*r,skewX:Math.atan(s)*r,scaleX:u,scaleY:c}}},function(t,e,n){"use strict";function cosh(t){return((t=Math.exp(t))+1/t)/2}function sinh(t){return((t=Math.exp(t))-1/t)/2}function tanh(t){return((t=Math.exp(2*t))-1)/(t+1)}var r=Math.SQRT2;e.a=function(t,e){var n,a,i=t[0],o=t[1],u=t[2],c=e[0],s=e[1],f=e[2],l=c-i,h=s-o,d=l*l+h*h;if(d<1e-12)a=Math.log(f/u)/r,n=function(t){return[i+t*l,o+t*h,u*Math.exp(r*t*a)]};else{var p=Math.sqrt(d),b=(f*f-u*u+4*d)/(2*u*2*p),v=(f*f-u*u-4*d)/(2*f*2*p),m=Math.log(Math.sqrt(b*b+1)-b),y=Math.log(Math.sqrt(v*v+1)-v);a=(y-m)/r,n=function(t){var e=t*a,n=cosh(m),c=u/(2*p)*(n*tanh(r*e+m)-sinh(m));return[i+c*l,o+c*h,u*n/cosh(r*e+m)]}}return n.duration=1e3*a,n}},function(t,e,n){"use strict";function hsl(t){return function(e,n){var i=t((e=Object(r.hsl)(e)).h,(n=Object(r.hsl)(n)).h),o=Object(a.a)(e.s,n.s),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.s=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hsl(a.c);var i=hsl(a.a)},function(t,e,n){"use strict";function lab(t,e){var n=Object(a.a)((t=Object(r.lab)(t)).l,(e=Object(r.lab)(e)).l),i=Object(a.a)(t.a,e.a),o=Object(a.a)(t.b,e.b),u=Object(a.a)(t.opacity,e.opacity);return function(e){return t.l=n(e),t.a=i(e),t.b=o(e),t.opacity=u(e),t+""}}e.a=lab;var r=n(4),a=n(11)},function(t,e,n){"use strict";function hcl(t){return function(e,n){var i=t((e=Object(r.hcl)(e)).h,(n=Object(r.hcl)(n)).h),o=Object(a.a)(e.c,n.c),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.c=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hcl(a.c);var i=hcl(a.a)},function(t,e,n){"use strict";function cubehelix(t){return function cubehelixGamma(e){function cubehelix(n,i){var o=t((n=Object(r.cubehelix)(n)).h,(i=Object(r.cubehelix)(i)).h),u=Object(a.a)(n.s,i.s),c=Object(a.a)(n.l,i.l),s=Object(a.a)(n.opacity,i.opacity);return function(t){return n.h=o(t),n.s=u(t),n.l=c(Math.pow(t,e)),n.opacity=s(t),n+""}}return e=+e,cubehelix.gamma=cubehelixGamma,cubehelix}(1)}n.d(e,"a",function(){return i});var r=n(4),a=n(11);e.b=cubehelix(a.c);var i=cubehelix(a.a)},function(t,e,n){"use strict";e.a=function(t,e){for(var n=new Array(e),r=0;r<e;++r)n[r]=t(r/(e-1));return n}},function(t,e,n){"use strict";function local(){return new Local}function Local(){this._="@"+(++r).toString(36)}e.a=local;var r=0;Local.prototype=local.prototype={constructor:Local,get:function(t){for(var e=this._;!(e in t);)if(!(t=t.parentNode))return;return t[e]},set:function(t,e){return t[this._]=e},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t){var e=Object(r.a)();return e.changedTouches&&(e=e.changedTouches[0]),Object(a.a)(t,e)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,e,n){"use strict";var r=n(1),a=n(31);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c,s=e[o],f=s.length,l=i[o]=new Array(f),h=0;h<f;++h)(u=s[h])&&(c=t.call(u,u.__data__,h,s))&&("__data__"in u&&(c.__data__=u.__data__),l[h]=c);return new r.a(i,this._parents)}},function(t,e,n){"use strict";var r=n(1),a=n(54);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=[],o=[],u=0;u<n;++u)for(var c,s=e[u],f=s.length,l=0;l<f;++l)(c=s[l])&&(i.push(t.call(c,c.__data__,l,s)),o.push(c));return new r.a(i,o)}},function(t,e,n){"use strict";var r=n(1),a=n(53);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new r.a(i,this._parents)}},function(t,e,n){"use strict";function bindIndex(t,e,n,r,i,o){for(var u,c=0,s=e.length,f=o.length;c<f;++c)(u=e[c])?(u.__data__=o[c],r[c]=u):n[c]=new a.a(t,o[c]);for(;c<s;++c)(u=e[c])&&(i[c]=u)}function bindKey(t,e,n,r,i,u,c){var s,f,l,h={},d=e.length,p=u.length,b=new Array(d);for(s=0;s<d;++s)(f=e[s])&&(b[s]=l=o+c.call(f,f.__data__,s,e),l in h?i[s]=f:h[l]=f);for(s=0;s<p;++s)l=o+c.call(t,u[s],s,u),(f=h[l])?(r[s]=f,f.__data__=u[s],h[l]=null):n[s]=new a.a(t,u[s]);for(s=0;s<d;++s)(f=e[s])&&h[b[s]]===f&&(i[s]=f)}var r=n(1),a=n(55),i=n(132),o="$";e.a=function(t,e){if(!t)return b=new Array(this.size()),l=-1,this.each(function(t){b[++l]=t}),b;var n=e?bindKey:bindIndex,a=this._parents,o=this._groups;"function"!=typeof t&&(t=Object(i.a)(t));for(var u=o.length,c=new Array(u),s=new Array(u),f=new Array(u),l=0;l<u;++l){var h=a[l],d=o[l],p=d.length,b=t.call(h,h&&h.__data__,l,a),v=b.length,m=s[l]=new Array(v),y=c[l]=new Array(v);n(h,d,m,y,f[l]=new Array(p),b,e);for(var g,_,x=0,w=0;x<v;++x)if(g=m[x]){for(x>=w&&(w=x+1);!(_=y[w])&&++w<v;);g._next=_||null}}return c=new r.a(c,a),c._enter=s,c._exit=f,c}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(56),a=n(1);e.a=function(){return new a.a(this._exit||this._groups.map(r.a),this._parents)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents)}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=-1,n=t.length;++e<n;)for(var r,a=t[e],i=a.length-1,o=a[i];--i>=0;)(r=a[i])&&(o&&o!==r.nextSibling&&o.parentNode.insertBefore(r,o),o=r);return this}},function(t,e,n){"use strict";function ascending(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}var r=n(1);e.a=function(t){function compareNode(e,n){return e&&n?t(e.__data__,n.__data__):!e-!n}t||(t=ascending);for(var e=this._groups,n=e.length,a=new Array(n),i=0;i<n;++i){for(var o,u=e[i],c=u.length,s=a[i]=new Array(c),f=0;f<c;++f)(o=u[f])&&(s[f]=o);s.sort(compareNode)}return new r.a(a,this._parents).order()}},function(t,e,n){"use strict";e.a=function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}},function(t,e,n){"use strict";e.a=function(){var t=new Array(this.size()),e=-1;return this.each(function(){t[++e]=this}),t}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=0,n=t.length;e<n;++e)for(var r=t[e],a=0,i=r.length;a<i;++a){var o=r[a];if(o)return o}return null}},function(t,e,n){"use strict";e.a=function(){var t=0;return this.each(function(){++t}),t}},function(t,e,n){"use strict";e.a=function(){return!this.node()}},function(t,e,n){"use strict";e.a=function(t){for(var e=this._groups,n=0,r=e.length;n<r;++n)for(var a,i=e[n],o=0,u=i.length;o<u;++o)(a=i[o])&&t.call(a,a.__data__,o,i);return this}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e){return function(){this.setAttribute(t,e)}}function attrConstantNS(t,e){return function(){this.setAttributeNS(t.space,t.local,e)}}function attrFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttribute(t):this.setAttribute(t,n)}}function attrFunctionNS(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,n)}}var r=n(26);e.a=function(t,e){var n=Object(r.a)(t);if(arguments.length<2){var a=this.node();return n.local?a.getAttributeNS(n.space,n.local):a.getAttribute(n)}return this.each((null==e?n.local?attrRemoveNS:attrRemove:"function"==typeof e?n.local?attrFunctionNS:attrFunction:n.local?attrConstantNS:attrConstant)(n,e))}},function(t,e,n){"use strict";function propertyRemove(t){return function(){delete this[t]}}function propertyConstant(t,e){return function(){this[t]=e}}function propertyFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?delete this[t]:this[t]=n}}e.a=function(t,e){return arguments.length>1?this.each((null==e?propertyRemove:"function"==typeof e?propertyFunction:propertyConstant)(t,e)):this.node()[t]}},function(t,e,n){"use strict";function classArray(t){return t.trim().split(/^|\s+/)}function classList(t){return t.classList||new ClassList(t)}function ClassList(t){this._node=t,this._names=classArray(t.getAttribute("class")||"")}function classedAdd(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.add(e[r])}function classedRemove(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.remove(e[r])}function classedTrue(t){return function(){classedAdd(this,t)}}function classedFalse(t){return function(){classedRemove(this,t)}}function classedFunction(t,e){return function(){(e.apply(this,arguments)?classedAdd:classedRemove)(this,t)}}ClassList.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var e=this._names.indexOf(t);e>=0&&(this._names.splice(e,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}},e.a=function(t,e){var n=classArray(t+"");if(arguments.length<2){for(var r=classList(this.node()),a=-1,i=n.length;++a<i;)if(!r.contains(n[a]))return!1;return!0}return this.each(("function"==typeof e?classedFunction:e?classedTrue:classedFalse)(n,e))}},function(t,e,n){"use strict";function textRemove(){this.textContent=""}function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t.apply(this,arguments);this.textContent=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?textRemove:("function"==typeof t?textFunction:textConstant)(t)):this.node().textContent}},function(t,e,n){"use strict";function htmlRemove(){this.innerHTML=""}function htmlConstant(t){return function(){this.innerHTML=t}}function htmlFunction(t){return function(){var e=t.apply(this,arguments);this.innerHTML=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?htmlRemove:("function"==typeof t?htmlFunction:htmlConstant)(t)):this.node().innerHTML}},function(t,e,n){"use strict";function raise(){this.nextSibling&&this.parentNode.appendChild(this)}e.a=function(){return this.each(raise)}},function(t,e,n){"use strict";function lower(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}e.a=function(){return this.each(lower)}},function(t,e,n){"use strict";var r=n(25);e.a=function(t){var e="function"==typeof t?t:Object(r.a)(t);return this.select(function(){return this.appendChild(e.apply(this,arguments))})}},function(t,e,n){"use strict";function constantNull(){return null}var r=n(25),a=n(31);e.a=function(t,e){var n="function"==typeof t?t:Object(r.a)(t),i=null==e?constantNull:"function"==typeof e?e:Object(a.a)(e);return this.select(function(){return this.insertBefore(n.apply(this,arguments),i.apply(this,arguments)||null)})}},function(t,e,n){"use strict";function remove(){var t=this.parentNode;t&&t.removeChild(this)}e.a=function(){return this.each(remove)}},function(t,e,n){"use strict";e.a=function(t){return arguments.length?this.property("__data__",t):this.node().__data__}},function(t,e,n){"use strict";function dispatchEvent(t,e,n){var a=Object(r.a)(t),i=a.CustomEvent;"function"==typeof i?i=new i(e,n):(i=a.document.createEvent("Event"),n?(i.initEvent(e,n.bubbles,n.cancelable),i.detail=n.detail):i.initEvent(e,!1,!1)),t.dispatchEvent(i)}function dispatchConstant(t,e){return function(){return dispatchEvent(this,t,e)}}function dispatchFunction(t,e){return function(){return dispatchEvent(this,t,e.apply(this,arguments))}}var r=n(32);e.a=function(t,e){return this.each(("function"==typeof e?dispatchFunction:dispatchConstant)(t,e))}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([document.querySelectorAll(t)],[document.documentElement]):new r.a([null==t?[]:t],r.c)}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e,n){arguments.length<3&&(n=e,e=Object(r.a)().changedTouches);for(var i,o=0,u=e?e.length:0;o<u;++o)if((i=e[o]).identifier===n)return Object(a.a)(t,i);return null}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e){null==e&&(e=Object(r.a)().touches);for(var n=0,i=e?e.length:0,o=new Array(i);n<i;++n)o[n]=Object(a.a)(t,e[n]);return o}},function(t,e,n){"use strict";var r=n(3),a=n(159),i=n(162);r.selection.prototype.interrupt=a.a,r.selection.prototype.transition=i.a},function(t,e,n){"use strict";var r=n(58);e.a=function(t){return this.each(function(){Object(r.a)(this,t)})}},function(t,e,n){"use strict";var r=n(33);e.a=function(t,e,n){var a=new r.a;return e=null==e?0:+e,a.restart(function(n){a.stop(),t(n+e)},e,n),a}},function(t,e,n){"use strict";n(33)},function(t,e,n){"use strict";function inherit(t,e){for(var n;!(n=t.__transition)||!(n=n[e]);)if(!(t=t.parentNode))return u.time=Object(o.a)(),u;return n}var r=n(7),a=n(2),i=n(65),o=n(59),u={time:null,delay:0,duration:250,ease:i.easeCubicInOut};e.a=function(t){var e,n;t instanceof r.a?(e=t._id,t=t._name):(e=Object(r.c)(),(n=u).time=Object(o.a)(),t=null==t?null:t+"");for(var i=this._groups,c=i.length,s=0;s<c;++s)for(var f,l=i[s],h=l.length,d=0;d<h;++d)(f=l[d])&&Object(a.e)(f,t,e,d,l,n||inherit(f,e));return new r.a(i,this._parents,t,e)}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e,n){var r,a;return function(){var i=this.getAttribute(t);return i===n?null:i===r?a:a=e(r=i,n)}}function attrConstantNS(t,e,n){var r,a;return function(){var i=this.getAttributeNS(t.space,t.local);return i===n?null:i===r?a:a=e(r=i,n)}}function attrFunction(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttribute(t):(o=this.getAttribute(t),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}function attrFunctionNS(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttributeNS(t.space,t.local):(o=this.getAttributeNS(t.space,t.local),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e){var n=Object(a.namespace)(t),u="transform"===n?r.interpolateTransformSvg:o.a;return this.attrTween(t,"function"==typeof e?(n.local?attrFunctionNS:attrFunction)(n,u,Object(i.b)(this,"attr."+t,e)):null==e?(n.local?attrRemoveNS:attrRemove)(n):(n.local?attrConstantNS:attrConstant)(n,u,e+""))}},function(t,e,n){"use strict";function attrTweenNS(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttributeNS(t.space,t.local,r(e))}}return tween._value=e,tween}function attrTween(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttribute(t,r(e))}}return tween._value=e,tween}var r=n(3);e.a=function(t,e){var n="attr."+t;if(arguments.length<2)return(n=this.tween(n))&&n._value;if(null==e)return this.tween(n,null);if("function"!=typeof e)throw new Error;var a=Object(r.namespace)(t);return this.tween(n,(a.local?attrTweenNS:attrTween)(a,e))}},function(t,e,n){"use strict";function delayFunction(t,e){return function(){Object(r.g)(this,t).delay=+e.apply(this,arguments)}}function delayConstant(t,e){return e=+e,function(){Object(r.g)(this,t).delay=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?delayFunction:delayConstant)(e,t)):Object(r.f)(this.node(),e).delay}},function(t,e,n){"use strict";function durationFunction(t,e){return function(){Object(r.h)(this,t).duration=+e.apply(this,arguments)}}function durationConstant(t,e){return e=+e,function(){Object(r.h)(this,t).duration=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?durationFunction:durationConstant)(e,t)):Object(r.f)(this.node(),e).duration}},function(t,e,n){"use strict";function easeConstant(t,e){if("function"!=typeof e)throw new Error;return function(){Object(r.h)(this,t).ease=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(easeConstant(e,t)):Object(r.f)(this.node(),e).ease}},function(t,e,n){"use strict";var r=n(3),a=n(7);e.a=function(t){"function"!=typeof t&&(t=Object(r.matcher)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new a.a(i,this._parents,this._name,this._id)}},function(t,e,n){"use strict";var r=n(7);e.a=function(t){if(t._id!==this._id)throw new Error;for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents,this._name,this._id)}},function(t,e,n){"use strict";function start(t){return(t+"").trim().split(/^|\s+/).every(function(t){var e=t.indexOf(".");return e>=0&&(t=t.slice(0,e)),!t||"start"===t})}function onFunction(t,e,n){var a,i,o=start(e)?r.g:r.h;return function(){var r=o(this,t),u=r.on;u!==a&&(i=(a=u).copy()).on(e,n),r.on=i}}var r=n(2);e.a=function(t,e){var n=this._id;return arguments.length<2?Object(r.f)(this.node(),n).on.on(t):this.each(onFunction(n,t,e))}},function(t,e,n){"use strict";function removeFunction(t){return function(){var e=this.parentNode;for(var n in this.__transition)if(+n!==t)return;e&&e.removeChild(this)}}e.a=function(){return this.on("end.remove",removeFunction(this._id))}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selector)(t));for(var o=this._groups,u=o.length,c=new Array(u),s=0;s<u;++s)for(var f,l,h=o[s],d=h.length,p=c[s]=new Array(d),b=0;b<d;++b)(f=h[b])&&(l=t.call(f,f.__data__,b,h))&&("__data__"in f&&(l.__data__=f.__data__),p[b]=l,Object(i.e)(p[b],e,n,b,p,Object(i.f)(f,n)));return new a.a(c,this._parents,e,n)}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selectorAll)(t));for(var o=this._groups,u=o.length,c=[],s=[],f=0;f<u;++f)for(var l,h=o[f],d=h.length,p=0;p<d;++p)if(l=h[p]){for(var b,v=t.call(l,l.__data__,p,h),m=Object(i.f)(l,n),y=0,g=v.length;y<g;++y)(b=v[y])&&Object(i.e)(b,e,n,y,v,m);c.push(v),s.push(l)}return new a.a(c,s,e,n)}},function(t,e,n){"use strict";var r=n(3),a=r.selection.prototype.constructor;e.a=function(){return new a(this._groups,this._parents)}},function(t,e,n){"use strict";function styleRemove(t,e){var n,r,i;return function(){var o=Object(a.style)(this,t),u=(this.style.removeProperty(t),Object(a.style)(this,t));return o===u?null:o===n&&u===r?i:i=e(n=o,r=u)}}function styleRemoveEnd(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){var r,i;return function(){var o=Object(a.style)(this,t);return o===n?null:o===r?i:i=e(r=o,n)}}function styleFunction(t,e,n){var r,i,o;return function(){var u=Object(a.style)(this,t),c=n(this);return null==c&&(this.style.removeProperty(t),c=Object(a.style)(this,t)),u===c?null:u===r&&c===i?o:o=e(r=u,i=c)}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e,n){var a="transform"==(t+="")?r.interpolateTransformCss:o.a;return null==e?this.styleTween(t,styleRemove(t,a)).on("end.style."+t,styleRemoveEnd(t)):this.styleTween(t,"function"==typeof e?styleFunction(t,a,Object(i.b)(this,"style."+t,e)):styleConstant(t,a,e+""),n)}},function(t,e,n){"use strict";function styleTween(t,e,n){function tween(){var r=this,a=e.apply(r,arguments);return a&&function(e){r.style.setProperty(t,a(e),n)}}return tween._value=e,tween}e.a=function(t,e,n){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==e)return this.tween(r,null);if("function"!=typeof e)throw new Error;return this.tween(r,styleTween(t,e,null==n?"":n))}},function(t,e,n){"use strict";function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t(this);this.textContent=null==e?"":e}}var r=n(17);e.a=function(t){return this.tween("text","function"==typeof t?textFunction(Object(r.b)(this,"text",t)):textConstant(null==t?"":t+""))}},function(t,e,n){"use strict";var r=n(7),a=n(2);e.a=function(){for(var t=this._name,e=this._id,n=Object(r.c)(),i=this._groups,o=i.length,u=0;u<o;++u)for(var c,s=i[u],f=s.length,l=0;l<f;++l)if(c=s[l]){var h=Object(a.f)(c,e);Object(a.e)(c,t,n,l,s,{time:h.time+h.delay+h.duration,delay:0,duration:h.duration,ease:h.ease})}return new r.a(i,this._parents,t,n)}},function(t,e,n){"use strict";var r=n(7),a=n(2),i=[null];e.a=function(t,e){var n,o,u=t.__transition;if(u){e=null==e?null:e+"";for(o in u)if((n=u[o]).state>a.c&&n.name===e)return new r.a([[t]],i,e,+o)}return null}},function(t,e,n){"use strict";var r=n(61),a=n(34),i=n(85),o=n(181);e.a=function(){function line(a){var i,o,f,l=a.length,h=!1;for(null==u&&(s=c(f=Object(r.a)())),i=0;i<=l;++i)!(i<l&&n(o=a[i],i,a))===h&&((h=!h)?s.lineStart():s.lineEnd()),h&&s.point(+t(o,i,a),+e(o,i,a));if(f)return s=null,f+""||null}var t=o.a,e=o.b,n=Object(a.a)(!0),u=null,c=i.a,s=null;return line.x=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(+e),line):t},line.y=function(t){return arguments.length?(e="function"==typeof t?t:Object(a.a)(+t),line):e},line.defined=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(!!t),line):n},line.curve=function(t){return arguments.length?(c=t,null!=u&&(s=c(u)),line):c},line.context=function(t){return arguments.length?(null==t?u=s=null:s=c(u=t),line):u},line}},function(t,e,n){"use strict";function x(t){return t[0]}function y(t){return t[1]}e.a=x,e.b=y},function(t,e,n){"use strict";function point(t,e,n){var a=t._x1,i=t._y1,o=t._x2,u=t._y2;if(t._l01_a>r.f){var c=2*t._l01_2a+3*t._l01_a*t._l12_a+t._l12_2a,s=3*t._l01_a*(t._l01_a+t._l12_a);a=(a*c-t._x0*t._l12_2a+t._x2*t._l01_2a)/s,i=(i*c-t._y0*t._l12_2a+t._y2*t._l01_2a)/s}if(t._l23_a>r.f){var f=2*t._l23_2a+3*t._l23_a*t._l12_a+t._l12_2a,l=3*t._l23_a*(t._l23_a+t._l12_a);o=(o*f+t._x1*t._l23_2a-e*t._l12_2a)/l,u=(u*f+t._y1*t._l23_2a-n*t._l12_2a)/l}t._context.bezierCurveTo(a,i,o,u,t._x2,t._y2)}function CatmullRom(t,e){this._context=t,this._alpha=e}e.b=point;var r=n(62),a=n(88);CatmullRom.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:this.point(this._x2,this._y2)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){if(t=+t,e=+e,this._point){var n=this._x2-t,r=this._y2-e;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(n*n+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;break;case 2:this._point=3;default:point(this,t,e)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.a=function custom(t){function catmullRom(e){return t?new CatmullRom(e,t):new a.a(e,0)}return catmullRom.alpha=function(t){return custom(+t)},catmullRom}(.5)},function(t,e,n){"use strict";function sum(t){for(var e,n=0,r=-1,a=t.length;++r<a;)(e=+t[r][1])&&(n+=e);return n}e.b=sum;var r=n(64);e.a=function(t){var e=t.map(sum);return Object(r.a)(t).sort(function(t,n){return e[t]-e[n]})}},function(t,e,n){"use strict";var r=n(69);e.a=function(t,e,n){var a,i,o,u,c=t.length,s=e.length,f=new Array(c*s);for(null==n&&(n=r.b),a=o=0;a<c;++a)for(u=t[a],i=0;i<s;++i,++o)f[o]=n(u,e[i]);return f}},function(t,e,n){"use strict";e.a=function(t,e){return e<t?-1:e>t?1:e>=t?0:NaN}},function(t,e,n){"use strict";var r=n(73),a=n(67),i=n(187),o=n(72),u=n(188),c=n(74),s=n(75),f=n(76);e.a=function(){function histogram(r){var i,o,u=r.length,f=new Array(u);for(i=0;i<u;++i)f[i]=t(r[i],i,r);var l=e(f),h=l[0],d=l[1],p=n(f,h,d);Array.isArray(p)||(p=Object(s.c)(h,d,p),p=Object(c.a)(Math.ceil(h/p)*p,Math.floor(d/p)*p,p));for(var b=p.length;p[0]<=h;)p.shift(),--b;for(;p[b-1]>d;)p.pop(),--b;var v,m=new Array(b+1);for(i=0;i<=b;++i)v=m[i]=[],v.x0=i>0?p[i-1]:h,v.x1=i<b?p[i]:d;for(i=0;i<u;++i)o=f[i],h<=o&&o<=d&&m[Object(a.c)(p,o,0,b)].push(r[i]);return m}var t=u.a,e=o.a,n=f.a;return histogram.value=function(e){return arguments.length?(t="function"==typeof e?e:Object(i.a)(e),histogram):t},histogram.domain=function(t){return arguments.length?(e="function"==typeof t?t:Object(i.a)([t[0],t[1]]),histogram):e},histogram.thresholds=function(t){return arguments.length?(n="function"==typeof t?t:Array.isArray(t)?Object(i.a)(r.b.call(t)):Object(i.a)(t),histogram):n},histogram}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(73),a=n(10),i=n(12),o=n(36);e.a=function(t,e,n){return t=r.a.call(t,i.a).sort(a.a),Math.ceil((n-e)/(2*(Object(o.a)(t,.75)-Object(o.a)(t,.25))*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";var r=n(70);e.a=function(t,e,n){return Math.ceil((n-e)/(3.5*Object(r.a)(t)*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&n>r&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&n>r&&(r=n);return r}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a=t.length,i=a,o=-1,u=0;if(null==e)for(;++o<a;)isNaN(n=Object(r.a)(t[o]))?--i:u+=n;else for(;++o<a;)isNaN(n=Object(r.a)(e(t[o],o,t)))?--i:u+=n;if(i)return u/i}},function(t,e,n){"use strict";var r=n(10),a=n(12),i=n(36);e.a=function(t,e){var n,o=t.length,u=-1,c=[];if(null==e)for(;++u<o;)isNaN(n=Object(a.a)(t[u]))||c.push(n);else for(;++u<o;)isNaN(n=Object(a.a)(e(t[u],u,t)))||c.push(n);return Object(i.a)(c.sort(r.a),.5)}},function(t,e,n){"use strict";e.a=function(t){for(var e,n,r,a=t.length,i=-1,o=0;++i<a;)o+=t[i].length;for(n=new Array(o);--a>=0;)for(r=t[a],e=r.length;--e>=0;)n[--o]=r[e];return n}},function(t,e,n){"use strict";e.a=function(t,e){for(var n=e.length,r=new Array(n);n--;)r[n]=t[e[n]];return r}},function(t,e,n){"use strict";var r=n(10);e.a=function(t,e){if(n=t.length){var n,a,i=0,o=0,u=t[o];for(null==e&&(e=r.a);++i<n;)(e(a=t[i],u)<0||0!==e(u,u))&&(u=a,o=i);return 0===e(u,u)?o:void 0}}},function(t,e,n){"use strict";e.a=function(t,e,n){for(var r,a,i=(null==n?t.length:n)-(e=null==e?0:+e);i;)a=Math.random()*i--|0,r=t[i+e],t[i+e]=t[a+e],t[a+e]=r;return t}},function(t,e,n){"use strict";e.a=function(t,e){var n,r=t.length,a=-1,i=0;if(null==e)for(;++a<r;)(n=+t[a])&&(i+=n);else for(;++a<r;)(n=+e(t[a],a,t))&&(i+=n);return i}},function(t,e,n){"use strict";var r=n(78);e.a=function(){return Object(r.a)(arguments)}},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(){},function(t,e){t.setTime(+t+e)},function(t,e){return e-t});a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)(function(e){e.setTime(Math.floor(e/t)*t)},function(e,n){e.setTime(+e+n*t)},function(e,n){return(n-e)/t}):a:null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.d)*a.d)},function(t,e){t.setTime(+t+e*a.d)},function(t,e){return(e-t)/a.d},function(t){return t.getUTCSeconds()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.c)*a.c)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){var e=t.getTimezoneOffset()*a.c%a.b;e<0&&(e+=a.b),t.setTime(Math.floor((+t-e)/a.b)*a.b+e)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"a",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.a},function(t){return t.getDate()-1});e.b=i;var o=i.range},function(t,e,n){"use strict";function weekday(t){return Object(r.a)(function(e){e.setDate(e.getDate()-(e.getDay()+7-t)%7),e.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+7*e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=weekday(0),o=weekday(1),u=weekday(2),c=weekday(3),s=weekday(4),f=weekday(5),l=weekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setDate(1),t.setHours(0,0,0,0)},function(t,e){t.setMonth(t.getMonth()+e)},function(t,e){return e.getMonth()-t.getMonth()+12*(e.getFullYear()-t.getFullYear())},function(t){return t.getMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setMonth(0,1),t.setHours(0,0,0,0)},function(t,e){t.setFullYear(t.getFullYear()+e)},function(t,e){return e.getFullYear()-t.getFullYear()},function(t){return t.getFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setFullYear(Math.floor(e.getFullYear()/t)*t),e.setMonth(0,1),e.setHours(0,0,0,0)},function(e,n){e.setFullYear(e.getFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCSeconds(0,0)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getUTCMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCMinutes(0,0,0)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getUTCHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+e)},function(t,e){return(e-t)/a.a},function(t){return t.getUTCDate()-1});e.a=i;var o=i.range},function(t,e,n){"use strict";function utcWeekday(t){return Object(r.a)(function(e){e.setUTCDate(e.getUTCDate()-(e.getUTCDay()+7-t)%7),e.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+7*e)},function(t,e){return(e-t)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=utcWeekday(0),o=utcWeekday(1),u=utcWeekday(2),c=utcWeekday(3),s=utcWeekday(4),f=utcWeekday(5),l=utcWeekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCMonth(t.getUTCMonth()+e)},function(t,e){return e.getUTCMonth()-t.getUTCMonth()+12*(e.getUTCFullYear()-t.getUTCFullYear())},function(t){return t.getUTCMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCFullYear(t.getUTCFullYear()+e)},function(t,e){return e.getUTCFullYear()-t.getUTCFullYear()},function(t){return t.getUTCFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setUTCFullYear(Math.floor(e.getUTCFullYear()/t)*t),e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0)},function(e,n){e.setUTCFullYear(e.getUTCFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";function parseIsoNative(t){var e=new Date(t);return isNaN(e)?null:e}var r=n(80),a=n(37),i=+new Date("2000-01-01T00:00:00.000Z")?parseIsoNative:Object(a.e)(r.b);e.a=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(216);n.d(e,"scaleBand",function(){return r.a}),n.d(e,"scalePoint",function(){return r.b});var a=n(222);n.d(e,"scaleIdentity",function(){return a.a});var i=n(14);n.d(e,"scaleLinear",function(){return i.a});var o=n(224);n.d(e,"scaleLog",function(){return o.a});var u=n(81);n.d(e,"scaleOrdinal",function(){return u.a}),n.d(e,"scaleImplicit",function(){return u.b});var c=n(225);n.d(e,"scalePow",function(){return c.a}),n.d(e,"scaleSqrt",function(){return c.b});var s=n(226);n.d(e,"scaleQuantile",function(){return s.a});var f=n(227);n.d(e,"scaleQuantize",function(){return f.a});var l=n(228);n.d(e,"scaleThreshold",function(){return l.a});var h=n(84);n.d(e,"scaleTime",function(){return h.b});var d=n(229);n.d(e,"scaleUtc",function(){return d.a});var p=n(230);n.d(e,"schemeCategory10",function(){return p.a});var b=n(231);n.d(e,"schemeCategory20b",function(){return b.a});var v=n(232);n.d(e,"schemeCategory20c",function(){return v.a});var m=n(233);n.d(e,"schemeCategory20",function(){return m.a});var y=n(234);n.d(e,"interpolateCubehelixDefault",function(){return y.a});var g=n(235);n.d(e,"interpolateRainbow",function(){return g.b}),n.d(e,"interpolateWarm",function(){return g.c}),n.d(e,"interpolateCool",function(){return g.a});var _=n(236);n.d(e,"interpolateViridis",function(){return _.a}),n.d(e,"interpolateMagma",function(){return _.c}),n.d(e,"interpolateInferno",function(){return _.b}),n.d(e,"interpolatePlasma",function(){return _.d});var x=n(237);n.d(e,"scaleSequential",function(){return x.a})},function(t,e,n){"use strict";function band(){function rescale(){var n=i().length,a=u[1]<u[0],h=u[a-0],d=u[1-a];t=(d-h)/Math.max(1,n-s+2*f),c&&(t=Math.floor(t)),h+=(d-h-t*(n-s))*l,e=t*(1-s),c&&(h=Math.round(h),e=Math.round(e));var p=Object(r.range)(n).map(function(e){return h+t*e});return o(a?p.reverse():p)}var t,e,n=Object(a.a)().unknown(void 0),i=n.domain,o=n.range,u=[0,1],c=!1,s=0,f=0,l=.5;return delete n.unknown,n.domain=function(t){return arguments.length?(i(t),rescale()):i()},n.range=function(t){return arguments.length?(u=[+t[0],+t[1]],rescale()):u.slice()},n.rangeRound=function(t){return u=[+t[0],+t[1]],c=!0,rescale()},n.bandwidth=function(){return e},n.step=function(){return t},n.round=function(t){return arguments.length?(c=!!t,rescale()):c},n.padding=function(t){return arguments.length?(s=f=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingInner=function(t){return arguments.length?(s=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingOuter=function(t){return arguments.length?(f=Math.max(0,Math.min(1,t)),rescale()):f},n.align=function(t){return arguments.length?(l=Math.max(0,Math.min(1,t)),rescale()):l},n.copy=function(){return band().domain(i()).range(u).round(c).paddingInner(s).paddingOuter(f).align(l)},rescale()}function pointish(t){var e=t.copy;return t.padding=t.paddingOuter,delete t.paddingInner,delete t.paddingOuter,t.copy=function(){return pointish(e())},t}function point(){return pointish(band().paddingInner(1))}e.a=band,e.b=point;var r=n(5),a=n(81)},function(t,e,n){"use strict";function createObject(){return{}}function setObject(t,e,n){t[e]=n}function createMap(){return Object(r.a)()}function setMap(t,e,n){t.set(e,n)}var r=n(38);e.a=function(){function apply(n,i,o,u){if(i>=a.length)return null!=t&&n.sort(t),null!=e?e(n):n;for(var c,s,f,l=-1,h=n.length,d=a[i++],p=Object(r.a)(),b=o();++l<h;)(f=p.get(c=d(s=n[l])+""))?f.push(s):p.set(c,[s]);return p.each(function(t,e){u(b,e,apply(t,i,o,u))}),b}function entries(t,n){if(++n>a.length)return t;var r,o=i[n-1];return null!=e&&n>=a.length?r=t.entries():(r=[],t.each(function(t,e){r.push({key:e,values:entries(t,n)})})),null!=o?r.sort(function(t,e){return o(t.key,e.key)}):r}var t,e,n,a=[],i=[];return n={object:function(t){return apply(t,0,createObject,setObject)},map:function(t){return apply(t,0,createMap,setMap)},entries:function(t){return entries(apply(t,0,createMap,setMap),0)},key:function(t){return a.push(t),n},sortKeys:function(t){return i[a.length-1]=t,n},sortValues:function(e){return t=e,n},rollup:function(t){return e=t,n}}}},function(t,e,n){"use strict";function Set(){}function set(t,e){var n=new Set;if(t instanceof Set)t.each(function(t){n.add(t)});else if(t){var r=-1,a=t.length;if(null==e)for(;++r<a;)n.add(t[r]);else for(;++r<a;)n.add(e(t[r],r,t))}return n}var r=n(38),a=r.a.prototype;Set.prototype=set.prototype={constructor:Set,has:a.has,add:function(t){return t+="",this[r.b+t]=t,this},remove:a.remove,clear:a.clear,values:a.keys,size:a.size,empty:a.empty,each:a.each},e.a=set},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(n);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(t[n]);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push({key:n,value:t[n]});return e}},function(t,e,n){"use strict";function identity(){function scale(t){return+t}var t=[0,1];return scale.invert=scale,scale.domain=scale.range=function(e){return arguments.length?(t=r.a.call(e,i.a),scale):t.slice()},scale.copy=function(){return identity().domain(t)},Object(a.b)(scale)}e.a=identity;var r=n(9),a=n(14),i=n(82)},function(t,e,n){"use strict";var r=n(5),a=n(21);e.a=function(t,e,n){var i,o=t[0],u=t[t.length-1],c=Object(r.tickStep)(o,u,null==e?10:e);switch(n=Object(a.formatSpecifier)(null==n?",f":n),n.type){case"s":var s=Math.max(Math.abs(o),Math.abs(u));return null!=n.precision||isNaN(i=Object(a.precisionPrefix)(c,s))||(n.precision=i),Object(a.formatPrefix)(n,s);case"":case"e":case"g":case"p":case"r":null!=n.precision||isNaN(i=Object(a.precisionRound)(c,Math.max(Math.abs(o),Math.abs(u))))||(n.precision=i-("e"===n.type));break;case"f":case"%":null!=n.precision||isNaN(i=Object(a.precisionFixed)(c))||(n.precision=i-2*("%"===n.type))}return Object(a.format)(n)}},function(t,e,n){"use strict";function deinterpolate(t,e){return(e=Math.log(e/t))?function(n){return Math.log(n/t)/e}:Object(i.a)(e)}function reinterpolate(t,e){return t<0?function(n){return-Math.pow(-e,n)*Math.pow(-t,1-n)}:function(n){return Math.pow(e,n)*Math.pow(t,1-n)}}function pow10(t){return isFinite(t)?+("1e"+t):t<0?0:t}function powp(t){return 10===t?pow10:t===Math.E?Math.exp:function(e){return Math.pow(t,e)}}function logp(t){return t===Math.E?Math.log:10===t&&Math.log10||2===t&&Math.log2||(t=Math.log(t),function(e){return Math.log(e)/t})}function reflect(t){return function(e){return-t(-e)}}function log(){function rescale(){return i=logp(n),c=powp(n),e()[0]<0&&(i=reflect(i),c=reflect(c)),t}var t=Object(u.b)(deinterpolate,reinterpolate).domain([1,10]),e=t.domain,n=10,i=logp(10),c=powp(10);return t.base=function(t){return arguments.length?(n=+t,rescale()):n},t.domain=function(t){return arguments.length?(e(t),rescale()):e()},t.ticks=function(t){var a,o=e(),u=o[0],s=o[o.length-1];(a=s<u)&&(d=u,u=s,s=d);var f,l,h,d=i(u),p=i(s),b=null==t?10:+t,v=[];if(!(n%1)&&p-d<b){if(d=Math.round(d)-1,p=Math.round(p)+1,u>0){for(;d<p;++d)for(l=1,f=c(d);l<n;++l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else for(;d<p;++d)for(l=n-1,f=c(d);l>=1;--l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else v=Object(r.ticks)(d,p,Math.min(p-d,b)).map(c);return a?v.reverse():v},t.tickFormat=function(e,r){if(null==r&&(r=10===n?".0e":","),"function"!=typeof r&&(r=Object(a.format)(r)),e===1/0)return r;null==e&&(e=10);var o=Math.max(1,n*e/t.ticks().length);return function(t){var e=t/c(Math.round(i(t)));return e*n<n-.5&&(e*=n),e<=o?r(t):""}},t.nice=function(){return e(Object(o.a)(e(),{floor:function(t){return c(Math.floor(i(t)))},ceil:function(t){return c(Math.ceil(i(t)))}}))},t.copy=function(){return Object(u.a)(t,log().base(n))},t}e.a=log;var r=n(5),a=n(21),i=n(39),o=n(83),u=n(18)},function(t,e,n){"use strict";function raise(t,e){return t<0?-Math.pow(-t,e):Math.pow(t,e)}function pow(){function deinterpolate(e,n){return(n=raise(n,t)-(e=raise(e,t)))?function(r){return(raise(r,t)-e)/n}:Object(r.a)(n)}function reinterpolate(e,n){return n=raise(n,t)-(e=raise(e,t)),function(r){return raise(e+n*r,1/t)}}var t=1,e=Object(i.b)(deinterpolate,reinterpolate),n=e.domain;return e.exponent=function(e){return arguments.length?(t=+e,n(n())):t},e.copy=function(){return Object(i.a)(e,pow().exponent(t))},Object(a.b)(e)}function sqrt(){return pow().exponent(.5)}e.a=pow,e.b=sqrt;var r=n(39),a=n(14),i=n(18)},function(t,e,n){"use strict";function quantile(){function rescale(){var a=0,i=Math.max(1,e.length);for(n=new Array(i-1);++a<i;)n[a-1]=Object(r.quantile)(t,a/i);return scale}function scale(t){if(!isNaN(t=+t))return e[Object(r.bisect)(n,t)]}var t=[],e=[],n=[];return scale.invertExtent=function(r){var a=e.indexOf(r);return a<0?[NaN,NaN]:[a>0?n[a-1]:t[0],a<n.length?n[a]:t[t.length-1]]},scale.domain=function(e){if(!arguments.length)return t.slice();t=[];for(var n,a=0,i=e.length;a<i;++a)null==(n=e[a])||isNaN(n=+n)||t.push(n);return t.sort(r.ascending),rescale()},scale.range=function(t){return arguments.length?(e=a.b.call(t),rescale()):e.slice()},scale.quantiles=function(){return n.slice()},scale.copy=function(){return quantile().domain(t).range(e)},scale}e.a=quantile;var r=n(5),a=n(9)},function(t,e,n){"use strict";function quantize(){function scale(t){if(t<=t)return u[Object(r.bisect)(o,t,0,n)]}function rescale(){var r=-1;for(o=new Array(n);++r<n;)o[r]=((r+1)*e-(r-n)*t)/(n+1);return scale}var t=0,e=1,n=1,o=[.5],u=[0,1];return scale.domain=function(n){return arguments.length?(t=+n[0],e=+n[1],rescale()):[t,e]},scale.range=function(t){return arguments.length?(n=(u=a.b.call(t)).length-1,rescale()):u.slice()},scale.invertExtent=function(r){var a=u.indexOf(r);return a<0?[NaN,NaN]:a<1?[t,o[0]]:a>=n?[o[n-1],e]:[o[a-1],o[a]]},scale.copy=function(){return quantize().domain([t,e]).range(u)},Object(i.b)(scale)}e.a=quantize;var r=n(5),a=n(9),i=n(14)},function(t,e,n){"use strict";function threshold(){function scale(a){if(a<=a)return e[Object(r.bisect)(t,a,0,n)]}var t=[.5],e=[0,1],n=1;return scale.domain=function(r){return arguments.length?(t=a.b.call(r),n=Math.min(t.length,e.length-1),scale):t.slice()},scale.range=function(r){return arguments.length?(e=a.b.call(r),n=Math.min(t.length,e.length-1),scale):e.slice()},scale.invertExtent=function(n){var r=e.indexOf(n);return[t[r-1],t[r]]},scale.copy=function(){return threshold().domain(t).range(e)},scale}e.a=threshold;var r=n(5),a=n(9)},function(t,e,n){"use strict";var r=n(84),a=n(40),i=n(35);e.a=function(){return Object(r.a)(i.utcYear,i.utcMonth,i.utcWeek,i.utcDay,i.utcHour,i.utcMinute,i.utcSecond,i.utcMillisecond,a.utcFormat).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)])}},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5")},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(300,.5,0),Object(r.cubehelix)(-240,.5,1))},function(t,e,n){"use strict";n.d(e,"c",function(){return i}),n.d(e,"a",function(){return o});var r=n(4),a=n(8),i=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(-100,.75,.35),Object(r.cubehelix)(80,1.5,.8)),o=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(260,.75,.35),Object(r.cubehelix)(80,1.5,.8)),u=Object(r.cubehelix)();e.b=function(t){(t<0||t>1)&&(t-=Math.floor(t));var e=Math.abs(t-.5);return u.h=360*t-100,u.s=1.5-1.5*e,u.l=.8-.9*e,u+""}},function(t,e,n){"use strict";function ramp(t){var e=t.length;return function(n){return t[Math.max(0,Math.min(e-1,Math.floor(n*e)))]}}n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"d",function(){return o});var r=n(16);e.a=ramp(Object(r.a)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));var a=ramp(Object(r.a)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),i=ramp(Object(r.a)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),o=ramp(Object(r.a)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"))},function(t,e,n){"use strict";function sequential(t){function scale(r){var i=(r-e)/(n-e);return t(a?Math.max(0,Math.min(1,i)):i)}var e=0,n=1,a=!1;return scale.domain=function(t){return arguments.length?(e=+t[0],n=+t[1],scale):[e,n]},scale.clamp=function(t){return arguments.length?(a=!!t,scale):a},scale.interpolator=function(e){return arguments.length?(t=e,scale):t},scale.copy=function(){return sequential(t).domain([e,n]).clamp(a)},Object(r.b)(scale)}e.a=sequential;var r=n(14)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{bar:'\n            <svg class="load-state bar-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 325">\n              \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(0 29)">\n                        <g stroke="#EFF2F5" stroke-dasharray="4 4">\n                            <path d="M.400592911 200.302477L710.674315 200.302477M.400592884 131.172748L710.674315 131.172748M.324410282 64.2071321L710.621499 64.2071321M.291004517.563888874L709.82431.563888889"/>\n                        </g>\n                        <g fill="#D2D6DF" transform="translate(63.08 11)">\n                            <polygon points="-.08 176 23.92 176 23.92 255 -.08 255"/>\n                            <polygon points="50.829 147 74.829 147 74.829 255 50.829 255"/>\n                            <polygon points="254.465 0 278.465 0 278.465 255 254.465 255"/>\n                            <polygon points="458.102 169 482.102 169 482.102 255 458.102 255"/>\n                            <polygon points="152.647 82 176.647 82 176.647 255 152.647 255"/>\n                            <polygon points="356.283 66 380.283 66 380.283 255 356.283 255"/>\n                            <polygon points="559.92 229 583.92 229 583.92 255 559.92 255"/>\n                            <polygon points="101.738 115 125.738 115 125.738 255 101.738 255"/>\n                            <polygon points="305.374 42 329.374 42 329.374 255 305.374 255"/>\n                            <polygon points="509.011 201 533.011 201 533.011 255 509.011 255"/>\n                            <polygon points="203.556 19 227.556 19 227.556 255 203.556 255"/>\n                            <polygon points="407.192 115 431.192 115 431.192 255 407.192 255"/>\n                        </g>\n                    </g>\n                    <polygon fill="#D2D6DF" fill-rule="nonzero" points="0 295 711 295 711 294 0 294"/>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',donut:'\n            <svg class="load-state donut-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 376 331">\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(116 107)">\n                        <circle cx="72" cy="72" r="72" stroke="#EFF2F5" stroke-linecap="round" stroke-width="9.6"/>\n                        <path stroke="#D2D6DF" stroke-width="19.2" d="M126.153559,119.524055 C137.264629,106.845712 144,90.2321371 144,72.0444604 C144,32.2554036 111.764502,0 72,0"/>\n                        <circle cx="72" cy="72" r="67.2" fill="#FFF"/>\n                    </g>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',line:'\n            <svg \n                class="load-state line-load-state" \n                xmlns="http://www.w3.org/2000/svg" \n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path \n                    id="chart-bg" \n                    class="chart-bg" \n                    style="stroke:#C3C6CF;" \n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n               <polyline \n                    id="chart-line" \n                    class="chart-line" \n                    style="stroke:#C3C6CF;stroke-width:4;fill:none;" \n                    points="8.8,175.8 62.4,237.7 116.1,184.7 169.7,175.8 223.3,57 277,176.8 330.6,176.8 384.3,122.5 437.9,176.8 491.6,176.8 545.2,218.4 598.8,122.5 652.5,184.7 706.1,135.1 "\n                />\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        '}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r=n(61),a=n(34),i=n(85),o=n(180),u=n(181);e.a=function(){function area(a){var i,o,u,d,p,b=a.length,v=!1,m=new Array(b),y=new Array(b);for(null==f&&(h=l(p=Object(r.a)())),i=0;i<=b;++i){if(!(i<b&&s(d=a[i],i,a))===v)if(v=!v)o=i,h.areaStart(),h.lineStart();else{for(h.lineEnd(),h.lineStart(),u=i-1;u>=o;--u)h.point(m[u],y[u]);h.lineEnd(),h.areaEnd()}v&&(m[i]=+t(d,i,a),y[i]=+n(d,i,a),h.point(e?+e(d,i,a):m[i],c?+c(d,i,a):y[i]))}if(p)return h=null,p+""||null}function arealine(){return Object(o.a)().defined(s).curve(l).context(f)}var t=u.a,e=null,n=Object(a.a)(0),c=u.b,s=Object(a.a)(!0),f=null,l=i.a,h=null;return area.x=function(n){return arguments.length?(t="function"==typeof n?n:Object(a.a)(+n),e=null,area):t},area.x0=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(+e),area):t},area.x1=function(t){return arguments.length?(e=null==t?null:"function"==typeof t?t:Object(a.a)(+t),area):e},area.y=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(+t),c=null,area):n},area.y0=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(+t),area):n},area.y1=function(t){return arguments.length?(c=null==t?null:"function"==typeof t?t:Object(a.a)(+t),area):c},area.lineX0=area.lineY0=function(){return arealine().x(t).y(n)},area.lineY1=function(){return arealine().x(t).y(c)},area.lineX1=function(){return arealine().x(e).y(n)},area.defined=function(t){return arguments.length?(s="function"==typeof t?t:Object(a.a)(!!t),area):s},area.curve=function(t){return arguments.length?(l=t,null!=f&&(h=l(f)),area):l},area.context=function(t){return arguments.length?(null==t?f=h=null:h=l(f=t),area):f},area}},function(t,e,n){"use strict";function Radial(t){this._curve=t}function curveRadial(t){function radial(e){return new Radial(t(e))}return radial._curve=t,radial}n.d(e,"a",function(){return a}),e.b=curveRadial;var r=n(85),a=curveRadial(r.a);Radial.prototype={areaStart:function(){this._curve.areaStart()},areaEnd:function(){this._curve.areaEnd()},lineStart:function(){this._curve.lineStart()},lineEnd:function(){this._curve.lineEnd()},point:function(t,e){this._curve.point(e*Math.sin(t),e*-Math.cos(t))}}},function(t,e,n){"use strict";function lineRadial(t){var e=t.curve;return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t.curve=function(t){return arguments.length?e(Object(r.b)(t)):e()._curve},t}e.b=lineRadial;var r=n(240),a=n(180);e.a=function(){return lineRadial(Object(a.a)().curve(r.a))}},function(t,e,n){"use strict";e.a=function(t,e){return[(e=+e)*Math.cos(t-=Math.PI/2),e*Math.sin(t)]}},function(t,e,n){"use strict";n.d(e,"a",function(){return r});var r=Array.prototype.slice},function(t,e,n){"use strict";var r=n(62);e.a={draw:function(t,e){var n=Math.sqrt(e/r.j);t.moveTo(n,0),t.arc(0,0,n,0,r.m)}}},function(t,e,n){"use strict";e.a={draw:function(t,e){var n=Math.sqrt(e/5)/2;t.moveTo(-3*n,-n),t.lineTo(-n,-n),t.lineTo(-n,-3*n),t.lineTo(n,-3*n),t.lineTo(n,-n),t.lineTo(3*n,-n),t.lineTo(3*n,n),t.lineTo(n,n),t.lineTo(n,3*n),t.lineTo(-n,3*n),t.lineTo(-n,n),t.lineTo(-3*n,n),t.closePath()}}},function(t,e,n){"use strict";var r=Math.sqrt(1/3),a=2*r;e.a={draw:function(t,e){var n=Math.sqrt(e/a),i=n*r;t.moveTo(0,-n),t.lineTo(i,0),t.lineTo(0,n),t.lineTo(-i,0),t.closePath()}}},function(t,e,n){"use strict";var r=n(62),a=Math.sin(r.j/10)/Math.sin(7*r.j/10),i=Math.sin(r.m/10)*a,o=-Math.cos(r.m/10)*a;e.a={draw:function(t,e){var n=Math.sqrt(.8908130915292852*e),a=i*n,u=o*n;t.moveTo(0,-n),t.lineTo(a,u);for(var c=1;c<5;++c){var s=r.m*c/5,f=Math.cos(s),l=Math.sin(s);t.lineTo(l*n,-f*n),t.lineTo(f*a-l*u,l*a+f*u)}t.closePath()}}},function(t,e,n){"use strict";e.a={draw:function(t,e){var n=Math.sqrt(e),r=-n/2;t.rect(r,r,n,n)}}},function(t,e,n){"use strict";var r=Math.sqrt(3);e.a={draw:function(t,e){var n=-Math.sqrt(e/(3*r));t.moveTo(0,2*n),t.lineTo(-r*n,-n),t.lineTo(r*n,-n),t.closePath()}}},function(t,e,n){"use strict";var r=-.5,a=Math.sqrt(3)/2,i=1/Math.sqrt(12),o=3*(i/2+1);e.a={draw:function(t,e){var n=Math.sqrt(e/o),u=n/2,c=n*i,s=u,f=n*i+n,l=-s,h=f;t.moveTo(u,c),t.lineTo(s,f),t.lineTo(l,h),t.lineTo(r*u-a*c,a*u+r*c),t.lineTo(r*s-a*f,a*s+r*f),t.lineTo(r*l-a*h,a*l+r*h),t.lineTo(r*u+a*c,r*c-a*u),t.lineTo(r*s+a*f,r*f-a*s),t.lineTo(r*l+a*h,r*h-a*l),t.closePath()}}},function(t,e,n){"use strict";function CardinalClosed(t,e){this._context=t,this._k=(1-e)/6}e.a=CardinalClosed;var r=n(86),a=n(88);CardinalClosed.prototype={areaStart:r.a,areaEnd:r.a,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._x3=t,this._y3=e;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=e);break;case 2:this._point=3,this._x5=t,this._y5=e;break;default:Object(a.c)(this,t,e)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.b=function custom(t){function cardinal(e){return new CardinalClosed(e,t)}return cardinal.tension=function(t){return custom(+t)},cardinal}(0)},function(t,e,n){"use strict";function CardinalOpen(t,e){this._context=t,this._k=(1-e)/6}e.a=CardinalOpen;var r=n(88);CardinalOpen.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Object(r.c)(this,t,e)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.b=function custom(t){function cardinal(e){return new CardinalOpen(e,t)}return cardinal.tension=function(t){return custom(+t)},cardinal}(0)},function(t,e,n){"use strict";var r;void 0!==(r=function(t){function exportChart(t,e,n){var r=createImage(convertSvgToHtml.call(this,t,n));r.onload=handleImageLoad.bind(r,createCanvas(this.width(),this.height()),e)}function addBackground(t){return t.replace(">",">"+c.styleBackgroundString)}function convertSvgToHtml(t,e){if(t){t.attr("version",1.1).attr("xmlns","http://www.w3.org/2000/svg");var n=a.initializeSerializer(),r=n(t.node());return r=formatHtmlByBrowser(r),r=prependTitle.call(this,r,e,parseInt(t.attr("width"),10)),r=addBackground(r)}}function createCanvas(t,e){var n=document.createElement("canvas");return n.height=e,n.width=t,n}function createImage(t){var e=new Image;return e.src=""+c.imageSourceBase+u(t),e}function drawImageOnCanvas(t,e){return e.getContext("2d").drawImage(t,0,0),e}function downloadCanvas(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:c.defaultFilename,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"image/png",r=t.toDataURL(n),a=document.createElement("a");a.href=r,a.download=e,document.body.appendChild(a),a.click(),document.body.removeChild(a)}function formatHtmlByBrowser(t){return navigator.userAgent.search("FireFox")>-1?t.replace(/url.*&quot;\)/,'url(&quot;linearGradient[id*="-gradient-"]&quot;);'):t}function handleImageLoad(t,e,n){n.preventDefault(),downloadCanvas(drawImageOnCanvas(this,t),e)}function prependTitle(t,e,n){if(!e||!n)return t;var a=r.grey;return t=t.replace(/<g/,'<text x="'+this.margin().left+'" y="'+c.titleTopOffset+'" font-family="'+c.titleFontFamily+'" font-size="'+c.titleFontSize+'" fill="'+a[6]+'"> '+e+" </text><g ")}var e=n(89),r=e.colorSchemas,a=(n(90),n(254)),i="undefined"!=typeof window,o=i&&window.btoa;o||(o=n(255).encode);var u=function(t){return o(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g,function(t,e){return String.fromCharCode("0x"+e)}))},c={styleClass:"britechartStyle",defaultFilename:"britechart.png",chartBackground:"white",imageSourceBase:"data:image/svg+xml;base64,",titleFontSize:"15px",titleFontFamily:"'Benton Sans', sans-serif",titleTopOffset:30,get styleBackgroundString(){return"<style>svg{background:"+this.chartBackground+";}</style>"}};return{exportChart:exportChart,convertSvgToHtml:convertSvgToHtml,createImage:createImage,drawImageOnCanvas:drawImageOnCanvas}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";t.exports=function(){return{initializeSerializer:function(){function computeDefaultStyleByTagName(t){var e={},n=document.body.appendChild(document.createElement(t)),r=window.getComputedStyle(n);return[].forEach.call(r,function(t){e[t]=r[t]}),document.body.removeChild(n),e}function getDefaultStyleByTagName(e){return e=e.toUpperCase(),t[e]||(t[e]=computeDefaultStyleByTagName(e)),t[e]}function serializeWithStyles(t){var n=[],r=void 0,a=void 0,i=void 0,o=void 0;if(t&&t.nodeType===Node.ELEMENT_NODE)return n=[],r=t.querySelectorAll("*"),[].forEach.call(r,function(t,r){e[t.tagName]||(a=window.getComputedStyle(t),i=getDefaultStyleByTagName(t.tagName),n[r]=t.style.cssText,[].forEach.call(a,function(e){a[e]!==i[e]&&(t.style[e]=a[e])}))}),o=t.outerHTML,r=[].map.call(r,function(t,e){return t.style.cssText=n[e],t}),o}var t={},e={BASE:!0,HEAD:!0,HTML:!0,META:!0,NOFRAME:!0,NOSCRIPT:!0,PARAM:!0,SCRIPT:!0,STYLE:!0,TITLE:!0},n=["A","ABBR","ADDRESS","AREA","ARTICLE","ASIDE","AUDIO","B","BASE","BDI","BDO","BLOCKQUOTE","BODY","BR","BUTTON","CANVAS","CAPTION","CENTER","CITE","CODE","COL","COLGROUP","COMMAND","DATALIST","DD","DEL","DETAILS","DFN","DIV","DL","DT","EM","EMBED","FIELDSET","FIGCAPTION","FIGURE","FONT","FOOTER","FORM","H1","H2","H3","H4","H5","H6","HEAD","HEADER","HGROUP","HR","HTML","I","IFRAME","IMG","INPUT","INS","KBD","LABEL","LEGEND","LI","LINK","MAP","MARK","MATH","MENU","META","METER","NAV","NOBR","NOSCRIPT","OBJECT","OL","OPTION","OPTGROUP","OUTPUT","P","PARAM","PRE","PROGRESS","Q","RP","RT","RUBY","S","SAMP","SCRIPT","SECTION","SELECT","SMALL","SOURCE","SPAN","STRONG","STYLE","SUB","SUMMARY","SUP","SVG","TABLE","TBODY","TD","TEXTAREA","TFOOT","TH","THEAD","TIME","TITLE","TR","TRACK","U","UL","VAR","VIDEO","WBR"];return[].forEach.call(n,function(n){e[n]||(t[n]=computeDefaultStyleByTagName(n))}),serializeWithStyles}}}()},function(t,e,n){(function(t,r){var a;!function(i){var o="object"==typeof e&&e,u=("object"==typeof t&&t&&t.exports,"object"==typeof r&&r);var c=function(t){this.message=t};c.prototype=new Error,c.prototype.name="InvalidCharacterError";var s=function(t){throw new c(t)},f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=/[\t\n\f\r ]/g,h=function(t){t=String(t).replace(l,"");var e=t.length;e%4==0&&(t=t.replace(/==?$/,""),e=t.length),(e%4==1||/[^+a-zA-Z0-9\/]/.test(t))&&s("Invalid character: the string to be decoded is not correctly encoded.");for(var n,r,a=0,i="",o=-1;++o<e;)r=f.indexOf(t.charAt(o)),n=a%4?64*n+r:r,a++%4&&(i+=String.fromCharCode(255&n>>(-2*a&6)));return i},d=function(t){t=String(t),/[^\0-\xFF]/.test(t)&&s("The string to be encoded contains characters outside of the Latin1 range.");for(var e,n,r,a,i=t.length%3,o="",u=-1,c=t.length-i;++u<c;)e=t.charCodeAt(u)<<16,n=t.charCodeAt(++u)<<8,r=t.charCodeAt(++u),a=e+n+r,o+=f.charAt(a>>18&63)+f.charAt(a>>12&63)+f.charAt(a>>6&63)+f.charAt(63&a);return 2==i?(e=t.charCodeAt(u)<<8,n=t.charCodeAt(++u),a=e+n,o+=f.charAt(a>>10)+f.charAt(a>>4&63)+f.charAt(a<<2&63)+"="):1==i&&(a=t.charCodeAt(u),o+=f.charAt(a>>2)+f.charAt(a<<4&63)+"=="),o},p={encode:d,decode:h,version:"0.1.0"};void 0!==(a=function(){return p}.call(e,n,e,t))&&(t.exports=a)}()}).call(e,n(256)(t),n(257))},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(259);n.d(e,"axisTop",function(){return r.d}),n.d(e,"axisRight",function(){return r.c}),n.d(e,"axisBottom",function(){return r.a}),n.d(e,"axisLeft",function(){return r.b})},function(t,e,n){"use strict";function translateX(t){return"translate("+(t+.5)+",0)"}function translateY(t){return"translate(0,"+(t+.5)+")"}function number(t){return function(e){return+t(e)}}function center(t){var e=Math.max(0,t.bandwidth()-1)/2;return t.round()&&(e=Math.round(e)),function(n){return+t(n)+e}}function entering(){return!this.__axis}function axis(t,e){function axis(r){var y=null==f?e.ticks?e.ticks.apply(e,n):e.domain():f,g=null==l?e.tickFormat?e.tickFormat.apply(e,n):a.a:l,_=Math.max(h,0)+p,x=e.range(),w=+x[0]+.5,O=+x[x.length-1]+.5,M=(e.bandwidth?center:number)(e.copy()),C=r.selection?r.selection():r,j=C.selectAll(".domain").data([null]),T=C.selectAll(".tick").data(y,e).order(),k=T.exit(),S=T.enter().append("g").attr("class","tick"),N=T.select("line"),A=T.select("text");j=j.merge(j.enter().insert("path",".tick").attr("class","domain").attr("stroke","#000")),T=T.merge(S),N=N.merge(S.append("line").attr("stroke","#000").attr(v+"2",b*h)),A=A.merge(S.append("text").attr("fill","#000").attr(v,b*_).attr("dy",t===i?"0em":t===u?"0.71em":"0.32em")),r!==C&&(j=j.transition(r),T=T.transition(r),N=N.transition(r),A=A.transition(r),k=k.transition(r).attr("opacity",s).attr("transform",function(t){return isFinite(t=M(t))?m(t):this.getAttribute("transform")}),S.attr("opacity",s).attr("transform",function(t){var e=this.parentNode.__axis;return m(e&&isFinite(e=e(t))?e:M(t))})),k.remove(),j.attr("d",t===c||t==o?"M"+b*d+","+w+"H0.5V"+O+"H"+b*d:"M"+w+","+b*d+"V0.5H"+O+"V"+b*d),T.attr("opacity",1).attr("transform",function(t){return m(M(t))}),N.attr(v+"2",b*h),A.attr(v,b*_).text(g),C.filter(entering).attr("fill","none").attr("font-size",10).attr("font-family","sans-serif").attr("text-anchor",t===o?"start":t===c?"end":"middle"),C.each(function(){this.__axis=M})}var n=[],f=null,l=null,h=6,d=6,p=3,b=t===i||t===c?-1:1,v=t===c||t===o?"x":"y",m=t===i||t===u?translateX:translateY;return axis.scale=function(t){return arguments.length?(e=t,axis):e},axis.ticks=function(){return n=r.a.call(arguments),axis},axis.tickArguments=function(t){return arguments.length?(n=null==t?[]:r.a.call(t),axis):n.slice()},axis.tickValues=function(t){return arguments.length?(f=null==t?null:r.a.call(t),axis):f&&f.slice()},axis.tickFormat=function(t){return arguments.length?(l=t,axis):l},axis.tickSize=function(t){return arguments.length?(h=d=+t,axis):h},axis.tickSizeInner=function(t){return arguments.length?(h=+t,axis):h},axis.tickSizeOuter=function(t){return arguments.length?(d=+t,axis):d},axis.tickPadding=function(t){return arguments.length?(p=+t,axis):p},axis}function axisTop(t){return axis(i,t)}function axisRight(t){return axis(o,t)}function axisBottom(t){return axis(u,t)}function axisLeft(t){return axis(c,t)}e.d=axisTop,e.c=axisRight,e.a=axisBottom,e.b=axisLeft;var r=n(260),a=n(261),i=1,o=2,u=3,c=4,s=1e-6},function(t,e,n){"use strict";n.d(e,"a",function(){return r});var r=Array.prototype.slice},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(263);n.d(e,"arc",function(){return r.a});var a=n(239);n.d(e,"area",function(){return a.a});var i=n(180);n.d(e,"line",function(){return i.a});var o=n(265);n.d(e,"pie",function(){return o.a});var u=n(268);n.d(e,"areaRadial",function(){return u.a}),n.d(e,"radialArea",function(){return u.a});var c=n(241);n.d(e,"lineRadial",function(){return c.a}),n.d(e,"radialLine",function(){return c.a});var s=n(242);n.d(e,"pointRadial",function(){return s.a});var f=n(269);n.d(e,"linkHorizontal",function(){return f.a}),n.d(e,"linkVertical",function(){return f.c}),n.d(e,"linkRadial",function(){return f.b});var l=n(270);n.d(e,"symbol",function(){return l.a}),n.d(e,"symbols",function(){return l.b});var h=n(244);n.d(e,"symbolCircle",function(){return h.a});var d=n(245);n.d(e,"symbolCross",function(){return d.a});var p=n(246);n.d(e,"symbolDiamond",function(){return p.a});var b=n(248);n.d(e,"symbolSquare",function(){return b.a});var v=n(247);n.d(e,"symbolStar",function(){return v.a});var m=n(249);n.d(e,"symbolTriangle",function(){return m.a});var y=n(250);n.d(e,"symbolWye",function(){return y.a});var g=n(271);n.d(e,"curveBasisClosed",function(){return g.a});var _=n(272);n.d(e,"curveBasisOpen",function(){return _.a});var x=n(87);n.d(e,"curveBasis",function(){return x.b});var w=n(273);n.d(e,"curveBundle",function(){return w.a});var O=n(251);n.d(e,"curveCardinalClosed",function(){return O.b});var M=n(252);n.d(e,"curveCardinalOpen",function(){return M.b});var C=n(88);n.d(e,"curveCardinal",function(){return C.b});var j=n(274);n.d(e,"curveCatmullRomClosed",function(){return j.a});var T=n(275);n.d(e,"curveCatmullRomOpen",function(){return T.a});var k=n(182);n.d(e,"curveCatmullRom",function(){return k.a});var S=n(276);n.d(e,"curveLinearClosed",function(){return S.a});var N=n(85);n.d(e,"curveLinear",function(){return N.a});var A=n(277);n.d(e,"curveMonotoneX",function(){return A.a}),n.d(e,"curveMonotoneY",function(){return A.b});var E=n(278);n.d(e,"curveNatural",function(){return E.a});var D=n(279);n.d(e,"curveStep",function(){return D.a}),n.d(e,"curveStepAfter",function(){return D.b}),n.d(e,"curveStepBefore",function(){return D.c});var F=n(280);n.d(e,"stack",function(){return F.a});var I=n(281);n.d(e,"stackOffsetExpand",function(){return I.a});var P=n(282);n.d(e,"stackOffsetDiverging",function(){return P.a});var R=n(63);n.d(e,"stackOffsetNone",function(){return R.a});var L=n(283);n.d(e,"stackOffsetSilhouette",function(){return L.a});var U=n(284);n.d(e,"stackOffsetWiggle",function(){return U.a});var H=n(183);n.d(e,"stackOrderAscending",function(){return H.a});var Y=n(285);n.d(e,"stackOrderDescending",function(){return Y.a});var q=n(286);n.d(e,"stackOrderInsideOut",function(){return q.a});var B=n(64);n.d(e,"stackOrderNone",function(){return B.a});var z=n(287);n.d(e,"stackOrderReverse",function(){return z.a})},function(t,e,n){"use strict";function arcInnerRadius(t){return t.innerRadius}function arcOuterRadius(t){return t.outerRadius}function arcStartAngle(t){return t.startAngle}function arcEndAngle(t){return t.endAngle}function arcPadAngle(t){return t&&t.padAngle}function intersect(t,e,n,r,a,i,o,u){var c=n-t,s=r-e,f=o-a,l=u-i,h=(f*(e-i)-l*(t-a))/(l*c-f*s);return[t+h*c,e+h*s]}function cornerTangents(t,e,n,r,a,o,u){var c=t-n,s=e-r,f=(u?o:-o)/Object(i.l)(c*c+s*s),l=f*s,h=-f*c,d=t+l,p=e+h,b=n+l,v=r+h,m=(d+b)/2,y=(p+v)/2,g=b-d,_=v-p,x=g*g+_*_,w=a-o,O=d*v-b*p,M=(_<0?-1:1)*Object(i.l)(Object(i.h)(0,w*w*x-O*O)),C=(O*_-g*M)/x,j=(-O*g-_*M)/x,T=(O*_+g*M)/x,k=(-O*g+_*M)/x,S=C-m,N=j-y,A=T-m,E=k-y;return S*S+N*N>A*A+E*E&&(C=T,j=k),{cx:C,cy:j,x01:-l,y01:-h,x11:C*(a/w-1),y11:j*(a/w-1)}}var r=n(61),a=n(34),i=n(62);e.a=function(){function arc(){var a,l,h=+t.apply(this,arguments),d=+e.apply(this,arguments),p=u.apply(this,arguments)-i.g,b=c.apply(this,arguments)-i.g,v=Object(i.a)(b-p),m=b>p;if(f||(f=a=Object(r.a)()),d<h&&(l=d,d=h,h=l),d>i.f)if(v>i.m-i.f)f.moveTo(d*Object(i.e)(p),d*Object(i.k)(p)),f.arc(0,0,d,p,b,!m),h>i.f&&(f.moveTo(h*Object(i.e)(b),h*Object(i.k)(b)),f.arc(0,0,h,b,p,m));else{var y,g,_=p,x=b,w=p,O=b,M=v,C=v,j=s.apply(this,arguments)/2,T=j>i.f&&(o?+o.apply(this,arguments):Object(i.l)(h*h+d*d)),k=Object(i.i)(Object(i.a)(d-h)/2,+n.apply(this,arguments)),S=k,N=k;if(T>i.f){var A=Object(i.c)(T/h*Object(i.k)(j)),E=Object(i.c)(T/d*Object(i.k)(j));(M-=2*A)>i.f?(A*=m?1:-1,w+=A,O-=A):(M=0,w=O=(p+b)/2),(C-=2*E)>i.f?(E*=m?1:-1,_+=E,x-=E):(C=0,_=x=(p+b)/2)}var D=d*Object(i.e)(_),F=d*Object(i.k)(_),I=h*Object(i.e)(O),P=h*Object(i.k)(O);if(k>i.f){var R=d*Object(i.e)(x),L=d*Object(i.k)(x),U=h*Object(i.e)(w),H=h*Object(i.k)(w);if(v<i.j){var Y=M>i.f?intersect(D,F,U,H,R,L,I,P):[I,P],q=D-Y[0],B=F-Y[1],z=R-Y[0],W=L-Y[1],V=1/Object(i.k)(Object(i.b)((q*z+B*W)/(Object(i.l)(q*q+B*B)*Object(i.l)(z*z+W*W)))/2),G=Object(i.l)(Y[0]*Y[0]+Y[1]*Y[1]);S=Object(i.i)(k,(h-G)/(V-1)),N=Object(i.i)(k,(d-G)/(V+1))}}C>i.f?N>i.f?(y=cornerTangents(U,H,D,F,d,N,m),g=cornerTangents(R,L,I,P,d,N,m),f.moveTo(y.cx+y.x01,y.cy+y.y01),N<k?f.arc(y.cx,y.cy,N,Object(i.d)(y.y01,y.x01),Object(i.d)(g.y01,g.x01),!m):(f.arc(y.cx,y.cy,N,Object(i.d)(y.y01,y.x01),Object(i.d)(y.y11,y.x11),!m),f.arc(0,0,d,Object(i.d)(y.cy+y.y11,y.cx+y.x11),Object(i.d)(g.cy+g.y11,g.cx+g.x11),!m),f.arc(g.cx,g.cy,N,Object(i.d)(g.y11,g.x11),Object(i.d)(g.y01,g.x01),!m))):(f.moveTo(D,F),f.arc(0,0,d,_,x,!m)):f.moveTo(D,F),h>i.f&&M>i.f?S>i.f?(y=cornerTangents(I,P,R,L,h,-S,m),g=cornerTangents(D,F,U,H,h,-S,m),f.lineTo(y.cx+y.x01,y.cy+y.y01),S<k?f.arc(y.cx,y.cy,S,Object(i.d)(y.y01,y.x01),Object(i.d)(g.y01,g.x01),!m):(f.arc(y.cx,y.cy,S,Object(i.d)(y.y01,y.x01),Object(i.d)(y.y11,y.x11),!m),f.arc(0,0,h,Object(i.d)(y.cy+y.y11,y.cx+y.x11),Object(i.d)(g.cy+g.y11,g.cx+g.x11),m),f.arc(g.cx,g.cy,S,Object(i.d)(g.y11,g.x11),Object(i.d)(g.y01,g.x01),!m))):f.arc(0,0,h,O,w,m):f.lineTo(I,P)}else f.moveTo(0,0);if(f.closePath(),a)return f=null,a+""||null}var t=arcInnerRadius,e=arcOuterRadius,n=Object(a.a)(0),o=null,u=arcStartAngle,c=arcEndAngle,s=arcPadAngle,f=null;return arc.centroid=function(){var n=(+t.apply(this,arguments)+ +e.apply(this,arguments))/2,r=(+u.apply(this,arguments)+ +c.apply(this,arguments))/2-i.j/2;return[Object(i.e)(r)*n,Object(i.k)(r)*n]},arc.innerRadius=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(+e),arc):t},arc.outerRadius=function(t){return arguments.length?(e="function"==typeof t?t:Object(a.a)(+t),arc):e},arc.cornerRadius=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(+t),arc):n},arc.padRadius=function(t){return arguments.length?(o=null==t?null:"function"==typeof t?t:Object(a.a)(+t),arc):o},arc.startAngle=function(t){return arguments.length?(u="function"==typeof t?t:Object(a.a)(+t),arc):u},arc.endAngle=function(t){return arguments.length?(c="function"==typeof t?t:Object(a.a)(+t),arc):c},arc.padAngle=function(t){return arguments.length?(s="function"==typeof t?t:Object(a.a)(+t),arc):s},arc.context=function(t){return arguments.length?(f=null==t?null:t,arc):f},arc}},function(t,e,n){"use strict";function Path(){this._x0=this._y0=this._x1=this._y1=null,this._=""}function path(){return new Path}var r=Math.PI,a=2*r,i=a-1e-6;Path.prototype=path.prototype={constructor:Path,moveTo:function(t,e){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+e)},closePath:function(){null!==this._x1&&(this._x1=this._x0,this._y1=this._y0,this._+="Z")},lineTo:function(t,e){this._+="L"+(this._x1=+t)+","+(this._y1=+e)},quadraticCurveTo:function(t,e,n,r){this._+="Q"+ +t+","+ +e+","+(this._x1=+n)+","+(this._y1=+r)},bezierCurveTo:function(t,e,n,r,a,i){this._+="C"+ +t+","+ +e+","+ +n+","+ +r+","+(this._x1=+a)+","+(this._y1=+i)},arcTo:function(t,e,n,a,i){t=+t,e=+e,n=+n,a=+a,i=+i;var o=this._x1,u=this._y1,c=n-t,s=a-e,f=o-t,l=u-e,h=f*f+l*l;if(i<0)throw new Error("negative radius: "+i);if(null===this._x1)this._+="M"+(this._x1=t)+","+(this._y1=e);else if(h>1e-6)if(Math.abs(l*c-s*f)>1e-6&&i){var d=n-o,p=a-u,b=c*c+s*s,v=d*d+p*p,m=Math.sqrt(b),y=Math.sqrt(h),g=i*Math.tan((r-Math.acos((b+h-v)/(2*m*y)))/2),_=g/y,x=g/m;Math.abs(_-1)>1e-6&&(this._+="L"+(t+_*f)+","+(e+_*l)),this._+="A"+i+","+i+",0,0,"+ +(l*d>f*p)+","+(this._x1=t+x*c)+","+(this._y1=e+x*s)}else this._+="L"+(this._x1=t)+","+(this._y1=e);else;},arc:function(t,e,n,o,u,c){t=+t,e=+e,n=+n;var s=n*Math.cos(o),f=n*Math.sin(o),l=t+s,h=e+f,d=1^c,p=c?o-u:u-o;if(n<0)throw new Error("negative radius: "+n);null===this._x1?this._+="M"+l+","+h:(Math.abs(this._x1-l)>1e-6||Math.abs(this._y1-h)>1e-6)&&(this._+="L"+l+","+h),n&&(p<0&&(p=p%a+a),p>i?this._+="A"+n+","+n+",0,1,"+d+","+(t-s)+","+(e-f)+"A"+n+","+n+",0,1,"+d+","+(this._x1=l)+","+(this._y1=h):p>1e-6&&(this._+="A"+n+","+n+",0,"+ +(p>=r)+","+d+","+(this._x1=t+n*Math.cos(u))+","+(this._y1=e+n*Math.sin(u))))},rect:function(t,e,n,r){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+e)+"h"+ +n+"v"+ +r+"h"+-n+"Z"},toString:function(){return this._}},e.a=path},function(t,e,n){"use strict";var r=n(34),a=n(266),i=n(267),o=n(62);e.a=function(){function pie(r){var a,i,f,l,h,d=r.length,p=0,b=new Array(d),v=new Array(d),m=+u.apply(this,arguments),y=Math.min(o.m,Math.max(-o.m,c.apply(this,arguments)-m)),g=Math.min(Math.abs(y)/d,s.apply(this,arguments)),_=g*(y<0?-1:1);for(a=0;a<d;++a)(h=v[b[a]=a]=+t(r[a],a,r))>0&&(p+=h);for(null!=e?b.sort(function(t,n){return e(v[t],v[n])}):null!=n&&b.sort(function(t,e){return n(r[t],r[e])}),a=0,f=p?(y-d*_)/p:0;a<d;++a,m=l)i=b[a],h=v[i],l=m+(h>0?h*f:0)+_,v[i]={data:r[i],index:a,value:h,startAngle:m,endAngle:l,padAngle:g};return v}var t=i.a,e=a.a,n=null,u=Object(r.a)(0),c=Object(r.a)(o.m),s=Object(r.a)(0);return pie.value=function(e){return arguments.length?(t="function"==typeof e?e:Object(r.a)(+e),pie):t},pie.sortValues=function(t){return arguments.length?(e=t,n=null,pie):e},pie.sort=function(t){return arguments.length?(n=t,e=null,pie):n},pie.startAngle=function(t){return arguments.length?(u="function"==typeof t?t:Object(r.a)(+t),pie):u},pie.endAngle=function(t){return arguments.length?(c="function"==typeof t?t:Object(r.a)(+t),pie):c},pie.padAngle=function(t){return arguments.length?(s="function"==typeof t?t:Object(r.a)(+t),pie):s},pie}},function(t,e,n){"use strict";e.a=function(t,e){return e<t?-1:e>t?1:e>=t?0:NaN}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(240),a=n(239),i=n(241);e.a=function(){var t=Object(a.a)().curve(r.a),e=t.curve,n=t.lineX0,o=t.lineX1,u=t.lineY0,c=t.lineY1;return t.angle=t.x,delete t.x,t.startAngle=t.x0,delete t.x0,t.endAngle=t.x1,delete t.x1,t.radius=t.y,delete t.y,t.innerRadius=t.y0,delete t.y0,t.outerRadius=t.y1,delete t.y1,t.lineStartAngle=function(){return Object(i.b)(n())},delete t.lineX0,t.lineEndAngle=function(){return Object(i.b)(o())},delete t.lineX1,t.lineInnerRadius=function(){return Object(i.b)(u())},delete t.lineY0,t.lineOuterRadius=function(){return Object(i.b)(c())},delete t.lineY1,t.curve=function(t){return arguments.length?e(Object(r.b)(t)):e()._curve},t}},function(t,e,n){"use strict";function linkSource(t){return t.source}function linkTarget(t){return t.target}function link(t){function link(){var i,o=a.a.call(arguments),f=e.apply(this,o),l=n.apply(this,o);if(s||(s=i=Object(r.a)()),t(s,+u.apply(this,(o[0]=f,o)),+c.apply(this,o),+u.apply(this,(o[0]=l,o)),+c.apply(this,o)),i)return s=null,i+""||null}var e=linkSource,n=linkTarget,u=o.a,c=o.b,s=null;return link.source=function(t){return arguments.length?(e=t,link):e},link.target=function(t){return arguments.length?(n=t,link):n},link.x=function(t){return arguments.length?(u="function"==typeof t?t:Object(i.a)(+t),link):u},link.y=function(t){return arguments.length?(c="function"==typeof t?t:Object(i.a)(+t),link):c},link.context=function(t){return arguments.length?(s=null==t?null:t,link):s},link}function curveHorizontal(t,e,n,r,a){t.moveTo(e,n),t.bezierCurveTo(e=(e+r)/2,n,e,a,r,a)}function curveVertical(t,e,n,r,a){t.moveTo(e,n),t.bezierCurveTo(e,n=(n+a)/2,r,n,r,a)}function curveRadial(t,e,n,r,a){var i=Object(u.a)(e,n),o=Object(u.a)(e,n=(n+a)/2),c=Object(u.a)(r,n),s=Object(u.a)(r,a);t.moveTo(i[0],i[1]),t.bezierCurveTo(o[0],o[1],c[0],c[1],s[0],s[1])}function linkHorizontal(){return link(curveHorizontal)}function linkVertical(){return link(curveVertical)}function linkRadial(){var t=link(curveRadial);return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t}e.a=linkHorizontal,e.c=linkVertical,e.b=linkRadial;var r=n(61),a=n(243),i=n(34),o=n(181),u=n(242)},function(t,e,n){"use strict";n.d(e,"b",function(){return h});var r=n(61),a=n(244),i=n(245),o=n(246),u=n(247),c=n(248),s=n(249),f=n(250),l=n(34),h=[a.a,i.a,o.a,c.a,u.a,s.a,f.a];e.a=function(){function symbol(){var a;if(n||(n=a=Object(r.a)()),t.apply(this,arguments).draw(n,+e.apply(this,arguments)),a)return n=null,a+""||null}var t=Object(l.a)(a.a),e=Object(l.a)(64),n=null;return symbol.type=function(e){return arguments.length?(t="function"==typeof e?e:Object(l.a)(e),symbol):t},symbol.size=function(t){return arguments.length?(e="function"==typeof t?t:Object(l.a)(+t),symbol):e},symbol.context=function(t){return arguments.length?(n=null==t?null:t,symbol):n},symbol}},function(t,e,n){"use strict";function BasisClosed(t){this._context=t}var r=n(86),a=n(87);BasisClosed.prototype={areaStart:r.a,areaEnd:r.a,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._y0=this._y1=this._y2=this._y3=this._y4=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x2,this._y2),this._context.closePath();break;case 2:this._context.moveTo((this._x2+2*this._x3)/3,(this._y2+2*this._y3)/3),this._context.lineTo((this._x3+2*this._x2)/3,(this._y3+2*this._y2)/3),this._context.closePath();break;case 3:this.point(this._x2,this._y2),this.point(this._x3,this._y3),this.point(this._x4,this._y4)}},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._x2=t,this._y2=e;break;case 1:this._point=2,this._x3=t,this._y3=e;break;case 2:this._point=3,this._x4=t,this._y4=e,this._context.moveTo((this._x0+4*this._x1+t)/6,(this._y0+4*this._y1+e)/6);break;default:Object(a.c)(this,t,e)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e}},e.a=function(t){return new BasisClosed(t)}},function(t,e,n){"use strict";function BasisOpen(t){this._context=t}var r=n(87);BasisOpen.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3;var n=(this._x0+4*this._x1+t)/6,a=(this._y0+4*this._y1+e)/6;this._line?this._context.lineTo(n,a):this._context.moveTo(n,a);break;case 3:this._point=4;default:Object(r.c)(this,t,e)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e}},e.a=function(t){return new BasisOpen(t)}},function(t,e,n){"use strict";function Bundle(t,e){this._basis=new r.a(t),this._beta=e}var r=n(87);Bundle.prototype={lineStart:function(){this._x=[],this._y=[],this._basis.lineStart()},lineEnd:function(){var t=this._x,e=this._y,n=t.length-1;if(n>0)for(var r,a=t[0],i=e[0],o=t[n]-a,u=e[n]-i,c=-1;++c<=n;)r=c/n,this._basis.point(this._beta*t[c]+(1-this._beta)*(a+r*o),this._beta*e[c]+(1-this._beta)*(i+r*u));this._x=this._y=null,this._basis.lineEnd()},point:function(t,e){this._x.push(+t),this._y.push(+e)}},e.a=function custom(t){function bundle(e){return 1===t?new r.a(e):new Bundle(e,t)}return bundle.beta=function(t){return custom(+t)},bundle}(.85)},function(t,e,n){"use strict";function CatmullRomClosed(t,e){this._context=t,this._alpha=e}var r=n(251),a=n(86),i=n(182);CatmullRomClosed.prototype={areaStart:a.a,areaEnd:a.a,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,e){if(t=+t,e=+e,this._point){var n=this._x2-t,r=this._y2-e;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(n*n+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._x3=t,this._y3=e;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=e);break;case 2:this._point=3,this._x5=t,this._y5=e;break;default:Object(i.b)(this,t,e)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.a=function custom(t){function catmullRom(e){return t?new CatmullRomClosed(e,t):new r.a(e,0)}return catmullRom.alpha=function(t){return custom(+t)},catmullRom}(.5)},function(t,e,n){"use strict";function CatmullRomOpen(t,e){this._context=t,this._alpha=e}var r=n(252),a=n(182);CatmullRomOpen.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){if(t=+t,e=+e,this._point){var n=this._x2-t,r=this._y2-e;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(n*n+r*r,this._alpha))}switch(this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Object(a.b)(this,t,e)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.a=function custom(t){function catmullRom(e){return t?new CatmullRomOpen(e,t):new r.a(e,0)}return catmullRom.alpha=function(t){return custom(+t)},catmullRom}(.5)},function(t,e,n){"use strict";function LinearClosed(t){this._context=t}var r=n(86);LinearClosed.prototype={areaStart:r.a,areaEnd:r.a,lineStart:function(){this._point=0},lineEnd:function(){this._point&&this._context.closePath()},point:function(t,e){t=+t,e=+e,this._point?this._context.lineTo(t,e):(this._point=1,this._context.moveTo(t,e))}},e.a=function(t){return new LinearClosed(t)}},function(t,e,n){"use strict";function sign(t){return t<0?-1:1}function slope3(t,e,n){var r=t._x1-t._x0,a=e-t._x1,i=(t._y1-t._y0)/(r||a<0&&-0),o=(n-t._y1)/(a||r<0&&-0),u=(i*a+o*r)/(r+a);return(sign(i)+sign(o))*Math.min(Math.abs(i),Math.abs(o),.5*Math.abs(u))||0}function slope2(t,e){var n=t._x1-t._x0;return n?(3*(t._y1-t._y0)/n-e)/2:e}function point(t,e,n){var r=t._x0,a=t._y0,i=t._x1,o=t._y1,u=(i-r)/3;t._context.bezierCurveTo(r+u,a+u*e,i-u,o-u*n,i,o)}function MonotoneX(t){this._context=t}function MonotoneY(t){this._context=new ReflectContext(t)}function ReflectContext(t){this._context=t}function monotoneX(t){return new MonotoneX(t)}function monotoneY(t){return new MonotoneY(t)}e.a=monotoneX,e.b=monotoneY,MonotoneX.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=this._t0=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x1,this._y1);break;case 3:point(this,this._t0,slope2(this,this._t0))}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){var n=NaN;if(t=+t,e=+e,t!==this._x1||e!==this._y1){switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;break;case 2:this._point=3,point(this,slope2(this,n=slope3(this,t,e)),n);break;default:point(this,this._t0,n=slope3(this,t,e))}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e,this._t0=n}}},(MonotoneY.prototype=Object.create(MonotoneX.prototype)).point=function(t,e){MonotoneX.prototype.point.call(this,e,t)},ReflectContext.prototype={moveTo:function(t,e){this._context.moveTo(e,t)},closePath:function(){this._context.closePath()},lineTo:function(t,e){this._context.lineTo(e,t)},bezierCurveTo:function(t,e,n,r,a,i){this._context.bezierCurveTo(e,t,r,n,i,a)}}},function(t,e,n){"use strict";function Natural(t){this._context=t}function controlPoints(t){var e,n,r=t.length-1,a=new Array(r),i=new Array(r),o=new Array(r);for(a[0]=0,i[0]=2,o[0]=t[0]+2*t[1],e=1;e<r-1;++e)a[e]=1,i[e]=4,o[e]=4*t[e]+2*t[e+1];for(a[r-1]=2,i[r-1]=7,o[r-1]=8*t[r-1]+t[r],e=1;e<r;++e)n=a[e]/i[e-1],i[e]-=n,o[e]-=n*o[e-1];for(a[r-1]=o[r-1]/i[r-1],e=r-2;e>=0;--e)a[e]=(o[e]-a[e+1])/i[e];for(i[r-1]=(t[r]+a[r-1])/2,e=0;e<r-1;++e)i[e]=2*t[e+1]-a[e+1];return[a,i]}Natural.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=[],this._y=[]},lineEnd:function(){var t=this._x,e=this._y,n=t.length;if(n)if(this._line?this._context.lineTo(t[0],e[0]):this._context.moveTo(t[0],e[0]),2===n)this._context.lineTo(t[1],e[1]);else for(var r=controlPoints(t),a=controlPoints(e),i=0,o=1;o<n;++i,++o)this._context.bezierCurveTo(r[0][i],a[0][i],r[1][i],a[1][i],t[o],e[o]);(this._line||0!==this._line&&1===n)&&this._context.closePath(),this._line=1-this._line,this._x=this._y=null},point:function(t,e){this._x.push(+t),this._y.push(+e)}},e.a=function(t){return new Natural(t)}},function(t,e,n){"use strict";function Step(t,e){this._context=t,this._t=e}function stepBefore(t){return new Step(t,0)}function stepAfter(t){return new Step(t,1)}e.c=stepBefore,e.b=stepAfter,Step.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=this._y=NaN,this._point=0},lineEnd:function(){0<this._t&&this._t<1&&2===this._point&&this._context.lineTo(this._x,this._y),(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line>=0&&(this._t=1-this._t,this._line=1-this._line)},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;default:if(this._t<=0)this._context.lineTo(this._x,e),this._context.lineTo(t,e);else{var n=this._x*(1-this._t)+t*this._t;this._context.lineTo(n,this._y),this._context.lineTo(n,e)}}this._x=t,this._y=e}},e.a=function(t){return new Step(t,.5)}},function(t,e,n){"use strict";function stackValue(t,e){return t[e]}var r=n(243),a=n(34),i=n(63),o=n(64);e.a=function(){function stack(r){var a,i,o=t.apply(this,arguments),c=r.length,s=o.length,f=new Array(s);for(a=0;a<s;++a){for(var l,h=o[a],d=f[a]=new Array(c),p=0;p<c;++p)d[p]=l=[0,+u(r[p],h,p,r)],l.data=r[p];d.key=h}for(a=0,i=e(f);a<s;++a)f[i[a]].index=a;return n(f,i),f}var t=Object(a.a)([]),e=o.a,n=i.a,u=stackValue;return stack.keys=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(r.a.call(e)),stack):t},stack.value=function(t){return arguments.length?(u="function"==typeof t?t:Object(a.a)(+t),stack):u},stack.order=function(t){return arguments.length?(e=null==t?o.a:"function"==typeof t?t:Object(a.a)(r.a.call(t)),stack):e},stack.offset=function(t){return arguments.length?(n=null==t?i.a:t,stack):n},stack}},function(t,e,n){"use strict";var r=n(63);e.a=function(t,e){if((a=t.length)>0){for(var n,a,i,o=0,u=t[0].length;o<u;++o){for(i=n=0;n<a;++n)i+=t[n][o][1]||0;if(i)for(n=0;n<a;++n)t[n][o][1]/=i}Object(r.a)(t,e)}}},function(t,e,n){"use strict";e.a=function(t,e){if((u=t.length)>1)for(var n,r,a,i,o,u,c=0,s=t[e[0]].length;c<s;++c)for(i=o=0,n=0;n<u;++n)(a=(r=t[e[n]][c])[1]-r[0])>=0?(r[0]=i,r[1]=i+=a):a<0?(r[1]=o,r[0]=o+=a):r[0]=i}},function(t,e,n){"use strict";var r=n(63);e.a=function(t,e){if((n=t.length)>0){for(var n,a=0,i=t[e[0]],o=i.length;a<o;++a){for(var u=0,c=0;u<n;++u)c+=t[u][a][1]||0;i[a][1]+=i[a][0]=-c/2}Object(r.a)(t,e)}}},function(t,e,n){"use strict";var r=n(63);e.a=function(t,e){if((i=t.length)>0&&(a=(n=t[e[0]]).length)>0){for(var n,a,i,o=0,u=1;u<a;++u){for(var c=0,s=0,f=0;c<i;++c){for(var l=t[e[c]],h=l[u][1]||0,d=l[u-1][1]||0,p=(h-d)/2,b=0;b<c;++b){var v=t[e[b]];p+=(v[u][1]||0)-(v[u-1][1]||0)}s+=h,f+=p*h}n[u-1][1]+=n[u-1][0]=o,s&&(o-=f/s)}n[u-1][1]+=n[u-1][0]=o,Object(r.a)(t,e)}}},function(t,e,n){"use strict";var r=n(183);e.a=function(t){return Object(r.a)(t).reverse()}},function(t,e,n){"use strict";var r=n(64),a=n(183);e.a=function(t){var e,n,i=t.length,o=t.map(a.b),u=Object(r.a)(t).sort(function(t,e){return o[e]-o[t]}),c=0,s=0,f=[],l=[];for(e=0;e<i;++e)n=u[e],c<s?(c+=o[n],f.push(n)):(s+=o[n],l.push(n));return l.reverse().concat(f)}},function(t,e,n){"use strict";var r=n(64);e.a=function(t){return Object(r.a)(t).reverse()}},function(t,e,n){"use strict";var r;void 0!==(r=function(t){function addDays(t,e){var n=new Date(t);return n.setDate(n.getDate()+e),String(n)}function calculatePercent(t,n,r){var a=n?t/n*100:0;return e.format(r)(a)}function diffDays(t,e){return Math.ceil(Math.abs((new Date(t).getTime()-new Date(e).getTime())/864e5))}function isInteger(t){return t%1==0}function uniqueId(t){var e=++r;return t.toString()+"-"+e}var e=n(21),r=0;return{addDays:addDays,calculatePercent:calculatePercent,diffDays:diffDays,isInteger:isInteger,uniqueId:uniqueId}}.call(e,n,e,t))&&(t.exports=r)},,function(t,e,n){"use strict";function _defineProperty(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var r,a=function(){function sliceIterator(t,e){var n=[],r=!0,a=!1,i=void 0;try{for(var o,u=t[Symbol.iterator]();!(r=(o=u.next()).done)&&(n.push(o.value),!e||n.length!==e);r=!0);}catch(t){a=!0,i=t}finally{try{!r&&u.return&&u.return()}finally{if(a)throw i}}return n}return function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return sliceIterator(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};void 0!==(r=function(t){var e,r=n(35),o=n(40),u=n(90),c=u.axisTimeCombinations,s=u.timeBenchmarks,f={minute:o.timeFormat("%M m"),hour:o.timeFormat("%H %p"),day:o.timeFormat("%e"),daymonth:o.timeFormat("%d %b"),month:o.timeFormat("%b"),year:o.timeFormat("%Y")},l={minute:{minute:"numeric"},hour:{hour:"numeric"},day:{day:"numeric"},daymonth:{day:"numeric",month:"short"},month:{month:"short"},year:{year:"numeric"}},h=(e={},_defineProperty(e,c.MINUTE_HOUR,r.timeHour.every(1)),_defineProperty(e,c.HOUR_DAY,r.timeDay.every(1)),_defineProperty(e,c.DAY_MONTH,r.timeMonth.every(1)),_defineProperty(e,c.MONTH_YEAR,r.timeYear.every(1)),e),d=function(t){var e=s.ONE_YEAR,n=s.ONE_DAY;return t<n?c.HOUR_DAY:t<e?c.DAY_MONTH:c.MONTH_YEAR},p=function(t,e){var n=Math.ceil(t/70);return e<5?r.timeDay:Math.min(e,n)},b=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"day",n=l[e],r=new Intl.DateTimeFormat(t,n);return function(t){return r.format(t)}},v=function(t){return Math.ceil(t/864e5)};return{getXAxisSettings:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,o=new Date(t[0].date),u=new Date(t[t.length-1].date),c=u-o;r&&("undefined"==typeof Intl||"object"===("undefined"==typeof Intl?"undefined":i(Intl))&&!Intl.DateTimeFormat)&&(r=null),n||(n=d(c));var s=n.split("-"),l=a(s,2),m=l[0],y=l[1],g=h[n],_=p(e,v(c));return{minor:{format:r?b(r,m):f[m],tick:_},major:{format:r?b(r,y):f[y],tick:g}}},getLocaleDateFormatter:b}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r;void 0!==(r=function(t){function getValueSize(t,e){var n="large";return t<e.small.limit?n="small":t<e.medium.limit&&(n="medium"),n}function formatIntegerValue(t){var e=getValueSize(t,r);return(0,r[e].format)(t)}function formatDecimalValue(t){var e=getValueSize(t,a);return(0,a[e].format)(t)}var e=n(21),r={small:{limit:10,format:e.format("")},medium:{limit:1e3,format:e.format("")},large:{limit:null,format:e.format(".2s")}},a={small:{limit:10,format:e.format(".3f")},medium:{limit:100,format:e.format(".1f")},large:{limit:null,format:e.format(".2s")}};return{formatDecimalValue:formatDecimalValue,formatIntegerValue:formatIntegerValue}}.call(e,n,e,t))&&(t.exports=r)},,function(t,e,n){"use strict";var r;void 0!==(r=function(t){var e=(n(3),"highlight-filter"),r=function(t){return t.append("defs").append("filter").attr("id",e)},a=function(t){return t.append("feGaussianBlur").attr("stdDeviation",1).attr("result","coloredBlur"),e},i=function(t){t.attr("x","-30%").attr("y","-30%").attr("width","160%").attr("height","160%"),t.append("feGaussianBlur").attr("stdDeviation","0.9 0.9").attr("result","glow");var n=t.append("feMerge");return n.append("feMergeNode").attr("in","glow"),n.append("feMergeNode").attr("in","glow"),n.append("feMergeNode").attr("in","glow"),e},o=function(t){t.attr("x","-500%").attr("y","-500%").attr("width","1800%").attr("height","1800%"),t.append("feColorMatrix").attr("type","matrix").attr("values","0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"),t.append("feGaussianBlur").attr("stdDeviation","1").attr("result","coloredBlur").attr("in","SourceGraphic");var n=t.append("feMerge");return n.append("feMergeNode").attr("in","coloredBlur"),n.append("feMergeNode").attr("in","SourceGraphic"),e};return{createFilterContainer:r,createGausianBlur:a,createWhiteGlow:function(t){t.attr("x","-5000%").attr("y","-5000%").attr("width","10000%").attr("height","10000%"),t.append("feFlood").attr("result","flood").attr("flood-color","#ffffff").attr("flood-opacity","1"),t.append("feComposite").attr("result","mask").attr("in2","SourceGraphic").attr("operator","in").attr("in","flood"),t.append("feMorphology").attr("result","dilated").attr("operator","dilate").attr("radius","2").attr("in","mask"),t.append("feGaussianBlur").attr("result","blurred").attr("stdDeviation","5").attr("in","dilated");var n=t.append("feMerge");return n.append("feMergeNode").attr("in","blurred"),n.append("feMergeNode").attr("in","SourceGraphic"),e},createGlow:i,createGlowWithMatrix:o}}.call(e,n,e,t))&&(t.exports=r)},,,,,,function(t,e,n){"use strict";var r,a=function(){function sliceIterator(t,e){var n=[],r=!0,a=!1,i=void 0;try{for(var o,u=t[Symbol.iterator]();!(r=(o=u.next()).done)&&(n.push(o.value),!e||n.length!==e);r=!0);}catch(t){a=!0,i=t}finally{try{!r&&u.return&&u.return()}finally{if(a)throw i}}return n}return function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return sliceIterator(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();void 0!==(r=function(t){var e=n(5),r=n(258),i=n(114),o=n(66),u=n(65),c=n(21),s=n(215),f=n(262),l=n(3),h=(n(91),n(40)),d=n(253),p=d.exportChart,b=n(89),v=n(238),m=v.line,y=n(290),g=y.getXAxisSettings,_=(y.getLocaleDateFormatter,n(90)),x=_.axisTimeCombinations,w=n(293),O=w.createFilterContainer,M=w.createGlowWithMatrix,C=n(291),j=C.formatIntegerValue,T=C.formatDecimalValue,k=n(288),S=k.isInteger,N=k.uniqueId;return function(){function exports(e){e.each(function(e){var r=cleanData(e);ft=r.dataByTopic,lt=r.dataByDate,k=n-t.left-t.right,A=d-t.top-t.bottom,buildScales(),buildSVG(this),buildAxis(),drawAxis(),buildGradient(),drawLines(),createMaskingClip(),shouldShowTooltip()&&(drawHoverOverlay(),drawVerticalMarker(),addMouseEvents())})}function addGlowFilter(t){V||(V=O(w.select(".metadata-group")),G=M(V)),l.select(t).style("stroke-width",Q).style("r",K).style("stroke-opacity",J).attr("filter","url(#"+G+")")}function addMouseEvents(){w.on("mouseover",function(t){handleMouseOver(this,t)}).on("mouseout",function(t){handleMouseOut(this,t)}).on("mousemove",function(t){handleMouseMove(this)})}function adjustYTickLabels(t){t.selectAll(".tick text").attr("transform","translate(0, -7)")}function getFormattedValue(t){var e=void 0;return e=S(t)?j:T,Tt&&(e=c.format(Tt)),e(t)}function buildAxis(){var t=D.domain()[1]-D.domain()[0],e=t<wt-1?t:wt,a=void 0,i=void 0;if("custom"===tt&&"string"==typeof nt)a={tick:et,format:h.timeFormat(nt)},i=null;else{var o=g(lt,n,tt,rt);a=o.minor,i=o.major,P=r.axisBottom(E).ticks(i.tick).tickSize(0,0).tickFormat(i.format)}I=r.axisBottom(E).ticks(a.tick).tickSize(10,0).tickPadding(H).tickFormat(a.format),R=r.axisLeft(D).ticks(e).tickSize([0]).tickPadding(H).tickFormat(getFormattedValue),drawGridLines(a.tick,e)}function buildContainerGroups(){var e=w.append("g").classed("container-group",!0).attr("transform","translate("+t.left+","+t.top+")");e.append("g").classed("x-axis-group",!0).append("g").classed("axis x",!0),e.selectAll(".x-axis-group").append("g").classed("month-axis",!0),e.append("g").classed("y-axis-group",!0).append("g").classed("axis y",!0),e.append("g").classed("grid-lines-group",!0),e.append("g").classed("chart-group",!0),e.append("g").classed("metadata-group",!0)}function buildGradient(){z||(z=w.select(".metadata-group").append("linearGradient").attr("id",W).attr("x1","0%").attr("y1","0%").attr("x2","100%").attr("y2","0%").attr("gradientUnits","userSpaceOnUse").selectAll("stop").data([{offset:"0%",color:q[0]},{offset:"100%",color:q[1]}]).enter().append("stop").attr("offset",function(t){return t.offset}).attr("stop-color",function(t){return t.color}))}function buildScales(){var t=e.min(ft,function(t){var n=t.dates;return e.min(n,Dt)}),n=e.max(ft,function(t){var n=t.dates;return e.max(n,Dt)}),r=e.max(ft,function(t){var n=t.dates;return e.max(n,Ft)}),a=e.min(ft,function(t){var n=t.dates;return e.min(n,Ft)}),i=Math.abs(a)<0?Math.abs(a):0;E=s.scaleTime().domain([t,n]).rangeRound([0,k]),D=s.scaleLinear().domain([i,Math.abs(r)]).rangeRound([A,0]).nice(),F=s.scaleOrdinal().range(Y).domain(ft.map(It));var o=F.range();B=F.domain().reduce(function(t,e,n){return t[e]=o[n],t},{})}function buildSVG(t){w||(w=l.select(t).append("svg").classed("britechart line-chart",!0),buildContainerGroups()),w.attr("width",n).attr("height",d)}function cleanData(t){var e=t.dataByTopic,n=t.dataByDate;if(!e)throw new Error("Data needs to have a dataByTopic property");var r=[];return e.forEach(function(t){t.dates.forEach(function(e){r.push({topicName:t[bt],name:t[pt],date:e[ht],value:e[dt]})})}),n=i.nest().key(Dt).entries(r).map(function(t){return{date:new Date(t.key),topics:t.values}}),n=n.map(function(t){return t.date=new Date(t.date),t}),e.forEach(function(t){t.dates.forEach(function(t){t.date=new Date(t[ht]),t.value=+t[dt]})}),{dataByTopic:e,dataByDate:n}}function cleanDataPointHighlights(){Ct.selectAll(".circle-container").remove()}function createMaskingClip(){at&&(ut=w.append("rect").attr("class","masking-rectangle").attr("width",n).attr("height",d).attr("x",0).attr("y",0),ut.transition().duration(ot).ease(it).attr("x",n).on("end",function(){return ut.remove()}))}function drawAxis(){if(w.select(".x-axis-group .axis.x").attr("transform","translate(0, "+A+")").call(I),"custom"!==tt&&w.select(".x-axis-group .month-axis").attr("transform","translate(0, "+(A+U)+")").call(P),vt){mt&&w.selectAll(".x-axis-label").remove();var t=k/2,e=A+U+yt;mt=w.select(".x-axis-group").append("text").attr("x",t).attr("y",e).attr("text-anchor","middle").attr("class","x-axis-label").text(vt)}if(w.select(".y-axis-group .axis.y").attr("transform","translate("+-L.left+", 0)").call(R).call(adjustYTickLabels),gt){_t&&w.selectAll(".y-axis-label").remove();var n=-xt-L.left,r=-A/2;_t=w.select(".y-axis-group").append("text").attr("x",r).attr("y",n).attr("text-anchor","middle").attr("transform","rotate(270)").attr("class","y-axis-label").text(gt)}}function drawLines(){var t=void 0,e=void 0;e=f.line().curve(st[ct]).x(function(t){var e=t.date;return E(e)}).y(function(t){var e=t.value;return D(e)}),t=w.select(".chart-group").selectAll(".line").data(ft,It),C=t.enter().append("g").attr("class","topic").append("path").attr("class","line").attr("id",function(t){return t.topic}).attr("d",function(t){var n=t.dates;return e(n)}).style("stroke",function(t){return 1===ft.length?"url(#"+W+")":Pt(t)}),t.exit().remove()}function drawGridLines(e,n){w.select(".grid-lines-group").selectAll("line").remove(),"horizontal"!==Nt&&"full"!==Nt||(St=w.select(".grid-lines-group").selectAll("line.horizontal-grid-line").data(D.ticks(n)).enter().append("line").attr("class","horizontal-grid-line").attr("x1",-L.left-30).attr("x2",k).attr("y1",function(t){return D(t)}).attr("y2",function(t){return D(t)})),"vertical"!==Nt&&"full"!==Nt||(kt=w.select(".grid-lines-group").selectAll("line.vertical-grid-line").data(E.ticks(e)).enter().append("line").attr("class","vertical-grid-line").attr("y1",0).attr("y2",A).attr("x1",function(t){return E(t)}).attr("x2",function(t){return E(t)})),At=w.select(".grid-lines-group").selectAll("line.extended-x-line").data([0]).enter().append("line").attr("class","extended-x-line").attr("x1",-L.left-30).attr("x2",k).attr("y1",d-t.bottom-t.top).attr("y2",d-t.bottom-t.top)}function drawHoverOverlay(){Ot||(Ot=w.select(".metadata-group").append("rect").attr("class","overlay").attr("y1",0).attr("y2",d).attr("height",A).attr("width",k).attr("fill",Mt).style("display","none"))}function drawVerticalMarker(){Ct||(Ct=w.select(".metadata-group").append("g").attr("class","hover-marker vertical-marker-container").attr("transform","translate(9999, 0)"),jt=Ct.selectAll("path").data([{x1:0,y1:0,x2:0,y2:0}]).enter().append("line").classed("vertical-marker",!0).attr("x1",0).attr("y1",A).attr("x2",0).attr("y2",0))}function findOutNearestDate(t,e,n){return new Date(t).getTime()-new Date(e.date).getTime()>new Date(n.date).getTime()-new Date(t).getTime()?e:n}function getNearestDataPoint(t){var n=E.invert(t),r=e.bisector(Dt).left,a=r(lt,n,1),i=lt[a],o=lt[a-1];return o&&i?findOutNearestDate(n,i,o):i}function handleMouseMove(e){var n=l.mouse(e),r=a(n,2),i=r[0],o=r[1],u=-t.left,c=getNearestDataPoint(i+u),s=void 0;c&&(s=E(new Date(c.date)),moveVerticalMarker(s),highlightDataPoints(c),Rt.call("customMouseMove",e,c,B,s,o))}function handleMouseOut(t,e){Ot.style("display","none"),jt.classed("bc-is-active",!1),Ct.attr("transform","translate(9999, 0)"),Rt.call("customMouseOut",t,e,l.mouse(t))}function handleMouseOver(t,e){Ot.style("display","block"),jt.classed("bc-is-active",!0),Rt.call("customMouseOver",t,e,l.mouse(t))}function handleHighlightClick(t,e){Rt.call("customDataEntryClick",t,e,l.mouse(t))}function highlightDataPoints(t){cleanDataPointHighlights();var e=C.nodes(),n=e.reduce(function(t,e){return t[e.id]=e,t},{}),r=t.topics.map(function(t){return{topic:t,node:n[t.name]}}).filter(function(t){return!!t.topic}).sort(function(t,e){return B[t.topic.name]<B[e.topic.name]});t.topics=r.map(function(t){return t.topic}),t.topics.forEach(function(e,n){var a=Ct.append("g").classed("circle-container",!0).append("circle").classed("data-point-highlighter",!0).attr("cx",X).attr("cy",0).attr("r",Z).style("stroke-width",$).style("stroke",B[e.name]).style("cursor","pointer").on("click",function(){addGlowFilter(this),handleHighlightClick(this,e)}).on("mouseout",function(){removeFilter(this)}),i=r[n].node,o=E(new Date(t.topics[n].date)),u=getPathYFromX(o,i,e.name);a.attr("transform","translate( "+-X+", "+u+" )")})}function getPathYFromX(t,e,n,r){var a=n+"-"+t;if(a in Et)return Et[a];r=r||.01;for(var i=0,o=e.getTotalLength(),u=e.getPointAtLength((o+i)/2),c=0;t<u.x-r||t>u.x+r;){var s=(i+o)/2;if(u=e.getPointAtLength(s),t<u.x?o=s:i=s,100<(c+=1))break}return Et[a]=u.y,Et[a]}function moveVerticalMarker(t){Ct.attr("transform","translate("+t+",0)")}function removeFilter(t){l.select(t).attr("filter","none")}function shouldShowTooltip(){return n>_}var t={top:60,right:30,bottom:40,left:70},n=960,d=500,v=m,y=null,_=480,w=void 0,C=void 0,k=void 0,A=void 0,E=void 0,D=void 0,F=void 0,I=void 0,P=void 0,R=void 0,L={top:0,left:15,bottom:0,right:0},U=28,H=5,Y=b.colorSchemas.britecharts,q=b.colorGradients.greenBlue,B=void 0,z=void 0,W=N("one-line-gradient"),V=null,G=null,X=12,Z=5,$=2,K=Z+2,Q=5,J=.6,tt=null,et=null,nt=null,rt=void 0,at=!1,it=u.easeQuadInOut,ot=1500,ut=void 0,ct="linear",st={linear:f.curveLinear,basis:f.curveBasis,cardinal:f.curveCardinal,catmullRom:f.curveCatmullRom,monotoneX:f.curveMonotoneX,monotoneY:f.curveMonotoneY,natural:f.curveNatural,step:f.curveStep,stepAfter:f.curveStepAfter,stepBefore:f.curveStepBefore},ft=void 0,lt=void 0,ht="date",dt="value",pt="topic",bt="topicName",vt=null,mt=null,yt=36,gt=null,_t=null,xt=36,wt=5,Ot=void 0,Mt="rgba(0, 0, 0, 0)",Ct=void 0,jt=void 0,Tt=void 0,kt=void 0,St=void 0,Nt=null,At=void 0,Et={},Dt=function(t){return t.date},Ft=function(t){return t.value},It=function(t){return t.topic},Pt=function(t){var e=t.topic;return F(e)},Rt=o.dispatch("customMouseOver","customMouseOut","customMouseMove","customDataEntryClick");return exports.aspectRatio=function(t){return arguments.length?(y=t,this):y},exports.xAxisLabel=function(t){return arguments.length?(vt=t,this):vt},exports.yAxisLabel=function(t){return arguments.length?(gt=t,this):gt},exports.colorSchema=function(t){return arguments.length?(Y=t,this):Y},exports.dateLabel=function(t){return arguments.length?(ht=t,this):ht},exports.xAxisFormat=function(t){return arguments.length?(tt=t,this):tt},exports.xAxisCustomFormat=function(t){return arguments.length?(nt=t,this):nt},exports.xTicks=function(t){return arguments.length?(et=t,this):et},exports.grid=function(t){return arguments.length?(Nt=t,this):Nt},exports.height=function(t){return arguments.length?(y&&(n=Math.ceil(t/y)),d=t,this):d},exports.isAnimated=function(t){return arguments.length?(at=t,this):at},exports.loadingState=function(t){return arguments.length?(v=t,this):v},exports.margin=function(e){return arguments.length?(t=e,this):t},exports.numberFormat=function(t){return arguments.length?(Tt=t,this):Tt},exports.lineCurve=function(t){return arguments.length?(ct=t,this):ct},exports.lineGradient=function(t){return arguments.length?(q=t,this):q},exports.tooltipThreshold=function(t){return arguments.length?(_=t,this):_},exports.topicLabel=function(t){return arguments.length?(pt=t,this):pt},exports.valueLabel=function(t){return arguments.length?(dt=t,this):dt},exports.yTicks=function(t){return arguments.length?(wt=t,this):wt},exports.width=function(t){return arguments.length?(y&&(d=Math.ceil(t*y)),n=t,this):n},exports.locale=function(t){return arguments.length?(rt=t,this):rt},exports.exportChart=function(t,e){p.call(exports,w,t,e)},exports.on=function(){var t=Rt.on.apply(Rt,arguments);return t===Rt?exports:t},exports.axisTimeCombinations=x,exports}}.call(e,n,e,t))&&(t.exports=r)}])})},function(t,e,n){"use strict";function _interopRequireDefault(t){return t&&t.__esModule?t:{default:t}}function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},a=function(){function defineProperties(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(t,e,n){return e&&defineProperties(t.prototype,e),n&&defineProperties(t,n),t}}(),i=n(4),o=_interopRequireDefault(i),u=n(6),c=_interopRequireDefault(u),s=n(105),f=_interopRequireDefault(s),l=n(17),h=function(t){function StackedArea(){return _classCallCheck(this,StackedArea),_possibleConstructorReturn(this,(StackedArea.__proto__||Object.getPrototypeOf(StackedArea)).apply(this,arguments))}return _inherits(StackedArea,t),a(StackedArea,[{key:"componentDidMount",value:function(){this.props.shouldShowLoadingState||null!==this.props.data&&this._createChart()}},{key:"componentDidUpdate",value:function(){this.props.shouldShowLoadingState||(this._chart?(this._updateChart(),this.props.createTooltip()):this._createChart())}},{key:"componentWillUnmount",value:function(){this.props.chart.destroy(this._rootNode)}},{key:"_createChart",value:function(){this._chart=this.props.chart.create(this._rootNode,this.props.data,this._getChartConfiguration())}},{key:"_updateChart",value:function(){this.props.chart.update(this._rootNode,this.props.data,this._getChartConfiguration(),this._chart)}},{key:"_getChartConfiguration",value:function(){var t=r({},this.props);return delete t.data,delete t.chart,delete t.createTooltip,delete t.shouldShowLoadingState,t}},{key:"_setRef",value:function(t){this._rootNode=t}},{key:"render",value:function(){return(0,l.loadingContainerWrapper)(this.props,this.props.chart.loading(),o.default.createElement("div",{className:"stacked-area-container",ref:this._setRef.bind(this)}))}}]),StackedArea}(o.default.Component);h.propTypes={data:c.default.arrayOf(c.default.any),axisTimeCombinations:c.default.number,areaOpacity:c.default.number,aspectRatio:c.default.number,colorSchema:c.default.arrayOf(c.default.string),dateLabel:c.default.number,grid:c.default.string,height:c.default.number,isAnimated:c.default.bool,keyLabel:c.default.number,locale:c.default.string,margin:c.default.shape({top:c.default.number,bottom:c.default.number,left:c.default.number,right:c.default.number}),shouldShowLoadingState:c.default.bool,tooltipThreshold:c.default.number,valueLabel:c.default.number,width:c.default.number,xAxisCustomFormat:c.default.string,xAxisFormat:c.default.string,xTicks:c.default.number,yTicks:c.default.number,customMouseOver:c.default.func,customMouseMove:c.default.func,customMouseOut:c.default.func,chart:c.default.object},h.defaultProps={chart:f.default,createTooltip:function(){return null},shouldShowLoadingState:!1},e.default=h},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(106),a=function(t){return t&&t.__esModule?t:{default:t}}(r),i=n(8),o=n(9),u=n(10),c=n(16),s={};s.create=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=(0,i.select)(t),c=(0,a.default)();return(0,o.validateData)(e),(0,o.validateContainer)(r),(0,o.validateConfiguration)(c,n),r.datum(e).call((0,u.applyConfiguration)(c,n)),c},s.update=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=arguments[3],a=(0,i.select)(t);return(0,o.validateContainer)(a),(0,o.validateConfiguration)(r,n),(0,u.applyConfiguration)(r,n),e&&e.length?((0,o.validateData)(e),a.datum(e).call(r)):a.call(r),r},s.destroy=function(){},s.loading=function(){return c.line},e.default=s},function(t,e,n){!function(e,n){t.exports=n()}(0,function(){return function(t){function __webpack_require__(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,__webpack_require__),r.l=!0,r.exports}var e={};return __webpack_require__.m=t,__webpack_require__.c=e,__webpack_require__.d=function(t,e,n){__webpack_require__.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},__webpack_require__.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return __webpack_require__.d(e,"a",e),e},__webpack_require__.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=303)}([function(t,e,n){"use strict";function newInterval(t,e,n,i){function interval(e){return t(e=new Date(+e)),e}return interval.floor=interval,interval.ceil=function(n){return t(n=new Date(n-1)),e(n,1),t(n),n},interval.round=function(t){var e=interval(t),n=interval.ceil(t);return t-e<n-t?e:n},interval.offset=function(t,n){return e(t=new Date(+t),null==n?1:Math.floor(n)),t},interval.range=function(n,r,a){var i=[];if(n=interval.ceil(n),a=null==a?1:Math.floor(a),!(n<r&&a>0))return i;do{i.push(new Date(+n))}while(e(n,a),t(n),n<r);return i},interval.filter=function(n){return newInterval(function(e){if(e>=e)for(;t(e),!n(e);)e.setTime(e-1)},function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;e(t,-1),!n(t););else for(;--r>=0;)for(;e(t,1),!n(t););})},n&&(interval.count=function(e,i){return r.setTime(+e),a.setTime(+i),t(r),t(a),Math.floor(n(r,a))},interval.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?interval.filter(i?function(e){return i(e)%t==0}:function(e){return interval.count(0,e)%t==0}):interval:null}),interval}e.a=newInterval;var r=new Date,a=new Date},function(t,e,n){"use strict";function Selection(t,e){this._groups=t,this._parents=e}function selection(){return new Selection([[document.documentElement]],E)}n.d(e,"c",function(){return E}),e.a=Selection;var r=n(128),a=n(129),i=n(130),o=n(131),u=n(55),c=n(133),s=n(134),f=n(135),l=n(136),h=n(137),d=n(138),p=n(139),b=n(140),v=n(141),m=n(142),y=n(143),g=n(57),_=n(144),x=n(145),w=n(146),O=n(147),M=n(148),C=n(149),j=n(150),T=n(151),k=n(152),S=n(153),N=n(29),A=n(154),E=[null];Selection.prototype=selection.prototype={constructor:Selection,select:r.a,selectAll:a.a,filter:i.a,data:o.a,enter:u.b,exit:c.a,merge:s.a,order:f.a,sort:l.a,call:h.a,nodes:d.a,node:p.a,size:b.a,empty:v.a,each:m.a,attr:y.a,style:g.a,property:_.a,classed:x.a,text:w.a,html:O.a,raise:M.a,lower:C.a,append:j.a,insert:T.a,remove:k.a,datum:S.a,on:N.b,dispatch:A.a},e.b=selection},function(t,e,n){"use strict";function init(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>u)throw new Error("too late");return n}function set(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>s)throw new Error("too late");return n}function get(t,e){var n=t.__transition;if(!n||!(n=n[e]))throw new Error("too late");return n}function create(t,e,n){function schedule(t){n.state=c,n.timer.restart(start,n.delay,n.time),n.delay<=t&&start(t-n.delay)}function start(o){var u,h,p,b;if(n.state!==c)return stop();for(u in i)if(b=i[u],b.name===n.name){if(b.state===f)return Object(a.b)(start);b.state===l?(b.state=d,b.timer.stop(),b.on.call("interrupt",t,t.__data__,b.index,b.group),delete i[u]):+u<e&&(b.state=d,b.timer.stop(),delete i[u])}if(Object(a.b)(function(){n.state===f&&(n.state=l,n.timer.restart(tick,n.delay,n.time),tick(o))}),n.state=s,n.on.call("start",t,t.__data__,n.index,n.group),n.state===s){for(n.state=f,r=new Array(p=n.tween.length),u=0,h=-1;u<p;++u)(b=n.tween[u].value.call(t,t.__data__,n.index,n.group))&&(r[++h]=b);r.length=h+1}}function tick(e){for(var a=e<n.duration?n.ease.call(null,e/n.duration):(n.timer.restart(stop),n.state=h,1),i=-1,o=r.length;++i<o;)r[i].call(null,a);n.state===h&&(n.on.call("end",t,t.__data__,n.index,n.group),stop())}function stop(){n.state=d,n.timer.stop(),delete i[e];for(var r in i)return;delete t.__transition}var r,i=t.__transition;i[e]=n,n.timer=Object(a.c)(schedule,0,n.time)}n.d(e,"c",function(){return c}),n.d(e,"d",function(){return s}),n.d(e,"b",function(){return h}),n.d(e,"a",function(){return d}),e.g=init,e.h=set,e.f=get;var r=n(66),a=n(59),i=Object(r.dispatch)("start","end","interrupt"),o=[],u=0,c=1,s=2,f=3,l=4,h=5,d=6;e.e=function(t,e,n,r,a,c){var s=t.__transition;if(s){if(n in s)return}else t.__transition={};create(t,n,{name:e,index:r,group:a,on:i,tween:o,time:c.time,delay:c.delay,duration:c.duration,ease:c.ease,timer:null,state:u})}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(25);n.d(e,"creator",function(){return r.a});var a=n(125);n.d(e,"local",function(){return a.a});var i=n(53);n.d(e,"matcher",function(){return i.a});var o=n(126);n.d(e,"mouse",function(){return o.a});var u=n(26);n.d(e,"namespace",function(){return u.a});var c=n(27);n.d(e,"namespaces",function(){return c.a});var s=n(127);n.d(e,"select",function(){return s.a});var f=n(155);n.d(e,"selectAll",function(){return f.a});var l=n(1);n.d(e,"selection",function(){return l.b});var h=n(31);n.d(e,"selector",function(){return h.a});var d=n(54);n.d(e,"selectorAll",function(){return d.a});var p=n(57);n.d(e,"style",function(){return p.b});var b=n(156);n.d(e,"touch",function(){return b.a});var v=n(157);n.d(e,"touches",function(){return v.a});var m=n(32);n.d(e,"window",function(){return m.a});var y=n(29);n.d(e,"event",function(){return y.c}),n.d(e,"customEvent",function(){return y.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(19);n.d(e,"color",function(){return r.e}),n.d(e,"rgb",function(){return r.g}),n.d(e,"hsl",function(){return r.f});var a=n(102);n.d(e,"lab",function(){return a.a}),n.d(e,"hcl",function(){return a.b});var i=n(103);n.d(e,"cubehelix",function(){return i.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(67);n.d(e,"bisect",function(){return r.c}),n.d(e,"bisectRight",function(){return r.b}),n.d(e,"bisectLeft",function(){return r.a});var a=n(10);n.d(e,"ascending",function(){return a.a});var i=n(68);n.d(e,"bisector",function(){return i.a});var o=n(184);n.d(e,"cross",function(){return o.a});var u=n(185);n.d(e,"descending",function(){return u.a});var c=n(70);n.d(e,"deviation",function(){return c.a});var s=n(72);n.d(e,"extent",function(){return s.a});var f=n(186);n.d(e,"histogram",function(){return f.a});var l=n(189);n.d(e,"thresholdFreedmanDiaconis",function(){return l.a});var h=n(190);n.d(e,"thresholdScott",function(){return h.a});var d=n(76);n.d(e,"thresholdSturges",function(){return d.a});var p=n(191);n.d(e,"max",function(){return p.a});var b=n(192);n.d(e,"mean",function(){return b.a});var v=n(193);n.d(e,"median",function(){return v.a});var m=n(194);n.d(e,"merge",function(){return m.a});var y=n(77);n.d(e,"min",function(){return y.a});var g=n(69);n.d(e,"pairs",function(){return g.a});var _=n(195);n.d(e,"permute",function(){return _.a});var x=n(36);n.d(e,"quantile",function(){return x.a});var w=n(74);n.d(e,"range",function(){return w.a});var O=n(196);n.d(e,"scan",function(){return O.a});var M=n(197);n.d(e,"shuffle",function(){return M.a});var C=n(198);n.d(e,"sum",function(){return C.a});var j=n(75);n.d(e,"ticks",function(){return j.a}),n.d(e,"tickIncrement",function(){return j.b}),n.d(e,"tickStep",function(){return j.c});var T=n(78);n.d(e,"transpose",function(){return T.a});var k=n(71);n.d(e,"variance",function(){return k.a});var S=n(199);n.d(e,"zip",function(){return S.a})},function(t,e,n){"use strict";n.d(e,"d",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"a",function(){return o}),n.d(e,"e",function(){return u});var r=1e3,a=6e4,i=36e5,o=864e5,u=6048e5},function(t,e,n){"use strict";function Transition(t,e,n,r){this._groups=t,this._parents=e,this._name=n,this._id=r}function transition(t){return Object(r.selection)().transition(t)}function newId(){return++x}e.a=Transition,e.b=transition,e.c=newId;var r=n(3),a=n(163),i=n(164),o=n(165),u=n(166),c=n(167),s=n(168),f=n(169),l=n(170),h=n(171),d=n(172),p=n(173),b=n(174),v=n(175),m=n(176),y=n(177),g=n(178),_=n(17),x=0,w=r.selection.prototype;Transition.prototype=transition.prototype={constructor:Transition,select:d.a,selectAll:p.a,filter:s.a,merge:f.a,selection:b.a,transition:g.a,call:w.call,nodes:w.nodes,node:w.node,size:w.size,empty:w.empty,each:w.each,on:l.a,attr:a.a,attrTween:i.a,style:v.a,styleTween:m.a,text:y.a,remove:h.a,tween:_.a,delay:o.a,duration:u.a,ease:c.a}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(23);n.d(e,"interpolate",function(){return r.a});var a=n(49);n.d(e,"interpolateArray",function(){return a.a});var i=n(24);n.d(e,"interpolateBasis",function(){return i.b});var o=n(47);n.d(e,"interpolateBasisClosed",function(){return o.a});var u=n(50);n.d(e,"interpolateDate",function(){return u.a});var c=n(15);n.d(e,"interpolateNumber",function(){return c.a});var s=n(51);n.d(e,"interpolateObject",function(){return s.a});var f=n(115);n.d(e,"interpolateRound",function(){return f.a});var l=n(52);n.d(e,"interpolateString",function(){return l.a});var h=n(116);n.d(e,"interpolateTransformCss",function(){return h.a}),n.d(e,"interpolateTransformSvg",function(){return h.b});var d=n(119);n.d(e,"interpolateZoom",function(){return d.a});var p=n(46);n.d(e,"interpolateRgb",function(){return p.a}),n.d(e,"interpolateRgbBasis",function(){return p.b}),n.d(e,"interpolateRgbBasisClosed",function(){return p.c});var b=n(120);n.d(e,"interpolateHsl",function(){return b.a}),n.d(e,"interpolateHslLong",function(){return b.b});var v=n(121);n.d(e,"interpolateLab",function(){return v.a});var m=n(122);n.d(e,"interpolateHcl",function(){return m.a}),n.d(e,"interpolateHclLong",function(){return m.b});var y=n(123);n.d(e,"interpolateCubehelix",function(){return y.b}),n.d(e,"interpolateCubehelixLong",function(){return y.a});var g=n(124);n.d(e,"quantize",function(){return g.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"b",function(){return i});var r=Array.prototype,a=r.map,i=r.slice},function(t,e,n){"use strict";e.a=function(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}},function(t,e,n){"use strict";function linear(t,e){return function(n){return t+n*e}}function exponential(t,e,n){return t=Math.pow(t,n),e=Math.pow(e,n)-t,n=1/n,function(r){return Math.pow(t+r*e,n)}}function hue(t,e){var n=e-t;return n?linear(t,n>180||n<-180?n-360*Math.round(n/360):n):Object(r.a)(isNaN(t)?e:t)}function gamma(t){return 1==(t=+t)?nogamma:function(e,n){return n-e?exponential(e,n,t):Object(r.a)(isNaN(e)?n:e)}}function nogamma(t,e){var n=e-t;return n?linear(t,n):Object(r.a)(isNaN(t)?e:t)}e.c=hue,e.b=gamma,e.a=nogamma;var r=n(48)},function(t,e,n){"use strict";e.a=function(t){return null===t?NaN:+t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t){return t=Object(r.a)(Math.abs(t)),t?t[1]:NaN}},function(t,e,n){"use strict";function linearish(t){var e=t.domain;return t.ticks=function(t){var n=e();return Object(r.ticks)(n[0],n[n.length-1],null==t?10:t)},t.tickFormat=function(t,n){return Object(o.a)(e(),t,n)},t.nice=function(n){null==n&&(n=10);var a,i=e(),o=0,u=i.length-1,c=i[o],s=i[u];return s<c&&(a=c,c=s,s=a,a=o,o=u,u=a),a=Object(r.tickIncrement)(c,s,n),a>0?(c=Math.floor(c/a)*a,s=Math.ceil(s/a)*a,a=Object(r.tickIncrement)(c,s,n)):a<0&&(c=Math.ceil(c*a)/a,s=Math.floor(s*a)/a,a=Object(r.tickIncrement)(c,s,n)),a>0?(i[o]=Math.floor(c/a)*a,i[u]=Math.ceil(s/a)*a,e(i)):a<0&&(i[o]=Math.ceil(c*a)/a,i[u]=Math.floor(s*a)/a,e(i)),t},t}function linear(){var t=Object(i.b)(i.c,a.interpolateNumber);return t.copy=function(){return Object(i.a)(t,linear())},linearish(t)}e.b=linearish,e.a=linear;var r=n(5),a=n(8),i=n(18),o=n(223)},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return t+e*n}}},function(t,e,n){"use strict";e.a=function(t){return t.match(/.{6}/g).map(function(t){return"#"+t})}},function(t,e,n){"use strict";function tweenRemove(t,e){var n,a;return function(){var i=Object(r.h)(this,t),o=i.tween;if(o!==n){a=n=o;for(var u=0,c=a.length;u<c;++u)if(a[u].name===e){a=a.slice(),a.splice(u,1);break}}i.tween=a}}function tweenFunction(t,e,n){var a,i;if("function"!=typeof n)throw new Error;return function(){var o=Object(r.h)(this,t),u=o.tween;if(u!==a){i=(a=u).slice();for(var c={name:e,value:n},s=0,f=i.length;s<f;++s)if(i[s].name===e){i[s]=c;break}s===f&&i.push(c)}o.tween=i}}function tweenValue(t,e,n){var a=t._id;return t.each(function(){var t=Object(r.h)(this,a);(t.value||(t.value={}))[e]=n.apply(this,arguments)}),function(t){return Object(r.f)(t,a).value[e]}}e.b=tweenValue;var r=n(2);e.a=function(t,e){var n=this._id;if(t+="",arguments.length<2){for(var a,i=Object(r.f)(this.node(),n).tween,o=0,u=i.length;o<u;++o)if((a=i[o]).name===t)return a.value;return null}return this.each((null==e?tweenRemove:tweenFunction)(n,t,e))}},function(t,e,n){"use strict";function deinterpolateLinear(t,e){return(e-=t=+t)?function(n){return(n-t)/e}:Object(o.a)(e)}function deinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=e?0:t>=n?1:r(t)}}}function reinterpolateClamp(t){return function(e,n){var r=t(e=+e,n=+n);return function(t){return t<=0?e:t>=1?n:r(t)}}}function bimap(t,e,n,r){var a=t[0],i=t[1],o=e[0],u=e[1];return i<a?(a=n(i,a),o=r(u,o)):(a=n(a,i),o=r(o,u)),function(t){return o(a(t))}}function polymap(t,e,n,a){var i=Math.min(t.length,e.length)-1,o=new Array(i),u=new Array(i),c=-1;for(t[i]<t[0]&&(t=t.slice().reverse(),e=e.slice().reverse());++c<i;)o[c]=n(t[c],t[c+1]),u[c]=a(e[c],e[c+1]);return function(e){var n=Object(r.bisect)(t,e,1,i)-1;return u[n](o[n](e))}}function copy(t,e){return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp())}function continuous(t,e){function rescale(){return n=Math.min(s.length,f.length)>2?polymap:bimap,r=o=null,scale}function scale(e){return(r||(r=n(s,f,h?deinterpolateClamp(t):t,l)))(+e)}var n,r,o,s=c,f=c,l=a.interpolate,h=!1;return scale.invert=function(t){return(o||(o=n(f,s,deinterpolateLinear,h?reinterpolateClamp(e):e)))(+t)},scale.domain=function(t){return arguments.length?(s=i.a.call(t,u.a),rescale()):s.slice()},scale.range=function(t){return arguments.length?(f=i.b.call(t),rescale()):f.slice()},scale.rangeRound=function(t){return f=i.b.call(t),l=a.interpolateRound,rescale()},scale.clamp=function(t){return arguments.length?(h=!!t,rescale()):h},scale.interpolate=function(t){return arguments.length?(l=t,rescale()):l},rescale()}e.c=deinterpolateLinear,e.a=copy,e.b=continuous;var r=n(5),a=n(8),i=n(9),o=n(39),u=n(82),c=[0,1]},function(t,e,n){"use strict";function Color(){}function color(t){var e;return t=(t+"").trim().toLowerCase(),(e=s.exec(t))?(e=parseInt(e[1],16),new Rgb(e>>8&15|e>>4&240,e>>4&15|240&e,(15&e)<<4|15&e,1)):(e=f.exec(t))?rgbn(parseInt(e[1],16)):(e=l.exec(t))?new Rgb(e[1],e[2],e[3],1):(e=h.exec(t))?new Rgb(255*e[1]/100,255*e[2]/100,255*e[3]/100,1):(e=d.exec(t))?rgba(e[1],e[2],e[3],e[4]):(e=p.exec(t))?rgba(255*e[1]/100,255*e[2]/100,255*e[3]/100,e[4]):(e=b.exec(t))?hsla(e[1],e[2]/100,e[3]/100,1):(e=v.exec(t))?hsla(e[1],e[2]/100,e[3]/100,e[4]):m.hasOwnProperty(t)?rgbn(m[t]):"transparent"===t?new Rgb(NaN,NaN,NaN,0):null}function rgbn(t){return new Rgb(t>>16&255,t>>8&255,255&t,1)}function rgba(t,e,n,r){return r<=0&&(t=e=n=NaN),new Rgb(t,e,n,r)}function rgbConvert(t){return t instanceof Color||(t=color(t)),t?(t=t.rgb(),new Rgb(t.r,t.g,t.b,t.opacity)):new Rgb}function rgb(t,e,n,r){return 1===arguments.length?rgbConvert(t):new Rgb(t,e,n,null==r?1:r)}function Rgb(t,e,n,r){this.r=+t,this.g=+e,this.b=+n,this.opacity=+r}function hsla(t,e,n,r){return r<=0?t=e=n=NaN:n<=0||n>=1?t=e=NaN:e<=0&&(t=NaN),new Hsl(t,e,n,r)}function hslConvert(t){if(t instanceof Hsl)return new Hsl(t.h,t.s,t.l,t.opacity);if(t instanceof Color||(t=color(t)),!t)return new Hsl;if(t instanceof Hsl)return t;t=t.rgb();var e=t.r/255,n=t.g/255,r=t.b/255,a=Math.min(e,n,r),i=Math.max(e,n,r),o=NaN,u=i-a,c=(i+a)/2;return u?(o=e===i?(n-r)/u+6*(n<r):n===i?(r-e)/u+2:(e-n)/u+4,u/=c<.5?i+a:2-i-a,o*=60):u=c>0&&c<1?0:o,new Hsl(o,u,c,t.opacity)}function hsl(t,e,n,r){return 1===arguments.length?hslConvert(t):new Hsl(t,e,n,null==r?1:r)}function Hsl(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}function hsl2rgb(t,e,n){return 255*(t<60?e+(n-e)*t/60:t<180?n:t<240?e+(n-e)*(240-t)/60:e)}e.a=Color,n.d(e,"d",function(){return a}),n.d(e,"c",function(){return i}),e.e=color,e.h=rgbConvert,e.g=rgb,e.b=Rgb,e.f=hsl;var r=n(20),a=.7,i=1/a,o="\\s*([+-]?\\d+)\\s*",u="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",s=/^#([0-9a-f]{3})$/,f=/^#([0-9a-f]{6})$/,l=new RegExp("^rgb\\("+[o,o,o]+"\\)$"),h=new RegExp("^rgb\\("+[c,c,c]+"\\)$"),d=new RegExp("^rgba\\("+[o,o,o,u]+"\\)$"),p=new RegExp("^rgba\\("+[c,c,c,u]+"\\)$"),b=new RegExp("^hsl\\("+[u,c,c]+"\\)$"),v=new RegExp("^hsla\\("+[u,c,c,u]+"\\)$"),m={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};Object(r.a)(Color,color,{displayable:function(){return this.rgb().displayable()},toString:function(){return this.rgb()+""}}),Object(r.a)(Rgb,rgb,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return 0<=this.r&&this.r<=255&&0<=this.g&&this.g<=255&&0<=this.b&&this.b<=255&&0<=this.opacity&&this.opacity<=1},toString:function(){var t=this.opacity;return t=isNaN(t)?1:Math.max(0,Math.min(1,t)),(1===t?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}})),Object(r.a)(Hsl,hsl,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),e=isNaN(t)||isNaN(this.s)?0:this.s,n=this.l,r=n+(n<.5?n:1-n)*e,a=2*n-r;return new Rgb(hsl2rgb(t>=240?t-240:t+120,a,r),hsl2rgb(t,a,r),hsl2rgb(t<120?t+240:t-120,a,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1}}))},function(t,e,n){"use strict";function extend(t,e){var n=Object.create(t.prototype);for(var r in e)n[r]=e[r];return n}e.b=extend,e.a=function(t,e,n){t.prototype=e.prototype=n,n.constructor=t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(105);n.d(e,"formatDefaultLocale",function(){return r.a}),n.d(e,"format",function(){return r.b}),n.d(e,"formatPrefix",function(){return r.c});var a=n(42);n.d(e,"formatLocale",function(){return a.a});var i=n(43);n.d(e,"formatSpecifier",function(){return i.a});var o=n(111);n.d(e,"precisionFixed",function(){return o.a});var u=n(112);n.d(e,"precisionPrefix",function(){return u.a});var c=n(113);n.d(e,"precisionRound",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){if((n=(t=e?t.toExponential(e-1):t.toExponential()).indexOf("e"))<0)return null;var n,r=t.slice(0,n);return[r.length>1?r[0]+r.slice(2):r,+t.slice(n+1)]}},function(t,e,n){"use strict";var r=n(4),a=n(46),i=n(49),o=n(50),u=n(15),c=n(51),s=n(52),f=n(48);e.a=function(t,e){var n,l=typeof e;return null==e||"boolean"===l?Object(f.a)(e):("number"===l?u.a:"string"===l?(n=Object(r.color)(e))?(e=n,a.a):s.a:e instanceof r.color?a.a:e instanceof Date?o.a:Array.isArray(e)?i.a:"function"!=typeof e.valueOf&&"function"!=typeof e.toString||isNaN(e)?c.a:u.a)(t,e)}},function(t,e,n){"use strict";function basis(t,e,n,r,a){var i=t*t,o=i*t;return((1-3*t+3*i-o)*e+(4-6*i+3*o)*n+(1+3*t+3*i-3*o)*r+o*a)/6}e.a=basis,e.b=function(t){var e=t.length-1;return function(n){var r=n<=0?n=0:n>=1?(n=1,e-1):Math.floor(n*e),a=t[r],i=t[r+1],o=r>0?t[r-1]:2*a-i,u=r<e-1?t[r+2]:2*i-a;return basis((n-r/e)*e,o,a,i,u)}}},function(t,e,n){"use strict";function creatorInherit(t){return function(){var e=this.ownerDocument,n=this.namespaceURI;return n===a.b&&e.documentElement.namespaceURI===a.b?e.createElement(t):e.createElementNS(n,t)}}function creatorFixed(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}var r=n(26),a=n(27);e.a=function(t){var e=Object(r.a)(t);return(e.local?creatorFixed:creatorInherit)(e)}},function(t,e,n){"use strict";var r=n(27);e.a=function(t){var e=t+="",n=e.indexOf(":");return n>=0&&"xmlns"!==(e=t.slice(0,n))&&(t=t.slice(n+1)),r.a.hasOwnProperty(e)?{space:r.a[e],local:t}:t}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r="http://www.w3.org/1999/xhtml";e.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,e,n){"use strict";var r=n(29);e.a=function(){for(var t,e=r.c;t=e.sourceEvent;)e=t;return e}},function(t,e,n){"use strict";function filterContextListener(t,e,n){return t=contextListener(t,e,n),function(e){var n=e.relatedTarget;n&&(n===this||8&n.compareDocumentPosition(this))||t.call(this,e)}}function contextListener(t,e,n){return function(r){var i=a;a=r;try{t.call(this,this.__data__,e,n)}finally{a=i}}}function parseTypenames(t){return t.trim().split(/^|\s+/).map(function(t){var e="",n=t.indexOf(".");return n>=0&&(e=t.slice(n+1),t=t.slice(0,n)),{type:t,name:e}})}function onRemove(t){return function(){var e=this.__on;if(e){for(var n,r=0,a=-1,i=e.length;r<i;++r)n=e[r],t.type&&n.type!==t.type||n.name!==t.name?e[++a]=n:this.removeEventListener(n.type,n.listener,n.capture);++a?e.length=a:delete this.__on}}}function onAdd(t,e,n){var a=r.hasOwnProperty(t.type)?filterContextListener:contextListener;return function(r,i,o){var u,c=this.__on,s=a(e,i,o);if(c)for(var f=0,l=c.length;f<l;++f)if((u=c[f]).type===t.type&&u.name===t.name)return this.removeEventListener(u.type,u.listener,u.capture),this.addEventListener(u.type,u.listener=s,u.capture=n),void(u.value=e);this.addEventListener(t.type,s,n),u={type:t.type,name:t.name,value:e,listener:s,capture:n},c?c.push(u):this.__on=[u]}}function customEvent(t,e,n,r){var i=a;t.sourceEvent=a,a=t;try{return e.apply(n,r)}finally{a=i}}n.d(e,"c",function(){return a}),e.a=customEvent;var r={},a=null;if("undefined"!=typeof document){"onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"})}e.b=function(t,e,n){var r,a,i=parseTypenames(t+""),o=i.length;{if(!(arguments.length<2)){for(u=e?onAdd:onRemove,null==n&&(n=!1),r=0;r<o;++r)this.each(u(i[r],e,n));return this}var u=this.node().__on;if(u)for(var c,s=0,f=u.length;s<f;++s)for(r=0,c=u[s];r<o;++r)if((a=i[r]).type===c.type&&a.name===c.name)return c.value}}},function(t,e,n){"use strict";e.a=function(t,e){var n=t.ownerSVGElement||t;if(n.createSVGPoint){var r=n.createSVGPoint();return r.x=e.clientX,r.y=e.clientY,r=r.matrixTransform(t.getScreenCTM().inverse()),[r.x,r.y]}var a=t.getBoundingClientRect();return[e.clientX-a.left-t.clientLeft,e.clientY-a.top-t.clientTop]}},function(t,e,n){"use strict";function none(){}e.a=function(t){return null==t?none:function(){return this.querySelector(t)}}},function(t,e,n){"use strict";e.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,e,n){"use strict";function now(){return f||(d(clearNow),f=h.now()+l)}function clearNow(){f=0}function Timer(){this._call=this._time=this._next=null}function timer(t,e,n){var r=new Timer;return r.restart(t,e,n),r}function timerFlush(){now(),++i;for(var t,e=r;e;)(t=f-e._time)>=0&&e._call.call(null,t),e=e._next;--i}function wake(){f=(s=h.now())+l,i=o=0;try{timerFlush()}finally{i=0,nap(),f=0}}function poke(){var t=h.now(),e=t-s;e>c&&(l-=e,s=t)}function nap(){for(var t,e,n=r,i=1/0;n;)n._call?(i>n._time&&(i=n._time),t=n,n=n._next):(e=n._next,n._next=null,n=t?t._next=e:r=e);a=t,sleep(i)}function sleep(t){if(!i){o&&(o=clearTimeout(o));var e=t-f;e>24?(t<1/0&&(o=setTimeout(wake,e)),u&&(u=clearInterval(u))):(u||(s=f,u=setInterval(poke,c)),i=1,d(wake))}}e.b=now,e.a=Timer,e.c=timer;var r,a,i=0,o=0,u=0,c=1e3,s=0,f=0,l=0,h="object"==typeof performance&&performance.now?performance:Date,d="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};Timer.prototype=timer.prototype={constructor:Timer,restart:function(t,e,n){if("function"!=typeof t)throw new TypeError("callback is not a function");n=(null==n?now():+n)+(null==e?0:+e),this._next||a===this||(a?a._next=this:r=this,a=this),this._call=t,this._time=n,sleep()},stop:function(){this._call&&(this._call=null,this._time=1/0,sleep())}}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(0);n.d(e,"timeInterval",function(){return r.a});var a=n(200);n.d(e,"timeMillisecond",function(){return a.a}),n.d(e,"timeMilliseconds",function(){return a.b}),n.d(e,"utcMillisecond",function(){return a.a}),n.d(e,"utcMilliseconds",function(){return a.b});var i=n(201);n.d(e,"timeSecond",function(){return i.a}),n.d(e,"timeSeconds",function(){return i.b}),n.d(e,"utcSecond",function(){return i.a}),n.d(e,"utcSeconds",function(){return i.b});var o=n(202);n.d(e,"timeMinute",function(){return o.a}),n.d(e,"timeMinutes",function(){return o.b});var u=n(203);n.d(e,"timeHour",function(){return u.a}),n.d(e,"timeHours",function(){return u.b});var c=n(204);n.d(e,"timeDay",function(){return c.b}),n.d(e,"timeDays",function(){return c.a});var s=n(205);n.d(e,"timeWeek",function(){return s.g}),n.d(e,"timeWeeks",function(){return s.h}),n.d(e,"timeSunday",function(){return s.g}),n.d(e,"timeSundays",function(){return s.h}),n.d(e,"timeMonday",function(){return s.c}),n.d(e,"timeMondays",function(){return s.d}),n.d(e,"timeTuesday",function(){return s.k}),n.d(e,"timeTuesdays",function(){return s.l}),n.d(e,"timeWednesday",function(){return s.m}),n.d(e,"timeWednesdays",function(){return s.n}),n.d(e,"timeThursday",function(){return s.i}),n.d(e,"timeThursdays",function(){return s.j}),n.d(e,"timeFriday",function(){return s.a}),n.d(e,"timeFridays",function(){return s.b}),n.d(e,"timeSaturday",function(){return s.e}),n.d(e,"timeSaturdays",function(){return s.f});var f=n(206);n.d(e,"timeMonth",function(){return f.a}),n.d(e,"timeMonths",function(){return f.b});var l=n(207);n.d(e,"timeYear",function(){return l.a}),n.d(e,"timeYears",function(){return l.b});var h=n(208);n.d(e,"utcMinute",function(){return h.a}),n.d(e,"utcMinutes",function(){return h.b});var d=n(209);n.d(e,"utcHour",function(){return d.a}),n.d(e,"utcHours",function(){return d.b});var p=n(210);n.d(e,"utcDay",function(){return p.a}),n.d(e,"utcDays",function(){return p.b});var b=n(211);n.d(e,"utcWeek",function(){return b.g}),n.d(e,"utcWeeks",function(){return b.h}),n.d(e,"utcSunday",function(){return b.g}),n.d(e,"utcSundays",function(){return b.h}),n.d(e,"utcMonday",function(){return b.c}),n.d(e,"utcMondays",function(){return b.d}),n.d(e,"utcTuesday",function(){return b.k}),n.d(e,"utcTuesdays",function(){return b.l}),n.d(e,"utcWednesday",function(){return b.m}),n.d(e,"utcWednesdays",function(){return b.n}),n.d(e,"utcThursday",function(){return b.i}),n.d(e,"utcThursdays",function(){return b.j}),n.d(e,"utcFriday",function(){return b.a}),n.d(e,"utcFridays",function(){return b.b}),n.d(e,"utcSaturday",function(){return b.e}),n.d(e,"utcSaturdays",function(){return b.f});var v=n(212);n.d(e,"utcMonth",function(){return v.a}),n.d(e,"utcMonths",function(){return v.b});var m=n(213);n.d(e,"utcYear",function(){return m.a}),n.d(e,"utcYears",function(){return m.b})},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e,n){if(null==n&&(n=r.a),a=t.length){if((e=+e)<=0||a<2)return+n(t[0],0,t);if(e>=1)return+n(t[a-1],a-1,t);var a,i=(a-1)*e,o=Math.floor(i),u=+n(t[o],o,t);return u+(+n(t[o+1],o+1,t)-u)*(i-o)}}},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(c.a)(t),a=r.format,i=r.parse,o=r.utcFormat,u=r.utcParse,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"d",function(){return o}),n.d(e,"e",function(){return u}),e.a=defaultLocale;var r,a,i,o,u,c=n(79);defaultLocale({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,e,n){"use strict";function Map(){}function map(t,e){var n=new Map;if(t instanceof Map)t.each(function(t,e){n.set(e,t)});else if(Array.isArray(t)){var r,a=-1,i=t.length;if(null==e)for(;++a<i;)n.set(a,t[a]);else for(;++a<i;)n.set(e(r=t[a],a,t),r)}else if(t)for(var o in t)n.set(o,t[o]);return n}n.d(e,"b",function(){return r});var r="$";Map.prototype=map.prototype={constructor:Map,has:function(t){return r+t in this},get:function(t){return this[r+t]},set:function(t,e){return this[r+t]=e,this},remove:function(t){var e=r+t;return e in this&&delete this[e]},clear:function(){for(var t in this)t[0]===r&&delete this[t]},keys:function(){var t=[];for(var e in this)e[0]===r&&t.push(e.slice(1));return t},values:function(){var t=[];for(var e in this)e[0]===r&&t.push(this[e]);return t},entries:function(){var t=[];for(var e in this)e[0]===r&&t.push({key:e.slice(1),value:this[e]});return t},size:function(){var t=0;for(var e in this)e[0]===r&&++t;return t},empty:function(){for(var t in this)if(t[0]===r)return!1;return!0},each:function(t){for(var e in this)e[0]===r&&t(this[e],e.slice(1),this)}},e.a=map},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(37);n.d(e,"timeFormatDefaultLocale",function(){return r.a}),n.d(e,"timeFormat",function(){return r.b}),n.d(e,"timeParse",function(){return r.c}),n.d(e,"utcFormat",function(){return r.d}),n.d(e,"utcParse",function(){return r.e});var a=n(79);n.d(e,"timeFormatLocale",function(){return a.a});var i=n(80);n.d(e,"isoFormat",function(){return i.a});var o=n(214);n.d(e,"isoParse",function(){return o.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"b",function(){return a});var r=Math.PI/180,a=180/Math.PI},function(t,e,n){"use strict";var r=n(13),a=n(106),i=n(107),o=n(43),u=n(44),c=n(45),s=n(110),f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];e.a=function(t){function newFormat(t){function format(t){var n,o,u,s=g,d=_;if("c"===y)d=x(t)+d,t="";else{t=+t;var O=t<0;if(t=x(Math.abs(t),m),O&&0==+t&&(O=!1),s=(O?"("===i?i:"-":"-"===i||"("===i?"":i)+s,d=d+("s"===y?f[8+c.b/3]:"")+(O&&"("===i?")":""),w)for(n=-1,o=t.length;++n<o;)if(48>(u=t.charCodeAt(n))||u>57){d=(46===u?l+t.slice(n+1):t.slice(n))+d,t=t.slice(0,n);break}}v&&!p&&(t=e(t,1/0));var M=s.length+t.length+d.length,C=M<b?new Array(b-M+1).join(r):"";switch(v&&p&&(t=e(C+t,C.length?b-d.length:1/0),C=""),a){case"<":t=s+t+d+C;break;case"=":t=s+C+t+d;break;case"^":t=C.slice(0,M=C.length>>1)+s+t+d+C.slice(M);break;default:t=C+s+t+d}return h(t)}t=Object(o.a)(t);var r=t.fill,a=t.align,i=t.sign,s=t.symbol,p=t.zero,b=t.width,v=t.comma,m=t.precision,y=t.type,g="$"===s?n[0]:"#"===s&&/[boxX]/.test(y)?"0"+y.toLowerCase():"",_="$"===s?n[1]:/[%p]/.test(y)?d:"",x=u.a[y],w=!y||/[defgprs%]/.test(y);return m=null==m?y?6:12:/[gprs]/.test(y)?Math.max(1,Math.min(21,m)):Math.max(0,Math.min(20,m)),format.toString=function(){return t+""},format}function formatPrefix(t,e){var n=newFormat((t=Object(o.a)(t),t.type="f",t)),a=3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3))),i=Math.pow(10,-a),u=f[8+a/3];return function(t){return n(i*t)+u}}var e=t.grouping&&t.thousands?Object(a.a)(t.grouping,t.thousands):s.a,n=t.currency,l=t.decimal,h=t.numerals?Object(i.a)(t.numerals):s.a,d=t.percent||"%";return{format:newFormat,formatPrefix:formatPrefix}}},function(t,e,n){"use strict";function formatSpecifier(t){return new FormatSpecifier(t)}function FormatSpecifier(t){if(!(e=a.exec(t)))throw new Error("invalid format: "+t);var e,n=e[1]||" ",i=e[2]||">",o=e[3]||"-",u=e[4]||"",c=!!e[5],s=e[6]&&+e[6],f=!!e[7],l=e[8]&&+e[8].slice(1),h=e[9]||"";"n"===h?(f=!0,h="g"):r.a[h]||(h=""),(c||"0"===n&&"="===i)&&(c=!0,n="0",i="="),this.fill=n,this.align=i,this.sign=o,this.symbol=u,this.zero=c,this.width=s,this.comma=f,this.precision=l,this.type=h}e.a=formatSpecifier;var r=n(44),a=/^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;formatSpecifier.prototype=FormatSpecifier.prototype,FormatSpecifier.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(null==this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(null==this.precision?"":"."+Math.max(0,0|this.precision))+this.type}},function(t,e,n){"use strict";var r=n(108),a=n(45),i=n(109);e.a={"":r.a,"%":function(t,e){return(100*t).toFixed(e)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,e){return t.toExponential(e)},f:function(t,e){return t.toFixed(e)},g:function(t,e){return t.toPrecision(e)},o:function(t){return Math.round(t).toString(8)},p:function(t,e){return Object(i.a)(100*t,e)},r:i.a,s:a.a,X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r,a=n(22);e.a=function(t,e){var n=Object(a.a)(t,e);if(!n)return t+"";var i=n[0],o=n[1],u=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return u===c?i:u>c?i+new Array(u-c+1).join("0"):u>0?i.slice(0,u)+"."+i.slice(u):"0."+new Array(1-u).join("0")+Object(a.a)(t,Math.max(0,e+u-1))[0]}},function(t,e,n){"use strict";function rgbSpline(t){return function(e){var n,a,i=e.length,o=new Array(i),u=new Array(i),c=new Array(i);for(n=0;n<i;++n)a=Object(r.rgb)(e[n]),o[n]=a.r||0,u[n]=a.g||0,c[n]=a.b||0;return o=t(o),u=t(u),c=t(c),a.opacity=1,function(t){return a.r=o(t),a.g=u(t),a.b=c(t),a+""}}}n.d(e,"b",function(){return u}),n.d(e,"c",function(){return c});var r=n(4),a=n(24),i=n(47),o=n(11);e.a=function rgbGamma(t){function rgb(t,n){var a=e((t=Object(r.rgb)(t)).r,(n=Object(r.rgb)(n)).r),i=e(t.g,n.g),u=e(t.b,n.b),c=Object(o.a)(t.opacity,n.opacity);return function(e){return t.r=a(e),t.g=i(e),t.b=u(e),t.opacity=c(e),t+""}}var e=Object(o.b)(t);return rgb.gamma=rgbGamma,rgb}(1);var u=rgbSpline(a.b),c=rgbSpline(i.a)},function(t,e,n){"use strict";var r=n(24);e.a=function(t){var e=t.length;return function(n){var a=Math.floor(((n%=1)<0?++n:n)*e),i=t[(a+e-1)%e],o=t[a%e],u=t[(a+1)%e],c=t[(a+2)%e];return Object(r.a)((n-a/e)*e,i,o,u,c)}}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a=e?e.length:0,i=t?Math.min(a,t.length):0,o=new Array(a),u=new Array(a);for(n=0;n<i;++n)o[n]=Object(r.a)(t[n],e[n]);for(;n<a;++n)u[n]=e[n];return function(t){for(n=0;n<i;++n)u[n]=o[n](t);return u}}},function(t,e,n){"use strict";e.a=function(t,e){var n=new Date;return t=+t,e-=t,function(r){return n.setTime(t+e*r),n}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a={},i={};null!==t&&"object"==typeof t||(t={}),null!==e&&"object"==typeof e||(e={});for(n in e)n in t?a[n]=Object(r.a)(t[n],e[n]):i[n]=e[n];return function(t){for(n in a)i[n]=a[n](t);return i}}},function(t,e,n){"use strict";function zero(t){return function(){return t}}function one(t){return function(e){return t(e)+""}}var r=n(15),a=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,i=new RegExp(a.source,"g");e.a=function(t,e){var n,o,u,c=a.lastIndex=i.lastIndex=0,s=-1,f=[],l=[];for(t+="",e+="";(n=a.exec(t))&&(o=i.exec(e));)(u=o.index)>c&&(u=e.slice(c,u),f[s]?f[s]+=u:f[++s]=u),(n=n[0])===(o=o[0])?f[s]?f[s]+=o:f[++s]=o:(f[++s]=null,l.push({i:s,x:Object(r.a)(n,o)})),c=i.lastIndex;return c<e.length&&(u=e.slice(c),f[s]?f[s]+=u:f[++s]=u),f.length<2?l[0]?one(l[0].x):zero(e):(e=l.length,function(t){for(var n,r=0;r<e;++r)f[(n=l[r]).i]=n.x(t);return f.join("")})}},function(t,e,n){"use strict";var r=function(t){return function(){return this.matches(t)}};if("undefined"!=typeof document){var a=document.documentElement;if(!a.matches){var i=a.webkitMatchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector;r=function(t){return function(){return i.call(this,t)}}}}e.a=r},function(t,e,n){"use strict";function empty(){return[]}e.a=function(t){return null==t?empty:function(){return this.querySelectorAll(t)}}},function(t,e,n){"use strict";function EnterNode(t,e){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=e}e.a=EnterNode;var r=n(56),a=n(1);e.b=function(){return new a.a(this._enter||this._groups.map(r.a),this._parents)},EnterNode.prototype={constructor:EnterNode,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,e){return this._parent.insertBefore(t,e)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}}},function(t,e,n){"use strict";e.a=function(t){return new Array(t.length)}},function(t,e,n){"use strict";function styleRemove(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){return function(){this.style.setProperty(t,e,n)}}function styleFunction(t,e,n){return function(){var r=e.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,n)}}function styleValue(t,e){return t.style.getPropertyValue(e)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(e)}e.b=styleValue;var r=n(32);e.a=function(t,e,n){return arguments.length>1?this.each((null==e?styleRemove:"function"==typeof e?styleFunction:styleConstant)(t,e,null==n?"":n)):styleValue(this.node(),t)}},function(t,e,n){"use strict";var r=n(2);e.a=function(t,e){var n,a,i,o=t.__transition,u=!0;if(o){e=null==e?null:e+"";for(i in o)(n=o[i]).name===e?(a=n.state>r.d&&n.state<r.b,n.state=r.a,n.timer.stop(),a&&n.on.call("interrupt",t,t.__data__,n.index,n.group),delete o[i]):u=!1;u&&delete t.__transition}}},function(t,e,n){"use strict";var r=n(33);n.d(e,"a",function(){return r.b}),n.d(e,"c",function(){return r.c});var a=n(160);n.d(e,"b",function(){return a.a});n(161)},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=function(t,e){var n;return("number"==typeof e?a.interpolateNumber:e instanceof r.color?a.interpolateRgb:(n=Object(r.color)(e))?(e=n,a.interpolateRgb):a.interpolateString)(t,e)}},function(t,e,n){"use strict";var r=n(264);n.d(e,"a",function(){return r.a})},function(t,e,n){"use strict";function acos(t){return t>1?0:t<-1?l:Math.acos(t)}function asin(t){return t>=1?h:t<=-1?-h:Math.asin(t)}n.d(e,"a",function(){return r}),n.d(e,"d",function(){return a}),n.d(e,"e",function(){return i}),n.d(e,"h",function(){return o}),n.d(e,"i",function(){return u}),n.d(e,"k",function(){return c}),n.d(e,"l",function(){return s}),n.d(e,"f",function(){return f}),n.d(e,"j",function(){return l}),n.d(e,"g",function(){return h}),n.d(e,"m",function(){return d}),e.b=acos,e.c=asin;var r=Math.abs,a=Math.atan2,i=Math.cos,o=Math.max,u=Math.min,c=Math.sin,s=Math.sqrt,f=1e-12,l=Math.PI,h=l/2,d=2*l},function(t,e,n){"use strict";e.a=function(t,e){if((a=t.length)>1)for(var n,r,a,i=1,o=t[e[0]],u=o.length;i<a;++i)for(r=o,o=t[e[i]],n=0;n<u;++n)o[n][1]+=o[n][0]=isNaN(r[n][1])?r[n][0]:r[n][1]}},function(t,e,n){"use strict";e.a=function(t){for(var e=t.length,n=new Array(e);--e>=0;)n[e]=e;return n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(92);n.d(e,"easeLinear",function(){return r.a});var a=n(93);n.d(e,"easeQuad",function(){return a.b}),n.d(e,"easeQuadIn",function(){return a.a}),n.d(e,"easeQuadOut",function(){return a.c}),n.d(e,"easeQuadInOut",function(){return a.b});var i=n(94);n.d(e,"easeCubic",function(){return i.b}),n.d(e,"easeCubicIn",function(){return i.a}),n.d(e,"easeCubicOut",function(){return i.c}),n.d(e,"easeCubicInOut",function(){return i.b});var o=n(95);n.d(e,"easePoly",function(){return o.b}),n.d(e,"easePolyIn",function(){return o.a}),n.d(e,"easePolyOut",function(){return o.c}),n.d(e,"easePolyInOut",function(){return o.b});var u=n(96);n.d(e,"easeSin",function(){return u.b}),n.d(e,"easeSinIn",function(){return u.a}),n.d(e,"easeSinOut",function(){return u.c}),n.d(e,"easeSinInOut",function(){return u.b});var c=n(97);n.d(e,"easeExp",function(){return c.b}),n.d(e,"easeExpIn",function(){return c.a}),n.d(e,"easeExpOut",function(){return c.c}),n.d(e,"easeExpInOut",function(){return c.b});var s=n(98);n.d(e,"easeCircle",function(){return s.b}),n.d(e,"easeCircleIn",function(){return s.a}),n.d(e,"easeCircleOut",function(){return s.c}),n.d(e,"easeCircleInOut",function(){return s.b});var f=n(99);n.d(e,"easeBounce",function(){return f.c}),n.d(e,"easeBounceIn",function(){return f.a}),n.d(e,"easeBounceOut",function(){return f.c}),n.d(e,"easeBounceInOut",function(){return f.b});var l=n(100);n.d(e,"easeBack",function(){return l.b}),n.d(e,"easeBackIn",function(){return l.a}),n.d(e,"easeBackOut",function(){return l.c}),n.d(e,"easeBackInOut",function(){return l.b});var h=n(101);n.d(e,"easeElastic",function(){return h.c}),n.d(e,"easeElasticIn",function(){return h.a}),n.d(e,"easeElasticOut",function(){return h.c}),n.d(e,"easeElasticInOut",function(){return h.b})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(104);n.d(e,"dispatch",function(){return r.a})},function(t,e,n){"use strict";n.d(e,"b",function(){return o}),n.d(e,"a",function(){return u});var r=n(10),a=n(68),i=Object(a.a)(r.a),o=i.right,u=i.left;e.c=o},function(t,e,n){"use strict";function ascendingComparator(t){return function(e,n){return Object(r.a)(t(e),n)}}var r=n(10);e.a=function(t){return 1===t.length&&(t=ascendingComparator(t)),{left:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)<0?r=i+1:a=i}return r},right:function(e,n,r,a){for(null==r&&(r=0),null==a&&(a=e.length);r<a;){var i=r+a>>>1;t(e[i],n)>0?a=i:r=i+1}return r}}}},function(t,e,n){"use strict";function pair(t,e){return[t,e]}e.b=pair,e.a=function(t,e){null==e&&(e=pair);for(var n=0,r=t.length-1,a=t[0],i=new Array(r<0?0:r);n<r;)i[n]=e(a,a=t[++n]);return i}},function(t,e,n){"use strict";var r=n(71);e.a=function(t,e){var n=Object(r.a)(t,e);return n?Math.sqrt(n):n}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a,i=t.length,o=0,u=-1,c=0,s=0;if(null==e)for(;++u<i;)isNaN(n=Object(r.a)(t[u]))||(a=n-c,c+=a/++o,s+=a*(n-c));else for(;++u<i;)isNaN(n=Object(r.a)(e(t[u],u,t)))||(a=n-c,c+=a/++o,s+=a*(n-c));if(o>1)return s/(o-1)}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a,i=t.length,o=-1;if(null==e){for(;++o<i;)if(null!=(n=t[o])&&n>=n)for(r=a=n;++o<i;)null!=(n=t[o])&&(r>n&&(r=n),a<n&&(a=n))}else for(;++o<i;)if(null!=(n=e(t[o],o,t))&&n>=n)for(r=a=n;++o<i;)null!=(n=e(t[o],o,t))&&(r>n&&(r=n),a<n&&(a=n));return[r,a]}},function(t,e,n){"use strict";n.d(e,"b",function(){return a}),n.d(e,"a",function(){return i});var r=Array.prototype,a=r.slice,i=r.map},function(t,e,n){"use strict";e.a=function(t,e,n){t=+t,e=+e,n=(a=arguments.length)<2?(e=t,t=0,1):a<3?1:+n;for(var r=-1,a=0|Math.max(0,Math.ceil((e-t)/n)),i=new Array(a);++r<a;)i[r]=t+r*n;return i}},function(t,e,n){"use strict";function tickIncrement(t,e,n){var o=(e-t)/Math.max(0,n),u=Math.floor(Math.log(o)/Math.LN10),c=o/Math.pow(10,u);return u>=0?(c>=r?10:c>=a?5:c>=i?2:1)*Math.pow(10,u):-Math.pow(10,-u)/(c>=r?10:c>=a?5:c>=i?2:1)}function tickStep(t,e,n){var o=Math.abs(e-t)/Math.max(0,n),u=Math.pow(10,Math.floor(Math.log(o)/Math.LN10)),c=o/u;return c>=r?u*=10:c>=a?u*=5:c>=i&&(u*=2),e<t?-u:u}e.b=tickIncrement,e.c=tickStep;var r=Math.sqrt(50),a=Math.sqrt(10),i=Math.sqrt(2);e.a=function(t,e,n){var r,a,i,o=e<t,u=-1;if(o&&(r=t,t=e,e=r),0===(i=tickIncrement(t,e,n))||!isFinite(i))return[];if(i>0)for(t=Math.ceil(t/i),e=Math.floor(e/i),a=new Array(r=Math.ceil(e-t+1));++u<r;)a[u]=(t+u)*i;else for(t=Math.floor(t*i),e=Math.ceil(e*i),a=new Array(r=Math.ceil(t-e+1));++u<r;)a[u]=(t-u)/i;return o&&a.reverse(),a}},function(t,e,n){"use strict";e.a=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&r>n&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&r>n&&(r=n);return r}},function(t,e,n){"use strict";function length(t){return t.length}var r=n(77);e.a=function(t){if(!(i=t.length))return[];for(var e=-1,n=Object(r.a)(t,length),a=new Array(n);++e<n;)for(var i,o=-1,u=a[e]=new Array(i);++o<i;)u[o]=t[o][e];return a}},function(t,e,n){"use strict";function localDate(t){if(0<=t.y&&t.y<100){var e=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return e.setFullYear(t.y),e}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function utcDate(t){if(0<=t.y&&t.y<100){var e=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return e.setUTCFullYear(t.y),e}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function newYear(t){return{y:t,m:0,d:1,H:0,M:0,S:0,L:0}}function formatLocale(t){function newFormat(t,e){return function(n){var r,i,o,u=[],c=-1,s=0,f=t.length;for(n instanceof Date||(n=new Date(+n));++c<f;)37===t.charCodeAt(c)&&(u.push(t.slice(s,c)),null!=(i=a[r=t.charAt(++c)])?r=t.charAt(++c):i="e"===r?" ":"0",(o=e[r])&&(r=o(n,i)),u.push(r),s=c+1);return u.push(t.slice(s,c)),u.join("")}}function newParse(t,e){return function(n){var r=newYear(1900);if(parseSpecifier(r,t,n+="",0)!=n.length)return null;if("p"in r&&(r.H=r.H%12+12*r.p),"W"in r||"U"in r){"w"in r||(r.w="W"in r?1:0);var a="Z"in r?utcDate(newYear(r.y)).getUTCDay():e(newYear(r.y)).getDay();r.m=0,r.d="W"in r?(r.w+6)%7+7*r.W-(a+5)%7:r.w+7*r.U-(a+6)%7}return"Z"in r?(r.H+=r.Z/100|0,r.M+=r.Z%100,utcDate(r)):e(r)}}function parseSpecifier(t,e,n,r){for(var i,o,u=0,c=e.length,s=n.length;u<c;){if(r>=s)return-1;if(37===(i=e.charCodeAt(u++))){if(i=e.charAt(u++),!(o=w[i in a?e.charAt(u++):i])||(r=o(t,n,r))<0)return-1}else if(i!=n.charCodeAt(r++))return-1}return r}function parsePeriod(t,e,n){var r=f.exec(e.slice(n));return r?(t.p=l[r[0].toLowerCase()],n+r[0].length):-1}function parseShortWeekday(t,e,n){var r=p.exec(e.slice(n));return r?(t.w=b[r[0].toLowerCase()],n+r[0].length):-1}function parseWeekday(t,e,n){var r=h.exec(e.slice(n));return r?(t.w=d[r[0].toLowerCase()],n+r[0].length):-1}function parseShortMonth(t,e,n){var r=y.exec(e.slice(n));return r?(t.m=g[r[0].toLowerCase()],n+r[0].length):-1}function parseMonth(t,e,n){var r=v.exec(e.slice(n));return r?(t.m=m[r[0].toLowerCase()],n+r[0].length):-1}function parseLocaleDateTime(t,n,r){return parseSpecifier(t,e,n,r)}function parseLocaleDate(t,e,r){return parseSpecifier(t,n,e,r)}function parseLocaleTime(t,e,n){return parseSpecifier(t,r,e,n)}function formatShortWeekday(t){return u[t.getDay()]}function formatWeekday(t){return o[t.getDay()]}function formatShortMonth(t){return s[t.getMonth()]}function formatMonth(t){return c[t.getMonth()]}function formatPeriod(t){return i[+(t.getHours()>=12)]}function formatUTCShortWeekday(t){return u[t.getUTCDay()]}function formatUTCWeekday(t){return o[t.getUTCDay()]}function formatUTCShortMonth(t){return s[t.getUTCMonth()]}function formatUTCMonth(t){return c[t.getUTCMonth()]}function formatUTCPeriod(t){return i[+(t.getUTCHours()>=12)]}var e=t.dateTime,n=t.date,r=t.time,i=t.periods,o=t.days,u=t.shortDays,c=t.months,s=t.shortMonths,f=formatRe(i),l=formatLookup(i),h=formatRe(o),d=formatLookup(o),p=formatRe(u),b=formatLookup(u),v=formatRe(c),m=formatLookup(c),y=formatRe(s),g=formatLookup(s),_={a:formatShortWeekday,A:formatWeekday,b:formatShortMonth,B:formatMonth,c:null,d:formatDayOfMonth,e:formatDayOfMonth,H:formatHour24,I:formatHour12,j:formatDayOfYear,L:formatMilliseconds,m:formatMonthNumber,M:formatMinutes,p:formatPeriod,S:formatSeconds,U:formatWeekNumberSunday,w:formatWeekdayNumber,W:formatWeekNumberMonday,x:null,X:null,y:formatYear,Y:formatFullYear,Z:formatZone,"%":formatLiteralPercent},x={a:formatUTCShortWeekday,A:formatUTCWeekday,b:formatUTCShortMonth,B:formatUTCMonth,c:null,d:formatUTCDayOfMonth,e:formatUTCDayOfMonth,H:formatUTCHour24,I:formatUTCHour12,j:formatUTCDayOfYear,L:formatUTCMilliseconds,m:formatUTCMonthNumber,M:formatUTCMinutes,p:formatUTCPeriod,S:formatUTCSeconds,U:formatUTCWeekNumberSunday,w:formatUTCWeekdayNumber,W:formatUTCWeekNumberMonday,x:null,X:null,y:formatUTCYear,Y:formatUTCFullYear,Z:formatUTCZone,"%":formatLiteralPercent},w={a:parseShortWeekday,A:parseWeekday,b:parseShortMonth,B:parseMonth,c:parseLocaleDateTime,d:parseDayOfMonth,e:parseDayOfMonth,H:parseHour24,I:parseHour24,j:parseDayOfYear,L:parseMilliseconds,m:parseMonthNumber,M:parseMinutes,p:parsePeriod,S:parseSeconds,U:parseWeekNumberSunday,w:parseWeekdayNumber,W:parseWeekNumberMonday,x:parseLocaleDate,X:parseLocaleTime,y:parseYear,Y:parseFullYear,Z:parseZone,"%":parseLiteralPercent};return _.x=newFormat(n,_),_.X=newFormat(r,_),_.c=newFormat(e,_),x.x=newFormat(n,x),x.X=newFormat(r,x),x.c=newFormat(e,x),{format:function(t){var e=newFormat(t+="",_);return e.toString=function(){return t},e},parse:function(t){var e=newParse(t+="",localDate);return e.toString=function(){return t},e},utcFormat:function(t){var e=newFormat(t+="",x);return e.toString=function(){return t},e},utcParse:function(t){var e=newParse(t,utcDate);return e.toString=function(){return t},e}}}function pad(t,e,n){var r=t<0?"-":"",a=(r?-t:t)+"",i=a.length;return r+(i<n?new Array(n-i+1).join(e)+a:a)}function requote(t){return t.replace(u,"\\$&")}function formatRe(t){return new RegExp("^(?:"+t.map(requote).join("|")+")","i")}function formatLookup(t){for(var e={},n=-1,r=t.length;++n<r;)e[t[n].toLowerCase()]=n;return e}function parseWeekdayNumber(t,e,n){var r=i.exec(e.slice(n,n+1));return r?(t.w=+r[0],n+r[0].length):-1}function parseWeekNumberSunday(t,e,n){var r=i.exec(e.slice(n));return r?(t.U=+r[0],n+r[0].length):-1}function parseWeekNumberMonday(t,e,n){var r=i.exec(e.slice(n));return r?(t.W=+r[0],n+r[0].length):-1}function parseFullYear(t,e,n){var r=i.exec(e.slice(n,n+4));return r?(t.y=+r[0],n+r[0].length):-1}function parseYear(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),n+r[0].length):-1}function parseZone(t,e,n){var r=/^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(e.slice(n,n+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),n+r[0].length):-1}function parseMonthNumber(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.m=r[0]-1,n+r[0].length):-1}function parseDayOfMonth(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.d=+r[0],n+r[0].length):-1}function parseDayOfYear(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.m=0,t.d=+r[0],n+r[0].length):-1}function parseHour24(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.H=+r[0],n+r[0].length):-1}function parseMinutes(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.M=+r[0],n+r[0].length):-1}function parseSeconds(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.S=+r[0],n+r[0].length):-1}function parseMilliseconds(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.L=+r[0],n+r[0].length):-1}function parseLiteralPercent(t,e,n){var r=o.exec(e.slice(n,n+1));return r?n+r[0].length:-1}function formatDayOfMonth(t,e){return pad(t.getDate(),e,2)}function formatHour24(t,e){return pad(t.getHours(),e,2)}function formatHour12(t,e){return pad(t.getHours()%12||12,e,2)}function formatDayOfYear(t,e){return pad(1+r.timeDay.count(Object(r.timeYear)(t),t),e,3)}function formatMilliseconds(t,e){return pad(t.getMilliseconds(),e,3)}function formatMonthNumber(t,e){return pad(t.getMonth()+1,e,2)}function formatMinutes(t,e){return pad(t.getMinutes(),e,2)}function formatSeconds(t,e){return pad(t.getSeconds(),e,2)}function formatWeekNumberSunday(t,e){return pad(r.timeSunday.count(Object(r.timeYear)(t),t),e,2)}function formatWeekdayNumber(t){return t.getDay()}function formatWeekNumberMonday(t,e){return pad(r.timeMonday.count(Object(r.timeYear)(t),t),e,2)}function formatYear(t,e){return pad(t.getFullYear()%100,e,2)}function formatFullYear(t,e){return pad(t.getFullYear()%1e4,e,4)}function formatZone(t){var e=t.getTimezoneOffset();return(e>0?"-":(e*=-1,"+"))+pad(e/60|0,"0",2)+pad(e%60,"0",2)}function formatUTCDayOfMonth(t,e){return pad(t.getUTCDate(),e,2)}function formatUTCHour24(t,e){return pad(t.getUTCHours(),e,2)}function formatUTCHour12(t,e){return pad(t.getUTCHours()%12||12,e,2)}function formatUTCDayOfYear(t,e){return pad(1+r.utcDay.count(Object(r.utcYear)(t),t),e,3)}function formatUTCMilliseconds(t,e){return pad(t.getUTCMilliseconds(),e,3)}function formatUTCMonthNumber(t,e){return pad(t.getUTCMonth()+1,e,2)}function formatUTCMinutes(t,e){return pad(t.getUTCMinutes(),e,2)}function formatUTCSeconds(t,e){return pad(t.getUTCSeconds(),e,2)}function formatUTCWeekNumberSunday(t,e){return pad(r.utcSunday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCWeekdayNumber(t){return t.getUTCDay()}function formatUTCWeekNumberMonday(t,e){return pad(r.utcMonday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCYear(t,e){return pad(t.getUTCFullYear()%100,e,2)}function formatUTCFullYear(t,e){return pad(t.getUTCFullYear()%1e4,e,4)}function formatUTCZone(){return"+0000"}function formatLiteralPercent(){return"%"}e.a=formatLocale;var r=n(35),a={"-":"",_:" ",0:"0"},i=/^\s*\d+/,o=/^%/,u=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g},function(t,e,n){"use strict";function formatIsoNative(t){return t.toISOString()}n.d(e,"b",function(){return a});var r=n(37),a="%Y-%m-%dT%H:%M:%S.%LZ",i=Date.prototype.toISOString?formatIsoNative:Object(r.d)(a);e.a=i},function(t,e,n){"use strict";function ordinal(t){function scale(r){var a=r+"",u=e.get(a);if(!u){if(o!==i)return o;e.set(a,u=n.push(r))}return t[(u-1)%t.length]}var e=Object(r.map)(),n=[],o=i;return t=null==t?[]:a.b.call(t),scale.domain=function(t){if(!arguments.length)return n.slice();n=[],e=Object(r.map)();for(var a,i,o=-1,u=t.length;++o<u;)e.has(i=(a=t[o])+"")||e.set(i,n.push(a));return scale},scale.range=function(e){return arguments.length?(t=a.b.call(e),scale):t.slice()},scale.unknown=function(t){return arguments.length?(o=t,scale):o},scale.copy=function(){return ordinal().domain(n).range(t).unknown(o)},scale}n.d(e,"b",function(){return i}),e.a=ordinal;var r=n(114),a=n(9),i={name:"implicit"}},function(t,e,n){"use strict";e.a=function(t){return+t}},function(t,e,n){"use strict";e.a=function(t,e){t=t.slice();var n,r=0,a=t.length-1,i=t[r],o=t[a];return o<i&&(n=r,r=a,a=n,n=i,i=o,o=n),t[r]=e.floor(i),t[a]=e.ceil(o),t}},function(t,e,n){"use strict";function date(t){return new Date(t)}function number(t){return t instanceof Date?+t:+new Date(+t)}function calendar(t,e,n,i,o,m,y,g,_){function tickFormat(r){return(y(r)<r?M:m(r)<r?C:o(r)<r?j:i(r)<r?T:e(r)<r?n(r)<r?k:S:t(r)<r?N:A)(r)}function tickInterval(e,n,a,i){if(null==e&&(e=10),"number"==typeof e){var o=Math.abs(a-n)/e,u=Object(r.bisector)(function(t){return t[2]}).right(E,o);u===E.length?(i=Object(r.tickStep)(n/v,a/v,e),e=t):u?(u=E[o/E[u-1][2]<E[u][2]/o?u-1:u],i=u[1],e=u[0]):(i=Object(r.tickStep)(n,a,e),e=g)}return null==i?e:e.every(i)}var x=Object(c.b)(c.c,a.interpolateNumber),w=x.invert,O=x.domain,M=_(".%L"),C=_(":%S"),j=_("%I:%M"),T=_("%I %p"),k=_("%a %d"),S=_("%b %d"),N=_("%B"),A=_("%Y"),E=[[y,1,f],[y,5,5*f],[y,15,15*f],[y,30,30*f],[m,1,l],[m,5,5*l],[m,15,15*l],[m,30,30*l],[o,1,h],[o,3,3*h],[o,6,6*h],[o,12,12*h],[i,1,d],[i,2,2*d],[n,1,p],[e,1,b],[e,3,3*b],[t,1,v]];return x.invert=function(t){return new Date(w(t))},x.domain=function(t){return arguments.length?O(u.a.call(t,number)):O().map(date)},x.ticks=function(t,e){var n,r=O(),a=r[0],i=r[r.length-1],o=i<a;return o&&(n=a,a=i,i=n),n=tickInterval(t,a,i,e),n=n?n.range(a,i+1):[],o?n.reverse():n},x.tickFormat=function(t,e){return null==e?tickFormat:_(e)},x.nice=function(t,e){var n=O();return(t=tickInterval(t,n[0],n[n.length-1],e))?O(Object(s.a)(n,t)):x},x.copy=function(){return Object(c.a)(x,calendar(t,e,n,i,o,m,y,g,_))},x}e.a=calendar;var r=n(5),a=n(8),i=n(35),o=n(40),u=n(9),c=n(18),s=n(83),f=1e3,l=60*f,h=60*l,d=24*h,p=7*d,b=30*d,v=365*d;e.b=function(){return calendar(i.timeYear,i.timeMonth,i.timeWeek,i.timeDay,i.timeHour,i.timeMinute,i.timeSecond,i.timeMillisecond,o.timeFormat).domain([new Date(2e3,0,1),new Date(2e3,0,2)])}},function(t,e,n){"use strict";function Linear(t){this._context=t}Linear.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._point=0},lineEnd:function(){(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;default:this._context.lineTo(t,e)}}},e.a=function(t){return new Linear(t)}},function(t,e,n){"use strict";e.a=function(){}},function(t,e,n){"use strict";function point(t,e,n){t._context.bezierCurveTo((2*t._x0+t._x1)/3,(2*t._y0+t._y1)/3,(t._x0+2*t._x1)/3,(t._y0+2*t._y1)/3,(t._x0+4*t._x1+e)/6,(t._y0+4*t._y1+n)/6)}function Basis(t){this._context=t}e.c=point,e.a=Basis,Basis.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){switch(this._point){case 3:point(this,this._x1,this._y1);case 2:this._context.lineTo(this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;break;case 2:this._point=3,this._context.lineTo((5*this._x0+this._x1)/6,(5*this._y0+this._y1)/6);default:point(this,t,e)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e}},e.b=function(t){return new Basis(t)}},function(t,e,n){"use strict";function point(t,e,n){t._context.bezierCurveTo(t._x1+t._k*(t._x2-t._x0),t._y1+t._k*(t._y2-t._y0),t._x2+t._k*(t._x1-e),t._y2+t._k*(t._y1-n),t._x2,t._y2)}function Cardinal(t,e){this._context=t,this._k=(1-e)/6}e.c=point,e.a=Cardinal,Cardinal.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:point(this,this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2,this._x1=t,this._y1=e;break;case 2:this._point=3;default:point(this,t,e)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.b=function custom(t){function cardinal(e){return new Cardinal(e,t)}return cardinal.tension=function(t){return custom(+t)},cardinal}(0)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},singleColors:{aloeGreen:["#7bdcc0"]},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green To Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"}}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},emptyDonutData:[{quantity:1,percentage:100}],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId"}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=(n(158),n(7));n.d(e,"transition",function(){return r.b});var a=n(179);n.d(e,"active",function(){return a.a});var i=n(58);n.d(e,"interrupt",function(){return i.a})},function(t,e,n){"use strict";function linear(t){return+t}e.a=linear},function(t,e,n){"use strict";function quadIn(t){return t*t}function quadOut(t){return t*(2-t)}function quadInOut(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.a=quadIn,e.c=quadOut,e.b=quadInOut},function(t,e,n){"use strict";function cubicIn(t){return t*t*t}function cubicOut(t){return--t*t*t+1}function cubicInOut(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.a=cubicIn,e.c=cubicOut,e.b=cubicInOut},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function polyIn(e){return Math.pow(e,t)}return t=+t,polyIn.exponent=custom,polyIn}(3),a=function custom(t){function polyOut(e){return 1-Math.pow(1-e,t)}return t=+t,polyOut.exponent=custom,polyOut}(3),i=function custom(t){function polyInOut(e){return((e*=2)<=1?Math.pow(e,t):2-Math.pow(2-e,t))/2}return t=+t,polyInOut.exponent=custom,polyInOut}(3)},function(t,e,n){"use strict";function sinIn(t){return 1-Math.cos(t*a)}function sinOut(t){return Math.sin(t*a)}function sinInOut(t){return(1-Math.cos(r*t))/2}e.a=sinIn,e.c=sinOut,e.b=sinInOut;var r=Math.PI,a=r/2},function(t,e,n){"use strict";function expIn(t){return Math.pow(2,10*t-10)}function expOut(t){return 1-Math.pow(2,-10*t)}function expInOut(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}e.a=expIn,e.c=expOut,e.b=expInOut},function(t,e,n){"use strict";function circleIn(t){return 1-Math.sqrt(1-t*t)}function circleOut(t){return Math.sqrt(1- --t*t)}function circleInOut(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}e.a=circleIn,e.c=circleOut,e.b=circleInOut},function(t,e,n){"use strict";function bounceIn(t){return 1-bounceOut(1-t)}function bounceOut(t){return(t=+t)<r?h*t*t:t<i?h*(t-=a)*t+o:t<c?h*(t-=u)*t+s:h*(t-=f)*t+l}function bounceInOut(t){return((t*=2)<=1?1-bounceOut(1-t):bounceOut(t-1)+1)/2}e.a=bounceIn,e.c=bounceOut,e.b=bounceInOut;var r=4/11,a=6/11,i=8/11,o=.75,u=9/11,c=10/11,s=.9375,f=21/22,l=63/64,h=1/r/r},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function backIn(e){return e*e*((t+1)*e-t)}return t=+t,backIn.overshoot=custom,backIn}(1.70158),a=function custom(t){function backOut(e){return--e*e*((t+1)*e+t)+1}return t=+t,backOut.overshoot=custom,backOut}(1.70158),i=function custom(t){function backInOut(e){return((e*=2)<1?e*e*((t+1)*e-t):(e-=2)*e*((t+1)*e+t)+2)/2}return t=+t,backInOut.overshoot=custom,backInOut}(1.70158)},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"b",function(){return o});var r=2*Math.PI,a=function custom(t,e){function elasticIn(r){return t*Math.pow(2,10*--r)*Math.sin((n-r)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticIn.amplitude=function(t){return custom(t,e*r)},elasticIn.period=function(e){return custom(t,e)},elasticIn}(1,.3),i=function custom(t,e){function elasticOut(r){return 1-t*Math.pow(2,-10*(r=+r))*Math.sin((r+n)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticOut.amplitude=function(t){return custom(t,e*r)},elasticOut.period=function(e){return custom(t,e)},elasticOut}(1,.3),o=function custom(t,e){function elasticInOut(r){return((r=2*r-1)<0?t*Math.pow(2,10*r)*Math.sin((n-r)/e):2-t*Math.pow(2,-10*r)*Math.sin((n+r)/e))/2}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticInOut.amplitude=function(t){return custom(t,e*r)},elasticInOut.period=function(e){return custom(t,e)},elasticInOut}(1,.3)},function(t,e,n){"use strict";function labConvert(t){if(t instanceof Lab)return new Lab(t.l,t.a,t.b,t.opacity);if(t instanceof Hcl){var e=t.h*i.a;return new Lab(t.l,Math.cos(e)*t.c,Math.sin(e)*t.c,t.opacity)}t instanceof a.b||(t=Object(a.h)(t));var n=rgb2xyz(t.r),r=rgb2xyz(t.g),s=rgb2xyz(t.b),f=xyz2lab((.4124564*n+.3575761*r+.1804375*s)/o),l=xyz2lab((.2126729*n+.7151522*r+.072175*s)/u);return new Lab(116*l-16,500*(f-l),200*(l-xyz2lab((.0193339*n+.119192*r+.9503041*s)/c)),t.opacity)}function lab(t,e,n,r){return 1===arguments.length?labConvert(t):new Lab(t,e,n,null==r?1:r)}function Lab(t,e,n,r){this.l=+t,this.a=+e,this.b=+n,this.opacity=+r}function xyz2lab(t){return t>h?Math.pow(t,1/3):t/l+s}function lab2xyz(t){return t>f?t*t*t:l*(t-s)}function xyz2rgb(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function rgb2xyz(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function hclConvert(t){if(t instanceof Hcl)return new Hcl(t.h,t.c,t.l,t.opacity);t instanceof Lab||(t=labConvert(t));var e=Math.atan2(t.b,t.a)*i.b;return new Hcl(e<0?e+360:e,Math.sqrt(t.a*t.a+t.b*t.b),t.l,t.opacity)}function hcl(t,e,n,r){return 1===arguments.length?hclConvert(t):new Hcl(t,e,n,null==r?1:r)}function Hcl(t,e,n,r){this.h=+t,this.c=+e,this.l=+n,this.opacity=+r}e.a=lab,e.b=hcl;var r=n(20),a=n(19),i=n(41),o=.95047,u=1,c=1.08883,s=4/29,f=6/29,l=3*f*f,h=f*f*f;Object(r.a)(Lab,lab,Object(r.b)(a.a,{brighter:function(t){return new Lab(this.l+18*(null==t?1:t),this.a,this.b,this.opacity)},darker:function(t){return new Lab(this.l-18*(null==t?1:t),this.a,this.b,this.opacity)},rgb:function(){var t=(this.l+16)/116,e=isNaN(this.a)?t:t+this.a/500,n=isNaN(this.b)?t:t-this.b/200;return t=u*lab2xyz(t),e=o*lab2xyz(e),n=c*lab2xyz(n),new a.b(xyz2rgb(3.2404542*e-1.5371385*t-.4985314*n),xyz2rgb(-.969266*e+1.8760108*t+.041556*n),xyz2rgb(.0556434*e-.2040259*t+1.0572252*n),this.opacity)}})),Object(r.a)(Hcl,hcl,Object(r.b)(a.a,{brighter:function(t){return new Hcl(this.h,this.c,this.l+18*(null==t?1:t),this.opacity)},darker:function(t){return new Hcl(this.h,this.c,this.l-18*(null==t?1:t),this.opacity)},rgb:function(){return labConvert(this).rgb()}}))},function(t,e,n){"use strict";function cubehelixConvert(t){if(t instanceof Cubehelix)return new Cubehelix(t.h,t.s,t.l,t.opacity);t instanceof a.b||(t=Object(a.h)(t));var e=t.r/255,n=t.g/255,r=t.b/255,o=(d*r+l*e-h*n)/(d+l-h),u=r-o,p=(f*(n-o)-c*u)/s,b=Math.sqrt(p*p+u*u)/(f*o*(1-o)),v=b?Math.atan2(p,u)*i.b-120:NaN;return new Cubehelix(v<0?v+360:v,b,o,t.opacity)}function cubehelix(t,e,n,r){return 1===arguments.length?cubehelixConvert(t):new Cubehelix(t,e,n,null==r?1:r)}function Cubehelix(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}e.a=cubehelix;var r=n(20),a=n(19),i=n(41),o=-.14861,u=1.78277,c=-.29227,s=-.90649,f=1.97294,l=f*s,h=f*u,d=u*c-s*o;Object(r.a)(Cubehelix,cubehelix,Object(r.b)(a.a,{brighter:function(t){return t=null==t?a.c:Math.pow(a.c,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a.d:Math.pow(a.d,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=isNaN(this.h)?0:(this.h+120)*i.a,e=+this.l,n=isNaN(this.s)?0:this.s*e*(1-e),r=Math.cos(t),l=Math.sin(t);return new a.b(255*(e+n*(o*r+u*l)),255*(e+n*(c*r+s*l)),255*(e+n*(f*r)),this.opacity)}}))},function(t,e,n){"use strict";function dispatch(){for(var t,e=0,n=arguments.length,r={};e<n;++e){if(!(t=arguments[e]+"")||t in r)throw new Error("illegal type: "+t);r[t]=[]}return new Dispatch(r)}function Dispatch(t){this._=t}function parseTypenames(t,e){return t.trim().split(/^|\s+/).map(function(t){var n="",r=t.indexOf(".");if(r>=0&&(n=t.slice(r+1),t=t.slice(0,r)),t&&!e.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:n}})}function get(t,e){for(var n,r=0,a=t.length;r<a;++r)if((n=t[r]).name===e)return n.value}function set(t,e,n){for(var a=0,i=t.length;a<i;++a)if(t[a].name===e){t[a]=r,t=t.slice(0,a).concat(t.slice(a+1));break}return null!=n&&t.push({name:e,value:n}),t}var r={value:function(){}};Dispatch.prototype=dispatch.prototype={constructor:Dispatch,on:function(t,e){var n,r=this._,a=parseTypenames(t+"",r),i=-1,o=a.length;{if(!(arguments.length<2)){if(null!=e&&"function"!=typeof e)throw new Error("invalid callback: "+e);for(;++i<o;)if(n=(t=a[i]).type)r[n]=set(r[n],t.name,e);else if(null==e)for(n in r)r[n]=set(r[n],t.name,null);return this}for(;++i<o;)if((n=(t=a[i]).type)&&(n=get(r[n],t.name)))return n}},copy:function(){var t={},e=this._;for(var n in e)t[n]=e[n].slice();return new Dispatch(t)},call:function(t,e){if((n=arguments.length-2)>0)for(var n,r,a=new Array(n),i=0;i<n;++i)a[i]=arguments[i+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(r=this._[t],i=0,n=r.length;i<n;++i)r[i].value.apply(e,a)},apply:function(t,e,n){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],a=0,i=r.length;a<i;++a)r[a].value.apply(e,n)}},e.a=dispatch},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(o.a)(t),a=r.format,i=r.formatPrefix,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),e.a=defaultLocale;var r,a,i,o=n(42);defaultLocale({decimal:".",thousands:",",grouping:[3],currency:["$",""]})},function(t,e,n){"use strict";e.a=function(t,e){return function(n,r){for(var a=n.length,i=[],o=0,u=t[0],c=0;a>0&&u>0&&(c+u+1>r&&(u=Math.max(1,r-c)),i.push(n.substring(a-=u,a+u)),!((c+=u+1)>r));)u=t[o=(o+1)%t.length];return i.reverse().join(e)}}},function(t,e,n){"use strict";e.a=function(t){return function(e){return e.replace(/[0-9]/g,function(e){return t[+e]})}}},function(t,e,n){"use strict";e.a=function(t,e){t=t.toPrecision(e);t:for(var n,r=t.length,a=1,i=-1;a<r;++a)switch(t[a]){case".":i=n=a;break;case"0":0===i&&(i=a),n=a;break;case"e":break t;default:i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t,e){var n=Object(r.a)(t,e);if(!n)return t+"";var a=n[0],i=n[1];return i<0?"0."+new Array(-i).join("0")+a:a.length>i+1?a.slice(0,i+1)+"."+a.slice(i+1):a+new Array(i-a.length+2).join("0")}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(13);e.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3)))-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return t=Math.abs(t),e=Math.abs(e)-t,Math.max(0,Object(r.a)(e)-Object(r.a)(t))+1}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(217);n.d(e,"nest",function(){return r.a});var a=n(218);n.d(e,"set",function(){return a.a});var i=n(38);n.d(e,"map",function(){return i.a});var o=n(219);n.d(e,"keys",function(){return o.a});var u=n(220);n.d(e,"values",function(){return u.a});var c=n(221);n.d(e,"entries",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return Math.round(t+e*n)}}},function(t,e,n){"use strict";function interpolateTransform(t,e,n,a){function pop(t){return t.length?t.pop()+" ":""}function translate(t,a,i,o,u,c){if(t!==i||a!==o){var s=u.push("translate(",null,e,null,n);c.push({i:s-4,x:Object(r.a)(t,i)},{i:s-2,x:Object(r.a)(a,o)})}else(i||o)&&u.push("translate("+i+e+o+n)}function rotate(t,e,n,i){t!==e?(t-e>180?e+=360:e-t>180&&(t+=360),i.push({i:n.push(pop(n)+"rotate(",null,a)-2,x:Object(r.a)(t,e)})):e&&n.push(pop(n)+"rotate("+e+a)}function skewX(t,e,n,i){t!==e?i.push({i:n.push(pop(n)+"skewX(",null,a)-2,x:Object(r.a)(t,e)}):e&&n.push(pop(n)+"skewX("+e+a)}function scale(t,e,n,a,i,o){if(t!==n||e!==a){var u=i.push(pop(i)+"scale(",null,",",null,")");o.push({i:u-4,x:Object(r.a)(t,n)},{i:u-2,x:Object(r.a)(e,a)})}else 1===n&&1===a||i.push(pop(i)+"scale("+n+","+a+")")}return function(e,n){var r=[],a=[];return e=t(e),n=t(n),translate(e.translateX,e.translateY,n.translateX,n.translateY,r,a),rotate(e.rotate,n.rotate,r,a),skewX(e.skewX,n.skewX,r,a),scale(e.scaleX,e.scaleY,n.scaleX,n.scaleY,r,a),e=n=null,function(t){for(var e,n=-1,i=a.length;++n<i;)r[(e=a[n]).i]=e.x(t);return r.join("")}}}n.d(e,"a",function(){return i}),n.d(e,"b",function(){return o});var r=n(15),a=n(117),i=interpolateTransform(a.a,"px, ","px)","deg)"),o=interpolateTransform(a.b,", ",")",")")},function(t,e,n){"use strict";function parseCss(t){return"none"===t?u.b:(r||(r=document.createElement("DIV"),a=document.documentElement,i=document.defaultView),r.style.transform=t,t=i.getComputedStyle(a.appendChild(r),null).getPropertyValue("transform"),a.removeChild(r),t=t.slice(7,-1).split(","),Object(u.a)(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}function parseSvg(t){return null==t?u.b:(o||(o=document.createElementNS("http://www.w3.org/2000/svg","g")),o.setAttribute("transform",t),(t=o.transform.baseVal.consolidate())?(t=t.matrix,Object(u.a)(t.a,t.b,t.c,t.d,t.e,t.f)):u.b)}e.a=parseCss,e.b=parseSvg;var r,a,i,o,u=n(118)},function(t,e,n){"use strict";n.d(e,"b",function(){return a});var r=180/Math.PI,a={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};e.a=function(t,e,n,a,i,o){var u,c,s;return(u=Math.sqrt(t*t+e*e))&&(t/=u,e/=u),(s=t*n+e*a)&&(n-=t*s,a-=e*s),(c=Math.sqrt(n*n+a*a))&&(n/=c,a/=c,s/=c),t*a<e*n&&(t=-t,e=-e,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(e,t)*r,skewX:Math.atan(s)*r,scaleX:u,scaleY:c}}},function(t,e,n){"use strict";function cosh(t){return((t=Math.exp(t))+1/t)/2}function sinh(t){return((t=Math.exp(t))-1/t)/2}function tanh(t){return((t=Math.exp(2*t))-1)/(t+1)}var r=Math.SQRT2;e.a=function(t,e){var n,a,i=t[0],o=t[1],u=t[2],c=e[0],s=e[1],f=e[2],l=c-i,h=s-o,d=l*l+h*h;if(d<1e-12)a=Math.log(f/u)/r,n=function(t){return[i+t*l,o+t*h,u*Math.exp(r*t*a)]};else{var p=Math.sqrt(d),b=(f*f-u*u+4*d)/(2*u*2*p),v=(f*f-u*u-4*d)/(2*f*2*p),m=Math.log(Math.sqrt(b*b+1)-b),y=Math.log(Math.sqrt(v*v+1)-v);a=(y-m)/r,n=function(t){var e=t*a,n=cosh(m),c=u/(2*p)*(n*tanh(r*e+m)-sinh(m));return[i+c*l,o+c*h,u*n/cosh(r*e+m)]}}return n.duration=1e3*a,n}},function(t,e,n){"use strict";function hsl(t){return function(e,n){var i=t((e=Object(r.hsl)(e)).h,(n=Object(r.hsl)(n)).h),o=Object(a.a)(e.s,n.s),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.s=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hsl(a.c);var i=hsl(a.a)},function(t,e,n){"use strict";function lab(t,e){var n=Object(a.a)((t=Object(r.lab)(t)).l,(e=Object(r.lab)(e)).l),i=Object(a.a)(t.a,e.a),o=Object(a.a)(t.b,e.b),u=Object(a.a)(t.opacity,e.opacity);return function(e){return t.l=n(e),t.a=i(e),t.b=o(e),t.opacity=u(e),t+""}}e.a=lab;var r=n(4),a=n(11)},function(t,e,n){"use strict";function hcl(t){return function(e,n){var i=t((e=Object(r.hcl)(e)).h,(n=Object(r.hcl)(n)).h),o=Object(a.a)(e.c,n.c),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.c=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hcl(a.c);var i=hcl(a.a)},function(t,e,n){"use strict";function cubehelix(t){return function cubehelixGamma(e){function cubehelix(n,i){var o=t((n=Object(r.cubehelix)(n)).h,(i=Object(r.cubehelix)(i)).h),u=Object(a.a)(n.s,i.s),c=Object(a.a)(n.l,i.l),s=Object(a.a)(n.opacity,i.opacity);return function(t){return n.h=o(t),n.s=u(t),n.l=c(Math.pow(t,e)),n.opacity=s(t),n+""}}return e=+e,cubehelix.gamma=cubehelixGamma,cubehelix}(1)}n.d(e,"a",function(){return i});var r=n(4),a=n(11);e.b=cubehelix(a.c);var i=cubehelix(a.a)},function(t,e,n){"use strict";e.a=function(t,e){for(var n=new Array(e),r=0;r<e;++r)n[r]=t(r/(e-1));return n}},function(t,e,n){"use strict";function local(){return new Local}function Local(){this._="@"+(++r).toString(36)}e.a=local;var r=0;Local.prototype=local.prototype={constructor:Local,get:function(t){for(var e=this._;!(e in t);)if(!(t=t.parentNode))return;return t[e]},set:function(t,e){return t[this._]=e},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t){var e=Object(r.a)();return e.changedTouches&&(e=e.changedTouches[0]),Object(a.a)(t,e)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,e,n){"use strict";var r=n(1),a=n(31);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c,s=e[o],f=s.length,l=i[o]=new Array(f),h=0;h<f;++h)(u=s[h])&&(c=t.call(u,u.__data__,h,s))&&("__data__"in u&&(c.__data__=u.__data__),l[h]=c);return new r.a(i,this._parents)}},function(t,e,n){"use strict";var r=n(1),a=n(54);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=[],o=[],u=0;u<n;++u)for(var c,s=e[u],f=s.length,l=0;l<f;++l)(c=s[l])&&(i.push(t.call(c,c.__data__,l,s)),o.push(c));return new r.a(i,o)}},function(t,e,n){"use strict";var r=n(1),a=n(53);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new r.a(i,this._parents)}},function(t,e,n){"use strict";function bindIndex(t,e,n,r,i,o){for(var u,c=0,s=e.length,f=o.length;c<f;++c)(u=e[c])?(u.__data__=o[c],r[c]=u):n[c]=new a.a(t,o[c]);for(;c<s;++c)(u=e[c])&&(i[c]=u)}function bindKey(t,e,n,r,i,u,c){var s,f,l,h={},d=e.length,p=u.length,b=new Array(d);for(s=0;s<d;++s)(f=e[s])&&(b[s]=l=o+c.call(f,f.__data__,s,e),l in h?i[s]=f:h[l]=f);for(s=0;s<p;++s)l=o+c.call(t,u[s],s,u),(f=h[l])?(r[s]=f,f.__data__=u[s],h[l]=null):n[s]=new a.a(t,u[s]);for(s=0;s<d;++s)(f=e[s])&&h[b[s]]===f&&(i[s]=f)}var r=n(1),a=n(55),i=n(132),o="$";e.a=function(t,e){if(!t)return b=new Array(this.size()),l=-1,this.each(function(t){b[++l]=t}),b;var n=e?bindKey:bindIndex,a=this._parents,o=this._groups;"function"!=typeof t&&(t=Object(i.a)(t));for(var u=o.length,c=new Array(u),s=new Array(u),f=new Array(u),l=0;l<u;++l){var h=a[l],d=o[l],p=d.length,b=t.call(h,h&&h.__data__,l,a),v=b.length,m=s[l]=new Array(v),y=c[l]=new Array(v);n(h,d,m,y,f[l]=new Array(p),b,e);for(var g,_,x=0,w=0;x<v;++x)if(g=m[x]){for(x>=w&&(w=x+1);!(_=y[w])&&++w<v;);g._next=_||null}}return c=new r.a(c,a),c._enter=s,c._exit=f,c}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(56),a=n(1);e.a=function(){return new a.a(this._exit||this._groups.map(r.a),this._parents)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents)}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=-1,n=t.length;++e<n;)for(var r,a=t[e],i=a.length-1,o=a[i];--i>=0;)(r=a[i])&&(o&&o!==r.nextSibling&&o.parentNode.insertBefore(r,o),o=r);return this}},function(t,e,n){"use strict";function ascending(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}var r=n(1);e.a=function(t){function compareNode(e,n){return e&&n?t(e.__data__,n.__data__):!e-!n}t||(t=ascending);for(var e=this._groups,n=e.length,a=new Array(n),i=0;i<n;++i){for(var o,u=e[i],c=u.length,s=a[i]=new Array(c),f=0;f<c;++f)(o=u[f])&&(s[f]=o);s.sort(compareNode)}return new r.a(a,this._parents).order()}},function(t,e,n){"use strict";e.a=function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}},function(t,e,n){"use strict";e.a=function(){var t=new Array(this.size()),e=-1;return this.each(function(){t[++e]=this}),t}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=0,n=t.length;e<n;++e)for(var r=t[e],a=0,i=r.length;a<i;++a){var o=r[a];if(o)return o}return null}},function(t,e,n){"use strict";e.a=function(){var t=0;return this.each(function(){++t}),t}},function(t,e,n){"use strict";e.a=function(){return!this.node()}},function(t,e,n){"use strict";e.a=function(t){for(var e=this._groups,n=0,r=e.length;n<r;++n)for(var a,i=e[n],o=0,u=i.length;o<u;++o)(a=i[o])&&t.call(a,a.__data__,o,i);return this}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e){return function(){this.setAttribute(t,e)}}function attrConstantNS(t,e){return function(){this.setAttributeNS(t.space,t.local,e)}}function attrFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttribute(t):this.setAttribute(t,n)}}function attrFunctionNS(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,n)}}var r=n(26);e.a=function(t,e){var n=Object(r.a)(t);if(arguments.length<2){var a=this.node();return n.local?a.getAttributeNS(n.space,n.local):a.getAttribute(n)}return this.each((null==e?n.local?attrRemoveNS:attrRemove:"function"==typeof e?n.local?attrFunctionNS:attrFunction:n.local?attrConstantNS:attrConstant)(n,e))}},function(t,e,n){"use strict";function propertyRemove(t){return function(){delete this[t]}}function propertyConstant(t,e){return function(){this[t]=e}}function propertyFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?delete this[t]:this[t]=n}}e.a=function(t,e){return arguments.length>1?this.each((null==e?propertyRemove:"function"==typeof e?propertyFunction:propertyConstant)(t,e)):this.node()[t]}},function(t,e,n){"use strict";function classArray(t){return t.trim().split(/^|\s+/)}function classList(t){return t.classList||new ClassList(t)}function ClassList(t){this._node=t,this._names=classArray(t.getAttribute("class")||"")}function classedAdd(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.add(e[r])}function classedRemove(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.remove(e[r])}function classedTrue(t){return function(){classedAdd(this,t)}}function classedFalse(t){return function(){classedRemove(this,t)}}function classedFunction(t,e){return function(){(e.apply(this,arguments)?classedAdd:classedRemove)(this,t)}}ClassList.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var e=this._names.indexOf(t);e>=0&&(this._names.splice(e,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}},e.a=function(t,e){var n=classArray(t+"");if(arguments.length<2){for(var r=classList(this.node()),a=-1,i=n.length;++a<i;)if(!r.contains(n[a]))return!1;return!0}return this.each(("function"==typeof e?classedFunction:e?classedTrue:classedFalse)(n,e))}},function(t,e,n){"use strict";function textRemove(){this.textContent=""}function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t.apply(this,arguments);this.textContent=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?textRemove:("function"==typeof t?textFunction:textConstant)(t)):this.node().textContent}},function(t,e,n){"use strict";function htmlRemove(){this.innerHTML=""}function htmlConstant(t){return function(){this.innerHTML=t}}function htmlFunction(t){return function(){var e=t.apply(this,arguments);this.innerHTML=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?htmlRemove:("function"==typeof t?htmlFunction:htmlConstant)(t)):this.node().innerHTML}},function(t,e,n){"use strict";function raise(){this.nextSibling&&this.parentNode.appendChild(this)}e.a=function(){return this.each(raise)}},function(t,e,n){"use strict";function lower(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}e.a=function(){return this.each(lower)}},function(t,e,n){"use strict";var r=n(25);e.a=function(t){var e="function"==typeof t?t:Object(r.a)(t);return this.select(function(){return this.appendChild(e.apply(this,arguments))})}},function(t,e,n){"use strict";function constantNull(){return null}var r=n(25),a=n(31);e.a=function(t,e){var n="function"==typeof t?t:Object(r.a)(t),i=null==e?constantNull:"function"==typeof e?e:Object(a.a)(e);return this.select(function(){return this.insertBefore(n.apply(this,arguments),i.apply(this,arguments)||null)})}},function(t,e,n){"use strict";function remove(){var t=this.parentNode;t&&t.removeChild(this)}e.a=function(){return this.each(remove)}},function(t,e,n){"use strict";e.a=function(t){return arguments.length?this.property("__data__",t):this.node().__data__}},function(t,e,n){"use strict";function dispatchEvent(t,e,n){var a=Object(r.a)(t),i=a.CustomEvent;"function"==typeof i?i=new i(e,n):(i=a.document.createEvent("Event"),n?(i.initEvent(e,n.bubbles,n.cancelable),i.detail=n.detail):i.initEvent(e,!1,!1)),t.dispatchEvent(i)}function dispatchConstant(t,e){return function(){return dispatchEvent(this,t,e)}}function dispatchFunction(t,e){return function(){return dispatchEvent(this,t,e.apply(this,arguments))}}var r=n(32);e.a=function(t,e){return this.each(("function"==typeof e?dispatchFunction:dispatchConstant)(t,e))}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([document.querySelectorAll(t)],[document.documentElement]):new r.a([null==t?[]:t],r.c)}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e,n){arguments.length<3&&(n=e,e=Object(r.a)().changedTouches);for(var i,o=0,u=e?e.length:0;o<u;++o)if((i=e[o]).identifier===n)return Object(a.a)(t,i);return null}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e){null==e&&(e=Object(r.a)().touches);for(var n=0,i=e?e.length:0,o=new Array(i);n<i;++n)o[n]=Object(a.a)(t,e[n]);return o}},function(t,e,n){"use strict";var r=n(3),a=n(159),i=n(162);r.selection.prototype.interrupt=a.a,r.selection.prototype.transition=i.a},function(t,e,n){"use strict";var r=n(58);e.a=function(t){return this.each(function(){Object(r.a)(this,t)})}},function(t,e,n){"use strict";var r=n(33);e.a=function(t,e,n){var a=new r.a;return e=null==e?0:+e,a.restart(function(n){a.stop(),t(n+e)},e,n),a}},function(t,e,n){"use strict";n(33)},function(t,e,n){"use strict";function inherit(t,e){for(var n;!(n=t.__transition)||!(n=n[e]);)if(!(t=t.parentNode))return u.time=Object(o.a)(),u;return n}var r=n(7),a=n(2),i=n(65),o=n(59),u={time:null,delay:0,duration:250,ease:i.easeCubicInOut};e.a=function(t){var e,n;t instanceof r.a?(e=t._id,t=t._name):(e=Object(r.c)(),(n=u).time=Object(o.a)(),t=null==t?null:t+"");for(var i=this._groups,c=i.length,s=0;s<c;++s)for(var f,l=i[s],h=l.length,d=0;d<h;++d)(f=l[d])&&Object(a.e)(f,t,e,d,l,n||inherit(f,e));return new r.a(i,this._parents,t,e)}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e,n){var r,a;return function(){var i=this.getAttribute(t);return i===n?null:i===r?a:a=e(r=i,n)}}function attrConstantNS(t,e,n){var r,a;return function(){var i=this.getAttributeNS(t.space,t.local);return i===n?null:i===r?a:a=e(r=i,n)}}function attrFunction(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttribute(t):(o=this.getAttribute(t),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}function attrFunctionNS(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttributeNS(t.space,t.local):(o=this.getAttributeNS(t.space,t.local),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e){var n=Object(a.namespace)(t),u="transform"===n?r.interpolateTransformSvg:o.a;return this.attrTween(t,"function"==typeof e?(n.local?attrFunctionNS:attrFunction)(n,u,Object(i.b)(this,"attr."+t,e)):null==e?(n.local?attrRemoveNS:attrRemove)(n):(n.local?attrConstantNS:attrConstant)(n,u,e+""))}},function(t,e,n){"use strict";function attrTweenNS(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttributeNS(t.space,t.local,r(e))}}return tween._value=e,tween}function attrTween(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttribute(t,r(e))}}return tween._value=e,tween}var r=n(3);e.a=function(t,e){var n="attr."+t;if(arguments.length<2)return(n=this.tween(n))&&n._value;if(null==e)return this.tween(n,null);if("function"!=typeof e)throw new Error;var a=Object(r.namespace)(t);return this.tween(n,(a.local?attrTweenNS:attrTween)(a,e))}},function(t,e,n){"use strict";function delayFunction(t,e){return function(){Object(r.g)(this,t).delay=+e.apply(this,arguments)}}function delayConstant(t,e){return e=+e,function(){Object(r.g)(this,t).delay=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?delayFunction:delayConstant)(e,t)):Object(r.f)(this.node(),e).delay}},function(t,e,n){"use strict";function durationFunction(t,e){return function(){Object(r.h)(this,t).duration=+e.apply(this,arguments)}}function durationConstant(t,e){return e=+e,function(){Object(r.h)(this,t).duration=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?durationFunction:durationConstant)(e,t)):Object(r.f)(this.node(),e).duration}},function(t,e,n){"use strict";function easeConstant(t,e){if("function"!=typeof e)throw new Error;return function(){Object(r.h)(this,t).ease=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(easeConstant(e,t)):Object(r.f)(this.node(),e).ease}},function(t,e,n){"use strict";var r=n(3),a=n(7);e.a=function(t){"function"!=typeof t&&(t=Object(r.matcher)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new a.a(i,this._parents,this._name,this._id)}},function(t,e,n){"use strict";var r=n(7);e.a=function(t){if(t._id!==this._id)throw new Error;for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents,this._name,this._id)}},function(t,e,n){"use strict";function start(t){return(t+"").trim().split(/^|\s+/).every(function(t){var e=t.indexOf(".");return e>=0&&(t=t.slice(0,e)),!t||"start"===t})}function onFunction(t,e,n){var a,i,o=start(e)?r.g:r.h;return function(){var r=o(this,t),u=r.on;u!==a&&(i=(a=u).copy()).on(e,n),r.on=i}}var r=n(2);e.a=function(t,e){var n=this._id;return arguments.length<2?Object(r.f)(this.node(),n).on.on(t):this.each(onFunction(n,t,e))}},function(t,e,n){"use strict";function removeFunction(t){return function(){var e=this.parentNode;for(var n in this.__transition)if(+n!==t)return;e&&e.removeChild(this)}}e.a=function(){return this.on("end.remove",removeFunction(this._id))}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selector)(t));for(var o=this._groups,u=o.length,c=new Array(u),s=0;s<u;++s)for(var f,l,h=o[s],d=h.length,p=c[s]=new Array(d),b=0;b<d;++b)(f=h[b])&&(l=t.call(f,f.__data__,b,h))&&("__data__"in f&&(l.__data__=f.__data__),p[b]=l,Object(i.e)(p[b],e,n,b,p,Object(i.f)(f,n)));return new a.a(c,this._parents,e,n)}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selectorAll)(t));for(var o=this._groups,u=o.length,c=[],s=[],f=0;f<u;++f)for(var l,h=o[f],d=h.length,p=0;p<d;++p)if(l=h[p]){for(var b,v=t.call(l,l.__data__,p,h),m=Object(i.f)(l,n),y=0,g=v.length;y<g;++y)(b=v[y])&&Object(i.e)(b,e,n,y,v,m);c.push(v),s.push(l)}return new a.a(c,s,e,n)}},function(t,e,n){"use strict";var r=n(3),a=r.selection.prototype.constructor;e.a=function(){return new a(this._groups,this._parents)}},function(t,e,n){"use strict";function styleRemove(t,e){var n,r,i;return function(){var o=Object(a.style)(this,t),u=(this.style.removeProperty(t),Object(a.style)(this,t));return o===u?null:o===n&&u===r?i:i=e(n=o,r=u)}}function styleRemoveEnd(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){var r,i;return function(){var o=Object(a.style)(this,t);return o===n?null:o===r?i:i=e(r=o,n)}}function styleFunction(t,e,n){var r,i,o;return function(){var u=Object(a.style)(this,t),c=n(this);return null==c&&(this.style.removeProperty(t),c=Object(a.style)(this,t)),u===c?null:u===r&&c===i?o:o=e(r=u,i=c)}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e,n){var a="transform"==(t+="")?r.interpolateTransformCss:o.a;return null==e?this.styleTween(t,styleRemove(t,a)).on("end.style."+t,styleRemoveEnd(t)):this.styleTween(t,"function"==typeof e?styleFunction(t,a,Object(i.b)(this,"style."+t,e)):styleConstant(t,a,e+""),n)}},function(t,e,n){"use strict";function styleTween(t,e,n){function tween(){var r=this,a=e.apply(r,arguments);return a&&function(e){r.style.setProperty(t,a(e),n)}}return tween._value=e,tween}e.a=function(t,e,n){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==e)return this.tween(r,null);if("function"!=typeof e)throw new Error;return this.tween(r,styleTween(t,e,null==n?"":n))}},function(t,e,n){"use strict";function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t(this);this.textContent=null==e?"":e}}var r=n(17);e.a=function(t){return this.tween("text","function"==typeof t?textFunction(Object(r.b)(this,"text",t)):textConstant(null==t?"":t+""))}},function(t,e,n){"use strict";var r=n(7),a=n(2);e.a=function(){for(var t=this._name,e=this._id,n=Object(r.c)(),i=this._groups,o=i.length,u=0;u<o;++u)for(var c,s=i[u],f=s.length,l=0;l<f;++l)if(c=s[l]){var h=Object(a.f)(c,e);Object(a.e)(c,t,n,l,s,{time:h.time+h.delay+h.duration,delay:0,duration:h.duration,ease:h.ease})}return new r.a(i,this._parents,t,n)}},function(t,e,n){"use strict";var r=n(7),a=n(2),i=[null];e.a=function(t,e){var n,o,u=t.__transition;if(u){e=null==e?null:e+"";for(o in u)if((n=u[o]).state>a.c&&n.name===e)return new r.a([[t]],i,e,+o)}return null}},function(t,e,n){"use strict";var r=n(61),a=n(34),i=n(85),o=n(181);e.a=function(){function line(a){var i,o,f,l=a.length,h=!1;for(null==u&&(s=c(f=Object(r.a)())),i=0;i<=l;++i)!(i<l&&n(o=a[i],i,a))===h&&((h=!h)?s.lineStart():s.lineEnd()),h&&s.point(+t(o,i,a),+e(o,i,a));if(f)return s=null,f+""||null}var t=o.a,e=o.b,n=Object(a.a)(!0),u=null,c=i.a,s=null;return line.x=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(+e),line):t},line.y=function(t){return arguments.length?(e="function"==typeof t?t:Object(a.a)(+t),line):e},line.defined=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(!!t),line):n},line.curve=function(t){return arguments.length?(c=t,null!=u&&(s=c(u)),line):c},line.context=function(t){return arguments.length?(null==t?u=s=null:s=c(u=t),line):u},line}},function(t,e,n){"use strict";function x(t){return t[0]}function y(t){return t[1]}e.a=x,e.b=y},function(t,e,n){"use strict";function point(t,e,n){var a=t._x1,i=t._y1,o=t._x2,u=t._y2;if(t._l01_a>r.f){var c=2*t._l01_2a+3*t._l01_a*t._l12_a+t._l12_2a,s=3*t._l01_a*(t._l01_a+t._l12_a);a=(a*c-t._x0*t._l12_2a+t._x2*t._l01_2a)/s,i=(i*c-t._y0*t._l12_2a+t._y2*t._l01_2a)/s}if(t._l23_a>r.f){var f=2*t._l23_2a+3*t._l23_a*t._l12_a+t._l12_2a,l=3*t._l23_a*(t._l23_a+t._l12_a);o=(o*f+t._x1*t._l23_2a-e*t._l12_2a)/l,u=(u*f+t._y1*t._l23_2a-n*t._l12_2a)/l}t._context.bezierCurveTo(a,i,o,u,t._x2,t._y2)}function CatmullRom(t,e){this._context=t,this._alpha=e}e.b=point;var r=n(62),a=n(88);CatmullRom.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:this.point(this._x2,this._y2)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){if(t=+t,e=+e,this._point){var n=this._x2-t,r=this._y2-e;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(n*n+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;break;case 2:this._point=3;default:point(this,t,e)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.a=function custom(t){function catmullRom(e){return t?new CatmullRom(e,t):new a.a(e,0)}return catmullRom.alpha=function(t){return custom(+t)},catmullRom}(.5)},function(t,e,n){"use strict";function sum(t){for(var e,n=0,r=-1,a=t.length;++r<a;)(e=+t[r][1])&&(n+=e);return n}e.b=sum;var r=n(64);e.a=function(t){var e=t.map(sum);return Object(r.a)(t).sort(function(t,n){return e[t]-e[n]})}},function(t,e,n){"use strict";var r=n(69);e.a=function(t,e,n){var a,i,o,u,c=t.length,s=e.length,f=new Array(c*s);for(null==n&&(n=r.b),a=o=0;a<c;++a)for(u=t[a],i=0;i<s;++i,++o)f[o]=n(u,e[i]);return f}},function(t,e,n){"use strict";e.a=function(t,e){return e<t?-1:e>t?1:e>=t?0:NaN}},function(t,e,n){"use strict";var r=n(73),a=n(67),i=n(187),o=n(72),u=n(188),c=n(74),s=n(75),f=n(76);e.a=function(){function histogram(r){var i,o,u=r.length,f=new Array(u);for(i=0;i<u;++i)f[i]=t(r[i],i,r);var l=e(f),h=l[0],d=l[1],p=n(f,h,d);Array.isArray(p)||(p=Object(s.c)(h,d,p),p=Object(c.a)(Math.ceil(h/p)*p,Math.floor(d/p)*p,p));for(var b=p.length;p[0]<=h;)p.shift(),--b;for(;p[b-1]>d;)p.pop(),--b;var v,m=new Array(b+1);for(i=0;i<=b;++i)v=m[i]=[],v.x0=i>0?p[i-1]:h,v.x1=i<b?p[i]:d;for(i=0;i<u;++i)o=f[i],h<=o&&o<=d&&m[Object(a.c)(p,o,0,b)].push(r[i]);return m}var t=u.a,e=o.a,n=f.a;return histogram.value=function(e){return arguments.length?(t="function"==typeof e?e:Object(i.a)(e),histogram):t},histogram.domain=function(t){return arguments.length?(e="function"==typeof t?t:Object(i.a)([t[0],t[1]]),histogram):e},histogram.thresholds=function(t){return arguments.length?(n="function"==typeof t?t:Array.isArray(t)?Object(i.a)(r.b.call(t)):Object(i.a)(t),histogram):n},histogram}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(73),a=n(10),i=n(12),o=n(36);e.a=function(t,e,n){return t=r.a.call(t,i.a).sort(a.a),Math.ceil((n-e)/(2*(Object(o.a)(t,.75)-Object(o.a)(t,.25))*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";var r=n(70);e.a=function(t,e,n){return Math.ceil((n-e)/(3.5*Object(r.a)(t)*Math.pow(t.length,-1/3)))}},function(t,e,n){"use strict";e.a=function(t,e){var n,r,a=t.length,i=-1;if(null==e){for(;++i<a;)if(null!=(n=t[i])&&n>=n)for(r=n;++i<a;)null!=(n=t[i])&&n>r&&(r=n)}else for(;++i<a;)if(null!=(n=e(t[i],i,t))&&n>=n)for(r=n;++i<a;)null!=(n=e(t[i],i,t))&&n>r&&(r=n);return r}},function(t,e,n){"use strict";var r=n(12);e.a=function(t,e){var n,a=t.length,i=a,o=-1,u=0;if(null==e)for(;++o<a;)isNaN(n=Object(r.a)(t[o]))?--i:u+=n;else for(;++o<a;)isNaN(n=Object(r.a)(e(t[o],o,t)))?--i:u+=n;if(i)return u/i}},function(t,e,n){"use strict";var r=n(10),a=n(12),i=n(36);e.a=function(t,e){var n,o=t.length,u=-1,c=[];if(null==e)for(;++u<o;)isNaN(n=Object(a.a)(t[u]))||c.push(n);else for(;++u<o;)isNaN(n=Object(a.a)(e(t[u],u,t)))||c.push(n);return Object(i.a)(c.sort(r.a),.5)}},function(t,e,n){"use strict";e.a=function(t){for(var e,n,r,a=t.length,i=-1,o=0;++i<a;)o+=t[i].length;for(n=new Array(o);--a>=0;)for(r=t[a],e=r.length;--e>=0;)n[--o]=r[e];return n}},function(t,e,n){"use strict";e.a=function(t,e){for(var n=e.length,r=new Array(n);n--;)r[n]=t[e[n]];return r}},function(t,e,n){"use strict";var r=n(10);e.a=function(t,e){if(n=t.length){var n,a,i=0,o=0,u=t[o];for(null==e&&(e=r.a);++i<n;)(e(a=t[i],u)<0||0!==e(u,u))&&(u=a,o=i);return 0===e(u,u)?o:void 0}}},function(t,e,n){"use strict";e.a=function(t,e,n){for(var r,a,i=(null==n?t.length:n)-(e=null==e?0:+e);i;)a=Math.random()*i--|0,r=t[i+e],t[i+e]=t[a+e],t[a+e]=r;return t}},function(t,e,n){"use strict";e.a=function(t,e){var n,r=t.length,a=-1,i=0;if(null==e)for(;++a<r;)(n=+t[a])&&(i+=n);else for(;++a<r;)(n=+e(t[a],a,t))&&(i+=n);return i}},function(t,e,n){"use strict";var r=n(78);e.a=function(){return Object(r.a)(arguments)}},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(){},function(t,e){t.setTime(+t+e)},function(t,e){return e-t});a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)(function(e){e.setTime(Math.floor(e/t)*t)},function(e,n){e.setTime(+e+n*t)},function(e,n){return(n-e)/t}):a:null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.d)*a.d)},function(t,e){t.setTime(+t+e*a.d)},function(t,e){return(e-t)/a.d},function(t){return t.getUTCSeconds()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.c)*a.c)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){var e=t.getTimezoneOffset()*a.c%a.b;e<0&&(e+=a.b),t.setTime(Math.floor((+t-e)/a.b)*a.b+e)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"a",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.a},function(t){return t.getDate()-1});e.b=i;var o=i.range},function(t,e,n){"use strict";function weekday(t){return Object(r.a)(function(e){e.setDate(e.getDate()-(e.getDay()+7-t)%7),e.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+7*e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=weekday(0),o=weekday(1),u=weekday(2),c=weekday(3),s=weekday(4),f=weekday(5),l=weekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setDate(1),t.setHours(0,0,0,0)},function(t,e){t.setMonth(t.getMonth()+e)},function(t,e){return e.getMonth()-t.getMonth()+12*(e.getFullYear()-t.getFullYear())},function(t){return t.getMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setMonth(0,1),t.setHours(0,0,0,0)},function(t,e){t.setFullYear(t.getFullYear()+e)},function(t,e){return e.getFullYear()-t.getFullYear()},function(t){return t.getFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setFullYear(Math.floor(e.getFullYear()/t)*t),e.setMonth(0,1),e.setHours(0,0,0,0)},function(e,n){e.setFullYear(e.getFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCSeconds(0,0)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getUTCMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCMinutes(0,0,0)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getUTCHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+e)},function(t,e){return(e-t)/a.a},function(t){return t.getUTCDate()-1});e.a=i;var o=i.range},function(t,e,n){"use strict";function utcWeekday(t){return Object(r.a)(function(e){e.setUTCDate(e.getUTCDate()-(e.getUTCDay()+7-t)%7),e.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+7*e)},function(t,e){return(e-t)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=utcWeekday(0),o=utcWeekday(1),u=utcWeekday(2),c=utcWeekday(3),s=utcWeekday(4),f=utcWeekday(5),l=utcWeekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCMonth(t.getUTCMonth()+e)},function(t,e){return e.getUTCMonth()-t.getUTCMonth()+12*(e.getUTCFullYear()-t.getUTCFullYear())},function(t){return t.getUTCMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCFullYear(t.getUTCFullYear()+e)},function(t,e){return e.getUTCFullYear()-t.getUTCFullYear()},function(t){return t.getUTCFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setUTCFullYear(Math.floor(e.getUTCFullYear()/t)*t),e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0)},function(e,n){e.setUTCFullYear(e.getUTCFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";function parseIsoNative(t){var e=new Date(t);return isNaN(e)?null:e}var r=n(80),a=n(37),i=+new Date("2000-01-01T00:00:00.000Z")?parseIsoNative:Object(a.e)(r.b);e.a=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(216);n.d(e,"scaleBand",function(){return r.a}),n.d(e,"scalePoint",function(){return r.b});var a=n(222);n.d(e,"scaleIdentity",function(){return a.a});var i=n(14);n.d(e,"scaleLinear",function(){return i.a});var o=n(224);n.d(e,"scaleLog",function(){return o.a});var u=n(81);n.d(e,"scaleOrdinal",function(){return u.a}),n.d(e,"scaleImplicit",function(){return u.b});var c=n(225);n.d(e,"scalePow",function(){return c.a}),n.d(e,"scaleSqrt",function(){return c.b});var s=n(226);n.d(e,"scaleQuantile",function(){return s.a});var f=n(227);n.d(e,"scaleQuantize",function(){return f.a});var l=n(228);n.d(e,"scaleThreshold",function(){return l.a});var h=n(84);n.d(e,"scaleTime",function(){return h.b});var d=n(229);n.d(e,"scaleUtc",function(){return d.a});var p=n(230);n.d(e,"schemeCategory10",function(){return p.a});var b=n(231);n.d(e,"schemeCategory20b",function(){return b.a});var v=n(232);n.d(e,"schemeCategory20c",function(){return v.a});var m=n(233);n.d(e,"schemeCategory20",function(){return m.a});var y=n(234);n.d(e,"interpolateCubehelixDefault",function(){return y.a});var g=n(235);n.d(e,"interpolateRainbow",function(){return g.b}),n.d(e,"interpolateWarm",function(){return g.c}),n.d(e,"interpolateCool",function(){return g.a});var _=n(236);n.d(e,"interpolateViridis",function(){return _.a}),n.d(e,"interpolateMagma",function(){return _.c}),n.d(e,"interpolateInferno",function(){return _.b}),n.d(e,"interpolatePlasma",function(){return _.d});var x=n(237);n.d(e,"scaleSequential",function(){return x.a})},function(t,e,n){"use strict";function band(){function rescale(){var n=i().length,a=u[1]<u[0],h=u[a-0],d=u[1-a];t=(d-h)/Math.max(1,n-s+2*f),c&&(t=Math.floor(t)),h+=(d-h-t*(n-s))*l,e=t*(1-s),c&&(h=Math.round(h),e=Math.round(e));var p=Object(r.range)(n).map(function(e){return h+t*e});return o(a?p.reverse():p)}var t,e,n=Object(a.a)().unknown(void 0),i=n.domain,o=n.range,u=[0,1],c=!1,s=0,f=0,l=.5;return delete n.unknown,n.domain=function(t){return arguments.length?(i(t),rescale()):i()},n.range=function(t){return arguments.length?(u=[+t[0],+t[1]],rescale()):u.slice()},n.rangeRound=function(t){return u=[+t[0],+t[1]],c=!0,rescale()},n.bandwidth=function(){return e},n.step=function(){return t},n.round=function(t){return arguments.length?(c=!!t,rescale()):c},n.padding=function(t){return arguments.length?(s=f=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingInner=function(t){return arguments.length?(s=Math.max(0,Math.min(1,t)),rescale()):s},n.paddingOuter=function(t){return arguments.length?(f=Math.max(0,Math.min(1,t)),rescale()):f},n.align=function(t){return arguments.length?(l=Math.max(0,Math.min(1,t)),rescale()):l},n.copy=function(){return band().domain(i()).range(u).round(c).paddingInner(s).paddingOuter(f).align(l)},rescale()}function pointish(t){var e=t.copy;return t.padding=t.paddingOuter,delete t.paddingInner,delete t.paddingOuter,t.copy=function(){return pointish(e())},t}function point(){return pointish(band().paddingInner(1))}e.a=band,e.b=point;var r=n(5),a=n(81)},function(t,e,n){"use strict";function createObject(){return{}}function setObject(t,e,n){t[e]=n}function createMap(){return Object(r.a)()}function setMap(t,e,n){t.set(e,n)}var r=n(38);e.a=function(){function apply(n,i,o,u){if(i>=a.length)return null!=t&&n.sort(t),null!=e?e(n):n;for(var c,s,f,l=-1,h=n.length,d=a[i++],p=Object(r.a)(),b=o();++l<h;)(f=p.get(c=d(s=n[l])+""))?f.push(s):p.set(c,[s]);return p.each(function(t,e){u(b,e,apply(t,i,o,u))}),b}function entries(t,n){if(++n>a.length)return t;var r,o=i[n-1];return null!=e&&n>=a.length?r=t.entries():(r=[],t.each(function(t,e){r.push({key:e,values:entries(t,n)})})),null!=o?r.sort(function(t,e){return o(t.key,e.key)}):r}var t,e,n,a=[],i=[];return n={object:function(t){return apply(t,0,createObject,setObject)},map:function(t){return apply(t,0,createMap,setMap)},entries:function(t){return entries(apply(t,0,createMap,setMap),0)},key:function(t){return a.push(t),n},sortKeys:function(t){return i[a.length-1]=t,n},sortValues:function(e){return t=e,n},rollup:function(t){return e=t,n}}}},function(t,e,n){"use strict";function Set(){}function set(t,e){var n=new Set;if(t instanceof Set)t.each(function(t){n.add(t)});else if(t){var r=-1,a=t.length;if(null==e)for(;++r<a;)n.add(t[r]);else for(;++r<a;)n.add(e(t[r],r,t))}return n}var r=n(38),a=r.a.prototype;Set.prototype=set.prototype={constructor:Set,has:a.has,add:function(t){return t+="",this[r.b+t]=t,this},remove:a.remove,clear:a.clear,values:a.keys,size:a.size,empty:a.empty,each:a.each},e.a=set},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(n);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push(t[n]);return e}},function(t,e,n){"use strict";e.a=function(t){var e=[];for(var n in t)e.push({key:n,value:t[n]});return e}},function(t,e,n){"use strict";function identity(){function scale(t){return+t}var t=[0,1];return scale.invert=scale,scale.domain=scale.range=function(e){return arguments.length?(t=r.a.call(e,i.a),scale):t.slice()},scale.copy=function(){return identity().domain(t)},Object(a.b)(scale)}e.a=identity;var r=n(9),a=n(14),i=n(82)},function(t,e,n){"use strict";var r=n(5),a=n(21);e.a=function(t,e,n){var i,o=t[0],u=t[t.length-1],c=Object(r.tickStep)(o,u,null==e?10:e);switch(n=Object(a.formatSpecifier)(null==n?",f":n),n.type){case"s":var s=Math.max(Math.abs(o),Math.abs(u));return null!=n.precision||isNaN(i=Object(a.precisionPrefix)(c,s))||(n.precision=i),Object(a.formatPrefix)(n,s);case"":case"e":case"g":case"p":case"r":null!=n.precision||isNaN(i=Object(a.precisionRound)(c,Math.max(Math.abs(o),Math.abs(u))))||(n.precision=i-("e"===n.type));break;case"f":case"%":null!=n.precision||isNaN(i=Object(a.precisionFixed)(c))||(n.precision=i-2*("%"===n.type))}return Object(a.format)(n)}},function(t,e,n){"use strict";function deinterpolate(t,e){return(e=Math.log(e/t))?function(n){return Math.log(n/t)/e}:Object(i.a)(e)}function reinterpolate(t,e){return t<0?function(n){return-Math.pow(-e,n)*Math.pow(-t,1-n)}:function(n){return Math.pow(e,n)*Math.pow(t,1-n)}}function pow10(t){return isFinite(t)?+("1e"+t):t<0?0:t}function powp(t){return 10===t?pow10:t===Math.E?Math.exp:function(e){return Math.pow(t,e)}}function logp(t){return t===Math.E?Math.log:10===t&&Math.log10||2===t&&Math.log2||(t=Math.log(t),function(e){return Math.log(e)/t})}function reflect(t){return function(e){return-t(-e)}}function log(){function rescale(){return i=logp(n),c=powp(n),e()[0]<0&&(i=reflect(i),c=reflect(c)),t}var t=Object(u.b)(deinterpolate,reinterpolate).domain([1,10]),e=t.domain,n=10,i=logp(10),c=powp(10);return t.base=function(t){return arguments.length?(n=+t,rescale()):n},t.domain=function(t){return arguments.length?(e(t),rescale()):e()},t.ticks=function(t){var a,o=e(),u=o[0],s=o[o.length-1];(a=s<u)&&(d=u,u=s,s=d);var f,l,h,d=i(u),p=i(s),b=null==t?10:+t,v=[];if(!(n%1)&&p-d<b){if(d=Math.round(d)-1,p=Math.round(p)+1,u>0){for(;d<p;++d)for(l=1,f=c(d);l<n;++l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else for(;d<p;++d)for(l=n-1,f=c(d);l>=1;--l)if(!((h=f*l)<u)){if(h>s)break;v.push(h)}}else v=Object(r.ticks)(d,p,Math.min(p-d,b)).map(c);return a?v.reverse():v},t.tickFormat=function(e,r){if(null==r&&(r=10===n?".0e":","),"function"!=typeof r&&(r=Object(a.format)(r)),e===1/0)return r;null==e&&(e=10);var o=Math.max(1,n*e/t.ticks().length);return function(t){var e=t/c(Math.round(i(t)));return e*n<n-.5&&(e*=n),e<=o?r(t):""}},t.nice=function(){return e(Object(o.a)(e(),{floor:function(t){return c(Math.floor(i(t)))},ceil:function(t){return c(Math.ceil(i(t)))}}))},t.copy=function(){return Object(u.a)(t,log().base(n))},t}e.a=log;var r=n(5),a=n(21),i=n(39),o=n(83),u=n(18)},function(t,e,n){"use strict";function raise(t,e){return t<0?-Math.pow(-t,e):Math.pow(t,e)}function pow(){function deinterpolate(e,n){return(n=raise(n,t)-(e=raise(e,t)))?function(r){return(raise(r,t)-e)/n}:Object(r.a)(n)}function reinterpolate(e,n){return n=raise(n,t)-(e=raise(e,t)),function(r){return raise(e+n*r,1/t)}}var t=1,e=Object(i.b)(deinterpolate,reinterpolate),n=e.domain;return e.exponent=function(e){return arguments.length?(t=+e,n(n())):t},e.copy=function(){return Object(i.a)(e,pow().exponent(t))},Object(a.b)(e)}function sqrt(){return pow().exponent(.5)}e.a=pow,e.b=sqrt;var r=n(39),a=n(14),i=n(18)},function(t,e,n){"use strict";function quantile(){function rescale(){var a=0,i=Math.max(1,e.length);for(n=new Array(i-1);++a<i;)n[a-1]=Object(r.quantile)(t,a/i);return scale}function scale(t){if(!isNaN(t=+t))return e[Object(r.bisect)(n,t)]}var t=[],e=[],n=[];return scale.invertExtent=function(r){var a=e.indexOf(r);return a<0?[NaN,NaN]:[a>0?n[a-1]:t[0],a<n.length?n[a]:t[t.length-1]]},scale.domain=function(e){if(!arguments.length)return t.slice();t=[];for(var n,a=0,i=e.length;a<i;++a)null==(n=e[a])||isNaN(n=+n)||t.push(n);return t.sort(r.ascending),rescale()},scale.range=function(t){return arguments.length?(e=a.b.call(t),rescale()):e.slice()},scale.quantiles=function(){return n.slice()},scale.copy=function(){return quantile().domain(t).range(e)},scale}e.a=quantile;var r=n(5),a=n(9)},function(t,e,n){"use strict";function quantize(){function scale(t){if(t<=t)return u[Object(r.bisect)(o,t,0,n)]}function rescale(){var r=-1;for(o=new Array(n);++r<n;)o[r]=((r+1)*e-(r-n)*t)/(n+1);return scale}var t=0,e=1,n=1,o=[.5],u=[0,1];return scale.domain=function(n){return arguments.length?(t=+n[0],e=+n[1],rescale()):[t,e]},scale.range=function(t){return arguments.length?(n=(u=a.b.call(t)).length-1,rescale()):u.slice()},scale.invertExtent=function(r){var a=u.indexOf(r);return a<0?[NaN,NaN]:a<1?[t,o[0]]:a>=n?[o[n-1],e]:[o[a-1],o[a]]},scale.copy=function(){return quantize().domain([t,e]).range(u)},Object(i.b)(scale)}e.a=quantize;var r=n(5),a=n(9),i=n(14)},function(t,e,n){"use strict";function threshold(){function scale(a){if(a<=a)return e[Object(r.bisect)(t,a,0,n)]}var t=[.5],e=[0,1],n=1;return scale.domain=function(r){return arguments.length?(t=a.b.call(r),n=Math.min(t.length,e.length-1),scale):t.slice()},scale.range=function(r){return arguments.length?(e=a.b.call(r),n=Math.min(t.length,e.length-1),scale):e.slice()},scale.invertExtent=function(n){var r=e.indexOf(n);return[t[r-1],t[r]]},scale.copy=function(){return threshold().domain(t).range(e)},scale}e.a=threshold;var r=n(5),a=n(9)},function(t,e,n){"use strict";var r=n(84),a=n(40),i=n(35);e.a=function(){return Object(r.a)(i.utcYear,i.utcMonth,i.utcWeek,i.utcDay,i.utcHour,i.utcMinute,i.utcSecond,i.utcMillisecond,a.utcFormat).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)])}},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9")},function(t,e,n){"use strict";var r=n(16);e.a=Object(r.a)("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5")},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(300,.5,0),Object(r.cubehelix)(-240,.5,1))},function(t,e,n){"use strict";n.d(e,"c",function(){return i}),n.d(e,"a",function(){return o});var r=n(4),a=n(8),i=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(-100,.75,.35),Object(r.cubehelix)(80,1.5,.8)),o=Object(a.interpolateCubehelixLong)(Object(r.cubehelix)(260,.75,.35),Object(r.cubehelix)(80,1.5,.8)),u=Object(r.cubehelix)();e.b=function(t){(t<0||t>1)&&(t-=Math.floor(t));var e=Math.abs(t-.5);return u.h=360*t-100,u.s=1.5-1.5*e,u.l=.8-.9*e,u+""}},function(t,e,n){"use strict";function ramp(t){var e=t.length;return function(n){return t[Math.max(0,Math.min(e-1,Math.floor(n*e)))]}}n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"d",function(){return o});var r=n(16);e.a=ramp(Object(r.a)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));var a=ramp(Object(r.a)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),i=ramp(Object(r.a)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),o=ramp(Object(r.a)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"))},function(t,e,n){"use strict";function sequential(t){function scale(r){var i=(r-e)/(n-e);return t(a?Math.max(0,Math.min(1,i)):i)}var e=0,n=1,a=!1;return scale.domain=function(t){return arguments.length?(e=+t[0],n=+t[1],scale):[e,n]},scale.clamp=function(t){return arguments.length?(a=!!t,scale):a},scale.interpolator=function(e){return arguments.length?(t=e,scale):t},scale.copy=function(){return sequential(t).domain([e,n]).clamp(a)},Object(r.b)(scale)}e.a=sequential;var r=n(14)},function(t,e,n){"use strict";var r;void 0!==(r=function(){return{bar:'\n            <svg class="load-state bar-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 325">\n              \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(0 29)">\n                        <g stroke="#EFF2F5" stroke-dasharray="4 4">\n                            <path d="M.400592911 200.302477L710.674315 200.302477M.400592884 131.172748L710.674315 131.172748M.324410282 64.2071321L710.621499 64.2071321M.291004517.563888874L709.82431.563888889"/>\n                        </g>\n                        <g fill="#D2D6DF" transform="translate(63.08 11)">\n                            <polygon points="-.08 176 23.92 176 23.92 255 -.08 255"/>\n                            <polygon points="50.829 147 74.829 147 74.829 255 50.829 255"/>\n                            <polygon points="254.465 0 278.465 0 278.465 255 254.465 255"/>\n                            <polygon points="458.102 169 482.102 169 482.102 255 458.102 255"/>\n                            <polygon points="152.647 82 176.647 82 176.647 255 152.647 255"/>\n                            <polygon points="356.283 66 380.283 66 380.283 255 356.283 255"/>\n                            <polygon points="559.92 229 583.92 229 583.92 255 559.92 255"/>\n                            <polygon points="101.738 115 125.738 115 125.738 255 101.738 255"/>\n                            <polygon points="305.374 42 329.374 42 329.374 255 305.374 255"/>\n                            <polygon points="509.011 201 533.011 201 533.011 255 509.011 255"/>\n                            <polygon points="203.556 19 227.556 19 227.556 255 203.556 255"/>\n                            <polygon points="407.192 115 431.192 115 431.192 255 407.192 255"/>\n                        </g>\n                    </g>\n                    <polygon fill="#D2D6DF" fill-rule="nonzero" points="0 295 711 295 711 294 0 294"/>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',donut:'\n            <svg class="load-state donut-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 376 331">\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(116 107)">\n                        <circle cx="72" cy="72" r="72" stroke="#EFF2F5" stroke-linecap="round" stroke-width="9.6"/>\n                        <path stroke="#D2D6DF" stroke-width="19.2" d="M126.153559,119.524055 C137.264629,106.845712 144,90.2321371 144,72.0444604 C144,32.2554036 111.764502,0 72,0"/>\n                        <circle cx="72" cy="72" r="67.2" fill="#FFF"/>\n                    </g>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',line:'\n            <svg \n                class="load-state line-load-state" \n                xmlns="http://www.w3.org/2000/svg" \n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" > \n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path \n                    id="chart-bg" \n                    class="chart-bg" \n                    style="stroke:#C3C6CF;" \n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n               <polyline \n                    id="chart-line" \n                    class="chart-line" \n                    style="stroke:#C3C6CF;stroke-width:4;fill:none;" \n                    points="8.8,175.8 62.4,237.7 116.1,184.7 169.7,175.8 223.3,57 277,176.8 330.6,176.8 384.3,122.5 437.9,176.8 491.6,176.8 545.2,218.4 598.8,122.5 652.5,184.7 706.1,135.1 "\n                />\n                <rect class="chart-filter" fill="url(#lgrad)" x="0" y="0" width="300%" height="100%"></rect>\n            </svg>\n        '}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r=n(61),a=n(34),i=n(85),o=n(180),u=n(181);e.a=function(){function area(a){var i,o,u,d,p,b=a.length,v=!1,m=new Array(b),y=new Array(b);for(null==f&&(h=l(p=Object(r.a)())),i=0;i<=b;++i){if(!(i<b&&s(d=a[i],i,a))===v)if(v=!v)o=i,h.areaStart(),h.lineStart();else{for(h.lineEnd(),h.lineStart(),u=i-1;u>=o;--u)h.point(m[u],y[u]);h.lineEnd(),h.areaEnd()}v&&(m[i]=+t(d,i,a),y[i]=+n(d,i,a),h.point(e?+e(d,i,a):m[i],c?+c(d,i,a):y[i]))}if(p)return h=null,p+""||null}function arealine(){return Object(o.a)().defined(s).curve(l).context(f)}var t=u.a,e=null,n=Object(a.a)(0),c=u.b,s=Object(a.a)(!0),f=null,l=i.a,h=null;return area.x=function(n){return arguments.length?(t="function"==typeof n?n:Object(a.a)(+n),e=null,area):t},area.x0=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(+e),area):t},area.x1=function(t){return arguments.length?(e=null==t?null:"function"==typeof t?t:Object(a.a)(+t),area):e},area.y=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(+t),c=null,area):n},area.y0=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(+t),area):n},area.y1=function(t){return arguments.length?(c=null==t?null:"function"==typeof t?t:Object(a.a)(+t),area):c},area.lineX0=area.lineY0=function(){return arealine().x(t).y(n)},area.lineY1=function(){return arealine().x(t).y(c)},area.lineX1=function(){return arealine().x(e).y(n)},area.defined=function(t){return arguments.length?(s="function"==typeof t?t:Object(a.a)(!!t),area):s},area.curve=function(t){return arguments.length?(l=t,null!=f&&(h=l(f)),area):l},area.context=function(t){return arguments.length?(null==t?f=h=null:h=l(f=t),area):f},area}},function(t,e,n){"use strict";function Radial(t){this._curve=t}function curveRadial(t){function radial(e){return new Radial(t(e))}return radial._curve=t,radial}n.d(e,"a",function(){return a}),e.b=curveRadial;var r=n(85),a=curveRadial(r.a);Radial.prototype={areaStart:function(){this._curve.areaStart()},areaEnd:function(){this._curve.areaEnd()},lineStart:function(){this._curve.lineStart()},lineEnd:function(){this._curve.lineEnd()},point:function(t,e){this._curve.point(e*Math.sin(t),e*-Math.cos(t))}}},function(t,e,n){"use strict";function lineRadial(t){var e=t.curve;return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t.curve=function(t){return arguments.length?e(Object(r.b)(t)):e()._curve},t}e.b=lineRadial;var r=n(240),a=n(180);e.a=function(){return lineRadial(Object(a.a)().curve(r.a))}},function(t,e,n){"use strict";e.a=function(t,e){return[(e=+e)*Math.cos(t-=Math.PI/2),e*Math.sin(t)]}},function(t,e,n){"use strict";n.d(e,"a",function(){return r});var r=Array.prototype.slice},function(t,e,n){"use strict";var r=n(62);e.a={draw:function(t,e){var n=Math.sqrt(e/r.j);t.moveTo(n,0),t.arc(0,0,n,0,r.m)}}},function(t,e,n){"use strict";e.a={draw:function(t,e){var n=Math.sqrt(e/5)/2;t.moveTo(-3*n,-n),t.lineTo(-n,-n),t.lineTo(-n,-3*n),t.lineTo(n,-3*n),t.lineTo(n,-n),t.lineTo(3*n,-n),t.lineTo(3*n,n),t.lineTo(n,n),t.lineTo(n,3*n),t.lineTo(-n,3*n),t.lineTo(-n,n),t.lineTo(-3*n,n),t.closePath()}}},function(t,e,n){"use strict";var r=Math.sqrt(1/3),a=2*r;e.a={draw:function(t,e){var n=Math.sqrt(e/a),i=n*r;t.moveTo(0,-n),t.lineTo(i,0),t.lineTo(0,n),t.lineTo(-i,0),t.closePath()}}},function(t,e,n){"use strict";var r=n(62),a=Math.sin(r.j/10)/Math.sin(7*r.j/10),i=Math.sin(r.m/10)*a,o=-Math.cos(r.m/10)*a;e.a={draw:function(t,e){var n=Math.sqrt(.8908130915292852*e),a=i*n,u=o*n;t.moveTo(0,-n),t.lineTo(a,u);for(var c=1;c<5;++c){var s=r.m*c/5,f=Math.cos(s),l=Math.sin(s);t.lineTo(l*n,-f*n),t.lineTo(f*a-l*u,l*a+f*u)}t.closePath()}}},function(t,e,n){"use strict";e.a={draw:function(t,e){var n=Math.sqrt(e),r=-n/2;t.rect(r,r,n,n)}}},function(t,e,n){"use strict";var r=Math.sqrt(3);e.a={draw:function(t,e){var n=-Math.sqrt(e/(3*r));t.moveTo(0,2*n),t.lineTo(-r*n,-n),t.lineTo(r*n,-n),t.closePath()}}},function(t,e,n){"use strict";var r=-.5,a=Math.sqrt(3)/2,i=1/Math.sqrt(12),o=3*(i/2+1);e.a={draw:function(t,e){var n=Math.sqrt(e/o),u=n/2,c=n*i,s=u,f=n*i+n,l=-s,h=f;t.moveTo(u,c),t.lineTo(s,f),t.lineTo(l,h),t.lineTo(r*u-a*c,a*u+r*c),t.lineTo(r*s-a*f,a*s+r*f),t.lineTo(r*l-a*h,a*l+r*h),t.lineTo(r*u+a*c,r*c-a*u),t.lineTo(r*s+a*f,r*f-a*s),t.lineTo(r*l+a*h,r*h-a*l),t.closePath()}}},function(t,e,n){"use strict";function CardinalClosed(t,e){this._context=t,this._k=(1-e)/6}e.a=CardinalClosed;var r=n(86),a=n(88);CardinalClosed.prototype={areaStart:r.a,areaEnd:r.a,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._x3=t,this._y3=e;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=e);break;case 2:this._point=3,this._x5=t,this._y5=e;break;default:Object(a.c)(this,t,e)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.b=function custom(t){function cardinal(e){return new CardinalClosed(e,t)}return cardinal.tension=function(t){return custom(+t)},cardinal}(0)},function(t,e,n){"use strict";function CardinalOpen(t,e){this._context=t,this._k=(1-e)/6}e.a=CardinalOpen;var r=n(88);CardinalOpen.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Object(r.c)(this,t,e)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.b=function custom(t){function cardinal(e){return new CardinalOpen(e,t)}return cardinal.tension=function(t){return custom(+t)},cardinal}(0)},function(t,e,n){"use strict";var r;void 0!==(r=function(t){function exportChart(t,e,n){var r=createImage(convertSvgToHtml.call(this,t,n));r.onload=handleImageLoad.bind(r,createCanvas(this.width(),this.height()),e)}function addBackground(t){return t.replace(">",">"+c.styleBackgroundString)}function convertSvgToHtml(t,e){if(t){t.attr("version",1.1).attr("xmlns","http://www.w3.org/2000/svg");var n=a.initializeSerializer(),r=n(t.node());return r=formatHtmlByBrowser(r),r=prependTitle.call(this,r,e,parseInt(t.attr("width"),10)),r=addBackground(r)}}function createCanvas(t,e){var n=document.createElement("canvas");return n.height=e,n.width=t,n}function createImage(t){var e=new Image;return e.src=""+c.imageSourceBase+u(t),e}function drawImageOnCanvas(t,e){return e.getContext("2d").drawImage(t,0,0),e}function downloadCanvas(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:c.defaultFilename,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"image/png",r=t.toDataURL(n),a=document.createElement("a");a.href=r,a.download=e,document.body.appendChild(a),a.click(),document.body.removeChild(a)}function formatHtmlByBrowser(t){return navigator.userAgent.search("FireFox")>-1?t.replace(/url.*&quot;\)/,'url(&quot;linearGradient[id*="-gradient-"]&quot;);'):t}function handleImageLoad(t,e,n){n.preventDefault(),downloadCanvas(drawImageOnCanvas(this,t),e)}function prependTitle(t,e,n){if(!e||!n)return t;var a=r.grey;return t=t.replace(/<g/,'<text x="'+this.margin().left+'" y="'+c.titleTopOffset+'" font-family="'+c.titleFontFamily+'" font-size="'+c.titleFontSize+'" fill="'+a[6]+'"> '+e+" </text><g ")}var e=n(89),r=e.colorSchemas,a=(n(90),n(254)),i="undefined"!=typeof window,o=i&&window.btoa;o||(o=n(255).encode);var u=function(t){return o(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g,function(t,e){return String.fromCharCode("0x"+e)}))},c={styleClass:"britechartStyle",defaultFilename:"britechart.png",chartBackground:"white",imageSourceBase:"data:image/svg+xml;base64,",titleFontSize:"15px",titleFontFamily:"'Benton Sans', sans-serif",titleTopOffset:30,get styleBackgroundString(){return"<style>svg{background:"+this.chartBackground+";}</style>"}};return{exportChart:exportChart,convertSvgToHtml:convertSvgToHtml,createImage:createImage,drawImageOnCanvas:drawImageOnCanvas}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";t.exports=function(){return{initializeSerializer:function(){function computeDefaultStyleByTagName(t){var e={},n=document.body.appendChild(document.createElement(t)),r=window.getComputedStyle(n);return[].forEach.call(r,function(t){e[t]=r[t]}),document.body.removeChild(n),e}function getDefaultStyleByTagName(e){return e=e.toUpperCase(),t[e]||(t[e]=computeDefaultStyleByTagName(e)),t[e]}function serializeWithStyles(t){var n=[],r=void 0,a=void 0,i=void 0,o=void 0;if(t&&t.nodeType===Node.ELEMENT_NODE)return n=[],r=t.querySelectorAll("*"),[].forEach.call(r,function(t,r){e[t.tagName]||(a=window.getComputedStyle(t),i=getDefaultStyleByTagName(t.tagName),n[r]=t.style.cssText,[].forEach.call(a,function(e){a[e]!==i[e]&&(t.style[e]=a[e])}))}),o=t.outerHTML,r=[].map.call(r,function(t,e){return t.style.cssText=n[e],t}),o}var t={},e={BASE:!0,HEAD:!0,HTML:!0,META:!0,NOFRAME:!0,NOSCRIPT:!0,PARAM:!0,SCRIPT:!0,STYLE:!0,TITLE:!0},n=["A","ABBR","ADDRESS","AREA","ARTICLE","ASIDE","AUDIO","B","BASE","BDI","BDO","BLOCKQUOTE","BODY","BR","BUTTON","CANVAS","CAPTION","CENTER","CITE","CODE","COL","COLGROUP","COMMAND","DATALIST","DD","DEL","DETAILS","DFN","DIV","DL","DT","EM","EMBED","FIELDSET","FIGCAPTION","FIGURE","FONT","FOOTER","FORM","H1","H2","H3","H4","H5","H6","HEAD","HEADER","HGROUP","HR","HTML","I","IFRAME","IMG","INPUT","INS","KBD","LABEL","LEGEND","LI","LINK","MAP","MARK","MATH","MENU","META","METER","NAV","NOBR","NOSCRIPT","OBJECT","OL","OPTION","OPTGROUP","OUTPUT","P","PARAM","PRE","PROGRESS","Q","RP","RT","RUBY","S","SAMP","SCRIPT","SECTION","SELECT","SMALL","SOURCE","SPAN","STRONG","STYLE","SUB","SUMMARY","SUP","SVG","TABLE","TBODY","TD","TEXTAREA","TFOOT","TH","THEAD","TIME","TITLE","TR","TRACK","U","UL","VAR","VIDEO","WBR"];return[].forEach.call(n,function(n){e[n]||(t[n]=computeDefaultStyleByTagName(n))}),serializeWithStyles}}}()},function(t,e,n){(function(t,r){var a;!function(i){var o="object"==typeof e&&e,u=("object"==typeof t&&t&&t.exports,"object"==typeof r&&r);var c=function(t){this.message=t};c.prototype=new Error,c.prototype.name="InvalidCharacterError";var s=function(t){throw new c(t)},f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=/[\t\n\f\r ]/g,h=function(t){t=String(t).replace(l,"");var e=t.length;e%4==0&&(t=t.replace(/==?$/,""),e=t.length),(e%4==1||/[^+a-zA-Z0-9\/]/.test(t))&&s("Invalid character: the string to be decoded is not correctly encoded.");for(var n,r,a=0,i="",o=-1;++o<e;)r=f.indexOf(t.charAt(o)),n=a%4?64*n+r:r,a++%4&&(i+=String.fromCharCode(255&n>>(-2*a&6)));return i},d=function(t){t=String(t),/[^\0-\xFF]/.test(t)&&s("The string to be encoded contains characters outside of the Latin1 range.");for(var e,n,r,a,i=t.length%3,o="",u=-1,c=t.length-i;++u<c;)e=t.charCodeAt(u)<<16,n=t.charCodeAt(++u)<<8,r=t.charCodeAt(++u),a=e+n+r,o+=f.charAt(a>>18&63)+f.charAt(a>>12&63)+f.charAt(a>>6&63)+f.charAt(63&a);return 2==i?(e=t.charCodeAt(u)<<8,n=t.charCodeAt(++u),a=e+n,o+=f.charAt(a>>10)+f.charAt(a>>4&63)+f.charAt(a<<2&63)+"="):1==i&&(a=t.charCodeAt(u),o+=f.charAt(a>>2)+f.charAt(a<<4&63)+"=="),o},p={encode:d,decode:h,version:"0.1.0"};void 0!==(a=function(){return p}.call(e,n,e,t))&&(t.exports=a)}()}).call(e,n(256)(t),n(257))},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(259);n.d(e,"axisTop",function(){return r.d}),n.d(e,"axisRight",function(){return r.c}),n.d(e,"axisBottom",function(){return r.a}),n.d(e,"axisLeft",function(){return r.b})},function(t,e,n){"use strict";function translateX(t){return"translate("+(t+.5)+",0)"}function translateY(t){return"translate(0,"+(t+.5)+")"}function number(t){return function(e){return+t(e)}}function center(t){var e=Math.max(0,t.bandwidth()-1)/2;return t.round()&&(e=Math.round(e)),function(n){return+t(n)+e}}function entering(){return!this.__axis}function axis(t,e){function axis(r){var y=null==f?e.ticks?e.ticks.apply(e,n):e.domain():f,g=null==l?e.tickFormat?e.tickFormat.apply(e,n):a.a:l,_=Math.max(h,0)+p,x=e.range(),w=+x[0]+.5,O=+x[x.length-1]+.5,M=(e.bandwidth?center:number)(e.copy()),C=r.selection?r.selection():r,j=C.selectAll(".domain").data([null]),T=C.selectAll(".tick").data(y,e).order(),k=T.exit(),S=T.enter().append("g").attr("class","tick"),N=T.select("line"),A=T.select("text");j=j.merge(j.enter().insert("path",".tick").attr("class","domain").attr("stroke","#000")),T=T.merge(S),N=N.merge(S.append("line").attr("stroke","#000").attr(v+"2",b*h)),A=A.merge(S.append("text").attr("fill","#000").attr(v,b*_).attr("dy",t===i?"0em":t===u?"0.71em":"0.32em")),r!==C&&(j=j.transition(r),T=T.transition(r),N=N.transition(r),A=A.transition(r),k=k.transition(r).attr("opacity",s).attr("transform",function(t){return isFinite(t=M(t))?m(t):this.getAttribute("transform")}),S.attr("opacity",s).attr("transform",function(t){var e=this.parentNode.__axis;return m(e&&isFinite(e=e(t))?e:M(t))})),k.remove(),j.attr("d",t===c||t==o?"M"+b*d+","+w+"H0.5V"+O+"H"+b*d:"M"+w+","+b*d+"V0.5H"+O+"V"+b*d),T.attr("opacity",1).attr("transform",function(t){return m(M(t))}),N.attr(v+"2",b*h),A.attr(v,b*_).text(g),C.filter(entering).attr("fill","none").attr("font-size",10).attr("font-family","sans-serif").attr("text-anchor",t===o?"start":t===c?"end":"middle"),C.each(function(){this.__axis=M})}var n=[],f=null,l=null,h=6,d=6,p=3,b=t===i||t===c?-1:1,v=t===c||t===o?"x":"y",m=t===i||t===u?translateX:translateY;return axis.scale=function(t){return arguments.length?(e=t,axis):e},axis.ticks=function(){return n=r.a.call(arguments),axis},axis.tickArguments=function(t){return arguments.length?(n=null==t?[]:r.a.call(t),axis):n.slice()},axis.tickValues=function(t){return arguments.length?(f=null==t?null:r.a.call(t),axis):f&&f.slice()},axis.tickFormat=function(t){return arguments.length?(l=t,axis):l},axis.tickSize=function(t){return arguments.length?(h=d=+t,axis):h},axis.tickSizeInner=function(t){return arguments.length?(h=+t,axis):h},axis.tickSizeOuter=function(t){return arguments.length?(d=+t,axis):d},axis.tickPadding=function(t){return arguments.length?(p=+t,axis):p},axis}function axisTop(t){return axis(i,t)}function axisRight(t){return axis(o,t)}function axisBottom(t){return axis(u,t)}function axisLeft(t){return axis(c,t)}e.d=axisTop,e.c=axisRight,e.a=axisBottom,e.b=axisLeft;var r=n(260),a=n(261),i=1,o=2,u=3,c=4,s=1e-6},function(t,e,n){"use strict";n.d(e,"a",function(){return r});var r=Array.prototype.slice},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(263);n.d(e,"arc",function(){return r.a});var a=n(239);n.d(e,"area",function(){return a.a});var i=n(180);n.d(e,"line",function(){return i.a});var o=n(265);n.d(e,"pie",function(){return o.a});var u=n(268);n.d(e,"areaRadial",function(){return u.a}),n.d(e,"radialArea",function(){return u.a});var c=n(241);n.d(e,"lineRadial",function(){return c.a}),n.d(e,"radialLine",function(){return c.a});var s=n(242);n.d(e,"pointRadial",function(){return s.a});var f=n(269);n.d(e,"linkHorizontal",function(){return f.a}),n.d(e,"linkVertical",function(){return f.c}),n.d(e,"linkRadial",function(){return f.b});var l=n(270);n.d(e,"symbol",function(){return l.a}),n.d(e,"symbols",function(){return l.b});var h=n(244);n.d(e,"symbolCircle",function(){return h.a});var d=n(245);n.d(e,"symbolCross",function(){return d.a});var p=n(246);n.d(e,"symbolDiamond",function(){return p.a});var b=n(248);n.d(e,"symbolSquare",function(){return b.a});var v=n(247);n.d(e,"symbolStar",function(){return v.a});var m=n(249);n.d(e,"symbolTriangle",function(){return m.a});var y=n(250);n.d(e,"symbolWye",function(){return y.a});var g=n(271);n.d(e,"curveBasisClosed",function(){return g.a});var _=n(272);n.d(e,"curveBasisOpen",function(){return _.a});var x=n(87);n.d(e,"curveBasis",function(){return x.b});var w=n(273);n.d(e,"curveBundle",function(){return w.a});var O=n(251);n.d(e,"curveCardinalClosed",function(){return O.b});var M=n(252);n.d(e,"curveCardinalOpen",function(){return M.b});var C=n(88);n.d(e,"curveCardinal",function(){return C.b});var j=n(274);n.d(e,"curveCatmullRomClosed",function(){return j.a});var T=n(275);n.d(e,"curveCatmullRomOpen",function(){return T.a});var k=n(182);n.d(e,"curveCatmullRom",function(){return k.a});var S=n(276);n.d(e,"curveLinearClosed",function(){return S.a});var N=n(85);n.d(e,"curveLinear",function(){return N.a});var A=n(277);n.d(e,"curveMonotoneX",function(){return A.a}),n.d(e,"curveMonotoneY",function(){return A.b});var E=n(278);n.d(e,"curveNatural",function(){return E.a});var D=n(279);n.d(e,"curveStep",function(){return D.a}),n.d(e,"curveStepAfter",function(){return D.b}),n.d(e,"curveStepBefore",function(){return D.c});var F=n(280);n.d(e,"stack",function(){return F.a});var I=n(281);n.d(e,"stackOffsetExpand",function(){return I.a});var P=n(282);n.d(e,"stackOffsetDiverging",function(){return P.a});var R=n(63);n.d(e,"stackOffsetNone",function(){return R.a});var L=n(283);n.d(e,"stackOffsetSilhouette",function(){return L.a});var U=n(284);n.d(e,"stackOffsetWiggle",function(){return U.a});var H=n(183);n.d(e,"stackOrderAscending",function(){return H.a});var Y=n(285);n.d(e,"stackOrderDescending",function(){return Y.a});var q=n(286);n.d(e,"stackOrderInsideOut",function(){return q.a});var B=n(64);n.d(e,"stackOrderNone",function(){return B.a});var z=n(287);n.d(e,"stackOrderReverse",function(){return z.a})},function(t,e,n){"use strict";function arcInnerRadius(t){return t.innerRadius}function arcOuterRadius(t){return t.outerRadius}function arcStartAngle(t){return t.startAngle}function arcEndAngle(t){return t.endAngle}function arcPadAngle(t){return t&&t.padAngle}function intersect(t,e,n,r,a,i,o,u){var c=n-t,s=r-e,f=o-a,l=u-i,h=(f*(e-i)-l*(t-a))/(l*c-f*s);return[t+h*c,e+h*s]}function cornerTangents(t,e,n,r,a,o,u){var c=t-n,s=e-r,f=(u?o:-o)/Object(i.l)(c*c+s*s),l=f*s,h=-f*c,d=t+l,p=e+h,b=n+l,v=r+h,m=(d+b)/2,y=(p+v)/2,g=b-d,_=v-p,x=g*g+_*_,w=a-o,O=d*v-b*p,M=(_<0?-1:1)*Object(i.l)(Object(i.h)(0,w*w*x-O*O)),C=(O*_-g*M)/x,j=(-O*g-_*M)/x,T=(O*_+g*M)/x,k=(-O*g+_*M)/x,S=C-m,N=j-y,A=T-m,E=k-y;return S*S+N*N>A*A+E*E&&(C=T,j=k),{cx:C,cy:j,x01:-l,y01:-h,x11:C*(a/w-1),y11:j*(a/w-1)}}var r=n(61),a=n(34),i=n(62);e.a=function(){function arc(){var a,l,h=+t.apply(this,arguments),d=+e.apply(this,arguments),p=u.apply(this,arguments)-i.g,b=c.apply(this,arguments)-i.g,v=Object(i.a)(b-p),m=b>p;if(f||(f=a=Object(r.a)()),d<h&&(l=d,d=h,h=l),d>i.f)if(v>i.m-i.f)f.moveTo(d*Object(i.e)(p),d*Object(i.k)(p)),f.arc(0,0,d,p,b,!m),h>i.f&&(f.moveTo(h*Object(i.e)(b),h*Object(i.k)(b)),f.arc(0,0,h,b,p,m));else{var y,g,_=p,x=b,w=p,O=b,M=v,C=v,j=s.apply(this,arguments)/2,T=j>i.f&&(o?+o.apply(this,arguments):Object(i.l)(h*h+d*d)),k=Object(i.i)(Object(i.a)(d-h)/2,+n.apply(this,arguments)),S=k,N=k;if(T>i.f){var A=Object(i.c)(T/h*Object(i.k)(j)),E=Object(i.c)(T/d*Object(i.k)(j));(M-=2*A)>i.f?(A*=m?1:-1,w+=A,O-=A):(M=0,w=O=(p+b)/2),(C-=2*E)>i.f?(E*=m?1:-1,_+=E,x-=E):(C=0,_=x=(p+b)/2)}var D=d*Object(i.e)(_),F=d*Object(i.k)(_),I=h*Object(i.e)(O),P=h*Object(i.k)(O);if(k>i.f){var R=d*Object(i.e)(x),L=d*Object(i.k)(x),U=h*Object(i.e)(w),H=h*Object(i.k)(w);if(v<i.j){var Y=M>i.f?intersect(D,F,U,H,R,L,I,P):[I,P],q=D-Y[0],B=F-Y[1],z=R-Y[0],W=L-Y[1],V=1/Object(i.k)(Object(i.b)((q*z+B*W)/(Object(i.l)(q*q+B*B)*Object(i.l)(z*z+W*W)))/2),G=Object(i.l)(Y[0]*Y[0]+Y[1]*Y[1]);S=Object(i.i)(k,(h-G)/(V-1)),N=Object(i.i)(k,(d-G)/(V+1))}}C>i.f?N>i.f?(y=cornerTangents(U,H,D,F,d,N,m),g=cornerTangents(R,L,I,P,d,N,m),f.moveTo(y.cx+y.x01,y.cy+y.y01),N<k?f.arc(y.cx,y.cy,N,Object(i.d)(y.y01,y.x01),Object(i.d)(g.y01,g.x01),!m):(f.arc(y.cx,y.cy,N,Object(i.d)(y.y01,y.x01),Object(i.d)(y.y11,y.x11),!m),f.arc(0,0,d,Object(i.d)(y.cy+y.y11,y.cx+y.x11),Object(i.d)(g.cy+g.y11,g.cx+g.x11),!m),f.arc(g.cx,g.cy,N,Object(i.d)(g.y11,g.x11),Object(i.d)(g.y01,g.x01),!m))):(f.moveTo(D,F),f.arc(0,0,d,_,x,!m)):f.moveTo(D,F),h>i.f&&M>i.f?S>i.f?(y=cornerTangents(I,P,R,L,h,-S,m),g=cornerTangents(D,F,U,H,h,-S,m),f.lineTo(y.cx+y.x01,y.cy+y.y01),S<k?f.arc(y.cx,y.cy,S,Object(i.d)(y.y01,y.x01),Object(i.d)(g.y01,g.x01),!m):(f.arc(y.cx,y.cy,S,Object(i.d)(y.y01,y.x01),Object(i.d)(y.y11,y.x11),!m),f.arc(0,0,h,Object(i.d)(y.cy+y.y11,y.cx+y.x11),Object(i.d)(g.cy+g.y11,g.cx+g.x11),m),f.arc(g.cx,g.cy,S,Object(i.d)(g.y11,g.x11),Object(i.d)(g.y01,g.x01),!m))):f.arc(0,0,h,O,w,m):f.lineTo(I,P)}else f.moveTo(0,0);if(f.closePath(),a)return f=null,a+""||null}var t=arcInnerRadius,e=arcOuterRadius,n=Object(a.a)(0),o=null,u=arcStartAngle,c=arcEndAngle,s=arcPadAngle,f=null;return arc.centroid=function(){var n=(+t.apply(this,arguments)+ +e.apply(this,arguments))/2,r=(+u.apply(this,arguments)+ +c.apply(this,arguments))/2-i.j/2;return[Object(i.e)(r)*n,Object(i.k)(r)*n]},arc.innerRadius=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(+e),arc):t},arc.outerRadius=function(t){return arguments.length?(e="function"==typeof t?t:Object(a.a)(+t),arc):e},arc.cornerRadius=function(t){return arguments.length?(n="function"==typeof t?t:Object(a.a)(+t),arc):n},arc.padRadius=function(t){return arguments.length?(o=null==t?null:"function"==typeof t?t:Object(a.a)(+t),arc):o},arc.startAngle=function(t){return arguments.length?(u="function"==typeof t?t:Object(a.a)(+t),arc):u},arc.endAngle=function(t){return arguments.length?(c="function"==typeof t?t:Object(a.a)(+t),arc):c},arc.padAngle=function(t){return arguments.length?(s="function"==typeof t?t:Object(a.a)(+t),arc):s},arc.context=function(t){return arguments.length?(f=null==t?null:t,arc):f},arc}},function(t,e,n){"use strict";function Path(){this._x0=this._y0=this._x1=this._y1=null,this._=""}function path(){return new Path}var r=Math.PI,a=2*r,i=a-1e-6;Path.prototype=path.prototype={constructor:Path,moveTo:function(t,e){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+e)},closePath:function(){null!==this._x1&&(this._x1=this._x0,this._y1=this._y0,this._+="Z")},lineTo:function(t,e){this._+="L"+(this._x1=+t)+","+(this._y1=+e)},quadraticCurveTo:function(t,e,n,r){this._+="Q"+ +t+","+ +e+","+(this._x1=+n)+","+(this._y1=+r)},bezierCurveTo:function(t,e,n,r,a,i){this._+="C"+ +t+","+ +e+","+ +n+","+ +r+","+(this._x1=+a)+","+(this._y1=+i)},arcTo:function(t,e,n,a,i){t=+t,e=+e,n=+n,a=+a,i=+i;var o=this._x1,u=this._y1,c=n-t,s=a-e,f=o-t,l=u-e,h=f*f+l*l;if(i<0)throw new Error("negative radius: "+i);if(null===this._x1)this._+="M"+(this._x1=t)+","+(this._y1=e);else if(h>1e-6)if(Math.abs(l*c-s*f)>1e-6&&i){var d=n-o,p=a-u,b=c*c+s*s,v=d*d+p*p,m=Math.sqrt(b),y=Math.sqrt(h),g=i*Math.tan((r-Math.acos((b+h-v)/(2*m*y)))/2),_=g/y,x=g/m;Math.abs(_-1)>1e-6&&(this._+="L"+(t+_*f)+","+(e+_*l)),this._+="A"+i+","+i+",0,0,"+ +(l*d>f*p)+","+(this._x1=t+x*c)+","+(this._y1=e+x*s)}else this._+="L"+(this._x1=t)+","+(this._y1=e);else;},arc:function(t,e,n,o,u,c){t=+t,e=+e,n=+n;var s=n*Math.cos(o),f=n*Math.sin(o),l=t+s,h=e+f,d=1^c,p=c?o-u:u-o;if(n<0)throw new Error("negative radius: "+n);null===this._x1?this._+="M"+l+","+h:(Math.abs(this._x1-l)>1e-6||Math.abs(this._y1-h)>1e-6)&&(this._+="L"+l+","+h),n&&(p<0&&(p=p%a+a),p>i?this._+="A"+n+","+n+",0,1,"+d+","+(t-s)+","+(e-f)+"A"+n+","+n+",0,1,"+d+","+(this._x1=l)+","+(this._y1=h):p>1e-6&&(this._+="A"+n+","+n+",0,"+ +(p>=r)+","+d+","+(this._x1=t+n*Math.cos(u))+","+(this._y1=e+n*Math.sin(u))))},rect:function(t,e,n,r){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+e)+"h"+ +n+"v"+ +r+"h"+-n+"Z"},toString:function(){return this._}},e.a=path},function(t,e,n){"use strict";var r=n(34),a=n(266),i=n(267),o=n(62);e.a=function(){function pie(r){var a,i,f,l,h,d=r.length,p=0,b=new Array(d),v=new Array(d),m=+u.apply(this,arguments),y=Math.min(o.m,Math.max(-o.m,c.apply(this,arguments)-m)),g=Math.min(Math.abs(y)/d,s.apply(this,arguments)),_=g*(y<0?-1:1);for(a=0;a<d;++a)(h=v[b[a]=a]=+t(r[a],a,r))>0&&(p+=h);for(null!=e?b.sort(function(t,n){return e(v[t],v[n])}):null!=n&&b.sort(function(t,e){return n(r[t],r[e])}),a=0,f=p?(y-d*_)/p:0;a<d;++a,m=l)i=b[a],h=v[i],l=m+(h>0?h*f:0)+_,v[i]={data:r[i],index:a,value:h,startAngle:m,endAngle:l,padAngle:g};return v}var t=i.a,e=a.a,n=null,u=Object(r.a)(0),c=Object(r.a)(o.m),s=Object(r.a)(0);return pie.value=function(e){return arguments.length?(t="function"==typeof e?e:Object(r.a)(+e),pie):t},pie.sortValues=function(t){return arguments.length?(e=t,n=null,pie):e},pie.sort=function(t){return arguments.length?(n=t,e=null,pie):n},pie.startAngle=function(t){return arguments.length?(u="function"==typeof t?t:Object(r.a)(+t),pie):u},pie.endAngle=function(t){return arguments.length?(c="function"==typeof t?t:Object(r.a)(+t),pie):c},pie.padAngle=function(t){return arguments.length?(s="function"==typeof t?t:Object(r.a)(+t),pie):s},pie}},function(t,e,n){"use strict";e.a=function(t,e){return e<t?-1:e>t?1:e>=t?0:NaN}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(240),a=n(239),i=n(241);e.a=function(){var t=Object(a.a)().curve(r.a),e=t.curve,n=t.lineX0,o=t.lineX1,u=t.lineY0,c=t.lineY1;return t.angle=t.x,delete t.x,t.startAngle=t.x0,delete t.x0,t.endAngle=t.x1,delete t.x1,t.radius=t.y,delete t.y,t.innerRadius=t.y0,delete t.y0,t.outerRadius=t.y1,delete t.y1,t.lineStartAngle=function(){return Object(i.b)(n())},delete t.lineX0,t.lineEndAngle=function(){return Object(i.b)(o())},delete t.lineX1,t.lineInnerRadius=function(){return Object(i.b)(u())},delete t.lineY0,t.lineOuterRadius=function(){return Object(i.b)(c())},delete t.lineY1,t.curve=function(t){return arguments.length?e(Object(r.b)(t)):e()._curve},t}},function(t,e,n){"use strict";function linkSource(t){return t.source}function linkTarget(t){return t.target}function link(t){function link(){var i,o=a.a.call(arguments),f=e.apply(this,o),l=n.apply(this,o);if(s||(s=i=Object(r.a)()),t(s,+u.apply(this,(o[0]=f,o)),+c.apply(this,o),+u.apply(this,(o[0]=l,o)),+c.apply(this,o)),i)return s=null,i+""||null}var e=linkSource,n=linkTarget,u=o.a,c=o.b,s=null;return link.source=function(t){return arguments.length?(e=t,link):e},link.target=function(t){return arguments.length?(n=t,link):n},link.x=function(t){return arguments.length?(u="function"==typeof t?t:Object(i.a)(+t),link):u},link.y=function(t){return arguments.length?(c="function"==typeof t?t:Object(i.a)(+t),link):c},link.context=function(t){return arguments.length?(s=null==t?null:t,link):s},link}function curveHorizontal(t,e,n,r,a){t.moveTo(e,n),t.bezierCurveTo(e=(e+r)/2,n,e,a,r,a)}function curveVertical(t,e,n,r,a){t.moveTo(e,n),t.bezierCurveTo(e,n=(n+a)/2,r,n,r,a)}function curveRadial(t,e,n,r,a){var i=Object(u.a)(e,n),o=Object(u.a)(e,n=(n+a)/2),c=Object(u.a)(r,n),s=Object(u.a)(r,a);t.moveTo(i[0],i[1]),t.bezierCurveTo(o[0],o[1],c[0],c[1],s[0],s[1])}function linkHorizontal(){return link(curveHorizontal)}function linkVertical(){return link(curveVertical)}function linkRadial(){var t=link(curveRadial);return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t}e.a=linkHorizontal,e.c=linkVertical,e.b=linkRadial;var r=n(61),a=n(243),i=n(34),o=n(181),u=n(242)},function(t,e,n){"use strict";n.d(e,"b",function(){return h});var r=n(61),a=n(244),i=n(245),o=n(246),u=n(247),c=n(248),s=n(249),f=n(250),l=n(34),h=[a.a,i.a,o.a,c.a,u.a,s.a,f.a];e.a=function(){function symbol(){var a;if(n||(n=a=Object(r.a)()),t.apply(this,arguments).draw(n,+e.apply(this,arguments)),a)return n=null,a+""||null}var t=Object(l.a)(a.a),e=Object(l.a)(64),n=null;return symbol.type=function(e){return arguments.length?(t="function"==typeof e?e:Object(l.a)(e),symbol):t},symbol.size=function(t){return arguments.length?(e="function"==typeof t?t:Object(l.a)(+t),symbol):e},symbol.context=function(t){return arguments.length?(n=null==t?null:t,symbol):n},symbol}},function(t,e,n){"use strict";function BasisClosed(t){this._context=t}var r=n(86),a=n(87);BasisClosed.prototype={areaStart:r.a,areaEnd:r.a,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._y0=this._y1=this._y2=this._y3=this._y4=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x2,this._y2),this._context.closePath();break;case 2:this._context.moveTo((this._x2+2*this._x3)/3,(this._y2+2*this._y3)/3),this._context.lineTo((this._x3+2*this._x2)/3,(this._y3+2*this._y2)/3),this._context.closePath();break;case 3:this.point(this._x2,this._y2),this.point(this._x3,this._y3),this.point(this._x4,this._y4)}},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._x2=t,this._y2=e;break;case 1:this._point=2,this._x3=t,this._y3=e;break;case 2:this._point=3,this._x4=t,this._y4=e,this._context.moveTo((this._x0+4*this._x1+t)/6,(this._y0+4*this._y1+e)/6);break;default:Object(a.c)(this,t,e)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e}},e.a=function(t){return new BasisClosed(t)}},function(t,e,n){"use strict";function BasisOpen(t){this._context=t}var r=n(87);BasisOpen.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3;var n=(this._x0+4*this._x1+t)/6,a=(this._y0+4*this._y1+e)/6;this._line?this._context.lineTo(n,a):this._context.moveTo(n,a);break;case 3:this._point=4;default:Object(r.c)(this,t,e)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e}},e.a=function(t){return new BasisOpen(t)}},function(t,e,n){"use strict";function Bundle(t,e){this._basis=new r.a(t),this._beta=e}var r=n(87);Bundle.prototype={lineStart:function(){this._x=[],this._y=[],this._basis.lineStart()},lineEnd:function(){var t=this._x,e=this._y,n=t.length-1;if(n>0)for(var r,a=t[0],i=e[0],o=t[n]-a,u=e[n]-i,c=-1;++c<=n;)r=c/n,this._basis.point(this._beta*t[c]+(1-this._beta)*(a+r*o),this._beta*e[c]+(1-this._beta)*(i+r*u));this._x=this._y=null,this._basis.lineEnd()},point:function(t,e){this._x.push(+t),this._y.push(+e)}},e.a=function custom(t){function bundle(e){return 1===t?new r.a(e):new Bundle(e,t)}return bundle.beta=function(t){return custom(+t)},bundle}(.85)},function(t,e,n){"use strict";function CatmullRomClosed(t,e){this._context=t,this._alpha=e}var r=n(251),a=n(86),i=n(182);CatmullRomClosed.prototype={areaStart:a.a,areaEnd:a.a,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,e){if(t=+t,e=+e,this._point){var n=this._x2-t,r=this._y2-e;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(n*n+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._x3=t,this._y3=e;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=e);break;case 2:this._point=3,this._x5=t,this._y5=e;break;default:Object(i.b)(this,t,e)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.a=function custom(t){function catmullRom(e){return t?new CatmullRomClosed(e,t):new r.a(e,0)}return catmullRom.alpha=function(t){return custom(+t)},catmullRom}(.5)},function(t,e,n){"use strict";function CatmullRomOpen(t,e){this._context=t,this._alpha=e}var r=n(252),a=n(182);CatmullRomOpen.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){if(t=+t,e=+e,this._point){var n=this._x2-t,r=this._y2-e;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(n*n+r*r,this._alpha))}switch(this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Object(a.b)(this,t,e)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=e}},e.a=function custom(t){function catmullRom(e){return t?new CatmullRomOpen(e,t):new r.a(e,0)}return catmullRom.alpha=function(t){return custom(+t)},catmullRom}(.5)},function(t,e,n){"use strict";function LinearClosed(t){this._context=t}var r=n(86);LinearClosed.prototype={areaStart:r.a,areaEnd:r.a,lineStart:function(){this._point=0},lineEnd:function(){this._point&&this._context.closePath()},point:function(t,e){t=+t,e=+e,this._point?this._context.lineTo(t,e):(this._point=1,this._context.moveTo(t,e))}},e.a=function(t){return new LinearClosed(t)}},function(t,e,n){"use strict";function sign(t){return t<0?-1:1}function slope3(t,e,n){var r=t._x1-t._x0,a=e-t._x1,i=(t._y1-t._y0)/(r||a<0&&-0),o=(n-t._y1)/(a||r<0&&-0),u=(i*a+o*r)/(r+a);return(sign(i)+sign(o))*Math.min(Math.abs(i),Math.abs(o),.5*Math.abs(u))||0}function slope2(t,e){var n=t._x1-t._x0;return n?(3*(t._y1-t._y0)/n-e)/2:e}function point(t,e,n){var r=t._x0,a=t._y0,i=t._x1,o=t._y1,u=(i-r)/3;t._context.bezierCurveTo(r+u,a+u*e,i-u,o-u*n,i,o)}function MonotoneX(t){this._context=t}function MonotoneY(t){this._context=new ReflectContext(t)}function ReflectContext(t){this._context=t}function monotoneX(t){return new MonotoneX(t)}function monotoneY(t){return new MonotoneY(t)}e.a=monotoneX,e.b=monotoneY,MonotoneX.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=this._t0=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x1,this._y1);break;case 3:point(this,this._t0,slope2(this,this._t0))}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,e){var n=NaN;if(t=+t,e=+e,t!==this._x1||e!==this._y1){switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;break;case 2:this._point=3,point(this,slope2(this,n=slope3(this,t,e)),n);break;default:point(this,this._t0,n=slope3(this,t,e))}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=e,this._t0=n}}},(MonotoneY.prototype=Object.create(MonotoneX.prototype)).point=function(t,e){MonotoneX.prototype.point.call(this,e,t)},ReflectContext.prototype={moveTo:function(t,e){this._context.moveTo(e,t)},closePath:function(){this._context.closePath()},lineTo:function(t,e){this._context.lineTo(e,t)},bezierCurveTo:function(t,e,n,r,a,i){this._context.bezierCurveTo(e,t,r,n,i,a)}}},function(t,e,n){"use strict";function Natural(t){this._context=t}function controlPoints(t){var e,n,r=t.length-1,a=new Array(r),i=new Array(r),o=new Array(r);for(a[0]=0,i[0]=2,o[0]=t[0]+2*t[1],e=1;e<r-1;++e)a[e]=1,i[e]=4,o[e]=4*t[e]+2*t[e+1];for(a[r-1]=2,i[r-1]=7,o[r-1]=8*t[r-1]+t[r],e=1;e<r;++e)n=a[e]/i[e-1],i[e]-=n,o[e]-=n*o[e-1];for(a[r-1]=o[r-1]/i[r-1],e=r-2;e>=0;--e)a[e]=(o[e]-a[e+1])/i[e];for(i[r-1]=(t[r]+a[r-1])/2,e=0;e<r-1;++e)i[e]=2*t[e+1]-a[e+1];return[a,i]}Natural.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=[],this._y=[]},lineEnd:function(){var t=this._x,e=this._y,n=t.length;if(n)if(this._line?this._context.lineTo(t[0],e[0]):this._context.moveTo(t[0],e[0]),2===n)this._context.lineTo(t[1],e[1]);else for(var r=controlPoints(t),a=controlPoints(e),i=0,o=1;o<n;++i,++o)this._context.bezierCurveTo(r[0][i],a[0][i],r[1][i],a[1][i],t[o],e[o]);(this._line||0!==this._line&&1===n)&&this._context.closePath(),this._line=1-this._line,this._x=this._y=null},point:function(t,e){this._x.push(+t),this._y.push(+e)}},e.a=function(t){return new Natural(t)}},function(t,e,n){"use strict";function Step(t,e){this._context=t,this._t=e}function stepBefore(t){return new Step(t,0)}function stepAfter(t){return new Step(t,1)}e.c=stepBefore,e.b=stepAfter,Step.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=this._y=NaN,this._point=0},lineEnd:function(){0<this._t&&this._t<1&&2===this._point&&this._context.lineTo(this._x,this._y),(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line>=0&&(this._t=1-this._t,this._line=1-this._line)},point:function(t,e){switch(t=+t,e=+e,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,e):this._context.moveTo(t,e);break;case 1:this._point=2;default:if(this._t<=0)this._context.lineTo(this._x,e),this._context.lineTo(t,e);else{var n=this._x*(1-this._t)+t*this._t;this._context.lineTo(n,this._y),this._context.lineTo(n,e)}}this._x=t,this._y=e}},e.a=function(t){return new Step(t,.5)}},function(t,e,n){"use strict";function stackValue(t,e){return t[e]}var r=n(243),a=n(34),i=n(63),o=n(64);e.a=function(){function stack(r){var a,i,o=t.apply(this,arguments),c=r.length,s=o.length,f=new Array(s);for(a=0;a<s;++a){for(var l,h=o[a],d=f[a]=new Array(c),p=0;p<c;++p)d[p]=l=[0,+u(r[p],h,p,r)],l.data=r[p];d.key=h}for(a=0,i=e(f);a<s;++a)f[i[a]].index=a;return n(f,i),f}var t=Object(a.a)([]),e=o.a,n=i.a,u=stackValue;return stack.keys=function(e){return arguments.length?(t="function"==typeof e?e:Object(a.a)(r.a.call(e)),stack):t},stack.value=function(t){return arguments.length?(u="function"==typeof t?t:Object(a.a)(+t),stack):u},stack.order=function(t){return arguments.length?(e=null==t?o.a:"function"==typeof t?t:Object(a.a)(r.a.call(t)),stack):e},stack.offset=function(t){return arguments.length?(n=null==t?i.a:t,stack):n},stack}},function(t,e,n){"use strict";var r=n(63);e.a=function(t,e){if((a=t.length)>0){for(var n,a,i,o=0,u=t[0].length;o<u;++o){for(i=n=0;n<a;++n)i+=t[n][o][1]||0;if(i)for(n=0;n<a;++n)t[n][o][1]/=i}Object(r.a)(t,e)}}},function(t,e,n){"use strict";e.a=function(t,e){if((u=t.length)>1)for(var n,r,a,i,o,u,c=0,s=t[e[0]].length;c<s;++c)for(i=o=0,n=0;n<u;++n)(a=(r=t[e[n]][c])[1]-r[0])>=0?(r[0]=i,r[1]=i+=a):a<0?(r[1]=o,r[0]=o+=a):r[0]=i}},function(t,e,n){"use strict";var r=n(63);e.a=function(t,e){if((n=t.length)>0){for(var n,a=0,i=t[e[0]],o=i.length;a<o;++a){for(var u=0,c=0;u<n;++u)c+=t[u][a][1]||0;i[a][1]+=i[a][0]=-c/2}Object(r.a)(t,e)}}},function(t,e,n){"use strict";var r=n(63);e.a=function(t,e){if((i=t.length)>0&&(a=(n=t[e[0]]).length)>0){for(var n,a,i,o=0,u=1;u<a;++u){for(var c=0,s=0,f=0;c<i;++c){for(var l=t[e[c]],h=l[u][1]||0,d=l[u-1][1]||0,p=(h-d)/2,b=0;b<c;++b){var v=t[e[b]];p+=(v[u][1]||0)-(v[u-1][1]||0)}s+=h,f+=p*h}n[u-1][1]+=n[u-1][0]=o,s&&(o-=f/s)}n[u-1][1]+=n[u-1][0]=o,Object(r.a)(t,e)}}},function(t,e,n){"use strict";var r=n(183);e.a=function(t){return Object(r.a)(t).reverse()}},function(t,e,n){"use strict";var r=n(64),a=n(183);e.a=function(t){var e,n,i=t.length,o=t.map(a.b),u=Object(r.a)(t).sort(function(t,e){return o[e]-o[t]}),c=0,s=0,f=[],l=[];for(e=0;e<i;++e)n=u[e],c<s?(c+=o[n],f.push(n)):(s+=o[n],l.push(n));return l.reverse().concat(f)}},function(t,e,n){"use strict";var r=n(64);e.a=function(t){return Object(r.a)(t).reverse()}},function(t,e,n){"use strict";var r;void 0!==(r=function(t){function addDays(t,e){var n=new Date(t);return n.setDate(n.getDate()+e),String(n)}function calculatePercent(t,n,r){var a=n?t/n*100:0;return e.format(r)(a)}function diffDays(t,e){return Math.ceil(Math.abs((new Date(t).getTime()-new Date(e).getTime())/864e5))}function isInteger(t){return t%1==0}function uniqueId(t){var e=++r;return t.toString()+"-"+e}var e=n(21),r=0;return{addDays:addDays,calculatePercent:calculatePercent,diffDays:diffDays,isInteger:isInteger,uniqueId:uniqueId}}.call(e,n,e,t))&&(t.exports=r)},,function(t,e,n){"use strict";function _defineProperty(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var r,a=function(){function sliceIterator(t,e){var n=[],r=!0,a=!1,i=void 0;try{for(var o,u=t[Symbol.iterator]();!(r=(o=u.next()).done)&&(n.push(o.value),!e||n.length!==e);r=!0);}catch(t){a=!0,i=t}finally{try{!r&&u.return&&u.return()}finally{if(a)throw i}}return n}return function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return sliceIterator(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};void 0!==(r=function(t){var e,r=n(35),o=n(40),u=n(90),c=u.axisTimeCombinations,s=u.timeBenchmarks,f={minute:o.timeFormat("%M m"),hour:o.timeFormat("%H %p"),day:o.timeFormat("%e"),daymonth:o.timeFormat("%d %b"),month:o.timeFormat("%b"),year:o.timeFormat("%Y")},l={minute:{minute:"numeric"},hour:{hour:"numeric"},day:{day:"numeric"},daymonth:{day:"numeric",month:"short"},month:{month:"short"},year:{year:"numeric"}},h=(e={},_defineProperty(e,c.MINUTE_HOUR,r.timeHour.every(1)),_defineProperty(e,c.HOUR_DAY,r.timeDay.every(1)),_defineProperty(e,c.DAY_MONTH,r.timeMonth.every(1)),_defineProperty(e,c.MONTH_YEAR,r.timeYear.every(1)),e),d=function(t){var e=s.ONE_YEAR,n=s.ONE_DAY;return t<n?c.HOUR_DAY:t<e?c.DAY_MONTH:c.MONTH_YEAR},p=function(t,e){var n=Math.ceil(t/70);return e<5?r.timeDay:Math.min(e,n)},b=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"day",n=l[e],r=new Intl.DateTimeFormat(t,n);return function(t){return r.format(t)}},v=function(t){return Math.ceil(t/864e5)};return{getXAxisSettings:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,o=new Date(t[0].date),u=new Date(t[t.length-1].date),c=u-o;r&&("undefined"==typeof Intl||"object"===("undefined"==typeof Intl?"undefined":i(Intl))&&!Intl.DateTimeFormat)&&(r=null),n||(n=d(c));var s=n.split("-"),l=a(s,2),m=l[0],y=l[1],g=h[n],_=p(e,v(c));return{minor:{format:r?b(r,m):f[m],tick:_},major:{format:r?b(r,y):f[y],tick:g}}},getLocaleDateFormatter:b}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";var r;void 0!==(r=function(t){function getValueSize(t,e){var n="large";return t<e.small.limit?n="small":t<e.medium.limit&&(n="medium"),n}function formatIntegerValue(t){var e=getValueSize(t,r);return(0,r[e].format)(t)}function formatDecimalValue(t){var e=getValueSize(t,a);return(0,a[e].format)(t)}var e=n(21),r={small:{limit:10,format:e.format("")},medium:{limit:1e3,format:e.format("")},large:{limit:null,format:e.format(".2s")}},a={small:{limit:10,format:e.format(".3f")},medium:{limit:100,format:e.format(".1f")},large:{limit:null,format:e.format(".2s")}};return{formatDecimalValue:formatDecimalValue,formatIntegerValue:formatIntegerValue}}.call(e,n,e,t))&&(t.exports=r)},function(t,e){function apply(t,e,n){switch(n.length){case 0:return t.call(e);case 1:return t.call(e,n[0]);case 2:return t.call(e,n[0],n[1]);case 3:return t.call(e,n[0],n[1],n[2])}return t.apply(e,n)}function baseTimes(t,e){for(var n=-1,r=Array(t);++n<t;)r[n]=e(n);return r}function arrayLikeKeys(t,e){var n=p(t)||isArguments(t)?baseTimes(t.length,String):[],r=n.length,a=!!r;for(var i in t)!e&&!c.call(t,i)||a&&("length"==i||isIndex(i,r))||n.push(i);return n}function assignValue(t,e,n){var r=t[e];c.call(t,e)&&eq(r,n)&&(void 0!==n||e in t)||(t[e]=n)}function baseKeys(t){if(!isPrototype(t))return l(t);var e=[];for(var n in Object(t))c.call(t,n)&&"constructor"!=n&&e.push(n);return e}function baseRest(t,e){return e=h(void 0===e?t.length-1:e,0),function(){for(var n=arguments,r=-1,a=h(n.length-e,0),i=Array(a);++r<a;)i[r]=n[e+r];r=-1;for(var o=Array(e+1);++r<e;)o[r]=n[r];return o[e]=i,apply(t,this,o)}}function copyObject(t,e,n,r){n||(n={});for(var a=-1,i=e.length;++a<i;){var o=e[a],u=r?r(n[o],t[o],o,n,t):void 0;assignValue(n,o,void 0===u?t[o]:u)}return n}function isIndex(t,e){return!!(e=null==e?n:e)&&("number"==typeof t||o.test(t))&&t>-1&&t%1==0&&t<e}function isIterateeCall(t,e,n){if(!isObject(n))return!1;var r=typeof e;return!!("number"==r?isArrayLike(n)&&isIndex(e,n.length):"string"==r&&e in n)&&eq(n[e],t)}function isPrototype(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||u)}function eq(t,e){return t===e||t!==t&&e!==e}function isArguments(t){return isArrayLikeObject(t)&&c.call(t,"callee")&&(!f.call(t,"callee")||s.call(t)==r)}function isArrayLike(t){return null!=t&&isLength(t.length)&&!isFunction(t)}function isArrayLikeObject(t){return isObjectLike(t)&&isArrayLike(t)}function isFunction(t){var e=isObject(t)?s.call(t):"";return e==a||e==i}function isLength(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=n}function isObject(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function isObjectLike(t){return!!t&&"object"==typeof t}function keys(t){return isArrayLike(t)?arrayLikeKeys(t):baseKeys(t)}var n=9007199254740991,r="[object Arguments]",a="[object Function]",i="[object GeneratorFunction]",o=/^(?:0|[1-9]\d*)$/,u=Object.prototype,c=u.hasOwnProperty,s=u.toString,f=u.propertyIsEnumerable,l=function(t,e){return function(n){return t(e(n))}}(Object.keys,Object),h=Math.max,d=!f.call({valueOf:1},"valueOf"),p=Array.isArray,b=function(t){return baseRest(function(e,n){var r=-1,a=n.length,i=a>1?n[a-1]:void 0,o=a>2?n[2]:void 0;for(i=t.length>3&&"function"==typeof i?(a--,i):void 0,o&&isIterateeCall(n[0],n[1],o)&&(i=a<3?void 0:i,a=1),e=Object(e);++r<a;){var u=n[r];u&&t(e,u,r,i)}return e})}(function(t,e){if(d||isPrototype(e)||isArrayLike(e))return void copyObject(e,keys(e),t);for(var n in e)c.call(e,n)&&assignValue(t,n,e[n])});t.exports=b},function(t,e,n){"use strict";var r;void 0!==(r=function(t){var e=(n(3),"highlight-filter"),r=function(t){return t.append("defs").append("filter").attr("id",e)},a=function(t){return t.append("feGaussianBlur").attr("stdDeviation",1).attr("result","coloredBlur"),e},i=function(t){t.attr("x","-30%").attr("y","-30%").attr("width","160%").attr("height","160%"),t.append("feGaussianBlur").attr("stdDeviation","0.9 0.9").attr("result","glow");var n=t.append("feMerge");return n.append("feMergeNode").attr("in","glow"),n.append("feMergeNode").attr("in","glow"),n.append("feMergeNode").attr("in","glow"),e},o=function(t){t.attr("x","-500%").attr("y","-500%").attr("width","1800%").attr("height","1800%"),t.append("feColorMatrix").attr("type","matrix").attr("values","0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"),t.append("feGaussianBlur").attr("stdDeviation","1").attr("result","coloredBlur").attr("in","SourceGraphic");var n=t.append("feMerge");return n.append("feMergeNode").attr("in","coloredBlur"),n.append("feMergeNode").attr("in","SourceGraphic"),e};return{createFilterContainer:r,createGausianBlur:a,createWhiteGlow:function(t){t.attr("x","-5000%").attr("y","-5000%").attr("width","10000%").attr("height","10000%"),t.append("feFlood").attr("result","flood").attr("flood-color","#ffffff").attr("flood-opacity","1"),t.append("feComposite").attr("result","mask").attr("in2","SourceGraphic").attr("operator","in").attr("in","flood"),t.append("feMorphology").attr("result","dilated").attr("operator","dilate").attr("radius","2").attr("in","mask"),t.append("feGaussianBlur").attr("result","blurred").attr("stdDeviation","5").attr("in","dilated");var n=t.append("feMerge");return n.append("feMergeNode").attr("in","blurred"),n.append("feMergeNode").attr("in","SourceGraphic"),e},createGlow:i,createGlowWithMatrix:o}}.call(e,n,e,t))&&(t.exports=r)},,,,,,,,,,function(t,e,n){"use strict";function _toConsumableArray(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function _defineProperty(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var r,a=function(){function sliceIterator(t,e){var n=[],r=!0,a=!1,i=void 0;try{for(var o,u=t[Symbol.iterator]();!(r=(o=u.next()).done)&&(n.push(o.value),!e||n.length!==e);r=!0);}catch(t){a=!0,i=t}finally{try{!r&&u.return&&u.return()}finally{if(a)throw i}}return n}return function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return sliceIterator(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();void 0!==(r=function(t){var e=n(5),r=n(258),i=n(114),o=n(66),u=n(65),c=n(215),s=n(262),f=n(3),l=(n(91),n(40)),h=n(292),d=n(253),p=d.exportChart,b=n(89),v=n(290),m=v.getXAxisSettings,y=(v.getLocaleDateFormatter,n(90)),g=y.axisTimeCombinations,_=n(291),x=_.formatIntegerValue,w=_.formatDecimalValue,O=n(293),M=O.createFilterContainer,C=O.createGlowWithMatrix,j=n(288),T=j.isInteger,k=j.addDays,S=j.diffDays,N=n(238),A=N.bar,E=function(t){return t.filter(function(t,e,n){return n.indexOf(t)===e})};return function(){function exports(e){e.each(function(e){gt=n-t.left-t.right,_t=d-t.top-t.bottom,xt=cleanData(e),wt=getDataByDate(xt),buildLayers(),buildScales(),buildSVG(this),buildAxis(),drawAxis(),drawStackedAreas(),shouldShowTooltip()&&(drawHoverOverlay(),drawVerticalMarker(),addMouseEvents())})}function addGlowFilter(t){Y||(Y=M(yt.select(".metadata-group")),q=C(Y)),f.select(t).style("stroke-width",G).style("r",V).style("stroke-opacity",X).attr("filter","url(#"+q+")")}function addMouseEvents(){yt.on("mouseover",function(t){handleMouseOver(this,t)}).on("mouseout",function(t){handleMouseOut(this,t)}).on("mousemove",function(t){handleMouseMove(this)})}function getFormattedValue(t){return(T(t)?x:w)(t)}function buildAxis(){var t=j.domain()[1]-j.domain()[0],e=t<I-1?t:I,a=void 0,i=void 0;if("custom"===J&&"string"==typeof et)a={tick:tt,format:l.timeFormat(et)},i=null;else{var o=m(wt,n,J,nt);a=o.minor,i=o.major,O=r.axisBottom(y).ticks(i.tick).tickSize(0,0).tickFormat(i.format)}_=r.axisBottom(y).ticks(a.tick).tickSize(10,0).tickPadding(L).tickFormat(a.format),N=r.axisRight(j).ticks(e).tickSize([0]).tickPadding(L).tickFormat(getFormattedValue),drawGridLines(a.tick,e)}function buildContainerGroups(){var e=yt.append("g").classed("container-group",!0).attr("transform","translate("+t.left+","+t.top+")");e.append("g").classed("x-axis-group",!0).append("g").classed("x axis",!0),e.selectAll(".x-axis-group").append("g").classed("month-axis",!0),e.append("g").classed("y-axis-group axis",!0),e.append("g").classed("grid-lines-group",!0),e.append("g").classed("chart-group",!0),e.append("g").classed("metadata-group",!0)}function buildLayers(){Ot=wt.map(function(t){return h({},t,t.values)}).map(function(t){return Object.keys(t).forEach(function(e){var n=t[e];n&&n.name&&(t[n.name]=n.value)}),h({},t,{date:new Date(t.key)})}),Mt=wt.map(function(t){return h({},t,t.values)}).map(function(t){return Object.keys(t).forEach(function(e){var n=t[e];n&&n.name&&(t[n.name]=0)}),h({},t,{date:new Date(t.key)})});var t=E(xt.map(It)).reduce(function(t,e){return h({},t,_defineProperty({},e,0))},{}),e=xt.reduce(function(t,e){return h({},t,_defineProperty({},e.name,t[e.name]+=e.value))},t);K=Q||formatOrder(e);var n=s.stack().keys(K).order(s.stackOrderNone).offset(s.stackOffsetNone);ot=n(Mt),at=n(Ot)}function formatOrder(t){var e=Object.keys(t).sort(function(e,n){return t[e]>t[n]?-1:t[e]===t[n]?0:1}),n=e.indexOf("Other");if(n>=0){var r=e.splice(n,1);e=e.concat(r)}return e}function buildScales(){var t=Ft?Dt.maxY:getMaxValueByDate();y=c.scaleTime().domain(e.extent(wt,function(t){return t.date})).rangeRound([0,gt]),j=c.scaleLinear().domain([0,t]).rangeRound([_t,0]).nice(),$=K.reduce(function(t,e,n){return h({},t,_defineProperty({},e,U[n]))},{})}function buildSVG(t){yt||(yt=f.select(t).append("svg").classed("britechart stacked-area",!0),buildContainerGroups()),yt.attr("width",n).attr("height",d)}function createFakeData(){var t=S(Dt.minDate,Dt.maxDate),e=Array.apply(null,Array(t));return Ft=!0,[].concat(_toConsumableArray(e.map(function(t,e){var n;return n={},_defineProperty(n,Nt,k(Dt.minDate,e)),_defineProperty(n,At,0),_defineProperty(n,Et,"1"),n})),_toConsumableArray(e.map(function(t,e){var n;return n={},_defineProperty(n,Nt,k(Dt.minDate,e)),_defineProperty(n,At,0),_defineProperty(n,Et,"2"),n})))}function cleanData(t){return t=0===t.length?createFakeData():t,t.reduce(function(t,e){return e.date=new Date(e[Nt]),e.value=+e[At],[].concat(_toConsumableArray(t),[e])},[])}function drawAxis(){yt.select(".x-axis-group .axis.x").attr("transform","translate( 0, "+_t+" )").call(_),"custom"!==J&&yt.select(".x-axis-group .month-axis").attr("transform","translate(0, "+(_t+F)+")").call(O),yt.select(".y-axis-group.axis").attr("transform","translate( "+-St.left+", 0)").call(N).call(adjustYTickLabels)}function adjustYTickLabels(t){t.selectAll(".tick text").attr("transform","translate("+R+", "+P+")")}function drawGridLines(e,n){yt.select(".grid-lines-group").selectAll("line").remove(),"horizontal"!==Tt&&"full"!==Tt||(jt=yt.select(".grid-lines-group").selectAll("line.horizontal-grid-line").data(j.ticks(n)).enter().append("line").attr("class","horizontal-grid-line").attr("x1",-St.left-30).attr("x2",gt).attr("y1",function(t){return j(t)}).attr("y2",function(t){return j(t)})),"vertical"!==Tt&&"full"!==Tt||(Ct=yt.select(".grid-lines-group").selectAll("line.vertical-grid-line").data(y.ticks(e)).enter().append("line").attr("class","vertical-grid-line").attr("y1",0).attr("y2",_t).attr("x1",function(t){return y(t)}).attr("x2",function(t){return y(t)})),rt=yt.select(".grid-lines-group").selectAll("line.extended-x-line").data([0]).enter().append("line").attr("class","extended-x-line").attr("x1",-St.left-30).attr("x2",gt).attr("y1",d-t.bottom-t.top).attr("y2",d-t.bottom-t.top)}function drawHoverOverlay(){ft&&yt.selectAll(".overlay").remove(),ft=yt.select(".metadata-group").append("rect").attr("class","overlay").attr("y1",0).attr("y2",_t).attr("height",_t).attr("width",gt).attr("fill",lt).style("display","none")}function drawEmptyDataLine(){var t=s.line().x(function(t){return y(t.date)}).y(function(){return j(0)-1}),e=yt.select(".chart-group");e.append("path").attr("class","empty-data-line").attr("d",t(Ot)).style("stroke","url(#empty-data-line-gradient)"),e.append("linearGradient").attr("id","empty-data-line-gradient").attr("gradientUnits","userSpaceOnUse").attr("x1",0).attr("x2",y(xt[xt.length-1].date)).attr("y1",0).attr("y2",0).selectAll("stop").data([{offset:"0%",color:H[0]},{offset:"100%",color:H[1]}]).enter().append("stop").attr("offset",function(t){return t.offset}).attr("stop-color",function(t){return t.color})}function drawStackedAreas(){if(it&&(yt.selectAll(".layer-container").remove(),yt.selectAll(".layer").remove(),yt.selectAll(".area-outline").remove()),Ft)return void drawEmptyDataLine();ut=s.area().curve(s.curveMonotoneX).x(function(t){var e=t.data;return y(e.date)}).y0(function(t){return j(t[0])}).y1(function(t){return j(t[1])}),ct=s.line().curve(ut.curve()).x(function(t){var e=t.data;return y(e.date)}).y(function(t){return j(t[1])}),bt?(it=yt.select(".chart-group").selectAll(".layer").data(ot,It).enter().append("g").classed("layer-container",!0),it.append("path").attr("class","layer").attr("d",ut).style("opacity",Z).style("fill",function(t){var e=t.key;return $[e]}),it.append("path").attr("class","area-outline").attr("d",ct).style("stroke",function(t){var e=t.key;return $[e]}),yt.select(".chart-group").selectAll(".layer").data(at).transition().delay(function(t,e){return st[e]}).duration(mt).ease(vt).attr("d",ut).style("opacity",Z).style("fill",function(t){var e=t.key;return $[e]}),yt.select(".chart-group").selectAll(".area-outline").data(at).transition().delay(function(t,e){return st[e]}).duration(mt).ease(vt).attr("d",ct)):(it=yt.select(".chart-group").selectAll(".layer").data(at).enter().append("g").classed("layer-container",!0),it.append("path").attr("class","layer").attr("d",ut).style("opacity",Z).style("fill",function(t){var e=t.key;return $[e]}),it.append("path").attr("class","area-outline").attr("d",ct).style("stroke",function(t){var e=t.key;return $[e]}),yt.select(".chart-group").selectAll(".layer").attr("d",ut).style("opacity",Z).style("fill",function(t){var e=t.key;return $[e]}),yt.select(".chart-group").selectAll(".area-outline").attr("class","area-outline").attr("d",ct).style("stroke",function(t){var e=t.key;return $[e]})),it.exit().transition().style("opacity",0).remove()}function drawVerticalMarker(){ht&&yt.selectAll(".vertical-marker-container").remove(),ht=yt.select(".metadata-group").append("g").attr("class","vertical-marker-container").attr("transform","translate(9999, 0)"),dt=ht.selectAll("path").data([{x1:0,y1:0,x2:0,y2:0}]).enter().append("line").classed("vertical-marker",!0).attr("x1",0).attr("y1",_t).attr("x2",0).attr("y2",0)}function cleanDataPointHighlights(){ht.selectAll(".circle-container").remove()}function getDataByDate(t){return i.nest().key(Pt).entries(t.sort(function(t,e){return t.date-e.date})).map(function(t){return h({},t,{date:new Date(t.key)})})}function getMaxValueByDate(){var t=E(xt.map(function(t){return t.name}));return e.max(Ot,function(n){var r=t.map(function(t){return n[t]});return e.sum(r)})}function getNearestDataPoint(t){var e=wt.filter(function(e){var n=e.date;return Math.abs(y(n)-t)<=pt});if(e.length)return e[0]}function setEpsilon(){var t=wt.map(function(t){return t.date});pt=(y(t[1])-y(t[0]))/2}function handleMouseMove(e){pt||setEpsilon();var n=f.mouse(e),r=a(n,2),i=r[0],o=r[1],u=getNearestDataPoint(i-t.left),c=void 0;u&&(c=y(new Date(u.key)),moveVerticalMarker(c),highlightDataPoints(u),Rt.call("customMouseMove",e,u,$,c,o))}function handleMouseOut(t,e){ft.style("display","none"),dt.classed("bc-is-active",!1),ht.attr("transform","translate(9999, 0)"),Rt.call("customMouseOut",t,e,f.mouse(t))}function handleMouseOver(t,e){ft.style("display","block"),dt.classed("bc-is-active",!0),Rt.call("customMouseOver",t,e,f.mouse(t))}function handleHighlightClick(t,e){Rt.call("customDataEntryClick",t,e,f.mouse(t))}function highlightDataPoints(t){var e=t.values,n=0;cleanDataPointHighlights(),e=e.filter(function(t){return!!t}).sort(function(t,e){return K.indexOf(t.name)>K.indexOf(e.name)}),e.forEach(function(t,r){var a=ht.append("g").classed("circle-container",!0).append("circle").classed("data-point-highlighter",!0).attr("cx",B).attr("cy",0).attr("r",z).style("stroke-width",W).style("stroke",$[t.name]).style("cursor","pointer").on("click",function(){addGlowFilter(this),handleHighlightClick(this,t)}).on("mouseout",function(){removeFilter(this)});n+=e[r][At],a.attr("transform","translate( "+-B+", "+j(n)+" )")})}function moveVerticalMarker(t){ht.attr("transform","translate("+t+",0)")}function removeFilter(t){f.select(t).attr("filter","none")}function shouldShowTooltip(){return n>kt&&!Ft}var t={top:70,right:30,bottom:60,left:70},n=960,d=500,v=A,y=void 0,_=void 0,O=void 0,j=void 0,N=void 0,D=null,F=30,I=5,P=-8,R=-20,L=5,U=b.colorSchemas.britecharts,H=b.colorGradients.greenBlue,Y=null,q=null,B=12,z=5,W=1.2,V=z+2,G=5,X=.6,Z=.24,$=void 0,K=void 0,Q=void 0,J=null,tt=null,et=null,nt=void 0,rt=void 0,at=void 0,it=void 0,ot=void 0,ut=void 0,ct=void 0,st=e.range(20,160,20),ft=void 0,lt="rgba(0, 0, 0, 0)",ht=void 0,dt=void 0,pt=void 0,bt=!1,vt=u.easeQuadInOut,mt=1e3,yt=void 0,gt=void 0,_t=void 0,xt=void 0,wt=void 0,Ot=void 0,Mt=void 0,Ct=void 0,jt=void 0,Tt=null,kt=480,St={top:0,left:15,bottom:0,right:0},Nt="date",At="value",Et="name",Dt={minDate:new Date((new Date).setDate((new Date).getDate()-30)),maxDate:new Date,maxY:500},Ft=!1,It=function(t){return t.name},Pt=function(t){return t.date},Rt=o.dispatch("customMouseOver","customMouseOut","customMouseMove","customDataEntryClick");return exports.areaOpacity=function(t){return arguments.length?(Z=t,this):Z},exports.aspectRatio=function(t){return arguments.length?(D=t,this):D},exports.colorSchema=function(t){return arguments.length?(U=t,this):U},exports.dateLabel=function(t){return arguments.length?(Nt=t,this):Nt},exports.emptyDataConfig=function(t){return arguments.length?(Dt=t,this):Dt},exports.grid=function(t){return arguments.length?(Tt=t,this):Tt},exports.height=function(t){return arguments.length?(D&&(n=Math.ceil(t/D)),d=t,this):d},exports.isAnimated=function(t){return arguments.length?(bt=t,this):bt},exports.keyLabel=function(t){return arguments.length?(Et=t,this):Et},exports.margin=function(e){return arguments.length?(t=e,this):t},exports.tooltipThreshold=function(t){return arguments.length?(kt=t,this):kt},exports.topicsOrder=function(t){return arguments.length?(Q=t,this):Q},exports.loadingState=function(t){return arguments.length?(v=t,this):v},exports.locale=function(t){return arguments.length?(nt=t,this):nt},exports.exportChart=function(t,e){p.call(exports,yt,t,e)},exports.on=function(){var t=Rt.on.apply(Rt,arguments);return t===Rt?exports:t},exports.axisTimeCombinations=g,exports.valueLabel=function(t){return arguments.length?(At=t,this):At},exports.width=function(t){return arguments.length?(D&&(d=Math.ceil(t*D)),n=t,this):n},exports.xAxisCustomFormat=function(t){return arguments.length?(et=t,this):et},exports.xAxisFormat=function(t){return arguments.length?(J=t,this):J},exports.xTicks=function(t){return arguments.length?(tt=t,this):tt},exports.yTicks=function(t){return arguments.length?(I=t,this):I},exports}}.call(e,n,e,t))&&(t.exports=r)}])})},function(t,e,n){"use strict";function _interopRequireDefault(t){return t&&t.__esModule?t:{default:t}}function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},a=function(){function defineProperties(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(t,e,n){return e&&defineProperties(t.prototype,e),n&&defineProperties(t,n),t}}(),i=n(4),o=_interopRequireDefault(i),u=n(6),c=_interopRequireDefault(u),s=n(108),f=_interopRequireDefault(s),l=".metadata-group .vertical-marker-container",h=function(t){function Tooltip(t){_classCallCheck(this,Tooltip);var e=_possibleConstructorReturn(this,(Tooltip.__proto__||Object.getPrototypeOf(Tooltip)).call(this,t));return e.state={isActive:!1,x:0,y:0,dataPoint:null,topicColorMap:null},e._createTooltip=function(){var t=e._rootNode.querySelector(l);t&&(e._chart=e.props.chart.create(t,e._getChartConfiguration()))},t.render&&(e.childChart=t.render({data:t.data,createTooltip:e._createTooltip,customMouseMove:e._handleMouseMove.bind(e),customMouseOut:e._handleMouseOut.bind(e),customMouseOver:e._handleMouseOver.bind(e)})),e}return _inherits(Tooltip,t),a(Tooltip,[{key:"componentDidMount",value:function(){this._createTooltip()}},{key:"componentDidUpdate",value:function(){var t=this._rootNode.querySelector(l);t&&(this._chart=this.props.chart.update(t,this._getChartConfiguration(),this.state,this._chart))}},{key:"componentWillUnmount",value:function(){this.props.chart.destroy(this._rootNode)}},{key:"_getChartConfiguration",value:function(){var t=r({},this.props);return delete t.data,delete t.chart,delete t.render,t}},{key:"_handleMouseMove",value:function(t,e,n,a){this.setState(function(i){return r({},i,{dataPoint:t,topicColorMap:e,x:n,y:a})});var i=this.props.customMouseMove;i&&i(t,e,n,a)}},{key:"_handleMouseOut",value:function(){this.setState(function(t){return r({},t,{isActive:!1})});var t=this.props.customMouseOut;t&&t()}},{key:"_handleMouseOver",value:function(){this.setState(function(t){return r({},t,{isActive:!0})});var t=this.props.customMouseOver;t&&t()}},{key:"_setRef",value:function(t){this._rootNode=t}},{key:"render",value:function(){return o.default.createElement("div",{className:"tooltip-chart-wrapper",ref:this._setRef.bind(this)},this.childChart)}}]),Tooltip}(o.default.Component);h.propTypes={dateCustomFormat:c.default.string,dateFormat:c.default.string,dateLabel:c.default.string,locale:c.default.string,nameLabel:c.default.string,shouldShowDateInTitle:c.default.bool,title:c.default.string,tooltipOffset:c.default.shape({x:c.default.number,y:c.default.number}),topicLabel:c.default.string,topicsOrder:c.default.arrayOf(c.default.string),valueFormat:c.default.string,valueLabel:c.default.string,chart:c.default.object},h.defaultProps={chart:f.default},e.default=h},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(109),a=function(t){return t&&t.__esModule?t:{default:t}}(r),i=n(8),o=n(9),u=n(10),c={};c.create=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=(0,i.select)(t),r=(0,a.default)();r.topicLabel("values"),(0,o.validateContainer)(n),(0,o.validateConfiguration)(r,e);var c=(0,u.applyConfiguration)(r,e);return n.datum([]).call(c),c},c.update=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=arguments[3],a=(0,i.select)(t);(0,o.validateContainer)(a),(0,o.validateConfiguration)(r,e);var c=(0,u.applyConfiguration)(r,e);return a.call(c),n.isActive?c.show():c.hide(),n.dataPoint&&n.topicColorMap&&"number"==typeof n.x&&c.update(n.dataPoint,n.topicColorMap,n.x,n.y),c},c.destroy=function(){},e.default=c},function(t,e,n){!function(e,n){t.exports=n()}(0,function(){return function(t){function __webpack_require__(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,__webpack_require__),r.l=!0,r.exports}var e={};return __webpack_require__.m=t,__webpack_require__.c=e,__webpack_require__.d=function(t,e,n){__webpack_require__.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},__webpack_require__.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return __webpack_require__.d(e,"a",e),e},__webpack_require__.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=300)}([function(t,e,n){"use strict";function newInterval(t,e,n,i){function interval(e){return t(e=new Date(+e)),e}return interval.floor=interval,interval.ceil=function(n){return t(n=new Date(n-1)),e(n,1),t(n),n},interval.round=function(t){var e=interval(t),n=interval.ceil(t);return t-e<n-t?e:n},interval.offset=function(t,n){return e(t=new Date(+t),null==n?1:Math.floor(n)),t},interval.range=function(n,r,a){var i=[];if(n=interval.ceil(n),a=null==a?1:Math.floor(a),!(n<r&&a>0))return i;do{i.push(new Date(+n))}while(e(n,a),t(n),n<r);return i},interval.filter=function(n){return newInterval(function(e){if(e>=e)for(;t(e),!n(e);)e.setTime(e-1)},function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;e(t,-1),!n(t););else for(;--r>=0;)for(;e(t,1),!n(t););})},n&&(interval.count=function(e,i){return r.setTime(+e),a.setTime(+i),t(r),t(a),Math.floor(n(r,a))},interval.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?interval.filter(i?function(e){return i(e)%t==0}:function(e){return interval.count(0,e)%t==0}):interval:null}),interval}e.a=newInterval;var r=new Date,a=new Date},function(t,e,n){"use strict";function Selection(t,e){this._groups=t,this._parents=e}function selection(){return new Selection([[document.documentElement]],E)}n.d(e,"c",function(){return E}),e.a=Selection;var r=n(128),a=n(129),i=n(130),o=n(131),u=n(55),c=n(133),s=n(134),f=n(135),l=n(136),h=n(137),d=n(138),p=n(139),b=n(140),v=n(141),m=n(142),y=n(143),g=n(57),_=n(144),x=n(145),w=n(146),O=n(147),M=n(148),C=n(149),j=n(150),T=n(151),k=n(152),S=n(153),N=n(29),A=n(154),E=[null];Selection.prototype=selection.prototype={constructor:Selection,select:r.a,selectAll:a.a,filter:i.a,data:o.a,enter:u.b,exit:c.a,merge:s.a,order:f.a,sort:l.a,call:h.a,nodes:d.a,node:p.a,size:b.a,empty:v.a,each:m.a,attr:y.a,style:g.a,property:_.a,classed:x.a,text:w.a,html:O.a,raise:M.a,lower:C.a,append:j.a,insert:T.a,remove:k.a,datum:S.a,on:N.b,dispatch:A.a},e.b=selection},function(t,e,n){"use strict";function init(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>u)throw new Error("too late");return n}function set(t,e){var n=t.__transition;if(!n||!(n=n[e])||n.state>s)throw new Error("too late");return n}function get(t,e){var n=t.__transition;if(!n||!(n=n[e]))throw new Error("too late");return n}function create(t,e,n){function schedule(t){n.state=c,n.timer.restart(start,n.delay,n.time),n.delay<=t&&start(t-n.delay)}function start(o){var u,h,p,b;if(n.state!==c)return stop();for(u in i)if(b=i[u],b.name===n.name){if(b.state===f)return Object(a.b)(start);b.state===l?(b.state=d,b.timer.stop(),b.on.call("interrupt",t,t.__data__,b.index,b.group),delete i[u]):+u<e&&(b.state=d,b.timer.stop(),delete i[u])}if(Object(a.b)(function(){n.state===f&&(n.state=l,n.timer.restart(tick,n.delay,n.time),tick(o))}),n.state=s,n.on.call("start",t,t.__data__,n.index,n.group),n.state===s){for(n.state=f,r=new Array(p=n.tween.length),u=0,h=-1;u<p;++u)(b=n.tween[u].value.call(t,t.__data__,n.index,n.group))&&(r[++h]=b);r.length=h+1}}function tick(e){for(var a=e<n.duration?n.ease.call(null,e/n.duration):(n.timer.restart(stop),n.state=h,1),i=-1,o=r.length;++i<o;)r[i].call(null,a);n.state===h&&(n.on.call("end",t,t.__data__,n.index,n.group),stop())}function stop(){n.state=d,n.timer.stop(),delete i[e];for(var r in i)return;delete t.__transition}var r,i=t.__transition;i[e]=n,n.timer=Object(a.c)(schedule,0,n.time)}n.d(e,"c",function(){return c}),n.d(e,"d",function(){return s}),n.d(e,"b",function(){return h}),n.d(e,"a",function(){return d}),e.g=init,e.h=set,e.f=get;var r=n(66),a=n(59),i=Object(r.dispatch)("start","end","interrupt"),o=[],u=0,c=1,s=2,f=3,l=4,h=5,d=6;e.e=function(t,e,n,r,a,c){var s=t.__transition;if(s){if(n in s)return}else t.__transition={};create(t,n,{name:e,index:r,group:a,on:i,tween:o,time:c.time,delay:c.delay,duration:c.duration,ease:c.ease,timer:null,state:u})}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(25);n.d(e,"creator",function(){return r.a});var a=n(125);n.d(e,"local",function(){return a.a});var i=n(53);n.d(e,"matcher",function(){return i.a});var o=n(126);n.d(e,"mouse",function(){return o.a});var u=n(26);n.d(e,"namespace",function(){return u.a});var c=n(27);n.d(e,"namespaces",function(){return c.a});var s=n(127);n.d(e,"select",function(){return s.a});var f=n(155);n.d(e,"selectAll",function(){return f.a});var l=n(1);n.d(e,"selection",function(){return l.b});var h=n(31);n.d(e,"selector",function(){return h.a});var d=n(54);n.d(e,"selectorAll",function(){return d.a});var p=n(57);n.d(e,"style",function(){return p.b});var b=n(156);n.d(e,"touch",function(){return b.a});var v=n(157);n.d(e,"touches",function(){return v.a});var m=n(32);n.d(e,"window",function(){return m.a});var y=n(29);n.d(e,"event",function(){return y.c}),n.d(e,"customEvent",function(){return y.a})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(19);n.d(e,"color",function(){return r.e}),n.d(e,"rgb",function(){return r.g}),n.d(e,"hsl",function(){return r.f});var a=n(102);n.d(e,"lab",function(){return a.a}),n.d(e,"hcl",function(){return a.b});var i=n(103);n.d(e,"cubehelix",function(){return i.a})},,function(t,e,n){"use strict";n.d(e,"d",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i}),n.d(e,"a",function(){return o}),n.d(e,"e",function(){return u});var r=1e3,a=6e4,i=36e5,o=864e5,u=6048e5},function(t,e,n){"use strict";function Transition(t,e,n,r){this._groups=t,this._parents=e,this._name=n,this._id=r}function transition(t){return Object(r.selection)().transition(t)}function newId(){return++x}e.a=Transition,e.b=transition,e.c=newId;var r=n(3),a=n(163),i=n(164),o=n(165),u=n(166),c=n(167),s=n(168),f=n(169),l=n(170),h=n(171),d=n(172),p=n(173),b=n(174),v=n(175),m=n(176),y=n(177),g=n(178),_=n(17),x=0,w=r.selection.prototype;Transition.prototype=transition.prototype={constructor:Transition,select:d.a,selectAll:p.a,filter:s.a,merge:f.a,selection:b.a,transition:g.a,call:w.call,nodes:w.nodes,node:w.node,size:w.size,empty:w.empty,each:w.each,on:l.a,attr:a.a,attrTween:i.a,style:v.a,styleTween:m.a,text:y.a,remove:h.a,tween:_.a,delay:o.a,duration:u.a,ease:c.a}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(23);n.d(e,"interpolate",function(){return r.a});var a=n(49);n.d(e,"interpolateArray",function(){return a.a});var i=n(24);n.d(e,"interpolateBasis",function(){return i.b});var o=n(47);n.d(e,"interpolateBasisClosed",function(){return o.a});var u=n(50);n.d(e,"interpolateDate",function(){return u.a});var c=n(15);n.d(e,"interpolateNumber",function(){return c.a});var s=n(51);n.d(e,"interpolateObject",function(){return s.a});var f=n(115);n.d(e,"interpolateRound",function(){return f.a});var l=n(52);n.d(e,"interpolateString",function(){return l.a});var h=n(116);n.d(e,"interpolateTransformCss",function(){return h.a}),n.d(e,"interpolateTransformSvg",function(){return h.b});var d=n(119);n.d(e,"interpolateZoom",function(){return d.a});var p=n(46);n.d(e,"interpolateRgb",function(){return p.a}),n.d(e,"interpolateRgbBasis",function(){return p.b}),n.d(e,"interpolateRgbBasisClosed",function(){return p.c});var b=n(120);n.d(e,"interpolateHsl",function(){return b.a}),n.d(e,"interpolateHslLong",function(){return b.b});var v=n(121);n.d(e,"interpolateLab",function(){return v.a});var m=n(122);n.d(e,"interpolateHcl",function(){return m.a}),n.d(e,"interpolateHclLong",function(){return m.b});var y=n(123);n.d(e,"interpolateCubehelix",function(){return y.b}),n.d(e,"interpolateCubehelixLong",function(){return y.a});var g=n(124);n.d(e,"quantize",function(){return g.a})},,,function(t,e,n){"use strict";function linear(t,e){return function(n){return t+n*e}}function exponential(t,e,n){return t=Math.pow(t,n),e=Math.pow(e,n)-t,n=1/n,function(r){return Math.pow(t+r*e,n)}}function hue(t,e){var n=e-t;return n?linear(t,n>180||n<-180?n-360*Math.round(n/360):n):Object(r.a)(isNaN(t)?e:t)}function gamma(t){return 1==(t=+t)?nogamma:function(e,n){return n-e?exponential(e,n,t):Object(r.a)(isNaN(e)?n:e)}}function nogamma(t,e){var n=e-t;return n?linear(t,n):Object(r.a)(isNaN(t)?e:t)}e.c=hue,e.b=gamma,e.a=nogamma;var r=n(48)},,function(t,e,n){"use strict";var r=n(22);e.a=function(t){return t=Object(r.a)(Math.abs(t)),t?t[1]:NaN}},,function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return t+e*n}}},,function(t,e,n){"use strict";function tweenRemove(t,e){var n,a;return function(){var i=Object(r.h)(this,t),o=i.tween;if(o!==n){a=n=o;for(var u=0,c=a.length;u<c;++u)if(a[u].name===e){a=a.slice(),a.splice(u,1);break}}i.tween=a}}function tweenFunction(t,e,n){var a,i;if("function"!=typeof n)throw new Error;return function(){var o=Object(r.h)(this,t),u=o.tween;if(u!==a){i=(a=u).slice();for(var c={name:e,value:n},s=0,f=i.length;s<f;++s)if(i[s].name===e){i[s]=c;break}s===f&&i.push(c)}o.tween=i}}function tweenValue(t,e,n){var a=t._id;return t.each(function(){var t=Object(r.h)(this,a);(t.value||(t.value={}))[e]=n.apply(this,arguments)}),function(t){return Object(r.f)(t,a).value[e]}}e.b=tweenValue;var r=n(2);e.a=function(t,e){var n=this._id;if(t+="",arguments.length<2){for(var a,i=Object(r.f)(this.node(),n).tween,o=0,u=i.length;o<u;++o)if((a=i[o]).name===t)return a.value;return null}return this.each((null==e?tweenRemove:tweenFunction)(n,t,e))}},,function(t,e,n){"use strict";function Color(){}function color(t){var e;return t=(t+"").trim().toLowerCase(),(e=s.exec(t))?(e=parseInt(e[1],16),new Rgb(e>>8&15|e>>4&240,e>>4&15|240&e,(15&e)<<4|15&e,1)):(e=f.exec(t))?rgbn(parseInt(e[1],16)):(e=l.exec(t))?new Rgb(e[1],e[2],e[3],1):(e=h.exec(t))?new Rgb(255*e[1]/100,255*e[2]/100,255*e[3]/100,1):(e=d.exec(t))?rgba(e[1],e[2],e[3],e[4]):(e=p.exec(t))?rgba(255*e[1]/100,255*e[2]/100,255*e[3]/100,e[4]):(e=b.exec(t))?hsla(e[1],e[2]/100,e[3]/100,1):(e=v.exec(t))?hsla(e[1],e[2]/100,e[3]/100,e[4]):m.hasOwnProperty(t)?rgbn(m[t]):"transparent"===t?new Rgb(NaN,NaN,NaN,0):null}function rgbn(t){return new Rgb(t>>16&255,t>>8&255,255&t,1)}function rgba(t,e,n,r){return r<=0&&(t=e=n=NaN),new Rgb(t,e,n,r)}function rgbConvert(t){return t instanceof Color||(t=color(t)),t?(t=t.rgb(),new Rgb(t.r,t.g,t.b,t.opacity)):new Rgb}function rgb(t,e,n,r){return 1===arguments.length?rgbConvert(t):new Rgb(t,e,n,null==r?1:r)}function Rgb(t,e,n,r){this.r=+t,this.g=+e,this.b=+n,this.opacity=+r}function hsla(t,e,n,r){return r<=0?t=e=n=NaN:n<=0||n>=1?t=e=NaN:e<=0&&(t=NaN),new Hsl(t,e,n,r)}function hslConvert(t){if(t instanceof Hsl)return new Hsl(t.h,t.s,t.l,t.opacity);if(t instanceof Color||(t=color(t)),!t)return new Hsl;if(t instanceof Hsl)return t;t=t.rgb();var e=t.r/255,n=t.g/255,r=t.b/255,a=Math.min(e,n,r),i=Math.max(e,n,r),o=NaN,u=i-a,c=(i+a)/2;return u?(o=e===i?(n-r)/u+6*(n<r):n===i?(r-e)/u+2:(e-n)/u+4,u/=c<.5?i+a:2-i-a,o*=60):u=c>0&&c<1?0:o,new Hsl(o,u,c,t.opacity)}function hsl(t,e,n,r){return 1===arguments.length?hslConvert(t):new Hsl(t,e,n,null==r?1:r)}function Hsl(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}function hsl2rgb(t,e,n){return 255*(t<60?e+(n-e)*t/60:t<180?n:t<240?e+(n-e)*(240-t)/60:e)}e.a=Color,n.d(e,"d",function(){return a}),n.d(e,"c",function(){return i}),e.e=color,e.h=rgbConvert,e.g=rgb,e.b=Rgb,e.f=hsl;var r=n(20),a=.7,i=1/a,o="\\s*([+-]?\\d+)\\s*",u="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",s=/^#([0-9a-f]{3})$/,f=/^#([0-9a-f]{6})$/,l=new RegExp("^rgb\\("+[o,o,o]+"\\)$"),h=new RegExp("^rgb\\("+[c,c,c]+"\\)$"),d=new RegExp("^rgba\\("+[o,o,o,u]+"\\)$"),p=new RegExp("^rgba\\("+[c,c,c,u]+"\\)$"),b=new RegExp("^hsl\\("+[u,c,c]+"\\)$"),v=new RegExp("^hsla\\("+[u,c,c,u]+"\\)$"),m={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};Object(r.a)(Color,color,{displayable:function(){return this.rgb().displayable()},toString:function(){return this.rgb()+""}}),Object(r.a)(Rgb,rgb,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Rgb(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return 0<=this.r&&this.r<=255&&0<=this.g&&this.g<=255&&0<=this.b&&this.b<=255&&0<=this.opacity&&this.opacity<=1},toString:function(){var t=this.opacity;return t=isNaN(t)?1:Math.max(0,Math.min(1,t)),(1===t?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}})),Object(r.a)(Hsl,hsl,Object(r.b)(Color,{brighter:function(t){return t=null==t?i:Math.pow(i,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a:Math.pow(a,t),new Hsl(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),e=isNaN(t)||isNaN(this.s)?0:this.s,n=this.l,r=n+(n<.5?n:1-n)*e,a=2*n-r;return new Rgb(hsl2rgb(t>=240?t-240:t+120,a,r),hsl2rgb(t,a,r),hsl2rgb(t<120?t+240:t-120,a,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1}}))},function(t,e,n){"use strict";function extend(t,e){var n=Object.create(t.prototype);for(var r in e)n[r]=e[r];return n}e.b=extend,e.a=function(t,e,n){t.prototype=e.prototype=n,n.constructor=t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(105);n.d(e,"formatDefaultLocale",function(){return r.a}),n.d(e,"format",function(){return r.b}),n.d(e,"formatPrefix",function(){return r.c});var a=n(42);n.d(e,"formatLocale",function(){return a.a});var i=n(43);n.d(e,"formatSpecifier",function(){return i.a});var o=n(111);n.d(e,"precisionFixed",function(){return o.a});var u=n(112);n.d(e,"precisionPrefix",function(){return u.a});var c=n(113);n.d(e,"precisionRound",function(){return c.a})},function(t,e,n){"use strict";e.a=function(t,e){if((n=(t=e?t.toExponential(e-1):t.toExponential()).indexOf("e"))<0)return null;var n,r=t.slice(0,n);return[r.length>1?r[0]+r.slice(2):r,+t.slice(n+1)]}},function(t,e,n){"use strict";var r=n(4),a=n(46),i=n(49),o=n(50),u=n(15),c=n(51),s=n(52),f=n(48);e.a=function(t,e){var n,l=typeof e;return null==e||"boolean"===l?Object(f.a)(e):("number"===l?u.a:"string"===l?(n=Object(r.color)(e))?(e=n,a.a):s.a:e instanceof r.color?a.a:e instanceof Date?o.a:Array.isArray(e)?i.a:"function"!=typeof e.valueOf&&"function"!=typeof e.toString||isNaN(e)?c.a:u.a)(t,e)}},function(t,e,n){"use strict";function basis(t,e,n,r,a){var i=t*t,o=i*t;return((1-3*t+3*i-o)*e+(4-6*i+3*o)*n+(1+3*t+3*i-3*o)*r+o*a)/6}e.a=basis,e.b=function(t){var e=t.length-1;return function(n){var r=n<=0?n=0:n>=1?(n=1,e-1):Math.floor(n*e),a=t[r],i=t[r+1],o=r>0?t[r-1]:2*a-i,u=r<e-1?t[r+2]:2*i-a;return basis((n-r/e)*e,o,a,i,u)}}},function(t,e,n){"use strict";function creatorInherit(t){return function(){var e=this.ownerDocument,n=this.namespaceURI;return n===a.b&&e.documentElement.namespaceURI===a.b?e.createElement(t):e.createElementNS(n,t)}}function creatorFixed(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}var r=n(26),a=n(27);e.a=function(t){var e=Object(r.a)(t);return(e.local?creatorFixed:creatorInherit)(e)}},function(t,e,n){"use strict";var r=n(27);e.a=function(t){var e=t+="",n=e.indexOf(":");return n>=0&&"xmlns"!==(e=t.slice(0,n))&&(t=t.slice(n+1)),r.a.hasOwnProperty(e)?{space:r.a[e],local:t}:t}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r="http://www.w3.org/1999/xhtml";e.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,e,n){"use strict";var r=n(29);e.a=function(){for(var t,e=r.c;t=e.sourceEvent;)e=t;return e}},function(t,e,n){"use strict";function filterContextListener(t,e,n){return t=contextListener(t,e,n),function(e){var n=e.relatedTarget;n&&(n===this||8&n.compareDocumentPosition(this))||t.call(this,e)}}function contextListener(t,e,n){return function(r){var i=a;a=r;try{t.call(this,this.__data__,e,n)}finally{a=i}}}function parseTypenames(t){return t.trim().split(/^|\s+/).map(function(t){var e="",n=t.indexOf(".");return n>=0&&(e=t.slice(n+1),t=t.slice(0,n)),{type:t,name:e}})}function onRemove(t){return function(){var e=this.__on;if(e){for(var n,r=0,a=-1,i=e.length;r<i;++r)n=e[r],t.type&&n.type!==t.type||n.name!==t.name?e[++a]=n:this.removeEventListener(n.type,n.listener,n.capture);++a?e.length=a:delete this.__on}}}function onAdd(t,e,n){var a=r.hasOwnProperty(t.type)?filterContextListener:contextListener;return function(r,i,o){var u,c=this.__on,s=a(e,i,o);if(c)for(var f=0,l=c.length;f<l;++f)if((u=c[f]).type===t.type&&u.name===t.name)return this.removeEventListener(u.type,u.listener,u.capture),this.addEventListener(u.type,u.listener=s,u.capture=n),void(u.value=e);this.addEventListener(t.type,s,n),u={type:t.type,name:t.name,value:e,listener:s,capture:n},c?c.push(u):this.__on=[u]}}function customEvent(t,e,n,r){var i=a;t.sourceEvent=a,a=t;try{return e.apply(n,r)}finally{a=i}}n.d(e,"c",function(){return a}),e.a=customEvent;var r={},a=null;if("undefined"!=typeof document){"onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"})}e.b=function(t,e,n){var r,a,i=parseTypenames(t+""),o=i.length;{if(!(arguments.length<2)){for(u=e?onAdd:onRemove,null==n&&(n=!1),r=0;r<o;++r)this.each(u(i[r],e,n));return this}var u=this.node().__on;if(u)for(var c,s=0,f=u.length;s<f;++s)for(r=0,c=u[s];r<o;++r)if((a=i[r]).type===c.type&&a.name===c.name)return c.value}}},function(t,e,n){"use strict";e.a=function(t,e){var n=t.ownerSVGElement||t;if(n.createSVGPoint){var r=n.createSVGPoint();return r.x=e.clientX,r.y=e.clientY,r=r.matrixTransform(t.getScreenCTM().inverse()),[r.x,r.y]}var a=t.getBoundingClientRect();return[e.clientX-a.left-t.clientLeft,e.clientY-a.top-t.clientTop]}},function(t,e,n){"use strict";function none(){}e.a=function(t){return null==t?none:function(){return this.querySelector(t)}}},function(t,e,n){"use strict";e.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,e,n){"use strict";function now(){return f||(d(clearNow),f=h.now()+l)}function clearNow(){f=0}function Timer(){this._call=this._time=this._next=null}function timer(t,e,n){var r=new Timer;return r.restart(t,e,n),r}function timerFlush(){now(),++i;for(var t,e=r;e;)(t=f-e._time)>=0&&e._call.call(null,t),e=e._next;--i}function wake(){f=(s=h.now())+l,i=o=0;try{timerFlush()}finally{i=0,nap(),f=0}}function poke(){var t=h.now(),e=t-s;e>c&&(l-=e,s=t)}function nap(){for(var t,e,n=r,i=1/0;n;)n._call?(i>n._time&&(i=n._time),t=n,n=n._next):(e=n._next,n._next=null,n=t?t._next=e:r=e);a=t,sleep(i)}function sleep(t){if(!i){o&&(o=clearTimeout(o));var e=t-f;e>24?(t<1/0&&(o=setTimeout(wake,e)),u&&(u=clearInterval(u))):(u||(s=f,u=setInterval(poke,c)),i=1,d(wake))}}e.b=now,e.a=Timer,e.c=timer;var r,a,i=0,o=0,u=0,c=1e3,s=0,f=0,l=0,h="object"==typeof performance&&performance.now?performance:Date,d="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};Timer.prototype=timer.prototype={constructor:Timer,restart:function(t,e,n){if("function"!=typeof t)throw new TypeError("callback is not a function");n=(null==n?now():+n)+(null==e?0:+e),this._next||a===this||(a?a._next=this:r=this,a=this),this._call=t,this._time=n,sleep()},stop:function(){this._call&&(this._call=null,this._time=1/0,sleep())}}},,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(0);n.d(e,"timeInterval",function(){return r.a});var a=n(200);n.d(e,"timeMillisecond",function(){return a.a}),n.d(e,"timeMilliseconds",function(){return a.b}),n.d(e,"utcMillisecond",function(){return a.a}),n.d(e,"utcMilliseconds",function(){return a.b});var i=n(201);n.d(e,"timeSecond",function(){return i.a}),n.d(e,"timeSeconds",function(){return i.b}),n.d(e,"utcSecond",function(){return i.a}),n.d(e,"utcSeconds",function(){return i.b});var o=n(202);n.d(e,"timeMinute",function(){return o.a}),n.d(e,"timeMinutes",function(){return o.b});var u=n(203);n.d(e,"timeHour",function(){return u.a}),n.d(e,"timeHours",function(){return u.b});var c=n(204);n.d(e,"timeDay",function(){return c.b}),n.d(e,"timeDays",function(){return c.a});var s=n(205);n.d(e,"timeWeek",function(){return s.g}),n.d(e,"timeWeeks",function(){return s.h}),n.d(e,"timeSunday",function(){return s.g}),n.d(e,"timeSundays",function(){return s.h}),n.d(e,"timeMonday",function(){return s.c}),n.d(e,"timeMondays",function(){return s.d}),n.d(e,"timeTuesday",function(){return s.k}),n.d(e,"timeTuesdays",function(){return s.l}),n.d(e,"timeWednesday",function(){return s.m}),n.d(e,"timeWednesdays",function(){return s.n}),n.d(e,"timeThursday",function(){return s.i}),n.d(e,"timeThursdays",function(){return s.j}),n.d(e,"timeFriday",function(){return s.a}),n.d(e,"timeFridays",function(){return s.b}),n.d(e,"timeSaturday",function(){return s.e}),n.d(e,"timeSaturdays",function(){return s.f});var f=n(206);n.d(e,"timeMonth",function(){return f.a}),n.d(e,"timeMonths",function(){return f.b});var l=n(207);n.d(e,"timeYear",function(){return l.a}),n.d(e,"timeYears",function(){return l.b});var h=n(208);n.d(e,"utcMinute",function(){return h.a}),n.d(e,"utcMinutes",function(){return h.b});var d=n(209);n.d(e,"utcHour",function(){return d.a}),n.d(e,"utcHours",function(){return d.b});var p=n(210);n.d(e,"utcDay",function(){return p.a}),n.d(e,"utcDays",function(){return p.b});var b=n(211);n.d(e,"utcWeek",function(){return b.g}),n.d(e,"utcWeeks",function(){return b.h}),n.d(e,"utcSunday",function(){return b.g}),n.d(e,"utcSundays",function(){return b.h}),n.d(e,"utcMonday",function(){return b.c}),n.d(e,"utcMondays",function(){return b.d}),n.d(e,"utcTuesday",function(){return b.k}),n.d(e,"utcTuesdays",function(){return b.l}),n.d(e,"utcWednesday",function(){return b.m}),n.d(e,"utcWednesdays",function(){return b.n}),n.d(e,"utcThursday",function(){return b.i}),n.d(e,"utcThursdays",function(){return b.j}),n.d(e,"utcFriday",function(){return b.a}),n.d(e,"utcFridays",function(){return b.b}),n.d(e,"utcSaturday",function(){return b.e}),n.d(e,"utcSaturdays",function(){return b.f});var v=n(212);n.d(e,"utcMonth",function(){return v.a}),n.d(e,"utcMonths",function(){return v.b});var m=n(213);n.d(e,"utcYear",function(){return m.a}),n.d(e,"utcYears",function(){return m.b})},,function(t,e,n){"use strict";function defaultLocale(t){return r=Object(c.a)(t),a=r.format,i=r.parse,o=r.utcFormat,u=r.utcParse,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"d",function(){return o}),n.d(e,"e",function(){return u}),e.a=defaultLocale;var r,a,i,o,u,c=n(79);defaultLocale({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},,,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(37);n.d(e,"timeFormatDefaultLocale",function(){return r.a}),n.d(e,"timeFormat",function(){return r.b}),n.d(e,"timeParse",function(){return r.c}),n.d(e,"utcFormat",function(){return r.d}),n.d(e,"utcParse",function(){return r.e});var a=n(79);n.d(e,"timeFormatLocale",function(){return a.a});var i=n(80);n.d(e,"isoFormat",function(){return i.a});var o=n(214);n.d(e,"isoParse",function(){return o.a})},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"b",function(){return a});var r=Math.PI/180,a=180/Math.PI},function(t,e,n){"use strict";var r=n(13),a=n(106),i=n(107),o=n(43),u=n(44),c=n(45),s=n(110),f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];e.a=function(t){function newFormat(t){function format(t){var n,o,u,s=g,d=_;if("c"===y)d=x(t)+d,t="";else{t=+t;var O=t<0;if(t=x(Math.abs(t),m),O&&0==+t&&(O=!1),s=(O?"("===i?i:"-":"-"===i||"("===i?"":i)+s,d=d+("s"===y?f[8+c.b/3]:"")+(O&&"("===i?")":""),w)for(n=-1,o=t.length;++n<o;)if(48>(u=t.charCodeAt(n))||u>57){d=(46===u?l+t.slice(n+1):t.slice(n))+d,t=t.slice(0,n);break}}v&&!p&&(t=e(t,1/0));var M=s.length+t.length+d.length,C=M<b?new Array(b-M+1).join(r):"";switch(v&&p&&(t=e(C+t,C.length?b-d.length:1/0),C=""),a){case"<":t=s+t+d+C;break;case"=":t=s+C+t+d;break;case"^":t=C.slice(0,M=C.length>>1)+s+t+d+C.slice(M);break;default:t=C+s+t+d}return h(t)}t=Object(o.a)(t);var r=t.fill,a=t.align,i=t.sign,s=t.symbol,p=t.zero,b=t.width,v=t.comma,m=t.precision,y=t.type,g="$"===s?n[0]:"#"===s&&/[boxX]/.test(y)?"0"+y.toLowerCase():"",_="$"===s?n[1]:/[%p]/.test(y)?d:"",x=u.a[y],w=!y||/[defgprs%]/.test(y);return m=null==m?y?6:12:/[gprs]/.test(y)?Math.max(1,Math.min(21,m)):Math.max(0,Math.min(20,m)),format.toString=function(){return t+""},format}function formatPrefix(t,e){var n=newFormat((t=Object(o.a)(t),t.type="f",t)),a=3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3))),i=Math.pow(10,-a),u=f[8+a/3];return function(t){return n(i*t)+u}}var e=t.grouping&&t.thousands?Object(a.a)(t.grouping,t.thousands):s.a,n=t.currency,l=t.decimal,h=t.numerals?Object(i.a)(t.numerals):s.a,d=t.percent||"%";return{format:newFormat,formatPrefix:formatPrefix}}},function(t,e,n){"use strict";function formatSpecifier(t){return new FormatSpecifier(t)}function FormatSpecifier(t){if(!(e=a.exec(t)))throw new Error("invalid format: "+t);var e,n=e[1]||" ",i=e[2]||">",o=e[3]||"-",u=e[4]||"",c=!!e[5],s=e[6]&&+e[6],f=!!e[7],l=e[8]&&+e[8].slice(1),h=e[9]||"";"n"===h?(f=!0,h="g"):r.a[h]||(h=""),(c||"0"===n&&"="===i)&&(c=!0,n="0",i="="),this.fill=n,this.align=i,this.sign=o,this.symbol=u,this.zero=c,this.width=s,this.comma=f,this.precision=l,this.type=h}e.a=formatSpecifier;var r=n(44),a=/^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;formatSpecifier.prototype=FormatSpecifier.prototype,FormatSpecifier.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(null==this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(null==this.precision?"":"."+Math.max(0,0|this.precision))+this.type}},function(t,e,n){"use strict";var r=n(108),a=n(45),i=n(109);e.a={"":r.a,"%":function(t,e){return(100*t).toFixed(e)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,e){return t.toExponential(e)},f:function(t,e){return t.toFixed(e)},g:function(t,e){return t.toPrecision(e)},o:function(t){return Math.round(t).toString(8)},p:function(t,e){return Object(i.a)(100*t,e)},r:i.a,s:a.a,X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}}},function(t,e,n){"use strict";n.d(e,"b",function(){return r});var r,a=n(22);e.a=function(t,e){var n=Object(a.a)(t,e);if(!n)return t+"";var i=n[0],o=n[1],u=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return u===c?i:u>c?i+new Array(u-c+1).join("0"):u>0?i.slice(0,u)+"."+i.slice(u):"0."+new Array(1-u).join("0")+Object(a.a)(t,Math.max(0,e+u-1))[0]}},function(t,e,n){"use strict";function rgbSpline(t){return function(e){var n,a,i=e.length,o=new Array(i),u=new Array(i),c=new Array(i);for(n=0;n<i;++n)a=Object(r.rgb)(e[n]),o[n]=a.r||0,u[n]=a.g||0,c[n]=a.b||0;return o=t(o),u=t(u),c=t(c),a.opacity=1,function(t){return a.r=o(t),a.g=u(t),a.b=c(t),a+""}}}n.d(e,"b",function(){return u}),n.d(e,"c",function(){return c});var r=n(4),a=n(24),i=n(47),o=n(11);e.a=function rgbGamma(t){function rgb(t,n){var a=e((t=Object(r.rgb)(t)).r,(n=Object(r.rgb)(n)).r),i=e(t.g,n.g),u=e(t.b,n.b),c=Object(o.a)(t.opacity,n.opacity);return function(e){return t.r=a(e),t.g=i(e),t.b=u(e),t.opacity=c(e),t+""}}var e=Object(o.b)(t);return rgb.gamma=rgbGamma,rgb}(1);var u=rgbSpline(a.b),c=rgbSpline(i.a)},function(t,e,n){"use strict";var r=n(24);e.a=function(t){var e=t.length;return function(n){var a=Math.floor(((n%=1)<0?++n:n)*e),i=t[(a+e-1)%e],o=t[a%e],u=t[(a+1)%e],c=t[(a+2)%e];return Object(r.a)((n-a/e)*e,i,o,u,c)}}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a=e?e.length:0,i=t?Math.min(a,t.length):0,o=new Array(a),u=new Array(a);for(n=0;n<i;++n)o[n]=Object(r.a)(t[n],e[n]);for(;n<a;++n)u[n]=e[n];return function(t){for(n=0;n<i;++n)u[n]=o[n](t);return u}}},function(t,e,n){"use strict";e.a=function(t,e){var n=new Date;return t=+t,e-=t,function(r){return n.setTime(t+e*r),n}}},function(t,e,n){"use strict";var r=n(23);e.a=function(t,e){var n,a={},i={};null!==t&&"object"==typeof t||(t={}),null!==e&&"object"==typeof e||(e={});for(n in e)n in t?a[n]=Object(r.a)(t[n],e[n]):i[n]=e[n];return function(t){for(n in a)i[n]=a[n](t);return i}}},function(t,e,n){"use strict";function zero(t){return function(){return t}}function one(t){return function(e){return t(e)+""}}var r=n(15),a=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,i=new RegExp(a.source,"g");e.a=function(t,e){var n,o,u,c=a.lastIndex=i.lastIndex=0,s=-1,f=[],l=[];for(t+="",e+="";(n=a.exec(t))&&(o=i.exec(e));)(u=o.index)>c&&(u=e.slice(c,u),f[s]?f[s]+=u:f[++s]=u),(n=n[0])===(o=o[0])?f[s]?f[s]+=o:f[++s]=o:(f[++s]=null,l.push({i:s,x:Object(r.a)(n,o)})),c=i.lastIndex;return c<e.length&&(u=e.slice(c),f[s]?f[s]+=u:f[++s]=u),f.length<2?l[0]?one(l[0].x):zero(e):(e=l.length,function(t){for(var n,r=0;r<e;++r)f[(n=l[r]).i]=n.x(t);return f.join("")})}},function(t,e,n){"use strict";var r=function(t){return function(){return this.matches(t)}};if("undefined"!=typeof document){var a=document.documentElement;if(!a.matches){var i=a.webkitMatchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector;r=function(t){return function(){return i.call(this,t)}}}}e.a=r},function(t,e,n){"use strict";function empty(){return[]}e.a=function(t){return null==t?empty:function(){return this.querySelectorAll(t)}}},function(t,e,n){"use strict";function EnterNode(t,e){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=e}e.a=EnterNode;var r=n(56),a=n(1);e.b=function(){return new a.a(this._enter||this._groups.map(r.a),this._parents)},EnterNode.prototype={constructor:EnterNode,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,e){return this._parent.insertBefore(t,e)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}}},function(t,e,n){"use strict";e.a=function(t){return new Array(t.length)}},function(t,e,n){"use strict";function styleRemove(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){return function(){this.style.setProperty(t,e,n)}}function styleFunction(t,e,n){return function(){var r=e.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,n)}}function styleValue(t,e){return t.style.getPropertyValue(e)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(e)}e.b=styleValue;var r=n(32);e.a=function(t,e,n){return arguments.length>1?this.each((null==e?styleRemove:"function"==typeof e?styleFunction:styleConstant)(t,e,null==n?"":n)):styleValue(this.node(),t)}},function(t,e,n){"use strict";var r=n(2);e.a=function(t,e){var n,a,i,o=t.__transition,u=!0;if(o){e=null==e?null:e+"";for(i in o)(n=o[i]).name===e?(a=n.state>r.d&&n.state<r.b,n.state=r.a,n.timer.stop(),a&&n.on.call("interrupt",t,t.__data__,n.index,n.group),delete o[i]):u=!1;u&&delete t.__transition}}},function(t,e,n){"use strict";var r=n(33);n.d(e,"a",function(){return r.b}),n.d(e,"c",function(){return r.c});var a=n(160);n.d(e,"b",function(){return a.a});n(161)},function(t,e,n){"use strict";var r=n(4),a=n(8);e.a=function(t,e){var n;return("number"==typeof e?a.interpolateNumber:e instanceof r.color?a.interpolateRgb:(n=Object(r.color)(e))?(e=n,a.interpolateRgb):a.interpolateString)(t,e)}},,,,,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(92);n.d(e,"easeLinear",function(){return r.a});var a=n(93);n.d(e,"easeQuad",function(){return a.b}),n.d(e,"easeQuadIn",function(){return a.a}),n.d(e,"easeQuadOut",function(){return a.c}),n.d(e,"easeQuadInOut",function(){return a.b});var i=n(94);n.d(e,"easeCubic",function(){return i.b}),n.d(e,"easeCubicIn",function(){return i.a}),n.d(e,"easeCubicOut",function(){return i.c}),n.d(e,"easeCubicInOut",function(){return i.b});var o=n(95);n.d(e,"easePoly",function(){return o.b}),n.d(e,"easePolyIn",function(){return o.a}),n.d(e,"easePolyOut",function(){return o.c}),n.d(e,"easePolyInOut",function(){return o.b});var u=n(96);n.d(e,"easeSin",function(){return u.b}),n.d(e,"easeSinIn",function(){return u.a}),n.d(e,"easeSinOut",function(){return u.c}),n.d(e,"easeSinInOut",function(){return u.b});var c=n(97);n.d(e,"easeExp",function(){return c.b}),n.d(e,"easeExpIn",function(){return c.a}),n.d(e,"easeExpOut",function(){return c.c}),n.d(e,"easeExpInOut",function(){return c.b});var s=n(98);n.d(e,"easeCircle",function(){return s.b}),n.d(e,"easeCircleIn",function(){return s.a}),n.d(e,"easeCircleOut",function(){return s.c}),n.d(e,"easeCircleInOut",function(){return s.b});var f=n(99);n.d(e,"easeBounce",function(){return f.c}),n.d(e,"easeBounceIn",function(){return f.a}),n.d(e,"easeBounceOut",function(){return f.c}),n.d(e,"easeBounceInOut",function(){return f.b});var l=n(100);n.d(e,"easeBack",function(){return l.b}),n.d(e,"easeBackIn",function(){return l.a}),n.d(e,"easeBackOut",function(){return l.c}),n.d(e,"easeBackInOut",function(){return l.b});var h=n(101);n.d(e,"easeElastic",function(){return h.c}),n.d(e,"easeElasticIn",function(){return h.a}),n.d(e,"easeElasticOut",function(){return h.c}),n.d(e,"easeElasticInOut",function(){return h.b})},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(104);n.d(e,"dispatch",function(){return r.a})},,,,,,,,,,,,,function(t,e,n){"use strict";function localDate(t){if(0<=t.y&&t.y<100){var e=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return e.setFullYear(t.y),e}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function utcDate(t){if(0<=t.y&&t.y<100){var e=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return e.setUTCFullYear(t.y),e}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function newYear(t){return{y:t,m:0,d:1,H:0,M:0,S:0,L:0}}function formatLocale(t){function newFormat(t,e){return function(n){var r,i,o,u=[],c=-1,s=0,f=t.length;for(n instanceof Date||(n=new Date(+n));++c<f;)37===t.charCodeAt(c)&&(u.push(t.slice(s,c)),null!=(i=a[r=t.charAt(++c)])?r=t.charAt(++c):i="e"===r?" ":"0",(o=e[r])&&(r=o(n,i)),u.push(r),s=c+1);return u.push(t.slice(s,c)),u.join("")}}function newParse(t,e){return function(n){var r=newYear(1900);if(parseSpecifier(r,t,n+="",0)!=n.length)return null;if("p"in r&&(r.H=r.H%12+12*r.p),"W"in r||"U"in r){"w"in r||(r.w="W"in r?1:0);var a="Z"in r?utcDate(newYear(r.y)).getUTCDay():e(newYear(r.y)).getDay();r.m=0,r.d="W"in r?(r.w+6)%7+7*r.W-(a+5)%7:r.w+7*r.U-(a+6)%7}return"Z"in r?(r.H+=r.Z/100|0,r.M+=r.Z%100,utcDate(r)):e(r)}}function parseSpecifier(t,e,n,r){for(var i,o,u=0,c=e.length,s=n.length;u<c;){if(r>=s)return-1;if(37===(i=e.charCodeAt(u++))){if(i=e.charAt(u++),!(o=w[i in a?e.charAt(u++):i])||(r=o(t,n,r))<0)return-1}else if(i!=n.charCodeAt(r++))return-1}return r}function parsePeriod(t,e,n){var r=f.exec(e.slice(n));return r?(t.p=l[r[0].toLowerCase()],n+r[0].length):-1}function parseShortWeekday(t,e,n){var r=p.exec(e.slice(n));return r?(t.w=b[r[0].toLowerCase()],n+r[0].length):-1}function parseWeekday(t,e,n){var r=h.exec(e.slice(n));return r?(t.w=d[r[0].toLowerCase()],n+r[0].length):-1}function parseShortMonth(t,e,n){var r=y.exec(e.slice(n));return r?(t.m=g[r[0].toLowerCase()],n+r[0].length):-1}function parseMonth(t,e,n){var r=v.exec(e.slice(n));return r?(t.m=m[r[0].toLowerCase()],n+r[0].length):-1}function parseLocaleDateTime(t,n,r){return parseSpecifier(t,e,n,r)}function parseLocaleDate(t,e,r){return parseSpecifier(t,n,e,r)}function parseLocaleTime(t,e,n){return parseSpecifier(t,r,e,n)}function formatShortWeekday(t){return u[t.getDay()]}function formatWeekday(t){return o[t.getDay()]}function formatShortMonth(t){return s[t.getMonth()]}function formatMonth(t){return c[t.getMonth()]}function formatPeriod(t){return i[+(t.getHours()>=12)]}function formatUTCShortWeekday(t){return u[t.getUTCDay()]}function formatUTCWeekday(t){return o[t.getUTCDay()]}function formatUTCShortMonth(t){return s[t.getUTCMonth()]}function formatUTCMonth(t){return c[t.getUTCMonth()]}function formatUTCPeriod(t){return i[+(t.getUTCHours()>=12)]}var e=t.dateTime,n=t.date,r=t.time,i=t.periods,o=t.days,u=t.shortDays,c=t.months,s=t.shortMonths,f=formatRe(i),l=formatLookup(i),h=formatRe(o),d=formatLookup(o),p=formatRe(u),b=formatLookup(u),v=formatRe(c),m=formatLookup(c),y=formatRe(s),g=formatLookup(s),_={a:formatShortWeekday,A:formatWeekday,b:formatShortMonth,B:formatMonth,c:null,d:formatDayOfMonth,e:formatDayOfMonth,H:formatHour24,I:formatHour12,j:formatDayOfYear,L:formatMilliseconds,m:formatMonthNumber,M:formatMinutes,p:formatPeriod,S:formatSeconds,U:formatWeekNumberSunday,w:formatWeekdayNumber,W:formatWeekNumberMonday,x:null,X:null,y:formatYear,Y:formatFullYear,Z:formatZone,"%":formatLiteralPercent},x={a:formatUTCShortWeekday,A:formatUTCWeekday,b:formatUTCShortMonth,B:formatUTCMonth,c:null,d:formatUTCDayOfMonth,e:formatUTCDayOfMonth,H:formatUTCHour24,I:formatUTCHour12,j:formatUTCDayOfYear,L:formatUTCMilliseconds,m:formatUTCMonthNumber,M:formatUTCMinutes,p:formatUTCPeriod,S:formatUTCSeconds,U:formatUTCWeekNumberSunday,w:formatUTCWeekdayNumber,W:formatUTCWeekNumberMonday,x:null,X:null,y:formatUTCYear,Y:formatUTCFullYear,Z:formatUTCZone,"%":formatLiteralPercent},w={a:parseShortWeekday,A:parseWeekday,b:parseShortMonth,B:parseMonth,c:parseLocaleDateTime,d:parseDayOfMonth,e:parseDayOfMonth,H:parseHour24,I:parseHour24,j:parseDayOfYear,L:parseMilliseconds,m:parseMonthNumber,M:parseMinutes,p:parsePeriod,S:parseSeconds,U:parseWeekNumberSunday,w:parseWeekdayNumber,W:parseWeekNumberMonday,x:parseLocaleDate,X:parseLocaleTime,y:parseYear,Y:parseFullYear,Z:parseZone,"%":parseLiteralPercent};return _.x=newFormat(n,_),_.X=newFormat(r,_),_.c=newFormat(e,_),x.x=newFormat(n,x),x.X=newFormat(r,x),x.c=newFormat(e,x),{format:function(t){var e=newFormat(t+="",_);return e.toString=function(){return t},e},parse:function(t){var e=newParse(t+="",localDate);return e.toString=function(){return t},e},utcFormat:function(t){var e=newFormat(t+="",x);return e.toString=function(){return t},e},utcParse:function(t){var e=newParse(t,utcDate);return e.toString=function(){return t},e}}}function pad(t,e,n){var r=t<0?"-":"",a=(r?-t:t)+"",i=a.length;return r+(i<n?new Array(n-i+1).join(e)+a:a)}function requote(t){return t.replace(u,"\\$&")}function formatRe(t){return new RegExp("^(?:"+t.map(requote).join("|")+")","i")}function formatLookup(t){for(var e={},n=-1,r=t.length;++n<r;)e[t[n].toLowerCase()]=n;return e}function parseWeekdayNumber(t,e,n){var r=i.exec(e.slice(n,n+1));return r?(t.w=+r[0],n+r[0].length):-1}function parseWeekNumberSunday(t,e,n){var r=i.exec(e.slice(n));return r?(t.U=+r[0],n+r[0].length):-1}function parseWeekNumberMonday(t,e,n){var r=i.exec(e.slice(n));return r?(t.W=+r[0],n+r[0].length):-1}function parseFullYear(t,e,n){var r=i.exec(e.slice(n,n+4));return r?(t.y=+r[0],n+r[0].length):-1}function parseYear(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),n+r[0].length):-1}function parseZone(t,e,n){var r=/^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(e.slice(n,n+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),n+r[0].length):-1}function parseMonthNumber(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.m=r[0]-1,n+r[0].length):-1}function parseDayOfMonth(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.d=+r[0],n+r[0].length):-1}function parseDayOfYear(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.m=0,t.d=+r[0],n+r[0].length):-1}function parseHour24(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.H=+r[0],n+r[0].length):-1}function parseMinutes(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.M=+r[0],n+r[0].length):-1}function parseSeconds(t,e,n){var r=i.exec(e.slice(n,n+2));return r?(t.S=+r[0],n+r[0].length):-1}function parseMilliseconds(t,e,n){var r=i.exec(e.slice(n,n+3));return r?(t.L=+r[0],n+r[0].length):-1}function parseLiteralPercent(t,e,n){var r=o.exec(e.slice(n,n+1));return r?n+r[0].length:-1}function formatDayOfMonth(t,e){return pad(t.getDate(),e,2)}function formatHour24(t,e){return pad(t.getHours(),e,2)}function formatHour12(t,e){return pad(t.getHours()%12||12,e,2)}function formatDayOfYear(t,e){return pad(1+r.timeDay.count(Object(r.timeYear)(t),t),e,3)}function formatMilliseconds(t,e){return pad(t.getMilliseconds(),e,3)}function formatMonthNumber(t,e){return pad(t.getMonth()+1,e,2)}function formatMinutes(t,e){return pad(t.getMinutes(),e,2)}function formatSeconds(t,e){return pad(t.getSeconds(),e,2)}function formatWeekNumberSunday(t,e){return pad(r.timeSunday.count(Object(r.timeYear)(t),t),e,2)}function formatWeekdayNumber(t){return t.getDay()}function formatWeekNumberMonday(t,e){return pad(r.timeMonday.count(Object(r.timeYear)(t),t),e,2)}function formatYear(t,e){return pad(t.getFullYear()%100,e,2)}function formatFullYear(t,e){return pad(t.getFullYear()%1e4,e,4)}function formatZone(t){var e=t.getTimezoneOffset();return(e>0?"-":(e*=-1,"+"))+pad(e/60|0,"0",2)+pad(e%60,"0",2)}function formatUTCDayOfMonth(t,e){return pad(t.getUTCDate(),e,2)}function formatUTCHour24(t,e){return pad(t.getUTCHours(),e,2)}function formatUTCHour12(t,e){return pad(t.getUTCHours()%12||12,e,2)}function formatUTCDayOfYear(t,e){return pad(1+r.utcDay.count(Object(r.utcYear)(t),t),e,3)}function formatUTCMilliseconds(t,e){return pad(t.getUTCMilliseconds(),e,3)}function formatUTCMonthNumber(t,e){return pad(t.getUTCMonth()+1,e,2)}function formatUTCMinutes(t,e){return pad(t.getUTCMinutes(),e,2)}function formatUTCSeconds(t,e){return pad(t.getUTCSeconds(),e,2)}function formatUTCWeekNumberSunday(t,e){return pad(r.utcSunday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCWeekdayNumber(t){return t.getUTCDay()}function formatUTCWeekNumberMonday(t,e){return pad(r.utcMonday.count(Object(r.utcYear)(t),t),e,2)}function formatUTCYear(t,e){return pad(t.getUTCFullYear()%100,e,2)}function formatUTCFullYear(t,e){return pad(t.getUTCFullYear()%1e4,e,4)}function formatUTCZone(){return"+0000"}function formatLiteralPercent(){return"%"}e.a=formatLocale;var r=n(35),a={"-":"",_:" ",0:"0"},i=/^\s*\d+/,o=/^%/,u=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g},function(t,e,n){"use strict";function formatIsoNative(t){return t.toISOString()}n.d(e,"b",function(){return a});var r=n(37),a="%Y-%m-%dT%H:%M:%S.%LZ",i=Date.prototype.toISOString?formatIsoNative:Object(r.d)(a);e.a=i},,,,,,,,,,function(t,e,n){"use strict";var r;void 0!==(r=function(){return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},emptyDonutData:[{quantity:1,percentage:100}],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId"}}.call(e,n,e,t))&&(t.exports=r)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=(n(158),n(7));n.d(e,"transition",function(){return r.b});var a=n(179);n.d(e,"active",function(){return a.a});var i=n(58);n.d(e,"interrupt",function(){return i.a})},function(t,e,n){"use strict";function linear(t){return+t}e.a=linear},function(t,e,n){"use strict";function quadIn(t){return t*t}function quadOut(t){return t*(2-t)}function quadInOut(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.a=quadIn,e.c=quadOut,e.b=quadInOut},function(t,e,n){"use strict";function cubicIn(t){return t*t*t}function cubicOut(t){return--t*t*t+1}function cubicInOut(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.a=cubicIn,e.c=cubicOut,e.b=cubicInOut},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function polyIn(e){return Math.pow(e,t)}return t=+t,polyIn.exponent=custom,polyIn}(3),a=function custom(t){function polyOut(e){return 1-Math.pow(1-e,t)}return t=+t,polyOut.exponent=custom,polyOut}(3),i=function custom(t){function polyInOut(e){return((e*=2)<=1?Math.pow(e,t):2-Math.pow(2-e,t))/2}return t=+t,polyInOut.exponent=custom,polyInOut}(3)},function(t,e,n){"use strict";function sinIn(t){return 1-Math.cos(t*a)}function sinOut(t){return Math.sin(t*a)}function sinInOut(t){return(1-Math.cos(r*t))/2}e.a=sinIn,e.c=sinOut,e.b=sinInOut;var r=Math.PI,a=r/2},function(t,e,n){"use strict";function expIn(t){return Math.pow(2,10*t-10)}function expOut(t){return 1-Math.pow(2,-10*t)}function expInOut(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}e.a=expIn,e.c=expOut,e.b=expInOut},function(t,e,n){"use strict";function circleIn(t){return 1-Math.sqrt(1-t*t)}function circleOut(t){return Math.sqrt(1- --t*t)}function circleInOut(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}e.a=circleIn,e.c=circleOut,e.b=circleInOut},function(t,e,n){"use strict";function bounceIn(t){return 1-bounceOut(1-t)}function bounceOut(t){return(t=+t)<r?h*t*t:t<i?h*(t-=a)*t+o:t<c?h*(t-=u)*t+s:h*(t-=f)*t+l}function bounceInOut(t){return((t*=2)<=1?1-bounceOut(1-t):bounceOut(t-1)+1)/2}e.a=bounceIn,e.c=bounceOut,e.b=bounceInOut;var r=4/11,a=6/11,i=8/11,o=.75,u=9/11,c=10/11,s=.9375,f=21/22,l=63/64,h=1/r/r},function(t,e,n){"use strict";n.d(e,"a",function(){return r}),n.d(e,"c",function(){return a}),n.d(e,"b",function(){return i});var r=function custom(t){function backIn(e){return e*e*((t+1)*e-t)}return t=+t,backIn.overshoot=custom,backIn}(1.70158),a=function custom(t){function backOut(e){return--e*e*((t+1)*e+t)+1}return t=+t,backOut.overshoot=custom,backOut}(1.70158),i=function custom(t){function backInOut(e){return((e*=2)<1?e*e*((t+1)*e-t):(e-=2)*e*((t+1)*e+t)+2)/2}return t=+t,backInOut.overshoot=custom,backInOut}(1.70158)},function(t,e,n){"use strict";n.d(e,"a",function(){return a}),n.d(e,"c",function(){return i}),n.d(e,"b",function(){return o});var r=2*Math.PI,a=function custom(t,e){function elasticIn(r){return t*Math.pow(2,10*--r)*Math.sin((n-r)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticIn.amplitude=function(t){return custom(t,e*r)},elasticIn.period=function(e){return custom(t,e)},elasticIn}(1,.3),i=function custom(t,e){function elasticOut(r){return 1-t*Math.pow(2,-10*(r=+r))*Math.sin((r+n)/e)}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticOut.amplitude=function(t){return custom(t,e*r)},elasticOut.period=function(e){return custom(t,e)},elasticOut}(1,.3),o=function custom(t,e){function elasticInOut(r){return((r=2*r-1)<0?t*Math.pow(2,10*r)*Math.sin((n-r)/e):2-t*Math.pow(2,-10*r)*Math.sin((n+r)/e))/2}var n=Math.asin(1/(t=Math.max(1,t)))*(e/=r);return elasticInOut.amplitude=function(t){return custom(t,e*r)},elasticInOut.period=function(e){return custom(t,e)},elasticInOut}(1,.3)},function(t,e,n){"use strict";function labConvert(t){if(t instanceof Lab)return new Lab(t.l,t.a,t.b,t.opacity);if(t instanceof Hcl){var e=t.h*i.a;return new Lab(t.l,Math.cos(e)*t.c,Math.sin(e)*t.c,t.opacity)}t instanceof a.b||(t=Object(a.h)(t));var n=rgb2xyz(t.r),r=rgb2xyz(t.g),s=rgb2xyz(t.b),f=xyz2lab((.4124564*n+.3575761*r+.1804375*s)/o),l=xyz2lab((.2126729*n+.7151522*r+.072175*s)/u);return new Lab(116*l-16,500*(f-l),200*(l-xyz2lab((.0193339*n+.119192*r+.9503041*s)/c)),t.opacity)}function lab(t,e,n,r){return 1===arguments.length?labConvert(t):new Lab(t,e,n,null==r?1:r)}function Lab(t,e,n,r){this.l=+t,this.a=+e,this.b=+n,this.opacity=+r}function xyz2lab(t){return t>h?Math.pow(t,1/3):t/l+s}function lab2xyz(t){return t>f?t*t*t:l*(t-s)}function xyz2rgb(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function rgb2xyz(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function hclConvert(t){if(t instanceof Hcl)return new Hcl(t.h,t.c,t.l,t.opacity);t instanceof Lab||(t=labConvert(t));var e=Math.atan2(t.b,t.a)*i.b;return new Hcl(e<0?e+360:e,Math.sqrt(t.a*t.a+t.b*t.b),t.l,t.opacity)}function hcl(t,e,n,r){return 1===arguments.length?hclConvert(t):new Hcl(t,e,n,null==r?1:r)}function Hcl(t,e,n,r){this.h=+t,this.c=+e,this.l=+n,this.opacity=+r}e.a=lab,e.b=hcl;var r=n(20),a=n(19),i=n(41),o=.95047,u=1,c=1.08883,s=4/29,f=6/29,l=3*f*f,h=f*f*f;Object(r.a)(Lab,lab,Object(r.b)(a.a,{brighter:function(t){return new Lab(this.l+18*(null==t?1:t),this.a,this.b,this.opacity)},darker:function(t){return new Lab(this.l-18*(null==t?1:t),this.a,this.b,this.opacity)},rgb:function(){var t=(this.l+16)/116,e=isNaN(this.a)?t:t+this.a/500,n=isNaN(this.b)?t:t-this.b/200;return t=u*lab2xyz(t),e=o*lab2xyz(e),n=c*lab2xyz(n),new a.b(xyz2rgb(3.2404542*e-1.5371385*t-.4985314*n),xyz2rgb(-.969266*e+1.8760108*t+.041556*n),xyz2rgb(.0556434*e-.2040259*t+1.0572252*n),this.opacity)}})),Object(r.a)(Hcl,hcl,Object(r.b)(a.a,{brighter:function(t){return new Hcl(this.h,this.c,this.l+18*(null==t?1:t),this.opacity)},darker:function(t){return new Hcl(this.h,this.c,this.l-18*(null==t?1:t),this.opacity)},rgb:function(){return labConvert(this).rgb()}}))},function(t,e,n){"use strict";function cubehelixConvert(t){if(t instanceof Cubehelix)return new Cubehelix(t.h,t.s,t.l,t.opacity);t instanceof a.b||(t=Object(a.h)(t));var e=t.r/255,n=t.g/255,r=t.b/255,o=(d*r+l*e-h*n)/(d+l-h),u=r-o,p=(f*(n-o)-c*u)/s,b=Math.sqrt(p*p+u*u)/(f*o*(1-o)),v=b?Math.atan2(p,u)*i.b-120:NaN;return new Cubehelix(v<0?v+360:v,b,o,t.opacity)}function cubehelix(t,e,n,r){return 1===arguments.length?cubehelixConvert(t):new Cubehelix(t,e,n,null==r?1:r)}function Cubehelix(t,e,n,r){this.h=+t,this.s=+e,this.l=+n,this.opacity=+r}e.a=cubehelix;var r=n(20),a=n(19),i=n(41),o=-.14861,u=1.78277,c=-.29227,s=-.90649,f=1.97294,l=f*s,h=f*u,d=u*c-s*o;Object(r.a)(Cubehelix,cubehelix,Object(r.b)(a.a,{brighter:function(t){return t=null==t?a.c:Math.pow(a.c,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?a.d:Math.pow(a.d,t),new Cubehelix(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=isNaN(this.h)?0:(this.h+120)*i.a,e=+this.l,n=isNaN(this.s)?0:this.s*e*(1-e),r=Math.cos(t),l=Math.sin(t);return new a.b(255*(e+n*(o*r+u*l)),255*(e+n*(c*r+s*l)),255*(e+n*(f*r)),this.opacity)}}))},function(t,e,n){"use strict";function dispatch(){for(var t,e=0,n=arguments.length,r={};e<n;++e){if(!(t=arguments[e]+"")||t in r)throw new Error("illegal type: "+t);r[t]=[]}return new Dispatch(r)}function Dispatch(t){this._=t}function parseTypenames(t,e){return t.trim().split(/^|\s+/).map(function(t){var n="",r=t.indexOf(".");if(r>=0&&(n=t.slice(r+1),t=t.slice(0,r)),t&&!e.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:n}})}function get(t,e){for(var n,r=0,a=t.length;r<a;++r)if((n=t[r]).name===e)return n.value}function set(t,e,n){for(var a=0,i=t.length;a<i;++a)if(t[a].name===e){t[a]=r,t=t.slice(0,a).concat(t.slice(a+1));break}return null!=n&&t.push({name:e,value:n}),t}var r={value:function(){}};Dispatch.prototype=dispatch.prototype={constructor:Dispatch,on:function(t,e){var n,r=this._,a=parseTypenames(t+"",r),i=-1,o=a.length;{if(!(arguments.length<2)){if(null!=e&&"function"!=typeof e)throw new Error("invalid callback: "+e);for(;++i<o;)if(n=(t=a[i]).type)r[n]=set(r[n],t.name,e);else if(null==e)for(n in r)r[n]=set(r[n],t.name,null);return this}for(;++i<o;)if((n=(t=a[i]).type)&&(n=get(r[n],t.name)))return n}},copy:function(){var t={},e=this._;for(var n in e)t[n]=e[n].slice();return new Dispatch(t)},call:function(t,e){if((n=arguments.length-2)>0)for(var n,r,a=new Array(n),i=0;i<n;++i)a[i]=arguments[i+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(r=this._[t],i=0,n=r.length;i<n;++i)r[i].value.apply(e,a)},apply:function(t,e,n){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],a=0,i=r.length;a<i;++a)r[a].value.apply(e,n)}},e.a=dispatch},function(t,e,n){"use strict";function defaultLocale(t){return r=Object(o.a)(t),a=r.format,i=r.formatPrefix,r}n.d(e,"b",function(){return a}),n.d(e,"c",function(){return i}),e.a=defaultLocale;var r,a,i,o=n(42);defaultLocale({decimal:".",thousands:",",grouping:[3],currency:["$",""]})},function(t,e,n){"use strict";e.a=function(t,e){return function(n,r){for(var a=n.length,i=[],o=0,u=t[0],c=0;a>0&&u>0&&(c+u+1>r&&(u=Math.max(1,r-c)),i.push(n.substring(a-=u,a+u)),!((c+=u+1)>r));)u=t[o=(o+1)%t.length];return i.reverse().join(e)}}},function(t,e,n){"use strict";e.a=function(t){return function(e){return e.replace(/[0-9]/g,function(e){return t[+e]})}}},function(t,e,n){"use strict";e.a=function(t,e){t=t.toPrecision(e);t:for(var n,r=t.length,a=1,i=-1;a<r;++a)switch(t[a]){case".":i=n=a;break;case"0":0===i&&(i=a),n=a;break;case"e":break t;default:i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}},function(t,e,n){"use strict";var r=n(22);e.a=function(t,e){var n=Object(r.a)(t,e);if(!n)return t+"";var a=n[0],i=n[1];return i<0?"0."+new Array(-i).join("0")+a:a.length>i+1?a.slice(0,i+1)+"."+a.slice(i+1):a+new Array(i-a.length+2).join("0")}},function(t,e,n){"use strict";e.a=function(t){return t}},function(t,e,n){"use strict";var r=n(13);e.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(e)/3)))-Object(r.a)(Math.abs(t)))}},function(t,e,n){"use strict";var r=n(13);e.a=function(t,e){return t=Math.abs(t),e=Math.abs(e)-t,Math.max(0,Object(r.a)(e)-Object(r.a)(t))+1}},,function(t,e,n){"use strict";e.a=function(t,e){return t=+t,e-=t,function(n){return Math.round(t+e*n)}}},function(t,e,n){"use strict";function interpolateTransform(t,e,n,a){function pop(t){return t.length?t.pop()+" ":""}function translate(t,a,i,o,u,c){if(t!==i||a!==o){var s=u.push("translate(",null,e,null,n);c.push({i:s-4,x:Object(r.a)(t,i)},{i:s-2,x:Object(r.a)(a,o)})}else(i||o)&&u.push("translate("+i+e+o+n)}function rotate(t,e,n,i){t!==e?(t-e>180?e+=360:e-t>180&&(t+=360),i.push({i:n.push(pop(n)+"rotate(",null,a)-2,x:Object(r.a)(t,e)})):e&&n.push(pop(n)+"rotate("+e+a)}function skewX(t,e,n,i){t!==e?i.push({i:n.push(pop(n)+"skewX(",null,a)-2,x:Object(r.a)(t,e)}):e&&n.push(pop(n)+"skewX("+e+a)}function scale(t,e,n,a,i,o){if(t!==n||e!==a){var u=i.push(pop(i)+"scale(",null,",",null,")");o.push({i:u-4,x:Object(r.a)(t,n)},{i:u-2,x:Object(r.a)(e,a)})}else 1===n&&1===a||i.push(pop(i)+"scale("+n+","+a+")")}return function(e,n){var r=[],a=[];return e=t(e),n=t(n),translate(e.translateX,e.translateY,n.translateX,n.translateY,r,a),rotate(e.rotate,n.rotate,r,a),skewX(e.skewX,n.skewX,r,a),scale(e.scaleX,e.scaleY,n.scaleX,n.scaleY,r,a),e=n=null,function(t){for(var e,n=-1,i=a.length;++n<i;)r[(e=a[n]).i]=e.x(t);return r.join("")}}}n.d(e,"a",function(){return i}),n.d(e,"b",function(){return o});var r=n(15),a=n(117),i=interpolateTransform(a.a,"px, ","px)","deg)"),o=interpolateTransform(a.b,", ",")",")")},function(t,e,n){"use strict";function parseCss(t){return"none"===t?u.b:(r||(r=document.createElement("DIV"),a=document.documentElement,i=document.defaultView),r.style.transform=t,t=i.getComputedStyle(a.appendChild(r),null).getPropertyValue("transform"),a.removeChild(r),t=t.slice(7,-1).split(","),Object(u.a)(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}function parseSvg(t){return null==t?u.b:(o||(o=document.createElementNS("http://www.w3.org/2000/svg","g")),o.setAttribute("transform",t),(t=o.transform.baseVal.consolidate())?(t=t.matrix,Object(u.a)(t.a,t.b,t.c,t.d,t.e,t.f)):u.b)}e.a=parseCss,e.b=parseSvg;var r,a,i,o,u=n(118)},function(t,e,n){"use strict";n.d(e,"b",function(){return a});var r=180/Math.PI,a={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};e.a=function(t,e,n,a,i,o){var u,c,s;return(u=Math.sqrt(t*t+e*e))&&(t/=u,e/=u),(s=t*n+e*a)&&(n-=t*s,a-=e*s),(c=Math.sqrt(n*n+a*a))&&(n/=c,a/=c,s/=c),t*a<e*n&&(t=-t,e=-e,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(e,t)*r,skewX:Math.atan(s)*r,scaleX:u,scaleY:c}}},function(t,e,n){"use strict";function cosh(t){return((t=Math.exp(t))+1/t)/2}function sinh(t){return((t=Math.exp(t))-1/t)/2}function tanh(t){return((t=Math.exp(2*t))-1)/(t+1)}var r=Math.SQRT2;e.a=function(t,e){var n,a,i=t[0],o=t[1],u=t[2],c=e[0],s=e[1],f=e[2],l=c-i,h=s-o,d=l*l+h*h;if(d<1e-12)a=Math.log(f/u)/r,n=function(t){return[i+t*l,o+t*h,u*Math.exp(r*t*a)]};else{var p=Math.sqrt(d),b=(f*f-u*u+4*d)/(2*u*2*p),v=(f*f-u*u-4*d)/(2*f*2*p),m=Math.log(Math.sqrt(b*b+1)-b),y=Math.log(Math.sqrt(v*v+1)-v);a=(y-m)/r,n=function(t){var e=t*a,n=cosh(m),c=u/(2*p)*(n*tanh(r*e+m)-sinh(m));return[i+c*l,o+c*h,u*n/cosh(r*e+m)]}}return n.duration=1e3*a,n}},function(t,e,n){"use strict";function hsl(t){return function(e,n){var i=t((e=Object(r.hsl)(e)).h,(n=Object(r.hsl)(n)).h),o=Object(a.a)(e.s,n.s),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.s=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hsl(a.c);var i=hsl(a.a)},function(t,e,n){"use strict";function lab(t,e){var n=Object(a.a)((t=Object(r.lab)(t)).l,(e=Object(r.lab)(e)).l),i=Object(a.a)(t.a,e.a),o=Object(a.a)(t.b,e.b),u=Object(a.a)(t.opacity,e.opacity);return function(e){return t.l=n(e),t.a=i(e),t.b=o(e),t.opacity=u(e),t+""}}e.a=lab;var r=n(4),a=n(11)},function(t,e,n){"use strict";function hcl(t){return function(e,n){var i=t((e=Object(r.hcl)(e)).h,(n=Object(r.hcl)(n)).h),o=Object(a.a)(e.c,n.c),u=Object(a.a)(e.l,n.l),c=Object(a.a)(e.opacity,n.opacity);return function(t){return e.h=i(t),e.c=o(t),e.l=u(t),e.opacity=c(t),e+""}}}n.d(e,"b",function(){return i});var r=n(4),a=n(11);e.a=hcl(a.c);var i=hcl(a.a)},function(t,e,n){"use strict";function cubehelix(t){return function cubehelixGamma(e){function cubehelix(n,i){var o=t((n=Object(r.cubehelix)(n)).h,(i=Object(r.cubehelix)(i)).h),u=Object(a.a)(n.s,i.s),c=Object(a.a)(n.l,i.l),s=Object(a.a)(n.opacity,i.opacity);return function(t){return n.h=o(t),n.s=u(t),n.l=c(Math.pow(t,e)),n.opacity=s(t),n+""}}return e=+e,cubehelix.gamma=cubehelixGamma,cubehelix}(1)}n.d(e,"a",function(){return i});var r=n(4),a=n(11);e.b=cubehelix(a.c);var i=cubehelix(a.a)},function(t,e,n){"use strict";e.a=function(t,e){for(var n=new Array(e),r=0;r<e;++r)n[r]=t(r/(e-1));return n}},function(t,e,n){"use strict";function local(){return new Local}function Local(){this._="@"+(++r).toString(36)}e.a=local;var r=0;Local.prototype=local.prototype={constructor:Local,get:function(t){for(var e=this._;!(e in t);)if(!(t=t.parentNode))return;return t[e]},set:function(t,e){return t[this._]=e},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t){var e=Object(r.a)();return e.changedTouches&&(e=e.changedTouches[0]),Object(a.a)(t,e)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,e,n){"use strict";var r=n(1),a=n(31);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c,s=e[o],f=s.length,l=i[o]=new Array(f),h=0;h<f;++h)(u=s[h])&&(c=t.call(u,u.__data__,h,s))&&("__data__"in u&&(c.__data__=u.__data__),l[h]=c);return new r.a(i,this._parents)}},function(t,e,n){"use strict";var r=n(1),a=n(54);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=[],o=[],u=0;u<n;++u)for(var c,s=e[u],f=s.length,l=0;l<f;++l)(c=s[l])&&(i.push(t.call(c,c.__data__,l,s)),o.push(c));return new r.a(i,o)}},function(t,e,n){"use strict";var r=n(1),a=n(53);e.a=function(t){"function"!=typeof t&&(t=Object(a.a)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new r.a(i,this._parents)}},function(t,e,n){"use strict";function bindIndex(t,e,n,r,i,o){for(var u,c=0,s=e.length,f=o.length;c<f;++c)(u=e[c])?(u.__data__=o[c],r[c]=u):n[c]=new a.a(t,o[c]);for(;c<s;++c)(u=e[c])&&(i[c]=u)}function bindKey(t,e,n,r,i,u,c){var s,f,l,h={},d=e.length,p=u.length,b=new Array(d);for(s=0;s<d;++s)(f=e[s])&&(b[s]=l=o+c.call(f,f.__data__,s,e),l in h?i[s]=f:h[l]=f);for(s=0;s<p;++s)l=o+c.call(t,u[s],s,u),(f=h[l])?(r[s]=f,f.__data__=u[s],h[l]=null):n[s]=new a.a(t,u[s]);for(s=0;s<d;++s)(f=e[s])&&h[b[s]]===f&&(i[s]=f)}var r=n(1),a=n(55),i=n(132),o="$";e.a=function(t,e){if(!t)return b=new Array(this.size()),l=-1,this.each(function(t){b[++l]=t}),b;var n=e?bindKey:bindIndex,a=this._parents,o=this._groups;"function"!=typeof t&&(t=Object(i.a)(t));for(var u=o.length,c=new Array(u),s=new Array(u),f=new Array(u),l=0;l<u;++l){var h=a[l],d=o[l],p=d.length,b=t.call(h,h&&h.__data__,l,a),v=b.length,m=s[l]=new Array(v),y=c[l]=new Array(v);n(h,d,m,y,f[l]=new Array(p),b,e);for(var g,_,x=0,w=0;x<v;++x)if(g=m[x]){for(x>=w&&(w=x+1);!(_=y[w])&&++w<v;);g._next=_||null}}return c=new r.a(c,a),c._enter=s,c._exit=f,c}},function(t,e,n){"use strict";e.a=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=n(56),a=n(1);e.a=function(){return new a.a(this._exit||this._groups.map(r.a),this._parents)}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents)}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=-1,n=t.length;++e<n;)for(var r,a=t[e],i=a.length-1,o=a[i];--i>=0;)(r=a[i])&&(o&&o!==r.nextSibling&&o.parentNode.insertBefore(r,o),o=r);return this}},function(t,e,n){"use strict";function ascending(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}var r=n(1);e.a=function(t){function compareNode(e,n){return e&&n?t(e.__data__,n.__data__):!e-!n}t||(t=ascending);for(var e=this._groups,n=e.length,a=new Array(n),i=0;i<n;++i){for(var o,u=e[i],c=u.length,s=a[i]=new Array(c),f=0;f<c;++f)(o=u[f])&&(s[f]=o);s.sort(compareNode)}return new r.a(a,this._parents).order()}},function(t,e,n){"use strict";e.a=function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}},function(t,e,n){"use strict";e.a=function(){var t=new Array(this.size()),e=-1;return this.each(function(){t[++e]=this}),t}},function(t,e,n){"use strict";e.a=function(){for(var t=this._groups,e=0,n=t.length;e<n;++e)for(var r=t[e],a=0,i=r.length;a<i;++a){var o=r[a];if(o)return o}return null}},function(t,e,n){"use strict";e.a=function(){var t=0;return this.each(function(){++t}),t}},function(t,e,n){"use strict";e.a=function(){return!this.node()}},function(t,e,n){"use strict";e.a=function(t){for(var e=this._groups,n=0,r=e.length;n<r;++n)for(var a,i=e[n],o=0,u=i.length;o<u;++o)(a=i[o])&&t.call(a,a.__data__,o,i);return this}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e){return function(){this.setAttribute(t,e)}}function attrConstantNS(t,e){return function(){this.setAttributeNS(t.space,t.local,e)}}function attrFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttribute(t):this.setAttribute(t,n)}}function attrFunctionNS(t,e){return function(){var n=e.apply(this,arguments);null==n?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,n)}}var r=n(26);e.a=function(t,e){var n=Object(r.a)(t);if(arguments.length<2){var a=this.node();return n.local?a.getAttributeNS(n.space,n.local):a.getAttribute(n)}return this.each((null==e?n.local?attrRemoveNS:attrRemove:"function"==typeof e?n.local?attrFunctionNS:attrFunction:n.local?attrConstantNS:attrConstant)(n,e))}},function(t,e,n){"use strict";function propertyRemove(t){return function(){delete this[t]}}function propertyConstant(t,e){return function(){this[t]=e}}function propertyFunction(t,e){return function(){var n=e.apply(this,arguments);null==n?delete this[t]:this[t]=n}}e.a=function(t,e){return arguments.length>1?this.each((null==e?propertyRemove:"function"==typeof e?propertyFunction:propertyConstant)(t,e)):this.node()[t]}},function(t,e,n){"use strict";function classArray(t){return t.trim().split(/^|\s+/)}function classList(t){return t.classList||new ClassList(t)}function ClassList(t){this._node=t,this._names=classArray(t.getAttribute("class")||"")}function classedAdd(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.add(e[r])}function classedRemove(t,e){for(var n=classList(t),r=-1,a=e.length;++r<a;)n.remove(e[r])}function classedTrue(t){return function(){classedAdd(this,t)}}function classedFalse(t){return function(){classedRemove(this,t)}}function classedFunction(t,e){return function(){(e.apply(this,arguments)?classedAdd:classedRemove)(this,t)}}ClassList.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var e=this._names.indexOf(t);e>=0&&(this._names.splice(e,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}},e.a=function(t,e){var n=classArray(t+"");if(arguments.length<2){for(var r=classList(this.node()),a=-1,i=n.length;++a<i;)if(!r.contains(n[a]))return!1;return!0}return this.each(("function"==typeof e?classedFunction:e?classedTrue:classedFalse)(n,e))}},function(t,e,n){"use strict";function textRemove(){this.textContent=""}function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t.apply(this,arguments);this.textContent=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?textRemove:("function"==typeof t?textFunction:textConstant)(t)):this.node().textContent}},function(t,e,n){"use strict";function htmlRemove(){this.innerHTML=""}function htmlConstant(t){return function(){this.innerHTML=t}}function htmlFunction(t){return function(){var e=t.apply(this,arguments);this.innerHTML=null==e?"":e}}e.a=function(t){return arguments.length?this.each(null==t?htmlRemove:("function"==typeof t?htmlFunction:htmlConstant)(t)):this.node().innerHTML}},function(t,e,n){"use strict";function raise(){this.nextSibling&&this.parentNode.appendChild(this)}e.a=function(){return this.each(raise)}},function(t,e,n){"use strict";function lower(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}e.a=function(){return this.each(lower)}},function(t,e,n){"use strict";var r=n(25);e.a=function(t){var e="function"==typeof t?t:Object(r.a)(t);return this.select(function(){return this.appendChild(e.apply(this,arguments))})}},function(t,e,n){"use strict";function constantNull(){return null}var r=n(25),a=n(31);e.a=function(t,e){var n="function"==typeof t?t:Object(r.a)(t),i=null==e?constantNull:"function"==typeof e?e:Object(a.a)(e);return this.select(function(){return this.insertBefore(n.apply(this,arguments),i.apply(this,arguments)||null)})}},function(t,e,n){"use strict";function remove(){var t=this.parentNode;t&&t.removeChild(this)}e.a=function(){return this.each(remove)}},function(t,e,n){"use strict";e.a=function(t){return arguments.length?this.property("__data__",t):this.node().__data__}},function(t,e,n){"use strict";function dispatchEvent(t,e,n){var a=Object(r.a)(t),i=a.CustomEvent;"function"==typeof i?i=new i(e,n):(i=a.document.createEvent("Event"),n?(i.initEvent(e,n.bubbles,n.cancelable),i.detail=n.detail):i.initEvent(e,!1,!1)),t.dispatchEvent(i)}function dispatchConstant(t,e){return function(){return dispatchEvent(this,t,e)}}function dispatchFunction(t,e){return function(){return dispatchEvent(this,t,e.apply(this,arguments))}}var r=n(32);e.a=function(t,e){return this.each(("function"==typeof e?dispatchFunction:dispatchConstant)(t,e))}},function(t,e,n){"use strict";var r=n(1);e.a=function(t){return"string"==typeof t?new r.a([document.querySelectorAll(t)],[document.documentElement]):new r.a([null==t?[]:t],r.c)}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e,n){arguments.length<3&&(n=e,e=Object(r.a)().changedTouches);for(var i,o=0,u=e?e.length:0;o<u;++o)if((i=e[o]).identifier===n)return Object(a.a)(t,i);return null}},function(t,e,n){"use strict";var r=n(28),a=n(30);e.a=function(t,e){null==e&&(e=Object(r.a)().touches);for(var n=0,i=e?e.length:0,o=new Array(i);n<i;++n)o[n]=Object(a.a)(t,e[n]);return o}},function(t,e,n){"use strict";var r=n(3),a=n(159),i=n(162);r.selection.prototype.interrupt=a.a,r.selection.prototype.transition=i.a},function(t,e,n){"use strict";var r=n(58);e.a=function(t){return this.each(function(){Object(r.a)(this,t)})}},function(t,e,n){"use strict";var r=n(33);e.a=function(t,e,n){var a=new r.a;return e=null==e?0:+e,a.restart(function(n){a.stop(),t(n+e)},e,n),a}},function(t,e,n){"use strict";n(33)},function(t,e,n){"use strict";function inherit(t,e){for(var n;!(n=t.__transition)||!(n=n[e]);)if(!(t=t.parentNode))return u.time=Object(o.a)(),u;return n}var r=n(7),a=n(2),i=n(65),o=n(59),u={time:null,delay:0,duration:250,ease:i.easeCubicInOut};e.a=function(t){var e,n;t instanceof r.a?(e=t._id,t=t._name):(e=Object(r.c)(),(n=u).time=Object(o.a)(),t=null==t?null:t+"");for(var i=this._groups,c=i.length,s=0;s<c;++s)for(var f,l=i[s],h=l.length,d=0;d<h;++d)(f=l[d])&&Object(a.e)(f,t,e,d,l,n||inherit(f,e));return new r.a(i,this._parents,t,e)}},function(t,e,n){"use strict";function attrRemove(t){return function(){this.removeAttribute(t)}}function attrRemoveNS(t){return function(){this.removeAttributeNS(t.space,t.local)}}function attrConstant(t,e,n){var r,a;return function(){var i=this.getAttribute(t);return i===n?null:i===r?a:a=e(r=i,n)}}function attrConstantNS(t,e,n){var r,a;return function(){var i=this.getAttributeNS(t.space,t.local);return i===n?null:i===r?a:a=e(r=i,n)}}function attrFunction(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttribute(t):(o=this.getAttribute(t),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}function attrFunctionNS(t,e,n){var r,a,i;return function(){var o,u=n(this);return null==u?void this.removeAttributeNS(t.space,t.local):(o=this.getAttributeNS(t.space,t.local),o===u?null:o===r&&u===a?i:i=e(r=o,a=u))}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e){var n=Object(a.namespace)(t),u="transform"===n?r.interpolateTransformSvg:o.a;return this.attrTween(t,"function"==typeof e?(n.local?attrFunctionNS:attrFunction)(n,u,Object(i.b)(this,"attr."+t,e)):null==e?(n.local?attrRemoveNS:attrRemove)(n):(n.local?attrConstantNS:attrConstant)(n,u,e+""))}},function(t,e,n){"use strict";function attrTweenNS(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttributeNS(t.space,t.local,r(e))}}return tween._value=e,tween}function attrTween(t,e){function tween(){var n=this,r=e.apply(n,arguments);return r&&function(e){n.setAttribute(t,r(e))}}return tween._value=e,tween}var r=n(3);e.a=function(t,e){var n="attr."+t;if(arguments.length<2)return(n=this.tween(n))&&n._value;if(null==e)return this.tween(n,null);if("function"!=typeof e)throw new Error;var a=Object(r.namespace)(t);return this.tween(n,(a.local?attrTweenNS:attrTween)(a,e))}},function(t,e,n){"use strict";function delayFunction(t,e){return function(){Object(r.g)(this,t).delay=+e.apply(this,arguments)}}function delayConstant(t,e){return e=+e,function(){Object(r.g)(this,t).delay=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?delayFunction:delayConstant)(e,t)):Object(r.f)(this.node(),e).delay}},function(t,e,n){"use strict";function durationFunction(t,e){return function(){Object(r.h)(this,t).duration=+e.apply(this,arguments)}}function durationConstant(t,e){return e=+e,function(){Object(r.h)(this,t).duration=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(("function"==typeof t?durationFunction:durationConstant)(e,t)):Object(r.f)(this.node(),e).duration}},function(t,e,n){"use strict";function easeConstant(t,e){if("function"!=typeof e)throw new Error;return function(){Object(r.h)(this,t).ease=e}}var r=n(2);e.a=function(t){var e=this._id;return arguments.length?this.each(easeConstant(e,t)):Object(r.f)(this.node(),e).ease}},function(t,e,n){"use strict";var r=n(3),a=n(7);e.a=function(t){"function"!=typeof t&&(t=Object(r.matcher)(t));for(var e=this._groups,n=e.length,i=new Array(n),o=0;o<n;++o)for(var u,c=e[o],s=c.length,f=i[o]=[],l=0;l<s;++l)(u=c[l])&&t.call(u,u.__data__,l,c)&&f.push(u);return new a.a(i,this._parents,this._name,this._id)}},function(t,e,n){"use strict";var r=n(7);e.a=function(t){if(t._id!==this._id)throw new Error;for(var e=this._groups,n=t._groups,a=e.length,i=n.length,o=Math.min(a,i),u=new Array(a),c=0;c<o;++c)for(var s,f=e[c],l=n[c],h=f.length,d=u[c]=new Array(h),p=0;p<h;++p)(s=f[p]||l[p])&&(d[p]=s);for(;c<a;++c)u[c]=e[c];return new r.a(u,this._parents,this._name,this._id)}},function(t,e,n){"use strict";function start(t){return(t+"").trim().split(/^|\s+/).every(function(t){var e=t.indexOf(".");return e>=0&&(t=t.slice(0,e)),!t||"start"===t})}function onFunction(t,e,n){var a,i,o=start(e)?r.g:r.h;return function(){var r=o(this,t),u=r.on;u!==a&&(i=(a=u).copy()).on(e,n),r.on=i}}var r=n(2);e.a=function(t,e){var n=this._id;return arguments.length<2?Object(r.f)(this.node(),n).on.on(t):this.each(onFunction(n,t,e))}},function(t,e,n){"use strict";function removeFunction(t){return function(){var e=this.parentNode;for(var n in this.__transition)if(+n!==t)return;e&&e.removeChild(this)}}e.a=function(){return this.on("end.remove",removeFunction(this._id))}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selector)(t));for(var o=this._groups,u=o.length,c=new Array(u),s=0;s<u;++s)for(var f,l,h=o[s],d=h.length,p=c[s]=new Array(d),b=0;b<d;++b)(f=h[b])&&(l=t.call(f,f.__data__,b,h))&&("__data__"in f&&(l.__data__=f.__data__),p[b]=l,Object(i.e)(p[b],e,n,b,p,Object(i.f)(f,n)));return new a.a(c,this._parents,e,n)}},function(t,e,n){"use strict";var r=n(3),a=n(7),i=n(2);e.a=function(t){var e=this._name,n=this._id;"function"!=typeof t&&(t=Object(r.selectorAll)(t));for(var o=this._groups,u=o.length,c=[],s=[],f=0;f<u;++f)for(var l,h=o[f],d=h.length,p=0;p<d;++p)if(l=h[p]){for(var b,v=t.call(l,l.__data__,p,h),m=Object(i.f)(l,n),y=0,g=v.length;y<g;++y)(b=v[y])&&Object(i.e)(b,e,n,y,v,m);c.push(v),s.push(l)}return new a.a(c,s,e,n)}},function(t,e,n){"use strict";var r=n(3),a=r.selection.prototype.constructor;e.a=function(){return new a(this._groups,this._parents)}},function(t,e,n){"use strict";function styleRemove(t,e){var n,r,i;return function(){var o=Object(a.style)(this,t),u=(this.style.removeProperty(t),Object(a.style)(this,t));return o===u?null:o===n&&u===r?i:i=e(n=o,r=u)}}function styleRemoveEnd(t){return function(){this.style.removeProperty(t)}}function styleConstant(t,e,n){var r,i;return function(){var o=Object(a.style)(this,t);return o===n?null:o===r?i:i=e(r=o,n)}}function styleFunction(t,e,n){var r,i,o;return function(){var u=Object(a.style)(this,t),c=n(this);return null==c&&(this.style.removeProperty(t),c=Object(a.style)(this,t)),u===c?null:u===r&&c===i?o:o=e(r=u,i=c)}}var r=n(8),a=n(3),i=n(17),o=n(60);e.a=function(t,e,n){var a="transform"==(t+="")?r.interpolateTransformCss:o.a;return null==e?this.styleTween(t,styleRemove(t,a)).on("end.style."+t,styleRemoveEnd(t)):this.styleTween(t,"function"==typeof e?styleFunction(t,a,Object(i.b)(this,"style."+t,e)):styleConstant(t,a,e+""),n)}},function(t,e,n){"use strict";function styleTween(t,e,n){function tween(){var r=this,a=e.apply(r,arguments);return a&&function(e){r.style.setProperty(t,a(e),n)}}return tween._value=e,tween}e.a=function(t,e,n){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==e)return this.tween(r,null);if("function"!=typeof e)throw new Error;return this.tween(r,styleTween(t,e,null==n?"":n))}},function(t,e,n){"use strict";function textConstant(t){return function(){this.textContent=t}}function textFunction(t){return function(){var e=t(this);this.textContent=null==e?"":e}}var r=n(17);e.a=function(t){return this.tween("text","function"==typeof t?textFunction(Object(r.b)(this,"text",t)):textConstant(null==t?"":t+""))}},function(t,e,n){"use strict";var r=n(7),a=n(2);e.a=function(){for(var t=this._name,e=this._id,n=Object(r.c)(),i=this._groups,o=i.length,u=0;u<o;++u)for(var c,s=i[u],f=s.length,l=0;l<f;++l)if(c=s[l]){var h=Object(a.f)(c,e);Object(a.e)(c,t,n,l,s,{time:h.time+h.delay+h.duration,delay:0,duration:h.duration,ease:h.ease})}return new r.a(i,this._parents,t,n)}},function(t,e,n){"use strict";var r=n(7),a=n(2),i=[null];e.a=function(t,e){var n,o,u=t.__transition;if(u){e=null==e?null:e+"";for(o in u)if((n=u[o]).state>a.c&&n.name===e)return new r.a([[t]],i,e,+o)}return null}},,,,,,,,,,,,,,,,,,,,,function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(){},function(t,e){t.setTime(+t+e)},function(t,e){return e-t});a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)(function(e){e.setTime(Math.floor(e/t)*t)},function(e,n){e.setTime(+e+n*t)},function(e,n){return(n-e)/t}):a:null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.d)*a.d)},function(t,e){t.setTime(+t+e*a.d)},function(t,e){return(e-t)/a.d},function(t){return t.getUTCSeconds()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setTime(Math.floor(t/a.c)*a.c)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){var e=t.getTimezoneOffset()*a.c%a.b;e<0&&(e+=a.b),t.setTime(Math.floor((+t-e)/a.b)*a.b+e)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"a",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.a},function(t){return t.getDate()-1});e.b=i;var o=i.range},function(t,e,n){"use strict";function weekday(t){return Object(r.a)(function(e){e.setDate(e.getDate()-(e.getDay()+7-t)%7),e.setHours(0,0,0,0)},function(t,e){t.setDate(t.getDate()+7*e)},function(t,e){return(e-t-(e.getTimezoneOffset()-t.getTimezoneOffset())*a.c)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=weekday(0),o=weekday(1),u=weekday(2),c=weekday(3),s=weekday(4),f=weekday(5),l=weekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setDate(1),t.setHours(0,0,0,0)},function(t,e){t.setMonth(t.getMonth()+e)},function(t,e){return e.getMonth()-t.getMonth()+12*(e.getFullYear()-t.getFullYear())},function(t){return t.getMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setMonth(0,1),t.setHours(0,0,0,0)},function(t,e){t.setFullYear(t.getFullYear()+e)},function(t,e){return e.getFullYear()-t.getFullYear()},function(t){return t.getFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setFullYear(Math.floor(e.getFullYear()/t)*t),e.setMonth(0,1),e.setHours(0,0,0,0)},function(e,n){e.setFullYear(e.getFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCSeconds(0,0)},function(t,e){t.setTime(+t+e*a.c)},function(t,e){return(e-t)/a.c},function(t){return t.getUTCMinutes()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCMinutes(0,0,0)},function(t,e){t.setTime(+t+e*a.b)},function(t,e){return(e-t)/a.b},function(t){return t.getUTCHours()});e.a=i;var o=i.range},function(t,e,n){"use strict";n.d(e,"b",function(){return o});var r=n(0),a=n(6),i=Object(r.a)(function(t){t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+e)},function(t,e){return(e-t)/a.a},function(t){return t.getUTCDate()-1});e.a=i;var o=i.range},function(t,e,n){"use strict";function utcWeekday(t){return Object(r.a)(function(e){e.setUTCDate(e.getUTCDate()-(e.getUTCDay()+7-t)%7),e.setUTCHours(0,0,0,0)},function(t,e){t.setUTCDate(t.getUTCDate()+7*e)},function(t,e){return(e-t)/a.e})}n.d(e,"g",function(){return i}),n.d(e,"c",function(){return o}),n.d(e,"k",function(){return u}),n.d(e,"m",function(){return c}),n.d(e,"i",function(){return s}),n.d(e,"a",function(){return f}),n.d(e,"e",function(){return l}),n.d(e,"h",function(){return h}),n.d(e,"d",function(){return d}),n.d(e,"l",function(){return p}),n.d(e,"n",function(){return b}),n.d(e,"j",function(){return v}),n.d(e,"b",function(){return m}),n.d(e,"f",function(){return y});var r=n(0),a=n(6),i=utcWeekday(0),o=utcWeekday(1),u=utcWeekday(2),c=utcWeekday(3),s=utcWeekday(4),f=utcWeekday(5),l=utcWeekday(6),h=i.range,d=o.range,p=u.range,b=c.range,v=s.range,m=f.range,y=l.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCMonth(t.getUTCMonth()+e)},function(t,e){return e.getUTCMonth()-t.getUTCMonth()+12*(e.getUTCFullYear()-t.getUTCFullYear())},function(t){return t.getUTCMonth()});e.a=a;var i=a.range},function(t,e,n){"use strict";n.d(e,"b",function(){return i});var r=n(0),a=Object(r.a)(function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},function(t,e){t.setUTCFullYear(t.getUTCFullYear()+e)},function(t,e){return e.getUTCFullYear()-t.getUTCFullYear()},function(t){return t.getUTCFullYear()});a.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)(function(e){e.setUTCFullYear(Math.floor(e.getUTCFullYear()/t)*t),e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0)},function(e,n){e.setUTCFullYear(e.getUTCFullYear()+n*t)}):null},e.a=a;var i=a.range},function(t,e,n){"use strict";function parseIsoNative(t){var e=new Date(t);return isNaN(e)?null:e}var r=n(80),a=n(37),i=+new Date("2000-01-01T00:00:00.000Z")?parseIsoNative:Object(a.e)(r.b);e.a=i},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,function(t,e,n){"use strict";var r;void 0!==(r=function(t){function addDays(t,e){var n=new Date(t);return n.setDate(n.getDate()+e),String(n)}function calculatePercent(t,n,r){var a=n?t/n*100:0;return e.format(r)(a)}function diffDays(t,e){return Math.ceil(Math.abs((new Date(t).getTime()-new Date(e).getTime())/864e5))}function isInteger(t){return t%1==0}function uniqueId(t){var e=++r;return t.toString()+"-"+e}var e=n(21),r=0;return{addDays:addDays,calculatePercent:calculatePercent,diffDays:diffDays,isInteger:isInteger,uniqueId:uniqueId}}.call(e,n,e,t))&&(t.exports=r)},,,function(t,e,n){"use strict";var r;void 0!==(r=function(t){function getValueSize(t,e){var n="large";return t<e.small.limit?n="small":t<e.medium.limit&&(n="medium"),n}function formatIntegerValue(t){var e=getValueSize(t,r);return(0,r[e].format)(t)}function formatDecimalValue(t){var e=getValueSize(t,a);return(0,a[e].format)(t)}var e=n(21),r={small:{limit:10,format:e.format("")},medium:{limit:1e3,format:e.format("")},large:{limit:null,format:e.format(".2s")}},a={small:{limit:10,format:e.format(".3f")},medium:{limit:100,format:e.format(".1f")},large:{limit:null,format:e.format(".2s")}};return{formatDecimalValue:formatDecimalValue,formatIntegerValue:formatIntegerValue}}.call(e,n,e,t))&&(t.exports=r)},,,,,,,,,function(t,e,n){"use strict";var r,a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=function(){function sliceIterator(t,e){var n=[],r=!0,a=!1,i=void 0;try{for(var o,u=t[Symbol.iterator]();!(r=(o=u.next()).done)&&(n.push(o.value),!e||n.length!==e);r=!0);}catch(t){a=!0,i=t}finally{try{!r&&u.return&&u.return()}finally{if(a)throw i}}return n}return function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return sliceIterator(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();void 0!==(r=function(t){var e=n(65),r=n(21),o=n(3),u=(n(91),n(40)),c=n(90),s=c.axisTimeCombinations,f=n(291),l=f.formatIntegerValue,h=f.formatDecimalValue,d=n(288),p=d.isInteger;return function(){function exports(e){e.each(function(e){Q=n-t.left-t.right,J=c-t.top-t.bottom,tt=e,buildSVG(this)})}function buildContainerGroups(){et.append("g").classed("tooltip-container-group",!0).attr("transform","translate( "+t.left+", "+t.top+")").append("g").classed("tooltip-group",!0)}function buildSVG(t){et||(et=o.select(t).append("g").classed("britechart britechart-tooltip",!0).style("display","none"),buildContainerGroups(),drawTooltip()),et.transition().attr("width",n).attr("height",c),exports.hide()}function cleanContent(){x.selectAll("text").remove(),x.selectAll("circle").remove()}function drawTooltip(){g=et.selectAll(".tooltip-group").append("g").classed("tooltip-text",!0),v=g.append("rect").classed("tooltip-text-container",!0).attr("x",-O/4+8).attr("y",0).attr("width",O).attr("height",M).attr("rx",C).attr("ry",C).style("fill",P).style("stroke",R).style("stroke-width",1),w=g.append("text").classed("tooltip-title",!0).attr("x",-O/4+16).attr("dy",".35em").attr("y",16).style("fill",L),_=g.append("line").classed("tooltip-divider",!0).attr("x1",-O/4+16).attr("x2",265).attr("y1",31).attr("y2",31).style("stroke",R),x=g.append("g").classed("tooltip-body",!0).style("transform","translateY(8px)").style("fill",U)}function getFormattedValue(t){var e=h;return t?(b?e=r.format(b):p(t)&&(e=l),e(t)):0}function getTooltipPosition(t){var e=i(t,2),n=e[0],r=(e[1],void 0),a=void 0;return r=n-O<0?O-185:-205,a=m.y,[r,a]}function getValueText(t){var e=t[q];return t.missingValue?"-":getFormattedValue(e).toString()}function resetSizeAndPositionPointers(){M=48,T=37,j=0}function updateTopicContent(t){var e=t[B],n=void 0,r=void 0,a=void 0,i=void 0,o=void 0;a=t.topicName||e,i=getValueText(t),o=x.append("text").classed("tooltip-left-text",!0).attr("dy","1em").attr("x",j).attr("y",T).style("fill",H).text(a).call(textWrap,y,N),r=x.append("text").classed("tooltip-right-text",!0).attr("dy","1em").attr("x",j).attr("y",T).style("fill",H).text(i),k=o.node().getBBox(),n=k.height?k.height:18.4,M+=n+A,r.attr("x",O-r.node().getBBox().width-10-O/4),x.append("circle").classed("tooltip-circle",!0).attr("cx",23-O/4).attr("cy",T+F).attr("r",5).style("fill",I[e]).style("stroke-width",1),T+=n+7}function updatePositionAndSize(t,e,n){var r=getTooltipPosition([e,n]),a=i(r,2),o=a[0],u=a[1];v.attr("width",O).attr("height",M+10),g.transition().duration(E).ease(D).attr("transform","translate("+o+", "+u+")"),_.attr("x2",O-60)}function updateTitle(t){var e=f,n=formatDate(new Date(t[Y]));e.length?d&&(e=e+" - "+n):e=n,w.text(e)}function formatDate(t){var e=V||W,n=null,r={month:"short",day:"numeric"};if(e===s.DAY_MONTH||e===s.MONTH_YEAR?(n=Z,r.year="numeric"):e===s.HOUR_DAY||e===s.MINUTE_HOUR?(n=$,r.hour="numeric"):e===s.CUSTOM&&"string"==typeof G&&(n=u.timeFormat(G)),K&&"undefined"!=typeof Intl&&"object"===("undefined"==typeof Intl?"undefined":a(Intl))&&Intl.DateTimeFormat){return Intl.DateTimeFormat(K,r).format(t)}return n(t)}function _sortByTopicsOrder(t){return(arguments.length>1&&void 0!==arguments[1]?arguments[1]:X).map(function(e){return t.filter(function(t){return t.name===e})[0]})}function _sortByAlpha(t){return t.map(function(t){return t}).sort(function(t,e){return t.name>e.name?1:t.name===e.name?0:-1})}function textWrap(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;t.each(function(){var r,a,i,u,c,s,f,l;for(t=o.select(this),r=t.text().split(/\s+/).reverse(),i=[],u=0,c=1.2,s=t.attr("y"),f=parseFloat(t.attr("dy")),l=t.text(null).append("tspan").attr("x",n).attr("y",s).attr("dy",f+"em");a=r.pop();)i.push(a),l.text(i.join(" ")),l.node().getComputedTextLength()>e&&(i.pop(),l.text(i.join(" ")),u<S-1&&(i=[a],l=t.append("tspan").attr("x",n).attr("y",s).attr("dy",++u*c+f+"em").text(a)))})}function updateContent(t){var e=t[z];X.length?e=_sortByTopicsOrder(e):e.length&&e[0].name&&(e=_sortByAlpha(e)),cleanContent(),updateTitle(t),resetSizeAndPositionPointers(),e.forEach(updateTopicContent)}function updateTooltip(t,e,n){updateContent(t),updatePositionAndSize(t,e,n)}var t={top:2,right:2,bottom:2,left:2},n=250,c=45,f="Tooltip title",d=!0,b=null,v=void 0,m={y:-55,x:0},y=170,g=void 0,_=void 0,x=void 0,w=void 0,O=250,M=48,C=3,j=0,T=37,k=void 0,S=3,N=-25,A=5,E=100,D=e.easeQuadInOut,F=8,I=void 0,P="#FFFFFF",R="#D2D6DF",L="#6D717A",U="#282C35",H="#000000",Y="date",q="value",B="name",z="topics",W=s.DAY_MONTH,V=null,G=null,X=[],Z=u.timeFormat("%b %d, %Y"),$=u.timeFormat("%b %d, %I %p"),K=void 0,Q=void 0,J=void 0,tt=void 0,et=void 0;return exports.axisTimeCombinations=s,exports.dateFormat=function(t){return arguments.length?(V=t,this):V||W},exports.dateCustomFormat=function(t){return arguments.length?(G=t,this):G},exports.dateLabel=function(t){return arguments.length?(Y=t,this):Y},exports.hide=function(){return et.style("display","none"),this},exports.locale=function(t){return arguments.length?(K=t,this):K},exports.nameLabel=function(t){return arguments.length?(B=t,this):B},exports.shouldShowDateInTitle=function(t){return arguments.length?(d=t,this):d},exports.show=function(){return et.style("display","block"),this},exports.title=function(t){return arguments.length?(f=t,this):f},exports.tooltipOffset=function(t){return arguments.length?(m=t,this):m},exports.topicsOrder=function(t){return arguments.length?(X=t,this):X},exports.topicLabel=function(t){return arguments.length?(z=t,this):z},exports.update=function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null;return I=e,updateTooltip(t,n,r),this},exports.valueFormat=function(t){return arguments.length?(b=t,this):b},exports.valueLabel=function(t){return arguments.length?(q=t,this):q},exports}}.call(e,n,e,t))&&(t.exports=r)}])})}]);
	//# sourceMappingURL=britecharts-react.min.js.map

/***/ },
/* 725 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(738);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(741);
	__webpack_require__(742);
	__webpack_require__(743);
	__webpack_require__(744);
	__webpack_require__(745);
	__webpack_require__(746);
	__webpack_require__(747);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(753);
	__webpack_require__(754);
	module.exports = __webpack_require__(244).Math;

/***/ },
/* 727 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(247);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(727);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(247)
	  , document = __webpack_require__(246).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 731 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(245) && !__webpack_require__(182)(function(){
	  return Object.defineProperty(__webpack_require__(730)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(728)
	  , IE8_DOM_DEFINE = __webpack_require__(732)
	  , toPrimitive    = __webpack_require__(736)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(245) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 734 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(246)
	  , hide      = __webpack_require__(380)
	  , has       = __webpack_require__(731)
	  , SRC       = __webpack_require__(737)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(244).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(247);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 737 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(39)
	  , log1p   = __webpack_require__(381)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(39)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(39)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(39)
	  , sign    = __webpack_require__(249);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(39);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(39)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(39)
	  , $expm1  = __webpack_require__(248);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(39)
	  , sign      = __webpack_require__(249)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(39)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(39)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(182)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(39);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(39);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(381)});

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(39);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(39);
	
	$export($export.S, 'Math', {sign: __webpack_require__(249)});

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(39)
	  , expm1   = __webpack_require__(248)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(182)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(39)
	  , expm1   = __webpack_require__(248)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(39);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var emptyObject = __webpack_require__(43);
	var _invariant = __webpack_require__(4);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @nosideeffects
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function (Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function (Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function (Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	    },
	    contextTypes: function (Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function (Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function (Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function (Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function () {} };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	      }
	
	      return;
	    }
	
	    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
	    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
	
	      var isInherited = name in Constructor;
	      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function (newThis) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	        } else if (!args.length) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedMixin = {
	    componentDidMount: function () {
	      this.__isMounted = true;
	    },
	    componentWillUnmount: function () {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function (newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function () {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function () {};
	  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedMixin);
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * cuid.js
	 * Collision-resistant UID generator for browsers and node.
	 * Sequential for fast db lookups and recency sorting.
	 * Safe for element IDs and server-side lookups.
	 *
	 * Extracted from CLCTR
	 *
	 * Copyright (c) Eric Elliott 2012
	 * MIT License
	 */
	
	/*global window, navigator, document, require, process, module */
	(function (app) {
	  'use strict';
	  var namespace = 'cuid',
	    c = 0,
	    blockSize = 4,
	    base = 36,
	    discreteValues = Math.pow(base, blockSize),
	
	    pad = function pad(num, size) {
	      var s = "000000000" + num;
	      return s.substr(s.length-size);
	    },
	
	    randomBlock = function randomBlock() {
	      return pad((Math.random() *
	            discreteValues << 0)
	            .toString(base), blockSize);
	    },
	
	    safeCounter = function () {
	      c = (c < discreteValues) ? c : 0;
	      c++; // this is not subliminal
	      return c - 1;
	    },
	
	    api = function cuid() {
	      // Starting with a lowercase letter makes
	      // it HTML element ID friendly.
	      var letter = 'c', // hard-coded allows for sequential access
	
	        // timestamp
	        // warning: this exposes the exact date and time
	        // that the uid was created.
	        timestamp = (new Date().getTime()).toString(base),
	
	        // Prevent same-machine collisions.
	        counter,
	
	        // A few chars to generate distinct ids for different
	        // clients (so different computers are far less
	        // likely to generate the same id)
	        fingerprint = api.fingerprint(),
	
	        // Grab some more chars from Math.random()
	        random = randomBlock() + randomBlock();
	
	        counter = pad(safeCounter().toString(base), blockSize);
	
	      return  (letter + timestamp + counter + fingerprint + random);
	    };
	
	  api.slug = function slug() {
	    var date = new Date().getTime().toString(36),
	      counter,
	      print = api.fingerprint().slice(0,1) +
	        api.fingerprint().slice(-1),
	      random = randomBlock().slice(-2);
	
	      counter = safeCounter().toString(36).slice(-4);
	
	    return date.slice(-2) +
	      counter + print + random;
	  };
	
	  api.globalCount = function globalCount() {
	    // We want to cache the results of this
	    var cache = (function calc() {
	        var i,
	          count = 0;
	
	        for (i in window) {
	          count++;
	        }
	
	        return count;
	      }());
	
	    api.globalCount = function () { return cache; };
	    return cache;
	  };
	
	  api.fingerprint = function browserPrint() {
	    return pad((navigator.mimeTypes.length +
	      navigator.userAgent.length).toString(36) +
	      api.globalCount().toString(36), 4);
	  };
	
	  // don't change anything from here down.
	  if (app.register) {
	    app.register(namespace, api);
	  } else if (true) {
	    module.exports = api;
	  } else {
	    app[namespace] = api;
	  }
	
	}(this.applitude || this));


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-chord/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(758), __webpack_require__(120)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Path) { 'use strict';
	
	var cos = Math.cos;
	var sin = Math.sin;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = pi * 2;
	var max = Math.max;
	
	function compareValue(compare) {
	  return function(a, b) {
	    return compare(
	      a.source.value + a.target.value,
	      b.source.value + b.target.value
	    );
	  };
	}
	
	var chord = function() {
	  var padAngle = 0,
	      sortGroups = null,
	      sortSubgroups = null,
	      sortChords = null;
	
	  function chord(matrix) {
	    var n = matrix.length,
	        groupSums = [],
	        groupIndex = d3Array.range(n),
	        subgroupIndex = [],
	        chords = [],
	        groups = chords.groups = new Array(n),
	        subgroups = new Array(n * n),
	        k,
	        x,
	        x0,
	        dx,
	        i,
	        j;
	
	    // Compute the sum.
	    k = 0, i = -1; while (++i < n) {
	      x = 0, j = -1; while (++j < n) {
	        x += matrix[i][j];
	      }
	      groupSums.push(x);
	      subgroupIndex.push(d3Array.range(n));
	      k += x;
	    }
	
	    // Sort groups…
	    if (sortGroups) groupIndex.sort(function(a, b) {
	      return sortGroups(groupSums[a], groupSums[b]);
	    });
	
	    // Sort subgroups…
	    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
	      d.sort(function(a, b) {
	        return sortSubgroups(matrix[i][a], matrix[i][b]);
	      });
	    });
	
	    // Convert the sum to scaling factor for [0, 2pi].
	    // TODO Allow start and end angle to be specified?
	    // TODO Allow padding to be specified as percentage?
	    k = max(0, tau - padAngle * n) / k;
	    dx = k ? padAngle : tau / n;
	
	    // Compute the start and end angle for each group and subgroup.
	    // Note: Opera has a bug reordering object literal properties!
	    x = 0, i = -1; while (++i < n) {
	      x0 = x, j = -1; while (++j < n) {
	        var di = groupIndex[i],
	            dj = subgroupIndex[di][j],
	            v = matrix[di][dj],
	            a0 = x,
	            a1 = x += v * k;
	        subgroups[dj * n + di] = {
	          index: di,
	          subindex: dj,
	          startAngle: a0,
	          endAngle: a1,
	          value: v
	        };
	      }
	      groups[di] = {
	        index: di,
	        startAngle: x0,
	        endAngle: x,
	        value: groupSums[di]
	      };
	      x += dx;
	    }
	
	    // Generate chords for each (non-empty) subgroup-subgroup link.
	    i = -1; while (++i < n) {
	      j = i - 1; while (++j < n) {
	        var source = subgroups[j * n + i],
	            target = subgroups[i * n + j];
	        if (source.value || target.value) {
	          chords.push(source.value < target.value
	              ? {source: target, target: source}
	              : {source: source, target: target});
	        }
	      }
	    }
	
	    return sortChords ? chords.sort(sortChords) : chords;
	  }
	
	  chord.padAngle = function(_) {
	    return arguments.length ? (padAngle = max(0, _), chord) : padAngle;
	  };
	
	  chord.sortGroups = function(_) {
	    return arguments.length ? (sortGroups = _, chord) : sortGroups;
	  };
	
	  chord.sortSubgroups = function(_) {
	    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
	  };
	
	  chord.sortChords = function(_) {
	    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
	  };
	
	  return chord;
	};
	
	var slice = Array.prototype.slice;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultSource(d) {
	  return d.source;
	}
	
	function defaultTarget(d) {
	  return d.target;
	}
	
	function defaultRadius(d) {
	  return d.radius;
	}
	
	function defaultStartAngle(d) {
	  return d.startAngle;
	}
	
	function defaultEndAngle(d) {
	  return d.endAngle;
	}
	
	var ribbon = function() {
	  var source = defaultSource,
	      target = defaultTarget,
	      radius = defaultRadius,
	      startAngle = defaultStartAngle,
	      endAngle = defaultEndAngle,
	      context = null;
	
	  function ribbon() {
	    var buffer,
	        argv = slice.call(arguments),
	        s = source.apply(this, argv),
	        t = target.apply(this, argv),
	        sr = +radius.apply(this, (argv[0] = s, argv)),
	        sa0 = startAngle.apply(this, argv) - halfPi,
	        sa1 = endAngle.apply(this, argv) - halfPi,
	        sx0 = sr * cos(sa0),
	        sy0 = sr * sin(sa0),
	        tr = +radius.apply(this, (argv[0] = t, argv)),
	        ta0 = startAngle.apply(this, argv) - halfPi,
	        ta1 = endAngle.apply(this, argv) - halfPi;
	
	    if (!context) context = buffer = d3Path.path();
	
	    context.moveTo(sx0, sy0);
	    context.arc(0, 0, sr, sa0, sa1);
	    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
	      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
	      context.arc(0, 0, tr, ta0, ta1);
	    }
	    context.quadraticCurveTo(0, 0, sx0, sy0);
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  ribbon.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), ribbon) : radius;
	  };
	
	  ribbon.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), ribbon) : startAngle;
	  };
	
	  ribbon.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), ribbon) : endAngle;
	  };
	
	  ribbon.source = function(_) {
	    return arguments.length ? (source = _, ribbon) : source;
	  };
	
	  ribbon.target = function(_) {
	    return arguments.length ? (target = _, ribbon) : target;
	  };
	
	  ribbon.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
	  };
	
	  return ribbon;
	};
	
	exports.chord = chord;
	exports.ribbon = ribbon;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse = stop < start,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  if (reverse) n = start, start = stop, stop = n;
	
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI;
	var halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11;
	var b2 = 6 / 11;
	var b3 = 8 / 11;
	var b4 = 3 / 4;
	var b5 = 9 / 11;
	var b6 = 10 / 11;
	var b7 = 15 / 16;
	var b8 = 21 / 22;
	var b9 = 63 / 64;
	var b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI;
	var amplitude = 1;
	var period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/d3/d3-hexbin Version 0.2.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var thirdPi = Math.PI / 3;
	var angles = [0, thirdPi, 2 * thirdPi, 3 * thirdPi, 4 * thirdPi, 5 * thirdPi];
	
	function pointX(d) {
	  return d[0];
	}
	
	function pointY(d) {
	  return d[1];
	}
	
	var hexbin = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 1,
	      y1 = 1,
	      x = pointX,
	      y = pointY,
	      r,
	      dx,
	      dy;
	
	  function hexbin(points) {
	    var binsById = {}, bins = [], i, n = points.length;
	
	    for (i = 0; i < n; ++i) {
	      if (isNaN(px = +x.call(null, point = points[i], i, points))
	          || isNaN(py = +y.call(null, point, i, points))) continue;
	
	      var point,
	          px,
	          py,
	          pj = Math.round(py = py / dy),
	          pi = Math.round(px = px / dx - (pj & 1) / 2),
	          py1 = py - pj;
	
	      if (Math.abs(py1) * 3 > 1) {
	        var px1 = px - pi,
	            pi2 = pi + (px < pi ? -1 : 1) / 2,
	            pj2 = pj + (py < pj ? -1 : 1),
	            px2 = px - pi2,
	            py2 = py - pj2;
	        if (px1 * px1 + py1 * py1 > px2 * px2 + py2 * py2) pi = pi2 + (pj & 1 ? 1 : -1) / 2, pj = pj2;
	      }
	
	      var id = pi + "-" + pj, bin = binsById[id];
	      if (bin) bin.push(point);
	      else {
	        bins.push(bin = binsById[id] = [point]);
	        bin.x = (pi + (pj & 1) / 2) * dx;
	        bin.y = pj * dy;
	      }
	    }
	
	    return bins;
	  }
	
	  function hexagon(radius) {
	    var x0 = 0, y0 = 0;
	    return angles.map(function(angle) {
	      var x1 = Math.sin(angle) * radius,
	          y1 = -Math.cos(angle) * radius,
	          dx = x1 - x0,
	          dy = y1 - y0;
	      x0 = x1, y0 = y1;
	      return [dx, dy];
	    });
	  }
	
	  hexbin.hexagon = function(radius) {
	    return "m" + hexagon(radius == null ? r : +radius).join("l") + "z";
	  };
	
	  hexbin.centers = function() {
	    var centers = [],
	        j = Math.round(y0 / dy),
	        i = Math.round(x0 / dx);
	    for (var y = j * dy; y < y1 + r; y += dy, ++j) {
	      for (var x = i * dx + (j & 1) * dx / 2; x < x1 + dx / 2; x += dx) {
	        centers.push([x, y]);
	      }
	    }
	    return centers;
	  };
	
	  hexbin.mesh = function() {
	    var fragment = hexagon(r).slice(0, 4).join("l");
	    return hexbin.centers().map(function(p) { return "M" + p + "m" + fragment; }).join("");
	  };
	
	  hexbin.x = function(_) {
	    return arguments.length ? (x = _, hexbin) : x;
	  };
	
	  hexbin.y = function(_) {
	    return arguments.length ? (y = _, hexbin) : y;
	  };
	
	  hexbin.radius = function(_) {
	    return arguments.length ? (r = +_, dx = r * 2 * Math.sin(thirdPi), dy = r * 1.5, hexbin) : r;
	  };
	
	  hexbin.size = function(_) {
	    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], hexbin) : [x1 - x0, y1 - y0];
	  };
	
	  hexbin.extent = function(_) {
	    return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], hexbin) : [[x0, y0], [x1, y1]];
	  };
	
	  return hexbin.radius(1);
	};
	
	exports.hexbin = hexbin;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(762), __webpack_require__(763), __webpack_require__(765)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate'], factory) :
	  (factory((global.d3_sankey = global.d3_sankey || {}),global.d3_array,global.d3_collection,global.d3_interpolate));
	}(this, function (exports,d3Array,d3Collection,d3Interpolate) { 'use strict';
	
	  var version = "0.1.0";
	
	  function sankey() {
	    var sankey = {},
	        nodeWidth = 24,
	        nodePadding = 8,
	        size = [1, 1],
	        align = 'justify', // left, right, center or justify
	        nodes = [],
	        links = [];
	
	    sankey.nodeWidth = function(_) {
	      if (!arguments.length) return nodeWidth;
	      nodeWidth = +_;
	      return sankey;
	    };
	
	    sankey.nodePadding = function(_) {
	      if (!arguments.length) return nodePadding;
	      nodePadding = +_;
	      return sankey;
	    };
	
	    sankey.nodes = function(_) {
	      if (!arguments.length) return nodes;
	      nodes = _;
	      return sankey;
	    };
	
	    sankey.links = function(_) {
	      if (!arguments.length) return links;
	      links = _;
	      return sankey;
	    };
	
	    sankey.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return sankey;
	    };
	
	    sankey.align = function(_) {
	      if (!arguments.length) return align;
	      align = _.toLowerCase();
	      return sankey;
	    };
	
	    sankey.layout = function(iterations) {
	      computeNodeLinks();
	      computeNodeValues();
	      computeNodeBreadths();
	      computeNodeDepths(iterations);
	      computeLinkDepths();
	      return sankey;
	    };
	
	    sankey.relayout = function() {
	      computeLinkDepths();
	      return sankey;
	    };
	
	    sankey.link = function() {
	      var curvature = .5;
	
	      function link(d) {
	        var x0 = d.source.x + d.source.dx,
	            x1 = d.target.x,
	            xi = d3Interpolate.number(x0, x1),
	            x2 = xi(curvature),
	            x3 = xi(1 - curvature),
	            y0 = d.source.y + d.sy + d.dy / 2,
	            y1 = d.target.y + d.ty + d.dy / 2;
	        return "M" + x0 + "," + y0
	             + "C" + x2 + "," + y0
	             + " " + x3 + "," + y1
	             + " " + x1 + "," + y1;
	      }
	
	      link.curvature = function(_) {
	        if (!arguments.length) return curvature;
	        curvature = +_;
	        return link;
	      };
	
	      return link;
	    };
	
	    // Populate the sourceLinks and targetLinks for each node.
	    // Also, if the source and target are not objects, assume they are indices.
	    function computeNodeLinks() {
	      nodes.forEach(function(node) {
	        node.sourceLinks = [];
	        node.targetLinks = [];
	      });
	      links.forEach(function(link) {
	        var source = link.source,
	            target = link.target;
	        if (typeof source === "number") source = link.source = nodes[link.source];
	        if (typeof target === "number") target = link.target = nodes[link.target];
	        source.sourceLinks.push(link);
	        target.targetLinks.push(link);
	      });
	    }
	
	    // Compute the value (size) of each node by summing the associated links.
	    function computeNodeValues() {
	      nodes.forEach(function(node) {
	        node.value = Math.max(
	          d3Array.sum(node.sourceLinks, value),
	          d3Array.sum(node.targetLinks, value)
	        );
	      });
	    }
	
	    // Iteratively assign the breadth (x-position) for each node.
	    // Nodes are assigned the maximum breadth of incoming neighbors plus one;
	    // nodes with no incoming links are assigned breadth zero, while
	    // nodes with no outgoing links are assigned the maximum breadth.
	    function computeNodeBreadths() {
	      var remainingNodes = nodes,
	          nextNodes,
	          x = 0,
	          reverse = (align === 'right'); // Reverse traversal direction
	
	      while (remainingNodes.length) {
	        nextNodes = [];
	        remainingNodes.forEach(function(node) {
	          node.x = x;
	          node.dx = nodeWidth;
	
	          node[reverse ? 'targetLinks' : 'sourceLinks'].forEach(function(link) {
	            var nextNode = link[reverse ? 'source' : 'target'];
	            if (nextNodes.indexOf(nextNode) < 0) {
	              nextNodes.push(nextNode);
	            }
	          });
	        });
	        remainingNodes = nextNodes;
	        ++x;
	      }
	
	      if (reverse) {
	        // Flip nodes horizontally
	        nodes.forEach(function(node) {
	          node.x *= -1;
	          node.x += x - 1;
	        });
	      }
	
	      if (align === 'center') {
	        moveSourcesRight();
	      }
	      if (align === 'justify') {
	        moveSinksRight(x);
	      }
	
	      scaleNodeBreadths((size[0] - nodeWidth) / (x - 1));
	    }
	
	    function moveSourcesRight() {
	      nodes.slice()
	        // Pack nodes from right to left
	        .sort(function(a, b) { return b.x - a.x; })
	        .forEach(function(node) {
	          if (!node.targetLinks.length) {
	            node.x = d3Array.min(node.sourceLinks, function(d) { return d.target.x; }) - 1;
	          }
	        });
	    }
	
	    function moveSinksRight(x) {
	      nodes.forEach(function(node) {
	        if (!node.sourceLinks.length) {
	          node.x = x - 1;
	        }
	      });
	    }
	
	    function scaleNodeBreadths(kx) {
	      nodes.forEach(function(node) {
	        node.x *= kx;
	      });
	    }
	
	    function computeNodeDepths(iterations) {
	      var nodesByBreadth = d3Collection.nest()
	          .key(function(d) { return d.x; })
	          .sortKeys(d3Array.ascending)
	          .entries(nodes)
	          .map(function(d) { return d.values; });
	
	      //
	      initializeNodeDepth();
	      resolveCollisions();
	      for (var alpha = 1; iterations > 0; --iterations) {
	        relaxRightToLeft(alpha *= .99);
	        resolveCollisions();
	        relaxLeftToRight(alpha);
	        resolveCollisions();
	      }
	
	      function initializeNodeDepth() {
	        var ky = d3Array.min(nodesByBreadth, function(nodes) {
	          return (size[1] - (nodes.length - 1) * nodePadding) / d3Array.sum(nodes, value);
	        });
	
	        nodesByBreadth.forEach(function(nodes) {
	          nodes.forEach(function(node, i) {
	            node.y = i;
	            node.dy = node.value * ky;
	          });
	        });
	
	        links.forEach(function(link) {
	          link.dy = link.value * ky;
	        });
	      }
	
	      function relaxLeftToRight(alpha) {
	        nodesByBreadth.forEach(function(nodes) {
	          nodes.forEach(function(node) {
	            if (node.targetLinks.length) {
	              var y = d3Array.sum(node.targetLinks, weightedSource) / d3Array.sum(node.targetLinks, value);
	              node.y += (y - center(node)) * alpha;
	            }
	          });
	        });
	
	        function weightedSource(link) {
	          return center(link.source) * link.value;
	        }
	      }
	
	      function relaxRightToLeft(alpha) {
	        nodesByBreadth.slice().reverse().forEach(function(nodes) {
	          nodes.forEach(function(node) {
	            if (node.sourceLinks.length) {
	              var y = d3Array.sum(node.sourceLinks, weightedTarget) / d3Array.sum(node.sourceLinks, value);
	              node.y += (y - center(node)) * alpha;
	            }
	          });
	        });
	
	        function weightedTarget(link) {
	          return center(link.target) * link.value;
	        }
	      }
	
	      function resolveCollisions() {
	        nodesByBreadth.forEach(function(nodes) {
	          var node,
	              dy,
	              y0 = 0,
	              n = nodes.length,
	              i;
	
	          // Push any overlapping nodes down.
	          nodes.sort(ascendingDepth);
	          for (i = 0; i < n; ++i) {
	            node = nodes[i];
	            dy = y0 - node.y;
	            if (dy > 0) node.y += dy;
	            y0 = node.y + node.dy + nodePadding;
	          }
	
	          // If the bottommost node goes outside the bounds, push it back up.
	          dy = y0 - nodePadding - size[1];
	          if (dy > 0) {
	            y0 = node.y -= dy;
	
	            // Push any overlapping nodes back up.
	            for (i = n - 2; i >= 0; --i) {
	              node = nodes[i];
	              dy = node.y + node.dy + nodePadding - y0;
	              if (dy > 0) node.y -= dy;
	              y0 = node.y;
	            }
	          }
	        });
	      }
	
	      function ascendingDepth(a, b) {
	        return a.y - b.y;
	      }
	    }
	
	    function computeLinkDepths() {
	      nodes.forEach(function(node) {
	        node.sourceLinks.sort(ascendingTargetDepth);
	        node.targetLinks.sort(ascendingSourceDepth);
	      });
	      nodes.forEach(function(node) {
	        var sy = 0, ty = 0;
	        node.sourceLinks.forEach(function(link) {
	          link.sy = sy;
	          sy += link.dy;
	        });
	        node.targetLinks.forEach(function(link) {
	          link.ty = ty;
	          ty += link.dy;
	        });
	      });
	
	      function ascendingSourceDepth(a, b) {
	        return a.source.y - b.source.y;
	      }
	
	      function ascendingTargetDepth(a, b) {
	        return a.target.y - b.target.y;
	      }
	    }
	
	    function center(node) {
	      return node.y + node.dy / 2;
	    }
	
	    function value(link) {
	      return link.value;
	    }
	
	    return sankey;
	  }
	
	  exports.version = version;
	  exports.sankey = sankey;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3_array = {})));
	}(this, function (exports) { 'use strict';
	
	  function ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	
	  function bisector(compare) {
	    if (compare.length === 1) compare = ascendingComparator(compare);
	    return {
	      left: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1;
	          else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid;
	          else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	
	  function ascendingComparator(f) {
	    return function(d, x) {
	      return ascending(f(d), x);
	    };
	  }
	
	  var ascendingBisect = bisector(ascending);
	  var bisectRight = ascendingBisect.right;
	  var bisectLeft = ascendingBisect.left;
	
	  function descending(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  }
	
	  function number$1(x) {
	    return x === null ? NaN : +x;
	  }
	
	  function variance(array, f) {
	    var n = array.length,
	        m = 0,
	        a,
	        d,
	        s = 0,
	        i = -1,
	        j = 0;
	
	    if (f == null) {
	      while (++i < n) {
	        if (!isNaN(a = number$1(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    else {
	      while (++i < n) {
	        if (!isNaN(a = number$1(f(array[i], i, array)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    if (j > 1) return s / (j - 1);
	  }
	
	  function deviation(array, f) {
	    var v = variance(array, f);
	    return v ? Math.sqrt(v) : v;
	  }
	
	  function extent(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b,
	        c;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    return [a, c];
	  }
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function identity(x) {
	    return x;
	  }
	
	  function range(start, stop, step) {
	    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	    var i = -1,
	        n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	        range = new Array(n);
	
	    while (++i < n) {
	      range[i] = start + i * step;
	    }
	
	    return range;
	  }
	
	  var e10 = Math.sqrt(50);
	  var e5 = Math.sqrt(10);
	  var e2 = Math.sqrt(2);
	  function ticks(start, stop, count) {
	    var step = tickStep(start, stop, count);
	    return range(
	      Math.ceil(start / step) * step,
	      Math.floor(stop / step) * step + step / 2, // inclusive
	      step
	    );
	  }
	
	  function tickStep(start, stop, count) {
	    var step0 = Math.abs(stop - start) / Math.max(0, count),
	        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	        error = step0 / step1;
	    if (error >= e10) step1 *= 10;
	    else if (error >= e5) step1 *= 5;
	    else if (error >= e2) step1 *= 2;
	    return stop < start ? -step1 : step1;
	  }
	
	  function sturges(values) {
	    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	  }
	
	  function number(x) {
	    return +x;
	  }
	
	  function histogram() {
	    var value = identity,
	        domain = extent,
	        threshold = sturges;
	
	    function histogram(data) {
	      var i,
	          n = data.length,
	          x,
	          values = new Array(n);
	
	      // Coerce values to numbers.
	      for (i = 0; i < n; ++i) {
	        values[i] = +value(data[i], i, data);
	      }
	
	      var xz = domain(values),
	          x0 = +xz[0],
	          x1 = +xz[1],
	          tz = threshold(values, x0, x1);
	
	      // Convert number of thresholds into uniform thresholds.
	      if (!Array.isArray(tz)) tz = ticks(x0, x1, +tz);
	
	      // Coerce thresholds to numbers, ignoring any outside the domain.
	      var m = tz.length;
	      for (i = 0; i < m; ++i) tz[i] = +tz[i];
	      while (tz[0] <= x0) tz.shift(), --m;
	      while (tz[m - 1] >= x1) tz.pop(), --m;
	
	      var bins = new Array(m + 1),
	          bin;
	
	      // Initialize bins.
	      for (i = 0; i <= m; ++i) {
	        bin = bins[i] = [];
	        bin.x0 = i > 0 ? tz[i - 1] : x0;
	        bin.x1 = i < m ? tz[i] : x1;
	      }
	
	      // Assign data to bins by value, ignoring any outside the domain.
	      for (i = 0; i < n; ++i) {
	        x = values[i];
	        if (x0 <= x && x <= x1) {
	          bins[bisectRight(tz, x, 0, m)].push(data[i]);
	        }
	      }
	
	      return bins;
	    }
	
	    histogram.value = function(_) {
	      return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), histogram) : value;
	    };
	
	    histogram.domain = function(_) {
	      return arguments.length ? (domain = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), histogram) : domain;
	    };
	
	    histogram.thresholds = function(_) {
	      if (!arguments.length) return threshold;
	      threshold = typeof _ === "function" ? _
	          : Array.isArray(_) ? constant(Array.prototype.map.call(_, number))
	          : constant(+_);
	      return histogram;
	    };
	
	    return histogram;
	  }
	
	  function quantile(array, p, f) {
	    if (f == null) f = number$1;
	    if (!(n = array.length)) return;
	    if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	    if (p >= 1) return +f(array[n - 1], n - 1, array);
	    var n,
	        h = (n - 1) * p,
	        i = Math.floor(h),
	        a = +f(array[i], i, array),
	        b = +f(array[i + 1], i + 1, array);
	    return a + (b - a) * (h - i);
	  }
	
	  function freedmanDiaconis(values, min, max) {
	    values.sort(ascending);
	    return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function scott(values, min, max) {
	    return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function max(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	    }
	
	    return a;
	  }
	
	  function mean(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1,
	        j = n;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number$1(array[i]))) s += a; else --j;
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number$1(f(array[i], i, array)))) s += a; else --j;
	    }
	
	    if (j) return s / j;
	  }
	
	  function median(array, f) {
	    var numbers = [],
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number$1(array[i]))) numbers.push(a);
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number$1(f(array[i], i, array)))) numbers.push(a);
	    }
	
	    return quantile(numbers.sort(ascending), 0.5);
	  }
	
	  function merge(arrays) {
	    var n = arrays.length,
	        m,
	        i = -1,
	        j = 0,
	        merged,
	        array;
	
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	
	    return merged;
	  }
	
	  function min(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	    }
	
	    return a;
	  }
	
	  function pairs(array) {
	    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [p, p = array[++i]];
	    return pairs;
	  }
	
	  function permute(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  }
	
	  function scan(array, compare) {
	    if (!(n = array.length)) return;
	    var i = 0,
	        n,
	        j = 0,
	        xi,
	        xj = array[j];
	
	    if (!compare) compare = ascending;
	
	    while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	    if (compare(xj, xj) === 0) return j;
	  }
	
	  function shuffle(array, i0, i1) {
	    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	        t,
	        i;
	
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0];
	      array[m + i0] = array[i + i0];
	      array[i + i0] = t;
	    }
	
	    return array;
	  }
	
	  function sum(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	    }
	
	    else {
	      while (++i < n) if (a = +f(array[i], i, array)) s += a;
	    }
	
	    return s;
	  }
	
	  function transpose(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  }
	
	  function length(d) {
	    return d.length;
	  }
	
	  function zip() {
	    return transpose(arguments);
	  }
	
	  var version = "0.7.1";
	
	  exports.version = version;
	  exports.bisect = bisectRight;
	  exports.bisectRight = bisectRight;
	  exports.bisectLeft = bisectLeft;
	  exports.ascending = ascending;
	  exports.bisector = bisector;
	  exports.descending = descending;
	  exports.deviation = deviation;
	  exports.extent = extent;
	  exports.histogram = histogram;
	  exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	  exports.thresholdScott = scott;
	  exports.thresholdSturges = sturges;
	  exports.max = max;
	  exports.mean = mean;
	  exports.median = median;
	  exports.merge = merge;
	  exports.min = min;
	  exports.pairs = pairs;
	  exports.permute = permute;
	  exports.quantile = quantile;
	  exports.range = range;
	  exports.scan = scan;
	  exports.shuffle = shuffle;
	  exports.sum = sum;
	  exports.ticks = ticks;
	  exports.tickStep = tickStep;
	  exports.transpose = transpose;
	  exports.variance = variance;
	  exports.zip = zip;
	
	}));

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3_collection = global.d3_collection || {})));
	}(this, function (exports) { 'use strict';
	
	  var prefix = "$";
	
	  function Map() {}
	
	  Map.prototype = map.prototype = {
	    constructor: Map,
	    has: function(key) {
	      return (prefix + key) in this;
	    },
	    get: function(key) {
	      return this[prefix + key];
	    },
	    set: function(key, value) {
	      this[prefix + key] = value;
	      return this;
	    },
	    remove: function(key) {
	      var property = prefix + key;
	      return property in this && delete this[property];
	    },
	    clear: function() {
	      for (var property in this) if (property[0] === prefix) delete this[property];
	    },
	    keys: function() {
	      var keys = [];
	      for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	      return keys;
	    },
	    values: function() {
	      var values = [];
	      for (var property in this) if (property[0] === prefix) values.push(this[property]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	      return entries;
	    },
	    size: function() {
	      var size = 0;
	      for (var property in this) if (property[0] === prefix) ++size;
	      return size;
	    },
	    empty: function() {
	      for (var property in this) if (property[0] === prefix) return false;
	      return true;
	    },
	    each: function(f) {
	      for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	    }
	  };
	
	  function map(object, f) {
	    var map = new Map;
	
	    // Copy constructor.
	    if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	    // Index array by numeric index or specified key function.
	    else if (Array.isArray(object)) {
	      var i = -1,
	          n = object.length,
	          o;
	
	      if (f == null) while (++i < n) map.set(i, object[i]);
	      else while (++i < n) map.set(f(o = object[i], i, object), o);
	    }
	
	    // Convert object to map.
	    else if (object) for (var key in object) map.set(key, object[key]);
	
	    return map;
	  }
	
	  function nest() {
	    var keys = [],
	        sortKeys = [],
	        sortValues,
	        rollup,
	        nest;
	
	    function apply(array, depth, createResult, setResult) {
	      if (depth >= keys.length) return rollup
	          ? rollup(array) : (sortValues
	          ? array.sort(sortValues)
	          : array);
	
	      var i = -1,
	          n = array.length,
	          key = keys[depth++],
	          keyValue,
	          value,
	          valuesByKey = map(),
	          values,
	          result = createResult();
	
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	          values.push(value);
	        } else {
	          valuesByKey.set(keyValue, [value]);
	        }
	      }
	
	      valuesByKey.each(function(values, key) {
	        setResult(result, key, apply(values, depth, createResult, setResult));
	      });
	
	      return result;
	    }
	
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	
	      var array = [],
	          sortKey = sortKeys[depth++];
	
	      map.each(function(value, key) {
	        array.push({key: key, values: entries(value, depth)});
	      });
	
	      return sortKey
	          ? array.sort(function(a, b) { return sortKey(a.key, b.key); })
	          : array;
	    }
	
	    return nest = {
	      object: function(array) { return apply(array, 0, createObject, setObject); },
	      map: function(array) { return apply(array, 0, createMap, setMap); },
	      entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	      key: function(d) { keys.push(d); return nest; },
	      sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	      sortValues: function(order) { sortValues = order; return nest; },
	      rollup: function(f) { rollup = f; return nest; }
	    };
	  }
	
	  function createObject() {
	    return {};
	  }
	
	  function setObject(object, key, value) {
	    object[key] = value;
	  }
	
	  function createMap() {
	    return map();
	  }
	
	  function setMap(map, key, value) {
	    map.set(key, value);
	  }
	
	  function Set() {}
	
	  var proto = map.prototype;
	
	  Set.prototype = set.prototype = {
	    constructor: Set,
	    has: proto.has,
	    add: function(value) {
	      value += "";
	      this[prefix + value] = value;
	      return this;
	    },
	    remove: proto.remove,
	    clear: proto.clear,
	    values: proto.keys,
	    size: proto.size,
	    empty: proto.empty,
	    each: proto.each
	  };
	
	  function set(object, f) {
	    var set = new Set;
	
	    // Copy constructor.
	    if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	    // Otherwise, assume it’s an array.
	    else if (object) {
	      var i = -1, n = object.length;
	      if (f == null) while (++i < n) set.add(object[i]);
	      else while (++i < n) set.add(f(object[i], i, object));
	    }
	
	    return set;
	  }
	
	  function keys(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  }
	
	  function values(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  }
	
	  function entries(map) {
	    var entries = [];
	    for (var key in map) entries.push({key: key, value: map[key]});
	    return entries;
	  }
	
	  var version = "0.1.2";
	
	  exports.version = version;
	  exports.nest = nest;
	  exports.set = set;
	  exports.map = map;
	  exports.keys = keys;
	  exports.values = values;
	  exports.entries = entries;
	
	}));

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3_color = {})));
	}(this, function (exports) { 'use strict';
	
	  function Color() {}
	
	  var darker = 0.7;
	  var brighter = 1 / darker;
	
	  var reHex3 = /^#([0-9a-f]{3})$/;
	  var reHex6 = /^#([0-9a-f]{6})$/;
	  var reRgbInteger = /^rgb\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*\)$/;
	  var reRgbPercent = /^rgb\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var reHslPercent = /^hsl\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var named = {
	    aliceblue: 0xf0f8ff,
	    antiquewhite: 0xfaebd7,
	    aqua: 0x00ffff,
	    aquamarine: 0x7fffd4,
	    azure: 0xf0ffff,
	    beige: 0xf5f5dc,
	    bisque: 0xffe4c4,
	    black: 0x000000,
	    blanchedalmond: 0xffebcd,
	    blue: 0x0000ff,
	    blueviolet: 0x8a2be2,
	    brown: 0xa52a2a,
	    burlywood: 0xdeb887,
	    cadetblue: 0x5f9ea0,
	    chartreuse: 0x7fff00,
	    chocolate: 0xd2691e,
	    coral: 0xff7f50,
	    cornflowerblue: 0x6495ed,
	    cornsilk: 0xfff8dc,
	    crimson: 0xdc143c,
	    cyan: 0x00ffff,
	    darkblue: 0x00008b,
	    darkcyan: 0x008b8b,
	    darkgoldenrod: 0xb8860b,
	    darkgray: 0xa9a9a9,
	    darkgreen: 0x006400,
	    darkgrey: 0xa9a9a9,
	    darkkhaki: 0xbdb76b,
	    darkmagenta: 0x8b008b,
	    darkolivegreen: 0x556b2f,
	    darkorange: 0xff8c00,
	    darkorchid: 0x9932cc,
	    darkred: 0x8b0000,
	    darksalmon: 0xe9967a,
	    darkseagreen: 0x8fbc8f,
	    darkslateblue: 0x483d8b,
	    darkslategray: 0x2f4f4f,
	    darkslategrey: 0x2f4f4f,
	    darkturquoise: 0x00ced1,
	    darkviolet: 0x9400d3,
	    deeppink: 0xff1493,
	    deepskyblue: 0x00bfff,
	    dimgray: 0x696969,
	    dimgrey: 0x696969,
	    dodgerblue: 0x1e90ff,
	    firebrick: 0xb22222,
	    floralwhite: 0xfffaf0,
	    forestgreen: 0x228b22,
	    fuchsia: 0xff00ff,
	    gainsboro: 0xdcdcdc,
	    ghostwhite: 0xf8f8ff,
	    gold: 0xffd700,
	    goldenrod: 0xdaa520,
	    gray: 0x808080,
	    green: 0x008000,
	    greenyellow: 0xadff2f,
	    grey: 0x808080,
	    honeydew: 0xf0fff0,
	    hotpink: 0xff69b4,
	    indianred: 0xcd5c5c,
	    indigo: 0x4b0082,
	    ivory: 0xfffff0,
	    khaki: 0xf0e68c,
	    lavender: 0xe6e6fa,
	    lavenderblush: 0xfff0f5,
	    lawngreen: 0x7cfc00,
	    lemonchiffon: 0xfffacd,
	    lightblue: 0xadd8e6,
	    lightcoral: 0xf08080,
	    lightcyan: 0xe0ffff,
	    lightgoldenrodyellow: 0xfafad2,
	    lightgray: 0xd3d3d3,
	    lightgreen: 0x90ee90,
	    lightgrey: 0xd3d3d3,
	    lightpink: 0xffb6c1,
	    lightsalmon: 0xffa07a,
	    lightseagreen: 0x20b2aa,
	    lightskyblue: 0x87cefa,
	    lightslategray: 0x778899,
	    lightslategrey: 0x778899,
	    lightsteelblue: 0xb0c4de,
	    lightyellow: 0xffffe0,
	    lime: 0x00ff00,
	    limegreen: 0x32cd32,
	    linen: 0xfaf0e6,
	    magenta: 0xff00ff,
	    maroon: 0x800000,
	    mediumaquamarine: 0x66cdaa,
	    mediumblue: 0x0000cd,
	    mediumorchid: 0xba55d3,
	    mediumpurple: 0x9370db,
	    mediumseagreen: 0x3cb371,
	    mediumslateblue: 0x7b68ee,
	    mediumspringgreen: 0x00fa9a,
	    mediumturquoise: 0x48d1cc,
	    mediumvioletred: 0xc71585,
	    midnightblue: 0x191970,
	    mintcream: 0xf5fffa,
	    mistyrose: 0xffe4e1,
	    moccasin: 0xffe4b5,
	    navajowhite: 0xffdead,
	    navy: 0x000080,
	    oldlace: 0xfdf5e6,
	    olive: 0x808000,
	    olivedrab: 0x6b8e23,
	    orange: 0xffa500,
	    orangered: 0xff4500,
	    orchid: 0xda70d6,
	    palegoldenrod: 0xeee8aa,
	    palegreen: 0x98fb98,
	    paleturquoise: 0xafeeee,
	    palevioletred: 0xdb7093,
	    papayawhip: 0xffefd5,
	    peachpuff: 0xffdab9,
	    peru: 0xcd853f,
	    pink: 0xffc0cb,
	    plum: 0xdda0dd,
	    powderblue: 0xb0e0e6,
	    purple: 0x800080,
	    rebeccapurple: 0x663399,
	    red: 0xff0000,
	    rosybrown: 0xbc8f8f,
	    royalblue: 0x4169e1,
	    saddlebrown: 0x8b4513,
	    salmon: 0xfa8072,
	    sandybrown: 0xf4a460,
	    seagreen: 0x2e8b57,
	    seashell: 0xfff5ee,
	    sienna: 0xa0522d,
	    silver: 0xc0c0c0,
	    skyblue: 0x87ceeb,
	    slateblue: 0x6a5acd,
	    slategray: 0x708090,
	    slategrey: 0x708090,
	    snow: 0xfffafa,
	    springgreen: 0x00ff7f,
	    steelblue: 0x4682b4,
	    tan: 0xd2b48c,
	    teal: 0x008080,
	    thistle: 0xd8bfd8,
	    tomato: 0xff6347,
	    turquoise: 0x40e0d0,
	    violet: 0xee82ee,
	    wheat: 0xf5deb3,
	    white: 0xffffff,
	    whitesmoke: 0xf5f5f5,
	    yellow: 0xffff00,
	    yellowgreen: 0x9acd32
	  };
	
	  color.prototype = Color.prototype = {
	    displayable: function() {
	      return this.rgb().displayable();
	    },
	    toString: function() {
	      return this.rgb() + "";
	    }
	  };
	
	  function color(format) {
	    var m;
	    format = (format + "").trim().toLowerCase();
	    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf))) // #f00
	        : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	        : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3]) // rgb(255,0,0)
	        : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100) // rgb(100%,0%,0%)
	        : (m = reHslPercent.exec(format)) ? new Hsl(m[1], m[2] / 100, m[3] / 100) // hsl(120,50%,50%)
	        : named.hasOwnProperty(format) ? rgbn(named[format])
	        : null;
	  }
	
	  function rgbn(n) {
	    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff);
	  }
	
	  function rgb(r, g, b) {
	    if (arguments.length === 1) {
	      if (!(r instanceof Color)) r = color(r);
	      if (r) {
	        r = r.rgb();
	        b = r.b;
	        g = r.g;
	        r = r.r;
	      } else {
	        r = g = b = NaN;
	      }
	    }
	    return new Rgb(r, g, b);
	  }
	
	  function Rgb(r, g, b) {
	    this.r = +r;
	    this.g = +g;
	    this.b = +b;
	  }
	
	  var _rgb = rgb.prototype = Rgb.prototype = new Color;
	
	  _rgb.brighter = function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k);
	  };
	
	  _rgb.darker = function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k);
	  };
	
	  _rgb.rgb = function() {
	    return this;
	  };
	
	  _rgb.displayable = function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255);
	  };
	
	  _rgb.toString = function() {
	    var r = Math.round(this.r),
	        g = Math.round(this.g),
	        b = Math.round(this.b);
	    return "#"
	        + (isNaN(r) || r <= 0 ? "00" : r < 16 ? "0" + r.toString(16) : r >= 255 ? "ff" : r.toString(16))
	        + (isNaN(g) || g <= 0 ? "00" : g < 16 ? "0" + g.toString(16) : g >= 255 ? "ff" : g.toString(16))
	        + (isNaN(b) || b <= 0 ? "00" : b < 16 ? "0" + b.toString(16) : b >= 255 ? "ff" : b.toString(16));
	  };
	
	  function hsl(h, s, l) {
	    if (arguments.length === 1) {
	      if (h instanceof Hsl) {
	        l = h.l;
	        s = h.s;
	        h = h.h;
	      } else {
	        if (!(h instanceof Color)) h = color(h);
	        if (h) {
	          if (h instanceof Hsl) return h;
	          h = h.rgb();
	          var r = h.r / 255,
	              g = h.g / 255,
	              b = h.b / 255,
	              min = Math.min(r, g, b),
	              max = Math.max(r, g, b),
	              range = max - min;
	          l = (max + min) / 2;
	          if (range) {
	            s = l < 0.5 ? range / (max + min) : range / (2 - max - min);
	            if (r === max) h = (g - b) / range + (g < b) * 6;
	            else if (g === max) h = (b - r) / range + 2;
	            else h = (r - g) / range + 4;
	            h *= 60;
	          } else {
	            h = NaN;
	            s = l > 0 && l < 1 ? 0 : h;
	          }
	        } else {
	          h = s = l = NaN;
	        }
	      }
	    }
	    return new Hsl(h, s, l);
	  }
	
	  function Hsl(h, s, l) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	  }
	
	  var _hsl = hsl.prototype = Hsl.prototype = new Color;
	
	  _hsl.brighter = function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k);
	  };
	
	  _hsl.darker = function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k);
	  };
	
	  _hsl.rgb = function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2)
	    );
	  };
	
	  _hsl.displayable = function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1);
	  };
	
	  /* From FvD 13.37, CSS Color Module Level 3 */
	  function hsl2rgb(h, m1, m2) {
	    return (h < 60 ? m1 + (m2 - m1) * h / 60
	        : h < 180 ? m2
	        : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	        : m1) * 255;
	  }
	
	  var deg2rad = Math.PI / 180;
	  var rad2deg = 180 / Math.PI;
	
	  var Kn = 18;
	  var Xn = 0.950470;
	  var Yn = 1;
	  var Zn = 1.088830;
	  var t0 = 4 / 29;
	  var t1 = 6 / 29;
	  var t2 = 3 * t1 * t1;
	  var t3 = t1 * t1 * t1;
	  function lab(l, a, b) {
	    if (arguments.length === 1) {
	      if (l instanceof Lab) {
	        b = l.b;
	        a = l.a;
	        l = l.l;
	      } else if (l instanceof Hcl) {
	        var h = l.h * deg2rad;
	        b = Math.sin(h) * l.c;
	        a = Math.cos(h) * l.c;
	        l = l.l;
	      } else {
	        if (!(l instanceof Rgb)) l = rgb(l);
	        b = rgb2xyz(l.r);
	        a = rgb2xyz(l.g);
	        l = rgb2xyz(l.b);
	        var x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	            y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	            z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	        b = 200 * (y - z);
	        a = 500 * (x - y);
	        l = 116 * y - 16;
	      }
	    }
	    return new Lab(l, a, b);
	  }
	
	  function Lab(l, a, b) {
	    this.l = +l;
	    this.a = +a;
	    this.b = +b;
	  }
	
	  var _lab = lab.prototype = Lab.prototype = new Color;
	
	  _lab.brighter = function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b);
	  };
	
	  _lab.darker = function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b);
	  };
	
	  _lab.rgb = function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z)
	    );
	  };
	
	  function xyz2lab(t) {
	    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	  }
	
	  function lab2xyz(t) {
	    return t > t1 ? t * t * t : t2 * (t - t0);
	  }
	
	  function xyz2rgb(x) {
	    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	  }
	
	  function rgb2xyz(x) {
	    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	  }
	
	  function hcl(h, c, l) {
	    if (arguments.length === 1) {
	      if (h instanceof Hcl) {
	        l = h.l;
	        c = h.c;
	        h = h.h;
	      } else {
	        if (!(h instanceof Lab)) h = lab(h);
	        l = h.l;
	        c = Math.sqrt(h.a * h.a + h.b * h.b);
	        h = Math.atan2(h.b, h.a) * rad2deg;
	        if (h < 0) h += 360;
	      }
	    }
	    return new Hcl(h, c, l);
	  }
	
	  function Hcl(h, c, l) {
	    this.h = +h;
	    this.c = +c;
	    this.l = +l;
	  }
	
	  var _hcl = hcl.prototype = Hcl.prototype = new Color;
	
	  _hcl.brighter = function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k));
	  };
	
	  _hcl.darker = function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k));
	  };
	
	  _hcl.rgb = function() {
	    return lab(this).rgb();
	  };
	
	  var A = -0.14861;
	  var B = +1.78277;
	  var C = -0.29227;
	  var D = -0.90649;
	  var E = +1.97294;
	  var ED = E * D;
	  var EB = E * B;
	  var BC_DA = B * C - D * A;
	  function cubehelix(h, s, l) {
	    if (arguments.length === 1) {
	      if (h instanceof Cubehelix) {
	        l = h.l;
	        s = h.s;
	        h = h.h;
	      } else {
	        if (!(h instanceof Rgb)) h = rgb(h);
	        var r = h.r / 255, g = h.g / 255, b = h.b / 255;
	        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB);
	        var bl = b - l, k = (E * (g - l) - C * bl) / D;
	        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)); // NaN if l=0 or l=1
	        h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	        if (h < 0) h += 360;
	      }
	    }
	    return new Cubehelix(h, s, l);
	  }
	
	  function Cubehelix(h, s, l) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	  }
	
	  var _cubehelix = cubehelix.prototype = Cubehelix.prototype = new Color;
	
	  _cubehelix.brighter = function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k);
	  };
	
	  _cubehelix.darker = function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k);
	  };
	
	  _cubehelix.rgb = function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh))
	    );
	  };
	
	  var version = "0.3.4";
	
	  exports.version = version;
	  exports.color = color;
	  exports.rgb = rgb;
	  exports.hsl = hsl;
	  exports.lab = lab;
	  exports.hcl = hcl;
	  exports.cubehelix = cubehelix;
	
	}));

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(764)) :
	  typeof define === 'function' && define.amd ? define('d3-interpolate', ['exports', 'd3-color'], factory) :
	  factory((global.d3_interpolate = {}),global.d3_color);
	}(this, function (exports,d3Color) { 'use strict';
	
	  function deltaHue(h1, h0) {
	    var delta = h1 - h0;
	    return delta > 180 || delta < -180
	        ? delta - 360 * Math.round(delta / 360)
	        : delta;
	  };
	
	  function cubehelixGamma(gamma) {
	    return function(a, b) {
	      a = d3Color.cubehelix(a);
	      b = d3Color.cubehelix(b);
	      var ah = isNaN(a.h) ? b.h : a.h,
	          as = isNaN(a.s) ? b.s : a.s,
	          al = a.l,
	          bh = isNaN(b.h) ? 0 : deltaHue(b.h, ah),
	          bs = isNaN(b.s) ? 0 : b.s - as,
	          bl = b.l - al;
	      return function(t) {
	        a.h = ah + bh * t;
	        a.s = as + bs * t;
	        a.l = al + bl * Math.pow(t, gamma);
	        return a + "";
	      };
	    };
	  };
	
	  function cubehelixGammaLong(gamma) {
	    return function(a, b) {
	      a = d3Color.cubehelix(a);
	      b = d3Color.cubehelix(b);
	      var ah = isNaN(a.h) ? b.h : a.h,
	          as = isNaN(a.s) ? b.s : a.s,
	          al = a.l,
	          bh = isNaN(b.h) ? 0 : b.h - ah,
	          bs = isNaN(b.s) ? 0 : b.s - as,
	          bl = b.l - al;
	      return function(t) {
	        a.h = ah + bh * t;
	        a.s = as + bs * t;
	        a.l = al + bl * Math.pow(t, gamma);
	        return a + "";
	      };
	    };
	  };
	
	  function rgb(a, b) {
	    a = d3Color.rgb(a);
	    b = d3Color.rgb(b);
	    var ar = a.r,
	        ag = a.g,
	        ab = a.b,
	        br = b.r - ar,
	        bg = b.g - ag,
	        bb = b.b - ab;
	    return function(t) {
	      a.r = ar + br * t;
	      a.g = ag + bg * t;
	      a.b = ab + bb * t;
	      return a + "";
	    };
	  };
	
	  function number(a, b) {
	    return a = +a, b -= a, function(t) {
	      return a + b * t;
	    };
	  };
	
	  function object(a, b) {
	    var i = {},
	        c = {},
	        k;
	
	    for (k in a) {
	      if (k in b) {
	        i[k] = value(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  };
	
	  var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	  var reB = new RegExp(reA.source, "g");
	  function zero(b) {
	    return function() {
	      return b;
	    };
	  }
	
	  function one(b) {
	    return function(t) {
	      return b(t) + "";
	    };
	  }
	
	  function string(a, b) {
	    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	        am, // current match in a
	        bm, // current match in b
	        bs, // string preceding current number in b, if any
	        i = -1, // index in s
	        s = [], // string constants and placeholders
	        q = []; // number interpolators
	
	    // Coerce inputs to strings.
	    a = a + "", b = b + "";
	
	    // Interpolate pairs of numbers in a & b.
	    while ((am = reA.exec(a))
	        && (bm = reB.exec(b))) {
	      if ((bs = bm.index) > bi) { // a string precedes the next number in b
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; // coalesce with previous string
	        else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	        if (s[i]) s[i] += bm; // coalesce with previous string
	        else s[++i] = bm;
	      } else { // interpolate non-matching numbers
	        s[++i] = null;
	        q.push({i: i, x: number(am, bm)});
	      }
	      bi = reB.lastIndex;
	    }
	
	    // Add remains of b.
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	
	    // Special optimization for only a single match.
	    // Otherwise, interpolate each of the numbers and rejoin the string.
	    return s.length < 2 ? (q[0]
	        ? one(q[0].x)
	        : zero(b))
	        : (b = q.length, function(t) {
	            for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	            return s.join("");
	          });
	  };
	
	  var values = [
	    function(a, b) {
	      var t = typeof b, c;
	      return (t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	          : b instanceof d3Color.color ? rgb
	          : Array.isArray(b) ? array
	          : t === "object" && isNaN(b) ? object
	          : number)(a, b);
	    }
	  ];
	
	  function value(a, b) {
	    var i = values.length, f;
	    while (--i >= 0 && !(f = values[i](a, b)));
	    return f;
	  };
	
	  // TODO sparse arrays?
	  function array(a, b) {
	    var x = [],
	        c = [],
	        na = a.length,
	        nb = b.length,
	        n0 = Math.min(a.length, b.length),
	        i;
	
	    for (i = 0; i < n0; ++i) x.push(value(a[i], b[i]));
	    for (; i < na; ++i) c[i] = a[i];
	    for (; i < nb; ++i) c[i] = b[i];
	
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  };
	
	  function round(a, b) {
	    return a = +a, b -= a, function(t) {
	      return Math.round(a + b * t);
	    };
	  };
	
	  var rad2deg = 180 / Math.PI;
	  var identity = {a: 1, b: 0, c: 0, d: 1, e: 0, f: 0};
	  var g;
	  // Compute x-scale and normalize the first row.
	  // Compute shear and make second row orthogonal to first.
	  // Compute y-scale and normalize the second row.
	  // Finally, compute the rotation.
	  function Transform(string) {
	    if (!g) g = document.createElementNS("http://www.w3.org/2000/svg", "g");
	    if (string) g.setAttribute("transform", string), t = g.transform.baseVal.consolidate();
	
	    var t,
	        m = t ? t.matrix : identity,
	        r0 = [m.a, m.b],
	        r1 = [m.c, m.d],
	        kx = normalize(r0),
	        kz = dot(r0, r1),
	        ky = normalize(combine(r1, r0, -kz)) || 0;
	
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * rad2deg;
	    this.translate = [m.e, m.f];
	    this.scale = [kx, ky];
	    this.skew = ky ? Math.atan2(kz, ky) * rad2deg : 0;
	  }
	
	  function dot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	
	  function normalize(a) {
	    var k = Math.sqrt(dot(a, a));
	    if (k) a[0] /= k, a[1] /= k;
	    return k;
	  }
	
	  function combine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	
	  function pop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	
	  function translate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(ta[0], tb[0])}, {i: i - 2, x: number(ta[1], tb[1])});
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	
	  function rotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, ")") - 2, x: number(ra, rb)});
	    } else if (rb) {
	      s.push(pop(s) + "rotate(" + rb + ")");
	    }
	  }
	
	  function skew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({i: s.push(pop(s) + "skewX(", null, ")") - 2, x: number(wa, wb)});
	    } else if (wb) {
	      s.push(pop(s) + "skewX(" + wb + ")");
	    }
	  }
	
	  function scale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(ka[0], kb[0])}, {i: i - 2, x: number(ka[1], kb[1])});
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(pop(s) + "scale(" + kb + ")");
	    }
	  }
	
	  function transform(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = new Transform(a), b = new Transform(b);
	    translate(a.translate, b.translate, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skew(a.skew, b.skew, s, q);
	    scale(a.scale, b.scale, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	
	  var rho = Math.SQRT2;
	  var rho2 = 2;
	  var rho4 = 4;
	  var epsilon2 = 1e-12;
	  function cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	
	  function sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	
	  function tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	
	  // p0 = [ux0, uy0, w0]
	  // p1 = [ux1, uy1, w1]
	  function zoom(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	        ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	        dx = ux1 - ux0,
	        dy = uy1 - uy0,
	        d2 = dx * dx + dy * dy,
	        i,
	        S;
	
	    // Special case for u0 ≅ u1.
	    if (d2 < epsilon2) {
	      S = Math.log(w1 / w0) / rho;
	      i = function(t) {
	        return [
	          ux0 + t * dx,
	          uy0 + t * dy,
	          w0 * Math.exp(rho * t * S)
	        ];
	      }
	    }
	
	    // General case.
	    else {
	      var d1 = Math.sqrt(d2),
	          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / rho;
	      i = function(t) {
	        var s = t * S,
	            coshr0 = cosh(r0),
	            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	        return [
	          ux0 + u * dx,
	          uy0 + u * dy,
	          w0 * coshr0 / cosh(rho * s + r0)
	        ];
	      }
	    }
	
	    i.duration = S * 1000;
	
	    return i;
	  };
	
	  function hsl(a, b) {
	    a = d3Color.hsl(a);
	    b = d3Color.hsl(b);
	    var ah = isNaN(a.h) ? b.h : a.h,
	        as = isNaN(a.s) ? b.s : a.s,
	        al = a.l,
	        bh = isNaN(b.h) ? 0 : deltaHue(b.h, ah),
	        bs = isNaN(b.s) ? 0 : b.s - as,
	        bl = b.l - al;
	    return function(t) {
	      a.h = ah + bh * t;
	      a.s = as + bs * t;
	      a.l = al + bl * t;
	      return a + "";
	    };
	  };
	
	  function hslLong(a, b) {
	    a = d3Color.hsl(a);
	    b = d3Color.hsl(b);
	    var ah = isNaN(a.h) ? b.h : a.h,
	        as = isNaN(a.s) ? b.s : a.s,
	        al = a.l,
	        bh = isNaN(b.h) ? 0 : b.h - ah,
	        bs = isNaN(b.s) ? 0 : b.s - as,
	        bl = b.l - al;
	    return function(t) {
	      a.h = ah + bh * t;
	      a.s = as + bs * t;
	      a.l = al + bl * t;
	      return a + "";
	    };
	  };
	
	  function lab(a, b) {
	    a = d3Color.lab(a);
	    b = d3Color.lab(b);
	    var al = a.l,
	        aa = a.a,
	        ab = a.b,
	        bl = b.l - al,
	        ba = b.a - aa,
	        bb = b.b - ab;
	    return function(t) {
	      a.l = al + bl * t;
	      a.a = aa + ba * t;
	      a.b = ab + bb * t;
	      return a + "";
	    };
	  };
	
	  function hcl(a, b) {
	    a = d3Color.hcl(a);
	    b = d3Color.hcl(b);
	    var ah = isNaN(a.h) ? b.h : a.h,
	        ac = isNaN(a.c) ? b.c : a.c,
	        al = a.l,
	        bh = isNaN(b.h) ? 0 : deltaHue(b.h, ah),
	        bc = isNaN(b.c) ? 0 : b.c - ac,
	        bl = b.l - al;
	    return function(t) {
	      a.h = ah + bh * t;
	      a.c = ac + bc * t;
	      a.l = al + bl * t;
	      return a + "";
	    };
	  };
	
	  function hclLong(a, b) {
	    a = d3Color.hcl(a);
	    b = d3Color.hcl(b);
	    var ah = isNaN(a.h) ? b.h : a.h,
	        ac = isNaN(a.c) ? b.c : a.c,
	        al = a.l,
	        bh = isNaN(b.h) ? 0 : b.h - ah,
	        bc = isNaN(b.c) ? 0 : b.c - ac,
	        bl = b.l - al;
	    return function(t) {
	      a.h = ah + bh * t;
	      a.c = ac + bc * t;
	      a.l = al + bl * t;
	      return a + "";
	    };
	  };
	
	  var cubehelix = cubehelixGamma(1);
	  var cubehelixLong = cubehelixGammaLong(1);
	
	  var version = "0.2.1";
	
	  exports.version = version;
	  exports.cubehelix = cubehelix;
	  exports.cubehelixLong = cubehelixLong;
	  exports.cubehelixGamma = cubehelixGamma;
	  exports.cubehelixGammaLong = cubehelixGammaLong;
	  exports.array = array;
	  exports.number = number;
	  exports.object = object;
	  exports.round = round;
	  exports.string = string;
	  exports.transform = transform;
	  exports.values = values;
	  exports.value = value;
	  exports.zoom = zoom;
	  exports.rgb = rgb;
	  exports.hsl = hsl;
	  exports.hslLong = hslLong;
	  exports.lab = lab;
	  exports.hcl = hcl;
	  exports.hclLong = hclLong;
	
	}));

/***/ },
/* 766 */
758,
/* 767 */
758,
/* 768 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME reflection-effect-fs\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nuniform sampler2D reflectionTexture;\nuniform int reflectionTextureWidth;\nuniform int reflectionTextureHeight;\n\nuniform float reflectivity;\nuniform float blur;\n\n\nvarying vec2 uv;\n\n#define KERNEL_SIZE 7\n\n/*\n * Samples from tex with a gaussian-shaped patch, centered at uv and\n * with standard deviation sigma.  The size of the texture in\n * pixels must be specified by dim\n */\nvec4 sample_gaussian(sampler2D tex, vec2 dim, vec2 uv, float sigma) {\n  if (sigma == 0.0) {\n    return texture2D(tex, uv);\n  }\n\n  vec2 delta = 1.0 / dim;\n  vec2 top_left = uv - delta * float(KERNEL_SIZE+1) / 2.0;\n\n  vec4 color = vec4(0);\n  float sum = 0.0;\n  for (int i = 0; i <  KERNEL_SIZE; ++i) {\n    for (int j = 0; j < KERNEL_SIZE; ++j) {\n      vec2 uv2 = top_left + vec2(i, j) * delta;\n      float d = length((uv2 - uv) * dim);\n      float f = exp(-(d*d) / (2.0*sigma * sigma));\n      color += f * texture2D(tex, uv2);\n      sum += f;\n    }\n  }\n  return color / sum;\n}\n\nvoid main(void) {\n  //map blur in [0, 1] to sigma in [0, inf]\n  //alpha will determine the \"steepness\" of our curve.\n  //this was picked just to make the scale feel \"natural\"\n  //if our image is 1000 pixels wide, a blur of 0.5 should correspond\n  //to a sigma of 1 pixels\n  float alpha = 1000.0;\n  float sigma = blur / (alpha * (1.0 - blur));\n  //let this be our standard deviation in terms of screen-widths.\n  //rewrite this in terms of pixels.\n  sigma *= float(reflectionTextureWidth);\n\n\n  gl_FragColor = sample_gaussian(reflectionTexture, vec2(reflectionTextureWidth,\n    reflectionTextureHeight), vec2(uv.x, 1. - uv.y), sigma);\n  //because our canvas expects alphas to be pre-multiplied, we multiply by whole\n  //color vector by reflectivity, not just the alpha channel\n  gl_FragColor *= reflectivity;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 769 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME reflection-effect-vs\n\nattribute vec3 vertices;\n\nvarying vec2 uv;\n\nvoid main(void) {\n  uv = vertices.xy;\n  gl_Position = vec4(2. * vertices.xy - vec2(1., 1.), 1., 1.);\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _luma = __webpack_require__(29);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _lib = __webpack_require__(255);
	
	var _viewports = __webpack_require__(262);
	
	var _reflectionEffectVertex = __webpack_require__(769);
	
	var _reflectionEffectVertex2 = _interopRequireDefault(_reflectionEffectVertex);
	
	var _reflectionEffectFragment = __webpack_require__(768);
	
	var _reflectionEffectFragment2 = _interopRequireDefault(_reflectionEffectFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* global window */
	
	
	var ReflectionEffect = function (_Effect) {
	  _inherits(ReflectionEffect, _Effect);
	
	  /**
	   * @classdesc
	   * ReflectionEffect
	   *
	   * @class
	   * @param reflectivity How visible reflections should be over the map, between 0 and 1
	   * @param blur how blurry the reflection should be, between 0 and 1
	   */
	
	  function ReflectionEffect() {
	    var reflectivity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
	    var blur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
	
	    _classCallCheck(this, ReflectionEffect);
	
	    var _this = _possibleConstructorReturn(this, (ReflectionEffect.__proto__ || Object.getPrototypeOf(ReflectionEffect)).call(this));
	
	    _this.reflectivity = reflectivity;
	    _this.blur = blur;
	    _this.framebuffer = null;
	    _this.setNeedsRedraw();
	    return _this;
	  }
	
	  _createClass(ReflectionEffect, [{
	    key: 'getShaders',
	    value: function getShaders() {
	      return {
	        vs: _reflectionEffectVertex2.default,
	        fs: _reflectionEffectFragment2.default
	      };
	    }
	  }, {
	    key: 'initialize',
	    value: function initialize(_ref) {
	      var gl = _ref.gl,
	          layerManager = _ref.layerManager;
	
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      this.unitQuad = new _luma.Model({
	        gl: gl,
	        id: 'reflection-effect',
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: _luma.GL.TRIANGLE_FAN,
	          vertices: new Float32Array([0, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0])
	        })
	      });
	      this.framebuffer = new _luma.Framebuffer(gl, { depth: true });
	    }
	  }, {
	    key: 'preDraw',
	    value: function preDraw(_ref2) {
	      var gl = _ref2.gl,
	          layerManager = _ref2.layerManager;
	      var viewport = layerManager.context.viewport;
	      /*
	       * the renderer already has a reference to this, but we don't have a reference to the renderer.
	       * when we refactor the camera code, we should make sure we get a reference to the renderer so
	       * that we can keep this in one place.
	       */
	
	      var dpi = typeof window !== 'undefined' && window.devicePixelRatio || 1;
	      this.framebuffer.resize({ width: dpi * viewport.width, height: dpi * viewport.height });
	      var pitch = viewport.pitch;
	      this.framebuffer.bind();
	      /* this is a huge hack around the existing viewport class.
	       * TODO in the future, once we implement bona-fide cameras, we really need to fix this.
	       */
	      layerManager.setViewport(new _viewports.WebMercatorViewport(Object.assign({}, viewport, { pitch: -180 - pitch })));
	      gl.clear(_luma.GL.COLOR_BUFFER_BIT | _luma.GL.DEPTH_BUFFER_BIT);
	
	      layerManager.drawLayers({ pass: 'reflection' });
	      layerManager.setViewport(viewport);
	      this.framebuffer.unbind();
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref3) {
	      var gl = _ref3.gl,
	          layerManager = _ref3.layerManager;
	
	      /*
	       * Render our unit quad.
	       * This will cover the entire screen, but will lie behind all other geometry.
	       * This quad will sample the previously generated reflection texture
	       * in order to create the reflection effect
	       */
	      this.unitQuad.render({
	        reflectionTexture: this.framebuffer.texture,
	        reflectionTextureWidth: this.framebuffer.width,
	        reflectionTextureHeight: this.framebuffer.height,
	        reflectivity: this.reflectivity,
	        blur: this.blur
	      });
	    }
	  }, {
	    key: 'finalize',
	    value: function finalize(_ref4) {
	      /* TODO: Free resources? */
	
	      var gl = _ref4.gl,
	          layerManager = _ref4.layerManager;
	    }
	  }]);
	
	  return ReflectionEffect;
	}(_lib.Effect);
	
	exports.default = ReflectionEffect;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lib = __webpack_require__(255);
	
	Object.defineProperty(exports, 'EffectManager', {
	  enumerable: true,
	  get: function get() {
	    return _lib.EffectManager;
	  }
	});
	Object.defineProperty(exports, 'Effect', {
	  enumerable: true,
	  get: function get() {
	    return _lib.Effect;
	  }
	});
	
	var _reflectionEffect = __webpack_require__(385);
	
	Object.defineProperty(exports, 'ReflectionEffect', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reflectionEffect).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9leHBlcmltZW50YWwvaW5kZXguanMiXSwibmFtZXMiOlsiRWZmZWN0TWFuYWdlciIsIkVmZmVjdCIsImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O2dCQW1CUUEsYTs7Ozs7O2dCQUFlQyxNOzs7Ozs7Ozs7cURBQ2ZDLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDb3B5cmlnaHQgKGMpIDIwMTUgLSAyMDE3IFViZXIgVGVjaG5vbG9naWVzLCBJbmMuXG4vL1xuLy8gUGVybWlzc2lvbiBpcyBoZXJlYnkgZ3JhbnRlZCwgZnJlZSBvZiBjaGFyZ2UsIHRvIGFueSBwZXJzb24gb2J0YWluaW5nIGEgY29weVxuLy8gb2YgdGhpcyBzb2Z0d2FyZSBhbmQgYXNzb2NpYXRlZCBkb2N1bWVudGF0aW9uIGZpbGVzICh0aGUgXCJTb2Z0d2FyZVwiKSwgdG8gZGVhbFxuLy8gaW4gdGhlIFNvZnR3YXJlIHdpdGhvdXQgcmVzdHJpY3Rpb24sIGluY2x1ZGluZyB3aXRob3V0IGxpbWl0YXRpb24gdGhlIHJpZ2h0c1xuLy8gdG8gdXNlLCBjb3B5LCBtb2RpZnksIG1lcmdlLCBwdWJsaXNoLCBkaXN0cmlidXRlLCBzdWJsaWNlbnNlLCBhbmQvb3Igc2VsbFxuLy8gY29waWVzIG9mIHRoZSBTb2Z0d2FyZSwgYW5kIHRvIHBlcm1pdCBwZXJzb25zIHRvIHdob20gdGhlIFNvZnR3YXJlIGlzXG4vLyBmdXJuaXNoZWQgdG8gZG8gc28sIHN1YmplY3QgdG8gdGhlIGZvbGxvd2luZyBjb25kaXRpb25zOlxuLy9cbi8vIFRoZSBhYm92ZSBjb3B5cmlnaHQgbm90aWNlIGFuZCB0aGlzIHBlcm1pc3Npb24gbm90aWNlIHNoYWxsIGJlIGluY2x1ZGVkIGluXG4vLyBhbGwgY29waWVzIG9yIHN1YnN0YW50aWFsIHBvcnRpb25zIG9mIHRoZSBTb2Z0d2FyZS5cbi8vXG4vLyBUSEUgU09GVFdBUkUgSVMgUFJPVklERUQgXCJBUyBJU1wiLCBXSVRIT1VUIFdBUlJBTlRZIE9GIEFOWSBLSU5ELCBFWFBSRVNTIE9SXG4vLyBJTVBMSUVELCBJTkNMVURJTkcgQlVUIE5PVCBMSU1JVEVEIFRPIFRIRSBXQVJSQU5USUVTIE9GIE1FUkNIQU5UQUJJTElUWSxcbi8vIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFIEFORCBOT05JTkZSSU5HRU1FTlQuIElOIE5PIEVWRU5UIFNIQUxMIFRIRVxuLy8gQVVUSE9SUyBPUiBDT1BZUklHSFQgSE9MREVSUyBCRSBMSUFCTEUgRk9SIEFOWSBDTEFJTSwgREFNQUdFUyBPUiBPVEhFUlxuLy8gTElBQklMSVRZLCBXSEVUSEVSIElOIEFOIEFDVElPTiBPRiBDT05UUkFDVCwgVE9SVCBPUiBPVEhFUldJU0UsIEFSSVNJTkcgRlJPTSxcbi8vIE9VVCBPRiBPUiBJTiBDT05ORUNUSU9OIFdJVEggVEhFIFNPRlRXQVJFIE9SIFRIRSBVU0UgT1IgT1RIRVIgREVBTElOR1MgSU5cbi8vIFRIRSBTT0ZUV0FSRS5cbmV4cG9ydCB7RWZmZWN0TWFuYWdlciwgRWZmZWN0fSBmcm9tICcuL2xpYic7XG5leHBvcnQge2RlZmF1bHQgYXMgUmVmbGVjdGlvbkVmZmVjdH0gZnJvbSAnLi9lZmZlY3RzL3JlZmxlY3Rpb24tZWZmZWN0JztcbiJdfQ==

/***/ },
/* 772 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* eslint-disable no-try-catch */
	
	var EffectManager = function () {
	  function EffectManager(_ref) {
	    var gl = _ref.gl,
	        layerManager = _ref.layerManager;
	
	    _classCallCheck(this, EffectManager);
	
	    this.gl = gl;
	    this.layerManager = layerManager;
	    this._effects = [];
	  }
	
	  /**
	   * Adds an effect to be managed.  That effect's initialize function will
	   * be called, and the effect's preDraw and draw callbacks will be
	   * called at the appropriate times in the render loop
	   * @param {Effect} effect - the effect to be added
	   */
	
	
	  _createClass(EffectManager, [{
	    key: "addEffect",
	    value: function addEffect(effect) {
	      this._effects.push(effect);
	      this._sortEffects();
	      effect.initialize({ gl: this.gl, layerManager: this.layerManager });
	    }
	
	    /**
	     * Removes an effect that is already being managed.  That effect's
	     * finalize function will be called, and its callbacks will no longer
	     * be envoked in the render loop
	     * @param {Effect} effect - the effect to be removed
	     * @return {bool} - True if the effect was already being managed, and
	     * thus successfully removed; false otherwise
	     */
	
	  }, {
	    key: "removeEffect",
	    value: function removeEffect(effect) {
	      var i = this._effects.indexOf(effect);
	      if (i >= 0) {
	        effect.finalize({ gl: this.gl, layerManager: this.layerManager });
	        this._effects.splice(i, 1);
	        return true;
	      }
	      return false;
	    }
	
	    /**
	     * Envoke the preDraw callback of all managed events, in order of
	     * decreasing priority
	     */
	
	  }, {
	    key: "preDraw",
	    value: function preDraw() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this._effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var effect = _step.value;
	
	          if (effect.needsRedraw) {
	            effect.preDraw({ gl: this.gl, layerManager: this.layerManager });
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	
	    /**
	     * Envoke the draw callback of all managed events, in order of
	     * decreasing priority
	     */
	
	  }, {
	    key: "draw",
	    value: function draw() {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this._effects[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var effect = _step2.value;
	
	          if (effect.needsRedraw) {
	            effect.draw({ gl: this.gl, layerManager: this.layerManager });
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: "_sortEffects",
	    value: function _sortEffects() {
	      this._effects.sort(function (a, b) {
	        if (a.priority > b.priority) {
	          return -1;
	        } else if (a.priority < b.priority) {
	          return 1;
	        }
	        return a.count - b.count;
	      });
	    }
	  }]);
	
	  return EffectManager;
	}();
	
	exports.default = EffectManager;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 773 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var counter = 0;
	
	var Effect = function () {
	  function Effect() {
	    _classCallCheck(this, Effect);
	
	    this.count = counter++;
	    this.visible = true;
	    this.priority = 0;
	    this.needsRedraw = false;
	  }
	
	  /**
	   * subclasses should override to set up any resources needed
	   */
	
	
	  _createClass(Effect, [{
	    key: "initialize",
	    value: function initialize(_ref) {
	      var gl = _ref.gl,
	          layerManager = _ref.layerManager;
	    }
	    /**
	     * and subclasses should free those resources here
	     */
	
	  }, {
	    key: "finalize",
	    value: function finalize(_ref2) {
	      var gl = _ref2.gl,
	          layerManager = _ref2.layerManager;
	    }
	    /**
	     * override for a callback immediately before drawing each frame
	     */
	
	  }, {
	    key: "preDraw",
	    value: function preDraw(_ref3) {
	      var gl = _ref3.gl,
	          layerManager = _ref3.layerManager;
	    }
	    /**
	     * override for a callback immediately after drawing a frame's layers
	     */
	
	  }, {
	    key: "draw",
	    value: function draw(_ref4) {
	      var gl = _ref4.gl,
	          layerManager = _ref4.layerManager;
	    }
	  }, {
	    key: "setNeedsRedraw",
	    value: function setNeedsRedraw() {
	      var redraw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.needsRedraw = redraw;
	    }
	  }]);
	
	  return Effect;
	}();
	
	exports.default = Effect;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 774 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME arc-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  gl_FragColor = vColor;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 775 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME arc-layer-vertex-64-shader\n\nattribute vec3 positions;\nattribute vec4 instanceSourceColors;\nattribute vec4 instanceTargetColors;\n\nattribute vec4 instancePositions;\nattribute vec4 instancePositions64Low;\n\nattribute vec3 instancePickingColors;\n\nuniform float numSegments;\nuniform vec2 viewportSize;\nuniform float strokeWidth;\nuniform float opacity;\nuniform float renderPickingBuffer;\n\nvarying vec4 vColor;\n\nvec2 paraboloid_fp64(vec2 source[2], vec2 target[2], float ratio) {\n\n  vec2 x[2];\n  vec2_mix_fp64(source, target, ratio, x);\n  vec2 center[2];\n  vec2_mix_fp64(source, target, 0.5, center);\n\n  vec2 dSourceCenter = vec2_distance_fp64(source, center);\n  vec2 dXCenter = vec2_distance_fp64(x, center);\n  return mul_fp64(sum_fp64(dSourceCenter, dXCenter), sub_fp64(dSourceCenter, dXCenter));\n}\n\n// offset vector by strokeWidth pixels\n// offset_direction is -1 (left) or 1 (right)\nvec2 getExtrusionOffset(vec2 line_clipspace, float offset_direction) {\n  // normalized direction of the line\n  vec2 dir_screenspace = normalize(line_clipspace * viewportSize);\n  // rotate by 90 degrees\n  dir_screenspace = vec2(-dir_screenspace.y, dir_screenspace.x);\n\n  vec2 offset_screenspace = dir_screenspace * offset_direction * strokeWidth / 2.0;\n  vec2 offset_clipspace = offset_screenspace / viewportSize * 2.0;\n\n  return offset_clipspace;\n}\n\nfloat getSegmentRatio(float index) {\n  return smoothstep(0.0, 1.0, index / (numSegments - 1.0));\n}\n\nvoid get_pos_fp64(vec2 source[2], vec2 target[2], float segmentRatio, out vec2 position[4]) {\n\n  vec2 vertex_height = paraboloid_fp64(source, target, segmentRatio);\n\n  vec2 position_temp[2];\n\n  vec2_mix_fp64(source, target, segmentRatio, position_temp);\n\n  position[0] = position_temp[0];\n  position[1] = position_temp[1];\n\n  if (vertex_height.x < 0.0 || (vertex_height.x == 0.0 && vertex_height.y <= 0.0)) {\n    vertex_height = vec2(0.0, 0.0);\n  }\n\n  position[2] = sqrt_fp64(vertex_height);\n  position[3] = vec2(1.0, 0.0);\n}\n\nvoid main(void) {\n  vec4 instanceSourcePositions64 = vec4(instancePositions.x,\n    instancePositions64Low.x, instancePositions.y, instancePositions64Low.y);\n  vec4 instanceTargetPositions64 = vec4(instancePositions.z,\n    instancePositions64Low.z, instancePositions.w, instancePositions64Low.w);\n\n  vec2 projected_source_coord[2];\n  vec2 projected_target_coord[2];\n\n  project_position_fp64(instanceSourcePositions64, projected_source_coord);\n  project_position_fp64(instanceTargetPositions64, projected_target_coord);\n\n  float segmentIndex = positions.x;\n  float segmentRatio = getSegmentRatio(segmentIndex);\n\n  // if it's the first point, use next - current as direction\n  // otherwise use current - prev\n  float indexDir = mix(-1.0, 1.0, step(segmentIndex, 0.0));\n  float nextSegmentRatio = getSegmentRatio(segmentIndex + indexDir);\n\n  vec2 curr_pos_modelspace[4];\n\n  get_pos_fp64(projected_source_coord, projected_target_coord, segmentRatio,\n    curr_pos_modelspace);\n\n  vec2 next_pos_modelspace[4];\n\n  get_pos_fp64(projected_source_coord, projected_target_coord, nextSegmentRatio,\n    next_pos_modelspace);\n\n  vec4 curr_pos_clipspace = project_to_clipspace_fp64(curr_pos_modelspace);\n  vec4 next_pos_clipspace = project_to_clipspace_fp64(next_pos_modelspace);\n\n  vec2 offset = getExtrusionOffset(next_pos_clipspace.xy - curr_pos_clipspace.xy, positions.y);\n\n  gl_Position = curr_pos_clipspace + vec4(offset, 0.0, 0.0);\n\n  vec4 color = mix(instanceSourceColors, instanceTargetColors, segmentRatio) / 255.;\n\n  vColor = mix(\n    vec4(color.rgb, color.a * opacity),\n    vec4(instancePickingColors / 255., 1.),\n    renderPickingBuffer\n  );\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 776 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME arc-layer-vertex-shader\n\nattribute vec3 positions;\nattribute vec4 instanceSourceColors;\nattribute vec4 instanceTargetColors;\nattribute vec4 instancePositions;\nattribute vec3 instancePickingColors;\n\nuniform float numSegments;\nuniform vec2 viewportSize;\nuniform float strokeWidth;\nuniform float opacity;\nuniform float renderPickingBuffer;\n\nvarying vec4 vColor;\n\nfloat paraboloid(vec2 source, vec2 target, float ratio) {\n\n  vec2 x = mix(source, target, ratio);\n  vec2 center = mix(source, target, 0.5);\n\n  float dSourceCenter = distance(source, center);\n  float dXCenter = distance(x, center);\n  return (dSourceCenter + dXCenter) * (dSourceCenter - dXCenter);\n}\n\n// offset vector by strokeWidth pixels\n// offset_direction is -1 (left) or 1 (right)\nvec2 getExtrusionOffset(vec2 line_clipspace, float offset_direction) {\n  // normalized direction of the line\n  vec2 dir_screenspace = normalize(line_clipspace * viewportSize);\n  // rotate by 90 degrees\n  dir_screenspace = vec2(-dir_screenspace.y, dir_screenspace.x);\n\n  vec2 offset_screenspace = dir_screenspace * offset_direction * strokeWidth / 2.0;\n  vec2 offset_clipspace = offset_screenspace / viewportSize * 2.0;\n\n  return offset_clipspace;\n}\n\nfloat getSegmentRatio(float index) {\n  return smoothstep(0.0, 1.0, index / (numSegments - 1.0));\n}\n\nvec3 getPos(vec2 source, vec2 target, float segmentRatio) {\n  float vertex_height = paraboloid(source, target, segmentRatio);\n\n  return vec3(\n    mix(source, target, segmentRatio),\n    sqrt(max(0.0, vertex_height))\n  );\n}\n\nvoid main(void) {\n  vec2 source = project_position(instancePositions.xy);\n  vec2 target = project_position(instancePositions.zw);\n\n  float segmentIndex = positions.x;\n  float segmentRatio = getSegmentRatio(segmentIndex);\n  // if it's the first point, use next - current as direction\n  // otherwise use current - prev\n  float indexDir = mix(-1.0, 1.0, step(segmentIndex, 0.0));\n  float nextSegmentRatio = getSegmentRatio(segmentIndex + indexDir);\n\n  vec3 currPos = getPos(source, target, segmentRatio);\n  vec3 nextPos = getPos(source, target, nextSegmentRatio);\n  vec4 curr = project_to_clipspace(vec4(currPos, 1.0));\n  vec4 next = project_to_clipspace(vec4(nextPos, 1.0));\n\n  // extrude\n  vec2 offset = getExtrusionOffset((next.xy - curr.xy) * indexDir, positions.y);\n  gl_Position = curr + vec4(offset, 0.0, 0.0);\n\n  vec4 color = mix(instanceSourceColors, instanceTargetColors, segmentRatio) / 255.;\n\n  vColor = mix(\n    vec4(color.rgb, color.a * opacity),\n    vec4(instancePickingColors / 255., 1.),\n    renderPickingBuffer\n  );\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _luma = __webpack_require__(29);
	
	var _fp = __webpack_require__(54);
	
	var _arcLayerVertex = __webpack_require__(776);
	
	var _arcLayerVertex2 = _interopRequireDefault(_arcLayerVertex);
	
	var _arcLayerVertex3 = __webpack_require__(775);
	
	var _arcLayerVertex4 = _interopRequireDefault(_arcLayerVertex3);
	
	var _arcLayerFragment = __webpack_require__(774);
	
	var _arcLayerFragment2 = _interopRequireDefault(_arcLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEFAULT_COLOR = [0, 0, 0, 255];
	
	var defaultProps = {
	  strokeWidth: 1,
	  fp64: false,
	
	  getSourcePosition: function getSourcePosition(x) {
	    return x.sourcePosition;
	  },
	  getTargetPosition: function getTargetPosition(x) {
	    return x.targetPosition;
	  },
	  getSourceColor: function getSourceColor(x) {
	    return x.color || DEFAULT_COLOR;
	  },
	  getTargetColor: function getTargetColor(x) {
	    return x.color || DEFAULT_COLOR;
	  }
	};
	
	var ArcLayer = function (_Layer) {
	  _inherits(ArcLayer, _Layer);
	
	  function ArcLayer() {
	    _classCallCheck(this, ArcLayer);
	
	    return _possibleConstructorReturn(this, (ArcLayer.__proto__ || Object.getPrototypeOf(ArcLayer)).apply(this, arguments));
	  }
	
	  _createClass(ArcLayer, [{
	    key: 'getShaders',
	    value: function getShaders() {
	      return (0, _fp.enable64bitSupport)(this.props) ? {
	        vs: _arcLayerVertex4.default, fs: _arcLayerFragment2.default, modules: ['fp64', 'project64']
	      } : {
	        vs: _arcLayerVertex2.default, fs: _arcLayerFragment2.default, modules: []
	      };
	    }
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      var gl = this.context.gl;
	
	      this.setState({ model: this._getModel(gl) });
	
	      var attributeManager = this.state.attributeManager;
	
	      /* eslint-disable max-len */
	
	      attributeManager.addInstanced({
	        instancePositions: { size: 4, accessor: ['getSourcePosition', 'getTargetPosition'], update: this.calculateInstancePositions },
	        instanceSourceColors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getSourceColor', update: this.calculateInstanceSourceColors },
	        instanceTargetColors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getTargetColor', update: this.calculateInstanceTargetColors }
	      });
	      /* eslint-enable max-len */
	    }
	  }, {
	    key: 'updateAttribute',
	    value: function updateAttribute(_ref) {
	      var props = _ref.props,
	          oldProps = _ref.oldProps,
	          changeFlags = _ref.changeFlags;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidateAll();
	
	        if (props.fp64 && props.projectionMode === _lib.COORDINATE_SYSTEM.LNGLAT) {
	          attributeManager.addInstanced({
	            instancePositions64Low: {
	              size: 4,
	              accessor: ['getSourcePosition', 'getTargetPosition'],
	              update: this.calculateInstancePositions64Low
	            }
	          });
	        } else {
	          attributeManager.remove(['instancePositions64Low']);
	        }
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref2) {
	      var props = _ref2.props,
	          oldProps = _ref2.oldProps,
	          changeFlags = _ref2.changeFlags;
	
	      _get(ArcLayer.prototype.__proto__ || Object.getPrototypeOf(ArcLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	      // Re-generate model if geometry changed
	      if (props.fp64 !== oldProps.fp64) {
	        var gl = this.context.gl;
	
	        this.setState({ model: this._getModel(gl) });
	      }
	      this.updateAttribute({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref3) {
	      var uniforms = _ref3.uniforms;
	      var strokeWidth = this.props.strokeWidth;
	
	
	      this.state.model.render(Object.assign({}, uniforms, {
	        strokeWidth: strokeWidth
	      }));
	    }
	  }, {
	    key: '_getModel',
	    value: function _getModel(gl) {
	      var positions = [];
	      var NUM_SEGMENTS = 50;
	      /*
	       *  (0, -1)-------------_(1, -1)
	       *       |          _,-"  |
	       *       o      _,-"      o
	       *       |  _,-"          |
	       *   (0, 1)"-------------(1, 1)
	       */
	      for (var i = 0; i < NUM_SEGMENTS; i++) {
	        positions = positions.concat([i, -1, 0, i, 1, 0]);
	      }
	
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      var model = new _luma.Model({
	        gl: gl,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: _luma.GL.TRIANGLE_STRIP,
	          positions: new Float32Array(positions)
	        }),
	        isInstanced: true
	      });
	
	      model.setUniforms({ numSegments: NUM_SEGMENTS });
	
	      return model;
	    }
	  }, {
	    key: 'calculateInstancePositions',
	    value: function calculateInstancePositions(attribute) {
	      var _props = this.props,
	          data = _props.data,
	          getSourcePosition = _props.getSourcePosition,
	          getTargetPosition = _props.getTargetPosition;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var object = _step.value;
	
	          var sourcePosition = getSourcePosition(object);
	          var targetPosition = getTargetPosition(object);
	          value[i + 0] = sourcePosition[0];
	          value[i + 1] = sourcePosition[1];
	          value[i + 2] = targetPosition[0];
	          value[i + 3] = targetPosition[1];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstancePositions64Low',
	    value: function calculateInstancePositions64Low(attribute) {
	      var _props2 = this.props,
	          data = _props2.data,
	          getSourcePosition = _props2.getSourcePosition,
	          getTargetPosition = _props2.getTargetPosition;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var object = _step2.value;
	
	          var sourcePosition = getSourcePosition(object);
	          var targetPosition = getTargetPosition(object);
	          value[i + 0] = (0, _fp.fp64ify)(sourcePosition[0])[1];
	          value[i + 1] = (0, _fp.fp64ify)(sourcePosition[1])[1];
	          value[i + 2] = (0, _fp.fp64ify)(targetPosition[0])[1];
	          value[i + 3] = (0, _fp.fp64ify)(targetPosition[1])[1];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceSourceColors',
	    value: function calculateInstanceSourceColors(attribute) {
	      var _props3 = this.props,
	          data = _props3.data,
	          getSourceColor = _props3.getSourceColor;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var object = _step3.value;
	
	          var color = getSourceColor(object);
	          value[i + 0] = color[0];
	          value[i + 1] = color[1];
	          value[i + 2] = color[2];
	          value[i + 3] = isNaN(color[3]) ? 255 : color[3];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceTargetColors',
	    value: function calculateInstanceTargetColors(attribute) {
	      var _props4 = this.props,
	          data = _props4.data,
	          getTargetColor = _props4.getTargetColor;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var object = _step4.value;
	
	          var color = getTargetColor(object);
	          value[i + 0] = color[0];
	          value[i + 1] = color[1];
	          value[i + 2] = color[2];
	          value[i + 3] = isNaN(color[3]) ? 255 : color[3];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	  }]);
	
	  return ArcLayer;
	}(_lib.Layer);
	
	exports.default = ArcLayer;
	
	
	ArcLayer.layerName = 'ArcLayer';
	ArcLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lib = __webpack_require__(35);
	
	var _scatterplotLayer = __webpack_require__(388);
	
	var _scatterplotLayer2 = _interopRequireDefault(_scatterplotLayer);
	
	var _pathLayer = __webpack_require__(257);
	
	var _pathLayer2 = _interopRequireDefault(_pathLayer);
	
	var _solidPolygonLayer = __webpack_require__(389);
	
	var _solidPolygonLayer2 = _interopRequireDefault(_solidPolygonLayer);
	
	var _geojson = __webpack_require__(779);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Use primitive layer to avoid "Composite Composite" layers for now
	
	
	var defaultLineColor = [0x0, 0x0, 0x0, 0xFF];
	var defaultFillColor = [0x0, 0x0, 0x0, 0xFF];
	
	var defaultProps = {
	  stroked: true,
	  filled: true,
	  extruded: false,
	  wireframe: false,
	
	  lineWidthScale: 1,
	  lineWidthMinPixels: 0,
	  lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
	  lineJointRounded: false,
	  lineMiterLimit: 4,
	  fp64: false,
	
	  // Line and polygon outline color
	  getLineColor: function getLineColor(f) {
	    return (0, _lib.get)(f, 'properties.lineColor') || defaultLineColor;
	  },
	  // Point and polygon fill color
	  getFillColor: function getFillColor(f) {
	    return (0, _lib.get)(f, 'properties.fillColor') || defaultFillColor;
	  },
	  // Point radius
	  getRadius: function getRadius(f) {
	    return (0, _lib.get)(f, 'properties.radius') || (0, _lib.get)(f, 'properties.size') || 1;
	  },
	  // Line and polygon outline accessors
	  getLineWidth: function getLineWidth(f) {
	    return (0, _lib.get)(f, 'properties.lineWidth') || 1;
	  },
	  // Polygon extrusion accessor
	  getElevation: function getElevation(f) {
	    return (0, _lib.get)(f, 'properties.elevation') || 1000;
	  },
	
	  // Optional settings for 'lighting' shader module
	  lightSettings: {
	    lightsPosition: [-122.45, 37.75, 8000, -122.0, 38.00, 5000],
	    ambientRatio: 0.05,
	    diffuseRatio: 0.6,
	    specularRatio: 0.8,
	    lightsStrength: [2.0, 0.0, 0.0, 0.0],
	    numberOfLights: 2
	  }
	};
	
	var getCoordinates = function getCoordinates(f) {
	  return (0, _lib.get)(f, 'geometry.coordinates');
	};
	
	var GeoJsonLayer = function (_CompositeLayer) {
	  _inherits(GeoJsonLayer, _CompositeLayer);
	
	  function GeoJsonLayer() {
	    _classCallCheck(this, GeoJsonLayer);
	
	    return _possibleConstructorReturn(this, (GeoJsonLayer.__proto__ || Object.getPrototypeOf(GeoJsonLayer)).apply(this, arguments));
	  }
	
	  _createClass(GeoJsonLayer, [{
	    key: 'initializeState',
	    value: function initializeState() {
	      this.state = {
	        features: {}
	      };
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref) {
	      var oldProps = _ref.oldProps,
	          props = _ref.props,
	          changeFlags = _ref.changeFlags;
	
	      if (changeFlags.dataChanged) {
	        var data = this.props.data;
	
	        var features = (0, _geojson.getGeojsonFeatures)(data);
	        this.state.features = (0, _geojson.separateGeojsonFeatures)(features);
	      }
	    }
	  }, {
	    key: 'getPickingInfo',
	    value: function getPickingInfo(_ref2) {
	      var info = _ref2.info;
	
	      return Object.assign(info, {
	        // override object with picked feature
	        object: info.object && info.object.feature || info.object
	      });
	    }
	  }, {
	    key: 'renderLayers',
	    value: function renderLayers() {
	      var features = this.state.features;
	      var pointFeatures = features.pointFeatures,
	          lineFeatures = features.lineFeatures,
	          polygonFeatures = features.polygonFeatures,
	          polygonOutlineFeatures = features.polygonOutlineFeatures;
	
	      // Layer composition props
	
	      var _props = this.props,
	          id = _props.id,
	          stroked = _props.stroked,
	          filled = _props.filled,
	          extruded = _props.extruded,
	          wireframe = _props.wireframe,
	          lightSettings = _props.lightSettings;
	
	      // Rendering props underlying layer
	
	      var _props2 = this.props,
	          lineWidthScale = _props2.lineWidthScale,
	          lineWidthMinPixels = _props2.lineWidthMinPixels,
	          lineWidthMaxPixels = _props2.lineWidthMaxPixels,
	          lineJointRounded = _props2.lineJointRounded,
	          lineMiterLimit = _props2.lineMiterLimit,
	          fp64 = _props2.fp64;
	
	      // Accessor props for underlying layers
	
	      var _props3 = this.props,
	          getLineColor = _props3.getLineColor,
	          getFillColor = _props3.getFillColor,
	          getRadius = _props3.getRadius,
	          getLineWidth = _props3.getLineWidth,
	          getElevation = _props3.getElevation,
	          updateTriggers = _props3.updateTriggers;
	
	      // base layer props
	
	      var _props4 = this.props,
	          opacity = _props4.opacity,
	          pickable = _props4.pickable,
	          visible = _props4.visible;
	
	      // viewport props
	
	      var _props5 = this.props,
	          positionOrigin = _props5.positionOrigin,
	          projectionMode = _props5.projectionMode,
	          modelMatrix = _props5.modelMatrix;
	
	
	      var drawPoints = pointFeatures && pointFeatures.length > 0;
	      var drawLines = lineFeatures && lineFeatures.length > 0;
	      var hasPolygonLines = polygonOutlineFeatures && polygonOutlineFeatures.length > 0;
	      var hasPolygon = polygonFeatures && polygonFeatures.length > 0;
	
	      // Filled Polygon Layer
	      var polygonFillLayer = filled && hasPolygon && new _solidPolygonLayer2.default({
	        id: id + '-polygon-fill',
	        data: polygonFeatures,
	        extruded: extruded,
	        wireframe: false,
	        lightSettings: lightSettings,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getPolygon: getCoordinates,
	        getElevation: getElevation,
	        getColor: getFillColor,
	        updateTriggers: {
	          getElevation: updateTriggers.getElevation,
	          getColor: updateTriggers.getFillColor
	        }
	      });
	
	      var polygonWireframeLayer = wireframe && extruded && hasPolygon && new _solidPolygonLayer2.default({
	        id: id + '-polygon-wireframe',
	        data: polygonFeatures,
	        extruded: extruded,
	        wireframe: true,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getPolygon: getCoordinates,
	        getElevation: getElevation,
	        getColor: getLineColor,
	        updateTriggers: {
	          getElevation: updateTriggers.getElevation,
	          getColor: updateTriggers.getLineColor
	        }
	      });
	
	      var polygonLineLayer = !extruded && stroked && hasPolygonLines && new _pathLayer2.default({
	        id: id + '-polygon-outline',
	        data: polygonOutlineFeatures,
	        widthScale: lineWidthScale,
	        widthMinPixels: lineWidthMinPixels,
	        widthMaxPixels: lineWidthMaxPixels,
	        rounded: lineJointRounded,
	        miterLimit: lineMiterLimit,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getPath: getCoordinates,
	        getColor: getLineColor,
	        getWidth: getLineWidth,
	        updateTriggers: {
	          getColor: updateTriggers.getLineColor,
	          getWidth: updateTriggers.getLineWidth
	        }
	      });
	
	      var pathLayer = drawLines && new _pathLayer2.default({
	        id: id + '-line-paths',
	        data: lineFeatures,
	        widthScale: lineWidthScale,
	        widthMinPixels: lineWidthMinPixels,
	        widthMaxPixels: lineWidthMaxPixels,
	        rounded: lineJointRounded,
	        miterLimit: lineMiterLimit,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getPath: getCoordinates,
	        getColor: getLineColor,
	        getWidth: getLineWidth,
	        updateTriggers: {
	          getColor: updateTriggers.getLineColor,
	          getWidth: updateTriggers.getLineWidth
	        }
	      });
	
	      var pointLayer = drawPoints && new _scatterplotLayer2.default({
	        id: id + '-points',
	        data: pointFeatures,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getPosition: getCoordinates,
	        getColor: getFillColor,
	        getRadius: getRadius,
	        updateTriggers: {
	          getColor: updateTriggers.getFillColor,
	          getRadius: updateTriggers.getRadius
	        }
	      });
	
	      return [polygonFillLayer, polygonWireframeLayer, polygonLineLayer, pathLayer, pointLayer].filter(Boolean);
	    }
	  }]);
	
	  return GeoJsonLayer;
	}(_lib.CompositeLayer);
	
	exports.default = GeoJsonLayer;
	
	
	GeoJsonLayer.layerName = 'GeoJsonLayer';
	GeoJsonLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGeojsonFeatures = getGeojsonFeatures;
	exports.separateGeojsonFeatures = separateGeojsonFeatures;
	
	var _lib = __webpack_require__(35);
	
	/**
	 * "Normalizes" complete or partial GeoJSON data into iterable list of features
	 * Can accept GeoJSON geometry or "Feature", "FeatureCollection" in addition
	 * to plain arrays and iterables.
	 * Works by extracting the feature array or wrapping single objects in an array,
	 * so that subsequent code can simply iterate over features.
	 *
	 * @param {object} geojson - geojson data
	 * @param {Object|Array} data - geojson object (FeatureCollection, Feature or
	 *  Geometry) or array of features
	 * @return {Array|"iteratable"} - iterable list of features
	 */
	function getGeojsonFeatures(geojson) {
	  // If array, assume this is a list of features
	  if (Array.isArray(geojson)) {
	    return geojson;
	  }
	
	  var type = (0, _lib.get)(geojson, 'type');
	  switch (type) {
	    case 'Point':
	    case 'MultiPoint':
	    case 'LineString':
	    case 'MultiLineString':
	    case 'Polygon':
	    case 'MultiPolygon':
	    case 'GeometryCollection':
	      // Wrap the geometry object in a 'Feature' object and wrap in an array
	      return [{ type: 'Feature', properties: {}, geometry: geojson }];
	    case 'Feature':
	      // Wrap the feature in a 'Features' array
	      return [geojson];
	    case 'FeatureCollection':
	      // Just return the 'Features' array from the collection
	      return (0, _lib.get)(geojson, 'features');
	    default:
	      throw new Error('Unknown geojson type');
	  }
	}
	
	// Linearize
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	function separateGeojsonFeatures(features) {
	  var pointFeatures = [];
	  var lineFeatures = [];
	  var polygonFeatures = [];
	  var polygonOutlineFeatures = [];
	
	  features.forEach(function (feature) {
	    var type = (0, _lib.get)(feature, 'geometry.type');
	    var coordinates = (0, _lib.get)(feature, 'geometry.coordinates');
	    var properties = (0, _lib.get)(feature, 'properties');
	    switch (type) {
	      case 'Point':
	        pointFeatures.push(feature);
	        break;
	      case 'MultiPoint':
	        // TODO - split multipoints
	        coordinates.forEach(function (point) {
	          pointFeatures.push({ geometry: { coordinates: point }, properties: properties, feature: feature });
	        });
	        break;
	      case 'LineString':
	        lineFeatures.push(feature);
	        break;
	      case 'MultiLineString':
	        // Break multilinestrings into multiple lines with same properties
	        coordinates.forEach(function (path) {
	          lineFeatures.push({ geometry: { coordinates: path }, properties: properties, feature: feature });
	        });
	        break;
	      case 'Polygon':
	        polygonFeatures.push(feature);
	        // Break polygon into multiple lines with same properties
	        coordinates.forEach(function (path) {
	          polygonOutlineFeatures.push({ geometry: { coordinates: path }, properties: properties, feature: feature });
	        });
	        break;
	      case 'MultiPolygon':
	        // Break multipolygons into multiple polygons with same properties
	        coordinates.forEach(function (polygon) {
	          polygonFeatures.push({ geometry: { coordinates: polygon }, properties: properties, feature: feature });
	          // Break polygon into multiple lines with same properties
	          polygon.forEach(function (path) {
	            polygonOutlineFeatures.push({ geometry: { coordinates: path }, properties: properties, feature: feature });
	          });
	        });
	        break;
	      // Not yet supported
	      case 'GeometryCollection':
	      default:
	        throw new Error('GeoJsonLayer: ' + type + ' not supported.');
	    }
	  });
	
	  return {
	    pointFeatures: pointFeatures,
	    lineFeatures: lineFeatures,
	    polygonFeatures: polygonFeatures,
	    polygonOutlineFeatures: polygonOutlineFeatures
	  };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 780 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME grid-cell-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  gl_FragColor = vColor;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 781 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Inspired by screen-grid-layer vertex shader in deck.gl
	
	exports.default = "#define SHADER_NAME grid-layer-vs\n\nattribute vec3 positions;\nattribute vec3 normals;\n\nattribute vec4 instancePositions;\nattribute vec2 instancePositions64xyLow;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\n// Picking uniforms\n// Set to 1.0 if rendering picking buffer, 0.0 if rendering for display\nuniform float renderPickingBuffer;\nuniform vec3 selectedPickingColor;\n\n// Custom uniforms\nuniform float extruded;\nuniform float lonOffset;\nuniform float latOffset;\nuniform float opacity;\nuniform float elevationScale;\n\n// A magic number to scale elevation so that 1 unit approximate to 1 meter\n#define ELEVATION_SCALE 0.8\n\n// Result\nvarying vec4 vColor;\n\nfloat isPicked(vec3 pickingColors, vec3 selectedColor) {\n return float(pickingColors.x == selectedColor.x\n && pickingColors.y == selectedColor.y\n && pickingColors.z == selectedColor.z);\n}\n\n\nvoid main(void) {\n  vec4 instancePositions64xy = vec4(\n    instancePositions.x + (positions.x + 1.0) * lonOffset / 2.0,\n    instancePositions64xyLow.x,\n    instancePositions.y + (positions.y + 1.0) * latOffset / 2.0,\n    instancePositions64xyLow.y);\n\n  vec2 projected_coord_xy[2];\n  project_position_fp64(instancePositions64xy, projected_coord_xy);\n\n  float elevation = 0.0;\n\n  if (extruded > 0.5) {\n    elevation = project_scale(instancePositions.w  * (positions.z + 1.0) *\n      ELEVATION_SCALE * elevationScale) + 1.0;\n  }\n\n  vec2 vertex_pos_modelspace[4];\n  vertex_pos_modelspace[0] = projected_coord_xy[0];\n  vertex_pos_modelspace[1] = projected_coord_xy[1];\n  vertex_pos_modelspace[2] = vec2(elevation, 0.0);\n  vertex_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  vec4 position_worldspace = vec4(\n    vertex_pos_modelspace[0].x, vertex_pos_modelspace[1].x,\n    vertex_pos_modelspace[2].x, vertex_pos_modelspace[3].x);\n\n  gl_Position = project_to_clipspace_fp64(vertex_pos_modelspace);\n\n  if (renderPickingBuffer < 0.5) {\n\n    // TODO: we should allow the user to specify the color for \"selected element\"\n    // check whether a bar is currently picked.\n    float selected = isPicked(instancePickingColors, selectedPickingColor);\n\n    float lightWeight = 1.0;\n\n    if (extruded > 0.5) {\n      lightWeight = getLightWeight(\n        position_worldspace,\n        normals\n      );\n    }\n\n    vec3 lightWeightedColor = lightWeight * instanceColors.rgb;\n    vec4 color = vec4(lightWeightedColor, instanceColors.a * opacity) / 255.0;\n    vColor = color;\n\n  } else {\n\n    vec4 pickingColor = vec4(instancePickingColors / 255.0, 1.0);\n     vColor = pickingColor;\n\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 782 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Inspired by screen-grid-layer vertex shader in deck.gl
	
	exports.default = "#define SHADER_NAME grid-layer-vs\n\nattribute vec3 positions;\nattribute vec3 normals;\n\nattribute vec4 instancePositions;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\n// Picking uniforms\n// Set to 1.0 if rendering picking buffer, 0.0 if rendering for display\nuniform float renderPickingBuffer;\nuniform vec3 selectedPickingColor;\n\n// Custom uniforms\nuniform float extruded;\nuniform float cellSize;\nuniform float opacity;\nuniform float elevationScale;\n\n// A magic number to scale elevation so that 1 unit approximate to 1 meter\n#define ELEVATION_SCALE 0.8\n\n// Result\nvarying vec4 vColor;\n\n// whether is point picked\nfloat isPicked(vec3 pickingColors, vec3 selectedColor) {\n return float(pickingColors.x == selectedColor.x\n && pickingColors.y == selectedColor.y\n && pickingColors.z == selectedColor.z);\n}\n\nvoid main(void) {\n\n  vec2 topLeftPos = project_position(instancePositions.xy);\n\n  // cube gemoetry vertics are between -1 to 1, scale and transform it to between 0, 1\n  vec2 pos = topLeftPos + vec2((positions.x + 1.0) * cellSize\n     / 2.0, (positions.y + 1.0) * cellSize / 2.0);\n\n  float elevation = 0.0;\n\n  if (extruded > 0.5) {\n    elevation = project_scale(instancePositions.w  * (positions.z + 1.0) *\n      ELEVATION_SCALE * elevationScale);\n  }\n\n  // extrude positions\n  vec3 extrudedPosition = vec3(pos.xy, elevation + 1.0);\n  vec4 position_worldspace = vec4(extrudedPosition, 1.0);\n  gl_Position = project_to_clipspace(position_worldspace);\n\n  if (renderPickingBuffer < 0.5) {\n\n    // TODO: we should allow the user to specify the color for \"selected element\"\n    // check whether a bar is currently picked.\n    float selected = isPicked(instancePickingColors, selectedPickingColor);\n\n    float lightWeight = 1.0;\n\n    if (extruded > 0.5) {\n      lightWeight = getLightWeight(\n        position_worldspace,\n        normals\n      );\n    }\n\n    vec3 lightWeightedColor = lightWeight * instanceColors.rgb;\n    vec4 color = vec4(lightWeightedColor, instanceColors.a * opacity) / 255.0;\n    vColor = color;\n\n  } else {\n\n    vec4 pickingColor = vec4(instancePickingColors / 255.0, 1.0);\n     vColor = pickingColor;\n\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9sYXllcnMvY29yZS9ncmlkLWNlbGwtbGF5ZXIvZ3JpZC1jZWxsLWxheWVyLXZlcnRleC5nbHNsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUEiLCJmaWxlIjoiZ3JpZC1jZWxsLWxheWVyLXZlcnRleC5nbHNsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQ29weXJpZ2h0IChjKSAyMDE1IC0gMjAxNyBVYmVyIFRlY2hub2xvZ2llcywgSW5jLlxuLy9cbi8vIFBlcm1pc3Npb24gaXMgaGVyZWJ5IGdyYW50ZWQsIGZyZWUgb2YgY2hhcmdlLCB0byBhbnkgcGVyc29uIG9idGFpbmluZyBhIGNvcHlcbi8vIG9mIHRoaXMgc29mdHdhcmUgYW5kIGFzc29jaWF0ZWQgZG9jdW1lbnRhdGlvbiBmaWxlcyAodGhlIFwiU29mdHdhcmVcIiksIHRvIGRlYWxcbi8vIGluIHRoZSBTb2Z0d2FyZSB3aXRob3V0IHJlc3RyaWN0aW9uLCBpbmNsdWRpbmcgd2l0aG91dCBsaW1pdGF0aW9uIHRoZSByaWdodHNcbi8vIHRvIHVzZSwgY29weSwgbW9kaWZ5LCBtZXJnZSwgcHVibGlzaCwgZGlzdHJpYnV0ZSwgc3VibGljZW5zZSwgYW5kL29yIHNlbGxcbi8vIGNvcGllcyBvZiB0aGUgU29mdHdhcmUsIGFuZCB0byBwZXJtaXQgcGVyc29ucyB0byB3aG9tIHRoZSBTb2Z0d2FyZSBpc1xuLy8gZnVybmlzaGVkIHRvIGRvIHNvLCBzdWJqZWN0IHRvIHRoZSBmb2xsb3dpbmcgY29uZGl0aW9uczpcbi8vXG4vLyBUaGUgYWJvdmUgY29weXJpZ2h0IG5vdGljZSBhbmQgdGhpcyBwZXJtaXNzaW9uIG5vdGljZSBzaGFsbCBiZSBpbmNsdWRlZCBpblxuLy8gYWxsIGNvcGllcyBvciBzdWJzdGFudGlhbCBwb3J0aW9ucyBvZiB0aGUgU29mdHdhcmUuXG4vL1xuLy8gVEhFIFNPRlRXQVJFIElTIFBST1ZJREVEIFwiQVMgSVNcIiwgV0lUSE9VVCBXQVJSQU5UWSBPRiBBTlkgS0lORCwgRVhQUkVTUyBPUlxuLy8gSU1QTElFRCwgSU5DTFVESU5HIEJVVCBOT1QgTElNSVRFRCBUTyBUSEUgV0FSUkFOVElFUyBPRiBNRVJDSEFOVEFCSUxJVFksXG4vLyBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRSBBTkQgTk9OSU5GUklOR0VNRU5ULiBJTiBOTyBFVkVOVCBTSEFMTCBUSEVcbi8vIEFVVEhPUlMgT1IgQ09QWVJJR0hUIEhPTERFUlMgQkUgTElBQkxFIEZPUiBBTlkgQ0xBSU0sIERBTUFHRVMgT1IgT1RIRVJcbi8vIExJQUJJTElUWSwgV0hFVEhFUiBJTiBBTiBBQ1RJT04gT0YgQ09OVFJBQ1QsIFRPUlQgT1IgT1RIRVJXSVNFLCBBUklTSU5HIEZST00sXG4vLyBPVVQgT0YgT1IgSU4gQ09OTkVDVElPTiBXSVRIIFRIRSBTT0ZUV0FSRSBPUiBUSEUgVVNFIE9SIE9USEVSIERFQUxJTkdTIElOXG4vLyBUSEUgU09GVFdBUkUuXG5cbi8vIEluc3BpcmVkIGJ5IHNjcmVlbi1ncmlkLWxheWVyIHZlcnRleCBzaGFkZXIgaW4gZGVjay5nbFxuXG5leHBvcnQgZGVmYXVsdCBgXFxcbiNkZWZpbmUgU0hBREVSX05BTUUgZ3JpZC1sYXllci12c1xuXG5hdHRyaWJ1dGUgdmVjMyBwb3NpdGlvbnM7XG5hdHRyaWJ1dGUgdmVjMyBub3JtYWxzO1xuXG5hdHRyaWJ1dGUgdmVjNCBpbnN0YW5jZVBvc2l0aW9ucztcbmF0dHJpYnV0ZSB2ZWM0IGluc3RhbmNlQ29sb3JzO1xuYXR0cmlidXRlIHZlYzMgaW5zdGFuY2VQaWNraW5nQ29sb3JzO1xuXG4vLyBQaWNraW5nIHVuaWZvcm1zXG4vLyBTZXQgdG8gMS4wIGlmIHJlbmRlcmluZyBwaWNraW5nIGJ1ZmZlciwgMC4wIGlmIHJlbmRlcmluZyBmb3IgZGlzcGxheVxudW5pZm9ybSBmbG9hdCByZW5kZXJQaWNraW5nQnVmZmVyO1xudW5pZm9ybSB2ZWMzIHNlbGVjdGVkUGlja2luZ0NvbG9yO1xuXG4vLyBDdXN0b20gdW5pZm9ybXNcbnVuaWZvcm0gZmxvYXQgZXh0cnVkZWQ7XG51bmlmb3JtIGZsb2F0IGNlbGxTaXplO1xudW5pZm9ybSBmbG9hdCBvcGFjaXR5O1xudW5pZm9ybSBmbG9hdCBlbGV2YXRpb25TY2FsZTtcblxuLy8gQSBtYWdpYyBudW1iZXIgdG8gc2NhbGUgZWxldmF0aW9uIHNvIHRoYXQgMSB1bml0IGFwcHJveGltYXRlIHRvIDEgbWV0ZXJcbiNkZWZpbmUgRUxFVkFUSU9OX1NDQUxFIDAuOFxuXG4vLyBSZXN1bHRcbnZhcnlpbmcgdmVjNCB2Q29sb3I7XG5cbi8vIHdoZXRoZXIgaXMgcG9pbnQgcGlja2VkXG5mbG9hdCBpc1BpY2tlZCh2ZWMzIHBpY2tpbmdDb2xvcnMsIHZlYzMgc2VsZWN0ZWRDb2xvcikge1xuIHJldHVybiBmbG9hdChwaWNraW5nQ29sb3JzLnggPT0gc2VsZWN0ZWRDb2xvci54XG4gJiYgcGlja2luZ0NvbG9ycy55ID09IHNlbGVjdGVkQ29sb3IueVxuICYmIHBpY2tpbmdDb2xvcnMueiA9PSBzZWxlY3RlZENvbG9yLnopO1xufVxuXG52b2lkIG1haW4odm9pZCkge1xuXG4gIHZlYzIgdG9wTGVmdFBvcyA9IHByb2plY3RfcG9zaXRpb24oaW5zdGFuY2VQb3NpdGlvbnMueHkpO1xuXG4gIC8vIGN1YmUgZ2Vtb2V0cnkgdmVydGljcyBhcmUgYmV0d2VlbiAtMSB0byAxLCBzY2FsZSBhbmQgdHJhbnNmb3JtIGl0IHRvIGJldHdlZW4gMCwgMVxuICB2ZWMyIHBvcyA9IHRvcExlZnRQb3MgKyB2ZWMyKChwb3NpdGlvbnMueCArIDEuMCkgKiBjZWxsU2l6ZVxuICAgICAvIDIuMCwgKHBvc2l0aW9ucy55ICsgMS4wKSAqIGNlbGxTaXplIC8gMi4wKTtcblxuICBmbG9hdCBlbGV2YXRpb24gPSAwLjA7XG5cbiAgaWYgKGV4dHJ1ZGVkID4gMC41KSB7XG4gICAgZWxldmF0aW9uID0gcHJvamVjdF9zY2FsZShpbnN0YW5jZVBvc2l0aW9ucy53ICAqIChwb3NpdGlvbnMueiArIDEuMCkgKlxuICAgICAgRUxFVkFUSU9OX1NDQUxFICogZWxldmF0aW9uU2NhbGUpO1xuICB9XG5cbiAgLy8gZXh0cnVkZSBwb3NpdGlvbnNcbiAgdmVjMyBleHRydWRlZFBvc2l0aW9uID0gdmVjMyhwb3MueHksIGVsZXZhdGlvbiArIDEuMCk7XG4gIHZlYzQgcG9zaXRpb25fd29ybGRzcGFjZSA9IHZlYzQoZXh0cnVkZWRQb3NpdGlvbiwgMS4wKTtcbiAgZ2xfUG9zaXRpb24gPSBwcm9qZWN0X3RvX2NsaXBzcGFjZShwb3NpdGlvbl93b3JsZHNwYWNlKTtcblxuICBpZiAocmVuZGVyUGlja2luZ0J1ZmZlciA8IDAuNSkge1xuXG4gICAgLy8gVE9ETzogd2Ugc2hvdWxkIGFsbG93IHRoZSB1c2VyIHRvIHNwZWNpZnkgdGhlIGNvbG9yIGZvciBcInNlbGVjdGVkIGVsZW1lbnRcIlxuICAgIC8vIGNoZWNrIHdoZXRoZXIgYSBiYXIgaXMgY3VycmVudGx5IHBpY2tlZC5cbiAgICBmbG9hdCBzZWxlY3RlZCA9IGlzUGlja2VkKGluc3RhbmNlUGlja2luZ0NvbG9ycywgc2VsZWN0ZWRQaWNraW5nQ29sb3IpO1xuXG4gICAgZmxvYXQgbGlnaHRXZWlnaHQgPSAxLjA7XG5cbiAgICBpZiAoZXh0cnVkZWQgPiAwLjUpIHtcbiAgICAgIGxpZ2h0V2VpZ2h0ID0gZ2V0TGlnaHRXZWlnaHQoXG4gICAgICAgIHBvc2l0aW9uX3dvcmxkc3BhY2UsXG4gICAgICAgIG5vcm1hbHNcbiAgICAgICk7XG4gICAgfVxuXG4gICAgdmVjMyBsaWdodFdlaWdodGVkQ29sb3IgPSBsaWdodFdlaWdodCAqIGluc3RhbmNlQ29sb3JzLnJnYjtcbiAgICB2ZWM0IGNvbG9yID0gdmVjNChsaWdodFdlaWdodGVkQ29sb3IsIGluc3RhbmNlQ29sb3JzLmEgKiBvcGFjaXR5KSAvIDI1NS4wO1xuICAgIHZDb2xvciA9IGNvbG9yO1xuXG4gIH0gZWxzZSB7XG5cbiAgICB2ZWM0IHBpY2tpbmdDb2xvciA9IHZlYzQoaW5zdGFuY2VQaWNraW5nQ29sb3JzIC8gMjU1LjAsIDEuMCk7XG4gICAgIHZDb2xvciA9IHBpY2tpbmdDb2xvcjtcblxuICB9XG59XG5gO1xuIl19

/***/ },
/* 783 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pointToDensityGridData = pointToDensityGridData;
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	var R_EARTH = 6378000;
	
	/**
	 * Calculate density grid from an array of points
	 * @param {array} points
	 * @param {number} cellSize - cell size in meters
	 * @param {function} getPosition - position accessor
	 * @returns {object} - grid data, cell dimension and count range
	 */
	function pointToDensityGridData(points, cellSize, getPosition) {
	  var _pointsToGridHashing2 = _pointsToGridHashing(points, cellSize, getPosition),
	      gridHash = _pointsToGridHashing2.gridHash,
	      gridOffset = _pointsToGridHashing2.gridOffset;
	
	  var layerData = _getGridLayerDataFromGridHash(gridHash, gridOffset);
	  var countRange = _getCellCountExtent(layerData);
	
	  return {
	    gridOffset: gridOffset,
	    layerData: layerData,
	    countRange: countRange
	  };
	}
	
	/**
	 * Project points into each cell, return a hash table of cells
	 * @param {array} points
	 * @param {number} cellSize - unit size in meters
	 * @param {function} getPosition - position accessor
	 * @returns {object} - grid hash and cell dimension
	 */
	function _pointsToGridHashing(points, cellSize, getPosition) {
	
	  // find the geometric center of sample points
	  var allLat = points.map(function (p) {
	    return getPosition(p)[1];
	  });
	  var latMin = Math.min.apply(null, allLat);
	  var latMax = Math.max.apply(null, allLat);
	
	  var centerLat = (latMin + latMax) / 2;
	
	  var gridOffset = _calculateGridLatLonOffset(cellSize, centerLat);
	
	  if (gridOffset.xOffset <= 0 || gridOffset.yOffset <= 0) {
	    return { gridHash: {}, gridOffset: gridOffset };
	  }
	  // calculate count per cell
	  var gridHash = points.reduce(function (accu, pt) {
	    var latIdx = Math.floor((getPosition(pt)[1] + 90) / gridOffset.yOffset);
	    var lonIdx = Math.floor((getPosition(pt)[0] + 180) / gridOffset.xOffset);
	    var key = latIdx + '-' + lonIdx;
	
	    accu[key] = accu[key] || { count: 0, points: [] };
	    accu[key].count += 1;
	    accu[key].points.push(pt);
	
	    return accu;
	  }, {});
	
	  return { gridHash: gridHash, gridOffset: gridOffset };
	}
	
	function _getGridLayerDataFromGridHash(gridHash, gridOffset) {
	  return Object.keys(gridHash).reduce(function (accu, key, i) {
	    var idxs = key.split('-');
	    var latIdx = parseInt(idxs[0], 10);
	    var lonIdx = parseInt(idxs[1], 10);
	
	    accu.push(Object.assign({
	      index: i,
	      position: [-180 + gridOffset.xOffset * lonIdx, -90 + gridOffset.yOffset * latIdx]
	    }, gridHash[key]));
	
	    return accu;
	  }, []);
	}
	
	function _getCellCountExtent(data) {
	  return data.length ? [Math.min.apply(null, data.map(function (d) {
	    return d.count;
	  })), Math.max.apply(null, data.map(function (d) {
	    return d.count;
	  }))] : [0, 1];
	}
	
	/**
	 * calculate grid layer cell size in lat lon based on world unit size
	 * and current latitude
	 * @param {number} cellSize
	 * @param {number} latitude
	 * @returns {object} - lat delta and lon delta
	 */
	function _calculateGridLatLonOffset(cellSize, latitude) {
	  var yOffset = _calculateLatOffset(cellSize);
	  var xOffset = _calculateLonOffset(latitude, cellSize);
	  return { yOffset: yOffset, xOffset: xOffset };
	}
	
	/**
	 * with a given x-km change, calculate the increment of latitude
	 * based on stackoverflow http://stackoverflow.com/questions/7477003
	 * @param {number} dy - change in km
	 * @return {number} - increment in latitude
	 */
	function _calculateLatOffset(dy) {
	  return dy / R_EARTH * (180 / Math.PI);
	}
	
	/**
	 * with a given x-km change, and current latitude
	 * calculate the increment of longitude
	 * based on stackoverflow http://stackoverflow.com/questions/7477003
	 * @param {number} lat - latitude of current location (based on city)
	 * @param {number} dx - change in km
	 * @return {number} - increment in longitude
	 */
	function _calculateLonOffset(lat, dx) {
	  return dx / R_EARTH * (180 / Math.PI) / Math.cos(lat * Math.PI / 180);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lib = __webpack_require__(35);
	
	var _gridCellLayer = __webpack_require__(386);
	
	var _gridCellLayer2 = _interopRequireDefault(_gridCellLayer);
	
	var _gridAggregator = __webpack_require__(783);
	
	var _scaleUtils = __webpack_require__(399);
	
	var _colorUtils = __webpack_require__(398);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultCellSize = 1000;
	var defaultElevationRange = [0, 1000];
	var defaultElevationScale = 1;
	
	var defaultProps = {
	  cellSize: defaultCellSize,
	  colorRange: _colorUtils.defaultColorRange,
	  colorDomain: null,
	  elevationRange: defaultElevationRange,
	  elevationDomain: null,
	  elevationScale: defaultElevationScale,
	  getPosition: function getPosition(x) {
	    return x.position;
	  },
	  extruded: false,
	  fp64: false,
	  // Optional settings for 'lighting' shader module
	  lightSettings: {
	    lightsPosition: [-122.45, 37.75, 8000, -122.0, 38.00, 5000],
	    ambientRatio: 0.05,
	    diffuseRatio: 0.6,
	    specularRatio: 0.8,
	    lightsStrength: [2.0, 0.0, 0.0, 0.0],
	    numberOfLights: 2
	  }
	};
	
	function _needsReProjectPoints(oldProps, props) {
	  return oldProps.cellSize !== props.cellSize;
	}
	
	var GridLayer = function (_Layer) {
	  _inherits(GridLayer, _Layer);
	
	  function GridLayer() {
	    _classCallCheck(this, GridLayer);
	
	    return _possibleConstructorReturn(this, (GridLayer.__proto__ || Object.getPrototypeOf(GridLayer)).apply(this, arguments));
	  }
	
	  _createClass(GridLayer, [{
	    key: 'initializeState',
	    value: function initializeState() {
	      this.state = {
	        layerData: [],
	        countRange: null
	      };
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref) {
	      var oldProps = _ref.oldProps,
	          props = _ref.props,
	          changeFlags = _ref.changeFlags;
	
	      if (changeFlags.dataChanged || _needsReProjectPoints(oldProps, props)) {
	        var _props = this.props,
	            data = _props.data,
	            cellSize = _props.cellSize,
	            getPosition = _props.getPosition;
	
	        var _pointToDensityGridDa = (0, _gridAggregator.pointToDensityGridData)(data, cellSize, getPosition),
	            layerData = _pointToDensityGridDa.layerData,
	            countRange = _pointToDensityGridDa.countRange;
	
	        Object.assign(this.state, { layerData: layerData, countRange: countRange });
	      }
	    }
	  }, {
	    key: 'getPickingInfo',
	    value: function getPickingInfo(_ref2) {
	      var info = _ref2.info;
	
	      var pickedCell = info.picked && info.index > -1 ? this.state.layerData[info.index] : null;
	
	      return Object.assign(info, {
	        picked: Boolean(pickedCell),
	        // override object with picked cell
	        object: pickedCell
	      });
	    }
	  }, {
	    key: '_onGetSublayerColor',
	    value: function _onGetSublayerColor(cell) {
	      var colorRange = this.props.colorRange;
	
	      var colorDomain = this.props.colorDomain || this.state.countRange;
	
	      return (0, _scaleUtils.quantizeScale)(colorDomain, colorRange, cell.count);
	    }
	  }, {
	    key: '_onGetSublayerElevation',
	    value: function _onGetSublayerElevation(cell) {
	      var elevationRange = this.props.elevationRange;
	
	      var elevationDomain = this.props.elevationDomain || [0, this.state.countRange[1]];
	      return (0, _scaleUtils.linearScale)(elevationDomain, elevationRange, cell.count);
	    }
	  }, {
	    key: 'renderLayers',
	    value: function renderLayers() {
	      var _props2 = this.props,
	          id = _props2.id,
	          elevationScale = _props2.elevationScale,
	          fp64 = _props2.fp64,
	          extruded = _props2.extruded,
	          cellSize = _props2.cellSize,
	          lightSettings = _props2.lightSettings;
	
	      // base layer props
	
	      var _props3 = this.props,
	          opacity = _props3.opacity,
	          pickable = _props3.pickable,
	          visible = _props3.visible;
	
	      // viewport props
	
	      var _props4 = this.props,
	          positionOrigin = _props4.positionOrigin,
	          projectionMode = _props4.projectionMode,
	          modelMatrix = _props4.modelMatrix;
	
	
	      return new _gridCellLayer2.default({
	        id: id + '-grid-cell',
	        data: this.state.layerData,
	        cellSize: cellSize,
	        lightSettings: lightSettings,
	        elevationScale: elevationScale,
	        extruded: extruded,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getColor: this._onGetSublayerColor.bind(this),
	        getElevation: this._onGetSublayerElevation.bind(this),
	        getPosition: function getPosition(d) {
	          return d.position;
	        },
	        updateTriggers: {
	          getColor: { colorRange: this.props.colorRange },
	          getElevation: { elevationRange: this.props.elevationRange }
	        }
	      });
	    }
	  }]);
	
	  return GridLayer;
	}(_lib.Layer);
	
	exports.default = GridLayer;
	
	
	GridLayer.layerName = 'GridLayer';
	GridLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 785 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME hexagon-cell-layer-fs\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  gl_FragColor = vColor;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 786 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME hexagon-cell-layer-vs-64\n\nattribute vec3 positions;\nattribute vec3 normals;\n\nattribute vec3 instancePositions;\nattribute vec2 instancePositions64xyLow;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\n// Picking uniforms\n// Set to 1.0 if rendering picking buffer, 0.0 if rendering for display\nuniform float renderPickingBuffer;\nuniform vec3 selectedPickingColor;\n\n// Custom uniforms\nuniform float opacity;\nuniform float radius;\nuniform float angle;\nuniform float extruded;\nuniform float coverage;\nuniform float elevationScale;\n\n// Result\nvarying vec4 vColor;\n\n// A magic number to scale elevation so that 1 unit approximate to 1 meter.\n#define ELEVATION_SCALE 0.8\n\nfloat isPicked(vec3 pickingColors, vec3 selectedColor) {\n return float(pickingColors.x == selectedColor.x\n && pickingColors.y == selectedColor.y\n && pickingColors.z == selectedColor.z);\n}\n\nvoid main(void) {\n\n  // rotate primitive position and normal\n  mat2 rotationMatrix = mat2(cos(angle), -sin(angle), sin(angle), cos(angle));\n\n  vec2 rPos = rotationMatrix * positions.xz;\n  vec2 rNorm = rotationMatrix * normals.xz;\n\n  vec3 rotatedPositions = vec3(rPos.x, positions.y, rPos.y);\n  vec3 rotatedNormals = vec3(rNorm.x, normals.y, rNorm.y);\n\n  // calculate elevation, if 3d not enabled set to 0\n  // cylindar gemoetry height are between -0.5 to 0.5, transform it to between 0, 1\n  float elevation = 0.0;\n\n  if (extruded > 0.5) {\n    elevation = project_scale(instancePositions.z * (positions.y + 0.5) *\n      ELEVATION_SCALE * elevationScale);\n}\n\n  float dotRadius = radius * clamp(coverage, 0.0, 1.0);\n  // // project center of hexagon\n\n  vec4 instancePositions64xy = vec4(\n    instancePositions.x, instancePositions64xyLow.x,\n    instancePositions.y, instancePositions64xyLow.y);\n\n  vec2 projected_coord_xy[2];\n  project_position_fp64(instancePositions64xy, projected_coord_xy);\n\n  vec2 vertex_pos_localspace[4];\n  vec4_fp64(vec4(rotatedPositions.xz * dotRadius, 0.0, 1.0), vertex_pos_localspace);\n\n  vec2 vertex_pos_modelspace[4];\n  vertex_pos_modelspace[0] = sum_fp64(vertex_pos_localspace[0], projected_coord_xy[0]);\n  vertex_pos_modelspace[1] = sum_fp64(vertex_pos_localspace[1], projected_coord_xy[1]);\n  vertex_pos_modelspace[2] = sum_fp64(vertex_pos_localspace[2], vec2(elevation, 0.0));\n  vertex_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  vec4 position_worldspace = vec4(\n    vertex_pos_modelspace[0].x, vertex_pos_modelspace[1].x,\n    vertex_pos_modelspace[2].x, vertex_pos_modelspace[3].x);\n\n  gl_Position = project_to_clipspace_fp64(vertex_pos_modelspace);\n\n  // render display\n  if (renderPickingBuffer < 0.5) {\n\n    // TODO: we should allow the user to specify the color for \"selected element\"\n    // check whether hexagon is currently picked.\n    float selected = isPicked(instancePickingColors, selectedPickingColor);\n\n    // Light calculations\n    // Worldspace is the linear space after Mercator projection\n\n    vec3 normals_worldspace = rotatedNormals;\n\n    float lightWeight = 1.0;\n\n    if (extruded > 0.5) {\n      lightWeight = getLightWeight(\n        position_worldspace,\n        normals_worldspace\n      );\n    }\n\n    vec3 lightWeightedColor = lightWeight * instanceColors.rgb;\n\n    // Color: Either opacity-multiplied instance color, or picking color\n    vec4 color = vec4(lightWeightedColor, opacity * instanceColors.a) / 255.0;\n\n    vColor = color;\n\n  } else {\n\n    vec4 pickingColor = vec4(instancePickingColors / 255.0, 1.0);\n    vColor = pickingColor;\n\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 787 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "\n#define SHADER_NAME hexagon-cell-layer-vs\n\nattribute vec3 positions;\nattribute vec3 normals;\n\nattribute vec3 instancePositions;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\n// Picking uniforms\n// Set to 1.0 if rendering picking buffer, 0.0 if rendering for display\nuniform float renderPickingBuffer;\nuniform vec3 selectedPickingColor;\n\n// Custom uniforms\nuniform float opacity;\nuniform float radius;\nuniform float angle;\nuniform float extruded;\nuniform float coverage;\nuniform float elevationScale;\n\n// Result\nvarying vec4 vColor;\n\n// A magic number to scale elevation so that 1 unit approximate to 1 meter.\n#define ELEVATION_SCALE 0.8\n\n// whether is point picked\nfloat isPicked(vec3 pickingColors, vec3 selectedColor) {\n return float(pickingColors.x == selectedColor.x\n && pickingColors.y == selectedColor.y\n && pickingColors.z == selectedColor.z);\n}\n\nvoid main(void) {\n\n  // rotate primitive position and normal\n  mat2 rotationMatrix = mat2(cos(angle), -sin(angle), sin(angle), cos(angle));\n\n  vec2 rPos = rotationMatrix * positions.xz;\n  vec2 rNorm = rotationMatrix * normals.xz;\n\n  vec3 rotatedPositions = vec3(rPos.x, positions.y, rPos.y);\n  vec3 rotatedNormals = vec3(rNorm.x, normals.y, rNorm.y);\n\n  // calculate elevation, if 3d not enabled set to 0\n  // cylindar gemoetry height are between -0.5 to 0.5, transform it to between 0, 1\n  float elevation = 0.0;\n\n  if (extruded > 0.5) {\n    elevation = project_scale(instancePositions.z * (positions.y + 0.5) *\n      ELEVATION_SCALE * elevationScale);\n  }\n\n  float dotRadius = radius * mix(coverage, 0.0, float(instanceColors.a == 0.0));\n  // // project center of hexagon\n\n  vec4 centroidPosition = vec4(project_position(instancePositions.xy), elevation, 0.0);\n\n  vec4 position_worldspace = centroidPosition + vec4(vec2(rotatedPositions.xz * dotRadius), 0., 1.);\n\n  gl_Position = project_to_clipspace(position_worldspace);\n\n  // render display\n  if (renderPickingBuffer < 0.5) {\n\n    // TODO: we should allow the user to specify the color for \"selected element\"\n    // check whether hexagon is currently picked.\n    float selected = isPicked(instancePickingColors, selectedPickingColor);\n\n    // Light calculations\n    // Worldspace is the linear space after Mercator projection\n\n    vec3 normals_worldspace = rotatedNormals;\n\n    float lightWeight = 1.0;\n\n    if (extruded > 0.5) {\n      lightWeight = getLightWeight(\n        position_worldspace,\n        normals_worldspace\n      );\n    }\n\n    vec3 lightWeightedColor = lightWeight * instanceColors.rgb;\n\n    // Color: Either opacity-multiplied instance color, or picking color\n    vec4 color = vec4(lightWeightedColor, opacity * instanceColors.a) / 255.0;\n\n    vColor = color;\n\n  } else {\n\n    vec4 pickingColor = vec4(instancePickingColors / 255.0, 1.0);\n    vColor = pickingColor;\n\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pointToHexbin = pointToHexbin;
	exports.getRadiusInPixel = getRadiusInPixel;
	
	var _d3Hexbin = __webpack_require__(760);
	
	/**
	 * Use d3-hexbin to performs hexagonal binning from geo points to hexagons
	 * @param {Array} data - array of points
	 * @param {Number} radius - hexagon radius in meter
	 * @param {function} getPosition - get points lon lat
	 * @param {Object} viewport - current viewport object
	
	 * @return {Object} - hexagons and countRange
	 */
	function pointToHexbin(_ref, viewport) {
	  var data = _ref.data,
	      radius = _ref.radius,
	      getPosition = _ref.getPosition;
	
	  // get hexagon radius in mercator world unit
	  var radiusInPixel = getRadiusInPixel(radius, viewport);
	
	  // add world space coordinates to points
	  var screenPoints = data.map(function (pt) {
	    return Object.assign({
	      screenCoord: viewport.projectFlat(getPosition(pt))
	    }, pt);
	  });
	
	  var newHexbin = (0, _d3Hexbin.hexbin)().radius(radiusInPixel).x(function (d) {
	    return d.screenCoord[0];
	  }).y(function (d) {
	    return d.screenCoord[1];
	  });
	
	  var hexagonBins = newHexbin(screenPoints);
	
	  return hexagonBins.map(function (hex) {
	    return {
	      centroid: viewport.unprojectFlat([hex.x, hex.y]),
	      points: hex
	    };
	  });
	}
	
	/**
	 * Get radius in mercator world space coordinates from meter
	 * @param {Number} radius - in meter
	 * @param {Object} viewport - current viewport object
	
	 * @return {Number} radius in mercator world spcae coordinates
	 */
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	function getRadiusInPixel(radius, viewport) {
	  var _viewport$getDistance = viewport.getDistanceScales(),
	      pixelsPerMeter = _viewport$getDistance.pixelsPerMeter;
	
	  // x, y distance should be the same
	
	
	  return radius * pixelsPerMeter[0];
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lib = __webpack_require__(35);
	
	var _hexagonCellLayer = __webpack_require__(387);
	
	var _hexagonCellLayer2 = _interopRequireDefault(_hexagonCellLayer);
	
	var _utils = __webpack_require__(42);
	
	var _scaleUtils = __webpack_require__(399);
	
	var _colorUtils = __webpack_require__(398);
	
	var _hexagonAggregator = __webpack_require__(788);
	
	var _binSorter = __webpack_require__(847);
	
	var _binSorter2 = _interopRequireDefault(_binSorter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultProps = {
	  colorDomain: null,
	  colorRange: _colorUtils.defaultColorRange,
	  elevationDomain: null,
	  elevationRange: [0, 1000],
	  elevationScale: 1,
	  lowerPercentile: 0,
	  upperPercentile: 100,
	  radius: 1000,
	  coverage: 1,
	  extruded: false,
	  hexagonAggregator: _hexagonAggregator.pointToHexbin,
	  getPosition: function getPosition(x) {
	    return x.position;
	  },
	  fp64: false,
	  // Optional settings for 'lighting' shader module
	  lightSettings: {
	    lightsPosition: [-122.45, 37.75, 8000, -122.0, 38.00, 5000],
	    ambientRatio: 0.05,
	    diffuseRatio: 0.6,
	    specularRatio: 0.8,
	    lightsStrength: [2.0, 0.0, 0.0, 0.0],
	    numberOfLights: 2
	  }
	};
	
	function _needsReProjectPoints(oldProps, props) {
	  return oldProps.radius !== props.radius;
	}
	
	function _percentileChanged(oldProps, props) {
	  return oldProps.lowerPercentile !== props.lowerPercentile || oldProps.upperPercentile !== props.upperPercentile;
	}
	
	var HexagonLayer = function (_Layer) {
	  _inherits(HexagonLayer, _Layer);
	
	  function HexagonLayer(props) {
	    _classCallCheck(this, HexagonLayer);
	
	    if (!props.radius) {
	      _utils.log.once(0, 'HexagonLayer: radius in meter is needed to aggregate points into ' + 'hexagonal bins, Now using 1000 meter as default');
	
	      props.radius = defaultProps.radius;
	    }
	
	    if (Number.isFinite(props.upperPercentile) && (props.upperPercentile > 100 || props.upperPercentile < 0)) {
	      _utils.log.once(0, 'HexagonLayer: upperPercentile should be between 0 and 100. ' + 'Assign to 100 by default');
	
	      props.upperPercentile = defaultProps.upperPercentile;
	    }
	
	    if (Number.isFinite(props.lowerPercentile) && (props.lowerPercentile > 100 || props.lowerPercentile < 0)) {
	      _utils.log.once(0, 'HexagonLayer: lowerPercentile should be between 0 and 100. ' + 'Assign to 0 by default');
	
	      props.lowerPercentile = defaultProps.upperPercentile;
	    }
	
	    if (props.lowerPercentile >= props.upperPercentile) {
	      _utils.log.once(0, 'HexagonLayer: lowerPercentile should not be bigger than ' + 'upperPercentile. Assign to 0 by default');
	
	      props.lowerPercentile = defaultProps.lowerPercentile;
	    }
	
	    return _possibleConstructorReturn(this, (HexagonLayer.__proto__ || Object.getPrototypeOf(HexagonLayer)).call(this, props));
	  }
	
	  _createClass(HexagonLayer, [{
	    key: 'initializeState',
	    value: function initializeState() {
	      this.state = {
	        hexagons: [],
	        countRange: null,
	        sortedCounts: null,
	        valueDomain: null
	      };
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref) {
	      var oldProps = _ref.oldProps,
	          props = _ref.props,
	          changeFlags = _ref.changeFlags;
	
	      if (changeFlags.dataChanged || _needsReProjectPoints(oldProps, props)) {
	        var hexagonAggregator = this.props.hexagonAggregator;
	        var viewport = this.context.viewport;
	
	
	        var hexagons = hexagonAggregator(this.props, viewport);
	        var sortedCounts = new _binSorter2.default(hexagons);
	
	        Object.assign(this.state, { hexagons: hexagons, sortedCounts: sortedCounts });
	
	        // this needs sortedCounts to be set
	        this._onPercentileChange();
	      } else if (_percentileChanged(oldProps, props)) {
	
	        this._onPercentileChange();
	      }
	    }
	  }, {
	    key: 'getPickingInfo',
	    value: function getPickingInfo(_ref2) {
	      var info = _ref2.info;
	
	      var pickedCell = info.picked && info.index > -1 ? this.state.hexagons[info.index] : null;
	
	      return Object.assign(info, {
	        picked: Boolean(pickedCell),
	        // override object with picked cell
	        object: pickedCell
	      });
	    }
	  }, {
	    key: '_onPercentileChange',
	    value: function _onPercentileChange() {
	      var _props = this.props,
	          lowerPercentile = _props.lowerPercentile,
	          upperPercentile = _props.upperPercentile;
	
	
	      this.state.valueDomain = this.state.sortedCounts.getCountRange([lowerPercentile, upperPercentile]);
	    }
	  }, {
	    key: '_onGetSublayerColor',
	    value: function _onGetSublayerColor(cell) {
	      var colorRange = this.props.colorRange;
	      var valueDomain = this.state.valueDomain;
	
	
	      var colorDomain = this.props.colorDomain || valueDomain;
	      var count = cell.points.length;
	      var color = (0, _scaleUtils.quantizeScale)(colorDomain, colorRange, count);
	
	      // if cell count is outside domain, set alpha to 0
	      var alpha = count >= valueDomain[0] && count <= valueDomain[1] ? Number.isFinite(color[3]) ? color[3] : 255 : 0;
	
	      return color.concat([alpha]);
	    }
	  }, {
	    key: '_onGetSublayerElevation',
	    value: function _onGetSublayerElevation(cell) {
	      var _props2 = this.props,
	          elevationDomain = _props2.elevationDomain,
	          elevationRange = _props2.elevationRange;
	      var sortedCounts = this.state.sortedCounts;
	
	      // elevation is not affected by percentile
	
	      var domain = elevationDomain || [0, sortedCounts.getMaxCount()];
	      return (0, _scaleUtils.linearScale)(domain, elevationRange, cell.points.length);
	    }
	  }, {
	    key: 'renderLayers',
	    value: function renderLayers() {
	      var _props3 = this.props,
	          id = _props3.id,
	          radius = _props3.radius,
	          elevationScale = _props3.elevationScale,
	          extruded = _props3.extruded,
	          coverage = _props3.coverage,
	          lightSettings = _props3.lightSettings,
	          fp64 = _props3.fp64;
	
	      // base layer props
	
	      var _props4 = this.props,
	          opacity = _props4.opacity,
	          pickable = _props4.pickable,
	          visible = _props4.visible;
	
	      // viewport props
	
	      var _props5 = this.props,
	          positionOrigin = _props5.positionOrigin,
	          projectionMode = _props5.projectionMode,
	          modelMatrix = _props5.modelMatrix;
	
	
	      return new _hexagonCellLayer2.default({
	        id: id + '-hexagon-cell',
	        data: this.state.hexagons,
	        radius: radius,
	        elevationScale: elevationScale,
	        angle: Math.PI,
	        extruded: extruded,
	        coverage: coverage,
	        lightSettings: lightSettings,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getColor: this._onGetSublayerColor.bind(this),
	        getElevation: this._onGetSublayerElevation.bind(this),
	        updateTriggers: {
	          getColor: {
	            colorRange: this.props.colorRange,
	            colorDomain: this.props.colorDomain,
	            lowerPercentile: this.props.lowerPercentile,
	            upperPercentile: this.props.upperPercentile
	          },
	          getElevation: {
	            elevationRange: this.props.elevationRange,
	            elevationDomain: this.props.elevationDomain
	          }
	        }
	      });
	    }
	  }]);
	
	  return HexagonLayer;
	}(_lib.Layer);
	
	exports.default = HexagonLayer;
	
	
	HexagonLayer.layerName = 'HexagonLayer';
	HexagonLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 790 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME scatterplot-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nuniform float opacity;\nuniform float renderPickingBuffer;\nuniform sampler2D iconsTexture;\n\nvarying float vColorMode;\nvarying vec4 vColor;\nvarying vec2 vTextureCoords;\n\nconst float MIN_ALPHA = 0.05;\n\nvoid main(void) {\n  vec4 texColor = texture2D(iconsTexture, vTextureCoords);\n\n  // if colorMode == 0, use pixel color from the texture\n  // if colorMode == 1 or rendering picking buffer, use texture as transparency mask\n  vec3 color = mix(texColor.rgb, vColor.rgb,\n    max(vColorMode, renderPickingBuffer)\n  );\n  float a = texColor.a * opacity * mix(1.0, vColor.a, vColorMode);\n\n  if (a < MIN_ALPHA) {\n    discard;\n  }\n\n  // if rendering to screen, use mixed alpha\n  // if rendering picking buffer, use binary alpha\n  a = mix(a, 1.0, renderPickingBuffer);\n\n  gl_FragColor = vec4(color, a);\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 791 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME icon-layer-vertex-shader\n\nattribute vec2 positions;\n\nattribute vec3 instancePositions;\nattribute vec2 instancePositions64xyLow;\nattribute float instanceSizes;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\nattribute vec4 instanceIconFrames;\nattribute float instanceColorModes;\nattribute vec2 instanceOffsets;\n\nuniform vec2 viewportSize;\nuniform float sizeScale;\nuniform float renderPickingBuffer;\nuniform vec2 iconsTextureDim;\n\nvarying float vColorMode;\nvarying vec4 vColor;\nvarying vec2 vTextureCoords;\n\nvoid main(void) {\n  vec2 iconSize = instanceIconFrames.zw;\n  vec2 iconSize_clipspace = iconSize / viewportSize * 2.0;\n  // scale icon height to match instanceSize\n  float instanceScale = iconSize.y == 0.0 ? 0.0 : instanceSizes / iconSize.y;\n\n  // The vertex variable is in clip space and should not go through project_to_clipspace call\n  vec2 vertex = (positions / 2.0 + instanceOffsets) * iconSize_clipspace *\n    sizeScale * instanceScale;\n\n  vertex.y *= -1.0;\n\n  vec4 instancePositions64xy = vec4(\n    instancePositions.x, instancePositions64xyLow.x,\n    instancePositions.y, instancePositions64xyLow.y);\n\n  vec2 projected_coord_xy[2];\n  project_position_fp64(instancePositions64xy, projected_coord_xy);\n\n  vec2 vertex_pos_modelspace[4];\n  vertex_pos_modelspace[0] = projected_coord_xy[0];\n  vertex_pos_modelspace[1] = projected_coord_xy[1];\n  vertex_pos_modelspace[2] = vec2(project_scale(instancePositions.z), 0.0);\n  vertex_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  gl_Position = project_to_clipspace_fp64(vertex_pos_modelspace) + vec4(vertex, 0.0, 0.0);\n\n  vTextureCoords = mix(\n    instanceIconFrames.xy,\n    instanceIconFrames.xy + iconSize,\n    (positions.xy + 1.0) / 2.0\n  ) / iconsTextureDim;\n\n  vTextureCoords.y = 1.0 - vTextureCoords.y;\n\n  vec4 color = instanceColors / 255.;\n  vec4 pickingColor = vec4(instancePickingColors / 255., 1.);\n  vColor = mix(color, pickingColor, renderPickingBuffer);\n\n  vColorMode = instanceColorModes;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 792 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME icon-layer-vertex-shader\n\nattribute vec2 positions;\n\nattribute vec3 instancePositions;\nattribute float instanceSizes;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\nattribute vec4 instanceIconFrames;\nattribute float instanceColorModes;\nattribute vec2 instanceOffsets;\n\nuniform vec2 viewportSize;\nuniform float sizeScale;\nuniform float renderPickingBuffer;\nuniform vec2 iconsTextureDim;\n\nvarying float vColorMode;\nvarying vec4 vColor;\nvarying vec2 vTextureCoords;\n\nvoid main(void) {\n  vec2 iconSize = instanceIconFrames.zw;\n  vec2 iconSize_clipspace = iconSize / viewportSize * 2.0;\n  // scale icon height to match instanceSize\n  float instanceScale = iconSize.y == 0.0 ? 0.0 : instanceSizes / iconSize.y;\n  vec3 center = project_position(instancePositions);\n  vec2 vertex = (positions / 2.0 + instanceOffsets) * iconSize_clipspace *\n    sizeScale * instanceScale;\n  vertex.y *= -1.0;\n  gl_Position = project_to_clipspace(vec4(center, 1.0)) + vec4(vertex, 0.0, 0.0);\n\n  vTextureCoords = mix(\n    instanceIconFrames.xy,\n    instanceIconFrames.xy + iconSize,\n    (positions.xy + 1.0) / 2.0\n  ) / iconsTextureDim;\n\n  vTextureCoords.y = 1.0 - vTextureCoords.y;\n\n  vec4 color = instanceColors / 255.;\n  vec4 pickingColor = vec4(instancePickingColors / 255., 1.);\n  vColor = mix(color, pickingColor, renderPickingBuffer);\n\n  vColorMode = instanceColorModes;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _luma = __webpack_require__(29);
	
	var _fp = __webpack_require__(54);
	
	var _iconLayerVertex = __webpack_require__(792);
	
	var _iconLayerVertex2 = _interopRequireDefault(_iconLayerVertex);
	
	var _iconLayerVertex3 = __webpack_require__(791);
	
	var _iconLayerVertex4 = _interopRequireDefault(_iconLayerVertex3);
	
	var _iconLayerFragment = __webpack_require__(790);
	
	var _iconLayerFragment2 = _interopRequireDefault(_iconLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	var DEFAULT_COLOR = [0, 0, 0, 255];
	
	/*
	 * @param {object} props
	 * @param {Texture2D | string} props.iconAtlas - atlas image url or texture
	 * @param {object} props.iconMapping - icon names mapped to icon definitions
	 * @param {object} props.iconMapping[icon_name].x - x position of icon on the atlas image
	 * @param {object} props.iconMapping[icon_name].y - y position of icon on the atlas image
	 * @param {object} props.iconMapping[icon_name].width - width of icon on the atlas image
	 * @param {object} props.iconMapping[icon_name].height - height of icon on the atlas image
	 * @param {object} props.iconMapping[icon_name].anchorX - x anchor of icon on the atlas image,
	 *   default to width / 2
	 * @param {object} props.iconMapping[icon_name].anchorY - y anchor of icon on the atlas image,
	 *   default to height / 2
	 * @param {object} props.iconMapping[icon_name].mask - whether icon is treated as a transparency
	 *   mask. If true, user defined color is applied. If false, original color from the image is
	 *   applied. Default to false.
	 * @param {number} props.size - icon size in pixels
	 * @param {func} props.getPosition - returns anchor position of the icon, in [lng, lat, z]
	 * @param {func} props.getIcon - returns icon name as a string
	 * @param {func} props.getSize - returns icon size multiplier as a number
	 * @param {func} props.getColor - returns color of the icon in [r, g, b, a]. Only works on icons
	 *   with mask: true.
	 */
	var defaultProps = {
	  iconAtlas: null,
	  iconMapping: {},
	  sizeScale: 1,
	  fp64: false,
	
	  getPosition: function getPosition(x) {
	    return x.position;
	  },
	  getIcon: function getIcon(x) {
	    return x.icon;
	  },
	  getColor: function getColor(x) {
	    return x.color || DEFAULT_COLOR;
	  },
	  getSize: function getSize(x) {
	    return x.size || 1;
	  }
	};
	
	var IconLayer = function (_Layer) {
	  _inherits(IconLayer, _Layer);
	
	  function IconLayer() {
	    _classCallCheck(this, IconLayer);
	
	    return _possibleConstructorReturn(this, (IconLayer.__proto__ || Object.getPrototypeOf(IconLayer)).apply(this, arguments));
	  }
	
	  _createClass(IconLayer, [{
	    key: 'initializeState',
	    value: function initializeState() {
	      var attributeManager = this.state.attributeManager;
	
	      /* eslint-disable max-len */
	
	      attributeManager.addInstanced({
	        instancePositions: { size: 3, accessor: 'getPosition', update: this.calculateInstancePositions },
	        instanceSizes: { size: 1, accessor: 'getSize', update: this.calculateInstanceSizes },
	        instanceOffsets: { size: 2, accessor: 'getIcon', update: this.calculateInstanceOffsets },
	        instanceIconFrames: { size: 4, accessor: 'getIcon', update: this.calculateInstanceIconFrames },
	        instanceColorModes: { size: 1, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getIcon', update: this.calculateInstanceColorMode },
	        instanceColors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getColor', update: this.calculateInstanceColors }
	      });
	      /* eslint-enable max-len */
	
	      var gl = this.context.gl;
	
	      this.setState({ model: this._getModel(gl) });
	    }
	  }, {
	    key: 'updateAttribute',
	    value: function updateAttribute(_ref) {
	      var props = _ref.props,
	          oldProps = _ref.oldProps,
	          changeFlags = _ref.changeFlags;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidateAll();
	
	        if (props.fp64 && props.projectionMode === _lib.COORDINATE_SYSTEM.LNGLAT) {
	          attributeManager.addInstanced({
	            instancePositions64xyLow: {
	              size: 2,
	              accessor: 'getPosition',
	              update: this.calculateInstancePositions64xyLow
	            }
	          });
	        } else {
	          attributeManager.remove(['instancePositions64xyLow']);
	        }
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref2) {
	      var oldProps = _ref2.oldProps,
	          props = _ref2.props,
	          changeFlags = _ref2.changeFlags;
	
	      _get(IconLayer.prototype.__proto__ || Object.getPrototypeOf(IconLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	
	      var iconAtlas = props.iconAtlas,
	          iconMapping = props.iconMapping;
	
	
	      if (oldProps.iconMapping !== iconMapping) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidate('instanceOffsets');
	        attributeManager.invalidate('instanceIconFrames');
	        attributeManager.invalidate('instanceColorModes');
	      }
	
	      if (oldProps.iconAtlas !== iconAtlas) {
	        var icons = {};
	        this.state.icons = icons;
	
	        if (iconAtlas instanceof _luma.Texture2D) {
	          icons.texture = iconAtlas;
	        } else if (typeof iconAtlas === 'string') {
	          (0, _luma.loadTextures)(this.context.gl, {
	            urls: [iconAtlas]
	          }).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 1),
	                texture = _ref4[0];
	
	            icons.texture = texture;
	          });
	        }
	      }
	
	      if (props.fp64 !== oldProps.fp64) {
	        var gl = this.context.gl;
	
	        this.setState({ model: this._getModel(gl) });
	      }
	      this.updateAttribute({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref5) {
	      var uniforms = _ref5.uniforms;
	      var sizeScale = this.props.sizeScale;
	
	      var iconsTexture = this.state.icons && this.state.icons.texture;
	
	      if (iconsTexture) {
	        this.state.model.render(Object.assign({}, uniforms, {
	          iconsTexture: iconsTexture,
	          iconsTextureDim: [iconsTexture.width, iconsTexture.height],
	          sizeScale: sizeScale
	        }));
	      }
	    }
	  }, {
	    key: 'getShaders',
	    value: function getShaders() {
	      return (0, _fp.enable64bitSupport)(this.props) ? {
	        vs: _iconLayerVertex4.default, fs: _iconLayerFragment2.default, modules: ['fp64', 'project64']
	      } : {
	        vs: _iconLayerVertex2.default, fs: _iconLayerFragment2.default, modules: []
	      };
	    }
	  }, {
	    key: '_getModel',
	    value: function _getModel(gl) {
	      var positions = [-1, -1, 0, -1, 1, 0, 1, 1, 0, 1, -1, 0];
	
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: _luma.GL.TRIANGLE_FAN,
	          positions: new Float32Array(positions)
	        }),
	        isInstanced: true
	      });
	    }
	  }, {
	    key: 'calculateInstancePositions',
	    value: function calculateInstancePositions(attribute) {
	      var _props = this.props,
	          data = _props.data,
	          getPosition = _props.getPosition;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var object = _step.value;
	
	          var position = getPosition(object);
	          value[i++] = position[0];
	          value[i++] = position[1];
	          value[i++] = position[2] || 0;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstancePositions64xyLow',
	    value: function calculateInstancePositions64xyLow(attribute) {
	      var _props2 = this.props,
	          data = _props2.data,
	          getPosition = _props2.getPosition;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var point = _step2.value;
	
	          var position = getPosition(point);
	          value[i++] = (0, _fp.fp64ify)(position[0])[1];
	          value[i++] = (0, _fp.fp64ify)(position[1])[1];
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceSizes',
	    value: function calculateInstanceSizes(attribute) {
	      var _props3 = this.props,
	          data = _props3.data,
	          getSize = _props3.getSize;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var object = _step3.value;
	
	          value[i++] = getSize(object);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceColors',
	    value: function calculateInstanceColors(attribute) {
	      var _props4 = this.props,
	          data = _props4.data,
	          getColor = _props4.getColor;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var object = _step4.value;
	
	          var color = getColor(object);
	
	          value[i++] = color[0];
	          value[i++] = color[1];
	          value[i++] = color[2];
	          value[i++] = isNaN(color[3]) ? 255 : color[3];
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceOffsets',
	    value: function calculateInstanceOffsets(attribute) {
	      var _props5 = this.props,
	          data = _props5.data,
	          iconMapping = _props5.iconMapping,
	          getIcon = _props5.getIcon;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = data[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var object = _step5.value;
	
	          var icon = getIcon(object);
	          var rect = iconMapping[icon] || {};
	          value[i++] = 1 / 2 - rect.anchorX / rect.width || 0;
	          value[i++] = 1 / 2 - rect.anchorY / rect.height || 0;
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceColorMode',
	    value: function calculateInstanceColorMode(attribute) {
	      var _props6 = this.props,
	          data = _props6.data,
	          iconMapping = _props6.iconMapping,
	          getIcon = _props6.getIcon;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = data[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var object = _step6.value;
	
	          var icon = getIcon(object);
	          var colorMode = iconMapping[icon] && iconMapping[icon].mask;
	          value[i++] = colorMode ? 1 : 0;
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceIconFrames',
	    value: function calculateInstanceIconFrames(attribute) {
	      var _props7 = this.props,
	          data = _props7.data,
	          iconMapping = _props7.iconMapping,
	          getIcon = _props7.getIcon;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion7 = true;
	      var _didIteratorError7 = false;
	      var _iteratorError7 = undefined;
	
	      try {
	        for (var _iterator7 = data[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	          var object = _step7.value;
	
	          var icon = getIcon(object);
	          var rect = iconMapping[icon] || {};
	          value[i++] = rect.x || 0;
	          value[i++] = rect.y || 0;
	          value[i++] = rect.width || 0;
	          value[i++] = rect.height || 0;
	        }
	      } catch (err) {
	        _didIteratorError7 = true;
	        _iteratorError7 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion7 && _iterator7.return) {
	            _iterator7.return();
	          }
	        } finally {
	          if (_didIteratorError7) {
	            throw _iteratorError7;
	          }
	        }
	      }
	    }
	  }]);
	
	  return IconLayer;
	}(_lib.Layer);
	
	exports.default = IconLayer;
	
	
	IconLayer.layerName = 'IconLayer';
	IconLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 794 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME line-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  gl_FragColor = vColor;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 795 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME line-layer-vertex-64-shader\n\nattribute vec3 positions;\nattribute vec3 instanceSourcePositions;\nattribute vec3 instanceTargetPositions;\nattribute vec4 instanceSourceTargetPositions64xyLow;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\nuniform vec2 viewportSize;\nuniform float strokeWidth;\nuniform float opacity;\nuniform float renderPickingBuffer;\n\nvarying vec4 vColor;\n\n// offset vector by strokeWidth pixels\n// offset_direction is -1 (left) or 1 (right)\nvec2 getExtrusionOffset(vec2 line_clipspace, float offset_direction) {\n  // normalized direction of the line\n  vec2 dir_screenspace = normalize(line_clipspace * viewportSize);\n  // rotate by 90 degrees\n  dir_screenspace = vec2(-dir_screenspace.y, dir_screenspace.x);\n\n  vec2 offset_screenspace = dir_screenspace * offset_direction * strokeWidth / 2.0;\n  vec2 offset_clipspace = offset_screenspace / viewportSize * 2.0;\n\n  return offset_clipspace;\n}\n\nvoid main(void) {\n  // Position\n  vec4 instanceSourcePositions64 = vec4(\n    instanceSourcePositions.x, instanceSourceTargetPositions64xyLow.x,\n    instanceSourcePositions.y, instanceSourceTargetPositions64xyLow.y);\n\n  vec4 instanceTargetPositions64 = vec4(\n    instanceTargetPositions.x, instanceSourceTargetPositions64xyLow.z,\n    instanceTargetPositions.y, instanceSourceTargetPositions64xyLow.w);\n\n  vec2 projected_source_coord[2];\n  vec2 projected_target_coord[2];\n\n  project_position_fp64(instanceSourcePositions64, projected_source_coord);\n  project_position_fp64(instanceTargetPositions64, projected_target_coord);\n\n  vec2 source_pos_modelspace[4];\n  source_pos_modelspace[0] =  projected_source_coord[0];\n  source_pos_modelspace[1] =  projected_source_coord[1];\n  source_pos_modelspace[2] = vec2(project_scale(instanceSourcePositions.z), 0.0);\n  source_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  vec4 source_pos_clipspace = project_to_clipspace_fp64(source_pos_modelspace);\n\n  vec2 target_pos_modelspace[4];\n  target_pos_modelspace[0] =  projected_target_coord[0];\n  target_pos_modelspace[1] =  projected_target_coord[1];\n  target_pos_modelspace[2] = vec2(project_scale(instanceTargetPositions.z), 0.0);\n  target_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  vec4 target_pos_clipspace = project_to_clipspace_fp64(target_pos_modelspace);\n\n  float segmentIndex = positions.x;\n  vec4 p = mix(source_pos_clipspace, target_pos_clipspace, segmentIndex);\n\n  vec2 offset = getExtrusionOffset(target_pos_clipspace.xy - source_pos_clipspace.xy, positions.y);\n\n  gl_Position = p + vec4(offset, 0.0, 0.0);\n\n  // Color\n  vec4 color = vec4(instanceColors.rgb, instanceColors.a * opacity) / 255.;\n  vec4 pickingColor = vec4(instancePickingColors / 255., 1.);\n\n  vColor = mix(\n    color,\n    pickingColor,\n    renderPickingBuffer\n  );\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 796 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME line-layer-vertex-shader\n\nattribute vec3 positions;\nattribute vec3 instanceSourcePositions;\nattribute vec3 instanceTargetPositions;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\nuniform vec2 viewportSize;\nuniform float strokeWidth;\nuniform float opacity;\nuniform float renderPickingBuffer;\n\nvarying vec4 vColor;\n\n// offset vector by strokeWidth pixels\n// offset_direction is -1 (left) or 1 (right)\nvec2 getExtrusionOffset(vec2 line_clipspace, float offset_direction) {\n  // normalized direction of the line\n  vec2 dir_screenspace = normalize(line_clipspace * viewportSize);\n  // rotate by 90 degrees\n  dir_screenspace = vec2(-dir_screenspace.y, dir_screenspace.x);\n\n  vec2 offset_screenspace = dir_screenspace * offset_direction * strokeWidth / 2.0;\n  vec2 offset_clipspace = offset_screenspace / viewportSize * 2.0;\n\n  return offset_clipspace;\n}\n\nvoid main(void) {\n  // Position\n  vec3 sourcePos = project_position(instanceSourcePositions);\n  vec3 targetPos = project_position(instanceTargetPositions);\n  vec4 source = project_to_clipspace(vec4(sourcePos, 1.0));\n  vec4 target = project_to_clipspace(vec4(targetPos, 1.0));\n\n  // linear interpolation of source & target to pick right coord\n  float segmentIndex = positions.x;\n  vec4 p = mix(source, target, segmentIndex);\n\n  // extrude\n  vec2 offset = getExtrusionOffset(target.xy - source.xy, positions.y);\n  gl_Position = p + vec4(offset, 0.0, 0.0);\n\n  // Color\n  vec4 color = vec4(instanceColors.rgb, instanceColors.a * opacity) / 255.;\n  vec4 pickingColor = vec4(instancePickingColors / 255., 1.);\n  vColor = mix(\n    color,\n    pickingColor,\n    renderPickingBuffer\n  );\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _luma = __webpack_require__(29);
	
	var _fp = __webpack_require__(54);
	
	var _lineLayerVertex = __webpack_require__(796);
	
	var _lineLayerVertex2 = _interopRequireDefault(_lineLayerVertex);
	
	var _lineLayerVertex3 = __webpack_require__(795);
	
	var _lineLayerVertex4 = _interopRequireDefault(_lineLayerVertex3);
	
	var _lineLayerFragment = __webpack_require__(794);
	
	var _lineLayerFragment2 = _interopRequireDefault(_lineLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEFAULT_COLOR = [0, 0, 0, 255];
	
	var defaultProps = {
	  strokeWidth: 1,
	  fp64: false,
	
	  getSourcePosition: function getSourcePosition(x) {
	    return x.sourcePosition;
	  },
	  getTargetPosition: function getTargetPosition(x) {
	    return x.targetPosition;
	  },
	  getColor: function getColor(x) {
	    return x.color || DEFAULT_COLOR;
	  }
	};
	
	var LineLayer = function (_Layer) {
	  _inherits(LineLayer, _Layer);
	
	  function LineLayer() {
	    _classCallCheck(this, LineLayer);
	
	    return _possibleConstructorReturn(this, (LineLayer.__proto__ || Object.getPrototypeOf(LineLayer)).apply(this, arguments));
	  }
	
	  _createClass(LineLayer, [{
	    key: 'getShaders',
	    value: function getShaders() {
	      return (0, _fp.enable64bitSupport)(this.props) ? {
	        vs: _lineLayerVertex4.default, fs: _lineLayerFragment2.default, modules: ['fp64', 'project64']
	      } : {
	        vs: _lineLayerVertex2.default, fs: _lineLayerFragment2.default, modules: []
	      };
	    }
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      var gl = this.context.gl;
	
	      this.setState({ model: this._getModel(gl) });
	
	      var attributeManager = this.state.attributeManager;
	
	      /* eslint-disable max-len */
	
	      attributeManager.addInstanced({
	        instanceSourcePositions: { size: 3, accessor: 'getSourcePosition', update: this.calculateInstanceSourcePositions },
	        instanceTargetPositions: { size: 3, accessor: 'getTargetPosition', update: this.calculateInstanceTargetPositions },
	        instanceColors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getColor', update: this.calculateInstanceColors }
	      });
	      /* eslint-enable max-len */
	    }
	  }, {
	    key: 'updateAttribute',
	    value: function updateAttribute(_ref) {
	      var props = _ref.props,
	          oldProps = _ref.oldProps,
	          changeFlags = _ref.changeFlags;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidateAll();
	
	        if (props.fp64 && props.projectionMode === _lib.COORDINATE_SYSTEM.LNGLAT) {
	          attributeManager.addInstanced({
	            instanceSourceTargetPositions64xyLow: {
	              size: 4,
	              accessor: ['getSourcePosition', 'getTargetPosition'],
	              update: this.calculateInstanceSourceTargetPositions64xyLow
	            }
	          });
	        } else {
	          attributeManager.remove(['instanceSourceTargetPositions64xyLow']);
	        }
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref2) {
	      var props = _ref2.props,
	          oldProps = _ref2.oldProps,
	          changeFlags = _ref2.changeFlags;
	
	      _get(LineLayer.prototype.__proto__ || Object.getPrototypeOf(LineLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	
	      if (props.fp64 !== oldProps.fp64) {
	        var gl = this.context.gl;
	
	        this.setState({ model: this._getModel(gl) });
	      }
	      this.updateAttribute({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref3) {
	      var uniforms = _ref3.uniforms;
	      var strokeWidth = this.props.strokeWidth;
	
	
	      this.state.model.render(Object.assign({}, uniforms, {
	        strokeWidth: strokeWidth
	      }));
	    }
	  }, {
	    key: '_getModel',
	    value: function _getModel(gl) {
	      /*
	       *  (0, -1)-------------_(1, -1)
	       *       |          _,-"  |
	       *       o      _,-"      o
	       *       |  _,-"          |
	       *   (0, 1)"-------------(1, 1)
	       */
	      var positions = [0, -1, 0, 0, 1, 0, 1, -1, 0, 1, 1, 0];
	
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: _luma.GL.TRIANGLE_STRIP,
	          positions: new Float32Array(positions)
	        }),
	        isInstanced: true
	      });
	    }
	  }, {
	    key: 'calculateInstanceSourcePositions',
	    value: function calculateInstanceSourcePositions(attribute) {
	      var _props = this.props,
	          data = _props.data,
	          getSourcePosition = _props.getSourcePosition;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var object = _step.value;
	
	          var sourcePosition = getSourcePosition(object);
	          value[i + 0] = sourcePosition[0];
	          value[i + 1] = sourcePosition[1];
	          value[i + 2] = isNaN(sourcePosition[2]) ? 0 : sourcePosition[2];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceTargetPositions',
	    value: function calculateInstanceTargetPositions(attribute) {
	      var _props2 = this.props,
	          data = _props2.data,
	          getTargetPosition = _props2.getTargetPosition;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var object = _step2.value;
	
	          var targetPosition = getTargetPosition(object);
	          value[i + 0] = targetPosition[0];
	          value[i + 1] = targetPosition[1];
	          value[i + 2] = isNaN(targetPosition[2]) ? 0 : targetPosition[2];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceSourceTargetPositions64xyLow',
	    value: function calculateInstanceSourceTargetPositions64xyLow(attribute) {
	      var _props3 = this.props,
	          data = _props3.data,
	          getSourcePosition = _props3.getSourcePosition,
	          getTargetPosition = _props3.getTargetPosition;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var object = _step3.value;
	
	          var sourcePosition = getSourcePosition(object);
	          var targetPosition = getTargetPosition(object);
	          value[i + 0] = (0, _fp.fp64ify)(sourcePosition[0])[1];
	          value[i + 1] = (0, _fp.fp64ify)(sourcePosition[1])[1];
	          value[i + 2] = (0, _fp.fp64ify)(targetPosition[0])[1];
	          value[i + 3] = (0, _fp.fp64ify)(targetPosition[1])[1];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceColors',
	    value: function calculateInstanceColors(attribute) {
	      var _props4 = this.props,
	          data = _props4.data,
	          getColor = _props4.getColor;
	      var value = attribute.value,
	          size = attribute.size;
	
	      var i = 0;
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var object = _step4.value;
	
	          var color = getColor(object);
	          value[i + 0] = color[0];
	          value[i + 1] = color[1];
	          value[i + 2] = color[2];
	          value[i + 3] = isNaN(color[3]) ? 255 : color[3];
	          i += size;
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	  }]);
	
	  return LineLayer;
	}(_lib.Layer);
	
	exports.default = LineLayer;
	
	
	LineLayer.layerName = 'LineLayer';
	LineLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 798 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME path-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nuniform float jointType;\nuniform float miterLimit;\n\nvarying vec4 vColor;\nvarying vec2 vCornerOffset;\nvarying float vMiterLength;\n\nvoid main(void) {\n  // if joint is rounded, test distance from the corner\n  if (jointType > 0.0 && vMiterLength > 0.0 && length(vCornerOffset) > 1.0) {\n    discard;\n  }\n  if (jointType == 0.0 && vMiterLength > miterLimit) {\n    discard;\n  }\n  gl_FragColor = vColor;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 799 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "\n#define SHADER_NAME path-layer-vertex-shader\n\nattribute vec3 positions;\n\nattribute vec3 instanceStartPositions;\nattribute vec3 instanceEndPositions;\nattribute vec4 instanceStartEndPositions64xyLow;\nattribute vec3 instanceLeftDeltas;\nattribute vec3 instanceRightDeltas;\nattribute float instanceStrokeWidths;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\nuniform float widthScale;\nuniform float widthMinPixels;\nuniform float widthMaxPixels;\nuniform float jointType;\nuniform float miterLimit;\n\nuniform float opacity;\nuniform float renderPickingBuffer;\n\nvarying vec4 vColor;\nvarying vec2 vCornerOffset;\nvarying float vMiterLength;\n\nconst float EPSILON = 0.001;\n\nfloat flipIfTrue(bool flag) {\n  return -(float(flag) * 2. - 1.);\n}\nvec3 lineJoin(vec3 prevPoint, vec3 currPoint, vec3 nextPoint) {\n\n  float width = clamp(project_scale(instanceStrokeWidths * widthScale),\n    widthMinPixels, widthMaxPixels) / 2.0;\n\n  vec2 deltaA = currPoint.xy - prevPoint.xy;\n  vec2 deltaB = nextPoint.xy - currPoint.xy;\n\n  vec2 offsetVec;\n  float offsetScale;\n  float offsetDirection;\n\n  float lenA = length(deltaA);\n  float lenB = length(deltaB);\n  vec2 dirA = lenA > 0. ? normalize(deltaA) : vec2(1.0, 0.0);\n  vec2 dirB = lenB > 0. ? normalize(deltaB) : vec2(1.0, 0.0);\n  vec2 perpA = vec2(-dirA.y, dirA.x);\n  vec2 perpB = vec2(-dirB.y, dirB.x);\n\n  // tangent of the corner\n  vec2 tangent = vec2(dirA + dirB);\n  tangent = length(tangent) > 0. ? normalize(tangent) : perpA;\n  // direction of the corner\n  vec2 miterVec = vec2(-tangent.y, tangent.x);\n  // width offset from current position\n  vec2 perp = mix(perpB, perpA, positions.x);\n  float L = mix(lenB, lenA, positions.x);\n\n  // cap super sharp angles\n  float sinHalfA = abs(dot(miterVec, perp));\n  float cosHalfA = abs(dot(dirA, miterVec));\n  bool turnsRight = dirA.x * dirB.y > dirA.y * dirB.x;\n\n  // relative position to the corner:\n  // -1: inside (smaller side of the angle)\n  // 0: center\n  // 1: outside (bigger side of the angle)\n  float cornerPosition = mix(\n    flipIfTrue(turnsRight == (positions.y > 0.0)),\n    0.0,\n    positions.z\n  );\n\n  offsetScale = 1.0 / max(sinHalfA, EPSILON);\n\n  // do not bevel if line segment is too short\n  cornerPosition *= float(cornerPosition <= 0.0 || sinHalfA < min(lenA, lenB) / width * cosHalfA);\n  // trim if inside corner extends further than the line segment\n  offsetScale = mix(\n    offsetScale,\n    min(offsetScale, L / width / max(cosHalfA, EPSILON)),\n    float(cornerPosition < 0.0)\n  );\n\n  vMiterLength = mix(\n    offsetScale * cornerPosition,\n    mix(offsetScale, 0.0, cornerPosition),\n    step(0.0, cornerPosition)\n  ) - sinHalfA * jointType;\n  offsetDirection = mix(\n    positions.y,\n    mix(\n      flipIfTrue(turnsRight),\n      positions.y * flipIfTrue(turnsRight == (positions.x == 1.)),\n      cornerPosition\n    ),\n    step(0.0, cornerPosition)\n  );\n  offsetVec = mix(miterVec, -tangent, step(0.5, cornerPosition));\n  offsetScale = mix(offsetScale, 1.0 / max(cosHalfA, 0.001), step(0.5, cornerPosition));\n\n  // special treatment for start cap and end cap\n  float isStartCap = step(0.0, -lenA);\n  float isEndCap = step(0.0, -lenB);\n  float isCap = max(isStartCap, isEndCap);\n\n  // 0: center, 1: side\n  cornerPosition = isCap * (1.0 - positions.z);\n\n  // start of path: use next - curr\n  offsetVec = mix(offsetVec, mix(dirB, perpB, cornerPosition), isStartCap);\n  // end of path: use curr - prev\n  offsetVec = mix(offsetVec, mix(dirA, perpA, cornerPosition), isEndCap);\n\n  // extend out a triangle to envelope the round cap\n  offsetScale = mix(\n    offsetScale,\n    mix(4.0 * jointType, 1.0, cornerPosition),\n    isCap\n  );\n  vMiterLength = mix(vMiterLength, 1.0 - cornerPosition, isCap);\n\n  offsetDirection = mix(\n    offsetDirection,\n    mix(flipIfTrue(isStartCap > 0.), positions.y, cornerPosition),\n    isCap\n  );\n\n  vCornerOffset = offsetVec * offsetDirection * offsetScale;\n\n  return vec3(vCornerOffset * width, 0.0);\n}\n\nvoid main() {\n  vec4 color = vec4(instanceColors.rgb, instanceColors.a * opacity) / 255.;\n  vec4 pickingColor = vec4(instancePickingColors, 255.) / 255.;\n  vColor = mix(color, pickingColor, renderPickingBuffer);\n\n  float isEnd = positions.x;\n\n  // Calculate previous position\n  vec3 prevPosition = mix(-instanceLeftDeltas, vec3(0.0), isEnd) + instanceStartPositions;\n  prevPosition = project_position(prevPosition);\n\n  // Calculate current position\n  // Only here we need to do the 64-bit calculations.\n\n  vec2 instanceStartPositions64[2];\n  instanceStartPositions64[0] = vec2(instanceStartPositions.x, instanceStartEndPositions64xyLow.x);\n  instanceStartPositions64[1] = vec2(instanceStartPositions.y, instanceStartEndPositions64xyLow.y);\n\n  vec2 instanceEndPositions64[2];\n  instanceEndPositions64[0] = vec2(instanceEndPositions.x, instanceStartEndPositions64xyLow.z);\n  instanceEndPositions64[1] = vec2(instanceEndPositions.y, instanceStartEndPositions64xyLow.w);\n\n  vec3 currPosition = mix(instanceStartPositions, instanceEndPositions, isEnd);\n\n  vec2 tempCurrPosition64[2];\n  vec2_mix_fp64(instanceStartPositions64, instanceEndPositions64, isEnd, tempCurrPosition64);\n\n  vec4 currPosition64 = vec4(tempCurrPosition64[0].xy, tempCurrPosition64[1].xy);\n\n  vec2 projected_curr_position[2];\n  project_position_fp64(currPosition64, projected_curr_position);\n  float projected_curr_position_z = project_scale(currPosition.z);\n\n  currPosition = project_position(currPosition);\n\n  // Calculate next positions\n  vec3 nextPosition = mix(vec3(0.0), instanceRightDeltas, isEnd) + instanceEndPositions;\n  nextPosition = project_position(nextPosition);\n\n  vec3 pos = lineJoin(prevPosition, currPosition, nextPosition);\n  vec2 vertex_pos_modelspace[4];\n  vertex_pos_modelspace[0] = sum_fp64(vec2(pos.x, 0.0), projected_curr_position[0]);\n  vertex_pos_modelspace[1] = sum_fp64(vec2(pos.y, 0.0), projected_curr_position[1]);\n  vertex_pos_modelspace[2] = vec2(pos.z + projected_curr_position_z, 0.0);\n  vertex_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  gl_Position = project_to_clipspace_fp64(vertex_pos_modelspace);\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 800 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME path-layer-vertex-shader\n\nattribute vec3 positions;\n\nattribute vec3 instanceStartPositions;\nattribute vec3 instanceEndPositions;\nattribute vec3 instanceLeftDeltas;\nattribute vec3 instanceRightDeltas;\nattribute float instanceStrokeWidths;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\nuniform float widthScale;\nuniform float widthMinPixels;\nuniform float widthMaxPixels;\nuniform float jointType;\nuniform float miterLimit;\n\nuniform float opacity;\nuniform float renderPickingBuffer;\n\nvarying vec4 vColor;\nvarying vec2 vCornerOffset;\nvarying float vMiterLength;\n\nconst float EPSILON = 0.001;\n\nfloat flipIfTrue(bool flag) {\n  return -(float(flag) * 2. - 1.);\n}\n\n// calculate line join positions\nvec3 lineJoin(vec3 prevPoint, vec3 currPoint, vec3 nextPoint) {\n\n  float width = clamp(project_scale(instanceStrokeWidths * widthScale),\n    widthMinPixels, widthMaxPixels) / 2.0;\n\n  vec2 deltaA = currPoint.xy - prevPoint.xy;\n  vec2 deltaB = nextPoint.xy - currPoint.xy;\n\n  vec2 offsetVec;\n  float offsetScale;\n  float offsetDirection;\n\n  float lenA = length(deltaA);\n  float lenB = length(deltaB);\n  vec2 dirA = lenA > 0. ? normalize(deltaA) : vec2(1.0, 0.0);\n  vec2 dirB = lenB > 0. ? normalize(deltaB) : vec2(1.0, 0.0);\n  vec2 perpA = vec2(-dirA.y, dirA.x);\n  vec2 perpB = vec2(-dirB.y, dirB.x);\n\n  // tangent of the corner\n  vec2 tangent = vec2(dirA + dirB);\n  tangent = length(tangent) > 0. ? normalize(tangent) : perpA;\n  // direction of the corner\n  vec2 miterVec = vec2(-tangent.y, tangent.x);\n  // width offset from current position\n  vec2 perp = mix(perpB, perpA, positions.x);\n  float L = mix(lenB, lenA, positions.x);\n\n  // cap super sharp angles\n  float sinHalfA = abs(dot(miterVec, perp));\n  float cosHalfA = abs(dot(dirA, miterVec));\n  bool turnsRight = dirA.x * dirB.y > dirA.y * dirB.x;\n\n  // relative position to the corner:\n  // -1: inside (smaller side of the angle)\n  // 0: center\n  // 1: outside (bigger side of the angle)\n  float cornerPosition = mix(\n    flipIfTrue(turnsRight == (positions.y > 0.0)),\n    0.0,\n    positions.z\n  );\n\n  offsetScale = 1.0 / max(sinHalfA, EPSILON);\n\n  // do not bevel if line segment is too short\n  cornerPosition *= float(cornerPosition <= 0.0 || sinHalfA < min(lenA, lenB) / width * cosHalfA);\n  // trim if inside corner extends further than the line segment\n  offsetScale = mix(\n    offsetScale,\n    min(offsetScale, L / width / max(cosHalfA, EPSILON)),\n    float(cornerPosition < 0.0)\n  );\n\n  vMiterLength = mix(\n    offsetScale * cornerPosition,\n    mix(offsetScale, 0.0, cornerPosition),\n    step(0.0, cornerPosition)\n  ) - sinHalfA * jointType;\n  offsetDirection = mix(\n    positions.y,\n    mix(\n      flipIfTrue(turnsRight),\n      positions.y * flipIfTrue(turnsRight == (positions.x == 1.)),\n      cornerPosition\n    ),\n    step(0.0, cornerPosition)\n  );\n  offsetVec = mix(miterVec, -tangent, step(0.5, cornerPosition));\n  offsetScale = mix(offsetScale, 1.0 / max(cosHalfA, 0.001), step(0.5, cornerPosition));\n\n  // special treatment for start cap and end cap\n  float isStartCap = step(0.0, -lenA);\n  float isEndCap = step(0.0, -lenB);\n  float isCap = max(isStartCap, isEndCap);\n\n  // 0: center, 1: side\n  cornerPosition = isCap * (1.0 - positions.z);\n\n  // start of path: use next - curr\n  offsetVec = mix(offsetVec, mix(dirB, perpB, cornerPosition), isStartCap);\n  // end of path: use curr - prev\n  offsetVec = mix(offsetVec, mix(dirA, perpA, cornerPosition), isEndCap);\n\n  // extend out a triangle to envelope the round cap\n  offsetScale = mix(\n    offsetScale,\n    mix(4.0 * jointType, 1.0, cornerPosition),\n    isCap\n  );\n  vMiterLength = mix(vMiterLength, 1.0 - cornerPosition, isCap);\n\n  offsetDirection = mix(\n    offsetDirection,\n    mix(flipIfTrue(isStartCap > 0.), positions.y, cornerPosition),\n    isCap\n  );\n\n  vCornerOffset = offsetVec * offsetDirection * offsetScale;\n\n  return currPoint + vec3(vCornerOffset * width, 0.0);\n}\n\nvoid main() {\n  vec4 color = vec4(instanceColors.rgb, instanceColors.a * opacity) / 255.;\n  vec4 pickingColor = vec4(instancePickingColors, 255.) / 255.;\n  vColor = mix(color, pickingColor, renderPickingBuffer);\n\n  float isEnd = positions.x;\n\n  vec3 prevPosition = mix(-instanceLeftDeltas, vec3(0.0), isEnd) + instanceStartPositions;\n  prevPosition = project_position(prevPosition);\n\n  vec3 currPosition = mix(instanceStartPositions, instanceEndPositions, isEnd);\n  currPosition = project_position(currPosition);\n\n  vec3 nextPosition = mix(vec3(0.0), instanceRightDeltas, isEnd) + instanceEndPositions;\n  nextPosition = project_position(nextPosition);\n\n  vec3 pos;\n\n  pos = lineJoin(prevPosition, currPosition, nextPosition);\n\n  gl_Position = project_to_clipspace(vec4(pos, 1.0));\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 801 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME point-cloud-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nvarying vec4 vColor;\nvarying vec2 unitPosition;\n\nvoid main(void) {\n\n  float distToCenter = length(unitPosition);\n\n  if (distToCenter <= 1.0) {\n    gl_FragColor = vColor;\n  } else {\n    discard;\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 802 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME point-cloud-layer-vertex-64-shader\n\nattribute vec3 positions;\n\nattribute vec3 instancePositions;\nattribute vec2 instancePositions64xyLow;\nattribute vec3 instanceNormals;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\nuniform float renderPickingBuffer;\nuniform float opacity;\nuniform float radiusPixels;\nuniform vec2 screenSize;\n\nvarying vec4 vColor;\nvarying vec2 unitPosition;\n\nvoid main(void) {\n  // position on the containing square in [-1, 1] space\n  unitPosition = positions.xy;\n\n  vec4 instancePositions64xy = vec4(\n    instancePositions.x, instancePositions64xyLow.x,\n    instancePositions.y, instancePositions64xyLow.y);\n\n  vec2 projected_coord_xy[2];\n  project_position_fp64(instancePositions64xy, projected_coord_xy);\n\n  vec2 vertex_pos_localspace[4];\n  vec4_fp64(vec4(positions.xy * radiusPixels / screenSize * 2.0, 0.0, 0.0), vertex_pos_localspace);\n\n  vec2 vertex_pos_modelspace[4];\n  vertex_pos_modelspace[0] = sum_fp64(vertex_pos_localspace[0], projected_coord_xy[0]);\n  vertex_pos_modelspace[1] = sum_fp64(vertex_pos_localspace[1], projected_coord_xy[1]);\n  vertex_pos_modelspace[2] = sum_fp64(vertex_pos_localspace[2],\n    vec2(project_scale(instancePositions.z), 0.0));\n  vertex_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  gl_Position = project_to_clipspace_fp64(vertex_pos_modelspace);\n\n  vec4 position_worldspace = vec4(\n    projected_coord_xy[0].x, projected_coord_xy[1].x,\n    project_scale(instancePositions.z), 1.0);\n\n  if (renderPickingBuffer > 0.5) {\n    vColor = vec4(instancePickingColors / 255., 1.);\n  } else {\n    // Apply lighting\n    float lightWeight = getLightWeight(position_worldspace, instanceNormals);\n\n    // Apply opacity to instance color, or return instance picking color\n    vColor = vec4(lightWeight * instanceColors.rgb, instanceColors.a * opacity) / 255.;\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 803 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME point-cloud-layer-vertex-shader\n\nattribute vec3 positions;\n\nattribute vec3 instancePositions;\nattribute vec3 instanceNormals;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\nuniform float renderPickingBuffer;\nuniform float opacity;\nuniform float radiusPixels;\nuniform vec2 viewportSize;\n\nvarying vec4 vColor;\nvarying vec2 unitPosition;\n\nvoid main(void) {\n  // position on the containing square in [-1, 1] space\n  unitPosition = positions.xy;\n\n  // Find the center of the point and add the current vertex\n  vec4 position_worldspace = vec4(project_position(instancePositions), 1.0);\n  vec2 vertex = positions.xy * radiusPixels / viewportSize * 2.0;\n  gl_Position = project_to_clipspace(position_worldspace) + vec4(vertex, 0.0, 0.0);\n\n  // Apply lighting\n  float lightWeight = getLightWeight(position_worldspace, instanceNormals);\n\n  // Apply opacity to instance color, or return instance picking color\n  vec4 color = vec4(lightWeight * instanceColors.rgb, instanceColors.a * opacity) / 255.;\n  vec4 pickingColor = vec4(instancePickingColors / 255., 1.);\n  vColor = mix(color, pickingColor, renderPickingBuffer);\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _luma = __webpack_require__(29);
	
	var _fp = __webpack_require__(54);
	
	var _pointCloudLayerVertex = __webpack_require__(803);
	
	var _pointCloudLayerVertex2 = _interopRequireDefault(_pointCloudLayerVertex);
	
	var _pointCloudLayerVertex3 = __webpack_require__(802);
	
	var _pointCloudLayerVertex4 = _interopRequireDefault(_pointCloudLayerVertex3);
	
	var _pointCloudLayerFragment = __webpack_require__(801);
	
	var _pointCloudLayerFragment2 = _interopRequireDefault(_pointCloudLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEFAULT_COLOR = [0, 0, 0, 255];
	
	var defaultProps = {
	  radiusPixels: 10, //  point radius in pixels
	  fp64: false,
	
	  getPosition: function getPosition(x) {
	    return x.position;
	  },
	  getNormal: function getNormal(x) {
	    return x.normal;
	  },
	  getColor: function getColor(x) {
	    return x.color || DEFAULT_COLOR;
	  },
	
	  lightSettings: {
	    lightsPosition: [0, 0, 5000, -1000, 1000, 8000, 5000, -5000, 1000],
	    ambientRatio: 0.2,
	    diffuseRatio: 0.6,
	    specularRatio: 0.8,
	    lightsStrength: [1.0, 0.0, 0.8, 0.0, 0.4, 0.0],
	    numberOfLights: 3
	  }
	};
	
	var PointCloudLayer = function (_Layer) {
	  _inherits(PointCloudLayer, _Layer);
	
	  function PointCloudLayer() {
	    _classCallCheck(this, PointCloudLayer);
	
	    return _possibleConstructorReturn(this, (PointCloudLayer.__proto__ || Object.getPrototypeOf(PointCloudLayer)).apply(this, arguments));
	  }
	
	  _createClass(PointCloudLayer, [{
	    key: 'getShaders',
	    value: function getShaders(id) {
	      return (0, _fp.enable64bitSupport)(this.props) ? {
	        vs: _pointCloudLayerVertex4.default, fs: _pointCloudLayerFragment2.default, modules: ['fp64', 'project64', 'lighting']
	      } : {
	        vs: _pointCloudLayerVertex2.default, fs: _pointCloudLayerFragment2.default, modules: ['lighting']
	      };
	    }
	  }, {
	    key: 'initializeState',
	    value: function initializeState() {
	      var gl = this.context.gl;
	
	      this.setState({ model: this._getModel(gl) });
	
	      /* eslint-disable max-len */
	      this.state.attributeManager.addInstanced({
	        instancePositions: { size: 3, accessor: 'getPosition', update: this.calculateInstancePositions },
	        instanceNormals: { size: 3, accessor: 'getNormal', defaultValue: 1, update: this.calculateInstanceNormals },
	        instanceColors: { size: 4, type: _luma.GL.UNSIGNED_BYTE, accessor: 'getColor', update: this.calculateInstanceColors }
	      });
	      /* eslint-enable max-len */
	    }
	  }, {
	    key: 'updateAttribute',
	    value: function updateAttribute(_ref) {
	      var props = _ref.props,
	          oldProps = _ref.oldProps,
	          changeFlags = _ref.changeFlags;
	
	      if (props.fp64 !== oldProps.fp64) {
	        var attributeManager = this.state.attributeManager;
	
	        attributeManager.invalidateAll();
	
	        if (props.fp64 && props.projectionMode === _lib.COORDINATE_SYSTEM.LNGLAT) {
	          attributeManager.addInstanced({
	            instancePositions64xyLow: {
	              size: 2,
	              accessor: 'getPosition',
	              update: this.calculateInstancePositions64xyLow
	            }
	          });
	        } else {
	          attributeManager.remove(['instancePositions64xyLow']);
	        }
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref2) {
	      var props = _ref2.props,
	          oldProps = _ref2.oldProps,
	          changeFlags = _ref2.changeFlags;
	
	      _get(PointCloudLayer.prototype.__proto__ || Object.getPrototypeOf(PointCloudLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	      if (props.fp64 !== oldProps.fp64) {
	        var gl = this.context.gl;
	
	        this.setState({ model: this._getModel(gl) });
	      }
	      this.updateAttribute({ props: props, oldProps: oldProps, changeFlags: changeFlags });
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref3) {
	      var uniforms = _ref3.uniforms;
	      var _props = this.props,
	          radiusPixels = _props.radiusPixels,
	          lightSettings = _props.lightSettings;
	
	      this.state.model.render(Object.assign({}, uniforms, {
	        radiusPixels: radiusPixels
	      }, lightSettings));
	    }
	  }, {
	    key: '_getModel',
	    value: function _getModel(gl) {
	      // a triangle that minimally cover the unit circle
	      var positions = [];
	      for (var i = 0; i < 3; i++) {
	        var angle = i / 3 * Math.PI * 2;
	        positions.push(Math.cos(angle) * 2, Math.sin(angle) * 2, 0);
	      }
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: _luma.GL.TRIANGLES,
	          positions: new Float32Array(positions)
	        }),
	        isInstanced: true
	      });
	    }
	  }, {
	    key: 'calculateInstancePositions',
	    value: function calculateInstancePositions(attribute) {
	      var _props2 = this.props,
	          data = _props2.data,
	          getPosition = _props2.getPosition;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var point = _step.value;
	
	          var position = getPosition(point);
	          value[i++] = position[0];
	          value[i++] = position[1];
	          value[i++] = position[2] || 0;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstancePositions64xyLow',
	    value: function calculateInstancePositions64xyLow(attribute) {
	      var _props3 = this.props,
	          data = _props3.data,
	          getPosition = _props3.getPosition;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var point = _step2.value;
	
	          var position = getPosition(point);
	          value[i++] = (0, _fp.fp64ify)(position[0])[1];
	          value[i++] = (0, _fp.fp64ify)(position[1])[1];
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceNormals',
	    value: function calculateInstanceNormals(attribute) {
	      var _props4 = this.props,
	          data = _props4.data,
	          getNormal = _props4.getNormal;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var point = _step3.value;
	
	          var normal = getNormal(point);
	          value[i++] = normal[0];
	          value[i++] = normal[1];
	          value[i++] = normal[2];
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'calculateInstanceColors',
	    value: function calculateInstanceColors(attribute) {
	      var _props5 = this.props,
	          data = _props5.data,
	          getColor = _props5.getColor;
	      var value = attribute.value;
	
	      var i = 0;
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var point = _step4.value;
	
	          var color = getColor(point);
	          value[i++] = color[0];
	          value[i++] = color[1];
	          value[i++] = color[2];
	          value[i++] = isNaN(color[3]) ? 255 : color[3];
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	  }]);
	
	  return PointCloudLayer;
	}(_lib.Layer);
	
	exports.default = PointCloudLayer;
	
	
	PointCloudLayer.layerName = 'PointCloudLayer';
	PointCloudLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lib = __webpack_require__(35);
	
	var _solidPolygonLayer = __webpack_require__(389);
	
	var _solidPolygonLayer2 = _interopRequireDefault(_solidPolygonLayer);
	
	var _pathLayer = __webpack_require__(257);
	
	var _pathLayer2 = _interopRequireDefault(_pathLayer);
	
	var _polygon = __webpack_require__(258);
	
	var Polygon = _interopRequireWildcard(_polygon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultLineColor = [0x0, 0x0, 0x0, 0xFF];
	var defaultFillColor = [0x0, 0x0, 0x0, 0xFF];
	
	var defaultProps = {
	  stroked: true,
	  filled: true,
	  extruded: false,
	  wireframe: false,
	
	  lineWidthScale: 1,
	  lineWidthMinPixels: 0,
	  lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
	  lineJointRounded: false,
	  lineMiterLimit: 4,
	  fp64: false,
	
	  getPolygon: function getPolygon(f) {
	    return (0, _lib.get)(f, 'polygon');
	  },
	  // Polygon fill color
	  getFillColor: function getFillColor(f) {
	    return (0, _lib.get)(f, 'fillColor') || defaultFillColor;
	  },
	  // Point, line and polygon outline color
	  getLineColor: function getLineColor(f) {
	    return (0, _lib.get)(f, 'lineColor') || defaultLineColor;
	  },
	  // Line and polygon outline accessors
	  getLineWidth: function getLineWidth(f) {
	    return (0, _lib.get)(f, 'lineWidth') || 1;
	  },
	  // Polygon extrusion accessor
	  getElevation: function getElevation(f) {
	    return (0, _lib.get)(f, 'elevation') || 1000;
	  },
	
	  // Optional settings for 'lighting' shader module
	  lightSettings: {
	    lightsPosition: [-122.45, 37.75, 8000, -122.0, 38.00, 5000],
	    ambientRatio: 0.05,
	    diffuseRatio: 0.6,
	    specularRatio: 0.8,
	    lightsStrength: [2.0, 0.0, 0.0, 0.0],
	    numberOfLights: 2
	  }
	};
	
	var PolygonLayer = function (_CompositeLayer) {
	  _inherits(PolygonLayer, _CompositeLayer);
	
	  function PolygonLayer() {
	    _classCallCheck(this, PolygonLayer);
	
	    return _possibleConstructorReturn(this, (PolygonLayer.__proto__ || Object.getPrototypeOf(PolygonLayer)).apply(this, arguments));
	  }
	
	  _createClass(PolygonLayer, [{
	    key: 'initializeState',
	    value: function initializeState() {
	      this.state = {
	        paths: []
	      };
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref) {
	      var _this2 = this;
	
	      var oldProps = _ref.oldProps,
	          props = _ref.props,
	          changeFlags = _ref.changeFlags;
	
	      if (changeFlags.dataChanged) {
	        var _props = this.props,
	            data = _props.data,
	            getPolygon = _props.getPolygon;
	
	        this.state.paths = [];
	        data.forEach(function (object) {
	          var complexPolygon = Polygon.normalize(getPolygon(object));
	          complexPolygon.forEach(function (polygon) {
	            return _this2.state.paths.push({
	              path: polygon,
	              object: object
	            });
	          });
	        });
	      }
	    }
	  }, {
	    key: 'getPickingInfo',
	    value: function getPickingInfo(_ref2) {
	      var info = _ref2.info;
	
	      return Object.assign(info, {
	        // override object with picked data
	        object: info.object && info.object.object || info.object
	      });
	    }
	  }, {
	    key: 'renderLayers',
	    value: function renderLayers() {
	      // Layer composition props
	      var _props2 = this.props,
	          data = _props2.data,
	          id = _props2.id,
	          stroked = _props2.stroked,
	          filled = _props2.filled,
	          extruded = _props2.extruded,
	          wireframe = _props2.wireframe;
	
	      // Rendering props underlying layer
	
	      var _props3 = this.props,
	          lineWidthScale = _props3.lineWidthScale,
	          lineWidthMinPixels = _props3.lineWidthMinPixels,
	          lineWidthMaxPixels = _props3.lineWidthMaxPixels,
	          lineJointRounded = _props3.lineJointRounded,
	          lineMiterLimit = _props3.lineMiterLimit,
	          fp64 = _props3.fp64;
	
	      // Accessor props for underlying layers
	
	      var _props4 = this.props,
	          getFillColor = _props4.getFillColor,
	          getLineColor = _props4.getLineColor,
	          getLineWidth = _props4.getLineWidth,
	          getElevation = _props4.getElevation,
	          getPolygon = _props4.getPolygon,
	          updateTriggers = _props4.updateTriggers,
	          lightSettings = _props4.lightSettings;
	
	      // base layer props
	
	      var _props5 = this.props,
	          opacity = _props5.opacity,
	          pickable = _props5.pickable,
	          visible = _props5.visible;
	
	      // viewport props
	
	      var _props6 = this.props,
	          positionOrigin = _props6.positionOrigin,
	          projectionMode = _props6.projectionMode,
	          modelMatrix = _props6.modelMatrix;
	      var paths = this.state.paths;
	
	
	      var hasData = data && data.length > 0;
	
	      // Filled Polygon Layer
	      var polygonLayer = filled && hasData && new _solidPolygonLayer2.default({
	        id: id + '-fill',
	        data: data,
	        extruded: extruded,
	        wireframe: false,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getPolygon: getPolygon,
	        getElevation: getElevation,
	        getColor: getFillColor,
	        updateTriggers: {
	          getElevation: updateTriggers.getElevation,
	          getColor: updateTriggers.getFillColor
	        },
	        lightSettings: lightSettings
	      });
	
	      var polygonWireframeLayer = extruded && wireframe && hasData && new _solidPolygonLayer2.default({
	        id: id + '-wireframe',
	        data: data,
	        extruded: true,
	        wireframe: true,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getPolygon: getPolygon,
	        getElevation: getElevation,
	        getColor: getLineColor,
	        updateTriggers: {
	          getElevation: updateTriggers.getElevation,
	          getColor: updateTriggers.getLineColor
	        }
	      });
	
	      // Polygon line layer
	      var polygonLineLayer = !extruded && stroked && hasData && new _pathLayer2.default({
	        id: id + '-stroke',
	        data: paths,
	        widthScale: lineWidthScale,
	        widthMinPixels: lineWidthMinPixels,
	        widthMaxPixels: lineWidthMaxPixels,
	        rounded: lineJointRounded,
	        miterLimit: lineMiterLimit,
	        fp64: fp64,
	        opacity: opacity,
	        pickable: pickable,
	        visible: visible,
	        projectionMode: projectionMode,
	        positionOrigin: positionOrigin,
	        modelMatrix: modelMatrix,
	        getPath: function getPath(x) {
	          return x.path;
	        },
	        getColor: getLineColor,
	        getWidth: getLineWidth,
	        updateTriggers: {
	          getWidth: updateTriggers.getLineWidth,
	          getColor: updateTriggers.getLineColor
	        }
	      });
	
	      return [polygonLayer, polygonWireframeLayer, polygonLineLayer].filter(Boolean);
	    }
	  }]);
	
	  return PolygonLayer;
	}(_lib.CompositeLayer);
	
	exports.default = PolygonLayer;
	
	
	PolygonLayer.layerName = 'PolygonLayer';
	PolygonLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 806 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME scatterplot-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nvarying vec4 vColor;\nvarying vec2 unitPosition;\nvarying float innerUnitRadius;\n\nvoid main(void) {\n\n  float distToCenter = length(unitPosition);\n\n  if (distToCenter <= 1.0 && distToCenter >= innerUnitRadius) {\n    gl_FragColor = vColor;\n  } else {\n    discard;\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 807 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME scatterplot-layer-vertex-64-shader\n\nattribute vec3 positions;\n\nattribute vec3 instancePositions;\nattribute vec2 instancePositions64xyLow;\nattribute float instanceRadius;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\n// Only one-dimensional arrays may be declared in GLSL ES 1.0. specs p.24\nuniform float opacity;\nuniform float radiusScale;\nuniform float radiusMinPixels;\nuniform float radiusMaxPixels;\nuniform float renderPickingBuffer;\nuniform float outline;\nuniform float strokeWidth;\n\nvarying vec4 vColor;\nvarying vec2 unitPosition;\nvarying float innerUnitRadius;\n\nvoid main(void) {\n  // Multiply out radius and clamp to limits\n  float outerRadiusPixels = clamp(\n    project_scale(radiusScale * instanceRadius),\n    radiusMinPixels, radiusMaxPixels\n  );\n\n  // outline is centered at the radius\n  // outer radius needs to offset by half stroke width\n  outerRadiusPixels += outline * strokeWidth / 2.0;\n\n  // position on the containing square in [-1, 1] space\n  unitPosition = positions.xy;\n  // 0 - solid circle, 1 - stroke with lineWidth=0\n  innerUnitRadius = outline * (1.0 - strokeWidth / outerRadiusPixels);\n\n  vec4 instancePositions64xy = vec4(\n    instancePositions.x, instancePositions64xyLow.x,\n    instancePositions.y, instancePositions64xyLow.y);\n\n  vec2 projected_coord_xy[2];\n  project_position_fp64(instancePositions64xy, projected_coord_xy);\n\n  vec2 vertex_pos_localspace[4];\n  vec4_fp64(vec4(positions * outerRadiusPixels, 0.0), vertex_pos_localspace);\n\n  vec2 vertex_pos_modelspace[4];\n  vertex_pos_modelspace[0] = sum_fp64(vertex_pos_localspace[0], projected_coord_xy[0]);\n  vertex_pos_modelspace[1] = sum_fp64(vertex_pos_localspace[1], projected_coord_xy[1]);\n  vertex_pos_modelspace[2] = sum_fp64(vertex_pos_localspace[2],\n    vec2(project_scale(instancePositions.z), 0.0));\n  vertex_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  gl_Position = project_to_clipspace_fp64(vertex_pos_modelspace);\n\n  if (renderPickingBuffer > 0.5) {\n    vColor = vec4(instancePickingColors / 255., 1.);\n  } else {\n    vColor = vec4(instanceColors.rgb, instanceColors.a * opacity) / 255.;\n  }\n  // // Apply opacity to instance color, or return instance picking color\n  // vec4 color = vec4(instanceColors.rgb, instanceColors.a * opacity) / 255.;\n  // vec4 pickingColor = vec4(instancePickingColors / 255., 1.);\n  // vColor = mix(color, pickingColor, renderPickingBuffer);\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 808 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME scatterplot-layer-vertex-shader\n\nattribute vec3 positions;\n\nattribute vec3 instancePositions;\nattribute float instanceRadius;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\nuniform float opacity;\nuniform float radiusScale;\nuniform float radiusMinPixels;\nuniform float radiusMaxPixels;\nuniform float renderPickingBuffer;\nuniform float outline;\nuniform float strokeWidth;\n\nvarying vec4 vColor;\nvarying vec2 unitPosition;\nvarying float innerUnitRadius;\n\nvoid main(void) {\n  // Multiply out radius and clamp to limits\n  float outerRadiusPixels = clamp(\n    project_scale(radiusScale * instanceRadius),\n    radiusMinPixels, radiusMaxPixels\n  );\n  // outline is centered at the radius\n  // outer radius needs to offset by half stroke width\n  outerRadiusPixels += outline * strokeWidth / 2.0;\n\n  // position on the containing square in [-1, 1] space\n  unitPosition = positions.xy;\n  // 0 - solid circle, 1 - stroke with lineWidth=0\n  innerUnitRadius = outline * (1.0 - strokeWidth / outerRadiusPixels);\n\n  // Find the center of the point and add the current vertex\n  vec3 center = project_position(instancePositions);\n  vec3 vertex = positions * outerRadiusPixels;\n  gl_Position = project_to_clipspace(vec4(center + vertex, 1.0));\n\n  // Apply opacity to instance color, or return instance picking color\n  vec4 color = vec4(instanceColors.rgb, instanceColors.a * opacity) / 255.;\n  vec4 pickingColor = vec4(instancePickingColors / 255., 1.);\n  vColor = mix(color, pickingColor, renderPickingBuffer);\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 809 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* fragment shader for the grid-layer */
	exports.default = "#define SHADER_NAME grid-layer-fs\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  gl_FragColor = vColor;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 810 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME grid-layer-vs\n\nattribute vec3 vertices;\nattribute vec3 instancePositions;\nattribute float instanceCount;\nattribute vec3 instancePickingColors;\n\nuniform float maxCount;\nuniform float opacity;\nuniform vec4 minColor;\nuniform vec4 maxColor;\nuniform float renderPickingBuffer;\nuniform vec3 cellScale;\nuniform vec3 selectedPickingColor;\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  vec4 color = mix(minColor, maxColor, instanceCount / maxCount) / 255.;\n\n  vColor = mix(\n    vec4(color.rgb, color.a * opacity),\n    vec4(instancePickingColors / 255., 1.),\n    renderPickingBuffer\n  );\n\n  gl_Position = vec4(instancePositions + vertices * cellScale, 1.);\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _luma = __webpack_require__(29);
	
	var _screenGridLayerVertex = __webpack_require__(810);
	
	var _screenGridLayerVertex2 = _interopRequireDefault(_screenGridLayerVertex);
	
	var _screenGridLayerFragment = __webpack_require__(809);
	
	var _screenGridLayerFragment2 = _interopRequireDefault(_screenGridLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultProps = {
	  cellSizePixels: 100,
	
	  // Color range?
	  minColor: [0, 0, 0, 255],
	  maxColor: [0, 255, 0, 255],
	
	  getPosition: function getPosition(d) {
	    return d.position;
	  },
	  getWeight: function getWeight(d) {
	    return 1;
	  }
	};
	
	var ScreenGridLayer = function (_Layer) {
	  _inherits(ScreenGridLayer, _Layer);
	
	  _createClass(ScreenGridLayer, [{
	    key: 'getShaders',
	    value: function getShaders() {
	      return {
	        vs: _screenGridLayerVertex2.default,
	        fs: _screenGridLayerFragment2.default
	      };
	    }
	  }]);
	
	  function ScreenGridLayer(props) {
	    _classCallCheck(this, ScreenGridLayer);
	
	    var _this = _possibleConstructorReturn(this, (ScreenGridLayer.__proto__ || Object.getPrototypeOf(ScreenGridLayer)).call(this, props));
	
	    _this._checkRemovedProp('unitWidth', 'cellSizePixels');
	    _this._checkRemovedProp('unitHeight', 'cellSizePixels');
	    return _this;
	  }
	
	  _createClass(ScreenGridLayer, [{
	    key: 'initializeState',
	    value: function initializeState() {
	      var attributeManager = this.state.attributeManager;
	      /* eslint-disable max-len */
	
	      attributeManager.addInstanced({
	        instancePositions: { size: 3, update: this.calculateInstancePositions },
	        instanceCount: { size: 1, accessor: ['getPosition', 'getWeight'], update: this.calculateInstanceCount }
	      });
	      /* eslint-disable max-len */
	
	      var gl = this.context.gl;
	
	      this.setState({ model: this.getModel(gl) });
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref) {
	      var oldProps = _ref.oldProps,
	          props = _ref.props,
	          changeFlags = _ref.changeFlags;
	
	      _get(ScreenGridLayer.prototype.__proto__ || Object.getPrototypeOf(ScreenGridLayer.prototype), 'updateState', this).call(this, { props: props, oldProps: oldProps, changeFlags: changeFlags });
	      var cellSizeChanged = props.cellSizePixels !== oldProps.cellSizePixels;
	
	      if (cellSizeChanged || changeFlags.viewportChanged) {
	        this.updateCell();
	      }
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref2) {
	      var uniforms = _ref2.uniforms;
	      var _props = this.props,
	          minColor = _props.minColor,
	          maxColor = _props.maxColor;
	      var _state = this.state,
	          model = _state.model,
	          cellScale = _state.cellScale,
	          maxCount = _state.maxCount;
	      var gl = this.context.gl;
	
	      gl.depthMask(true);
	      uniforms = Object.assign({}, uniforms, { minColor: minColor, maxColor: maxColor, cellScale: cellScale, maxCount: maxCount });
	      model.render(uniforms);
	    }
	  }, {
	    key: 'getModel',
	    value: function getModel(gl) {
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: _luma.GL.TRIANGLE_FAN,
	          vertices: new Float32Array([0, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0])
	        }),
	        isInstanced: true
	      });
	    }
	  }, {
	    key: 'updateCell',
	    value: function updateCell() {
	      var _context$viewport = this.context.viewport,
	          width = _context$viewport.width,
	          height = _context$viewport.height;
	      var cellSizePixels = this.props.cellSizePixels;
	
	
	      var MARGIN = 2;
	      var cellScale = new Float32Array([(cellSizePixels - MARGIN) / width * 2, -(cellSizePixels - MARGIN) / height * 2, 1]);
	      var numCol = Math.ceil(width / cellSizePixels);
	      var numRow = Math.ceil(height / cellSizePixels);
	
	      this.setState({
	        cellScale: cellScale,
	        numCol: numCol,
	        numRow: numRow,
	        numInstances: numCol * numRow
	      });
	
	      var attributeManager = this.state.attributeManager;
	
	      attributeManager.invalidateAll();
	    }
	  }, {
	    key: 'calculateInstancePositions',
	    value: function calculateInstancePositions(attribute, _ref3) {
	      var numInstances = _ref3.numInstances;
	      var _context$viewport2 = this.context.viewport,
	          width = _context$viewport2.width,
	          height = _context$viewport2.height;
	      var cellSizePixels = this.props.cellSizePixels;
	      var numCol = this.state.numCol;
	      var value = attribute.value,
	          size = attribute.size;
	
	
	      for (var i = 0; i < numInstances; i++) {
	        var x = i % numCol;
	        var y = Math.floor(i / numCol);
	        value[i * size + 0] = x * cellSizePixels / width * 2 - 1;
	        value[i * size + 1] = 1 - y * cellSizePixels / height * 2;
	        value[i * size + 2] = 0;
	      }
	    }
	  }, {
	    key: 'calculateInstanceCount',
	    value: function calculateInstanceCount(attribute) {
	      var _props2 = this.props,
	          data = _props2.data,
	          cellSizePixels = _props2.cellSizePixels,
	          getPosition = _props2.getPosition,
	          getWeight = _props2.getWeight;
	      var _state2 = this.state,
	          numCol = _state2.numCol,
	          numRow = _state2.numRow;
	      var value = attribute.value;
	
	      var maxCount = 0;
	
	      value.fill(0.0);
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var point = _step.value;
	
	          var pixel = this.project(getPosition(point));
	          var colId = Math.floor(pixel[0] / cellSizePixels);
	          var rowId = Math.floor(pixel[1] / cellSizePixels);
	          if (colId >= 0 && colId < numCol && rowId >= 0 && rowId < numRow) {
	            var i = colId + rowId * numCol;
	            value[i] += getWeight(point);
	            if (value[i] > maxCount) {
	              maxCount = value[i];
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.setState({ maxCount: maxCount });
	    }
	  }]);
	
	  return ScreenGridLayer;
	}(_lib.Layer);
	
	exports.default = ScreenGridLayer;
	
	
	ScreenGridLayer.layerName = 'ScreenGridLayer';
	ScreenGridLayer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PolygonTesselatorExtruded = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _polygon = __webpack_require__(258);
	
	var Polygon = _interopRequireWildcard(_polygon);
	
	var _glMatrix = __webpack_require__(55);
	
	var _fp = __webpack_require__(54);
	
	var _utils = __webpack_require__(42);
	
	var _earcut = __webpack_require__(184);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	var _lodash = __webpack_require__(407);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function getPickingColor(index) {
	  return [(index + 1) % 256, Math.floor((index + 1) / 256) % 256, Math.floor((index + 1) / 256 / 256) % 256];
	}
	
	function parseColor(color) {
	  if (!Array.isArray(color)) {
	    color = [(0, _utils.get)(color, 0), (0, _utils.get)(color, 1), (0, _utils.get)(color, 2), (0, _utils.get)(color, 3)];
	  }
	  color[3] = Number.isFinite(color[3]) ? color[3] : 255;
	  return color;
	}
	
	var DEFAULT_COLOR = [0, 0, 0, 255]; // Black
	
	var PolygonTesselatorExtruded = exports.PolygonTesselatorExtruded = function () {
	  function PolygonTesselatorExtruded(_ref) {
	    var polygons = _ref.polygons,
	        _ref$getHeight = _ref.getHeight,
	        getHeight = _ref$getHeight === undefined ? function (x) {
	      return 1000;
	    } : _ref$getHeight,
	        _ref$getColor = _ref.getColor,
	        getColor = _ref$getColor === undefined ? function (x) {
	      return [0, 0, 0, 255];
	    } : _ref$getColor,
	        _ref$wireframe = _ref.wireframe,
	        wireframe = _ref$wireframe === undefined ? false : _ref$wireframe,
	        _ref$fp = _ref.fp64,
	        fp64 = _ref$fp === undefined ? false : _ref$fp;
	
	    _classCallCheck(this, PolygonTesselatorExtruded);
	
	    this.fp64 = fp64;
	
	    // Expensive operation, convert all polygons to arrays
	    polygons = polygons.map(function (complexPolygon, polygonIndex) {
	      var height = getHeight(polygonIndex) || 0;
	      return Polygon.normalize(complexPolygon).map(function (polygon) {
	        return polygon.map(function (coord) {
	          return [(0, _utils.get)(coord, 0), (0, _utils.get)(coord, 1), height];
	        });
	      });
	    });
	
	    var groupedVertices = polygons;
	    this.groupedVertices = polygons;
	    this.wireframe = wireframe;
	
	    this.attributes = {};
	
	    var positionsJS = calculatePositionsJS({ groupedVertices: groupedVertices, wireframe: wireframe });
	    Object.assign(this.attributes, {
	      positions: calculatePositions(positionsJS, this.fp64),
	      indices: calculateIndices({ groupedVertices: groupedVertices, wireframe: wireframe }),
	      normals: calculateNormals({ groupedVertices: groupedVertices, wireframe: wireframe }),
	      // colors: calculateColors({groupedVertices, wireframe, getColor}),
	      pickingColors: calculatePickingColors({ groupedVertices: groupedVertices, wireframe: wireframe })
	    });
	  }
	
	  _createClass(PolygonTesselatorExtruded, [{
	    key: 'indices',
	    value: function indices() {
	      return this.attributes.indices;
	    }
	  }, {
	    key: 'positions',
	    value: function positions() {
	      return this.attributes.positions;
	    }
	  }, {
	    key: 'normals',
	    value: function normals() {
	      return this.attributes.normals;
	    }
	  }, {
	    key: 'colors',
	    value: function colors() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$getColor = _ref2.getColor,
	          getColor = _ref2$getColor === undefined ? function (x) {
	        return DEFAULT_COLOR;
	      } : _ref2$getColor;
	
	      var groupedVertices = this.groupedVertices,
	          wireframe = this.wireframe;
	
	      return calculateColors({ groupedVertices: groupedVertices, wireframe: wireframe, getColor: getColor });
	    }
	  }, {
	    key: 'pickingColors',
	    value: function pickingColors() {
	      return this.attributes.pickingColors;
	    }
	
	    // updateTriggers: {
	    //   positions: ['getHeight'],
	    //   colors: ['getColors']
	    //   pickingColors: 'none'
	    // }
	
	  }]);
	
	  return PolygonTesselatorExtruded;
	}();
	
	function countVertices(vertices) {
	  return vertices.reduce(function (vertexCount, polygon) {
	    return vertexCount + (0, _utils.count)(polygon);
	  }, 0);
	}
	
	function calculateIndices(_ref3) {
	  var groupedVertices = _ref3.groupedVertices,
	      _ref3$wireframe = _ref3.wireframe,
	      wireframe = _ref3$wireframe === undefined ? false : _ref3$wireframe;
	
	  // adjust index offset for multiple polygons
	  var multiplier = wireframe ? 2 : 5;
	  var offsets = groupedVertices.reduce(function (acc, vertices) {
	    return [].concat(_toConsumableArray(acc), [acc[acc.length - 1] + countVertices(vertices) * multiplier]);
	  }, [0]);
	
	  var indices = groupedVertices.map(function (vertices, polygonIndex) {
	    return wireframe ?
	    // 1. get sequentially ordered indices of each polygons wireframe
	    // 2. offset them by the number of indices in previous polygons
	    calculateContourIndices(vertices, offsets[polygonIndex]) :
	    // 1. get triangulated indices for the internal areas
	    // 2. offset them by the number of indices in previous polygons
	    calculateSurfaceIndices(vertices, offsets[polygonIndex]);
	  });
	
	  return new Uint32Array((0, _lodash2.default)(indices));
	}
	
	// Calculate a flat position array in JS - can be mapped to 32 or 64 bit typed arrays
	// Remarks:
	// * each top vertex is on 3 surfaces
	// * each bottom vertex is on 2 surfaces
	function calculatePositionsJS(_ref4) {
	  var groupedVertices = _ref4.groupedVertices,
	      _ref4$wireframe = _ref4.wireframe,
	      wireframe = _ref4$wireframe === undefined ? false : _ref4$wireframe;
	
	  var positions = groupedVertices.map(function (vertices) {
	    var topVertices = Array.prototype.concat.apply([], vertices);
	    var baseVertices = topVertices.map(function (v) {
	      return [(0, _utils.get)(v, 0), (0, _utils.get)(v, 1), 0];
	    });
	    return wireframe ? [topVertices, baseVertices] : [topVertices, topVertices, topVertices, baseVertices, baseVertices];
	  });
	
	  return (0, _lodash2.default)(positions);
	}
	
	function calculatePositions(positionsJS, fp64) {
	  var positionLow = void 0;
	  if (fp64) {
	    // We only need x, y component
	    positionLow = new Float32Array(positionsJS.length / 3 * 2);
	    for (var i = 0; i < positionsJS.length / 3; i++) {
	      positionLow[i * 2 + 0] = (0, _fp.fp64ify)(positionsJS[i * 3 + 0])[1];
	      positionLow[i * 2 + 1] = (0, _fp.fp64ify)(positionsJS[i * 3 + 1])[1];
	    }
	  }
	  return { positions: new Float32Array(positionsJS), positions64xyLow: positionLow };
	}
	
	function calculateNormals(_ref5) {
	  var groupedVertices = _ref5.groupedVertices,
	      wireframe = _ref5.wireframe;
	
	  var up = [0, 1, 0];
	
	  var normals = groupedVertices.map(function (vertices, polygonIndex) {
	    var topNormals = new Array(countVertices(vertices)).fill(up);
	    var sideNormals = vertices.map(function (polygon) {
	      return calculateSideNormals(polygon);
	    });
	    var sideNormalsForward = sideNormals.map(function (n) {
	      return n[0];
	    });
	    var sideNormalsBackward = sideNormals.map(function (n) {
	      return n[1];
	    });
	
	    return wireframe ? [topNormals, topNormals] : [topNormals, sideNormalsForward, sideNormalsBackward, sideNormalsForward, sideNormalsBackward];
	  });
	
	  return new Float32Array((0, _lodash2.default)(normals));
	}
	
	function calculateSideNormals(vertices) {
	  var normals = [];
	
	  var lastVertice = null;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = vertices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var vertice = _step.value;
	
	      if (lastVertice) {
	        // vertex[i-1], vertex[i]
	        var n = getNormal(lastVertice, vertice);
	        normals.push(n);
	      }
	      lastVertice = vertice;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return [[].concat(normals, [normals[0]]), [normals[0]].concat(normals)];
	}
	
	function calculateColors(_ref6) {
	  var groupedVertices = _ref6.groupedVertices,
	      getColor = _ref6.getColor,
	      _ref6$wireframe = _ref6.wireframe,
	      wireframe = _ref6$wireframe === undefined ? false : _ref6$wireframe;
	
	  var colors = groupedVertices.map(function (complexPolygon, polygonIndex) {
	    var color = getColor(polygonIndex);
	    color = parseColor(color);
	
	    var numVertices = countVertices(complexPolygon);
	    var topColors = new Array(numVertices).fill(color);
	    var baseColors = new Array(numVertices).fill(color);
	    return wireframe ? [topColors, baseColors] : [topColors, topColors, topColors, baseColors, baseColors];
	  });
	  return new Uint8ClampedArray((0, _lodash2.default)(colors));
	}
	
	function calculatePickingColors(_ref7) {
	  var groupedVertices = _ref7.groupedVertices,
	      _ref7$wireframe = _ref7.wireframe,
	      wireframe = _ref7$wireframe === undefined ? false : _ref7$wireframe;
	
	  var colors = groupedVertices.map(function (vertices, polygonIndex) {
	    var numVertices = countVertices(vertices);
	    var color = getPickingColor(polygonIndex);
	    var topColors = new Array(numVertices).fill(color);
	    var baseColors = new Array(numVertices).fill(color);
	    return wireframe ? [topColors, baseColors] : [topColors, topColors, topColors, baseColors, baseColors];
	  });
	  return new Uint8ClampedArray((0, _lodash2.default)(colors));
	}
	
	function calculateContourIndices(vertices, offset) {
	  var stride = countVertices(vertices);
	
	  return vertices.map(function (polygon) {
	    var indices = [offset];
	    var numVertices = polygon.length;
	
	    // polygon top
	    // use vertex pairs for GL.LINES => [0, 1, 1, 2, 2, ..., n-1, n-1, 0]
	    for (var i = 1; i < numVertices - 1; i++) {
	      indices.push(i + offset, i + offset);
	    }
	    indices.push(offset);
	
	    // polygon sides
	    for (var _i = 0; _i < numVertices - 1; _i++) {
	      indices.push(_i + offset, _i + stride + offset);
	    }
	
	    offset += numVertices;
	    return indices;
	  });
	}
	
	function calculateSurfaceIndices(vertices, offset) {
	  var stride = countVertices(vertices);
	  var quad = [[0, 1], [0, 3], [1, 2], [1, 2], [0, 3], [1, 4]];
	
	  function drawRectangle(i) {
	    return quad.map(function (v) {
	      return i + v[0] + stride * v[1] + offset;
	    });
	  }
	
	  var holes = null;
	
	  if (vertices.length > 1) {
	    holes = vertices.reduce(function (acc, polygon) {
	      return [].concat(_toConsumableArray(acc), [acc[acc.length - 1] + polygon.length]);
	    }, [0]).slice(1, vertices.length);
	  }
	
	  var topIndices = (0, _earcut2.default)((0, _lodash2.default)(vertices), holes, 3).map(function (index) {
	    return index + offset;
	  });
	
	  var sideIndices = vertices.map(function (polygon) {
	    var numVertices = polygon.length;
	    // polygon top
	    var indices = [];
	
	    // polygon sides
	    for (var i = 0; i < numVertices - 1; i++) {
	      indices.push.apply(indices, _toConsumableArray(drawRectangle(i)));
	    }
	
	    offset += numVertices;
	    return indices;
	  });
	
	  return [topIndices, sideIndices];
	}
	
	// helpers
	
	// get normal vector of line segment
	function getNormal(p1, p2) {
	  var p1x = (0, _utils.get)(p1, 0);
	  var p1y = (0, _utils.get)(p1, 1);
	  var p2x = (0, _utils.get)(p2, 0);
	  var p2y = (0, _utils.get)(p2, 1);
	
	  if (p1x === p2x && p1y === p2y) {
	    return [1, 0, 0];
	  }
	
	  var degrees2radians = Math.PI / 180;
	  var lon1 = degrees2radians * p1x;
	  var lon2 = degrees2radians * p2x;
	  var lat1 = degrees2radians * p1y;
	  var lat2 = degrees2radians * p2y;
	  var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
	  var b = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
	  return _glMatrix.vec3.normalize([], [b, 0, -a]);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PolygonTesselator = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Handles tesselation of polygons with holes
	// - 2D surfaces
	// - 2D outlines
	// - 3D surfaces (top and sides only)
	// - 3D wireframes (not yet)
	
	
	exports.flattenVertices2 = flattenVertices2;
	
	var _polygon = __webpack_require__(258);
	
	var Polygon = _interopRequireWildcard(_polygon);
	
	var _earcut = __webpack_require__(184);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	var _utils = __webpack_require__(42);
	
	var _fp = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Maybe deck.gl or luma.gl needs to export this
	function getPickingColor(index) {
	  return [(index + 1) % 256, Math.floor((index + 1) / 256) % 256, Math.floor((index + 1) / 256 / 256) % 256];
	}
	
	function parseColor(color) {
	  if (!Array.isArray(color)) {
	    color = [(0, _utils.get)(color, 0), (0, _utils.get)(color, 1), (0, _utils.get)(color, 2), (0, _utils.get)(color, 3)];
	  }
	  color[3] = Number.isFinite(color[3]) ? color[3] : 255;
	  return color;
	}
	
	var DEFAULT_COLOR = [0, 0, 0, 255]; // Black
	
	// This class is set up to allow querying one attribute at a time
	// the way the AttributeManager expects it
	
	var PolygonTesselator = exports.PolygonTesselator = function () {
	  function PolygonTesselator(_ref) {
	    var polygons = _ref.polygons,
	        _ref$fp = _ref.fp64,
	        fp64 = _ref$fp === undefined ? false : _ref$fp;
	
	    _classCallCheck(this, PolygonTesselator);
	
	    // Normalize all polygons
	    this.polygons = polygons.map(function (polygon) {
	      return Polygon.normalize(polygon);
	    });
	    // Count all polygon vertices
	    this.pointCount = getPointCount(this.polygons);
	    this.fp64 = fp64;
	  }
	
	  _createClass(PolygonTesselator, [{
	    key: 'indices',
	    value: function indices() {
	      var polygons = this.polygons,
	          indexCount = this.indexCount;
	
	      return calculateIndices({ polygons: polygons, indexCount: indexCount });
	    }
	  }, {
	    key: 'positions',
	    value: function positions() {
	      var polygons = this.polygons,
	          pointCount = this.pointCount;
	
	      return calculatePositions({ polygons: polygons, pointCount: pointCount, fp64: this.fp64 });
	    }
	  }, {
	    key: 'normals',
	    value: function normals() {
	      var polygons = this.polygons,
	          pointCount = this.pointCount;
	
	      return calculateNormals({ polygons: polygons, pointCount: pointCount });
	    }
	  }, {
	    key: 'colors',
	    value: function colors() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$getColor = _ref2.getColor,
	          getColor = _ref2$getColor === undefined ? function (x) {
	        return DEFAULT_COLOR;
	      } : _ref2$getColor;
	
	      var polygons = this.polygons,
	          pointCount = this.pointCount;
	
	      return calculateColors({ polygons: polygons, pointCount: pointCount, getColor: getColor });
	    }
	  }, {
	    key: 'pickingColors',
	    value: function pickingColors() {
	      var polygons = this.polygons,
	          pointCount = this.pointCount;
	
	      return calculatePickingColors({ polygons: polygons, pointCount: pointCount });
	    }
	
	    // getAttribute({size, accessor}) {
	    //   const {polygons, pointCount} = this;
	    //   return calculateAttribute({polygons, pointCount, size, accessor});
	    // }
	
	  }]);
	
	  return PolygonTesselator;
	}();
	
	// Count number of points in a list of complex polygons
	
	
	function getPointCount(polygons) {
	  return polygons.reduce(function (points, polygon) {
	    return points + Polygon.getVertexCount(polygon);
	  }, 0);
	}
	
	// COunt number of triangles in a list of complex polygons
	function getTriangleCount(polygons) {
	  return polygons.reduce(function (triangles, polygon) {
	    return triangles + Polygon.getTriangleCount(polygon);
	  }, 0);
	}
	
	// Returns the offsets of each complex polygon in the combined array of all polygons
	function getPolygonOffsets(polygons) {
	  var offsets = new Array((0, _utils.count)(polygons) + 1);
	  offsets[0] = 0;
	  var offset = 0;
	  polygons.forEach(function (polygon, i) {
	    offset += Polygon.getVertexCount(polygon);
	    offsets[i + 1] = offset;
	  });
	  return offsets;
	}
	
	// Returns the offset of each hole polygon in the flattened array for that polygon
	function getHoleIndices(complexPolygon) {
	  var holeIndices = null;
	  if ((0, _utils.count)(complexPolygon) > 1) {
	    var polygonStartIndex = 0;
	    holeIndices = [];
	    complexPolygon.forEach(function (polygon) {
	      polygonStartIndex += (0, _utils.count)(polygon);
	      holeIndices.push(polygonStartIndex);
	    });
	    // Last element points to end of the flat array, remove it
	    holeIndices.pop();
	  }
	  return holeIndices;
	}
	
	function calculateIndices(_ref3) {
	  var polygons = _ref3.polygons,
	      _ref3$IndexType = _ref3.IndexType,
	      IndexType = _ref3$IndexType === undefined ? Uint32Array : _ref3$IndexType;
	
	  // Calculate length of index array (3 * number of triangles)
	  var indexCount = 3 * getTriangleCount(polygons);
	  var offsets = getPolygonOffsets(polygons);
	
	  // Allocate the attribute
	  // TODO it's not the index count but the vertex count that must be checked
	  if (IndexType === Uint16Array && indexCount > 65535) {
	    throw new Error('Vertex count exceeds browser\'s limit');
	  }
	  var attribute = new IndexType(indexCount);
	
	  // 1. get triangulated indices for the internal areas
	  // 2. offset them by the number of indices in previous polygons
	  var i = 0;
	  polygons.forEach(function (polygon, polygonIndex) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = calculateSurfaceIndices(polygon)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var index = _step.value;
	
	        attribute[i++] = index + offsets[polygonIndex];
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  });
	
	  return attribute;
	}
	
	/*
	 * Get vertex indices for drawing complexPolygon mesh
	 * @private
	 * @param {[Number,Number,Number][][]} complexPolygon
	 * @returns {[Number]} indices
	 */
	function calculateSurfaceIndices(complexPolygon) {
	  // Prepare an array of hole indices as expected by earcut
	  var holeIndices = getHoleIndices(complexPolygon);
	  // Flatten the polygon as expected by earcut
	  var verts = flattenVertices2(complexPolygon);
	  // Let earcut triangulate the polygon
	  return (0, _earcut2.default)(verts, holeIndices, 3);
	}
	
	// TODO - refactor
	function isContainer(value) {
	  return Array.isArray(value) || ArrayBuffer.isView(value) || value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	
	// TODO - refactor, this file should not need a separate flatten func
	// Flattens nested array of vertices, padding third coordinate as needed
	function flattenVertices2(nestedArray) {
	  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref4$result = _ref4.result,
	      result = _ref4$result === undefined ? [] : _ref4$result,
	      _ref4$dimensions = _ref4.dimensions,
	      dimensions = _ref4$dimensions === undefined ? 3 : _ref4$dimensions;
	
	  var index = -1;
	  var vertexLength = 0;
	  var length = (0, _utils.count)(nestedArray);
	  while (++index < length) {
	    var value = (0, _utils.get)(nestedArray, index);
	    if (isContainer(value)) {
	      (0, _utils.flattenVertices)(value, { result: result, dimensions: dimensions });
	    } else {
	      if (vertexLength < dimensions) {
	        // eslint-disable-line
	        result.push(value);
	        vertexLength++;
	      }
	    }
	  }
	  // Add a third coordinate if needed
	  if (vertexLength > 0 && vertexLength < dimensions) {
	    result.push(0);
	  }
	  return result;
	}
	
	function calculatePositions(_ref5) {
	  var polygons = _ref5.polygons,
	      pointCount = _ref5.pointCount,
	      fp64 = _ref5.fp64;
	
	  // Flatten out all the vertices of all the sub subPolygons
	  var attribute = new Float32Array(pointCount * 3);
	  var attributeLow = void 0;
	  if (fp64) {
	    // We only need x, y component
	    attributeLow = new Float32Array(pointCount * 2);
	  }
	  var i = 0;
	  var j = 0;
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = polygons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var polygon = _step2.value;
	
	      Polygon.forEachVertex(polygon, function (vertex) {
	        // eslint-disable-line
	        var x = (0, _utils.get)(vertex, 0);
	        var y = (0, _utils.get)(vertex, 1);
	        var z = (0, _utils.get)(vertex, 2) || 0;
	        attribute[i++] = x;
	        attribute[i++] = y;
	        attribute[i++] = z;
	        if (fp64) {
	          attributeLow[j++] = (0, _fp.fp64ify)(x)[1];
	          attributeLow[j++] = (0, _fp.fp64ify)(y)[1];
	        }
	      });
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return { positions: attribute, positions64xyLow: attributeLow };
	}
	
	function calculateNormals(_ref6) {
	  var polygons = _ref6.polygons,
	      pointCount = _ref6.pointCount;
	
	  // TODO - use generic vertex attribute?
	  var attribute = new Float32Array(pointCount * 3);
	  (0, _utils.fillArray)({ target: attribute, source: [0, 1, 0], start: 0, pointCount: pointCount });
	  return attribute;
	}
	
	function calculateColors(_ref7) {
	  var polygons = _ref7.polygons,
	      pointCount = _ref7.pointCount,
	      getColor = _ref7.getColor;
	
	  var attribute = new Uint8ClampedArray(pointCount * 4);
	  var i = 0;
	  polygons.forEach(function (complexPolygon, polygonIndex) {
	    // Calculate polygon color
	    var color = getColor(polygonIndex);
	    color = parseColor(color);
	
	    var vertexCount = Polygon.getVertexCount(complexPolygon);
	    (0, _utils.fillArray)({ target: attribute, source: color, start: i, count: vertexCount });
	    i += color.length * vertexCount;
	  });
	  return attribute;
	}
	
	function calculatePickingColors(_ref8) {
	  var polygons = _ref8.polygons,
	      pointCount = _ref8.pointCount;
	
	  var attribute = new Uint8ClampedArray(pointCount * 3);
	  var i = 0;
	  polygons.forEach(function (complexPolygon, polygonIndex) {
	    var color = getPickingColor(polygonIndex);
	    var vertexCount = Polygon.getVertexCount(complexPolygon);
	    (0, _utils.fillArray)({ target: attribute, source: color, start: i, count: vertexCount });
	    i += color.length * vertexCount;
	  });
	  return attribute;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 814 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME polygon-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\n// PICKING\n// uniform bool pickingEnabled;\nvarying vec4 vPickingColor;\nvec4 picking_getColor() {\n  return vPickingColor;\n}\n// PICKING\n\nvoid main(void) {\n  gl_FragColor = picking_getColor();\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 815 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME polygon-layer-vertex-shader\n\nattribute vec3 positions;\nattribute vec2 positions64xyLow;\nattribute vec3 normals;\nattribute vec4 colors;\nattribute vec3 pickingColors;\n\nuniform float extruded;\nuniform float opacity;\n\nuniform float renderPickingBuffer;\nuniform vec3 selectedPickingColor;\n\n// PICKING\nuniform float pickingEnabled;\nvarying vec4 vPickingColor;\n\nvoid main(void) {\n  vec4 positions64xy = vec4(positions.x, positions64xyLow.x, positions.y, positions64xyLow.y);\n\n  vec2 projected_coord_xy[2];\n  project_position_fp64(positions64xy, projected_coord_xy);\n\n  vec2 vertex_pos_modelspace[4];\n  vertex_pos_modelspace[0] = projected_coord_xy[0];\n  vertex_pos_modelspace[1] = projected_coord_xy[1];\n  vertex_pos_modelspace[2] = vec2(project_scale(positions.z), 0.0);\n  vertex_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  gl_Position = project_to_clipspace_fp64(vertex_pos_modelspace);\n\n  vec4 position_worldspace = vec4(\n    vertex_pos_modelspace[0].x, vertex_pos_modelspace[1].x,\n    vertex_pos_modelspace[2].x, vertex_pos_modelspace[3].x);\n\n  if (pickingEnabled < 0.5) {\n    float lightWeight = 1.0;\n\n    if (extruded > 0.5) {\n      lightWeight = getLightWeight(\n        position_worldspace,\n        normals\n      );\n    }\n\n    vec3 lightWeightedColor = lightWeight * colors.rgb;\n    vec4 color = vec4(lightWeightedColor, colors.a * opacity) / 255.0;\n\n    vPickingColor = color;\n\n  } else {\n    vPickingColor = vec4(pickingColors.rgb / 255.0, 1.0);\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 816 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME polygon-layer-vertex-shader\n\nattribute vec3 positions;\nattribute vec3 normals;\nattribute vec4 colors;\nattribute vec3 pickingColors;\n\nuniform float extruded;\nuniform float opacity;\n\nuniform float renderPickingBuffer;\nuniform vec3 selectedPickingColor;\n\n// PICKING\nuniform float pickingEnabled;\nvarying vec4 vPickingColor;\n\nvoid main(void) {\n  vec4 position_worldspace = vec4(project_position(positions), 1.0);\n  gl_Position = project_to_clipspace(position_worldspace);\n\n  if (pickingEnabled < 0.5) {\n    float lightWeight = 1.0;\n\n    if (extruded > 0.5) {\n      lightWeight = getLightWeight(\n        position_worldspace,\n        normals\n      );\n    }\n\n    vec3 lightWeightedColor = lightWeight * colors.rgb;\n    vec4 color = vec4(lightWeightedColor, colors.a * opacity) / 255.0;\n\n    vPickingColor = color;\n\n  } else {\n    vPickingColor = vec4(pickingColors.rgb / 255.0, 1.0);\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _choroplethLayer = __webpack_require__(390);
	
	var _choroplethLayer2 = _interopRequireDefault(_choroplethLayer);
	
	var _utils = __webpack_require__(42);
	
	var _lodash = __webpack_require__(407);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _choroplethLayerVertex = __webpack_require__(818);
	
	var _choroplethLayerVertex2 = _interopRequireDefault(_choroplethLayerVertex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var ChoroplethLayer64 = function (_ChoroplethLayer) {
	  _inherits(ChoroplethLayer64, _ChoroplethLayer);
	
	  function ChoroplethLayer64(props) {
	    _classCallCheck(this, ChoroplethLayer64);
	
	    var _this = _possibleConstructorReturn(this, (ChoroplethLayer64.__proto__ || Object.getPrototypeOf(ChoroplethLayer64)).call(this, props));
	
	    _utils.log.once('ChoroplethLayer64 is deprecated. Consider using GeoJsonLayer instead');
	    return _this;
	  }
	
	  _createClass(ChoroplethLayer64, [{
	    key: 'initializeState',
	    value: function initializeState() {
	      _get(ChoroplethLayer64.prototype.__proto__ || Object.getPrototypeOf(ChoroplethLayer64.prototype), 'initializeState', this).call(this);
	
	      this.state.attributeManager.add({
	        positions64: { size: 4, update: this.calculatePositions64 },
	        heights64: { size: 2, update: this.calculateHeights64 }
	      });
	    }
	  }, {
	    key: 'getShaders',
	    value: function getShaders() {
	      return {
	        vs: _choroplethLayerVertex2.default,
	        fs: _get(ChoroplethLayer64.prototype.__proto__ || Object.getPrototypeOf(ChoroplethLayer64.prototype), 'getShaders', this).call(this).fs,
	        fp64: true,
	        project64: true
	      };
	    }
	  }, {
	    key: 'calculatePositions64',
	    value: function calculatePositions64(attribute) {
	      var vertices = (0, _lodash2.default)(this.state.choropleths);
	      attribute.value = new Float32Array(vertices.length / 3 * 4);
	      for (var index = 0; index < vertices.length / 3; index++) {
	        var _fp64ify = (0, _utils.fp64ify)(vertices[index * 3]);
	
	        var _fp64ify2 = _slicedToArray(_fp64ify, 2);
	
	        attribute.value[index * 4] = _fp64ify2[0];
	        attribute.value[index * 4 + 1] = _fp64ify2[1];
	
	        var _fp64ify3 = (0, _utils.fp64ify)(vertices[index * 3 + 1]);
	
	        var _fp64ify4 = _slicedToArray(_fp64ify3, 2);
	
	        attribute.value[index * 4 + 2] = _fp64ify4[0];
	        attribute.value[index * 4 + 3] = _fp64ify4[1];
	      }
	    }
	  }, {
	    key: 'calculateHeights64',
	    value: function calculateHeights64(attribute) {
	      var vertices = (0, _lodash2.default)(this.state.choropleths);
	      attribute.value = new Float32Array(vertices.length / 3 * 2);
	      for (var index = 0; index < vertices.length / 3; index++) {
	        var _fp64ify5 = (0, _utils.fp64ify)(vertices[index * 3 + 2]);
	
	        var _fp64ify6 = _slicedToArray(_fp64ify5, 2);
	
	        attribute.value[index * 2] = _fp64ify6[0];
	        attribute.value[index * 2 + 1] = _fp64ify6[1];
	      }
	    }
	  }]);
	
	  return ChoroplethLayer64;
	}(_choroplethLayer2.default);
	
	exports.default = ChoroplethLayer64;
	
	
	ChoroplethLayer64.layerName = 'ChoroplethLayer64';
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 818 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME choropleth-layer-vertex-64-shader\n\nattribute vec4 positions64;\nattribute vec2 heights64;\nattribute vec4 colors;\nattribute vec3 pickingColors;\n\nuniform float opacity;\nuniform float renderPickingBuffer;\nuniform vec3 selectedPickingColor;\n\nuniform float pickingEnabled;\nvarying vec4 vPickingColor;\nvoid picking_setPickColor(vec3 pickingColor) {\n  vPickingColor = vec4(pickingColor,  1.);\n}\nvec4 picking_setNormalAndPickColors(vec4 color, vec3 pickingColor) {\n  vec4 pickingColor4 = vec4(pickingColor.rgb, 1.);\n  vPickingColor = mix(color, pickingColor4, pickingEnabled);\n  return vPickingColor;\n}\n\nvoid main(void) {\n  // For some reason, need to add one to elevation to show up in untilted mode\n  vec2 projectedCoord[2];\n  project_position_fp64(positions64, projectedCoord);\n\n  vec2 vertex_pos_modelspace[4];\n\n  vertex_pos_modelspace[0] = projectedCoord[0];\n  vertex_pos_modelspace[1] = projectedCoord[1];\n  vertex_pos_modelspace[2] = heights64;\n  vertex_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  gl_Position = project_to_clipspace_fp64(vertex_pos_modelspace);\n\n  vec4 color = vec4(colors.rgb, colors.a * opacity) / 255.;\n\n  picking_setNormalAndPickColors(\n    color,\n    pickingColors / 255.\n  );\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 819 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME choropleth-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\n// PICKING\n// uniform bool pickingEnabled;\nvarying vec4 vPickingColor;\nvec4 picking_getColor() {\n  return vPickingColor;\n}\n// PICKING\n\nvoid main(void) {\n  gl_FragColor = picking_getColor();\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 820 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME choropleth-layer-vertex-shader\n\nattribute vec3 positions;\nattribute vec4 colors;\nattribute vec3 pickingColors;\n\nuniform float opacity;\nuniform float renderPickingBuffer;\nuniform vec3 selectedPickingColor;\n\n// PICKING\nuniform float pickingEnabled;\nvarying vec4 vPickingColor;\nvoid picking_setPickColor(vec3 pickingColor) {\n  vPickingColor = vec4(pickingColor,  1.);\n}\nvec4 picking_setNormalAndPickColors(vec4 color, vec3 pickingColor) {\n  vec4 pickingColor4 = vec4(pickingColor.rgb, 1.);\n  vPickingColor = mix(color, pickingColor4, pickingEnabled);\n  return vPickingColor;\n}\n\n// PICKING\n// vec4 getColor(vec4 color, float opacity, vec3 pickingColor, float renderPickingBuffer) {\n//   vec4 color4 = vec4(color.xyz / 255., color.w / 255. * opacity);\n//   vec4 pickingColor4 = vec4(pickingColor / 255., 1.);\n//   return mix(color4, pickingColor4, renderPickingBuffer);\n// }\n\nvoid main(void) {\n\n  vec4 color = vec4(colors.rgb, colors.a * opacity) / 255.;\n\n  picking_setNormalAndPickColors(\n    color,\n    pickingColors / 255.\n  );\n\n  vec3 p = project_position(positions);\n  gl_Position = project_to_clipspace(vec4(p, 1.));\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGeojsonFeatures = getGeojsonFeatures;
	exports.featureToPolygons = featureToPolygons;
	exports.extractPolygons = extractPolygons;
	exports.normalizeGeojson = normalizeGeojson;
	
	var _utils = __webpack_require__(42);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	/**
	 * "Normalizes" complete or partial GeoJSON data into iterable list of features
	 * Can accept GeoJSON geometry or "Feature", "FeatureCollection" in addition
	 * to plain arrays and iterables.
	 * Works by extracting the feature array or wrapping single objects in an array,
	 * so that subsequent code can simply iterate over features.
	 *
	 * @param {object} geojson - geojson data
	 * @param {Object|Array} data - geojson object (FeatureCollection, Feature or
	 *  Geometry) or array of features
	 * @return {Array|"iteratable"} - iterable list of features
	 */
	function getGeojsonFeatures(geojson) {
	  // If array, assume this is a list of features
	  if (Array.isArray(geojson)) {
	    return geojson;
	  }
	
	  var type = (0, _utils.get)(geojson, 'type');
	  switch (type) {
	    case 'Point':
	    case 'MultiPoint':
	    case 'LineString':
	    case 'MultiLineString':
	    case 'Polygon':
	    case 'MultiPolygon':
	    case 'GeometryCollection':
	      // Wrap the geometry object in a 'Feature' object and wrap in an array
	      return [{ type: 'Feature', properties: {}, geometry: geojson }];
	    case 'Feature':
	      // Wrap the feature in a 'Features' array
	      return [geojson];
	    case 'FeatureCollection':
	      // Just return the 'Features' array from the collection
	      return (0, _utils.get)(geojson, 'features');
	    default:
	      throw new Error('Unknown geojson type');
	  }
	}
	
	/*
	 * converts a GeoJSON "Feature" object to a list of GeoJSON polygon-style coordinates
	 * @param {Object | Array} data - geojson object or array of feature
	 * @returns {[Number,Number,Number][][][]} array of choropleths
	 */
	function featureToPolygons(feature) {
	  var geometry = (0, _utils.get)(feature, 'geometry');
	  // If no geometry field, assume that "feature" is the polygon list
	  if (geometry === undefined) {
	    return feature;
	  }
	
	  var type = (0, _utils.get)(geometry, 'type');
	  var coordinates = (0, _utils.get)(geometry, 'coordinates');
	
	  var polygons = void 0;
	  switch (type) {
	    case 'MultiPolygon':
	      polygons = coordinates;
	      break;
	    case 'Polygon':
	      polygons = [coordinates];
	      break;
	    case 'LineString':
	      // TODO - should lines really be handled in this switch?
	      polygons = [[coordinates]];
	      break;
	    case 'MultiLineString':
	      // TODO - should lines really be handled in this switch?
	      polygons = coordinates.map(function (coords) {
	        return [coords];
	      });
	      break;
	    default:
	      polygons = [];
	  }
	  return polygons;
	}
	
	// DEPRECATED - USED BY OLD CHOROPLETH LAYERS
	
	/*
	 * converts list of features from a GeoJSON object to a list of GeoJSON
	 * polygon-style coordinates
	 * @param {Object} data - geojson object
	 * @returns {[Number,Number,Number][][][]} array of choropleths
	 */
	function extractPolygons(data) {
	  var normalizedGeojson = normalizeGeojson(data);
	  var features = (0, _utils.get)(normalizedGeojson, 'features');
	
	  var result = [];
	  features.forEach(function (feature, featureIndex) {
	    var choropleths = featureToPolygons(feature);
	
	    /* eslint-disable max-nested-callbacks */
	    choropleths = choropleths.map(function (choropleth) {
	      return choropleth.map(function (polygon) {
	        return polygon.map(function (coord) {
	          return [(0, _utils.get)(coord, 0), (0, _utils.get)(coord, 1), (0, _utils.get)(coord, 2) || 0];
	        });
	      });
	    });
	    /* eslint-enable max-nested-callbacks */
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = choropleths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var choropleth = _step.value;
	
	        choropleth.featureIndex = featureIndex;
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    result.push.apply(result, _toConsumableArray(choropleths));
	  });
	  return result;
	}
	
	/**
	 * "Normalizes" a GeoJSON geometry or "Feature" into a "FeatureCollection",
	 * by wrapping it in an extra object/array.
	 *
	 * @param {object} geojson - geojson data
	 * @return {object} - normalized geojson data
	 */
	function normalizeGeojson(geojson) {
	  var type = (0, _utils.get)(geojson, 'type');
	  switch (type) {
	    case 'Point':
	    case 'MultiPoint':
	    case 'LineString':
	    case 'MultiLineString':
	    case 'Polygon':
	    case 'MultiPolygon':
	    case 'GeometryCollection':
	      // Wrap the geometry object in a "Feature" and add the feature to a "FeatureCollection"
	      return {
	        type: 'FeatureCollection',
	        features: [{ type: 'Feature', properties: {}, geometry: geojson }]
	      };
	    case 'Feature':
	      // Add the feature to a "FeatureCollection"
	      return {
	        type: 'FeatureCollection',
	        features: [geojson]
	      };
	    case 'FeatureCollection':
	      // Just return the feature collection
	      return geojson;
	    default:
	      throw new Error('Unknown geojson type');
	  }
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lib = __webpack_require__(35);
	
	var _shaderUtils = __webpack_require__(49);
	
	var _fp = __webpack_require__(54);
	
	var _luma = __webpack_require__(29);
	
	var _utils = __webpack_require__(42);
	
	var _earcut = __webpack_require__(184);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	var _glMatrix = __webpack_require__(55);
	
	var _extrudedChoroplethLayerVertex = __webpack_require__(824);
	
	var _extrudedChoroplethLayerVertex2 = _interopRequireDefault(_extrudedChoroplethLayerVertex);
	
	var _extrudedChoroplethLayerFragment = __webpack_require__(823);
	
	var _extrudedChoroplethLayerFragment2 = _interopRequireDefault(_extrudedChoroplethLayerFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEFAULT_COLOR = [180, 180, 200, 255];
	var DEFAULT_AMBIENT_COLOR = [255, 255, 255];
	var DEFAULT_POINTLIGHT_AMBIENT_COEFFICIENT = 0.1;
	var DEFAULT_POINTLIGHT_LOCATION = [40.4406, -79.9959, 100];
	var DEFAULT_POINTLIGHT_COLOR = [255, 255, 255];
	var DEFAULT_POINTLIGHT_ATTENUATION = 1.0;
	var DEFAULT_MATERIAL_SPECULAR_COLOR = [255, 255, 255];
	var DEFAULT_MATERIAL_SHININESS = 1;
	
	var defaultProps = {
	  opacity: 1,
	  elevation: 1
	};
	
	var ExtrudedChoroplethLayer64 = function (_Layer) {
	  _inherits(ExtrudedChoroplethLayer64, _Layer);
	
	  function ExtrudedChoroplethLayer64(props) {
	    _classCallCheck(this, ExtrudedChoroplethLayer64);
	
	    var _this = _possibleConstructorReturn(this, (ExtrudedChoroplethLayer64.__proto__ || Object.getPrototypeOf(ExtrudedChoroplethLayer64)).call(this, props));
	
	    _utils.log.once('ExtrudedChoroplethLayer64 is deprecated. Consider using GeoJsonLayer instead');
	    return _this;
	  }
	
	  _createClass(ExtrudedChoroplethLayer64, [{
	    key: 'initializeState',
	    value: function initializeState() {
	      var attributeManager = this.state.attributeManager;
	
	      attributeManager.add({
	        indices: { size: 1, isIndexed: true, update: this.calculateIndices },
	        positions: { size: 4, update: this.calculatePositions },
	        heights: { size: 2, update: this.calculateHeights },
	        normals: { size: 3, update: this.calculateNormals },
	        colors: { size: 4, update: this.calculateColors }
	      });
	
	      var gl = this.context.gl;
	
	      this.setState({
	        numInstances: 0,
	        model: this.getModel(gl)
	      });
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(_ref) {
	      var changeFlags = _ref.changeFlags;
	      var attributeManager = this.state.attributeManager;
	
	      if (changeFlags.dataChanged) {
	        this.extractExtrudedChoropleth();
	        attributeManager.invalidateAll();
	      }
	
	      var _props = this.props,
	          elevation = _props.elevation,
	          ambientColor = _props.ambientColor,
	          pointLightColor = _props.pointLightColor,
	          pointLightLocation = _props.pointLightLocation,
	          pointLightAmbientCoefficient = _props.pointLightAmbientCoefficient,
	          pointLightAttenuation = _props.pointLightAttenuation,
	          materialSpecularColor = _props.materialSpecularColor,
	          materialShininess = _props.materialShininess;
	
	
	      this.setUniforms({
	        elevation: Number.isFinite(elevation) ? elevation : 1,
	        uAmbientColor: ambientColor || DEFAULT_AMBIENT_COLOR,
	        uPointLightAmbientCoefficient: pointLightAmbientCoefficient || DEFAULT_POINTLIGHT_AMBIENT_COEFFICIENT,
	        uPointLightLocation: pointLightLocation || DEFAULT_POINTLIGHT_LOCATION,
	        uPointLightColor: pointLightColor || DEFAULT_POINTLIGHT_COLOR,
	        uPointLightAttenuation: pointLightAttenuation || DEFAULT_POINTLIGHT_ATTENUATION,
	        uMaterialSpecularColor: materialSpecularColor || DEFAULT_MATERIAL_SPECULAR_COLOR,
	        uMaterialShininess: materialShininess || DEFAULT_MATERIAL_SHININESS
	      });
	    }
	  }, {
	    key: 'draw',
	    value: function draw(_ref2) {
	      var uniforms = _ref2.uniforms;
	
	      this.state.model.render(uniforms);
	    }
	  }, {
	    key: 'getPickingInfo',
	    value: function getPickingInfo(opts) {
	      var info = _get(ExtrudedChoroplethLayer64.prototype.__proto__ || Object.getPrototypeOf(ExtrudedChoroplethLayer64.prototype), 'getPickingInfo', this).call(this, opts);
	      var index = this.decodePickingColor(info.color);
	      var feature = index >= 0 ? this.props.data.features[index] : null;
	      info.feature = feature;
	      info.object = feature;
	      return info;
	    }
	  }, {
	    key: 'getShaders',
	    value: function getShaders() {
	      return {
	        vs: _extrudedChoroplethLayerVertex2.default,
	        fs: _extrudedChoroplethLayerFragment2.default,
	        fp64: true,
	        project64: true
	      };
	    }
	  }, {
	    key: 'getModel',
	    value: function getModel(gl) {
	      // Make sure we have 32 bit support
	      // TODO - this could be done automatically by luma in "draw"
	      // when it detects 32 bit indices
	      if (!gl.getExtension('OES_element_index_uint')) {
	        throw new Error('Extruded choropleth layer needs 32 bit indices');
	      }
	
	      // Buildings are 3d so depth test should be enabled
	      // TODO - it is a little heavy handed to have a layer set this
	      // Alternatively, check depth test and warn if not set, or add a prop
	      // setDepthTest that is on by default.
	      gl.enable(_luma.GL.DEPTH_TEST);
	      gl.depthFunc(_luma.GL.LEQUAL);
	
	      var shaders = (0, _shaderUtils.assembleShaders)(gl, this.getShaders());
	
	      return new _luma.Model({
	        gl: gl,
	        id: this.props.id,
	        vs: shaders.vs,
	        fs: shaders.fs,
	        geometry: new _luma.Geometry({
	          drawMode: this.props.drawWireframe ? _luma.GL.LINES : _luma.GL.TRIANGLES
	        }),
	        vertexCount: 0,
	        isIndexed: true
	      });
	    }
	
	    // each top vertex is on 3 surfaces
	    // each bottom vertex is on 2 surfaces
	
	  }, {
	    key: 'calculatePositions',
	    value: function calculatePositions(attribute) {
	      var _this2 = this;
	
	      var positions = this.state.positions;
	
	      if (!positions) {
	        positions = (0, _utils.flatten)(this.state.groupedVertices.map(function (vertices) {
	          var topVertices = Array.prototype.concat.apply([], vertices);
	          var baseVertices = topVertices.map(function (v) {
	            return [v[0], v[1], 0];
	          });
	          return _this2.props.drawWireframe ? [topVertices, baseVertices] : [topVertices, topVertices, topVertices, baseVertices, baseVertices];
	        }));
	      }
	
	      attribute.value = new Float32Array(positions.length / 3 * 4);
	
	      for (var i = 0; i < positions.length / 3; i++) {
	        var _fp64ify = (0, _fp.fp64ify)(positions[i * 3 + 0]);
	
	        var _fp64ify2 = _slicedToArray(_fp64ify, 2);
	
	        attribute.value[i * 4 + 0] = _fp64ify2[0];
	        attribute.value[i * 4 + 1] = _fp64ify2[1];
	
	        var _fp64ify3 = (0, _fp.fp64ify)(positions[i * 3 + 1]);
	
	        var _fp64ify4 = _slicedToArray(_fp64ify3, 2);
	
	        attribute.value[i * 4 + 2] = _fp64ify4[0];
	        attribute.value[i * 4 + 3] = _fp64ify4[1];
	      }
	    }
	  }, {
	    key: 'calculateHeights',
	    value: function calculateHeights(attribute) {
	      var _this3 = this;
	
	      var positions = this.state.positions;
	
	      if (!positions) {
	        positions = (0, _utils.flatten)(this.state.groupedVertices.map(function (vertices) {
	          var topVertices = Array.prototype.concat.apply([], vertices);
	          var baseVertices = topVertices.map(function (v) {
	            return [v[0], v[1], 0];
	          });
	          return _this3.props.drawWireframe ? [topVertices, baseVertices] : [topVertices, topVertices, topVertices, baseVertices, baseVertices];
	        }));
	      }
	
	      attribute.value = new Float32Array(positions.length / 3 * 2);
	      for (var i = 0; i < positions.length / 3; i++) {
	        var _fp64ify5 = (0, _fp.fp64ify)(positions[i * 3 + 2] + 0.1);
	
	        var _fp64ify6 = _slicedToArray(_fp64ify5, 2);
	
	        attribute.value[i * 2 + 0] = _fp64ify6[0];
	        attribute.value[i * 2 + 1] = _fp64ify6[1];
	      }
	    }
	  }, {
	    key: 'calculateNormals',
	    value: function calculateNormals(attribute) {
	      var _this4 = this;
	
	      var up = [0, 1, 0];
	
	      var normals = this.state.groupedVertices.map(function (vertices, buildingIndex) {
	        var topNormals = new Array(countVertices(vertices)).fill(up);
	        var sideNormals = vertices.map(function (polygon) {
	          return _this4.calculateSideNormals(polygon);
	        });
	        var sideNormalsForward = sideNormals.map(function (n) {
	          return n[0];
	        });
	        var sideNormalsBackward = sideNormals.map(function (n) {
	          return n[1];
	        });
	
	        return _this4.props.drawWireframe ? [topNormals, topNormals] : [topNormals, sideNormalsForward, sideNormalsBackward, sideNormalsForward, sideNormalsBackward];
	      });
	
	      attribute.value = new Float32Array((0, _utils.flatten)(normals));
	    }
	  }, {
	    key: 'calculateSideNormals',
	    value: function calculateSideNormals(vertices) {
	      var numVertices = vertices.length;
	      var normals = [];
	
	      for (var i = 0; i < numVertices - 1; i++) {
	        var n = getNormal(vertices[i], vertices[i + 1]);
	        normals.push(n);
	      }
	
	      return [[].concat(normals, [normals[0]]), [normals[0]].concat(normals)];
	    }
	  }, {
	    key: 'calculateIndices',
	    value: function calculateIndices(attribute) {
	      var _this5 = this;
	
	      // adjust index offset for multiple buildings
	      var multiplier = this.props.drawWireframe ? 2 : 5;
	      var offsets = this.state.groupedVertices.reduce(function (acc, vertices) {
	        return [].concat(_toConsumableArray(acc), [acc[acc.length - 1] + countVertices(vertices) * multiplier]);
	      }, [0]);
	
	      var indices = this.state.groupedVertices.map(function (vertices, buildingIndex) {
	        return _this5.props.drawWireframe ?
	        // 1. get sequentially ordered indices of each building wireframe
	        // 2. offset them by the number of indices in previous buildings
	        _this5.calculateContourIndices(vertices, offsets[buildingIndex]) :
	        // 1. get triangulated indices for the internal areas
	        // 2. offset them by the number of indices in previous buildings
	        _this5.calculateSurfaceIndices(vertices, offsets[buildingIndex]);
	      });
	
	      attribute.value = new Uint32Array((0, _utils.flatten)(indices));
	      attribute.target = _luma.GL.ELEMENT_ARRAY_BUFFER;
	      this.state.model.setVertexCount(attribute.value.length / attribute.size);
	    }
	  }, {
	    key: 'calculateColors',
	    value: function calculateColors(attribute) {
	      var _this6 = this;
	
	      var colors = this.state.groupedVertices.map(function (vertices, buildingIndex) {
	        var color = _this6.props.color;
	
	        var baseColor = color || DEFAULT_COLOR;
	        var topColor = color || DEFAULT_COLOR;
	        var numVertices = countVertices(vertices);
	
	        var topColors = new Array(numVertices).fill(topColor);
	        var baseColors = new Array(numVertices).fill(baseColor);
	        return _this6.props.drawWireframe ? [topColors, baseColors] : [topColors, topColors, topColors, baseColors, baseColors];
	      });
	      attribute.value = new Float32Array((0, _utils.flatten)(colors));
	    }
	  }, {
	    key: 'extractExtrudedChoropleth',
	    value: function extractExtrudedChoropleth() {
	      var _this7 = this;
	
	      var data = this.props.data;
	      // Generate a flat list of buildings
	
	      this.state.buildings = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var _state$buildings;
	
	          var building = _step.value;
	          var properties = building.properties,
	              geometry = building.geometry;
	          var coordinates = geometry.coordinates,
	              type = geometry.type;
	
	          if (!properties.height) {
	            properties.height = Math.random() * 1000;
	          }
	          switch (type) {
	            case 'MultiPolygon':
	              // Maps to multiple buildings
	              var buildings = coordinates.map(function (coords) {
	                return { coordinates: coords, properties: properties };
	              });
	              (_state$buildings = _this7.state.buildings).push.apply(_state$buildings, _toConsumableArray(buildings));
	              break;
	            case 'Polygon':
	              // Maps to a single building
	              _this7.state.buildings.push({ coordinates: coordinates, properties: properties });
	              break;
	            default:
	            // We are ignoring Points for now
	          }
	        };
	
	        for (var _iterator = data.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        }
	
	        // Generate vertices for the building list
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.state.groupedVertices = this.state.buildings.map(function (building) {
	        return building.coordinates.map(function (polygon) {
	          return polygon.map(function (coordinate) {
	            return [coordinate[0], coordinate[1], building.properties.height || 10];
	          });
	        });
	      });
	    }
	  }, {
	    key: 'calculateContourIndices',
	    value: function calculateContourIndices(vertices, offset) {
	      var stride = countVertices(vertices);
	
	      return vertices.map(function (polygon) {
	        var indices = [offset];
	        var numVertices = polygon.length;
	
	        // building top
	        // use vertex pairs for GL.LINES => [0, 1, 1, 2, 2, ..., n-1, n-1, 0]
	        for (var i = 1; i < numVertices - 1; i++) {
	          indices.push(i + offset, i + offset);
	        }
	        indices.push(offset);
	
	        // building sides
	        for (var _i = 0; _i < numVertices - 1; _i++) {
	          indices.push(_i + offset, _i + stride + offset);
	        }
	
	        offset += numVertices;
	        return indices;
	      });
	    }
	  }, {
	    key: 'calculateSurfaceIndices',
	    value: function calculateSurfaceIndices(vertices, offset) {
	      var stride = countVertices(vertices);
	      var holes = null;
	      var quad = [[0, 1], [0, 3], [1, 2], [1, 2], [0, 3], [1, 4]];
	
	      if (vertices.length > 1) {
	        holes = vertices.reduce(function (acc, polygon) {
	          return [].concat(_toConsumableArray(acc), [acc[acc.length - 1] + polygon.length]);
	        }, [0]).slice(1, vertices.length);
	      }
	
	      var topIndices = (0, _earcut2.default)((0, _utils.flatten)(vertices), holes, 3).map(function (index) {
	        return index + offset;
	      });
	
	      var sideIndices = vertices.map(function (polygon) {
	        var numVertices = polygon.length;
	        // building top
	        var indices = [];
	
	        // building sides
	        for (var i = 0; i < numVertices - 1; i++) {
	          indices.push.apply(indices, _toConsumableArray(drawRectangle(i)));
	        }
	
	        offset += numVertices;
	        return indices;
	      });
	
	      return [topIndices, sideIndices];
	
	      function drawRectangle(i) {
	        return quad.map(function (v) {
	          return i + v[0] + stride * v[1] + offset;
	        });
	      }
	    }
	  }]);
	
	  return ExtrudedChoroplethLayer64;
	}(_lib.Layer);
	
	exports.default = ExtrudedChoroplethLayer64;
	
	
	ExtrudedChoroplethLayer64.layerName = 'ExtrudedChoroplethLayer64';
	ExtrudedChoroplethLayer64.defaultProps = defaultProps;
	
	/*
	 * helpers
	 */
	// get normal vector of line segment
	function getNormal(p1, p2) {
	  if (p1[0] === p2[0] && p1[1] === p2[1]) {
	    return [1, 0, 0];
	  }
	
	  var degrees2radians = Math.PI / 180;
	
	  var lon1 = degrees2radians * p1[0];
	  var lon2 = degrees2radians * p2[0];
	  var lat1 = degrees2radians * p1[1];
	  var lat2 = degrees2radians * p2[1];
	
	  var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
	  var b = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
	
	  return _glMatrix.vec3.normalize([], [b, 0, -a]);
	}
	
	// count number of vertices in geojson polygon
	function countVertices(vertices) {
	  return vertices.reduce(function (count, polygon) {
	    return count + polygon.length;
	  }, 0);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 823 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* fragment shader for the building-layer */
	exports.default = "#define SHADER_NAME building-layer-fragment-shader\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  gl_FragColor = vColor;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9sYXllcnMvZGVwcmVjYXRlZC9leHRydWRlZC1jaG9yb3BsZXRoLWxheWVyLTY0L2V4dHJ1ZGVkLWNob3JvcGxldGgtbGF5ZXItZnJhZ21lbnQuZ2xzbC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBIiwiZmlsZSI6ImV4dHJ1ZGVkLWNob3JvcGxldGgtbGF5ZXItZnJhZ21lbnQuZ2xzbC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvcHlyaWdodCAoYykgMjAxNSAtIDIwMTcgVWJlciBUZWNobm9sb2dpZXMsIEluYy5cbi8vXG4vLyBQZXJtaXNzaW9uIGlzIGhlcmVieSBncmFudGVkLCBmcmVlIG9mIGNoYXJnZSwgdG8gYW55IHBlcnNvbiBvYnRhaW5pbmcgYSBjb3B5XG4vLyBvZiB0aGlzIHNvZnR3YXJlIGFuZCBhc3NvY2lhdGVkIGRvY3VtZW50YXRpb24gZmlsZXMgKHRoZSBcIlNvZnR3YXJlXCIpLCB0byBkZWFsXG4vLyBpbiB0aGUgU29mdHdhcmUgd2l0aG91dCByZXN0cmljdGlvbiwgaW5jbHVkaW5nIHdpdGhvdXQgbGltaXRhdGlvbiB0aGUgcmlnaHRzXG4vLyB0byB1c2UsIGNvcHksIG1vZGlmeSwgbWVyZ2UsIHB1Ymxpc2gsIGRpc3RyaWJ1dGUsIHN1YmxpY2Vuc2UsIGFuZC9vciBzZWxsXG4vLyBjb3BpZXMgb2YgdGhlIFNvZnR3YXJlLCBhbmQgdG8gcGVybWl0IHBlcnNvbnMgdG8gd2hvbSB0aGUgU29mdHdhcmUgaXNcbi8vIGZ1cm5pc2hlZCB0byBkbyBzbywgc3ViamVjdCB0byB0aGUgZm9sbG93aW5nIGNvbmRpdGlvbnM6XG4vL1xuLy8gVGhlIGFib3ZlIGNvcHlyaWdodCBub3RpY2UgYW5kIHRoaXMgcGVybWlzc2lvbiBub3RpY2Ugc2hhbGwgYmUgaW5jbHVkZWQgaW5cbi8vIGFsbCBjb3BpZXMgb3Igc3Vic3RhbnRpYWwgcG9ydGlvbnMgb2YgdGhlIFNvZnR3YXJlLlxuLy9cbi8vIFRIRSBTT0ZUV0FSRSBJUyBQUk9WSURFRCBcIkFTIElTXCIsIFdJVEhPVVQgV0FSUkFOVFkgT0YgQU5ZIEtJTkQsIEVYUFJFU1MgT1Jcbi8vIElNUExJRUQsIElOQ0xVRElORyBCVVQgTk9UIExJTUlURUQgVE8gVEhFIFdBUlJBTlRJRVMgT0YgTUVSQ0hBTlRBQklMSVRZLFxuLy8gRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UgQU5EIE5PTklORlJJTkdFTUVOVC4gSU4gTk8gRVZFTlQgU0hBTEwgVEhFXG4vLyBBVVRIT1JTIE9SIENPUFlSSUdIVCBIT0xERVJTIEJFIExJQUJMRSBGT1IgQU5ZIENMQUlNLCBEQU1BR0VTIE9SIE9USEVSXG4vLyBMSUFCSUxJVFksIFdIRVRIRVIgSU4gQU4gQUNUSU9OIE9GIENPTlRSQUNULCBUT1JUIE9SIE9USEVSV0lTRSwgQVJJU0lORyBGUk9NLFxuLy8gT1VUIE9GIE9SIElOIENPTk5FQ1RJT04gV0lUSCBUSEUgU09GVFdBUkUgT1IgVEhFIFVTRSBPUiBPVEhFUiBERUFMSU5HUyBJTlxuLy8gVEhFIFNPRlRXQVJFLlxuXG4vKiBmcmFnbWVudCBzaGFkZXIgZm9yIHRoZSBidWlsZGluZy1sYXllciAqL1xuZXhwb3J0IGRlZmF1bHQgYFxcXG4jZGVmaW5lIFNIQURFUl9OQU1FIGJ1aWxkaW5nLWxheWVyLWZyYWdtZW50LXNoYWRlclxuXG4jaWZkZWYgR0xfRVNcbnByZWNpc2lvbiBoaWdocCBmbG9hdDtcbiNlbmRpZlxuXG52YXJ5aW5nIHZlYzQgdkNvbG9yO1xuXG52b2lkIG1haW4odm9pZCkge1xuICBnbF9GcmFnQ29sb3IgPSB2Q29sb3I7XG59XG5gO1xuIl19

/***/ },
/* 824 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "#define SHADER_NAME extruded-choropleths-layer-vertex-shader\n\nattribute vec4 positions;\nattribute vec2 heights;\nattribute vec3 normals;\nattribute vec4 colors;\n\nuniform float opacity;\nuniform float elevation;\n\nuniform vec3 uAmbientColor;\nuniform float uPointLightAmbientCoefficient;\nuniform vec3 uPointLightLocation;\nuniform vec3 uPointLightColor;\nuniform float uPointLightAttenuation;\n\nuniform vec3 uMaterialSpecularColor;\nuniform float uMaterialShininess;\n\nvarying vec4 vColor;\n\nvec3 applyLighting(vec3 position_modelspace, vec3 normal_modelspace, vec3 color) {\n\n  vec3 pointLightLocation_modelspace = vec3(project_position(uPointLightLocation));\n  vec3 lightDirection = normalize(pointLightLocation_modelspace - position_modelspace);\n\n  vec3 ambient = uPointLightAmbientCoefficient * color / 255.0 * uAmbientColor / 255.0;\n\n  float diffuseCoefficient = max(dot(normal_modelspace, lightDirection), 0.0);\n  vec3 diffuse = diffuseCoefficient * uPointLightColor / 255. * color / 255.;\n\n  return ambient + uPointLightAttenuation * diffuse;\n}\n\nvoid main(void) {\n  vec2 projected_xy[2];\n  project_position_fp64(positions, projected_xy);\n  vec2 scaled_height = mul_fp64(heights, vec2(projectionPixelsPerUnit.x * elevation, 0.0));\n\n  vec2 vertex_pos_modelspace[4];\n  vertex_pos_modelspace[0] = projected_xy[0];\n  vertex_pos_modelspace[1] = projected_xy[1];\n  vertex_pos_modelspace[2] = sum_fp64(scaled_height, vec2(1.0, 0.0));\n  vertex_pos_modelspace[3] = vec2(1.0, 0.0);\n\n  gl_Position = project_to_clipspace_fp64(vertex_pos_modelspace);\n\n  vec3 color = applyLighting(\n  \tvec3(\n  \t  vertex_pos_modelspace[0].x,\n  \t  vertex_pos_modelspace[1].x,\n  \t  vertex_pos_modelspace[2].x),\n  \tnormals,\n  \tcolors.rgb\n  );\n  vColor = vec4(color, opacity);\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _layer = __webpack_require__(259);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var CompositeLayer = function (_Layer) {
	  _inherits(CompositeLayer, _Layer);
	
	  function CompositeLayer(props) {
	    _classCallCheck(this, CompositeLayer);
	
	    return _possibleConstructorReturn(this, (CompositeLayer.__proto__ || Object.getPrototypeOf(CompositeLayer)).call(this, props));
	  }
	
	  // initializeState is usually not needed for composite layers
	  // Provide empty definition to disable check for missing definition
	
	
	  _createClass(CompositeLayer, [{
	    key: 'initializeState',
	    value: function initializeState() {}
	
	    // No-op for the invalidateAttribute function as the composite
	    // layer has no AttributeManager
	
	  }, {
	    key: 'invalidateAttribute',
	    value: function invalidateAttribute() {}
	
	    // called to augment the info object that is bubbled up from a sublayer
	    // override Layer.getPickingInfo() because decoding / setting uniform do
	    // not apply to a composite layer.
	    // @return null to cancel event
	
	  }, {
	    key: 'getPickingInfo',
	    value: function getPickingInfo(_ref) {
	      var info = _ref.info;
	
	      return info;
	    }
	  }]);
	
	  return CompositeLayer;
	}(_layer2.default);
	
	exports.default = CompositeLayer;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvY29tcG9zaXRlLWxheWVyLmpzIl0sIm5hbWVzIjpbIkNvbXBvc2l0ZUxheWVyIiwicHJvcHMiLCJpbmZvIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQW9CQTs7Ozs7Ozs7OzsrZUFwQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0lBSXFCQSxjOzs7QUFDbkIsMEJBQVlDLEtBQVosRUFBbUI7QUFBQTs7QUFBQSwySEFDWEEsS0FEVztBQUVsQjs7QUFFRDtBQUNBOzs7OztzQ0FDa0IsQ0FDakI7O0FBRUQ7QUFDQTs7OzswQ0FDc0IsQ0FDckI7O0FBRUQ7QUFDQTtBQUNBO0FBQ0E7Ozs7eUNBQ3VCO0FBQUEsVUFBUEMsSUFBTyxRQUFQQSxJQUFPOztBQUNyQixhQUFPQSxJQUFQO0FBQ0Q7Ozs7OztrQkFyQmtCRixjIiwiZmlsZSI6ImNvbXBvc2l0ZS1sYXllci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvcHlyaWdodCAoYykgMjAxNSAtIDIwMTcgVWJlciBUZWNobm9sb2dpZXMsIEluYy5cbi8vXG4vLyBQZXJtaXNzaW9uIGlzIGhlcmVieSBncmFudGVkLCBmcmVlIG9mIGNoYXJnZSwgdG8gYW55IHBlcnNvbiBvYnRhaW5pbmcgYSBjb3B5XG4vLyBvZiB0aGlzIHNvZnR3YXJlIGFuZCBhc3NvY2lhdGVkIGRvY3VtZW50YXRpb24gZmlsZXMgKHRoZSBcIlNvZnR3YXJlXCIpLCB0byBkZWFsXG4vLyBpbiB0aGUgU29mdHdhcmUgd2l0aG91dCByZXN0cmljdGlvbiwgaW5jbHVkaW5nIHdpdGhvdXQgbGltaXRhdGlvbiB0aGUgcmlnaHRzXG4vLyB0byB1c2UsIGNvcHksIG1vZGlmeSwgbWVyZ2UsIHB1Ymxpc2gsIGRpc3RyaWJ1dGUsIHN1YmxpY2Vuc2UsIGFuZC9vciBzZWxsXG4vLyBjb3BpZXMgb2YgdGhlIFNvZnR3YXJlLCBhbmQgdG8gcGVybWl0IHBlcnNvbnMgdG8gd2hvbSB0aGUgU29mdHdhcmUgaXNcbi8vIGZ1cm5pc2hlZCB0byBkbyBzbywgc3ViamVjdCB0byB0aGUgZm9sbG93aW5nIGNvbmRpdGlvbnM6XG4vL1xuLy8gVGhlIGFib3ZlIGNvcHlyaWdodCBub3RpY2UgYW5kIHRoaXMgcGVybWlzc2lvbiBub3RpY2Ugc2hhbGwgYmUgaW5jbHVkZWQgaW5cbi8vIGFsbCBjb3BpZXMgb3Igc3Vic3RhbnRpYWwgcG9ydGlvbnMgb2YgdGhlIFNvZnR3YXJlLlxuLy9cbi8vIFRIRSBTT0ZUV0FSRSBJUyBQUk9WSURFRCBcIkFTIElTXCIsIFdJVEhPVVQgV0FSUkFOVFkgT0YgQU5ZIEtJTkQsIEVYUFJFU1MgT1Jcbi8vIElNUExJRUQsIElOQ0xVRElORyBCVVQgTk9UIExJTUlURUQgVE8gVEhFIFdBUlJBTlRJRVMgT0YgTUVSQ0hBTlRBQklMSVRZLFxuLy8gRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UgQU5EIE5PTklORlJJTkdFTUVOVC4gSU4gTk8gRVZFTlQgU0hBTEwgVEhFXG4vLyBBVVRIT1JTIE9SIENPUFlSSUdIVCBIT0xERVJTIEJFIExJQUJMRSBGT1IgQU5ZIENMQUlNLCBEQU1BR0VTIE9SIE9USEVSXG4vLyBMSUFCSUxJVFksIFdIRVRIRVIgSU4gQU4gQUNUSU9OIE9GIENPTlRSQUNULCBUT1JUIE9SIE9USEVSV0lTRSwgQVJJU0lORyBGUk9NLFxuLy8gT1VUIE9GIE9SIElOIENPTk5FQ1RJT04gV0lUSCBUSEUgU09GVFdBUkUgT1IgVEhFIFVTRSBPUiBPVEhFUiBERUFMSU5HUyBJTlxuLy8gVEhFIFNPRlRXQVJFLlxuXG5pbXBvcnQgTGF5ZXIgZnJvbSAnLi9sYXllcic7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIENvbXBvc2l0ZUxheWVyIGV4dGVuZHMgTGF5ZXIge1xuICBjb25zdHJ1Y3Rvcihwcm9wcykge1xuICAgIHN1cGVyKHByb3BzKTtcbiAgfVxuXG4gIC8vIGluaXRpYWxpemVTdGF0ZSBpcyB1c3VhbGx5IG5vdCBuZWVkZWQgZm9yIGNvbXBvc2l0ZSBsYXllcnNcbiAgLy8gUHJvdmlkZSBlbXB0eSBkZWZpbml0aW9uIHRvIGRpc2FibGUgY2hlY2sgZm9yIG1pc3NpbmcgZGVmaW5pdGlvblxuICBpbml0aWFsaXplU3RhdGUoKSB7XG4gIH1cblxuICAvLyBOby1vcCBmb3IgdGhlIGludmFsaWRhdGVBdHRyaWJ1dGUgZnVuY3Rpb24gYXMgdGhlIGNvbXBvc2l0ZVxuICAvLyBsYXllciBoYXMgbm8gQXR0cmlidXRlTWFuYWdlclxuICBpbnZhbGlkYXRlQXR0cmlidXRlKCkge1xuICB9XG5cbiAgLy8gY2FsbGVkIHRvIGF1Z21lbnQgdGhlIGluZm8gb2JqZWN0IHRoYXQgaXMgYnViYmxlZCB1cCBmcm9tIGEgc3VibGF5ZXJcbiAgLy8gb3ZlcnJpZGUgTGF5ZXIuZ2V0UGlja2luZ0luZm8oKSBiZWNhdXNlIGRlY29kaW5nIC8gc2V0dGluZyB1bmlmb3JtIGRvXG4gIC8vIG5vdCBhcHBseSB0byBhIGNvbXBvc2l0ZSBsYXllci5cbiAgLy8gQHJldHVybiBudWxsIHRvIGNhbmNlbCBldmVudFxuICBnZXRQaWNraW5nSW5mbyh7aW5mb30pIHtcbiAgICByZXR1cm4gaW5mbztcbiAgfVxufVxuIl19

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.drawLayers = drawLayers;
	exports.pickLayers = pickLayers;
	
	var _luma = __webpack_require__(29);
	
	var _viewportUniforms = __webpack_require__(835);
	
	var _utils = __webpack_require__(42);
	
	var EMPTY_PIXEL = new Uint8Array(4); // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* global window */
	
	var renderCount = 0;
	
	function drawLayers(_ref) {
	  var layers = _ref.layers,
	      pass = _ref.pass;
	
	  _utils.log.log(3, 'DRAWING ' + layers.length + ' layers');
	
	  // render layers in normal colors
	  var visibleCount = 0;
	  // render layers in normal colors
	  layers.forEach(function (layer, layerIndex) {
	    if (layer.props.visible) {
	      layer.drawLayer({
	        uniforms: Object.assign({ renderPickingBuffer: 0, pickingEnabled: 0 }, layer.context.uniforms, (0, _viewportUniforms.getUniformsFromViewport)(layer.context.viewport, layer.props), { layerIndex: layerIndex })
	      });
	      visibleCount++;
	    }
	  });
	
	  _utils.log.log(3, 'RENDER PASS ' + pass + ': ' + renderCount++ + '\n    ' + visibleCount + ' visible, ' + layers.length + ' total');
	}
	
	/* eslint-disable max-depth, max-statements */
	function pickLayers(gl, _ref2) {
	  var layers = _ref2.layers,
	      pickingFBO = _ref2.pickingFBO,
	      _ref2$uniforms = _ref2.uniforms,
	      uniforms = _ref2$uniforms === undefined ? {} : _ref2$uniforms,
	      x = _ref2.x,
	      y = _ref2.y,
	      viewport = _ref2.viewport,
	      mode = _ref2.mode,
	      lastPickedInfo = _ref2.lastPickedInfo;
	
	
	  // Convert from canvas top-left to WebGL bottom-left coordinates
	  // And compensate for pixelRatio
	  var pixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;
	  var deviceX = x * pixelRatio;
	  var deviceY = gl.canvas.height - y * pixelRatio;
	
	  // TODO - just return glContextWithState once luma updates
	  var unhandledPickInfos = [];
	
	  // Make sure we clear scissor test and fbo bindings in case of exceptions
	  // We are only interested in one pixel, no need to render anything else
	  (0, _luma.glContextWithState)(gl, {
	    frameBuffer: pickingFBO,
	    framebuffer: pickingFBO,
	    scissorTest: { x: deviceX, y: deviceY, w: 1, h: 1 }
	  }, function () {
	
	    // Picking process start
	    // Clear the frame buffer
	    gl.clear(_luma.GL.COLOR_BUFFER_BIT | _luma.GL.DEPTH_BUFFER_BIT);
	    // Save current blend settings
	    var oldBlendMode = (0, _utils.getBlendMode)(gl);
	    // Set blend mode for picking
	    // always overwrite existing pixel with [r,g,b,layerIndex]
	    gl.enable(gl.BLEND);
	    gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.CONSTANT_ALPHA, gl.ZERO);
	    gl.blendEquation(gl.FUNC_ADD);
	
	    // Render all pickable layers in picking colors
	    layers.forEach(function (layer, layerIndex) {
	      if (layer.props.visible && layer.props.pickable) {
	
	        // Encode layerIndex with alpha
	        gl.blendColor(0, 0, 0, (layerIndex + 1) / 255);
	
	        layer.drawLayer({
	          uniforms: Object.assign({ renderPickingBuffer: 1, pickingEnabled: 1 }, layer.context.uniforms, (0, _viewportUniforms.getUniformsFromViewport)(layer.context.viewport, layer.props), { layerIndex: layerIndex })
	        });
	      }
	    });
	
	    // Read color in the central pixel, to be mapped with picking colors
	    var pickedColor = new Uint8Array(4);
	    gl.readPixels(deviceX, deviceY, 1, 1, _luma.GL.RGBA, _luma.GL.UNSIGNED_BYTE, pickedColor);
	
	    // restore blend mode
	    (0, _utils.setBlendMode)(gl, oldBlendMode);
	    // Picking process end
	
	    // Process picked info start
	    // Decode picked color
	    var pickedLayerIndex = pickedColor[3] - 1;
	    var pickedLayer = pickedLayerIndex >= 0 ? layers[pickedLayerIndex] : null;
	    var pickedObjectIndex = pickedLayer ? pickedLayer.decodePickingColor(pickedColor) : -1;
	    var pickedLayerId = pickedLayer && pickedLayer.props.id;
	    var affectedLayers = pickedLayer ? [pickedLayer] : [];
	
	    if (mode === 'hover') {
	      // only invoke onHover events if picked object has changed
	      var lastPickedObjectIndex = lastPickedInfo.index;
	      var lastPickedLayerId = lastPickedInfo.layerId;
	
	      if (pickedLayerId === lastPickedLayerId && pickedObjectIndex === lastPickedObjectIndex) {
	        // picked object did not change, no need to proceed
	        return;
	      }
	
	      if (pickedLayerId !== lastPickedLayerId) {
	        // We cannot store a ref to lastPickedLayer in the context because
	        // the state of an outdated layer is no longer valid
	        // and the props may have changed
	        var lastPickedLayer = layers.find(function (l) {
	          return l.props.id === lastPickedLayerId;
	        });
	        if (lastPickedLayer) {
	          // Let leave event fire before enter event
	          affectedLayers.unshift(lastPickedLayer);
	        }
	      }
	
	      // Update layer manager context
	      lastPickedInfo.layerId = pickedLayerId;
	      lastPickedInfo.index = pickedObjectIndex;
	    }
	
	    var baseInfo = createInfo([x, y], viewport);
	    baseInfo.devicePixel = [deviceX, deviceY];
	    baseInfo.pixelRatio = pixelRatio;
	
	    // Use a Map to store all picking infos.
	    // The following two forEach loops are the result of
	    // https://github.com/uber/deck.gl/issues/443
	    // Please be very careful when changing this pattern
	    var infos = new Map();
	
	    affectedLayers.forEach(function (layer) {
	      var info = Object.assign({}, baseInfo);
	
	      if (layer === pickedLayer) {
	        info.color = pickedColor;
	        info.index = pickedObjectIndex;
	        info.picked = true;
	      }
	
	      // Walk up the composite chain and find the owner of the event
	      // sublayers are never directly exposed to the user
	      while (layer && info) {
	        // For a composite layer, sourceLayer will point to the sublayer
	        // where the event originates from.
	        // It provides additional context for the composite layer's
	        // getPickingInfo() method to populate the info object
	        var sourceLayer = info.layer || layer;
	        info.layer = layer;
	        // layer.pickLayer() function requires a non-null ```layer.state```
	        // object to funtion properly. So the layer refereced here
	        // must be the "current" layer, not an "out-dated" / "invalidated" layer
	        info = layer.pickLayer({ info: info, mode: mode, sourceLayer: sourceLayer });
	        layer = layer.parentLayer;
	      }
	
	      // This guarantees that there will be only one copy of info for
	      // one composite layer
	      if (info) {
	        infos.set(info.layer.id, info);
	      }
	    });
	
	    infos.forEach(function (info) {
	      var handled = false;
	      // The onClick and onHover functions are provided by the user
	      // and out of control by deck.gl. It's very much possible that
	      // the user calls React lifecycle methods in these function, such as
	      // ReactComponent.setState(). React lifecycle methods sometimes induce
	      // a re-render and re-generation of props of deck.gl and its layers,
	      // which invalidates all layers currently passed to this very function.
	
	      // Therefore, calls to functions like onClick and onHover need to be done
	      // at the end of the function. NO operation relies on the states of current
	      // layers should be called after this two lines of code.
	      switch (mode) {
	        case 'click':
	          handled = info.layer.props.onClick(info);break;
	        case 'hover':
	          handled = info.layer.props.onHover(info);break;
	        default:
	          throw new Error('unknown pick type');
	      }
	
	      if (!handled) {
	        unhandledPickInfos.push(info);
	      }
	    });
	  });
	
	  return unhandledPickInfos;
	}
	/* eslint-enable max-depth, max-statements */
	
	function createInfo(pixel, viewport) {
	  // Assign a number of potentially useful props to the "info" object
	  return {
	    color: EMPTY_PIXEL,
	    index: -1,
	    picked: false,
	    x: pixel[0],
	    y: pixel[1],
	    pixel: pixel,
	    lngLat: viewport.unproject(pixel)
	  };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _globals = __webpack_require__(834);
	
	var _log = __webpack_require__(261);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _package = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STARTUP_MESSAGE = 'set deck.log.priority=2 to trace attribute updates';
	
	// Version detection
	// TODO - this imports a rather large JSON file, we only need one field
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	if (_globals.global.deck && _globals.global.deck.VERSION !== _package.version) {
	  throw new Error('deck.gl - multiple versions detected: ' + _globals.global.deck.VERSION + ' vs ' + _package.version);
	}
	
	if (!_globals.global.deck) {
	  /* global console */
	  /* eslint-disable no-console */
	  console.log('deck.gl ' + _package.version + ' - ' + STARTUP_MESSAGE);
	
	  _globals.global.deck = _globals.global.deck || {
	    VERSION: _package.version,
	    log: _log2.default
	  };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// IMLEMENTATION NOTES: Why new layers are created on every render
	//
	// The key here is to understand the declarative / functional
	// programming nature of "reactive" applications.
	//
	// - In a reactive application, the entire "UI tree"
	//   is re-rendered every time something in the application changes.
	//
	// - The UI framework (such as React or deck.gl) then diffs the rendered
	//   tree of UI elements (React Elements or deck.gl Layers) against the
	//   previously tree and makes optimized changes (to the DOM or to WebGL state).
	//
	// - Deck.gl layers are not based on React.
	//   But it should be possible to wrap deck.gl layers in React components to
	//   enable use of JSX.
	//
	// The deck.gl model that for the app creates a new set of on layers on every
	// render.
	// Internally, the new layers are efficiently matched against existing layers
	// using layer ids.
	//
	// All calculated state (programs, attributes etc) are stored in a state object
	// and this state object is moved forward to the match layer on every render
	// cycle.  The new layer ends up with the state of the old layer (and the
	// props of the new layer), while the old layer is simply discarded for
	// garbage collecion.
	//
	/* eslint-disable no-try-catch */
	
	
	var _layer = __webpack_require__(259);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	var _utils = __webpack_require__(42);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _drawAndPick = __webpack_require__(826);
	
	var _viewports = __webpack_require__(262);
	
	var _luma = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LOG_PRIORITY_LIFECYCLE = 2;
	var LOG_PRIORITY_LIFECYCLE_MINOR = 3;
	
	var LayerManager = function () {
	  function LayerManager(_ref) {
	    var gl = _ref.gl;
	
	    _classCallCheck(this, LayerManager);
	
	    this.prevLayers = [];
	    this.layers = [];
	    // Tracks if any layers were drawn last update
	    // Needed to ensure that screen is cleared when no layers are shown
	    this.screenCleared = false;
	    this.oldContext = {};
	    this.context = {
	      gl: gl,
	      uniforms: {},
	      viewport: null,
	      viewportChanged: true,
	      pickingFBO: null,
	      lastPickedInfo: {
	        index: -1,
	        layerId: null
	      }
	    };
	    Object.seal(this.context);
	  }
	
	  _createClass(LayerManager, [{
	    key: 'setViewport',
	    value: function setViewport(viewport) {
	      (0, _assert2.default)(viewport instanceof _viewports.Viewport, 'Invalid viewport');
	
	      // TODO - viewport change detection breaks METER_OFFSETS mode
	      // const oldViewport = this.context.viewport;
	      // const viewportChanged = !oldViewport || !viewport.equals(oldViewport);
	
	      var viewportChanged = true;
	
	      if (viewportChanged) {
	        Object.assign(this.oldContext, this.context);
	        this.context.viewport = viewport;
	        this.context.viewportChanged = true;
	        this.context.uniforms = {};
	        (0, _utils.log)(4, viewport);
	      }
	
	      return this;
	    }
	  }, {
	    key: 'updateLayers',
	    value: function updateLayers(_ref2) {
	      var newLayers = _ref2.newLayers;
	
	      /* eslint-disable */
	      (0, _assert2.default)(this.context.viewport, 'LayerManager.updateLayers: viewport not set');
	
	      // Filter out any null layers
	      newLayers = newLayers.filter(function (newLayer) {
	        return newLayer !== null;
	      });
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = newLayers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var layer = _step.value;
	
	          layer.context = this.context;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.prevLayers = this.layers;
	
	      var _updateLayers2 = this._updateLayers({
	        oldLayers: this.prevLayers,
	        newLayers: newLayers
	      }),
	          error = _updateLayers2.error,
	          generatedLayers = _updateLayers2.generatedLayers;
	
	      this.layers = generatedLayers;
	      // Throw first error found, if any
	      if (error) {
	        throw error;
	      }
	      return this;
	    }
	  }, {
	    key: 'drawLayers',
	    value: function drawLayers(_ref3) {
	      var pass = _ref3.pass;
	
	      (0, _assert2.default)(this.context.viewport, 'LayerManager.drawLayers: viewport not set');
	
	      (0, _drawAndPick.drawLayers)({ layers: this.layers, pass: pass });
	
	      return this;
	    }
	  }, {
	    key: 'pickLayer',
	    value: function pickLayer(_ref4) {
	      var x = _ref4.x,
	          y = _ref4.y,
	          mode = _ref4.mode;
	      var _context = this.context,
	          gl = _context.gl,
	          uniforms = _context.uniforms;
	
	      // Set up a frame buffer if needed
	
	      if (this.context.pickingFBO === null || gl.canvas.width !== this.context.pickingFBO.width || gl.canvas.height !== this.context.pickingFBO.height) {
	        this.context.pickingFBO = new _luma.FramebufferObject(gl, {
	          width: gl.canvas.width,
	          height: gl.canvas.height
	        });
	      }
	      return (0, _drawAndPick.pickLayers)(gl, {
	        x: x,
	        y: y,
	        uniforms: {
	          renderPickingBuffer: true,
	          picking_uEnable: true
	        },
	        layers: this.layers,
	        mode: mode,
	        viewport: this.context.viewport,
	        pickingFBO: this.context.pickingFBO,
	        lastPickedInfo: this.context.lastPickedInfo
	      });
	    }
	  }, {
	    key: 'needsRedraw',
	    value: function needsRedraw() {
	      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref5$clearRedrawFlag = _ref5.clearRedrawFlags,
	          clearRedrawFlags = _ref5$clearRedrawFlag === undefined ? false : _ref5$clearRedrawFlag;
	
	      if (!this.context.viewport) {
	        return false;
	      }
	
	      var redraw = false;
	
	      // Make sure that buffer is cleared once when layer list becomes empty
	      if (this.layers.length === 0) {
	        if (this.screenCleared === false) {
	          redraw = true;
	          this.screenCleared = true;
	          return true;
	        }
	      } else {
	        if (this.screenCleared === true) {
	          this.screenCleared = false;
	        }
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.layers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var layer = _step2.value;
	
	          redraw = redraw || layer.getNeedsRedraw({ clearRedrawFlags: clearRedrawFlags });
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return redraw;
	    }
	
	    // PRIVATE METHODS
	
	    // Match all layers, checking for caught errors
	    // To avoid having an exception in one layer disrupt other layers
	
	  }, {
	    key: '_updateLayers',
	    value: function _updateLayers(_ref6) {
	      var oldLayers = _ref6.oldLayers,
	          newLayers = _ref6.newLayers;
	
	      // Create old layer map
	      var oldLayerMap = {};
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = oldLayers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var oldLayer = _step3.value;
	
	          if (oldLayerMap[oldLayer.id]) {
	            _utils.log.once(0, 'Multipe old layers with same id ' + layerName(oldLayer));
	          } else {
	            oldLayerMap[oldLayer.id] = oldLayer;
	          }
	        }
	
	        // Allocate array for generated layers
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      var generatedLayers = [];
	
	      // Match sublayers
	      var error = this._matchSublayers({
	        newLayers: newLayers, oldLayerMap: oldLayerMap, generatedLayers: generatedLayers
	      });
	
	      var error2 = this._finalizeOldLayers(oldLayers);
	      var firstError = error || error2;
	      return { error: firstError, generatedLayers: generatedLayers };
	    }
	
	    /* eslint-disable max-statements */
	
	  }, {
	    key: '_matchSublayers',
	    value: function _matchSublayers(_ref7) {
	      var _this = this;
	
	      var newLayers = _ref7.newLayers,
	          oldLayerMap = _ref7.oldLayerMap,
	          generatedLayers = _ref7.generatedLayers;
	
	      // Filter out any null layers
	      newLayers = newLayers.filter(function (newLayer) {
	        return newLayer !== null;
	      });
	
	      var error = null;
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var newLayer = _step4.value;
	
	          newLayer.context = _this.context;
	
	          try {
	            // 1. given a new coming layer, find its matching layer
	            var oldLayer = oldLayerMap[newLayer.id];
	            oldLayerMap[newLayer.id] = null;
	
	            if (oldLayer === null) {
	              _utils.log.once(0, 'Multipe new layers with same id ' + layerName(newLayer));
	            }
	
	            // Only transfer state at this stage. We must not generate exceptions
	            // until all layers' state have been transferred
	            if (oldLayer) {
	              (0, _utils.log)(LOG_PRIORITY_LIFECYCLE_MINOR, 'matched ' + layerName(newLayer), oldLayer, '=>', newLayer);
	              _this._transferLayerState(oldLayer, newLayer);
	              _this._updateLayer(newLayer);
	            } else {
	              _this._initializeNewLayer(newLayer);
	            }
	            generatedLayers.push(newLayer);
	
	            // Call layer lifecycle method: render sublayers
	            var sublayers = newLayer.renderLayers();
	            // End layer lifecycle method: render sublayers
	
	            if (sublayers) {
	              sublayers = Array.isArray(sublayers) ? sublayers : [sublayers];
	
	              // populate reference to parent layer
	              sublayers.forEach(function (layer) {
	                layer.parentLayer = newLayer;
	              });
	
	              _this._matchSublayers({
	                newLayers: sublayers,
	                oldLayerMap: oldLayerMap,
	                generatedLayers: generatedLayers
	              });
	            }
	          } catch (err) {
	            _utils.log.once(0, 'deck.gl error during matching of ' + layerName(newLayer) + ' ' + err, err);
	            // Save first error
	            error = error || err;
	          }
	        };
	
	        for (var _iterator4 = newLayers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      return error;
	    }
	  }, {
	    key: '_transferLayerState',
	    value: function _transferLayerState(oldLayer, newLayer) {
	      var state = oldLayer.state,
	          props = oldLayer.props;
	
	      // sanity check
	
	      (0, _assert2.default)(state, 'deck.gl sanity check - Matching layer has no state');
	      (0, _assert2.default)(oldLayer !== newLayer, 'deck.gl sanity check - Matching layer is same');
	
	      // Move state
	      newLayer.state = state;
	      newLayer.lifecycle = 'Matched. State transferred from previous layer';
	      state.layer = newLayer;
	
	      // Update model layer reference
	      if (state.model) {
	        state.model.userData.layer = newLayer;
	      }
	      // Keep a temporary ref to the old props, for prop comparison
	      newLayer.oldProps = props;
	      // oldLayer.state = null;
	      newLayer.lifecycle = 'Awaiting garbage collection';
	    }
	
	    // Update the old layers that were not matched
	
	  }, {
	    key: '_finalizeOldLayers',
	    value: function _finalizeOldLayers(oldLayers) {
	      var error = null;
	      // Unmatched layers still have state, it will be discarded
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = oldLayers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var layer = _step5.value;
	
	          if (layer.state) {
	            error = error || this._finalizeLayer(layer);
	          }
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	
	      return error;
	    }
	
	    // Initializes a single layer, calling layer methods
	
	  }, {
	    key: '_initializeNewLayer',
	    value: function _initializeNewLayer(layer) {
	      var error = null;
	      // Check if new layer, and initialize it's state
	      if (!layer.state) {
	        (0, _utils.log)(LOG_PRIORITY_LIFECYCLE, 'initializing ' + layerName(layer));
	        try {
	          layer.initializeLayer({
	            oldProps: {},
	            props: layer.props,
	            oldContext: this.oldContext,
	            context: this.context,
	            changeFlags: layer.diffProps({}, layer.props, this.context)
	          });
	          layer.lifecycle = 'Intialized';
	        } catch (err) {
	          _utils.log.once(0, 'deck.gl error during initialization of ' + layerName(layer) + ' ' + err, err);
	          // Save first error
	          error = error || err;
	        }
	        // Set back pointer (used in picking)
	        if (layer.state) {
	          layer.state.layer = layer;
	          // Save layer on model for picking purposes
	          // TODO - store on model.userData rather than directly on model
	        }
	        if (layer.state && layer.state.model) {
	          layer.state.model.userData.layer = layer;
	        }
	      }
	      return error;
	    }
	
	    // Updates a single layer, calling layer methods
	
	  }, {
	    key: '_updateLayer',
	    value: function _updateLayer(layer) {
	      var oldProps = layer.oldProps,
	          props = layer.props;
	
	      var error = null;
	      if (oldProps) {
	        try {
	          layer.updateLayer({
	            oldProps: oldProps,
	            props: props,
	            context: this.context,
	            oldContext: this.oldContext,
	            changeFlags: layer.diffProps(oldProps, layer.props, this.context)
	          });
	        } catch (err) {
	          _utils.log.once(0, 'deck.gl error during update of ' + layerName(layer), err);
	          // Save first error
	          error = err;
	        }
	        (0, _utils.log)(LOG_PRIORITY_LIFECYCLE_MINOR, 'updating ' + layerName(layer));
	      }
	      return error;
	    }
	
	    // Finalizes a single layer
	
	  }, {
	    key: '_finalizeLayer',
	    value: function _finalizeLayer(layer) {
	      var error = null;
	      var state = layer.state;
	
	      if (state) {
	        try {
	          layer.finalizeLayer();
	        } catch (err) {
	          _utils.log.once(0, 'deck.gl error during finalization of ' + layerName(layer), err);
	          // Save first error
	          error = err;
	        }
	        // layer.state = null;
	        layer.lifecycle = 'Finalized! Awaiting garbage collection';
	        (0, _utils.log)(LOG_PRIORITY_LIFECYCLE, 'finalizing ' + layerName(layer));
	      }
	      return error;
	    }
	  }]);
	
	  return LayerManager;
	}();
	
	exports.default = LayerManager;
	
	
	function layerName(layer) {
	  if (layer instanceof _layer2.default) {
	    return '' + layer;
	  }
	  return !layer ? 'null layer' : 'invalid layer';
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 829 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBlendMode = getBlendMode;
	exports.setBlendMode = setBlendMode;
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// get current blending settings
	function getBlendMode(gl) {
	  return {
	    enabled: gl.getParameter(gl.BLEND),
	    equationRGB: gl.getParameter(gl.BLEND_EQUATION_RGB),
	    equationAlpha: gl.getParameter(gl.BLEND_EQUATION_ALPHA),
	    srcRGB: gl.getParameter(gl.BLEND_SRC_RGB),
	    dstRGB: gl.getParameter(gl.BLEND_DST_RGB),
	    srcAlpha: gl.getParameter(gl.BLEND_SRC_ALPHA),
	    dstAlpha: gl.getParameter(gl.BLEND_DST_ALPHA)
	  };
	}
	
	// apply blending settings
	function setBlendMode(gl, settings) {
	  if (settings.enabled) {
	    gl.enable(gl.BLEND);
	  } else {
	    gl.disable(gl.BLEND);
	  }
	  gl.blendEquationSeparate(settings.equationRGB, settings.equationAlpha);
	  gl.blendFuncSeparate(settings.srcRGB, settings.dstRGB, settings.srcAlpha, settings.dstAlpha);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 830 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseColor = parseColor;
	exports.parseHexColor = parseHexColor;
	exports.setOpacity = setOpacity;
	exports.applyOpacity = applyOpacity;
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Parse array or string color
	function parseColor(color) {
	  if (Array.isArray(color)) {
	    if (color.length === 3) {
	      return [color[0], color[1], color[2], 255];
	    }
	    return color;
	  }
	  if (typeof color === 'string') {
	    return parseHexColor(color);
	  }
	  return null;
	}
	
	// Parse a hex color
	function parseHexColor(color) {
	  var array = new Uint8ClampedArray(4);
	  if (color.length === 7) {
	    var value = parseInt(color.substring(1), 16);
	    array[0] = value / 65536;
	    array[1] = value / 256 % 256;
	    array[2] = value % 256;
	    array[3] = 255;
	  } else if (color.length === 9) {
	    var _value = parseInt(color.substring(1), 16);
	    array[0] = _value / 16777216;
	    array[1] = _value / 65536 % 256;
	    array[2] = _value / 256 % 256;
	    array[3] = _value % 256;
	  }
	  return array;
	}
	
	function setOpacity(color) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 127;
	
	  return [color[0], color[1], color[2], opacity];
	}
	
	function applyOpacity(color) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 127;
	
	  return [color[0], color[1], color[2], opacity];
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 831 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.compareArrays = compareArrays;
	exports.checkArray = checkArray;
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	function compareArrays(array1, array2) {
	
	  var length = Math.min(array1.length, array2.length);
	  for (var i = 0; i < length; ++i) {
	    if (array1[i] !== array2[i]) {
	      return "Arrays are different in element " + i + ": " + array1[i] + " vs " + array2[i];
	    }
	  }
	
	  if (array1.length !== array2.length) {
	    return "Arrays have different length " + array1.length + " vs " + array2.length;
	  }
	
	  return null;
	}
	
	function checkArray(array) {
	  for (var i = 0; i < array.length; ++i) {
	    if (!Number.isFinite(array[i])) {
	      throw new Error("Array has invalid element " + i + ": " + array[i]);
	    }
	  }
	  return null;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.compareProps = compareProps;
	exports.areEqualShallow = areEqualShallow;
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * @param {Object} opt.oldProps - object with old key/value pairs
	 * @param {Object} opt.newProps - object with new key/value pairs
	 * @param {Object} opt.ignoreProps={} - object, keys that should not be compared
	 * @returns {null|String} - null when values of all keys are strictly equal.
	 *   if unequal, returns a string explaining what changed.
	 */
	/* eslint-disable max-statements, complexity */
	function compareProps() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      oldProps = _ref.oldProps,
	      newProps = _ref.newProps,
	      _ref$ignoreProps = _ref.ignoreProps,
	      ignoreProps = _ref$ignoreProps === undefined ? {} : _ref$ignoreProps;
	
	  (0, _assert2.default)(oldProps !== undefined && newProps !== undefined, 'compareProps args');
	
	  if (oldProps === newProps) {
	    return null;
	  }
	
	  if ((typeof oldProps === 'undefined' ? 'undefined' : _typeof(oldProps)) !== 'object' || oldProps === null) {
	    return 'old props is not an object';
	  }
	  if ((typeof newProps === 'undefined' ? 'undefined' : _typeof(newProps)) !== 'object' || newProps === null) {
	    return 'new props is not an object';
	  }
	
	  // Test if new props different from old props
	  for (var key in oldProps) {
	    if (!(key in ignoreProps)) {
	      if (!newProps.hasOwnProperty(key)) {
	        return 'prop ' + key + ' dropped: ' + oldProps[key] + ' -> (undefined)';
	      } else if (oldProps[key] !== newProps[key]) {
	        return 'prop ' + key + ' changed: ' + oldProps[key] + ' -> ' + newProps[key];
	      }
	    }
	  }
	
	  // Test if any new props have been added
	  for (var _key in newProps) {
	    if (!(_key in ignoreProps)) {
	      if (!oldProps.hasOwnProperty(_key)) {
	        return 'prop ' + _key + ' added: (undefined) -> ' + newProps[_key];
	      }
	    }
	  }
	
	  return null;
	}
	/* eslint-enable max-statements, complexity */
	
	// Shallow compare
	/* eslint-disable complexity */
	function areEqualShallow(a, b) {
	  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref2$ignore = _ref2.ignore,
	      ignore = _ref2$ignore === undefined ? {} : _ref2$ignore;
	
	  if (a === b) {
	    return true;
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object' || a === null || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== 'object' || b === null) {
	    return false;
	  }
	
	  if (Object.keys(a).length !== Object.keys(b).length) {
	    return false;
	  }
	
	  for (var key in a) {
	    if (!(key in ignore) && (!(key in b) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	  for (var _key2 in b) {
	    if (!(_key2 in ignore) && !(_key2 in a)) {
	      return false;
	    }
	  }
	  return true;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 833 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flatten = flatten;
	exports.countVertices = countVertices;
	exports.flattenVertices = flattenVertices;
	exports.fillArray = fillArray;
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Flattens a nested array into a single level array
	 * @example flatten([[1, [2]], [3], 4]) => [1, 2, 3, 4]
	 * @param {Array} array The array to flatten.
	 * @return {Array} Returns the new flattened array.
	 */
	function flatten(array) {
	  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var index = -1;
	  while (++index < array.length) {
	    var value = array[index];
	    if (Array.isArray(value)) {
	      flatten(value, result);
	    } else {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	function countVertices(nestedArray) {
	  var count = 0;
	  var index = -1;
	  while (++index < nestedArray.length) {
	    var value = nestedArray[index];
	    if (Array.isArray(value) || ArrayBuffer.isView(value)) {
	      count += countVertices(value);
	    } else {
	      count++;
	    }
	  }
	  return count;
	}
	
	// Flattens nested array of vertices, padding third coordinate as needed
	function flattenVertices(nestedArray) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$result = _ref.result,
	      result = _ref$result === undefined ? [] : _ref$result,
	      _ref$dimensions = _ref.dimensions,
	      dimensions = _ref$dimensions === undefined ? 3 : _ref$dimensions;
	
	  var index = -1;
	  var vertexLength = 0;
	  while (++index < nestedArray.length) {
	    var value = nestedArray[index];
	    if (Array.isArray(value) || ArrayBuffer.isView(value)) {
	      flattenVertices(value, { result: result, dimensions: dimensions });
	    } else {
	      if (vertexLength < dimensions) {
	        // eslint-disable-line
	        result.push(value);
	        vertexLength++;
	      }
	    }
	  }
	  // Add a third coordinate if needed
	  if (vertexLength > 0 && vertexLength < dimensions) {
	    result.push(0);
	  }
	  return result;
	}
	
	// Uses copyWithin to significantly speed up typed array value filling
	function fillArray(_ref2) {
	  var target = _ref2.target,
	      source = _ref2.source,
	      _ref2$start = _ref2.start,
	      start = _ref2$start === undefined ? 0 : _ref2$start,
	      _ref2$count = _ref2.count,
	      count = _ref2$count === undefined ? 1 : _ref2$count;
	
	  var total = count * source.length;
	  var copied = 0;
	  for (var i = 0; i < source.length; ++i) {
	    target[start + copied++] = source[i];
	  }
	
	  while (copied < total) {
	    // If we have copied less than half, copy everything we got
	    // else copy remaining in one operation
	    if (copied < total - copied) {
	      target.copyWithin(start + copied, start, start + copied);
	      copied *= 2;
	    } else {
	      target.copyWithin(start + copied, start, start + total - copied);
	      copied = total;
	    }
	  }
	
	  return target;
	}
	
	// Flattens nested array of vertices, padding third coordinate as needed
	/*
	export function flattenTypedVertices(nestedArray, {
	  result = [],
	  Type = Float32Array,
	  start = 0,
	  dimensions = 3
	} = {}) {
	  let index = -1;
	  let vertexLength = 0;
	  while (++index < nestedArray.length) {
	    const value = nestedArray[index];
	    if (Array.isArray(value) || ArrayBuffer.isView(value)) {
	      start = flattenTypedVertices(value, {result, start, dimensions});
	    } else {
	      if (vertexLength < dimensions) { // eslint-disable-line
	        result[start++] = value;
	        vertexLength++;
	      }
	    }
	  }
	  // Add a third coordinate if needed
	  if (vertexLength > 0 && vertexLength < dimensions) {
	    result[start++] = 0;
	  }
	  return start;
	}
	*/
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 834 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* global window, global, document */
	module.exports = {
	  window: typeof window !== 'undefined' ? window : global,
	  global: typeof global !== 'undefined' ? global : window,
	  document: typeof document !== 'undefined' ? document : {}
	};
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* global window */
	
	
	exports.getUniformsFromViewport = getUniformsFromViewport;
	
	var _luma = __webpack_require__(29);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _constants = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fp64ify(a) {
	  var hiPart = Math.fround(a);
	  var loPart = a - Math.fround(a);
	  return [hiPart, loPart];
	}
	
	// To quickly set a vector to zero
	var ZERO_VECTOR = [0, 0, 0, 0];
	// 4x4 matrix that drops 4th component of vector
	var VECTOR_TO_POINT_MATRIX = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0];
	
	function calculateMatrixAndOffset(_ref) {
	  var projectionMode = _ref.projectionMode,
	      positionOrigin = _ref.positionOrigin,
	      viewport = _ref.viewport,
	      modelMatrix = _ref.modelMatrix;
	  var viewMatrixUncentered = viewport.viewMatrixUncentered,
	      viewMatrix = viewport.viewMatrix,
	      projectionMatrix = viewport.projectionMatrix;
	
	
	  var projectionCenter = void 0;
	  var modelViewMatrix = void 0;
	
	  switch (projectionMode) {
	
	    case _constants.COORDINATE_SYSTEM.IDENTITY:
	    case _constants.COORDINATE_SYSTEM.LNGLAT:
	      projectionCenter = ZERO_VECTOR;
	      modelViewMatrix = new _luma.Matrix4(viewMatrix);
	      break;
	
	    // TODO: make lighitng work for meter offset mode
	    case _constants.COORDINATE_SYSTEM.METER_OFFSETS:
	      // Calculate transformed projectionCenter (in 64 bit precision)
	      // This is the key to offset mode precision (avoids doing this
	      // addition in 32 bit precision)
	      var positionPixels = viewport.projectFlat(positionOrigin);
	      var viewProjectionMatrix = new _luma.Matrix4(projectionMatrix).multiplyRight(viewMatrix);
	      projectionCenter = viewProjectionMatrix.transformVector([positionPixels[0], positionPixels[1], 0.0, 1.0]);
	
	      // Always apply uncentered projection matrix if available (shader adds center)
	      modelViewMatrix = new _luma.Matrix4(viewMatrixUncentered || viewMatrix)
	      // Zero out 4th coordinate ("after" model matrix) - avoids further translations
	      .multiplyRight(VECTOR_TO_POINT_MATRIX);
	      break;
	
	    default:
	      throw new Error('Unknown projection mode');
	  }
	
	  var viewMatrixInv = modelViewMatrix.clone().invert();
	
	  if (modelMatrix) {
	    // Apply model matrix if supplied
	    modelViewMatrix.multiplyRight(modelMatrix);
	  }
	
	  var modelViewProjectionMatrix = new _luma.Matrix4(projectionMatrix).multiplyRight(modelViewMatrix);
	  var cameraPos = [viewMatrixInv[12], viewMatrixInv[13], viewMatrixInv[14]];
	
	  return {
	    modelViewMatrix: modelViewMatrix,
	    modelViewProjectionMatrix: modelViewProjectionMatrix,
	    projectionCenter: projectionCenter,
	    cameraPos: cameraPos
	  };
	}
	
	/**
	 * Returns uniforms for shaders based on current projection
	 * includes: projection matrix suitable for shaders
	 *
	 * TODO - Ensure this works with any viewport, not just WebMercatorViewports
	 *
	 * @param {WebMercatorViewport} viewport -
	 * @return {Float32Array} - 4x4 projection matrix that can be used in shaders
	 */
	function getUniformsFromViewport(viewport) {
	  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref2$modelMatrix = _ref2.modelMatrix,
	      modelMatrix = _ref2$modelMatrix === undefined ? null : _ref2$modelMatrix,
	      _ref2$projectionMode = _ref2.projectionMode,
	      projectionMode = _ref2$projectionMode === undefined ? _constants.COORDINATE_SYSTEM.LNGLAT : _ref2$projectionMode,
	      _ref2$positionOrigin = _ref2.positionOrigin,
	      positionOrigin = _ref2$positionOrigin === undefined ? [0, 0] : _ref2$positionOrigin;
	
	  (0, _assert2.default)(viewport.scale, 'Viewport scale missing');
	
	  var _calculateMatrixAndOf = calculateMatrixAndOffset({ projectionMode: projectionMode, positionOrigin: positionOrigin, modelMatrix: modelMatrix, viewport: viewport }),
	      projectionCenter = _calculateMatrixAndOf.projectionCenter,
	      modelViewMatrix = _calculateMatrixAndOf.modelViewMatrix,
	      modelViewProjectionMatrix = _calculateMatrixAndOf.modelViewProjectionMatrix,
	      cameraPos = _calculateMatrixAndOf.cameraPos;
	
	  (0, _assert2.default)(modelViewProjectionMatrix, 'Viewport missing modelViewProjectionMatrix');
	
	  // Calculate projection pixels per unit
	  var projectionPixelsPerUnit = viewport.getDistanceScales().pixelsPerMeter;
	  (0, _assert2.default)(projectionPixelsPerUnit, 'Viewport missing pixelsPerMeter');
	
	  // calculate WebGL matrices
	
	  // Convert to Float32
	  var glProjectionMatrix = new Float32Array(modelViewProjectionMatrix);
	
	  // "Float64Array"
	  // Transpose the projection matrix to column major for GLSL.
	  var glProjectionMatrixFP64 = new Float32Array(32);
	  for (var i = 0; i < 4; ++i) {
	    for (var j = 0; j < 4; ++j) {
	      var _fp64ify = fp64ify(modelViewProjectionMatrix[j * 4 + i]);
	
	      var _fp64ify2 = _slicedToArray(_fp64ify, 2);
	
	      glProjectionMatrixFP64[(i * 4 + j) * 2] = _fp64ify2[0];
	      glProjectionMatrixFP64[(i * 4 + j) * 2 + 1] = _fp64ify2[1];
	    }
	  }
	
	  var devicePixelRatio = window && window.devicePixelRatio || 1;
	
	  return {
	    // Projection mode values
	    projectionMode: projectionMode,
	    projectionCenter: projectionCenter,
	
	    // modelMatrix: modelMatrix || new Matrix4().identity(),
	    modelViewMatrix: modelViewMatrix,
	
	    // Screen size
	    viewportSize: [viewport.width * devicePixelRatio, viewport.height * devicePixelRatio],
	    devicePixelRatio: devicePixelRatio,
	
	    // Main projection matrices
	    projectionMatrix: glProjectionMatrix,
	    projectionMatrixUncentered: glProjectionMatrix,
	    projectionFP64: glProjectionMatrixFP64,
	    projectionPixelsPerUnit: projectionPixelsPerUnit,
	
	    // This is the mercator scale (2 ** zoom)
	    projectionScale: viewport.scale,
	
	    // Deprecated?
	    projectionScaleFP64: fp64ify(viewport.scale),
	
	    // This is for lighting calculations
	    cameraPos: new Float32Array(cameraPos)
	
	  };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autobind = __webpack_require__(396);
	
	var _autobind2 = _interopRequireDefault(_autobind);
	
	var _webglRenderer = __webpack_require__(837);
	
	var _webglRenderer2 = _interopRequireDefault(_webglRenderer);
	
	var _lib = __webpack_require__(35);
	
	var _experimental = __webpack_require__(771);
	
	var _luma = __webpack_require__(29);
	
	var _viewports = __webpack_require__(262);
	
	var _utils = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	function noop() {}
	
	var propTypes = {
	  id: _react.PropTypes.string,
	  width: _react.PropTypes.number.isRequired,
	  height: _react.PropTypes.number.isRequired,
	  layers: _react.PropTypes.arrayOf(_react.PropTypes.instanceOf(_lib.Layer)).isRequired,
	  effects: _react.PropTypes.arrayOf(_react.PropTypes.instanceOf(_experimental.Effect)),
	  gl: _react.PropTypes.object,
	  debug: _react.PropTypes.bool,
	  viewport: _react.PropTypes.instanceOf(_viewports.Viewport),
	  onWebGLInitialized: _react.PropTypes.func,
	  onLayerClick: _react.PropTypes.func,
	  onLayerHover: _react.PropTypes.func,
	  onAfterRender: _react.PropTypes.func
	};
	
	var defaultProps = {
	  id: 'deckgl-overlay',
	  debug: false,
	  gl: null,
	  effects: [],
	  onWebGLInitialized: noop,
	  onLayerClick: noop,
	  onLayerHover: noop,
	  onAfterRender: noop
	};
	
	var DeckGL = function (_React$Component) {
	  _inherits(DeckGL, _React$Component);
	
	  function DeckGL(props) {
	    _classCallCheck(this, DeckGL);
	
	    var _this = _possibleConstructorReturn(this, (DeckGL.__proto__ || Object.getPrototypeOf(DeckGL)).call(this, props));
	
	    _this.state = {};
	    _this.needsRedraw = true;
	    _this.layerManager = null;
	    _this.effectManager = null;
	    (0, _autobind2.default)(_this);
	    return _this;
	  }
	
	  _createClass(DeckGL, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this._updateLayers(nextProps);
	    }
	  }, {
	    key: '_updateLayers',
	    value: function _updateLayers(nextProps) {
	      var width = nextProps.width,
	          height = nextProps.height,
	          latitude = nextProps.latitude,
	          longitude = nextProps.longitude,
	          zoom = nextProps.zoom,
	          pitch = nextProps.pitch,
	          bearing = nextProps.bearing,
	          altitude = nextProps.altitude;
	      var viewport = nextProps.viewport;
	
	      // If Viewport is not supplied, create one from mercator props
	
	      viewport = viewport || new _viewports.WebMercatorViewport({
	        width: width, height: height, latitude: latitude, longitude: longitude, zoom: zoom, pitch: pitch, bearing: bearing, altitude: altitude
	      });
	
	      if (this.layerManager) {
	        this.layerManager.setViewport(viewport).updateLayers({ newLayers: nextProps.layers });
	      }
	    }
	  }, {
	    key: '_onRendererInitialized',
	    value: function _onRendererInitialized(_ref) {
	      var gl = _ref.gl,
	          canvas = _ref.canvas;
	
	      gl.enable(_luma.GL.BLEND);
	      gl.blendFunc(_luma.GL.SRC_ALPHA, _luma.GL.ONE_MINUS_SRC_ALPHA);
	
	      this.props.onWebGLInitialized(gl);
	
	      // Note: avoid React setState due GL animation loop / setState timing issue
	      this.layerManager = new _lib.LayerManager({ gl: gl });
	      this.effectManager = new _experimental.EffectManager({ gl: gl, layerManager: this.layerManager });
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.props.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var effect = _step.value;
	
	          this.effectManager.addEffect(effect);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this._updateLayers(this.props);
	
	      // Check if a mouse event has been specified and that at least one of the layers is pickable
	      var hasEvent = this.props.onLayerClick !== noop || this.props.onLayerHover !== noop;
	      var hasPickableLayer = this.layerManager.layers.map(function (l) {
	        return l.props.pickable;
	      }).includes(true);
	      if (this.layerManager.layers.length && hasEvent && !hasPickableLayer) {
	        _utils.log.once(0, 'You have supplied a mouse event handler but none of your layers got the `pickable` flag.');
	      }
	
	      this.events = (0, _luma.addEvents)(canvas, {
	        cacheSize: false,
	        cachePosition: false,
	        centerOrigin: false,
	        onClick: this._onClick,
	        onMouseMove: this._onMouseMove
	      });
	    }
	
	    // Route events to layers
	
	  }, {
	    key: '_onClick',
	    value: function _onClick(event) {
	      // use offsetX|Y for relative position to the container, drop event if falsy
	      if (!event || !event.event || !Number.isFinite(event.event.offsetX)) {
	        return;
	      }
	      var _event$event = event.event,
	          x = _event$event.offsetX,
	          y = _event$event.offsetY;
	
	      var selectedInfos = this.layerManager.pickLayer({ x: x, y: y, mode: 'click' });
	      if (selectedInfos.length) {
	        var firstInfo = selectedInfos.find(function (info) {
	          return info.index >= 0;
	        });
	        // Event.event holds the original MouseEvent object
	        this.props.onLayerClick(firstInfo, selectedInfos, event.event);
	      }
	    }
	
	    // Route events to layers
	
	  }, {
	    key: '_onMouseMove',
	    value: function _onMouseMove(event) {
	      if (!event || !event.event || !Number.isFinite(event.event.offsetX)) {
	        return;
	      }
	      var _event$event2 = event.event,
	          x = _event$event2.offsetX,
	          y = _event$event2.offsetY;
	
	      var selectedInfos = this.layerManager.pickLayer({ x: x, y: y, mode: 'hover' });
	      if (selectedInfos.length) {
	        var firstInfo = selectedInfos.find(function (info) {
	          return info.index >= 0;
	        });
	        // Event.event holds the original MouseEvent object
	        this.props.onLayerHover(firstInfo, selectedInfos, event.event);
	      }
	    }
	  }, {
	    key: '_onRenderFrame',
	    value: function _onRenderFrame(_ref2) {
	      var gl = _ref2.gl;
	
	      var redraw = this.layerManager.needsRedraw({ clearRedrawFlags: true });
	      if (!redraw) {
	        return;
	      }
	
	      // clear depth and color buffers
	      gl.clear(_luma.GL.COLOR_BUFFER_BIT | _luma.GL.DEPTH_BUFFER_BIT);
	
	      this.effectManager.preDraw();
	      this.layerManager.drawLayers({ pass: 'primary' });
	      this.effectManager.draw();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          width = _props.width,
	          height = _props.height,
	          gl = _props.gl,
	          debug = _props.debug;
	
	
	      return (0, _react.createElement)(_webglRenderer2.default, Object.assign({}, this.props, {
	        width: width,
	        height: height,
	        gl: gl,
	        debug: debug,
	        viewport: { x: 0, y: 0, width: width, height: height },
	        onRendererInitialized: this._onRendererInitialized,
	        onNeedRedraw: this._onNeedRedraw,
	        onRenderFrame: this._onRenderFrame,
	        onMouseMove: this._onMouseMove,
	        onClick: this._onClick
	      }));
	    }
	  }]);
	
	  return DeckGL;
	}(_react2.default.Component);
	
	exports.default = DeckGL;
	
	
	DeckGL.propTypes = propTypes;
	DeckGL.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autobind = __webpack_require__(396);
	
	var _autobind2 = _interopRequireDefault(_autobind);
	
	var _luma = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/* global window */
	
	
	/* global requestAnimationFrame, cancelAnimationFrame */
	
	var DEFAULT_PIXEL_RATIO = typeof window !== 'undefined' && window.devicePixelRatio || 1;
	
	var propTypes = {
	  id: _react.PropTypes.string.isRequired,
	
	  width: _react.PropTypes.number.isRequired,
	  height: _react.PropTypes.number.isRequired,
	  style: _react.PropTypes.object,
	
	  pixelRatio: _react.PropTypes.number,
	  viewport: _react.PropTypes.object.isRequired,
	  events: _react.PropTypes.object,
	  gl: _react.PropTypes.object,
	  glOptions: _react.PropTypes.object,
	  debug: _react.PropTypes.bool,
	
	  onInitializationFailed: _react.PropTypes.func,
	  onRendererInitialized: _react.PropTypes.func.isRequired,
	  onRenderFrame: _react.PropTypes.func,
	  onMouseMove: _react.PropTypes.func,
	  onClick: _react.PropTypes.func
	};
	
	var defaultProps = {
	  style: {},
	  gl: null,
	  glOptions: { preserveDrawingBuffer: true },
	  debug: false,
	  pixelRatio: DEFAULT_PIXEL_RATIO,
	
	  onInitializationFailed: function onInitializationFailed(error) {
	    throw error;
	  },
	  onRendererInitialized: function onRendererInitialized() {},
	  onRenderFrame: function onRenderFrame() {}
	};
	
	var WebGLRenderer = function (_React$Component) {
	  _inherits(WebGLRenderer, _React$Component);
	
	  /**
	   * @classdesc
	   * Small react component that uses Luma.GL to initialize a WebGL context.
	   *
	   * Returns a canvas, creates a basic WebGL context
	   * sets up a renderloop, and registers some basic event handlers
	   *
	   * @class
	   * @param {Object} props - see propTypes documentation
	   */
	  function WebGLRenderer(props) {
	    _classCallCheck(this, WebGLRenderer);
	
	    var _this = _possibleConstructorReturn(this, (WebGLRenderer.__proto__ || Object.getPrototypeOf(WebGLRenderer)).call(this, props));
	
	    _this.state = {};
	    _this._animationFrame = null;
	    _this.gl = null;
	    (0, _autobind2.default)(_this);
	    return _this;
	  }
	
	  _createClass(WebGLRenderer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var canvas = this.refs.overlay;
	      this._initWebGL(canvas);
	      this._animationLoop();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._cancelAnimationLoop();
	    }
	
	    /**
	     * Initialize LumaGL library and through it WebGL
	     * @param {string} canvas
	     */
	
	  }, {
	    key: '_initWebGL',
	    value: function _initWebGL(canvas) {
	      var _props = this.props,
	          debug = _props.debug,
	          glOptions = _props.glOptions;
	
	      // Create context if not supplied
	
	      var gl = this.props.gl;
	      if (!gl) {
	        try {
	          gl = (0, _luma.createGLContext)(Object.assign({ canvas: canvas, debug: debug }, glOptions));
	        } catch (error) {
	          this.props.onInitializationFailed(error);
	          return;
	        }
	      }
	
	      this.gl = gl;
	
	      // Call callback last, in case it throws
	      this.props.onRendererInitialized({ canvas: canvas, gl: gl });
	    }
	
	    /**
	     * Main WebGL animation loop
	     */
	
	  }, {
	    key: '_animationLoop',
	    value: function _animationLoop() {
	      this._renderFrame();
	      // Keep registering ourselves for the next animation frame
	      if (typeof window !== 'undefined') {
	        this._animationFrame = requestAnimationFrame(this._animationLoop);
	      }
	    }
	  }, {
	    key: '_cancelAnimationLoop',
	    value: function _cancelAnimationLoop() {
	      if (this._animationFrame) {
	        cancelAnimationFrame(this._animationFrame);
	      }
	    }
	
	    // Updates WebGL viewport to latest props
	    // for clean logging, only calls gl.viewport if props have changed
	
	  }, {
	    key: '_updateGLViewport',
	    value: function _updateGLViewport() {
	      var _props$viewport = this.props.viewport,
	          x = _props$viewport.x,
	          y = _props$viewport.y,
	          w = _props$viewport.width,
	          h = _props$viewport.height;
	      var dpr = this.props.pixelRatio;
	      var gl = this.gl;
	
	
	      x = x * dpr;
	      y = y * dpr;
	      w = w * dpr;
	      h = h * dpr;
	
	      if (x !== this.x || y !== this.y || w !== this.w || h !== this.h) {
	        gl.viewport(x, y, w, h);
	        this.x = x;
	        this.y = y;
	        this.w = w;
	        this.h = h;
	      }
	    }
	  }, {
	    key: '_renderFrame',
	    value: function _renderFrame() {
	      var _props$viewport2 = this.props.viewport,
	          width = _props$viewport2.width,
	          height = _props$viewport2.height;
	      var gl = this.gl;
	
	      // Check for reasons not to draw
	
	      if (!gl || !(width > 0) || !(height > 0)) {
	        return;
	      }
	
	      this._updateGLViewport();
	
	      // Call render callback
	      this.props.onRenderFrame({ gl: gl });
	
	      this.props.onAfterRender(this.refs.overlay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          width = _props2.width,
	          height = _props2.height,
	          pixelRatio = _props2.pixelRatio,
	          style = _props2.style;
	
	      return (0, _react.createElement)('canvas', {
	        ref: 'overlay',
	        key: 'overlay',
	        id: id,
	        width: width * pixelRatio,
	        height: height * pixelRatio,
	        style: Object.assign({}, style, { width: width, height: height })
	      });
	    }
	  }]);
	
	  return WebGLRenderer;
	}(_react2.default.Component);
	
	exports.default = WebGLRenderer;
	
	
	WebGLRenderer.propTypes = propTypes;
	WebGLRenderer.defaultProps = defaultProps;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkRendererVendor = checkRendererVendor;
	exports.getPlatformShaderDefines = getPlatformShaderDefines;
	exports.assembleShaders = assembleShaders;
	
	var _luma = __webpack_require__(29);
	
	var _shaderChunks = __webpack_require__(397);
	
	var SHADER_CHUNKS = _interopRequireWildcard(_shaderChunks);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	function checkRendererVendor(debugInfo, gpuVendor) {
	  var vendor = debugInfo.vendor,
	      renderer = debugInfo.renderer;
	
	  var result = void 0;
	  switch (gpuVendor) {
	    case 'nvidia':
	      result = vendor.match(/NVIDIA/i) || renderer.match(/NVIDIA/i);
	      break;
	    case 'intel':
	      result = vendor.match(/INTEL/i) || renderer.match(/INTEL/i);
	      break;
	    case 'amd':
	      result = vendor.match(/AMD/i) || renderer.match(/AMD/i) || vendor.match(/ATI/i) || renderer.match(/ATI/i);
	      break;
	    default:
	      result = false;
	  }
	  return result;
	}
	
	// Load shader chunks
	// import SHADER_CHUNKS from '../../dist/shaderlib/shader-chunks';
	function getPlatformShaderDefines(gl) {
	  /* eslint-disable */
	  var platformDefines = '';
	  var debugInfo = (0, _luma.glGetDebugInfo)(gl);
	
	  if (checkRendererVendor(debugInfo, 'nvidia')) {
	    platformDefines += '#define NVIDIA_GPU\n#define NVIDIA_FP64_WORKAROUND 1\n#define NVIDIA_EQUATION_WORKAROUND 1\n';
	  } else if (checkRendererVendor(debugInfo, 'intel')) {
	    platformDefines += '#define INTEL_GPU\n#define INTEL_FP64_WORKAROUND 1\n#define NVIDIA_EQUATION_WORKAROUND 1\n #define INTEL_TAN_WORKAROUND 1\n';
	  } else if (checkRendererVendor(debugInfo, 'amd')) {
	    platformDefines += '#define AMD_GPU\n';
	  } else {
	    platformDefines += '#define DEFAULT_GPU\n';
	  }
	
	  return platformDefines;
	}
	
	function assembleShader(gl) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _opts = opts,
	      vs = _opts.vs,
	      _opts$project = _opts.project,
	      project = _opts$project === undefined ? true : _opts$project,
	      _opts$project2 = _opts.project64,
	      project64 = _opts$project2 === undefined ? false : _opts$project2;
	  var _opts2 = opts,
	      _opts2$fp = _opts2.fp64,
	      fp64 = _opts2$fp === undefined ? false : _opts2$fp;
	
	  if (project64 === true) {
	    fp64 = true;
	  }
	  var source = getPlatformShaderDefines(gl) + '\n';
	  opts = Object.assign({}, opts, { project: project, project64: project64, fp64: fp64 });
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(SHADER_CHUNKS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var chunkName = _step.value;
	
	      if (opts[chunkName]) {
	        source += SHADER_CHUNKS[chunkName].source + '\n';
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = (opts.modules || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var _chunkName = _step2.value;
	
	      if (SHADER_CHUNKS[_chunkName]) {
	        source += SHADER_CHUNKS[_chunkName].source + '\n';
	      } else {
	        throw new Error('Shader module ' + _chunkName + ' not found');
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  source += vs;
	  return source;
	}
	
	function assembleShaders(gl, opts) {
	  return {
	    gl: gl,
	    vs: assembleShader(gl, opts),
	    fs: opts.fs
	  };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fp64 = undefined;
	
	var _mathFp = __webpack_require__(840);
	
	var _mathFp2 = _interopRequireDefault(_mathFp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fp64 = exports.fp64 = {
	  interface: 'fp64',
	  source: _mathFp2.default
	}; // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 840 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "uniform float ONE;\n\nconst vec2 E_FP64 = vec2(2.7182817459106445e+00, 8.254840366817007e-08);\nconst vec2 LOG2_FP64 = vec2(0.6931471824645996e+00, -1.9046542121259336e-09);\nconst vec2 PI_FP64 = vec2(3.1415927410125732, -8.742278012618954e-8);\nconst vec2 TWO_PI_FP64 = vec2(6.2831854820251465, -1.7484556025237907e-7);\nconst vec2 PI_2_FP64 = vec2(1.5707963705062866, -4.371139006309477e-8);\nconst vec2 PI_4_FP64 = vec2(0.7853981852531433, -2.1855695031547384e-8);\nconst vec2 PI_16_FP64 = vec2(0.19634954631328583, -5.463923757886846e-9);\nconst vec2 PI_16_2_FP64 = vec2(0.39269909262657166, -1.0927847515773692e-8);\nconst vec2 PI_16_3_FP64 = vec2(0.5890486240386963, -1.4906100798128818e-9);\nconst vec2 PI_180_FP64 = vec2(0.01745329238474369, 1.3519960498364902e-10);\n\nconst vec2 SIN_TABLE_0_FP64 = vec2(0.19509032368659973, -1.6704714833615242e-9);\nconst vec2 SIN_TABLE_1_FP64 = vec2(0.3826834261417389, 6.22335089017767e-9);\nconst vec2 SIN_TABLE_2_FP64 = vec2(0.5555702447891235, -1.1769521357507529e-8);\nconst vec2 SIN_TABLE_3_FP64 = vec2(0.7071067690849304, 1.2101617041793133e-8);\n\nconst vec2 COS_TABLE_0_FP64 = vec2(0.9807852506637573, 2.9739473106360492e-8);\nconst vec2 COS_TABLE_1_FP64 = vec2(0.9238795042037964, 2.8307490351764386e-8);\nconst vec2 COS_TABLE_2_FP64 = vec2(0.8314695954322815, 1.6870263741530778e-8);\nconst vec2 COS_TABLE_3_FP64 = vec2(0.7071067690849304, 1.2101617152815436e-8);\n\nconst vec2 INVERSE_FACTORIAL_3_FP64 = vec2(1.666666716337204e-01, -4.967053879312289e-09); // 1/3!\nconst vec2 INVERSE_FACTORIAL_4_FP64 = vec2(4.16666679084301e-02, -1.2417634698280722e-09); // 1/4!\nconst vec2 INVERSE_FACTORIAL_5_FP64 = vec2(8.333333767950535e-03, -4.34617203337595e-10); // 1/5!\nconst vec2 INVERSE_FACTORIAL_6_FP64 = vec2(1.3888889225199819e-03, -3.3631094437103215e-11); // 1/6!\nconst vec2 INVERSE_FACTORIAL_7_FP64 = vec2(1.9841270113829523e-04,  -2.725596874933456e-12); // 1/7!\nconst vec2 INVERSE_FACTORIAL_8_FP64 = vec2(2.4801587642286904e-05, -3.406996025904184e-13); // 1/8!\nconst vec2 INVERSE_FACTORIAL_9_FP64 = vec2(2.75573188446287533e-06, 3.7935713937038186e-14); // 1/9!\nconst vec2 INVERSE_FACTORIAL_10_FP64 = vec2(2.755731998149713e-07, -7.575112367869873e-15); // 1/10!\n\nfloat nint(float d) {\n    if (d == floor(d)) return d;\n    return floor(d + 0.5);\n}\n\n#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)\nvec2 split(float a) {\n  const float SPLIT = 4097.0;\n  float t = a * SPLIT;\n  float a_hi = t * ONE - (t - a);\n  float a_lo = a * ONE - a_hi;\n  return vec2(a_hi, a_lo);\n}\n#else\nvec2 split(float a) {\n  const float SPLIT = 4097.0;\n  float t = a * SPLIT;\n  float a_hi = t - (t - a);\n  float a_lo = a - a_hi;\n  return vec2(a_hi, a_lo);\n}\n#endif\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\nvec2 quickTwoSum(float a, float b) {\n  float sum = (a + b) * ONE;\n  float err = b - (sum - a) * ONE;\n  return vec2(sum, err);\n}\n#else\nvec2 quickTwoSum(float a, float b) {\n  float sum = a + b;\n  float err = b - (sum - a);\n  return vec2(sum, err);\n}\n#endif\n\nvec2 nint_fp64(vec2 a) {\n    float hi = nint(a.x);\n    float lo;\n    vec2 tmp;\n    if (hi == a.x) {\n        lo = nint(a.y);\n        tmp = quickTwoSum(hi, lo);\n    } else {\n        lo = 0.0;\n        if (abs(hi - a.x) == 0.5 && a.y < 0.0) {\n            hi -= 1.0;\n        }\n        tmp = vec2(hi, lo);\n    }\n    return tmp;\n}\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\n\n/* The purpose of this workaround is to prevent compilers from\noptimizing away necessary arithmetic operations by swapping their sequences\nor transform the equation to some 'equivalent' from.\n\nThe method is to multiply an artifical variable, ONE, which will be known to\nthe compiler to be one only at the runtime. The whole expression is then represented\nas a polynomial with respective to ONE. In the coefficients of all terms, only one a\nand one b should appear\n\nerr = (a + b) * ONE^6 - a * ONE^5 - (a + b) * ONE^4 + a * ONE^3 - b - (a + b) * ONE^2 + a * ONE\n*/\n\nvec2 twoSum(float a, float b) {\n  float s = (a + b);\n  float v = (s * ONE - a) * ONE;\n  float err = (a - (s - v) * ONE) * ONE * ONE * ONE + (b - v);\n  return vec2(s, err);\n}\n#else\nvec2 twoSum(float a, float b) {\n  float s = a + b;\n  float v = s - a;\n  float err = (a - (s - v)) + (b - v);\n  return vec2(s, err);\n}\n#endif\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\n/* Same thing as in twoSum() */\nvec2 twoSub(float a, float b) {\n  float s = (a - b);\n  float v = (s * ONE - a) * ONE;\n  float err = (a - (s - v) * ONE) * ONE * ONE * ONE - (b + v);\n  return vec2(s, err);\n}\n#else\nvec2 twoSub(float a, float b) {\n  float s = a - b;\n  float v = s - a;\n  float err = (a - (s - v)) - (b + v);\n  return vec2(s, err);\n}\n#endif\n\nvec2 twoProd(float a, float b) {\n  float prod = a * b;\n  vec2 a_fp64 = split(a);\n  vec2 b_fp64 = split(b);\n  float err = ((a_fp64.x * b_fp64.x - prod) + a_fp64.x * b_fp64.y +\n    a_fp64.y * b_fp64.x) + a_fp64.y * b_fp64.y;\n  return vec2(prod, err);\n}\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\nvec2 twoSqr(float a) {\n  float prod = a * a;\n  vec2 a_fp64 = split(a);\n\n  float err = ((a_fp64.x * a_fp64.x - prod) * ONE + 2.0 * a_fp64.x *\n    a_fp64.y * ONE * ONE) + a_fp64.y * a_fp64.y * ONE * ONE * ONE;\n  return vec2(prod, err);\n}\n#else\nvec2 twoSqr(float a) {\n  float prod = a * a;\n  vec2 a_fp64 = split(a);\n\n  float err = ((a_fp64.x * a_fp64.x - prod) + 2.0 * a_fp64.x * a_fp64.y) + a_fp64.y * a_fp64.y;\n  return vec2(prod, err);\n}\n#endif\n\nvec2 sum_fp64(vec2 a, vec2 b) {\n  vec2 s, t;\n  s = twoSum(a.x, b.x);\n  t = twoSum(a.y, b.y);\n  s.y += t.x;\n  s = quickTwoSum(s.x, s.y);\n  s.y += t.y;\n  s = quickTwoSum(s.x, s.y);\n  return s;\n}\n\nvec2 sub_fp64(vec2 a, vec2 b) {\n  vec2 s, t;\n  s = twoSub(a.x, b.x);\n  t = twoSub(a.y, b.y);\n  s.y += t.x;\n  s = quickTwoSum(s.x, s.y);\n  s.y += t.y;\n  s = quickTwoSum(s.x, s.y);\n  return s;\n}\n\nvec2 mul_fp64(vec2 a, vec2 b) {\n  vec2 prod = twoProd(a.x, b.x);\n  // y component is for the error\n  prod.y += a.x * b.y;\n  prod.y += a.y * b.x;\n  prod = quickTwoSum(prod.x, prod.y);\n  return prod;\n}\n\nvec2 div_fp64(vec2 a, vec2 b) {\n  float xn = 1.0 / b.x;\n  vec2 yn = a * xn;\n  float diff = (sub_fp64(a, mul_fp64(b, yn))).x;\n  vec2 prod = twoProd(xn, diff);\n  return sum_fp64(yn, prod);\n}\n\nvec2 sqrt_fp64(vec2 a) {\n\n  if (a.x == 0.0 && a.y == 0.0) return vec2(0.0, 0.0);\n  if (a.x < 0.0) return vec2(0.0 / 0.0, 0.0 / 0.0);\n\n  float x = 1.0 / sqrt(a.x);\n  float yn = a.x * x;\n#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)\n  vec2 yn_sqr = twoSqr(yn) * ONE;\n#else\n  vec2 yn_sqr = twoSqr(yn);\n#endif\n  float diff = sub_fp64(a, yn_sqr).x;\n  vec2 prod = twoProd(x * 0.5, diff);\n  return sum_fp64(vec2(yn, 0.0), prod);\n}\n\n/* k_power controls how much range reduction we would like to have\nRange reduction uses the following method:\nassume a = k_power * r + m * log(2), k and m being integers.\nSet k_power = 4 (we can choose other k to trade accuracy with performance.\nwe only need to calculate exp(r) and using exp(a) = 2^m * exp(r)^k_power;\n*/\n\nvec2 exp_fp64(vec2 a) {\n  // We need to make sure these two numbers match\n  // as bit-wise shift is not available in GLSL 1.0\n  const int k_power = 4;\n  const float k = 16.0;\n\n  const float inv_k = 1.0 / k;\n\n  if (a.x <= -88.0) return vec2(0.0, 0.0);\n  if (a.x >= 88.0) return vec2(1.0 / 0.0, 1.0 / 0.0);\n  if (a.x == 0.0 && a.y == 0.0) return vec2(1.0, 0.0);\n  if (a.x == 1.0 && a.y == 0.0) return E_FP64;\n\n  float m = floor(a.x / LOG2_FP64.x + 0.5);\n  vec2 r = sub_fp64(a, mul_fp64(LOG2_FP64, vec2(m, 0.0))) * inv_k;\n  vec2 s, t, p;\n\n  p = mul_fp64(r, r);\n  s = sum_fp64(r, p * 0.5);\n  p = mul_fp64(p, r);\n  t = mul_fp64(p, INVERSE_FACTORIAL_3_FP64);\n\n  s = sum_fp64(s, t);\n  p = mul_fp64(p, r);\n  t = mul_fp64(p, INVERSE_FACTORIAL_4_FP64);\n\n  s = sum_fp64(s, t);\n  p = mul_fp64(p, r);\n  t = mul_fp64(p, INVERSE_FACTORIAL_5_FP64);\n\n  // s = sum_fp64(s, t);\n  // p = mul_fp64(p, r);\n  // t = mul_fp64(p, INVERSE_FACTORIAL_6_FP64);\n\n  // s = sum_fp64(s, t);\n  // p = mul_fp64(p, r);\n  // t = mul_fp64(p, INVERSE_FACTORIAL_7_FP64);\n\n  s = sum_fp64(s, t);\n\n\n  // At this point, s = exp(r) - 1; but after following 4 recursions, we will get exp(r) ^ 512 - 1.\n  for (int i = 0; i < k_power; i++) {\n    s = sum_fp64(s * 2.0, mul_fp64(s, s));\n  }\n\n#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)\n  s = sum_fp64(s, vec2(ONE, 0.0));\n#else\n  s = sum_fp64(s, vec2(1.0, 0.0));\n#endif\n\n  return s * pow(2.0, m);\n//   return r;\n}\n\nvec2 log_fp64(vec2 a)\n{\n  if (a.x == 1.0 && a.y == 0.0) return vec2(0.0, 0.0);\n  if (a.x <= 0.0) return vec2(0.0 / 0.0, 0.0 / 0.0);\n  vec2 x = vec2(log(a.x), 0.0);\n  vec2 s;\n#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)\n  s = vec2(ONE, 0.0);\n#else\n  s = vec2(1.0, 0.0);\n#endif\n\n  x = sub_fp64(sum_fp64(x, mul_fp64(a, exp_fp64(-x))), s);\n  return x;\n}\n\nvec2 sin_taylor_fp64(vec2 a) {\n  vec2 r, s, t, x;\n\n  if (a.x == 0.0 && a.y == 0.0) {\n    return vec2(0.0, 0.0);\n  }\n\n  x = -mul_fp64(a, a);\n  s = a;\n  r = a;\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_3_FP64);\n  s = sum_fp64(s, t);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_5_FP64);\n  s = sum_fp64(s, t);\n\n  /* keep the following commented code in case we need them\n  for extra accuracy from the Taylor expansion*/\n\n  // r = mul_fp64(r, x);\n  // t = mul_fp64(r, INVERSE_FACTORIAL_7_FP64);\n  // s = sum_fp64(s, t);\n\n  // r = mul_fp64(r, x);\n  // t = mul_fp64(r, INVERSE_FACTORIAL_9_FP64);\n  // s = sum_fp64(s, t);\n\n  return s;\n}\n\nvec2 cos_taylor_fp64(vec2 a) {\n  vec2 r, s, t, x;\n\n  if (a.x == 0.0 && a.y == 0.0) {\n    return vec2(1.0, 0.0);\n  }\n\n  x = -mul_fp64(a, a);\n  r = x;\n  s = sum_fp64(vec2(1.0, 0.0), r * 0.5);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_4_FP64);\n  s = sum_fp64(s, t);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_6_FP64);\n  s = sum_fp64(s, t);\n\n  /* keep the following commented code in case we need them\n  for extra accuracy from the Taylor expansion*/\n\n  // r = mul_fp64(r, x);\n  // t = mul_fp64(r, INVERSE_FACTORIAL_8_FP64);\n  // s = sum_fp64(s, t);\n\n  // r = mul_fp64(r, x);\n  // t = mul_fp64(r, INVERSE_FACTORIAL_10_FP64);\n  // s = sum_fp64(s, t);\n\n  return s;\n}\n\nvoid sincos_taylor_fp64(vec2 a, out vec2 sin_t, out vec2 cos_t) {\n  if (a.x == 0.0 && a.y == 0.0) {\n    sin_t = vec2(0.0, 0.0);\n    cos_t = vec2(1.0, 0.0);\n  }\n\n  sin_t = sin_taylor_fp64(a);\n  cos_t = sqrt_fp64(sub_fp64(vec2(1.0, 0.0), mul_fp64(sin_t, sin_t)));\n}\n\nvec2 sin_fp64(vec2 a) {\n    if (a.x == 0.0 && a.y == 0.0) {\n        return vec2(0.0, 0.0);\n    }\n\n    // 2pi range reduction\n    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));\n    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));\n\n    vec2 t;\n    float q = floor(r.x / PI_2_FP64.x + 0.5);\n    int j = int(q);\n\n    if (j < -2 || j > 2) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    }\n\n    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));\n\n    q = floor(t.x / PI_16_FP64.x + 0.5);\n    int k = int(q);\n\n    if (k == 0) {\n        if (j == 0) {\n            return sin_taylor_fp64(t);\n        } else if (j == 1) {\n            return cos_taylor_fp64(t);\n        } else if (j == -1) {\n            return -cos_taylor_fp64(t);\n        } else {\n            return -sin_taylor_fp64(t);\n        }\n    }\n\n    int abs_k = int(abs(float(k)));\n\n    if (abs_k > 4) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    } else {\n        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));\n    }\n\n    vec2 u = vec2(0.0, 0.0);\n    vec2 v = vec2(0.0, 0.0);\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\n    if (abs(float(abs_k) - 1.0) < 0.5) {\n        u = COS_TABLE_0_FP64;\n        v = SIN_TABLE_0_FP64;\n    } else if (abs(float(abs_k) - 2.0) < 0.5) {\n        u = COS_TABLE_1_FP64;\n        v = SIN_TABLE_1_FP64;\n    } else if (abs(float(abs_k) - 3.0) < 0.5) {\n        u = COS_TABLE_2_FP64;\n        v = SIN_TABLE_2_FP64;\n    } else if (abs(float(abs_k) - 4.0) < 0.5) {\n        u = COS_TABLE_3_FP64;\n        v = SIN_TABLE_3_FP64;\n    }\n#else\n    if (abs_k == 1) {\n        u = COS_TABLE_0_FP64;\n        v = SIN_TABLE_0_FP64;\n    } else if (abs_k == 2) {\n        u = COS_TABLE_1_FP64;\n        v = SIN_TABLE_1_FP64;\n    } else if (abs_k == 3) {\n        u = COS_TABLE_2_FP64;\n        v = SIN_TABLE_2_FP64;\n    } else if (abs_k == 4) {\n        u = COS_TABLE_3_FP64;\n        v = SIN_TABLE_3_FP64;\n    }\n#endif\n\n    vec2 sin_t, cos_t;\n    sincos_taylor_fp64(t, sin_t, cos_t);\n\n\n\n    vec2 result = vec2(0.0, 0.0);\n    if (j == 0) {\n        if (k > 0) {\n            result = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        } else {\n            result = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        }\n    } else if (j == 1) {\n        if (k > 0) {\n            result = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        } else {\n            result = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        }\n    } else if (j == -1) {\n        if (k > 0) {\n            result = sub_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));\n        } else {\n            result = -sum_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));\n        }\n    } else {\n        if (k > 0) {\n            result = -sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        } else {\n            result = sub_fp64(mul_fp64(v, cos_t), mul_fp64(u, sin_t));\n        }\n    }\n\n    return result;\n}\n\nvec2 cos_fp64(vec2 a) {\n    if (a.x == 0.0 && a.y == 0.0) {\n        return vec2(1.0, 0.0);\n    }\n\n    // 2pi range reduction\n    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));\n    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));\n\n    vec2 t;\n    float q = floor(r.x / PI_2_FP64.x + 0.5);\n    int j = int(q);\n\n    if (j < -2 || j > 2) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    }\n\n    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));\n\n    q = floor(t.x / PI_16_FP64.x + 0.5);\n    int k = int(q);\n\n    if (k == 0) {\n        if (j == 0) {\n            return cos_taylor_fp64(t);\n        } else if (j == 1) {\n            return -sin_taylor_fp64(t);\n        } else if (j == -1) {\n            return sin_taylor_fp64(t);\n        } else {\n            return -cos_taylor_fp64(t);\n        }\n    }\n\n    int abs_k = int(abs(float(k)));\n\n    if (abs_k > 4) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    } else {\n        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));\n    }\n\n    vec2 u = vec2(0.0, 0.0);\n    vec2 v = vec2(0.0, 0.0);\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\n    if (abs(float(abs_k) - 1.0) < 0.5) {\n        u = COS_TABLE_0_FP64;\n        v = SIN_TABLE_0_FP64;\n    } else if (abs(float(abs_k) - 2.0) < 0.5) {\n        u = COS_TABLE_1_FP64;\n        v = SIN_TABLE_1_FP64;\n    } else if (abs(float(abs_k) - 3.0) < 0.5) {\n        u = COS_TABLE_2_FP64;\n        v = SIN_TABLE_2_FP64;\n    } else if (abs(float(abs_k) - 4.0) < 0.5) {\n        u = COS_TABLE_3_FP64;\n        v = SIN_TABLE_3_FP64;\n    }\n#else\n    if (abs_k == 1) {\n        u = COS_TABLE_0_FP64;\n        v = SIN_TABLE_0_FP64;\n    } else if (abs_k == 2) {\n        u = COS_TABLE_1_FP64;\n        v = SIN_TABLE_1_FP64;\n    } else if (abs_k == 3) {\n        u = COS_TABLE_2_FP64;\n        v = SIN_TABLE_2_FP64;\n    } else if (abs_k == 4) {\n        u = COS_TABLE_3_FP64;\n        v = SIN_TABLE_3_FP64;\n    }\n#endif\n\n    vec2 sin_t, cos_t;\n    sincos_taylor_fp64(t, sin_t, cos_t);\n\n    vec2 result = vec2(0.0, 0.0);\n    if (j == 0) {\n        if (k > 0) {\n            result = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        } else {\n            result = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        }\n    } else if (j == 1) {\n        if (k > 0) {\n            result = -sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        } else {\n            result = sub_fp64(mul_fp64(v, cos_t), mul_fp64(u, sin_t));\n        }\n    } else if (j == -1) {\n        if (k > 0) {\n            result = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        } else {\n            result = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        }\n    } else {\n        if (k > 0) {\n            result = sub_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));\n        } else {\n            result = -sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        }\n    }\n\n    return result;\n}\n\nvec2 tan_fp64(vec2 a) {\n    vec2 sin_a;\n    vec2 cos_a;\n\n    if (a.x == 0.0 && a.y == 0.0) {\n        return vec2(0.0, 0.0);\n    }\n\n    // 2pi range reduction\n    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));\n    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));\n\n    vec2 t;\n    float q = floor(r.x / PI_2_FP64.x + 0.5);\n    int j = int(q);\n\n\n    if (j < -2 || j > 2) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    }\n\n    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));\n\n    q = floor(t.x / PI_16_FP64.x + 0.5);\n    int k = int(q);\n    int abs_k = int(abs(float(k)));\n\n    // We just can't get PI/16 * 3.0 very accurately.\n    // so let's just store it\n    if (abs_k > 4) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    } else {\n        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));\n    }\n\n\n    vec2 u = vec2(0.0, 0.0);\n    vec2 v = vec2(0.0, 0.0);\n\n    vec2 sin_t, cos_t;\n    vec2 s, c;\n    sincos_taylor_fp64(t, sin_t, cos_t);\n\n    if (k == 0) {\n        s = sin_t;\n        c = cos_t;\n    } else {\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\n        if (abs(float(abs_k) - 1.0) < 0.5) {\n            u = COS_TABLE_0_FP64;\n            v = SIN_TABLE_0_FP64;\n        } else if (abs(float(abs_k) - 2.0) < 0.5) {\n            u = COS_TABLE_1_FP64;\n            v = SIN_TABLE_1_FP64;\n        } else if (abs(float(abs_k) - 3.0) < 0.5) {\n            u = COS_TABLE_2_FP64;\n            v = SIN_TABLE_2_FP64;\n        } else if (abs(float(abs_k) - 4.0) < 0.5) {\n            u = COS_TABLE_3_FP64;\n            v = SIN_TABLE_3_FP64;\n        }\n#else\n        if (abs_k == 1) {\n            u = COS_TABLE_0_FP64;\n            v = SIN_TABLE_0_FP64;\n        } else if (abs_k == 2) {\n            u = COS_TABLE_1_FP64;\n            v = SIN_TABLE_1_FP64;\n        } else if (abs_k == 3) {\n            u = COS_TABLE_2_FP64;\n            v = SIN_TABLE_2_FP64;\n        } else if (abs_k == 4) {\n            u = COS_TABLE_3_FP64;\n            v = SIN_TABLE_3_FP64;\n        }\n#endif\n        if (k > 0) {\n            s = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n            c = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        } else {\n            s = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n            c = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        }\n    }\n\n    if (j == 0) {\n        sin_a = s;\n        cos_a = c;\n    } else if (j == 1) {\n        sin_a = c;\n        cos_a = -s;\n    } else if (j == -1) {\n        sin_a = -c;\n        cos_a = s;\n    } else {\n        sin_a = -s;\n        cos_a = -c;\n    }\n    return div_fp64(sin_a, cos_a);\n}\n\nvec2 radians_fp64(vec2 degree) {\n  return mul_fp64(degree, PI_180_FP64);\n}\n\nvec2 mix_fp64(vec2 a, vec2 b, float x) {\n  vec2 range = sub_fp64(b, a);\n  return sum_fp64(a, mul_fp64(range, vec2(x, 0.0)));\n}\n\n// Vector functions\n// vec2 functions\nvoid vec2_sum_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {\n    out_val[0] = sum_fp64(a[0], b[0]);\n    out_val[1] = sum_fp64(a[1], b[1]);\n}\n\nvoid vec2_sub_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {\n    out_val[0] = sub_fp64(a[0], b[0]);\n    out_val[1] = sub_fp64(a[1], b[1]);\n}\n\nvoid vec2_mul_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {\n    out_val[0] = mul_fp64(a[0], b[0]);\n    out_val[1] = mul_fp64(a[1], b[1]);\n}\n\nvoid vec2_div_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {\n    out_val[0] = div_fp64(a[0], b[0]);\n    out_val[1] = div_fp64(a[1], b[1]);\n}\n\nvoid vec2_mix_fp64(vec2 x[2], vec2 y[2], float a, out vec2 out_val[2]) {\n  vec2 range[2];\n  vec2_sub_fp64(y, x, range);\n  vec2 portion[2];\n  portion[0] = range[0] * a;\n  portion[1] = range[1] * a;\n  vec2_sum_fp64(x, portion, out_val);\n}\n\nvec2 vec2_length_fp64(vec2 x[2]) {\n  return sqrt_fp64(sum_fp64(mul_fp64(x[0], x[0]), mul_fp64(x[1], x[1])));\n}\n\nvoid vec2_normalize_fp64(vec2 x[2], out vec2 out_val[2]) {\n  vec2 length = vec2_length_fp64(x);\n  vec2 length_vec2[2];\n  length_vec2[0] = length;\n  length_vec2[1] = length;\n\n  vec2_div_fp64(x, length_vec2, out_val);\n}\n\nvec2 vec2_distance_fp64(vec2 x[2], vec2 y[2]) {\n  vec2 diff[2];\n  vec2_sub_fp64(x, y, diff);\n  return vec2_length_fp64(diff);\n}\n\nvec2 vec2_dot_fp64(vec2 a[2], vec2 b[2]) {\n  vec2 v[2];\n\n  v[0] = mul_fp64(a[0], b[0]);\n  v[1] = mul_fp64(a[1], b[1]);\n\n  return sum_fp64(v[0], v[1]);\n}\n\n// vec3 functions\nvoid vec3_sub_fp64(vec2 a[3], vec2 b[3], out vec2 out_val[3]) {\n  for (int i = 0; i < 3; i++) {\n    out_val[i] = sum_fp64(a[i], b[i]);\n  }\n}\n\nvoid vec3_sum_fp64(vec2 a[3], vec2 b[3], out vec2 out_val[3]) {\n  for (int i = 0; i < 3; i++) {\n    out_val[i] = sum_fp64(a[i], b[i]);\n  }\n}\n\nvec2 vec3_length_fp64(vec2 x[3]) {\n  return sqrt_fp64(sum_fp64(sum_fp64(mul_fp64(x[0], x[0]), mul_fp64(x[1], x[1])),\n    mul_fp64(x[2], x[2])));\n}\n\nvec2 vec3_distance_fp64(vec2 x[3], vec2 y[3]) {\n  vec2 diff[3];\n  vec3_sub_fp64(x, y, diff);\n  return vec3_length_fp64(diff);\n}\n\n// vec4 functions\nvoid vec4_fp64(vec4 a, out vec2 out_val[4]) {\n  out_val[0].x = a[0];\n  out_val[0].y = 0.0;\n\n  out_val[1].x = a[1];\n  out_val[1].y = 0.0;\n\n  out_val[2].x = a[2];\n  out_val[2].y = 0.0;\n\n  out_val[3].x = a[3];\n  out_val[3].y = 0.0;\n}\n\nvoid vec4_scalar_mul_fp64(vec2 a[4], vec2 b, out vec2 out_val[4]) {\n  out_val[0] = mul_fp64(a[0], b);\n  out_val[1] = mul_fp64(a[1], b);\n  out_val[2] = mul_fp64(a[2], b);\n  out_val[3] = mul_fp64(a[3], b);\n}\n\nvoid vec4_sum_fp64(vec2 a[4], vec2 b[4], out vec2 out_val[4]) {\n  for (int i = 0; i < 4; i++) {\n    out_val[i] = sum_fp64(a[i], b[i]);\n  }\n}\n\nvoid vec4_dot_fp64(vec2 a[4], vec2 b[4], out vec2 out_val) {\n  vec2 v[4];\n\n  v[0] = mul_fp64(a[0], b[0]);\n  v[1] = mul_fp64(a[1], b[1]);\n  v[2] = mul_fp64(a[2], b[2]);\n  v[3] = mul_fp64(a[3], b[3]);\n\n  out_val = sum_fp64(sum_fp64(v[0], v[1]), sum_fp64(v[2], v[3]));\n}\n\nvoid mat4_vec4_mul_fp64(vec2 b[16], vec2 a[4], out vec2 out_val[4]) {\n  vec2 tmp[4];\n\n  for (int i = 0; i < 4; i++)\n  {\n    for (int j = 0; j < 4; j++)\n    {\n      tmp[j] = b[j + i * 4];\n    }\n    vec4_dot_fp64(a, tmp, out_val[i]);\n  }\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lighting = undefined;
	
	var _lighting = __webpack_require__(842);
	
	var _lighting2 = _interopRequireDefault(_lighting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lighting = exports.lighting = {
	  interface: 'lighting',
	  source: _lighting2.default
	}; // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 842 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// lighting
	
	exports.default = "#define NUM_OF_LIGHTS 2\nuniform vec3 cameraPos;\nuniform vec3 lightsPosition[16];\nuniform vec2 lightsStrength[16];\nuniform float ambientRatio;\nuniform float diffuseRatio;\nuniform float specularRatio;\n\nfloat getLightWeight(vec4 position_worldspace, vec3 normals_worldspace) {\n  float lightWeight = 0.0;\n\n  vec3 position_worldspace_vec3 = position_worldspace.xyz / position_worldspace.w;\n  vec3 normals_worldspace_vec3 = normals_worldspace.xzy;\n\n  vec3 camera_pos_worldspace = cameraPos;\n  vec3 view_direction = normalize(camera_pos_worldspace - position_worldspace_vec3);\n\n  for (int i = 0; i < NUM_OF_LIGHTS; i++) {\n    vec3 light_position_worldspace = project_position(lightsPosition[i]);\n    vec3 light_direction = normalize(light_position_worldspace - position_worldspace_vec3);\n\n    vec3 halfway_direction = normalize(light_direction + view_direction);\n    float lambertian = dot(light_direction, normals_worldspace_vec3);\n    float specular = 0.0;\n    if (lambertian > 0.0) {\n      float specular_angle = max(dot(normals_worldspace_vec3, halfway_direction), 0.0);\n      specular = pow(specular_angle, 32.0);\n    }\n    lambertian = max(lambertian, 0.0);\n    lightWeight += (ambientRatio + lambertian * diffuseRatio + specular * specularRatio) *\n      lightsStrength[i].x;\n\n  }\n\n  return lightWeight;\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.project = undefined;
	
	var _project = __webpack_require__(844);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var project = exports.project = {
	  interface: 'project',
	  source: _project2.default
	}; // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaGFkZXJsaWIvcHJvamVjdC9pbmRleC5qcyJdLCJuYW1lcyI6WyJwcm9qZWN0IiwiaW50ZXJmYWNlIiwic291cmNlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBb0JBOzs7Ozs7QUFFTyxJQUFNQSw0QkFBVTtBQUNyQkMsYUFBVyxTQURVO0FBRXJCQztBQUZxQixDQUFoQixDLENBdEJQO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQ29weXJpZ2h0IChjKSAyMDE1IC0gMjAxNyBVYmVyIFRlY2hub2xvZ2llcywgSW5jLlxuLy9cbi8vIFBlcm1pc3Npb24gaXMgaGVyZWJ5IGdyYW50ZWQsIGZyZWUgb2YgY2hhcmdlLCB0byBhbnkgcGVyc29uIG9idGFpbmluZyBhIGNvcHlcbi8vIG9mIHRoaXMgc29mdHdhcmUgYW5kIGFzc29jaWF0ZWQgZG9jdW1lbnRhdGlvbiBmaWxlcyAodGhlIFwiU29mdHdhcmVcIiksIHRvIGRlYWxcbi8vIGluIHRoZSBTb2Z0d2FyZSB3aXRob3V0IHJlc3RyaWN0aW9uLCBpbmNsdWRpbmcgd2l0aG91dCBsaW1pdGF0aW9uIHRoZSByaWdodHNcbi8vIHRvIHVzZSwgY29weSwgbW9kaWZ5LCBtZXJnZSwgcHVibGlzaCwgZGlzdHJpYnV0ZSwgc3VibGljZW5zZSwgYW5kL29yIHNlbGxcbi8vIGNvcGllcyBvZiB0aGUgU29mdHdhcmUsIGFuZCB0byBwZXJtaXQgcGVyc29ucyB0byB3aG9tIHRoZSBTb2Z0d2FyZSBpc1xuLy8gZnVybmlzaGVkIHRvIGRvIHNvLCBzdWJqZWN0IHRvIHRoZSBmb2xsb3dpbmcgY29uZGl0aW9uczpcbi8vXG4vLyBUaGUgYWJvdmUgY29weXJpZ2h0IG5vdGljZSBhbmQgdGhpcyBwZXJtaXNzaW9uIG5vdGljZSBzaGFsbCBiZSBpbmNsdWRlZCBpblxuLy8gYWxsIGNvcGllcyBvciBzdWJzdGFudGlhbCBwb3J0aW9ucyBvZiB0aGUgU29mdHdhcmUuXG4vL1xuLy8gVEhFIFNPRlRXQVJFIElTIFBST1ZJREVEIFwiQVMgSVNcIiwgV0lUSE9VVCBXQVJSQU5UWSBPRiBBTlkgS0lORCwgRVhQUkVTUyBPUlxuLy8gSU1QTElFRCwgSU5DTFVESU5HIEJVVCBOT1QgTElNSVRFRCBUTyBUSEUgV0FSUkFOVElFUyBPRiBNRVJDSEFOVEFCSUxJVFksXG4vLyBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRSBBTkQgTk9OSU5GUklOR0VNRU5ULiBJTiBOTyBFVkVOVCBTSEFMTCBUSEVcbi8vIEFVVEhPUlMgT1IgQ09QWVJJR0hUIEhPTERFUlMgQkUgTElBQkxFIEZPUiBBTlkgQ0xBSU0sIERBTUFHRVMgT1IgT1RIRVJcbi8vIExJQUJJTElUWSwgV0hFVEhFUiBJTiBBTiBBQ1RJT04gT0YgQ09OVFJBQ1QsIFRPUlQgT1IgT1RIRVJXSVNFLCBBUklTSU5HIEZST00sXG4vLyBPVVQgT0YgT1IgSU4gQ09OTkVDVElPTiBXSVRIIFRIRSBTT0ZUV0FSRSBPUiBUSEUgVVNFIE9SIE9USEVSIERFQUxJTkdTIElOXG4vLyBUSEUgU09GVFdBUkUuXG5cbmltcG9ydCBwcm9qZWN0U2hhZGVyIGZyb20gJy4vcHJvamVjdC5nbHNsJztcblxuZXhwb3J0IGNvbnN0IHByb2plY3QgPSB7XG4gIGludGVyZmFjZTogJ3Byb2plY3QnLFxuICBzb3VyY2U6IHByb2plY3RTaGFkZXJcbn07XG4iXX0=

/***/ },
/* 844 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "const float TILE_SIZE = 512.0;\nconst float PI = 3.1415926536;\nconst float WORLD_SCALE = TILE_SIZE / (PI * 2.0);\n\n// ref: lib/constants.js\nconst float PROJECT_IDENTITY = 0.;\nconst float PROJECT_MERCATOR = 1.;\nconst float PROJECT_MERCATOR_OFFSETS = 2.;\n\nuniform float projectionMode;\nuniform float projectionScale;\nuniform vec4 projectionCenter;\nuniform vec3 projectionPixelsPerUnit;\n\nuniform mat4 modelViewMatrix;\nuniform mat4 projectionMatrix;\nuniform mat4 projectionMatrixUncentered;\n\n#ifdef INTEL_TAN_WORKAROUND\n\n// All these functions are for substituting tan() function from Intel GPU only\nconst float TWO_PI = 6.2831854820251465;\nconst float PI_2 = 1.5707963705062866;\nconst float PI_16 = 0.1963495463132858;\n\nconst float SIN_TABLE_0 = 0.19509032368659973;\nconst float SIN_TABLE_1 = 0.3826834261417389;\nconst float SIN_TABLE_2 = 0.5555702447891235;\nconst float SIN_TABLE_3 = 0.7071067690849304;\n\nconst float COS_TABLE_0 = 0.9807852506637573;\nconst float COS_TABLE_1 = 0.9238795042037964;\nconst float COS_TABLE_2 = 0.8314695954322815;\nconst float COS_TABLE_3 = 0.7071067690849304;\n\nconst float INVERSE_FACTORIAL_3 = 1.666666716337204e-01; // 1/3!\nconst float INVERSE_FACTORIAL_5 = 8.333333767950535e-03; // 1/5!\nconst float INVERSE_FACTORIAL_7 = 1.9841270113829523e-04; // 1/7!\nconst float INVERSE_FACTORIAL_9 = 2.75573188446287533e-06; // 1/9!\n\nfloat sin_taylor_fp32(float a) {\n  float r, s, t, x;\n\n  if (a == 0.0) {\n    return 0.0;\n  }\n\n  x = -a * a;\n  s = a;\n  r = a;\n\n  r = r * x;\n  t = r * INVERSE_FACTORIAL_3;\n  s = s + t;\n\n  r = r * x;\n  t = r * INVERSE_FACTORIAL_5;\n  s = s + t;\n\n  r = r * x;\n  t = r * INVERSE_FACTORIAL_7;\n  s = s + t;\n\n  r = r * x;\n  t = r * INVERSE_FACTORIAL_9;\n  s = s + t;\n\n  return s;\n}\n\nvoid sincos_taylor_fp32(float a, out float sin_t, out float cos_t) {\n  if (a == 0.0) {\n    sin_t = 0.0;\n    cos_t = 1.0;\n  }\n  sin_t = sin_taylor_fp32(a);\n  cos_t = sqrt(1.0 - sin_t * sin_t);\n}\n\nfloat tan_taylor_fp32(float a) {\n    float sin_a;\n    float cos_a;\n\n    if (a == 0.0) {\n        return 0.0;\n    }\n\n    // 2pi range reduction\n    float z = floor(a / TWO_PI);\n    float r = a - TWO_PI * z;\n\n    float t;\n    float q = floor(r / PI_2 + 0.5);\n    int j = int(q);\n\n    if (j < -2 || j > 2) {\n        return 0.0 / 0.0;\n    }\n\n    t = r - PI_2 * q;\n\n    q = floor(t / PI_16 + 0.5);\n    int k = int(q);\n    int abs_k = int(abs(float(k)));\n\n    if (abs_k > 4) {\n        return 0.0 / 0.0;\n    } else {\n        t = t - PI_16 * q;\n    }\n\n    float u = 0.0;\n    float v = 0.0;\n\n    float sin_t, cos_t;\n    float s, c;\n    sincos_taylor_fp32(t, sin_t, cos_t);\n\n    if (k == 0) {\n        s = sin_t;\n        c = cos_t;\n    } else {\n        if (abs(float(abs_k) - 1.0) < 0.5) {\n            u = COS_TABLE_0;\n            v = SIN_TABLE_0;\n        } else if (abs(float(abs_k) - 2.0) < 0.5) {\n            u = COS_TABLE_1;\n            v = SIN_TABLE_1;\n        } else if (abs(float(abs_k) - 3.0) < 0.5) {\n            u = COS_TABLE_2;\n            v = SIN_TABLE_2;\n        } else if (abs(float(abs_k) - 4.0) < 0.5) {\n            u = COS_TABLE_3;\n            v = SIN_TABLE_3;\n        }\n        if (k > 0) {\n            s = u * sin_t + v * cos_t;\n            c = u * cos_t - v * sin_t;\n        } else {\n            s = u * sin_t - v * cos_t;\n            c = u * cos_t + v * sin_t;\n        }\n    }\n\n    if (j == 0) {\n        sin_a = s;\n        cos_a = c;\n    } else if (j == 1) {\n        sin_a = c;\n        cos_a = -s;\n    } else if (j == -1) {\n        sin_a = -c;\n        cos_a = s;\n    } else {\n        sin_a = -s;\n        cos_a = -c;\n    }\n    return sin_a / cos_a;\n}\n#endif\n\nfloat tan_fp32(float a) {\n#ifdef INTEL_TAN_WORKAROUND\n  return tan_taylor_fp32(a);\n#else\n  return tan(a);\n#endif\n}\n\n//\n// Scaling offsets\n//\n\nfloat project_scale(float meters) {\n  if (projectionMode == PROJECT_MERCATOR_OFFSETS) {\n    return meters;\n  } else {\n    return meters * projectionPixelsPerUnit.x;\n  }\n}\n\nvec2 project_scale(vec2 meters) {\n  if (projectionMode == PROJECT_MERCATOR_OFFSETS) {\n    return meters;\n  } else {\n    return vec2(\n      meters.x * projectionPixelsPerUnit.x,\n      meters.y * projectionPixelsPerUnit.x\n    );\n  }\n}\n\nvec3 project_scale(vec3 meters) {\n  if (projectionMode == PROJECT_MERCATOR_OFFSETS) {\n    return meters;\n  } else {\n    return vec3(\n      meters.x * projectionPixelsPerUnit.x,\n      meters.y * projectionPixelsPerUnit.x,\n      meters.z * projectionPixelsPerUnit.x\n    );\n  }\n}\n\nvec4 project_scale(vec4 meters) {\n  if (projectionMode == PROJECT_MERCATOR_OFFSETS) {\n    return meters;\n  } else {\n    return vec4(\n      meters.x * projectionPixelsPerUnit.x,\n      meters.y * projectionPixelsPerUnit.x,\n      meters.z * projectionPixelsPerUnit.x,\n      meters.w\n    );\n  }\n}\n\n//\n// Projecting positions\n//\n\n// non-linear projection: lnglats => unit tile [0-1, 0-1]\nvec2 project_mercator_(vec2 lnglat) {\n  return vec2(\n    radians(lnglat.x) + PI,\n    PI - log(tan_fp32(PI * 0.25 + radians(lnglat.y) * 0.5))\n  );\n}\n\nvec2 project_position(vec2 position) {\n  if (projectionMode == PROJECT_IDENTITY) {\n    return position;\n  }\n  if (projectionMode == PROJECT_MERCATOR_OFFSETS) {\n    return position;\n    return project_scale(position);\n  }\n  // Covers projectionMode == PROJECT_MERCATOR\n  return project_mercator_(position) * WORLD_SCALE * projectionScale;\n}\n\nvec3 project_position(vec3 position) {\n  return vec3(project_position(position.xy), project_scale(position.z));\n}\n\nvec4 project_position(vec4 position) {\n  return vec4(project_position(position.xyz), position.w);\n}\n\n//\n\nvec4 project_to_viewspace(vec4 position) {\n  return modelViewMatrix * position;\n}\n\nvec4 project_to_clipspace(vec4 position) {\n  if (projectionMode == PROJECT_MERCATOR_OFFSETS) {\n    position = position * projectionPixelsPerUnit.x;\n  }\n  return projectionMatrix * position + projectionCenter;\n}\n\n// Backwards compatibility\n\nfloat scale(float position) {\n  return project_scale(position);\n}\n\nvec2 scale(vec2 position) {\n  return project_scale(position);\n}\n\nvec3 scale(vec3 position) {\n  return project_scale(position);\n}\n\nvec4 scale(vec4 position) {\n  return project_scale(position);\n}\n\nvec2 preproject(vec2 position) {\n  return project_position(position);\n}\n\nvec3 preproject(vec3 position) {\n  return project_position(position);\n}\n\nvec4 preproject(vec4 position) {\n  return project_position(position);\n}\n\nvec4 project(vec4 position) {\n  return project_to_clipspace(position);\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.project64 = undefined;
	
	var _project = __webpack_require__(846);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var project64 = exports.project64 = {
	  interface: 'project64',
	  source: _project2.default
	}; // Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 846 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = "\nconst vec2 WORLD_SCALE_FP64 = vec2(81.4873275756836, 0.0000032873668232014097);\n\nuniform vec2 projectionScaleFP64;\nuniform vec2 projectionFP64[16];\n\n// longitude: lnglat_fp64.xy; latitude: lnglat_fp64.zw\nvoid mercatorProject_fp64(vec4 lnglat_fp64, out vec2 out_val[2]) {\n\n#if defined(NVIDIA_FP64_WORKAROUND)\n  out_val[0] = sum_fp64(radians_fp64(lnglat_fp64.xy), PI_FP64 * ONE);\n#else\n  out_val[0] = sum_fp64(radians_fp64(lnglat_fp64.xy), PI_FP64);\n#endif\n  out_val[1] = sub_fp64(PI_FP64,\n    log_fp64(tan_fp64(sum_fp64(PI_4_FP64, radians_fp64(lnglat_fp64.zw) / 2.0))));\n  return;\n}\n\nvoid project_position_fp64(vec4 position_fp64, out vec2 out_val[2]) {\n\n  vec2 pos_fp64[2];\n  mercatorProject_fp64(position_fp64, pos_fp64);\n  vec2 x_fp64 = mul_fp64(pos_fp64[0], projectionScaleFP64);\n  vec2 y_fp64 = mul_fp64(pos_fp64[1], projectionScaleFP64);\n  out_val[0] = mul_fp64(x_fp64, WORLD_SCALE_FP64);\n  out_val[1] = mul_fp64(y_fp64, WORLD_SCALE_FP64);\n\n  return;\n}\n\nvec4 project_to_clipspace_fp64(vec2 vertex_pos_modelspace[4]) {\n  vec2 vertex_pos_clipspace[4];\n  mat4_vec4_mul_fp64(projectionFP64, vertex_pos_modelspace, vertex_pos_clipspace);\n  return vec4(\n    vertex_pos_clipspace[0].x,\n    vertex_pos_clipspace[1].x,\n    vertex_pos_clipspace[2].x,\n    vertex_pos_clipspace[3].x\n    );\n}\n";
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 847 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var BinSorter = function () {
	  function BinSorter(bins) {
	    _classCallCheck(this, BinSorter);
	
	    this.sortedBins = this.getSortedCounts(bins);
	  }
	
	  /**
	   * Get an array of object with sorted count and index of bins
	   * @param {Array} bins
	   * @return {Array} array of count and index lookup
	   */
	
	
	  _createClass(BinSorter, [{
	    key: "getSortedCounts",
	    value: function getSortedCounts(bins) {
	      return bins.map(function (h, i) {
	        return { i: i, counts: h.points.length };
	      }).sort(function (a, b) {
	        return a.counts - b.counts;
	      });
	    }
	
	    /**
	     * Get an array of object with sorted count and index of bins
	     * @param {Number[]} range
	     * @param {Number} range[0] - lower bound
	     * @param {Number} range[1] - upper bound
	     * @return {Array} array of nuw count range
	     */
	
	  }, {
	    key: "getCountRange",
	    value: function getCountRange(_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          lower = _ref2[0],
	          upper = _ref2[1];
	
	      var len = this.sortedBins.length;
	      var lowerIdx = Math.ceil(lower / 100 * (len - 1));
	      var upperIdx = Math.floor(upper / 100 * (len - 1));
	
	      return [this.sortedBins[lowerIdx].counts, this.sortedBins[upperIdx].counts];
	    }
	
	    /**
	     * Get ths max count of all bins
	     * @return {Number | Boolean} max count
	     */
	
	  }, {
	    key: "getMaxCount",
	    value: function getMaxCount() {
	      return this.sortedBins.length && this.sortedBins[this.sortedBins.length - 1].counts;
	    }
	  }]);
	
	  return BinSorter;
	}();
	
	exports.default = BinSorter;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(850);
	var isArguments = __webpack_require__(849);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 849 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 850 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(852);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
	}
	module.exports = exports['default'];

/***/ },
/* 852 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ },
/* 853 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(400);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(400);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ },
/* 856 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 857 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 858 */
857,
/* 859 */
857,
/* 860 */
857,
/* 861 */
857,
/* 862 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(862);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(872);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var createArrayFromMixed = __webpack_require__(865);
	var getMarkupWrap = __webpack_require__(867);
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 868 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 869 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(869);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 871 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(871);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 873 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.5d5d9eef.svg";

/***/ },
/* 875 */
/***/ function(module, exports) {

	module.exports = {
	  ACTIVE_ATTRIBUTES: 35721,
	  ACTIVE_ATTRIBUTE_MAX_LENGTH: 35722,
	  ACTIVE_TEXTURE: 34016,
	  ACTIVE_UNIFORMS: 35718,
	  ACTIVE_UNIFORM_MAX_LENGTH: 35719,
	  ALIASED_LINE_WIDTH_RANGE: 33902,
	  ALIASED_POINT_SIZE_RANGE: 33901,
	  ALPHA: 6406,
	  ALPHA_BITS: 3413,
	  ALWAYS: 519,
	  ARRAY_BUFFER: 34962,
	  ARRAY_BUFFER_BINDING: 34964,
	  ATTACHED_SHADERS: 35717,
	  BACK: 1029,
	  BLEND: 3042,
	  BLEND_COLOR: 32773,
	  BLEND_DST_ALPHA: 32970,
	  BLEND_DST_RGB: 32968,
	  BLEND_EQUATION: 32777,
	  BLEND_EQUATION_ALPHA: 34877,
	  BLEND_EQUATION_RGB: 32777,
	  BLEND_SRC_ALPHA: 32971,
	  BLEND_SRC_RGB: 32969,
	  BLUE_BITS: 3412,
	  BOOL: 35670,
	  BOOL_VEC2: 35671,
	  BOOL_VEC3: 35672,
	  BOOL_VEC4: 35673,
	  BROWSER_DEFAULT_WEBGL: 37444,
	  BUFFER_SIZE: 34660,
	  BUFFER_USAGE: 34661,
	  BYTE: 5120,
	  CCW: 2305,
	  CLAMP_TO_EDGE: 33071,
	  COLOR_ATTACHMENT0: 36064,
	  COLOR_BUFFER_BIT: 16384,
	  COLOR_CLEAR_VALUE: 3106,
	  COLOR_WRITEMASK: 3107,
	  COMPILE_STATUS: 35713,
	  COMPRESSED_TEXTURE_FORMATS: 34467,
	  CONSTANT_ALPHA: 32771,
	  CONSTANT_COLOR: 32769,
	  CONTEXT_LOST_WEBGL: 37442,
	  CULL_FACE: 2884,
	  CULL_FACE_MODE: 2885,
	  CURRENT_PROGRAM: 35725,
	  CURRENT_VERTEX_ATTRIB: 34342,
	  CW: 2304,
	  DECR: 7683,
	  DECR_WRAP: 34056,
	  DELETE_STATUS: 35712,
	  DEPTH_ATTACHMENT: 36096,
	  DEPTH_BITS: 3414,
	  DEPTH_BUFFER_BIT: 256,
	  DEPTH_CLEAR_VALUE: 2931,
	  DEPTH_COMPONENT: 6402,
	  DEPTH_COMPONENT16: 33189,
	  DEPTH_FUNC: 2932,
	  DEPTH_RANGE: 2928,
	  DEPTH_STENCIL: 34041,
	  DEPTH_STENCIL_ATTACHMENT: 33306,
	  DEPTH_TEST: 2929,
	  DEPTH_WRITEMASK: 2930,
	  DITHER: 3024,
	  DONT_CARE: 4352,
	  DST_ALPHA: 772,
	  DST_COLOR: 774,
	  DYNAMIC_DRAW: 35048,
	  ELEMENT_ARRAY_BUFFER: 34963,
	  ELEMENT_ARRAY_BUFFER_BINDING: 34965,
	  EQUAL: 514,
	  FASTEST: 4353,
	  FLOAT: 5126,
	  FLOAT_MAT2: 35674,
	  FLOAT_MAT3: 35675,
	  FLOAT_MAT4: 35676,
	  FLOAT_VEC2: 35664,
	  FLOAT_VEC3: 35665,
	  FLOAT_VEC4: 35666,
	  FRAGMENT_SHADER: 35632,
	  FRAMEBUFFER: 36160,
	  FRAMEBUFFER_ATTACHMENT_OBJECT_NAME: 36049,
	  FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE: 36048,
	  FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE: 36051,
	  FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL: 36050,
	  FRAMEBUFFER_BINDING: 36006,
	  FRAMEBUFFER_COMPLETE: 36053,
	  FRAMEBUFFER_INCOMPLETE_ATTACHMENT: 36054,
	  FRAMEBUFFER_INCOMPLETE_DIMENSIONS: 36057,
	  FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT: 36055,
	  FRAMEBUFFER_UNSUPPORTED: 36061,
	  FRONT: 1028,
	  FRONT_AND_BACK: 1032,
	  FRONT_FACE: 2886,
	  FUNC_ADD: 32774,
	  FUNC_REVERSE_SUBTRACT: 32779,
	  FUNC_SUBTRACT: 32778,
	  GENERATE_MIPMAP_HINT: 33170,
	  GEQUAL: 518,
	  GREATER: 516,
	  GREEN_BITS: 3411,
	  HIGH_FLOAT: 36338,
	  HIGH_INT: 36341,
	  INCR: 7682,
	  INCR_WRAP: 34055,
	  INFO_LOG_LENGTH: 35716,
	  INT: 5124,
	  INT_VEC2: 35667,
	  INT_VEC3: 35668,
	  INT_VEC4: 35669,
	  INVALID_ENUM: 1280,
	  INVALID_FRAMEBUFFER_OPERATION: 1286,
	  INVALID_OPERATION: 1282,
	  INVALID_VALUE: 1281,
	  INVERT: 5386,
	  KEEP: 7680,
	  LEQUAL: 515,
	  LESS: 513,
	  LINEAR: 9729,
	  LINEAR_MIPMAP_LINEAR: 9987,
	  LINEAR_MIPMAP_NEAREST: 9985,
	  LINES: 1,
	  LINE_LOOP: 2,
	  LINE_STRIP: 3,
	  LINE_WIDTH: 2849,
	  LINK_STATUS: 35714,
	  LOW_FLOAT: 36336,
	  LOW_INT: 36339,
	  LUMINANCE: 6409,
	  LUMINANCE_ALPHA: 6410,
	  MAX_COMBINED_TEXTURE_IMAGE_UNITS: 35661,
	  MAX_CUBE_MAP_TEXTURE_SIZE: 34076,
	  MAX_FRAGMENT_UNIFORM_VECTORS: 36349,
	  MAX_RENDERBUFFER_SIZE: 34024,
	  MAX_TEXTURE_IMAGE_UNITS: 34930,
	  MAX_TEXTURE_SIZE: 3379,
	  MAX_VARYING_VECTORS: 36348,
	  MAX_VERTEX_ATTRIBS: 34921,
	  MAX_VERTEX_TEXTURE_IMAGE_UNITS: 35660,
	  MAX_VERTEX_UNIFORM_VECTORS: 36347,
	  MAX_VIEWPORT_DIMS: 3386,
	  MEDIUM_FLOAT: 36337,
	  MEDIUM_INT: 36340,
	  MIRRORED_REPEAT: 33648,
	  NEAREST: 9728,
	  NEAREST_MIPMAP_LINEAR: 9986,
	  NEAREST_MIPMAP_NEAREST: 9984,
	  NEVER: 512,
	  NICEST: 4354,
	  NONE: 0,
	  NOTEQUAL: 517,
	  NO_ERROR: 0,
	  NUM_COMPRESSED_TEXTURE_FORMATS: 34466,
	  ONE: 1,
	  ONE_MINUS_CONSTANT_ALPHA: 32772,
	  ONE_MINUS_CONSTANT_COLOR: 32770,
	  ONE_MINUS_DST_ALPHA: 773,
	  ONE_MINUS_DST_COLOR: 775,
	  ONE_MINUS_SRC_ALPHA: 771,
	  ONE_MINUS_SRC_COLOR: 769,
	  OUT_OF_MEMORY: 1285,
	  PACK_ALIGNMENT: 3333,
	  POINTS: 0,
	  POLYGON_OFFSET_FACTOR: 32824,
	  POLYGON_OFFSET_FILL: 32823,
	  POLYGON_OFFSET_UNITS: 10752,
	  RED_BITS: 3410,
	  RENDERBUFFER: 36161,
	  RENDERBUFFER_ALPHA_SIZE: 36179,
	  RENDERBUFFER_BINDING: 36007,
	  RENDERBUFFER_BLUE_SIZE: 36178,
	  RENDERBUFFER_DEPTH_SIZE: 36180,
	  RENDERBUFFER_GREEN_SIZE: 36177,
	  RENDERBUFFER_HEIGHT: 36163,
	  RENDERBUFFER_INTERNAL_FORMAT: 36164,
	  RENDERBUFFER_RED_SIZE: 36176,
	  RENDERBUFFER_STENCIL_SIZE: 36181,
	  RENDERBUFFER_WIDTH: 36162,
	  RENDERER: 7937,
	  REPEAT: 10497,
	  REPLACE: 7681,
	  RGB: 6407,
	  RGB5_A1: 32855,
	  RGB565: 36194,
	  RGBA: 6408,
	  RGBA4: 32854,
	  SAMPLER_2D: 35678,
	  SAMPLER_CUBE: 35680,
	  SAMPLES: 32937,
	  SAMPLE_ALPHA_TO_COVERAGE: 32926,
	  SAMPLE_BUFFERS: 32936,
	  SAMPLE_COVERAGE: 32928,
	  SAMPLE_COVERAGE_INVERT: 32939,
	  SAMPLE_COVERAGE_VALUE: 32938,
	  SCISSOR_BOX: 3088,
	  SCISSOR_TEST: 3089,
	  SHADER_COMPILER: 36346,
	  SHADER_SOURCE_LENGTH: 35720,
	  SHADER_TYPE: 35663,
	  SHADING_LANGUAGE_VERSION: 35724,
	  SHORT: 5122,
	  SRC_ALPHA: 770,
	  SRC_ALPHA_SATURATE: 776,
	  SRC_COLOR: 768,
	  STATIC_DRAW: 35044,
	  STENCIL_ATTACHMENT: 36128,
	  STENCIL_BACK_FAIL: 34817,
	  STENCIL_BACK_FUNC: 34816,
	  STENCIL_BACK_PASS_DEPTH_FAIL: 34818,
	  STENCIL_BACK_PASS_DEPTH_PASS: 34819,
	  STENCIL_BACK_REF: 36003,
	  STENCIL_BACK_VALUE_MASK: 36004,
	  STENCIL_BACK_WRITEMASK: 36005,
	  STENCIL_BITS: 3415,
	  STENCIL_BUFFER_BIT: 1024,
	  STENCIL_CLEAR_VALUE: 2961,
	  STENCIL_FAIL: 2964,
	  STENCIL_FUNC: 2962,
	  STENCIL_INDEX: 6401,
	  STENCIL_INDEX8: 36168,
	  STENCIL_PASS_DEPTH_FAIL: 2965,
	  STENCIL_PASS_DEPTH_PASS: 2966,
	  STENCIL_REF: 2967,
	  STENCIL_TEST: 2960,
	  STENCIL_VALUE_MASK: 2963,
	  STENCIL_WRITEMASK: 2968,
	  STREAM_DRAW: 35040,
	  SUBPIXEL_BITS: 3408,
	  TEXTURE: 5890,
	  TEXTURE0: 33984,
	  TEXTURE1: 33985,
	  TEXTURE2: 33986,
	  TEXTURE3: 33987,
	  TEXTURE4: 33988,
	  TEXTURE5: 33989,
	  TEXTURE6: 33990,
	  TEXTURE7: 33991,
	  TEXTURE8: 33992,
	  TEXTURE9: 33993,
	  TEXTURE10: 33994,
	  TEXTURE11: 33995,
	  TEXTURE12: 33996,
	  TEXTURE13: 33997,
	  TEXTURE14: 33998,
	  TEXTURE15: 33999,
	  TEXTURE16: 34000,
	  TEXTURE17: 34001,
	  TEXTURE18: 34002,
	  TEXTURE19: 34003,
	  TEXTURE20: 34004,
	  TEXTURE21: 34005,
	  TEXTURE22: 34006,
	  TEXTURE23: 34007,
	  TEXTURE24: 34008,
	  TEXTURE25: 34009,
	  TEXTURE26: 34010,
	  TEXTURE27: 34011,
	  TEXTURE28: 34012,
	  TEXTURE29: 34013,
	  TEXTURE30: 34014,
	  TEXTURE31: 34015,
	  TEXTURE_2D: 3553,
	  TEXTURE_BINDING_2D: 32873,
	  TEXTURE_BINDING_CUBE_MAP: 34068,
	  TEXTURE_CUBE_MAP: 34067,
	  TEXTURE_CUBE_MAP_NEGATIVE_X: 34070,
	  TEXTURE_CUBE_MAP_NEGATIVE_Y: 34072,
	  TEXTURE_CUBE_MAP_NEGATIVE_Z: 34074,
	  TEXTURE_CUBE_MAP_POSITIVE_X: 34069,
	  TEXTURE_CUBE_MAP_POSITIVE_Y: 34071,
	  TEXTURE_CUBE_MAP_POSITIVE_Z: 34073,
	  TEXTURE_MAG_FILTER: 10240,
	  TEXTURE_MIN_FILTER: 10241,
	  TEXTURE_WRAP_S: 10242,
	  TEXTURE_WRAP_T: 10243,
	  TRIANGLES: 4,
	  TRIANGLE_FAN: 6,
	  TRIANGLE_STRIP: 5,
	  UNPACK_ALIGNMENT: 3317,
	  UNPACK_COLORSPACE_CONVERSION_WEBGL: 37443,
	  UNPACK_FLIP_Y_WEBGL: 37440,
	  UNPACK_PREMULTIPLY_ALPHA_WEBGL: 37441,
	  UNSIGNED_BYTE: 5121,
	  UNSIGNED_INT: 5125,
	  UNSIGNED_SHORT: 5123,
	  UNSIGNED_SHORT_4_4_4_4: 32819,
	  UNSIGNED_SHORT_5_5_5_1: 32820,
	  UNSIGNED_SHORT_5_6_5: 33635,
	  VALIDATE_STATUS: 35715,
	  VENDOR: 7936,
	  VERSION: 7938,
	  VERTEX_ATTRIB_ARRAY_BUFFER_BINDING: 34975,
	  VERTEX_ATTRIB_ARRAY_ENABLED: 34338,
	  VERTEX_ATTRIB_ARRAY_NORMALIZED: 34922,
	  VERTEX_ATTRIB_ARRAY_POINTER: 34373,
	  VERTEX_ATTRIB_ARRAY_SIZE: 34339,
	  VERTEX_ATTRIB_ARRAY_STRIDE: 34340,
	  VERTEX_ATTRIB_ARRAY_TYPE: 34341,
	  VERTEX_SHADER: 35633,
	  VIEWPORT: 2978,
	  ZERO: 0
	}


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var glMatrix = __webpack_require__(81);
	
	/**
	 * @class 2x2 Matrix
	 * @name mat2
	 */
	var mat2 = {};
	
	/**
	 * Creates a new identity mat2
	 *
	 * @returns {mat2} a new 2x2 matrix
	 */
	mat2.create = function() {
	    var out = new glMatrix.ARRAY_TYPE(4);
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 1;
	    return out;
	};
	
	/**
	 * Creates a new mat2 initialized with values from an existing matrix
	 *
	 * @param {mat2} a matrix to clone
	 * @returns {mat2} a new 2x2 matrix
	 */
	mat2.clone = function(a) {
	    var out = new glMatrix.ARRAY_TYPE(4);
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    return out;
	};
	
	/**
	 * Copy the values from one mat2 to another
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the source matrix
	 * @returns {mat2} out
	 */
	mat2.copy = function(out, a) {
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    return out;
	};
	
	/**
	 * Set a mat2 to the identity matrix
	 *
	 * @param {mat2} out the receiving matrix
	 * @returns {mat2} out
	 */
	mat2.identity = function(out) {
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 1;
	    return out;
	};
	
	/**
	 * Create a new mat2 with the given values
	 *
	 * @param {Number} m00 Component in column 0, row 0 position (index 0)
	 * @param {Number} m01 Component in column 0, row 1 position (index 1)
	 * @param {Number} m10 Component in column 1, row 0 position (index 2)
	 * @param {Number} m11 Component in column 1, row 1 position (index 3)
	 * @returns {mat2} out A new 2x2 matrix
	 */
	mat2.fromValues = function(m00, m01, m10, m11) {
	    var out = new glMatrix.ARRAY_TYPE(4);
	    out[0] = m00;
	    out[1] = m01;
	    out[2] = m10;
	    out[3] = m11;
	    return out;
	};
	
	/**
	 * Set the components of a mat2 to the given values
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {Number} m00 Component in column 0, row 0 position (index 0)
	 * @param {Number} m01 Component in column 0, row 1 position (index 1)
	 * @param {Number} m10 Component in column 1, row 0 position (index 2)
	 * @param {Number} m11 Component in column 1, row 1 position (index 3)
	 * @returns {mat2} out
	 */
	mat2.set = function(out, m00, m01, m10, m11) {
	    out[0] = m00;
	    out[1] = m01;
	    out[2] = m10;
	    out[3] = m11;
	    return out;
	};
	
	
	/**
	 * Transpose the values of a mat2
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the source matrix
	 * @returns {mat2} out
	 */
	mat2.transpose = function(out, a) {
	    // If we are transposing ourselves we can skip a few steps but have to cache some values
	    if (out === a) {
	        var a1 = a[1];
	        out[1] = a[2];
	        out[2] = a1;
	    } else {
	        out[0] = a[0];
	        out[1] = a[2];
	        out[2] = a[1];
	        out[3] = a[3];
	    }
	    
	    return out;
	};
	
	/**
	 * Inverts a mat2
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the source matrix
	 * @returns {mat2} out
	 */
	mat2.invert = function(out, a) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3],
	
	        // Calculate the determinant
	        det = a0 * a3 - a2 * a1;
	
	    if (!det) {
	        return null;
	    }
	    det = 1.0 / det;
	    
	    out[0] =  a3 * det;
	    out[1] = -a1 * det;
	    out[2] = -a2 * det;
	    out[3] =  a0 * det;
	
	    return out;
	};
	
	/**
	 * Calculates the adjugate of a mat2
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the source matrix
	 * @returns {mat2} out
	 */
	mat2.adjoint = function(out, a) {
	    // Caching this value is nessecary if out == a
	    var a0 = a[0];
	    out[0] =  a[3];
	    out[1] = -a[1];
	    out[2] = -a[2];
	    out[3] =  a0;
	
	    return out;
	};
	
	/**
	 * Calculates the determinant of a mat2
	 *
	 * @param {mat2} a the source matrix
	 * @returns {Number} determinant of a
	 */
	mat2.determinant = function (a) {
	    return a[0] * a[3] - a[2] * a[1];
	};
	
	/**
	 * Multiplies two mat2's
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the first operand
	 * @param {mat2} b the second operand
	 * @returns {mat2} out
	 */
	mat2.multiply = function (out, a, b) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
	    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
	    out[0] = a0 * b0 + a2 * b1;
	    out[1] = a1 * b0 + a3 * b1;
	    out[2] = a0 * b2 + a2 * b3;
	    out[3] = a1 * b2 + a3 * b3;
	    return out;
	};
	
	/**
	 * Alias for {@link mat2.multiply}
	 * @function
	 */
	mat2.mul = mat2.multiply;
	
	/**
	 * Rotates a mat2 by the given angle
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat2} out
	 */
	mat2.rotate = function (out, a, rad) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3],
	        s = Math.sin(rad),
	        c = Math.cos(rad);
	    out[0] = a0 *  c + a2 * s;
	    out[1] = a1 *  c + a3 * s;
	    out[2] = a0 * -s + a2 * c;
	    out[3] = a1 * -s + a3 * c;
	    return out;
	};
	
	/**
	 * Scales the mat2 by the dimensions in the given vec2
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the matrix to rotate
	 * @param {vec2} v the vec2 to scale the matrix by
	 * @returns {mat2} out
	 **/
	mat2.scale = function(out, a, v) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3],
	        v0 = v[0], v1 = v[1];
	    out[0] = a0 * v0;
	    out[1] = a1 * v0;
	    out[2] = a2 * v1;
	    out[3] = a3 * v1;
	    return out;
	};
	
	/**
	 * Creates a matrix from a given angle
	 * This is equivalent to (but much faster than):
	 *
	 *     mat2.identity(dest);
	 *     mat2.rotate(dest, dest, rad);
	 *
	 * @param {mat2} out mat2 receiving operation result
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat2} out
	 */
	mat2.fromRotation = function(out, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad);
	    out[0] = c;
	    out[1] = s;
	    out[2] = -s;
	    out[3] = c;
	    return out;
	}
	
	/**
	 * Creates a matrix from a vector scaling
	 * This is equivalent to (but much faster than):
	 *
	 *     mat2.identity(dest);
	 *     mat2.scale(dest, dest, vec);
	 *
	 * @param {mat2} out mat2 receiving operation result
	 * @param {vec2} v Scaling vector
	 * @returns {mat2} out
	 */
	mat2.fromScaling = function(out, v) {
	    out[0] = v[0];
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = v[1];
	    return out;
	}
	
	/**
	 * Returns a string representation of a mat2
	 *
	 * @param {mat2} mat matrix to represent as a string
	 * @returns {String} string representation of the matrix
	 */
	mat2.str = function (a) {
	    return 'mat2(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
	};
	
	/**
	 * Returns Frobenius norm of a mat2
	 *
	 * @param {mat2} a the matrix to calculate Frobenius norm of
	 * @returns {Number} Frobenius norm
	 */
	mat2.frob = function (a) {
	    return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2)))
	};
	
	/**
	 * Returns L, D and U matrices (Lower triangular, Diagonal and Upper triangular) by factorizing the input matrix
	 * @param {mat2} L the lower triangular matrix 
	 * @param {mat2} D the diagonal matrix 
	 * @param {mat2} U the upper triangular matrix 
	 * @param {mat2} a the input matrix to factorize
	 */
	
	mat2.LDU = function (L, D, U, a) { 
	    L[2] = a[2]/a[0]; 
	    U[0] = a[0]; 
	    U[1] = a[1]; 
	    U[3] = a[3] - L[2] * U[1]; 
	    return [L, D, U];       
	}; 
	
	/**
	 * Adds two mat2's
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the first operand
	 * @param {mat2} b the second operand
	 * @returns {mat2} out
	 */
	mat2.add = function(out, a, b) {
	    out[0] = a[0] + b[0];
	    out[1] = a[1] + b[1];
	    out[2] = a[2] + b[2];
	    out[3] = a[3] + b[3];
	    return out;
	};
	
	/**
	 * Subtracts matrix b from matrix a
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the first operand
	 * @param {mat2} b the second operand
	 * @returns {mat2} out
	 */
	mat2.subtract = function(out, a, b) {
	    out[0] = a[0] - b[0];
	    out[1] = a[1] - b[1];
	    out[2] = a[2] - b[2];
	    out[3] = a[3] - b[3];
	    return out;
	};
	
	/**
	 * Alias for {@link mat2.subtract}
	 * @function
	 */
	mat2.sub = mat2.subtract;
	
	/**
	 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
	 *
	 * @param {mat2} a The first matrix.
	 * @param {mat2} b The second matrix.
	 * @returns {Boolean} True if the matrices are equal, false otherwise.
	 */
	mat2.exactEquals = function (a, b) {
	    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
	};
	
	/**
	 * Returns whether or not the matrices have approximately the same elements in the same position.
	 *
	 * @param {mat2} a The first matrix.
	 * @param {mat2} b The second matrix.
	 * @returns {Boolean} True if the matrices are equal, false otherwise.
	 */
	mat2.equals = function (a, b) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
	    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
	    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
	            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
	            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
	            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)));
	};
	
	/**
	 * Multiply each element of the matrix by a scalar.
	 *
	 * @param {mat2} out the receiving matrix
	 * @param {mat2} a the matrix to scale
	 * @param {Number} b amount to scale the matrix's elements by
	 * @returns {mat2} out
	 */
	mat2.multiplyScalar = function(out, a, b) {
	    out[0] = a[0] * b;
	    out[1] = a[1] * b;
	    out[2] = a[2] * b;
	    out[3] = a[3] * b;
	    return out;
	};
	
	/**
	 * Adds two mat2's after multiplying each element of the second operand by a scalar value.
	 *
	 * @param {mat2} out the receiving vector
	 * @param {mat2} a the first operand
	 * @param {mat2} b the second operand
	 * @param {Number} scale the amount to scale b's elements by before adding
	 * @returns {mat2} out
	 */
	mat2.multiplyScalarAndAdd = function(out, a, b, scale) {
	    out[0] = a[0] + (b[0] * scale);
	    out[1] = a[1] + (b[1] * scale);
	    out[2] = a[2] + (b[2] * scale);
	    out[3] = a[3] + (b[3] * scale);
	    return out;
	};
	
	module.exports = mat2;


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var glMatrix = __webpack_require__(81);
	
	/**
	 * @class 2x3 Matrix
	 * @name mat2d
	 * 
	 * @description 
	 * A mat2d contains six elements defined as:
	 * <pre>
	 * [a, c, tx,
	 *  b, d, ty]
	 * </pre>
	 * This is a short form for the 3x3 matrix:
	 * <pre>
	 * [a, c, tx,
	 *  b, d, ty,
	 *  0, 0, 1]
	 * </pre>
	 * The last row is ignored so the array is shorter and operations are faster.
	 */
	var mat2d = {};
	
	/**
	 * Creates a new identity mat2d
	 *
	 * @returns {mat2d} a new 2x3 matrix
	 */
	mat2d.create = function() {
	    var out = new glMatrix.ARRAY_TYPE(6);
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 1;
	    out[4] = 0;
	    out[5] = 0;
	    return out;
	};
	
	/**
	 * Creates a new mat2d initialized with values from an existing matrix
	 *
	 * @param {mat2d} a matrix to clone
	 * @returns {mat2d} a new 2x3 matrix
	 */
	mat2d.clone = function(a) {
	    var out = new glMatrix.ARRAY_TYPE(6);
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    out[4] = a[4];
	    out[5] = a[5];
	    return out;
	};
	
	/**
	 * Copy the values from one mat2d to another
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {mat2d} a the source matrix
	 * @returns {mat2d} out
	 */
	mat2d.copy = function(out, a) {
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    out[4] = a[4];
	    out[5] = a[5];
	    return out;
	};
	
	/**
	 * Set a mat2d to the identity matrix
	 *
	 * @param {mat2d} out the receiving matrix
	 * @returns {mat2d} out
	 */
	mat2d.identity = function(out) {
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 1;
	    out[4] = 0;
	    out[5] = 0;
	    return out;
	};
	
	/**
	 * Create a new mat2d with the given values
	 *
	 * @param {Number} a Component A (index 0)
	 * @param {Number} b Component B (index 1)
	 * @param {Number} c Component C (index 2)
	 * @param {Number} d Component D (index 3)
	 * @param {Number} tx Component TX (index 4)
	 * @param {Number} ty Component TY (index 5)
	 * @returns {mat2d} A new mat2d
	 */
	mat2d.fromValues = function(a, b, c, d, tx, ty) {
	    var out = new glMatrix.ARRAY_TYPE(6);
	    out[0] = a;
	    out[1] = b;
	    out[2] = c;
	    out[3] = d;
	    out[4] = tx;
	    out[5] = ty;
	    return out;
	};
	
	/**
	 * Set the components of a mat2d to the given values
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {Number} a Component A (index 0)
	 * @param {Number} b Component B (index 1)
	 * @param {Number} c Component C (index 2)
	 * @param {Number} d Component D (index 3)
	 * @param {Number} tx Component TX (index 4)
	 * @param {Number} ty Component TY (index 5)
	 * @returns {mat2d} out
	 */
	mat2d.set = function(out, a, b, c, d, tx, ty) {
	    out[0] = a;
	    out[1] = b;
	    out[2] = c;
	    out[3] = d;
	    out[4] = tx;
	    out[5] = ty;
	    return out;
	};
	
	/**
	 * Inverts a mat2d
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {mat2d} a the source matrix
	 * @returns {mat2d} out
	 */
	mat2d.invert = function(out, a) {
	    var aa = a[0], ab = a[1], ac = a[2], ad = a[3],
	        atx = a[4], aty = a[5];
	
	    var det = aa * ad - ab * ac;
	    if(!det){
	        return null;
	    }
	    det = 1.0 / det;
	
	    out[0] = ad * det;
	    out[1] = -ab * det;
	    out[2] = -ac * det;
	    out[3] = aa * det;
	    out[4] = (ac * aty - ad * atx) * det;
	    out[5] = (ab * atx - aa * aty) * det;
	    return out;
	};
	
	/**
	 * Calculates the determinant of a mat2d
	 *
	 * @param {mat2d} a the source matrix
	 * @returns {Number} determinant of a
	 */
	mat2d.determinant = function (a) {
	    return a[0] * a[3] - a[1] * a[2];
	};
	
	/**
	 * Multiplies two mat2d's
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {mat2d} a the first operand
	 * @param {mat2d} b the second operand
	 * @returns {mat2d} out
	 */
	mat2d.multiply = function (out, a, b) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5],
	        b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
	    out[0] = a0 * b0 + a2 * b1;
	    out[1] = a1 * b0 + a3 * b1;
	    out[2] = a0 * b2 + a2 * b3;
	    out[3] = a1 * b2 + a3 * b3;
	    out[4] = a0 * b4 + a2 * b5 + a4;
	    out[5] = a1 * b4 + a3 * b5 + a5;
	    return out;
	};
	
	/**
	 * Alias for {@link mat2d.multiply}
	 * @function
	 */
	mat2d.mul = mat2d.multiply;
	
	/**
	 * Rotates a mat2d by the given angle
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {mat2d} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat2d} out
	 */
	mat2d.rotate = function (out, a, rad) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5],
	        s = Math.sin(rad),
	        c = Math.cos(rad);
	    out[0] = a0 *  c + a2 * s;
	    out[1] = a1 *  c + a3 * s;
	    out[2] = a0 * -s + a2 * c;
	    out[3] = a1 * -s + a3 * c;
	    out[4] = a4;
	    out[5] = a5;
	    return out;
	};
	
	/**
	 * Scales the mat2d by the dimensions in the given vec2
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {mat2d} a the matrix to translate
	 * @param {vec2} v the vec2 to scale the matrix by
	 * @returns {mat2d} out
	 **/
	mat2d.scale = function(out, a, v) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5],
	        v0 = v[0], v1 = v[1];
	    out[0] = a0 * v0;
	    out[1] = a1 * v0;
	    out[2] = a2 * v1;
	    out[3] = a3 * v1;
	    out[4] = a4;
	    out[5] = a5;
	    return out;
	};
	
	/**
	 * Translates the mat2d by the dimensions in the given vec2
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {mat2d} a the matrix to translate
	 * @param {vec2} v the vec2 to translate the matrix by
	 * @returns {mat2d} out
	 **/
	mat2d.translate = function(out, a, v) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5],
	        v0 = v[0], v1 = v[1];
	    out[0] = a0;
	    out[1] = a1;
	    out[2] = a2;
	    out[3] = a3;
	    out[4] = a0 * v0 + a2 * v1 + a4;
	    out[5] = a1 * v0 + a3 * v1 + a5;
	    return out;
	};
	
	/**
	 * Creates a matrix from a given angle
	 * This is equivalent to (but much faster than):
	 *
	 *     mat2d.identity(dest);
	 *     mat2d.rotate(dest, dest, rad);
	 *
	 * @param {mat2d} out mat2d receiving operation result
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat2d} out
	 */
	mat2d.fromRotation = function(out, rad) {
	    var s = Math.sin(rad), c = Math.cos(rad);
	    out[0] = c;
	    out[1] = s;
	    out[2] = -s;
	    out[3] = c;
	    out[4] = 0;
	    out[5] = 0;
	    return out;
	}
	
	/**
	 * Creates a matrix from a vector scaling
	 * This is equivalent to (but much faster than):
	 *
	 *     mat2d.identity(dest);
	 *     mat2d.scale(dest, dest, vec);
	 *
	 * @param {mat2d} out mat2d receiving operation result
	 * @param {vec2} v Scaling vector
	 * @returns {mat2d} out
	 */
	mat2d.fromScaling = function(out, v) {
	    out[0] = v[0];
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = v[1];
	    out[4] = 0;
	    out[5] = 0;
	    return out;
	}
	
	/**
	 * Creates a matrix from a vector translation
	 * This is equivalent to (but much faster than):
	 *
	 *     mat2d.identity(dest);
	 *     mat2d.translate(dest, dest, vec);
	 *
	 * @param {mat2d} out mat2d receiving operation result
	 * @param {vec2} v Translation vector
	 * @returns {mat2d} out
	 */
	mat2d.fromTranslation = function(out, v) {
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 1;
	    out[4] = v[0];
	    out[5] = v[1];
	    return out;
	}
	
	/**
	 * Returns a string representation of a mat2d
	 *
	 * @param {mat2d} a matrix to represent as a string
	 * @returns {String} string representation of the matrix
	 */
	mat2d.str = function (a) {
	    return 'mat2d(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + 
	                    a[3] + ', ' + a[4] + ', ' + a[5] + ')';
	};
	
	/**
	 * Returns Frobenius norm of a mat2d
	 *
	 * @param {mat2d} a the matrix to calculate Frobenius norm of
	 * @returns {Number} Frobenius norm
	 */
	mat2d.frob = function (a) { 
	    return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + 1))
	}; 
	
	/**
	 * Adds two mat2d's
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {mat2d} a the first operand
	 * @param {mat2d} b the second operand
	 * @returns {mat2d} out
	 */
	mat2d.add = function(out, a, b) {
	    out[0] = a[0] + b[0];
	    out[1] = a[1] + b[1];
	    out[2] = a[2] + b[2];
	    out[3] = a[3] + b[3];
	    out[4] = a[4] + b[4];
	    out[5] = a[5] + b[5];
	    return out;
	};
	
	/**
	 * Subtracts matrix b from matrix a
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {mat2d} a the first operand
	 * @param {mat2d} b the second operand
	 * @returns {mat2d} out
	 */
	mat2d.subtract = function(out, a, b) {
	    out[0] = a[0] - b[0];
	    out[1] = a[1] - b[1];
	    out[2] = a[2] - b[2];
	    out[3] = a[3] - b[3];
	    out[4] = a[4] - b[4];
	    out[5] = a[5] - b[5];
	    return out;
	};
	
	/**
	 * Alias for {@link mat2d.subtract}
	 * @function
	 */
	mat2d.sub = mat2d.subtract;
	
	/**
	 * Multiply each element of the matrix by a scalar.
	 *
	 * @param {mat2d} out the receiving matrix
	 * @param {mat2d} a the matrix to scale
	 * @param {Number} b amount to scale the matrix's elements by
	 * @returns {mat2d} out
	 */
	mat2d.multiplyScalar = function(out, a, b) {
	    out[0] = a[0] * b;
	    out[1] = a[1] * b;
	    out[2] = a[2] * b;
	    out[3] = a[3] * b;
	    out[4] = a[4] * b;
	    out[5] = a[5] * b;
	    return out;
	};
	
	/**
	 * Adds two mat2d's after multiplying each element of the second operand by a scalar value.
	 *
	 * @param {mat2d} out the receiving vector
	 * @param {mat2d} a the first operand
	 * @param {mat2d} b the second operand
	 * @param {Number} scale the amount to scale b's elements by before adding
	 * @returns {mat2d} out
	 */
	mat2d.multiplyScalarAndAdd = function(out, a, b, scale) {
	    out[0] = a[0] + (b[0] * scale);
	    out[1] = a[1] + (b[1] * scale);
	    out[2] = a[2] + (b[2] * scale);
	    out[3] = a[3] + (b[3] * scale);
	    out[4] = a[4] + (b[4] * scale);
	    out[5] = a[5] + (b[5] * scale);
	    return out;
	};
	
	/**
	 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
	 *
	 * @param {mat2d} a The first matrix.
	 * @param {mat2d} b The second matrix.
	 * @returns {Boolean} True if the matrices are equal, false otherwise.
	 */
	mat2d.exactEquals = function (a, b) {
	    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5];
	};
	
	/**
	 * Returns whether or not the matrices have approximately the same elements in the same position.
	 *
	 * @param {mat2d} a The first matrix.
	 * @param {mat2d} b The second matrix.
	 * @returns {Boolean} True if the matrices are equal, false otherwise.
	 */
	mat2d.equals = function (a, b) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
	    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
	    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
	            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
	            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
	            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
	            Math.abs(a4 - b4) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
	            Math.abs(a5 - b5) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a5), Math.abs(b5)));
	};
	
	module.exports = mat2d;


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var glMatrix = __webpack_require__(81);
	
	/**
	 * @class 4x4 Matrix
	 * @name mat4
	 */
	var mat4 = {
	  scalar: {},
	  SIMD: {},
	};
	
	/**
	 * Creates a new identity mat4
	 *
	 * @returns {mat4} a new 4x4 matrix
	 */
	mat4.create = function() {
	    var out = new glMatrix.ARRAY_TYPE(16);
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = 1;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = 1;
	    out[11] = 0;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	    return out;
	};
	
	/**
	 * Creates a new mat4 initialized with values from an existing matrix
	 *
	 * @param {mat4} a matrix to clone
	 * @returns {mat4} a new 4x4 matrix
	 */
	mat4.clone = function(a) {
	    var out = new glMatrix.ARRAY_TYPE(16);
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    out[4] = a[4];
	    out[5] = a[5];
	    out[6] = a[6];
	    out[7] = a[7];
	    out[8] = a[8];
	    out[9] = a[9];
	    out[10] = a[10];
	    out[11] = a[11];
	    out[12] = a[12];
	    out[13] = a[13];
	    out[14] = a[14];
	    out[15] = a[15];
	    return out;
	};
	
	/**
	 * Copy the values from one mat4 to another
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	mat4.copy = function(out, a) {
	    out[0] = a[0];
	    out[1] = a[1];
	    out[2] = a[2];
	    out[3] = a[3];
	    out[4] = a[4];
	    out[5] = a[5];
	    out[6] = a[6];
	    out[7] = a[7];
	    out[8] = a[8];
	    out[9] = a[9];
	    out[10] = a[10];
	    out[11] = a[11];
	    out[12] = a[12];
	    out[13] = a[13];
	    out[14] = a[14];
	    out[15] = a[15];
	    return out;
	};
	
	/**
	 * Create a new mat4 with the given values
	 *
	 * @param {Number} m00 Component in column 0, row 0 position (index 0)
	 * @param {Number} m01 Component in column 0, row 1 position (index 1)
	 * @param {Number} m02 Component in column 0, row 2 position (index 2)
	 * @param {Number} m03 Component in column 0, row 3 position (index 3)
	 * @param {Number} m10 Component in column 1, row 0 position (index 4)
	 * @param {Number} m11 Component in column 1, row 1 position (index 5)
	 * @param {Number} m12 Component in column 1, row 2 position (index 6)
	 * @param {Number} m13 Component in column 1, row 3 position (index 7)
	 * @param {Number} m20 Component in column 2, row 0 position (index 8)
	 * @param {Number} m21 Component in column 2, row 1 position (index 9)
	 * @param {Number} m22 Component in column 2, row 2 position (index 10)
	 * @param {Number} m23 Component in column 2, row 3 position (index 11)
	 * @param {Number} m30 Component in column 3, row 0 position (index 12)
	 * @param {Number} m31 Component in column 3, row 1 position (index 13)
	 * @param {Number} m32 Component in column 3, row 2 position (index 14)
	 * @param {Number} m33 Component in column 3, row 3 position (index 15)
	 * @returns {mat4} A new mat4
	 */
	mat4.fromValues = function(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
	    var out = new glMatrix.ARRAY_TYPE(16);
	    out[0] = m00;
	    out[1] = m01;
	    out[2] = m02;
	    out[3] = m03;
	    out[4] = m10;
	    out[5] = m11;
	    out[6] = m12;
	    out[7] = m13;
	    out[8] = m20;
	    out[9] = m21;
	    out[10] = m22;
	    out[11] = m23;
	    out[12] = m30;
	    out[13] = m31;
	    out[14] = m32;
	    out[15] = m33;
	    return out;
	};
	
	/**
	 * Set the components of a mat4 to the given values
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {Number} m00 Component in column 0, row 0 position (index 0)
	 * @param {Number} m01 Component in column 0, row 1 position (index 1)
	 * @param {Number} m02 Component in column 0, row 2 position (index 2)
	 * @param {Number} m03 Component in column 0, row 3 position (index 3)
	 * @param {Number} m10 Component in column 1, row 0 position (index 4)
	 * @param {Number} m11 Component in column 1, row 1 position (index 5)
	 * @param {Number} m12 Component in column 1, row 2 position (index 6)
	 * @param {Number} m13 Component in column 1, row 3 position (index 7)
	 * @param {Number} m20 Component in column 2, row 0 position (index 8)
	 * @param {Number} m21 Component in column 2, row 1 position (index 9)
	 * @param {Number} m22 Component in column 2, row 2 position (index 10)
	 * @param {Number} m23 Component in column 2, row 3 position (index 11)
	 * @param {Number} m30 Component in column 3, row 0 position (index 12)
	 * @param {Number} m31 Component in column 3, row 1 position (index 13)
	 * @param {Number} m32 Component in column 3, row 2 position (index 14)
	 * @param {Number} m33 Component in column 3, row 3 position (index 15)
	 * @returns {mat4} out
	 */
	mat4.set = function(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
	    out[0] = m00;
	    out[1] = m01;
	    out[2] = m02;
	    out[3] = m03;
	    out[4] = m10;
	    out[5] = m11;
	    out[6] = m12;
	    out[7] = m13;
	    out[8] = m20;
	    out[9] = m21;
	    out[10] = m22;
	    out[11] = m23;
	    out[12] = m30;
	    out[13] = m31;
	    out[14] = m32;
	    out[15] = m33;
	    return out;
	};
	
	
	/**
	 * Set a mat4 to the identity matrix
	 *
	 * @param {mat4} out the receiving matrix
	 * @returns {mat4} out
	 */
	mat4.identity = function(out) {
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = 1;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = 1;
	    out[11] = 0;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	    return out;
	};
	
	/**
	 * Transpose the values of a mat4 not using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	mat4.scalar.transpose = function(out, a) {
	    // If we are transposing ourselves we can skip a few steps but have to cache some values
	    if (out === a) {
	        var a01 = a[1], a02 = a[2], a03 = a[3],
	            a12 = a[6], a13 = a[7],
	            a23 = a[11];
	
	        out[1] = a[4];
	        out[2] = a[8];
	        out[3] = a[12];
	        out[4] = a01;
	        out[6] = a[9];
	        out[7] = a[13];
	        out[8] = a02;
	        out[9] = a12;
	        out[11] = a[14];
	        out[12] = a03;
	        out[13] = a13;
	        out[14] = a23;
	    } else {
	        out[0] = a[0];
	        out[1] = a[4];
	        out[2] = a[8];
	        out[3] = a[12];
	        out[4] = a[1];
	        out[5] = a[5];
	        out[6] = a[9];
	        out[7] = a[13];
	        out[8] = a[2];
	        out[9] = a[6];
	        out[10] = a[10];
	        out[11] = a[14];
	        out[12] = a[3];
	        out[13] = a[7];
	        out[14] = a[11];
	        out[15] = a[15];
	    }
	
	    return out;
	};
	
	/**
	 * Transpose the values of a mat4 using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	mat4.SIMD.transpose = function(out, a) {
	    var a0, a1, a2, a3,
	        tmp01, tmp23,
	        out0, out1, out2, out3;
	
	    a0 = SIMD.Float32x4.load(a, 0);
	    a1 = SIMD.Float32x4.load(a, 4);
	    a2 = SIMD.Float32x4.load(a, 8);
	    a3 = SIMD.Float32x4.load(a, 12);
	
	    tmp01 = SIMD.Float32x4.shuffle(a0, a1, 0, 1, 4, 5);
	    tmp23 = SIMD.Float32x4.shuffle(a2, a3, 0, 1, 4, 5);
	    out0  = SIMD.Float32x4.shuffle(tmp01, tmp23, 0, 2, 4, 6);
	    out1  = SIMD.Float32x4.shuffle(tmp01, tmp23, 1, 3, 5, 7);
	    SIMD.Float32x4.store(out, 0,  out0);
	    SIMD.Float32x4.store(out, 4,  out1);
	
	    tmp01 = SIMD.Float32x4.shuffle(a0, a1, 2, 3, 6, 7);
	    tmp23 = SIMD.Float32x4.shuffle(a2, a3, 2, 3, 6, 7);
	    out2  = SIMD.Float32x4.shuffle(tmp01, tmp23, 0, 2, 4, 6);
	    out3  = SIMD.Float32x4.shuffle(tmp01, tmp23, 1, 3, 5, 7);
	    SIMD.Float32x4.store(out, 8,  out2);
	    SIMD.Float32x4.store(out, 12, out3);
	
	    return out;
	};
	
	/**
	 * Transpse a mat4 using SIMD if available and enabled
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	mat4.transpose = glMatrix.USE_SIMD ? mat4.SIMD.transpose : mat4.scalar.transpose;
	
	/**
	 * Inverts a mat4 not using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	mat4.scalar.invert = function(out, a) {
	    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
	        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
	        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
	        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],
	
	        b00 = a00 * a11 - a01 * a10,
	        b01 = a00 * a12 - a02 * a10,
	        b02 = a00 * a13 - a03 * a10,
	        b03 = a01 * a12 - a02 * a11,
	        b04 = a01 * a13 - a03 * a11,
	        b05 = a02 * a13 - a03 * a12,
	        b06 = a20 * a31 - a21 * a30,
	        b07 = a20 * a32 - a22 * a30,
	        b08 = a20 * a33 - a23 * a30,
	        b09 = a21 * a32 - a22 * a31,
	        b10 = a21 * a33 - a23 * a31,
	        b11 = a22 * a33 - a23 * a32,
	
	        // Calculate the determinant
	        det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	
	    if (!det) {
	        return null;
	    }
	    det = 1.0 / det;
	
	    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
	    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
	    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
	    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
	    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
	    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
	    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
	
	    return out;
	};
	
	/**
	 * Inverts a mat4 using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	mat4.SIMD.invert = function(out, a) {
	  var row0, row1, row2, row3,
	      tmp1,
	      minor0, minor1, minor2, minor3,
	      det,
	      a0 = SIMD.Float32x4.load(a, 0),
	      a1 = SIMD.Float32x4.load(a, 4),
	      a2 = SIMD.Float32x4.load(a, 8),
	      a3 = SIMD.Float32x4.load(a, 12);
	
	  // Compute matrix adjugate
	  tmp1 = SIMD.Float32x4.shuffle(a0, a1, 0, 1, 4, 5);
	  row1 = SIMD.Float32x4.shuffle(a2, a3, 0, 1, 4, 5);
	  row0 = SIMD.Float32x4.shuffle(tmp1, row1, 0, 2, 4, 6);
	  row1 = SIMD.Float32x4.shuffle(row1, tmp1, 1, 3, 5, 7);
	  tmp1 = SIMD.Float32x4.shuffle(a0, a1, 2, 3, 6, 7);
	  row3 = SIMD.Float32x4.shuffle(a2, a3, 2, 3, 6, 7);
	  row2 = SIMD.Float32x4.shuffle(tmp1, row3, 0, 2, 4, 6);
	  row3 = SIMD.Float32x4.shuffle(row3, tmp1, 1, 3, 5, 7);
	
	  tmp1   = SIMD.Float32x4.mul(row2, row3);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor0 = SIMD.Float32x4.mul(row1, tmp1);
	  minor1 = SIMD.Float32x4.mul(row0, tmp1);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor0 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row1, tmp1), minor0);
	  minor1 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor1);
	  minor1 = SIMD.Float32x4.swizzle(minor1, 2, 3, 0, 1);
	
	  tmp1   = SIMD.Float32x4.mul(row1, row2);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor0 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor0);
	  minor3 = SIMD.Float32x4.mul(row0, tmp1);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor0 = SIMD.Float32x4.sub(minor0, SIMD.Float32x4.mul(row3, tmp1));
	  minor3 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor3);
	  minor3 = SIMD.Float32x4.swizzle(minor3, 2, 3, 0, 1);
	
	  tmp1   = SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(row1, 2, 3, 0, 1), row3);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  row2   = SIMD.Float32x4.swizzle(row2, 2, 3, 0, 1);
	  minor0 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row2, tmp1), minor0);
	  minor2 = SIMD.Float32x4.mul(row0, tmp1);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor0 = SIMD.Float32x4.sub(minor0, SIMD.Float32x4.mul(row2, tmp1));
	  minor2 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor2);
	  minor2 = SIMD.Float32x4.swizzle(minor2, 2, 3, 0, 1);
	
	  tmp1   = SIMD.Float32x4.mul(row0, row1);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor2 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor2);
	  minor3 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row2, tmp1), minor3);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor2 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row3, tmp1), minor2);
	  minor3 = SIMD.Float32x4.sub(minor3, SIMD.Float32x4.mul(row2, tmp1));
	
	  tmp1   = SIMD.Float32x4.mul(row0, row3);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor1 = SIMD.Float32x4.sub(minor1, SIMD.Float32x4.mul(row2, tmp1));
	  minor2 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row1, tmp1), minor2);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor1 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row2, tmp1), minor1);
	  minor2 = SIMD.Float32x4.sub(minor2, SIMD.Float32x4.mul(row1, tmp1));
	
	  tmp1   = SIMD.Float32x4.mul(row0, row2);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor1 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor1);
	  minor3 = SIMD.Float32x4.sub(minor3, SIMD.Float32x4.mul(row1, tmp1));
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor1 = SIMD.Float32x4.sub(minor1, SIMD.Float32x4.mul(row3, tmp1));
	  minor3 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row1, tmp1), minor3);
	
	  // Compute matrix determinant
	  det   = SIMD.Float32x4.mul(row0, minor0);
	  det   = SIMD.Float32x4.add(SIMD.Float32x4.swizzle(det, 2, 3, 0, 1), det);
	  det   = SIMD.Float32x4.add(SIMD.Float32x4.swizzle(det, 1, 0, 3, 2), det);
	  tmp1  = SIMD.Float32x4.reciprocalApproximation(det);
	  det   = SIMD.Float32x4.sub(
	               SIMD.Float32x4.add(tmp1, tmp1),
	               SIMD.Float32x4.mul(det, SIMD.Float32x4.mul(tmp1, tmp1)));
	  det   = SIMD.Float32x4.swizzle(det, 0, 0, 0, 0);
	  if (!det) {
	      return null;
	  }
	
	  // Compute matrix inverse
	  SIMD.Float32x4.store(out, 0,  SIMD.Float32x4.mul(det, minor0));
	  SIMD.Float32x4.store(out, 4,  SIMD.Float32x4.mul(det, minor1));
	  SIMD.Float32x4.store(out, 8,  SIMD.Float32x4.mul(det, minor2));
	  SIMD.Float32x4.store(out, 12, SIMD.Float32x4.mul(det, minor3));
	  return out;
	}
	
	/**
	 * Inverts a mat4 using SIMD if available and enabled
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	mat4.invert = glMatrix.USE_SIMD ? mat4.SIMD.invert : mat4.scalar.invert;
	
	/**
	 * Calculates the adjugate of a mat4 not using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	mat4.scalar.adjoint = function(out, a) {
	    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
	        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
	        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
	        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
	
	    out[0]  =  (a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22));
	    out[1]  = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
	    out[2]  =  (a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12));
	    out[3]  = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
	    out[4]  = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
	    out[5]  =  (a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22));
	    out[6]  = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
	    out[7]  =  (a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12));
	    out[8]  =  (a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21));
	    out[9]  = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
	    out[10] =  (a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11));
	    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
	    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
	    out[13] =  (a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21));
	    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
	    out[15] =  (a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11));
	    return out;
	};
	
	/**
	 * Calculates the adjugate of a mat4 using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	mat4.SIMD.adjoint = function(out, a) {
	  var a0, a1, a2, a3;
	  var row0, row1, row2, row3;
	  var tmp1;
	  var minor0, minor1, minor2, minor3;
	
	  var a0 = SIMD.Float32x4.load(a, 0);
	  var a1 = SIMD.Float32x4.load(a, 4);
	  var a2 = SIMD.Float32x4.load(a, 8);
	  var a3 = SIMD.Float32x4.load(a, 12);
	
	  // Transpose the source matrix.  Sort of.  Not a true transpose operation
	  tmp1 = SIMD.Float32x4.shuffle(a0, a1, 0, 1, 4, 5);
	  row1 = SIMD.Float32x4.shuffle(a2, a3, 0, 1, 4, 5);
	  row0 = SIMD.Float32x4.shuffle(tmp1, row1, 0, 2, 4, 6);
	  row1 = SIMD.Float32x4.shuffle(row1, tmp1, 1, 3, 5, 7);
	
	  tmp1 = SIMD.Float32x4.shuffle(a0, a1, 2, 3, 6, 7);
	  row3 = SIMD.Float32x4.shuffle(a2, a3, 2, 3, 6, 7);
	  row2 = SIMD.Float32x4.shuffle(tmp1, row3, 0, 2, 4, 6);
	  row3 = SIMD.Float32x4.shuffle(row3, tmp1, 1, 3, 5, 7);
	
	  tmp1   = SIMD.Float32x4.mul(row2, row3);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor0 = SIMD.Float32x4.mul(row1, tmp1);
	  minor1 = SIMD.Float32x4.mul(row0, tmp1);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor0 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row1, tmp1), minor0);
	  minor1 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor1);
	  minor1 = SIMD.Float32x4.swizzle(minor1, 2, 3, 0, 1);
	
	  tmp1   = SIMD.Float32x4.mul(row1, row2);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor0 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor0);
	  minor3 = SIMD.Float32x4.mul(row0, tmp1);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor0 = SIMD.Float32x4.sub(minor0, SIMD.Float32x4.mul(row3, tmp1));
	  minor3 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor3);
	  minor3 = SIMD.Float32x4.swizzle(minor3, 2, 3, 0, 1);
	
	  tmp1   = SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(row1, 2, 3, 0, 1), row3);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  row2   = SIMD.Float32x4.swizzle(row2, 2, 3, 0, 1);
	  minor0 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row2, tmp1), minor0);
	  minor2 = SIMD.Float32x4.mul(row0, tmp1);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor0 = SIMD.Float32x4.sub(minor0, SIMD.Float32x4.mul(row2, tmp1));
	  minor2 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor2);
	  minor2 = SIMD.Float32x4.swizzle(minor2, 2, 3, 0, 1);
	
	  tmp1   = SIMD.Float32x4.mul(row0, row1);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor2 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor2);
	  minor3 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row2, tmp1), minor3);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor2 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row3, tmp1), minor2);
	  minor3 = SIMD.Float32x4.sub(minor3, SIMD.Float32x4.mul(row2, tmp1));
	
	  tmp1   = SIMD.Float32x4.mul(row0, row3);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor1 = SIMD.Float32x4.sub(minor1, SIMD.Float32x4.mul(row2, tmp1));
	  minor2 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row1, tmp1), minor2);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor1 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row2, tmp1), minor1);
	  minor2 = SIMD.Float32x4.sub(minor2, SIMD.Float32x4.mul(row1, tmp1));
	
	  tmp1   = SIMD.Float32x4.mul(row0, row2);
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
	  minor1 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor1);
	  minor3 = SIMD.Float32x4.sub(minor3, SIMD.Float32x4.mul(row1, tmp1));
	  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
	  minor1 = SIMD.Float32x4.sub(minor1, SIMD.Float32x4.mul(row3, tmp1));
	  minor3 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row1, tmp1), minor3);
	
	  SIMD.Float32x4.store(out, 0,  minor0);
	  SIMD.Float32x4.store(out, 4,  minor1);
	  SIMD.Float32x4.store(out, 8,  minor2);
	  SIMD.Float32x4.store(out, 12, minor3);
	  return out;
	};
	
	/**
	 * Calculates the adjugate of a mat4 using SIMD if available and enabled
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	 mat4.adjoint = glMatrix.USE_SIMD ? mat4.SIMD.adjoint : mat4.scalar.adjoint;
	
	/**
	 * Calculates the determinant of a mat4
	 *
	 * @param {mat4} a the source matrix
	 * @returns {Number} determinant of a
	 */
	mat4.determinant = function (a) {
	    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
	        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
	        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
	        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],
	
	        b00 = a00 * a11 - a01 * a10,
	        b01 = a00 * a12 - a02 * a10,
	        b02 = a00 * a13 - a03 * a10,
	        b03 = a01 * a12 - a02 * a11,
	        b04 = a01 * a13 - a03 * a11,
	        b05 = a02 * a13 - a03 * a12,
	        b06 = a20 * a31 - a21 * a30,
	        b07 = a20 * a32 - a22 * a30,
	        b08 = a20 * a33 - a23 * a30,
	        b09 = a21 * a32 - a22 * a31,
	        b10 = a21 * a33 - a23 * a31,
	        b11 = a22 * a33 - a23 * a32;
	
	    // Calculate the determinant
	    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	};
	
	/**
	 * Multiplies two mat4's explicitly using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the first operand, must be a Float32Array
	 * @param {mat4} b the second operand, must be a Float32Array
	 * @returns {mat4} out
	 */
	mat4.SIMD.multiply = function (out, a, b) {
	    var a0 = SIMD.Float32x4.load(a, 0);
	    var a1 = SIMD.Float32x4.load(a, 4);
	    var a2 = SIMD.Float32x4.load(a, 8);
	    var a3 = SIMD.Float32x4.load(a, 12);
	
	    var b0 = SIMD.Float32x4.load(b, 0);
	    var out0 = SIMD.Float32x4.add(
	                   SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b0, 0, 0, 0, 0), a0),
	                   SIMD.Float32x4.add(
	                       SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b0, 1, 1, 1, 1), a1),
	                       SIMD.Float32x4.add(
	                           SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b0, 2, 2, 2, 2), a2),
	                           SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b0, 3, 3, 3, 3), a3))));
	    SIMD.Float32x4.store(out, 0, out0);
	
	    var b1 = SIMD.Float32x4.load(b, 4);
	    var out1 = SIMD.Float32x4.add(
	                   SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b1, 0, 0, 0, 0), a0),
	                   SIMD.Float32x4.add(
	                       SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b1, 1, 1, 1, 1), a1),
	                       SIMD.Float32x4.add(
	                           SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b1, 2, 2, 2, 2), a2),
	                           SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b1, 3, 3, 3, 3), a3))));
	    SIMD.Float32x4.store(out, 4, out1);
	
	    var b2 = SIMD.Float32x4.load(b, 8);
	    var out2 = SIMD.Float32x4.add(
	                   SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b2, 0, 0, 0, 0), a0),
	                   SIMD.Float32x4.add(
	                       SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b2, 1, 1, 1, 1), a1),
	                       SIMD.Float32x4.add(
	                               SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b2, 2, 2, 2, 2), a2),
	                               SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b2, 3, 3, 3, 3), a3))));
	    SIMD.Float32x4.store(out, 8, out2);
	
	    var b3 = SIMD.Float32x4.load(b, 12);
	    var out3 = SIMD.Float32x4.add(
	                   SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b3, 0, 0, 0, 0), a0),
	                   SIMD.Float32x4.add(
	                        SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b3, 1, 1, 1, 1), a1),
	                        SIMD.Float32x4.add(
	                            SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b3, 2, 2, 2, 2), a2),
	                            SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b3, 3, 3, 3, 3), a3))));
	    SIMD.Float32x4.store(out, 12, out3);
	
	    return out;
	};
	
	/**
	 * Multiplies two mat4's explicitly not using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the first operand
	 * @param {mat4} b the second operand
	 * @returns {mat4} out
	 */
	mat4.scalar.multiply = function (out, a, b) {
	    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
	        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
	        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
	        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
	
	    // Cache only the current line of the second matrix
	    var b0  = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
	    out[0] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
	    out[1] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
	    out[2] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
	    out[3] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
	
	    b0 = b[4]; b1 = b[5]; b2 = b[6]; b3 = b[7];
	    out[4] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
	    out[5] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
	    out[6] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
	    out[7] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
	
	    b0 = b[8]; b1 = b[9]; b2 = b[10]; b3 = b[11];
	    out[8] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
	    out[9] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
	    out[10] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
	    out[11] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
	
	    b0 = b[12]; b1 = b[13]; b2 = b[14]; b3 = b[15];
	    out[12] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
	    out[13] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
	    out[14] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
	    out[15] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
	    return out;
	};
	
	/**
	 * Multiplies two mat4's using SIMD if available and enabled
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the first operand
	 * @param {mat4} b the second operand
	 * @returns {mat4} out
	 */
	mat4.multiply = glMatrix.USE_SIMD ? mat4.SIMD.multiply : mat4.scalar.multiply;
	
	/**
	 * Alias for {@link mat4.multiply}
	 * @function
	 */
	mat4.mul = mat4.multiply;
	
	/**
	 * Translate a mat4 by the given vector not using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to translate
	 * @param {vec3} v vector to translate by
	 * @returns {mat4} out
	 */
	mat4.scalar.translate = function (out, a, v) {
	    var x = v[0], y = v[1], z = v[2],
	        a00, a01, a02, a03,
	        a10, a11, a12, a13,
	        a20, a21, a22, a23;
	
	    if (a === out) {
	        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
	        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
	        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
	        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
	    } else {
	        a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
	        a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
	        a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];
	
	        out[0] = a00; out[1] = a01; out[2] = a02; out[3] = a03;
	        out[4] = a10; out[5] = a11; out[6] = a12; out[7] = a13;
	        out[8] = a20; out[9] = a21; out[10] = a22; out[11] = a23;
	
	        out[12] = a00 * x + a10 * y + a20 * z + a[12];
	        out[13] = a01 * x + a11 * y + a21 * z + a[13];
	        out[14] = a02 * x + a12 * y + a22 * z + a[14];
	        out[15] = a03 * x + a13 * y + a23 * z + a[15];
	    }
	
	    return out;
	};
	
	/**
	 * Translates a mat4 by the given vector using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to translate
	 * @param {vec3} v vector to translate by
	 * @returns {mat4} out
	 */
	mat4.SIMD.translate = function (out, a, v) {
	    var a0 = SIMD.Float32x4.load(a, 0),
	        a1 = SIMD.Float32x4.load(a, 4),
	        a2 = SIMD.Float32x4.load(a, 8),
	        a3 = SIMD.Float32x4.load(a, 12),
	        vec = SIMD.Float32x4(v[0], v[1], v[2] , 0);
	
	    if (a !== out) {
	        out[0] = a[0]; out[1] = a[1]; out[2] = a[2]; out[3] = a[3];
	        out[4] = a[4]; out[5] = a[5]; out[6] = a[6]; out[7] = a[7];
	        out[8] = a[8]; out[9] = a[9]; out[10] = a[10]; out[11] = a[11];
	    }
	
	    a0 = SIMD.Float32x4.mul(a0, SIMD.Float32x4.swizzle(vec, 0, 0, 0, 0));
	    a1 = SIMD.Float32x4.mul(a1, SIMD.Float32x4.swizzle(vec, 1, 1, 1, 1));
	    a2 = SIMD.Float32x4.mul(a2, SIMD.Float32x4.swizzle(vec, 2, 2, 2, 2));
	
	    var t0 = SIMD.Float32x4.add(a0, SIMD.Float32x4.add(a1, SIMD.Float32x4.add(a2, a3)));
	    SIMD.Float32x4.store(out, 12, t0);
	
	    return out;
	};
	
	/**
	 * Translates a mat4 by the given vector using SIMD if available and enabled
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to translate
	 * @param {vec3} v vector to translate by
	 * @returns {mat4} out
	 */
	mat4.translate = glMatrix.USE_SIMD ? mat4.SIMD.translate : mat4.scalar.translate;
	
	/**
	 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to scale
	 * @param {vec3} v the vec3 to scale the matrix by
	 * @returns {mat4} out
	 **/
	mat4.scalar.scale = function(out, a, v) {
	    var x = v[0], y = v[1], z = v[2];
	
	    out[0] = a[0] * x;
	    out[1] = a[1] * x;
	    out[2] = a[2] * x;
	    out[3] = a[3] * x;
	    out[4] = a[4] * y;
	    out[5] = a[5] * y;
	    out[6] = a[6] * y;
	    out[7] = a[7] * y;
	    out[8] = a[8] * z;
	    out[9] = a[9] * z;
	    out[10] = a[10] * z;
	    out[11] = a[11] * z;
	    out[12] = a[12];
	    out[13] = a[13];
	    out[14] = a[14];
	    out[15] = a[15];
	    return out;
	};
	
	/**
	 * Scales the mat4 by the dimensions in the given vec3 using vectorization
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to scale
	 * @param {vec3} v the vec3 to scale the matrix by
	 * @returns {mat4} out
	 **/
	mat4.SIMD.scale = function(out, a, v) {
	    var a0, a1, a2;
	    var vec = SIMD.Float32x4(v[0], v[1], v[2], 0);
	
	    a0 = SIMD.Float32x4.load(a, 0);
	    SIMD.Float32x4.store(
	        out, 0, SIMD.Float32x4.mul(a0, SIMD.Float32x4.swizzle(vec, 0, 0, 0, 0)));
	
	    a1 = SIMD.Float32x4.load(a, 4);
	    SIMD.Float32x4.store(
	        out, 4, SIMD.Float32x4.mul(a1, SIMD.Float32x4.swizzle(vec, 1, 1, 1, 1)));
	
	    a2 = SIMD.Float32x4.load(a, 8);
	    SIMD.Float32x4.store(
	        out, 8, SIMD.Float32x4.mul(a2, SIMD.Float32x4.swizzle(vec, 2, 2, 2, 2)));
	
	    out[12] = a[12];
	    out[13] = a[13];
	    out[14] = a[14];
	    out[15] = a[15];
	    return out;
	};
	
	/**
	 * Scales the mat4 by the dimensions in the given vec3 using SIMD if available and enabled
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to scale
	 * @param {vec3} v the vec3 to scale the matrix by
	 * @returns {mat4} out
	 */
	mat4.scale = glMatrix.USE_SIMD ? mat4.SIMD.scale : mat4.scalar.scale;
	
	/**
	 * Rotates a mat4 by the given angle around the given axis
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @param {vec3} axis the axis to rotate around
	 * @returns {mat4} out
	 */
	mat4.rotate = function (out, a, rad, axis) {
	    var x = axis[0], y = axis[1], z = axis[2],
	        len = Math.sqrt(x * x + y * y + z * z),
	        s, c, t,
	        a00, a01, a02, a03,
	        a10, a11, a12, a13,
	        a20, a21, a22, a23,
	        b00, b01, b02,
	        b10, b11, b12,
	        b20, b21, b22;
	
	    if (Math.abs(len) < glMatrix.EPSILON) { return null; }
	
	    len = 1 / len;
	    x *= len;
	    y *= len;
	    z *= len;
	
	    s = Math.sin(rad);
	    c = Math.cos(rad);
	    t = 1 - c;
	
	    a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
	    a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
	    a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];
	
	    // Construct the elements of the rotation matrix
	    b00 = x * x * t + c; b01 = y * x * t + z * s; b02 = z * x * t - y * s;
	    b10 = x * y * t - z * s; b11 = y * y * t + c; b12 = z * y * t + x * s;
	    b20 = x * z * t + y * s; b21 = y * z * t - x * s; b22 = z * z * t + c;
	
	    // Perform rotation-specific matrix multiplication
	    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
	    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
	    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
	    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
	    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
	    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
	    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
	    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
	    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
	    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
	    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
	    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged last row
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	    return out;
	};
	
	/**
	 * Rotates a matrix by the given angle around the X axis not using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.scalar.rotateX = function (out, a, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad),
	        a10 = a[4],
	        a11 = a[5],
	        a12 = a[6],
	        a13 = a[7],
	        a20 = a[8],
	        a21 = a[9],
	        a22 = a[10],
	        a23 = a[11];
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged rows
	        out[0]  = a[0];
	        out[1]  = a[1];
	        out[2]  = a[2];
	        out[3]  = a[3];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	
	    // Perform axis-specific matrix multiplication
	    out[4] = a10 * c + a20 * s;
	    out[5] = a11 * c + a21 * s;
	    out[6] = a12 * c + a22 * s;
	    out[7] = a13 * c + a23 * s;
	    out[8] = a20 * c - a10 * s;
	    out[9] = a21 * c - a11 * s;
	    out[10] = a22 * c - a12 * s;
	    out[11] = a23 * c - a13 * s;
	    return out;
	};
	
	/**
	 * Rotates a matrix by the given angle around the X axis using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.SIMD.rotateX = function (out, a, rad) {
	    var s = SIMD.Float32x4.splat(Math.sin(rad)),
	        c = SIMD.Float32x4.splat(Math.cos(rad));
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged rows
	      out[0]  = a[0];
	      out[1]  = a[1];
	      out[2]  = a[2];
	      out[3]  = a[3];
	      out[12] = a[12];
	      out[13] = a[13];
	      out[14] = a[14];
	      out[15] = a[15];
	    }
	
	    // Perform axis-specific matrix multiplication
	    var a_1 = SIMD.Float32x4.load(a, 4);
	    var a_2 = SIMD.Float32x4.load(a, 8);
	    SIMD.Float32x4.store(out, 4,
	                         SIMD.Float32x4.add(SIMD.Float32x4.mul(a_1, c), SIMD.Float32x4.mul(a_2, s)));
	    SIMD.Float32x4.store(out, 8,
	                         SIMD.Float32x4.sub(SIMD.Float32x4.mul(a_2, c), SIMD.Float32x4.mul(a_1, s)));
	    return out;
	};
	
	/**
	 * Rotates a matrix by the given angle around the X axis using SIMD if availabe and enabled
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.rotateX = glMatrix.USE_SIMD ? mat4.SIMD.rotateX : mat4.scalar.rotateX;
	
	/**
	 * Rotates a matrix by the given angle around the Y axis not using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.scalar.rotateY = function (out, a, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad),
	        a00 = a[0],
	        a01 = a[1],
	        a02 = a[2],
	        a03 = a[3],
	        a20 = a[8],
	        a21 = a[9],
	        a22 = a[10],
	        a23 = a[11];
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged rows
	        out[4]  = a[4];
	        out[5]  = a[5];
	        out[6]  = a[6];
	        out[7]  = a[7];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	
	    // Perform axis-specific matrix multiplication
	    out[0] = a00 * c - a20 * s;
	    out[1] = a01 * c - a21 * s;
	    out[2] = a02 * c - a22 * s;
	    out[3] = a03 * c - a23 * s;
	    out[8] = a00 * s + a20 * c;
	    out[9] = a01 * s + a21 * c;
	    out[10] = a02 * s + a22 * c;
	    out[11] = a03 * s + a23 * c;
	    return out;
	};
	
	/**
	 * Rotates a matrix by the given angle around the Y axis using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.SIMD.rotateY = function (out, a, rad) {
	    var s = SIMD.Float32x4.splat(Math.sin(rad)),
	        c = SIMD.Float32x4.splat(Math.cos(rad));
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged rows
	        out[4]  = a[4];
	        out[5]  = a[5];
	        out[6]  = a[6];
	        out[7]  = a[7];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	
	    // Perform axis-specific matrix multiplication
	    var a_0 = SIMD.Float32x4.load(a, 0);
	    var a_2 = SIMD.Float32x4.load(a, 8);
	    SIMD.Float32x4.store(out, 0,
	                         SIMD.Float32x4.sub(SIMD.Float32x4.mul(a_0, c), SIMD.Float32x4.mul(a_2, s)));
	    SIMD.Float32x4.store(out, 8,
	                         SIMD.Float32x4.add(SIMD.Float32x4.mul(a_0, s), SIMD.Float32x4.mul(a_2, c)));
	    return out;
	};
	
	/**
	 * Rotates a matrix by the given angle around the Y axis if SIMD available and enabled
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	 mat4.rotateY = glMatrix.USE_SIMD ? mat4.SIMD.rotateY : mat4.scalar.rotateY;
	
	/**
	 * Rotates a matrix by the given angle around the Z axis not using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.scalar.rotateZ = function (out, a, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad),
	        a00 = a[0],
	        a01 = a[1],
	        a02 = a[2],
	        a03 = a[3],
	        a10 = a[4],
	        a11 = a[5],
	        a12 = a[6],
	        a13 = a[7];
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged last row
	        out[8]  = a[8];
	        out[9]  = a[9];
	        out[10] = a[10];
	        out[11] = a[11];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	
	    // Perform axis-specific matrix multiplication
	    out[0] = a00 * c + a10 * s;
	    out[1] = a01 * c + a11 * s;
	    out[2] = a02 * c + a12 * s;
	    out[3] = a03 * c + a13 * s;
	    out[4] = a10 * c - a00 * s;
	    out[5] = a11 * c - a01 * s;
	    out[6] = a12 * c - a02 * s;
	    out[7] = a13 * c - a03 * s;
	    return out;
	};
	
	/**
	 * Rotates a matrix by the given angle around the Z axis using SIMD
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.SIMD.rotateZ = function (out, a, rad) {
	    var s = SIMD.Float32x4.splat(Math.sin(rad)),
	        c = SIMD.Float32x4.splat(Math.cos(rad));
	
	    if (a !== out) { // If the source and destination differ, copy the unchanged last row
	        out[8]  = a[8];
	        out[9]  = a[9];
	        out[10] = a[10];
	        out[11] = a[11];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	    }
	
	    // Perform axis-specific matrix multiplication
	    var a_0 = SIMD.Float32x4.load(a, 0);
	    var a_1 = SIMD.Float32x4.load(a, 4);
	    SIMD.Float32x4.store(out, 0,
	                         SIMD.Float32x4.add(SIMD.Float32x4.mul(a_0, c), SIMD.Float32x4.mul(a_1, s)));
	    SIMD.Float32x4.store(out, 4,
	                         SIMD.Float32x4.sub(SIMD.Float32x4.mul(a_1, c), SIMD.Float32x4.mul(a_0, s)));
	    return out;
	};
	
	/**
	 * Rotates a matrix by the given angle around the Z axis if SIMD available and enabled
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to rotate
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	 mat4.rotateZ = glMatrix.USE_SIMD ? mat4.SIMD.rotateZ : mat4.scalar.rotateZ;
	
	/**
	 * Creates a matrix from a vector translation
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.translate(dest, dest, vec);
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {vec3} v Translation vector
	 * @returns {mat4} out
	 */
	mat4.fromTranslation = function(out, v) {
	    out[0] = 1;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = 1;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = 1;
	    out[11] = 0;
	    out[12] = v[0];
	    out[13] = v[1];
	    out[14] = v[2];
	    out[15] = 1;
	    return out;
	}
	
	/**
	 * Creates a matrix from a vector scaling
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.scale(dest, dest, vec);
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {vec3} v Scaling vector
	 * @returns {mat4} out
	 */
	mat4.fromScaling = function(out, v) {
	    out[0] = v[0];
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = v[1];
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = v[2];
	    out[11] = 0;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	    return out;
	}
	
	/**
	 * Creates a matrix from a given angle around a given axis
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.rotate(dest, dest, rad, axis);
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {Number} rad the angle to rotate the matrix by
	 * @param {vec3} axis the axis to rotate around
	 * @returns {mat4} out
	 */
	mat4.fromRotation = function(out, rad, axis) {
	    var x = axis[0], y = axis[1], z = axis[2],
	        len = Math.sqrt(x * x + y * y + z * z),
	        s, c, t;
	
	    if (Math.abs(len) < glMatrix.EPSILON) { return null; }
	
	    len = 1 / len;
	    x *= len;
	    y *= len;
	    z *= len;
	
	    s = Math.sin(rad);
	    c = Math.cos(rad);
	    t = 1 - c;
	
	    // Perform rotation-specific matrix multiplication
	    out[0] = x * x * t + c;
	    out[1] = y * x * t + z * s;
	    out[2] = z * x * t - y * s;
	    out[3] = 0;
	    out[4] = x * y * t - z * s;
	    out[5] = y * y * t + c;
	    out[6] = z * y * t + x * s;
	    out[7] = 0;
	    out[8] = x * z * t + y * s;
	    out[9] = y * z * t - x * s;
	    out[10] = z * z * t + c;
	    out[11] = 0;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	    return out;
	}
	
	/**
	 * Creates a matrix from the given angle around the X axis
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.rotateX(dest, dest, rad);
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.fromXRotation = function(out, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad);
	
	    // Perform axis-specific matrix multiplication
	    out[0]  = 1;
	    out[1]  = 0;
	    out[2]  = 0;
	    out[3]  = 0;
	    out[4] = 0;
	    out[5] = c;
	    out[6] = s;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = -s;
	    out[10] = c;
	    out[11] = 0;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	    return out;
	}
	
	/**
	 * Creates a matrix from the given angle around the Y axis
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.rotateY(dest, dest, rad);
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.fromYRotation = function(out, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad);
	
	    // Perform axis-specific matrix multiplication
	    out[0]  = c;
	    out[1]  = 0;
	    out[2]  = -s;
	    out[3]  = 0;
	    out[4] = 0;
	    out[5] = 1;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = s;
	    out[9] = 0;
	    out[10] = c;
	    out[11] = 0;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	    return out;
	}
	
	/**
	 * Creates a matrix from the given angle around the Z axis
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.rotateZ(dest, dest, rad);
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {Number} rad the angle to rotate the matrix by
	 * @returns {mat4} out
	 */
	mat4.fromZRotation = function(out, rad) {
	    var s = Math.sin(rad),
	        c = Math.cos(rad);
	
	    // Perform axis-specific matrix multiplication
	    out[0]  = c;
	    out[1]  = s;
	    out[2]  = 0;
	    out[3]  = 0;
	    out[4] = -s;
	    out[5] = c;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = 1;
	    out[11] = 0;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	    return out;
	}
	
	/**
	 * Creates a matrix from a quaternion rotation and vector translation
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.translate(dest, vec);
	 *     var quatMat = mat4.create();
	 *     quat4.toMat4(quat, quatMat);
	 *     mat4.multiply(dest, quatMat);
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {quat4} q Rotation quaternion
	 * @param {vec3} v Translation vector
	 * @returns {mat4} out
	 */
	mat4.fromRotationTranslation = function (out, q, v) {
	    // Quaternion math
	    var x = q[0], y = q[1], z = q[2], w = q[3],
	        x2 = x + x,
	        y2 = y + y,
	        z2 = z + z,
	
	        xx = x * x2,
	        xy = x * y2,
	        xz = x * z2,
	        yy = y * y2,
	        yz = y * z2,
	        zz = z * z2,
	        wx = w * x2,
	        wy = w * y2,
	        wz = w * z2;
	
	    out[0] = 1 - (yy + zz);
	    out[1] = xy + wz;
	    out[2] = xz - wy;
	    out[3] = 0;
	    out[4] = xy - wz;
	    out[5] = 1 - (xx + zz);
	    out[6] = yz + wx;
	    out[7] = 0;
	    out[8] = xz + wy;
	    out[9] = yz - wx;
	    out[10] = 1 - (xx + yy);
	    out[11] = 0;
	    out[12] = v[0];
	    out[13] = v[1];
	    out[14] = v[2];
	    out[15] = 1;
	
	    return out;
	};
	
	/**
	 * Returns the translation vector component of a transformation
	 *  matrix. If a matrix is built with fromRotationTranslation,
	 *  the returned vector will be the same as the translation vector
	 *  originally supplied.
	 * @param  {vec3} out Vector to receive translation component
	 * @param  {mat4} mat Matrix to be decomposed (input)
	 * @return {vec3} out
	 */
	mat4.getTranslation = function (out, mat) {
	  out[0] = mat[12];
	  out[1] = mat[13];
	  out[2] = mat[14];
	
	  return out;
	};
	
	/**
	 * Returns a quaternion representing the rotational component
	 *  of a transformation matrix. If a matrix is built with
	 *  fromRotationTranslation, the returned quaternion will be the
	 *  same as the quaternion originally supplied.
	 * @param {quat} out Quaternion to receive the rotation component
	 * @param {mat4} mat Matrix to be decomposed (input)
	 * @return {quat} out
	 */
	mat4.getRotation = function (out, mat) {
	  // Algorithm taken from http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
	  var trace = mat[0] + mat[5] + mat[10];
	  var S = 0;
	
	  if (trace > 0) { 
	    S = Math.sqrt(trace + 1.0) * 2;
	    out[3] = 0.25 * S;
	    out[0] = (mat[6] - mat[9]) / S;
	    out[1] = (mat[8] - mat[2]) / S; 
	    out[2] = (mat[1] - mat[4]) / S; 
	  } else if ((mat[0] > mat[5])&(mat[0] > mat[10])) { 
	    S = Math.sqrt(1.0 + mat[0] - mat[5] - mat[10]) * 2;
	    out[3] = (mat[6] - mat[9]) / S;
	    out[0] = 0.25 * S;
	    out[1] = (mat[1] + mat[4]) / S; 
	    out[2] = (mat[8] + mat[2]) / S; 
	  } else if (mat[5] > mat[10]) { 
	    S = Math.sqrt(1.0 + mat[5] - mat[0] - mat[10]) * 2;
	    out[3] = (mat[8] - mat[2]) / S;
	    out[0] = (mat[1] + mat[4]) / S; 
	    out[1] = 0.25 * S;
	    out[2] = (mat[6] + mat[9]) / S; 
	  } else { 
	    S = Math.sqrt(1.0 + mat[10] - mat[0] - mat[5]) * 2;
	    out[3] = (mat[1] - mat[4]) / S;
	    out[0] = (mat[8] + mat[2]) / S;
	    out[1] = (mat[6] + mat[9]) / S;
	    out[2] = 0.25 * S;
	  }
	
	  return out;
	};
	
	/**
	 * Creates a matrix from a quaternion rotation, vector translation and vector scale
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.translate(dest, vec);
	 *     var quatMat = mat4.create();
	 *     quat4.toMat4(quat, quatMat);
	 *     mat4.multiply(dest, quatMat);
	 *     mat4.scale(dest, scale)
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {quat4} q Rotation quaternion
	 * @param {vec3} v Translation vector
	 * @param {vec3} s Scaling vector
	 * @returns {mat4} out
	 */
	mat4.fromRotationTranslationScale = function (out, q, v, s) {
	    // Quaternion math
	    var x = q[0], y = q[1], z = q[2], w = q[3],
	        x2 = x + x,
	        y2 = y + y,
	        z2 = z + z,
	
	        xx = x * x2,
	        xy = x * y2,
	        xz = x * z2,
	        yy = y * y2,
	        yz = y * z2,
	        zz = z * z2,
	        wx = w * x2,
	        wy = w * y2,
	        wz = w * z2,
	        sx = s[0],
	        sy = s[1],
	        sz = s[2];
	
	    out[0] = (1 - (yy + zz)) * sx;
	    out[1] = (xy + wz) * sx;
	    out[2] = (xz - wy) * sx;
	    out[3] = 0;
	    out[4] = (xy - wz) * sy;
	    out[5] = (1 - (xx + zz)) * sy;
	    out[6] = (yz + wx) * sy;
	    out[7] = 0;
	    out[8] = (xz + wy) * sz;
	    out[9] = (yz - wx) * sz;
	    out[10] = (1 - (xx + yy)) * sz;
	    out[11] = 0;
	    out[12] = v[0];
	    out[13] = v[1];
	    out[14] = v[2];
	    out[15] = 1;
	
	    return out;
	};
	
	/**
	 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
	 * This is equivalent to (but much faster than):
	 *
	 *     mat4.identity(dest);
	 *     mat4.translate(dest, vec);
	 *     mat4.translate(dest, origin);
	 *     var quatMat = mat4.create();
	 *     quat4.toMat4(quat, quatMat);
	 *     mat4.multiply(dest, quatMat);
	 *     mat4.scale(dest, scale)
	 *     mat4.translate(dest, negativeOrigin);
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {quat4} q Rotation quaternion
	 * @param {vec3} v Translation vector
	 * @param {vec3} s Scaling vector
	 * @param {vec3} o The origin vector around which to scale and rotate
	 * @returns {mat4} out
	 */
	mat4.fromRotationTranslationScaleOrigin = function (out, q, v, s, o) {
	  // Quaternion math
	  var x = q[0], y = q[1], z = q[2], w = q[3],
	      x2 = x + x,
	      y2 = y + y,
	      z2 = z + z,
	
	      xx = x * x2,
	      xy = x * y2,
	      xz = x * z2,
	      yy = y * y2,
	      yz = y * z2,
	      zz = z * z2,
	      wx = w * x2,
	      wy = w * y2,
	      wz = w * z2,
	
	      sx = s[0],
	      sy = s[1],
	      sz = s[2],
	
	      ox = o[0],
	      oy = o[1],
	      oz = o[2];
	
	  out[0] = (1 - (yy + zz)) * sx;
	  out[1] = (xy + wz) * sx;
	  out[2] = (xz - wy) * sx;
	  out[3] = 0;
	  out[4] = (xy - wz) * sy;
	  out[5] = (1 - (xx + zz)) * sy;
	  out[6] = (yz + wx) * sy;
	  out[7] = 0;
	  out[8] = (xz + wy) * sz;
	  out[9] = (yz - wx) * sz;
	  out[10] = (1 - (xx + yy)) * sz;
	  out[11] = 0;
	  out[12] = v[0] + ox - (out[0] * ox + out[4] * oy + out[8] * oz);
	  out[13] = v[1] + oy - (out[1] * ox + out[5] * oy + out[9] * oz);
	  out[14] = v[2] + oz - (out[2] * ox + out[6] * oy + out[10] * oz);
	  out[15] = 1;
	
	  return out;
	};
	
	/**
	 * Calculates a 4x4 matrix from the given quaternion
	 *
	 * @param {mat4} out mat4 receiving operation result
	 * @param {quat} q Quaternion to create matrix from
	 *
	 * @returns {mat4} out
	 */
	mat4.fromQuat = function (out, q) {
	    var x = q[0], y = q[1], z = q[2], w = q[3],
	        x2 = x + x,
	        y2 = y + y,
	        z2 = z + z,
	
	        xx = x * x2,
	        yx = y * x2,
	        yy = y * y2,
	        zx = z * x2,
	        zy = z * y2,
	        zz = z * z2,
	        wx = w * x2,
	        wy = w * y2,
	        wz = w * z2;
	
	    out[0] = 1 - yy - zz;
	    out[1] = yx + wz;
	    out[2] = zx - wy;
	    out[3] = 0;
	
	    out[4] = yx - wz;
	    out[5] = 1 - xx - zz;
	    out[6] = zy + wx;
	    out[7] = 0;
	
	    out[8] = zx + wy;
	    out[9] = zy - wx;
	    out[10] = 1 - xx - yy;
	    out[11] = 0;
	
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = 0;
	    out[15] = 1;
	
	    return out;
	};
	
	/**
	 * Generates a frustum matrix with the given bounds
	 *
	 * @param {mat4} out mat4 frustum matrix will be written into
	 * @param {Number} left Left bound of the frustum
	 * @param {Number} right Right bound of the frustum
	 * @param {Number} bottom Bottom bound of the frustum
	 * @param {Number} top Top bound of the frustum
	 * @param {Number} near Near bound of the frustum
	 * @param {Number} far Far bound of the frustum
	 * @returns {mat4} out
	 */
	mat4.frustum = function (out, left, right, bottom, top, near, far) {
	    var rl = 1 / (right - left),
	        tb = 1 / (top - bottom),
	        nf = 1 / (near - far);
	    out[0] = (near * 2) * rl;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = (near * 2) * tb;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = (right + left) * rl;
	    out[9] = (top + bottom) * tb;
	    out[10] = (far + near) * nf;
	    out[11] = -1;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = (far * near * 2) * nf;
	    out[15] = 0;
	    return out;
	};
	
	/**
	 * Generates a perspective projection matrix with the given bounds
	 *
	 * @param {mat4} out mat4 frustum matrix will be written into
	 * @param {number} fovy Vertical field of view in radians
	 * @param {number} aspect Aspect ratio. typically viewport width/height
	 * @param {number} near Near bound of the frustum
	 * @param {number} far Far bound of the frustum
	 * @returns {mat4} out
	 */
	mat4.perspective = function (out, fovy, aspect, near, far) {
	    var f = 1.0 / Math.tan(fovy / 2),
	        nf = 1 / (near - far);
	    out[0] = f / aspect;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = f;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = (far + near) * nf;
	    out[11] = -1;
	    out[12] = 0;
	    out[13] = 0;
	    out[14] = (2 * far * near) * nf;
	    out[15] = 0;
	    return out;
	};
	
	/**
	 * Generates a perspective projection matrix with the given field of view.
	 * This is primarily useful for generating projection matrices to be used
	 * with the still experiemental WebVR API.
	 *
	 * @param {mat4} out mat4 frustum matrix will be written into
	 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
	 * @param {number} near Near bound of the frustum
	 * @param {number} far Far bound of the frustum
	 * @returns {mat4} out
	 */
	mat4.perspectiveFromFieldOfView = function (out, fov, near, far) {
	    var upTan = Math.tan(fov.upDegrees * Math.PI/180.0),
	        downTan = Math.tan(fov.downDegrees * Math.PI/180.0),
	        leftTan = Math.tan(fov.leftDegrees * Math.PI/180.0),
	        rightTan = Math.tan(fov.rightDegrees * Math.PI/180.0),
	        xScale = 2.0 / (leftTan + rightTan),
	        yScale = 2.0 / (upTan + downTan);
	
	    out[0] = xScale;
	    out[1] = 0.0;
	    out[2] = 0.0;
	    out[3] = 0.0;
	    out[4] = 0.0;
	    out[5] = yScale;
	    out[6] = 0.0;
	    out[7] = 0.0;
	    out[8] = -((leftTan - rightTan) * xScale * 0.5);
	    out[9] = ((upTan - downTan) * yScale * 0.5);
	    out[10] = far / (near - far);
	    out[11] = -1.0;
	    out[12] = 0.0;
	    out[13] = 0.0;
	    out[14] = (far * near) / (near - far);
	    out[15] = 0.0;
	    return out;
	}
	
	/**
	 * Generates a orthogonal projection matrix with the given bounds
	 *
	 * @param {mat4} out mat4 frustum matrix will be written into
	 * @param {number} left Left bound of the frustum
	 * @param {number} right Right bound of the frustum
	 * @param {number} bottom Bottom bound of the frustum
	 * @param {number} top Top bound of the frustum
	 * @param {number} near Near bound of the frustum
	 * @param {number} far Far bound of the frustum
	 * @returns {mat4} out
	 */
	mat4.ortho = function (out, left, right, bottom, top, near, far) {
	    var lr = 1 / (left - right),
	        bt = 1 / (bottom - top),
	        nf = 1 / (near - far);
	    out[0] = -2 * lr;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 0;
	    out[4] = 0;
	    out[5] = -2 * bt;
	    out[6] = 0;
	    out[7] = 0;
	    out[8] = 0;
	    out[9] = 0;
	    out[10] = 2 * nf;
	    out[11] = 0;
	    out[12] = (left + right) * lr;
	    out[13] = (top + bottom) * bt;
	    out[14] = (far + near) * nf;
	    out[15] = 1;
	    return out;
	};
	
	/**
	 * Generates a look-at matrix with the given eye position, focal point, and up axis
	 *
	 * @param {mat4} out mat4 frustum matrix will be written into
	 * @param {vec3} eye Position of the viewer
	 * @param {vec3} center Point the viewer is looking at
	 * @param {vec3} up vec3 pointing up
	 * @returns {mat4} out
	 */
	mat4.lookAt = function (out, eye, center, up) {
	    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len,
	        eyex = eye[0],
	        eyey = eye[1],
	        eyez = eye[2],
	        upx = up[0],
	        upy = up[1],
	        upz = up[2],
	        centerx = center[0],
	        centery = center[1],
	        centerz = center[2];
	
	    if (Math.abs(eyex - centerx) < glMatrix.EPSILON &&
	        Math.abs(eyey - centery) < glMatrix.EPSILON &&
	        Math.abs(eyez - centerz) < glMatrix.EPSILON) {
	        return mat4.identity(out);
	    }
	
	    z0 = eyex - centerx;
	    z1 = eyey - centery;
	    z2 = eyez - centerz;
	
	    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
	    z0 *= len;
	    z1 *= len;
	    z2 *= len;
	
	    x0 = upy * z2 - upz * z1;
	    x1 = upz * z0 - upx * z2;
	    x2 = upx * z1 - upy * z0;
	    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
	    if (!len) {
	        x0 = 0;
	        x1 = 0;
	        x2 = 0;
	    } else {
	        len = 1 / len;
	        x0 *= len;
	        x1 *= len;
	        x2 *= len;
	    }
	
	    y0 = z1 * x2 - z2 * x1;
	    y1 = z2 * x0 - z0 * x2;
	    y2 = z0 * x1 - z1 * x0;
	
	    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
	    if (!len) {
	        y0 = 0;
	        y1 = 0;
	        y2 = 0;
	    } else {
	        len = 1 / len;
	        y0 *= len;
	        y1 *= len;
	        y2 *= len;
	    }
	
	    out[0] = x0;
	    out[1] = y0;
	    out[2] = z0;
	    out[3] = 0;
	    out[4] = x1;
	    out[5] = y1;
	    out[6] = z1;
	    out[7] = 0;
	    out[8] = x2;
	    out[9] = y2;
	    out[10] = z2;
	    out[11] = 0;
	    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
	    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
	    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
	    out[15] = 1;
	
	    return out;
	};
	
	/**
	 * Returns a string representation of a mat4
	 *
	 * @param {mat4} mat matrix to represent as a string
	 * @returns {String} string representation of the matrix
	 */
	mat4.str = function (a) {
	    return 'mat4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ', ' +
	                    a[4] + ', ' + a[5] + ', ' + a[6] + ', ' + a[7] + ', ' +
	                    a[8] + ', ' + a[9] + ', ' + a[10] + ', ' + a[11] + ', ' +
	                    a[12] + ', ' + a[13] + ', ' + a[14] + ', ' + a[15] + ')';
	};
	
	/**
	 * Returns Frobenius norm of a mat4
	 *
	 * @param {mat4} a the matrix to calculate Frobenius norm of
	 * @returns {Number} Frobenius norm
	 */
	mat4.frob = function (a) {
	    return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2) + Math.pow(a[9], 2) + Math.pow(a[10], 2) + Math.pow(a[11], 2) + Math.pow(a[12], 2) + Math.pow(a[13], 2) + Math.pow(a[14], 2) + Math.pow(a[15], 2) ))
	};
	
	/**
	 * Adds two mat4's
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the first operand
	 * @param {mat4} b the second operand
	 * @returns {mat4} out
	 */
	mat4.add = function(out, a, b) {
	    out[0] = a[0] + b[0];
	    out[1] = a[1] + b[1];
	    out[2] = a[2] + b[2];
	    out[3] = a[3] + b[3];
	    out[4] = a[4] + b[4];
	    out[5] = a[5] + b[5];
	    out[6] = a[6] + b[6];
	    out[7] = a[7] + b[7];
	    out[8] = a[8] + b[8];
	    out[9] = a[9] + b[9];
	    out[10] = a[10] + b[10];
	    out[11] = a[11] + b[11];
	    out[12] = a[12] + b[12];
	    out[13] = a[13] + b[13];
	    out[14] = a[14] + b[14];
	    out[15] = a[15] + b[15];
	    return out;
	};
	
	/**
	 * Subtracts matrix b from matrix a
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the first operand
	 * @param {mat4} b the second operand
	 * @returns {mat4} out
	 */
	mat4.subtract = function(out, a, b) {
	    out[0] = a[0] - b[0];
	    out[1] = a[1] - b[1];
	    out[2] = a[2] - b[2];
	    out[3] = a[3] - b[3];
	    out[4] = a[4] - b[4];
	    out[5] = a[5] - b[5];
	    out[6] = a[6] - b[6];
	    out[7] = a[7] - b[7];
	    out[8] = a[8] - b[8];
	    out[9] = a[9] - b[9];
	    out[10] = a[10] - b[10];
	    out[11] = a[11] - b[11];
	    out[12] = a[12] - b[12];
	    out[13] = a[13] - b[13];
	    out[14] = a[14] - b[14];
	    out[15] = a[15] - b[15];
	    return out;
	};
	
	/**
	 * Alias for {@link mat4.subtract}
	 * @function
	 */
	mat4.sub = mat4.subtract;
	
	/**
	 * Multiply each element of the matrix by a scalar.
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the matrix to scale
	 * @param {Number} b amount to scale the matrix's elements by
	 * @returns {mat4} out
	 */
	mat4.multiplyScalar = function(out, a, b) {
	    out[0] = a[0] * b;
	    out[1] = a[1] * b;
	    out[2] = a[2] * b;
	    out[3] = a[3] * b;
	    out[4] = a[4] * b;
	    out[5] = a[5] * b;
	    out[6] = a[6] * b;
	    out[7] = a[7] * b;
	    out[8] = a[8] * b;
	    out[9] = a[9] * b;
	    out[10] = a[10] * b;
	    out[11] = a[11] * b;
	    out[12] = a[12] * b;
	    out[13] = a[13] * b;
	    out[14] = a[14] * b;
	    out[15] = a[15] * b;
	    return out;
	};
	
	/**
	 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
	 *
	 * @param {mat4} out the receiving vector
	 * @param {mat4} a the first operand
	 * @param {mat4} b the second operand
	 * @param {Number} scale the amount to scale b's elements by before adding
	 * @returns {mat4} out
	 */
	mat4.multiplyScalarAndAdd = function(out, a, b, scale) {
	    out[0] = a[0] + (b[0] * scale);
	    out[1] = a[1] + (b[1] * scale);
	    out[2] = a[2] + (b[2] * scale);
	    out[3] = a[3] + (b[3] * scale);
	    out[4] = a[4] + (b[4] * scale);
	    out[5] = a[5] + (b[5] * scale);
	    out[6] = a[6] + (b[6] * scale);
	    out[7] = a[7] + (b[7] * scale);
	    out[8] = a[8] + (b[8] * scale);
	    out[9] = a[9] + (b[9] * scale);
	    out[10] = a[10] + (b[10] * scale);
	    out[11] = a[11] + (b[11] * scale);
	    out[12] = a[12] + (b[12] * scale);
	    out[13] = a[13] + (b[13] * scale);
	    out[14] = a[14] + (b[14] * scale);
	    out[15] = a[15] + (b[15] * scale);
	    return out;
	};
	
	/**
	 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
	 *
	 * @param {mat4} a The first matrix.
	 * @param {mat4} b The second matrix.
	 * @returns {Boolean} True if the matrices are equal, false otherwise.
	 */
	mat4.exactEquals = function (a, b) {
	    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && 
	           a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && 
	           a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] &&
	           a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
	};
	
	/**
	 * Returns whether or not the matrices have approximately the same elements in the same position.
	 *
	 * @param {mat4} a The first matrix.
	 * @param {mat4} b The second matrix.
	 * @returns {Boolean} True if the matrices are equal, false otherwise.
	 */
	mat4.equals = function (a, b) {
	    var a0  = a[0],  a1  = a[1],  a2  = a[2],  a3  = a[3],
	        a4  = a[4],  a5  = a[5],  a6  = a[6],  a7  = a[7], 
	        a8  = a[8],  a9  = a[9],  a10 = a[10], a11 = a[11], 
	        a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
	
	    var b0  = b[0],  b1  = b[1],  b2  = b[2],  b3  = b[3],
	        b4  = b[4],  b5  = b[5],  b6  = b[6],  b7  = b[7], 
	        b8  = b[8],  b9  = b[9],  b10 = b[10], b11 = b[11], 
	        b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
	
	    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
	            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
	            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
	            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
	            Math.abs(a4 - b4) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
	            Math.abs(a5 - b5) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a5), Math.abs(b5)) &&
	            Math.abs(a6 - b6) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a6), Math.abs(b6)) &&
	            Math.abs(a7 - b7) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a7), Math.abs(b7)) &&
	            Math.abs(a8 - b8) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a8), Math.abs(b8)) &&
	            Math.abs(a9 - b9) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a9), Math.abs(b9)) &&
	            Math.abs(a10 - b10) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a10), Math.abs(b10)) &&
	            Math.abs(a11 - b11) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a11), Math.abs(b11)) &&
	            Math.abs(a12 - b12) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a12), Math.abs(b12)) &&
	            Math.abs(a13 - b13) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a13), Math.abs(b13)) &&
	            Math.abs(a14 - b14) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a14), Math.abs(b14)) &&
	            Math.abs(a15 - b15) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a15), Math.abs(b15)));
	};
	
	
	
	module.exports = mat4;


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var glMatrix = __webpack_require__(81);
	var mat3 = __webpack_require__(404);
	var vec3 = __webpack_require__(405);
	var vec4 = __webpack_require__(406);
	
	/**
	 * @class Quaternion
	 * @name quat
	 */
	var quat = {};
	
	/**
	 * Creates a new identity quat
	 *
	 * @returns {quat} a new quaternion
	 */
	quat.create = function() {
	    var out = new glMatrix.ARRAY_TYPE(4);
	    out[0] = 0;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 1;
	    return out;
	};
	
	/**
	 * Sets a quaternion to represent the shortest rotation from one
	 * vector to another.
	 *
	 * Both vectors are assumed to be unit length.
	 *
	 * @param {quat} out the receiving quaternion.
	 * @param {vec3} a the initial vector
	 * @param {vec3} b the destination vector
	 * @returns {quat} out
	 */
	quat.rotationTo = (function() {
	    var tmpvec3 = vec3.create();
	    var xUnitVec3 = vec3.fromValues(1,0,0);
	    var yUnitVec3 = vec3.fromValues(0,1,0);
	
	    return function(out, a, b) {
	        var dot = vec3.dot(a, b);
	        if (dot < -0.999999) {
	            vec3.cross(tmpvec3, xUnitVec3, a);
	            if (vec3.length(tmpvec3) < 0.000001)
	                vec3.cross(tmpvec3, yUnitVec3, a);
	            vec3.normalize(tmpvec3, tmpvec3);
	            quat.setAxisAngle(out, tmpvec3, Math.PI);
	            return out;
	        } else if (dot > 0.999999) {
	            out[0] = 0;
	            out[1] = 0;
	            out[2] = 0;
	            out[3] = 1;
	            return out;
	        } else {
	            vec3.cross(tmpvec3, a, b);
	            out[0] = tmpvec3[0];
	            out[1] = tmpvec3[1];
	            out[2] = tmpvec3[2];
	            out[3] = 1 + dot;
	            return quat.normalize(out, out);
	        }
	    };
	})();
	
	/**
	 * Sets the specified quaternion with values corresponding to the given
	 * axes. Each axis is a vec3 and is expected to be unit length and
	 * perpendicular to all other specified axes.
	 *
	 * @param {vec3} view  the vector representing the viewing direction
	 * @param {vec3} right the vector representing the local "right" direction
	 * @param {vec3} up    the vector representing the local "up" direction
	 * @returns {quat} out
	 */
	quat.setAxes = (function() {
	    var matr = mat3.create();
	
	    return function(out, view, right, up) {
	        matr[0] = right[0];
	        matr[3] = right[1];
	        matr[6] = right[2];
	
	        matr[1] = up[0];
	        matr[4] = up[1];
	        matr[7] = up[2];
	
	        matr[2] = -view[0];
	        matr[5] = -view[1];
	        matr[8] = -view[2];
	
	        return quat.normalize(out, quat.fromMat3(out, matr));
	    };
	})();
	
	/**
	 * Creates a new quat initialized with values from an existing quaternion
	 *
	 * @param {quat} a quaternion to clone
	 * @returns {quat} a new quaternion
	 * @function
	 */
	quat.clone = vec4.clone;
	
	/**
	 * Creates a new quat initialized with the given values
	 *
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @param {Number} w W component
	 * @returns {quat} a new quaternion
	 * @function
	 */
	quat.fromValues = vec4.fromValues;
	
	/**
	 * Copy the values from one quat to another
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a the source quaternion
	 * @returns {quat} out
	 * @function
	 */
	quat.copy = vec4.copy;
	
	/**
	 * Set the components of a quat to the given values
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @param {Number} z Z component
	 * @param {Number} w W component
	 * @returns {quat} out
	 * @function
	 */
	quat.set = vec4.set;
	
	/**
	 * Set a quat to the identity quaternion
	 *
	 * @param {quat} out the receiving quaternion
	 * @returns {quat} out
	 */
	quat.identity = function(out) {
	    out[0] = 0;
	    out[1] = 0;
	    out[2] = 0;
	    out[3] = 1;
	    return out;
	};
	
	/**
	 * Sets a quat from the given angle and rotation axis,
	 * then returns it.
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {vec3} axis the axis around which to rotate
	 * @param {Number} rad the angle in radians
	 * @returns {quat} out
	 **/
	quat.setAxisAngle = function(out, axis, rad) {
	    rad = rad * 0.5;
	    var s = Math.sin(rad);
	    out[0] = s * axis[0];
	    out[1] = s * axis[1];
	    out[2] = s * axis[2];
	    out[3] = Math.cos(rad);
	    return out;
	};
	
	/**
	 * Gets the rotation axis and angle for a given
	 *  quaternion. If a quaternion is created with
	 *  setAxisAngle, this method will return the same
	 *  values as providied in the original parameter list
	 *  OR functionally equivalent values.
	 * Example: The quaternion formed by axis [0, 0, 1] and
	 *  angle -90 is the same as the quaternion formed by
	 *  [0, 0, 1] and 270. This method favors the latter.
	 * @param  {vec3} out_axis  Vector receiving the axis of rotation
	 * @param  {quat} q     Quaternion to be decomposed
	 * @return {Number}     Angle, in radians, of the rotation
	 */
	quat.getAxisAngle = function(out_axis, q) {
	    var rad = Math.acos(q[3]) * 2.0;
	    var s = Math.sin(rad / 2.0);
	    if (s != 0.0) {
	        out_axis[0] = q[0] / s;
	        out_axis[1] = q[1] / s;
	        out_axis[2] = q[2] / s;
	    } else {
	        // If s is zero, return any axis (no rotation - axis does not matter)
	        out_axis[0] = 1;
	        out_axis[1] = 0;
	        out_axis[2] = 0;
	    }
	    return rad;
	};
	
	/**
	 * Adds two quat's
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a the first operand
	 * @param {quat} b the second operand
	 * @returns {quat} out
	 * @function
	 */
	quat.add = vec4.add;
	
	/**
	 * Multiplies two quat's
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a the first operand
	 * @param {quat} b the second operand
	 * @returns {quat} out
	 */
	quat.multiply = function(out, a, b) {
	    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	        bx = b[0], by = b[1], bz = b[2], bw = b[3];
	
	    out[0] = ax * bw + aw * bx + ay * bz - az * by;
	    out[1] = ay * bw + aw * by + az * bx - ax * bz;
	    out[2] = az * bw + aw * bz + ax * by - ay * bx;
	    out[3] = aw * bw - ax * bx - ay * by - az * bz;
	    return out;
	};
	
	/**
	 * Alias for {@link quat.multiply}
	 * @function
	 */
	quat.mul = quat.multiply;
	
	/**
	 * Scales a quat by a scalar number
	 *
	 * @param {quat} out the receiving vector
	 * @param {quat} a the vector to scale
	 * @param {Number} b amount to scale the vector by
	 * @returns {quat} out
	 * @function
	 */
	quat.scale = vec4.scale;
	
	/**
	 * Rotates a quaternion by the given angle about the X axis
	 *
	 * @param {quat} out quat receiving operation result
	 * @param {quat} a quat to rotate
	 * @param {number} rad angle (in radians) to rotate
	 * @returns {quat} out
	 */
	quat.rotateX = function (out, a, rad) {
	    rad *= 0.5; 
	
	    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	        bx = Math.sin(rad), bw = Math.cos(rad);
	
	    out[0] = ax * bw + aw * bx;
	    out[1] = ay * bw + az * bx;
	    out[2] = az * bw - ay * bx;
	    out[3] = aw * bw - ax * bx;
	    return out;
	};
	
	/**
	 * Rotates a quaternion by the given angle about the Y axis
	 *
	 * @param {quat} out quat receiving operation result
	 * @param {quat} a quat to rotate
	 * @param {number} rad angle (in radians) to rotate
	 * @returns {quat} out
	 */
	quat.rotateY = function (out, a, rad) {
	    rad *= 0.5; 
	
	    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	        by = Math.sin(rad), bw = Math.cos(rad);
	
	    out[0] = ax * bw - az * by;
	    out[1] = ay * bw + aw * by;
	    out[2] = az * bw + ax * by;
	    out[3] = aw * bw - ay * by;
	    return out;
	};
	
	/**
	 * Rotates a quaternion by the given angle about the Z axis
	 *
	 * @param {quat} out quat receiving operation result
	 * @param {quat} a quat to rotate
	 * @param {number} rad angle (in radians) to rotate
	 * @returns {quat} out
	 */
	quat.rotateZ = function (out, a, rad) {
	    rad *= 0.5; 
	
	    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	        bz = Math.sin(rad), bw = Math.cos(rad);
	
	    out[0] = ax * bw + ay * bz;
	    out[1] = ay * bw - ax * bz;
	    out[2] = az * bw + aw * bz;
	    out[3] = aw * bw - az * bz;
	    return out;
	};
	
	/**
	 * Calculates the W component of a quat from the X, Y, and Z components.
	 * Assumes that quaternion is 1 unit in length.
	 * Any existing W component will be ignored.
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a quat to calculate W component of
	 * @returns {quat} out
	 */
	quat.calculateW = function (out, a) {
	    var x = a[0], y = a[1], z = a[2];
	
	    out[0] = x;
	    out[1] = y;
	    out[2] = z;
	    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
	    return out;
	};
	
	/**
	 * Calculates the dot product of two quat's
	 *
	 * @param {quat} a the first operand
	 * @param {quat} b the second operand
	 * @returns {Number} dot product of a and b
	 * @function
	 */
	quat.dot = vec4.dot;
	
	/**
	 * Performs a linear interpolation between two quat's
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a the first operand
	 * @param {quat} b the second operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {quat} out
	 * @function
	 */
	quat.lerp = vec4.lerp;
	
	/**
	 * Performs a spherical linear interpolation between two quat
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a the first operand
	 * @param {quat} b the second operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {quat} out
	 */
	quat.slerp = function (out, a, b, t) {
	    // benchmarks:
	    //    http://jsperf.com/quaternion-slerp-implementations
	
	    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	        bx = b[0], by = b[1], bz = b[2], bw = b[3];
	
	    var        omega, cosom, sinom, scale0, scale1;
	
	    // calc cosine
	    cosom = ax * bx + ay * by + az * bz + aw * bw;
	    // adjust signs (if necessary)
	    if ( cosom < 0.0 ) {
	        cosom = -cosom;
	        bx = - bx;
	        by = - by;
	        bz = - bz;
	        bw = - bw;
	    }
	    // calculate coefficients
	    if ( (1.0 - cosom) > 0.000001 ) {
	        // standard case (slerp)
	        omega  = Math.acos(cosom);
	        sinom  = Math.sin(omega);
	        scale0 = Math.sin((1.0 - t) * omega) / sinom;
	        scale1 = Math.sin(t * omega) / sinom;
	    } else {        
	        // "from" and "to" quaternions are very close 
	        //  ... so we can do a linear interpolation
	        scale0 = 1.0 - t;
	        scale1 = t;
	    }
	    // calculate final values
	    out[0] = scale0 * ax + scale1 * bx;
	    out[1] = scale0 * ay + scale1 * by;
	    out[2] = scale0 * az + scale1 * bz;
	    out[3] = scale0 * aw + scale1 * bw;
	    
	    return out;
	};
	
	/**
	 * Performs a spherical linear interpolation with two control points
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a the first operand
	 * @param {quat} b the second operand
	 * @param {quat} c the third operand
	 * @param {quat} d the fourth operand
	 * @param {Number} t interpolation amount
	 * @returns {quat} out
	 */
	quat.sqlerp = (function () {
	  var temp1 = quat.create();
	  var temp2 = quat.create();
	  
	  return function (out, a, b, c, d, t) {
	    quat.slerp(temp1, a, d, t);
	    quat.slerp(temp2, b, c, t);
	    quat.slerp(out, temp1, temp2, 2 * t * (1 - t));
	    
	    return out;
	  };
	}());
	
	/**
	 * Calculates the inverse of a quat
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a quat to calculate inverse of
	 * @returns {quat} out
	 */
	quat.invert = function(out, a) {
	    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3],
	        dot = a0*a0 + a1*a1 + a2*a2 + a3*a3,
	        invDot = dot ? 1.0/dot : 0;
	    
	    // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
	
	    out[0] = -a0*invDot;
	    out[1] = -a1*invDot;
	    out[2] = -a2*invDot;
	    out[3] = a3*invDot;
	    return out;
	};
	
	/**
	 * Calculates the conjugate of a quat
	 * If the quaternion is normalized, this function is faster than quat.inverse and produces the same result.
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a quat to calculate conjugate of
	 * @returns {quat} out
	 */
	quat.conjugate = function (out, a) {
	    out[0] = -a[0];
	    out[1] = -a[1];
	    out[2] = -a[2];
	    out[3] = a[3];
	    return out;
	};
	
	/**
	 * Calculates the length of a quat
	 *
	 * @param {quat} a vector to calculate length of
	 * @returns {Number} length of a
	 * @function
	 */
	quat.length = vec4.length;
	
	/**
	 * Alias for {@link quat.length}
	 * @function
	 */
	quat.len = quat.length;
	
	/**
	 * Calculates the squared length of a quat
	 *
	 * @param {quat} a vector to calculate squared length of
	 * @returns {Number} squared length of a
	 * @function
	 */
	quat.squaredLength = vec4.squaredLength;
	
	/**
	 * Alias for {@link quat.squaredLength}
	 * @function
	 */
	quat.sqrLen = quat.squaredLength;
	
	/**
	 * Normalize a quat
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {quat} a quaternion to normalize
	 * @returns {quat} out
	 * @function
	 */
	quat.normalize = vec4.normalize;
	
	/**
	 * Creates a quaternion from the given 3x3 rotation matrix.
	 *
	 * NOTE: The resultant quaternion is not normalized, so you should be sure
	 * to renormalize the quaternion yourself where necessary.
	 *
	 * @param {quat} out the receiving quaternion
	 * @param {mat3} m rotation matrix
	 * @returns {quat} out
	 * @function
	 */
	quat.fromMat3 = function(out, m) {
	    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
	    // article "Quaternion Calculus and Fast Animation".
	    var fTrace = m[0] + m[4] + m[8];
	    var fRoot;
	
	    if ( fTrace > 0.0 ) {
	        // |w| > 1/2, may as well choose w > 1/2
	        fRoot = Math.sqrt(fTrace + 1.0);  // 2w
	        out[3] = 0.5 * fRoot;
	        fRoot = 0.5/fRoot;  // 1/(4w)
	        out[0] = (m[5]-m[7])*fRoot;
	        out[1] = (m[6]-m[2])*fRoot;
	        out[2] = (m[1]-m[3])*fRoot;
	    } else {
	        // |w| <= 1/2
	        var i = 0;
	        if ( m[4] > m[0] )
	          i = 1;
	        if ( m[8] > m[i*3+i] )
	          i = 2;
	        var j = (i+1)%3;
	        var k = (i+2)%3;
	        
	        fRoot = Math.sqrt(m[i*3+i]-m[j*3+j]-m[k*3+k] + 1.0);
	        out[i] = 0.5 * fRoot;
	        fRoot = 0.5 / fRoot;
	        out[3] = (m[j*3+k] - m[k*3+j]) * fRoot;
	        out[j] = (m[j*3+i] + m[i*3+j]) * fRoot;
	        out[k] = (m[k*3+i] + m[i*3+k]) * fRoot;
	    }
	    
	    return out;
	};
	
	/**
	 * Returns a string representation of a quatenion
	 *
	 * @param {quat} vec vector to represent as a string
	 * @returns {String} string representation of the vector
	 */
	quat.str = function (a) {
	    return 'quat(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
	};
	
	/**
	 * Returns whether or not the quaternions have exactly the same elements in the same position (when compared with ===)
	 *
	 * @param {quat} a The first quaternion.
	 * @param {quat} b The second quaternion.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	quat.exactEquals = vec4.exactEquals;
	
	/**
	 * Returns whether or not the quaternions have approximately the same elements in the same position.
	 *
	 * @param {quat} a The first vector.
	 * @param {quat} b The second vector.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	quat.equals = vec4.equals;
	
	module.exports = quat;


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var glMatrix = __webpack_require__(81);
	
	/**
	 * @class 2 Dimensional Vector
	 * @name vec2
	 */
	var vec2 = {};
	
	/**
	 * Creates a new, empty vec2
	 *
	 * @returns {vec2} a new 2D vector
	 */
	vec2.create = function() {
	    var out = new glMatrix.ARRAY_TYPE(2);
	    out[0] = 0;
	    out[1] = 0;
	    return out;
	};
	
	/**
	 * Creates a new vec2 initialized with values from an existing vector
	 *
	 * @param {vec2} a vector to clone
	 * @returns {vec2} a new 2D vector
	 */
	vec2.clone = function(a) {
	    var out = new glMatrix.ARRAY_TYPE(2);
	    out[0] = a[0];
	    out[1] = a[1];
	    return out;
	};
	
	/**
	 * Creates a new vec2 initialized with the given values
	 *
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @returns {vec2} a new 2D vector
	 */
	vec2.fromValues = function(x, y) {
	    var out = new glMatrix.ARRAY_TYPE(2);
	    out[0] = x;
	    out[1] = y;
	    return out;
	};
	
	/**
	 * Copy the values from one vec2 to another
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the source vector
	 * @returns {vec2} out
	 */
	vec2.copy = function(out, a) {
	    out[0] = a[0];
	    out[1] = a[1];
	    return out;
	};
	
	/**
	 * Set the components of a vec2 to the given values
	 *
	 * @param {vec2} out the receiving vector
	 * @param {Number} x X component
	 * @param {Number} y Y component
	 * @returns {vec2} out
	 */
	vec2.set = function(out, x, y) {
	    out[0] = x;
	    out[1] = y;
	    return out;
	};
	
	/**
	 * Adds two vec2's
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {vec2} out
	 */
	vec2.add = function(out, a, b) {
	    out[0] = a[0] + b[0];
	    out[1] = a[1] + b[1];
	    return out;
	};
	
	/**
	 * Subtracts vector b from vector a
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {vec2} out
	 */
	vec2.subtract = function(out, a, b) {
	    out[0] = a[0] - b[0];
	    out[1] = a[1] - b[1];
	    return out;
	};
	
	/**
	 * Alias for {@link vec2.subtract}
	 * @function
	 */
	vec2.sub = vec2.subtract;
	
	/**
	 * Multiplies two vec2's
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {vec2} out
	 */
	vec2.multiply = function(out, a, b) {
	    out[0] = a[0] * b[0];
	    out[1] = a[1] * b[1];
	    return out;
	};
	
	/**
	 * Alias for {@link vec2.multiply}
	 * @function
	 */
	vec2.mul = vec2.multiply;
	
	/**
	 * Divides two vec2's
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {vec2} out
	 */
	vec2.divide = function(out, a, b) {
	    out[0] = a[0] / b[0];
	    out[1] = a[1] / b[1];
	    return out;
	};
	
	/**
	 * Alias for {@link vec2.divide}
	 * @function
	 */
	vec2.div = vec2.divide;
	
	/**
	 * Math.ceil the components of a vec2
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a vector to ceil
	 * @returns {vec2} out
	 */
	vec2.ceil = function (out, a) {
	    out[0] = Math.ceil(a[0]);
	    out[1] = Math.ceil(a[1]);
	    return out;
	};
	
	/**
	 * Math.floor the components of a vec2
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a vector to floor
	 * @returns {vec2} out
	 */
	vec2.floor = function (out, a) {
	    out[0] = Math.floor(a[0]);
	    out[1] = Math.floor(a[1]);
	    return out;
	};
	
	/**
	 * Returns the minimum of two vec2's
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {vec2} out
	 */
	vec2.min = function(out, a, b) {
	    out[0] = Math.min(a[0], b[0]);
	    out[1] = Math.min(a[1], b[1]);
	    return out;
	};
	
	/**
	 * Returns the maximum of two vec2's
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {vec2} out
	 */
	vec2.max = function(out, a, b) {
	    out[0] = Math.max(a[0], b[0]);
	    out[1] = Math.max(a[1], b[1]);
	    return out;
	};
	
	/**
	 * Math.round the components of a vec2
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a vector to round
	 * @returns {vec2} out
	 */
	vec2.round = function (out, a) {
	    out[0] = Math.round(a[0]);
	    out[1] = Math.round(a[1]);
	    return out;
	};
	
	/**
	 * Scales a vec2 by a scalar number
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the vector to scale
	 * @param {Number} b amount to scale the vector by
	 * @returns {vec2} out
	 */
	vec2.scale = function(out, a, b) {
	    out[0] = a[0] * b;
	    out[1] = a[1] * b;
	    return out;
	};
	
	/**
	 * Adds two vec2's after scaling the second operand by a scalar value
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @param {Number} scale the amount to scale b by before adding
	 * @returns {vec2} out
	 */
	vec2.scaleAndAdd = function(out, a, b, scale) {
	    out[0] = a[0] + (b[0] * scale);
	    out[1] = a[1] + (b[1] * scale);
	    return out;
	};
	
	/**
	 * Calculates the euclidian distance between two vec2's
	 *
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {Number} distance between a and b
	 */
	vec2.distance = function(a, b) {
	    var x = b[0] - a[0],
	        y = b[1] - a[1];
	    return Math.sqrt(x*x + y*y);
	};
	
	/**
	 * Alias for {@link vec2.distance}
	 * @function
	 */
	vec2.dist = vec2.distance;
	
	/**
	 * Calculates the squared euclidian distance between two vec2's
	 *
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {Number} squared distance between a and b
	 */
	vec2.squaredDistance = function(a, b) {
	    var x = b[0] - a[0],
	        y = b[1] - a[1];
	    return x*x + y*y;
	};
	
	/**
	 * Alias for {@link vec2.squaredDistance}
	 * @function
	 */
	vec2.sqrDist = vec2.squaredDistance;
	
	/**
	 * Calculates the length of a vec2
	 *
	 * @param {vec2} a vector to calculate length of
	 * @returns {Number} length of a
	 */
	vec2.length = function (a) {
	    var x = a[0],
	        y = a[1];
	    return Math.sqrt(x*x + y*y);
	};
	
	/**
	 * Alias for {@link vec2.length}
	 * @function
	 */
	vec2.len = vec2.length;
	
	/**
	 * Calculates the squared length of a vec2
	 *
	 * @param {vec2} a vector to calculate squared length of
	 * @returns {Number} squared length of a
	 */
	vec2.squaredLength = function (a) {
	    var x = a[0],
	        y = a[1];
	    return x*x + y*y;
	};
	
	/**
	 * Alias for {@link vec2.squaredLength}
	 * @function
	 */
	vec2.sqrLen = vec2.squaredLength;
	
	/**
	 * Negates the components of a vec2
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a vector to negate
	 * @returns {vec2} out
	 */
	vec2.negate = function(out, a) {
	    out[0] = -a[0];
	    out[1] = -a[1];
	    return out;
	};
	
	/**
	 * Returns the inverse of the components of a vec2
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a vector to invert
	 * @returns {vec2} out
	 */
	vec2.inverse = function(out, a) {
	  out[0] = 1.0 / a[0];
	  out[1] = 1.0 / a[1];
	  return out;
	};
	
	/**
	 * Normalize a vec2
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a vector to normalize
	 * @returns {vec2} out
	 */
	vec2.normalize = function(out, a) {
	    var x = a[0],
	        y = a[1];
	    var len = x*x + y*y;
	    if (len > 0) {
	        //TODO: evaluate use of glm_invsqrt here?
	        len = 1 / Math.sqrt(len);
	        out[0] = a[0] * len;
	        out[1] = a[1] * len;
	    }
	    return out;
	};
	
	/**
	 * Calculates the dot product of two vec2's
	 *
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {Number} dot product of a and b
	 */
	vec2.dot = function (a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	};
	
	/**
	 * Computes the cross product of two vec2's
	 * Note that the cross product must by definition produce a 3D vector
	 *
	 * @param {vec3} out the receiving vector
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @returns {vec3} out
	 */
	vec2.cross = function(out, a, b) {
	    var z = a[0] * b[1] - a[1] * b[0];
	    out[0] = out[1] = 0;
	    out[2] = z;
	    return out;
	};
	
	/**
	 * Performs a linear interpolation between two vec2's
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the first operand
	 * @param {vec2} b the second operand
	 * @param {Number} t interpolation amount between the two inputs
	 * @returns {vec2} out
	 */
	vec2.lerp = function (out, a, b, t) {
	    var ax = a[0],
	        ay = a[1];
	    out[0] = ax + t * (b[0] - ax);
	    out[1] = ay + t * (b[1] - ay);
	    return out;
	};
	
	/**
	 * Generates a random vector with the given scale
	 *
	 * @param {vec2} out the receiving vector
	 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
	 * @returns {vec2} out
	 */
	vec2.random = function (out, scale) {
	    scale = scale || 1.0;
	    var r = glMatrix.RANDOM() * 2.0 * Math.PI;
	    out[0] = Math.cos(r) * scale;
	    out[1] = Math.sin(r) * scale;
	    return out;
	};
	
	/**
	 * Transforms the vec2 with a mat2
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the vector to transform
	 * @param {mat2} m matrix to transform with
	 * @returns {vec2} out
	 */
	vec2.transformMat2 = function(out, a, m) {
	    var x = a[0],
	        y = a[1];
	    out[0] = m[0] * x + m[2] * y;
	    out[1] = m[1] * x + m[3] * y;
	    return out;
	};
	
	/**
	 * Transforms the vec2 with a mat2d
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the vector to transform
	 * @param {mat2d} m matrix to transform with
	 * @returns {vec2} out
	 */
	vec2.transformMat2d = function(out, a, m) {
	    var x = a[0],
	        y = a[1];
	    out[0] = m[0] * x + m[2] * y + m[4];
	    out[1] = m[1] * x + m[3] * y + m[5];
	    return out;
	};
	
	/**
	 * Transforms the vec2 with a mat3
	 * 3rd vector component is implicitly '1'
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the vector to transform
	 * @param {mat3} m matrix to transform with
	 * @returns {vec2} out
	 */
	vec2.transformMat3 = function(out, a, m) {
	    var x = a[0],
	        y = a[1];
	    out[0] = m[0] * x + m[3] * y + m[6];
	    out[1] = m[1] * x + m[4] * y + m[7];
	    return out;
	};
	
	/**
	 * Transforms the vec2 with a mat4
	 * 3rd vector component is implicitly '0'
	 * 4th vector component is implicitly '1'
	 *
	 * @param {vec2} out the receiving vector
	 * @param {vec2} a the vector to transform
	 * @param {mat4} m matrix to transform with
	 * @returns {vec2} out
	 */
	vec2.transformMat4 = function(out, a, m) {
	    var x = a[0], 
	        y = a[1];
	    out[0] = m[0] * x + m[4] * y + m[12];
	    out[1] = m[1] * x + m[5] * y + m[13];
	    return out;
	};
	
	/**
	 * Perform some operation over an array of vec2s.
	 *
	 * @param {Array} a the array of vectors to iterate over
	 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
	 * @param {Number} offset Number of elements to skip at the beginning of the array
	 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
	 * @param {Function} fn Function to call for each vector in the array
	 * @param {Object} [arg] additional argument to pass to fn
	 * @returns {Array} a
	 * @function
	 */
	vec2.forEach = (function() {
	    var vec = vec2.create();
	
	    return function(a, stride, offset, count, fn, arg) {
	        var i, l;
	        if(!stride) {
	            stride = 2;
	        }
	
	        if(!offset) {
	            offset = 0;
	        }
	        
	        if(count) {
	            l = Math.min((count * stride) + offset, a.length);
	        } else {
	            l = a.length;
	        }
	
	        for(i = offset; i < l; i += stride) {
	            vec[0] = a[i]; vec[1] = a[i+1];
	            fn(vec, vec, arg);
	            a[i] = vec[0]; a[i+1] = vec[1];
	        }
	        
	        return a;
	    };
	})();
	
	/**
	 * Returns a string representation of a vector
	 *
	 * @param {vec2} vec vector to represent as a string
	 * @returns {String} string representation of the vector
	 */
	vec2.str = function (a) {
	    return 'vec2(' + a[0] + ', ' + a[1] + ')';
	};
	
	/**
	 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
	 *
	 * @param {vec2} a The first vector.
	 * @param {vec2} b The second vector.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	vec2.exactEquals = function (a, b) {
	    return a[0] === b[0] && a[1] === b[1];
	};
	
	/**
	 * Returns whether or not the vectors have approximately the same elements in the same position.
	 *
	 * @param {vec2} a The first vector.
	 * @param {vec2} b The second vector.
	 * @returns {Boolean} True if the vectors are equal, false otherwise.
	 */
	vec2.equals = function (a, b) {
	    var a0 = a[0], a1 = a[1];
	    var b0 = b[0], b1 = b[1];
	    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
	            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)));
	};
	
	module.exports = vec2;


/***/ },
/* 881 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 882 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 883 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 884 */
/***/ function(module, exports) {

	module.exports = {
		"name": "deck.gl",
		"description": "A suite of 3D-enabled data visualization overlays, suitable for react-map-gl",
		"license": "MIT",
		"version": "4.0.0",
		"keywords": [
			"webgl",
			"visualization",
			"overlay",
			"layer"
		],
		"repository": {
			"type": "git",
			"url": "https://github.com/uber/deck.gl.git"
		},
		"main": "dist/index.js",
		"module": "dist-es6/index.js",
		"files": [
			"dist",
			"dist-es6",
			"src"
		],
		"scripts": {
			"start": "(cd examples/layer-browser && (path-exists node_modules || npm i) && npm run start-local)",
			"build-clean": "rm -fr dist dist-es6 && mkdir -p dist dist-es6",
			"build-es6": "rm -fr dist-es6 && babel src --out-dir dist-es6 --plugins=static-fs --source-maps inline",
			"build-es5": "rm -fr dist && babel src --out-dir dist --plugins=static-fs,transform-es2015-modules-commonjs --source-maps inline",
			"build-buble": "buble dist-es6 -o dist --no modules --y dangerousForOf --objectAssign",
			"build": "npm run build-clean && npm run build-es6 && npm run build-es5 && webpack -d --display-modules",
			"lint": "eslint src test examples && npm run lint-yarn",
			"lint-yarn": "!(find . -name yarn.lock -exec grep -l unpm.u {} \\; | egrep '.*')",
			"publish-prod": "npm run build && npm run test && npm run test-dist && npm publish",
			"publish-beta": "npm run build && npm run test && npm run test-dist && npm publish --tag beta",
			"test": "npm run lint && npm run test-node",
			"test-node": "node test/node.js",
			"test-dist": "node test/node-dist.js",
			"test-browser": "webpack-dev-server --config webpack.config.test-browser.js --progress --hot --open --port 3010",
			"bench": "node test/bench/node.js",
			"bench-browser": "webpack-dev-server --config webpack.config.bench-browser.js --progress --hot --open --port 3011",
			"test-fp64": "(cd test/fp64-test && webpack-dev-server --config webpack.config.test-fp64.js --progress --hot --open)",
			"test-rendering": "(cd test/rendering-test && webpack-dev-server --config webpack.config.test-rendering.js --progress --hot --open)"
		},
		"dependencies": {
			"d3-hexbin": "^0.2.1",
			"earcut": "^2.0.6",
			"gl-matrix": "^2.3.2",
			"lodash.flattendeep": "^4.4.0"
		},
		"devDependencies": {
			"babel-cli": "^6.22.2",
			"babel-core": "^6.22.1",
			"babel-loader": "^6.2.10",
			"babel-plugin-static-fs": "^1.1.0",
			"babel-plugin-transform-es2015-modules-commonjs": "^6.22.0",
			"babel-polyfill": "^6.20.0",
			"babel-preset-es2015": "^6.4.3",
			"benchmark": "^2.1.3",
			"brfs-babel": "^1.0.0",
			"buble": "^0.15.1",
			"buble-loader": "^0.4.0",
			"colorbrewer": "^1.0.0",
			"eslint": "^3.0.0",
			"eslint-config-uber-es2015": "^3.0.0",
			"eslint-config-uber-jsx": "^3.0.0",
			"eslint-plugin-react": "~6.7.0",
			"faucet": "0.0.1",
			"file-loader": "^0.10.1",
			"gl": "^4.0.3",
			"immutable": "^3.8.1",
			"luma.gl": "^3.0.0",
			"module-alias": "^2.0.0",
			"path-exists-cli": "^1.0.0",
			"pre-commit": "^1.2.2",
			"raw-loader": "^0.5.1",
			"react": "^15.4.0",
			"react-addons-test-utils": "^15.4.2",
			"react-dom": "^15.4.0",
			"reify": "^0.4.4",
			"tap-browser-color": "^0.1.2",
			"tape": "^4.5.1",
			"tape-catch": "^1.0.4",
			"transform-loader": "^0.2.3",
			"uglify-js": "^2.6.1",
			"url-loader": "^0.5.7",
			"webpack": "^2.2.0",
			"webpack-dev-server": "^2.2.0"
		},
		"peerDependencies": {
			"luma.gl": "^3.0.0",
			"react": "0.14.x - 15.x",
			"react-dom": "0.14.x - 15.x"
		},
		"babel": {
			"presets": [
				[
					"es2015",
					{
						"modules": false
					}
				]
			]
		}
	};

/***/ },
/* 885 */
/***/ function(module, exports) {

	module.exports = {
		"name": "luma.gl",
		"version": "3.0.2",
		"description": "A WebGL JavaScript visualization library.",
		"license": "MIT",
		"contributors": [
			"Ib Green <ib@uber.com>",
			"Nicolas Belmonte <nico@uber.com>",
			"Rye Terrell <ryeterrell@ryeterrell.net",
			"Shan He <shan@uber.com>",
			"Mikola Lysenko <mikolalysenko@gmail.com",
			"Wesam Manassra <manassra@uber.com>"
		],
		"repository": {
			"type": "git",
			"url": "https://github.com/uber/luma.gl"
		},
		"keywords": [
			"webgl",
			"visualization",
			"animation",
			"3d"
		],
		"main": "dist/index.js",
		"module": "dist-es6/index.js",
		"files": [
			"src",
			"dist",
			"dist-es6",
			"headless.js"
		],
		"scripts": {
			"start-webpack": "(cd examples/main && yarn && npm run start-local)",
			"start": "npm run build-watch && budo dist/bundle.js:dist/lumagl.js --live --open --port 3000 --watch-glob '**/*.{html,css,js,glsl}' ",
			"build-watch": "babel src -d dist --source-maps inline --copy-files --watch & babel examples -d dist --source-maps inline --copy-files --watch &",
			"build-clean": "rm -fr dist dist-es6 && mkdir -p dist dist-es6 ",
			"build-es6": "rm -fr dist-es6 && babel src --out-dir dist-es6 --plugins=static-fs --source-maps inline",
			"build-es5": "rm -fr dist && babel src --out-dir dist --plugins=static-fs,transform-es2015-modules-commonjs --source-maps inline",
			"build-buble": "rm -fr dist-buble && mkdir -p dist-buble && buble src -o dist-buble --no modules --y dangerousForOf --objectAssign",
			"build": "npm run build-es6 && npm run build-es5",
			"build-shaders": "find . -name '*.glsl' -type f -exec bash -c 'echo \"export default `\\\" \"$1\" \"`;\"' -- {} \\;",
			"build-shaders2": "find . -name '*.glsl' -type f -exec bash -c 'echo \"export default `\\\" ; cat \"$1\" ; echo \"`;\" \"${1/glsl/glsl.js}\"' -- {} \\;",
			"build-shader": "echo 'export default `\\' ; cat \"$1\" ; echo '`;'",
			"lint": "eslint src test",
			"publish-prod": "npm run build && npm run test-fast && npm publish",
			"publish-beta": "npm run build && npm run test-fast && npm publish --tag beta",
			"test": "npm run lint && npm run test-node",
			"test-fast": "npm run lint && node test/node.js | faucet",
			"test-node": "node test/node.js",
			"test-browser": "webpack-dev-server --config webpack.config.test-browser.js --progress --hot --open",
			"test-shader": "npm run build-dist && budo src/test/fp64-shader.spec.js:build/test-bundle.js --dir test --live --open --port 3001 --watch-glob '**/*.{html,css,scss,js,glsl}' -- -t babelify -t brfs-babel",
			"docs": "npm run docs-build && open ./_docs/docs/index.html",
			"docs-build": "rm -fr _docs/* && jekyll build --config=docs/_config.yml --layouts docs/_layouts",
			"docs-gh-pages": "git subtree push --prefix _docs origin gh-pages",
			"docs-gh-pages-force": "git push origin `git subtree split --prefix _docs dev`:gh-pages --force",
			"docs-publish": "npm run docs-build && git add _docs -f && git commit -m 'UPDATE DOCS' --no-verify && npm run docs-gh-pages"
		},
		"dependencies": {
			"gl-constants": "^1.0.0",
			"gl-matrix": "^2.3.2",
			"webgl-debug": "^1.0.2"
		},
		"devDependencies": {
			"babel-cli": "^6.18",
			"babel-core": "^6.18",
			"babel-eslint": "^6.0.0",
			"babel-plugin-static-fs": "^1.1.0",
			"babel-plugin-transform-builtin-extend": "^1.1.0",
			"babel-plugin-transform-decorators-legacy": "^1.3.4",
			"babel-preset-es2015": "^6.18",
			"babel-preset-stage-2": "^6.18",
			"babelify": "^7.2.0",
			"blue-tape": "^0.2.0",
			"brfs-babel": "^1.0.0",
			"browserify": "^13.0.0",
			"buble": "^0.15.1",
			"buble-loader": "^0.4.0",
			"budo": "^8.0.3",
			"disc": "^1.3.2",
			"electron-prebuilt": "^0.37.2",
			"eslint": "^3.0",
			"eslint-config-uber-es2015": "^3.0.0",
			"eslint-config-uber-jsx": "^3.0.0",
			"eslint-plugin-babel": "^4.0.0",
			"eslint-plugin-react": "~6.7.0",
			"faucet": "0.0.1",
			"gl": "^4.0.2",
			"jsdom": "^9.9.1",
			"luma.gl": "3.0.0-alpha.3",
			"mkdirp": "^0.5.1",
			"module-alias": "^2.0.0",
			"pre-commit": "^1.2.2",
			"raw-loader": "^0.5.1",
			"react": "^15.4.0",
			"react-addons-test-utils": "^15.4.2",
			"react-dom": "^15.4.0",
			"reify": "^0.4.4",
			"sinon": "^1.17.7",
			"source-map-support": "^0.4.2",
			"tap-browser-color": "^0.1.2",
			"tape": "^4.6.3",
			"tape-catch": "^1.0.4",
			"tape-promise": "^1.1.0",
			"testron": "^1.2.0",
			"transform-loader": "^0.2.3",
			"uglify-js": "^2.6.1",
			"webpack": "^2.2.0-rc.3",
			"webpack-dev-server": "^2.2.0-rc.0"
		}
	};

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(102),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(965),
	    hashDelete = __webpack_require__(966),
	    hashGet = __webpack_require__(967),
	    hashHas = __webpack_require__(968),
	    hashSet = __webpack_require__(969);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(102),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 889 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 890 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 891 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(150);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(83),
	    keys = __webpack_require__(76);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(83),
	    keysIn = __webpack_require__(128);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(187),
	    arrayIncludes = __webpack_require__(189),
	    arrayIncludesWith = __webpack_require__(268),
	    arrayMap = __webpack_require__(92),
	    baseUnary = __webpack_require__(151),
	    cacheHas = __webpack_require__(196);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(150);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 897 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(187),
	    arrayIncludes = __webpack_require__(189),
	    arrayIncludesWith = __webpack_require__(268),
	    arrayMap = __webpack_require__(92),
	    baseUnary = __webpack_require__(151),
	    cacheHas = __webpack_require__(196);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(194);
	
	/**
	 * The base implementation of `_.invert` and `_.invertBy` which inverts
	 * `object` with values transformed by `iteratee` and set by `setter`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform values.
	 * @param {Object} accumulator The initial inverted object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseInverter(object, setter, iteratee, accumulator) {
	  baseForOwn(object, function(value, key, object) {
	    setter(accumulator, iteratee(value), key, object);
	  });
	  return accumulator;
	}
	
	module.exports = baseInverter;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(82),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(82),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var dateTag = '[object Date]';
	
	/**
	 * The base implementation of `_.isDate` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	 */
	function baseIsDate(value) {
	  return isObjectLike(value) && baseGetTag(value) == dateTag;
	}
	
	module.exports = baseIsDate;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(188),
	    equalArrays = __webpack_require__(434),
	    equalByTag = __webpack_require__(958),
	    equalObjects = __webpack_require__(959),
	    getTag = __webpack_require__(201),
	    isArray = __webpack_require__(16),
	    isBuffer = __webpack_require__(157),
	    isTypedArray = __webpack_require__(207);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(188),
	    baseIsEqual = __webpack_require__(272);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 904 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(6),
	    isMasked = __webpack_require__(975),
	    isObject = __webpack_require__(44),
	    toSource = __webpack_require__(451);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(82),
	    isLength = __webpack_require__(285),
	    isObjectLike = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(44),
	    isPrototype = __webpack_require__(154),
	    nativeKeysIn = __webpack_require__(989);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(150),
	    isArrayLike = __webpack_require__(75);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(903),
	    getMatchData = __webpack_require__(960),
	    matchesStrictComparable = __webpack_require__(443);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(272),
	    get = __webpack_require__(126),
	    hasIn = __webpack_require__(455),
	    isKey = __webpack_require__(280),
	    isStrictComparable = __webpack_require__(442),
	    matchesStrictComparable = __webpack_require__(443),
	    toKey = __webpack_require__(124);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(415),
	    cloneBuffer = __webpack_require__(426),
	    cloneTypedArray = __webpack_require__(427),
	    copyArray = __webpack_require__(197),
	    initCloneObject = __webpack_require__(440),
	    isArguments = __webpack_require__(156),
	    isArray = __webpack_require__(16),
	    isArrayLikeObject = __webpack_require__(284),
	    isBuffer = __webpack_require__(157),
	    isFunction = __webpack_require__(6),
	    isObject = __webpack_require__(44),
	    isPlainObject = __webpack_require__(103),
	    isTypedArray = __webpack_require__(207),
	    toPlainObject = __webpack_require__(1030);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(92),
	    baseIteratee = __webpack_require__(68),
	    baseMap = __webpack_require__(908),
	    baseSortBy = __webpack_require__(922),
	    baseUnary = __webpack_require__(151),
	    compareMultiple = __webpack_require__(938),
	    identity = __webpack_require__(69);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(914),
	    hasIn = __webpack_require__(455);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(195),
	    baseSet = __webpack_require__(424),
	    castPath = __webpack_require__(123);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 915 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(195);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 917 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 918 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(452),
	    defineProperty = __webpack_require__(433),
	    identity = __webpack_require__(69);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 920 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(150);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 922 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 923 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 924 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(92);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(122),
	    arrayMap = __webpack_require__(92),
	    isArray = __webpack_require__(16),
	    isSymbol = __webpack_require__(127);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(187),
	    arrayIncludes = __webpack_require__(189),
	    arrayIncludesWith = __webpack_require__(268),
	    cacheHas = __webpack_require__(196),
	    createSet = __webpack_require__(953),
	    setToArray = __webpack_require__(204);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(123),
	    last = __webpack_require__(287),
	    parent = __webpack_require__(991),
	    toKey = __webpack_require__(124);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(92);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(284);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(69);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(275);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(889),
	    arrayReduce = __webpack_require__(270),
	    mapToArray = __webpack_require__(281);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 934 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(890),
	    arrayReduce = __webpack_require__(270),
	    setToArray = __webpack_require__(204);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(122);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(127);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(937);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(83),
	    getSymbols = __webpack_require__(279);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(83),
	    getSymbolsIn = __webpack_require__(439);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(48);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 942 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(891),
	    baseAggregator = __webpack_require__(892),
	    baseIteratee = __webpack_require__(68),
	    isArray = __webpack_require__(16);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(75);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 945 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(198),
	    root = __webpack_require__(48);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(148),
	    createCtor = __webpack_require__(198),
	    createHybrid = __webpack_require__(430),
	    createRecurry = __webpack_require__(431),
	    getHolder = __webpack_require__(199),
	    replaceHolders = __webpack_require__(155),
	    root = __webpack_require__(48);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(68),
	    isArrayLike = __webpack_require__(75),
	    keys = __webpack_require__(76);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(265),
	    flatRest = __webpack_require__(276),
	    getData = __webpack_require__(277),
	    getFuncName = __webpack_require__(438),
	    isArray = __webpack_require__(16),
	    isLaziable = __webpack_require__(441);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 && isArray(value)) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	var baseInverter = __webpack_require__(899);
	
	/**
	 * Creates a function like `_.invertBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} toIteratee The function to resolve iteratees.
	 * @returns {Function} Returns the new inverter function.
	 */
	function createInverter(setter, toIteratee) {
	  return function(object, iteratee) {
	    return baseInverter(object, setter, toIteratee(iteratee), {});
	  };
	}
	
	module.exports = createInverter;


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(148),
	    createCtor = __webpack_require__(198),
	    root = __webpack_require__(48);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(917),
	    isIterateeCall = __webpack_require__(202),
	    toFinite = __webpack_require__(460);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(408),
	    noop = __webpack_require__(458),
	    setToArray = __webpack_require__(204);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(925),
	    getTag = __webpack_require__(201),
	    mapToArray = __webpack_require__(281),
	    setToPairs = __webpack_require__(996);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = getTag(object);
	    if (tag == mapTag) {
	      return mapToArray(object);
	    }
	    if (tag == setTag) {
	      return setToPairs(object);
	    }
	    return baseToPairs(object, keysFunc(object));
	  };
	}
	
	module.exports = createToPairs;


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(125);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	 * of source objects to the destination object for all destination properties
	 * that resolve to `undefined`.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsAssignIn(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsAssignIn;


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(274),
	    isObject = __webpack_require__(44);
	
	/**
	 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	 * objects into destination objects that are passed thru.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to merge.
	 * @param {Object} object The parent object of `objValue`.
	 * @param {Object} source The parent object of `srcValue`.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	  if (isObject(objValue) && isObject(srcValue)) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, objValue);
	    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	    stack['delete'](srcValue);
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsMerge;


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(103);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(122),
	    Uint8Array = __webpack_require__(409),
	    eq = __webpack_require__(125),
	    equalArrays = __webpack_require__(434),
	    mapToArray = __webpack_require__(281),
	    setToArray = __webpack_require__(204);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(436);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(442),
	    keys = __webpack_require__(76);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(122);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 962 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 963 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(123),
	    isArguments = __webpack_require__(156),
	    isArray = __webpack_require__(16),
	    isIndex = __webpack_require__(153),
	    isLength = __webpack_require__(285),
	    toKey = __webpack_require__(124);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(203);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 966 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(203);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(203);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(203);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 970 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(275),
	    cloneDataView = __webpack_require__(932),
	    cloneMap = __webpack_require__(933),
	    cloneRegExp = __webpack_require__(934),
	    cloneSet = __webpack_require__(935),
	    cloneSymbol = __webpack_require__(936),
	    cloneTypedArray = __webpack_require__(427);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 972 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(122),
	    isArguments = __webpack_require__(156),
	    isArray = __webpack_require__(16);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 974 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(941);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 976 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(191);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(191);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(191);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(191);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(887),
	    ListCache = __webpack_require__(186),
	    Map = __webpack_require__(266);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(200);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(200);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(200);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(200);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(288);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(428),
	    composeArgsRight = __webpack_require__(429),
	    replaceHolders = __webpack_require__(155);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(446);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 989 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 990 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(195),
	    baseSlice = __webpack_require__(920);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 992 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(197),
	    isIndex = __webpack_require__(153);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 994 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 995 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 996 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}
	
	module.exports = setToPairs;


/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(186);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 998 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 999 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1000 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(186),
	    Map = __webpack_require__(266),
	    MapCache = __webpack_require__(267);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1002 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(986);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(411),
	    arrayIncludes = __webpack_require__(189);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(264),
	    LodashWrapper = __webpack_require__(265),
	    copyArray = __webpack_require__(197);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(83),
	    createAssigner = __webpack_require__(152),
	    keysIn = __webpack_require__(128);
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	module.exports = assignIn;


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(83),
	    createAssigner = __webpack_require__(152),
	    keysIn = __webpack_require__(128);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(148),
	    baseRest = __webpack_require__(93),
	    customDefaultsMerge = __webpack_require__(956),
	    mergeWith = __webpack_require__(1022);
	
	/**
	 * This method is like `_.defaults` except that it recursively assigns
	 * default properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaults
	 * @example
	 *
	 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	 * // => { 'a': { 'b': 2, 'c': 3 } }
	 */
	var defaultsDeep = baseRest(function(args) {
	  args.push(undefined, customDefaultsMerge);
	  return apply(mergeWith, undefined, args);
	});
	
	module.exports = defaultsDeep;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1006);


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(412),
	    baseFilter = __webpack_require__(896),
	    baseIteratee = __webpack_require__(68),
	    isArray = __webpack_require__(16);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(948),
	    findIndex = __webpack_require__(1012);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(417),
	    baseIteratee = __webpack_require__(68),
	    toInteger = __webpack_require__(210);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(271),
	    toInteger = __webpack_require__(210);
	
	/**
	 * Recursively flatten `array` up to `depth` times.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.4.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @param {number} [depth=1] The maximum recursion depth.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * var array = [1, [2, [3, [4]], 5]];
	 *
	 * _.flattenDepth(array, 1);
	 * // => [1, 2, [3, [4]], 5]
	 *
	 * _.flattenDepth(array, 2);
	 * // => [1, 2, 3, [4], 5]
	 */
	function flattenDepth(array, depth) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  depth = depth === undefined ? 1 : toInteger(depth);
	  return baseFlatten(array, depth);
	}
	
	module.exports = flattenDepth;


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(949);
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(194),
	    castFunction = __webpack_require__(931);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },
/* 1016 */
/***/ function(module, exports) {

	/**
	 * The inverse of `_.toPairs`; this method returns an object composed
	 * from key-value `pairs`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} pairs The key-value pairs.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.fromPairs([['a', 1], ['b', 2]]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function fromPairs(pairs) {
	  var index = -1,
	      length = pairs == null ? 0 : pairs.length,
	      result = {};
	
	  while (++index < length) {
	    var pair = pairs[index];
	    result[pair[0]] = pair[1];
	  }
	  return result;
	}
	
	module.exports = fromPairs;


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(92),
	    baseIntersection = __webpack_require__(898),
	    baseRest = __webpack_require__(93),
	    castArrayLikeObject = __webpack_require__(930);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(452),
	    createInverter = __webpack_require__(950),
	    identity = __webpack_require__(69);
	
	/**
	 * Creates an object composed of the inverted keys and values of `object`.
	 * If `object` contains duplicate values, subsequent values overwrite
	 * property assignments of previous values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invert(object);
	 * // => { '1': 'c', '2': 'b' }
	 */
	var invert = createInverter(function(result, value, key) {
	  result[value] = key;
	}, constant(identity));
	
	module.exports = invert;


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsDate = __webpack_require__(901),
	    baseUnary = __webpack_require__(151),
	    nodeUtil = __webpack_require__(445);
	
	/* Node.js helper references. */
	var nodeIsDate = nodeUtil && nodeUtil.isDate;
	
	/**
	 * Checks if `value` is classified as a `Date` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	 * @example
	 *
	 * _.isDate(new Date);
	 * // => true
	 *
	 * _.isDate('Mon April 23 2012');
	 * // => false
	 */
	var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	module.exports = isDate;


/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(457);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(149),
	    baseForOwn = __webpack_require__(194),
	    baseIteratee = __webpack_require__(68);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(274),
	    createAssigner = __webpack_require__(152);
	
	/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined`, merging is handled by the
	 * method instead. The `customizer` is invoked with six arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = { 'a': [1], 'b': [2] };
	 * var other = { 'a': [3], 'b': [4] };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'a': [1, 3], 'b': [2, 4] }
	 */
	var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	  baseMerge(object, source, srcIndex, customizer);
	});
	
	module.exports = mergeWith;


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(193),
	    baseIteratee = __webpack_require__(68),
	    baseLt = __webpack_require__(423);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(48);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(270),
	    baseEach = __webpack_require__(150),
	    baseIteratee = __webpack_require__(68),
	    baseReduce = __webpack_require__(918),
	    isArray = __webpack_require__(16);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(424);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(414),
	    baseIteratee = __webpack_require__(68),
	    baseSome = __webpack_require__(921),
	    isArray = __webpack_require__(16),
	    isIterateeCall = __webpack_require__(202);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 1028 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(954),
	    keys = __webpack_require__(76);
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = createToPairs(keys);
	
	module.exports = toPairs;


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(83),
	    keysIn = __webpack_require__(128);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(462);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(264),
	    LodashWrapper = __webpack_require__(265),
	    baseLodash = __webpack_require__(273),
	    isArray = __webpack_require__(16),
	    isObjectLike = __webpack_require__(70),
	    wrapperClone = __webpack_require__(1005);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Timer based animation
	// TODO clean up linting
	/* eslint-disable */
	/* global setTimeout */
	
	
	var _utils = __webpack_require__(30);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Queue = [];
	
	var Fx = function () {
	  function Fx() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Fx);
	
	    this.opt = (0, _utils.merge)({
	      delay: 0,
	      duration: 1000,
	      transition: function transition(x) {
	        return x;
	      },
	      onCompute: _utils.noop,
	      onComplete: _utils.noop
	    }, options);
	  }
	
	  _createClass(Fx, [{
	    key: 'start',
	    value: function start(options) {
	      this.opt = (0, _utils.merge)(this.opt, options || {});
	      this.time = Date.now();
	      this.animating = true;
	      Queue.push(this);
	    }
	
	    // perform a step in the animation
	
	  }, {
	    key: 'step',
	    value: function step() {
	      // if not animating, then return
	      if (!this.animating) {
	        return;
	      }
	      var currentTime = Date.now(),
	          time = this.time,
	          opt = this.opt,
	          delay = opt.delay,
	          duration = opt.duration,
	          delta = 0;
	      // hold animation for the delay
	      if (currentTime < time + delay) {
	        opt.onCompute.call(this, delta);
	        return;
	      }
	      // if in our time window, then execute animation
	      if (currentTime < time + delay + duration) {
	        delta = opt.transition((currentTime - time - delay) / duration);
	        opt.onCompute.call(this, delta);
	      } else {
	        this.animating = false;
	        opt.onCompute.call(this, 1);
	        opt.onComplete.call(this);
	      }
	    }
	  }], [{
	    key: 'compute',
	    value: function compute(from, to, delta) {
	      return from + (to - from) * delta;
	    }
	  }]);
	
	  return Fx;
	}();
	
	exports.default = Fx;
	
	
	Fx.Queue = Queue;
	
	// Easing equations
	Fx.Transition = {
	  linear: function linear(p) {
	    return p;
	  }
	};
	
	var Trans = Fx.Transition;
	
	Fx.prototype.time = null;
	
	function makeTrans(transition, params) {
	  params = (0, _utils.splat)(params);
	  return Object.assign(transition, {
	    easeIn: function easeIn(pos) {
	      return transition(pos, params);
	    },
	    easeOut: function easeOut(pos) {
	      return 1 - transition(1 - pos, params);
	    },
	    easeInOut: function easeInOut(pos) {
	      return pos <= 0.5 ? transition(2 * pos, params) / 2 : (2 - transition(2 * (1 - pos), params)) / 2;
	    }
	  });
	}
	
	var transitions = {
	  Pow: function Pow(p, x) {
	    return Math.pow(p, x[0] || 6);
	  },
	  Expo: function Expo(p) {
	    return Math.pow(2, 8 * (p - 1));
	  },
	  Circ: function Circ(p) {
	    return 1 - Math.sin(Math.acos(p));
	  },
	  Sine: function Sine(p) {
	    return 1 - Math.sin((1 - p) * Math.PI / 2);
	  },
	  Back: function Back(p, x) {
	    x = x[0] || 1.618;
	    return Math.pow(p, 2) * ((x + 1) * p - x);
	  },
	  Bounce: function Bounce(p) {
	    var value;
	    for (var a = 0, b = 1; 1; a += b, b /= 2) {
	      if (p >= (7 - 4 * a) / 11) {
	        value = b * b - Math.pow((11 - 6 * a - 11 * p) / 4, 2);
	        break;
	      }
	    }
	    return value;
	  },
	  Elastic: function Elastic(p, x) {
	    return Math.pow(2, 10 * --p) * Math.cos(20 * p * Math.PI * (x[0] || 1) / 3);
	  }
	};
	
	for (var t in transitions) {
	  Trans[t] = makeTrans(transitions[t]);
	}
	
	['Quad', 'Cubic', 'Quart', 'Quint'].forEach(function (elem, i) {
	  Trans[elem] = makeTrans(function (p) {
	    return Math.pow(p, [i + 2]);
	  });
	});
	
	// animationTime - function branching
	
	// rye: TODO- refactor global definition when we define the two
	//           (browserify/<script>) build paths.
	var global;
	try {
	  global = window;
	} catch (e) {
	  global = null;
	}
	
	var checkFxQueue = function checkFxQueue() {
	  var oldQueue = Queue;
	  Queue = [];
	  if (oldQueue.length) {
	    for (var i = 0, l = oldQueue.length, fx; i < l; i++) {
	      fx = oldQueue[i];
	      fx.step();
	      if (fx.animating) {
	        Queue.push(fx);
	      }
	    }
	    Fx.Queue = Queue;
	  }
	};
	
	if (global) {
	  var found = false;
	  ['webkitAnimationTime', 'mozAnimationTime', 'animationTime', 'webkitAnimationStartTime', 'mozAnimationStartTime', 'animationStartTime'].forEach(function (impl) {
	    if (impl in global) {
	      Fx.animationTime = function () {
	        return global[impl];
	      };
	      found = true;
	    }
	  });
	  if (!found) {
	    Fx.animationTime = Date.now;
	  }
	  // requestAnimationFrame - function branching
	  found = false;
	  ['webkitRequestAnimationFrame', 'mozRequestAnimationFrame', 'requestAnimationFrame'].forEach(function (impl) {
	    if (impl in global) {
	      Fx.requestAnimationFrame = function (callback) {
	        global[impl](function () {
	          checkFxQueue();
	          callback();
	        });
	      };
	      found = true;
	    }
	  });
	  if (!found) {
	    Fx.requestAnimationFrame = function (callback) {
	      setTimeout(function () {
	        checkFxQueue();
	        callback();
	      }, 1000 / 60);
	    };
	  }
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrthoCamera = exports.PerspectiveCamera = exports.Camera = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // camera.js
	// Provides a Camera with ModelView and Projection matrices
	
	var _deprecated = __webpack_require__(1036);
	
	var _utils = __webpack_require__(30);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Camera = exports.Camera = function () {
	  function Camera() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Camera);
	
	    opts = (0, _utils.merge)({
	      fov: 45,
	      near: 0.1,
	      far: 500,
	      aspect: 1,
	      position: new _deprecated.Vec3(0, 0, 0),
	      target: new _deprecated.Vec3(0, 0, -1),
	      up: new _deprecated.Vec3(0, 1, 0)
	    }, opts);
	
	    this.fov = opts.fov;
	    this.near = opts.near;
	    this.far = opts.far;
	    this.aspect = opts.aspect;
	    this.position = opts.position;
	    this.target = opts.target;
	    this.up = opts.up;
	    this.view = new _deprecated.Mat4();
	    this.uniforms = {};
	    this.projection = new _deprecated.Mat4();
	    Object.seal(this);
	
	    this.update();
	  }
	
	  _createClass(Camera, [{
	    key: 'project',
	    value: function project() {
	      return null;
	    }
	  }, {
	    key: 'unproject',
	    value: function unproject() {
	      return null;
	    }
	  }, {
	    key: 'getUniforms',
	    value: function getUniforms() {
	      return this.uniforms;
	    }
	  }, {
	    key: '_updateUniforms',
	    value: function _updateUniforms() {
	      var viewProjection = this.view.mulMat4(this.projection);
	      var viewProjectionInverse = viewProjection.invert();
	      this.uniforms = {
	        cameraPosition: this.position,
	        projectionMatrix: this.projection,
	        viewMatrix: this.view,
	        viewProjectionMatrix: viewProjection,
	        viewInverseMatrix: this.view.invert(),
	        viewProjectionInverseMatrix: viewProjectionInverse
	      };
	    }
	  }]);
	
	  return Camera;
	}();
	
	var PerspectiveCamera = exports.PerspectiveCamera = function (_Camera) {
	  _inherits(PerspectiveCamera, _Camera);
	
	  function PerspectiveCamera() {
	    _classCallCheck(this, PerspectiveCamera);
	
	    return _possibleConstructorReturn(this, (PerspectiveCamera.__proto__ || Object.getPrototypeOf(PerspectiveCamera)).apply(this, arguments));
	  }
	
	  _createClass(PerspectiveCamera, [{
	    key: 'update',
	    value: function update() {
	      this.projection = new _deprecated.Mat4().perspective(this.fov, this.aspect, this.near, this.far);
	      this.view.lookAt(this.position, this.target, this.up);
	      this._updateUniforms();
	    }
	  }]);
	
	  return PerspectiveCamera;
	}(Camera);
	
	var OrthoCamera = exports.OrthoCamera = function () {
	  function OrthoCamera() {
	    _classCallCheck(this, OrthoCamera);
	  }
	
	  _createClass(OrthoCamera, [{
	    key: 'update',
	    value: function update() {
	      var ymax = this.near * Math.tan(this.fov * Math.PI / 360);
	      var ymin = -ymax;
	      var xmin = ymin * this.aspect;
	      var xmax = ymax * this.aspect;
	      this.projection = new _deprecated.Mat4().ortho(xmin, xmax, ymin, ymax, this.near, this.far);
	      this.view.lookAt(this.position, this.target, this.up);
	      this._updateUniforms();
	    }
	  }]);
	
	  return OrthoCamera;
	}();
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1035 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAX_TEXTURES = exports.MAX_TEXTURES = 10;
	var MAX_POINT_LIGHTS = exports.MAX_POINT_LIGHTS = 4;
	var PICKING_RES = exports.PICKING_RES = 4;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb3JlL2NvbmZpZy5qcyJdLCJuYW1lcyI6WyJNQVhfVEVYVFVSRVMiLCJNQVhfUE9JTlRfTElHSFRTIiwiUElDS0lOR19SRVMiXSwibWFwcGluZ3MiOiI7Ozs7O0FBQU8sSUFBTUEsc0NBQWUsRUFBckI7QUFDQSxJQUFNQyw4Q0FBbUIsQ0FBekI7QUFDQSxJQUFNQyxvQ0FBYyxDQUFwQiIsImZpbGUiOiJjb25maWcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgTUFYX1RFWFRVUkVTID0gMTA7XG5leHBvcnQgY29uc3QgTUFYX1BPSU5UX0xJR0hUUyA9IDQ7XG5leHBvcnQgY29uc3QgUElDS0lOR19SRVMgPSA0O1xuIl19

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _math = __webpack_require__(292);
	
	Object.keys(_math).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _math[key];
	    }
	  });
	});
	
	var _fbo = __webpack_require__(465);
	
	Object.defineProperty(exports, 'FramebufferObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fbo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kZXByZWNhdGVkL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOzs7Ozs7O3dDQUNRQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSAnLi9tYXRoJztcbmV4cG9ydCB7ZGVmYXVsdCBhcyBGcmFtZWJ1ZmZlck9iamVjdH0gZnJvbSAnLi9mYm8nO1xuIl19

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _object3d = __webpack_require__(294);
	
	Object.defineProperty(exports, 'Object3D', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_object3d).default;
	  }
	});
	
	var _group = __webpack_require__(293);
	
	Object.defineProperty(exports, 'Group', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_group).default;
	  }
	});
	
	var _scene = __webpack_require__(1038);
	
	Object.defineProperty(exports, 'Scene', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_scene).default;
	  }
	});
	
	var _pick = __webpack_require__(466);
	
	Object.defineProperty(exports, 'pickModels', {
	  enumerable: true,
	  get: function get() {
	    return _pick.pickModels;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9kZXByZWNhdGVkL3NjZW5lZ3JhcGgvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCIsInBpY2tNb2RlbHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OzZDQUFRQSxPOzs7Ozs7Ozs7MENBQ0FBLE87Ozs7Ozs7OzswQ0FDQUEsTzs7Ozs7Ozs7O2lCQUNBQyxVIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHtkZWZhdWx0IGFzIE9iamVjdDNEfSBmcm9tICcuL29iamVjdC0zZCc7XG5leHBvcnQge2RlZmF1bHQgYXMgR3JvdXB9IGZyb20gJy4vZ3JvdXAnO1xuZXhwb3J0IHtkZWZhdWx0IGFzIFNjZW5lfSBmcm9tICcuL3NjZW5lJztcbmV4cG9ydCB7cGlja01vZGVsc30gZnJvbSAnLi9waWNrJztcbiJdfQ==

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(1035);
	
	var config = _interopRequireWildcard(_config);
	
	var _math = __webpack_require__(477);
	
	var _utils = __webpack_require__(30);
	
	var _group = __webpack_require__(293);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _pick = __webpack_require__(466);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Scene Object management and rendering
	/* eslint-disable max-statements, no-try-catch */
	
	var INVALID_ARGUMENT = 'LumaGL.Scene invalid argument';
	
	var DEFAULT_SCENE_OPTS = {
	  lights: {
	    enable: false,
	    // ambient light
	    ambient: { r: 0.2, g: 0.2, b: 0.2 },
	    // directional light
	    directional: {
	      direction: { x: 1, y: 1, z: 1 },
	      color: { r: 0, g: 0, b: 0 }
	    }
	    // point light
	    // points: []
	  },
	  effects: {
	    fog: false
	    // { near, far, color }
	  },
	  clearColor: true,
	  clearDepth: true,
	  backgroundColor: { r: 0, g: 0, b: 0, a: 1 },
	  backgroundDepth: 1
	};
	
	// Scene class
	
	var Scene = function (_Group) {
	  _inherits(Scene, _Group);
	
	  function Scene(gl, opts) {
	    _classCallCheck(this, Scene);
	
	    (0, _assert2.default)(gl, INVALID_ARGUMENT);
	
	    opts = (0, _utils.merge)(DEFAULT_SCENE_OPTS, opts);
	
	    var _this = _possibleConstructorReturn(this, (Scene.__proto__ || Object.getPrototypeOf(Scene)).call(this, opts));
	
	    _this.gl = gl;
	    _this.config = opts;
	    _this.needsRedraw = false;
	    Object.seal(_this);
	    return _this;
	  }
	
	  _createClass(Scene, [{
	    key: 'setNeedsRedraw',
	    value: function setNeedsRedraw() {
	      var redraw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.needsRedraw = redraw;
	      return this;
	    }
	  }, {
	    key: 'getNeedsRedraw',
	    value: function getNeedsRedraw() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$clearRedrawFlags = _ref.clearRedrawFlags,
	          clearRedrawFlags = _ref$clearRedrawFlags === undefined ? false : _ref$clearRedrawFlags;
	
	      var redraw = false;
	      redraw = redraw || this.needsRedraw;
	      this.needsRedraw = this.needsRedraw && !clearRedrawFlags;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var model = _step.value;
	
	          redraw = redraw || model.getNeedsRedraw({ clearRedrawFlags: clearRedrawFlags });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return redraw;
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      var gl = this.gl;
	
	      if (this.config.clearColor) {
	        var bg = this.config.backgroundColor;
	        gl.clearColor(bg.r, bg.g, bg.b, bg.a);
	      }
	      if (this.config.clearDepth) {
	        gl.clearDepth(this.config.backgroundDepth);
	      }
	      if (this.config.clearColor && this.config.clearDepth) {
	        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	      } else if (this.config.clearColor) {
	        gl.clear(gl.COLOR_BUFFER_BIT);
	      } else if (this.config.clearDepth) {
	        gl.clear(gl.DEPTH_BUFFER_BIT);
	      }
	      return this;
	    }
	
	    // Renders all objects in the scene.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var uniforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this.clear();
	      // Go through each model and render it.
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.traverse()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var model = _step2.value;
	
	          if (model.display) {
	            this.renderObject({ model: model, uniforms: uniforms });
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return this;
	    }
	  }, {
	    key: 'renderObject',
	    value: function renderObject(_ref2) {
	      var model = _ref2.model,
	          uniforms = _ref2.uniforms;
	
	      // Setup lighting and scene effects like fog, etc.
	      model.render(Object.assign({}, this.getSceneUniforms(), { uniforms: uniforms }));
	      return this;
	    }
	  }, {
	    key: 'pickModels',
	    value: function pickModels() {
	      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var x = opts.x,
	          y = opts.y,
	          _opts$uniforms = opts.uniforms,
	          uniforms = _opts$uniforms === undefined ? {} : _opts$uniforms;
	
	      return (0, _pick.pickModels)(this.gl, Object.assign({
	        group: this,
	        x: x, y: y,
	        uniforms: uniforms
	      }, opts));
	    }
	
	    // Setup the lighting system: ambient, directional, point lights.
	
	  }, {
	    key: 'getSceneUniforms',
	    value: function getSceneUniforms() {
	      // Setup Lighting
	      var _config$lights = this.config.lights,
	          enable = _config$lights.enable,
	          ambient = _config$lights.ambient,
	          directional = _config$lights.directional,
	          points = _config$lights.points;
	
	      // Set light uniforms. Ambient and directional lights.
	
	      return Object.assign({}, this.getEffectsUniforms(), { enableLights: enable }, enable && ambient ? this.getAmbientUniforms(ambient) : {}, enable && directional ? this.getDirectionalUniforms(directional) : {}, enable && points ? this.getPointUniforms(points) : {});
	    }
	  }, {
	    key: 'getAmbientUniforms',
	    value: function getAmbientUniforms(ambient) {
	      return {
	        ambientColor: [ambient.r, ambient.g, ambient.b]
	      };
	    }
	  }, {
	    key: 'getDirectionalUniforms',
	    value: function getDirectionalUniforms(directional) {
	      var color = directional.color,
	          direction = directional.direction;
	
	      // Normalize lighting direction vector
	
	      var dir = new _math.Vector3(direction.x, direction.y, direction.z).normalize().scale(-1, -1, -1);
	
	      return {
	        directionalColor: [color.r, color.g, color.b],
	        lightingDirection: [dir.x, dir.y, dir.z]
	      };
	    }
	  }, {
	    key: 'getPointUniforms',
	    value: function getPointUniforms(points) {
	      points = points instanceof Array ? points : [points];
	      var numberPoints = points.length;
	      var uniforms = { numberPoints: numberPoints };
	
	      var pointLocations = [];
	      var pointColors = [];
	      var enableSpecular = [];
	      var pointSpecularColors = [];
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = points[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var point = _step3.value;
	          var position = point.position,
	              color = point.color,
	              diffuse = point.diffuse,
	              specular = point.specular;
	
	          var pointColor = color || diffuse;
	
	          pointLocations.push(position.x, position.y, position.z);
	          pointColors.push(pointColor.r, pointColor.g, pointColor.b);
	
	          // Add specular color
	          enableSpecular.push(Number(Boolean(specular)));
	          if (specular) {
	            pointSpecularColors.push(specular.r, specular.g, specular.b);
	          } else {
	            pointSpecularColors.push(0, 0, 0);
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      if (pointLocations.length) {
	        Object.assign(uniforms, {
	          pointLocation: pointLocations,
	          pointColor: pointColors,
	          enableSpecular: enableSpecular,
	          pointSpecularColor: pointSpecularColors
	        });
	      }
	
	      return uniforms;
	    }
	
	    // Setup effects like fog, etc.
	
	  }, {
	    key: 'getEffectsUniforms',
	    value: function getEffectsUniforms() {
	      var fog = this.config.effects.fog;
	
	
	      if (fog) {
	        var _fog$color = fog.color,
	            color = _fog$color === undefined ? { r: 0.5, g: 0.5, b: 0.5 } : _fog$color;
	
	        return {
	          hasFog: true,
	          fogNear: fog.near,
	          fogFar: fog.far,
	          fogColor: [color.r, color.g, color.b]
	        };
	      }
	      return { hasFog: false };
	    }
	  }]);
	
	  return Scene;
	}(_group2.default);
	
	exports.default = Scene;
	
	
	Scene.MAX_TEXTURES = config.MAX_TEXTURES;
	Scene.MAX_POINT_LIGHTS = config.MAX_POINT_LIGHTS;
	Scene.PICKING_RES = config.PICKING_RES;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1039 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  hasTexture1: false,
	  hasTextureCube1: false,
	
	  enableLights: false,
	  useReflection: false,
	
	  // picking configs
	  enablePicking: false,
	  hasPickingColors: false,
	
	  // fog configuration
	  hasFog: false
	};
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9kZXByZWNhdGVkL3NoYWRlcmxpYi9kZWZhdWx0LXVuaWZvcm1zLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJoYXNUZXh0dXJlMSIsImhhc1RleHR1cmVDdWJlMSIsImVuYWJsZUxpZ2h0cyIsInVzZVJlZmxlY3Rpb24iLCJlbmFibGVQaWNraW5nIiwiaGFzUGlja2luZ0NvbG9ycyIsImhhc0ZvZyJdLCJtYXBwaW5ncyI6Ijs7QUFBQUEsT0FBT0MsT0FBUCxHQUFpQjtBQUNmQyxlQUFhLEtBREU7QUFFZkMsbUJBQWlCLEtBRkY7O0FBSWZDLGdCQUFjLEtBSkM7QUFLZkMsaUJBQWUsS0FMQTs7QUFPZjtBQUNBQyxpQkFBZSxLQVJBO0FBU2ZDLG9CQUFrQixLQVRIOztBQVdmO0FBQ0FDLFVBQVE7QUFaTyxDQUFqQiIsImZpbGUiOiJkZWZhdWx0LXVuaWZvcm1zLmpzIiwic291cmNlc0NvbnRlbnQiOlsibW9kdWxlLmV4cG9ydHMgPSB7XG4gIGhhc1RleHR1cmUxOiBmYWxzZSxcbiAgaGFzVGV4dHVyZUN1YmUxOiBmYWxzZSxcblxuICBlbmFibGVMaWdodHM6IGZhbHNlLFxuICB1c2VSZWZsZWN0aW9uOiBmYWxzZSxcblxuICAvLyBwaWNraW5nIGNvbmZpZ3NcbiAgZW5hYmxlUGlja2luZzogZmFsc2UsXG4gIGhhc1BpY2tpbmdDb2xvcnM6IGZhbHNlLFxuXG4gIC8vIGZvZyBjb25maWd1cmF0aW9uXG4gIGhhc0ZvZzogZmFsc2Vcbn07XG4iXX0=

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _path = __webpack_require__(132);
	
	// Default Shaders
	var vs = '#define SHADER_NAME luma-default-vertex\n\n#define LIGHT_MAX 4\n\n// object attributes\nattribute vec3 positions;\nattribute vec3 normals;\nattribute vec4 colors;\nattribute vec4 pickingColors;\nattribute vec2 texCoords;\n\n// camera and object matrices\nuniform mat4 viewMatrix;\nuniform mat4 viewInverseMatrix;\nuniform mat4 projectionMatrix;\nuniform mat4 viewProjectionMatrix;\n\n// objectMatrix * viewMatrix = worldMatrix\nuniform mat4 worldMatrix;\nuniform mat4 worldInverseMatrix;\nuniform mat4 worldInverseTransposeMatrix;\nuniform mat4 objectMatrix;\nuniform vec3 cameraPosition;\n\n// lighting configuration\nuniform bool enableLights;\nuniform vec3 ambientColor;\nuniform vec3 directionalColor;\nuniform vec3 lightingDirection;\n\n// point lights configuration\nuniform vec3 pointLocation[LIGHT_MAX];\nuniform vec3 pointColor[LIGHT_MAX];\nuniform int numberPoints;\n\n// reflection / refraction configuration\nuniform bool useReflection;\n\n// varyings\nvarying vec3 vReflection;\nvarying vec4 vColor;\nvarying vec4 vPickingColor;\nvarying vec2 vTexCoord;\nvarying vec4 vNormal;\nvarying vec3 lightWeighting;\n\nvoid main(void) {\n  vec4 mvPosition = worldMatrix * vec4(positions, 1.0);\n  vec4 transformedNormal = worldInverseTransposeMatrix * vec4(normals, 1.0);\n\n  // lighting code\n  if(!enableLights) {\n    lightWeighting = vec3(1.0, 1.0, 1.0);\n  } else {\n    vec3 plightDirection;\n    vec3 pointWeight = vec3(0.0, 0.0, 0.0);\n    float directionalLightWeighting =\n      max(dot(transformedNormal.xyz, lightingDirection), 0.0);\n    for (int i = 0; i < LIGHT_MAX; i++) {\n      if (i < numberPoints) {\n        plightDirection = normalize(\n          (viewMatrix * vec4(pointLocation[i], 1.0)).xyz - mvPosition.xyz);\n         pointWeight += max(\n          dot(transformedNormal.xyz, plightDirection), 0.0) * pointColor[i];\n       } else {\n         break;\n       }\n     }\n\n    lightWeighting = ambientColor +\n      (directionalColor * directionalLightWeighting) + pointWeight;\n  }\n\n  // refraction / reflection code\n  if (useReflection) {\n    vReflection =\n      (viewInverseMatrix[3] - (worldMatrix * vec4(positions, 1.0))).xyz;\n  } else {\n    vReflection = vec3(1.0, 1.0, 1.0);\n  }\n\n  // pass results to varyings\n  vColor = colors;\n  vPickingColor = pickingColors;\n  vTexCoord = texCoords;\n  vNormal = transformedNormal;\n  gl_Position = projectionMatrix * worldMatrix * vec4(positions, 1.0);\n}\n';
	var fs = '#define SHADER_NAME luma-default-fragment\n\n#ifdef GL_ES\nprecision highp float;\n#endif\n\n// varyings\nvarying vec4 vColor;\nvarying vec4 vPickingColor;\nvarying vec2 vTexCoord;\nvarying vec3 lightWeighting;\nvarying vec3 vReflection;\nvarying vec4 vNormal;\n\n// texture configs\nuniform bool hasTexture1;\nuniform sampler2D sampler1;\nuniform bool hasTextureCube1;\nuniform samplerCube samplerCube1;\n\n// picking configs\nuniform bool enablePicking;\nuniform bool hasPickingColors;\nuniform vec3 pickColor;\n\n// reflection / refraction configs\nuniform float reflection;\nuniform float refraction;\n\n// fog configuration\nuniform bool hasFog;\nuniform vec3 fogColor;\nuniform float fogNear;\nuniform float fogFar;\n\nvoid main(){\n  // set color from texture\n  if (!hasTexture1) {\n    gl_FragColor = vec4(vColor.rgb * lightWeighting, vColor.a);\n  } else {\n    gl_FragColor =\n      vec4(texture2D(sampler1, vec2(vTexCoord.s, vTexCoord.t)).rgb *\n      lightWeighting, 1.0);\n  }\n\n  // has cube texture then apply reflection\n  // if (hasTextureCube1) {\n  //   vec3 nReflection = normalize(vReflection);\n  //   vec3 reflectionValue;\n  //   if (refraction > 0.0) {\n  //    reflectionValue = refract(nReflection, vNormal.xyz, refraction);\n  //   } else {\n  //    reflectionValue = -reflect(nReflection, vNormal.xyz);\n  //   }\n\n  //   // TODO(nico): check whether this is right.\n  //   vec4 cubeColor = textureCube(samplerCube1,\n  //       vec3(-reflectionValue.x, -reflectionValue.y, reflectionValue.z));\n  //   gl_FragColor = vec4(mix(gl_FragColor.xyz, cubeColor.xyz, reflection), 1.0);\n  // }\n\n  // set picking\n  if (enablePicking) {\n    if (hasPickingColors) {\n      gl_FragColor = vPickingColor;\n    } else {\n      gl_FragColor = vec4(pickColor, 1.0);\n    }\n  }\n\n  // handle fog\n  // if (hasFog) {\n  //   float depth = gl_FragCoord.z / gl_FragCoord.w;\n  //   float fogFactor = smoothstep(fogNear, fogFar, depth);\n  //   gl_FragColor = mix(gl_FragColor, vec4(fogColor, gl_FragColor.w), fogFactor);\n  // }\n}\n';
	var defaultUniforms = __webpack_require__(1039);
	
	module.exports = {
	  default: {
	    vs: vs,
	    fs: fs,
	    defaultUniforms: defaultUniforms
	  }
	};
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9kZXByZWNhdGVkL3NoYWRlcmxpYi9pbmRleC5qcyJdLCJuYW1lcyI6WyJ2cyIsImZzIiwiZGVmYXVsdFVuaWZvcm1zIiwicmVxdWlyZSIsIm1vZHVsZSIsImV4cG9ydHMiLCJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOztBQUNBOztBQUVBO0FBQ0EsSUFBTUEsbzVFQUFOO0FBQ0EsSUFBTUMsMmdFQUFOO0FBQ0EsSUFBTUMsa0JBQWtCQyxRQUFRLG9CQUFSLENBQXhCOztBQUVBQyxPQUFPQyxPQUFQLEdBQWlCO0FBQ2ZDLFdBQVM7QUFDUE4sVUFETztBQUVQQyxVQUZPO0FBR1BDO0FBSE87QUFETSxDQUFqQiIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7cmVhZEZpbGVTeW5jfSBmcm9tICdmcyc7XG5pbXBvcnQge2pvaW59IGZyb20gJ3BhdGgnO1xuXG4vLyBEZWZhdWx0IFNoYWRlcnNcbmNvbnN0IHZzID0gcmVhZEZpbGVTeW5jKGpvaW4oX19kaXJuYW1lLCAnLi9kZWZhdWx0LXZlcnRleC5nbHNsJyksICd1dGY4Jyk7XG5jb25zdCBmcyA9IHJlYWRGaWxlU3luYyhqb2luKF9fZGlybmFtZSwgJy4vZGVmYXVsdC1mcmFnbWVudC5nbHNsJyksICd1dGY4Jyk7XG5jb25zdCBkZWZhdWx0VW5pZm9ybXMgPSByZXF1aXJlKCcuL2RlZmF1bHQtdW5pZm9ybXMnKTtcblxubW9kdWxlLmV4cG9ydHMgPSB7XG4gIGRlZmF1bHQ6IHtcbiAgICB2cyxcbiAgICBmcyxcbiAgICBkZWZhdWx0VW5pZm9ybXNcbiAgfVxufTtcbiJdfQ==

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fragmentShader = exports.vertexShader = exports.name = undefined;
	exports.getUniforms = getUniforms;
	
	var _path = __webpack_require__(132);
	
	var name = exports.name = 'fog';
	var vertexShader = exports.vertexShader = '';
	var fragmentShader = exports.fragmentShader = Buffer('Ly8gZm9nIGNvbmZpZ3VyYXRpb24KdW5pZm9ybSBib29sIGZvZ191RW5hYmxlOwp1bmlmb3JtIHZlYzMgZm9nX3VDb2xvcjsKdW5pZm9ybSBmbG9hdCBmb2dfdU5lYXI7CnVuaWZvcm0gZmxvYXQgZm9nX3VGYXI7CgovKgogKiBBcHBsaWVzIGxpbmVhciBmb2cgdG8gYSBjb2xvcgogKiBwYXJhbSAtIHVuZm9nZ2VkIGNvbG9yCiAqIHJldHVybiAtIGZvZ2dlZCBjb2xvcgogKi8KdmVjNCBmb2dfZmlsdGVyQ29sb3IodmVjNCBjb2xvcikgewogIGlmIChmb2dfdUVuYWJsZSkgewogICAgZmxvYXQgZGVwdGggPSBnbF9GcmFnQ29vcmQueiAvIGdsX0ZyYWdDb29yZC53OwogICAgZmxvYXQgZm9nRmFjdG9yID0gc21vb3Roc3RlcChmb2dfdU5lYXIsIGZvZ191RmFyLCBkZXB0aCk7CiAgICByZXR1cm4gbWl4KGNvbG9yLCB2ZWM0KGZvZ191Q29sb3IsIGdsX0ZyYWdDb2xvci53KSwgZm9nRmFjdG9yKTsKICB9IGVsc2UgewogIAlyZXR1cm4gY29sb3I7CiAgfQp9CgovLyBPdGhlciBmb2cgc2hhZGVycywgZXhwb25lbnRpYWwgZXRjLCBzZWUKLy8gaHR0cDovL2luMmdwdS5jb20vMjAxNC8wNy8yMi9jcmVhdGUtZm9nLXNoYWRlci8K', 'base64');
	
	/* eslint-disable camelcase */
	function getUniforms() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$fogEnable = _ref.fogEnable,
	      fogEnable = _ref$fogEnable === undefined ? false : _ref$fogEnable,
	      _ref$fogColor = _ref.fogColor,
	      fogColor = _ref$fogColor === undefined ? [0.5, 0.5, 0.5] : _ref$fogColor,
	      _ref$fogNear = _ref.fogNear,
	      fogNear = _ref$fogNear === undefined ? 1 : _ref$fogNear,
	      _ref$fogFar = _ref.fogFar,
	      fogFar = _ref$fogFar === undefined ? 100 : _ref$fogFar;
	
	  return {
	    fog_uEnable: fogEnable,
	    fog_uColor: fogColor,
	    fog_uNear: fogNear,
	    fog_uFar: fogFar
	  };
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVyLW1vZHVsZXMvZm9nL2luZGV4LmpzIl0sIm5hbWVzIjpbImdldFVuaWZvcm1zIiwibmFtZSIsInZlcnRleFNoYWRlciIsImZyYWdtZW50U2hhZGVyIiwiZm9nRW5hYmxlIiwiZm9nQ29sb3IiLCJmb2dOZWFyIiwiZm9nRmFyIiwiZm9nX3VFbmFibGUiLCJmb2dfdUNvbG9yIiwiZm9nX3VOZWFyIiwiZm9nX3VGYXIiXSwibWFwcGluZ3MiOiI7Ozs7OztRQVFnQkEsVyxHQUFBQSxXOztBQVBoQjs7QUFFTyxJQUFNQyxzQkFBTyxLQUFiO0FBQ0EsSUFBTUMsc0NBQWUsRUFBckI7QUFDQSxJQUFNQyxrMEJBQU47O0FBRVA7QUFDTyxTQUFTSCxXQUFULEdBS0M7QUFBQSxpRkFBSixFQUFJO0FBQUEsNEJBSk5JLFNBSU07QUFBQSxNQUpOQSxTQUlNLGtDQUpNLEtBSU47QUFBQSwyQkFITkMsUUFHTTtBQUFBLE1BSE5BLFFBR00saUNBSEssQ0FBQyxHQUFELEVBQU0sR0FBTixFQUFXLEdBQVgsQ0FHTDtBQUFBLDBCQUZOQyxPQUVNO0FBQUEsTUFGTkEsT0FFTSxnQ0FGSSxDQUVKO0FBQUEseUJBRE5DLE1BQ007QUFBQSxNQUROQSxNQUNNLCtCQURHLEdBQ0g7O0FBQ04sU0FBTztBQUNMQyxpQkFBYUosU0FEUjtBQUVMSyxnQkFBWUosUUFGUDtBQUdMSyxlQUFXSixPQUhOO0FBSUxLLGNBQVVKO0FBSkwsR0FBUDtBQU1EIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtyZWFkRmlsZVN5bmN9IGZyb20gJ2ZzJztcbmltcG9ydCB7am9pbn0gZnJvbSAncGF0aCc7XG5cbmV4cG9ydCBjb25zdCBuYW1lID0gJ2ZvZyc7XG5leHBvcnQgY29uc3QgdmVydGV4U2hhZGVyID0gJyc7XG5leHBvcnQgY29uc3QgZnJhZ21lbnRTaGFkZXIgPSByZWFkRmlsZVN5bmMoam9pbihfX2Rpcm5hbWUsICcuL2ZvZy1mcmFnbWVudC5nbHNsJykpO1xuXG4vKiBlc2xpbnQtZGlzYWJsZSBjYW1lbGNhc2UgKi9cbmV4cG9ydCBmdW5jdGlvbiBnZXRVbmlmb3Jtcyh7XG4gIGZvZ0VuYWJsZSA9IGZhbHNlLFxuICBmb2dDb2xvciA9IFswLjUsIDAuNSwgMC41XSxcbiAgZm9nTmVhciA9IDEsXG4gIGZvZ0ZhciA9IDEwMFxufSA9IHt9KSB7XG4gIHJldHVybiB7XG4gICAgZm9nX3VFbmFibGU6IGZvZ0VuYWJsZSxcbiAgICBmb2dfdUNvbG9yOiBmb2dDb2xvcixcbiAgICBmb2dfdU5lYXI6IGZvZ05lYXIsXG4gICAgZm9nX3VGYXI6IGZvZ0ZhclxuICB9O1xufVxuIl19
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(243).Buffer))

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.vertexShader = exports.name = undefined;
	
	var _mathFp = __webpack_require__(1043);
	
	Object.keys(_mathFp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mathFp[key];
	    }
	  });
	});
	
	var _path = __webpack_require__(132);
	
	var name = exports.name = 'fp64';
	var vertexShader = exports.vertexShader = '// Copyright (c) 2016 Uber Technologies, Inc.\n//\n// Permission is hereby granted, free of charge, to any person obtaining a copy\n// of this software and associated documentation files (the "Software"), to deal\n// in the Software without restriction, including without limitation the rights\n// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n// copies of the Software, and to permit persons to whom the Software is\n// furnished to do so, subject to the following conditions:\n//\n// The above copyright notice and this permission notice shall be included in\n// all copies or substantial portions of the Software.\n//\n// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n// THE SOFTWARE.\nuniform float ONE;\n\nconst vec2 E_FP64 = vec2(2.7182817459106445e+00, 8.254840366817007e-08);\nconst vec2 LOG2_FP64 = vec2(0.6931471824645996e+00, -1.9046542121259336e-09);\nconst vec2 PI_FP64 = vec2(3.1415927410125732, -8.742278012618954e-8);\nconst vec2 TWO_PI_FP64 = vec2(6.2831854820251465, -1.7484556025237907e-7);\nconst vec2 PI_2_FP64 = vec2(1.5707963705062866, -4.371139006309477e-8);\nconst vec2 PI_4_FP64 = vec2(0.7853981852531433, -2.1855695031547384e-8);\nconst vec2 PI_16_FP64 = vec2(0.19634954631328583, -5.463923757886846e-9);\nconst vec2 PI_16_2_FP64 = vec2(0.39269909262657166, -1.0927847515773692e-8);\nconst vec2 PI_16_3_FP64 = vec2(0.5890486240386963, -1.4906100798128818e-9);\n\nconst vec2 SIN_TABLE_0_FP64 = vec2(0.19509032368659973, -1.6704714833615242e-9);\nconst vec2 SIN_TABLE_1_FP64 = vec2(0.3826834261417389, 6.22335089017767e-9);\nconst vec2 SIN_TABLE_2_FP64 = vec2(0.5555702447891235, -1.1769521357507529e-8);\nconst vec2 SIN_TABLE_3_FP64 = vec2(0.7071067690849304, 1.2101617041793133e-8);\n\nconst vec2 COS_TABLE_0_FP64 = vec2(0.9807852506637573, 2.9739473106360492e-8);\nconst vec2 COS_TABLE_1_FP64 = vec2(0.9238795042037964, 2.8307490351764386e-8);\nconst vec2 COS_TABLE_2_FP64 = vec2(0.8314695954322815, 1.6870263741530778e-8);\nconst vec2 COS_TABLE_3_FP64 = vec2(0.7071067690849304, 1.2101617152815436e-8);\n\nconst vec2 INVERSE_FACTORIAL_3_FP64 = vec2(1.666666716337204e-01, -4.967053879312289e-09); // 1/3!\nconst vec2 INVERSE_FACTORIAL_4_FP64 = vec2(4.16666679084301e-02, -1.2417634698280722e-09); // 1/4!\nconst vec2 INVERSE_FACTORIAL_5_FP64 = vec2(8.333333767950535e-03, -4.34617203337595e-10); // 1/5!\nconst vec2 INVERSE_FACTORIAL_6_FP64 = vec2(1.3888889225199819e-03, -3.3631094437103215e-11); // 1/6!\nconst vec2 INVERSE_FACTORIAL_7_FP64 = vec2(1.9841270113829523e-04,  -2.725596874933456e-12); // 1/7!\nconst vec2 INVERSE_FACTORIAL_8_FP64 = vec2(2.4801587642286904e-05, -3.406996025904184e-13); // 1/8!\nconst vec2 INVERSE_FACTORIAL_9_FP64 = vec2(2.75573188446287533e-06, 3.7935713937038186e-14); // 1/9!\nconst vec2 INVERSE_FACTORIAL_10_FP64 = vec2(2.755731998149713e-07, -7.575112367869873e-15); // 1/10!\n\nfloat nint(float d) {\n    if (d == floor(d)) return d;\n    return floor(d + 0.5);\n}\n\n#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)\nvec2 split(float a) {\n  const float SPLIT = 4097.0;\n  float t = a * SPLIT;\n  float a_hi = t * ONE - (t - a);\n  float a_lo = a * ONE - a_hi;\n  return vec2(a_hi, a_lo);\n}\n#else\nvec2 split(float a) {\n  const float SPLIT = 4097.0;\n  float t = a * SPLIT;\n  float a_hi = t - (t - a);\n  float a_lo = a - a_hi;\n  return vec2(a_hi, a_lo);\n}\n#endif\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\nvec2 quickTwoSum(float a, float b) {\n  float sum = (a + b) * ONE;\n  float err = b - (sum - a) * ONE;\n  return vec2(sum, err);\n}\n#else\nvec2 quickTwoSum(float a, float b) {\n  float sum = a + b;\n  float err = b - (sum - a);\n  return vec2(sum, err);\n}\n#endif\n\nvec2 nint_fp64(vec2 a) {\n    float hi = nint(a.x);\n    float lo;\n    vec2 tmp;\n    if (hi == a.x) {\n        lo = nint(a.y);\n        tmp = quickTwoSum(hi, lo);\n    } else {\n        lo = 0.0;\n        if (abs(hi - a.x) == 0.5 && a.y < 0.0) {\n            hi -= 1.0;\n        }\n        tmp = vec2(hi, lo);\n    }\n    return tmp;\n}\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\nvec2 twoSum(float a, float b) {\n  float s = (a + b) * ONE;\n  float v = (s - a);\n  float err = (a - (s - v) * ONE) * ONE + (b - v);\n  return vec2(s, err);\n}\n#else\nvec2 twoSum(float a, float b) {\n  float s = a + b;\n  float v = s - a;\n  float err = (a - (s - v)) + (b - v);\n  return vec2(s, err);\n}\n#endif\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\nvec2 twoSub(float a, float b) {\n  float s = (a - b) * ONE;\n  float v = (s - a);\n  float err = (a - (s - v) * ONE) * ONE - (b + v);\n  return vec2(s, err);\n}\n#else\nvec2 twoSub(float a, float b) {\n  float s = a - b;\n  float v = s - a;\n  float err = (a - (s - v)) - (b + v);\n  return vec2(s, err);\n}\n#endif\n\nvec2 twoProd(float a, float b) {\n  float prod = a * b;\n  vec2 a_fp64 = split(a);\n  vec2 b_fp64 = split(b);\n  float err = ((a_fp64.x * b_fp64.x - prod) + a_fp64.x * b_fp64.y +\n    a_fp64.y * b_fp64.x) + a_fp64.y * b_fp64.y;\n  return vec2(prod, err);\n}\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\nvec2 twoSqr(float a) {\n  float prod = a * a;\n  vec2 a_fp64 = split(a);\n\n  float err = ((a_fp64.x * a_fp64.x - prod) * ONE + 2.0 * a_fp64.x * a_fp64.y * ONE * ONE) + a_fp64.y * a_fp64.y * ONE * ONE * ONE;\n  return vec2(prod, err);\n}\n#else\nvec2 twoSqr(float a) {\n  float prod = a * a;\n  vec2 a_fp64 = split(a);\n\n  float err = ((a_fp64.x * a_fp64.x - prod) + 2.0 * a_fp64.x * a_fp64.y) + a_fp64.y * a_fp64.y;\n  return vec2(prod, err);\n}\n#endif\n\nvec2 sum_fp64(vec2 a, vec2 b) {\n  vec2 s, t;\n  s = twoSum(a.x, b.x);\n  t = twoSum(a.y, b.y);\n  s.y += t.x;\n  s = quickTwoSum(s.x, s.y);\n  s.y += t.y;\n  s = quickTwoSum(s.x, s.y);\n  return s;\n}\n\nvec2 sub_fp64(vec2 a, vec2 b) {\n  vec2 s, t;\n  s = twoSub(a.x, b.x);\n  t = twoSub(a.y, b.y);\n  s.y += t.x;\n  s = quickTwoSum(s.x, s.y);\n  s.y += t.y;\n  s = quickTwoSum(s.x, s.y);\n  return s;\n}\n\nvec2 mul_fp64(vec2 a, vec2 b) {\n  vec2 prod = twoProd(a.x, b.x);\n  // y component is for the error\n  prod.y += a.x * b.y;\n  prod.y += a.y * b.x;\n  prod = quickTwoSum(prod.x, prod.y);\n  return prod;\n}\n\nvec2 div_fp64(vec2 a, vec2 b) {\n  float xn = 1.0 / b.x;\n  vec2 yn = a * xn;\n  float diff = (sub_fp64(a, mul_fp64(b, yn))).x;\n  vec2 prod = twoProd(xn, diff);\n  return sum_fp64(yn, prod);\n}\n\nvec2 sqrt_fp64(vec2 a) {\n\n  if (a.x == 0.0 && a.y == 0.0) return vec2(0.0, 0.0);\n  if (a.x < 0.0) return vec2(0.0 / 0.0, 0.0 / 0.0);\n\n  float x = 1.0 / sqrt(a.x);\n  float yn = a.x * x;\n#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)\n  vec2 yn_sqr = twoSqr(yn) * ONE;\n#else\n  vec2 yn_sqr = twoSqr(yn);\n#endif\n  float diff = sub_fp64(a, yn_sqr).x;\n  vec2 prod = twoProd(x * 0.5, diff);\n  return sum_fp64(vec2(yn, 0.0), prod);\n}\n\nvec2 exp_fp64(vec2 a) {\n  const float k = 512.0;\n  const float inv_k = 1.0 / k;\n\n  if (a.x <= -88.0) return vec2(0.0, 0.0);\n  if (a.x >= 88.0) return vec2(1.0 / 0.0, 1.0 / 0.0);\n  if (a.x == 0.0 && a.y == 0.0) return vec2(1.0, 0.0);\n  if (a.x == 1.0 && a.y == 0.0) return E_FP64;\n\n  // Range reduction using assume a = kr + m * log(2), k and m being integers.\n  // Set k = 9 (we can choose other k to trade accuracy with performance.\n  // we only need to calculate exp(r) and using exp(a) = 2^m * exp(r)^k\n\n  float m = floor(a.x / LOG2_FP64.x + 0.5);\n  vec2 r = sub_fp64(a, mul_fp64(LOG2_FP64, vec2(m, 0.0))) * inv_k;\n  vec2 s, t, p;\n\n  p = mul_fp64(r, r);\n  s = sum_fp64(r, p * 0.5);\n  p = mul_fp64(p, r);\n  t = mul_fp64(p, INVERSE_FACTORIAL_3_FP64);\n\n  s = sum_fp64(s, t);\n  p = mul_fp64(p, r);\n  t = mul_fp64(p, INVERSE_FACTORIAL_4_FP64);\n\n  s = sum_fp64(s, t);\n  p = mul_fp64(p, r);\n  t = mul_fp64(p, INVERSE_FACTORIAL_5_FP64);\n\n  s = sum_fp64(s, t);\n  p = mul_fp64(p, r);\n  t = mul_fp64(p, INVERSE_FACTORIAL_6_FP64);\n\n  s = sum_fp64(s, t);\n  p = mul_fp64(p, r);\n  t = mul_fp64(p, INVERSE_FACTORIAL_7_FP64);\n\n  s = sum_fp64(s, t);\n\n  // At this point, s = exp(r) - 1; but after following 4 recursions, we will get exp(r) ^ 512 - 1.\n\n  s = sum_fp64(s * 2.0, mul_fp64(s, s));\n  s = sum_fp64(s * 2.0, mul_fp64(s, s));\n  s = sum_fp64(s * 2.0, mul_fp64(s, s));\n  s = sum_fp64(s * 2.0, mul_fp64(s, s));\n\n  // We can add more iterations here and increase k.\n  s = sum_fp64(s * 2.0, mul_fp64(s, s));\n  s = sum_fp64(s * 2.0, mul_fp64(s, s));\n  s = sum_fp64(s * 2.0, mul_fp64(s, s));\n  s = sum_fp64(s * 2.0, mul_fp64(s, s));\n  s = sum_fp64(s * 2.0, mul_fp64(s, s));\n\n#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)\n  s = sum_fp64(s, vec2(1.0, 0.0) * ONE);\n#else\n  s = sum_fp64(s, vec2(1.0, 0.0));\n#endif\n\n  return s * pow(2.0, m);\n//   return r;\n}\n\nvec2 log_fp64(vec2 a)\n{\n  if (a.x == 1.0 && a.y == 0.0) return vec2(0.0, 0.0);\n  if (a.x <= 0.0) return vec2(0.0 / 0.0, 0.0 / 0.0);\n  vec2 x = vec2(log(a.x), 0.0);\n  x = sub_fp64(sum_fp64(x, mul_fp64(a, exp_fp64(-x))), vec2(1.0, 0.0));\n  return x;\n}\n\nvec2 sin_taylor_fp64(vec2 a) {\n  vec2 r, s, t, x;\n\n  if (a.x == 0.0 && a.y == 0.0) {\n    return vec2(0.0, 0.0);\n  }\n\n  x = -mul_fp64(a, a);\n  s = a;\n  r = a;\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_3_FP64);\n  s = sum_fp64(s, t);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_5_FP64);\n  s = sum_fp64(s, t);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_7_FP64);\n  s = sum_fp64(s, t);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_9_FP64);\n  s = sum_fp64(s, t);\n\n  return s;\n}\n\nvec2 cos_taylor_fp64(vec2 a) {\n  vec2 r, s, t, x;\n\n  if (a.x == 0.0 && a.y == 0.0) {\n    return vec2(1.0, 0.0);\n  }\n\n  x = -mul_fp64(a, a);\n  r = x;\n  s = sum_fp64(vec2(1.0, 0.0), r * 0.5);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_4_FP64);\n  s = sum_fp64(s, t);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_6_FP64);\n  s = sum_fp64(s, t);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_8_FP64);\n  s = sum_fp64(s, t);\n\n  r = mul_fp64(r, x);\n  t = mul_fp64(r, INVERSE_FACTORIAL_10_FP64);\n  s = sum_fp64(s, t);\n\n  return s;\n}\n\nvoid sincos_taylor_fp64(vec2 a, out vec2 sin_t, out vec2 cos_t) {\n  if (a.x == 0.0 && a.y == 0.0) {\n    sin_t = vec2(0.0, 0.0);\n    cos_t = vec2(1.0, 0.0);\n  }\n\n  sin_t = sin_taylor_fp64(a);\n  cos_t = sqrt_fp64(sub_fp64(vec2(1.0, 0.0), mul_fp64(sin_t, sin_t)));\n}\n\nvec2 sin_fp64(vec2 a) {\n    if (a.x == 0.0 && a.y == 0.0) {\n        return vec2(0.0, 0.0);\n    }\n\n    // 2pi range reduction\n    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));\n    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));\n\n    vec2 t;\n    float q = floor(r.x / PI_2_FP64.x + 0.5);\n    int j = int(q);\n\n    if (j < -2 || j > 2) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    }\n\n    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));\n\n    q = floor(t.x / PI_16_FP64.x + 0.5);\n    int k = int(q);\n\n    if (k == 0) {\n        if (j == 0) {\n            return sin_taylor_fp64(t);\n        } else if (j == 1) {\n            return cos_taylor_fp64(t);\n        } else if (j == -1) {\n            return -cos_taylor_fp64(t);\n        } else {\n            return -sin_taylor_fp64(t);\n        }\n    }\n\n    int abs_k = int(abs(float(k)));\n\n    if (abs_k > 4) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    } else if (k == 3) {\n        t = sub_fp64(t, PI_16_3_FP64);\n    } else if (k == -3) {\n        t = sum_fp64(t, PI_16_3_FP64);\n    } else {\n        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));\n    }\n\n    vec2 u = vec2(0.0, 0.0);\n    vec2 v = vec2(0.0, 0.0);\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\n    if (abs(float(abs_k) - 1.0) < 0.5) {\n        u = COS_TABLE_0_FP64;\n        v = SIN_TABLE_0_FP64;\n    } else if (abs(float(abs_k) - 2.0) < 0.5) {\n        u = COS_TABLE_1_FP64;\n        v = SIN_TABLE_1_FP64;\n    } else if (abs(float(abs_k) - 3.0) < 0.5) {\n        u = COS_TABLE_2_FP64;\n        v = SIN_TABLE_2_FP64;\n    } else if (abs(float(abs_k) - 4.0) < 0.5) {\n        u = COS_TABLE_3_FP64;\n        v = SIN_TABLE_3_FP64;\n    }\n#else\n    if (abs_k == 1) {\n        u = COS_TABLE_0_FP64;\n        v = SIN_TABLE_0_FP64;\n    } else if (abs_k == 2) {\n        u = COS_TABLE_1_FP64;\n        v = SIN_TABLE_1_FP64;\n    } else if (abs_k == 3) {\n        u = COS_TABLE_2_FP64;\n        v = SIN_TABLE_2_FP64;\n    } else if (abs_k == 4) {\n        u = COS_TABLE_3_FP64;\n        v = SIN_TABLE_3_FP64;\n    }\n#endif\n\n    vec2 sin_t, cos_t;\n    sincos_taylor_fp64(t, sin_t, cos_t);\n\n    vec2 result = vec2(0.0, 0.0);\n    if (j == 0) {\n        if (k > 0) {\n            result = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        } else {\n            result = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        }\n    } else if (j == 1) {\n        if (k > 0) {\n            result = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        } else {\n            result = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        }\n    } else if (j == -1) {\n        if (k > 0) {\n            result = sub_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));\n        } else {\n            result = -sum_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));\n        }\n    } else {\n        if (k > 0) {\n            result = -sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        } else {\n            result = sub_fp64(mul_fp64(v, cos_t), mul_fp64(u, sin_t));\n        }\n    }\n\n    return result;\n}\n\nvec2 cos_fp64(vec2 a) {\n    if (a.x == 0.0 && a.y == 0.0) {\n        return vec2(1.0, 0.0);\n    }\n\n    // 2pi range reduction\n    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));\n    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));\n\n    vec2 t;\n    float q = floor(r.x / PI_2_FP64.x + 0.5);\n    int j = int(q);\n\n    if (j < -2 || j > 2) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    }\n\n    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));\n\n    q = floor(t.x / PI_16_FP64.x + 0.5);\n    int k = int(q);\n\n    if (k == 0) {\n        if (j == 0) {\n            return cos_taylor_fp64(t);\n        } else if (j == 1) {\n            return -sin_taylor_fp64(t);\n        } else if (j == -1) {\n            return sin_taylor_fp64(t);\n        } else {\n            return -cos_taylor_fp64(t);\n        }\n    }\n\n    int abs_k = int(abs(float(k)));\n\n    if (abs_k > 4) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    } else if (k == 3) {\n        t = sub_fp64(t, PI_16_3_FP64);\n    } else if (k == -3) {\n        t = sum_fp64(t, PI_16_3_FP64);\n    } else {\n        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));\n    }\n\n    vec2 u = vec2(0.0, 0.0);\n    vec2 v = vec2(0.0, 0.0);\n\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\n    if (abs(float(abs_k) - 1.0) < 0.5) {\n        u = COS_TABLE_0_FP64;\n        v = SIN_TABLE_0_FP64;\n    } else if (abs(float(abs_k) - 2.0) < 0.5) {\n        u = COS_TABLE_1_FP64;\n        v = SIN_TABLE_1_FP64;\n    } else if (abs(float(abs_k) - 3.0) < 0.5) {\n        u = COS_TABLE_2_FP64;\n        v = SIN_TABLE_2_FP64;\n    } else if (abs(float(abs_k) - 4.0) < 0.5) {\n        u = COS_TABLE_3_FP64;\n        v = SIN_TABLE_3_FP64;\n    }\n#else\n    if (abs_k == 1) {\n        u = COS_TABLE_0_FP64;\n        v = SIN_TABLE_0_FP64;\n    } else if (abs_k == 2) {\n        u = COS_TABLE_1_FP64;\n        v = SIN_TABLE_1_FP64;\n    } else if (abs_k == 3) {\n        u = COS_TABLE_2_FP64;\n        v = SIN_TABLE_2_FP64;\n    } else if (abs_k == 4) {\n        u = COS_TABLE_3_FP64;\n        v = SIN_TABLE_3_FP64;\n    }\n#endif\n\n    vec2 sin_t, cos_t;\n    sincos_taylor_fp64(t, sin_t, cos_t);\n\n    vec2 result = vec2(0.0, 0.0);\n    if (j == 0) {\n        if (k > 0) {\n            result = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        } else {\n            result = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        }\n    } else if (j == 1) {\n        if (k > 0) {\n            result = -sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        } else {\n            result = sub_fp64(mul_fp64(v, cos_t), mul_fp64(u, sin_t));\n        }\n    } else if (j == -1) {\n        if (k > 0) {\n            result = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        } else {\n            result = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n        }\n    } else {\n        if (k > 0) {\n            result = sub_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));\n        } else {\n            result = -sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        }\n    }\n\n    return result;\n}\n\nvec2 tan_fp64(vec2 a) {\n    vec2 sin_a;\n    vec2 cos_a;\n\n    if (a.x == 0.0 && a.y == 0.0) {\n        return vec2(0.0, 0.0);\n    }\n\n    // 2pi range reduction\n    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));\n    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));\n\n    vec2 t;\n    float q = floor(r.x / PI_2_FP64.x + 0.5);\n    int j = int(q);\n\n\n    if (j < -2 || j > 2) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    }\n\n    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));\n\n    q = floor(t.x / PI_16_FP64.x + 0.5);\n    int k = int(q);\n    int abs_k = int(abs(float(k)));\n\n    // We just can\'t get PI/16 * 3.0 very accurately.\n    // so let\'s just store it\n    if (abs_k > 4) {\n        return vec2(0.0 / 0.0, 0.0 / 0.0);\n    } else if (k == 3) {\n        t = sub_fp64(t, PI_16_3_FP64);\n    } else if (k == -3) {\n        t = sum_fp64(t, PI_16_3_FP64);\n    } else {\n        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));\n    }\n\n\n    vec2 u = vec2(0.0, 0.0);\n    vec2 v = vec2(0.0, 0.0);\n\n    vec2 sin_t, cos_t;\n    vec2 s, c;\n    sincos_taylor_fp64(t, sin_t, cos_t);\n\n    if (k == 0) {\n        s = sin_t;\n        c = cos_t;\n    } else {\n#if defined(NVIDIA_EQUATION_WORKAROUND) || defined(INTEL_EQUATION_WORKAROUND)\n        if (abs(float(abs_k) - 1.0) < 0.5) {\n            u = COS_TABLE_0_FP64;\n            v = SIN_TABLE_0_FP64;\n        } else if (abs(float(abs_k) - 2.0) < 0.5) {\n            u = COS_TABLE_1_FP64;\n            v = SIN_TABLE_1_FP64;\n        } else if (abs(float(abs_k) - 3.0) < 0.5) {\n            u = COS_TABLE_2_FP64;\n            v = SIN_TABLE_2_FP64;\n        } else if (abs(float(abs_k) - 4.0) < 0.5) {\n            u = COS_TABLE_3_FP64;\n            v = SIN_TABLE_3_FP64;\n        }\n#else\n        if (abs_k == 1) {\n            u = COS_TABLE_0_FP64;\n            v = SIN_TABLE_0_FP64;\n        } else if (abs_k == 2) {\n            u = COS_TABLE_1_FP64;\n            v = SIN_TABLE_1_FP64;\n        } else if (abs_k == 3) {\n            u = COS_TABLE_2_FP64;\n            v = SIN_TABLE_2_FP64;\n        } else if (abs_k == 4) {\n            u = COS_TABLE_3_FP64;\n            v = SIN_TABLE_3_FP64;\n        }\n#endif\n        if (k > 0) {\n            s = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n            c = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        } else {\n            s = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));\n            c = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));\n        }\n    }\n\n    if (j == 0) {\n        sin_a = s;\n        cos_a = c;\n    } else if (j == 1) {\n        sin_a = c;\n        cos_a = -s;\n    } else if (j == -1) {\n        sin_a = -c;\n        cos_a = s;\n    } else {\n        sin_a = -s;\n        cos_a = -c;\n    }\n    return div_fp64(sin_a, cos_a);\n}\n\nvec2 radians_fp64(vec2 degree) {\n  return div_fp64(mul_fp64(degree, PI_FP64), vec2(180.0, 0.0));\n}\n\n// Vector functions\n// vec2 functions\nvoid vec2_sum_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {\n    out_val[0] = sum_fp64(a[0], b[0]);\n    out_val[1] = sum_fp64(a[1], b[1]);\n}\n\nvoid vec2_sub_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {\n    out_val[0] = sub_fp64(a[0], b[0]);\n    out_val[1] = sub_fp64(a[1], b[1]);\n}\n\nvoid vec2_mix_fp64(vec2 x[2], vec2 y[2], float a, out vec2 out_val[2]) {\n  vec2 range[2];\n  vec2_sub_fp64(y, x, range);\n  vec2 portion[2];\n  portion[0] = range[0] * a;\n  portion[1] = range[1] * a;\n  vec2_sum_fp64(x, portion, out_val);\n}\n\nvec2 vec2_length_fp64(vec2 x[2]) {\n  return sqrt_fp64(sum_fp64(mul_fp64(x[0], x[0]), mul_fp64(x[1], x[1])));\n}\n\nvec2 vec2_distance_fp64(vec2 x[2], vec2 y[2]) {\n  vec2 diff[2];\n  vec2_sub_fp64(x, y, diff);\n  return vec2_length_fp64(diff);\n}\n\n// vec3 functions\nvoid vec3_sub_fp64(vec2 a[3], vec2 b[3], out vec2 out_val[3]) {\n  for (int i = 0; i < 3; i++) {\n    out_val[i] = sum_fp64(a[i], b[i]);\n  }\n}\n\nvoid vec3_sum_fp64(vec2 a[3], vec2 b[3], out vec2 out_val[3]) {\n  for (int i = 0; i < 3; i++) {\n    out_val[i] = sum_fp64(a[i], b[i]);\n  }\n}\n\nvec2 vec3_length_fp64(vec2 x[3]) {\n  return sqrt_fp64(sum_fp64(sum_fp64(mul_fp64(x[0], x[0]), mul_fp64(x[1], x[1])), mul_fp64(x[2], x[2])));\n}\n\nvec2 vec3_distance_fp64(vec2 x[3], vec2 y[3]) {\n  vec2 diff[3];\n  vec3_sub_fp64(x, y, diff);\n  return vec3_length_fp64(diff);\n}\n\n// vec4 functions\nvoid vec4_fp64(vec4 a, out vec2 out_val[4]) {\n  out_val[0].x = a[0];\n  out_val[0].y = 0.0;\n\n  out_val[1].x = a[1];\n  out_val[1].y = 0.0;\n\n  out_val[2].x = a[2];\n  out_val[2].y = 0.0;\n\n  out_val[3].x = a[3];\n  out_val[3].y = 0.0;\n}\n\nvoid vec4_scalar_mul_fp64(vec2 a[4], vec2 b, out vec2 out_val[4]) {\n  out_val[0] = mul_fp64(a[0], b);\n  out_val[1] = mul_fp64(a[1], b);\n  out_val[2] = mul_fp64(a[2], b);\n  out_val[3] = mul_fp64(a[3], b);\n}\n\nvoid vec4_sum_fp64(vec2 a[4], vec2 b[4], out vec2 out_val[4]) {\n  for (int i = 0; i < 4; i++) {\n    out_val[i] = sum_fp64(a[i], b[i]);\n  }\n}\n\nvoid vec4_dot_fp64(vec2 a[4], vec2 b[4], out vec2 out_val) {\n  vec2 v[4];\n\n  v[0] = mul_fp64(a[0], b[0]);\n  v[1] = mul_fp64(a[1], b[1]);\n  v[2] = mul_fp64(a[2], b[2]);\n  v[3] = mul_fp64(a[3], b[3]);\n\n  out_val = sum_fp64(sum_fp64(v[0], v[1]), sum_fp64(v[2], v[3]));\n}\n\nvoid mat4_vec4_mul_fp64(vec2 b[16], vec2 a[4], out vec2 out_val[4]) {\n  vec2 tmp[4];\n\n  for (int i = 0; i < 4; i++)\n  {\n    for (int j = 0; j < 4; j++)\n    {\n      tmp[j] = b[j + i * 4];\n    }\n    vec4_dot_fp64(a, tmp, out_val[i]);\n  }\n}\n';
	
	// JS Utilities
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVyLW1vZHVsZXMvZnA2NC9pbmRleC5qcyJdLCJuYW1lcyI6WyJuYW1lIiwidmVydGV4U2hhZGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFPQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBTkE7O0FBRU8sSUFBTUEsc0JBQU8sTUFBYjtBQUNBLElBQU1DLDB5c0JBQU47O0FBRVAiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge3JlYWRGaWxlU3luY30gZnJvbSAnZnMnO1xuaW1wb3J0IHtqb2lufSBmcm9tICdwYXRoJztcblxuZXhwb3J0IGNvbnN0IG5hbWUgPSAnZnA2NCc7XG5leHBvcnQgY29uc3QgdmVydGV4U2hhZGVyID0gcmVhZEZpbGVTeW5jKGpvaW4oX19kaXJuYW1lLCAnL21hdGgtZnA2NC5nbHNsJyksICd1dGY4Jyk7XG5cbi8vIEpTIFV0aWxpdGllc1xuZXhwb3J0ICogZnJvbSAnLi9tYXRoLWZwNjQnO1xuIl19

/***/ },
/* 1043 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fp64ify = fp64ify;
	function fp64ify(a) {
	  var hi = Math.fround(a);
	  var lo = a - Math.fround(a);
	  return new Float32Array([hi, lo]);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVyLW1vZHVsZXMvZnA2NC9tYXRoLWZwNjQuanMiXSwibmFtZXMiOlsiZnA2NGlmeSIsImEiLCJoaSIsIk1hdGgiLCJmcm91bmQiLCJsbyIsIkZsb2F0MzJBcnJheSJdLCJtYXBwaW5ncyI6Ijs7Ozs7UUFBZ0JBLE8sR0FBQUEsTztBQUFULFNBQVNBLE9BQVQsQ0FBaUJDLENBQWpCLEVBQW9CO0FBQ3pCLE1BQU1DLEtBQUtDLEtBQUtDLE1BQUwsQ0FBWUgsQ0FBWixDQUFYO0FBQ0EsTUFBTUksS0FBS0osSUFBSUUsS0FBS0MsTUFBTCxDQUFZSCxDQUFaLENBQWY7QUFDQSxTQUFPLElBQUlLLFlBQUosQ0FBaUIsQ0FBQ0osRUFBRCxFQUFLRyxFQUFMLENBQWpCLENBQVA7QUFDRCIsImZpbGUiOiJtYXRoLWZwNjQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZnVuY3Rpb24gZnA2NGlmeShhKSB7XG4gIGNvbnN0IGhpID0gTWF0aC5mcm91bmQoYSk7XG4gIGNvbnN0IGxvID0gYSAtIE1hdGguZnJvdW5kKGEpO1xuICByZXR1cm4gbmV3IEZsb2F0MzJBcnJheShbaGksIGxvXSk7XG59XG4iXX0=

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _shaderTools = __webpack_require__(467);
	
	var _fp = __webpack_require__(1042);
	
	var fp64 = _interopRequireWildcard(_fp);
	
	var _fog = __webpack_require__(1041);
	
	var fog = _interopRequireWildcard(_fog);
	
	var _picking = __webpack_require__(1046);
	
	var picking = _interopRequireWildcard(_picking);
	
	var _material = __webpack_require__(1045);
	
	var material = _interopRequireWildcard(_material);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	(0, _shaderTools.registerShaderModules)([fp64, fog, picking,
	// lighting,
	material]);
	// import * as lighting from './lighting';
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVyLW1vZHVsZXMvaW5kZXguanMiXSwibmFtZXMiOlsiZnA2NCIsImZvZyIsInBpY2tpbmciLCJtYXRlcmlhbCJdLCJtYXBwaW5ncyI6Ijs7QUFBQTs7QUFFQTs7SUFBWUEsSTs7QUFFWjs7SUFBWUMsRzs7QUFDWjs7SUFBWUMsTzs7QUFFWjs7SUFBWUMsUTs7OztBQUVaLHdDQUFzQixDQUNwQkgsSUFEb0IsRUFFcEJDLEdBRm9CLEVBR3BCQyxPQUhvQjtBQUlwQjtBQUNBQyxRQUxvQixDQUF0QjtBQUhBIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtyZWdpc3RlclNoYWRlck1vZHVsZXN9IGZyb20gJy4uL3NoYWRlci10b29scyc7XG5cbmltcG9ydCAqIGFzIGZwNjQgZnJvbSAnLi9mcDY0JztcblxuaW1wb3J0ICogYXMgZm9nIGZyb20gJy4vZm9nJztcbmltcG9ydCAqIGFzIHBpY2tpbmcgZnJvbSAnLi9waWNraW5nJztcbi8vIGltcG9ydCAqIGFzIGxpZ2h0aW5nIGZyb20gJy4vbGlnaHRpbmcnO1xuaW1wb3J0ICogYXMgbWF0ZXJpYWwgZnJvbSAnLi9tYXRlcmlhbCc7XG5cbnJlZ2lzdGVyU2hhZGVyTW9kdWxlcyhbXG4gIGZwNjQsXG4gIGZvZyxcbiAgcGlja2luZyxcbiAgLy8gbGlnaHRpbmcsXG4gIG1hdGVyaWFsXG5dKTtcbiJdfQ==

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fragmentShader = exports.vertexShader = exports.name = undefined;
	exports.getUniforms = getUniforms;
	
	var _path = __webpack_require__(132);
	
	var name = exports.name = 'material';
	var vertexShader = exports.vertexShader = Buffer('Ci8qIFNldCB0aGUgVVYgY29vcmRpbmF0ZSBmcm9tIGF0dHJpYnV0ZXMgKi8Kdm9pZCBtYXRlcmlhbF9zZXRVVnMoZGlmZnVzZVVWLCBzcGVjdWxhclVWKSB7CiAgbWF0ZXJpYWxfdkRpZmZ1c2VVViA9IGRpZmZ1c2VVVjsKICBtYXRlcmlhbF92U3BlY3VsYXJVViA9IHNwZWN1bGFyVVY7Cn0K', 'base64');
	var fragmentShader = exports.fragmentShader = Buffer('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', 'base64');
	
	/* eslint-disable camelcase */
	function getUniforms() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$enable = _ref.enable,
	      enable = _ref$enable === undefined ? true : _ref$enable;
	
	  return {
	    picking_enable: enable
	  };
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVyLW1vZHVsZXMvbWF0ZXJpYWwvaW5kZXguanMiXSwibmFtZXMiOlsiZ2V0VW5pZm9ybXMiLCJuYW1lIiwidmVydGV4U2hhZGVyIiwiZnJhZ21lbnRTaGFkZXIiLCJlbmFibGUiLCJwaWNraW5nX2VuYWJsZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O1FBUWdCQSxXLEdBQUFBLFc7O0FBUGhCOztBQUVPLElBQU1DLHNCQUFPLFVBQWI7QUFDQSxJQUFNQyxzUkFBTjtBQUNBLElBQU1DLHNxRkFBTjs7QUFFUDtBQUNPLFNBQVNILFdBQVQsR0FFQztBQUFBLGlGQUFKLEVBQUk7QUFBQSx5QkFETkksTUFDTTtBQUFBLE1BRE5BLE1BQ00sK0JBREcsSUFDSDs7QUFDTixTQUFPO0FBQ0xDLG9CQUFnQkQ7QUFEWCxHQUFQO0FBR0QiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge3JlYWRGaWxlU3luY30gZnJvbSAnZnMnO1xuaW1wb3J0IHtqb2lufSBmcm9tICdwYXRoJztcblxuZXhwb3J0IGNvbnN0IG5hbWUgPSAnbWF0ZXJpYWwnO1xuZXhwb3J0IGNvbnN0IHZlcnRleFNoYWRlciA9IHJlYWRGaWxlU3luYyhqb2luKF9fZGlybmFtZSwgJy4vbWF0ZXJpYWwtdmVydGV4Lmdsc2wnKSk7XG5leHBvcnQgY29uc3QgZnJhZ21lbnRTaGFkZXIgPSByZWFkRmlsZVN5bmMoam9pbihfX2Rpcm5hbWUsICcuL21hdGVyaWFsLWZyYWdtZW50Lmdsc2wnKSk7XG5cbi8qIGVzbGludC1kaXNhYmxlIGNhbWVsY2FzZSAqL1xuZXhwb3J0IGZ1bmN0aW9uIGdldFVuaWZvcm1zKHtcbiAgZW5hYmxlID0gdHJ1ZVxufSA9IHt9KSB7XG4gIHJldHVybiB7XG4gICAgcGlja2luZ19lbmFibGU6IGVuYWJsZVxuICB9O1xufVxuIl19
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(243).Buffer))

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fragmentShader = exports.vertexShader = exports.name = undefined;
	exports.getUniforms = getUniforms;
	
	var _path = __webpack_require__(132);
	
	var name = exports.name = 'picking';
	var vertexShader = exports.vertexShader = Buffer('dmFyeWluZyB2ZWM0IHZDb2xvcjsKdmFyeWluZyB2ZWM0IHBpY2tpbmdfdkNvbG9yOwoKLy8gU3RvcmVzIHRoZSBwaWNraW5nIGNvbG9yCnZvaWQgcGlja2luZ19zZXRQaWNraW5nQ29sb3IodmVjMyBwaWNraW5nQ29sb3IpIHsKICB2UGlja2luZ0NvbG9yID0gcGlja2luZ0NvbG9yczsKfQo=', 'base64');
	var fragmentShader = exports.fragmentShader = Buffer('Ly8gcGlja2luZyBjb25maWdzCnVuaWZvcm0gYm9vbCBwaWNraW5nX3VFbmFibGVkOwp2YXJ5aW5nIHZlYzMgcGlja2luZ192UGlja2luZ0NvbG9yOwoKLyoKICogUmV0dXJucyBwaWNraW5nIGNvbG9yIGlmIHBpY2tpbmcgZW5hYmxlZAogKiBOb3RlOiBTaG91bGQgYmUgY2FsbGVkIGxhc3QsIHBpY2tpbmcgY29sb3IgbXVzdCBub3QgYmUgbW9kaWZpZWQuCiAqLwp2ZWM0IHBpY2tpbmdfZmlsdGVyQ29sb3IodmVjNCBjb2xvcikgewogIC8vIHNldCBwaWNraW5nCiAgaWYgKHBpY2tpbmdfdUVuYWJsZWQpIHsKICAJcmV0dXJuIHBpY2tpbmdfdlBpY2tpbmdDb2xvcjsKICB9IGVsc2UgewogIAlyZXR1cm4gY29sb3I7CiAgfQp9Cg==', 'base64');
	
	/* eslint-disable camelcase */
	function getUniforms() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$enable = _ref.enable,
	      enable = _ref$enable === undefined ? true : _ref$enable;
	
	  return {
	    picking_enable: enable
	  };
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVyLW1vZHVsZXMvcGlja2luZy9pbmRleC5qcyJdLCJuYW1lcyI6WyJnZXRVbmlmb3JtcyIsIm5hbWUiLCJ2ZXJ0ZXhTaGFkZXIiLCJmcmFnbWVudFNoYWRlciIsImVuYWJsZSIsInBpY2tpbmdfZW5hYmxlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7UUFRZ0JBLFcsR0FBQUEsVzs7QUFQaEI7O0FBRU8sSUFBTUMsc0JBQU8sU0FBYjtBQUNBLElBQU1DLHNSQUFOO0FBQ0EsSUFBTUMsMGhCQUFOOztBQUVQO0FBQ08sU0FBU0gsV0FBVCxHQUEyQztBQUFBLGlGQUFKLEVBQUk7QUFBQSx5QkFBckJJLE1BQXFCO0FBQUEsTUFBckJBLE1BQXFCLCtCQUFaLElBQVk7O0FBQ2hELFNBQU87QUFDTEMsb0JBQWdCRDtBQURYLEdBQVA7QUFHRCIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7cmVhZEZpbGVTeW5jfSBmcm9tICdmcyc7XG5pbXBvcnQge2pvaW59IGZyb20gJ3BhdGgnO1xuXG5leHBvcnQgY29uc3QgbmFtZSA9ICdwaWNraW5nJztcbmV4cG9ydCBjb25zdCB2ZXJ0ZXhTaGFkZXIgPSByZWFkRmlsZVN5bmMoam9pbihfX2Rpcm5hbWUsICcuL3BpY2tpbmctdmVydGV4Lmdsc2wnKSk7XG5leHBvcnQgY29uc3QgZnJhZ21lbnRTaGFkZXIgPSByZWFkRmlsZVN5bmMoam9pbihfX2Rpcm5hbWUsICcuL3BpY2tpbmctZnJhZ21lbnQuZ2xzbCcpKTtcblxuLyogZXNsaW50LWRpc2FibGUgY2FtZWxjYXNlICovXG5leHBvcnQgZnVuY3Rpb24gZ2V0VW5pZm9ybXMoe2VuYWJsZSA9IHRydWV9ID0ge30pIHtcbiAgcmV0dXJuIHtcbiAgICBwaWNraW5nX2VuYWJsZTogZW5hYmxlXG4gIH07XG59XG4iXX0=
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(243).Buffer))

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkRendererVendor = checkRendererVendor;
	exports.getPlatformShaderDefines = getPlatformShaderDefines;
	exports.assembleShaders = assembleShaders;
	
	var _registerShaders = __webpack_require__(468);
	
	var _webgl = __webpack_require__(131);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERTEX_SHADER = 'vertexShader';
	var FRAGMENT_SHADER = 'fragmentShader';
	
	function checkRendererVendor(debugInfo, gpuVendor) {
	  var vendor = debugInfo.vendor,
	      renderer = debugInfo.renderer;
	
	  var result = void 0;
	  switch (gpuVendor) {
	    case 'nvidia':
	      result = vendor.match(/NVIDIA/i) || renderer.match(/NVIDIA/i);
	      break;
	    case 'intel':
	      result = vendor.match(/INTEL/i) || renderer.match(/INTEL/i);
	      break;
	    case 'amd':
	      result = vendor.match(/AMD/i) || renderer.match(/AMD/i) || vendor.match(/ATI/i) || renderer.match(/ATI/i);
	      break;
	    default:
	      result = false;
	  }
	  return result;
	}
	
	function getPlatformShaderDefines(gl) {
	  /* eslint-disable */
	  var platformDefines = '';
	  var debugInfo = (0, _webgl.glGetDebugInfo)(gl);
	
	  if (checkRendererVendor(debugInfo, 'nvidia')) {
	    platformDefines += '#define NVIDIA_GPU\n#define NVIDIA_FP64_WORKAROUND 1\n#define NVIDIA_EQUATION_WORKAROUND 1\n';
	  } else if (checkRendererVendor(debugInfo, 'intel')) {
	    platformDefines += '#define INTEL_GPU\n#define INTEL_FP64_WORKAROUND 1\n#define NVIDIA_EQUATION_WORKAROUND 1\n #define INTEL_TAN_WORKAROUND 1\n';
	  } else if (checkRendererVendor(debugInfo, 'amd')) {
	    platformDefines += '#define AMD_GPU\n';
	  } else {
	    platformDefines += '#define DEFAULT_GPU\n';
	  }
	
	  return platformDefines;
	}
	
	function assembleShader(gl, _ref) {
	  var source = _ref.source,
	      type = _ref.type,
	      _ref$modules = _ref.modules,
	      modules = _ref$modules === undefined ? [] : _ref$modules;
	
	  (0, _assert2.default)(typeof source === 'string', 'shader source must be a string');
	
	  // Add platform defines
	  var assembledSource = getPlatformShaderDefines(gl) + '\n';
	
	  // Add dependent modules in resolved order
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = modules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var moduleName = _step.value;
	
	      var shaderModule = (0, _registerShaders.getShaderModule)(moduleName);
	      if (!shaderModule) {
	        (0, _assert2.default)(shaderModule, 'shader module is not defined');
	      }
	      var moduleSource = shaderModule[type];
	      assembledSource += '// BEGIN SHADER MODULE ' + moduleName + '\n#define MODULE_' + moduleName.toUpperCase() + '\n' + moduleSource + '\n// END SHADER MODULE ' + moduleName;
	    }
	
	    // Add actual source of shader
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  assembledSource += source;
	
	  return assembledSource;
	}
	
	/**
	 * Apply set of modules
	 */
	function assembleShaders(gl) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var vs = opts.vs,
	      fs = opts.fs;
	
	  var modules = (0, _registerShaders.getShaderDependencies)(opts.modules || []);
	  return {
	    gl: gl,
	    vs: assembleShader(gl, Object.assign({}, opts, { source: vs, type: VERTEX_SHADER, modules: modules })),
	    fs: assembleShader(gl, Object.assign({}, opts, { source: fs, type: FRAGMENT_SHADER, modules: modules }))
	  };
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webgl = __webpack_require__(131);
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ERR_SOURCE = 'ShaderCache expects source strings';
	var ERR_CONTEXT = 'ShaderCache does not support caching across multiple contexts';
	
	var ShaderCache = function () {
	
	  /**
	   * A cache of compiled shaders, keyed by shader source strings.
	   * Compilation of long shaders can be time consuming.
	   * By using this class, the application can ensure that each shader
	   * is only compiled once.
	   */
	  function ShaderCache() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        gl = _ref.gl;
	
	    _classCallCheck(this, ShaderCache);
	
	    this.gl = gl;
	    this.vertexShaders = {};
	    this.fragmentShaders = {};
	  }
	
	  /**
	   * Deletes shader references
	   * @return {ShaderCache} - returns this for chaining
	   */
	
	
	  _createClass(ShaderCache, [{
	    key: 'delete',
	    value: function _delete() {
	      // TODO - requires reference counting to avoid deleting shaders in use
	      return this;
	    }
	
	    /**
	     * Returns a compiled `VertexShader` object corresponding to the supplied
	     * GLSL source code string, if possible from cache.
	     *
	     * @param {WebGLRenderingContext} gl - gl context
	     * @param {String} source - Source code for shader
	     * @return {VertexShader} - a compiled vertex shader
	     */
	
	  }, {
	    key: 'getVertexShader',
	    value: function getVertexShader(gl, source) {
	      (0, _assert2.default)(typeof source === 'string', ERR_SOURCE);
	
	      var shader = this.vertexShaders[source];
	      (0, _assert2.default)(!shader || shader.gl === gl, ERR_CONTEXT);
	
	      if (!shader) {
	        shader = new _webgl.VertexShader(gl, source);
	        this.vertexShaders[source] = shader;
	      }
	      return shader;
	    }
	
	    /**
	     * Returns a compiled `VertexShader` object corresponding to the supplied
	     * GLSL source code string, if possible from cache.
	     *
	     * @param {WebGLRenderingContext} gl - gl context
	     * @param {String} source - Source code for shader
	     * @return {FragmentShader} - a compiled fragment shader, possibly from chache
	     */
	
	  }, {
	    key: 'getFragmentShader',
	    value: function getFragmentShader(gl, source) {
	      (0, _assert2.default)(typeof source === 'string', ERR_SOURCE);
	
	      var shader = this.fragmentShaders[source];
	      (0, _assert2.default)(!shader || shader.gl === gl, ERR_CONTEXT);
	
	      if (!shader) {
	        shader = new _webgl.FragmentShader(gl, source);
	        this.fragmentShaders[source] = shader;
	      }
	      return shader;
	    }
	  }]);
	
	  return ShaderCache;
	}();
	
	exports.default = ShaderCache;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1049 */
/***/ function(module, exports) {

	"use strict";
	
	// TODO - this file should be removed when module system is fully built out
	module.exports = {
	  hasTexture1: false,
	  hasTextureCube1: false,
	
	  enableLights: false,
	  useReflection: false,
	
	  // picking configs
	  enablePicking: false,
	  hasPickingColors: false,
	
	  // fog configuration
	  hasFog: false
	};
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVycy9kZWZhdWx0LXVuaWZvcm1zLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJoYXNUZXh0dXJlMSIsImhhc1RleHR1cmVDdWJlMSIsImVuYWJsZUxpZ2h0cyIsInVzZVJlZmxlY3Rpb24iLCJlbmFibGVQaWNraW5nIiwiaGFzUGlja2luZ0NvbG9ycyIsImhhc0ZvZyJdLCJtYXBwaW5ncyI6Ijs7QUFBQTtBQUNBQSxPQUFPQyxPQUFQLEdBQWlCO0FBQ2ZDLGVBQWEsS0FERTtBQUVmQyxtQkFBaUIsS0FGRjs7QUFJZkMsZ0JBQWMsS0FKQztBQUtmQyxpQkFBZSxLQUxBOztBQU9mO0FBQ0FDLGlCQUFlLEtBUkE7QUFTZkMsb0JBQWtCLEtBVEg7O0FBV2Y7QUFDQUMsVUFBUTtBQVpPLENBQWpCIiwiZmlsZSI6ImRlZmF1bHQtdW5pZm9ybXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBUT0RPIC0gdGhpcyBmaWxlIHNob3VsZCBiZSByZW1vdmVkIHdoZW4gbW9kdWxlIHN5c3RlbSBpcyBmdWxseSBidWlsdCBvdXRcbm1vZHVsZS5leHBvcnRzID0ge1xuICBoYXNUZXh0dXJlMTogZmFsc2UsXG4gIGhhc1RleHR1cmVDdWJlMTogZmFsc2UsXG5cbiAgZW5hYmxlTGlnaHRzOiBmYWxzZSxcbiAgdXNlUmVmbGVjdGlvbjogZmFsc2UsXG5cbiAgLy8gcGlja2luZyBjb25maWdzXG4gIGVuYWJsZVBpY2tpbmc6IGZhbHNlLFxuICBoYXNQaWNraW5nQ29sb3JzOiBmYWxzZSxcblxuICAvLyBmb2cgY29uZmlndXJhdGlvblxuICBoYXNGb2c6IGZhbHNlXG59O1xuIl19

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHADERS = undefined;
	
	var _path = __webpack_require__(132);
	
	// Default Shaders
	var vs = '#define SHADER_NAME luma-default-vs\n\n#define LIGHT_MAX 4\n\nattribute vec3 position;\nattribute vec3 normal;\nattribute vec4 color;\nattribute vec2 texCoord1;\n\nuniform mat4 worldMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 projectionMatrix;\nuniform mat4 worldInverseTransposeMatrix;\n\nuniform bool enableLights;\nuniform vec3 ambientColor;\nuniform vec3 directionalColor;\nuniform vec3 lightingDirection;\n\nuniform vec3 pointLocation[LIGHT_MAX];\nuniform vec3 pointColor[LIGHT_MAX];\nuniform int numberPoints;\n\nvarying vec4 vColor;\nvarying vec2 vTexCoord;\nvarying vec3 lightWeighting;\n\nvoid main(void) {\n  vec4 mvPosition = worldMatrix * vec4(position, 1.0);\n\n  if(!enableLights) {\n    lightWeighting = vec3(1.0, 1.0, 1.0);\n  } else {\n    vec3 plightDirection;\n    vec3 pointWeight = vec3(0.0, 0.0, 0.0);\n    vec4 transformedNormal = worldInverseTransposeMatrix * vec4(normal, 1.0);\n    float directionalLightWeighting = max(dot(transformedNormal.xyz, lightingDirection), 0.0);\n    for (int i = 0; i < LIGHT_MAX; i++) {\n      if (i < numberPoints) {\n        plightDirection = normalize((viewMatrix * vec4(pointLocation[i], 1.0)).xyz - mvPosition.xyz);\n        pointWeight += max(dot(transformedNormal.xyz, plightDirection), 0.0) * pointColor[i];\n      } else {\n        break;\n      }\n    }\n\n    lightWeighting = ambientColor + (directionalColor * directionalLightWeighting) + pointWeight;\n  }\n\n  vColor = color;\n  vTexCoord = texCoord1;\n  gl_Position = projectionMatrix * worldMatrix * vec4(position, 1.0);\n}\n';
	var fs = '#ifdef GL_ES\nprecision highp float;\n#endif\n\n#define SHADER_NAME luma-default-fs\n\nvarying vec4 vColor;\nvarying vec2 vTexCoord;\nvarying vec3 lightWeighting;\n\nuniform bool hasTexture1;\nuniform sampler2D sampler1;\n\nuniform bool enablePicking;\nuniform vec3 pickColor;\n\nuniform bool hasFog;\nuniform vec3 fogColor;\n\nuniform float fogNear;\nuniform float fogFar;\n\nvoid main() {\n  if(!hasTexture1) {\n    gl_FragColor = vec4(vColor.rgb * lightWeighting, vColor.a);\n  } else {\n    gl_FragColor = vec4(texture2D(sampler1, vec2(vTexCoord.s, vTexCoord.t)).rgb * lightWeighting, 1.0);\n  }\n\n  if (enablePicking) {\n    gl_FragColor = vec4(pickColor, 1.0);\n  }\n\n  /* handle fog */\n  if (hasFog) {\n    float depth = gl_FragCoord.z / gl_FragCoord.w;\n    float fogFactor = smoothstep(fogNear, fogFar, depth);\n    gl_FragColor = mix(gl_FragColor, vec4(fogColor, gl_FragColor.w), fogFactor);\n  }\n}\n';
	var defaultUniforms = __webpack_require__(1049);
	
	var SHADERS = exports.SHADERS = {
	  vs: vs,
	  fs: fs,
	  defaultUniforms: defaultUniforms
	};
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVycy9pbmRleC5qcyJdLCJuYW1lcyI6WyJ2cyIsImZzIiwiZGVmYXVsdFVuaWZvcm1zIiwicmVxdWlyZSIsIlNIQURFUlMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7QUFFQTtBQUNBLElBQU1BLHNoREFBTjtBQUNBLElBQU1DLHk1QkFBTjtBQUNBLElBQU1DLGtCQUFrQkMsUUFBUSxvQkFBUixDQUF4Qjs7QUFFTyxJQUFNQyw0QkFBVTtBQUNyQkosUUFEcUI7QUFFckJDLFFBRnFCO0FBR3JCQztBQUhxQixDQUFoQiIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7cmVhZEZpbGVTeW5jfSBmcm9tICdmcyc7XG5pbXBvcnQge2pvaW59IGZyb20gJ3BhdGgnO1xuXG4vLyBEZWZhdWx0IFNoYWRlcnNcbmNvbnN0IHZzID0gcmVhZEZpbGVTeW5jKGpvaW4oX19kaXJuYW1lLCAnLi9kZWZhdWx0LnZzLmdsc2wnKSwgJ3V0ZjgnKTtcbmNvbnN0IGZzID0gcmVhZEZpbGVTeW5jKGpvaW4oX19kaXJuYW1lLCAnLi9kZWZhdWx0LmZzLmdsc2wnKSwgJ3V0ZjgnKTtcbmNvbnN0IGRlZmF1bHRVbmlmb3JtcyA9IHJlcXVpcmUoJy4vZGVmYXVsdC11bmlmb3JtcycpO1xuXG5leHBvcnQgY29uc3QgU0hBREVSUyA9IHtcbiAgdnMsXG4gIGZzLFxuICBkZWZhdWx0VW5pZm9ybXNcbn07XG4iXX0=

/***/ },
/* 1051 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.requestFile = requestFile;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Supports loading (requesting) assets with XHR (XmlHttpRequest)
	/* eslint-disable guard-for-in, complexity, no-try-catch */
	
	/* global XMLHttpRequest */
	function noop() {}
	
	var XHR_STATES = {
	  UNINITIALIZED: 0,
	  LOADING: 1,
	  LOADED: 2,
	  INTERACTIVE: 3,
	  COMPLETED: 4
	};
	
	var XHR = function () {
	  function XHR(_ref) {
	    var url = _ref.url,
	        _ref$path = _ref.path,
	        path = _ref$path === undefined ? null : _ref$path,
	        _ref$method = _ref.method,
	        method = _ref$method === undefined ? 'GET' : _ref$method,
	        _ref$asynchronous = _ref.asynchronous,
	        asynchronous = _ref$asynchronous === undefined ? true : _ref$asynchronous,
	        _ref$noCache = _ref.noCache,
	        noCache = _ref$noCache === undefined ? false : _ref$noCache,
	        _ref$sendAsBinary = _ref.sendAsBinary,
	        sendAsBinary = _ref$sendAsBinary === undefined ? false : _ref$sendAsBinary,
	        _ref$responseType = _ref.responseType,
	        responseType = _ref$responseType === undefined ? false : _ref$responseType,
	        _ref$onProgress = _ref.onProgress,
	        onProgress = _ref$onProgress === undefined ? noop : _ref$onProgress,
	        _ref$onError = _ref.onError,
	        onError = _ref$onError === undefined ? noop : _ref$onError,
	        _ref$onAbort = _ref.onAbort,
	        onAbort = _ref$onAbort === undefined ? noop : _ref$onAbort,
	        _ref$onComplete = _ref.onComplete,
	        onComplete = _ref$onComplete === undefined ? noop : _ref$onComplete;
	
	    _classCallCheck(this, XHR);
	
	    this.url = path ? path.join(path, url) : url;
	    this.method = method;
	    this.async = asynchronous;
	    this.noCache = noCache;
	    this.sendAsBinary = sendAsBinary;
	    this.responseType = responseType;
	
	    this.req = new XMLHttpRequest();
	
	    this.req.onload = function (e) {
	      return onComplete(e);
	    };
	    this.req.onerror = function (e) {
	      return onError(e);
	    };
	    this.req.onabort = function (e) {
	      return onAbort(e);
	    };
	    this.req.onprogress = function (e) {
	      if (e.lengthComputable) {
	        onProgress(e, Math.round(e.loaded / e.total * 100));
	      } else {
	        onProgress(e, -1);
	      }
	    };
	  }
	
	  _createClass(XHR, [{
	    key: 'setRequestHeader',
	    value: function setRequestHeader(header, value) {
	      this.req.setRequestHeader(header, value);
	      return this;
	    }
	
	    // /* eslint-disable max-statements */
	
	  }, {
	    key: 'sendAsync',
	    value: function sendAsync() {
	      var _this = this;
	
	      var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.body || null;
	
	      return new Promise(function (resolve, reject) {
	        try {
	          (function () {
	            var req = _this.req,
	                method = _this.method,
	                noCache = _this.noCache,
	                sendAsBinary = _this.sendAsBinary,
	                responseType = _this.responseType;
	
	
	            var url = noCache ? _this.url + (_this.url.indexOf('?') >= 0 ? '&' : '?') + Date.now() : _this.url;
	
	            req.open(method, url, _this.async);
	
	            if (responseType) {
	              req.responseType = responseType;
	            }
	
	            if (_this.async) {
	              req.onreadystatechange = function (e) {
	                if (req.readyState === XHR_STATES.COMPLETED) {
	                  if (req.status === 200) {
	                    resolve(req.responseType ? req.response : req.responseText);
	                  } else {
	                    reject(new Error(req.status + ': ' + url));
	                  }
	                }
	              };
	            }
	
	            if (sendAsBinary) {
	              req.sendAsBinary(body);
	            } else {
	              req.send(body);
	            }
	
	            if (!_this.async) {
	              if (req.status === 200) {
	                resolve(req.responseType ? req.response : req.responseText);
	              } else {
	                reject(new Error(req.status + ': ' + url));
	              }
	            }
	          })();
	        } catch (error) {
	          reject(error);
	        }
	      });
	    }
	    /* eslint-enable max-statements */
	
	  }]);
	
	  return XHR;
	}();
	
	function requestFile(opts) {
	  var xhr = new XHR(opts);
	  return xhr.sendAsync();
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _browserLoad = __webpack_require__(476);
	
	Object.defineProperty(exports, 'loadFile', {
	  enumerable: true,
	  get: function get() {
	    return _browserLoad.loadFile;
	  }
	});
	Object.defineProperty(exports, 'loadImage', {
	  enumerable: true,
	  get: function get() {
	    return _browserLoad.loadImage;
	  }
	});
	
	var _loadFiles = __webpack_require__(1053);
	
	Object.defineProperty(exports, 'loadFiles', {
	  enumerable: true,
	  get: function get() {
	    return _loadFiles.loadFiles;
	  }
	});
	Object.defineProperty(exports, 'loadImages', {
	  enumerable: true,
	  get: function get() {
	    return _loadFiles.loadImages;
	  }
	});
	Object.defineProperty(exports, 'loadTextures', {
	  enumerable: true,
	  get: function get() {
	    return _loadFiles.loadTextures;
	  }
	});
	Object.defineProperty(exports, 'loadProgram', {
	  enumerable: true,
	  get: function get() {
	    return _loadFiles.loadProgram;
	  }
	});
	Object.defineProperty(exports, 'loadModel', {
	  enumerable: true,
	  get: function get() {
	    return _loadFiles.loadModel;
	  }
	});
	Object.defineProperty(exports, 'parseModel', {
	  enumerable: true,
	  get: function get() {
	    return _loadFiles.parseModel;
	  }
	});
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pby9pbmRleC5qcyJdLCJuYW1lcyI6WyJsb2FkRmlsZSIsImxvYWRJbWFnZSIsImxvYWRGaWxlcyIsImxvYWRJbWFnZXMiLCJsb2FkVGV4dHVyZXMiLCJsb2FkUHJvZ3JhbSIsImxvYWRNb2RlbCIsInBhcnNlTW9kZWwiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O3dCQUNRQSxROzs7Ozs7d0JBQVVDLFM7Ozs7Ozs7OztzQkFDVkMsUzs7Ozs7O3NCQUFXQyxVOzs7Ozs7c0JBQVlDLFk7Ozs7OztzQkFDdkJDLFc7Ozs7OztzQkFBYUMsUzs7Ozs7O3NCQUFXQyxVIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQ2FsbCBhIHJlcXVpcmUgYmFzZWQgaGVscGVyIHRvIHNlbGVjdCBwbGF0Zm9ybSB0byBleHBvcnRcbmV4cG9ydCB7bG9hZEZpbGUsIGxvYWRJbWFnZX0gZnJvbSAnLi9icm93c2VyLWxvYWQnO1xuZXhwb3J0IHtsb2FkRmlsZXMsIGxvYWRJbWFnZXMsIGxvYWRUZXh0dXJlc30gZnJvbSAnLi9sb2FkLWZpbGVzJztcbmV4cG9ydCB7bG9hZFByb2dyYW0sIGxvYWRNb2RlbCwgcGFyc2VNb2RlbH0gZnJvbSAnLi9sb2FkLWZpbGVzJztcbiJdfQ==

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable guard-for-in, complexity, no-try-catch */
	
	
	exports.loadFiles = loadFiles;
	exports.loadImages = loadImages;
	exports.loadTextures = loadTextures;
	exports.loadProgram = loadProgram;
	exports.loadModel = loadModel;
	exports.parseModel = parseModel;
	
	var _assert = __webpack_require__(15);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _browserLoad = __webpack_require__(476);
	
	var _webgl = __webpack_require__(131);
	
	var _core = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function noop() {}
	
	/*
	 * Loads (Requests) multiple files asynchronously
	 */
	function loadFiles() {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var urls = opts.urls,
	      _opts$onProgress = opts.onProgress,
	      onProgress = _opts$onProgress === undefined ? noop : _opts$onProgress;
	
	  (0, _assert2.default)(urls.every(function (url) {
	    return typeof url === 'string';
	  }), 'loadImages: {urls} must be array of strings');
	  var count = 0;
	  return Promise.all(urls.map(function (url) {
	    var promise = (0, _browserLoad.loadFile)(Object.assign({ url: url }, opts));
	    promise.then(function (file) {
	      return onProgress({
	        progress: ++count / urls.length,
	        count: count,
	        total: urls.length,
	        url: url
	      });
	    });
	    return promise;
	  }));
	}
	
	/*
	 * Loads (requests) multiple images asynchronously
	 */
	function loadImages() {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var urls = opts.urls,
	      _opts$onProgress2 = opts.onProgress,
	      onProgress = _opts$onProgress2 === undefined ? noop : _opts$onProgress2;
	
	  (0, _assert2.default)(urls.every(function (url) {
	    return typeof url === 'string';
	  }), 'loadImages: {urls} must be array of strings');
	  var count = 0;
	  return Promise.all(urls.map(function (url) {
	    var promise = (0, _browserLoad.loadImage)(url);
	    promise.then(function (file) {
	      return onProgress({
	        progress: ++count / urls.length,
	        count: count,
	        total: urls.length,
	        url: url
	      });
	    });
	    return promise;
	  }));
	}
	
	function loadTextures(gl) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var urls = opts.urls,
	      _opts$onProgress3 = opts.onProgress,
	      onProgress = _opts$onProgress3 === undefined ? noop : _opts$onProgress3;
	
	  (0, _assert2.default)(urls.every(function (url) {
	    return typeof url === 'string';
	  }), 'loadTextures: {urls} must be array of strings');
	
	  return loadImages(Object.assign({ urls: urls, onProgress: onProgress }, opts)).then(function (images) {
	    return images.map(function (img, i) {
	      var params = Array.isArray(opts.parameters) ? opts.parameters[i] : opts.parameters;
	      params = params === undefined ? {} : params;
	      return new _webgl.Texture2D(gl, Object.assign({ id: urls[i] }, params, { data: img }));
	    });
	  });
	}
	
	function loadProgram(gl) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var vs = opts.vs,
	      fs = opts.fs,
	      _opts$onProgress4 = opts.onProgress,
	      onProgress = _opts$onProgress4 === undefined ? noop : _opts$onProgress4;
	
	  return loadFiles(Object.assign({ urls: [vs, fs], onProgress: onProgress }, opts)).then(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        vsText = _ref2[0],
	        fsText = _ref2[1];
	
	    return new _webgl.Program(gl, Object.assign({ vs: vsText, fs: fsText }, opts));
	  });
	}
	
	// Loads a simple JSON format
	function loadModel(gl) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var url = opts.url,
	      _opts$onProgress5 = opts.onProgress,
	      onProgress = _opts$onProgress5 === undefined ? noop : _opts$onProgress5;
	
	  return loadFiles(Object.assign({ urls: [url], onProgress: onProgress }, opts)).then(function (_ref3) {
	    var _ref4 = _slicedToArray(_ref3, 1),
	        file = _ref4[0];
	
	    return parseModel(gl, Object.assign({ file: file }, opts));
	  });
	}
	
	function parseModel(gl) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var file = opts.file,
	      _opts$program = opts.program,
	      program = _opts$program === undefined ? new _webgl.Program(gl) : _opts$program;
	
	  var json = typeof file === 'string' ? parseJSON(file) : file;
	  // Remove any attributes so that we can create a geometry
	  // TODO - change format to put these in geometry sub object?
	  var attributes = {};
	  var modelOptions = {};
	  for (var key in json) {
	    var value = json[key];
	    if (Array.isArray(value)) {
	      attributes[key] = key === 'indices' ? new Uint16Array(value) : new Float32Array(value);
	    } else {
	      modelOptions[key] = value;
	    }
	  }
	
	  return new _core.Model(Object.assign({ program: program, geometry: new _core.Geometry({ attributes: attributes }) }, modelOptions, opts));
	}
	
	function parseJSON(file) {
	  try {
	    return JSON.parse(file);
	  } catch (error) {
	    throw new Error('Failed to parse JSON: ' + error);
	  }
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _core = __webpack_require__(105);
	
	var _geometry = __webpack_require__(84);
	
	var _webgl = __webpack_require__(131);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ClipSpaceQuad
	
	
	var CLIPSPACE_QUAD_VERTEX_SHADER = 'attribute vec2 aClipSpacePosition;\nattribute vec2 aTexCoord;\nattribute vec2 aCoordinate;\n\nvarying vec2 position;\nvarying vec2 coordinate;\nvarying vec2 uv;\n\nvoid main(void) {\n  gl_Position = vec4(aClipSpacePosition, 0., 1.);\n  position = aClipSpacePosition;\n  coordinate = aCoordinate;\n  uv = aTexCoord;\n}\n';
	
	/* eslint-disable indent, no-multi-spaces */
	var POSITIONS = [-1, -1, 1, -1, -1, 1, 1, 1
	// -1, -1,
	//  1, -1,
	//  1,  1,
	// -1, -1,
	//  1,  1,
	// -1,  1
	];
	
	var TEX_COORDS = POSITIONS.map(function (coord) {
	  return coord === -1 ? 0 : coord;
	});
	/* eslint-enable indent, no-multi-spaces */
	
	var ClipSpaceQuad = function (_Model) {
	  _inherits(ClipSpaceQuad, _Model);
	
	  function ClipSpaceQuad(opts) {
	    _classCallCheck(this, ClipSpaceQuad);
	
	    var _this = _possibleConstructorReturn(this, (ClipSpaceQuad.__proto__ || Object.getPrototypeOf(ClipSpaceQuad)).call(this, Object.assign({}, opts, {
	      vs: CLIPSPACE_QUAD_VERTEX_SHADER,
	      geometry: new _geometry.Geometry({
	        drawMode: _webgl.GL.TRIANGLE_STRIP,
	        attributes: {
	          aClipSpacePosition: {
	            value: new Float32Array(POSITIONS),
	            size: 2
	          },
	          aTexCoord: {
	            value: new Float32Array(TEX_COORDS),
	            size: 2
	          },
	          aCoordinate: {
	            value: new Float32Array(TEX_COORDS),
	            size: 2
	          }
	        }
	      })
	    })));
	
	    _this.setVertexCount(4);
	    return _this;
	  }
	
	  return ClipSpaceQuad;
	}(_core.Model);
	
	exports.default = ClipSpaceQuad;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(84);
	
	var _core = __webpack_require__(105);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cone = function (_Model) {
	  _inherits(Cone, _Model);
	
	  function Cone() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Cone);
	
	    return _possibleConstructorReturn(this, (Cone.__proto__ || Object.getPrototypeOf(Cone)).call(this, Object.assign({}, opts, { geometry: new _geometry.ConeGeometry(opts) })));
	  }
	
	  return Cone;
	}(_core.Model);
	
	exports.default = Cone;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvY29uZS5qcyJdLCJuYW1lcyI6WyJDb25lIiwib3B0cyIsIk9iamVjdCIsImFzc2lnbiIsImdlb21ldHJ5Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7Ozs7O0lBRXFCQSxJOzs7QUFDbkIsa0JBQXVCO0FBQUEsUUFBWEMsSUFBVyx1RUFBSixFQUFJOztBQUFBOztBQUFBLHVHQUNmQyxPQUFPQyxNQUFQLENBQWMsRUFBZCxFQUFrQkYsSUFBbEIsRUFBd0IsRUFBQ0csVUFBVSwyQkFBaUJILElBQWpCLENBQVgsRUFBeEIsQ0FEZTtBQUV0Qjs7Ozs7a0JBSGtCRCxJIiwiZmlsZSI6ImNvbmUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge0NvbmVHZW9tZXRyeX0gZnJvbSAnLi4vZ2VvbWV0cnknO1xuaW1wb3J0IHtNb2RlbH0gZnJvbSAnLi4vY29yZSc7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIENvbmUgZXh0ZW5kcyBNb2RlbCB7XG4gIGNvbnN0cnVjdG9yKG9wdHMgPSB7fSkge1xuICAgIHN1cGVyKE9iamVjdC5hc3NpZ24oe30sIG9wdHMsIHtnZW9tZXRyeTogbmV3IENvbmVHZW9tZXRyeShvcHRzKX0pKTtcbiAgfVxufVxuIl19

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(84);
	
	var _core = __webpack_require__(105);
	
	var _utils = __webpack_require__(30);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cube = function (_Model) {
	  _inherits(Cube, _Model);
	
	  function Cube() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Cube);
	
	    var _opts$id = opts.id,
	        id = _opts$id === undefined ? (0, _utils.uid)('cube') : _opts$id;
	    return _possibleConstructorReturn(this, (Cube.__proto__ || Object.getPrototypeOf(Cube)).call(this, Object.assign({}, opts, { id: id, geometry: new _geometry.CubeGeometry(opts) })));
	  }
	
	  return Cube;
	}(_core.Model);
	
	exports.default = Cube;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvY3ViZS5qcyJdLCJuYW1lcyI6WyJDdWJlIiwib3B0cyIsImlkIiwiT2JqZWN0IiwiYXNzaWduIiwiZ2VvbWV0cnkiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7Ozs7Ozs7SUFFcUJBLEk7OztBQUNuQixrQkFBdUI7QUFBQSxRQUFYQyxJQUFXLHVFQUFKLEVBQUk7O0FBQUE7O0FBQUEsbUJBQ01BLElBRE4sQ0FDZEMsRUFEYztBQUFBLFFBQ2RBLEVBRGMsNEJBQ1QsZ0JBQUksTUFBSixDQURTO0FBQUEsdUdBRWZDLE9BQU9DLE1BQVAsQ0FBYyxFQUFkLEVBQWtCSCxJQUFsQixFQUF3QixFQUFDQyxNQUFELEVBQUtHLFVBQVUsMkJBQWlCSixJQUFqQixDQUFmLEVBQXhCLENBRmU7QUFHdEI7Ozs7O2tCQUprQkQsSSIsImZpbGUiOiJjdWJlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtDdWJlR2VvbWV0cnl9IGZyb20gJy4uL2dlb21ldHJ5JztcbmltcG9ydCB7TW9kZWx9IGZyb20gJy4uL2NvcmUnO1xuaW1wb3J0IHt1aWR9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgQ3ViZSBleHRlbmRzIE1vZGVsIHtcbiAgY29uc3RydWN0b3Iob3B0cyA9IHt9KSB7XG4gICAgY29uc3Qge2lkID0gdWlkKCdjdWJlJyl9ID0gb3B0cztcbiAgICBzdXBlcihPYmplY3QuYXNzaWduKHt9LCBvcHRzLCB7aWQsIGdlb21ldHJ5OiBuZXcgQ3ViZUdlb21ldHJ5KG9wdHMpfSkpO1xuICB9XG59XG4iXX0=

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(84);
	
	var _model = __webpack_require__(212);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cylinder = function (_Model) {
	  _inherits(Cylinder, _Model);
	
	  function Cylinder() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Cylinder);
	
	    return _possibleConstructorReturn(this, (Cylinder.__proto__ || Object.getPrototypeOf(Cylinder)).call(this, Object.assign({}, opts, { geometry: new _geometry.CylinderGeometry(opts) })));
	  }
	
	  return Cylinder;
	}(_model2.default);
	
	exports.default = Cylinder;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvY3lsaW5kZXIuanMiXSwibmFtZXMiOlsiQ3lsaW5kZXIiLCJvcHRzIiwiT2JqZWN0IiwiYXNzaWduIiwiZ2VvbWV0cnkiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7Ozs7Ozs7Ozs7O0lBRXFCQSxROzs7QUFDbkIsc0JBQXVCO0FBQUEsUUFBWEMsSUFBVyx1RUFBSixFQUFJOztBQUFBOztBQUFBLCtHQUNmQyxPQUFPQyxNQUFQLENBQWMsRUFBZCxFQUFrQkYsSUFBbEIsRUFBd0IsRUFBQ0csVUFBVSwrQkFBcUJILElBQXJCLENBQVgsRUFBeEIsQ0FEZTtBQUV0Qjs7Ozs7a0JBSGtCRCxRIiwiZmlsZSI6ImN5bGluZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtDeWxpbmRlckdlb21ldHJ5fSBmcm9tICcuLi9nZW9tZXRyeSc7XG5pbXBvcnQgTW9kZWwgZnJvbSAnLi4vY29yZS9tb2RlbCc7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEN5bGluZGVyIGV4dGVuZHMgTW9kZWwge1xuICBjb25zdHJ1Y3RvcihvcHRzID0ge30pIHtcbiAgICBzdXBlcihPYmplY3QuYXNzaWduKHt9LCBvcHRzLCB7Z2VvbWV0cnk6IG5ldyBDeWxpbmRlckdlb21ldHJ5KG9wdHMpfSkpO1xuICB9XG59XG4iXX0=

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _core = __webpack_require__(105);
	
	var _geometry = __webpack_require__(84);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IcoSphere = function (_Model) {
	  _inherits(IcoSphere, _Model);
	
	  function IcoSphere() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, IcoSphere);
	
	    return _possibleConstructorReturn(this, (IcoSphere.__proto__ || Object.getPrototypeOf(IcoSphere)).call(this, Object.assign({}, opts, { geometry: new _geometry.IcoSphereGeometry(opts) })));
	  }
	
	  return IcoSphere;
	}(_core.Model);
	
	exports.default = IcoSphere;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvaWNvLXNwaGVyZS5qcyJdLCJuYW1lcyI6WyJJY29TcGhlcmUiLCJvcHRzIiwiT2JqZWN0IiwiYXNzaWduIiwiZ2VvbWV0cnkiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7Ozs7Ozs7SUFFcUJBLFM7OztBQUNuQix1QkFBdUI7QUFBQSxRQUFYQyxJQUFXLHVFQUFKLEVBQUk7O0FBQUE7O0FBQUEsaUhBQ2ZDLE9BQU9DLE1BQVAsQ0FBYyxFQUFkLEVBQWtCRixJQUFsQixFQUF3QixFQUFDRyxVQUFVLGdDQUFzQkgsSUFBdEIsQ0FBWCxFQUF4QixDQURlO0FBRXRCOzs7OztrQkFIa0JELFMiLCJmaWxlIjoiaWNvLXNwaGVyZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7TW9kZWx9IGZyb20gJy4uL2NvcmUnO1xuaW1wb3J0IHtJY29TcGhlcmVHZW9tZXRyeX0gZnJvbSAnLi4vZ2VvbWV0cnknO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBJY29TcGhlcmUgZXh0ZW5kcyBNb2RlbCB7XG4gIGNvbnN0cnVjdG9yKG9wdHMgPSB7fSkge1xuICAgIHN1cGVyKE9iamVjdC5hc3NpZ24oe30sIG9wdHMsIHtnZW9tZXRyeTogbmV3IEljb1NwaGVyZUdlb21ldHJ5KG9wdHMpfSkpO1xuICB9XG59XG4iXX0=

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(84);
	
	var _model = __webpack_require__(212);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _utils = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Plane = function (_Model) {
	  _inherits(Plane, _Model);
	
	  function Plane() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Plane);
	
	    var _opts$id = opts.id,
	        id = _opts$id === undefined ? (0, _utils.uid)('plane') : _opts$id;
	    return _possibleConstructorReturn(this, (Plane.__proto__ || Object.getPrototypeOf(Plane)).call(this, Object.assign({}, opts, { id: id, geometry: new _geometry.PlaneGeometry(opts) })));
	  }
	
	  return Plane;
	}(_model2.default);
	
	exports.default = Plane;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvcGxhbmUuanMiXSwibmFtZXMiOlsiUGxhbmUiLCJvcHRzIiwiaWQiLCJPYmplY3QiLCJhc3NpZ24iLCJnZW9tZXRyeSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUNBOzs7O0FBQ0E7Ozs7Ozs7Ozs7SUFFcUJBLEs7OztBQUNuQixtQkFBdUI7QUFBQSxRQUFYQyxJQUFXLHVFQUFKLEVBQUk7O0FBQUE7O0FBQUEsbUJBQ09BLElBRFAsQ0FDZEMsRUFEYztBQUFBLFFBQ2RBLEVBRGMsNEJBQ1QsZ0JBQUksT0FBSixDQURTO0FBQUEseUdBRWZDLE9BQU9DLE1BQVAsQ0FBYyxFQUFkLEVBQWtCSCxJQUFsQixFQUF3QixFQUFDQyxNQUFELEVBQUtHLFVBQVUsNEJBQWtCSixJQUFsQixDQUFmLEVBQXhCLENBRmU7QUFHdEI7Ozs7O2tCQUprQkQsSyIsImZpbGUiOiJwbGFuZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7UGxhbmVHZW9tZXRyeX0gZnJvbSAnLi4vZ2VvbWV0cnknO1xuaW1wb3J0IE1vZGVsIGZyb20gJy4uL2NvcmUvbW9kZWwnO1xuaW1wb3J0IHt1aWR9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgUGxhbmUgZXh0ZW5kcyBNb2RlbCB7XG4gIGNvbnN0cnVjdG9yKG9wdHMgPSB7fSkge1xuICAgIGNvbnN0IHtpZCA9IHVpZCgncGxhbmUnKX0gPSBvcHRzO1xuICAgIHN1cGVyKE9iamVjdC5hc3NpZ24oe30sIG9wdHMsIHtpZCwgZ2VvbWV0cnk6IG5ldyBQbGFuZUdlb21ldHJ5KG9wdHMpfSkpO1xuICB9XG59XG4iXX0=

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _core = __webpack_require__(105);
	
	var _geometry = __webpack_require__(84);
	
	var _utils = __webpack_require__(30);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sphere = function (_Model) {
	  _inherits(Sphere, _Model);
	
	  function Sphere() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Sphere);
	
	    var _opts$id = opts.id,
	        id = _opts$id === undefined ? (0, _utils.uid)('sphere') : _opts$id;
	    return _possibleConstructorReturn(this, (Sphere.__proto__ || Object.getPrototypeOf(Sphere)).call(this, Object.assign({}, opts, { id: id, geometry: new _geometry.SphereGeometry(opts) })));
	  }
	
	  return Sphere;
	}(_core.Model);
	
	exports.default = Sphere;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvc3BoZXJlLmpzIl0sIm5hbWVzIjpbIlNwaGVyZSIsIm9wdHMiLCJpZCIsIk9iamVjdCIsImFzc2lnbiIsImdlb21ldHJ5Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7O0FBQ0E7Ozs7Ozs7O0lBRXFCQSxNOzs7QUFDbkIsb0JBQXVCO0FBQUEsUUFBWEMsSUFBVyx1RUFBSixFQUFJOztBQUFBOztBQUFBLG1CQUNRQSxJQURSLENBQ2RDLEVBRGM7QUFBQSxRQUNkQSxFQURjLDRCQUNULGdCQUFJLFFBQUosQ0FEUztBQUFBLDJHQUVmQyxPQUFPQyxNQUFQLENBQWMsRUFBZCxFQUFrQkgsSUFBbEIsRUFBd0IsRUFBQ0MsTUFBRCxFQUFLRyxVQUFVLDZCQUFtQkosSUFBbkIsQ0FBZixFQUF4QixDQUZlO0FBR3RCOzs7OztrQkFKa0JELE0iLCJmaWxlIjoic3BoZXJlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtNb2RlbH0gZnJvbSAnLi4vY29yZSc7XG5pbXBvcnQge1NwaGVyZUdlb21ldHJ5fSBmcm9tICcuLi9nZW9tZXRyeSc7XG5pbXBvcnQge3VpZH0gZnJvbSAnLi4vdXRpbHMnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBTcGhlcmUgZXh0ZW5kcyBNb2RlbCB7XG4gIGNvbnN0cnVjdG9yKG9wdHMgPSB7fSkge1xuICAgIGNvbnN0IHtpZCA9IHVpZCgnc3BoZXJlJyl9ID0gb3B0cztcbiAgICBzdXBlcihPYmplY3QuYXNzaWduKHt9LCBvcHRzLCB7aWQsIGdlb21ldHJ5OiBuZXcgU3BoZXJlR2VvbWV0cnkob3B0cyl9KSk7XG4gIH1cbn1cbiJdfQ==

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _geometry = __webpack_require__(84);
	
	var _core = __webpack_require__(105);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TruncatedCone = function (_Model) {
	  _inherits(TruncatedCone, _Model);
	
	  function TruncatedCone() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, TruncatedCone);
	
	    return _possibleConstructorReturn(this, (TruncatedCone.__proto__ || Object.getPrototypeOf(TruncatedCone)).call(this, Object.assign({}, opts, { geometry: new _geometry.TruncatedConeGeometry(opts) })));
	  }
	
	  return TruncatedCone;
	}(_core.Model);
	
	exports.default = TruncatedCone;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvdHJ1bmNhdGVkLWNvbmUuanMiXSwibmFtZXMiOlsiVHJ1bmNhdGVkQ29uZSIsIm9wdHMiLCJPYmplY3QiLCJhc3NpZ24iLCJnZW9tZXRyeSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUNBOzs7Ozs7OztJQUVxQkEsYTs7O0FBQ25CLDJCQUF1QjtBQUFBLFFBQVhDLElBQVcsdUVBQUosRUFBSTs7QUFBQTs7QUFBQSx5SEFDZkMsT0FBT0MsTUFBUCxDQUFjLEVBQWQsRUFBa0JGLElBQWxCLEVBQXdCLEVBQUNHLFVBQVUsb0NBQTBCSCxJQUExQixDQUFYLEVBQXhCLENBRGU7QUFFdEI7Ozs7O2tCQUhrQkQsYSIsImZpbGUiOiJ0cnVuY2F0ZWQtY29uZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7VHJ1bmNhdGVkQ29uZUdlb21ldHJ5fSBmcm9tICcuLi9nZW9tZXRyeSc7XG5pbXBvcnQge01vZGVsfSBmcm9tICcuLi9jb3JlJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVHJ1bmNhdGVkQ29uZSBleHRlbmRzIE1vZGVsIHtcbiAgY29uc3RydWN0b3Iob3B0cyA9IHt9KSB7XG4gICAgc3VwZXIoT2JqZWN0LmFzc2lnbih7fSwgb3B0cywge2dlb21ldHJ5OiBuZXcgVHJ1bmNhdGVkQ29uZUdlb21ldHJ5KG9wdHMpfSkpO1xuICB9XG59XG4iXX0=

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkArguments = checkArguments;
	exports.validateVector2 = validateVector2;
	exports.checkVector2 = checkVector2;
	exports.validateVector3 = validateVector3;
	exports.checkVector3 = checkVector3;
	exports.validateVector4 = validateVector4;
	exports.checkVector4 = checkVector4;
	exports.validateQuaternion = validateQuaternion;
	exports.checkQuaternion = checkQuaternion;
	exports.validateMatrix2 = validateMatrix2;
	exports.checkMatrix2 = checkMatrix2;
	exports.validateMatrix2d = validateMatrix2d;
	exports.checkMatrix2d = checkMatrix2d;
	exports.validateMatrix3 = validateMatrix3;
	exports.checkMatrix3 = checkMatrix3;
	exports.validateMatrix4 = validateMatrix4;
	exports.checkMatrix4 = checkMatrix4;
	
	var _glMatrix = __webpack_require__(55);
	
	function checkArguments() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  for (var i = 0; i < args.length; ++i) {
	    if (args[i] === undefined) {
	      throw new Error('Invalid math argument');
	    }
	  }
	}
	
	function validateVector2(v) {
	  return v.length === 2 && Number.isFinite(v[0]) && Number.isFinite(v[1]);
	}
	
	function checkVector2(v) {
	  if (_glMatrix.glMatrix.debug && !validateVector2(v)) {
	    throw new Error('Invalid Vector2');
	  }
	}
	
	function validateVector3(v) {
	  return v.length === 3 && Number.isFinite(v[0]) && Number.isFinite(v[1]) && Number.isFinite(v[2]);
	}
	
	function checkVector3(v) {
	  if (_glMatrix.glMatrix.debug && !validateVector3(v)) {
	    throw new Error('Invalid Vector3');
	  }
	}
	
	function validateVector4(v) {
	  return v.length === 4 && Number.isFinite(v[0]) && Number.isFinite(v[1]) && Number.isFinite(v[2]) && Number.isFinite(v[3]);
	}
	
	function checkVector4(v) {
	  if (_glMatrix.glMatrix.debug && !validateVector4(v)) {
	    throw new Error('Invalid Vector4');
	  }
	}
	
	function validateQuaternion(q) {
	  return q.length === 4 && Number.isFinite(q[0]) && Number.isFinite(q[1]) && Number.isFinite(q[2]) && Number.isFinite(q[3]);
	}
	
	function checkQuaternion(q) {
	  if (_glMatrix.glMatrix.debug && !validateQuaternion(q)) {
	    throw new Error('Invalid Quaternion');
	  }
	}
	
	function validateMatrix2(m) {
	  return m.length === 4 && Number.isFinite(m[0]) && Number.isFinite(m[1]) && Number.isFinite(m[2]) && Number.isFinite(m[3]);
	}
	
	function checkMatrix2(m) {
	  if (_glMatrix.glMatrix.debug && !validateMatrix2(m)) {
	    throw new Error('Invalid Matrix2');
	  }
	}
	
	function validateMatrix2d(m) {
	  return m.length === 6 && Number.isFinite(m[0]) && Number.isFinite(m[1]) && Number.isFinite(m[2]) && Number.isFinite(m[3]) && Number.isFinite(m[4]) && Number.isFinite(m[5]);
	}
	
	function checkMatrix2d(m) {
	  if (_glMatrix.glMatrix.debug && !validateMatrix2d(m)) {
	    throw new Error('Invalid Matrix2d');
	  }
	}
	
	function validateMatrix3(m) {
	  return m.length === 9 && Number.isFinite(m[0]) && Number.isFinite(m[1]) && Number.isFinite(m[2]) && Number.isFinite(m[3]) && Number.isFinite(m[4]) && Number.isFinite(m[5]) && Number.isFinite(m[6]) && Number.isFinite(m[7]) && Number.isFinite(m[8]);
	}
	
	function checkMatrix3(m) {
	  if (_glMatrix.glMatrix.debug && !validateMatrix3(m)) {
	    throw new Error('Invalid Matrix3');
	  }
	}
	
	function validateMatrix4(m) {
	  return m.length === 16 && Number.isFinite(m[0]) && Number.isFinite(m[1]) && Number.isFinite(m[2]) && Number.isFinite(m[3]) && Number.isFinite(m[4]) && Number.isFinite(m[5]) && Number.isFinite(m[6]) && Number.isFinite(m[7]) && Number.isFinite(m[8]) && Number.isFinite(m[9]) && Number.isFinite(m[10]) && Number.isFinite(m[11]) && Number.isFinite(m[12]) && Number.isFinite(m[13]) && Number.isFinite(m[14]) && Number.isFinite(m[15]);
	}
	
	function checkMatrix4(m) {
	  if (_glMatrix.glMatrix.debug && !validateMatrix4(m)) {
	    throw new Error('Invalid Matrix4');
	  }
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageLoadPromise = exports.isPageLoaded = undefined;
	
	var _isBrowser = __webpack_require__(299);
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isPageLoaded = exports.isPageLoaded = false; /* global window, document */
	var pageLoadPromise = exports.pageLoadPromise = _isBrowser2.default ? new Promise(function (resolve, reject) {
	  window.onload = function () {
	    exports.isPageLoaded = isPageLoaded = true;
	    resolve(document);
	  };
	}) : Promise.resolve({});
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9icm93c2VyLXV0aWxzLmpzIl0sIm5hbWVzIjpbImlzUGFnZUxvYWRlZCIsInBhZ2VMb2FkUHJvbWlzZSIsIlByb21pc2UiLCJyZXNvbHZlIiwicmVqZWN0Iiwid2luZG93Iiwib25sb2FkIiwiZG9jdW1lbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7Ozs7O0FBRU8sSUFBSUEsc0NBQWUsS0FBbkIsQyxDQUhQO0FBS08sSUFBTUMsNENBQWtCLHNCQUM3QixJQUFJQyxPQUFKLENBQVksVUFBQ0MsT0FBRCxFQUFVQyxNQUFWLEVBQXFCO0FBQy9CQyxTQUFPQyxNQUFQLEdBQWdCLFlBQU07QUFDcEIsWUFMS04sWUFLTCxrQkFBZSxJQUFmO0FBQ0FHLFlBQVFJLFFBQVI7QUFDRCxHQUhEO0FBSUQsQ0FMRCxDQUQ2QixHQU83QkwsUUFBUUMsT0FBUixDQUFnQixFQUFoQixDQVBLIiwiZmlsZSI6ImJyb3dzZXItdXRpbHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBnbG9iYWwgd2luZG93LCBkb2N1bWVudCAqL1xuaW1wb3J0IGlzQnJvd3NlciBmcm9tICcuL2lzLWJyb3dzZXInO1xuXG5leHBvcnQgbGV0IGlzUGFnZUxvYWRlZCA9IGZhbHNlO1xuXG5leHBvcnQgY29uc3QgcGFnZUxvYWRQcm9taXNlID0gaXNCcm93c2VyID9cbiAgbmV3IFByb21pc2UoKHJlc29sdmUsIHJlamVjdCkgPT4ge1xuICAgIHdpbmRvdy5vbmxvYWQgPSAoKSA9PiB7XG4gICAgICBpc1BhZ2VMb2FkZWQgPSB0cnVlO1xuICAgICAgcmVzb2x2ZShkb2N1bWVudCk7XG4gICAgfTtcbiAgfSkgOlxuICBQcm9taXNlLnJlc29sdmUoe30pO1xuXG4iXX0=

/***/ },
/* 1064 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.promisify = promisify;
	/**
	 * Converts a function that accepts a node style (err, result) callback
	 * as the last argument into a function that takes the same arguments
	 * and returns a promise that resolves or rejects with the values provided
	 * by the original callback
	 * @param {Function} func - function to wrap
	 * @return {Function} promisified function
	 */
	/* eslint-disable no-try-catch */
	function promisify(func) {
	  return function promisifiedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return new Promise(function (resolve, reject) {
	      function callback(error, data) {
	        try {
	          if (error) {
	            reject(error);
	          } else {
	            resolve(data);
	          }
	        } catch (e) {
	          reject(e);
	        }
	      }
	      func.apply(undefined, args.concat([callback]));
	    });
	  };
	}
	/* eslint-enable no-try-catch */
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1065 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.splat = splat;
	exports.noop = noop;
	exports.uid = uid;
	exports.merge = merge;
	/**
	 * Wraps the argument in an array if it is not one.
	 * @param {object} a - The object to wrap.
	 * @return {Array} array
	 **/
	function splat(a) {
	  return a ? Array.isArray(a) ? a : [a] : [];
	}
	
	/**
	* Provides a standard noop function.
	**/
	function noop() {}
	
	var uidCounters = {};
	
	/**
	 * Returns a UID.
	 * @param {String} id= - Identifier base name
	 * @return {number} uid
	 **/
	function uid() {
	  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
	
	  uidCounters[id] = uidCounters[id] || 1;
	  var count = uidCounters[id]++;
	  return id + '-' + count;
	}
	
	/**
	 * Merge multiple objects into one.
	 * @param {...object} objects - The objects to merge.
	 * @return {object} object
	 **/
	function merge(objects) {
	  var mix = {};
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    var object = arguments[i];
	    if (!object || object.constructor.name !== 'Object') {
	      /* eslint-disable no-continue */
	      continue;
	    }
	    for (var key in object) {
	      var op = object[key];
	      var mp = mix[key];
	      if (mp && op.constructor.name === 'Object' && mp.constructor.name === 'Object') {
	        mix[key] = merge(mp, op);
	      } else {
	        mix[key] = detach(op);
	      }
	    }
	  }
	  return mix;
	}
	
	/**
	 * Internal function for duplicating an object.
	 * @param {object} elem - The object to recursively duplicate.
	 * @return {object} object
	 **/
	function detach(elem) {
	  var t = elem.constructor.name;
	  var ans = void 0;
	  if (t === 'Object') {
	    ans = {};
	    for (var p in elem) {
	      ans[p] = detach(elem[p]);
	    }
	  } else if (t === 'Array') {
	    ans = [];
	    for (var i = 0, l = elem.length; i < l; i++) {
	      ans[i] = detach(elem[i]);
	    }
	  } else {
	    ans = elem;
	  }
	
	  return ans;
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getShaderName = getShaderName;
	exports.formatGLSLCompilerError = formatGLSLCompilerError;
	
	var _webglConstants = __webpack_require__(162);
	
	var _webglConstants2 = _interopRequireDefault(_webglConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import shaderName from 'glsl-shader-name';
	// replace with regexp
	function getShaderName(shader) {
	  return 'unnamed';
	}
	
	/**
	 * Formats a GLSL shader compiler error and generates a string
	 * showing the source code around the error.
	 *
	 * From https://github.com/wwwtyro/gl-format-compiler-error (public domain)
	 *
	 * @param {String} errLog - error log from gl.getShaderInfoLog
	 * @param {String} src - original shader source code
	 * @param {Number} shaderType - shader type (GL constant)
	 * @return {String} - Formatted strings has the error marked inline with src.
	 */
	/* eslint-disable no-continue, max-statements */
	function formatGLSLCompilerError(errLog, src, shaderType) {
	  var errorStrings = errLog.split(/\r?\n/);
	  var errors = {};
	
	  // Parse the error - note: browser and driver dependent
	  for (var i = 0; i < errorStrings.length; i++) {
	    var errorString = errorStrings[i];
	    if (errorString.length <= 1) {
	      continue;
	    }
	    var lineNo = parseInt(errorString.split(':')[2], 10);
	    if (isNaN(lineNo)) {
	      return 'Could not parse GLSL compiler error: ' + errLog;
	    }
	    errors[lineNo] = errorString;
	  }
	
	  // Format the error inline with the code
	  var message = '';
	  var lines = addLineNumbers(src).split(/\r?\n/);
	
	  for (var _i = 0; _i < lines.length; _i++) {
	    var line = lines[_i];
	    if (!errors[_i + 3] && !errors[_i + 2] && !errors[_i + 1]) {
	      continue;
	    }
	    message += line + '\n';
	    if (errors[_i + 1]) {
	      var e = errors[_i + 1];
	      e = e.substr(e.split(':', 3).join(':').length + 1).trim();
	      message += '^^^ ' + e + '\n\n';
	    }
	  }
	
	  var name = getShaderName(src) || 'unknown name';
	  var type = getShaderTypeName(shaderType);
	  return 'GLSL error in ' + type + ' shader ' + name + '\n' + message;
	}
	
	/**
	 * Prepends line numbers to each line of a string.
	 * The line numbers will be left-padded with spaces to ensure an
	 * aligned layout when rendered using monospace fonts.
	 *
	 * Adapted from https://github.com/Jam3/add-line-numbers, MIT license
	 *
	 * @param {String} string - multi-line string to add line numbers to
	 * @param {Number} start=1 - number of spaces to add
	 * @param {String} delim =': ' - injected between line number and original line
	 * @return {String} string - The original string with line numbers added
	 */
	function addLineNumbers(string) {
	  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var delim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ': ';
	
	  var lines = string.split(/\r?\n/);
	  var maxDigits = String(lines.length + start - 1).length;
	  return lines.map(function (line, i) {
	    var lineNumber = i + start;
	    var digits = String(lineNumber).length;
	    var prefix = padLeft(lineNumber, maxDigits - digits);
	    return prefix + delim + line;
	  }).join('\n');
	}
	
	/**
	 * Pads a string with a number of spaces (space characters) to the left
	 * @param {String} string - string to pad
	 * @param {Number} digits - number of spaces to add
	 * @return {String} string - The padded string
	 */
	function padLeft(string, digits) {
	  var result = '';
	  for (var i = 0; i < digits; ++i) {
	    result += ' ';
	  }
	  return '' + result + string;
	}
	
	function getShaderTypeName(type) {
	  switch (type) {
	    case _webglConstants2.default.FRAGMENT_SHADER:
	      return 'fragment';
	    case _webglConstants2.default.VERTEX_SHADER:
	      return 'vertex';
	    default:
	      return 'unknown type';
	  }
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(1071);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(1069);
		function inc(arr,val){
			for(var i=0;i<arr.length;i++)
				arr[i]+=val;
			return arr;
		}
		var token=['sin','cos','tan','pi','(',')','P','C',
			  'asin','acos','atan','7','8','9','int',
			  'cosh','acosh','ln','^','root','4','5','6','/','!',
			  'tanh','atanh','Mod','1','2','3','*',
			  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
		var show=['sin','cos','tan','&pi;','(',')','P','C',
			'asin','acos','atan','7','8','9','Int',
			'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
			'tanh','atanh',' Mod ','1','2','3','&times;',
			'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
		var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
			Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
			Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
			Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
			Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
		var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
		var type=[0,0,0,3,4,5,10,10,
			0,0,0,1,1,1,0,
			0,0,0,10,0,1,1,1,2,7,
			0,0,2,1,1,1,2,
			0,0,3,0,1,6,9,9,11,12,13,12,8];
		 /*
		0 : function with syntax function_name(Maths_exp)
		1 : numbers
		2 : binary operators like * / Mod left associate and same precedence
		3 : Math constant values like e,pi,Cruncher ans
		4 : opening bracket
		5 : closing bracket
		6 : decimal
		7 : function with syntax (Math_exp)function_name
		8: function with syntax function_name(Math_exp1,Math_exp2)
		9 : binary operator like +,-
		10: binary operator like P C or ^
		11: ,
		12: function with , seperated three parameters
		13: variable of Sigma function
		 */
		var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
		type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
		type_1={0:true,3:true,4:true,8:true,12:true,13:true},
		empty={},
		type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
		type6={1:true},
		newAr=[[],
				["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
				["pi","ln","Pi"],
				["sin","cos","tan","Del","int","Mod","log","pow"],
				["asin","acos","atan","cosh","root","tanh","sinh"],
				["acosh","atanh","asinh","Sigma"]];
		function match(str1,str2,i,x){
			for(var f=0;f<x;f++){
				if (str1[i+f]!==str2[f])
					return false;
			}
			return true;
		}
		Mexp.addToken=function(tokens){
			for(i=0;i<tokens.length;i++){
				x=tokens[i].token.length;
				var temp=-1;
	
				//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on
	
				if (x<newAr.length)	//match to check if token is really huge and not existing
									//if not checked it will break in next line as undefined index
					for(y=0;y<newAr[x].length;y++){
						if (tokens[i].token===newAr[x][y]){
							temp=token.indexOf(newAr[x][y]);
							break;
						}
					}
				if (temp===-1) {
					token.push(tokens[i].token);
					type.push(tokens[i].type);
					if(newAr.length<=tokens[i].token.length)
						newAr[tokens[i].token.length]=[];
					newAr[tokens[i].token.length].push(tokens[i].token);
					eva.push(tokens[i].value);
					show.push(tokens[i].show);
				}
				else {
					token[temp]=tokens[i].token;
					type[temp]=tokens[i].type;
					eva[temp]=tokens[i].value;
					show[temp]=tokens[i].show;
				}
			}
		};
		Mexp.lex=function(inp,tokens){
			'use strict';
			var str=[{type:4,value:"(",show:"(",pre:0}];
			var ptc=[];	//Parenthesis to close at the beginning is after one token
			var inpStr=inp;
			var key;
	        var pcounter=0;
			var allowed=type0;
			var bracToClose=0;
			var asterick=empty;
			var prevKey='';
			var i,x,y;
			if(typeof tokens!=="undefined")
				Mexp.addToken(tokens);
			var obj={};
			for(i=0;i<inpStr.length;i++){
				if (inpStr[i]==' ') {
					continue;
				}
				key='';
				sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
					for(y=0;y<newAr[x].length;y++){
						if (match(inpStr,newAr[x][y],i,x)){
							key=newAr[x][y];
							break sec;
						}
					}
				}
				i+=key.length-1;
				if(key===''){
					throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
				}
				var index=token.indexOf(key);
				var cToken=key;
				var cType=type[index];
				var cEv=eva[index];
				var cPre=preced[cType];
				var	cShow=show[index];
				var pre=str[str.length-1];
				for(j=ptc.length;j--;){	//loop over ptc
					if(ptc[j]===0){
						if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
							if(allowed[cType]!==true){
								throw(new Mexp.exception(key+" is not allowed after "+prevKey));
							}
							str.push({value:")",type:5,pre:0,show:")"});
							allowed=type1;
							asterick=type_3;
							inc(ptc,-1).pop();
						}
					}
				}
				if(allowed[cType]!==true){
					throw(new Mexp.exception(key+" is not allowed after "+prevKey));
				}
				if(asterick[cType]===true){
					cType=2;
					cEv=Mexp.math.mul;
					cShow="&times;";
					cPre=3;
					i=i-key.length;
			 	}
				obj={value:cEv,type:cType,pre:cPre,show:cShow};
				if(cType===0){
					allowed=type0;
					asterick=empty;
					inc(ptc,2).push(2);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===1){
					if(pre.type===1){
						pre.value+=cEv;
						inc(ptc,1);
					}
					else {
						str.push(obj);
					}
					allowed=type1;
					asterick=type_1;
				}
				else if(cType===2){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===3){//constant
					str.push(obj);
					allowed=type1;
					asterick=type_3;
				}
				else if(cType===4){
	                pcounter+=ptc.length;
	                ptc=[];
					bracToClose++;
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===5){
					if(!bracToClose){
						throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
					}
	                while(pcounter--){	//loop over ptc
	    						str.push({value:")",type:5,pre:0,show:")"});
	    			}
	                pcounter=0;
					bracToClose--;
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				else if(cType===6){
					if(pre.hasDec){
						throw(new Mexp.exception("Two decimals are not allowed in one number"));
					}
					if(pre.type!==1){
						pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
						str.push(pre);
						inc(ptc,-1);
					}
					allowed=type6;
					inc(ptc,1);
					asterick=empty;
					pre.value+=cEv;
					pre.hasDec=true;
				}
				else if(cType===7){
					allowed=type1;
					asterick=type_3;
					inc(ptc,1);
					str.push(obj);
				}
				if(cType===8){
					allowed=type0;
					asterick=empty;
					inc(ptc,4).push(4);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===9){
					if(pre.type===9){
						if(pre.value===Mexp.math.add){
							pre.value=cEv;
							pre.show=cShow;
							inc(ptc,1);
						}
						else if(pre.value===Mexp.math.sub&&cShow==='-'){
							pre.value=Mexp.math.add;
							pre.show='+';
							inc(ptc,1);
						}
					}
					else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
						if(cToken==='-'){//do nothing for + token
										//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
							allowed=type0;
							asterick=empty;
							inc(ptc,2).push(2);
							str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
							str.push({value:"(",type:4,pre:0,show:"("});
						}
					}
					else{
						str.push(obj);
						inc(ptc,2);
					}
					allowed=type0;
					asterick=empty;
				}
				else if(cType===10){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===11){
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===12){
					allowed=type0;
					asterick=empty;
					inc(ptc,6).push(6);
					str.push(obj);
					str.push({value:"(",type:4,pre:0});
				}
				else if(cType===13){
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				inc(ptc,-1);
				prevKey=key;
			}
			for(var j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
	
					str.push({value:")",show:")",type:5,pre:3});
					inc(ptc,-1).pop();
				}
			}
			if (allowed[5]!==true) {
				throw(new Mexp.exception("complete the expression"));
			}
			while(bracToClose--)
				str.push({value:")",show:")",type:5,pre:3});
	
			str.push({type:5,value:")",show:")",pre:0});
	//        console.log(str);
			return new Mexp(str);
		};
	    module.exports=Mexp;


/***/ },
/* 1069 */
/***/ function(module, exports) {

		var Mexp=function(parsed){
			this.value=parsed;
	
		};
	
		Mexp.math={
			isDegree:true, //mode of calculator
			acos:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
			},
			add:function(a,b){
				return a+b;
			},
			asin:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
			},
			atan:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
			},
			acosh:function(x){
				return Math.log(x+Math.sqrt(x*x-1));
			},
			asinh:function(x){
				return Math.log(x+Math.sqrt(x*x+1));
			},
			atanh:function(x){
				return Math.log((1+x)/(1-x));
			},
			C:function(n,r){
				var pro=1,other=n-r,choice=r;
				if(choice<other){
				choice=other;
				other=r;
				}
				for(var i=choice+1;i<=n;i++)
					pro*=i;
				return pro/Mexp.math.fact(other);
			},
			changeSign:function(x){
				return -x;
			},
			cos:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.cos(x);
			},
			cosh:function(x){
				return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
			},
			div:function(a,b){
			return a/b;
			},
			fact:function(n) {
			if(n%1!==0)return "NAN";
				var pro=1;
				for(var i=2;i<=n;i++)
					pro*=i;
				return pro;
			},
			inverse:function(x){
				return 1/x;
			},
			log:function(i){
				return Math.log(i)/Math.log(10);
			},
			mod:function(a,b){
			return a%b;
			},
			mul:function(a,b){
			return a*b;
			},
			P:function(n,r){var pro=1;
				 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
						pro*=i;
						return pro;
	
			},
			Pi:function(low,high,ex){
				var pro=1;
				for(var i=low;i<=high;i++){
					pro*=Number(ex.postfixEval({n:i}));
				}
				return pro;
			},
			pow10x:function(e){
				var x=1;
				while(e--){x*=10;}
				return x;
			},
			sigma:function(low,high,ex){
				var sum=0;
				for(var i=low;i<=high;i++){
					sum+=Number(ex.postfixEval({n:i}));
				}
				return sum;
			},
			sin:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.sin(x);
			},
			sinh:function(x){
				return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
			},
			sub:function(a,b){
			return a-b;
			},
			tan:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.tan(x);
			},
			tanh:function(x){
				return Mexp.sinha(x)/Mexp.cosha(x);
			},
			toRadian:function(x){
				return x*Math.PI/180;
			}
		};
		Mexp.exception=function(message){
			this.message=message;
		};
	    module.exports=Mexp;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	
	    var Mexp=__webpack_require__(1068);
	
		Mexp.prototype.toPostfix = function () {
			'use strict';
			var post=[],elem,popped,prep,pre,ele;
	    	var stack=[{value:"(",type:4,pre:0}];
			var arr=this.value;
			for (var i=1; i < arr.length; i++) {
				if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
					if(arr[i].type===1)
						arr[i].value=Number(arr[i].value);
					post.push(arr[i]);
				}
				else if(arr[i].type===4){
					stack.push(arr[i]);
				}
				else if(arr[i].type===5){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
				}
				else if(arr[i].type===11){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
					stack.push(popped);
				}
				else {
					elem=arr[i];
					pre=elem.pre;
					ele=stack[stack.length-1];
					prep=ele.pre;
					var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
					if(pre>prep)stack.push(elem);
					else {
						while(prep>=pre&&!flag||flag&&pre<prep){
							popped=stack.pop();
							ele=stack[stack.length-1];
							post.push(popped);
							prep=ele.pre;
							flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
						}
						stack.push(elem);
					}
				}
			}
			return new Mexp(post);
		};
	    module.exports=Mexp;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(1070);
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict';
		UserDefined=UserDefined||{};
		UserDefined.PI=Math.PI;
		UserDefined.E=Math.E;
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		var bool=(typeof UserDefined.n!=="undefined");
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1){
				stack.push({value:arr[i].value,type:1});
			}
			else if(arr[i].type===3){
				stack.push({value:UserDefined[arr[i].value],type:1});
			}
			else if(arr[i].type===0){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===7){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===8){
				pop1=stack.pop();
				pop2=stack.pop();
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
			else if(arr[i].type===10){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
					pop2.value=pop2.concat(pop1);
					pop2.value.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
	            }
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
	                console.log(pop2);
					pop2=pop2.concat(pop1);
					pop2.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
				}
			}
			else if(arr[i].type===12){
				pop1=stack.pop();
				if (typeof pop1.type!=="undefined") {
					pop1=[pop1];
				}
				pop2=stack.pop();
				pop3=stack.pop();
				stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
			}
			else if(arr[i].type===13){
				if(bool){
					stack.push({value:UserDefined[arr[i].value],type:3});
				}
				else stack.push([arr[i]]);
			}
		}
		if (stack.length>1) {
			throw(new Mexp.exception("Uncaught Syntax error"));
		}
		return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
	};
	Mexp.eval=function(str,tokens,obj){
		if (typeof tokens==="undefined") {
			return this.lex(str).toPostfix().postfixEval();
		}
		else if (typeof obj==="undefined") {
			if (typeof tokens.length!=="undefined") 
				return this.lex(str,tokens).toPostfix().postfixEval();
			else
				return this.lex(str).toPostfix().postfixEval(tokens);
		}
		else
			return this.lex(str,tokens).toPostfix().postfixEval(obj);
	};
	module.exports=Mexp;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var AxisTick = function (_Component) {
	    _inherits(AxisTick, _Component);
	
	    function AxisTick() {
	        _classCallCheck(this, AxisTick);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    AxisTick.prototype.render = function render() {
	        var _props = this.props,
	            _value = _props.value,
	            x = _props.x,
	            y = _props.y,
	            opacity = _props.opacity,
	            rotate = _props.rotate,
	            format = _props.format,
	            lineX = _props.lineX,
	            lineY = _props.lineY,
	            _onClick = _props.onClick,
	            textX = _props.textX,
	            textY = _props.textY,
	            textBaseline = _props.textBaseline,
	            textAnchor = _props.textAnchor,
	            theme = _props.theme;
	
	
	        var value = _value;
	        if (format !== undefined) {
	            value = format(value);
	        }
	
	        var gStyle = { opacity: opacity };
	        if (_onClick) {
	            gStyle['cursor'] = 'pointer';
	        }
	
	        return _react2.default.createElement(
	            'g',
	            _extends({
	                transform: 'translate(' + x + ',' + y + ')'
	            }, _onClick ? { onClick: function onClick(e) {
	                    return _onClick(e, value);
	                } } : {}, {
	                style: gStyle
	            }),
	            _react2.default.createElement('line', { x1: 0, x2: lineX, y1: 0, y2: lineY, stroke: theme.axis.tickColor }),
	            _react2.default.createElement(
	                'text',
	                {
	                    alignmentBaseline: textBaseline,
	                    textAnchor: textAnchor,
	                    transform: 'translate(' + textX + ',' + textY + ') rotate(' + rotate + ')',
	                    style: {
	                        fill: theme.axis.textColor,
	                        fontSize: theme.axis.fontSize
	                    }
	                },
	                value
	            )
	        );
	    };
	
	    return AxisTick;
	}(_react.Component);
	
	AxisTick.propTypes = {
	    format: _propTypes2.default.func,
	    theme: _propTypes2.default.object.isRequired,
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired,
	    opacity: _propTypes2.default.number.isRequired,
	    rotate: _propTypes2.default.number.isRequired
	};
	AxisTick.defaultProps = {
	    opacity: 1,
	    rotate: 0
	};
	exports.default = AxisTick;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var GridLine = function GridLine(props) {
	    return _react2.default.createElement('line', props);
	};
	
	GridLine.propTypes = {
	    x1: _propTypes2.default.number.isRequired,
	    x2: _propTypes2.default.number.isRequired,
	    y1: _propTypes2.default.number.isRequired,
	    y2: _propTypes2.default.number.isRequired
	};
	
	GridLine.defaultProps = {
	    x1: 0,
	    x2: 0,
	    y1: 0,
	    y2: 0
	};
	
	exports.default = GridLine;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _GridLine = __webpack_require__(1073);
	
	var _GridLine2 = _interopRequireDefault(_GridLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var GridLines = function (_Component) {
	    _inherits(GridLines, _Component);
	
	    function GridLines(props) {
	        _classCallCheck(this, GridLines);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.willEnter = _this.willEnter.bind(_this);
	        _this.willLeave = _this.willLeave.bind(_this);
	        return _this;
	    }
	
	    GridLines.prototype.willEnter = function willEnter(_ref) {
	        var style = _ref.style;
	        var type = this.props.type;
	
	
	        return {
	            opacity: 0,
	            x1: type === 'x' ? 0 : style.x1.val,
	            x2: type === 'x' ? 0 : style.x2.val,
	            y1: type === 'y' ? 0 : style.y1.val,
	            y2: type === 'y' ? 0 : style.y2.val
	        };
	    };
	
	    GridLines.prototype.willLeave = function willLeave(_ref2) {
	        var style = _ref2.style;
	        var _props = this.props,
	            motionStiffness = _props.motionStiffness,
	            motionDamping = _props.motionDamping;
	
	        var springConfig = {
	            stiffness: motionStiffness,
	            damping: motionDamping
	        };
	
	        return {
	            opacity: (0, _reactMotion.spring)(0, springConfig),
	            x1: (0, _reactMotion.spring)(style.x1.val, springConfig),
	            x2: (0, _reactMotion.spring)(style.x2.val, springConfig),
	            y1: (0, _reactMotion.spring)(style.y1.val, springConfig),
	            y2: (0, _reactMotion.spring)(style.y2.val, springConfig)
	        };
	    };
	
	    GridLines.prototype.render = function render() {
	        var _props2 = this.props,
	            lines = _props2.lines,
	            animate = _props2.animate,
	            motionStiffness = _props2.motionStiffness,
	            motionDamping = _props2.motionDamping,
	            theme = _props2.theme;
	
	
	        if (!animate) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                lines.map(function (line) {
	                    return _react2.default.createElement(_GridLine2.default, _extends({}, line, theme.grid));
	                })
	            );
	        }
	
	        var springConfig = {
	            stiffness: motionStiffness,
	            damping: motionDamping
	        };
	
	        return _react2.default.createElement(
	            _reactMotion.TransitionMotion,
	            {
	                willEnter: this.willEnter,
	                willLeave: this.willLeave,
	                styles: lines.map(function (line) {
	                    return {
	                        key: line.key,
	                        style: {
	                            opacity: (0, _reactMotion.spring)(1, springConfig),
	                            x1: (0, _reactMotion.spring)(line.x1 || 0, springConfig),
	                            x2: (0, _reactMotion.spring)(line.x2 || 0, springConfig),
	                            y1: (0, _reactMotion.spring)(line.y1 || 0, springConfig),
	                            y2: (0, _reactMotion.spring)(line.y2 || 0, springConfig)
	                        }
	                    };
	                })
	            },
	            function (interpolatedStyles) {
	                return _react2.default.createElement(
	                    'g',
	                    null,
	                    interpolatedStyles.map(function (interpolatedStyle) {
	                        var key = interpolatedStyle.key,
	                            style = interpolatedStyle.style;
	
	
	                        return _react2.default.createElement(_GridLine2.default, _extends({ key: key }, theme.grid, style));
	                    })
	                );
	            }
	        );
	    };
	
	    return GridLines;
	}(_react.Component);
	
	GridLines.propTypes = {
	    type: _propTypes2.default.oneOf(['x', 'y']).isRequired,
	    lines: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        key: _propTypes2.default.string.isRequired,
	        x1: _propTypes2.default.number,
	        x2: _propTypes2.default.number,
	        y1: _propTypes2.default.number,
	        y2: _propTypes2.default.number
	    })).isRequired,
	    theme: _propTypes2.default.object.isRequired,
	    // motion
	    animate: _propTypes2.default.bool.isRequired,
	    motionStiffness: _propTypes2.default.number.isRequired,
	    motionDamping: _propTypes2.default.number.isRequired
	};
	exports.default = GridLines;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Axis = __webpack_require__(490);
	
	Object.defineProperty(exports, 'Axis', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Axis).default;
	  }
	});
	
	var _Axes = __webpack_require__(164);
	
	Object.defineProperty(exports, 'Axes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Axes).default;
	  }
	});
	
	var _Grid = __webpack_require__(165);
	
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param {string} axis
	 * @param {number} width
	 * @param {number} height
	 * @param {string} position
	 * @param {number} offsetX
	 * @param {number} offsetY
	 * @param {string} orientation
	 * @return {{ x: number, y: number, textAnchor: string }}
	 */
	var computeLabel = function computeLabel(_ref) {
	    var axis = _ref.axis,
	        width = _ref.width,
	        height = _ref.height,
	        position = _ref.position,
	        offsetX = _ref.offsetX,
	        offsetY = _ref.offsetY,
	        orientation = _ref.orientation;
	
	    var x = 0;
	    var y = 0;
	    var rotation = orientation === 'vertical' ? -90 : 0;
	    var textAnchor = 'start';
	
	    if (axis === 'x') {
	        switch (position) {
	            case 'top-left':
	                x = -offsetX;
	                y = offsetY;
	                textAnchor = 'end';
	                break;
	            case 'top':
	                y = -offsetY;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'middle';
	                } else {
	                    textAnchor = 'start';
	                }
	                break;
	            case 'top-right':
	                x = offsetX;
	                y = offsetY;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'start';
	                } else {
	                    textAnchor = 'end';
	                }
	                break;
	            case 'right':
	                x = offsetX;
	                y = height / 2;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'start';
	                } else {
	                    textAnchor = 'middle';
	                }
	                break;
	            case 'bottom-right':
	                x = offsetX;
	                y = height - offsetY;
	                textAnchor = 'start';
	                break;
	            case 'bottom':
	                y = height + offsetY;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'middle';
	                } else {
	                    textAnchor = 'end';
	                }
	                break;
	            case 'bottom-left':
	                y = height - offsetY;
	                x = -offsetX;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'end';
	                } else {
	                    textAnchor = 'start';
	                }
	                break;
	            case 'left':
	                x = -offsetX;
	                y = height / 2;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'end';
	                } else {
	                    textAnchor = 'middle';
	                }
	                break;
	        }
	    } else {
	        switch (position) {
	            case 'top-left':
	                x = offsetX;
	                y = -offsetY;
	                textAnchor = 'start';
	                break;
	            case 'top':
	                x = width / 2;
	                y = -offsetY;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'middle';
	                } else {
	                    textAnchor = 'start';
	                }
	                break;
	            case 'top-right':
	                x = width - offsetX;
	                y = -offsetY;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'end';
	                } else {
	                    textAnchor = 'start';
	                }
	                break;
	            case 'right':
	                x = width + offsetX;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'start';
	                } else {
	                    textAnchor = 'middle';
	                }
	                break;
	            case 'bottom-right':
	                x = width - offsetX;
	                y = offsetY;
	                textAnchor = 'end';
	                break;
	            case 'bottom':
	                x = width / 2;
	                y = offsetY;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'middle';
	                } else {
	                    textAnchor = 'end';
	                }
	                break;
	            case 'bottom-left':
	                x = offsetX;
	                y = offsetY;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'start';
	                } else {
	                    textAnchor = 'end';
	                }
	                break;
	            case 'left':
	                x = -offsetX;
	                if (orientation === 'horizontal') {
	                    textAnchor = 'end';
	                } else {
	                    textAnchor = 'middle';
	                }
	                break;
	        }
	    }
	
	    return { x: x, y: y, rotation: rotation, textAnchor: textAnchor };
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	
	var CartesianMarkersItem = function CartesianMarkersItem(_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height,
	        axis = _ref2.axis,
	        scale = _ref2.scale,
	        value = _ref2.value,
	        theme = _ref2.theme,
	        lineStyle = _ref2.lineStyle,
	        textStyle = _ref2.textStyle,
	        legend = _ref2.legend,
	        legendPosition = _ref2.legendPosition,
	        legendOffsetX = _ref2.legendOffsetX,
	        legendOffsetY = _ref2.legendOffsetY,
	        legendOrientation = _ref2.legendOrientation;
	
	    var x = 0;
	    var x2 = 0;
	    var y = 0;
	    var y2 = 0;
	
	    if (axis === 'y') {
	        y = scale(value);
	        x2 = width;
	    } else {
	        x = scale(value);
	        y2 = height;
	    }
	
	    var legendNode = null;
	    if (legend) {
	        var legendProps = computeLabel({
	            axis: axis,
	            width: width,
	            height: height,
	            position: legendPosition,
	            offsetX: legendOffsetX,
	            offsetY: legendOffsetY,
	            orientation: legendOrientation
	        });
	        legendNode = _react2.default.createElement(
	            'text',
	            {
	                transform: 'translate(' + legendProps.x + ', ' + legendProps.y + ') rotate(' + legendProps.rotation + ')',
	                textAnchor: legendProps.textAnchor,
	                alignmentBaseline: 'central',
	                style: textStyle
	            },
	            legend
	        );
	    }
	
	    return _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + x + ', ' + y + ')' },
	        _react2.default.createElement('line', {
	            x1: 0,
	            x2: x2,
	            y1: 0,
	            y2: y2,
	            stroke: theme.markers.lineColor,
	            strokeWidth: theme.markers.lineStrokeWidth,
	            style: lineStyle
	        }),
	        legendNode
	    );
	};
	
	CartesianMarkersItem.propTypes = {
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	
	    axis: _propTypes2.default.oneOf(['x', 'y']).isRequired,
	    scale: _propTypes2.default.func.isRequired,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	    lineStyle: _propTypes2.default.object,
	    textStyle: _propTypes2.default.object,
	
	    legend: _propTypes2.default.string,
	    legendPosition: _propTypes2.default.oneOf(['top-left', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left']),
	    legendOffsetX: _propTypes2.default.number.isRequired,
	    legendOffsetY: _propTypes2.default.number.isRequired,
	    legendOrientation: _propTypes2.default.oneOf(['horizontal', 'vertical']).isRequired,
	
	    theme: _propTypes2.default.shape({
	        markers: _propTypes2.default.shape({
	            textColor: _propTypes2.default.string.isRequired,
	            fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired
	        }).isRequired
	    }).isRequired
	};
	
	CartesianMarkersItem.defaultProps = {
	    legendPosition: 'top-right',
	    legendOffsetX: 14,
	    legendOffsetY: 14,
	    legendOrientation: 'horizontal'
	};
	
	exports.default = (0, _pure2.default)(CartesianMarkersItem);

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var BarItem = function BarItem(_ref) {
	    var data = _ref.data,
	        x = _ref.x,
	        y = _ref.y,
	        width = _ref.width,
	        height = _ref.height,
	        borderRadius = _ref.borderRadius,
	        color = _ref.color,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        label = _ref.label,
	        shouldRenderLabel = _ref.shouldRenderLabel,
	        labelColor = _ref.labelColor,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        onClick = _ref.onClick,
	        tooltipFormat = _ref.tooltipFormat,
	        theme = _ref.theme;
	
	    var handleTooltip = function handleTooltip(e) {
	        return showTooltip(_react2.default.createElement(_BasicTooltip2.default, {
	            id: data.id + ' - ' + data.indexValue,
	            value: data.value,
	            enableChip: true,
	            color: color,
	            theme: theme,
	            format: tooltipFormat
	        }), e);
	    };
	
	    return _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + x + ', ' + y + ')' },
	        _react2.default.createElement('rect', {
	            width: width,
	            height: height,
	            rx: borderRadius,
	            ry: borderRadius,
	            fill: data.fill ? data.fill : color,
	            strokeWidth: borderWidth,
	            stroke: borderColor,
	            onMouseEnter: handleTooltip,
	            onMouseMove: handleTooltip,
	            onMouseLeave: hideTooltip,
	            onClick: onClick
	        }),
	        shouldRenderLabel && _react2.default.createElement(
	            'text',
	            {
	                x: width / 2,
	                y: height / 2,
	                textAnchor: 'middle',
	                alignmentBaseline: 'central',
	                style: {
	                    pointerEvents: 'none',
	                    fill: labelColor
	                }
	            },
	            label
	        )
	    );
	};
	
	BarItem.propTypes = {
	    data: _propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired,
	        value: _propTypes2.default.number.isRequired,
	        indexValue: _propTypes2.default.string.isRequired
	    }).isRequired,
	
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired,
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    borderRadius: _propTypes2.default.number.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired,
	
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    shouldRenderLabel: _propTypes2.default.bool.isRequired,
	    labelColor: _propTypes2.default.string.isRequired,
	
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	
	    theme: _propTypes2.default.shape({
	        tooltip: _propTypes2.default.shape({}).isRequired
	    }).isRequired
	};
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['data', 'onClick'], function (_ref2) {
	    var data = _ref2.data,
	        _onClick = _ref2.onClick;
	    return {
	        onClick: function onClick(event) {
	            return _onClick(data, event);
	        }
	    };
	}), _pure2.default);
	
	exports.default = enhance(BarItem);

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Bar = __webpack_require__(492);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveBar = function ResponsiveBar(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Bar2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveBar;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _BarCanvas = __webpack_require__(493);
	
	var _BarCanvas2 = _interopRequireDefault(_BarCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveBarCanvas = function ResponsiveBarCanvas(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_BarCanvas2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveBarCanvas;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Bar = __webpack_require__(492);
	
	Object.defineProperty(exports, 'Bar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bar).default;
	  }
	});
	
	var _BarCanvas = __webpack_require__(493);
	
	Object.defineProperty(exports, 'BarCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BarCanvas).default;
	  }
	});
	
	var _ResponsiveBar = __webpack_require__(1078);
	
	Object.defineProperty(exports, 'ResponsiveBar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveBar).default;
	  }
	});
	
	var _ResponsiveBarCanvas = __webpack_require__(1079);
	
	Object.defineProperty(exports, 'ResponsiveBarCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveBarCanvas).default;
	  }
	});
	
	var _props = __webpack_require__(219);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BubbleHtmlNode = function BubbleHtmlNode(_ref) {
	    var node = _ref.node,
	        style = _ref.style,
	        handlers = _ref.handlers;
	
	    if (style.r <= 0) return null;
	
	    return _react2.default.createElement(
	        'div',
	        _extends({
	            style: {
	                position: 'absolute',
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                background: style.color,
	                color: style.labelTextColor,
	                borderWidth: style.borderWidth,
	                borderColor: style.borderColor,
	                top: style.y - style.r,
	                left: style.x - style.r,
	                width: style.r * 2,
	                height: style.r * 2,
	                borderStyle: 'solid',
	                borderRadius: style.r
	            }
	        }, handlers),
	        node.label !== false && node.label
	    );
	};
	
	BubbleHtmlNode.propTypes = {
	    node: _propTypes2.default.object.isRequired,
	    style: _propTypes2.default.shape({
	        r: _propTypes2.default.number.isRequired,
	        x: _propTypes2.default.number.isRequired,
	        y: _propTypes2.default.number.isRequired,
	        color: _propTypes2.default.string.isRequired,
	        fill: _propTypes2.default.string,
	        borderWidth: _propTypes2.default.number.isRequired,
	        borderColor: _propTypes2.default.string.isRequired,
	        labelTextColor: _propTypes2.default.string.isRequired
	    }).isRequired,
	    handlers: _propTypes2.default.object.isRequired
	};
	
	exports.default = BubbleHtmlNode;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BubbleNode = function BubbleNode(_ref) {
	    var node = _ref.node,
	        style = _ref.style,
	        handlers = _ref.handlers;
	
	    if (style.r <= 0) return null;
	
	    return _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + style.x + ',' + style.y + ')' },
	        _react2.default.createElement('circle', _extends({
	            r: style.r
	        }, handlers, {
	            fill: style.fill ? style.fill : style.color,
	            stroke: style.borderColor,
	            strokeWidth: style.borderWidth
	        })),
	        node.label !== false && _react2.default.createElement(
	            'text',
	            {
	                textAnchor: 'middle',
	                alignmentBaseline: 'central',
	                style: {
	                    fill: style.labelTextColor,
	                    pointerEvents: 'none'
	                }
	            },
	            node.label
	        )
	    );
	};
	
	BubbleNode.propTypes = {
	    node: _propTypes2.default.object.isRequired,
	    style: _propTypes2.default.shape({
	        r: _propTypes2.default.number.isRequired,
	        x: _propTypes2.default.number.isRequired,
	        y: _propTypes2.default.number.isRequired,
	        color: _propTypes2.default.string.isRequired,
	        fill: _propTypes2.default.string,
	        borderWidth: _propTypes2.default.number.isRequired,
	        borderColor: _propTypes2.default.string.isRequired,
	        labelTextColor: _propTypes2.default.string.isRequired
	    }).isRequired,
	    handlers: _propTypes2.default.object.isRequired
	};
	
	exports.default = BubbleNode;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Bubble = __webpack_require__(495);
	
	var _Bubble2 = _interopRequireDefault(_Bubble);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Bubble2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _BubbleCanvas = __webpack_require__(496);
	
	var _BubbleCanvas2 = _interopRequireDefault(_BubbleCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_BubbleCanvas2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _BubbleHtml = __webpack_require__(497);
	
	var _BubbleHtml2 = _interopRequireDefault(_BubbleHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_BubbleHtml2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Bubble = __webpack_require__(495);
	
	Object.defineProperty(exports, 'Bubble', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bubble).default;
	  }
	});
	
	var _ResponsiveBubble = __webpack_require__(1083);
	
	Object.defineProperty(exports, 'ResponsiveBubble', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveBubble).default;
	  }
	});
	
	var _BubbleHtml = __webpack_require__(497);
	
	Object.defineProperty(exports, 'BubbleHtml', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BubbleHtml).default;
	  }
	});
	
	var _ResponsiveBubbleHtml = __webpack_require__(1085);
	
	Object.defineProperty(exports, 'ResponsiveBubbleHtml', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveBubbleHtml).default;
	  }
	});
	
	var _BubbleCanvas = __webpack_require__(496);
	
	Object.defineProperty(exports, 'BubbleCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BubbleCanvas).default;
	  }
	});
	
	var _ResponsiveBubbleCanvas = __webpack_require__(1084);
	
	Object.defineProperty(exports, 'ResponsiveBubbleCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveBubbleCanvas).default;
	  }
	});
	
	var _props = __webpack_require__(500);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _noop = __webpack_require__(107);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarDay = function CalendarDay(_ref) {
	    var x = _ref.x,
	        y = _ref.y,
	        size = _ref.size,
	        color = _ref.color,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        onClick = _ref.onClick,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip;
	    return _react2.default.createElement('rect', {
	        x: x,
	        y: y,
	        width: size,
	        height: size,
	        style: {
	            fill: color,
	            strokeWidth: borderWidth,
	            stroke: borderColor
	        },
	        onClick: onClick,
	        onMouseEnter: showTooltip,
	        onMouseMove: showTooltip,
	        onMouseLeave: hideTooltip
	    });
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	
	CalendarDay.propTypes = {
	    onClick: _propTypes2.default.func.isRequired,
	    data: _propTypes2.default.object.isRequired,
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired,
	    size: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired,
	
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	
	    theme: _propTypes2.default.shape({
	        tooltip: _propTypes2.default.shape({}).isRequired
	    }).isRequired
	};
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['data', 'onClick'], function (_ref2) {
	    var data = _ref2.data,
	        _onClick = _ref2.onClick;
	    return {
	        onClick: function onClick(event) {
	            return _onClick(data, event);
	        }
	    };
	}), (0, _withPropsOnChange2.default)(['data', 'color', 'showTooltip', 'theme', 'tooltipFormat'], function (_ref3) {
	    var data = _ref3.data,
	        color = _ref3.color,
	        _showTooltip = _ref3.showTooltip,
	        theme = _ref3.theme,
	        tooltipFormat = _ref3.tooltipFormat;
	
	    if (data.value === undefined) return { showTooltip: _noop2.default };
	
	    return {
	        showTooltip: function showTooltip(event) {
	            return _showTooltip(_react2.default.createElement(_BasicTooltip2.default, {
	                id: '' + data.day,
	                value: data.value,
	                enableChip: true,
	                color: color,
	                theme: theme,
	                format: tooltipFormat
	            }), event);
	        }
	    };
	}), _pure2.default);
	
	exports.default = enhance(CalendarDay);

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarMonthPath = function CalendarMonthPath(_ref) {
	    var path = _ref.path,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor;
	    return _react2.default.createElement('path', {
	        d: path,
	        style: {
	            fill: 'none',
	            strokeWidth: borderWidth,
	            stroke: borderColor
	        }
	    });
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	
	CalendarMonthPath.propTypes = {
	    path: _propTypes2.default.string.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _pure2.default)(CalendarMonthPath);

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Calendar = __webpack_require__(501);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Calendar2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _maxBy2 = __webpack_require__(208);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _minBy2 = __webpack_require__(1023);
	
	var _minBy3 = _interopRequireDefault(_minBy2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _d3Scale = __webpack_require__(71);
	
	var _hocs = __webpack_require__(52);
	
	var _props = __webpack_require__(304);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	exports.default = function (Component) {
	    return (0, _compose2.default)((0, _defaultProps2.default)(_props.CalendarDefaultProps), (0, _hocs.withTheme)(), (0, _hocs.withDimensions)(), (0, _withPropsOnChange2.default)(['data', 'domain', 'colors'], function (_ref) {
	        var data = _ref.data,
	            domain = _ref.domain,
	            colors = _ref.colors;
	
	        var colorDomain = void 0;
	        if (domain === 'auto') {
	            colorDomain = [(0, _minBy3.default)(data, 'value').value, (0, _maxBy3.default)(data, 'value').value];
	        } else {
	            colorDomain = [].concat(domain);
	        }
	
	        var colorScale = (0, _d3Scale.scaleQuantize)().domain(colorDomain).range(colors);
	
	        return { colorScale: colorScale };
	    }), _pure2.default)(Component);
	};

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Calendar = __webpack_require__(501);
	
	Object.defineProperty(exports, 'Calendar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Calendar).default;
	  }
	});
	
	var _ResponsiveCalendar = __webpack_require__(1089);
	
	Object.defineProperty(exports, 'ResponsiveCalendar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveCalendar).default;
	  }
	});
	
	var _props = __webpack_require__(304);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _colors = __webpack_require__(24);
	
	var _ChordArcTooltip = __webpack_require__(503);
	
	var _ChordArcTooltip2 = _interopRequireDefault(_ChordArcTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChordArcs = function ChordArcs(_ref) {
	    var arcs = _ref.arcs,
	        borderWidth = _ref.borderWidth,
	        getBorderColor = _ref.getBorderColor,
	        getOpacity = _ref.getOpacity,
	        shapeGenerator = _ref.shapeGenerator,
	        theme = _ref.theme,
	        tooltipFormat = _ref.tooltipFormat,
	        setCurrent = _ref.setCurrent,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness;
	
	    var commonProps = function commonProps(arc) {
	        var arcTooltip = _react2.default.createElement(_ChordArcTooltip2.default, { arc: arc, theme: theme, format: tooltipFormat });
	
	        return {
	            strokeWidth: borderWidth,
	            onMouseEnter: function onMouseEnter(e) {
	                setCurrent(arc);
	                showTooltip(arcTooltip, e);
	            },
	            onMouseMove: function onMouseMove(e) {
	                showTooltip(arcTooltip, e);
	            },
	            onMouseLeave: function onMouseLeave() {
	                setCurrent(null);
	                hideTooltip();
	            }
	        };
	    };
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            arcs.map(function (arc) {
	                var opacity = getOpacity(arc);
	
	                return _react2.default.createElement('path', _extends({
	                    key: arc.key,
	                    d: shapeGenerator(arc),
	                    fill: arc.color,
	                    fillOpacity: opacity,
	                    stroke: getBorderColor(arc),
	                    strokeOpacity: opacity
	                }, commonProps(arc)));
	            })
	        );
	    }
	
	    var springConfig = {
	        damping: motionDamping,
	        stiffness: motionStiffness,
	        precision: 0.001
	    };
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            styles: arcs.map(function (arc) {
	                return {
	                    key: arc.key,
	                    data: arc,
	                    style: _extends({
	                        startAngle: (0, _reactMotion.spring)(arc.startAngle, springConfig),
	                        endAngle: (0, _reactMotion.spring)(arc.endAngle, springConfig),
	                        opacity: (0, _reactMotion.spring)(getOpacity(arc), springConfig)
	                    }, (0, _colors.colorMotionSpring)(arc.color, springConfig))
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref2) {
	                    var key = _ref2.key,
	                        style = _ref2.style,
	                        arc = _ref2.data;
	
	                    var color = (0, _colors.getInterpolatedColor)(style);
	
	                    return _react2.default.createElement('path', _extends({
	                        key: key,
	                        d: shapeGenerator({
	                            startAngle: style.startAngle,
	                            endAngle: style.endAngle
	                        }),
	                        fill: color,
	                        fillOpacity: style.opacity,
	                        stroke: getBorderColor(_extends({}, arc, { color: color })),
	                        strokeOpacity: style.opacity
	                    }, commonProps(arc)));
	                })
	            );
	        }
	    );
	};
	
	ChordArcs.propTypes = {
	    arcs: _propTypes2.default.array.isRequired,
	    shapeGenerator: _propTypes2.default.func.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    getOpacity: _propTypes2.default.func.isRequired,
	    setCurrent: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired,
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _pure2.default)(ChordArcs);

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _polar = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var ChordLabels = function ChordLabels(_ref) {
	    var arcs = _ref.arcs,
	        radius = _ref.radius,
	        rotation = _ref.rotation,
	        getLabel = _ref.getLabel,
	        getColor = _ref.getColor,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness;
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            arcs.map(function (arc) {
	                var color = getColor(arc, theme);
	                var angle = (0, _polar.midAngle)(arc);
	                var props = (0, _polar.getPolarLabelProps)(radius, angle, rotation);
	
	                return _react2.default.createElement(
	                    'text',
	                    {
	                        key: arc.key,
	                        transform: 'translate(' + props.x + ', ' + props.y + ') rotate(' + props.rotate + ')',
	                        style: { pointerEvents: 'none', fill: color },
	                        textAnchor: props.align,
	                        alignmentBaseline: props.baseline
	                    },
	                    getLabel(arc)
	                );
	            })
	        );
	    }
	
	    var springConfig = {
	        damping: motionDamping,
	        stiffness: motionStiffness
	    };
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            styles: arcs.map(function (arc) {
	                var angle = (0, _polar.midAngle)(arc);
	
	                return {
	                    key: arc.key,
	                    data: arc,
	                    style: {
	                        angle: (0, _reactMotion.spring)(angle, springConfig)
	                    }
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref2) {
	                    var key = _ref2.key,
	                        style = _ref2.style,
	                        arc = _ref2.data;
	
	                    var color = getColor(arc, theme);
	                    var props = (0, _polar.getPolarLabelProps)(radius, style.angle, rotation);
	
	                    return _react2.default.createElement(
	                        'text',
	                        {
	                            key: key,
	                            transform: 'translate(' + props.x + ', ' + props.y + ') rotate(' + props.rotate + ')',
	                            style: { pointerEvents: 'none', fill: color },
	                            textAnchor: props.align,
	                            alignmentBaseline: props.baseline
	                        },
	                        getLabel(arc)
	                    );
	                })
	            );
	        }
	    );
	};
	
	ChordLabels.propTypes = {
	    arcs: _propTypes2.default.array.isRequired,
	    radius: _propTypes2.default.number.isRequired,
	    rotation: _propTypes2.default.number.isRequired,
	    getLabel: _propTypes2.default.func.isRequired,
	    getColor: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = ChordLabels;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _mapValues2 = __webpack_require__(1021);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _d3Format = __webpack_require__(108);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _colors = __webpack_require__(24);
	
	var _polar = __webpack_require__(60);
	
	var _TableTooltip = __webpack_require__(222);
	
	var _TableTooltip2 = _interopRequireDefault(_TableTooltip);
	
	var _Chip = __webpack_require__(166);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Used to get ribbon angles, instead of using source and target arcs,
	 * we sort arcs by value to have smooth transitions, otherwise,
	 * if source|target arc value becomes greater than the other,
	 * the ribbon will be reversed.
	 *
	 * @param {Object}  source
	 * @param {Object}  target
	 * @param {boolean} useMiddleAngle
	 * @param {Object}  [springConfig]
	 * @return {Object}
	 */
	var getRibbonAngles = function getRibbonAngles(_ref, useMiddleAngle, springConfig) {
	    var source = _ref.source,
	        target = _ref.target;
	
	    var firstArc = void 0;
	    var secondArc = void 0;
	    if (source.startAngle < target.startAngle) {
	        firstArc = source;
	        secondArc = target;
	    } else {
	        firstArc = target;
	        secondArc = source;
	    }
	
	    var angles = void 0;
	    if (useMiddleAngle === true) {
	        var firstMiddleAngle = (0, _polar.midAngle)(firstArc);
	        var secondMiddleAngle = (0, _polar.midAngle)(secondArc);
	
	        angles = {
	            sourceStartAngle: firstMiddleAngle,
	            sourceEndAngle: firstMiddleAngle,
	            targetStartAngle: secondMiddleAngle,
	            targetEndAngle: secondMiddleAngle
	        };
	    } else {
	        angles = {
	            sourceStartAngle: firstArc.startAngle,
	            sourceEndAngle: firstArc.endAngle,
	            targetStartAngle: secondArc.startAngle,
	            targetEndAngle: secondArc.endAngle
	        };
	    }
	
	    if (!springConfig) return angles;
	
	    return (0, _mapValues3.default)(angles, function (angle) {
	        return (0, _reactMotion.spring)(angle, springConfig);
	    });
	};
	
	var ribbonWillEnter = function ribbonWillEnter(_ref2) {
	    var ribbon = _ref2.data;
	    return _extends({}, getRibbonAngles(ribbon, true), {
	        opacity: 0
	    }, (0, _colors.colorMotionSpring)(ribbon.source.color));
	};
	
	var ribbonWillLeave = function ribbonWillLeave(springConfig) {
	    return function (_ref3) {
	        var ribbon = _ref3.data;
	        return _extends({}, getRibbonAngles(ribbon, true, springConfig), {
	            opacity: 0
	        }, (0, _colors.colorMotionSpring)(ribbon.source.color, springConfig));
	    };
	};
	
	var ChordRibbons = function ChordRibbons(_ref4) {
	    var ribbons = _ref4.ribbons,
	        shapeGenerator = _ref4.shapeGenerator,
	        borderWidth = _ref4.borderWidth,
	        getBorderColor = _ref4.getBorderColor,
	        getOpacity = _ref4.getOpacity,
	        theme = _ref4.theme,
	        tooltipFormat = _ref4.tooltipFormat,
	        setCurrent = _ref4.setCurrent,
	        showTooltip = _ref4.showTooltip,
	        hideTooltip = _ref4.hideTooltip,
	        animate = _ref4.animate,
	        motionDamping = _ref4.motionDamping,
	        motionStiffness = _ref4.motionStiffness;
	
	    var commonProps = function commonProps(ribbon) {
	        var ribbonTooltip = _react2.default.createElement(_TableTooltip2.default, {
	            theme: theme,
	            rows: [[_react2.default.createElement(_Chip2.default, { color: ribbon.source.color }), _react2.default.createElement(
	                'strong',
	                null,
	                ribbon.source.id
	            ), tooltipFormat ? tooltipFormat(ribbon.source.value) : ribbon.source.value], [_react2.default.createElement(_Chip2.default, { color: ribbon.target.color }), _react2.default.createElement(
	                'strong',
	                null,
	                ribbon.target.id
	            ), tooltipFormat ? tooltipFormat(ribbon.target.value) : ribbon.target.value]]
	        });
	
	        return {
	            strokeWidth: borderWidth,
	            onMouseEnter: function onMouseEnter(e) {
	                setCurrent(ribbon);
	                showTooltip(ribbonTooltip, e);
	            },
	            onMouseMove: function onMouseMove(e) {
	                showTooltip(ribbonTooltip, e);
	            },
	            onMouseLeave: function onMouseLeave() {
	                setCurrent(null);
	                hideTooltip();
	            }
	        };
	    };
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            ribbons.map(function (ribbon) {
	                var opacity = getOpacity(ribbon);
	
	                return _react2.default.createElement('path', _extends({
	                    key: ribbon.key,
	                    d: shapeGenerator(ribbon),
	                    fill: ribbon.source.color,
	                    fillOpacity: opacity,
	                    stroke: getBorderColor(_extends({}, ribbon, { color: ribbon.source.color })),
	                    strokeOpacity: opacity
	                }, commonProps(ribbon)));
	            })
	        );
	    }
	
	    var springConfig = {
	        damping: motionDamping,
	        stiffness: motionStiffness,
	        precision: 0.001
	    };
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            willEnter: ribbonWillEnter,
	            willLeave: ribbonWillLeave(springConfig),
	            styles: ribbons.map(function (ribbon) {
	                return {
	                    key: ribbon.key,
	                    data: ribbon,
	                    style: _extends({}, getRibbonAngles(ribbon, false, springConfig), {
	                        opacity: (0, _reactMotion.spring)(getOpacity(ribbon), springConfig)
	                    }, (0, _colors.colorMotionSpring)(ribbon.source.color, springConfig))
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref5) {
	                    var key = _ref5.key,
	                        style = _ref5.style,
	                        ribbon = _ref5.data;
	
	                    var color = (0, _colors.getInterpolatedColor)(style);
	
	                    return _react2.default.createElement('path', _extends({
	                        key: key,
	                        d: shapeGenerator({
	                            source: {
	                                startAngle: style.sourceStartAngle,
	                                endAngle: Math.max(style.sourceEndAngle, style.sourceStartAngle)
	                            },
	                            target: {
	                                startAngle: style.targetStartAngle,
	                                endAngle: Math.max(style.targetEndAngle, style.targetStartAngle)
	                            }
	                        }),
	                        fill: color,
	                        fillOpacity: style.opacity,
	                        stroke: getBorderColor(_extends({}, ribbon, { color: color })),
	                        strokeOpacity: style.opacity
	                    }, commonProps(ribbon)));
	                })
	            );
	        }
	    );
	};
	
	ChordRibbons.propTypes = {
	    ribbons: _propTypes2.default.array.isRequired,
	    shapeGenerator: _propTypes2.default.func.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    getBorderColor: _propTypes2.default.func.isRequired,
	    getOpacity: _propTypes2.default.func.isRequired,
	    setCurrent: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired,
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired
	};
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['tooltipFormat'], function (_ref6) {
	    var tooltipFormat = _ref6.tooltipFormat;
	
	    if (!tooltipFormat || (0, _isFunction3.default)(tooltipFormat)) return { tooltipFormat: tooltipFormat };
	    return { tooltipFormat: (0, _d3Format.format)(tooltipFormat) };
	}), _pure2.default);
	
	exports.default = enhance(ChordRibbons);

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Chord = __webpack_require__(502);
	
	var _Chord2 = _interopRequireDefault(_Chord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveChord = function ResponsiveChord(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Chord2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveChord;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _ChordCanvas = __webpack_require__(504);
	
	var _ChordCanvas2 = _interopRequireDefault(_ChordCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveChordCanvas = function ResponsiveChordCanvas(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_ChordCanvas2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveChordCanvas;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Chord = __webpack_require__(502);
	
	Object.defineProperty(exports, 'Chord', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chord).default;
	  }
	});
	
	var _ChordCanvas = __webpack_require__(504);
	
	Object.defineProperty(exports, 'ChordCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ChordCanvas).default;
	  }
	});
	
	var _ResponsiveChord = __webpack_require__(1095);
	
	Object.defineProperty(exports, 'ResponsiveChord', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveChord).default;
	  }
	});
	
	var _ResponsiveChordCanvas = __webpack_require__(1096);
	
	Object.defineProperty(exports, 'ResponsiveChordCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveChordCanvas).default;
	  }
	});
	
	var _props = __webpack_require__(220);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = { cursor: 'pointer' }; /*
	                                    * This file is part of the nivo project.
	                                    *
	                                    * Copyright 2016-present, Raphaël Benitte.
	                                    *
	                                    * For the full copyright and license information, please view the LICENSE
	                                    * file that was distributed with this source code.
	                                    */
	
	
	var HeatMapCellCircle = function HeatMapCellCircle(_ref) {
	    var value = _ref.value,
	        x = _ref.x,
	        y = _ref.y,
	        width = _ref.width,
	        height = _ref.height,
	        color = _ref.color,
	        opacity = _ref.opacity,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        textColor = _ref.textColor,
	        onHover = _ref.onHover,
	        onLeave = _ref.onLeave;
	    return _react2.default.createElement(
	        'g',
	        {
	            transform: 'translate(' + x + ', ' + y + ')',
	            style: style,
	            onMouseEnter: onHover,
	            onMouseMove: onHover,
	            onMouseLeave: onLeave
	        },
	        _react2.default.createElement('circle', {
	            r: Math.min(width, height) / 2,
	            fill: color,
	            fillOpacity: opacity,
	            strokeWidth: borderWidth,
	            stroke: borderColor,
	            strokeOpacity: opacity
	        }),
	        _react2.default.createElement(
	            'text',
	            {
	                alignmentBaseline: 'central',
	                textAnchor: 'middle',
	                style: { fill: textColor },
	                fillOpacity: opacity
	            },
	            value
	        )
	    );
	};
	
	HeatMapCellCircle.propTypes = {
	    value: _propTypes2.default.number.isRequired,
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired,
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    opacity: _propTypes2.default.number.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired,
	    textColor: _propTypes2.default.string.isRequired,
	    onHover: _propTypes2.default.func.isRequired,
	    onLeave: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _pure2.default)(HeatMapCellCircle);

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = { cursor: 'pointer' }; /*
	                                    * This file is part of the nivo project.
	                                    *
	                                    * Copyright 2016-present, Raphaël Benitte.
	                                    *
	                                    * For the full copyright and license information, please view the LICENSE
	                                    * file that was distributed with this source code.
	                                    */
	
	
	var HeatMapCellRect = function HeatMapCellRect(_ref) {
	    var value = _ref.value,
	        x = _ref.x,
	        y = _ref.y,
	        width = _ref.width,
	        height = _ref.height,
	        color = _ref.color,
	        opacity = _ref.opacity,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        textColor = _ref.textColor,
	        onHover = _ref.onHover,
	        onLeave = _ref.onLeave;
	    return _react2.default.createElement(
	        'g',
	        {
	            transform: 'translate(' + x + ', ' + y + ')',
	            onMouseEnter: onHover,
	            onMouseMove: onHover,
	            onMouseLeave: onLeave,
	            style: style
	        },
	        _react2.default.createElement('rect', {
	            x: width * -0.5,
	            y: height * -0.5,
	            width: width,
	            height: height,
	            fill: color,
	            fillOpacity: opacity,
	            strokeWidth: borderWidth,
	            stroke: borderColor,
	            strokeOpacity: opacity
	        }),
	        _react2.default.createElement(
	            'text',
	            {
	                alignmentBaseline: 'central',
	                textAnchor: 'middle',
	                style: { fill: textColor },
	                fillOpacity: opacity
	            },
	            value
	        )
	    );
	};
	
	HeatMapCellRect.propTypes = {
	    value: _propTypes2.default.number.isRequired,
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired,
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    opacity: _propTypes2.default.number.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired,
	    textColor: _propTypes2.default.string.isRequired,
	    onHover: _propTypes2.default.func.isRequired,
	    onLeave: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _pure2.default)(HeatMapCellRect);

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _HeatMap = __webpack_require__(506);
	
	var _HeatMap2 = _interopRequireDefault(_HeatMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveHeatMap = function ResponsiveHeatMap(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_HeatMap2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveHeatMap;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _HeatMapCanvas = __webpack_require__(507);
	
	var _HeatMapCanvas2 = _interopRequireDefault(_HeatMapCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveHeatMapCanvas = function ResponsiveHeatMapCanvas(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_HeatMapCanvas2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveHeatMapCanvas;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HeatMap = __webpack_require__(506);
	
	Object.defineProperty(exports, 'HeatMap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeatMap).default;
	  }
	});
	
	var _HeatMapCanvas = __webpack_require__(507);
	
	Object.defineProperty(exports, 'HeatMapCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeatMapCanvas).default;
	  }
	});
	
	var _ResponsiveHeatMap = __webpack_require__(1100);
	
	Object.defineProperty(exports, 'ResponsiveHeatMap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveHeatMap).default;
	  }
	});
	
	var _ResponsiveHeatMapCanvas = __webpack_require__(1101);
	
	Object.defineProperty(exports, 'ResponsiveHeatMapCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveHeatMapCanvas).default;
	  }
	});
	
	var _props = __webpack_require__(221);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _props = __webpack_require__(19);
	
	var _SmartMotion = __webpack_require__(163);
	
	var _SmartMotion2 = _interopRequireDefault(_SmartMotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LineAreas = function LineAreas(_ref) {
	    var areaGenerator = _ref.areaGenerator,
	        areaOpacity = _ref.areaOpacity,
	        lines = _ref.lines,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            lines.map(function (_ref2) {
	                var id = _ref2.id,
	                    areaColor = _ref2.color,
	                    points = _ref2.points;
	                return _react2.default.createElement('path', {
	                    key: id,
	                    d: areaGenerator(points),
	                    fill: areaColor,
	                    fillOpacity: areaOpacity,
	                    strokeWidth: 0
	                });
	            })
	        );
	    }
	
	    var springConfig = {
	        stiffness: motionStiffness,
	        damping: motionDamping
	    };
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        lines.map(function (_ref3) {
	            var id = _ref3.id,
	                areaColor = _ref3.color,
	                points = _ref3.points;
	            return _react2.default.createElement(
	                _SmartMotion2.default,
	                {
	                    key: id,
	                    style: function style(spring) {
	                        return {
	                            d: spring(areaGenerator(points), springConfig),
	                            fill: spring(areaColor, springConfig)
	                        };
	                    }
	                },
	                function (style) {
	                    return _react2.default.createElement('path', {
	                        key: id,
	                        d: style.d,
	                        fill: areaColor,
	                        fillOpacity: areaOpacity,
	                        strokeWidth: 0
	                    });
	                }
	            );
	        })
	    );
	};
	
	LineAreas.propTypes = _extends({
	    areaOpacity: _propTypes2.default.number.isRequired
	}, _props.motionPropTypes);
	
	exports.default = (0, _pure2.default)(LineAreas);

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _props = __webpack_require__(19);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _DotsItem = __webpack_require__(311);
	
	var _DotsItem2 = _interopRequireDefault(_DotsItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LineDots = function LineDots(_ref) {
	    var lines = _ref.lines,
	        symbol = _ref.symbol,
	        size = _ref.size,
	        color = _ref.color,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        enableLabel = _ref.enableLabel,
	        label = _ref.label,
	        labelFormat = _ref.labelFormat,
	        labelYOffset = _ref.labelYOffset,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    var getLabel = (0, _propertiesConverters.getLabelGenerator)(label, labelFormat);
	
	    var points = lines.reduce(function (acc, line) {
	        var id = line.id,
	            points = line.points;
	
	
	        return [].concat(acc, points.filter(function (point) {
	            return point.value !== null;
	        }).map(function (point) {
	            var pointData = {
	                serie: { id: id },
	                x: point.key,
	                y: point.value
	            };
	
	            return {
	                key: id + '.' + point.x,
	                x: point.x,
	                y: point.y,
	                fill: color(line),
	                stroke: borderColor(line),
	                label: enableLabel ? getLabel(pointData) : null
	            };
	        }));
	    }, []);
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            points.map(function (point) {
	                return _react2.default.createElement(_DotsItem2.default, {
	                    key: point.key,
	                    x: point.x,
	                    y: point.y,
	                    symbol: symbol,
	                    size: size,
	                    color: point.fill,
	                    borderWidth: borderWidth,
	                    borderColor: point.stroke,
	                    label: point.label,
	                    labelYOffset: labelYOffset,
	                    theme: theme
	                });
	            })
	        );
	    }
	    var springConfig = {
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            styles: points.map(function (point) {
	                return {
	                    key: point.key,
	                    data: point,
	                    style: {
	                        x: (0, _reactMotion.spring)(point.x, springConfig),
	                        y: (0, _reactMotion.spring)(point.y, springConfig),
	                        size: (0, _reactMotion.spring)(size, springConfig)
	                    }
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref2) {
	                    var key = _ref2.key,
	                        style = _ref2.style,
	                        point = _ref2.data;
	                    return _react2.default.createElement(_DotsItem2.default, _extends({
	                        key: key
	                    }, style, {
	                        symbol: symbol,
	                        color: point.fill,
	                        borderWidth: borderWidth,
	                        borderColor: point.stroke,
	                        label: point.label,
	                        labelYOffset: labelYOffset,
	                        theme: theme
	                    }));
	                })
	            );
	        }
	    );
	};
	
	LineDots.propTypes = _extends({
	    lines: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired
	    })),
	
	    symbol: _propTypes2.default.func,
	    size: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.func.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.func.isRequired,
	
	    // labels
	    enableLabel: _propTypes2.default.bool.isRequired,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    labelFormat: _propTypes2.default.string,
	    labelYOffset: _propTypes2.default.number,
	
	    // theming
	    theme: _propTypes2.default.shape({
	        dots: _propTypes2.default.shape({
	            textColor: _propTypes2.default.string.isRequired,
	            fontSize: _propTypes2.default.string.isRequired
	        }).isRequired
	    }).isRequired
	
	}, _props.motionPropTypes);
	
	LineDots.defaultProps = {
	    // labels
	    enableLabel: false,
	    label: 'y'
	};
	
	exports.default = LineDots;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _props = __webpack_require__(19);
	
	var _SmartMotion = __webpack_require__(163);
	
	var _SmartMotion2 = _interopRequireDefault(_SmartMotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LineLines = function LineLines(_ref) {
	    var lines = _ref.lines,
	        lineGenerator = _ref.lineGenerator,
	        lineWidth = _ref.lineWidth,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            lines.map(function (_ref2) {
	                var id = _ref2.id,
	                    lineColor = _ref2.color,
	                    points = _ref2.points;
	                return _react2.default.createElement('path', {
	                    key: id,
	                    d: lineGenerator(points),
	                    fill: 'none',
	                    strokeWidth: lineWidth,
	                    stroke: lineColor
	                });
	            })
	        );
	    }
	
	    var springConfig = {
	        stiffness: motionStiffness,
	        damping: motionDamping
	    };
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        lines.map(function (_ref3) {
	            var id = _ref3.id,
	                lineColor = _ref3.color,
	                points = _ref3.points;
	            return _react2.default.createElement(
	                _SmartMotion2.default,
	                {
	                    key: id,
	                    style: function style(spring) {
	                        return {
	                            d: spring(lineGenerator(points), springConfig),
	                            stroke: spring(lineColor, springConfig)
	                        };
	                    }
	                },
	                function (style) {
	                    return _react2.default.createElement('path', {
	                        key: id,
	                        d: style.d,
	                        fill: 'none',
	                        strokeWidth: lineWidth,
	                        stroke: style.stroke
	                    });
	                }
	            );
	        })
	    );
	};
	
	LineLines.propTypes = _extends({
	    lineWidth: _propTypes2.default.number.isRequired
	}, _props.motionPropTypes);
	
	exports.default = (0, _pure2.default)(LineLines);

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _LineSlicesItem = __webpack_require__(1107);
	
	var _LineSlicesItem2 = _interopRequireDefault(_LineSlicesItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var LineSlices = function LineSlices(_ref) {
	    var slices = _ref.slices,
	        height = _ref.height,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        theme = _ref.theme,
	        tooltipFormat = _ref.tooltipFormat;
	    return _react2.default.createElement(
	        'g',
	        null,
	        slices.map(function (slice) {
	            return _react2.default.createElement(_LineSlicesItem2.default, {
	                key: slice.id,
	                slice: slice,
	                height: height,
	                showTooltip: showTooltip,
	                hideTooltip: hideTooltip,
	                theme: theme,
	                tooltipFormat: tooltipFormat
	            });
	        })
	    );
	};
	
	LineSlices.propTypes = {
	    slices: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired,
	        x: _propTypes2.default.number.isRequired,
	        points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	            id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	            value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	            color: _propTypes2.default.string.isRequired
	        })).isRequired
	    })).isRequired,
	    height: _propTypes2.default.number.isRequired,
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _pure2.default)(LineSlices);

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(108);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _withState = __webpack_require__(98);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _withHandlers = __webpack_require__(180);
	
	var _withHandlers2 = _interopRequireDefault(_withHandlers);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _TableTooltip = __webpack_require__(222);
	
	var _TableTooltip2 = _interopRequireDefault(_TableTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chip = function Chip(_ref) {
	    var color = _ref.color;
	    return _react2.default.createElement('span', { style: { display: 'block', width: '12px', height: '12px', background: color } });
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	
	var LineSlicesItem = function LineSlicesItem(_ref2) {
	    var slice = _ref2.slice,
	        height = _ref2.height,
	        showTooltip = _ref2.showTooltip,
	        hideTooltip = _ref2.hideTooltip,
	        isHover = _ref2.isHover;
	    return _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + slice.x + ', 0)' },
	        isHover && _react2.default.createElement('line', {
	            x1: 0,
	            x2: 0,
	            y1: 0,
	            y2: height,
	            stroke: '#000',
	            strokeOpacity: 0.35,
	            strokeWidth: 1
	        }),
	        _react2.default.createElement('rect', {
	            x: -20,
	            width: 40,
	            height: height,
	            fill: '#000',
	            fillOpacity: 0,
	            onMouseEnter: showTooltip,
	            onMouseMove: showTooltip,
	            onMouseLeave: hideTooltip
	        })
	    );
	};
	
	LineSlicesItem.propTypes = {
	    slice: _propTypes2.default.object.isRequired,
	    height: _propTypes2.default.number.isRequired,
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    isHover: _propTypes2.default.bool.isRequired,
	    theme: _propTypes2.default.object.isRequired
	};
	
	var enhance = (0, _compose2.default)((0, _withState2.default)('isHover', 'setIsHover', false), (0, _withPropsOnChange2.default)(['slice', 'theme', 'tooltipFormat'], function (_ref3) {
	    var slice = _ref3.slice,
	        theme = _ref3.theme,
	        tooltipFormat = _ref3.tooltipFormat;
	
	    var format = !tooltipFormat || (0, _isFunction3.default)(tooltipFormat) ? tooltipFormat : (0, _d3Format.format)(tooltipFormat);
	    var hasValues = slice.points.some(function (p) {
	        return p.value !== null;
	    });
	
	    return {
	        tooltip: hasValues ? _react2.default.createElement(_TableTooltip2.default, {
	            theme: theme,
	            rows: slice.points.filter(function (p) {
	                return p.value !== null;
	            }).map(function (p) {
	                return [_react2.default.createElement(Chip, { color: p.color }), p.id, format ? format(p.value) : p.value];
	            })
	        }) : null
	    };
	}), (0, _withHandlers2.default)({
	    showTooltip: function showTooltip(_ref4) {
	        var _showTooltip = _ref4.showTooltip,
	            setIsHover = _ref4.setIsHover,
	            tooltip = _ref4.tooltip;
	        return function (e) {
	            setIsHover(true);
	            _showTooltip(tooltip, e);
	        };
	    },
	    hideTooltip: function hideTooltip(_ref5) {
	        var _hideTooltip = _ref5.hideTooltip,
	            setIsHover = _ref5.setIsHover;
	        return function () {
	            setIsHover(false);
	            _hideTooltip();
	        };
	    }
	}), _pure2.default);
	
	exports.default = enhance(LineSlicesItem);

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Line = __webpack_require__(510);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveLine = function ResponsiveLine(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Line2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveLine;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Line = __webpack_require__(510);
	
	Object.defineProperty(exports, 'Line', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Line).default;
	  }
	});
	
	var _ResponsiveLine = __webpack_require__(1108);
	
	Object.defineProperty(exports, 'ResponsiveLine', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveLine).default;
	  }
	});
	
	var _props = __webpack_require__(511);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _polar = __webpack_require__(60);
	
	var _d3Shape = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var lineGenerator = (0, _d3Shape.line)().x(function (d) {
	    return d.x;
	}).y(function (d) {
	    return d.y;
	});
	
	var PieRadialLabels = function (_Component) {
	    _inherits(PieRadialLabels, _Component);
	
	    function PieRadialLabels() {
	        _classCallCheck(this, PieRadialLabels);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    PieRadialLabels.prototype.render = function render() {
	        var _props = this.props,
	            data = _props.data,
	            label = _props.label,
	            radius = _props.radius,
	            skipAngle = _props.skipAngle,
	            linkOffset = _props.linkOffset,
	            linkDiagonalLength = _props.linkDiagonalLength,
	            linkHorizontalLength = _props.linkHorizontalLength,
	            linkStrokeWidth = _props.linkStrokeWidth,
	            textXOffset = _props.textXOffset,
	            textColor = _props.textColor,
	            linkColor = _props.linkColor,
	            theme = _props.theme;
	
	
	        return _react2.default.createElement(
	            'g',
	            null,
	            data.filter(function (d) {
	                return skipAngle === 0 || d.angleDegrees > skipAngle;
	            }).map(function (d) {
	                var angle = (0, _polar.midAngle)(d) - Math.PI / 2;
	                var positionA = (0, _polar.positionFromAngle)(angle, radius + linkOffset);
	                var positionB = (0, _polar.positionFromAngle)(angle, radius + linkOffset + linkDiagonalLength);
	                var positionC = void 0;
	                var labelPosition = void 0;
	                var textAnchor = void 0;
	                if (angle + Math.PI / 2 < Math.PI) {
	                    positionC = { x: positionB.x + linkHorizontalLength, y: positionB.y };
	                    labelPosition = {
	                        x: positionB.x + linkHorizontalLength + textXOffset,
	                        y: positionB.y
	                    };
	                    textAnchor = 'start';
	                } else {
	                    positionC = { x: positionB.x - linkHorizontalLength, y: positionB.y };
	                    labelPosition = {
	                        x: positionB.x - linkHorizontalLength - textXOffset,
	                        y: positionB.y
	                    };
	                    textAnchor = 'end';
	                }
	
	                return _react2.default.createElement(
	                    'g',
	                    { key: d.data.id },
	                    _react2.default.createElement('path', {
	                        d: lineGenerator([positionA, positionB, positionC]),
	                        fill: 'none',
	                        style: { fill: 'none', stroke: linkColor(d.data, theme) },
	                        strokeWidth: linkStrokeWidth
	                    }),
	                    _react2.default.createElement(
	                        'g',
	                        { transform: 'translate(' + labelPosition.x + ', ' + labelPosition.y + ')' },
	                        _react2.default.createElement(
	                            'text',
	                            {
	                                textAnchor: textAnchor,
	                                dy: '0.3em',
	                                style: {
	                                    fill: textColor(d.data, theme),
	                                    fontSize: theme.axis.fontSize
	                                }
	                            },
	                            label(d.data)
	                        )
	                    )
	                );
	            })
	        );
	    };
	
	    return PieRadialLabels;
	}(_react.Component);
	
	PieRadialLabels.propTypes = {
	    label: _propTypes2.default.func.isRequired,
	    skipAngle: _propTypes2.default.number.isRequired,
	    radius: _propTypes2.default.number.isRequired,
	    linkOffset: _propTypes2.default.number.isRequired,
	    linkDiagonalLength: _propTypes2.default.number.isRequired,
	    linkHorizontalLength: _propTypes2.default.number.isRequired,
	    linkStrokeWidth: _propTypes2.default.number.isRequired,
	    textXOffset: _propTypes2.default.number.isRequired,
	    textColor: _propTypes2.default.func.isRequired,
	    linkColor: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.shape({
	        axis: _propTypes2.default.shape({
	            tickColor: _propTypes2.default.string.isRequired,
	            fontSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	        }).isRequired
	    }).isRequired
	};
	PieRadialLabels.defaultProps = {
	    skipAngle: 0,
	    linkOffset: 0,
	    linkDiagonalLength: 16,
	    linkHorizontalLength: 24,
	    linkStrokeWidth: 1,
	    textXOffset: 6
	};
	exports.default = PieRadialLabels;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _polar = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var sliceStyle = {
	    pointerEvents: 'none'
	};
	
	var PieSlicesLabels = function (_Component) {
	    _inherits(PieSlicesLabels, _Component);
	
	    function PieSlicesLabels() {
	        _classCallCheck(this, PieSlicesLabels);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    PieSlicesLabels.prototype.render = function render() {
	        var _props = this.props,
	            data = _props.data,
	            label = _props.label,
	            radius = _props.radius,
	            skipAngle = _props.skipAngle,
	            innerRadius = _props.innerRadius,
	            textColor = _props.textColor,
	            theme = _props.theme;
	
	
	        var centerRadius = innerRadius + (radius - innerRadius) / 2;
	
	        return _react2.default.createElement(
	            'g',
	            null,
	            data.filter(function (d) {
	                return skipAngle === 0 || d.angleDegrees > skipAngle;
	            }).map(function (d) {
	                var angle = (0, _polar.midAngle)(d) - Math.PI / 2;
	                var position = (0, _polar.positionFromAngle)(angle, centerRadius);
	
	                return _react2.default.createElement(
	                    'g',
	                    {
	                        key: d.data.id,
	                        transform: 'translate(' + position.x + ', ' + position.y + ')',
	                        style: sliceStyle
	                    },
	                    _react2.default.createElement(
	                        'text',
	                        {
	                            textAnchor: 'middle',
	                            style: {
	                                fill: textColor(d.data, theme),
	                                fontSize: theme.axis.fontSize
	                            }
	                        },
	                        label(d.data)
	                    )
	                );
	            })
	        );
	    };
	
	    return PieSlicesLabels;
	}(_react.Component);
	
	PieSlicesLabels.propTypes = {
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    skipAngle: _propTypes2.default.number.isRequired,
	    radius: _propTypes2.default.number.isRequired,
	    innerRadius: _propTypes2.default.number.isRequired,
	    textColor: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.shape({
	        axis: _propTypes2.default.shape({
	            textColor: _propTypes2.default.string.isRequired,
	            fontSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	        }).isRequired
	    }).isRequired
	};
	PieSlicesLabels.defaultProps = {
	    skipAngle: 0
	};
	exports.default = PieSlicesLabels;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Pie = __webpack_require__(512);
	
	var _Pie2 = _interopRequireDefault(_Pie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsivePie = function ResponsivePie(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Pie2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsivePie;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _hocs = __webpack_require__(52);
	
	var _props = __webpack_require__(305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (Component) {
	    return (0, _compose2.default)((0, _defaultProps2.default)(_props.PieDefaultProps), (0, _hocs.withTheme)(), (0, _hocs.withDimensions)(), (0, _hocs.withColors)(), _pure2.default)(Component);
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Pie = __webpack_require__(512);
	
	Object.defineProperty(exports, 'Pie', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pie).default;
	  }
	});
	
	var _ResponsivePie = __webpack_require__(1112);
	
	Object.defineProperty(exports, 'ResponsivePie', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsivePie).default;
	  }
	});
	
	var _props = __webpack_require__(305);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _props = __webpack_require__(19);
	
	var _polar = __webpack_require__(60);
	
	var _RadarGridLabels = __webpack_require__(1116);
	
	var _RadarGridLabels2 = _interopRequireDefault(_RadarGridLabels);
	
	var _RadarGridLevels = __webpack_require__(1117);
	
	var _RadarGridLevels2 = _interopRequireDefault(_RadarGridLevels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadarGrid = function RadarGrid(_ref) {
	    var indices = _ref.indices,
	        shape = _ref.shape,
	        radius = _ref.radius,
	        radii = _ref.radii,
	        angles = _ref.angles,
	        angleStep = _ref.angleStep,
	        labelOffset = _ref.labelOffset,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    var motionProps = {
	        animate: animate,
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        angles.map(function (angle, i) {
	            var position = (0, _polar.positionFromAngle)(angle, radius);
	            return _react2.default.createElement('line', _extends({
	                key: 'axis.' + i,
	                x1: 0,
	                y1: 0,
	                x2: position.x,
	                y2: position.y
	            }, theme.grid));
	        }),
	        _react2.default.createElement(_RadarGridLevels2.default, _extends({
	            shape: shape,
	            radii: radii,
	            angleStep: angleStep,
	            dataLength: indices.length,
	            theme: theme
	        }, motionProps)),
	        _react2.default.createElement(_RadarGridLabels2.default, _extends({
	            radius: radius,
	            angles: angles,
	            indices: indices,
	            labelOffset: labelOffset,
	            theme: theme
	        }, motionProps))
	    );
	};
	
	RadarGrid.propTypes = _extends({
	    indices: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])).isRequired,
	    shape: _propTypes2.default.oneOf(['circular', 'linear']).isRequired,
	    radius: _propTypes2.default.number.isRequired,
	    angleStep: _propTypes2.default.number.isRequired,
	
	    labelOffset: _propTypes2.default.number.isRequired,
	
	    theme: _propTypes2.default.object.isRequired
	
	}, _props.motionPropTypes);
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['indices', 'levels', 'radius', 'angleStep'], function (props) {
	    return {
	        radii: (0, _range3.default)(props.levels).map(function (i) {
	            return props.radius / props.levels * (i + 1);
	        }).reverse(),
	        angles: (0, _range3.default)(props.indices.length).map(function (i) {
	            return i * props.angleStep - Math.PI / 2;
	        })
	    };
	}), _pure2.default);
	
	exports.default = enhance(RadarGrid);

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _props = __webpack_require__(19);
	
	var _polar = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textAnchorFromAngle = function textAnchorFromAngle(_angle) {
	    var angle = (0, _polar.radiansToDegrees)(_angle) + 90;
	    if (angle <= 10 || angle >= 350 || angle >= 170 && angle <= 190) return 'middle';
	    if (angle > 180) return 'end';
	    return 'start';
	};
	
	var RadarGridLabels = function RadarGridLabels(_ref) {
	    var radius = _ref.radius,
	        angles = _ref.angles,
	        indices = _ref.indices,
	        labelOffset = _ref.labelOffset,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    var springConfig = {
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    var labels = indices.map(function (index, i) {
	        var position = (0, _polar.positionFromAngle)(angles[i], radius + labelOffset);
	        var textAnchor = textAnchorFromAngle(angles[i]);
	
	        return _extends({
	            key: 'label.' + i,
	            label: index,
	            textAnchor: textAnchor
	        }, position);
	    });
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            labels.map(function (label) {
	                return _react2.default.createElement(
	                    'text',
	                    _extends({
	                        style: {
	                            fill: theme.axis.textColor,
	                            fontSize: theme.axis.fontSize
	                        },
	                        dy: '0.5em'
	                    }, label),
	                    label.label
	                );
	            })
	        );
	    }
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            styles: labels.map(function (label) {
	                return {
	                    key: label.key,
	                    data: {
	                        label: label.label,
	                        textAnchor: label.textAnchor
	                    },
	                    style: {
	                        x: (0, _reactMotion.spring)(label.x, springConfig),
	                        y: (0, _reactMotion.spring)(label.y, springConfig)
	                    }
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref2) {
	                    var key = _ref2.key,
	                        style = _ref2.style,
	                        data = _ref2.data;
	                    return _react2.default.createElement(
	                        'text',
	                        _extends({
	                            key: key,
	                            dy: '0.5em',
	                            textAnchor: data.textAnchor,
	                            style: {
	                                fill: theme.axis.textColor,
	                                fontSize: theme.axis.fontSize
	                            }
	                        }, style),
	                        data.label
	                    );
	                })
	            );
	        }
	    );
	};
	
	RadarGridLabels.propTypes = _extends({
	    radius: _propTypes2.default.number.isRequired,
	    angles: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	
	    indices: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])).isRequired,
	    labelOffset: _propTypes2.default.number.isRequired,
	
	    theme: _propTypes2.default.object.isRequired
	
	}, _props.motionPropTypes);
	
	exports.default = (0, _pure2.default)(RadarGridLabels);

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _reactMotion = __webpack_require__(25);
	
	var _props = __webpack_require__(19);
	
	var _d3Shape = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var levelWillEnter = function levelWillEnter() {
	    return { r: 0 };
	};
	
	var RadarGridLevels = function RadarGridLevels(_ref) {
	    var shape = _ref.shape,
	        radii = _ref.radii,
	        angleStep = _ref.angleStep,
	        dataLength = _ref.dataLength,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    var springConfig = {
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    var levelsTransitionProps = {
	        willEnter: levelWillEnter,
	        willLeave: function willLeave() {
	            return { r: (0, _reactMotion.spring)(0, springConfig) };
	        },
	        styles: radii.map(function (r, i) {
	            return {
	                key: 'level.' + i,
	                style: {
	                    r: (0, _reactMotion.spring)(r, springConfig)
	                }
	            };
	        })
	    };
	
	    if (shape === 'circular') {
	        if (animate !== true) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                radii.map(function (r, i) {
	                    return _react2.default.createElement('circle', _extends({ key: 'level.' + i, fill: 'none', r: r }, theme.grid));
	                })
	            );
	        }
	
	        return _react2.default.createElement(
	            _reactMotion.TransitionMotion,
	            levelsTransitionProps,
	            function (interpolatedStyles) {
	                return _react2.default.createElement(
	                    'g',
	                    null,
	                    interpolatedStyles.map(function (_ref2) {
	                        var key = _ref2.key,
	                            style = _ref2.style,
	                            data = _ref2.data;
	                        return _react2.default.createElement('circle', _extends({ key: key, fill: 'none', r: style.r }, theme.grid));
	                    })
	                );
	            }
	        );
	    }
	
	    var radarLineGenerator = (0, _d3Shape.lineRadial)().angle(function (i) {
	        return i * angleStep;
	    }).curve(_d3Shape.curveLinearClosed);
	
	    var points = (0, _range3.default)(dataLength);
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            radii.map(function (radius, i) {
	                return _react2.default.createElement('path', _extends({
	                    key: 'level.' + i,
	                    fill: 'none',
	                    d: radarLineGenerator.radius(radius)(points)
	                }, theme.grid));
	            })
	        );
	    }
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        levelsTransitionProps,
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref3) {
	                    var key = _ref3.key,
	                        style = _ref3.style,
	                        data = _ref3.data;
	                    return _react2.default.createElement('path', _extends({
	                        key: key,
	                        fill: 'none',
	                        d: radarLineGenerator.radius(style.r)(points)
	                    }, theme.grid));
	                })
	            );
	        }
	    );
	};
	
	RadarGridLevels.propTypes = _extends({
	    shape: _propTypes2.default.oneOf(['circular', 'linear']).isRequired,
	    radii: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	    angleStep: _propTypes2.default.number.isRequired,
	    dataLength: _propTypes2.default.number.isRequired,
	
	    theme: _propTypes2.default.object.isRequired
	
	}, _props.motionPropTypes);
	
	exports.default = (0, _pure2.default)(RadarGridLevels);

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _props = __webpack_require__(19);
	
	var _colors = __webpack_require__(24);
	
	var _SmartMotion = __webpack_require__(163);
	
	var _SmartMotion2 = _interopRequireDefault(_SmartMotion);
	
	var _d3Shape = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadarShapes = function RadarShapes(_ref) {
	    var data = _ref.data,
	        keys = _ref.keys,
	        colorByKey = _ref.colorByKey,
	        lineGenerator = _ref.lineGenerator,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        fillOpacity = _ref.fillOpacity,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            keys.map(function (key) {
	                return _react2.default.createElement('path', {
	                    key: key,
	                    d: lineGenerator(data.map(function (d) {
	                        return d[key];
	                    })),
	                    fill: colorByKey[key],
	                    fillOpacity: fillOpacity,
	                    stroke: borderColor({ key: key, color: colorByKey[key] }),
	                    strokeWidth: borderWidth
	                });
	            })
	        );
	    }
	
	    var springConfig = {
	        stiffness: motionStiffness,
	        damping: motionDamping
	    };
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        keys.map(function (key) {
	            return _react2.default.createElement(
	                _SmartMotion2.default,
	                {
	                    key: key,
	                    style: function style(spring) {
	                        return {
	                            d: spring(lineGenerator(data.map(function (d) {
	                                return d[key];
	                            })), springConfig),
	                            fill: spring(colorByKey[key], springConfig),
	                            stroke: spring(borderColor({ key: key, color: colorByKey[key] }), springConfig)
	                        };
	                    }
	                },
	                function (style) {
	                    return _react2.default.createElement('path', _extends({ fillOpacity: fillOpacity, strokeWidth: borderWidth }, style));
	                }
	            );
	        })
	    );
	};
	
	RadarShapes.propTypes = _extends({
	    // data
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])).isRequired,
	    colorByKey: _propTypes2.default.object.isRequired,
	
	    radiusScale: _propTypes2.default.func.isRequired,
	    angleStep: _propTypes2.default.number.isRequired,
	
	    curveInterpolator: _propTypes2.default.func.isRequired,
	    lineGenerator: _propTypes2.default.func.isRequired,
	
	    // border
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.func.isRequired,
	
	    // theming
	    fillOpacity: _propTypes2.default.number.isRequired
	
	}, _props.motionPropTypes);
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['borderColor'], function (props) {
	    return {
	        borderColor: (0, _colors.getInheritedColorGenerator)(props.borderColor)
	    };
	}), (0, _withPropsOnChange2.default)(['radiusScale', 'angleStep', 'curveInterpolator'], function (_ref2) {
	    var radiusScale = _ref2.radiusScale,
	        angleStep = _ref2.angleStep,
	        curveInterpolator = _ref2.curveInterpolator;
	    return {
	        lineGenerator: (0, _d3Shape.lineRadial)().radius(function (d) {
	            return radiusScale(d);
	        }).angle(function (d, i) {
	            return i * angleStep;
	        }).curve(curveInterpolator)
	    };
	}), _pure2.default);
	
	exports.default = enhance(RadarShapes);

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _d3Shape = __webpack_require__(13);
	
	var _RadarTooltipItem = __webpack_require__(1120);
	
	var _RadarTooltipItem2 = _interopRequireDefault(_RadarTooltipItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadarTooltip = function RadarTooltip(_ref) {
	    var data = _ref.data,
	        keys = _ref.keys,
	        getIndex = _ref.getIndex,
	        colorByKey = _ref.colorByKey,
	        radius = _ref.radius,
	        angleStep = _ref.angleStep,
	        theme = _ref.theme,
	        tooltipFormat = _ref.tooltipFormat,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip;
	
	    var arc = (0, _d3Shape.arc)().outerRadius(radius).innerRadius(0);
	
	    var halfAngleStep = angleStep * 0.5;
	    var rootStartAngle = -halfAngleStep;
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        data.map(function (d, i) {
	            var index = getIndex(d);
	            var startAngle = rootStartAngle;
	            var endAngle = startAngle + angleStep;
	
	            rootStartAngle += angleStep;
	
	            return _react2.default.createElement(_RadarTooltipItem2.default, {
	                key: index,
	                datum: d,
	                keys: keys,
	                index: index,
	                colorByKey: colorByKey,
	                startAngle: startAngle,
	                endAngle: endAngle,
	                radius: radius,
	                arcGenerator: arc,
	                theme: theme,
	                tooltipFormat: tooltipFormat,
	                showTooltip: showTooltip,
	                hideTooltip: hideTooltip
	            });
	        })
	    );
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	
	RadarTooltip.propTypes = {
	    data: _propTypes2.default.array.isRequired,
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])).isRequired,
	    getIndex: _propTypes2.default.func.isRequired,
	    colorByKey: _propTypes2.default.object.isRequired,
	
	    radius: _propTypes2.default.number.isRequired,
	    angleStep: _propTypes2.default.number.isRequired,
	
	    theme: _propTypes2.default.object.isRequired,
	
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _pure2.default)(RadarTooltip);

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sortBy2 = __webpack_require__(78);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(108);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withState = __webpack_require__(98);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _withHandlers = __webpack_require__(180);
	
	var _withHandlers2 = _interopRequireDefault(_withHandlers);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _polar = __webpack_require__(60);
	
	var _TableTooltip = __webpack_require__(222);
	
	var _TableTooltip2 = _interopRequireDefault(_TableTooltip);
	
	var _Chip = __webpack_require__(166);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadarTooltipItem = function RadarTooltipItem(_ref) {
	    var path = _ref.path,
	        tipX = _ref.tipX,
	        tipY = _ref.tipY,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        isHover = _ref.isHover;
	    return _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('line', { x1: 0, y1: 0, x2: tipX, y2: tipY, stroke: '#000', strokeOpacity: isHover ? 0.35 : 0 }),
	        _react2.default.createElement('path', {
	            d: path,
	            fill: '#F00',
	            fillOpacity: 0,
	            onMouseEnter: showTooltip,
	            onMouseMove: showTooltip,
	            onMouseLeave: hideTooltip
	        })
	    );
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	
	RadarTooltipItem.propTypes = {
	    datum: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired,
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])).isRequired,
	    index: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    colorByKey: _propTypes2.default.object.isRequired,
	
	    startAngle: _propTypes2.default.number.isRequired,
	    endAngle: _propTypes2.default.number.isRequired,
	    radius: _propTypes2.default.number.isRequired,
	    tipX: _propTypes2.default.number.isRequired, // computed
	    tipY: _propTypes2.default.number.isRequired, // computed
	
	    arcGenerator: _propTypes2.default.func.isRequired, // computed
	    path: _propTypes2.default.string.isRequired, // computed
	
	    theme: _propTypes2.default.object.isRequired,
	
	    showTooltip: _propTypes2.default.func.isRequired, // re-computed
	    hideTooltip: _propTypes2.default.func.isRequired, // re-computed
	
	    isHover: _propTypes2.default.bool.isRequired // computed
	};
	
	var enhance = (0, _compose2.default)((0, _withState2.default)('isHover', 'setIsHover', false), (0, _withPropsOnChange2.default)(['datum', 'keys', 'index', 'colorByKey', 'theme', 'tooltipFormat'], function (_ref2) {
	    var datum = _ref2.datum,
	        keys = _ref2.keys,
	        index = _ref2.index,
	        colorByKey = _ref2.colorByKey,
	        theme = _ref2.theme,
	        tooltipFormat = _ref2.tooltipFormat;
	
	    var format = !tooltipFormat || (0, _isFunction3.default)(tooltipFormat) ? tooltipFormat : (0, _d3Format.format)(tooltipFormat);
	
	    return {
	        tooltip: _react2.default.createElement(_TableTooltip2.default, {
	            title: _react2.default.createElement(
	                'strong',
	                null,
	                index
	            ),
	            rows: (0, _sortBy3.default)(keys.map(function (key) {
	                return [_react2.default.createElement(_Chip2.default, { color: colorByKey[key] }), key, format ? format(datum[key]) : datum[key]];
	            }), '2').reverse(),
	            theme: theme
	        })
	    };
	}), (0, _withPropsOnChange2.default)(['startAngle', 'endAngle', 'radius', 'arcGenerator'], function (_ref3) {
	    var startAngle = _ref3.startAngle,
	        endAngle = _ref3.endAngle,
	        radius = _ref3.radius,
	        arcGenerator = _ref3.arcGenerator;
	
	    var position = (0, _polar.positionFromAngle)(startAngle + (endAngle - startAngle) * 0.5 - Math.PI / 2, radius);
	
	    return {
	        path: arcGenerator({ startAngle: startAngle, endAngle: endAngle }),
	        tipX: position.x,
	        tipY: position.y
	    };
	}), (0, _withHandlers2.default)({
	    showTooltip: function showTooltip(_ref4) {
	        var _showTooltip = _ref4.showTooltip,
	            setIsHover = _ref4.setIsHover,
	            tooltip = _ref4.tooltip;
	        return function (e) {
	            setIsHover(true);
	            _showTooltip(tooltip, e);
	        };
	    },
	    hideTooltip: function hideTooltip(_ref5) {
	        var _hideTooltip = _ref5.hideTooltip,
	            setIsHover = _ref5.setIsHover;
	        return function () {
	            setIsHover(false);
	            _hideTooltip();
	        };
	    }
	}), _pure2.default);
	
	exports.default = enhance(RadarTooltipItem);

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Radar = __webpack_require__(513);
	
	var _Radar2 = _interopRequireDefault(_Radar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveRadar = function ResponsiveRadar(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Radar2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveRadar;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Radar = __webpack_require__(513);
	
	Object.defineProperty(exports, 'Radar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Radar).default;
	  }
	});
	Object.keys(_Radar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Radar[key];
	    }
	  });
	});
	
	var _ResponsiveRadar = __webpack_require__(1121);
	
	Object.defineProperty(exports, 'ResponsiveRadar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveRadar).default;
	  }
	});
	
	var _RadarDots = __webpack_require__(514);
	
	Object.defineProperty(exports, 'RadarDots', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RadarDots).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Sankey = __webpack_require__(515);
	
	var _Sankey2 = _interopRequireDefault(_Sankey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveSankey = function ResponsiveSankey(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Sankey2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveSankey;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _reactMotion = __webpack_require__(25);
	
	var _colors = __webpack_require__(24);
	
	var _props = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SankeyLabels = function SankeyLabels(_ref) {
	    var nodes = _ref.nodes,
	        width = _ref.width,
	        labelPosition = _ref.labelPosition,
	        labelPadding = _ref.labelPadding,
	        labelOrientation = _ref.labelOrientation,
	        getLabelTextColor = _ref.getLabelTextColor,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness;
	
	    var labelRotation = labelOrientation === 'vertical' ? -90 : 0;
	    var labels = nodes.map(function (node) {
	        var x = void 0;
	        var textAnchor = void 0;
	        if (node.x < width / 2) {
	            if (labelPosition === 'inside') {
	                x = node.x1 + labelPadding;
	                textAnchor = labelOrientation === 'vertical' ? 'middle' : 'start';
	            } else {
	                x = node.x - labelPadding;
	                textAnchor = labelOrientation === 'vertical' ? 'middle' : 'end';
	            }
	        } else {
	            if (labelPosition === 'inside') {
	                x = node.x - labelPadding;
	                textAnchor = labelOrientation === 'vertical' ? 'middle' : 'end';
	            } else {
	                x = node.x1 + labelPadding;
	                textAnchor = labelOrientation === 'vertical' ? 'middle' : 'start';
	            }
	        }
	
	        return {
	            id: node.id,
	            label: node.label,
	            x: x,
	            y: node.y + node.height / 2,
	            textAnchor: textAnchor,
	            color: getLabelTextColor(node)
	        };
	    });
	
	    if (!animate) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            labels.map(function (label) {
	                return _react2.default.createElement(
	                    'text',
	                    {
	                        key: label.id,
	                        alignmentBaseline: 'central',
	                        textAnchor: label.textAnchor,
	                        transform: 'translate(' + label.x + ', ' + label.y + ') rotate(' + labelRotation + ')',
	                        style: _extends({}, theme.sankey.label, { fill: label.color })
	                    },
	                    label.label
	                );
	            })
	        );
	    }
	
	    var springProps = {
	        damping: motionDamping,
	        stiffness: motionStiffness
	    };
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            styles: labels.map(function (label) {
	                return {
	                    key: label.id,
	                    data: label,
	                    style: _extends({
	                        x: (0, _reactMotion.spring)(label.x, springProps),
	                        y: (0, _reactMotion.spring)(label.y, springProps),
	                        rotation: (0, _reactMotion.spring)(labelRotation, springProps)
	                    }, (0, _colors.colorMotionSpring)(label.color, springProps))
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref2) {
	                    var key = _ref2.key,
	                        style = _ref2.style,
	                        data = _ref2.data;
	
	                    var color = (0, _colors.getInterpolatedColor)(style);
	
	                    return _react2.default.createElement(
	                        'text',
	                        {
	                            key: key,
	                            transform: 'translate(' + style.x + ', ' + style.y + ') rotate(' + style.rotation + ')',
	                            alignmentBaseline: 'central',
	                            textAnchor: data.textAnchor,
	                            style: _extends({}, theme.sankey.label, {
	                                fill: color,
	                                pointerEvents: 'none'
	                            })
	                        },
	                        data.label
	                    );
	                })
	            );
	        }
	    );
	};
	
	SankeyLabels.propTypes = _extends({
	    nodes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	        label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	        x1: _propTypes2.default.number.isRequired,
	        x: _propTypes2.default.number.isRequired,
	        y: _propTypes2.default.number.isRequired,
	        width: _propTypes2.default.number.isRequired,
	        height: _propTypes2.default.number.isRequired
	    })).isRequired,
	
	    width: _propTypes2.default.number.isRequired,
	
	    labelPosition: _propTypes2.default.oneOf(['inside', 'outside']).isRequired,
	    labelPadding: _propTypes2.default.number.isRequired,
	    labelOrientation: _propTypes2.default.oneOf(['horizontal', 'vertical']).isRequired,
	    getLabelTextColor: _propTypes2.default.func.isRequired,
	
	    theme: _propTypes2.default.shape({
	        sankey: _propTypes2.default.shape({
	            label: _propTypes2.default.object.isRequired
	        }).isRequired
	    }).isRequired
	
	}, _props.motionPropTypes);
	
	exports.default = (0, _pure2.default)(SankeyLabels);

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _d3Sankey = __webpack_require__(252);
	
	var _props = __webpack_require__(19);
	
	var _SmartMotion = __webpack_require__(163);
	
	var _SmartMotion2 = _interopRequireDefault(_SmartMotion);
	
	var _SankeyLinksItem = __webpack_require__(1126);
	
	var _SankeyLinksItem2 = _interopRequireDefault(_SankeyLinksItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLinkPath = (0, _d3Sankey.sankeyLinkHorizontal)();
	
	var SankeyLinks = function SankeyLinks(_ref) {
	    var links = _ref.links,
	        linkOpacity = _ref.linkOpacity,
	        linkHoverOpacity = _ref.linkHoverOpacity,
	        linkHoverOthersOpacity = _ref.linkHoverOthersOpacity,
	        linkContract = _ref.linkContract,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        setCurrentLink = _ref.setCurrentLink,
	        currentNode = _ref.currentNode,
	        currentLink = _ref.currentLink,
	        isCurrentLink = _ref.isCurrentLink,
	        onClick = _ref.onClick,
	        tooltipFormat = _ref.tooltipFormat,
	        tooltip = _ref.tooltip,
	        theme = _ref.theme;
	
	    var getOpacity = function getOpacity(link) {
	        if (!currentNode && !currentLink) return linkOpacity;
	        if (isCurrentLink(link)) return linkHoverOpacity;
	        return linkHoverOthersOpacity;
	    };
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            links.map(function (link) {
	                return _react2.default.createElement(_SankeyLinksItem2.default, {
	                    key: link.source.id + '.' + link.target.id,
	                    link: link,
	                    path: getLinkPath(link),
	                    width: Math.max(1, link.width - linkContract * 2),
	                    color: link.color,
	                    opacity: getOpacity(link),
	                    contract: linkContract,
	                    showTooltip: showTooltip,
	                    hideTooltip: hideTooltip,
	                    setCurrent: setCurrentLink,
	                    onClick: onClick,
	                    tooltip: tooltip,
	                    theme: theme,
	                    tooltipFormat: tooltipFormat
	                });
	            })
	        );
	    }
	
	    var springConfig = {
	        stiffness: motionStiffness,
	        damping: motionDamping
	    };
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        links.map(function (link) {
	            return _react2.default.createElement(
	                _SmartMotion2.default,
	                {
	                    key: link.source.id + '.' + link.target.id,
	                    style: function style(spring) {
	                        return {
	                            path: spring(getLinkPath(link), springConfig),
	                            width: spring(Math.max(1, link.width - linkContract * 2), springConfig),
	                            color: spring(link.color, springConfig),
	                            opacity: spring(getOpacity(link), springConfig),
	                            contract: spring(linkContract, springConfig)
	                        };
	                    }
	                },
	                function (style) {
	                    return _react2.default.createElement(_SankeyLinksItem2.default, _extends({
	                        link: link
	                    }, style, {
	                        showTooltip: showTooltip,
	                        hideTooltip: hideTooltip,
	                        setCurrent: setCurrentLink,
	                        onClick: onClick,
	                        tooltip: tooltip,
	                        theme: theme,
	                        tooltipFormat: tooltipFormat
	                    }));
	                }
	            );
	        })
	    );
	};
	
	SankeyLinks.propTypes = _extends({
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        source: _propTypes2.default.shape({
	            id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	            label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	        }).isRequired,
	        target: _propTypes2.default.shape({
	            id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	            label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	        }).isRequired,
	        width: _propTypes2.default.number.isRequired,
	        color: _propTypes2.default.string.isRequired
	    })).isRequired,
	
	    // links
	    linkOpacity: _propTypes2.default.number.isRequired,
	    linkHoverOpacity: _propTypes2.default.number.isRequired,
	    linkHoverOthersOpacity: _propTypes2.default.number.isRequired,
	    linkContract: _propTypes2.default.number.isRequired,
	
	    theme: _propTypes2.default.object.isRequired,
	    tooltip: _propTypes2.default.func
	
	}, _props.motionPropTypes, {
	
	    // interactivity
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    setCurrentLink: _propTypes2.default.func.isRequired,
	    currentLink: _propTypes2.default.object,
	    isCurrentLink: _propTypes2.default.func.isRequired,
	    onClick: _propTypes2.default.func.isRequired
	});
	
	exports.default = (0, _pure2.default)(SankeyLinks);

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withState = __webpack_require__(98);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _withHandlers = __webpack_require__(180);
	
	var _withHandlers2 = _interopRequireDefault(_withHandlers);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	var _Chip = __webpack_require__(166);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tooltipStyles = {
	    container: {
	        display: 'flex',
	        alignItems: 'center'
	    },
	    sourceChip: {
	        marginRight: 7
	    },
	    targetChip: {
	        marginLeft: 7,
	        marginRight: 7
	    }
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	
	var TooltipContent = function TooltipContent(_ref) {
	    var link = _ref.link,
	        format = _ref.format;
	    return _react2.default.createElement(
	        'span',
	        { style: tooltipStyles.container },
	        _react2.default.createElement(_Chip2.default, { color: link.source.color, style: tooltipStyles.sourceChip }),
	        _react2.default.createElement(
	            'strong',
	            null,
	            link.source.label
	        ),
	        '\xA0>\xA0',
	        _react2.default.createElement(
	            'strong',
	            null,
	            link.target.label
	        ),
	        _react2.default.createElement(_Chip2.default, { color: link.target.color, style: tooltipStyles.targetChip }),
	        _react2.default.createElement(
	            'strong',
	            null,
	            format ? format(link.value) : link.value
	        )
	    );
	};
	
	var SankeyLinksItem = function SankeyLinksItem(_ref2) {
	    var link = _ref2.link,
	        path = _ref2.path,
	        width = _ref2.width,
	        color = _ref2.color,
	        opacity = _ref2.opacity,
	        contract = _ref2.contract,
	        handleMouseEnter = _ref2.handleMouseEnter,
	        handleMouseMove = _ref2.handleMouseMove,
	        handleMouseLeave = _ref2.handleMouseLeave,
	        onClick = _ref2.onClick;
	    return _react2.default.createElement('path', {
	        fill: 'none',
	        d: path,
	        strokeWidth: Math.max(1, width - contract * 2),
	        stroke: color,
	        strokeOpacity: opacity,
	        onMouseEnter: handleMouseEnter,
	        onMouseMove: handleMouseMove,
	        onMouseLeave: handleMouseLeave,
	        onClick: onClick
	    });
	};
	
	SankeyLinksItem.propTypes = {
	    link: _propTypes2.default.shape({
	        source: _propTypes2.default.shape({
	            id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	            label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	        }).isRequired,
	        target: _propTypes2.default.shape({
	            id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	            label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	        }).isRequired,
	        color: _propTypes2.default.string.isRequired,
	        value: _propTypes2.default.number.isRequired
	    }).isRequired,
	
	    path: _propTypes2.default.string.isRequired,
	    width: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    opacity: _propTypes2.default.number.isRequired,
	    contract: _propTypes2.default.number.isRequired,
	
	    theme: _propTypes2.default.object.isRequired,
	
	    // interactivity
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    setCurrent: _propTypes2.default.func.isRequired,
	    onClick: _propTypes2.default.func.isRequired
	};
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['link', 'theme', 'tooltip', 'tooltipFormat'], function (_ref3) {
	    var link = _ref3.link,
	        theme = _ref3.theme,
	        tooltip = _ref3.tooltip,
	        tooltipFormat = _ref3.tooltipFormat;
	
	    if (tooltip) {
	        return {
	            tooltip: _react2.default.createElement(_BasicTooltip2.default, { id: tooltip(link), enableChip: false, theme: theme })
	        };
	    }
	    return {
	        tooltip: _react2.default.createElement(_BasicTooltip2.default, {
	            id: _react2.default.createElement(TooltipContent, { format: tooltipFormat, link: link }),
	            theme: theme
	        })
	    };
	}), (0, _withPropsOnChange2.default)(['onClick', 'link'], function (_ref4) {
	    var _onClick = _ref4.onClick,
	        link = _ref4.link;
	    return {
	        onClick: function onClick(event) {
	            return _onClick(link, event);
	        }
	    };
	}), (0, _withHandlers2.default)({
	    handleMouseEnter: function handleMouseEnter(_ref5) {
	        var showTooltip = _ref5.showTooltip,
	            setCurrent = _ref5.setCurrent,
	            link = _ref5.link,
	            tooltip = _ref5.tooltip;
	        return function (e) {
	            setCurrent(link);
	            showTooltip(tooltip, e);
	        };
	    },
	    handleMouseMove: function handleMouseMove(_ref6) {
	        var showTooltip = _ref6.showTooltip,
	            tooltip = _ref6.tooltip;
	        return function (e) {
	            showTooltip(tooltip, e);
	        };
	    },
	    handleMouseLeave: function handleMouseLeave(_ref7) {
	        var hideTooltip = _ref7.hideTooltip,
	            setCurrent = _ref7.setCurrent;
	        return function () {
	            setCurrent(null);
	            hideTooltip();
	        };
	    }
	}), _pure2.default);
	
	exports.default = enhance(SankeyLinksItem);

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _reactMotion = __webpack_require__(25);
	
	var _colors = __webpack_require__(24);
	
	var _props = __webpack_require__(19);
	
	var _SankeyNodesItem = __webpack_require__(1128);
	
	var _SankeyNodesItem2 = _interopRequireDefault(_SankeyNodesItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SankeyNodes = function SankeyNodes(_ref) {
	    var nodes = _ref.nodes,
	        nodeOpacity = _ref.nodeOpacity,
	        nodeHoverOpacity = _ref.nodeHoverOpacity,
	        nodeHoverOthersOpacity = _ref.nodeHoverOthersOpacity,
	        nodeBorderWidth = _ref.nodeBorderWidth,
	        getNodeBorderColor = _ref.getNodeBorderColor,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        setCurrentNode = _ref.setCurrentNode,
	        currentNode = _ref.currentNode,
	        currentLink = _ref.currentLink,
	        isCurrentNode = _ref.isCurrentNode,
	        onClick = _ref.onClick,
	        tooltip = _ref.tooltip,
	        theme = _ref.theme;
	
	    var getOpacity = function getOpacity(node) {
	        if (!currentNode && !currentLink) return nodeOpacity;
	        if (isCurrentNode(node)) return nodeHoverOpacity;
	        return nodeHoverOthersOpacity;
	    };
	
	    if (!animate) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            nodes.map(function (node) {
	                return _react2.default.createElement(_SankeyNodesItem2.default, {
	                    key: node.id,
	                    node: node,
	                    x: node.x,
	                    y: node.y,
	                    width: node.width,
	                    height: node.height,
	                    color: node.color,
	                    opacity: getOpacity(node),
	                    borderWidth: nodeBorderWidth,
	                    borderColor: getNodeBorderColor(node),
	                    showTooltip: showTooltip,
	                    hideTooltip: hideTooltip,
	                    setCurrent: setCurrentNode,
	                    onClick: onClick,
	                    tooltip: tooltip,
	                    theme: theme
	                });
	            })
	        );
	    }
	
	    var springProps = {
	        damping: motionDamping,
	        stiffness: motionStiffness
	    };
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            styles: nodes.map(function (node) {
	                return {
	                    key: node.id,
	                    data: node,
	                    style: _extends({
	                        x: (0, _reactMotion.spring)(node.x, springProps),
	                        y: (0, _reactMotion.spring)(node.y, springProps),
	                        width: (0, _reactMotion.spring)(node.width, springProps),
	                        height: (0, _reactMotion.spring)(node.height, springProps),
	                        opacity: (0, _reactMotion.spring)(getOpacity(node), springProps)
	                    }, (0, _colors.colorMotionSpring)(node.color, springProps))
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref2) {
	                    var key = _ref2.key,
	                        style = _ref2.style,
	                        node = _ref2.data;
	
	                    var color = (0, _colors.getInterpolatedColor)(style);
	
	                    return _react2.default.createElement(_SankeyNodesItem2.default, {
	                        key: key,
	                        node: node,
	                        x: style.x,
	                        y: style.y,
	                        width: Math.max(style.width, 0),
	                        height: Math.max(style.height, 0),
	                        color: color,
	                        opacity: style.opacity,
	                        borderWidth: nodeBorderWidth,
	                        borderColor: getNodeBorderColor(_extends({}, node, { color: color })),
	                        showTooltip: showTooltip,
	                        hideTooltip: hideTooltip,
	                        setCurrent: setCurrentNode,
	                        onClick: onClick,
	                        tooltip: tooltip,
	                        theme: theme
	                    });
	                })
	            );
	        }
	    );
	};
	
	SankeyNodes.propTypes = _extends({
	    nodes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	        x: _propTypes2.default.number.isRequired,
	        y: _propTypes2.default.number.isRequired,
	        width: _propTypes2.default.number.isRequired,
	        height: _propTypes2.default.number.isRequired,
	        color: _propTypes2.default.string.isRequired
	    })).isRequired,
	
	    nodePaddingX: _propTypes2.default.number.isRequired,
	    nodeOpacity: _propTypes2.default.number.isRequired,
	    nodeHoverOpacity: _propTypes2.default.number.isRequired,
	    nodeHoverOthersOpacity: _propTypes2.default.number.isRequired,
	    nodeBorderWidth: _propTypes2.default.number.isRequired,
	    getNodeBorderColor: _propTypes2.default.func.isRequired,
	
	    theme: _propTypes2.default.object.isRequired,
	    tooltip: _propTypes2.default.func
	
	}, _props.motionPropTypes, {
	
	    // interactivity
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    setCurrentNode: _propTypes2.default.func.isRequired,
	    currentNode: _propTypes2.default.object,
	    currentLink: _propTypes2.default.object,
	    isCurrentNode: _propTypes2.default.func.isRequired,
	    onClick: _propTypes2.default.func.isRequired
	});
	
	exports.default = (0, _pure2.default)(SankeyNodes);

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withState = __webpack_require__(98);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _withHandlers = __webpack_require__(180);
	
	var _withHandlers2 = _interopRequireDefault(_withHandlers);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var SankeyNodesItem = function SankeyNodesItem(_ref) {
	    var node = _ref.node,
	        x = _ref.x,
	        y = _ref.y,
	        width = _ref.width,
	        height = _ref.height,
	        color = _ref.color,
	        opacity = _ref.opacity,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        handleMouseEnter = _ref.handleMouseEnter,
	        handleMouseMove = _ref.handleMouseMove,
	        handleMouseLeave = _ref.handleMouseLeave,
	        onClick = _ref.onClick;
	    return _react2.default.createElement('rect', {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        fill: color,
	        fillOpacity: opacity,
	        strokeWidth: borderWidth,
	        stroke: borderColor,
	        strokeOpacity: opacity,
	        onMouseEnter: handleMouseEnter,
	        onMouseMove: handleMouseMove,
	        onMouseLeave: handleMouseLeave,
	        onClick: onClick
	    });
	};
	
	SankeyNodesItem.propTypes = {
	    node: _propTypes2.default.shape({
	        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	        label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	        color: _propTypes2.default.string.isRequired
	    }),
	
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired,
	    width: _propTypes2.default.number.isRequired,
	    height: _propTypes2.default.number.isRequired,
	
	    color: _propTypes2.default.string.isRequired,
	    opacity: _propTypes2.default.number.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired,
	
	    // interactivity
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    setCurrent: _propTypes2.default.func.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	
	    tooltip: _propTypes2.default.element.isRequired,
	    theme: _propTypes2.default.object.isRequired
	};
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['node', 'theme', 'tooltip'], function (_ref2) {
	    var node = _ref2.node,
	        theme = _ref2.theme,
	        tooltip = _ref2.tooltip;
	
	    if (tooltip) {
	        return {
	            tooltip: _react2.default.createElement(_BasicTooltip2.default, { id: tooltip(node), enableChip: false, theme: theme })
	        };
	    }
	    return {
	        tooltip: _react2.default.createElement(_BasicTooltip2.default, { id: node.label, enableChip: true, color: node.color, theme: theme })
	    };
	}), (0, _withPropsOnChange2.default)(['onClick', 'node'], function (_ref3) {
	    var _onClick = _ref3.onClick,
	        node = _ref3.node;
	    return {
	        onClick: function onClick(event) {
	            return _onClick(node, event);
	        }
	    };
	}), (0, _withHandlers2.default)({
	    handleMouseEnter: function handleMouseEnter(_ref4) {
	        var showTooltip = _ref4.showTooltip,
	            setCurrent = _ref4.setCurrent,
	            node = _ref4.node,
	            tooltip = _ref4.tooltip;
	        return function (e) {
	            setCurrent(node);
	            showTooltip(tooltip, e);
	        };
	    },
	    handleMouseMove: function handleMouseMove(_ref5) {
	        var showTooltip = _ref5.showTooltip,
	            tooltip = _ref5.tooltip;
	        return function (e) {
	            showTooltip(tooltip, e);
	        };
	    },
	    handleMouseLeave: function handleMouseLeave(_ref6) {
	        var hideTooltip = _ref6.hideTooltip,
	            setCurrent = _ref6.setCurrent;
	        return function () {
	            setCurrent(null);
	            hideTooltip();
	        };
	    }
	}), _pure2.default);
	
	exports.default = enhance(SankeyNodesItem);

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withState = __webpack_require__(98);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _colors = __webpack_require__(24);
	
	var _propertiesConverters = __webpack_require__(64);
	
	var _hocs = __webpack_require__(52);
	
	var _props = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (Component) {
	    return (0, _compose2.default)((0, _defaultProps2.default)(_props.SankeyDefaultProps), (0, _withState2.default)('currentNode', 'setCurrentNode', null), (0, _withState2.default)('currentLink', 'setCurrentLink', null), (0, _hocs.withColors)(), (0, _hocs.withColors)({
	        colorByKey: 'linkColorBy',
	        destKey: 'getLinkColor',
	        defaultColorBy: 'source.id'
	    }), (0, _hocs.withTheme)(), (0, _hocs.withDimensions)(), (0, _hocs.withMotion)(), (0, _withPropsOnChange2.default)(['nodeBorderColor'], function (_ref) {
	        var nodeBorderColor = _ref.nodeBorderColor;
	        return {
	            getNodeBorderColor: (0, _colors.getInheritedColorGenerator)(nodeBorderColor)
	        };
	    }), (0, _withPropsOnChange2.default)(['labelTextColor'], function (_ref2) {
	        var labelTextColor = _ref2.labelTextColor;
	        return {
	            getLabelTextColor: (0, _colors.getInheritedColorGenerator)(labelTextColor)
	        };
	    }), (0, _withPropsOnChange2.default)(['label', 'labelFormat'], function (_ref3) {
	        var label = _ref3.label,
	            labelFormat = _ref3.labelFormat;
	        return {
	            getLabel: (0, _propertiesConverters.getLabelGenerator)(label, labelFormat)
	        };
	    }), _pure2.default)(Component);
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Sankey = __webpack_require__(515);
	
	Object.defineProperty(exports, 'Sankey', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sankey).default;
	  }
	});
	
	var _ResponsiveSankey = __webpack_require__(1123);
	
	Object.defineProperty(exports, 'ResponsiveSankey', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveSankey).default;
	  }
	});
	
	var _props = __webpack_require__(306);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Stream = __webpack_require__(516);
	
	var _Stream2 = _interopRequireDefault(_Stream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveStream = function ResponsiveStream(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Stream2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveStream;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _props = __webpack_require__(19);
	
	var _SmartMotion = __webpack_require__(163);
	
	var _SmartMotion2 = _interopRequireDefault(_SmartMotion);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StreamLayers = function StreamLayers(_ref) {
	    var layers = _ref.layers,
	        fillOpacity = _ref.fillOpacity,
	        borderWidth = _ref.borderWidth,
	        getBorderColor = _ref.getBorderColor,
	        theme = _ref.theme,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        animate = _ref.animate,
	        motionStiffness = _ref.motionStiffness,
	        motionDamping = _ref.motionDamping;
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            layers.map(function (layer, i) {
	                var id = layer.id,
	                    path = layer.path,
	                    color = layer.color;
	
	
	                var handleTooltip = function handleTooltip(e) {
	                    return showTooltip(_react2.default.createElement(_BasicTooltip2.default, { id: id, enableChip: true, color: color, theme: theme }), e);
	                };
	
	                return _react2.default.createElement('path', {
	                    key: i,
	                    onMouseMove: handleTooltip,
	                    onMouseEnter: handleTooltip,
	                    onMouseLeave: hideTooltip,
	                    d: path,
	                    fill: layer.fill ? layer.fill : layer.color,
	                    fillOpacity: fillOpacity,
	                    stroke: getBorderColor(layer),
	                    strokeWidth: borderWidth
	                });
	            })
	        );
	    }
	
	    var springConfig = {
	        stiffness: motionStiffness,
	        damping: motionDamping
	    };
	
	    return _react2.default.createElement(
	        'g',
	        null,
	        layers.map(function (layer, i) {
	            var id = layer.id,
	                path = layer.path,
	                color = layer.color;
	
	
	            var handleTooltip = function handleTooltip(e) {
	                return showTooltip(_react2.default.createElement(_BasicTooltip2.default, { id: id, enableChip: true, color: color, theme: theme }), e);
	            };
	
	            return _react2.default.createElement(
	                _SmartMotion2.default,
	                {
	                    key: i,
	                    style: function style(spring) {
	                        return {
	                            d: spring(path, springConfig),
	                            fill: spring(color, springConfig),
	                            fillOpacity: spring(fillOpacity, springConfig)
	                        };
	                    }
	                },
	                function (style) {
	                    return _react2.default.createElement('path', _extends({
	                        onMouseMove: handleTooltip,
	                        onMouseEnter: handleTooltip,
	                        onMouseLeave: hideTooltip
	                    }, style, {
	                        fill: layer.fill ? layer.fill : style.fill,
	                        stroke: getBorderColor(layer),
	                        strokeWidth: borderWidth
	                    }));
	                }
	            );
	        })
	    );
	};
	
	StreamLayers.propTypes = _extends({
	    fillOpacity: _propTypes2.default.number.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    getBorderColor: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired
	
	}, _props.motionPropTypes);
	
	exports.default = StreamLayers;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _StreamSlicesItem = __webpack_require__(1134);
	
	var _StreamSlicesItem2 = _interopRequireDefault(_StreamSlicesItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var StreamSlices = function StreamSlices(_ref) {
	    var slices = _ref.slices,
	        height = _ref.height,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        theme = _ref.theme,
	        tooltipFormat = _ref.tooltipFormat;
	    return _react2.default.createElement(
	        'g',
	        null,
	        slices.map(function (slice) {
	            return _react2.default.createElement(_StreamSlicesItem2.default, {
	                key: slice.index,
	                slice: slice,
	                height: height,
	                showTooltip: showTooltip,
	                hideTooltip: hideTooltip,
	                theme: theme,
	                tooltipFormat: tooltipFormat
	            });
	        })
	    );
	};
	
	StreamSlices.propTypes = {
	    slices: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        index: _propTypes2.default.number.isRequired,
	        x: _propTypes2.default.number.isRequired,
	        stack: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	            id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	            value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	            color: _propTypes2.default.string.isRequired
	        })).isRequired
	    })).isRequired,
	    height: _propTypes2.default.number.isRequired,
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _pure2.default)(StreamSlices);

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Format = __webpack_require__(108);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _withState = __webpack_require__(98);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _withHandlers = __webpack_require__(180);
	
	var _withHandlers2 = _interopRequireDefault(_withHandlers);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _TableTooltip = __webpack_require__(222);
	
	var _TableTooltip2 = _interopRequireDefault(_TableTooltip);
	
	var _Chip = __webpack_require__(166);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var StreamSlicesItem = function StreamSlicesItem(_ref) {
	    var slice = _ref.slice,
	        height = _ref.height,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        isHover = _ref.isHover;
	    return _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + slice.x + ', 0)' },
	        isHover && _react2.default.createElement('line', {
	            x1: 0,
	            x2: 0,
	            y1: 0,
	            y2: height,
	            stroke: '#000',
	            strokeOpacity: 0.35,
	            strokeWidth: 1
	        }),
	        _react2.default.createElement('rect', {
	            x: -20,
	            width: 40,
	            height: height,
	            fill: '#000',
	            fillOpacity: 0,
	            onMouseEnter: showTooltip,
	            onMouseMove: showTooltip,
	            onMouseLeave: hideTooltip
	        })
	    );
	};
	
	StreamSlicesItem.propTypes = {
	    slice: _propTypes2.default.object.isRequired,
	    height: _propTypes2.default.number.isRequired,
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    isHover: _propTypes2.default.bool.isRequired,
	    theme: _propTypes2.default.object.isRequired
	};
	
	var enhance = (0, _compose2.default)((0, _withState2.default)('isHover', 'setIsHover', false), (0, _withPropsOnChange2.default)(['slice', 'theme', 'tooltipFormat'], function (_ref2) {
	    var slice = _ref2.slice,
	        theme = _ref2.theme,
	        tooltipFormat = _ref2.tooltipFormat;
	
	    var format = !tooltipFormat || (0, _isFunction3.default)(tooltipFormat) ? tooltipFormat : (0, _d3Format.format)(tooltipFormat);
	
	    return {
	        tooltip: _react2.default.createElement(_TableTooltip2.default, {
	            theme: theme,
	            rows: slice.stack.map(function (p) {
	                return [_react2.default.createElement(_Chip2.default, { color: p.color }), p.id, format ? format(p.value) : p.value];
	            })
	        })
	    };
	}), (0, _withHandlers2.default)({
	    showTooltip: function showTooltip(_ref3) {
	        var _showTooltip = _ref3.showTooltip,
	            setIsHover = _ref3.setIsHover,
	            tooltip = _ref3.tooltip;
	        return function (e) {
	            setIsHover(true);
	            _showTooltip(tooltip, e);
	        };
	    },
	    hideTooltip: function hideTooltip(_ref4) {
	        var _hideTooltip = _ref4.hideTooltip,
	            setIsHover = _ref4.setIsHover;
	        return function () {
	            setIsHover(false);
	            _hideTooltip();
	        };
	    }
	}), _pure2.default);
	
	exports.default = enhance(StreamSlicesItem);

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _max2 = __webpack_require__(104);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _min2 = __webpack_require__(129);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Shape = __webpack_require__(13);
	
	var _d3Scale = __webpack_require__(71);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _props = __webpack_require__(19);
	
	var _hocs = __webpack_require__(52);
	
	var _colors = __webpack_require__(24);
	
	var _props2 = __webpack_require__(307);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stackMin = function stackMin(layers) {
	    return (0, _min3.default)(layers.reduce(function (acc, layer) {
	        return [].concat(acc, layer.map(function (d) {
	            return d[0];
	        }));
	    }, []));
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	var stackMax = function stackMax(layers) {
	    return (0, _max3.default)(layers.reduce(function (acc, layer) {
	        return [].concat(acc, layer.map(function (d) {
	            return d[1];
	        }));
	    }, []));
	};
	
	exports.default = function (Component) {
	    return (0, _compose2.default)((0, _defaultProps2.default)(_props2.StreamDefaultProps), (0, _hocs.withTheme)(), (0, _hocs.withCurve)(), (0, _hocs.withDimensions)(), (0, _hocs.withMotion)(), (0, _withPropsOnChange2.default)(['curveInterpolator'], function (_ref) {
	        var curveInterpolator = _ref.curveInterpolator;
	        return {
	            areaGenerator: (0, _d3Shape.area)().x(function (_ref2) {
	                var x = _ref2.x;
	                return x;
	            }).y0(function (_ref3) {
	                var y1 = _ref3.y1;
	                return y1;
	            }).y1(function (_ref4) {
	                var y2 = _ref4.y2;
	                return y2;
	            }).curve(curveInterpolator)
	        };
	    }), (0, _withPropsOnChange2.default)(['colors'], function (_ref5) {
	        var colors = _ref5.colors;
	        return {
	            getColor: (0, _colors.getColorRange)(colors)
	        };
	    }), (0, _withPropsOnChange2.default)(['borderColor'], function (_ref6) {
	        var borderColor = _ref6.borderColor;
	        return {
	            getBorderColor: (0, _colors.getInheritedColorGenerator)(borderColor)
	        };
	    }), (0, _withPropsOnChange2.default)(['keys', 'offsetType', 'order'], function (_ref7) {
	        var keys = _ref7.keys,
	            offsetType = _ref7.offsetType,
	            order = _ref7.order;
	        return {
	            stack: (0, _d3Shape.stack)().keys(keys).offset((0, _props.stackOffsetFromProp)(offsetType)).order((0, _props.stackOrderFromProp)(order))
	        };
	    }), (0, _withPropsOnChange2.default)(['stack', 'data', 'width', 'height'], function (_ref8) {
	        var stack = _ref8.stack,
	            data = _ref8.data,
	            width = _ref8.width,
	            height = _ref8.height;
	
	        var layers = stack(data);
	        layers.forEach(function (layer) {
	            layer.forEach(function (point) {
	                point.value = point.data[layer.key];
	            });
	        });
	
	        var minValue = stackMin(layers);
	        var maxValue = stackMax(layers);
	
	        return {
	            layers: layers,
	            xScale: (0, _d3Scale.scalePoint)().domain((0, _range3.default)(data.length)).range([0, width]),
	            yScale: (0, _d3Scale.scaleLinear)().domain([minValue, maxValue]).range([height, 0])
	        };
	    }), _pure2.default)(Component);
	};

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Stream = __webpack_require__(516);
	
	Object.defineProperty(exports, 'Stream', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Stream).default;
	  }
	});
	
	var _ResponsiveStream = __webpack_require__(1131);
	
	Object.defineProperty(exports, 'ResponsiveStream', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveStream).default;
	  }
	});
	
	var _props = __webpack_require__(307);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Sunburst = __webpack_require__(517);
	
	var _Sunburst2 = _interopRequireDefault(_Sunburst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveSunburst = function ResponsiveSunburst(props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Sunburst2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveSunburst;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _BasicTooltip = __webpack_require__(63);
	
	var _BasicTooltip2 = _interopRequireDefault(_BasicTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var SunburstArc = function SunburstArc(_ref) {
	    var node = _ref.node,
	        path = _ref.path,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip;
	    return _react2.default.createElement('path', {
	        d: path,
	        fill: node.data.color,
	        stroke: borderColor,
	        strokeWidth: borderWidth,
	        onMouseEnter: showTooltip,
	        onMouseMove: showTooltip,
	        onMouseLeave: hideTooltip
	    });
	};
	
	SunburstArc.propTypes = {
	    node: _propTypes2.default.shape({}).isRequired,
	    arcGenerator: _propTypes2.default.func.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired,
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired
	};
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['node', 'arcGenerator'], function (_ref2) {
	    var node = _ref2.node,
	        arcGenerator = _ref2.arcGenerator;
	    return {
	        path: arcGenerator(node)
	    };
	}), (0, _withPropsOnChange2.default)(['node', 'showTooltip', 'theme'], function (_ref3) {
	    var node = _ref3.node,
	        _showTooltip = _ref3.showTooltip,
	        theme = _ref3.theme;
	    return {
	        showTooltip: function showTooltip(e) {
	            _showTooltip(_react2.default.createElement(_BasicTooltip2.default, {
	                id: node.data.id,
	                enableChip: true,
	                color: node.data.color,
	                value: node.data.percentage.toFixed(2) + '%',
	                theme: theme
	            }), e);
	        }
	    };
	}), _pure2.default);
	
	exports.default = enhance(SunburstArc);

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Sunburst = __webpack_require__(517);
	
	Object.defineProperty(exports, 'Sunburst', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sunburst).default;
	  }
	});
	Object.keys(_Sunburst).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Sunburst[key];
	    }
	  });
	});
	
	var _ResponsiveSunburst = __webpack_require__(1137);
	
	Object.defineProperty(exports, 'ResponsiveSunburst', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveSunburst).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _TreeMap = __webpack_require__(518);
	
	var _TreeMap2 = _interopRequireDefault(_TreeMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_TreeMap2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _TreeMapCanvas = __webpack_require__(519);
	
	var _TreeMapCanvas2 = _interopRequireDefault(_TreeMapCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_TreeMapCanvas2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _TreeMapHtml = __webpack_require__(520);
	
	var _TreeMapHtml2 = _interopRequireDefault(_TreeMapHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_TreeMapHtml2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreeMapHtmlNode = function TreeMapHtmlNode(_ref) {
	    var node = _ref.node,
	        style = _ref.style,
	        handlers = _ref.handlers;
	
	    if (style.width <= 0 || style.height <= 0) return null;
	
	    var rotate = node.label && style.orientLabel && style.height > style.width;
	
	    return _react2.default.createElement(
	        'div',
	        _extends({
	            style: {
	                boxSizing: 'border-box',
	                position: 'absolute',
	                top: style.y,
	                left: style.x,
	                width: style.width,
	                height: style.height,
	                background: style.color,
	                overflow: 'hidden',
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                borderWidth: style.borderWidth,
	                borderStyle: 'solid',
	                borderColor: style.borderColor
	            }
	        }, handlers),
	        node.label !== false && _react2.default.createElement(
	            'span',
	            {
	                style: {
	                    color: style.labelTextColor,
	                    transform: 'rotate(' + (rotate ? '-90' : '0') + 'deg)',
	                    WebkitUserSelect: 'none',
	                    MozUserSelect: 'none',
	                    MsUserSelect: 'none',
	                    userSelect: 'none'
	                }
	            },
	            node.label
	        )
	    );
	};
	
	TreeMapHtmlNode.propTypes = {
	    node: _propTypes2.default.object.isRequired,
	    style: _propTypes2.default.shape({
	        x: _propTypes2.default.number.isRequired,
	        y: _propTypes2.default.number.isRequired,
	        width: _propTypes2.default.number.isRequired,
	        height: _propTypes2.default.number.isRequired,
	        color: _propTypes2.default.string.isRequired,
	        borderWidth: _propTypes2.default.number.isRequired,
	        borderColor: _propTypes2.default.string.isRequired,
	        labelTextColor: _propTypes2.default.string.isRequired,
	        orientLabel: _propTypes2.default.bool.isRequired
	    }).isRequired,
	    handlers: _propTypes2.default.object.isRequired
	};
	
	exports.default = TreeMapHtmlNode;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreeMapNode = function TreeMapNode(_ref) {
	    var style = _ref.style,
	        node = _ref.node,
	        handlers = _ref.handlers;
	
	    if (style.width <= 0 || style.height <= 0) return null;
	
	    var rotate = node.label && style.orientLabel && style.height > style.width;
	
	    return _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + style.x + ',' + style.y + ')' },
	        _react2.default.createElement('rect', _extends({
	            width: style.width,
	            height: style.height,
	            fill: style.fill ? style.fill : style.color,
	            strokeWidth: style.borderWidth,
	            stroke: style.borderColor
	        }, handlers)),
	        node.label && _react2.default.createElement(
	            'text',
	            {
	                textAnchor: 'middle',
	                alignmentBaseline: 'central',
	                style: { fill: style.labelTextColor, pointerEvents: 'none' },
	                transform: 'translate(' + style.width / 2 + ',' + style.height / 2 + ') rotate(' + (rotate ? -90 : 0) + ')'
	            },
	            node.label
	        )
	    );
	};
	
	TreeMapNode.propTypes = {
	    node: _propTypes2.default.object.isRequired,
	    style: _propTypes2.default.shape({
	        x: _propTypes2.default.number.isRequired,
	        y: _propTypes2.default.number.isRequired,
	        width: _propTypes2.default.number.isRequired,
	        height: _propTypes2.default.number.isRequired,
	        color: _propTypes2.default.string.isRequired,
	        borderWidth: _propTypes2.default.number.isRequired,
	        borderColor: _propTypes2.default.string.isRequired,
	        labelTextColor: _propTypes2.default.string.isRequired,
	        orientLabel: _propTypes2.default.bool.isRequired
	    }).isRequired,
	    handlers: _propTypes2.default.object.isRequired
	};
	
	exports.default = TreeMapNode;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TreeMap = __webpack_require__(518);
	
	Object.defineProperty(exports, 'TreeMap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TreeMap).default;
	  }
	});
	
	var _ResponsiveTreeMap = __webpack_require__(1140);
	
	Object.defineProperty(exports, 'ResponsiveTreeMap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveTreeMap).default;
	  }
	});
	
	var _TreeMapHtml = __webpack_require__(520);
	
	Object.defineProperty(exports, 'TreeMapHtml', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TreeMapHtml).default;
	  }
	});
	
	var _ResponsiveTreeMapHtml = __webpack_require__(1142);
	
	Object.defineProperty(exports, 'ResponsiveTreeMapHtml', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveTreeMapHtml).default;
	  }
	});
	
	var _TreeMapCanvas = __webpack_require__(519);
	
	Object.defineProperty(exports, 'TreeMapCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TreeMapCanvas).default;
	  }
	});
	
	var _ResponsiveTreeMapCanvas = __webpack_require__(1141);
	
	Object.defineProperty(exports, 'ResponsiveTreeMapCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveTreeMapCanvas).default;
	  }
	});
	
	var _props = __webpack_require__(524);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveWrapper = __webpack_require__(33);
	
	var _ResponsiveWrapper2 = _interopRequireDefault(_ResponsiveWrapper);
	
	var _Voronoi = __webpack_require__(525);
	
	var _Voronoi2 = _interopRequireDefault(_Voronoi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _ResponsiveWrapper2.default,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Voronoi2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _hocs = __webpack_require__(52);
	
	var _props = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	exports.default = function (Component) {
	  return (0, _compose2.default)((0, _defaultProps2.default)(_props.VoronoiDefaultProps), (0, _hocs.withTheme)(), (0, _hocs.withDimensions)(), _pure2.default)(Component);
	};

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Voronoi = __webpack_require__(525);
	
	Object.defineProperty(exports, 'Voronoi', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Voronoi).default;
	  }
	});
	
	var _ResponsiveVoronoi = __webpack_require__(1146);
	
	Object.defineProperty(exports, 'ResponsiveVoronoi', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveVoronoi).default;
	  }
	});
	
	var _props = __webpack_require__(309);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Defs = exports.defsMapping = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _gradients = __webpack_require__(526);
	
	var _patterns = __webpack_require__(527);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defsMapping = exports.defsMapping = _extends({}, _gradients.gradientTypes, _patterns.patternTypes);
	
	var Defs = (0, _pure2.default)(function (_ref) {
	    var definitions = _ref.defs;
	
	    if (!definitions || definitions.length < 1) return null;
	
	    return _react2.default.createElement(
	        'defs',
	        null,
	        definitions.map(function (_ref2) {
	            var type = _ref2.type,
	                def = _objectWithoutProperties(_ref2, ['type']);
	
	            if (defsMapping[type]) return _react2.default.createElement(defsMapping[type], _extends({ key: def.id }, def));
	
	            return null;
	        })
	    );
	});
	
	exports.Defs = Defs;
	Defs.propTypes = {
	    defs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        type: _propTypes2.default.oneOf(Object.keys(defsMapping)).isRequired,
	        id: _propTypes2.default.string.isRequired
	    }))
	};

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.linearGradientDef = exports.LinearGradient = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinearGradient = exports.LinearGradient = function LinearGradient(_ref) {
	    var id = _ref.id,
	        colors = _ref.colors;
	    return _react2.default.createElement(
	        'linearGradient',
	        { id: id, x1: 0, x2: 0, y1: 0, y2: 1 },
	        colors.map(function (_ref2) {
	            var offset = _ref2.offset,
	                color = _ref2.color,
	                opacity = _ref2.opacity;
	            return _react2.default.createElement('stop', {
	                key: offset,
	                offset: offset + '%',
	                stopColor: color,
	                stopOpacity: opacity !== undefined ? opacity : 1
	            });
	        })
	    );
	};
	
	LinearGradient.propTypes = {
	    id: _propTypes2.default.string.isRequired,
	    colors: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        offset: _propTypes2.default.number.isRequired,
	        color: _propTypes2.default.string.isRequired
	    })).isRequired
	};
	
	var linearGradientDef = exports.linearGradientDef = function linearGradientDef(id, colors) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return _extends({
	        id: id,
	        type: 'linearGradient',
	        colors: colors
	    }, options);
	};

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.patternDotsDef = exports.PatternDots = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PatternDots = exports.PatternDots = (0, _pure2.default)(function (_ref) {
	    var id = _ref.id,
	        background = _ref.background,
	        color = _ref.color,
	        size = _ref.size,
	        padding = _ref.padding,
	        stagger = _ref.stagger;
	
	    var fullSize = size + padding;
	    var radius = size / 2;
	    var halfPadding = padding / 2;
	    if (stagger === true) {
	        fullSize = size * 2 + padding * 2;
	    }
	
	    return _react2.default.createElement(
	        'pattern',
	        { id: id, width: fullSize, height: fullSize, patternUnits: 'userSpaceOnUse' },
	        _react2.default.createElement('rect', { width: fullSize, height: fullSize, fill: background }),
	        _react2.default.createElement('circle', { cx: halfPadding + radius, cy: halfPadding + radius, r: radius, fill: color }),
	        stagger && _react2.default.createElement('circle', {
	            cx: padding * 1.5 + size + radius,
	            cy: padding * 1.5 + size + radius,
	            r: radius,
	            fill: color
	        })
	    );
	});
	
	PatternDots.propTypes = {
	    id: _propTypes2.default.string.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    background: _propTypes2.default.string.isRequired,
	    size: _propTypes2.default.number.isRequired,
	    padding: _propTypes2.default.number.isRequired,
	    stagger: _propTypes2.default.bool.isRequired
	};
	
	PatternDots.defaultProps = {
	    color: '#000000',
	    background: '#ffffff',
	    size: 4,
	    padding: 4,
	    stagger: false
	};
	
	var patternDotsDef = exports.patternDotsDef = function patternDotsDef(id) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return _extends({
	        id: id,
	        type: 'patternDots'
	    }, options);
	};

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.patternLinesDef = exports.PatternLines = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _polar = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PatternLines = exports.PatternLines = (0, _pure2.default)(function (_ref) {
	    var id = _ref.id,
	        _spacing = _ref.spacing,
	        _rotation = _ref.rotation,
	        background = _ref.background,
	        color = _ref.color,
	        lineWidth = _ref.lineWidth;
	
	    var rotation = Math.round(_rotation) % 360;
	    var spacing = Math.abs(_spacing);
	
	    if (rotation > 180) rotation = rotation - 360;else if (rotation > 90) rotation = rotation - 180;else if (rotation < -180) rotation = rotation + 360;else if (rotation < -90) rotation = rotation + 180;
	
	    var width = spacing;
	    var height = spacing;
	    var path = void 0;
	
	    if (rotation === 0) {
	        path = '\n                M 0 0 L ' + width + ' 0\n                M 0 ' + height + ' L ' + width + ' ' + height + '\n            ';
	    } else if (rotation === 90) {
	        path = '\n                M 0 0 L 0 ' + height + '\n                M ' + width + ' 0 L ' + width + ' ' + height + '\n            ';
	    } else {
	        width = Math.abs(spacing / Math.sin((0, _polar.degreesToRadians)(rotation)));
	        height = spacing / Math.sin((0, _polar.degreesToRadians)(90 - rotation));
	
	        if (rotation > 0) {
	            path = '\n                    M 0 ' + -height + ' L ' + width * 2 + ' ' + height + '\n                    M ' + -width + ' ' + -height + ' L ' + width + ' ' + height + '\n                    M ' + -width + ' 0 L ' + width + ' ' + height * 2 + '\n                ';
	        } else {
	            path = '\n                    M ' + -width + ' ' + height + ' L ' + width + ' ' + -height + '\n                    M ' + -width + ' ' + height * 2 + ' L ' + width * 2 + ' ' + -height + '\n                    M 0 ' + height * 2 + ' L ' + width * 2 + ' 0\n                ';
	        }
	    }
	
	    return _react2.default.createElement(
	        'pattern',
	        { id: id, width: width, height: height, patternUnits: 'userSpaceOnUse' },
	        _react2.default.createElement('rect', {
	            width: width,
	            height: height,
	            fill: background,
	            stroke: 'rgba(255, 0, 0, 0.1)',
	            strokeWidth: 0
	        }),
	        _react2.default.createElement('path', { d: path, strokeWidth: lineWidth, stroke: color, strokeLinecap: 'square' })
	    );
	});
	
	PatternLines.propTypes = {
	    id: _propTypes2.default.string.isRequired,
	    spacing: _propTypes2.default.number.isRequired,
	    rotation: _propTypes2.default.number.isRequired,
	    background: _propTypes2.default.string.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    lineWidth: _propTypes2.default.number.isRequired
	};
	
	PatternLines.defaultProps = {
	    spacing: 5,
	    rotation: 0,
	    color: '#000000',
	    background: '#ffffff',
	    lineWidth: 2
	};
	
	var patternLinesDef = exports.patternLinesDef = function patternLinesDef(id) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return _extends({
	        id: id,
	        type: 'patternLines'
	    }, options);
	};

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.patternSquaresDef = exports.PatternSquares = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PatternSquares = exports.PatternSquares = (0, _pure2.default)(function (_ref) {
	    var id = _ref.id,
	        background = _ref.background,
	        color = _ref.color,
	        size = _ref.size,
	        padding = _ref.padding,
	        stagger = _ref.stagger;
	
	    var fullSize = size + padding;
	    var halfPadding = padding / 2;
	    if (stagger === true) {
	        fullSize = size * 2 + padding * 2;
	    }
	
	    return _react2.default.createElement(
	        'pattern',
	        { id: id, width: fullSize, height: fullSize, patternUnits: 'userSpaceOnUse' },
	        _react2.default.createElement('rect', { width: fullSize, height: fullSize, fill: background }),
	        _react2.default.createElement('rect', { x: halfPadding, y: halfPadding, width: size, height: size, fill: color }),
	        stagger && _react2.default.createElement('rect', {
	            x: padding * 1.5 + size,
	            y: padding * 1.5 + size,
	            width: size,
	            height: size,
	            fill: color
	        })
	    );
	});
	
	PatternSquares.propTypes = {
	    id: _propTypes2.default.string.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    background: _propTypes2.default.string.isRequired,
	    size: _propTypes2.default.number.isRequired,
	    padding: _propTypes2.default.number.isRequired,
	    stagger: _propTypes2.default.bool.isRequired
	};
	
	PatternSquares.defaultProps = {
	    color: '#000000',
	    background: '#ffffff',
	    size: 4,
	    padding: 4,
	    stagger: false
	};
	
	var patternSquaresDef = exports.patternSquaresDef = function patternSquaresDef(id) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return _extends({
	        id: id,
	        type: 'patternSquares'
	    }, options);
	};

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DotsItemSymbol = function DotsItemSymbol(_ref) {
	    var size = _ref.size,
	        color = _ref.color,
	        borderWidth = _ref.borderWidth,
	        borderColor = _ref.borderColor;
	    return _react2.default.createElement('circle', {
	        r: size / 2,
	        fill: color,
	        stroke: borderColor,
	        strokeWidth: borderWidth,
	        style: { pointerEvents: 'none' }
	    });
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	
	
	DotsItemSymbol.propTypes = {
	    size: _propTypes2.default.number.isRequired,
	    color: _propTypes2.default.string.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    borderColor: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _pure2.default)(DotsItemSymbol);

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DotsItem = __webpack_require__(311);
	
	Object.defineProperty(exports, 'DotsItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DotsItem).default;
	  }
	});
	Object.keys(_DotsItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DotsItem[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _directions = __webpack_require__(223);
	
	Object.keys(_directions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directions[key];
	    }
	  });
	});

/***/ },
/* 1157 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var defaultTheme = exports.defaultTheme = {
	    axis: {
	        textColor: '#000',
	        fontSize: '11px',
	        tickColor: '#000',
	        legendColor: '#000',
	        legendFontSize: '11px'
	    },
	    grid: {
	        stroke: '#ddd',
	        strokeWidth: 1,
	        strokeDasharray: ''
	    },
	    markers: {
	        lineColor: '#000',
	        lineStrokeWidth: 1,
	        textColor: '#000',
	        fontSize: '11px'
	    },
	    dots: {
	        textColor: '#000',
	        fontSize: '11px'
	    },
	    tooltip: {
	        container: {
	            background: 'white',
	            color: 'inherit',
	            fontSize: 'inherit',
	            borderRadius: '2px',
	            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
	            padding: '5px 9px'
	        },
	        basic: {
	            whiteSpace: 'pre',
	            display: 'flex',
	            alignItems: 'center'
	        },
	        table: {},
	        tableCell: {
	            padding: '3px 5px'
	        }
	    },
	    labels: {
	        textColor: '#000'
	    },
	    sankey: {
	        label: {}
	    }
	};

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _setPropTypes2 = __webpack_require__(179);
	
	var _setPropTypes3 = _interopRequireDefault(_setPropTypes2);
	
	var _defaultProps2 = __webpack_require__(41);
	
	var _defaultProps3 = _interopRequireDefault(_defaultProps2);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _colors = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This HOC watch colors related props change
	 * and returns the corresponding color generator function.
	 * Using it prevent from having a new ref each time
	 * we pass through the component, useful for shallow comparison.
	 */
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	exports.default = function () {
	    var _defaultProps, _setPropTypes;
	
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$colorsKey = _ref.colorsKey,
	        colorsKey = _ref$colorsKey === undefined ? 'colors' : _ref$colorsKey,
	        _ref$colorByKey = _ref.colorByKey,
	        colorByKey = _ref$colorByKey === undefined ? 'colorBy' : _ref$colorByKey,
	        _ref$destKey = _ref.destKey,
	        destKey = _ref$destKey === undefined ? 'getColor' : _ref$destKey,
	        _ref$defaultColors = _ref.defaultColors,
	        defaultColors = _ref$defaultColors === undefined ? 'nivo' : _ref$defaultColors,
	        _ref$defaultColorBy = _ref.defaultColorBy,
	        defaultColorBy = _ref$defaultColorBy === undefined ? 'id' : _ref$defaultColorBy;
	
	    return (0, _compose2.default)((0, _defaultProps3.default)((_defaultProps = {}, _defaultProps[colorsKey] = defaultColors, _defaultProps[colorByKey] = defaultColorBy, _defaultProps)), (0, _setPropTypes3.default)((_setPropTypes = {}, _setPropTypes[colorsKey] = _propTypes2.default.any.isRequired, _setPropTypes[colorByKey] = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]), _setPropTypes)), (0, _withPropsOnChange2.default)([colorsKey, colorByKey], function (props) {
	        var _ref2;
	
	        return _ref2 = {}, _ref2[destKey] = (0, _colors.getColorsGenerator)(props[colorsKey], props[colorByKey]), _ref2;
	    }));
	};

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withProps = __webpack_require__(623);
	
	var _withProps2 = _interopRequireDefault(_withProps);
	
	var _props = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This HOC transform d3 curve interpolation identifier
	 * to its corresponding interpolator.
	 */
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	exports.default = function () {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$srcKey = _ref.srcKey,
	      srcKey = _ref$srcKey === undefined ? 'curve' : _ref$srcKey,
	      _ref$destKey = _ref.destKey,
	      destKey = _ref$destKey === undefined ? 'curveInterpolator' : _ref$destKey;
	
	  return (0, _withProps2.default)(function (props) {
	    var _ref2;
	
	    return _ref2 = {}, _ref2[destKey] = (0, _props.curveFromProp)(props[srcKey]), _ref2;
	  });
	};

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEqual2 = __webpack_require__(31);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _setPropTypes = __webpack_require__(179);
	
	var _setPropTypes2 = _interopRequireDefault(_setPropTypes);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _props = __webpack_require__(19);
	
	var _defaults = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This HOC watch width, height & margin props change
	 * and returns new width/height plus outer dimensions.
	 * Using it prevent from having a new ref each time
	 * we pass through the component, useful for shallow comparison.
	 * It also add required propTypes & set default margin.
	 */
	exports.default = function () {
	    return (0, _compose2.default)((0, _defaultProps2.default)({
	        margin: _defaults.defaultMargin
	    }), (0, _setPropTypes2.default)({
	        width: _propTypes2.default.number.isRequired,
	        height: _propTypes2.default.number.isRequired,
	        margin: _props.marginPropType
	    }), (0, _withPropsOnChange2.default)(function (props, nextProps) {
	        return props.width !== nextProps.width || props.height !== nextProps.height || !(0, _isEqual3.default)(props.margin, nextProps.margin);
	    }, function (props) {
	        var margin = Object.assign({}, _defaults.defaultMargin, props.margin);
	
	        return {
	            margin: margin,
	            width: props.width - margin.left - margin.right,
	            height: props.height - margin.top - margin.bottom,
	            outerWidth: props.width,
	            outerHeight: props.height
	        };
	    }));
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps2 = __webpack_require__(41);
	
	var _defaultProps3 = _interopRequireDefault(_defaultProps2);
	
	var _setPropTypes2 = __webpack_require__(179);
	
	var _setPropTypes3 = _interopRequireDefault(_setPropTypes2);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _d3Hierarchy = __webpack_require__(144);
	
	var _propertiesConverters = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This HOC watch hierarchical data props change
	 * and returns the corresponding summed hierarchy.
	 * Using it prevent from having a new ref each time
	 * we pass through the component, useful for shallow comparison.
	 */
	exports.default = function () {
	    var _defaultProps, _setPropTypes;
	
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$srcKey = _ref.srcKey,
	        srcKey = _ref$srcKey === undefined ? 'root' : _ref$srcKey,
	        _ref$destKey = _ref.destKey,
	        destKey = _ref$destKey === undefined ? 'root' : _ref$destKey,
	        _ref$valueKey = _ref.valueKey,
	        valueKey = _ref$valueKey === undefined ? 'value' : _ref$valueKey,
	        _ref$valueDefault = _ref.valueDefault,
	        valueDefault = _ref$valueDefault === undefined ? 'value' : _ref$valueDefault;
	
	    return (0, _compose2.default)((0, _defaultProps3.default)((_defaultProps = {}, _defaultProps[valueKey] = valueDefault, _defaultProps)), (0, _setPropTypes3.default)((_setPropTypes = {}, _setPropTypes[srcKey] = _propTypes2.default.object.isRequired, _setPropTypes[valueKey] = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired, _setPropTypes)), (0, _withPropsOnChange2.default)([srcKey, valueKey], function (props) {
	        var _ref2;
	
	        return _ref2 = {}, _ref2[destKey] = (0, _d3Hierarchy.hierarchy)(props[srcKey]).sum((0, _propertiesConverters.getAccessorFor)(props[valueKey])), _ref2;
	    }));
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _partialRight2 = __webpack_require__(57);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(41);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _setPropTypes = __webpack_require__(179);
	
	var _setPropTypes2 = _interopRequireDefault(_setPropTypes);
	
	var _reactMotion = __webpack_require__(25);
	
	var _props = __webpack_require__(19);
	
	var _defaults = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _compose2.default)((0, _setPropTypes2.default)(_props.motionPropTypes), (0, _defaultProps2.default)({
	        animate: _defaults.defaultAnimate,
	        motionDamping: _defaults.defaultMotionDamping,
	        motionStiffness: _defaults.defaultMotionStiffness
	    }), (0, _withPropsOnChange2.default)(['motionDamping', 'motionStiffness'], function (_ref) {
	        var motionDamping = _ref.motionDamping,
	            motionStiffness = _ref.motionStiffness;
	        return {
	            boundSpring: (0, _partialRight3.default)(_reactMotion.spring, {
	                damping: motionDamping,
	                stiffness: motionStiffness
	            })
	        };
	    }));
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _merge2 = __webpack_require__(158);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(18);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _setPropTypes2 = __webpack_require__(179);
	
	var _setPropTypes3 = _interopRequireDefault(_setPropTypes2);
	
	var _withPropsOnChange = __webpack_require__(22);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _defaults = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This HOC watch theme prop change
	 * and returns it deeply merged with default theme.
	 * Using it prevent from having a new ref each time
	 * we pass through the component, useful for shallow comparison.
	 */
	exports.default = function () {
	    var _setPropTypes;
	
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$srcKey = _ref.srcKey,
	        srcKey = _ref$srcKey === undefined ? 'theme' : _ref$srcKey,
	        _ref$destKey = _ref.destKey,
	        destKey = _ref$destKey === undefined ? 'theme' : _ref$destKey;
	
	    return (0, _compose2.default)((0, _setPropTypes3.default)((_setPropTypes = {}, _setPropTypes[srcKey] = _propTypes2.default.object, _setPropTypes)), (0, _withPropsOnChange2.default)([srcKey], function (props) {
	        var _ref2;
	
	        return _ref2 = {}, _ref2[destKey] = (0, _merge3.default)({}, _defaults.defaultTheme, props[srcKey]), _ref2;
	    }));
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _bar = __webpack_require__(1080);
	
	Object.keys(_bar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _bar[key];
	    }
	  });
	});
	
	var _bubble = __webpack_require__(1086);
	
	Object.keys(_bubble).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _bubble[key];
	    }
	  });
	});
	
	var _calendar = __webpack_require__(1091);
	
	Object.keys(_calendar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _calendar[key];
	    }
	  });
	});
	
	var _chord = __webpack_require__(1097);
	
	Object.keys(_chord).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _chord[key];
	    }
	  });
	});
	
	var _heatmap = __webpack_require__(1102);
	
	Object.keys(_heatmap).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _heatmap[key];
	    }
	  });
	});
	
	var _line = __webpack_require__(1109);
	
	Object.keys(_line).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _line[key];
	    }
	  });
	});
	
	var _pie = __webpack_require__(1114);
	
	Object.keys(_pie).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _pie[key];
	    }
	  });
	});
	
	var _radar = __webpack_require__(1122);
	
	Object.keys(_radar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _radar[key];
	    }
	  });
	});
	
	var _sankey = __webpack_require__(1130);
	
	Object.keys(_sankey).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sankey[key];
	    }
	  });
	});
	
	var _stream = __webpack_require__(1136);
	
	Object.keys(_stream).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _stream[key];
	    }
	  });
	});
	
	var _sunburst = __webpack_require__(1139);
	
	Object.keys(_sunburst).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sunburst[key];
	    }
	  });
	});
	
	var _treemap = __webpack_require__(1145);
	
	Object.keys(_treemap).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _treemap[key];
	    }
	  });
	});
	
	var _voronoi = __webpack_require__(1148);
	
	Object.keys(_voronoi).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _voronoi[key];
	    }
	  });
	});
	
	var _axes = __webpack_require__(1075);
	
	Object.keys(_axes).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _axes[key];
	    }
	  });
	});
	
	var _dots = __webpack_require__(1155);
	
	Object.keys(_dots).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _dots[key];
	    }
	  });
	});
	
	var _defs = __webpack_require__(310);
	
	Object.keys(_defs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _defs[key];
	    }
	  });
	});
	
	var _constants = __webpack_require__(1156);
	
	Object.keys(_constants).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _constants[key];
	    }
	  });
	});
	
	var _props = __webpack_require__(19);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	var _colors = __webpack_require__(24);
	
	Object.keys(_colors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colors[key];
	    }
	  });
	});
	
	var _defaults = __webpack_require__(167);
	
	Object.keys(_defaults).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _defaults[key];
	    }
	  });
	});

/***/ },
/* 1165 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	
	/**
	 * Render heatmap rect cell.
	 *
	 * @param {Object} ctx
	 * @param {number} x
	 * @param {number} y
	 * @param {number} width
	 * @param {number} height
	 * @param {string) color
	 * @param {number} opacity
	 * @param {string} labelTextColor
	 * @param {number} value
	 */
	var renderRect = exports.renderRect = function renderRect(ctx, _ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      color = _ref.color,
	      opacity = _ref.opacity,
	      labelTextColor = _ref.labelTextColor,
	      value = _ref.value;
	
	  ctx.save();
	  ctx.globalAlpha = opacity;
	
	  ctx.fillStyle = color;
	  ctx.fillRect(x - width / 2, y - height / 2, width, height);
	
	  ctx.fillStyle = labelTextColor;
	  ctx.fillText(value, x, y);
	
	  ctx.restore();
	};
	
	/**
	 * Render heatmap circle cell.
	 *
	 * @param {Object} ctx
	 * @param {number} x
	 * @param {number} y
	 * @param {number} width
	 * @param {number} height
	 * @param {string) color
	 * @param {number} opacity
	 * @param {string} labelTextColor
	 * @param {number} value
	 */
	var renderCircle = exports.renderCircle = function renderCircle(ctx, _ref2) {
	  var x = _ref2.x,
	      y = _ref2.y,
	      width = _ref2.width,
	      height = _ref2.height,
	      color = _ref2.color,
	      opacity = _ref2.opacity,
	      labelTextColor = _ref2.labelTextColor,
	      value = _ref2.value;
	
	  ctx.save();
	  ctx.globalAlpha = opacity;
	
	  var radius = Math.min(width, height) / 2;
	
	  ctx.fillStyle = color;
	  ctx.beginPath();
	  ctx.arc(x, y, radius, 0, 2 * Math.PI);
	  ctx.fill();
	
	  ctx.fillStyle = labelTextColor;
	  ctx.fillText(value, x, y);
	
	  ctx.restore();
	};

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.generateGroupedBars = exports.generateHorizontalGroupedBars = exports.generateVerticalGroupedBars = exports.getGroupedScale = undefined;
	
	var _max2 = __webpack_require__(104);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _min2 = __webpack_require__(129);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _d3Scale = __webpack_require__(71);
	
	var _common = __webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates scale for grouped bar chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {Array.<string>} keys
	 * @param {number}         _minValue
	 * @param {number|string}  _maxValue
	 * @param {Array.<number>} range
	 * @returns {Function}
	 */
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var getGroupedScale = exports.getGroupedScale = function getGroupedScale(data, keys, _minValue, _maxValue, range) {
	    var allValues = data.reduce(function (acc, entry) {
	        return [].concat(acc, keys.map(function (k) {
	            return entry[k];
	        }));
	    }, []);
	
	    var maxValue = _maxValue;
	    if (maxValue === 'auto') {
	        maxValue = (0, _max3.default)(allValues);
	    }
	
	    var minValue = _minValue;
	    if (minValue === 'auto') {
	        minValue = (0, _min3.default)(allValues);
	        if (minValue > 0) minValue = 0;
	    }
	
	    return (0, _d3Scale.scaleLinear)().rangeRound(range).domain([minValue, maxValue]);
	};
	
	/**
	 * Generates x/y scales & bars for vertical grouped bar chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {Function}       getIndex
	 * @param {Array.<string>} keys
	 * @param {number}         minValue
	 * @param {number}         maxValue
	 * @param {boolean}        reverse
	 * @param {number}         width
	 * @param {number}         height
	 * @param {Function}       getColor
	 * @param {number}         [padding=0]
	 * @param {number}         [innerPadding=0]
	 * @return {{ xScale: Function, yScale: Function, bars: Array.<Object> }}
	 */
	var generateVerticalGroupedBars = exports.generateVerticalGroupedBars = function generateVerticalGroupedBars(_ref) {
	    var data = _ref.data,
	        getIndex = _ref.getIndex,
	        keys = _ref.keys,
	        minValue = _ref.minValue,
	        maxValue = _ref.maxValue,
	        reverse = _ref.reverse,
	        width = _ref.width,
	        height = _ref.height,
	        getColor = _ref.getColor,
	        _ref$padding = _ref.padding,
	        padding = _ref$padding === undefined ? 0 : _ref$padding,
	        _ref$innerPadding = _ref.innerPadding,
	        innerPadding = _ref$innerPadding === undefined ? 0 : _ref$innerPadding;
	
	    var xScale = (0, _common.getIndexedScale)(data, getIndex, [0, width], padding);
	    var yRange = reverse ? [0, height] : [height, 0];
	    var yScale = getGroupedScale(data, keys, minValue, maxValue, yRange);
	
	    var barWidth = (xScale.bandwidth() - innerPadding * (keys.length - 1)) / keys.length;
	    var yRef = yScale(0);
	
	    var getY = function getY(d) {
	        return d > 0 ? yScale(d) : yRef;
	    };
	    var getHeight = function getHeight(d, y) {
	        return d > 0 ? yRef - y : yScale(d) - yRef;
	    };
	    if (reverse) {
	        getY = function getY(d) {
	            return d < 0 ? yScale(d) : yRef;
	        };
	        getHeight = function getHeight(d, y) {
	            return d < 0 ? yRef - y : yScale(d) - yRef;
	        };
	    }
	
	    var bars = [];
	    if (barWidth > 0) {
	        keys.forEach(function (key, i) {
	            (0, _range3.default)(xScale.domain().length).forEach(function (index) {
	                var x = xScale(getIndex(data[index])) + barWidth * i + innerPadding * i;
	                var y = getY(data[index][key]);
	                var barHeight = getHeight(data[index][key], y);
	
	                if (barWidth > 0 && barHeight > 0) {
	                    var barData = {
	                        id: key,
	                        value: data[index][key],
	                        index: index,
	                        indexValue: getIndex(data[index]),
	                        data: data[index]
	                    };
	
	                    bars.push({
	                        key: key + '.' + barData.indexValue,
	                        data: barData,
	                        x: x,
	                        y: y,
	                        width: barWidth,
	                        height: barHeight,
	                        color: getColor(barData)
	                    });
	                }
	            });
	        });
	    }
	
	    return { xScale: xScale, yScale: yScale, bars: bars };
	};
	
	/**
	 * Generates x/y scales & bars for horizontal grouped bar chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {Function}       getIndex
	 * @param {Array.<string>} keys
	 * @param {number}         minValue
	 * @param {number}         maxValue
	 * @param {boolean}        reverse
	 * @param {number}         width
	 * @param {number}         height
	 * @param {Function}       getColor
	 * @param {number}         [padding=0]
	 * @param {number}         [innerPadding=0]
	 * @return {{ xScale: Function, yScale: Function, bars: Array.<Object> }}
	 */
	var generateHorizontalGroupedBars = exports.generateHorizontalGroupedBars = function generateHorizontalGroupedBars(_ref2) {
	    var data = _ref2.data,
	        getIndex = _ref2.getIndex,
	        keys = _ref2.keys,
	        minValue = _ref2.minValue,
	        maxValue = _ref2.maxValue,
	        reverse = _ref2.reverse,
	        width = _ref2.width,
	        height = _ref2.height,
	        getColor = _ref2.getColor,
	        _ref2$padding = _ref2.padding,
	        padding = _ref2$padding === undefined ? 0 : _ref2$padding,
	        _ref2$innerPadding = _ref2.innerPadding,
	        innerPadding = _ref2$innerPadding === undefined ? 0 : _ref2$innerPadding;
	
	    var xRange = reverse ? [width, 0] : [0, width];
	    var xScale = getGroupedScale(data, keys, minValue, maxValue, xRange);
	    var yScale = (0, _common.getIndexedScale)(data, getIndex, [height, 0], padding);
	
	    var barHeight = (yScale.bandwidth() - innerPadding * (keys.length - 1)) / keys.length;
	    var xRef = xScale(0);
	
	    var getX = function getX(d) {
	        return d > 0 ? xRef : xScale(d);
	    };
	    var getWidth = function getWidth(d, x) {
	        return d > 0 ? xScale(d) - xRef : xRef - x;
	    };
	    if (reverse) {
	        getX = function getX(d) {
	            return d < 0 ? xRef : xScale(d);
	        };
	        getWidth = function getWidth(d, x) {
	            return d < 0 ? xScale(d) - xRef : xRef - x;
	        };
	    }
	
	    var bars = [];
	    if (barHeight > 0) {
	        keys.forEach(function (key, i) {
	            (0, _range3.default)(yScale.domain().length).forEach(function (index) {
	                var x = getX(data[index][key]);
	                var y = yScale(getIndex(data[index])) + barHeight * i + innerPadding * i;
	                var barWidth = getWidth(data[index][key], x);
	
	                if (barWidth > 0) {
	                    var barData = {
	                        id: key,
	                        value: data[index][key],
	                        index: index,
	                        indexValue: getIndex(data[index]),
	                        data: data[index]
	                    };
	
	                    bars.push({
	                        key: key + '.' + barData.indexValue,
	                        data: barData,
	                        x: x,
	                        y: y,
	                        width: barWidth,
	                        height: barHeight,
	                        color: getColor(barData)
	                    });
	                }
	            });
	        });
	    }
	
	    return { xScale: xScale, yScale: yScale, bars: bars };
	};
	
	/**
	 * Generates x/y scales & bars for grouped bar chart.
	 *
	 * @param {Object} options
	 * @return {{ xScale: Function, yScale: Function, bars: Array.<Object> }}
	 */
	var generateGroupedBars = exports.generateGroupedBars = function generateGroupedBars(options) {
	    return options.layout === 'vertical' ? generateVerticalGroupedBars(options) : generateHorizontalGroupedBars(options);
	};

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.generateStackedBars = exports.generateHorizontalStackedBars = exports.generateVerticalStackedBars = exports.getStackedScale = undefined;
	
	var _max2 = __webpack_require__(104);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _min2 = __webpack_require__(129);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _flattenDepth2 = __webpack_require__(1013);
	
	var _flattenDepth3 = _interopRequireDefault(_flattenDepth2);
	
	var _d3Scale = __webpack_require__(71);
	
	var _d3Shape = __webpack_require__(13);
	
	var _common = __webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates scale for stacked bar chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {number|string}  _minValue
	 * @param {number|string}  _maxValue
	 * @param {Array.<number>} range
	 * @returns {Function}
	 */
	var getStackedScale = exports.getStackedScale = function getStackedScale(data, _minValue, _maxValue, range) {
	    var allValues = (0, _flattenDepth3.default)(data, 2);
	
	    var minValue = _minValue;
	    if (minValue === 'auto') {
	        minValue = (0, _min3.default)(allValues);
	    }
	
	    var maxValue = _maxValue;
	    if (maxValue === 'auto') {
	        maxValue = (0, _max3.default)(allValues);
	    }
	
	    return (0, _d3Scale.scaleLinear)().rangeRound(range).domain([minValue, maxValue]);
	};
	
	/**
	 * Generates x/y scales & bars for vertical stacked bar chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {Function}       getIndex
	 * @param {Array.<string>} keys
	 * @param {number}         minValue
	 * @param {number}         maxValue
	 * @param {boolean}        reverse
	 * @param {number}         width
	 * @param {number}         height
	 * @param {Function}       getColor
	 * @param {number}         [padding=0]
	 * @param {number}         [innerPadding=0]
	 * @return {{ xScale: Function, yScale: Function, bars: Array.<Object> }}
	 */
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var generateVerticalStackedBars = exports.generateVerticalStackedBars = function generateVerticalStackedBars(_ref) {
	    var data = _ref.data,
	        getIndex = _ref.getIndex,
	        keys = _ref.keys,
	        minValue = _ref.minValue,
	        maxValue = _ref.maxValue,
	        reverse = _ref.reverse,
	        width = _ref.width,
	        height = _ref.height,
	        getColor = _ref.getColor,
	        _ref$padding = _ref.padding,
	        padding = _ref$padding === undefined ? 0 : _ref$padding,
	        _ref$innerPadding = _ref.innerPadding,
	        innerPadding = _ref$innerPadding === undefined ? 0 : _ref$innerPadding;
	
	    var stackedData = (0, _d3Shape.stack)().keys(keys).offset(_d3Shape.stackOffsetDiverging)(data);
	
	    var xScale = (0, _common.getIndexedScale)(data, getIndex, [0, width], padding);
	    var yRange = reverse ? [0, height] : [height, 0];
	    var yScale = getStackedScale(stackedData, minValue, maxValue, yRange);
	
	    var bars = [];
	    var barWidth = xScale.bandwidth();
	
	    var getY = function getY(d) {
	        return yScale(d[1]);
	    };
	    var getHeight = function getHeight(d, y) {
	        return yScale(d[0]) - y;
	    };
	    if (reverse) {
	        getY = function getY(d) {
	            return yScale(d[0]);
	        };
	        getHeight = function getHeight(d, y) {
	            return yScale(d[1]) - y;
	        };
	    }
	
	    if (barWidth > 0) {
	        stackedData.forEach(function (stackedDataItem) {
	            xScale.domain().forEach(function (index, i) {
	                var d = stackedDataItem[i];
	                var x = xScale(getIndex(d.data));
	
	                var y = getY(d);
	                var barHeight = getHeight(d, y);
	                if (innerPadding > 0) {
	                    y += innerPadding * 0.5;
	                    barHeight -= innerPadding;
	                }
	
	                if (barHeight > 0) {
	                    var barData = {
	                        id: stackedDataItem.key,
	                        value: d.data[stackedDataItem.key],
	                        index: i,
	                        indexValue: index,
	                        data: d.data
	                    };
	
	                    bars.push({
	                        key: stackedDataItem.key + '.' + index,
	                        data: barData,
	                        x: x,
	                        y: y,
	                        width: barWidth,
	                        height: barHeight,
	                        color: getColor(barData)
	                    });
	                }
	            });
	        });
	    }
	
	    return { xScale: xScale, yScale: yScale, bars: bars };
	};
	
	/**
	 * Generates x/y scales & bars for horizontal stacked bar chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {Function}       getIndex
	 * @param {Array.<string>} keys
	 * @param {number}         minValue
	 * @param {number}         maxValue
	 * @param {boolean}        reverse
	 * @param {number}         width
	 * @param {number}         height
	 * @param {Function}       getColor
	 * @param {number}         [padding=0]
	 * @param {number}         [innerPadding=0]
	 * @return {{ xScale: Function, yScale: Function, bars: Array.<Object> }}
	 */
	var generateHorizontalStackedBars = exports.generateHorizontalStackedBars = function generateHorizontalStackedBars(_ref2) {
	    var data = _ref2.data,
	        getIndex = _ref2.getIndex,
	        keys = _ref2.keys,
	        minValue = _ref2.minValue,
	        maxValue = _ref2.maxValue,
	        reverse = _ref2.reverse,
	        width = _ref2.width,
	        height = _ref2.height,
	        getColor = _ref2.getColor,
	        _ref2$padding = _ref2.padding,
	        padding = _ref2$padding === undefined ? 0 : _ref2$padding,
	        _ref2$innerPadding = _ref2.innerPadding,
	        innerPadding = _ref2$innerPadding === undefined ? 0 : _ref2$innerPadding;
	
	    var stackedData = (0, _d3Shape.stack)().keys(keys).offset(_d3Shape.stackOffsetDiverging)(data);
	
	    var xRange = reverse ? [width, 0] : [0, width];
	    var xScale = getStackedScale(stackedData, minValue, maxValue, xRange);
	    var yScale = (0, _common.getIndexedScale)(data, getIndex, [height, 0], padding);
	
	    var bars = [];
	    var barHeight = yScale.bandwidth();
	
	    var getX = function getX(d) {
	        return xScale(d[0]);
	    };
	    var getWidth = function getWidth(d, x) {
	        return xScale(d[1]) - x;
	    };
	    if (reverse) {
	        getX = function getX(d) {
	            return xScale(d[1]);
	        };
	        getWidth = function getWidth(d, y) {
	            return xScale(d[0]) - y;
	        };
	    }
	
	    if (barHeight > 0) {
	        stackedData.forEach(function (stackedDataItem) {
	            yScale.domain().forEach(function (index, i) {
	                var d = stackedDataItem[i];
	                var y = yScale(getIndex(d.data));
	
	                var barData = {
	                    id: stackedDataItem.key,
	                    value: d.data[stackedDataItem.key],
	                    index: i,
	                    indexValue: index,
	                    data: d.data
	                };
	
	                var x = getX(d);
	                var barWidth = getWidth(d, x);
	                if (innerPadding > 0) {
	                    x += innerPadding * 0.5;
	                    barWidth -= innerPadding;
	                }
	
	                if (barWidth > 0) {
	                    bars.push({
	                        key: stackedDataItem.key + '.' + index,
	                        data: barData,
	                        x: x,
	                        y: y,
	                        width: barWidth,
	                        height: barHeight,
	                        color: getColor(barData)
	                    });
	                }
	            });
	        });
	    }
	
	    return { xScale: xScale, yScale: yScale, bars: bars };
	};
	
	/**
	 * Generates x/y scales & bars for stacked bar chart.
	 *
	 * @param {Object} options
	 * @return {{ xScale: Function, yScale: Function, bars: Array.<Object> }}
	 */
	var generateStackedBars = exports.generateStackedBars = function generateStackedBars(options) {
	    return options.layout === 'vertical' ? generateVerticalStackedBars(options) : generateHorizontalStackedBars(options);
	};

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.computeZoom = exports.computeNodes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _hierarchy = __webpack_require__(534);
	
	var computeNodes = exports.computeNodes = function computeNodes(_ref) {
	    var root = _ref.root,
	        pack = _ref.pack,
	        leavesOnly = _ref.leavesOnly,
	        getIdentity = _ref.getIdentity,
	        getColor = _ref.getColor;
	
	    // assign a unique id depending on node path to each node
	    root.each(function (node) {
	        node.id = getIdentity(node.data);
	        node.path = (0, _hierarchy.computeNodePath)(node, getIdentity);
	    });
	
	    pack(root);
	
	    var nodes = leavesOnly ? root.leaves() : root.descendants();
	    nodes = nodes.map(function (node) {
	        node.color = getColor(_extends({}, node.data, { depth: node.depth }));
	        node.label = false;
	
	        return node;
	    });
	
	    return nodes;
	};
	
	var computeZoom = exports.computeZoom = function computeZoom(nodes, currentNodePath, width, height) {
	    var currentNode = nodes.find(function (_ref2) {
	        var path = _ref2.path;
	        return path === currentNodePath;
	    });
	
	    if (!currentNode) return nodes;
	
	    var ratio = Math.min(width, height) / (currentNode.r * 2);
	    var offsetX = width / 2 - currentNode.x * ratio;
	    var offsetY = height / 2 - currentNode.y * ratio;
	
	    return nodes.map(function (node) {
	        return _extends({}, node, {
	            r: node.r * ratio,
	            x: node.x * ratio + offsetX,
	            y: node.y * ratio + offsetY
	        });
	    });
	};

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _assign2 = __webpack_require__(17);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _max2 = __webpack_require__(104);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isDate2 = __webpack_require__(1019);
	
	var _isDate3 = _interopRequireDefault(_isDate2);
	
	var _memoize2 = __webpack_require__(288);
	
	var _memoize3 = _interopRequireDefault(_memoize2);
	
	var _directions = __webpack_require__(223);
	
	var _d3TimeFormat = __webpack_require__(537);
	
	var _d3Time = __webpack_require__(1187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Compute day cell size according to current context.
	 *
	 * @param {number} width
	 * @param {number} height
	 * @param {number} direction
	 * @param {array}  yearRange
	 * @param {number} yearSpacing
	 * @param {number} daySpacing
	 * @param {number} maxWeeks
	 * @returns {number}
	 */
	var computeCellSize = function computeCellSize(_ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        direction = _ref.direction,
	        yearRange = _ref.yearRange,
	        yearSpacing = _ref.yearSpacing,
	        daySpacing = _ref.daySpacing,
	        maxWeeks = _ref.maxWeeks;
	
	    var hCellSize = void 0;
	    var vCellSize = void 0;
	
	    if (direction === _directions.DIRECTION_HORIZONTAL) {
	        hCellSize = (width - daySpacing * maxWeeks) / maxWeeks;
	        vCellSize = (height - (yearRange.length - 1) * yearSpacing - yearRange.length * (8 * daySpacing)) / (yearRange.length * 7);
	    } else {
	        hCellSize = (width - (yearRange.length - 1) * yearSpacing - yearRange.length * (8 * daySpacing)) / (yearRange.length * 7);
	        vCellSize = (height - daySpacing * maxWeeks) / maxWeeks;
	    }
	
	    return Math.min(hCellSize, vCellSize);
	};
	
	/**
	 * Computes month path and bounding box.
	 *
	 * @param {Date}   date
	 * @param {number} cellSize
	 * @param {number} yearIndex
	 * @param {number} yearSpacing
	 * @param {number} daySpacing
	 * @param {string} direction
	 * @returns { { path: string, bbox: { x: number, y: number, width: number, height: number } } }
	 */
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	
	var monthPathAndBBox = function monthPathAndBBox(_ref2) {
	    var date = _ref2.date,
	        cellSize = _ref2.cellSize,
	        yearIndex = _ref2.yearIndex,
	        yearSpacing = _ref2.yearSpacing,
	        daySpacing = _ref2.daySpacing,
	        direction = _ref2.direction;
	
	    var t1 = new Date(date.getFullYear(), date.getMonth() + 1, 0); // first day of next month
	    var d0 = date.getDay(); // first day of month
	    var w0 = _d3Time.timeWeek.count((0, _d3Time.timeYear)(date), date); // first week of month
	    var d1 = t1.getDay(); // last day of month
	    var w1 = _d3Time.timeWeek.count((0, _d3Time.timeYear)(t1), t1); // last week of month
	
	    // offset according to year index
	    var xO = 0;
	    var yO = 0;
	    var yearOffset = yearIndex * (7 * (cellSize + daySpacing) + yearSpacing);
	    if (direction === _directions.DIRECTION_HORIZONTAL) {
	        yO = yearOffset;
	    } else {
	        xO = yearOffset;
	    }
	
	    var path = void 0;
	    var bbox = { x: xO, y: yO, width: 0, height: 0 };
	    if (direction === _directions.DIRECTION_HORIZONTAL) {
	        path = ['M' + (xO + (w0 + 1) * (cellSize + daySpacing)) + ',' + (yO + d0 * (cellSize + daySpacing)), 'H' + (xO + w0 * (cellSize + daySpacing)) + 'V' + (yO + 7 * (cellSize + daySpacing)), 'H' + (xO + w1 * (cellSize + daySpacing)) + 'V' + (yO + (d1 + 1) * (cellSize + daySpacing)), 'H' + (xO + (w1 + 1) * (cellSize + daySpacing)) + 'V' + yO, 'H' + (xO + (w0 + 1) * (cellSize + daySpacing)) + 'Z'].join('');
	
	        bbox.x = xO + w0 * (cellSize + daySpacing);
	        bbox.width = (w1 + 1) * (cellSize + daySpacing) - bbox.x;
	        bbox.height = 7 * (cellSize + daySpacing);
	    } else {
	        path = ['M' + (xO + d0 * (cellSize + daySpacing)) + ',' + (yO + (w0 + 1) * (cellSize + daySpacing)), 'H' + xO + 'V' + (yO + (w1 + 1) * (cellSize + daySpacing)), 'H' + (xO + (d1 + 1) * (cellSize + daySpacing)) + 'V' + (yO + w1 * (cellSize + daySpacing)), 'H' + (xO + 7 * (cellSize + daySpacing)) + 'V' + (yO + w0 * (cellSize + daySpacing)), 'H' + (xO + d0 * (cellSize + daySpacing)) + 'Z'].join('');
	
	        bbox.y = yO + w0 * (cellSize + daySpacing);
	        bbox.width = 7 * (cellSize + daySpacing);
	        bbox.height = (w1 + 1) * (cellSize + daySpacing) - bbox.y;
	    }
	
	    return { path: path, bbox: bbox };
	};
	
	/**
	 * Creates a memoized version of monthPathAndBBox function.
	 */
	var memoMonthPathAndBBox = (0, _memoize3.default)(monthPathAndBBox, function (_ref3) {
	    var date = _ref3.date,
	        cellSize = _ref3.cellSize,
	        yearIndex = _ref3.yearIndex,
	        yearSpacing = _ref3.yearSpacing,
	        daySpacing = _ref3.daySpacing,
	        direction = _ref3.direction;
	
	    return date.toString() + '.' + cellSize + '.' + yearIndex + '.' + yearSpacing + '.' + daySpacing + '.' + direction;
	});
	
	/**
	 * Returns a function to Compute day cell position for horizontal layout.
	 *
	 * @param {number} cellSize
	 * @param {number} yearSpacing
	 * @param {number} daySpacing
	 * @returns { function(): { x: number, y: number } }
	 */
	var cellPositionHorizontal = function cellPositionHorizontal(cellSize, yearSpacing, daySpacing) {
	    return function (d, yearIndex) {
	        var weekOfYear = _d3Time.timeWeek.count((0, _d3Time.timeYear)(d), d);
	
	        return {
	            x: weekOfYear * (cellSize + daySpacing) + daySpacing / 2,
	            y: d.getDay() * (cellSize + daySpacing) + daySpacing / 2 + yearIndex * (yearSpacing + 7 * (cellSize + daySpacing))
	        };
	    };
	};
	
	/**
	 * Returns a function to Compute day cell position for vertical layout.
	 *
	 * @param {number} cellSize
	 * @param {number} yearSpacing
	 * @param {number} daySpacing
	 * @returns { function(): { x: number, y: number } }
	 */
	var cellPositionVertical = function cellPositionVertical(cellSize, yearSpacing, daySpacing) {
	    return function (d, yearIndex) {
	        var weekOfYear = _d3Time.timeWeek.count((0, _d3Time.timeYear)(d), d);
	
	        return {
	            x: d.getDay() * (cellSize + daySpacing) + daySpacing / 2 + yearIndex * (yearSpacing + 7 * (cellSize + daySpacing)),
	            y: weekOfYear * (cellSize + daySpacing) + daySpacing / 2
	        };
	    };
	};
	
	// used for days range and data matching
	var dayFormat = (0, _d3TimeFormat.timeFormat)('%Y-%m-%d');
	
	/**
	 * This layout is responsible for computing Calendar chart data/positions….
	 * It's used for all Calendar related chart components.
	 *
	 * @param {number}      width
	 * @param {number}      height
	 * @param {string|Date} from
	 * @param {string|Date} to
	 * @param {array}       data
	 * @param {string}      direction
	 * @param {object}      colorScale
	 * @param {string}      emptyColor
	 * @param {number}      yearSpacing
	 * @param {number}      daySpacing
	 * @returns {object}
	 */
	var CalendarLayout = function CalendarLayout(_ref4) {
	    var width = _ref4.width,
	        height = _ref4.height,
	        from = _ref4.from,
	        to = _ref4.to,
	        data = _ref4.data,
	        direction = _ref4.direction,
	        colorScale = _ref4.colorScale,
	        emptyColor = _ref4.emptyColor,
	        yearSpacing = _ref4.yearSpacing,
	        daySpacing = _ref4.daySpacing;
	
	    // time related data
	    var fromDate = (0, _isDate3.default)(from) ? from : new Date(from);
	    var toDate = (0, _isDate3.default)(to) ? to : new Date(to);
	
	    var yearRange = (0, _range3.default)(fromDate.getFullYear(), toDate.getFullYear() + 1);
	    var maxWeeks = (0, _max3.default)(yearRange.map(function (year) {
	        return (0, _d3Time.timeWeeks)(new Date(year, 0, 1), new Date(year + 1, 0, 1)).length;
	    })) + 1;
	
	    // ——————————————————————————————————————————————————————————————————————————————————————————————————————
	    // Computes years/months/days
	    // ——————————————————————————————————————————————————————————————————————————————————————————————————————
	    // compute cellSize
	    var cellSize = computeCellSize({
	        width: width,
	        height: height,
	        direction: direction,
	        yearRange: yearRange,
	        yearSpacing: yearSpacing,
	        daySpacing: daySpacing,
	        maxWeeks: maxWeeks
	    });
	
	    // determine day cells positioning function according to layout direction
	    var cellPosition = void 0;
	    if (direction === _directions.DIRECTION_HORIZONTAL) {
	        cellPosition = cellPositionHorizontal(cellSize, yearSpacing, daySpacing);
	    } else {
	        cellPosition = cellPositionVertical(cellSize, yearSpacing, daySpacing);
	    }
	
	    var years = [];
	    var months = [];
	    var days = [];
	
	    yearRange.forEach(function (year, i) {
	        var yearStart = new Date(year, 0, 1);
	        var yearEnd = new Date(year + 1, 0, 1);
	
	        days = days.concat((0, _d3Time.timeDays)(yearStart, yearEnd).map(function (dayDate) {
	            return (0, _assign3.default)({
	                date: dayDate,
	                day: dayFormat(dayDate),
	                size: cellSize
	            }, cellPosition(dayDate, i));
	        }));
	
	        var yearMonths = (0, _d3Time.timeMonths)(yearStart, yearEnd).map(function (monthDate) {
	            return (0, _assign3.default)({ date: monthDate }, memoMonthPathAndBBox({
	                date: monthDate,
	                direction: direction,
	                yearIndex: i,
	                yearSpacing: yearSpacing,
	                daySpacing: daySpacing,
	                cellSize: cellSize
	            }));
	        });
	
	        months = months.concat(yearMonths);
	
	        years.push({
	            year: year,
	            bbox: {
	                x: yearMonths[0].bbox.x,
	                y: yearMonths[0].bbox.y,
	                width: yearMonths[11].bbox.x - yearMonths[0].bbox.x + yearMonths[11].bbox.width,
	                height: yearMonths[11].bbox.y - yearMonths[0].bbox.y + yearMonths[11].bbox.height
	            }
	        });
	    });
	
	    // ——————————————————————————————————————————————————————————————————————————————————————————————————————
	    // Computes days/data intersection
	    // ——————————————————————————————————————————————————————————————————————————————————————————————————————
	    //const color = scalePropToD3Scale(colorScale)
	
	    days.forEach(function (day) {
	        day.color = emptyColor;
	        data.forEach(function (dataDay) {
	            if (dataDay.day === day.day) {
	                day.value = dataDay.value;
	                day.color = colorScale(dataDay.value);
	            }
	        });
	    });
	
	    return { years: years, months: months, days: days, cellSize: cellSize };
	};
	
	exports.default = CalendarLayout;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.generateStackedLines = exports.generateLines = exports.getScales = exports.getStackedScales = exports.getStackedYScale = exports.getYScale = exports.getXScale = undefined;
	
	var _uniq2 = __webpack_require__(211);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _sumBy2 = __webpack_require__(290);
	
	var _sumBy3 = _interopRequireDefault(_sumBy2);
	
	var _max2 = __webpack_require__(104);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _min2 = __webpack_require__(129);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _d3Scale = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates X scale.
	 *
	 * @param {Array.<Object>} data
	 * @param {number}         width
	 * @returns {Function}
	 */
	var getXScale = exports.getXScale = function getXScale(data, width) {
	    var xLengths = (0, _uniq3.default)(data.map(function (_ref) {
	        var data = _ref.data;
	        return data.length;
	    }));
	    if (xLengths.length > 1) {
	        throw new Error(['Found inconsitent data for x,', 'expecting all series to have same length', 'but found: ' + xLengths.join(', ')].join(' '));
	    }
	
	    return (0, _d3Scale.scalePoint)().range([0, width]).domain(data[0].data.map(function (_ref2) {
	        var x = _ref2.x;
	        return x;
	    }));
	};
	
	/**
	 * Generates Y scale for line chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {number}         height
	 * @param {number|string}  minValue
	 * @param {number|string}  maxValue
	 * @returns {Function}
	 */
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var getYScale = exports.getYScale = function getYScale(data, height, minValue, maxValue) {
	    var minY = minValue;
	    if (minValue === 'auto') {
	        minY = (0, _min3.default)(data.map(function (serie) {
	            return (0, _min3.default)(serie.data.map(function (d) {
	                return d.y;
	            }));
	        }));
	    }
	
	    var maxY = maxValue;
	    if (maxValue === 'auto') {
	        maxY = (0, _max3.default)(data.map(function (serie) {
	            return (0, _max3.default)(serie.data.map(function (d) {
	                return d.y;
	            }));
	        }));
	    }
	
	    return (0, _d3Scale.scaleLinear)().rangeRound([height, 0]).domain([minY, maxY]);
	};
	
	/**
	 * Generates Y scale for stacked line chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {Object}         xScale
	 * @param {number}         height
	 * @param {number|string}  minValue
	 * @param {number|string}  maxValue
	 * @returns {Function}
	 */
	var getStackedYScale = exports.getStackedYScale = function getStackedYScale(data, xScale, height, minValue, maxValue) {
	    var minY = minValue;
	    if (minValue === 'auto') {
	        minY = (0, _min3.default)(data.map(function (serie) {
	            return (0, _min3.default)(serie.data.map(function (d) {
	                return d.y;
	            }));
	        }));
	    }
	
	    var maxY = maxValue;
	    if (maxValue === 'auto') {
	        maxY = (0, _max3.default)((0, _range3.default)(xScale.domain().length).map(function (i) {
	            return (0, _sumBy3.default)(data, function (serie) {
	                return serie.data[i].y;
	            });
	        }));
	    }
	
	    return (0, _d3Scale.scaleLinear)().rangeRound([height, 0]).domain([minY, maxY]);
	};
	
	/**
	 * Generates stacked x/y scales.
	 *
	 * @param {Array}         data
	 * @param {number}        width
	 * @param {number}        height
	 * @param {number|string} minY
	 * @param {number|string} maxY
	 * @return {{ xScale: Function, yScale: Function }}
	 */
	var getStackedScales = exports.getStackedScales = function getStackedScales(_ref3) {
	    var data = _ref3.data,
	        width = _ref3.width,
	        height = _ref3.height,
	        minY = _ref3.minY,
	        maxY = _ref3.maxY;
	
	    var xScale = getXScale(data, width);
	    var yScale = getStackedYScale(data, xScale, height, minY, maxY);
	
	    return { xScale: xScale, yScale: yScale };
	};
	
	/**
	 * Generates non stacked x/ scales
	 *
	 * @param {Array}         data
	 * @param {number}        width
	 * @param {number}        height
	 * @param {number|string} minY
	 * @param {number|string} maxY
	 * @return {{ xScale: Function, yScale: Function }}
	 */
	var getScales = exports.getScales = function getScales(_ref4) {
	    var data = _ref4.data,
	        width = _ref4.width,
	        height = _ref4.height,
	        minY = _ref4.minY,
	        maxY = _ref4.maxY;
	
	    var xScale = getXScale(data, width);
	    var yScale = getYScale(data, height, minY, maxY);
	
	    return { xScale: xScale, yScale: yScale };
	};
	
	/**
	 * Generates x/y scales & lines for line chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {Function}       xScale
	 * @param {Function}       yScale
	 * @param {Function}       color
	 * @return {{ xScale: Function, yScale: Function, lines: Array.<Object> }}
	 */
	var generateLines = exports.generateLines = function generateLines(data, xScale, yScale, color) {
	    return data.map(function (serie) {
	        var id = serie.id,
	            serieData = serie.data;
	
	
	        return {
	            id: id,
	            color: color(serie),
	            data: serie,
	            points: serieData.map(function (d) {
	                return Object.assign({}, d, {
	                    value: d.y,
	                    x: xScale(d.x),
	                    y: yScale(d.y)
	                });
	            })
	        };
	    });
	};
	
	/**
	 * Generates x/y scales & lines for stacked line chart.
	 *
	 * @param {Array.<Object>} data
	 * @param {Function}       xScale
	 * @param {Function}       yScale
	 * @param {Function}       color
	 * @return {{ xScale: Function, yScale: Function, lines: Array.<Object> }}
	 */
	var generateStackedLines = exports.generateStackedLines = function generateStackedLines(data, xScale, yScale, color) {
	    return data.reduce(function (acc, serie, serieIndex) {
	        var previousPoints = serieIndex === 0 ? null : acc[serieIndex - 1].points;
	
	        var id = serie.id,
	            serieData = serie.data;
	
	
	        return [].concat(acc, [{
	            id: id,
	            color: color(serie),
	            data: serie,
	            points: serieData.map(function (d, i) {
	                if (!previousPoints) {
	                    return Object.assign({}, d, {
	                        value: d.y,
	                        x: d.x,
	                        y: d.y
	                    });
	                }
	
	                return Object.assign({}, d, {
	                    value: d.y,
	                    x: d.x,
	                    y: d.y + previousPoints[i].accY
	                });
	            }).map(function (d) {
	                return {
	                    key: d.x,
	                    value: d.value,
	                    accY: d.y,
	                    x: xScale(d.x),
	                    y: yScale(d.y)
	                };
	            })
	        }]);
	    }, []);
	};

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getInheritedColorGenerator = undefined;
	
	var _get2 = __webpack_require__(126);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _memoize2 = __webpack_require__(288);
	
	var _memoize3 = _interopRequireDefault(_memoize2);
	
	var _d3Color = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Memoize both color generator & color generator result.
	 */
	var memoizedColorModifier = (0, _memoize3.default)(function (method, _amount) {
	    var amount = parseFloat(_amount);
	
	    return (0, _memoize3.default)(function (d) {
	        return (0, _d3Color.rgb)(d.color)[method](amount).toString();
	    }, function (d) {
	        return d.color;
	    });
	}, function (method, amount) {
	    return method + '.' + amount;
	}); /*
	     * This file is part of the nivo project.
	     *
	     * Copyright 2016-present, Raphaël Benitte.
	     *
	     * For the full copyright and license information, please view the LICENSE
	     * file that was distributed with this source code.
	     */
	
	
	var noneGenerator = function noneGenerator() {
	    return 'none';
	};
	var inheritGenerator = function inheritGenerator(d) {
	    return d.color;
	};
	
	/**
	 * @param {string|Function} instruction
	 * @param {string}          [themeKey]
	 * @return {Function}
	 */
	var getInheritedColorGenerator = exports.getInheritedColorGenerator = function getInheritedColorGenerator(instruction, themeKey) {
	    if (instruction === 'none') return noneGenerator;
	
	    if ((0, _isFunction3.default)(instruction)) return instruction;
	
	    if (instruction === 'theme') {
	        if (!themeKey) {
	            throw new Error('Cannot use \'theme\' directive without providing \'themeKey\'');
	        }
	
	        return function (d, theme) {
	            return (0, _get3.default)(theme, themeKey);
	        };
	    }
	
	    if (instruction === 'inherit') return inheritGenerator;
	
	    var inheritMatches = instruction.match(/inherit:(darker|brighter)\(([0-9.]+)\)/);
	    if (inheritMatches) {
	        var method = inheritMatches[1];
	        var amount = inheritMatches[2];
	
	        return memoizedColorModifier(method, amount);
	    }
	
	    return function () {
	        return instruction;
	    };
	};

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getInterpolatedColor = exports.colorMotionSpring = undefined;
	
	var _reactMotion = __webpack_require__(25);
	
	var _d3Color = __webpack_require__(47);
	
	/**
	 * Decompose a color for use with react-motion.
	 *
	 * @param {string} _color
	 * @param {Object} [_config]
	 * @return {Object}
	 */
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var colorMotionSpring = exports.colorMotionSpring = function colorMotionSpring(_color, _config) {
	    var color = (0, _d3Color.rgb)(_color);
	
	    if (!_config) return {
	        colorR: color.r,
	        colorG: color.g,
	        colorB: color.b
	    };
	
	    var config = Object.assign({}, _config, { precision: 1 });
	
	    return {
	        colorR: (0, _reactMotion.spring)(color.r, config),
	        colorG: (0, _reactMotion.spring)(color.g, config),
	        colorB: (0, _reactMotion.spring)(color.b, config)
	    };
	};
	
	/**
	 * Re-assemble interpolated color components for easy use.
	 *
	 * @param {number} colorR
	 * @param {number} colorG
	 * @param {number} colorB
	 * @return {string}
	 */
	var getInterpolatedColor = exports.getInterpolatedColor = function getInterpolatedColor(_ref) {
	    var colorR = _ref.colorR,
	        colorG = _ref.colorG,
	        colorB = _ref.colorB;
	    return 'rgb(' + Math.round(Math.max(colorR, 0)) + ',' + Math.round(Math.max(colorG, 0)) + ',' + Math.round(Math.max(colorB, 0)) + ')';
	};

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.guessQuantizeColorScale = exports.quantizeColorScalesKeys = exports.quantizeColorScales = undefined;
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _last2 = __webpack_require__(287);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _d3Scale = __webpack_require__(71);
	
	var _d3ScaleChromatic = __webpack_require__(253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var quantizeColorScales = exports.quantizeColorScales = {
	    nivo: ['#d76445', '#f47560', '#e8c1a0', '#97e3d5', '#61cdbb', '#00b0a7'],
	
	    // Diverging
	    BrBG: (0, _last3.default)(_d3ScaleChromatic.schemeBrBG),
	    PRGn: (0, _last3.default)(_d3ScaleChromatic.schemePRGn),
	    PiYG: (0, _last3.default)(_d3ScaleChromatic.schemePiYG),
	    PuOr: (0, _last3.default)(_d3ScaleChromatic.schemePuOr),
	    RdBu: (0, _last3.default)(_d3ScaleChromatic.schemeRdBu),
	    RdGy: (0, _last3.default)(_d3ScaleChromatic.schemeRdGy),
	    RdYlBu: (0, _last3.default)(_d3ScaleChromatic.schemeRdYlBu),
	    RdYlGn: (0, _last3.default)(_d3ScaleChromatic.schemeRdYlGn),
	    spectral: (0, _last3.default)(_d3ScaleChromatic.schemeSpectral),
	
	    // Sequential (Single Hue)
	    blues: (0, _last3.default)(_d3ScaleChromatic.schemeBlues),
	    greens: (0, _last3.default)(_d3ScaleChromatic.schemeGreens),
	    greys: (0, _last3.default)(_d3ScaleChromatic.schemeGreys),
	    oranges: (0, _last3.default)(_d3ScaleChromatic.schemeOranges),
	    purples: (0, _last3.default)(_d3ScaleChromatic.schemePurples),
	    reds: (0, _last3.default)(_d3ScaleChromatic.schemeReds),
	
	    // Sequential (Multi-Hue)
	    BuGn: (0, _last3.default)(_d3ScaleChromatic.schemeBuGn),
	    BuPu: (0, _last3.default)(_d3ScaleChromatic.schemeBuPu),
	    GnBu: (0, _last3.default)(_d3ScaleChromatic.schemeGnBu),
	    OrRd: (0, _last3.default)(_d3ScaleChromatic.schemeOrRd),
	    PuBuGn: (0, _last3.default)(_d3ScaleChromatic.schemePuBuGn),
	    PuBu: (0, _last3.default)(_d3ScaleChromatic.schemePuBu),
	    PuRd: (0, _last3.default)(_d3ScaleChromatic.schemePuRd),
	    RdPu: (0, _last3.default)(_d3ScaleChromatic.schemeRdPu),
	    YlGnBu: (0, _last3.default)(_d3ScaleChromatic.schemeYlGnBu),
	    YlGn: (0, _last3.default)(_d3ScaleChromatic.schemeYlGn),
	    YlOrBr: (0, _last3.default)(_d3ScaleChromatic.schemeYlOrBr),
	    YlOrRd: (0, _last3.default)(_d3ScaleChromatic.schemeYlOrRd)
	};
	
	var quantizeColorScalesKeys = exports.quantizeColorScalesKeys = Object.keys(quantizeColorScales);
	
	var guessQuantizeColorScale = exports.guessQuantizeColorScale = function guessQuantizeColorScale(colors) {
	    // colors is already a valid scale
	    if ((0, _isFunction3.default)(colors)) {
	        if (!(0, _isFunction3.default)(colors.domain)) {
	            throw new Error('Provided colors should be a valid quantize scale providing a \'domain()\' function');
	        }
	
	        return colors;
	    }
	
	    if (quantizeColorScales[colors]) {
	        // use predefined d3 quantize color scale
	        return (0, _d3Scale.scaleQuantize)().range(quantizeColorScales[colors]);
	    }
	
	    // user defined colors
	    if ((0, _isArray3.default)(colors)) return (0, _d3Scale.scaleQuantize)().range(colors);
	
	    throw new Error('Unable to guess quantize color scale from \'' + colors + '\',\nmust be a function or one of:\n\'' + quantizeColorScalesKeys.join('\', \'') + '\'');
	};

/***/ },
/* 1174 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	
	/**
	 * Computes distance between two points.
	 *
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @return {number}
	 */
	var getDistance = exports.getDistance = function getDistance(x1, y1, x2, y2) {
	  var deltaX = x2 - x1;
	  var deltaY = y2 - y1;
	
	  deltaX *= deltaX;
	  deltaY *= deltaY;
	
	  return Math.sqrt(deltaX + deltaY);
	};
	
	/**
	 * Computes angle (radians) between two points.
	 *
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @return {number}
	 */
	var getAngle = exports.getAngle = function getAngle(x1, y1, x2, y2) {
	  var angle = Math.atan2(y2 - y1, x2 - x1) - Math.PI / 2;
	
	  return angle > 0 ? angle : Math.PI * 2 + angle;
	};
	
	/**
	 * Check if cursor is in given rectangle.
	 *
	 * @param {number} x
	 * @param {number} y
	 * @param {number} width
	 * @param {number} height
	 * @param {number} cursorX
	 * @param {number} cursorY
	 * @return {boolean}
	 */
	var isCursorInRect = exports.isCursorInRect = function isCursorInRect(x, y, width, height, cursorX, cursorY) {
	  return x <= cursorX && cursorX <= x + width && y <= cursorY && cursorY <= y + height;
	};
	
	/**
	 * Check if cursor is in given ring.
	 *
	 * @param {number} centerX
	 * @param {number} centerY
	 * @param {number} radius
	 * @param {number} innerRadius
	 * @param {number} cursorX
	 * @param {number} cursorY
	 * @return {boolean}
	 */
	var isCursorInRing = exports.isCursorInRing = function isCursorInRing(centerX, centerY, radius, innerRadius, cursorX, cursorY) {
	  var distance = getDistance(cursorX, cursorY, centerX, centerY);
	
	  return distance < radius && distance > innerRadius;
	};
	
	/**
	 * Search for an arc being under cursor.
	 *
	 * @param {number}         centerX
	 * @param {number}         centerY
	 * @param {number}         radius
	 * @param {number}         innerRadius
	 * @param {Array.<Object>} arcs
	 * @param {number}         cursorX
	 * @param {number}         cursorY
	 * @return {*}
	 */
	var getHoveredArc = exports.getHoveredArc = function getHoveredArc(centerX, centerY, radius, innerRadius, arcs, cursorX, cursorY) {
	  if (!isCursorInRing(centerX, centerY, radius, innerRadius, cursorX, cursorY)) return null;
	
	  var cursorAngle = getAngle(cursorX, cursorY, centerX, centerY);
	
	  return arcs.find(function (_ref) {
	    var startAngle = _ref.startAngle,
	        endAngle = _ref.endAngle;
	    return cursorAngle >= startAngle && cursorAngle < endAngle;
	  });
	};

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getPolarLabelProps = undefined;
	
	var _utils = __webpack_require__(535);
	
	var _bridge = __webpack_require__(529);
	
	/**
	 * @param {number} radius
	 * @param {number} angle          angle (radians)
	 * @param {number} [rotation=0]   label rotation (degrees)
	 * @param {string} [engine='svg'] one of: 'svg', 'canvas'
	 * @return {{ x: number, y: number, rotate: number, align: string, baseline: string }}
	 */
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var getPolarLabelProps = exports.getPolarLabelProps = function getPolarLabelProps(radius, angle, rotation) {
	    var engine = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'svg';
	
	    var textProps = _bridge.textPropsByEngine[engine];
	
	    var _positionFromAngle = (0, _utils.positionFromAngle)(angle - Math.PI / 2, radius),
	        x = _positionFromAngle.x,
	        y = _positionFromAngle.y;
	
	    var rotate = (0, _utils.radiansToDegrees)(angle);
	    var align = textProps.align.center;
	    var baseline = textProps.baseline.bottom;
	
	    if (rotation > 0) {
	        align = textProps.align.right;
	        baseline = textProps.baseline.center;
	    } else if (rotation < 0) {
	        align = textProps.align.left;
	        baseline = textProps.baseline.center;
	    }
	
	    // reverse labels after 180°
	    if (rotation !== 0 && rotate > 180) {
	        rotate -= 180;
	        align = align === textProps.align.right ? textProps.align.left : textProps.align.right;
	    }
	
	    rotate += rotation;
	
	    return { x: x, y: y, rotate: rotate, align: align, baseline: baseline };
	};

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.quantizeColorScalePropType = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colors = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var quantizeColorScalePropType = exports.quantizeColorScalePropType = _propTypes2.default.oneOfType([_propTypes2.default.oneOf(_colors.quantizeColorScalesKeys), _propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.string)]);

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.curveFromProp = exports.lineCurvePropType = exports.lineCurvePropKeys = exports.areaCurvePropType = exports.areaCurvePropKeys = exports.closedCurvePropType = exports.closedCurvePropKeys = exports.curvePropType = exports.curvePropKeys = exports.curvePropMapping = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _without = __webpack_require__(160);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _d3Shape = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var curvePropMapping = exports.curvePropMapping = {
	    basis: _d3Shape.curveBasis,
	    basisClosed: _d3Shape.curveBasisClosed,
	    basisOpen: _d3Shape.curveBasisOpen,
	    bundle: _d3Shape.curveBundle,
	    cardinal: _d3Shape.curveCardinal,
	    cardinalClosed: _d3Shape.curveCardinalClosed,
	    cardinalOpen: _d3Shape.curveCardinalOpen,
	    catmullRom: _d3Shape.curveCatmullRom,
	    catmullRomClosed: _d3Shape.curveCatmullRomClosed,
	    catmullRomOpen: _d3Shape.curveCatmullRomOpen,
	    linear: _d3Shape.curveLinear,
	    linearClosed: _d3Shape.curveLinearClosed,
	    monotoneX: _d3Shape.curveMonotoneX,
	    monotoneY: _d3Shape.curveMonotoneY,
	    natural: _d3Shape.curveNatural,
	    step: _d3Shape.curveStep,
	    stepAfter: _d3Shape.curveStepAfter,
	    stepBefore: _d3Shape.curveStepBefore
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */
	var curvePropKeys = exports.curvePropKeys = Object.keys(curvePropMapping);
	
	var curvePropType = exports.curvePropType = _propTypes2.default.oneOf(curvePropKeys);
	
	var closedCurvePropKeys = exports.closedCurvePropKeys = curvePropKeys.filter(function (c) {
	    return c.endsWith('Closed');
	});
	
	var closedCurvePropType = exports.closedCurvePropType = _propTypes2.default.oneOf(closedCurvePropKeys);
	
	// Safe curves to be used with d3 area shape generator
	var areaCurvePropKeys = exports.areaCurvePropKeys = (0, _without2.default)(curvePropKeys, 'bundle', 'basisClosed', 'basisOpen', 'cardinalClosed', 'cardinalOpen', 'catmullRomClosed', 'catmullRomOpen', 'linearClosed');
	
	var areaCurvePropType = exports.areaCurvePropType = _propTypes2.default.oneOf(areaCurvePropKeys);
	
	// Safe curves to be used with d3 line shape generator
	var lineCurvePropKeys = exports.lineCurvePropKeys = (0, _without2.default)(curvePropKeys, 'bundle', 'basisClosed', 'basisOpen', 'cardinalClosed', 'cardinalOpen', 'catmullRomClosed', 'catmullRomOpen', 'linearClosed');
	
	var lineCurvePropType = exports.lineCurvePropType = _propTypes2.default.oneOf(lineCurvePropKeys);
	
	/**
	 * Returns curve interpolator from given identifier.
	 *
	 * @param {string} id - Curve interpolator identifier
	 * @return {Function}
	 */
	var curveFromProp = exports.curveFromProp = function curveFromProp(id) {
	    var curveInterpolator = curvePropMapping[id];
	    if (!curveInterpolator) {
	        throw new TypeError('\'' + id + '\', is not a valid curve interpolator identifier.');
	    }
	
	    return curvePropMapping[id];
	};

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.defsPropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defsPropTypes = exports.defsPropTypes = {
	    defs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired
	    })).isRequired,
	    fill: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string,
	        match: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['*']), _propTypes2.default.object, _propTypes2.default.func]).isRequired
	    })).isRequired
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.sankeyAlignmentFromProp = exports.sankeyAlignmentPropType = exports.sankeyAlignmentPropKeys = exports.sankeyAlignmentPropMapping = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Sankey = __webpack_require__(252);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var sankeyAlignmentPropMapping = exports.sankeyAlignmentPropMapping = {
	  center: _d3Sankey.sankeyCenter,
	  justify: _d3Sankey.sankeyJustify,
	  left: _d3Sankey.sankeyLeft,
	  right: _d3Sankey.sankeyRight
	};
	
	var sankeyAlignmentPropKeys = exports.sankeyAlignmentPropKeys = Object.keys(sankeyAlignmentPropMapping);
	
	var sankeyAlignmentPropType = exports.sankeyAlignmentPropType = _propTypes2.default.oneOf(sankeyAlignmentPropKeys);
	
	var sankeyAlignmentFromProp = exports.sankeyAlignmentFromProp = function sankeyAlignmentFromProp(prop) {
	  return sankeyAlignmentPropMapping[prop];
	};

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.stackOffsetFromProp = exports.stackOffsetPropType = exports.stackOffsetPropKeys = exports.stackOffsetPropMapping = exports.stackOrderFromProp = exports.stackOrderPropType = exports.stackOrderPropKeys = exports.stackOrderPropMapping = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var stackOrderPropMapping = exports.stackOrderPropMapping = {
	    ascending: _d3Shape.stackOrderAscending,
	    descending: _d3Shape.stackOrderDescending,
	    insideOut: _d3Shape.stackOrderInsideOut,
	    none: _d3Shape.stackOrderNone,
	    reverse: _d3Shape.stackOrderReverse
	};
	
	var stackOrderPropKeys = exports.stackOrderPropKeys = Object.keys(stackOrderPropMapping);
	
	var stackOrderPropType = exports.stackOrderPropType = _propTypes2.default.oneOf(stackOrderPropKeys);
	
	var stackOrderFromProp = exports.stackOrderFromProp = function stackOrderFromProp(prop) {
	    return stackOrderPropMapping[prop];
	};
	
	var stackOffsetPropMapping = exports.stackOffsetPropMapping = {
	    expand: _d3Shape.stackOffsetExpand,
	    diverging: _d3Shape.stackOffsetDiverging,
	    none: _d3Shape.stackOffsetNone,
	    silhouette: _d3Shape.stackOffsetSilhouette,
	    wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var stackOffsetPropKeys = exports.stackOffsetPropKeys = Object.keys(stackOffsetPropMapping);
	
	var stackOffsetPropType = exports.stackOffsetPropType = _propTypes2.default.oneOf(stackOffsetPropKeys);
	
	var stackOffsetFromProp = exports.stackOffsetFromProp = function stackOffsetFromProp(prop) {
	    return stackOffsetPropMapping[prop];
	};

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.treeMapTileFromProp = exports.treeMapTilePropType = exports.treeMapTilePropKeys = exports.treeMapTilePropMapping = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Hierarchy = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var treeMapTilePropMapping = exports.treeMapTilePropMapping = {
	    binary: _d3Hierarchy.treemapBinary,
	    dice: _d3Hierarchy.treemapDice,
	    slice: _d3Hierarchy.treemapSlice,
	    sliceDice: _d3Hierarchy.treemapSliceDice,
	    squarify: _d3Hierarchy.treemapSquarify,
	    resquarify: _d3Hierarchy.treemapResquarify
	};
	
	var treeMapTilePropKeys = exports.treeMapTilePropKeys = Object.keys(treeMapTilePropMapping);
	
	var treeMapTilePropType = exports.treeMapTilePropType = _propTypes2.default.oneOf(treeMapTilePropKeys);
	
	var treeMapTileFromProp = exports.treeMapTileFromProp = function treeMapTileFromProp(prop) {
	    return treeMapTilePropMapping[prop];
	};

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(47)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1183 */
382,
/* 1184 */
145,
/* 1185 */
[1487, 536],
/* 1186 */
254,
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1188 */
709,
/* 1189 */
710,
/* 1190 */
[1485, 1188, 1189, 1191],
/* 1191 */
712,
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(312);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(225);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(314);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(133);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(96);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(313);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(315);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(312);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(225);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(314);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(133);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(96);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(313);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(315);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(312);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(225);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(314);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(1195);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(133);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(96);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(313);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(315);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ },
/* 1195 */
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 1197 */
[1489, 538],
/* 1198 */
36,
/* 1199 */
4,
/* 1200 */
[1490, 1198, 1199],
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(539);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(539);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1204 */
[1490, 36, 4],
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(36);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	var ReactPropTypesSecret = __webpack_require__(1206);
	var checkPropTypes = __webpack_require__(1203);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1206 */
652,
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)))

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(185);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 1209 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(34);
	
	var focusNode = __webpack_require__(402);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(170);
	var ExecutionEnvironment = __webpack_require__(50);
	var FallbackCompositionState = __webpack_require__(1217);
	var SyntheticCompositionEvent = __webpack_require__(1251);
	var SyntheticInputEvent = __webpack_require__(1254);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(542);
	var ExecutionEnvironment = __webpack_require__(50);
	var ReactInstrumentation = __webpack_require__(65);
	
	var camelizeStyleName = __webpack_require__(863);
	var dangerousStyleValue = __webpack_require__(1260);
	var hyphenateStyleName = __webpack_require__(870);
	var memoizeStringOnly = __webpack_require__(873);
	var warning = __webpack_require__(8);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(169);
	var EventPropagators = __webpack_require__(170);
	var ExecutionEnvironment = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(72);
	var SyntheticEvent = __webpack_require__(86);
	
	var getEventTarget = __webpack_require__(328);
	var isEventSupported = __webpack_require__(330);
	var isTextInputElement = __webpack_require__(564);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var DOMLazyTree = __webpack_require__(134);
	var ExecutionEnvironment = __webpack_require__(50);
	
	var createNodesFromMarkup = __webpack_require__(866);
	var emptyFunction = __webpack_require__(36);
	var invariant = __webpack_require__(4);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 1215 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(170);
	var ReactDOMComponentTree = __webpack_require__(34);
	var SyntheticMouseEvent = __webpack_require__(227);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var PooledClass = __webpack_require__(109);
	
	var getTextContentAccessor = __webpack_require__(563);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(135);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(110);
	
	var instantiateReactComponent = __webpack_require__(329);
	var KeyEscapeUtils = __webpack_require__(320);
	var shouldUpdateReactComponent = __webpack_require__(331);
	var traverseAllChildren = __webpack_require__(566);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/talk-react-d3"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(602);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)))

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(316);
	var ReactDOMIDOperations = __webpack_require__(1226);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(11);
	
	var React = __webpack_require__(115);
	var ReactComponentEnvironment = __webpack_require__(322);
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactErrorUtils = __webpack_require__(323);
	var ReactInstanceMap = __webpack_require__(171);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactNodeTypes = __webpack_require__(556);
	var ReactReconciler = __webpack_require__(110);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(43);
	var invariant = __webpack_require__(4);
	var shallowEqual = __webpack_require__(185);
	var shouldUpdateReactComponent = __webpack_require__(331);
	var warning = __webpack_require__(8);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDefaultInjection = __webpack_require__(549);
	var ReactMount = __webpack_require__(555);
	var ReactReconciler = __webpack_require__(110);
	var ReactUpdates = __webpack_require__(72);
	var ReactVersion = __webpack_require__(558);
	
	var findDOMNode = __webpack_require__(1261);
	var getHostComponentFromComposite = __webpack_require__(562);
	var renderSubtreeIntoContainer = __webpack_require__(1268);
	var warning = __webpack_require__(8);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(11);
	
	var AutoFocusUtils = __webpack_require__(1210);
	var CSSPropertyOperations = __webpack_require__(1212);
	var DOMLazyTree = __webpack_require__(134);
	var DOMNamespaces = __webpack_require__(317);
	var DOMProperty = __webpack_require__(135);
	var DOMPropertyOperations = __webpack_require__(544);
	var EventPluginHub = __webpack_require__(169);
	var EventPluginRegistry = __webpack_require__(318);
	var ReactBrowserEventEmitter = __webpack_require__(226);
	var ReactDOMComponentFlags = __webpack_require__(545);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMInput = __webpack_require__(1227);
	var ReactDOMOption = __webpack_require__(1228);
	var ReactDOMSelect = __webpack_require__(547);
	var ReactDOMTextarea = __webpack_require__(1232);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactMultiChild = __webpack_require__(1238);
	var ReactServerRenderingTransaction = __webpack_require__(557);
	
	var emptyFunction = __webpack_require__(36);
	var escapeTextContentForBrowser = __webpack_require__(229);
	var invariant = __webpack_require__(4);
	var isEventSupported = __webpack_require__(330);
	var shallowEqual = __webpack_require__(185);
	var validateDOMNesting = __webpack_require__(332);
	var warning = __webpack_require__(8);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var DOMLazyTree = __webpack_require__(134);
	var ReactDOMComponentTree = __webpack_require__(34);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1225 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(316);
	var ReactDOMComponentTree = __webpack_require__(34);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(11);
	
	var DOMPropertyOperations = __webpack_require__(544);
	var LinkedValueUtils = __webpack_require__(321);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(72);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var React = __webpack_require__(115);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMSelect = __webpack_require__(547);
	
	var warning = __webpack_require__(8);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var getNodeForCharacterOffset = __webpack_require__(1265);
	var getTextContentAccessor = __webpack_require__(563);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(549);
	var ReactServerRendering = __webpack_require__(1244);
	var ReactVersion = __webpack_require__(558);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(11);
	
	var DOMChildrenOperations = __webpack_require__(316);
	var DOMLazyTree = __webpack_require__(134);
	var ReactDOMComponentTree = __webpack_require__(34);
	
	var escapeTextContentForBrowser = __webpack_require__(229);
	var invariant = __webpack_require__(4);
	var validateDOMNesting = __webpack_require__(332);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(11);
	
	var LinkedValueUtils = __webpack_require__(321);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(72);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1234 */
603,
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(169);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var EventListener = __webpack_require__(401);
	var ExecutionEnvironment = __webpack_require__(50);
	var PooledClass = __webpack_require__(109);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(72);
	
	var getEventTarget = __webpack_require__(328);
	var getUnboundedScrollPosition = __webpack_require__(868);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(135);
	var EventPluginHub = __webpack_require__(169);
	var EventPluginUtils = __webpack_require__(319);
	var ReactComponentEnvironment = __webpack_require__(322);
	var ReactEmptyComponent = __webpack_require__(550);
	var ReactBrowserEventEmitter = __webpack_require__(226);
	var ReactHostComponent = __webpack_require__(552);
	var ReactUpdates = __webpack_require__(72);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactComponentEnvironment = __webpack_require__(322);
	var ReactInstanceMap = __webpack_require__(171);
	var ReactInstrumentation = __webpack_require__(65);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactReconciler = __webpack_require__(110);
	var ReactChildReconciler = __webpack_require__(1219);
	
	var emptyFunction = __webpack_require__(36);
	var flattenChildren = __webpack_require__(1262);
	var invariant = __webpack_require__(4);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1240 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var CallbackQueue = __webpack_require__(543);
	var PooledClass = __webpack_require__(109);
	var ReactBrowserEventEmitter = __webpack_require__(226);
	var ReactInputSelection = __webpack_require__(553);
	var ReactInstrumentation = __webpack_require__(65);
	var Transaction = __webpack_require__(228);
	var ReactUpdateQueue = __webpack_require__(324);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1239);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1243 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var React = __webpack_require__(115);
	var ReactDOMContainerInfo = __webpack_require__(546);
	var ReactDefaultBatchingStrategy = __webpack_require__(548);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactMarkupChecksum = __webpack_require__(554);
	var ReactReconciler = __webpack_require__(110);
	var ReactServerBatchingStrategy = __webpack_require__(1243);
	var ReactServerRenderingTransaction = __webpack_require__(557);
	var ReactUpdates = __webpack_require__(72);
	
	var emptyObject = __webpack_require__(43);
	var instantiateReactComponent = __webpack_require__(329);
	var invariant = __webpack_require__(4);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(324);
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1246 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(170);
	var ExecutionEnvironment = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInputSelection = __webpack_require__(553);
	var SyntheticEvent = __webpack_require__(86);
	
	var getActiveElement = __webpack_require__(403);
	var isTextInputElement = __webpack_require__(564);
	var shallowEqual = __webpack_require__(185);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var EventListener = __webpack_require__(401);
	var EventPropagators = __webpack_require__(170);
	var ReactDOMComponentTree = __webpack_require__(34);
	var SyntheticAnimationEvent = __webpack_require__(1249);
	var SyntheticClipboardEvent = __webpack_require__(1250);
	var SyntheticEvent = __webpack_require__(86);
	var SyntheticFocusEvent = __webpack_require__(1253);
	var SyntheticKeyboardEvent = __webpack_require__(1255);
	var SyntheticMouseEvent = __webpack_require__(227);
	var SyntheticDragEvent = __webpack_require__(1252);
	var SyntheticTouchEvent = __webpack_require__(1256);
	var SyntheticTransitionEvent = __webpack_require__(1257);
	var SyntheticUIEvent = __webpack_require__(172);
	var SyntheticWheelEvent = __webpack_require__(1258);
	
	var emptyFunction = __webpack_require__(36);
	var getEventCharCode = __webpack_require__(326);
	var invariant = __webpack_require__(4);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(227);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(172);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(172);
	
	var getEventCharCode = __webpack_require__(326);
	var getEventKey = __webpack_require__(1263);
	var getEventModifierState = __webpack_require__(327);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(172);
	
	var getEventModifierState = __webpack_require__(327);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(227);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1259 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(542);
	var warning = __webpack_require__(8);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInstanceMap = __webpack_require__(171);
	
	var getHostComponentFromComposite = __webpack_require__(562);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(320);
	var traverseAllChildren = __webpack_require__(566);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/talk-react-d3"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(602);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)))

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(326);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1264 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1265 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(229);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(555);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1230);


/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withContentRect = __webpack_require__(567);
	
	var _withContentRect2 = _interopRequireDefault(_withContentRect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Measure(_ref) {
	  var measure = _ref.measure,
	      measureRef = _ref.measureRef,
	      contentRect = _ref.contentRect,
	      children = _ref.children;
	
	  return children({ measure: measure, measureRef: measureRef, contentRect: contentRect });
	}
	
	exports.default = (0, _withContentRect2.default)()(Measure);
	module.exports = exports['default'];

/***/ },
/* 1271 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function getContentRect(node, types) {
	  var calculations = {};
	
	  if (types.indexOf('client') > -1) {
	    calculations.client = {
	      top: node.clientTop,
	      left: node.clientLeft,
	      width: node.clientWidth,
	      height: node.clientHeight
	    };
	  }
	
	  if (types.indexOf('offset') > -1) {
	    calculations.offset = {
	      top: node.offsetTop,
	      left: node.offsetLeft,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    };
	  }
	
	  if (types.indexOf('scroll') > -1) {
	    calculations.scroll = {
	      top: node.scrollTop,
	      left: node.scrollLeft,
	      width: node.scrollWidth,
	      height: node.scrollHeight
	    };
	  }
	
	  if (types.indexOf('bounds') > -1) {
	    var rect = node.getBoundingClientRect();
	    calculations.bounds = {
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left,
	      width: rect.width,
	      height: rect.height
	    };
	  }
	
	  if (types.indexOf('margin') > -1) {
	    var styles = getComputedStyle(node);
	    calculations.margin = {
	      top: parseInt(styles.marginTop),
	      right: parseInt(styles.marginRight),
	      bottom: parseInt(styles.marginBottom),
	      left: parseInt(styles.marginLeft)
	    };
	  }
	
	  return calculations;
	}
	
	exports.default = getContentRect;
	module.exports = exports['default'];

/***/ },
/* 1272 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTypes;
	var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
	
	function getTypes(props) {
	  var allowedTypes = [];
	  types.forEach(function (type) {
	    if (props[type]) {
	      allowedTypes.push(type);
	    }
	  });
	  return allowedTypes;
	}
	module.exports = exports['default'];

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withContentRect = exports.default = undefined;
	
	var _Measure = __webpack_require__(1270);
	
	var _Measure2 = _interopRequireDefault(_Measure);
	
	var _withContentRect = __webpack_require__(567);
	
	var _withContentRect2 = _interopRequireDefault(_withContentRect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Measure2.default;
	exports.withContentRect = _withContentRect2.default;

/***/ },
/* 1274 */
709,
/* 1275 */
710,
/* 1276 */
[1485, 1274, 1275, 1278],
/* 1277 */
[1486, 1276],
/* 1278 */
712,
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(333);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(231);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(335);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(133);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(96);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(334);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(250);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    onRest: _propTypes2['default'].func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(333);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(231);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(335);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(133);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(96);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(334);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(250);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	    styles: _propTypes2['default'].func.isRequired,
	    children: _propTypes2['default'].func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(333);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(231);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(335);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(1282);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(133);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(96);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(334);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(250);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _createReactClass2['default']({
	  propTypes: {
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	    })),
	    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	    }))]).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    willEnter: _propTypes2['default'].func,
	    willLeave: _propTypes2['default'].func,
	    didLeave: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  unmounting: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    if (this.unmounting) {
	      return;
	    }
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // https://github.com/chenglou/react-motion/pull/420
	      // > if execution passes the conditional if (this.unmounting), then
	      // executes async defaultRaf and after that component unmounts and after
	      // that the callback of defaultRaf is called, then setState will be called
	      // on unmounted component.
	      if (_this.unmounting) {
	        return;
	      }
	
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ },
/* 1282 */
1195,
/* 1283 */
[1488, 1279, 1280, 1281, 1285, 568, 231, 1284],
/* 1284 */
1196,
/* 1285 */
[1489, 568],
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeDetectorStyles = __webpack_require__(1287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResizeDetector = function (_Component) {
	  _inherits(ResizeDetector, _Component);
	
	  function ResizeDetector() {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));
	
	    _this.state = {
	      expandChildHeight: 0,
	      expandChildWidth: 0,
	      expandScrollLeft: 0,
	      expandScrollTop: 0,
	      shrinkScrollTop: 0,
	      shrinkScrollLeft: 0,
	      lastWidth: 0,
	      lastHeight: 0
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _containerSize = this.containerSize(),
	          _containerSize2 = _slicedToArray(_containerSize, 2),
	          width = _containerSize2[0],
	          height = _containerSize2[1];
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.expand.scrollLeft = this.expand.scrollWidth;
	      this.expand.scrollTop = this.expand.scrollHeight;
	
	      this.shrink.scrollLeft = this.shrink.scrollWidth;
	      this.shrink.scrollTop = this.shrink.scrollHeight;
	    }
	  }, {
	    key: 'containerSize',
	    value: function containerSize() {
	      return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
	    }
	  }, {
	    key: 'reset',
	    value: function reset(containerWidth, containerHeight) {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var parent = this.container.parentElement;
	
	      var position = 'static';
	      if (parent.currentStyle) {
	        position = parent.currentStyle.position;
	      } else if (window.getComputedStyle) {
	        position = window.getComputedStyle(parent).position;
	      }
	      if (position === 'static') {
	        parent.style.position = 'relative';
	      }
	
	      this.setState({
	        expandChildHeight: this.expand.offsetHeight + 10,
	        expandChildWidth: this.expand.offsetWidth + 10,
	        lastWidth: containerWidth,
	        lastHeight: containerHeight
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var state = this.state;
	
	      var _containerSize3 = this.containerSize(),
	          _containerSize4 = _slicedToArray(_containerSize3, 2),
	          width = _containerSize4[0],
	          height = _containerSize4[1];
	
	      if (width !== state.lastWidth || height !== state.lastHeight) {
	        this.props.onResize(width, height);
	      }
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var state = this.state;
	
	
	      var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
	        width: state.expandChildWidth,
	        height: state.expandChildHeight
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
	            _this2.container = e;
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.expand = e;
	            } },
	          _react2.default.createElement('div', { style: expandStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.shrink = e;
	            } },
	          _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })
	        )
	      );
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.Component);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ },
/* 1287 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var parentStyle = exports.parentStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  right: 0,
	  bottom: 0,
	  overflow: 'scroll',
	  zIndex: -1,
	  visibility: 'hidden'
	};
	
	var shrinkChildStyle = exports.shrinkChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '200%',
	  height: '200%'
	};
	
	var expandChildStyle = exports.expandChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(1286);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1202).enable();
	  window.Promise = __webpack_require__(1201);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1482);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(11);


/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(1299);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateGroupChild = __webpack_require__(1291);
	
	var _AnimateGroupChild2 = _interopRequireDefault(_AnimateGroupChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroup = (_temp = _class = function (_Component) {
	  _inherits(AnimateGroup, _Component);
	
	  function AnimateGroup() {
	    _classCallCheck(this, AnimateGroup);
	
	    return _possibleConstructorReturn(this, (AnimateGroup.__proto__ || Object.getPrototypeOf(AnimateGroup)).apply(this, arguments));
	  }
	
	  _createClass(AnimateGroup, [{
	    key: 'wrapChild',
	    value: function wrapChild(child) {
	      var _props = this.props,
	          appear = _props.appear,
	          leave = _props.leave,
	          enter = _props.enter;
	
	
	      return _react2.default.createElement(
	        _AnimateGroupChild2.default,
	        {
	          appear: appear,
	          leave: leave,
	          enter: enter
	        },
	        child
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          children = _props2.children;
	
	
	      return _react2.default.createElement(
	        _reactTransitionGroup.TransitionGroup,
	        {
	          component: component,
	          childFactory: this.wrapChild.bind(this)
	        },
	        children
	      );
	    }
	  }]);
	
	  return AnimateGroup;
	}(_react.Component), _class.propTypes = {
	  appear: _propTypes2.default.object,
	  leave: _propTypes2.default.object,
	  enter: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
	  component: _propTypes2.default.any
	}, _class.defaultProps = {
	  component: 'span'
	}, _temp);
	exports.default = AnimateGroup;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Animate = __webpack_require__(569);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroupChild = (_temp2 = _class = function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimateGroupChild.__proto__ || Object.getPrototypeOf(AnimateGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isActive: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: 'handleStyleActive',
	    value: function handleStyleActive(style, done) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	          done();
	        } : done;
	
	        this.setState(_extends({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      this.handleStyleActive(this.props.appear, done);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      this.handleStyleActive(this.props.enter, done);
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      this.handleStyleActive(this.props.leave, done);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Animate2.default,
	        this.state,
	        _react.Children.only(this.props.children)
	      );
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component), _class.propTypes = {
	  appear: _propTypes2.default.object,
	  leave: _propTypes2.default.object,
	  enter: _propTypes2.default.object,
	  children: _propTypes2.default.element
	}, _temp2);
	exports.default = AnimateGroupChild;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = createAnimateManager;
	
	var _setRafTimeout = __webpack_require__(1295);
	
	var _setRafTimeout2 = _interopRequireDefault(_setRafTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function createAnimateManager() {
	  var currStyle = {};
	  var handleChange = function handleChange() {
	    return null;
	  };
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles), curr);
	
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if ((typeof _style === 'undefined' ? 'undefined' : _typeof(_style)) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = undefined;
	
	var _isPlainObject2 = __webpack_require__(103);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isEqual2 = __webpack_require__(31);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    var keyA = keysA[i];
	
	    if (objA[keyA] === objB[keyA]) {
	      continue;
	    }
	
	    // special diff with Array or Object
	    if ((0, _isArray3.default)(objA[keyA])) {
	      if (!(0, _isArray3.default)(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
	        return false;
	      } else if (!(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if ((0, _isPlainObject3.default)(objA[keyA])) {
	      if (!(0, _isPlainObject3.default)(objB[keyA]) || !(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	function shouldComponentUpdate(nextProps, nextState) {
	  return shallowCompare(this, nextProps, nextState);
	}
	/* eslint-disable no-param-reassign */
	function pureRenderDecorator(component) {
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filter2 = __webpack_require__(1010);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _raf = __webpack_require__(96);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _util = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _extends({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _extends({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	};
	
	// configure update function
	
	exports.default = function (from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime = void 0;
	  var beginTime = void 0;
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter3.default)(stepperStyle, needContinue).length;
	  };
	
	  // stepper timing function like spring
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	
	    stepperStyle = calStepperVals(easing, stepperStyle, steps);
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, getCurrStyle(stepperStyle)));
	
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf2.default)(update);
	    }
	  };
	
	  // t => val timing function like cubic-bezier
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(undefined, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle);
	
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf2.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(undefined, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	
	      render(_extends({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate;
	
	  // return start animation method
	  return function () {
	    (0, _raf2.default)(update);
	
	    // return stop animation method
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = __webpack_require__(96);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf2.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf2.default)(shouldUpdate);
	}

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.render = undefined;
	
	var _reactDom = __webpack_require__(541);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _server = __webpack_require__(1269);
	
	var _server2 = _interopRequireDefault(_server);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var render = exports.render = function render(rootComponent, domElement) {
	  if (navigator.userAgent.match(/Node\.js/i)) {
	    domElement.innerHTML = _server2.default.renderToString(rootComponent);
	  } else {
	    _reactDom2.default.render(rootComponent, domElement);
	  }
	};

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(571);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(1298);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(572);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes = propTypes;
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(851);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(853);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(855);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(854);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(541);
	
	var _PropTypes = __webpack_require__(572);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes = propTypes;
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransitionGroup = __webpack_require__(1297);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _TransitionGroup = __webpack_require__(571);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransitionGroup: _CSSTransitionGroup2.default
	};

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1315);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactUikitBase = __webpack_require__(338);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Article = function Article(props) {
	  // CSS classes
	  var cssClassNames = _reactUikitBase.helpers.cleanClasses(['uk-article', props.classes, props.className]);
	
	  var ignoreProps = ['children', 'classes', 'kitid', 'lead', 'meta', 'title'];
	
	  // Remove non valid html attributes
	  var cleanProps = _reactUikitBase.helpers.cleanProps(ignoreProps)(props);
	
	  // Elements
	  var title = props.title ? _react2.default.createElement(
	    'h1',
	    { className: 'uk-article-title' },
	    props.title
	  ) : null;
	  var meta = props.meta ? _react2.default.createElement(
	    'p',
	    { className: 'uk-article-meta' },
	    props.meta
	  ) : null;
	  var lead = props.lead ? _react2.default.createElement(
	    'p',
	    { className: 'uk-article-lead' },
	    props.lead
	  ) : null;
	
	  // Return Component
	  return _react2.default.createElement(
	    'article',
	    _extends({}, cleanProps, (0, _reactUikitBase.events)(props), {
	      className: cssClassNames,
	      'data-kitid': props.kitid
	    }),
	    title,
	    meta,
	    lead,
	    props.children
	  );
	};
	
	Article.propTypes = {
	  children: _react2.default.PropTypes.any,
	  className: _react2.default.PropTypes.string,
	  classes: _react2.default.PropTypes.array,
	  kitid: _react2.default.PropTypes.string,
	  lead: _react2.default.PropTypes.string,
	  meta: _react2.default.PropTypes.string,
	  title: _react2.default.PropTypes.string
	};
	
	exports.default = (0, _reactUikitBase.base)(Article);

/***/ },
/* 1302 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 1303 */
[1492, 173],
/* 1304 */
[1493, 1305, 336, 1311, 1306, 1307, 111, 1309, 1312, 1313],
/* 1305 */
[1494, 1303, 111, 1314],
/* 1306 */
[1495, 173, 336, 111, 1308, 574, 337],
/* 1307 */
[1497, 111],
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(121);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 1309 */
[1499, 111, 574, 1310, 576],
/* 1310 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypesSecret
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1311 */
[1500, 336, 337],
/* 1312 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.3.2';

/***/ },
/* 1313 */
[1501, 173, 111],
/* 1314 */
[1502, 173, 573, 111, 576, 1302],
/* 1315 */
[1503, 1304],
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(583);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(577);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _uikit = __webpack_require__(338);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Element = function Element(props) {
	  var cssClassNames = _uikit.helpers.cleanClasses([props.classes, props.className]);
	
	  var cleanProps = _uikit.helpers.cleanProps([])(props);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({
	      className: cssClassNames
	    }, cleanProps),
	    props.children
	  );
	};
	
	Element.propTypes = {
	  classes: _react2.default.PropTypes.array,
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.any
	};
	
	function createElement() {
	  return (0, _base2.default)(Element);
	}
	exports.default = createElement;

/***/ },
/* 1317 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var events = function events(props) {
	  return {
	    // Mouse
	    onClick: props.onClick,
	    onDoubleClick: props.onDoubleClick,
	    onMouseDown: props.onMouseDown,
	    onMouseEnter: props.onMouseEnter,
	    onMouseLeave: props.onMouseLeave,
	    onMouseMove: props.onMouseMove,
	    onMouseOut: props.onMouseOut,
	    onMouseOver: props.onMouseOver,
	    onMouseUp: props.onMouseUp,
	
	    // Keyboard
	    onKeyDown: props.onKeyDown,
	    onKeyPress: props.onKeyPress,
	    onKeyUp: props.onKeyUp,
	
	    // Form
	    onBlur: props.onBlur,
	    onChange: props.onChange,
	    onFocus: props.onFocus,
	    onFocusIn: props.onFocusIn,
	    onInput: props.onInput,
	    onReset: props.onReset,
	    onSelect: props.onSelect,
	    onSubmit: props.onSubmit,
	
	    // Frame/Object
	    onLoad: props.onLoad,
	    onScroll: props.onScroll,
	
	    // Drag
	    onDrag: props.onDrag,
	    onDragEnd: props.onDragEnd,
	    onDragEnter: props.onDragEnter,
	    onDragLeave: props.onDragLeave,
	    onDragExit: props.onDragExit,
	    onDragOver: props.onDragOver,
	    onDragStart: props.onDragStart,
	    onDrop: props.onDrop,
	
	    // Clipboard
	    onCopy: props.onCopy,
	    onCut: props.onCut,
	    onPaste: props.onPaste,
	
	    // Media
	    onCanPlay: props.onCanPlay,
	    onCanPlayThrough: props.onCanPlayThrough,
	    onDurationChange: props.onDurationChange,
	    onEmptied: props.onEmptied,
	    onEnded: props.onEnded,
	    onLoadedData: props.onLoadedData,
	    onLoadedMetadata: props.onLoadedMetadata,
	    onLoadStart: props.onLoadStart,
	    onPause: props.oPausenPause,
	    onPlay: props.onPlay,
	    onPlaying: props.onPlaying,
	    onProgress: props.onProgress,
	    onRateChange: props.onRateChange,
	    onSeeked: props.onSeeked,
	    onSeeking: props.onSeeking,
	    onStalled: props.onStalled,
	    onSuspend: props.onSuspend,
	    onTimeUpdate: props.onTimeUpdate,
	    onVolumeChange: props.onVolumeChange,
	    onWaiting: props.onWaiting,
	
	    // Misc
	    onAbort: props.onAbort,
	    onError: props.onError,
	    onWheel: props.onWheel,
	
	    // Touch
	    onTouchCancel: props.onTouchCancel,
	    onTouchEnd: props.onTouchend,
	    onTouchMove: props.onTouchMove,
	    onTouchStart: props.onTouchStart
	  };
	};
	
	exports.default = events;

/***/ },
/* 1318 */
1302,
/* 1319 */
[1492, 174],
/* 1320 */
[1493, 1321, 340, 1327, 1322, 1323, 112, 1325, 1328, 1329],
/* 1321 */
[1494, 1319, 112, 1330],
/* 1322 */
[1495, 174, 340, 112, 1324, 580, 341],
/* 1323 */
[1497, 112],
/* 1324 */
1308,
/* 1325 */
[1499, 112, 580, 1326, 582],
/* 1326 */
1310,
/* 1327 */
[1500, 340, 341],
/* 1328 */
1312,
/* 1329 */
[1501, 174, 112],
/* 1330 */
[1502, 174, 579, 112, 582, 1318],
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1345);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactUikitBase = __webpack_require__(338);
	
	var _reactUikitBase2 = _interopRequireDefault(_reactUikitBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Grid = function Grid(props) {
	  // CSS classes
	  var cssClassNames = _reactUikitBase2.default.helpers.cleanClasses(['uk-grid', props.classes, props.divider ? 'uk-grid-divider' : null, props.gutter ? 'uk-grid-' + props.gutter : null, props.large ? 'uk-grid-width-large-' + props.large : null, props.match ? 'uk-grid-match' : null, props.medium ? 'uk-grid-width-medium-' + props.medium : null, props.small ? 'uk-grid-width-small-' + props.small : null, props.widths ? 'uk-grid-width-' + props.widths : null, props.xlarge ? 'uk-grid-width-xlarge-' + props.xlarge : null, props.className]);
	
	  // Remove non valid html attributes
	  var ignoreProps = ['children', 'classes', 'divider', 'gutter', 'indent', 'kitid', 'large', 'match', 'medium', 'small', 'type', 'widths', 'xlarge'];
	
	  var cleanProps = _reactUikitBase2.default.helpers.cleanProps(ignoreProps)(props);
	
	  // Elements
	  var events = _reactUikitBase2.default.events(props);
	
	  var type = {
	    block: _react2.default.createElement(
	      'div',
	      _extends({}, cleanProps, events, {
	        style: props.indent ? { marginLeft: '0px' } : null,
	        className: cssClassNames,
	        'data-kitid': props.kitid
	      }),
	      props.children
	    ),
	
	    list: _react2.default.createElement(
	      'ul',
	      _extends({}, cleanProps, _reactUikitBase2.default.events(props), {
	        className: cssClassNames,
	        'data-kitid': props.kitid
	      }),
	      props.children
	    )
	  };
	
	  // Return Component
	  return type[props.type] || type['block'];
	};
	
	Grid.propTypes = {
	  children: _react2.default.PropTypes.any,
	  className: _react2.default.PropTypes.string,
	  classes: _react2.default.PropTypes.array,
	  divider: _react2.default.PropTypes.bool,
	  gutter: _react2.default.PropTypes.oneOf(['small', 'medium', 'collapse']),
	  indent: _react2.default.PropTypes.bool,
	  kitid: _react2.default.PropTypes.string,
	  large: _react2.default.PropTypes.oneOf(_reactUikitBase2.default.helpers.colSpan),
	  match: _react2.default.PropTypes.bool,
	  medium: _react2.default.PropTypes.oneOf(_reactUikitBase2.default.helpers.colSpan),
	  small: _react2.default.PropTypes.oneOf(_reactUikitBase2.default.helpers.colSpan),
	  type: _react2.default.PropTypes.oneOf(['block', 'list']),
	  widths: _react2.default.PropTypes.oneOf(_reactUikitBase2.default.helpers.colSpan),
	  xlarge: _react2.default.PropTypes.oneOf(_reactUikitBase2.default.helpers.colSpan)
	};
	
	exports.default = _reactUikitBase2.default.base(Grid);

/***/ },
/* 1332 */
1302,
/* 1333 */
[1492, 175],
/* 1334 */
[1493, 1335, 342, 1341, 1336, 1337, 113, 1339, 1342, 1343],
/* 1335 */
[1494, 1333, 113, 1344],
/* 1336 */
[1495, 175, 342, 113, 1338, 585, 343],
/* 1337 */
[1497, 113],
/* 1338 */
1308,
/* 1339 */
[1499, 113, 585, 1340, 587],
/* 1340 */
1310,
/* 1341 */
[1500, 342, 343],
/* 1342 */
1312,
/* 1343 */
[1501, 175, 113],
/* 1344 */
[1502, 175, 584, 113, 587, 1332],
/* 1345 */
[1503, 1334],
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScaleUtils = exports.AxisUtils = exports.makeWidthFlexible = exports.Sunburst = exports.Sankey = exports.RadialChart = exports.Treemap = exports.ContinuousSizeLegend = exports.ContinuousColorLegend = exports.SearchableDiscreteColorLegend = exports.DiscreteColorLegend = exports.Voronoi = exports.HorizontalGridLines = exports.VerticalGridLines = exports.GridLines = exports.CircularGridLines = exports.YAxis = exports.XAxis = exports.XYPlot = exports.Crosshair = exports.Hint = exports.LineMarkSeriesGL = exports.LineMarkSeriesCanvas = exports.LineMarkSeries = exports.ArcSeries = exports.AreaSeries = exports.HeatmapSeries = exports.MarkSeriesCanvas = exports.MarkSeriesGL = exports.MarkSeries = exports.RectSeriesCanvas = exports.RectSeries = exports.PolygonSeries = exports.LabelSeries = exports.HorizontalRectSeriesCanvas = exports.HorizontalRectSeries = exports.VerticalRectSeriesCanvas = exports.VerticalRectSeries = exports.VerticalBarSeriesCanvas = exports.VerticalBarSeries = exports.HorizontalBarSeriesCanvas = exports.HorizontalBarSeries = exports.LineSeriesGL = exports.LineSeriesCanvas = exports.LineSeries = exports.AbstractSeries = undefined;
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _lineSeries = __webpack_require__(595);
	
	var _lineSeries2 = _interopRequireDefault(_lineSeries);
	
	var _lineSeriesCanvas = __webpack_require__(593);
	
	var _lineSeriesCanvas2 = _interopRequireDefault(_lineSeriesCanvas);
	
	var _lineSeriesGl = __webpack_require__(594);
	
	var _lineSeriesGl2 = _interopRequireDefault(_lineSeriesGl);
	
	var _horizontalBarSeries = __webpack_require__(1366);
	
	var _horizontalBarSeries2 = _interopRequireDefault(_horizontalBarSeries);
	
	var _horizontalBarSeriesCanvas = __webpack_require__(1365);
	
	var _horizontalBarSeriesCanvas2 = _interopRequireDefault(_horizontalBarSeriesCanvas);
	
	var _verticalBarSeries = __webpack_require__(1374);
	
	var _verticalBarSeries2 = _interopRequireDefault(_verticalBarSeries);
	
	var _verticalBarSeriesCanvas = __webpack_require__(1373);
	
	var _verticalBarSeriesCanvas2 = _interopRequireDefault(_verticalBarSeriesCanvas);
	
	var _verticalRectSeries = __webpack_require__(1376);
	
	var _verticalRectSeries2 = _interopRequireDefault(_verticalRectSeries);
	
	var _verticalRectSeriesCanvas = __webpack_require__(1375);
	
	var _verticalRectSeriesCanvas2 = _interopRequireDefault(_verticalRectSeriesCanvas);
	
	var _horizontalRectSeries = __webpack_require__(1368);
	
	var _horizontalRectSeries2 = _interopRequireDefault(_horizontalRectSeries);
	
	var _horizontalRectSeriesCanvas = __webpack_require__(1367);
	
	var _horizontalRectSeriesCanvas2 = _interopRequireDefault(_horizontalRectSeriesCanvas);
	
	var _labelSeries = __webpack_require__(592);
	
	var _labelSeries2 = _interopRequireDefault(_labelSeries);
	
	var _polygonSeries = __webpack_require__(1372);
	
	var _polygonSeries2 = _interopRequireDefault(_polygonSeries);
	
	var _rectSeries = __webpack_require__(347);
	
	var _rectSeries2 = _interopRequireDefault(_rectSeries);
	
	var _rectSeriesCanvas = __webpack_require__(346);
	
	var _rectSeriesCanvas2 = _interopRequireDefault(_rectSeriesCanvas);
	
	var _markSeries = __webpack_require__(598);
	
	var _markSeries2 = _interopRequireDefault(_markSeries);
	
	var _markSeriesGl = __webpack_require__(597);
	
	var _markSeriesGl2 = _interopRequireDefault(_markSeriesGl);
	
	var _markSeriesCanvas = __webpack_require__(596);
	
	var _markSeriesCanvas2 = _interopRequireDefault(_markSeriesCanvas);
	
	var _heatmapSeries = __webpack_require__(1364);
	
	var _heatmapSeries2 = _interopRequireDefault(_heatmapSeries);
	
	var _areaSeries = __webpack_require__(1361);
	
	var _areaSeries2 = _interopRequireDefault(_areaSeries);
	
	var _arcSeries = __webpack_require__(345);
	
	var _arcSeries2 = _interopRequireDefault(_arcSeries);
	
	var _lineMarkSeries = __webpack_require__(1371);
	
	var _lineMarkSeries2 = _interopRequireDefault(_lineMarkSeries);
	
	var _lineMarkSeriesCanvas = __webpack_require__(1369);
	
	var _lineMarkSeriesCanvas2 = _interopRequireDefault(_lineMarkSeriesCanvas);
	
	var _lineMarkSeriesGl = __webpack_require__(1370);
	
	var _lineMarkSeriesGl2 = _interopRequireDefault(_lineMarkSeriesGl);
	
	var _hint = __webpack_require__(1359);
	
	var _hint2 = _interopRequireDefault(_hint);
	
	var _crosshair = __webpack_require__(1358);
	
	var _crosshair2 = _interopRequireDefault(_crosshair);
	
	var _xyPlot = __webpack_require__(348);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _xAxis = __webpack_require__(1355);
	
	var _xAxis2 = _interopRequireDefault(_xAxis);
	
	var _yAxis = __webpack_require__(1356);
	
	var _yAxis2 = _interopRequireDefault(_yAxis);
	
	var _circularGridLines = __webpack_require__(1357);
	
	var _circularGridLines2 = _interopRequireDefault(_circularGridLines);
	
	var _gridLines = __webpack_require__(344);
	
	var _gridLines2 = _interopRequireDefault(_gridLines);
	
	var _verticalGridLines = __webpack_require__(1377);
	
	var _verticalGridLines2 = _interopRequireDefault(_verticalGridLines);
	
	var _horizontalGridLines = __webpack_require__(1360);
	
	var _horizontalGridLines2 = _interopRequireDefault(_horizontalGridLines);
	
	var _voronoi = __webpack_require__(599);
	
	var _voronoi2 = _interopRequireDefault(_voronoi);
	
	var _discreteColorLegend = __webpack_require__(588);
	
	var _discreteColorLegend2 = _interopRequireDefault(_discreteColorLegend);
	
	var _searchableDiscreteColorLegend = __webpack_require__(1350);
	
	var _searchableDiscreteColorLegend2 = _interopRequireDefault(_searchableDiscreteColorLegend);
	
	var _continuousColorLegend = __webpack_require__(1347);
	
	var _continuousColorLegend2 = _interopRequireDefault(_continuousColorLegend);
	
	var _continuousSizeLegend = __webpack_require__(1348);
	
	var _continuousSizeLegend2 = _interopRequireDefault(_continuousSizeLegend);
	
	var _treemap = __webpack_require__(1381);
	
	var _treemap2 = _interopRequireDefault(_treemap);
	
	var _radialChart = __webpack_require__(1378);
	
	var _radialChart2 = _interopRequireDefault(_radialChart);
	
	var _sankey = __webpack_require__(1379);
	
	var _sankey2 = _interopRequireDefault(_sankey);
	
	var _sunburst = __webpack_require__(1380);
	
	var _sunburst2 = _interopRequireDefault(_sunburst);
	
	var _makeVisFlexible = __webpack_require__(1351);
	
	var _makeVisFlexible2 = _interopRequireDefault(_makeVisFlexible);
	
	var _axisUtils = __webpack_require__(73);
	
	var _axisUtils2 = _interopRequireDefault(_axisUtils);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _scalesUtils2 = _interopRequireDefault(_scalesUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AbstractSeries = _abstractSeries2.default; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.LineSeries = _lineSeries2.default;
	exports.LineSeriesCanvas = _lineSeriesCanvas2.default;
	exports.LineSeriesGL = _lineSeriesGl2.default;
	exports.HorizontalBarSeries = _horizontalBarSeries2.default;
	exports.HorizontalBarSeriesCanvas = _horizontalBarSeriesCanvas2.default;
	exports.VerticalBarSeries = _verticalBarSeries2.default;
	exports.VerticalBarSeriesCanvas = _verticalBarSeriesCanvas2.default;
	exports.VerticalRectSeries = _verticalRectSeries2.default;
	exports.VerticalRectSeriesCanvas = _verticalRectSeriesCanvas2.default;
	exports.HorizontalRectSeries = _horizontalRectSeries2.default;
	exports.HorizontalRectSeriesCanvas = _horizontalRectSeriesCanvas2.default;
	exports.LabelSeries = _labelSeries2.default;
	exports.PolygonSeries = _polygonSeries2.default;
	exports.RectSeries = _rectSeries2.default;
	exports.RectSeriesCanvas = _rectSeriesCanvas2.default;
	exports.MarkSeries = _markSeries2.default;
	exports.MarkSeriesGL = _markSeriesGl2.default;
	exports.MarkSeriesCanvas = _markSeriesCanvas2.default;
	exports.HeatmapSeries = _heatmapSeries2.default;
	exports.AreaSeries = _areaSeries2.default;
	exports.ArcSeries = _arcSeries2.default;
	exports.LineMarkSeries = _lineMarkSeries2.default;
	exports.LineMarkSeriesCanvas = _lineMarkSeriesCanvas2.default;
	exports.LineMarkSeriesGL = _lineMarkSeriesGl2.default;
	exports.Hint = _hint2.default;
	exports.Crosshair = _crosshair2.default;
	exports.XYPlot = _xyPlot2.default;
	exports.XAxis = _xAxis2.default;
	exports.YAxis = _yAxis2.default;
	exports.CircularGridLines = _circularGridLines2.default;
	exports.GridLines = _gridLines2.default;
	exports.VerticalGridLines = _verticalGridLines2.default;
	exports.HorizontalGridLines = _horizontalGridLines2.default;
	exports.Voronoi = _voronoi2.default;
	exports.DiscreteColorLegend = _discreteColorLegend2.default;
	exports.SearchableDiscreteColorLegend = _searchableDiscreteColorLegend2.default;
	exports.ContinuousColorLegend = _continuousColorLegend2.default;
	exports.ContinuousSizeLegend = _continuousSizeLegend2.default;
	exports.Treemap = _treemap2.default;
	exports.RadialChart = _radialChart2.default;
	exports.Sankey = _sankey2.default;
	exports.Sunburst = _sunburst2.default;
	exports.makeWidthFlexible = _makeVisFlexible2.default;
	exports.AxisUtils = _axisUtils2.default;
	exports.ScaleUtils = _scalesUtils2.default;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _theme = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  height: _propTypes2.default.number,
	  endColor: _propTypes2.default.string,
	  endTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  midColor: _propTypes2.default.string,
	  midTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  startColor: _propTypes2.default.string,
	  startTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  width: _propTypes2.default.number
	}; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultProps = {
	  className: '',
	  startColor: _theme.CONTINUOUS_COLOR_RANGE[0],
	  endColor: _theme.CONTINUOUS_COLOR_RANGE[1]
	};
	
	function ContinuousColorLegend(_ref) {
	  var startColor = _ref.startColor,
	      midColor = _ref.midColor,
	      endColor = _ref.endColor,
	      startTitle = _ref.startTitle,
	      midTitle = _ref.midTitle,
	      endTitle = _ref.endTitle,
	      height = _ref.height,
	      width = _ref.width,
	      className = _ref.className;
	
	  var colors = [startColor];
	  if (midColor) {
	    colors.push(midColor);
	  }
	  colors.push(endColor);
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-continuous-color-legend ' + className, style: { width: width, height: height } },
	    _react2.default.createElement('div', {
	      className: 'rv-gradient',
	      style: { background: 'linear-gradient(to right, ' + colors.join(',') + ')' } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-legend-titles' },
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__left' },
	        startTitle
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__right' },
	        endTitle
	      ),
	      midTitle ? _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__center' },
	        midTitle
	      ) : null
	    )
	  );
	}
	
	ContinuousColorLegend.displayName = 'ContinuousColorLegend';
	ContinuousColorLegend.propTypes = propTypes;
	ContinuousColorLegend.defaultProps = defaultProps;
	
	exports.default = ContinuousColorLegend;

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  circlesTotal: _propTypes2.default.number,
	  endSize: _propTypes2.default.number,
	  endTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  height: _propTypes2.default.number,
	  startSize: _propTypes2.default.number,
	  startTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  width: _propTypes2.default.number
	};
	
	var defaultProps = {
	  circlesTotal: 10,
	  className: '',
	  endSize: 20,
	  startSize: 2
	};
	
	function ContinuousSizeLegend(_ref) {
	  var startTitle = _ref.startTitle,
	      endTitle = _ref.endTitle,
	      startSize = _ref.startSize,
	      endSize = _ref.endSize,
	      circlesTotal = _ref.circlesTotal,
	      height = _ref.height,
	      width = _ref.width,
	      className = _ref.className;
	
	  var circles = [];
	  var step = (endSize - startSize) / (circlesTotal - 1);
	
	  for (var i = 0; i < circlesTotal; i++) {
	    var size = step * i + startSize;
	    circles.push(_react2.default.createElement('div', { key: i, className: 'rv-bubble', style: {
	        width: size,
	        height: size,
	        borderRadius: size / 2
	      } }));
	    // Add the separator in order to justify the content (otherwise the tags
	    // will be stacked together without any margins around).
	    circles.push(' ');
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-continuous-size-legend ' + className, style: { width: width, height: height } },
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-bubbles', style: { height: endSize } },
	      circles,
	      _react2.default.createElement('div', { className: 'rv-spacer' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-legend-titles' },
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__left' },
	        startTitle
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__right' },
	        endTitle
	      )
	    )
	  );
	}
	
	ContinuousSizeLegend.displayName = 'ContinuousSizeLegend';
	ContinuousSizeLegend.propTypes = propTypes;
	ContinuousSizeLegend.defaultProps = defaultProps;
	
	exports.default = ContinuousSizeLegend;

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  color: _propTypes2.default.string.isRequired,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  orientation: _propTypes2.default.oneOf(['vertical', 'horizontal']).isRequired
	};
	
	var defaultProps = {
	  disabled: false
	};
	
	function DiscreteColorLegendItem(_ref) {
	  var onClick = _ref.onClick,
	      title = _ref.title,
	      color = _ref.color,
	      disabled = _ref.disabled,
	      orientation = _ref.orientation;
	
	  var className = 'rv-discrete-color-legend-item ' + orientation;
	  if (disabled) {
	    className += ' disabled';
	  }
	  if (onClick) {
	    className += ' clickable';
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: className, onClick: onClick },
	    _react2.default.createElement('span', {
	      className: 'rv-discrete-color-legend-item__color',
	      style: disabled ? null : { background: color } }),
	    _react2.default.createElement(
	      'span',
	      { className: 'rv-discrete-color-legend-item__title' },
	      title
	    )
	  );
	}
	
	DiscreteColorLegendItem.propTypes = propTypes;
	DiscreteColorLegendItem.defaultProps = defaultProps;
	DiscreteColorLegendItem.displayName = 'DiscreteColorLegendItem';
	
	exports.default = DiscreteColorLegendItem;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _discreteColorLegend = __webpack_require__(588);
	
	var _discreteColorLegend2 = _interopRequireDefault(_discreteColorLegend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _extends({}, _discreteColorLegend2.default.propTypes, {
	  searchText: _propTypes2.default.string,
	  onSearchChange: _propTypes2.default.func,
	  searchPlaceholder: _propTypes2.default.string,
	  searchFn: _propTypes2.default.func
	});
	
	var defaultProps = {
	  className: '',
	  searchText: '',
	  searchFn: function searchFn(items, s) {
	    return items.filter(function (item) {
	      return String(item.title || item).toLowerCase().indexOf(s) !== -1;
	    });
	  }
	};
	
	function SearchableDiscreteColorLegend(props) {
	  var items = props.items,
	      onItemClick = props.onItemClick,
	      searchFn = props.searchFn,
	      onSearchChange = props.onSearchChange,
	      searchText = props.searchText,
	      searchPlaceholder = props.searchPlaceholder,
	      width = props.width,
	      height = props.height,
	      className = props.className;
	
	  var onChange = onSearchChange ? function (_ref) {
	    var value = _ref.target.value;
	    return onSearchChange(value);
	  } : null;
	  var filteredItems = searchFn(items, searchText);
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-search-wrapper ' + className, style: { width: width, height: height } },
	    _react2.default.createElement(
	      'form',
	      { className: 'rv-search-wrapper__form' },
	      _react2.default.createElement('input', {
	        type: 'search',
	        placeholder: searchPlaceholder,
	        className: 'rv-search-wrapper__form__input',
	        value: searchText,
	        onChange: onChange })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-search-wrapper__contents' },
	      _react2.default.createElement(_discreteColorLegend2.default, {
	        items: filteredItems,
	        onItemClick: onItemClick })
	    )
	  );
	}
	
	SearchableDiscreteColorLegend.propTypes = propTypes;
	SearchableDiscreteColorLegend.defaultProps = defaultProps;
	SearchableDiscreteColorLegend.displayName = 'SearchableDiscreteColorLegend';
	
	exports.default = SearchableDiscreteColorLegend;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = makeVisFlexible;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _window = __webpack_require__(881);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _reactUtils = __webpack_require__(600);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var CONTAINER_REF = 'container';
	
	// As a performance enhancement, we want to only listen once
	var resizeSubscribers = [];
	var DEBOUNCE_DURATION = 100;
	var timeoutId = null;
	
	/**
	 * Calls each subscriber, debounced to the
	 */
	function debounceEmitResize() {
	  _window2.default.clearTimeout(timeoutId);
	  timeoutId = _window2.default.setTimeout(emitResize, DEBOUNCE_DURATION);
	}
	
	/**
	 * Calls each subscriber once syncronously.
	 */
	function emitResize() {
	  resizeSubscribers.forEach(function (cb) {
	    return cb();
	  });
	}
	
	/**
	 * Add the given callback to the list of subscribers to be caled when the
	 * window resizes. Returns a function that, when called, removes the given
	 * callback from the list of subscribers. This function is also resposible for
	 * adding and removing the resize listener on `window`.
	 *
	 * @param {Function} cb - Subscriber callback function
	 * @returns {Function} Unsubscribe function
	 */
	function subscribeToDebouncedResize(cb) {
	  resizeSubscribers.push(cb);
	
	  // if we go from zero to one Flexible components instances, add the listener
	  if (resizeSubscribers.length === 1) {
	    _window2.default.addEventListener('resize', debounceEmitResize);
	  }
	  return function unsubscribe() {
	    removeSubscriber(cb);
	
	    // if we have no Flexible components, remove the listener
	    if (resizeSubscribers.length === 0) {
	      _window2.default.clearTimeout(timeoutId);
	      _window2.default.removeEventListener('resize', debounceEmitResize);
	    }
	  };
	}
	
	/**
	 * Helper for removing the given callback from the list of subscribers.
	 *
	 * @param {Function} cb - Subscriber callback function
	 */
	function removeSubscriber(cb) {
	  var index = resizeSubscribers.indexOf(cb);
	  if (index > -1) {
	    resizeSubscribers.splice(index, 1);
	  }
	}
	
	/**
	 * Add the ability to stretch the visualization on window resize.
	 * @param {*} Component React class for the child component.
	 * @returns {*} Flexible component.
	 */
	function makeVisFlexible(Component) {
	
	  var ResultClass = function (_React$Component) {
	    _inherits(ResultClass, _React$Component);
	
	    _createClass(ResultClass, null, [{
	      key: 'propTypes',
	      get: function get() {
	        var _Component$propTypes = Component.propTypes,
	            width = _Component$propTypes.width,
	            otherPropTypes = _objectWithoutProperties(_Component$propTypes, ['width']); // eslint-disable-line no-unused-vars
	
	
	        return otherPropTypes;
	      }
	    }]);
	
	    function ResultClass(props) {
	      _classCallCheck(this, ResultClass);
	
	      var _this = _possibleConstructorReturn(this, (ResultClass.__proto__ || Object.getPrototypeOf(ResultClass)).call(this, props));
	
	      _this.state = {
	        width: 0
	      };
	      _this._onResize = _this._onResize.bind(_this);
	      return _this;
	    }
	
	    /**
	     * Get the width of the container and assign the width.
	     * @private
	     */
	
	
	    _createClass(ResultClass, [{
	      key: '_onResize',
	      value: function _onResize() {
	        var containerElement = (0, _reactUtils.getDOMNode)(this.refs[CONTAINER_REF]);
	        var offsetWidth = containerElement.offsetWidth;
	        if (this.state.width !== offsetWidth) {
	          this.setState({
	            width: offsetWidth
	          });
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._onResize();
	        this.cancelSubscription = subscribeToDebouncedResize(this._onResize);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps() {
	        this._onResize();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.cancelSubscription();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var width = this.state.width;
	
	        var props = _extends({}, this.props, { animation: width === 0 ? null : this.props.animation });
	
	        return _react2.default.createElement(
	          'div',
	          {
	            ref: CONTAINER_REF },
	          _react2.default.createElement(Component, _extends({
	            width: width
	          }, props))
	        );
	      }
	    }]);
	
	    return ResultClass;
	  }(_react2.default.Component);
	
	  ResultClass.displayName = 'Flexible' + Component.displayName;
	
	  return ResultClass;
	}

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = {
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired
	};
	
	function AxisLine(_ref) {
	  var orientation = _ref.orientation,
	      width = _ref.width,
	      height = _ref.height;
	
	  var lineProps = void 0;
	  if (orientation === LEFT) {
	    lineProps = {
	      x1: width,
	      x2: width,
	      y1: 0,
	      y2: height
	    };
	  } else if (orientation === RIGHT) {
	    lineProps = {
	      x1: 0,
	      x2: 0,
	      y1: 0,
	      y2: height
	    };
	  } else if (orientation === TOP) {
	    lineProps = {
	      x1: 0,
	      x2: width,
	      y1: height,
	      y2: height
	    };
	  } else {
	    lineProps = {
	      x1: 0,
	      x2: width,
	      y1: 0,
	      y2: 0
	    };
	  }
	  return _react2.default.createElement('line', _extends({}, lineProps, { className: 'rv-xy-plot__axis__line' }));
	}
	
	AxisLine.displayName = 'AxisLine';
	AxisLine.propTypes = propTypes;
	
	exports.default = AxisLine;

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(73);
	
	var _scalesUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = {
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired
	};
	
	function _getTickFormatFn(scale, tickTotal, tickFormat) {
	  return !tickFormat ? scale.tickFormat ? scale.tickFormat(tickTotal) : function (v) {
	    return v;
	  } : tickFormat;
	}
	
	var AxisTicks = function (_React$Component) {
	  _inherits(AxisTicks, _React$Component);
	
	  function AxisTicks() {
	    _classCallCheck(this, AxisTicks);
	
	    return _possibleConstructorReturn(this, (AxisTicks.__proto__ || Object.getPrototypeOf(AxisTicks)).apply(this, arguments));
	  }
	
	  _createClass(AxisTicks, [{
	    key: '_isAxisVertical',
	
	
	    /**
	     * Gets if the axis is vertical.
	     * @returns {boolean} True if vertical.
	     * @private
	     */
	    value: function _isAxisVertical() {
	      var orientation = this.props.orientation;
	
	      return orientation === LEFT || orientation === RIGHT;
	    }
	
	    /**
	     * Check if axis ticks should be mirrored (for the right and top positions.
	     * @returns {boolean} True if mirrored.
	     * @private
	     */
	
	  }, {
	    key: '_areTicksWrapped',
	    value: function _areTicksWrapped() {
	      var orientation = this.props.orientation;
	
	      return orientation === LEFT || orientation === TOP;
	    }
	  }, {
	    key: '_getTickContainerPropsGetterFn',
	    value: function _getTickContainerPropsGetterFn() {
	      if (this._isAxisVertical()) {
	        return function (pos) {
	          return { transform: 'translate(0, ' + pos + ')' };
	        };
	      }
	      return function (pos) {
	        return { transform: 'translate(' + pos + ', 0)' };
	      };
	    }
	
	    /**
	     * Get the props of the tick line.
	     * @returns {Object} Props.
	     * @private
	     */
	
	  }, {
	    key: '_getTickLineProps',
	    value: function _getTickLineProps() {
	      var _ref;
	
	      var _props = this.props,
	          tickSize = _props.tickSize,
	          _props$tickSizeOuter = _props.tickSizeOuter,
	          tickSizeOuter = _props$tickSizeOuter === undefined ? tickSize : _props$tickSizeOuter,
	          _props$tickSizeInner = _props.tickSizeInner,
	          tickSizeInner = _props$tickSizeInner === undefined ? tickSize : _props$tickSizeInner;
	
	      var isVertical = this._isAxisVertical();
	      var tickXAttr = isVertical ? 'y' : 'x';
	      var tickYAttr = isVertical ? 'x' : 'y';
	      var wrap = this._areTicksWrapped() ? -1 : 1;
	      return _ref = {}, _defineProperty(_ref, tickXAttr + '1', 0), _defineProperty(_ref, tickXAttr + '2', 0), _defineProperty(_ref, tickYAttr + '1', -wrap * tickSizeInner), _defineProperty(_ref, tickYAttr + '2', wrap * tickSizeOuter), _ref;
	    }
	
	    /**
	     * Get attributes for the label of the tick.
	     * @returns {Object} Object with properties.
	     * @private
	     */
	
	  }, {
	    key: '_getTickLabelProps',
	    value: function _getTickLabelProps() {
	      var _props2 = this.props,
	          orientation = _props2.orientation,
	          tickLabelAngle = _props2.tickLabelAngle,
	          tickSize = _props2.tickSize,
	          _props2$tickSizeOuter = _props2.tickSizeOuter,
	          tickSizeOuter = _props2$tickSizeOuter === undefined ? tickSize : _props2$tickSizeOuter,
	          _props2$tickPadding = _props2.tickPadding,
	          tickPadding = _props2$tickPadding === undefined ? tickSize : _props2$tickPadding;
	
	      // Assign the text orientation inside the label of the tick mark.
	
	      var textAnchor = void 0;
	      if (orientation === LEFT || orientation === BOTTOM && tickLabelAngle) {
	        textAnchor = 'end';
	      } else if (orientation === RIGHT || orientation === TOP && tickLabelAngle) {
	        textAnchor = 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      // The label's position is translated to the given padding and then the
	      // label is rotated to the given angle.
	      var isVertical = this._isAxisVertical();
	      var wrap = this._areTicksWrapped() ? -1 : 1;
	
	      var labelOffset = wrap * (tickSizeOuter + tickPadding);
	      var transform = (isVertical ? 'translate(' + labelOffset + ', 0)' : 'translate(0, ' + labelOffset + ')') + (tickLabelAngle ? ' rotate(' + tickLabelAngle + ')' : '');
	
	      // Set the vertical offset of the label according to the position of
	      // the axis.
	      var dy = orientation === TOP || tickLabelAngle ? '0' : orientation === BOTTOM ? '0.72em' : '0.32em';
	
	      return {
	        textAnchor: textAnchor,
	        dy: dy,
	        transform: transform
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          attr = _props3.attr,
	          orientation = _props3.orientation,
	          width = _props3.width,
	          height = _props3.height,
	          tickFormat = _props3.tickFormat,
	          tickTotal = _props3.tickTotal,
	          tickValues = _props3.tickValues;
	
	
	      var x = orientation === LEFT ? width : 0;
	      var y = orientation === TOP ? height : 0;
	
	      var scale = (0, _scalesUtils.getAttributeScale)(this.props, attr);
	
	      var values = (0, _axisUtils.getTickValues)(scale, tickTotal, tickValues);
	      var tickFormatFn = _getTickFormatFn(scale, tickTotal, tickFormat);
	
	      var translateFn = this._getTickContainerPropsGetterFn();
	      var pathProps = this._getTickLineProps();
	      var textProps = this._getTickLabelProps();
	
	      var ticks = values.map(function (v, i) {
	        var pos = scale(v);
	        var text = tickFormatFn(v);
	
	        return _react2.default.createElement(
	          'g',
	          _extends({ key: i }, translateFn(pos, 0), { className: 'rv-xy-plot__axis__tick' }),
	          _react2.default.createElement('line', _extends({}, pathProps, { className: 'rv-xy-plot__axis__tick__line' })),
	          _react2.default.createElement(
	            'text',
	            _extends({}, textProps, { className: 'rv-xy-plot__axis__tick__text' }),
	            text
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + x + ', ' + y + ')',
	          className: 'rv-xy-plot__axis__ticks' },
	        ticks
	      );
	    }
	  }]);
	
	  return AxisTicks;
	}(_react2.default.Component);
	
	AxisTicks.displayName = 'AxisTicks';
	AxisTicks.propTypes = propTypes;
	AxisTicks.requiresSVG = true;
	
	exports.default = AxisTicks;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Assuming that 16px = 1em
	var ADJUSTMENT_FOR_TEXT_SIZE = 16;
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	/**
	 * Compute transformations, keyed by orientation
	 * @param {number} width - width of axis
	 * @param {number} height - height of axis
	 * @returns {Object} Object of transformations, keyed by orientation
	 */
	
	var transformation = function transformation(width, height) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, LEFT, {
	    x: ADJUSTMENT_FOR_TEXT_SIZE,
	    y: 0,
	    rotation: -90,
	    textAnchor: 'end'
	  }), _defineProperty(_ref, RIGHT, {
	    x: ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
	    y: height,
	    rotation: -90,
	    textAnchor: 'start'
	  }), _defineProperty(_ref, TOP, {
	    x: 0,
	    y: ADJUSTMENT_FOR_TEXT_SIZE,
	    rotation: 0,
	    textAnchor: 'start'
	  }), _defineProperty(_ref, BOTTOM, {
	    x: width,
	    y: -6,
	    rotation: 0,
	    textAnchor: 'end'
	  }), _ref;
	};
	
	var propTypes = {
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
	  title: _propTypes2.default.string.isRequired
	};
	
	function AxisTitle(_ref2) {
	  var orientation = _ref2.orientation,
	      width = _ref2.width,
	      height = _ref2.height,
	      title = _ref2.title;
	
	  var outerGroupTranslateX = orientation === LEFT ? width : 0;
	  var outerGroupTranslateY = orientation === TOP ? height : 0;
	  var outerGroupTransform = 'translate(' + outerGroupTranslateX + ', ' + outerGroupTranslateY + ')';
	  var _transformation$orien = transformation(width, height)[orientation],
	      x = _transformation$orien.x,
	      y = _transformation$orien.y,
	      rotation = _transformation$orien.rotation,
	      textAnchor = _transformation$orien.textAnchor;
	
	  var innerGroupTransform = 'translate(' + x + ', ' + y + ') rotate(' + rotation + ')';
	
	  return _react2.default.createElement(
	    'g',
	    { transform: outerGroupTransform, className: 'rv-xy-plot__axis__title' },
	    _react2.default.createElement(
	      'g',
	      { style: { textAnchor: textAnchor }, transform: innerGroupTransform },
	      _react2.default.createElement(
	        'text',
	        null,
	        title
	      )
	    )
	  );
	}
	
	AxisTitle.displayName = 'AxisTitle';
	AxisTitle.propTypes = propTypes;
	
	exports.default = AxisTitle;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(73);
	
	var _axis = __webpack_require__(589);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = _extends({}, _axis2.default.propTypes, {
	  orientation: _propTypes2.default.oneOf([TOP, BOTTOM])
	});
	
	var defaultProps = {
	  orientation: BOTTOM,
	  attr: 'x'
	};
	
	function XAxis(props) {
	  return _react2.default.createElement(_axis2.default, props);
	}
	
	XAxis.displayName = 'XAxis';
	XAxis.propTypes = propTypes;
	XAxis.defaultProps = defaultProps;
	XAxis.requiresSVG = true;
	
	exports.default = XAxis;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(73);
	
	var _axis = __webpack_require__(589);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT;
	
	
	var propTypes = _extends({}, _axis2.default.propTypes, {
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT])
	});
	
	var defaultProps = {
	  orientation: LEFT,
	  attr: 'y'
	};
	
	function YAxis(props) {
	  return _react2.default.createElement(_axis2.default, props);
	}
	
	YAxis.displayName = 'YAxis';
	YAxis.propTypes = propTypes;
	YAxis.defaultProps = defaultProps;
	YAxis.requiresSVG = true;
	
	exports.default = YAxis;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pureRenderComponent = __webpack_require__(114);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _axisUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];
	
	var CircularGridLines = function (_PureRenderComponent) {
	  _inherits(CircularGridLines, _PureRenderComponent);
	
	  function CircularGridLines() {
	    _classCallCheck(this, CircularGridLines);
	
	    return _possibleConstructorReturn(this, (CircularGridLines.__proto__ || Object.getPrototypeOf(CircularGridLines)).apply(this, arguments));
	  }
	
	  _createClass(CircularGridLines, [{
	    key: '_getDefaultProps',
	    value: function _getDefaultProps() {
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          marginTop = _props.marginTop,
	          marginLeft = _props.marginLeft;
	
	      return {
	        left: marginLeft,
	        top: marginTop,
	        width: innerWidth,
	        height: innerHeight,
	        tickTotal: (0, _axisUtils.getTicksTotalFromSize)(Math.min(innerWidth, innerHeight))
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          animation = _props2.animation,
	          centerX = _props2.centerX,
	          centerY = _props2.centerY;
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(CircularGridLines, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var props = _extends({}, this._getDefaultProps(), this.props);
	
	      var tickTotal = props.tickTotal,
	          tickValues = props.tickValues,
	          marginLeft = props.marginLeft,
	          marginTop = props.marginTop,
	          rRange = props.rRange;
	
	
	      var xScale = (0, _scalesUtils.getAttributeScale)(props, 'x');
	      var yScale = (0, _scalesUtils.getAttributeScale)(props, 'y');
	      var values = (0, _axisUtils.getTickValues)(xScale, tickTotal, tickValues);
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + (xScale(centerX) + marginLeft) + ',' + (yScale(centerY) + marginTop) + ')',
	          className: 'rv-xy-plot__circular-grid-lines' },
	        values.reduce(function (res, value, index) {
	          var radius = xScale(value);
	          if (rRange && (radius < rRange[0] || radius > rRange[1])) {
	            return res;
	          }
	          return res.concat([_react2.default.createElement('circle', _extends({ cx: 0, cy: 0, r: radius }, {
	            key: index,
	            className: 'rv-xy-plot__circular-grid-lines__line' }))]);
	        }, [])
	      );
	    }
	  }]);
	
	  return CircularGridLines;
	}(_pureRenderComponent2.default);
	
	CircularGridLines.displayName = 'CircularGridLines';
	CircularGridLines.propTypes = {
	  centerX: _propTypes2.default.number,
	  centerY: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  rRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	
	  tickValues: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  tickTotal: _propTypes2.default.number,
	
	  animation: _animation.AnimationPropType,
	  // generally supplied by xyplot
	  marginTop: _propTypes2.default.number,
	  marginBottom: _propTypes2.default.number,
	  marginLeft: _propTypes2.default.number,
	  marginRight: _propTypes2.default.number,
	  innerWidth: _propTypes2.default.number,
	  innerHeight: _propTypes2.default.number
	};
	CircularGridLines.defaultProps = {
	  centerX: 0,
	  centerY: 0
	};
	CircularGridLines.requiresSVG = true;
	
	exports.default = CircularGridLines;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pureRenderComponent = __webpack_require__(114);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _scalesUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Format title by detault.
	 * @param {Array} values List of values.
	 * @returns {*} Formatted value or undefined.
	 */
	function defaultTitleFormat(values) {
	  var value = getFirstNonEmptyValue(values);
	  if (value) {
	    return {
	      title: 'x',
	      value: value.x
	    };
	  }
	}
	
	/**
	 * Format items by default.
	 * @param {Array} values Array of values.
	 * @returns {*} Formatted list of items.
	 */
	function defaultItemsFormat(values) {
	  return values.map(function (v, i) {
	    if (v) {
	      return { value: v.y, title: i };
	    }
	  });
	}
	
	/**
	 * Get the first non-empty item from an array.
	 * @param {Array} values Array of values.
	 * @returns {*} First non-empty value or undefined.
	 */
	function getFirstNonEmptyValue(values) {
	  return (values || []).find(function (v) {
	    return Boolean(v);
	  });
	}
	
	var Crosshair = function (_PureRenderComponent) {
	  _inherits(Crosshair, _PureRenderComponent);
	
	  function Crosshair() {
	    _classCallCheck(this, Crosshair);
	
	    return _possibleConstructorReturn(this, (Crosshair.__proto__ || Object.getPrototypeOf(Crosshair)).apply(this, arguments));
	  }
	
	  _createClass(Crosshair, [{
	    key: '_renderCrosshairTitle',
	
	
	    /**
	     * Render crosshair title.
	     * @returns {*} Container with the crosshair title.
	     * @private
	     */
	    value: function _renderCrosshairTitle() {
	      var _props = this.props,
	          values = _props.values,
	          titleFormat = _props.titleFormat;
	
	      var titleItem = titleFormat(values);
	      if (!titleItem) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'rv-crosshair__title', key: 'title' },
	        _react2.default.createElement(
	          'span',
	          { className: 'rv-crosshair__title__title' },
	          titleItem.title
	        ),
	        ': ',
	        _react2.default.createElement(
	          'span',
	          { className: 'rv-crosshair__title__value' },
	          titleItem.value
	        )
	      );
	    }
	
	    /**
	     * Render crosshair items (title + value for each series).
	     * @returns {*} Array of React classes with the crosshair values.
	     * @private
	     */
	
	  }, {
	    key: '_renderCrosshairItems',
	    value: function _renderCrosshairItems() {
	      var _props2 = this.props,
	          values = _props2.values,
	          itemsFormat = _props2.itemsFormat;
	
	      var items = itemsFormat(values);
	      if (!items) {
	        return null;
	      }
	      return items.filter(function (i) {
	        return i;
	      }).map(function renderValue(item, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'rv-crosshair__item', key: 'item' + i },
	          _react2.default.createElement(
	            'span',
	            { className: 'rv-crosshair__item__title' },
	            item.title
	          ),
	          ': ',
	          _react2.default.createElement(
	            'span',
	            { className: 'rv-crosshair__item__value' },
	            item.value
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          values = _props3.values,
	          marginTop = _props3.marginTop,
	          marginLeft = _props3.marginLeft,
	          innerWidth = _props3.innerWidth,
	          innerHeight = _props3.innerHeight;
	
	      var value = getFirstNonEmptyValue(values);
	      if (!value) {
	        return null;
	      }
	      var x = (0, _scalesUtils.getAttributeFunctor)(this.props, 'x');
	      var innerLeft = x(value);
	
	      var _props$orientation = this.props.orientation,
	          orientation = _props$orientation === undefined ? innerLeft > innerWidth / 2 ? 'left' : 'right' : _props$orientation;
	
	      var left = marginLeft + innerLeft;
	      var top = marginTop;
	      var innerClassName = 'rv-crosshair__inner rv-crosshair__inner--' + orientation;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-crosshair',
	          style: { left: left + 'px', top: top + 'px' } },
	        _react2.default.createElement('div', {
	          className: 'rv-crosshair__line',
	          style: { height: innerHeight + 'px' } }),
	        _react2.default.createElement(
	          'div',
	          { className: innerClassName },
	          children ? children : _react2.default.createElement(
	            'div',
	            { className: 'rv-crosshair__inner__content' },
	            _react2.default.createElement(
	              'div',
	              null,
	              this._renderCrosshairTitle(),
	              this._renderCrosshairItems()
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        values: _propTypes2.default.array,
	        series: _propTypes2.default.object,
	        innerWidth: _propTypes2.default.number,
	        innerHeight: _propTypes2.default.number,
	        marginLeft: _propTypes2.default.number,
	        marginTop: _propTypes2.default.number,
	        orientation: _propTypes2.default.oneOf(['left', 'right']),
	        itemsFormat: _propTypes2.default.func,
	        titleFormat: _propTypes2.default.func
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        titleFormat: defaultTitleFormat,
	        itemsFormat: defaultItemsFormat
	      };
	    }
	  }]);
	
	  return Crosshair;
	}(_pureRenderComponent2.default);
	
	Crosshair.displayName = 'Crosshair';
	
	exports.default = Crosshair;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pureRenderComponent = __webpack_require__(114);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _scalesUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/*
	 * Hint provides two options for placement of hint:
	 * a) around a data point in one of four quadrants (imagine the point bisected
	 *    by two axes -vertical, horizontal- creating 4 quadrants around a data
	 *    point).
	 * b) **New** pin to an edge of chart/plot area and position along that edge
	 *    using data point's other dimension value.
	 *
	 * To support these two options, deprecate one Hint props (orientation) with two
	 * new Hint align prop object (horizontal, vertical) with following values:
	 *
	 *   horizontal: auto, left, right, leftEdge, rightEdge
	 *   vertical: auto, bottom, top, bottomEdge, topEdge
	 *
	 * Thus, the following ALIGN constants are the values for horizontal
	 * and vertical
	 */
	var ALIGN = {
	  AUTO: 'auto',
	  LEFT: 'left',
	  RIGHT: 'right',
	  LEFT_EDGE: 'leftEdge',
	  RIGHT_EDGE: 'rightEdge',
	  BOTTOM: 'bottom',
	  TOP: 'top',
	  BOTTOM_EDGE: 'bottomEdge',
	  TOP_EDGE: 'topEdge'
	};
	
	/**
	 * For backwards support, retain the ORIENTATION prop constants
	 */
	var ORIENTATION = {
	  BOTTOM_LEFT: 'bottomleft',
	  BOTTOM_RIGHT: 'bottomright',
	  TOP_LEFT: 'topleft',
	  TOP_RIGHT: 'topright'
	};
	
	/**
	 * Default format function for the value.
	 * @param {Object} value Value.
	 * @returns {Array} title-value pairs.
	 */
	function defaultFormat(value) {
	  return Object.keys(value).map(function getProp(key) {
	    return { title: key, value: value[key] };
	  });
	}
	
	var Hint = function (_PureRenderComponent) {
	  _inherits(Hint, _PureRenderComponent);
	
	  function Hint() {
	    _classCallCheck(this, Hint);
	
	    return _possibleConstructorReturn(this, (Hint.__proto__ || Object.getPrototypeOf(Hint)).apply(this, arguments));
	  }
	
	  _createClass(Hint, [{
	    key: '_getCSSRight',
	
	
	    /**
	     * Get the right coordinate of the hint.
	     * When x undefined or null, edge case, pin right.
	     * @param {number} x X.
	     * @returns {{right: *}} Mixin.
	     * @private
	     */
	    value: function _getCSSRight(x) {
	      if (x === undefined || x === null) {
	        return {
	          right: 0
	        };
	      }
	
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          marginRight = _props.marginRight;
	
	      return {
	        right: marginRight + innerWidth - x
	      };
	    }
	
	    /**
	     * Get the left coordinate of the hint.
	     * When x undefined or null, edge case, pin left.
	     * @param {number} x X.
	     * @returns {{left: *}} Mixin.
	     * @private
	     */
	
	  }, {
	    key: '_getCSSLeft',
	    value: function _getCSSLeft(x) {
	      if (x === undefined || x === null) {
	        return {
	          left: 0
	        };
	      }
	
	      var marginLeft = this.props.marginLeft;
	
	      return {
	        left: marginLeft + x
	      };
	    }
	
	    /**
	     * Get the bottom coordinate of the hint.
	     * When y undefined or null, edge case, pin bottom.
	     * @param {number} y Y.
	     * @returns {{bottom: *}} Mixin.
	     * @private
	     */
	
	  }, {
	    key: '_getCSSBottom',
	    value: function _getCSSBottom(y) {
	      if (y === undefined || y === null) {
	        return {
	          bottom: 0
	        };
	      }
	
	      var _props2 = this.props,
	          innerHeight = _props2.innerHeight,
	          marginBottom = _props2.marginBottom;
	
	      return {
	        bottom: marginBottom + innerHeight - y
	      };
	    }
	
	    /**
	     * Get the top coordinate of the hint.
	     * When y undefined or null, edge case, pin top.
	     * @param {number} y Y.
	     * @returns {{top: *}} Mixin.
	     * @private
	     */
	
	  }, {
	    key: '_getCSSTop',
	    value: function _getCSSTop(y) {
	      if (y === undefined || y === null) {
	        return {
	          top: 0
	        };
	      }
	
	      var marginTop = this.props.marginTop;
	
	      return {
	        top: marginTop + y
	      };
	    }
	  }, {
	    key: '_mapOrientationToAlign',
	    value: function _mapOrientationToAlign(orientation) {
	      // TODO: print warning that this feature is deprecated and support will be
	      // removed in next major release.
	      switch (orientation) {
	        case ORIENTATION.BOTTOM_LEFT:
	          return {
	            horizontal: ALIGN.LEFT,
	            vertical: ALIGN.BOTTOM
	          };
	        case ORIENTATION.BOTTOM_RIGHT:
	          return {
	            horizontal: ALIGN.RIGHT,
	            vertical: ALIGN.BOTTOM
	          };
	        case ORIENTATION.TOP_LEFT:
	          return {
	            horizontal: ALIGN.LEFT,
	            vertical: ALIGN.TOP
	          };
	        case ORIENTATION.TOP_RIGHT:
	          return {
	            horizontal: ALIGN.RIGHT,
	            vertical: ALIGN.TOP
	          };
	        default:
	          // fall back to horizontalAlign, verticalAlign that are either
	          // provided or defaulted to AUTO.  So, don't change things
	          break;
	      }
	    }
	
	    /**
	     * Obtain align object with horizontal and vertical settings
	     * but convert any AUTO values to the non-auto ALIGN depending on the
	     * values of x and y.
	     * @param {number} x X value.
	     * @param {number} y Y value.
	     * @returns {Object} Align object w/ horizontal, vertical prop strings.
	     * @private
	     */
	
	  }, {
	    key: '_getAlign',
	    value: function _getAlign(x, y) {
	      var _props3 = this.props,
	          innerWidth = _props3.innerWidth,
	          innerHeight = _props3.innerHeight,
	          orientation = _props3.orientation,
	          _props3$align = _props3.align,
	          horizontal = _props3$align.horizontal,
	          vertical = _props3$align.vertical;
	
	      var align = orientation ? this._mapOrientationToAlign(orientation) : { horizontal: horizontal, vertical: vertical };
	      if (horizontal === ALIGN.AUTO) {
	        align.horizontal = x > innerWidth / 2 ? ALIGN.LEFT : ALIGN.RIGHT;
	      }
	      if (vertical === ALIGN.AUTO) {
	        align.vertical = y > innerHeight / 2 ? ALIGN.TOP : ALIGN.BOTTOM;
	      }
	      return align;
	    }
	
	    /**
	     * Get a CSS mixin for a proper positioning of the element.
	     * @param {Object} align object with horizontal and vertical prop strings.
	     * @param {number} x X position.
	     * @param {number} y Y position.
	     * @returns {Object} Object, that may contain `left` or `right, `top` or
	     * `bottom` properties.
	     * @private
	     */
	
	  }, {
	    key: '_getAlignStyle',
	    value: function _getAlignStyle(align, x, y) {
	      return _extends({}, this._getXCSS(align.horizontal, x), this._getYCSS(align.vertical, y));
	    }
	  }, {
	    key: '_getYCSS',
	    value: function _getYCSS(verticalAlign, y) {
	      // obtain yCSS
	      switch (verticalAlign) {
	        case ALIGN.TOP_EDGE:
	          // this pins x to top edge
	          return this._getCSSTop(null);
	        case ALIGN.BOTTOM_EDGE:
	          // this pins x to bottom edge
	          return this._getCSSBottom(null);
	        case ALIGN.BOTTOM:
	          // this places hint text to the bottom of center, so set its top edge
	          return this._getCSSTop(y);
	        case ALIGN.TOP:
	        default:
	          // this places hint text to the top of center, so set its bottom edge
	          // default case should not be possible but if it happens set to BOTTOM
	          return this._getCSSBottom(y);
	      }
	    }
	  }, {
	    key: '_getXCSS',
	    value: function _getXCSS(horizontal, x) {
	      // obtain xCSS
	      switch (horizontal) {
	        case ALIGN.LEFT_EDGE:
	          // this pins x to left edge
	          return this._getCSSLeft(null);
	        case ALIGN.RIGHT_EDGE:
	          // this pins x to left edge
	          return this._getCSSRight(null);
	        case ALIGN.LEFT:
	          // this places hint text to the left of center, so set its right edge
	          return this._getCSSRight(x);
	        case ALIGN.RIGHT:
	        default:
	          // this places hint text to the right of center, so set its left edge
	          // default case should not be possible but if it happens set to RIGHT
	          return this._getCSSLeft(x);
	      }
	    }
	
	    /**
	     * Get the class names from align values.
	     * @param {Object} align object with horizontal and vertical prop strings.
	     * @returns {string} Class names.
	     * @private
	     */
	
	  }, {
	    key: '_getAlignClassNames',
	    value: function _getAlignClassNames(align) {
	      var orientation = this.props.orientation;
	
	      var orientationClass = orientation ? 'rv-hint--orientation-' + orientation : '';
	      return orientationClass + ' rv-hint--horizontalAlign-' + align.horizontal + '\n     rv-hint--verticalAlign-' + align.vertical;
	    }
	
	    /**
	     * Get the position for the hint and the appropriate class name.
	     * @returns {{style: Object, className: string}} Style and className for the
	     * hint.
	     * @private
	     */
	
	  }, {
	    key: '_getPositionInfo',
	    value: function _getPositionInfo() {
	      var _props4 = this.props,
	          value = _props4.value,
	          getAlignStyle = _props4.getAlignStyle;
	
	
	      var x = (0, _scalesUtils.getAttributeFunctor)(this.props, 'x')(value);
	      var y = (0, _scalesUtils.getAttributeFunctor)(this.props, 'y')(value);
	
	      var align = this._getAlign(x, y);
	
	      return {
	        style: getAlignStyle ? getAlignStyle(align, x, y) : this._getAlignStyle(align, x, y),
	        className: this._getAlignClassNames(align)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          value = _props5.value,
	          format = _props5.format,
	          children = _props5.children;
	
	      var _getPositionInfo2 = this._getPositionInfo(),
	          style = _getPositionInfo2.style,
	          className = _getPositionInfo2.className;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-hint ' + className,
	          style: _extends({}, style, {
	            position: 'absolute'
	          }) },
	        children ? children : _react2.default.createElement(
	          'div',
	          { className: 'rv-hint__content' },
	          format(value).map(function (formattedProp, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: 'rv-hint' + i },
	              _react2.default.createElement(
	                'span',
	                { className: 'rv-hint__title' },
	                formattedProp.title
	              ),
	              ': ',
	              _react2.default.createElement(
	                'span',
	                { className: 'rv-hint__value' },
	                formattedProp.value
	              )
	            );
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        marginTop: _propTypes2.default.number,
	        marginLeft: _propTypes2.default.number,
	        innerWidth: _propTypes2.default.number,
	        innerHeight: _propTypes2.default.number,
	        scales: _propTypes2.default.object,
	        value: _propTypes2.default.object,
	        format: _propTypes2.default.func,
	        align: _propTypes2.default.shape({
	          horizontal: _propTypes2.default.oneOf([ALIGN.AUTO, ALIGN.LEFT, ALIGN.RIGHT, ALIGN.LEFT_EDGE, ALIGN.RIGHT_EDGE]),
	          vertical: _propTypes2.default.oneOf([ALIGN.AUTO, ALIGN.BOTTOM, ALIGN.TOP, ALIGN.BOTTOM_EDGE, ALIGN.TOP_EDGE])
	        }),
	        getAlignStyle: _propTypes2.default.func,
	        orientation: _propTypes2.default.oneOf([ORIENTATION.BOTTOM_LEFT, ORIENTATION.BOTTOM_RIGHT, ORIENTATION.TOP_LEFT, ORIENTATION.TOP_RIGHT])
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        format: defaultFormat,
	        align: {
	          horizontal: ALIGN.AUTO,
	          vertical: ALIGN.AUTO
	        }
	      };
	    }
	  }]);
	
	  return Hint;
	}(_pureRenderComponent2.default);
	
	Hint.displayName = 'Hint';
	Hint.ORIENTATION = ORIENTATION;
	Hint.ALIGN = ALIGN;
	
	exports.default = Hint;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(73);
	
	var _gridLines = __webpack_require__(344);
	
	var _gridLines2 = _interopRequireDefault(_gridLines);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HORIZONTAL = _axisUtils.DIRECTION.HORIZONTAL;
	
	
	var propTypes = _extends({}, _gridLines2.default.propTypes, {
	  direction: _propTypes2.default.oneOf([HORIZONTAL])
	});
	
	var defaultProps = {
	  direction: HORIZONTAL,
	  attr: 'y'
	};
	
	function HorizontalGridLines(props) {
	  return _react2.default.createElement(_gridLines2.default, props);
	}
	
	HorizontalGridLines.displayName = 'HorizontalGridLines';
	HorizontalGridLines.propTypes = propTypes;
	HorizontalGridLines.defaultProps = defaultProps;
	HorizontalGridLines.requiresSVG = true;
	
	exports.default = HorizontalGridLines;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Shape = __webpack_require__(233);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _theme = __webpack_require__(45);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';
	
	var AreaSeries = function (_AbstractSeries) {
	  _inherits(AreaSeries, _AbstractSeries);
	
	  function AreaSeries() {
	    _classCallCheck(this, AreaSeries);
	
	    return _possibleConstructorReturn(this, (AreaSeries.__proto__ || Object.getPrototypeOf(AreaSeries)).apply(this, arguments));
	  }
	
	  _createClass(AreaSeries, [{
	    key: '_renderArea',
	    value: function _renderArea(data, x, y0, y, curve) {
	      var area = d3Shape.area();
	      if (curve !== null) {
	        if (typeof curve === 'string' && d3Shape[curve]) {
	          area = area.curve(d3Shape[curve]);
	        } else if (typeof curve === 'function') {
	          area = area.curve(curve);
	        }
	      }
	      area = area.x(x).y0(y0).y1(y);
	      return area(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          curve = _props.curve,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(AreaSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	      var y0 = this._getAttr0Functor('y');
	      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
	      var fill = this._getAttributeValue('fill') || this._getAttributeValue('color');
	      var newOpacity = this._getAttributeValue('opacity');
	      var opacity = Number.isFinite(newOpacity) ? newOpacity : _theme.DEFAULT_OPACITY;
	      var d = this._renderArea(data, x, y0, y, curve);
	      return _react2.default.createElement('path', {
	        d: d,
	        className: predefinedClassName + ' ' + className,
	        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
	        onMouseOver: this._seriesMouseOverHandler,
	        onMouseOut: this._seriesMouseOutHandler,
	        onClick: this._seriesClickHandler,
	        style: {
	          opacity: opacity,
	          stroke: stroke,
	          fill: fill
	        } });
	    }
	  }]);
	
	  return AreaSeries;
	}(_abstractSeries2.default);
	
	AreaSeries.displayName = 'AreaSeries';
	
	exports.default = AreaSeries;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var CanvasWrapper = function (_Component) {
	  _inherits(CanvasWrapper, _Component);
	
	  function CanvasWrapper() {
	    _classCallCheck(this, CanvasWrapper);
	
	    return _possibleConstructorReturn(this, (CanvasWrapper.__proto__ || Object.getPrototypeOf(CanvasWrapper)).apply(this, arguments));
	  }
	
	  _createClass(CanvasWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.drawChildren(this.props, this.refs.canvas.getContext('2d'));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      this.drawChildren(nextProps, this.refs.canvas.getContext('2d'));
	    }
	  }, {
	    key: 'drawChildren',
	    value: function drawChildren(props, ctx) {
	      var children = props.children,
	          innerHeight = props.innerHeight,
	          innerWidth = props.innerWidth;
	
	      if (!ctx) {
	        return;
	      }
	      ctx.clearRect(0, 0, innerWidth, innerHeight);
	      children.forEach(function (layer) {
	        return layer.type.renderLayer(layer.props, ctx);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          innerHeight = _props.innerHeight,
	          innerWidth = _props.innerWidth;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            left: marginLeft,
	            top: marginTop
	          },
	          className: 'rv-xy-canvas' },
	        _react2.default.createElement('canvas', {
	          className: 'rv-xy-canvas-element',
	          height: innerHeight,
	          width: innerWidth,
	          ref: 'canvas' })
	      );
	    }
	  }]);
	
	  return CanvasWrapper;
	}(_react.Component);
	
	CanvasWrapper.displayName = 'CanvasWrapper';
	CanvasWrapper.propTypes = {
	  marginLeft: _propTypes2.default.number.isRequired,
	  marginTop: _propTypes2.default.number.isRequired,
	  innerHeight: _propTypes2.default.number.isRequired,
	  innerWidth: _propTypes2.default.number.isRequired
	};
	
	exports.default = CanvasWrapper;

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deck = __webpack_require__(256);
	
	var _deck2 = _interopRequireDefault(_deck);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DeckGLWrapper = function (_Component) {
	  _inherits(DeckGLWrapper, _Component);
	
	  function DeckGLWrapper() {
	    _classCallCheck(this, DeckGLWrapper);
	
	    return _possibleConstructorReturn(this, (DeckGLWrapper.__proto__ || Object.getPrototypeOf(DeckGLWrapper)).apply(this, arguments));
	  }
	
	  _createClass(DeckGLWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          marginBottom = _props.marginBottom,
	          marginRight = _props.marginRight,
	          innerHeight = _props.innerHeight,
	          innerWidth = _props.innerWidth;
	
	
	      var width = innerWidth + marginLeft + marginRight;
	      var height = innerHeight + marginTop + marginBottom;
	
	      var glViewport = new _deck.OrthographicViewport({
	        width: width || 0,
	        height: height || 0,
	        left: -marginLeft,
	        top: -marginTop
	      });
	      if (!innerHeight || !innerWidth) {
	        return null;
	      }
	
	      var layers = children.reduce(function (res, layer) {
	        if (!layer.type.renderLayer) {
	          var trueLayer = layer.props.children;
	          return res.concat(trueLayer.type.renderLayer(trueLayer.props));
	        }
	
	        return res.concat(layer.type.renderLayer(layer.props));
	      }, []);
	      return _react2.default.createElement(_deck2.default, { width: width, height: height, viewport: glViewport,
	        style: { position: 'absolute', top: 0, left: 0 },
	        layers: layers });
	    }
	  }]);
	
	  return DeckGLWrapper;
	}(_react.Component);
	
	DeckGLWrapper.displayName = 'DeckGLWrapper';
	DeckGLWrapper.propTypes = {
	  marginLeft: _propTypes2.default.number.isRequired,
	  marginTop: _propTypes2.default.number.isRequired,
	  marginBottom: _propTypes2.default.number.isRequired,
	  marginRight: _propTypes2.default.number.isRequired,
	  innerHeight: _propTypes2.default.number.isRequired,
	  innerWidth: _propTypes2.default.number.isRequired
	};
	
	exports.default = DeckGLWrapper;

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--heatmap';
	
	var HeatmapSeries = function (_AbstractSeries) {
	  _inherits(HeatmapSeries, _AbstractSeries);
	
	  function HeatmapSeries() {
	    _classCallCheck(this, HeatmapSeries);
	
	    return _possibleConstructorReturn(this, (HeatmapSeries.__proto__ || Object.getPrototypeOf(HeatmapSeries)).apply(this, arguments));
	  }
	
	  _createClass(HeatmapSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(HeatmapSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var xDistance = this._getScaleDistance('x');
	      var yDistance = this._getScaleDistance('y');
	      return _react2.default.createElement(
	        'g',
	        {
	          className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var attrs = {
	            style: {
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d),
	              opacity: opacityFunctor && opacityFunctor(d)
	            },
	            x: xFunctor(d) - xDistance / 2,
	            y: yFunctor(d) - yDistance / 2,
	            width: xDistance,
	            height: yDistance,
	            key: i,
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(d, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(d, e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(d, e);
	            }
	          };
	          return _react2.default.createElement('rect', attrs);
	        })
	      );
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x' || attr === 'y';
	      return { isDomainAdjustmentNeeded: isDomainAdjustmentNeeded };
	    }
	  }]);
	
	  return HeatmapSeries;
	}(_abstractSeries2.default);
	
	HeatmapSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	HeatmapSeries.displayName = 'HeatmapSeries';
	
	exports.default = HeatmapSeries;

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeriesCanvas = __webpack_require__(590);
	
	var _barSeriesCanvas2 = _interopRequireDefault(_barSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalBarSeriesCanvas = function (_AbstractSeries) {
	  _inherits(HorizontalBarSeriesCanvas, _AbstractSeries);
	
	  function HorizontalBarSeriesCanvas() {
	    _classCallCheck(this, HorizontalBarSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (HorizontalBarSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalBarSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalBarSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'y';
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _barSeriesCanvas2.default.renderLayer(_extends({}, props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }), ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return HorizontalBarSeriesCanvas;
	}(_abstractSeries2.default);
	
	HorizontalBarSeriesCanvas.displayName = 'HorizontalBarSeriesCanvas';
	HorizontalBarSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = HorizontalBarSeriesCanvas;

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeries = __webpack_require__(591);
	
	var _barSeries2 = _interopRequireDefault(_barSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalBarSeries = function (_AbstractSeries) {
	  _inherits(HorizontalBarSeries, _AbstractSeries);
	
	  function HorizontalBarSeries() {
	    _classCallCheck(this, HorizontalBarSeries);
	
	    return _possibleConstructorReturn(this, (HorizontalBarSeries.__proto__ || Object.getPrototypeOf(HorizontalBarSeries)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalBarSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_barSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'y';
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return HorizontalBarSeries;
	}(_abstractSeries2.default);
	
	HorizontalBarSeries.displayName = 'HorizontalBarSeries';
	
	exports.default = HorizontalBarSeries;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeriesCanvas = __webpack_require__(346);
	
	var _rectSeriesCanvas2 = _interopRequireDefault(_rectSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalRectSeriesCanvas = function (_AbstractSeries) {
	  _inherits(HorizontalRectSeriesCanvas, _AbstractSeries);
	
	  function HorizontalRectSeriesCanvas() {
	    _classCallCheck(this, HorizontalRectSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (HorizontalRectSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalRectSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalRectSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'y';
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _rectSeriesCanvas2.default.renderLayer(_extends({}, props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }), ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return HorizontalRectSeriesCanvas;
	}(_abstractSeries2.default);
	
	HorizontalRectSeriesCanvas.displayName = 'HorizontalRectSeriesCanvas';
	HorizontalRectSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = HorizontalRectSeriesCanvas;

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeries = __webpack_require__(347);
	
	var _rectSeries2 = _interopRequireDefault(_rectSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalRectSeries = function (_AbstractSeries) {
	  _inherits(HorizontalRectSeries, _AbstractSeries);
	
	  function HorizontalRectSeries() {
	    _classCallCheck(this, HorizontalRectSeries);
	
	    return _possibleConstructorReturn(this, (HorizontalRectSeries.__proto__ || Object.getPrototypeOf(HorizontalRectSeries)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalRectSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_rectSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'y';
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return HorizontalRectSeries;
	}(_abstractSeries2.default);
	
	HorizontalRectSeries.displayName = 'HorizontalRectSeries';
	
	exports.default = HorizontalRectSeries;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _markSeriesCanvas = __webpack_require__(596);
	
	var _markSeriesCanvas2 = _interopRequireDefault(_markSeriesCanvas);
	
	var _lineSeriesCanvas = __webpack_require__(593);
	
	var _lineSeriesCanvas2 = _interopRequireDefault(_lineSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var LineMarkSeriesCanvas = function (_AbstractSeries) {
	  _inherits(LineMarkSeriesCanvas, _AbstractSeries);
	
	  function LineMarkSeriesCanvas() {
	    _classCallCheck(this, LineMarkSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (LineMarkSeriesCanvas.__proto__ || Object.getPrototypeOf(LineMarkSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(LineMarkSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _lineSeriesCanvas2.default.renderLayer(props, ctx);
	      _markSeriesCanvas2.default.renderLayer(props, ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return LineMarkSeriesCanvas;
	}(_abstractSeries2.default);
	
	LineMarkSeriesCanvas.displayName = 'LineMarkSeriesCanvas';
	LineMarkSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = LineMarkSeriesCanvas;

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _lineSeriesGl = __webpack_require__(594);
	
	var _lineSeriesGl2 = _interopRequireDefault(_lineSeriesGl);
	
	var _markSeriesGl = __webpack_require__(597);
	
	var _markSeriesGl2 = _interopRequireDefault(_markSeriesGl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var LineMarkSeriesGL = function (_AbstractSeries) {
	  _inherits(LineMarkSeriesGL, _AbstractSeries);
	
	  function LineMarkSeriesGL() {
	    _classCallCheck(this, LineMarkSeriesGL);
	
	    return _possibleConstructorReturn(this, (LineMarkSeriesGL.__proto__ || Object.getPrototypeOf(LineMarkSeriesGL)).apply(this, arguments));
	  }
	
	  _createClass(LineMarkSeriesGL, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props) {
	      return [_lineSeriesGl2.default.renderLayer(_extends({}, props, { seriesId: props.seriesId + '-line' })), _markSeriesGl2.default.renderLayer(_extends({}, props, { seriesId: props.seriesId + '-mark' }))];
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isDeckGL',
	    get: function get() {
	      return true;
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return _lineSeriesGl2.default.defaultProps;
	    }
	  }]);
	
	  return LineMarkSeriesGL;
	}(_abstractSeries2.default);
	
	LineMarkSeriesGL.displayName = 'LineMarkSeriesGL';
	
	exports.default = LineMarkSeriesGL;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _lineSeries = __webpack_require__(595);
	
	var _lineSeries2 = _interopRequireDefault(_lineSeries);
	
	var _markSeries = __webpack_require__(598);
	
	var _markSeries2 = _interopRequireDefault(_markSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var LineMarkSeries = function (_AbstractSeries) {
	  _inherits(LineMarkSeries, _AbstractSeries);
	
	  function LineMarkSeries() {
	    _classCallCheck(this, LineMarkSeries);
	
	    return _possibleConstructorReturn(this, (LineMarkSeries.__proto__ || Object.getPrototypeOf(LineMarkSeries)).apply(this, arguments));
	  }
	
	  _createClass(LineMarkSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'g',
	        { className: 'rv-xy-plot__series rv-xy-plot__series--linemark' },
	        _react2.default.createElement(_lineSeries2.default, this.props),
	        _react2.default.createElement(_markSeries2.default, this.props)
	      );
	    }
	  }], [{
	    key: 'defaultProps',
	    get: function get() {
	      return _lineSeries2.default.defaultProps;
	    }
	  }]);
	
	  return LineMarkSeries;
	}(_abstractSeries2.default);
	
	LineMarkSeries.displayName = 'LineMarkSeries';
	
	exports.default = LineMarkSeries;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--polygon';
	var DEFAULT_COLOR = '#12939A';
	
	var generatePath = function generatePath(data, xFunctor, yFunctor) {
	  return data.reduce(function (res, row, i) {
	    return res + ' ' + (i ? 'L' : 'M') + xFunctor(row) + ' ' + yFunctor(row);
	  }, '') + ' Z';
	};
	
	var PolygonSeries = function (_AbstractSeries) {
	  _inherits(PolygonSeries, _AbstractSeries);
	
	  function PolygonSeries() {
	    _classCallCheck(this, PolygonSeries);
	
	    return _possibleConstructorReturn(this, (PolygonSeries.__proto__ || Object.getPrototypeOf(PolygonSeries)).apply(this, arguments));
	  }
	
	  _createClass(PolygonSeries, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          color = _props.color,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(PolygonSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement('path', {
	        className: predefinedClassName + ' ' + className,
	        onMouseOver: this._seriesMouseOverHandler,
	        onMouseOut: this._seriesMouseOutHandler,
	        onClick: this._seriesClickHandler,
	        fill: color || DEFAULT_COLOR,
	        style: style,
	        d: generatePath(data, xFunctor, yFunctor),
	        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
	        ref: 'container'
	      });
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return _extends({}, _abstractSeries2.default.propTypes);
	    }
	  }]);
	
	  return PolygonSeries;
	}(_abstractSeries2.default);
	
	PolygonSeries.displayName = 'PolygonSeries';
	
	exports.default = PolygonSeries;

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeriesCanvas = __webpack_require__(590);
	
	var _barSeriesCanvas2 = _interopRequireDefault(_barSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalBarSeriesCanvas = function (_AbstractSeries) {
	  _inherits(HorizontalBarSeriesCanvas, _AbstractSeries);
	
	  function HorizontalBarSeriesCanvas() {
	    _classCallCheck(this, HorizontalBarSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (HorizontalBarSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalBarSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalBarSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x';
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _barSeriesCanvas2.default.renderLayer(_extends({}, props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }), ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return HorizontalBarSeriesCanvas;
	}(_abstractSeries2.default);
	
	HorizontalBarSeriesCanvas.displayName = 'HorizontalBarSeriesCanvas';
	HorizontalBarSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = HorizontalBarSeriesCanvas;

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeries = __webpack_require__(591);
	
	var _barSeries2 = _interopRequireDefault(_barSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var VerticalBarSeries = function (_AbstractSeries) {
	  _inherits(VerticalBarSeries, _AbstractSeries);
	
	  function VerticalBarSeries() {
	    _classCallCheck(this, VerticalBarSeries);
	
	    return _possibleConstructorReturn(this, (VerticalBarSeries.__proto__ || Object.getPrototypeOf(VerticalBarSeries)).apply(this, arguments));
	  }
	
	  _createClass(VerticalBarSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_barSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x';
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return VerticalBarSeries;
	}(_abstractSeries2.default);
	
	VerticalBarSeries.displayName = 'VerticalBarSeries';
	
	exports.default = VerticalBarSeries;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeriesCanvas = __webpack_require__(346);
	
	var _rectSeriesCanvas2 = _interopRequireDefault(_rectSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalRectSeriesCanvas = function (_AbstractSeries) {
	  _inherits(HorizontalRectSeriesCanvas, _AbstractSeries);
	
	  function HorizontalRectSeriesCanvas() {
	    _classCallCheck(this, HorizontalRectSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (HorizontalRectSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalRectSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalRectSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x';
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _rectSeriesCanvas2.default.renderLayer(_extends({}, props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }), ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return HorizontalRectSeriesCanvas;
	}(_abstractSeries2.default);
	
	HorizontalRectSeriesCanvas.displayName = 'HorizontalRectSeriesCanvas';
	HorizontalRectSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = HorizontalRectSeriesCanvas;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(23);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeries = __webpack_require__(347);
	
	var _rectSeries2 = _interopRequireDefault(_rectSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var VerticalRectSeries = function (_AbstractSeries) {
	  _inherits(VerticalRectSeries, _AbstractSeries);
	
	  function VerticalRectSeries() {
	    _classCallCheck(this, VerticalRectSeries);
	
	    return _possibleConstructorReturn(this, (VerticalRectSeries.__proto__ || Object.getPrototypeOf(VerticalRectSeries)).apply(this, arguments));
	  }
	
	  _createClass(VerticalRectSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_rectSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x';
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return VerticalRectSeries;
	}(_abstractSeries2.default);
	
	VerticalRectSeries.displayName = 'VerticalRectSeries';
	
	exports.default = VerticalRectSeries;

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gridLines = __webpack_require__(344);
	
	var _gridLines2 = _interopRequireDefault(_gridLines);
	
	var _axisUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERTICAL = _axisUtils.DIRECTION.VERTICAL;
	
	
	var propTypes = _extends({}, _gridLines2.default.propTypes, {
	  direction: _propTypes2.default.oneOf([VERTICAL])
	});
	
	var defaultProps = {
	  direction: VERTICAL,
	  attr: 'x'
	};
	
	function VerticalGridLines(props) {
	  return _react2.default.createElement(_gridLines2.default, props);
	}
	
	VerticalGridLines.displayName = 'VerticalGridLines';
	VerticalGridLines.propTypes = propTypes;
	VerticalGridLines.defaultProps = defaultProps;
	VerticalGridLines.requiresSVG = true;
	
	exports.default = VerticalGridLines;

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(233);
	
	var _animation = __webpack_require__(38);
	
	var _arcSeries = __webpack_require__(345);
	
	var _arcSeries2 = _interopRequireDefault(_arcSeries);
	
	var _labelSeries = __webpack_require__(592);
	
	var _labelSeries2 = _interopRequireDefault(_labelSeries);
	
	var _xyPlot = __webpack_require__(348);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _theme = __webpack_require__(45);
	
	var _chartUtils = __webpack_require__(349);
	
	var _seriesUtils = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var predefinedClassName = 'rv-radial-chart';
	
	var DEFAULT_RADIUS_MARGIN = 15;
	
	/**
	 * Create the list of wedges to render.
	 * @param {Object} props
	   props.data {Object} - tree structured data (each node has a name anc an array of children)
	 * @returns {Array} Array of nodes.
	 */
	function getWedgesToRender(_ref) {
	  var data = _ref.data;
	
	  var pie = (0, _d3Shape.pie)().sort(null).value(function (d) {
	    return d.angle;
	  });
	  var pieData = pie(data).reverse();
	  return pieData.map(function (row, index) {
	    return _extends({}, row.data, {
	      angle0: row.startAngle,
	      angle: row.endAngle,
	      radius0: row.data.innerRadius || 0,
	      radius: row.data.radius || 1,
	      color: row.data.color || index
	    });
	  });
	}
	
	function generateLabels(mappedData) {
	  return mappedData.reduce(function (res, row) {
	    var angle = row.angle,
	        angle0 = row.angle0,
	        radius = row.radius,
	        label = row.label,
	        subLabel = row.subLabel;
	
	    var centeredAngle = (angle + angle0) / 2;
	
	    // unfortunate, but true fact: d3 starts its radians at 12 oclock rather than 3
	    // and move clockwise rather than counter clockwise. why why why!
	    var updatedAngle = -1 * centeredAngle + Math.PI / 2;
	    var newLabels = [];
	    if (row.label) {
	      newLabels.push({
	        angle: updatedAngle,
	        radius: radius * 1.1,
	        label: label,
	        style: { fontSize: '12px' }
	      });
	    }
	
	    if (subLabel) {
	      newLabels.push({
	        angle: updatedAngle,
	        radius: radius * 1.1,
	        label: subLabel,
	        yOffset: 12,
	        style: { fontSize: '10px' }
	      });
	    }
	    return res.concat(newLabels);
	  }, []);
	  // could add force direction here to make sure the labels dont overlap
	}
	
	/**
	 * Get the max radius so the chart can extend to the margin.
	 * @param  {Number} width - container width
	 * @param  {Number} height - container height
	 * @return {Number} radius
	 */
	function getMaxRadius(width, height) {
	  return Math.min(width, height) / 2 - DEFAULT_RADIUS_MARGIN;
	}
	
	var RadialChart = function (_Component) {
	  _inherits(RadialChart, _Component);
	
	  function RadialChart() {
	    _classCallCheck(this, RadialChart);
	
	    return _possibleConstructorReturn(this, (RadialChart.__proto__ || Object.getPrototypeOf(RadialChart)).apply(this, arguments));
	  }
	
	  _createClass(RadialChart, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          children = _props.children,
	          data = _props.data,
	          height = _props.height,
	          hideRootNode = _props.hideRootNode,
	          width = _props.width,
	          colorType = _props.colorType,
	          radius = _props.radius,
	          innerRadius = _props.innerRadius,
	          showLabels = _props.showLabels,
	          margin = _props.margin,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          labelsAboveChildren = _props.labelsAboveChildren;
	
	      var mappedData = getWedgesToRender({ data: data, height: height, hideRootNode: hideRootNode, width: width });
	      var radialDomain = (0, _seriesUtils.getRadialDomain)(mappedData);
	      var arcProps = _extends({
	        colorType: colorType
	      }, this.props, {
	        animation: animation,
	        radiusDomain: [0, radialDomain],
	        data: mappedData,
	        radiusNoFallBack: true,
	        arcClassName: 'rv-radial-chart__series--pie__slice'
	      });
	      if (radius) {
	        arcProps.radiusDomain = [0, 1];
	        arcProps.radiusRange = [innerRadius || 0, radius];
	        arcProps.radiusType = 'linear';
	      }
	      var maxRadius = radius ? radius : getMaxRadius(width, height);
	      var defaultMargin = (0, _chartUtils.getRadialLayoutMargin)(width, height, maxRadius);
	      return _react2.default.createElement(
	        _xyPlot2.default,
	        {
	          height: height,
	          width: width,
	          margin: _extends({}, margin, defaultMargin),
	          className: className + ' ' + predefinedClassName,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          xDomain: [-radialDomain, radialDomain],
	          yDomain: [-radialDomain, radialDomain] },
	        _react2.default.createElement(_arcSeries2.default, arcProps),
	        showLabels && !labelsAboveChildren && _react2.default.createElement(_labelSeries2.default, { data: generateLabels(mappedData) }),
	        children,
	        showLabels && labelsAboveChildren && _react2.default.createElement(_labelSeries2.default, { data: generateLabels(mappedData) })
	      );
	    }
	  }]);
	
	  return RadialChart;
	}(_react.Component);
	
	RadialChart.displayName = 'RadialChart';
	RadialChart.PropTypes = {
	  animation: _animation.AnimationPropType,
	  className: _propTypes2.default.string,
	  colorType: _propTypes2.default.string,
	  data: _propTypes2.default.object.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  labelsAboveChildren: _propTypes2.default.bool,
	  margin: _chartUtils.MarginPropType,
	  onValueClick: _propTypes2.default.func,
	  onValueMouseOver: _propTypes2.default.func,
	  onValueMouseOut: _propTypes2.default.func,
	  width: _propTypes2.default.number.isRequired,
	  showLabels: _propTypes2.default.bool
	};
	RadialChart.defaultProps = {
	  className: '',
	  colorType: 'category',
	  colorRange: _theme.DISCRETE_COLOR_RANGE
	};
	
	exports.default = RadialChart;

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3SankeyAlign = __webpack_require__(761);
	
	var _voronoi = __webpack_require__(599);
	
	var _voronoi2 = _interopRequireDefault(_voronoi);
	
	var _theme = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NOOP = function NOOP(f) {
	  return f;
	};
	
	var DEFAULT_LINK_COLOR = _theme.DISCRETE_COLOR_RANGE[1];
	var DEFAULT_LINK_OPACITY = 0.7;
	var DEFAULT_NODE_COLOR = _theme.DISCRETE_COLOR_RANGE[0];
	var DEFAULT_NODE_OPACITY = 1;
	
	var Sankey = function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey() {
	    _classCallCheck(this, Sankey);
	
	    return _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).apply(this, arguments));
	  }
	
	  _createClass(Sankey, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          align = _props.align,
	          className = _props.className,
	          hasVoronoi = _props.hasVoronoi,
	          height = _props.height,
	          layout = _props.layout,
	          links = _props.links,
	          margin = _props.margin,
	          nodePadding = _props.nodePadding,
	          nodes = _props.nodes,
	          nodeWidth = _props.nodeWidth,
	          onBlur = _props.onBlur,
	          _onClick = _props.onClick,
	          onHover = _props.onHover,
	          width = _props.width;
	
	
	      var sankeyInstance = (0, _d3SankeyAlign.sankey)().size([width, height]).nodeWidth(nodeWidth).nodePadding(nodePadding).nodes(nodes).links(links).align(align).layout(layout);
	
	      var nWidth = sankeyInstance.nodeWidth();
	      var path = sankeyInstance.link();
	
	      return _react2.default.createElement(
	        'svg',
	        { height: height + margin, width: width + margin, className: 'rv-sankey ' + className },
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(' + margin / 2 + ', ' + margin / 2 + ')' },
	          links.map(function (link, i) {
	            return _react2.default.createElement('path', {
	              d: path(link),
	              className: 'rv-sankey__link',
	              opacity: Number.isFinite(link.opacity) ? link.opacity : DEFAULT_LINK_OPACITY,
	              stroke: link.color || DEFAULT_LINK_COLOR,
	              strokeWidth: Math.max(1, link.dy),
	              fill: 'none',
	              key: link.id || link.key || 'link-' + i });
	          }),
	          nodes.map(function (node, i) {
	            return _react2.default.createElement(
	              'g',
	              {
	                transform: 'translate(' + node.x + ', ' + node.y + ')',
	                className: 'rv-sankey__node',
	                opacity: Number.isFinite(node.opacity) ? node.opacity : DEFAULT_NODE_OPACITY,
	                key: node.id || node.key || 'node-' + i },
	              _react2.default.createElement('rect', {
	                onClick: function onClick() {
	                  return _onClick(node);
	                },
	                onMouseOver: function onMouseOver() {
	                  return onHover(node);
	                },
	                onMouseOut: function onMouseOut() {
	                  return onBlur(node);
	                },
	                fill: node.color || DEFAULT_NODE_COLOR,
	                height: node.dy,
	                width: nWidth })
	            );
	          }),
	          hasVoronoi && _react2.default.createElement(_voronoi2.default, {
	            className: 'rv-sankey__voronoi',
	            extent: [[-margin, -margin], [width + margin, height + margin]],
	            nodes: nodes,
	            onBlur: onBlur,
	            onClick: _onClick,
	            onHover: onHover,
	            x: function x(d) {
	              return d.x + d.dx / 2;
	            },
	            y: function y(d) {
	              return d.y + d.dy / 2;
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component);
	
	Sankey.defaultProps = {
	  align: 'justify',
	  className: '',
	  hasVoronoi: false,
	  layout: 50,
	  margin: 20,
	  nodePadding: 10,
	  nodeWidth: 10,
	  onBlur: NOOP,
	  onClick: NOOP,
	  onHover: NOOP
	};
	Sankey.propTypes = {
	  align: _propTypes2.default.oneOf(['justify', 'left', 'right', 'center']),
	  className: _propTypes2.default.string,
	  hasVoronoi: _propTypes2.default.bool,
	  height: _propTypes2.default.number.isRequired,
	  layout: _propTypes2.default.number,
	  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    source: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]).isRequired,
	    target: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]).isRequired
	  })).isRequired,
	  margin: _propTypes2.default.number,
	  nodePadding: _propTypes2.default.number,
	  nodes: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  nodeWidth: _propTypes2.default.number,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onHover: _propTypes2.default.func,
	  width: _propTypes2.default.number.isRequired
	};
	exports.default = Sankey;

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Hierarchy = __webpack_require__(601);
	
	var _d3Scale = __webpack_require__(101);
	
	var _animation = __webpack_require__(38);
	
	var _arcSeries = __webpack_require__(345);
	
	var _arcSeries2 = _interopRequireDefault(_arcSeries);
	
	var _xyPlot = __webpack_require__(348);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _seriesUtils = __webpack_require__(61);
	
	var _chartUtils = __webpack_require__(349);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Create the list of nodes to render.
	 * @param {Object} props
	   props.data {Object} - tree structured data (each node has a name anc an array of children)
	   props.height {number} - the height of the graphic to be rendered
	   props.hideRootNode {boolean} - whether or not to hide the root node
	   props.width {number} - the width of the graphic to be rendered
	 * @returns {Array} Array of nodes.
	 */
	function getNodesToRender(_ref) {
	  var data = _ref.data,
	      height = _ref.height,
	      hideRootNode = _ref.hideRootNode,
	      width = _ref.width;
	
	  var partitionFunction = (0, _d3Hierarchy.partition)();
	  var structuredInput = (0, _d3Hierarchy.hierarchy)(data).sum(function (d) {
	    return d.size;
	  });
	  var radius = Math.min(width, height) / 2 - 10;
	  var x = (0, _d3Scale.scaleLinear)().range([0, 2 * Math.PI]);
	  var y = (0, _d3Scale.scaleSqrt)().range([0, radius]);
	
	  return partitionFunction(structuredInput).descendants().reduce(function (res, cell, index) {
	    if (hideRootNode && index === 0) {
	      return res;
	    }
	
	    return res.concat([_extends({
	      angle0: Math.max(0, Math.min(2 * Math.PI, x(cell.x0))),
	      angle: Math.max(0, Math.min(2 * Math.PI, x(cell.x1))),
	      radius0: Math.max(0, y(cell.y0)),
	      radius: Math.max(0, y(cell.y1)),
	      depth: cell.depth,
	      parent: cell.parent
	    }, cell.data)]);
	  }, []);
	}
	
	var Sunburst = function (_React$Component) {
	  _inherits(Sunburst, _React$Component);
	
	  function Sunburst() {
	    _classCallCheck(this, Sunburst);
	
	    return _possibleConstructorReturn(this, (Sunburst.__proto__ || Object.getPrototypeOf(Sunburst)).apply(this, arguments));
	  }
	
	  _createClass(Sunburst, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          height = _props.height,
	          hideRootNode = _props.hideRootNode,
	          width = _props.width,
	          colorType = _props.colorType;
	
	      var mappedData = getNodesToRender({ data: data, height: height, hideRootNode: hideRootNode, width: width });
	      var radialDomain = (0, _seriesUtils.getRadialDomain)(mappedData);
	      var margin = (0, _chartUtils.getRadialLayoutMargin)(width, height, radialDomain);
	      return _react2.default.createElement(
	        _xyPlot2.default,
	        {
	          height: height,
	          width: width,
	          className: className,
	          margin: margin,
	          xDomain: [-radialDomain, radialDomain],
	          yDomain: [-radialDomain, radialDomain] },
	        _react2.default.createElement(_arcSeries2.default, _extends({
	          colorType: colorType
	        }, this.props, {
	          animation: animation,
	          radiusDomain: [0, radialDomain],
	          // need to present a stripped down version for interpolation
	          data: animation ? mappedData.map(function (row) {
	            return _extends({}, row, { parent: null, children: null });
	          }) : mappedData,
	          _data: animation ? mappedData : null
	        }))
	      );
	    }
	  }]);
	
	  return Sunburst;
	}(_react2.default.Component);
	
	Sunburst.displayName = 'Sunburst';
	Sunburst.PropTypes = {
	  animation: _animation.AnimationPropType,
	  className: _propTypes2.default.string,
	  colorType: _propTypes2.default.string,
	  data: _propTypes2.default.object.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  hideRootNode: _propTypes2.default.bool,
	  onValueClick: _propTypes2.default.func,
	  onValueMouseOver: _propTypes2.default.func,
	  onValueMouseOut: _propTypes2.default.func,
	  width: _propTypes2.default.number.isRequired
	};
	Sunburst.defaultProps = {
	  className: '',
	  colorType: 'literal',
	  hideRootNode: false
	};
	
	exports.default = Sunburst;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Hierarchy = __webpack_require__(601);
	
	var _theme = __webpack_require__(45);
	
	var _animation = __webpack_require__(38);
	
	var _scalesUtils = __webpack_require__(40);
	
	var _treemapLeaf = __webpack_require__(1382);
	
	var _treemapLeaf2 = _interopRequireDefault(_treemapLeaf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TREEMAP_TILE_MODES = {
	  squarify: _d3Hierarchy.treemapSquarify,
	  resquarify: _d3Hierarchy.treemapResquarify,
	  slice: _d3Hierarchy.treemapSlice,
	  dice: _d3Hierarchy.treemapDice,
	  slicedice: _d3Hierarchy.treemapSliceDice,
	  binary: _d3Hierarchy.treemapBinary
	};
	
	var TREEMAP_LAYOUT_MODES = ['circlePack', 'partition', 'partition-pivot'];
	
	var NOOP = function NOOP(d) {
	  return d;
	};
	
	var ATTRIBUTES = ['opacity', 'color'];
	
	/**
	 * Get the map of scale functions from the given props.
	 * @param {Object} props Props for the component.
	 * @returns {Object} Map of scale functions.
	 * @private
	 */
	function _getScaleFns(props) {
	  var data = props.data;
	
	  var allData = data.children || [];
	
	  // Adding _allData property to the object to reuse the existing
	  // getAttributeFunctor function.
	  var compatibleProps = _extends({}, props, (0, _scalesUtils.getMissingScaleProps)(props, allData, ATTRIBUTES), {
	    _allData: allData
	  });
	  return {
	    opacity: (0, _scalesUtils.getAttributeFunctor)(compatibleProps, 'opacity'),
	    color: (0, _scalesUtils.getAttributeFunctor)(compatibleProps, 'color')
	  };
	}
	
	var Treemap = function (_React$Component) {
	  _inherits(Treemap, _React$Component);
	
	  _createClass(Treemap, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        animation: _animation.AnimationPropType,
	        className: _propTypes2.default.string,
	        data: _propTypes2.default.object.isRequired,
	        height: _propTypes2.default.number.isRequired,
	        mode: _propTypes2.default.oneOf(Object.keys(TREEMAP_TILE_MODES).concat(TREEMAP_LAYOUT_MODES)),
	        onLeafClick: _propTypes2.default.func,
	        onLeafMouseOver: _propTypes2.default.func,
	        onLeafMouseOut: _propTypes2.default.func,
	        useCirclePacking: _propTypes2.default.bool,
	        padding: _propTypes2.default.number.isRequired,
	        width: _propTypes2.default.number.isRequired
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        className: '',
	        colorRange: _theme.CONTINUOUS_COLOR_RANGE,
	        _colorValue: _theme.DEFAULT_COLOR,
	        data: {
	          children: []
	        },
	        mode: 'squarify',
	        onLeafClick: NOOP,
	        onLeafMouseOver: NOOP,
	        onLeafMouseOut: NOOP,
	        opacityType: _theme.OPACITY_TYPE,
	        _opacityValue: _theme.DEFAULT_OPACITY,
	        padding: 1
	      };
	    }
	  }]);
	
	  function Treemap(props) {
	    _classCallCheck(this, Treemap);
	
	    var _this = _possibleConstructorReturn(this, (Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call(this, props));
	
	    _this.state = { scales: _getScaleFns(props) };
	    return _this;
	  }
	
	  _createClass(Treemap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState({ scales: _getScaleFns(props) });
	    }
	
	    /**
	     * Create the list of nodes to render.
	     * @returns {Array} Array of nodes.
	     * @private
	     */
	
	  }, {
	    key: '_getNodesToRender',
	    value: function _getNodesToRender() {
	      var _props = this.props,
	          data = _props.data,
	          height = _props.height,
	          width = _props.width,
	          mode = _props.mode,
	          padding = _props.padding;
	
	      if (data && (mode === 'partition' || mode === 'partition-pivot')) {
	        var partitionFunction = (0, _d3Hierarchy.partition)().size([width, height]).padding(padding);
	        var structuredInput = (0, _d3Hierarchy.hierarchy)(data).sum(function (d) {
	          return d.size;
	        });
	        var mappedNodes = partitionFunction(structuredInput).descendants();
	        if (mode === 'partition-pivot') {
	          return mappedNodes.map(function (node) {
	            return _extends({}, node, {
	              x0: node.y0,
	              x1: node.y1,
	              y0: node.x0,
	              y1: node.x1
	            });
	          });
	        }
	        return mappedNodes;
	      }
	      if (data && mode === 'circlePack') {
	        var packingFunction = (0, _d3Hierarchy.pack)().size([width, height]).padding(padding);
	        var _structuredInput = (0, _d3Hierarchy.hierarchy)(data).sort(function (a, b) {
	          return a.size - b.size;
	        }).sum(function (d) {
	          return d.size;
	        });
	        return packingFunction(_structuredInput).descendants();
	      }
	      if (data) {
	        var tileFn = TREEMAP_TILE_MODES[mode];
	        var treemapingFunction = (0, _d3Hierarchy.treemap)(tileFn).tile(tileFn).size([width, height]).padding(padding);
	        var _structuredInput2 = (0, _d3Hierarchy.hierarchy)(data).sort(function (a, b) {
	          return a.size - b.size;
	        }).sum(function (d) {
	          return d.size;
	        });
	
	        return treemapingFunction(_structuredInput2).descendants();
	      }
	      return [];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          animation = _props2.animation,
	          className = _props2.className,
	          height = _props2.height,
	          mode = _props2.mode,
	          width = _props2.width;
	
	      var nodes = this._getNodesToRender();
	      var useCirclePacking = mode === 'circlePack';
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-treemap ' + (useCirclePacking ? 'rv-treemap-circle-packed' : '') + ' ' + className,
	          style: {
	            width: width + 'px',
	            height: height + 'px'
	          } },
	        nodes.map(function (node, index) {
	          // throw out the rootest node
	          if (!useCirclePacking && !index) {
	            return null;
	          }
	
	          var nodeProps = _extends({
	            animation: animation,
	            node: node
	          }, _this2.props, {
	            x0: useCirclePacking ? node.x : node.x0,
	            x1: useCirclePacking ? node.x : node.x1,
	            y0: useCirclePacking ? node.y : node.y0,
	            y1: useCirclePacking ? node.y : node.y1,
	            r: useCirclePacking ? node.r : 1,
	            scales: _this2.state.scales
	          });
	          return _react2.default.createElement(_treemapLeaf2.default, _extends({}, nodeProps, { key: 'leaf-' + index }));
	        })
	      );
	    }
	  }]);
	
	  return Treemap;
	}(_react2.default.Component);
	
	Treemap.displayName = 'Treemap';
	
	exports.default = Treemap;

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _scalesUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var ANIMATED_PROPS = ['colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'x0', 'x1', 'y0', 'y1', 'r'];
	
	var TreemapLeaf = function (_React$Component) {
	  _inherits(TreemapLeaf, _React$Component);
	
	  function TreemapLeaf() {
	    _classCallCheck(this, TreemapLeaf);
	
	    return _possibleConstructorReturn(this, (TreemapLeaf.__proto__ || Object.getPrototypeOf(TreemapLeaf)).apply(this, arguments));
	  }
	
	  _createClass(TreemapLeaf, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          mode = _props.mode,
	          node = _props.node,
	          onLeafClick = _props.onLeafClick,
	          onLeafMouseOver = _props.onLeafMouseOver,
	          onLeafMouseOut = _props.onLeafMouseOut,
	          r = _props.r,
	          scales = _props.scales,
	          x0 = _props.x0,
	          x1 = _props.x1,
	          y0 = _props.y0,
	          y1 = _props.y1;
	
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: ANIMATED_PROPS }),
	          _react2.default.createElement(TreemapLeaf, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var useCirclePacking = mode === 'circlePack';
	      var background = scales.color(node);
	      var opacity = scales.opacity(node);
	      var color = (0, _scalesUtils.getFontColorFromBackground)(background);
	      var title = node.data.title;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-treemap__leaf ' + (useCirclePacking ? 'rv-treemap__leaf--circle' : ''),
	          onMouseEnter: function onMouseEnter(event) {
	            return onLeafMouseOver(node, event);
	          },
	          onMouseLeave: function onMouseLeave(event) {
	            return onLeafMouseOut(node, event);
	          },
	          onClick: function onClick(event) {
	            return onLeafClick(node, event);
	          },
	          style: {
	            top: useCirclePacking ? y0 - r : y0,
	            left: useCirclePacking ? x0 - r : x0,
	            width: useCirclePacking ? r * 2 : x1 - x0,
	            height: useCirclePacking ? r * 2 : y1 - y0,
	            background: background,
	            opacity: opacity,
	            color: color
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'rv-treemap__leaf__content' },
	          title
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        animation: _animation.AnimationPropType,
	        height: _propTypes2.default.number.isRequired,
	        mode: _propTypes2.default.string,
	        node: _propTypes2.default.object.isRequired,
	        onLeafClick: _propTypes2.default.func,
	        onLeafMouseOver: _propTypes2.default.func,
	        onLeafMouseOut: _propTypes2.default.func,
	        scales: _propTypes2.default.object.isRequired,
	        width: _propTypes2.default.number.isRequired,
	        r: _propTypes2.default.number.isRequired,
	        x0: _propTypes2.default.number.isRequired,
	        x1: _propTypes2.default.number.isRequired,
	        y0: _propTypes2.default.number.isRequired,
	        y1: _propTypes2.default.number.isRequired
	      };
	    }
	  }]);
	
	  return TreemapLeaf;
	}(_react2.default.Component);
	
	exports.default = TreemapLeaf;

/***/ },
/* 1383 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getObjectValueAccessor = getObjectValueAccessor;
	exports.getUniquePropertyValues = getUniquePropertyValues;
	exports.addValueToArray = addValueToArray;
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Get the value accessor function that gets a property from an object.
	 * @param {string} propertyName Property name.
	 * @returns {Function} Value accessor.
	 */
	function getObjectValueAccessor(propertyName) {
	  return function (obj) {
	    return obj[propertyName];
	  };
	}
	
	/**
	 * Get unique property values from an array.
	 * @param {Array} arr Array of data.
	 * @param {string} propertyName Prop name.
	 * @returns {Array} Array of unique values.
	 */
	function getUniquePropertyValues(arr, propertyName) {
	  var setOfValues = new Set(arr.map(getObjectValueAccessor(propertyName)));
	  return Array.from(setOfValues);
	}
	
	/**
	 * Add zero to the domain.
	 * @param {Array} arr Add zero to the domain.
	 * @param {Number} value Add zero to domain.
	 * @returns {Array} Adjusted domain.
	 */
	function addValueToArray(arr, value) {
	  var result = [].concat(arr);
	  if (result[0] > value) {
	    result[0] = value;
	  }
	  if (result[result.length - 1] < value) {
	    result[result.length - 1] = value;
	  }
	  return result;
	}

/***/ },
/* 1384 */
758,
/* 1385 */
320,
/* 1386 */
[1491, 137],
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1386);
	var ReactElement = __webpack_require__(136);
	
	var emptyFunction = __webpack_require__(36);
	var traverseAllChildren = __webpack_require__(1397);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(137),
	    _assign = __webpack_require__(11);
	
	var ReactComponent = __webpack_require__(350);
	var ReactElement = __webpack_require__(136);
	var ReactPropTypeLocationNames = __webpack_require__(1390);
	var ReactNoopUpdateQueue = __webpack_require__(351);
	
	var emptyObject = __webpack_require__(43);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(136);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(136),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(540);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactComponent = __webpack_require__(350);
	var ReactNoopUpdateQueue = __webpack_require__(351);
	
	var emptyObject = __webpack_require__(43);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 1393 */
558,
/* 1394 */
1264,
/* 1395 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(137);
	
	var ReactElement = __webpack_require__(136);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(137);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var REACT_ELEMENT_TYPE = __webpack_require__(603);
	
	var getIteratorFn = __webpack_require__(1394);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(1385);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @fileOverview calculate tick values of scale
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @author xile611, arcthur
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @date 2015-09-17
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
	
	var _utils = __webpack_require__(606);
	
	var _arithmetic = __webpack_require__(1399);
	
	var _arithmetic2 = _interopRequireDefault(_arithmetic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max;
	
	  // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Number}  roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Number}  The step which is easy to understand between two ticks
	 */
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep <= 0) {
	    return 0;
	  }
	
	  var digitCount = _arithmetic2.default.getDigitCount(roughStep);
	  // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	  var stepRatio = roughStep / Math.pow(10, digitCount);
	  // When an integer and a float multiplied, the accuracy of result may be wrong
	  var amendStepRatio = digitCount !== 1 ? _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.05) + correctionFactor, 0.05) : _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.1) + correctionFactor, 0.1);
	
	  var formatStep = _arithmetic2.default.multiply(amendStepRatio, Math.pow(10, digitCount));
	
	  return allowDecimals ? formatStep : Math.ceil(formatStep);
	}
	
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var isFlt = _arithmetic2.default.isFloat(value);
	  var step = 1;
	  // calculate the middle value of ticks
	  var middle = value;
	
	  if (isFlt && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = Math.pow(10, _arithmetic2.default.getDigitCount(value) - 1);
	
	      middle = _arithmetic2.default.multiply(Math.floor(value / step), step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = Math.floor(value);
	    }
	  } else if (value === 0) {
	    middle = Math.floor((tickCount - 1) / 2);
	  } else if (!allowDecimals) {
	    middle = Math.floor(value);
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(n - middleIndex, step));
	  }), _utils.range);
	
	  return fn(0, tickCount);
	}
	
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // The step which is easy to understand between two ticks
	  var step = getFormatStep((max - min) / (tickCount - 1), allowDecimals, correctionFactor);
	  // A medial value of ticks
	  var middle = void 0;
	
	  // When 0 is inside the interval, 0 should be a tick
	  if (min <= 0 && max >= 0) {
	    middle = 0;
	  } else {
	    middle = _arithmetic2.default.divide(_arithmetic2.default.sum(min, max), 2);
	    middle = _arithmetic2.default.minus(middle, _arithmetic2.default.modulo(middle, step));
	  }
	
	  var belowCount = Math.ceil((middle - min) / step);
	  var upCount = Math.ceil((max - middle) / step);
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  } else if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: _arithmetic2.default.minus(middle, _arithmetic2.default.multiply(belowCount, step)),
	    tickMax: _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(upCount, step))
	  };
	}
	/**
	 * Calculate the ticks of an interval
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  // Get the step between two ticks
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic2.default.rangeStep(tickMin, tickMax + 0.1 * step, step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return cormin + n * step;
	  }), _utils.range);
	
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	  var values = [].concat(_toConsumableArray(_arithmetic2.default.rangeStep(cormin, cormax - 0.99 * step, step)), [cormax]);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = exports.getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	var getTickValues = exports.getTickValues = (0, _utils.memoize)(getTickValuesFn);
	var getTickValuesFixedDomain = exports.getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(606);
	
	/**
	 * 判断数据是否为浮点类型
	 *
	 * @param {Number} num 输入值
	 * @return {Boolean} 是否是浮点类型
	 */
	function isFloat(num) {
	  return (/^([+-]?)\d*\.\d+$/.test(num)
	  );
	}
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	function getDigitCount(value) {
	  var abs = Math.abs(value);
	  var result = void 0;
	
	  if (value === 0) {
	    result = 1;
	  } else if (abs < 1) {
	    result = Math.floor(Math.log(abs) / Math.log(10)) + 1;
	  } else {
	    var str = '' + value;
	    var ary = str.split('.');
	
	    result = ary[0].length;
	  }
	
	  return result;
	}
	/**
	 * 计算数值的小数点后的位数
	 * @param  {Number} a 数值，可能为整数，也可能为浮点数
	 * @return {Integer}   位数
	 */
	function getDecimalDigitCount(a) {
	  var str = a ? '' + a : '';
	  var ary = str.split('.');
	
	  return ary.length > 1 ? ary[1].length : 0;
	}
	/**
	 * 乘法运算，解决了js运算的精度问题
	 * @param  {Number} a 被乘数
	 * @param  {Number} b 乘数
	 * @return {Number}   积
	 */
	function multiply(a, b) {
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	  var count = getDecimalDigitCount(a) + getDecimalDigitCount(b);
	
	  return intA * intB / Math.pow(10, count);
	}
	/**
	 * 加法运算，解决了js运算的精度问题
	 * @param  {Number} a 被加数
	 * @param  {Number} b 加数
	 * @return {Number}   和
	 */
	function sum(a, b) {
	  var count = Math.max(getDecimalDigitCount(a), getDecimalDigitCount(b));
	
	  count = Math.pow(10, count);
	
	  return (multiply(a, count) + multiply(b, count)) / count;
	}
	/**
	 * 减法运算，解决了js运算的精度问题
	 * @param  {Number} a 被减数
	 * @param  {Number} b 减数
	 * @return {Number}   差
	 */
	function minus(a, b) {
	  return sum(a, -b);
	}
	/**
	 * 除法运算，解决了js运算的精度问题
	 * @param  {Number} a 被除数
	 * @param  {Number} b 除数
	 * @return {Number}   结果
	 */
	function divide(a, b) {
	  var ca = getDecimalDigitCount(a);
	  var cb = getDecimalDigitCount(b);
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	
	  return intA / intB * Math.pow(10, cb - ca);
	}
	
	function modulo(a, b) {
	  var mod = Math.abs(b);
	
	  if (b <= 0) {
	    return a;
	  }
	
	  var cnt = Math.floor(a / mod);
	
	  return minus(a, multiply(mod, cnt));
	}
	
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Number} start 起点
	 * @param  {Number} end   终点，不包含该值
	 * @param  {Number} step  步长
	 * @return {Array}        若干数值
	 */
	function rangeStep(start, end, step) {
	  var num = start;
	  var result = [];
	
	  while (num < end) {
	    result.push(num);
	
	    num = sum(num, step);
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	
	exports.default = {
	  rangeStep: rangeStep,
	  isFloat: isFloat,
	  getDigitCount: getDigitCount,
	  getDecimalDigitCount: getDecimalDigitCount,
	
	  sum: sum,
	  minus: minus,
	  multiply: multiply,
	  divide: divide,
	  modulo: modulo,
	
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /**
	                                   * @fileOverview Composed Chart
	                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Line = __webpack_require__(356);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _Bar = __webpack_require__(353);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _Area = __webpack_require__(352);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _generateCategoricalChart = __webpack_require__(238);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _AreaChart = __webpack_require__(610);
	
	var _LineChart = __webpack_require__(612);
	
	var _BarChart = __webpack_require__(611);
	
	var _ComposedDataDecorator = __webpack_require__(177);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GRAPHICAL_TYPES = ['Area', 'Bar', 'Line'];
	var GRAPHICAL_MAP = { Area: _AreaChart.AreaChart, Bar: _BarChart.BarChart, Line: _LineChart.LineChart };
	
	var ComposedChart = (_dec = (0, _ComposedDataDecorator2.default)({}), (0, _PureRender2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ComposedChart, _Component);
	
	  function ComposedChart() {
	    _classCallCheck(this, ComposedChart);
	
	    return _possibleConstructorReturn(this, (ComposedChart.__proto__ || Object.getPrototypeOf(ComposedChart)).apply(this, arguments));
	  }
	
	  _createClass(ComposedChart, [{
	    key: 'filterGraphicalItems',
	    value: function filterGraphicalItems() {
	      var graphicalItems = this.props.graphicalItems;
	
	      var record = {};
	      var result = [];
	
	      for (var i = 0, len = graphicalItems.length; i < len; i++) {
	        var item = graphicalItems[i];
	        var displayName = item.type.displayName;
	
	        if (GRAPHICAL_TYPES.indexOf(displayName) >= 0) {
	          if (!(0, _isNil3.default)(record[displayName])) {
	            var index = record[displayName];
	
	            result[index].items = [].concat(_toConsumableArray(result[index].items), [item]);
	          } else {
	            record[displayName] = result.length;
	            result.push({ items: [item], type: displayName });
	          }
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderCursor',
	    value: function renderCursor(_ref) {
	      var xAxisMap = _ref.xAxisMap,
	          yAxisMap = _ref.yAxisMap,
	          offset = _ref.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
	      var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var bandSize = (0, _DataUtils.getBandSizeOfAxis)(axis);
	      var start = ticks[activeTooltipIndex].coordinate;
	      var cursorProps = _extends({
	        fill: '#f1f1f1'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        x: layout === 'horizontal' ? start : offset.left + 0.5,
	        y: layout === 'horizontal' ? offset.top + 0.5 : start,
	        width: layout === 'horizontal' ? bandSize : offset.width - 1,
	        height: layout === 'horizontal' ? offset.height - 1 : bandSize
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Rectangle2.default, cursorProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          xAxisMap = _props2.xAxisMap,
	          yAxisMap = _props2.yAxisMap,
	          offset = _props2.offset;
	
	      var filteredItems = this.filterGraphicalItems();
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-composed' },
	        this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
	        filteredItems.map(function (_ref2) {
	          var items = _ref2.items,
	              type = _ref2.type;
	
	          var Chart = GRAPHICAL_MAP[type];
	
	          return _react2.default.createElement(Chart, _extends({ key: type }, _this2.props, { graphicalItems: items, isComposed: true }));
	        })
	      );
	    }
	  }]);
	
	  return ComposedChart;
	}(_react.Component), _class2.displayName = 'ComposedChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  axisTicks: _propTypes2.default.array,
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _propTypes2.default.number,
	  dataEndIndex: _propTypes2.default.number,
	  isTooltipActive: _propTypes2.default.bool,
	  activeTooltipIndex: _propTypes2.default.number,
	  xAxisMap: _propTypes2.default.object,
	  yAxisMap: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  graphicalItems: _propTypes2.default.array,
	  stackGroups: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(ComposedChart, [_Line2.default, _Area2.default, _Bar2.default]);

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PieChart = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Pie Chart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(88);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Legend = __webpack_require__(116);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Pie = __webpack_require__(613);
	
	var _Pie2 = _interopRequireDefault(_Pie);
	
	var _Cell = __webpack_require__(176);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _PolarUtils = __webpack_require__(89);
	
	var _ComposedDataDecorator = __webpack_require__(177);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getComposedData = function getComposedData(_ref) {
	  var item = _ref.item;
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _extends({
	        payload: entry
	      }, presentationProps, entry, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _extends({}, presentationProps, cell.props);
	    });
	  }
	
	  return [];
	};
	
	var PieChart = exports.PieChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData, ChildComponent: _Pie2.default }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(PieChart, _Component);
	
	  function PieChart() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PieChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = PieChart.__proto__ || Object.getPrototypeOf(PieChart)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      activeTooltipLabel: '',
	      activeTooltipCoord: { x: 0, y: 0 },
	      activeTooltipPayload: [],
	      isTooltipActive: false
	    }, _this.handleMouseEnter = function (el) {
	      var children = _this.props.children;
	      var cx = el.cx,
	          cy = el.cy,
	          outerRadius = el.outerRadius,
	          midAngle = el.midAngle;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: true,
	          activeTooltipCoord: (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, midAngle),
	          activeTooltipPayload: [el]
	        });
	      }
	    }, _this.handleMouseLeave = function () {
	      var children = _this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: false
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PieChart, [{
	    key: 'renderLegend',
	
	    /**
	     * Draw legend
	     * @param  {Array} items             The instances of Pie
	     * @return {ReactElement}            The instance of Legend
	     */
	    value: function renderLegend(items) {
	      var _props = this.props,
	          children = _props.children,
	          allComposedData = _props.allComposedData;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	      if (!legendItem) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height,
	          margin = _props2.margin;
	
	      var legendData = legendItem.props && legendItem.props.payload || items.reduce(function (result, child, i) {
	        var nameKey = child.props.nameKey;
	
	        var data = allComposedData[i];
	
	        return result.concat(data.map(function (entry) {
	          return {
	            type: legendItem.props.iconType || child.props.legendType,
	            value: entry[nameKey],
	            color: entry.fill,
	            payload: entry
	          };
	        }));
	      }, []);
	
	      return _react2.default.cloneElement(legendItem, _extends({}, _Legend2.default.getWithHeight(legendItem, width), {
	        payload: legendData,
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin
	      }));
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          width = _props3.width,
	          height = _props3.height;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeTooltipLabel = _state.activeTooltipLabel,
	          activeTooltipCoord = _state.activeTooltipCoord,
	          activeTooltipPayload = _state.activeTooltipPayload;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: activeTooltipLabel,
	        payload: activeTooltipPayload,
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw the main part of bar chart
	     * @param  {Array} items    All the instance of Pie
	     * @return {ReactComponent} All the instance of Pie
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          margin = _props4.margin,
	          allComposedData = _props4.allComposedData,
	          onMouseEnter = _props4.onMouseEnter,
	          onMouseLeave = _props4.onMouseLeave,
	          onClick = _props4.onClick;
	
	
	      return items.map(function (child, i) {
	        var _child$props = child.props,
	            innerRadius = _child$props.innerRadius,
	            outerRadius = _child$props.outerRadius,
	            childOnMouseEnter = _child$props.onMouseEnter,
	            childOnMouseLeave = _child$props.onMouseLeave,
	            childOnClick = _child$props.onClick;
	
	        var cx = (0, _DataUtils.getPercentValue)(child.props.cx, width, width / 2);
	        var cy = (0, _DataUtils.getPercentValue)(child.props.cy, height, height / 2);
	        var maxRadius = (0, _PolarUtils.getMaxRadius)(width, height, margin);
	
	        return _react2.default.cloneElement(child, {
	          key: child.key || 'recharts-pie-' + i,
	          cx: cx,
	          cy: cy,
	          maxRadius: child.props.maxRadius || Math.sqrt(width * width + height * height) / 2,
	          innerRadius: (0, _DataUtils.getPercentValue)(innerRadius, maxRadius, 0),
	          outerRadius: (0, _DataUtils.getPercentValue)(outerRadius, maxRadius, maxRadius * 0.8),
	          composedData: allComposedData[i],
	          onMouseEnter: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
	          onMouseLeave: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
	          onClick: (0, _DataUtils.combineEventHandlers)(null, onClick, childOnClick)
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          style = _props5.style,
	          children = _props5.children,
	          className = _props5.className,
	          width = _props5.width,
	          height = _props5.height,
	          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);
	
	      var items = (0, _ReactUtils.findAllByType)(children, _Pie2.default);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderItems(items),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(items),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return PieChart;
	}(_react.Component), _class2.displayName = 'PieChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	  title: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  style: {},
	  margin: { top: 0, right: 0, bottom: 0, left: 0 }
	}, _temp2)) || _class);
	exports.default = PieChart;

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar Chart
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(101);
	
	var _rechartsScale = __webpack_require__(605);
	
	var _Surface = __webpack_require__(88);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Legend = __webpack_require__(116);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Radar = __webpack_require__(617);
	
	var _Radar2 = _interopRequireDefault(_Radar);
	
	var _PolarGrid = __webpack_require__(615);
	
	var _PolarGrid2 = _interopRequireDefault(_PolarGrid);
	
	var _PolarAngleAxis = __webpack_require__(614);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(616);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DOMUtils = __webpack_require__(178);
	
	var _PolarUtils = __webpack_require__(89);
	
	var _DataUtils = __webpack_require__(14);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _AnimationDecorator = __webpack_require__(138);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadarChart = (0, _AnimationDecorator2.default)(_class = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadarChart, _Component);
	
	  function RadarChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadarChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadarChart.__proto__ || Object.getPrototypeOf(RadarChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (itemProps, e) {
	      var children = _this.props.children;
	      var points = itemProps.points;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem && points.length) {
	        var container = _this.container;
	        var containerOffset = (0, _DOMUtils.getOffset)(container);
	        var ne = (0, _DOMUtils.calculateChartCoordinate)(e, containerOffset);
	
	        _this.setState({
	          isTooltipActive: true,
	          activeTooltipLabel: itemProps.name || itemProps.dataKey,
	          activeTooltipCoord: { x: ne.chartX, y: ne.chartY },
	          activeTooltipPayload: _this.getTooltipContent(itemProps)
	        });
	      }
	    }, _this.handleMouseLeave = function () {
	      var children = _this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: false
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadarChart, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent(itemProps) {
	      var points = itemProps.points,
	          dataKey = itemProps.dataKey,
	          unit = itemProps.unit;
	
	
	      return points.map(function (entry) {
	        var name = entry.name,
	            value = entry.value,
	            payload = entry.payload;
	
	
	        return _extends({}, (0, _ReactUtils.getPresentationAttributes)(itemProps), {
	          dataKey: dataKey, unit: unit, name: name, value: value, payload: payload
	        });
	      });
	    }
	  }, {
	    key: 'getRadiusAxisCfg',
	    value: function getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius) {
	      var props = radiusAxis ? radiusAxis.props : _PolarRadiusAxis2.default.defaultProps;
	      var domain = void 0,
	          tickCount = void 0,
	          ticks = void 0;
	
	      if (radiusAxis && radiusAxis.props.ticks) {
	        ticks = radiusAxis.props.ticks;
	
	        tickCount = ticks.length;
	        domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	      } else {
	        tickCount = Math.max(radiusAxis && radiusAxis.props.tickCount || _PolarRadiusAxis2.default.defaultProps.tickCount, 2);
	        ticks = this.getTicksByItems(radiusAxis, tickCount);
	
	        domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	      }
	
	      return {
	        tickCount: tickCount,
	        ticks: ticks,
	        scale: (0, _DataUtils.parseScale)(props).domain(domain).range([innerRadius, outerRadius])
	      };
	    }
	  }, {
	    key: 'getTicksByItems',
	    value: function getTicksByItems(axisItem, tickCount) {
	      var _props = this.props,
	          data = _props.data,
	          children = _props.children;
	
	      var _ref2 = axisItem ? axisItem.props : _PolarRadiusAxis2.default.defaultProps,
	          domain = _ref2.domain,
	          allowDataOverflow = _ref2.allowDataOverflow;
	
	      var radarItems = (0, _ReactUtils.findAllByType)(children, _Radar2.default);
	      var dataKeys = radarItems.map(function (item) {
	        return item.props.dataKey;
	      });
	      var extent = data.reduce(function (prev, current) {
	        var values = dataKeys.map(function (v) {
	          return (0, _DataUtils.getValueByDataKey)(current, v, 0);
	        });
	        var currentMax = Math.max.apply(null, values);
	        var currentMin = Math.min.apply(null, values);
	
	        return [Math.min(prev[0], currentMin), Math.max(prev[1], currentMax)];
	      }, [Infinity, -Infinity]);
	      var finalDomain = (0, _DataUtils.parseSpecifiedDomain)(domain, extent, allowDataOverflow);
	
	      if (domain && (domain[0] === 'auto' || domain[1] === 'auto')) {
	        return (0, _rechartsScale.getNiceTickValues)(finalDomain, tickCount);
	      }
	
	      return finalDomain;
	    }
	  }, {
	    key: 'getGridRadius',
	    value: function getGridRadius(gridCount, innerRadius, outerRadius) {
	      var domain = (0, _range3.default)(0, gridCount);
	      var scale = (0, _d3Scale.scalePoint)().domain(domain).range([innerRadius, outerRadius]);
	
	      return domain.map(function (v) {
	        return scale(v);
	      });
	    }
	  }, {
	    key: 'getAngle',
	    value: function getAngle(index, dataLength, startAngle, clockWise) {
	      var sign = clockWise ? -1 : 1;
	      var angleInterval = 360 / dataLength;
	
	      return startAngle + index * sign * angleInterval;
	    }
	  }, {
	    key: 'getAngleTicks',
	    value: function getAngleTicks(dataLength, startAngle, clockWise) {
	      var angles = [];
	
	      for (var i = 0; i < dataLength; i++) {
	        angles.push(this.getAngle(i, dataLength, startAngle, clockWise));
	      }
	
	      return angles;
	    }
	  }, {
	    key: 'getRadiusTicks',
	    value: function getRadiusTicks(axisCfg) {
	      var ticks = axisCfg.ticks,
	          scale = axisCfg.scale;
	
	
	      if (ticks && ticks.length) {
	        return ticks.map(function (entry) {
	          return {
	            radius: scale(entry),
	            value: entry
	          };
	        });
	      }
	      var tickCount = axisCfg.tickCount;
	
	      var domain = scale.domain();
	
	      return (0, _range3.default)(0, tickCount).map(function (v, i) {
	        var value = domain[0] + i * (domain[1] - domain[0]) / (tickCount - 1);
	        return {
	          value: value,
	          radius: scale(value)
	        };
	      });
	    }
	  }, {
	    key: 'getComposedData',
	    value: function getComposedData(item, scale, cx, cy) {
	      var _this2 = this;
	
	      var dataKey = item.props.dataKey;
	      var _props2 = this.props,
	          data = _props2.data,
	          startAngle = _props2.startAngle,
	          clockWise = _props2.clockWise,
	          children = _props2.children;
	
	      var angleAxis = (0, _ReactUtils.findChildByType)(children, _PolarAngleAxis2.default);
	      var nameKey = angleAxis && angleAxis.props.dataKey;
	      var len = data.length;
	
	      return data.map(function (entry, i) {
	        var value = (0, _DataUtils.getValueByDataKey)(entry, dataKey, 0);
	        var angle = _this2.getAngle(i, len, startAngle, clockWise);
	        var radius = scale(value);
	
	        return _extends({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	          value: value,
	          name: nameKey ? entry[nameKey] || i : i,
	          cx: cx, cy: cy, radius: radius, angle: angle,
	          payload: entry
	        });
	      });
	    }
	    /**
	     * Returns default, reset state for the radar chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        activeTooltipLabel: '',
	        activeTooltipCoord: { x: 0, y: 0 },
	        isTooltipActive: false
	      };
	    }
	  }, {
	    key: 'renderRadars',
	    value: function renderRadars(items, scale, cx, cy) {
	      var _this3 = this;
	
	      if (!items || !items.length) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onClick = _props3.onClick;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return items.map(function (el, index) {
	        return _react2.default.cloneElement(el, _extends({}, baseProps, (0, _ReactUtils.getPresentationAttributes)(el), {
	          animationId: _this3.props.animationId,
	          points: _this3.getComposedData(el, scale, cx, cy),
	          key: el.key || 'radar-' + index,
	          onMouseEnter: (0, _DataUtils.combineEventHandlers)(_this3.handleMouseEnter, onMouseEnter, el.props.onMouseEnter),
	          onMouseLeave: (0, _DataUtils.combineEventHandlers)(_this3.handleMouseLeave, onMouseLeave, el.props.onMouseLeave),
	          onClick: (0, _DataUtils.combineEventHandlers)(null, onClick, el.props.onClick)
	        }));
	      });
	    }
	  }, {
	    key: 'renderGrid',
	    value: function renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius) {
	      var children = this.props.children;
	
	      var grid = (0, _ReactUtils.findChildByType)(children, _PolarGrid2.default);
	
	      if (!grid) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          startAngle = _props4.startAngle,
	          clockWise = _props4.clockWise,
	          data = _props4.data;
	
	      var len = data.length;
	      var gridCount = radiusAxisCfg.tickCount;
	
	      return _react2.default.cloneElement(grid, {
	        polarAngles: this.getAngleTicks(len, startAngle, clockWise),
	        polarRadius: this.getGridRadius(gridCount, innerRadius, outerRadius),
	        cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	        key: 'layer-grid'
	      });
	    }
	  }, {
	    key: 'renderAngleAxis',
	    value: function renderAngleAxis(cx, cy, outerRadius, maxRadius) {
	      var _this4 = this;
	
	      var children = this.props.children;
	
	      var angleAxis = (0, _ReactUtils.findChildByType)(children, _PolarAngleAxis2.default);
	
	      if (!angleAxis || angleAxis.props.hide) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          data = _props5.data,
	          startAngle = _props5.startAngle,
	          clockWise = _props5.clockWise;
	
	      var len = data.length;
	      var grid = (0, _ReactUtils.findChildByType)(children, _PolarGrid2.default);
	      var radius = (0, _DataUtils.getPercentValue)(angleAxis.props.radius, maxRadius, outerRadius);
	      var dataKey = angleAxis.props.dataKey;
	
	
	      return _react2.default.cloneElement(angleAxis, {
	        ticks: data.map(function (v, i) {
	          return {
	            value: (0, _DataUtils.getValueByDataKey)(v, dataKey, i),
	            angle: _this4.getAngle(i, len, startAngle, clockWise)
	          };
	        }),
	        cx: cx, cy: cy, radius: radius,
	        axisLineType: grid && grid.props && grid.props.gridType || _PolarGrid2.default.defaultProps.gridType,
	        key: 'layer-angle-axis'
	      });
	    }
	  }, {
	    key: 'renderRadiusAxis',
	    value: function renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy) {
	      if (!radiusAxis || radiusAxis.props.hide) {
	        return null;
	      }
	
	      var startAngle = this.props.startAngle;
	
	      return _react2.default.cloneElement(radiusAxis, {
	        angle: radiusAxis.props.angle || startAngle,
	        ticks: this.getRadiusTicks(radiusAxisCfg),
	        cx: cx, cy: cy
	      });
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeTooltipLabel = _state.activeTooltipLabel,
	          activeTooltipCoord = _state.activeTooltipCoord,
	          activeTooltipPayload = _state.activeTooltipPayload;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: activeTooltipLabel,
	        payload: activeTooltipPayload,
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw legend
	     * @param  {Array} items             The instances of item
	     * @return {ReactElement}            The instance of Legend
	     */
	
	  }, {
	    key: 'renderLegend',
	    value: function renderLegend(items) {
	      var children = this.props.children;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	      if (!legendItem) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          margin = _props7.margin;
	
	      var legendData = legendItem.props && legendItem.props.payload || items.map(function (child) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            name = _child$props.name,
	            legendType = _child$props.legendType;
	
	
	        return {
	          dataKey: dataKey,
	          type: legendItem.props.iconType || legendType || 'square',
	          color: child.props.stroke || child.props.fill,
	          value: name || dataKey,
	          payload: child.props
	        };
	      }, this);
	
	      return _react2.default.cloneElement(legendItem, _extends({}, _Legend2.default.getWithHeight(legendItem, width), {
	        payload: legendData,
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props8 = this.props,
	          className = _props8.className,
	          data = _props8.data,
	          width = _props8.width,
	          height = _props8.height,
	          margin = _props8.margin,
	          children = _props8.children,
	          style = _props8.style,
	          others = _objectWithoutProperties(_props8, ['className', 'data', 'width', 'height', 'margin', 'children', 'style']);
	
	      var cx = (0, _DataUtils.getPercentValue)(this.props.cx, width, width / 2);
	      var cy = (0, _DataUtils.getPercentValue)(this.props.cy, height, height / 2);
	      var maxRadius = (0, _PolarUtils.getMaxRadius)(width, height, margin);
	      var innerRadius = (0, _DataUtils.getPercentValue)(this.props.innerRadius, maxRadius, 0);
	      var outerRadius = (0, _DataUtils.getPercentValue)(this.props.outerRadius, maxRadius, maxRadius * 0.8);
	
	      if (outerRadius <= 0 || !data || !data.length) {
	        return null;
	      }
	
	      var items = (0, _ReactUtils.findAllByType)(children, _Radar2.default);
	      var radiusAxis = (0, _ReactUtils.findChildByType)(children, _PolarRadiusAxis2.default);
	      var radiusAxisCfg = this.getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height }),
	          ref: function ref(node) {
	            _this5.container = node;
	          }
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius),
	          this.renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy),
	          this.renderAngleAxis(cx, cy, outerRadius, maxRadius),
	          this.renderRadars(items, radiusAxisCfg.scale, cx, cy),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(items),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return RadarChart;
	}(_react.Component), _class2.displayName = 'RadarChart', _class2.propTypes = {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	
	  cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  startAngle: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  clockWise: _propTypes2.default.bool,
	
	  data: _propTypes2.default.array,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  animationId: _propTypes2.default.number,
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  width: 0,
	  height: 0,
	  cx: '50%',
	  cy: '50%',
	  innerRadius: 0,
	  outerRadius: '80%',
	
	  startAngle: 90,
	  clockWise: true,
	  data: [],
	  margin: { top: 0, right: 0, bottom: 0, left: 0 }
	}, _temp2)) || _class) || _class;
	
	exports.default = RadarChart;

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(51);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar Bar Chart
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(101);
	
	var _Surface = __webpack_require__(88);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _RadialBar = __webpack_require__(618);
	
	var _RadialBar2 = _interopRequireDefault(_RadialBar);
	
	var _DataUtils = __webpack_require__(14);
	
	var _Cell = __webpack_require__(176);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _Legend = __webpack_require__(116);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _PolarUtils = __webpack_require__(89);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadialBarChart = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadialBarChart, _Component);
	
	  function RadialBarChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadialBarChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBarChart.__proto__ || Object.getPrototypeOf(RadialBarChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (el) {
	      var children = _this.props.children;
	      var cx = el.cx,
	          cy = el.cy,
	          endAngle = el.endAngle,
	          outerRadius = el.outerRadius;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: true,
	          activeTooltipCoord: (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, endAngle),
	          activeTooltipPayload: [el.payload]
	        });
	      }
	    }, _this.handleMouseLeave = function () {
	      var children = _this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: false
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadialBarChart, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	    /**
	     * Compose the data of each group
	     * @param  {Object} item        An instance of RadialBar
	     * @param  {Array}  barPosition The offset and size of each bar
	     * @param  {Object} radiusScale The scale function of radius of bars
	     * @param  {Object} center      The coordinate of center
	     * @param  {String} dataKey     The unique key of a group
	     * @return {Array}              Composed data
	     */
	
	  }, {
	    key: 'getComposedData',
	    value: function getComposedData(item, barPosition, radiusScale, center, dataKey) {
	      var data = this.props.data;
	
	      var pos = (0, _DataUtils.findPositionOfBar)(barPosition, item);
	      var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell2.default);
	
	      return data.map(function (entry, index) {
	        var value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	        var radius = radiusScale(index);
	
	        return _extends({}, entry, center, {
	          value: value,
	          innerRadius: radius - pos.offset,
	          outerRadius: radius - pos.offset + pos.radius,
	          payload: entry
	        }, cells && cells[index] && cells[index].props);
	      });
	    }
	    /**
	     * Calculate the size of all groups
	     * @param  {Array} items All the instance of RadialBar
	     * @return {Object} The size of all groups
	     */
	
	  }, {
	    key: 'getRadiusList',
	    value: function getRadiusList(items) {
	      var barSize = this.props.barSize;
	
	
	      return items.map(function (child) {
	        return _extends({}, child.props, {
	          item: child,
	          barSize: child.props.barSize || barSize
	        });
	      });
	    }
	
	    /**
	     * Calculate the scale function of radius
	     * @param {Number} innerRadius The outer radius
	     * @param {Number} outerRadius The inner radius
	     * @return {Object}            A scale function
	     */
	
	  }, {
	    key: 'getRadiusScale',
	    value: function getRadiusScale(innerRadius, outerRadius) {
	      var data = this.props.data;
	
	      var bandCount = Math.max(data.length, 1);
	      var range = [outerRadius, innerRadius];
	      var scale = (0, _d3Scale.scaleBand)().domain((0, _range3.default)(0, bandCount)).range(range);
	
	      return scale;
	    }
	
	    /**
	     * Calculate the size of each bar and the gap between two bars
	     * @param  {Number} bandRadius  The radius of each category
	     * @param  {Array} radiusList   The radius of all groups
	     * @return {Number} The size of each bar and the gap between two bars
	     */
	
	  }, {
	    key: 'getBarPosition',
	    value: function getBarPosition(bandRadius, radiusList) {
	      var _props = this.props,
	          barGap = _props.barGap,
	          barCategoryGap = _props.barCategoryGap;
	
	      var len = radiusList.length;
	      var result = void 0;
	
	      // whether or not is barSize setted by user
	      if (len && radiusList[0].barSize === +radiusList[0].barSize) {
	        var sum = radiusList.reduce(function (res, entry) {
	          return res + entry.barSize;
	        }, 0);
	        sum += (len - 1) * barGap;
	        var offset = -sum / 2 >> 0;
	        var prev = { offset: offset - barGap, radius: 0 };
	
	        result = radiusList.reduce(function (res, entry) {
	          prev = {
	            offset: prev.offset + prev.radius + barGap,
	            radius: entry.barSize
	          };
	
	          return [].concat(_toConsumableArray(res), [{ item: entry.item, position: prev }]);
	        }, []);
	      } else {
	        var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandRadius);
	        var radius = (bandRadius - 2 * _offset - (len - 1) * barGap) / len >> 0;
	        _offset = -Math.max((radius * len + (len - 1) * barGap) / 2 >> 0, 0);
	
	        result = radiusList.reduce(function (res, entry, i) {
	          return [].concat(_toConsumableArray(res), [{
	            item: entry.item,
	            position: {
	              offset: _offset + (radius + barGap) * i,
	              radius: radius
	            }
	          }]);
	        }, []);
	      }
	
	      return result;
	    }
	    /**
	     * Returns default, reset state for the radial bar chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        activeTooltipLabel: '',
	        activeTooltipPayload: [],
	        activeTooltipCoord: { x: 0, y: 0 },
	        isTooltipActive: false
	      };
	    }
	  }, {
	    key: 'renderLegend',
	
	
	    /**
	     * Draw legend
	     * @param  {ReactElement} legendItem The instance of Legend
	     * @return {ReactElement}            The instance of Legend
	     */
	    value: function renderLegend() {
	      var children = this.props.children;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	      if (!legendItem) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          data = _props2.data,
	          width = _props2.width,
	          height = _props2.height,
	          margin = _props2.margin;
	
	
	      var legendData = legendItem.props && legendItem.props.payload || data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || 'square',
	          color: entry.fill || '#000',
	          value: entry.name,
	          payload: entry
	        };
	      });
	
	      return _react2.default.cloneElement(legendItem, _extends({}, _Legend2.default.getWithHeight(legendItem, width), {
	        payload: legendData,
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin
	      }));
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          width = _props3.width,
	          height = _props3.height;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeTooltipLabel = _state.activeTooltipLabel,
	          activeTooltipCoord = _state.activeTooltipCoord,
	          activeTooltipPayload = _state.activeTooltipPayload;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: activeTooltipLabel,
	        payload: activeTooltipPayload,
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw the main part of bar chart
	     * @param  {Array} items     All the instance of RadialBar
	     * @param  {Object} radiusScale The scale function of radius of bars
	     * @param  {Object} center      The coordinate of center
	     * @return {ReactComponent}  All the instances of RadialBar
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, radiusScale, center) {
	      var _this2 = this;
	
	      if (!items || !items.length) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          onMouseEnter = _props4.onMouseEnter,
	          onMouseLeave = _props4.onMouseLeave,
	          onClick = _props4.onClick;
	
	      var radiusList = this.getRadiusList(items);
	      var bandRadius = radiusScale.bandwidth();
	      var barPosition = this.getBarPosition(bandRadius, radiusList);
	
	      return items.map(function (child, i) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            childOnMouseEnter = _child$props.onMouseEnter,
	            childOnMouseLeave = _child$props.onMouseLeave,
	            childOnClick = _child$props.onClick;
	
	
	        return _react2.default.cloneElement(child, _extends({}, center, {
	          key: child.key || 'radial-bar-' + i,
	          onMouseEnter: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
	          onMouseLeave: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
	          onClick: (0, _DataUtils.combineEventHandlers)(null, onClick, childOnClick),
	          data: _this2.getComposedData(child, barPosition, radiusScale, center, dataKey)
	        }));
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      if (!(0, _ReactUtils.validateWidthHeight)(this) || !data || !data.length) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          style = _props5.style,
	          children = _props5.children,
	          className = _props5.className,
	          width = _props5.width,
	          height = _props5.height,
	          margin = _props5.margin,
	          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height', 'margin']);
	
	      var items = (0, _ReactUtils.findAllByType)(children, _RadialBar2.default);
	      var cx = (0, _DataUtils.getPercentValue)(this.props.cx, width, width / 2);
	      var cy = (0, _DataUtils.getPercentValue)(this.props.cy, height, height / 2);
	      var maxRadius = (0, _PolarUtils.getMaxRadius)(width, height, margin);
	      var innerRadius = (0, _DataUtils.getPercentValue)(this.props.innerRadius, maxRadius, 0);
	      var outerRadius = (0, _DataUtils.getPercentValue)(this.props.outerRadius, maxRadius, maxRadius * 0.8);
	      var radiusScale = this.getRadiusScale(innerRadius, outerRadius);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { cursor: 'default', position: 'relative', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderItems(items, radiusScale, { cx: cx, cy: cy }),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(),
	        this.renderTooltip(items)
	      );
	    }
	  }]);
	
	  return RadialBarChart;
	}(_react.Component), _class2.displayName = 'RadialBarChart', _class2.propTypes = {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	  cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  data: _propTypes2.default.array,
	  innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  // The offset radius between two categorys
	  barCategoryGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  // The gap radius of two radial bar in one category
	  barGap: _propTypes2.default.number,
	  // The radius of each radial bar
	  barSize: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string
	}, _class2.defaultProps = {
	  cx: '50%',
	  cy: '50%',
	  innerRadius: '30%',
	  outerRadius: '90%',
	  barGap: 2,
	  barCategoryGap: '10%',
	  style: {},
	  margin: { top: 0, right: 0, bottom: 0, left: 0 }
	}, _temp2)) || _class;
	
	exports.default = RadialBarChart;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _sumBy2 = __webpack_require__(290);
	
	var _sumBy3 = _interopRequireDefault(_sumBy2);
	
	var _min2 = __webpack_require__(129);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _maxBy2 = __webpack_require__(208);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @file TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(88);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultCoordinateOfTooltip = { x: 0, y: 0 };
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return { sourceNodes: sourceNodes, sourceLinks: sourceLinks, targetLinks: targetLinks, targetNodes: targetNodes };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	
	    return _extends({}, entry, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	  var maxDepth = (0, _maxBy3.default)(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return { tree: tree, maxDepth: maxDepth };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min3.default)(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy3.default)(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _extends({}, link, { dy: getValue(link) * yRatio });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length;
	
	    // Sort by the value of y
	    nodes.sort(ascendingY);
	
	    var y0 = 0;
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	
	  resolveCollisions(depthTree, height, nodePadding);
	
	  var alpha = 1;
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	
	    resolveCollisions(depthTree, height, nodePadding);
	
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	
	  return { nodes: tree, links: newLinks };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return { x: el.x + el.width / 2, y: el.y + el.height / 2 };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _DataUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _DataUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	  if (payload.source && payload.target) {
	    var sourceName = (0, _DataUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _DataUtils.getValueByDataKey)(payload.target, nameKey, '');
	
	    return [{
	      payload: el,
	      name: sourceName + ' - ' + targetName,
	      value: (0, _DataUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey(props) {
	    _classCallCheck(this, Sankey);
	
	    var _this = _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).call(this, props));
	
	    _this.state = _this.createDefaultState(props);
	    return _this;
	  }
	
	  _createClass(Sankey, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          iterations = _props.iterations,
	          nodeWidth = _props.nodeWidth,
	          nodePadding = _props.nodePadding,
	          nameKey = _props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _PureRender.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.createDefaultState(this.props));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations, nodeWidth: nodeWidth, nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes, links: links
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(el, type, e) {
	      var _props2 = this.props,
	          onMouseEnter = _props2.onMouseEnter,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(el, type, e) {
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          children = _props3.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: 'renderLinkItem',
	    value: function renderLinkItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth']);
	
	      return _react2.default.createElement('path', _extends({
	        className: 'recharts-sankey-link',
	        d: '\n          M' + sourceX + ',' + sourceY + '\n          C' + sourceControlX + ',' + sourceY + ' ' + targetControlX + ',' + targetY + ' ' + targetX + ',' + targetY + '\n        ',
	        fill: 'none',
	        stroke: '#333',
	        strokeWidth: linkWidth,
	        strokeOpacity: '0.2'
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: 'renderLinks',
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          linkCurvature = _props4.linkCurvature,
	          linkContent = _props4.link,
	          margin = _props4.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-links', key: 'recharts-sankey-links' },
	        links.map(function (link, i) {
	          var sourceRelativeY = link.sy,
	              targetRelativeY = link.ty,
	              linkWidth = link.dy;
	
	          var source = nodes[link.source];
	          var target = nodes[link.target];
	          var sourceX = source.x + source.dx + left;
	          var targetX = target.x + left;
	          var interpolationFunc = interpolationGenerator(sourceX, targetX);
	          var sourceControlX = interpolationFunc(linkCurvature);
	          var targetControlX = interpolationFunc(1 - linkCurvature);
	          var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	          var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	          var linkProps = _extends({
	            sourceX: sourceX, targetX: targetX,
	            sourceY: sourceY, targetY: targetY,
	            sourceControlX: sourceControlX, targetControlX: targetControlX,
	            sourceRelativeY: sourceRelativeY, targetRelativeY: targetRelativeY,
	            linkWidth: linkWidth,
	            index: i,
	            payload: _extends({}, link, { source: source, target: target })
	          }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	          var events = {
	            onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	            onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'link' + i }, events),
	            _this2.renderLinkItem(linkContent, linkProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderNodeItem',
	    value: function renderNodeItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        className: 'recharts-sankey-node',
	        fill: '#0088fe',
	        fillOpacity: '0.8'
	      }, props));
	    }
	  }, {
	    key: 'renderNodes',
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          nodeContent = _props5.node,
	          margin = _props5.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-nodes', key: 'recharts-sankey-nodes' },
	        nodes.map(function (node, i) {
	          var x = node.x,
	              y = node.y,
	              dx = node.dx,
	              dy = node.dy;
	
	          var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	            x: x + left,
	            y: y + top,
	            width: dx,
	            height: dy,
	            index: i,
	            payload: node
	          });
	          var events = {
	            onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	            onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'node' + i }, events),
	            _this3.renderNodeItem(nodeContent, nodeProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props6 = this.props,
	          children = _props6.children,
	          width = _props6.width,
	          height = _props6.height,
	          nameKey = _props6.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeElement = _state.activeElement,
	          activeElementType = _state.activeElementType;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var _state2 = this.state,
	          links = _state2.links,
	          nodes = _state2.nodes;
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          (0, _ReactUtils.filterSvgElements)(children),
	          this.renderLinks(links, nodes),
	          this.renderNodes(nodes)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component), _class2.displayName = 'Sankey', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.shape({
	    nodes: _propTypes2.default.array,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      target: _propTypes2.default.number,
	      source: _propTypes2.default.number,
	      value: _propTypes2.default.number
	    }))
	  }),
	
	  nodePadding: _propTypes2.default.number,
	  nodeWidth: _propTypes2.default.number,
	  linkCurvature: _propTypes2.default.number,
	  iterations: _propTypes2.default.number,
	
	  node: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  link: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  })
	}), _class2.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: { top: 5, right: 5, bottom: 5, left: 5 }
	}, _temp)) || _class;
	
	exports.default = Sankey;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Scatter Chart
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(88);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Cell = __webpack_require__(176);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _Legend = __webpack_require__(116);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Cross = __webpack_require__(619);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _CartesianAxis = __webpack_require__(354);
	
	var _CartesianAxis2 = _interopRequireDefault(_CartesianAxis);
	
	var _CartesianGrid = __webpack_require__(355);
	
	var _CartesianGrid2 = _interopRequireDefault(_CartesianGrid);
	
	var _Scatter = __webpack_require__(608);
	
	var _Scatter2 = _interopRequireDefault(_Scatter);
	
	var _XAxis = __webpack_require__(357);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(358);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _ZAxis = __webpack_require__(609);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _ReferenceLine = __webpack_require__(237);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceDot = __webpack_require__(236);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceArea = __webpack_require__(235);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(14);
	
	var _LogUtils = __webpack_require__(362);
	
	var _CartesianUtils = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScatterChart = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(ScatterChart, _Component);
	
	  function ScatterChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScatterChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScatterChart.__proto__ || Object.getPrototypeOf(ScatterChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      activeTooltipCoord: { x: 0, y: 0 },
	      isTooltipActive: false,
	      activeItem: null
	    }, _this.handleLegendBBoxUpdate = function (box) {
	      if (box && _this.legendInstance) {
	        _this.forceUpdate();
	      }
	    }, _this.handleScatterMouseEnter = function (el) {
	      _this.setState({
	        isTooltipActive: true,
	        activeItem: el,
	        activeTooltipCoord: { x: el.cx, y: el.cy }
	      });
	    }, _this.handleScatterMouseLeave = function () {
	      _this.setState({
	        isTooltipActive: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScatterChart, [{
	    key: 'getComposedData',
	
	    /**
	     * Compose the data of each group
	     * @param  {Object} item        An instance of Scatter
	     * @param  {Array}  data        The original data
	     * @param  {Object} xAxis       The configuration of x-axis
	     * @param  {Object} yAxis       The configuration of y-axis
	     * @param  {Object} zAxis       The configuration of z-axis
	     * @return {Array} Composed data
	     */
	    value: function getComposedData(item, data, xAxis, yAxis, zAxis) {
	      var children = item.props.children;
	
	      var xAxisDataKey = xAxis.dataKey;
	      var yAxisDataKey = yAxis.dataKey;
	      var zAxisDataKey = zAxis.dataKey;
	      var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	      return data.map(function (entry, index) {
	        return _extends({}, entry, {
	          cx: (0, _DataUtils.isNumber)(entry[xAxisDataKey]) ? xAxis.scale(entry[xAxisDataKey]) : null,
	          cy: (0, _DataUtils.isNumber)(entry[yAxisDataKey]) ? yAxis.scale(entry[yAxisDataKey]) : null,
	          size: zAxisDataKey !== undefined && (0, _DataUtils.isNumber)(entry[zAxisDataKey]) ? zAxis.scale(entry[zAxisDataKey]) : zAxis.range[0],
	          node: {
	            x: entry[xAxisDataKey],
	            y: entry[yAxisDataKey],
	            z: zAxisDataKey !== undefined && entry[zAxisDataKey] || '-'
	          },
	          payload: entry
	        }, cells && cells[index] && cells[index].props);
	      });
	    }
	  }, {
	    key: 'getDomain',
	    value: function getDomain(items, dataKey, axisId, axisType) {
	      var domain = items.reduce(function (result, item) {
	        return result.concat(item.props.data.map(function (entry) {
	          return (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	        }));
	      }, []);
	
	      if (axisType === 'xAxis' || axisType === 'yAxis') {
	        domain = (0, _CartesianUtils.detectReferenceElementsDomain)(this.props.children, domain, axisId, axisType);
	      }
	
	      return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
	    }
	
	    /**
	     * Get the configuration of x-axis or y-axis
	     * @param  {String} axisType The type of axis
	     * @param  {Array} items     The instances of item
	     * @return {Object}          Configuration
	     */
	
	  }, {
	    key: 'getAxis',
	    value: function getAxis() {
	      var axisType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xAxis';
	      var items = arguments[1];
	      var children = this.props.children;
	
	      var Axis = axisType === 'xAxis' ? _XAxis2.default : _YAxis2.default;
	      var axis = (0, _ReactUtils.findChildByType)(children, Axis);
	
	      (0, _LogUtils.warn)(axis, 'recharts: ScatterChart must has %s', Axis.displayName);
	
	      if (axis) {
	        var domain = (0, _DataUtils.parseSpecifiedDomain)(axis.props.domain, this.getDomain(items, axis.props.dataKey, axis.props[axisType + 'Id'], axisType), axis.props.allowDataOverflow);
	
	        return _extends({}, axis.props, {
	          axisType: axisType,
	          domain: domain,
	          type: 'number',
	          originalDomain: axis.props.domain
	        });
	      }
	
	      return null;
	    }
	
	    /**
	     * Get the configuration of z-axis
	     * @param  {Array} items The instances of item
	     * @return {Object}      Configuration
	     */
	
	  }, {
	    key: 'getZAxis',
	    value: function getZAxis(items) {
	      var children = this.props.children;
	
	      var axisItem = (0, _ReactUtils.findChildByType)(children, _ZAxis2.default);
	      var axisProps = axisItem && axisItem.props || _ZAxis2.default.defaultProps;
	      var domain = axisProps.dataKey ? this.getDomain(items, axisProps.dataKey) : [-1, 1];
	
	      return _extends({}, axisProps, {
	        domain: domain,
	        scale: (0, _DataUtils.parseScale)(axisProps).domain(domain).range(axisProps.range)
	      });
	    }
	  }, {
	    key: 'getOffset',
	    value: function getOffset(items, xAxis, yAxis) {
	      var _props = this.props,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          children = _props.children;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	      var offset = {
	        left: margin.left || 0, right: margin.right || 0,
	        top: margin.top || 0, bottom: margin.bottom || 0
	      };
	
	      if (!xAxis.hide && !xAxis.mirror) {
	        offset[xAxis.orientation] += xAxis.height;
	      }
	      if (!yAxis.hide && !yAxis.mirror) {
	        offset[yAxis.orientation] += yAxis.width;
	      }
	
	      if (legendItem && this.legendInstance) {
	        var legendBox = this.legendInstance.getBBox();
	        offset = (0, _CartesianUtils.appendOffsetOfLegend)(offset, items, this.props, legendBox);
	      }
	
	      return _extends({}, offset, {
	        width: width - offset.left - offset.right,
	        height: height - offset.top - offset.bottom
	      });
	    }
	    /**
	     * Calculate the scale function, position, width, height of axes
	     * @param  {Object} axis     The configuration of axis
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @param  {Object} axisType The type of axis, x-axis or y-axis
	     * @return {Object} Configuration
	     */
	
	  }, {
	    key: 'getFormatAxis',
	    value: function getFormatAxis(axis, offset, axisType) {
	      var orientation = axis.orientation,
	          domain = axis.domain,
	          mirror = axis.mirror,
	          tickFormat = axis.tickFormat,
	          _axis$padding = axis.padding,
	          padding = _axis$padding === undefined ? {} : _axis$padding;
	
	      var position = {
	        left: offset.left,
	        right: offset.left + offset.width,
	        top: offset.top,
	        bottom: offset.top + offset.height
	      };
	      var range = axisType === 'xAxis' ? [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)] : [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)];
	
	      var scale = (0, _DataUtils.parseScale)(axis).domain(domain).range(range);
	      var ticks = (0, _CartesianUtils.getTicksOfScale)(scale, axis);
	      if (tickFormat) {
	        scale.tickFormat(tickFormat);
	      }
	
	      var x = void 0,
	          y = void 0;
	
	      if (axisType === 'xAxis') {
	        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        x = offset.left;
	        y = position[orientation] - needSpace * axis.height;
	      } else {
	        var _needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        x = position[orientation] - _needSpace * axis.width;
	        y = offset.top;
	      }
	
	      return _extends({}, axis, ticks, {
	        scale: scale,
	        width: axisType === 'xAxis' ? offset.width : axis.width,
	        height: axisType === 'yAxis' ? offset.height : axis.height,
	        x: x, y: y
	      });
	    }
	
	    /**
	     * Get the content to be displayed in the tooltip
	     * @param  {Object} data  The data of active item
	     * @param  {Object} xAxis The configuration of x-axis
	     * @param  {Object} yAxis The configuration of y-axis
	     * @param  {Object} zAxis The configuration of z-axis
	     * @return {Array}        The content of tooltip
	     */
	
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent(data, xAxis, yAxis, zAxis) {
	      if (!data) {
	        return null;
	      }
	
	      var payload = data.payload,
	          node = data.node;
	
	
	      var content = [{
	        name: xAxis.name || xAxis.dataKey,
	        unit: xAxis.unit || '',
	        value: node.x,
	        payload: payload
	      }, {
	        name: yAxis.name || yAxis.dataKey,
	        unit: yAxis.unit || '',
	        value: node.y,
	        payload: payload
	      }];
	
	      if (node.z && node.z !== '-') {
	        content.push({
	          name: zAxis.name || zAxis.dataKey,
	          unit: zAxis.unit || '',
	          value: node.z,
	          payload: payload
	        });
	      }
	
	      return content;
	    }
	    /**
	     * The handler of mouse entering a scatter
	     * @param {Object} el The active scatter
	     * @param {Object} e  Event object
	     * @return {Object} no return
	     */
	
	
	    /**
	     * The handler of mouse leaving a scatter
	     * @return {Object} no return
	     */
	
	  }, {
	    key: 'renderTooltip',
	
	
	    /**
	     * Draw Tooltip
	     * @param  {Array} items   The instances of Scatter
	     * @param  {Object} xAxis  The configuration of x-axis
	     * @param  {Object} yAxis  The configuration of y-axis
	     * @param  {Object} zAxis  The configuration of z-axis
	     * @param  {Object} offset The offset of main part in the svg element
	     * @return {ReactElement}  The instance of Tooltip
	     */
	    value: function renderTooltip(items, xAxis, yAxis, zAxis, offset) {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeItem = _state.activeItem,
	          activeTooltipCoord = _state.activeTooltipCoord;
	
	      var viewBox = {
	        x: offset.left,
	        y: offset.top,
	        width: offset.width,
	        height: offset.height
	      };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: '',
	        payload: this.getTooltipContent(activeItem, xAxis, yAxis, zAxis),
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw grid
	     * @param  {Object} xAxis  The configuration of x-axis
	     * @param  {Object} yAxis  The configuration of y-axis
	     * @param  {Object} offset The offset of main part in the svg element
	     * @return {ReactElement} The instance of grid
	     */
	
	  }, {
	    key: 'renderGrid',
	    value: function renderGrid(xAxis, yAxis, offset) {
	      var _props2 = this.props,
	          children = _props2.children,
	          width = _props2.width,
	          height = _props2.height;
	
	      var gridItem = (0, _ReactUtils.findChildByType)(children, _CartesianGrid2.default);
	
	      if (!gridItem) {
	        return null;
	      }
	
	      var verticalPoints = (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, xAxis, {
	        ticks: (0, _CartesianUtils.getTicksOfAxis)(xAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.left, offset.left + offset.width);
	
	      var horizontalPoints = (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, yAxis, {
	        ticks: (0, _CartesianUtils.getTicksOfAxis)(yAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.top, offset.top + offset.height);
	
	      return _react2.default.cloneElement(gridItem, {
	        key: 'grid',
	        x: offset.left,
	        y: offset.top,
	        width: offset.width,
	        height: offset.height,
	        verticalPoints: verticalPoints,
	        horizontalPoints: horizontalPoints
	      });
	    }
	    /**
	     * Draw legend
	     * @param  {Array} items     The instances of Scatters
	     * @return {ReactElement}    The instance of Legend
	     */
	
	  }, {
	    key: 'renderLegend',
	    value: function renderLegend(items) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          children = _props3.children,
	          width = _props3.width,
	          height = _props3.height,
	          margin = _props3.margin;
	
	      var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	      var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	      var props = (0, _CartesianUtils.getLegendProps)(children, items, legendWidth, legendHeight);
	
	      if (!props) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Legend2.default, _extends({}, props, {
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin,
	        ref: function ref(legend) {
	          _this2.legendInstance = legend;
	        },
	        onBBoxUpdate: this.handleLegendBBoxUpdate
	      }));
	    }
	
	    /**
	     * Draw axis
	     * @param {Object} axis     The configuration of axis
	     * @param {String} layerKey The key of layer
	     * @return {ReactElement}   The instance of axis
	     */
	
	  }, {
	    key: 'renderAxis',
	    value: function renderAxis(axis, layerKey) {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height;
	
	
	      if (axis && !axis.hide) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          { key: layerKey, className: layerKey },
	          _react2.default.createElement(_CartesianAxis2.default, _extends({}, axis, {
	            viewBox: { x: 0, y: 0, width: width, height: height },
	            ticks: (0, _CartesianUtils.getTicksOfAxis)(axis, true)
	          }))
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderCursor',
	    value: function renderCursor(xAxis, yAxis, offset) {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem || !tooltipItem.props.cursor || !this.state.isTooltipActive) {
	        return null;
	      }
	      var activeItem = this.state.activeItem;
	
	
	      var cursorProps = _extends({
	        stroke: '#ccc',
	        strokeDasharray: '5 5'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), offset, {
	        x: activeItem.cx,
	        y: activeItem.cy,
	        payload: activeItem
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Cross2.default, cursorProps);
	    }
	
	    /**
	     * Draw the main part of scatter chart
	     * @param  {Array} items   All the instance of Scatter
	     * @param  {Object} xAxis  The configuration of all x-axis
	     * @param  {Object} yAxis  The configuration of all y-axis
	     * @param  {Object} zAxis  The configuration of all z-axis
	     * @param  {Object} offset The offset of main part in the svg element
	     * @return {ReactComponent}  All the instances of Scatter
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, xAxis, yAxis, zAxis, offset) {
	      var _this3 = this;
	
	      var activeGroupId = this.state.activeGroupId;
	
	      return items.map(function (child, i) {
	        var _child$props = child.props,
	            strokeWidth = _child$props.strokeWidth,
	            data = _child$props.data;
	
	
	        var finalStrokeWidth = strokeWidth === +strokeWidth ? strokeWidth : 1;
	        finalStrokeWidth = activeGroupId === 'scatter-' + i ? finalStrokeWidth + 2 : finalStrokeWidth;
	
	        return _react2.default.cloneElement(child, _extends({
	          key: child.key || 'scatter-' + i,
	          groupId: 'scatter-' + i,
	          strokeWidth: finalStrokeWidth,
	          onMouseLeave: _this3.handleScatterMouseLeave,
	          onMouseEnter: _this3.handleScatterMouseEnter,
	          points: _this3.getComposedData(child, data, xAxis, yAxis, zAxis)
	        }, offset, {
	          xAxis: xAxis,
	          yAxis: yAxis
	        }));
	      }, this);
	    }
	  }, {
	    key: 'renderReferenceElements',
	    value: function renderReferenceElements(xAxis, yAxis, offset, isFront, Compt) {
	      var children = this.props.children;
	
	      var elements = (0, _ReactUtils.findAllByType)(children, Compt);
	
	      if (!elements || !elements.length) {
	        return null;
	      }
	
	      var keyPrefix = (0, _ReactUtils.getDisplayName)(Compt) + '-' + (isFront ? 'front' : 'back');
	
	      return elements.filter(function (entry) {
	        return isFront === entry.props.isFront;
	      }).map(function (entry, i) {
	        return _react2.default.cloneElement(entry, {
	          key: keyPrefix + '-' + i,
	          xAxis: xAxis, yAxis: yAxis,
	          viewBox: {
	            x: offset.left,
	            y: offset.top,
	            width: offset.width,
	            height: offset.height
	          }
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      // eslint-disable-next-line no-unused-vars
	
	      var _props5 = this.props,
	          style = _props5.style,
	          children = _props5.children,
	          className = _props5.className,
	          width = _props5.width,
	          height = _props5.height,
	          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);
	
	      var items = (0, _ReactUtils.findAllByType)(children, _Scatter2.default);
	      var zAxis = this.getZAxis(items);
	      var xAxis = this.getAxis('xAxis', items);
	      var yAxis = this.getAxis('yAxis', items);
	
	      var offset = this.getOffset(items, xAxis, yAxis);
	      xAxis = this.getFormatAxis(xAxis, offset, 'xAxis');
	      yAxis = this.getFormatAxis(yAxis, offset, 'yAxis');
	      var events = (0, _ReactUtils.filterEventAttributes)(this.props);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: { position: 'relative', cursor: 'default', width: width, height: height }
	        }, events),
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderGrid(xAxis, yAxis, offset),
	          this.renderReferenceElements(xAxis, yAxis, offset, false, _ReferenceArea2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, false, _ReferenceLine2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, false, _ReferenceDot2.default),
	          this.renderAxis(xAxis, 'recharts-x-axis'),
	          this.renderAxis(yAxis, 'recharts-y-axis'),
	          this.renderCursor(xAxis, yAxis, offset),
	          this.renderItems(items, xAxis, yAxis, zAxis, offset),
	          this.renderReferenceElements(xAxis, yAxis, offset, true, _ReferenceArea2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, true, _ReferenceLine2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, true, _ReferenceDot2.default),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(items),
	        this.renderTooltip(items, xAxis, yAxis, zAxis, offset)
	      );
	    }
	  }]);
	
	  return ScatterChart;
	}(_react.Component), _class2.displayName = 'ScatterChart', _class2.propTypes = _extends({}, _ReactUtils.EVENT_ATTRIBUTES, {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	  title: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string
	}), _class2.defaultProps = {
	  style: {},
	  margin: { top: 5, right: 5, bottom: 5, left: 5 }
	}, _temp2)) || _class;
	
	exports.default = ScatterChart;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(6);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(66);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(88);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _ReactUtils = __webpack_require__(9);
	
	var _Tooltip = __webpack_require__(67);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({ depth: childDepth, node: child, index: i, valueKey: valueKey });
	  }) : null;
	  var value = void 0;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = isNaN(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _extends({}, node, {
	    children: computedChildren,
	    value: value, depth: depth, index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return { x: node.x, y: node.y, width: node.width, height: node.height };
	};
	
	// Compute the area for each child based on value & scale.
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	
	  return children.map(function (child) {
	    var area = child.value * ratio;
	
	    return _extends({}, child, {
	      area: isNaN(area) || area <= 0 ? 0 : area
	    });
	  });
	};
	
	// Computes the score for the specified row, as the worst aspect ratio.
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, { min: Infinity, max: 0 }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  }
	  // what's z
	  child.z = true;
	  // add the remain x to the last one of row
	  child.width += parentRect.x + parentRect.width - curX;
	
	  return _extends({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	
	  return _extends({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	};
	
	// Recursively arranges the specified node's children into squarified rows.
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	    var child = void 0,
	        score = void 0; // the current row score
	    var size = Math.min(rect.width, rect.height); // initial orientation
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	
	      score = getWorstScore(row, size, aspectRatio);
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _extends({}, node, { children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      }) });
	  }
	
	  return node;
	};
	
	var Treemap = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Treemap, _Component);
	
	  function Treemap() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Treemap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        activeNode: null
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(node, e) {
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          children = _props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(node, e) {
	      var _props2 = this.props,
	          onMouseLeave = _props2.onMouseLeave,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(node) {
	      var onClick = this.props.onClick;
	
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: 'renderAnimatedItem',
	    value: function renderAnimatedItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          isUpdateAnimationActive = _props3.isUpdateAnimationActive;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y;
	
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf) {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: { x: x, y: y, width: width, height: height },
	          to: { x: x, y: y, width: width, height: height },
	          duration: animationDuration,
	          easing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref3) {
	          var currX = _ref3.x,
	              currY = _ref3.y,
	              currWidth = _ref3.width,
	              currHeight = _ref3.height;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              from: 'translate(' + translateX + 'px, ' + translateX + 'px)',
	              to: 'translate(0, 0)',
	              attributeName: 'transform',
	              begin: animationBegin,
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration
	            },
	            _react2.default.createElement(
	              _Layer2.default,
	              event,
	              _this2.renderContentItem(content, _extends({}, nodeProps, {
	                isAnimationActive: isAnimationActive,
	                isUpdateAnimationActive: !isUpdateAnimationActive,
	                width: currWidth,
	                height: currHeight,
	                x: currX,
	                y: currY
	              }))
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderContentItem',
	    value: function renderContentItem(content, nodeProps) {
	      if (_react2.default.isValidElement(content)) {
	        return _react2.default.cloneElement(content, nodeProps);
	      } else if ((0, _isFunction3.default)(content)) {
	        return content(nodeProps);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        fill: '#fff',
	        stroke: '#000'
	      }, nodeProps));
	    }
	  }, {
	    key: 'renderNode',
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var content = this.props.content;
	
	      var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), node, { root: root });
	      var isLeaf = !node.children || !node.children.length;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { key: 'recharts-treemap-node-' + i, className: 'recharts-treemap-depth-' + node.depth },
	        this.renderAnimatedItem(content, nodeProps, isLeaf),
	        node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null
	      );
	    }
	  }, {
	    key: 'renderAllNodes',
	    value: function renderAllNodes() {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          data = _props4.data,
	          dataKey = _props4.dataKey,
	          aspectRatio = _props4.aspectRatio;
	
	
	      var root = computeNode({
	        depth: 0,
	        node: { children: data, x: 0, y: 0, width: width, height: height },
	        index: 0,
	        valueKey: dataKey
	      });
	
	      var formatRoot = squarify(root, aspectRatio);
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props5 = this.props,
	          children = _props5.children,
	          nameKey = _props5.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height,
	          dataKey = _props6.dataKey;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeNode = _state.activeNode;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _DataUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _DataUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderAllNodes(),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Treemap;
	}(_react.Component), _class2.displayName = 'Treemap', _class2.propTypes = {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  style: _propTypes2.default.object,
	  aspectRatio: _propTypes2.default.number,
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}, _class2.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear'
	}, _temp2)) || _class;
	
	exports.default = Treemap;

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Legend Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Surface = __webpack_require__(88);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Symbols = __webpack_require__(361);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ReactUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SIZE = 32;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultLegendContent, _Component);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, (DefaultLegendContent.__proto__ || Object.getPrototypeOf(DefaultLegendContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: 'renderIcon',
	
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var color = data.color;
	
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	
	      if (data.type === 'line') {
	        return _react2.default.createElement('path', {
	          strokeWidth: 4,
	          fill: 'none',
	          stroke: color,
	          d: 'M0,' + halfSize + 'h' + thirdSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + 2 * thirdSize + ',' + halfSize + '\n            H' + SIZE + 'M' + 2 * thirdSize + ',' + halfSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + thirdSize + ',' + halfSize,
	          className: 'recharts-legend-icon'
	        });
	      } else if (data.type === 'rect') {
	        return _react2.default.createElement('path', {
	          stroke: 'none',
	          fill: color,
	          d: 'M0,' + SIZE / 8 + 'h' + SIZE + 'v' + SIZE * 3 / 4 + 'h' + -SIZE + 'z',
	          className: 'recharts-legend-icon'
	        });
	      }
	
	      return _react2.default.createElement(_Symbols2.default, {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: 'diameter',
	        type: data.type
	      });
	    }
	
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          iconSize = _props.iconSize,
	          layout = _props.layout,
	          formatter = _props.formatter;
	
	      var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };
	
	      return payload.map(function (entry, i) {
	        var finalFormatter = entry.formatter || formatter;
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'li',
	          _extends({
	            className: 'recharts-legend-item legend-item-' + i,
	            style: itemStyle,
	            key: 'legend-item-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _react2.default.createElement(
	            _Surface2.default,
	            { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle },
	            _this2.renderIcon(entry, iconSize)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'recharts-legend-item-text' },
	            finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          payload = _props2.payload,
	          layout = _props2.layout,
	          align = _props2.align;
	
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'recharts-default-legend', style: finalStyle },
	        this.renderItems()
	      );
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.element,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle'
	}, _temp)) || _class;
	
	exports.default = DefaultLegendContent;

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(56);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(16);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Tooltip Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(10);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray3.default)(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultTooltipContent, _Component);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, (DefaultTooltipContent.__proto__ || Object.getPrototypeOf(DefaultTooltipContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props = this.props,
	          payload = _props.payload,
	          separator = _props.separator,
	          formatter = _props.formatter,
	          itemStyle = _props.itemStyle,
	          itemSorter = _props.itemSorter;
	
	
	      if (payload && payload.length) {
	        var listStyle = { padding: 0, margin: 0 };
	
	        var items = payload.filter(function (entry) {
	          return !(0, _isNil3.default)(entry.value);
	        }).sort(itemSorter).map(function (entry, i) {
	          var finalItemStyle = _extends({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	
	          return _react2.default.createElement(
	            'li',
	            { className: 'recharts-tooltip-item', key: 'tooltip-item-' + i, style: finalItemStyle },
	            entry.name ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-name' },
	              entry.name
	            ) : null,
	            entry.name ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-separator' },
	              separator
	            ) : null,
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-value' },
	              finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-unit' },
	              entry.unit || ''
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          'ul',
	          { className: 'recharts-tooltip-item-list', style: listStyle },
	          items
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          labelStyle = _props2.labelStyle,
	          label = _props2.label,
	          labelFormatter = _props2.labelFormatter,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var finalStyle = _extends({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, wrapperStyle);
	      var finalLabelStyle = _extends({
	        margin: 0
	      }, labelStyle);
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'recharts-default-tooltip', style: finalStyle },
	        _react2.default.createElement(
	          'p',
	          { className: 'recharts-tooltip-label', style: finalLabelStyle },
	          finalLabel
	        ),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.Component), _class2.displayName = 'DefaultTooltipContent', _class2.propTypes = {
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  wrapperStyle: _propTypes2.default.object,
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  labelFormatter: _propTypes2.default.func,
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	  itemSorter: _propTypes2.default.func
	}, _class2.defaultProps = {
	  separator: ' : ',
	  itemStyle: {},
	  labelStyle: {}
	}, _temp)) || _class;
	
	exports.default = DefaultTooltipContent;

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(453);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResizeDetector = __webpack_require__(1288);
	
	var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);
	
	var _DataUtils = __webpack_require__(14);
	
	var _LogUtils = __webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResponsiveContainer = (_temp = _class = function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    _classCallCheck(this, ResponsiveContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResponsiveContainer.__proto__ || Object.getPrototypeOf(ResponsiveContainer)).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	
	    _this.handleResize = props.debounce > 0 ? (0, _debounce3.default)(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'getContainerSize',
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: 'renderChart',
	    value: function renderChart() {
	      var _state = this.state,
	          containerWidth = _state.containerWidth,
	          containerHeight = _state.containerHeight;
	
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _props = this.props,
	          aspect = _props.aspect,
	          width = _props.width,
	          height = _props.height,
	          minWidth = _props.minWidth,
	          minHeight = _props.minHeight,
	          maxHeight = _props.maxHeight,
	          children = _props.children;
	
	
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), 'The width(%s) and height(%s) are both fixed numbers,\n       maybe you don\'t need to use a ResponsiveContainer.', width, height);
	
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        calculatedHeight = calculatedWidth / aspect;
	        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 && calculatedHeight > 0, 'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.', calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	
	      return _react2.default.cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          minWidth = _props2.minWidth,
	          minHeight = _props2.minHeight,
	          width = _props2.width,
	          height = _props2.height,
	          maxHeight = _props2.maxHeight;
	
	      var style = { width: width, height: height, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-responsive-container',
	          style: style,
	          ref: function ref(node) {
	            _this2.container = node;
	          }
	        },
	        this.renderChart(),
	        _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, handleHeight: true, onResize: this.handleResize })
	      );
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component), _class.displayName = 'ResponsiveContainer', _class.propTypes = {
	  aspect: _propTypes2.default.number,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  minHeight: _propTypes2.default.number,
	  minWidth: _propTypes2.default.number,
	  maxHeight: _propTypes2.default.number,
	  children: _propTypes2.default.node.isRequired,
	  debounce: _propTypes2.default.number
	}, _class.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	}, _temp);
	exports.default = ResponsiveContainer;

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ComposedChart = exports.RadialBarChart = exports.AreaChart = exports.ScatterChart = exports.RadarChart = exports.Sankey = exports.Treemap = exports.PieChart = exports.BarChart = exports.LineChart = exports.ErrorBar = exports.ZAxis = exports.YAxis = exports.XAxis = exports.Scatter = exports.Bar = exports.Area = exports.Line = exports.CartesianGrid = exports.CartesianAxis = exports.ReferenceArea = exports.ReferenceDot = exports.ReferenceLine = exports.Brush = exports.RadialBar = exports.Radar = exports.Pie = exports.PolarAngleAxis = exports.PolarRadiusAxis = exports.PolarGrid = exports.Symbols = exports.Cross = exports.Dot = exports.Polygon = exports.Rectangle = exports.Curve = exports.Sector = exports.Text = exports.Cell = exports.ResponsiveContainer = exports.Tooltip = exports.Legend = exports.Layer = exports.Surface = undefined;
	
	__webpack_require__(1411);
	
	var _Surface2 = __webpack_require__(88);
	
	var _Surface3 = _interopRequireDefault(_Surface2);
	
	var _Layer2 = __webpack_require__(26);
	
	var _Layer3 = _interopRequireDefault(_Layer2);
	
	var _Legend2 = __webpack_require__(116);
	
	var _Legend3 = _interopRequireDefault(_Legend2);
	
	var _Tooltip2 = __webpack_require__(67);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _ResponsiveContainer2 = __webpack_require__(1409);
	
	var _ResponsiveContainer3 = _interopRequireDefault(_ResponsiveContainer2);
	
	var _Cell2 = __webpack_require__(176);
	
	var _Cell3 = _interopRequireDefault(_Cell2);
	
	var _Text2 = __webpack_require__(62);
	
	var _Text3 = _interopRequireDefault(_Text2);
	
	var _Sector2 = __webpack_require__(360);
	
	var _Sector3 = _interopRequireDefault(_Sector2);
	
	var _Curve2 = __webpack_require__(117);
	
	var _Curve3 = _interopRequireDefault(_Curve2);
	
	var _Rectangle2 = __webpack_require__(118);
	
	var _Rectangle3 = _interopRequireDefault(_Rectangle2);
	
	var _Polygon2 = __webpack_require__(359);
	
	var _Polygon3 = _interopRequireDefault(_Polygon2);
	
	var _Dot2 = __webpack_require__(97);
	
	var _Dot3 = _interopRequireDefault(_Dot2);
	
	var _Cross2 = __webpack_require__(619);
	
	var _Cross3 = _interopRequireDefault(_Cross2);
	
	var _Symbols2 = __webpack_require__(361);
	
	var _Symbols3 = _interopRequireDefault(_Symbols2);
	
	var _PolarGrid2 = __webpack_require__(615);
	
	var _PolarGrid3 = _interopRequireDefault(_PolarGrid2);
	
	var _PolarRadiusAxis2 = __webpack_require__(616);
	
	var _PolarRadiusAxis3 = _interopRequireDefault(_PolarRadiusAxis2);
	
	var _PolarAngleAxis2 = __webpack_require__(614);
	
	var _PolarAngleAxis3 = _interopRequireDefault(_PolarAngleAxis2);
	
	var _Pie2 = __webpack_require__(613);
	
	var _Pie3 = _interopRequireDefault(_Pie2);
	
	var _Radar2 = __webpack_require__(617);
	
	var _Radar3 = _interopRequireDefault(_Radar2);
	
	var _RadialBar2 = __webpack_require__(618);
	
	var _RadialBar3 = _interopRequireDefault(_RadialBar2);
	
	var _Brush2 = __webpack_require__(607);
	
	var _Brush3 = _interopRequireDefault(_Brush2);
	
	var _ReferenceLine2 = __webpack_require__(237);
	
	var _ReferenceLine3 = _interopRequireDefault(_ReferenceLine2);
	
	var _ReferenceDot2 = __webpack_require__(236);
	
	var _ReferenceDot3 = _interopRequireDefault(_ReferenceDot2);
	
	var _ReferenceArea2 = __webpack_require__(235);
	
	var _ReferenceArea3 = _interopRequireDefault(_ReferenceArea2);
	
	var _CartesianAxis2 = __webpack_require__(354);
	
	var _CartesianAxis3 = _interopRequireDefault(_CartesianAxis2);
	
	var _CartesianGrid2 = __webpack_require__(355);
	
	var _CartesianGrid3 = _interopRequireDefault(_CartesianGrid2);
	
	var _Line2 = __webpack_require__(356);
	
	var _Line3 = _interopRequireDefault(_Line2);
	
	var _Area2 = __webpack_require__(352);
	
	var _Area3 = _interopRequireDefault(_Area2);
	
	var _Bar2 = __webpack_require__(353);
	
	var _Bar3 = _interopRequireDefault(_Bar2);
	
	var _Scatter2 = __webpack_require__(608);
	
	var _Scatter3 = _interopRequireDefault(_Scatter2);
	
	var _XAxis2 = __webpack_require__(357);
	
	var _XAxis3 = _interopRequireDefault(_XAxis2);
	
	var _YAxis2 = __webpack_require__(358);
	
	var _YAxis3 = _interopRequireDefault(_YAxis2);
	
	var _ZAxis2 = __webpack_require__(609);
	
	var _ZAxis3 = _interopRequireDefault(_ZAxis2);
	
	var _ErrorBar2 = __webpack_require__(234);
	
	var _ErrorBar3 = _interopRequireDefault(_ErrorBar2);
	
	var _LineChart2 = __webpack_require__(612);
	
	var _LineChart3 = _interopRequireDefault(_LineChart2);
	
	var _BarChart2 = __webpack_require__(611);
	
	var _BarChart3 = _interopRequireDefault(_BarChart2);
	
	var _PieChart2 = __webpack_require__(1401);
	
	var _PieChart3 = _interopRequireDefault(_PieChart2);
	
	var _Treemap2 = __webpack_require__(1406);
	
	var _Treemap3 = _interopRequireDefault(_Treemap2);
	
	var _Sankey2 = __webpack_require__(1404);
	
	var _Sankey3 = _interopRequireDefault(_Sankey2);
	
	var _RadarChart2 = __webpack_require__(1402);
	
	var _RadarChart3 = _interopRequireDefault(_RadarChart2);
	
	var _ScatterChart2 = __webpack_require__(1405);
	
	var _ScatterChart3 = _interopRequireDefault(_ScatterChart2);
	
	var _AreaChart2 = __webpack_require__(610);
	
	var _AreaChart3 = _interopRequireDefault(_AreaChart2);
	
	var _RadialBarChart2 = __webpack_require__(1403);
	
	var _RadialBarChart3 = _interopRequireDefault(_RadialBarChart2);
	
	var _ComposedChart2 = __webpack_require__(1400);
	
	var _ComposedChart3 = _interopRequireDefault(_ComposedChart2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Surface = _Surface3.default;
	exports.Layer = _Layer3.default;
	exports.Legend = _Legend3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.ResponsiveContainer = _ResponsiveContainer3.default;
	exports.Cell = _Cell3.default;
	exports.Text = _Text3.default;
	exports.Sector = _Sector3.default;
	exports.Curve = _Curve3.default;
	exports.Rectangle = _Rectangle3.default;
	exports.Polygon = _Polygon3.default;
	exports.Dot = _Dot3.default;
	exports.Cross = _Cross3.default;
	exports.Symbols = _Symbols3.default;
	exports.PolarGrid = _PolarGrid3.default;
	exports.PolarRadiusAxis = _PolarRadiusAxis3.default;
	exports.PolarAngleAxis = _PolarAngleAxis3.default;
	exports.Pie = _Pie3.default;
	exports.Radar = _Radar3.default;
	exports.RadialBar = _RadialBar3.default;
	exports.Brush = _Brush3.default;
	exports.ReferenceLine = _ReferenceLine3.default;
	exports.ReferenceDot = _ReferenceDot3.default;
	exports.ReferenceArea = _ReferenceArea3.default;
	exports.CartesianAxis = _CartesianAxis3.default;
	exports.CartesianGrid = _CartesianGrid3.default;
	exports.Line = _Line3.default;
	exports.Area = _Area3.default;
	exports.Bar = _Bar3.default;
	exports.Scatter = _Scatter3.default;
	exports.XAxis = _XAxis3.default;
	exports.YAxis = _YAxis3.default;
	exports.ZAxis = _ZAxis3.default;
	exports.ErrorBar = _ErrorBar3.default;
	exports.LineChart = _LineChart3.default;
	exports.BarChart = _BarChart3.default;
	exports.PieChart = _PieChart3.default;
	exports.Treemap = _Treemap3.default;
	exports.Sankey = _Sankey3.default;
	exports.RadarChart = _RadarChart3.default;
	exports.ScatterChart = _ScatterChart3.default;
	exports.AreaChart = _AreaChart3.default;
	exports.RadialBarChart = _RadialBarChart3.default;
	exports.ComposedChart = _ComposedChart3.default;

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(726);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = undefined;
	
	var _events = __webpack_require__(856);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventCenter = new _events2.default();
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	exports.eventCenter = eventCenter;
	var SYNC_EVENT = exports.SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ },
/* 1413 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ },
/* 1414 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.render === 'function');
	};
	
	exports.default = isClassComponent;

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(1414);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes);
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setDisplayName = __webpack_require__(90);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(91);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(119);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
	    }
	    return MapProps;
	  };
	};
	
	exports.default = mapProps;

/***/ },
/* 1417 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (("production") === 'production' && !hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ },
/* 1419 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var pick = function pick(obj, keys) {
	  var result = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	  return result;
	};
	
	exports.default = pick;

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(90);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(91);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(119);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _shallowEqual = __webpack_require__(364);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapValues = __webpack_require__(622);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var WithStateHandlers = function (_Component) {
	      _inherits(WithStateHandlers, _Component);
	
	      function WithStateHandlers() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithStateHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        var propsChanged = nextProps !== this.props;
	        // the idea is to skip render if stateUpdater handler return undefined
	        // this allows to create no state update handlers with access to state and props
	        var stateChanged = !(0, _shallowEqual2.default)(nextState, this.state);
	        return propsChanged || stateChanged;
	      };
	
	      WithStateHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
	      };
	
	      return WithStateHandlers;
	    }(_react.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
	      this.stateUpdaters = (0, _mapValues2.default)(stateUpdaters, function (handler) {
	        return function (mayBeEvent) {
	          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          // Having that functional form of setState can be called async
	          // we need to persist SyntheticEvent
	          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
	            mayBeEvent.persist();
	          }
	
	          _this2.setState(function (state, props) {
	            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
	          });
	        };
	      });
	    };
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
	    }
	    return WithStateHandlers;
	  };
	};
	
	exports.default = withStateHandlers;

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(379)
	var reduceFunctionCall = __webpack_require__(1422)
	var mexp = __webpack_require__(1067)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(379)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1424 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 1425 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":"/talk-react-d3"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1425);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1424);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(95)))

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.makeCreateContainerFunction=exports.combineContainerMixins=undefined;var _flow2=__webpack_require__(1014);var _flow3=_interopRequireDefault(_flow2);var _includes2=__webpack_require__(206);var _includes3=_interopRequireDefault(_includes2);var _forOwn2=__webpack_require__(1015);var _forOwn3=_interopRequireDefault(_forOwn2);var _groupBy2=__webpack_require__(454);var _groupBy3=_interopRequireDefault(_groupBy2);var _toPairs2=__webpack_require__(1029);var _toPairs3=_interopRequireDefault(_toPairs2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==="function"?Symbol.iterator:"@@iterator"](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==="function"?Symbol.iterator:"@@iterator")in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();
	var _victoryCore=__webpack_require__(12);
	
	var _victoryVoronoiContainer=__webpack_require__(629);
	var _victoryZoomContainer=__webpack_require__(630);
	var _victorySelectionContainer=__webpack_require__(628);
	var _victoryBrushContainer=__webpack_require__(627);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var ensureArray=function ensureArray(thing){
	if(!thing){
	return[];
	}else if(!Array.isArray(thing)){
	return[thing];
	}else{
	return thing;
	}
	};
	
	var combineEventHandlers=function combineEventHandlers(eventHandlersArray){
	
	
	return eventHandlersArray.reduce(function(localHandlers,finalHandlers){
	(0,_forOwn3.default)(localHandlers,function(localHandler,eventName){
	var existingHandler=finalHandlers[eventName];
	if(existingHandler){
	
	finalHandlers[eventName]=function combinedHandler(){
	
	var existingMutations=ensureArray(existingHandler.apply(undefined,arguments));
	var localMutations=ensureArray(localHandler.apply(undefined,arguments));
	return existingMutations.concat(localMutations);
	};
	}else{
	finalHandlers[eventName]=localHandler;
	}
	});
	return finalHandlers;
	});
	};
	
	var combineDefaultEvents=function combineDefaultEvents(defaultEvents){
	
	
	var eventsByTarget=(0,_groupBy3.default)(defaultEvents,"target");
	return(0,_toPairs3.default)(eventsByTarget).map(
	function(_ref){var _ref2=_slicedToArray(_ref,2),target=_ref2[0],eventsArray=_ref2[1];
	return{
	target:target,
	eventHandlers:combineEventHandlers(eventsArray.map(function(event){return event.eventHandlers;}))};
	
	
	});
	
	};
	
	var combineContainerMixins=exports.combineContainerMixins=function combineContainerMixins(mixins,Container){var _class,_temp;
	
	
	
	
	
	var Classes=mixins.map(function(mixin){return mixin(Container);});
	var instances=Classes.map(function(Class){return new Class();});
	var NaiveCombinedContainer=(0,_flow3.default)(mixins)(Container);
	
	return _temp=_class=function(_NaiveCombinedContain){_inherits(VictoryCombinedContainer,_NaiveCombinedContain);function VictoryCombinedContainer(){_classCallCheck(this,VictoryCombinedContainer);return _possibleConstructorReturn(this,(VictoryCombinedContainer.__proto__||Object.getPrototypeOf(VictoryCombinedContainer)).apply(this,arguments));}_createClass(VictoryCombinedContainer,[{key:"getChildren",value:function getChildren(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	props){
	return instances.reduce(
	function(children,instance){return instance.getChildren(_extends({},props,{children:children}));},
	props.children);
	
	}}]);return VictoryCombinedContainer;}(NaiveCombinedContainer),_class.displayName="CustomVictoryContainer",_class.propTypes=Classes.reduce(function(propTypes,Class){return _extends({},propTypes,Class.propTypes);},{}),_class.defaultProps=Classes.reduce(function(defaultProps,Class){return _extends({},defaultProps,Class.defaultProps);},{}),_class.defaultEvents=combineDefaultEvents(Classes.reduce(function(defaultEvents,Class){return[].concat(_toConsumableArray(defaultEvents),_toConsumableArray(Class.defaultEvents));},[])),_temp;
	
	};
	
	var checkBehaviorName=function checkBehaviorName(behavior,behaviors){
	if(behavior&&!(0,_includes3.default)(behaviors,behavior)){
	_victoryCore.Log.warn("\""+
	behavior+"\" is not a valid behavior. Choose from ["+behaviors.join(", ")+"].");
	
	}
	};
	
	var makeCreateContainerFunction=exports.makeCreateContainerFunction=function makeCreateContainerFunction(mixinMap,Container){return function(behaviorA,behaviorB){
	var behaviors=Object.keys(mixinMap);
	
	checkBehaviorName(behaviorA,behaviors);
	checkBehaviorName(behaviorB,behaviors);
	
	if(arguments.length<=2?0:arguments.length-2){
	_victoryCore.Log.warn("too many arguments given to createContainer (maximum accepted: 2).");
	}
	
	var firstMixins=mixinMap[behaviorA];
	var secondMixins=mixinMap[behaviorB]||[];
	
	if(!firstMixins){
	return Container;
	}
	
	return combineContainerMixins([].concat(_toConsumableArray(firstMixins),_toConsumableArray(secondMixins)),Container);
	};};exports.default=
	
	makeCreateContainerFunction({
	zoom:[_victoryZoomContainer.zoomContainerMixin],
	voronoi:[_victoryVoronoiContainer.voronoiContainerMixin],
	selection:[_victorySelectionContainer.selectionContainerMixin],
	brush:[_victoryBrushContainer.brushContainerMixin]},_victoryCore.VictoryContainer);

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);
	
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	
	getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
	props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"area");
	var calculatedValues=this.getCalculatedValues(props);var
	scale=calculatedValues.scale,style=calculatedValues.style,data=calculatedValues.data,domain=calculatedValues.domain;var _props=
	
	
	props,standalone=_props.standalone,interpolation=_props.interpolation,events=_props.events,sharedEvents=_props.sharedEvents,width=_props.width,height=_props.height,groupComponent=_props.groupComponent,theme=_props.theme;
	
	var initialChildProps={
	parent:{style:style.parent,width:width,height:height,scale:scale,data:data,domain:domain,standalone:standalone,theme:theme},
	all:{
	data:{scale:scale,data:data,interpolation:interpolation,groupComponent:groupComponent,style:style.data}}};
	
	
	return data.reduce(function(childProps,datum,index){
	var text=_this.getLabelText(props,datum,index);
	if(text!==undefined&&text!==null||events||sharedEvents){
	var eventKey=datum.eventKey||index;
	childProps[eventKey]={labels:_this.getLabelProps(text,index,calculatedValues)};
	}
	return childProps;
	},initialChildProps);
	},
	
	getCalculatedValues:function getCalculatedValues(props){var
	theme=props.theme;
	var defaultStyles=theme&&theme.area&&theme.area.style?theme.area.style:{};
	var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%");
	var range={
	x:_victoryCore.Helpers.getRange(props,"x"),
	y:_victoryCore.Helpers.getRange(props,"y")};
	
	var domain={
	x:_victoryCore.Domain.getDomainWithZero(props,"x"),
	y:_victoryCore.Domain.getDomainWithZero(props,"y")};
	
	var scale={
	x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
	y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};
	
	
	var data=this.getDataWithBaseline(props,scale);
	return{style:style,data:data,scale:scale,domain:domain};
	},
	
	getLabelProps:function getLabelProps(text,index,calculatedProps){var
	scale=calculatedProps.scale,data=calculatedProps.data,style=calculatedProps.style;
	var datum=data[index];var _getLabelPosition=
	this.getLabelPosition(datum,scale),x=_getLabelPosition.x,y=_getLabelPosition.y;
	var labelStyle=this.getLabelStyle(style)||{};
	var sign=(datum._y1||datum._y)<0?-1:1;
	return{
	style:labelStyle,
	x:x,
	y:y-sign*(labelStyle.padding||0),
	text:text,
	index:index,
	scale:scale,
	datum:datum,
	data:data,
	textAnchor:labelStyle.textAnchor,
	verticalAnchor:labelStyle.verticalAnchor||"end",
	angle:labelStyle.angle};
	
	},
	
	getLabelText:function getLabelText(props,datum,index){
	return datum.label||(Array.isArray(props.labels)?
	props.labels[index]:props.labels);
	},
	
	getLabelPosition:function getLabelPosition(datum,scale){
	return{
	x:scale.x(datum._x1!==undefined?datum._x1:datum._x),
	y:scale.y(datum._y1!==undefined?datum._y1:datum._y)};
	
	},
	
	getLabelStyle:function getLabelStyle(style){
	var dataStyle=style.data||{};
	var labelStyle=style.labels||{};
	
	var opacity=dataStyle.opacity;
	
	
	var fill=dataStyle.stroke;
	var padding=labelStyle.padding||0;
	return(0,_defaults3.default)({},labelStyle,{opacity:opacity,fill:fill,padding:padding});
	},
	
	
	getDataWithBaseline:function getDataWithBaseline(props,scale){
	var data=_victoryCore.Data.getData(props);
	
	if(data.length<2){
	_victoryCore.Log.warn("Area requires at least two data points.");
	data=[];
	}
	var defaultMin=_victoryCore.Scale.getType(scale.y)==="log"?1/Number.MAX_SAFE_INTEGER:0;
	var domainY=scale.y.domain();
	var minY=Math.min.apply(Math,_toConsumableArray(domainY))>0?Math.min.apply(Math,_toConsumableArray(domainY)):defaultMin;
	
	return data.map(function(datum){
	var _y1=datum._y1!==undefined?datum._y1:datum._y;
	var _y0=datum._y0!==undefined?datum._y0:minY;
	return(0,_assign3.default)({},datum,{_y0:_y0,_y1:_y1});
	});
	}};

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _helperMethods=__webpack_require__(1428);var _helperMethods2=_interopRequireDefault(_helperMethods);
	var _victoryCore=__webpack_require__(12);
	
	
	
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50,
	interpolation:"linear"};
	
	
	var animationWhitelist=["data","domain","height","padding","style","width"];var
	
	VictoryArea=function(_React$Component){_inherits(VictoryArea,_React$Component);function VictoryArea(){_classCallCheck(this,VictoryArea);return _possibleConstructorReturn(this,(VictoryArea.__proto__||Object.getPrototypeOf(VictoryArea)).apply(this,arguments));}_createClass(VictoryArea,[{key:"shouldAnimate",value:function shouldAnimate()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{
	return!!this.props.animate;
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,role);
	
	if(this.shouldAnimate()){
	return this.animateComponent(props,animationWhitelist);
	}
	var children=this.renderContinuousData(props);
	return this.renderContainer(props.containerComponent,children);
	}}]);return VictoryArea;}(_react2.default.Component);VictoryArea.propTypes=_extends({},_commonProps.BaseProps,_commonProps.DataProps,{interpolation:_propTypes2.default.oneOf(["basis","bundle","cardinal","catmullRom","linear","monotoneX","monotoneY","natural","radial","step","stepAfter","stepBefore"]),label:_victoryCore.PropTypes.deprecated(_propTypes2.default.string,"Use `labels` instead for individual data labels")});VictoryArea.defaultProps={dataComponent:_react2.default.createElement(_victoryCore.Area,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),scale:"linear",samples:50,standalone:true,containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement(_victoryCore.VictoryClipContainer,null),theme:_victoryCore.VictoryTheme.grayscale};VictoryArea.displayName="VictoryArea";VictoryArea.role="area";VictoryArea.continuous=true;VictoryArea.defaultTransitions=_victoryCore.DefaultTransitions.continuousTransitions();VictoryArea.getDomain=_victoryCore.Domain.getDomainWithZero.bind(_victoryCore.Domain);VictoryArea.getData=_victoryCore.Data.getData.bind(_victoryCore.Data);VictoryArea.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryArea.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=
	
	
	(0,_victoryCore.addEvents)(VictoryArea);

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _without2=__webpack_require__(160);var _without3=_interopRequireDefault(_without2);var _range2=__webpack_require__(51);var _range3=_interopRequireDefault(_range2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _defaultsDeep2=__webpack_require__(1008);var _defaultsDeep3=_interopRequireDefault(_defaultsDeep2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _includes2=__webpack_require__(206);var _includes3=_interopRequireDefault(_includes2);
	
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}
	
	var orientationSign={
	top:-1,
	left:-1,
	right:1,
	bottom:1};exports.default=
	
	
	{
	evaluateProp:function evaluateProp(prop,data,index){
	return(0,_isFunction3.default)(prop)?prop(data,index):prop;
	},
	
	evaluateStyle:function evaluateStyle(style,data,index){var _this=this;
	if(!style||!Object.keys(style).some(function(value){return(0,_isFunction3.default)(style[value]);})){
	return style;
	}
	return Object.keys(style).reduce(function(prev,curr){
	prev[curr]=_this.evaluateProp(style[curr],data,index);
	return prev;
	},{});
	},
	
	
	getDomain:function getDomain(props,axis){
	var inherentAxis=this.getAxis(props);
	if(axis&&axis!==inherentAxis){
	return undefined;
	}
	var domain=void 0;
	if(Array.isArray(props.domain)){
	domain=props.domain;
	}else if(props.domain&&props.domain[inherentAxis]){
	domain=props.domain[inherentAxis];
	}else if(Array.isArray(props.tickValues)&&props.tickValues.length>1){
	domain=_victoryCore.Domain.getDomainFromTickValues(props);
	}
	var paddedDomain=_victoryCore.Domain.padDomain(domain,props,inherentAxis);
	return domain?_victoryCore.Domain.cleanDomain(paddedDomain,props,inherentAxis):undefined;
	},
	
	
	getAxis:function getAxis(props,flipped){
	if(props.orientation){
	var vertical={top:"x",bottom:"x",left:"y",right:"y"};
	return vertical[props.orientation];
	}
	var axisType=props.dependentAxis?"dependent":"independent";
	var flippedAxis={dependent:"x",independent:"y"};
	var normalAxis={independent:"x",dependent:"y"};
	return flipped?flippedAxis[axisType]:normalAxis[axisType];
	},
	
	
	getScale:function getScale(props){
	var axis=this.getAxis(props);
	var scale=_victoryCore.Scale.getBaseScale(props,axis);
	var domain=this.getDomain(props)||scale.domain();
	scale.range(_victoryCore.Helpers.getRange(props,axis));
	scale.domain(domain);
	return scale;
	},
	
	getStyleObject:function getStyleObject(props){var
	theme=props.theme,dependentAxis=props.dependentAxis;
	var generalAxisStyle=theme&&theme.axis&&theme.axis.style;
	var axisType=dependentAxis?"dependentAxis":"independentAxis";
	var specificAxisStyle=theme&&theme[axisType]&&theme[axisType].style;
	
	return generalAxisStyle&&specificAxisStyle?
	(0,_defaultsDeep3.default)({},
	specificAxisStyle,
	generalAxisStyle):
	
	specificAxisStyle||generalAxisStyle;
	},
	
	getStyles:function getStyles(props,styleObject){
	var style=props.style||{};
	styleObject=styleObject||{};
	var parentStyleProps={height:"auto",width:"100%"};
	return{
	parent:(0,_defaults3.default)(parentStyleProps,style.parent,styleObject.parent),
	axis:(0,_defaults3.default)({},style.axis,styleObject.axis),
	axisLabel:(0,_defaults3.default)({},style.axisLabel,styleObject.axisLabel),
	grid:(0,_defaults3.default)({},style.grid,styleObject.grid),
	ticks:(0,_defaults3.default)({},style.ticks,styleObject.ticks),
	tickLabels:(0,_defaults3.default)({},style.tickLabels,styleObject.tickLabels)};
	
	},
	
	getTickProps:function getTickProps(layout,style,datum){var
	position=layout.position,transform=layout.transform;
	return{
	x1:transform.x,
	y1:transform.y,
	x2:transform.x+position.x2,
	y2:transform.y+position.y2,
	style:style,
	datum:datum};
	
	},
	
	getTickLabelProps:function getTickLabelProps(layout,style,anchors,datum,text){var
	position=layout.position,transform=layout.transform;
	return{
	style:style,
	x:transform.x+position.x,
	y:transform.y+position.y,
	verticalAnchor:anchors.verticalAnchor,
	textAnchor:anchors.textAnchor,
	angle:style.angle,
	text:text,
	datum:datum};
	
	},
	
	getGridProps:function getGridProps(layout,style,datum){var
	edge=layout.edge,transform=layout.transform;
	return{
	x1:transform.x,
	y1:transform.y,
	x2:edge.x+transform.x,
	y2:edge.y+transform.y,
	style:style,
	datum:datum};
	
	},
	
	getAxisProps:function getAxisProps(modifiedProps,calculatedValues,globalTransform){var
	style=calculatedValues.style,padding=calculatedValues.padding,isVertical=calculatedValues.isVertical;var
	width=modifiedProps.width,height=modifiedProps.height;
	return{
	style:style.axis,
	x1:isVertical?globalTransform.x:padding.left+globalTransform.x,
	x2:isVertical?globalTransform.x:width-padding.right+globalTransform.x,
	y1:isVertical?padding.top+globalTransform.y:globalTransform.y,
	y2:isVertical?height-padding.bottom+globalTransform.y:globalTransform.y};
	
	},
	
	getLayoutProps:function getLayoutProps(modifiedProps,calculatedValues){
	var offset=this.getOffset(modifiedProps,calculatedValues);
	return{
	globalTransform:this.getTransform(modifiedProps,calculatedValues,offset),
	gridOffset:this.getGridOffset(modifiedProps,calculatedValues,offset),
	gridEdge:this.getGridEdge(modifiedProps,calculatedValues)};
	
	},
	
	getEvaluatedStyles:function getEvaluatedStyles(style,tick,index){
	return{
	tickStyle:this.evaluateStyle(style.ticks,tick,index),
	labelStyle:this.evaluateStyle(style.tickLabels,tick,index),
	gridStyle:this.evaluateStyle(style.grid,tick,index)};
	
	},
	
	getRole:function getRole(props){
	if(props.dependentAxis){
	return props.theme&&props.theme.dependentAxis?
	"dependentAxis":
	"axis";
	}
	
	return props.theme&&props.theme.independentAxis?
	"independentAxis":
	"axis";
	},
	
	getShallowMergedThemeProps:function getShallowMergedThemeProps(props,role){
	var axisTheme=props.theme.axis||{};
	return(0,_defaults3.default)({},props.theme[role],axisTheme);
	},
	
	modifyProps:function modifyProps(props,fallbackProps,role){
	if(role!=="axis"){
	props.theme[role]=this.getShallowMergedThemeProps(props,role);
	}
	return _victoryCore.Helpers.modifyProps(props,fallbackProps,role);
	},
	
	getBaseProps:function getBaseProps(props,fallbackProps){var _this2=this;
	var role=this.getRole(props);
	props=this.modifyProps(props,fallbackProps,role);
	var calculatedValues=this.getCalculatedValues(props);var
	
	style=
	calculatedValues.style,orientation=calculatedValues.orientation,isVertical=calculatedValues.isVertical,scale=calculatedValues.scale,ticks=calculatedValues.ticks,tickFormat=calculatedValues.tickFormat,stringTicks=calculatedValues.stringTicks,anchors=calculatedValues.anchors,domain=calculatedValues.domain;var _props=
	props,width=_props.width,height=_props.height,standalone=_props.standalone,theme=_props.theme,tickValues=_props.tickValues;var _getLayoutProps=
	
	
	this.getLayoutProps(props,calculatedValues),globalTransform=_getLayoutProps.globalTransform,gridOffset=_getLayoutProps.gridOffset,gridEdge=_getLayoutProps.gridEdge;
	
	var axisProps=this.getAxisProps(props,calculatedValues,globalTransform);
	var axisLabelProps=this.getAxisLabelProps(props,calculatedValues,globalTransform);
	var initialChildProps={parent:{
	style:style.parent,ticks:ticks,scale:scale,width:width,height:height,domain:domain,standalone:standalone,theme:theme}};
	
	
	return ticks.reduce(function(childProps,indexedTick,index){
	var tick=stringTicks?tickValues[indexedTick-1]:indexedTick;
	
	var styles=_this2.getEvaluatedStyles(style,tick,index);
	var tickLayout={
	position:_this2.getTickPosition(styles,orientation,isVertical),
	transform:_this2.getTickTransform(scale(indexedTick),globalTransform,isVertical)};
	
	
	var gridLayout={
	edge:gridEdge,
	transform:{
	x:isVertical?
	-gridOffset.x+globalTransform.x:scale(indexedTick)+globalTransform.x,
	y:isVertical?
	scale(indexedTick)+globalTransform.y:gridOffset.y+globalTransform.y}};
	
	
	
	childProps[index]={
	axis:axisProps,
	axisLabel:axisLabelProps,
	ticks:_this2.getTickProps(tickLayout,styles.tickStyle,tick),
	tickLabels:_this2.getTickLabelProps(
	tickLayout,styles.labelStyle,anchors,tick,tickFormat(tick,index)),
	
	grid:_this2.getGridProps(gridLayout,styles.gridStyle,tick)};
	
	
	return childProps;
	},initialChildProps);
	},
	
	getCalculatedValues:function getCalculatedValues(props){
	var defaultStyles=this.getStyleObject(props);
	var style=this.getStyles(props,defaultStyles);
	var padding=_victoryCore.Helpers.getPadding(props);
	var orientation=props.orientation||(props.dependentAxis?"left":"bottom");
	var isVertical=_victoryCore.Helpers.isVertical(props);
	var labelPadding=this.getLabelPadding(props,style);
	var stringTicks=_victoryCore.Helpers.stringTicks(props);
	var scale=this.getScale(props);
	var domain=this.getDomain(props);
	var ticks=this.getTicks(props,scale);
	var tickFormat=this.getTickFormat(props,scale,ticks);
	var anchors=this.getAnchors(orientation,isVertical);
	
	return{
	style:style,padding:padding,orientation:orientation,isVertical:isVertical,labelPadding:labelPadding,stringTicks:stringTicks,
	anchors:anchors,scale:scale,ticks:ticks,tickFormat:tickFormat,domain:domain};
	
	},
	
	getAxisLabelProps:function getAxisLabelProps(props,calculatedValues,globalTransform){var
	style=calculatedValues.style,orientation=calculatedValues.orientation,padding=calculatedValues.padding,labelPadding=calculatedValues.labelPadding,isVertical=calculatedValues.isVertical;
	var sign=orientationSign[orientation];
	var hPadding=padding.left+padding.right;
	var vPadding=padding.top+padding.bottom;
	var verticalAnchor=sign<0?"end":"start";
	var labelStyle=style.axisLabel;
	var angle=isVertical?-90:0;
	var x=isVertical?globalTransform.x+sign*labelPadding:
	(props.width-hPadding)/2+padding.left+globalTransform.x;
	var y=isVertical?
	(props.height-vPadding)/2+padding.bottom+globalTransform.y:
	sign*labelPadding+globalTransform.y;
	return{
	x:x,
	y:y,
	verticalAnchor:labelStyle.verticalAnchor||verticalAnchor,
	textAnchor:labelStyle.textAnchor||"middle",
	angle:labelStyle.angle||angle,
	style:labelStyle,
	text:props.label};
	
	},
	
	getTicks:function getTicks(props,scale){var
	tickValues=props.tickValues,tickCount=props.tickCount,crossAxis=props.crossAxis;
	if(props.tickValues){
	if(_victoryCore.Helpers.stringTicks(props)){
	return(0,_range3.default)(1,props.tickValues.length+1);
	}
	return tickValues.length?tickValues:scale.domain();
	}else if(scale.ticks&&(0,_isFunction3.default)(scale.ticks)){
	var scaleTicks=scale.ticks(tickCount);
	var ticks=Array.isArray(scaleTicks)&&scaleTicks.length?scaleTicks:scale.domain();
	if(crossAxis){
	var filteredTicks=(0,_includes3.default)(ticks,0)?(0,_without3.default)(ticks,0):ticks;
	return filteredTicks.length?filteredTicks:ticks;
	}
	return ticks;
	}
	return scale.domain();
	},
	
	getAnchors:function getAnchors(orientation,isVertical){
	var anchorOrientation={top:"end",left:"end",right:"start",bottom:"start"};
	var anchor=anchorOrientation[orientation];
	return{
	textAnchor:isVertical?anchor:"middle",
	verticalAnchor:isVertical?"middle":anchor};
	
	},
	
	getTickFormat:function getTickFormat(props,scale){
	if(props.tickFormat&&(0,_isFunction3.default)(props.tickFormat)){
	return props.tickFormat;
	}else if(props.tickFormat&&Array.isArray(props.tickFormat)){
	return function(x,index){return props.tickFormat[index];};
	}else if(_victoryCore.Helpers.stringTicks(props)){
	return function(x,index){return props.tickValues[index];};
	}else if(scale.tickFormat&&(0,_isFunction3.default)(scale.tickFormat)){
	return scale.tickFormat();
	}else{
	return function(x){return x;};
	}
	},
	
	getLabelPadding:function getLabelPadding(props,style){
	var labelStyle=style.axisLabel||{};
	if(typeof labelStyle.padding!=="undefined"&&labelStyle.padding!==null){
	return labelStyle.padding;
	}
	var isVertical=_victoryCore.Helpers.isVertical(props);
	
	
	var fontSize=labelStyle.fontSize||14;
	return props.label?fontSize*(isVertical?2.3:1.6):0;
	
	},
	
	getOffset:function getOffset(props,calculatedValues){var _this3=this;var
	
	style=
	calculatedValues.style,padding=calculatedValues.padding,isVertical=calculatedValues.isVertical,orientation=calculatedValues.orientation,labelPadding=calculatedValues.labelPadding,stringTicks=calculatedValues.stringTicks,ticks=calculatedValues.ticks;
	var xPadding=orientation==="right"?padding.right:padding.left;
	var yPadding=orientation==="top"?padding.top:padding.bottom;
	var fontSize=style.axisLabel.fontSize||14;
	var offsetX=props.offsetX!==null&&props.offsetX!==undefined?
	props.offsetX:xPadding;
	var offsetY=props.offsetY!==null&&props.offsetY!==undefined?
	props.offsetY:yPadding;
	var tickSizes=ticks.map(function(data){
	var tick=stringTicks?props.tickValues[data-1]:data;
	var tickStyle=_this3.evaluateStyle(style.ticks,tick);
	return tickStyle.size||0;
	});
	var totalPadding=fontSize+2*Math.max.apply(Math,_toConsumableArray(tickSizes))+labelPadding;
	var minimumPadding=1.2*fontSize;
	var x=isVertical?totalPadding:minimumPadding;
	var y=isVertical?minimumPadding:totalPadding;
	return{
	x:offsetX!==null&&offsetX!==undefined?offsetX:x,
	y:offsetY!==null&&offsetY!==undefined?offsetY:y};
	
	},
	
	getTransform:function getTransform(props,calculatedValues,offset){var
	orientation=calculatedValues.orientation;
	return{
	top:{x:0,y:offset.y},
	bottom:{x:0,y:props.height-offset.y},
	left:{x:offset.x,y:0},
	right:{x:props.width-offset.x,y:0}}[
	orientation];
	},
	
	getTickPosition:function getTickPosition(style,orientation,isVertical){var
	tickStyle=style.tickStyle,labelStyle=style.labelStyle;
	var size=tickStyle.size||0;
	var tickPadding=tickStyle.padding||0;
	var labelPadding=labelStyle.padding||0;
	var tickSpacing=size+tickPadding+labelPadding;
	var sign=orientationSign[orientation];
	return{
	x:isVertical?sign*tickSpacing:0,
	x2:isVertical?sign*size:0,
	y:isVertical?0:sign*tickSpacing,
	y2:isVertical?0:sign*size};
	
	},
	
	getTickTransform:function getTickTransform(tick,globalTransform,isVertical){
	return{
	x:isVertical?globalTransform.x:tick+globalTransform.x,
	y:isVertical?tick+globalTransform.y:globalTransform.y};
	
	},
	
	getGridEdge:function getGridEdge(props,calculatedValues){var
	orientation=calculatedValues.orientation,padding=calculatedValues.padding,isVertical=calculatedValues.isVertical;
	var sign=-orientationSign[orientation];
	var x=isVertical?
	sign*(props.width-(padding.left+padding.right)):0;
	var y=isVertical?
	0:sign*(props.height-(padding.top+padding.bottom));
	return{x:x,y:y};
	},
	
	getGridOffset:function getGridOffset(props,calculatedValues,offset){var
	padding=calculatedValues.padding,orientation=calculatedValues.orientation;
	var xPadding=orientation==="right"?padding.right:padding.left;
	var yPadding=orientation==="top"?padding.top:padding.bottom;
	return{
	x:props.crossAxis?offset.x-xPadding:0,
	y:props.crossAxis?offset.y-yPadding:0};
	
	}};

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);
	
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=
	
	{
	
	getBarWidth:function getBarWidth(props){var
	style=props.style,width=props.width,data=props.data;
	var padding=props.padding.left||props.padding;
	
	var defaultWidth=data.length===0?8:(width-2*padding)/data.length;
	return style&&style.width?style.width:defaultWidth;
	},
	
	getBarPosition:function getBarPosition(props,datum,scale){
	var defaultMin=_victoryCore.Scale.getType(scale.y)==="log"?
	1/Number.MAX_SAFE_INTEGER:0;
	
	var y0=datum._y0!==undefined?datum._y0:defaultMin;
	var formatValue=function formatValue(value,axis){
	return datum[axis]instanceof Date?new Date(value):value;
	};
	var x=datum._x1!==undefined?datum._x1:datum._x;
	var y1=datum._y1!==undefined?datum._y1:datum._y;
	return{
	x:scale.x(formatValue(x,"x")),
	y0:scale.y(formatValue(y0,"y")),
	y:scale.y(formatValue(y1,"y"))};
	
	},
	
	getBarStyle:function getBarStyle(datum,baseStyle){
	var styleData=(0,_omit3.default)(datum,[
	"xName","yName","x","y","label","errorX","errorY","eventKey"]);
	
	return(0,_defaults3.default)({},styleData,baseStyle);
	},
	
	getLabelStyle:function getLabelStyle(style,datum){
	return(0,_defaults3.default)({},{
	angle:datum.angle,
	textAnchor:datum.textAnchor,
	verticalAnchor:datum.verticalAnchor},
	style);
	},
	
	getLabel:function getLabel(props,datum,index){
	return datum.label||(Array.isArray(props.labels)?
	props.labels[index]:props.labels);
	},
	
	getLabelAnchors:function getLabelAnchors(datum,horizontal){
	var sign=datum._y>=0?1:-1;
	if(!horizontal){
	return{
	vertical:sign>=0?"end":"start",
	text:"middle"};
	
	}else{
	return{
	vertical:"middle",
	text:sign>=0?"start":"end"};
	
	}
	},
	
	getlabelPadding:function getlabelPadding(style,datum,horizontal){
	var defaultPadding=style.padding||0;
	var sign=datum._y<0?-1:1;
	return{
	x:horizontal?sign*defaultPadding:0,
	y:horizontal?0:sign*defaultPadding};
	
	},
	
	getCalculatedValues:function getCalculatedValues(props){var
	theme=props.theme,horizontal=props.horizontal;
	var defaultStyles=theme&&theme.bar&&theme.bar.style?theme.bar.style:{};
	var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%");
	var data=_victoryCore.Data.getData(props);
	var range={
	x:_victoryCore.Helpers.getRange(props,"x"),
	y:_victoryCore.Helpers.getRange(props,"y")};
	
	var domain={
	x:_victoryCore.Domain.getDomainWithZero(props,"x"),
	y:_victoryCore.Domain.getDomainWithZero(props,"y")};
	
	var xScale=_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x);
	var yScale=_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y);
	var scale={
	x:horizontal?yScale:xScale,
	y:horizontal?xScale:yScale};
	
	return{style:style,data:data,scale:scale,domain:domain};
	},
	
	getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
	props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"bar");var _getCalculatedValues=
	this.getCalculatedValues(props),style=_getCalculatedValues.style,data=_getCalculatedValues.data,scale=_getCalculatedValues.scale,domain=_getCalculatedValues.domain;var _props=
	props,horizontal=_props.horizontal,width=_props.width,height=_props.height,padding=_props.padding,standalone=_props.standalone,theme=_props.theme;
	var initialChildProps={parent:{
	domain:domain,scale:scale,width:width,height:height,data:data,standalone:standalone,theme:theme,style:style.parent}};
	
	
	return data.reduce(function(childProps,datum,index){
	var eventKey=datum.eventKey||index;
	var position=_this.getBarPosition(props,datum,scale);
	var dataProps=(0,_assign3.default)(
	{
	style:_this.getBarStyle(datum,style.data),
	index:index,
	datum:datum,
	scale:scale,
	horizontal:horizontal,
	padding:padding,
	width:width,
	data:data},
	
	position);
	
	
	childProps[eventKey]={
	data:dataProps};
	
	var text=_this.getLabel(props,datum,index);
	if(text!==undefined&&text!==null||props.events||props.sharedEvents){
	childProps[eventKey].labels=_this.getLabelProps(dataProps,text,style);
	}
	
	return childProps;
	},initialChildProps);
	},
	
	getLabelProps:function getLabelProps(dataProps,text,calculatedStyle){var
	datum=dataProps.datum,data=dataProps.data,horizontal=dataProps.horizontal,x=dataProps.x,y=dataProps.y,y0=dataProps.y0,index=dataProps.index,scale=dataProps.scale;
	var labelStyle=this.getLabelStyle(calculatedStyle.labels,datum);
	var labelPadding=this.getlabelPadding(labelStyle,datum,horizontal);
	var anchors=this.getLabelAnchors(datum,horizontal);
	return{
	style:labelStyle,
	x:horizontal?y+labelPadding.x:x+labelPadding.x,
	y:horizontal?x+labelPadding.y:y-labelPadding.y,
	y0:y0,
	text:text,
	index:index,
	scale:scale,
	datum:datum,
	data:data,
	horizontal:horizontal,
	textAnchor:labelStyle.textAnchor||anchors.text,
	verticalAnchor:labelStyle.verticalAnchor||anchors.vertical,
	angle:labelStyle.angle};
	
	}};

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _helperMethods=__webpack_require__(1431);var _helperMethods2=_interopRequireDefault(_helperMethods);
	
	var _victoryCore=__webpack_require__(12);
	
	
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50};
	
	
	var defaultData=[
	{x:1,y:1},
	{x:2,y:2},
	{x:3,y:3},
	{x:4,y:4}];
	
	
	var animationWhitelist=["data","domain","height","padding","style","width"];var
	
	VictoryBar=function(_React$Component){_inherits(VictoryBar,_React$Component);function VictoryBar(){_classCallCheck(this,VictoryBar);return _possibleConstructorReturn(this,(VictoryBar.__proto__||Object.getPrototypeOf(VictoryBar)).apply(this,arguments));}_createClass(VictoryBar,[{key:"shouldAnimate",value:function shouldAnimate()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{
	return!!this.props.animate;
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,role);
	if(this.shouldAnimate()){
	return this.animateComponent(props,animationWhitelist);
	}
	var children=this.renderData(props);
	return this.renderContainer(props.containerComponent,children);
	}}]);return VictoryBar;}(_react2.default.Component);VictoryBar.displayName="VictoryBar";VictoryBar.role="bar";VictoryBar.defaultTransitions={onLoad:{duration:2000,before:function before(){return{_y:0,_y1:0,_y0:0};},after:function after(datum){return{_y:datum._y,_y1:datum._y1,_y0:datum._y0};}},onExit:{duration:500,before:function before(){return{_y:0,yOffset:0};}},onEnter:{duration:500,before:function before(){return{_y:0,_y1:0,_y0:0};},after:function after(datum){return{_y:datum._y,_y1:datum._y1,_y0:datum._y0};}}};VictoryBar.propTypes=_extends({},_commonProps.BaseProps,_commonProps.DataProps,{horizontal:_propTypes2.default.bool});VictoryBar.defaultProps={data:defaultData,dataComponent:_react2.default.createElement(_victoryCore.Bar,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),scale:"linear",standalone:true,containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",{role:"presentation"}),theme:_victoryCore.VictoryTheme.grayscale};VictoryBar.getDomain=_victoryCore.Domain.getDomainWithZero.bind(_victoryCore.Domain);VictoryBar.getData=_victoryCore.Data.getData.bind(_victoryCore.Data);VictoryBar.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryBar.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=
	
	
	(0,_victoryCore.addEvents)(VictoryBar);

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);var _sortBy2=__webpack_require__(78);var _sortBy3=_interopRequireDefault(_sortBy2);var _pick2=__webpack_require__(94);var _pick3=_interopRequireDefault(_pick2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);
	
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
	props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"candlestick");
	var calculatedValues=this.getCalculatedValues(props);var
	data=calculatedValues.data,style=calculatedValues.style,scale=calculatedValues.scale,domain=calculatedValues.domain;var _props=
	props,groupComponent=_props.groupComponent,width=_props.width,height=_props.height,padding=_props.padding,standalone=_props.standalone,theme=_props.theme;
	var initialChildProps={parent:{
	domain:domain,scale:scale,width:width,height:height,data:data,standalone:standalone,theme:theme,style:style.parent}};
	
	
	return data.reduce(function(childProps,datum,index){
	var eventKey=datum.eventKey||index;
	var x=scale.x(datum._x1!==undefined?datum._x1:datum._x);
	var y1=scale.y(datum._high);
	var y2=scale.y(datum._low);
	var candleHeight=Math.abs(scale.y(datum._open)-scale.y(datum._close));
	var y=scale.y(Math.max(datum._open,datum._close));
	var dataStyle=_this.getDataStyles(datum,style.data,props);
	var dataProps={
	x:x,y:y,y1:y1,y2:y2,candleHeight:candleHeight,scale:scale,data:data,datum:datum,groupComponent:groupComponent,
	index:index,style:dataStyle,padding:padding,width:width};
	
	
	childProps[eventKey]={
	data:dataProps};
	
	var text=_this.getLabelText(props,datum,index);
	if(text!==undefined&&text!==null||props.events||props.sharedEvents){
	childProps[eventKey].labels=_this.getLabelProps(dataProps,text,style);
	}
	
	return childProps;
	},initialChildProps);
	},
	
	getLabelProps:function getLabelProps(dataProps,text,calculatedStyle){var
	x=dataProps.x,y1=dataProps.y1,index=dataProps.index,scale=dataProps.scale,datum=dataProps.datum,data=dataProps.data;
	var labelStyle=this.getLabelStyle(calculatedStyle.labels,dataProps)||{};
	return{
	style:labelStyle,
	y:y1-(labelStyle.padding||0),
	x:x,
	text:text,
	index:index,
	scale:scale,
	datum:datum,
	data:data,
	textAnchor:labelStyle.textAnchor,
	verticalAnchor:labelStyle.verticalAnchor||"end",
	angle:labelStyle.angle};
	
	},
	
	getCalculatedValues:function getCalculatedValues(props){var
	theme=props.theme;
	var defaultStyle=theme&&theme.candlestick&&theme.candlestick.style?
	theme.candlestick.style:{};
	var style=_victoryCore.Helpers.getStyles(props.style,defaultStyle,"auto","100%");
	var data=_victoryCore.Data.addEventKeys(props,this.getData(props));
	var range={
	x:_victoryCore.Helpers.getRange(props,"x"),
	y:_victoryCore.Helpers.getRange(props,"y")};
	
	var domain={
	x:this.getDomain(props,"x"),
	y:this.getDomain(props,"y")};
	
	var scale={
	x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
	y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};
	
	return{domain:domain,data:data,scale:scale,style:style};
	},
	
	getData:function getData(props){
	if(!props.data||props.data.length<1){
	_victoryCore.Log.warn("This is an empty dataset.");
	return[];
	}
	var stringMap={
	x:_victoryCore.Data.createStringMap(props,"x")};
	
	
	var accessor={
	x:_victoryCore.Helpers.createAccessor(props.x!==undefined?props.x:"x"),
	open:_victoryCore.Helpers.createAccessor(props.open!==undefined?props.open:"open"),
	close:_victoryCore.Helpers.createAccessor(props.close!==undefined?props.close:"close"),
	high:_victoryCore.Helpers.createAccessor(props.high!==undefined?props.high:"high"),
	low:_victoryCore.Helpers.createAccessor(props.low!==undefined?props.low:"low")};
	
	return this.sortData(props.data.map(function(datum,index){
	var evaluatedX=accessor.x(datum);
	var _x=evaluatedX!==undefined?evaluatedX:index;
	var _open=accessor.open(datum);
	var _close=accessor.close(datum);
	var _high=accessor.high(datum);
	var _low=accessor.low(datum);
	var _y=[_open,_close,_high,_low];
	return(0,_assign3.default)(
	{},
	datum,
	{_x:_x,_y:_y,_open:_open,_close:_close,_high:_high,_low:_low},
	typeof _x==="string"?{_x:stringMap.x[_x],x:_x}:{});
	
	}),props.sortKey);
	},
	
	sortData:function sortData(dataset,sortKey){
	if(!sortKey){
	return dataset;
	}
	
	if(sortKey==="x"||sortKey==="y"){
	sortKey="_"+sortKey;
	}
	
	return(0,_sortBy3.default)(dataset,sortKey);
	},
	
	getDomain:function getDomain(props,axis){
	var domain=void 0;
	if(props.domain&&props.domain[axis]){
	domain=props.domain[axis];
	}else if(props.domain&&Array.isArray(props.domain)){
	domain=props.domain;
	}else{
	var dataset=this.getData(props);
	var allData=dataset.reduce(function(memo,datum){
	return Array.isArray(datum["_"+axis])?
	memo.concat.apply(memo,_toConsumableArray(datum["_"+axis])):memo.concat(datum["_"+axis]);
	},
	[]);
	
	if(allData.length<1){
	return _victoryCore.Scale.getBaseScale(props,axis).domain();
	}
	
	var min=Math.min.apply(Math,_toConsumableArray(allData));
	var max=Math.max.apply(Math,_toConsumableArray(allData));
	if(min===max){
	var adjustedMax=max===0?1:max+max;
	return[0,adjustedMax];
	}
	domain=[min,max];
	}
	return _victoryCore.Domain.cleanDomain(_victoryCore.Domain.padDomain(domain,props,axis),props);
	},
	
	isTransparent:function isTransparent(attr){
	return attr==="none"||attr==="transparent";
	},
	
	getDataStyles:function getDataStyles(datum,style,props){
	style=style||{};
	var stylesFromData=(0,_omit3.default)(datum,[
	"x","y","size","name","label","open","close","high","low"]);
	
	var candleColor=datum.open>datum.close?
	props.candleColors.negative:props.candleColors.positive;
	var fill=datum.fill||style.fill||candleColor;
	var strokeColor=datum.stroke||style.stroke;
	var stroke=this.isTransparent(strokeColor)?fill:strokeColor||"black";
	return(0,_defaults3.default)({},stylesFromData,{stroke:stroke,fill:fill},style);
	},
	
	getLabelText:function getLabelText(props,datum,index){
	return datum.label||(Array.isArray(props.labels)?
	props.labels[index]:props.labels);
	},
	
	getLabelStyle:function getLabelStyle(labelStyle,dataProps){
	labelStyle=labelStyle||{};var
	size=dataProps.size,style=dataProps.style;
	var matchedStyle=(0,_pick3.default)(style,["opacity","fill"]);
	var padding=labelStyle.padding||size*0.25;
	return(0,_defaults3.default)({},labelStyle,matchedStyle,{padding:padding});
	}};

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	
	var _victoryCore=__webpack_require__(12);
	
	
	
	var _helperMethods=__webpack_require__(1433);var _helperMethods2=_interopRequireDefault(_helperMethods);
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50,
	candleColors:{
	positive:"#ffffff",
	negative:"#252525"}};
	
	
	
	var defaultData=[
	{x:new Date(2016,6,1),open:5,close:10,high:15,low:0},
	{x:new Date(2016,6,2),open:10,close:15,high:20,low:5},
	{x:new Date(2016,6,3),open:15,close:20,high:25,low:10},
	{x:new Date(2016,6,4),open:20,close:25,high:30,low:15},
	{x:new Date(2016,6,5),open:25,close:30,high:35,low:20},
	{x:new Date(2016,6,6),open:30,close:35,high:40,low:25},
	{x:new Date(2016,6,7),open:35,close:40,high:45,low:30},
	{x:new Date(2016,6,8),open:40,close:45,high:50,low:35}];
	
	
	
	var animationWhitelist=[
	"data","domain","height","padding","samples","size","style","width"];var
	
	
	VictoryCandlestick=function(_React$Component){_inherits(VictoryCandlestick,_React$Component);function VictoryCandlestick(){_classCallCheck(this,VictoryCandlestick);return _possibleConstructorReturn(this,(VictoryCandlestick.__proto__||Object.getPrototypeOf(VictoryCandlestick)).apply(this,arguments));}_createClass(VictoryCandlestick,[{key:"shouldAnimate",value:function shouldAnimate()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{
	return!!this.props.animate;
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,role);
	if(this.shouldAnimate()){
	return this.animateComponent(props,animationWhitelist);
	}
	var children=this.renderData(props);
	return this.renderContainer(props.containerComponent,children);
	}}]);return VictoryCandlestick;}(_react2.default.Component);VictoryCandlestick.displayName="VictoryCandlestick";VictoryCandlestick.role="candlestick";VictoryCandlestick.defaultTransitions=_victoryCore.DefaultTransitions.discreteTransitions();VictoryCandlestick.propTypes=_extends({},_commonProps.BaseProps,_commonProps.DataProps,{candleColors:_propTypes2.default.shape({positive:_propTypes2.default.string,negative:_propTypes2.default.string}),close:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)]),high:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)]),low:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)]),open:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)])});VictoryCandlestick.defaultProps={samples:50,scale:"linear",data:defaultData,standalone:true,dataComponent:_react2.default.createElement(_victoryCore.Candle,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",{role:"presentation"}),theme:_victoryCore.VictoryTheme.grayscale};VictoryCandlestick.getDomain=_helperMethods2.default.getDomain.bind(_helperMethods2.default);VictoryCandlestick.getData=_helperMethods2.default.getData.bind(_helperMethods2.default);VictoryCandlestick.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryCandlestick.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=
	
	
	(0,_victoryCore.addEvents)(VictoryCandlestick);

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _values2=__webpack_require__(291);var _values3=_interopRequireDefault(_values2);var _sortBy2=__webpack_require__(78);var _sortBy3=_interopRequireDefault(_sortBy2);var _invert2=__webpack_require__(1018);var _invert3=_interopRequireDefault(_invert2);
	
	var _axis=__webpack_require__(240);var _axis2=_interopRequireDefault(_axis);
	var _wrapper=__webpack_require__(242);var _wrapper2=_interopRequireDefault(_wrapper);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}
	
	var identity=function identity(x){return x;};exports.default=
	
	{
	getChildComponents:function getChildComponents(props,defaultAxes){
	var childComponents=_react2.default.Children.toArray(props.children);
	if(childComponents.length===0){
	return[defaultAxes.independent,defaultAxes.dependent];
	}
	
	var axisComponents={
	dependent:_axis2.default.getAxisComponentsWithParent(childComponents,"dependent"),
	independent:_axis2.default.getAxisComponentsWithParent(childComponents,"independent")};
	
	
	if(axisComponents.dependent.length===0&&axisComponents.independent.length===0){
	return childComponents.concat([defaultAxes.independent,defaultAxes.dependent]);
	}
	if(axisComponents.dependent.length>1||axisComponents.independent.length>1){
	var msg="Only one VictoryAxis component of each axis type is allowed when "+
	"using the VictoryChart wrapper. Only the first axis will be used. Please compose "+
	"multi-axis charts manually";
	_victoryCore.Log.warn(msg);
	var dataComponents=this.getDataComponents(childComponents);
	return _victoryCore.Collection.removeUndefined(
	dataComponents.concat([axisComponents.dependent[0],axisComponents.independent[0]]));
	
	}
	return childComponents;
	},
	
	getDefaultDomainPadding:function getDefaultDomainPadding(childComponents,horizontal){
	var groupComponent=childComponents.filter(function(child){
	return child.type&&child.type.role&&child.type.role==="group-wrapper";
	});
	
	if(groupComponent.length<1){
	return undefined;
	}var _groupComponent$0$pro=
	
	groupComponent[0].props,offset=_groupComponent$0$pro.offset,children=_groupComponent$0$pro.children;
	return horizontal?
	{y:offset*children.length/2}:
	{x:offset*children.length/2};
	},
	
	getDataComponents:function getDataComponents(childComponents){
	var findDataComponents=function findDataComponents(children){
	return children.reduce(function(memo,child){
	if(child.type&&child.type.role==="axis"){
	return memo;
	}else if(child.props&&child.props.children){
	return memo.concat(findDataComponents(_react2.default.Children.toArray(child.props.children)));
	}
	return memo.concat(child);
	},[]);
	};
	
	return findDataComponents(childComponents);
	},
	
	getDomain:function getDomain(props,axis,childComponents){
	childComponents=childComponents||_react2.default.Children.toArray(props.children);
	var domain=_wrapper2.default.getDomain(props,axis,childComponents);
	var orientations=_axis2.default.getAxisOrientations(childComponents);
	return _victoryCore.Domain.orientDomain(domain,orientations,axis);
	},
	
	getAxisOffset:function getAxisOffset(props,calculatedProps){var
	axisComponents=calculatedProps.axisComponents,scale=calculatedProps.scale,origin=calculatedProps.origin,originSign=calculatedProps.originSign;
	
	var axisOrientations={
	x:_axis2.default.getOrientation(axisComponents.x,"x",originSign.x),
	y:_axis2.default.getOrientation(axisComponents.y,"y",originSign.y)};
	
	var orientationOffset={
	x:axisOrientations.y==="left"?0:props.width,
	y:axisOrientations.x==="bottom"?props.height:0};
	
	var calculatedOffset={
	x:Math.abs(orientationOffset.x-scale.x(origin.x)),
	y:Math.abs(orientationOffset.y-scale.y(origin.y))};
	
	
	return{
	x:axisComponents.x&&axisComponents.x.offsetX!==undefined?
	axisComponents.x.offsetX:calculatedOffset.x,
	y:axisComponents.y&&axisComponents.y.offsetY!==undefined?
	axisComponents.y.offsetY:calculatedOffset.y};
	
	},
	
	getTicksFromData:function getTicksFromData(calculatedProps,axis){
	var currentAxis=_victoryCore.Helpers.getCurrentAxis(axis,calculatedProps.horizontal);
	var stringMap=calculatedProps.stringMap[currentAxis];
	
	var categoryArray=calculatedProps.categories[currentAxis];
	var ticksFromCategories=categoryArray&&_victoryCore.Collection.containsOnlyStrings(categoryArray)?
	categoryArray.map(function(tick){return stringMap[tick];}):categoryArray;
	var ticksFromStringMap=stringMap&&(0,_values3.default)(stringMap);
	
	return ticksFromCategories&&ticksFromCategories.length!==0?
	ticksFromCategories:ticksFromStringMap;
	},
	
	getTicksFromAxis:function getTicksFromAxis(calculatedProps,axis,component){
	var tickValues=component.props.tickValues;
	if(!tickValues){
	return undefined;
	}
	var currentAxis=_victoryCore.Helpers.getCurrentAxis(axis,calculatedProps.horizontal);
	var stringMap=calculatedProps.stringMap[currentAxis];
	return _victoryCore.Collection.containsOnlyStrings(tickValues)&&stringMap?
	tickValues.map(function(tick){return stringMap[tick];}):tickValues;
	},
	
	getTicks:function getTicks(){
	return this.getTicksFromAxis.apply(this,arguments)||this.getTicksFromData.apply(this,arguments);
	},
	
	getTickFormat:function getTickFormat(component,axis,calculatedProps){
	var currentAxis=_victoryCore.Helpers.getCurrentAxis(axis,calculatedProps.horizontal);
	var stringMap=calculatedProps.stringMap[currentAxis];
	var tickValues=component.props.tickValues;
	var useIdentity=tickValues&&!_victoryCore.Collection.containsStrings(tickValues)&&
	!_victoryCore.Collection.containsDates(tickValues);
	if(useIdentity){
	return identity;
	}else if(stringMap!==null){
	var tickValueArray=(0,_sortBy3.default)((0,_values3.default)(stringMap),function(n){return n;});
	var invertedStringMap=(0,_invert3.default)(stringMap);
	var dataNames=tickValueArray.map(function(tick){return invertedStringMap[tick];});
	
	var dataTicks=[""].concat(_toConsumableArray(dataNames),[""]);
	return function(x){return dataTicks[x];};
	}else{
	return calculatedProps.scale[currentAxis].tickFormat()||identity;
	}
	},
	
	createStringMap:function createStringMap(props,axis,childComponents){
	var allStrings=_wrapper2.default.getStringsFromChildren(props,axis,childComponents);
	return allStrings.length===0?null:
	allStrings.reduce(function(memo,string,index){
	memo[string]=index+1;
	return memo;
	},{});
	}};

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _victoryCore=__webpack_require__(12);
	var _victoryAxis=__webpack_require__(633);var _victoryAxis2=_interopRequireDefault(_victoryAxis);
	var _helperMethods=__webpack_require__(1435);var _helperMethods2=_interopRequireDefault(_helperMethods);
	var _axis=__webpack_require__(240);var _axis2=_interopRequireDefault(_axis);
	var _wrapper=__webpack_require__(242);var _wrapper2=_interopRequireDefault(_wrapper);
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50};var
	
	
	VictoryChart=function(_React$Component){_inherits(VictoryChart,_React$Component);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function VictoryChart(props){_classCallCheck(this,VictoryChart);var _this=_possibleConstructorReturn(this,(VictoryChart.__proto__||Object.getPrototypeOf(VictoryChart)).call(this,
	props));
	_this.state={};
	if(props.animate){
	_this.state={
	nodesShouldLoad:false,
	nodesDoneLoad:false,
	animating:true};
	
	_this.setAnimationState=_wrapper2.default.setAnimationState.bind(_this);
	}
	_this.events=_wrapper2.default.getAllEvents(props);return _this;
	}_createClass(VictoryChart,[{key:"componentWillMount",value:function componentWillMount()
	
	{
	this.events=_wrapper2.default.getAllEvents(this.props);
	}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(
	
	nextProps){
	if(this.props.animate){
	this.setAnimationState(this.props,nextProps);
	}
	this.events=_wrapper2.default.getAllEvents(nextProps);
	}},{key:"getStyles",value:function getStyles(
	
	props){
	var styleProps=props.style&&props.style.parent;
	return{
	parent:(0,_defaults3.default)({
	height:"auto",
	width:"100%",
	userSelect:"none"},
	
	styleProps)};
	
	}},{key:"getAxisProps",value:function getAxisProps(
	
	child,props,calculatedProps){var
	domain=calculatedProps.domain,scale=calculatedProps.scale,originSign=calculatedProps.originSign;
	var axis=child.type.getAxis(child.props);
	var axisOffset=_helperMethods2.default.getAxisOffset(props,calculatedProps);
	var tickValues=_helperMethods2.default.getTicks(calculatedProps,axis,child);
	var tickFormat=
	child.props.tickFormat||_helperMethods2.default.getTickFormat(child,axis,calculatedProps);
	var offsetY=axis==="y"?undefined:axisOffset.y;
	var offsetX=axis==="x"?undefined:axisOffset.x;
	var crossAxis=child.props.crossAxis===false?false:true;
	var orientation=_axis2.default.getOrientation(child,axis,originSign[axis]);
	return{
	domain:domain[axis],
	scale:scale[axis],
	tickValues:tickValues,
	tickFormat:tickFormat,
	offsetY:child.props.offsetY!==undefined?child.props.offsetY:offsetY,
	offsetX:child.props.offsetX!==undefined?child.props.offsetX:offsetX,
	crossAxis:crossAxis,
	orientation:orientation};
	
	
	}},{key:"getChildProps",value:function getChildProps(
	
	child,props,calculatedProps){
	var axisChild=_axis2.default.findAxisComponents([child]);
	if(axisChild.length>0){
	return this.getAxisProps(axisChild[0],props,calculatedProps);
	}
	return{
	domain:calculatedProps.domain,
	scale:calculatedProps.scale,
	categories:calculatedProps.categories};
	
	}},{key:"getCalculatedProps",value:function getCalculatedProps(
	
	props,childComponents){
	var style=this.getStyles(props);
	var horizontal=childComponents.some(function(component){
	return component.props&&component.props.horizontal;
	});
	var axisComponents={
	x:_axis2.default.getAxisComponent(childComponents,"x"),
	y:_axis2.default.getAxisComponent(childComponents,"y")};
	
	var domain={
	x:_helperMethods2.default.getDomain(props,"x",childComponents),
	y:_helperMethods2.default.getDomain(props,"y",childComponents)};
	
	var range={
	x:_victoryCore.Helpers.getRange(props,"x"),
	y:_victoryCore.Helpers.getRange(props,"y")};
	
	var baseScale={
	x:_victoryCore.Scale.getScaleFromProps(props,"x")||
	axisComponents.x&&axisComponents.x.type.getScale(axisComponents.x.props)||
	_victoryCore.Scale.getDefaultScale(),
	y:_victoryCore.Scale.getScaleFromProps(props,"y")||
	axisComponents.y&&axisComponents.y.type.getScale(axisComponents.y.props)||
	_victoryCore.Scale.getDefaultScale()};
	
	var scale={
	x:baseScale.x.domain(domain.x).range(range.x),
	y:baseScale.y.domain(domain.y).range(range.y)};
	
	
	var origin={
	x:_axis2.default.getOrigin(domain.x),
	y:_axis2.default.getOrigin(domain.y)};
	
	
	var originSign={
	x:_axis2.default.getOriginSign(origin.x,domain.x),
	y:_axis2.default.getOriginSign(origin.y,domain.y)};
	
	
	
	var categories={
	x:_wrapper2.default.getCategories(props,"x",childComponents),
	y:_wrapper2.default.getCategories(props,"y",childComponents)};
	
	
	var stringMap={
	x:_helperMethods2.default.createStringMap(props,"x",childComponents),
	y:_helperMethods2.default.createStringMap(props,"y",childComponents)};
	
	
	var defaultDomainPadding=_helperMethods2.default.getDefaultDomainPadding(childComponents,horizontal);
	
	return{
	axisComponents:axisComponents,categories:categories,domain:domain,horizontal:horizontal,scale:scale,stringMap:stringMap,
	style:style,origin:origin,originSign:originSign,defaultDomainPadding:defaultDomainPadding};
	
	}},{key:"getNewChildren",value:function getNewChildren(
	
	props,childComponents,calculatedProps){var _this2=this;
	var baseStyle=calculatedProps.style.parent;
	var getAnimationProps=_wrapper2.default.getAnimationProps.bind(this);
	
	return childComponents.map(function(child,index){
	var style=(0,_defaults3.default)({},child.props.style,{parent:baseStyle});
	var childProps=_this2.getChildProps(child,props,calculatedProps);
	var newProps=(0,_defaults3.default)({
	animate:getAnimationProps(props,child,index),
	height:props.height,
	width:props.width,
	clipWidth:props.width,
	clipHeight:props.height,
	padding:_victoryCore.Helpers.getPadding(props),
	key:index,
	theme:props.theme,
	standalone:false,
	style:style},
	childProps);
	
	return _react2.default.cloneElement(child,newProps);
	});
	}},{key:"renderContainer",value:function renderContainer(
	
	containerComponent,props){
	var containerProps=(0,_defaults3.default)({},containerComponent.props,props);
	return _react2.default.cloneElement(containerComponent,containerProps);
	}},{key:"getContainerProps",value:function getContainerProps(
	
	props,calculatedProps){var
	width=props.width,height=props.height,standalone=props.standalone,theme=props.theme;var
	domain=calculatedProps.domain,scale=calculatedProps.scale,style=calculatedProps.style;
	return{
	domain:domain,scale:scale,width:width,height:height,standalone:standalone,theme:theme,style:style.parent};
	
	}},{key:"render",value:function render()
	
	{
	var props=this.state&&this.state.nodesWillExit?
	this.state.oldProps||this.props:this.props;
	var modifiedProps=_victoryCore.Helpers.modifyProps(props,fallbackProps,"chart");var
	eventKey=modifiedProps.eventKey,containerComponent=modifiedProps.containerComponent;
	var childComponents=_helperMethods2.default.getChildComponents(modifiedProps,
	modifiedProps.defaultAxes);
	var calculatedProps=this.getCalculatedProps(modifiedProps,childComponents);
	var newChildren=this.getNewChildren(modifiedProps,childComponents,calculatedProps);
	var containerProps=this.getContainerProps(modifiedProps,calculatedProps);
	var container=this.renderContainer(containerComponent,containerProps);
	if(this.events){
	return(
	_react2.default.createElement(_victoryCore.VictorySharedEvents,{events:this.events,eventKey:eventKey,container:container},
	newChildren));
	
	
	}
	return _react2.default.cloneElement(container,container.props,newChildren);
	}}]);return VictoryChart;}(_react2.default.Component);VictoryChart.displayName="VictoryChart";VictoryChart.propTypes=_extends({},_commonProps.BaseProps,{children:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node),_propTypes2.default.node]),defaultAxes:_propTypes2.default.shape({independent:_propTypes2.default.element,dependent:_propTypes2.default.element})});VictoryChart.defaultProps={containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),defaultAxes:{independent:_react2.default.createElement(_victoryAxis2.default,null),dependent:_react2.default.createElement(_victoryAxis2.default,{dependentAxis:true})},groupComponent:_react2.default.createElement("g",null),standalone:true,theme:_victoryCore.VictoryTheme.grayscale};VictoryChart.expectedComponents=["groupComponent","containerComponent"];exports.default=VictoryChart;

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _pick2=__webpack_require__(94);var _pick3=_interopRequireDefault(_pick2);var _sortBy2=__webpack_require__(78);var _sortBy3=_interopRequireDefault(_sortBy2);var _flatten2=__webpack_require__(205);var _flatten3=_interopRequireDefault(_flatten2);var _isArray2=__webpack_require__(16);var _isArray3=_interopRequireDefault(_isArray2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
	props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"errorbar");var _getCalculatedValues=
	this.getCalculatedValues(props,fallbackProps),data=_getCalculatedValues.data,style=_getCalculatedValues.style,scale=_getCalculatedValues.scale,domain=_getCalculatedValues.domain;var _props=
	props,groupComponent=_props.groupComponent,height=_props.height,width=_props.width,borderWidth=_props.borderWidth,standalone=_props.standalone,theme=_props.theme;
	var initialChildProps={parent:{
	domain:domain,style:style.parent,scale:scale,data:data,height:height,width:width,standalone:standalone,theme:theme}};
	
	
	return data.reduce(function(childProps,datum,index){
	var eventKey=datum.eventKey||index;
	var x=scale.x(datum._x1!==undefined?datum._x1:datum._x);
	var y=scale.y(datum._y1!==undefined?datum._y1:datum._y);
	
	var dataProps={
	x:x,y:y,scale:scale,datum:datum,data:data,index:index,groupComponent:groupComponent,borderWidth:borderWidth,
	style:_this.getDataStyles(datum,style.data),
	errorX:_this.getErrors(datum,scale,"x"),
	errorY:_this.getErrors(datum,scale,"y")};
	
	
	childProps[eventKey]={
	data:dataProps};
	
	var text=_this.getLabelText(props,datum,index);
	if(text!==undefined&&text!==null||props.events||props.sharedEvents){
	childProps[eventKey].labels=_this.getLabelProps(dataProps,text,style);
	}
	
	return childProps;
	},initialChildProps);
	},
	
	getLabelProps:function getLabelProps(dataProps,text,calculatedStyle){var
	x=dataProps.x,index=dataProps.index,scale=dataProps.scale,errorY=dataProps.errorY;
	var error=errorY&&Array.isArray(errorY)?errorY[0]:errorY;
	var y=error||dataProps.y;
	var labelStyle=this.getLabelStyle(calculatedStyle.labels,dataProps)||{};
	return{
	style:labelStyle,
	y:y-(labelStyle.padding||0),
	x:x,
	text:text,
	index:index,
	scale:scale,
	datum:dataProps.datum,
	data:dataProps.data,
	textAnchor:labelStyle.textAnchor,
	verticalAnchor:labelStyle.verticalAnchor||"end",
	angle:labelStyle.angle};
	
	},
	
	getErrorData:function getErrorData(props){
	if(props.data){
	if(props.data.length<1){
	_victoryCore.Log.warn("This is an empty dataset.");
	return[];
	}
	
	return this.formatErrorData(props.data,props);
	}else{
	var generatedData=(props.errorX||props.errorY)&&this.generateData(props);
	return this.formatErrorData(generatedData,props);
	}
	},
	
	getErrors:function getErrors(datum,scale,axis){
	
	
	
	
	
	
	
	var errorNames={x:"errorX",y:"errorY"};
	var errors=datum[errorNames[axis]];
	if(errors===0){
	return false;
	}
	
	return(0,_isArray3.default)(errors)?
	[errors[0]===0?false:scale[axis](errors[0]+datum["_"+axis]),
	errors[1]===0?false:scale[axis](datum["_"+axis]-errors[1])]:
	[scale[axis](errors+datum["_"+axis]),scale[axis](datum["_"+axis]-errors)];
	},
	
	formatErrorData:function formatErrorData(dataset,props){
	if(!dataset){
	return[];
	}
	var accessor={
	x:_victoryCore.Helpers.createAccessor(props.x!==undefined?props.x:"x"),
	y:_victoryCore.Helpers.createAccessor(props.y!==undefined?props.y:"y"),
	errorX:_victoryCore.Helpers.createAccessor(props.errorX!==undefined?props.errorX:"errorX"),
	errorY:_victoryCore.Helpers.createAccessor(props.errorY!==undefined?props.errorY:"errorY")};
	
	
	var replaceNegatives=function replaceNegatives(errors){
	
	var replaceNeg=function replaceNeg(val){return!val||val<0?0:val;};
	return(0,_isArray3.default)(errors)?errors.map(function(err){return replaceNeg(err);}):replaceNeg(errors);
	};
	
	var stringMap={
	x:_victoryCore.Data.createStringMap(props,"x"),
	y:_victoryCore.Data.createStringMap(props,"y")};
	
	
	return this.sortData(dataset.map(function(datum,index){
	var evaluatedX=accessor.x(datum);
	var evaluatedY=accessor.y(datum);
	var _x=evaluatedX!==undefined?evaluatedX:index;
	var _y=evaluatedY!==undefined?evaluatedY:datum;
	var errorX=replaceNegatives(accessor.errorX(datum));
	var errorY=replaceNegatives(accessor.errorY(datum));
	
	return(0,_assign3.default)(
	{},
	datum,
	{_x:_x,_y:_y,errorX:errorX,errorY:errorY},
	
	typeof _x==="string"?{_x:stringMap.x[_x],x:_x}:{},
	typeof _y==="string"?{_y:stringMap.y[_y],y:_y}:{});
	
	}),props.sortKey);
	},
	
	sortData:function sortData(dataset,sortKey){
	if(!sortKey){
	return dataset;
	}
	
	if(sortKey==="x"||sortKey==="y"){
	sortKey="_"+sortKey;
	}
	
	return(0,_sortBy3.default)(dataset,sortKey);
	},
	
	getDomain:function getDomain(props,axis){
	var propsDomain=_victoryCore.Domain.getDomainFromProps(props,axis);
	if(propsDomain){
	return _victoryCore.Domain.padDomain(propsDomain,props,axis);
	}
	var categoryDomain=_victoryCore.Domain.getDomainFromCategories(props,axis);
	if(categoryDomain){
	return _victoryCore.Domain.padDomain(categoryDomain,props,axis);
	}
	var dataset=this.getErrorData(props);
	
	if(dataset.length<1){
	return _victoryCore.Scale.getBaseScale(props,axis).domain();
	}
	
	var domain=this.getDomainFromData(props,axis,dataset);
	return _victoryCore.Domain.cleanDomain(_victoryCore.Domain.padDomain(domain,props,axis),props);
	},
	
	getDomainFromData:function getDomainFromData(props,axis,dataset){
	var currentAxis=_victoryCore.Helpers.getCurrentAxis(axis,props.horizontal);
	var error=void 0;
	if(currentAxis==="x"){
	error="errorX";
	}else if(currentAxis==="y"){
	error="errorY";
	}
	var axisData=(0,_flatten3.default)(dataset).map(function(datum){return datum["_"+currentAxis];});
	var errorData=(0,_flatten3.default)((0,_flatten3.default)(dataset).map(function(datum){
	var errorMax=void 0;
	var errorMin=void 0;
	if((0,_isArray3.default)(datum[error])){
	errorMax=datum[error][0]+datum["_"+currentAxis];
	errorMin=datum["_"+currentAxis]-datum[error][1];
	}else{
	errorMax=datum[error]+datum["_"+currentAxis];
	errorMin=datum["_"+currentAxis]-datum[error];
	}
	return[errorMax,errorMin];
	}));
	
	var allData=axisData.concat(errorData);
	var min=Math.min.apply(Math,_toConsumableArray(allData));
	var max=Math.max.apply(Math,_toConsumableArray(allData));
	
	
	if(min===max){
	var adjustedMax=max===0?1:max;
	return[0,adjustedMax];
	}
	return[min,max];
	},
	
	getCalculatedValues:function getCalculatedValues(props){
	var defaultStyles=props.theme&&props.theme.errorbar&&props.theme.errorbar.style?
	props.theme.errorbar.style:{};
	var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%")||{};
	var dataWithErrors=(0,_assign3.default)(_victoryCore.Data.getData(props),this.getErrorData(props));
	var data=_victoryCore.Data.addEventKeys(props,dataWithErrors);
	var range={
	x:_victoryCore.Helpers.getRange(props,"x"),
	y:_victoryCore.Helpers.getRange(props,"y")};
	
	var domain={
	x:this.getDomain(props,"x"),
	y:this.getDomain(props,"y")};
	
	var scale={
	x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
	y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};
	
	
	return{domain:domain,data:data,scale:scale,style:style};
	},
	
	getDataStyles:function getDataStyles(datum,style){
	var stylesFromData=(0,_omit3.default)(datum,[
	"x","y","name","errorX","errorY","eventKey"]);
	
	return(0,_defaults3.default)({},stylesFromData,style);
	},
	
	getLabelText:function getLabelText(props,datum,index){
	return datum.label||Array.isArray(props.labels)?
	props.labels[index]:props.labels;
	},
	
	getLabelStyle:function getLabelStyle(labelStyle,dataProps){
	labelStyle=labelStyle||{};var
	size=dataProps.size,style=dataProps.style;
	var matchedStyle=(0,_pick3.default)(style,["opacity","fill"]);
	var padding=labelStyle.padding||size*0.25;
	return(0,_defaults3.default)({},labelStyle,matchedStyle,{padding:padding})||{};
	}};

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _victoryCore=__webpack_require__(12);
	
	
	
	
	var _helperMethods=__webpack_require__(1437);var _helperMethods2=_interopRequireDefault(_helperMethods);
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50};
	
	
	var defaultData=[
	{x:1,y:1,errorX:0.1,errorY:0.1},
	{x:2,y:2,errorX:0.2,errorY:0.2},
	{x:3,y:3,errorX:0.3,errorY:0.3},
	{x:4,y:4,errorX:0.4,errorY:0.4}];
	
	
	var animationWhitelist=[
	"data","domain","height","padding","samples",
	"style","width","errorX","errorY","borderWidth"];var
	
	
	VictoryErrorBar=function(_React$Component){_inherits(VictoryErrorBar,_React$Component);function VictoryErrorBar(){_classCallCheck(this,VictoryErrorBar);return _possibleConstructorReturn(this,(VictoryErrorBar.__proto__||Object.getPrototypeOf(VictoryErrorBar)).apply(this,arguments));}_createClass(VictoryErrorBar,[{key:"shouldAnimate",value:function shouldAnimate()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{
	return!!this.props.animate;
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,role);
	if(this.shouldAnimate()){
	return this.animateComponent(props,animationWhitelist);
	}
	var children=this.renderData(props);
	return this.renderContainer(props.containerComponent,children);
	}}]);return VictoryErrorBar;}(_react2.default.Component);VictoryErrorBar.displayName="VictoryErrorBar";VictoryErrorBar.role="errorBar";VictoryErrorBar.defaultTransitions=_victoryCore.DefaultTransitions.discreteTransitions();VictoryErrorBar.propTypes=_extends({},_commonProps.BaseProps,_commonProps.DataProps,{borderWidth:_propTypes2.default.number,errorX:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)]),errorY:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)]),horizontal:_propTypes2.default.bool});VictoryErrorBar.defaultProps={data:defaultData,scale:"linear",standalone:true,dataComponent:_react2.default.createElement(_victoryCore.ErrorBar,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",{role:"presentation"}),theme:_victoryCore.VictoryTheme.grayscale};VictoryErrorBar.getDomain=_helperMethods2.default.getDomain.bind(_helperMethods2.default);VictoryErrorBar.getData=_victoryCore.Data.getData.bind(_victoryCore.Data);VictoryErrorBar.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryErrorBar.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=
	
	
	(0,_victoryCore.addEvents)(VictoryErrorBar);

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _victoryCore=__webpack_require__(12);
	
	
	var _wrapper=__webpack_require__(242);var _wrapper2=_interopRequireDefault(_wrapper);
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50,
	offset:0};var
	
	
	VictoryGroup=function(_React$Component){_inherits(VictoryGroup,_React$Component);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function VictoryGroup(props){_classCallCheck(this,VictoryGroup);var _this=_possibleConstructorReturn(this,(VictoryGroup.__proto__||Object.getPrototypeOf(VictoryGroup)).call(this,
	props));
	if(props.animate){
	_this.state={
	nodesShouldLoad:false,
	nodesDoneLoad:false,
	animating:true};
	
	_this.setAnimationState=_wrapper2.default.setAnimationState.bind(_this);
	_this.events=_wrapper2.default.getAllEvents(props);
	}return _this;
	}_createClass(VictoryGroup,[{key:"componentWillMount",value:function componentWillMount()
	
	{
	this.events=_wrapper2.default.getAllEvents(this.props);
	}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(
	
	nextProps){
	if(this.props.animate){
	this.setAnimationState(this.props,nextProps);
	}
	this.events=_wrapper2.default.getAllEvents(nextProps);
	}},{key:"getCalculatedProps",value:function getCalculatedProps(
	
	props,childComponents){var
	role=this.constructor.role;
	var style=this.getStyle(props.theme,props.style,role);
	var modifiedProps=_victoryCore.Helpers.modifyProps(props,fallbackProps);
	var horizontal=modifiedProps.horizontal||childComponents.every(
	function(component){return component.props&&component.props.horizontal;});
	
	var datasets=_wrapper2.default.getDataFromChildren(modifiedProps);
	var domain={
	x:_wrapper2.default.getDomain(modifiedProps,"x",childComponents),
	y:_wrapper2.default.getDomain(modifiedProps,"y",childComponents)};
	
	var range={
	x:_victoryCore.Helpers.getRange(modifiedProps,"x"),
	y:_victoryCore.Helpers.getRange(modifiedProps,"y")};
	
	var baseScale={
	x:_victoryCore.Scale.getScaleFromProps(modifiedProps,"x")||_victoryCore.Scale.getDefaultScale(),
	y:_victoryCore.Scale.getScaleFromProps(modifiedProps,"y")||_victoryCore.Scale.getDefaultScale()};
	
	var xScale=baseScale.x.domain(domain.x).range(range.x);
	var yScale=baseScale.y.domain(domain.y).range(range.y);
	var scale={
	x:horizontal?yScale:xScale,
	y:horizontal?xScale:yScale};
	
	var categories={
	x:_wrapper2.default.getCategories(modifiedProps,"x"),
	y:_wrapper2.default.getCategories(modifiedProps,"y")};
	
	var colorScale=modifiedProps.colorScale;
	var color=modifiedProps.color;
	return{datasets:datasets,categories:categories,range:range,domain:domain,horizontal:horizontal,scale:scale,style:style,colorScale:colorScale,color:color};
	}},{key:"pixelsToValue",value:function pixelsToValue(
	
	props,axis,calculatedProps){
	if(props.offset===0){
	return 0;
	}
	var childComponents=_react2.default.Children.toArray(props.children);
	var horizontalChildren=childComponents.some(function(child){return child.props.horizontal;});
	var horizontal=props&&props.horizontal||horizontalChildren.length>0;
	var currentAxis=_victoryCore.Helpers.getCurrentAxis(axis,horizontal);
	var domain=calculatedProps.domain[currentAxis];
	var range=calculatedProps.range[currentAxis];
	var domainExtent=Math.max.apply(Math,_toConsumableArray(domain))-Math.min.apply(Math,_toConsumableArray(domain));
	var rangeExtent=Math.max.apply(Math,_toConsumableArray(range))-Math.min.apply(Math,_toConsumableArray(range));
	return domainExtent/rangeExtent*props.offset;
	}},{key:"getXO",value:function getXO(
	
	props,calculatedProps,index){
	var center=(calculatedProps.datasets.length-1)/2;
	var totalWidth=this.pixelsToValue(props,"x",calculatedProps);
	return(index-center)*totalWidth;
	}},{key:"getLabels",value:function getLabels(
	
	props,datasets,index){
	if(!props.labels){
	return undefined;
	}
	return Math.floor(datasets.length/2)===index?props.labels:undefined;
	}},{key:"getChildProps",value:function getChildProps(
	
	props,calculatedProps){var
	categories=calculatedProps.categories,domain=calculatedProps.domain,scale=calculatedProps.scale,horizontal=calculatedProps.horizontal;
	return{
	height:props.height,
	width:props.width,
	padding:_victoryCore.Helpers.getPadding(props),
	standalone:false,
	theme:props.theme,
	categories:categories,
	domain:domain,
	scale:scale,
	horizontal:horizontal};
	
	}},{key:"getColorScale",value:function getColorScale(
	
	props,child){
	var role=child.type&&child.type.role;
	var colorScaleOptions=child.props.colorScale||props.colorScale;
	if(role!=="group"&&role!=="stack"){
	return undefined;
	}
	return props.theme&&props.theme.group?colorScaleOptions||props.theme.group.colorScale:
	colorScaleOptions;
	}},{key:"getDataWithOffset",value:function getDataWithOffset(
	
	props,defaultDataset,offset){
	var dataset=props.data||props.y?_victoryCore.Data.getData(props):defaultDataset;
	var xOffset=offset||0;
	return dataset.map(function(datum){
	var _x1=datum._x instanceof Date?new Date(datum._x+xOffset):datum._x+xOffset;
	return(0,_assign3.default)({},datum,{_x1:_x1});
	});
	}},{key:"getNewChildren",value:function getNewChildren(
	
	
	props,childComponents,calculatedProps){var _this2=this;var
	datasets=calculatedProps.datasets,horizontal=calculatedProps.horizontal,domain=calculatedProps.domain;var
	theme=props.theme,labelComponent=props.labelComponent;
	var childProps=this.getChildProps(props,calculatedProps);
	var getAnimationProps=_wrapper2.default.getAnimationProps.bind(this);
	
	return childComponents.map(function(child,index){
	var role=child.type&&child.type.role;
	var xOffset=_this2.getXO(props,calculatedProps,index);
	var style=role==="voronoi"||role==="tooltip"?
	child.props.style:_wrapper2.default.getChildStyle(child,index,calculatedProps);
	var labels=props.labels?_this2.getLabels(props,datasets,index):child.props.labels;
	return _react2.default.cloneElement(child,(0,_assign3.default)({
	domain:domain,labels:labels,style:style,theme:theme,horizontal:horizontal,
	data:_this2.getDataWithOffset(props,datasets[index],xOffset),
	animate:getAnimationProps(props,child,index),
	colorScale:_this2.getColorScale(props,child),
	key:index,
	labelComponent:labelComponent||child.props.labelComponent,
	xOffset:role==="stack"?xOffset:undefined},
	childProps));
	});
	}},{key:"renderContainer",value:function renderContainer(
	
	containerComponent,props){
	var containerProps=(0,_defaults3.default)({},containerComponent.props,props);
	return _react2.default.cloneElement(containerComponent,containerProps);
	}},{key:"getContainerProps",value:function getContainerProps(
	
	props,calculatedProps){var
	width=props.width,height=props.height,standalone=props.standalone,theme=props.theme;var
	domain=calculatedProps.domain,scale=calculatedProps.scale,style=calculatedProps.style;
	return{
	domain:domain,scale:scale,width:width,height:height,standalone:standalone,theme:theme,style:style.parent};
	
	}},{key:"getStyle",value:function getStyle(
	
	theme,style,role){
	var defaultStyle=theme&&theme[role]&&theme[role].style?theme[role].style:{};
	return _victoryCore.Helpers.getStyles(style,defaultStyle,"auto","100%");
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=this.state&&this.state.nodesWillExit?
	this.state.oldProps||this.props:this.props;
	var modifiedProps=_victoryCore.Helpers.modifyProps(props,fallbackProps,role);var
	eventKey=modifiedProps.eventKey,containerComponent=modifiedProps.containerComponent;
	var childComponents=_react2.default.Children.toArray(modifiedProps.children);
	var calculatedProps=this.getCalculatedProps(modifiedProps,childComponents);
	var newChildren=this.getNewChildren(modifiedProps,childComponents,calculatedProps);
	var containerProps=this.getContainerProps(modifiedProps,calculatedProps);
	var container=this.renderContainer(containerComponent,containerProps);
	if(this.events){
	return(
	_react2.default.createElement(_victoryCore.VictorySharedEvents,{events:this.events,eventKey:eventKey,container:container},
	newChildren));
	
	
	}
	return _react2.default.cloneElement(container,container.props,newChildren);
	}}]);return VictoryGroup;}(_react2.default.Component);VictoryGroup.displayName="VictoryGroup";VictoryGroup.role="group";VictoryGroup.propTypes=_extends({},_commonProps.BaseProps,_commonProps.DataProps,{children:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node),_propTypes2.default.node]),color:_propTypes2.default.string,colorScale:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string),_propTypes2.default.oneOf(["grayscale","qualitative","heatmap","warm","cool","red","green","blue"])]),horizontal:_propTypes2.default.bool,offset:_propTypes2.default.number});VictoryGroup.defaultProps={containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",null),samples:50,scale:"linear",standalone:true,theme:_victoryCore.VictoryTheme.grayscale};VictoryGroup.getDomain=_wrapper2.default.getDomain.bind(_wrapper2.default);VictoryGroup.getData=_wrapper2.default.getData.bind(_wrapper2.default);exports.default=VictoryGroup;

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);
	
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=
	
	{
	getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
	props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"line");
	var calculatedValues=this.getCalculatedValues(props);var
	scale=calculatedValues.scale,data=calculatedValues.data,domain=calculatedValues.domain,style=calculatedValues.style;var _props=
	
	
	props,interpolation=_props.interpolation,width=_props.width,height=_props.height,events=_props.events,sharedEvents=_props.sharedEvents,standalone=_props.standalone,groupComponent=_props.groupComponent,theme=_props.theme;
	var initialChildProps={
	parent:{style:style.parent,scale:scale,data:data,height:height,width:width,domain:domain,standalone:standalone},
	all:{data:{scale:scale,data:data,interpolation:interpolation,groupComponent:groupComponent,theme:theme,style:style.data}}};
	
	return data.reduce(function(childProps,datum,index){
	var text=_this.getLabelText(props,datum,index);
	if(text!==undefined&&text!==null||events||sharedEvents){
	var eventKey=datum.eventKey||index;
	childProps[eventKey]={labels:_this.getLabelProps(text,index,calculatedValues)};
	}
	return childProps;
	},initialChildProps);
	},
	
	getCalculatedValues:function getCalculatedValues(props){
	var data=_victoryCore.Data.getData(props);
	
	if(data.length<2){
	_victoryCore.Log.warn("VictoryLine needs at least two data points to render properly.");
	data=[];
	}
	
	var range={
	x:_victoryCore.Helpers.getRange(props,"x"),
	y:_victoryCore.Helpers.getRange(props,"y")};
	
	var domain={
	x:_victoryCore.Domain.getDomain(props,"x"),
	y:_victoryCore.Domain.getDomain(props,"y")};
	
	var scale={
	x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
	y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};
	
	
	var defaultStyles=props.theme&&props.theme.line&&props.theme.line.style?
	props.theme.line.style:{};
	var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%");
	
	return{domain:domain,data:data,scale:scale,style:style};
	},
	
	getLabelText:function getLabelText(props,datum,index){
	return datum.label||(Array.isArray(props.labels)?
	props.labels[index]:props.labels);
	},
	
	getLabelProps:function getLabelProps(text,index,calculatedProps){var
	scale=calculatedProps.scale,data=calculatedProps.data,style=calculatedProps.style;
	var datum=data[index];var _getLabelPosition=
	this.getLabelPosition(datum,scale),x=_getLabelPosition.x,y=_getLabelPosition.y;
	var labelStyle=this.getLabelStyle(style)||{};
	var sign=(datum._y1||datum._y)<0?-1:1;
	return{
	style:labelStyle,
	x:x,
	y:y-sign*(labelStyle.padding||0),
	text:text,
	index:index,
	scale:scale,
	datum:datum,
	data:data,
	textAnchor:labelStyle.textAnchor,
	verticalAnchor:labelStyle.verticalAnchor||"end",
	angle:labelStyle.angle};
	
	},
	
	getLabelPosition:function getLabelPosition(datum,scale){
	return{
	x:scale.x(datum._x1!==undefined?datum._x1:datum._x),
	y:scale.y(datum._y1!==undefined?datum._y1:datum._y)};
	
	},
	
	getLabelStyle:function getLabelStyle(style){
	var dataStyle=style.data||{};
	var labelStyle=style.labels||{};
	
	var opacity=dataStyle.opacity;
	
	
	var fill=dataStyle.stroke;
	var padding=labelStyle.padding||0;
	return(0,_defaults3.default)({},labelStyle,{opacity:opacity,fill:fill,padding:padding});
	}};

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _helperMethods=__webpack_require__(1440);var _helperMethods2=_interopRequireDefault(_helperMethods);
	var _victoryCore=__webpack_require__(12);
	
	
	
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50,
	interpolation:"linear"};
	
	
	var animationWhitelist=["data","domain","height","padding","samples","style","width"];var
	
	VictoryLine=function(_React$Component){_inherits(VictoryLine,_React$Component);function VictoryLine(){_classCallCheck(this,VictoryLine);return _possibleConstructorReturn(this,(VictoryLine.__proto__||Object.getPrototypeOf(VictoryLine)).apply(this,arguments));}_createClass(VictoryLine,[{key:"shouldAnimate",value:function shouldAnimate()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{
	return!!this.props.animate;
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,role);
	if(this.shouldAnimate()){
	return this.animateComponent(props,animationWhitelist);
	}
	var children=this.renderContinuousData(props);
	return this.renderContainer(props.containerComponent,children);
	}}]);return VictoryLine;}(_react2.default.Component);VictoryLine.displayName="VictoryLine";VictoryLine.role="line";VictoryLine.defaultTransitions=_victoryCore.DefaultTransitions.continuousTransitions();VictoryLine.continuous=true;VictoryLine.propTypes=_extends({},_commonProps.BaseProps,_commonProps.DataProps,{interpolation:_propTypes2.default.oneOf(["basis","bundle","cardinal","catmullRom","linear","monotoneX","monotoneY","natural","radial","step","stepAfter","stepBefore"]),label:_victoryCore.PropTypes.deprecated(_propTypes2.default.string,"Use `labels` instead for individual data labels")});VictoryLine.defaultProps={samples:50,scale:"linear",standalone:true,sortKey:"x",dataComponent:_react2.default.createElement(_victoryCore.Curve,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement(_victoryCore.VictoryClipContainer,null),theme:_victoryCore.VictoryTheme.grayscale};VictoryLine.getDomain=_victoryCore.Domain.getDomain.bind(_victoryCore.Domain);VictoryLine.getData=_victoryCore.Data.getData.bind(_victoryCore.Data);VictoryLine.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryLine.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=
	
	(0,_victoryCore.addEvents)(VictoryLine);

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);var _pick2=__webpack_require__(94);var _pick3=_interopRequireDefault(_pick2);var _values2=__webpack_require__(291);var _values3=_interopRequireDefault(_values2);
	var _victoryCore=__webpack_require__(12);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
	props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"scatter");
	var calculatedValues=this.getCalculatedValues(props);var _props=
	props,height=_props.height,width=_props.width,standalone=_props.standalone,theme=_props.theme;var
	data=calculatedValues.data,style=calculatedValues.style,scale=calculatedValues.scale,domain=calculatedValues.domain;
	var initialChildProps={parent:{
	style:style.parent,scale:scale,domain:domain,data:data,height:height,width:width,standalone:standalone,theme:theme}};
	
	
	return data.reduce(function(childProps,datum,index){
	var eventKey=datum.eventKey;
	var x=scale.x(datum._x1!==undefined?datum._x1:datum._x);
	var y=scale.y(datum._y1!==undefined?datum._y1:datum._y);
	var dataProps={
	x:x,y:y,datum:datum,data:data,index:index,scale:scale,
	size:_this.getSize(datum,props,calculatedValues),
	symbol:_this.getSymbol(datum,props),
	style:_this.getDataStyles(datum,style.data)};
	
	
	childProps[eventKey]={data:dataProps};
	var text=_this.getLabelText(props,datum,index);
	if(text!==undefined&&text!==null||props.events||props.sharedEvents){
	childProps[eventKey].labels=_this.getLabelProps(dataProps,text,style);
	}
	
	return childProps;
	},initialChildProps);
	},
	
	getLabelProps:function getLabelProps(dataProps,text,calculatedStyle){var
	x=dataProps.x,y=dataProps.y,index=dataProps.index,scale=dataProps.scale,datum=dataProps.datum,data=dataProps.data;
	var labelStyle=this.getLabelStyle(calculatedStyle.labels,dataProps)||{};
	var sign=(datum._y1||datum._y)<0?-1:1;
	return{
	style:labelStyle,
	x:x,
	y:y-sign*(labelStyle.padding||0),
	text:text,
	index:index,
	scale:scale,
	datum:datum,
	data:data,
	textAnchor:labelStyle.textAnchor,
	verticalAnchor:labelStyle.verticalAnchor||"end",
	angle:labelStyle.angle};
	
	},
	
	getCalculatedValues:function getCalculatedValues(props){
	var defaultStyles=props.theme&&props.theme.scatter&&props.theme.scatter.style?
	props.theme.scatter.style:{};
	var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%");
	var data=_victoryCore.Data.getData(props);
	var range={
	x:_victoryCore.Helpers.getRange(props,"x"),
	y:_victoryCore.Helpers.getRange(props,"y")};
	
	var domain={
	x:_victoryCore.Domain.getDomain(props,"x"),
	y:_victoryCore.Domain.getDomain(props,"y")};
	
	var scale={
	x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
	y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};
	
	var z=props.bubbleProperty||"z";
	return{domain:domain,data:data,scale:scale,style:style,z:z};
	},
	
	getDataStyles:function getDataStyles(datum,style){
	var stylesFromData=(0,_omit3.default)(datum,[
	"_x","_y","z","size","symbol","name","label","eventKey"]);
	
	return(0,_defaults3.default)({},stylesFromData,style);
	},
	
	getLabelText:function getLabelText(props,datum,index){
	return datum.label||(Array.isArray(props.labels)?
	props.labels[index]:props.labels);
	},
	
	getLabelStyle:function getLabelStyle(labelStyle,dataProps){var
	size=dataProps.size,style=dataProps.style;
	var matchedStyle=(0,_pick3.default)(style,["opacity","fill"]);
	var padding=labelStyle.padding||size*0.25;
	return(0,_defaults3.default)({},labelStyle,matchedStyle,{padding:padding});
	},
	
	getSymbol:function getSymbol(data,props){
	if(props.bubbleProperty){
	return"circle";
	}
	return data.symbol||props.symbol;
	},
	
	getBubbleSize:function getBubbleSize(datum,props,calculatedValues){var
	data=calculatedValues.data,z=calculatedValues.z;
	var getMaxRadius=function getMaxRadius(){
	var minPadding=Math.min.apply(Math,_toConsumableArray((0,_values3.default)(_victoryCore.Helpers.getPadding(props))));
	return Math.max(minPadding,5);
	};
	var zData=data.map(function(point){return point[z];});
	var zMin=Math.min.apply(Math,_toConsumableArray(zData));
	var zMax=Math.max.apply(Math,_toConsumableArray(zData));
	var maxRadius=props.maxBubbleSize||getMaxRadius();
	var maxArea=Math.PI*Math.pow(maxRadius,2);
	var area=(datum[z]-zMin)/(zMax-zMin)*maxArea;
	var radius=Math.sqrt(area/Math.PI);
	return Math.max(radius,1);
	},
	
	getSize:function getSize(data,props,calculatedValues){
	if(data.size){
	return typeof data.size==="function"?data.size:Math.max(data.size,1);
	}else if(typeof props.size==="function"){
	return props.size;
	}else if(data[calculatedValues.z]){
	return this.getBubbleSize(data,props,calculatedValues);
	}else{
	return Math.max(props.size,1);
	}
	}};

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	
	var _victoryCore=__webpack_require__(12);
	
	
	
	var _helperMethods=__webpack_require__(1442);var _helperMethods2=_interopRequireDefault(_helperMethods);
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50,
	size:3,
	symbol:"circle"};
	
	
	var animationWhitelist=[
	"data","domain","height","maxBubbleSize","padding","samples","size","style","width"];var
	
	
	VictoryScatter=function(_React$Component){_inherits(VictoryScatter,_React$Component);function VictoryScatter(){_classCallCheck(this,VictoryScatter);return _possibleConstructorReturn(this,(VictoryScatter.__proto__||Object.getPrototypeOf(VictoryScatter)).apply(this,arguments));}_createClass(VictoryScatter,[{key:"shouldAnimate",value:function shouldAnimate()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{
	return!!this.props.animate;
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,role);
	if(this.shouldAnimate()){
	return this.animateComponent(props,animationWhitelist);
	}
	var children=this.renderData(props);
	return this.renderContainer(props.containerComponent,children);
	}}]);return VictoryScatter;}(_react2.default.Component);VictoryScatter.displayName="VictoryScatter";VictoryScatter.role="scatter";VictoryScatter.defaultTransitions=_victoryCore.DefaultTransitions.discreteTransitions();VictoryScatter.propTypes=_extends({},_commonProps.BaseProps,_commonProps.DataProps,{bubbleProperty:_propTypes2.default.string,maxBubbleSize:_victoryCore.PropTypes.nonNegative,size:_propTypes2.default.oneOfType([_victoryCore.PropTypes.nonNegative,_propTypes2.default.func]),symbol:_propTypes2.default.oneOfType([_propTypes2.default.oneOf(["circle","diamond","plus","square","star","triangleDown","triangleUp"]),_propTypes2.default.func])});VictoryScatter.defaultProps={samples:50,scale:"linear",standalone:true,dataComponent:_react2.default.createElement(_victoryCore.Point,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",null),theme:_victoryCore.VictoryTheme.grayscale};VictoryScatter.getDomain=_victoryCore.Domain.getDomain.bind(_victoryCore.Domain);VictoryScatter.getData=_victoryCore.Data.getData.bind(_victoryCore.Data);VictoryScatter.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryScatter.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=
	
	
	(0,_victoryCore.addEvents)(VictoryScatter);

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _victoryCore=__webpack_require__(12);
	var _wrapper=__webpack_require__(242);var _wrapper2=_interopRequireDefault(_wrapper);
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50};var
	
	
	VictoryStack=function(_React$Component){_inherits(VictoryStack,_React$Component);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function VictoryStack(props){_classCallCheck(this,VictoryStack);var _this=_possibleConstructorReturn(this,(VictoryStack.__proto__||Object.getPrototypeOf(VictoryStack)).call(this,
	props));
	if(props.animate){
	_this.state={
	nodesShouldLoad:false,
	nodesDoneLoad:false,
	animating:true};
	
	_this.setAnimationState=_wrapper2.default.setAnimationState.bind(_this);
	_this.events=_wrapper2.default.getAllEvents(props);
	}return _this;
	}_createClass(VictoryStack,[{key:"componentWillMount",value:function componentWillMount()
	
	{
	this.events=_wrapper2.default.getAllEvents(this.props);
	}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(
	
	nextProps){
	if(this.props.animate){
	this.setAnimationState(this.props,nextProps);
	}
	this.events=_wrapper2.default.getAllEvents(nextProps);
	}},{key:"getCalculatedProps",value:function getCalculatedProps(
	
	props,childComponents){var
	role=this.constructor.role;
	var style=this.getStyle(props.theme,props.style,role);
	var horizontal=props.horizontal||childComponents.every(
	function(component){return component.props.horizontal;});
	
	var datasets=_wrapper2.default.getDataFromChildren(props);
	var domain={
	x:_wrapper2.default.getStackedDomain(props,"x",datasets),
	y:_wrapper2.default.getStackedDomain(props,"y",datasets)};
	
	var range={
	x:_victoryCore.Helpers.getRange(props,"x"),
	y:_victoryCore.Helpers.getRange(props,"y")};
	
	var baseScale={
	x:_victoryCore.Scale.getScaleFromProps(props,"x")||_victoryCore.Scale.getDefaultScale(),
	y:_victoryCore.Scale.getScaleFromProps(props,"y")||_victoryCore.Scale.getDefaultScale()};
	
	var xScale=baseScale.x.domain(domain.x).range(range.x);
	var yScale=baseScale.y.domain(domain.y).range(range.y);
	var scale={
	x:horizontal?yScale:xScale,
	y:horizontal?xScale:yScale};
	
	var categories={
	x:_wrapper2.default.getCategories(props,"x"),
	y:_wrapper2.default.getCategories(props,"y")};
	
	var colorScale=props.colorScale;
	return{datasets:datasets,categories:categories,range:range,domain:domain,horizontal:horizontal,scale:scale,style:style,colorScale:colorScale};
	}},{key:"addLayoutData",value:function addLayoutData(
	
	props,calculatedProps,datasets,index){
	var xOffset=props.xOffset||0;
	return datasets[index].map(function(datum){
	var yOffset=_wrapper2.default.getY0(datum,index,calculatedProps)||0;
	return(0,_assign3.default)({},datum,{
	_y0:datum._y instanceof Date?yOffset&&new Date(yOffset)||datum._y:yOffset,
	_y1:datum._y instanceof Date?new Date(+datum._y+ +yOffset):datum._y+yOffset,
	_x1:datum._x instanceof Date?new Date(+datum._x+ +xOffset):datum._x+xOffset});
	
	});
	}},{key:"getLabels",value:function getLabels(
	
	props,datasets,index){
	if(!props.labels){
	return undefined;
	}
	return datasets.length===index+1?props.labels:undefined;
	}},{key:"getChildProps",value:function getChildProps(
	
	props,calculatedProps){var
	categories=calculatedProps.categories,domain=calculatedProps.domain,scale=calculatedProps.scale,horizontal=calculatedProps.horizontal;
	return{
	height:props.height,
	width:props.width,
	padding:_victoryCore.Helpers.getPadding(props),
	standalone:false,
	theme:props.theme,
	categories:categories,
	domain:domain,
	scale:scale,
	horizontal:horizontal};
	
	}},{key:"getColorScale",value:function getColorScale(
	
	props,child){
	var role=child.type&&child.type.role;
	var colorScaleOptions=child.props.colorScale||props.colorScale;
	if(role!=="group"&&role!=="stack"){
	return undefined;
	}
	return props.theme?colorScaleOptions||props.theme.props.colorScale:
	colorScaleOptions;
	}},{key:"getNewChildren",value:function getNewChildren(
	
	
	props,childComponents,calculatedProps){var _this2=this;var
	datasets=calculatedProps.datasets;
	var childProps=this.getChildProps(props,calculatedProps);
	var getAnimationProps=_wrapper2.default.getAnimationProps.bind(this);
	
	return childComponents.map(function(child,index){
	var data=_this2.addLayoutData(props,calculatedProps,datasets,index);
	var style=_wrapper2.default.getChildStyle(child,index,calculatedProps);
	var labels=props.labels?_this2.getLabels(props,datasets,index):child.props.labels;
	
	return _react2.default.cloneElement(child,(0,_assign3.default)({
	animate:getAnimationProps(props,child,index),
	key:index,
	labels:labels,
	domainPadding:child.props.domainPadding||props.domainPadding,
	theme:props.theme,
	labelComponent:props.labelComponent||child.props.labelComponent,
	style:style,
	colorScale:_this2.getColorScale(props,child),
	data:data},
	childProps));
	});
	}},{key:"renderContainer",value:function renderContainer(
	
	containerComponent,props){
	var containerProps=(0,_defaults3.default)({},containerComponent.props,props);
	return _react2.default.cloneElement(containerComponent,containerProps);
	}},{key:"getContainerProps",value:function getContainerProps(
	
	props,calculatedProps){var
	width=props.width,height=props.height,standalone=props.standalone,theme=props.theme;var
	domain=calculatedProps.domain,scale=calculatedProps.scale,style=calculatedProps.style;
	return{
	domain:domain,scale:scale,width:width,height:height,standalone:standalone,theme:theme,style:style.parent};
	
	}},{key:"getStyle",value:function getStyle(
	
	theme,style,role){
	var defaultStyle=theme&&theme[role]&&theme[role].style?theme[role].style:{};
	return _victoryCore.Helpers.getStyles(style,defaultStyle,"auto","100%");
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=this.state&&this.state.nodesWillExit?
	this.state.oldProps||this.props:this.props;
	var modifiedProps=_victoryCore.Helpers.modifyProps(props,fallbackProps,role);var
	eventKey=modifiedProps.eventKey,containerComponent=modifiedProps.containerComponent;
	var childComponents=_react2.default.Children.toArray(modifiedProps.children);
	var calculatedProps=this.getCalculatedProps(modifiedProps,childComponents);
	var newChildren=this.getNewChildren(modifiedProps,childComponents,calculatedProps);
	var containerProps=this.getContainerProps(modifiedProps,calculatedProps);
	var container=this.renderContainer(containerComponent,containerProps);
	if(this.events){
	return(
	_react2.default.createElement(_victoryCore.VictorySharedEvents,{events:this.events,eventKey:eventKey,container:container},
	newChildren));
	
	
	}
	
	return _react2.default.cloneElement(container,container.props,newChildren);
	}}]);return VictoryStack;}(_react2.default.Component);VictoryStack.displayName="VictoryStack";VictoryStack.role="stack";VictoryStack.propTypes=_extends({},_commonProps.BaseProps,{categories:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string),_propTypes2.default.shape({x:_propTypes2.default.arrayOf(_propTypes2.default.string),y:_propTypes2.default.arrayOf(_propTypes2.default.string)})]),children:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node),_propTypes2.default.node]),colorScale:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string),_propTypes2.default.oneOf(["grayscale","qualitative","heatmap","warm","cool","red","green","blue"])]),horizontal:_propTypes2.default.bool,labelComponent:_propTypes2.default.element,labels:_propTypes2.default.oneOfType([_propTypes2.default.func,_propTypes2.default.array]),style:_propTypes2.default.shape({parent:_propTypes2.default.object,data:_propTypes2.default.object,labels:_propTypes2.default.object}),xOffset:_propTypes2.default.number});VictoryStack.defaultProps={containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",null),scale:"linear",standalone:true,theme:_victoryCore.VictoryTheme.grayscale};VictoryStack.getDomain=_wrapper2.default.getStackedDomain.bind(_wrapper2.default);VictoryStack.getData=_wrapper2.default.getData.bind(_wrapper2.default);exports.default=VictoryStack;

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _without2=__webpack_require__(160);var _without3=_interopRequireDefault(_without2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);
	var _victoryCore=__webpack_require__(12);
	var _d3Voronoi=__webpack_require__(146);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
	props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"voronoi");var _getCalculatedValues=
	this.getCalculatedValues(props),data=_getCalculatedValues.data,style=_getCalculatedValues.style,scale=_getCalculatedValues.scale,polygons=_getCalculatedValues.polygons,domain=_getCalculatedValues.domain;var _props=
	props,width=_props.width,height=_props.height,standalone=_props.standalone,theme=_props.theme,events=_props.events,sharedEvents=_props.sharedEvents;
	var initialChildProps={parent:{
	style:style.parent,scale:scale,domain:domain,data:data,standalone:standalone,height:height,width:width,theme:theme}};
	
	
	return data.reduce(function(childProps,datum,index){
	var polygon=(0,_without3.default)(polygons[index],"data");
	var eventKey=datum.eventKey;
	var x=scale.x(datum._x1!==undefined?datum._x1:datum._x);
	var y=scale.y(datum._y1!==undefined?datum._y1:datum._y);
	var dataProps={
	x:x,y:y,datum:datum,data:data,index:index,scale:scale,polygon:polygon,
	size:props.size,
	style:_this.getDataStyles(datum,style.data)};
	
	
	childProps[eventKey]={data:dataProps};
	var text=_this.getLabelText(props,datum,index);
	if(text!==undefined&&text!==null||events||sharedEvents){
	childProps[eventKey].labels=_this.getLabelProps(dataProps,text,style);
	}
	
	return childProps;
	},initialChildProps);
	},
	
	getLabelProps:function getLabelProps(dataProps,text,calculatedStyle){var
	x=dataProps.x,y=dataProps.y,index=dataProps.index,scale=dataProps.scale,datum=dataProps.datum,data=dataProps.data;
	var labelStyle=this.getLabelStyle(calculatedStyle.labels,dataProps)||{};
	return{
	style:labelStyle,
	x:x,
	y:y-(labelStyle.padding||0),
	text:text,
	index:index,
	scale:scale,
	datum:datum,
	data:data,
	textAnchor:labelStyle.textAnchor,
	verticalAnchor:labelStyle.verticalAnchor||"end",
	angle:labelStyle.angle};
	
	},
	
	getCalculatedValues:function getCalculatedValues(props){
	var defaultStyles=props.theme&&props.theme.voronoi&&props.theme.voronoi.style?
	props.theme.voronoi.style:{};
	var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%");
	var data=_victoryCore.Data.getData(props);
	var range={
	x:_victoryCore.Helpers.getRange(props,"x"),
	y:_victoryCore.Helpers.getRange(props,"y")};
	
	var domain={
	x:_victoryCore.Domain.getDomain(props,"x"),
	y:_victoryCore.Domain.getDomain(props,"y")};
	
	var scale={
	x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
	y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};
	
	var voronoi=this.getVoronoi(range,scale);
	var polygons=voronoi.polygons(data);
	return{domain:domain,data:data,scale:scale,style:style,polygons:polygons};
	},
	
	getVoronoi:function getVoronoi(range,scale){
	var minRange=[Math.min.apply(Math,_toConsumableArray(range.x)),Math.min.apply(Math,_toConsumableArray(range.y))];
	var maxRange=[Math.max.apply(Math,_toConsumableArray(range.x)),Math.max.apply(Math,_toConsumableArray(range.y))];
	return(0,_d3Voronoi.voronoi)().
	x(function(d){return scale.x(d._x1!==undefined?d._x1:d._x);}).
	y(function(d){return scale.y(d._y1!==undefined?d._y1:d._y);}).
	extent([minRange,maxRange]);
	},
	
	getDataStyles:function getDataStyles(datum,style){
	var stylesFromData=(0,_omit3.default)(datum,[
	"_x","_y","name","label"]);
	
	return(0,_defaults3.default)({},stylesFromData,style);
	},
	
	getLabelText:function getLabelText(props,datum,index){
	return datum.label||Array.isArray(props.labels)?
	props.labels[index]:props.labels;
	},
	
	getLabelStyle:function getLabelStyle(style,datum){
	return(0,_defaults3.default)({},{
	angle:datum.angle,
	textAnchor:datum.textAnchor,
	verticalAnchor:datum.verticalAnchor},
	style);
	}};

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	
	var _victoryCore=__webpack_require__(12);
	
	
	
	var _helperMethods=__webpack_require__(1445);var _helperMethods2=_interopRequireDefault(_helperMethods);
	var _commonProps=__webpack_require__(74);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var fallbackProps={
	width:450,
	height:300,
	padding:50};
	
	
	var animationWhitelist=[
	"data","domain","height","padding","samples","size","style","width"];var
	
	
	VictoryVoronoi=function(_React$Component){_inherits(VictoryVoronoi,_React$Component);function VictoryVoronoi(){_classCallCheck(this,VictoryVoronoi);return _possibleConstructorReturn(this,(VictoryVoronoi.__proto__||Object.getPrototypeOf(VictoryVoronoi)).apply(this,arguments));}_createClass(VictoryVoronoi,[{key:"componentDidMount",value:function componentDidMount()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{
	_victoryCore.Log.warn(
	"`VictoryVoronoi` will be deprecated in victory@0.20.0, use `VictoryVoronoiContainer` instead");
	
	}},{key:"shouldAnimate",value:function shouldAnimate()
	
	
	{
	return!!this.props.animate;
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,role);
	if(this.shouldAnimate()){
	return this.animateComponent(props,animationWhitelist);
	}
	var children=this.renderData(props);
	return this.renderContainer(props.containerComponent,children);
	}}]);return VictoryVoronoi;}(_react2.default.Component);VictoryVoronoi.displayName="VictoryVoronoi";VictoryVoronoi.role="voronoi";VictoryVoronoi.defaultTransitions=_victoryCore.DefaultTransitions.discreteTransitions();VictoryVoronoi.propTypes=_extends({},_commonProps.BaseProps,_commonProps.DataProps,{size:_victoryCore.PropTypes.nonNegative});VictoryVoronoi.defaultProps={samples:50,scale:"linear",standalone:true,dataComponent:_react2.default.createElement(_victoryCore.Voronoi,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",{role:"presentation"}),theme:_victoryCore.VictoryTheme.grayscale};VictoryVoronoi.getDomain=_victoryCore.Domain.getDomain.bind(_victoryCore.Domain);VictoryVoronoi.getData=_victoryCore.Data.getData.bind(_victoryCore.Data);VictoryVoronoi.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryVoronoi.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=
	
	
	(0,_victoryCore.addEvents)(VictoryVoronoi);

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _victoryChart=__webpack_require__(1436);Object.defineProperty(exports,"VictoryChart",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryChart).default;}});var _victoryLine=__webpack_require__(1441);Object.defineProperty(exports,"VictoryLine",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryLine).
	default;}});var _victoryAxis=__webpack_require__(633);Object.defineProperty(exports,"VictoryAxis",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryAxis).
	default;}});var _victoryArea=__webpack_require__(1429);Object.defineProperty(exports,"VictoryArea",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryArea).
	default;}});var _victoryBar=__webpack_require__(1432);Object.defineProperty(exports,"VictoryBar",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryBar).
	default;}});var _victoryScatter=__webpack_require__(1443);Object.defineProperty(exports,"VictoryScatter",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryScatter).
	default;}});var _victoryGroup=__webpack_require__(1439);Object.defineProperty(exports,"VictoryGroup",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryGroup).
	default;}});var _victoryStack=__webpack_require__(1444);Object.defineProperty(exports,"VictoryStack",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryStack).
	default;}});var _victoryErrorbar=__webpack_require__(1438);Object.defineProperty(exports,"VictoryErrorBar",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryErrorbar).
	default;}});var _victoryVoronoi=__webpack_require__(1446);Object.defineProperty(exports,"VictoryVoronoi",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryVoronoi).
	default;}});var _victoryCandlestick=__webpack_require__(1434);Object.defineProperty(exports,"VictoryCandlestick",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryCandlestick).
	
	default;}});var _victorySelectionContainer=__webpack_require__(628);Object.defineProperty(exports,"selectionContainerMixin",{enumerable:true,get:function get(){return _victorySelectionContainer.
	
	
	selectionContainerMixin;}});Object.defineProperty(exports,"VictorySelectionContainer",{enumerable:true,get:function get(){return _interopRequireDefault(_victorySelectionContainer).
	default;}});var _victoryBrushContainer=__webpack_require__(627);Object.defineProperty(exports,"brushContainerMixin",{enumerable:true,get:function get(){return _victoryBrushContainer.
	
	
	brushContainerMixin;}});Object.defineProperty(exports,"VictoryBrushContainer",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryBrushContainer).
	default;}});var _victoryVoronoiContainer=__webpack_require__(629);Object.defineProperty(exports,"voronoiContainerMixin",{enumerable:true,get:function get(){return _victoryVoronoiContainer.
	
	
	voronoiContainerMixin;}});Object.defineProperty(exports,"VictoryVoronoiContainer",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryVoronoiContainer).
	default;}});var _victoryZoomContainer=__webpack_require__(630);Object.defineProperty(exports,"zoomContainerMixin",{enumerable:true,get:function get(){return _victoryZoomContainer.
	
	
	zoomContainerMixin;}});Object.defineProperty(exports,"VictoryZoomContainer",{enumerable:true,get:function get(){return _interopRequireDefault(_victoryZoomContainer).
	default;}});var _createContainer=__webpack_require__(1427);Object.defineProperty(exports,"combineContainerMixins",{enumerable:true,get:function get(){return _createContainer.
	
	
	combineContainerMixins;}});Object.defineProperty(exports,"makeCreateContainerFunction",{enumerable:true,get:function get(){return _createContainer.
	makeCreateContainerFunction;}});Object.defineProperty(exports,"createContainer",{enumerable:true,get:function get(){return _interopRequireDefault(_createContainer).
	default;}});var _brushHelpers=__webpack_require__(625);Object.defineProperty(exports,"BrushHelpers",{enumerable:true,get:function get(){return _interopRequireDefault(_brushHelpers).
	
	default;}});var _selectionHelpers=__webpack_require__(626);Object.defineProperty(exports,"SelectionHelpers",{enumerable:true,get:function get(){return _interopRequireDefault(_selectionHelpers).
	default;}});var _voronoiHelpers=__webpack_require__(631);Object.defineProperty(exports,"VoronoiHelpers",{enumerable:true,get:function get(){return _interopRequireDefault(_voronoiHelpers).
	default;}});var _zoomHelpers=__webpack_require__(632);Object.defineProperty(exports,"ZoomHelpers",{enumerable:true,get:function get(){return _interopRequireDefault(_zoomHelpers).
	default;}});Object.defineProperty(exports,"RawZoomHelpers",{enumerable:true,get:function get(){return _zoomHelpers.RawZoomHelpers;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.victoryInterpolator=exports.interpolateObject=exports.interpolateFunction=exports.interpolateImmediate=exports.isInterpolatable=undefined;var _isPlainObject2=__webpack_require__(103);var _isPlainObject3=_interopRequireDefault(_isPlainObject2);var _d3Interpolate=__webpack_require__(145);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}
	
	
	var isInterpolatable=exports.isInterpolatable=function isInterpolatable(obj){
	
	if(obj!==null){
	switch(typeof obj){
	case"undefined":
	return false;
	case"number":
	
	
	return!isNaN(obj)&&obj!==Number.POSITIVE_INFINITY&&obj!==Number.NEGATIVE_INFINITY;
	case"string":
	
	
	return true;
	case"boolean":
	
	
	
	return false;
	case"object":
	
	return obj instanceof Date||Array.isArray(obj)||(0,_isPlainObject3.default)(obj);
	case"function":
	
	
	
	
	
	
	
	
	
	
	return true;}
	
	}
	return false;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var interpolateImmediate=exports.interpolateImmediate=function interpolateImmediate(a,b){var when=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;
	return function(t){
	return t<when?a:b;
	};
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	var interpolateFunction=exports.interpolateFunction=function interpolateFunction(a,b){
	return function(t){
	if(t>=1){
	return b;
	}
	return function(){
	
	var aval=typeof a==="function"?a.apply(this,arguments):a;
	var bval=typeof b==="function"?b.apply(this,arguments):b;
	return(0,_d3Interpolate.interpolate)(aval,bval)(t);
	};
	};
	};
	
	
	
	
	
	
	
	
	
	
	
	var interpolateObject=exports.interpolateObject=function interpolateObject(a,b){
	var interpolateTypes=function interpolateTypes(x,y){
	if(x===y||!isInterpolatable(x)||!isInterpolatable(y)){
	return interpolateImmediate(x,y);
	}
	if(typeof x==="function"||typeof y==="function"){
	return interpolateFunction(x,y);
	}
	if(typeof x==="object"&&(0,_isPlainObject3.default)(x)||typeof y==="object"&&(0,_isPlainObject3.default)(y)){
	return interpolateObject(x,y);
	}
	return(0,_d3Interpolate.interpolate)(x,y);
	};
	
	var i={};
	var c={};
	var k=void 0;
	
	if(a===null||typeof a!=="object"){
	a={};
	}
	if(b===null||typeof b!=="object"){
	b={};
	}
	
	for(k in b){
	if(k in a){
	i[k]=interpolateTypes(a[k],b[k]);
	}else{
	c[k]=b[k];
	}
	}
	
	return function(t){
	for(k in i){
	c[k]=i[k](t);
	}
	return c;
	};
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var victoryInterpolator=exports.victoryInterpolator=function victoryInterpolator(a,b){
	
	
	
	if(a===b||!isInterpolatable(a)||!isInterpolatable(b)){
	return interpolateImmediate(a,b);
	}
	if(typeof a==="function"||typeof b==="function"){
	return interpolateFunction(a,b);
	}
	if((0,_isPlainObject3.default)(a)||(0,_isPlainObject3.default)(b)){
	return interpolateObject(a,b);
	}
	return(0,_d3Interpolate.interpolate)(a,b);
	};

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	
	var _index=__webpack_require__(366);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	VictoryClipContainer=function(_React$Component){_inherits(VictoryClipContainer,_React$Component);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function VictoryClipContainer(props){_classCallCheck(this,VictoryClipContainer);var _this=_possibleConstructorReturn(this,(VictoryClipContainer.__proto__||Object.getPrototypeOf(VictoryClipContainer)).call(this,
	props));
	_this.clipId=Math.round(Math.random()*10000);return _this;
	}_createClass(VictoryClipContainer,[{key:"renderClippedGroup",value:function renderClippedGroup(
	
	
	props,clipId){var
	style=props.style,events=props.events,transform=props.transform,children=props.children,className=props.className;
	var clipComponent=this.renderClipComponent(props,clipId);
	return(
	_react2.default.createElement("g",_extends({
	className:className,
	style:style},
	events,{
	transform:transform}),
	
	clipComponent,
	_react2.default.createElement("g",{clipPath:"url(#"+clipId+")"},
	children)));
	
	
	
	}},{key:"renderGroup",value:function renderGroup(
	
	
	props){var
	style=props.style,events=props.events,transform=props.transform,children=props.children,className=props.className;
	return(
	_react2.default.createElement("g",_extends({
	className:className,
	style:style},
	events,{
	transform:transform}),
	
	children));
	
	
	}},{key:"renderClipComponent",value:function renderClipComponent(
	
	
	props,clipId){var
	
	clipPadding=
	props.clipPadding,translateX=props.translateX,translateY=props.translateY,clipHeight=props.clipHeight,clipWidth=props.clipWidth,clipPathComponent=props.clipPathComponent;
	return _react2.default.cloneElement(
	clipPathComponent,
	{clipPadding:clipPadding,clipId:clipId,translateX:translateX,translateY:translateY,clipWidth:clipWidth,clipHeight:clipHeight});
	
	}},{key:"getClipValue",value:function getClipValue(
	
	props,axis){
	var clipValues={x:props.clipWidth,y:props.clipHeight};
	if(clipValues[axis]!==undefined){
	return clipValues[axis];
	}
	var range=this.getRange(props,axis);
	return range?Math.abs(range[0]-range[1])||undefined:undefined;
	}},{key:"getTranslateValue",value:function getTranslateValue(
	
	props,axis){
	var translateValues={x:props.translateX,y:props.translateY};
	if(translateValues[axis]!==undefined){
	return translateValues[axis];
	}
	var range=this.getRange(props,axis);
	return range?Math.min.apply(Math,_toConsumableArray(range)):undefined;
	}},{key:"getRange",value:function getRange(
	
	props,axis){
	var scale=props.scale||{};
	if(!scale[axis]){
	return undefined;
	}
	return(0,_isFunction3.default)(scale[axis].range)?scale[axis].range():undefined;
	}},{key:"render",value:function render()
	
	{
	var clipHeight=this.getClipValue(this.props,"y");
	var clipWidth=this.getClipValue(this.props,"x");
	if(clipWidth===undefined||clipHeight===undefined){
	return this.renderGroup(this.props);
	}
	var translateX=this.getTranslateValue(this.props,"x");
	var translateY=this.getTranslateValue(this.props,"y");
	var clipProps=(0,_defaults3.default)({},this.props,{clipHeight:clipHeight,clipWidth:clipWidth,translateX:translateX,translateY:translateY});
	return this.renderClippedGroup(clipProps,this.clipId);
	}}]);return VictoryClipContainer;}(_react2.default.Component);VictoryClipContainer.displayName="VictoryClipContainer";VictoryClipContainer.role="container";VictoryClipContainer.propTypes={children:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node),_propTypes2.default.node]),className:_propTypes2.default.string,clipHeight:_propTypes2.default.number,clipPadding:_propTypes2.default.shape({top:_propTypes2.default.number,bottom:_propTypes2.default.number,left:_propTypes2.default.number,right:_propTypes2.default.number}),clipPathComponent:_propTypes2.default.element,clipWidth:_propTypes2.default.number,events:_propTypes2.default.object,style:_propTypes2.default.object,transform:_propTypes2.default.string,translateX:_propTypes2.default.number,translateY:_propTypes2.default.number};VictoryClipContainer.defaultProps={clipPathComponent:_react2.default.createElement(_index.ClipPath,null)};exports.default=VictoryClipContainer;

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _maxBy2=__webpack_require__(208);var _maxBy3=_interopRequireDefault(_maxBy2);var _sumBy2=__webpack_require__(290);var _sumBy3=_interopRequireDefault(_sumBy2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _isEmpty2=__webpack_require__(456);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _merge2=__webpack_require__(158);var _merge3=_interopRequireDefault(_merge2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _index=__webpack_require__(53);
	
	var _victoryLabel=__webpack_require__(365);var _victoryLabel2=_interopRequireDefault(_victoryLabel);
	var _victoryContainer=__webpack_require__(635);var _victoryContainer2=_interopRequireDefault(_victoryContainer);
	var _victoryTheme=__webpack_require__(367);var _victoryTheme2=_interopRequireDefault(_victoryTheme);
	var _point=__webpack_require__(638);var _point2=_interopRequireDefault(_point);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var defaultLegendData=[
	{name:"Series 1"},
	{name:"Series 2"}];var
	
	
	VictoryLegend=function(_React$Component){_inherits(VictoryLegend,_React$Component);function VictoryLegend(){_classCallCheck(this,VictoryLegend);return _possibleConstructorReturn(this,(VictoryLegend.__proto__||Object.getPrototypeOf(VictoryLegend)).apply(this,arguments));}_createClass(VictoryLegend,[{key:"calculateLegendHeight",value:function calculateLegendHeight(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	textSizes,padding,isHorizontal){var _props=
	this.props,data=_props.data,gutter=_props.gutter;
	var contentHeight=isHorizontal?
	(0,_maxBy3.default)(textSizes,"height").height:
	(0,_sumBy3.default)(textSizes,"height")+gutter*(data.length-1);
	
	return padding.top+contentHeight+padding.bottom;
	}},{key:"calculateLegendWidth",value:function calculateLegendWidth(
	
	textSizes,padding,isHorizontal){var _props2=
	this.props,data=_props2.data,gutter=_props2.gutter,symbolSpacer=_props2.symbolSpacer;
	var contentWidth=isHorizontal?
	(0,_sumBy3.default)(textSizes,"width")+(gutter+symbolSpacer*3)*(data.length-1):
	(0,_maxBy3.default)(textSizes,"width").width+symbolSpacer*2;
	
	return padding.left+contentWidth+padding.right;
	}},{key:"getColorScale",value:function getColorScale(
	
	theme){var
	colorScale=this.props.colorScale;
	var colorScaleOptions=colorScale||theme.colorScale;
	
	if(typeof colorScaleOptions==="string"){
	colorScaleOptions=_index.Style.getColorScale(colorScaleOptions);
	}
	
	return!(0,_isEmpty3.default)(theme)?colorScaleOptions||theme.colorScale:colorScaleOptions||[];
	}},{key:"getCalculatedProps",value:function getCalculatedProps()
	
	{var _this2=this;var
	role=this.constructor.role;var _props3=
	this.props,data=_props3.data,orientation=_props3.orientation,theme=_props3.theme;var _props4=
	this.props,height=_props4.height,padding=_props4.padding,width=_props4.width;
	
	var legendTheme=theme&&theme[role]?theme[role]:{};
	var parentStyles=this.getStyles({},legendTheme,"parent");
	var colorScale=this.getColorScale(legendTheme);
	var isHorizontal=orientation==="horizontal";
	var symbolStyles=[];
	var labelStyles=[];
	var leftOffset=0;
	
	padding=_index.Helpers.getPadding({padding:padding||theme.padding});
	height=_index.Helpers.evaluateProp(height||theme.height,data);
	width=_index.Helpers.evaluateProp(width||theme.width,data);
	
	var textSizes=data.map(function(datum,i){
	var labelStyle=_this2.getStyles(datum,legendTheme,"labels");
	symbolStyles[i]=_this2.getStyles(datum,legendTheme,"symbol",colorScale[i]);
	labelStyles[i]=labelStyle;
	
	var textSize=_index.TextSize.approximateTextSize(datum.name,labelStyle);
	textSize.leftOffset=leftOffset;
	leftOffset+=textSize.width;
	
	return textSize;
	});
	
	if(!height){
	height=this.calculateLegendHeight(textSizes,padding,isHorizontal);
	}
	if(!width){
	width=this.calculateLegendWidth(textSizes,padding,isHorizontal);
	}
	
	return _extends({},
	this.props,
	{isHorizontal:isHorizontal,height:height,labelStyles:labelStyles,padding:padding,parentStyles:parentStyles,symbolStyles:symbolStyles,textSizes:textSizes,width:width});
	
	}},{key:"getStyles",value:function getStyles(
	
	datum,theme,key,color){var
	style=this.props.style;
	var styleKey=key==="symbol"?"data":key;
	var colorScaleStyle=color?{fill:color}:{};
	var styles=(0,_merge3.default)({},theme.style[styleKey],colorScaleStyle,style[styleKey],datum[key]);
	return _index.Helpers.evaluateStyle(styles,datum);
	}},{key:"getSymbolSize",value:function getSymbolSize(
	
	datum,fontSize){
	return datum.symbol&&datum.symbol.size?datum.symbol.size:fontSize/2.5;
	}},{key:"getSymbolProps",value:function getSymbolProps(
	
	datum,props,i){var
	
	dataComponent=
	
	props.dataComponent,gutter=props.gutter,labelStyles=props.labelStyles,isHorizontal=props.isHorizontal,padding=props.padding,symbolSpacer=props.symbolSpacer,symbolStyles=props.symbolStyles,textSizes=props.textSizes;var
	leftOffset=textSizes[i].leftOffset;var
	fontSize=labelStyles[i].fontSize;
	var symbolShift=fontSize/2;
	var style=symbolStyles[i];
	
	var symbolCoords=isHorizontal?{
	x:padding.left+leftOffset+symbolShift+(fontSize+symbolSpacer+gutter)*i,
	y:padding.top+symbolShift}:
	{
	x:padding.left+symbolShift,
	y:padding.top+symbolShift+(fontSize+gutter)*i};
	
	
	return(0,_defaults3.default)({},
	dataComponent.props,_extends({
	
	key:"symbol-"+i,
	style:style,
	size:this.getSymbolSize(datum,fontSize),
	symbol:style.type},
	symbolCoords));
	
	
	}},{key:"getLabelProps",value:function getLabelProps(
	
	datum,props,i){var
	
	gutter=
	props.gutter,isHorizontal=props.isHorizontal,symbolSpacer=props.symbolSpacer,labelComponent=props.labelComponent,labelStyles=props.labelStyles,textSizes=props.textSizes,padding=props.padding;
	var style=labelStyles[i];var
	fontSize=style.fontSize;
	var symbolShift=fontSize/2;
	
	var labelCoords=isHorizontal?{
	x:padding.left+textSizes[i].leftOffset+(fontSize+symbolSpacer)*(i+1)+gutter*i,
	y:padding.top+symbolShift}:
	{
	x:padding.left+fontSize+symbolSpacer,
	y:padding.top+symbolShift+(fontSize+gutter)*i};
	
	
	return(0,_defaults3.default)({},
	labelComponent.props,_extends({
	
	key:"label-"+i,
	style:style,
	text:datum.name},
	labelCoords));
	
	
	}},{key:"renderLegendItems",value:function renderLegendItems(
	
	props){var _this3=this;var
	data=props.data,dataComponent=props.dataComponent,labelComponent=props.labelComponent;
	var legendData=(0,_isEmpty3.default)(data)?defaultLegendData:data;
	
	var dataComponents=legendData.map(function(datum,i){
	return _react2.default.cloneElement(
	dataComponent,
	_this3.getSymbolProps(datum,props,i));
	
	});
	
	var labelComponents=legendData.map(function(datum,i){
	return _react2.default.cloneElement(
	labelComponent,
	_this3.getLabelProps(datum,props,i));
	
	});
	
	return[].concat(_toConsumableArray(dataComponents),_toConsumableArray(labelComponents));
	}},{key:"renderGroup",value:function renderGroup(
	
	props,children){var
	groupComponent=props.groupComponent,height=props.height,standalone=props.standalone,width=props.width,x=props.x,y=props.y;
	var style=props.style||{};
	var groupProps={role:"presentation"};
	var transform="translate("+x+", "+y+")";
	if(!standalone){
	groupProps=_extends(groupProps,{height:height,width:width,transform:transform,style:style.parent});
	}
	
	return _react2.default.cloneElement(groupComponent,groupProps,children);
	}},{key:"renderContainer",value:function renderContainer(
	
	props,children){var
	containerComponent=props.containerComponent,height=props.height,width=props.width;
	var style=props.style||{};
	return _react2.default.cloneElement(
	containerComponent,
	{height:height,width:width,style:style.parent},
	children);
	
	}},{key:"render",value:function render()
	
	{
	var props=this.getCalculatedProps();
	var group=this.renderGroup(props,this.renderLegendItems(props));
	return props.standalone?this.renderContainer(props,group):group;
	}}]);return VictoryLegend;}(_react2.default.Component);VictoryLegend.displayName="VictoryLegend";VictoryLegend.role="legend";VictoryLegend.propTypes={colorScale:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string),_propTypes2.default.oneOf(["grayscale","qualitative","heatmap","warm","cool","red","green","blue"])]),containerComponent:_propTypes2.default.element,data:_propTypes2.default.arrayOf(_propTypes2.default.shape({name:_propTypes2.default.string.isRequired,label:_propTypes2.default.object,symbol:_propTypes2.default.object})),dataComponent:_propTypes2.default.element,groupComponent:_propTypes2.default.element,gutter:_propTypes2.default.number,height:_propTypes2.default.oneOfType([_index.PropTypes.nonNegative,_propTypes2.default.func]),labelComponent:_propTypes2.default.element,orientation:_propTypes2.default.oneOf(["horizontal","vertical"]),padding:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.shape({top:_propTypes2.default.number,bottom:_propTypes2.default.number,left:_propTypes2.default.number,right:_propTypes2.default.number})]),standalone:_propTypes2.default.bool,style:_propTypes2.default.shape({data:_propTypes2.default.object,labels:_propTypes2.default.object,parent:_propTypes2.default.object}),symbolSpacer:_propTypes2.default.number,theme:_propTypes2.default.object,width:_propTypes2.default.oneOfType([_index.PropTypes.nonNegative,_propTypes2.default.func]),x:_propTypes2.default.number,y:_propTypes2.default.number};VictoryLegend.defaultProps={data:defaultLegendData,containerComponent:_react2.default.createElement(_victoryContainer2.default,null),dataComponent:_react2.default.createElement(_point2.default,null),groupComponent:_react2.default.createElement("g",null),gutter:10,labelComponent:_react2.default.createElement(_victoryLabel2.default,null),orientation:"vertical",standalone:true,style:{},symbolSpacer:8,theme:_victoryTheme2.default.grayscale,x:0,y:0};exports.default=VictoryLegend;

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _victoryUtil=__webpack_require__(53);
	
	var _d3Shape=__webpack_require__(642);var d3Shape=_interopRequireWildcard(_d3Shape);
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Area=function(_React$Component){_inherits(Area,_React$Component);function Area(){_classCallCheck(this,Area);return _possibleConstructorReturn(this,(Area.__proto__||Object.getPrototypeOf(Area)).apply(this,arguments));}_createClass(Area,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	
	{var _calculateAttributes=
	this.calculateAttributes(this.props),style=_calculateAttributes.style,areaPaths=_calculateAttributes.areaPaths,linePaths=_calculateAttributes.linePaths;
	this.style=style;
	this.areaPaths=areaPaths;
	this.linePaths=linePaths;
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _calculateAttributes2=
	this.calculateAttributes(nextProps),style=_calculateAttributes2.style,areaPaths=_calculateAttributes2.areaPaths,linePaths=_calculateAttributes2.linePaths;
	if(!(0,_isEqual3.default)(linePaths,this.linePaths)||!(0,_isEqual3.default)(style,this.style)){
	this.style=style;
	this.areaPaths=areaPaths;
	this.linePaths=linePaths;
	return true;
	}
	return false;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){var
	style=props.style,data=props.data,active=props.active,scale=props.scale;
	var dataSegments=this.getDataSegments(data);
	var xScale=scale.x;
	var yScale=scale.y;
	var interpolation=this.toNewName(props.interpolation);
	var areaFunction=d3Shape.area().
	curve(d3Shape[interpolation]).
	x(function(d){return xScale(d._x1!==undefined?d._x1:d._x);}).
	y1(function(d){return yScale(d._y1!==undefined?d._y1:d._y);}).
	y0(function(d){return yScale(d._y0);});
	var lineFunction=d3Shape.line().
	curve(d3Shape[interpolation]).
	x(function(d){return xScale(d._x1!==undefined?d._x1:d._x);}).
	y(function(d){return yScale(d._y1);});
	return{
	style:_victoryUtil.Helpers.evaluateStyle((0,_assign3.default)({fill:"black"},style),data,active),
	areaPaths:dataSegments.map(function(segment){return areaFunction(segment);}),
	linePaths:dataSegments.map(function(segment){return lineFunction(segment);})};
	
	}},{key:"getDataSegments",value:function getDataSegments(
	
	data){
	return _victoryUtil.Collection.splitArray(data,function(datum){
	var yDatum=datum.y1!==undefined?datum._y1:datum._y;
	
	return yDatum===null||typeof yDatum==="undefined";
	}).filter(function(segment){return segment.length>1;});
	}},{key:"toNewName",value:function toNewName(
	
	interpolation){
	
	var capitalize=function capitalize(s){return s&&s[0].toUpperCase()+s.slice(1);};
	return"curve"+capitalize(interpolation);
	}},{key:"renderArea",value:function renderArea(
	
	
	paths,style,events){
	var areaStroke=style.stroke?"none":style.fill;
	var areaStyle=(0,_assign3.default)({},style,{stroke:areaStroke});var _props=
	this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
	return paths.map(function(path,index){
	return(
	_react2.default.createElement("path",_extends({
	key:"area-"+index,
	style:areaStyle,
	shapeRendering:shapeRendering||"auto",
	role:role||"presentation",
	d:path,
	className:className},
	events)));
	
	
	});
	}},{key:"renderLine",value:function renderLine(
	
	
	paths,style,events){
	if(!style.stroke||style.stroke==="none"||style.stroke==="transparent"){
	return[];
	}var _props2=
	this.props,role=_props2.role,shapeRendering=_props2.shapeRendering,className=_props2.className;
	var lineStyle=(0,_assign3.default)({},style,{fill:"none"});
	return paths.map(function(path,index){
	return(
	_react2.default.createElement("path",_extends({
	key:"area-stroke-"+index,
	style:lineStyle,
	shapeRendering:shapeRendering||"auto",
	role:role||"presentation",
	d:path,
	className:className},
	events)));
	
	
	});
	}},{key:"render",value:function render()
	
	{var _props3=
	this.props,events=_props3.events,groupComponent=_props3.groupComponent;
	var areas=this.renderArea(this.areaPaths,this.style,events);
	var lines=this.renderLine(this.linePaths,this.style,events);
	var children=[].concat(_toConsumableArray(lines),_toConsumableArray(areas));
	return children.length===1?children[0]:_react2.default.cloneElement(groupComponent,{},children);
	}}]);return Area;}(_react2.default.Component);Area.propTypes=_extends({},_commonProps2.default,{groupComponent:_propTypes2.default.element,interpolation:_propTypes2.default.string});Area.defaultProps={groupComponent:_react2.default.createElement("g",null)};exports.default=Area;

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Bar=function(_React$Component){_inherits(Bar,_React$Component);function Bar(){_classCallCheck(this,Bar);return _possibleConstructorReturn(this,(Bar.__proto__||Object.getPrototypeOf(Bar)).apply(this,arguments));}_createClass(Bar,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{var _calculateAttributes=
	this.calculateAttributes(this.props),style=_calculateAttributes.style,path=_calculateAttributes.path;
	this.style=style;
	this.path=path;
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _calculateAttributes2=
	this.calculateAttributes(nextProps),style=_calculateAttributes2.style,path=_calculateAttributes2.path;
	if(path!==this.path||!(0,_isEqual3.default)(style,this.style)){
	this.style=style;
	this.path=path;
	return true;
	}
	return false;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){var
	datum=props.datum,active=props.active,x=props.x,y=props.y;
	var stroke=props.style&&props.style.fill||"black";
	var baseStyle={fill:"black",stroke:stroke};
	var style=_helpers2.default.evaluateStyle((0,_assign3.default)(baseStyle,props.style),datum,active);
	var width=this.getBarWidth(props,style);
	var path=typeof x==="number"&&typeof y==="number"?
	this.getBarPath(props,width):undefined;
	return{style:style,path:path};
	}},{key:"getVerticalBarPath",value:function getVerticalBarPath(
	
	props,width){
	var size=width/2;
	var y0=Math.round(props.y0);
	var y1=Math.round(props.y);
	var x0=Math.round(props.x-size);
	var x1=Math.round(props.x+size);
	return"M "+x0+", "+y0+"\n      L "+
	x0+", "+y1+"\n      L "+
	x1+", "+y1+"\n      L "+
	x1+", "+y0+"\n      L "+
	x0+", "+y0+"\n      z";
	
	}},{key:"getHorizontalBarPath",value:function getHorizontalBarPath(
	
	props,width){
	var size=width/2;
	var y0=Math.round(props.y0);
	var y1=Math.round(props.y);
	var x0=Math.round(props.x-size);
	var x1=Math.round(props.x+size);
	return"M "+y0+", "+x0+"\n      L "+
	y0+", "+x1+"\n      L "+
	y1+", "+x1+"\n      L "+
	y1+", "+x0+"\n      L "+
	y0+", "+x0+"\n      z";
	
	}},{key:"getBarPath",value:function getBarPath(
	
	props,width){
	return this.props.horizontal?
	this.getHorizontalBarPath(props,width):this.getVerticalBarPath(props,width);
	}},{key:"getBarWidth",value:function getBarWidth(
	
	props,style){
	if(style.width){
	return style.width;
	}var
	
	width=props.width,data=props.data;
	var padding=props.padding.left||props.padding;
	
	var defaultWidth=data.length===0?8:(width-2*padding)/data.length;
	return defaultWidth;
	}},{key:"renderBar",value:function renderBar(
	
	
	path,style,events){var _props=
	this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
	return(
	_react2.default.createElement("path",_extends({
	d:path,
	className:className,
	style:style,
	role:role||"presentation",
	shapeRendering:shapeRendering||"auto"},
	events)));
	
	
	}},{key:"render",value:function render()
	
	{
	return this.renderBar(this.path,this.style,this.props.events);
	}}]);return Bar;}(_react2.default.Component);Bar.propTypes=_extends({},_commonProps2.default,{datum:_propTypes2.default.object,horizontal:_propTypes2.default.bool,padding:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.object]),width:_propTypes2.default.number,x:_propTypes2.default.number,y:_propTypes2.default.number,y0:_propTypes2.default.number});exports.default=Bar;

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _victoryUtil=__webpack_require__(53);
	
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Candle=function(_React$Component){_inherits(Candle,_React$Component);function Candle(){_classCallCheck(this,Candle);return _possibleConstructorReturn(this,(Candle.__proto__||Object.getPrototypeOf(Candle)).apply(this,arguments));}_createClass(Candle,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{var _calculateAttributes=
	this.calculateAttributes(this.props),style=_calculateAttributes.style,candleWidth=_calculateAttributes.candleWidth;
	this.style=style;
	this.candleWidth=candleWidth;
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _props=
	this.props,x=_props.x,y=_props.y,y1=_props.y1,y2=_props.y2;var _calculateAttributes2=
	this.calculateAttributes(nextProps),style=_calculateAttributes2.style,candleWidth=_calculateAttributes2.candleWidth;
	
	if(!_victoryUtil.Collection.allSetsEqual([
	[x,nextProps.x],
	[y,nextProps.y],
	[y1,nextProps.y1],
	[y2,nextProps.y2],
	[candleWidth,this.candleWidth],
	[style,this.style]]))
	{
	this.style=style;
	this.candleWidth=candleWidth;
	return true;
	}
	return false;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){var
	data=props.data,datum=props.datum,active=props.active,width=props.width;
	var style=_victoryUtil.Helpers.evaluateStyle((0,_assign3.default)({stroke:"black"},props.style),datum,active);
	var padding=props.padding.left||props.padding;
	var candleWidth=style.width||0.5*(width-2*padding)/data.length;
	return{style:style,candleWidth:candleWidth};
	}},{key:"renderWick",value:function renderWick(
	
	
	wickProps){
	return _react2.default.createElement("line",wickProps);
	}},{key:"renderCandle",value:function renderCandle(
	
	
	candleProps){
	return _react2.default.createElement("rect",candleProps);
	}},{key:"getCandleProps",value:function getCandleProps(
	
	props){var
	candleHeight=props.candleHeight,x=props.x,y=props.y,events=props.events,role=props.role,className=props.className;
	var shapeRendering=props.shapeRendering||"auto";
	var candleX=x-this.candleWidth/2;
	return(0,_assign3.default)({
	x:candleX,y:y,style:this.style,role:role,width:this.candleWidth,height:candleHeight,
	shapeRendering:shapeRendering,className:className},
	events);
	}},{key:"getWickProps",value:function getWickProps(
	
	props){var
	x=props.x,y1=props.y1,y2=props.y2,events=props.events,className=props.className;
	var shapeRendering=props.shapeRendering||"auto";
	var role=props.role||"presentation";
	return(0,_assign3.default)(
	{x1:x,x2:x,y1:y1,y2:y2,style:this.style,role:role,shapeRendering:shapeRendering,className:className},
	events);
	
	}},{key:"render",value:function render()
	
	{
	var candleProps=this.getCandleProps(this.props);
	var wickProps=this.getWickProps(this.props);
	return _react2.default.cloneElement(
	this.props.groupComponent,{},this.renderWick(wickProps),this.renderCandle(candleProps));
	
	}}]);return Candle;}(_react2.default.Component);Candle.propTypes=_extends({},_commonProps2.default,{candleHeight:_propTypes2.default.number,datum:_propTypes2.default.object,groupComponent:_propTypes2.default.element,padding:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.object]),width:_propTypes2.default.number,x:_propTypes2.default.number,y:_propTypes2.default.number,y1:_propTypes2.default.number,y2:_propTypes2.default.number});Candle.defaultProps={groupComponent:_react2.default.createElement("g",null)};exports.default=Candle;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _victoryUtil=__webpack_require__(53);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	
	
	ClipPath=function(_React$Component){_inherits(ClipPath,_React$Component);function ClipPath(){_classCallCheck(this,ClipPath);return _possibleConstructorReturn(this,(ClipPath.__proto__||Object.getPrototypeOf(ClipPath)).apply(this,arguments));}_createClass(ClipPath,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{
	_extends(this,this.calculateAttributes(this.props));
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){
	var calculatedAttributes=this.calculateAttributes(nextProps);
	if(!_victoryUtil.Collection.allSetsEqual([
	[this.props.clipId,nextProps.clipId],
	[this.x,calculatedAttributes.x],
	[this.y,calculatedAttributes.y],
	[this.height,calculatedAttributes.height],
	[this.width,calculatedAttributes.width]]))
	{
	_extends(this,calculatedAttributes);
	return true;
	}
	return false;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){var _props$clipWidth=
	props.clipWidth,clipWidth=_props$clipWidth===undefined?0:_props$clipWidth,_props$clipHeight=props.clipHeight,clipHeight=_props$clipHeight===undefined?0:_props$clipHeight,_props$translateX=props.translateX,translateX=_props$translateX===undefined?0:_props$translateX,_props$translateY=props.translateY,translateY=_props$translateY===undefined?0:_props$translateY;
	var clipPadding=_victoryUtil.Helpers.getPadding({padding:props.clipPadding});
	
	return{
	x:translateX-clipPadding.left,
	y:translateY-clipPadding.top,
	width:Math.max(clipWidth+clipPadding.left+clipPadding.right,0),
	height:Math.max(clipHeight+clipPadding.top+clipPadding.bottom,0)};
	
	}},{key:"renderClipPath",value:function renderClipPath(
	
	
	props,id){
	return(
	_react2.default.createElement("defs",null,
	_react2.default.createElement("clipPath",{id:id},
	_react2.default.createElement("rect",props))));
	
	
	
	}},{key:"render",value:function render()
	
	{var _props=
	this.props,clipId=_props.clipId,className=_props.className;
	var clipProps={className:className,x:this.x,y:this.y,width:this.width,height:this.height};
	return this.renderClipPath(clipProps,clipId);
	}}]);return ClipPath;}(_react2.default.Component);ClipPath.propTypes={className:_propTypes2.default.string,clipHeight:_victoryUtil.PropTypes.nonNegative,clipId:_propTypes2.default.number,clipPadding:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.shape({top:_propTypes2.default.number,bottom:_propTypes2.default.number,left:_propTypes2.default.number,right:_propTypes2.default.number})]),clipWidth:_victoryUtil.PropTypes.nonNegative,translateX:_propTypes2.default.number,translateY:_propTypes2.default.number};exports.default=ClipPath;

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _victoryUtil=__webpack_require__(53);
	
	var _d3Shape=__webpack_require__(642);var d3Shape=_interopRequireWildcard(_d3Shape);
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Curve=function(_React$Component){_inherits(Curve,_React$Component);function Curve(){_classCallCheck(this,Curve);return _possibleConstructorReturn(this,(Curve.__proto__||Object.getPrototypeOf(Curve)).apply(this,arguments));}_createClass(Curve,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	
	{var _calculateAttributes=
	this.calculateAttributes(this.props),style=_calculateAttributes.style,paths=_calculateAttributes.paths;
	this.style=style;
	this.paths=paths;
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _calculateAttributes2=
	this.calculateAttributes(nextProps),style=_calculateAttributes2.style,paths=_calculateAttributes2.paths;
	if(!(0,_isEqual3.default)(paths,this.paths)||!(0,_isEqual3.default)(style,this.style)){
	this.style=style;
	this.paths=paths;
	return true;
	}
	return false;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){var
	style=props.style,data=props.data,active=props.active,scale=props.scale,interpolation=props.interpolation;
	var dataSegments=this.getDataSegments(data);
	var xScale=scale.x;
	var yScale=scale.y;
	var lineFunction=d3Shape.line().
	curve(d3Shape[this.toNewName(interpolation)]).
	x(function(d){return xScale(d._x1!==undefined?d._x1:d._x);}).
	y(function(d){return yScale(d._y1!==undefined?d._y1:d._y);});
	return{
	style:_victoryUtil.Helpers.evaluateStyle(
	(0,_assign3.default)({fill:"none",stroke:"black"},style),data,active),
	
	paths:dataSegments.map(function(d){return lineFunction(d);})};
	
	}},{key:"getDataSegments",value:function getDataSegments(
	
	data){
	return _victoryUtil.Collection.splitArray(data,function(datum){
	var yDatum=datum.y1!==undefined?datum._y1:datum._y;
	
	return yDatum===null||typeof yDatum==="undefined";
	}).filter(function(segment){return segment.length>1;});
	}},{key:"toNewName",value:function toNewName(
	
	interpolation){
	
	var capitalize=function capitalize(s){return s&&s[0].toUpperCase()+s.slice(1);};
	return"curve"+capitalize(interpolation);
	}},{key:"renderLine",value:function renderLine(
	
	
	paths,style,events){var _props=
	this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
	return paths.map(function(path,index){
	return(
	_react2.default.createElement("path",_extends({
	key:"area-stroke-"+index,
	style:style,
	shapeRendering:shapeRendering||"auto",
	role:role||"presentation",
	d:path,
	className:className},
	events)));
	
	
	});
	}},{key:"render",value:function render()
	
	{var _props2=
	this.props,events=_props2.events,groupComponent=_props2.groupComponent;
	var children=this.renderLine(this.paths,this.style,events);
	return children.length===1?children[0]:_react2.default.cloneElement(groupComponent,{},children);
	}}]);return Curve;}(_react2.default.Component);Curve.propTypes=_extends({},_commonProps2.default,{groupComponent:_propTypes2.default.element,interpolation:_propTypes2.default.string});Curve.defaultProps={groupComponent:_react2.default.createElement("g",null)};exports.default=Curve;

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _victoryUtil=__webpack_require__(53);
	
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	ErrorBar=function(_React$Component){_inherits(ErrorBar,_React$Component);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function ErrorBar(props){_classCallCheck(this,ErrorBar);return _possibleConstructorReturn(this,(ErrorBar.__proto__||Object.getPrototypeOf(ErrorBar)).call(this,
	props));
	}_createClass(ErrorBar,[{key:"componentWillMount",value:function componentWillMount()
	
	{
	this.style=this.getStyle(this.props);
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _props=
	this.props,x=_props.x,y=_props.y,errorX=_props.errorX,errorY=_props.errorY;
	var nextStyle=this.getStyle(nextProps);
	
	if(!_victoryUtil.Collection.allSetsEqual([
	[x,nextProps.x],
	[y,nextProps.y],
	[errorX,nextProps.errorX],
	[errorY,nextProps.errorY],
	[this.style,nextStyle]]))
	{
	this.style=nextStyle;
	return true;
	}
	
	return false;
	}},{key:"getStyle",value:function getStyle(
	
	props){var
	style=props.style,datum=props.datum,active=props.active;
	return _victoryUtil.Helpers.evaluateStyle((0,_assign3.default)({stroke:"black"},style),datum,active);
	}},{key:"renderLine",value:function renderLine(
	
	
	props,style,events){
	return _react2.default.createElement("line",_extends({},props,{style:style},events));
	}},{key:"renderBorder",value:function renderBorder(
	
	props,error,type){var
	x=props.x,y=props.y,borderWidth=props.borderWidth,events=props.events,style=props.style,role=props.role,shapeRendering=props.shapeRendering,className=props.className;
	var vertical=type==="Right"||type==="Left";
	var errorPortion=error["error"+type];
	var borderProps={
	role:role,shapeRendering:shapeRendering,className:className,
	key:"border"+type,
	x1:vertical?errorPortion:x-borderWidth,
	x2:vertical?errorPortion:x+borderWidth,
	y1:vertical?y-borderWidth:errorPortion,
	y2:vertical?y+borderWidth:errorPortion};
	
	return this.renderLine(borderProps,style,events);
	}},{key:"renderCross",value:function renderCross(
	
	props,error,type){var
	x=props.x,y=props.y,events=props.events,style=props.style,role=props.role,shapeRendering=props.shapeRendering,className=props.className;
	var vertical=type==="Top"||type==="Bottom";
	var errorPortion=error["error"+type];
	var borderProps={
	role:role,shapeRendering:shapeRendering,className:className,
	key:"cross"+type,
	x1:x,
	x2:vertical?x:errorPortion,
	y1:y,
	y2:vertical?errorPortion:y};
	
	return this.renderLine(borderProps,style,events);
	}},{key:"renderErrorBar",value:function renderErrorBar(
	
	error,props){var
	groupComponent=props.groupComponent;
	return _react2.default.cloneElement(groupComponent,{},
	error.errorRight?this.renderBorder(props,error,"Right"):null,
	error.errorLeft?this.renderBorder(props,error,"Left"):null,
	error.errorBottom?this.renderBorder(props,error,"Bottom"):null,
	error.errorTop?this.renderBorder(props,error,"Top"):null,
	error.errorRight?this.renderCross(props,error,"Right"):null,
	error.errorLeft?this.renderCross(props,error,"Left"):null,
	error.errorBottom?this.renderCross(props,error,"Bottom"):null,
	error.errorTop?this.renderCross(props,error,"Top"):null);
	
	}},{key:"render",value:function render()
	
	{var _props2=
	
	
	
	this.props,x=_props2.x,y=_props2.y,borderWidth=_props2.borderWidth,groupComponent=_props2.groupComponent,events=_props2.events,errorX=_props2.errorX,errorY=_props2.errorY,scale=_props2.scale,role=_props2.role,shapeRendering=_props2.shapeRendering,className=_props2.className;
	var rangeX=void 0;
	var rangeY=void 0;
	var positiveErrorX=void 0;
	var negativeErrorX=void 0;
	var positiveErrorY=void 0;
	var negativeErrorY=void 0;
	var errorTop=void 0;
	var errorBottom=void 0;
	var errorRight=void 0;
	var errorLeft=void 0;
	
	if(errorX){
	rangeX=scale.x.range();
	positiveErrorX=errorX[0];
	negativeErrorX=errorX[1];
	errorRight=positiveErrorX>=rangeX[1]?rangeX[1]:positiveErrorX;
	errorLeft=negativeErrorX<=rangeX[0]?rangeX[0]:negativeErrorX;
	}
	
	if(errorY){
	rangeY=scale.y.range();
	positiveErrorY=errorY[1];
	negativeErrorY=errorY[0];
	errorTop=positiveErrorY>=rangeY[0]?rangeY[0]:positiveErrorY;
	errorBottom=negativeErrorY<=rangeY[1]?rangeY[1]:negativeErrorY;
	}
	var props={
	x:x,y:y,borderWidth:borderWidth,groupComponent:groupComponent,events:events,className:className,
	role:role||"presentation",
	shapeRendering:shapeRendering||"auto",
	style:this.style};
	
	return _react2.default.cloneElement(
	this.props.groupComponent,
	{},
	this.renderErrorBar({errorTop:errorTop,errorBottom:errorBottom,errorRight:errorRight,errorLeft:errorLeft},props));
	
	}}]);return ErrorBar;}(_react2.default.Component);ErrorBar.propTypes=_extends({},_commonProps2.default,{borderWidth:_propTypes2.default.number,datum:_propTypes2.default.object,errorX:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.array,_propTypes2.default.bool]),errorY:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.array,_propTypes2.default.bool]),groupComponent:_propTypes2.default.element,x:_propTypes2.default.number,y:_propTypes2.default.number});ErrorBar.defaultProps={borderWidth:10,groupComponent:_react2.default.createElement("g",null)};exports.default=ErrorBar;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Flyout=function(_React$Component){_inherits(Flyout,_React$Component);function Flyout(){_classCallCheck(this,Flyout);return _possibleConstructorReturn(this,(Flyout.__proto__||Object.getPrototypeOf(Flyout)).apply(this,arguments));}_createClass(Flyout,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{var _calculateAttributes=
	this.calculateAttributes(this.props),style=_calculateAttributes.style,path=_calculateAttributes.path;
	this.style=style;
	this.path=path;
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _calculateAttributes2=
	this.calculateAttributes(nextProps),style=_calculateAttributes2.style,path=_calculateAttributes2.path;
	if(path!==this.path||!(0,_isEqual3.default)(style,this.style)){
	this.style=style;
	this.path=path;
	return true;
	}
	return false;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){var
	datum=props.datum,active=props.active,style=props.style;
	return{
	style:_helpers2.default.evaluateStyle(style,datum,active),
	path:this.getFlyoutPath(props)};
	
	}},{key:"getVerticalPath",value:function getVerticalPath(
	
	
	props){var
	pointerLength=props.pointerLength,pointerWidth=props.pointerWidth,cornerRadius=props.cornerRadius,orientation=props.orientation,width=props.width,height=props.height;
	var sign=orientation==="top"?1:-1;
	var x=props.x+(props.dx||0);
	var y=props.y-sign*(props.dy||0);
	var pointerEdge=y-sign*pointerLength;
	var oppositeEdge=y-sign*pointerLength-sign*height;
	var rightEdge=x+width/2;
	var leftEdge=x-width/2;
	var direction=orientation==="top"?"0 0 0":"0 0 1";
	var arc=Math.round(cornerRadius)+" "+Math.round(cornerRadius)+" "+direction;
	return"M "+Math.round(x-pointerWidth/2)+", "+Math.round(pointerEdge)+"\n      L "+
	Math.round(x)+", "+Math.round(y)+"\n      L "+
	Math.round(x+pointerWidth/2)+", "+Math.round(pointerEdge)+"\n      L "+
	Math.round(rightEdge-cornerRadius)+", "+Math.round(pointerEdge)+"\n      A "+
	arc+" "+Math.round(rightEdge)+", "+Math.round(pointerEdge-sign*cornerRadius)+"\n      L "+
	Math.round(rightEdge)+", "+Math.round(oppositeEdge+sign*cornerRadius)+"\n      A "+
	arc+" "+Math.round(rightEdge-cornerRadius)+", "+Math.round(oppositeEdge)+"\n      L "+
	Math.round(leftEdge+cornerRadius)+", "+Math.round(oppositeEdge)+"\n      A "+
	arc+" "+Math.round(leftEdge)+", "+Math.round(oppositeEdge+sign*cornerRadius)+"\n      L "+
	Math.round(leftEdge)+", "+Math.round(pointerEdge-sign*cornerRadius)+"\n      A "+
	arc+" "+Math.round(leftEdge+cornerRadius)+", "+Math.round(pointerEdge)+"\n      z";
	
	}},{key:"getHorizontalPath",value:function getHorizontalPath(
	
	props){var
	pointerLength=props.pointerLength,pointerWidth=props.pointerWidth,cornerRadius=props.cornerRadius,orientation=props.orientation,width=props.width,height=props.height;
	var sign=orientation==="right"?1:-1;
	var x=props.x+sign*(props.dx||0);
	var y=props.y-(props.dy||0);
	var pointerEdge=x+sign*pointerLength;
	var oppositeEdge=x+sign*pointerLength+sign*width;
	var bottomEdge=y+height/2;
	var topEdge=y-height/2;
	var direction=orientation==="right"?"0 0 0":"0 0 1";
	var arc=Math.round(cornerRadius)+" "+Math.round(cornerRadius)+" "+direction;
	return"M "+Math.round(pointerEdge)+", "+Math.round(y-pointerWidth/2)+"\n      L "+
	Math.round(x)+", "+Math.round(y)+"\n      L "+
	Math.round(pointerEdge)+", "+Math.round(y+pointerWidth/2)+"\n      L "+
	Math.round(pointerEdge)+", "+Math.round(bottomEdge-cornerRadius)+"\n      A "+
	arc+" "+Math.round(pointerEdge+sign*cornerRadius)+", "+Math.round(bottomEdge)+"\n      L "+(
	oppositeEdge-sign*cornerRadius)+", "+bottomEdge+"\n      A "+
	arc+" "+Math.round(oppositeEdge)+", "+Math.round(bottomEdge-cornerRadius)+"\n      L "+
	oppositeEdge+", "+(topEdge+cornerRadius)+"\n      A "+
	arc+" "+Math.round(oppositeEdge-sign*cornerRadius)+", "+Math.round(topEdge)+"\n      L "+
	Math.round(pointerEdge+sign*cornerRadius)+", "+Math.round(topEdge)+"\n      A "+
	arc+" "+Math.round(pointerEdge)+", "+Math.round(topEdge+cornerRadius)+"\n      z";
	
	}},{key:"getFlyoutPath",value:function getFlyoutPath(
	
	props){
	var orientation=props.orientation||"top";
	return orientation==="left"||orientation==="right"?
	this.getHorizontalPath(props):this.getVerticalPath(props);
	}},{key:"renderFlyout",value:function renderFlyout(
	
	
	path,style,events){var _props=
	this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
	return(
	_react2.default.createElement("path",_extends({
	className:className,
	d:path,
	style:style,
	shapeRendering:shapeRendering||"auto",
	role:role||"presentation"},
	events)));
	
	
	}},{key:"render",value:function render()
	
	{
	return this.renderFlyout(this.path,this.style,this.props.events);
	}}]);return Flyout;}(_react2.default.Component);Flyout.propTypes=_extends({},_commonProps2.default,{cornerRadius:_propTypes2.default.number,datum:_propTypes2.default.object,dx:_propTypes2.default.number,dy:_propTypes2.default.number,height:_propTypes2.default.number,orientation:_propTypes2.default.oneOf(["top","bottom","left","right"]),pointerLength:_propTypes2.default.number,pointerWidth:_propTypes2.default.number,width:_propTypes2.default.number,x:_propTypes2.default.number,y:_propTypes2.default.number});exports.default=Flyout;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Line=function(_React$Component){_inherits(Line,_React$Component);function Line(){_classCallCheck(this,Line);return _possibleConstructorReturn(this,(Line.__proto__||Object.getPrototypeOf(Line)).apply(this,arguments));}_createClass(Line,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	{
	this.style=this.getStyle(this.props);
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _props=
	this.props,x1=_props.x1,x2=_props.x2,y1=_props.y1,y2=_props.y2;
	var style=this.getStyle(nextProps);
	if(x1!==nextProps.x1||x2!==nextProps.x2||y1!==nextProps.y1||y2!==nextProps.y2){
	this.style=style;
	return true;
	}
	
	if(!(0,_isEqual3.default)(style,this.style)){
	this.style=style;
	return true;
	}
	
	return false;
	}},{key:"getStyle",value:function getStyle(
	
	props){var
	style=props.style,datum=props.datum,active=props.active;
	return _helpers2.default.evaluateStyle((0,_assign3.default)({stroke:"black"},style),datum,active);
	}},{key:"renderAxisLine",value:function renderAxisLine(
	
	
	props,style,events){var _props2=
	this.props,role=_props2.role,shapeRendering=_props2.shapeRendering,className=_props2.className;
	return(
	_react2.default.createElement("line",_extends({},
	props,{
	className:className,
	style:style,
	role:role||"presentation",
	shapeRendering:shapeRendering||"auto",
	vectorEffect:"non-scaling-stroke"},
	events)));
	
	
	}},{key:"render",value:function render()
	
	{var _props3=
	this.props,x1=_props3.x1,x2=_props3.x2,y1=_props3.y1,y2=_props3.y2,events=_props3.events;
	return this.renderAxisLine({x1:x1,x2:x2,y1:y1,y2:y2},this.style,events);
	}}]);return Line;}(_react2.default.Component);Line.propTypes=_extends({},_commonProps2.default,{datum:_propTypes2.default.any,x1:_propTypes2.default.number,x2:_propTypes2.default.number,y1:_propTypes2.default.number,y2:_propTypes2.default.number});exports.default=Line;

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _range2=__webpack_require__(51);var _range3=_interopRequireDefault(_range2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=
	
	
	{
	circle:function circle(x,y,size){
	var s=Math.round(size);
	return"M "+Math.round(x)+", "+Math.round(y)+" m "+-s+", 0\n      a "+
	s+", "+s+" 0 1,0 "+s*2+",0\n      a "+
	s+", "+s+" 0 1,0 "+-s*2+",0";
	},
	
	square:function square(x,y,size){
	var baseSize=0.87*size;
	var x0=Math.round(x-baseSize);
	var x1=Math.round(x+baseSize);
	var y0=Math.round(y-baseSize);
	var y1=Math.round(y+baseSize);
	return"M "+x0+", "+y1+"\n      L "+
	x1+", "+y1+"\n      L "+
	x1+", "+y0+"\n      L "+
	x0+", "+y0+"\n      z";
	
	},
	
	diamond:function diamond(x,y,size){
	var baseSize=0.87*size;
	var length=Math.sqrt(2*(baseSize*baseSize));
	return"M "+Math.round(x)+", "+Math.round(y+length)+"\n      L "+
	Math.round(x+length)+", "+Math.round(y)+"\n      L "+
	Math.round(x)+", "+Math.round(y-length)+"\n      L "+
	Math.round(x-length)+", "+Math.round(y)+"\n      z";
	
	},
	
	triangleDown:function triangleDown(x,y,size){
	var height=size/2*Math.sqrt(3);
	var x0=Math.round(x-size);
	var x1=Math.round(x+size);
	var y0=Math.round(y-size);
	var y1=Math.round(y+height);
	return"M "+x0+", "+y0+"\n      L "+
	x1+", "+y0+"\n      L "+
	Math.round(x)+", "+y1+"\n      z";
	
	},
	
	triangleUp:function triangleUp(x,y,size){
	var height=size/2*Math.sqrt(3);
	var x0=Math.round(x-size);
	var x1=Math.round(x+size);
	var y0=Math.round(y-height);
	var y1=Math.round(y+size);
	return"M "+x0+", "+y1+"\n      L "+
	x1+", "+y1+"\n      L "+
	Math.round(x)+", "+y0+"\n      z";
	
	},
	
	plus:function plus(x,y,size){
	var baseSize=1.1*size;
	return"M "+Math.round(x-baseSize/2.5)+", "+Math.round(y+baseSize)+"\n      L "+
	Math.round(x+baseSize/2.5)+", "+Math.round(y+baseSize)+"\n      L "+
	Math.round(x+baseSize/2.5)+", "+Math.round(y+baseSize/2.5)+"\n      L "+
	Math.round(x+baseSize)+", "+Math.round(y+baseSize/2.5)+"\n      L "+
	Math.round(x+baseSize)+", "+Math.round(y-baseSize/2.5)+"\n      L "+
	Math.round(x+baseSize/2.5)+", "+Math.round(y-baseSize/2.5)+"\n      L "+
	Math.round(x+baseSize/2.5)+", "+Math.round(y-baseSize)+"\n      L "+
	Math.round(x-baseSize/2.5)+", "+Math.round(y-baseSize)+"\n      L "+
	Math.round(x-baseSize/2.5)+", "+Math.round(y-baseSize/2.5)+"\n      L "+
	Math.round(x-baseSize)+", "+Math.round(y-baseSize/2.5)+"\n      L "+
	Math.round(x-baseSize)+", "+Math.round(y+baseSize/2.5)+"\n      L "+
	Math.round(x-baseSize/2.5)+", "+Math.round(y+baseSize/2.5)+"\n      z";
	
	},
	
	star:function star(x,y,size){
	var baseSize=1.35*size;
	var angle=Math.PI/5;
	var starCoords=(0,_range3.default)(10).map(function(index){
	var length=index%2===0?baseSize:baseSize/2;
	return length*Math.sin(angle*(index+1))+x+",\n        "+(
	length*Math.cos(angle*(index+1))+y);
	});
	return"M "+starCoords.join("L")+" z";
	}};

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Slice=function(_React$Component){_inherits(Slice,_React$Component);function Slice(){_classCallCheck(this,Slice);return _possibleConstructorReturn(this,(Slice.__proto__||Object.getPrototypeOf(Slice)).apply(this,arguments));}_createClass(Slice,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	{var _calculateAttributes=
	this.calculateAttributes(this.props),style=_calculateAttributes.style,path=_calculateAttributes.path;
	this.style=style;
	this.path=path;
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _calculateAttributes2=
	this.calculateAttributes(nextProps),style=_calculateAttributes2.style,path=_calculateAttributes2.path;
	if(path!==this.path||!(0,_isEqual3.default)(style,this.style)){
	this.style=style;
	this.path=path;
	return true;
	}
	return false;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){var
	style=props.style,datum=props.datum,active=props.active,pathFunction=props.pathFunction,slice=props.slice;
	return{
	style:_helpers2.default.evaluateStyle(style,datum,active),
	path:pathFunction(slice)};
	
	}},{key:"renderSlice",value:function renderSlice(
	
	
	path,style,events){var _props=
	this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
	return(
	_react2.default.createElement("path",_extends({
	d:path,
	className:className,
	role:role||"presentation",
	style:style,
	shapeRendering:shapeRendering||"auto"},
	events)));
	
	
	}},{key:"render",value:function render()
	
	{
	return this.renderSlice(this.path,this.style,this.props.events);
	}}]);return Slice;}(_react2.default.Component);Slice.propTypes=_extends({},_commonProps2.default,{datum:_propTypes2.default.object,pathFunction:_propTypes2.default.func,slice:_propTypes2.default.object});exports.default=Slice;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=__webpack_require__(31);var _isEqual3=_interopRequireDefault(_isEqual2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	
	var _commonProps=__webpack_require__(79);var _commonProps2=_interopRequireDefault(_commonProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	Voronoi=function(_React$Component){_inherits(Voronoi,_React$Component);function Voronoi(){_classCallCheck(this,Voronoi);return _possibleConstructorReturn(this,(Voronoi.__proto__||Object.getPrototypeOf(Voronoi)).apply(this,arguments));}_createClass(Voronoi,[{key:"componentWillMount",value:function componentWillMount()
	
	
	
	
	
	
	
	
	
	{var _calculateAttributes=
	this.calculateAttributes(this.props),style=_calculateAttributes.style,circle=_calculateAttributes.circle,voronoi=_calculateAttributes.voronoi;
	this.style=style;
	this.circle=circle;
	this.voronoi=voronoi;
	}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
	
	nextProps){var _calculateAttributes2=
	this.calculateAttributes(nextProps),style=_calculateAttributes2.style,circle=_calculateAttributes2.circle,voronoi=_calculateAttributes2.voronoi;
	if(circle!==this.circle||voronoi!==this.voronoi||!(0,_isEqual3.default)(style,this.style)){
	this.style=style;
	this.circle=circle;
	this.voronoi=voronoi;
	return true;
	}
	return false;
	}},{key:"calculateAttributes",value:function calculateAttributes(
	
	props){var
	style=props.style,datum=props.datum,active=props.active;
	return{
	style:_helpers2.default.evaluateStyle(style,datum,active),
	circle:this.getCirclePath(props),
	voronoi:this.getVoronoiPath(props)};
	
	}},{key:"getVoronoiPath",value:function getVoronoiPath(
	
	props){var
	polygon=props.polygon;
	return Array.isArray(polygon)&&polygon.length?"M "+
	props.polygon.join("L")+" Z":"";
	}},{key:"getCirclePath",value:function getCirclePath(
	
	props){
	if(!props.size){
	return null;
	}var
	x=props.x,y=props.y,datum=props.datum,active=props.active;
	var size=_helpers2.default.evaluateProp(props.size,datum,active);
	return"M "+x+", "+y+" m "+-size+", 0\n      a "+
	size+", "+size+" 0 1,0 "+size*2+",0\n      a "+
	size+", "+size+" 0 1,0 "+-size*2+",0";
	}},{key:"renderPoint",value:function renderPoint(
	
	
	paths,style,events){
	var clipId=paths.circle&&"clipPath-"+Math.random();
	var clipPath=paths.circle?"url(#"+clipId+")":undefined;var _props=
	this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
	var voronoiPath=
	_react2.default.createElement("path",_extends({
	d:paths.circle||paths.voronoi,
	className:className,
	clipPath:clipPath,
	style:style,
	role:role||"presentation",
	shapeRendering:shapeRendering||"auto"},
	events));
	
	
	return paths.circle?
	
	_react2.default.createElement("g",null,
	_react2.default.createElement("defs",null,
	_react2.default.createElement("clipPath",{id:clipId},
	_react2.default.createElement("path",{d:paths.voronoi,className:className}))),
	
	
	voronoiPath):
	
	
	voronoiPath;
	}},{key:"render",value:function render()
	
	{
	var paths={
	circle:this.circle,
	voronoi:this.voronoi};
	
	return this.renderPoint(paths,this.style,this.props.events);
	}}]);return Voronoi;}(_react2.default.Component);Voronoi.propTypes=_extends({},_commonProps2.default,{datum:_propTypes2.default.object,polygon:_propTypes2.default.array,size:_propTypes2.default.number,x:_propTypes2.default.number,y:_propTypes2.default.number});exports.default=Voronoi;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _fromPairs2=__webpack_require__(1016);var _fromPairs3=_interopRequireDefault(_fromPairs2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _index=__webpack_require__(53);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var
	
	VictorySharedEvents=function(_React$Component){_inherits(VictorySharedEvents,_React$Component);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function VictorySharedEvents(){_classCallCheck(this,VictorySharedEvents);var _this=_possibleConstructorReturn(this,(VictorySharedEvents.__proto__||Object.getPrototypeOf(VictorySharedEvents)).call(this));
	
	_this.state=_this.state||{};
	_this.getScopedEvents=_index.Events.getScopedEvents.bind(_this);
	_this.getEventState=_index.Events.getEventState.bind(_this);
	_this.getTimer=_this.getTimer.bind(_this);return _this;
	}_createClass(VictorySharedEvents,[{key:"getChildContext",value:function getChildContext()
	
	{
	return{
	getTimer:this.getTimer};
	
	}},{key:"componentWillMount",value:function componentWillMount()
	
	{
	this.setUpChildren(this.props);
	}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(
	
	newProps){
	this.setUpChildren(newProps);
	}},{key:"getTimer",value:function getTimer()
	
	{
	if(this.context.getTimer){
	return this.context.getTimer();
	}
	if(!this.timer){
	this.timer=new _index.Timer();
	}
	return this.timer;
	}},{key:"getAllEvents",value:function getAllEvents(
	
	props){
	var components=["container","groupComponent"];
	this.componentEvents=_index.Events.getComponentEvents(props,components);
	if(Array.isArray(this.componentEvents)){var _componentEvents;
	return Array.isArray(props.events)?
	(_componentEvents=this.componentEvents).concat.apply(_componentEvents,_toConsumableArray(props.events)):this.componentEvents;
	}
	return props.events;
	}},{key:"setUpChildren",value:function setUpChildren(
	
	props){
	this.events=this.getAllEvents(props);
	if(this.events){
	this.childComponents=_react2.default.Children.toArray(props.children);
	var childBaseProps=this.getBasePropsFromChildren(this.childComponents);
	var parentBaseProps=props.container?props.container.props:{};
	this.baseProps=(0,_assign3.default)({},childBaseProps,{parent:parentBaseProps});
	}
	}},{key:"getBasePropsFromChildren",value:function getBasePropsFromChildren(
	
	childComponents){
	var iteratee=function iteratee(child,childName,parent){
	if(child.type&&(0,_isFunction3.default)(child.type.getBaseProps)){
	child=parent?_react2.default.cloneElement(child,parent.props):child;
	var _baseProps=child.props&&child.type.getBaseProps(child.props);
	return _baseProps?[[childName,_baseProps]]:null;
	}else{
	return null;
	}
	};
	
	var baseProps=_index.Helpers.reduceChildren(childComponents,iteratee);
	return(0,_fromPairs3.default)(baseProps);
	}},{key:"getNewChildren",value:function getNewChildren(
	
	props){var _this2=this;var
	events=props.events,eventKey=props.eventKey;
	var childNames=Object.keys(this.baseProps);
	var alterChildren=function alterChildren(children){
	return children.reduce(function(memo,child,index){
	if(child.props.children){
	return memo.concat(_react2.default.cloneElement(
	child,
	child.props,
	alterChildren(_react2.default.Children.toArray(child.props.children))));
	
	}else if(child.type&&(0,_isFunction3.default)(child.type.getBaseProps)){
	var name=child.props.name||childNames.shift()||index;
	var childEvents=Array.isArray(events)&&
	events.filter(function(event){
	if(event.target==="parent"){
	return false;
	}
	return Array.isArray(event.childName)?
	event.childName.indexOf(name)>-1:
	event.childName===name||event.childName==="all";
	});
	var sharedEvents={
	events:childEvents,
	getEvents:(0,_partialRight3.default)(_this2.getScopedEvents,name,_this2.baseProps),
	getEventState:(0,_partialRight3.default)(_this2.getEventState,name)};
	
	return memo.concat(_react2.default.cloneElement(child,(0,_assign3.default)(
	{key:"events-"+name,sharedEvents:sharedEvents,eventKey:eventKey},
	child.props)));
	
	}else{
	return memo.concat(child);
	}
	},[]);
	};
	
	return alterChildren(this.childComponents);
	}},{key:"getContainer",value:function getContainer(
	
	props,children){
	var parents=Array.isArray(this.events)&&
	this.events.filter(function(event){return event.target==="parent";});
	var sharedEvents=parents.length>0?
	{
	events:parents,
	getEvents:(0,_partialRight3.default)(this.getScopedEvents,null,this.baseProps),
	getEventState:(0,_partialRight3.default)(this.getEventState,null)}:
	null;
	var container=this.props.container||this.props.groupComponent;
	var containerProps=container.props||{};
	var boundGetEvents=_index.Events.getEvents.bind(this);
	var parentEvents=sharedEvents&&boundGetEvents({sharedEvents:sharedEvents},"parent");
	var parentProps=(0,_defaults3.default)(
	{},
	this.getEventState("parent","parent"),
	containerProps,
	this.baseProps.parent,
	{children:children});
	
	var events=(0,_defaults3.default)(
	{},_index.Events.getPartialEvents(parentEvents,"parent",parentProps),containerProps.events);
	
	return _react2.default.cloneElement(container,(0,_assign3.default)({},parentProps,{events:events}));
	}},{key:"render",value:function render()
	
	{
	if(this.events){
	var children=this.getNewChildren(this.props);
	return this.getContainer(this.props,children);
	}
	return _react2.default.cloneElement(this.props.container,{children:this.props.children});
	}}]);return VictorySharedEvents;}(_react2.default.Component);VictorySharedEvents.displayName="VictorySharedEvents";VictorySharedEvents.role="shared-event-wrapper";VictorySharedEvents.propTypes={children:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node),_propTypes2.default.node]),container:_propTypes2.default.node,eventKey:_propTypes2.default.oneOfType([_propTypes2.default.array,_propTypes2.default.func,_index.PropTypes.allOfType([_index.PropTypes.integer,_index.PropTypes.nonNegative]),_propTypes2.default.string]),events:_propTypes2.default.arrayOf(_propTypes2.default.shape({childName:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.array]),eventHandlers:_propTypes2.default.object,eventKey:_propTypes2.default.oneOfType([_propTypes2.default.array,_propTypes2.default.func,_index.PropTypes.allOfType([_index.PropTypes.integer,_index.PropTypes.nonNegative]),_propTypes2.default.string]),target:_propTypes2.default.string})),groupComponent:_propTypes2.default.node};VictorySharedEvents.defaultProps={groupComponent:_react2.default.createElement("g",null)};VictorySharedEvents.contextTypes={getTimer:_propTypes2.default.func};VictorySharedEvents.childContextTypes={getTimer:_propTypes2.default.func};exports.default=VictorySharedEvents;

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}
	
	
	
	
	var colors=[
	"#252525",
	"#525252",
	"#737373",
	"#969696",
	"#bdbdbd",
	"#d9d9d9",
	"#f0f0f0"];
	
	
	var charcoal="#252525";
	
	
	
	var sansSerif="'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif";
	var letterSpacing="normal";
	var fontSize=14;
	
	
	
	var baseProps={
	width:450,
	height:300,
	padding:50,
	colorScale:colors};
	
	
	
	
	var baseLabelStyles={
	fontFamily:sansSerif,
	fontSize:fontSize,
	letterSpacing:letterSpacing,
	padding:10,
	fill:charcoal,
	stroke:"transparent"};
	
	
	var centeredLabelStyles=(0,_assign3.default)({textAnchor:"middle"},baseLabelStyles);
	
	
	
	var strokeLinecap="round";
	var strokeLinejoin="round";exports.default=
	
	{
	area:(0,_assign3.default)({
	style:{
	data:{
	fill:charcoal},
	
	labels:centeredLabelStyles}},
	
	baseProps),
	axis:(0,_assign3.default)({
	style:{
	axis:{
	fill:"transparent",
	stroke:charcoal,
	strokeWidth:1,
	strokeLinecap:strokeLinecap,
	strokeLinejoin:strokeLinejoin},
	
	axisLabel:(0,_assign3.default)({},centeredLabelStyles,{
	padding:25}),
	
	grid:{
	fill:"transparent",
	stroke:"transparent",
	pointerEvents:"none"},
	
	ticks:{
	fill:"transparent",
	size:1,
	stroke:"transparent"},
	
	tickLabels:baseLabelStyles}},
	
	baseProps),
	bar:(0,_assign3.default)({
	style:{
	data:{
	fill:charcoal,
	padding:10,
	strokeWidth:0,
	width:8},
	
	labels:baseLabelStyles}},
	
	baseProps),
	candlestick:(0,_assign3.default)({
	style:{
	data:{
	stroke:charcoal,
	strokeWidth:1},
	
	labels:centeredLabelStyles},
	
	candleColors:{
	positive:"#ffffff",
	negative:charcoal}},
	
	baseProps),
	chart:baseProps,
	errorbar:(0,_assign3.default)({
	style:{
	data:{
	fill:"transparent",
	stroke:charcoal,
	strokeWidth:2},
	
	labels:centeredLabelStyles}},
	
	baseProps),
	group:(0,_assign3.default)({
	colorScale:colors},
	baseProps),
	line:(0,_assign3.default)({
	style:{
	data:{
	fill:"transparent",
	stroke:charcoal,
	strokeWidth:2},
	
	labels:centeredLabelStyles}},
	
	baseProps),
	pie:{
	style:{
	data:{
	padding:10,
	stroke:"transparent",
	strokeWidth:1},
	
	labels:(0,_assign3.default)({},baseLabelStyles,{padding:20})},
	
	colorScale:colors,
	width:400,
	height:400,
	padding:50},
	
	scatter:(0,_assign3.default)({
	style:{
	data:{
	fill:charcoal,
	stroke:"transparent",
	strokeWidth:0},
	
	labels:centeredLabelStyles}},
	
	baseProps),
	stack:(0,_assign3.default)({
	colorScale:colors},
	baseProps),
	tooltip:{
	style:(0,_assign3.default)({},centeredLabelStyles,{padding:5,pointerEvents:"none"}),
	flyoutStyle:{
	stroke:charcoal,
	strokeWidth:1,
	fill:"#f0f0f0",
	pointerEvents:"none"},
	
	cornerRadius:5,
	pointerLength:10},
	
	voronoi:(0,_assign3.default)({
	style:{
	data:{
	fill:"transparent",
	stroke:"transparent",
	strokeWidth:0},
	
	labels:(0,_assign3.default)({},centeredLabelStyles,{padding:5,pointerEvents:"none"}),
	flyout:{
	stroke:charcoal,
	strokeWidth:1,
	fill:"#f0f0f0",
	pointerEvents:"none"}}},
	
	
	baseProps),
	legend:{
	colorScale:colors,
	style:{
	data:{
	type:"circle"},
	
	labels:baseLabelStyles}}};

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}
	
	
	
	
	var yellow200="#FFF59D";
	var deepOrange600="#F4511E";
	var lime300="#DCE775";
	var lightGreen500="#8BC34A";
	var teal700="#00796B";
	var cyan900="#006064";
	var colors=[
	deepOrange600,
	yellow200,
	lime300,
	lightGreen500,
	teal700,
	cyan900];
	
	var blueGrey50="#ECEFF1";
	var blueGrey300="#90A4AE";
	var blueGrey700="#455A64";
	var grey900="#212121";
	
	
	
	var sansSerif="'Roboto', 'Helvetica Neue', Helvetica, sans-serif";
	var letterSpacing="normal";
	var fontSize=12;
	
	
	
	var padding=8;
	var baseProps={
	width:350,
	height:350,
	padding:50};
	
	
	
	
	var baseLabelStyles={
	fontFamily:sansSerif,
	fontSize:fontSize,
	letterSpacing:letterSpacing,
	padding:padding,
	fill:blueGrey700,
	stroke:"transparent",
	strokeWidth:0};
	
	
	var centeredLabelStyles=(0,_assign3.default)({textAnchor:"middle"},baseLabelStyles);
	
	
	
	var strokeDasharray="10, 5";
	var strokeLinecap="round";
	var strokeLinejoin="round";exports.default=
	
	{
	area:(0,_assign3.default)({
	style:{
	data:{
	fill:grey900},
	
	labels:centeredLabelStyles}},
	
	baseProps),
	axis:(0,_assign3.default)({
	style:{
	axis:{
	fill:"transparent",
	stroke:blueGrey300,
	strokeWidth:2,
	strokeLinecap:strokeLinecap,
	strokeLinejoin:strokeLinejoin},
	
	axisLabel:(0,_assign3.default)({},centeredLabelStyles,{
	padding:padding,
	stroke:"transparent"}),
	
	grid:{
	fill:"transparent",
	stroke:blueGrey50,
	strokeDasharray:strokeDasharray,
	strokeLinecap:strokeLinecap,
	strokeLinejoin:strokeLinejoin,
	pointerEvents:"none"},
	
	ticks:{
	fill:"transparent",
	size:5,
	stroke:blueGrey300,
	strokeWidth:1,
	strokeLinecap:strokeLinecap,
	strokeLinejoin:strokeLinejoin},
	
	tickLabels:(0,_assign3.default)({},baseLabelStyles,{
	fill:blueGrey700})}},
	
	
	baseProps),
	bar:(0,_assign3.default)({
	style:{
	data:{
	fill:blueGrey700,
	padding:padding,
	strokeWidth:0,
	width:5},
	
	labels:baseLabelStyles}},
	
	baseProps),
	candlestick:(0,_assign3.default)({
	style:{
	data:{
	stroke:blueGrey700},
	
	labels:centeredLabelStyles},
	
	candleColors:{
	positive:"#ffffff",
	negative:blueGrey700}},
	
	baseProps),
	chart:baseProps,
	errorbar:(0,_assign3.default)({
	style:{
	data:{
	fill:"transparent",
	opacity:1,
	stroke:blueGrey700,
	strokeWidth:2},
	
	labels:centeredLabelStyles}},
	
	baseProps),
	group:(0,_assign3.default)({
	colorScale:colors},
	baseProps),
	line:(0,_assign3.default)({
	style:{
	data:{
	fill:"transparent",
	opacity:1,
	stroke:blueGrey700,
	strokeWidth:2},
	
	labels:centeredLabelStyles}},
	
	baseProps),
	pie:(0,_assign3.default)({
	colorScale:colors,
	style:{
	data:{
	padding:padding,
	stroke:blueGrey50,
	strokeWidth:1},
	
	labels:(0,_assign3.default)({},baseLabelStyles,{padding:20})}},
	
	baseProps),
	scatter:(0,_assign3.default)({
	style:{
	data:{
	fill:blueGrey700,
	opacity:1,
	stroke:"transparent",
	strokeWidth:0},
	
	labels:centeredLabelStyles}},
	
	baseProps),
	stack:(0,_assign3.default)({
	colorScale:colors},
	baseProps),
	tooltip:{
	style:(0,_assign3.default)({},centeredLabelStyles,{padding:5,pointerEvents:"none"}),
	flyoutStyle:{
	stroke:grey900,
	strokeWidth:1,
	fill:"#f0f0f0",
	pointerEvents:"none"},
	
	cornerRadius:5,
	pointerLength:10},
	
	voronoi:(0,_assign3.default)({
	style:{
	data:{
	fill:"transparent",
	stroke:"transparent",
	strokeWidth:0},
	
	labels:(0,_assign3.default)({},centeredLabelStyles,{padding:5,pointerEvents:"none"}),
	flyout:{
	stroke:grey900,
	strokeWidth:1,
	fill:"#f0f0f0",
	pointerEvents:"none"}}},
	
	
	baseProps),
	legend:{
	colorScale:colors,
	style:{
	data:{
	type:"circle"},
	
	labels:baseLabelStyles}}};

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	var _index=__webpack_require__(53);
	var _victoryLabel=__webpack_require__(365);var _victoryLabel2=_interopRequireDefault(_victoryLabel);
	var _victoryTheme=__webpack_require__(367);var _victoryTheme2=_interopRequireDefault(_victoryTheme);
	var _index2=__webpack_require__(366);
	var _victoryPortal=__webpack_require__(637);var _victoryPortal2=_interopRequireDefault(_victoryPortal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	
	var fallbackProps={
	cornerRadius:5,
	pointerLength:10,
	pointerWidth:10};var
	
	
	VictoryTooltip=function(_React$Component){_inherits(VictoryTooltip,_React$Component);function VictoryTooltip(){_classCallCheck(this,VictoryTooltip);return _possibleConstructorReturn(this,(VictoryTooltip.__proto__||Object.getPrototypeOf(VictoryTooltip)).apply(this,arguments));}_createClass(VictoryTooltip,[{key:"getEvaluatedProps",value:function getEvaluatedProps(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	props){var
	
	horizontal=
	
	props.horizontal,datum=props.datum,pointerLength=props.pointerLength,pointerWidth=props.pointerWidth,cornerRadius=props.cornerRadius,width=props.width,height=props.height,orientation=props.orientation,dx=props.dx,dy=props.dy,text=props.text,active=props.active;
	
	var style=Array.isArray(props.style)?
	props.style.map(function(s){return _index.Helpers.evaluateStyle(s,datum,active);}):
	_index.Helpers.evaluateStyle(props.style,datum,active);
	var flyoutStyle=_index.Helpers.evaluateStyle(props.flyoutStyle,datum,active);
	var padding=flyoutStyle&&flyoutStyle.padding||0;
	var defaultDx=horizontal?padding:0;
	var defaultDy=horizontal?0:padding;
	var getDefaultOrientation=function getDefaultOrientation(){
	var positive=horizontal?"right":"top";
	var negative=horizontal?"left":"bottom";
	return datum&&datum.y<0?negative:positive;
	};
	return(0,_assign3.default)(
	{},
	props,
	{
	style:style,
	flyoutStyle:flyoutStyle,
	dx:dx!==undefined?_index.Helpers.evaluateProp(dx,datum,active):defaultDx,
	dy:dy!==undefined?_index.Helpers.evaluateProp(dy,datum,active):defaultDy,
	cornerRadius:_index.Helpers.evaluateProp(cornerRadius,datum,active),
	pointerLength:_index.Helpers.evaluateProp(pointerLength,datum,active),
	pointerWidth:_index.Helpers.evaluateProp(pointerWidth,datum,active),
	orientation:_index.Helpers.evaluateProp(orientation,datum,active)||getDefaultOrientation(),
	width:_index.Helpers.evaluateProp(width,datum,active),
	height:_index.Helpers.evaluateProp(height,datum,active),
	active:_index.Helpers.evaluateProp(active,datum,active),
	text:_index.Helpers.evaluateProp(text,datum,active)});
	
	
	}},{key:"getCalculatedValues",value:function getCalculatedValues(
	
	props){var
	style=props.style,text=props.text,datum=props.datum,theme=props.theme,active=props.active;
	var defaultLabelStyles=theme&&theme.tooltip&&theme.tooltip.style?
	theme.tooltip.style:{};
	var baseLabelStyle=Array.isArray(style)?
	style.map(function(s){return(0,_defaults3.default)({},s,defaultLabelStyles);}):
	(0,_defaults3.default)({},style,defaultLabelStyles);
	var defaultFlyoutStyles=theme&&theme.tooltip&&theme.tooltip.flyoutStyle?
	theme.tooltip.flyoutStyle:{};
	var flyoutStyle=props.flyoutStyle?
	(0,_defaults3.default)({},props.flyoutStyle,defaultFlyoutStyles):defaultFlyoutStyles;
	var labelStyle=Array.isArray(baseLabelStyle)?
	baseLabelStyle.map(function(s){return _index.Helpers.evaluateStyle(s,datum,active);}):
	_index.Helpers.evaluateStyle(baseLabelStyle,datum,active);
	var labelSize=_index.TextSize.approximateTextSize(text,labelStyle);
	var flyoutDimensions=this.getDimensions(props,labelSize,labelStyle);
	var flyoutCenter=this.getFlyoutCenter(props,flyoutDimensions);
	return{labelStyle:labelStyle,flyoutStyle:flyoutStyle,labelSize:labelSize,flyoutDimensions:flyoutDimensions,flyoutCenter:flyoutCenter};
	}},{key:"getFlyoutCenter",value:function getFlyoutCenter(
	
	props,dimensions){var
	x=props.x,y=props.y,dx=props.dx,dy=props.dy,pointerLength=props.pointerLength,orientation=props.orientation;var
	height=dimensions.height,width=dimensions.width;
	var sign=orientation==="right"||orientation==="top"?1:-1;
	return{
	x:orientation==="left"||orientation==="right"?
	x+sign*(pointerLength+width/2+dx):x+sign*dx,
	y:orientation==="top"||orientation==="bottom"?
	y-sign*(pointerLength+height/2+dy):y-sign*dy};
	
	}},{key:"getLabelPadding",value:function getLabelPadding(
	
	style){
	if(!style){
	return 0;
	}
	var paddings=Array.isArray(style)?style.map(function(s){return s.padding;}):[style.padding];
	return Math.max.apply(Math,_toConsumableArray(paddings).concat([0]));
	}},{key:"getDimensions",value:function getDimensions(
	
	props,labelSize,labelStyle){var
	orientation=props.orientation,cornerRadius=props.cornerRadius,pointerLength=props.pointerLength,pointerWidth=props.pointerWidth;
	var padding=this.getLabelPadding(labelStyle);
	var getHeight=function getHeight(){
	var calculatedHeight=labelSize.height+padding;
	var minHeight=orientation==="top"||orientation==="bottom"?
	2*cornerRadius:2*cornerRadius+pointerWidth;
	return Math.max(minHeight,calculatedHeight);
	};
	var getWidth=function getWidth(){
	var calculatedWidth=labelSize.width+padding;
	var minWidth=orientation==="left"||orientation==="right"?
	2*cornerRadius+pointerLength:2*cornerRadius;
	return Math.max(minWidth,calculatedWidth);
	};
	return{
	height:props.height||getHeight(props,labelSize,orientation)+padding/2,
	width:props.width||getWidth(props,labelSize,orientation)+padding};
	
	}},{key:"getLabelProps",value:function getLabelProps(
	
	props,calculatedValues){var
	flyoutCenter=calculatedValues.flyoutCenter,labelStyle=calculatedValues.labelStyle,labelSize=calculatedValues.labelSize,dy=calculatedValues.dy,dx=calculatedValues.dx;var
	text=props.text,datum=props.datum,labelComponent=props.labelComponent,index=props.index;
	var textAnchor=(Array.isArray(labelStyle)&&labelStyle.length?
	labelStyle[0].textAnchor:
	labelStyle.textAnchor)||"middle";
	var getLabelX=function getLabelX(){
	var sign=textAnchor==="end"?-1:1;
	return flyoutCenter.x-sign*(labelSize.width/2);
	};
	return(0,_defaults3.default)(
	{},
	labelComponent.props,
	{
	key:"label-"+index,
	text:text,datum:datum,textAnchor:textAnchor,dy:dy,dx:dx,
	style:labelStyle,
	x:!textAnchor||textAnchor==="middle"?
	flyoutCenter.x:getLabelX(),
	y:flyoutCenter.y,
	verticalAnchor:"middle",
	angle:labelStyle.angle});
	
	
	}},{key:"getFlyoutProps",value:function getFlyoutProps(
	
	props,calculatedValues){var
	flyoutDimensions=calculatedValues.flyoutDimensions,flyoutStyle=calculatedValues.flyoutStyle;var
	
	x=
	
	props.x,y=props.y,dx=props.dx,dy=props.dy,orientation=props.orientation,pointerLength=props.pointerLength,pointerWidth=props.pointerWidth,cornerRadius=props.cornerRadius,events=props.events,flyoutComponent=props.flyoutComponent,index=props.index;
	return(0,_defaults3.default)(
	{},
	flyoutComponent.props,
	{
	x:x,y:y,dx:dx,dy:dy,orientation:orientation,pointerLength:pointerLength,pointerWidth:pointerWidth,cornerRadius:cornerRadius,events:events,
	key:"flyout-"+index,
	width:flyoutDimensions.width,
	height:flyoutDimensions.height,
	style:flyoutStyle});
	
	
	}},{key:"renderTooltip",value:function renderTooltip(
	
	
	props){
	var evaluatedProps=this.getEvaluatedProps(props);var
	
	flyoutComponent=
	evaluatedProps.flyoutComponent,labelComponent=evaluatedProps.labelComponent,groupComponent=evaluatedProps.groupComponent,active=evaluatedProps.active,renderInPortal=evaluatedProps.renderInPortal;
	if(!active){
	return null;
	}
	var calculatedValues=this.getCalculatedValues(evaluatedProps);
	var children=[
	_react2.default.cloneElement(flyoutComponent,this.getFlyoutProps(evaluatedProps,calculatedValues)),
	_react2.default.cloneElement(labelComponent,this.getLabelProps(evaluatedProps,calculatedValues))];
	
	var tooltip=_react2.default.cloneElement(groupComponent,{role:"presentation"},children);
	return renderInPortal?_react2.default.createElement(_victoryPortal2.default,null,tooltip):tooltip;
	}},{key:"render",value:function render()
	
	{
	var props=_index.Helpers.modifyProps(this.props,fallbackProps,"tooltip");
	return this.renderTooltip(props);
	}}]);return VictoryTooltip;}(_react2.default.Component);VictoryTooltip.displayName="VictoryTooltip";VictoryTooltip.propTypes={activateData:_propTypes2.default.bool,active:_propTypes2.default.oneOfType([_propTypes2.default.bool,_propTypes2.default.func]),cornerRadius:_propTypes2.default.oneOfType([_index.PropTypes.nonNegative,_propTypes2.default.func]),data:_propTypes2.default.array,datum:_propTypes2.default.object,dx:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.func]),dy:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.func]),events:_propTypes2.default.object,flyoutComponent:_propTypes2.default.element,flyoutStyle:_propTypes2.default.object,groupComponent:_propTypes2.default.element,height:_propTypes2.default.oneOfType([_index.PropTypes.nonNegative,_propTypes2.default.func]),horizontal:_propTypes2.default.bool,index:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string]),labelComponent:_propTypes2.default.element,orientation:_propTypes2.default.oneOfType([_propTypes2.default.oneOf(["top","bottom","left","right"]),_propTypes2.default.func]),pointerLength:_propTypes2.default.oneOfType([_index.PropTypes.nonNegative,_propTypes2.default.func]),pointerWidth:_propTypes2.default.oneOfType([_index.PropTypes.nonNegative,_propTypes2.default.func]),renderInPortal:_propTypes2.default.bool,style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.array]),text:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number,_propTypes2.default.func,_propTypes2.default.array]),theme:_propTypes2.default.object,width:_propTypes2.default.oneOfType([_index.PropTypes.nonNegative,_propTypes2.default.func]),x:_propTypes2.default.number,y:_propTypes2.default.number};VictoryTooltip.defaultProps={theme:_victoryTheme2.default.grayscale,active:false,renderInPortal:true,labelComponent:_react2.default.createElement(_victoryLabel2.default,null),flyoutComponent:_react2.default.createElement(_index2.Flyout,null),groupComponent:_react2.default.createElement("g",null)};VictoryTooltip.defaultEvents=[{target:"data",eventHandlers:{onMouseOver:function onMouseOver(targetProps){return[{target:"labels",mutation:function mutation(){return{active:true};}},{target:"data",mutation:function mutation(){return targetProps.activateData?{active:true}:{active:undefined};}}];},onMouseOut:function onMouseOut(){return[{target:"labels",mutation:function mutation(){return{active:undefined};}},{target:"data",mutation:function mutation(){return{active:undefined};}}];}}}];exports.default=VictoryTooltip;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _without2=__webpack_require__(160);var _without3=_interopRequireDefault(_without2);var _pick2=__webpack_require__(94);var _pick3=_interopRequireDefault(_pick2);var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	
	var _events=__webpack_require__(640);var _events2=_interopRequireDefault(_events);
	var _victoryTransition=__webpack_require__(639);var _victoryTransition2=_interopRequireDefault(_victoryTransition);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}exports.default=
	
	function(WrappedComponent){
	return function(_WrappedComponent){_inherits(addEvents,_WrappedComponent);function addEvents(){_classCallCheck(this,addEvents);return _possibleConstructorReturn(this,(addEvents.__proto__||Object.getPrototypeOf(addEvents)).apply(this,arguments));}_createClass(addEvents,[{key:"componentWillMount",value:function componentWillMount()
	
	{
	if((0,_isFunction3.default)(_get(addEvents.prototype.__proto__||Object.getPrototypeOf(addEvents.prototype),"componentWillMount",this))){
	_get(addEvents.prototype.__proto__||Object.getPrototypeOf(addEvents.prototype),"componentWillMount",this).call(this);
	}
	this.state=this.state||{};
	var getScopedEvents=_events2.default.getScopedEvents.bind(this);
	this.getEvents=(0,_partialRight3.default)(_events2.default.getEvents.bind(this),getScopedEvents);
	this.getEventState=_events2.default.getEventState.bind(this);
	this.setupEvents(this.props);
	}},{key:"componentWillUpdate",value:function componentWillUpdate(
	
	newProps){
	if((0,_isFunction3.default)(_get(addEvents.prototype.__proto__||Object.getPrototypeOf(addEvents.prototype),"componentWillReceiveProps",this))){
	_get(addEvents.prototype.__proto__||Object.getPrototypeOf(addEvents.prototype),"componentWillReceiveProps",this).call(this);
	}
	this.setupEvents(newProps);
	}},{key:"setupEvents",value:function setupEvents(
	
	props){var
	sharedEvents=props.sharedEvents;
	var components=WrappedComponent.expectedComponents;
	this.componentEvents=_events2.default.getComponentEvents(props,components);
	this.getSharedEventState=sharedEvents&&(0,_isFunction3.default)(sharedEvents.getEventState)?
	sharedEvents.getEventState:function(){return undefined;};
	this.baseProps=this.getBaseProps(props);
	this.dataKeys=Object.keys(this.baseProps).filter(function(key){return key!=="parent";});
	this.hasEvents=props.events||props.sharedEvents||this.componentEvents;
	this.events=this.getAllEvents(props);
	}},{key:"getBaseProps",value:function getBaseProps(
	
	props){
	var sharedParentState=this.getSharedEventState("parent","parent");
	var parentState=this.getEventState("parent","parent");
	var baseParentProps=(0,_defaults3.default)({},parentState,sharedParentState);
	var parentPropsList=baseParentProps.parentControlledProps;
	var parentProps=parentPropsList?(0,_pick3.default)(baseParentProps,parentPropsList):{};
	var modifiedProps=(0,_defaults3.default)({},parentProps,props);
	return(0,_isFunction3.default)(WrappedComponent.getBaseProps)?
	WrappedComponent.getBaseProps(modifiedProps):{};
	}},{key:"getAllEvents",value:function getAllEvents(
	
	props){
	if(Array.isArray(this.componentEvents)){var _componentEvents;
	return Array.isArray(props.events)?
	(_componentEvents=this.componentEvents).concat.apply(_componentEvents,_toConsumableArray(props.events)):this.componentEvents;
	}
	return props.events;
	}},{key:"getComponentProps",value:function getComponentProps(
	
	component,type,index){var
	role=WrappedComponent.role;
	var key=this.dataKeys&&this.dataKeys[index]||index;
	var baseProps=this.baseProps[key][type]||this.baseProps[key];
	if(!baseProps&&!this.hasEvents){
	return undefined;
	}
	if(this.hasEvents){
	var baseEvents=this.getEvents(this.props,type,key);
	var componentProps=(0,_defaults3.default)(
	{index:index,key:role+"-"+type+"-"+key},
	this.getEventState(key,type),
	this.getSharedEventState(key,type),
	component.props,
	baseProps);
	
	var events=(0,_defaults3.default)(
	{},_events2.default.getPartialEvents(baseEvents,key,componentProps),componentProps.events);
	
	return(0,_assign3.default)(
	{},componentProps,{events:events});
	
	}
	return(0,_defaults3.default)(
	{index:index,key:role+"-"+type+"-"+key},
	component.props,
	baseProps);
	
	}},{key:"renderContainer",value:function renderContainer(
	
	component,children){
	var isContainer=component.type&&component.type.role==="container";
	var parentProps=isContainer?this.getComponentProps(component,"parent","parent"):{};
	return _react2.default.cloneElement(component,parentProps,children);
	}},{key:"animateComponent",value:function animateComponent(
	
	props,animationWhitelist){
	return(
	_react2.default.createElement(_victoryTransition2.default,{animate:props.animate,animationWhitelist:animationWhitelist},
	_react2.default.createElement(this.constructor,props)));
	
	
	}},{key:"renderContinuousData",value:function renderContinuousData(
	
	
	props){var _this2=this;var
	dataComponent=props.dataComponent,labelComponent=props.labelComponent,groupComponent=props.groupComponent;
	var dataKeys=(0,_without3.default)(this.dataKeys,"all");
	var labelComponents=dataKeys.reduce(function(memo,key){
	var labelProps=_this2.getComponentProps(labelComponent,"labels",key);
	if(labelProps&&labelProps.text!==undefined&&labelProps.text!==null){
	memo=memo.concat(_react2.default.cloneElement(labelComponent,labelProps));
	}
	return memo;
	},[]);
	var dataProps=this.getComponentProps(dataComponent,"data","all");
	var children=[_react2.default.cloneElement(dataComponent,dataProps)].concat(_toConsumableArray(labelComponents));
	return this.renderContainer(groupComponent,children);
	}},{key:"renderData",value:function renderData(
	
	props){var _this3=this;var
	dataComponent=props.dataComponent,labelComponent=props.labelComponent,groupComponent=props.groupComponent;
	var dataComponents=this.dataKeys.map(function(_dataKey,index){
	var dataProps=_this3.getComponentProps(dataComponent,"data",index);
	return _react2.default.cloneElement(dataComponent,dataProps);
	});
	
	var labelComponents=this.dataKeys.map(function(_dataKey,index){
	var labelProps=_this3.getComponentProps(labelComponent,"labels",index);
	if(labelProps.text!==undefined&&labelProps.text!==null){
	return _react2.default.cloneElement(labelComponent,labelProps);
	}
	return undefined;
	}).filter(Boolean);
	
	var children=[].concat(_toConsumableArray(dataComponents),_toConsumableArray(labelComponents));
	return this.renderContainer(groupComponent,children);
	}}]);return addEvents;}(WrappedComponent);
	
	
	};

/***/ },
/* 1467 */
/***/ function(module, exports) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.
	continuousTransitions=continuousTransitions;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	discreteTransitions=discreteTransitions;function continuousTransitions(){return{onLoad:{duration:2000},onExit:{duration:500},onEnter:{duration:500}};}function discreteTransitions(){
	return{
	onLoad:{
	duration:2000,
	before:function before(){return{opacity:0};},
	after:function after(datum){return datum;}},
	
	onExit:{
	duration:600,
	before:function before(){return{opacity:0};}},
	
	onEnter:{
	duration:600,
	before:function before(){return{opacity:0};},
	after:function after(datum){return datum;}}};
	
	
	}

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isPlainObject2=__webpack_require__(103);var _isPlainObject3=_interopRequireDefault(_isPlainObject2);var _includes2=__webpack_require__(206);var _includes3=_interopRequireDefault(_includes2);var _flatten2=__webpack_require__(205);var _flatten3=_interopRequireDefault(_flatten2);
	var _data=__webpack_require__(368);var _data2=_interopRequireDefault(_data);
	var _scale=__webpack_require__(370);var _scale2=_interopRequireDefault(_scale);
	var _helpers=__webpack_require__(80);var _helpers2=_interopRequireDefault(_helpers);
	var _collection=__webpack_require__(139);var _collection2=_interopRequireDefault(_collection);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=
	
	{
	
	
	
	
	
	
	
	getDomain:function getDomain(props,axis){
	var propsDomain=this.getDomainFromProps(props,axis);
	if(propsDomain){
	return this.padDomain(propsDomain,props,axis);
	}
	var categoryDomain=this.getDomainFromCategories(props,axis);
	if(categoryDomain){
	return this.padDomain(categoryDomain,props,axis);
	}
	var dataset=_data2.default.getData(props);
	var domain=this.getDomainFromData(props,axis,dataset);
	return this.cleanDomain(this.padDomain(domain,props,axis),props,axis);
	},
	
	
	
	
	
	
	
	
	
	
	cleanDomain:function cleanDomain(domain,props,axis){
	var scaleType=_scale2.default.getScaleType(props,axis);
	
	if(scaleType!=="log"){
	return domain;
	}
	
	var rules=function rules(dom){
	var almostZero=dom[0]<0||dom[1]<0?-1/Number.MAX_SAFE_INTEGER:
	1/Number.MAX_SAFE_INTEGER;
	var domainOne=dom[0]===0?almostZero:dom[0];
	var domainTwo=dom[1]===0?almostZero:dom[1];
	return[domainOne,domainTwo];
	};
	
	return rules(domain);
	},
	
	
	
	
	
	
	
	
	getDomainWithZero:function getDomainWithZero(props,axis){var _this=this;
	var propsDomain=this.getDomainFromProps(props,axis);
	if(propsDomain){
	return this.cleanDomain(this.padDomain(propsDomain,props,axis),props,axis);
	}var
	horizontal=props.horizontal;
	var ensureZero=function ensureZero(domain){
	var isDependent=axis==="y"&&!horizontal||axis==="x"&&horizontal;
	var min=_collection2.default.getMinValue(domain,0);
	var max=_collection2.default.getMaxValue(domain,0);
	var zeroDomain=isDependent?[min,max]:domain;
	return _this.padDomain(zeroDomain,props,axis);
	};
	var categoryDomain=this.getDomainFromCategories(props,axis);
	if(categoryDomain){
	return this.cleanDomain(this.padDomain(ensureZero(categoryDomain),props,axis),props,axis);
	}
	var dataset=_data2.default.getData(props);
	var domain=ensureZero(this.getDomainFromData(props,axis,dataset));
	return this.cleanDomain(this.padDomain(domain,props,axis),props,axis);
	},
	
	
	
	
	
	
	
	getDomainFromProps:function getDomainFromProps(props,axis){
	if(props.domain&&props.domain[axis]){
	return props.domain[axis];
	}else if(props.domain&&Array.isArray(props.domain)){
	return props.domain;
	}
	return undefined;
	},
	
	
	
	
	
	
	
	
	getDomainFromData:function getDomainFromData(props,axis,dataset){
	var currentAxis=_helpers2.default.getCurrentAxis(axis,props.horizontal);
	var allData=(0,_flatten3.default)(dataset).map(function(datum){return datum["_"+currentAxis];});
	
	if(allData.length<1){
	return _scale2.default.getBaseScale(props,axis).domain();
	}
	
	var min=_collection2.default.getMinValue(allData);
	var max=_collection2.default.getMaxValue(allData);
	
	
	if(min===max){
	var adjustedMax=max===0?1:max;
	return[0,adjustedMax];
	}
	return[min,max];
	},
	
	
	
	
	
	
	getDomainFromTickValues:function getDomainFromTickValues(props){
	var domain=void 0;
	if(_helpers2.default.stringTicks(props)){
	domain=[1,props.tickValues.length];
	}else{
	
	var ticks=props.tickValues.map(function(value){return+value;});
	domain=[_collection2.default.getMinValue(ticks),_collection2.default.getMaxValue(ticks)];
	}
	if(_helpers2.default.isVertical(props)){
	domain.reverse();
	}
	return domain;
	},
	
	
	
	
	
	
	
	getDomainFromCategories:function getDomainFromCategories(props,axis){
	var categories=_data2.default.getCategories(props,axis);
	if(!categories){
	return undefined;
	}
	var stringArray=_collection2.default.containsStrings(categories)?
	_data2.default.getStringsFromCategories(props,axis):[];
	var stringMap=stringArray.length===0?null:
	stringArray.reduce(function(memo,string,index){
	memo[string]=index+1;
	return memo;
	},{});
	var categoryValues=stringMap?
	categories.map(function(value){return stringMap[value];}):categories;
	return[
	_collection2.default.getMinValue(categoryValues),_collection2.default.getMaxValue(categoryValues)];
	
	},
	
	
	
	
	
	
	
	
	getDomainFromGroupedData:function getDomainFromGroupedData(props,axis,datasets){var
	horizontal=props.horizontal;
	var dependent=axis==="x"&&!horizontal||axis==="y"&&horizontal;
	if(dependent&&props.categories){
	return this.getDomainFromCategories(props,axis);
	}
	var globalDomain=this.getDomainFromData(props,axis,datasets);
	
	
	var cumulativeData=!dependent?
	this.getCumulativeData(props,axis,datasets):[];
	
	var cumulativeMaxArray=cumulativeData.map(function(dataset){
	return dataset.reduce(function(memo,val){
	return val>0?+val+ +memo:memo;
	},0);
	});
	var cumulativeMinArray=cumulativeData.map(function(dataset){
	return dataset.reduce(function(memo,val){
	return val<0?+val+ +memo:memo;
	},0);
	});
	
	var cumulativeMin=Math.min.apply(Math,_toConsumableArray(cumulativeMinArray));
	
	var domainMin=cumulativeMin<0?cumulativeMin:_collection2.default.getMinValue(globalDomain);
	var domainMax=_collection2.default.getMaxValue.apply(_collection2.default,[globalDomain].concat(_toConsumableArray(cumulativeMaxArray)));
	
	
	if(domainMin===domainMax){
	var adjustedMax=domainMax===0?1:domainMax;
	return[0,adjustedMax];
	}
	return[domainMin,domainMax];
	},
	
	
	
	
	
	
	
	
	getCumulativeData:function getCumulativeData(props,axis,datasets){
	var currentAxis=_helpers2.default.getCurrentAxis(axis,props.horizontal);
	var categories=[];
	var axisValues=[];
	datasets.forEach(function(dataset){
	dataset.forEach(function(data){
	if(data.category!==undefined&&!(0,_includes3.default)(categories,data.category)){
	categories.push(data.category);
	}else if(!(0,_includes3.default)(axisValues,data[currentAxis])){
	axisValues.push(data[currentAxis]);
	}
	});
	});
	
	var _dataByCategory=function _dataByCategory(){
	return categories.map(function(value){
	return datasets.reduce(function(prev,data){
	return data.category===value?prev.concat(data[axis]):prev;
	},[]);
	});
	};
	
	var _dataByIndex=function _dataByIndex(){
	return axisValues.map(function(value,index){
	return datasets.map(function(data){return data[index]&&data[index]["_"+currentAxis];});
	});
	};
	
	return categories.length===0?_dataByIndex():_dataByCategory();
	},
	
	
	
	
	
	
	
	getDomainPadding:function getDomainPadding(props,axis){
	var formatPadding=function formatPadding(padding){
	return Array.isArray(padding)?
	{left:padding[0],right:padding[1]}:{left:padding,right:padding};
	};
	
	return(0,_isPlainObject3.default)(props.domainPadding)?
	formatPadding(props.domainPadding[axis]):formatPadding(props.domainPadding);
	},
	
	
	
	
	
	
	
	
	padDomain:function padDomain(domain,props,axis){
	if(!props.domainPadding){
	return domain;
	}
	
	var padding=this.getDomainPadding(props,axis);
	if(!padding.left&&!padding.right){
	return domain;
	}
	
	var domainMin=_collection2.default.getMinValue(domain);
	var domainMax=_collection2.default.getMaxValue(domain);
	var range=_helpers2.default.getRange(props,axis);
	var rangeExtent=Math.abs(Math.max.apply(Math,_toConsumableArray(range))-Math.min.apply(Math,_toConsumableArray(range)));
	
	
	var initialPadding={
	left:Math.abs(domainMax-domainMin)*padding.left/rangeExtent,
	right:Math.abs(domainMax-domainMin)*padding.right/rangeExtent};
	
	
	
	var adjustedDomain={
	min:domainMin>=0&&domainMin-initialPadding.left<=0?
	0:domainMin.valueOf()-initialPadding.left,
	max:domainMax<=0&&domainMax+initialPadding.right>=0?
	0:domainMax.valueOf()+initialPadding.right};
	
	
	
	var finalPadding={
	left:Math.abs(adjustedDomain.max-adjustedDomain.min)*padding.left/rangeExtent,
	right:Math.abs(adjustedDomain.max-adjustedDomain.min)*padding.right/rangeExtent};
	
	
	
	var finalDomain={
	min:domainMin>=0&&domainMin-finalPadding.left<=0?
	0:domainMin.valueOf()-finalPadding.left,
	max:domainMax>=0&&domainMax+finalPadding.right<=0?
	0:domainMax.valueOf()+finalPadding.right};
	
	
	return domainMin instanceof Date||domainMax instanceof Date?
	[new Date(finalDomain.min),new Date(finalDomain.max)]:[finalDomain.min,finalDomain.max];
	},
	
	
	
	
	
	
	
	
	orientDomain:function orientDomain(domain,orientations,axis){
	
	
	var otherAxis=axis==="x"?"y":"x";
	var defaultOrientation=function defaultOrientation(ax){return ax==="x"?"bottom":"left";};
	var flippedAxis=orientations.x==="left"||orientations.x==="right";
	var standardOrientation=flippedAxis?
	orientations[otherAxis]===defaultOrientation(axis):
	orientations[otherAxis]===defaultOrientation(otherAxis);
	if(flippedAxis){
	return standardOrientation?domain.concat().reverse():domain;
	}else{
	return standardOrientation?domain:domain.concat().reverse();
	}
	}};

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _find2=__webpack_require__(1011);var _find3=_interopRequireDefault(_find2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);
	
	var _log=__webpack_require__(369);var _log2=_interopRequireDefault(_log);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}
	
	
	
	
	
	
	
	
	var makeChainable=function makeChainable(validator){
	
	var _chainable=function _chainable(isRequired,props,propName,componentName){
	var value=props[propName];
	if(typeof value==="undefined"||value===null){
	if(isRequired){
	return new Error("Required `"+
	propName+"` was not specified in `"+componentName+"`.");
	
	}
	return null;
	}for(var _len=arguments.length,rest=Array(_len>4?_len-4:0),_key=4;_key<_len;_key++){rest[_key-4]=arguments[_key];}
	return validator.apply(undefined,[props,propName,componentName].concat(rest));
	};
	var chainable=_chainable.bind(null,false);
	chainable.isRequired=_chainable.bind(null,true);
	return chainable;
	};
	
	var nullConstructor=function nullConstructor(){return null;};
	var undefinedConstructor=function undefinedConstructor(){return undefined;};
	
	
	
	
	
	
	
	var getConstructor=function getConstructor(value){
	if(typeof value==="undefined"){
	return undefinedConstructor;
	}else if(value===null){
	return nullConstructor;
	}else{
	return value.constructor;
	}
	};
	
	
	
	
	
	
	
	
	var getConstructorName=function getConstructorName(value){
	if(typeof value==="undefined"){
	return"undefined";
	}else if(value===null){
	return"null";
	}
	return Object.prototype.toString.call(value).slice(8,-1);
	};exports.default=
	
	{
	
	
	
	
	
	
	
	deprecated:function deprecated(propType,explanation){
	return function(props,propName,componentName){
	var value=props[propName];
	if(value!==null&&value!==undefined){
	_log2.default.warn("\""+
	propName+"\" property of \""+componentName+"\" has been deprecated "+explanation);
	
	}
	return _propTypes2.default.checkPropTypes(_defineProperty({},propName,propType),props,propName,componentName);
	};
	},
	
	
	
	
	
	
	
	
	allOfType:function allOfType(validators){
	return makeChainable(function(props,propName,componentName){for(var _len2=arguments.length,rest=Array(_len2>3?_len2-3:0),_key2=3;_key2<_len2;_key2++){rest[_key2-3]=arguments[_key2];}return(
	validators.reduce(
	function(result,validator){return result||validator.apply(undefined,[props,propName,componentName].concat(rest));},
	undefined));});
	
	
	},
	
	
	
	
	nonNegative:makeChainable(function(props,propName,componentName){
	var value=props[propName];
	if(typeof value!=="number"||value<0){
	return new Error("`"+
	propName+"` in `"+componentName+"` must be a non-negative number.");
	
	}
	return undefined;
	}),
	
	
	
	
	integer:makeChainable(function(props,propName,componentName){
	var value=props[propName];
	if(typeof value!=="number"||value%1!==0){
	return new Error("`"+
	propName+"` in `"+componentName+"` must be an integer.");
	
	}
	return undefined;
	}),
	
	
	
	
	greaterThanZero:makeChainable(function(props,propName,componentName){
	var value=props[propName];
	if(typeof value!=="number"||value<=0){
	return new Error("`"+
	propName+"` in `"+componentName+"` must be a number greater than zero.");
	
	}
	return undefined;
	}),
	
	
	
	
	domain:makeChainable(function(props,propName,componentName){
	var value=props[propName];
	if(!Array.isArray(value)||value.length!==2||value[1]===value[0]){
	return new Error("`"+
	propName+"` in `"+componentName+"` must be an array of two unique numeric values.");
	
	}
	return undefined;
	}),
	
	
	
	
	scale:makeChainable(function(props,propName,componentName){
	var supportedScaleStrings=["linear","time","log","sqrt"];
	var validScale=function validScale(scl){
	if((0,_isFunction3.default)(scl)){
	return(0,_isFunction3.default)(scl.copy)&&(0,_isFunction3.default)(scl.domain)&&(0,_isFunction3.default)(scl.range);
	}else if(typeof scl==="string"){
	return supportedScaleStrings.indexOf(scl)!==-1;
	}
	return false;
	};
	
	var value=props[propName];
	if(!validScale(value)){
	return new Error("`"+
	propName+"` in `"+componentName+"` must be a d3 scale.");
	
	}
	return undefined;
	}),
	
	
	
	
	homogeneousArray:makeChainable(function(props,propName,componentName){
	var values=props[propName];
	if(!Array.isArray(values)){
	return new Error("`"+
	propName+"` in `"+componentName+"` must be an array.");
	
	}
	
	if(values.length<2){
	return undefined;
	}
	
	var comparisonConstructor=getConstructor(values[0]);
	
	var typeMismatchedValue=(0,_find3.default)(values,function(value){
	return comparisonConstructor!==getConstructor(value);
	});
	
	if(typeMismatchedValue){
	var constructorName=getConstructorName(values[0]);
	var otherConstructorName=getConstructorName(typeMismatchedValue);
	
	return new Error(
	"Expected `"+propName+"` in `"+componentName+"` to be a "+("homogeneous array, but found types `"+
	constructorName+"` and ")+("`"+
	otherConstructorName+"`."));
	
	}
	return undefined;
	}),
	
	
	
	
	matchDataLength:makeChainable(function(props,propName){
	if(
	props[propName]&&
	Array.isArray(props[propName])&&
	props[propName].length!==props.data.length)
	{
	return new Error("Length of data and "+propName+" arrays must match.");
	}
	return undefined;
	})};

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	
	var _data=__webpack_require__(368);var _data2=_interopRequireDefault(_data);
	var _collection=__webpack_require__(139);var _collection2=_interopRequireDefault(_collection);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=
	
	{
	getParentSVG:function getParentSVG(target){
	if(target.nodeName==="svg"){
	return target;
	}else{
	return this.getParentSVG(target.parentNode);
	}
	},
	
	getTransformationMatrix:function getTransformationMatrix(svg){
	return svg.getScreenCTM().inverse();
	},
	
	getSVGEventCoordinates:function getSVGEventCoordinates(evt){
	if(typeof document==="undefined"){
	
	
	return{
	x:evt.nativeEvent.locationX,
	y:evt.nativeEvent.locationY};
	
	}
	var svg=this.getParentSVG(evt.target);
	var matrix=this.getTransformationMatrix(svg);
	return{
	x:this.transformTarget(evt.clientX,matrix,"x"),
	y:this.transformTarget(evt.clientY,matrix,"y")};
	
	},
	
	transformTarget:function transformTarget(target,matrix,dimension){var
	a=matrix.a,d=matrix.d,e=matrix.e,f=matrix.f;
	return dimension==="y"?
	d*target+f:a*target+e;
	},
	
	getDomainCoordinates:function getDomainCoordinates(scale,domain){
	domain=domain||{x:scale.x.domain(),y:scale.y.domain()};
	return{
	x:[scale.x(domain.x[0]),scale.x(domain.x[1])],
	y:[scale.y(domain.y[0]),scale.y(domain.y[1])]};
	
	},
	
	getDataCoordinates:function getDataCoordinates(scale,x,y){
	return{
	x:scale.x.invert(x),
	y:scale.y.invert(y)};
	
	},
	
	getBounds:function getBounds(props){var
	x1=props.x1,x2=props.x2,y1=props.y1,y2=props.y2,scale=props.scale;
	var point1=this.getDataCoordinates(scale,x1,y1);
	var point2=this.getDataCoordinates(scale,x2,y2);
	var makeBound=function makeBound(a,b){
	return[_collection2.default.getMinValue([a,b]),_collection2.default.getMaxValue([a,b])];
	};
	
	return{
	x:makeBound(point1.x,point2.x),
	y:makeBound(point1.y,point2.y)};
	
	},
	
	getDatasets:function getDatasets(props){
	if(props.data){
	return[{data:props.data}];
	}
	var getData=function getData(childProps){
	var data=_data2.default.getData(childProps);
	return Array.isArray(data)&&data.length>0?data:undefined;
	};
	
	
	
	var children=_react2.default.Children.toArray(props.children).reverse();
	var childrenLength=children.length;
	var dataArr=[];
	var dataArrLength=0;
	var childIndex=0;
	while(childrenLength>0){
	var child=children[--childrenLength];
	var childName=child.props.name||childIndex;
	childIndex++;
	if(child.type&&child.type.role==="axis"){
	childIndex++;
	}else if(child.type&&(0,_isFunction3.default)(child.type.getData)){
	dataArr[dataArrLength++]={childName:childName,data:child.type.getData(child.props)};
	}else if(child.props&&child.props.children){
	var newChildren=_react2.default.Children.toArray(child.props.children);
	var newChildrenLength=newChildren.length;
	for(var index=0;index<newChildrenLength;index++){
	children[childrenLength++]=newChildren[index];
	}
	}else{
	dataArr[dataArrLength++]={childName:childName,data:getData(child.props)};
	}
	}
	return dataArr;
	},
	
	filterDatasets:function filterDatasets(datasets,bounds){var _this=this;
	var filtered=datasets.reduce(function(memo,dataset){
	var selectedData=_this.getSelectedData(dataset.data,bounds);
	memo=selectedData?
	memo.concat({
	childName:dataset.childName,eventKey:selectedData.eventKey,data:selectedData.data}):
	
	memo;
	return memo;
	},[]);
	return filtered.length?filtered:null;
	},
	
	getSelectedData:function getSelectedData(dataset,bounds){var
	x=bounds.x,y=bounds.y;
	var withinBounds=function withinBounds(d){
	return d._x>=x[0]&&d._x<=x[1]&&d._y>=y[0]&&d._y<=y[1];
	};
	
	var selectedData=dataset.reduce(function(accum,datum,index){
	if(withinBounds(datum)){
	accum.data.push(datum);
	accum.eventKey.push(datum.eventKey===undefined?index:datum.eventKey);
	}
	
	return accum;
	},{
	data:[],
	eventKey:[]});
	
	
	return selectedData.data.length>0?selectedData:null;
	}};

/***/ },
/* 1471 */
/***/ function(module, exports) {

	Object.defineProperty(exports,"__esModule",{value:true});
	
	
	
	
	
	
	
	
	var toTransformString=function toTransformString(obj){for(var _len=arguments.length,more=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){more[_key-1]=arguments[_key];}
	if(more.length>0){
	return more.reduce(function(memo,currentObj){
	return[memo,toTransformString(currentObj)].join(" ");
	},toTransformString(obj));
	}else{
	if(!obj||typeof obj==="string"){
	return obj;
	}
	var transforms=[];
	for(var key in obj){
	if(obj.hasOwnProperty(key)){
	var value=obj[key];
	transforms.push(key+"("+value+")");
	}
	}
	return transforms.join(" ");
	}
	};exports.default=
	
	{
	
	toTransformString:toTransformString,
	
	
	
	
	
	
	
	
	getColorScale:function getColorScale(name){
	var scales={
	grayscale:[
	"#cccccc","#969696","#636363","#252525"],
	
	qualitative:[
	"#334D5C","#45B29D","#EFC94C","#E27A3F","#DF5A49",
	"#4F7DA1","#55DBC1","#EFDA97","#E2A37F","#DF948A"],
	
	heatmap:["#428517","#77D200","#D6D305","#EC8E19","#C92B05"],
	warm:["#940031","#C43343","#DC5429","#FF821D","#FFAF55"],
	cool:["#2746B9","#0B69D4","#2794DB","#31BB76","#60E83B"],
	red:["#FCAE91","#FB6A4A","#DE2D26","#A50F15","#750B0E"],
	blue:["#002C61","#004B8F","#006BC9","#3795E5","#65B4F4"],
	green:["#354722","#466631","#649146","#8AB25C","#A9C97E"]};
	
	return name?scales[name]:scales.greyscale;
	}};

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _merge2=__webpack_require__(158);var _merge3=_interopRequireDefault(_merge2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}
	
	
	
	var fontDictionary={
	"American Typewriter":2.09,
	"Baskerville":2.51,
	"Georgia":2.27,
	"Hoefler Text":2.39,
	"Palatino":2.26,
	"Times New Roman":2.48,
	"Arial":2.26,
	"Gill Sans":2.47,
	"Gill Sans 300":2.58,
	"Helvetica Neue":2.24,
	"Lucida Grande":2.05,
	"Tahoma":2.25,
	"Trebuchet MS":2.2,
	"Verdana":1.96,
	"Courier New":1.67,
	"cursive":1.84,
	"fantasy":2.09,
	"monospace":1.81,
	"serif":2.04,
	"sans-serif":1.89};
	
	
	
	var absoluteMeasurementUnitsToPixels={
	"mm":3.8,
	"sm":38,
	"pt":1.33,
	"pc":16,
	"in":96,
	"px":1};
	
	var relativeMeasurementUnitsCoef={
	"em":1,
	"ex":0.5};
	
	
	var coefficients={
	averageFontConstant:2.1675,
	widthOverlapCoef:1.25,
	heightOverlapCoef:1.05,
	lineCapitalCoef:1.15,
	lineSpaceHeightCoef:0.2};
	
	var defaultStyle={
	lineHeight:1,
	letterSpacing:"0px",
	fontSize:0,
	angle:0,
	fontFamily:""};
	
	
	var _degreeToRadian=function _degreeToRadian(angle){return angle*Math.PI/180;};
	
	var _getFontCharacterConstant=function _getFontCharacterConstant(fontFamily){
	var firstFont=fontFamily.split(",")[0].replace(/'|"/g,"");
	return fontDictionary[firstFont]||coefficients.averageFontConstant;
	};
	
	var _splitToLines=function _splitToLines(text){
	return Array.isArray(text)?text:text.toString().split(/\r\n|\r|\n/g);
	};
	
	var _getSizeWithRotate=function _getSizeWithRotate(axisSize,dependentSize,angle){
	var angleInRadian=_degreeToRadian(angle);
	return Math.abs(Math.cos(angleInRadian)*axisSize)+
	Math.abs(Math.sin(angleInRadian)*dependentSize);
	};
	
	
	
	
	
	
	
	var convertLengthToPixels=function convertLengthToPixels(length,fontSize){
	var attribute=length.match(/[a-zA-Z%]+/)[0];
	var value=length.match(/[0-9.,]+/);
	var result=void 0;
	if(absoluteMeasurementUnitsToPixels.hasOwnProperty(attribute)){
	result=value*absoluteMeasurementUnitsToPixels[attribute];
	}else if(relativeMeasurementUnitsCoef.hasOwnProperty(attribute)){
	result=(fontSize?value*fontSize:value*coefficients.defaultFontSize)*
	relativeMeasurementUnitsCoef[attribute];
	}else{
	result=value;
	}
	return result;
	};
	
	var _prepareParams=function _prepareParams(inputStyle,index){
	var lineStyle=Array.isArray(inputStyle)?inputStyle[index]:inputStyle;
	var style=(0,_defaults3.default)({},lineStyle,defaultStyle);
	return(0,_merge3.default)({},style,{
	characterConstant:style.characterConstant||_getFontCharacterConstant(style.fontFamily),
	letterSpacing:convertLengthToPixels(style.letterSpacing,style.fontSize),
	fontSize:typeof style.fontSize==="number"?
	style.fontSize:
	convertLengthToPixels(String(style.fontSize))});
	
	};
	
	var _approximateTextWidthInternal=function _approximateTextWidthInternal(text,style){
	var widths=_splitToLines(text).map(function(line,index){
	var len=line.toString().length;var _prepareParams2=
	_prepareParams(style,index),fontSize=_prepareParams2.fontSize,characterConstant=_prepareParams2.characterConstant,letterSpacing=_prepareParams2.letterSpacing;
	return len*fontSize/characterConstant+letterSpacing*Math.max(len-1,0);
	});
	return Math.max.apply(Math,_toConsumableArray(widths));
	};
	
	var _approximateTextHeightInternal=function _approximateTextHeightInternal(text,style){
	return _splitToLines(text).reduce(function(total,line,index){
	var lineStyle=_prepareParams(style,index);
	var height=lineStyle.fontSize*coefficients.lineCapitalCoef;
	var emptySpace=index===0?0:lineStyle.fontSize*coefficients.lineSpaceHeightCoef;
	return total+lineStyle.lineHeight*(height+emptySpace);
	},0);
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	var approximateTextSize=function approximateTextSize(text,style){
	var angle=Array.isArray(style)?style[0]&&style[0].angle:style&&style.angle;
	var height=_approximateTextHeightInternal(text,style);
	var width=_approximateTextWidthInternal(text,style);
	var widthWithRotate=angle?_getSizeWithRotate(width,height,angle):width;
	var heightWithRotate=angle?_getSizeWithRotate(height,width,angle):height;
	return{
	width:widthWithRotate*coefficients.widthOverlapCoef,
	height:heightWithRotate*coefficients.heightOverlapCoef};
	
	};exports.default=
	
	{
	approximateTextSize:approximateTextSize,
	convertLengthToPixels:convertLengthToPixels};

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _identity2=__webpack_require__(69);var _identity3=_interopRequireDefault(_identity2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	getInitialTransitionState=getInitialTransitionState;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	getTransitionPropsFactory=getTransitionPropsFactory;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getDatumKey(datum,idx){return(datum.key||idx).toString();}function getKeyedData(data){return data.reduce(function(keyedData,datum,idx){var key=getDatumKey(datum,idx);keyedData[key]=datum;return keyedData;},{});}function getKeyedDataDifference(a,b){var hasDifference=false;var difference=Object.keys(a).reduce(function(_difference,key){if(!(key in b)){hasDifference=true;_difference[key]=true;}return _difference;},{});return hasDifference&&difference;}function getNodeTransitions(oldData,nextData){var oldDataKeyed=oldData&&getKeyedData(oldData);var nextDataKeyed=nextData&&getKeyedData(nextData);return{entering:oldDataKeyed&&getKeyedDataDifference(nextDataKeyed,oldDataKeyed),exiting:nextDataKeyed&&getKeyedDataDifference(oldDataKeyed,nextDataKeyed)};}function getChildData(child){if(child.type&&child.type.getData){return child.type.getData(child.props);}return child.props&&child.props.data||false;}function getInitialTransitionState(oldChildren,nextChildren){var nodesWillExit=false;var nodesWillEnter=false;var getTransition=function getTransition(oldChild,newChild){if(!newChild||oldChild.type!==newChild.type){return{};}var _ref=getNodeTransitions(getChildData(oldChild),getChildData(newChild))||{},entering=_ref.entering,exiting=_ref.exiting;nodesWillExit=nodesWillExit||!!exiting;nodesWillEnter=nodesWillEnter||!!entering;return{entering:entering||false,exiting:exiting||false};};var getTransitionsFromChildren=function getTransitionsFromChildren(old,next){return old.map(function(child,idx){if(child&&child.props&&child.props.children){return getTransitionsFromChildren(_react2.default.Children.toArray(old[idx].props.children),_react2.default.Children.toArray(next[idx].props.children));}return getTransition(child,next[idx]);});};var childrenTransitions=getTransitionsFromChildren(_react2.default.Children.toArray(oldChildren),_react2.default.Children.toArray(nextChildren));return{nodesWillExit:nodesWillExit,nodesWillEnter:nodesWillEnter,childrenTransitions:childrenTransitions,nodesShouldEnter:false};}function getInitialChildProps(animate,data){var after=animate.onEnter&&animate.onEnter.after?animate.onEnter.after:_identity3.default;return{data:data.map(function(datum){return(0,_assign3.default)({},datum,after(datum));})};}function getChildBeforeLoad(animate,child,data,cb){animate=(0,_assign3.default)({},animate,{onEnd:cb});if(animate&&animate.onLoad&&!animate.onLoad.duration){return{animate:animate,data:data};}var before=animate.onLoad&&animate.onLoad.before?animate.onLoad.before:_identity3.default;data=data.map(function(datum){return(0,_assign3.default)({},datum,before(datum));});return{animate:animate,data:data,clipWidth:0};}function getChildOnLoad(animate,data,cb){animate=(0,_assign3.default)({},animate,{onEnd:cb});if(animate&&animate.onLoad&&!animate.onLoad.duration){return{animate:animate,data:data};}var after=animate.onLoad&&animate.onLoad.after?animate.onLoad.after:_identity3.default;data=data.map(function(datum){return(0,_assign3.default)({},datum,after(datum));});return{animate:animate,data:data};}function getChildPropsOnExit(animate,child,data,exitingNodes,cb){var onExit=animate&&animate.onExit;animate=(0,_assign3.default)({},animate,onExit);if(exitingNodes){animate.onEnd=cb;var before=animate.onExit&&animate.onExit.before?animate.onExit.before:_identity3.default;data=data.map(function(datum,idx){var key=(datum.key||idx).toString();return exitingNodes[key]?(0,_assign3.default)({},datum,before(datum)):datum;});}return{animate:animate,data:data};}function getChildPropsBeforeEnter(animate,child,data,enteringNodes,cb){if(enteringNodes){animate=(0,_assign3.default)({},animate,{onEnd:cb});var before=animate.onEnter&&animate.onEnter.before?animate.onEnter.before:_identity3.default;data=data.map(function(datum,idx){var key=(datum.key||idx).toString();return enteringNodes[key]?(0,_assign3.default)({},datum,before(datum)):datum;});}return{animate:animate,data:data};}function getChildPropsOnEnter(animate,data,enteringNodes,cb){var onEnter=animate&&animate.onEnter;animate=(0,_assign3.default)({},animate,onEnter);if(enteringNodes){animate.onEnd=cb;var after=animate.onEnter&&animate.onEnter.after?animate.onEnter.after:_identity3.default;data=data.map(function(datum,idx){var key=getDatumKey(datum,idx);return enteringNodes[key]?(0,_assign3.default)({},datum,after(datum)):datum;});}return{animate:animate,data:data};}function getTransitionPropsFactory(props,state,setState){
	var nodesWillExit=state&&state.nodesWillExit;
	var nodesWillEnter=state&&state.nodesWillEnter;
	var nodesShouldEnter=state&&state.nodesShouldEnter;
	var nodesShouldLoad=state&&state.nodesShouldLoad;
	var nodesDoneLoad=state&&state.nodesDoneLoad;
	var childrenTransitions=state&&state.childrenTransitions||[];
	var transitionDurations={
	enter:props.animate&&props.animate.onEnter&&props.animate.onEnter.duration,
	exit:props.animate&&props.animate.onExit&&props.animate.onExit.duration,
	load:props.animate&&props.animate.onLoad&&props.animate.onLoad.duration,
	move:props.animate&&props.animate.duration};
	
	
	var onLoad=function onLoad(child,data,animate){
	if(nodesShouldLoad){
	return getChildOnLoad(animate,data,function(){
	setState({nodesShouldLoad:false,nodesDoneLoad:true});
	});
	}
	
	return getChildBeforeLoad(animate,child,data,function(){
	setState({nodesDoneLoad:true});
	});
	};
	
	var onExit=function onExit(nodes,child,data,animate){
	return getChildPropsOnExit(animate,child,data,nodes,function(){
	setState({nodesWillExit:false});
	});
	};
	
	var onEnter=function onEnter(nodes,child,data,animate){
	if(nodesShouldEnter){
	return getChildPropsOnEnter(animate,data,nodes,function(){
	setState({nodesWillEnter:false});
	});
	}
	
	return getChildPropsBeforeEnter(animate,child,data,nodes,function(){
	setState({nodesShouldEnter:true});
	});
	};
	
	var getChildTransitionDuration=function getChildTransitionDuration(child,type){
	var animate=child.props.animate;
	var defaultTransitions=child.type&&child.type.defaultTransitions;
	if(defaultTransitions){
	var animationDuration=animate[type]&&animate[type].duration;
	return animationDuration!==undefined?
	animationDuration:defaultTransitions[type]&&defaultTransitions[type].duration;
	}
	
	return{};
	};
	
	return function getTransitionProps(child,index){
	var data=getChildData(child)||[];
	var animate=(0,_defaults3.default)({},props.animate,child.props.animate);
	
	animate.onExit=(0,_defaults3.default)(
	{},animate.onExit,child.type.defaultTransitions&&child.type.defaultTransitions.onExit);
	
	animate.onEnter=(0,_defaults3.default)(
	{},animate.onEnter,child.type.defaultTransitions&&child.type.defaultTransitions.onEnter);
	
	animate.onLoad=(0,_defaults3.default)(
	{},animate.onLoad,child.type.defaultTransitions&&child.type.defaultTransitions.onLoad);
	
	
	var childTransitions=childrenTransitions[index]||childrenTransitions[0];
	if(!nodesDoneLoad){
	
	var load=transitionDurations.load!==undefined?
	transitionDurations.load:getChildTransitionDuration(child,"onLoad");
	var animation={duration:load};
	return onLoad(child,data,(0,_assign3.default)({},animate,animation));
	}else if(nodesWillExit){
	var exitingNodes=childTransitions&&childTransitions.exiting;
	var exit=transitionDurations.exit!==undefined?
	transitionDurations.exit:getChildTransitionDuration(child,"onExit");
	
	var _animation=exitingNodes?{duration:exit}:{delay:exit};
	return onExit(exitingNodes,child,data,(0,_assign3.default)({},animate,_animation));
	}else if(nodesWillEnter){
	var enteringNodes=childTransitions&&childTransitions.entering;
	var enter=transitionDurations.enter!==undefined?
	transitionDurations.enter:getChildTransitionDuration(child,"onEnter");
	var move=transitionDurations.move!==undefined?
	transitionDurations.move:child.props.animate&&child.props.animate.duration;
	var _animation2={duration:nodesShouldEnter&&enteringNodes?enter:move};
	return onEnter(enteringNodes,child,data,(0,_assign3.default)({},animate,_animation2));
	}else if(!state&&animate&&animate.onExit){
	
	
	
	
	
	
	
	
	
	return getInitialChildProps(animate,data);
	}
	return{animate:animate,data:data};
	};
	}

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0;
	var timeout = 0;
	var interval = 0;
	var pokeDelay = 1000;
	var taskHead;
	var taskTail;
	var clockLast = 0;
	var clockNow = 0;
	var clockSkew = 0;
	var clock = typeof performance === "object" && performance.now ? performance : Date;
	var setFrame = typeof requestAnimationFrame === "function" ? requestAnimationFrame : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow;
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, delay);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clockNow, interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	var timeout$1 = function(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	};
	
	var interval$1 = function(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	};
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _omit2=__webpack_require__(77);var _omit3=_interopRequireDefault(_omit2);var _isFunction2=__webpack_require__(6);var _isFunction3=_interopRequireDefault(_isFunction2);var _defaults2=__webpack_require__(21);var _defaults3=_interopRequireDefault(_defaults2);var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);
	
	var _d3Shape=__webpack_require__(1478);var d3Shape=_interopRequireWildcard(_d3Shape);
	
	var _victoryCore=__webpack_require__(12);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=
	
	{
	degreesToRadians:function degreesToRadians(degrees){
	return degrees*(Math.PI/180);
	},
	
	checkForValidText:function checkForValidText(text){
	if(text===undefined||text===null){
	return text;
	}else{
	return""+text;
	}
	},
	
	getSliceStyle:function getSliceStyle(datum,index,calculatedValues){var
	style=calculatedValues.style,colors=calculatedValues.colors;
	var fill=this.getColor(style,colors,index);
	var dataStyles=(0,_omit3.default)(datum,["_x","_y","x","y","label"]);
	return(0,_defaults3.default)({},dataStyles,{fill:fill},style.data);
	},
	
	getBaseProps:function getBaseProps(props,fallbackProps){
	props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"pie");
	var calculatedValues=this.getCalculatedValues(props);var
	slices=calculatedValues.slices,style=calculatedValues.style,pathFunction=calculatedValues.pathFunction,data=calculatedValues.data;
	var childProps={
	parent:{
	standalone:props.standalone,slices:slices,pathFunction:pathFunction,
	width:props.width,height:props.height,style:style.parent}};
	
	
	
	for(var index=0,len=slices.length;index<len;index++){
	var slice=slices[index];
	var datum=data[index];
	var eventKey=datum.eventKey||index;
	var dataProps={
	index:index,slice:slice,pathFunction:pathFunction,datum:datum,data:data,
	style:this.getSliceStyle(datum,index,calculatedValues)};
	
	
	childProps[eventKey]={
	data:dataProps,
	labels:this.getLabelProps(props,dataProps,calculatedValues)};
	
	}
	return childProps;
	},
	
	getLabelProps:function getLabelProps(props,dataProps,calculatedValues){var
	index=dataProps.index,datum=dataProps.datum,data=dataProps.data,slice=dataProps.slice;var
	style=calculatedValues.style,radius=calculatedValues.radius;
	var labelStyle=(0,_assign3.default)({padding:0},style.labels);
	var labelRadius=_victoryCore.Helpers.evaluateProp(props.labelRadius,datum);
	var labelPosition=this.getLabelPosition(radius,labelRadius,labelStyle);
	var position=labelPosition.centroid(slice);
	var orientation=this.getLabelOrientation(slice);
	return{
	index:index,datum:datum,data:data,slice:slice,orientation:orientation,
	style:labelStyle,
	x:position[0],
	y:position[1],
	text:this.getLabelText(props,datum,index),
	textAnchor:labelStyle.textAnchor||this.getTextAnchor(orientation),
	verticalAnchor:labelStyle.verticalAnchor||this.getVerticalAnchor(orientation),
	angle:labelStyle.angle};
	
	},
	
	getCalculatedValues:function getCalculatedValues(props){var
	theme=props.theme,colorScale=props.colorScale;
	var styleObject=theme&&theme.pie&&theme.pie.style?theme.pie.style:{};
	var style=_victoryCore.Helpers.getStyles(props.style,styleObject,"auto","100%");
	var colors=Array.isArray(colorScale)?colorScale:_victoryCore.Style.getColorScale(colorScale);
	var padding=_victoryCore.Helpers.getPadding(props);
	var radius=this.getRadius(props,padding);
	var data=_victoryCore.Data.getData(props);
	var slices=this.getSlices(props,data);
	var pathFunction=d3Shape.arc().
	cornerRadius(props.cornerRadius).
	outerRadius(radius).
	innerRadius(props.innerRadius);
	return{style:style,colors:colors,padding:padding,radius:radius,data:data,slices:slices,pathFunction:pathFunction};
	},
	
	getColor:function getColor(style,colors,index){
	if(style&&style.data&&style.data.fill){
	return style.data.fill;
	}
	return colors&&colors[index%colors.length];
	},
	
	getRadius:function getRadius(props,padding){
	return Math.min(
	props.width-padding.left-padding.right,
	props.height-padding.top-padding.bottom)/
	2;
	},
	
	getLabelPosition:function getLabelPosition(radius,labelRadius,style){
	
	var padding=style&&style.padding||0;
	var arcRadius=labelRadius||radius+padding;
	return d3Shape.arc().
	outerRadius(arcRadius).
	innerRadius(arcRadius);
	},
	
	getLabelOrientation:function getLabelOrientation(slice){
	var radiansToDegrees=function radiansToDegrees(radians){
	return radians*(180/Math.PI);
	};
	var start=radiansToDegrees(slice.startAngle);
	var end=radiansToDegrees(slice.endAngle);
	var degree=start+(end-start)/2;
	if(degree<45||degree>315){
	return"top";
	}else if(degree>=45&&degree<135){
	return"right";
	}else if(degree>=135&&degree<225){
	return"bottom";
	}else{
	return"left";
	}
	},
	
	getTextAnchor:function getTextAnchor(orientation){
	if(orientation==="top"||orientation==="bottom"){
	return"middle";
	}
	return orientation==="right"?"start":"end";
	},
	
	getVerticalAnchor:function getVerticalAnchor(orientation){
	if(orientation==="left"||orientation==="right"){
	return"middle";
	}
	return orientation==="bottom"?"start":"end";
	},
	
	getLabelText:function getLabelText(props,datum,index){
	var text=void 0;
	if(datum.label){
	text=datum.label;
	}else if(Array.isArray(props.labels)){
	text=props.labels[index];
	}else{
	text=(0,_isFunction3.default)(props.labels)?props.labels(datum):datum.xName||datum._x;
	}
	return this.checkForValidText(text);
	},
	
	getSlices:function getSlices(props,data){
	var layoutFunction=d3Shape.pie().
	sort(null).
	startAngle(this.degreesToRadians(props.startAngle)).
	endAngle(this.degreesToRadians(props.endAngle)).
	padAngle(this.degreesToRadians(props.padAngle)).
	value(function(datum){return datum._y;});
	return layoutFunction(data);
	}};

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _assign2=__webpack_require__(17);var _assign3=_interopRequireDefault(_assign2);var _partialRight2=__webpack_require__(57);var _partialRight3=_interopRequireDefault(_partialRight2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
	var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
	var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);
	
	var _victoryCore=__webpack_require__(12);
	
	
	
	var _helperMethods=__webpack_require__(1475);var _helperMethods2=_interopRequireDefault(_helperMethods);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var fallbackProps={
	endAngle:360,
	height:400,
	innerRadius:0,
	cornerRadius:0,
	padAngle:0,
	padding:30,
	width:400,
	startAngle:0,
	colorScale:[
	"#ffffff",
	"#f0f0f0",
	"#d9d9d9",
	"#bdbdbd",
	"#969696",
	"#737373",
	"#525252",
	"#252525",
	"#000000"]};
	
	
	
	var animationWhitelist=[
	"data","endAngle","height","innerRadius","cornerRadius","padAngle","padding",
	"colorScale","startAngle","style","width"];var
	
	
	VictoryPie=function(_React$Component){_inherits(VictoryPie,_React$Component);function VictoryPie(){_classCallCheck(this,VictoryPie);return _possibleConstructorReturn(this,(VictoryPie.__proto__||Object.getPrototypeOf(VictoryPie)).apply(this,arguments));}_createClass(VictoryPie,[{key:"renderPieData",value:function renderPieData(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	props){var
	dataComponent=props.dataComponent,labelComponent=props.labelComponent;
	var dataComponents=[];
	var labelComponents=[];
	for(var index=0,len=this.dataKeys.length;index<len;index++){
	var dataProps=this.getComponentProps(dataComponent,"data",index);
	dataComponents[index]=_react2.default.cloneElement(dataComponent,dataProps);
	
	var labelProps=this.getComponentProps(labelComponent,"labels",index);
	if(labelProps&&labelProps.text!==undefined&&labelProps.text!==null){
	labelComponents[index]=_react2.default.cloneElement(
	labelComponent,(0,_assign3.default)({},labelProps,{renderInPortal:false}));
	
	}
	}
	var children=[].concat(dataComponents,labelComponents);
	return this.renderGroup(props,children);
	}},{key:"renderGroup",value:function renderGroup(
	
	
	props,children){
	var offset=this.getOffset(props);
	var transform="translate("+offset.x+", "+offset.y+")";
	var groupComponent=_react2.default.cloneElement(props.groupComponent,{transform:transform});
	return this.renderContainer(groupComponent,children);
	}},{key:"getOffset",value:function getOffset(
	
	props){var
	width=props.width,height=props.height;
	var calculatedProps=_helperMethods2.default.getCalculatedValues(props);var
	padding=calculatedProps.padding,radius=calculatedProps.radius;
	var offsetWidth=width/2+padding.left-padding.right;
	var offsetHeight=height/2+padding.top-padding.bottom;
	return{
	x:offsetWidth+radius>width?radius+padding.left-padding.right:offsetWidth,
	y:offsetHeight+radius>height?radius+padding.top-padding.bottom:offsetHeight};
	
	}},{key:"shouldAnimate",value:function shouldAnimate()
	
	
	{
	return Boolean(this.props.animate);
	}},{key:"render",value:function render()
	
	{var
	role=this.constructor.role;
	var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,role);
	if(this.shouldAnimate()){
	return this.animateComponent(props,animationWhitelist);
	}
	
	var children=this.renderPieData(props);
	return this.renderContainer(props.containerComponent,children);
	}}]);return VictoryPie;}(_react2.default.Component);VictoryPie.displayName="VictoryPie";VictoryPie.defaultTransitions={onExit:{duration:500,before:function before(){return{_y:0,label:" "};}},onEnter:{duration:500,before:function before(){return{_y:0,label:" "};},after:function after(datum){return{y_:datum._y,label:datum.label};}}};VictoryPie.propTypes={animate:_propTypes2.default.object,colorScale:_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string),_propTypes2.default.oneOf(["grayscale","qualitative","heatmap","warm","cool","red","green","blue"])]),containerComponent:_propTypes2.default.element,cornerRadius:_victoryCore.PropTypes.nonNegative,data:_propTypes2.default.array,dataComponent:_propTypes2.default.element,endAngle:_propTypes2.default.number,eventKey:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string]),events:_propTypes2.default.arrayOf(_propTypes2.default.shape({target:_propTypes2.default.oneOf(["data","labels","parent"]),eventKey:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string]),eventHandlers:_propTypes2.default.object})),groupComponent:_propTypes2.default.element,height:_victoryCore.PropTypes.nonNegative,innerRadius:_victoryCore.PropTypes.nonNegative,labelComponent:_propTypes2.default.element,labelRadius:_propTypes2.default.oneOfType([_victoryCore.PropTypes.nonNegative,_propTypes2.default.func]),labels:_propTypes2.default.oneOfType([_propTypes2.default.func,_propTypes2.default.array]),name:_propTypes2.default.string,padAngle:_victoryCore.PropTypes.nonNegative,padding:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.shape({top:_propTypes2.default.number,bottom:_propTypes2.default.number,left:_propTypes2.default.number,right:_propTypes2.default.number})]),sharedEvents:_propTypes2.default.shape({events:_propTypes2.default.array,getEventState:_propTypes2.default.func}),sortKey:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)]),standalone:_propTypes2.default.bool,startAngle:_propTypes2.default.number,style:_propTypes2.default.shape({parent:_propTypes2.default.object,data:_propTypes2.default.object,labels:_propTypes2.default.object}),theme:_propTypes2.default.object,width:_victoryCore.PropTypes.nonNegative,x:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)]),y:_propTypes2.default.oneOfType([_propTypes2.default.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)])};VictoryPie.defaultProps={data:[{x:"A",y:1},{x:"B",y:2},{x:"C",y:3},{x:"D",y:1},{x:"E",y:2}],standalone:true,dataComponent:_react2.default.createElement(_victoryCore.Slice,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",null),theme:_victoryCore.VictoryTheme.grayscale};VictoryPie.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryPie.getData=_victoryCore.Data.getData.bind(_victoryCore.Data);VictoryPie.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=
	
	
	(0,_victoryCore.addEvents)(VictoryPie);

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.VictoryPie=undefined;var _victoryPie=__webpack_require__(1476);var _victoryPie2=_interopRequireDefault(_victoryPie);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.
	VictoryPie=_victoryPie2.default;

/***/ },
/* 1478 */
233,
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});exports.Selection=exports.Transitions=exports.TextSize=exports.Style=exports.Scale=exports.PropTypes=exports.Log=exports.Helpers=exports.Events=exports.Domain=exports.DefaultTransitions=exports.Data=exports.Collection=exports.addEvents=exports.createContainer=exports.combineContainerMixins=exports.voronoiContainerMixin=exports.VoronoiHelpers=exports.VictoryVoronoiContainer=exports.brushContainerMixin=exports.BrushHelpers=exports.VictoryBrushContainer=exports.selectionContainerMixin=exports.SelectionHelpers=exports.VictorySelectionContainer=exports.zoomContainerMixin=exports.ZoomHelpers=exports.VictoryZoomContainer=exports.VictoryClipContainer=exports.VictoryContainer=exports.Portal=exports.VictoryPortal=exports.VictoryVoronoi=exports.VictoryTooltip=exports.VictorySharedEvents=exports.VictoryTransition=exports.VictoryTheme=exports.VictoryStack=exports.VictoryScatter=exports.VictoryPie=exports.VictoryLegend=exports.VictoryLabel=exports.VictoryLine=exports.VictoryGroup=exports.VictoryErrorBar=exports.VictoryChart=exports.VictoryCandlestick=exports.VictoryBar=exports.VictoryAxis=exports.VictoryArea=exports.VictoryAnimation=exports.Flyout=exports.Voronoi=exports.Slice=exports.Point=exports.Line=exports.ErrorBar=exports.Curve=exports.ClipPath=exports.Candle=exports.Bar=exports.Area=undefined;var _victoryCore=__webpack_require__(12);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var _victoryChart=__webpack_require__(1447);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var _victoryPie=__webpack_require__(1477);exports.
	
	
	Area=_victoryCore.Area;exports.Bar=_victoryCore.Bar;exports.Candle=_victoryCore.Candle;exports.ClipPath=_victoryCore.ClipPath;exports.Curve=_victoryCore.Curve;exports.ErrorBar=_victoryCore.ErrorBar;exports.Line=_victoryCore.Line;exports.Point=_victoryCore.Point;exports.Slice=_victoryCore.Slice;exports.Voronoi=_victoryCore.Voronoi;exports.Flyout=_victoryCore.Flyout;exports.
	VictoryAnimation=_victoryCore.VictoryAnimation;exports.
	VictoryArea=_victoryChart.VictoryArea;exports.
	VictoryAxis=_victoryChart.VictoryAxis;exports.
	VictoryBar=_victoryChart.VictoryBar;exports.
	VictoryCandlestick=_victoryChart.VictoryCandlestick;exports.
	VictoryChart=_victoryChart.VictoryChart;exports.
	VictoryErrorBar=_victoryChart.VictoryErrorBar;exports.
	VictoryGroup=_victoryChart.VictoryGroup;exports.
	VictoryLine=_victoryChart.VictoryLine;exports.
	VictoryLabel=_victoryCore.VictoryLabel;exports.
	VictoryLegend=_victoryCore.VictoryLegend;exports.
	VictoryPie=_victoryPie.VictoryPie;exports.
	VictoryScatter=_victoryChart.VictoryScatter;exports.
	VictoryStack=_victoryChart.VictoryStack;exports.
	VictoryTheme=_victoryCore.VictoryTheme;exports.
	VictoryTransition=_victoryCore.VictoryTransition;exports.
	VictorySharedEvents=_victoryCore.VictorySharedEvents;exports.
	VictoryTooltip=_victoryCore.VictoryTooltip;exports.
	VictoryVoronoi=_victoryChart.VictoryVoronoi;exports.
	VictoryPortal=_victoryCore.VictoryPortal;exports.
	Portal=_victoryCore.Portal;exports.
	VictoryContainer=_victoryCore.VictoryContainer;exports.VictoryClipContainer=_victoryCore.VictoryClipContainer;exports.
	VictoryZoomContainer=_victoryChart.VictoryZoomContainer;exports.ZoomHelpers=_victoryChart.ZoomHelpers;exports.zoomContainerMixin=_victoryChart.zoomContainerMixin;exports.
	VictorySelectionContainer=_victoryChart.VictorySelectionContainer;exports.SelectionHelpers=_victoryChart.SelectionHelpers;exports.selectionContainerMixin=_victoryChart.selectionContainerMixin;exports.
	VictoryBrushContainer=_victoryChart.VictoryBrushContainer;exports.BrushHelpers=_victoryChart.BrushHelpers;exports.brushContainerMixin=_victoryChart.brushContainerMixin;exports.
	VictoryVoronoiContainer=_victoryChart.VictoryVoronoiContainer;exports.VoronoiHelpers=_victoryChart.VoronoiHelpers;exports.voronoiContainerMixin=_victoryChart.voronoiContainerMixin;exports.
	combineContainerMixins=_victoryChart.combineContainerMixins;exports.createContainer=_victoryChart.createContainer;exports.
	addEvents=_victoryCore.addEvents;exports.Collection=_victoryCore.Collection;exports.Data=_victoryCore.Data;exports.DefaultTransitions=_victoryCore.DefaultTransitions;exports.Domain=_victoryCore.Domain;exports.Events=_victoryCore.Events;exports.Helpers=_victoryCore.Helpers;exports.Log=_victoryCore.Log;exports.
	PropTypes=_victoryCore.PropTypes;exports.Scale=_victoryCore.Scale;exports.Style=_victoryCore.Style;exports.TextSize=_victoryCore.TextSize;exports.Transitions=_victoryCore.Transitions;exports.Selection=_victoryCore.Selection;

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 1481 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	** Copyright (c) 2012 The Khronos Group Inc.
	**
	** Permission is hereby granted, free of charge, to any person obtaining a
	** copy of this software and/or associated documentation files (the
	** "Materials"), to deal in the Materials without restriction, including
	** without limitation the rights to use, copy, modify, merge, publish,
	** distribute, sublicense, and/or sell copies of the Materials, and to
	** permit persons to whom the Materials are furnished to do so, subject to
	** the following conditions:
	**
	** The above copyright notice and this permission notice shall be included
	** in all copies or substantial portions of the Materials.
	**
	** THE MATERIALS ARE PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	** EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	** MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	** IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	** CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	** TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	** MATERIALS OR THE USE OR OTHER DEALINGS IN THE MATERIALS.
	*/
	
	//Ported to node by Marcin Ignac on 2016-05-20
	
	// Various functions for helping debug WebGL apps.
	
	WebGLDebugUtils = function() {
	
	//polyfill window in node
	if (typeof(window) == 'undefined') {
	    window = global;
	}
	
	/**
	 * Wrapped logging function.
	 * @param {string} msg Message to log.
	 */
	var log = function(msg) {
	  if (window.console && window.console.log) {
	    window.console.log(msg);
	  }
	};
	
	/**
	 * Wrapped error logging function.
	 * @param {string} msg Message to log.
	 */
	var error = function(msg) {
	  if (window.console && window.console.error) {
	    window.console.error(msg);
	  } else {
	    log(msg);
	  }
	};
	
	
	/**
	 * Which arguments are enums based on the number of arguments to the function.
	 * So
	 *    'texImage2D': {
	 *       9: { 0:true, 2:true, 6:true, 7:true },
	 *       6: { 0:true, 2:true, 3:true, 4:true },
	 *    },
	 *
	 * means if there are 9 arguments then 6 and 7 are enums, if there are 6
	 * arguments 3 and 4 are enums
	 *
	 * @type {!Object.<number, !Object.<number, string>}
	 */
	var glValidEnumContexts = {
	  // Generic setters and getters
	
	  'enable': {1: { 0:true }},
	  'disable': {1: { 0:true }},
	  'getParameter': {1: { 0:true }},
	
	  // Rendering
	
	  'drawArrays': {3:{ 0:true }},
	  'drawElements': {4:{ 0:true, 2:true }},
	
	  // Shaders
	
	  'createShader': {1: { 0:true }},
	  'getShaderParameter': {2: { 1:true }},
	  'getProgramParameter': {2: { 1:true }},
	  'getShaderPrecisionFormat': {2: { 0: true, 1:true }},
	
	  // Vertex attributes
	
	  'getVertexAttrib': {2: { 1:true }},
	  'vertexAttribPointer': {6: { 2:true }},
	
	  // Textures
	
	  'bindTexture': {2: { 0:true }},
	  'activeTexture': {1: { 0:true }},
	  'getTexParameter': {2: { 0:true, 1:true }},
	  'texParameterf': {3: { 0:true, 1:true }},
	  'texParameteri': {3: { 0:true, 1:true, 2:true }},
	  'texImage2D': {
	     9: { 0:true, 2:true, 6:true, 7:true },
	     6: { 0:true, 2:true, 3:true, 4:true }
	  },
	  'texSubImage2D': {
	    9: { 0:true, 6:true, 7:true },
	    7: { 0:true, 4:true, 5:true }
	  },
	  'copyTexImage2D': {8: { 0:true, 2:true }},
	  'copyTexSubImage2D': {8: { 0:true }},
	  'generateMipmap': {1: { 0:true }},
	  'compressedTexImage2D': {7: { 0: true, 2:true }},
	  'compressedTexSubImage2D': {8: { 0: true, 6:true }},
	
	  // Buffer objects
	
	  'bindBuffer': {2: { 0:true }},
	  'bufferData': {3: { 0:true, 2:true }},
	  'bufferSubData': {3: { 0:true }},
	  'getBufferParameter': {2: { 0:true, 1:true }},
	
	  // Renderbuffers and framebuffers
	
	  'pixelStorei': {2: { 0:true, 1:true }},
	  'readPixels': {7: { 4:true, 5:true }},
	  'bindRenderbuffer': {2: { 0:true }},
	  'bindFramebuffer': {2: { 0:true }},
	  'checkFramebufferStatus': {1: { 0:true }},
	  'framebufferRenderbuffer': {4: { 0:true, 1:true, 2:true }},
	  'framebufferTexture2D': {5: { 0:true, 1:true, 2:true }},
	  'getFramebufferAttachmentParameter': {3: { 0:true, 1:true, 2:true }},
	  'getRenderbufferParameter': {2: { 0:true, 1:true }},
	  'renderbufferStorage': {4: { 0:true, 1:true }},
	
	  // Frame buffer operations (clear, blend, depth test, stencil)
	
	  'clear': {1: { 0: { 'enumBitwiseOr': ['COLOR_BUFFER_BIT', 'DEPTH_BUFFER_BIT', 'STENCIL_BUFFER_BIT'] }}},
	  'depthFunc': {1: { 0:true }},
	  'blendFunc': {2: { 0:true, 1:true }},
	  'blendFuncSeparate': {4: { 0:true, 1:true, 2:true, 3:true }},
	  'blendEquation': {1: { 0:true }},
	  'blendEquationSeparate': {2: { 0:true, 1:true }},
	  'stencilFunc': {3: { 0:true }},
	  'stencilFuncSeparate': {4: { 0:true, 1:true }},
	  'stencilMaskSeparate': {2: { 0:true }},
	  'stencilOp': {3: { 0:true, 1:true, 2:true }},
	  'stencilOpSeparate': {4: { 0:true, 1:true, 2:true, 3:true }},
	
	  // Culling
	
	  'cullFace': {1: { 0:true }},
	  'frontFace': {1: { 0:true }},
	
	  // ANGLE_instanced_arrays extension
	
	  'drawArraysInstancedANGLE': {4: { 0:true }},
	  'drawElementsInstancedANGLE': {5: { 0:true, 2:true }},
	
	  // EXT_blend_minmax extension
	
	  'blendEquationEXT': {1: { 0:true }}
	};
	
	/**
	 * Map of numbers to names.
	 * @type {Object}
	 */
	var glEnums = null;
	
	/**
	 * Map of names to numbers.
	 * @type {Object}
	 */
	var enumStringToValue = null;
	
	/**
	 * Initializes this module. Safe to call more than once.
	 * @param {!WebGLRenderingContext} ctx A WebGL context. If
	 *    you have more than one context it doesn't matter which one
	 *    you pass in, it is only used to pull out constants.
	 */
	function init(ctx) {
	  if (glEnums == null) {
	    glEnums = { };
	    enumStringToValue = { };
	    for (var propertyName in ctx) {
	      if (typeof ctx[propertyName] == 'number') {
	        glEnums[ctx[propertyName]] = propertyName;
	        enumStringToValue[propertyName] = ctx[propertyName];
	      }
	    }
	  }
	}
	
	/**
	 * Checks the utils have been initialized.
	 */
	function checkInit() {
	  if (glEnums == null) {
	    throw 'WebGLDebugUtils.init(ctx) not called';
	  }
	}
	
	/**
	 * Returns true or false if value matches any WebGL enum
	 * @param {*} value Value to check if it might be an enum.
	 * @return {boolean} True if value matches one of the WebGL defined enums
	 */
	function mightBeEnum(value) {
	  checkInit();
	  return (glEnums[value] !== undefined);
	}
	
	/**
	 * Gets an string version of an WebGL enum.
	 *
	 * Example:
	 *   var str = WebGLDebugUtil.glEnumToString(ctx.getError());
	 *
	 * @param {number} value Value to return an enum for
	 * @return {string} The string version of the enum.
	 */
	function glEnumToString(value) {
	  checkInit();
	  var name = glEnums[value];
	  return (name !== undefined) ? ("gl." + name) :
	      ("/*UNKNOWN WebGL ENUM*/ 0x" + value.toString(16) + "");
	}
	
	/**
	 * Returns the string version of a WebGL argument.
	 * Attempts to convert enum arguments to strings.
	 * @param {string} functionName the name of the WebGL function.
	 * @param {number} numArgs the number of arguments passed to the function.
	 * @param {number} argumentIndx the index of the argument.
	 * @param {*} value The value of the argument.
	 * @return {string} The value as a string.
	 */
	function glFunctionArgToString(functionName, numArgs, argumentIndex, value) {
	  var funcInfo = glValidEnumContexts[functionName];
	  if (funcInfo !== undefined) {
	    var funcInfo = funcInfo[numArgs];
	    if (funcInfo !== undefined) {
	      if (funcInfo[argumentIndex]) {
	        if (typeof funcInfo[argumentIndex] === 'object' &&
	            funcInfo[argumentIndex]['enumBitwiseOr'] !== undefined) {
	          var enums = funcInfo[argumentIndex]['enumBitwiseOr'];
	          var orResult = 0;
	          var orEnums = [];
	          for (var i = 0; i < enums.length; ++i) {
	            var enumValue = enumStringToValue[enums[i]];
	            if ((value & enumValue) !== 0) {
	              orResult |= enumValue;
	              orEnums.push(glEnumToString(enumValue));
	            }
	          }
	          if (orResult === value) {
	            return orEnums.join(' | ');
	          } else {
	            return glEnumToString(value);
	          }
	        } else {
	          return glEnumToString(value);
	        }
	      }
	    }
	  }
	  if (value === null) {
	    return "null";
	  } else if (value === undefined) {
	    return "undefined";
	  } else {
	    return value.toString();
	  }
	}
	
	/**
	 * Converts the arguments of a WebGL function to a string.
	 * Attempts to convert enum arguments to strings.
	 *
	 * @param {string} functionName the name of the WebGL function.
	 * @param {number} args The arguments.
	 * @return {string} The arguments as a string.
	 */
	function glFunctionArgsToString(functionName, args) {
	  // apparently we can't do args.join(",");
	  var argStr = "";
	  var numArgs = args.length;
	  for (var ii = 0; ii < numArgs; ++ii) {
	    argStr += ((ii == 0) ? '' : ', ') +
	        glFunctionArgToString(functionName, numArgs, ii, args[ii]);
	  }
	  return argStr;
	};
	
	
	function makePropertyWrapper(wrapper, original, propertyName) {
	  //log("wrap prop: " + propertyName);
	  wrapper.__defineGetter__(propertyName, function() {
	    return original[propertyName];
	  });
	  // TODO(gmane): this needs to handle properties that take more than
	  // one value?
	  wrapper.__defineSetter__(propertyName, function(value) {
	    //log("set: " + propertyName);
	    original[propertyName] = value;
	  });
	}
	
	// Makes a function that calls a function on another object.
	function makeFunctionWrapper(original, functionName) {
	  //log("wrap fn: " + functionName);
	  var f = original[functionName];
	  return function() {
	    //log("call: " + functionName);
	    var result = f.apply(original, arguments);
	    return result;
	  };
	}
	
	/**
	 * Given a WebGL context returns a wrapped context that calls
	 * gl.getError after every command and calls a function if the
	 * result is not gl.NO_ERROR.
	 *
	 * @param {!WebGLRenderingContext} ctx The webgl context to
	 *        wrap.
	 * @param {!function(err, funcName, args): void} opt_onErrorFunc
	 *        The function to call when gl.getError returns an
	 *        error. If not specified the default function calls
	 *        console.log with a message.
	 * @param {!function(funcName, args): void} opt_onFunc The
	 *        function to call when each webgl function is called.
	 *        You can use this to log all calls for example.
	 * @param {!WebGLRenderingContext} opt_err_ctx The webgl context
	 *        to call getError on if different than ctx.
	 */
	function makeDebugContext(ctx, opt_onErrorFunc, opt_onFunc, opt_err_ctx) {
	  opt_err_ctx = opt_err_ctx || ctx;
	  init(ctx);
	  opt_onErrorFunc = opt_onErrorFunc || function(err, functionName, args) {
	        // apparently we can't do args.join(",");
	        var argStr = "";
	        var numArgs = args.length;
	        for (var ii = 0; ii < numArgs; ++ii) {
	          argStr += ((ii == 0) ? '' : ', ') +
	              glFunctionArgToString(functionName, numArgs, ii, args[ii]);
	        }
	        error("WebGL error "+ glEnumToString(err) + " in "+ functionName +
	              "(" + argStr + ")");
	      };
	
	  // Holds booleans for each GL error so after we get the error ourselves
	  // we can still return it to the client app.
	  var glErrorShadow = { };
	
	  // Makes a function that calls a WebGL function and then calls getError.
	  function makeErrorWrapper(ctx, functionName) {
	    return function() {
	      if (opt_onFunc) {
	        opt_onFunc(functionName, arguments);
	      }
	      var result = ctx[functionName].apply(ctx, arguments);
	      var err = opt_err_ctx.getError();
	      if (err != 0) {
	        glErrorShadow[err] = true;
	        opt_onErrorFunc(err, functionName, arguments);
	      }
	      return result;
	    };
	  }
	
	  // Make a an object that has a copy of every property of the WebGL context
	  // but wraps all functions.
	  var wrapper = {};
	  for (var propertyName in ctx) {
	    if (typeof ctx[propertyName] == 'function') {
	      if (propertyName != 'getExtension') {
	        wrapper[propertyName] = makeErrorWrapper(ctx, propertyName);
	      } else {
	        var wrapped = makeErrorWrapper(ctx, propertyName);
	        wrapper[propertyName] = function () {
	          var result = wrapped.apply(ctx, arguments);
	          return makeDebugContext(result, opt_onErrorFunc, opt_onFunc, opt_err_ctx);
	        };
	      }
	    } else {
	      makePropertyWrapper(wrapper, ctx, propertyName);
	    }
	  }
	
	  // Override the getError function with one that returns our saved results.
	  wrapper.getError = function() {
	    for (var err in glErrorShadow) {
	      if (glErrorShadow.hasOwnProperty(err)) {
	        if (glErrorShadow[err]) {
	          glErrorShadow[err] = false;
	          return err;
	        }
	      }
	    }
	    return ctx.NO_ERROR;
	  };
	
	  return wrapper;
	}
	
	function resetToInitialState(ctx) {
	  var numAttribs = ctx.getParameter(ctx.MAX_VERTEX_ATTRIBS);
	  var tmp = ctx.createBuffer();
	  ctx.bindBuffer(ctx.ARRAY_BUFFER, tmp);
	  for (var ii = 0; ii < numAttribs; ++ii) {
	    ctx.disableVertexAttribArray(ii);
	    ctx.vertexAttribPointer(ii, 4, ctx.FLOAT, false, 0, 0);
	    ctx.vertexAttrib1f(ii, 0);
	  }
	  ctx.deleteBuffer(tmp);
	
	  var numTextureUnits = ctx.getParameter(ctx.MAX_TEXTURE_IMAGE_UNITS);
	  for (var ii = 0; ii < numTextureUnits; ++ii) {
	    ctx.activeTexture(ctx.TEXTURE0 + ii);
	    ctx.bindTexture(ctx.TEXTURE_CUBE_MAP, null);
	    ctx.bindTexture(ctx.TEXTURE_2D, null);
	  }
	
	  ctx.activeTexture(ctx.TEXTURE0);
	  ctx.useProgram(null);
	  ctx.bindBuffer(ctx.ARRAY_BUFFER, null);
	  ctx.bindBuffer(ctx.ELEMENT_ARRAY_BUFFER, null);
	  ctx.bindFramebuffer(ctx.FRAMEBUFFER, null);
	  ctx.bindRenderbuffer(ctx.RENDERBUFFER, null);
	  ctx.disable(ctx.BLEND);
	  ctx.disable(ctx.CULL_FACE);
	  ctx.disable(ctx.DEPTH_TEST);
	  ctx.disable(ctx.DITHER);
	  ctx.disable(ctx.SCISSOR_TEST);
	  ctx.blendColor(0, 0, 0, 0);
	  ctx.blendEquation(ctx.FUNC_ADD);
	  ctx.blendFunc(ctx.ONE, ctx.ZERO);
	  ctx.clearColor(0, 0, 0, 0);
	  ctx.clearDepth(1);
	  ctx.clearStencil(-1);
	  ctx.colorMask(true, true, true, true);
	  ctx.cullFace(ctx.BACK);
	  ctx.depthFunc(ctx.LESS);
	  ctx.depthMask(true);
	  ctx.depthRange(0, 1);
	  ctx.frontFace(ctx.CCW);
	  ctx.hint(ctx.GENERATE_MIPMAP_HINT, ctx.DONT_CARE);
	  ctx.lineWidth(1);
	  ctx.pixelStorei(ctx.PACK_ALIGNMENT, 4);
	  ctx.pixelStorei(ctx.UNPACK_ALIGNMENT, 4);
	  ctx.pixelStorei(ctx.UNPACK_FLIP_Y_WEBGL, false);
	  ctx.pixelStorei(ctx.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
	  // TODO: Delete this IF.
	  if (ctx.UNPACK_COLORSPACE_CONVERSION_WEBGL) {
	    ctx.pixelStorei(ctx.UNPACK_COLORSPACE_CONVERSION_WEBGL, ctx.BROWSER_DEFAULT_WEBGL);
	  }
	  ctx.polygonOffset(0, 0);
	  ctx.sampleCoverage(1, false);
	  ctx.scissor(0, 0, ctx.canvas.width, ctx.canvas.height);
	  ctx.stencilFunc(ctx.ALWAYS, 0, 0xFFFFFFFF);
	  ctx.stencilMask(0xFFFFFFFF);
	  ctx.stencilOp(ctx.KEEP, ctx.KEEP, ctx.KEEP);
	  ctx.viewport(0, 0, ctx.canvas.width, ctx.canvas.height);
	  ctx.clear(ctx.COLOR_BUFFER_BIT | ctx.DEPTH_BUFFER_BIT | ctx.STENCIL_BUFFER_BIT);
	
	  // TODO: This should NOT be needed but Firefox fails with 'hint'
	  while(ctx.getError());
	}
	
	function makeLostContextSimulatingCanvas(canvas) {
	  var unwrappedContext_;
	  var wrappedContext_;
	  var onLost_ = [];
	  var onRestored_ = [];
	  var wrappedContext_ = {};
	  var contextId_ = 1;
	  var contextLost_ = false;
	  var resourceId_ = 0;
	  var resourceDb_ = [];
	  var numCallsToLoseContext_ = 0;
	  var numCalls_ = 0;
	  var canRestore_ = false;
	  var restoreTimeout_ = 0;
	
	  // Holds booleans for each GL error so can simulate errors.
	  var glErrorShadow_ = { };
	
	  canvas.getContext = function(f) {
	    return function() {
	      var ctx = f.apply(canvas, arguments);
	      // Did we get a context and is it a WebGL context?
	      if (ctx instanceof WebGLRenderingContext) {
	        if (ctx != unwrappedContext_) {
	          if (unwrappedContext_) {
	            throw "got different context"
	          }
	          unwrappedContext_ = ctx;
	          wrappedContext_ = makeLostContextSimulatingContext(unwrappedContext_);
	        }
	        return wrappedContext_;
	      }
	      return ctx;
	    }
	  }(canvas.getContext);
	
	  function wrapEvent(listener) {
	    if (typeof(listener) == "function") {
	      return listener;
	    } else {
	      return function(info) {
	        listener.handleEvent(info);
	      }
	    }
	  }
	
	  var addOnContextLostListener = function(listener) {
	    onLost_.push(wrapEvent(listener));
	  };
	
	  var addOnContextRestoredListener = function(listener) {
	    onRestored_.push(wrapEvent(listener));
	  };
	
	
	  function wrapAddEventListener(canvas) {
	    var f = canvas.addEventListener;
	    canvas.addEventListener = function(type, listener, bubble) {
	      switch (type) {
	        case 'webglcontextlost':
	          addOnContextLostListener(listener);
	          break;
	        case 'webglcontextrestored':
	          addOnContextRestoredListener(listener);
	          break;
	        default:
	          f.apply(canvas, arguments);
	      }
	    };
	  }
	
	  wrapAddEventListener(canvas);
	
	  canvas.loseContext = function() {
	    if (!contextLost_) {
	      contextLost_ = true;
	      numCallsToLoseContext_ = 0;
	      ++contextId_;
	      while (unwrappedContext_.getError());
	      clearErrors();
	      glErrorShadow_[unwrappedContext_.CONTEXT_LOST_WEBGL] = true;
	      var event = makeWebGLContextEvent("context lost");
	      var callbacks = onLost_.slice();
	      setTimeout(function() {
	          //log("numCallbacks:" + callbacks.length);
	          for (var ii = 0; ii < callbacks.length; ++ii) {
	            //log("calling callback:" + ii);
	            callbacks[ii](event);
	          }
	          if (restoreTimeout_ >= 0) {
	            setTimeout(function() {
	                canvas.restoreContext();
	              }, restoreTimeout_);
	          }
	        }, 0);
	    }
	  };
	
	  canvas.restoreContext = function() {
	    if (contextLost_) {
	      if (onRestored_.length) {
	        setTimeout(function() {
	            if (!canRestore_) {
	              throw "can not restore. webglcontestlost listener did not call event.preventDefault";
	            }
	            freeResources();
	            resetToInitialState(unwrappedContext_);
	            contextLost_ = false;
	            numCalls_ = 0;
	            canRestore_ = false;
	            var callbacks = onRestored_.slice();
	            var event = makeWebGLContextEvent("context restored");
	            for (var ii = 0; ii < callbacks.length; ++ii) {
	              callbacks[ii](event);
	            }
	          }, 0);
	      }
	    }
	  };
	
	  canvas.loseContextInNCalls = function(numCalls) {
	    if (contextLost_) {
	      throw "You can not ask a lost contet to be lost";
	    }
	    numCallsToLoseContext_ = numCalls_ + numCalls;
	  };
	
	  canvas.getNumCalls = function() {
	    return numCalls_;
	  };
	
	  canvas.setRestoreTimeout = function(timeout) {
	    restoreTimeout_ = timeout;
	  };
	
	  function isWebGLObject(obj) {
	    //return false;
	    return (obj instanceof WebGLBuffer ||
	            obj instanceof WebGLFramebuffer ||
	            obj instanceof WebGLProgram ||
	            obj instanceof WebGLRenderbuffer ||
	            obj instanceof WebGLShader ||
	            obj instanceof WebGLTexture);
	  }
	
	  function checkResources(args) {
	    for (var ii = 0; ii < args.length; ++ii) {
	      var arg = args[ii];
	      if (isWebGLObject(arg)) {
	        return arg.__webglDebugContextLostId__ == contextId_;
	      }
	    }
	    return true;
	  }
	
	  function clearErrors() {
	    var k = Object.keys(glErrorShadow_);
	    for (var ii = 0; ii < k.length; ++ii) {
	      delete glErrorShadow_[k];
	    }
	  }
	
	  function loseContextIfTime() {
	    ++numCalls_;
	    if (!contextLost_) {
	      if (numCallsToLoseContext_ == numCalls_) {
	        canvas.loseContext();
	      }
	    }
	  }
	
	  // Makes a function that simulates WebGL when out of context.
	  function makeLostContextFunctionWrapper(ctx, functionName) {
	    var f = ctx[functionName];
	    return function() {
	      // log("calling:" + functionName);
	      // Only call the functions if the context is not lost.
	      loseContextIfTime();
	      if (!contextLost_) {
	        //if (!checkResources(arguments)) {
	        //  glErrorShadow_[wrappedContext_.INVALID_OPERATION] = true;
	        //  return;
	        //}
	        var result = f.apply(ctx, arguments);
	        return result;
	      }
	    };
	  }
	
	  function freeResources() {
	    for (var ii = 0; ii < resourceDb_.length; ++ii) {
	      var resource = resourceDb_[ii];
	      if (resource instanceof WebGLBuffer) {
	        unwrappedContext_.deleteBuffer(resource);
	      } else if (resource instanceof WebGLFramebuffer) {
	        unwrappedContext_.deleteFramebuffer(resource);
	      } else if (resource instanceof WebGLProgram) {
	        unwrappedContext_.deleteProgram(resource);
	      } else if (resource instanceof WebGLRenderbuffer) {
	        unwrappedContext_.deleteRenderbuffer(resource);
	      } else if (resource instanceof WebGLShader) {
	        unwrappedContext_.deleteShader(resource);
	      } else if (resource instanceof WebGLTexture) {
	        unwrappedContext_.deleteTexture(resource);
	      }
	    }
	  }
	
	  function makeWebGLContextEvent(statusMessage) {
	    return {
	      statusMessage: statusMessage,
	      preventDefault: function() {
	          canRestore_ = true;
	        }
	    };
	  }
	
	  return canvas;
	
	  function makeLostContextSimulatingContext(ctx) {
	    // copy all functions and properties to wrapper
	    for (var propertyName in ctx) {
	      if (typeof ctx[propertyName] == 'function') {
	         wrappedContext_[propertyName] = makeLostContextFunctionWrapper(
	             ctx, propertyName);
	       } else {
	         makePropertyWrapper(wrappedContext_, ctx, propertyName);
	       }
	    }
	
	    // Wrap a few functions specially.
	    wrappedContext_.getError = function() {
	      loseContextIfTime();
	      if (!contextLost_) {
	        var err;
	        while (err = unwrappedContext_.getError()) {
	          glErrorShadow_[err] = true;
	        }
	      }
	      for (var err in glErrorShadow_) {
	        if (glErrorShadow_[err]) {
	          delete glErrorShadow_[err];
	          return err;
	        }
	      }
	      return wrappedContext_.NO_ERROR;
	    };
	
	    var creationFunctions = [
	      "createBuffer",
	      "createFramebuffer",
	      "createProgram",
	      "createRenderbuffer",
	      "createShader",
	      "createTexture"
	    ];
	    for (var ii = 0; ii < creationFunctions.length; ++ii) {
	      var functionName = creationFunctions[ii];
	      wrappedContext_[functionName] = function(f) {
	        return function() {
	          loseContextIfTime();
	          if (contextLost_) {
	            return null;
	          }
	          var obj = f.apply(ctx, arguments);
	          obj.__webglDebugContextLostId__ = contextId_;
	          resourceDb_.push(obj);
	          return obj;
	        };
	      }(ctx[functionName]);
	    }
	
	    var functionsThatShouldReturnNull = [
	      "getActiveAttrib",
	      "getActiveUniform",
	      "getBufferParameter",
	      "getContextAttributes",
	      "getAttachedShaders",
	      "getFramebufferAttachmentParameter",
	      "getParameter",
	      "getProgramParameter",
	      "getProgramInfoLog",
	      "getRenderbufferParameter",
	      "getShaderParameter",
	      "getShaderInfoLog",
	      "getShaderSource",
	      "getTexParameter",
	      "getUniform",
	      "getUniformLocation",
	      "getVertexAttrib"
	    ];
	    for (var ii = 0; ii < functionsThatShouldReturnNull.length; ++ii) {
	      var functionName = functionsThatShouldReturnNull[ii];
	      wrappedContext_[functionName] = function(f) {
	        return function() {
	          loseContextIfTime();
	          if (contextLost_) {
	            return null;
	          }
	          return f.apply(ctx, arguments);
	        }
	      }(wrappedContext_[functionName]);
	    }
	
	    var isFunctions = [
	      "isBuffer",
	      "isEnabled",
	      "isFramebuffer",
	      "isProgram",
	      "isRenderbuffer",
	      "isShader",
	      "isTexture"
	    ];
	    for (var ii = 0; ii < isFunctions.length; ++ii) {
	      var functionName = isFunctions[ii];
	      wrappedContext_[functionName] = function(f) {
	        return function() {
	          loseContextIfTime();
	          if (contextLost_) {
	            return false;
	          }
	          return f.apply(ctx, arguments);
	        }
	      }(wrappedContext_[functionName]);
	    }
	
	    wrappedContext_.checkFramebufferStatus = function(f) {
	      return function() {
	        loseContextIfTime();
	        if (contextLost_) {
	          return wrappedContext_.FRAMEBUFFER_UNSUPPORTED;
	        }
	        return f.apply(ctx, arguments);
	      };
	    }(wrappedContext_.checkFramebufferStatus);
	
	    wrappedContext_.getAttribLocation = function(f) {
	      return function() {
	        loseContextIfTime();
	        if (contextLost_) {
	          return -1;
	        }
	        return f.apply(ctx, arguments);
	      };
	    }(wrappedContext_.getAttribLocation);
	
	    wrappedContext_.getVertexAttribOffset = function(f) {
	      return function() {
	        loseContextIfTime();
	        if (contextLost_) {
	          return 0;
	        }
	        return f.apply(ctx, arguments);
	      };
	    }(wrappedContext_.getVertexAttribOffset);
	
	    wrappedContext_.isContextLost = function() {
	      return contextLost_;
	    };
	
	    return wrappedContext_;
	  }
	}
	
	return {
	  /**
	   * Initializes this module. Safe to call more than once.
	   * @param {!WebGLRenderingContext} ctx A WebGL context. If
	   *    you have more than one context it doesn't matter which one
	   *    you pass in, it is only used to pull out constants.
	   */
	  'init': init,
	
	  /**
	   * Returns true or false if value matches any WebGL enum
	   * @param {*} value Value to check if it might be an enum.
	   * @return {boolean} True if value matches one of the WebGL defined enums
	   */
	  'mightBeEnum': mightBeEnum,
	
	  /**
	   * Gets an string version of an WebGL enum.
	   *
	   * Example:
	   *   WebGLDebugUtil.init(ctx);
	   *   var str = WebGLDebugUtil.glEnumToString(ctx.getError());
	   *
	   * @param {number} value Value to return an enum for
	   * @return {string} The string version of the enum.
	   */
	  'glEnumToString': glEnumToString,
	
	  /**
	   * Converts the argument of a WebGL function to a string.
	   * Attempts to convert enum arguments to strings.
	   *
	   * Example:
	   *   WebGLDebugUtil.init(ctx);
	   *   var str = WebGLDebugUtil.glFunctionArgToString('bindTexture', 2, 0, gl.TEXTURE_2D);
	   *
	   * would return 'TEXTURE_2D'
	   *
	   * @param {string} functionName the name of the WebGL function.
	   * @param {number} numArgs The number of arguments
	   * @param {number} argumentIndx the index of the argument.
	   * @param {*} value The value of the argument.
	   * @return {string} The value as a string.
	   */
	  'glFunctionArgToString': glFunctionArgToString,
	
	  /**
	   * Converts the arguments of a WebGL function to a string.
	   * Attempts to convert enum arguments to strings.
	   *
	   * @param {string} functionName the name of the WebGL function.
	   * @param {number} args The arguments.
	   * @return {string} The arguments as a string.
	   */
	  'glFunctionArgsToString': glFunctionArgsToString,
	
	  /**
	   * Given a WebGL context returns a wrapped context that calls
	   * gl.getError after every command and calls a function if the
	   * result is not NO_ERROR.
	   *
	   * You can supply your own function if you want. For example, if you'd like
	   * an exception thrown on any GL error you could do this
	   *
	   *    function throwOnGLError(err, funcName, args) {
	   *      throw WebGLDebugUtils.glEnumToString(err) +
	   *            " was caused by call to " + funcName;
	   *    };
	   *
	   *    ctx = WebGLDebugUtils.makeDebugContext(
	   *        canvas.getContext("webgl"), throwOnGLError);
	   *
	   * @param {!WebGLRenderingContext} ctx The webgl context to wrap.
	   * @param {!function(err, funcName, args): void} opt_onErrorFunc The function
	   *     to call when gl.getError returns an error. If not specified the default
	   *     function calls console.log with a message.
	   * @param {!function(funcName, args): void} opt_onFunc The
	   *     function to call when each webgl function is called. You
	   *     can use this to log all calls for example.
	   */
	  'makeDebugContext': makeDebugContext,
	
	  /**
	   * Given a canvas element returns a wrapped canvas element that will
	   * simulate lost context. The canvas returned adds the following functions.
	   *
	   * loseContext:
	   *   simulates a lost context event.
	   *
	   * restoreContext:
	   *   simulates the context being restored.
	   *
	   * lostContextInNCalls:
	   *   loses the context after N gl calls.
	   *
	   * getNumCalls:
	   *   tells you how many gl calls there have been so far.
	   *
	   * setRestoreTimeout:
	   *   sets the number of milliseconds until the context is restored
	   *   after it has been lost. Defaults to 0. Pass -1 to prevent
	   *   automatic restoring.
	   *
	   * @param {!Canvas} canvas The canvas element to wrap.
	   */
	  'makeLostContextSimulatingCanvas': makeLostContextSimulatingCanvas,
	
	  /**
	   * Resets a context to the initial state.
	   * @param {!WebGLRenderingContext} ctx The webgl context to
	   *     reset.
	   */
	  'resetToInitialState': resetToInitialState
	};
	
	}();
	
	module.exports = WebGLDebugUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1482 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// https://d3js.org/d3-scale/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(251), __webpack_require__(143), __webpack_require__(__webpack_module_template_argument_0__), __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__), __webpack_require__(__webpack_module_template_argument_3__), __webpack_require__(47)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(__webpack_module_template_argument_0__);
	var invariant = __webpack_require__(__webpack_module_template_argument_1__);
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://d3js.org/d3-time-format/ Version 2.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(__webpack_module_template_argument_0__)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$1;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.timeFormat = locale$1.format;
	  exports.timeParse = locale$1.parse;
	  exports.utcFormat = locale$1.utcFormat;
	  exports.utcParse = locale$1.utcParse;
	  return locale$1;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(__webpack_module_template_argument_0__);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(__webpack_module_template_argument_1__);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(__webpack_module_template_argument_2__);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(__webpack_module_template_argument_3__);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(__webpack_module_template_argument_4__);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(__webpack_module_template_argument_5__);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(__webpack_module_template_argument_6__);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(__webpack_module_template_argument_0__);
	var invariant = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactChildren = __webpack_require__(__webpack_module_template_argument_0__);
	var ReactComponent = __webpack_require__(__webpack_module_template_argument_1__);
	var ReactPureComponent = __webpack_require__(__webpack_module_template_argument_2__);
	var ReactClass = __webpack_require__(__webpack_module_template_argument_3__);
	var ReactDOMFactories = __webpack_require__(__webpack_module_template_argument_4__);
	var ReactElement = __webpack_require__(__webpack_module_template_argument_5__);
	var ReactPropTypes = __webpack_require__(__webpack_module_template_argument_6__);
	var ReactVersion = __webpack_require__(__webpack_module_template_argument_7__);
	
	var onlyChild = __webpack_require__(__webpack_module_template_argument_8__);
	var warning = __webpack_require__(8);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(__webpack_module_template_argument_0__);
	var ReactElement = __webpack_require__(__webpack_module_template_argument_1__);
	
	var emptyFunction = __webpack_require__(36);
	var traverseAllChildren = __webpack_require__(__webpack_module_template_argument_2__);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__),
	    _assign = __webpack_require__(11);
	
	var ReactComponent = __webpack_require__(__webpack_module_template_argument_1__);
	var ReactElement = __webpack_require__(__webpack_module_template_argument_2__);
	var ReactPropTypeLocations = __webpack_require__(__webpack_module_template_argument_3__);
	var ReactPropTypeLocationNames = __webpack_require__(__webpack_module_template_argument_4__);
	var ReactNoopUpdateQueue = __webpack_require__(__webpack_module_template_argument_5__);
	
	var emptyObject = __webpack_require__(43);
	var invariant = __webpack_require__(4);
	var keyMirror = __webpack_require__(121);
	var keyOf = __webpack_require__(263);
	var warning = __webpack_require__(8);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var ReactNoopUpdateQueue = __webpack_require__(__webpack_module_template_argument_1__);
	
	var canDefineProperty = __webpack_require__(__webpack_module_template_argument_2__);
	var emptyObject = __webpack_require__(43);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(__webpack_module_template_argument_0__);
	
	var warning = __webpack_require__(8);
	var canDefineProperty = __webpack_require__(__webpack_module_template_argument_1__);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      Object.defineProperty(element, '_shadowChildren', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: shadowChildren
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._shadowChildren = shadowChildren;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(__webpack_module_template_argument_0__);
	var ReactPropTypeLocationNames = __webpack_require__(__webpack_module_template_argument_1__);
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_2__);
	
	var emptyFunction = __webpack_require__(36);
	var getIteratorFn = __webpack_require__(__webpack_module_template_argument_3__);
	var warning = __webpack_require__(8);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new PropTypeError('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPureComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactComponent = __webpack_require__(__webpack_module_template_argument_0__);
	var ReactNoopUpdateQueue = __webpack_require__(__webpack_module_template_argument_1__);
	
	var emptyObject = __webpack_require__(43);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var ReactElement = __webpack_require__(__webpack_module_template_argument_1__);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var ReactCurrentOwner = __webpack_require__(__webpack_module_template_argument_1__);
	var ReactElement = __webpack_require__(__webpack_module_template_argument_2__);
	
	var getIteratorFn = __webpack_require__(__webpack_module_template_argument_3__);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(__webpack_module_template_argument_4__);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.50dacf11.js